(function ()
{
    'use strict';

    angular.module('app.settings.users',[])
        .controller('DeletePromptDialogController', DeletePromptDialogController);

    /** @ngInject */
    function DeletePromptDialogController(user,deleteUser,$mdDialog)
    {
        var vm = this;
        vm.user = user;
        vm.confirm = confirm;
        vm.isButtonActive = false;
        vm.enableButton = enableButton;
        vm.closeDialog = closeDialog;

        function confirm(){
            deleteUser(user);
            $mdDialog.hide();
        }

        function closeDialog (){
            $mdDialog.hide();
        }

        function enableButton(){
            if(vm.user.username == vm.confirmUsername){
                vm.isButtonActive = true;
            }else{
                vm.isButtonActive = false;
            }
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.settings.users')
        .controller('ViewUserController', ViewUserController);

    function ViewUserController($scope, $state, ToolsFactory, $filter, users, LoginService, UserService, $mdDialog, MessageService, $document){   
        var vm = this;
        var dataForEveryPage;
        var totalPage;
        var loginUserInfo = LoginService.getUserInfo();

        var allowedForceLogoutUserIDs = [1, 42];
        vm.canUseForceLogout = allowedForceLogoutUserIDs.indexOf(parseInt(loginUserInfo.userID, 10)) !== -1;
        vm.forceLogoutUser = forceLogoutUser;

        if(typeof(loginUserInfo) == "undefined"){
            return;
        }

        for(var i = 0; i < users.length; i++){
            users[i].canBeChanged = false;
            users[i].isOwner = false;

            if(loginUserInfo.userID == users[i].id_user){
                users[i].isOwner = true;
            }

            if(UserService.checkRoles(loginUserInfo.subRoles, users[i].roles)){
                users[i].canBeChanged = true;
            }
        }

        var filteredUsers = users;

        vm.totalUser = filteredUsers.length;
        vm.search = search;        
        vm.resetTable = resetTable;
        vm.goToEditUser = goToEditUser;
        vm.goToMyProfile = goToMyProfile;
        vm.deleteUser = deleteUser;
        vm.goToPage = goToPage;
        vm.goToLastPage = goToLastPage;
        vm.options = [10, 25, 50, 100];
        vm.itemPerPage = vm.options[0];
        vm.dialogTest = dialogTest;
        vm.pageOptions;
        
        resetTable();

        function resetTable(){
            dataForEveryPage = ToolsFactory.dividDataByPage(filteredUsers, vm.itemPerPage);
            totalPage = dataForEveryPage.length;
            goToPage(1);
        }

        function search(){
            filteredUsers = $filter('filter')(users, vm.keyword);
            vm.totalUser = filteredUsers.length;
            resetTable();
        }

        function goToEditUser(userID,companyID){
            var params = {
                    userID:userID,
                    companyID:companyID
                };
            $state.go("app.settings.users.edit-user", params);  
        }

        function goToMyProfile(userID,companyID){
            var params = {
                    userID:userID,
                    companyID:companyID
                };
            $state.go("app.settings.users.my-profile", params);  
        }

        function deleteUser(user){

            UserService.deleteUser(user.id_user, user.fk_id_company, deleteUserCallback);
        } 

        function deleteUserCallback (err, userID) {

        	if(err){
        		MessageService.showToast(err)
        		return;
        	}

            for(var i = 0; i<users.length; i++){
                var currentUser = users[i];
                if(currentUser.id_user == userID){
                    users.splice(i,1);
                }
            }
            filteredUsers = users;
            resetTable();
            MessageService.showToast("Success !")
        }

        function goToPage(pageNumber){
            vm.users = dataForEveryPage[pageNumber - 1];
            vm.pages = ToolsFactory.pageListBuilder(totalPage, pageNumber);
        }   

        function goToLastPage(){
            goToPage(totalPage)
        }   

        function dialogTest(user){
            $mdDialog.show({
                controller         : 'DeletePromptDialogController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/settings/users/dialogs/delete-prompt-dialog.html',
                clickOutsideToClose: true,
                locals             : {
                    user      : user,
                    deleteUser : deleteUser
                }
            });
        }

        function forceLogoutUser(user) {
            if (!vm.canUseForceLogout) {
                MessageService.showToast("You do not have permission to force logout users.");
                return;
            }

            if (!user || !user.id_user) {
                MessageService.showToast("Invalid user.");
                return;
            }

            if (parseInt(loginUserInfo.userID, 10) === parseInt(user.id_user, 10)) {
                MessageService.showToast("You cannot force logout yourself.");
                return;
            }

            var confirmMessage = "Are you sure you want to force logout user \"" + user.username + "\"?";

            if (!window.confirm(confirmMessage)) {
                return;
            }

            UserService.forceLogoutUser(user.id_user, function(err, result) {
                if (err) {
                    MessageService.showToast(err);
                    return;
                }

                MessageService.showToast("User has been force logged out.");
            });
        }
    }
})();
(function ()
{
	'use strict';

	angular
		.module('app.settings.users')
		.controller('MyProfileController', MyProfileController);

	function MyProfileController($sce, $scope, $state, ToolsFactory, user, LoginService, UserService, $timeout, MessageService, Const, FileUploader, FileUploadService, ProgressService){  
		var vm = this;

		//saperate roles with other user params
		var originRoles = user[0].roles;
		delete user[0].roles;
		
		var originUser = Object.assign({},user[0]);
		var originSelectedRoles = [];
		var currentSelectedRoles = [];	

		vm.user = user[0];
		vm.rolesCanBeChanged = [];
		vm.myRoles = originRoles;
		vm.updateProfile = updateProfile;
		vm.validWarnings = {};
		vm.checkUsername = checkUsername;
		vm.checkEmail = checkEmail;
		vm.isUsernameAvailable = true 
		vm.isEmailAvailable = true
		vm.isDisableButton = false;
		vm.processStatus = {};

		var loginUserSubRoles	= LoginService.getUserSubRoles();
		var loginUserID			= LoginService.getUserID();

		LoginService.subscribe(updateMyRoleCallback);

		vm.uploader = FileUploadService.getNewUploader();

		var imageFilter = FileUploadService.getImageFilter();
		var sizeFilter 	= FileUploadService.getSizeFilter(5);

		vm.uploader.filters.push(imageFilter);
		vm.uploader.filters.push(sizeFilter);

		//change string array to object array to show which subrole is selected
		for(var i = 0; i < loginUserSubRoles.length; i++){
			var currentLoginUserSubRole = loginUserSubRoles[i];
			var roleObj = {};

			roleObj.isCheck = false;
			if(Array.isArray(originRoles) && originRoles.indexOf(currentLoginUserSubRole) != -1){
				roleObj.isCheck = true;
				originSelectedRoles.push(currentLoginUserSubRole);
			}

			roleObj.roleTitle = currentLoginUserSubRole;
			roleObj.description = Const.roleDescription[currentLoginUserSubRole];

			vm.rolesCanBeChanged.push(roleObj);
		}

		function inputValidator (form){
			var propNameList = Object.keys($scope.editUser);
			var isInputValid = true;

			for(var i = 0; i < propNameList.length; i++){
				var currentPropName = propNameList[i];

				if(currentPropName.startsWith('$')){
					continue;
				}
				if(!form[currentPropName].$valid){
					isInputValid = false;
				}			  
			}
			return isInputValid
		}

		function updateProfile(){
			currentSelectedRoles = [];
			vm.rolesCanBeChanged.forEach(function(roleObj){
				if(roleObj.isCheck){
					currentSelectedRoles.push(roleObj.roleTitle)
				}
			});

			var paramsToBeUpdated = {};
			var propNameList = Object.keys(originUser);

			for(var i = 0; i < propNameList.length; i++){
				var propName = propNameList[i]
		 
				if(vm.user[propName] === originUser[propName]){
					continue;
				}
				paramsToBeUpdated[propName] = vm.user[propName];
			}

			if(!ToolsFactory.isSameArray(currentSelectedRoles, originSelectedRoles)){

				paramsToBeUpdated.roles = currentSelectedRoles;
			}
			 
			if(Object.keys(paramsToBeUpdated).length == 0){
				MessageService.showToast("No changes is made")
				return;
			}
			if(vm.isUsernameAvailable == undefined || vm.isEmailAvailable == undefined){
				return;
			}

			if(!inputValidator($scope.editUser) || vm.isUsernameAvailable != true || vm.isEmailAvailable != true){
				MessageService.showToast("Please make sure all input is valid")
				return;
			}
			var userID = LoginService.getUserID();
			var companyID = LoginService.getCompanyID();

			vm.isDisableButton = true;

			ProgressService.setMode("indeterminate");
			ProgressService.isVisble(true);

			UserService.updateUser(userID, companyID, paramsToBeUpdated, updateCallback);
		}

		function checkUsername(){
			if($scope.editUser.username.$invalid){
				return;
			}

			if(vm.user.username != originUser.username){
				vm.isCheckingUsername = true;
				UserService.checkAvailability("username", vm.user.username, checkUsernameCallback); 
			}  
		}

		function checkUsernameCallback(result){
			vm.isCheckingUsername = false;
			vm.isUsernameAvailable = result;
		}
		
		function checkEmail(){
			if($scope.editUser.email.$invalid){
				return;
			}			 
			if(vm.user.email != originUser.email){
				vm.isCheckingEmail = true;
				UserService.checkAvailability("email", vm.user.email, checkEmailCallback);
			}
		}

		function checkEmailCallback(result){
			vm.isCheckingEmail = false;
			vm.isEmailAvailable = result;
		}		

		function inputValidation () {
			checkUsername();
			checkEmail();
		}

		function updateCallback(err, result){
			ProgressService.isVisble(false);
			vm.isDisableButton = false;

			if(err){
				MessageService.showToast(err);
				return;
			}

			originUser = Object.assign({},vm.user);
			originSelectedRoles = currentSelectedRoles; 
			var updatedUserInfo = LoginService.getUserInfo();

			updatedUserInfo.firstName = originUser.first_name;
			updatedUserInfo.lastName = originUser.last_name;

			leftExcludingJoin(updatedUserInfo.roles, loginUserSubRoles);

			currentSelectedRoles.forEach(function (role){
				updatedUserInfo.roles.push(role)
			})

			LoginService.saveUserStatus(updatedUserInfo);

			MessageService.showToast("Success !");
		}

		function leftExcludingJoin(leftArray, rightArray){
			for(var j = 0; j < rightArray.length; j++){
				var currentItem = rightArray[j];

				if(leftArray.indexOf(currentItem) != -1){
				  leftArray.splice(leftArray.indexOf(currentItem), 1)
				}
			}
		}

		function updateMyRoleCallback (){
			vm.myRoles = LoginService.getUserRoles();
		}

		vm.uploader.onAfterAddingFile = function(fileItem) {
			vm.isDisableButton = true;
			fileItem.removeAfterUpload = true;

			var userID 	= vm.user.id_user;
			var imageID;

			if(vm.user.profileimage != null && Array.isArray(vm.user.profileimage)){
				imageID = vm.user.profileimage[0].id_profile_image;
			}
			
			var url;
			var method;

			if(imageID == null){
				url = FileUploadService.getUrlForCreateProfileImage(userID)
				method = "POST";
			}else{
				url = FileUploadService.getUrlForUpdateProfileImage(userID, imageID)
				method = "PUT";
			}

			fileItem.url = url;
			fileItem.method = method;

			var url = URL.createObjectURL(fileItem._file);
			fileItem.imageSrc = $sce.trustAsResourceUrl(url);

			ProgressService.setMode("indeterminate");
			ProgressService.isVisble(true);
			vm.uploader.uploadAll();
		};

		vm.uploader.onErrorItem = function(fileItem, response, status, headers) {
			ProgressService.isVisble(false);
			vm.isDisableButton = false; 
			MessageService.showToast(status + ": Fail to upload file.")
		};

		vm.uploader.onCompleteItem = function(fileItem, response, status, headers) {
			ProgressService.isVisble(false);
			vm.isDisableButton = false; 

			if(headers.code != Const.code.success){
				MessageService.showToast(headers.code + ': ' + headers.message);  
				return;
			}

			if(!Array.isArray(vm.user.profileimage)){
				vm.user.profileimage = [];
			}

			if(!Array.isArray(vm.user.profileimage)){
				vm.user.profileimage = [];
			}

			if(!vm.user.profileimage[0]){
				vm.user.profileimage[0] = {};
			}

			vm.user.profileimage[0].url = response.url;
			vm.user.profileimage[0].id_profile_image = response.id_profile_image;

			var updatedUserInfo = LoginService.getUserInfo();
			updatedUserInfo.profileImage.imageID	= response.id_profile_image;
			updatedUserInfo.profileImage.url		= response.url;
			LoginService.saveUserStatus(updatedUserInfo);			

			MessageService.showToast("Success !")	  		   				
		};
	}
})();
(function ()
{
	'use strict';

	angular
		.module('app.settings.users')
		.controller('EditUserController', EditUserController);

	function EditUserController($sce, $scope, $state, ToolsFactory, user, LoginService, UserService, $timeout, MessageService, Const, FileUploader, FileUploadService, ProgressService, RoleCheckService){  
		var vm = this;

		//saperate roles with other user params
		var originRoles = user[0].roles;
		delete user[0].roles;
		var originUser = Object.assign({},user[0]);

		var originSelectedRoles = [];
		var currentSelectedRoles = [];	   
		
		vm.headerFirstName = originUser.first_name;
		vm.headerLastName = originUser.last_name;
		vm.user = user[0];
		vm.rolesCanBeChanged = [];
		vm.updateProfile = updateProfile;
		vm.validWarnings = {};
		vm.checkUsername = checkUsername;
		vm.checkEmail = checkEmail;
		vm.isUsernameAvailable = true 
		vm.isEmailAvailable = true
		vm.isDisableButton = false;
		vm.processStatus = {};

		vm.uploader = FileUploadService.getNewUploader();

		var imageFilter = FileUploadService.getImageFilter();
		var sizeFilter 	= FileUploadService.getSizeFilter(5);

		vm.uploader.filters.push(imageFilter);
		vm.uploader.filters.push(sizeFilter);

		var assignableRoleTitles = RoleCheckService.getAssignableRoleTitles();

		//change string array to object array to show which subrole is selected
		for(var i = 0; i < assignableRoleTitles.length; i++){
			var currentLoginUserSubRole = assignableRoleTitles[i];
			var roleObj = {};

			roleObj.isCheck = false;
			if(Array.isArray(originRoles) && originRoles.indexOf(currentLoginUserSubRole) != -1){
				roleObj.isCheck = true;
				originSelectedRoles.push(currentLoginUserSubRole);
			}

			roleObj.roleTitle = currentLoginUserSubRole;
			roleObj.displayName = RoleCheckService.getRoleDisplayName(currentLoginUserSubRole);
			roleObj.description = Const.roleDescription[currentLoginUserSubRole] || '';
			vm.rolesCanBeChanged.push(roleObj);
		}

		function inputValidator (form){
			var propNameList = Object.keys($scope.editUser);
			var isInputValid = true;

			for(var i = 0; i < propNameList.length; i++){
				var currentPropName = propNameList[i];

				if(currentPropName.startsWith('$')){
					continue;
				}
				if(currentPropName === 'password' && !form[currentPropName].$viewValue){
					continue;
				}
				if(!form[currentPropName].$valid){
					isInputValid = false;
				}			  
			}
			return isInputValid
		}

		function updateProfile(){
			currentSelectedRoles = [];
			vm.rolesCanBeChanged.forEach(function(roleObj){
				if(roleObj.isCheck){
					currentSelectedRoles.push(roleObj.roleTitle)
				}
			});

			var paramsToBeUpdated = {};
			var propNameList = Object.keys(originUser);

			for(var i = 0; i < propNameList.length; i++){
				var propName = propNameList[i]
		 
				if(vm.user[propName] === originUser[propName]){
					continue;
				}
				if(propName === 'password' && !vm.user.password){
					continue;
				}
				paramsToBeUpdated[propName] = vm.user[propName];
			}

			if(!ToolsFactory.isSameArray(currentSelectedRoles, originSelectedRoles)){
				paramsToBeUpdated.roles = currentSelectedRoles;
			}

			if(Object.keys(paramsToBeUpdated).length == 0){
				MessageService.showToast("No changes is made")
				return;
			}
			if(!inputValidator($scope.editUser, vm.validWarnings) || vm.isUsernameAvailable === false || vm.isEmailAvailable === false){
				MessageService.showToast("Please make sure all input is valid")
				return;
			}
			var userID = originUser.id_user;
			var companyID = originUser.fk_id_company;

			vm.isDisableButton = true;

			ProgressService.setMode("indeterminate");
			ProgressService.isVisble(true);

			UserService.updateUser(userID, companyID, paramsToBeUpdated, updateCallback);
		}

		function checkUsername(){
			if($scope.editUser.username.$invalid){
				return;
			}
			
			if(vm.user.username != originUser.username){
				vm.isCheckingUsername = true;
				UserService.checkAvailability("username", vm.user.username, checkUsernameCallback); 
			} else {
				vm.isUsernameAvailable = true;
			}
		}

		function checkUsernameCallback(result){
			vm.isCheckingUsername = false;
			vm.isUsernameAvailable = result;
		}
		
		function checkEmail(){
			if($scope.editUser.email.$invalid){
				return;
			}  

			if(vm.user.email != originUser.email){
				vm.isCheckingEmail = true;
				UserService.checkAvailability("email", vm.user.email, checkEmailCallback);
			} else {
				vm.isEmailAvailable = true;
			}
		}

		function checkEmailCallback(result){
			vm.isCheckingEmail = false;
			vm.isEmailAvailable = result;
		}		

		function updateCallback(err, result){
			ProgressService.isVisble(false);
			vm.isDisableButton = false;

			if(err){
				MessageService.showToast(err);
				return;
			}

			originUser = Object.assign({},vm.user);
			originSelectedRoles = currentSelectedRoles; 

			vm.headerFirstName = originUser.first_name;
			vm.headerLastName = originUser.last_name;

			MessageService.showToast("Success !");
		}

		vm.uploader.onAfterAddingFile = function(fileItem) {
			vm.isDisableButton = true;
			fileItem.removeAfterUpload = true;

			var userID 	= vm.user.id_user
			var imageID;

			if(vm.user.profileimage != null && Array.isArray(vm.user.profileimage)){
				imageID = vm.user.profileimage[0].id_profile_image;
			}

			var url;
			var method;

			if(imageID == null){
				url = FileUploadService.getUrlForCreateProfileImage(userID)
				method = "POST";
			}else{
				url = FileUploadService.getUrlForUpdateProfileImage(userID, imageID)
				method = "PUT";
			}

			fileItem.url = url;
			fileItem.method = method;

			var url = URL.createObjectURL(fileItem._file);
			fileItem.imageSrc = $sce.trustAsResourceUrl(url);

			ProgressService.setMode("indeterminate");
			ProgressService.isVisble(true);
			vm.uploader.uploadAll();
		};

		vm.uploader.onErrorItem = function(fileItem, response, status, headers) {
			ProgressService.isVisble(false);
			vm.isDisableButton = false; 
			MessageService.showToast(status + ": Fail to upload file.")
		};

		vm.uploader.onCompleteItem = function(fileItem, response, status, headers) {
			ProgressService.isVisble(false);
			vm.isDisableButton = false; 

			if(headers.code != Const.code.success){
				MessageService.showToast(headers.code + ': ' + headers.message);  
				return;
			}

			if(!Array.isArray(vm.user.profileimage)){
				vm.user.profileimage = [];
			}

			if(!vm.user.profileimage[0]){
				vm.user.profileimage[0] = {};
			}

			vm.user.profileimage[0].url = response.url;
			vm.user.profileimage[0].id_profile_image = response.id_profile_image;

			MessageService.showToast("Success !")	  		   				
		};
	}
})();
(function ()
{
	'use strict';

	angular
		.module('app.settings.users')
		.controller('AddUserController', AddUserController);

	function AddUserController($sce, $scope, $state, ToolsFactory, UserService, LoginService, $timeout, MessageService, Const, FileUploader, FileUploadService, ProgressService, RoleCheckService){   
		var vm = this;

		vm.user = {};
		vm.addUser = addUser;
		vm.roles = [];

		vm.checkUsername = checkUsername;
		vm.checkEmail = checkEmail;
		vm.disableAddButton = false;		
		vm.processStatus = {};

		var loginUserSubRoles = RoleCheckService.getAssignableRoleTitles();
		var companyID = LoginService.getCompanyID();

		vm.uploader = FileUploadService.getNewUploader();

		var imageFilter = FileUploadService.getImageFilter();
		var sizeFilter 	= FileUploadService.getSizeFilter(5);

		vm.uploader.filters.push(imageFilter);
		vm.uploader.filters.push(sizeFilter);		

		init ();

		function addUser(){
			if($scope.addUser.$invalid){
				MessageService.showToast("Please make sure all input is valid");
				return;
			}

			if(vm.isUsernameAvailable !== true || vm.isEmailAvailable !== true){
				ensureAvailabilityThenAdd();
				return;
			}

			submitNewUser();
		}

		function ensureAvailabilityThenAdd(){
			UserService.checkAvailability("username", vm.user.username, function(usernameOk){
				vm.isUsernameAvailable = usernameOk;
				if(!usernameOk){
					MessageService.showToast("Please make sure all input is valid");
					return;
				}

				UserService.checkAvailability("email", vm.user.email, function(emailOk){
					vm.isEmailAvailable = emailOk;
					if(!emailOk){
						MessageService.showToast("Please make sure all input is valid");
						return;
					}

					submitNewUser();
				});
			});
		}

		function submitNewUser(){
			var roles = [];
			vm.roles.forEach(function(currentRole){
				if(currentRole.isCheck){
					roles.push(currentRole.roleTitle);
				}
			});

			var newUser = vm.user;
			newUser.roles = roles;

			vm.disableAddButton = true;
			ProgressService.isVisble(true);

			UserService.addUser(companyID, newUser, addUserCallback);
		}

		function init (){
			loginUserSubRoles.forEach(function(currentRole){
				var roleObj={};

				roleObj.description = Const.roleDescription[currentRole] || '';
				roleObj.roleTitle = currentRole;
				roleObj.displayName = RoleCheckService.getRoleDisplayName(currentRole);
				roleObj.isCheck = false;
		
				vm.roles.push(roleObj);	 
			})
		}

		function checkUsername(username){
			if($scope.addUser.username.$invalid){
				return;
			}
			
			if(username != null){
				vm.isCheckingUsername = true;
				UserService.checkAvailability("username", username, checkUsernameCallback); 
			}	
		}

		function checkUsernameCallback(result){
			vm.isCheckingUsername = false;
			vm.isUsernameAvailable = result;
		}
		
		function checkEmail(email){
			if($scope.addUser.email.$invalid){
				return;
			}		   
			
			if(email != null){
				vm.isCheckingEmail = true;
				UserService.checkAvailability("email", email, checkEmailCallback);
			}
		}

		function checkEmailCallback(result){
			vm.isCheckingEmail = false;
			vm.isEmailAvailable = result;
		} 

		function addUserCallback (error, newUserID){		 
			if(error){
				ProgressService.isVisble(false);
				MessageService.showToast(error);
				vm.disableAddButton = false;
				return
			}

			if(vm.uploader.queue == 0){
				ProgressService.isVisble(false);
				MessageService.showToast("Success !")		   
				$state.go("app.settings.users.view-user");	 
				return;	   	
			}
			vm.uploader.onBeforeUploadItem = function(item) {
				item.removeAfterUpload = true;
				item.url = FileUploadService.getUrlForCreateProfileImage(newUserID);	
			}

			ProgressService.setMode("indeterminate");
			ProgressService.isVisble(true);

			vm.uploader.uploadAll();
		}

		vm.uploader.onAfterAddingFile = function(fileItem) {
			vm.uploader.queue = [];
			
			var url = URL.createObjectURL(fileItem._file);
			fileItem.imageSrc = $sce.trustAsResourceUrl(url);

			vm.uploader.queue.push(fileItem);	
		}

		vm.uploader.onErrorItem = function(fileItem, response, status, headers) {
			ProgressService.isVisble(false);
			vm.disableAddButton = false; 

			MessageService.showToast(status + ": Fail to upload file.")
		};

		vm.uploader.onCompleteItem = function(fileItem, response, status, headers) {
			if(!FileUploadService.isUploadSuccess(headers)){
				MessageService.showToast(headers.message);
				return;
			}
			
			ProgressService.isVisble(false);
			vm.disableAddButton = false; 

			if(headers.code == Const.code.success){
				vm.user.profileimage = {};
				vm.user.profileimage.url = response.url;
				vm.user.profileimage.id_profile_image = response.id_profile_image;

				MessageService.showToast("Success !")	 
				$state.go("app.settings.users.view-user"); 
				return
			}

			MessageService.showToast("Success create user, but fail to upload image")
			$state.go("app.settings.users.view-user"); 
			return;   		   				
		};
	}
})();
(function ()
{
	'use strict';

	angular
		.module('app.settings.miscfeestypes', [])
		.config(config);

	/** @ngInject */
	function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider, miscfeestypesTempValueProvider)
	{	   
		var miscfeestypesTempValue = miscfeestypesTempValueProvider.$get();

		$stateProvider
			.state("app.settings.miscfeestypes",{
				url:"/miscfeestypes"
			})
			.state("app.settings.miscfeestypes.view-miscfeestypes",{
				url:"/view-miscfeestypes",
				views	: {
					'content@app': {
						templateUrl: 'app/main/settings/miscfeestypes/view-miscfeestypes/view-miscfeestypes.html',
						controller : 'ViewmiscfeestypesController as vm'
					}
				},
				resolve :{
					miscfeestypes:function(apiResolver, LoginService){
						return apiResolver.resolve('miscfeestypes@getmiscfeestypes', {
							companyID: LoginService.getCompanyID(), 
							vehicleID: 0, 
							workorderID: 0
						});
					}
				}
			})
			.state('app.settings.miscfeestypes.add-miscfeestypes', {
				url	  : '/add-miscfeestypes',
				views	: {
					'content@app': {
						templateUrl: 'app/main/settings/miscfeestypes/add-miscfeestypes/add-miscfeestypes.html',
						controller : 'AddmiscfeestypesController as vm'
					}
				}
			})
	 }


})();
(function ()
{
    'use strict';

    angular.module('app.settings.miscfeestypes')
        .controller('DeletePromptDialogControllermiscfeestypes', DeletePromptDialogControllermiscfeestypes);

    /** @ngInject */
    function DeletePromptDialogControllermiscfeestypes(miscfeestypes, deletemiscfeestypes, $mdDialog,miscfeestypesService)
    {
        var vm = this;
        vm.miscfeestypes = miscfeestypes;
        vm.deletemiscfeestypes = deletemiscfeestypes
        vm.confirm = confirm;
        vm.isButtonActive = false;
        vm.enableButton = enableButton;
        vm.closeDialog = closeDialog;

        function confirm(){
            deletemiscfeestypes(miscfeestypes);
            $mdDialog.hide();
        }

        function closeDialog (){
            $mdDialog.hide();
        }

        function enableButton(){
            if(vm.miscfeestypes.name == vm.confirmmiscfeesname){
                vm.isButtonActive = true;
            }else{
                vm.isButtonActive = false;
            }
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.settings.miscfeestypes')
        .controller('ViewmiscfeestypesController', ViewmiscfeestypesController);

    function ViewmiscfeestypesController($scope, $state, ToolsFactory, $filter, miscfeestypes, LoginService, miscfeestypesService, $mdDialog, MessageService, $document){   
        var vm = this;
        var dataForEveryPage;
        var totalPage;
        var loginUserInfo = LoginService.getUserInfo();

        if(typeof(loginUserInfo) == "undefined"){
            return;
        }

        for(var i = 0; i < miscfeestypes.length; i++){
            miscfeestypes[i].canBeChanged = true;
            miscfeestypes[i].isOwner = true;

            if(loginUserInfo.userID == miscfeestypes[i].id_user){
                miscfeestypes[i].isOwner = true;
            }
        }

        var filteredUsers = miscfeestypes;
        vm.totalUser = filteredUsers.length;
        vm.search = search;        
        vm.resetTable = resetTable;
        // vm.goToEditLabour = goToEditLabour;
        // vm.deleteLabour = deleteLabour;
        vm.goToPage = goToPage;
        vm.goToLastPage = goToLastPage;
        vm.options = [10, 25, 50, 100];
        vm.itemPerPage = vm.options[0];
        vm.dialogTest = dialogTest;
        vm.dialogedit = dialogedit;
        vm.pageOptions;
        vm.miscfeestypes = miscfeestypes
        resetTable();

        function resetTable(){
            dataForEveryPage = ToolsFactory.dividDataByPage(filteredUsers, vm.itemPerPage);
            totalPage = dataForEveryPage.length;
            goToPage(1);
        }

        function search(){
            filteredUsers = $filter('filter')(miscfeestypes, vm.keyword);
            vm.totalUser = filteredUsers.length;
            resetTable();
        }

        function goToEditmiscfeestypes(miscfeestypesID,companyID){
            var params = {
                    miscfeestypesID:miscfeestypesID,
                    companyID:companyID 
                };
            $state.go("app.settings.miscfeestypes.edit-miscfeestypes", params);  
        }

        function deletemiscfeestypes(miscfeestypes){
            miscfeestypesService.deletemiscfeestypes(miscfeestypes, deletemiscfeestypesCallback);
        }

        function deletemiscfeestypesCallback (err, miscfeestypestypeID) {

        	if(err){
        		MessageService.showToast(err)
        		return;
        	}

            for(var i = 0; i<miscfeestypes.length; i++){
                var currentUser = miscfeestypes[i];
                if(currentUser.id_miscfee == miscfeestypestypeID.id_miscfee){
                    miscfeestypes.splice(i,1);
                }
            }
            filteredUsers = miscfeestypes;
            resetTable();
            MessageService.showToast("refresh Success !");

        }

        function updatemiscfeestypes(miscfeestypes){
            miscfeestypesService.updatemiscfeestypes(miscfeestypes, updatemiscfeestypesCallback);
        }

        function updatemiscfeestypesCallback (err, miscfeestypes) {

        	if(err){
        		MessageService.showToast(err)
        		return;
        	}
            MessageService.showToast("refresh Success !");

        }

        function goToPage(pageNumber){
            vm.miscfeestypes = dataForEveryPage[pageNumber - 1];
            vm.pages = ToolsFactory.pageListBuilder(totalPage, pageNumber);
        }   

        function goToLastPage(){
            goToPage(totalPage)
        }   

        function dialogTest(miscfeestypes){
            $mdDialog.show({
                controller         : 'DeletePromptDialogControllermiscfeestypes',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/settings/miscfeestypes/dialogs/delete-prompt-dialog-miscfeestypes.html',
                clickOutsideToClose: true,
                locals             : {
                    miscfeestypes      : miscfeestypes,
                    deletemiscfeestypes : deletemiscfeestypes
                }
            });
        }

        function dialogedit(miscfeestypes){
            $mdDialog.show({
                controller         : 'EditPromptDialogControllermiscfeestypes',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/settings/miscfeestypes/edit-miscfeestypes/edit-miscfeestypes.html',
                clickOutsideToClose: true,
                locals             : {
                    miscfeestypes      : miscfeestypes,
                    updatemiscfeestypes : updatemiscfeestypes
                }
            });
        }
    }
})();
(function ()
{
    'use strict';

    angular.module('app.settings.miscfeestypes')
        .controller('EditPromptDialogControllermiscfeestypes', EditPromptDialogControllermiscfeestypes);

    /** @ngInject */
    function EditPromptDialogControllermiscfeestypes(miscfeestypes, updatemiscfeestypes, $mdDialog, $state)
    {
        var vm = this;
        vm.miscfeestypes = miscfeestypes;
        vm.updatemiscfeestypes = updatemiscfeestypes
        vm.confirm = confirm;
        vm.isButtonActive = true;
        vm.enableButton = enableButton;
        vm.closeDialog = closeDialog;

        vm.name = vm.miscfeestypes.name;
        vm.default_retail_price = vm.miscfeestypes.default_retail_price;
        vm.default_quantity = vm.miscfeestypes.default_quantity;
        vm.is_default = vm.miscfeestypes.is_default == 1;

        function confirm(){
            vm.miscfeestypes.name = vm.name;
            vm.miscfeestypes.default_retail_price = vm.default_retail_price;
            vm.miscfeestypes.default_quantity = vm.default_quantity;
            vm.miscfeestypes.is_default = vm.is_default ? 1 : 0;
            updatemiscfeestypes(miscfeestypes);

            
            $mdDialog.hide();
        }

        function closeDialog (){
            $mdDialog.hide();
        }

        function enableButton(){
            if(vm.name.length  >= 1){
                vm.isButtonActive = true;
            }else{
                vm.isButtonActive = false;
            }
        }
    }
})();

(function ()
{
	'use strict';

	angular
		.module('app.settings.miscfeestypes')
		.controller('AddmiscfeestypesController', AddmiscfeestypesController);

	function AddmiscfeestypesController($sce, $scope, $state, ToolsFactory, miscfeestypesService, LoginService, $timeout, MessageService, Const, FileUploader, FileUploadService, ProgressService){   
		var vm = this;

		vm.miscfeestypes = {};
		vm.addmiscfeestypes = addmiscfeestypes;
		vm.roles = [];
		vm.checkmiscfeestypesdescription = checkmiscfeestypesdescription;

		vm.checkEmail = checkEmail;
		vm.disableAddButton = false;		
		vm.processStatus = {};

		var loginUserSubRoles = LoginService.getUserSubRoles();
		var companyID = LoginService.getCompanyID();

		vm.uploader = FileUploadService.getNewUploader();

		var imageFilter = FileUploadService.getImageFilter();
		var sizeFilter 	= FileUploadService.getSizeFilter(5);

		vm.uploader.filters.push(imageFilter);
		vm.uploader.filters.push(sizeFilter);		

		init ();

		function addmiscfeestypes(){
			if($scope.addmiscfeestypes.$invalid){
				MessageService.showToast("Please make sure all input is valid");
				return;
			}
			var newmiscfeestypes= vm.miscfeestypes;

			vm.disableAddButton = true;
			ProgressService.isVisble(true);

			miscfeestypesService.addmiscfeestypes(companyID, newmiscfeestypes, addmiscfeestypesCallback);
		}

		function init (){
			loginUserSubRoles.forEach(function(currentRole){
				var roleObj={};

				roleObj.description = Const.roleDescription[currentRole];
				roleObj.roleTitle = currentRole;
				roleObj.isCheck = false;
		
				vm.roles.push(roleObj);	 
			})
		}

		function checkmiscfeestypesdescription(username){
			
			if(username != null){
				vm.isCheckingUsername = true;
				
			}	
		}
		function checkEmail(email){
			if($scope.addUser.email.$invalid){
				return;
			}		   
			
			if(email != null){
				vm.isCheckingEmail = true;
				UserService.checkAvailability("email", email, checkEmailCallback);
			}
		}

		function checkEmailCallback(result){
			vm.isCheckingEmail = false;
			vm.isEmailAvailable = result;
		} 

		function addmiscfeestypesCallback (error, newUserID){	 
			if(error){
				ProgressService.isVisble(false);
				MessageService.showToast(error);
				vm.disableAddButton = false;
				return
			}

			if(vm.uploader.queue == 0){
				ProgressService.isVisble(false);
				MessageService.showToast("Success !")		   
				$state.go("app.settings.miscfeestypes.view-miscfeestypes");	 
				return;	   	
			}
			ProgressService.setMode("indeterminate");
			ProgressService.isVisble(true);

			
			vm.uploader.uploadAll();
		}

		vm.uploader.onAfterAddingFile = function(fileItem) {
			vm.uploader.queue = [];
			
			var url = URL.createObjectURL(fileItem._file);
			fileItem.imageSrc = $sce.trustAsResourceUrl(url);

			vm.uploader.queue.push(fileItem);	
		}

		vm.uploader.onErrorItem = function(fileItem, response, status, headers) {
			ProgressService.isVisble(false);
			vm.disableAddButton = false; 

			MessageService.showToast(status + ": Fail to upload file.")
		};

		vm.uploader.onCompleteItem = function(fileItem, response, status, headers) {
			if(!FileUploadService.isUploadSuccess(headers)){
				MessageService.showToast(headers.message);
				return;
			}
			
			ProgressService.isVisble(false);
			vm.disableAddButton = false; 

			if(headers.code == Const.code.success){
				vm.user.profileimage = {};
				vm.user.profileimage.url = response.url;
				vm.user.profileimage.id_profile_image = response.id_profile_image;

				MessageService.showToast("Success !")	 
				$state.go("app.settings.users.view-user"); 
				return
			}

			MessageService.showToast("Success create user, but fail to upload image")
			$state.go("app.settings.users.view-user"); 
			return;   		   				
		};
	}
})();
(function ()
{
	'use strict';

	angular
		.module('app.settings.packages', [])
		//.module('app.settings.presetPackages', [])
		.constant("PresetPackageConstants", {
			dateFormat: "YYYY-MM-DD",
			itemTypeIDs:{
				MECHANIC: 1
			}
		})
		.config(config);

	/** @ngInject */
	function config($stateProvider)
	{
		$stateProvider
		.state("app.settings.packages",{
			url:"/packages"
		})
		.state("app.settings.packages.presetPackages",{
				url:"/presetPackages",
				views	: {
					'content@app': {
						templateUrl: 'app/main/settings/preset-packages/preset-packages.html',
						controller : 'PresetPackagesController as vm'
					}
				},
				resolve :{
					jobtypes:function(apiResolver, LoginService){
						return apiResolver.resolve('jobtypes@getJob', {
							companyID: LoginService.getCompanyID(), 
						});
					}
				}
			})
		.state("app.settings.packages.viewPackages",{
				url	  : '/view-packages',
				views	: {
					'content@app': {
						templateUrl: 'app/main/settings/preset-packages/view-packages/view-packages.html',
						controller : 'ViewpackagesController as vm'
					}
				},
				resolve :{
					jobtypes:function(apiResolver, LoginService){
						return apiResolver.resolve('jobtypes@getJob', {
							companyID: LoginService.getCompanyID(), 
						});
					}
				}
			})
	}
})();
(function ()
{
    'use strict';

    angular
        .module('app.settings.packages')
        .controller('ViewpackagesController', ViewpackagesController);

    function ViewpackagesController($scope, $state, ToolsFactory, $filter, jobtypes, LoginService, jobtypesService, $mdDialog, MessageService, $document, LabourService, PartTypesService, miscfeestypesService, $q, DialogService, GeneralTools, PresetPackagesService, PresetPackage){   
        const vm = this;
		const companyID = LoginService.getCompanyID();
		
		vm.today = new Date();
		vm.setActiveExpDate = setActiveExpDate
		vm.translateToDollar = GeneralTools.inputTranslators.dollar;
		vm.decimalTranslator = GeneralTools.inputTranslators.decimal;
		vm.quantityInputOption = {
			decimalFractionSize:0
		};
		
		vm.addItem = addItem;
		vm.addPackage = addPackage;
		vm.deletePackages = deletePackages;
		vm.removeNewItem = removeNewItem;
		vm.check = check
		vm.jobTyppList = jobtypes
		vm.newAssignedJobHolder = "";
		init();

		function init(){
			//initPackageTypes();
			initNewPresetPackage();
			initPresetPackages();
		}

		function initPackageTypes(){
			PresetPackagesService.getPackageItemTypes().$promise.then(function(packageItemTypes){
				vm.packageItemTypes = packageItemTypes;
			})
			.catch(MessageService.showToast);
		}

		function initNewPresetPackage(){
			vm.newPresetPackage = new PresetPackage();
			vm.newPresetPackage.items = [];
		}

		function initPresetPackages(){
			PresetPackagesService.getPresetPackages({companyID: companyID}).$promise.then(function(presetPackages){
				if(!Array.isArray(presetPackages)){
					return;
				}

				vm.presetPackages = presetPackages;
			})
			.catch(MessageService.showToast);
		}

		function addItem(){
			if(!$scope.packageItemForm.$valid){
				MessageService.showToast("Something wrong in package item form");
				return;
			}

			if(!$scope.packageItemJobForm.$valid){
				MessageService.showToast("Something wrong in job item coverage form");
				return;
			}

			if(vm.newAssignedJobHolder && vm.newAssignedJobHolder.items && vm.newAssignedJobHolder.items[0] && vm.newAssignedJobHolder.items[0].job){
				if(vm.newAssignedJobHolder.items[0].job.job_labour.length > 0){
					vm.newAssignedJobHolder.items[0].job.job_labour.forEach(function(){
						
					})
				}

			}
			vm.newPresetPackage.items.push({
				name: vm.newPackageItemName,
				quantity: vm.newPackageItemQuantity,
				job: vm.newAssignedJobHolder
				//fk_id_package_item_type: vm.newPackageItemType
			});

			resetPackageItemForm();
		}

		function resetPackageItemForm(){
			vm.newPackageItemName = null;
			vm.newPackageItemQuantity = null;
			vm.newAssignedJobHolder = null;
			//vm.newPackageItemType = null;

			$scope.packageItemForm.$setPristine(true);
			$scope.packageItemForm.$setUntouched();

			$scope.packageItemJobForm.$setPristine(true);
			$scope.packageItemJobForm.$setUntouched();
		}

		function setActiveExpDate(){
			if(!vm.newPackageActiveExpiryDate){
				vm.newPresetPackage.active_expiry_date = null;
				return
			}

			vm.newPresetPackage.setActiveExpiryDate(moment(vm.newPackageActiveExpiryDate));

			if(!vm.newPresetPackage.active_expiry_date){
				vm.newPackageActiveExpiryDate = null
			}
		}
		function check(){
		}
		function addPackage(){

			if(!$scope.newPackageForm.$valid){			
				MessageService.showToast("Something wrong in the package form.");
				return;
			}

			
			if(!$scope.newPackageForm2.$valid){			
				MessageService.showToast("Something wrong in the package form.");
				return;
			}

			if(!Array.isArray(vm.newPresetPackage.items) || vm.newPresetPackage.items.length <= 0){
				MessageService.showToast("Please add an item to the package.");
				return;
			}

			const resourcePath = {
				companyID: companyID
			}

			vm.newPresetPackage.items.forEach(function(item){
				item.fk_id_job = item.job.id_job
			})

			if(!vm.newPresetPackage.valid_mileage){
				vm.newPresetPackage.valid_mileage = null
			}

			vm.isSaving = true;
			
			PresetPackagesService.createPresetPackages(resourcePath, vm.newPresetPackage).$promise
				.then(function(newPresetPackageID){
					vm.newPresetPackage.id_preset_package = newPresetPackageID
					vm.presetPackages.push(angular.copy(vm.newPresetPackage));
					resetNewPackageForm();
					MessageService.showToast("Package added");
                    $state.go("app.settings.packages.presetPackages");	 
				})
				.catch(MessageService.showToast)
				.finally(function(){
					vm.isSaving = false;
				});
		}

        // function addjobCallback (error, newUserID){	 
		// 	if(error){
		// 		ProgressService.isVisble(false);
		// 		MessageService.showToast(error);
		// 		vm.disableAddButton = false;
		// 		return
		// 	}

		// 	if(vm.uploader.queue == 0){
		// 		ProgressService.isVisble(false);
		// 		MessageService.showToast("Success !")		   
		// 		$state.go("app.settings.jobtypes.view-jobtypes");	 
		// 		return;	   	
		// 	}
		// 	ProgressService.setMode("indeterminate");
		// 	ProgressService.isVisble(true);

			
		// 	vm.uploader.uploadAll();
		// }

		function deletePackages(){
			if(!vm.getSelectedPackages){
				return;
			}

			const selectedPackages = vm.getSelectedPackages();

			if(!Array.isArray(selectedPackages) ){
				return;
			}

			if(selectedPackages.length <= 0){
				MessageService.showToast("Please select a package.");
				return;
			}

			vm.isDeleting = true;

			DialogService.showYesOrNoDialog("Delete Packages", "Delete " + selectedPackages.length + " packages")
				.then(function(isYes){
					if(!isYes){
						return $q.reject();
					}

					const queue = [];

					selectedPackages.forEach(function(presetPackage){
						queue.push(deletePresetPackage(presetPackage));
					});

					return $q.all(queue);
				})
				.then(function(){
					MessageService.showToast("Packages deleted");
				})
				.catch(function(error){
					if(error){
						MessageService.showToast(error);
					}
				})
				.finally(function(){
					vm.isDeleting = false;
				});
		}

		function deletePresetPackage(presetPackage){
			const resourcePath = {
				companyID: companyID,
				presetpackageID: presetPackage.id_preset_package
			}

			return PresetPackagesService.deletePresetPackages(resourcePath).$promise				
				.then(function(){
					const index = vm.presetPackages.findIndex(function(item){
						return !!item && item.id_preset_package == presetPackage.id_preset_package;
					});

					vm.presetPackages.splice(index, 1);
					return $q.resolve();	
				});
		}

		function removeNewItem(index){
			if(vm.newPresetPackage && Array.isArray(vm.newPresetPackage.items)){
				vm.newPresetPackage.items.splice(index, 1);
			}
		}

		function resetNewPackageForm(){
			initNewPresetPackage();
			vm.newPackageActiveExpiryDate = null;
			$scope.newPackageForm.$setPristine();
			$scope.newPackageForm.$setUntouched();
			$scope.newPackageForm2.$setPristine();
			$scope.newPackageForm2.$setUntouched();
		}
    }
})();
(function ()
{
    'use strict';

    angular.module('app.settings.parttype', [])
        .controller('EditPromptDialogControllerparttype', EditPromptDialogControllerparttype);

    /** @ngInject */
    function EditPromptDialogControllerparttype(parttype, updateparttype, $mdDialog,LabourService, $state)
    {
        var vm = this;
        vm.parttype = parttype;
        vm.updateparttype = updateparttype
        vm.confirm = confirm;
        vm.isButtonActive = true;
        vm.enableButton = enableButton;
        vm.closeDialog = closeDialog;

        vm.name = vm.parttype.name;
        //vm.default_retail = vm.parttype.default_retail;




        function confirm(){
            vm.parttype.name =  vm.name;
            //vm.parttype.default_retail = vm.default_retail;
            updateparttype(parttype);

            
            $mdDialog.hide();
        }

        function closeDialog (){
            $mdDialog.hide();
        }

        function enableButton(){
            if(vm.name.length  >= 1){
                vm.isButtonActive = true;
            }else{
                vm.isButtonActive = false;
            }
        }
    }
})();

(function ()
{
    'use strict';

    angular.module('app.settings.packages')
        .controller('EditpackagesController', EditpackagesController);

    /** @ngInject */
    function EditpackagesController(autocartpackage, jobtypes, refreshPresetPackages, $mdDialog, LoginService, PresetPackagesService, MessageService, $state, $scope)
    {
        var vm = this;
        const companyID = LoginService.getCompanyID();
        vm.autocartpackage = angular.copy(autocartpackage)
        vm.autocartpackagebackup = angular.copy(autocartpackage)
        vm.closeDialog = closeDialog;
        vm.jobTyppList = jobtypes
        vm.newAssignedJobHolder = "";
		vm.editingList = {};
        vm.refreshPresetPackages = refreshPresetPackages;

		function closeDialog (){
            $mdDialog.hide();
        }

		vm.editContent = function editContent(item){
            
            vm.editingList[item] = true
        }

		vm.finisheditContent =  function finisheditContent(item){
            vm.autocartpackage.active_expiry_date = moment(vm.autocartpackage.active_expiry_date).format("YYYY-MM-DD") 
            vm.editingList[item] = false
        }

        vm.cancelEdit = function cancelEdit(){
   
            vm.autocartpackage = angular.copy(vm.autocartpackagebackup)
     
            $mdDialog.hide();

        }
        
        vm.updatePackage = function updatePackage(){
            const resourcePath = {
				companyID: companyID
			}

            PresetPackagesService.updatePresetPackages(resourcePath, vm.autocartpackage).$promise
            .then(function(newPresetPackageID){

                MessageService.showToast("Package updated");
            })
            .catch(MessageService.showToast)
            .finally(function(){
                refreshPresetPackages();
            });

            $mdDialog.hide();

        }

        vm.deleteItem = function addnewlabour(item, presetPackage){
            const index = presetPackage.items.findIndex(function(element) {return element.id_preset_package_item === item.id_preset_package_item});
            if (index !== -1) {
            presetPackage.items.splice(index, 1);
            }
        }

        vm.addItem = function addItem(){
			if(!$scope.packageItemForm.$valid){
				MessageService.showToast("Something wrong in package item form");
				return;
			}

			if(!$scope.packageItemJobForm.$valid){
				MessageService.showToast("Something wrong in job item coverage form");
				return;
			}

            vm.autocartpackage.items.push({
				name: vm.newPackageItemName,
				quantity: vm.newPackageItemQuantity,
                fk_id_job: vm.newAssignedJobHolder.id_job,
				coverage_json: {
					job_labour: vm.newAssignedJobHolder.job_labour,
					job_miscfee: vm.newAssignedJobHolder.job_miscfee,
					job_part:	vm.newAssignedJobHolder.job_part
				}
			});
			resetPackageItemForm();
		}

        function resetPackageItemForm(){
			vm.newPackageItemName = null;
			vm.newPackageItemQuantity = null;
			vm.newAssignedJobHolder = null;
			//vm.newPackageItemType = null;

			$scope.packageItemForm.$setPristine(true);
			$scope.packageItemForm.$setUntouched();

			$scope.packageItemJobForm.$setPristine(true);
			$scope.packageItemJobForm.$setUntouched();
		}

	}
})();

(function ()
{
    'use strict';

    angular
        .module('app.settings.parttype')
        .controller('ViewParttypesController', ViewParttypesController);

    function ViewParttypesController($scope, $state, ToolsFactory, $filter, LoginService, PartTypesService, $mdDialog, MessageService, $document, parttype){   
        var vm = this;
        var dataForEveryPage;
        var totalPage;
        var loginUserInfo = LoginService.getUserInfo();

        var companyID = LoginService.getCompanyID();
        vm.parttype = parttype
        if(typeof(loginUserInfo) == "undefined"){
            return;
        }


        for(var i = 0; i < parttype.length; i++){
            parttype[i].canBeChanged = true;
            parttype[i].isOwner = true;

            if(loginUserInfo.userID == parttype[i].id_user){
                parttype[i].isOwner = true;
            }
        }

        var filteredUsers = parttype;

        vm.totalUser = filteredUsers.length;
        vm.search = search;        
        vm.resetTable = resetTable;
        vm.goToEditparttype = goToEditparttype;
        vm.deleteparttype = deleteparttype;
        vm.goToPage = goToPage;
        vm.goToLastPage = goToLastPage;
        vm.options = [10, 25, 50, 100];
        vm.itemPerPage = vm.options[0];
        // vm.dialogTest = dialogTest;
        vm.dialogedit = dialogedit;
        vm.pageOptions;
        
        resetTable();

        function resetTable(){
            dataForEveryPage = ToolsFactory.dividDataByPage(filteredUsers, vm.itemPerPage);
            totalPage = dataForEveryPage.length;
            goToPage(1);
        }

        function search(){
            filteredUsers = $filter('filter')(parttype, vm.keyword);
            vm.totalUser = filteredUsers.length;
            resetTable();
        }

        function goToEditparttype(id_part_type,companyID){
            var params = {
                    id_part_type:id_part_type,
                    companyID:companyID 
                };
            $state.go("app.settings.parttype.edit-parttype", params);  
        }

        function deleteparttype(parttype)
        {
            
            PartTypesService.deleteparttype(parttype, companyID,deleteparttypeCallback);
        }

        function deleteparttypeCallback (err, parttypesID) {

        	if(err){
        		MessageService.showToast(err)
        		return;
        	}
            for(var i = 0; i<parttype.length; i++){
                var currentUser = parttype[i];
                if(currentUser.id_part_type == parttypesID.id_part_type){
                    parttype.splice(i,1);
                }
            }
            filteredUsers = parttype;
            resetTable();
            MessageService.showToast("refresh Success !");

        }

        function updateparttype(parttype){
            PartTypesService.updateparttype(parttype, updateparttypeCallback);
        }

        function updateparttypeCallback (err, parttype) {

        	if(err){
        		MessageService.showToast(err)
        		return;
        	}
            MessageService.showToast("refresh Success !");

        }

        function goToPage(pageNumber){
            vm.parttype = dataForEveryPage[pageNumber - 1];
            vm.pages = ToolsFactory.pageListBuilder(totalPage, pageNumber);
        }   

        function goToLastPage(){
            goToPage(totalPage)
        }   

        function dialogedit(parttype){
            $mdDialog.show({
                controller         : 'EditPromptDialogControllerparttype',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/settings/parttype/edit-parttype/edit-parttype.html',
                clickOutsideToClose: true,
                locals             : {
                    parttype      : parttype,
                    updateparttype : updateparttype
                }
            });
        }
    }
})();
(function ()
{
	'use strict';

	angular
		.module('app.settings.parttype')
		.controller('AddParttypeController', AddParttypeController);

	function AddParttypeController($sce, $scope, $state, ToolsFactory, PartTypesService, LoginService, $timeout, MessageService, Const, FileUploader, FileUploadService, ProgressService){   
		
		var vm = this;

		vm.parttype = {};
		vm.addPartType = addPartType;
		vm.roles = [];
		vm.checkPartTypedescription = checkPartTypedescription;

		vm.checkEmail = checkEmail;
		vm.disableAddButton = false;		
		vm.processStatus = {};

		var loginUserSubRoles = LoginService.getUserSubRoles();
		var companyID = LoginService.getCompanyID();

		vm.uploader = FileUploadService.getNewUploader();

		var imageFilter = FileUploadService.getImageFilter();
		var sizeFilter 	= FileUploadService.getSizeFilter(5);

		vm.uploader.filters.push(imageFilter);
		vm.uploader.filters.push(sizeFilter);		

		init ();

		
		function addPartType(){
			if($scope.addPartType.$invalid){
				MessageService.showToast("Please make sure all input is valid");
				return;
			}
			var newPartType= vm.parttype;
			vm.disableAddButton = true;
			ProgressService.isVisble(true);
			PartTypesService.createparttype(companyID, newPartType, addPartTypeCallback);
		}

		function init (){
			loginUserSubRoles.forEach(function(currentRole){
				var roleObj={};

				roleObj.description = Const.roleDescription[currentRole];
				roleObj.roleTitle = currentRole;
				roleObj.isCheck = false;
		
				vm.roles.push(roleObj);	 
			})
		}

		function checkPartTypedescription(name){
			
			if(name != null){
				vm.isCheckingUsername = true;
				
			}	
		}


		function checkEmail(email){
			if($scope.addUser.email.$invalid){
				return;
			}		   
			
			if(email != null){
				vm.isCheckingEmail = true;
				UserService.checkAvailability("email", email, checkEmailCallback);
			}
		}

		function checkEmailCallback(result){
			vm.isCheckingEmail = false;
			vm.isEmailAvailable = result;
		} 

		function addPartTypeCallback (error, newUserID){	 
			if(error){
				ProgressService.isVisble(false);
				MessageService.showToast(error);
				vm.disableAddButton = false;
				return
			}

			if(vm.uploader.queue == 0){
				ProgressService.isVisble(false);
				MessageService.showToast("Success !")		   
				$state.go("app.settings.parttype.view-parttypes");	 
				return;	   	
			}
			vm.uploader.onBeforeUploadItem = function(item) {
				item.removeAfterUpload = true;
				item.url = FileUploadService.getUrlForCreateProfileImage(newUserID);	
			}

			ProgressService.setMode("indeterminate");
			ProgressService.isVisble(true);

			vm.uploader.uploadAll();
		}

		vm.uploader.onAfterAddingFile = function(fileItem) {
			vm.uploader.queue = [];
			
			var url = URL.createObjectURL(fileItem._file);
			fileItem.imageSrc = $sce.trustAsResourceUrl(url);

			vm.uploader.queue.push(fileItem);	
		}

		vm.uploader.onErrorItem = function(fileItem, response, status, headers) {
			ProgressService.isVisble(false);
			vm.disableAddButton = false; 

			MessageService.showToast(status + ": Fail to upload file.")
		};

		vm.uploader.onCompleteItem = function(fileItem, response, status, headers) {
			if(!FileUploadService.isUploadSuccess(headers)){
				MessageService.showToast(headers.message);
				return;
			}
			
			ProgressService.isVisble(false);
			vm.disableAddButton = false; 

			if(headers.code == Const.code.success){
				vm.user.profileimage = {};
				vm.user.profileimage.url = response.url;
				vm.user.profileimage.id_profile_image = response.id_profile_image;

				MessageService.showToast("Success !")	 
				$state.go("app.settings.users.view-user"); 
				return
			}

			MessageService.showToast("Success create user, but fail to upload image")
			$state.go("app.settings.users.view-user"); 
			return;   		   				
		};
	}
})();
(function ()
{
	'use strict';

	angular
		.module('app.settings.labour', [])
		.config(config);

	/** @ngInject */
	function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider, labourTempValueProvider)
	{	   
		var labourTempValue = labourTempValueProvider.$get();

		$stateProvider
			.state("app.settings.labour",{
				url:"/labour"
			})
			.state("app.settings.labour.view-labour",{
				url:"/view-labour",
				views	: {
					'content@app': {
						templateUrl: 'app/main/settings/labour/view-labour/view-labour.html',
						controller : 'ViewLabourController as vm'
					}
				},
				resolve :{
					labour:function(apiResolver, LoginService){
						return apiResolver.resolve('labour@getLabour', {companyID: LoginService.getCompanyID()});
					}
				}
			})
			.state('app.settings.labour.add-labour', {
				url	  : '/add-labour',
				views	: {
					'content@app': {
						templateUrl: 'app/main/settings/labour/add-labour/add-labour.html',
						controller : 'AddLabourController as vm'
					}
				}
			})
			.state('app.settings.labour.edit-labour', {
				url	  : '/edit-labour',
				views	: {
					'content@app': {
						templateUrl: 'app/main/settings/labour/edit-labour/edit-labour.html',
						controller : 'EditLabourController as vm'
					}
				},
				resolve:{
					Labour:function(apiResolver, $stateParams){
						var companyID = $stateParams.companyID;
						var userID = $stateParams.labourTypesID;

						var labourName = $stateParams.labourName;
						var labourRate = $stateParams.labourRate;
						var labourTime = $stateParams.labourTime;
						var labourQuantity = $stateParams.labourQuantity;

						if(typeof(companyID) == "number"){
							labourTempValue.setTempCompanyID(companyID);
						}else{
							companyID = labourTempValue.getTempCompanyID(companyID);
						}

						if(typeof(userID) == "number"){
							labourTempValue.setTempLabourID(userID);
						}else{
							userID = labourTempValue.getTempLabourID(userID);
						}
						return apiResolver.resolve('labour@getlabourr', {'labourTypesID' : userID, "companyID" : companyID, "labourName": labourName, "labourRate": labourRate, "labourTime": labourTime, "labourQuantity": labourQuantity});
					}
				},
				params: {
					labourTypesID: null,
					companyID: null,
					labourName: null,
					labourRate: null,
					labourTime: null,
					labourQuantity: null,
				}
			});
	}


})();
(function ()
{
    'use strict';

    angular.module('app.settings.labour')
        .controller('EditPromptDialogControllerLabour', EditPromptDialogControllerLabour);

    /** @ngInject */
    function EditPromptDialogControllerLabour(labour, updateLabour, $mdDialog,LabourService, $state)
    {
        var vm = this;
        vm.labour = labour;
        vm.updateLabour = updateLabour
        vm.confirm = confirm;
        vm.isButtonActive = true;
        vm.enableButton = enableButton;
        vm.closeDialog = closeDialog;

        vm.labourName = vm.labour.labour_name;
        vm.labourRate = vm.labour.default_rate;
        vm.labourTime = vm.labour.default_time;
        vm.labourQuantity = vm.labour.default_quantity;



        function confirm(){
            vm.labour.labour_name =  vm.labourName;
            vm.labour.default_rate = vm.labourRate;
            vm.labour.default_time =  vm.labourTime;
            vm.labour.default_quantity = vm.labourQuantity;
            updateLabour(labour);

            
            $mdDialog.hide();
        }

        function closeDialog (){
            $mdDialog.hide();
        }

        function enableButton(){
            if(vm.labourName.length  >= 1){
                vm.isButtonActive = true;
            }else{
                vm.isButtonActive = false;
            }
        }
    }
})();

(function ()
{
	'use strict';

	angular
		.module('app.settings.labour')
		.controller('AddLabourController', AddLabourController);

	function AddLabourController($sce, $scope, $state, ToolsFactory, LabourService, LoginService, $timeout, MessageService, Const, FileUploader, FileUploadService, ProgressService){   
		var vm = this;

		vm.labour = {};
		vm.addLabour = addLabour;
		vm.roles = [];
		vm.checkLabourdescription = checkLabourdescription;

		vm.checkEmail = checkEmail;
		vm.disableAddButton = false;		
		vm.processStatus = {};

		var loginUserSubRoles = LoginService.getUserSubRoles();
		var companyID = LoginService.getCompanyID();

		vm.uploader = FileUploadService.getNewUploader();

		var imageFilter = FileUploadService.getImageFilter();
		var sizeFilter 	= FileUploadService.getSizeFilter(5);

		vm.uploader.filters.push(imageFilter);
		vm.uploader.filters.push(sizeFilter);		

		init ();

		function addLabour(){
			
			if($scope.addLabour.$invalid){
				MessageService.showToast("Please make sure all input is valid");
				return;
			}
			var newLabour= vm.labour;

			vm.disableAddButton = true;
			ProgressService.isVisble(true);

			LabourService.addLabour(companyID, newLabour, addLabourCallback);
		}

		function init (){
			loginUserSubRoles.forEach(function(currentRole){
				var roleObj={};

				roleObj.description = Const.roleDescription[currentRole];
				roleObj.roleTitle = currentRole;
				roleObj.isCheck = false;
		
				vm.roles.push(roleObj);	 
			})
		}

		function checkLabourdescription(username){
			
			if(username != null){
				vm.isCheckingUsername = true;
				
			}	
		}
		function checkEmail(email){
			if($scope.addUser.email.$invalid){
				return;
			}		   
			
			if(email != null){
				vm.isCheckingEmail = true;
				UserService.checkAvailability("email", email, checkEmailCallback);
			}
		}

		function checkEmailCallback(result){
			vm.isCheckingEmail = false;
			vm.isEmailAvailable = result;
		} 

		function addLabourCallback (error, newUserID){	 
			if(error){
				ProgressService.isVisble(false);
				MessageService.showToast(error);
				vm.disableAddButton = false;
				return
			}

			if(vm.uploader.queue == 0){
				ProgressService.isVisble(false);
				MessageService.showToast("Success !")		   
				$state.go("app.settings.labour.view-labour");	 
				return;	   	
			}
			vm.uploader.onBeforeUploadItem = function(item) {
				item.removeAfterUpload = true;
				item.url = FileUploadService.getUrlForCreateProfileImage(newUserID);	
			}

			ProgressService.setMode("indeterminate");
			ProgressService.isVisble(true);

			vm.uploader.uploadAll();
		}

		vm.uploader.onAfterAddingFile = function(fileItem) {
			vm.uploader.queue = [];
			
			var url = URL.createObjectURL(fileItem._file);
			fileItem.imageSrc = $sce.trustAsResourceUrl(url);

			vm.uploader.queue.push(fileItem);	
		}

		vm.uploader.onErrorItem = function(fileItem, response, status, headers) {
			ProgressService.isVisble(false);
			vm.disableAddButton = false; 

			MessageService.showToast(status + ": Fail to upload file.")
		};

		vm.uploader.onCompleteItem = function(fileItem, response, status, headers) {
			if(!FileUploadService.isUploadSuccess(headers)){
				MessageService.showToast(headers.message);
				return;
			}
			
			ProgressService.isVisble(false);
			vm.disableAddButton = false; 

			if(headers.code == Const.code.success){
				vm.user.profileimage = {};
				vm.user.profileimage.url = response.url;
				vm.user.profileimage.id_profile_image = response.id_profile_image;

				MessageService.showToast("Success !")	 
				$state.go("app.settings.users.view-user"); 
				return
			}

			MessageService.showToast("Success create user, but fail to upload image")
			$state.go("app.settings.users.view-user"); 
			return;   		   				
		};
	}
})();
(function ()
{
    'use strict';

    angular
        .module('app.settings.labour')
        .controller('ViewLabourController', ViewLabourController);

    function ViewLabourController($scope, $state, ToolsFactory, $filter, labour, LoginService, LabourService, $mdDialog, MessageService, $document){   
        var vm = this;
        var dataForEveryPage;
        var totalPage;
        var loginUserInfo = LoginService.getUserInfo();

        if(typeof(loginUserInfo) == "undefined"){
            return;
        }

        for(var i = 0; i < labour.length; i++){
            labour[i].canBeChanged = true;
            labour[i].isOwner = true;

            if(loginUserInfo.userID == labour[i].id_user){
                labour[i].isOwner = true;
            }
        }

        var filteredUsers = labour;

        vm.totalUser = filteredUsers.length;
        vm.search = search;        
        vm.resetTable = resetTable;
        vm.goToEditLabour = goToEditLabour;
        vm.deleteLabour = deleteLabour;
        vm.goToPage = goToPage;
        vm.goToLastPage = goToLastPage;
        vm.options = [10, 25, 50, 100];
        vm.itemPerPage = vm.options[0];
        vm.dialogTest = dialogTest;
        vm.dialogedit = dialogedit;
        vm.pageOptions;
        
        resetTable();

        function resetTable(){
            dataForEveryPage = ToolsFactory.dividDataByPage(filteredUsers, vm.itemPerPage);
            totalPage = dataForEveryPage.length;
            goToPage(1);
        }

        function search(){
            filteredUsers = $filter('filter')(labour, vm.keyword);
            vm.totalUser = filteredUsers.length;
            resetTable();
        }

        function goToEditLabour(labourID,companyID){
            var params = {
                    labourTypesID:labourID,
                    companyID:companyID 
                };
            $state.go("app.settings.labour.edit-labour", params);  
        }

        function deleteLabour(labour){
            LabourService.deleteLabour(labour, deleteLabourCallback);
        }

        function deleteLabourCallback (err, labourtypeID) {

        	if(err){
        		MessageService.showToast(err)
        		return;
        	}

            for(var i = 0; i<labour.length; i++){
                var currentUser = labour[i];
                if(currentUser.id_labour_type == labourtypeID.id_labour_type){
                    labour.splice(i,1);
                }
            }
            filteredUsers = labour;
            resetTable();
            MessageService.showToast("refresh Success !");

        }

        function updateLabour(labour){
            LabourService.updateLabour(labour, updateLabourCallback);
        }

        function updateLabourCallback (err, labour) {

        	if(err){
        		MessageService.showToast(err)
        		return;
        	}
            MessageService.showToast("refresh Success !");

        }

        function goToPage(pageNumber){
            vm.labour = dataForEveryPage[pageNumber - 1];
            vm.pages = ToolsFactory.pageListBuilder(totalPage, pageNumber);
        }   

        function goToLastPage(){
            goToPage(totalPage)
        }   

        function dialogTest(labour){
            $mdDialog.show({
                controller         : 'DeletePromptDialogControllerLabour',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/settings/labour/dialogs/delete-prompt-dialog-labour.html',
                clickOutsideToClose: true,
                locals             : {
                    labour      : labour,
                    deleteLabour : deleteLabour
                }
            });
        }

        function dialogedit(labour){
            $mdDialog.show({
                controller         : 'EditPromptDialogControllerLabour',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/settings/labour/edit-labour/edit-labour.html',
                clickOutsideToClose: true,
                locals             : {
                    labour      : labour,
                    updateLabour : updateLabour
                }
            });
        }
    }
})();
(function ()
{
	'use strict';

	angular
		.module('app.settings.jobtypes', [])
		.config(config);

	/** @ngInject */
	function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider, jobtypesTempValueProvider)
	{	   
		var jobtypesTempValue = jobtypesTempValueProvider.$get();

		$stateProvider
			.state("app.settings.jobtypes",{
				url:"/jobtypes"
			})
			.state("app.settings.jobtypes.view-jobtypes",{
				url:"/view-jobtypes",
				views	: {
					'content@app': {
						templateUrl: 'app/main/settings/jobtypes/view-jobtypes/view-jobtypes.html',
						controller : 'ViewjobtypesController as vm'
					}
				},
				resolve :{
					jobtypes:function(apiResolver, LoginService){
						return apiResolver.resolve('jobtypes@getJob', {
							companyID: LoginService.getCompanyID(), 
						});
					},
					servicesCatogoryList:function($q, MessageService, jobtypesService, LoginService, $stateParams){
						const resourcePath = { 
							companyID: LoginService.getCompanyID(),
							customerportalsliderID: undefined
						};

						return jobtypesService.getAllServicesCatogory(resourcePath).$promise.catch(MessageService.showToast);
					},
				}
			})
			.state('app.settings.jobtypes.add-job', {
				url	  : '/add-job',
				views	: {
					'content@app': {
						templateUrl: 'app/main/settings/jobtypes/add-job/add-job.html',
						controller : 'AddjobController as vm'
					}
				},
				resolve :{
					servicesCatogoryList:function($q, MessageService, jobtypesService, LoginService, $stateParams){
						const resourcePath = { 
							companyID: LoginService.getCompanyID(),
							customerportalsliderID: undefined
						};

						return jobtypesService.getAllServicesCatogory(resourcePath).$promise.catch(MessageService.showToast);
					},
				}
			})
	 }


})();
(function ()
{
    'use strict';

    angular
        .module('app.settings.jobtypes')
        .controller('ViewjobtypesController', ViewjobtypesController);

    function ViewjobtypesController($scope, $state, ToolsFactory, $filter, jobtypes, LoginService, jobtypesService, $mdDialog, MessageService, $document, LabourService, PartTypesService, miscfeestypesService, servicesCatogoryList){   
        var vm = this;
        var dataForEveryPage;
        var totalPage;
        var loginUserInfo = LoginService.getUserInfo();
        const companyID = LoginService.getCompanyID();
        const userID = LoginService.getUserID();

        if(typeof(loginUserInfo) == "undefined"){
            return;
        }
        
        for(var i = 0; i < jobtypes.length; i++){
            jobtypes[i].canBeChanged = true;
            jobtypes[i].isOwner = true;
        }

        vm.labourtypelist = [];
        LabourService.getLabour({
                        companyID: companyID,
                        userID: userID
            }).then(function(result) {
                for(var i = 0; i < result.length; i++){
                vm.labourtypelist.push(result[i])
                }
        });

        vm.parttypelist = [];
        PartTypesService.getparttypes({
                        companyID: companyID,
                        userID: userID
            }).then(function(result) {
                for(var i = 0; i < result.length; i++){
                    // if(result[i].deleted != 1){
                        
                    // }
                    vm.parttypelist.push(result[i])
                }
               
        });

        vm.miscfeetypelist = [];
        miscfeestypesService.getMiscFeesTypes({
                        companyID: companyID,
                        userID: userID,
                        vehicleID: 0, 
                        workorderID: 0
            }).then(function(result) {
                for(var i = 0; i < result.length; i++){
                    vm.miscfeetypelist.push(result[i])
                } 
        });

        var filteredUsers = jobtypes;
        vm.totalUser = filteredUsers.length;
        vm.search = search;        
        vm.resetTable = resetTable;
        // vm.goToEditLabour = goToEditLabour;
        // vm.deleteLabour = deleteLabour;
        vm.goToPage = goToPage;
        vm.goToLastPage = goToLastPage;
        vm.options = [10, 25, 50, 100];
        vm.itemPerPage = vm.options[0];
        vm.dialogdelete = dialogdelete;
        vm.dialogedit = dialogedit;
        vm.dialogdetail = dialogdetail;
        vm.pageOptions;
        vm.jobtypes = jobtypes
        resetTable();

        function resetTable(){
            dataForEveryPage = ToolsFactory.dividDataByPage(filteredUsers, vm.itemPerPage);
            totalPage = dataForEveryPage.length;
            goToPage(1);
        }

        function search(){
            filteredUsers = $filter('filter')(jobtypes, vm.keyword);
            vm.totalUser = filteredUsers.length;
            resetTable();
        }

        // function goToEditmiscfeestypes(miscfeestypesID,companyID){
        //     var params = {
        //             miscfeestypesID:miscfeestypesID,
        //             companyID:companyID 
        //         };
        //     $state.go("app.settings.miscfeestypes.edit-miscfeestypes", params);  
        // }

        function deletejob(job){
            jobtypesService.deletejob(job, deletejobCallback);
        }

        function deletejobCallback (err, job) {

        	if(err){
        		MessageService.showToast(err)
        		return;
        	}

            for(var i = 0; i<jobtypes.length; i++){
                var currentUser = jobtypes[i];
                if(currentUser.id_job == job.id_job){
                    jobtypes.splice(i,1);
                }
            }
            filteredUsers = jobtypes;
            resetTable();
            MessageService.showToast("refresh Success !");

        }

        function updatejob(job){
            jobtypesService.updatejob(job, updatejobCallback);
        }

        function updatejobCallback (err, job) {

        	if(err){
        		MessageService.showToast(err)
        		return;
        	}
            MessageService.showToast("refresh Success !");

        }

        function goToPage(pageNumber){
            vm.jobtypes = dataForEveryPage[pageNumber - 1];
            vm.pages = ToolsFactory.pageListBuilder(totalPage, pageNumber);
        }   

        function goToLastPage(){
            goToPage(totalPage)
        }   

        function dialogdelete(job){
            $mdDialog.show({
                controller         : 'DeletePromptDialogControllerjob',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/settings/jobtypes/dialogs/delete-prompt-dialog-job.html',
                clickOutsideToClose: true,
                locals             : {
                    job      : job,
                    deletejob : deletejob
                }
            });
        }

        function dialogedit(job){
            $mdDialog.show({
                controller         : 'EditPromptDialogControllerjob',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/settings/jobtypes/edit-job/edit-job.html',
                clickOutsideToClose: true,
                locals             : {
                    job      : job,
                    part_type: vm.parttypelist,
                    labour_type: vm.labourtypelist,
                    miscfee_type: vm.miscfeetypelist,
                    servicesCatogoryList: servicesCatogoryList,
                    updatejob : updatejob,
                    refresh: refresh
                }
            });
        }

        
        function dialogdetail(job){
            $mdDialog.show({
                controller         : 'ViewDetailPromptDialogControllerjob',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/settings/jobtypes/view-detail-job/view-detail-job.html',
                clickOutsideToClose: true,
                locals             : {
                    job      : job,
                    part_type: vm.parttypelist,
                    labour_type: vm.labourtypelist,
                    miscfee_type: vm.miscfeetypelist,
                    updatejob : updatejob
                }
            });
        }

        function refresh () {
        vm.refreshing = true
        jobtypesService.getjobtypes({
            companyID: LoginService.getCompanyID()
        }).$promise.then(function (result) {
            vm.jobtypes = result
            for (var i = 0; i < vm.jobtypes.length; i++) {
            vm.jobtypes[i].canBeChanged = true
            vm.jobtypes[i].isOwner = true
            }
            vm.refreshing = false
        })
            .catch(MessageService.showToast)
        }
    }
})();
(function ()
{
    'use strict';

    angular.module('app.settings.labour')
        .controller('DeletePromptDialogControllerLabour', DeletePromptDialogControllerLabour);

    /** @ngInject */
    function DeletePromptDialogControllerLabour(labour, deleteLabour, $mdDialog,LabourService)
    {
        var vm = this;
        vm.labour = labour;
        vm.deleteLabour = deleteLabour
        vm.confirm = confirm;
        vm.isButtonActive = false;
        vm.enableButton = enableButton;
        vm.closeDialog = closeDialog;

        function confirm(){
            deleteLabour(labour);
            $mdDialog.hide();
        }

        function closeDialog (){
            $mdDialog.hide();
        }

        function enableButton(){
            if(vm.labour.labour_name == vm.confirmLabourname){
                vm.isButtonActive = true;
            }else{
                vm.isButtonActive = false;
            }
        }
    }
})();


(function ()
{
    'use strict';

    angular.module('app.settings.jobtypes')
        .controller('ViewDetailPromptDialogControllerjob', ViewDetailPromptDialogControllerjob);

    /** @ngInject */
    function ViewDetailPromptDialogControllerjob(job,part_type, labour_type, miscfee_type, updatejob, $mdDialog, $state, $scope)
    {
        var vm = this;
        vm.job = job;
        vm.updatejob = updatejob
        vm.confirm = confirm;

        vm.addnewlabour = addnewlabour;
        vm.addnewpart = addnewpart;
        vm.addnewmiscfee = addnewmiscfee;
        vm.removelabour = removelabour;
        vm.removepart = removepart;
        vm.removemiscfee = removemiscfee;

        vm.isButtonActive = true;
        vm.enableButton = enableButton;
        vm.closeDialog = closeDialog;

        vm.name = vm.job.name;

        $scope.labour = vm.job.job_labour;
        $scope.part = vm.job.job_part;
        $scope.miscfees = vm.job.job_miscfee;

        vm.containlabour = true;
        vm.containpart = true;
        vm.containmiscfees = true;

        vm.labourtypes = labour_type
        vm.parttypes = part_type
        vm.miscfeetypes = miscfee_type

        vm.newlabourselected = "";
        vm.newpartselected = "";
        vm.newmiscfeeselected = "";

        for(var labour in $scope.labour){
            if($scope.labour[labour] && $scope.labour[labour].fk_id_labourtype ){
                $scope.labour[labour].labour_quantity = +$scope.labour[labour].labour_quantity
                $scope.labour[labour].labour_coverage = +$scope.labour[labour].labour_coverage
            }else{
                vm.containlabour = false
                $scope.labour=[]
            }
        }

        for(var part in $scope.part){
            if($scope.part[part] && $scope.part[part].fk_id_parttype){
                $scope.part[part].part_quantity = +$scope.part[part].part_quantity
                $scope.part[part].part_coverage = +$scope.part[part].part_coverage
            }else{
                vm.containpart = false
                $scope.part=[]
            }
        }

        for(var miscfee in $scope.miscfees){
            if($scope.miscfees[miscfee] && $scope.miscfees[miscfee].fk_id_miscfeestype){
                $scope.miscfees[miscfee].miscfees_quantity = +$scope.miscfees[miscfee].miscfees_quantity
                $scope.miscfees[miscfee].miscfees_coverage = +$scope.miscfees[miscfee].miscfees_coverage
            }else{
                vm.containmiscfees = false
                $scope.miscfees=[]
            }
        }

        function confirm(){
            job.job_labour = $scope.labour;
            job.job_part = $scope.part;
            job.job_miscfee = $scope.miscfees;
            job.name = vm.name;
            updatejob(job);
            
            $mdDialog.hide();
        }

        function addnewlabour(){
            if(!vm.newlabourselected){
                return 
            }else{
                $scope.labour.push(
                    {
                        fk_id_labourtype: vm.newlabourselected.id_labour_type,
                        labour_name:vm.newlabourselected.labour_name,
                        labour_quantity:vm.newlabourselected.default_quantity
                    }
                )
                vm.containlabour = true

            }
        }
        function addnewpart(){
            if(!vm.newpartselected){
                return 
            }else{
                $scope.part.push(
                    {
                        part_name:vm.newpartselected.name,
                        part_quantity: 1,
                        fk_id_parttype: vm.newpartselected.id_part_type
                    }
                )
                vm.containpart = true

            }
        }

        function addnewmiscfee(){
            if(!vm.newmiscfeeselected){
                return 
            }else{
                $scope.miscfees.push(
                    {
                        fk_id_miscfeestype: vm.newmiscfeeselected.id_miscfee,
                        miscfees_name:vm.newmiscfeeselected.name,
                        miscfees_quantity: vm.newmiscfeeselected.default_quantity
                    }
                )
                vm.containmiscfees = true
            }

        }

        function removelabour(labour){
            if(!labour){
                return
            }else{
                for(var i = 0; i<$scope.labour.length; i++){
                    var currentLabour = $scope.labour[i];
                    if(currentLabour.fk_id_labourtype == labour.fk_id_labourtype && currentLabour.labour_name == labour.labour_name && currentLabour.labour_quantity == labour.labour_quantity){
                        $scope.labour.splice(i,1);
                        return
                    }
                }
            }
        }

        function removepart(part){
            if(!part){
                return
            }else{
                for(var i = 0; i<$scope.part.length; i++){
                    var currentPart = $scope.part[i];
                    if(currentPart.fk_id_parttype == part.fk_id_parttype && currentPart.part_name == part.part_name && currentPart.part_quantity == part.part_quantity){
                        $scope.part.splice(i,1);
                        return
                    }
                }
            }
        }

        function removemiscfee(miscfees){
            if(!miscfees){
                return
            }else{
                for(var i = 0; i<$scope.miscfees.length; i++){
                    var currentPart = $scope.miscfees[i];
                    if(currentPart.fk_id_miscfeestype == miscfees.fk_id_miscfeestype && currentPart.miscfees_name == miscfees.miscfees_name && currentPart.miscfees_quantity == miscfees.miscfees_quantity){
                        $scope.miscfees.splice(i,1);
                        return
                    }
                }
            }
        }

        function closeDialog (){
            $scope.labour = [];
            $scope.part = [];
            $scope.miscfees = [];
            $mdDialog.hide();
        }

        function enableButton(){
            if(vm.name.length  >= 1){
                vm.isButtonActive = true;
            }else{
                vm.isButtonActive = false;
            }
        }

    }
})();


(function ()
{
    'use strict';

    angular.module('app.settings.jobtypes')
        .controller('EditPromptDialogControllerjob', EditPromptDialogControllerjob);

    /** @ngInject */
    function EditPromptDialogControllerjob(job, part_type, labour_type, miscfee_type, updatejob, $mdDialog, $state, $scope, servicesCatogoryList, LoginService, FileUploadService, MessageService,refresh, jobtypesService, ImageCompresser, $sce)
    {
        var vm = this;

        var sizeFilter 	 = FileUploadService.getSizeFilter(20);
        var imageFilter  = FileUploadService.getImageFilter();
        var customFilter = FileUploadService.getCustomFilter(["pdf", "jpg", "jpeg", "png"]);

        vm.imageUploader = FileUploadService.getNewUploader();
        vm.imageUploader.filters.push(imageFilter);
        vm.imageUploader.filters.push(sizeFilter);

        vm.job = job;
        vm.updatejob = updatejob
        vm.confirm = confirm;

        vm.addnewlabour = addnewlabour;
        vm.addnewpart = addnewpart;
        vm.addnewmiscfee = addnewmiscfee;
        vm.removelabour = removelabour;
        vm.removepart = removepart;
        vm.removemiscfee = removemiscfee;

        vm.isButtonActive = true;
        vm.enableButton = enableButton;
        vm.closeDialog = closeDialog;

        vm.name = vm.job.name;

        $scope.labour = vm.job.job_labour;
        $scope.part = vm.job.job_part;
        $scope.miscfees = vm.job.job_miscfee;

        vm.containlabour = true;
        vm.containpart = true;
        vm.containmiscfees = true;

        vm.labourtypes = labour_type
        vm.parttypes = part_type
        vm.miscfeetypes = miscfee_type
        vm.servicesCatogoryList = servicesCatogoryList;

        vm.newlabourselected = "";
        vm.newpartselected = "";
        vm.newmiscfeeselected = "";
        vm.servicecatogoryselected="";
        for(var servicesCatogory in vm.servicesCatogoryList){
            if(vm.servicesCatogoryList[servicesCatogory].id_services_catogory == vm.job.fk_id_services_catogory){
                vm.servicecatogoryselected = vm.servicesCatogoryList[servicesCatogory]
            }
        }

        for(var labour in $scope.labour){
            if($scope.labour[labour] && $scope.labour[labour].fk_id_labourtype ){
                $scope.labour[labour].labour_quantity = +$scope.labour[labour].labour_quantity
            }else{
                vm.containlabour = false
                $scope.labour=[]
            }
        }

        for(var part in $scope.part){
            if($scope.part[part] && $scope.part[part].fk_id_parttype){
                $scope.part[part].part_quantity = +$scope.part[part].part_quantity
            }else{
                vm.containpart = false
                $scope.part=[]
            }
        }

        for(var miscfee in $scope.miscfees){
            if($scope.miscfees[miscfee] && $scope.miscfees[miscfee].fk_id_miscfeestype){
                $scope.miscfees[miscfee].miscfees_quantity = +$scope.miscfees[miscfee].miscfees_quantity
            }else{
                vm.containmiscfees = false
                $scope.miscfees=[]
            }
        }

        function confirm(){
            job.job_labour = $scope.labour;
            job.job_part = $scope.part;
            job.job_miscfee = $scope.miscfees;
            job.name = vm.name;
            job.fk_id_services_catogory = vm.servicecatogoryselected.id_services_catogory
            updatejob(job);
            $mdDialog.hide();
        }
        function addnewlabour(){
            if(!vm.newlabourselected){
                return 
            }else{
                $scope.labour.push(
                    {
                        fk_id_labourtype: vm.newlabourselected.id_labour_type,
                        labour_name:vm.newlabourselected.labour_name,
                        labour_quantity:vm.newlabourselected.default_quantity
                    }
                )
                vm.containlabour = true

            }
        }
        function addnewpart(){
            if(!vm.newpartselected){
                return 
            }else{
                $scope.part.push(
                    {
                        part_name:vm.newpartselected.name,
                        part_quantity: 1,
                        fk_id_parttype: vm.newpartselected.id_part_type
                    }
                )
                vm.containpart = true

            }
        }
        function addnewmiscfee(){
            if(!vm.newmiscfeeselected){
                return 
            }else{
                $scope.miscfees.push(
                    {
                        fk_id_miscfeestype: vm.newmiscfeeselected.id_miscfee,
                        miscfees_name:vm.newmiscfeeselected.name,
                        miscfees_quantity: vm.newmiscfeeselected.default_quantity
                    }
                )
                vm.containmiscfees = true
            }

        }
        function removelabour(labour){
            if(!labour){
                return
            }else{
                for(var i = 0; i<$scope.labour.length; i++){
                    var currentLabour = $scope.labour[i];
                    if(currentLabour.fk_id_labourtype == labour.fk_id_labourtype && currentLabour.labour_name == labour.labour_name && currentLabour.labour_quantity == labour.labour_quantity){
                        $scope.labour.splice(i,1);
                        return
                    }
                }
            }
        }
        function removepart(part){
            if(!part){
                return
            }else{
                for(var i = 0; i<$scope.part.length; i++){
                    var currentPart = $scope.part[i];
                    if(currentPart.fk_id_parttype == part.fk_id_parttype && currentPart.part_name == part.part_name && currentPart.part_quantity == part.part_quantity){
                        $scope.part.splice(i,1);
                        return
                    }
                }
            }
        }
        function removemiscfee(miscfees){
            if(!miscfees){
                return
            }else{
                for(var i = 0; i<$scope.miscfees.length; i++){
                    var currentPart = $scope.miscfees[i];
                    if(currentPart.fk_id_miscfeestype == miscfees.fk_id_miscfeestype && currentPart.miscfees_name == miscfees.miscfees_name && currentPart.miscfees_quantity == miscfees.miscfees_quantity){
                        $scope.miscfees.splice(i,1);
                        return
                    }
                }
            }
        }
        function closeDialog (){
            $scope.labour = [];
            $scope.part = [];
            $scope.miscfees = [];
            $mdDialog.hide();
        }
        function enableButton(){
            if(vm.name.length  >= 1){
                vm.isButtonActive = true;
            }else{
                vm.isButtonActive = false;
            }
        }


        vm.imageUploader.onAfterAddingFile = function(fileItem) {
            var imageCompresser = new ImageCompresser(); 

            var url = URL.createObjectURL(fileItem._file);
            fileItem.imageSrc = $sce.trustAsResourceUrl(url);

            imageCompresser.photo(fileItem._file, 1024, "file", false, function(file){
                fileItem._file 		= file;
                fileItem.file.size 	= file.size;
                fileItem.url 		= FileUploadService.getUrlForCreateJobTypeServicesCategoryImage(vm.job.id_job);		
                fileItem.upload();
            });
        }

        vm.imageUploader.onSuccessItem = function(item, response, status, headers){
            if(!FileUploadService.isUploadSuccess(headers)){
                MessageService.showToast(headers.message);
                return;
            }
            jobtypesService.getjobtypes({
                companyID: LoginService.getCompanyID(),
                jobTypesID: vm.job.id_job
            }).$promise.then(function(result){
                        item.remove();
                        vm.job = result[0]
                        refresh()

                    })
            .catch(MessageService.showToast);
        }
    }
})();

(function ()
{
    'use strict';

    angular.module('app.settings.jobtypes')
        .controller('DeletePromptDialogControllerjob', DeletePromptDialogControllerjob);

    /** @ngInject */
    function DeletePromptDialogControllerjob(job, deletejob, $mdDialog, miscfeestypesService)
    {
        var vm = this;
        vm.job = job;
        vm.deletejob = deletejob
        vm.confirm = confirm;
        vm.isButtonActive = false;
        vm.enableButton = enableButton;
        vm.closeDialog = closeDialog;

        function confirm(){
            deletejob(job);
            $mdDialog.hide();
        }

        function closeDialog (){
            $mdDialog.hide();
        }

        function enableButton(){
            if(vm.job.name == vm.confirmmiscfeesname){
                vm.isButtonActive = true;
            }else{
                vm.isButtonActive = false;
            }
        }
    }
})();

(function ()
{
	'use strict';

	angular
		.module('app.settings.customerportalslider', [])
		.config(config);

	/** @ngInject */
	function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider, customerPortalSliderTempValueProvider)
	{	   
		var customerPortalSliderTempValue = customerPortalSliderTempValueProvider.$get();

		$stateProvider
			.state("app.settings.customerportalslider",{
				url:"/customerportalslider"
			})
			.state("app.settings.customerportalslider.view-customerportalslider",{
				url:"/view-customerportalslider",
				views	: {
					'content@app': {
						templateUrl: 'app/main/settings/customer_portal_slider/view-customerportalslider/view-customerportalslider.html',
						controller : 'ViewCustomerPortalSliderController as vm'
					}
				},
				resolve :{
					customerPortalSliderList:function($q, MessageService, customerPortalSliderService, LoginService, $stateParams){
						const resourcePath = { 
							companyID: LoginService.getCompanyID(),
							customerportalsliderID: undefined
						};

						return customerPortalSliderService.getAllCustomerPortalSlider(resourcePath).$promise.catch(MessageService.showToast);
					},
				}
			})
			.state('app.settings.customerportalslider.add-customerportalslider', {
				url	  : '/add-customerportalslider',
				views	: {
					'content@app': {
						templateUrl: 'app/main/settings/customer_portal_slider/add-customerportalslider/add-customerportalslider.html',
						controller : 'AddCustomerPortalSliderController as vm'
					}
				}
			})
			.state('app.settings.customerportalslider.edit-customerportalslider', {
				url	  : '/edit-customerportalslider',
				views	: {
					'content@app': {
						templateUrl: 'app/main/settings/customer_portal_slider/edit-customerportalslider/edit-customerportalslider.html',
						controller : 'EditPromptDialogControllerCustomerPortalSlider as vm'
					}
				}
			})

			.state('app.settings.customerportalslider.detail-customerportalslider', {
				url	  : '/detail-customerportalslider',
				views	: {
					'content@app': {
						templateUrl: 'app/main/settings/customer_portal_slider/detail-customerportalslider/detail-customerportalslider.html',
						controller : 'DetailPromptDialogControllerCustomerPortalSlider as vm'
					}
				}
			});
	}


})();
(function ()
{
    'use strict';

    angular.module('app.settings.customerportalslider')
        .controller('DetailPromptDialogControllerCustomerPortalSlider', DetailPromptDialogControllerCustomerPortalSlider);

    /** @ngInject */
    function DetailPromptDialogControllerCustomerPortalSlider(sliderItem, $mdDialog, $state, deleteSlider)
    {
        var vm = this;
        vm.sliderItem = sliderItem
        // vm.parttype = parttype;
        // vm.updateparttype = updateparttype
        vm.confirm = confirm;
        // vm.isButtonActive = true;
        vm.enableButton = enableButton;
        vm.closeDialog = closeDialog;
        vm.confirmText = "CONFIRM"
        vm.confirmmiscfeesname;




        function confirm(){

            deleteSlider(sliderItem);
            $mdDialog.hide();
        }

        function closeDialog (){
            $mdDialog.hide();
        }

        function enableButton(){
            if(vm.confirmmiscfeesname == vm.confirmText){
                vm.isButtonActive = true;
            }else{
                vm.isButtonActive = false;
            }
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.settings.customerportalslider')
        .controller('ViewCustomerPortalSliderController', ViewCustomerPortalSliderController);

    function ViewCustomerPortalSliderController(customerPortalSliderList, LoginService, customerPortalSliderService, $mdDialog, MessageService){   
        var vm = this;
        vm.customerPortalSliderList = customerPortalSliderList

        vm.dialogDelete = dialogDelete;
        vm.dialogedit = dialogedit;
        vm.deleteSlider = deleteSlider;
        // var dataForEveryPage;
        // var totalPage;
        // var loginUserInfo = LoginService.getUserInfo();

        // var companyID = LoginService.getCompanyID();
        // vm.parttype = parttype
        // if(typeof(loginUserInfo) == "undefined"){
        //     return;
        // }


        // for(var i = 0; i < parttype.length; i++){
        //     parttype[i].canBeChanged = true;
        //     parttype[i].isOwner = true;

        //     if(loginUserInfo.userID == parttype[i].id_user){
        //         parttype[i].isOwner = true;
        //     }
        // }

        // var filteredUsers = parttype;

        // vm.totalUser = filteredUsers.length;
        // vm.search = search;        
        // vm.resetTable = resetTable;
        // vm.goToEditparttype = goToEditparttype;
        // vm.deleteparttype = deleteparttype;
        // vm.goToPage = goToPage;
        // vm.goToLastPage = goToLastPage;
        // vm.options = [10, 25, 50, 100];
        // vm.itemPerPage = vm.options[0];
        // // vm.dialogTest = dialogTest;
        // vm.dialogedit = dialogedit;
        // vm.pageOptions;
        
        // resetTable();

        // function resetTable(){
        //     dataForEveryPage = ToolsFactory.dividDataByPage(filteredUsers, vm.itemPerPage);
        //     totalPage = dataForEveryPage.length;
        //     goToPage(1);
        // }

        // function search(){
        //     filteredUsers = $filter('filter')(parttype, vm.keyword);
        //     vm.totalUser = filteredUsers.length;
        //     resetTable();
        // }

        // function goToEditparttype(id_part_type,companyID){
        //     var params = {
        //             id_part_type:id_part_type,
        //             companyID:companyID 
        //         };
        //     $state.go("app.settings.parttype.edit-parttype", params);  
        // }

        function deleteSliderImage(slider)
        {
            customerPortalSliderService.DeleteSlider({ 
                companyID: LoginService.getCompanyID(),
                customerportalsliderID: slider.id_customer_portal_slider_file,
            }, slider).then(function(result){
                refresh()
            })
        }

        function deleteSlider(slider)
        {
            customerPortalSliderService.DeleteSliderV2({ 
                companyID: LoginService.getCompanyID(),
                customerportalsliderIDV2: slider.id_customer_portal_slider_file,
            }, slider).then(function(result){
                refresh()
            })
        }

        
        function refresh(){
            vm.refreshing = true
            customerPortalSliderService.getGivenCustomerPortalSlider({
                companyID: LoginService.getCompanyID(),
            }).$promise
                    .then(function(result){
                        vm.customerPortalSliderList = result
                        vm.refreshing = false
                    })
            .catch(MessageService.showToast);
        
        }

        function updateSlider(slider){
            return customerPortalSliderService.updateSlider({ 
                companyID: LoginService.getCompanyID(),
                customerportalsliderID: slider.id_customer_portal_slider_file
            }, slider).then(function(result){
                refresh()
            })
        }

        function dialogedit(sliderItem){
            $mdDialog.show({
                controller         : 'EditPromptDialogControllerCustomerPortalSlider',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/settings/customer_portal_slider/edit-customerportalslider/edit-customerportalslider.html',
                clickOutsideToClose: true,
                locals             : {
                    sliderItem      : sliderItem,
                    updateSlider : updateSlider,
                    refresh: refresh,
                    deleteSliderImage: deleteSliderImage
                }
            });
        }

        function dialogDelete(sliderItem){
            $mdDialog.show({
                controller         : 'DetailPromptDialogControllerCustomerPortalSlider',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/settings/customer_portal_slider/detail-customerportalslider/detail-customerportalslider.html',
                clickOutsideToClose: true,
                locals             : {
                    sliderItem      : sliderItem,
                    deleteSlider: deleteSlider
                }
            });
        }
    }
})();
(function ()
{
	'use strict';

	angular
		.module('app.settings.jobtypes')
		.controller('AddjobController', AddjobController);

	function AddjobController($sce, $scope, $state, ToolsFactory, jobtypesService, LabourService, DialogService, servicesCatogoryList, PartTypesService, miscfeestypesService, LoginService, $timeout, MessageService, Const, FileUploader, FileUploadService, ProgressService){   
		var vm = this;
        vm.isButtonActive = true;
		vm.name = "";
		vm.miscfeestypes = {};
		vm.addjob = addjob;
		vm.roles = [];
		vm.checkmiscfeestypesdescription = checkmiscfeestypesdescription;
		vm.servicesCatogoryList = servicesCatogoryList;
		vm.checkEmail = checkEmail;
		vm.enableButton = enableButton;
		vm.disableAddButton = false;		
		vm.processStatus = {};
		vm.servicecatogoryselected;
		vm.for_customer_portal;
		vm.hours;

		var loginUserSubRoles = LoginService.getUserSubRoles();
		var companyID = LoginService.getCompanyID();
		const userID = LoginService.getUserID();


		vm.uploader = FileUploadService.getNewUploader();

		var imageFilter = FileUploadService.getImageFilter();
		var sizeFilter 	= FileUploadService.getSizeFilter(5);

		vm.uploader.filters.push(imageFilter);
		vm.uploader.filters.push(sizeFilter);		

		$scope.labour = [];
        $scope.part = [];
        $scope.miscfees = [];

        vm.addnewlabour = addnewlabour;
        vm.addnewpart = addnewpart;
        vm.addnewmiscfee = addnewmiscfee;
        vm.removelabour = removelabour;
        vm.removepart = removepart;
        vm.removemiscfee = removemiscfee;

		init ();

        vm.newlabourselected = "";
        vm.newpartselected = "";
        vm.newmiscfeeselected = "";

		vm.labourtypelist = [];
        LabourService.getLabour({
                        companyID: companyID,
                        userID: userID
            }).then(function(result) {
                for(var i = 0; i < result.length; i++){
                vm.labourtypelist.push(result[i])
                }
        });

        vm.parttypelist = [];
        PartTypesService.getparttypes({
                        companyID: companyID,
                        userID: userID
            }).then(function(result) {
                for(var i = 0; i < result.length; i++){
                    // if(result[i].deleted != 1){
                        
                    // }
                    vm.parttypelist.push(result[i])
                }
               
        });

        vm.miscfeetypelist = [];
        miscfeestypesService.getMiscFeesTypes({
                        companyID: companyID,
                        userID: userID,
                        vehicleID: 0, 
                        workorderID: 0
            }).then(function(result) {
                for(var i = 0; i < result.length; i++){
                    vm.miscfeetypelist.push(result[i])
                } 
        });

		function init(){
			loginUserSubRoles.forEach(function(currentRole){
				var roleObj={};

				roleObj.description = Const.roleDescription[currentRole];
				roleObj.roleTitle = currentRole;
				roleObj.isCheck = false;
		
				vm.roles.push(roleObj);	 
			})
		}

		function checkmiscfeestypesdescription(username){
			
			if(username != null){
				vm.isCheckingUsername = true;
				
			}	
		}
		function checkEmail(email){
			if($scope.addUser.email.$invalid){
				return;
			}		   
			
			if(email != null){
				vm.isCheckingEmail = true;
				UserService.checkAvailability("email", email, checkEmailCallback);
			}
		}

		function checkEmailCallback(result){
			vm.isCheckingEmail = false;
			vm.isEmailAvailable = result;
		} 

		function addjob(){
			if($scope.addmiscfeestypes.$invalid){
				MessageService.showToast("Please make sure all input is valid");
				return;
			}

			for(var i = 0; i < $scope.labour.length; i++){
				if(!$scope.labour[i].labour_quantity){
					MessageService.showToast("Please make sure all input under labour is valid");
					return;
				}
			}

			for(var i = 0; i < $scope.part.length; i++){
				if(!$scope.part[i].part_quantity){
					MessageService.showToast("Please make sure all input under part is valid");
					return;
				}
			}

			for(var i = 0; i < $scope.miscfees.length; i++){
				if(!$scope.miscfees[i].miscfees_quantity){
					MessageService.showToast("Please make sure all input under misc fee is valid");
					return;
				}
			}
			var fk_id_services_catogory;
			if(vm.servicecatogoryselected){
				fk_id_services_catogory = vm.servicecatogoryselected.id_services_catogory
			}else{
				fk_id_services_catogory = undefined
			}
			
			var dialogOptions = {};

			var warningString;

			if ($scope.part.length === 0 && $scope.labour.length === 0 && $scope.miscfees.length === 0) {
				warningString = "There are no parts, labour, and misc fees added for this job. Would you like to proceed?";
			  } else if ($scope.part.length === 0 && $scope.labour.length === 0) {
				warningString = "There are no parts and labour added for this job. Would you like to proceed?";
			  } else if ($scope.part.length === 0 && $scope.miscfees.length === 0) {
				warningString = "There are no parts and misc fees added for this job. Would you like to proceed?";
			  } else if ($scope.labour.length === 0 && $scope.miscfees.length === 0) {
				warningString = "There is no labour and misc fees added for this job. Would you like to proceed?";
			  } else if ($scope.part.length === 0) {
				warningString = "There are no parts added for this job. Would you like to proceed?";
			  } else if ($scope.labour.length === 0) {
				warningString = "There is no labour added for this job. Would you like to proceed?";
			  } else if ($scope.miscfees.length === 0) {
				warningString = "There are no misc fees added for this job. Would you like to proceed?";
			  }else{
				warningString = ""
			  }

			dialogOptions.titleString = "Add Job";
			dialogOptions.contentString = warningString;

			var confirmOption = {};

			confirmOption.optionName = "YES";
			confirmOption.onClick = function(){
				
			var newjob = {
				name:vm.name,
				fk_id_company: companyID,
				job_labour: $scope.labour,
				job_part: $scope.part,
				job_miscfee:$scope.miscfees,
				for_customer_portal: vm.for_customer_portal || false,
				fk_id_services_catogory: fk_id_services_catogory,
				hours: vm.hours || 0
			}

			vm.disableAddButton = true;
			ProgressService.isVisble(true);
			jobtypesService.addjob(companyID, newjob, addjobCallback);
			DialogService.close();
			}
			var cancelOption = {};

			cancelOption.optionName = "NO";
			cancelOption.onClick = function(){
				DialogService.close();
			}

			dialogOptions.options = [confirmOption, cancelOption];

			if(warningString.length > 0){
				DialogService.showOptionsDialog(dialogOptions);
			}else{
				var newjob = {
					name:vm.name,
					fk_id_company: companyID,
					job_labour: $scope.labour,
					job_part: $scope.part,
					job_miscfee:$scope.miscfees,
					for_customer_portal: vm.for_customer_portal || false,
					fk_id_services_catogory: fk_id_services_catogory,
					hours: vm.hours || 0
				}
	
				vm.disableAddButton = true;
				ProgressService.isVisble(true);
				jobtypesService.addjob(companyID, newjob, addjobCallback);
			}
		}

		function addjobCallback (error, newUserID){	 
			if(error){
				ProgressService.isVisble(false);
				MessageService.showToast(error);
				vm.disableAddButton = false;
				return
			}

			if(vm.uploader.queue == 0){
				ProgressService.isVisble(false);
				MessageService.showToast("Success !")		   
				$state.go("app.settings.jobtypes.view-jobtypes");	 
				return;	   	
			}
			ProgressService.setMode("indeterminate");
			ProgressService.isVisble(true);

			
			vm.uploader.uploadAll();
		}

		vm.uploader.onAfterAddingFile = function(fileItem) {
			vm.uploader.queue = [];
			
			var url = URL.createObjectURL(fileItem._file);
			fileItem.imageSrc = $sce.trustAsResourceUrl(url);

			vm.uploader.queue.push(fileItem);	
		}

		vm.uploader.onErrorItem = function(fileItem, response, status, headers) {
			ProgressService.isVisble(false);
			vm.disableAddButton = false; 

			MessageService.showToast(status + ": Fail to upload file.")
		};

		vm.uploader.onCompleteItem = function(fileItem, response, status, headers) {
			if(!FileUploadService.isUploadSuccess(headers)){
				MessageService.showToast(headers.message);
				return;
			}
			
			ProgressService.isVisble(false);
			vm.disableAddButton = false; 

			if(headers.code == Const.code.success){
				vm.user.profileimage = {};
				vm.user.profileimage.url = response.url;
				vm.user.profileimage.id_profile_image = response.id_profile_image;

				MessageService.showToast("Success !")	 
				$state.go("app.settings.users.view-user"); 
				return
			}

			MessageService.showToast("Success create user, but fail to upload image")
			$state.go("app.settings.users.view-user"); 
			return;   		   				
		};

		function enableButton(){
            if(vm.name.length  >= 1){
                vm.isButtonActive = true;
            }else{
                vm.isButtonActive = false;
            }
        }

		function addnewpart(){
            if(!vm.newpartselected){
                return 
            }else{
                $scope.part.push(
                    {
                        part_name:vm.newpartselected.name,
                        part_quantity: 1,
                        fk_id_parttype: vm.newpartselected.id_part_type
                    }
                )
                vm.containpart = true

            }
        }

        function addnewlabour(){
            if(!vm.newlabourselected){
                return 
            }else{
                $scope.labour.push(
                    {
                        fk_id_labourtype: vm.newlabourselected.id_labour_type,
                        labour_name:vm.newlabourselected.labour_name,
                        labour_quantity:vm.newlabourselected.default_quantity
                    }
                )
                vm.containlabour = true

            }
        }

		function addnewmiscfee(){
            if(!vm.newmiscfeeselected){
                return 
            }else{
                $scope.miscfees.push(
                    {
                        fk_id_miscfeestype: vm.newmiscfeeselected.id_miscfee,
                        miscfees_name:vm.newmiscfeeselected.name,
                        miscfees_quantity: vm.newmiscfeeselected.default_quantity
                    }
                )
                vm.containmiscfees = true
            }

        }

		function removelabour(labour){
            if(!labour){
                return
            }else{
                for(var i = 0; i<$scope.labour.length; i++){
                    var currentLabour = $scope.labour[i];
                    if(currentLabour.fk_id_labourtype == labour.fk_id_labourtype && currentLabour.labour_name == labour.labour_name && currentLabour.labour_quantity == labour.labour_quantity){
                        $scope.labour.splice(i,1);
                        return
                    }
                }
            }
        }

		function removepart(part){
            if(!part){
                return
            }else{
                for(var i = 0; i<$scope.part.length; i++){
                    var currentPart = $scope.part[i];
                    if(currentPart.fk_id_parttype == part.fk_id_parttype && currentPart.part_name == part.part_name && currentPart.part_quantity == part.part_quantity){
                        $scope.part.splice(i,1);
                        return
                    }
                }
            }
        }

        function removemiscfee(miscfees){
            if(!miscfees){
                return
            }else{
                for(var i = 0; i<$scope.miscfees.length; i++){
                    var currentPart = $scope.miscfees[i];
                    if(currentPart.fk_id_miscfeestype == miscfees.fk_id_miscfeestype && currentPart.miscfees_name == miscfees.miscfees_name && currentPart.miscfees_quantity == miscfees.miscfees_quantity){
                        $scope.miscfees.splice(i,1);
                        return
                    }
                }
            }
        }
	}
})();
(function ()
{
    'use strict';

    angular.module('app.settings.customerportalslider')
        .controller('EditPromptDialogControllerCustomerPortalSlider', EditPromptDialogControllerCustomerPortalSlider);

    /** @ngInject */
    function EditPromptDialogControllerCustomerPortalSlider(sliderItem, FileUploadService, updateSlider, $mdDialog, customerPortalSliderService, LoginService, ImageCompresser, $sce, MessageService, refresh, deleteSliderImage)
    {
        var vm = this;
        vm.sliderItem = sliderItem;
        vm.editContent = editContent;
        vm.finisheditContent = finisheditContent;
        vm.editingList = {};
        vm.confirm = confirm;
        vm.closeDialog = closeDialog;
        vm.confirmDeleting = confirmDeleting;

        var sizeFilter 	 = FileUploadService.getSizeFilter(20);
        var imageFilter  = FileUploadService.getImageFilter();
        var customFilter = FileUploadService.getCustomFilter(["pdf", "jpg", "jpeg", "png"]);

        vm.imageUploader = FileUploadService.getNewUploader();
        vm.imageUploader.filters.push(imageFilter);
        vm.imageUploader.filters.push(sizeFilter);

        function confirm(){
            updateSlider(sliderItem);
            $mdDialog.hide();
        }

        function confirmDeleting(){
            deleteSliderImage(sliderItem);
            $mdDialog.hide();
        }

        function closeDialog (){
            $mdDialog.hide();
        }

        function editContent(item){
            vm.editingList[item] = true
        }

        function finisheditContent(item){
            vm.editingList[item] = false
        }

        vm.imageUploader.onAfterAddingFile = function(fileItem) {
            var imageCompresser = new ImageCompresser(); 

            var url = URL.createObjectURL(fileItem._file);
            fileItem.imageSrc = $sce.trustAsResourceUrl(url);

            imageCompresser.photo(fileItem._file, 1024, "file", false, function(file){
                fileItem._file 		= file;
                fileItem.file.size 	= file.size;
                fileItem.url 		= FileUploadService.getUrlForCreateCustomerPortalSliderImage(vm.sliderItem.id_customer_portal_slider_file);		
                fileItem.upload();
            });
        }

        vm.imageUploader.onSuccessItem = function(item, response, status, headers){
            if(!FileUploadService.isUploadSuccess(headers)){
                MessageService.showToast(headers.message);
                return;
            }

            customerPortalSliderService.getGivenCustomerPortalSlider({
                companyID: LoginService.getCompanyID(),
                customerportalsliderID: sliderItem.id_customer_portal_slider_file
            }).$promise
                    .then(function(result){
                        item.remove();
                        vm.sliderItem = result[0]
                        refresh()

                    })
            .catch(MessageService.showToast);
        }
    }
})();

(function ()
{
	'use strict';

	angular
		.module('app.settings.customerportalslider')
		.controller('AddCustomerPortalSliderController', AddCustomerPortalSliderController);

	function AddCustomerPortalSliderController(customerPortalSliderService, ProgressService, LoginService, MessageService, $state){   
		
		var vm = this;
		vm.addSlider = addSlider

		vm.slider = {
			description: null,
			title: null,
			button_text: null,
			// button_link: null,
			// slider_link: null,
			link:null,
			fk_id_file: null,
			for_mobile: false,
			for_desktop: false,
			is_enable: false,
		}
		// vm.parttype = {};
		// vm.addPartType = addPartType;
		// vm.roles = [];
		// vm.checkPartTypedescription = checkPartTypedescription;

		// vm.checkEmail = checkEmail;
		vm.disableAddButton = false;		
		// vm.processStatus = {};

		// var loginUserSubRoles = LoginService.getUserSubRoles();
		var companyID = LoginService.getCompanyID();

		// vm.uploader = FileUploadService.getNewUploader();

		// var imageFilter = FileUploadService.getImageFilter();
		// var sizeFilter 	= FileUploadService.getSizeFilter(5);

		// vm.uploader.filters.push(imageFilter);
		// vm.uploader.filters.push(sizeFilter);		

		// init ();

		// function init (){
		// 	loginUserSubRoles.forEach(function(currentRole){
		// 		var roleObj={};

		// 		roleObj.description = Const.roleDescription[currentRole];
		// 		roleObj.roleTitle = currentRole;
		// 		roleObj.isCheck = false;
		
		// 		vm.roles.push(roleObj);	 
		// 	})
		// }

		// function checkPartTypedescription(name){
			
		// 	if(name != null){
		// 		vm.isCheckingUsername = true;
				
		// 	}	
		// }


		// function checkEmail(email){
		// 	if($scope.addUser.email.$invalid){
		// 		return;
		// 	}		   
			
		// 	if(email != null){
		// 		vm.isCheckingEmail = true;
		// 		UserService.checkAvailability("email", email, checkEmailCallback);
		// 	}
		// }

		// function checkEmailCallback(result){
		// 	vm.isCheckingEmail = false;
		// 	vm.isEmailAvailable = result;
		// } 

		// function addPartTypeCallback (error, newUserID){	 
		// 	if(error){
		// 		ProgressService.isVisble(false);
		// 		MessageService.showToast(error);
		// 		vm.disableAddButton = false;
		// 		return
		// 	}

		// 	if(vm.uploader.queue == 0){
		// 		ProgressService.isVisble(false);
		// 		MessageService.showToast("Success !")		   
		// 		$state.go("app.settings.parttype.view-parttypes");	 
		// 		return;	   	
		// 	}
		// 	vm.uploader.onBeforeUploadItem = function(item) {
		// 		item.removeAfterUpload = true;
		// 		item.url = FileUploadService.getUrlForCreateProfileImage(newUserID);	
		// 	}

		// 	ProgressService.setMode("indeterminate");
		// 	ProgressService.isVisble(true);

		// 	vm.uploader.uploadAll();
		// }

		// vm.uploader.onAfterAddingFile = function(fileItem) {
		// 	vm.uploader.queue = [];
			
		// 	var url = URL.createObjectURL(fileItem._file);
		// 	fileItem.imageSrc = $sce.trustAsResourceUrl(url);

		// 	vm.uploader.queue.push(fileItem);	
		// }

		// vm.uploader.onErrorItem = function(fileItem, response, status, headers) {
		// 	ProgressService.isVisble(false);
		// 	vm.disableAddButton = false; 

		// 	MessageService.showToast(status + ": Fail to upload file.")
		// };

		// vm.uploader.onCompleteItem = function(fileItem, response, status, headers) {
		// 	if(!FileUploadService.isUploadSuccess(headers)){
		// 		MessageService.showToast(headers.message);
		// 		return;
		// 	}
			
		// 	ProgressService.isVisble(false);
		// 	vm.disableAddButton = false; 

		// 	if(headers.code == Const.code.success){
		// 		vm.user.profileimage = {};
		// 		vm.user.profileimage.url = response.url;
		// 		vm.user.profileimage.id_profile_image = response.id_profile_image;

		// 		MessageService.showToast("Success !")	 
		// 		$state.go("app.settings.users.view-user"); 
		// 		return
		// 	}

		// 	MessageService.showToast("Success create user, but fail to upload image")
		// 	$state.go("app.settings.users.view-user"); 
		// 	return;   		   				
		// };


		function addSlider(){
			vm.disableAddButton = true;
			ProgressService.isVisble(true);
			customerPortalSliderService.createSlider({companyID: LoginService.getCompanyID(), customerportalsliderIDV2: 0}, vm.slider).then(function(result){
				if(!result){
					ProgressService.isVisble(false);
					MessageService.showToast(error);
					vm.disableAddButton = false;
					return
				}

				ProgressService.setMode("indeterminate");
				ProgressService.isVisble(false);
				MessageService.showToast("Success !")	 
				$state.go("app.settings.customerportalslider.view-customerportalslider"); 
			});
		}
	}
})();
(function ()
{
	'use strict';

	angular
		.module('app.settings.customerportalservicescatogory', [])
		.config(config);

	/** @ngInject */
	function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider, customerportalservicescatogoryTempValueProvider)
	{	   
		var customerportalservicescatogoryTempValueService = customerportalservicescatogoryTempValueProvider.$get();
		
		$stateProvider
			.state("app.settings.customerportalservicescatogory",{
				url:"/customerportalservicescatogory"
			})
			.state("app.settings.customerportalservicescatogory.view-customerportalservicescatogory",{
				url:"/view-customerportalservicescatogory",
				views	: {
					'content@app': {
						templateUrl: 'app/main/settings/customer-portal-services-catogory/view-customerportalservicescatogory/view-customerportalservicescatogory.html',
						controller : 'ViewCustomerPortalServicesCatogory as vm'
					}
				},
				resolve :{
					customerPortalAppointmentServicesCatogory:function($q, MessageService, customerportalservicescatogoryService, LoginService, $stateParams){
						const resourcePath = { 
							companyID: LoginService.getCompanyID(),
							customerportalsliderID: undefined
						};

						return customerportalservicescatogoryService.getAllCustomerPortalAppointmentServicesCatogory(resourcePath).$promise.catch(MessageService.showToast);
					},
				}
			})

			.state('app.settings.customerportalservicescatogory.add-customerportalservicescatogory', {
				url	  : '/add-customerportalservicescatogory',
				views	: {
					'content@app': {
						templateUrl: 'app/main/settings/customer-portal-services-catogory/add-customerportalservicescatogory/add-customerportalservicescatogory.html',
						controller : 'AddCustomerPortalServicesCatogory as vm'
					}
				}
			})
			// .state('app.settings.customerportalservicescatogory.edit-customerportalservicescatogory', {
			// 	url	  : '/edit-customerportalservicescatogory',
			// 	views	: {
			// 		'content@app': {
			// 			templateUrl: 'app/main/settings/customer-portal-services-catogory/edit-customerportalservicescatogory/edit-customerportalservicescatogory.html',
			// 			controller : 'EditCustomerPortalServicesCatogory as vm'
			// 		}
			// 	}
			// })
	}


})();


(function ()
{
    'use strict';

    angular
        .module('app.settings.customerportalservicescatogory')
        .controller('ViewCustomerPortalServicesCatogory', ViewCustomerPortalServicesCatogory);

    function ViewCustomerPortalServicesCatogory(customerPortalAppointmentServicesCatogory, LoginService, customerportalservicescatogoryService, $mdDialog, MessageService, ToolsFactory){   
        var vm = this;
        vm.customerPortalAppointmentServicesCatogory = customerPortalAppointmentServicesCatogory
        vm.dialogDelete = dialogDelete;
        vm.dialogedit = dialogedit;
        var dataForEveryPage;
        var totalPage;
        var loginUserInfo = LoginService.getUserInfo();

        var companyID = LoginService.getCompanyID();


        var filteredUsers = customerPortalAppointmentServicesCatogory;

        vm.totalUser = filteredUsers.length;
        vm.search = search;        
        vm.resetTable = resetTable;
        vm.goToEditparttype = goToEditparttype;
        vm.goToPage = goToPage;
        vm.goToLastPage = goToLastPage;
        vm.options = [10, 25, 50, 100];
        vm.itemPerPage = vm.options[0];
        vm.dialogedit = dialogedit;
        vm.pageOptions;
        
        resetTable();

        function resetTable(){
            dataForEveryPage = ToolsFactory.dividDataByPage(filteredUsers, vm.itemPerPage);
            totalPage = dataForEveryPage.length;
            goToPage(1);
        }

        function search(){
            filteredUsers = $filter('filter')(parttype, vm.keyword);
            vm.totalUser = filteredUsers.length;
            resetTable();
        }

        function goToEditparttype(id_part_type,companyID){
            var params = {
                    id_part_type:id_part_type,
                    companyID:companyID 
                };
            $state.go("app.settings.parttype.edit-parttype", params);  
        }

        function goToPage(pageNumber){
            vm.parttype = dataForEveryPage[pageNumber - 1];
            vm.pages = ToolsFactory.pageListBuilder(totalPage, pageNumber);
        } 

        function goToLastPage(){
            goToPage(totalPage)
        }   
        
        function refresh(){
            vm.refreshing = true
            customerportalservicescatogoryService.getAllCustomerPortalAppointmentServicesCatogory({
                companyID: LoginService.getCompanyID(),
            }).$promise
                    .then(function(result){
                        vm.customerPortalAppointmentServicesCatogory = result
                        vm.refreshing = false
                    })
            .catch(MessageService.showToast);
        
        }

        function deleteServicesCatogory(item)
        {
            customerportalservicescatogoryService.deleteCustomerPortalAppointmentServicesCatogory({ 
                companyID: LoginService.getCompanyID(),
                customerportalappointmentservicescatogoryID: item.id_services_catogory,
            }).then(function(result){
                refresh()
            })
        }

        function updateServicesCatogory(item){
            return customerportalservicescatogoryService.updateCustomerPortalAppointmentServicesCatogory({ 
                companyID: LoginService.getCompanyID(),
                customerportalappointmentservicescatogoryID: item.id_services_catogory
            }, item).then(function(result){
                refresh()
            })
        }



        function dialogedit(item){
            $mdDialog.show({
                controller         : 'EditPromptDialogControllerCustomerPortalAppointmentServicesCatogory',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/settings/customer-portal-services-catogory/edit-customerportalservicescatogory/edit-customerportalservicescatogory.html',
                clickOutsideToClose: true,
                locals             : {
                    customerPortalAppointmentServicesCatogory      : item,
                    updateServicesCatogory : updateServicesCatogory,
                    refresh: refresh
                }
            });
        }

        function dialogDelete(item){
            $mdDialog.show({
                controller         : 'DeletePromptDialogControllerCustomerPortalAppointmentServicesCatogory',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/settings/customer-portal-services-catogory/delete-customerportalservicescatogory/delete-prompt-dialog-customerportalservicescatogory.html',
                clickOutsideToClose: true,
                locals             : {
                    customerPortalAppointmentServicesCatogory      : item,
                    deleteServicesCatogory: deleteServicesCatogory
                }
            });
        }
    }
})();
(function ()
{
    'use strict';

    angular.module('app.settings.customerportalservicescatogory')
        .controller('EditPromptDialogControllerCustomerPortalAppointmentServicesCatogory', EditPromptDialogControllerCustomerPortalAppointmentServicesCatogory);

    /** @ngInject */ 
    function EditPromptDialogControllerCustomerPortalAppointmentServicesCatogory(customerPortalAppointmentServicesCatogory, FileUploadService, updateServicesCatogory, $mdDialog, customerPortalSliderService, LoginService, ImageCompresser, $sce, MessageService, refresh)
    {
        var vm = this;
        vm.customerPortalAppointmentServicesCatogory = customerPortalAppointmentServicesCatogory;
        vm.editContent = editContent;
        vm.finisheditContent = finisheditContent;
        vm.editingList = {};
        vm.confirm = confirm;
        vm.closeDialog = closeDialog;
        vm.confirmDeleting = confirmDeleting;

        var sizeFilter 	 = FileUploadService.getSizeFilter(20);
        var imageFilter  = FileUploadService.getImageFilter();
        var customFilter = FileUploadService.getCustomFilter(["pdf", "jpg", "jpeg", "png"]);

        vm.imageUploader = FileUploadService.getNewUploader();
        vm.imageUploader.filters.push(imageFilter);
        vm.imageUploader.filters.push(sizeFilter);

        function confirm(){
            updateServicesCatogory(customerPortalAppointmentServicesCatogory);
            $mdDialog.hide();
        }

        function confirmDeleting(){
            $mdDialog.hide();
        }

        function closeDialog (){
            $mdDialog.hide();
        }

        function editContent(item){
            vm.editingList[item] = true
        }

        function finisheditContent(item){
            vm.editingList[item] = false
        }

        vm.imageUploader.onAfterAddingFile = function(fileItem) {
            var imageCompresser = new ImageCompresser(); 

            var url = URL.createObjectURL(fileItem._file);
            fileItem.imageSrc = $sce.trustAsResourceUrl(url);

            imageCompresser.photo(fileItem._file, 1024, "file", false, function(file){
                fileItem._file 		= file;
                fileItem.file.size 	= file.size;
                fileItem.url 		= FileUploadService.getUrlForCreateCustomerPortalSliderImage(vm.sliderItem.id_customer_portal_slider_file);		
                fileItem.upload();
            });
        }

        vm.imageUploader.onSuccessItem = function(item, response, status, headers){
            if(!FileUploadService.isUploadSuccess(headers)){
                MessageService.showToast(headers.message);
                return;
            }

            customerPortalSliderService.getGivenCustomerPortalSlider({
                companyID: LoginService.getCompanyID(),
                customerportalsliderID: sliderItem.id_customer_portal_slider_file
            }).$promise
                    .then(function(result){
                        item.remove();
                        vm.sliderItem = result[0]
                        refresh()

                    })
            .catch(MessageService.showToast);
        }
    }
})();

(function ()
{
    'use strict';

    angular.module('app.settings.customerportalservicescatogory')
        .controller('DeletePromptDialogControllerCustomerPortalAppointmentServicesCatogory', DeletePromptDialogControllerCustomerPortalAppointmentServicesCatogory);

    /** @ngInject */
    function DeletePromptDialogControllerCustomerPortalAppointmentServicesCatogory(customerPortalAppointmentServicesCatogory, deleteServicesCatogory, $mdDialog,LabourService)
    {
        var vm = this;
        vm.customerPortalAppointmentServicesCatogory = customerPortalAppointmentServicesCatogory;
        vm.deleteServicesCatogory = deleteServicesCatogory
        vm.confirm = confirm;
        vm.isButtonActive = false;
        vm.enableButton = enableButton;
        vm.closeDialog = closeDialog;

        function confirm(){
            deleteServicesCatogory(customerPortalAppointmentServicesCatogory);
            $mdDialog.hide();
        }

        function closeDialog (){
            $mdDialog.hide();
        }

        function enableButton(){
            if(vm.customerPortalAppointmentServicesCatogory.name == vm.confirmLabourname){
                vm.isButtonActive = true;
            }else{
                vm.isButtonActive = false;
            }
        }
    }
})();

(function ()
{
	'use strict';

	angular
		.module('app.settings.customerportalservicescatogory')
		.controller('AddCustomerPortalServicesCatogory', AddCustomerPortalServicesCatogory);

	function AddCustomerPortalServicesCatogory(customerportalservicescatogoryService, ProgressService, LoginService, MessageService, $state){   
		
		var vm = this;
		vm.addSlider = addSlider

		vm.customerPortalServicesCatogory = {
			name: null,
		}
		// vm.parttype = {};
		// vm.addPartType = addPartType;
		// vm.roles = [];
		// vm.checkPartTypedescription = checkPartTypedescription;

		// vm.checkEmail = checkEmail;
		vm.disableAddButton = false;		
		// vm.processStatus = {};

		// var loginUserSubRoles = LoginService.getUserSubRoles();
		var companyID = LoginService.getCompanyID();

		// vm.uploader = FileUploadService.getNewUploader();

		// var imageFilter = FileUploadService.getImageFilter();
		// var sizeFilter 	= FileUploadService.getSizeFilter(5);

		// vm.uploader.filters.push(imageFilter);
		// vm.uploader.filters.push(sizeFilter);		

		// init ();

		// function init (){
		// 	loginUserSubRoles.forEach(function(currentRole){
		// 		var roleObj={};

		// 		roleObj.description = Const.roleDescription[currentRole];
		// 		roleObj.roleTitle = currentRole;
		// 		roleObj.isCheck = false;
		
		// 		vm.roles.push(roleObj);	 
		// 	})
		// }

		// function checkPartTypedescription(name){
			
		// 	if(name != null){
		// 		vm.isCheckingUsername = true;
				
		// 	}	
		// }


		// function checkEmail(email){
		// 	if($scope.addUser.email.$invalid){
		// 		return;
		// 	}		   
			
		// 	if(email != null){
		// 		vm.isCheckingEmail = true;
		// 		UserService.checkAvailability("email", email, checkEmailCallback);
		// 	}
		// }

		// function checkEmailCallback(result){
		// 	vm.isCheckingEmail = false;
		// 	vm.isEmailAvailable = result;
		// } 

		// function addPartTypeCallback (error, newUserID){	 
		// 	if(error){
		// 		ProgressService.isVisble(false);
		// 		MessageService.showToast(error);
		// 		vm.disableAddButton = false;
		// 		return
		// 	}

		// 	if(vm.uploader.queue == 0){
		// 		ProgressService.isVisble(false);
		// 		MessageService.showToast("Success !")		   
		// 		$state.go("app.settings.parttype.view-parttypes");	 
		// 		return;	   	
		// 	}
		// 	vm.uploader.onBeforeUploadItem = function(item) {
		// 		item.removeAfterUpload = true;
		// 		item.url = FileUploadService.getUrlForCreateProfileImage(newUserID);	
		// 	}

		// 	ProgressService.setMode("indeterminate");
		// 	ProgressService.isVisble(true);

		// 	vm.uploader.uploadAll();
		// }

		// vm.uploader.onAfterAddingFile = function(fileItem) {
		// 	vm.uploader.queue = [];
			
		// 	var url = URL.createObjectURL(fileItem._file);
		// 	fileItem.imageSrc = $sce.trustAsResourceUrl(url);

		// 	vm.uploader.queue.push(fileItem);	
		// }

		// vm.uploader.onErrorItem = function(fileItem, response, status, headers) {
		// 	ProgressService.isVisble(false);
		// 	vm.disableAddButton = false; 

		// 	MessageService.showToast(status + ": Fail to upload file.")
		// };

		// vm.uploader.onCompleteItem = function(fileItem, response, status, headers) {
		// 	if(!FileUploadService.isUploadSuccess(headers)){
		// 		MessageService.showToast(headers.message);
		// 		return;
		// 	}
			
		// 	ProgressService.isVisble(false);
		// 	vm.disableAddButton = false; 

		// 	if(headers.code == Const.code.success){
		// 		vm.user.profileimage = {};
		// 		vm.user.profileimage.url = response.url;
		// 		vm.user.profileimage.id_profile_image = response.id_profile_image;

		// 		MessageService.showToast("Success !")	 
		// 		$state.go("app.settings.users.view-user"); 
		// 		return
		// 	}

		// 	MessageService.showToast("Success create user, but fail to upload image")
		// 	$state.go("app.settings.users.view-user"); 
		// 	return;   		   				
		// };


		function addSlider(){
			vm.disableAddButton = true;
			ProgressService.isVisble(true);
			customerportalservicescatogoryService.createCustomerPortalAppointmentServicesCatogory({companyID: LoginService.getCompanyID()}, vm.customerPortalServicesCatogory).then(function(result){
				if(!result){
					ProgressService.isVisble(false);
					MessageService.showToast("Fail to create");
					vm.disableAddButton = false;
					return
				}

				ProgressService.setMode("indeterminate");
				ProgressService.isVisble(false);
				MessageService.showToast("Success !")	 
				$state.go("app.settings.customerportalservicescatogory.view-customerportalservicescatogory"); 
			});
		}
	}
})();
(function ()
{
	'use strict';

	angular
		.module('app.settings.coupon', [])
		.config(config);

	/** @ngInject */
	function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider, labourTempValueProvider)
	{	   
		var labourTempValue = labourTempValueProvider.$get();

		$stateProvider
			.state("app.settings.coupon",{
				url:"/coupon"
			})
			.state("app.settings.coupon.view-coupon",{
				url:"/view-coupon",
				views	: {
					'content@app': {
						templateUrl: 'app/main/settings/coupon/view-coupon/view-coupon.html',
						controller : 'ViewCouponController as vm'
					}
				},
				resolve :{
					coupon:function(apiResolver, LoginService){
						//return []
						return apiResolver.resolve('coupon@getCoupon', {companyID: LoginService.getCompanyID()});
					},
					labour:function(apiResolver, LoginService){
						return apiResolver.resolve('labour@getLabour', {companyID: LoginService.getCompanyID()});
					},
					miscfeestypes:function(apiResolver, LoginService){
						return apiResolver.resolve('miscfeestypes@getmiscfeestypes', {
							companyID: LoginService.getCompanyID(), 
							vehicleID: 0, 
							workorderID: 0
						});
					},
					parttype:function(apiResolver, LoginService){
						return apiResolver.resolve('parttype@getparttypes', {companyID: LoginService.getCompanyID()});
					},
					presetPackage:function(MessageService, PresetPackagesService, LoginService){
						return PresetPackagesService.getPresetPackages({companyID: LoginService.getCompanyID()}).$promise.then(function(presetPackages){
							if(!Array.isArray(presetPackages)){
								return [];
							}else{
								return presetPackages;
							}
						})
						.catch(MessageService.showToast);
					},
					presetWarranty:function(MessageService, WarrantyService, LoginService, Warranty){	
						return WarrantyService.getWarranty({companyID: LoginService.getCompanyID()}).$promise.then(function(warrantyResponse){
							if(!Array.isArray(warrantyResponse)){
								return [];
							}else{
								var warrantyList = [];

								warrantyResponse.forEach(function(warrantyData){
									if(warrantyData == null){
										return;
									}
			
									var warranty = new Warranty();
									warranty.setAttributes(warrantyData);
			
									warrantyList.push(warranty);
								});

								return warrantyList;
							}
						})
						.catch(MessageService.showToast);
					}
				}
			})
			.state('app.settings.coupon.add-coupon', {
				url	  : '/add-coupon',
				views	: {
					'content@app': {
						templateUrl: 'app/main/settings/coupon/add-coupon/add-coupon.html',
						controller : 'AddCouponController as vm'
					}
				}
			})
			// .state('app.settings.coupon.edit-coupon', {
			// 	url	  : '/edit-coupon',
			// 	views	: {
			// 		'content@app': {
			// 			templateUrl: 'app/main/settings/coupon/edit-coupon/edit-coupon.html',
			// 			controller : 'EditPromptDialogControllerCoupon as vm'
			// 		}
			// 	},
			// 	resolve:{
			// 		Coupon:function(apiResolver, $stateParams){
			// 			var companyID = $stateParams.companyID;
			// 			var userID = $stateParams.labourTypesID;

			// 			var labourName = $stateParams.labourName;
			// 			var labourRate = $stateParams.labourRate;
			// 			var labourTime = $stateParams.labourTime;
			// 			var labourQuantity = $stateParams.labourQuantity;

			// 			if(typeof(companyID) == "number"){
			// 				labourTempValue.setTempCompanyID(companyID);
			// 			}else{
			// 				companyID = labourTempValue.getTempCompanyID(companyID);
			// 			}

			// 			if(typeof(userID) == "number"){
			// 				labourTempValue.setTempCouponID(userID);
			// 			}else{
			// 				userID = labourTempValue.getTempCouponID(userID);
			// 			}
			// 			return apiResolver.resolve('coupon@getlabourr', {'labourTypesID' : userID, "companyID" : companyID, "labourName": labourName, "labourRate": labourRate, "labourTime": labourTime, "labourQuantity": labourQuantity});
			// 		}
			// 	},
			// 	params: {
			// 		labourTypesID: null,
			// 		companyID: null,
			// 		labourName: null,
			// 		labourRate: null,
			// 		labourTime: null,
			// 		labourQuantity: null,
			// 	}
			// });
	}


})();
(function ()
{
    'use strict';

    angular.module('app.settings.coupon')
        .controller('EditPromptDialogControllerCoupon', EditPromptDialogControllerCoupon);

    /** @ngInject */
    function EditPromptDialogControllerCoupon(coupon, miscfeestypes, parttype, labour, updateCoupon, $mdDialog, CouponService, $state)
    {
        var vm = this;
        vm.coupon = coupon;
        vm.updateCoupon = updateCoupon
        vm.confirm = confirm;
        vm.isButtonActive = true;
       
        vm.closeDialog = closeDialog;

        vm.labourName = vm.coupon.labour_name;
        vm.labourRate = vm.coupon.default_rate;
        vm.labourTime = vm.coupon.default_time;
        vm.labourQuantity = vm.coupon.default_quantity;

        function confirm(){
            vm.coupon.labour_name =  vm.labourName;
            vm.coupon.default_rate = vm.labourRate;
            vm.coupon.default_time =  vm.labourTime;
            vm.coupon.default_quantity = vm.labourQuantity;
            updateCoupon(coupon);

            
            $mdDialog.hide();
        }

        function closeDialog (){
            $mdDialog.hide();
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.settings.coupon')
        .controller('ViewCouponController', ViewCouponController);

    function ViewCouponController($scope, $state, ToolsFactory, $filter, coupon, LoginService, CouponService, $mdDialog, MessageService, $document, labour, miscfeestypes, parttype, presetPackage, presetWarranty){   
        var vm = this;
        var dataForEveryPage;
        var totalPage;
        var couponList = [];  
        vm.coupons = [];  
        vm.labour = [];  
        vm.miscfeestypes = [];  
        vm.parttype = [];
        vm.presetPackage = [];
        vm.presetWarranty = [];

        var loginUserInfo = LoginService.getUserInfo();

        if(typeof(loginUserInfo) == "undefined"){
            return;
        }
        
        var filteredUsers = coupon;

        vm.totalCoupons = filteredUsers.length;
        vm.search = search;        
        vm.resetTable = resetTable;
        // vm.editCoupon = editCoupon;
        vm.deleteCoupon = deleteCoupon;
        vm.goToPage = goToPage;
        vm.goToLastPage = goToLastPage;
        vm.options = [10, 25, 50, 100];
        vm.itemPerPage = vm.options[0];
        vm.dialogTest = dialogTest;
        vm.dialogedit = dialogedit;
        vm.pageOptions;
        vm.copyCouponURL = copyCouponURL;
        init()
        resetTable();

        function init(){
            initCoupn();
            initLabour();
            initMiscfeestypes();
            initParttype();
            initPresetPackage();
            initPresetWarranty();
        }

        function initCoupn(){
            if(coupon && coupon.length > 0){
                vm.coupons = coupon;
            }
        }

        function initLabour(){
            if(labour && labour.length > 0){
                vm.labour = coupon;
            }
        }

        function initParttype(){
            if(parttype && parttype.length > 0){
                vm.parttype = parttype;
            }
        }

        function initMiscfeestypes(){
            if(miscfeestypes && miscfeestypes.length > 0){
                vm.miscfeestypes = miscfeestypes;
            }
        }

        function initPresetPackage(){
            if(!Array.isArray(presetPackage)){
                vm.presetPackage = presetPackage;
            }else{
                vm.presetPackage = [];
            }
        }

        function initPresetWarranty(){
            if(!Array.isArray(presetWarranty)){
                vm.presetWarranty = presetWarranty;
            }else{
                vm.presetWarranty = [];
            }
        }


        function resetTable(){
            dataForEveryPage = ToolsFactory.dividDataByPage(filteredUsers, vm.itemPerPage);
            totalPage = dataForEveryPage.length;
            goToPage(1);
        }

        function search(){
            filteredUsers = $filter('filter')(coupon, vm.keyword);
            vm.totalCoupons = filteredUsers.length;
            resetTable();
        }

        function deleteCoupon(coupon){
            CouponService.deleteCoupon(coupon, deleteCouponCallback);
        }

        function deleteCouponCallback (err, couponData) {
        	if(err){
        		MessageService.showToast(err)
        		return;
        	}


            for(var i = 0; i<coupon.length; i++){
                var currentUser = coupon[i];
                if(currentUser.id_coupon == couponData.id_coupon){
                    coupon.splice(i,1);
                }
            }
            filteredUsers = coupon;
            resetTable();
            MessageService.showToast("refresh Success !");

        }

        function updateCoupon(coupon){
            CouponService.updateCoupon(coupon, updateCouponCallback);
        }

        function updateCouponCallback (err, coupon) {

        	if(err){
        		MessageService.showToast(err)
        		return;
        	}
            MessageService.showToast("refresh Success !");

        }

        function goToPage(pageNumber){
            vm.coupon = dataForEveryPage[pageNumber - 1];
            vm.pages = ToolsFactory.pageListBuilder(totalPage, pageNumber);
        }   

        function goToLastPage(){
            goToPage(totalPage)
        }   

        function dialogTest(coupon){
            $mdDialog.show({
                controller         : 'DeletePromptDialogControllerCoupon',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/settings/coupon/dialogs/delete-prompt-dialog-coupon.html',
                clickOutsideToClose: true,
                locals             : {
                    coupon      : coupon,
                    deleteCoupon : deleteCoupon
                }
            });
        }

        function dialogedit(coupon) {
            $mdDialog.show({
                controller: 'EditPromptDialogControllerCoupon',
                controllerAs: 'vm',
                templateUrl: 'app/main/settings/coupon/edit-coupon/edit-coupon.html',
                clickOutsideToClose: true,
                locals: {
                    coupon: coupon,
                    labour: vm.labour,
                    miscfeestypes: vm.miscfeestypes,
                    parttype: vm.parttype,
                    presetPackage: vm.presetPackage,
                    presetWarranty: vm.presetWarranty,
                    updateCoupon: updateCoupon
                }
            });
        }

        function copyCouponURL(coupon){

            var currentUrl = window.location.href;
        
            var baseUrl;
        
            if (currentUrl.includes('https://test.autocart.ca')) {
                baseUrl = 'https://test.portal.autocart.ca';
            } else if (currentUrl.includes('https://www.autocart.ca')) {
                baseUrl = 'https://portal.autocart.ca';
            } else {
                baseUrl = 'http://localhost:4200/';
            }
        
            // Construct the new URL
            var newUrl = baseUrl + '/search-customer?couponCode=' + coupon.code;
        
            // Copy the URL to the clipboard (if required)
            navigator.clipboard.writeText(newUrl).then(function(){
                MessageService.showToast("URL Copied!");
            }).catch(function(err){
                console.error('Failed to copy URL: ', err);
                MessageService.showToast("Failed to copy URL!");
            });
        }
    }
})();
(function ()
{
	'use strict';

	angular
		.module('app.settings.coupon')
		.controller('AddCouponController', AddCouponController);

	function AddCouponController($sce, $scope, $state, ToolsFactory, CouponService, LoginService, $timeout, MessageService, Const, FileUploader, FileUploadService, ProgressService){   
		var vm = this;

		vm.newCoupon = {};
		vm.addCoupon = addCoupon;
		vm.roles = [];
		vm.checkCoupondescription = checkCoupondescription;

		vm.checkEmail = checkEmail;
		vm.disableAddButton = false;		
		vm.processStatus = {};

		var loginUserSubRoles = LoginService.getUserSubRoles();
		var companyID = LoginService.getCompanyID();

		vm.uploader = FileUploadService.getNewUploader();

		var imageFilter = FileUploadService.getImageFilter();
		var sizeFilter 	= FileUploadService.getSizeFilter(5);

		vm.uploader.filters.push(imageFilter);
		vm.uploader.filters.push(sizeFilter);		

		init ();

		function addCoupon(){
			console.log(vm.newCoupon)
			if($scope.addCouponForm.$invalid){
				MessageService.showToast("Please make sure all input is valid");
				return;
			}
			var newCoupon= vm.newCoupon;

			vm.disableAddButton = true;
			ProgressService.isVisble(true);

			CouponService.addCoupon(companyID, newCoupon, addCouponCallback);
		}

		function init (){
			loginUserSubRoles.forEach(function(currentRole){
				var roleObj={};

				roleObj.description = Const.roleDescription[currentRole];
				roleObj.roleTitle = currentRole;
				roleObj.isCheck = false;
		
				vm.roles.push(roleObj);	 
			})
		}

		function checkCoupondescription(username){
			
			if(username != null){
				vm.isCheckingUsername = true;
				
			}	
		}
		function checkEmail(email){
			if($scope.addUser.email.$invalid){
				return;
			}		   
			
			if(email != null){
				vm.isCheckingEmail = true;
				UserService.checkAvailability("email", email, checkEmailCallback);
			}
		}

		function checkEmailCallback(result){
			vm.isCheckingEmail = false;
			vm.isEmailAvailable = result;
		} 

		function addCouponCallback (error, newUserID){	 
			if(error){
				ProgressService.isVisble(false);
				MessageService.showToast(error);
				vm.disableAddButton = false;
				return
			}

			if(vm.uploader.queue == 0){
				ProgressService.isVisble(false);
				MessageService.showToast("Success !")		   
				$state.go("app.settings.coupon.view-coupon");	 
				return;	   	
			}
			vm.uploader.onBeforeUploadItem = function(item) {
				item.removeAfterUpload = true;
				item.url = FileUploadService.getUrlForCreateProfileImage(newUserID);	
			}

			ProgressService.setMode("indeterminate");
			ProgressService.isVisble(true);

			vm.uploader.uploadAll();
		}

		vm.uploader.onAfterAddingFile = function(fileItem) {
			vm.uploader.queue = [];
			
			var url = URL.createObjectURL(fileItem._file);
			fileItem.imageSrc = $sce.trustAsResourceUrl(url);

			vm.uploader.queue.push(fileItem);	
		}

		vm.uploader.onErrorItem = function(fileItem, response, status, headers) {
			ProgressService.isVisble(false);
			vm.disableAddButton = false; 

			MessageService.showToast(status + ": Fail to upload file.")
		};

		vm.uploader.onCompleteItem = function(fileItem, response, status, headers) {
			if(!FileUploadService.isUploadSuccess(headers)){
				MessageService.showToast(headers.message);
				return;
			}
			
			ProgressService.isVisble(false);
			vm.disableAddButton = false; 

			if(headers.code == Const.code.success){
				vm.user.profileimage = {};
				vm.user.profileimage.url = response.url;
				vm.user.profileimage.id_profile_image = response.id_profile_image;

				MessageService.showToast("Success !")	 
				$state.go("app.settings.users.view-user"); 
				return
			}

			MessageService.showToast("Success create user, but fail to upload image")
			$state.go("app.settings.users.view-user"); 
			return;   		   				
		};
	}
})();
(function ()
{
	'use strict';

	angular
		.module('app.settings.warranty', [])
		.config(config);

	/** @ngInject */
	function config($stateProvider)
	{
		$stateProvider
		.state("app.settings.warranty",{
			url:"/warranty"
		})
		.state("app.settings.warranty.view-Warranty",{
				url:"/view-Warranty",
				views	: {
					'content@app': {
						templateUrl: 'app/main/settings/Warranty/view-Warranty/view-Warranty.html',
						controller : 'ViewWarrantyController as vm'
					}
				},
			})
		.state("app.settings.warranty.add-Warranty",{
				url:"/add-Warranty",
				views	: {
					'content@app': {
						templateUrl: 'app/main/settings/Warranty/add-Warranty/add-Warranty.html',
						controller : 'AddWarrantyController as vm'
					}
				},
		})
		.state("app.settings.warranty.add-WarrantyFeature",{
			url:"/add-WarrantyFeature",
			views	: {
				'content@app': {
					templateUrl: 'app/main/settings/Warranty/add-WarrantyFeature/add-WarrantyFeature.html',
					controller : 'AddWarrantyFeatureController as vm'
				}
			},
			resolve :{
				warrantyfeatureList:function($q, MessageService, WarrantyService, LoginService, $stateParams){
					const resourcePath = { 
						companyID: LoginService.getCompanyID()
					};

					return WarrantyService.getWarrantyFeature(resourcePath).$promise.catch(MessageService.showToast);
				},
			}
	})
	}
})();
(function ()
{
	'use strict';

	angular
		.module('app.settings.warranty')
		.controller('ViewWarrantyController', ViewWarrantyController);

	function ViewWarrantyController($q, DialogService, LoginService, $scope, GeneralTools, WarrantyService, PresetPackage, $timeout, MessageService, $mdDialog){   
		const vm = this;
		const companyID = LoginService.getCompanyID();
		vm.dialogdelete = dialogdelete;
        vm.dialogedit = dialogedit;
		vm.showItems = {};
		vm.warrantyfeature;

		init();

		function init(){
			initWarranty();
			initWarrantyfeature();
		}

		function initWarranty(){
			WarrantyService.getWarranty({companyID: companyID}).$promise.then(function(warranty){
				vm.warranty = warranty;
				vm.totalwarranty = warranty.length;

				for(var i = 0; i < vm.warranty.length; i++){
					vm.warranty[i].canBeChanged = true;
					vm.warranty[i].isOwner = true;
				}
			})
			.catch(MessageService.showToast);
		}

		function initWarrantyfeature(){
			WarrantyService.getWarrantyFeature({companyID: companyID}).$promise.then(function(warrantyfeature){
				vm.warrantyfeature = warrantyfeature;
			})
			.catch(MessageService.showToast);
		}

		function dialogdelete(warranty){
            $mdDialog.show({
                controller         : 'DeletePromptDialogControllerWarranty',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/settings/Warranty/delete-dialog/delete-warranty.html',
                clickOutsideToClose: true,
                locals             : {
                    warranty      : warranty,
                    deletewarranty : deletewarranty
                }
            });
        }

        function dialogedit(warranty){
            $mdDialog.show({
                controller         : 'EditPromptDialogControllerWarranty',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/settings/Warranty/edit-dialog/edit-warranty.html',
                clickOutsideToClose: true,
                locals             : {
                    warranty      : warranty,
					warrantyfeature: vm.warrantyfeature,
                    updatewarranty : updatewarranty
                }
            });
        }
		
        function deletewarranty(warranty){
			warranty.companyID = companyID
			warranty.warrantyID = warranty.id_warranty
			WarrantyService.deleteWarranty({companyID: companyID, warrantyID:warranty.id_warranty}, deletewarrantyCallback);
        }

        function deletewarrantyCallback (err, warranty) {

        	if(err){
        		MessageService.showToast(err)
        		return;
        	}
            for(var i = 0; i<vm.warranty.length; i++){
                var currentUser = vm.warranty[i];
                if(currentUser.id_warranty == warranty.warrantyID){
                    vm.warranty.splice(i,1);
                }
            }
            MessageService.showToast("refresh Success !");

        }

		function updatewarranty(warranty){
			warranty.companyID = companyID
			warranty.warrantyID = warranty.id_warranty
            WarrantyService.updateWarranty(warranty, updatewarrantCallback);
        }

        function updatewarrantCallback (err, job) {

        	if(err){
        		MessageService.showToast(err)
        		return;
        	}
			initWarranty();
            MessageService.showToast("refresh Success !");

        }
	}
})();
(function ()
{
    'use strict';

    angular.module('app.settings.coupon')
        .controller('DeletePromptDialogControllerCoupon', DeletePromptDialogControllerCoupon);

    /** @ngInject */
    function DeletePromptDialogControllerCoupon(coupon, deleteCoupon, $mdDialog,CouponService)
    {
        var vm = this;
        vm.coupon = coupon;
        vm.deleteCoupon = deleteCoupon
        vm.confirm = confirm;
        vm.isButtonActive = false;
        vm.enableButton = enableButton;
        vm.closeDialog = closeDialog;

        function confirm(){
            deleteCoupon(coupon);
            $mdDialog.hide();
        }

        function closeDialog (){
            $mdDialog.hide();
        }

        function enableButton(){
            if(vm.coupon.labour_name == vm.confirmCouponname){
                vm.isButtonActive = true;
            }else{
                vm.isButtonActive = false;
            }
        }
    }
})();

(function ()
{
    'use strict';

    angular.module('app.settings.warranty')
        .controller('DeletePromptDialogControllerWarranty', DeletePromptDialogControllerWarranty);

    /** @ngInject */
    function DeletePromptDialogControllerWarranty(warranty, deletewarranty, $mdDialog, miscfeestypesService)
    {
        var vm = this;
        vm.warranty = warranty

        vm.deletewarranty = deletewarranty
        vm.confirmwarrantyname ="";
        vm.confirm = confirm;
        vm.isButtonActive = false;
        vm.enableButton = enableButton;
        vm.closeDialog = closeDialog;


        function confirm(){
            deletewarranty(warranty);
            $mdDialog.hide();
        }

        function closeDialog (){
            $mdDialog.hide();
        }

        function enableButton(){
            if(vm.warranty.name == vm.confirmwarrantyname){
                vm.isButtonActive = true;
            }else{
                vm.isButtonActive = false;
            }
        }
    }
})();


(function () {
    'use strict';

    angular.module('app.settings.warranty')
        .controller('EditPromptDialogControllerWarranty', EditPromptDialogControllerWarranty);

    /** @ngInject */
    function EditPromptDialogControllerWarranty(warranty, warrantyfeature, updatewarranty, $mdDialog, $state, $scope) {
        var vm = this;

        vm.warranty = warranty;
        vm.warrantyfeature = warrantyfeature;
        vm.updatewarranty = updatewarranty
        vm.confirm = confirm;

        vm.addnewwarrantyfeature = addnewwarrantyfeature;
        vm.removewarrantyfeature = removewarrantyfeature;
        vm.extractnewfeatures = extractnewfeaturesid;
        vm.extractremovedfeaturesid = extractremovedfeaturesid;

        vm.isButtonActive = true;
        vm.enableButton = enableButton;
        vm.closeDialog = closeDialog;


        vm.warrantytempholder = angular.copy(warranty);
        $scope.features = angular.copy(vm.warranty.features);

        vm.containfeature = true;


        // vm.labourtypes = labour_type
        // vm.parttypes = part_type
        // vm.miscfeetypes = miscfee_type

        vm.newwarrantyfeatureselected = "";

        for (var feature in $scope.features) {
            if ($scope.features[feature] && $scope.features[feature].id_warranty_feature) {
                //$scope.feature[feature].labour_quantity = +$scope.feature[feature].labour_quantity
            } else {
                vm.containfeature = false
                $scope.features = []
            }
        }


        function confirm() {
            vm.warranty = vm.warrantytempholder
            vm.warranty.addedfeaturelist = extractnewfeaturesid();
            vm.warranty.removedfeaturelist = extractremovedfeaturesid();
            updatewarranty(vm.warranty);
            $mdDialog.hide();
        }

        function addnewwarrantyfeature() {
            if (!vm.newwarrantyfeatureselected) {
                return
            } else {
                $scope.features.push(
                    {
                        description: vm.newwarrantyfeatureselected.description,
                        id_warranty_feature: vm.newwarrantyfeatureselected.id_warranty_feature,
                        name: vm.newwarrantyfeatureselected.name
                    }
                )
                vm.containlabour = true
            }
        }

        function removewarrantyfeature(feature) {
            if (!feature) {
                return
            } else {
                for (var i = 0; i < $scope.features.length; i++) {
                    var currentPart = $scope.features[i];
                    if (currentPart.id_warranty_feature == feature.id_warranty_feature && currentPart.name == feature.name && currentPart.description == feature.description) {
                        $scope.features.splice(i, 1);
                        return
                    }
                }
            }
        }

        function extractnewfeaturesid() {
            var oldlist = [];
            var newlist = [];
            for (var i = 0; i < vm.warranty.features.length; i++) {
                var currentPart = vm.warranty.features[i];
                oldlist.push(currentPart.id_warranty_feature)
            }

            for (var i = 0; i < $scope.features.length; i++) {
                var currentPart = $scope.features[i];
                newlist.push(currentPart.id_warranty_feature)
            }

            var difference = newlist.filter(function(x){return  !oldlist.includes(x)});
            return difference
        }

        function extractremovedfeaturesid() {
            var oldlist = [];
            var newlist = [];
            for (var i = 0; i < vm.warranty.features.length; i++) {
                var currentPart = vm.warranty.features[i];
                oldlist.push(currentPart.id_warranty_feature)
            }

            for (var i = 0; i < $scope.features.length; i++) {
                var currentPart = $scope.features[i];
                newlist.push(currentPart.id_warranty_feature)
            }
            var difference = oldlist.filter(function(x){return !newlist.includes(x)});
            return difference
        }

        function closeDialog() {
            $scope.labour = [];
            $scope.part = [];
            $scope.miscfees = [];
            $mdDialog.hide();
        }

        function isdatavalid() {
            if ((vm.warrantytempholder.name.length <= 0 ||
                    vm.warrantytempholder.cost == null ||
                    vm.warrantytempholder.duration_month == null ||
                    vm.warrantytempholder.max_vehicle_year == null ||
                    vm.warrantytempholder.min_mileage == null ||
                    vm.warrantytempholder.max_mileage == null ||
                    vm.warrantytempholder.provider.length <= 0)) 
            {
                return false
            } else {
                return true
            }
        }
        function enableButton() {
            if (isdatavalid()) {
                vm.isButtonActive = true;
            } else {
                vm.isButtonActive = false;
            }
        }

    }
})();

(function ()
{
	'use strict';

	angular
		.module('app.settings.warranty')
		.controller('AddWarrantyFeatureController', AddWarrantyFeatureController);

	function AddWarrantyFeatureController($q, DialogService, LoginService, $scope, GeneralTools, warrantyfeatureList, WarrantyService, $timeout, MessageService, jobtypes){   
		const vm = this;
		const companyID = LoginService.getCompanyID();
		
		vm.addItem = addItem;
		vm.newWarrantyFeatureDescription=""
		vm.newWarrantyFeatureName=""
		vm.addPackage = addPackage;
		vm.deleteWarrantyFeature = deleteWarrantyFeature;

		vm.showItems = {};
		vm.selectedMap = {};
		vm.getSelectedPackages = getSelectedPackages;


		init();
		vm.showItems = {};
		function init(){
			initWarrantyfeature();
			
		}


		function initWarrantyfeature(){
			// WarrantyService.getWarrantyFeature({companyID: companyID}).$promise.then(function(warrantyfeature){
			// 	vm.warrantyfeature = warrantyfeature;
			// })
			// .catch(MessageService.showToast);
			vm.warrantyfeature = warrantyfeatureList;
		}

		function addItem(){
			if(!$scope.packageItemForm.$valid){
				MessageService.showToast("Something wrong in package item form");
				return;
			}

			vm.newPresetPackage.items.push({
				name: vm.newWarrantyFeatureName,
				description: vm.newWarrantyFeatureDescription,
			});

			resetPackageItemForm();
		}

		function resetPackageItemForm(){
			vm.newWarrantyFeatureName = null;
			vm.newWarrantyFeatureDescription = null;

			$scope.newWarrantyFeatureForm.$setPristine(true);
			$scope.newWarrantyFeatureForm.$setUntouched();
		}

		function addPackage(){

			if(!$scope.newWarrantyFeatureForm.$valid){			
				MessageService.showToast("Something wrong in the warranty form.");
				return;
			}

			const resourcePath = {
				companyID: companyID
			}


			vm.isSaving = true;
			resourcePath.name = vm.newWarrantyFeatureName
			resourcePath.description = vm.newWarrantyFeatureDescription
			WarrantyService.createWarrantyFeature(resourcePath).$promise
				.then(function(newPresetPackageID){
					if(newPresetPackageID && newPresetPackageID.data){
						vm.warrantyfeature.push(angular.copy({id_warranty_feature: newPresetPackageID.data, name:vm.newWarrantyFeatureName, description:vm.newWarrantyFeatureDescription}));
					}

					resetPackageItemForm();
					MessageService.showToast("warranty feature added");
				})
				.catch(MessageService.showToast)
				.finally(function(){
					vm.isSaving = false;
				});
		}

		function deleteWarrantyFeature(){
			if(!vm.getSelectedPackages){
				return;
			}
	
		const selectedPackages = vm.getSelectedPackages();

			if(!Array.isArray(selectedPackages) ){
				return;
			}

			if(selectedPackages.length <= 0){
				MessageService.showToast("Please select a Warranty Feature.");
				return;
			}
			vm.isDeleting = true;
			DialogService.showYesOrNoDialog("Delete Warranty Feature", "Delete " + selectedPackages.length + " Warranty Features")
				.then(function(isYes){
					if(!isYes){
						return $q.reject();
					}

					const queue = [];
					
					selectedPackages.forEach(function(presetPackage){
						queue.push(deleteWarrantyFeature2(presetPackage));
					});

					return $q.all(queue);
				})
				.then(function(){
					MessageService.showToast("Warranty Feature deleted");
				})
				.catch(function(error){
					if(error){
						MessageService.showToast(error);
					}
				})
				.finally(function(){
					vm.isDeleting = false;
				});
		}

		function deleteWarrantyFeature2(presetPackage){

			const resourcePath = {
				companyID: companyID,
				warrantyfeatureID: presetPackage.id_warranty_feature
			}

			return WarrantyService.deleteWarrantyFeature(resourcePath).$promise				
				.then(function(){
					const index = vm.warrantyfeature.findIndex(function(item){
						return !!item && item.id_warranty_feature == presetPackage.id_warranty_feature;
					});

					vm.warrantyfeature.splice(index, 1);
					return $q.resolve();	
				});
		}

		
		function getSelectedPackages(){
			if(!Array.isArray(vm.warrantyfeature)){
				return;
			}

			return vm.warrantyfeature.filter(function(itme){
				return !!itme && vm.selectedMap[itme.id_warranty_feature];
			});
		}
	}
})();
(function ()
{
	"use strict";

	angular
		.module("app.settings.warranty")
		.component("addWarrantyFeatureList", {
				bindings:{
					warrantyFeature: '<',
					getSelectedPackages: '='
				},
				templateUrl: "app/main/settings/warranty/add-WarrantyFeature-list/add-WarrantyFeature-list.html",
				controller: componentController,
		  		controllerAs: 'vm'
			});

		function componentController(GeneralTools, MessageService, WorkOrderService, LoginService){
			var vm = this;


			vm.$postLink = initCallbacks;
			vm.showItems = {};
			vm.selectedMap = {};

			function initCallbacks(){
				vm.getSelectedPackages = getSelectedPackages;
			}

			function getSelectedPackages(){
				if(!Array.isArray(vm.warrantyFeature)){
					return;
				}

				return vm.warrantyFeature.filter(function(itme){
					return !!itme && vm.selectedMap[itme.id_warranty_feature];
				});
			}




		}
})();
(function ()
{
	'use strict';

	angular
		.module('app.settings.warranty')
		.controller('AddWarrantyController', AddWarrantyController);

	function AddWarrantyController($state, $q, DialogService, LoginService, $scope, GeneralTools, WarrantyService, PresetPackage, $timeout, MessageService, jobtypes, ProgressService, FileUploadService){   
		const vm = this;
		const companyID = LoginService.getCompanyID();
		
		// vm.today = new Date();
		// vm.setActiveExpDate = setActiveExpDate
		// vm.translateToDollar = GeneralTools.inputTranslators.dollar;
		// vm.decimalTranslator = GeneralTools.inputTranslators.decimal;
		// vm.quantityInputOption = {
		// 	decimalFractionSize:0
		// };
		
		// vm.addItem = addItem;
		// vm.addPackage = addPackage;
		// vm.deletePackages = deletePackages;
		// vm.removeNewItem = removeNewItem;
		// vm.jobTyppList = jobtypes
		// vm.newAssignedJobHolder = "";

		$scope.features = [];
		vm.newwarrantyfeatureselected = "";
		vm.showItems = {};
		vm.addnewmiscfee = addnewmiscfee;
		vm.removemiscfee = removemiscfee;
		vm.addwarranty = addwarranty;
		vm.isButtonActive = true;
		vm.warranty = {};
		vm.disableAddButton = false;
		vm.uploader = FileUploadService.getNewUploader();


		init();



		function init(){
			initWarrantyfeature();
			initWarranty();
			// initNewPresetPackage();
			// initPresetPackages();
		}

		// function initWarranty(){
		// 	WarrantyService.getWarranty({companyID: companyID}).$promise.then(function(warranty){
		// 		vm.warranty = warranty;
		// 		vm.totalwarranty = warranty.length;
		// 	})
		// 	.catch(MessageService.showToast);
		// }

		function initWarrantyfeature(){
			WarrantyService.getWarrantyFeature({companyID: companyID}).$promise.then(function(warrantyfeature){
				vm.warrantyfeature = warrantyfeature;
			})
			.catch(MessageService.showToast);
		}

		function initWarranty(){
			WarrantyService.getWarranty({companyID: companyID}).$promise.then(function(warranty){
				vm.warrantylist = warranty;
				vm.totalwarranty = warranty.length;
			})
			.catch(MessageService.showToast);
		}


		function addnewmiscfee(){
            if(!vm.newwarrantyfeatureselected){
                return 
            }else if(trytoaaddsamefeature(vm.newwarrantyfeatureselected)){
				MessageService.showToast("The feature you are attempting to add has already been incorporated.");
			}else{
                $scope.features.push(
                    {
						id_warranty_feature: vm.newwarrantyfeatureselected.id_warranty_feature,
                        name: vm.newwarrantyfeatureselected.name,
                        description:vm.newwarrantyfeatureselected.description,
                    }
                )
                vm.containmiscfees = true
            }

        }

		function trytoaaddsamefeature(feature){
			var temp = false;
			for(var i = 0; i<$scope.features.length; i++){
				var currentPart =  $scope.features[i];
				if(currentPart.id_warranty_feature == feature.id_warranty_feature && currentPart.name == feature.name && currentPart.description == feature.description){
					temp = true
				}
			}
			return temp

		}

		function enableButton(){
            if(vm.name.length  >= 1){
                vm.isButtonActive = true;
            }else{
                vm.isButtonActive = false;
            }
        }

		function removemiscfee(feature){
            if(!feature){
                return
            }else{
                for(var i = 0; i<$scope.features.length; i++){
                    var currentPart = $scope.features[i];
                    if(currentPart.id_warranty_feature == feature.id_warranty_feature && currentPart.name == feature.name && currentPart.description == feature.description){
                        $scope.features.splice(i,1);
                        return
                    }
                }
            }
        }

		function addwarranty(){
			if($scope.addwarranty.$invalid){
				MessageService.showToast("Please make sure all input is valid");
				return;
			}

			if($scope.features.length <= 0){
				MessageService.showToast("Warranty must contain at least 1 feature");
				return;
			}

			if(vm.warranty.retail == null){
				vm.warranty.retail = vm.warranty.cost
			}

			var newwarranty = {
				companyID: companyID,
				cost:vm.warranty.cost,
				description: vm.warranty.description,
				duration_mileage: vm.warranty.duration_mileage,
				duration_month: vm.warranty.duration_month,
				max_mileage:vm.warranty.max_mileage,
				max_vehicle_year: vm.warranty.max_vehicle_year,
				min_mileage: vm.warranty.min_mileage,
				name: vm.warranty.name,
				provider: vm.warranty.provider,
				retail: vm.warranty.retail,
				features:$scope.features,
				max_claim: vm.warranty.max_claim
			}

			vm.disableAddButton = true;
			ProgressService.isVisble(true);

			WarrantyService.createWarranty(newwarranty, addwarrantyCallback);
		}

		function addwarrantyCallback (error, newUserID){	 
			if(error){
				ProgressService.isVisble(false);
				MessageService.showToast(error);
				vm.disableAddButton = false;
				return
			}

			if(vm.uploader.queue == 0){
				ProgressService.isVisble(false);
				MessageService.showToast("Success !")		   
				$state.go("app.settings.warranty.view-Warranty");	 
				return;	   	
			}
			ProgressService.setMode("indeterminate");
			ProgressService.isVisble(true);

			
			vm.uploader.uploadAll();
		}

		// function initPackageTypes(){
		// 	PresetPackagesService.getPackageItemTypes().$promise.then(function(packageItemTypes){
		// 		vm.packageItemTypes = packageItemTypes;
		// 	})
		// 	.catch(MessageService.showToast);
		// }

		// function initNewPresetPackage(){
		// 	vm.newPresetPackage = new PresetPackage();
		// 	vm.newPresetPackage.items = [];
		// }

		// function initPresetPackages(){
		// 	PresetPackagesService.getPresetPackages({companyID: companyID}).$promise.then(function(presetPackages){
		// 		if(!Array.isArray(presetPackages)){
		// 			return;
		// 		}

		// 		vm.presetPackages = presetPackages;
		// 	})
		// 	.catch(MessageService.showToast);
		// }

		// function addItem(){
		// 	if(!$scope.packageItemForm.$valid){
		// 		MessageService.showToast("Something wrong in package item form");
		// 		return;
		// 	}

		// 	vm.newPresetPackage.items.push({
		// 		name: vm.newPackageItemName,
		// 		quantity: vm.newPackageItemQuantity,
		// 		job: vm.newAssignedJobHolder
		// 		//fk_id_package_item_type: vm.newPackageItemType
		// 	});

		// 	resetPackageItemForm();
		// }

		// function resetPackageItemForm(){
		// 	vm.newPackageItemName = null;
		// 	vm.newPackageItemQuantity = null;
		// 	vm.newAssignedJobHolder = null;
		// 	//vm.newPackageItemType = null;

		// 	$scope.packageItemForm.$setPristine(true);
		// 	$scope.packageItemForm.$setUntouched();
		// }

		// function setActiveExpDate(){
		// 	if(!vm.newPackageActiveExpiryDate){
		// 		vm.newPresetPackage.active_expiry_date = null;
		// 		return
		// 	}

		// 	vm.newPresetPackage.setActiveExpiryDate(moment(vm.newPackageActiveExpiryDate));

		// 	if(!vm.newPresetPackage.active_expiry_date){
		// 		vm.newPackageActiveExpiryDate = null
		// 	}
		// }

		// function addPackage(){

		// 	if(!$scope.newPackageForm.$valid){			
		// 		MessageService.showToast("Something wrong in the package form.");
		// 		return;
		// 	}

			
		// 	if(!$scope.newPackageForm2.$valid){			
		// 		MessageService.showToast("Something wrong in the package form.");
		// 		return;
		// 	}

		// 	if(!Array.isArray(vm.newPresetPackage.items) || vm.newPresetPackage.items.length <= 0){
		// 		MessageService.showToast("Please add an item to the package.");
		// 		return;
		// 	}

		// 	const resourcePath = {
		// 		companyID: companyID
		// 	}

		// 	vm.newPresetPackage.items.forEach(function(item){
		// 		item.fk_id_job = item.job.id_job
		// 	})

		// 	if(!vm.newPresetPackage.valid_mileage){
		// 		vm.newPresetPackage.valid_mileage = null
		// 	}

		// 	vm.isSaving = true;
			
		// 	PresetPackagesService.createPresetPackages(resourcePath, vm.newPresetPackage).$promise
		// 		.then(function(newPresetPackageID){
		// 			vm.newPresetPackage.id_preset_package = newPresetPackageID
		// 			vm.presetPackages.push(angular.copy(vm.newPresetPackage));
		// 			resetNewPackageForm();
		// 			MessageService.showToast("Package added");
		// 		})
		// 		.catch(MessageService.showToast)
		// 		.finally(function(){
		// 			vm.isSaving = false;
		// 		});
		// }

		// function deletePackages(){
		// 	if(!vm.getSelectedPackages){
		// 		return;
		// 	}

		// 	const selectedPackages = vm.getSelectedPackages();

		// 	if(!Array.isArray(selectedPackages) ){
		// 		return;
		// 	}

		// 	if(selectedPackages.length <= 0){
		// 		MessageService.showToast("Please select a package.");
		// 		return;
		// 	}

		// 	vm.isDeleting = true;

		// 	DialogService.showYesOrNoDialog("Delete Packages", "Delete " + selectedPackages.length + " packages")
		// 		.then(function(isYes){
		// 			if(!isYes){
		// 				return $q.reject();
		// 			}

		// 			const queue = [];

		// 			selectedPackages.forEach(function(presetPackage){
		// 				queue.push(deletePresetPackage(presetPackage));
		// 			});

		// 			return $q.all(queue);
		// 		})
		// 		.then(function(){
		// 			MessageService.showToast("Packages deleted");
		// 		})
		// 		.catch(function(error){
		// 			if(error){
		// 				MessageService.showToast(error);
		// 			}
		// 		})
		// 		.finally(function(){
		// 			vm.isDeleting = false;
		// 		});
		// }

		// function deletePresetPackage(presetPackage){
		// 	const resourcePath = {
		// 		companyID: companyID,
		// 		presetpackageID: presetPackage.id_preset_package
		// 	}

		// 	return PresetPackagesService.deletePresetPackages(resourcePath).$promise				
		// 		.then(function(){
		// 			const index = vm.presetPackages.findIndex(function(item){
		// 				return !!item && item.id_preset_package == presetPackage.id_preset_package;
		// 			});

		// 			vm.presetPackages.splice(index, 1);
		// 			return $q.resolve();	
		// 		});
		// }

		// function removeNewItem(index){
		// 	if(vm.newPresetPackage && Array.isArray(vm.newPresetPackage.items)){
		// 		vm.newPresetPackage.items.splice(index, 1);
		// 	}
		// }

		// function resetNewPackageForm(){
		// 	initNewPresetPackage();
		// 	vm.newPackageActiveExpiryDate = null;
		// 	$scope.newPackageForm.$setPristine();
		// 	$scope.newPackageForm.$setUntouched();
		// 	$scope.newPackageForm2.$setPristine();
		// 	$scope.newPackageForm2.$setUntouched();
		// }
	}
})();
(function ()
{
	'use strict';

	angular
		.module('app.customers', ['app.goto'])
		.constant("CustomerConstants", {
			minAge:16,
			birthdayDateFormate:"YYYY-MM-DD",
			licenseExpiryDateFormat: "YYYY-MM-DD",
			profileImagePlaceHolder:'assets/images/placeholder-vans.png',
			licenseImagePlaceHolder:'assets/images/placeholder-vans.png',
			defaultLimitPerPage:20,
			defaultPage:1,
			defaultSortBy:"first_name",
			defaultSortDirection:"ASC",
			newVehicleIdParamName : "newVehicleID",
			phoneCategories:{
				home:1,
				mobile:2
			}
		})
		.config(config);

	/** @ngInject */
	function config($stateProvider, msNavigationServiceProvider, loginInfoProvider, CustomerConstants)
	{	  

		$stateProvider
			.state('app.customers', {
				url : '/customers?firstName&lastName&email&phoneNumber&page&limit&sortBy&sortDirection',
				reloadOnSearch : false,
				views	: {
					'content@app': {
						templateUrl: 'app/main/customers/browse-customers/browse-customers.html',
						controller : 'BrowseCustomersController as vm'
					}
				}
			})
			.state('app.add-customer', {
				url :"/add-customer?redirectState&redirectParams",
				views	: {
						'content@app': {
							templateUrl: 'app/main/customers/add-customer/add-customer.html',
							controller : 'AddCustomerController as vm'
						}
					},
				resolve:{
					phoneCategories:function(CustomersService, MessageService){
						return CustomersService.getCachedPhoneCategories().catch(MessageService.showToast);
					},
					emailCategories:function(CustomersService, MessageService){
						return CustomersService.getCachedPhoneCategories().catch(MessageService.showToast);
					}
				},
				params: {
					newCustomer: null
				}	
			})
			.state('app.view-customer', {
				url	  : '/customer/{customerID}?tab&'  + CustomerConstants.newVehicleIdParamName ,
				views	: {
					'content@app': {
						templateUrl: 'app/main/customers/view-customer/view-customer.html',
						controller : 'ViewCustomerController as vm'
					}
				},
				reloadOnSearch : false,
				resolve:{	
					customers:function($stateParams, CustomersService, MessageService, LoginService){
						var resourcePath = {
							customerID: $stateParams.customerID,
							companyID: LoginService.getCompanyID()
						};
						return CustomersService.getCustomers(resourcePath, null, null, null).catch(MessageService.showToast);
					},
					serviceMap:function(WorkOrderService, MessageService, LoginService, $stateParams, GeneralTools){
						const resourcePath = {
							companyID: LoginService.getCompanyID()
						};

						const filter = {
							filters: GeneralTools.equalFilterBuilder("fk_id_customer", $stateParams.customerID)
						}

						return WorkOrderService.getAllMatchedServiceMaps(resourcePath, filter).catch(MessageService.showToast);
					},
					constants:function($q, CustomersService, MessageService, AppointmentsService){
						const queue = {
							phoneCategories: CustomersService.getCachedPhoneCategories(),
							emailCategories: CustomersService.getCachedEmailCategories(),
							appointmentStatus: AppointmentsService.getCachedAppointmentStatus()
						}
						
						return $q.all(queue).catch(MessageService.showToast);
					},
					testDrives:function($stateParams, CustomersService, MessageService, LoginService){
						var resourcePath = {}; 
						resourcePath.companyID = LoginService.getCompanyID();
						resourcePath.customerID = $stateParams.customerID;

						return CustomersService.getTestDrives(resourcePath).catch(MessageService.showToast);
					},
					creditCard:function($stateParams, CustomersService, MessageService, LoginService){
						var resourcePath = {}; 
						resourcePath.companyID = LoginService.getCompanyID();
						resourcePath.customerID = $stateParams.customerID;
						 return []
						return CustomersService.getCreditCards(resourcePath).catch(MessageService.showToast);
					},

					customAppointment:function($stateParams, CustomersService, MessageService, LoginService){
						var resourcePath = {}; 
						resourcePath.companyID = LoginService.getCompanyID();
						resourcePath.customerID = $stateParams.customerID;
						return CustomersService.getCustomAppointment(resourcePath).catch(MessageService.showToast);
					},

				}
			})
			.state('app.edit-customer', {
				url	  : '/edit-customer/{customerID}?' + CustomerConstants.newVehicleIdParamName,
				views	: {
					'content@app': {
						templateUrl: 'app/main/customers/edit-customer/edit-customer.html',
						controller : 'EditCustomerController as vm'
					}
				},
				reloadOnSearch : false,
				resolve:{	
					customerToBeEdit:function($stateParams, CustomersService, MessageService, LoginService){
						var resourcePath = {
							customerID: $stateParams.customerID,
							companyID: LoginService.getCompanyID()
						};
						return CustomersService.getCustomers(resourcePath, null, null, null).catch(MessageService.showToast);
					},
					phoneCategories:function(CustomersService, MessageService){
						return CustomersService.getCachedPhoneCategories().catch(MessageService.showToast);
					},
					emailCategories:function(CustomersService, MessageService){
						return CustomersService.getCachedEmailCategories().catch(MessageService.showToast);
					},
					customerFiles:function($stateParams, CustomersService, MessageService, LoginService){
						var resourcePath = {}; 
						resourcePath.companyID = LoginService.getCompanyID();
						resourcePath.customerID = $stateParams.customerID;

						return CustomersService.getCustomerFiles(resourcePath).catch(MessageService.showToast);
					},
					testDrives:function($stateParams, CustomersService, MessageService, LoginService){
						var resourcePath = {}; 
						resourcePath.companyID = LoginService.getCompanyID();
						resourcePath.customerID = $stateParams.customerID;

						return CustomersService.getTestDrives(resourcePath).catch(MessageService.showToast);
					},
					creditCard:function($stateParams, CustomersService, MessageService, LoginService){
						var resourcePath = {}; 
						resourcePath.companyID = LoginService.getCompanyID();
						resourcePath.customerID = $stateParams.customerID;
						 return []
						return CustomersService.getCreditCards(resourcePath).catch(MessageService.showToast);
					},
					serviceMap:function(WorkOrderService, MessageService, LoginService, $stateParams, GeneralTools){
						const resourcePath = {
							companyID: LoginService.getCompanyID()
						};

						const filter = {
							filters: GeneralTools.equalFilterBuilder("fk_id_customer", $stateParams.customerID)
						}

						return WorkOrderService.getAllMatchedServiceMaps(resourcePath, filter).catch(MessageService.showToast);
					}

				}
			});	


			msNavigationServiceProvider.saveItem("customers", {
				title : "CUSTOMERS",
				icon : "icon-car",
				weight: 3,
				requiredRoles:[]			 
			});

			msNavigationServiceProvider.saveItem('customers.browse-customers', {
				title: 'Browse Customers',
				state: 'app.customers',
				requiredRoles:[]	
			});   

			msNavigationServiceProvider.saveItem('customers.add-customer', {
				title: 'Add Customer',
				state: 'app.add-customer',
				requiredRoles:["developer", "company_manager", "accountant", "sales_manager", "salesman", "advertizing", "service_advisor", "book_test_drive"]			 
			});	
	}

})();
(function () {
    "use strict";

    angular
        .module("app.customers")
        .component("customAppointmentList", {
            bindings: {
                disableEditing: '<',
                onStatusChanged: '<',
                appointmentStatus: '<',
                appointments: '=',
                selectedMap: '='
            },
            templateUrl: "app/main/customers/view-customer/custom-appointment/custom-appointment-list.html",
            controller: componentController,
            controllerAs: 'vm'
        });

    function componentController($state, WorkOrderConstants, $window, $scope, $timeout) {
        const vm = this;
        vm.isSmallScreen = false;
        vm.tempbool = false;

        vm.dateFormat = WorkOrderConstants.scheduleDateFormat;
        vm.getScheduleUrl = getScheduleUrl;
        vm.isAllSelected = isAllSelected;
        vm.selectAll = selectAll;

        vm.$onInit = function () {
            initializeAppointment();
        }

        angular.element($window).on('resize', checkScreenSize);
        checkScreenSize();

        function isAllSelected() {
            if (!Array.isArray(vm.appointments) || vm.appointments.length <= 0 || !vm.selectedMap) {
                return;
            }

            return vm.appointments.every(function (appointment) {
                return !!appointment && vm.selectedMap[appointment.id_appointment];
            });
        }

        function selectAll() {
            if (!Array.isArray(vm.appointments) || !vm.selectedMap) {
                return;
            }

            const allSelected = isAllSelected();

            vm.appointments.forEach(function (appointment) {
                if (!appointment) {
                    return;
                }

                vm.selectedMap[appointment.id_appointment] = !allSelected;
            });
        }

        function getScheduleUrl(appointment) {
            if (!appointment) {
                return;
            }
            return $state.href("app.workorder-schedule", { goToDate: appointment.start })
        }

        function initializeAppointment() {
            if (vm.appointments && vm.appointments.length > 0) {
                vm.appointments.forEach(function (appointment) {
                    if (!appointment) {
                        return;
                    }
                    appointment.isTitleModified = false;
                });
            }
        }

        vm.onAppointmentDetailChanged = function (appointment) {
            if (!appointment) {
                return;
            }
            appointment.isTitleModified = true;
        }

        vm.updateAppointmentDetail = function (appointment) {
            if (!appointment) {
                return;
            }
            vm.onStatusChanged(appointment)
            appointment.isTitleModified = false;
        }

        function checkScreenSize() {
            vm.isSmallScreen = $window.innerWidth <= 768;

            // Use $timeout to ensure this runs after the current digest cycle
            $timeout(function () {
                if (!$scope.$$phase) {
                    $scope.$apply();
                }
            }, 0);
        }

        $scope.$on('$destroy', function () {
            angular.element($window).off('resize', checkScreenSize);
        });
    }
})();

(function ()
{
	"use strict";

	angular.module("app.components",['textAngular']);

})();
(function ()
{
	"use strict";

	angular
		.module("app.components")
		.component("testDriveList", {
				bindings:{
					testDrives:'=',
					onOptionSelected:'<',
					onRemoveClick:'<',
					onDetailClick:'<',
					disableRemoveButton:'<'
				},
				templateUrl: "app/main/customers/edit-customer/customer-components/test-drive-list.html",
				controller: componentController,
		  		controllerAs: 'vm'
			});

		function componentController(VehicleService, $state, LoginService, $q, GeneralTools, TaskConstants){
			var vm = this;	

			vm.$onInit = initComponent;
			vm.queryVehicles = queryVehicles;
			vm.getUrlForDetailPage = getUrlForDetailPage;
			vm.selectItem = selectItem;
			vm.getTestDriveTime = getTestDriveTime;

			function initComponent (){
				if(vm.testDrives == null){
					vm.testDrives = [];
				}
			}

			function queryVehicles (searchText){
				var resourcePath = {companyID: LoginService.getCompanyID()};

				var filterString = '(' + VehicleService.searchTextFilterBuilder(searchText) + ')';

				/*filterString = GeneralTools.stringConnector(filterString, filterStringBuiler("is_valid", "true"), " AND ");
				filterString = GeneralTools.stringConnector(filterString, filterStringBuiler("is_online", "true"), " AND ");*/
				filterString = GeneralTools.stringConnector(filterString, filterStringBuiler("purchase_info.is_canceled", "false"), " AND ");

				var filters = { 
					filters: filterString,
					isSold: false
				};

				return VehicleService.getVehicle(resourcePath, filters)
					.then(function(result){
						if(result == null || !Array.isArray(result.data)){
							return $q.reject();
						}

						return $q.resolve(result.data);
					})
					.catch(function(error){
						return $q.reject();
					});
			}

			function filterStringBuiler(columnName, value){
				if(typeof(columnName) != "string" || columnName.trim() == '' 
						|| typeof(value) != "string" || value.trim() == ''){
					return '';
				}

				return '(' + columnName + " eq " + value + ')';
			}

			function getUrlForDetailPage(vehicleID){
				var param = {vehicleID:vehicleID};

				return $state.href('app.vehicle.general', param, {absolute: true}); 
			}

			function selectItem(item){
				vm.onOptionSelected(item);

				vm.searchText = null;
			}

			function getTestDriveTime(testDrive){
				return moment(testDrive.date).local().format('YYYY-MM-DD HH:mm:ss')	
			}
		}
})();
(function ()
{
	"use strict";

	angular
		.module("app.customers")
		.component("serviceVehicleList", {
				bindings:{
					serviceMap: '<',
					onVehicleSelect: '<',
					cleanSearchBox:'=',
					isProcessing: '=',
					onRemoveItem: '<',
					notFoundMessage: '<',
					notFoundUrl: '<'
				},
				templateUrl: "app/main/customers/edit-customer/customer-components/service-vehicle-list.html",
				controller: componentController,
		  		controllerAs: 'vm'
			});

		function componentController($q, LoginService, TaskConstants, $state, VehicleService, GeneralTools){
			var vm = this;	
			const companyID = LoginService.getCompanyID();
			vm.$postLink = initOutPutCallbacks;
			vm.getVehicleUrl = getVehicleUrl;
			vm.queryVehicle = queryVehicle;
			vm.selectVehicle = selectVehicle;

			function queryVehicle(){
				if(!vm.searchText){
					return;
				}

				const resourcePath = {
					companyID: companyID
				}
			
				//const searchFilterString = VehicleService.searchTextFilterBuilder(vm.searchText);
				const filter = { filters: VehicleService.searchTextFilterBuilder(vm.searchText)};

				return VehicleService.getVehicle(resourcePath, filter, null, null)
					.then(function(result){
						if(result == null || !Array.isArray(result.data)){
							return $q.reject("result invalid.");
						}

						return $q.resolve(result.data);
					})
			}

			function getVehicleUrl(vehicleID){
				var param = {vehicleID:vehicleID};

				return $state.href('app.vehicle.general', param, {absolute: true}); 
			}

			function selectVehicle(){
				if(!vm.selectedVehicle || typeof(vm.onVehicleSelect) != "function"){
					return;
				}
				vm.onVehicleSelect(vm.selectedVehicle);
			}

			function initOutPutCallbacks(){
				vm.cleanSearchBox = cleanSearchBox;
			}

			function cleanSearchBox(){
				vm.selectedVehicle = null;
				vm.searchText = null;
			}
		}
})();
(function ()
{
	"use strict";

	angular
		.module("app.customers")
		.component("customerPurchasedVehicles", {
				bindings:{
					customerId:'<'
				},
				templateUrl: "app/main/customers/edit-customer/customer-components/purchased-vehicles.html",
				controller: componentController,
		  		controllerAs: 'vm'
			});

		function componentController(TaskConstants, $state, $q, FileUploadService, FileViewService, GeneralTools, MessageService, SaleInfoService, LoginService, VehicleService){
			var vm = this;	
			var companyID = LoginService.getCompanyID()

			vm.$onInit = initComponent;
			vm.dataMap = [];
			vm.getVehicleUrl = getVehicleUrl;
			vm.getSaleInfoUrl = getSaleInfoUrl;

			function initComponent(){
				var resourcePath = {companyID: companyID};
				var filters = {
					filters: "(fk_id_customer eq " + vm.customerId + ")"
				}

				var sorting = {
					sortBy: "sale_date",
					sortDirection: "ASC"
				}
				
				SaleInfoService.getSaleInfos(resourcePath, filters, null, sorting)
					.then(function(saleInfos){
						if(!Array.isArray(saleInfos)){
							return $q.reject("Sale info data is invalid");
						}

						var taskList = [];

						saleInfos.forEach(function(saleInfo){
							taskList.push(fetchVehicle(saleInfo));
						})

						return $q.all(taskList);
					})
					.then(function(){
					})
					.catch(MessageService.showToast);
			}

			function fetchVehicle(saleInfo){
				var defer = $q.defer();

				if(saleInfo == null){
					return $q.reject("Sale info data is invalid");
				}

				var resourcePath = {
					companyID: companyID,
					vehicleID: saleInfo.getVehicleID()
				}

				VehicleService.getVehicle(resourcePath)
					.then(function(response){
						if(response == null || !Array.isArray(response.data)){
							return $q.reject("Vehicle data is invalid");
						}

						vm.dataMap.push({
							vehicleData: response.data[0],
							saleInfoData: saleInfo
						})

						defer.resolve();
					})
					.catch(function(error){
						defer.reject(error);
					})

				return defer.promise;
			}

			function getSaleInfoUrl(vehicle, saleInfo){
				if(vehicle == null || saleInfo == null){
					return;
				}

				var param = {
					vehicleID:vehicle.getResourceID(),
					saleInfoID: saleInfo.getResourceID()
				};

				return $state.href('app.edit-sale-info', param, {absolute: true}); 
			}

			function getVehicleUrl(vehicle){
				if(vehicle == null){
					return;
				}

				var param = {vehicleID:vehicle.getResourceID()};

				return $state.href('app.vehicle.general', param, {absolute: true}); 
			}
		}
})();
(function ()
{
	"use strict";

	angular
		.module("app.customers")
		.component("phoneNumberList", {
				bindings:{
					phoneNumberList:'=',
					phoneCategories:'<',
					isFormValid:'='
				},
				templateUrl: "app/main/customers/edit-customer/customer-components/phone-number-list.html",
				controller: componentController,
		  		controllerAs: 'vm'
			});

		function componentController($scope, MessageService){
			var phoneNumberCheck = new RegExp('^[0-9]{0,20}$');
			var vm = this;

			vm.addNewPhoneNumber = addNewPhoneNumber;
			vm.removePhoneNumber = removePhoneNumber;
			vm.onPhoneNumberCreatorInputChange = onPhoneNumberCreatorInputChange;

			vm.$onInit = function(){
				vm.phoneNumberCreatorValidator = {}
				vm.isAddNewPhoneNumberDisabled = true;

				if(vm.phoneNumberList == null){
					vm.phoneNumberList = [];
				}

				vm.phoneNumberEditorInputOptions = {
					icon: "icon-note-multiple-outline",
					placeholder: "Phone Number",
					required:true,
					invalidPatternMessage:"Only number allowed!",
					inputPattern: new RegExp('^[0-9]*$'),
					maxLength:20
				};

				vm.phoneNumberCreatorInputOptions = {
					icon: "icon-note-multiple-outline",
					placeholder: "New Phone Number"
				};
			}

			function addNewPhoneNumber (){
				var newPhoneNumberObj = {};
				
				if(vm.newPhoneNumber == null  || vm.newPhoneNumber.trim() == '' || !phoneNumberCheck.test(vm.newPhoneNumber)){
					vm.phoneNumberCreatorValidator.isPhoneNumberError = true;
					return;
				}

				newPhoneNumberObj.phone_number = vm.newPhoneNumber.trim();
				newPhoneNumberObj.fk_id_phone_category = vm.newPhoneCategory;
				newPhoneNumberObj.allow_notification = false;
				vm.phoneNumberList.push(newPhoneNumberObj);
			}

			function removePhoneNumber (index){
				vm.phoneNumberList.splice(index, 1);
			}

			function onPhoneNumberCreatorInputChange(inputValue){	
				if(inputValue == null || inputValue.trim() == ''){
					vm.isAddNewPhoneNumberDisabled = true;
					vm.phoneNumberCreatorValidator.isPhoneNumberError = false;
					return;
				}

				if(phoneNumberCheck.test(inputValue)){
					vm.isAddNewPhoneNumberDisabled = false;
					vm.phoneNumberCreatorValidator.isPhoneNumberError = false;
				}else{
					vm.isAddNewPhoneNumberDisabled = true;
					vm.phoneNumberCreatorValidator.isPhoneNumberError = true;
				}	
			}	

			vm.$postLink = function(){
				vm.isFormValid = function(){
					$scope.customerPhoneListForm.$submitted = true;
					return $scope.customerPhoneListForm.$valid;
				};
			}
		}
})();
(function ()
{
	"use strict";

	angular
		.module("app.customers")
		.component("emailList", {
				bindings:{
					emailList:'=',
					emailCategories:'<',
					isFormValid:'='
				},
				templateUrl: "app/main/customers/edit-customer/customer-components/email-list.html",
				controller: componentController,
		  		controllerAs: 'vm'
			});

		function componentController($scope, MessageService, GeneralTools){
			var vm = this;
			vm.addNewEmail = addNewEmail;
			vm.removeEmail = removeEmail;
			vm.onEmailCreatorInputChange = onEmailCreatorInputChange;

			vm.$onInit = function(){
				vm.emailCreatorValidator = {};
				vm.isAddEmailButtonDisabled = true;

				if(vm.emailList == null){
					vm.emailList = [];
				}

				vm.emailEditorInputOptions = {
					icon: "icon-note-multiple-outline",
					placeholder: "Email address",
					required:true,
					invalidPatternMessage:"Invalid email address!",
					inputType:"email",
					maxLength:100
				};

				vm.emailCreatorInputOptions = {
					icon: "icon-note-multiple-outline",
					placeholder: "New Email"
				};
			}

			function addNewEmail (){
				var newEmailObj = {};

				if(vm.newEmail == null || vm.newEmail.trim() == '' || !GeneralTools.isEmailAddressValid(vm.newEmail)){
					vm.emailCreatorValidator.isEmailError = true;
					return;
				}

				newEmailObj.email_address = vm.newEmail.trim();
				newEmailObj.fk_id_email_category = vm.newEmailCategory;
				newEmailObj.allow_notification = false;
				vm.emailList.push(newEmailObj);
			}

			function onEmailCreatorInputChange(inputValue){
				if(inputValue == null || inputValue.trim() == ''){
					vm.isAddEmailButtonDisabled = true;
					vm.emailCreatorValidator.isEmailError = false;
					return;
				}

				if(GeneralTools.isEmailAddressValid(inputValue)){
					vm.isAddEmailButtonDisabled = false;
					vm.emailCreatorValidator.isEmailError = false;
				}else{
					vm.isAddEmailButtonDisabled = true;
					vm.emailCreatorValidator.isEmailError = true;
				}	
			}	

			function removeEmail (index){
				vm.emailList.splice(index, 1);
			}

			vm.$postLink = function(){
				vm.isFormValid = function(){
					$scope.customerEmailListForm.$submitted = true;
					return $scope.customerEmailListForm.$valid;
				};
			}
		}
})();

(function ()
{
	"use strict";

	angular
		.module("app.customers")
		.component("customerInfoForm", {
				bindings:{
					customer:'=',
					constants:'<',
					isFormValid:'='
				},
				templateUrl: "app/main/customers/edit-customer/customer-components/customer-info-form.html",
				controller: componentController,
		  		controllerAs: 'vm'
			});

		function componentController($scope, $filter){
			var vm = this;

			vm.setLicenseExpiryDate = setLicenseExpiryDate;

			vm.$onInit = function(){
				vm.firstNameInputOptions = {
					icon: "icon-note-multiple-outline",
					placeholder: "First Name",
					maxLength:30,
					required:true
				};

				vm.lastNameInputOptions = {
					icon: "icon-note-multiple-outline",
					placeholder: "Last Name",
					maxLength:30,
					required:true
				};

				vm.driverLicenseInputOptions = {
					icon: "icon-note-multiple-outline",
					placeholder: "Driver License",
					invalidPatternMessage:"Only number and charactors allowed!",
					inputPattern: new RegExp('^[a-zA-Z0-9]*$'),
					required:true
				};

				vm.policyNumberInputOptions = {
					icon: "icon-note-multiple-outline",
					placeholder: "Policy Number"
				};

				vm.insuranceCompanyInputOptions = {
					icon: "icon-note-multiple-outline",
					placeholder: "Insurance Company"
				};

				vm.noteInputOptions = {
					icon: "icon-note-multiple-outline",
					placeholder: "Note"
				};	

				if(vm.customer != null){
					vm.resourcePath = vm.customer.getResourcePath();
				}		

				vm.datePickerValue = vm.customer.getLicenseExpiryDateMomentObj();	
			}

			function setLicenseExpiryDate(date){
				vm.customer.setLicenseExpiryDate(moment(date));
			}

			vm.$postLink = function(){
				vm.isFormValid = function(){
					$scope.custormerInfoForm.$submitted = true;
					return $scope.custormerInfoForm.$valid;
				};
			}
		}
})();
(function ()
{
	"use strict";

	angular
		.module("app.customers")
		.component("customerFileUploader", {
				bindings:{
					fileUploader:'=',
					uploadedFiles:'=',
					onDeleteUploadedFileClick:'<',
					onDeleteQueueFileClick:'<',
					onLinkClick:'<'
				},
				templateUrl: "app/main/customers/edit-customer/customer-components/customer-file-uploader.html",
				controller: componentController,
		  		controllerAs: 'vm'
			});

		function componentController(FileUploadService, FileViewService, GeneralTools, MessageService){
			var vm = this;	

			vm.$onInit = initComponent;
			vm.getFileNameLink = getFileNameLink;
			vm.onCopyLinkClick = onCopyLinkClick;

			function initComponent(){
				if(vm.fileUploader == null){
					vm.fileUploader = FileUploadService.getNewUploader();
				}
			}

			function getFileNameLink(file){
				return FileViewService.generateUrlByUUID(file.uuid);
			}

			function onCopyLinkClick(file){
				GeneralTools.copyToClipboard(FileViewService.generateUrlByUUID(file.uuid));
				MessageService.showToast("Copy link to clipboard!")
			}

			
		}
})();
(function ()
{
	"use strict";

	angular
		.module("app.customers")
		.component("customerCreditCardForm", {
				bindings:{
					customerId:'<',
					creditCardList: '=',
					showAddSection: '=',
					customer: '='

				},
				templateUrl: "app/main/customers/edit-customer/customer-components/credit-card.html",
				controller: componentController,
		  		controllerAs: 'vm'
			});

		function componentController($scope, CustomersService, ProgressService, MessageService){
			var vm = this;	
			vm.showAddPaymentMethodBoolean = false;
			vm.$onInit = initComponent;
			vm.creditCardExpiryDate = null;
			vm.card_number = null;
			vm.card_firstname = null;
			vm.card_lastname = null;
			vm.card_address = null;
			vm.card_city = null;
			vm.card_province = null;
			vm.card_postcode = null;
			vm.copyboolean = true
			vm.isDeletingCreditCard = false
			function initComponent(){
			}

			vm.showAddPaymentMethod = function showAddPaymentMethod(){
				vm.showAddPaymentMethodBoolean = !vm.showAddPaymentMethodBoolean 
			}

			vm.onCreditCardNumberChange = function(card_number){
				if(card_number && card_number.length !== 16){
					$scope.customerCreditCardForm.cardNumber.$setValidity('valid', false);
				}else{
					$scope.customerCreditCardForm.cardNumber.$setValidity('valid', true);
				}
			}

			vm.oncreditCardExpiryDateChange = function(creditCardExpiryDate){
				if(creditCardExpiryDate){
					var parts = creditCardExpiryDate.split('/');
					var month = parseInt(parts[0], 10);
					var year = parseInt(parts[1], 10);
				
					var currentDate = new Date();
					var currentYear = currentDate.getFullYear() % 100;
					var currentMonth = currentDate.getMonth() + 1; 
				
					if (year > currentYear || (year === currentYear && month >= currentMonth)) {
						$scope.customerCreditCardForm.creditCardExpiryDate.$setValidity('valid', true);
					} else {
						$scope.customerCreditCardForm.creditCardExpiryDate.$setValidity('valid', false);
					}
				}

			}

			vm.addSlash = function(event) {
				var value = event.target.value;
				if (value.length === 2 && event.charCode >= 48 && event.charCode <= 57) {
					event.target.value = value + '/';
				}
			};

			vm.pullinfoFromCustomer = function(){
				if(vm.customer && vm.customer.first_name){
					vm.card_firstname = vm.customer.first_name;
				}
				
				if(vm.customer && vm.customer.last_name){
					vm.card_lastname = vm.customer.last_name;
				}

				if(vm.customer && vm.customer.address_street_number && vm.customer.address_street){
					vm.card_address = vm.customer.address_street_number + ' ' + vm.customer.address_street; 
				}

				if(vm.customer && vm.customer.address_city){
					vm.card_city = vm.customer.address_city;
				}
				
				if(vm.customer && vm.customer.address_province){
					vm.card_province = vm.customer.address_province;
				}

				if(vm.customer && vm.customer.address_postal_code){
					vm.card_postcode = vm.customer.address_postal_code;
				}

				vm.copyboolean = !vm.copyboolean
			}

			vm.clearCustomerInfo = function(){
				vm.card_firstname = null;
				vm.card_lastname = null;
				vm.card_address = null;
				vm.card_city = null;
				vm.card_province = null;
				vm.card_postcode = null;
				vm.copyboolean = !vm.copyboolean
			}

			vm.addCreditCard = function(){
				if(vm.creditCardExpiryDate == null || vm.card_number == null || vm.card_firstname == null || vm.card_lastname == null){
					return;
				}

				var requestBody = {
					creditCardExpiryDate : vm.creditCardExpiryDate,
					card_number : vm.card_number,
					card_firstname : vm.card_firstname,
					card_lastname : vm.card_lastname,
					card_address : vm.card_address,
					card_city : vm.card_city,
					card_province : vm.card_province,
					card_postcode : vm.card_postcode
				}
				var resourcePath = vm.customer.getResourcePath();
	
				ProgressService.setMode("indeterminate");
				ProgressService.isVisble(true);
	
				vm.isDeletingCreditCard = true;
	
				CustomersService.SaveClientPaymentProfile(requestBody, resourcePath)
						.then(function(creditCardListResponse){
							vm.creditCardList = creditCardListResponse
							MessageService.showToast("Success!");
						})
						.catch(MessageService.showToast)
						.finally(function(){
							ProgressService.isVisble(false);
							vm.isDeletingCreditCard = false;
						});
			}

			vm.deleteCreditCard = function(card){
				if(card.customerProfileID == null || card.paymentProfileID == null){
					return;
				}
				vm.isDeletingCreditCard = true

				var requestBody = {
					customerProfileID : card.customerProfileID,
					paymentProfileID : card.paymentProfileID

				}
				var resourcePath = vm.customer.getResourcePath();
	
				ProgressService.setMode("indeterminate");
				ProgressService.isVisble(true);
	
				CustomersService.deleteClientPaymentProfile(requestBody, resourcePath)
						.then(function(creditCardListResponse){
							vm.creditCardList = creditCardListResponse
							MessageService.showToast("Success!");
						})
						.catch(MessageService.showToast)
						.finally(function(){
							ProgressService.isVisble(false);
							vm.isDeletingCreditCard = false;
						});
			}
		}
})();

(function ()
{
	"use strict";

	angular
		.module("app.customers")
		.component("customerTable", {
				bindings:{
					customersInCurrentPage:'=',
					onSearchParamChange:'<'
				},
				templateUrl: "app/main/customers/browse-customers/customers-table/customers-table.html",
				controller: componentController,
		  		controllerAs: 'vm'
			});

		function componentController($state, $scope, $filter, $stateParams, CustomersService, LoginService, MessageService, CustomerConstants, ProgressService, Customer, GeneralTools){
			var vm = this;
			var numberPattern = new RegExp('^[0-9]*$');
			var firstNameKeyName = "first_name";
			var lastNameKeyName = "last_name";
			var phoneNumberKeyName = "phone_number";
			var emailKeyName = "email_address";

			vm.translateToPhoneNumber = GeneralTools.inputTranslators.phoneNumber;
			
			vm.displayOptions = [10, 25, 50, 100];

			vm.$onInit = initComponent;

			vm.goToPage = goToPage;
			vm.onItemsPerPageChange = onItemsPerPageChange;
			vm.onSearchTextChange = onSearchTextChange;

			vm.getCustomerFullName = getCustomerFullName;
			vm.getCustomerEmailAddress = getCustomerEmailAddress;
			vm.getCustomerDriverLicense = getCustomerDriverLicense;
			vm.getCustomerPhoneNumber = getCustomerPhoneNumber;
			vm.getCustomerPageUrl = getCustomerPageUrl;
			vm.createCustomerByPhoneNumber = createCustomerByPhoneNumber;

			vm.setSorting = setSorting;

			function initComponent(){			
				initPagination();
				initSorting();
				initFilters();
				resetTable();
				$scope.$on('$locationChangeSuccess', syncFromUrlParams);
			}

			function syncFromUrlParams(){
				if ($state.current.name !== 'app.customers') {
					return;
				}

				var params = $stateParams;
				var nextPage = params.page ? parseInt(params.page, 10) : CustomerConstants.defaultPage;
				var nextLimit = params.limit ? parseInt(params.limit, 10) : vm.pagination.limit;
				var nextSortBy = params.sortBy || vm.sorting.sortBy;
				var nextSortDirection = params.sortDirection
					? params.sortDirection.toUpperCase()
					: vm.sorting.sortDirection;

				if (
					params.firstName === vm.firstNameSearchText &&
					params.lastName === vm.lastNameSearchText &&
					params.phoneNumber === vm.phoneNumberSearchText &&
					params.email === vm.emailSearchText &&
					nextPage === vm.pagination.page &&
					nextLimit === vm.pagination.limit &&
					nextSortBy === vm.sorting.sortBy &&
					nextSortDirection === vm.sorting.sortDirection
				) {
					return;
				}

				vm.firstNameSearchText = params.firstName;
				vm.lastNameSearchText = params.lastName;
				vm.phoneNumberSearchText = params.phoneNumber;
				vm.emailSearchText = params.email;
				vm.pagination.page = nextPage;
				vm.pagination.limit = nextLimit;
				vm.itemsPerPage = nextLimit;
				vm.sorting.sortBy = nextSortBy;
				vm.sorting.sortDirection = nextSortDirection;

				buildFilter();
				resetTable();
			}

			function initFilters(){
				vm.firstNameSearchText = $stateParams.firstName;
				vm.lastNameSearchText = $stateParams.lastName;
				vm.phoneNumberSearchText = $stateParams.phoneNumber;
				vm.emailSearchText = $stateParams.email;

				buildFilter();
			}

			function controlCustomerButtonVisible (){
				if((vm.firstNameSearchText || vm.lastNameSearchText || vm.phoneNumberSearchText || vm.emailSearchText) && vm.customersInCurrentPage.length <= 0 ){
					vm.isCreateCustomerButtonVisible = true;
				}else{
					vm.isCreateCustomerButtonVisible = false;
				}
			}

			function initSorting(){
				vm.sorting = {
					sortBy: CustomerConstants.defaultSortBy,
					sortDirection: CustomerConstants.defaultSortDirection
				}

				if($stateParams.sortBy != null){
					vm.sorting.sortBy = $stateParams.sortBy;
				}

				if($stateParams.sortDirection != null){
					vm.sorting.sortDirection = $stateParams.sortDirection.toUpperCase();
				}
			}

			function initPagination(){
				vm.pagination = {
					page: CustomerConstants.defaultPage,
					limit: CustomerConstants.defaultLimitPerPage
				}

				if($stateParams.page){
					vm.pagination.page = $stateParams.page;
				}

				if($stateParams.limit){
					vm.pagination.limit = $stateParams.limit;
				}else{
					vm.pagination.limit = vm.displayOptions[0];
				}

				vm.itemsPerPage = parseInt(vm.pagination.limit);
			}

			function filterStringBuiler(columnName, value){
				if(!columnName|| !columnName.trim() || !value || !value.trim()){
					return '';
				}

				return "contains(" + columnName + ",'" + value + "')";
			}

			function onSearchTextChange(){
				buildFilter();
				goToPage(1);

				if(vm.onSearchParamChange){
					vm.onSearchParamChange(getCurrentSearchParam());
				}
			}

			function getCurrentSearchParam(){
				const filterParam = {
					firstName: vm.firstNameSearchText,
					lastName: vm.lastNameSearchText,
					email: vm.emailSearchText,
					phoneNumber: vm.phoneNumberSearchText
				}

				return Object.assign(filterParam, vm.pagination, vm.sorting);
			}

			function buildFilter(){
				if(!vm.customerFilters){
					vm.customerFilters = {};
				}

				var firstNameFilter 	= filterStringBuiler(firstNameKeyName, vm.firstNameSearchText);
				var lastNameFilter 		= filterStringBuiler(lastNameKeyName, vm.lastNameSearchText);
				var phoneNumberFilter 	= filterStringBuiler(phoneNumberKeyName, vm.phoneNumberSearchText);

				var emailFilter = '';

				if(vm.emailSearchText){
					var atIndex = vm.emailSearchText.indexOf('@');
					var endIndex = atIndex == -1? vm.emailSearchText.length:atIndex;
					emailFilter	= filterStringBuiler(emailKeyName, vm.emailSearchText.substring(0, endIndex));					
				}
				
				vm.customerFilters.filters = ''

				vm.customerFilters.filters = GeneralTools.stringConnector(vm.customerFilters.filters, firstNameFilter, " AND ");
				vm.customerFilters.filters = GeneralTools.stringConnector(vm.customerFilters.filters, lastNameFilter, " AND ");
				vm.customerFilters.filters = GeneralTools.stringConnector(vm.customerFilters.filters, phoneNumberFilter, " OR ");
				vm.customerFilters.filters = GeneralTools.stringConnector(vm.customerFilters.filters, emailFilter, " OR ");
			}

			function onItemsPerPageChange(){
				vm.pagination.limit = vm.itemsPerPage;
				goToPage(1);

				if(vm.onSearchParamChange){
					vm.onSearchParamChange(getCurrentSearchParam());
				}
			}

			function setSorting(sortingName){
				if(vm.sorting.sortBy != sortingName){
					vm.sorting.sortBy = sortingName;
					vm.sorting.sortDirection = "ASC";
				}else{
					reverseSortDirection();
				}

				resetTable();

				if(vm.onSearchParamChange){
					vm.onSearchParamChange(getCurrentSearchParam());
				}
			}

			function reverseSortDirection(){
				if(vm.sorting.sortDirection == "ASC"){
					vm.sorting.sortDirection = "DESC";
				}else{
					vm.sorting.sortDirection = "ASC";
				}
			}

			function resetTable(){
				var resourcePath = {
					companyID: LoginService.getCompanyID()
				}

				ProgressService.setMode("indeterminate");
				ProgressService.isVisble(true);

				CustomersService.getCustomers(resourcePath, vm.customerFilters, vm.pagination, vm.sorting)
					.then(function(response){
						vm.customersInCurrentPage = response.data;
						resetPaginationUI(extractPaginationFromResponseHeader(response.headerGetter));
						ProgressService.isVisble(false);
						controlCustomerButtonVisible();
					})
					.catch(function(error){
						ProgressService.isVisble(false);
						MessageService.showToast(error)
					});
			}

			function extractPaginationFromResponseHeader(headerGetter){
				var pagination = {};

				pagination.currentPage = parseInt(headerGetter("pagination-page"));
				pagination.totalItem = parseInt(headerGetter("pagination-total-item"));
				pagination.itemsPerPage = parseInt(headerGetter("pagination-limit"));

				return pagination;
			}

			function resetPaginationUI(pagination){
				vm.totalCustomerFound = pagination.totalItem;
				vm.totalPage = Math.ceil(pagination.totalItem / pagination.itemsPerPage);

				vm.currentPage = pagination.currentPage;

				vm.pagesBeforeCurrentPage = getPagesBeforeCurrentPage(vm.currentPage);
				vm.pagesAfterCurrentPage = getPagesAfterCurrentPage(vm.totalPage, vm.currentPage);
			}

			function goToPage(pageNumber){		
				vm.pagination.page = pageNumber;
				vm.pagination.limit = vm.itemsPerPage;

				resetTable();

				if(vm.onSearchParamChange){
					vm.onSearchParamChange(getCurrentSearchParam());
				}
			}

			function getPagesBeforeCurrentPage (currentPage) {
				var pageNumbers = [];

				for(var i = 5; i > 0; i--){
					var pageNumber = currentPage - i;
					if( pageNumber > 0){
						pageNumbers.push(pageNumber);
					}
				}

				return pageNumbers;
			}

			function getPagesAfterCurrentPage (tatalPages, currentPage) {
				var pageNumbers = [];

				for(var i = 1; i <= 5; i++){
					var pageNumber = currentPage + i;
					if( pageNumber <= tatalPages){
						pageNumbers.push(pageNumber);
					}
				}
				return pageNumbers;
			}	

			function getCustomerFullName (customer){
				if((customer.first_name == null || customer.first_name.trim() == '') 
					&& (customer.last_name == null || customer.last_name.trim() == '')){
					return "Unknown";
				}

				return customer.first_name + ' ' + customer.last_name;
			}	

			function getCustomerDriverLicense (customer){
				if(customer.drivers_license == null || customer.drivers_license.trim() == ''){
					return "Unknown";
				}

				return customer.drivers_license;
			}	
			

			function getCustomerEmailAddress(customer){
				if(!Array.isArray(customer.emails) || customer.emails.length <= 0){
					return ''
				}

				return customer.emails[0].email_address;
			}

			function getCustomerPhoneNumber(customer){
				if(!Array.isArray(customer.phone_numbers) || customer.phone_numbers.length <= 0){
					return ''
				}

				return GeneralTools.stringToPhoneNumberString(customer.phone_numbers[0].phone_number);
			}

			function getCustomerPageUrl (customer){
				var param = {customerID:customer.getResourceID()};

				return $state.href('app.view-customer', param, {absolute: true}); 
			}	

			function createCustomerByPhoneNumber(){
				var newCustomer = new Customer();
				var params = {};

				if(vm.phoneNumberSearchText != null){
					newCustomer.addPhoneNumber({phone_number: vm.phoneNumberSearchText, fk_id_phone_category: CustomerConstants.phoneCategories.mobile});
				}

				if(vm.emailSearchText != null){
					newCustomer.addEmail({email_address: vm.emailSearchText});
				}

				if(vm.firstNameSearchText != null){
					newCustomer.first_name = vm.firstNameSearchText;
				}

				if(vm.lastNameSearchText != null){
					newCustomer.last_name = vm.lastNameSearchText;
				}
				
				params.newCustomer = newCustomer;

				$state.go("app.add-customer", params);
			}
		}
})();
(function () {
	'use strict';

	angular
		.module('app.workOrders', ['app.goto'])
		.constant("WorkOrderConstants", {
			businessHours: [
				{
					daysOfWeek: [1, 2, 3, 4],
					startTime: '9:00',
					endTime: '19:00',
					format: "HH:mm"
				},
				{
					daysOfWeek: [5],
					startTime: '9:00',
					endTime: '18:00',
					format: "HH:mm"
				},
				{
					daysOfWeek: [6],
					startTime: '9:00',
					endTime: '17:00',
					format: "HH:mm"
				}
			],
			keyNames: {
				invoiceNumber: "invoice_number",
				status: "work_order.fk_id_work_order_status",
				priority: "work_order.fk_id_work_order_priority"
			},
			dateFormat: "YYYY-MM-DD",
			dateTimeFormat: "YYYY-MM-DD[T]HH:mm:ss[Z]",
			anchorTags: {
				general: "generalAnchorTag",
				extra: "extraTag",
				parts: "partsAnchorTag",
				labors: "laborsAnchorTag",
				discounts: "discountsAnchorTag",
				payments: "paymentsAnchorTag",
				miscfees: "miscfeestag",
				packages: "packagestag",
				warranty: "warrantytag"
			},
			anchorEventName: "onAnchorClicked",
			statusIDs: {
				quoted: 1,
				declined: 2,
				completedEleswhere: 3,
				completed: 4,
				booked: 5,
				onlot: 6,
				started: 7
			},
			calendarViews: {
				timeGridDay: "timeGridDay",
				timeGridWeek: "timeGridWeek",
				dayGridMonth: "dayGridMonth"
			},
			editWorkOrderEvents: {
				updateSummary: {
					eventName: "editWorkOrderEventsUpdateSummary",
					updateDetails: {
						workOrder: "workOrder",
						parts: "parts",
						inventories: "inventories",
						labors: "labors",
						miscfees: "miscfees",
						workorderpackagelist: "workorderpackagelist",
						workorderwarrantylist: "workorderwarrantylist",
						discounts: "discounts",
						payments: "payments",
						demandMap: "demandMap",
						workOrderRogerDollarGenerated: "workOrderRogerDollarGenerated",
						workOrderRogerDollarRedeemed: "workOrderRogerDollarRedeemed"
					}
				},
				scroll: {
					eventName: "editWorkOrderEventsScroll"
				},
				unsavedChangesCheck: {
					eventName: "editWorkOrderEventsUnsavedChangesCheck"
				},
				controlSensitiveContent: {
					eventName: "editWorkOrderEventsControlSensitiveContent"
				}
			},
			newPurchaseDefaultWorkOrderNote: "New Car Oil Change",
			scheduleDateFormat: "EEE, MMM d, h:mm a"
		})
		.config(config)

	/** @ngInject */
	function config($stateProvider) {
		$stateProvider
			.state('app.browse-workorder', {
				url: '/workorders?invoiceNumber&status&priority&location&isAvailable&sortBy&sortDirection&limit&page',
				reloadOnSearch: false,
				views: {
					'content@app': {
						templateUrl: 'app/main/workorders/browse-workorders/browse-workorders.html',
						controller: 'BrowseWorkOrderController as vm'
					}
				},
				resolve: {
					constants: function (MessageService, $q, WorkOrderService, LoginService, VehicleService) {
						const queue = {
							workOrderStatus: WorkOrderService.getCachedWorkOrderStatus(),
							workOrderPriorities: WorkOrderService.getCachedWorkOrderPriorities(),
							locations: VehicleService.getCachedLocations({ companyID: LoginService.getCompanyID() })
						}

						return $q.all(queue).catch(MessageService.showToast);
					},
					userConfig: function ($q, LoginService, UserConfigService, MessageService) {

						const resourcePath = {
							companyID: LoginService.getCompanyID(),
							userID: LoginService.getUserID()
						};

						return UserConfigService.getUserConfig(resourcePath).catch(MessageService.showToast);
					}
				}
			})
			.state('app.browse-outstanding-workorder', {
				url: '/outstandingworkorders?invoiceNumber&status&priority&location&isAvailable&sortBy&sortDirection&limit&page',
				reloadOnSearch: false,
				views: {
					'content@app': {
						templateUrl: 'app/main/workorders/browse-outstanding-workorders/browse-outstanding-workorders.html',
						controller: 'BrowseOutstandingWorkOrderController as vm'
					}
				},
				resolve: {
					constants: function (MessageService, $q, WorkOrderService, LoginService, VehicleService) {
						const queue = {
							workOrderStatus: WorkOrderService.getCachedWorkOrderStatus(),
							workOrderPriorities: WorkOrderService.getCachedWorkOrderPriorities(),
							locations: VehicleService.getCachedLocations({ companyID: LoginService.getCompanyID() })
						}

						return $q.all(queue).catch(MessageService.showToast);
					},
					userConfig: function ($q, LoginService, UserConfigService, MessageService) {

						const resourcePath = {
							companyID: LoginService.getCompanyID(),
							userID: LoginService.getUserID()
						};

						return UserConfigService.getUserConfig(resourcePath).catch(MessageService.showToast);
					}
				}
			})

			.state('app.browse-part-appointment-workorder', {
				url: '/partappointmentworkorders?invoiceNumber&status&priority&location&isAvailable&sortBy&sortDirection&limit&page',
				reloadOnSearch: false,
				views: {
					'content@app': {
						templateUrl: 'app/main/workorders/browse-part-appointment-workorders/browse-part-appointment-workorders.html',
						controller: 'BrowsePartAppointmentWorkOrderController as vm'
					}
				},
				resolve: {
					constants: function (MessageService, $q, WorkOrderService, LoginService, VehicleService) {
						const queue = {
							workOrderStatus: WorkOrderService.getCachedWorkOrderStatus(),
							workOrderPriorities: WorkOrderService.getCachedWorkOrderPriorities(),
							locations: VehicleService.getCachedLocations({ companyID: LoginService.getCompanyID() })
						}

						return $q.all(queue).catch(MessageService.showToast);
					},
					userConfig: function ($q, LoginService, UserConfigService, MessageService) {

						const resourcePath = {
							companyID: LoginService.getCompanyID(),
							userID: LoginService.getUserID()
						};

						return UserConfigService.getUserConfig(resourcePath).catch(MessageService.showToast);
					}
				}
			})

			.state('app.browse-part-no-appointment-workorder', {
				url: '/partnoappointmentworkorders?invoiceNumber&status&priority&location&isAvailable&sortBy&sortDirection&limit&page',
				reloadOnSearch: false,
				views: {
					'content@app': {
						templateUrl: 'app/main/workorders/browse-part-no-appointment-workorders/browse-part-no-appointment-workorders.html',
						controller: 'BrowsePartNoAppointmentWorkOrderController as vm'
					}
				},
				resolve: {
					constants: function (MessageService, $q, WorkOrderService, LoginService, VehicleService) {
						const queue = {
							workOrderStatus: WorkOrderService.getCachedWorkOrderStatus(),
							workOrderPriorities: WorkOrderService.getCachedWorkOrderPriorities(),
							locations: VehicleService.getCachedLocations({ companyID: LoginService.getCompanyID() })
						}

						return $q.all(queue).catch(MessageService.showToast);
					},
					userConfig: function ($q, LoginService, UserConfigService, MessageService) {

						const resourcePath = {
							companyID: LoginService.getCompanyID(),
							userID: LoginService.getUserID()
						};

						return UserConfigService.getUserConfig(resourcePath).catch(MessageService.showToast);
					}
				}
			})

			.state('app.browse-warranty-workorder', {
				url: '/warrantyworkorders?invoiceNumber&status&priority&location&isAvailable&sortBy&sortDirection&limit&page',
				reloadOnSearch: false,
				views: {
					'content@app': {
						templateUrl: 'app/main/workorders/browse-warranty-workorders/browse-warranty-workorders.html',
						controller: 'BrowseWarrantyWorkOrderController as vm'
					}
				},
				resolve: {
					constants: function (MessageService, $q, WorkOrderService, LoginService, VehicleService) {
						const queue = {
							workOrderStatus: WorkOrderService.getCachedWorkOrderStatus(),
							workOrderPriorities: WorkOrderService.getCachedWorkOrderPriorities(),
							locations: VehicleService.getCachedLocations({ companyID: LoginService.getCompanyID() })
						}

						return $q.all(queue).catch(MessageService.showToast);
					},
					userConfig: function ($q, LoginService, UserConfigService, MessageService) {

						const resourcePath = {
							companyID: LoginService.getCompanyID(),
							userID: LoginService.getUserID()
						};

						return UserConfigService.getUserConfig(resourcePath).catch(MessageService.showToast);
					}
				}
			})

			.state('app.browse-pending-workorder', {
				url: '/pendingworkorders?invoiceNumber&status&priority&location&isAvailable&sortBy&sortDirection&limit&page',
				reloadOnSearch: false,
				views: {
					'content@app': {
						templateUrl: 'app/main/workorders/browse-pending-workorders/browse-pending-workorders.html',
						controller: 'BrowsePendingWorkOrderController as vm'
					}
				},
				resolve: {
					constants: function (MessageService, $q, WorkOrderService, LoginService, VehicleService) {
						const queue = {
							workOrderStatus: WorkOrderService.getCachedWorkOrderStatus(),
							workOrderPriorities: WorkOrderService.getCachedWorkOrderPriorities(),
							locations: VehicleService.getCachedLocations({ companyID: LoginService.getCompanyID() })
						}

						return $q.all(queue).catch(MessageService.showToast);
					},
					userConfig: function ($q, LoginService, UserConfigService, MessageService) {

						const resourcePath = {
							companyID: LoginService.getCompanyID(),
							userID: LoginService.getUserID()
						};

						return UserConfigService.getUserConfig(resourcePath).catch(MessageService.showToast);
					}
				}
			})

			.state('app.edit-workorder', {
				url: '/vehicle/{vehicleID}/workorder/{workOrderID}',
				reloadOnSearch: false,
				views: {
					'content@app': {
						templateUrl: 'app/main/workorders/edit-workorder/edit-workorder.html',
						controller: 'EditWorkOrderController as vm'
					}
				},
				resolve: {
					vehicle: function ($q, MessageService, VehicleService, LoginService, $stateParams) {
						const resourcePath = {
							companyID: LoginService.getCompanyID(),
							vehicleID: $stateParams.vehicleID
						};

						return VehicleService.getVehicle(resourcePath).catch(MessageService.showToast);
					},
					workOrder: function ($q, MessageService, WorkOrderService, LoginService, $stateParams) {
						const resourcePath = {
							companyID: LoginService.getCompanyID(),
							vehicleID: $stateParams.vehicleID,
							workorderID: $stateParams.workOrderID
						};

						return WorkOrderService.getWorkOrders(resourcePath).$promise.catch(MessageService.showToast);
					},
					parts: function ($q, RoleCheckService, MessageService, WorkOrderService, LoginService, $stateParams) {
						const resourcePath = {
							companyID: LoginService.getCompanyID(),
							vehicleID: $stateParams.vehicleID,
							workorderID: $stateParams.workOrderID
						};

						return WorkOrderService.getWorkOrderParts(resourcePath).$promise.catch(MessageService.showToast);
					},
					inventories: function ($q, RoleCheckService, MessageService, WorkOrderService, LoginService, $stateParams) {
						const resourcePath = {
							companyID: LoginService.getCompanyID(),
							vehicleID: $stateParams.vehicleID,
							workorderID: $stateParams.workOrderID
						};

						return WorkOrderService.getWorkOrderInventories(resourcePath).$promise.catch(MessageService.showToast);
					},
					labors: function ($q, MessageService, WorkOrderService, LoginService, $stateParams) {
						const resourcePath = {
							companyID: LoginService.getCompanyID(),
							vehicleID: $stateParams.vehicleID,
							workorderID: $stateParams.workOrderID
						};

						return WorkOrderService.getLabors(resourcePath).$promise.catch(MessageService.showToast);
					},
					miscfeestypes: function ($q, MessageService, WorkOrderService, LoginService, $stateParams) {
						const resourcePath = {
							companyID: LoginService.getCompanyID(),
							vehicleID: $stateParams.vehicleID,
							workorderID: $stateParams.workOrderID
						};

						return WorkOrderService.getMiscfeestype(resourcePath).$promise.catch(MessageService.showToast);
					},

					workorderpackagelist: function ($q, MessageService, WorkOrderService, LoginService, $stateParams) {
						const resourcePath = {
							companyID: LoginService.getCompanyID(),
							vehicleID: $stateParams.vehicleID,
							workorderID: $stateParams.workOrderID
						};
						return WorkOrderService.getWorkOrderPackages(resourcePath).$promise.catch(MessageService.showToast);
					},

					workorderpaymentstatus: function (MessageService, WorkOrderService) {
						return WorkOrderService.getWorkorderPaymentStatus().$promise.catch(MessageService.showToast);
					},

					jobtypes: function ($q, MessageService, WorkOrderService, LoginService, $stateParams) {
						const resourcePath = {
							companyID: LoginService.getCompanyID(),
							// vehicleID: $stateParams.vehicleID,
							// workorderID: $stateParams.workOrderID
						};

						return WorkOrderService.getJobtypes(resourcePath).$promise.catch(MessageService.showToast);
					},

					workorderWarranty: function ($q, MessageService, WorkOrderService, LoginService, $stateParams) {
						const resourcePath = {
							companyID: LoginService.getCompanyID(),
							vehicleID: $stateParams.vehicleID,
							workorderID: $stateParams.workOrderID
						};
						return WorkOrderService.getWorkOrderWarranties(resourcePath).$promise.catch(MessageService.showToast);
					},

					workorderWarrantyOption: function ($q, MessageService, WorkOrderService, LoginService, $stateParams) {
						const resourcePath = {
							companyID: LoginService.getCompanyID(),
						};

						return WorkOrderService.getWorkOrderWarrantyOptions(resourcePath).catch(MessageService.showToast);
					},

					discounts: function ($q, RoleCheckService, MessageService, WorkOrderService, LoginService, $stateParams) {
						const resourcePath = {
							companyID: LoginService.getCompanyID(),
							vehicleID: $stateParams.vehicleID,
							workorderID: $stateParams.workOrderID,
						};

						return WorkOrderService.getDiscounts(resourcePath).$promise.catch(MessageService.showToast);
					},

					workOrderCoupons: function ($q, RoleCheckService, MessageService, WorkOrderService, LoginService, $stateParams) {
						const resourcePath = {
							companyID: LoginService.getCompanyID(),
							vehicleID: $stateParams.vehicleID,
							workorderID: $stateParams.workOrderID,
						};
						//return []
						return WorkOrderService.getCoupons(resourcePath).$promise.catch(MessageService.showToast);
					},

					workOrderRDGenerated: function ($q, RoleCheckService, MessageService, WorkOrderService, LoginService, $stateParams) {
						const resourcePath = {
							companyID: LoginService.getCompanyID(),
							vehicleID: $stateParams.vehicleID,
							workorderID: $stateParams.workOrderID
						};

						return WorkOrderService.getgeneratedRD(resourcePath).$promise.catch(MessageService.showToast);
					},

					workOrderRDRedeemed: function ($q, RoleCheckService, MessageService, WorkOrderService, LoginService, $stateParams) {
						const resourcePath = {
							companyID: LoginService.getCompanyID(),
							vehicleID: $stateParams.vehicleID,
							workorderID: $stateParams.workOrderID
						};

						return WorkOrderService.getredeemedRD(resourcePath).$promise.catch(MessageService.showToast);
					},


					payments: function ($q, RoleCheckService, MessageService, WorkOrderService, LoginService, $stateParams) {
						const resourcePath = {
							companyID: LoginService.getCompanyID(),
							vehicleID: $stateParams.vehicleID,
							workorderID: $stateParams.workOrderID
						};

						return WorkOrderService.getPayments(resourcePath).$promise.catch(MessageService.showToast);
					},
					sharedConstants: function (MessageService, $q, WorkOrderService, LoginService, SaleInfoService, CustomersService) {
						const resourcePath = { companyID: LoginService.getCompanyID() };
						const queue = {
							workOrderStatus: WorkOrderService.getCachedWorkOrderStatus(),
							workOrderPriorities: WorkOrderService.getCachedWorkOrderPriorities(),
							paymentMethods: SaleInfoService.getCachedPaymentMethods(),
							phoneCategories: CustomersService.getCachedPhoneCategories(),
							paymentStatus: SaleInfoService.getCachedPaymentMethods()
						}

						return $q.all(queue).catch(MessageService.showToast);
					},
					workOrderJob: function ($q, RoleCheckService, MessageService, WorkOrderService, LoginService, $stateParams) {
						const resourcePath = {
							companyID: LoginService.getCompanyID(),
							vehicleID: $stateParams.vehicleID,
							workorderID: $stateParams.workOrderID
						};

						return WorkOrderService.getWorkOrderJob(resourcePath).$promise.catch(MessageService.showToast);
					},

					customers: function (ToolsConstants, RoleCheckService, $stateParams, LoginService, GeneralTools, $q, WorkOrderService, SaleInfoService, CustomersService, MessageService) {
						const companyID = LoginService.getCompanyID();
						const serviceMapResourcePath = {
							companyID: companyID
						};
						const saleInfoResourcePath = {
							companyID: companyID,
							vehicleID: $stateParams.vehicleID
						};

						const vehicleFilter = GeneralTools.equalFilterBuilder("fk_id_vehicle", $stateParams.vehicleID);
						const saleInfoCanceledFilter = GeneralTools.equalFilterBuilder("sale_info.is_canceled", false);

						const serviceMapfilter = {
							filters: vehicleFilter
						}

						const saleInfoFitler = {
							filters: GeneralTools.stringConnector(vehicleFilter, saleInfoCanceledFilter, ToolsConstants.apiFilters.andConnector)
						}

						const sorting = {
							sortBy: "sale_info.sale_date",
							sortDirection: ToolsConstants.apiSortingDirections.DESC
						}

						var serviceMap;

						return $q.all({
							serviceMap: WorkOrderService.getAllMatchedServiceMaps(serviceMapResourcePath, serviceMapfilter),
							saleInfos: SaleInfoService.getSaleInfos(saleInfoResourcePath, saleInfoFitler, null, sorting)
						})
							.then(function (result) {
								if (!result || !Array.isArray(result.serviceMap) || !Array.isArray(result.saleInfos)) {
									return $q.reject("Failed to fetch serviceMap/saleInfos data.");
								}

								serviceMap = result.serviceMap;
								const queue = {};

								if (result.saleInfos[0] && !queue[result.saleInfos[0].fk_id_customer]) {
									const resourcePath = {
										companyID: companyID,
										customerID: result.saleInfos[0].fk_id_customer
									};

									queue[result.saleInfos[0].fk_id_customer] = CustomersService.getCustomers(resourcePath);
								}

								return $q.all(queue);
							})
							.then(function (result) {
								if (!result) {
									return $q.reject("Failed to build customer list.");
								}

								const customers = [];

								Object.keys(result).forEach(function (customerID) {
									if (result[customerID] && Array.isArray(result[customerID].data) && result[customerID].data[0]) {
										customers.push({
											id_customer: customerID,
											first_name: result[customerID].data[0].first_name,
											last_name: result[customerID].data[0].last_name,
											rogerDollarAvaliable: result[customerID].data[0].rogerDollarAvaliable,
											email_address: result[customerID].data[0].emails
										});
									}
								});

								serviceMap.forEach(function (item) {
									if (item && item.customer && !result[item.customer.id_customer]) {
										var name = item.customer.first_name;
										customers.push({
											id_customer: item.customer.id_customer,
											first_name: item.customer.first_name,
											last_name: item.customer.last_name,
											rogerDollarAvaliable: item.customer.rogerDollarAvaliable,
											email_address: item.customer.emails,
											work_order_filter_end: item.customer.work_order_filter_end,
											work_order_filter_start: item.customer.work_order_filter_start,
										});
									}
								});
								return $q.resolve(customers);
							})
							.catch(MessageService.showToast);
					}
				}
			})
			.state('app.edit-workorder.general', {
				url: '/general',
				reloadOnSearch: false,
				views: {
					'childPage@app.edit-workorder': {
						templateUrl: 'app/main/workorders/edit-workorder/edit-workorder-general.html',
						controller: 'EditWorkOrderGeneralController as vm'
					}
				},
				resolve: {
					mechanics: function (MessageService, WorkOrderService, LoginService, $stateParams) {
						const resourcePath = {
							companyID: LoginService.getCompanyID(),
							vehicleID: $stateParams.vehicleID,
							workorderID: $stateParams.workOrderID
						};

						return WorkOrderService.getMechanics(resourcePath).catch(MessageService.showToast);
					},
					constants: function (AppointmentsService, MessageService, InventoryService, $q, WorkOrderService, LoginService, SaleInfoService, PurchaseInvoiceService) {
						const resourcePath = { companyID: LoginService.getCompanyID() };
						const queue = {
							partTypes: InventoryService.getInventoryTypes(),
							suggestedLaborPrice: WorkOrderService.getCachedSuggestedLaborPrice(resourcePath),
							suppliers: PurchaseInvoiceService.getCachedSuppliers(resourcePath),
							appointmentStatus: AppointmentsService.getCachedAppointmentStatus()
						}

						return $q.all(queue).catch(MessageService.showToast);
					},
					appointments: function (MessageService, WorkOrderService, LoginService, $stateParams, GeneralTools) {
						const resourcePath = { companyID: LoginService.getCompanyID() };
						const filter = { filters: GeneralTools.equalFilterBuilder("fk_id_work_order", $stateParams.workOrderID) };
						const sorting = {
							sortBy: "start",
							sortDirection: "DESC", 
							workOrderAppointmentBoolean: true
						}

						return WorkOrderService.getAllMatchedAppointments(resourcePath, filter, sorting).catch(MessageService.showToast);
					},
					customerserviceMap: function (WorkOrderService, MessageService, LoginService, $stateParams, GeneralTools) {
						const resourcePath = {
							companyID: LoginService.getCompanyID()
						};

						const filter = {
							filters: GeneralTools.equalFilterBuilder("fk_id_vehicle", $stateParams.vehicleID)
						}

						return WorkOrderService.getAllMatchedServiceMaps(resourcePath, filter).catch(MessageService.showToast);
					},
					customersaleInfos: function ($stateParams, SaleInfoService, MessageService, LoginService, $q) {
						if (!LoginService.getUserStatus() || !LoginService.getUserStatus().isLogin) {
							return $q.resolve();
						}

						var resourcePath = {
							companyID: LoginService.getCompanyID(),
							vehicleID: $stateParams.vehicleID
						};

						return SaleInfoService.getVehicleSaleInfos(resourcePath).catch(MessageService.showToast);
					},
					workOrderCustomerPortalAppointments: function (MessageService, AppointmentsService, LoginService, GeneralTools, AppointmentConstants, $stateParams, ToolsConstants) {
						const resourcePath = {
							companyID: LoginService.getCompanyID()
						};

						var calendarFilter = GeneralTools.equalFilterBuilder("fk_id_work_order", $stateParams.workOrderID);
						var timeRangeFilter = GeneralTools.equalRangeFilterBuilder("start", moment().startOf('day').utc().format("YYYY-MM-DD HH:mm:ss"), moment().add(7, 'years').utc().format("YYYY-MM-DD HH:mm:ss"));
						timeRangeFilter = GeneralTools.addBracketToString(timeRangeFilter);
						calendarFilter = GeneralTools.addBracketToString(calendarFilter);
						var filterString = GeneralTools.notEqualFilterBuilder(AppointmentConstants.keyNames.appointmentStatus, AppointmentConstants.statusIDs.CANCELLED);
						filterString = GeneralTools.stringConnector(filterString, calendarFilter, ToolsConstants.apiFilters.andConnector);
						var filter = { filters: filterString };
						return AppointmentsService.getAllMatchedCustomerPortalAppointments(resourcePath, filter);
					},
					presetPackages: function (PresetPackagesService, LoginService, MessageService) {
						const resourcePath = {
							companyID: LoginService.getCompanyID()
						};

						return PresetPackagesService.getPresetPackages(resourcePath).$promise.catch(MessageService.showToast);
					},
					SalePackage: function($stateParams, SaleInfoService, MessageService, LoginService, $q) {
						if (!LoginService.getUserStatus() || !LoginService.getUserStatus().isLogin) {
						  return $q.resolve();
						}
					  
						var resourcePath = {
						  companyID: LoginService.getCompanyID(),
						  vehicleID: $stateParams.vehicleID
						};
					  
						return SaleInfoService.getVehicleSaleInfos(resourcePath)
						  .then(function (result) {
							if (!Array.isArray(result) || !result || result[0] == undefined) {
								return $q.all(Object.values({}));
							} else {
							  var saleInfoID = result[0].id_sale_info;
							  const packageResourcePath = {
								companyID: LoginService.getCompanyID(),
								vehicleID: $stateParams.vehicleID,
								saleinfoID: saleInfoID
							  };
					  
							  return SaleInfoService.getSalePackages(packageResourcePath).$promise
								.then(function (salePackages) {
								  if (!Array.isArray(salePackages)) {
									return $q.reject("Failed to fetch available items, salePackages are invalid");
								  }
					  
								  const queue = {};
					  
								  salePackages.forEach(function (salePackage) {
									if (salePackage && salePackage.isAvailable()) {
									  const itemResourcePath = {
										companyID: LoginService.getCompanyID(),
										vehicleID: $stateParams.vehicleID,
										saleinfoID: saleInfoID,
										packageID: salePackage.id_sale_package
									  };
					  
									  queue[salePackage.id_sale_package] = $q.all({
										packageData: salePackage,
										packageItems: SaleInfoService.getSalePackageItems(itemResourcePath).$promise
									  });
									}
								  });
					  
								  return $q.all(queue);
								})
								.then(function (result) {
								  if (!result) {
									return $q.reject("Failed to fetch available items, items are invalid");
								  }
					  
								  Object.keys(result).forEach(function (packageID) {
									if (result[packageID] && Array.isArray(result[packageID].packageItems)) {
									  result[packageID].packageItems = result[packageID].packageItems.filter(function (packageItem) {
										return packageItem && packageItem.quantity > 0;
									  });
									}
					  
									if (result[packageID].packageItems.length <= 0) {
									  delete result[packageID];
									}
								  });
								  return $q.all(Object.values(result));
								})
								.catch(MessageService.showToast);
							}
						  })
						.catch(MessageService.showToast);
					},
					purchasedWorkOrderPackage:function($stateParams, WorkOrderService, MessageService, LoginService, $q) {
						if (!LoginService.getUserStatus() || !LoginService.getUserStatus().isLogin) {
						  return $q.resolve();
						}
					  
						const resourcePath = {
							companyID: LoginService.getCompanyID(),
							vehicleID: $stateParams.vehicleID,
							workorderID: $stateParams.workOrderID,
						};
						const body = {
							iscompleted: true
						}
					  
						return WorkOrderService.getWorkOrderPackages(resourcePath, body).$promise
						  .then(function (result) {
							if (!Array.isArray(result) || !result) {
								return $q.all(Object.values({}));
							} else {
								const queue = {};
								result.forEach(function (workorderPackage) {
									if (workorderPackage && workorderPackage.isAvailable()) {
										const resourcePath = {
											companyID: LoginService.getCompanyID(),
											vehicleID: $stateParams.vehicleID,
											workorderID: $stateParams.workOrderID,
											packageID: workorderPackage.id_work_order_package
										};
										queue[workorderPackage.id_work_order_package] = $q.all({
											packageData: workorderPackage,
											packageItems: WorkOrderService.getWorkOrderpackageItems(resourcePath).$promise
										});
									}
								});

								return $q.all(queue);

							}
						  })
						  .then(function (result) {
							if (!result) {
								return $q.reject("Failed to fetch work order available items, items are invalid");
							}
		
							Object.keys(result).forEach(function (packageID) {
								if (result[packageID] && Array.isArray(result[packageID].packageItems)) {
									result[packageID].packageItems = result[packageID].packageItems.filter(function (packageItem) {
										return packageItem && packageItem.quantity > 0;
									});
								}
		
								if (result[packageID].packageItems.length <= 0) {
									delete result[packageID];
								}
							});
		
							return $q.all(Object.values(result));
							
						}).catch(MessageService.showToast);
					},  
				}
			})
			.state('app.edit-workorder.extra', {
				url: '/extra',
				reloadOnSearch: false,
				views: {
					'childPage@app.edit-workorder': {
						templateUrl: 'app/main/workorders/edit-workorder/edit-workorder-extra.html',
						controller: 'EditWorkOrderExtraController as vm'
					}
				},
				resolve: {
					mechanics: function (MessageService, WorkOrderService, LoginService, $stateParams) {
						const resourcePath = {
							companyID: LoginService.getCompanyID(),
							vehicleID: $stateParams.vehicleID,
							workorderID: $stateParams.workOrderID
						};

						return WorkOrderService.getMechanics(resourcePath).catch(MessageService.showToast);
					},
					constants: function (AppointmentsService, MessageService, InventoryService, $q, WorkOrderService, LoginService, SaleInfoService, PurchaseInvoiceService) {
						const resourcePath = { companyID: LoginService.getCompanyID() };
						const queue = {
							partTypes: InventoryService.getInventoryTypes(),
							suggestedLaborPrice: WorkOrderService.getCachedSuggestedLaborPrice(resourcePath),
							suppliers: PurchaseInvoiceService.getCachedSuppliers(resourcePath),
							appointmentStatus: AppointmentsService.getCachedAppointmentStatus()
						}

						return $q.all(queue).catch(MessageService.showToast);
					},
					appointments: function (MessageService, WorkOrderService, LoginService, $stateParams, GeneralTools) {
						const resourcePath = { companyID: LoginService.getCompanyID() };
						const filter = { filters: GeneralTools.equalFilterBuilder("fk_id_work_order", $stateParams.workOrderID) };
						const sorting = {
							sortBy: "start",
							sortDirection: "DESC"
						}

						return WorkOrderService.getAllMatchedAppointments(resourcePath, filter, sorting).catch(MessageService.showToast);
					},
					customerserviceMap: function (WorkOrderService, MessageService, LoginService, $stateParams, GeneralTools) {
						const resourcePath = {
							companyID: LoginService.getCompanyID()
						};

						const filter = {
							filters: GeneralTools.equalFilterBuilder("fk_id_vehicle", $stateParams.vehicleID)
						}

						return WorkOrderService.getAllMatchedServiceMaps(resourcePath, filter).catch(MessageService.showToast);
					},
					customersaleInfos: function ($stateParams, SaleInfoService, MessageService, LoginService, $q) {
						if (!LoginService.getUserStatus() || !LoginService.getUserStatus().isLogin) {
							return $q.resolve();
						}

						var resourcePath = {
							companyID: LoginService.getCompanyID(),
							vehicleID: $stateParams.vehicleID
						};

						return SaleInfoService.getVehicleSaleInfos(resourcePath).catch(MessageService.showToast);
					},
					workOrderCustomerPortalAppointments: function (MessageService, AppointmentsService, LoginService, GeneralTools, AppointmentConstants, $stateParams, ToolsConstants) {
						const resourcePath = {
							companyID: LoginService.getCompanyID()
						};

						var calendarFilter = GeneralTools.equalFilterBuilder("fk_id_work_order", $stateParams.workOrderID);
						var timeRangeFilter = GeneralTools.equalRangeFilterBuilder("start", moment().startOf('day').utc().format("YYYY-MM-DD HH:mm:ss"), moment().add(7, 'years').utc().format("YYYY-MM-DD HH:mm:ss"));
						timeRangeFilter = GeneralTools.addBracketToString(timeRangeFilter);
						calendarFilter = GeneralTools.addBracketToString(calendarFilter);
						var filterString = GeneralTools.notEqualFilterBuilder(AppointmentConstants.keyNames.appointmentStatus, AppointmentConstants.statusIDs.CANCELLED);
						filterString = GeneralTools.stringConnector(filterString, calendarFilter, ToolsConstants.apiFilters.andConnector);
						var filter = { filters: filterString };
						return AppointmentsService.getAllMatchedCustomerPortalAppointments(resourcePath, filter);
					},
				}
			})
			.state('app.edit-workorder.discounts', {
				url: '/discounts',
				reloadOnSearch: false,
				views: {
					'childPage@app.edit-workorder': {
						templateUrl: 'app/main/workorders/edit-workorder/edit-workorder-discounts.html',
						controller: 'EditWorkOrderDiscountsController as vm'
					}
				},
				resolve: {
					customerserviceMap: function (WorkOrderService, MessageService, LoginService, $stateParams, GeneralTools) {
						const resourcePath = {
							companyID: LoginService.getCompanyID()
						};

						const filter = {
							filters: GeneralTools.equalFilterBuilder("fk_id_vehicle", $stateParams.vehicleID)
						}

						return WorkOrderService.getAllMatchedServiceMaps(resourcePath, filter).catch(MessageService.showToast);
					},
					customersaleInfos: function ($stateParams, SaleInfoService, MessageService, LoginService, $q) {
						if (!LoginService.getUserStatus() || !LoginService.getUserStatus().isLogin) {
							return $q.resolve();
						}

						var resourcePath = {
							companyID: LoginService.getCompanyID(),
							vehicleID: $stateParams.vehicleID
						};

						return SaleInfoService.getVehicleSaleInfos(resourcePath).catch(MessageService.showToast);
					}
				}
			})
			.state('app.edit-workorder.payments', {
				url: '/payments',
				reloadOnSearch: false,
				views: {
					'childPage@app.edit-workorder': {
						templateUrl: 'app/main/workorders/edit-workorder/edit-workorder-payments.html',
						controller: 'EditWorkOrderPaymentsController as vm'
					}
				},
				resolve: {
					customersaleInfos: function ($stateParams, SaleInfoService, MessageService, LoginService, $q) {
						if (!LoginService.getUserStatus() || !LoginService.getUserStatus().isLogin) {
							return $q.resolve();
						}

						var resourcePath = {
							companyID: LoginService.getCompanyID(),
							vehicleID: $stateParams.vehicleID
						};

						return SaleInfoService.getVehicleSaleInfos(resourcePath).catch(MessageService.showToast);
					},
					customerserviceMap: function (WorkOrderService, MessageService, LoginService, $stateParams, GeneralTools) {
						const resourcePath = {
							companyID: LoginService.getCompanyID()
						};

						const filter = {
							filters: GeneralTools.equalFilterBuilder("fk_id_vehicle", $stateParams.vehicleID)
						}

						return WorkOrderService.getAllMatchedServiceMaps(resourcePath, filter).catch(MessageService.showToast);
					},
				}
			})
			.state('app.edit-workorder.appointments', {
				url: '/appointments',
				reloadOnSearch: false,
				views: {
					'childPage@app.edit-workorder': {
						templateUrl: 'app/main/workorders/edit-workorder/edit-workorder-appointments.html',
						controller: 'EditWorkOrderAppointmentsController as vm'
					}
				},
				resolve: {
					constants: function (AppointmentsService, MessageService, InventoryService, $q, WorkOrderService, LoginService, SaleInfoService, PurchaseInvoiceService) {
						const resourcePath = { companyID: LoginService.getCompanyID() };
						const queue = {
							appointmentStatus: AppointmentsService.getCachedAppointmentStatus()
						}

						return $q.all(queue).catch(MessageService.showToast);
					},
					appointments: function (MessageService, WorkOrderService, LoginService, $stateParams, GeneralTools) {
						const resourcePath = { companyID: LoginService.getCompanyID() };
						const filter = { filters: GeneralTools.equalFilterBuilder("fk_id_work_order", $stateParams.workOrderID) };
						const sorting = {
							sortBy: "start",
							sortDirection: "DESC",
							workOrderAppointmentBoolean: true
						}

						return WorkOrderService.getAllMatchedAppointments(resourcePath, filter, sorting).catch(MessageService.showToast);
					},
					customersaleInfos: function ($stateParams, SaleInfoService, MessageService, LoginService, $q) {
						if (!LoginService.getUserStatus() || !LoginService.getUserStatus().isLogin) {
							return $q.resolve();
						}

						var resourcePath = {
							companyID: LoginService.getCompanyID(),
							vehicleID: $stateParams.vehicleID
						};

						return SaleInfoService.getVehicleSaleInfos(resourcePath).catch(MessageService.showToast);
					}
				}
			})
			.state('app.edit-workorder.files', {
				url: '/files',
				reloadOnSearch: false,
				views: {
					'childPage@app.edit-workorder': {
						templateUrl: 'app/main/workorders/edit-workorder/edit-workorder-files.html',
						controller: 'EditWorkOrderFilesController as vm'
					}
				},
				resolve: {
					files: function (MessageService, WorkOrderService, LoginService, $stateParams) {
						const resourcePath = {
							companyID: LoginService.getCompanyID(),
							vehicleID: $stateParams.vehicleID,
							workorderID: $stateParams.workOrderID
						};

						return WorkOrderService.getFiles(resourcePath).catch(MessageService.showToast);
					}
				}
			})
			.state('app.edit-workorder.logs', {
				url: '/logs',
				reloadOnSearch: false,
				views: {
					'childPage@app.edit-workorder': {
						templateUrl: 'app/main/workorders/edit-workorder/edit-workorder-logs.html',
						controller: 'EditWorkOrderLogsController as vm'
					}
				},
				resolve: {
					constants: function (AppointmentsService, MessageService, InventoryService, $q, WorkOrderService, LoginService, SaleInfoService, PurchaseInvoiceService) {
						const resourcePath = { companyID: LoginService.getCompanyID() };
						const queue = {
							appointmentStatus: AppointmentsService.getCachedAppointmentStatus()
						}

						return $q.all(queue).catch(MessageService.showToast);
					},
					appointments: function (MessageService, WorkOrderService, LoginService, $stateParams, GeneralTools) {
						const resourcePath = { companyID: LoginService.getCompanyID() };
						const filter = { filters: GeneralTools.equalFilterBuilder("fk_id_work_order", $stateParams.workOrderID) };
						const sorting = {
							sortBy: "start",
							sortDirection: "DESC",
							workOrderAppointmentBoolean: true
						}

						return WorkOrderService.getAllMatchedAppointments(resourcePath, filter, sorting).catch(MessageService.showToast);
					},
					customersaleInfos: function ($stateParams, SaleInfoService, MessageService, LoginService, $q) {
						if (!LoginService.getUserStatus() || !LoginService.getUserStatus().isLogin) {
							return $q.resolve();
						}

						var resourcePath = {
							companyID: LoginService.getCompanyID(),
							vehicleID: $stateParams.vehicleID
						};

						return SaleInfoService.getVehicleSaleInfos(resourcePath).catch(MessageService.showToast);
					},
					workorderlogs: function (MessageService, WorkOrderService, LoginService, $stateParams) {
						const resourcePath = {
							companyID: LoginService.getCompanyID(),
							vehicleID: $stateParams.vehicleID,
							workorderID: $stateParams.workOrderID
						};

						return WorkOrderService.getWorkOrderLog(resourcePath).catch(MessageService.showToast);
					}
				}
			})
			.state('app.workorder-schedule', {
				url: '/workorderschedule?workOrderID&vehicleID&customerID&calendarFilters&goToDate',
				reloadOnSearch: false,
				views: {
					'content@app': {
						templateUrl: 'app/main/workorders/schedule/schedule.html',
						controller: "WorkOrderScheduleController as vm"
					}
				},
				resolve: {
					calendars: function (MessageService, AppointmentsService, LoginService) {
						const resourcePath = {
							companyID: LoginService.getCompanyID()
						};

						return AppointmentsService.getCachedCalendars(resourcePath).catch(MessageService.showToast);
					},
					customerportalcalendars: function (MessageService, AppointmentsService, LoginService) {
						const resourcePath = {
							companyID: LoginService.getCompanyID()
						};

						return AppointmentsService.getCustomerPortalAppointmentCalendars(resourcePath).catch(MessageService.showToast);
					},

					userConfig: function ($q, LoginService, UserConfigService, MessageService) {

						const resourcePath = {
							companyID: LoginService.getCompanyID(),
							userID: LoginService.getUserID()
						};

						return UserConfigService.getUserConfig(resourcePath).catch(MessageService.showToast);
					}
				}
			})

			.state('app.workorder-new-schedule', {
				url: '/activeschedule?calendarFilters',
				reloadOnSearch: false,
				views: {
					'content@app': {
						templateUrl: 'app/main/workorders/new-schedule/new-schedule.html',
						controller: "NewScheduleController as vm"
					}
				},
				resolve: {
					calendars: function (MessageService, AppointmentsService, LoginService) {
						const resourcePath = {
							companyID: LoginService.getCompanyID()
						};

						return AppointmentsService.getCachedCalendars(resourcePath).catch(MessageService.showToast);
					},
					customerportalcalendars: function (MessageService, AppointmentsService, LoginService) {
						const resourcePath = {
							companyID: LoginService.getCompanyID()
						};

						return AppointmentsService.getCustomerPortalAppointmentCalendars(resourcePath).catch(MessageService.showToast);
					},

					userConfig: function ($q, LoginService, UserConfigService, MessageService) {

						const resourcePath = {
							companyID: LoginService.getCompanyID(),
							userID: LoginService.getUserID()
						};

						return UserConfigService.getUserConfig(resourcePath).catch(MessageService.showToast);
					}
				}
			})
			
			.state('app.customerportal-appointment', {
				url: '/customerportal/appointment?calendarFilters&',
				reloadOnSearch: false,
				views: {
					'content@app': {
						templateUrl: 'app/main/workorders/customer_portal_appointment/customer-portal-appointment.html',
						controller: "CustomerPortalAppointmentController as vm"
					}
				},
				resolve: {
					customerportalcalendars: function (MessageService, AppointmentsService, LoginService) {
						const resourcePath = {
							companyID: LoginService.getCompanyID()
						};

						return AppointmentsService.getCustomerPortalAppointmentCalendars(resourcePath).catch(MessageService.showToast);
					},
					userConfig: function ($q, LoginService, UserConfigService, MessageService) {

						const resourcePath = {
							companyID: LoginService.getCompanyID(),
							userID: LoginService.getUserID()
						};

						return UserConfigService.getUserConfig(resourcePath).catch(MessageService.showToast);
					}
				}
			});
	}

})();
(function ()
{
	'use strict';

	angular
		.module('app.workOrders')
		.controller('WorkOrderSummaryController', WorkOrderSummaryController);

	function WorkOrderSummaryController(LoginService, $stateParams, WorkOrderService, WorkOrderPayment, GeneralTools, serviceMap, $rootScope, $state, WorkOrderConstants, MessageService, WorkOrderDataSharingService, constants){   
		const vm = this;
		const companyID = LoginService.getCompanyID();
		const generalState = "app.edit-workorder.general";
		const discountsState = "app.edit-workorder.discounts";
		const paymentsState = "app.edit-workorder.payments";

		vm.translateToDollar = GeneralTools.inputTranslators.dollar;
		vm.onAnchorClicked = onAnchorClicked;
		vm.addPayment = addPayment

		init();

		function init(){
			initConstants();
			initSummaryCard();
			initDefaultCustomer();
		}

		function initSummaryCard(){
			vm.partList = WorkOrderDataSharingService.getPartList();
			vm.workOrder = WorkOrderDataSharingService.getWorkOrder();
			vm.laborList = WorkOrderDataSharingService.getLaborList();
			vm.miscfeeList = WorkOrderDataSharingService.getMiscFeesList();
			vm.discountList = WorkOrderDataSharingService.getDiscountList();
			vm.paymentList = WorkOrderDataSharingService.getPaymentList();
			vm.workOrderWarrantyList = WorkOrderDataSharingService.getWorkOrderWarrantyList();
		}

		function initDefaultCustomer(){
			if(Array.isArray(serviceMap)){
				vm.defaultCustomer = serviceMap[0].customer;
			}

			if(vm.defaultCustomer){
				vm.customerPageUrl = $state.href("app.view-customer", {customerID: vm.defaultCustomer.id_customer})
			}
		}

		function initConstants(){
			if(!constants){
				MessageService.showToast("constants invalid");
				return;
			}

			vm.paymentMethods = constants.paymentMethods;
			vm.workOrderStatus = constants.workOrderStatus;
		}

		function onAnchorClicked(tag){
			const currentState = $state.current.name;

			switch(tag){
				case WorkOrderConstants.anchorTags.discounts:
					if(currentState != discountsState){
						$state.go(discountsState, {'#': tag});
					}
					break;
				case WorkOrderConstants.anchorTags.payments:
					if(currentState != paymentsState){
						$state.go(paymentsState, {'#': tag});
					}
					break;
				default:
					if(currentState != generalState){
						$state.go(generalState, {'#': tag});
					}
					break;
			}

			$rootScope.$broadcast(WorkOrderConstants.anchorEventName, tag);
		}

		function addPayment(){
			const payment = new WorkOrderPayment();

			payment.setCustomer(vm.defaultCustomer);
			payment.fk_id_payment_method = vm.paymentMethodID;
			payment.amount = vm.paymentAmount;
			payment.payment_date = moment().format("YYYY-MM-DD[T]HH:mm:ss");

			if(!payment.isValid()){
				MessageService.showToast("Please select method and enter amount.");
				return;
			}

			const resourcePath = {
				companyID: companyID,
				vehicleID: $stateParams.vehicleID,
				workorderID: $stateParams.workOrderID
			}

			vm.isAddingPayment = true;

			WorkOrderService.createPayment(resourcePath, payment)
				.then(function(newPaymentID){
					payment.id_work_order_payment = newPaymentID;
					vm.paymentList.push(payment);

					vm.paymentMethodID = null;
					vm.paymentAmount = null;

					MessageService.showToast("Payment is added");
				})
				.catch(MessageService.showToast)
				.finally(function(){
					vm.isAddingPayment = false;
				});
		}
	}
})();
(function ()
{
	"use strict";

	angular
		.module("app.workOrders")
		.component("workorderSummaryCard", {
				bindings:{
					hiddenSections:'<',
					workorder: '<',
					partList:'<',
					inventoryList:'<',
					laborList: '<',
					miscfeesList: '<',
					discountList: '<',
					paymentList: '<',
					warrantyPaymentList: '<',
					creditCardPaymentList: '<',
					workOrderPackageList: '<',
					workOrderWarrantyList: '<',
					workorderStatusOptions: '<',
					onAnchorClicked: '<',
					demandMap: '<',
					workOrderRdGenerated: '<',
					workOrderRdRedeemed: '<'
				},
				templateUrl: "app/main/workorders/workorder-summary/workorder-summary-card.html",
				controller: componentController,
		  		controllerAs: 'vm'
			});

		function componentController(PartConstants, $scope, WorkOrderSummaryCalculator, WorkOrderConstants, WorkOrderDataSharingService){
			const vm = this;
			const workOrderSummaryCalculator = new WorkOrderSummaryCalculator();

			vm.generalAnchorTag = WorkOrderConstants.anchorTags.general;
			vm.partsAnchorTag = WorkOrderConstants.anchorTags.parts;
			vm.laborsAnchorTag = WorkOrderConstants.anchorTags.labors;
			vm.miscfeeAnchorTag = WorkOrderConstants.anchorTags.miscfees;
			vm.discountsAnchorTag = WorkOrderConstants.anchorTags.discounts;
			vm.paymentsAnchorTag = WorkOrderConstants.anchorTags.payments;

			vm.submittedWarrantyAmount = 0;
			vm.pendingWarrantyAmount = 0;
			vm.recievedWarrantyAmount = 0;
			vm.rogerDollarGeneratedAmount = 0;
			vm.rogerDollarRedeemAmount = 0;

			vm.$postLink = postLink;
			vm.getWorkOrderStatus = getWorkOrderStatus;
			vm.getPartStyleClass = getPartStyleClass;
			vm.getInventoryStyleClass = getInventoryStyleClass;
			
			
			function postLink(){
				$scope.$watch("vm.workorder.subsidized_percentage", updateSummary);
				$scope.$watch("vm.workorder.is_subsidized_by_percentage", updateSummary);
				$scope.$watch("vm.workorder.subsidized_amount", updateSummary);
				$scope.$watch("vm.workorder.tax_rate", updateSummary);
				$scope.$watch("vm.partList", updateSummary, true);
				$scope.$watch("vm.inventoryList", updateSummary, true);
				$scope.$watch("vm.laborList", updateSummary, true);
				$scope.$watch("vm.miscfeesList", updateSummary, true);
				$scope.$watch("vm.workOrderPackageList", updateSummary, true);
				$scope.$watch("vm.workOrderWarrantyList", updateSummary, true);
				$scope.$watch("vm.discountList.length", updateSummary);
				$scope.$watch("vm.paymentList.length", updateSummary);
				$scope.$watch("vm.workOrderRdGenerated", updateSummary);
				$scope.$watch("vm.workOrderRdRedeemed", updateSummary);
				
			}

			function getWorkOrderStatus(){
				if(!Array.isArray(vm.workorderStatusOptions)){
					return;
				}

				const matchedStatus = vm.workorderStatusOptions.find(function(status){
					if(!status || !vm.workorder){
						return;
					}
					return status.id_work_order_status == vm.workorder.fk_id_work_order_status;
				});

				if(matchedStatus){
					return matchedStatus.status;
				} 
			}

			function updateSummary(){

				if(vm.workorder){
					workOrderSummaryCalculator.setTaxRate(vm.workorder.tax_rate);
					workOrderSummaryCalculator.setSubsidizedAmount(vm.workorder.subsidized_amount);
					workOrderSummaryCalculator.setSubsidizedPercentage(vm.workorder.subsidized_percentage);
					workOrderSummaryCalculator.setIsSubsidizedByPercentage(vm.workorder.is_subsidized_by_percentage);
				}
				
				workOrderSummaryCalculator.setParts(vm.partList);
				workOrderSummaryCalculator.setInventories(vm.inventoryList);
				workOrderSummaryCalculator.setLabors(vm.laborList);
				workOrderSummaryCalculator.setMiscfees(vm.miscfeesList);
				workOrderSummaryCalculator.setWorkOrderPackageList(vm.workOrderPackageList);
				workOrderSummaryCalculator.setWorkOrderWarrantyList(vm.workOrderWarrantyList);
				workOrderSummaryCalculator.setDiscounts(vm.discountList);
				workOrderSummaryCalculator.setPayments(vm.paymentList);
				workOrderSummaryCalculator.setRDRedeemed(vm.workOrderRdRedeemed);
				vm.warrantyPaymentList = initwarrantypaymentList(vm.paymentList)
				vm.creditCardPaymentList = initcreditCardpaymentList(vm.paymentList)


				vm.submittedWarrantyAmount = 0;
				vm.pendingWarrantyAmount = 0;
				vm.recievedWarrantyAmount = 0;
				vm.warrantyPaymentList.forEach(function(payment){
					switch(payment.fk_payment_status){
						case 1:
							vm.pendingWarrantyAmount = vm.pendingWarrantyAmount + payment.amount;
							break;
						case 2:
							vm.submittedWarrantyAmount = vm.submittedWarrantyAmount + payment.amount;
							break;
						case 3:
							vm.recievedWarrantyAmount = vm.recievedWarrantyAmount + payment.amount;
							break;
					}
				})

				
				vm.creditCardAmount = 0;
				vm.voidedCreditCardAmount = 0;
				vm.refundCreditCardAmount = 0;
				vm.creditCardPaymentList.forEach(function(payment){
					if(payment.is_canceled){
						vm.voidedCreditCardAmount = vm.voidedCreditCardAmount + payment.amount
					}else if(payment.is_refund){
						vm.refundCreditCardAmount = vm.refundCreditCardAmount + payment.amount
					}else{
						vm.creditCardAmount = vm.creditCardAmount + payment.amount
					}
				})




				vm.discountDetailList = workOrderSummaryCalculator.getTotalDiscountDetailList();
				vm.totalPartsAndInventoriesRetails = workOrderSummaryCalculator.getPartsAndInventoryTotalRetail();
				vm.totalLaborsCost = workOrderSummaryCalculator.getTotalLaborsCost();
				vm.totalPackageCost = workOrderSummaryCalculator.getTotalWorkOrderPackageListCost();
				vm.totalWarrantyCost = workOrderSummaryCalculator.getTotalWorkOrderWarrantyListCost();
				vm.totalMiscfeesCost = workOrderSummaryCalculator.getTotalMiscfeesCost();
				vm.subtotalBeforeSubtraction = workOrderSummaryCalculator.getSubtotalBeforeSubtraction();
				vm.totalDiscountOff = workOrderSummaryCalculator.getTotalDiscountAmount();
				vm.subsidization = workOrderSummaryCalculator.getSubsidization();
				vm.totalBeforeTax = workOrderSummaryCalculator.getTotalBeforeTax();
				WorkOrderDataSharingService.setworkOrderSubTotal(vm.totalBeforeTax);
				vm.totalTax = workOrderSummaryCalculator.getTotalTax();
				vm.totalAfterTax = workOrderSummaryCalculator.getTotalAfterTax();
				vm.totalPayments = workOrderSummaryCalculator.getTotalPayments();
				vm.outstanding = workOrderSummaryCalculator.getOutstanding();
				vm.totalCost = workOrderSummaryCalculator.getTotalCost();
				vm.profit = workOrderSummaryCalculator.getProfit();
				// vm.workOrderRdRedeemed = workOrderSummaryCalculator.getRDRedeemed();

				if(vm.workOrderRdGenerated[0] && vm.workOrderRdGenerated[0].resourceData){
					vm.rogerDollarGeneratedAmount = vm.workOrderRdGenerated[0].resourceData.generated_amount;
				}else if(vm.workOrderRdGenerated[0] && vm.workOrderRdGenerated[0].generated_amount ){
					vm.rogerDollarGeneratedAmount = vm.workOrderRdGenerated[0].generated_amount;
				}


				if(vm.workOrderRdRedeemed && vm.workOrderRdRedeemed[0] && vm.workOrderRdRedeemed[0].resourceData){
					vm.rogerDollarRedeemAmount = vm.workOrderRdRedeemed[0].resourceData.redeemed_amount;
				}else if(vm.workOrderRdRedeemed && vm.workOrderRdRedeemed[0] && vm.workOrderRdRedeemed[0].redeemed_amount ){
					vm.rogerDollarRedeemAmount = vm.workOrderRdRedeemed[0].redeemed_amount;
				}

				if(vm.workOrderRdRedeemed && vm.workOrderRdRedeemed.length <= 0){
					vm.rogerDollarRedeemAmount = 0
				}
			}

			function initwarrantypaymentList(payments){
				var warrantyPaymentList = [];
				payments.forEach(function(payment){
					if(payment.fk_id_payment_method == 6){
						warrantyPaymentList.push(payment);
					}
				});
				return warrantyPaymentList;
			}

			function initcreditCardpaymentList(payments){
				var creditCardPaymentList = [];
				payments.forEach(function(payment){
					if(payment.fk_id_payment_method == 11){
						creditCardPaymentList.push(payment);
					}
				});
				return creditCardPaymentList;
			}

			function getPartStyleClass(item) {
				const classList = [];

				if(!item){
					return;
				} 

				if(item.is_returned){
					classList.push(PartConstants.styleClasses.returnedForDiv);
					return classList;
				}

				if(!item.is_ordered){
					classList.push(PartConstants.styleClasses.notOrdered);
					return classList;
				}

				if(item.fk_id_purchase_invoice){
					classList.push(PartConstants.styleClasses.orderedInvoiced);
				} else {
					classList.push(PartConstants.styleClasses.orderedUninvoiced);	
				}

				return classList; 
			}

			function getInventoryStyleClass(item){
				if(vm.demandMap && vm.demandMap[item.fk_id_inventory] && vm.demandMap[item.fk_id_inventory].totalDemand > vm.demandMap[item.fk_id_inventory].totalInStock){
					return [PartConstants.styleClasses.inventoryNotEnough];
				}
				return [PartConstants.styleClasses.orderedInvoiced];
			}

			vm.check = function check(){
			}
		}
})();
(function ()
{
	'use strict';

	angular
		.module("app.workOrders")
		.factory("WorkOrderSummaryCalculator", WorkOrderSummaryCalculatorClass)

	/** @ngInject */
	function WorkOrderSummaryCalculatorClass(GeneralTools)
	{	 
		function WorkOrderSummaryCalculator(){}

		WorkOrderSummaryCalculator.prototype.setWorkorder = function (workorder) {
			if(workorder){
				this.setTaxRate(workorder.tax_rate);
				this.setSubsidizedAmount(workorder.subsidized_amount);
				this.setSubsidizedPercentage(workorder.subsidized_percentage);
				this.setIsSubsidizedByPercentage(workorder.is_subsidized_by_percentage);
			}
		}

		WorkOrderSummaryCalculator.prototype.setTaxRate = function (taxRate) {
			this.taxRate = taxRate;
		}

		WorkOrderSummaryCalculator.prototype.getTaxRate = function () {
			return GeneralTools.preciseNumber(GeneralTools.parseNumber(this.taxRate), 2);
		}

		WorkOrderSummaryCalculator.prototype.setSubsidizedAmount = function (subsidizedAmount) {
			this.subsidizedAmount = subsidizedAmount;
		}

		WorkOrderSummaryCalculator.prototype.getSubsidizedAmount = function () {
			return GeneralTools.preciseNumber(GeneralTools.parseNumber(this.subsidizedAmount), 2);
		}

		WorkOrderSummaryCalculator.prototype.setSubsidizedPercentage = function (subsidizedPercentage) {
			this.subsidizedPercentage = subsidizedPercentage;
		}

		WorkOrderSummaryCalculator.prototype.getSubsidizedPercentage = function () {
			return GeneralTools.preciseNumber(GeneralTools.parseNumber(this.subsidizedPercentage), 2);
		}

		WorkOrderSummaryCalculator.prototype.setIsSubsidizedByPercentage = function (isSubsidizedByPercentage) {
			this.isSubsidizedByPercentage = isSubsidizedByPercentage;
		}

		WorkOrderSummaryCalculator.prototype.getIsSubsidizedByPercentage = function () {
			return this.isSubsidizedByPercentage
		}

		WorkOrderSummaryCalculator.prototype.setParts = function (parts) {
			this.parts = parts;
		}

		WorkOrderSummaryCalculator.prototype.getParts = function () {
			return this.parts;
		}

		WorkOrderSummaryCalculator.prototype.setInventories = function (inventories) {
			this.inventories = inventories;
		}

		WorkOrderSummaryCalculator.prototype.getInventories = function () {
			return this.inventories;
		}

		WorkOrderSummaryCalculator.prototype.setLabors = function (labors) {
			this.labors = labors;
		}

		WorkOrderSummaryCalculator.prototype.setMiscfees = function (miscfees) {
			this.miscfees = miscfees;
		}

		WorkOrderSummaryCalculator.prototype.getMiscfees = function () {
			return this.miscfees;
		}

		WorkOrderSummaryCalculator.prototype.getLabors = function () {
			return this.labors;
		}

		WorkOrderSummaryCalculator.prototype.setWorkOrderPackageList = function (workOrderPackageList) {
			this.workOrderPackageList = workOrderPackageList;
		}

		WorkOrderSummaryCalculator.prototype.getWorkOrderPackageList = function () {
			return this.workOrderPackageList;
		}

		WorkOrderSummaryCalculator.prototype.setWorkOrderWarrantyList = function (workOrderWarrantyList) {
			this.workOrderWarrantyList = workOrderWarrantyList;
		}

		WorkOrderSummaryCalculator.prototype.getWorkOrderWarrantyList = function () {
			return this.workOrderWarrantyList;
		}

		WorkOrderSummaryCalculator.prototype.setDiscounts = function (discounts) {
			this.discounts = discounts;
		}

		WorkOrderSummaryCalculator.prototype.getDiscounts = function () {
			return this.discounts;
		}



		WorkOrderSummaryCalculator.prototype.setRDRedeemed = function (rDRedeemed) {
			this.rDRedeemed = rDRedeemed;
		}

		WorkOrderSummaryCalculator.prototype.getRDRedeemed = function () {
			return this.rDRedeemed;
		}

		WorkOrderSummaryCalculator.prototype.setPayments = function (payments) {
			this.payments = payments;
		}

		WorkOrderSummaryCalculator.prototype.getPayments = function () {
			return this.payments;
		}

		WorkOrderSummaryCalculator.prototype.getTotalInventoriesCost = function () {
			const inventories = this.getInventories();
			var total = 0;

			if(!Array.isArray(inventories)){
				return total;
			}

			inventories.forEach(function(inventory){
				if(!!inventory ){
					total += GeneralTools.parseNumber(inventory.purchase_price) * GeneralTools.parseNumber(inventory.quantity);
				}
			});

			return GeneralTools.preciseNumber(total , 2);
		}

		WorkOrderSummaryCalculator.prototype.getTotalInventoriesRetail = function () {
			const inventories = this.getInventories();
			var total = 0;

			if(!Array.isArray(inventories)){
				return total;
			}

			inventories.forEach(function(inventory){
				if(!!inventory ){
					total += GeneralTools.parseNumber(inventory.retail_price) * GeneralTools.parseNumber(inventory.quantity);
				}
			});

			return GeneralTools.preciseNumber(total , 2);
		}

		WorkOrderSummaryCalculator.prototype.getTotalPartsCost = function () {
			const parts = this.getParts();
			var total = 0;

			if(!Array.isArray(parts)){
				return total;
			}

			parts.forEach(function(part){
				if(!!part && !part.is_returned){
					total += GeneralTools.parseNumber(part.purchase_price) * GeneralTools.parseNumber(part.quantity);
				}
			});

			return GeneralTools.preciseNumber(total , 2);
		}
		
		WorkOrderSummaryCalculator.prototype.getTotalMiscfeesCost = function () {
			const miscfees = this.getMiscfees();
			var total = 0;

			if(!Array.isArray(miscfees)){
				return total;
			}

			miscfees.forEach(function(miscfee){
				if(!!miscfee){
					total += GeneralTools.parseNumber(miscfee.price) * GeneralTools.parseNumber(miscfee.quantity);
				}
			});

			return GeneralTools.preciseNumber(total , 2);
		}



		WorkOrderSummaryCalculator.prototype.getTotalPartsRetail = function () {
			const parts = this.getParts();
			var total = 0;

			if(!Array.isArray(parts)){
				return total;
			}

			parts.forEach(function(part){
				if(!!part && !part.is_returned){
					total += GeneralTools.parseNumber(part.retail_price) * GeneralTools.parseNumber(part.quantity);
				}
			});

			return GeneralTools.preciseNumber(total , 2);
		}

		WorkOrderSummaryCalculator.prototype.getTotalLaborsCost = function () {
	 		const labors = this.getLabors();
	 		var total = 0;

	 		if(!Array.isArray(labors)){
	 			return total;
	 		}

	 		labors.forEach(function(labor){
	 			if(!!labor ){
	 				total += GeneralTools.parseNumber(labor.price) * GeneralTools.parseNumber(labor.hour);
	 			}
	 		});

	 		return GeneralTools.preciseNumber(total , 2);
		}

		WorkOrderSummaryCalculator.prototype.getTotalWorkOrderPackageListCost = function () {
			const workOrderPackageList = this.getWorkOrderPackageList();
			var total = 0;

			if(!Array.isArray(workOrderPackageList)){
				return total;
			}

			workOrderPackageList.forEach(function(workorderpackage){
				if(!!workorderpackage ){
					total += GeneralTools.parseNumber(workorderpackage.price);
				}
			});

			return GeneralTools.preciseNumber(total , 2);
	   }

	   WorkOrderSummaryCalculator.prototype.getTotalWorkOrderWarrantyListCost = function () {
		const workOrderWarrantyList = this.getWorkOrderWarrantyList();
		var total = 0;

		if(!Array.isArray(workOrderWarrantyList)){
			return total;
		}

		workOrderWarrantyList.forEach(function(workorderwarranty){
			if(!!workorderwarranty ){
				total += GeneralTools.parseNumber(workorderwarranty.retail);
			}
		});

		return GeneralTools.preciseNumber(total , 2);
   }

		WorkOrderSummaryCalculator.prototype.getTotalMiscfeesCost = function () {
			const miscfees = this.getMiscfees();
			var total = 0;

			if(!Array.isArray(miscfees)){
				return total;
			}
			
			miscfees.forEach(function(MiscFees){
				if(!!MiscFees ){
					total += GeneralTools.parseNumber(MiscFees.price) * GeneralTools.parseNumber(MiscFees.quantity);
				}
			});
			return GeneralTools.preciseNumber(total , 2);
	   }

		WorkOrderSummaryCalculator.prototype.getTotalLaborsHours = function () {
	 		const labors = this.getLabors();
	 		var total = 0;

	 		if(!Array.isArray(labors)){
	 			return total;
	 		}

	 		labors.forEach(function(labor){
	 			if(!!labor ){
	 				total += GeneralTools.parseNumber(labor.hour);
	 			}
	 		});

	 		return GeneralTools.preciseNumber(total , 2);
		}

		WorkOrderSummaryCalculator.prototype.getPartsAndInventoryTotalCost = function () {
			return GeneralTools.preciseNumber(this.getTotalPartsCost() + this.getTotalInventoriesCost(), 2);
		}

		WorkOrderSummaryCalculator.prototype.getPartsAndInventoryTotalRetail = function () {
			return GeneralTools.preciseNumber(this.getTotalPartsRetail() + this.getTotalInventoriesRetail(), 2);
		}

		WorkOrderSummaryCalculator.prototype.getSubtotalBeforeSubtraction = function () {
			return GeneralTools.preciseNumber(this.getPartsAndInventoryTotalRetail() + this.getTotalLaborsCost() + this.getTotalMiscfeesCost() + this.getTotalWorkOrderPackageListCost() + this.getTotalWorkOrderWarrantyListCost(), 2);
		}

		WorkOrderSummaryCalculator.prototype.getTotalDiscountDetailList = function () {
			if(!Array.isArray(this.discounts) && !Array.isArray(this.rDRedeemed)){
				return;
			}

			const detailList = [];
			var discountableAmount = this.getSubtotalBeforeSubtraction();
			const percentageDiscounts = [];
			const nonPercentageDiscounts = [];
			//const rogerDollarRedeemDiscounts = [];

			this.discounts.forEach(function(discount){
				if(!discount){
					return;
				}

				if(discount.is_percentage){
					percentageDiscounts.push(discount);
				} else {
					nonPercentageDiscounts.push(discount);
				}
			});

			// if(this.rDRedeemed){
			// 	this.rDRedeemed.forEach(function(redeemed){
			// 		if(!redeemed){
			// 			return;
			// 		}
	
			// 		if(redeemed.resourceData){
			// 			rogerDollarRedeemDiscounts.push(redeemed);
			// 		}else if(redeemed.redeemed_amount)
			// 		{
			// 			rogerDollarRedeemDiscounts.push(redeemed);
			// 		}
			// 	});
			// }

			

			percentageDiscounts.forEach(function(discount){
				const deductionAmount = discountableAmount * GeneralTools.parseNumber(discount.percentage_off)
				discountableAmount -= deductionAmount;
				detailList.push({
					discountData: discount,
					deductionAmount: GeneralTools.preciseNumber(deductionAmount, 2)
				});
			});

			nonPercentageDiscounts.forEach(function(discount){
				const deductionAmount = GeneralTools.parseNumber(discount.amount_off);
				discountableAmount -= deductionAmount;
				detailList.push({
					discountData: discount,
					deductionAmount: GeneralTools.preciseNumber(deductionAmount, 2)
				});
			});


			// rogerDollarRedeemDiscounts.forEach(function(discount){
			// 	if(discount.resourceData){
			// 		const deductionAmount = GeneralTools.parseNumber(discount.resourceData.redeemed_amount);
			// 		discountableAmount -= deductionAmount;
			// 		detailList.push({
			// 			discountData: discount,
			// 			deductionAmount: GeneralTools.preciseNumber(deductionAmount, 2)
			// 		});
			// 	}else{
			// 		const deductionAmount = GeneralTools.parseNumber(discount.redeemed_amount);
			// 		discountableAmount -= deductionAmount;
			// 		detailList.push({
			// 			discountData: discount,
			// 			deductionAmount: GeneralTools.preciseNumber(deductionAmount, 2)
			// 		});
			// 	}
				
				

			// });


			return detailList;
		}

		WorkOrderSummaryCalculator.prototype.getTotalDiscountAmount = function () {
			const detailList = this.getTotalDiscountDetailList();
			
			var totalDiscountAmount = 0;

			if(!Array.isArray(detailList)){
				return totalDiscountAmount;
			}

			detailList.forEach(function(detail){
				totalDiscountAmount += detail.deductionAmount;
			});

			return GeneralTools.preciseNumber(totalDiscountAmount, 2);
		}

		WorkOrderSummaryCalculator.prototype.getTotalBeforeSubsidization = function () {
			return GeneralTools.preciseNumber(this.getSubtotalBeforeSubtraction() - this.getTotalDiscountAmount(), 2);
		}

		WorkOrderSummaryCalculator.prototype.getSubsidization = function () {
			if(!this.getIsSubsidizedByPercentage()){
				return this.getSubsidizedAmount();
			}

			const totalBeforeSubsidization = this.getTotalBeforeSubsidization();

			return GeneralTools.preciseNumber(totalBeforeSubsidization * this.getSubsidizedPercentage(), 2); 
		}

		WorkOrderSummaryCalculator.prototype.getTotalBeforeTax = function () {
			return GeneralTools.preciseNumber(this.getTotalBeforeSubsidization() - this.getSubsidization(), 2);
		}

		WorkOrderSummaryCalculator.prototype.getTotalTax = function () {
			const taxRate = this.getTaxRate()
			var totalBeforeTax = this.getTotalBeforeTax();
			var totalTax = 0;

			if(taxRate <= 0 || totalBeforeTax <= 0){
				return totalTax;
			}

			return GeneralTools.preciseNumber(totalBeforeTax * taxRate, 2);
		}

		WorkOrderSummaryCalculator.prototype.getTotalAfterTax = function () {
			return GeneralTools.preciseNumber(this.getTotalBeforeTax() + this.getTotalTax(), 2);
		}

		WorkOrderSummaryCalculator.prototype.getTotalPayments = function () {
			const payments = this.getPayments();
			const rogerDollarRedeemDiscounts = [];
			const rogerDollardetailList = [];
			var redemptionAmount = 0;
			var total = 0;

			if(!Array.isArray(payments)){
				return total;
			}

			payments.forEach(function(payment){
				if(!!payment ){
					if(payment.fk_id_payment_method == 11 && (payment.is_refund || payment.is_canceled)){
					}else{
						total += GeneralTools.parseNumber(payment.amount);
					}
				}
			});

			if(this.rDRedeemed){
				this.rDRedeemed.forEach(function(redeemed){
					if(!redeemed){
						return;
					}
	
					if(redeemed.resourceData){
						rogerDollarRedeemDiscounts.push(redeemed);
					}else if(redeemed.redeemed_amount)
					{
						rogerDollarRedeemDiscounts.push(redeemed);
					}
				});
			}

			

			rogerDollarRedeemDiscounts.forEach(function(discount){
				if(discount.resourceData){
					const amount = GeneralTools.parseNumber(discount.resourceData.redeemed_amount);
					redemptionAmount = amount;
					rogerDollardetailList.push({
						discountData: discount,
						Amount: GeneralTools.preciseNumber(redemptionAmount, 2)
					});
				}else{
					const amount = GeneralTools.parseNumber(discount.redeemed_amount);
					redemptionAmount = amount;
					rogerDollardetailList.push({
						discountData: discount,
						Amount: GeneralTools.preciseNumber(redemptionAmount, 2)
					});
				}
			})

			if(!Array.isArray(rogerDollardetailList)){
				return GeneralTools.preciseNumber(total , 2);
			}

			rogerDollardetailList.forEach(function(detail){
				total += detail.Amount;
			});


			return GeneralTools.preciseNumber(total , 2);




			
		}

		WorkOrderSummaryCalculator.prototype.getTotalCost = function () {
			return this.getPartsAndInventoryTotalCost() + this.getTotalMiscfeesCost();
		}

		WorkOrderSummaryCalculator.prototype.getOutstanding = function () {
			return GeneralTools.preciseNumber(this.getTotalAfterTax() - this.getTotalPayments(), 2);
		}

/*		WorkOrderSummaryCalculator.prototype.getPotentialIncomeAfterTax = function () {
			return GeneralTools.preciseNumber(this.getTotalBeforeSubsidization() *  (1 + this.getTaxRate()), 2);
		}

		WorkOrderSummaryCalculator.prototype.getPotentialProfit = function () {
			return GeneralTools.preciseNumber(this.getPotentialIncomeAfterTax() - this.getTotalCost(), 2);
		}
*/
		WorkOrderSummaryCalculator.prototype.getProfit = function () {
			return GeneralTools.preciseNumber(this.getTotalBeforeTax() - this.getTotalCost(), 2);
		}

		return WorkOrderSummaryCalculator;
	}


})();
(function ()
{
	'use strict';

	angular
		.module('app.workOrders')
		.controller('WorkOrderDetailNavController', WorkOrderDetailNavController);

	function WorkOrderDetailNavController($state, $rootScope){   
		const vm = this;

		vm.navItems = [
			{
				name: "GENERAL",
				state: "app.edit-workorder.general"
			},
			{
				name: "DISCOUNTS",
				state: "app.edit-workorder.discounts"
			},
			{
				name: "PAYMENTS",
				state: "app.edit-workorder.payments"
			},
			{
				name: "FILES",
				state: "app.edit-workorder.files"
			}
		]
		
		vm.getLink = getLink;
		vm.setCurrentNavItem = setCurrentNavItem;
		vm.getCurrentTabName = getCurrentTabName;
		//vm.goToState = goToState;

		setCurrentNavItem();

		$rootScope.$on('$stateChangeSuccess', function(event, current) {
			vm.showMenu = false;
			vm.currentState = current.name;
		});

		function setCurrentNavItem(){
			vm.currentState = $state.current.name;
		}

		function goToState(state){
			return $state.go(state);
		}

		function getLink(state){
			return $state.href(state);
		}

		function getCurrentTabName(){
			const currentNavItem = vm.navItems.find(function(navItem){
				return navItem.state == vm.currentState;
			}); 

			if(currentNavItem){
				return currentNavItem.name;
			}
		}
	}
})();
(function ()
{
	'use strict';

	angular
		.module('app.workOrders')
		.controller('SelectCalendarDialogController', SelectCalendarDialogController);

	function SelectCalendarDialogController(calendars, $mdDialog){   
		const vm = this;

		vm.calendars = calendars;
		vm.closeDialog = closeDialog;
		vm.select = select

		function select(id) {
			if(!Array.isArray(vm.calendars)){
				$mdDialog.hide();
			}

			const matchedCalendar = vm.calendars.find(function(calendar){
				if(calendar){
					return calendar.id_calendar == id;
				}
			});

			$mdDialog.hide(matchedCalendar);
		}

		function closeDialog (){
			$mdDialog.hide();
		}
	}
})();
(function () {
	'use strict';

	angular
		.module('app.workOrders')
		.controller('WorkOrderScheduleController', WorkOrderScheduleController);

	function WorkOrderScheduleController(api, WorkOrderSummaryCalculator, AppointmentConstants, customerportalcalendars, WorkOrderConstants, ToolsConstants, DialogService, UserConfigService, UserConfigConstants, userConfig, AppointmentsService, LoginConst, $location, $state, VehicleService, GeneralTools, $stateParams, $scope, $q, $timeout, MessageService, $mdDialog, SaleInfoService, WorkOrderService, CustomersService, calendars, LoginService, UserService) {
		const vm = this;
		const deleteAppointmentWarningTitle = "Delete Appointment";
		const companyID = LoginService.getCompanyID();
		const userID = LoginService.getUserID();
		const maxAppointmentDuration = 8;
		const defaultAppointmentDuration = 1;
		const eventTextColor = "white";
		const startKeyName = "start";
		const calendarKeyName = "fk_id_calendar";
		const customAppointmentTag = "[CUSTOM]";
		const confirmAppointmentTag = "[CONFIRMED]  ";
		const cancelAppointmentTag = "[CANCELLED]  ";
		
		const timeRangeFilterFormat = "YYYY-MM-DD HH:mm:ss";
		const appointmentTimeFormat = "YYYY-MM-DD[T]HH:mm:ss[Z]";
		const calendarHeader = {
			left: WorkOrderConstants.calendarViews.dayGridMonth + ',' + WorkOrderConstants.calendarViews.timeGridWeek + ',' + WorkOrderConstants.calendarViews.timeGridDay,
			center: "title",
			right: "prev,today,next"
		};
		const calendarViewsOptions = {
			timeGrid: {
				minTime: "9:00:00",
				maxTime: "19:00:00",
				allDaySlot: false,
				slotDuration: "00:15:00",
				slotLabelInterval: "01:00"
			}
		};
		const requests = [];

		var calendarGrid;
		var workOrder;
		var workordersDetailsMap = {};

		vm.warningMessageDateFormat = WorkOrderConstants.scheduleDateFormat;
		vm.refreshCalendarGrid = refreshCalendarGrid;
		vm.refreshCalendarNotification = refreshCalendarNotification;
		vm.isCustomFilterApplied = isCustomFilterApplied;
		vm.selectCustomFilter = selectCustomFilter;
		vm.deleteCustomFilter = deleteCustomFilter;
		vm.addCustomFilter = addCustomFilter;
		vm.showWarningMessageBox = showWarningMessageBox;
		vm.getWorkorderUrl = getWorkorderUrl;

		init();

		function init() {
			initCustomFilters();
			initCalendarOptions();
			initCalendarFilters();
			initCalendarGrid();
			initNewWorkOrderAppointment();
			initNewAppointment();
			initNewCustomAppointment();
			$scope.$on("$stateChangeStart", cancelRequest);
		}

		function cancelRequest() {
			for (var i = requests.length - 1; i >= 0; i--) {
				const request = requests[i];

				if (request && request.$cancelRequest) {
					request.$cancelRequest();
					requests.splice(i, 1);
				}
			}
		}

		function initNewWorkOrderAppointment() {
			if (!$stateParams.workOrderID || !$stateParams.vehicleID) {
				return;
			}

			const queue = {
				workOrder: fetchWorkOrder($stateParams.workOrderID, $stateParams.vehicleID),
				labors: fetchWorkOrderLabors($stateParams.workOrderID, $stateParams.vehicleID),
				vehicle: fetchVehicle($stateParams.vehicleID),
				serviceMap: fetchServiceMap($stateParams.vehicleID),
				saleInfo: fetchSaleInfo($stateParams.vehicleID)
			};

			vm.showNewWorkOrderAppointment = true;
			vm.loadingNewWorkorderAppointment = true;

			$q.all(queue)
			
				.then(function (result) {
					if (!result) {
						return $q.reject("work order result invalid.");
					}
					workOrder = result.workOrder;
					getRelavenCustomer(result.serviceMap, result.saleInfo).then(function(customerName){
						buildNewWorkOrderAppointmentObj(result.workOrder, result.labors, result.vehicle, result.serviceMap, customerName);
						vm.workOrderUrl = getWorkorderUrl($stateParams.workOrderID, $stateParams.vehicleID);
					})
				})
				.catch(MessageService.showToast)
				.finally(function () {
					vm.loadingNewWorkorderAppointment = false;
				});
		}

		function getRelavenCustomer(serviceMap, saleInfo) {
			var tempStartDate = moment('1000-01-01', 'YYYY-MM-DD');
			var tempCustomerId = null
			var isCustomerFromSaleInfo = false
			if (!Array.isArray(serviceMap) && !Array.isArray(saleInfo)) {
				return;
			}

			if (serviceMap.length > 0 && saleInfo.length == 0) {
				serviceMap.forEach(function (customer) {
					if (customer.customer.work_order_filter_start != null && tempStartDate.isBefore(moment(customer.customer.work_order_filter_start, 'YYYY-MM-DD'))) {
						tempStartDate = moment(customer.customer.work_order_filter_start, 'YYYY-MM-DD')
						tempCustomerId = customer.customer.id_customer
					}else if(tempCustomerId == null && customer.customer.work_order_filter_start == null ){
						tempCustomerId = customer.customer.id_customer
					}
				})
				const resourcePath = {
					companyID: companyID,
					customerID: tempCustomerId
				};
				return CustomersService.getCustomers(resourcePath)
					.then(function (result) {
						if (result && result.data.length > 0) {
							return result.data[0].first_name + ' ' + result.data[0].last_name
						}
						return $q.resolve(null);
					})
					.catch(MessageService.showToast);

			} else if (saleInfo.length > 0 && serviceMap.length == 0) {
				saleInfo.forEach(function (customer) {
					if (customer.work_order_filter_start != null && tempStartDate.isBefore(moment(customer.work_order_filter_start, 'YYYY-MM-DD'))) {
						tempStartDate = moment(customer.work_order_filter_start, 'YYYY-MM-DD')
						tempCustomerId = customer.fk_id_customer
						isCustomerFromSaleInfo = true
					}else if(tempCustomerId == null && customer.work_order_filter_start == null ){
						tempCustomerId = customer.fk_id_customer
					}
				})



				const resourcePath = {
					companyID: companyID,
					customerID: tempCustomerId
				};
				return CustomersService.getCustomers(resourcePath).then(function (result) {
					if (result && result.data.length > 0) {
						return result.data[0].first_name + ' ' + result.data[0].last_name
					}
					return $q.resolve(null);
				})
					.catch(MessageService.showToast);

			} else {
				serviceMap.forEach(function (customer) {
					if (customer.customer.work_order_filter_start != null && tempStartDate.isBefore(moment(customer.customer.work_order_filter_start, 'YYYY-MM-DD'))) {
						tempStartDate = moment(customer.customer.work_order_filter_start, 'YYYY-MM-DD')
						tempCustomerId = customer.customer.id_customer
					}else if(tempCustomerId == null && customer.customer.work_order_filter_start == null ){
						tempCustomerId = customer.customer.id_customer
					}
				})
				saleInfo.forEach(function (customer) {
					if (customer.work_order_filter_start != null && tempStartDate.isBefore(moment(customer.work_order_filter_start, 'YYYY-MM-DD'))) {
						tempStartDate = moment(customer.work_order_filter_start, 'YYYY-MM-DD')
						tempCustomerId = customer.fk_id_customer
						isCustomerFromSaleInfo = true
					}else if(tempCustomerId == null && customer.customer.work_order_filter_start == null ){
						tempCustomerId = customer.customer.id_customer
					}
				})


				const resourcePath = {
					companyID: companyID,
					customerID: tempCustomerId
				};
				return CustomersService.getCustomers(resourcePath)
					.then(function (result) {
						if (result && result.data.length > 0) {
							return result.data[0].first_name + ' ' + result.data[0].last_name
						}
						return $q.resolve(null);
					})
					.catch(MessageService.showToast);
			}
		}

		function getWorkorderUrl(workorderID, vehicleID) {
			return $state.href("app.edit-workorder.general", { workOrderID: workorderID, vehicleID: vehicleID });
		}

		function initCustomFilters() {
			if (!userConfig) {
				return;
			}

			vm.pageConfigs = userConfig.getPageConfigs(UserConfigConstants.pageKeyNames.workOrderSchedule);
		}

		function initCalendarFilters() {
			const pageConfigs = LoginService.getPageConfigs(LoginConst.pageConfigKeys.workorderSchedule);
			var calendarFilter = GeneralTools.urlObjectParamTranslator($stateParams.calendarFilters);

			if (Array.isArray(calendarFilter)) {
				applyCalendarFilter(calendarFilter);
				return;
			}

			if (pageConfigs && pageConfigs.currentCalendar) {
				const customFilter = getCustomFilterByName(pageConfigs.currentCalendar);

				if (customFilter) {
					calendarFilter = customFilter.calendars;
				}
			}

			applyCalendarFilter(calendarFilter);
		}

		function initCalendarOptions() {
			vm.calendars = calendars;

			if (!Array.isArray(vm.calendars)) {
				vm.calendars = [];
			}
			
		}

		function initCalendarGrid() {
			const calendarEl = document.getElementById('calendar');
			calendarGrid = new FullCalendar.Calendar(calendarEl, {
				header: calendarHeader,
				businessHours: WorkOrderConstants.businessHours,
				eventConstraint: "businessHours",
				height: "auto",
				droppable: !vm.isAddingEvent && !vm.isLoadingEvents && !vm.isUpdatingEvent,
				editable: !vm.isAddingEvent && !vm.isLoadingEvents && !vm.isUpdatingEvent,
				eventLimit: true,
				plugins: ["dayGrid", "timeGrid", "interaction"],
				defaultView: getCalendarDefaultView(),
				views: calendarViewsOptions,

				events: function (fetchInfo) {
					if (calendarGrid) {
						calendarGrid.removeAllEvents()
					}
					return fetchEvents(moment(fetchInfo.start), moment(fetchInfo.end));
				},
				eventDrop: function (info) {
					updateAppointmentTime(info.event)
				},
				eventResize: function (info) {
					updateAppointmentTime(info.event)
				},
				eventReceive: function (info) {
					onAppointmentAdd(info.event);
				},
				eventClick: function (info) {
					if (info.event.extendedProps.isCustomAppointment) {
						showEditAppointmentDialog(info.event)
					}
				},
				datesRender: function (info) {
					refreshWarningMessages();
				}
			});

			calendarGrid.render();

			if ($stateParams.goToDate) {
				calendarGrid.gotoDate($stateParams.goToDate);
			}
		}

		function getCalenderEventsByTimeRange(events, startMomentObj, endTimeMomentObj) {
			if (!Array.isArray(events) || !startMomentObj || !startMomentObj.isValid() || !endTimeMomentObj || !endTimeMomentObj.isValid()) {
				return;
			}

			return events.filter(function (event) {
				if (!event || !event.start) {
					return;
				}
				const eventStart = moment(event.start);
				return eventStart.isValid() && eventStart.isSameOrAfter(startMomentObj) && eventStart.isSameOrBefore(endTimeMomentObj)
			});
		}

		function getCalendarDefaultView() {
			if ((!GeneralTools.isMobileOrTabletDevice() && $stateParams.workOrderID && $stateParams.vehicleID) || $stateParams.customerID) {
				return WorkOrderConstants.calendarViews.timeGridWeek;	
			}

			return WorkOrderConstants.calendarViews.timeGridDay;
		}

		function showEditAppointmentDialog(calendarEvent) {
			if (!calendarEvent || !calendarEvent.extendedProps) {
				return;
			}
			const originTitle = removeCustomTag(calendarEvent.title);
			const dialogOptions = {
				controller: 'CalendarTitleEditorDialogController',
				controllerAs: 'vm',
				templateUrl: 'app/main/workorders/schedule/calendar-event-title-editor-dialog.html',
				clickOutsideToClose: true,
				locals: { title: originTitle },
			};

			$mdDialog.show(dialogOptions)
				.then(function (result) {
					if (!result) {
						return;
					}

					if (result.delete) {
						showDeleteAppointmentDialog(calendarEvent);
						return;
					}

					if (!result || !result.confirm || result.title == originTitle) {
						return;
					}

					const resourcePath = {
						companyID: companyID,
						appointmentID: calendarEvent.extendedProps.appointmentID
					}

					const requestBody = {
						title: result.title
					}
					AppointmentsService.updateAppointment(resourcePath, requestBody)
						.then(function () {
							calendarEvent.setProp("title", customAppointmentTag + result.title);
						})
						.catch(MessageService.showToast)
				})
				.catch(function (error) {
					if (error) {
						MessageService.showToast(error);
					}
				});
		}

		function showDeleteAppointmentDialog(calendarEvent) {
			if (!calendarEvent) {
				return;
			}

			const warningMessage = "Are you sure to delete appointment " + calendarEvent.title;

			const resourcePath = {
				companyID: companyID,
				appointmentID: calendarEvent.extendedProps.appointmentID
			}

			DialogService.showYesOrNoDialog(deleteAppointmentWarningTitle, warningMessage)
				.then(function (yes) {
					if (yes) {
						return AppointmentsService.deleteAppointment(resourcePath);;
					}

					return $q.reject();
				})
				.then(function () {
					calendarEvent.remove()
				})
				.catch(function (error) {
					if (error) {
						MessageService.showToast(error);
					}
				});
		}

		function removeCustomTag(title) {
			if (!title) {
				return;
			}

			if (title.startsWith(customAppointmentTag)) {
				title = title.substring(customAppointmentTag.length, title.length);
			}

			return title;
		}

		function updateAppointmentTime(calendarEvent) {
			if (!calendarEvent.extendedProps) {
				return;
			}

			const requestBody = {
				start: moment(calendarEvent.start).utc().format(appointmentTimeFormat),
				end: moment(calendarEvent.end).utc().format(appointmentTimeFormat)
			}

			var promise = $q.resolve();

			vm.isUpdatingEvent = true;

			if (calendarEvent.extendedProps.isCustomAppointment || calendarEvent.extendedProps.isCustomerCustomAppointment) {
				const resourcePath = {
					companyID: companyID,
					appointmentID: calendarEvent.extendedProps.appointmentID
				};

				promise = AppointmentsService.updateAppointment(resourcePath, requestBody);
			} else {
				const resourcePath = {
					companyID: companyID,
					workorderappointmentID: calendarEvent.extendedProps.appointmentID
				};

				promise = WorkOrderService.updateAppointment(resourcePath, requestBody);
			}

			promise
				.then(refreshWarningMessages)
				.catch(MessageService.showToast)
				.finally(function () {
					vm.isUpdatingEvent = false;
				});
		}

		function onAppointmentAdd(calendarEvent) {
			if (!calendarEvent.extendedProps) {
				return;
			}

			vm.isAddingEvent = true;

			showCalendarDialog()
				.then(function (calendar) {
					if (!calendar) {
						return $q.reject();
					}

					calendarEvent.setProp("backgroundColor", calendar.color);

					if (calendarEvent.extendedProps.isCustomAppointment) {
						return createAppointment(calendarEvent, calendar.id_calendar)
					}
					else if(!calendarEvent.extendedProps.isCustomAppointment && calendarEvent.extendedProps.isCustomerCustomAppointment){
						return createCustomAppointment(calendarEvent, calendar.id_calendar);
					}
					else{
						return createWorkOrderAppointment(calendarEvent, calendar.id_calendar);
					}
				})
				.then(function (newID) {
					calendarEvent.setExtendedProp("appointmentID", newID);
					MessageService.showToast("Appointment is added to the schedule.");
					if (calendarEvent.extendedProps.isCustomAppointment) {
						calendarEvent.setProp("title", customAppointmentTag + vm.newAppointment.title);
						return $q.resolve()
					} else {
						calendarEvent.setExtendedProp("workOrderID", $stateParams.workOrderID);
						calendarEvent.setExtendedProp("vehicleID", $stateParams.vehicleID);
						vm.showNewWorkOrderAppointment = false;
						$timeout(function () {
							$location.search({ calendarFilters: $stateParams.calendarFilters }).replace();
						});
						refreshWarningMessages();
						return $q.resolve()
					}
				})
				.catch(function (message) {
					if (message) {
						MessageService.showToast(message)
					}
					calendarEvent.remove();
				})
				.finally(function () {
					vm.isAddingEvent = false;
				});
		}

		function createAppointment(calendarEvent, calendarID) {
			if (!calendarEvent) {
				return $q.reject("calendar event invalid");
			}

			const resourcePath = { companyID: companyID };
			const requestBody = {
				title: vm.newAppointment.title,
				start: moment(calendarEvent.start).utc().format(appointmentTimeFormat),
				end: moment(calendarEvent.end).utc().format(appointmentTimeFormat),
				fk_id_calendar: calendarID
			}

			return AppointmentsService.createAppointment(resourcePath, requestBody);
		}

		function createWorkOrderAppointment(calendarEvent, calendarID) {
			if (!calendarEvent) {
				return $q.reject("calendar event invalid");
			}

			const resourcePath = { companyID: companyID };
			const requestBody = {
				title: calendarEvent.title,
				start: moment(calendarEvent.start).utc().format(appointmentTimeFormat),
				end: moment(calendarEvent.end).utc().format(appointmentTimeFormat),
				fk_id_calendar: calendarID,
				fk_id_work_order: $stateParams.workOrderID,
				fk_id_vehicle: $stateParams.vehicleID
			}

			return WorkOrderService.createAppointment(resourcePath, requestBody);
		}

		function showCalendarDialog() {
			const selectedCalendars = getSelectedCalendars();

			if (!Array.isArray(selectedCalendars)) {
				return $q.reject("Calendars invalid.");
			}

			if (selectedCalendars.length == 1 && !!selectedCalendars[0]) {
				return $q.resolve(selectedCalendars[0]);
			}

			if (selectedCalendars.length <= 0) {
				selectedCalendars = vm.calendars;
			}

			const dialogOptions = {
				controller: 'SelectCalendarDialogController',
				controllerAs: 'vm',
				templateUrl: 'app/main/workorders/schedule/select-calendar-dialog.html',
				clickOutsideToClose: true,
				locals: { calendars: selectedCalendars }
			};

			return $mdDialog.show(dialogOptions);
		}

		function fetchEvents(startTime, endTime) {
			const defer = $q.defer();
			const resourcePath = { companyID: companyID };
			const filter = getFilter(startTime, endTime);

			const queue = {
				allAppointments: AppointmentsService.getAllMatchedAppointments(resourcePath, filter),
				workOrderAppointments: WorkOrderService.getAllMatchedAppointments(resourcePath, filter),
				customerPortalAppointments: AppointmentsService.getAllMatchedCustomerPortalAppointments(resourcePath, filter),
			}
		
			vm.isLoadingEvents = true;
		
			$q.all(queue)
				.then(function(result) {
					if (!result) {
						return $q.reject("Appointments data invalid");
					}
		
					return builtEventList(result.allAppointments, result.workOrderAppointments);
				})
				.then(function(appointments) {
					if (!Array.isArray(appointments)) {
						return $q.reject("Appointments data invalid");
					}
		
					// var customerPortalAppointmentList = buildCustomerPortalAppointmentEventList(result.customerPortalAppointments)
					// if(customerPortalAppointmentList.length > 0){
					//     appointments = appointments.concat(customerPortalAppointmentList)
					// }
		
					refreshUrl();
					saveCustomFilterToLocal();
					refreshWarningMessages(appointments);
					vm.isLoadingEvents = false;
					defer.resolve(appointments);
				})
				.catch(function(error) {
					MessageService.showToast(error);
					vm.isLoadingEvents = false; // Ensure loading state is reset even on error
					defer.reject(error);
				});
		
			return defer.promise;
		}
		

		function getSelectedCalendars() {
			if (!Array.isArray(vm.calendars)) {
				return;
			}

			return vm.calendars.filter(function (calendar) {
				return !!calendar && calendar.isShow;
			});
		}

		function builtEventList(allAppointments, workOrderAppointments) {
			if (!Array.isArray(allAppointments) || !Array.isArray(workOrderAppointments)) {
				return;
			}
		
			// Create an array of promises
			const eventPromises = allAppointments.map(function (appointment) {
				if (!appointment) {
					return;
				}
				const matchedAppointment = workOrderAppointments.find(function (workOrderAppointment) {
					return !!workOrderAppointment && workOrderAppointment.fk_id_appointment == appointment.id_appointment;
				});
				if (matchedAppointment) {
					return Promise.resolve(castWorkOrderAppointmentToCalenderEvent(matchedAppointment));
				}
		
				if (appointment.fk_id_calendar == 10 && appointment.fk_id_customer != null) {
					return castCustomAppointmentToCalenderEvent(appointment);
				}
		
				return Promise.resolve(castAppointmentToCalenderEvent(appointment));
			});
		
			// Use Promise.all to wait for all promises to resolve
			return Promise.all(eventPromises)
				.then(function(events) {
					// Filter out any undefined events (in case any promises resolved to undefined)
					return events.filter(function(event){
						return (event !== undefined);
					});
				})
				.catch(function(error) {
					// Handle any errors that occurred during the processing of promises
					console.error("Error building event list:", error);
				});
		}
		

		function buildCustomerPortalAppointmentEventList(customerPortalAppointments) {
			if (!Array.isArray(customerPortalAppointments)) {
				return;
			}

			return customerPortalAppointments.map(function (appointment) {
				if (!appointment) {
					return;
				}

				return castCustomerPortalAppointmentToCalenderEvent(appointment);
			});
		}

		function castCustomerPortalAppointmentToCalenderEvent(appointment) {
			if (!appointment) {
				return;
			}
			const event = {};
			var title;

			if (appointment.appointment_type_name) {
				title = appointment.appointment_type_name;
			}
			if (appointment.customer_name) {
				title += ", " + appointment.customer_name;
			}

			if (appointment.vehicle_name) {
				title += ", " + appointment.vehicle_name;
			}


			event.title = title;
			event.start = appointment.start;
			event.end = appointment.end;
			event.color = getCustomerPortalCalendarColor(appointment.fk_id_calendar);
			event.textColor = eventTextColor;
			event.extendedProps = {
				isCustomerPoraltalAppointment: true,
				appointmentID: appointment.id_customer_portal_appointment,
				fk_id_calendar: appointment.fk_id_calendar,
				type: appointment.fk_id_job_type,
				title: title,
				name: appointment.customer_name,
				start: appointment.start,
				end: appointment.end,
				email: appointment.cutomer_email,
				phone: appointment.cutomer_phone,
				additional_info: appointment.customer_additional_information,
				appointment_type: appointment.appointment_type_name,
				vehicle_name: appointment.vehicle_name,
				customer_id: appointment.fk_id_customer,
				vehicle_id: appointment.fk_id_vehicle,
				appointment_status_name: appointment.appointment_status_name,
			}

			if (appointment.fk_id_work_order) {
				event.extendedProps.fk_id_work_order = appointment.fk_id_work_order
				event.url = getWorkorderUrl(appointment.fk_id_work_order, appointment.fk_id_vehicle);
			}
			return event;
		}


		function castAppointmentToCalenderEvent(appointment) {
			if (!appointment) {
				return;
			}

			const event = {};
			var title = customAppointmentTag;
			if (appointment.fk_id_appointment_status == 5) {
				title = confirmAppointmentTag 
			}
			if (appointment.fk_id_appointment_status == 6) {
				title = cancelAppointmentTag 
			}
			
			if (appointment.title) {
				title = title + ' ' + appointment.title;
			}



			event.title = title;
			event.start = appointment.start;
			event.end = appointment.end;
			event.color = getCalendarColor(appointment.fk_id_calendar, appointment.fk_id_appointment_status);
			event.textColor = eventTextColor;
			event.extendedProps = {
				isCustomAppointment: true,
				appointmentID: appointment.id_appointment,
				status: appointment.fk_id_appointment_status
			}

			return event;
		}

		function getCustomerPortalCalendarColor(calendarID) {
			var colorstring = ""
			if (!Array.isArray(vm.calendars)) {
				return;
			}
			const matchedCalendar = vm.calendars.find(function (calendar) {
				if (calendar) {
					return calendar.id_calendar == calendarID;
				}
			});

			if (matchedCalendar) {
				return matchedCalendar.color;
			}
		}

		function castWorkOrderAppointmentToCalenderEvent(workOrderAppointment) {
			if (!workOrderAppointment) {
				return;
			}

			if(workOrderAppointment.fk_id_appointment_status == 5){
				workOrderAppointment.title = confirmAppointmentTag + workOrderAppointment.title;
			}		
			else if(workOrderAppointment.fk_id_appointment_status == 6){
				workOrderAppointment.title = cancelAppointmentTag + workOrderAppointment.title;
			}		


			const event = {};
			event.title = workOrderAppointment.title;
			event.start = workOrderAppointment.start;
			event.end = workOrderAppointment.end;
			event.color = getCalendarColor(workOrderAppointment.fk_id_calendar, workOrderAppointment.fk_id_work_order_status);
			event.textColor = eventTextColor;
			event.extendedProps = {
				isCustomAppointment: false,
				appointmentID: workOrderAppointment.id_work_order_appointment,
				status: workOrderAppointment.fk_id_appointment_status,
				workOrderID: workOrderAppointment.fk_id_work_order,
				vehicleID: workOrderAppointment.fk_id_vehicle,
			}
			event.url = getWorkorderUrl(workOrderAppointment.fk_id_work_order, workOrderAppointment.fk_id_vehicle);
			return event;
		}

		function getCalendarColor(calendarID, workOrderStatusID) {
			var colorstring = ""
			if (!Array.isArray(vm.calendars)) {
				return;
			}
			const matchedCalendar = vm.calendars.find(function (calendar) {
				if (calendar) {
					return calendar.id_calendar == calendarID;
				}
			});

			if (matchedCalendar) {
				if (workOrderStatusID != null && (workOrderStatusID == 3 || workOrderStatusID == 4)) {
					colorstring = matchedCalendar.color;
					colorstring = "rgb(210, 210, 210)"
					return colorstring
				} else {
					return matchedCalendar.color;
				}
			}
			// if(matchedCalendar){
			// 	return matchedCalendar.color;
			// }
		}

		function getFilter(startMoment, endMoment) {
			var calendarFilter = getCalendarFilterString();
			var timeRangeFilter = getTimeRangeFilterString(startMoment, endMoment);

			if (!timeRangeFilter) {
				return;
			}

			timeRangeFilter = GeneralTools.addBracketToString(timeRangeFilter);

			if (calendarFilter) {
				calendarFilter = GeneralTools.addBracketToString(calendarFilter);
			}

			var filterString = GeneralTools.notEqualFilterBuilder(AppointmentConstants.keyNames.appointmentStatus, AppointmentConstants.statusIDs.CANCELLED);

			filterString = GeneralTools.stringConnector(filterString, calendarFilter, ToolsConstants.apiFilters.andConnector);
			filterString = GeneralTools.stringConnector(filterString, timeRangeFilter, ToolsConstants.apiFilters.andConnector);

			return { filters: filterString };
		}

		function getTimeRangeFilterString(startMoment, endMoment) {
			if (!startMoment || !startMoment.isValid() || !endMoment || !endMoment.isValid() || startMoment.isSameOrAfter(endMoment)) {
				return;
			}

			return GeneralTools.equalRangeFilterBuilder(startKeyName, startMoment.utc().format(timeRangeFilterFormat), endMoment.utc().format(timeRangeFilterFormat))
		}

		function getCalendarFilterString() {
			if (!Array.isArray(vm.calendars)) {
				return;
			}

			var filterString = '';
			vm.calendars.forEach(function (calendar) {
				if (calendar && calendar.isShow) {
					filterString = GeneralTools.stringConnector(filterString, GeneralTools.equalFilterBuilder(calendarKeyName, calendar.id_calendar), ToolsConstants.apiFilters.orConnector)
				}
			});

			return filterString;
		}

		function refreshUrl() {
			const urlParams = {};

			if ($stateParams.workOrderID) {
				urlParams.workOrderID = $stateParams.workOrderID;
			}

			if ($stateParams.vehicleID) {
				urlParams.vehicleID = $stateParams.vehicleID;
			}

			if ($stateParams.customerID) {
				urlParams.customerID = $stateParams.customerID;
			}

			const currentCalendars = [];

			if (Array.isArray(vm.calendars)) {
				vm.calendars.forEach(function (calendar) {
					if (calendar && calendar.isShow) {
						currentCalendars.push(calendar.id_calendar);
					}
				});
			}

			urlParams.calendarFilters = JSON.stringify(currentCalendars);
			$location.search(urlParams).replace();
		}

		function saveCustomFilterToLocal() {
			if (!vm.pageConfigs || !Array.isArray(vm.pageConfigs.customFilters)) {
				return;
			}

			const currentCustomFilter = vm.pageConfigs.customFilters.find(function (customFilter) {
				return isCustomFilterApplied(customFilter);
			});

			if (!currentCustomFilter) {
				return;
			}

			var pageConfigs = LoginService.getPageConfigs(LoginConst.pageConfigKeys.workorderSchedule);

			if (!pageConfigs) {
				pageConfigs = {};
			}

			pageConfigs.currentCalendar = currentCustomFilter.name;

			LoginService.savePageConfigs(LoginConst.pageConfigKeys.workorderSchedule, pageConfigs);
		}

		function getCustomFilterByName(name) {
			if (!vm.pageConfigs || !Array.isArray(vm.pageConfigs.customFilters)) {
				return;
			}

			return vm.pageConfigs.customFilters.find(function (customFilter) {
				return !!customFilter && customFilter.name == name;
			});
		}

		function applyCalendarFilter(calendarFilter) {
			if (!Array.isArray(vm.calendars)) {
				return;
			}

			const hasFilter = Array.isArray(calendarFilter);

			vm.calendars.forEach(function (calendar) {
				if (calendar && hasFilter) {
					calendar.isShow = calendarFilter.indexOf(calendar.id_calendar) != -1;
				} else {
					calendar.isShow = true;
				}
			});
		}

		function isCustomFilterApplied(customFilter) {
			if (!customFilter || !Array.isArray(customFilter.calendars) || !Array.isArray(vm.calendars)) {
				return;
			}

			return vm.calendars.every(function (calendar) {
				if (!calendar) {
					return;
				}

				if (customFilter.calendars.indexOf(calendar.id_calendar) == -1) {
					return !calendar.isShow;
				} else {
					return calendar.isShow;
				}
			});
		}

		function selectCustomFilter(customFilterName) {
			const customFilter = getCustomFilterByName(customFilterName);
			if (customFilter) {
				applyCalendarFilter(customFilter.calendars);
				refreshCalendarGrid();
			}
		}

		function deleteCustomFilter(index) {
			var dialogOptions = {};

			dialogOptions.titleString = "Remove Filter";
			dialogOptions.contentString = "Are you sure to remove filter";

			var confirmOption = {};

			confirmOption.optionName = "YES";
			confirmOption.onClick = function () {
				confirmDeleteCustomFilter(index);
				DialogService.close();
			}

			var cancelOption = {};

			cancelOption.optionName = "NO";
			cancelOption.onClick = function () {
				DialogService.close();
			}

			dialogOptions.options = [confirmOption, cancelOption];

			DialogService.showOptionsDialog(dialogOptions);
		}

		function confirmDeleteCustomFilter(index) {
			const currentPageConfig = userConfig.getPageConfigs(UserConfigConstants.pageKeyNames.workOrderSchedule);

			if (currentPageConfig && Array.isArray(currentPageConfig.customFilters)) {
				currentPageConfig.customFilters.splice(index, 1);
			}

			userConfig.setPageConfigs(UserConfigConstants.pageKeyNames.workOrderSchedule, currentPageConfig);

			vm.isDeletingFilter = true;

			updateUserConfig(userConfig)
				.then(function () {
					vm.pageConfigs = currentPageConfig;
					MessageService.showToast("Filter is removed.");
				})
				.catch(MessageService.showToast)
				.finally(function () {
					vm.isDeletingFilter = false;
				});
		}

		function refreshCalendarGrid() {
			if (calendarGrid) {
				calendarGrid.refetchEvents();
			}
		}

		function refreshCalendarNotification(calendar) {
			const resourcePath = {
				companyID: companyID,
				calendarID: calendar.id_calendar
			}
			calendar.notification = !calendar.notification
			AppointmentsService.updateCalendars(resourcePath, calendar)
				.then(function (result) {
					MessageService.showToast("Calendar notification Updated");
				})
				.catch(MessageService.showToast)
		}

		function addCustomFilter() {
			if (!vm.newCustomFilterName) {
				MessageService.showToast("Please enter a name.")
				return;
			}

			if (!Array.isArray(vm.calendars)) {
				return;
			}

			const calendarIdList = [];

			vm.calendars.forEach(function (calendar) {
				if (calendar && calendar.isShow) {
					calendarIdList.push(calendar.id_calendar);
				}
			});

			var currentPageConfig = userConfig.getPageConfigs(UserConfigConstants.pageKeyNames.workOrderSchedule);

			if (!currentPageConfig) {
				currentPageConfig = {};
			}

			if (!Array.isArray(currentPageConfig.customFilters)) {
				currentPageConfig.customFilters = [];
			}

			currentPageConfig.customFilters.push({
				name: vm.newCustomFilterName,
				calendars: calendarIdList
			});

			userConfig.setPageConfigs(UserConfigConstants.pageKeyNames.workOrderSchedule, currentPageConfig);

			vm.isSavingFilter = true;

			updateUserConfig(userConfig)
				.then(function () {
					vm.pageConfigs = currentPageConfig;
					vm.newCustomFilterName = null;
					MessageService.showToast("New filter is saved.");
				})
				.catch(MessageService.showToast)
				.finally(function () {
					vm.isSavingFilter = false;
				});
		}

		function updateUserConfig(userConfig) {
			if (!userConfig) {
				return $q.reject("User config invalid");
			}

			const resourcePath = {
				companyID: companyID,
				userID: userID
			}

			const requestBody = {
				config: userConfig.config
			}

			return UserConfigService.updateUserConfig(resourcePath, requestBody);
		}

		function fetchServiceMap(vehicleID) {
			const resourcePath = {
				companyID: companyID
			};

			const filter = {
				filters: GeneralTools.equalFilterBuilder("fk_id_vehicle", vehicleID)
			}

			return WorkOrderService.getAllMatchedServiceMaps(resourcePath, filter);
		}

		function fetchSaleInfo(vehicleID) {
			const resourcePath = {
				companyID: companyID
			};

			const filter = {
				filters: GeneralTools.equalFilterBuilder("fk_id_vehicle", vehicleID)
			}
			return SaleInfoService.getSaleInfos(resourcePath, filter)
		}

		function fetchVehicle(vehicleID) {
			const resourcePath = {
				companyID: companyID,
				vehicleID: vehicleID
			};

			return VehicleService.getVehicle(resourcePath)
				.then(function (result) {
					if (!result || !Array.isArray(result.data) || result.data.length != 1 || !result.data[0]) {
						return $q.reject("Failed to fetch vehicle data");
					}

					return result.data[0];
				})
		}

		function fetchWorkOrder(workOrderID, vehicleID) {

			const resourcePath = {
				companyID: companyID,
				vehicleID: vehicleID,
				workorderID: workOrderID
			};
			const request = WorkOrderService.getWorkOrders(resourcePath);
			requests.push(request);

			return request.$promise.then(function (result) {
				if (!Array.isArray(result) || result.length != 1 || !result[0]) {
					return $q.reject("Failed to fetch word order data");
				}

				return $q.resolve(result[0]);
			});
		}

		function fetchWorkOrderLabors(workOrderID, vehicleID) {
			const resourcePath = {
				companyID: companyID,
				vehicleID: vehicleID,
				workorderID: workOrderID
			};

			const request = WorkOrderService.getLabors(resourcePath);
			requests.push(request);

			return request.$promise;
		}

		function fetchMiscfeesData(workOrderID, vehicleID) {
			const resourcePath = {
				companyID: companyID,
				vehicleID: vehicleID,
				workorderID: workOrderID
			};

			return WorkOrderService.getMiscfeestype(resourcePath).$promise
		}

		function fetchWorkOrderPackageListData(workOrderID, vehicleID) {
			const resourcePath = {
				companyID: companyID,
				vehicleID: vehicleID,
				workorderID: workOrderID
			};

			return WorkOrderService.getWorkOrderPackages(resourcePath).$promise
		}

		function fetchRogerDollarRedeemData(workOrderID, vehicleID) {
			const resourcePath = {
				companyID: companyID,
				vehicleID: vehicleID,
				workorderID: workOrderID
			};

			return WorkOrderService.getredeemedRD(resourcePath).$promise;
		}


		function fetchWorkOrderWarrantyListData(workOrderID, vehicleID) {
			const resourcePath = {
				companyID: companyID,
				vehicleID: vehicleID,
				workorderID: workOrderID
			};

			return WorkOrderService.getWorkOrderWarranties(resourcePath).$promise;
		}

		function buildNewWorkOrderAppointmentObj(workOrder, labors, vehicle, serviceMap, customerName) {
			if (!workOrder || !vehicle || !Array.isArray(labors) || !Array.isArray(serviceMap) ) {
				return;
			}

			var title = '';
			if(customerName != null){
				title += customerName + '\'s ';
			}
			else if (serviceMap[0] && serviceMap[0].customer) {
				title += serviceMap[0].customer.first_name + ' ' + serviceMap[0].customer.last_name + '\'s ';
			}

			title += vehicle.getYearMakeModel();

			var totalLaborTime = 0;

			labors.forEach(function (labor) {
				if (labor) {
					totalLaborTime += labor.hour;
				}

				title += ' ' + labor.name;
			});

			// if (workOrder.notes) {
			// 	title += ' ' + workOrder.notes;
			// }

			totalLaborTime = Math.ceil(totalLaborTime / 0.25) * 0.25;

			if (totalLaborTime > maxAppointmentDuration) {
				totalLaborTime = maxAppointmentDuration;
			}

			if (totalLaborTime <= 0) {
				totalLaborTime = defaultAppointmentDuration;
			}

			const newWorkOrderAppointment = {
				title: title,
				textColor: eventTextColor,
				duration: {
					hours: Math.floor(totalLaborTime),
					minutes: totalLaborTime % 1 * 60
				},
				extendedProps: {
					isCustomAppointment: false
				},
				url: getWorkorderUrl(workOrder.id_work_order, vehicle.getResourceID())
			}
			vm.workOrderInvoiceNumber = workOrder.invoice_number;
			vm.workOrderAppointmentTitle = title;

			const draggableEl = document.getElementById('newWorkOrderAppointment');
			new FullCalendarInteraction.Draggable(draggableEl, { eventData: newWorkOrderAppointment });
		}

		function initNewAppointment() {
			vm.newAppointment = {
				title: '',
				duration: "01:00",
				textColor: eventTextColor,
				extendedProps: {
					isCustomAppointment: true
				}
			};

			const draggableEl = document.getElementById('newAppointment');
			new FullCalendarInteraction.Draggable(draggableEl, { eventData: vm.newAppointment });
		}

		function refreshWarningMessages(appointments) {
			if (vm.showNewWorkOrderAppointment) {
				return;
			}

			cancelRequest();

			if (!Array.isArray(appointments) && calendarGrid && calendarGrid.view) {
				appointments = getCalenderEventsByTimeRange(calendarGrid.getEvents(), moment(calendarGrid.view.currentStart), moment(calendarGrid.view.currentEnd));
			}

			if (!Array.isArray(appointments)) {
				return;
			}

			const queue = {};
			vm.isRefreshingWarningMessage = true;

			appointments.forEach(function (appointment) {
				if (!appointment || !appointment.extendedProps || appointment.extendedProps.isCustomAppointment || appointment.extendedProps.isCustomerPoraltalAppointment) {
					return;
				}

				if (!queue[appointment.extendedProps.workOrderID] && appointment.extendedProps.vehicleID) {
					queue[appointment.extendedProps.workOrderID] = fetchWorkorderDetails(appointment.extendedProps.workOrderID, appointment.extendedProps.vehicleID);
				}
			});

			$q.all(queue)
				.then(function (workorderDetails) {
					refreshEmptyWorkorderWarningMessage(appointments, workorderDetails);
					refreshPartsNotOrderedWarningMessage(appointments, workorderDetails);
					refreshInventoryInsufficientWarningMessage(appointments, workorderDetails);
					refreshPassedDueTimeWarningMessage(appointments, workorderDetails);
					refreshCompletedWithOutstandingWarningMessage(appointments, workorderDetails);

					refreshNotEnroughRetailPriceOnPartWorkorderWarningMessage(appointments, workorderDetails);
				})
				.catch(function (error) {
					if (error) {
						MessageService.showToast(error);
					}
				})
				.finally(function () {
					vm.isRefreshingWarningMessage = false;
				});
		}

		function refreshEmptyWorkorderWarningMessage(appointments, workorderDetails) {
			if (!Array.isArray(appointments) || !workorderDetails) {
				return;
			}

			const appointmentMap = {};
			vm.emptyWorkorders = {};
			vm.emptyWorkordersCount = 0;

			appointments.forEach(function (appointment) {
				if (!appointment || !appointment.extendedProps || appointment.extendedProps.isCustomAppointment || !isAppointmentExpected(appointment.extendedProps.status)) {
					return;
				}

				if (!Array.isArray(appointmentMap[appointment.extendedProps.workOrderID])) {
					appointmentMap[appointment.extendedProps.workOrderID] = [];
				}

				appointmentMap[appointment.extendedProps.workOrderID].push(appointment);
			});

			Object.keys(workorderDetails).forEach(function (workorderID) {
				if (!workorderDetails[workorderID] 
					|| !workorderDetails[workorderID].workorder 

					||
					(
					workorderDetails[workorderID].workorder.fk_id_work_order_status != WorkOrderConstants.statusIDs.quoted
					&& workorderDetails[workorderID].workorder.fk_id_work_order_status != WorkOrderConstants.statusIDs.booked
					&& workorderDetails[workorderID].workorder.fk_id_work_order_status != WorkOrderConstants.statusIDs.onlot
					&& workorderDetails[workorderID].workorder.fk_id_work_order_status != WorkOrderConstants.statusIDs.started
					)

					|| !Array.isArray(appointmentMap[workorderID])
					|| appointmentMap[workorderID].length <= 0){
					return;
				}

				if ((!Array.isArray(workorderDetails[workorderID].parts) || workorderDetails[workorderID].parts.length <= 0) &&
					(!Array.isArray(workorderDetails[workorderID].inventories) || workorderDetails[workorderID].inventories.length <= 0) &&
					(!Array.isArray(workorderDetails[workorderID].labors) || workorderDetails[workorderID].labors.length <= 0) &&
					(!Array.isArray(workorderDetails[workorderID].miscfees) || workorderDetails[workorderID].miscfees.length <= 0)
					) {
					vm.emptyWorkorders[workorderID] = {
						workorder: workorderDetails[workorderID].workorder,
						appointments: appointmentMap[workorderID]
					};

					vm.emptyWorkordersCount++;
				}
			});
		}

		function isAppointmentExpected(statusID) {
			switch (statusID) {
				case AppointmentConstants.statusIDs.NO_SHOW:
					return false;
				case AppointmentConstants.statusIDs.CANCELLED:
					return false;
				case AppointmentConstants.statusIDs.POSTPONED:
					return false;
				default:
					return true;
			}
		}

		function refreshPartsNotOrderedWarningMessage(appointments, workorderDetails) {
			if (!Array.isArray(appointments) || !workorderDetails) {
				return;
			}

			const appointmentMap = {};
			vm.partsNotOrdered = {};
			vm.partsNotOrderedCount = 0;

			appointments.forEach(function (appointment) {
				if (!appointment || !appointment.extendedProps || appointment.extendedProps.isCustomAppointment || !isAppointmentExpected(appointment.extendedProps.status)) {
					return;
				}

				if (!Array.isArray(appointmentMap[appointment.extendedProps.workOrderID])) {
					appointmentMap[appointment.extendedProps.workOrderID] = [];
				}

				appointmentMap[appointment.extendedProps.workOrderID].push(appointment);
			});

			Object.keys(workorderDetails).forEach(function (workorderID) {
				if (!workorderDetails[workorderID]
					|| !workorderDetails[workorderID].workorder
					||
					(
					workorderDetails[workorderID].workorder.fk_id_work_order_status != WorkOrderConstants.statusIDs.quoted
					&& workorderDetails[workorderID].workorder.fk_id_work_order_status != WorkOrderConstants.statusIDs.booked
					&& workorderDetails[workorderID].workorder.fk_id_work_order_status != WorkOrderConstants.statusIDs.onlot
					&& workorderDetails[workorderID].workorder.fk_id_work_order_status != WorkOrderConstants.statusIDs.started
					)
					|| !Array.isArray(appointmentMap[workorderID])
					|| appointmentMap[workorderID].length <= 0) {
					return;
				}

				if (isAnyPartsNotOrdered(workorderDetails[workorderID].parts)) {
					vm.partsNotOrdered[workorderID] = {
						workorder: workorderDetails[workorderID].workorder,
						appointments: appointmentMap[workorderID]
					}
					vm.partsNotOrderedCount++;
				}
			});
		}

		function refreshInventoryInsufficientWarningMessage(appointments, workorderDetails) {
			var demandMap = {};
			var appointmentMap = {};
			vm.inventoryInsufficientCount = 0;

			appointments.forEach(function (appointment) {
				if (!appointment || !appointment.extendedProps || appointment.extendedProps.isCustomAppointment || !isAppointmentExpected(appointment.extendedProps.status)) {
					return;
				}

				if (!Array.isArray(appointmentMap[appointment.extendedProps.workOrderID])) {
					appointmentMap[appointment.extendedProps.workOrderID] = [];
				}

				appointmentMap[appointment.extendedProps.workOrderID].push(appointment);
			});

			Object.keys(workorderDetails).forEach(function (workorderID) {
				if (!workorderDetails[workorderID] || !Array.isArray(workorderDetails[workorderID].inventories) || !workorderDetails[workorderID].workorder 
				
				
				||
				(
				workorderDetails[workorderID].workorder.fk_id_work_order_status != WorkOrderConstants.statusIDs.quoted
				&& workorderDetails[workorderID].workorder.fk_id_work_order_status != WorkOrderConstants.statusIDs.booked
				&& workorderDetails[workorderID].workorder.fk_id_work_order_status != WorkOrderConstants.statusIDs.onlot
				&& workorderDetails[workorderID].workorder.fk_id_work_order_status != WorkOrderConstants.statusIDs.started
				)
				
				|| !appointmentMap[workorderID] || appointmentMap[workorderID].length <= 0) {
					
					
					return;
				}

				workorderDetails[workorderID].inventories.forEach(function (inventory) {
					if (!inventory) {
						return;
					}

					const quantityInStock = GeneralTools.parseNumber(inventory.quantity_in_stock);
					const demandQuantity = GeneralTools.parseNumber(inventory.quantity);
					const demandMapDetail = {
						workorder: workorderDetails[workorderID].workorder,
						appointments: appointmentMap[workorderID]
					};

					if (demandMap[inventory.fk_id_inventory]) {
						demandMap[inventory.fk_id_inventory].totalInStock = quantityInStock;
						demandMap[inventory.fk_id_inventory].totalDemand += demandQuantity;
						demandMap[inventory.fk_id_inventory].details[workorderID] = demandMapDetail;
						return;
					}

					const details = {};
					details[workorderID] = demandMapDetail;

					demandMap[inventory.fk_id_inventory] = {
						totalInStock: quantityInStock,
						totalDemand: demandQuantity,
						code: inventory.code,
						name: inventory.name,
						details: details
					}
				});
			});

			Object.keys(demandMap).forEach(function (inventoryID) {
				if (demandMap[inventoryID].totalInStock >= demandMap[inventoryID].totalDemand) {
					delete demandMap[inventoryID];
					return;
				}

				vm.inventoryInsufficientCount++;
			});

			vm.inventoryInsufficient = demandMap;
		}

		function refreshPassedDueTimeWarningMessage(appointments, workorderDetails) {
			if (!Array.isArray(appointments) || !workorderDetails) {
				return;
			}

			const current = moment();
			const twoHoursAgo = current.hour(current.hour() - 2);

			vm.passedDueTime = {};
			vm.passedDueTimeCount = 0;

			appointments.forEach(function (appointment) {
				if (!appointment
					|| !appointment.extendedProps
					|| appointment.extendedProps.isCustomAppointment
					|| !isAppointmentExpected(appointment.extendedProps.status)
					|| moment(appointment.start).isAfter(twoHoursAgo)
					|| !workorderDetails[appointment.extendedProps.workOrderID]
					|| !workorderDetails[appointment.extendedProps.workOrderID].workorder
					||
					(
					workorderDetails[appointment.extendedProps.workOrderID].workorder.fk_id_work_order_status != WorkOrderConstants.statusIDs.quoted
					&& workorderDetails[appointment.extendedProps.workOrderID].workorder.fk_id_work_order_status != WorkOrderConstants.statusIDs.booked
					&& workorderDetails[appointment.extendedProps.workOrderID].workorder.fk_id_work_order_status != WorkOrderConstants.statusIDs.onlot
					&& workorderDetails[appointment.extendedProps.workOrderID].workorder.fk_id_work_order_status != WorkOrderConstants.statusIDs.started
					)
					
				) {
					return;
				}

				if (!vm.passedDueTime[appointment.extendedProps.workOrderID]) {
					vm.passedDueTime[appointment.extendedProps.workOrderID] = {
						workorder: workorderDetails[appointment.extendedProps.workOrderID].workorder,
						appointments: []
					}
					vm.passedDueTimeCount++;
				}

				vm.passedDueTime[appointment.extendedProps.workOrderID].appointments.push(appointment);
			});
		}

		function refreshCompletedWithOutstandingWarningMessage(appointments, workorderDetails) {
			if (!Array.isArray(appointments) || !workorderDetails) {
				return;
			}

			vm.completedWithOutstanding = {};
			const appointmentMap = {};
			vm.completedWithOutstandingCount = 0;

			appointments.forEach(function (appointment) {
				if (!appointment
					|| !appointment.extendedProps
					|| appointment.extendedProps.isCustomAppointment
					|| !isAppointmentExpected(appointment.extendedProps.status)) {
					return;
				}

				if (!Array.isArray(appointmentMap[appointment.extendedProps.workOrderID])) {
					appointmentMap[appointment.extendedProps.workOrderID] = [];
				}

				appointmentMap[appointment.extendedProps.workOrderID].push(appointment);
			});

			Object.keys(workorderDetails).forEach(function (workorderID) {
				if (!workorderDetails[workorderID]
					|| !workorderDetails[workorderID].workorder
					|| !workorderDetails[workorderID].workorder.isCompleted()
					|| !Array.isArray(appointmentMap[workorderID])
					|| appointmentMap[workorderID].length <= 0) {
					return;
				}

				const workOrderSummaryCalculator = new WorkOrderSummaryCalculator();
				workOrderSummaryCalculator.setWorkorder(workorderDetails[workorderID].workorder);
				workOrderSummaryCalculator.setParts(workorderDetails[workorderID].parts);
				workOrderSummaryCalculator.setInventories(workorderDetails[workorderID].inventories);
				workOrderSummaryCalculator.setLabors(workorderDetails[workorderID].labors);
				workOrderSummaryCalculator.setMiscfees(workorderDetails[workorderID].miscfees);
				workOrderSummaryCalculator.setWorkOrderPackageList(workorderDetails[workorderID].workorderpackage);
				workOrderSummaryCalculator.setWorkOrderWarrantyList(workorderDetails[workorderID].workorderwarranty);
				workOrderSummaryCalculator.setDiscounts(workorderDetails[workorderID].discounts);
				workOrderSummaryCalculator.setPayments(workorderDetails[workorderID].payments);
				workOrderSummaryCalculator.setRDRedeemed(workorderDetails[workorderID].rogerdollarredeem);
				if (workOrderSummaryCalculator.getOutstanding() == 0) {
					return;
				}

				vm.completedWithOutstanding[workorderID] = {
					workorder: workorderDetails[workorderID].workorder,
					appointments: appointmentMap[workorderID]
				}

				vm.completedWithOutstandingCount++;
			});
		}

		function fetchWorkorderDetails(workorderID, vehicleID) {
			const queue = {};
			if (workordersDetailsMap[workorderID]) {
				if (workordersDetailsMap[workorderID].workorder) {
					queue.workorder = $q.resolve(workordersDetailsMap[workorderID].workorder);
				} else {
					queue.workorder = fetchWorkOrder(workorderID, vehicleID);
				}

				if (workordersDetailsMap[workorderID].parts) {
					queue.parts = $q.resolve(workordersDetailsMap[workorderID].parts);
				} else {
					queue.parts = fetchWorkOrderParts(workorderID, vehicleID);
				}

				if (workordersDetailsMap[workorderID].inventories) {
					queue.inventories = $q.resolve(workordersDetailsMap[workorderID].inventories);
				} else {
					queue.inventories = fetchWorkOrderInventories(workorderID, vehicleID);
				}

				if (workordersDetailsMap[workorderID].labors) {
					queue.labors = $q.resolve(workordersDetailsMap[workorderID].labors);
				} else {
					queue.labors = fetchWorkOrderLabors(workorderID, vehicleID);
				}

				if (workordersDetailsMap[workorderID].miscfees) {
					queue.miscfees = $q.resolve(workordersDetailsMap[workorderID].miscfees);
				} else {
					queue.miscfees = fetchMiscfeesData(workorderID, vehicleID);
				}
				if (workordersDetailsMap[workorderID].workorderpackage) {
					queue.workorderpackage = $q.resolve(workordersDetailsMap[workorderID].workorderpackage);
				} else {
					queue.workorderpackage = fetchWorkOrderPackageListData(workorderID, vehicleID);
				}
				if (workordersDetailsMap[workorderID].workorderwarranty) {
					queue.workorderwarranty = $q.resolve(workordersDetailsMap[workorderID].workorderwarranty);
				} else {
					queue.workorderwarranty = fetchWorkOrderWarrantyListData(workorderID, vehicleID);
				}

				if (workordersDetailsMap[workorderID].rogerdollarredeem) {
					queue.rogerdollarredeem = $q.resolve(workordersDetailsMap[workorderID].rogerdollarredeem);
				} else {
					queue.rogerdollarredeem = fetchRogerDollarRedeemData(workorderID, vehicleID);
				}
			} else {
				queue.workorder = fetchWorkOrder(workorderID, vehicleID);
				queue.parts = fetchWorkOrderParts(workorderID, vehicleID);
				queue.inventories = fetchWorkOrderInventories(workorderID, vehicleID);
				queue.labors = fetchWorkOrderLabors(workorderID, vehicleID);
				queue.miscfees = fetchMiscfeesData(workorderID, vehicleID);
				queue.workorderpackage = fetchWorkOrderPackageListData(workorderID, vehicleID);
				queue.workorderwarranty = fetchWorkOrderWarrantyListData(workorderID, vehicleID);
				queue.rogerdollarredeem = fetchRogerDollarRedeemData(workorderID, vehicleID);
			}

			return $q.all(queue)
				.then(function (result) {
					if (!result || !result.workorder) {
						return $q.reject("Failed to fetch workorder details: id " + workorderID);
					}
					if (!result.workorder.isCompleted()) {
						return $q.resolve(result);
					}

					if (workordersDetailsMap[workorderID]) {
						if (workordersDetailsMap[workorderID].discounts) {
							result.discounts = $q.resolve(workordersDetailsMap[workorderID].discounts);
						} else {
							result.discounts = fetchWorkOrderDiscounts(workorderID, vehicleID);
						}

						if (workordersDetailsMap[workorderID].payments) {
							result.payments = $q.resolve(workordersDetailsMap[workorderID].payments);
						} else {
							result.payments = fetchWorkOrderPayments(workorderID, vehicleID);
						}


					} else {
						result.discounts = fetchWorkOrderDiscounts(workorderID, vehicleID);
						result.payments = fetchWorkOrderPayments(workorderID, vehicleID);
					}

					return $q.all(result);
				})
				.then(function (result) {
					workordersDetailsMap[workorderID] = result;
					return $q.resolve(result);
				})
		}

		function isAnyInventoryInsufficient(demandMap, workorderInventories) {
			if (!demandMap || !Array.isArray(workorderInventories)) {
				return;
			}

			return !!workorderInventories.find(function (inventory) {
				return !!inventory && !!demandMap[inventory.fk_id_inventory] && demandMap[inventory.fk_id_inventory].totalDemand > demandMap[inventory.fk_id_inventory].totalInStock;
			});
		}

		function isAnyPartsNotOrdered(parts) {
			if (!Array.isArray(parts)) {
				return;
			}

			return !!parts.find(function (part) {
				return !!part && !part.is_returned && !part.is_ordered;
			});
		}

		function addToDemandMap(demandMap, workorderInventories) {
			if (!demandMap || !Array.isArray(workorderInventories)) {
				return;
			}

			workorderInventories.forEach(function (inventory) {
				if (!inventory) {
					return;
				}

				const quantityInStock = GeneralTools.parseNumber(inventory.quantity_in_stock);
				const demandQuantity = GeneralTools.parseNumber(inventory.quantity);

				if (demandMap[inventory.fk_id_inventory]) {
					demandMap[inventory.fk_id_inventory].totalInStock = quantityInStock;
					demandMap[inventory.fk_id_inventory].totalDemand += demandQuantity;
					return;
				}

				demandMap[inventory.fk_id_inventory] = {
					totalInStock: quantityInStock,
					totalDemand: demandQuantity,
					code: inventory.code,
					name: inventory.name
				}
			});

			return demandMap;
		}

		function fetchWorkOrderDiscounts(workOrderID, vehicleID) {
			const resourcePath = {
				companyID: companyID,
				vehicleID: vehicleID,
				workorderID: workOrderID
			};

			const request = WorkOrderService.getDiscounts(resourcePath);
			requests.push(request);

			return request.$promise;
		}

		function fetchWorkOrderPayments(workOrderID, vehicleID) {
			const resourcePath = {
				companyID: companyID,
				vehicleID: vehicleID,
				workorderID: workOrderID
			};

			const request = WorkOrderService.getPayments(resourcePath);
			requests.push(request);

			return request.$promise;
		}

		function refreshDemandMap(inventories) {
			return $q.resolve()
		}

		function fetchWorkOrderParts(workOrderID, vehicleID) {
			const resourcePath = {
				companyID: companyID,
				vehicleID: vehicleID,
				workorderID: workOrderID
			};

			const request = WorkOrderService.getWorkOrderParts(resourcePath);
			requests.push(request);

			return request.$promise;
		}

		function fetchWorkOrderInventories(workOrderID, vehicleID) {
			const resourcePath = {
				companyID: companyID,
				vehicleID: vehicleID,
				workorderID: workOrderID
			};

			const request = WorkOrderService.getWorkOrderInventories(resourcePath);
			requests.push(request);

			return request.$promise;
		}

		function showWarningMessageBox() {
			return !vm.showNewWorkOrderAppointment && (
				vm.passedDueTimeCount > 0 ||
				vm.emptyWorkordersCount > 0 ||
				vm.inventoryInsufficientCount > 0 ||
				vm.completedWithOutstandingCount > 0 ||
				vm.partsNotOrderedCount > 0 ||
				vm.underRateWorkordersCount > 0
			)
		}

		function refreshNotEnroughRetailPriceOnPartWorkorderWarningMessage(appointments, workorderDetails) {
			if (!Array.isArray(appointments) || !workorderDetails) {
				return;
			}

			const appointmentMap = {};
			vm.underRateWorkorders = {};
			vm.underRateWorkordersCount = 0;

			appointments.forEach(function (appointment) {
				if (!appointment || !appointment.extendedProps || appointment.extendedProps.isCustomAppointment || !isAppointmentExpected(appointment.extendedProps.status)) {
					return;
				}

				if (!Array.isArray(appointmentMap[appointment.extendedProps.workOrderID])) {
					appointmentMap[appointment.extendedProps.workOrderID] = [];
				}

				appointmentMap[appointment.extendedProps.workOrderID].push(appointment);
			});

			Object.keys(workorderDetails).forEach(function (workorderID) {
				if (!workorderDetails[workorderID] 
					|| !workorderDetails[workorderID].workorder 

					||
					(
					workorderDetails[workorderID].workorder.fk_id_work_order_status != WorkOrderConstants.statusIDs.quoted
					&& workorderDetails[workorderID].workorder.fk_id_work_order_status != WorkOrderConstants.statusIDs.booked
					&& workorderDetails[workorderID].workorder.fk_id_work_order_status != WorkOrderConstants.statusIDs.onlot
					&& workorderDetails[workorderID].workorder.fk_id_work_order_status != WorkOrderConstants.statusIDs.started
					)

					|| !Array.isArray(appointmentMap[workorderID])
					|| appointmentMap[workorderID].length <= 0){
					return;
				}

				if (isAnyPartsUnderRate(workorderDetails[workorderID].parts)) {
					vm.underRateWorkorders[workorderID] = {
						workorder: workorderDetails[workorderID].workorder,
						appointments: appointmentMap[workorderID]
					};

					vm.underRateWorkordersCount++;
				}
			});
		}

		function isAnyPartsUnderRate(parts) {
			if (!Array.isArray(parts)) {
				return;
			}

			return !!parts.find(function (part) {
				return !!part && !(part.purchase_price * 0.6 < part.retail_price);
			});
		}

		function initNewCustomAppointment() {
			var length = window.localStorage.getItem('customAppointmentHolderLength');
			var title = window.localStorage.getItem('customAppointmentHolderTitle');
			var category = window.localStorage.getItem('customAppointmentHolderCategory');
			var createBy = window.localStorage.getItem('customAppointmentHolderCreateBy');

			if (!$stateParams.customerID || $stateParams.vehicleID || $stateParams.workOrderID || length == null || title == null || category == null) {
				return;
			}
			MessageService.showToast("Drag and drop the appointment to the calendar to create a new appointment.");

			const queue = {
				customer: fetchCustomerById($stateParams.customerID),
				length: length,
				title: title,
				category: category,
				createBy: createBy
			};

			vm.showNewCustomAppointment = true;
			vm.loadingNewCustomAppointment = true;

			$q.all(queue)
				.then(function (result) {
					if (!result || result.customer.data.length != 1) {
						return $q.reject("custom appointment information invalid.");
					}
					buildNewCustomAppointmentObj(result.customer.data, result.title, result.length, result.category, result.createBy);
					vm.CustomerUrl = getCustomerUrl($stateParams.customerID);
				})
				.catch(MessageService.showToast)
				.finally(function () {
					window.localStorage.removeItem('customAppointmentHolderLength');
					window.localStorage.removeItem('customAppointmentHolderTitle');
					window.localStorage.removeItem('customAppointmentHolderCategory');
					window.localStorage.removeItem('customAppointmentHolderCreateBy');
					vm.loadingNewCustomAppointment = false;
			});


		}

		function getCustomerUrl(CustomerID) {
			return $state.href("app.view-customer", {customerID: CustomerID, tab: 'Appointments'});
		}

		function buildNewCustomAppointmentObj(serviceMap, appointmentTitle, appointmentLength, appointmentCategory, appointmentCreateBy) {
			if (!serviceMap || !appointmentTitle || !appointmentLength || !appointmentCategory) {
				return;
			}

			var title = '';

			
			
			if(appointmentTitle != null){
				title += appointmentTitle;
			}else if (serviceMap[0] && serviceMap[0].first_name) {
				title += serviceMap[0].first_name + ' ' + serviceMap[0].last_name;
			}


			var totalLaborTime = 0;

			totalLaborTime += Number(appointmentLength) / 60;

			totalLaborTime = Math.ceil(totalLaborTime / 0.25) * 0.25;

			if (totalLaborTime > maxAppointmentDuration) {
				totalLaborTime = maxAppointmentDuration;
			}

			if (totalLaborTime <= 0) {
				totalLaborTime = defaultAppointmentDuration;
			}



			const newCustomAppointment = {
				title: title,
				textColor: eventTextColor,
				duration: {
					hours: Math.floor(totalLaborTime),
					minutes: totalLaborTime % 1 * 60
				},
				extendedProps: {
					isCustomAppointment: false,
					isCustomerCustomAppointment: true
				},
				url: getCustomerUrl(serviceMap[0].id_customer),
				category: appointmentCategory,
				createBy: appointmentCreateBy
			}

			vm.customAppointmentTitle = title;

			const draggableEl = document.getElementById('newCustomAppointment');
			new FullCalendarInteraction.Draggable(draggableEl, { eventData: newCustomAppointment });
		}
		
		function fetchCustomerById(customerID) {
			var resourcePath = {
				customerID: customerID,
				companyID: companyID
			};

			return CustomersService.getCustomers(resourcePath, null, null, null);
		}

		function createCustomAppointment(calendarEvent, calendarID) {
			if (!calendarEvent) {
				return $q.reject("calendar event invalid");
			}

			const resourcePath = { companyID: companyID, customerID: $stateParams.customerID };
			const requestBody = {
				title: calendarEvent.title,
				start: moment(calendarEvent.start).utc().format(appointmentTimeFormat),
				end: moment(calendarEvent.end).utc().format(appointmentTimeFormat),
				fk_id_calendar: calendarID,
				fk_id_customer: $stateParams.customerID,
				category: calendarEvent.extendedProps.category,
				create_by: calendarEvent.extendedProps.createBy
			}

			return AppointmentsService.createCustomAppointment(resourcePath, requestBody);
		}

		function castCustomAppointmentToCalenderEvent(workOrderAppointment) {
			if (!workOrderAppointment) {
				return;
			}
		
			const queue = {
				customer: fetchCustomerById(workOrderAppointment.fk_id_customer),
				user: fetchUserById(workOrderAppointment.create_by)
			};
		
			return $q.all(queue)
				.then(function(result) {
					if (!result || result.customer.data.length !== 1) {
						return $q.reject("Custom appointment information invalid.");
					}
		
					const customer = result.customer.data[0];
					const user = result.user[0];
					let tempTitleParts = [];
					var tempHolder = null;
		
					if (workOrderAppointment.fk_id_appointment_status === 5) {
						tempTitleParts.push(confirmAppointmentTag);
					} else if (workOrderAppointment.fk_id_appointment_status === 6) {
						tempTitleParts.push(cancelAppointmentTag);
					}
		
					if (customer.getFullName()) {
						tempHolder = '[ ' + customer.getFullName() + ' ]'
						tempTitleParts.push(tempHolder);
						tempHolder = null;
					}
		
					if (customer.getPhoneNumber()) {
						tempHolder = '[ ' + customer.getPhoneNumber() + ' ]'
						tempTitleParts.push(tempHolder);
						tempHolder = null;
					}
		
					if (workOrderAppointment.title) {
						tempHolder = '[ ' + workOrderAppointment.title + ' ]'
						tempTitleParts.push(tempHolder);
						tempHolder = null;
					}
		
					if (user.username) {
						tempHolder = '[ ' + user.username + ' ]'
						tempTitleParts.push(tempHolder);
						tempHolder = null;
					}
		
					const tempTitle = tempTitleParts.join(' - ');
		
					const event = {
						title: tempTitle,
						start: workOrderAppointment.start,
						end: workOrderAppointment.end,
						color: getCalendarColor(workOrderAppointment.fk_id_calendar, workOrderAppointment.fk_id_work_order_status),
						textColor: eventTextColor,
						extendedProps: {
							isCustomAppointment: false,
							isCustomerCustomAppointment: true,
							appointmentID: workOrderAppointment.id_appointment,
							status: workOrderAppointment.fk_id_appointment_status,
							workOrderID: workOrderAppointment.fk_id_work_order,
							vehicleID: workOrderAppointment.fk_id_vehicle,
							customerID: workOrderAppointment.fk_id_customer,
							category: workOrderAppointment.category,
							createBy: workOrderAppointment.create_by
						},
						url: getCustomerUrl(workOrderAppointment.fk_id_customer)
					};
		
					return event;
				})
				.catch(MessageService.showToast);
		}
		
		
		

		function fetchUserById(userId) {
			var inspectorResourcePath = {
				companyID: companyID,
				userID: userId
			};
			return UserService.getUsers(inspectorResourcePath, null);
		}
	}
})();
(function ()
{
	"use strict";

	angular
		.module("app.workOrders")
		.component("scheduleWarningItem", {
				bindings:{
					title: '<',
					workorderAppointmentDetails: '<'
				},
				templateUrl: "app/main/workorders/schedule/schedule-warning-item.html",
				controller: componentController,
		  		controllerAs: 'vm'
			});

		function componentController($state, WorkOrderConstants){
			const vm = this;
			vm.getWorkorderUrl = getWorkorderUrl;
			vm.warningMessageDateFormat = WorkOrderConstants.scheduleDateFormat;
			vm.getCount = getCount;
			function getCount(){
				var count = 0;

				if(!vm.workorderAppointmentDetails){
					return count;
				}

				Object.keys(vm.workorderAppointmentDetails).forEach(function(key){
					if(vm.workorderAppointmentDetails[key] 
						&& Array.isArray(vm.workorderAppointmentDetails[key].appointments) 
						&& vm.workorderAppointmentDetails[key].appointments.length > 0){
						count++;
					}
				});

				return count;
			}

			function getWorkorderUrl(workorderID, vehicleID){
				return $state.href("app.edit-workorder.general", {workOrderID: workorderID, vehicleID: vehicleID});
			}
		}
})();
(function ()
{
	'use strict';

	angular
		.module('app.workOrders')
		.controller('CalendarTitleEditorDialogController', CalendarTitleEditorDialogController);

	function CalendarTitleEditorDialogController(title, $mdDialog){   
		const vm = this;

		vm.title = title;
		vm.closeDialog = closeDialog;
		vm.save = save
		vm.deleteClicked = deleteClicked

		function deleteClicked(){
			$mdDialog.hide({delete: true});
		}

		function save() {
			$mdDialog.hide({
				confirm: true,
				title: vm.title
			});
		}

		function closeDialog (){
			$mdDialog.hide();
		}
	}
})();
(function ()
{
	'use strict';

	angular
		.module('app.workOrders')
		.controller('NewScheduleController', NewScheduleController);

	function NewScheduleController(api, $interval, WorkOrderSummaryCalculator, AppointmentConstants, customerportalcalendars, WorkOrderConstants, ToolsConstants, DialogService, UserConfigService, UserConfigConstants, userConfig, AppointmentsService, LoginConst, $location, $state, VehicleService, GeneralTools, $stateParams, $scope, $q, $timeout, MessageService, $mdDialog, SaleInfoService, WorkOrderService, CustomersService, calendars, LoginService, UserService) {
		const vm = this;
		const deleteAppointmentWarningTitle = "Delete Appointment";
		const companyID = LoginService.getCompanyID();
		const userID = LoginService.getUserID();
		const maxAppointmentDuration = 8;
		const defaultAppointmentDuration = 1;
		const eventTextColor = "white";
		const startKeyName = "start";
		const calendarKeyName = "fk_id_calendar";
		const customAppointmentTag = "[CUSTOM]";
		const confirmAppointmentTag = "[CONFIRMED]  ";
		const cancelAppointmentTag = "[CANCELLED]  ";
		
		const timeRangeFilterFormat = "YYYY-MM-DD HH:mm:ss";
		const appointmentTimeFormat = "YYYY-MM-DD[T]HH:mm:ss[Z]";
		const calendarHeader = {
			left: WorkOrderConstants.calendarViews.dayGridMonth + ',' + WorkOrderConstants.calendarViews.timeGridWeek + ',' + WorkOrderConstants.calendarViews.timeGridDay,
			center: "title",
			right: "prev,today,next"
		};
		const calendarViewsOptions = {
			timeGrid: {
				minTime: "9:00:00",
				maxTime: "19:00:00",
				allDaySlot: false,
				slotDuration: "00:15:00",
				slotLabelInterval: "01:00"
			}
		};
		const requests = [];
		
		vm.calendarWorkOrder = new Map();
		var calendarGrid;
		var workOrder;
		var workordersDetailsMap = {};
		vm.DateFilter = new Date();

		vm.warningMessageDateFormat = WorkOrderConstants.scheduleDateFormat;
		vm.refreshCalendarGrid = refreshCalendarGrid;
		vm.refreshCalendarNotification = refreshCalendarNotification;
		vm.isCustomFilterApplied = isCustomFilterApplied;
		vm.selectCustomFilter = selectCustomFilter;
		vm.deleteCustomFilter = deleteCustomFilter;
		vm.addCustomFilter = addCustomFilter;
		vm.showWarningMessageBox = showWarningMessageBox;
		vm.getWorkorderUrl = getWorkorderUrl;
		vm.initCalendarGrid = initCalendarGrid;

		vm.tempWorkOrder = [
			{
				"invoice_number": "H123456",
				"work_order_id_url": "http://localhost:3001/vehicle/3931/workorder/7038/general",
				"on_lot_time": "2025-01-21 16:46:54"
			},
			{
				"invoice_number": "H123457",
				"work_order_id_url": "http://localhost:3001/vehicle/3932/workorder/7039/general",
				"on_lot_time": "2025-01-21 16:41:54"
			},
			{
				"invoice_number": "H123458",
				"work_order_id_url": "http://localhost:3001/vehicle/3933/workorder/7040/general",
				"on_lot_time": "2025-01-21 16:36:54"
			},
			{
				"invoice_number": "H123459",
				"work_order_id_url": "http://localhost:3001/vehicle/3934/workorder/7041/general",
				"on_lot_time": "2025-01-21 16:31:54"
			},
			{
				"invoice_number": "H123460",
				"work_order_id_url": "http://localhost:3001/vehicle/3935/workorder/7042/general",
				"on_lot_time": "2025-01-21 16:26:54"
			},
			{
				"invoice_number": "H123457",
				"work_order_id_url": "http://localhost:3001/vehicle/3932/workorder/7039/general",
				"on_lot_time": "2025-01-21 16:41:54"
			},
			{
				"invoice_number": "H123458",
				"work_order_id_url": "http://localhost:3001/vehicle/3933/workorder/7040/general",
				"on_lot_time": "2025-01-21 16:36:54"
			},
			{
				"invoice_number": "H123459",
				"work_order_id_url": "http://localhost:3001/vehicle/3934/workorder/7041/general",
				"on_lot_time": "2025-01-21 16:31:54"
			},
			{
				"invoice_number": "H123460",
				"work_order_id_url": "http://localhost:3001/vehicle/3935/workorder/7042/general",
				"on_lot_time": "2025-01-21 16:26:54"
			},
			{
				"invoice_number": "H123457",
				"work_order_id_url": "http://localhost:3001/vehicle/3932/workorder/7039/general",
				"on_lot_time": "2025-01-21 16:41:54"
			},
			{
				"invoice_number": "H123458",
				"work_order_id_url": "http://localhost:3001/vehicle/3933/workorder/7040/general",
				"on_lot_time": "2025-01-21 16:36:54"
			},
			{
				"invoice_number": "H123459",
				"work_order_id_url": "http://localhost:3001/vehicle/3934/workorder/7041/general",
				"on_lot_time": "2025-01-21 16:31:54"
			},
			{
				"invoice_number": "H123460",
				"work_order_id_url": "http://localhost:3001/vehicle/3935/workorder/7042/general",
				"on_lot_time": "2025-01-21 16:26:54"
			},
		]

		vm.calendarOrder = [
			3,
			1,
			2,
			4,
			5,
			6,
			7,
			8,
			9,
			10
		]
		

		init();

		function init() {
			initCustomFilters();
			initCalendarOptions();
			initCalendarFilters();
			// initWorkOrder();
			initCalendarGrid();
			// initNewWorkOrderAppointment();
			// initNewAppointment();
			// initNewCustomAppointment();
			// $scope.$on("$stateChangeStart", cancelRequest);
		}

		vm.redirectToUrl = function(work_order_id, vehicle_id) {
			var url = vm.getWorkorderUrl(work_order_id, vehicle_id);
			window.open(url, '_blank');
		};

		vm.calculateTimeElapsed = function(workorder) {
			var onLotTime = workorder.on_lot_time;
			if(onLotTime == null){
				onLotTime = workorder.start
			}
			const onLot = new Date(onLotTime);
			const now = new Date();
			const diffMs = Math.abs(now - onLot); // Difference in milliseconds
			const hours = Math.floor(diffMs / (1000 * 60 * 60));
			const minutes = Math.floor((diffMs % (1000 * 60 * 60)) / (1000 * 60));
			const seconds = Math.floor((diffMs % (1000 * 60)) / 1000);
			var time = hours + "h " + minutes + "m " + seconds + "s ";
			return time;
			;
		};

		vm.getElapsedTimeColor = function (workorder) {
			var onLotTime = workorder.on_lot_time;
			if (onLotTime == null) {
				onLotTime = workorder.start;
			}
		
			const onLot = new Date(onLotTime);
			const now = new Date();
		
			// Check if onLotTime is in the future
			if (onLot > now) {
				return 'white';
			}
		
			const diffMs = Math.abs(now - onLot); // Difference in milliseconds
			const minutes = Math.floor(diffMs / (1000 * 60)); // Convert ms to minutes
		
			if (minutes < 5) {
				return 'black';
			} else if (minutes < 15) {
				return 'orange';
			} else {
				return 'red';
			}
		};

		$interval(function() {
			// No need to manually call $apply as $interval triggers the digest cycle
		}, 1000);

		function cancelRequest() {
			for (var i = requests.length - 1; i >= 0; i--) {
				const request = requests[i];

				if (request && request.$cancelRequest) {
					request.$cancelRequest();
					requests.splice(i, 1);
				}
			}
		}

		function initNewWorkOrderAppointment() {
			if (!$stateParams.workOrderID || !$stateParams.vehicleID) {
				return;
			}

			const queue = {
				workOrder: fetchWorkOrder($stateParams.workOrderID, $stateParams.vehicleID),
				labors: fetchWorkOrderLabors($stateParams.workOrderID, $stateParams.vehicleID),
				vehicle: fetchVehicle($stateParams.vehicleID),
				serviceMap: fetchServiceMap($stateParams.vehicleID),
				saleInfo: fetchSaleInfo($stateParams.vehicleID)
			};

			vm.showNewWorkOrderAppointment = true;
			vm.loadingNewWorkorderAppointment = true;

			$q.all(queue)
			
				.then(function (result) {
					if (!result) {
						return $q.reject("work order result invalid.");
					}
					workOrder = result.workOrder;
					getRelavenCustomer(result.serviceMap, result.saleInfo).then(function(customerName){
						buildNewWorkOrderAppointmentObj(result.workOrder, result.labors, result.vehicle, result.serviceMap, customerName);
						vm.workOrderUrl = getWorkorderUrl($stateParams.workOrderID, $stateParams.vehicleID);
					})
				})
				.catch(MessageService.showToast)
				.finally(function () {
					vm.loadingNewWorkorderAppointment = false;
				});
		}

		function getRelavenCustomer(serviceMap, saleInfo) {
			var tempStartDate = moment('1000-01-01', 'YYYY-MM-DD');
			var tempCustomerId = null
			var isCustomerFromSaleInfo = false
			if (!Array.isArray(serviceMap) && !Array.isArray(saleInfo)) {
				return;
			}

			if (serviceMap.length > 0 && saleInfo.length == 0) {
				serviceMap.forEach(function (customer) {
					if (customer.customer.work_order_filter_start != null && tempStartDate.isBefore(moment(customer.customer.work_order_filter_start, 'YYYY-MM-DD'))) {
						tempStartDate = moment(customer.customer.work_order_filter_start, 'YYYY-MM-DD')
						tempCustomerId = customer.customer.id_customer
					}else if(tempCustomerId == null && customer.customer.work_order_filter_start == null ){
						tempCustomerId = customer.customer.id_customer
					}
				})
				const resourcePath = {
					companyID: companyID,
					customerID: tempCustomerId
				};
				return CustomersService.getCustomers(resourcePath)
					.then(function (result) {
						if (result && result.data.length > 0) {
							return result.data[0].first_name + ' ' + result.data[0].last_name
						}
						return $q.resolve(null);
					})
					.catch(MessageService.showToast);

			} else if (saleInfo.length > 0 && serviceMap.length == 0) {
				saleInfo.forEach(function (customer) {
					if (customer.work_order_filter_start != null && tempStartDate.isBefore(moment(customer.work_order_filter_start, 'YYYY-MM-DD'))) {
						tempStartDate = moment(customer.work_order_filter_start, 'YYYY-MM-DD')
						tempCustomerId = customer.fk_id_customer
						isCustomerFromSaleInfo = true
					}else if(tempCustomerId == null && customer.work_order_filter_start == null ){
						tempCustomerId = customer.fk_id_customer
					}
				})



				const resourcePath = {
					companyID: companyID,
					customerID: tempCustomerId
				};
				return CustomersService.getCustomers(resourcePath).then(function (result) {
					if (result && result.data.length > 0) {
						return result.data[0].first_name + ' ' + result.data[0].last_name
					}
					return $q.resolve(null);
				})
					.catch(MessageService.showToast);

			} else {
				serviceMap.forEach(function (customer) {
					if (customer.customer.work_order_filter_start != null && tempStartDate.isBefore(moment(customer.customer.work_order_filter_start, 'YYYY-MM-DD'))) {
						tempStartDate = moment(customer.customer.work_order_filter_start, 'YYYY-MM-DD')
						tempCustomerId = customer.customer.id_customer
					}else if(tempCustomerId == null && customer.customer.work_order_filter_start == null ){
						tempCustomerId = customer.customer.id_customer
					}
				})
				saleInfo.forEach(function (customer) {
					if (customer.work_order_filter_start != null && tempStartDate.isBefore(moment(customer.work_order_filter_start, 'YYYY-MM-DD'))) {
						tempStartDate = moment(customer.work_order_filter_start, 'YYYY-MM-DD')
						tempCustomerId = customer.fk_id_customer
						isCustomerFromSaleInfo = true
					}else if(tempCustomerId == null && customer.customer.work_order_filter_start == null ){
						tempCustomerId = customer.customer.id_customer
					}
				})


				const resourcePath = {
					companyID: companyID,
					customerID: tempCustomerId
				};
				return CustomersService.getCustomers(resourcePath)
					.then(function (result) {
						if (result && result.data.length > 0) {
							return result.data[0].first_name + ' ' + result.data[0].last_name
						}
						return $q.resolve(null);
					})
					.catch(MessageService.showToast);
			}
		}

		function getWorkorderUrl(workorderID, vehicleID) {
			return $state.href("app.edit-workorder.general", { workOrderID: workorderID, vehicleID: vehicleID });
		}

		function initCustomFilters() {
			if (!userConfig) {
				return;
			}

			vm.pageConfigs = userConfig.getPageConfigs(UserConfigConstants.pageKeyNames.workOrderActiveSchedule);
		}

		function initCalendarFilters() {
			const pageConfigs = LoginService.getPageConfigs(LoginConst.pageConfigKeys.workorderSchedule);
			var calendarFilter = GeneralTools.urlObjectParamTranslator($stateParams.calendarFilters);

			if (Array.isArray(calendarFilter)) {
				applyCalendarFilter(calendarFilter);
				return;
			}

			if (pageConfigs && pageConfigs.currentCalendar) {
				const customFilter = getCustomFilterByName(pageConfigs.currentCalendar);

				if (customFilter) {
					calendarFilter = customFilter.calendars;
				}
			}

			applyCalendarFilter(calendarFilter);
		}

		function initCalendarOptions() {
			vm.calendars = calendars;

			if (!Array.isArray(vm.calendars)) {
				vm.calendars = [];
			}

			vm.calendars.sort(function (a, b) {
				return vm.calendarOrder.indexOf(a.id_calendar) - vm.calendarOrder.indexOf(b.id_calendar);
			});

			vm.calendars.forEach(function (calendar) {
				if(vm.calendarWorkOrder.get(calendar.id_calendar) == undefined){
					vm.calendarWorkOrder.set(calendar.id_calendar, []);
				}
			})
		}

		function initCalendarGrid() {

			const startDate = vm.DateFilter

			const startOfDay = new Date(
				startDate.getFullYear(),
				startDate.getMonth(),
				startDate.getDate(),
				0, 0, 0
			);
			
			// Create a variable for the end of the day
			const endOfDay = new Date(
				startDate.getFullYear(),
				startDate.getMonth(),
				startDate.getDate(),
				23, 59, 59
			);

			//empty the array in calendarWorkOrder
			vm.calendarWorkOrder.forEach(function(value, key){
				vm.calendarWorkOrder.set(key, [])
			});


			return fetchEvents(moment( startOfDay.toISOString()), moment(endOfDay.toISOString()));
		}

		function getCalenderEventsByTimeRange(events, startMomentObj, endTimeMomentObj) {
			if (!Array.isArray(events) || !startMomentObj || !startMomentObj.isValid() || !endTimeMomentObj || !endTimeMomentObj.isValid()) {
				return;
			}

			return events.filter(function (event) {
				if (!event || !event.start) {
					return;
				}
				const eventStart = moment(event.start);
				return eventStart.isValid() && eventStart.isSameOrAfter(startMomentObj) && eventStart.isSameOrBefore(endTimeMomentObj)
			});
		}

		function getCalendarDefaultView() {
			if ((!GeneralTools.isMobileOrTabletDevice() && $stateParams.workOrderID && $stateParams.vehicleID) || $stateParams.customerID) {
				return WorkOrderConstants.calendarViews.timeGridWeek;	
			}

			return WorkOrderConstants.calendarViews.timeGridDay;
		}

		function showEditAppointmentDialog(calendarEvent) {
			if (!calendarEvent || !calendarEvent.extendedProps) {
				return;
			}
			const originTitle = removeCustomTag(calendarEvent.title);
			const dialogOptions = {
				controller: 'CalendarTitleEditorDialogController',
				controllerAs: 'vm',
				templateUrl: 'app/main/workorders/schedule/calendar-event-title-editor-dialog.html',
				clickOutsideToClose: true,
				locals: { title: originTitle },
			};

			$mdDialog.show(dialogOptions)
				.then(function (result) {
					if (!result) {
						return;
					}

					if (result.delete) {
						showDeleteAppointmentDialog(calendarEvent);
						return;
					}

					if (!result || !result.confirm || result.title == originTitle) {
						return;
					}

					const resourcePath = {
						companyID: companyID,
						appointmentID: calendarEvent.extendedProps.appointmentID
					}

					const requestBody = {
						title: result.title
					}
					AppointmentsService.updateAppointment(resourcePath, requestBody)
						.then(function () {
							calendarEvent.setProp("title", customAppointmentTag + result.title);
						})
						.catch(MessageService.showToast)
				})
				.catch(function (error) {
					if (error) {
						MessageService.showToast(error);
					}
				});
		}

		function showDeleteAppointmentDialog(calendarEvent) {
			if (!calendarEvent) {
				return;
			}

			const warningMessage = "Are you sure to delete appointment " + calendarEvent.title;

			const resourcePath = {
				companyID: companyID,
				appointmentID: calendarEvent.extendedProps.appointmentID
			}

			DialogService.showYesOrNoDialog(deleteAppointmentWarningTitle, warningMessage)
				.then(function (yes) {
					if (yes) {
						return AppointmentsService.deleteAppointment(resourcePath);;
					}

					return $q.reject();
				})
				.then(function () {
					calendarEvent.remove()
				})
				.catch(function (error) {
					if (error) {
						MessageService.showToast(error);
					}
				});
		}

		function removeCustomTag(title) {
			if (!title) {
				return;
			}

			if (title.startsWith(customAppointmentTag)) {
				title = title.substring(customAppointmentTag.length, title.length);
			}

			return title;
		}

		function updateAppointmentTime(calendarEvent) {
			if (!calendarEvent.extendedProps) {
				return;
			}

			const requestBody = {
				start: moment(calendarEvent.start).utc().format(appointmentTimeFormat),
				end: moment(calendarEvent.end).utc().format(appointmentTimeFormat)
			}

			var promise = $q.resolve();

			vm.isUpdatingEvent = true;

			if (calendarEvent.extendedProps.isCustomAppointment || calendarEvent.extendedProps.isCustomerCustomAppointment) {
				const resourcePath = {
					companyID: companyID,
					appointmentID: calendarEvent.extendedProps.appointmentID
				};

				promise = AppointmentsService.updateAppointment(resourcePath, requestBody);
			} else {
				const resourcePath = {
					companyID: companyID,
					workorderappointmentID: calendarEvent.extendedProps.appointmentID
				};

				promise = WorkOrderService.updateAppointment(resourcePath, requestBody);
			}

			promise
				.then(refreshWarningMessages)
				.catch(MessageService.showToast)
				.finally(function () {
					vm.isUpdatingEvent = false;
				});
		}

		function onAppointmentAdd(calendarEvent) {
			if (!calendarEvent.extendedProps) {
				return;
			}

			vm.isAddingEvent = true;

			showCalendarDialog()
				.then(function (calendar) {
					if (!calendar) {
						return $q.reject();
					}

					calendarEvent.setProp("backgroundColor", calendar.color);

					if (calendarEvent.extendedProps.isCustomAppointment) {
						return createAppointment(calendarEvent, calendar.id_calendar)
					}
					else if(!calendarEvent.extendedProps.isCustomAppointment && calendarEvent.extendedProps.isCustomerCustomAppointment){
						return createCustomAppointment(calendarEvent, calendar.id_calendar);
					}
					else{
						return createWorkOrderAppointment(calendarEvent, calendar.id_calendar);
					}
				})
				.then(function (newID) {
					calendarEvent.setExtendedProp("appointmentID", newID);
					MessageService.showToast("Appointment is added to the schedule.");
					if (calendarEvent.extendedProps.isCustomAppointment) {
						calendarEvent.setProp("title", customAppointmentTag + vm.newAppointment.title);
						return $q.resolve()
					} else {
						calendarEvent.setExtendedProp("workOrderID", $stateParams.workOrderID);
						calendarEvent.setExtendedProp("vehicleID", $stateParams.vehicleID);
						vm.showNewWorkOrderAppointment = false;
						$timeout(function () {
							$location.search({ calendarFilters: $stateParams.calendarFilters }).replace();
						});
						refreshWarningMessages();
						return $q.resolve()
					}
				})
				.catch(function (message) {
					if (message) {
						MessageService.showToast(message)
					}
					calendarEvent.remove();
				})
				.finally(function () {
					vm.isAddingEvent = false;
				});
		}

		function createAppointment(calendarEvent, calendarID) {
			if (!calendarEvent) {
				return $q.reject("calendar event invalid");
			}

			const resourcePath = { companyID: companyID };
			const requestBody = {
				title: vm.newAppointment.title,
				start: moment(calendarEvent.start).utc().format(appointmentTimeFormat),
				end: moment(calendarEvent.end).utc().format(appointmentTimeFormat),
				fk_id_calendar: calendarID
			}

			return AppointmentsService.createAppointment(resourcePath, requestBody);
		}

		function createWorkOrderAppointment(calendarEvent, calendarID) {
			if (!calendarEvent) {
				return $q.reject("calendar event invalid");
			}

			const resourcePath = { companyID: companyID };
			const requestBody = {
				title: calendarEvent.title,
				start: moment(calendarEvent.start).utc().format(appointmentTimeFormat),
				end: moment(calendarEvent.end).utc().format(appointmentTimeFormat),
				fk_id_calendar: calendarID,
				fk_id_work_order: $stateParams.workOrderID,
				fk_id_vehicle: $stateParams.vehicleID
			}

			return WorkOrderService.createAppointment(resourcePath, requestBody);
		}

		function showCalendarDialog() {
			const selectedCalendars = getSelectedCalendars();

			if (!Array.isArray(selectedCalendars)) {
				return $q.reject("Calendars invalid.");
			}

			if (selectedCalendars.length == 1 && !!selectedCalendars[0]) {
				return $q.resolve(selectedCalendars[0]);
			}

			if (selectedCalendars.length <= 0) {
				selectedCalendars = vm.calendars;
			}

			const dialogOptions = {
				controller: 'SelectCalendarDialogController',
				controllerAs: 'vm',
				templateUrl: 'app/main/workorders/schedule/select-calendar-dialog.html',
				clickOutsideToClose: true,
				locals: { calendars: selectedCalendars }
			};

			return $mdDialog.show(dialogOptions);
		}

		function fetchEvents(startTime, endTime) {
			const defer = $q.defer();
			const resourcePath = { companyID: companyID };
			const filter = getFilter(startTime, endTime);

			const queue = {
				workOrderAppointments: WorkOrderService.getAllMatchedAppointments(resourcePath, filter)
			}
		
			vm.isLoadingEvents = true;
		
			$q.all(queue)
				.then(function(result) {
					if (!result) {
						return $q.reject("Appointments data invalid");
					}

					return buildWorkOrderAppointmentList(result.workOrderAppointments);
				})
				.then(function(appointments) {
					vm.isLoadingEvents = false;
					defer.resolve(appointments);
				})
				.catch(function(error) {
					MessageService.showToast(error);
					vm.isLoadingEvents = false;
					defer.reject(error);
				});
		
			return defer.promise;
		}

		function buildWorkOrderAppointmentList(workOrderAppointments){
			if (!Array.isArray(workOrderAppointments)) {
				return;
			}
			
			workOrderAppointments.forEach(function (workOrderAppointment) {
				if(vm.calendarWorkOrder.get(workOrderAppointment.fk_id_calendar) != undefined && workOrderAppointment.fk_id_work_order_status == 6){
					vm.calendarWorkOrder.get(workOrderAppointment.fk_id_calendar).push(workOrderAppointment)
				}
			})
			vm.calendarWorkOrder.forEach(function(items, key)  {
				items.sort(function(a, b)  {
					const dateA = new Date(a.start || '9999-12-31');
					const dateB = new Date(b.start || '9999-12-31');
					
					return dateA - dateB;
				});
			
				vm.calendarWorkOrder.set(key, items);
			});

			vm.calendarWorkOrder.forEach(function(items, key)  {
				items.sort(function(a, b)  {
					const dateA = new Date(a.on_lot_at || '9999-12-31');
					const dateB = new Date(b.on_lot_at || '9999-12-31');
					
					return dateA - dateB;
				});
			
				vm.calendarWorkOrder.set(key, items);
			});
			
			

			return vm.calendarWorkOrder

		}
		

		function getSelectedCalendars() {
			if (!Array.isArray(vm.calendars)) {
				return;
			}

			return vm.calendars.filter(function (calendar) {
				return !!calendar && calendar.isShow;
			});
		}

		function builtEventList(allAppointments, workOrderAppointments) {
			if (!Array.isArray(allAppointments) || !Array.isArray(workOrderAppointments)) {
				return;
			}
		
			// Create an array of promises
			const eventPromises = allAppointments.map(function (appointment) {
				if (!appointment) {
					return;
				}
				const matchedAppointment = workOrderAppointments.find(function (workOrderAppointment) {
					return !!workOrderAppointment && workOrderAppointment.fk_id_appointment == appointment.id_appointment;
				});
				if (matchedAppointment) {
					return Promise.resolve(castWorkOrderAppointmentToCalenderEvent(matchedAppointment));
				}
		
				if (appointment.fk_id_calendar == 10 && appointment.fk_id_customer != null) {
					return castCustomAppointmentToCalenderEvent(appointment);
				}
		
				return Promise.resolve(castAppointmentToCalenderEvent(appointment));
			});
		
			// Use Promise.all to wait for all promises to resolve
			return Promise.all(eventPromises)
				.then(function(events) {
					// Filter out any undefined events (in case any promises resolved to undefined)
					return events.filter(function(event){
						return (event !== undefined);
					});
				})
				.catch(function(error) {
					// Handle any errors that occurred during the processing of promises
					console.error("Error building event list:", error);
				});
		}
		

		function buildCustomerPortalAppointmentEventList(customerPortalAppointments) {
			if (!Array.isArray(customerPortalAppointments)) {
				return;
			}

			return customerPortalAppointments.map(function (appointment) {
				if (!appointment) {
					return;
				}

				return castCustomerPortalAppointmentToCalenderEvent(appointment);
			});
		}

		function castCustomerPortalAppointmentToCalenderEvent(appointment) {
			if (!appointment) {
				return;
			}
			const event = {};
			var title;

			if (appointment.appointment_type_name) {
				title = appointment.appointment_type_name;
			}
			if (appointment.customer_name) {
				title += ", " + appointment.customer_name;
			}

			if (appointment.vehicle_name) {
				title += ", " + appointment.vehicle_name;
			}


			event.title = title;
			event.start = appointment.start;
			event.end = appointment.end;
			event.color = getCustomerPortalCalendarColor(appointment.fk_id_calendar);
			event.textColor = eventTextColor;
			event.extendedProps = {
				isCustomerPoraltalAppointment: true,
				appointmentID: appointment.id_customer_portal_appointment,
				fk_id_calendar: appointment.fk_id_calendar,
				type: appointment.fk_id_job_type,
				title: title,
				name: appointment.customer_name,
				start: appointment.start,
				end: appointment.end,
				email: appointment.cutomer_email,
				phone: appointment.cutomer_phone,
				additional_info: appointment.customer_additional_information,
				appointment_type: appointment.appointment_type_name,
				vehicle_name: appointment.vehicle_name,
				customer_id: appointment.fk_id_customer,
				vehicle_id: appointment.fk_id_vehicle,
				appointment_status_name: appointment.appointment_status_name,
			}

			if (appointment.fk_id_work_order) {
				event.extendedProps.fk_id_work_order = appointment.fk_id_work_order
				event.url = getWorkorderUrl(appointment.fk_id_work_order, appointment.fk_id_vehicle);
			}
			return event;
		}


		function castAppointmentToCalenderEvent(appointment) {
			if (!appointment) {
				return;
			}

			const event = {};
			var title = customAppointmentTag;
			if (appointment.fk_id_appointment_status == 5) {
				title = confirmAppointmentTag 
			}
			if (appointment.fk_id_appointment_status == 6) {
				title = cancelAppointmentTag 
			}
			
			if (appointment.title) {
				title = title + ' ' + appointment.title;
			}



			event.title = title;
			event.start = appointment.start;
			event.end = appointment.end;
			event.color = getCalendarColor(appointment.fk_id_calendar, appointment.fk_id_appointment_status);
			event.textColor = eventTextColor;
			event.extendedProps = {
				isCustomAppointment: true,
				appointmentID: appointment.id_appointment,
				status: appointment.fk_id_appointment_status
			}

			return event;
		}

		function getCustomerPortalCalendarColor(calendarID) {
			var colorstring = ""
			if (!Array.isArray(vm.calendars)) {
				return;
			}
			const matchedCalendar = vm.calendars.find(function (calendar) {
				if (calendar) {
					return calendar.id_calendar == calendarID;
				}
			});

			if (matchedCalendar) {
				return matchedCalendar.color;
			}
		}

		function castWorkOrderAppointmentToCalenderEvent(workOrderAppointment) {
			if (!workOrderAppointment) {
				return;
			}

			if(workOrderAppointment.fk_id_appointment_status == 5){
				workOrderAppointment.title = confirmAppointmentTag + workOrderAppointment.title;
			}		
			else if(workOrderAppointment.fk_id_appointment_status == 6){
				workOrderAppointment.title = cancelAppointmentTag + workOrderAppointment.title;
			}		


			const event = {};
			event.title = workOrderAppointment.title;
			event.start = workOrderAppointment.start;
			event.end = workOrderAppointment.end;
			event.color = getCalendarColor(workOrderAppointment.fk_id_calendar, workOrderAppointment.fk_id_work_order_status);
			event.textColor = eventTextColor;
			event.extendedProps = {
				isCustomAppointment: false,
				appointmentID: workOrderAppointment.id_work_order_appointment,
				status: workOrderAppointment.fk_id_appointment_status,
				workOrderID: workOrderAppointment.fk_id_work_order,
				vehicleID: workOrderAppointment.fk_id_vehicle,
			}
			event.url = getWorkorderUrl(workOrderAppointment.fk_id_work_order, workOrderAppointment.fk_id_vehicle);
			return event;
		}

		function getCalendarColor(calendarID, workOrderStatusID) {
			var colorstring = ""
			if (!Array.isArray(vm.calendars)) {
				return;
			}
			const matchedCalendar = vm.calendars.find(function (calendar) {
				if (calendar) {
					return calendar.id_calendar == calendarID;
				}
			});

			if (matchedCalendar) {
				if (workOrderStatusID != null && (workOrderStatusID == 3 || workOrderStatusID == 4)) {
					colorstring = matchedCalendar.color;
					colorstring = "rgb(210, 210, 210)"
					return colorstring
				} else {
					return matchedCalendar.color;
				}
			}
			// if(matchedCalendar){
			// 	return matchedCalendar.color;
			// }
		}

		function getFilter(startMoment, endMoment) {
			var calendarFilter = getCalendarFilterString();
			var timeRangeFilter = getTimeRangeFilterString(startMoment, endMoment);

			if (!timeRangeFilter) {
				return;
			}

			timeRangeFilter = GeneralTools.addBracketToString(timeRangeFilter);

			if (calendarFilter) {
				calendarFilter = GeneralTools.addBracketToString(calendarFilter);
			}

			var filterString = GeneralTools.notEqualFilterBuilder(AppointmentConstants.keyNames.appointmentStatus, AppointmentConstants.statusIDs.CANCELLED);

			filterString = GeneralTools.stringConnector(filterString, calendarFilter, ToolsConstants.apiFilters.andConnector);
			filterString = GeneralTools.stringConnector(filterString, timeRangeFilter, ToolsConstants.apiFilters.andConnector);

			return { filters: filterString };
		}

		function getTimeRangeFilterString(startMoment, endMoment) {
			if (!startMoment || !startMoment.isValid() || !endMoment || !endMoment.isValid() || startMoment.isSameOrAfter(endMoment)) {
				return;
			}

			return GeneralTools.equalRangeFilterBuilder(startKeyName, startMoment.utc().format(timeRangeFilterFormat), endMoment.utc().format(timeRangeFilterFormat))
		}

		function getCalendarFilterString() {
			if (!Array.isArray(vm.calendars)) {
				return;
			}

			var filterString = '';
			vm.calendars.forEach(function (calendar) {
				if (calendar && calendar.isShow) {
					filterString = GeneralTools.stringConnector(filterString, GeneralTools.equalFilterBuilder(calendarKeyName, calendar.id_calendar), ToolsConstants.apiFilters.orConnector)
				}
			});

			return filterString;
		}

		function refreshUrl() {
			const urlParams = {};

			if ($stateParams.workOrderID) {
				urlParams.workOrderID = $stateParams.workOrderID;
			}

			if ($stateParams.vehicleID) {
				urlParams.vehicleID = $stateParams.vehicleID;
			}

			if ($stateParams.customerID) {
				urlParams.customerID = $stateParams.customerID;
			}

			const currentCalendars = [];

			if (Array.isArray(vm.calendars)) {
				vm.calendars.forEach(function (calendar) {
					if (calendar && calendar.isShow) {
						currentCalendars.push(calendar.id_calendar);
					}
				});
			}

			urlParams.calendarFilters = JSON.stringify(currentCalendars);
			$location.search(urlParams).replace();
		}

		function saveCustomFilterToLocal() {
			if (!vm.pageConfigs || !Array.isArray(vm.pageConfigs.customFilters)) {
				return;
			}

			const currentCustomFilter = vm.pageConfigs.customFilters.find(function (customFilter) {
				return isCustomFilterApplied(customFilter);
			});

			if (!currentCustomFilter) {
				return;
			}

			var pageConfigs = LoginService.getPageConfigs(LoginConst.pageConfigKeys.workorderSchedule);

			if (!pageConfigs) {
				pageConfigs = {};
			}

			pageConfigs.currentCalendar = currentCustomFilter.name;

			LoginService.savePageConfigs(LoginConst.pageConfigKeys.workorderSchedule, pageConfigs);
		}

		function getCustomFilterByName(name) {
			if (!vm.pageConfigs || !Array.isArray(vm.pageConfigs.customFilters)) {
				return;
			}

			return vm.pageConfigs.customFilters.find(function (customFilter) {
				return !!customFilter && customFilter.name == name;
			});
		}

		function applyCalendarFilter(calendarFilter) {
			if (!Array.isArray(vm.calendars)) {
				return;
			}

			const hasFilter = Array.isArray(calendarFilter);

			vm.calendars.forEach(function (calendar) {
				if (calendar && hasFilter) {
					calendar.isShow = calendarFilter.indexOf(calendar.id_calendar) != -1;
				} else {
					calendar.isShow = true;
				}
			});
		}

		function isCustomFilterApplied(customFilter) {
			if (!customFilter || !Array.isArray(customFilter.calendars) || !Array.isArray(vm.calendars)) {
				return;
			}

			return vm.calendars.every(function (calendar) {
				if (!calendar) {
					return;
				}

				if (customFilter.calendars.indexOf(calendar.id_calendar) == -1) {
					return !calendar.isShow;
				} else {
					return calendar.isShow;
				}
			});
		}

		function selectCustomFilter(customFilterName) {
			const customFilter = getCustomFilterByName(customFilterName);
			if (customFilter) {
				applyCalendarFilter(customFilter.calendars);
				refreshCalendarGrid();
			}
		}

		function deleteCustomFilter(index) {
			var dialogOptions = {};

			dialogOptions.titleString = "Remove Filter";
			dialogOptions.contentString = "Are you sure to remove filter";

			var confirmOption = {};

			confirmOption.optionName = "YES";
			confirmOption.onClick = function () {
				confirmDeleteCustomFilter(index);
				DialogService.close();
			}

			var cancelOption = {};

			cancelOption.optionName = "NO";
			cancelOption.onClick = function () {
				DialogService.close();
			}

			dialogOptions.options = [confirmOption, cancelOption];

			DialogService.showOptionsDialog(dialogOptions);
		}

		function confirmDeleteCustomFilter(index) {
			const currentPageConfig = userConfig.getPageConfigs(UserConfigConstants.pageKeyNames.workOrderActiveSchedule);

			if (currentPageConfig && Array.isArray(currentPageConfig.customFilters)) {
				currentPageConfig.customFilters.splice(index, 1);
			}

			userConfig.setPageConfigs(UserConfigConstants.pageKeyNames.workOrderActiveSchedule, currentPageConfig);

			vm.isDeletingFilter = true;

			updateUserConfig(userConfig)
				.then(function () {
					vm.pageConfigs = currentPageConfig;
					MessageService.showToast("Filter is removed.");
				})
				.catch(MessageService.showToast)
				.finally(function () {
					vm.isDeletingFilter = false;
				});
		}

		function refreshCalendarGrid() {
			if (calendarGrid) {
				calendarGrid.refetchEvents();
			}
		}

		function refreshCalendarNotification(calendar) {
			const resourcePath = {
				companyID: companyID,
				calendarID: calendar.id_calendar
			}
			calendar.notification = !calendar.notification
			AppointmentsService.updateCalendars(resourcePath, calendar)
				.then(function (result) {
					MessageService.showToast("Calendar notification Updated");
				})
				.catch(MessageService.showToast)
		}

		function addCustomFilter() {
			if (!vm.newCustomFilterName) {
				MessageService.showToast("Please enter a name.")
				return;
			}

			if (!Array.isArray(vm.calendars)) {
				return;
			}

			const calendarIdList = [];

			vm.calendars.forEach(function (calendar) {
				if (calendar && calendar.isShow) {
					calendarIdList.push(calendar.id_calendar);
				}
			});

			var currentPageConfig = userConfig.getPageConfigs(UserConfigConstants.pageKeyNames.workOrderActiveSchedule);

			if (!currentPageConfig) {
				currentPageConfig = {};
			}

			if (!Array.isArray(currentPageConfig.customFilters)) {
				currentPageConfig.customFilters = [];
			}

			currentPageConfig.customFilters.push({
				name: vm.newCustomFilterName,
				calendars: calendarIdList
			});

			userConfig.setPageConfigs(UserConfigConstants.pageKeyNames.workOrderActiveSchedule, currentPageConfig);

			vm.isSavingFilter = true;

			updateUserConfig(userConfig)
				.then(function () {
					vm.pageConfigs = currentPageConfig;
					vm.newCustomFilterName = null;
					MessageService.showToast("New filter is saved.");
				})
				.catch(MessageService.showToast)
				.finally(function () {
					vm.isSavingFilter = false;
				});
		}

		function updateUserConfig(userConfig) {
			if (!userConfig) {
				return $q.reject("User config invalid");
			}

			const resourcePath = {
				companyID: companyID,
				userID: userID
			}

			const requestBody = {
				config: userConfig.config
			}

			return UserConfigService.updateUserConfig(resourcePath, requestBody);
		}

		function fetchServiceMap(vehicleID) {
			const resourcePath = {
				companyID: companyID
			};

			const filter = {
				filters: GeneralTools.equalFilterBuilder("fk_id_vehicle", vehicleID)
			}

			return WorkOrderService.getAllMatchedServiceMaps(resourcePath, filter);
		}

		function fetchSaleInfo(vehicleID) {
			const resourcePath = {
				companyID: companyID
			};

			const filter = {
				filters: GeneralTools.equalFilterBuilder("fk_id_vehicle", vehicleID)
			}
			return SaleInfoService.getSaleInfos(resourcePath, filter)
		}

		function fetchVehicle(vehicleID) {
			const resourcePath = {
				companyID: companyID,
				vehicleID: vehicleID
			};

			return VehicleService.getVehicle(resourcePath)
				.then(function (result) {
					if (!result || !Array.isArray(result.data) || result.data.length != 1 || !result.data[0]) {
						return $q.reject("Failed to fetch vehicle data");
					}

					return result.data[0];
				})
		}

		function fetchWorkOrder(workOrderID, vehicleID) {

			const resourcePath = {
				companyID: companyID,
				vehicleID: vehicleID,
				workorderID: workOrderID
			};
			const request = WorkOrderService.getWorkOrders(resourcePath);
			requests.push(request);

			return request.$promise.then(function (result) {
				if (!Array.isArray(result) || result.length != 1 || !result[0]) {
					return $q.reject("Failed to fetch word order data");
				}

				return $q.resolve(result[0]);
			});
		}

		function fetchWorkOrderLabors(workOrderID, vehicleID) {
			const resourcePath = {
				companyID: companyID,
				vehicleID: vehicleID,
				workorderID: workOrderID
			};

			const request = WorkOrderService.getLabors(resourcePath);
			requests.push(request);

			return request.$promise;
		}

		function fetchMiscfeesData(workOrderID, vehicleID) {
			const resourcePath = {
				companyID: companyID,
				vehicleID: vehicleID,
				workorderID: workOrderID
			};

			return WorkOrderService.getMiscfeestype(resourcePath).$promise
		}

		function fetchWorkOrderPackageListData(workOrderID, vehicleID) {
			const resourcePath = {
				companyID: companyID,
				vehicleID: vehicleID,
				workorderID: workOrderID
			};

			return WorkOrderService.getWorkOrderPackages(resourcePath).$promise
		}

		function fetchRogerDollarRedeemData(workOrderID, vehicleID) {
			const resourcePath = {
				companyID: companyID,
				vehicleID: vehicleID,
				workorderID: workOrderID
			};

			return WorkOrderService.getredeemedRD(resourcePath).$promise;
		}


		function fetchWorkOrderWarrantyListData(workOrderID, vehicleID) {
			const resourcePath = {
				companyID: companyID,
				vehicleID: vehicleID,
				workorderID: workOrderID
			};

			return WorkOrderService.getWorkOrderWarranties(resourcePath).$promise;
		}

		function buildNewWorkOrderAppointmentObj(workOrder, labors, vehicle, serviceMap, customerName) {
			if (!workOrder || !vehicle || !Array.isArray(labors) || !Array.isArray(serviceMap) ) {
				return;
			}

			var title = '';
			if(customerName != null){
				title += customerName + '\'s ';
			}
			else if (serviceMap[0] && serviceMap[0].customer) {
				title += serviceMap[0].customer.first_name + ' ' + serviceMap[0].customer.last_name + '\'s ';
			}

			title += vehicle.getYearMakeModel();

			var totalLaborTime = 0;

			labors.forEach(function (labor) {
				if (labor) {
					totalLaborTime += labor.hour;
				}

				title += ' ' + labor.name;
			});

			// if (workOrder.notes) {
			// 	title += ' ' + workOrder.notes;
			// }

			totalLaborTime = Math.ceil(totalLaborTime / 0.25) * 0.25;

			if (totalLaborTime > maxAppointmentDuration) {
				totalLaborTime = maxAppointmentDuration;
			}

			if (totalLaborTime <= 0) {
				totalLaborTime = defaultAppointmentDuration;
			}

			const newWorkOrderAppointment = {
				title: title,
				textColor: eventTextColor,
				duration: {
					hours: Math.floor(totalLaborTime),
					minutes: totalLaborTime % 1 * 60
				},
				extendedProps: {
					isCustomAppointment: false
				},
				url: getWorkorderUrl(workOrder.id_work_order, vehicle.getResourceID())
			}
			vm.workOrderInvoiceNumber = workOrder.invoice_number;
			vm.workOrderAppointmentTitle = title;

			const draggableEl = document.getElementById('newWorkOrderAppointment');
			new FullCalendarInteraction.Draggable(draggableEl, { eventData: newWorkOrderAppointment });
		}

		function initNewAppointment() {
			vm.newAppointment = {
				title: '',
				duration: "01:00",
				textColor: eventTextColor,
				extendedProps: {
					isCustomAppointment: true
				}
			};

			const draggableEl = document.getElementById('newAppointment');
			new FullCalendarInteraction.Draggable(draggableEl, { eventData: vm.newAppointment });
		}

		function refreshWarningMessages(appointments) {
			if (vm.showNewWorkOrderAppointment) {
				return;
			}

			cancelRequest();

			if (!Array.isArray(appointments) && calendarGrid && calendarGrid.view) {
				appointments = getCalenderEventsByTimeRange(calendarGrid.getEvents(), moment(calendarGrid.view.currentStart), moment(calendarGrid.view.currentEnd));
			}

			if (!Array.isArray(appointments)) {
				return;
			}

			const queue = {};
			vm.isRefreshingWarningMessage = true;

			appointments.forEach(function (appointment) {
				if (!appointment || !appointment.extendedProps || appointment.extendedProps.isCustomAppointment || appointment.extendedProps.isCustomerPoraltalAppointment) {
					return;
				}

				if (!queue[appointment.extendedProps.workOrderID] && appointment.extendedProps.vehicleID) {
					queue[appointment.extendedProps.workOrderID] = fetchWorkorderDetails(appointment.extendedProps.workOrderID, appointment.extendedProps.vehicleID);
				}
			});

			$q.all(queue)
				.then(function (workorderDetails) {
					refreshEmptyWorkorderWarningMessage(appointments, workorderDetails);
					refreshPartsNotOrderedWarningMessage(appointments, workorderDetails);
					refreshInventoryInsufficientWarningMessage(appointments, workorderDetails);
					refreshPassedDueTimeWarningMessage(appointments, workorderDetails);
					refreshCompletedWithOutstandingWarningMessage(appointments, workorderDetails);

					refreshNotEnroughRetailPriceOnPartWorkorderWarningMessage(appointments, workorderDetails);
				})
				.catch(function (error) {
					if (error) {
						MessageService.showToast(error);
					}
				})
				.finally(function () {
					vm.isRefreshingWarningMessage = false;
				});
		}

		function refreshEmptyWorkorderWarningMessage(appointments, workorderDetails) {
			if (!Array.isArray(appointments) || !workorderDetails) {
				return;
			}

			const appointmentMap = {};
			vm.emptyWorkorders = {};
			vm.emptyWorkordersCount = 0;

			appointments.forEach(function (appointment) {
				if (!appointment || !appointment.extendedProps || appointment.extendedProps.isCustomAppointment || !isAppointmentExpected(appointment.extendedProps.status)) {
					return;
				}

				if (!Array.isArray(appointmentMap[appointment.extendedProps.workOrderID])) {
					appointmentMap[appointment.extendedProps.workOrderID] = [];
				}

				appointmentMap[appointment.extendedProps.workOrderID].push(appointment);
			});

			Object.keys(workorderDetails).forEach(function (workorderID) {
				if (!workorderDetails[workorderID] 
					|| !workorderDetails[workorderID].workorder 

					||
					(
					workorderDetails[workorderID].workorder.fk_id_work_order_status != WorkOrderConstants.statusIDs.quoted
					&& workorderDetails[workorderID].workorder.fk_id_work_order_status != WorkOrderConstants.statusIDs.booked
					&& workorderDetails[workorderID].workorder.fk_id_work_order_status != WorkOrderConstants.statusIDs.onlot
					&& workorderDetails[workorderID].workorder.fk_id_work_order_status != WorkOrderConstants.statusIDs.started
					)

					|| !Array.isArray(appointmentMap[workorderID])
					|| appointmentMap[workorderID].length <= 0){
					return;
				}

				if ((!Array.isArray(workorderDetails[workorderID].parts) || workorderDetails[workorderID].parts.length <= 0) &&
					(!Array.isArray(workorderDetails[workorderID].inventories) || workorderDetails[workorderID].inventories.length <= 0) &&
					(!Array.isArray(workorderDetails[workorderID].labors) || workorderDetails[workorderID].labors.length <= 0) &&
					(!Array.isArray(workorderDetails[workorderID].miscfees) || workorderDetails[workorderID].miscfees.length <= 0)
					) {
					vm.emptyWorkorders[workorderID] = {
						workorder: workorderDetails[workorderID].workorder,
						appointments: appointmentMap[workorderID]
					};

					vm.emptyWorkordersCount++;
				}
			});
		}

		function isAppointmentExpected(statusID) {
			switch (statusID) {
				case AppointmentConstants.statusIDs.NO_SHOW:
					return false;
				case AppointmentConstants.statusIDs.CANCELLED:
					return false;
				case AppointmentConstants.statusIDs.POSTPONED:
					return false;
				default:
					return true;
			}
		}

		function refreshPartsNotOrderedWarningMessage(appointments, workorderDetails) {
			if (!Array.isArray(appointments) || !workorderDetails) {
				return;
			}

			const appointmentMap = {};
			vm.partsNotOrdered = {};
			vm.partsNotOrderedCount = 0;

			appointments.forEach(function (appointment) {
				if (!appointment || !appointment.extendedProps || appointment.extendedProps.isCustomAppointment || !isAppointmentExpected(appointment.extendedProps.status)) {
					return;
				}

				if (!Array.isArray(appointmentMap[appointment.extendedProps.workOrderID])) {
					appointmentMap[appointment.extendedProps.workOrderID] = [];
				}

				appointmentMap[appointment.extendedProps.workOrderID].push(appointment);
			});

			Object.keys(workorderDetails).forEach(function (workorderID) {
				if (!workorderDetails[workorderID]
					|| !workorderDetails[workorderID].workorder
					||
					(
					workorderDetails[workorderID].workorder.fk_id_work_order_status != WorkOrderConstants.statusIDs.quoted
					&& workorderDetails[workorderID].workorder.fk_id_work_order_status != WorkOrderConstants.statusIDs.booked
					&& workorderDetails[workorderID].workorder.fk_id_work_order_status != WorkOrderConstants.statusIDs.onlot
					&& workorderDetails[workorderID].workorder.fk_id_work_order_status != WorkOrderConstants.statusIDs.started
					)
					|| !Array.isArray(appointmentMap[workorderID])
					|| appointmentMap[workorderID].length <= 0) {
					return;
				}

				if (isAnyPartsNotOrdered(workorderDetails[workorderID].parts)) {
					vm.partsNotOrdered[workorderID] = {
						workorder: workorderDetails[workorderID].workorder,
						appointments: appointmentMap[workorderID]
					}
					vm.partsNotOrderedCount++;
				}
			});
		}

		function refreshInventoryInsufficientWarningMessage(appointments, workorderDetails) {
			var demandMap = {};
			var appointmentMap = {};
			vm.inventoryInsufficientCount = 0;

			appointments.forEach(function (appointment) {
				if (!appointment || !appointment.extendedProps || appointment.extendedProps.isCustomAppointment || !isAppointmentExpected(appointment.extendedProps.status)) {
					return;
				}

				if (!Array.isArray(appointmentMap[appointment.extendedProps.workOrderID])) {
					appointmentMap[appointment.extendedProps.workOrderID] = [];
				}

				appointmentMap[appointment.extendedProps.workOrderID].push(appointment);
			});

			Object.keys(workorderDetails).forEach(function (workorderID) {
				if (!workorderDetails[workorderID] || !Array.isArray(workorderDetails[workorderID].inventories) || !workorderDetails[workorderID].workorder 
				
				
				||
				(
				workorderDetails[workorderID].workorder.fk_id_work_order_status != WorkOrderConstants.statusIDs.quoted
				&& workorderDetails[workorderID].workorder.fk_id_work_order_status != WorkOrderConstants.statusIDs.booked
				&& workorderDetails[workorderID].workorder.fk_id_work_order_status != WorkOrderConstants.statusIDs.onlot
				&& workorderDetails[workorderID].workorder.fk_id_work_order_status != WorkOrderConstants.statusIDs.started
				)
				
				|| !appointmentMap[workorderID] || appointmentMap[workorderID].length <= 0) {
					
					
					return;
				}

				workorderDetails[workorderID].inventories.forEach(function (inventory) {
					if (!inventory) {
						return;
					}

					const quantityInStock = GeneralTools.parseNumber(inventory.quantity_in_stock);
					const demandQuantity = GeneralTools.parseNumber(inventory.quantity);
					const demandMapDetail = {
						workorder: workorderDetails[workorderID].workorder,
						appointments: appointmentMap[workorderID]
					};

					if (demandMap[inventory.fk_id_inventory]) {
						demandMap[inventory.fk_id_inventory].totalInStock = quantityInStock;
						demandMap[inventory.fk_id_inventory].totalDemand += demandQuantity;
						demandMap[inventory.fk_id_inventory].details[workorderID] = demandMapDetail;
						return;
					}

					const details = {};
					details[workorderID] = demandMapDetail;

					demandMap[inventory.fk_id_inventory] = {
						totalInStock: quantityInStock,
						totalDemand: demandQuantity,
						code: inventory.code,
						name: inventory.name,
						details: details
					}
				});
			});

			Object.keys(demandMap).forEach(function (inventoryID) {
				if (demandMap[inventoryID].totalInStock >= demandMap[inventoryID].totalDemand) {
					delete demandMap[inventoryID];
					return;
				}

				vm.inventoryInsufficientCount++;
			});

			vm.inventoryInsufficient = demandMap;
		}

		function refreshPassedDueTimeWarningMessage(appointments, workorderDetails) {
			if (!Array.isArray(appointments) || !workorderDetails) {
				return;
			}

			const current = moment();
			const twoHoursAgo = current.hour(current.hour() - 2);

			vm.passedDueTime = {};
			vm.passedDueTimeCount = 0;

			appointments.forEach(function (appointment) {
				if (!appointment
					|| !appointment.extendedProps
					|| appointment.extendedProps.isCustomAppointment
					|| !isAppointmentExpected(appointment.extendedProps.status)
					|| moment(appointment.start).isAfter(twoHoursAgo)
					|| !workorderDetails[appointment.extendedProps.workOrderID]
					|| !workorderDetails[appointment.extendedProps.workOrderID].workorder
					||
					(
					workorderDetails[appointment.extendedProps.workOrderID].workorder.fk_id_work_order_status != WorkOrderConstants.statusIDs.quoted
					&& workorderDetails[appointment.extendedProps.workOrderID].workorder.fk_id_work_order_status != WorkOrderConstants.statusIDs.booked
					&& workorderDetails[appointment.extendedProps.workOrderID].workorder.fk_id_work_order_status != WorkOrderConstants.statusIDs.onlot
					&& workorderDetails[appointment.extendedProps.workOrderID].workorder.fk_id_work_order_status != WorkOrderConstants.statusIDs.started
					)
					
				) {
					return;
				}

				if (!vm.passedDueTime[appointment.extendedProps.workOrderID]) {
					vm.passedDueTime[appointment.extendedProps.workOrderID] = {
						workorder: workorderDetails[appointment.extendedProps.workOrderID].workorder,
						appointments: []
					}
					vm.passedDueTimeCount++;
				}

				vm.passedDueTime[appointment.extendedProps.workOrderID].appointments.push(appointment);
			});
		}

		function refreshCompletedWithOutstandingWarningMessage(appointments, workorderDetails) {
			if (!Array.isArray(appointments) || !workorderDetails) {
				return;
			}

			vm.completedWithOutstanding = {};
			const appointmentMap = {};
			vm.completedWithOutstandingCount = 0;

			appointments.forEach(function (appointment) {
				if (!appointment
					|| !appointment.extendedProps
					|| appointment.extendedProps.isCustomAppointment
					|| !isAppointmentExpected(appointment.extendedProps.status)) {
					return;
				}

				if (!Array.isArray(appointmentMap[appointment.extendedProps.workOrderID])) {
					appointmentMap[appointment.extendedProps.workOrderID] = [];
				}

				appointmentMap[appointment.extendedProps.workOrderID].push(appointment);
			});

			Object.keys(workorderDetails).forEach(function (workorderID) {
				if (!workorderDetails[workorderID]
					|| !workorderDetails[workorderID].workorder
					|| !workorderDetails[workorderID].workorder.isCompleted()
					|| !Array.isArray(appointmentMap[workorderID])
					|| appointmentMap[workorderID].length <= 0) {
					return;
				}

				const workOrderSummaryCalculator = new WorkOrderSummaryCalculator();
				workOrderSummaryCalculator.setWorkorder(workorderDetails[workorderID].workorder);
				workOrderSummaryCalculator.setParts(workorderDetails[workorderID].parts);
				workOrderSummaryCalculator.setInventories(workorderDetails[workorderID].inventories);
				workOrderSummaryCalculator.setLabors(workorderDetails[workorderID].labors);
				workOrderSummaryCalculator.setMiscfees(workorderDetails[workorderID].miscfees);
				workOrderSummaryCalculator.setWorkOrderPackageList(workorderDetails[workorderID].workorderpackage);
				workOrderSummaryCalculator.setWorkOrderWarrantyList(workorderDetails[workorderID].workorderwarranty);
				workOrderSummaryCalculator.setDiscounts(workorderDetails[workorderID].discounts);
				workOrderSummaryCalculator.setPayments(workorderDetails[workorderID].payments);
				workOrderSummaryCalculator.setRDRedeemed(workorderDetails[workorderID].rogerdollarredeem);
				if (workOrderSummaryCalculator.getOutstanding() == 0) {
					return;
				}

				vm.completedWithOutstanding[workorderID] = {
					workorder: workorderDetails[workorderID].workorder,
					appointments: appointmentMap[workorderID]
				}

				vm.completedWithOutstandingCount++;
			});
		}

		function fetchWorkorderDetails(workorderID, vehicleID) {
			const queue = {};
			if (workordersDetailsMap[workorderID]) {
				if (workordersDetailsMap[workorderID].workorder) {
					queue.workorder = $q.resolve(workordersDetailsMap[workorderID].workorder);
				} else {
					queue.workorder = fetchWorkOrder(workorderID, vehicleID);
				}

				if (workordersDetailsMap[workorderID].parts) {
					queue.parts = $q.resolve(workordersDetailsMap[workorderID].parts);
				} else {
					queue.parts = fetchWorkOrderParts(workorderID, vehicleID);
				}

				if (workordersDetailsMap[workorderID].inventories) {
					queue.inventories = $q.resolve(workordersDetailsMap[workorderID].inventories);
				} else {
					queue.inventories = fetchWorkOrderInventories(workorderID, vehicleID);
				}

				if (workordersDetailsMap[workorderID].labors) {
					queue.labors = $q.resolve(workordersDetailsMap[workorderID].labors);
				} else {
					queue.labors = fetchWorkOrderLabors(workorderID, vehicleID);
				}

				if (workordersDetailsMap[workorderID].miscfees) {
					queue.miscfees = $q.resolve(workordersDetailsMap[workorderID].miscfees);
				} else {
					queue.miscfees = fetchMiscfeesData(workorderID, vehicleID);
				}
				if (workordersDetailsMap[workorderID].workorderpackage) {
					queue.workorderpackage = $q.resolve(workordersDetailsMap[workorderID].workorderpackage);
				} else {
					queue.workorderpackage = fetchWorkOrderPackageListData(workorderID, vehicleID);
				}
				if (workordersDetailsMap[workorderID].workorderwarranty) {
					queue.workorderwarranty = $q.resolve(workordersDetailsMap[workorderID].workorderwarranty);
				} else {
					queue.workorderwarranty = fetchWorkOrderWarrantyListData(workorderID, vehicleID);
				}

				if (workordersDetailsMap[workorderID].rogerdollarredeem) {
					queue.rogerdollarredeem = $q.resolve(workordersDetailsMap[workorderID].rogerdollarredeem);
				} else {
					queue.rogerdollarredeem = fetchRogerDollarRedeemData(workorderID, vehicleID);
				}
			} else {
				queue.workorder = fetchWorkOrder(workorderID, vehicleID);
				queue.parts = fetchWorkOrderParts(workorderID, vehicleID);
				queue.inventories = fetchWorkOrderInventories(workorderID, vehicleID);
				queue.labors = fetchWorkOrderLabors(workorderID, vehicleID);
				queue.miscfees = fetchMiscfeesData(workorderID, vehicleID);
				queue.workorderpackage = fetchWorkOrderPackageListData(workorderID, vehicleID);
				queue.workorderwarranty = fetchWorkOrderWarrantyListData(workorderID, vehicleID);
				queue.rogerdollarredeem = fetchRogerDollarRedeemData(workorderID, vehicleID);
			}

			return $q.all(queue)
				.then(function (result) {
					if (!result || !result.workorder) {
						return $q.reject("Failed to fetch workorder details: id " + workorderID);
					}
					if (!result.workorder.isCompleted()) {
						return $q.resolve(result);
					}

					if (workordersDetailsMap[workorderID]) {
						if (workordersDetailsMap[workorderID].discounts) {
							result.discounts = $q.resolve(workordersDetailsMap[workorderID].discounts);
						} else {
							result.discounts = fetchWorkOrderDiscounts(workorderID, vehicleID);
						}

						if (workordersDetailsMap[workorderID].payments) {
							result.payments = $q.resolve(workordersDetailsMap[workorderID].payments);
						} else {
							result.payments = fetchWorkOrderPayments(workorderID, vehicleID);
						}


					} else {
						result.discounts = fetchWorkOrderDiscounts(workorderID, vehicleID);
						result.payments = fetchWorkOrderPayments(workorderID, vehicleID);
					}

					return $q.all(result);
				})
				.then(function (result) {
					workordersDetailsMap[workorderID] = result;
					return $q.resolve(result);
				})
		}

		function isAnyInventoryInsufficient(demandMap, workorderInventories) {
			if (!demandMap || !Array.isArray(workorderInventories)) {
				return;
			}

			return !!workorderInventories.find(function (inventory) {
				return !!inventory && !!demandMap[inventory.fk_id_inventory] && demandMap[inventory.fk_id_inventory].totalDemand > demandMap[inventory.fk_id_inventory].totalInStock;
			});
		}

		function isAnyPartsNotOrdered(parts) {
			if (!Array.isArray(parts)) {
				return;
			}

			return !!parts.find(function (part) {
				return !!part && !part.is_returned && !part.is_ordered;
			});
		}

		function addToDemandMap(demandMap, workorderInventories) {
			if (!demandMap || !Array.isArray(workorderInventories)) {
				return;
			}

			workorderInventories.forEach(function (inventory) {
				if (!inventory) {
					return;
				}

				const quantityInStock = GeneralTools.parseNumber(inventory.quantity_in_stock);
				const demandQuantity = GeneralTools.parseNumber(inventory.quantity);

				if (demandMap[inventory.fk_id_inventory]) {
					demandMap[inventory.fk_id_inventory].totalInStock = quantityInStock;
					demandMap[inventory.fk_id_inventory].totalDemand += demandQuantity;
					return;
				}

				demandMap[inventory.fk_id_inventory] = {
					totalInStock: quantityInStock,
					totalDemand: demandQuantity,
					code: inventory.code,
					name: inventory.name
				}
			});

			return demandMap;
		}

		function fetchWorkOrderDiscounts(workOrderID, vehicleID) {
			const resourcePath = {
				companyID: companyID,
				vehicleID: vehicleID,
				workorderID: workOrderID
			};

			const request = WorkOrderService.getDiscounts(resourcePath);
			requests.push(request);

			return request.$promise;
		}

		function fetchWorkOrderPayments(workOrderID, vehicleID) {
			const resourcePath = {
				companyID: companyID,
				vehicleID: vehicleID,
				workorderID: workOrderID
			};

			const request = WorkOrderService.getPayments(resourcePath);
			requests.push(request);

			return request.$promise;
		}

		function refreshDemandMap(inventories) {
			return $q.resolve()
		}

		function fetchWorkOrderParts(workOrderID, vehicleID) {
			const resourcePath = {
				companyID: companyID,
				vehicleID: vehicleID,
				workorderID: workOrderID
			};

			const request = WorkOrderService.getWorkOrderParts(resourcePath);
			requests.push(request);

			return request.$promise;
		}

		function fetchWorkOrderInventories(workOrderID, vehicleID) {
			const resourcePath = {
				companyID: companyID,
				vehicleID: vehicleID,
				workorderID: workOrderID
			};

			const request = WorkOrderService.getWorkOrderInventories(resourcePath);
			requests.push(request);

			return request.$promise;
		}

		function showWarningMessageBox() {
			return !vm.showNewWorkOrderAppointment && (
				vm.passedDueTimeCount > 0 ||
				vm.emptyWorkordersCount > 0 ||
				vm.inventoryInsufficientCount > 0 ||
				vm.completedWithOutstandingCount > 0 ||
				vm.partsNotOrderedCount > 0 ||
				vm.underRateWorkordersCount > 0
			)
		}

		function refreshNotEnroughRetailPriceOnPartWorkorderWarningMessage(appointments, workorderDetails) {
			if (!Array.isArray(appointments) || !workorderDetails) {
				return;
			}

			const appointmentMap = {};
			vm.underRateWorkorders = {};
			vm.underRateWorkordersCount = 0;

			appointments.forEach(function (appointment) {
				if (!appointment || !appointment.extendedProps || appointment.extendedProps.isCustomAppointment || !isAppointmentExpected(appointment.extendedProps.status)) {
					return;
				}

				if (!Array.isArray(appointmentMap[appointment.extendedProps.workOrderID])) {
					appointmentMap[appointment.extendedProps.workOrderID] = [];
				}

				appointmentMap[appointment.extendedProps.workOrderID].push(appointment);
			});

			Object.keys(workorderDetails).forEach(function (workorderID) {
				if (!workorderDetails[workorderID] 
					|| !workorderDetails[workorderID].workorder 

					||
					(
					workorderDetails[workorderID].workorder.fk_id_work_order_status != WorkOrderConstants.statusIDs.quoted
					&& workorderDetails[workorderID].workorder.fk_id_work_order_status != WorkOrderConstants.statusIDs.booked
					&& workorderDetails[workorderID].workorder.fk_id_work_order_status != WorkOrderConstants.statusIDs.onlot
					&& workorderDetails[workorderID].workorder.fk_id_work_order_status != WorkOrderConstants.statusIDs.started
					)

					|| !Array.isArray(appointmentMap[workorderID])
					|| appointmentMap[workorderID].length <= 0){
					return;
				}

				if (isAnyPartsUnderRate(workorderDetails[workorderID].parts)) {
					vm.underRateWorkorders[workorderID] = {
						workorder: workorderDetails[workorderID].workorder,
						appointments: appointmentMap[workorderID]
					};

					vm.underRateWorkordersCount++;
				}
			});
		}

		function isAnyPartsUnderRate(parts) {
			if (!Array.isArray(parts)) {
				return;
			}

			return !!parts.find(function (part) {
				return !!part && !(part.purchase_price * 0.6 < part.retail_price);
			});
		}

		function initNewCustomAppointment() {
			var length = window.localStorage.getItem('customAppointmentHolderLength');
			var title = window.localStorage.getItem('customAppointmentHolderTitle');
			var category = window.localStorage.getItem('customAppointmentHolderCategory');
			var createBy = window.localStorage.getItem('customAppointmentHolderCreateBy');

			if (!$stateParams.customerID || $stateParams.vehicleID || $stateParams.workOrderID || length == null || title == null || category == null) {
				return;
			}
			MessageService.showToast("Drag and drop the appointment to the calendar to create a new appointment.");

			const queue = {
				customer: fetchCustomerById($stateParams.customerID),
				length: length,
				title: title,
				category: category,
				createBy: createBy
			};

			vm.showNewCustomAppointment = true;
			vm.loadingNewCustomAppointment = true;

			$q.all(queue)
				.then(function (result) {
					if (!result || result.customer.data.length != 1) {
						return $q.reject("custom appointment information invalid.");
					}
					buildNewCustomAppointmentObj(result.customer.data, result.title, result.length, result.category, result.createBy);
					vm.CustomerUrl = getCustomerUrl($stateParams.customerID);
				})
				.catch(MessageService.showToast)
				.finally(function () {
					window.localStorage.removeItem('customAppointmentHolderLength');
					window.localStorage.removeItem('customAppointmentHolderTitle');
					window.localStorage.removeItem('customAppointmentHolderCategory');
					window.localStorage.removeItem('customAppointmentHolderCreateBy');
					vm.loadingNewCustomAppointment = false;
			});


		}

		function getCustomerUrl(CustomerID) {
			return $state.href("app.view-customer", {customerID: CustomerID, tab: 'Appointments'});
		}

		function buildNewCustomAppointmentObj(serviceMap, appointmentTitle, appointmentLength, appointmentCategory, appointmentCreateBy) {
			if (!serviceMap || !appointmentTitle || !appointmentLength || !appointmentCategory) {
				return;
			}

			var title = '';

			
			
			if(appointmentTitle != null){
				title += appointmentTitle;
			}else if (serviceMap[0] && serviceMap[0].first_name) {
				title += serviceMap[0].first_name + ' ' + serviceMap[0].last_name;
			}


			var totalLaborTime = 0;

			totalLaborTime += Number(appointmentLength) / 60;

			totalLaborTime = Math.ceil(totalLaborTime / 0.25) * 0.25;

			if (totalLaborTime > maxAppointmentDuration) {
				totalLaborTime = maxAppointmentDuration;
			}

			if (totalLaborTime <= 0) {
				totalLaborTime = defaultAppointmentDuration;
			}



			const newCustomAppointment = {
				title: title,
				textColor: eventTextColor,
				duration: {
					hours: Math.floor(totalLaborTime),
					minutes: totalLaborTime % 1 * 60
				},
				extendedProps: {
					isCustomAppointment: false,
					isCustomerCustomAppointment: true
				},
				url: getCustomerUrl(serviceMap[0].id_customer),
				category: appointmentCategory,
				createBy: appointmentCreateBy
			}

			vm.customAppointmentTitle = title;

			const draggableEl = document.getElementById('newCustomAppointment');
			new FullCalendarInteraction.Draggable(draggableEl, { eventData: newCustomAppointment });
		}
		
		function fetchCustomerById(customerID) {
			var resourcePath = {
				customerID: customerID,
				companyID: companyID
			};

			return CustomersService.getCustomers(resourcePath, null, null, null);
		}

		function createCustomAppointment(calendarEvent, calendarID) {
			if (!calendarEvent) {
				return $q.reject("calendar event invalid");
			}

			const resourcePath = { companyID: companyID, customerID: $stateParams.customerID };
			const requestBody = {
				title: calendarEvent.title,
				start: moment(calendarEvent.start).utc().format(appointmentTimeFormat),
				end: moment(calendarEvent.end).utc().format(appointmentTimeFormat),
				fk_id_calendar: calendarID,
				fk_id_customer: $stateParams.customerID,
				category: calendarEvent.extendedProps.category,
				create_by: calendarEvent.extendedProps.createBy
			}

			return AppointmentsService.createCustomAppointment(resourcePath, requestBody);
		}

		function castCustomAppointmentToCalenderEvent(workOrderAppointment) {
			if (!workOrderAppointment) {
				return;
			}
		
			const queue = {
				customer: fetchCustomerById(workOrderAppointment.fk_id_customer),
				user: fetchUserById(workOrderAppointment.create_by)
			};
		
			return $q.all(queue)
				.then(function(result) {
					if (!result || result.customer.data.length !== 1) {
						return $q.reject("Custom appointment information invalid.");
					}
		
					const customer = result.customer.data[0];
					const user = result.user[0];
					let tempTitleParts = [];
					var tempHolder = null;
		
					if (workOrderAppointment.fk_id_appointment_status === 5) {
						tempTitleParts.push(confirmAppointmentTag);
					} else if (workOrderAppointment.fk_id_appointment_status === 6) {
						tempTitleParts.push(cancelAppointmentTag);
					}
		
					if (customer.getFullName()) {
						tempHolder = '[ ' + customer.getFullName() + ' ]'
						tempTitleParts.push(tempHolder);
						tempHolder = null;
					}
		
					if (customer.getPhoneNumber()) {
						tempHolder = '[ ' + customer.getPhoneNumber() + ' ]'
						tempTitleParts.push(tempHolder);
						tempHolder = null;
					}
		
					if (workOrderAppointment.title) {
						tempHolder = '[ ' + workOrderAppointment.title + ' ]'
						tempTitleParts.push(tempHolder);
						tempHolder = null;
					}
		
					if (user.username) {
						tempHolder = '[ ' + user.username + ' ]'
						tempTitleParts.push(tempHolder);
						tempHolder = null;
					}
		
					const tempTitle = tempTitleParts.join(' - ');
		
					const event = {
						title: tempTitle,
						start: workOrderAppointment.start,
						end: workOrderAppointment.end,
						color: getCalendarColor(workOrderAppointment.fk_id_calendar, workOrderAppointment.fk_id_work_order_status),
						textColor: eventTextColor,
						extendedProps: {
							isCustomAppointment: false,
							isCustomerCustomAppointment: true,
							appointmentID: workOrderAppointment.id_appointment,
							status: workOrderAppointment.fk_id_appointment_status,
							workOrderID: workOrderAppointment.fk_id_work_order,
							vehicleID: workOrderAppointment.fk_id_vehicle,
							customerID: workOrderAppointment.fk_id_customer,
							category: workOrderAppointment.category,
							createBy: workOrderAppointment.create_by
						},
						url: getCustomerUrl(workOrderAppointment.fk_id_customer)
					};
		
					return event;
				})
				.catch(MessageService.showToast);
		}
		
		
		

		function fetchUserById(userId) {
			var inspectorResourcePath = {
				companyID: companyID,
				userID: userId
			};
			return UserService.getUsers(inspectorResourcePath, null);
		}
	}
})();
(function ()
{
	'use strict';

	angular
		.module('app.workOrders')
		.service('WorkorderUnsavedChangesHelper', WorkorderUnsavedChangesHelper);

	function WorkorderUnsavedChangesHelper($q){
		this.subscribe = function(key, subscriber){
			if(!this.subscribers){
				this.subscribers = {};
			}

			this.subscribers[key] = subscriber;
		}

		this.unsubscribe = function(key){
			if(this.subscribers){
				delete this.subscribers[key];
			}
		}

		this.checkAll = function(){
			const _this = this;
			if(!_this.subscribers){
				return $q.reject("Can not find subscribers");
			}

			const queue = [];

			Object.keys(_this.subscribers).forEach(function(key){
				queue.push(_this.check(key));
			});

			return $q.all(queue);
		}

		this.check = function(key){
			if(!this.subscribers || !this.subscribers[key]){
				return $q.reject("Can not find subscriber: " + key);
			}

			if(typeof(this.subscribers[key].check) != "function"){
				return $q.reject("Can not find check function in subscriber: " + key);;
			}

			return this.subscribers[key].check();
		}

		this.saveAll = function(){
			const _this = this;
			if(!_this.subscribers){
				return $q.reject("Can not find subscribers");
			}

			const queue = [];

			Object.keys(_this.subscribers).forEach(function(key){
				queue.push(_this.save(key));
			});

			return $q.all(queue);
		}

		this.save = function(key){
			if(!this.subscribers || !this.subscribers[key]){
				return $q.reject("Can not find subscriber: " + key);
			}

			if(typeof(this.subscribers[key].save) != "function"){
				return $q.reject("Can not find save function in subscriber: " + key);;
			}

			return this.subscribers[key].save();
		}
	}
})();
(function () {
	'use strict';

	angular
		.module('app.workOrders')
		.controller('EditWorkOrderController', EditWorkOrderController);

	function EditWorkOrderController(WorkOrderQRPrint, $location, ApiConst, LoginConst, RoleCheckService, WorkOrderService, WorkOrderPayment, workOrderJob, DialogService, workOrderRDRedeemed, workOrderRDGenerated, WorkorderUnsavedChangesHelper, $q, LoginService, workorderWarrantyOption, CustomersService, GeneralTools, MessageService, customers, WorkOrderPrint, WorkOrderDataSharingService, $scope, sharedConstants, discounts, payments, labors, vehicle, $state, workOrder, $rootScope, $stateParams, parts, inventories, WorkOrderConstants, workorderpaymentstatus, miscfeestypes, workorderWarranty, jobtypes, workorderpackagelist, workOrderCoupons, $http) {
		const vm = this;
		const confirmString = "CONFIRM";
		const generalState = "app.edit-workorder.general";
		const extraState = "app.edit-workorder.extra"
		const discountsState = "app.edit-workorder.discounts";
		const paymentsState = "app.edit-workorder.payments";
		const appointmentsState = "app.edit-workorder.appointments";
		const filesState = "app.edit-workorder.files";
		const logState = "app.edit-workorder.logs";
		const unsavedChangeWarning = "This page has unsaved content which will not be printed."
		const saveAndContinueStr = "save & print";
		const ignoreAndContinueStr = "ignore & print";
		const userInfo = LoginService.getUserInfo();
		const companyID = LoginService.getCompanyID();
		const vehicleID = $stateParams.vehicleID;
		const workorderID = $stateParams.workOrderID;

		const workOrderStatusQuoted = "This work order is quoted. Are you sure you want to start working on it?";
		const workOrderStatusDeclined = "This work order has been declined. Are you sure you want to start working on it?";
		const workOrderStatusCompleted = "This work order has been completed. Are you sure you want to start working on it?";
		const workOrderStatusStarted = "This work order has been started. Are you sure you want to start working on it?";
		const workOrderStatusBooking = "This work order has been booked. Do you want to start working on it?";

		const workOrderStatusNotBooking = "This work order is not booked. Do you want to set it to On Lot and print the QR Code?";

		const workOrderStatusOnLot = "This vehicle is ready. Do you want to start working on it?";
		const workOrderQRCodePrint = "Are you sure you want to print the QR code? This will set the current work order status to 'On Lot.'";
		const workOrderStart = "Start working";
		const workOrderStatusSet = "Yes, set it";
		const workOrderNo = "No";


		const canSeeProfit = RoleCheckService.deepCheckRole(["company_manager", "service_advisor"]);
		vm.translateToDollar = GeneralTools.inputTranslators.dollar;
		vm.onAnchorClicked = onAnchorClicked;
		vm.vehicleDetailPageUrl = $state.href("app.vehicle.workorder", { vehicleID: $stateParams.vehicleID });
		vm.print = print;
		vm.printQR = printQR;
		vm.printMode = "current";
		vm.printStartDate = null;
		vm.printEndDate = null;
		vm.addPaymentShortCut = addPaymentShortCut;
		vm.deleteWorkorder = deleteWorkorder;
		vm.controlSensitiveContent = controlSensitiveContent;
		vm.sendTrackingLink = sendTrackingLink;
		vm.trackingCustomerID = null;
		vm.trackingCustomer = null;
		vm.isSendingTrackingLink = false;

		vm.isMechanic = RoleCheckService.checkRole(["mechanic"]);
		vm.isServiceAdvisor = RoleCheckService.deepCheckRole(["service_advisor"]);
		vm.customerRegistrationTempHolder;
		vm.clientEmailAddressHolder = "";
		vm.isDeveloper = RoleCheckService.checkRole(["developer"]);
		vm.isCompanyManager = RoleCheckService.checkRole(["company_manager"]);

		vm.customerCreditCards = [];
		
		vm.creditCardSelected = {
			customerProfileID: null,
			paymentProfileID: null
		};

		var domain;
		switch(window.location.host){
			case ApiConst.productDomain:
				domain = ApiConst.productDomain;
				break;
			case ApiConst.productBackupDomain:
				domain = ApiConst.productBackupDomain;
				break;
			case ApiConst.testDomain:
				domain = ApiConst.testDomain;
				break;
			default:
				domain = 'localhost:3001';
				break;
		}
		const socketUrl = ApiConst.http + domain + "/vehicle/"+$stateParams.vehicleID+"/workorder/"+$stateParams.workOrderID+"/general?qr=true";
		var qrParam = $location.search().qr;

		var temp = document.getElementById("qrcode")
		new QRCode(temp, socketUrl);

		window.onload = init();
		function init() {
			if (!Array.isArray(workOrder) || workOrder.length != 1 || !workOrder[0]) {
				$state.go("app.homepage");
				return;
			}

			$scope.$watch("vm.paymentCustomer", function () {
				$scope.$emit(
					vm.onCreditCardCustomerSelectionChange());
			})

			initConstants();
			initNavBar();
			initVehicle();
			initCustomers();
			initObservers();
			initSensitiveContentControl();


			WorkOrderDataSharingService.setWorkOrder(workOrder[0]);
			WorkOrderDataSharingService.setPartList(parts);
			WorkOrderDataSharingService.setInventoryList(inventories);
			WorkOrderDataSharingService.setLaborList(labors);
			WorkOrderDataSharingService.setMiscFeesList(miscfeestypes);
			WorkOrderDataSharingService.setJobTypeList(jobtypes);
			WorkOrderDataSharingService.setDiscountList(discounts);	
			WorkOrderDataSharingService.setworkOrderCouponList(workOrderCoupons);
			WorkOrderDataSharingService.setRDGeneratedList(workOrderRDGenerated);
			WorkOrderDataSharingService.setRDRedeemeddList(workOrderRDRedeemed);
			WorkOrderDataSharingService.setPaymentList(payments);
			WorkOrderDataSharingService.setWorkOrderWarrantyList(workorderWarranty);
			WorkOrderDataSharingService.setWorkOrderWarrantyoptions(workorderWarrantyOption);
			vm.warrantyPaymentList = initwarrantypaymentList(payments);
			vm.creditCardPaymentList = initCreditCardpaymentList(payments);
			WorkOrderDataSharingService.setWorkOrderPaymentStatusList(workorderpaymentstatus);
			WorkOrderDataSharingService.setWorkOrderPackageList(workorderpackagelist);
			vm.workOrderPackageList = workorderpackagelist
			vm.workorderpaymentstatus = workorderpaymentstatus;
			WorkOrderDataSharingService.setworkOrderJobList(workOrderJob);
			vm.workOrderJob = workOrderJob

			refreshSummary();
			redirect();
			if(qrParam == "true"){
				qRcodeUrlScaned();
			}

		}

		function initwarrantypaymentList(payments) {
			var warrantyPaymentList = [];
			payments.forEach(function (payment) {
				if (payment.fk_id_payment_method == 6) {
					warrantyPaymentList.push(payment);
				}
			});
			return warrantyPaymentList;
		}

		function initCreditCardpaymentList(payments) {
			var creditCardPaymentList = [];
			payments.forEach(function (payment) {
				if (payment.fk_id_payment_method == 11) {
					creditCardPaymentList.push(payment);
				}
			});
			return creditCardPaymentList;
		}

		function initSensitiveContentControl() {
			var pageConfig = LoginService.getPageConfigs(LoginConst.pageConfigKeys.editWorkorder);

			if (!pageConfig) {
				pageConfig = {};
				pageConfig.showSensitiveContent = false;
				LoginService.savePageConfigs(LoginConst.pageConfigKeys.editWorkorder, pageConfig);
			}

			vm.showSensitiveContent = pageConfig.showSensitiveContent;

			vm.hiddenSummarySections = {
				outstanding: !vm.isServiceAdvisor,
				profit: !canSeeProfit || !vm.showSensitiveContent
			}
		}

		function initObservers() {
			$scope.$on('$stateChangeSuccess', function (event, toState, toParams, fromState, fromParams) {
				refreshSummary();
				redirect();
			});

			$rootScope.$on(WorkOrderConstants.editWorkOrderEvents.updateSummary.eventName, function (event, updateDetails, data) {
				switch (updateDetails) {
					case WorkOrderConstants.editWorkOrderEvents.updateSummary.updateDetails.workOrder:
						vm.workOrder = data;
						vm.isQuoted = vm.workOrder.isQuoted();
						break;
					case WorkOrderConstants.editWorkOrderEvents.updateSummary.updateDetails.parts:
						vm.summaryPartList = data;
						break;
					case WorkOrderConstants.editWorkOrderEvents.updateSummary.updateDetails.inventories:
						vm.summaryInventoryList = data;
						break;
					case WorkOrderConstants.editWorkOrderEvents.updateSummary.updateDetails.labors:
						vm.summarylaborList = data;
						break;
					case WorkOrderConstants.editWorkOrderEvents.updateSummary.updateDetails.miscfees:
						vm.summarymiscfeesList = data;
						break;
					case WorkOrderConstants.editWorkOrderEvents.updateSummary.updateDetails.workorderpackagelist:
						vm.summaryWorkOrderPackageList = data;
						break;
					case WorkOrderConstants.editWorkOrderEvents.updateSummary.updateDetails.workorderwarrantylist:
						vm.workOrderWarrantyList = data;
						break;
					case WorkOrderConstants.editWorkOrderEvents.updateSummary.updateDetails.discounts:
						vm.summaryDiscountList = data;
						break;
					case WorkOrderConstants.editWorkOrderEvents.updateSummary.updateDetails.payments:
						vm.summaryPaymentList = data;
						break;
					case WorkOrderConstants.editWorkOrderEvents.updateSummary.updateDetails.demandMap:
						vm.summaryDemandMap = data;
						break;
					case WorkOrderConstants.editWorkOrderEvents.updateSummary.updateDetails.workOrderRogerDollarGenerated:
						vm.summaryworkOrderRDGenerated = data;
						break;

					case WorkOrderConstants.editWorkOrderEvents.updateSummary.updateDetails.workOrderCoupons:
						vm.workOrderCoupons = data;
						break;

					case WorkOrderConstants.editWorkOrderEvents.updateSummary.updateDetails.workOrderRogerDollarRedeemed:
						vm.summaryworkOrderRDRedeemed = data;
						break;
				}
			});
		}

		function initCustomers() {
			if (!Array.isArray(customers)) {
				return;
			}

			vm.customers = customers;

			const queue = [];

			// base on work order quote_date
			// filter out customer that should not see this work order by their work_order_filter_start and work_order_filter_end
			// if the work_order_filter_start or work_order_filter_end is null, then always show
			const workOrderQuoteDate = moment(workOrder[0].quote_date);
			for (let i = vm.customers.length - 1; i >= 0; i--) {
			const customer = vm.customers[i];
			if (!customer) continue;

			const hasStart = !!customer.work_order_filter_start;
			const hasEnd   = !!customer.work_order_filter_end;

			const start = hasStart ? moment(customer.work_order_filter_start) : null;
			const end   = hasEnd   ? moment(customer.work_order_filter_end)   : null;

			const shouldHide =
				(hasStart && workOrderQuoteDate.isBefore(start)) ||
				(hasEnd   && workOrderQuoteDate.isAfter(end));

			if (shouldHide) vm.customers.splice(i, 1);
			}

			// if there are more than 1 customer, show the one with the largest in work_order_filter_start date first
			if (vm.customers.length > 1) {
				vm.customers.sort(function(a, b) {
					if (!a.work_order_filter_start && !b.work_order_filter_start) return 0;
					if (!a.work_order_filter_start) return 1;
					if (!b.work_order_filter_start) return -1;	
					return moment(b.work_order_filter_start).diff(moment(a.work_order_filter_start));
				});
			}
			
			if (vm.customers[0]) {
				vm.printCustomerID = vm.customers[0].id_customer;
				vm.trackingCustomerID = vm.customers[0].id_customer;
				vm.trackingCustomer = vm.customers[0];
				vm.paymentCustomer = vm.customers[0];
			}

			Object.keys(vm.customers).forEach(function(customerID){
				queue.push(fetchCustomerData(vm.customers[customerID].id_customer));
			});

			$q.all(queue)
			.then(function(result){

				if(!Array.isArray(result)){
					return $q.reject("Customers data invalid");
				}


				result.forEach(function(customer){
					if(!customer){
						return;
					}
					Object.keys(vm.customers).forEach(function(customerID){
						if(vm.customers[customerID].id_customer == customer.id_customer) {
							vm.customers[customerID].email_address = customer.emails;
							vm.customers[customerID].phone_numbers = customer.phone_numbers;
						}
					});
				});

				return $q.resolve()
			})
			.catch(MessageService.showToast)
			.finally(function(){
				if (Object.values(vm.customers).length >= 1) {
					const customerListValues = Object.values(vm.customers);
					vm.customerRegistrationTempHolder = customerListValues[0];
					if(customerListValues[0] && customerListValues[0] && customerListValues[0].email_address && customerListValues[0].email_address.length >= 1){
						vm.clientEmailAddressHolder = customerListValues[0].email_address[0].email_address
					}
				}
			});

			
			
		}

		function refreshSummary() {
			vm.workOrder = WorkOrderDataSharingService.getWorkOrder();
			vm.summaryPartList = WorkOrderDataSharingService.getPartList();
			vm.summaryInventoryList = WorkOrderDataSharingService.getInventoryList();
			vm.summarylaborList = WorkOrderDataSharingService.getLaborList();
			vm.summarymiscfeesList = WorkOrderDataSharingService.getMiscFeesList();
			vm.summaryWorkOrderPackageList = WorkOrderDataSharingService.getWorkOrderPackageList();
			vm.workOrderWarrantyList = WorkOrderDataSharingService.getWorkOrderWarrantyList();
			vm.summaryDiscountList = WorkOrderDataSharingService.getDiscountList();
			vm.summaryPaymentList = WorkOrderDataSharingService.getPaymentList();
			vm.summaryworkOrderRDGenerated =  WorkOrderDataSharingService.getRDGeneratedList();
			vm.workOrderCoupons =  WorkOrderDataSharingService.getworkOrderCouponList();
			vm.summaryworkOrderRDRedeemed = WorkOrderDataSharingService.getRDRedeemeddList();
			vm.warrantyPaymentList = initwarrantypaymentList(vm.summaryPaymentList);
			vm.creditCardPaymentList = initCreditCardpaymentList(vm.summaryPaymentList);
		}

		function initConstants() {
			if (!sharedConstants) {
				MessageService.showToast("constants invalid");
				return;
			}

			vm.workOrderStatus = sharedConstants.workOrderStatus;
			vm.paymentMethods = sharedConstants.paymentMethods;
			vm.phoneCategories = sharedConstants.phoneCategories;
		}

		function initNavBar() {
			vm.navItem = [
				{
					state: generalState,
					name: "GENERAL"
				},
				{
					state: extraState,
					name: "EXTRA"
				},
				{
					state: discountsState,
					name: "DISCOUNTS"
				},
				{
					state: paymentsState,
					name: "PAYMENTS"
				},
				{
					state: appointmentsState,
					name: "APPOINTMENTS"
				},
				{
					state: filesState,
					name: "FILES"
				}
			];

			if(vm.isDeveloper || vm.isCompanyManager){
				vm.navItem.push({
					state: logState,
					name: "LOGS"
				})
			}

			vm.currentState = $state.current.name;
		}

		function initVehicle() {
			if (vehicle && Array.isArray(vehicle.data) && vehicle.data.length === 1 && !!vehicle.data[0]) {
				vm.vehicle = vehicle.data[0];
			}
		}

		function redirect() {
			if ($state.current.name == "app.edit-workorder") {
				$state.go("app.edit-workorder.general");
			}
		}

		

		function print() {
			if (vm.printMode === "dateRange") {
				return printDateRange();
			}

			const workOrderPrint = new WorkOrderPrint($stateParams.vehicleID, $stateParams.workOrderID, vm.printCustomerID, vm.isQuoted);
			vm.isPrinting = true;

			WorkorderUnsavedChangesHelper.checkAll()
				.then(function (result) {
					if (!Array.isArray(result)) {
						return $q.reject("Failed to check unsaved changes");
					}


					const hasUnsavedChanges = result.find(function (hasUnsavedChange) {

						return hasUnsavedChange
					});

					if (hasUnsavedChanges) {
						return DialogService.showYesOrNoDialog(null, unsavedChangeWarning, saveAndContinueStr, ignoreAndContinueStr);
					}

					return $q.resolve();
				})
				.then(function (isSavingChanges) {
					if (isSavingChanges) {
						return WorkorderUnsavedChangesHelper.saveAll();
					}

					return $q.resolve();
				})
				.then(function () {
					return workOrderPrint.fetchDatas();
				})
				.then(function () {
					return workOrderPrint.open();
				})
				.then(function () {
					// record work order print log to the backend
					const resourcePath = {
						companyID: companyID,
						vehicleID: $stateParams.vehicleID,
						workorderID: $stateParams.workOrderID
					}
					return WorkOrderService.recordWorkOrderPrint(resourcePath, workOrderPrint);
				})
				.catch(function (error) {
					if (error) {
						MessageService.showToast(error);
					}
				})
				.finally(function () {
					vm.isPrinting = false;
				});
		}

		function printDateRange() {
			if (!vm.printStartDate || !vm.printEndDate) {
				MessageService.showToast("Please choose both a start date and an end date.");
				return $q.resolve();
			}

			const startDate = moment(vm.printStartDate).format("YYYY-MM-DD");
			const endDate = moment(vm.printEndDate).format("YYYY-MM-DD");

			if (moment(startDate).isAfter(moment(endDate))) {
				MessageService.showToast("Start date must be before or equal to end date.");
				return $q.resolve();
			}

			const requestUrl = GeneralTools.getBaseUrl() + "companies/" + companyID + "/vehicles/" + $stateParams.vehicleID + "/workorders/invoice-pdf-range";
			const pdfWindow = window.open("", "_blank");

			vm.isPrinting = true;

			return $http.get(requestUrl, {
				responseType: "arraybuffer",
				headers: {
					token: LoginService.getToken()
				},
				params: {
					startDate: startDate,
					endDate: endDate
				}
			})
				.then(function (response) {
					const blob = new Blob([new Uint8Array(response.data)], { type: "application/pdf" });
					if (pdfWindow) {
						pdfWindow.location = URL.createObjectURL(blob);
					} else {
						window.open(URL.createObjectURL(blob), "_blank");
					}
				})
				.catch(function (error) {
					if (pdfWindow) {
						pdfWindow.close();
					}
					MessageService.showToast(error);
				})
				.finally(function () {
					vm.isPrinting = false;
				});
		}

		function printQR() {
			const workOrderPrint = new WorkOrderQRPrint($stateParams.vehicleID, $stateParams.workOrderID, vm.printCustomerID, vm.isQuoted, socketUrl);
			vm.isPrinting = true;
			
			if(!vm.workOrder.isBooked()){
				DialogService.showYesOrNoDialog("QR Code Scaned", workOrderStatusNotBooking, workOrderStatusSet, workOrderNo).then(function(result){
					if(result){
						onStatusClick(6);
					}

				WorkorderUnsavedChangesHelper.checkAll()
				.then(function (result) {
					if (!Array.isArray(result)) {
						return $q.reject("Failed to check unsaved changes");
					}

					const hasUnsavedChanges = result.find(function (hasUnsavedChange) {
						return hasUnsavedChange
					});

					if (hasUnsavedChanges) {
						return DialogService.showYesOrNoDialog(null, unsavedChangeWarning, saveAndContinueStr, ignoreAndContinueStr);
					}

					return $q.resolve();
				})
				.then(function (isSavingChanges) {
					if (isSavingChanges) {
						return WorkorderUnsavedChangesHelper.saveAll();
					}

					return $q.resolve();
				})
				.then(function () {
					return workOrderPrint.fetchDatas();
				})
				.then(function () {
					return workOrderPrint.open();
				})
				.catch(function (error) {
					if (error) {
						MessageService.showToast(error);
					}
				})
				.finally(function () {
					vm.isPrinting = false;
				});
				});
			}else{
				WorkorderUnsavedChangesHelper.checkAll()
				.then(function (result) {
					if (!Array.isArray(result)) {
						return $q.reject("Failed to check unsaved changes");
					}

					const hasUnsavedChanges = result.find(function (hasUnsavedChange) {
						return hasUnsavedChange
					});

					if (hasUnsavedChanges) {
						return DialogService.showYesOrNoDialog(null, unsavedChangeWarning, saveAndContinueStr, ignoreAndContinueStr);
					}

					return $q.resolve();
				})
				.then(function (isSavingChanges) {
					if (isSavingChanges) {
						return WorkorderUnsavedChangesHelper.saveAll();
					}

					return $q.resolve();
				})
				.then(function () {
					return workOrderPrint.fetchDatas();
				})
				.then(function () {
					return workOrderPrint.open();
				})
				.catch(function (error) {
					if (error) {
						MessageService.showToast(error);
					}
				})
				.finally(function () {
					vm.isPrinting = false;
				});
			}


			
		}

		function onAnchorClicked(tag) {
			switch (tag) {
				case WorkOrderConstants.anchorTags.discounts:
					if ($state.current.name == discountsState) {
						$scope.$emit(WorkOrderConstants.editWorkOrderEvents.scroll.eventName, tag);
					} else {
						$state.go(discountsState, { '#': tag });
					}
					break;
				case WorkOrderConstants.anchorTags.payments:
					if ($state.current.name == paymentsState) {
						$scope.$emit(WorkOrderConstants.editWorkOrderEvents.scroll.eventName, tag);
					} else {
						$state.go(paymentsState, { '#': tag });
					}
					break;
					case WorkOrderConstants.anchorTags.extra:
						if ($state.current.name == extraState) {
							$scope.$emit(WorkOrderConstants.editWorkOrderEvents.scroll.eventName, tag);
						} else {
							$state.go(extraState, { '#': tag });
						}
						break;
				default:
					if ($state.current.name == generalState) {
						$scope.$emit(WorkOrderConstants.editWorkOrderEvents.scroll.eventName, tag);
					} else {
						$state.go(generalState, { '#': tag });
					}
					break;
			}
		}

		function qRcodeUrlScaned(){
			if(vm.workOrder.isQuoted()){
				DialogService.showYesOrNoDialog("QR Code Scaned", workOrderStatusQuoted, workOrderStart, workOrderNo).then(function(result){
					if(result){
						onStatusClick(7);
					}
				});
			}

			if(vm.workOrder.isDeclinded()){
				DialogService.showYesOrNoDialog("QR Code Scaned", workOrderStatusDeclined, workOrderStart, workOrderNo).then(function(result){

				});
			}

			if(vm.workOrder.isCompletedElseWhere()){
				DialogService.showYesOrNoDialog("QR Code Scaned", workOrderStatusCompleted, workOrderStart, workOrderNo).then(function(result){

				});
			}

			if(vm.workOrder.isCompleted()){
				DialogService.showYesOrNoDialog("QR Code Scaned", workOrderStatusCompleted, workOrderStart, workOrderNo).then(function(result){

				});
			}

			if(vm.workOrder.isBooked()){
				DialogService.showYesOrNoDialog("QR Code Scaned", workOrderStatusBooking, workOrderStart, workOrderNo).then(function(result){
					if(result){
						onStatusClick(7);
					}
				});
			}

			if(vm.workOrder.isOnLot()){
				DialogService.showYesOrNoDialog("QR Code Scaned", workOrderStatusOnLot, workOrderStart, workOrderNo).then(function(result){
					if(result){
						onStatusClick(7);
					}
				});
			}

			if(vm.workOrder.isStarted()){
				return
			}
		}

		function onStatusClick(statusCode){
			console.log("onStatusClick")
			var promise = $q.resolve();
			promise.then(function(){
				setWorkorderStatus(statusCode);
				return updateWorkOrder(GeneralTools.updateResourceRequestBodyGenerator(vm.workOrder, WorkOrderDataSharingService.getWorkOrder()));	
			})
			.then(function(){
				MessageService.showToast("Success.");
			})
			.catch(function(error){
				if(error){
					MessageService.showToast(error);
				}
			})
			.finally(function(){
				vm.isSaving = false;
			});
		}

		function setWorkorderStatus(statusID){
			if(!vm.workOrder){
				return;
			}

			if(statusID == WorkOrderConstants.statusIDs.completed && !vm.workOrder.completed_date) {
				vm.workOrder.setCompletedDateTime(moment().utc());	
			}

			if(statusID == WorkOrderConstants.statusIDs.quoted && !vm.workOrder.quote_date) {
				vm.workOrder.setQuoteDate(moment().utc());
			}

			vm.workOrder.fk_id_work_order_status = statusID;
		}

		function updateWorkOrder(requestBody){
			const resourcePath = {
				companyID: companyID,
				vehicleID: $stateParams.vehicleID,
				workorderID: $stateParams.workOrderID
			}

			return WorkOrderService.updateWorkOrder(resourcePath, requestBody)
				.then(function(){
					WorkOrderDataSharingService.setWorkOrder(vm.workOrder);
					return $q.resolve();
				});
		}


		function addPaymentShortCut() {
			const payment = new WorkOrderPayment();

			payment.setCustomer(vm.paymentCustomer);
			payment.setReceivedBy(userInfo);
			payment.fk_id_payment_method = vm.paymentMethodID;
			payment.fk_payment_status = vm.paymentStatusID
			payment.amount = vm.paymentAmount;
			payment.invoice_number = vm.workOrder.invoice_number
			payment.description = 'Vehicle work order payment (invoice: ' + vm.workOrder.invoice_number + ')'
			if(payment.fk_id_payment_method == 11){
				payment.customerProfileID = vm.creditCardSelected.customerProfileID !== undefined ||  vm.creditCardSelected.customerProfileID !== null ? vm.creditCardSelected.customerProfileID : null;
				payment.paymentProfileID = vm.creditCardSelected.paymentProfileID !== undefined || vm.creditCardSelected.paymentProfileID !== null ? vm.creditCardSelected.paymentProfileID : null;
			}

			if (!payment || !payment.isValid()) {
				MessageService.showToast("Please make sure every field is entered");
				return;
			}

			vm.isAddingPayment = true;



			if ((vm.workOrder.fk_id_work_order_status == 3 || vm.workOrder.fk_id_work_order_status == 4)) {

				postPayment(payment)
				.then(function (newPayment) {
					const paymentList = WorkOrderDataSharingService.getPaymentList(payments);
					paymentList.push(newPayment);
					vm.summaryPaymentList = paymentList;
					WorkOrderDataSharingService.setPaymentList(paymentList);

					vm.paymentMethodID = null;
					vm.paymentAmount = null;

					MessageService.showToast("Payment is added");
				})
				.catch(MessageService.showToast)
				.finally(function () {
					vm.isAddingPayment = false;
			});

			} else {
				var dialogOptions = {};

				dialogOptions.titleString = "Work order status is not completed";
				dialogOptions.contentString = "Would you like to set work order status to completed in addition to payment ?";

				var confirmOption = {};

				confirmOption.optionName = "YES";
				confirmOption.onClick = function () {
					var promise = $q.resolve();

					promise.then(function () {
						setWorkorderStatus(4);
						return updateWorkOrder(GeneralTools.updateResourceRequestBodyGenerator(vm.workOrder, WorkOrderDataSharingService.getWorkOrder()));
					})
						.then(function () {
							MessageService.showToast("Success.");
						})
						.catch(function (error) {
							if (error) {
								MessageService.showToast(error);
							}
						})
						.finally(function () {

							postPayment(payment)
							.then(function (newPayment) {
								const paymentList = WorkOrderDataSharingService.getPaymentList(payments);
								paymentList.push(newPayment);
								vm.summaryPaymentList = paymentList;
								WorkOrderDataSharingService.setPaymentList(paymentList);
			
								vm.paymentMethodID = null;
								vm.paymentAmount = null;
			
								MessageService.showToast("Payment is added");
							})
							.catch(MessageService.showToast)
							.finally(function () {
								vm.isAddingPayment = false;
						});

							DialogService.close();

						});
				}

				var cancelOption = {};

				cancelOption.optionName = "NO";
				cancelOption.onClick = function () {
					postPayment(payment)
					.then(function (newPayment) {
						const paymentList = WorkOrderDataSharingService.getPaymentList(payments);
						paymentList.push(newPayment);
						vm.summaryPaymentList = paymentList;
						WorkOrderDataSharingService.setPaymentList(paymentList);
	
						vm.paymentMethodID = null;
						vm.paymentAmount = null;
	
						MessageService.showToast("Payment is added");
					})
					.catch(MessageService.showToast)
					.finally(function () {
						vm.isAddingPayment = false;
				});
					DialogService.close();
				}

				dialogOptions.options = [confirmOption, cancelOption];

				DialogService.showOptionsDialog(dialogOptions);


			}








		}

		function postPayment(payment) {
			const resourcePath = {
				companyID: companyID,
				vehicleID: $stateParams.vehicleID,
				workorderID: $stateParams.workOrderID
			}

			return WorkOrderService.createPayment(resourcePath, payment)
				.then(function (newPaymentID) {
					resourcePath.paymentID = newPaymentID;
					return WorkOrderService.getPayments(resourcePath).$promise;
				})
				.then(function (paymentList) {
					if (!Array.isArray(paymentList) || paymentList.length != 1 || !paymentList[0]) {
						return $q.reject("Payment just created is invalid.");
					}

					return $q.resolve(paymentList[0]);
				})
		}

		function deleteWorkorder() {
			var dialogOptions = {};

			dialogOptions.inputBoxPlaceHolder = "Enter here";
			dialogOptions.cancelButtonString = "CANCEL";
			dialogOptions.confirmButtonString = "CONFIRM";
			dialogOptions.titleString = "ARE YOU SURE TO DELETE THIS WORKORDER";
			dialogOptions.contentString = "Please Type \"" + confirmString + "\" below:";

			dialogOptions.confirmCallback = confirmDeleteWorkorderCallback;
			dialogOptions.enableConfirmButtonCallback = enableDeleteVehicleButtonCallback;

			DialogService.showConfirmDialog(dialogOptions);
		}

		function enableDeleteVehicleButtonCallback(inputString) {
			if (inputString === confirmString) {
				return true;
			}
			return false;
		}

		function confirmDeleteWorkorderCallback() {
			const resourcePath = {
				companyID: companyID,
				vehicleID: vehicleID,
				workorderID: workorderID
			};

			vm.isDeletingWorkorder = true;

			WorkOrderService.deleteWorkOrder(resourcePath)
				.then(function () {
					$state.go("app.vehicle.general", { vehicleID: vehicleID });
				})
				.catch(function (error) {
					MessageService.showToast(error);
					vm.isDeletingWorkorder = false;
				})
		}

		function controlSensitiveContent() {
			vm.showSensitiveContent = !vm.showSensitiveContent;
			$scope.$emit(WorkOrderConstants.editWorkOrderEvents.controlSensitiveContent.eventName, vm.showSensitiveContent);

			var pageConfig = LoginService.getPageConfigs(LoginConst.pageConfigKeys.editWorkorder);

			if (!pageConfig) {
				pageConfig = {};
			}

			pageConfig.showSensitiveContent = vm.showSensitiveContent;

			if (vm.hiddenSummarySections) {
				vm.hiddenSummarySections.profit = !vm.showSensitiveContent || !canSeeProfit;
			}

			LoginService.savePageConfigs(LoginConst.pageConfigKeys.editWorkorder, pageConfig);
		}

		function fetchCustomerData(customerID){
			const resourcePath = {
				companyID: companyID,
				customerID: customerID
			};
			return CustomersService.getCustomers(resourcePath)
				.then(function(result){
					if(!result || !Array.isArray(result.data) || result.data.length != 1 || !result.data[0]){
						return $q.reject("customer data invalid");
					}

					return $q.resolve(result.data[0]);
				})
		}

		vm.onPDFEmailCustomerChange  = function(){
			for (var i = 0; i < vm.customers.length; i++) {
				if (vm.customers &&  vm.customers[i] &&  vm.customers[i].email_address && vm.customers[i].id_customer == vm.printCustomerID) {
					vm.clientEmailAddressHolder = vm.customers[i].email_address[0].email_address;
					break;
				}
			}
		}

		vm.getPDFFromWorkOrder = function() {

			const workOrderPrint = new WorkOrderPrint($stateParams.vehicleID, $stateParams.workOrderID, vm.customerRegistrationTempHolder.id_customer, vm.isQuoted);

			vm.isPrinting = true;

			WorkorderUnsavedChangesHelper.checkAll()
				.then(function (result) {
					if (!Array.isArray(result)) {
						return $q.reject("Failed to check unsaved changes");
					}


					const hasUnsavedChanges = result.find(function (hasUnsavedChange) {

						return hasUnsavedChange
					});

					if (hasUnsavedChanges) {
						return DialogService.showYesOrNoDialog(null, unsavedChangeWarning, saveAndContinueStr, ignoreAndContinueStr);
					}

					return $q.resolve();
				})
				.then(function (isSavingChanges) {
					if (isSavingChanges) {
						return WorkorderUnsavedChangesHelper.saveAll();
					}

					return $q.resolve();
				})
				.then(function () {
					return workOrderPrint.fetchDatas();
				})
				.then(function () {
					return workOrderPrint.getPdfDocDefinition().then(function(result){
						var emaildata = {
							customerID: vm.customerRegistrationTempHolder.id_customer,
							customer_name: vm.customerRegistrationTempHolder.first_name + " " + vm.customerRegistrationTempHolder.last_name,
							pdf_data: result,
							is_quoted: vm.isQuoted,
							email_address: vm.clientEmailAddressHolder,
							invoice_number: vm.workOrder.invoice_number
						}

						const resourcePath = {
							companyID: companyID,
							vehicleID: $stateParams.vehicleID,
							workorderID: $stateParams.workOrderID
						}
			
						return WorkOrderService.sendWorkOrderPDFEmail(resourcePath, emaildata)
							.then(function () {
								return $q.resolve();
							});



					});
				})
				.catch(function (error) {
					if (error) {
						MessageService.showToast(error);
					}
				})
				.finally(function () {
					setTimeout(function() {
						vm.isPrinting = false;
						MessageService.showToast("Work Order PDF Email Send.");
					  }, 3000);
				});
		}

		vm.onCreditCardCustomerSelectionChange = function(){
			if(vm.paymentCustomer && vm.paymentCustomer.id_customer){
				var resourcePath = {}; 
				resourcePath.companyID = LoginService.getCompanyID();
				resourcePath.customerID = vm.paymentCustomer.id_customer
				CustomersService.getCreditCards(resourcePath)
				.then(function(result){
					vm.customerCreditCards = result
				})
			}
		}

		vm.getCustomerPhoneDisplay = function(customer) {
			if (customer && Array.isArray(customer.phone_numbers) && customer.phone_numbers[0]) {
				return GeneralTools.stringToPhoneNumberString(customer.phone_numbers[0].phone_number);
			}
			return '';
		}

		vm.onTrackingCustomerChange = function() {
			for (var i = 0; i < vm.customers.length; i++) {
				if (vm.customers[i] && vm.customers[i].id_customer == vm.trackingCustomerID) {
					vm.trackingCustomer = vm.customers[i];
					return;
				}
			}
			vm.trackingCustomer = null;
		}

		function sendTrackingLink() {
			if (!vm.trackingCustomerID || !vm.trackingCustomer || vm.isSendingTrackingLink) {
				return;
			}

			var phone = '';
			if (Array.isArray(vm.trackingCustomer.phone_numbers) && vm.trackingCustomer.phone_numbers[0]) {
				phone = vm.trackingCustomer.phone_numbers[0].phone_number;
			}

			if (!phone) {
				MessageService.showToast('Selected customer has no phone number on file.');
				return;
			}

			vm.isSendingTrackingLink = true;
			var token = LoginService.getToken();

			$http.post(GeneralTools.getBaseUrl() + 'tracking/send-link', {
				customerID: vm.trackingCustomerID,
				workOrderID: workorderID,
				phone: phone,
				customerName: vm.trackingCustomer.first_name
			}, {
				headers: { 'token': token }
			})
			.then(function(response) {
				var msg = (response.data && response.data.message) ? response.data.message : 'Tracking link sent successfully.';
				MessageService.showToast(msg);
			})
			.catch(function(error) {
				var msg = (error && error.data && error.data.message) ? error.data.message : 'Failed to send tracking link.';
				MessageService.showToast(msg);
			})
			.finally(function() {
				vm.isSendingTrackingLink = false;
			});
		}
	}
})();

(function ()
{
	'use strict';

	angular
		.module('app.workOrders')
		.controller('EditWorkOrderPaymentsController', EditWorkOrderPaymentsController);

	function EditWorkOrderPaymentsController(vehicle, WorkorderUnsavedChangesHelper, customers, SaleInfoService, WorkOrderDataSharingService, $rootScope, $state, $q, GeneralTools, sharedConstants, DialogService, LoginService, $scope, MessageService, WorkOrderService, $stateParams, WorkOrderConstants, customersaleInfos, customerserviceMap, CustomersService, $location, WorkOrderRDRedeemed){
		const vm = this;
		const controllerName = "EditWorkOrderPaymentsController";
		const companyID = LoginService.getCompanyID();
		const unsavedChangeWarning = "This page has unsaved content."
		const saveAndContinueStr = "save & continue";
		const ignoreAndContinueStr = "ignore & continue";
		const userInfo = LoginService.getUserInfo();
		var isIgnoringUnsavedChanges = false;

		vm.paymentsAnchorTag = WorkOrderConstants.anchorTags.payments;
		vm.subsidizedPercentageInputOptions = {
			maxValue: 100
		}
		vm.translateToDollar = GeneralTools.inputTranslators.dollar;
		vm.translateToPercentage = GeneralTools.inputTranslators.percentage;
		vm.addPayment = addPayment;
		vm.deletePayment = deletePayment;
		vm.onSaveClick = onSaveClick;
		vm.initWarrantyClaimWarningMessage = initWarrantyClaimWarningMessage;
		vm.redeemRogerDollar = redeemRogerDollar;
		vm.deletRogerDollarRedeem = deletRogerDollarRedeem;
		vm.isAnyRogersDollarRedeemItemSelected = isAnyRogersDollarRedeemItemSelected;
		vm.onCustomerSelectionChange = onCustomerSelectionChange;
		vm.redeemamount = 0;
		vm.voidCreditCardPayment = voidCreditCardPayment;
		vm.refundCreditCardPayment = refundCreditCardPayment;
		init();

		function init(){
			initConstants();
			vm.workOrder = WorkOrderDataSharingService.getWorkOrder();
			initPayments();
			initWorkorderPaymentStatus();
			initCustomers();
			initObservers();
			initListeners();
			subscribeToUnsavedChangesHelper();
			initVehicle();
			initCustomerInfo();
			initWorkOrderRDRedeemed();
		}

		function subscribeToUnsavedChangesHelper(){
			WorkorderUnsavedChangesHelper.subscribe(controllerName, {
				check:function(){
					if(getUnsavedChanges().paymentstatus.length == 0 && getUnsavedChanges().subside == undefined){
						return null
					}else{
						return $q.resolve(!!getUnsavedChanges().subside || !!getUnsavedChanges().paymentstatus);
					}
					
				},
				save: function(){
					var unsavedChanges = getUnsavedChanges().subside;
					var unsavedChanges2 = getUnsavedChanges().paymentstatus;
					if(unsavedChanges == undefined){
						unsavedChanges = []
					}
					const defer = $q.defer();
					
					if(unsavedChanges || unsavedChanges2){
						vm.isSaving = true;
						if(unsavedChanges){
							updateWorkOrder(unsavedChanges).then(function(){
								defer.resolve()
							})
							.catch(defer.reject)
							.finally(function(){
								vm.isSaving = false;
							});
						}
						if(unsavedChanges2){
							updateWorkOrderPaymentStatus(unsavedChanges2).then(function(){
								defer.resolve()
							})
							.catch(defer.reject)
							.finally(function(){
								vm.isSaving = false;
							});
						}


					} else {
						defer.resolve();
					}

					return defer.promise;
				}
			})
		}

		function initObservers(){
			$rootScope.$on(WorkOrderConstants.editWorkOrderEvents.scroll.eventName, function(event, tag){
				GeneralTools.scrollToTag(tag);
			});

			$scope.$on("$stateChangeStart", function(event, toState, toParams, fromState, fromParams){
				const unsavedChanges = getUnsavedChanges().subside;
				const unsavedChanges2 = getUnsavedChanges().paymentstatus;
				if(!unsavedChanges || isIgnoringUnsavedChanges || !unsavedChanges2){
					WorkorderUnsavedChangesHelper.unsubscribe(controllerName);
					return;
				}

				event.preventDefault();
				$rootScope.$root.loadingProgress = false;
				DialogService.showYesOrNoDialog(null, unsavedChangeWarning, saveAndContinueStr, ignoreAndContinueStr)
					.then(function(isYes){
						if(isYes){
							vm.isSaving = true;
							return updateWorkOrder(unsavedChanges).then(function(){
								if(unsavedChanges2){
									updateWorkOrderPaymentStatus(unsavedChanges2);
								}
							});
						}
						
						isIgnoringUnsavedChanges = true;
						return $q.resolve();
					})
					.then(function(){
						WorkorderUnsavedChangesHelper.unsubscribe(controllerName);
						$state.go(toState.name, toParams);
					})
					.catch(function(error){
						if(error){
							MessageService.showToast(error);
						}
					})
					.finally(function(){
						vm.isSaving = false;
					});				
			});
		}

		function initListeners(){
			$scope.$watch("vm.payments.length", function(){
				$scope.$emit(
					WorkOrderConstants.editWorkOrderEvents.updateSummary.eventName, 
					WorkOrderConstants.editWorkOrderEvents.updateSummary.updateDetails.payments, 
					vm.payments);
			});	

			$scope.$watch("vm.workOrder.subsidized_amount", function(){
				$scope.$emit(
					WorkOrderConstants.editWorkOrderEvents.updateSummary.eventName, 
					WorkOrderConstants.editWorkOrderEvents.updateSummary.updateDetails.workOrder, 
					vm.workOrder);
			});

			$scope.$watch("vm.workOrderRDRedeemedList.length", function(){
				$scope.$emit(
					WorkOrderConstants.editWorkOrderEvents.updateSummary.eventName, 
					WorkOrderConstants.editWorkOrderEvents.updateSummary.updateDetails.workOrderRogerDollarRedeemed,
					vm.workOrderRDRedeemedList);
			});
		}

		function initPayments(){
			const payments = WorkOrderDataSharingService.getPaymentList();
			if(Array.isArray(payments)){
				vm.payments = payments;
			} else {
				vm.payments = [];
			}	
		}

		function initWorkorderPaymentStatus(){
			const paymentstatuslist = WorkOrderDataSharingService.getWorkOrderPaymentStatusList();
			if(Array.isArray(paymentstatuslist)){
				vm.paymentstatuslist = paymentstatuslist;
			} else {
				vm.paymentstatuslist = [];
			}	
		}

		function initConstants(){
			if(!sharedConstants){
				MessageService.showToast("sharedConstants invalid");
				return;
			}

			vm.paymentMethods = sharedConstants.paymentMethods;
		}

		function initCustomers(){
			if(Array.isArray(customers)){
				vm.customers = customers;
			} else {
				vm.customers = [];
			}
		}

		function addPayment(payment){
			if(!payment || !payment.isValid()){
				MessageService.showToast("Please make sure every field is entered");
				return;
			}

			vm.isAddingPayment = true;
			postPayment(payment)
				.then(function(newPayment){
					if(Array.isArray(vm.payments)){
						vm.payments.push(newPayment);
						WorkOrderDataSharingService.setPaymentList(vm.payments);
					}				
					vm.cleanPaymentInputs();
					MessageService.showToast("Payment is added");
				})
				.catch(MessageService.showToast)
				.finally(function(){
					vm.isAddingPayment = false;
				});
		}

		function postPayment(payment){
			const resourcePath = {
				companyID: companyID,
				vehicleID: $stateParams.vehicleID,
				workorderID: $stateParams.workOrderID
			}

			return WorkOrderService.createPayment(resourcePath, payment)
				.then(function(newPaymentID){
					resourcePath.paymentID = newPaymentID;
					return WorkOrderService.getPayments(resourcePath).$promise;
				})
				.then(function(paymentList){
					if(!Array.isArray(paymentList) || paymentList.length != 1 || !paymentList[0]){
						return $q.reject("Payment just created is invalid.");
					}

					if(!Array.isArray(vm.payments)){
						return $q.reject("Payment list invalid.");
					}

					return $q.resolve(paymentList[0]);
				})
		}

		function deletePayment(payment, index){
			if(!payment){
				MessageService.showToast("Payment data invalid");
				return;
			}

			var dialogOptions = {};

			dialogOptions.titleString = "Delete Payment";
			dialogOptions.contentString = "Are you sure to remove payment - $" + payment.amount;

			var confirmOption = {};

			confirmOption.optionName = "YES";
			confirmOption.onClick = function(){
				confirmDeletePayment(payment.id_work_order_payment, index);
				DialogService.close();
			}

			var cancelOption = {};

			cancelOption.optionName = "NO";
			cancelOption.onClick = function(){
				DialogService.close();
			}

			dialogOptions.options = [confirmOption, cancelOption];

			DialogService.showOptionsDialog(dialogOptions);
		}

		function confirmDeletePayment(paymentID, index){
			const resourcePath = {
				companyID: companyID,
				vehicleID: $stateParams.vehicleID,
				workorderID: $stateParams.workOrderID,
				paymentID: paymentID
			}
			
			vm.isDeletingPayment = true;

			WorkOrderService.deletePayment(resourcePath)
				.then(function(){
					if(Array.isArray(vm.payments)){
						vm.payments.splice(index, 1);
						WorkOrderDataSharingService.setPaymentList(vm.payments);
					}		
					MessageService.showToast("Payment is removed.");
				})
				.catch(MessageService.showToast)
				.finally(function(){
					vm.isDeletingPayment = false;
				});
		}

		function onSaveClick(){
			const workOrderRequestBody = getUnsavedChanges().subside;
			const workOrderRequestBody2 = getUnsavedChanges().paymentstatus;
			if(!workOrderRequestBody && !workOrderRequestBody2){
				MessageService.showToast("No changes detected.");
				return 
			}
			
			vm.isSaving = true;

			if(workOrderRequestBody){
				updateWorkOrder(workOrderRequestBody)
				.then(function(){
					MessageService.showToast("Success.")
				})
				.catch(MessageService.showToast)
				.finally(function(){
					vm.isSaving = false;
				});
			}
			if(workOrderRequestBody2.length > 0){
				updateWorkOrderPaymentStatus(workOrderRequestBody2)
				.then(function(){
					MessageService.showToast("Success.")
				})
				.catch(MessageService.showToast)
				.finally(function(){
					vm.isSaving = false;
				});
			}


		}

		function updateWorkOrder(requestBody){
			const resourcePath = {
				companyID: companyID,
				vehicleID: $stateParams.vehicleID,
				workorderID: $stateParams.workOrderID
			}

			return WorkOrderService.updateWorkOrder(resourcePath, requestBody)
				.then(function(){
					WorkOrderDataSharingService.setWorkOrder(vm.workOrder);
					return $q.resolve();
				});
		}

		function updateWorkOrderPaymentStatus(requestBody){
			if(requestBody.length <= 0){
				return
			}
			const resourcePath = {
				companyID: companyID,
				vehicleID: $stateParams.vehicleID,
				workorderID: $stateParams.workOrderID,
			}

			return WorkOrderService.updateWorkOrderPayment(resourcePath, requestBody)
				.then(function(){
					WorkOrderDataSharingService.setPaymentList(vm.payments);
					return $q.resolve();
				});
		}

		function showUnsaveChangesWarning(message){
			const defer = $q.defer()
			var dialogOptions = {};

			dialogOptions.titleString = "You have unsaved changes";
			dialogOptions.contentString = message;;

			var ignoreOption = {};
			ignoreOption.optionName = "IGNORE";
			ignoreOption.onClick = function(){
				defer.resolve(false)
			}

			var confirmOption = {};
			confirmOption.optionName = "YES";
			confirmOption.onClick = function(){
				defer.resolve(true)
			}

			var cancelOption = {};
			cancelOption.optionName = "NO";
			cancelOption.onClick = function(){
				defer.reject()
			}

			dialogOptions.options = [ignoreOption, confirmOption, cancelOption];

			DialogService.showOptionsDialog(dialogOptions);

			return defer.promise;
		}

		function getUnsavedChanges(){
			const originWorkorder = WorkOrderDataSharingService.getWorkOrder();
			const originPayment = WorkOrderDataSharingService.getPaymentList();
			var paymentstatustempholder = [];
			var subsidizedtempholder;
			var totalhodler = {}
			if(vm.workOrder.selectedCustomer){
				delete vm.workOrder.selectedCustomer
			}

			if(vm.workOrder.is_subsidized_by_percentage){
				vm.workOrder.subsidized_amount = originWorkorder.subsidized_amount;
			} else {
				vm.workOrder.subsidized_percentage = originWorkorder.subsidized_percentage;
			}

			subsidizedtempholder = GeneralTools.updateResourceRequestBodyGenerator(vm.workOrder, originWorkorder)

			for(var i = 0; i<originPayment.length; i++){
				if(originPayment[i].fk_payment_status != vm.payments[i].fk_payment_status){
					paymentstatustempholder.push({
						paymentID: vm.payments[i].id_work_order_payment,
						fk_payment_status: vm.payments[i].fk_payment_status
					})
				}
			}
			totalhodler.subside = subsidizedtempholder

			totalhodler.paymentstatus = paymentstatustempholder

			return totalhodler
		}

		function initCompletedWorkOrderWarranty() {

			const resourcePath = {
				companyID: companyID,
				vehicleID: $stateParams.vehicleID,
				workorderID: $stateParams.workOrderID,
			};

			const body = {
				iscompleted: true
			}

			WorkOrderService.getWorkOrderWarranties(resourcePath, body).$promise
				.then(function (result) {
					if (!result) {
						return $q.reject("Failed to fetch work order available warranty, warranty are invalid");
					}
					vm.completedWorkOrderWarranty = result

					vm.max_claim = 0
					if(vm.saleinfowarranty && vm.saleinfowarranty.max_claim){
						vm.max_claim = parseFloat(vm.saleinfowarranty.max_claim)
					}
		
					if(vm.completedWorkOrderWarranty.length > 0){
						vm.completedWorkOrderWarranty.forEach(function(WorkOrderWarranty) {
							if(parseFloat(WorkOrderWarranty.max_claim) > vm.max_claim){
								vm.max_claim = parseFloat(WorkOrderWarranty.max_claim)
							}
						});
					}
				})
				.catch(MessageService.showToast)
		}

		function initVehicle() {
			if (vehicle && Array.isArray(vehicle.data) && vehicle.data.length === 1 && !!vehicle.data[0]) {
				vm.vehicle = vehicle.data[0]
			}
			// vehicle is sold
			if (vm.vehicle.is_sold) {
				initSalePackageItems();
			}else{
				initCompletedWorkOrderWarranty();
			}

		}

		function initSalePackageItems() {
			const saleInfoResourcePath = {
				companyID: companyID,
				vehicleID: $stateParams.vehicleID
			};

			const workOrderWarrantyresourcePath = {
				companyID: companyID,
				vehicleID: $stateParams.vehicleID,
				workorderID: $stateParams.workOrderID,
			};

			const body = {
				iscompleted: true
			}



			var saleInfoID;

			SaleInfoService.getVehicleSaleInfos(saleInfoResourcePath)
				.then(function (saleInfos) {
					if (!Array.isArray(saleInfos) || !saleInfos[0]) {
						return $q.reject("Failed to fetch available items, sale info invalid.");
					}
					vm.saleInfo = saleInfos[0]
					saleInfoID = saleInfos[0].id_sale_info;
				})
				.then(function(){
					return WorkOrderService.getWorkOrderWarranties(workOrderWarrantyresourcePath, body).$promise

				})
				.then(function (result) {
					if (!result) {
						return $q.reject("Failed to fetch work order available warranty, warranty are invalid");
					}
					vm.completedWorkOrderWarranty = result

					
				}).then(function(){
					const saleWarrntyresourcePath = {
						companyID: companyID,
						vehicleID: $stateParams.vehicleID,
						saleinfoID: vm.saleInfo.id_sale_info
					}
					SaleInfoService.getSaleWarranties(saleWarrntyresourcePath).then(function (warranties) {
						if (!Array.isArray(warranties) || !warranties[0]) {
							return;
						}
		
						vm.saleinfowarranty = warranties[0];
						vm.max_claim = 0
						if(vm.saleinfowarranty && vm.saleinfowarranty.max_claim){
							vm.max_claim = parseFloat(vm.saleinfowarranty.max_claim)
						}
			
						if(vm.completedWorkOrderWarranty.length > 0){
							vm.completedWorkOrderWarranty.forEach(function(WorkOrderWarranty) {
								if(parseFloat(WorkOrderWarranty.max_claim) > vm.max_claim){
									vm.max_claim = parseFloat(WorkOrderWarranty.max_claim)
								}
							});
						}
					});
				})
				.catch(MessageService.showToast);
		}

		function initWarrantyClaimWarningMessage(){
			var max_claim = 0
			if(vm.saleinfowarranty && vm.saleinfowarranty.max_claim){
				max_claim = parseFloat(vm.saleinfowarranty.max_claim)
			}
			if(vm.completedWorkOrderWarranty.length > 0){
				vm.completedWorkOrderWarranty.forEach(function(WorkOrderWarranty) {
					if(parseFloat(WorkOrderWarranty.max_claim) > max_claim){
						max_claim = parseFloat(WorkOrderWarranty.max_claim)
					}
				});
			}
		}

		function deletRogerDollarRedeem(){
			if(!isAnyRogersDollarRedeemItemSelected()){
				MessageService.showToast("No item selected");
				return;
			}

			var dialogOptions = {};

			dialogOptions.titleString = "Delete Rogers Dollar Redemption";
			dialogOptions.contentString = "Are you sure to delete rogers dollar redemption";

			var confirmOption = {};

			confirmOption.optionName = "YES";
			confirmOption.onClick = function(){
				confirmDeleteRogerDollarRedeem();
				DialogService.close();
			}

			var cancelOption = {};

			cancelOption.optionName = "NO";
			cancelOption.onClick = function(){
				DialogService.close();
			}

			dialogOptions.options = [confirmOption, cancelOption];

			DialogService.showOptionsDialog(dialogOptions);
		}

		function confirmDeleteRogerDollarRedeem(discountID, index){
			if(!vm.rogersDollarselectedMap || !Array.isArray(vm.workOrderRDRedeemedList)){
				return;
			}
			

			const queue = [];

			vm.workOrderRDRedeemedList.forEach(function(discount){
				if(!discount || ((discount.resourceData &&!vm.rogersDollarselectedMap[discount.resourceData.id_rd_redeemed]) && (discount &&!vm.rogersDollarselectedMap[discount.id_rd_redeemed])) ){
					return;
				}
				queue.push(deleteRogerDollarRedeem(getRDRedeemItemID(discount)));	
			});

			vm.isDeletingDiscount = true;

			$q.all(queue)
				.then(function(){

					//WorkOrderDataSharingService.setRDRedeemeddList(vm.workOrderRDRedeemedList);

				})
				.catch(MessageService.showToast)
				.finally(function(){
					vm.isDeletingDiscount = false;
				})
		}

		function deleteRogerDollarRedeem(rogerDollarID){
			const resourcePath = {
				companyID: companyID,
				vehicleID: $stateParams.vehicleID,
				workorderID: $stateParams.workOrderID,
				rgdollarsredeemID: rogerDollarID,
			}
			return WorkOrderService.deleteRDRedeem(resourcePath)
				.then(function(){
					vm.workOrderRDRedeemedList = []			
					WorkOrderDataSharingService.setRDRedeemeddList(vm.workOrderRDRedeemedList);		
					return $q.resolve();
				});		
		}

		function redeemRogerDollar(){
			if(!vm.selectedCustomer || !vm.selectedCustomer.customerInfo){
				MessageService.showToast("Please select a customer to redeem from.");
				return;
			}


			if(vm.redeemamount <= 0){
				MessageService.showToast("Please enter a correct amount to redeem.");
				return;
			}

			vm.isRedeeming = true
			const resourcePath = {
				companyID: companyID,
				vehicleID: $stateParams.vehicleID,
				workorderID: $stateParams.workOrderID,
			}
			return WorkOrderService.redeemRogerDollar(resourcePath, {redeemamount: vm.redeemamount, customerID: vm.selectedCustomer.customerInfo.id_customer})
			.then(function (insertID) {
				if(insertID){

					var temp = new WorkOrderRDRedeemed();
					temp.setAttributes({
						id_rd_redeemed: insertID,
						redeemed_amount: vm.redeemamount,
						fk_id_work_order: $stateParams.workOrderID,
						fk_id_user: userInfo.userID,
						fk_id_customer: vm.selectedCustomer.customerInfo.id_customer,
						date: moment().format("YYYY-MM-DD")
					})

					const newArray = [temp].map(function(obj){
						const resourceData  = {
							id_rd_redeemed: insertID,
							fk_id_work_order: parseInt($stateParams.workOrderID),
							fk_id_customer: vm.selectedCustomer.customerInfo.id_customer,
							redeemed_amount: vm.redeemamount,
							date: moment().format("YYYY-MM-DD"),
							fk_id_user: userInfo.userID,
						}
						return resourceData
					})
					
					vm.workOrderRDRedeemedList =  angular.copy(newArray)
					WorkOrderDataSharingService.setRDRedeemeddList(newArray);
					initWorkOrderRDRedeemed();
				}else{
					MessageService.showToast("Redemption failed. The work order may include a redemption.");
				}
				return $q.resolve();
			})
			.catch(MessageService.showToast)
			.finally(function(){
				vm.isRedeeming = false
			});
		}

		function initWorkOrderRDRedeemed() {
			const workOrderRDRedeemed = WorkOrderDataSharingService.getRDRedeemeddList();


			if (!Array.isArray(workOrderRDRedeemed)) {
				return;
			}

			vm.workOrderRDRedeemedList = workOrderRDRedeemed;
		}

		function getRDRedeemItemID(discount){
			var Id;
			if(discount && discount.resourceData){
				Id = discount.resourceData.id_rd_redeemed
			}else if(discount && discount.id_rd_redeemed){
				Id = discount.id_rd_redeemed
			}
			return Id
		}

		function initCustomerInfo(){
			vm.customerList = {};
			if(!Array.isArray(customersaleInfos)){
				return;
			}

			customersaleInfos.forEach(function(saleInfo){
				if(!saleInfo || saleInfo.is_canceled){
					return;
				}

				if(!vm.customerList[saleInfo.fk_id_customer]){
					vm.customerList[saleInfo.fk_id_customer] = {};
				}

				if(!Array.isArray(vm.customerList[saleInfo.fk_id_customer].customersaleInfos)){
					vm.customerList[saleInfo.fk_id_customer].customersaleInfos = [];
				}

				vm.customerList[saleInfo.fk_id_customer].customersaleInfos.push(saleInfo);
			})

			if(!Array.isArray(customerserviceMap)){
				return;
			}

			customerserviceMap.forEach(function(item){
				if(!item || !item.customer){
					return;
				}

				if(!vm.customerList[item.customer.id_customer]){
					vm.customerList[item.customer.id_customer] = {};
				}

				if(item.customer.rogerDollarAvaliable && item.customer.rogerDollarAvaliable >= 0){
					vm.customerList[item.customer.id_customer].customerInfo = {
						first_name: item.customer.first_name,
						last_name: item.customer.last_name,
						id_customer: item.customer.id_customer,
						rogerDollarAvaliable: item.customer.rogerDollarAvaliable
					}
				}else{
					item.customer.rogerDollarAvaliable = 0
					vm.customerList[item.customer.id_customer].customerInfo = {
						first_name: item.customer.first_name,
						last_name: item.customer.last_name,
						id_customer: item.customer.id_customer,
						rogerDollarAvaliable: item.customer.rogerDollarAvaliable
					}
				}

				vm.customerList[item.customer.id_customer].customerserviceMap = item.id_service_map;
			});

			const queue = [];
			Object.keys(vm.customerList).forEach(function(customerID){
				queue.push(fetchCustomerData(customerID));
			});

			vm.fetchingCustomersData = true;

			$q.all(queue)
				.then(function(result){
					if(!Array.isArray(result)){
						return $q.reject("Customers data invalid");
					}

					result.forEach(function(customer){
						if(!customer){
							return;
						}

						if(!vm.customerList[customer.id_customer]){
							vm.customerList[customer.id_customer] = {};
						}

						vm.customerList[customer.id_customer].customerInfo = customer;
					});

					return $q.resolve()
				})
				.catch(MessageService.showToast)
				.finally(function(){
					if(vm.customerList){
						for (var customerId in vm.customerList){
							if(vm.workOrder){
								var customer = vm.customerList[customerId];
								var customerInfo = customer.customerInfo;
								vm.selectedCustomer = customer
							}

							if(vm.customerList[customerId].customerInfo.rogerDollarAvaliable < 0){
								vm.customerList[customerId].customerInfo.rogerDollarAvaliable = 0
							}


						  }
					}else{
						vm.selectedCustomer={}
					}
					if(vm.selectedCustomer && vm.selectedCustomer.customerInfo.rogerDollarAvaliable >= 0 ){
						vm.redeemamount = vm.selectedCustomer.customerInfo.rogerDollarAvaliable
					}else{
						vm.redeemamount = 0
					}
					$location.search({}).replace();
					vm.fetchingCustomersData = false;
				});
		}

		function fetchCustomerData(customerID){
			const resourcePath = {
				companyID: companyID,
				customerID: customerID
			};

			return CustomersService.getCustomers(resourcePath)
				.then(function(result){
					if(!result || !Array.isArray(result.data) || result.data.length != 1 || !result.data[0]){
						return $q.reject("customer data invalid");
					}

					return $q.resolve(result.data[0]);
				})
		}

		function isAnyRogersDollarRedeemItemSelected(){
			if(!vm.rogersDollarselectedMap || !Array.isArray(vm.workOrderRDRedeemedList)){
				return;
			}

			const selectedItem = vm.workOrderRDRedeemedList.find(function(discount){
				var redeemid;
				if(discount.resourceData){
					redeemid = discount.resourceData.id_rd_redeemed;
				}else if(discount.id_rd_redeemed){
					redeemid = discount.id_rd_redeemed
				}
				return !!discount && vm.rogersDollarselectedMap[redeemid]
			});
			
			return !!selectedItem;
		}
		function onCustomerSelectionChange(){
			if(vm.selectedCustomer && vm.selectedCustomer.customerInfo.rogerDollarAvaliable){
				vm.redeemamount = vm.selectedCustomer.customerInfo.rogerDollarAvaliable
			}else{
				vm.redeemamount = 0
			}
		}

		
		function voidCreditCardPayment(payment, index){
			if(!payment){
				MessageService.showToast("Payment data invalid");
				return;
			}

			var dialogOptions = {};

			dialogOptions.titleString = "Void Payment";
			dialogOptions.contentString = "Are you sure to void credit card payment - $" + payment.amount;

			var confirmOption = {};

			confirmOption.optionName = "YES";
			confirmOption.onClick = function(){
				confirmVoidCreditCardPayment(payment.customer, payment.authorize_net_profile_id, payment.authorize_trans_id, index);
				DialogService.close();
			}

			var cancelOption = {};

			cancelOption.optionName = "NO";
			cancelOption.onClick = function(){
				DialogService.close();
			}

			dialogOptions.options = [confirmOption, cancelOption];

			DialogService.showOptionsDialog(dialogOptions);
		}

		function confirmVoidCreditCardPayment(customer, authorize_net_profile_id, authorize_trans_id, index){
			const resourcePath = {
				companyID: companyID,
				customerID: customer.id_customer,
				authorizeNetProfile: authorize_net_profile_id
			}
			
			vm.isDeletingPayment = true;
			var requestBody = {
				companyID: companyID,
				customerID: customer.id_customer,
				authorize_trans_id: authorize_trans_id,
				authorizeNetProfile: authorize_net_profile_id
			}
			WorkOrderService.voidCreditCardsPayment(requestBody, resourcePath)
				.then(function(result){
					if(Array.isArray(vm.payments)){
						vm.payments[index].is_canceled = 1
						vm.payments[index].message = result.message
						vm.payments[index].authorize_trans_id = result.authorize_trans_id
						vm.payments[index].authorize_trans_detail_copy = result.authorize_trans_detail_copy
					}		
					MessageService.showToast("Credit Card payment is void.");
				})
				.catch(MessageService.showToast)
				.finally(function(){
					vm.isDeletingPayment = false;
				});

		}

		function refundCreditCardPayment(payment, index){
			if(!payment){
				MessageService.showToast("Payment data invalid");
				return;
			}

			var dialogOptions = {};

			dialogOptions.titleString = "Refund Payment";
			dialogOptions.contentString = "Are you sure to refund credit card payment - $" + payment.amount;

			var confirmOption = {};

			confirmOption.optionName = "YES";
			confirmOption.onClick = function(){
				confirmRefundCreditCardPayment(payment.customer, payment.authorize_net_profile_id, payment.authorize_trans_id, payment.amount, index);
				DialogService.close();
			}

			var cancelOption = {};

			cancelOption.optionName = "NO";
			cancelOption.onClick = function(){
				DialogService.close();
			}

			dialogOptions.options = [confirmOption, cancelOption];

			DialogService.showOptionsDialog(dialogOptions);
		}

		function confirmRefundCreditCardPayment(customer, authorize_net_profile_id, authorize_trans_id, amount, index){
			const resourcePath = {
				companyID: companyID,
				customerID: customer.id_customer,
				authorizeNetProfile: authorize_net_profile_id
			}
			
			vm.isDeletingPayment = true;
			var requestBody = {
				companyID: companyID,
				customerID: customer.id_customer,
				authorize_trans_id: authorize_trans_id,
				authorizeNetProfile: authorize_net_profile_id,
				amount: amount
			}
			WorkOrderService.refundCreditCardsPayment(requestBody, resourcePath)
				.then(function(result){
					if(Array.isArray(vm.payments)){
						vm.payments[index].is_refund = 1
						vm.payments[index].message = result.message
						vm.payments[index].authorize_trans_id = result.authorize_trans_id
						vm.payments[index].authorize_trans_detail_copy = result.authorize_trans_detail_copy
					}		
					MessageService.showToast("Credit card payment is refound.");
				})
				.catch(MessageService.showToast)
				.finally(function(){
					vm.isDeletingPayment = false;
				});

		}


	}
})();
(function ()
{
	'use strict';

	angular
		.module('app.workOrders')
		.controller('EditWorkOrderLogsController', EditWorkOrderLogsController);

	function EditWorkOrderLogsController($q, constants, $state, appointments, DialogService, LoginService, GeneralTools, $scope, AppointmentConstants, AppointmentsService, ToolsConstants, MessageService, WorkOrderService, $stateParams, WorkOrderConstants, workorderlogs){
		const vm = this;
		const companyID = LoginService.getCompanyID();
		const timeRangeFilterFormat = "YYYY-MM-DD HH:mm:ss";
		const startKeyName = "start";

		vm.addAppointmentUrl = $state.href("app.workorder-schedule", {workOrderID: $stateParams.workOrderID, vehicleID: $stateParams.vehicleID});
		vm.appointments = [];
		vm.removeSelectedAppointments = removeSelectedAppointments;
		vm.updateAppointmentStatus = updateAppointmentStatus;
		vm.isAnyItemSelected = isAnyItemSelected;
		vm.disableDeleteButton = disableDeleteButton;

		init();

		function init(){
			initConstants();
			initWorkOrderLogs();
			fetchCustomerPortalAppointment();
		}

		function initConstants(){
			if(!constants){
				MessageService.showToast("constants invalid");
				return;
			}

			vm.appointmentStatus = constants.appointmentStatus;
		}

		function initWorkOrderLogs(){
			if(Array.isArray(workorderlogs)){
				vm.workorderlogs = workorderlogs;
			} else {
				vm.workorderlogs = [];
			}
		}

		function removeSelectedAppointments(){
			var dialogOptions = {};

			dialogOptions.titleString = "Delete Appointments";
			dialogOptions.contentString = "Are you sure to delete selected appointments";

			var confirmOption = {};

			confirmOption.optionName = "YES";
			confirmOption.onClick = function(){
				confirmDeleteSelectedAppointments();
				DialogService.close();
			}

			var cancelOption = {};

			cancelOption.optionName = "NO";
			cancelOption.onClick = function(){
				DialogService.close();
			}

			dialogOptions.options = [confirmOption, cancelOption];

			DialogService.showOptionsDialog(dialogOptions);
		}

		function confirmDeleteSelectedAppointments() {
			if(!vm.selectedMap || !Array.isArray(vm.appointments)){
				return;
			}

			const queue = [];
			vm.isDeletingAppointment = true;

			vm.appointments.forEach(function(appointment){
				if(!appointment || !vm.selectedMap[appointment.id_work_order_appointment]){
					return;
				}
				
				queue.push(deleteAppointment(appointment.id_work_order_appointment));	
			});

			$q.all(queue)
				.then(function(){			
					MessageService.showToast("Appointments is deleted.");
				})
				.catch(MessageService.showToast)
				.finally(function(){
					vm.isDeletingAppointment = false;
				})
		}

		function deleteAppointment(appointmentID){
			const resourcePath = {
				companyID: companyID,
				workorderappointmentID: appointmentID
			}

			return WorkOrderService.deleteAppointment(resourcePath)
				.then(function(){
					const index = vm.appointments.findIndex(function(appointment) {
						return appointment && appointment.id_work_order_appointment == appointmentID;
					});

					vm.appointments.splice(index, 1);
					return $q.resolve();
				});
		}

		function updateAppointmentStatus(appointment) {
			if(!appointment){
				return;
			}
			
			vm.isUpdatingAppointment = true;

			const resourcePath = { 
				companyID: companyID,
				workorderappointmentID: appointment.id_work_order_appointment
			};

			const requestBody = {
				fk_id_appointment_status: appointment.fk_id_appointment_status
			};

			WorkOrderService.updateAppointment(resourcePath, requestBody)
				.then(function(){
					MessageService.showToast("Appointment is updated.");
				})
				.catch(MessageService.showToast)
				.finally(function(){
					vm.isUpdatingAppointment = false;
				});
		}

		function isAnyItemSelected(){
			if(!vm.selectedMap || !Array.isArray(vm.appointments)){
				return;
			}

			const selectedItem = vm.appointments.find(function(appointment){
				return !!appointment && vm.selectedMap[appointment.id_work_order_appointment];
			});

			return !!selectedItem;
		}

		function disableDeleteButton() {
			return !isAnyItemSelected() || vm.isUpdatingAppointment || vm.isDeletingAppointment;
		}

		function fetchCustomerPortalAppointment(){
			const defer = $q.defer();
			const resourcePath = {companyID: companyID};
			var startTime = moment().startOf('day')
			var endTime = moment().add(7, 'years')
			const filter = getFilter(startTime, endTime);
			const queue = {customerPortalAppointments: AppointmentsService.getAllMatchedCustomerPortalAppointments(resourcePath, filter)}
			vm.isLoadingEvents = true;

			$q.all(queue).then(function(result){
					if(!result){
						return $q.reject("Customer Portal Appointments data invalid");
					}
					//var customerPortalAppointmentList = buildCustomerPortalAppointmentEventList(result.customerPortalAppointments)
					vm.isLoadingEvents = false;
					defer.resolve(appointments); 
				})
				.catch(function(error){
					MessageService.showToast(error);
					defer.reject(error);
				});

			return defer.promise;
		}

		function fetchCustomerPortalAppointment(){
			const defer = $q.defer();
			const resourcePath = {companyID: companyID};
			var startTime = moment().startOf('day')
			var endTime = moment().add(7, 'years')
			const filter = getFilter(startTime, endTime);
			const queue = {customerPortalAppointments: AppointmentsService.getAllMatchedCustomerPortalAppointments(resourcePath, filter)}
			vm.isLoadingEvents = true;

			$q.all(queue).then(function(result){
					if(!result){
						return $q.reject("Customer Portal Appointments data invalid");
					}
					//var customerPortalAppointmentList = buildCustomerPortalAppointmentEventList(result.customerPortalAppointments)
					vm.customerPortalAppointments = result.customerPortalAppointments
					vm.isLoadingEvents = false;
					defer.resolve(appointments); 
				})
				.catch(function(error){
					MessageService.showToast(error);
					defer.reject(error);
				});

			return defer.promise;
		}

		function getFilter(startMoment, endMoment){
			var calendarFilter = getCalendarFilterString();
			var timeRangeFilter = getTimeRangeFilterString(startMoment, endMoment);

			if(!timeRangeFilter){
				return;
			}

			timeRangeFilter = GeneralTools.addBracketToString(timeRangeFilter);

			if(calendarFilter){
				calendarFilter = GeneralTools.addBracketToString(calendarFilter);
			}

			var filterString = GeneralTools.notEqualFilterBuilder(AppointmentConstants.keyNames.appointmentStatus, AppointmentConstants.statusIDs.CANCELLED);

			filterString = GeneralTools.stringConnector(filterString, calendarFilter, ToolsConstants.apiFilters.andConnector);
			filterString = GeneralTools.stringConnector(filterString, timeRangeFilter, ToolsConstants.apiFilters.andConnector);

			return { filters: filterString };
		}

		function getCalendarFilterString(){
			var filterString = ''


			filterString = GeneralTools.stringConnector(
				filterString,
				GeneralTools.equalFilterBuilder("fk_id_work_order", $stateParams.workOrderID),
				GeneralTools.notEqualFilterBuilder("fk_id_appointment_status", AppointmentConstants.customerPortalStatusID.Cancelled),
				ToolsConstants.apiFilters.andConnector
			)

			return filterString;
		}

		function getTimeRangeFilterString(startMoment, endMoment){
			if(!startMoment || !startMoment.isValid() || !endMoment || !endMoment.isValid() || startMoment.isSameOrAfter(endMoment)){
				return;
			}
			return GeneralTools.equalRangeFilterBuilder(startKeyName, startMoment.utc().format(timeRangeFilterFormat), endMoment.utc().format(timeRangeFilterFormat))
		}
	}
})();
(function () {
	'use strict';

	angular
		.module('app.workOrders')
		.controller('EditWorkOrderGeneralController', EditWorkOrderGeneralController);


	function EditWorkOrderGeneralController(Part, miscfeestypes, PresetPackagesService, $location, LabourService,CustomersService, WorkOrderPrint, AppointmentConstants, AppointmentsService, workOrderCustomerPortalAppointments, customerserviceMap, WorkOrderRDGenerated, customersaleInfos, LoginConst, ProgressService, WorkOrderPackage, WorkOrderWarranty, PresetPackageConstants, SaleInfoService, Labor, VehicleService, WorkOrder, WorkorderUnsavedChangesHelper, sharedConstants, WorkOrderDataSharingService, appointments, $mdDialog, $rootScope, WorkOrderDiscount, PartConstants, WorkOrderInventory, ToolsConstants, WorkOrderPart, PartTableItem, InventoryConstants, ReturnInvoiceService, PurchaseInvoiceService, constants, InventoryService, GeneralTools, $q, $stateParams, DialogService, RoleCheckService, vehicle, $state, $scope, WorkOrderConstants, mechanics, WorkOrderMechanic, LoginService, WorkOrderService, MessageService, miscfeestypesService, presetPackages, SalePackage, purchasedWorkOrderPackage) {
		const vm = this;
		const dot = "\u25cf";
		const controllerName = "EditWorkOrderGeneralController";
		const userInfo = LoginService.getUserInfo();
		const companyID = LoginService.getCompanyID();

		const partTableInvalidMessage = "Something wrong in part table.";
		const warrantyTableInvalidMessage = "Something wrong in warranty section.";
		const laborTableInvalidMessage = "Something wrong in labor table.";
		const miscfeeTableInvalidMessage = "Something wrong in misc fee table.";
		const splitNewItemTag = "(NEW)";
		const splitConfirmMessageTitle = "Split Work Order Confirmation";
		const splitConfirmMessage = "Items will be moved to a new workorder.";
		const splitPartsMessage = "Parts:";
		const splitLaborMessage = "Labors:";
		const splitMiscfeesMessage = "Misc fees:"
		const missingMileageWarning = "Complete this workorder without mileage?"
		const missingMechanicWarning = "Complete this workorder without a supervising licensed technician?"
		const unsavedChangeWarning = "This page has unsaved content."
		const completeWorkOrderWarning = "Save inventory items and complete?"
		const saveAndContinueStr = "save & continue";
		const ignoreAndContinueStr = "ignore & continue";
		const frontBrakePresetJobTitle = "Front Brake";
		const frontBrakePadPartName = "Front Brake Pads";
		const frontBrakeRotorPartName = "Front Brake Rotor";
		const frontBrakeLaborName = "Replace Front Brake";
		const rearBrakePresetJobTitle = "Rear Brake";
		const rearBrakePadPartName = "Rear Brake Pads";
		const rearBrakeRotorPartName = "Rear Brake Rotor";
		const rearBrakeLaborName = "Replace Rear Brake";
		const rustProofUnderBodyTitle = "Rust Proof Under Body"
		const rustProofUnderBodyPrice = 139;
		const rustProofCompleteTitle = "Rust Proof Complete"
		const rustProofCompletePrice = 199;
		const installFourTiresTitle = "Install 4 Tires"
		const installFourTiresPrice = 100;
		const generatingRogerDollarA = "After completing this work order, customer will receive $"
		const generatingRogerDollarB = " worth of Rogers Dollars that cannot be altered. \nIf you don't want Rogers Dollars to be generated, uncheck the checkbox before completing the work order."
		const vehicleID = $stateParams.vehicleID;

		const partsFromPresetJob = {};
		const laborsFromPresetJob = {};
		const isDeveloper = RoleCheckService.checkRole(["developer"]);
		const isServiceAdvisor = RoleCheckService.checkRole(["service_advisor"]);
		const isManager = RoleCheckService.checkRole(["company_manager"]);
		vm.packageItemsMap = {};
		vm.workOrderPackageItemsMap = {};
		vm.clientEmailAddressHolder = "";

		var isIgnoringUnsavedChanges = false;
		var showSensitiveContent;

		vm.generalAnchorTag = WorkOrderConstants.anchorTags.general;
		vm.partsAnchorTag = WorkOrderConstants.anchorTags.parts;
		vm.laborsAnchorTag = WorkOrderConstants.anchorTags.labors;
		vm.miscfeesAnchorTag = WorkOrderConstants.anchorTags.miscfees;
		vm.packagesAnchorTag = WorkOrderConstants.anchorTags.packages;
		vm.warrantyAnchorTag = WorkOrderConstants.anchorTags.warranty;
		vm.warrantyCollapseSectionID = "WARRANTY";
		vm.sectionOptions = {
			warranty: {
				name: "Warranty",
				id: vm.warrantyCollapseSectionID
			}
		};
		vm.addAppointmentUrl = $state.href("app.workorder-schedule", { workOrderID: $stateParams.workOrderID, vehicleID: $stateParams.vehicleID });
		vm.appointmentsTabUrl = $state.href("app.edit-workorder.appointments", { workOrderID: $stateParams.workOrderID, vehicleID: $stateParams.vehicleID });
		vm.percentageTransaletor = percentageTransaletor;
		vm.translateToDollar = GeneralTools.inputTranslators.dollar;
		vm.translateToPercentage = GeneralTools.inputTranslators.percentage;
		vm.percentageInputOption = {
			decimalFractionSize: 0,
			maxValue: 100
		};
		vm.showWarrantyfromWorkOrderTable = true;
		vm.showWarrantyfromSaleInfoTable = true
		vm.showPresetJobTable = false;
		if(isDeveloper || isServiceAdvisor || isManager){
			vm.showPrintedNotesSection = true;
		}else{
			vm.showPrintedNotesSection = true;
		}
		vm.showAiNotesSection = false;
		vm.aiNotesExpanded = false;
		vm.showPackagefromWorkOrderTable = true;
		vm.showPackagefromSaleInfoTable = true;
		vm.showRegistrationEmailSection = true;
		vm.showWorkOrderPDFEmailSection = true;
		vm.containRedeemableJobItem = false;
		vm.colorCache = {};


		// Workorder
		vm.onStatusClick = onStatusClick;
		vm.splitWorkorder = splitWorkorder;
		vm.onPresetJobAdd = onPresetJobAdd;
		vm.onPresetJobTypeAdd = onPresetJobTypeAdd;

		// Mechanic
		vm.isMechanic = RoleCheckService.checkRole(["mechanic", "mechanic_apprentice"]);
		vm.isAssignedToMechanic = isAssignedToMechanic;
		vm.isAssignedToMe = isAssignedToMe;
		vm.assignWorkOrderToMe = assignWorkOrderToMe;
		vm.addMechanic = addMechanic;
		vm.removeMechanic = removeMechanic;
		vm.addWorkOrderPackage = addWorkOrderPackage;
		vm.deleteWorkOrderPackage = deleteWorkOrderPackage;
		vm.onSendClientRegistrationEmail = onSendClientRegistrationEmail;
		vm.saleInfo;
		vm.initNewWorkOrderWarranty = initNewWorkOrderWarranty;
		vm.removeWorkOrderWarranty = removeWorkOrderWarranty;
		vm.getWorkOrderWarrantyRequestBodys = getWorkOrderWarrantyRequestBodys;
		vm.getLaborsRequestBodys = getLaborsRequestBodys;
		vm.optionRedeemWorkOrderPackageItem = optionRedeemWorkOrderPackageItem;
		const userID = LoginService.getUserID();
		vm.labourlist = [];
		vm.showRetailPriceError = false
		vm.showCostError = false
		vm.defaultRetailPercentadge = 0.6;




		LabourService.getLabour({
			companyID: companyID,
			userID: userID
		}).then(function (result) {
			for (var i = 0; i < result.length; i++) {

				vm.labourlist.push(result[i])
			}
		});

		vm.allmiscfeestypeslist = [];
		miscfeestypesService.getMiscFeesTypes({
			companyID: companyID,
			userID: userID,
			vehicleID: 0,
			workorderID: 0
		}).then(function (result) {
			for (var i = 0; i < result.length; i++) {
				vm.allmiscfeestypeslist.push(result[i])
			}
		});



		// Part table
		const partTableTabAll = {
			name: "all",
			title: "All",
			rowClass: getRowClass
		};
		const partTableTabNotOrdered = {
			name: "notOrdered",
			title: "NOT ORDERED",
			filter: isPartNotOrdered,
			tabClass: getNotOrderTabClass,
			rowClass: getRowClass
		};
		const partTableTabOrdered = {
			name: "ordered",
			title: "ORDERED",
			tabClass: getOrderedTabClass,
			rowClass: getRowClass,
			filter: isPartOrdered
		};
		const partTableTabReturned = {
			name: "returned",
			title: "RETURNED",
			filter: isPartReturned,
			rowClass: getRowClass
		};

		var convertedParts = {};
		vm.partTableTabs = [
			partTableTabAll,
			partTableTabNotOrdered,
			partTableTabOrdered,
			partTableTabReturned
		];

		vm.customerRegistrationTempHolder;
		vm.matchedInventories = {};
		vm.partList = [];
		vm.invoiceMap = {};
		vm.returnInvoiceMap = {};
		vm.addPart = addPart;
		vm.refreshDemandMap = refreshDemandMap;
		vm.onConvertPartToInventory = onConvertPartToInventory;
		vm.onPartTableTabChange = onPartTableTabChange;
		vm.isAnyPartSelectedInCurrentTab = isAnyPartSelectedInCurrentTab;
		vm.removeSelectedParts = removeSelectedParts;
		vm.saveWorkOrderWarrantyButtonClick = saveWorkOrderWarrantyButtonClick;
		vm.updateUpcomingCustomerPortalAppontmentStatus = updateUpcomingCustomerPortalAppontmentStatus;
		vm.getRecentJobInfo = getRecentJobInfo;
		
		// Labors
		vm.isAnyLaborSelected = isAnyLaborSelected;
		vm.removeSelectedLabors = removeSelectedLabors;

		// Discounts
		vm.addDiscountOnParts = addDiscountOnParts;
		vm.addDiscountOnLabors = addDiscountOnLabors;

		//Miscfees
		vm.isAnyMiscfeesSelected = isAnyMiscfeesSelected
		vm.removeSelectedMiscfees = removeSelectedMiscfees;

		// Appointments
		vm.updateUpcomingAppontmentStatus = updateUpcomingAppontmentStatus;

		vm.completedStatusID = WorkOrderConstants.statusIDs.completed;
		vm.onSaveClick = onSaveClick;
		vm.redeemSalePackageItem = redeemSalePackageItem;
		vm.redeemWorkOrderPackageItem = redeemWorkOrderPackageItem;

		init();
		function init() {
			initConstants();
			initVehicle();
			vm.workOrder = WorkOrderDataSharingService.getWorkOrder();
			initUpcomingAppointment();
			initMechanics();
			initParts();
			initInventories();
			initLabors();
			initDiscounts();
			initMiscFees();
			initJobTypes();
			initWorkOrderPackages();
			initObservers();
			initListeners();
			initPresetJobs();
			initWorkOrderWarranty();
			initWarrantyOptions();
			initSensitiveContentControl();
			subscribeToUnsavedChangesHelper();
			initCustomerInfo();
			initWorkOrderRDGenerated();
			initWorkOrderJobList();
			initWorkOrderJobItemColorCache();
			checkIfWorkOrderJobValidForPackageRedeem()
		}

		//customerserviceMap, customersaleInfos
		function initCustomerInfo(){
			vm.customerList = {};
			if(!Array.isArray(customersaleInfos)){
				return;
			}
			customersaleInfos.forEach(function(saleInfo){
				if(!saleInfo || saleInfo.is_canceled){
					return;
				}

				if(!vm.customerList[saleInfo.fk_id_customer]){
					vm.customerList[saleInfo.fk_id_customer] = {};
				}

				if(!Array.isArray(vm.customerList[saleInfo.fk_id_customer].customersaleInfos)){
					vm.customerList[saleInfo.fk_id_customer].customersaleInfos = [];
				}

				vm.customerList[saleInfo.fk_id_customer].customersaleInfos.push(saleInfo);
			})

			if(!Array.isArray(customerserviceMap)){
				return;
			}

			customerserviceMap.forEach(function(item){
				if(!item || !item.customer){
					return;
				}

				if(!vm.customerList[item.customer.id_customer]){
					vm.customerList[item.customer.id_customer] = {};
				}

				vm.customerList[item.customer.id_customer].customerInfo = {
					first_name: item.customer.first_name,
					last_name: item.customer.last_name,
					id_customer: item.customer.id_customer
				}

				vm.customerList[item.customer.id_customer].customerserviceMap = item.id_service_map;
			});

			const queue = [];
			Object.keys(vm.customerList).forEach(function(customerID){
				queue.push(fetchCustomerData(customerID));
			});

			vm.fetchingCustomersData = true;

			$q.all(queue)
				.then(function(result){
					if(!Array.isArray(result)){
						return $q.reject("Customers data invalid");
					}

					result.forEach(function(customer){
						if(!customer){
							return;
						}

						if(!vm.customerList[customer.id_customer]){
							vm.customerList[customer.id_customer] = {};
						}

						vm.customerList[customer.id_customer].customerInfo = customer;
					});

					return $q.resolve()
				})
				.catch(MessageService.showToast)
				.finally(function(){
					if (Object.values(vm.customerList).length >= 1) {
						const customerListValues = Object.values(vm.customerList);
						vm.customerRegistrationTempHolder = customerListValues[0];

						if(customerListValues[0] && customerListValues[0].customerInfo && customerListValues[0].customerInfo.emails && customerListValues[0].customerInfo.emails.length >= 1){
							vm.clientEmailAddressHolder = customerListValues[0].customerInfo.emails[0].email_address
						}
					}

					if(!vm.workOrder.rogerdollar_generated && vm.customerList && vm.workOrder){
						for (var customerId in vm.customerList) {
							var customer = vm.customerList[customerId];
							var customerInfo = customer.customerInfo;
							vm.workOrder.selectedCustomer = customer
						  }
					}else{
						delete vm.workOrder.selectedCustomer
					}
					$location.search({}).replace();
					vm.fetchingCustomersData = false;
				});
		}

		function fetchCustomerData(customerID){
			const resourcePath = {
				companyID: companyID,
				customerID: customerID
			};

			return CustomersService.getCustomers(resourcePath)
				.then(function(result){
					if(!result || !Array.isArray(result.data) || result.data.length != 1 || !result.data[0]){
						return $q.reject("customer data invalid");
					}

					return $q.resolve(result.data[0]);
				})
		}

		function initSensitiveContentControl() {
			const pageConfig = LoginService.getPageConfigs(LoginConst.pageConfigKeys.editWorkorder);

			if (pageConfig) {
				showSensitiveContent = pageConfig.showSensitiveContent;
			} else {
				showSensitiveContent = false;
			}
		}

		function getRecentJobInfo(jobItem){
			if (!jobItem) {
				return;
			}
			var result;
			var job_labour_temp_list = [];
			jobItem.job_labour.forEach(function(job_labour) {
				if(job_labour && job_labour.fk_id_labourtype){
					job_labour_temp_list.push(job_labour)
				}
			})
			var job_part_temp_list = [];
			jobItem.job_part.forEach(function(job_part) {
				if(job_part && job_part.fk_id_parttype){
					job_part_temp_list.push(job_part)
				}
			})
			var job_miscfee_temp_list = [];
			jobItem.job_miscfee.forEach(function(job_miscfee) {
				if(job_miscfee && job_miscfee.fk_id_miscfeestype){
					job_miscfee_temp_list.push(job_miscfee)
				}
			})

			if(job_labour_temp_list.length > 0){
				getRecentLabour(job_labour_temp_list)
			}

			if(job_part_temp_list.length > 0){
				result = getRecentPartPart(job_part_temp_list)
				result = getRecentPartPartFromInventory(job_part_temp_list)
			}

			if(job_miscfee_temp_list.length > 0){
				getRecentMiscfee(job_miscfee_temp_list)
			}
		}

		function getRecentPartPart(part_list){
			if (!vm.vehicle) {
				return;
			}
			var recentpartQueryParam;
			part_list.forEach(function(params) {
				recentpartQueryParam = {
					vehicleID: $stateParams.vehicleID,
					partType: params.fk_id_parttype
				}
				$q.all({
					recentPart: VehicleService.getMostRecentParts(companyID, recentpartQueryParam),
				}).then(function (result) {
						if (!result) {
							return $q.reject("Failed to init recent part, common part data invalid.");
						}
						result.recentPart.forEach(function(item){
							return item
						})
					});
			})
		}

		function getRecentPartPartFromInventory(part_list){
			if (!vm.vehicle) {
				return;
			}
			var recentpartQueryParam;
			part_list.forEach(function(params) {
				recentpartQueryParam = {
					vehicleID: $stateParams.vehicleID,
					partType: params.fk_id_parttype
				}
				$q.all({
					recentPart: VehicleService.getMostRecentPartsFromInventory(companyID, recentpartQueryParam),
				}).then(function (result) {
						if (!result) {
							return $q.reject("Failed to init recent part, common part data invalid.");
						}
						result.recentPart.forEach(function(item){
							return item
							
						})
					});
			})
		}

		function getRecentLabour(labour_list){
			if (!vm.vehicle) {
				return;
			}

			var recentlabourQueryParam;
			labour_list.forEach(function(params) {
				recentlabourQueryParam = {
					vehicleID: $stateParams.vehicleID,
					labourType: params.fk_id_labourtype
				}

				$q.all({
					recentLabour: VehicleService.getMostRecentLabour(companyID, recentlabourQueryParam),
				}).then(function (result) {
						if (!result) {
							return $q.reject("Failed to init recent labor, common misc fee data invalid.");
						}
						result.recentLabour.forEach(function(item){
						})
					});
			})
		}

		function getRecentMiscfee(miscfee_list){
			if (!vm.vehicle) {
				return;
			}

			var recentmiscfeeQueryParam;
			miscfee_list.forEach(function(params) {
				recentmiscfeeQueryParam = {
					vehicleID: $stateParams.vehicleID,
					miscfeeType: params.fk_id_miscfeestype
				}

				$q.all({
					recentMiscfee: VehicleService.getMostRecentMiscfee(companyID, recentmiscfeeQueryParam),
				}).then(function (result) {
						if (!result) {
							return $q.reject("Failed to init recent misc fee, common misc fee data invalid.");
						}
						result.recentMiscfee.forEach(function(item){
						})
					});
			})
		}

		function initPresetJobs() {
			if (!vm.vehicle) {
				return;
			}

			const oilPartQueryParam = {
				vehicleID: $stateParams.vehicleID,
				partType: PartConstants.partTypeIDs.OIL
			}

			const filterPartQueryParam = {
				vehicleID: $stateParams.vehicleID,
				partType: PartConstants.partTypeIDs.FILTER
			}

			$q.all({
				oils: VehicleService.getMostRecentParts(companyID, oilPartQueryParam),
				oilsFromInventory: VehicleService.getMostRecentPartsFromInventory(companyID, oilPartQueryParam),
				filters: VehicleService.getMostRecentParts(companyID, filterPartQueryParam),
				filtersFromInventory: VehicleService.getMostRecentPartsFromInventory(companyID, filterPartQueryParam),
			})
				.then(function (result) {
					if (!result) {
						return $q.reject("Failed to init preset jobs, common parts data invalid.");
					}



					vm.presetJobs = [
						buildOilChangePresetJob(
							result.oils,
							result.oilsFromInventory,
							result.filters,
							result.filtersFromInventory),
						buildBrakePresetJob(false),
						buildBrakePresetJob(true),
						buildOneLaborPresetJob(rustProofUnderBodyTitle, rustProofUnderBodyPrice),
						buildOneLaborPresetJob(rustProofCompleteTitle, rustProofCompletePrice),
						buildOneLaborPresetJob(installFourTiresTitle, installFourTiresPrice)
					];
				});
		}

		function initWorkOrderWarranty() {
			const workorderWarrantylist = WorkOrderDataSharingService.getWorkOrderWarrantyList()
			if (!Array.isArray(workorderWarrantylist)) {
				return;
			}

			vm.workorderWarranty = [];

			workorderWarrantylist.forEach(function (workorderwarranty) {
				vm.workorderWarranty.push(workorderwarranty);
			});
		}

		function initWarrantyOptions() {
			const workorderWarrantyoptions = WorkOrderDataSharingService.getWorkOrderWarrantyoptions()
			if (!Array.isArray(workorderWarrantyoptions)) {
				return;
			}
			vm.warrantyOptions = workorderWarrantyoptions;
		}

		function initNewWorkOrderWarranty() {
			vm.workorderWarranty.push(new WorkOrderWarranty());
		}

		function removeWorkOrderWarranty(warranty) {
			var dialogOptions = {};
			var index;
			dialogOptions.titleString = "Remove warranty";
			dialogOptions.contentString = "Are you sure to remove warranty from this work order?";

			var confirmOption = {};

			confirmOption.optionName = "YES";
			vm.workorderWarranty.forEach(function (warrantyitem) {
				if (warrantyitem.id_work_order_warranty == warranty.id_work_order_warranty) {
					index = vm.workorderWarranty.indexOf(warranty)
				}
			})

			confirmOption.onClick = function () {
				confirmRemoveWorkOrderWarrantyCallback(warranty, index);
				DialogService.close();
			}

			var cancelOption = {};

			cancelOption.optionName = "NO";
			cancelOption.onClick = function () {
				DialogService.close();
			}

			dialogOptions.options = [confirmOption, cancelOption];

			DialogService.showOptionsDialog(dialogOptions);
		}

		function confirmRemoveWorkOrderWarrantyCallback(warranty, index) {
			if (warranty == null) {
				return;
			}

			if (warranty.id_work_order_warranty == undefined && index != null) {
				vm.workorderWarranty.splice(index, 1);
				MessageService.showToast("Warranty is removed");
				return
			}

			var resourcePath = {
				companyID: companyID,
				vehicleID: vm.vehicle.getResourceID(),
				workorderID: $stateParams.workOrderID,
				warrantyID: warranty.id_work_order_warranty

			}

			vm.isProcessingData = true;
			ProgressService.setMode("indeterminate");
			ProgressService.isVisble(true);
			WorkOrderService.deleteWorkOrderWarranty(resourcePath).$promise
				.then(function (response) {
					vm.workorderWarranty.splice(index, 1);
					MessageService.showToast("Warranty is removed");
					return
					//return updateDefaultTasksForWarranty();
				})
				.catch(MessageService.showToast)
				.finally(function () {
					vm.isProcessingData = false;
					ProgressService.isVisble(false);
				})

			vm.isProcessingData = false;
			ProgressService.isVisble(false);
		}

		function buildOneLaborPresetJob(laborTitle, price, quantity) {
			if (!quantity) {
				quantity = 1;
			}

			const presetJob = {
				title: laborTitle,
				labors: []
			}

			const labor = new Labor();
			labor.name = laborTitle;
			labor.hour = quantity;
			labor.price = price;

			presetJob.labors.push({
				isSelected: true,
				laborData: labor
			});

			return presetJob;
		}

		function buildBrakePresetJob(isRear) {
			var title = frontBrakePresetJobTitle;
			var padsName = frontBrakePadPartName;
			var rotorsName = frontBrakeRotorPartName;
			var laborName = frontBrakeLaborName;

			if (isRear) {
				title = rearBrakePresetJobTitle;
				padsName = rearBrakePadPartName;
				rotorsName = rearBrakeRotorPartName;
				laborName = rearBrakeLaborName;
			}

			const presetJob = {
				title: title,
				partsMap: {},
				labors: []
			}

			presetJob.partsMap[PartConstants.partTypeIDs.BRAKES] = [];

			const padPart = new WorkOrderPart();

			padPart.name = padsName;
			padPart.quantity = 1;
			padPart.fk_id_part_type = PartConstants.partTypeIDs.BRAKES;

			presetJob.partsMap[PartConstants.partTypeIDs.BRAKES].push({
				isSelected: true,
				partData: padPart
			});

			const roterPart = new WorkOrderPart();

			roterPart.name = rotorsName;
			roterPart.quantity = 2;
			roterPart.fk_id_part_type = PartConstants.partTypeIDs.BRAKES;

			presetJob.partsMap[PartConstants.partTypeIDs.BRAKES].push({
				isSelected: true,
				partData: roterPart
			});

			const labor = new Labor();
			labor.name = laborName;
			labor.hour = 1.5;

			if (vm.suggestedLaborPrice) {
				labor.price = vm.suggestedLaborPrice.price;
			}

			presetJob.labors.push({
				isSelected: true,
				laborData: labor
			});

			return presetJob;
		}

		function getMostRecentParts(parts, partsFromInventory) {
			if (!Array.isArray(parts) || !Array.isArray(partsFromInventory)) {
				return;
			}

			var partsList = [];
			var inventoryList = [];

			var usedDate;
			var inventoryUsedDate;

			if (parts[0] && parts[0].usedDate) {
				usedDate = moment(parts[0].usedDate);
			}

			if (partsFromInventory[0] && partsFromInventory[0].usedDate) {
				inventoryUsedDate = moment(partsFromInventory[0].usedDate);
			}

			if (usedDate && inventoryUsedDate) {
				if (usedDate.isAfter(inventoryUsedDate)) {
					partsList = parts;
				} else if (usedDate.isBefore(inventoryUsedDate)) {
					inventoryList = partsFromInventory;
				} else {
					partsList = parts;
					inventoryList = partsFromInventory;
				}
			} else if (usedDate) {
				partsList = parts;
			} else if (inventoryUsedDate) {
				inventoryList = partsFromInventory;
			} else {
				partsList = parts;
				inventoryList = partsFromInventory;
			}

			partsList = partsList.map(function (item) {
				const part = new WorkOrderPart();

				part.setAttributes(item.part);
				part.quantity = 1;

				return { partData: part };
			});

			inventoryList = inventoryList.map(function (item) {
				const workOrderInventory = new WorkOrderInventory();

				workOrderInventory.pullDataFromInventory(item.inventory);
				workOrderInventory.quantity = item.mostFrequentQuantity;
				return { inventoryData: workOrderInventory };
			});

			return partsList.concat(inventoryList);
		}

		function buildOilChangePresetJob(oils, oilsFromInventory, filters, filtersFromInventory) {
			const partsMap = {};

			partsMap[PartConstants.partTypeIDs.OIL] = getMostRecentParts(oils, oilsFromInventory);
			partsMap[PartConstants.partTypeIDs.FILTER] = getMostRecentParts(filters, filtersFromInventory);

			for (var partTypeID in partsMap) {
				if (!Array.isArray(partsMap[partTypeID]) || partsMap[partTypeID].length <= 0) {
					partsMap[partTypeID] = [{ partData: buildDefaultOliChangePartItem(partTypeID) }]
				}

				if (partsMap[partTypeID][0]) {
					partsMap[partTypeID][0].isSelected = true;
				}
			}

			return {
				title: "Oil Change",
				partsMap: partsMap
			}
		}

		function buildDefaultOliChangePartItem(partTypeID) {
			const part = new WorkOrderPart();
			part.fk_id_part_type = partTypeID;

			switch (Number(partTypeID)) {
				case PartConstants.partTypeIDs.FILTER:
					part.name = "Filter";
					part.quantity = 1;
					break;
				case PartConstants.partTypeIDs.OIL:
					part.name = "Oil";
					break;
			}

			return part;
		}

		function subscribeToUnsavedChangesHelper() {
			WorkorderUnsavedChangesHelper.subscribe(controllerName, {
				check: function () {
					return $q.resolve(!!hasUnsavedChanges());
				},
				save: function () {
					const defer = $q.defer();

					if (hasUnsavedChanges()) {
						vm.isSaving = true;

						save().then(function () {
							defer.resolve()
						})
							.catch(defer.reject)
							.finally(function () {
								vm.isSaving = false;
							});
					} else {
						defer.resolve();
					}

					return defer.promise;
				}
			})
		}

		function initUpcomingAppointment() {
			vm.customerPortalAppointments
			if (Array.isArray(appointments)) {
				vm.totalAppointments = appointments.length;
				vm.upcomingAppointment = appointments[0];
				if (vm.upcomingAppointment) {
					vm.upcomingAppointmentUrl = $state.href("app.workorder-schedule", { goToDate: vm.upcomingAppointment.start });
				}
			}
		}

		function initDiscounts() {
			const discounts = WorkOrderDataSharingService.getDiscountList();

			if (Array.isArray(discounts)) {
				vm.discounts = discounts;
			} else {
				vm.discounts = [];
			}
		}

		function initLabors() {
			const labors = WorkOrderDataSharingService.getLaborList();
			if (!Array.isArray(labors)) {
				return;
			}

			vm.laborList = [];

			labors.forEach(function (labor) {
				vm.laborList.push({
					laborData: labor
				});
			});
		}

		function initMiscFees() {
			const MiscFees = WorkOrderDataSharingService.getMiscFeesList();


			if (!Array.isArray(MiscFees)) {
				return;
			}

			vm.MiscFeesList = [];

			MiscFees.forEach(function (MiscFees) {
				vm.MiscFeesList.push({
					MiscFees: MiscFees
				});
			});

		}

		function initJobTypes() {
			const JobType = WorkOrderDataSharingService.getJobTypeList();


			if (!Array.isArray(JobType)) {
				return;
			}

			vm.JobTypeList = [];

			JobType.forEach(function (Job) {
				vm.JobTypeList.push({
					JobType: Job
				});

			});
		}

		function initWorkOrderRDGenerated() {
			const workOrderRDGenerated = WorkOrderDataSharingService.getRDGeneratedList();
			if (!Array.isArray(workOrderRDGenerated)) {
				return;
			}

			vm.workOrderRDGeneratedList = angular.copy(workOrderRDGenerated);
		}

		function initWorkOrderJobList() {
			const WorkOrderJobList = WorkOrderDataSharingService.getworkOrderJobList();
			if (!Array.isArray(WorkOrderJobList)) {
				return;
			}

			vm.workOrderJobList = angular.copy(WorkOrderJobList);
		}

		function initInventories() {
			const inventories = WorkOrderDataSharingService.getInventoryList();

			if (!Array.isArray(inventories)) {
				return;
			}

			inventories.forEach(function (inventory) {
				const item = new PartTableItem();
				item.setInventoryData(inventory)
				vm.partList.push(item);
			});

			refreshDemandMap();
		}

		function initParts() {
			const parts = WorkOrderDataSharingService.getPartList();

			if (!Array.isArray(parts)) {
				return;
			}

			const invoiceIdList = [];
			const returnInvoiceIdList = [];

			parts.forEach(function (part) {
				if (!part) {
					return;
				}

				const invoiceID = part.fk_id_purchase_invoice;
				const returnInvoiceID = part.fk_id_return_invoice;

				const item = new PartTableItem();
				item.setPartData(part)
				vm.partList.push(item);

				if (!!invoiceID && invoiceIdList.indexOf(invoiceID) == -1) {
					invoiceIdList.push(invoiceID);
				}

				if (!!returnInvoiceID && returnInvoiceIdList.indexOf(returnInvoiceID) == -1) {
					returnInvoiceIdList.push(returnInvoiceID);
				}
			});

			initInvoices(invoiceIdList);
			//initReturnInvoices(returnInvoiceIdList);
			initMatchedInventories();
		}

		function initMatchedInventories() {
			if (!Array.isArray(vm.partList)) {
				return;
			}

			const queue = [];

			vm.partList.forEach(function (item) {
				if (item && item.partData) {
					queue.push(queryInventory(item.partData.code));
				}
			});
		}

		function queryInventory(code) {
			const resourcePath = { companyID: companyID };
			const filter = {
				filters: GeneralTools.equalFilterBuilder(InventoryConstants.keyNames.code, code)
			};

			return InventoryService.getInventories(resourcePath, filter)
				.then(function (result) {
					if (!result || !Array.isArray(result.data) || result.data.length > 1) {
						return $q.reject("Inventory data invalid");
					}

					const inventory = result.data[0];

					if (inventory) {
						vm.matchedInventories[inventory.code] = inventory;
					}
					return $q.resolve();
				});
		}

		function initInvoices(invoiceIdList) {
			if (!Array.isArray(invoiceIdList)) {
				return;
			}

			invoiceIdList.forEach(function (invoiceID) {
				if (!!invoiceID) {
					initInvoice(invoiceID);
				}
			});
		}

		function initInvoice(invoiceID) {
			const resourcePath = {
				companyID: companyID,
				purchaseinvoiceID: invoiceID
			}

			PurchaseInvoiceService.getPurchaseInvoices(resourcePath)
				.then(function (result) {
					if (!result || !Array.isArray(result.data) || result.data.length != 1 || !result.data[0]) {
						return $q.reject("invoice with id: " + invoiceID + " is invaild");
					}

					vm.invoiceMap[invoiceID] = result.data[0];
				});
		}

		function initReturnInvoices(invoiceIdList) {
			if (!Array.isArray(invoiceIdList)) {
				return;
			}

			invoiceIdList.forEach(function (invoiceID) {
				if (!!invoiceID) {
					initReturnInvoice(invoiceID);
				}
			});
		}

		function initReturnInvoice(invoiceID) {
			const resourcePath = {
				companyID: companyID,
				returninvoiceID: invoiceID
			}

			ReturnInvoiceService.getReturnInvoices(resourcePath)
				.then(function (result) {
					if (!result || !Array.isArray(result.data) || result.data.length != 1 || !result.data[0]) {
						return $q.reject("invoice with id: " + invoiceID + " is invaild");
					}

					vm.returnInvoiceMap[invoiceID] = result.data[0];
				});
		}

		function initConstants() {
			if (!constants) {
				MessageService.showToast("constants invalid");
				return;
			}

			vm.partTypes = constants.partTypes;
			vm.suggestedLaborPrice = constants.suggestedLaborPrice;
			vm.suppliers = constants.suppliers;
			vm.paymentMethods = constants.paymentMethods;
			vm.appointmentStatus = constants.appointmentStatus;
			vm.customerPortalAppointmentStatus = constants.appointmentStatus;
			if (sharedConstants) {
				vm.workOrderPriorities = sharedConstants.workOrderPriorities;
				vm.workOrderStatus = sharedConstants.workOrderStatus;
			}
		}

		function initVehicle() {
			if (vehicle && Array.isArray(vehicle.data) && vehicle.data.length === 1 && !!vehicle.data[0]) {
				vm.vehicle = vehicle.data[0]
			}

			initPresetPackages();
			if (vm.vehicle.is_sold) {
				initSalePackageItems()
				
			}
			initCompletedWorkOrderPackageItems()
			initCompletedWorkOrderWarranty()
		}

		function initSaleWarranty() {

			if (!vm.saleInfo) {
				return;
			}

			const resourcePath = {
				companyID: companyID,
				vehicleID: vehicleID,
				saleinfoID: vm.saleInfo[0].id_sale_info
			}
			SaleInfoService.getSaleWarranties(resourcePath).then(function (warranties) {
				if (!Array.isArray(warranties) || !warranties[0]) {

					return;
				}

				vm.warranty = warranties[0];
				
				var saleMileage = 0;
				var warrantyMileage = 0;

				if (typeof (vm.saleInfo[0].mileage) == "number") {
					saleMileage = vm.saleInfo[0].mileage;
				}

				if (typeof (vm.warranty.duration_mileage) == "number") {
					warrantyMileage = vm.warranty.duration_mileage;
				}

				vm.totalWarrantyCoveredMileage = saleMileage + warrantyMileage;
				const saleDate = moment(vm.saleInfo[0].sale_date);

				if (saleDate && saleDate.isValid() && typeof (vm.warranty.duration_month) == "number") {
					const month = saleDate.month();

					vm.warrantyExpiryDate = saleDate.month(month + vm.warranty.duration_month).format("YYYY-MM-DD");
				}
			});
		}

		function initSalePackageItems() {

			if (!Array.isArray(customersaleInfos) || !customersaleInfos[0]) {
				vm.saleInfo = [];
			}
			vm.saleInfo = customersaleInfos;

			initSaleWarranty()
			if (!Array.isArray(SalePackage) || !SalePackage[0]) {
				vm.availableItems = [];
			}
			vm.availableItems = SalePackage;
		}

		function initCompletedWorkOrderPackageItems() {
			if (!Array.isArray(purchasedWorkOrderPackage) || !purchasedWorkOrderPackage[0]) {
				vm.availableWorkOrderItems = [];
			}
			vm.availableWorkOrderItems = purchasedWorkOrderPackage;
		}

		function initCompletedWorkOrderWarranty() {

			const resourcePath = {
				companyID: companyID,
				vehicleID: $stateParams.vehicleID,
				workorderID: $stateParams.workOrderID,
			};

			const body = {
				iscompleted: true
			}

			WorkOrderService.getWorkOrderWarranties(resourcePath, body).$promise
				.then(function (result) {
					if (!result) {
						return $q.reject("Failed to fetch work order available warranty, warranty are invalid");
					}
					vm.completedWorkOrderWarranty = result
				})
				.catch(MessageService.showToast);
		}

		function initObservers() {
			$rootScope.$on(WorkOrderConstants.editWorkOrderEvents.scroll.eventName, function (event, tag) {
				GeneralTools.scrollToTag(tag);
			});

			$rootScope.$on(WorkOrderConstants.editWorkOrderEvents.controlSensitiveContent.eventName, function (event, _showSensitiveContent) {
				showSensitiveContent = _showSensitiveContent;
				onPartTableTabChange(vm.partTableTabs[vm.currentPartTableTabIndex]);
			});

			$scope.$on("$stateChangeStart", function (event, toState, toParams, fromState, fromParams) {
				if (!hasUnsavedChanges() || isIgnoringUnsavedChanges) {
					WorkorderUnsavedChangesHelper.unsubscribe(controllerName);
					return;
				}

				event.preventDefault();
				$rootScope.$root.loadingProgress = false;
				DialogService.showYesOrNoDialog(null, unsavedChangeWarning, saveAndContinueStr, ignoreAndContinueStr)
					.then(function (isToSaveChanges) {
						if (isToSaveChanges) {
							vm.isSaving = true;
							return save();
						}

						isIgnoringUnsavedChanges = true;
						return $q.resolve();
					})
					.then(function () {
						WorkorderUnsavedChangesHelper.unsubscribe(controllerName);
						$state.go(toState.name, toParams);
					})
					.catch(function (error) {
						if (error) {
							MessageService.showToast(error);
						}
					})
					.finally(function () {
						vm.isSaving = false;
					});
			});
		}

		function initListeners() {
			$scope.$watch("vm.workOrder", function () {
				vm.workOrder.notes = vm.workOrder.notes ? vm.workOrder.notes : null;
				vm.workOrder.mechanic_notes = vm.workOrder.mechanic_notes ? vm.workOrder.mechanic_notes : null;
				vm.workOrder.printed_notes = vm.workOrder.printed_notes ? vm.workOrder.printed_notes : null;
				vm.workOrder.ai_notes = vm.workOrder.ai_notes ? vm.workOrder.ai_notes : null;
				$scope.$emit(
					WorkOrderConstants.editWorkOrderEvents.updateSummary.eventName,
					WorkOrderConstants.editWorkOrderEvents.updateSummary.updateDetails.workOrder,
					vm.workOrder);
			}, true);

			$scope.$watch("vm.partList", function () {
				$scope.$emit(
					WorkOrderConstants.editWorkOrderEvents.updateSummary.eventName,
					WorkOrderConstants.editWorkOrderEvents.updateSummary.updateDetails.parts,
					extractPartsFromPartList());
				$scope.$emit(
					WorkOrderConstants.editWorkOrderEvents.updateSummary.eventName,
					WorkOrderConstants.editWorkOrderEvents.updateSummary.updateDetails.inventories,
					extractInventoryListFromPartList());
				vm.checkPartRetailPricevalid(vm.partList);
				vm.checkPartCostevalid(vm.partList)
			}, true);

			$scope.$watch("vm.laborList", function () {
				$scope.$emit(
					WorkOrderConstants.editWorkOrderEvents.updateSummary.eventName,
					WorkOrderConstants.editWorkOrderEvents.updateSummary.updateDetails.labors,
					extractLaborsFromLaborList());
			}, true);
			$scope.$watch("vm.MiscFeesList", function () {
				$scope.$emit(
					WorkOrderConstants.editWorkOrderEvents.updateSummary.eventName,
					WorkOrderConstants.editWorkOrderEvents.updateSummary.updateDetails.miscfees,
					extractMiscfeesFromMiscfeesList());
			}, true);
			$scope.$watch("vm.workorderPackages", function () {
				$scope.$emit(
					WorkOrderConstants.editWorkOrderEvents.updateSummary.eventName,
					WorkOrderConstants.editWorkOrderEvents.updateSummary.updateDetails.workorderpackagelist,
					extractWorkOrderPackageFromWorkOrderpackageList());
			}, true);

			$scope.$watch("vm.workorderWarranty", function () {
				$scope.$emit(
					WorkOrderConstants.editWorkOrderEvents.updateSummary.eventName,
					WorkOrderConstants.editWorkOrderEvents.updateSummary.updateDetails.workorderwarrantylist,
					extractWorkOrderWarrantyFromWorkOrderwarrantyList());
			}, true);

			$scope.$watch("vm.discounts.length", function () {
				$scope.$emit(
					WorkOrderConstants.editWorkOrderEvents.updateSummary.eventName,
					WorkOrderConstants.editWorkOrderEvents.updateSummary.updateDetails.discounts,
					vm.discounts);
			});

			
			$scope.$watch("vm.workOrderRDGeneratedList", function () {
				$scope.$emit(
					WorkOrderConstants.editWorkOrderEvents.updateSummary.eventName,
					WorkOrderConstants.editWorkOrderEvents.updateSummary.updateDetails.workOrderRogerDollarGenerated,
					vm.workOrderRDGeneratedList);
			});

			$scope.$watch("vm.demandMap", function () {
				$scope.$emit(
					WorkOrderConstants.editWorkOrderEvents.updateSummary.eventName,
					WorkOrderConstants.editWorkOrderEvents.updateSummary.updateDetails.demandMap,
					vm.demandMap);
			}, true);
		}

		function initMechanics() {
			if (Array.isArray(mechanics)) {
				vm.mechanics = mechanics;
			} else {
				vm.mechanics = [];
			}
		}

		function isAssignedToMechanic() {
			var hasMechanic = false;

			if (!Array.isArray(vm.mechanics)) {
				return;
			}

			vm.mechanics.forEach(function (mechanic) {
				if (Array.isArray(mechanic.roles) && mechanic.roles.indexOf("mechanic") != -1) {
					hasMechanic = true;
				}
			});

			return hasMechanic;
		}

		function isAssignedToMe() {
			if (!Array.isArray(vm.mechanics)) {
				return;
			}

			return vm.mechanics.findIndex(function (mechanic) {
				return mechanic.id_user == userInfo.userID;
			}) != -1;
		}

		function assignWorkOrderToMe() {
			const workOrderMechanic = new WorkOrderMechanic();

			workOrderMechanic.setUser({
				id_user: userInfo.userID,
				first_name: userInfo.firstName,
				last_name: userInfo.lastName,
				roles: userInfo.roles
			});

			addMechanic(workOrderMechanic);
		}

		function addMechanic(workOrderMechanic) {
			const resourcePath = {
				companyID: companyID,
				vehicleID: $stateParams.vehicleID,
				workorderID: $stateParams.workOrderID
			};

			vm.isAddingMechanic = true;

			WorkOrderService.addMechanic(resourcePath, workOrderMechanic)
				.then(function (newMechanicID) {
					workOrderMechanic.id_work_order_mechanic = newMechanicID;

					vm.mechanics.push(workOrderMechanic);

					MessageService.showToast("Mechanic is added.");
				})
				.catch(MessageService.showToast)
				.finally(function () {
					vm.isAddingMechanic = false;
				});
		}

		function removeMechanic(mechanic, index) {
			if (!mechanic) {
				MessageService.showToast("mechanic is invalid");
				return;
			}

			var dialogOptions = {};

			dialogOptions.titleString = "Remove Mechanic";
			dialogOptions.contentString = "Are you sure to remove " + mechanic.first_name + ' ' + mechanic.last_name + '?';

			var confirmOption = {};

			confirmOption.optionName = "YES";
			confirmOption.onClick = function () {
				confirmRemoveMechanic(mechanic, index);
				DialogService.close();
			}

			var cancelOption = {};

			cancelOption.optionName = "NO";
			cancelOption.onClick = function () {
				DialogService.close();
			}

			dialogOptions.options = [confirmOption, cancelOption];

			DialogService.showOptionsDialog(dialogOptions);
		}

		function confirmRemoveMechanic(mechanic, index) {
			if (!mechanic) {
				return;
			}

			const resourcePath = {
				companyID: companyID,
				vehicleID: $stateParams.vehicleID,
				workorderID: $stateParams.workOrderID,
				mechanicID: mechanic.id_work_order_mechanic
			};

			vm.isRemovingMechanic = true;

			WorkOrderService.removeMechanic(resourcePath)
				.then(function () {
					vm.mechanics.splice(index, 1);
					MessageService.showToast("Mechanic is removed.");
				})
				.catch(MessageService.showToast)
				.finally(function () {
					vm.isRemovingMechanic = false;
				});
		}

		function resetOriginPartList() {
			const partList = [];

			if (!Array.isArray(vm.partList)) {
				return;
			}

			vm.partList.forEach(function (item) {
				if (item && item.partData) {
					partList.push(item.partData);
				}
			});

			WorkOrderDataSharingService.setPartList(partList);
		}

		function onSaveClick() {
			vm.isSaving = true;
			console.log("onSaveClick")
			save().then(function () {
				MessageService.showToast("Success.")
			})
				.catch(MessageService.showToast)
				.finally(function () {
					vm.isSaving = false;
				});

		}

		function save() {
			if (!vm.isInfoFormValid()) {
				return $q.reject("Something wrong in info form.");
			}

			if (vm.isWarrntySectionValid && !vm.isWarrntySectionValid()) {
				return $q.reject(warrantyTableInvalidMessage);
			}

			if (vm.isPartTableValid && !vm.isPartTableValid()) {
				return $q.reject(partTableInvalidMessage);
			}

			if (vm.isLaborTableValid && !vm.isLaborTableValid()) {
				return $q.reject(laborTableInvalidMessage);
			}

			if (vm.isMiscfeeTableValid && !vm.isMiscfeeTableValid()) {
				return $q.reject(miscfeeTableInvalidMessage);
			}

			const queue = [];
			if(vm.workOrder.selectedCustomer){
				delete vm.workOrder.selectedCustomer
			}
			const workOrderRequestBody = GeneralTools.updateResourceRequestBodyGenerator(vm.workOrder, WorkOrderDataSharingService.getWorkOrder());
			const partsRequestBody = getPartsRequestBodys();
			const inventoriesRequestBody = getInventoriesRequestBodys();
			const laborsRequestBody = getLaborsRequestBodys();
			const MiscFeesRequestBody = getMiscfeeRequestBodys();
			const workOrderWarrantyRequestBody = getWorkOrderWarrantyRequestBodys();

			if (workOrderRequestBody && workOrderRequestBody != undefined) {
				queue.push(updateWorkOrder(workOrderRequestBody));
			}

			if (partsRequestBody && partsRequestBody != undefined) {
				queue.push(saveParts(partsRequestBody));
			}

			if (inventoriesRequestBody && inventoriesRequestBody != undefined) {
				queue.push(saveInventories(inventoriesRequestBody));
			}

			if (laborsRequestBody && laborsRequestBody != undefined) {
				queue.push(saveLabors(laborsRequestBody));
			}

			if (MiscFeesRequestBody && MiscFeesRequestBody != undefined) {
				queue.push(saveMiscfees(MiscFeesRequestBody));
			}

			if (workOrderWarrantyRequestBody && workOrderWarrantyRequestBody != undefined) {
				queue.push(saveWorkOrderWarranty(workOrderWarrantyRequestBody));
			}

			if (queue.length <= 0) {
				return $q.reject("No changes detected.");
			}
			return $q.all(queue);
		}

		function savePartLabourAndMiscFeeOnJobAdd(id_job){

			if (vm.isPartTableValid && !vm.isPartTableValid()) {
				return $q.reject(partTableInvalidMessage);
			}

			if (vm.isLaborTableValid && !vm.isLaborTableValid()) {
				return $q.reject(laborTableInvalidMessage);
			}

			if (vm.isMiscfeeTableValid && !vm.isMiscfeeTableValid()) {
				return $q.reject(miscfeeTableInvalidMessage);
			}
			const queue = [];
			const partsRequestBody = getPartsRequestBodys();
			const inventoriesRequestBody = getInventoriesRequestBodys();
			const laborsRequestBody = getLaborsRequestBodys();
			const MiscFeesRequestBody = getMiscfeeRequestBodys();

			var workOrderJobQueryParam = {
			companyID: LoginService.getCompanyID(),
			vehicleID: $stateParams.vehicleID,
			workorderID: $stateParams.workOrderID
			}

			var workOrderJobRequestBody = {
				fk_id_work_order: $stateParams.workOrderID,
				fk_id_job_type: id_job
			}
			
			const defer = $q.defer()
			if((partsRequestBody && partsRequestBody != undefined) || (inventoriesRequestBody && inventoriesRequestBody != undefined) || (laborsRequestBody && laborsRequestBody != undefined) || (MiscFeesRequestBody && MiscFeesRequestBody != undefined)){
				WorkOrderService.createWorkOrderJob(workOrderJobQueryParam, workOrderJobRequestBody).then(function(result){
					if(!result){
						return
					}
					const workOrderJobId = result
					if (MiscFeesRequestBody && MiscFeesRequestBody != undefined) {
						MiscFeesRequestBody.miscfeesToUpdate = [];
						if(MiscFeesRequestBody.miscfeesToCreate && MiscFeesRequestBody.miscfeesToCreate!= undefined){
							MiscFeesRequestBody.miscfeesToCreate.forEach(function(item){
								if(item.requestBody.addingFromJob){
									item.requestBody.workOrderJobID = workOrderJobId
								}
							})
						}
						queue.push(saveMiscfees(MiscFeesRequestBody));
					}
					if (laborsRequestBody && laborsRequestBody != undefined) {
						laborsRequestBody.laborsToUpdate = [];
						if(laborsRequestBody.laborsToCreate && laborsRequestBody.laborsToCreate!= undefined){
							laborsRequestBody.laborsToCreate.forEach(function(item){
								if(item.requestBody.addingFromJob){
									item.requestBody.workOrderJobID = workOrderJobId
								}
							})
						}
						queue.push(saveLabors(laborsRequestBody));
					}
					if (partsRequestBody && partsRequestBody != undefined) {
						partsRequestBody.partsToDetele = [];
						partsRequestBody.partsToUpdate = [];
						if(partsRequestBody.partsToCreate && partsRequestBody.partsToCreate!= undefined){
							partsRequestBody.partsToCreate.forEach(function(item){
								if(item.requestBody.addingFromJob){
									item.requestBody.workOrderJobID = workOrderJobId
								}
							})
						}
						queue.push(saveParts(partsRequestBody));
					}
					if (inventoriesRequestBody && inventoriesRequestBody != undefined) {
						inventoriesRequestBody.inventoriesToUpdate = [];
						if(inventoriesRequestBody.inventoriesToCreate && inventoriesRequestBody.inventoriesToCreate!= undefined){
							inventoriesRequestBody.inventoriesToCreate.forEach(function(item){
								if(item.requestBody.addingFromJob){
									item.requestBody.workOrderJobID = workOrderJobId
								}
							})
						}
						queue.push(saveInventories(inventoriesRequestBody));
					}
					if (queue.length <= 0) {
						return $q.reject("No changes detected.");
					}
					return $q.all(queue).then(function(){
						const resourcePath = { 
							companyID: LoginService.getCompanyID(),
							vehicleID: $stateParams.vehicleID,
							workorderID: $stateParams.workOrderID
						};
						return WorkOrderService.getWorkOrderJob(resourcePath).$promise.catch(MessageService.showToast)
					})
					.then(function(result){
						if(result && result != undefined){
							WorkOrderDataSharingService.setworkOrderJobList(result);
							initWorkOrderJobList()
							checkIfWorkOrderJobValidForPackageRedeem()
						}
					});


					
				}).catch(function (error) {
					defer.reject(error);
					MessageService.showToast(error);
				});

			}
		}


		function getInventoriesRequestBodys() {
			const inventoriesToCreate = [];
			const inventoriesToUpdate = [];

			if (!Array.isArray(vm.partList)) {
				return;
			}

			vm.partList.forEach(function (item, index) {
				if (!item || !item.inventoryData) {
					return;
				}

				if (!item.inventoryData.id_work_order_inventory) {
					inventoriesToCreate.push({
						index: index,
						requestBody: item.inventoryData
					});
					return;
				}

				const changedProperties = getUpdateInventoryRequestBody(item.inventoryData);

				if (!!changedProperties) {
					inventoriesToUpdate.push({
						requestBody: changedProperties,
						inventoryID: item.inventoryData.id_work_order_inventory
					});
				}
			});

			if (inventoriesToCreate.length <= 0 && inventoriesToUpdate.length <= 0) {
				return;
			}

			return {
				inventoriesToCreate: inventoriesToCreate,
				inventoriesToUpdate: inventoriesToUpdate
			}
		}

		function getUpdateInventoryRequestBody(inventory) {
			const originInventoryList = WorkOrderDataSharingService.getInventoryList();

			if (!inventory || !inventory.id_work_order_inventory) {
				return;
			}

			if (!Array.isArray(originInventoryList)) {
				return;
			}

			const originInventory = originInventoryList.find(function (item) {
				if (!item) {
					return;
				}

				return item.id_work_order_inventory == inventory.id_work_order_inventory;
			});

			if (!originInventory) {
				return;
			}

			const changedProperties = GeneralTools.updateResourceRequestBodyGenerator(inventory, originInventory);

			if (!!changedProperties) {
				return changedProperties;
			}
		}

		function getPartsRequestBodys() {
			const originPartList = WorkOrderDataSharingService.getPartList();
			const partsToCreate = [];
			const partsToUpdate = [];
			const partsToDetele = [];

			if (!Array.isArray(vm.partList) || !Array.isArray(originPartList)) {
				return;
			}

			originPartList.forEach(function (part) {
				if (!part) {
					return;
				}

				const remainingPart = vm.partList.find(function (item) {
					return !!item && !!item.partData && item.partData.getResourceId() == part.getResourceId();
				});

				if (!remainingPart) {
					partsToDetele.push(part);
				}
			})

			vm.partList.forEach(function (item, index) {
				if (!item || !item.partData) {
					return;
				}

				if (!item.partData.id_work_order_part) {
					partsToCreate.push({
						index: index,
						requestBody: item.partData
					});
					return;
				}

				const changedProperties = getUpdatePartRequestBody(item.partData);

				if (!!changedProperties) {
					partsToUpdate.push({
						requestBody: changedProperties,
						partID: item.partData.id_work_order_part
					});
				}
			});

			if (partsToCreate.length <= 0 && partsToUpdate.length <= 0 && partsToDetele.length <= 0) {
				return;
			}

			return {
				partsToCreate: partsToCreate,
				partsToUpdate: partsToUpdate,
				partsToDetele: partsToDetele
			};
		}

		function getUpdatePartRequestBody(part) {
			const originPartList = WorkOrderDataSharingService.getPartList();

			if (!part || !part.id_work_order_part) {
				return;
			}

			if (!Array.isArray(originPartList)) {
				return;
			}

			const originPart = originPartList.find(function (item) {
				return !!item && item.id_work_order_part == part.id_work_order_part;
			});

			if (!originPart) {
				return;
			}

			const changedProperties = GeneralTools.updateResourceRequestBodyGenerator(part, originPart);

			if (!!changedProperties) {
				return changedProperties;
			}
		}

		function updateWorkOrder(requestBody) {
			const resourcePath = {
				companyID: companyID,
				vehicleID: $stateParams.vehicleID,
				workorderID: $stateParams.workOrderID
			}

			return WorkOrderService.updateWorkOrder(resourcePath, requestBody)
				.then(function () {
					WorkOrderDataSharingService.setWorkOrder(vm.workOrder);
					return $q.resolve();
				});
		}

		function addPart() {
			const part = getNewBasicPart();
			const item = new PartTableItem();

			item.setPartData(part)
			vm.partList.push(item);
		}

		function extractInventoryListFromPartList() {
			if (!Array.isArray(vm.partList)) {
				return;
			}
			const inventoryList = [];

			vm.partList.forEach(function (item) {
				if (!!item && item.inventoryData) {
					inventoryList.push(item.inventoryData)
				}
			});

			return inventoryList;
		}

		function extractPartsFromPartList() {
			if (!Array.isArray(vm.partList)) {
				return;
			}
			const parts = [];

			vm.partList.forEach(function (item) {
				if (!!item && item.partData) {
					parts.push(item.partData)
				}
			});

			return parts;
		}

		function extractLaborsFromLaborList() {
			if (!Array.isArray(vm.laborList)) {
				return;
			}
			const labors = [];

			vm.laborList.forEach(function (item) {
				if (!!item && item.laborData) {
					labors.push(item.laborData)
				}
			});

			return labors;
		}

		function extractMiscfeesFromMiscfeesList() {
			if (!Array.isArray(vm.MiscFeesList)) {
				return;
			}
			const miscfees = [];

			vm.MiscFeesList.forEach(function (item) {
				if (!!item && item.MiscFees && item.MiscFees.price && item.MiscFees.quantity && item.MiscFees.name && item.MiscFees.fk_misc_fees_type) {
					miscfees.push(item.MiscFees)
				}
			});

			return miscfees;
		}

		function extractWorkOrderPackageFromWorkOrderpackageList() {
			if (!Array.isArray(vm.workorderPackages)) {
				return;
			}
			const workorderpackages = [];
			vm.workorderPackages.forEach(function (item) {
				if (!!item && item.price && item.name && item.id_work_order_package && item.fk_id_preset_package) {
					workorderpackages.push(item)
				}
			});
			return workorderpackages;
		}

		function extractWorkOrderWarrantyFromWorkOrderwarrantyList() {
			if (!Array.isArray(vm.workorderWarranty)) {
				return;
			}
			const workorderwarranties = [];
			vm.workorderWarranty.forEach(function (item) {
				if (!!item && item.retail && item.name && item.id_work_order_warranty && item.duration_month && item.cost) {
					workorderwarranties.push(item)
				}
			});
			return workorderwarranties;
		}


		function resetOriginInventoryList() {
			const inventoryList = [];

			if (!Array.isArray(vm.partList)) {
				return;
			}

			vm.partList.forEach(function (item) {
				if (item && item.inventoryData) {
					inventoryList.push(item.inventoryData);
				}
			});

			WorkOrderDataSharingService.setInventoryList(inventoryList);
		}

		function refreshDemandMap() {
			const defer = $q.defer()
			if (!Array.isArray(vm.partList)) {
				return;
			}

			const queue = [];
			const demandMap = {};

			vm.partList.forEach(function (item) {
				if (!item || !item.inventoryData) {
					return;
				}

				if (!demandMap[item.inventoryData.fk_id_inventory]) {
					demandMap[item.inventoryData.fk_id_inventory] = {
						totalDemand: 0,
						name: item.inventoryData.name,
						code: item.inventoryData.code
					}
				}
				demandMap[item.inventoryData.fk_id_inventory].totalDemand += GeneralTools.parseNumber(item.inventoryData.quantity);
			});

			Object.keys(demandMap).forEach(function (inventoryID) {
				queue.push(fetchInventoryData(inventoryID));
			});

			$q.all(queue)
				.then(function (inventoryList) {
					inventoryList.forEach(function (inventory) {
						if (!inventory) {
							return;
						}

						if (demandMap[inventory.id_inventory]) {
							demandMap[inventory.id_inventory].totalInStock = GeneralTools.parseNumber(inventory.quantity);
						}
					});

					vm.demandMap = demandMap;
					defer.resolve(vm.demandMap);
				})
				.catch(function (error) {
					defer.reject(error);
					MessageService.showToast(error);
				});

			return defer.promise;
		}

		function fetchInventoryData(inventoryID) {
			const resourcePath = {
				companyID: companyID,
				inventoryID: inventoryID
			}

			return InventoryService.getInventories(resourcePath)
				.then(function (result) {
					if (!result || !Array.isArray(result.data) || result.data.length != 1 || !result.data[0]) {
						return $q.reject("Inventory data invalid.")
					}

					return $q.resolve(result.data[0]);
				})
		}

		function getNewBasicPart() {
			const part = new WorkOrderPart();

			part.setAttributes({
				fk_id_part_type: PartConstants.partTypeIDs.OTHER,
				purchase_tax_rate: ToolsConstants.taxRate
			});

			if (vm.partTableTabs[vm.currentPartTableTabIndex]) {
				switch (vm.partTableTabs[vm.currentPartTableTabIndex].name) {
					case partTableTabOrdered.name:
						part.is_ordered = true;
						break;
					case partTableTabReturned.name:
						part.is_returned = true;
						break;
				}
			}

			return part;
		}

		function onConvertPartToInventory(item, inventory) {
			if (!item || !inventory || vm.workOrder.isCompleted()) {
				return;
			}

			if (item.partData && item.partData.is_ordered) {
				item.name = inventory.name;
				item.code = inventory.code;
				item.retailPrice = inventory.retail_price;
				item.suggestedRetailPrice = inventory.retail_price;
				item.cost = inventory.purchase_price;
				item.updateProperties();
				return;
			}

			const itemQuantitiy = GeneralTools.parseNumber(item.quantity);

			const workOrderInventory = new WorkOrderInventory();
			workOrderInventory.pullDataFromInventory(inventory);
			workOrderInventory.quantity = item.quantity;
			item.setInventoryData(workOrderInventory);

			refreshDemandMap();
		}

		function isPartOrdered(item) {
			if (!item) {
				return;
			}

			if (!!item.inventoryData) {
				return true;
			}

			if (!!item.partData && item.partData.is_ordered && !item.partData.is_returned) {
				return true;
			}
		}

		function isPartNotOrdered(item) {
			return !!item && !!item.partData && !item.partData.is_ordered && !item.partData.is_returned;
		}

		function isPartReturned(item) {
			return !!item && !!item.partData && item.partData.is_returned;
		}

		function getNotOrderTabClass() {
			if (!Array.isArray(vm.partList)) {
				return;
			}

			var anyItemInCurrentTab = false;
			const matchedItem = vm.partList.find(function (item) {
				if (!item || !item.partData || !isPartNotOrdered(item)) {
					return;
				}

				anyItemInCurrentTab = true;
			});

			if (!anyItemInCurrentTab) {
				return;
			}

			return [PartConstants.styleClasses.notOrdered];
		}

		function getOrderedTabClass() {
			if (!Array.isArray(vm.partList)) {
				return;
			}

			var anyItemInCurrentTab = false;

			const warningItem = vm.partList.find(function (item) {
				if (!item) {
					return;
				}

				if (!!item.partData && isPartOrdered(item)) {
					anyItemInCurrentTab = true;

					if (!item.partData.fk_id_purchase_invoice) {
						return true;
					}
				}

				if (!!item.inventoryData) {
					anyItemInCurrentTab = true;
					if (vm.demandMap && vm.demandMap[item.inventoryData.fk_id_inventory] && vm.demandMap[item.inventoryData.fk_id_inventory].totalDemand > vm.demandMap[item.inventoryData.fk_id_inventory].totalInStock) {
						return true;
					}
				}
			});

			if (!anyItemInCurrentTab) {
				return;
			}

			if (warningItem) {
				if (warningItem.partData) {
					return [PartConstants.styleClasses.orderedUninvoiced];
				}

				return [PartConstants.styleClasses.inventoryNotEnough];
			}

			return [PartConstants.styleClasses.orderedInvoiced];
		}

		function getRowClass(item) {
			if (!item) {
				return;
			}

			if (item.inventoryData) {
				if (vm.demandMap && vm.demandMap[item.inventoryData.fk_id_inventory] && vm.demandMap[item.inventoryData.fk_id_inventory].totalDemand > vm.demandMap[item.inventoryData.fk_id_inventory].totalInStock) {
					return [PartConstants.styleClasses.inventoryNotEnough];
				}
				return [PartConstants.styleClasses.orderedInvoiced];
			}

			if (!item.partData) {
				return;
			}

			if (item.partData.is_returned) {
				return [PartConstants.styleClasses.returnedForTable];
			}

			if (!item.partData.is_ordered) {
				return [PartConstants.styleClasses.notOrdered];
			}

			if (item.partData.fk_id_purchase_invoice) {
				return [PartConstants.styleClasses.orderedInvoiced];
			} else {
				return [PartConstants.styleClasses.orderedUninvoiced];
			}
		}

		function onPartTableTabChange(tab) {
			if (!tab) {
				return;
			}

			switch (tab.name) {
				case partTableTabAll.name:
					vm.hiddenColumns = {
						cost: !showSensitiveContent,
						suggestedRetailPrice: true,
						invoice: true,
						returnInvoice: true
					}
					return;
				case partTableTabOrdered.name:
					vm.hiddenColumns = {
						cost: !showSensitiveContent,
						suggestedRetailPrice: true,
						returnInvoice: true
					}
					return;
				case partTableTabNotOrdered.name:
					vm.hiddenColumns = {
						cost: !showSensitiveContent,
						suggestedRetailPrice: true,
						invoice: true,
						returnInvoice: true
					}
					return;
				case partTableTabReturned.name:
					vm.hiddenColumns = {
						cost: !showSensitiveContent,
						suggestedRetailPrice: true,
						returnInvoice: true
					}
					return;
			}
		}

		function saveParts(requestBody) {
			if (!requestBody) {
				return;
			}

			const queue = [createParts(requestBody.partsToCreate), updateParts(requestBody.partsToUpdate), deleteParts(requestBody.partsToDetele)];

			return $q.all(queue)
				.then(function () {
					resetOriginPartList();
					return $q.resolve();
				});
		}

		function deleteParts(requestBodyList) {
			if (!Array.isArray(requestBodyList)) {
				return $q.reject("deleteParts requestBodyList invalid");
			}

			const queue = [];

			requestBodyList.forEach(function (item) {
				if (!item) {
					return;
				}

				queue.push(deletePart(item.id_work_order_part));
			});

			return $q.all(queue);
		}

		function deletePart(partID) {
			const resourcePath = {
				companyID: companyID,
				vehicleID: $stateParams.vehicleID,
				workorderID: $stateParams.workOrderID,
				partID: partID
			}

			return WorkOrderService.deleteWorkOrderPart(resourcePath)
				.then(function () {
					const index = vm.partList.findIndex(function (item) {
						return !!item && !!item.partData && item.partData.id_work_order_part == partID;
					});

					if (index != -1) {
						vm.partList.splice(index, 1);
					}
					return $q.resolve();
				});
		}

		function createParts(requestBodyList) {
			if (!Array.isArray(requestBodyList)) {
				return $q.reject("createParts requestBodyList invalid");
			}

			const queue = [];

			requestBodyList.forEach(function (item) {
				if (!item) {
					return;
				}

				queue.push(createPart(item.requestBody, item.index));
			});

			return $q.all(queue);
		}

		function createPart(requestBody, index) {
			const resourcePath = {
				companyID: companyID,
				vehicleID: $stateParams.vehicleID,
				workorderID: $stateParams.workOrderID
			}
			return WorkOrderService.createWorkOrderPart(resourcePath, requestBody)
				.then(function (newPartId) {
					if (!!vm.partList[index] && !!vm.partList[index].partData) {
						vm.partList[index].partData.id_work_order_part = newPartId;
						vm.partList[index].id = newPartId;
					}
					return $q.resolve();
				})
		}

		function updateParts(requestBodyList) {
			if (!Array.isArray(requestBodyList)) {
				return $q.reject("updateParts requestBodyList invalid");
			}

			const queue = [];

			requestBodyList.forEach(function (item) {
				if (!item) {
					return;
				}

				const resourcePath = {
					companyID: companyID,
					vehicleID: $stateParams.vehicleID,
					workorderID: $stateParams.workOrderID,
					partID: item.partID
				}

				queue.push(WorkOrderService.updateWorkOrderParts(resourcePath, item.requestBody));
			});

			return $q.all(queue);
		}

		function saveInventories(requestBody) {
			if (!requestBody) {
				return;
			}

			return $q.all([createInventories(requestBody.inventoriesToCreate), updateInventories(requestBody.inventoriesToUpdate)])
				.then(function () {
					resetOriginInventoryList();
					return $q.resolve();
				});
		}

		function createInventories(requestBodyList) {
			if (!Array.isArray(requestBodyList)) {
				return $q.reject("createInventories requestBodyList invalid");
			}

			const queue = [];

			requestBodyList.forEach(function (item) {
				if (!item) {
					return;
				}

				queue.push(createInventory(item.requestBody, item.index));
			});

			return $q.all(queue);
		}

		function createInventory(requestBody, index) {
			const resourcePath = {
				companyID: companyID,
				vehicleID: $stateParams.vehicleID,
				workorderID: $stateParams.workOrderID
			}

			return WorkOrderService.createWorkOrderInventory(resourcePath, requestBody)
				.then(function (newInventoryId) {
					if (Array.isArray(vm.partList) && vm.partList[index] && vm.partList[index].inventoryData) {
						vm.partList[index].inventoryData.id_work_order_inventory = newInventoryId;
						vm.partList[index].id = newInventoryId;
					}

					return $q.resolve();
				})
		}

		function updateInventories(requestBodyList) {
			if (!Array.isArray(requestBodyList)) {
				return $q.reject("updateInventories requestBodyList invalid");
			}

			const queue = [];

			requestBodyList.forEach(function (item) {
				if (!item) {
					return;
				}

				const resourcePath = {
					companyID: companyID,
					vehicleID: $stateParams.vehicleID,
					workorderID: $stateParams.workOrderID,
					inventoryID: item.inventoryID
				}

				queue.push(WorkOrderService.updateWorkOrderInventory(resourcePath, item.requestBody));
			});

			return $q.all(queue);
		}

		function resetOriginLaborList() {
			if (!Array.isArray(vm.laborList)) {
				return;
			}

			const laborList = [];

			vm.laborList.forEach(function (item) {
				if (item && item.laborData) {
					laborList.push(item.laborData);
				}
			});

			WorkOrderDataSharingService.setLaborList(laborList);
		}

		function resetOriginMiscfeesList() {
			if (!Array.isArray(vm.MiscFeesList)) {
				return;
			}

			const MiscFeesList = [];

			vm.MiscFeesList.forEach(function (item) {
				if (item && item.MiscFees) {
					// item.MiscFees.id_misc_fees = item.MiscFees.fk_misc_fees_type;
					MiscFeesList.push(item.MiscFees);
				}
			});

			WorkOrderDataSharingService.setMiscFeesList(MiscFeesList);
		}

		function getLaborsRequestBodys() {
			const laborsToCreate = [];
			const laborsToUpdate = [];

			if (!Array.isArray(vm.laborList)) {
				return;
			}

			vm.laborList.forEach(function (item, index) {
				if (!item || !item.laborData || item.isSelected) {
					return;
				}

				if (!item.laborData.id_labor) {
					laborsToCreate.push({
						index: index,
						requestBody: item.laborData
					});
					return;
				}

				const changedProperties = getUpdateLaborRequestBody(item.laborData);

				if (!!changedProperties) {
					laborsToUpdate.push({
						requestBody: changedProperties,
						laborID: item.laborData.id_labor
					});
				}
			});

			if (laborsToCreate.length <= 0 && laborsToUpdate.length <= 0) {
				return;
			}
			return {
				laborsToCreate: laborsToCreate,
				laborsToUpdate: laborsToUpdate
			}
		}

		function getMiscfeeRequestBodys() {
			const miscfeesToCreate = [];
			const miscfeesToUpdate = [];

			if (!Array.isArray(vm.MiscFeesList)) {
				return;
			}

			vm.MiscFeesList.forEach(function (item, index) {
				if (!item || !item.MiscFees) {
					return;
				}

				if (!item.MiscFees.id_misc_fees) {
					miscfeesToCreate.push({
						index: index,
						requestBody: item.MiscFees
					});
					return;
				}

				const changedProperties = getUpdateMiscRequestBody(item.MiscFees);

				if (!!changedProperties) {
					miscfeesToUpdate.push({
						requestBody: changedProperties,
						miscfeeID: item.MiscFees.id_misc_fees
					});
				}
			});

			if (miscfeesToCreate.length <= 0 && miscfeesToUpdate.length <= 0) {
				return;
			}
			return {
				miscfeesToCreate: miscfeesToCreate,
				miscfeesToUpdate: miscfeesToUpdate
			}
		}

		function getUpdateLaborRequestBody(labor) {
			const originLaborList = WorkOrderDataSharingService.getLaborList();

			if (!labor || !labor.id_labor) {
				return;
			}

			if (!Array.isArray(originLaborList)) {
				return;
			}

			const originLabor = originLaborList.find(function (item) {
				if (!item) {
					return;
				}

				return item.id_labor == labor.id_labor;
			});

			if (!originLabor) {
				return;
			}

			const changedProperties = GeneralTools.updateResourceRequestBodyGenerator(labor, originLabor);
			if (!!changedProperties) {
				return changedProperties;
			}
		}

		function getUpdateMiscRequestBody(miscfees) {
			const originidmiscfeesList = WorkOrderDataSharingService.getMiscFeesList();

			if (!miscfees || !miscfees.id_misc_fees) {
				return;
			}

			if (!Array.isArray(originidmiscfeesList)) {
				return;
			}

			const originmiscfees = originidmiscfeesList.find(function (item) {
				if (!item) {
					return;
				}

				return item.id_misc_fees == miscfees.id_misc_fees;
			});

			if (!originmiscfees) {
				return;
			}

			const changedProperties = GeneralTools.updateResourceRequestBodyGenerator(miscfees, originmiscfees);

			if (!!changedProperties) {
				return changedProperties;
			}
		}

		function saveLabors(requestBody) {
			if (!requestBody) {
				return;
			}

			return $q.all([createLabors(requestBody.laborsToCreate), updateLabors(requestBody.laborsToUpdate)])
				.then(function () {
					resetOriginLaborList();
					return $q.resolve();
				});
		}

		function saveMiscfees(requestBody) {
			if (!requestBody) {
				return;
			}

			return $q.all([createMiscfees(requestBody.miscfeesToCreate), updateMiscfees(requestBody.miscfeesToUpdate)])
				.then(function () {
					resetOriginMiscfeesList();
					return $q.resolve();
				});
		}

		function createLabors(requestBodyList) {
			if (!Array.isArray(requestBodyList)) {
				return $q.reject("createLabors requestBodyList invalid");
			}

			const queue = [];

			requestBodyList.forEach(function (item) {
				if (!item) {
					return;
				}

				queue.push(createLabor(item.requestBody, item.index));
			});

			return $q.all(queue);
		}

		function createMiscfees(requestBodyList) {
			if (!Array.isArray(requestBodyList)) {
				return $q.reject("createMiscfees requestBodyList invalid");
			}

			const queue = [];

			requestBodyList.forEach(function (item) {
				if (!item) {
					return;
				}
				queue.push(createMiscfee(item.requestBody, item.index));
			});

			return $q.all(queue);
		}

		function createLabor(requestBody, index) {
			const resourcePath = {
				companyID: companyID,
				vehicleID: $stateParams.vehicleID,
				workorderID: $stateParams.workOrderID
			}

			return WorkOrderService.createLabor(resourcePath, requestBody)
				.then(function (newLaborId) {
					if (Array.isArray(vm.laborList) && vm.laborList[index] && vm.laborList[index].laborData) {
						vm.laborList[index].laborData.id_labor = newLaborId;
						for (var i = 0; i < vm.labourlist.length; i++) {
							if (parseInt(vm.laborList[index].laborData.fk_id_labour_type) == vm.labourlist[i].id_labour_type) {
								vm.laborList[index].laborData.labour_name = vm.labourlist[i].labour_name;
							}
						}
					}

					return $q.resolve();
				})
		}

		function createMiscfee(requestBody, index) {
			const resourcePath = {
				companyID: companyID,
				vehicleID: $stateParams.vehicleID,
				workorderID: $stateParams.workOrderID
			}
			return WorkOrderService.createmiscfees(resourcePath, requestBody)
				.then(function (newmiscfeesId) {
					if (Array.isArray(vm.MiscFeesList) && vm.MiscFeesList[index] && vm.MiscFeesList[index].MiscFees) {
						vm.MiscFeesList[index].MiscFees.id_misc_fees = newmiscfeesId;
					}

					return $q.resolve();
				})
		}

		function updateLabors(requestBodyList) {
			if (!Array.isArray(requestBodyList)) {
				return $q.reject("updateLabors requestBodyList invalid");
			}

			const queue = [];

			requestBodyList.forEach(function (item) {
				if (!item) {
					return;
				}

				const resourcePath = {
					companyID: companyID,
					vehicleID: $stateParams.vehicleID,
					workorderID: $stateParams.workOrderID,
					laborID: item.laborID
				}
				queue.push(WorkOrderService.updateLabor(resourcePath, item.requestBody));
			});

			return $q.all(queue);
		}

		function updateMiscfees(requestBodyList) {
			if (!Array.isArray(requestBodyList)) {
				return $q.reject("updateMiscfees requestBodyList invalid");
			}

			const queue = [];

			requestBodyList.forEach(function (item) {
				if (!item) {
					return;
				}
				const resourcePath = {
					companyID: companyID,
					vehicleID: $stateParams.vehicleID,
					workorderID: $stateParams.workOrderID,
					miscfeeID: item.miscfeeID
				}
				queue.push(WorkOrderService.updateMiscfees(resourcePath, item.requestBody));
			});

			return $q.all(queue);
		}

		function isAnyPartSelectedInCurrentTab() {
			if (!Array.isArray(vm.partList)) {
				return;
			}

			const hasFilter = !!vm.partTableTabs[vm.currentPartTableTabIndex] && typeof (vm.partTableTabs[vm.currentPartTableTabIndex].filter) == "function";

			const selectedPart = vm.partList.find(function (item) {
				return (!hasFilter || vm.partTableTabs[vm.currentPartTableTabIndex].filter(item)) && !!item && !!item.isSelected;
			});

			return !!selectedPart;
		}

		function removeSelectedParts() {
			const details = getPartTableCurrentTabSelectedItemsDetail();

			if (!details) {
				MessageService.showToast("Part table data invalid.");
				return;
			}

			if (details.existingPartIdList.length > 0 || details.existingInventoryIdList.length > 0) {

				var itemsFromWorkOrderJob = false;

				var workOrderJobItemHolder = {
					matchingLaboursList: [],
					matchingPartsList: [],
					matchingInvensList: [],
					matchingMiscfeeList: []
				};

				var workOrderJobIdItemHolder;

				details.existingPartIdList.forEach(function(partId){
					if(checkGivenIdisFromWorkOrderJob(vm.workOrderJobList, partId, 1)){
						itemsFromWorkOrderJob = true
						workOrderJobIdItemHolder = getGivenItemIdAssociatedWorkOrderJobID(vm.workOrderJobList, partId, 1)
						var allItems = getAllItemsUnderWorkOrderJobID(workOrderJobIdItemHolder);

						allItems.matchingLaboursList.forEach(function(item) {
							workOrderJobItemHolder.matchingLaboursList.push(item);
						  });
						  allItems.matchingPartsList.forEach(function(item) {
							workOrderJobItemHolder.matchingPartsList.push(item);
						  });
						  allItems.matchingInvensList.forEach(function(item) {
							workOrderJobItemHolder.matchingInvensList.push(item);
						  });
						  allItems.matchingMiscfeeList.forEach(function(item) {
							workOrderJobItemHolder.matchingMiscfeeList.push(item);
						});
					}
				})

				details.existingInventoryIdList.forEach(function(invenId){
					if(checkGivenIdisFromWorkOrderJob(vm.workOrderJobList, invenId, 2)){
						itemsFromWorkOrderJob = true
						workOrderJobIdItemHolder = getGivenItemIdAssociatedWorkOrderJobID(vm.workOrderJobList, invenId, 2)
						//workOrderJobItemHolder = getAllItemsUnderWorkOrderJobID(workOrderJobIdItemHolder)
						var allItems = getAllItemsUnderWorkOrderJobID(workOrderJobIdItemHolder);
						allItems.matchingLaboursList.forEach(function(item) {
							workOrderJobItemHolder.matchingLaboursList.push(item);
						  });
						  allItems.matchingPartsList.forEach(function(item) {
							workOrderJobItemHolder.matchingPartsList.push(item);
						  });
						  allItems.matchingInvensList.forEach(function(item) {
							workOrderJobItemHolder.matchingInvensList.push(item);
						  });
						  allItems.matchingMiscfeeList.forEach(function(item) {
							workOrderJobItemHolder.matchingMiscfeeList.push(item);
						});

					}
				})
				var seen = {};
				workOrderJobItemHolder.matchingLaboursList = workOrderJobItemHolder.matchingLaboursList.filter(function(item) {
				if (seen[item.id_labor]) {
					return false;
				}
				seen[item.id_labor] = true;
					return true;
				});
				seen = {};
				workOrderJobItemHolder.matchingPartsList = workOrderJobItemHolder.matchingPartsList.filter(function(item) {
				if (seen[item.id_work_order_part]) {
					return false;
				}
				seen[item.id_work_order_part] = true;
					return true;
				});

				if(itemsFromWorkOrderJob){
					showDeleteWorkOrderJobItemsDialog(workOrderJobItemHolder, constructWarningMessageBaseOnWorkOrderJobItems(workOrderJobItemHolder), workOrderJobIdItemHolder);
				}else{
					showDeletePartTableItemsDialog(details.existingPartIdList, details.existingInventoryIdList, details.newItemIndexList);
				}

				
			} else {
				removeNewPartTableItems(details.newItemIndexList);
				MessageService.showToast("Parts are removed.");
			}
		}

		function showDeleteWorkOrderJobItemsDialog(workOrderJobItem, workOrderJobItemString, workOrderJobIdItemHolder) {
			var dialogOptions = {};

			dialogOptions.titleString = "Removing Job Items";

			dialogOptions.contentString = workOrderJobItemString + "Are you sure you want to remove all these items?";

			var confirmOption = {};

			var existingPartIdList = [];
			var existingInventoryIdList = [];
			var existingMiscfeesIdList  = [];
			var existingLaborIdList = [];
			
			if(workOrderJobItemString){

				if(workOrderJobItem.matchingPartsList.length > 0){
					workOrderJobItem.matchingPartsList.forEach(function(part){
						existingPartIdList.push(part.id_work_order_part)
					})
				}

				if(workOrderJobItem.matchingInvensList.length > 0){
					workOrderJobItem.matchingInvensList.forEach(function(part){
						existingInventoryIdList.push(part.id_work_order_inventory)
					})
				}

				if(workOrderJobItem.matchingLaboursList.length > 0){
					workOrderJobItem.matchingLaboursList.forEach(function(part){
						existingLaborIdList.push(part.id_labor)
					})
				}

				if(workOrderJobItem.matchingMiscfeeList.length > 0){
					workOrderJobItem.matchingMiscfeeList.forEach(function(part){
						existingMiscfeesIdList.push(part.id_misc_fees)
					})
				}
			}

			confirmOption.optionName = "YES";
			confirmOption.onClick = function () {
				vm.isDeletingPartTableItems = true;
				
				confirmDeletePartsOrInventories(existingPartIdList, existingInventoryIdList, [])
				.then(function () {
						MessageService.showToast("Work Order Job Part Items are removed.");
						confirmDeleteLabors(existingLaborIdList, [])
				})
				.then(function(){
					MessageService.showToast("Work Order Job Labour Items are removed.");
					confirmDeleteMiscfees(existingMiscfeesIdList, [])
				})
				.then(function(){
					MessageService.showToast("Work Order Job Misc Fee Items are removed.");
				}).then(function(){
					deleteWorkOrderJobById(workOrderJobIdItemHolder)
				})
				.catch(MessageService.showToast)
				.finally(function () {
					vm.isDeletingPartTableItems = false;
				});

				DialogService.close();
			}

			var cancelOption = {};

			cancelOption.optionName = "NO";
			cancelOption.onClick = function () {
				DialogService.close();
			}

			dialogOptions.options = [confirmOption, cancelOption];

			DialogService.showOptionsDialog(dialogOptions);
		}

		function getPartTableCurrentTabSelectedItemsDetail() {
			const existingPartIdList = [];
			const existingInventoryIdList = [];
			const newItemIndexList = [];

			if (!Array.isArray(vm.partList)) {
				return;
			}

			const hasFilter = !!vm.partTableTabs[vm.currentPartTableTabIndex] && typeof (vm.partTableTabs[vm.currentPartTableTabIndex].filter) == "function";

			vm.partList.forEach(function (item, index) {
				if ((hasFilter && !vm.partTableTabs[vm.currentPartTableTabIndex].filter(item)) || !item || !item.isSelected) {
					return;
				}
				if (!!item.partData && !!item.partData.id_work_order_part) {
					existingPartIdList.push(item.partData.id_work_order_part);
				} else if (!!item.inventoryData && !!item.inventoryData.id_work_order_inventory) {
					existingInventoryIdList.push(item.inventoryData.id_work_order_inventory);
				} else {
					newItemIndexList.push(index);
				}
			});

			// Find the parts converted to inventory.
			const originPartList = WorkOrderDataSharingService.getPartList();

			if (Array.isArray(originPartList)) {
				originPartList.forEach(function (part) {
					if (!!part) {
						part.id_work_order_part

						const index = vm.partList.findIndex(function (item) {
							return !!item && !!item.partData && item.partData.id_work_order_part == part.id_work_order_part;
						});

						if (index == -1) {
							existingPartIdList.push(part.id_work_order_part);
						}
					}
				});
			}
			return {
				existingPartIdList: existingPartIdList,
				existingInventoryIdList: existingInventoryIdList,
				newItemIndexList: newItemIndexList
			};
		}

		function showDeletePartTableItemsDialog(existingPartIdList, existingInventoryIdList, newItemIndexList) {
			var dialogOptions = {};

			dialogOptions.titleString = "Remove Parts";
			dialogOptions.contentString = "Are you sure to remove selected items";

			var confirmOption = {};

			confirmOption.optionName = "YES";
			confirmOption.onClick = function () {
				vm.isDeletingPartTableItems = true;

				confirmDeletePartsOrInventories(existingPartIdList, existingInventoryIdList, newItemIndexList)
					.then(function () {
						MessageService.showToast("Parts are removed.");
					})
					.catch(MessageService.showToast)
					.finally(function () {
						vm.isDeletingPartTableItems = false;
					});

				DialogService.close();
			}

			var cancelOption = {};

			cancelOption.optionName = "NO";
			cancelOption.onClick = function () {
				DialogService.close();
			}

			dialogOptions.options = [confirmOption, cancelOption];

			DialogService.showOptionsDialog(dialogOptions);
		}

		function confirmDeletePartsOrInventories(existingPartIdList, existingInventoryIdList, newItemIndexList) {
			removeNewPartTableItems(newItemIndexList);

			if (!Array.isArray(existingPartIdList) || !Array.isArray(existingInventoryIdList)) {
				return;
			}

			const queue = [];

			existingPartIdList.forEach(function (partID) {
				queue.push(deletePart(partID));
			});

			existingInventoryIdList.forEach(function (inventoryID) {
				queue.push(deleteWorkOrderInventory(inventoryID));
			});

			return $q.all(queue)
				.then(function () {
					resetOriginPartList();
					resetOriginInventoryList();
					return $q.resolve();
				});
		}

		function removeNewPartTableItems(newItemIndexList) {
			if (!Array.isArray(newItemIndexList)) {
				return;
			}

			newItemIndexList.reverse();

			newItemIndexList.forEach(function (index) {
				vm.partList.splice(index, 1);
			});
		}

		function deleteWorkOrderInventory(inventoryID) {
			const resourcePath = {
				companyID: companyID,
				vehicleID: $stateParams.vehicleID,
				workorderID: $stateParams.workOrderID,
				inventoryID: inventoryID
			}

			return WorkOrderService.deleteWorkOrderInventory(resourcePath)
				.then(function () {
					const index = vm.partList.findIndex(function (item) {
						return !!item && !!item.inventoryData && item.inventoryData.id_work_order_inventory == inventoryID;
					});

					if (index != -1) {
						vm.partList.splice(index, 1);
					}
					return $q.resolve();
				});
		}

		function isAnyLaborSelected() {
			if (!Array.isArray(vm.laborList)) {
				return;
			}

			return !!vm.laborList.find(function (item) {
				return item && item.isSelected;
			});
		}

		function isAnyMiscfeesSelected() {
			if (!Array.isArray(vm.MiscFeesList)) {
				return;
			}

			return !!vm.MiscFeesList.find(function (item) {
				return item && item.isSelected;
			});

		}

		function removeSelectedLabors() {
			const details = getLaborTableSelectedItemsDetail();

			if (details.existingLaborIdList.length > 0) {

				var itemsFromWorkOrderJob = false;

				var workOrderJobItemHolder = {
					matchingLaboursList: [],
					matchingPartsList: [],
					matchingInvensList: [],
					matchingMiscfeeList: []
				};
				
				var workOrderJobIdItemHolder;
				  
				  details.existingLaborIdList.forEach(function(partId) {
					if (checkGivenIdisFromWorkOrderJob(vm.workOrderJobList, partId, 4)) {
					  itemsFromWorkOrderJob = true;
					  
					workOrderJobIdItemHolder = getGivenItemIdAssociatedWorkOrderJobID(vm.workOrderJobList, partId, 4);
					  var allItems = getAllItemsUnderWorkOrderJobID(workOrderJobIdItemHolder);
				  
					  allItems.matchingLaboursList.forEach(function(item) {
						workOrderJobItemHolder.matchingLaboursList.push(item);
					  });
					  allItems.matchingPartsList.forEach(function(item) {
						workOrderJobItemHolder.matchingPartsList.push(item);
					  });
					  allItems.matchingInvensList.forEach(function(item) {
						workOrderJobItemHolder.matchingInvensList.push(item);
					  });
					  allItems.matchingMiscfeeList.forEach(function(item) {
						workOrderJobItemHolder.matchingMiscfeeList.push(item);
					  });
					}
				});

				var seen = {};
				workOrderJobItemHolder.matchingLaboursList = workOrderJobItemHolder.matchingLaboursList.filter(function(item) {
				if (seen[item.id_labor]) {
					return false;
				}
				seen[item.id_labor] = true;
					return true;
				});
				seen = {};
				workOrderJobItemHolder.matchingPartsList = workOrderJobItemHolder.matchingPartsList.filter(function(item) {
				if (seen[item.id_work_order_part]) {
					return false;
				}
				seen[item.id_work_order_part] = true;
					return true;
				});



				if(itemsFromWorkOrderJob){
					showDeleteWorkOrderJobItemsDialog(workOrderJobItemHolder, constructWarningMessageBaseOnWorkOrderJobItems(workOrderJobItemHolder), workOrderJobIdItemHolder);
				}else{
					showDeleteLaborsDialog(details.existingLaborIdList, details.newLaborIndexList);
				}
				
			} else {
				removeNewLabors(details.newLaborIndexList);
				MessageService.showToast("Labors are removed.");
			}
		}

		function removeSelectedMiscfees() {
			const details = getMiscfeesTableSelectedItemsDetail();

			if (details.existingMiscfeesIdList.length > 0) {

				var itemsFromWorkOrderJob = false;

				var workOrderJobItemHolder = {
					matchingLaboursList: [],
					matchingPartsList: [],
					matchingInvensList: [],
					matchingMiscfeeList: []
				};

				var workOrderJobIdItemHolder;

				details.existingMiscfeesIdList.forEach(function(partId){
					if(checkGivenIdisFromWorkOrderJob(vm.workOrderJobList, partId, 3)){
						itemsFromWorkOrderJob = true
						workOrderJobIdItemHolder = getGivenItemIdAssociatedWorkOrderJobID(vm.workOrderJobList, partId, 3)
						var allItems = getAllItemsUnderWorkOrderJobID(workOrderJobIdItemHolder);

						allItems.matchingLaboursList.forEach(function(item) {
							workOrderJobItemHolder.matchingLaboursList.push(item);
						  });
						  allItems.matchingPartsList.forEach(function(item) {
							workOrderJobItemHolder.matchingPartsList.push(item);
						  });
						  allItems.matchingInvensList.forEach(function(item) {
							workOrderJobItemHolder.matchingInvensList.push(item);
						  });
						  allItems.matchingMiscfeeList.forEach(function(item) {
							workOrderJobItemHolder.matchingMiscfeeList.push(item);
						});
					}
				})
				var seen = {};
				workOrderJobItemHolder.matchingLaboursList = workOrderJobItemHolder.matchingLaboursList.filter(function(item) {
				if (seen[item.id_labor]) {
					return false;
				}
				seen[item.id_labor] = true;
					return true;
				});
				seen = {};
				workOrderJobItemHolder.matchingPartsList = workOrderJobItemHolder.matchingPartsList.filter(function(item) {
				if (seen[item.id_work_order_part]) {
					return false;
				}
				seen[item.id_work_order_part] = true;
					return true;
				});

				if(itemsFromWorkOrderJob){
					showDeleteWorkOrderJobItemsDialog(workOrderJobItemHolder, constructWarningMessageBaseOnWorkOrderJobItems(workOrderJobItemHolder), workOrderJobIdItemHolder);
				}else{
					showDeleteMiscfeesDialog(details.existingMiscfeesIdList, details.newMiscfeesIndexList);
				}

			} else {
				removeNewMiscfees(details.newMiscfeesIndexList);
				MessageService.showToast("Misc fees are removed.");
			}
		}

		function getLaborTableSelectedItemsDetail() {
			const existingLaborIdList = [];
			const newLaborIndexList = [];

			vm.laborList.forEach(function (item, index) {
				if (!item || !item.isSelected) {
					return;
				}

				if (!!item.laborData.id_labor) {
					existingLaborIdList.push(item.laborData.id_labor);
				} else {
					newLaborIndexList.push(index);
				}
			});

			return {
				existingLaborIdList: existingLaborIdList,
				newLaborIndexList: newLaborIndexList
			}
		}

		function getMiscfeesTableSelectedItemsDetail() {
			const existingMiscfeesIdList = [];
			const newMiscfeesIndexList = [];

			vm.MiscFeesList.forEach(function (item, index) {
				if (!item || !item.isSelected) {
					return;
				}

				if (!!item.MiscFees.id_misc_fees) {
					existingMiscfeesIdList.push(item.MiscFees.id_misc_fees);
				} else {
					newMiscfeesIndexList.push(index);
				}
			});

			return {
				existingMiscfeesIdList: existingMiscfeesIdList,
				newMiscfeesIndexList: newMiscfeesIndexList
			}
		}

		function showDeleteLaborsDialog(existingLaborIdList, newLaborIndexList) {
			var dialogOptions = {};

			dialogOptions.titleString = "Remove Labors";
			dialogOptions.contentString = "Are you sure to remove selected items";

			var confirmOption = {};

			confirmOption.optionName = "YES";
			confirmOption.onClick = function () {
				vm.isDeletingLabors = true;

				confirmDeleteLabors(existingLaborIdList, newLaborIndexList)
					.then(function () {
						MessageService.showToast("Labors are removed.");
					})
					.catch(MessageService.showToast)
					.finally(function () {
						vm.isDeletingLabors = false;
					})
				DialogService.close();
			}

			var cancelOption = {};

			cancelOption.optionName = "NO";
			cancelOption.onClick = function () {
				DialogService.close();
			}

			dialogOptions.options = [confirmOption, cancelOption];

			DialogService.showOptionsDialog(dialogOptions);
		}

		function showDeleteMiscfeesDialog(existingMiscfeesIdList, newMiscfeesIndexList) {
			var dialogOptions = {};

			dialogOptions.titleString = "Remove Misc fees";
			dialogOptions.contentString = "Are you sure to remove selected items";

			var confirmOption = {};

			confirmOption.optionName = "YES";
			confirmOption.onClick = function () {
				vm.isDeletingMiscfees = true;

				confirmDeleteMiscfees(existingMiscfeesIdList, newMiscfeesIndexList)
					.then(function () {
						MessageService.showToast("Misc fees are removed.");
					})
					.catch(MessageService.showToast)
					.finally(function () {
						vm.isDeletingMiscfees = false;
					})
				DialogService.close();
			}

			var cancelOption = {};

			cancelOption.optionName = "NO";
			cancelOption.onClick = function () {
				DialogService.close();
			}

			dialogOptions.options = [confirmOption, cancelOption];

			DialogService.showOptionsDialog(dialogOptions);
		}

		function confirmDeleteLabors(existingLaborIdList, newLaborIndexList) {
			removeNewLabors(newLaborIndexList);

			if (!Array.isArray(existingLaborIdList)) {
				return;
			}

			const queue = [];

			existingLaborIdList.forEach(function (laborID) {
				queue.push(deleteLabor(laborID));
			});

			return $q.all(queue)
				.then(function () {
					resetOriginLaborList();
					return $q.resolve();
				});
		}

		function confirmDeleteMiscfees(existingMiscfeesIdList, newMiscfeesIndexList) {
			removeNewMiscfees(newMiscfeesIndexList);

			if (!Array.isArray(existingMiscfeesIdList)) {
				return;
			}

			const queue = [];

			existingMiscfeesIdList.forEach(function (id_misc_fees) {
				queue.push(deleteMiscfee(id_misc_fees));
			});

			return $q.all(queue)
				.then(function () {
					resetOriginMiscfeesList();
					return $q.resolve();
				});
		}

		function deleteLabor(laborID) {
			const resourcePath = {
				companyID: companyID,
				vehicleID: $stateParams.vehicleID,
				workorderID: $stateParams.workOrderID,
				laborID: laborID
			}

			return WorkOrderService.deleteLabor(resourcePath)
				.then(function () {
					const index = vm.laborList.findIndex(function (item) {
						return !!item && item.laborData.id_labor == laborID;
					});

					vm.laborList.splice(index, 1);
					return $q.resolve();
				});
		}

		function deleteMiscfee(id_misc_fees) {
			const resourcePath = {
				companyID: companyID,
				vehicleID: $stateParams.vehicleID,
				workorderID: $stateParams.workOrderID,
				miscfeeID: id_misc_fees
			}

			return WorkOrderService.deleteMiscfees(resourcePath)
				.then(function () {
					const index = vm.MiscFeesList.findIndex(function (item) {
						return !!item && item.MiscFees.id_misc_fees == id_misc_fees;
					});

					vm.MiscFeesList.splice(index, 1);
					return $q.resolve();
				});
		}

		function removeNewLabors(newLaborIndexList) {
			if (!Array.isArray(newLaborIndexList)) {
				return;
			}

			newLaborIndexList.reverse();

			newLaborIndexList.forEach(function (index) {
				vm.laborList.splice(index, 1);
			});
		}


		function removeNewMiscfees(newMiscfeesIndexList) {
			if (!Array.isArray(newMiscfeesIndexList)) {
				return;
			}

			newMiscfeesIndexList.reverse();

			newMiscfeesIndexList.forEach(function (index) {
				vm.MiscFeesList.splice(index, 1);
			});
		}

		function addDiscountOnParts() {
			const discount = new WorkOrderDiscount();

			discount.description = "Parts Discount";
			discount.is_percentage = false;

			if (vm.isPartDiscountPercentage) {
				var totalSelectedPartPrice = 0;

				if (!Array.isArray(vm.partList)) {
					return;
				}

				const hasFilter = !!vm.partTableTabs[vm.currentPartTableTabIndex] && typeof (vm.partTableTabs[vm.currentPartTableTabIndex].filter) == "function";

				vm.partList.forEach(function (item) {
					if ((hasFilter && !vm.partTableTabs[vm.currentPartTableTabIndex].filter(item)) || !item || !item.isSelected) {
						return;
					}

					if (!!item.partData) {
						totalSelectedPartPrice += GeneralTools.parseNumber(item.partData.quantity) * GeneralTools.parseNumber(item.partData.retail_price);
					} else if (!!item.inventoryData) {
						totalSelectedPartPrice += GeneralTools.parseNumber(item.inventoryData.quantity) * GeneralTools.parseNumber(item.inventoryData.retail_price);
					}
				});

				discount.amount_off = GeneralTools.preciseNumber(vm.partDiscountAmount * totalSelectedPartPrice, 2);
			} else {
				discount.amount_off = vm.partDiscountAmount;
			}

			vm.isSaving = true;

			addDiscount(discount)
				.then(function () {
					MessageService.showToast("Discount added.");
				})
				.catch(MessageService.showToast)
				.finally(function () {
					vm.isSaving = false;
					vm.showPartDiscount = false;
					vm.partDiscountAmount = null;
					vm.isPartDiscountPercentage = false;
				});;
		}

		function addDiscountOnLabors() {
			const discount = new WorkOrderDiscount();

			discount.description = "Labors Discount";
			discount.is_percentage = false;

			if (vm.isLaborDiscountPercentage) {
				var totalSelectedLaborPrice = 0;

				if (!Array.isArray(vm.laborList)) {
					return;
				}

				vm.laborList.forEach(function (item) {
					if (!!item && item.isSelected && !!item.laborData) {
						totalSelectedLaborPrice += GeneralTools.parseNumber(item.laborData.price) * GeneralTools.parseNumber(item.laborData.hour);
					}
				});

				discount.amount_off = GeneralTools.preciseNumber(vm.laborDiscountAmount * totalSelectedLaborPrice, 2);
			} else {
				discount.amount_off = vm.laborDiscountAmount;
			}

			vm.isSaving = true;

			addDiscount(discount)
				.then(function () {
					MessageService.showToast("Discount added.");
				})
				.catch(MessageService.showToast)
				.finally(function () {
					vm.isSaving = false;
					vm.showLaborDiscount = false;
					vm.laborDiscountAmount = null;
					vm.isLaborDiscountPercentage = false;
				});;
		}

		function addDiscount(discount) {
			if (!discount) {
				MessageService.showToast("Discount data invalid");
				return;
			}

			if (discount.is_percentage && !discount.percentage_off) {
				MessageService.showToast("Please enter discount percentage");
				return;
			}

			if (!discount.is_percentage && !discount.amount_off) {
				MessageService.showToast("Please enter discount amount");
				return;
			}

			const resourcePath = {
				companyID: companyID,
				vehicleID: $stateParams.vehicleID,
				workorderID: $stateParams.workOrderID
			}

			return WorkOrderService.createDiscount(resourcePath, discount)
				.then(function (newDiscountID) {
					discount.id_work_order_discount = newDiscountID;
					vm.discounts.push(discount)
					WorkOrderDataSharingService.setDiscountList(vm.discounts);
					return $q.resolve();
				});
		}

		function isWorkOrderCapbleforRD(str) {


			return DialogService.showYesOrNoDialog(null, str)
			.then(function (isContinue) {
				if (isContinue) {
					return $q.resolve(true);
				}
				return  $q.resolve(false);
				
			}).catch(function(result){
				return  $q.resolve(false);
			});

		}

		function generateRD(rogerDollar, customerInfo){
			const resourcePath = {
				companyID: companyID,
				vehicleID: $stateParams.vehicleID,
				workorderID: $stateParams.workOrderID,
			}
			return WorkOrderService.generateRD(resourcePath, {rgdollar: rogerDollar, customerID: customerInfo.id_customer})
			.then(function (insertID) {
				if(insertID){
					var temp = new WorkOrderRDGenerated();
					temp.setAttributes({
						id_rd_generated: insertID,
						generated_amount: rogerDollar,
						fk_id_work_order: $stateParams.workOrderID,
						fk_id_user: userInfo.userID,
						fk_id_customer: customerInfo.id_customer,
						date: moment().format("YYYY-MM-DD")
					})

					const newArray = [temp].map(function(obj){
						const resourceData  = {
							id_rd_generated: insertID,
							generated_amount: rogerDollar,
							fk_id_work_order: $stateParams.workOrderID,
							fk_id_user: userInfo.userID,
							fk_id_customer: customerInfo.id_customer,
							date: moment().format("YYYY-MM-DD")
						}
						return resourceData
					})

					vm.workOrderRDGeneratedList = angular.copy(newArray)
					WorkOrderDataSharingService.setRDGeneratedList(newArray);
				}
				return $q.resolve();
			})
			.catch(MessageService.showToast)
			.finally(function(){

			});
		}

		function onStatusClick(status) {
			if(status.id_work_order_status == vm.workOrder.fk_id_work_order_status){
				return 
			}

			var subtotaltempholder = WorkOrderDataSharingService.getworkOrderSubTotal();
			var rogerDollar = parseFloat((vm.workOrder.rogerdollar_generate_precentage * subtotaltempholder).toFixed(2))
			var rogerDollarstr = generatingRogerDollarA + (vm.workOrder.rogerdollar_generate_precentage * subtotaltempholder).toFixed(2) + generatingRogerDollarB;

			var isCompleting = false;
			var isRevertingComplete = false;

			if (status.id_work_order_status == WorkOrderConstants.statusIDs.completed) {
				isCompleting = true;
			} else if (vm.workOrder.fk_id_work_order_status == WorkOrderConstants.statusIDs.completed) {
				isRevertingComplete = true;
			}

			if( (vm.workOrder.selectedCustomer == undefined || vm.workOrder.selectedCustomer.customerInfo == undefined)  && isCompleting && rogerDollar > 0 && vm.workOrder.is_rogerdollar_generable == true && vm.workOrderRDGeneratedList.length == 0 ){
				MessageService.showToast("Error, Capable of generate Rogers Dollar but missing Customer Select.");
				return
			}

			var promise = $q.resolve();
			var promiseA = $q.resolve();
			vm.isSaving = true;

			if (isCompleting && rogerDollar > 0 && vm.workOrder.is_rogerdollar_generable == true && vm.workOrderRDGeneratedList.length == 0 && vm.workOrder.selectedCustomer.customerInfo != undefined) {
				promiseA = isWorkOrderCapbleforRD(rogerDollarstr).then(function(params) {
					if (params) {
						return generateRD(rogerDollar, vm.workOrder.selectedCustomer.customerInfo)
					}	
					vm.isSaving = false
					return $q.reject();
				}).catch(function (error) {
					if (error) {
						return $q.reject();
					}
				}).then(function () {
					if (isCompleting) {
						promise = checkBeforeCompleteWorkorder()
							.then(function (isContinue) {
								if (isContinue) {
									return saveInventoryAndModifyQuantity(true);
								}
		
								return $q.reject();
							});
					} else if (isRevertingComplete) {
						promise = saveInventoryAndModifyQuantity(false);
					}
		
					promise.then(function () {
						setWorkorderStatus(status.id_work_order_status);
						return updateWorkOrder(GeneralTools.updateResourceRequestBodyGenerator(vm.workOrder, WorkOrderDataSharingService.getWorkOrder()));
					})
						.then(function () {
							refreshDemandMap();
							vm.refreshDates();
							MessageService.showToast("Success.");
						})
						.catch(function (error) {
							if (error) {
								MessageService.showToast(error);
							}
						})
						.finally(function () {
							vm.isSaving = false;
						});
				})

			}else{
				if (isCompleting) {
					promise = checkBeforeCompleteWorkorder()
						.then(function (isContinue) {
							if (isContinue) {
								return saveInventoryAndModifyQuantity(true);
							}
	
							return $q.reject();
						});
				} else if (isRevertingComplete) {
					promise = saveInventoryAndModifyQuantity(false);
				}
	
				promise.then(function () {
					setWorkorderStatus(status.id_work_order_status);
					return updateWorkOrder(GeneralTools.updateResourceRequestBodyGenerator(vm.workOrder, WorkOrderDataSharingService.getWorkOrder()));
				})
					.then(function () {
						refreshDemandMap();
						vm.refreshDates();
						MessageService.showToast("Success.");
					})
					.catch(function (error) {
						if (error) {
							MessageService.showToast(error);
						}
					})
					.finally(function () {
						vm.isSaving = false;
					});
			}
			
		}

		function checkBeforeCompleteWorkorder() {
			return isInventoryEnough()
				.then(function () {
					if (!isAssignedToMechanic()) {
						return DialogService.showYesOrNoDialog(null, missingMechanicWarning);
					}

					return $q.resolve(true);
				})
				.then(function (isContinue) {
					if (!isContinue) {
						return $q.reject();
					}

					if (vm.workOrder.mileage == null) {
						return DialogService.showYesOrNoDialog(null, missingMileageWarning);
					}

					return $q.resolve(true);
				});
		}

		function setWorkorderStatus(statusID) {
			if (!vm.workOrder) {
				return;
			}

			if (statusID == WorkOrderConstants.statusIDs.completed && !vm.workOrder.completed_date) {
				vm.workOrder.setCompletedDateTime(moment().utc());
			}

			if (statusID == WorkOrderConstants.statusIDs.quoted && !vm.workOrder.quote_date) {
				vm.workOrder.setQuoteDate(moment().utc());
			}

			vm.workOrder.fk_id_work_order_status = statusID;
		}

		function saveInventoryAndModifyQuantity(isNegative) {
			const unsavedChanges = getInventoriesRequestBodys();

			if (!unsavedChanges) {
				return modifyInventoriesQuantity(extractInventoryListFromPartList(), isNegative);
			}

			var ignoreUnsavedChanges = false;

			return DialogService.showYesOrNoDialog(null, completeWorkOrderWarning, saveAndContinueStr, ignoreAndContinueStr)
				.then(function (isToSaveChanges) {
					if (isToSaveChanges) {
						return saveInventories(unsavedChanges);
					}

					ignoreUnsavedChanges = true;
					return $q.resolve();
				})
				.then(function () {
					if (ignoreUnsavedChanges) {
						return modifyInventoriesQuantity(WorkOrderDataSharingService.getInventoryList(), isNegative);
					}
					resetOriginInventoryList();
					return modifyInventoriesQuantity(extractInventoryListFromPartList(), isNegative);
				});
		}

		function hasUnsavedChanges() {
			delete vm.workOrder.selectedCustomer
			if (GeneralTools.updateResourceRequestBodyGenerator(vm.workOrder, WorkOrderDataSharingService.getWorkOrder())) {
				return true;
			}

			if (getPartsRequestBodys()) {
				return true;
			}

			if (getInventoriesRequestBodys()) {
				return true;
			}

			if (getLaborsRequestBodys()) {
				return true;
			}

			if (getMiscfeeRequestBodys()) {
				return true;
			}

			if (getWorkOrderWarrantyRequestBodys()) {
				return true
			}

			return false;
		}

		function modifyInventoriesQuantity(inventories, isNegative) {
			if (!Array.isArray(inventories)) {
				return $q.reject("Selected inventories invalid.");
			}

			const quantityChangeMap = {};

			inventories.forEach(function (inventory) {
				if (!inventory) {
					return;
				}

				if (quantityChangeMap[inventory.fk_id_inventory] == null) {
					quantityChangeMap[inventory.fk_id_inventory] = 0;
				}

				if (isNegative) {
					quantityChangeMap[inventory.fk_id_inventory] -= inventory.quantity;
				} else {
					quantityChangeMap[inventory.fk_id_inventory] += inventory.quantity;
				}
			});

			const queue = [];

			Object.keys(quantityChangeMap).forEach(function (inventoryID) {
				const resourcePath = {
					companyID: companyID,
					inventoryID: inventoryID
				};

				queue.push(InventoryService.modifyInventoryQuantity(resourcePath, quantityChangeMap[inventoryID]));
			});

			return $q.all(queue);
		}

		function isInventoryEnough() {
			return refreshDemandMap().then(function (demandMap) {
				if (!demandMap) {
					return $q.reject("Demand map invalid.");
				}

				const isEnough = Object.keys(vm.demandMap).every(function (inventoryID) {
					return !!vm.demandMap[inventoryID] && vm.demandMap[inventoryID].totalInStock >= vm.demandMap[inventoryID].totalDemand;
				});

				if (isEnough) {
					return $q.resolve();
				}

				return $q.reject("Inventory not enough");
			});
		}

		function updateUpcomingAppontmentStatus(statusID) {
			if (!vm.upcomingAppointment) {
				return;
			}

			vm.isUpdatingAppointment = true;

			const resourcePath = {
				companyID: companyID,
				workorderappointmentID: vm.upcomingAppointment.id_work_order_appointment
			};

			const requestBody = {};

			if (statusID == vm.upcomingAppointment.fk_id_appointment_status) {
				requestBody.fk_id_appointment_status = null;
			} else {
				requestBody.fk_id_appointment_status = statusID;
			}

			WorkOrderService.updateAppointment(resourcePath, requestBody)
				.then(function () {
					vm.upcomingAppointment.fk_id_appointment_status = requestBody.fk_id_appointment_status;
					MessageService.showToast("Appointment is updated.");
				})
				.catch(MessageService.showToast)
				.finally(function () {
					vm.isUpdatingAppointment = false;
				});
		}

		function updateUpcomingCustomerPortalAppontmentStatus(statusID) {
			if (!vm.upcomingAppointment) {
				return;
			}

			vm.isUpdatingAppointment = true;

			const resourcePath = {
				companyID: companyID,
				workorderappointmentID: vm.upcomingAppointment.id_work_order_appointment
			};

			const requestBody = {};

			if (statusID == vm.upcomingAppointment.fk_id_appointment_status) {
				requestBody.fk_id_appointment_status = null;
			} else {
				requestBody.fk_id_appointment_status = statusID;
			}

			WorkOrderService.updateAppointment(resourcePath, requestBody)
				.then(function () {
					vm.upcomingAppointment.fk_id_appointment_status = requestBody.fk_id_appointment_status;
					MessageService.showToast("Appointment is updated.");
				})
				.catch(MessageService.showToast)
				.finally(function () {
					vm.isUpdatingAppointment = false;
				});
		}

		function percentageTransaletor(isPercentage, key) {
			if (typeof (vm[key]) != "number") {
				return;
			}

			if (isPercentage) {
				vm[key] = vm[key] / 100;
			} else {
				vm[key] = vm[key] * 100;
			}
		}

		function splitWorkorder() {
			if (!isAnyPartSelectedInCurrentTab() && !isAnyLaborSelected() && !isAnyMiscfeesSelected()) {
				MessageService.showToast("No part or labor or misc fees selected.");
				return;
			}

			if (vm.isWarrntySectionValid && !vm.isWarrntySectionValid()) {
				MessageService.showToast(warrantyTableInvalidMessage);
				return;
			}

			if (vm.isPartTableValid && !vm.isPartTableValid()) {
				MessageService.showToast(partTableInvalidMessage);
				return;
			}

			if (vm.isLaborTableValid && !vm.isLaborTableValid()) {
				MessageService.showToast(laborTableInvalidMessage);
				return;
			}

			if (vm.isMiscfeeTableValid && !vm.isMiscfeeTableValid()) {
				MessageService.showToast(miscfeeTableInvalidMessage);
				return;
			}


			var partTableDetail;
			var laborTableDetail;
			var miscfeesTableDetail;
			var newWorkorderID;
			var unsavedChangeCheck = $q.resolve();
			vm.isSpliting = true;

			if (hasUnsavedChanges()) {
				unsavedChangeCheck = DialogService.showYesOrNoDialog(null, unsavedChangeWarning, saveAndContinueStr, ignoreAndContinueStr)
					.then(function (isSave) {
						if (isSave) {
							return save();
						}

						return $q.resolve();
					});
			}

			unsavedChangeCheck.then(function () {
				partTableDetail = getPartTableCurrentTabSelectedItemsDetail();
				laborTableDetail = getLaborTableSelectedItemsDetail();
				miscfeesTableDetail = getMiscfeesTableSelectedItemsDetail();
				return DialogService.showYesOrNoDialog(splitConfirmMessageTitle, getSplitConfirmMessage(partTableDetail, laborTableDetail, miscfeesTableDetail));
			})
				.then(function (isContinue) {
					if (!isContinue) {
						return $q.reject();
					}

					return createNewWorkorder();
				})
				.then(function (_newWorkorderID) {
					newWorkorderID = _newWorkorderID;

					return $q.all([
						copySelectedPartsToWorkorder(newWorkorderID),
						copySelectedLaborToWorkorder(newWorkorderID),
						copySelectedMiscfeesToWorkorder(newWorkorderID)
					]);
				})
				.then(function () {
					const queue = [];

					if (partTableDetail) {
						queue.push(confirmDeletePartsOrInventories(partTableDetail.existingPartIdList, partTableDetail.existingInventoryIdList, partTableDetail.newItemIndexList));
					}

					if (laborTableDetail) {
						queue.push(confirmDeleteLabors(laborTableDetail.existingLaborIdList, laborTableDetail.newLaborIndexList));
					}

					if (miscfeesTableDetail) {
						queue.push(confirmDeleteMiscfees(miscfeesTableDetail.existingMiscfeesIdList, miscfeesTableDetail.newMiscfeesIndexList));
					}

					return $q.all(queue);
				})
				.then(function () {
					window.open($state.href("app.edit-workorder.general", { workOrderID: newWorkorderID, vehicleID: $stateParams.vehicleID }), '_blank');
				})
				.catch(function (error) {
					if (error) {
						MessageService.showToast(error);
					}
				})
				.finally(function () {
					vm.isSpliting = false;
				});
		}

		function copySelectedPartsToWorkorder(workorderID) {
			const hasFilter = !!vm.partTableTabs[vm.currentPartTableTabIndex] && typeof (vm.partTableTabs[vm.currentPartTableTabIndex].filter) == "function";
			const queue = [];
			const resourcePath = {
				companyID: companyID,
				vehicleID: $stateParams.vehicleID,
				workorderID: workorderID
			}

			vm.partList.forEach(function (item, index) {
				if ((hasFilter && !vm.partTableTabs[vm.currentPartTableTabIndex].filter(item)) || !item || !item.isSelected) {
					return;
				}

				if (!!item.partData) {
					queue.push(WorkOrderService.createWorkOrderPart(resourcePath, item.partData));
				} else if (!!item.inventoryData) {
					queue.push(WorkOrderService.createWorkOrderInventory(resourcePath, item.inventoryData));
				}
			});

			return $q.all(queue);
		}

		function copySelectedLaborToWorkorder(workorderID) {
			const queue = [];
			const resourcePath = {
				companyID: companyID,
				vehicleID: $stateParams.vehicleID,
				workorderID: workorderID
			}

			vm.laborList.forEach(function (item, index) {
				if (!item || !item.isSelected) {
					return;
				}

				queue.push(WorkOrderService.createLabor(resourcePath, item.laborData));
			});

			return $q.all(queue);
		}


		function copySelectedMiscfeesToWorkorder(workorderID) {
			const queue = [];
			const resourcePath = {
				companyID: companyID,
				vehicleID: $stateParams.vehicleID,
				workorderID: workorderID
			}

			vm.MiscFeesList.forEach(function (item, index) {
				if (!item || !item.isSelected) {
					return;
				}
				delete item.MiscFees.id_misc_fees
				queue.push(WorkOrderService.createmiscfees(resourcePath, item.MiscFees));
			});

			return $q.all(queue);
		}

		function createNewWorkorder() {
			const resourcePath = {
				companyID: companyID,
				vehicleID: $stateParams.vehicleID
			}

			const workOrder = new WorkOrder();

			workOrder.quote_date = moment().format(WorkOrderConstants.dateFormat);
			workOrder.fk_id_work_order_status = WorkOrderConstants.statusIDs.quoted;
			workOrder.tax_rate = ToolsConstants.taxRate;

			const lowestPriority = WorkOrderService.getLowestWorkOrderPriority(vm.workOrderPriorities);

			if (lowestPriority) {
				workOrder.fk_id_work_order_priority = lowestPriority.id_work_order_priority;
			}

			return WorkOrderService.createWorkOrder(resourcePath, workOrder);
		}

		function getSplitConfirmMessage(partTableDetail, laborTableDetail, miscfeesTableDetail) {
			if (!partTableDetail || !laborTableDetail || !miscfeesTableDetail || !Array.isArray(vm.partList) || !Array.isArray(vm.laborList) || !Array.isArray(vm.MiscFeesList)) {
				MessageService.showToast("Part table or labor or misc fees table data invalid.");
				return;
			}

			var existingPartsAndInventoriesNameList = '';
			var newPartsAndInventoriesNameList = '';

			vm.partList.forEach(function (item, index) {
				if (!item) {
					return;
				}

				if (item.partData) {
					if (partTableDetail.existingPartIdList.indexOf(item.partData.id_work_order_part) != -1) {
						existingPartsAndInventoriesNameList = GeneralTools.stringConnector(existingPartsAndInventoriesNameList, dot + item.partData.name, '\n');
					} else if (partTableDetail.newItemIndexList.indexOf(index) != -1) {
						newPartsAndInventoriesNameList = GeneralTools.stringConnector(newPartsAndInventoriesNameList, dot + item.partData.name + splitNewItemTag, '\n');
					}
				} else if (item.inventoryData) {
					if (partTableDetail.existingInventoryIdList.indexOf(item.inventoryData.id_work_order_inventory) != -1) {
						existingPartsAndInventoriesNameList = GeneralTools.stringConnector(existingPartsAndInventoriesNameList, dot + item.inventoryData.name, '\n');
					} else if (partTableDetail.newItemIndexList.indexOf(index) != -1) {
						newPartsAndInventoriesNameList = GeneralTools.stringConnector(newPartsAndInventoriesNameList, dot + item.inventoryData.name + splitNewItemTag, '\n');
					}
				}
			});

			var existingLaborNameList = '';
			var newLaborNameList = '';

			vm.laborList.forEach(function (item, index) {
				if (!item || !item.laborData) {
					return;
				}

				if (laborTableDetail.existingLaborIdList.indexOf(item.laborData.id_labor) != -1) {
					existingLaborNameList = GeneralTools.stringConnector(existingLaborNameList, dot + item.laborData.name, '\n');
				} else if (laborTableDetail.newLaborIndexList.indexOf(index) != -1) {
					newLaborNameList = GeneralTools.stringConnector(newLaborNameList, dot + item.laborData.name + splitNewItemTag, '\n');
				}
			});

			var existingMiscfeesNameList = '';
			var newgMiscfeesNameList = '';

			vm.MiscFeesList.forEach(function (item, index) {
				if (!item || !item.MiscFees) {
					return;
				}

				if (miscfeesTableDetail.existingMiscfeesIdList.indexOf(item.MiscFees.id_misc_fees) != -1) {
					existingMiscfeesNameList = GeneralTools.stringConnector(existingMiscfeesNameList, dot + item.MiscFees.name, '\n');
				} else if (miscfeesTableDetail.newMiscfeesIndexList.indexOf(index) != -1) {
					newgMiscfeesNameList = GeneralTools.stringConnector(newgMiscfeesNameList, dot + item.MiscFees.name + splitNewItemTag, '\n');
				}
			});

			var confirmMessage = splitConfirmMessage;

			if (existingPartsAndInventoriesNameList || newPartsAndInventoriesNameList) {
				confirmMessage = GeneralTools.stringConnector(confirmMessage, splitPartsMessage, '\n\n');
				confirmMessage = GeneralTools.stringConnector(confirmMessage, existingPartsAndInventoriesNameList, '\n');
				confirmMessage = GeneralTools.stringConnector(confirmMessage, newPartsAndInventoriesNameList, '\n');
			}

			if (existingLaborNameList || newLaborNameList) {
				confirmMessage = GeneralTools.stringConnector(confirmMessage, splitLaborMessage, '\n\n');
				confirmMessage = GeneralTools.stringConnector(confirmMessage, existingLaborNameList, '\n');
				confirmMessage = GeneralTools.stringConnector(confirmMessage, newLaborNameList, '\n');
			}

			if (existingMiscfeesNameList || newgMiscfeesNameList) {
				confirmMessage = GeneralTools.stringConnector(confirmMessage, splitMiscfeesMessage, '\n\n');
				confirmMessage = GeneralTools.stringConnector(confirmMessage, existingMiscfeesNameList, '\n');
				confirmMessage = GeneralTools.stringConnector(confirmMessage, newgMiscfeesNameList, '\n');
			}

			return confirmMessage;
		}

		function onPresetJobAdd(presetJob) {
			if (!presetJob) {
				return;
			}

			var isInventoryAdded = false;

			if (presetJob.partsMap) {
				Object.keys(presetJob.partsMap).forEach(function (partTypeID) {
					if (!Array.isArray(presetJob.partsMap[partTypeID])) {
						return;
					}

					presetJob.partsMap[partTypeID].forEach(function (item) {
						if (!item || !item.isSelected) {
							return;
						}

						const partTableItem = new PartTableItem();

						if (item.partData) {
							const dataCopy = angular.copy(item.partData);
							partTableItem.setPartData(dataCopy);
						}

						if (item.inventoryData) {
							const dataCopy = angular.copy(item.inventoryData);
							partTableItem.setInventoryData(dataCopy);
							isInventoryAdded = true;
						}

						vm.partList.push(partTableItem);
					});
				});
			}

			if (Array.isArray(presetJob.labors)) {
				presetJob.labors.forEach(function (item) {
					if (!item || !item.isSelected) {
						return;
					}

					const dataCopy = angular.copy(item.laborData);
					vm.laborList.push({ laborData: dataCopy });
				});
			}

			if (isInventoryAdded) {
				refreshDemandMap();
			}
		}
		
		function onPresetJobTypeAdd(presetJob) {
			//var defer = $q.defer();
			if (!presetJob) {
				return
			}

			onPresetJobTypeAddCallBack(presetJob).then(function(result){
				return savePartLabourAndMiscFeeOnJobAdd(presetJob.id_job)
			})
			.then(function(){
			})
		}

		function onPresetJobTypeAddCallBack(presetJob){
			var defer = $q.defer();
			if (!presetJob) {
				return
			}

			$q.all([]).then(function(){
				
				if (presetJob.job_part) {
					presetJob.job_part.forEach(function (item) {
					if (!item || !item.isSelected) {
						return
					}
		
					var part = new WorkOrderPart()
					var partFoundFromRecent = false
					var recentpartQueryParam = {
						vehicleID: $stateParams.vehicleID,
						partType: item.fk_id_parttype
					}
		
					// check if part added to this vehicle from part table and inventory table, if so add from it
					$q.all({
						recentPartFromPart: VehicleService.getMostRecentParts(companyID, recentpartQueryParam),
						recentPartFromInventory: VehicleService.getMostRecentPartsFromInventory(companyID, recentpartQueryParam)
					}).then(function (result) {
						if (!result) {
						return $q.reject('Failed to init recent part, common part data invalid.')
						}
		
						var isInventoryAdded = false;
						result.recentPartFromInventory.forEach(function (inventoryItem) {
						partFoundFromRecent = true
						part.setAttributes({
							name: inventoryItem.inventory.name,
							fk_id_part_type: inventoryItem.inventory.fk_id_part_type,
							quantity: inventoryItem.mostFrequentQuantity,
							retail_price: inventoryItem.inventory.retail_price,
							code: inventoryItem.inventory.code,
							fk_id_inventory: inventoryItem.inventory.id_inventory,
							addingFromJob: true
						})
						isInventoryAdded = true
						})
		
						if (!partFoundFromRecent) {
						result.recentPartFromPart.forEach(function (partItem) {
							partFoundFromRecent = true
							part.setAttributes({
							name: partItem.part.name,
							fk_id_part_type: partItem.part.fk_id_part_type,
							quantity: partItem.mostFrequentQuantity,
							retail_price: partItem.part.retail_price,
							code: partItem.part.code,
							addingFromJob: true
							})
						})
						}
		
						// add part from default part type
						if (!partFoundFromRecent) {
						part.setAttributes({
							name: item.part_name,
							fk_id_part_type: item.fk_id_parttype,
							quantity: +item.part_quantity,
							retail_price: 10,
							code: item.part_code,
							addingFromJob: true
						})
		
						vm.partTypes.forEach(function (parttype) {
							if (parttype.id_part_type == +item.fk_id_parttype) {
							part.retail_price = parttype.default_retail
							}
						})
						}
		
						const partTableItem = new PartTableItem()
						if (item) {
						const dataCopy = angular.copy(part)
							if(isInventoryAdded){
								partTableItem.setInventoryData(dataCopy)
							}else{
								partTableItem.setPartData(dataCopy)
							}
						}

						//setInventoryData
		
						vm.partList.push(partTableItem)
					})
					})


				}
		
				if (presetJob.job_labour) {
					presetJob.job_labour.forEach(function (item) {
					if (!item || !item.isSelected) {
						return
					}
					
					
					var recentlabourQueryParam = {
						vehicleID: $stateParams.vehicleID,
						labourType: item.fk_id_labourtype
					}
					$q.all({recentLabour: VehicleService.getMostRecentLabour(companyID, recentlabourQueryParam)})
						.then(function (result) {
						if (!result) {
							return $q.reject('Failed to init recent labor, common misc fee data invalid.')
						}
						var labourFoundFromRecent = false
						var labor = new Labor()
						// result.recentLabour.forEach(function (labouritem) {
						// 	labourFoundFromRecent = true
						// 	labor.setAttributes({
						// 	name: labouritem.labour.name,
						// 	hour: +labouritem.mostFrequentQuantity,
						// 	fk_id_labour_type: labouritem.labour.fk_id_labour_type,
						// 	price: labouritem.labour.price,
						// 	id_labour_type: +labouritem.labour.fk_id_labour_type,
						// 	addingFromJob: true
						// 	})
						// })

						if (!labourFoundFromRecent) {
							labor.setAttributes({
								name: item.labour_name,
								hour: +item.labour_quantity,
								fk_id_labour_type: +item.fk_id_labourtype,
								price: null,
								addingFromJob: true
							})
							vm.labourlist.forEach(function (labour) {
								if (labour.id_labour_type == +item.fk_id_labourtype) {
									labor.price = labour.default_rate
								}
							})
							}
							const dataCopy = angular.copy(labor)
							vm.laborList.push({ laborData: dataCopy })
						})
					})
				}
		
				if (presetJob.job_miscfee) {
					presetJob.job_miscfee.forEach(function (item) {
					if (!item || !item.isSelected) {
						return
					}
		
					var miscfeeFoundFromRecent = false
					var recentmiscfeeQueryParam = {
						vehicleID: $stateParams.vehicleID,
						miscfeeType: item.fk_id_miscfeestype
					}
					var MiscFees = {}
		
					$q.all({
						recentMiscfee: VehicleService.getMostRecentMiscfee(companyID, recentmiscfeeQueryParam)
					}).then(function (result) {
						if (!result) {
						return $q.reject('Failed to init recent misc fee, common misc fee data invalid.')
						}
		
		
						result.recentMiscfee.forEach(function (item) {
						miscfeeFoundFromRecent = true
						MiscFees = {
							MiscFees: {
							name: item.miscfee.name,
							quantity: item.mostFrequentQuantity,
							fk_misc_fees_type: item.miscfee.fk_misc_fees_type,
							price: item.miscfee.price,
							addingFromJob: true
							}
						}
						})
		
						if (!miscfeeFoundFromRecent) {
						MiscFees = {
							MiscFees: {
							name: item.miscfees_name,
							quantity: +item.miscfees_quantity,
							fk_misc_fees_type: +item.fk_id_miscfeestype,
							price: +item.default_retail_price,
							addingFromJob: true
							}
						}
						vm.allmiscfeestypeslist.forEach(function (miscfeestypes) {
							if (miscfeestypes.fk_id_miscfeestype == +item.fk_id_miscfeestype) {
							MiscFees.MiscFees.price = miscfeestypes.default_retail_price
							}
						})
						}
						vm.MiscFeesList.push(MiscFees)
						
					})
					})
				}

				const resourcePath = { 
					companyID: LoginService.getCompanyID(),
					vehicleID: $stateParams.vehicleID,
					workorderID: $stateParams.workOrderID
				};

				$q.all({
					recentMiscfee: WorkOrderService.getWorkOrderJob(resourcePath).$promise.catch(MessageService.showToast)
				}).then(function(result){
					defer.resolve(result.recentMiscfee);
				})

			  })

			  return defer.promise;
			  
		}

		function redeemSalePackageItem(salePackage, packageItem) {
			vm.isRedeeming = true;
			DialogService.showYesOrNoDialog(null, "Are you sure to redeem: " + packageItem.name)
				.then(function (isYes) {
					if (!isYes) {
						return $q.reject();
					}

					const resourcePath = {
						companyID: companyID,
						vehicleID: $stateParams.vehicleID,
						saleinfoID: salePackage.fk_id_sale_info,
						packageID: salePackage.id_sale_package,
						packageitemID: packageItem.id_sale_package_item,
						workorderID: vm.workOrder.id_work_order,
						currentmileage: vm.vehicle.mileage,
					};
					return SaleInfoService.redeemSalePackageItem(resourcePath).$promise;
				})
				.then(function () {
					if (vm.availableItems
						&& vm.availableItems[salePackage.id_sale_package]
						&& Array.isArray(vm.availableItems[salePackage.id_sale_package].packageItems)) {

						vm.availableItems[salePackage.id_sale_package].packageItems.find(function (item) {
							if (item && item.id_sale_package_item == packageItem.id_sale_package_item) {
								item.quantity--;
								return true;
							}
						});

						MessageService.showToast("Item is redeemed.")
					}

				})
				.catch(function (error) {
					if (error) {
						MessageService.showToast(error);
					}
				})
				.finally(function () {
					vm.isRedeeming = false;
				});
		}

		//given a jobtype. extract the discount form it's part/misc/labour
		function redeemPackageDiscount(coverage_job) {
			var discount_str = ""
			var totaDiscount = 0;
			var totalPartDiscount = 0;
			var totalLaborDiscount = 0;
			var totalMiscfeeDiscount = 0;
			var partList_temp = [];
			var laborList_temp = [];
			var miscfeeList_temp = [];

			//copy and clear the from the current part list
			vm.partList.forEach(function (part) {

				if (partList_temp.length == 0) {
					const foundparttypename = vm.partTypes.find(function (parttype) {
						if (+parttype.id_part_type === part.type) {
							return parttype
						}
					});
					partList_temp.push({
						part_type: part.type,
						part_type_total: part.retailPrice * part.quantity,
						part_type_total_quantity: parseFloat(part.quantity),
						part_type_name: (foundparttypename ? foundparttypename.name : part.name)
					})
				} else {
					var foundmatch = false
					partList_temp.forEach(function (temp_part) {
						if (part.type == temp_part.part_type) {
							foundmatch = true
							temp_part.part_type_total += part.retailPrice * part.quantity,
								temp_part.part_type_total_quantity += parseFloat(part.quantity)
						}
					})

					if (!foundmatch) {
						const foundparttypename = vm.partTypes.find(function (parttype) {
							if (+parttype.id_part_type === part.type) {
								return parttype
							}
						});
						partList_temp.push({
							part_type: part.type,
							part_type_total: part.retailPrice * part.quantity,
							part_type_total_quantity: parseFloat(part.quantity),
							part_type_name: (foundparttypename ? foundparttypename.name : part.name)
						})
					}
				}
			})
			//copy and clear the from the current labor list
			vm.laborList.forEach(function (labor) {
				if (laborList_temp.length == 0) {

					const foundlabourtypename = vm.labourlist.find(function (labourtype) {
						if (+labourtype.id_labour_type === labor.laborData.fk_id_labour_type) {
							return labourtype
						}
					});

					laborList_temp.push({
						labor_type: labor.laborData.fk_id_labour_type,
						labor_type_total: +labor.laborData.price * +labor.laborData.hour,
						labor_type_total_hour: +labor.laborData.hour,
						labor_type_name: (foundlabourtypename ? foundlabourtypename.labour_name : "None")
					})
				} else {
					var foundmatch = false
					laborList_temp.forEach(function (temp_labor) {
						if (labor.laborData.fk_id_labour_type == temp_labor.labor_type) {
							foundmatch = true
							temp_labor.labor_type_total += +labor.laborData.price * +labor.laborData.hour,
								temp_labor.labor_type_total_hour += +labor.laborData.hour
						}
					})

					if (!foundmatch) {

						const foundlabourtypename = vm.labourlist.find(function (labourtype) {
							if (+labourtype.id_labour_type === labor.laborData.fk_id_labour_type) {
								return labourtype
							}
						});

						laborList_temp.push({
							labor_type: labor.laborData.fk_id_labour_type,
							labor_type_total: +labor.laborData.price * +labor.laborData.hour,
							labor_type_total_hour: +labor.laborData.hour,
							labor_type_name: (foundlabourtypename ? foundlabourtypename.labour_name : "None")
						})
					}
				}
			})
			//copy and clear the from the current misc fee list
			vm.MiscFeesList.forEach(function (miscfee) {
				if (miscfeeList_temp.length == 0) {
					const foundmiscfeetypename = vm.allmiscfeestypeslist.find(function (miscfeetype) {
						if (+miscfeetype.id_miscfee === miscfee.MiscFees.fk_misc_fees_type) {
							return miscfeetype
						}
					});
					miscfeeList_temp.push({
						miscfee_type: miscfee.MiscFees.fk_misc_fees_type,
						miscfee_type_total: +miscfee.MiscFees.price * +miscfee.MiscFees.quantity,
						miscfee_type_total_quantity: +miscfee.MiscFees.quantity,
						misfee_type_name: (foundmiscfeetypename ? foundmiscfeetypename.name : "None")
					})
				} else {
					var foundmatch = false
					miscfeeList_temp.forEach(function (temp_miscfee) {
						if (miscfee.MiscFees.fk_misc_fees_type == temp_miscfee.miscfee_type) {
							foundmatch = true
							temp_miscfee.miscfee_type_total += +miscfee.MiscFees.price * +miscfee.MiscFees.quantity,
								temp_miscfee.miscfee_type_total_quantity += +miscfee.MiscFees.quantity
						}
					})

					if (!foundmatch) {

						const foundmiscfeetypename = vm.allmiscfeestypeslist.find(function (miscfeetype) {
							if (+miscfeetype.id_miscfee === miscfee.MiscFees.fk_misc_fees_type) {
								return miscfeetype
							}
						});

						miscfeeList_temp.push({
							miscfee_type: miscfee.MiscFees.fk_misc_fees_type,
							miscfee_type_total: +miscfee.MiscFees.price * +miscfee.MiscFees.quantity,
							miscfee_type_total_quantity: +miscfee.MiscFees.quantity,
							misfee_type_name: (foundmiscfeetypename ? foundmiscfeetypename.name : "None")
						})
					}
				}
			})

			if (coverage_job.length > 0) {
				coverage_job.forEach(function (job) {
					if (job && job.JobType) {
						//iterate through coverage part and calculate the part coverage
						if (job.JobType.job_part.length > 0) {
							job.JobType.job_part.forEach(function (part) {
								const partTypeToFind = +part.fk_id_parttype;
								const foundPart = partList_temp.find(function (part) {
									if (+part.part_type === partTypeToFind) {
										return part
									}
								});
								if (foundPart) {
									if (parseFloat(foundPart.part_type_total_quantity) >= parseFloat(part.part_quantity)) {
										// check if the coverage is greater than the total, if so only discount the total part
										if (parseFloat((+part.part_coverage)) <= parseFloat(foundPart.part_type_total)) {

											totalPartDiscount += parseFloat((+part.part_coverage))
											discount_str += foundPart.part_type_name + " Reduction: $" + parseFloat((+part.part_coverage)) + ".\n"
											foundPart.part_type_total -= parseFloat((+part.part_coverage))


										} else {

											totalPartDiscount += parseFloat((foundPart.part_type_total))
											discount_str += foundPart.part_type_name + " Reduction: $" + parseFloat((foundPart.part_type_total)) + ".\n"
											foundPart.part_type_total = 0


										}
										foundPart.part_type_total_quantity -= parseFloat((+part.part_quantity))

									} else {
										// case we only cover partial of the part cost
										var percentageofquantity = parseFloat((+foundPart.part_type_total_quantity / +part.part_quantity));
										if (parseFloat((+part.part_coverage * percentageofquantity)) <= foundPart.part_type_total) {

											totalPartDiscount += + parseFloat((+part.part_coverage * percentageofquantity));
											foundPart.part_type_total -= parseFloat((+part.part_coverage * percentageofquantity));
											discount_str += foundPart.part_type_name + " Reduction: $" + parseFloat((+part.part_coverage * percentageofquantity)) + ".\n"
										} else {

											totalPartDiscount += parseFloat(foundPart.part_type_total)
											foundPart.part_type_total = 0
											discount_str +=foundPart.part_type_name + " Reduction: $" + parseFloat(foundPart.part_type_total) + ".\n"
										}
										foundPart.part_type_total_quantity -= parseFloat((+part.part_quantity))
									}

								}
							})

						}
						//discount_str += "Total Discount from Part: " + totalPartDiscount + ".\n\n"
						//iterate through coverage labour and calculate the labour coverage
						if (job.JobType.job_labour.length > 0) {
							job.JobType.job_labour.forEach(function (labour) {
								const labourTypeToFind = +labour.fk_id_labourtype;
								const foundlabour = laborList_temp.find(function (labour) {
									if (+labour.labor_type === labourTypeToFind) {
										return labour
									}
								});

								if (foundlabour) {

									if (parseFloat(foundlabour.labor_type_total_hour) >= parseFloat(labour.labour_quantity)) {
										if (parseFloat((labour.labour_coverage)) <= parseFloat(foundlabour.labor_type_total)) {


											totalLaborDiscount += parseFloat(labour.labour_coverage)
											discount_str += foundlabour.labor_type_name + " Reduction: $" + parseFloat(labour.labour_coverage) + ".\n"
											foundlabour.labor_type_total -= parseFloat(labour.labour_coverage)


										} else {


											totalLaborDiscount += parseFloat(foundlabour.labor_type_total)
											discount_str += foundlabour.labor_type_name + " Reduction: $" + parseFloat(foundlabour.labor_type_total) + ".\n"
											foundlabour.labor_type_total = 0


										}
										foundlabour.labor_type_total_hour -= parseFloat((labour.labour_quantity))
									} else {
										var percentageofquantity = parseFloat((parseFloat(foundlabour.labor_type_total_hour) / parseFloat(labour.labour_quantity)));
										if (parseFloat((+labour.labour_coverage * percentageofquantity)) <= parseFloat(foundlabour.labor_type_total)) {


											totalLaborDiscount += parseFloat(parseFloat(labour.labour_coverage) * parseFloat(percentageofquantity));
											discount_str += foundlabour.labor_type_name + " Reduction: $" + parseFloat(parseFloat(labour.labour_coverage) * parseFloat(percentageofquantity)) + ".\n"
											foundlabour.labor_type_total -= parseFloat((parseFloat(labour.labour_coverage) * parseFloat(percentageofquantity)));


										} else {


											totalLaborDiscount += parseFloat(foundlabour.labor_type_total)
											discount_str += foundlabour.labor_type_name + " Reduction: $" + parseFloat(foundlabour.labor_type_total) + ".\n"
											foundlabour.labor_type_total = 0


										}
										foundlabour.labor_type_total_hour -= parseFloat((labour.labour_quantity))
									}
								}
							})
						}
						//discount_str += "Total Discount from Labor: " + totalLaborDiscount + ".\n\n"
						//iterate through coverage miscfee and calculate the miscfee coverage
						if (job.JobType.job_miscfee.length > 0) {
							job.JobType.job_miscfee.forEach(function (miscfee) {

								const miscfeeTypeToFind = +miscfee.fk_id_miscfeestype;
								const foundmiscfee = miscfeeList_temp.find(function (miscfee) {
									if (+miscfee.miscfee_type === miscfeeTypeToFind) {
										return miscfee
									}
								});

								if (foundmiscfee) {

									if (parseFloat(foundmiscfee.miscfee_type_total_quantity) >= parseFloat(miscfee.miscfees_quantity)) {
										if (parseFloat((miscfee.miscfees_coverage)) <= parseFloat(foundmiscfee.miscfee_type_total)) {


											totalMiscfeeDiscount += parseFloat(miscfee.miscfees_coverage)
											discount_str += foundmiscfee.misfee_type_name + " Reduction: $" + parseFloat(miscfee.miscfees_coverage) + ".\n"
											foundmiscfee.miscfee_type_total -= parseFloat(miscfee.miscfees_coverage)


										} else {


											totalMiscfeeDiscount += parseFloat(foundmiscfee.miscfee_type_total)
											discount_str += foundmiscfee.misfee_type_name + " Reduction: $" + parseFloat(foundmiscfee.miscfee_type_total) + ".\n"
											foundmiscfee.miscfee_type_total = 0


										}
										foundmiscfee.miscfee_type_total_quantity -= parseFloat((miscfee.miscfees_quantity))
									} else {
										var percentageofquantity = parseFloat((parseFloat(foundmiscfee.miscfee_type_total_quantity) / parseFloat(miscfee.miscfees_quantity)));
										if (parseFloat((+miscfee.miscfees_coverage * percentageofquantity)) <= parseFloat(foundmiscfee.miscfee_type_total)) {


											totalMiscfeeDiscount += parseFloat(parseFloat(miscfee.miscfees_coverage) * parseFloat(percentageofquantity));
											discount_str += foundmiscfee.misfee_type_name + " Reduction: $" + parseFloat(parseFloat(miscfee.miscfees_coverage) * parseFloat(percentageofquantity)) + ".\n"
											foundmiscfee.miscfee_type_total -= parseFloat((parseFloat(miscfee.miscfees_coverage) * parseFloat(percentageofquantity)));


										} else {


											totalMiscfeeDiscount += parseFloat(foundmiscfee.miscfee_type_total)
											discount_str += foundmiscfee.misfee_type_name + " Reduction: $" + parseFloat(foundmiscfee.miscfee_type_total) + ".\n"
											foundmiscfee.miscfee_type_total = 0


										}
										foundmiscfee.miscfee_type_total_quantity -= parseFloat((miscfee.miscfees_quantity))
									}
								}
							})
						}
					}
					//discount_str += "Total Discount from Misc fee: " + totalMiscfeeDiscount + ".\n\n"
				})

			}

			totaDiscount = parseFloat((parseFloat(totalPartDiscount) + parseFloat(totalLaborDiscount) + parseFloat(totalMiscfeeDiscount)).toFixed(2))
			discount_str += "Total Discount: $" + totaDiscount + ".\n"


			return {
				discount: totaDiscount,
				discount_str: discount_str
			}
		}

		function redeemwithoutDiscount(workorderPackage, packageItem) {
			vm.isRedeeming = true;

			const resourcePath = {
				companyID: companyID,
				vehicleID: $stateParams.vehicleID,
				packageID: workorderPackage.id_work_order_package,
				packageitemID: packageItem.id_work_order_package_item,
				workorderID: workorderPackage.fk_id_work_order,
				currentmileage: vm.vehicle.mileage,
				workOrderRequestFrom: $stateParams.workOrderID
			};
			WorkOrderService.redeemWorkOrderPackageItem(resourcePath).$promise.then(function () {
				if (vm.availableWorkOrderItems
					&& vm.availableWorkOrderItems[workorderPackage.id_work_order_package]
					&& Array.isArray(vm.availableWorkOrderItems[workorderPackage.id_work_order_package].packageItems)) {
					vm.availableWorkOrderItems[workorderPackage.id_work_order_package].packageItems.find(function (item) {
						if (item && item.id_work_order_package_item == packageItem.id_work_order_package_item) {
							item.quantity--;
							return true;
						}
					});

					MessageService.showToast("Item is redeemed.")
				}

			})
				.catch(function (error) {
					if (error) {
						MessageService.showToast(error);
					}
				})
				.finally(function () {
					vm.isRedeeming = false;
				});

		}

		function redeemwithDiscount(workorderPackage, packageItem, discount_amount) {
			vm.isRedeeming = true;
			const discount = new WorkOrderDiscount();

			discount.description = "Package Redeem Discount ID: " + packageItem.name;
			discount.is_percentage = false;
			discount.amount_off = GeneralTools.preciseNumber(discount_amount, 2);

			//addDiscount(discount)
			
			const resourcePath = {
				companyID: companyID,
				vehicleID: $stateParams.vehicleID,
				packageID: workorderPackage.id_work_order_package,
				packageitemID: packageItem.id_work_order_package_item,
				workorderID: workorderPackage.fk_id_work_order,
				currentmileage: vm.vehicle.mileage,
				workOrderRequestFrom: $stateParams.workOrderID
			};

			addDiscount(discount).then(function(){
				WorkOrderService.redeemWorkOrderPackageItem(resourcePath).$promise.then(function () {
					if (vm.availableWorkOrderItems
						&& vm.availableWorkOrderItems[workorderPackage.id_work_order_package]
						&& Array.isArray(vm.availableWorkOrderItems[workorderPackage.id_work_order_package].packageItems)) {
						vm.availableWorkOrderItems[workorderPackage.id_work_order_package].packageItems.find(function (item) {
							if (item && item.id_work_order_package_item == packageItem.id_work_order_package_item) {
								item.quantity--;
								return true;
							}
						});
	
						MessageService.showToast("Item is redeemed.")
					}
	
				})
					.catch(function (error) {
						if (error) {
							MessageService.showToast(error);
						}
					})
					.finally(function () {
						vm.isRedeeming = false;
					});
			})
		}

		function optionRedeemWorkOrderPackageItem(workorderPackage, packageItem) {

			//find corresponding package item job from preset package
			var selectedPackageItem;
			var coverage_job = [];

			if (packageItem && packageItem.fk_id_preset_package_item) {
				vm.presetPackages.forEach(function (presentpackage) {
					if (presentpackage.items && presentpackage.items.length > 0) {
						presentpackage.items.forEach(function (presentpackageitem) {
							if (presentpackageitem.id_preset_package_item == packageItem.fk_id_preset_package_item) {
								selectedPackageItem = angular.copy(presentpackageitem)
							}
						})
					}
				})

			}



			var temp;
			if(selectedPackageItem.coverage_json != null){
				temp = [
					{
						JobType: 
						{
							job_labour: selectedPackageItem.coverage_json.job_labour,
							job_miscfee: selectedPackageItem.coverage_json.job_miscfee,
							job_part: selectedPackageItem.coverage_json.job_part,
						}
					}
				]
			}

			
			if (temp) {
				var resultA = redeemPackageDiscount(temp);
			}


			// if (selectedPackageItem && selectedPackageItem.fk_id_job) {
			// 	coverage_job.push(vm.JobTypeList.find(function (job) {
			// 		if (job.JobType.id_job === selectedPackageItem.fk_id_job) {
			// 			return job
			// 		}
			// 	}))


			// 	if (coverage_job) {
			// 		var resultA = redeemPackageDiscount(coverage_job);
			// 	}
			// }

			var packageNameStr = "Are you sure to redeem: " + packageItem.name

			if(resultA == undefined || resultA.discount <= 0){
				redeemWorkOrderPackageItem(workorderPackage, packageItem)
			}else{


				if (resultA && resultA.discount_str && resultA.discount > 0) {
					packageNameStr = packageNameStr + "\nThis redemption contain the following: \n" + resultA.discount_str
				}
	
	
				var dialogOptions = {};
	
				dialogOptions.titleString = "Redeeming Package";
				dialogOptions.contentString = "";
				dialogOptions.contentString += packageNameStr;
				var confirmOption = {};
	
				confirmOption.optionName = "Yes, with reduction";
				confirmOption.onClick = function () {

					if(resultA && resultA.discount > 0){
						redeemwithDiscount(workorderPackage, packageItem, resultA.discount)
					}else{
						redeemwithDiscount(workorderPackage, packageItem, 0)
					}


					
					DialogService.close();
				}
	
				var cancelOption = {};
				cancelOption.optionName = "NO";
				cancelOption.onClick = function () {
					DialogService.close();
				}
	
				var maybeOption = {};
				maybeOption.optionName = "Yes without reduction";
				maybeOption.onClick = function () {
					redeemwithoutDiscount(workorderPackage, packageItem)
					
					DialogService.close();
				}
	
				dialogOptions.options = [confirmOption, maybeOption, cancelOption];
	
				DialogService.showOptionsDialog(dialogOptions);
			}
		}

		function redeemWorkOrderPackageItem(workorderPackage, packageItem) {
			vm.isRedeeming = true;

			DialogService.showYesOrNoDialog(null, "Are you sure to redeem: " + packageItem.name + ", there is currently no items or fees to be redeemed?")
				.then(function (isYes) {
					if (!isYes) {
						return $q.reject();
					}

					const resourcePath = {
						companyID: companyID,
						vehicleID: $stateParams.vehicleID,
						packageID: workorderPackage.id_work_order_package,
						packageitemID: packageItem.id_work_order_package_item,
						workorderID: workorderPackage.fk_id_work_order,
						currentmileage: vm.vehicle.mileage,
						workOrderRequestFrom: $stateParams.workOrderID
					};
					return WorkOrderService.redeemWorkOrderPackageItem(resourcePath).$promise;
				})
				.then(function () {
					if (vm.availableWorkOrderItems
						&& vm.availableWorkOrderItems[workorderPackage.id_work_order_package]
						&& Array.isArray(vm.availableWorkOrderItems[workorderPackage.id_work_order_package].packageItems)) {
						vm.availableWorkOrderItems[workorderPackage.id_work_order_package].packageItems.find(function (item) {
							if (item && item.id_work_order_package_item == packageItem.id_work_order_package_item) {
								item.quantity--;
								return true;
							}
						});

						MessageService.showToast("Item is redeemed.")
					}

				})
				.catch(function (error) {
					if (error) {
						MessageService.showToast(error);
					}
				})
				.finally(function () {
					vm.isRedeeming = false;
				});
		}

		function initPresetPackages() {
			if(!Array.isArray(presetPackages)){
				return
			}else{
				vm.presetPackages = presetPackages;
			}
		}

		function initSalePackages() {
			const resourcePath = {
				companyID: companyID,
				vehicleID: $stateParams.vehicleID,
				saleinfoID: vm.saleInfo.id_sale_info
			};
			SaleInfoService.getSalePackages(resourcePath).$promise.then(function (salePackages) {
				if (!Array.isArray(salePackages)) {
					return $q.reject("salePackages is invalid");
				}
				vm.salePackages = salePackages;

				salePackages.forEach(function (salePackage) {
					fecthSalePackageItems(salePackage.id_sale_package)
				});
			})
				.catch(MessageService.showToast);
		}

		function initWorkOrderPackages() {

			const workOrderPackageList = WorkOrderDataSharingService.getWorkOrderPackageList();

			if (!Array.isArray(workOrderPackageList)) {
				return;
			}

			vm.workorderPackages = [];

			vm.workorderPackages = angular.copy(workOrderPackageList)

			vm.workorderPackages.forEach(function (workorderPackage) {
				fecthWorkOrderPackageItems(workorderPackage.id_work_order_package)
			});
		}

		function fecthWorkOrderPackageItems(workorderpackageID) {
			const resourcePath = {
				companyID: companyID,
				vehicleID: $stateParams.vehicleID,
				workorderID: $stateParams.workOrderID,
				packageID: workorderpackageID
			};

			WorkOrderService.getWorkOrderpackageItems(resourcePath).$promise.then(function (items) {
				vm.workOrderPackageItemsMap[workorderpackageID] = items;
			})
				.catch(MessageService.showToast);
		}

		function fecthSalePackageItems(packageID) {
			const resourcePath = {
				companyID: companyID,
				vehicleID: $stateParams.vehicleID,
				saleinfoID: vm.saleInfo.id_sale_info,
				packageID: packageID
			};

			SaleInfoService.getSalePackageItems(resourcePath).$promise.then(function (items) {
				vm.packageItemsMap[packageID] = items;
			})
				.catch(MessageService.showToast);
		}

		function addWorkOrderPackage(presetPackage) {
			vm.isAddingPackages = true;

			const resourcePath = {
				companyID: companyID,
				vehicleID: $stateParams.vehicleID,
				workorderID: $stateParams.workOrderID
			}

			const workorderPackage = new WorkOrderPackage();
			workorderPackage.pullDataFromPresetPackage(presetPackage);


			return WorkOrderService.createWorkOrderPackage(resourcePath, workorderPackage).$promise
				.then(function (workOrderPackageID) {
					workorderPackage.id_work_order_package = workOrderPackageID;
					vm.workorderPackages.push(workorderPackage);
					vm.packageItemsMap[workOrderPackageID] = [];
					WorkOrderDataSharingService.setWorkOrderPackageList(vm.workorderPackages);
					presetPackage.items.forEach(function (item) {
						vm.packageItemsMap[workOrderPackageID].push({
							name: item.name,
							quantity: item.quantity,
							origin_quantity: item.quantity,
							fk_id_preset_package_item: item.id_preset_package_item
						});
					});
				})
				.catch(MessageService.showToast)
				.finally(function () {
					vm.isAddingPackages = false;
				});
		}

		function deleteWorkOrderPackage(workorderPackage, presetPackage) {
			vm.isDeletingPackage = true;
			const newWorkorderPackage = new WorkOrderPackage();
			newWorkorderPackage.pullDataFromPresetPackage(presetPackage)
			var dialogPromise = $q.resolve(true);
			if (!workorderPackage.getExpiryDateMomentObj().isSame(newWorkorderPackage.getExpiryDateMomentObj()) || (presetPackage.valid_mileage && workorderPackage.expiry_mileage && presetPackage.valid_mileage != 0 && (workorderPackage.expiry_mileage - vm.vehicle.mileage - presetPackage.valid_mileage) != 0)) {
				dialogPromise = DialogService.showYesOrNoDialog("Unselect Package", "Unselecting this package will result in resetting the expiry date and covering mileage if you choose to add it again.")
			}

			return dialogPromise
				.then(function (isYes) {
					if (isYes) {
						const resourcePath = {
							companyID: companyID,
							vehicleID: $stateParams.vehicleID,
							workorderID: $stateParams.workOrderID,
							packageID: workorderPackage.id_work_order_package
						}
						return WorkOrderService.deleteWorkOrderPackage(resourcePath).$promise;
					}

					return $q.reject();
				})
				.then(function () {
					const index = vm.workorderPackages.findIndex(function (item) {
						return !!item && item.id_work_order_package == workorderPackage.id_work_order_package;
					});
					vm.workorderPackages.splice(index, 1);
					WorkOrderDataSharingService.setWorkOrderPackageList(vm.workorderPackages);
				})

				.catch(function (error) {
					if (error) {
						MessageService.showToast(error);
					}
				})
				.finally(function () {
					vm.isDeletingPackage = false;
				});
		}

		function onSendClientRegistrationEmail() {
			vm.sendingRegistrationEmail = true
			if (!vm.customerRegistrationTempHolder) {
				MessageService.showToast("Please choose the designated customer associated with this vehicle.");
				return
			}

			if (!vm.clientEmailAddressHolder) {
				MessageService.showToast("The Reciver email address could not be empty.");
				return
			}

			const resourcePath = {
				companyID: companyID,
				vehicleID: $stateParams.vehicleID,
				customerVehicleID: $stateParams.vehicleID,
			}
			const requestBody = {
				userID: userInfo.userID,
				workorderID: $stateParams.workOrderID,
				customerEmailAddress: vm.clientEmailAddressHolder,
				id_customer: vm.customerRegistrationTempHolder.customerInfo.id_customer

			}
			

			return WorkOrderService.sendCustomerRegistrationEmail(resourcePath, requestBody)
			.then(function(result) {
			  initCustomerInfo();
			})
			.catch(function(error) {
			  MessageService.showToast(error);
			})
			.finally(function() {
			  setTimeout(function() {
				vm.sendingRegistrationEmail = false;
				MessageService.showToast("Success.");
			  }, 3000);
			});

		}

		function getWorkOrderWarrantyRequestBodys() {
			const workOrderWarrantyToCreate = [];
			const workOrderWarrantyToUpdate = [];



			if (!Array.isArray(vm.workorderWarranty)) {
				return;
			}

			vm.workorderWarranty.forEach(function (item, index) {
				if (!item) {
					return;
				}

				if (!item.id_work_order_warranty) {
					workOrderWarrantyToCreate.push({
						index: index,
						requestBody: item
					});
					return;
				}

				const changedProperties = getUpdateWorkOrderWarrantyRequestBody(item);
				if (!!changedProperties) {
					workOrderWarrantyToUpdate.push({
						requestBody: changedProperties,
						id_work_order_warranty: item.id_work_order_warranty
					});
				}
			});

			if (workOrderWarrantyToCreate.length <= 0 && workOrderWarrantyToUpdate.length <= 0) {
				return;
			}
			return {
				workOrderWarrantyToCreate: workOrderWarrantyToCreate,
				workOrderWarrantyToUpdate: workOrderWarrantyToUpdate
			}
		}

		function getUpdateWorkOrderWarrantyRequestBody(workOrderWarranty) {

			const originWorkOrderWarrantyList = WorkOrderDataSharingService.getWorkOrderWarrantyList();

			if (!workOrderWarranty || !workOrderWarranty.id_work_order_warranty) {
				return;
			}

			if (!Array.isArray(originWorkOrderWarrantyList)) {
				return;
			}

			const originWorkOrderWarranty = originWorkOrderWarrantyList.find(function (item) {
				if (!item) {
					return;
				}

				return item.id_work_order_warranty == workOrderWarranty.id_work_order_warranty;
			});

			if (!originWorkOrderWarranty) {
				return;
			}

			const changedProperties = GeneralTools.updateResourceRequestBodyGenerator(workOrderWarranty, originWorkOrderWarranty);
			if (!!changedProperties) {
				return changedProperties;
			}
		}


		function saveWorkOrderWarranty(requestBody) {
			if (!requestBody) {
				return;
			}

			return $q.all([createWorkOrderWarrantyHelper(requestBody.workOrderWarrantyToCreate), updateWorkOrderWarranty(requestBody.workOrderWarrantyToUpdate)])
				.then(function () {
					resetOriginWorkOrderWarrantyList();
					return $q.resolve();
				});
		}

		function createWorkOrderWarrantyHelper(requestBodyList) {
			if (!Array.isArray(requestBodyList)) {
				return $q.reject("createWorkOrderWarranty requestBodyList invalid");
			}

			const queue = [];
			requestBodyList.forEach(function (item) {
				if (!item) {
					return;
				}

				queue.push(createWorkOrderWarranty(item.requestBody, item.index));
			});

			return $q.all(queue);
		}

		function createWorkOrderWarranty(requestBody, index) {
			const resourcePath = {
				companyID: companyID,
				vehicleID: $stateParams.vehicleID,
				workorderID: $stateParams.workOrderID,
			}
			return WorkOrderService.createWorkOrderWarranty(resourcePath, requestBody)
				.then(function (newWorkOrderWarrantyId) {
					if (Array.isArray(vm.workorderWarranty) && vm.workorderWarranty[index] && vm.workorderWarranty[index].$$hashKey) {
						vm.workorderWarranty[index].id_work_order_warranty = newWorkOrderWarrantyId;
					}
					return $q.resolve();
				})
		}

		function updateWorkOrderWarranty(requestBodyList) {
			if (!Array.isArray(requestBodyList)) {
				return $q.reject("updateWorkOrderWarranty requestBodyList invalid");
			}

			const queue = [];

			requestBodyList.forEach(function (item) {
				if (!item) {
					return;
				}
				const resourcePath = {
					companyID: companyID,
					vehicleID: $stateParams.vehicleID,
					workorderID: $stateParams.workOrderID,
					warrantyID: item.id_work_order_warranty
				}

				queue.push(WorkOrderService.updateWorkOrderWarranty(resourcePath, item));
			});

			return $q.all(queue);
		}

		function resetOriginWorkOrderWarrantyList() {
			const workOrderWarrantyList = [];

			if (!Array.isArray(vm.workorderWarranty)) {
				return;
			}
			vm.workorderWarranty.forEach(function (item) {
				if (item) {
					workOrderWarrantyList.push(item);
				}
			});
			WorkOrderDataSharingService.setWorkOrderWarrantyList(workOrderWarrantyList);
		}

		function saveWorkOrderWarrantyButtonClick() {
			vm.isSaving = true;
			console.log("on Warranty Save Clicked")
			saveWorkOrderWarrantyButtonClickHandler().then(function () {
				MessageService.showToast("Success.")
			})
				.catch(MessageService.showToast)
				.finally(function () {
					vm.isSaving = false;
				});

		}

		function saveWorkOrderWarrantyButtonClickHandler() {
			if (!vm.isInfoFormValid()) {
				return $q.reject("Something wrong in info form.");
			}

			if (vm.isWarrntySectionValid && !vm.isWarrntySectionValid()) {
				return $q.reject(warrantyTableInvalidMessage);
			}

			const queue = [];

			const workOrderWarrantyRequestBody = getWorkOrderWarrantyRequestBodys();

			if (workOrderWarrantyRequestBody) {
				queue.push(saveWorkOrderWarranty(workOrderWarrantyRequestBody));
			}
			if (queue.length <= 0) {
				return $q.reject("No changes detected.");
			}

			return $q.all(queue);
		}

		vm.check = check;
		function check(){
		}

		function checkGivenIdisFromWorkOrderJob(workOrderJob, Id, itemTypeId){
			if(workOrderJob.length <= 0){
				return false
			}
			var match = false
			workOrderJob.forEach(function(workOrderJobItem){
				if(workOrderJobItem.work_order_job_json.length > 0){
					workOrderJobItem.work_order_job_json.forEach(function(work_order_job_json_item){
						if(parseInt(work_order_job_json_item.fk_id_item) == parseInt(Id) && parseInt(work_order_job_json_item.fk_id_work_order_job_item_type) == parseInt(itemTypeId)){
							match =  true
						}
					})
				}
			})
			return match
		};

		function getGivenItemIdAssociatedWorkOrderJobID(workOrderJob, Id, itemTypeId){
			if(workOrderJob.length <= 0){
				return undefined
			}
			var workOrderId = undefined;
			workOrderJob.forEach(function(workOrderJobItem){
				if(workOrderJobItem.work_order_job_json.length > 0){
					workOrderJobItem.work_order_job_json.forEach(function(work_order_job_json_item){
						if(parseInt(work_order_job_json_item.fk_id_item) == parseInt(Id) && parseInt(work_order_job_json_item.fk_id_work_order_job_item_type) == parseInt(itemTypeId)){
							workOrderId = workOrderJobItem.id_work_order_job
						}
					})
				}
			})

			return workOrderId
		};

		function getAllItemsUnderWorkOrderJobID(workOrderJobId){
			if(vm.workOrderJobList.length <= 0){
				return []
			}
			var workOrderItems = [];
			var targetWorkOrderJob;



			vm.workOrderJobList.forEach(function(workOrderJobItem){
				if(workOrderJobItem.work_order_job_json.length > 0){
					if(workOrderJobItem.id_work_order_job == workOrderJobId){
						targetWorkOrderJob = workOrderJobItem.work_order_job_json
					}
				}
			})

			var foundAllItems = true
			var matchPartsList = []
			var matchInvensList = []
			var matchLaboursList = []
			var matchMiscfeeList = []
			if(targetWorkOrderJob.length > 0){
				targetWorkOrderJob.forEach(function(workOrderJobItemJson){
					var foundMatchtems = false
					if(workOrderJobItemJson.fk_id_item){
						switch (workOrderJobItemJson.fk_id_work_order_job_item_type){
							case '1':
								vm.partList.forEach(function (item) {
									if (!!item.partData && !!item.partData.id_work_order_part && (parseInt(workOrderJobItemJson.fk_id_item) == item.partData.id_work_order_part)) {
										matchPartsList.push(item.partData);
										foundMatchtems = true;
									}
								});
								
								break
							case '2':
								vm.partList.forEach(function (item) {
									if (!!item.inventoryData && !!item.inventoryData.id_work_order_inventory && (parseInt(workOrderJobItemJson.fk_id_item) == item.inventoryData.id_work_order_inventory)) {
										matchInvensList.push(item.inventoryData);
										foundMatchtems = true;
									}
								});
								break
							case '3':
								vm.MiscFeesList.forEach(function(item){
									if (!!item.MiscFees && !!item.MiscFees.id_misc_fees && (parseInt(workOrderJobItemJson.fk_id_item) == item.MiscFees.id_misc_fees)) {
										matchMiscfeeList.push(item.MiscFees);
										foundMatchtems = true;
									}
								})
								foundMatchtems = true;
								break
							case '4':
								vm.laborList.forEach(function(item){
									if (!!item.laborData && !!item.laborData.id_labor && (parseInt(workOrderJobItemJson.fk_id_item) == item.laborData.id_labor)) {
										matchLaboursList.push(item.laborData);
										foundMatchtems = true;
									}
								})
								foundMatchtems = true;
								break
						}


						if(!foundMatchtems){
							foundAllItems = false
						}
					}

				})
			}

			return {
					matchingPartsList: matchPartsList,
					matchingInvensList: matchInvensList,
					matchingLaboursList: matchLaboursList,
					matchingMiscfeeList: matchMiscfeeList
			}
			
		};

		function constructWarningMessageBaseOnWorkOrderJobItems(workOrderJobItems){
			var text = ""
			if(!workOrderJobItems){
				return undefined
			}

			if(workOrderJobItems.matchingInvensList.length > 0){
				workOrderJobItems.matchingInvensList.forEach(function(item){
					text += "Inventory: " + item.name + " *(" + item.quantity + ") \n"
				})
			}

			if(workOrderJobItems.matchingPartsList.length > 0){
				workOrderJobItems.matchingPartsList.forEach(function(item){
					text += "Part: " + item.name + " *(" + item.quantity + ") \n"
				})
			}

			if(workOrderJobItems.matchingLaboursList.length > 0){
				workOrderJobItems.matchingLaboursList.forEach(function(item){
					text += "Labour: " + item.name + " *(" + item.hour + ") \n"
				})
			}

			if(workOrderJobItems.matchingMiscfeeList.length > 0){
				workOrderJobItems.matchingMiscfeeList.forEach(function(item){
					text += "Misc Fee: " + item.name + " *(" + item.quantity + ") \n"
				})
			}
			return text

		}

		function deleteWorkOrderJobById(workOrderJobId){
			const resourcePath = { 
				companyID: LoginService.getCompanyID(),
				vehicleID: $stateParams.vehicleID,
				workorderID: $stateParams.workOrderID,
				workorderjobID: workOrderJobId
			};

			return WorkOrderService.deleteWorkOrderJob(resourcePath)
				.then(function (deletedWorkOrderJobId) {
					const index = vm.MiscFeesList.findIndex(function (item) {
						return !!item && item.id_work_order_job == deletedWorkOrderJobId;
					});

					vm.workOrderJobList.splice(index, 1);
					checkIfWorkOrderJobValidForPackageRedeem()
					WorkOrderDataSharingService.setworkOrderJobList(vm.workOrderJobList);
					
					return $q.resolve();
				});
		}

		function initWorkOrderJobItemColorCache(){
			if(vm.workOrderJobList && vm.workOrderJobList.length > 0){
				vm.workOrderJobList.forEach(function(workOrderJobItem){
					vm.colorCache[workOrderJobItem.id_work_order_job] = generateRGBAStyle(workOrderJobItem.id_work_order_job)
			})
		}
		}

		function generateRGBAStyle(number) {
			var red = Math.floor(Math.random() * 256);
			var green = Math.floor(Math.random() * 256);
			var blue = Math.floor(Math.random() * 256);
			red = (red + number) % 256;
			green = (green + number) % 256;
			blue = (blue + number) % 256;
			var rgbaStyle = "rgba(" + red + ", " + green + ", " + blue + ", " + 0.1 + ")";
			return rgbaStyle
		}

		function checkIfWorkOrderJobValidForPackageRedeem(){

			if(!vm.workOrderJobList || vm.workOrderJobList.length == 0){
				vm.containRedeemableJobItem = false
				return
			}

			if((!vm.availableWorkOrderItems || vm.availableWorkOrderItems.length <= 0) && (!vm.availableItems || vm.availableItems.length <= 0)){
				vm.containRedeemableJobItem = false
				return
			}


			var jobList = []
			//extract all the job id from the work order job list
			if(vm.workOrderJobList && vm.workOrderJobList.length >= 1){
				vm.workOrderJobList.forEach(function(item){
					jobList.push(item.fk_id_job_type)
				})
			}

			var presentPackageItemId = []
			if(vm.availableWorkOrderItems && vm.availableWorkOrderItems.length > 0){
				vm.availableWorkOrderItems.forEach(function(item){
					if(item && item.packageItems.length > 0){
						item.packageItems.forEach(function(packageitem){
							presentPackageItemId.push(packageitem.fk_id_preset_package_item)
						})
					}
				})
			}

			if(vm.availableItems && vm.availableItems.length > 0){
				vm.availableItems.forEach(function(item){
					if(item && item.packageItems.length > 0){
						item.packageItems.forEach(function(packageitem){
							presentPackageItemId.push(packageitem.fk_id_preset_package_item)
						})
					}
				})
			}

			var correspondingJobIdList = []
			if(vm.presetPackages && vm.presetPackages.length > 0){
				vm.presetPackages.forEach(function(item){
					if(item && item.items.length > 0){
						item.items.forEach(function(packageitem){
							if(presentPackageItemId.includes(packageitem.id_preset_package_item)){
								correspondingJobIdList.push(packageitem.fk_id_job)
							}
						})
					}
				})
			}

			jobList.forEach(function(job){
				if(correspondingJobIdList.includes(job)){
					vm.containRedeemableJobItem = true
					DialogService.showWarningDialog("Work order job scanned.", "Possible redeemable package has been found", "Got it")
					return
				}else{
					vm.containRedeemableJobItem = false
				}
			})
		}

		vm.onPDFEmailCustomerChange  = function(){
			if(vm.customerRegistrationTempHolder){
				if(vm.customerRegistrationTempHolder.customerInfo && vm.customerRegistrationTempHolder.customerInfo.emails && vm.customerRegistrationTempHolder.customerInfo.emails.length >= 1){
					vm.clientEmailAddressHolder =vm.customerRegistrationTempHolder.customerInfo.emails[0].email_address
				}
			}
		}

		vm.getPDFFromWorkOrder = function() {

			const workOrderPrint = new WorkOrderPrint($stateParams.vehicleID, $stateParams.workOrderID, vm.customerRegistrationTempHolder.customerInfo.id_customer, vm.isQuoted);

			vm.isPrinting = true;

			WorkorderUnsavedChangesHelper.checkAll()
				.then(function (result) {
					if (!Array.isArray(result)) {
						return $q.reject("Failed to check unsaved changes");
					}


					const hasUnsavedChanges = result.find(function (hasUnsavedChange) {

						return hasUnsavedChange
					});

					if (hasUnsavedChanges) {
						return DialogService.showYesOrNoDialog(null, unsavedChangeWarning, saveAndContinueStr, ignoreAndContinueStr);
					}

					return $q.resolve();
				})
				.then(function (isSavingChanges) {
					if (isSavingChanges) {
						return WorkorderUnsavedChangesHelper.saveAll();
					}

					return $q.resolve();
				})
				.then(function () {
					return workOrderPrint.fetchDatas();
				})
				.then(function () {
					return workOrderPrint.getPdfDocDefinition().then(function(result){
						var emaildata = {
							customerID: vm.customerRegistrationTempHolder.customerInfo.id_customer,
							customer_name: vm.customerRegistrationTempHolder.customerInfo.first_name + " " + vm.customerRegistrationTempHolder.customerInfo.last_name,
							pdf_data: result,
							is_quoted: vm.isQuoted,
							email_address: vm.clientEmailAddressHolder,
							invoice_number: vm.workOrder.invoice_number
						}

						const resourcePath = {
							companyID: companyID,
							vehicleID: $stateParams.vehicleID,
							workorderID: $stateParams.workOrderID
						}
			
						// return WorkOrderService.sendWorkOrderPDFEmail(resourcePath, emaildata)
						// 	.then(function () {
						// 		return $q.resolve();
						// 	});



					});
				})
				.catch(function (error) {
					if (error) {
						MessageService.showToast(error);
					}
				})
				.finally(function () {
					setTimeout(function() {
						vm.isPrinting = false;
						MessageService.showToast("Work Order PDF Email Send.");
					  }, 3000);
				});
		}

		vm.checkPartRetailPricevalid = function(partList){
			var newshowRetailPriceError = false
			partList.forEach(function(part){
				if(part && part.cost && part.cost > 0){

					if(part.retailPrice && part.retailPrice > 0 && Number((part.cost * vm.defaultRetailPercentadge + part.cost).toFixed(2)) > part.retailPrice){
						
						newshowRetailPriceError = true
					}else if(!part.retailPrice || part.retailPrice == 0){
						newshowRetailPriceError = true
					}
				}
			});
			vm.showRetailPriceError = newshowRetailPriceError
		}

		vm.checkPartCostevalid = function(partList){
			var newshowCostError = false
			partList.forEach(function(part){
				if(part && (!part.cost && part.cost <= 0)){
					newshowCostError = true
				}
			});
			vm.showCostError = newshowCostError
		}
	}
})();
(function ()
{
	'use strict';

	angular
		.module('app.workOrders')
		.controller('EditWorkOrderFilesController', EditWorkOrderFilesController);

	function EditWorkOrderFilesController(FileUploadService, files, DialogService, LoginService, $scope, MessageService, WorkOrderService, $stateParams, WorkOrderConstants){
		const vm = this;
		const companyID = LoginService.getCompanyID();

		vm.fileUploader = FileUploadService.getNewUploader();
		vm.fileUploader.filters.push(FileUploadService.getSizeFilter(20));
		vm.onFileDelete = onFileDelete;

		init();

		function init(){
			initFiles();
		}

		function initFiles(){
			if(Array.isArray(files)){
				vm.files = files;
			} else {
				vm.files = [];
			}
		}

		vm.fileUploader.onAfterAddingFile = function(fileItem){
			fileItem.url = FileUploadService.getUrlForCreateWorkOrderFile($stateParams.vehicleID, $stateParams.workOrderID);
			fileItem.upload();
		}

		vm.fileUploader.onCompleteItem = function(item, response, status, headers){
			if(!FileUploadService.isUploadSuccess(headers)){
				MessageService.showToast(headers.message);
				return;
			}

			var resourcePath = {
				companyID: companyID,
				vehicleID: $stateParams.vehicleID,
				workorderID: $stateParams.workOrderID,
				fileID: response.data
			}

			WorkOrderService.getFiles(resourcePath)
				.then(function(files){
					if(!Array.isArray(files)){
						return $q.reject("Work order file data is invalid.");
					}
					vm.files.push(files[0]);
					item.remove();
				})
				.catch(MessageService.showToast);
		}

		function onFileDelete(uploadedFile, index){
			const dialogOptions = {};

			dialogOptions.titleString = "Delete File";
			dialogOptions.contentString = "Are you sure to delete " + uploadedFile.file_name + '?';

			const confirmOption = {};

			confirmOption.optionName = "YES";
			confirmOption.onClick = function(){
				confirmDeleteFileCallback(uploadedFile, index);
				DialogService.close();
			}

			var cancelOption = {};

			cancelOption.optionName = "NO";
			cancelOption.onClick = function(){
				DialogService.close();
			}

			dialogOptions.options = [confirmOption, cancelOption];

			DialogService.showOptionsDialog(dialogOptions);

		}

		function confirmDeleteFileCallback(uploadedFile, index){
			var resourcePath = {
				companyID: companyID,
				vehicleID: $stateParams.vehicleID,
				workorderID: $stateParams.workOrderID,
				fileID: uploadedFile.id_work_order_file
			}
			
			vm.isDeletingFile = true;

			WorkOrderService.deleteFile(resourcePath)
				.then(function(){
					vm.files.splice(index, 1)
				})
				.catch(MessageService.showToast)
				.finally(function(){
					vm.isDeletingFile = false;
				})
		}
	}
})();
(function () {
	'use strict';

	angular
		.module('app.workOrders')
		.controller('EditWorkOrderExtraController', EditWorkOrderExtraController);


	function EditWorkOrderExtraController(Part, miscfeestypes, PresetPackagesService, $location, LabourService,CustomersService, AppointmentConstants, AppointmentsService, workOrderCustomerPortalAppointments, customerserviceMap, WorkOrderRDGenerated, customersaleInfos, LoginConst, ProgressService, WorkOrderPackage, WorkOrderWarranty, PresetPackageConstants, SaleInfoService, Labor, VehicleService, WorkOrder, WorkorderUnsavedChangesHelper, sharedConstants, WorkOrderDataSharingService, appointments, $mdDialog, $rootScope, WorkOrderDiscount, PartConstants, WorkOrderInventory, ToolsConstants, WorkOrderPart, PartTableItem, InventoryConstants, ReturnInvoiceService, PurchaseInvoiceService, constants, InventoryService, GeneralTools, $q, $stateParams, DialogService, RoleCheckService, vehicle, $state, $scope, WorkOrderConstants, mechanics, WorkOrderMechanic, LoginService, WorkOrderService, MessageService, miscfeestypesService) {
		const vm = this;

		const dot = "\u25cf";
		const controllerName = "EditWorkOrderExtraController";
		const userInfo = LoginService.getUserInfo();
		const companyID = LoginService.getCompanyID();

		const partTableInvalidMessage = "Something wrong in part table.";
		const warrantyTableInvalidMessage = "Something wrong in warranty section.";
		const laborTableInvalidMessage = "Something wrong in labor table.";
		const miscfeeTableInvalidMessage = "Something wrong in misc fee table.";
		const splitNewItemTag = "(NEW)";
		const splitConfirmMessageTitle = "Split Work Order Confirmation";
		const splitConfirmMessage = "Items will be moved to a new workorder.";
		const splitPartsMessage = "Parts:";
		const splitLaborMessage = "Labors:";
		const splitMiscfeesMessage = "Misc fees:"
		const missingMileageWarning = "Complete this workorder without mileage?"
		const missingMechanicWarning = "Complete this workorder without a supervising licensed technician?"
		const unsavedChangeWarning = "This page has unsaved content."
		const completeWorkOrderWarning = "Save inventory items and complete?"
		const saveAndContinueStr = "save & continue";
		const ignoreAndContinueStr = "ignore & continue";
		const frontBrakePresetJobTitle = "Front Brake";
		const frontBrakePadPartName = "Front Brake Pads";
		const frontBrakeRotorPartName = "Front Brake Rotor";
		const frontBrakeLaborName = "Replace Front Brake";
		const rearBrakePresetJobTitle = "Rear Brake";
		const rearBrakePadPartName = "Rear Brake Pads";
		const rearBrakeRotorPartName = "Rear Brake Rotor";
		const rearBrakeLaborName = "Replace Rear Brake";
		const rustProofUnderBodyTitle = "Rust Proof Under Body"
		const rustProofUnderBodyPrice = 139;
		const rustProofCompleteTitle = "Rust Proof Complete"
		const rustProofCompletePrice = 199;
		const installFourTiresTitle = "Install 4 Tires"
		const installFourTiresPrice = 100;
		const generatingRogerDollarA = "After completing this work order, customer will receive $"
		const generatingRogerDollarB = " worth of Rogers Dollars that cannot be altered. \nIf you don't want Rogers Dollars to be generated, uncheck the checkbox before completing the work order."
		const vehicleID = $stateParams.vehicleID;

		const partsFromPresetJob = {};
		const laborsFromPresetJob = {};
		vm.packageItemsMap = {};
		vm.workOrderPackageItemsMap = {};
		vm.clientEmailAddressHolder = "";

		var isIgnoringUnsavedChanges = false;
		var showSensitiveContent;

		vm.generalAnchorTag = WorkOrderConstants.anchorTags.general;
		vm.partsAnchorTag = WorkOrderConstants.anchorTags.parts;
		vm.laborsAnchorTag = WorkOrderConstants.anchorTags.labors;
		vm.miscfeesAnchorTag = WorkOrderConstants.anchorTags.miscfees;
		vm.packagesAnchorTag = WorkOrderConstants.anchorTags.packages;
		vm.warrantyAnchorTag = WorkOrderConstants.anchorTags.warranty;
		vm.warrantyCollapseSectionID = "WARRANTY";
		vm.sectionOptions = {
			warranty: {
				name: "Warranty",
				id: vm.warrantyCollapseSectionID
			}
		};
		vm.addAppointmentUrl = $state.href("app.workorder-schedule", { workOrderID: $stateParams.workOrderID, vehicleID: $stateParams.vehicleID });
		vm.appointmentsTabUrl = $state.href("app.edit-workorder.appointments", { workOrderID: $stateParams.workOrderID, vehicleID: $stateParams.vehicleID });
		vm.percentageTransaletor = percentageTransaletor;
		vm.translateToDollar = GeneralTools.inputTranslators.dollar;
		vm.translateToPercentage = GeneralTools.inputTranslators.percentage;
		vm.percentageInputOption = {
			decimalFractionSize: 0,
			maxValue: 100
		};



		// Workorder
		vm.onStatusClick = onStatusClick;
		vm.splitWorkorder = splitWorkorder;
		vm.onPresetJobAdd = onPresetJobAdd;
		vm.onPresetJobTypeAdd = onPresetJobTypeAdd;

		// Mechanic
		vm.isMechanic = RoleCheckService.checkRole(["mechanic", "mechanic_apprentice"]);
		vm.isAssignedToMechanic = isAssignedToMechanic;
		vm.isAssignedToMe = isAssignedToMe;
		vm.assignWorkOrderToMe = assignWorkOrderToMe;
		vm.addMechanic = addMechanic;
		vm.removeMechanic = removeMechanic;
		vm.addWorkOrderPackage = addWorkOrderPackage;
		vm.deleteWorkOrderPackage = deleteWorkOrderPackage;
		vm.onSendClientRegistrationEmail = onSendClientRegistrationEmail;
		vm.saleInfo;
		vm.initNewWorkOrderWarranty = initNewWorkOrderWarranty;
		vm.removeWorkOrderWarranty = removeWorkOrderWarranty;
		vm.getWorkOrderWarrantyRequestBodys = getWorkOrderWarrantyRequestBodys;
		vm.getLaborsRequestBodys = getLaborsRequestBodys;
		vm.optionRedeemWorkOrderPackageItem = optionRedeemWorkOrderPackageItem;
		const userID = LoginService.getUserID();
		vm.labourlist = [];
		LabourService.getLabour({
			companyID: companyID,
			userID: userID
		}).then(function (result) {
			for (var i = 0; i < result.length; i++) {

				vm.labourlist.push(result[i])
			}
		});

		vm.allmiscfeestypeslist = [];
		miscfeestypesService.getMiscFeesTypes({
			companyID: companyID,
			userID: userID,
			vehicleID: 0,
			workorderID: 0
		}).then(function (result) {
			for (var i = 0; i < result.length; i++) {
				vm.allmiscfeestypeslist.push(result[i])
			}
		});



		// Part table
		const partTableTabAll = {
			name: "all",
			title: "All",
			rowClass: getRowClass
		};
		const partTableTabNotOrdered = {
			name: "notOrdered",
			title: "NOT ORDERED",
			filter: isPartNotOrdered,
			tabClass: getNotOrderTabClass,
			rowClass: getRowClass
		};
		const partTableTabOrdered = {
			name: "ordered",
			title: "ORDERED",
			tabClass: getOrderedTabClass,
			rowClass: getRowClass,
			filter: isPartOrdered
		};
		const partTableTabReturned = {
			name: "returned",
			title: "RETURNED",
			filter: isPartReturned,
			rowClass: getRowClass
		};

		var convertedParts = {};
		vm.partTableTabs = [
			partTableTabAll,
			partTableTabNotOrdered,
			partTableTabOrdered,
			partTableTabReturned
		];

		vm.customerRegistrationTempHolder;
		vm.matchedInventories = {};
		vm.partList = [];
		vm.invoiceMap = {};
		vm.returnInvoiceMap = {};
		vm.addPart = addPart;
		vm.refreshDemandMap = refreshDemandMap;
		vm.onConvertPartToInventory = onConvertPartToInventory;
		vm.onPartTableTabChange = onPartTableTabChange;
		vm.isAnyPartSelectedInCurrentTab = isAnyPartSelectedInCurrentTab;
		vm.removeSelectedParts = removeSelectedParts;
		vm.saveWorkOrderWarrantyButtonClick = saveWorkOrderWarrantyButtonClick;
		vm.updateUpcomingCustomerPortalAppontmentStatus = updateUpcomingCustomerPortalAppontmentStatus;
		
		// Labors
		vm.isAnyLaborSelected = isAnyLaborSelected;
		vm.removeSelectedLabors = removeSelectedLabors;

		// Discounts
		vm.addDiscountOnParts = addDiscountOnParts;
		vm.addDiscountOnLabors = addDiscountOnLabors;

		//Miscfees
		vm.isAnyMiscfeesSelected = isAnyMiscfeesSelected
		vm.removeSelectedMiscfees = removeSelectedMiscfees;

		// Appointments
		vm.updateUpcomingAppontmentStatus = updateUpcomingAppontmentStatus;

		vm.completedStatusID = WorkOrderConstants.statusIDs.completed;
		vm.onSaveClick = onSaveClick;
		vm.redeemSalePackageItem = redeemSalePackageItem;
		vm.redeemWorkOrderPackageItem = redeemWorkOrderPackageItem;

		init();
		function init() {
			initConstants();
			initVehicle();
			vm.workOrder = WorkOrderDataSharingService.getWorkOrder();
			initUpcomingAppointment();
			initMechanics();
			initParts();
			initInventories();
			initLabors();
			initDiscounts();
			initMiscFees();
			initJobTypes();
			initWorkOrderPackages();
			initObservers();
			initListeners();
			initPresetJobs();
			initWorkOrderWarranty();
			initWarrantyOptions();
			initSensitiveContentControl();
			subscribeToUnsavedChangesHelper();
			initCustomerInfo();
			initWorkOrderRDGenerated();
		}

		//customerserviceMap, customersaleInfos
		function initCustomerInfo(){
			vm.customerList = {};
			if(!Array.isArray(customersaleInfos)){
				return;
			}

			customersaleInfos.forEach(function(saleInfo){
				if(!saleInfo || saleInfo.is_canceled){
					return;
				}

				if(!vm.customerList[saleInfo.fk_id_customer]){
					vm.customerList[saleInfo.fk_id_customer] = {};
				}

				if(!Array.isArray(vm.customerList[saleInfo.fk_id_customer].customersaleInfos)){
					vm.customerList[saleInfo.fk_id_customer].customersaleInfos = [];
				}

				vm.customerList[saleInfo.fk_id_customer].customersaleInfos.push(saleInfo);
			})

			if(!Array.isArray(customerserviceMap)){
				return;
			}

			customerserviceMap.forEach(function(item){
				if(!item || !item.customer){
					return;
				}

				if(!vm.customerList[item.customer.id_customer]){
					vm.customerList[item.customer.id_customer] = {};
				}

				vm.customerList[item.customer.id_customer].customerInfo = {
					first_name: item.customer.first_name,
					last_name: item.customer.last_name,
					id_customer: item.customer.id_customer
				}

				vm.customerList[item.customer.id_customer].customerserviceMap = item.id_service_map;
			});

			const queue = [];
			Object.keys(vm.customerList).forEach(function(customerID){
				queue.push(fetchCustomerData(customerID));
			});

			vm.fetchingCustomersData = true;

			$q.all(queue)
				.then(function(result){
					if(!Array.isArray(result)){
						return $q.reject("Customers data invalid");
					}

					result.forEach(function(customer){
						if(!customer){
							return;
						}

						if(!vm.customerList[customer.id_customer]){
							vm.customerList[customer.id_customer] = {};
						}

						vm.customerList[customer.id_customer].customerInfo = customer;
					});

					return $q.resolve()
				})
				.catch(MessageService.showToast)
				.finally(function(){
					if(!vm.workOrder.rogerdollar_generated && vm.customerList && vm.workOrder){
						for (var customerId in vm.customerList) {
							var customer = vm.customerList[customerId];
							var customerInfo = customer.customerInfo;
							vm.workOrder.selectedCustomer = customer
						  }
					}else{
						delete vm.workOrder.selectedCustomer
					}
					$location.search({}).replace();
					vm.fetchingCustomersData = false;
				});
		}

		function fetchCustomerData(customerID){
			const resourcePath = {
				companyID: companyID,
				customerID: customerID
			};

			return CustomersService.getCustomers(resourcePath)
				.then(function(result){
					if(!result || !Array.isArray(result.data) || result.data.length != 1 || !result.data[0]){
						return $q.reject("customer data invalid");
					}

					return $q.resolve(result.data[0]);
				})
		}

		function initSensitiveContentControl() {
			const pageConfig = LoginService.getPageConfigs(LoginConst.pageConfigKeys.editWorkorder);

			if (pageConfig) {
				showSensitiveContent = pageConfig.showSensitiveContent;
			} else {
				showSensitiveContent = false;
			}
		}

		function initPresetJobs() {
			if (!vm.vehicle) {
				return;
			}

			const oilPartQueryParam = {
				vehicleID: $stateParams.vehicleID,
				partType: PartConstants.partTypeIDs.OIL
			}

			const filterPartQueryParam = {
				vehicleID: $stateParams.vehicleID,
				partType: PartConstants.partTypeIDs.FILTER
			}

			$q.all({
				oils: VehicleService.getMostRecentParts(companyID, oilPartQueryParam),
				oilsFromInventory: VehicleService.getMostRecentPartsFromInventory(companyID, oilPartQueryParam),
				filters: VehicleService.getMostRecentParts(companyID, filterPartQueryParam),
				filtersFromInventory: VehicleService.getMostRecentPartsFromInventory(companyID, filterPartQueryParam),
			})
				.then(function (result) {
					if (!result) {
						return $q.reject("Failed to init preset jobs, common parts data invalid.");
					}



					vm.presetJobs = [
						buildOilChangePresetJob(
							result.oils,
							result.oilsFromInventory,
							result.filters,
							result.filtersFromInventory),
						buildBrakePresetJob(false),
						buildBrakePresetJob(true),
						buildOneLaborPresetJob(rustProofUnderBodyTitle, rustProofUnderBodyPrice),
						buildOneLaborPresetJob(rustProofCompleteTitle, rustProofCompletePrice),
						buildOneLaborPresetJob(installFourTiresTitle, installFourTiresPrice)
					];
				});
		}

		function initWorkOrderWarranty() {
			const workorderWarrantylist = WorkOrderDataSharingService.getWorkOrderWarrantyList()
			if (!Array.isArray(workorderWarrantylist)) {
				return;
			}

			vm.workorderWarranty = [];

			workorderWarrantylist.forEach(function (workorderwarranty) {
				vm.workorderWarranty.push(workorderwarranty);
			});
		}

		function initWarrantyOptions() {
			const workorderWarrantyoptions = WorkOrderDataSharingService.getWorkOrderWarrantyoptions()
			if (!Array.isArray(workorderWarrantyoptions)) {
				return;
			}
			vm.warrantyOptions = workorderWarrantyoptions;
		}

		function initNewWorkOrderWarranty() {
			vm.workorderWarranty.push(new WorkOrderWarranty());
		}

		function removeWorkOrderWarranty(warranty) {
			var dialogOptions = {};
			var index;
			dialogOptions.titleString = "Remove warranty";
			dialogOptions.contentString = "Are you sure to remove warranty from this work order?";

			var confirmOption = {};

			confirmOption.optionName = "YES";
			vm.workorderWarranty.forEach(function (warrantyitem) {
				if (warrantyitem.id_work_order_warranty == warranty.id_work_order_warranty) {
					index = vm.workorderWarranty.indexOf(warranty)
				}
			})

			confirmOption.onClick = function () {
				confirmRemoveWorkOrderWarrantyCallback(warranty, index);
				DialogService.close();
			}

			var cancelOption = {};

			cancelOption.optionName = "NO";
			cancelOption.onClick = function () {
				DialogService.close();
			}

			dialogOptions.options = [confirmOption, cancelOption];

			DialogService.showOptionsDialog(dialogOptions);
		}

		function confirmRemoveWorkOrderWarrantyCallback(warranty, index) {
			if (warranty == null) {
				return;
			}

			if (warranty.id_work_order_warranty == undefined && index != null) {
				vm.workorderWarranty.splice(index, 1);
				MessageService.showToast("Warranty is removed");
				return
			}

			var resourcePath = {
				companyID: companyID,
				vehicleID: vm.vehicle.getResourceID(),
				workorderID: $stateParams.workOrderID,
				warrantyID: warranty.id_work_order_warranty

			}

			vm.isProcessingData = true;
			ProgressService.setMode("indeterminate");
			ProgressService.isVisble(true);
			WorkOrderService.deleteWorkOrderWarranty(resourcePath).$promise
				.then(function (response) {
					vm.workorderWarranty.splice(index, 1);
					MessageService.showToast("Warranty is removed");
					return
					//return updateDefaultTasksForWarranty();
				})
				.catch(MessageService.showToast)
				.finally(function () {
					vm.isProcessingData = false;
					ProgressService.isVisble(false);
				})

			vm.isProcessingData = false;
			ProgressService.isVisble(false);
		}

		function buildOneLaborPresetJob(laborTitle, price, quantity) {
			if (!quantity) {
				quantity = 1;
			}

			const presetJob = {
				title: laborTitle,
				labors: []
			}

			const labor = new Labor();
			labor.name = laborTitle;
			labor.hour = quantity;
			labor.price = price;

			presetJob.labors.push({
				isSelected: true,
				laborData: labor
			});

			return presetJob;
		}

		function buildBrakePresetJob(isRear) {
			var title = frontBrakePresetJobTitle;
			var padsName = frontBrakePadPartName;
			var rotorsName = frontBrakeRotorPartName;
			var laborName = frontBrakeLaborName;

			if (isRear) {
				title = rearBrakePresetJobTitle;
				padsName = rearBrakePadPartName;
				rotorsName = rearBrakeRotorPartName;
				laborName = rearBrakeLaborName;
			}

			const presetJob = {
				title: title,
				partsMap: {},
				labors: []
			}

			presetJob.partsMap[PartConstants.partTypeIDs.BRAKES] = [];

			const padPart = new WorkOrderPart();

			padPart.name = padsName;
			padPart.quantity = 1;
			padPart.fk_id_part_type = PartConstants.partTypeIDs.BRAKES;

			presetJob.partsMap[PartConstants.partTypeIDs.BRAKES].push({
				isSelected: true,
				partData: padPart
			});

			const roterPart = new WorkOrderPart();

			roterPart.name = rotorsName;
			roterPart.quantity = 2;
			roterPart.fk_id_part_type = PartConstants.partTypeIDs.BRAKES;

			presetJob.partsMap[PartConstants.partTypeIDs.BRAKES].push({
				isSelected: true,
				partData: roterPart
			});

			const labor = new Labor();
			labor.name = laborName;
			labor.hour = 1.5;

			if (vm.suggestedLaborPrice) {
				labor.price = vm.suggestedLaborPrice.price;
			}

			presetJob.labors.push({
				isSelected: true,
				laborData: labor
			});

			return presetJob;
		}

		function getMostRecentParts(parts, partsFromInventory) {
			if (!Array.isArray(parts) || !Array.isArray(partsFromInventory)) {
				return;
			}

			var partsList = [];
			var inventoryList = [];

			var usedDate;
			var inventoryUsedDate;

			if (parts[0] && parts[0].usedDate) {
				usedDate = moment(parts[0].usedDate);
			}

			if (partsFromInventory[0] && partsFromInventory[0].usedDate) {
				inventoryUsedDate = moment(partsFromInventory[0].usedDate);
			}

			if (usedDate && inventoryUsedDate) {
				if (usedDate.isAfter(inventoryUsedDate)) {
					partsList = parts;
				} else if (usedDate.isBefore(inventoryUsedDate)) {
					inventoryList = partsFromInventory;
				} else {
					partsList = parts;
					inventoryList = partsFromInventory;
				}
			} else if (usedDate) {
				partsList = parts;
			} else if (inventoryUsedDate) {
				inventoryList = partsFromInventory;
			} else {
				partsList = parts;
				inventoryList = partsFromInventory;
			}

			partsList = partsList.map(function (item) {
				const part = new WorkOrderPart();

				part.setAttributes(item.part);
				part.quantity = 1;

				return { partData: part };
			});

			inventoryList = inventoryList.map(function (item) {
				const workOrderInventory = new WorkOrderInventory();

				workOrderInventory.pullDataFromInventory(item.inventory);
				workOrderInventory.quantity = item.mostFrequentQuantity;
				return { inventoryData: workOrderInventory };
			});

			return partsList.concat(inventoryList);
		}

		function buildOilChangePresetJob(oils, oilsFromInventory, filters, filtersFromInventory) {
			const partsMap = {};

			partsMap[PartConstants.partTypeIDs.OIL] = getMostRecentParts(oils, oilsFromInventory);
			partsMap[PartConstants.partTypeIDs.FILTER] = getMostRecentParts(filters, filtersFromInventory);

			for (var partTypeID in partsMap) {
				if (!Array.isArray(partsMap[partTypeID]) || partsMap[partTypeID].length <= 0) {
					partsMap[partTypeID] = [{ partData: buildDefaultOliChangePartItem(partTypeID) }]
				}

				if (partsMap[partTypeID][0]) {
					partsMap[partTypeID][0].isSelected = true;
				}
			}

			return {
				title: "Oil Change",
				partsMap: partsMap
			}
		}

		function buildDefaultOliChangePartItem(partTypeID) {
			const part = new WorkOrderPart();
			part.fk_id_part_type = partTypeID;

			switch (Number(partTypeID)) {
				case PartConstants.partTypeIDs.FILTER:
					part.name = "Filter";
					part.quantity = 1;
					break;
				case PartConstants.partTypeIDs.OIL:
					part.name = "Oil";
					break;
			}

			return part;
		}

		function subscribeToUnsavedChangesHelper() {
			WorkorderUnsavedChangesHelper.subscribe(controllerName, {
				check: function () {
					return $q.resolve(!!hasUnsavedChanges());
				},
				save: function () {
					const defer = $q.defer();

					if (hasUnsavedChanges()) {
						vm.isSaving = true;

						save().then(function () {
							defer.resolve()
						})
							.catch(defer.reject)
							.finally(function () {
								vm.isSaving = false;
							});
					} else {
						defer.resolve();
					}

					return defer.promise;
				}
			})
		}

		function initUpcomingAppointment() {
			vm.customerPortalAppointments
			if (Array.isArray(appointments)) {
				vm.totalAppointments = appointments.length;
				vm.upcomingAppointment = appointments[0];
				if (vm.upcomingAppointment) {
					vm.upcomingAppointmentUrl = $state.href("app.workorder-schedule", { goToDate: vm.upcomingAppointment.start });
				}
			}

			if(Array.isArray(workOrderCustomerPortalAppointments)){
				vm.totalAppointments = vm.totalAppointments + workOrderCustomerPortalAppointments.length;
				vm.customerPortalAppointments = workOrderCustomerPortalAppointments
				var tempAllAppointmentList = angular.copy(appointments).concat(angular.copy(vm.customerPortalAppointments))
				vm.upcomingAppointment = tempAllAppointmentList.sort(function(a, b){
					const dateA = new Date(a.start);
					const dateB = new Date(b.start);
					return dateB - dateA;
				})[0];
			}
		}

		function initDiscounts() {
			const discounts = WorkOrderDataSharingService.getDiscountList();

			if (Array.isArray(discounts)) {
				vm.discounts = discounts;
			} else {
				vm.discounts = [];
			}
		}

		function initLabors() {
			const labors = WorkOrderDataSharingService.getLaborList();
			if (!Array.isArray(labors)) {
				return;
			}

			vm.laborList = [];

			labors.forEach(function (labor) {
				vm.laborList.push({
					laborData: labor
				});
			});
		}

		function initMiscFees() {
			const MiscFees = WorkOrderDataSharingService.getMiscFeesList();


			if (!Array.isArray(MiscFees)) {
				return;
			}

			vm.MiscFeesList = [];

			MiscFees.forEach(function (MiscFees) {
				vm.MiscFeesList.push({
					MiscFees: MiscFees
				});
			});

		}

		function initJobTypes() {
			const JobType = WorkOrderDataSharingService.getJobTypeList();


			if (!Array.isArray(JobType)) {
				return;
			}

			vm.JobTypeList = [];

			JobType.forEach(function (Job) {
				vm.JobTypeList.push({
					JobType: Job
				});

			});
		}

		function initWorkOrderRDGenerated() {
			const workOrderRDGenerated = WorkOrderDataSharingService.getRDGeneratedList();
			if (!Array.isArray(workOrderRDGenerated)) {
				return;
			}

			vm.workOrderRDGeneratedList = angular.copy(workOrderRDGenerated);
		}

		function initInventories() {
			const inventories = WorkOrderDataSharingService.getInventoryList();

			if (!Array.isArray(inventories)) {
				return;
			}

			inventories.forEach(function (inventory) {
				const item = new PartTableItem();
				item.setInventoryData(inventory)
				vm.partList.push(item);
			});

			refreshDemandMap();
		}

		function initParts() {
			const parts = WorkOrderDataSharingService.getPartList();

			if (!Array.isArray(parts)) {
				return;
			}

			const invoiceIdList = [];
			const returnInvoiceIdList = [];

			parts.forEach(function (part) {
				if (!part) {
					return;
				}

				const invoiceID = part.fk_id_purchase_invoice;
				const returnInvoiceID = part.fk_id_return_invoice;

				const item = new PartTableItem();
				item.setPartData(part)
				vm.partList.push(item);

				if (!!invoiceID && invoiceIdList.indexOf(invoiceID) == -1) {
					invoiceIdList.push(invoiceID);
				}

				if (!!returnInvoiceID && returnInvoiceIdList.indexOf(returnInvoiceID) == -1) {
					returnInvoiceIdList.push(returnInvoiceID);
				}
			});

			initInvoices(invoiceIdList);
			//initReturnInvoices(returnInvoiceIdList);
			initMatchedInventories();
		}

		function initMatchedInventories() {
			if (!Array.isArray(vm.partList)) {
				return;
			}

			const queue = [];

			vm.partList.forEach(function (item) {
				if (item && item.partData) {
					queue.push(queryInventory(item.partData.code));
				}
			});
		}

		function queryInventory(code) {
			const resourcePath = { companyID: companyID };
			const filter = {
				filters: GeneralTools.equalFilterBuilder(InventoryConstants.keyNames.code, code)
			};

			return InventoryService.getInventories(resourcePath, filter)
				.then(function (result) {
					if (!result || !Array.isArray(result.data) || result.data.length > 1) {
						return $q.reject("Inventory data invalid");
					}

					const inventory = result.data[0];

					if (inventory) {
						vm.matchedInventories[inventory.code] = inventory;
					}
					return $q.resolve();
				});
		}

		function initInvoices(invoiceIdList) {
			if (!Array.isArray(invoiceIdList)) {
				return;
			}

			invoiceIdList.forEach(function (invoiceID) {
				if (!!invoiceID) {
					initInvoice(invoiceID);
				}
			});
		}

		function initInvoice(invoiceID) {
			const resourcePath = {
				companyID: companyID,
				purchaseinvoiceID: invoiceID
			}

			PurchaseInvoiceService.getPurchaseInvoices(resourcePath)
				.then(function (result) {
					if (!result || !Array.isArray(result.data) || result.data.length != 1 || !result.data[0]) {
						return $q.reject("invoice with id: " + invoiceID + " is invaild");
					}

					vm.invoiceMap[invoiceID] = result.data[0];
				});
		}

		function initReturnInvoices(invoiceIdList) {
			if (!Array.isArray(invoiceIdList)) {
				return;
			}

			invoiceIdList.forEach(function (invoiceID) {
				if (!!invoiceID) {
					initReturnInvoice(invoiceID);
				}
			});
		}

		function initReturnInvoice(invoiceID) {
			const resourcePath = {
				companyID: companyID,
				returninvoiceID: invoiceID
			}

			ReturnInvoiceService.getReturnInvoices(resourcePath)
				.then(function (result) {
					if (!result || !Array.isArray(result.data) || result.data.length != 1 || !result.data[0]) {
						return $q.reject("invoice with id: " + invoiceID + " is invaild");
					}

					vm.returnInvoiceMap[invoiceID] = result.data[0];
				});
		}

		function initConstants() {
			if (!constants) {
				MessageService.showToast("constants invalid");
				return;
			}

			vm.partTypes = constants.partTypes;
			vm.suggestedLaborPrice = constants.suggestedLaborPrice;
			vm.suppliers = constants.suppliers;
			vm.paymentMethods = constants.paymentMethods;
			vm.appointmentStatus = constants.appointmentStatus;
			vm.customerPortalAppointmentStatus = AppointmentConstants.customerPortalStatusID
			if (sharedConstants) {
				vm.workOrderPriorities = sharedConstants.workOrderPriorities;
				vm.workOrderStatus = sharedConstants.workOrderStatus;
			}
		}

		function initVehicle() {
			if (vehicle && Array.isArray(vehicle.data) && vehicle.data.length === 1 && !!vehicle.data[0]) {
				vm.vehicle = vehicle.data[0]
			}

			initPresetPackages();
			// vehicle is sold
			if (vm.vehicle.is_sold) {
				initSalePackageItems();
			}
			initCompletedWorkOrderPackageItems();
			initCompletedWorkOrderWarranty()
		}

		function initSaleWarranty(saleInfo) {
			if (!saleInfo) {
				return;
			}

			const resourcePath = {
				companyID: companyID,
				vehicleID: vehicleID,
				saleinfoID: saleInfo.id_sale_info
			}

			SaleInfoService.getSaleWarranties(resourcePath).then(function (warranties) {
				if (!Array.isArray(warranties) || !warranties[0]) {
					return;
				}

				vm.warranty = warranties[0];
				var saleMileage = 0;
				var warrantyMileage = 0;

				if (typeof (saleInfo.mileage) == "number") {
					saleMileage = saleInfo.mileage;
				}

				if (typeof (vm.warranty.duration_mileage) == "number") {
					warrantyMileage = vm.warranty.duration_mileage;
				}

				vm.totalWarrantyCoveredMileage = saleMileage + warrantyMileage;

				const saleDate = saleInfo.getSaleDateMomentObj();

				if (saleDate && saleDate.isValid() && typeof (vm.warranty.duration_month) == "number") {
					const month = saleDate.month();

					vm.warrantyExpiryDate = saleDate.month(month + vm.warranty.duration_month).format("YYYY-MM-DD");
				}
			});
		}

		function initSalePackageItems() {
			const saleInfoResourcePath = {
				companyID: companyID,
				vehicleID: $stateParams.vehicleID
			};

			var saleInfoID;

			SaleInfoService.getVehicleSaleInfos(saleInfoResourcePath)
				.then(function (saleInfos) {
					if (!Array.isArray(saleInfos) || !saleInfos[0]) {
						return $q.reject("Failed to fetch available items, sale info invalid.");
					}
					vm.saleInfo = saleInfos[0]
					initSaleWarranty(vm.saleInfo);
					initSalePackages();
					saleInfoID = saleInfos[0].id_sale_info;
					const packageResourcePath = {
						companyID: companyID,
						vehicleID: $stateParams.vehicleID,
						saleinfoID: saleInfoID
					}

					return SaleInfoService.getSalePackages(packageResourcePath).$promise;
				})
				.then(function (salePackages) {
					if (!Array.isArray(salePackages)) {
						return $q.reject("Failed to fetch available items, salePackages are invalid");
					}

					const queue = {};

					salePackages.forEach(function (salePackage) {
						if (salePackage && salePackage.isAvailable()) {
							const itemResourcePath = {
								companyID: companyID,
								vehicleID: $stateParams.vehicleID,
								saleinfoID: saleInfoID,
								packageID: salePackage.id_sale_package
							};

							queue[salePackage.id_sale_package] = $q.all({
								packageData: salePackage,
								packageItems: SaleInfoService.getSalePackageItems(itemResourcePath).$promise
							});
						}
					});

					return $q.all(queue);
				})
				.then(function (result) {
					if (!result) {
						return $q.reject("Failed to fetch available items, items are invalid");
					}

					Object.keys(result).forEach(function (packageID) {
						if (result[packageID] && Array.isArray(result[packageID].packageItems)) {
							result[packageID].packageItems = result[packageID].packageItems.filter(function (packageItem) {
								return packageItem && packageItem.quantity > 0;
							});
						}

						if (result[packageID].packageItems.length <= 0) {
							delete result[packageID];
						}
					});

					vm.availableItems = result;

				})
				.catch(MessageService.showToast);
		}

		function initCompletedWorkOrderPackageItems() {
			const resourcePath = {
				companyID: companyID,
				vehicleID: $stateParams.vehicleID,
				workorderID: $stateParams.workOrderID,
			};
			const body = {
				iscompleted: true
			}

			WorkOrderService.getWorkOrderPackages(resourcePath, body).$promise
				.then(function (workorderPackages) {
					if (!Array.isArray(workorderPackages)) {
						return $q.reject("Failed to fetch available items, workorderPackages are invalid");
					}

					const queue = {};

					workorderPackages.forEach(function (workorderPackage) {
						if (workorderPackage && workorderPackage.isAvailable()) {
							const resourcePath = {
								companyID: companyID,
								vehicleID: $stateParams.vehicleID,
								workorderID: $stateParams.workOrderID,
								packageID: workorderPackage.id_work_order_package
							};
							queue[workorderPackage.id_work_order_package] = $q.all({
								packageData: workorderPackage,
								packageItems: WorkOrderService.getWorkOrderpackageItems(resourcePath).$promise
							});
						}
					});

					return $q.all(queue);
				})
				.then(function (result) {
					if (!result) {
						return $q.reject("Failed to fetch work order available items, items are invalid");
					}

					Object.keys(result).forEach(function (packageID) {
						if (result[packageID] && Array.isArray(result[packageID].packageItems)) {
							result[packageID].packageItems = result[packageID].packageItems.filter(function (packageItem) {
								return packageItem && packageItem.quantity > 0;
							});
						}

						if (result[packageID].packageItems.length <= 0) {
							delete result[packageID];
						}
					});

					vm.availableWorkOrderItems = result;
				})
				.catch(MessageService.showToast);
		}

		function initCompletedWorkOrderWarranty() {

			const resourcePath = {
				companyID: companyID,
				vehicleID: $stateParams.vehicleID,
				workorderID: $stateParams.workOrderID,
			};

			const body = {
				iscompleted: true
			}

			WorkOrderService.getWorkOrderWarranties(resourcePath, body).$promise
				.then(function (result) {
					if (!result) {
						return $q.reject("Failed to fetch work order available warranty, warranty are invalid");
					}
					vm.completedWorkOrderWarranty = result
				})
				.catch(MessageService.showToast);
		}

		function initObservers() {
			$rootScope.$on(WorkOrderConstants.editWorkOrderEvents.scroll.eventName, function (event, tag) {
				GeneralTools.scrollToTag(tag);
			});

			$rootScope.$on(WorkOrderConstants.editWorkOrderEvents.controlSensitiveContent.eventName, function (event, _showSensitiveContent) {
				showSensitiveContent = _showSensitiveContent;
				onPartTableTabChange(vm.partTableTabs[vm.currentPartTableTabIndex]);
			});

			$scope.$on("$stateChangeStart", function (event, toState, toParams, fromState, fromParams) {
				if (!hasUnsavedChanges() || isIgnoringUnsavedChanges) {
					WorkorderUnsavedChangesHelper.unsubscribe(controllerName);
					return;
				}

				event.preventDefault();
				$rootScope.$root.loadingProgress = false;
				DialogService.showYesOrNoDialog(null, unsavedChangeWarning, saveAndContinueStr, ignoreAndContinueStr)
					.then(function (isToSaveChanges) {
						if (isToSaveChanges) {
							vm.isSaving = true;
							return save();
						}

						isIgnoringUnsavedChanges = true;
						return $q.resolve();
					})
					.then(function () {
						WorkorderUnsavedChangesHelper.unsubscribe(controllerName);
						$state.go(toState.name, toParams);
					})
					.catch(function (error) {
						if (error) {
							MessageService.showToast(error);
						}
					})
					.finally(function () {
						vm.isSaving = false;
					});
			});
		}

		function initListeners() {
			$scope.$watch("vm.workOrder", function () {
				vm.workOrder.notes = vm.workOrder.notes ? vm.workOrder.notes : null;
				vm.workOrder.mechanic_notes = vm.workOrder.mechanic_notes ? vm.workOrder.mechanic_notes : null;
				vm.workOrder.printed_notes = vm.workOrder.printed_notes ? vm.workOrder.printed_notes : null;
				vm.workOrder.ai_notes = vm.workOrder.ai_notes ? vm.workOrder.ai_notes : null;
				$scope.$emit(
					WorkOrderConstants.editWorkOrderEvents.updateSummary.eventName,
					WorkOrderConstants.editWorkOrderEvents.updateSummary.updateDetails.workOrder,
					vm.workOrder);
			}, true);

			$scope.$watch("vm.partList", function () {
				$scope.$emit(
					WorkOrderConstants.editWorkOrderEvents.updateSummary.eventName,
					WorkOrderConstants.editWorkOrderEvents.updateSummary.updateDetails.parts,
					extractPartsFromPartList());
				$scope.$emit(
					WorkOrderConstants.editWorkOrderEvents.updateSummary.eventName,
					WorkOrderConstants.editWorkOrderEvents.updateSummary.updateDetails.inventories,
					extractInventoryListFromPartList());
			}, true);

			$scope.$watch("vm.laborList", function () {
				$scope.$emit(
					WorkOrderConstants.editWorkOrderEvents.updateSummary.eventName,
					WorkOrderConstants.editWorkOrderEvents.updateSummary.updateDetails.labors,
					extractLaborsFromLaborList());
			}, true);
			$scope.$watch("vm.MiscFeesList", function () {
				$scope.$emit(
					WorkOrderConstants.editWorkOrderEvents.updateSummary.eventName,
					WorkOrderConstants.editWorkOrderEvents.updateSummary.updateDetails.miscfees,
					extractMiscfeesFromMiscfeesList());
			}, true);
			$scope.$watch("vm.workorderPackages", function () {
				$scope.$emit(
					WorkOrderConstants.editWorkOrderEvents.updateSummary.eventName,
					WorkOrderConstants.editWorkOrderEvents.updateSummary.updateDetails.workorderpackagelist,
					extractWorkOrderPackageFromWorkOrderpackageList());
			}, true);

			$scope.$watch("vm.workorderWarranty", function () {
				$scope.$emit(
					WorkOrderConstants.editWorkOrderEvents.updateSummary.eventName,
					WorkOrderConstants.editWorkOrderEvents.updateSummary.updateDetails.workorderwarrantylist,
					extractWorkOrderWarrantyFromWorkOrderwarrantyList());
			}, true);

			$scope.$watch("vm.discounts.length", function () {
				$scope.$emit(
					WorkOrderConstants.editWorkOrderEvents.updateSummary.eventName,
					WorkOrderConstants.editWorkOrderEvents.updateSummary.updateDetails.discounts,
					vm.discounts);
			});

			
			$scope.$watch("vm.workOrderRDGeneratedList", function () {
				$scope.$emit(
					WorkOrderConstants.editWorkOrderEvents.updateSummary.eventName,
					WorkOrderConstants.editWorkOrderEvents.updateSummary.updateDetails.workOrderRogerDollarGenerated,
					vm.workOrderRDGeneratedList);
			});

			$scope.$watch("vm.demandMap", function () {
				$scope.$emit(
					WorkOrderConstants.editWorkOrderEvents.updateSummary.eventName,
					WorkOrderConstants.editWorkOrderEvents.updateSummary.updateDetails.demandMap,
					vm.demandMap);
			}, true);
		}

		function initMechanics() {
			if (Array.isArray(mechanics)) {
				vm.mechanics = mechanics;
			} else {
				vm.mechanics = [];
			}
		}

		function isAssignedToMechanic() {
			var hasMechanic = false;

			if (!Array.isArray(vm.mechanics)) {
				return;
			}

			vm.mechanics.forEach(function (mechanic) {
				if (Array.isArray(mechanic.roles) && mechanic.roles.indexOf("mechanic") != -1) {
					hasMechanic = true;
				}
			});

			return hasMechanic;
		}

		function isAssignedToMe() {
			if (!Array.isArray(vm.mechanics)) {
				return;
			}

			return vm.mechanics.findIndex(function (mechanic) {
				return mechanic.id_user == userInfo.userID;
			}) != -1;
		}

		function assignWorkOrderToMe() {
			const workOrderMechanic = new WorkOrderMechanic();

			workOrderMechanic.setUser({
				id_user: userInfo.userID,
				first_name: userInfo.firstName,
				last_name: userInfo.lastName,
				roles: userInfo.roles
			});

			addMechanic(workOrderMechanic);
		}

		function addMechanic(workOrderMechanic) {
			const resourcePath = {
				companyID: companyID,
				vehicleID: $stateParams.vehicleID,
				workorderID: $stateParams.workOrderID
			};

			vm.isAddingMechanic = true;

			WorkOrderService.addMechanic(resourcePath, workOrderMechanic)
				.then(function (newMechanicID) {
					workOrderMechanic.id_work_order_mechanic = newMechanicID;

					vm.mechanics.push(workOrderMechanic);

					MessageService.showToast("Mechanic is added.");
				})
				.catch(MessageService.showToast)
				.finally(function () {
					vm.isAddingMechanic = false;
				});
		}

		function removeMechanic(mechanic, index) {
			if (!mechanic) {
				MessageService.showToast("mechanic is invalid");
				return;
			}

			var dialogOptions = {};

			dialogOptions.titleString = "Remove Mechanic";
			dialogOptions.contentString = "Are you sure to remove " + mechanic.first_name + ' ' + mechanic.last_name + '?';

			var confirmOption = {};

			confirmOption.optionName = "YES";
			confirmOption.onClick = function () {
				confirmRemoveMechanic(mechanic, index);
				DialogService.close();
			}

			var cancelOption = {};

			cancelOption.optionName = "NO";
			cancelOption.onClick = function () {
				DialogService.close();
			}

			dialogOptions.options = [confirmOption, cancelOption];

			DialogService.showOptionsDialog(dialogOptions);
		}

		function confirmRemoveMechanic(mechanic, index) {
			if (!mechanic) {
				return;
			}

			const resourcePath = {
				companyID: companyID,
				vehicleID: $stateParams.vehicleID,
				workorderID: $stateParams.workOrderID,
				mechanicID: mechanic.id_work_order_mechanic
			};

			vm.isRemovingMechanic = true;

			WorkOrderService.removeMechanic(resourcePath)
				.then(function () {
					vm.mechanics.splice(index, 1);
					MessageService.showToast("Mechanic is removed.");
				})
				.catch(MessageService.showToast)
				.finally(function () {
					vm.isRemovingMechanic = false;
				});
		}

		function resetOriginPartList() {
			const partList = [];

			if (!Array.isArray(vm.partList)) {
				return;
			}

			vm.partList.forEach(function (item) {
				if (item && item.partData) {
					partList.push(item.partData);
				}
			});

			WorkOrderDataSharingService.setPartList(partList);
		}

		function onSaveClick() {
			vm.isSaving = true;
			console.log("onSaveClick")
			save().then(function () {
				MessageService.showToast("Success.")
			})
				.catch(MessageService.showToast)
				.finally(function () {
					vm.isSaving = false;
				});

		}

		function save() {
			if (!vm.isInfoFormValid()) {
				return $q.reject("Something wrong in info form.");
			}

			if (vm.isWarrntySectionValid && !vm.isWarrntySectionValid()) {
				return $q.reject(warrantyTableInvalidMessage);
			}

			if (vm.isPartTableValid && !vm.isPartTableValid()) {
				return $q.reject(partTableInvalidMessage);
			}

			if (vm.isLaborTableValid && !vm.isLaborTableValid()) {
				return $q.reject(laborTableInvalidMessage);
			}

			if (vm.isMiscfeeTableValid && !vm.isMiscfeeTableValid()) {
				return $q.reject(miscfeeTableInvalidMessage);
			}

			const queue = [];
			if(vm.workOrder.selectedCustomer){
				delete vm.workOrder.selectedCustomer
			}
			const workOrderRequestBody = GeneralTools.updateResourceRequestBodyGenerator(vm.workOrder, WorkOrderDataSharingService.getWorkOrder());
			const partsRequestBody = getPartsRequestBodys();
			const inventoriesRequestBody = getInventoriesRequestBodys();
			const laborsRequestBody = getLaborsRequestBodys();
			const MiscFeesRequestBody = getMiscfeeRequestBodys();
			const workOrderWarrantyRequestBody = getWorkOrderWarrantyRequestBodys();

			if (workOrderRequestBody && workOrderRequestBody != undefined) {

				queue.push(updateWorkOrder(workOrderRequestBody));
			}

			if (partsRequestBody && partsRequestBody != undefined) {

				queue.push(saveParts(partsRequestBody));
			}

			if (inventoriesRequestBody && inventoriesRequestBody != undefined) {

				queue.push(saveInventories(inventoriesRequestBody));
			}

			if (laborsRequestBody && laborsRequestBody != undefined) {

				queue.push(saveLabors(laborsRequestBody));
			}

			if (MiscFeesRequestBody && MiscFeesRequestBody != undefined) {

				queue.push(saveMiscfees(MiscFeesRequestBody));
			}

			if (workOrderWarrantyRequestBody && workOrderWarrantyRequestBody != undefined) {
				queue.push(saveWorkOrderWarranty(workOrderWarrantyRequestBody));
			}

			if (queue.length <= 0) {
				return $q.reject("No changes detected.");
			}

			return $q.all(queue);
		}

		function getInventoriesRequestBodys() {
			const inventoriesToCreate = [];
			const inventoriesToUpdate = [];

			if (!Array.isArray(vm.partList)) {
				return;
			}

			vm.partList.forEach(function (item, index) {
				if (!item || !item.inventoryData) {
					return;
				}

				if (!item.inventoryData.id_work_order_inventory) {
					inventoriesToCreate.push({
						index: index,
						requestBody: item.inventoryData
					});
					return;
				}

				const changedProperties = getUpdateInventoryRequestBody(item.inventoryData);

				if (!!changedProperties) {
					inventoriesToUpdate.push({
						requestBody: changedProperties,
						inventoryID: item.inventoryData.id_work_order_inventory
					});
				}
			});

			if (inventoriesToCreate.length <= 0 && inventoriesToUpdate.length <= 0) {
				return;
			}

			return {
				inventoriesToCreate: inventoriesToCreate,
				inventoriesToUpdate: inventoriesToUpdate
			}
		}

		function getUpdateInventoryRequestBody(inventory) {
			const originInventoryList = WorkOrderDataSharingService.getInventoryList();

			if (!inventory || !inventory.id_work_order_inventory) {
				return;
			}

			if (!Array.isArray(originInventoryList)) {
				return;
			}

			const originInventory = originInventoryList.find(function (item) {
				if (!item) {
					return;
				}

				return item.id_work_order_inventory == inventory.id_work_order_inventory;
			});

			if (!originInventory) {
				return;
			}

			const changedProperties = GeneralTools.updateResourceRequestBodyGenerator(inventory, originInventory);

			if (!!changedProperties) {
				return changedProperties;
			}
		}

		function getPartsRequestBodys() {
			const originPartList = WorkOrderDataSharingService.getPartList();
			const partsToCreate = [];
			const partsToUpdate = [];
			const partsToDetele = [];

			if (!Array.isArray(vm.partList) || !Array.isArray(originPartList)) {
				return;
			}

			originPartList.forEach(function (part) {
				if (!part) {
					return;
				}

				const remainingPart = vm.partList.find(function (item) {
					return !!item && !!item.partData && item.partData.getResourceId() == part.getResourceId();
				});

				if (!remainingPart) {
					partsToDetele.push(part);
				}
			})

			vm.partList.forEach(function (item, index) {
				if (!item || !item.partData) {
					return;
				}

				if (!item.partData.id_work_order_part) {
					partsToCreate.push({
						index: index,
						requestBody: item.partData
					});
					return;
				}

				const changedProperties = getUpdatePartRequestBody(item.partData);

				if (!!changedProperties) {
					partsToUpdate.push({
						requestBody: changedProperties,
						partID: item.partData.id_work_order_part
					});
				}
			});

			if (partsToCreate.length <= 0 && partsToUpdate.length <= 0 && partsToDetele.length <= 0) {
				return;
			}

			return {
				partsToCreate: partsToCreate,
				partsToUpdate: partsToUpdate,
				partsToDetele: partsToDetele
			};
		}

		function getUpdatePartRequestBody(part) {
			const originPartList = WorkOrderDataSharingService.getPartList();

			if (!part || !part.id_work_order_part) {
				return;
			}

			if (!Array.isArray(originPartList)) {
				return;
			}

			const originPart = originPartList.find(function (item) {
				return !!item && item.id_work_order_part == part.id_work_order_part;
			});

			if (!originPart) {
				return;
			}

			const changedProperties = GeneralTools.updateResourceRequestBodyGenerator(part, originPart);

			if (!!changedProperties) {
				return changedProperties;
			}
		}

		function updateWorkOrder(requestBody) {
			const resourcePath = {
				companyID: companyID,
				vehicleID: $stateParams.vehicleID,
				workorderID: $stateParams.workOrderID
			}

			return WorkOrderService.updateWorkOrder(resourcePath, requestBody)
				.then(function () {
					WorkOrderDataSharingService.setWorkOrder(vm.workOrder);
					return $q.resolve();
				});
		}

		function addPart() {
			const part = getNewBasicPart();
			const item = new PartTableItem();

			item.setPartData(part)
			vm.partList.push(item);
		}

		function extractInventoryListFromPartList() {
			if (!Array.isArray(vm.partList)) {
				return;
			}
			const inventoryList = [];

			vm.partList.forEach(function (item) {
				if (!!item && item.inventoryData) {
					inventoryList.push(item.inventoryData)
				}
			});

			return inventoryList;
		}

		function extractPartsFromPartList() {
			if (!Array.isArray(vm.partList)) {
				return;
			}
			const parts = [];

			vm.partList.forEach(function (item) {
				if (!!item && item.partData) {
					parts.push(item.partData)
				}
			});

			return parts;
		}

		function extractLaborsFromLaborList() {
			if (!Array.isArray(vm.laborList)) {
				return;
			}
			const labors = [];

			vm.laborList.forEach(function (item) {
				if (!!item && item.laborData) {
					labors.push(item.laborData)
				}
			});

			return labors;
		}

		function extractMiscfeesFromMiscfeesList() {
			if (!Array.isArray(vm.MiscFeesList)) {
				return;
			}
			const miscfees = [];

			vm.MiscFeesList.forEach(function (item) {
				if (!!item && item.MiscFees && item.MiscFees.price && item.MiscFees.quantity && item.MiscFees.name && item.MiscFees.fk_misc_fees_type) {
					miscfees.push(item.MiscFees)
				}
			});

			return miscfees;
		}

		function extractWorkOrderPackageFromWorkOrderpackageList() {
			if (!Array.isArray(vm.workorderPackages)) {
				return;
			}
			const workorderpackages = [];
			vm.workorderPackages.forEach(function (item) {
				if (!!item && item.price && item.name && item.id_work_order_package && item.fk_id_preset_package) {
					workorderpackages.push(item)
				}
			});
			return workorderpackages;
		}

		function extractWorkOrderWarrantyFromWorkOrderwarrantyList() {
			if (!Array.isArray(vm.workorderWarranty)) {
				return;
			}
			const workorderwarranties = [];
			vm.workorderWarranty.forEach(function (item) {
				if (!!item && item.retail && item.name && item.id_work_order_warranty && item.duration_month && item.cost) {
					workorderwarranties.push(item)
				}
			});
			return workorderwarranties;
		}


		function resetOriginInventoryList() {
			const inventoryList = [];

			if (!Array.isArray(vm.partList)) {
				return;
			}

			vm.partList.forEach(function (item) {
				if (item && item.inventoryData) {
					inventoryList.push(item.inventoryData);
				}
			});

			WorkOrderDataSharingService.setInventoryList(inventoryList);
		}

		function refreshDemandMap() {
			const defer = $q.defer()
			if (!Array.isArray(vm.partList)) {
				return;
			}

			const queue = [];
			const demandMap = {};

			vm.partList.forEach(function (item) {
				if (!item || !item.inventoryData) {
					return;
				}

				if (!demandMap[item.inventoryData.fk_id_inventory]) {
					demandMap[item.inventoryData.fk_id_inventory] = {
						totalDemand: 0,
						name: item.inventoryData.name,
						code: item.inventoryData.code
					}
				}
				demandMap[item.inventoryData.fk_id_inventory].totalDemand += GeneralTools.parseNumber(item.inventoryData.quantity);
			});

			Object.keys(demandMap).forEach(function (inventoryID) {
				queue.push(fetchInventoryData(inventoryID));
			});

			$q.all(queue)
				.then(function (inventoryList) {
					inventoryList.forEach(function (inventory) {
						if (!inventory) {
							return;
						}

						if (demandMap[inventory.id_inventory]) {
							demandMap[inventory.id_inventory].totalInStock = GeneralTools.parseNumber(inventory.quantity);
						}
					});

					vm.demandMap = demandMap;
					defer.resolve(vm.demandMap);
				})
				.catch(function (error) {
					defer.reject(error);
					MessageService.showToast(error);
				});

			return defer.promise;
		}

		function fetchInventoryData(inventoryID) {
			const resourcePath = {
				companyID: companyID,
				inventoryID: inventoryID
			}

			return InventoryService.getInventories(resourcePath)
				.then(function (result) {
					if (!result || !Array.isArray(result.data) || result.data.length != 1 || !result.data[0]) {
						return $q.reject("Inventory data invalid.")
					}

					return $q.resolve(result.data[0]);
				})
		}

		function getNewBasicPart() {
			const part = new WorkOrderPart();

			part.setAttributes({
				fk_id_part_type: PartConstants.partTypeIDs.OTHER,
				purchase_tax_rate: ToolsConstants.taxRate
			});

			if (vm.partTableTabs[vm.currentPartTableTabIndex]) {
				switch (vm.partTableTabs[vm.currentPartTableTabIndex].name) {
					case partTableTabOrdered.name:
						part.is_ordered = true;
						break;
					case partTableTabReturned.name:
						part.is_returned = true;
						break;
				}
			}

			return part;
		}

		function onConvertPartToInventory(item, inventory) {
			if (!item || !inventory || vm.workOrder.isCompleted()) {
				return;
			}

			if (item.partData && item.partData.is_ordered) {
				item.name = inventory.name;
				item.code = inventory.code;
				item.retailPrice = inventory.retail_price;
				item.suggestedRetailPrice = inventory.retail_price;
				item.cost = inventory.purchase_price;
				item.updateProperties();
				return;
			}

			const itemQuantitiy = GeneralTools.parseNumber(item.quantity);

			const workOrderInventory = new WorkOrderInventory();
			workOrderInventory.pullDataFromInventory(inventory);
			workOrderInventory.quantity = item.quantity;
			item.setInventoryData(workOrderInventory);

			refreshDemandMap();
		}

		function isPartOrdered(item) {
			if (!item) {
				return;
			}

			if (!!item.inventoryData) {
				return true;
			}

			if (!!item.partData && item.partData.is_ordered && !item.partData.is_returned) {
				return true;
			}
		}

		function isPartNotOrdered(item) {
			return !!item && !!item.partData && !item.partData.is_ordered && !item.partData.is_returned;
		}

		function isPartReturned(item) {
			return !!item && !!item.partData && item.partData.is_returned;
		}

		function getNotOrderTabClass() {
			if (!Array.isArray(vm.partList)) {
				return;
			}

			var anyItemInCurrentTab = false;
			const matchedItem = vm.partList.find(function (item) {
				if (!item || !item.partData || !isPartNotOrdered(item)) {
					return;
				}

				anyItemInCurrentTab = true;
			});

			if (!anyItemInCurrentTab) {
				return;
			}

			return [PartConstants.styleClasses.notOrdered];
		}

		function getOrderedTabClass() {
			if (!Array.isArray(vm.partList)) {
				return;
			}

			var anyItemInCurrentTab = false;

			const warningItem = vm.partList.find(function (item) {
				if (!item) {
					return;
				}

				if (!!item.partData && isPartOrdered(item)) {
					anyItemInCurrentTab = true;

					if (!item.partData.fk_id_purchase_invoice) {
						return true;
					}
				}

				if (!!item.inventoryData) {
					anyItemInCurrentTab = true;
					if (vm.demandMap && vm.demandMap[item.inventoryData.fk_id_inventory] && vm.demandMap[item.inventoryData.fk_id_inventory].totalDemand > vm.demandMap[item.inventoryData.fk_id_inventory].totalInStock) {
						return true;
					}
				}
			});

			if (!anyItemInCurrentTab) {
				return;
			}

			if (warningItem) {
				if (warningItem.partData) {
					return [PartConstants.styleClasses.orderedUninvoiced];
				}

				return [PartConstants.styleClasses.inventoryNotEnough];
			}

			return [PartConstants.styleClasses.orderedInvoiced];
		}

		function getRowClass(item) {
			if (!item) {
				return;
			}

			if (item.inventoryData) {
				if (vm.demandMap && vm.demandMap[item.inventoryData.fk_id_inventory] && vm.demandMap[item.inventoryData.fk_id_inventory].totalDemand > vm.demandMap[item.inventoryData.fk_id_inventory].totalInStock) {
					return [PartConstants.styleClasses.inventoryNotEnough];
				}
				return [PartConstants.styleClasses.orderedInvoiced];
			}

			if (!item.partData) {
				return;
			}

			if (item.partData.is_returned) {
				return [PartConstants.styleClasses.returnedForTable];
			}

			if (!item.partData.is_ordered) {
				return [PartConstants.styleClasses.notOrdered];
			}

			if (item.partData.fk_id_purchase_invoice) {
				return [PartConstants.styleClasses.orderedInvoiced];
			} else {
				return [PartConstants.styleClasses.orderedUninvoiced];
			}
		}

		function onPartTableTabChange(tab) {
			if (!tab) {
				return;
			}

			switch (tab.name) {
				case partTableTabAll.name:
					vm.hiddenColumns = {
						cost: !showSensitiveContent,
						suggestedRetailPrice: true,
						invoice: true,
						returnInvoice: true
					}
					return;
				case partTableTabOrdered.name:
					vm.hiddenColumns = {
						cost: !showSensitiveContent,
						suggestedRetailPrice: true,
						returnInvoice: true
					}
					return;
				case partTableTabNotOrdered.name:
					vm.hiddenColumns = {
						cost: !showSensitiveContent,
						suggestedRetailPrice: true,
						invoice: true,
						returnInvoice: true
					}
					return;
				case partTableTabReturned.name:
					vm.hiddenColumns = {
						cost: !showSensitiveContent,
						suggestedRetailPrice: true,
						returnInvoice: true
					}
					return;
			}
		}

		function saveParts(requestBody) {
			if (!requestBody) {
				return;
			}

			const queue = [createParts(requestBody.partsToCreate), updateParts(requestBody.partsToUpdate), deleteParts(requestBody.partsToDetele)];

			return $q.all(queue)
				.then(function () {
					resetOriginPartList();
					return $q.resolve();
				});
		}

		function deleteParts(requestBodyList) {
			if (!Array.isArray(requestBodyList)) {
				return $q.reject("deleteParts requestBodyList invalid");
			}

			const queue = [];

			requestBodyList.forEach(function (item) {
				if (!item) {
					return;
				}

				queue.push(deletePart(item.id_work_order_part));
			});

			return $q.all(queue);
		}

		function deletePart(partID) {
			const resourcePath = {
				companyID: companyID,
				vehicleID: $stateParams.vehicleID,
				workorderID: $stateParams.workOrderID,
				partID: partID
			}

			return WorkOrderService.deleteWorkOrderPart(resourcePath)
				.then(function () {
					const index = vm.partList.findIndex(function (item) {
						return !!item && !!item.partData && item.partData.id_work_order_part == partID;
					});

					if (index != -1) {
						vm.partList.splice(index, 1);
					}
					return $q.resolve();
				});
		}

		function createParts(requestBodyList) {
			if (!Array.isArray(requestBodyList)) {
				return $q.reject("createParts requestBodyList invalid");
			}

			const queue = [];

			requestBodyList.forEach(function (item) {
				if (!item) {
					return;
				}

				queue.push(createPart(item.requestBody, item.index));
			});

			return $q.all(queue);
		}

		function createPart(requestBody, index) {
			const resourcePath = {
				companyID: companyID,
				vehicleID: $stateParams.vehicleID,
				workorderID: $stateParams.workOrderID
			}

			return WorkOrderService.createWorkOrderPart(resourcePath, requestBody)
				.then(function (newPartId) {
					if (!!vm.partList[index] && !!vm.partList[index].partData) {
						vm.partList[index].partData.id_work_order_part = newPartId;
						vm.partList[index].id = newPartId;
					}
					return $q.resolve();
				})
		}

		function updateParts(requestBodyList) {
			if (!Array.isArray(requestBodyList)) {
				return $q.reject("updateParts requestBodyList invalid");
			}

			const queue = [];

			requestBodyList.forEach(function (item) {
				if (!item) {
					return;
				}

				const resourcePath = {
					companyID: companyID,
					vehicleID: $stateParams.vehicleID,
					workorderID: $stateParams.workOrderID,
					partID: item.partID
				}

				queue.push(WorkOrderService.updateWorkOrderParts(resourcePath, item.requestBody));
			});

			return $q.all(queue);
		}

		function saveInventories(requestBody) {
			if (!requestBody) {
				return;
			}

			return $q.all([createInventories(requestBody.inventoriesToCreate), updateInventories(requestBody.inventoriesToUpdate)])
				.then(function () {
					resetOriginInventoryList();
					return $q.resolve();
				});
		}

		function createInventories(requestBodyList) {
			if (!Array.isArray(requestBodyList)) {
				return $q.reject("createInventories requestBodyList invalid");
			}

			const queue = [];

			requestBodyList.forEach(function (item) {
				if (!item) {
					return;
				}

				queue.push(createInventory(item.requestBody, item.index));
			});

			return $q.all(queue);
		}

		function createInventory(requestBody, index) {
			const resourcePath = {
				companyID: companyID,
				vehicleID: $stateParams.vehicleID,
				workorderID: $stateParams.workOrderID
			}

			return WorkOrderService.createWorkOrderInventory(resourcePath, requestBody)
				.then(function (newInventoryId) {
					if (Array.isArray(vm.partList) && vm.partList[index] && vm.partList[index].inventoryData) {
						vm.partList[index].inventoryData.id_work_order_inventory = newInventoryId;
						vm.partList[index].id = newInventoryId;
					}

					return $q.resolve();
				})
		}

		function updateInventories(requestBodyList) {
			if (!Array.isArray(requestBodyList)) {
				return $q.reject("updateInventories requestBodyList invalid");
			}

			const queue = [];

			requestBodyList.forEach(function (item) {
				if (!item) {
					return;
				}

				const resourcePath = {
					companyID: companyID,
					vehicleID: $stateParams.vehicleID,
					workorderID: $stateParams.workOrderID,
					inventoryID: item.inventoryID
				}

				queue.push(WorkOrderService.updateWorkOrderInventory(resourcePath, item.requestBody));
			});

			return $q.all(queue);
		}

		function resetOriginLaborList() {
			if (!Array.isArray(vm.laborList)) {
				return;
			}

			const laborList = [];

			vm.laborList.forEach(function (item) {
				if (item && item.laborData) {
					laborList.push(item.laborData);
				}
			});

			WorkOrderDataSharingService.setLaborList(laborList);
		}

		function resetOriginMiscfeesList() {
			if (!Array.isArray(vm.MiscFeesList)) {
				return;
			}

			const MiscFeesList = [];

			vm.MiscFeesList.forEach(function (item) {
				if (item && item.MiscFees) {
					item.MiscFees.id_misc_fees = item.MiscFees.fk_misc_fees_type;
					MiscFeesList.push(item.MiscFees);
				}
			});

			WorkOrderDataSharingService.setMiscFeesList(MiscFeesList);
		}

		function getLaborsRequestBodys() {
			const laborsToCreate = [];
			const laborsToUpdate = [];

			if (!Array.isArray(vm.laborList)) {
				return;
			}

			vm.laborList.forEach(function (item, index) {
				if (!item || !item.laborData || item.isSelected) {
					return;
				}

				if (!item.laborData.id_labor) {
					laborsToCreate.push({
						index: index,
						requestBody: item.laborData
					});
					return;
				}

				const changedProperties = getUpdateLaborRequestBody(item.laborData);

				if (!!changedProperties) {
					laborsToUpdate.push({
						requestBody: changedProperties,
						laborID: item.laborData.id_labor
					});
				}
			});

			if (laborsToCreate.length <= 0 && laborsToUpdate.length <= 0) {
				return;
			}
			return {
				laborsToCreate: laborsToCreate,
				laborsToUpdate: laborsToUpdate
			}
		}

		function getMiscfeeRequestBodys() {
			const miscfeesToCreate = [];
			const miscfeesToUpdate = [];

			if (!Array.isArray(vm.MiscFeesList)) {
				return;
			}

			vm.MiscFeesList.forEach(function (item, index) {
				if (!item || !item.MiscFees) {
					return;
				}

				if (!item.MiscFees.id_misc_fees) {
					miscfeesToCreate.push({
						index: index,
						requestBody: item.MiscFees
					});
					return;
				}

				const changedProperties = getUpdateMiscRequestBody(item.MiscFees);

				if (!!changedProperties) {
					miscfeesToUpdate.push({
						requestBody: changedProperties,
						miscfeeID: item.MiscFees.id_misc_fees
					});
				}
			});

			if (miscfeesToCreate.length <= 0 && miscfeesToUpdate.length <= 0) {
				return;
			}
			return {
				miscfeesToCreate: miscfeesToCreate,
				miscfeesToUpdate: miscfeesToUpdate
			}
		}

		function getUpdateLaborRequestBody(labor) {
			const originLaborList = WorkOrderDataSharingService.getLaborList();

			if (!labor || !labor.id_labor) {
				return;
			}

			if (!Array.isArray(originLaborList)) {
				return;
			}

			const originLabor = originLaborList.find(function (item) {
				if (!item) {
					return;
				}

				return item.id_labor == labor.id_labor;
			});

			if (!originLabor) {
				return;
			}

			const changedProperties = GeneralTools.updateResourceRequestBodyGenerator(labor, originLabor);
			if (!!changedProperties) {
				return changedProperties;
			}
		}

		function getUpdateMiscRequestBody(miscfees) {
			const originidmiscfeesList = WorkOrderDataSharingService.getMiscFeesList();

			if (!miscfees || !miscfees.id_misc_fees) {
				return;
			}

			if (!Array.isArray(originidmiscfeesList)) {
				return;
			}

			const originmiscfees = originidmiscfeesList.find(function (item) {
				if (!item) {
					return;
				}

				return item.id_misc_fees == miscfees.id_misc_fees;
			});

			if (!originmiscfees) {
				return;
			}

			const changedProperties = GeneralTools.updateResourceRequestBodyGenerator(miscfees, originmiscfees);

			if (!!changedProperties) {
				return changedProperties;
			}
		}

		function saveLabors(requestBody) {
			if (!requestBody) {
				return;
			}

			return $q.all([createLabors(requestBody.laborsToCreate), updateLabors(requestBody.laborsToUpdate)])
				.then(function () {
					resetOriginLaborList();
					return $q.resolve();
				});
		}

		function saveMiscfees(requestBody) {
			if (!requestBody) {
				return;
			}

			return $q.all([createMiscfees(requestBody.miscfeesToCreate), updateMiscfees(requestBody.miscfeesToUpdate)])
				.then(function () {
					resetOriginMiscfeesList();
					return $q.resolve();
				});
		}

		function createLabors(requestBodyList) {
			if (!Array.isArray(requestBodyList)) {
				return $q.reject("createLabors requestBodyList invalid");
			}

			const queue = [];

			requestBodyList.forEach(function (item) {
				if (!item) {
					return;
				}

				queue.push(createLabor(item.requestBody, item.index));
			});

			return $q.all(queue);
		}

		function createMiscfees(requestBodyList) {
			if (!Array.isArray(requestBodyList)) {
				return $q.reject("createMiscfees requestBodyList invalid");
			}

			const queue = [];

			requestBodyList.forEach(function (item) {
				if (!item) {
					return;
				}
				queue.push(createMiscfee(item.requestBody, item.index));
			});

			return $q.all(queue);
		}

		function createLabor(requestBody, index) {
			const resourcePath = {
				companyID: companyID,
				vehicleID: $stateParams.vehicleID,
				workorderID: $stateParams.workOrderID
			}

			return WorkOrderService.createLabor(resourcePath, requestBody)
				.then(function (newLaborId) {
					if (Array.isArray(vm.laborList) && vm.laborList[index] && vm.laborList[index].laborData) {
						vm.laborList[index].laborData.id_labor = newLaborId;
						for (var i = 0; i < vm.labourlist.length; i++) {
							if (parseInt(vm.laborList[index].laborData.fk_id_labour_type) == vm.labourlist[i].id_labour_type) {
								vm.laborList[index].laborData.labour_name = vm.labourlist[i].labour_name;
							}
						}
					}

					return $q.resolve();
				})
		}

		function createMiscfee(requestBody, index) {
			const resourcePath = {
				companyID: companyID,
				vehicleID: $stateParams.vehicleID,
				workorderID: $stateParams.workOrderID
			}

			return WorkOrderService.createmiscfees(resourcePath, requestBody)
				.then(function (newmiscfeesId) {
					if (Array.isArray(vm.MiscFeesList) && vm.MiscFeesList[index] && vm.MiscFeesList[index].labMiscFeesorData) {
						vm.MiscFeesList[index].labMiscFeesorData.id_misc_fees = newmiscfeesId;
					}

					return $q.resolve();
				})
		}

		function updateLabors(requestBodyList) {
			if (!Array.isArray(requestBodyList)) {
				return $q.reject("updateLabors requestBodyList invalid");
			}

			const queue = [];

			requestBodyList.forEach(function (item) {
				if (!item) {
					return;
				}

				const resourcePath = {
					companyID: companyID,
					vehicleID: $stateParams.vehicleID,
					workorderID: $stateParams.workOrderID,
					laborID: item.laborID
				}
				queue.push(WorkOrderService.updateLabor(resourcePath, item.requestBody));
			});

			return $q.all(queue);
		}

		function updateMiscfees(requestBodyList) {
			if (!Array.isArray(requestBodyList)) {
				return $q.reject("updateMiscfees requestBodyList invalid");
			}

			const queue = [];

			requestBodyList.forEach(function (item) {
				if (!item) {
					return;
				}
				const resourcePath = {
					companyID: companyID,
					vehicleID: $stateParams.vehicleID,
					workorderID: $stateParams.workOrderID,
					miscfeeID: item.miscfeeID
				}
				queue.push(WorkOrderService.updateMiscfees(resourcePath, item.requestBody));
			});

			return $q.all(queue);
		}

		function isAnyPartSelectedInCurrentTab() {
			if (!Array.isArray(vm.partList)) {
				return;
			}

			const hasFilter = !!vm.partTableTabs[vm.currentPartTableTabIndex] && typeof (vm.partTableTabs[vm.currentPartTableTabIndex].filter) == "function";

			const selectedPart = vm.partList.find(function (item) {
				return (!hasFilter || vm.partTableTabs[vm.currentPartTableTabIndex].filter(item)) && !!item && !!item.isSelected;
			});

			return !!selectedPart;
		}

		function removeSelectedParts() {
			const details = getPartTableCurrentTabSelectedItemsDetail();

			if (!details) {
				MessageService.showToast("Part table data invalid.");
				return;
			}

			if (details.existingPartIdList.length > 0 || details.existingInventoryIdList.length > 0) {
				showDeletePartTableItemsDialog(details.existingPartIdList, details.existingInventoryIdList, details.newItemIndexList);
			} else {
				removeNewPartTableItems(details.newItemIndexList);
				MessageService.showToast("Parts are removed.");
			}
		}

		function getPartTableCurrentTabSelectedItemsDetail() {
			const existingPartIdList = [];
			const existingInventoryIdList = [];
			const newItemIndexList = [];

			if (!Array.isArray(vm.partList)) {
				return;
			}

			const hasFilter = !!vm.partTableTabs[vm.currentPartTableTabIndex] && typeof (vm.partTableTabs[vm.currentPartTableTabIndex].filter) == "function";

			vm.partList.forEach(function (item, index) {
				if ((hasFilter && !vm.partTableTabs[vm.currentPartTableTabIndex].filter(item)) || !item || !item.isSelected) {
					return;
				}

				if (!!item.partData && !!item.partData.id_work_order_part) {
					existingPartIdList.push(item.partData.id_work_order_part);
				} else if (!!item.inventoryData && !!item.inventoryData.id_work_order_inventory) {
					existingInventoryIdList.push(item.inventoryData.id_work_order_inventory);
				} else {
					newItemIndexList.push(index);
				}
			});

			// Find the parts converted to inventory.
			const originPartList = WorkOrderDataSharingService.getPartList();

			if (Array.isArray(originPartList)) {
				originPartList.forEach(function (part) {
					if (!!part) {
						part.id_work_order_part

						const index = vm.partList.findIndex(function (item) {
							return !!item && !!item.partData && item.partData.id_work_order_part == part.id_work_order_part;
						});

						if (index == -1) {
							existingPartIdList.push(part.id_work_order_part);
						}
					}
				});
			}

			return {
				existingPartIdList: existingPartIdList,
				existingInventoryIdList: existingInventoryIdList,
				newItemIndexList: newItemIndexList
			};
		}

		function showDeletePartTableItemsDialog(existingPartIdList, existingInventoryIdList, newItemIndexList) {
			var dialogOptions = {};

			dialogOptions.titleString = "Remove Parts";
			dialogOptions.contentString = "Are you sure to remove selected items";

			var confirmOption = {};

			confirmOption.optionName = "YES";
			confirmOption.onClick = function () {
				vm.isDeletingPartTableItems = true;

				confirmDeletePartsOrInventories(existingPartIdList, existingInventoryIdList, newItemIndexList)
					.then(function () {
						MessageService.showToast("Parts are removed.");
					})
					.catch(MessageService.showToast)
					.finally(function () {
						vm.isDeletingPartTableItems = false;
					});

				DialogService.close();
			}

			var cancelOption = {};

			cancelOption.optionName = "NO";
			cancelOption.onClick = function () {
				DialogService.close();
			}

			dialogOptions.options = [confirmOption, cancelOption];

			DialogService.showOptionsDialog(dialogOptions);
		}

		function confirmDeletePartsOrInventories(existingPartIdList, existingInventoryIdList, newItemIndexList) {
			removeNewPartTableItems(newItemIndexList);

			if (!Array.isArray(existingPartIdList) || !Array.isArray(existingInventoryIdList)) {
				return;
			}

			const queue = [];

			existingPartIdList.forEach(function (partID) {
				queue.push(deletePart(partID));
			});

			existingInventoryIdList.forEach(function (inventoryID) {
				queue.push(deleteWorkOrderInventory(inventoryID));
			});

			return $q.all(queue)
				.then(function () {
					resetOriginPartList();
					resetOriginInventoryList();
					return $q.resolve();
				});
		}

		function removeNewPartTableItems(newItemIndexList) {
			if (!Array.isArray(newItemIndexList)) {
				return;
			}

			newItemIndexList.reverse();

			newItemIndexList.forEach(function (index) {
				vm.partList.splice(index, 1);
			});
		}

		function deleteWorkOrderInventory(inventoryID) {
			const resourcePath = {
				companyID: companyID,
				vehicleID: $stateParams.vehicleID,
				workorderID: $stateParams.workOrderID,
				inventoryID: inventoryID
			}

			return WorkOrderService.deleteWorkOrderInventory(resourcePath)
				.then(function () {
					const index = vm.partList.findIndex(function (item) {
						return !!item && !!item.inventoryData && item.inventoryData.id_work_order_inventory == inventoryID;
					});

					if (index != -1) {
						vm.partList.splice(index, 1);
					}
					return $q.resolve();
				});
		}

		function isAnyLaborSelected() {
			if (!Array.isArray(vm.laborList)) {
				return;
			}

			return !!vm.laborList.find(function (item) {
				return item && item.isSelected;
			});
		}

		function isAnyMiscfeesSelected() {
			if (!Array.isArray(vm.MiscFeesList)) {
				return;
			}

			return !!vm.MiscFeesList.find(function (item) {
				return item && item.isSelected;
			});

		}

		function removeSelectedLabors() {
			const details = getLaborTableSelectedItemsDetail();

			if (details.existingLaborIdList.length > 0) {
				showDeleteLaborsDialog(details.existingLaborIdList, details.newLaborIndexList);
			} else {
				removeNewLabors(details.newLaborIndexList);
				MessageService.showToast("Labors are removed.");
			}
		}

		function removeSelectedMiscfees() {
			const details = getMiscfeesTableSelectedItemsDetail();

			if (details.existingMiscfeesIdList.length > 0) {
				showDeleteMiscfeesDialog(details.existingMiscfeesIdList, details.newMiscfeesIndexList);
			} else {
				removeNewMiscfees(details.newMiscfeesIndexList);
				MessageService.showToast("Misc fees are removed.");
			}
		}

		function getLaborTableSelectedItemsDetail() {
			const existingLaborIdList = [];
			const newLaborIndexList = [];

			vm.laborList.forEach(function (item, index) {
				if (!item || !item.isSelected) {
					return;
				}

				if (!!item.laborData.id_labor) {
					existingLaborIdList.push(item.laborData.id_labor);
				} else {
					newLaborIndexList.push(index);
				}
			});

			return {
				existingLaborIdList: existingLaborIdList,
				newLaborIndexList: newLaborIndexList
			}
		}

		function getMiscfeesTableSelectedItemsDetail() {
			const existingMiscfeesIdList = [];
			const newMiscfeesIndexList = [];

			vm.MiscFeesList.forEach(function (item, index) {
				if (!item || !item.isSelected) {
					return;
				}

				if (!!item.MiscFees.id_misc_fees) {
					existingMiscfeesIdList.push(item.MiscFees.id_misc_fees);
				} else {
					newMiscfeesIndexList.push(index);
				}
			});

			return {
				existingMiscfeesIdList: existingMiscfeesIdList,
				newMiscfeesIndexList: newMiscfeesIndexList
			}
		}

		function showDeleteLaborsDialog(existingLaborIdList, newLaborIndexList) {
			var dialogOptions = {};

			dialogOptions.titleString = "Remove Labors";
			dialogOptions.contentString = "Are you sure to remove selected items";

			var confirmOption = {};

			confirmOption.optionName = "YES";
			confirmOption.onClick = function () {
				vm.isDeletingLabors = true;

				confirmDeleteLabors(existingLaborIdList, newLaborIndexList)
					.then(function () {
						MessageService.showToast("Labors are removed.");
					})
					.catch(MessageService.showToast)
					.finally(function () {
						vm.isDeletingLabors = false;
					})
				DialogService.close();
			}

			var cancelOption = {};

			cancelOption.optionName = "NO";
			cancelOption.onClick = function () {
				DialogService.close();
			}

			dialogOptions.options = [confirmOption, cancelOption];

			DialogService.showOptionsDialog(dialogOptions);
		}

		function showDeleteMiscfeesDialog(existingMiscfeesIdList, newMiscfeesIndexList) {
			var dialogOptions = {};

			dialogOptions.titleString = "Remove Misc fees";
			dialogOptions.contentString = "Are you sure to remove selected items";

			var confirmOption = {};

			confirmOption.optionName = "YES";
			confirmOption.onClick = function () {
				vm.isDeletingMiscfees = true;

				confirmDeleteMiscfees(existingMiscfeesIdList, newMiscfeesIndexList)
					.then(function () {
						MessageService.showToast("Misc fees are removed.");
					})
					.catch(MessageService.showToast)
					.finally(function () {
						vm.isDeletingMiscfees = false;
					})
				DialogService.close();
			}

			var cancelOption = {};

			cancelOption.optionName = "NO";
			cancelOption.onClick = function () {
				DialogService.close();
			}

			dialogOptions.options = [confirmOption, cancelOption];

			DialogService.showOptionsDialog(dialogOptions);
		}

		function confirmDeleteLabors(existingLaborIdList, newLaborIndexList) {
			removeNewLabors(newLaborIndexList);

			if (!Array.isArray(existingLaborIdList)) {
				return;
			}

			const queue = [];

			existingLaborIdList.forEach(function (laborID) {
				queue.push(deleteLabor(laborID));
			});

			return $q.all(queue)
				.then(function () {
					resetOriginLaborList();
					return $q.resolve();
				});
		}

		function confirmDeleteMiscfees(existingMiscfeesIdList, newMiscfeesIndexList) {
			removeNewMiscfees(newMiscfeesIndexList);

			if (!Array.isArray(existingMiscfeesIdList)) {
				return;
			}

			const queue = [];

			existingMiscfeesIdList.forEach(function (id_misc_fees) {
				queue.push(deleteMiscfee(id_misc_fees));
			});

			return $q.all(queue)
				.then(function () {
					resetOriginMiscfeesList();
					return $q.resolve();
				});
		}

		function deleteLabor(laborID) {
			const resourcePath = {
				companyID: companyID,
				vehicleID: $stateParams.vehicleID,
				workorderID: $stateParams.workOrderID,
				laborID: laborID
			}

			return WorkOrderService.deleteLabor(resourcePath)
				.then(function () {
					const index = vm.laborList.findIndex(function (item) {
						return !!item && item.laborData.id_labor == laborID;
					});

					vm.laborList.splice(index, 1);
					return $q.resolve();
				});
		}

		function deleteMiscfee(id_misc_fees) {
			const resourcePath = {
				companyID: companyID,
				vehicleID: $stateParams.vehicleID,
				workorderID: $stateParams.workOrderID,
				miscfeeID: id_misc_fees
			}

			return WorkOrderService.deleteMiscfees(resourcePath)
				.then(function () {
					const index = vm.MiscFeesList.findIndex(function (item) {
						return !!item && item.MiscFees.id_misc_fees == id_misc_fees;
					});

					vm.MiscFeesList.splice(index, 1);
					return $q.resolve();
				});
		}

		function removeNewLabors(newLaborIndexList) {
			if (!Array.isArray(newLaborIndexList)) {
				return;
			}

			newLaborIndexList.reverse();

			newLaborIndexList.forEach(function (index) {
				vm.laborList.splice(index, 1);
			});
		}


		function removeNewMiscfees(newMiscfeesIndexList) {
			if (!Array.isArray(newMiscfeesIndexList)) {
				return;
			}

			newMiscfeesIndexList.reverse();

			newMiscfeesIndexList.forEach(function (index) {
				vm.MiscFeesList.splice(index, 1);
			});
		}

		function addDiscountOnParts() {
			const discount = new WorkOrderDiscount();

			discount.description = "Parts Discount";
			discount.is_percentage = false;

			if (vm.isPartDiscountPercentage) {
				var totalSelectedPartPrice = 0;

				if (!Array.isArray(vm.partList)) {
					return;
				}

				const hasFilter = !!vm.partTableTabs[vm.currentPartTableTabIndex] && typeof (vm.partTableTabs[vm.currentPartTableTabIndex].filter) == "function";

				vm.partList.forEach(function (item) {
					if ((hasFilter && !vm.partTableTabs[vm.currentPartTableTabIndex].filter(item)) || !item || !item.isSelected) {
						return;
					}

					if (!!item.partData) {
						totalSelectedPartPrice += GeneralTools.parseNumber(item.partData.quantity) * GeneralTools.parseNumber(item.partData.retail_price);
					} else if (!!item.inventoryData) {
						totalSelectedPartPrice += GeneralTools.parseNumber(item.inventoryData.quantity) * GeneralTools.parseNumber(item.inventoryData.retail_price);
					}
				});

				discount.amount_off = GeneralTools.preciseNumber(vm.partDiscountAmount * totalSelectedPartPrice, 2);
			} else {
				discount.amount_off = vm.partDiscountAmount;
			}

			vm.isSaving = true;

			addDiscount(discount)
				.then(function () {
					MessageService.showToast("Discount added.");
				})
				.catch(MessageService.showToast)
				.finally(function () {
					vm.isSaving = false;
					vm.showPartDiscount = false;
					vm.partDiscountAmount = null;
					vm.isPartDiscountPercentage = false;
				});;
		}

		function addDiscountOnLabors() {
			const discount = new WorkOrderDiscount();

			discount.description = "Labors Discount";
			discount.is_percentage = false;

			if (vm.isLaborDiscountPercentage) {
				var totalSelectedLaborPrice = 0;

				if (!Array.isArray(vm.laborList)) {
					return;
				}

				vm.laborList.forEach(function (item) {
					if (!!item && item.isSelected && !!item.laborData) {
						totalSelectedLaborPrice += GeneralTools.parseNumber(item.laborData.price) * GeneralTools.parseNumber(item.laborData.hour);
					}
				});

				discount.amount_off = GeneralTools.preciseNumber(vm.laborDiscountAmount * totalSelectedLaborPrice, 2);
			} else {
				discount.amount_off = vm.laborDiscountAmount;
			}

			vm.isSaving = true;

			addDiscount(discount)
				.then(function () {
					MessageService.showToast("Discount added.");
				})
				.catch(MessageService.showToast)
				.finally(function () {
					vm.isSaving = false;
					vm.showLaborDiscount = false;
					vm.laborDiscountAmount = null;
					vm.isLaborDiscountPercentage = false;
				});;
		}

		function addDiscount(discount) {
			if (!discount) {
				MessageService.showToast("Discount data invalid");
				return;
			}

			if (discount.is_percentage && !discount.percentage_off) {
				MessageService.showToast("Please enter discount percentage");
				return;
			}

			if (!discount.is_percentage && !discount.amount_off) {
				MessageService.showToast("Please enter discount amount");
				return;
			}

			const resourcePath = {
				companyID: companyID,
				vehicleID: $stateParams.vehicleID,
				workorderID: $stateParams.workOrderID
			}

			return WorkOrderService.createDiscount(resourcePath, discount)
				.then(function (newDiscountID) {
					discount.id_work_order_discount = newDiscountID;
					vm.discounts.push(discount)
					WorkOrderDataSharingService.setDiscountList(vm.discounts);
					return $q.resolve();
				});
		}

		function isWorkOrderCapbleforRD(str) {


			return DialogService.showYesOrNoDialog(null, str)
			.then(function (isContinue) {
				if (isContinue) {
					return $q.resolve(true);
				}
				return  $q.resolve(false);
				
			}).catch(function(result){
				return  $q.resolve(false);
			});

		}

		function generateRD(rogerDollar, customerInfo){
			const resourcePath = {
				companyID: companyID,
				vehicleID: $stateParams.vehicleID,
				workorderID: $stateParams.workOrderID,
			}
			return WorkOrderService.generateRD(resourcePath, {rgdollar: rogerDollar, customerID: customerInfo.id_customer})
			.then(function (insertID) {
				if(insertID){
					var temp = new WorkOrderRDGenerated();
					temp.setAttributes({
						id_rd_generated: insertID,
						generated_amount: rogerDollar,
						fk_id_work_order: $stateParams.workOrderID,
						fk_id_user: userInfo.userID,
						fk_id_customer: customerInfo.id_customer,
						date: moment().format("YYYY-MM-DD")
					})

					const newArray = [temp].map(function(obj){
						const resourceData  = {
							id_rd_generated: insertID,
							generated_amount: rogerDollar,
							fk_id_work_order: $stateParams.workOrderID,
							fk_id_user: userInfo.userID,
							fk_id_customer: customerInfo.id_customer,
							date: moment().format("YYYY-MM-DD")
						}
						return resourceData
					})

					vm.workOrderRDGeneratedList = angular.copy(newArray)
					WorkOrderDataSharingService.setRDGeneratedList(newArray);
				}
				return $q.resolve();
			})
			.catch(MessageService.showToast)
			.finally(function(){

			});
		}

		function onStatusClick(status) {

			var subtotaltempholder = WorkOrderDataSharingService.getworkOrderSubTotal();
			var rogerDollar = parseFloat((vm.workOrder.rogerdollar_generate_precentage * subtotaltempholder).toFixed(2))
			var rogerDollarstr = generatingRogerDollarA + (vm.workOrder.rogerdollar_generate_precentage * subtotaltempholder).toFixed(2) + generatingRogerDollarB;

			var isCompleting = false;
			var isRevertingComplete = false;

			if (status.id_work_order_status == WorkOrderConstants.statusIDs.completed) {
				isCompleting = true;
			} else if (vm.workOrder.fk_id_work_order_status == WorkOrderConstants.statusIDs.completed) {
				isRevertingComplete = true;
			}

			if( (vm.workOrder.selectedCustomer == undefined || vm.workOrder.selectedCustomer.customerInfo == undefined)  && isCompleting && rogerDollar > 0 && vm.workOrder.is_rogerdollar_generable == true && vm.workOrderRDGeneratedList.length == 0 ){
				MessageService.showToast("Error, Capable of generate Rogers Dollar but missing Customer Select.");
				return
			}

			var promise = $q.resolve();
			var promiseA = $q.resolve();
			vm.isSaving = true;

			if (isCompleting && rogerDollar > 0 && vm.workOrder.is_rogerdollar_generable == true && vm.workOrderRDGeneratedList.length == 0 && vm.workOrder.selectedCustomer.customerInfo != undefined) {
				promiseA = isWorkOrderCapbleforRD(rogerDollarstr).then(function(params) {
					if (params) {
						return generateRD(rogerDollar, vm.workOrder.selectedCustomer.customerInfo)
					}	
					vm.isSaving = false
					return $q.reject();
				}).catch(function (error) {
					if (error) {
						return $q.reject();
					}
				}).then(function () {
					if (isCompleting) {
						promise = checkBeforeCompleteWorkorder()
							.then(function (isContinue) {
								if (isContinue) {
									return saveInventoryAndModifyQuantity(true);
								}
		
								return $q.reject();
							});
					} else if (isRevertingComplete) {
						promise = saveInventoryAndModifyQuantity(false);
					}
		
					promise.then(function () {
						setWorkorderStatus(status.id_work_order_status);
						return updateWorkOrder(GeneralTools.updateResourceRequestBodyGenerator(vm.workOrder, WorkOrderDataSharingService.getWorkOrder()));
					})
						.then(function () {
							refreshDemandMap();
							vm.refreshDates();
							MessageService.showToast("Success.");
						})
						.catch(function (error) {
							if (error) {
								MessageService.showToast(error);
							}
						})
						.finally(function () {
							vm.isSaving = false;
						});
				})

			}else{
				if (isCompleting) {
					promise = checkBeforeCompleteWorkorder()
						.then(function (isContinue) {
							if (isContinue) {
								return saveInventoryAndModifyQuantity(true);
							}
	
							return $q.reject();
						});
				} else if (isRevertingComplete) {
					promise = saveInventoryAndModifyQuantity(false);
				}
	
				promise.then(function () {
					setWorkorderStatus(status.id_work_order_status);
					return updateWorkOrder(GeneralTools.updateResourceRequestBodyGenerator(vm.workOrder, WorkOrderDataSharingService.getWorkOrder()));
				})
					.then(function () {
						refreshDemandMap();
						vm.refreshDates();
						MessageService.showToast("Success.");
					})
					.catch(function (error) {
						if (error) {
							MessageService.showToast(error);
						}
					})
					.finally(function () {
						vm.isSaving = false;
					});
			}
			
		}

		function checkBeforeCompleteWorkorder() {
			return isInventoryEnough()
				.then(function () {
					if (!isAssignedToMechanic()) {
						return DialogService.showYesOrNoDialog(null, missingMechanicWarning);
					}

					return $q.resolve(true);
				})
				.then(function (isContinue) {
					if (!isContinue) {
						return $q.reject();
					}

					if (vm.workOrder.mileage == null) {
						return DialogService.showYesOrNoDialog(null, missingMileageWarning);
					}

					return $q.resolve(true);
				});
		}

		function setWorkorderStatus(statusID) {
			if (!vm.workOrder) {
				return;
			}

			if (statusID == WorkOrderConstants.statusIDs.completed && !vm.workOrder.completed_date) {
				vm.workOrder.setCompletedDateTime(moment().utc());
			}

			if (statusID == WorkOrderConstants.statusIDs.quoted && !vm.workOrder.quote_date) {
				vm.workOrder.setQuoteDate(moment().utc());
			}

			vm.workOrder.fk_id_work_order_status = statusID;
		}

		function saveInventoryAndModifyQuantity(isNegative) {
			const unsavedChanges = getInventoriesRequestBodys();

			if (!unsavedChanges) {
				return modifyInventoriesQuantity(extractInventoryListFromPartList(), isNegative);
			}

			var ignoreUnsavedChanges = false;

			return DialogService.showYesOrNoDialog(null, completeWorkOrderWarning, saveAndContinueStr, ignoreAndContinueStr)
				.then(function (isToSaveChanges) {
					if (isToSaveChanges) {
						return saveInventories(unsavedChanges);
					}

					ignoreUnsavedChanges = true;
					return $q.resolve();
				})
				.then(function () {
					if (ignoreUnsavedChanges) {
						return modifyInventoriesQuantity(WorkOrderDataSharingService.getInventoryList(), isNegative);
					}
					resetOriginInventoryList();
					return modifyInventoriesQuantity(extractInventoryListFromPartList(), isNegative);
				});
		}

		function hasUnsavedChanges() {
			delete vm.workOrder.selectedCustomer
			if (GeneralTools.updateResourceRequestBodyGenerator(vm.workOrder, WorkOrderDataSharingService.getWorkOrder())) {
				return true;
			}

			if (getPartsRequestBodys()) {
				return true;
			}

			if (getInventoriesRequestBodys()) {
				return true;
			}

			if (getLaborsRequestBodys()) {
				return true;
			}

			if (getMiscfeeRequestBodys()) {
				return true;
			}

			if (getWorkOrderWarrantyRequestBodys()) {
				return true
			}

			return false;
		}

		function modifyInventoriesQuantity(inventories, isNegative) {
			if (!Array.isArray(inventories)) {
				return $q.reject("Selected inventories invalid.");
			}

			const quantityChangeMap = {};

			inventories.forEach(function (inventory) {
				if (!inventory) {
					return;
				}

				if (quantityChangeMap[inventory.fk_id_inventory] == null) {
					quantityChangeMap[inventory.fk_id_inventory] = 0;
				}

				if (isNegative) {
					quantityChangeMap[inventory.fk_id_inventory] -= inventory.quantity;
				} else {
					quantityChangeMap[inventory.fk_id_inventory] += inventory.quantity;
				}
			});

			const queue = [];

			Object.keys(quantityChangeMap).forEach(function (inventoryID) {
				const resourcePath = {
					companyID: companyID,
					inventoryID: inventoryID
				};

				queue.push(InventoryService.modifyInventoryQuantity(resourcePath, quantityChangeMap[inventoryID]));
			});

			return $q.all(queue);
		}

		function isInventoryEnough() {
			return refreshDemandMap().then(function (demandMap) {
				if (!demandMap) {
					return $q.reject("Demand map invalid.");
				}

				const isEnough = Object.keys(vm.demandMap).every(function (inventoryID) {
					return !!vm.demandMap[inventoryID] && vm.demandMap[inventoryID].totalInStock >= vm.demandMap[inventoryID].totalDemand;
				});

				if (isEnough) {
					return $q.resolve();
				}

				return $q.reject("Inventory not enough");
			});
		}

		function updateUpcomingAppontmentStatus(statusID) {
			if (!vm.upcomingAppointment) {
				return;
			}

			vm.isUpdatingAppointment = true;

			const resourcePath = {
				companyID: companyID,
				workorderappointmentID: vm.upcomingAppointment.id_work_order_appointment
			};

			const requestBody = {};

			if (statusID == vm.upcomingAppointment.fk_id_appointment_status) {
				requestBody.fk_id_appointment_status = null;
			} else {
				requestBody.fk_id_appointment_status = statusID;
			}

			WorkOrderService.updateAppointment(resourcePath, requestBody)
				.then(function () {
					vm.upcomingAppointment.fk_id_appointment_status = requestBody.fk_id_appointment_status;
					MessageService.showToast("Appointment is updated.");
				})
				.catch(MessageService.showToast)
				.finally(function () {
					vm.isUpdatingAppointment = false;
				});
		}


		
		function updateUpcomingCustomerPortalAppontmentStatus(statusID) {
			if (!vm.upcomingAppointment) {
				return;
			}

			vm.isUpdatingAppointment = true;

			const resourcePath = {
				companyID: companyID,
				workorderappointmentID: vm.upcomingAppointment.id_work_order_appointment
			};

			const requestBody = {};

			if (statusID == vm.upcomingAppointment.fk_id_appointment_status) {
				requestBody.fk_id_appointment_status = null;
			} else {
				requestBody.fk_id_appointment_status = statusID;
			}

			WorkOrderService.updateAppointment(resourcePath, requestBody)
				.then(function () {
					vm.upcomingAppointment.fk_id_appointment_status = requestBody.fk_id_appointment_status;
					MessageService.showToast("Appointment is updated.");
				})
				.catch(MessageService.showToast)
				.finally(function () {
					vm.isUpdatingAppointment = false;
				});
		}




		function percentageTransaletor(isPercentage, key) {
			if (typeof (vm[key]) != "number") {
				return;
			}

			if (isPercentage) {
				vm[key] = vm[key] / 100;
			} else {
				vm[key] = vm[key] * 100;
			}
		}

		function splitWorkorder() {
			if (!isAnyPartSelectedInCurrentTab() && !isAnyLaborSelected() && !isAnyMiscfeesSelected()) {
				MessageService.showToast("No part or labor or misc fees selected.");
				return;
			}

			if (vm.isWarrntySectionValid && !vm.isWarrntySectionValid()) {
				MessageService.showToast(warrantyTableInvalidMessage);
				return;
			}

			if (vm.isPartTableValid && !vm.isPartTableValid()) {
				MessageService.showToast(partTableInvalidMessage);
				return;
			}

			if (vm.isLaborTableValid && !vm.isLaborTableValid()) {
				MessageService.showToast(laborTableInvalidMessage);
				return;
			}

			if (vm.isMiscfeeTableValid && !vm.isMiscfeeTableValid()) {
				MessageService.showToast(miscfeeTableInvalidMessage);
				return;
			}


			var partTableDetail;
			var laborTableDetail;
			var miscfeesTableDetail;
			var newWorkorderID;
			var unsavedChangeCheck = $q.resolve();
			vm.isSpliting = true;

			if (hasUnsavedChanges()) {
				unsavedChangeCheck = DialogService.showYesOrNoDialog(null, unsavedChangeWarning, saveAndContinueStr, ignoreAndContinueStr)
					.then(function (isSave) {
						if (isSave) {
							return save();
						}

						return $q.resolve();
					});
			}

			unsavedChangeCheck.then(function () {
				partTableDetail = getPartTableCurrentTabSelectedItemsDetail();
				laborTableDetail = getLaborTableSelectedItemsDetail();
				miscfeesTableDetail = getMiscfeesTableSelectedItemsDetail();
				return DialogService.showYesOrNoDialog(splitConfirmMessageTitle, getSplitConfirmMessage(partTableDetail, laborTableDetail, miscfeesTableDetail));
			})
				.then(function (isContinue) {
					if (!isContinue) {
						return $q.reject();
					}

					return createNewWorkorder();
				})
				.then(function (_newWorkorderID) {
					newWorkorderID = _newWorkorderID;

					return $q.all([
						copySelectedPartsToWorkorder(newWorkorderID),
						copySelectedLaborToWorkorder(newWorkorderID),
						copySelectedMiscfeesToWorkorder(newWorkorderID)
					]);
				})
				.then(function () {
					const queue = [];

					if (partTableDetail) {
						queue.push(confirmDeletePartsOrInventories(partTableDetail.existingPartIdList, partTableDetail.existingInventoryIdList, partTableDetail.newItemIndexList));
					}

					if (laborTableDetail) {
						queue.push(confirmDeleteLabors(laborTableDetail.existingLaborIdList, laborTableDetail.newLaborIndexList));
					}

					if (miscfeesTableDetail) {
						queue.push(confirmDeleteMiscfees(miscfeesTableDetail.existingMiscfeesIdList, miscfeesTableDetail.newMiscfeesIndexList));
					}

					return $q.all(queue);
				})
				.then(function () {
					window.open($state.href("app.edit-workorder.general", { workOrderID: newWorkorderID, vehicleID: $stateParams.vehicleID }), '_blank');
				})
				.catch(function (error) {
					if (error) {
						MessageService.showToast(error);
					}
				})
				.finally(function () {
					vm.isSpliting = false;
				});
		}

		function copySelectedPartsToWorkorder(workorderID) {
			const hasFilter = !!vm.partTableTabs[vm.currentPartTableTabIndex] && typeof (vm.partTableTabs[vm.currentPartTableTabIndex].filter) == "function";
			const queue = [];
			const resourcePath = {
				companyID: companyID,
				vehicleID: $stateParams.vehicleID,
				workorderID: workorderID
			}

			vm.partList.forEach(function (item, index) {
				if ((hasFilter && !vm.partTableTabs[vm.currentPartTableTabIndex].filter(item)) || !item || !item.isSelected) {
					return;
				}

				if (!!item.partData) {
					queue.push(WorkOrderService.createWorkOrderPart(resourcePath, item.partData));
				} else if (!!item.inventoryData) {
					queue.push(WorkOrderService.createWorkOrderInventory(resourcePath, item.inventoryData));
				}
			});

			return $q.all(queue);
		}

		function copySelectedLaborToWorkorder(workorderID) {
			const queue = [];
			const resourcePath = {
				companyID: companyID,
				vehicleID: $stateParams.vehicleID,
				workorderID: workorderID
			}

			vm.laborList.forEach(function (item, index) {
				if (!item || !item.isSelected) {
					return;
				}

				queue.push(WorkOrderService.createLabor(resourcePath, item.laborData));
			});

			return $q.all(queue);
		}


		function copySelectedMiscfeesToWorkorder(workorderID) {
			const queue = [];
			const resourcePath = {
				companyID: companyID,
				vehicleID: $stateParams.vehicleID,
				workorderID: workorderID
			}

			vm.MiscFeesList.forEach(function (item, index) {
				if (!item || !item.isSelected) {
					return;
				}
				delete item.MiscFees.id_misc_fees
				queue.push(WorkOrderService.createmiscfees(resourcePath, item.MiscFees));
			});

			return $q.all(queue);
		}

		function createNewWorkorder() {
			const resourcePath = {
				companyID: companyID,
				vehicleID: $stateParams.vehicleID
			}

			const workOrder = new WorkOrder();

			workOrder.quote_date = moment().format(WorkOrderConstants.dateFormat);
			workOrder.fk_id_work_order_status = WorkOrderConstants.statusIDs.quoted;
			workOrder.tax_rate = ToolsConstants.taxRate;

			const lowestPriority = WorkOrderService.getLowestWorkOrderPriority(vm.workOrderPriorities);

			if (lowestPriority) {
				workOrder.fk_id_work_order_priority = lowestPriority.id_work_order_priority;
			}

			return WorkOrderService.createWorkOrder(resourcePath, workOrder);
		}

		function getSplitConfirmMessage(partTableDetail, laborTableDetail, miscfeesTableDetail) {
			if (!partTableDetail || !laborTableDetail || !miscfeesTableDetail || !Array.isArray(vm.partList) || !Array.isArray(vm.laborList) || !Array.isArray(vm.MiscFeesList)) {
				MessageService.showToast("Part table or labor or misc fees table data invalid.");
				return;
			}

			var existingPartsAndInventoriesNameList = '';
			var newPartsAndInventoriesNameList = '';

			vm.partList.forEach(function (item, index) {
				if (!item) {
					return;
				}

				if (item.partData) {
					if (partTableDetail.existingPartIdList.indexOf(item.partData.id_work_order_part) != -1) {
						existingPartsAndInventoriesNameList = GeneralTools.stringConnector(existingPartsAndInventoriesNameList, dot + item.partData.name, '\n');
					} else if (partTableDetail.newItemIndexList.indexOf(index) != -1) {
						newPartsAndInventoriesNameList = GeneralTools.stringConnector(newPartsAndInventoriesNameList, dot + item.partData.name + splitNewItemTag, '\n');
					}
				} else if (item.inventoryData) {
					if (partTableDetail.existingInventoryIdList.indexOf(item.inventoryData.id_work_order_inventory) != -1) {
						existingPartsAndInventoriesNameList = GeneralTools.stringConnector(existingPartsAndInventoriesNameList, dot + item.inventoryData.name, '\n');
					} else if (partTableDetail.newItemIndexList.indexOf(index) != -1) {
						newPartsAndInventoriesNameList = GeneralTools.stringConnector(newPartsAndInventoriesNameList, dot + item.inventoryData.name + splitNewItemTag, '\n');
					}
				}
			});

			var existingLaborNameList = '';
			var newLaborNameList = '';

			vm.laborList.forEach(function (item, index) {
				if (!item || !item.laborData) {
					return;
				}

				if (laborTableDetail.existingLaborIdList.indexOf(item.laborData.id_labor) != -1) {
					existingLaborNameList = GeneralTools.stringConnector(existingLaborNameList, dot + item.laborData.name, '\n');
				} else if (laborTableDetail.newLaborIndexList.indexOf(index) != -1) {
					newLaborNameList = GeneralTools.stringConnector(newLaborNameList, dot + item.laborData.name + splitNewItemTag, '\n');
				}
			});

			var existingMiscfeesNameList = '';
			var newgMiscfeesNameList = '';

			vm.MiscFeesList.forEach(function (item, index) {
				if (!item || !item.MiscFees) {
					return;
				}

				if (miscfeesTableDetail.existingMiscfeesIdList.indexOf(item.MiscFees.id_misc_fees) != -1) {
					existingMiscfeesNameList = GeneralTools.stringConnector(existingMiscfeesNameList, dot + item.MiscFees.name, '\n');
				} else if (miscfeesTableDetail.newMiscfeesIndexList.indexOf(index) != -1) {
					newgMiscfeesNameList = GeneralTools.stringConnector(newgMiscfeesNameList, dot + item.MiscFees.name + splitNewItemTag, '\n');
				}
			});

			var confirmMessage = splitConfirmMessage;

			if (existingPartsAndInventoriesNameList || newPartsAndInventoriesNameList) {
				confirmMessage = GeneralTools.stringConnector(confirmMessage, splitPartsMessage, '\n\n');
				confirmMessage = GeneralTools.stringConnector(confirmMessage, existingPartsAndInventoriesNameList, '\n');
				confirmMessage = GeneralTools.stringConnector(confirmMessage, newPartsAndInventoriesNameList, '\n');
			}

			if (existingLaborNameList || newLaborNameList) {
				confirmMessage = GeneralTools.stringConnector(confirmMessage, splitLaborMessage, '\n\n');
				confirmMessage = GeneralTools.stringConnector(confirmMessage, existingLaborNameList, '\n');
				confirmMessage = GeneralTools.stringConnector(confirmMessage, newLaborNameList, '\n');
			}

			if (existingMiscfeesNameList || newgMiscfeesNameList) {
				confirmMessage = GeneralTools.stringConnector(confirmMessage, splitMiscfeesMessage, '\n\n');
				confirmMessage = GeneralTools.stringConnector(confirmMessage, existingMiscfeesNameList, '\n');
				confirmMessage = GeneralTools.stringConnector(confirmMessage, newgMiscfeesNameList, '\n');
			}

			return confirmMessage;
		}

		function onPresetJobAdd(presetJob) {
			if (!presetJob) {
				return;
			}

			var isInventoryAdded = false;

			if (presetJob.partsMap) {
				Object.keys(presetJob.partsMap).forEach(function (partTypeID) {
					if (!Array.isArray(presetJob.partsMap[partTypeID])) {
						return;
					}

					presetJob.partsMap[partTypeID].forEach(function (item) {
						if (!item || !item.isSelected) {
							return;
						}

						const partTableItem = new PartTableItem();

						if (item.partData) {
							const dataCopy = angular.copy(item.partData);
							partTableItem.setPartData(dataCopy);
						}

						if (item.inventoryData) {
							const dataCopy = angular.copy(item.inventoryData);
							partTableItem.setInventoryData(dataCopy);
							isInventoryAdded = true;
						}

						vm.partList.push(partTableItem);
					});
				});
			}

			if (Array.isArray(presetJob.labors)) {
				presetJob.labors.forEach(function (item) {
					if (!item || !item.isSelected) {
						return;
					}

					const dataCopy = angular.copy(item.laborData);
					vm.laborList.push({ laborData: dataCopy });
				});
			}

			if (isInventoryAdded) {
				refreshDemandMap();
			}
		}
		function onPresetJobTypeAdd(presetJob) {
			if (!presetJob) {
				return;
			}




			presetJob.job_part.forEach(function (item) {
				if (!item || !item.isSelected) {
					return;
				}
				const partTableItem = new PartTableItem();

				var part = new WorkOrderPart();
				part.setAttributes({
					name: item.part_name,
					fk_id_part_type: item.fk_id_parttype,
					quantity: +item.fk_id_parttype,
					retail_price: 10,
					code: item.part_code
				})

				vm.partTypes.forEach(function (parttype) {
					if (parttype.id_part_type == +item.fk_id_parttype) {
						part.retail_price = parttype.default_retail
					}
				})
				if (item) {
					const dataCopy = angular.copy(part);
					partTableItem.setPartData(dataCopy);
				}
				vm.partList.push(partTableItem);
			});


			if (presetJob.job_labour) {
				presetJob.job_labour.forEach(function (item) {
					if (!item || !item.isSelected) {
						return;
					}

					var labor = new Labor();
					labor.setAttributes({
						name: item.labour_name,
						hour: +item.labour_quantity,
						fk_id_labour_type: +item.fk_id_labourtype,
						price: null
					})

					vm.labourlist.forEach(function (labour) {
						if (labour.id_labour_type == +item.fk_id_labourtype) {
							labor.price = labour.default_rate
						}
					})


					const dataCopy = angular.copy(labor);
					vm.laborList.push({ laborData: dataCopy });


				});
			}

			if (presetJob.job_miscfee) {
				presetJob.job_miscfee.forEach(function (item) {
					if (!item || !item.isSelected) {
						return;
					}
					var MiscFees = {
						MiscFees: {
							name: item.miscfees_name,
							quantity: +item.miscfees_quantity,
							fk_misc_fees_type: +item.fk_id_miscfeestype,
							price: null
						}
					}
					vm.allmiscfeestypeslist.forEach(function (miscfeestypes) {
						if (miscfeestypes.id_miscfee == +item.fk_id_miscfeestype) {
							MiscFees.MiscFees.price = miscfeestypes.default_retail_price
						}
					})
					vm.MiscFeesList.push(MiscFees);
				});
			}


		}

		function redeemSalePackageItem(salePackage, packageItem) {
			vm.isRedeeming = true;
			DialogService.showYesOrNoDialog(null, "Are you sure to redeem: " + packageItem.name)
				.then(function (isYes) {
					if (!isYes) {
						return $q.reject();
					}

					const resourcePath = {
						companyID: companyID,
						vehicleID: $stateParams.vehicleID,
						saleinfoID: salePackage.fk_id_sale_info,
						packageID: salePackage.id_sale_package,
						packageitemID: packageItem.id_sale_package_item,
						workorderID: vm.workOrder.id_work_order,
						currentmileage: vm.saleInfo.mileage
					};

					return SaleInfoService.redeemSalePackageItem(resourcePath).$promise;
				})
				.then(function () {
					if (vm.availableItems
						&& vm.availableItems[salePackage.id_sale_package]
						&& Array.isArray(vm.availableItems[salePackage.id_sale_package].packageItems)) {

						vm.availableItems[salePackage.id_sale_package].packageItems.find(function (item) {
							if (item && item.id_sale_package_item == packageItem.id_sale_package_item) {
								item.quantity--;
								return true;
							}
						});

						MessageService.showToast("Item is redeemed.")
					}

				})
				.catch(function (error) {
					if (error) {
						MessageService.showToast(error);
					}
				})
				.finally(function () {
					vm.isRedeeming = false;
				});
		}

		//given a jobtype. extract the discount form it's part/misc/labour
		function redeemPackageDiscount(coverage_job) {
			var discount_str = ""
			var totaDiscount = 0;
			var totalPartDiscount = 0;
			var totalLaborDiscount = 0;
			var totalMiscfeeDiscount = 0;
			var partList_temp = [];
			var laborList_temp = [];
			var miscfeeList_temp = [];

			//copy and clear the from the current part list
			vm.partList.forEach(function (part) {

				if (partList_temp.length == 0) {
					const foundparttypename = vm.partTypes.find(function (parttype) {
						if (+parttype.id_part_type === part.type) {
							return parttype
						}
					});
					partList_temp.push({
						part_type: part.type,
						part_type_total: part.retailPrice * part.quantity,
						part_type_total_quantity: parseFloat(part.quantity),
						part_type_name: (foundparttypename ? foundparttypename.name : part.name)
					})
				} else {
					var foundmatch = false
					partList_temp.forEach(function (temp_part) {
						if (part.type == temp_part.part_type) {
							foundmatch = true
							temp_part.part_type_total += part.retailPrice * part.quantity,
								temp_part.part_type_total_quantity += parseFloat(part.quantity)
						}
					})

					if (!foundmatch) {
						const foundparttypename = vm.partTypes.find(function (parttype) {
							if (+parttype.id_part_type === part.type) {
								return parttype
							}
						});
						partList_temp.push({
							part_type: part.type,
							part_type_total: part.retailPrice * part.quantity,
							part_type_total_quantity: parseFloat(part.quantity),
							part_type_name: (foundparttypename ? foundparttypename.name : part.name)
						})
					}
				}
			})
			//copy and clear the from the current labor list
			vm.laborList.forEach(function (labor) {
				if (laborList_temp.length == 0) {

					const foundlabourtypename = vm.labourlist.find(function (labourtype) {
						if (+labourtype.id_labour_type === labor.laborData.fk_id_labour_type) {
							return labourtype
						}
					});

					laborList_temp.push({
						labor_type: labor.laborData.fk_id_labour_type,
						labor_type_total: +labor.laborData.price * +labor.laborData.hour,
						labor_type_total_hour: +labor.laborData.hour,
						labor_type_name: (foundlabourtypename ? foundlabourtypename.labour_name : "None")
					})
				} else {
					var foundmatch = false
					laborList_temp.forEach(function (temp_labor) {
						if (labor.laborData.fk_id_labour_type == temp_labor.labor_type) {
							foundmatch = true
							temp_labor.labor_type_total += +labor.laborData.price * +labor.laborData.hour,
								temp_labor.labor_type_total_hour += +labor.laborData.hour
						}
					})

					if (!foundmatch) {

						const foundlabourtypename = vm.labourlist.find(function (labourtype) {
							if (+labourtype.id_labour_type === labor.laborData.fk_id_labour_type) {
								return labourtype
							}
						});

						laborList_temp.push({
							labor_type: labor.laborData.fk_id_labour_type,
							labor_type_total: +labor.laborData.price * +labor.laborData.hour,
							labor_type_total_hour: +labor.laborData.hour,
							labor_type_name: (foundlabourtypename ? foundlabourtypename.labour_name : "None")
						})
					}
				}
			})
			//copy and clear the from the current misc fee list
			vm.MiscFeesList.forEach(function (miscfee) {
				if (miscfeeList_temp.length == 0) {
					const foundmiscfeetypename = vm.allmiscfeestypeslist.find(function (miscfeetype) {
						if (+miscfeetype.id_miscfee === miscfee.MiscFees.fk_misc_fees_type) {
							return miscfeetype
						}
					});
					miscfeeList_temp.push({
						miscfee_type: miscfee.MiscFees.fk_misc_fees_type,
						miscfee_type_total: +miscfee.MiscFees.price * +miscfee.MiscFees.quantity,
						miscfee_type_total_quantity: +miscfee.MiscFees.quantity,
						misfee_type_name: (foundmiscfeetypename ? foundmiscfeetypename.name : "None")
					})
				} else {
					var foundmatch = false
					miscfeeList_temp.forEach(function (temp_miscfee) {
						if (miscfee.MiscFees.fk_misc_fees_type == temp_miscfee.miscfee_type) {
							foundmatch = true
							temp_miscfee.miscfee_type_total += +miscfee.MiscFees.price * +miscfee.MiscFees.quantity,
								temp_miscfee.miscfee_type_total_quantity += +miscfee.MiscFees.quantity
						}
					})

					if (!foundmatch) {

						const foundmiscfeetypename = vm.allmiscfeestypeslist.find(function (miscfeetype) {
							if (+miscfeetype.id_miscfee === miscfee.MiscFees.fk_misc_fees_type) {
								return miscfeetype
							}
						});

						miscfeeList_temp.push({
							miscfee_type: miscfee.MiscFees.fk_misc_fees_type,
							miscfee_type_total: +miscfee.MiscFees.price * +miscfee.MiscFees.quantity,
							miscfee_type_total_quantity: +miscfee.MiscFees.quantity,
							misfee_type_name: (foundmiscfeetypename ? foundmiscfeetypename.name : "None")
						})
					}
				}
			})

			if (coverage_job.length > 0) {
				coverage_job.forEach(function (job) {
					if (job && job.JobType) {
						//iterate through coverage part and calculate the part coverage
						if (job.JobType.job_part.length > 0) {
							job.JobType.job_part.forEach(function (part) {
								const partTypeToFind = +part.fk_id_parttype;
								const foundPart = partList_temp.find(function (part) {
									if (+part.part_type === partTypeToFind) {
										return part
									}
								});
								if (foundPart) {
									if (parseFloat(foundPart.part_type_total_quantity) >= parseFloat(part.part_quantity)) {
										// check if the coverage is greater than the total, if so only discount the total part
										if (parseFloat((+part.part_coverage)) <= parseFloat(foundPart.part_type_total)) {

											totalPartDiscount += parseFloat((+part.part_coverage))
											discount_str += foundPart.part_type_name + " Reduction: $" + parseFloat((+part.part_coverage)) + ".\n"
											foundPart.part_type_total -= parseFloat((+part.part_coverage))


										} else {

											totalPartDiscount += parseFloat((foundPart.part_type_total))
											discount_str += foundPart.part_type_name + " Reduction: $" + parseFloat((foundPart.part_type_total)) + ".\n"
											foundPart.part_type_total = 0


										}
										foundPart.part_type_total_quantity -= parseFloat((+part.part_quantity))

									} else {
										// case we only cover partial of the part cost
										var percentageofquantity = parseFloat((+foundPart.part_type_total_quantity / +part.part_quantity));
										if (parseFloat((+part.part_coverage * percentageofquantity)) <= foundPart.part_type_total) {

											totalPartDiscount += + parseFloat((+part.part_coverage * percentageofquantity));
											foundPart.part_type_total -= parseFloat((+part.part_coverage * percentageofquantity));
											discount_str += foundPart.part_type_name + " Reduction: $" + parseFloat((+part.part_coverage * percentageofquantity)) + ".\n"
										} else {

											totalPartDiscount += parseFloat(foundPart.part_type_total)
											foundPart.part_type_total = 0
											discount_str +=foundPart.part_type_name + " Reduction: $" + parseFloat(foundPart.part_type_total) + ".\n"
										}
										foundPart.part_type_total_quantity -= parseFloat((+part.part_quantity))
									}

								}
							})

						}
						//discount_str += "Total Discount from Part: " + totalPartDiscount + ".\n\n"
						//iterate through coverage labour and calculate the labour coverage
						if (job.JobType.job_labour.length > 0) {
							job.JobType.job_labour.forEach(function (labour) {
								const labourTypeToFind = +labour.fk_id_labourtype;
								const foundlabour = laborList_temp.find(function (labour) {
									if (+labour.labor_type === labourTypeToFind) {
										return labour
									}
								});

								if (foundlabour) {

									if (parseFloat(foundlabour.labor_type_total_hour) >= parseFloat(labour.labour_quantity)) {
										if (parseFloat((labour.labour_coverage)) <= parseFloat(foundlabour.labor_type_total)) {


											totalLaborDiscount += parseFloat(labour.labour_coverage)
											discount_str += foundlabour.labor_type_name + " Reduction: $" + parseFloat(labour.labour_coverage) + ".\n"
											foundlabour.labor_type_total -= parseFloat(labour.labour_coverage)


										} else {


											totalLaborDiscount += parseFloat(foundlabour.labor_type_total)
											discount_str += foundlabour.labor_type_name + " Reduction: $" + parseFloat(foundlabour.labor_type_total) + ".\n"
											foundlabour.labor_type_total = 0


										}
										foundlabour.labor_type_total_hour -= parseFloat((labour.labour_quantity))
									} else {
										var percentageofquantity = parseFloat((parseFloat(foundlabour.labor_type_total_hour) / parseFloat(labour.labour_quantity)));
										if (parseFloat((+labour.labour_coverage * percentageofquantity)) <= parseFloat(foundlabour.labor_type_total)) {


											totalLaborDiscount += parseFloat(parseFloat(labour.labour_coverage) * parseFloat(percentageofquantity));
											discount_str += foundlabour.labor_type_name + " Reduction: $" + parseFloat(parseFloat(labour.labour_coverage) * parseFloat(percentageofquantity)) + ".\n"
											foundlabour.labor_type_total -= parseFloat((parseFloat(labour.labour_coverage) * parseFloat(percentageofquantity)));


										} else {


											totalLaborDiscount += parseFloat(foundlabour.labor_type_total)
											discount_str += foundlabour.labor_type_name + " Reduction: $" + parseFloat(foundlabour.labor_type_total) + ".\n"
											foundlabour.labor_type_total = 0


										}
										foundlabour.labor_type_total_hour -= parseFloat((labour.labour_quantity))
									}
								}
							})
						}
						//discount_str += "Total Discount from Labor: " + totalLaborDiscount + ".\n\n"
						//iterate through coverage miscfee and calculate the miscfee coverage
						if (job.JobType.job_miscfee.length > 0) {
							job.JobType.job_miscfee.forEach(function (miscfee) {

								const miscfeeTypeToFind = +miscfee.fk_id_miscfeestype;
								const foundmiscfee = miscfeeList_temp.find(function (miscfee) {
									if (+miscfee.miscfee_type === miscfeeTypeToFind) {
										return miscfee
									}
								});

								if (foundmiscfee) {

									if (parseFloat(foundmiscfee.miscfee_type_total_quantity) >= parseFloat(miscfee.miscfees_quantity)) {
										if (parseFloat((miscfee.miscfees_coverage)) <= parseFloat(foundmiscfee.miscfee_type_total)) {


											totalMiscfeeDiscount += parseFloat(miscfee.miscfees_coverage)
											discount_str += foundmiscfee.misfee_type_name + " Reduction: $" + parseFloat(miscfee.miscfees_coverage) + ".\n"
											foundmiscfee.miscfee_type_total -= parseFloat(miscfee.miscfees_coverage)


										} else {


											totalMiscfeeDiscount += parseFloat(foundmiscfee.miscfee_type_total)
											discount_str += foundmiscfee.misfee_type_name + " Reduction: $" + parseFloat(foundmiscfee.miscfee_type_total) + ".\n"
											foundmiscfee.miscfee_type_total = 0


										}
										foundmiscfee.miscfee_type_total_quantity -= parseFloat((miscfee.miscfees_quantity))
									} else {
										var percentageofquantity = parseFloat((parseFloat(foundmiscfee.miscfee_type_total_quantity) / parseFloat(miscfee.miscfees_quantity)));
										if (parseFloat((+miscfee.miscfees_coverage * percentageofquantity)) <= parseFloat(foundmiscfee.miscfee_type_total)) {


											totalMiscfeeDiscount += parseFloat(parseFloat(miscfee.miscfees_coverage) * parseFloat(percentageofquantity));
											discount_str += foundmiscfee.misfee_type_name + " Reduction: $" + parseFloat(parseFloat(miscfee.miscfees_coverage) * parseFloat(percentageofquantity)) + ".\n"
											foundmiscfee.miscfee_type_total -= parseFloat((parseFloat(miscfee.miscfees_coverage) * parseFloat(percentageofquantity)));


										} else {


											totalMiscfeeDiscount += parseFloat(foundmiscfee.miscfee_type_total)
											discount_str += foundmiscfee.misfee_type_name + " Reduction: $" + parseFloat(foundmiscfee.miscfee_type_total) + ".\n"
											foundmiscfee.miscfee_type_total = 0


										}
										foundmiscfee.miscfee_type_total_quantity -= parseFloat((miscfee.miscfees_quantity))
									}
								}
							})
						}
					}
					//discount_str += "Total Discount from Misc fee: " + totalMiscfeeDiscount + ".\n\n"
				})

			}

			totaDiscount = parseFloat((parseFloat(totalPartDiscount) + parseFloat(totalLaborDiscount) + parseFloat(totalMiscfeeDiscount)).toFixed(2))
			discount_str += "Total Discount: $" + totaDiscount + ".\n"


			return {
				discount: totaDiscount,
				discount_str: discount_str
			}
		}

		function redeemwithoutDiscount(workorderPackage, packageItem) {
			vm.isRedeeming = true;

			const resourcePath = {
				companyID: companyID,
				vehicleID: $stateParams.vehicleID,
				packageID: workorderPackage.id_work_order_package,
				packageitemID: packageItem.id_work_order_package_item,
				workorderID: workorderPackage.fk_id_work_order,
				currentmileage: vm.vehicle.mileage,
				workOrderRequestFrom: $stateParams.workOrderID
			};
			WorkOrderService.redeemWorkOrderPackageItem(resourcePath).$promise.then(function () {
				if (vm.availableWorkOrderItems
					&& vm.availableWorkOrderItems[workorderPackage.id_work_order_package]
					&& Array.isArray(vm.availableWorkOrderItems[workorderPackage.id_work_order_package].packageItems)) {
					vm.availableWorkOrderItems[workorderPackage.id_work_order_package].packageItems.find(function (item) {
						if (item && item.id_work_order_package_item == packageItem.id_work_order_package_item) {
							item.quantity--;
							return true;
						}
					});

					MessageService.showToast("Item is redeemed.")
				}

			})
				.catch(function (error) {
					if (error) {
						MessageService.showToast(error);
					}
				})
				.finally(function () {
					vm.isRedeeming = false;
				});

		}

		function redeemwithDiscount(workorderPackage, packageItem, discount_amount) {
			vm.isRedeeming = true;
			const discount = new WorkOrderDiscount();

			discount.description = "Package Redeem Discount ID: " + packageItem.name;
			discount.is_percentage = false;
			discount.amount_off = GeneralTools.preciseNumber(discount_amount, 2);

			//addDiscount(discount)
			
			const resourcePath = {
				companyID: companyID,
				vehicleID: $stateParams.vehicleID,
				packageID: workorderPackage.id_work_order_package,
				packageitemID: packageItem.id_work_order_package_item,
				workorderID: workorderPackage.fk_id_work_order,
				currentmileage: vm.vehicle.mileage,
				workOrderRequestFrom: $stateParams.workOrderID
			};

			addDiscount(discount).then(function(){
				WorkOrderService.redeemWorkOrderPackageItem(resourcePath).$promise.then(function () {
					if (vm.availableWorkOrderItems
						&& vm.availableWorkOrderItems[workorderPackage.id_work_order_package]
						&& Array.isArray(vm.availableWorkOrderItems[workorderPackage.id_work_order_package].packageItems)) {
						vm.availableWorkOrderItems[workorderPackage.id_work_order_package].packageItems.find(function (item) {
							if (item && item.id_work_order_package_item == packageItem.id_work_order_package_item) {
								item.quantity--;
								return true;
							}
						});
	
						MessageService.showToast("Item is redeemed.")
					}
	
				})
					.catch(function (error) {
						if (error) {
							MessageService.showToast(error);
						}
					})
					.finally(function () {
						vm.isRedeeming = false;
					});
			})
		}

		function optionRedeemWorkOrderPackageItem(workorderPackage, packageItem) {

			var selectedPackageItem;
			var coverage_job = [];

			if (packageItem && packageItem.fk_id_preset_package_item) {
				vm.presetPackages.forEach(function (presentpackage) {
					if (presentpackage.items && presentpackage.items.length > 0) {
						presentpackage.items.forEach(function (presentpackageitem) {
							if (presentpackageitem.id_preset_package_item == packageItem.fk_id_preset_package_item) {
								selectedPackageItem = angular.copy(presentpackageitem)
							}
						})
					}
				})

			}

			if (selectedPackageItem && selectedPackageItem.fk_id_job) {
				coverage_job.push(vm.JobTypeList.find(function (job) {
					if (job.JobType.id_job === selectedPackageItem.fk_id_job) {
						return job
					}
				}))
				if (coverage_job) {
					var resultA = redeemPackageDiscount(coverage_job);
				}
			}

			var packageNameStr = "Are you sure to redeem: " + packageItem.name

			if(resultA && resultA.discount <= 0){
				redeemWorkOrderPackageItem(workorderPackage, packageItem)
			}else{


				if (resultA && resultA.discount_str && resultA.discount > 0) {
					packageNameStr = packageNameStr + "\nThis redemption contain the following: \n" + resultA.discount_str
				}
	
	
				var dialogOptions = {};
	
				dialogOptions.titleString = "Redeeming Package";
				dialogOptions.contentString = "";
				dialogOptions.contentString += packageNameStr;
				var confirmOption = {};
	
				confirmOption.optionName = "Yes, with reduction";
				confirmOption.onClick = function () {

					if(resultA && resultA.discount > 0){
						redeemwithDiscount(workorderPackage, packageItem, resultA.discount)
					}else{
						redeemwithDiscount(workorderPackage, packageItem, 0)
					}


					
					DialogService.close();
				}
	
				var cancelOption = {};
				cancelOption.optionName = "NO";
				cancelOption.onClick = function () {
					DialogService.close();
				}
	
				var maybeOption = {};
				maybeOption.optionName = "Yes without reduction";
				maybeOption.onClick = function () {
					redeemwithoutDiscount(workorderPackage, packageItem)
					
					DialogService.close();
				}
	
				dialogOptions.options = [confirmOption, maybeOption, cancelOption];
	
				DialogService.showOptionsDialog(dialogOptions);
			}
		}

		function redeemWorkOrderPackageItem(workorderPackage, packageItem) {
			vm.isRedeeming = true;

			DialogService.showYesOrNoDialog(null, "Are you sure to redeem: " + packageItem.name + ", there is currently no items or fees to be redeemed?")
				.then(function (isYes) {
					if (!isYes) {
						return $q.reject();
					}

					const resourcePath = {
						companyID: companyID,
						vehicleID: $stateParams.vehicleID,
						packageID: workorderPackage.id_work_order_package,
						packageitemID: packageItem.id_work_order_package_item,
						workorderID: workorderPackage.fk_id_work_order,
						currentmileage: vm.vehicle.mileage,
						workOrderRequestFrom: $stateParams.workOrderID
					};
					return WorkOrderService.redeemWorkOrderPackageItem(resourcePath).$promise;
				})
				.then(function () {
					if (vm.availableWorkOrderItems
						&& vm.availableWorkOrderItems[workorderPackage.id_work_order_package]
						&& Array.isArray(vm.availableWorkOrderItems[workorderPackage.id_work_order_package].packageItems)) {
						vm.availableWorkOrderItems[workorderPackage.id_work_order_package].packageItems.find(function (item) {
							if (item && item.id_work_order_package_item == packageItem.id_work_order_package_item) {
								item.quantity--;
								return true;
							}
						});

						MessageService.showToast("Item is redeemed.")
					}

				})
				.catch(function (error) {
					if (error) {
						MessageService.showToast(error);
					}
				})
				.finally(function () {
					vm.isRedeeming = false;
				});
		}

		function initPresetPackages() {
			PresetPackagesService.getPresetPackages({ companyID: companyID }).$promise.then(function (presetPackages) {
				vm.presetPackages = presetPackages;

			});
		}

		function initSalePackages() {
			const resourcePath = {
				companyID: companyID,
				vehicleID: $stateParams.vehicleID,
				saleinfoID: vm.saleInfo.id_sale_info
			};
			SaleInfoService.getSalePackages(resourcePath).$promise.then(function (salePackages) {
				if (!Array.isArray(salePackages)) {
					return $q.reject("salePackages is invalid");
				}
				vm.salePackages = salePackages;

				salePackages.forEach(function (salePackage) {
					fecthSalePackageItems(salePackage.id_sale_package)
				});
			})
				.catch(MessageService.showToast);
		}

		function initWorkOrderPackages() {

			const workOrderPackageList = WorkOrderDataSharingService.getWorkOrderPackageList();

			if (!Array.isArray(workOrderPackageList)) {
				return;
			}

			vm.workorderPackages = [];

			vm.workorderPackages = angular.copy(workOrderPackageList)

			vm.workorderPackages.forEach(function (workorderPackage) {
				fecthWorkOrderPackageItems(workorderPackage.id_work_order_package)
			});
		}

		function fecthWorkOrderPackageItems(workorderpackageID) {
			const resourcePath = {
				companyID: companyID,
				vehicleID: $stateParams.vehicleID,
				workorderID: $stateParams.workOrderID,
				packageID: workorderpackageID
			};

			WorkOrderService.getWorkOrderpackageItems(resourcePath).$promise.then(function (items) {
				vm.workOrderPackageItemsMap[workorderpackageID] = items;
			})
				.catch(MessageService.showToast);
		}

		function fecthSalePackageItems(packageID) {
			const resourcePath = {
				companyID: companyID,
				vehicleID: $stateParams.vehicleID,
				saleinfoID: vm.saleInfo.id_sale_info,
				packageID: packageID
			};

			SaleInfoService.getSalePackageItems(resourcePath).$promise.then(function (items) {
				vm.packageItemsMap[packageID] = items;
			})
				.catch(MessageService.showToast);
		}

		function addWorkOrderPackage(presetPackage) {
			vm.isAddingPackages = true;

			const resourcePath = {
				companyID: companyID,
				vehicleID: $stateParams.vehicleID,
				workorderID: $stateParams.workOrderID
			}

			const workorderPackage = new WorkOrderPackage();
			workorderPackage.pullDataFromPresetPackage(presetPackage);


			return WorkOrderService.createWorkOrderPackage(resourcePath, workorderPackage).$promise
				.then(function (workOrderPackageID) {
					workorderPackage.id_work_order_package = workOrderPackageID;
					vm.workorderPackages.push(workorderPackage);
					vm.packageItemsMap[workOrderPackageID] = [];
					WorkOrderDataSharingService.setWorkOrderPackageList(vm.workorderPackages);
					presetPackage.items.forEach(function (item) {
						vm.packageItemsMap[workOrderPackageID].push({
							name: item.name,
							quantity: item.quantity,
							origin_quantity: item.quantity,
							fk_id_preset_package_item: item.id_preset_package_item
						});
					});
				})
				.catch(MessageService.showToast)
				.finally(function () {
					vm.isAddingPackages = false;
				});
		}

		function deleteWorkOrderPackage(workorderPackage, presetPackage) {
			vm.isDeletingPackage = true;
			const newWorkorderPackage = new WorkOrderPackage();
			newWorkorderPackage.pullDataFromPresetPackage(presetPackage)
			var dialogPromise = $q.resolve(true);
			if (!workorderPackage.getExpiryDateMomentObj().isSame(newWorkorderPackage.getExpiryDateMomentObj()) || (presetPackage.valid_mileage && workorderPackage.expiry_mileage && presetPackage.valid_mileage != 0 && (workorderPackage.expiry_mileage - vm.vehicle.mileage - presetPackage.valid_mileage) != 0)) {
				dialogPromise = DialogService.showYesOrNoDialog("Unselect Package", "Unselecting this package will result in resetting the expiry date and covering mileage if you choose to add it again.")
			}

			return dialogPromise
				.then(function (isYes) {
					if (isYes) {
						const resourcePath = {
							companyID: companyID,
							vehicleID: $stateParams.vehicleID,
							workorderID: $stateParams.workOrderID,
							packageID: workorderPackage.id_work_order_package
						}
						return WorkOrderService.deleteWorkOrderPackage(resourcePath).$promise;
					}

					return $q.reject();
				})
				.then(function () {
					const index = vm.workorderPackages.findIndex(function (item) {
						return !!item && item.id_work_order_package == workorderPackage.id_work_order_package;
					});
					vm.workorderPackages.splice(index, 1);
					WorkOrderDataSharingService.setWorkOrderPackageList(vm.workorderPackages);
				})

				.catch(function (error) {
					if (error) {
						MessageService.showToast(error);
					}
				})
				.finally(function () {
					vm.isDeletingPackage = false;
				});
		}

		function onSendClientRegistrationEmail() {
			if(!vm.customerRegistrationTempHolder){
				MessageService.showToast("Please choose the designated customer associated with this vehicle.");
				return
			}

			if(!vm.clientEmailAddressHolder){
				MessageService.showToast("The Reciver email address could not be empty.");
				return
			}

			const resourcePath = {
				companyID: companyID,
				vehicleID: $stateParams.vehicleID,
				customerVehicleID: $stateParams.vehicleID,
			}
			const requestBody = {
				userID: userInfo.userID,
				workorderID: $stateParams.workOrderID,
				customerEmailAddress: vm.clientEmailAddressHolder,
				id_customer: vm.customerRegistrationTempHolder.customerInfo.id_customer

			}
			vm.sendingRegistrationEmail = true

			return WorkOrderService.sendCustomerRegistrationEmail(resourcePath, requestBody)
				.then(function (result) {
					vm.sendingRegistrationEmail = false
			})

		}

		function getWorkOrderWarrantyRequestBodys() {
			const workOrderWarrantyToCreate = [];
			const workOrderWarrantyToUpdate = [];



			if (!Array.isArray(vm.workorderWarranty)) {
				return;
			}

			vm.workorderWarranty.forEach(function (item, index) {
				if (!item) {
					return;
				}

				if (!item.id_work_order_warranty) {
					workOrderWarrantyToCreate.push({
						index: index,
						requestBody: item
					});
					return;
				}

				const changedProperties = getUpdateWorkOrderWarrantyRequestBody(item);
				if (!!changedProperties) {
					workOrderWarrantyToUpdate.push({
						requestBody: changedProperties,
						id_work_order_warranty: item.id_work_order_warranty
					});
				}
			});

			if (workOrderWarrantyToCreate.length <= 0 && workOrderWarrantyToUpdate.length <= 0) {
				return;
			}
			return {
				workOrderWarrantyToCreate: workOrderWarrantyToCreate,
				workOrderWarrantyToUpdate: workOrderWarrantyToUpdate
			}
		}

		function getUpdateWorkOrderWarrantyRequestBody(workOrderWarranty) {

			const originWorkOrderWarrantyList = WorkOrderDataSharingService.getWorkOrderWarrantyList();

			if (!workOrderWarranty || !workOrderWarranty.id_work_order_warranty) {
				return;
			}

			if (!Array.isArray(originWorkOrderWarrantyList)) {
				return;
			}

			const originWorkOrderWarranty = originWorkOrderWarrantyList.find(function (item) {
				if (!item) {
					return;
				}

				return item.id_work_order_warranty == workOrderWarranty.id_work_order_warranty;
			});

			if (!originWorkOrderWarranty) {
				return;
			}

			const changedProperties = GeneralTools.updateResourceRequestBodyGenerator(workOrderWarranty, originWorkOrderWarranty);
			if (!!changedProperties) {
				return changedProperties;
			}
		}


		function saveWorkOrderWarranty(requestBody) {
			if (!requestBody) {
				return;
			}

			return $q.all([createWorkOrderWarrantyHelper(requestBody.workOrderWarrantyToCreate), updateWorkOrderWarranty(requestBody.workOrderWarrantyToUpdate)])
				.then(function () {
					resetOriginWorkOrderWarrantyList();
					return $q.resolve();
				});
		}

		function createWorkOrderWarrantyHelper(requestBodyList) {
			if (!Array.isArray(requestBodyList)) {
				return $q.reject("createWorkOrderWarranty requestBodyList invalid");
			}

			const queue = [];
			requestBodyList.forEach(function (item) {
				if (!item) {
					return;
				}

				queue.push(createWorkOrderWarranty(item.requestBody, item.index));
			});

			return $q.all(queue);
		}

		function createWorkOrderWarranty(requestBody, index) {
			const resourcePath = {
				companyID: companyID,
				vehicleID: $stateParams.vehicleID,
				workorderID: $stateParams.workOrderID,
			}
			return WorkOrderService.createWorkOrderWarranty(resourcePath, requestBody)
				.then(function (newWorkOrderWarrantyId) {
					if (Array.isArray(vm.workorderWarranty) && vm.workorderWarranty[index] && vm.workorderWarranty[index].$$hashKey) {
						vm.workorderWarranty[index].id_work_order_warranty = newWorkOrderWarrantyId;
					}
					return $q.resolve();
				})
		}

		function updateWorkOrderWarranty(requestBodyList) {
			if (!Array.isArray(requestBodyList)) {
				return $q.reject("updateWorkOrderWarranty requestBodyList invalid");
			}

			const queue = [];

			requestBodyList.forEach(function (item) {
				if (!item) {
					return;
				}
				const resourcePath = {
					companyID: companyID,
					vehicleID: $stateParams.vehicleID,
					workorderID: $stateParams.workOrderID,
					warrantyID: item.id_work_order_warranty
				}

				queue.push(WorkOrderService.updateWorkOrderWarranty(resourcePath, item));
			});

			return $q.all(queue);
		}

		function resetOriginWorkOrderWarrantyList() {
			const workOrderWarrantyList = [];

			if (!Array.isArray(vm.workorderWarranty)) {
				return;
			}
			vm.workorderWarranty.forEach(function (item) {
				if (item) {
					workOrderWarrantyList.push(item);
				}
			});
			WorkOrderDataSharingService.setWorkOrderWarrantyList(workOrderWarrantyList);
		}

		function saveWorkOrderWarrantyButtonClick() {
			vm.isSaving = true;
			console.log("on Warranty Save Clicked")
			saveWorkOrderWarrantyButtonClickHandler().then(function () {
				MessageService.showToast("Success.")
			})
				.catch(MessageService.showToast)
				.finally(function () {
					vm.isSaving = false;
				});

		}

		function saveWorkOrderWarrantyButtonClickHandler() {
			if (!vm.isInfoFormValid()) {
				return $q.reject("Something wrong in info form.");
			}

			if (vm.isWarrntySectionValid && !vm.isWarrntySectionValid()) {
				return $q.reject(warrantyTableInvalidMessage);
			}

			const queue = [];

			const workOrderWarrantyRequestBody = getWorkOrderWarrantyRequestBodys();

			if (workOrderWarrantyRequestBody) {
				queue.push(saveWorkOrderWarranty(workOrderWarrantyRequestBody));
			}
			if (queue.length <= 0) {
				return $q.reject("No changes detected.");
			}

			return $q.all(queue);
		}

		

	}
})();
(function ()
{
	'use strict';

	angular
		.module('app.workOrders')
		.controller('EditWorkOrderDiscountsController', EditWorkOrderDiscountsController);

	function EditWorkOrderDiscountsController($rootScope, $q, WorkOrderDiscount, GeneralTools, WorkOrderDataSharingService, WorkOrderRDRedeemed, DialogService, $location, CustomersService, customerserviceMap, customersaleInfos, LoginService, $scope, MessageService, WorkOrderService, $stateParams, WorkOrderConstants){
		const vm = this;
		const companyID = LoginService.getCompanyID();
		const userInfo = LoginService.getUserInfo();
		vm.selectedMap = {};

		vm.rogersDollarselectedMap = {};
		vm.addDiscount = addDiscount;
		vm.percentageTransaletor = percentageTransaletor;
		vm.isAnyItemSelected = isAnyItemSelected;
		vm.isAnyRogersDollarRedeemItemSelected = isAnyRogersDollarRedeemItemSelected;
		vm.deleteDiscounts = deleteDiscounts;
		vm.redeemRogerDollar = redeemRogerDollar;
		vm.deletRogerDollarRedeem = deletRogerDollarRedeem;
		vm.discountsAnchorTag = WorkOrderConstants.anchorTags.discounts;
		vm.translateToDollar = GeneralTools.inputTranslators.dollar;
		vm.translateToPercentage = GeneralTools.inputTranslators.percentage;
		vm.redeemamount = 0;
		vm.selectedCustomer
		vm.percentageInputOption = {
			decimalFractionSize:0,
			maxValue:100
		};
		vm.discountsInputOptions = {
			decimalFractionSize: 2
		}
		vm.couponCode = null;
		vm.checkAndAddCouponDiscount = checkAndAddCouponDiscount;
		init();
		initCustomerInfo();
		initWorkOrderRDRedeemed();

		function init(){
			const discounts = WorkOrderDataSharingService.getDiscountList();

			if(Array.isArray(discounts)){
				vm.discounts = discounts;
			} else {
				vm.discounts = [];
			}

			$rootScope.$on(WorkOrderConstants.editWorkOrderEvents.scroll.eventName, function(event, tag){
				GeneralTools.scrollToTag(tag);
			});

			$scope.$watch("vm.discounts.length", function(){
				$scope.$emit(
					WorkOrderConstants.editWorkOrderEvents.updateSummary.eventName, 
					WorkOrderConstants.editWorkOrderEvents.updateSummary.updateDetails.discounts, 
					vm.discounts);
			});

			$scope.$watch("vm.workOrderRDRedeemedList.length", function(){
				$scope.$emit(
					WorkOrderConstants.editWorkOrderEvents.updateSummary.eventName, 
					WorkOrderConstants.editWorkOrderEvents.updateSummary.updateDetails.workOrderRogerDollarRedeemed, 
					vm.workOrderRDRedeemedList);
			});
		}

		function initCustomerInfo(){
			vm.customerList = {};
			if(!Array.isArray(customersaleInfos)){
				return;
			}

			customersaleInfos.forEach(function(saleInfo){
				if(!saleInfo || saleInfo.is_canceled){
					return;
				}

				if(!vm.customerList[saleInfo.fk_id_customer]){
					vm.customerList[saleInfo.fk_id_customer] = {};
				}

				if(!Array.isArray(vm.customerList[saleInfo.fk_id_customer].customersaleInfos)){
					vm.customerList[saleInfo.fk_id_customer].customersaleInfos = [];
				}

				vm.customerList[saleInfo.fk_id_customer].customersaleInfos.push(saleInfo);
			})

			if(!Array.isArray(customerserviceMap)){
				return;
			}

			customerserviceMap.forEach(function(item){
				if(!item || !item.customer){
					return;
				}

				if(!vm.customerList[item.customer.id_customer]){
					vm.customerList[item.customer.id_customer] = {};
				}

				vm.customerList[item.customer.id_customer].customerInfo = {
					first_name: item.customer.first_name,
					last_name: item.customer.last_name,
					id_customer: item.customer.id_customer
				}

				vm.customerList[item.customer.id_customer].customerserviceMap = item.id_service_map;
			});

			const queue = [];
			Object.keys(vm.customerList).forEach(function(customerID){
				queue.push(fetchCustomerData(customerID));
			});

			vm.fetchingCustomersData = true;

			$q.all(queue)
				.then(function(result){
					if(!Array.isArray(result)){
						return $q.reject("Customers data invalid");
					}

					result.forEach(function(customer){
						if(!customer){
							return;
						}

						if(!vm.customerList[customer.id_customer]){
							vm.customerList[customer.id_customer] = {};
						}

						vm.customerList[customer.id_customer].customerInfo = customer;
					});

					return $q.resolve()
				})
				.catch(MessageService.showToast)
				.finally(function(){
					if(vm.customerList){
						for (var customerId in vm.customerList){
							if(vm.workOrder){
								var customer = vm.customerList[customerId];
								var customerInfo = customer.customerInfo;
								vm.workOrder.selectedCustomer = customer
							}

						  }
					}else{
						vm.selectedCustomer={}
					}
					$location.search({}).replace();
					vm.fetchingCustomersData = false;
				});
		}

		function fetchCustomerData(customerID){
			const resourcePath = {
				companyID: companyID,
				customerID: customerID
			};

			return CustomersService.getCustomers(resourcePath)
				.then(function(result){
					if(!result || !Array.isArray(result.data) || result.data.length != 1 || !result.data[0]){
						return $q.reject("customer data invalid");
					}

					return $q.resolve(result.data[0]);
				})
		}

		function addDiscount(){
			const discount = new WorkOrderDiscount();

			discount.is_percentage = !!vm.isPercentage;
			discount.description = vm.description;

			if(vm.isPercentage){
				discount.percentage_off = vm.amount;
			} else {
				discount.amount_off = vm.amount;
			}

			if(discount.is_percentage && !discount.percentage_off){
				MessageService.showToast("Please enter percentage");
				return;
			}

			if(!discount.is_percentage && !discount.amount_off){
				MessageService.showToast("Please enter amount");
				return;
			}

			const resourcePath = {
				companyID: companyID,
				vehicleID: $stateParams.vehicleID,
				workorderID: $stateParams.workOrderID
			}

			vm.isAddingDiscount = true;
			WorkOrderService.createDiscount(resourcePath, discount)
				.then(function(newDiscountID){
					discount.id_work_order_discount = newDiscountID;
					if(Array.isArray(vm.discounts)){
						vm.discounts.push(discount);
						WorkOrderDataSharingService.setDiscountList(vm.discounts);
					}	
					cleanDiscountInputs();
					MessageService.showToast("Discount is added");
				})
				.catch(MessageService.showToast)
				.finally(function(){
					vm.isAddingDiscount = false;
				});
		}

		function deleteDiscounts(){
			if(!isAnyItemSelected()){
				MessageService.showToast("No item selected");
				return;
			}

			var dialogOptions = {};

			dialogOptions.titleString = "Delete Discounts";
			dialogOptions.contentString = "Are you sure to delete discounts";

			var confirmOption = {};

			confirmOption.optionName = "YES";
			confirmOption.onClick = function(){
				confirmDeleteDiscounts();
				DialogService.close();
			}

			var cancelOption = {};

			cancelOption.optionName = "NO";
			cancelOption.onClick = function(){
				DialogService.close();
			}

			dialogOptions.options = [confirmOption, cancelOption];

			DialogService.showOptionsDialog(dialogOptions);
		}

		function deletRogerDollarRedeem(){
			if(!isAnyRogersDollarRedeemItemSelected()){
				MessageService.showToast("No item selected");
				return;
			}

			var dialogOptions = {};

			dialogOptions.titleString = "Delete Rogers Dollar Redemption";
			dialogOptions.contentString = "Are you sure to delete rogers dollar redemption";

			var confirmOption = {};

			confirmOption.optionName = "YES";
			confirmOption.onClick = function(){
				confirmDeleteRogerDollarRedeem();
				DialogService.close();
			}

			var cancelOption = {};

			cancelOption.optionName = "NO";
			cancelOption.onClick = function(){
				DialogService.close();
			}

			dialogOptions.options = [confirmOption, cancelOption];

			DialogService.showOptionsDialog(dialogOptions);
		}

		function confirmDeleteRogerDollarRedeem(discountID, index){
			if(!vm.rogersDollarselectedMap || !Array.isArray(vm.workOrderRDRedeemedList)){
				return;
			}

			const queue = [];

			vm.workOrderRDRedeemedList.forEach(function(discount){
				if(!discount || ((discount.resourceData &&!vm.rogersDollarselectedMap[discount.resourceData.id_rd_redeemed]) && (discount &&!vm.rogersDollarselectedMap[discount.id_rd_redeemed])) ){
					return;
				}

				
				
				queue.push(deleteRogerDollarRedeem(getRDRedeemItemID(discount)));	
			});

			vm.isDeletingDiscount = true;

			$q.all(queue)
				.then(function(){
					WorkOrderDataSharingService.setRDRedeemeddList(vm.workOrderRDRedeemedList);
				})
				.catch(MessageService.showToast)
				.finally(function(){
					vm.isDeletingDiscount = false;
				})
		}

		function confirmDeleteDiscounts(discountID, index){
			if(!vm.selectedMap || !Array.isArray(vm.discounts)){
				return;
			}

			const queue = [];

			vm.discounts.forEach(function(discount){
				if(!discount || !vm.selectedMap[discount.id_work_order_discount]){
					return;
				}
				
				queue.push(deleteDiscount(discount.id_work_order_discount));	
			});

			vm.isDeletingDiscount = true;

			$q.all(queue)
				.then(function(){
					WorkOrderDataSharingService.setDiscountList(vm.discounts);
				})
				.catch(MessageService.showToast)
				.finally(function(){
					vm.isDeletingDiscount = false;
				})
		}

		function deleteDiscount(discountID){
			const resourcePath = {
				companyID: companyID,
				vehicleID: $stateParams.vehicleID,
				workorderID: $stateParams.workOrderID,
				discountID: discountID
			}

			return WorkOrderService.deleteDiscount(resourcePath)
				.then(function(){
					if(Array.isArray(vm.discounts)){
						const index = vm.discounts.findIndex(function(discount){
							return !!discount && discount.id_work_order_discount == discountID;
						});
						vm.discounts.splice(index, 1);					
					}					
					return $q.resolve();
				});		
		}

		function deleteRogerDollarRedeem(rogerDollarID){
			const resourcePath = {
				companyID: companyID,
				vehicleID: $stateParams.vehicleID,
				workorderID: $stateParams.workOrderID,
				rgdollarsredeemID: rogerDollarID,
			}
			return WorkOrderService.deleteRDRedeem(resourcePath)
				.then(function(){
					if(Array.isArray(vm.workOrderRDRedeemedList)){
						const index = vm.workOrderRDRedeemedList.findIndex(function(discount){
							var redeemid;
							if(discount.resourceData){
								redeemid = discount.resourceData.id_rd_redeemed;
							}else if(discount.id_rd_redeemed){
								redeemid = discount.id_rd_redeemed
							}
							return !!discount && vm.rogersDollarselectedMap[redeemid]
						});
						vm.workOrderRDRedeemedList.splice(index, 1);					
					}					
					return $q.resolve();
				});		
		}

		function percentageTransaletor(){
			if(typeof(vm.amount) != "number"){
				return;
			}

			if(vm.isPercentage){

				if(vm.amount > 100){
					vm.amount = 1;
				} else {
					vm.amount = vm.amount / 100;
				}			
			} else {
				vm.amount = vm.amount * 100;
			}
		}

		function cleanDiscountInputs(){
			vm.description = null;
			vm.amount = null;
		}

		function isAnyItemSelected(){
			if(!vm.selectedMap || !Array.isArray(vm.discounts)){
				return;
			}

			const selectedItem = vm.discounts.find(function(discount){
				return !!discount && vm.selectedMap[discount.id_work_order_discount];
			});

			return !!selectedItem;
		}

		function isAnyRogersDollarRedeemItemSelected(){
			if(!vm.rogersDollarselectedMap || !Array.isArray(vm.workOrderRDRedeemedList)){
				return;
			}

			const selectedItem = vm.workOrderRDRedeemedList.find(function(discount){
				var redeemid;
				if(discount.resourceData){
					redeemid = discount.resourceData.id_rd_redeemed;
				}else if(discount.id_rd_redeemed){
					redeemid = discount.id_rd_redeemed
				}
				return !!discount && vm.rogersDollarselectedMap[redeemid]
			});
			
			return !!selectedItem;
		}

		function redeemRogerDollar(){
			if(!vm.selectedCustomer || !vm.selectedCustomer.customerInfo){
				MessageService.showToast("Please select a customer to redeem from.");
				return;
			}


			if(vm.redeemamount <= 0){
				MessageService.showToast("Please enter a correct amount to redeem.");
				return;
			}

			vm.isRedeeming = true
			const resourcePath = {
				companyID: companyID,
				vehicleID: $stateParams.vehicleID,
				workorderID: $stateParams.workOrderID,
			}
			return WorkOrderService.redeemRogerDollar(resourcePath, {redeemamount: vm.redeemamount, customerID: vm.selectedCustomer.customerInfo.id_customer})
			.then(function (insertID) {
				if(insertID){

					var temp = new WorkOrderRDRedeemed();
					temp.setAttributes({
						id_rd_redeemed: insertID,
						redeemed_amount: vm.redeemamount,
						fk_id_work_order: $stateParams.workOrderID,
						fk_id_user: userInfo.userID,
						fk_id_customer: vm.selectedCustomer.customerInfo.id_customer,
						date: moment().format("YYYY-MM-DD")
					})

					const newArray = [temp].map(function(obj){
						const resourceData  = {
							id_rd_redeemed: insertID,
							fk_id_work_order: parseInt($stateParams.workOrderID),
							fk_id_customer: vm.selectedCustomer.customerInfo.id_customer,
							redeemed_amount: vm.redeemamount,
							date: moment().format("YYYY-MM-DD"),
							fk_id_user: userInfo.userID,
						}
						return resourceData
					})
					
					vm.workOrderRDRedeemedList =  angular.copy(newArray)
					WorkOrderDataSharingService.setRDRedeemeddList(newArray);
					initWorkOrderRDRedeemed();
				}else{
					MessageService.showToast("Redemption failed. The work order may include a redemption.");
				}
				return $q.resolve();
			})
			.catch(MessageService.showToast)
			.finally(function(){
				vm.isRedeeming = false
			});
		}

		function initWorkOrderRDRedeemed() {
			const workOrderRDRedeemed = WorkOrderDataSharingService.getRDRedeemeddList();


			if (!Array.isArray(workOrderRDRedeemed)) {
				return;
			}

			vm.workOrderRDRedeemedList = workOrderRDRedeemed;
		}

		function getRDRedeemItemID(discount){
			var Id;
			if(discount && discount.resourceData){
				Id = discount.resourceData.id_rd_redeemed
			}else if(discount && discount.id_rd_redeemed){
				Id = discount.id_rd_redeemed
			}
			return Id
		}

		function checkAndAddCouponDiscount(){

			if(!vm.couponCode){
				MessageService.showToast("Please enter coupon code");
				return;
			}

			var couponBody = {
				couponCode: vm.couponCode
			};

			const resourcePath = {
				companyID: companyID,
				vehicleID: $stateParams.vehicleID,
				workorderID: $stateParams.workOrderID
			}

			vm.isAddingDiscount = true;
			WorkOrderService.addWorkOrderCoupons(resourcePath, couponBody)
				.then(function(newDiscountID){
					if(Array.isArray(vm.discounts)){
						vm.discounts.push(newDiscountID);
						WorkOrderDataSharingService.setDiscountList(vm.discounts);
					}	
					cleanDiscountInputs();
					MessageService.showToast("Coupon is added");
				})
				.catch(MessageService.showToast)
				.finally(function(){
					vm.isAddingDiscount = false;
				});
		}

	}
})();
(function ()
{
	'use strict';

	angular
		.module('app.workOrders')
		.controller('EditWorkOrderAppointmentsController', EditWorkOrderAppointmentsController);

	function EditWorkOrderAppointmentsController($q, constants, $state, appointments, DialogService, LoginService, GeneralTools, $scope, AppointmentConstants, AppointmentsService, ToolsConstants, MessageService, WorkOrderService, $stateParams, WorkOrderConstants){
		const vm = this;
		const companyID = LoginService.getCompanyID();
		const timeRangeFilterFormat = "YYYY-MM-DD HH:mm:ss";
		const startKeyName = "start";

		vm.addAppointmentUrl = $state.href("app.workorder-schedule", {workOrderID: $stateParams.workOrderID, vehicleID: $stateParams.vehicleID});
		vm.appointments = [];
		vm.removeSelectedAppointments = removeSelectedAppointments;
		vm.updateAppointmentStatus = updateAppointmentStatus;
		vm.isAnyItemSelected = isAnyItemSelected;
		vm.disableDeleteButton = disableDeleteButton;

		init();

		function init(){
			initConstants();
			initAppointments();
			fetchCustomerPortalAppointment();
		}

		function initConstants(){
			if(!constants){
				MessageService.showToast("constants invalid");
				return;
			}

			vm.appointmentStatus = constants.appointmentStatus;
		}

		function initAppointments(){
			if(Array.isArray(appointments)){
				vm.appointments = appointments;
			} else {
				vm.appointments = [];
			}
		}

		function removeSelectedAppointments(){
			var dialogOptions = {};

			dialogOptions.titleString = "Delete Appointments";
			dialogOptions.contentString = "Are you sure to delete selected appointments";

			var confirmOption = {};

			confirmOption.optionName = "YES";
			confirmOption.onClick = function(){
				confirmDeleteSelectedAppointments();
				DialogService.close();
			}

			var cancelOption = {};

			cancelOption.optionName = "NO";
			cancelOption.onClick = function(){
				DialogService.close();
			}

			dialogOptions.options = [confirmOption, cancelOption];

			DialogService.showOptionsDialog(dialogOptions);
		}

		function confirmDeleteSelectedAppointments() {
			if(!vm.selectedMap || !Array.isArray(vm.appointments)){
				return;
			}

			const queue = [];
			vm.isDeletingAppointment = true;

			vm.appointments.forEach(function(appointment){
				if(!appointment || !vm.selectedMap[appointment.id_work_order_appointment]){
					return;
				}
				
				queue.push(deleteAppointment(appointment.id_work_order_appointment));	
			});

			$q.all(queue)
				.then(function(){			
					MessageService.showToast("Appointments is deleted.");
				})
				.catch(MessageService.showToast)
				.finally(function(){
					vm.isDeletingAppointment = false;
				})
		}

		function deleteAppointment(appointmentID){
			const resourcePath = {
				companyID: companyID,
				workorderappointmentID: appointmentID
			}

			return WorkOrderService.deleteAppointment(resourcePath)
				.then(function(){
					const index = vm.appointments.findIndex(function(appointment) {
						return appointment && appointment.id_work_order_appointment == appointmentID;
					});

					vm.appointments.splice(index, 1);
					return $q.resolve();
				});
		}

		function updateAppointmentStatus(appointment) {
			if(!appointment){
				return;
			}
			
			vm.isUpdatingAppointment = true;

			const resourcePath = { 
				companyID: companyID,
				workorderappointmentID: appointment.id_work_order_appointment
			};

			const requestBody = {
				fk_id_appointment_status: appointment.fk_id_appointment_status
			};

			WorkOrderService.updateAppointment(resourcePath, requestBody)
				.then(function(){
					MessageService.showToast("Appointment is updated.");
				})
				.catch(MessageService.showToast)
				.finally(function(){
					vm.isUpdatingAppointment = false;
				});
		}

		function isAnyItemSelected(){
			if(!vm.selectedMap || !Array.isArray(vm.appointments)){
				return;
			}

			const selectedItem = vm.appointments.find(function(appointment){
				return !!appointment && vm.selectedMap[appointment.id_work_order_appointment];
			});

			return !!selectedItem;
		}

		function disableDeleteButton() {
			return !isAnyItemSelected() || vm.isUpdatingAppointment || vm.isDeletingAppointment;
		}

		function fetchCustomerPortalAppointment(){
			const defer = $q.defer();
			const resourcePath = {companyID: companyID};
			var startTime = moment().startOf('day')
			var endTime = moment().add(7, 'years')
			const filter = getFilter(startTime, endTime);
			const queue = {customerPortalAppointments: AppointmentsService.getAllMatchedCustomerPortalAppointments(resourcePath, filter)}
			vm.isLoadingEvents = true;

			$q.all(queue).then(function(result){
					if(!result){
						return $q.reject("Customer Portal Appointments data invalid");
					}
					//var customerPortalAppointmentList = buildCustomerPortalAppointmentEventList(result.customerPortalAppointments)
					vm.isLoadingEvents = false;
					defer.resolve(appointments); 
				})
				.catch(function(error){
					MessageService.showToast(error);
					defer.reject(error);
				});

			return defer.promise;
		}

		function fetchCustomerPortalAppointment(){
			const defer = $q.defer();
			const resourcePath = {companyID: companyID};
			var startTime = moment().startOf('day')
			var endTime = moment().add(7, 'years')
			const filter = getFilter(startTime, endTime);
			const queue = {customerPortalAppointments: AppointmentsService.getAllMatchedCustomerPortalAppointments(resourcePath, filter)}
			vm.isLoadingEvents = true;

			$q.all(queue).then(function(result){
					if(!result){
						return $q.reject("Customer Portal Appointments data invalid");
					}
					//var customerPortalAppointmentList = buildCustomerPortalAppointmentEventList(result.customerPortalAppointments)
					vm.customerPortalAppointments = result.customerPortalAppointments
					vm.isLoadingEvents = false;
					defer.resolve(appointments); 
				})
				.catch(function(error){
					MessageService.showToast(error);
					defer.reject(error);
				});

			return defer.promise;
		}

		function getFilter(startMoment, endMoment){
			var calendarFilter = getCalendarFilterString();
			var timeRangeFilter = getTimeRangeFilterString(startMoment, endMoment);

			if(!timeRangeFilter){
				return;
			}

			timeRangeFilter = GeneralTools.addBracketToString(timeRangeFilter);

			if(calendarFilter){
				calendarFilter = GeneralTools.addBracketToString(calendarFilter);
			}

			var filterString = GeneralTools.notEqualFilterBuilder(AppointmentConstants.keyNames.appointmentStatus, AppointmentConstants.statusIDs.CANCELLED);

			filterString = GeneralTools.stringConnector(filterString, calendarFilter, ToolsConstants.apiFilters.andConnector);
			filterString = GeneralTools.stringConnector(filterString, timeRangeFilter, ToolsConstants.apiFilters.andConnector);

			return { filters: filterString };
		}

		function getCalendarFilterString(){
			var filterString = ''


			filterString = GeneralTools.stringConnector(
				filterString,
				GeneralTools.equalFilterBuilder("fk_id_work_order", $stateParams.workOrderID),
				GeneralTools.notEqualFilterBuilder("fk_id_appointment_status", AppointmentConstants.customerPortalStatusID.Cancelled),
				ToolsConstants.apiFilters.andConnector
			)

			return filterString;
		}

		function getTimeRangeFilterString(startMoment, endMoment){
			if(!startMoment || !startMoment.isValid() || !endMoment || !endMoment.isValid() || startMoment.isSameOrAfter(endMoment)){
				return;
			}
			return GeneralTools.equalRangeFilterBuilder(startKeyName, startMoment.utc().format(timeRangeFilterFormat), endMoment.utc().format(timeRangeFilterFormat))
		}
	}
})();
(function ()
{
	'use strict';

	angular
		.module('app.workOrders')
		.service('WorkOrderDataSharingService', WorkOrderDataSharingService);

	function WorkOrderDataSharingService(){   

		this.setWorkOrder = function(workOrder){
			this.workOrder = angular.copy(workOrder)
		}

		this.getWorkOrder = function(){
			return angular.copy(this.workOrder);
		}

		this.setPartList = function(partList){
			this.partList = angular.copy(partList);
		}

		this.getPartList = function(){
			return angular.copy(this.partList);
		}

		this.setInventoryList = function(inventoryList){
			this.inventoryList = angular.copy(inventoryList);
		}

		this.getInventoryList = function(){
			return angular.copy(this.inventoryList);
		}

		this.setLaborList = function(laborList){
			this.laborList = angular.copy(laborList);
		}

		this.setLabourList = function(labourList){
			this.labourList = angular.copy(labourList);
		}

		this.setMiscFeesList = function(MiscFeesTypesList){
			this.MiscFeesTypesList = angular.copy(MiscFeesTypesList);
		}

		this.getMiscFeesList = function(){
			return angular.copy(this.MiscFeesTypesList);
		}

		this.setWorkOrderPackageList = function(workOrderPackageList){
			this.workOrderPackageList = angular.copy(workOrderPackageList);
		}

		this.getWorkOrderPackageList = function(){
			return angular.copy(this.workOrderPackageList);
		}

		this.setWorkOrderPaymentStatusList = function(WorkOrderPaymentStatusList){
			this.WorkOrderPaymentStatusList = angular.copy(WorkOrderPaymentStatusList);
		}

		this.getWorkOrderPaymentStatusList = function(){
			return angular.copy(this.WorkOrderPaymentStatusList);
		}

		this.setJobTypeList = function(JobTypeList){
			this.JobTypeList = angular.copy(JobTypeList);
		}

		this.getJobTypeList = function(){
			return angular.copy(this.JobTypeList);
		}

		this.setWorkOrderWarrantyList = function(workOrderWarrantyList){
			this.workOrderWarrantyList = angular.copy(workOrderWarrantyList);
		}

		this.getWorkOrderWarrantyList = function(){
			return angular.copy(this.workOrderWarrantyList);
		}

		this.setWorkOrderWarrantyoptions = function(workOrderWarrantyOptions){
			this.workOrderWarrantyOptions = angular.copy(workOrderWarrantyOptions);
		}

		this.getWorkOrderWarrantyoptions = function(){
			return angular.copy(this.workOrderWarrantyOptions);
		}

		this.getLaborList = function(){
			return angular.copy(this.laborList);
		}
		
		this.getLabourList = function(){
			return angular.copy(this.labourList);
		}

		this.setDiscountList = function(dicountList){
			this.dicountList = angular.copy(dicountList);
		}

		this.getDiscountList = function(){
			return angular.copy(this.dicountList);
		}

		this.setRDGeneratedList = function(rDGeneratedList){
			this.rDGeneratedList = angular.copy(rDGeneratedList);
		}

		this.getRDGeneratedList = function(){
			return angular.copy(this.rDGeneratedList);
		}

		this.setRDRedeemeddList = function(RDRedeemeddList){
			this.RDRedeemeddList = angular.copy(RDRedeemeddList);
		}

		this.getRDRedeemeddList = function(){
			return angular.copy(this.RDRedeemeddList);
		}
		
		this.setPaymentList = function(paymentList){
			this.paymentList = angular.copy(paymentList);
		}

		this.getPaymentList = function(){
			return angular.copy(this.paymentList);
		}

		
		this.setworkOrderSubTotal = function(subtotal){
			this.workOrderSubTotal = angular.copy(subtotal);
		}

		this.getworkOrderSubTotal = function(){
			return angular.copy(this.workOrderSubTotal);
		}
		
		this.setworkOrderJobList = function(workOrderJobList){
			this.workOrderJobList = angular.copy(workOrderJobList);
		}

		this.getworkOrderJobList = function(){
			return angular.copy(this.workOrderJobList);
		}

		this.setworkOrderCouponList = function(workOrderCouponList){
			this.workOrderCouponList = angular.copy(workOrderCouponList);
		}

		this.getworkOrderCouponList = function(){
			return angular.copy(this.workOrderCouponList);
		}
	}
})();
(function ()
{
	"use strict";
	angular.module("app.saleInfo",[])
		.constant("SaleInfoConstants", {
			deliveryDueDateFormat:"YYYY-MM-DD",
			deliveryDateFormat:"YYYY-MM-DD",
			saleDateFormat:"YYYY-MM-DD",
			salePackageDateFormat:"YYYY-MM-DD",
			warrantyLength: 90,
			saleInfoSummaryAnchors:{
				GENERAL: "GENERAL",
				PAYMENTS: "PAYMENTS",
				FINANCING: "FINANCING",
				TRADE_IN: "TRADE_IN",
				WARRANTY: "WARRANTY",
				EXTRAS: "EXTRAS",
				PACKAGES: "PACKAGES",
				PROMOTIONS: "PROMOTIONS",
			},
			omvic:22.00
		})
		.config(config);

	/** @ngInject */
	function config($stateProvider, msNavigationServiceProvider, loginInfoProvider)
	{	  

		$stateProvider
			.state('app.edit-sale-info', {
				url :"/vehicle/{vehicleID}/saleinfo/{saleInfoID}/edit",
				views	: {
						'content@app': {
							templateUrl: 'app/main/sale-info/edit-sale-info.html',
							controller : 'EditSaleInfoController as vm'
						}
					},
				resolve:{
					constants:function(WorkOrderService, $q, SaleInfoService, CustomersService, MessageService, FinanceApplicationService, LoginService){
						var companyID = LoginService.getCompanyID();
						var tasks = {};

						tasks.employmentStatus 			= FinanceApplicationService.getCachedEmploymentStatus();
						tasks.livingArrangementTypes 	= FinanceApplicationService.getCachedLivingArrangementTypes();
						tasks.plateOptions 				= SaleInfoService.getCachedPlateOptions({companyID:companyID});
						tasks.warrantyOptions 			= SaleInfoService.getWarrantyOptions({companyID:companyID});
						tasks.presetExtrasOptions 		= SaleInfoService.getPresetExtrasOptions({companyID:companyID});
						tasks.promotionOptions 			= SaleInfoService.getPromotions({companyID:companyID});
						tasks.paymentOptions 			= SaleInfoService.getCachedPaymentOptions();
						tasks.paymentMethods 			= SaleInfoService.getCachedPaymentMethods();
						tasks.phoneCategories 			= CustomersService.getCachedPhoneCategories();
						tasks.emailCategories 			= CustomersService.getCachedEmailCategories();
						tasks.workorderPriorities = WorkOrderService.getCachedWorkOrderPriorities()

						return $q.all(tasks).catch(MessageService.showToast);
					},
					vehicle:function($stateParams, VehicleService, MessageService, LoginService){
						var resourcePath = { 
							companyID: LoginService.getCompanyID(),
							vehicleID: $stateParams.vehicleID
						}
						return VehicleService.getVehicle(resourcePath).catch(MessageService.showToast);			
					},
					saleInfo:function($q, SaleInfoService, $stateParams, MessageService, LoginService){
						var resourcePath = {
							companyID: LoginService.getCompanyID(),
							vehicleID: $stateParams.vehicleID,
							saleinfoID: $stateParams.saleInfoID
						}

						return SaleInfoService.getVehicleSaleInfos(resourcePath).catch(MessageService.showToast);
					},
					tradeInVehicle:function($q, $stateParams, MessageService, SaleInfoService, LoginService){
						var resourcePath = {
							companyID: LoginService.getCompanyID(),
							vehicleID: $stateParams.vehicleID,
							saleinfoID: $stateParams.saleInfoID
						}

						return SaleInfoService.getTradeInVehicles(resourcePath).catch(MessageService.showToast);
					},
					saleWarranty:function($q, $stateParams, MessageService, SaleInfoService, LoginService){
						var resourcePath = {
							companyID: LoginService.getCompanyID(),
							vehicleID: $stateParams.vehicleID,
							saleinfoID: $stateParams.saleInfoID
						}

						return SaleInfoService.getSaleWarranties(resourcePath).catch(MessageService.showToast);
					},
					saleExtras:function($q, $stateParams, MessageService, SaleInfoService, LoginService){
						var resourcePath = {
							companyID: LoginService.getCompanyID(),
							vehicleID: $stateParams.vehicleID,
							saleinfoID: $stateParams.saleInfoID
						}

						return SaleInfoService.getSaleExtras(resourcePath).catch(MessageService.showToast);
					},
					promotions:function($q, $stateParams, MessageService, SaleInfoService, LoginService){
						var resourcePath = {
							companyID: LoginService.getCompanyID(),
							vehicleID: $stateParams.vehicleID,
							saleinfoID: $stateParams.saleInfoID
						}

						return SaleInfoService.getSalePromotions(resourcePath).catch(MessageService.showToast);
					},
					payments:function($q, $stateParams, MessageService, SaleInfoService, LoginService){
						var resourcePath = {
							companyID: LoginService.getCompanyID(),
							vehicleID: $stateParams.vehicleID,
							saleinfoID: $stateParams.saleInfoID
						}

						return SaleInfoService.getSalePayments(resourcePath).catch(MessageService.showToast);
					},
					saleFiles:function($q, $stateParams, MessageService, SaleInfoService, LoginService){
						var resourcePath = {
							companyID: LoginService.getCompanyID(),
							vehicleID: $stateParams.vehicleID,
							saleinfoID: $stateParams.saleInfoID
						}

						return SaleInfoService.getSaleInfoFiles(resourcePath).catch(MessageService.showToast);
					},
					disclosures:function($stateParams, SaleInfoService, MessageService, LoginService){
						var resourcePath = {
							companyID : LoginService.getCompanyID(),
							vehicleID : $stateParams.vehicleID,
							saleinfoID : $stateParams.saleInfoID
						};

						return SaleInfoService.getSaleDisclosures(resourcePath).catch(MessageService.showToast);
					},
					signatures:function($stateParams, SaleInfoSignatureService, MessageService, LoginService){
						var resourcePath = {
							companyID : LoginService.getCompanyID(),
							vehicleID : $stateParams.vehicleID,
							saleinfoID : $stateParams.saleInfoID
						};

						return SaleInfoSignatureService.getSaleSignatures(resourcePath).catch(MessageService.showToast);
					},
					jobtypes:function(apiResolver, LoginService){
						return apiResolver.resolve('jobtypes@getJob', {
							companyID: LoginService.getCompanyID(), 
						});
					}
				}
			});

	}

})();
(function ()
{
	'use strict';

	angular
		.module("app.saleInfo")
		.factory("WorkOrderQRPrint", WorkOrderQRPrintClass)

	/** @ngInject */
	function WorkOrderQRPrintClass($location, ApiConst, Customer, CustomersService, WorkOrderService, $filter, $q, VehicleService, WorkOrderSummaryCalculator, LoginService, GeneralTools)
	{
		const companyID = LoginService.getCompanyID();
		const headerImg = "assets/images/workorderheader.jpg";
		const footer = { text:[{text:"Comments ", bold: true}, "HST NUMBER: 875901308RT0001"] };
		const defaultStyle = { fontSize:8 };
		const customStyles = {
			tableHeader: {
				bold: true,
				color: 'black',
				fillColor: '#CCCCCC'
			},
			tableStyle:{
				margin: [0, 0, 0, 20]
			}
		};

		var domain;
		switch(window.location.host){
			case ApiConst.productDomain:
				domain = ApiConst.productDomain;
				break;
			case ApiConst.productBackupDomain:
				domain = ApiConst.productBackupDomain;
				break;
			case ApiConst.testDomain:
				domain = ApiConst.testDomain;
				break;
			default:
				domain = 'localhost:3001';
				break;
		}
		// const socketUrl = ApiConst.http + domain + $location.$$path + '?qr=true';
		const tableLayout =  {
			fillColor: function (rowIndex, node, columnIndex) {
				return (rowIndex % 2 === 0) ? '#efefef' : null;
			},
			hLineWidth: function (i, node) {
				return  (i === 0 || i === node.table.body.length)  ? 0.3 : 0;
			},
			vLineWidth: function (i, node) {
				return 0;
			},
			hLineColor: function (i, node) {
				return 'gray';
			},
		}

		function WorkOrderPrint(vehicleID, workOrderID, customerID, isQuoted, qrcodeurl){
			this.vehicleID = vehicleID;
			this.workOrderID = workOrderID;
			this.customerID = customerID;
			this.isQuoted = isQuoted;
			this.workOrderSummaryCalculator = new WorkOrderSummaryCalculator();
			this.socketUrl = qrcodeurl;
		}

		WorkOrderPrint.prototype.fetchDatas = function(){
			const _this = this;
			const queue = {
				vehicle: fetchVehicleData(this.vehicleID),
				workOrder: fetchWorkOrderData(this.vehicleID, this.workOrderID),
				customer: fetchCustomerData(this.customerID),
				parts: fetchPartsData(this.vehicleID, this.workOrderID),
				inventories: fetchInventoriesData(this.vehicleID, this.workOrderID),
				labors: fetchLaborsData(this.vehicleID, this.workOrderID),
				// miscfees: fetchMiscfeesData(this.vehicleID, this.workOrderID),
				// workOrderWarrantyListData: fetchWorkOrderWarrantyListData(this.vehicleID, this.workOrderID),
				// workOrderPackageListData: fetchWorkOrderPackageListData(this.vehicleID, this.workOrderID),
				// discounts: fetchDiscountsData(this.vehicleID, this.workOrderID),
				// payments: fetchPaymentsData(this.vehicleID, this.workOrderID),
			};
			return $q.all(queue)
				.then(function(result){
					if(!result){
						return $q.reject("Failed to fetch all datas.");
					}

					_this.vehicleData = result.vehicle;
					_this.workOrderData = result.workOrder;
					
					_this.customerData = result.customer;
					_this.inventoriesData = result.inventories;
					_this.laborsData = result.labors;
					// _this.miscfeesData = result.miscfees;
					// _this.workOrderWarrantyListData = result.workOrderWarrantyListData
					// _this.workOrderPackageListData = result.workOrderPackageListData
					// _this.discountsData = result.discounts;
					// _this.paymentsData = result.payments;
					_this.partsData = result.parts;

					// if(_this.workOrderData){
					// 	_this.workOrderSummaryCalculator.setTaxRate(_this.workOrderData.tax_rate);
					// 	_this.workOrderSummaryCalculator.setSubsidizedAmount(_this.workOrderData.subsidized_amount);
					// 	_this.workOrderSummaryCalculator.setSubsidizedPercentage(_this.workOrderData.subsidized_percentage);
					// 	_this.workOrderSummaryCalculator.setIsSubsidizedByPercentage(_this.workOrderData.is_subsidized_by_percentage);
					// }
		
					// _this.workOrderSummaryCalculator.setParts(_this.partsData);
					// _this.workOrderSummaryCalculator.setInventories(_this.inventoriesData);
					// _this.workOrderSummaryCalculator.setLabors(_this.laborsData);
					// _this.workOrderSummaryCalculator.setMiscfees(_this.miscfeesData);
					// _this.workOrderSummaryCalculator.setWorkOrderPackageList(_this.workOrderPackageListData);
					// _this.workOrderSummaryCalculator.setWorkOrderWarrantyList(_this.workOrderWarrantyListData);
					// _this.workOrderSummaryCalculator.setDiscounts(_this.discountsData);
					// _this.workOrderSummaryCalculator.setPayments(_this.paymentsData);
					return $q.resolve(_this);
				})
		}



		WorkOrderPrint.prototype.getDocDefinition = function(){
			const _this = this;
			return imgToDataUrl(headerImg)
				.then(function(dataUrl){
					const header = {image:dataUrl, width: 500, alignment: 'center', margin:[0, 0, 0, 0]};
					const docDefinition = {
							content:[
							header,
							getBasicInfosBlock(_this.workOrderData, _this.vehicleData, _this.customerData, _this.isQuoted),
							getPartsList(_this.partsData, _this.inventoriesData),
							getLaborsList(_this.laborsData),
							getWorkOrderNoteList(_this.workOrderData),


							getQRCode(_this.socketUrl),

							
							// getWorkOrderPackageList(_this.workOrderPackageListData),
							// getWorkOrderWarrantyList(_this.workOrderWarrantyListData),
							// getDiscountsList(_this.workOrderSummaryCalculator.getTotalDiscountDetailList()),
							// getPaymentsList(_this.paymentsData),
							// getSummaryBlock(_this.workOrderSummaryCalculator),
							// footer
						],
						styles: customStyles,
						defaultStyle: defaultStyle
					};
					return $q.resolve(docDefinition)
				});
		}

		function getPaymentsList(payments){
			if(!Array.isArray(payments) || payments.length <= 0){
				return;
			}

			const tableBlock = {	
				style: "tableStyle",
				layout: tableLayout,
				table: {
					widths: ['*', '*', '*', 60],
					headerRows: 1,
					body:[[
						{text: "Date", style:"tableHeader"},
						{text: "Paid By", style:"tableHeader"},
						{text: "Received By", style:"tableHeader"},
						{text: "Amount", style:"tableHeader"}
					]]
				}
			}
	
			payments.forEach(function(payment){
				tableBlock.table.body.push(buildPaymentListRow(payment));				
			});

			return tableBlock;
		}

		function buildPaymentListRow(payment){
			if(!payment){
				return;
			}

			var paidBy = '';
			var receivedBy = '';

			if(payment.customer){
				paidBy = payment.customer.first_name + ' ' + payment.customer.last_name;
			}

			if(payment.received_by){
				receivedBy = payment.received_by.first_name + ' ' + payment.received_by.last_name;
			}

			return [
				{text:$filter('date')(payment.payment_date, "medium")}, 
				{text:paidBy},
				{text:receivedBy},
				{text:$filter('currency')(payment.amount, '$', 2)}
			];
		}

		function getDiscountsList(detailList){
			if(!Array.isArray(detailList) || detailList.length <= 0){
				return;
			}

			const tableBlock = {	
				style: "tableStyle",
				layout: tableLayout,
				table: {
					widths: ['*', 60],
					headerRows: 1,
					body:[[
						{text: "Discount", style:"tableHeader"}, 
						{text: "Amount", style:"tableHeader"}
					]]
				}
			}
	
			detailList.forEach(function(item){
				tableBlock.table.body.push(buildDiscountListRow(item));				
			});

			return tableBlock;
		}

		function buildDiscountListRow(item){
			if(!item || !item.discountData){
				return;
			}

			var description = item.discountData.description;

			if(item.discountData.percentage_off){
				description += '(' + item.discountData.percentage_off * 100 + "%)";
			}

			return [
				{text:description},
				{text:$filter('currency')(item.deductionAmount * -1, '$', 2)}
			];
		}

		function getLaborsList(labors){
			if(!Array.isArray(labors) || labors.length <= 0){
				return;
			}

			const tableBlock = {	
				style: "tableStyle",
				layout: tableLayout,
				table: {
					widths: ['*', 60, 60, 60],
					headerRows: 1,
					body:[[
						{text: "Labor", style:"tableHeader"}, 
						{text: "Quantity", style:"tableHeader"}, 
						{text:'Rate', style:"tableHeader"}, 
						{text:'Total', style:"tableHeader"}
					]]
				}
			}
	
			labors.forEach(function(labor){
				tableBlock.table.body.push(buildLaborListRow(labor));				
			});

			return tableBlock;
		}

		function getWorkOrderPackageList(workorderpackagelist){
			if(!Array.isArray(workorderpackagelist) || workorderpackagelist.length <= 0){
				return;
			}

			const tableBlock = {	
				style: "tableStyle",
				layout: tableLayout,
				table: {
					widths: ['*', 60, 60, 60],
					headerRows: 1,
					body:[[
						{text: "Package", style:"tableHeader"}, 
						{text: "Quantity", style:"tableHeader"}, 
						{text:'Rate', style:"tableHeader"}, 
						{text:'Total', style:"tableHeader"}
					]]
				}
			}
	
			workorderpackagelist.forEach(function(workorderpackage){
				tableBlock.table.body.push(buildtWorkOrderPackageListRow(workorderpackage));				
			});

			return tableBlock;
		}

		function buildtWorkOrderPackageListRow(workorderpackage){
			if(!workorderpackage){
				return;
			}

			const workorderpackageName = workorderpackage.name;
			const unitPrice = GeneralTools.parseNumber(workorderpackage.price);
			// const hour = GeneralTools.parseNumber(workorderpackage.hour);

			return buildItemListRow(workorderpackageName, 1, unitPrice);
		}

		function getWorkOrderWarrantyList(workorderwarrantylist){
			if(!Array.isArray(workorderwarrantylist) || workorderwarrantylist.length <= 0){
				return;
			}

			const tableBlock = {	
				style: "tableStyle",
				layout: tableLayout,
				table: {
					widths: ['*', 60, 60, 60],
					headerRows: 1,
					body:[[
						{text: "Warranty", style:"tableHeader"}, 
						{text: "Quantity", style:"tableHeader"}, 
						{text:'Price', style:"tableHeader"}, 
						{text:'Total', style:"tableHeader"}
					]]
				}
			}
	
			workorderwarrantylist.forEach(function(workorderwarranty){
				tableBlock.table.body.push(buildtWorkOrderWarrantyListRow(workorderwarranty));				
			});

			return tableBlock;
		}

		function buildtWorkOrderWarrantyListRow(workorderwarranty){
			if(!workorderwarranty){
				return;
			}

			const workorderwarrantyName = workorderwarranty.name;
			const unitPrice = GeneralTools.parseNumber(workorderwarranty.retail);
			// const hour = GeneralTools.parseNumber(workorderpackage.hour);

			return buildItemListRow(workorderwarrantyName, 1, unitPrice);
		}

		function getMiscfeesList(miscfees){
			if(!Array.isArray(miscfees) || miscfees.length <= 0){
				return;
			}

			const tableBlock = {	
				style: "tableStyle",
				layout: tableLayout,
				table: {
					widths: ['*', 60, 60, 60],
					headerRows: 1,
					body:[[
						{text: "Misc fees", style:"tableHeader"}, 
						{text: "Quantity", style:"tableHeader"}, 
						{text:'Rate', style:"tableHeader"}, 
						{text:'Total', style:"tableHeader"}
					]]
				}
			}
	
			miscfees.forEach(function(miscfee){
				tableBlock.table.body.push(buildMiscfeesListRow(miscfee));				
			});

			return tableBlock;
		}

		function buildLaborListRow(labor){
			if(!labor){
				return;
			}

			const laborName = labor.name;
			const unitPrice = GeneralTools.parseNumber(labor.price);
			const hour = GeneralTools.parseNumber(labor.hour);

			return buildItemListRow(laborName, hour, unitPrice);
		}

		function buildMiscfeesListRow(miscfee){
			if(!miscfee){
				return;
			}

			const miscfeeName = miscfee.name;
			const unitPrice = GeneralTools.parseNumber(miscfee.price);
			const quantity = GeneralTools.parseNumber(miscfee.quantity);

			return buildItemListRow(miscfeeName, quantity, unitPrice);
		}


		function getQRCode(socketUrl){
			if(!socketUrl){
				return 
			}

			const tableBlock = {	
				style: "tableStyle",
				layout: tableLayout,
				qr: socketUrl, fit: '125',
				alignment: 'center', margin:[0, 5, 0, 0]
			}


			return tableBlock;
		}

		function getWorkOrderNoteList(workorderDate) {
			if (!workorderDate) {
				return;
			}
			
			var workOrderNoteList;
			var keys = [
				{ key: "notes", title: "Notes" },
				{ key: "mechanic_notes", title: "Mechanic Notes" },
			];
		
			workOrderNoteList = keys.reduce(function(notesList, item) {
				var note = workorderDate[item.key];
		
				if (note) {
					notesList.push([
						{
							text: item.title,
							fillColor: '#eeeeee'
						},
						{
							text: note
						}
					]);
				}
				return notesList;
			}, []);

			if (workOrderNoteList.length <= 0) {
				return;
			}

			return {
				table: {
					widths: [100, '*'],
					body: workOrderNoteList
				}
			};
		}
		

		function buildInventoryListRow(inventory){
			if(!inventory){
				return;
			}

			var inventoryStatus = "Not Ordered"

			if(inventory.quantity_in_stock > 0){
				var inventoryStatus = "Ordered"

			}
			const itemName = inventory.name;
			const InventoryCode = inventory.code !== null && inventory.code.trim() !== '' ? inventory.code : ' ';
			const unitPrice = GeneralTools.parseNumber(inventory.retail_price);
			const quantity = GeneralTools.parseNumber(inventory.quantity);

			return buildPartTableItemListRow(itemName,InventoryCode, inventoryStatus, quantity, unitPrice);
		}

		function buildPartListRow(part){
			if(!part){
				return;
			}

			const itemName = part.name;

			var partStauts = "Not Ordered"
			if(part.is_ordered){
				partStauts = "Ordered"
			}

			if(part.is_returned){
				partStauts = "Returned"
			}
			const partCode = part.code !== null && part.code.trim() !== '' ? part.code : ' ';
			const unitPrice = GeneralTools.parseNumber(part.retail_price);
			const quantity = GeneralTools.parseNumber(part.quantity);

			return buildPartTableItemListRow(itemName, partCode, partStauts, quantity, unitPrice);
		}

		function buildPartTableItemListRow(itemName, code, status, quantity, unitPrice){
			if(typeof(quantity) != "number" || typeof(unitPrice) != "number"){
				return;
			}

			return [
				{text:itemName}, 
				{text:code}, 
				{text:status}, 
				{text:quantity}, 
				{text:$filter('currency')(unitPrice, '$', 2)}, 
				{text:$filter('currency')(unitPrice * quantity, '$', 2)}
			];
		}



		function buildItemListRow(itemName, quantity, unitPrice){
			if(typeof(quantity) != "number" || typeof(unitPrice) != "number"){
				return;
			}

			return [
				{text:itemName}, 
				{text:quantity}, 
				{text:$filter('currency')(unitPrice, '$', 2)}, 
				{text:$filter('currency')(unitPrice * quantity, '$', 2)}
			];
		}

		function getBasicInfosBlock(workOrder, vehicle, customer, isQuoted){
			var invoiceNumber;
			var invoiceType = "INVOICE";
			var customerName;
			var yearMakeModel;
			var mileage;
			var vin;
			var customerPhone;
			var date;

			if(workOrder){
				invoiceNumber = workOrder.invoice_number;
				
				if(isQuoted){
					date = workOrder.quote_date ? workOrder.quote_date : null;
				} else {
					date = workOrder.completed_date ? $filter("date")(workOrder.completed_date, "yyyy-MM-dd") : null;
				}

				mileage = workOrder.mileage ? "Mileage: " + $filter("number")(workOrder.mileage) + " KM" : null;
			}

			if(isQuoted){
				invoiceType = "QUOTE";
			}

			if(vehicle){
				yearMakeModel = vehicle.getYearMakeModel();				
				vin = vehicle.vin ? "VIN: " + vehicle.vin : null;
			}

			if(customer){
				customerName = customer.getFullName();
				if(Array.isArray(customer.phone_numbers) && !!customer.phone_numbers[0]){
					customerPhone = "Phone: " + GeneralTools.stringToPhoneNumberString(customer.phone_numbers[0].phone_number);
				}
			}

			return {
				margin: [0, 5, 0, 20],
				width: '*',
				columns: [
					{
						alignment: 'left',
						stack: [
							{text: invoiceType + " NUMBER - " + invoiceNumber, fontSize:10, bold: true,  margin: [0, 0, 0, 10]},
							// {text: "Roger's Motors Service", bold: true},
							// "550 Bronte Rd, Oakville, ON",
							// "L6L 6S1",
							// "Phone: (905) 618-0350"
						]
					},
					{
						alignment: 'right',
						stack: [
							{text: "To:", fontSize:10, bold: true,  margin: [0, 0, 0, 10]},
							{text: customerName, bold: true},
							yearMakeModel,
							mileage,
							vin,
							// customerPhone,
							{text:[{text:"Date: ", bold: true}, date], margin: [0, 5, 0, 0]}
						]
					}
				]
			};
		}

		function getSummaryBlock(workOrderSummaryCalculator){
			if(!workOrderSummaryCalculator){
				return;
			}

			const subtotalBeforeSubtraction = workOrderSummaryCalculator.getSubtotalBeforeSubtraction();
			const totalDiscountOff = workOrderSummaryCalculator.getTotalDiscountAmount();
			const subsidizedAmount = workOrderSummaryCalculator.getSubsidization();
			const totalBeforeTax = workOrderSummaryCalculator.getTotalBeforeTax();
			const totalTax = workOrderSummaryCalculator.getTotalTax();
			const totalAfterTax = workOrderSummaryCalculator.getTotalAfterTax();
			const totalPayments = workOrderSummaryCalculator.getTotalPayments();

			var taxRow;
			var subsidizedRow;
			var discountsRow;
			var paymentRow;
			var totalBeforeTaxRow;

			if(totalTax){
				taxRow = getSummaryItem("Tax (" + workOrderSummaryCalculator.getTaxRate() * 100 + "%)", totalTax);
			}

			if(subsidizedAmount){
				var title;
				if(workOrderSummaryCalculator.getIsSubsidizedByPercentage()){
					title = "Subsidized(" + workOrderSummaryCalculator.getSubsidizedPercentage() * 100 + "%)"
				} else {
					title = "Subsidized"
				}

				subsidizedRow = getSummaryItem(title, subsidizedAmount * -1);
			}		

			if(totalDiscountOff){
				discountsRow = getSummaryItem("Discounts", totalDiscountOff * -1);
			}

			if(totalPayments){
				paymentRow = getSummaryItem("Payments", totalPayments);
			}

			if(subtotalBeforeSubtraction != totalBeforeTax){
				totalBeforeTaxRow = getSummaryItem("Subtotal", totalBeforeTax)
			}

			const outstandingRow = getSummaryItem("OUTSTANDING", workOrderSummaryCalculator.getOutstanding());
			outstandingRow.bold = true;
			outstandingRow.fontSize = 14;

			return { 
				stack:[
					getSummaryItem("Subtotal", subtotalBeforeSubtraction),
					discountsRow,
					subsidizedRow,
					totalBeforeTaxRow,
					taxRow,
					getSummaryItem("Total", totalAfterTax),
					paymentRow,
					outstandingRow
				]
			}

		}

		function getSummaryItem(title, value){
			return {
				width: '*',
				margin:[0, 3, 0, 0],
				fontSize:10,
				columns: [
					{							
						alignment: 'right',
						text:title
					},
					{
						width:100,
						alignment: 'right',
						text:$filter('currency')(value, '$', 2)
					}
				]
			}
		}

		function imgToDataUrl(url){
			const defer = $q.defer();
			const canvas = document.createElement("canvas");
			
			const image = new Image();
			image.src = url;
			image.onload = function(){
				const context = canvas.getContext('2d');

				canvas.height = this.height;
				canvas.width = this.width;
				context.drawImage(this, 0, 0);

				defer.resolve(canvas.toDataURL());
			}

			image.onerror = function(error){
				defer.reject("Failed to load image.");
			}

			return defer.promise;
		}


		WorkOrderPrint.prototype.download = function(){
			return this.getDocDefinition()
				.then(function(docDefinition){
					pdfMake.createPdf(docDefinition).download();
				});
			
		}

		WorkOrderPrint.prototype.open = function(){
			return this.getDocDefinition()
				.then(function(docDefinition){
					pdfMake.createPdf(docDefinition).open();
				});
		}

		function fetchVehicleData(vehicleID){
			const resourcePath = {
				companyID: companyID,
				vehicleID: vehicleID
			};

			return VehicleService.getVehicle(resourcePath)
				.then(function(result){
					if(!result || !Array.isArray(result.data) || result.data.length != 1 || !result.data[0]){
						return $q.reject("Failed to fetch vehicle data");
					}

					return $q.resolve(result.data[0]);
				});
		}

		function fetchWorkOrderData(vehicleID, workOrderID){
			const resourcePath = { 
				companyID: companyID,
				vehicleID: vehicleID,
				workorderID: workOrderID
			};

			return WorkOrderService.getWorkOrders(resourcePath).$promise
				.then(function(result){
					if(!result || !Array.isArray(result) || result.length != 1 || !result[0]){
						return $q.reject("Failed to fetch work order data");
					}

					return $q.resolve(result[0]);
				});
		}

		function fetchCustomerData(customerID){
			if(!customerID){
				var sampleCustomer = new Customer()

				sampleCustomer.setAttributes({
					first_name: "Roger's",
					last_name: "Motors",
					phone_numbers: [{phone_number: "9056180350"}]
				});

				return $q.resolve(sampleCustomer)
			}

			const resourcePath = {
				customerID: customerID,
				companyID: companyID
			};
			return CustomersService.getCustomers(resourcePath)
				.then(function(result){
					if(!result || !Array.isArray(result.data) || result.data.length != 1 || !result.data[0]){				
						return $q.reject("Failed to fetch customer data");
					}

					return $q.resolve(result.data[0]);
				});
		}

		function fetchPartsData(vehicleID, workOrderID){
			const resourcePath = { 
				companyID: companyID,
				vehicleID: vehicleID,
				workorderID: workOrderID
			};

			return WorkOrderService.getWorkOrderParts(resourcePath).$promise
		}

		function fetchInventoriesData(vehicleID, workOrderID){
			const resourcePath = { 
				companyID: companyID,
				vehicleID: vehicleID,
				workorderID: workOrderID
			};

			return WorkOrderService.getWorkOrderInventories(resourcePath).$promise
		}

		function fetchLaborsData(vehicleID, workOrderID){
			const resourcePath = { 
				companyID: companyID,
				vehicleID: vehicleID,
				workorderID: workOrderID
			};

			return WorkOrderService.getLabors(resourcePath).$promise
		}

		function fetchWorkOrderPackageListData(vehicleID, workOrderID){
			const resourcePath = { 
				companyID: companyID,
				vehicleID: vehicleID,
				workorderID: workOrderID
			};

			return WorkOrderService.getWorkOrderPackages(resourcePath).$promise
		}

		function fetchWorkOrderWarrantyListData(vehicleID, workOrderID){
			const resourcePath = { 
				companyID: companyID,
				vehicleID: vehicleID,
				workorderID: workOrderID
			};

			return WorkOrderService.getWorkOrderWarranties(resourcePath).$promise;
		}
		

		
		function fetchMiscfeesData(vehicleID, workOrderID){
			const resourcePath = { 
				companyID: companyID,
				vehicleID: vehicleID,
				workorderID: workOrderID
			};

			return WorkOrderService.getMiscfeestype(resourcePath).$promise
		}

		function fetchDiscountsData(vehicleID, workOrderID){
			const resourcePath = { 
				companyID: companyID,
				vehicleID: vehicleID,
				workorderID: workOrderID
			};

			return WorkOrderService.getDiscounts(resourcePath).$promise;
		}

		function fetchPaymentsData(vehicleID, workOrderID){
			const resourcePath = { 
				companyID: companyID,
				vehicleID: vehicleID,
				workorderID: workOrderID
			};

			return WorkOrderService.getPayments(resourcePath).$promise;
		}

		function getPartsList(parts, inventories){
			if((!Array.isArray(parts) || parts.length <= 0) && (!Array.isArray(inventories) || inventories.length <= 0)){
				return 
			}

			const tableBlock = {	
				style: "tableStyle",
				layout: tableLayout,
				table: {
					widths: ['*', 60, 60, 60, 60, 60],
					headerRows: 1,
					body:[[
						{text: "Part", style:"tableHeader"}, 

						{text: "Part Code", style:"tableHeader"}, 
						{text:'Status', style:"tableHeader"}, 

						{text: "Quantity", style:"tableHeader"}, 
						{text:'Unit Price', style:"tableHeader"}, 
						{text:'Total', style:"tableHeader"}
					]]
				}
			}

			if(Array.isArray(parts)){
				parts.forEach(function(part){
					if(!!part && !part.is_returned){
						tableBlock.table.body.push(buildPartListRow(part));
					}				
				});
			}

			if(Array.isArray(inventories)){
				inventories.forEach(function(inventory){
					tableBlock.table.body.push(buildInventoryListRow(inventory));
				});
			}

			return tableBlock;
		}

		return WorkOrderPrint;
	}
})();

(function () {
	'use strict';

	angular
		.module("app.saleInfo")
		.factory("WorkOrderPrint", WorkOrderPrintClass)

	/** @ngInject */
	function WorkOrderPrintClass(Customer, CustomersService, WorkOrderService, $filter, $q, VehicleService, WorkOrderSummaryCalculator, LoginService, GeneralTools) {
		const companyID = LoginService.getCompanyID();
		const headerImg = "assets/images/workorderheader.jpg";
		const footer = { text: [{ text: "Comments ", bold: true }, "HST NUMBER: 875901308RT0001"] };
		const defaultStyle = { fontSize: 8 };
		const customStyles = {
			tableHeader: {
				bold: true,
				color: 'black',
				fillColor: '#CCCCCC'
			},
			tableStyle: {
				margin: [0, 0, 0, 20]
			}
		};

		const tableLayout = {
			fillColor: function (rowIndex, node, columnIndex) {
				return (rowIndex % 2 === 0) ? '#efefef' : null;
			},
			hLineWidth: function (i, node) {
				return (i === 0 || i === node.table.body.length) ? 0.3 : 0;
			},
			vLineWidth: function (i, node) {
				return 0;
			},
			hLineColor: function (i, node) {
				return 'gray';
			},
		}

		function WorkOrderPrint(vehicleID, workOrderID, customerID, isQuoted) {
			this.vehicleID = vehicleID;
			this.workOrderID = workOrderID;
			this.customerID = customerID;
			this.isQuoted = isQuoted;
			this.workOrderSummaryCalculator = new WorkOrderSummaryCalculator();
		}

		WorkOrderPrint.prototype.fetchDatas = function () {
			const _this = this;
			const queue = {
				vehicle: fetchVehicleData(this.vehicleID),
				workOrder: fetchWorkOrderData(this.vehicleID, this.workOrderID),
				customer: fetchCustomerData(this.customerID),
				parts: fetchPartsData(this.vehicleID, this.workOrderID),
				inventories: fetchInventoriesData(this.vehicleID, this.workOrderID),
				labors: fetchLaborsData(this.vehicleID, this.workOrderID),
				miscfees: fetchMiscfeesData(this.vehicleID, this.workOrderID),
				workOrderWarrantyListData: fetchWorkOrderWarrantyListData(this.vehicleID, this.workOrderID),
				workOrderPackageListData: fetchWorkOrderPackageListData(this.vehicleID, this.workOrderID),
				discounts: fetchDiscountsData(this.vehicleID, this.workOrderID),
				rogerDollarRedeem: fetchRogerDollarRedeemData(this.vehicleID, this.workOrderID),
				payments: fetchPaymentsData(this.vehicleID, this.workOrderID),
			};
			return $q.all(queue)
				.then(function (result) {
					if (!result) {
						return $q.reject("Failed to fetch all datas.");
					}

					_this.vehicleData = result.vehicle;
					_this.workOrderData = result.workOrder;
					_this.customerData = result.customer;
					_this.inventoriesData = result.inventories;
					_this.laborsData = result.labors;
					_this.miscfeesData = result.miscfees;
					_this.workOrderWarrantyListData = result.workOrderWarrantyListData
					_this.workOrderPackageListData = result.workOrderPackageListData
					_this.discountsData = result.discounts;
					_this.rogerDollarRedeemData = result.rogerDollarRedeem;

					_this.paymentsData = result.payments;
					_this.partsData = result.parts;

					if (_this.workOrderData) {
						_this.workOrderSummaryCalculator.setTaxRate(_this.workOrderData.tax_rate);
						_this.workOrderSummaryCalculator.setSubsidizedAmount(_this.workOrderData.subsidized_amount);
						_this.workOrderSummaryCalculator.setSubsidizedPercentage(_this.workOrderData.subsidized_percentage);
						_this.workOrderSummaryCalculator.setIsSubsidizedByPercentage(_this.workOrderData.is_subsidized_by_percentage);
					}

					_this.workOrderSummaryCalculator.setParts(_this.partsData);
					_this.workOrderSummaryCalculator.setInventories(_this.inventoriesData);
					_this.workOrderSummaryCalculator.setLabors(_this.laborsData);
					_this.workOrderSummaryCalculator.setMiscfees(_this.miscfeesData);
					_this.workOrderSummaryCalculator.setWorkOrderPackageList(_this.workOrderPackageListData);
					_this.workOrderSummaryCalculator.setWorkOrderWarrantyList(_this.workOrderWarrantyListData);
					_this.workOrderSummaryCalculator.setDiscounts(_this.discountsData);
					_this.workOrderSummaryCalculator.setRDRedeemed(_this.rogerDollarRedeemData);
					_this.workOrderSummaryCalculator.setPayments(_this.paymentsData);

					return $q.resolve(_this);
				})
		}

		WorkOrderPrint.prototype.getDocDefinition = function () {
			const _this = this;
			return imgToDataUrl(headerImg)
				.then(function (dataUrl) {
					const header = { image: dataUrl, width: 500, alignment: 'center', margin: [0, 50, 0, 0] };

					const docDefinition = {
						content: [
							header,
							getBasicInfosBlock(_this.workOrderData, _this.vehicleData, _this.customerData, _this.isQuoted),
							getPartsList(_this.partsData, _this.inventoriesData),
							getLaborsList(_this.laborsData),
							getMiscfeesList(_this.miscfeesData),
							getWorkOrderPackageList(_this.workOrderPackageListData),
							getWorkOrderWarrantyList(_this.workOrderWarrantyListData),
							getDiscountsList(_this.workOrderSummaryCalculator.getTotalDiscountDetailList()),
							getPaymentsList(_this.paymentsData, _this.rogerDollarRedeemData),
							getWorkOrderPrintedNotesList(_this.workOrderData, _this.isQuoted),
							getSummaryBlock(_this.workOrderSummaryCalculator),
							footer
						],
						styles: customStyles,
						defaultStyle: defaultStyle
					};
					return $q.resolve(docDefinition)
				});
		}

		function getPaymentsList(payments, rogerDollarRedeemData) {
			if ((!Array.isArray(payments) || payments.length <= 0) && (!Array.isArray(rogerDollarRedeemData) || rogerDollarRedeemData.length <= 0)) {
				return;
			}

			const tableBlock = {
				style: "tableStyle",
				layout: tableLayout,
				table: {
					widths: ['*', '*', '*', 60],
					headerRows: 1,
					body: [[
						{ text: "Date", style: "tableHeader" },
						{ text: "Paid By", style: "tableHeader" },
						{ text: "Received By", style: "tableHeader" },
						{ text: "Amount", style: "tableHeader" }
					]]
				}
			}

			payments.forEach(function (payment) {
				tableBlock.table.body.push(buildPaymentListRow(payment));
			});

			rogerDollarRedeemData.forEach(function (payment) {
				tableBlock.table.body.push(buildRogerDollarRedeemListRow(payment));
			});

			return tableBlock;
		}

		function getRogerDollarRedeemList(rogerDollarRedeemData) {
			if (!Array.isArray(rogerDollarRedeemData) || rogerDollarRedeemData.length <= 0) {
				return;
			}

			const tableBlock = {
				style: "tableStyle",
				layout: tableLayout,
				table: {
					widths: ['*', '*', '*', 60],
					headerRows: 1,
					body: [[
						{ text: "Date", style: "tableHeader" },
						{ text: "Paid By", style: "tableHeader" },
						{ text: "Received By", style: "tableHeader" },
						{ text: "Amount", style: "tableHeader" }
					]]
				}
			}

			rogerDollarRedeemData.forEach(function (payment) {
				tableBlock.table.body.push(buildRogerDollarRedeemListRow(payment));
			});

			return tableBlock;
		}

		function buildRogerDollarRedeemListRow(rogerDollarRedeemData) {
			if (!rogerDollarRedeemData) {
				return;
			}

			var paidBy = '';
			var receivedBy;

			if (rogerDollarRedeemData.resourceData.received_by) {
				receivedBy = rogerDollarRedeemData.resourceData.received_by.first_name + ' ' + rogerDollarRedeemData.resourceData.received_by.last_name;
			}

			paidBy = "Rogers Dollars Redemption"

			return [
				{ text: $filter('date')(moment(rogerDollarRedeemData.resourceData.date).format('MMMM Do YYYY, h:mm:ss a'), "medium") },
				{ text: paidBy },
				{ text: receivedBy },
				{
					text: $filter('currency')(rogerDollarRedeemData.resourceData
						.redeemed_amount, '$', 2)
				}
			];
		}


		function buildPaymentListRow(payment) {
			if (!payment) {
				return;
			}

			var paidBy = '';
			var receivedBy = '';

			if (payment.customer) {
				paidBy = payment.customer.first_name + ' ' + payment.customer.last_name;
			}

			if (payment.received_by) {
				receivedBy = payment.received_by.first_name + ' ' + payment.received_by.last_name;
			}

			return [
				{ text: $filter('date')(payment.payment_date, "medium") },
				{ text: paidBy },
				{ text: receivedBy },
				{ text: $filter('currency')(payment.amount, '$', 2) }
			];
		}

		function getDiscountsList(detailList) {
			if (!Array.isArray(detailList) || detailList.length <= 0) {
				return;
			}

			const tableBlock = {
				style: "tableStyle",
				layout: tableLayout,
				table: {
					widths: ['*', 60],
					headerRows: 1,
					body: [[
						{ text: "Discount", style: "tableHeader" },
						{ text: "Amount", style: "tableHeader" }
					]]
				}
			}

			detailList.forEach(function (item) {
				tableBlock.table.body.push(buildDiscountListRow(item));
			});

			return tableBlock;
		}

		function buildDiscountListRow(item) {
			if (!item || !item.discountData) {
				return;
			}

			if (item.discountData.description) {
				var description = item.discountData.description;
			} else {
				var description = "Rogers Dollars Redemption";
			}

			if (item.discountData.percentage_off) {
				description += '(' + item.discountData.percentage_off * 100 + "%)";
			}

			return [
				{ text: description },
				{ text: $filter('currency')(item.deductionAmount * -1, '$', 2) }
			];
		}

		function getLaborsList(labors) {
			if (!Array.isArray(labors) || labors.length <= 0) {
				return;
			}

			const tableBlock = {
				style: "tableStyle",
				layout: tableLayout,
				table: {
					widths: ['*', 60, 60, 60],
					headerRows: 1,
					body: [[
						{ text: "Labor", style: "tableHeader" },
						{ text: "Time(Hour)", style: "tableHeader" },
						{ text: 'Rate', style: "tableHeader" },
						{ text: 'Total', style: "tableHeader" }
					]]
				}
			}

			labors.forEach(function (labor) {
				tableBlock.table.body.push(buildLaborListRow(labor));
			});

			return tableBlock;
		}

		function getWorkOrderPackageList(workorderpackagelist) {
			if (!Array.isArray(workorderpackagelist) || workorderpackagelist.length <= 0) {
				return;
			}

			const tableBlock = {
				style: "tableStyle",
				layout: tableLayout,
				table: {
					widths: ['*', 60, 60, 60],
					headerRows: 1,
					body: [[
						{ text: "Package", style: "tableHeader" },
						{ text: "Quantity", style: "tableHeader" },
						{ text: 'Rate', style: "tableHeader" },
						{ text: 'Total', style: "tableHeader" }
					]]
				}
			}

			workorderpackagelist.forEach(function (workorderpackage) {
				tableBlock.table.body.push(buildtWorkOrderPackageListRow(workorderpackage));
			});

			return tableBlock;
		}

		function buildtWorkOrderPackageListRow(workorderpackage) {
			if (!workorderpackage) {
				return;
			}

			const workorderpackageName = workorderpackage.name;
			const unitPrice = GeneralTools.parseNumber(workorderpackage.price);
			// const hour = GeneralTools.parseNumber(workorderpackage.hour);

			return buildItemListRow(workorderpackageName, 1, unitPrice);
		}

		function getWorkOrderWarrantyList(workorderwarrantylist) {
			if (!Array.isArray(workorderwarrantylist) || workorderwarrantylist.length <= 0) {
				return;
			}

			const tableBlock = {
				style: "tableStyle",
				layout: tableLayout,
				table: {
					widths: ['*', 60, 60, 60],
					headerRows: 1,
					body: [[
						{ text: "Warranty", style: "tableHeader" },
						{ text: "Quantity", style: "tableHeader" },
						{ text: 'Price', style: "tableHeader" },
						{ text: 'Total', style: "tableHeader" }
					]]
				}
			}

			workorderwarrantylist.forEach(function (workorderwarranty) {
				tableBlock.table.body.push(buildtWorkOrderWarrantyListRow(workorderwarranty));
			});

			return tableBlock;
		}

		function buildtWorkOrderWarrantyListRow(workorderwarranty) {
			if (!workorderwarranty) {
				return;
			}

			const workorderwarrantyName = workorderwarranty.name;
			const unitPrice = GeneralTools.parseNumber(workorderwarranty.retail);
			// const hour = GeneralTools.parseNumber(workorderpackage.hour);

			return buildItemListRow(workorderwarrantyName, 1, unitPrice);
		}

		function getMiscfeesList(miscfees) {
			if (!Array.isArray(miscfees) || miscfees.length <= 0) {
				return;
			}

			const tableBlock = {
				style: "tableStyle",
				layout: tableLayout,
				table: {
					widths: ['*', 60, 60, 60],
					headerRows: 1,
					body: [[
						{ text: "Misc fees", style: "tableHeader" },
						{ text: "Quantity", style: "tableHeader" },
						{ text: 'Rate', style: "tableHeader" },
						{ text: 'Total', style: "tableHeader" }
					]]
				}
			}

			miscfees.forEach(function (miscfee) {
				tableBlock.table.body.push(buildMiscfeesListRow(miscfee));
			});

			return tableBlock;
		}

		function buildLaborListRow(labor) {
			if (!labor) {
				return;
			}

			const laborName = labor.name;
			const unitPrice = GeneralTools.parseNumber(labor.price);
			const hour = GeneralTools.parseNumber(labor.hour);

			return buildItemListRow(laborName, hour, unitPrice);
		}

		function buildMiscfeesListRow(miscfee) {
			if (!miscfee) {
				return;
			}

			const miscfeeName = miscfee.name;
			const unitPrice = GeneralTools.parseNumber(miscfee.price);
			const quantity = GeneralTools.parseNumber(miscfee.quantity);

			return buildItemListRow(miscfeeName, quantity, unitPrice);
		}

		function getWorkOrderPrintedNotesList(workorderDate, isQuoted) {
			if (!workorderDate) {
			  return;
			}
		  
			const notesList = [];

			if(isQuoted){
				notesList.push(
					{ text: ["Our quote is valid for 30 days from the date it is issued. After this period, prices and availability may be subject to change. Please let us know if you have any questions or need assistance before the expiration date."] }
				)
			}
		  
			// Add the header "Notes"
			notesList.push({
			  text: 'Notes',
			  fillColor: '#eeeeee',
			  bold: true,
			  margin: [0, 5],
			});
		  
			// Add the horizontal line
			notesList.push({ canvas: [{ type: 'line', x1: 0, y1: 0, x2: 515, y2: 0 }] });
		  
			// Add the note content
			const note = workorderDate.printed_notes;
			if (note) {
			  notesList.push({
				text: note,
				margin: [0, 5],
			  });
			}
		  
			return {
			  stack: notesList,
			};
		  }
		  


		function getPartsList(parts, inventories) {
			if ((!Array.isArray(parts) || parts.length <= 0) && (!Array.isArray(inventories) || inventories.length <= 0)) {
				return
			}

			const tableBlock = {
				style: "tableStyle",
				layout: tableLayout,
				table: {
					widths: ['*', 60, 60, 60],
					headerRows: 1,
					body: [[
						{ text: "Part", style: "tableHeader" },
						{ text: "Quantity", style: "tableHeader" },
						{ text: 'Unit Price', style: "tableHeader" },
						{ text: 'Total', style: "tableHeader" }
					]]
				}
			}

			if (Array.isArray(parts)) {
				parts.forEach(function (part) {
					if (!!part && !part.is_returned) {
						tableBlock.table.body.push(buildPartListRow(part));
					}
				});
			}

			if (Array.isArray(inventories)) {
				inventories.forEach(function (inventory) {
					tableBlock.table.body.push(buildInventoryListRow(inventory));
				});
			}

			return tableBlock;
		}

		function buildInventoryListRow(inventory) {
			if (!inventory) {
				return;
			}

			const itemName = inventory.name;
			const unitPrice = GeneralTools.parseNumber(inventory.retail_price);
			const quantity = GeneralTools.parseNumber(inventory.quantity);

			return buildItemListRow(itemName, quantity, unitPrice);
		}

		function buildPartListRow(part) {
			if (!part) {
				return;
			}

			const itemName = part.name;
			const unitPrice = GeneralTools.parseNumber(part.retail_price);
			const quantity = GeneralTools.parseNumber(part.quantity);

			return buildItemListRow(itemName, quantity, unitPrice);
		}

		function buildItemListRow(itemName, quantity, unitPrice) {
			if (typeof (quantity) != "number" || typeof (unitPrice) != "number") {
				return;
			}

			return [
				{ text: itemName },
				{ text: quantity },
				{ text: $filter('currency')(unitPrice, '$', 2) },
				{ text: $filter('currency')(unitPrice * quantity, '$', 2) }
			];
		}

		function getBasicInfosBlock(workOrder, vehicle, customer, isQuoted) {
			var invoiceNumber;
			var invoiceType = "INVOICE";
			var customerName;
			var yearMakeModel;
			var mileage;
			var vin;
			var customerPhone;
			var date;
			var rogersdollar;

			if (workOrder) {
				invoiceNumber = workOrder.invoice_number;

				if (isQuoted) {
					date = workOrder.quote_date ? workOrder.quote_date : null;
				} else {
					date = workOrder.completed_date ? $filter("date")(workOrder.completed_date, "yyyy-MM-dd") : null;
				}

				mileage = workOrder.mileage ? "Mileage: " + $filter("number")(workOrder.mileage) + " KM" : null;
			}

			if (isQuoted) {
				invoiceType = "QUOTE";
			}

			if (vehicle) {
				yearMakeModel = vehicle.getYearMakeModel();
				vin = vehicle.vin ? "VIN: " + vehicle.vin : null;
			}

			if (customer) {
				customerName = customer.getFullName();
				if (Array.isArray(customer.phone_numbers) && !!customer.phone_numbers[0]) {
					customerPhone = "Phone: " + GeneralTools.stringToPhoneNumberString(customer.phone_numbers[0].phone_number);
				}
				if (customer.rogerDollarAvaliable && customer.rogerDollarAvaliable > 0) {
					rogersdollar = customer.rogerDollarAvaliable
				} else {
					rogersdollar = 0;
				}

				rogersdollar = rogersdollar.toFixed(2)
			}

			return {
				margin: [0, 20, 0, 20],
				width: '*',
				columns: [
					{
						alignment: 'left',
						stack: [
							{ text: invoiceType + " NUMBER - " + invoiceNumber, fontSize: 10, bold: true, margin: [0, 0, 0, 10] },
							{ text: "Roger's Motors Service", bold: true },
							"550 Bronte Rd, Oakville, ON",
							"L6L 6S1",
							"Phone: (289) 815-1171"
						]
					},
					{
						alignment: 'right',
						stack: [
							{ text: "To:", fontSize: 10, bold: true, margin: [0, 0, 0, 10] },
							{ text: customerName, bold: true },
							yearMakeModel,
							mileage,
							vin,
							customerPhone,
							// "Rogers Dollar Avaliable: $" + rogersdollar,
							{ text: [{ text: "Date: ", bold: true }, date], margin: [0, 10, 0, 0] }
						]
					}
				]
			};
		}

		function getSummaryBlock(workOrderSummaryCalculator) {
			if (!workOrderSummaryCalculator) {
				return;
			}

			const subtotalBeforeSubtraction = workOrderSummaryCalculator.getSubtotalBeforeSubtraction();
			const totalDiscountOff = workOrderSummaryCalculator.getTotalDiscountAmount();
			const subsidizedAmount = workOrderSummaryCalculator.getSubsidization();
			const totalBeforeTax = workOrderSummaryCalculator.getTotalBeforeTax();
			const totalTax = workOrderSummaryCalculator.getTotalTax();
			const totalAfterTax = workOrderSummaryCalculator.getTotalAfterTax();
			const totalPayments = workOrderSummaryCalculator.getTotalPayments();

			var taxRow;
			var subsidizedRow;
			var discountsRow;
			var paymentRow;
			var totalBeforeTaxRow;

			if (totalTax) {
				taxRow = getSummaryItem("Tax (" + workOrderSummaryCalculator.getTaxRate() * 100 + "%)", totalTax);
			}

			if (subsidizedAmount) {
				var title;
				if (workOrderSummaryCalculator.getIsSubsidizedByPercentage()) {
					title = "Subsidized(" + workOrderSummaryCalculator.getSubsidizedPercentage() * 100 + "%)"
				} else {
					title = "Subsidized"
				}

				subsidizedRow = getSummaryItem(title, subsidizedAmount * -1);
			}

			if (totalDiscountOff) {
				discountsRow = getSummaryItem("Discounts", totalDiscountOff * -1);
			}

			if (totalPayments) {
				paymentRow = getSummaryItem("Payments", totalPayments);
			}

			if (subtotalBeforeSubtraction != totalBeforeTax) {
				totalBeforeTaxRow = getSummaryItem("Subtotal", totalBeforeTax)
			}

			const outstandingRow = getSummaryItem("OUTSTANDING", workOrderSummaryCalculator.getOutstanding());
			outstandingRow.bold = true;
			outstandingRow.fontSize = 14;

			return {
				stack: [
					getSummaryItem("Subtotal", subtotalBeforeSubtraction),
					discountsRow,
					subsidizedRow,
					totalBeforeTaxRow,
					taxRow,
					getSummaryItem("Total", totalAfterTax),
					paymentRow,
					outstandingRow
				]
			}

		}

		function getSummaryItem(title, value) {
			return {
				width: '*',
				margin: [0, 3, 0, 0],
				fontSize: 10,
				columns: [
					{
						alignment: 'right',
						text: title
					},
					{
						width: 100,
						alignment: 'right',
						text: $filter('currency')(value, '$', 2)
					}
				]
			}
		}

		function imgToDataUrl(url) {
			const defer = $q.defer();
			const canvas = document.createElement("canvas");

			const image = new Image();
			image.src = url;
			image.onload = function () {
				const context = canvas.getContext('2d');

				canvas.height = this.height;
				canvas.width = this.width;
				context.drawImage(this, 0, 0);

				defer.resolve(canvas.toDataURL());
			}

			image.onerror = function (error) {
				defer.reject("Failed to load image.");
			}

			return defer.promise;
		}


		WorkOrderPrint.prototype.download = function () {
			return this.getDocDefinition()
				.then(function (docDefinition) {
					pdfMake.createPdf(docDefinition).download();
				});

		}

		WorkOrderPrint.prototype.open = function () {
			return this.getDocDefinition()
				.then(function (docDefinition) {
					pdfMake.createPdf(docDefinition).open();
				});
		}

		WorkOrderPrint.prototype.getContentBlocks = function (headerDataUrl) {
			const _this = this;
			const header = { image: headerDataUrl, width: 500, alignment: 'center', margin: [0, 50, 0, 0] };
			return [
				header,
				getBasicInfosBlock(_this.workOrderData, _this.vehicleData, _this.customerData, _this.isQuoted),
				getPartsList(_this.partsData, _this.inventoriesData),
				getLaborsList(_this.laborsData),
				getMiscfeesList(_this.miscfeesData),
				getWorkOrderPackageList(_this.workOrderPackageListData),
				getWorkOrderWarrantyList(_this.workOrderWarrantyListData),
				getDiscountsList(_this.workOrderSummaryCalculator.getTotalDiscountDetailList()),
				getPaymentsList(_this.paymentsData, _this.rogerDollarRedeemData),
				getWorkOrderPrintedNotesList(_this.workOrderData, _this.isQuoted),
				getSummaryBlock(_this.workOrderSummaryCalculator),
				footer
			];
		}

		WorkOrderPrint.openMultiple = function (prints) {
			return imgToDataUrl(headerImg)
				.then(function (dataUrl) {
					var combinedContent = [];
					prints.forEach(function (wp, i) {
						if (i > 0) {
							combinedContent.push({ text: '', pageBreak: 'before' });
						}
						var blocks = wp.getContentBlocks(dataUrl);
						blocks.forEach(function (block) {
							if (block) {
								combinedContent.push(block);
							}
						});
					});
					var docDefinition = {
						content: combinedContent,
						styles: customStyles,
						defaultStyle: defaultStyle
					};
					pdfMake.createPdf(docDefinition).open();
				});
		}




		WorkOrderPrint.prototype.getPdfDocDefinition = function () {
			return this.getDocDefinition()
				.then(function (docDefinition) {
					return docDefinition
				})

		};


		// WorkOrderPrint.prototype.getPdfDocDefinition = function () {
		//   return this.getDocDefinition()
		// 	.then(function (docDefinition) {
		// 	  var pdfDocument = pdfMake.createPdf(docDefinition);
		// 	  return new Promise(function (resolve, reject) {
		// 		pdfDocument.getBuffer((buffer) => {
		// 		  resolve(buffer);
		// 		});
		// 	  });
		// 	})
		// 	.catch(function (error) {
		// 	  console.error("Error generating PDF:", error);
		// 	  throw error;
		// };


		function fetchVehicleData(vehicleID) {
			const resourcePath = {
				companyID: companyID,
				vehicleID: vehicleID
			};

			return VehicleService.getVehicle(resourcePath)
				.then(function (result) {
					if (!result || !Array.isArray(result.data) || result.data.length != 1 || !result.data[0]) {
						return $q.reject("Failed to fetch vehicle data");
					}

					return $q.resolve(result.data[0]);
				});
		}

		function fetchWorkOrderData(vehicleID, workOrderID) {
			const resourcePath = {
				companyID: companyID,
				vehicleID: vehicleID,
				workorderID: workOrderID
			};

			return WorkOrderService.getWorkOrders(resourcePath).$promise
				.then(function (result) {
					if (!result || !Array.isArray(result) || result.length != 1 || !result[0]) {
						return $q.reject("Failed to fetch work order data");
					}

					return $q.resolve(result[0]);
				});
		}

		function fetchCustomerData(customerID) {
			if (!customerID) {
				var sampleCustomer = new Customer()

				sampleCustomer.setAttributes({
					first_name: "Roger's",
					last_name: "Motors",
					phone_numbers: [{ phone_number: "9056180350" }]
				});

				return $q.resolve(sampleCustomer)
			}

			const resourcePath = {
				customerID: customerID,
				companyID: companyID
			};
			return CustomersService.getCustomers(resourcePath)
				.then(function (result) {
					if (!result || !Array.isArray(result.data) || result.data.length != 1 || !result.data[0]) {
						return $q.reject("Failed to fetch customer data");
					}

					return $q.resolve(result.data[0]);
				});
		}

		function fetchPartsData(vehicleID, workOrderID) {
			const resourcePath = {
				companyID: companyID,
				vehicleID: vehicleID,
				workorderID: workOrderID
			};

			return WorkOrderService.getWorkOrderParts(resourcePath).$promise
		}

		function fetchInventoriesData(vehicleID, workOrderID) {
			const resourcePath = {
				companyID: companyID,
				vehicleID: vehicleID,
				workorderID: workOrderID
			};

			return WorkOrderService.getWorkOrderInventories(resourcePath).$promise
		}

		function fetchLaborsData(vehicleID, workOrderID) {
			const resourcePath = {
				companyID: companyID,
				vehicleID: vehicleID,
				workorderID: workOrderID
			};

			return WorkOrderService.getLabors(resourcePath).$promise
		}

		function fetchWorkOrderPackageListData(vehicleID, workOrderID) {
			const resourcePath = {
				companyID: companyID,
				vehicleID: vehicleID,
				workorderID: workOrderID
			};

			return WorkOrderService.getWorkOrderPackages(resourcePath).$promise
		}

		function fetchWorkOrderWarrantyListData(vehicleID, workOrderID) {
			const resourcePath = {
				companyID: companyID,
				vehicleID: vehicleID,
				workorderID: workOrderID
			};

			return WorkOrderService.getWorkOrderWarranties(resourcePath).$promise;
		}



		function fetchMiscfeesData(vehicleID, workOrderID) {
			const resourcePath = {
				companyID: companyID,
				vehicleID: vehicleID,
				workorderID: workOrderID
			};

			return WorkOrderService.getMiscfeestype(resourcePath).$promise
		}

		function fetchDiscountsData(vehicleID, workOrderID) {
			const resourcePath = {
				companyID: companyID,
				vehicleID: vehicleID,
				workorderID: workOrderID
			};

			return WorkOrderService.getDiscounts(resourcePath).$promise;
		}


		function fetchRogerDollarRedeemData(vehicleID, workOrderID) {
			const resourcePath = {
				companyID: companyID,
				vehicleID: vehicleID,
				workorderID: workOrderID
			};

			return WorkOrderService.getredeemedRD(resourcePath).$promise;
		}


		function fetchPaymentsData(vehicleID, workOrderID) {
			const resourcePath = {
				companyID: companyID,
				vehicleID: vehicleID,
				workorderID: workOrderID
			};

			return WorkOrderService.getPayments(resourcePath).$promise;
		}

		function generatePdfContent(result) {

			const headerImage = result.content[0].image;
			const header = { image: headerImage, width: 500, alignment: 'center', margin: [0, 50, 0, 0] };

			return [header];
		}

		return WorkOrderPrint;
	}
})();
(function ()
{
	'use strict';

	angular
		.module('app.workOrders')
		.controller('SelectCustomerPortalCalendarDialogController', SelectCustomerPortalCalendarDialogController);

	function SelectCustomerPortalCalendarDialogController(calendars, $mdDialog, $state, GeneralTools, WorkOrderService, LoginService){   
		const vm = this;

		vm.calendars = calendars;
		vm.closeDialog = closeDialog;
		vm.select = select
		vm.getCustomerUrl =getCustomerUrl;
		vm.getVehicleUrl = getVehicleUrl;
		vm.getCustomerPhoneNumber = getCustomerPhoneNumber;
		vm.isDeleting = false;
		vm.deleteAppointment = deleteAppointment;
		const companyID = LoginService.getCompanyID();

		function select(id) {
			if(!Array.isArray(vm.calendars)){
				$mdDialog.hide();
			}

			const matchedCalendar = vm.calendars.find(function(calendar){
				if(calendar){
					return calendar.id_calendar == id;
				}
			});

			$mdDialog.hide(matchedCalendar);
		}

		function closeDialog (){
			$mdDialog.hide();
		}

		function getCustomerUrl(customerID){
			if(customerID == null){
				return;
			}
			// console.log($state.href("app.view-customer", {customerID: customerID}))
			$state.go("app.view-customer", {customerID: customerID})
			$mdDialog.hide();
			return 

		}

		function getVehicleUrl(vehicleID){
			if(vehicleID == null){
				return;
			}
			var param = {vehicleID: vehicleID};
			// console.log($state.href('app.vehicle.general', param, {absolute: true}))
			$state.go('app.vehicle.general', param, {absolute: true})
			$mdDialog.hide();
			return
		}

		
		function getCustomerPhoneNumber(phone_numbers){
			if(phone_numbers.length <= 0){
				return ''
			}

			return GeneralTools.stringToPhoneNumberString(phone_numbers);
		}

		function deleteAppointment(){
			vm.isDeleting = true;
			var appointmentId = vm.calendars.appointmentID
			var resourcePath = {
				companyID: companyID,
				customerportalappointmentID: appointmentId
			}
			WorkOrderService.cancelCustomerPortalAppointmentByAdmin(resourcePath).then(function(result){
				console.log(result)
			})
			vm.isDeleting = false;
		}
	}
})();
(function ()
{
	'use strict';

	angular
		.module('app.workOrders')
		.controller('CustomerPortalAppointmentController', CustomerPortalAppointmentController);

	function CustomerPortalAppointmentController(api, WorkOrderSummaryCalculator, AppointmentConstants, WorkOrderConstants, userConfig, ToolsConstants, customerportalcalendars, DialogService, UserConfigService, UserConfigConstants, AppointmentsService, LoginConst, $location, $state, VehicleService, GeneralTools, $stateParams, $scope, $q, $timeout, MessageService, $mdDialog, WorkOrderService, LoginService){   
		const vm = this;
		// const deleteAppointmentWarningTitle = "Delete Appointment";
		const companyID = LoginService.getCompanyID();
		const userID = LoginService.getUserID();
		// const maxAppointmentDuration = 8;
		// const defaultAppointmentDuration = 1;
		const eventTextColor = "white";
		const startKeyName = "start";
		const calendarKeyName = "fk_id_job_type";
		const customAppointmentTag = "[CUSTOM] ";
		const timeRangeFilterFormat = "YYYY-MM-DD HH:mm:ss";
		const appointmentTimeFormat = "YYYY-MM-DD[T]HH:mm:ss[Z]";
		const calendarHeader = { 
				left: WorkOrderConstants.calendarViews.dayGridMonth + ',' + WorkOrderConstants.calendarViews.timeGridWeek + ',' + WorkOrderConstants.calendarViews.timeGridDay,
				center:"title",
				right: "prev,today,next"
			};
		const calendarViewsOptions = {
				timeGrid:{
					minTime: "9:00:00",
					maxTime: "19:00:00",
					allDaySlot: false,
					slotDuration: "00:15:00",
					slotLabelInterval: "0:30"
				}
			};
		const requests = [];

		var calendarGrid;
		// var workOrder;
		// var workordersDetailsMap = {};

		// vm.warningMessageDateFormat = WorkOrderConstants.scheduleDateFormat;
		vm.refreshCalendarGrid = refreshCalendarGrid;
		vm.isCustomFilterApplied = isCustomFilterApplied;
		vm.selectCustomFilter = selectCustomFilter;
		vm.deleteCustomFilter = deleteCustomFilter;
		vm.addCustomFilter = addCustomFilter;
		// vm.showWarningMessageBox = showWarningMessageBox;
		// vm.getWorkorderUrl = getWorkorderUrl;

		init();

		function init(){
			initCustomFilters();
			initCalendarOptions();
			initCalendarFilters();
			initCalendarGrid();
			//initNewWorkOrderAppointment();
			//initNewAppointment();
			$scope.$on("$stateChangeStart", cancelRequest);
		}

		function cancelRequest(){
			for(var i = requests.length - 1; i >= 0; i--){
				const request = requests[i];

				if(request && request.$cancelRequest){
					request.$cancelRequest();
					requests.splice(i, 1);
				}
			}
		}

		function initCustomFilters(){
			if(!userConfig){
				return;
			}
			vm.pageConfigs = userConfig.getPageConfigs(UserConfigConstants.pageKeyNames.customerPortalAppointment);
		}

		function initCalendarFilters(){
			const pageConfigs = LoginService.getPageConfigs(LoginConst.pageConfigKeys.workorderSchedule);
			var calendarFilter = GeneralTools.urlObjectParamTranslator($stateParams.calendarFilters);		

			if(Array.isArray(calendarFilter)){
				applyCalendarFilter(calendarFilter);
				return;
			}

			if (pageConfigs && pageConfigs.currentCalendar){
				const customFilter = getCustomFilterByName(pageConfigs.currentCalendar);

				if(customFilter){
					calendarFilter = customFilter.calendars;		
				}
			}

			applyCalendarFilter(calendarFilter);
		}

		function initCalendarOptions(){
			vm.calendars = customerportalcalendars;


			if(!Array.isArray(vm.calendars)){
				vm.calendars = [];
			}

			
		}

		function initCalendarGrid(){
			const calendarEl = document.getElementById('calendar');
			calendarGrid = new FullCalendar.Calendar(calendarEl, {
				header: calendarHeader,
				businessHours: [
					{
						daysOfWeek: [ 1, 2, 3, 4, 5],
						startTime: '10:00',
						endTime: '20:00',
						format: "HH:mm"
					},
				],
				eventConstraint: "businessHours",
				height: "auto",
				droppable: !vm.isAddingEvent && !vm.isLoadingEvents && !vm.isUpdatingEvent,
				editable: !vm.isAddingEvent && !vm.isLoadingEvents && !vm.isUpdatingEvent,
				eventLimit: true,
				plugins: [ "dayGrid", "timeGrid", "interaction"],
				defaultView: getCalendarDefaultView(),
				views:calendarViewsOptions,
				events: function(fetchInfo){
					if(calendarGrid){
						calendarGrid.removeAllEvents()
					}

					return fetchEvents(moment(fetchInfo.start), moment(fetchInfo.end));
				},
				// eventDrop:function(info){
				// 	updateAppointmentTime(info.event)
				// },
				// eventResize:function(info){
				// 	updateAppointmentTime(info.event)
				// },
				// eventReceive:function(info){
				// 	onAppointmentAdd(info.event);
				// },
				eventClick:function(info){
					if(info.event.extendedProps.isCustomAppointment){
						showEditAppointmentDialog(info.event)
					}
				},
				datesRender:function(info){
					refreshWarningMessages();
				}
			});

			calendarGrid.render();

			if($stateParams.goToDate){
				calendarGrid.gotoDate($stateParams.goToDate);
			}
		}

		function getCalenderEventsByTimeRange(events, startMomentObj, endTimeMomentObj){
			if(!Array.isArray(events) || !startMomentObj || !startMomentObj.isValid() || !endTimeMomentObj || !endTimeMomentObj.isValid()){
				return;
			}

			return events.filter(function(event){
				if(!event || !event.start){
					return;
				}
				const eventStart = moment(event.start);
				return eventStart.isValid() && eventStart.isSameOrAfter(startMomentObj) && eventStart.isSameOrBefore(endTimeMomentObj)
			});
		}

		function getCalendarDefaultView(){
			if(!GeneralTools.isMobileOrTabletDevice()){
				return WorkOrderConstants.calendarViews.timeGridWeek;
			}

			return WorkOrderConstants.calendarViews.timeGridDay;
		}

		function showEditAppointmentDialog(calendarEvent){
			if(!calendarEvent || !calendarEvent.extendedProps){
				return;
			}
			const originTitle = removeCustomTag(calendarEvent.title);
			const dialogOptions = {
				controller: 'SelectCustomerPortalCalendarDialogController',
				controllerAs: 'vm',
				templateUrl: 'app/main/workorders/customer_portal_appointment/select-customer-portal-calendar-dialog.html',
				clickOutsideToClose: true,
				locals: {title: originTitle},
				calendars: calendarEvent.extendedProps
				
			};

			$mdDialog.show(dialogOptions)
				.then(function(result){
					return
				})
				.catch(function(error){
					if(error){
						MessageService.showToast(error);
					}
				});
		}

		function showDeleteAppointmentDialog(calendarEvent){
			if(!calendarEvent){
				return;
			}

			const warningMessage = "Are you sure to delete appointment " + calendarEvent.title;

			const resourcePath = {
				companyID: companyID,
				appointmentID: calendarEvent.extendedProps.appointmentID
			}

			DialogService.showYesOrNoDialog(deleteAppointmentWarningTitle, warningMessage)
				.then(function(yes){
					if(yes){
						return AppointmentsService.deleteAppointment(resourcePath);;
					}

					return $q.reject();
				})
				.then(function(){
					calendarEvent.remove()
				})
				.catch(function(error){
					if(error){
						MessageService.showToast(error);
					}
				});
		}

		function removeCustomTag(title){
			if(!title){
				return;
			}
			// console.log(title)
			// if(title.startsWith(customAppointmentTag)){
			// 	title = title.substring(customAppointmentTag.length, title.length);
			// }	

			return title;
		}

		function fetchEvents(startTime, endTime){
			const defer = $q.defer();
			const resourcePath = {companyID: companyID};
			const filter = getFilter(startTime, endTime);

			const queue = {
				allAppointments: AppointmentsService.getAllMatchedCustomerPortalAppointments(resourcePath, filter),
			}

			vm.isLoadingEvents = true;

			$q.all(queue).then(function(result){
					if(!result){
						return $q.reject("Appointments data invalid");
					}

					const appointments = builtEventList(result.allAppointments);

					if(!Array.isArray(appointments)){
						return $q.reject("Appointments data invalid"); 
					}

					refreshUrl();
					saveCustomFilterToLocal();
					refreshWarningMessages(appointments);
					vm.isLoadingEvents = false;
					defer.resolve(appointments); 
				})
				.catch(function(error){
					MessageService.showToast(error);
					defer.reject(error);
				});

			return defer.promise;
		}

		// function getSelectedCalendars() {
		// 	if(!Array.isArray(vm.calendars)){
		// 		return;
		// 	}

		// 	return vm.calendars.filter(function(calendar){
		// 		return !!calendar && calendar.isShow;
		// 	});
		// }

		function builtEventList(allAppointments){
			if(!Array.isArray(allAppointments)){
				return;
			}

			return allAppointments.map(function(appointment){
				if(!appointment){
					return;
				}

				return castAppointmentToCalenderEvent(appointment);
			});
		}

		function castAppointmentToCalenderEvent(appointment){

			if(!appointment){
				return;
			}
			const event = {};
			var title;

			if(appointment.appointment_type_name){
				title = appointment.appointment_type_name;
			}
			if(appointment.customer_name){
				title += ", " + appointment.customer_name;
			}

			if(appointment.vehicle_name){
				title += ", " + appointment.vehicle_name;
			}


			event.title = title;
			event.start = appointment.start;
			event.end = appointment.end;
			event.color = getCalendarColor(appointment.fk_id_job_type);
			
			event.textColor = eventTextColor;
			event.extendedProps = {
				isCustomAppointment: true,
				appointmentID: appointment.id_customer_portal_appointment,
				type: appointment.fk_id_job_type,
				title: title,
				name: appointment.customer_name,
				start: appointment.start,
				end: appointment.end,
				email: appointment.cutomer_email,
				phone: appointment.cutomer_phone,
				additional_info: appointment.customer_additional_information,
				appointment_type: appointment.appointment_type_name,
				vehicle_name: appointment.vehicle_name,
				customer_id: appointment.fk_id_customer,
				vehicle_id: appointment.fk_id_vehicle,
			}

			return event;
		}

		function getCalendarColor(calendarID){
			var colorstring = ""
			if(!Array.isArray(vm.calendars)){
				return;
			}
			const matchedCalendar = vm.calendars.find(function(calendar){
				if(calendar){
					return calendar.id_job == calendarID;
				}
			});

			if(matchedCalendar){
				return matchedCalendar.color;
			}
		}

		function getFilter(startMoment, endMoment){
			var calendarFilter = getCalendarFilterString();
			var timeRangeFilter = getTimeRangeFilterString(startMoment, endMoment);

			if(!timeRangeFilter){
				return;
			}

			timeRangeFilter = GeneralTools.addBracketToString(timeRangeFilter);

			if(calendarFilter){
				calendarFilter = GeneralTools.addBracketToString(calendarFilter);
			}

			//var filterString = GeneralTools.notEqualFilterBuilder(AppointmentConstants.keyNames.appointmentStatus, AppointmentConstants.statusIDs.CANCELLED);
			var filterString;
			filterString = GeneralTools.stringConnector(filterString, calendarFilter, ToolsConstants.apiFilters.andConnector);
			filterString = GeneralTools.stringConnector(filterString, timeRangeFilter, ToolsConstants.apiFilters.andConnector);

			return { filters: filterString };
		}

		function getTimeRangeFilterString(startMoment, endMoment){
			if(!startMoment || !startMoment.isValid() || !endMoment || !endMoment.isValid() || startMoment.isSameOrAfter(endMoment)){
				return;
			}

			return GeneralTools.equalRangeFilterBuilder(startKeyName, startMoment.utc().format(timeRangeFilterFormat), endMoment.utc().format(timeRangeFilterFormat))
		}

		function getCalendarFilterString(){
			if(!Array.isArray(vm.calendars)){
				return;
			}

			var filterString = '';

			vm.calendars.forEach(function(calendar){
				if(calendar && calendar.isShow){
					filterString = GeneralTools.stringConnector(filterString, GeneralTools.equalFilterBuilder(calendarKeyName, calendar.id_job), ToolsConstants.apiFilters.orConnector)
				}
			});
			return filterString;
		}

		function refreshUrl(){
			const urlParams = {};


			const currentCalendars = [];
			if(Array.isArray(vm.calendars)){
				vm.calendars.forEach(function(calendar){
					if(calendar && calendar.isShow){
						currentCalendars.push(calendar.id_job);
					}
				});
			}
			
			urlParams.calendarFilters = JSON.stringify(currentCalendars);
			$location.search(urlParams).replace();
		}

		function saveCustomFilterToLocal(){
			if(!vm.pageConfigs || !Array.isArray(vm.pageConfigs.customFilters)){
				return;
			}

			const currentCustomFilter = vm.pageConfigs.customFilters.find(function(customFilter){
				return isCustomFilterApplied(customFilter);
			});

			if(!currentCustomFilter){
				return;
			}

			var pageConfigs = LoginService.getPageConfigs(LoginConst.pageConfigKeys.workorderSchedule);

			if(!pageConfigs){
				pageConfigs = {};
			}

			pageConfigs.currentCalendar = currentCustomFilter.name;

			LoginService.savePageConfigs(LoginConst.pageConfigKeys.workorderSchedule, pageConfigs);
		}

		function getCustomFilterByName(name) {
			if(!vm.pageConfigs || !Array.isArray(vm.pageConfigs.customFilters)){
				return;
			}

			return vm.pageConfigs.customFilters.find(function(customFilter){
				return !!customFilter && customFilter.name == name;
			});
		}

		function applyCalendarFilter(calendarFilter) {
			if(!Array.isArray(vm.calendars)){
				return;
			}

			const hasFilter = Array.isArray(calendarFilter);

			vm.calendars.forEach(function(calendar) {
				if(calendar && hasFilter){
					calendar.isShow = calendarFilter.indexOf(calendar.id_job) != -1;
				} else {
					calendar.isShow = true;
				}
			});	
		}

		function isCustomFilterApplied(customFilter) {
			if(!customFilter || !Array.isArray(customFilter.calendars) || !Array.isArray(vm.calendars)){
				return;
			}

			return vm.calendars.every(function(calendar) {
				if(!calendar){
					return;
				}

				if(customFilter.calendars.indexOf(calendar.id_job) == -1){
					return !calendar.isShow;
				} else {
					return calendar.isShow;
				}
			});			
		}

		function selectCustomFilter(customFilterName) {
			const customFilter = getCustomFilterByName(customFilterName);
			if(customFilter){
				applyCalendarFilter(customFilter.customerportalcalendars);
				refreshCalendarGrid();
			}
		}

		function deleteCustomFilter(index){
			var dialogOptions = {};

			dialogOptions.titleString = "Remove Filter";
			dialogOptions.contentString = "Are you sure to remove filter";

			var confirmOption = {};

			confirmOption.optionName = "YES";
			confirmOption.onClick = function(){
				confirmDeleteCustomFilter(index);
				DialogService.close();
			}

			var cancelOption = {};

			cancelOption.optionName = "NO";
			cancelOption.onClick = function(){
				DialogService.close();
			}

			dialogOptions.options = [confirmOption, cancelOption];

			DialogService.showOptionsDialog(dialogOptions);
		}

		function confirmDeleteCustomFilter(index) {
			const currentPageConfig = userConfig.getPageConfigs(UserConfigConstants.pageKeyNames.customerPortalAppointment);	

			if(currentPageConfig && Array.isArray(currentPageConfig.customFilters)){
				currentPageConfig.customFilters.splice(index, 1);
			}

			userConfig.setPageConfigs(UserConfigConstants.pageKeyNames.customerPortalAppointment, currentPageConfig);		

			vm.isDeletingFilter = true;
			
			updateUserConfig(userConfig)
				.then(function(){
					vm.pageConfigs = currentPageConfig;
					MessageService.showToast("Filter is removed.");
				})
				.catch(MessageService.showToast)
				.finally(function(){
					vm.isDeletingFilter = false;
				});
		}

		function refreshCalendarGrid(){
			if(calendarGrid){
				calendarGrid.refetchEvents();
			}
		}

		function addCustomFilter() {
			if(!vm.newCustomFilterName){
				MessageService.showToast("Please enter a name.")
				return;
			}

			if(!Array.isArray(vm.calendars)){
				return;
			}

			const calendarIdList = [];

			vm.calendars.forEach(function(calendar){
				if(calendar && calendar.isShow){
					calendarIdList.push(calendar.id_job);
				}
			});

			var currentPageConfig = userConfig.getPageConfigs(UserConfigConstants.pageKeyNames.customerPortalAppointment);

			if(!currentPageConfig){
				currentPageConfig = {};
			}

			if(!Array.isArray(currentPageConfig.customFilters)){
				currentPageConfig.customFilters = [];
			}

			currentPageConfig.customFilters.push({
				name: vm.newCustomFilterName,
				customerportalcalendars: calendarIdList
			});

			userConfig.setPageConfigs(UserConfigConstants.pageKeyNames.customerPortalAppointment, currentPageConfig);		

			vm.isSavingFilter = true;
			
			updateUserConfig(userConfig)
				.then(function(){
					vm.pageConfigs = currentPageConfig;
					vm.newCustomFilterName = null;
					MessageService.showToast("New filter is saved.");
				})
				.catch(MessageService.showToast)
				.finally(function(){
					vm.isSavingFilter = false;
				});
		}

		function updateUserConfig(userConfig){
			if(!userConfig){
				return $q.reject("User config invalid");
			}

			const resourcePath = {
				companyID: companyID,
				userID: userID
			}

			const requestBody = {
				config: userConfig.config
			}
			return UserConfigService.updateUserConfig(resourcePath, requestBody);
		}

		// function fetchServiceMap(vehicleID){
		// 	const resourcePath = {
		// 		companyID: companyID
		// 	};

		// 	const filter = {
		// 		filters: GeneralTools.equalFilterBuilder("fk_id_vehicle", vehicleID)
		// 	}

		// 	return WorkOrderService.getAllMatchedServiceMaps(resourcePath, filter);
		// }

		// function fetchVehicle(vehicleID){
		// 	const resourcePath = {
		// 		companyID: companyID,
		// 		vehicleID: vehicleID
		// 	};

		// 	return VehicleService.getVehicle(resourcePath)
		// 		.then(function(result){
		// 			if(!result || !Array.isArray(result.data) || result.data.length != 1 || !result.data[0]){
		// 				return $q.reject("Failed to fetch vehicle data");
		// 			}

		// 			return result.data[0];	
		// 		})
		// }

		// function fetchWorkOrder(workOrderID, vehicleID){
		// 	const resourcePath = {
		// 		companyID: companyID,
		// 		vehicleID: vehicleID,
		// 		workorderID: workOrderID
		// 	};

		// 	const request = WorkOrderService.getWorkOrders(resourcePath);
		// 	requests.push(request);

		// 	return request.$promise.then(function(result){
		// 		if(!Array.isArray(result) || result.length != 1 || !result[0]){
		// 			return $q.reject("Failed to fetch word order data");
		// 		}

		// 		return $q.resolve(result[0]);
		// 	});
		// }

		// function fetchWorkOrderLabors(workOrderID, vehicleID){
		// 	const resourcePath = {
		// 		companyID: companyID,
		// 		vehicleID: vehicleID,
		// 		workorderID: workOrderID
		// 	};

		// 	const request = WorkOrderService.getLabors(resourcePath);
		// 	requests.push(request);
			
		// 	return request.$promise;
		// }

		// function buildNewWorkOrderAppointmentObj(workOrder, labors, vehicle, serviceMap){
		// 	if(!workOrder || !vehicle || !Array.isArray(labors) || !Array.isArray(serviceMap)){
		// 		return;
		// 	}

		// 	var title = '';

		// 	if(serviceMap[0] && serviceMap[0].customer){
		// 		title += serviceMap[0].customer.first_name + ' ' + serviceMap[0].customer.last_name + '\'s ';
		// 	}
			
		// 	title += vehicle.getYearMakeModel();

		// 	var totalLaborTime = 0;

		// 	labors.forEach(function(labor){
		// 		if(labor){
		// 			totalLaborTime += labor.hour;
		// 		}

		// 		title += ' ' + labor.name;
		// 	});

		// 	if(workOrder.notes){
		// 		title += ' ' + workOrder.notes;
		// 	}

		// 	totalLaborTime = Math.ceil(totalLaborTime / 0.25) * 0.25;

		// 	if(totalLaborTime > maxAppointmentDuration){
		// 		totalLaborTime = maxAppointmentDuration;
		// 	}

		// 	if(totalLaborTime <= 0){
		// 		totalLaborTime = defaultAppointmentDuration;
		// 	}

		// 	const newWorkOrderAppointment = {
		// 		title: title,
		// 		textColor: eventTextColor,
		// 		duration: {
		// 			hours: Math.floor(totalLaborTime),
		// 			minutes: totalLaborTime % 1 * 60
		// 		},
		// 		extendedProps:{
		// 			isCustomAppointment: false
		// 		},
		// 		url: getWorkorderUrl(workOrder.id_work_order, vehicle.getResourceID())
		// 	}
		// 	vm.workOrderInvoiceNumber = workOrder.invoice_number;
		// 	vm.workOrderAppointmentTitle = title;

		// 	const draggableEl = document.getElementById('newWorkOrderAppointment');
		// 	new FullCalendarInteraction.Draggable(draggableEl, {eventData:newWorkOrderAppointment});
		// }

		// function initNewAppointment(){
		// 	vm.newAppointment = { 
		// 		title: '',
		// 		duration: "01:00", 
		// 		textColor: eventTextColor,
		// 		extendedProps:{
		// 			isCustomAppointment: true
		// 		} 
		// 	};
			
		// 	const draggableEl = document.getElementById('newAppointment');
		// 	new FullCalendarInteraction.Draggable(draggableEl, {eventData:vm.newAppointment});
		// }

		function refreshWarningMessages(appointments){
			if(vm.showNewWorkOrderAppointment){
				return;
			}

			cancelRequest();

			if(!Array.isArray(appointments) && calendarGrid && calendarGrid.view){
				appointments = getCalenderEventsByTimeRange(calendarGrid.getEvents(), moment(calendarGrid.view.currentStart),  moment(calendarGrid.view.currentEnd));
			}

			if(!Array.isArray(appointments)){
				return;
			}

			const queue = {};
			vm.isRefreshingWarningMessage = true;

			appointments.forEach(function(appointment){
				if(!appointment || !appointment.extendedProps ||  appointment.extendedProps.isCustomAppointment){
					return;
				}
			});

			$q.all(queue)
				.then(function(workorderDetails){
					// refreshEmptyWorkorderWarningMessage(appointments, workorderDetails);
					// refreshPartsNotOrderedWarningMessage(appointments, workorderDetails);
					// refreshInventoryInsufficientWarningMessage(appointments, workorderDetails);
					// refreshPassedDueTimeWarningMessage(appointments, workorderDetails);
					// refreshCompletedWithOutstandingWarningMessage(appointments, workorderDetails);
				})
				.catch(function(error){
					if(error){
						MessageService.showToast(error);
					}
				})
				.finally(function(){
					vm.isRefreshingWarningMessage = false;
				});
		}

		// function refreshEmptyWorkorderWarningMessage(appointments, workorderDetails){
		// 	if(!Array.isArray(appointments) || !workorderDetails){
		// 		return;
		// 	}

		// 	const appointmentMap = {};
		// 	vm.emptyWorkorders = {};
		// 	vm.emptyWorkordersCount = 0;

		// 	appointments.forEach(function(appointment){
		// 		if(!appointment || !appointment.extendedProps || appointment.extendedProps.isCustomAppointment || !isAppointmentExpected(appointment.extendedProps.status)){
		// 			return;
		// 		}

		// 		if(!Array.isArray(appointmentMap[appointment.extendedProps.workOrderID])){
		// 			appointmentMap[appointment.extendedProps.workOrderID] = [];
		// 		}

		// 		appointmentMap[appointment.extendedProps.workOrderID].push(appointment);
		// 	});

		// 	Object.keys(workorderDetails).forEach(function(workorderID){
		// 		if(!workorderDetails[workorderID] 
		// 			|| !workorderDetails[workorderID].workorder 
		// 			|| !workorderDetails[workorderID].workorder.isQuoted()

		// 			|| !workorderDetails[workorderID].workorder.isBooked()
		// 			|| !workorderDetails[workorderID].workorder.isOnLot()
		// 			|| !workorderDetails[workorderID].workorder.isStarted()

		// 			|| !Array.isArray(appointmentMap[workorderID])
		// 			|| appointmentMap[workorderID].length <= 0){
		// 			return;
		// 		}

		// 		if((!Array.isArray(workorderDetails[workorderID].parts) || workorderDetails[workorderID].parts.length <= 0) &&
		// 			(!Array.isArray(workorderDetails[workorderID].inventories) || workorderDetails[workorderID].inventories.length <= 0) &&
		// 			(!Array.isArray(workorderDetails[workorderID].labors) || workorderDetails[workorderID].labors.length <= 0)){

		// 			vm.emptyWorkorders[workorderID] = {
		// 				workorder: workorderDetails[workorderID].workorder,
		// 				appointments: appointmentMap[workorderID]
		// 			};

		// 			vm.emptyWorkordersCount++;
		// 		}
		// 	});
		// }

		// function isAppointmentExpected(statusID){
		// 	switch(statusID){
		// 		case AppointmentConstants.statusIDs.NO_SHOW:
		// 			return false;
		// 		case AppointmentConstants.statusIDs.CANCELLED:
		// 			return false;
		// 		case AppointmentConstants.statusIDs.POSTPONED:
		// 			return false;
		// 		default:
		// 			return true;
		// 	}
		// }

		// function refreshPartsNotOrderedWarningMessage(appointments, workorderDetails){
		// 	if(!Array.isArray(appointments) || !workorderDetails){
		// 		return;
		// 	}

		// 	const appointmentMap = {};
		// 	vm.partsNotOrdered = {};
		// 	vm.partsNotOrderedCount = 0;
			
		// 	appointments.forEach(function(appointment){
		// 		if(!appointment || !appointment.extendedProps || appointment.extendedProps.isCustomAppointment || !isAppointmentExpected(appointment.extendedProps.status)){
		// 			return;
		// 		}

		// 		if(!Array.isArray(appointmentMap[appointment.extendedProps.workOrderID])){
		// 			appointmentMap[appointment.extendedProps.workOrderID] = [];
		// 		}

		// 		appointmentMap[appointment.extendedProps.workOrderID].push(appointment);
		// 	});

		// 	Object.keys(workorderDetails).forEach(function(workorderID){
		// 		if(!workorderDetails[workorderID] 
		// 			|| !workorderDetails[workorderID].workorder 
		// 			|| !workorderDetails[workorderID].workorder.isQuoted()

		// 			|| !workorderDetails[workorderID].workorder.isBooked()
		// 			|| !workorderDetails[workorderID].workorder.isOnLot()
		// 			|| !workorderDetails[workorderID].workorder.isStarted()

		// 			|| !Array.isArray(appointmentMap[workorderID])
		// 			|| appointmentMap[workorderID].length <= 0){
		// 			return;
		// 		}

		// 		if(isAnyPartsNotOrdered(workorderDetails[workorderID].parts)){
		// 			vm.partsNotOrdered[workorderID] = {
		// 				workorder: workorderDetails[workorderID].workorder,
		// 				appointments: appointmentMap[workorderID]
		// 			}
		// 			vm.partsNotOrderedCount++;
		// 		}
		// 	});
		// }

		// function refreshInventoryInsufficientWarningMessage(appointments, workorderDetails){
		// 	var demandMap = {};
		// 	var appointmentMap = {};
		// 	vm.inventoryInsufficientCount = 0;

		// 	appointments.forEach(function(appointment){
		// 		if(!appointment || !appointment.extendedProps ||  appointment.extendedProps.isCustomAppointment || !isAppointmentExpected(appointment.extendedProps.status)){
		// 			return;
		// 		}

		// 		if(!Array.isArray(appointmentMap[appointment.extendedProps.workOrderID])){
		// 			appointmentMap[appointment.extendedProps.workOrderID] = [];
		// 		}

		// 		appointmentMap[appointment.extendedProps.workOrderID].push(appointment);
		// 	});

		// 	Object.keys(workorderDetails).forEach(function(workorderID){
		// 		if(!workorderDetails[workorderID] || !Array.isArray(workorderDetails[workorderID].inventories) || !workorderDetails[workorderID].workorder || !workorderDetails[workorderID].workorder.isQuoted() || !workorderDetails[workorderID].workorder.isBooked()  || !workorderDetails[workorderID].workorder.isOnLot()  || !workorderDetails[workorderID].workorder.isStarted()  || !appointmentMap[workorderID] || appointmentMap[workorderID].length <= 0){
		// 			return;
		// 		}

		// 		workorderDetails[workorderID].inventories.forEach(function(inventory){
		// 			if(!inventory){
		// 				return;
		// 			}

		// 			const quantityInStock = GeneralTools.parseNumber(inventory.quantity_in_stock);
		// 			const demandQuantity = GeneralTools.parseNumber(inventory.quantity);
		// 			const demandMapDetail = {
		// 				workorder: workorderDetails[workorderID].workorder,
		// 				appointments: appointmentMap[workorderID]
		// 			};

		// 			if(demandMap[inventory.fk_id_inventory]){
		// 				demandMap[inventory.fk_id_inventory].totalInStock = quantityInStock;
		// 				demandMap[inventory.fk_id_inventory].totalDemand += demandQuantity;
		// 				demandMap[inventory.fk_id_inventory].details[workorderID] = demandMapDetail;
		// 				return;
		// 			} 

		// 			const details = {};
		// 			details[workorderID] = demandMapDetail;

		// 			demandMap[inventory.fk_id_inventory] = {
		// 				totalInStock: quantityInStock,
		// 				totalDemand: demandQuantity,
		// 				code: inventory.code,
		// 				name: inventory.name,
		// 				details: details
		// 			}
		// 		});
		// 	});

		// 	Object.keys(demandMap).forEach(function(inventoryID){
		// 		if(demandMap[inventoryID].totalInStock >= demandMap[inventoryID].totalDemand){
		// 			delete demandMap[inventoryID];
		// 			return;
		// 		}

		// 		vm.inventoryInsufficientCount++;
		// 	});

		// 	vm.inventoryInsufficient = demandMap;
		// }

		// function refreshPassedDueTimeWarningMessage(appointments, workorderDetails){
		// 	if(!Array.isArray(appointments) || !workorderDetails){
		// 		return;
		// 	}

		// 	const current = moment();
		// 	const twoHoursAgo = current.hour(current.hour() - 2);

		// 	vm.passedDueTime = {};
		// 	vm.passedDueTimeCount = 0;

		// 	appointments.forEach(function(appointment){
		// 		if(!appointment 
		// 			|| !appointment.extendedProps 
		// 			|| appointment.extendedProps.isCustomAppointment
		// 			|| !isAppointmentExpected(appointment.extendedProps.status)
		// 			|| moment(appointment.start).isAfter(twoHoursAgo)
		// 			|| !workorderDetails[appointment.extendedProps.workOrderID]
		// 			|| !workorderDetails[appointment.extendedProps.workOrderID].workorder
		// 			|| !workorderDetails[appointment.extendedProps.workOrderID].workorder.isQuoted()

		// 			|| !workorderDetails[appointment.extendedProps.workOrderID].workorder.isBooked()
		// 			|| !workorderDetails[appointment.extendedProps.workOrderID].workorder.isOnLot()
		// 			|| !workorderDetails[appointment.extendedProps.workOrderID].workorder.isStarted()
		// 			){
		// 			return;
		// 		}

		// 		if(!vm.passedDueTime[appointment.extendedProps.workOrderID]){
		// 			vm.passedDueTime[appointment.extendedProps.workOrderID] = {
		// 				workorder: workorderDetails[appointment.extendedProps.workOrderID].workorder,
		// 				appointments: []
		// 			}
		// 			vm.passedDueTimeCount++;
		// 		}

		// 		vm.passedDueTime[appointment.extendedProps.workOrderID].appointments.push(appointment);
		// 	});
		// }

		// function refreshCompletedWithOutstandingWarningMessage(appointments, workorderDetails){
		// 	if(!Array.isArray(appointments) || !workorderDetails){
		// 		return;
		// 	}

		// 	vm.completedWithOutstanding = {};
		// 	const appointmentMap = {};
		// 	vm.completedWithOutstandingCount = 0;
	
		// 	appointments.forEach(function(appointment){
		// 		if(!appointment 
		// 			|| !appointment.extendedProps 
		// 			|| appointment.extendedProps.isCustomAppointment
		// 			|| !isAppointmentExpected(appointment.extendedProps.status)){
		// 			return;
		// 		}

		// 		if(!Array.isArray(appointmentMap[appointment.extendedProps.workOrderID])){
		// 			appointmentMap[appointment.extendedProps.workOrderID] = [];
		// 		}

		// 		appointmentMap[appointment.extendedProps.workOrderID].push(appointment);
		// 	});

		// 	Object.keys(workorderDetails).forEach(function(workorderID){
		// 		if(!workorderDetails[workorderID] 
		// 			|| !workorderDetails[workorderID].workorder 
		// 			|| !workorderDetails[workorderID].workorder.isCompleted()
		// 			|| !Array.isArray(appointmentMap[workorderID])
		// 			|| appointmentMap[workorderID].length <= 0){
		// 			return;
		// 		}

		// 		const workOrderSummaryCalculator = new WorkOrderSummaryCalculator();
		// 		workOrderSummaryCalculator.setWorkorder(workorderDetails[workorderID].workorder);
		// 		workOrderSummaryCalculator.setParts(workorderDetails[workorderID].parts);
		// 		workOrderSummaryCalculator.setInventories(workorderDetails[workorderID].inventories);
		// 		workOrderSummaryCalculator.setLabors(workorderDetails[workorderID].labors);
		// 		workOrderSummaryCalculator.setDiscounts(workorderDetails[workorderID].discounts);
		// 		workOrderSummaryCalculator.setPayments(workorderDetails[workorderID].payments);

		// 		if(workOrderSummaryCalculator.getOutstanding() == 0){
		// 			return;
		// 		}

		// 		vm.completedWithOutstanding[workorderID] = {
		// 			workorder: workorderDetails[workorderID].workorder,
		// 			appointments: appointmentMap[workorderID]
		// 		}

		// 		vm.completedWithOutstandingCount++;
		// 	});
		// }

		// function fetchWorkorderDetails(workorderID, vehicleID){
		// 	const queue = {};

		// 	if(workordersDetailsMap[workorderID]){
		// 		if(workordersDetailsMap[workorderID].workorder){
		// 			queue.workorder = $q.resolve(workordersDetailsMap[workorderID].workorder);
		// 		} else {
		// 			queue.workorder = fetchWorkOrder(workorderID, vehicleID);
		// 		}

		// 		if(workordersDetailsMap[workorderID].parts){
		// 			queue.parts = $q.resolve(workordersDetailsMap[workorderID].parts);
		// 		} else {
		// 			queue.parts = fetchWorkOrderParts(workorderID, vehicleID);
		// 		}

		// 		if(workordersDetailsMap[workorderID].inventories){
		// 			queue.inventories = $q.resolve(workordersDetailsMap[workorderID].inventories);
		// 		} else {
		// 			queue.inventories = fetchWorkOrderInventories(workorderID, vehicleID);
		// 		}

		// 		if(workordersDetailsMap[workorderID].labors){
		// 			queue.labors = $q.resolve(workordersDetailsMap[workorderID].labors);
		// 		} else {
		// 			queue.labors = fetchWorkOrderLabors(workorderID, vehicleID);
		// 		}
		// 	} else {
		// 		queue.workorder = fetchWorkOrder(workorderID, vehicleID);
		// 		queue.parts = fetchWorkOrderParts(workorderID, vehicleID);
		// 		queue.inventories = fetchWorkOrderInventories(workorderID, vehicleID);
		// 		queue.labors = fetchWorkOrderLabors(workorderID, vehicleID);
		// 	}

		// 	return $q.all(queue)
		// 		.then(function(result){
		// 			if(!result || !result.workorder){
		// 				return $q.reject("Failed to fetch workorder details: id " + workorderID);
		// 			}

		// 			if(!result.workorder.isCompleted()){
		// 				return $q.resolve(result);
		// 			}

		// 			if(workordersDetailsMap[workorderID]){
		// 				if(workordersDetailsMap[workorderID].discounts){
		// 					result.discounts = $q.resolve(workordersDetailsMap[workorderID].discounts);
		// 				} else {
		// 					result.discounts = fetchWorkOrderDiscounts(workorderID, vehicleID);
		// 				}

		// 				if(workordersDetailsMap[workorderID].payments){
		// 					result.payments = $q.resolve(workordersDetailsMap[workorderID].payments);
		// 				} else {
		// 					result.payments = fetchWorkOrderPayments(workorderID, vehicleID);
		// 				}
		// 			} else {
		// 				result.discounts = fetchWorkOrderDiscounts(workorderID, vehicleID);
		// 				result.payments = fetchWorkOrderPayments(workorderID, vehicleID);
		// 			}

		// 			return $q.all(result);
		// 		})
		// 		.then(function(result){
		// 			workordersDetailsMap[workorderID] = result;
		// 			return $q.resolve(result);
		// 		})
		// }

		// function isAnyInventoryInsufficient(demandMap, workorderInventories){
		// 	if(!demandMap || !Array.isArray(workorderInventories)){
		// 		return;
		// 	}

		// 	return !!workorderInventories.find(function(inventory){
		// 		return !!inventory && !!demandMap[inventory.fk_id_inventory] && demandMap[inventory.fk_id_inventory].totalDemand > demandMap[inventory.fk_id_inventory].totalInStock;
		// 	});
		// }

		// function isAnyPartsNotOrdered(parts){
		// 	if(!Array.isArray(parts)){
		// 		return;
		// 	}

		// 	return !!parts.find(function(part){
		// 		return !!part && !part.is_returned && !part.is_ordered;
		// 	});
		// }

		// function addToDemandMap(demandMap, workorderInventories){
		// 	if(!demandMap || !Array.isArray(workorderInventories)){
		// 		return;
		// 	}

		// 	workorderInventories.forEach(function(inventory){
		// 		if(!inventory){
		// 			return;
		// 		}

		// 		const quantityInStock = GeneralTools.parseNumber(inventory.quantity_in_stock);
		// 		const demandQuantity = GeneralTools.parseNumber(inventory.quantity);

		// 		if(demandMap[inventory.fk_id_inventory]){
		// 			demandMap[inventory.fk_id_inventory].totalInStock = quantityInStock;
		// 			demandMap[inventory.fk_id_inventory].totalDemand += demandQuantity;
		// 			return;
		// 		} 

		// 		demandMap[inventory.fk_id_inventory] = {
		// 			totalInStock: quantityInStock,
		// 			totalDemand: demandQuantity,
		// 			code: inventory.code,
		// 			name: inventory.name
		// 		}
		// 	});

		// 	return demandMap;
		// }

		// function fetchWorkOrderDiscounts(workOrderID, vehicleID){
		// 	const resourcePath = { 
		// 		companyID: companyID,
		// 		vehicleID: vehicleID,
		// 		workorderID: workOrderID
		// 	};

		// 	const request = WorkOrderService.getDiscounts(resourcePath);
		// 	requests.push(request);
			
		// 	return request.$promise;
		// }

		// function fetchWorkOrderPayments(workOrderID, vehicleID){
		// 	const resourcePath = { 
		// 		companyID: companyID,
		// 		vehicleID: vehicleID,
		// 		workorderID: workOrderID
		// 	};

		// 	const request = WorkOrderService.getPayments(resourcePath);
		// 	requests.push(request);
			
		// 	return request.$promise;
		// }

		// function refreshDemandMap(inventories){
		// 	return $q.resolve()
		// }

		// function fetchWorkOrderParts(workOrderID, vehicleID){
		// 	const resourcePath = {
		// 		companyID: companyID,
		// 		vehicleID: vehicleID,
		// 		workorderID: workOrderID
		// 	};

		// 	const request = WorkOrderService.getWorkOrderParts(resourcePath);
		// 	requests.push(request);
			
		// 	return request.$promise;
		// }

		// function fetchWorkOrderInventories(workOrderID, vehicleID){
		// 	const resourcePath = {
		// 		companyID: companyID,
		// 		vehicleID: vehicleID,
		// 		workorderID: workOrderID
		// 	};

		// 	const request = WorkOrderService.getWorkOrderInventories(resourcePath);
		// 	requests.push(request);

		// 	return request.$promise;
		// }

		// function showWarningMessageBox(){
		// 	return !vm.showNewWorkOrderAppointment && (
		// 			vm.passedDueTimeCount > 0 || 
		// 			vm.emptyWorkordersCount > 0 || 
		// 			vm.inventoryInsufficientCount > 0 || 
		// 			vm.completedWithOutstandingCount > 0 || 
		// 			vm.partsNotOrderedCount > 0)
		// }
	}
})();
(function ()
{
	"use strict";

	angular
		.module("app.workOrders")
		.component("workorderWarranty", {
				bindings:{
					warranty: '=',
					onAddClick: '<',
					vehicleInfo: '=',
					coveredMileage: '=',
					expiryDate: '='
				},
				templateUrl: "app/main/workorders/components/workorder-warranty.html",
				controller: componentController,
		  		controllerAs: 'vm'
			});

		function componentController(){
			const vm = this;
			// vm.vehicle = vehicle;
			
			vm.getPartType = getPartType;
			vm.$onInit = initComponent;

			function getPartType(partTypeID) {
				if(!Array.isArray(vm.partTypes)){
					return;
				}

				const matchedItem = vm.partTypes.find(function(item) {
					return !!item && item.id_part_type == partTypeID;
				});

				if(matchedItem){
					return matchedItem.name;
				}
			}

			function initComponent(){
				vm.currentmileage = vm.vehicleInfo.mileage;
				vm.currentdate = moment().format("YYYY-MM-DD")
			}
		}
})();



(function ()
{
	"use strict";

	angular
		.module("app.workOrders")
		.component("workorderWarrantyForm", {
				bindings:{
					vehicle:'<',
					warrantOptions:'<',
					currentWarranty:'=',
					isFormValid: '=',
					removeWorkOrderWarranty:'<'
				},
				templateUrl: "app/main/workorders/components/workorder-warranty-form.html",
				controller: componentController,
		  		controllerAs: 'vm',
		  		require: {
			        form : '^form'
			    }
			});

		function componentController(GeneralTools, MessageService, Warranty, WorkOrderWarranty){
			var vm = this;	

			vm.translateToDollar = GeneralTools.inputTranslators.dollar;
			vm.translateToPhoneNumber = GeneralTools.inputTranslators.phoneNumber;
			vm.translateToFirstCap = GeneralTools.inputTranslators.initCapitalize;
			vm.translateToPostalCode = GeneralTools.inputTranslators.postalCode;
			vm.translateToMonth = GeneralTools.inputTranslators.month;
			vm.translateToSIN = GeneralTools.inputTranslators.SIN;
			vm.translateToVIN = GeneralTools.inputTranslators.VIN;

			vm.$onInit = initComponent;
			vm.$postLink = initOutputCallbacks;
			vm.check = check;

			vm.onRemoveWarrantyclick = onRemoveWarrantyclick;

			vm.pullDataFromWarrantyOption = pullDataFromWarrantyOption

			function initComponent(){
				initAvailableWarranties();
			}

			function onRemoveWarrantyclick(workOrderWarranty){
				if(typeof(vm.removeWorkOrderWarranty) != "function" ){
					return;
				}

				vm.removeWorkOrderWarranty(workOrderWarranty);
			}

			function initOutputCallbacks(){
				vm.isFormValid = isFormValid;
			}

			function isFormValid(){
				if(!vm.currentWarranty){
					return false;
				}

				return vm.currentWarranty.every(function(item){
					return !!item && !!item.duration_month && item.cost != null && item.retail != null && item.name != null;
				});
			};

			function pullDataFromWarrantyOption(warranty, presetwarranty){
				if(presetwarranty == null){
					MessageService.showToast("Warranty data is invalid.");
					return;
				}

				if(warranty == null){
					warranty = new WorkOrderWarranty();
				}

				warranty.pullDataFromWarranty(presetwarranty);
			}

			function initCurrentWarranty(){
				if(!Array.isArray(vm.warrantOptions)){
					return;
				}

				vm.currentWarranty = vm.warrantOptions.find(function(warranty){
					return warranty.getResourceID() == vm.selectedWarrantyId;
				})
			}

			function initAvailableWarranties(){
				if(!Array.isArray(vm.warrantOptions)){
					return;
				}

				var currentDate = new Date();
				var vehicleAge = currentDate.getFullYear() - vm.vehicle.year;

				vm.availableWarranties = vm.warrantOptions.filter(function(warranty){
					return (vm.vehicle.mileage <= warranty.max_mileage 
							&& vm.vehicle.mileage >= warranty.min_mileage 
							&& vehicleAge <= warranty.max_vehicle_year);
				});
			}

			function check(){
				//console.log(vm.currentWarranty);
			}
		}
})();
(function ()
{
	"use strict";

	angular
		.module("app.workOrders")
		.component("workorderStatusBar", {
				bindings:{
					statusOptions: '<',
					onStatusClick: '<',
					workorder: "=",
					isProcessing: "=",
					isDisabled:"="
				},
				templateUrl: "app/main/workorders/components/workorder-status-bar.html",
				controller: componentController,
		  		controllerAs: 'vm'
			});

		function componentController(GeneralTools, LoginService, $q, MessageService, $scope, WorkOrderDiscount){
			const vm = this;

			vm.getBackgroudColor = getBackgroudColor;
			vm.showWorkOrderStatusDropDown = false
			vm.workOrderStatusTempHolder;
			vm.statusOrderList = [1, 5, 6, 7, 3, 4, 2]

			function getBackgroudColor(index){
				if(!Array.isArray(vm.statusOptions) || !vm.workorder){
					return;
				}

				if(Array.isArray(vm.statusOptions) && vm.statusOptions.length > 0){
					vm.statusOptions.sort(function(a, b){
						const indexA = vm.statusOrderList.indexOf(a.id_work_order_status);
						const indexB = vm.statusOrderList.indexOf(b.id_work_order_status);
						return indexA - indexB;
					  });
				}

				var red = 0;
				var green = 0;
				var blue = 0;
				var opt = 1;
				var progress = (index + 1) / vm.statusOptions.length;

				vm.statusOptions.forEach(function(item){
					if(item.id_work_order_status == vm.workorder.fk_id_work_order_status){
						vm.workOrderStatusTempHolder = item
					}
				});
				

				progress = progress > 1 ? 1 : progress;
				if(vm.workorder.isCompleted()){
					green = 255 - 100 * progress;
				}else if(vm.workorder.isQuoted()){
					blue = 255;
					green = 255 - 100 * progress;
				}else if(vm.workorder.isBooked()){
					red = 255;
					green = 165;
					blue = 0;
					opt = 0.3
				}else if(vm.workorder.isOnLot()){
					red = 255;
					green = 165;
					blue = 0;
					opt = 0.5
				}else if(vm.workorder.isStarted()){
					red = 255;
					green = 165;
					blue = 0;
				}
				else {	
					red = 255;
					green = 200 - 100 * progress;
					blue = 100 - 100 * progress;
				}

				return {'background-color': "rgba(" + red + ',' + green + ',' + blue + ',' + opt + ')'};
			}
		}
})();



(function ()
{
	"use strict";

	angular
		.module("app.workOrders")
		.component("workorderRogerDollarRedeemList", {
				bindings:{
					discounts: '=',
					selectedMap: '=',
					workOrderRDRedeemedList: '<',
					customerList: '<'
				},
				templateUrl: "app/main/workorders/components/workorder-roger-dollar-redeem-list.html",
				controller: componentController,
		  		controllerAs: 'vm'
			});

		function componentController(GeneralTools, LoginService, $q, MessageService, $scope, WorkOrderDiscount){
			const vm = this;

			vm.isAllSelected = isAllSelected;
			vm.selectAll = selectAll;
			vm.getRogersDollarRedeemCustomerName = getRogersDollarRedeemCustomerName;
			vm.getRDRedeemItemID = getRDRedeemItemID;

			function isAllSelected(){
				if(!Array.isArray(vm.workOrderRDRedeemedList) || vm.workOrderRDRedeemedList.length <= 0 || !vm.selectedMap){
					return;
				}

				return vm.workOrderRDRedeemedList.every(function(discount){
					var redeemid;
					if(discount.resourceData){
						redeemid = discount.resourceData.id_rd_redeemed;
					}else if(discount.id_rd_redeemed){
						redeemid = discount.id_rd_redeemed
					}
					return !!discount && vm.selectedMap[redeemid]
				});
			}

			function selectAll(){
				if(!Array.isArray(vm.workOrderRDRedeemedList) || !vm.selectedMap){
					return;
				}

				const allSelected = isAllSelected();

				vm.workOrderRDRedeemedList.forEach(function(discount){
					if(!discount){
						return;
					}
					if(discount.resourceData){
						vm.selectedMap[discount.resourceData.id_rd_redeemed] = !allSelected;
					}else if(discount.id_rd_redeemed){
						vm.selectedMap[discount.id_rd_redeemed] = !allSelected;
					}
					
				});
			}

			function getRogersDollarRedeemCustomerName(customerID){
				var customerNmae = "Customer"
				if(customerID && vm.customerList[customerID]){
					if(vm.customerList[customerID].customerInfo && vm.customerList[customerID].customerInfo.first_name && vm.customerList[customerID].customerInfo.last_name){
						customerNmae = vm.customerList[customerID].customerInfo.first_name + " " + vm.customerList[customerID].customerInfo.last_name
					}
				}

				return customerNmae
			}

			function getRDRedeemItemID(discount){
				var Id;
				if(discount && discount.resourceData){
					Id = discount.resourceData.id_rd_redeemed
				}else if(discount && discount.id_rd_redeemed){
					Id = discount.id_rd_redeemed
				}
				return Id
			}
		}
})();



(function ()
{
	"use strict";

	angular
		.module("app.workOrders")
		.component("workorderPresetJobs", {
				bindings:{
					presetJobs: '=',
					partTypes: '<',
					onAddClick: '<'
				},
				templateUrl: "app/main/workorders/components/workorder-preset-jobs.html",
				controller: componentController,
		  		controllerAs: 'vm'
			});

		function componentController(){
			const vm = this;

			vm.getPartType = getPartType;
			vm.check = check;

			function getPartType(partTypeID) {
				if(!Array.isArray(vm.partTypes)){
					return;
				}

				const matchedItem = vm.partTypes.find(function(item) {
					return !!item && item.id_part_type == partTypeID;
				});

				if(matchedItem){
					return matchedItem.name;
				}
			}

			function check() {
				// console.log(vm.partTypes)
				// console.log(vm.presetJobs)
			}
		}
})();



(function ()
{
	"use strict";

	angular
		.module("app.workOrders")
		.component("workorderPaymentList", {
				bindings:{
					paymentMethods: '<',
					payments: '=',	
					onRemovePayment: "=",
					voidCreditCardPayment: "=",
					refundCreditCardPayment: "=",
					isProcessing: "="
				},
				templateUrl: "app/main/workorders/components/workorder-payments-list.html",
				controller: componentController,
		  		controllerAs: 'vm'
			});

		function componentController(GeneralTools, LoginService, $q, MessageService, $scope, WorkOrderPayment, $state){
			const vm = this;

			vm.getPaymentMethod = getPaymentMethod;
			vm.getCustomerPageUrl = getCustomerPageUrl;
			vm.updateWarrantyPaymentStatus = updateWarrantyPaymentStatus
			function getPaymentMethod(paymentMethodID){
				if(!Array.isArray(vm.paymentMethods)){
					return;
				}

				const mathchedMethod = vm.paymentMethods.find(function(paymentMethod){
					if(!paymentMethod){
						return;
					}

					return paymentMethod.id_payment_method == paymentMethodID;
				});

				if(!!mathchedMethod){
					return mathchedMethod.name;
				}
			}

			function getCustomerPageUrl(customerID){
				return $state.href("app.view-customer", {customerID: customerID});
			}

			function updateWarrantyPaymentStatus(payment){
				switch(payment.fk_payment_status){
					case 1:
						payment.fk_payment_status = 2
						payment.paymentStatus = "SUBMITTED"
					break;
					case 2:
						payment.fk_payment_status = 3
						payment.paymentStatus = "RECEIVED"
					break;
					case 3:
						payment.fk_payment_status = 1
						payment.paymentStatus = "PENDING"
					break;
				}

			}
		}
})();



(function () {
	"use strict";

	angular
		.module("app.workOrders")
		.component("workorderPaymentCreater", {
			bindings: {
				customers: "<",
				paymentMethods: '<',
				onAddPayment: '<',
				cleanInputs: '=',
				isProcessing: '=',
				paymentStatusList: '<',
				workOrder: "="
			},
			templateUrl: "app/main/workorders/components/workorder-payment-creater.html",
			controller: componentController,
			controllerAs: 'vm'
		});

	function componentController(LoginService, $scope, GeneralTools, WorkOrderPayment, DialogService, MessageService, WorkOrderService, WorkOrderDataSharingService, $q, WorkOrderConstants, $stateParams, CustomersService, ProgressService) {
		const vm = this;
		const userInfo = LoginService.getUserInfo();
		const companyID = LoginService.getCompanyID();
		vm.$postLink = initOutputCallbacks;

		vm.translateToDollar = GeneralTools.inputTranslators.dollar;
		vm.add = add;


		vm.showAddPaymentMethodBoolean = false;
		vm.creditCardExpiryDate = null;
		vm.card_number = null;
		vm.card_firstname = null;
		vm.card_lastname = null;
		vm.card_address = null;
		vm.card_city = null;
		vm.card_province = null;
		vm.card_postcode = null;
		vm.copyboolean = true;
		vm.customerCreditCards = []
		vm.creditCardSelected = {
			customerProfileID: null,
			paymentProfileID: null
		};
		vm.isDeletingCreditCard = false;


		$scope.$watch("vm.customers", function () {
			vm.customersIndex = 0;
		})

		$scope.$watch("vm.customersIndex", function () {
			$scope.$emit(
				vm.onCustomerChange());
		})

		function add() {
			if (typeof (vm.onAddPayment) != "function") {
				return;
			}


			if ((vm.workOrder.fk_id_work_order_status == 3 || vm.workOrder.fk_id_work_order_status == 4)) {

				const payment = new WorkOrderPayment();

				if (Array.isArray(vm.customers)) {
					payment.setCustomer(vm.customers[vm.customersIndex]);
				}

				payment.setReceivedBy(userInfo);
				payment.fk_id_payment_method = vm.paymentMethodID;
				payment.fk_payment_status = vm.paymentstatus
				payment.amount = vm.amount;
				payment.invoice_number = vm.workOrder.invoice_number
				payment.description = 'Vehicle work order payment (invoice: ' + vm.workOrder.invoice_number + ')'
				if(payment.fk_id_payment_method == 11){
					payment.customerProfileID = vm.creditCardSelected.customerProfileID !== undefined ||  vm.creditCardSelected.customerProfileID !== null ? vm.creditCardSelected.customerProfileID : null;
					payment.paymentProfileID = vm.creditCardSelected.paymentProfileID !== undefined || vm.creditCardSelected.paymentProfileID !== null ? vm.creditCardSelected.paymentProfileID : null;
				}
				vm.onAddPayment(payment);

			} else {
				var dialogOptions = {};

				dialogOptions.titleString = "Work order status is not completed";
				dialogOptions.contentString = "Would you like to set work order status to completed in addition to payment ?";

				var confirmOption = {};
				confirmOption.optionName = "YES";
				confirmOption.onClick = function () {
					var promise = $q.resolve();

					promise.then(function () {
						setWorkorderStatus(4);
						return updateWorkOrder(GeneralTools.updateResourceRequestBodyGenerator(vm.workOrder, WorkOrderDataSharingService.getWorkOrder()));
					})
						.then(function () {
							MessageService.showToast("Success.");
						})
						.catch(function (error) {
							if (error) {
								MessageService.showToast(error);
							}
						})
						.finally(function () {

							const payment = new WorkOrderPayment();

							if (Array.isArray(vm.customers)) {
								payment.setCustomer(vm.customers[vm.customersIndex]);
							}

							payment.setReceivedBy(userInfo);
							payment.fk_id_payment_method = vm.paymentMethodID;
							payment.fk_payment_status = vm.paymentstatus
							payment.amount = vm.amount;
							payment.invoice_number = vm.workOrder.invoice_number
							payment.description = 'Vehicle work order payment (invoice: ' + vm.workOrder.invoice_number + ')'
							if(payment.fk_id_payment_method == 11){
								payment.customerProfileID = vm.creditCardSelected.customerProfileID !== undefined ||  vm.creditCardSelected.customerProfileID !== null ? vm.creditCardSelected.customerProfileID : null;
								payment.paymentProfileID = vm.creditCardSelected.paymentProfileID !== undefined || vm.creditCardSelected.paymentProfileID !== null ? vm.creditCardSelected.paymentProfileID : null;
							}
							vm.onAddPayment(payment);

							DialogService.close();

						});
				}

				var cancelOption = {};

				cancelOption.optionName = "NO";
				cancelOption.onClick = function () {
					const payment = new WorkOrderPayment();

					if (Array.isArray(vm.customers)) {
						payment.setCustomer(vm.customers[vm.customersIndex]);
					}

					payment.setReceivedBy(userInfo);
					payment.fk_id_payment_method = vm.paymentMethodID;
					payment.fk_payment_status = vm.paymentstatus
					payment.amount = vm.amount;
					payment.invoice_number = vm.workOrder.invoice_number
					payment.description = 'Vehicle work order payment (invoice: ' + vm.workOrder.invoice_number + ')'
					if(payment.fk_id_payment_method == 11){
						payment.customerProfileID = vm.creditCardSelected.customerProfileID !== undefined ||  vm.creditCardSelected.customerProfileID !== null ? vm.creditCardSelected.customerProfileID : null;
						payment.paymentProfileID = vm.creditCardSelected.paymentProfileID !== undefined || vm.creditCardSelected.paymentProfileID !== null ? vm.creditCardSelected.paymentProfileID : null;
					}
					vm.onAddPayment(payment);

					DialogService.close();
					DialogService.close();
				}

				dialogOptions.options = [confirmOption, cancelOption];

				DialogService.showOptionsDialog(dialogOptions);


			}



		}

		function initOutputCallbacks() {
			vm.cleanInputs = cleanInputs;

		}

		function cleanInputs() {
			vm.paymentMethodID = null;
			vm.amount = null;
		}

		function setWorkorderStatus(statusID) {
			if (!vm.workOrder) {
				return;
			}

			if (statusID == WorkOrderConstants.statusIDs.completed && !vm.workOrder.completed_date) {
				vm.workOrder.setCompletedDateTime(moment().utc());
			}

			if (statusID == WorkOrderConstants.statusIDs.quoted && !vm.workOrder.quote_date) {
				vm.workOrder.setQuoteDate(moment().utc());
			}

			vm.workOrder.fk_id_work_order_status = statusID;
		}

		function updateWorkOrder(requestBody) {
			const resourcePath = {
				companyID: companyID,
				vehicleID: $stateParams.vehicleID,
				workorderID: $stateParams.workOrderID
			}

			return WorkOrderService.updateWorkOrder(resourcePath, requestBody)
				.then(function () {
					WorkOrderDataSharingService.setWorkOrder(vm.workOrder);
					return $q.resolve();
				});
		}

		vm.showAddPaymentMethod = function showAddPaymentMethod(){
			vm.showAddPaymentMethodBoolean = !vm.showAddPaymentMethodBoolean 
		}

		vm.onCreditCardNumberChange = function(card_number){
			if(card_number && card_number.length !== 16){
				$scope.workordercustomerCreditCardForm.cardNumber.$setValidity('valid', false);
			}else{
				$scope.workordercustomerCreditCardForm.cardNumber.$setValidity('valid', true);
			}

		}

		vm.oncreditCardExpiryDateChange = function(creditCardExpiryDate){
			if(creditCardExpiryDate){
				var parts = creditCardExpiryDate.split('/');
				var month = parseInt(parts[0], 10);
				var year = parseInt(parts[1], 10);
			
				var currentDate = new Date();
				var currentYear = currentDate.getFullYear() % 100;
				var currentMonth = currentDate.getMonth() + 1; 
			
				if (year > currentYear || (year === currentYear && month >= currentMonth)) {
					$scope.workordercustomerCreditCardForm.creditCardExpiryDate.$setValidity('valid', true);
				} else {
					$scope.workordercustomerCreditCardForm.creditCardExpiryDate.$setValidity('valid', false);
				}
			}

		}

		vm.addSlash = function(event) {
			var value = event.target.value;
			if (value.length === 2 && event.charCode >= 48 && event.charCode <= 57) {
				event.target.value = value + '/';
			}
		};

		vm.pullinfoFromCustomer = function(){
			vm.customer = vm.customers[vm.customersIndex]
			if(vm.customer && vm.customer.first_name){
				vm.card_firstname = vm.customer.first_name;
			}
			
			if(vm.customer && vm.customer.last_name){
				vm.card_lastname = vm.customer.last_name;
			}

			if(vm.customer && vm.customer.address_street_number && vm.customer.address_street){
				vm.card_address = vm.customer.address_street_number + ' ' + vm.customer.address_street; 
			}

			if(vm.customer && vm.customer.address_city){
				vm.card_city = vm.customer.address_city;
			}
			
			if(vm.customer && vm.customer.address_province){
				vm.card_province = vm.customer.address_province;
			}

			if(vm.customer && vm.customer.address_postal_code){
				vm.card_postcode = vm.customer.address_postal_code;
			}

			vm.copyboolean = !vm.copyboolean
		}

		vm.clearCustomerInfo = function(){
			vm.card_firstname = null;
			vm.card_lastname = null;
			vm.card_address = null;
			vm.card_city = null;
			vm.card_province = null;
			vm.card_postcode = null;
			vm.copyboolean = !vm.copyboolean
		}

		vm.onCustomerChange = function(){
			if(vm.customers && vm.customers.length >0 && vm.customers[vm.customersIndex] && vm.customers[vm.customersIndex].id_customer){
				var resourcePath = {}; 
				resourcePath.companyID = LoginService.getCompanyID();
				resourcePath.customerID = vm.customers[vm.customersIndex].id_customer
				CustomersService.getCreditCards(resourcePath)
				.then(function(result){
					vm.customerCreditCards = result
				})
			}
		}

		vm.addCreditCard = function(){
			if(vm.creditCardExpiryDate == null || vm.card_number == null || vm.card_firstname == null || vm.card_lastname == null
			|| !vm.customers || vm.customers.length == 0 || !vm.customers[vm.customersIndex] || !vm.customers[vm.customersIndex].id_customer){
				return;
			}

			var requestBody = {
				creditCardExpiryDate : vm.creditCardExpiryDate,
				card_number : vm.card_number,
				card_firstname : vm.card_firstname,
				card_lastname : vm.card_lastname,
				card_address : vm.card_address,
				card_city : vm.card_city,
				card_province : vm.card_province,
				card_postcode : vm.card_postcode
			}
			var resourcePath = {}; 
			resourcePath.companyID = LoginService.getCompanyID();
			resourcePath.customerID = vm.customers[vm.customersIndex].id_customer

			ProgressService.setMode("indeterminate");
			ProgressService.isVisble(true);

			vm.isDeletingCreditCard = true;

			CustomersService.SaveClientPaymentProfile(requestBody, resourcePath)
					.then(function(creditCardListResponse){
						vm.customerCreditCards = creditCardListResponse
						MessageService.showToast("Success!");
					})
					.catch(MessageService.showToast)
					.finally(function(){
						ProgressService.isVisble(false);
						vm.isDeletingCreditCard = false;
					});
		}


	}
})();



(function ()
{
	"use strict";

	angular
		.module("app.workOrders")
		.component("workorderPackageList", {
				bindings:{
					soldDate:'<',
					presetPackages: '<',
					packageItemsMap:'<',
					salePackages:'<',
					saleInfo: '<',
					onPresetPackageSelect: '<',
					onPurchasePackageRemove: '<',
					jobList:'<'
				},
				templateUrl: "app/main/workorders/components/workorder-package-list.html",
				controller: componentController,
		  		controllerAs: 'vm'
			});

		function componentController(GeneralTools, MessageService, $scope, $q){
			var vm = this;

			vm.showSalePackageItems = {};
			vm.selectedMap = {};
			vm.packageItemMaxDisplay = 2;
			vm.packageMap = {};
			vm.togglePackage = togglePackage;
			vm.showItems = {};



			$scope.$watch("vm.presetPackages", updatePackageMap, true);
			$scope.$watch("vm.salePackages", updatePackageMap, true);
			$scope.$watch("vm.packageItemsMap", updatePackageMap, true);

			function updatePackageMap(){
				if(!Array.isArray(vm.salePackages) || !Array.isArray(vm.presetPackages) || !vm.packageItemsMap){
					return;
				}

			const packageList = [];
			const purchasedPackageMap = {};

				vm.salePackages.forEach(function(salePackage){
					var purchasedPackage = {};	


					purchasedPackage.name = salePackage.name;
					purchasedPackage.price = salePackage.price;
					purchasedPackage.expired = !salePackage.isAvailable();
					purchasedPackage.isPurchased = true;

					purchasedPackage.date = "Exp:" + salePackage.expiry_date;
					purchasedPackage.salePackage = salePackage;

					const salePackageItems = vm.packageItemsMap[salePackage.id_sale_package];

					if(Array.isArray(salePackageItems)){
						const quantityMap = {};
						salePackageItems.forEach(function(item){
							quantityMap[item.fk_id_preset_package_item] = item.quantity;
						});
						purchasedPackage.quantityMap = quantityMap;
					}

					purchasedPackageMap[salePackage.fk_id_preset_package] = purchasedPackage;
				});

				vm.presetPackages.forEach(function(presetPackage){
					var purchasedPackage = purchasedPackageMap[presetPackage.id_preset_package];

					if(purchasedPackage){
						purchasedPackage.presetPackage = presetPackage;
						if(vm.saleInfo.mileage && presetPackage.valid_mileage != 0 && presetPackage.valid_mileage){
							purchasedPackage.valid_mileage =  "Cover mileage under:" +  (vm.saleInfo.mileage + presetPackage.valid_mileage);
						}else{
							purchasedPackage.valid_mileage =  "No mileage limit on cover";
						}
						
						purchasedPackage.items = presetPackage.items.map(function(presetItem){
							if(purchasedPackage.quantityMap){
								const currentQuantity = purchasedPackage.quantityMap[presetItem.id_preset_package_item];
								return presetItem.name + '(' + currentQuantity + '/' + presetItem.quantity + ')';
							}		
						});

						packageList.push(purchasedPackage);
						return;
					}

					
					if(vm.soldDate){
						const soldDateMoment = moment(vm.soldDate);
						if(soldDateMoment.isValid() && moment(presetPackage.active_expiry_date).isBefore(soldDateMoment)){
							return;
						}
					}
					
					packageList.push({
						name: presetPackage.name,
						isPurchased: false,
						expired: !presetPackage.isActive(),
						price: presetPackage.price,
						valid_mileage: presetPackage.valid_mileage,
						date: GeneralTools.getValidTimeString(presetPackage.valid_time),
						presetPackage: presetPackage,
						items: presetPackage.items.map(function(item){
							return item.name + ' * ' + item.quantity;
						})
					});
				});

				vm.packageList = packageList;
			}

			function togglePackage(_package){
				if(_package.isDisabled){
					return;
				}

				var promise = $q.resolve();

				if(_package.isPurchased){
					if(typeof(vm.onPurchasePackageRemove) == "function"){
						promise = vm.onPurchasePackageRemove(_package.salePackage, _package.presetPackage);
					}
				} else if(typeof(vm.onPresetPackageSelect) == "function"){
					if(_package.presetPackage.valid_mileage && _package.presetPackage.valid_mileage != 0){
						_package.presetPackage.expiry_mileage = _package.presetPackage.valid_mileage + vm.saleInfo.mileage;
					}else{
						_package.presetPackage.expiry_mileage = null;
					}
					promise = vm.onPresetPackageSelect(_package.presetPackage);
				}

				if(promise && promise.constructor.name == "Promise"){
					_package.isDisabled = true;
					promise.finally(function(){
						_package.isDisabled = false;
					})
				}

			}
		}
})();
(function ()
{
	"use strict";

	angular
		.module("app.workOrders")
		.component("workorderMechanicSection", {
				bindings:{
					disableAdding: '=',
					disableDeleting: '=',
					mechanics: '=',
					onAddMechanic: "<",
					onRemoveMechanic: '<',
					isProcessing:'='
				},
				templateUrl: "app/main/workorders/components/workorder-mechanic-section.html",
				controller: componentController,
		  		controllerAs: 'vm'
			});

		function componentController($q, LoginService, $state, GeneralTools, MessageService, UserService, WorkOrderMechanic){
			const vm = this;
			const companyID = LoginService.getCompanyID();
			const mechanicRoles = ["mechanic", "mechanic_apprentice"];

			vm.queryMechanic = queryMechanic;

			vm.addMechanic = addMechanic;

			function addMechanic(){
				if(typeof(vm.onAddMechanic) != "function" || !vm.selectedMechanic){
					return;
				}

				const workOrderMechanic = new WorkOrderMechanic();

				workOrderMechanic.setUser(vm.selectedMechanic);
				workOrderMechanic.setPrimary(vm.isPrimary);

				vm.onAddMechanic(workOrderMechanic);
				vm.searchText = null;
			}

			function queryMechanic(searchText){
				return UserService.getUsers({companyID: companyID}, searchText)
					.then(function(users){
						return $q.resolve(filterMechanic(users));
					});
			}

			function filterMechanic(users){
				var mechanics = [];

				if(!Array.isArray(users)){
					return mechanics;
				}

				users.forEach(function(user){
					if(checkMechanicRole(user.roles)){
						mechanics.push(user)
					}
				})

				return mechanics;
			}

			function checkMechanicRole(userRole){
				var isMechanic = false;

				if(!Array.isArray(userRole)){
					return isMechanic;
				}

				userRole.forEach(function(role){
					if(mechanicRoles.indexOf(role) != -1){
						isMechanic = true;
					}
				});

				return isMechanic;
			}
		}
})();
(function ()
{
	"use strict";

	angular
		.module("app.workOrders")
		.component("workorderJobType", {
				bindings:{
					jobtypeList: '<',
					partTypes: '<',
					onAddClick: '<',
					getRecentJobInfo: '<'
				},
				templateUrl: "app/main/workorders/components/workorder-job-type.html",
				controller: componentController,
		  		controllerAs: 'vm'
			});

		function componentController(LoginService, WorkOrderDataSharingService){
			const vm = this;
			const companyID = LoginService.getCompanyID();
			const userID = LoginService.getUserID();
			vm.getPartType = getPartType;
			initJobTypes();
			vm.check = check


			function getPartType(partTypeID) {
				if(!Array.isArray(vm.partTypes)){
					return;
				}

				const matchedItem = vm.partTypes.find(function(item) {
					return !!item && item.id_part_type == partTypeID;
				});

				if(matchedItem){
					return matchedItem.name;
				}
			}

			function initJobTypes(){
				const JobType = WorkOrderDataSharingService.getJobTypeList();
				if(!Array.isArray(JobType)){
					return;
				}
	
				vm.JobTypeList = [];
	
				JobType.forEach(function(Job){
					

					Job.job_part.forEach(function(part){
						part = initSelectedandShow(part)
					})

					Job.job_labour.forEach(function(labour){
						labour = initSelectedandShow(labour)
					})

					Job.job_miscfee.forEach(function(miscfee){
						miscfee = initSelectedandShow(miscfee)
					})

					vm.JobTypeList.push({
						JobType: Job,
						showDetail:false
					});
					
				});
			}

			function initSelectedandShow(item){
				if(item.fk_id_parttype|| item.fk_id_miscfeestype || item.fk_id_labourtype){
					item.isSelected = true;
				}
				return item
			}

			function check(item){
				vm.getRecentJobInfo(item)
			}

		}
})();



(function ()
{
	"use strict";

	angular
		.module("app.workOrders")
		.component("workorderInfoForm", {
				bindings:{
					disabledInputs:'=',
					workOrder: '=',
					isFormValid: '=',
					isProcessingData: "=",
					refreshDates: "=",
					workOrderPriorities:'<',
					customerList: '<',
					workOrderRdGeneratedList: '<',
				},
				templateUrl: "app/main/workorders/components/workorder-info-form.html",
				controller: componentController,
		  		controllerAs: 'vm'
			});

		function componentController(GeneralTools, LoginService, $q, MessageService, $scope, WorkOrderConstants){
			const vm = this;
			const companyID = LoginService.getCompanyID();

			var exsitingJobID;

			vm.translateToNumber = GeneralTools.inputTranslators.decimal;
			vm.timePickerFormat = "LT";
			vm.displayedPercentage = 0;

			vm.numberInputOption = {
				decimalFractionSize:0,
				canBeNegative:false
			};

			vm.$onInit = initComponent;
			vm.$postLink = initOutPutCallbacks;

			vm.setQuoteDate = setQuoteDate;
			/*vm.setStartDate = setStartDate;
			vm.setStartTime = setStartTime;*/
			vm.setCompleteDate = setCompleteDate;
			vm.setCompleteTime = setCompleteTime;

			vm.dateValidation = [
				{
					name:"dateValidation",
					validateFn:function(modelValue, viewValue){
						const startDate = vm.workOrder.getStartDateTimeMomentObj();
						const completeDate = vm.workOrder.getCompletedDateTimeMomentObj();

						if(!startDate || !completeDate){
							return true;
						}

						return startDate.isBefore(completeDate);
					}
				}
			];

			function initComponent(){
				refreshDates()
			}

			function refreshDates(){
				vm.quoteDatePickerValue = vm.workOrder.getQuoteDateMomentObj();
				vm.displayedPercentage = ($scope.vm.workOrder.rogerdollar_generate_precentage * 100);
				/*const startDateMomentObj = vm.workOrder.getStartDateTimeMomentObj();
				if(startDateMomentObj){
					vm.startDatePickerValue = startDateMomentObj;
					vm.startTimePickerValue = angular.copy(startDateMomentObj);
				}*/

				const completedDateMomentObj = vm.workOrder.getCompletedDateTimeMomentObj();
				vm.completeDatePickerValue = completedDateMomentObj;
				vm.completeTimePickerValue = angular.copy(completedDateMomentObj);
			}

/*			function setStartDate (datePickerValue){			
				if(!datePickerValue){
					vm.workOrder.start_date = null;
					return;
				}

				vm.workOrder.setStartDateTime(moment(datePickerValue).utc());

				if(!vm.startTimePickerValue){
					vm.startTimePickerValue = vm.workOrder.getStartDateTimeMomentObj();
				}
			}

			function setStartTime (timePickerValue){				
				if(!timePickerValue){
					return;
				}

				vm.workOrder.setStartDateTime(copyTimeToMoment(castTimePickerValueToMoment(timePickerValue), vm.workOrder.getStartDateTimeMomentObj()).utc());
				
				if(!vm.startDatePickerValue){
					vm.startDatePickerValue = vm.workOrder.getStartDateTimeMomentObj();
				}
			}*/

			function setCompleteDate (datePickerValue){
				if(!datePickerValue){
					vm.workOrder.setCompletedDateTime(null);
					vm.completeTimePickerValue = null;
					return;
				}

				vm.workOrder.setCompletedDateTime(moment(datePickerValue).utc());

				if(!vm.completeTimePickerValue){
					vm.completeTimePickerValue = vm.workOrder.getCompletedDateTimeMomentObj();
				}		
			}

			function setCompleteTime (timePickerValue){
				if(!timePickerValue){

					if(vm.completeDatePickerValue){
						const defaultMoment = moment();
						defaultMoment.hour(0);
						defaultMoment.minute(0);
						defaultMoment.second(0);

						vm.workOrder.setCompletedDateTime(copyTimeToMoment(defaultMoment, vm.workOrder.getCompletedDateTimeMomentObj()).utc());
						vm.completeTimePickerValue = vm.workOrder.getCompletedDateTimeMomentObj();
					}

					return;
				}

				vm.workOrder.setCompletedDateTime(copyTimeToMoment(castTimePickerValueToMoment(timePickerValue), vm.workOrder.getCompletedDateTimeMomentObj()).utc());

				if(!vm.completeDatePickerValue){
					vm.completeDatePickerValue = vm.workOrder.getCompletedDateTimeMomentObj();
				}
			}

			function castTimePickerValueToMoment(timePickerValue){
				switch (timePickerValue.constructor.name){
					case "M":
						return timePickerValue;
					case "Moment":
						return timePickerValue;
					case "String":
						return moment(timePickerValue, vm.timePickerFormat);
				}
			}

			function copyTimeToMoment(source, target){
				if(!source){
					return target;
				}
				
				if(!target){
					return source;
				}

				target.hour(source.hour());
				target.minute(source.minute());
				target.second(source.second());

				return target;
			}

			function setQuoteDate(){
				if(vm.workOrder && vm.quoteDatePickerValue){
					vm.workOrder.setQuoteDate(moment(vm.quoteDatePickerValue));
				} else {
					vm.workOrder.setQuoteDate(null);
				}
			}

			function initOutPutCallbacks(){
				vm.isFormValid = isFormValid;
				vm.refreshDates = refreshDates;
			}

			function isFormValid(){
				$scope.workOrderInfoForm.$submitted = true;
				return $scope.workOrderInfoForm.$valid;
			};

			vm.check = check;
			function check(){
				console.log(vm.workOrder)
			}

			vm.updateModelValue = function() {
				vm.displayedPercentage = vm.displayedPercentage.replace(/[^0-9.]/g, '');
				if(parseFloat(vm.displayedPercentage) / 100 >= 1){
					vm.displayedPercentage = '100'
				}
				if(parseFloat(vm.displayedPercentage) / 100 <= 0){
					vm.displayedPercentage = '0'
				}
				if(!vm.displayedPercentage){
					vm.workOrder.rogerdollar_generate_precentage = 0;
				}else{
					vm.workOrder.rogerdollar_generate_precentage = parseFloat(vm.displayedPercentage) / 100;
				}
			};


		}
})();
(function ()
{
	"use strict";

	angular
		.module("app.workOrders")
		.component("workorderDiscountList", {
				bindings:{
					discounts: '=',
					selectedMap: '=',
				},
				templateUrl: "app/main/workorders/components/workorder-discounts-list.html",
				controller: componentController,
		  		controllerAs: 'vm'
			});

		function componentController(GeneralTools, LoginService, $q, MessageService, $scope, WorkOrderDiscount){
			const vm = this;

			vm.isAllSelected = isAllSelected;
			vm.selectAll = selectAll;

			function isAllSelected(){
				if(!Array.isArray(vm.discounts) || vm.discounts.length <= 0 || !vm.selectedMap){
					return;
				}

				return vm.discounts.every(function(discount){
					return !!discount && vm.selectedMap[discount.id_work_order_discount];
				});
			}

			function selectAll(){
				if(!Array.isArray(vm.discounts) || !vm.selectedMap){
					return;
				}

				const allSelected = isAllSelected();

				vm.discounts.forEach(function(discount){
					if(!discount){
						return;
					}

					vm.selectedMap[discount.id_work_order_discount] = !allSelected;
				});
			}
		}
})();



(function ()
{
	"use strict";

	angular
		.module("app.workOrders")
		.component("workorderCustomerPortalAppointmentList", {
				bindings:{
					disableEditing:'<',
					onStatusChanged: '<',
					appointmentStatus: '<',
					appointments: '=',
					selectedMap: '='
				},
				templateUrl: "app/main/workorders/components/workorder-customer-portal-appointment-list.html",
				controller: componentController,
		  		controllerAs: 'vm'
			});

		function componentController($state, WorkOrderConstants){
			const vm = this;

			vm.dateFormat = WorkOrderConstants.scheduleDateFormat;
			vm.getScheduleUrl = getScheduleUrl;
			vm.isAllSelected = isAllSelected;
			vm.selectAll = selectAll;

			function isAllSelected(){
				if(!Array.isArray(vm.appointments) || vm.appointments.length <= 0 || !vm.selectedMap){
					return;
				}

				return vm.appointments.every(function(appointment){
					return !!appointment && vm.selectedMap[appointment.id_work_order_appointment];
				});
			}

			function selectAll(){
				if(!Array.isArray(vm.appointments) || !vm.selectedMap){
					return;
				}

				const allSelected = isAllSelected();

				vm.appointments.forEach(function(appointment){
					if(!appointment){
						return;
					}

					vm.selectedMap[appointment.id_work_order_appointment] = !allSelected;
				});
			}

			function getScheduleUrl(appointment){
				if(!appointment){
					return;
				}		
				return $state.href("app.workorder-schedule", {goToDate:appointment.start})
			}


		}
})();



(function ()
{
	"use strict";

	angular
		.module("app.workOrders")
		.component("workorderCouponList", {
				bindings:{
					discounts: '=',
					selectedMap: '=',
				},
				templateUrl: "app/main/workorders/components/workorder-coupons-list.html",
				controller: componentController,
		  		controllerAs: 'vm'
			});

		function componentController(GeneralTools, LoginService, $q, MessageService, $scope, WorkOrderDiscount){
			const vm = this;

			vm.isAllSelected = isAllSelected;
			vm.selectAll = selectAll;

			function isAllSelected(){
				if(!Array.isArray(vm.discounts) || vm.discounts.length <= 0 || !vm.selectedMap){
					return;
				}

				return vm.discounts.every(function(discount){
					return !!discount && vm.selectedMap[discount.id_work_order_discount];
				});
			}

			function selectAll(){
				if(!Array.isArray(vm.discounts) || !vm.selectedMap){
					return;
				}

				const allSelected = isAllSelected();

				vm.discounts.forEach(function(discount){
					if(!discount){
						return;
					}

					vm.selectedMap[discount.id_work_order_discount] = !allSelected;
				});
			}
		}
})();



(function ()
{
	"use strict";

	angular
		.module("app.workOrders")
		.component("workorderCompletedWarranty", {
				bindings:{
					warranty: '=',
					onAddClick: '<',
					vehicleInfo: '=',
					coveredMileage: '=',
					expiryDate: '='
				},
				templateUrl: "app/main/workorders/components/workorder-completed-warranty.html",
				controller: componentController,
		  		controllerAs: 'vm'
			});

		function componentController(){
			const vm = this;
			// vm.vehicle = vehicle;
			
			vm.getPartType = getPartType;
			vm.$onInit = initComponent;
			vm.getCoveredMile = getCoveredMile;
			vm.getExpiryDate = getExpiryDate;
			function getPartType(partTypeID) {
				if(!Array.isArray(vm.partTypes)){
					return;
				}

				const matchedItem = vm.partTypes.find(function(item) {
					return !!item && item.id_part_type == partTypeID;
				});

				if(matchedItem){
					return matchedItem.name;
				}
			}

			function initComponent(){
				vm.currentmileage = vm.vehicleInfo.mileage;
				vm.currentdate = moment().format("YYYY-MM-DD")
			}

			function getCoveredMile(duration_mileage, mileage){
				if(duration_mileage){
					return mileage + duration_mileage
				}else{
					return mileage
				}
			}

			function getExpiryDate(duration_month){
				if(typeof(duration_month) == "number"){
					const month =  moment().month();
					return moment().month(month + duration_month).format("YYYY-MM-DD");
				}
			}
		}
})();



(function ()
{
	"use strict";

	angular
		.module("app.workOrders")
		.component("workorderAppointmentList", {
				bindings:{
					disableEditing:'<',
					onStatusChanged: '<',
					appointmentStatus: '<',
					appointments: '=',
					selectedMap: '='
				},
				templateUrl: "app/main/workorders/components/workorder-appointment-list.html",
				controller: componentController,
		  		controllerAs: 'vm'
			});

		function componentController($state, WorkOrderConstants){
			const vm = this;

			vm.dateFormat = WorkOrderConstants.scheduleDateFormat;
			vm.getScheduleUrl = getScheduleUrl;
			vm.isAllSelected = isAllSelected;
			vm.selectAll = selectAll;

			function isAllSelected(){
				if(!Array.isArray(vm.appointments) || vm.appointments.length <= 0 || !vm.selectedMap){
					return;
				}

				return vm.appointments.every(function(appointment){
					return !!appointment && vm.selectedMap[appointment.id_work_order_appointment];
				});
			}

			function selectAll(){
				if(!Array.isArray(vm.appointments) || !vm.selectedMap){
					return;
				}

				const allSelected = isAllSelected();

				vm.appointments.forEach(function(appointment){
					if(!appointment){
						return;
					}

					vm.selectedMap[appointment.id_work_order_appointment] = !allSelected;
				});
			}

			function getScheduleUrl(appointment){
				if(!appointment){
					return;
				}		
				return $state.href("app.workorder-schedule", {goToDate:appointment.start})
			}


		}
})();



(function ()
{
	"use strict";

	angular
		.module("app.workOrders")
		.component("returnInvoiceSection", {
				bindings:{
					disableSupplier: '<',
					supplierId: '<',
					suppliers: '=',
					onSelectInvoice: '<',
					onCreateInvoice: '<'
				},
				templateUrl: "app/main/workorders/components/return-invoice-section.html",
				controller: componentController,
		  		controllerAs: 'vm'
			});

		function componentController(ReturnInvoice, $q, LoginService, $state, GeneralTools, MessageService, ReturnInvoiceService, ReturnInvoiceConstants, ToolsConstants){
			const vm = this;	
			const companyID = LoginService.getCompanyID();

			vm.queryInvoice = queryInvoice;
			vm.getInvoiceSupplier = getInvoiceSupplier;
			vm.getInvoiceLink = getInvoiceLink;

			vm.selectInvoice = selectInvoice;
			vm.createInvoice = createInvoice;

			function createInvoice(){
				if(typeof(vm.onCreateInvoice) != "function"){
					return;
				}

				const invoice = new ReturnInvoice();

				invoice.fk_id_supplier = vm.supplierId;
				invoice.invoice_number = vm.invoiceNumber;

				const promise = vm.onCreateInvoice(invoice);

				if(!promise || promise.constructor.name != "Promise"){
					return;
				}

				vm.isCreating = true;

				promise
					.then(queryInvoice)
					.catch(MessageService.showToast)
					.finally(function(){
						vm.isCreating = false;
					});
			}

			function cleanAll(){
				console.log("cleanAll")
			}

			function selectInvoice(invoice){
				if(typeof(vm.onSelectInvoice) != "function"){
					return;
				}

				const promise = vm.onSelectInvoice(invoice);

				if(!promise || promise.constructor.name != "Promise"){
					return;
				}

				vm.isProcessing = true;

				promise
					.catch(MessageService.showToast)
					.finally(function(){
						vm.isProcessing = false;
					})
			}

			function getInvoiceLink(invoiceID){
				if(!!invoiceID){
					return $state.href("app.edit-return-invoice", {returnInvoiceID: invoiceID});
				}	
			}

			function getInvoiceSupplier(supplierId){
				var supplier;

				if(Array.isArray(vm.suppliers) && !!supplierId){
					supplier = vm.suppliers.find(function(supplier){
						return !!supplier && supplier.id_supplier == supplierId;
					})
				}

				if(!!supplier){
					return supplier.name;
				}
			}

			function queryInvoice(searchText){
				if(!vm.invoiceNumber){
					return;
				}

				const resourcePath = {
					companyID: companyID
				}

				var filterString = '';

				if(vm.supplierId){
					filterString = GeneralTools.equalFilterBuilder(ReturnInvoiceConstants.keyNames.supplier, vm.supplierId)
				}

				const invoiceFilter = GeneralTools.containFilterBuilder(ReturnInvoiceConstants.keyNames.invoiceNumber, vm.invoiceNumber);
				filterString = GeneralTools.stringConnector(filterString, invoiceFilter, ToolsConstants.apiFilters.andConnector);

				ReturnInvoiceService.getReturnInvoices(resourcePath, {filters: filterString})
					.then(function(result) {
						if(!result || !Array.isArray(result.data)){
							defer.reject("Invoice data invaild.");
							return;
						}

						vm.matchedInvoices = result.data;
					})
					.catch(MessageService.showToast);
			}

		}
})();
(function ()
{
	"use strict";

	angular
		.module("app.workOrders")
		.component("redeemItemList", {
				bindings:{
					packageDatas: '<',
					disableRedeem: '<',
					onRedeemClick: '<',
					saleInfo: '<'
				},
				templateUrl: "app/main/workorders/components/redeem-item-list.html",
				controller: componentController,
		  		controllerAs: 'vm'
			});

		function componentController($scope, $q, LoginService, $state, GeneralTools, MessageService, CustomersService){
			const vm = this;	
			const companyID = LoginService.getCompanyID();
			vm.disableRedeem = false;

			vm.anyItemAvailable = anyItemAvailable;
			
			function anyItemAvailable(){
				return vm.packageDatas && Object.keys(vm.packageDatas).length > 0;
			}
		}
})();
(function ()
{
	"use strict";

	angular
		.module("app.workOrders")
		.component("purchaseInvoiceSection", {
				bindings:{
					suppliers: "=",
					onSelectInvoice: "<",
					onCreateInvoice: '<'
				},
				templateUrl: "app/main/workorders/components/purchase-invoice-section.html",
				controller: componentController,
		  		controllerAs: 'vm'
			});

		function componentController(PurchaseInvoice, $q, LoginService, $state, GeneralTools, MessageService, PurchaseInvoiceService, PurchaseInvoiceConstants, ToolsConstants){
			const vm = this;	
			const companyID = LoginService.getCompanyID();

			vm.queryInvoice = queryInvoice;
			vm.getInvoiceSupplier = getInvoiceSupplier;
			vm.getInvoiceLink = getInvoiceLink;

			vm.selectInvoice = selectInvoice;
			vm.createInvoice = createInvoice;

			function createInvoice(){
				if(typeof(vm.onCreateInvoice) != "function"){
					return;
				}

				const invoice = new PurchaseInvoice();

				invoice.fk_id_supplier = vm.supplierID;
				invoice.invoice_number = vm.invoiceNumber;

				const promise = vm.onCreateInvoice(invoice);

				if(!promise || promise.constructor.name != "Promise"){
					return;
				}

				vm.isCreating = true;

				promise
					.then(queryInvoice)
					.catch(MessageService.showToast)
					.finally(function(){
						vm.isCreating = false;
					});
			}

			function selectInvoice(invoice){
				if(typeof(vm.onSelectInvoice) != "function"){
					return;
				}

				const promise = vm.onSelectInvoice(invoice);

				if(!promise || promise.constructor.name != "Promise"){
					return;
				}

				vm.isProcessing = true;

				promise
					.catch(MessageService.showToast)
					.finally(function(){
						vm.isProcessing = false;
					})
			}

			function getInvoiceLink(invoiceID){
				if(!!invoiceID){
					return $state.href("app.edit-purchase-invoice", {purchaseInvoiceID: invoiceID});
				}	
			}

			function getInvoiceSupplier(supplierID){
				var supplier;

				if(Array.isArray(vm.suppliers) && !!supplierID){
					supplier = vm.suppliers.find(function(supplier){
						return !!supplier && supplier.id_supplier == supplierID;
					})
				}

				if(!!supplier){
					return supplier.name;
				}
			}

			function queryInvoice(){
				if(!vm.invoiceNumber){
					return;
				}

				const resourcePath = {
					companyID: companyID
				}

				var filterString = '';

				if(vm.supplierID){
					filterString = GeneralTools.equalFilterBuilder(PurchaseInvoiceConstants.keyNames.supplier, vm.supplierID)
				}

				const invoiceFilter = GeneralTools.containFilterBuilder(PurchaseInvoiceConstants.keyNames.invoiceNumber, vm.invoiceNumber);
				filterString = GeneralTools.stringConnector(filterString, invoiceFilter, ToolsConstants.apiFilters.andConnector);

				PurchaseInvoiceService.getPurchaseInvoices(resourcePath, {filters: filterString})
					.then(function(result) {
						if(!result || !Array.isArray(result.data)){
							defer.reject("Invoice data invaild.");
							return;
						}

						vm.matchedInvoices = result.data;
					})
					.catch(MessageService.showToast);
			}

		}
})();
(function ()
{
	"use strict";

	angular
		.module("app.workOrders")
		.component("miscfeeTable", {
				bindings:{
					hideAdding:'=',
					disableAdding:'=',
					disableEditing:'=',
					miscfeestypeslist:'<',
					onAddMiscfees: '<',
					onRemoveMiscfees: '<',
					selectable: "<",
					suggestedPrice: '<',
					isFormValid: '=',
					workOrderJobList:'=',
					colorCache: '='
				},
				templateUrl: "app/main/workorders/components/miscfee-table.html",
				controller: componentController,
		  		controllerAs: 'vm'
			});

		function componentController(GeneralTools, $scope, LoginService, $q, MessageService, miscfeestypes, $timeout, miscfeestypesService){
			const vm = this;

			const companyID = LoginService.getCompanyID();
			const userID = LoginService.getUserID();


			vm.allmiscfeestypeslist = [];
			miscfeestypesService.getMiscFeesTypes({
							companyID: companyID,
							userID: userID,
							vehicleID: 0, 
							workorderID: 0
				}).then(function(result) {
					for(var i = 0; i < result.length; i++){
						vm.allmiscfeestypeslist.push(result[i])
					}
			});



			var countries = ["Afghanistan","Albania","Algeria","Andorra","Angola","Anguilla","Antigua &amp; Barbuda","Argentina","Armenia","Aruba","Australia","Austria","Azerbaijan","Bahamas","Bahrain","Bangladesh","Barbados","Belarus","Belgium","Belize","Benin","Bermuda","Bhutan","Bolivia","Bosnia &amp; Herzegovina","Botswana","Brazil","British Virgin Islands","Brunei","Bulgaria","Burkina Faso","Burundi","Cambodia","Cameroon","Canada","Cape Verde","Cayman Islands","Central Arfrican Republic","Chad","Chile","China","Colombia","Congo","Cook Islands","Costa Rica","Cote D Ivoire","Croatia","Cuba","Curacao","Cyprus","Czech Republic","Denmark","Djibouti","Dominica","Dominican Republic","Ecuador","Egypt","El Salvador","Equatorial Guinea","Eritrea","Estonia","Ethiopia","Falkland Islands","Faroe Islands","Fiji","Finland","France","French Polynesia","French West Indies","Gabon","Gambia","Georgia","Germany","Ghana","Gibraltar","Greece","Greenland","Grenada","Guam","Guatemala","Guernsey","Guinea","Guinea Bissau","Guyana","Haiti","Honduras","Hong Kong","Hungary","Iceland","India","Indonesia","Iran","Iraq","Ireland","Isle of Man","Israel","Italy","Jamaica","Japan","Jersey","Jordan","Kazakhstan","Kenya","Kiribati","Kosovo","Kuwait","Kyrgyzstan","Laos","Latvia","Lebanon","Lesotho","Liberia","Libya","Liechtenstein","Lithuania","Luxembourg","Macau","Macedonia","Madagascar","Malawi","Malaysia","Maldives","Mali","Malta","Marshall Islands","Mauritania","Mauritius","Mexico","Micronesia","Moldova","Monaco","Mongolia","Montenegro","Montserrat","Morocco","Mozambique","Myanmar","Namibia","Nauro","Nepal","Netherlands","Netherlands Antilles","New Caledonia","New Zealand","Nicaragua","Niger","Nigeria","North Korea","Norway","Oman","Pakistan","Palau","Palestine","Panama","Papua New Guinea","Paraguay","Peru","Philippines","Poland","Portugal","Puerto Rico","Qatar","Reunion","Romania","Russia","Rwanda","Saint Pierre &amp; Miquelon","Samoa","San Marino","Sao Tome and Principe","Saudi Arabia","Senegal","Serbia","Seychelles","Sierra Leone","Singapore","Slovakia","Slovenia","Solomon Islands","Somalia","South Africa","South Korea","South Sudan","Spain","Sri Lanka","St Kitts &amp; Nevis","St Lucia","St Vincent","Sudan","Suriname","Swaziland","Sweden","Switzerland","Syria","Taiwan","Tajikistan","Tanzania","Thailand","Timor L'Este","Togo","Tonga","Trinidad &amp; Tobago","Tunisia","Turkey","Turkmenistan","Turks &amp; Caicos","Tuvalu","Uganda","Ukraine","United Arab Emirates","United Kingdom","United States of America","Uruguay","Uzbekistan","Vanuatu","Vatican City","Venezuela","Vietnam","Virgin Islands (US)","Yemen","Zambia","Zimbabwe"];

			var isloading = false

			var init = true
			
			vm.translateToDollar = GeneralTools.inputTranslators.dollar;
			vm.decimalTranslator = GeneralTools.inputTranslators.decimal;
			vm.allInitCapitalizeTranslator = GeneralTools.inputTranslators.allInitCapitalize;
			vm.addLabor
			vm.onmiscfeestypechange = onmiscfeestypechange;
			vm.hourInputOption = {
				decimalFractionSize:2,
				canBeNegative: false
			};

			vm.$onInit = initComponent;
			vm.$postLink = initOutPutCallbacks;

			vm.isAllSelected = isAllSelected;
			vm.selectAll = selectAll;

			vm.onRowFocus = onRowFocus;
			vm.onRowBlur = onRowBlur;
			vm.onInputFocus = onInputFocus;
			vm.onTypeInputFocus = onTypeInputFocus;
			vm.onInputBlur = onInputBlur;
			vm.addNewRow = addNewRow;
			vm.getMiscFeesTypeNameById = getMiscFeesTypeNameById;
			vm.check = check
			vm.typeselected;
			vm.getWorkOrderJobIdFromItemId = getWorkOrderJobIdFromItemId


			function initComponent(){
				$scope.$watch("vm.focusIndex", function(newValue, oldValue){
					if(vm.editingIndex != oldValue){
						removeEmptyRow(oldValue)
					}
				});
			}

			function getMiscFeesTypeNameById(id){
				for(var x = 0; x < vm.allmiscfeestypeslist.length; x++){
					if(id == vm.allmiscfeestypeslist[x].id_miscfee){
						return vm.allmiscfeestypeslist[x].name
					}
				}
		}

			

			function selectAll(){
				if(!Array.isArray(vm.miscfeestypeslist)){
					return;
				}

				var allSelected = isAllSelected();

				vm.miscfeestypeslist.forEach(function(item, index){
					item.isSelected = !allSelected;
				});
			}

			function isAllSelected(){
				if(!Array.isArray(vm.miscfeestypeslist)){
					return;
				}

				return vm.miscfeestypeslist.every(function(item, index){
					return item.isSelected;
				})
			}

			function onRowFocus(index, isReturned){
				vm.focusIndex = index
				vm.isFocusOnRow = true;		
				vm.editingIndex = null;

				$timeout(function(){
					const nameInput = angular.element(document.querySelector('#miscfeesRowTypes' + index));
					if(nameInput){
						nameInput.focus();
					}			
				});
			}

			function onRowBlur() {
				vm.isFocusOnRow = false;	
				waitAndCheckIsEditing();			
			}

			function onInputFocus(index) {
				vm.isFocusOnRow = false;
				vm.editingIndex = index;
			}

			function onTypeInputFocus(index){
				vm.isFocusOnRow = false;
				vm.typeselected = vm.allmiscfeestypeslist[index].MiscFees
				
				vm.editingIndex = index;
			}

			function onInputBlur(){
				vm.editingIndex = null;
				waitAndCheckIsEditing();			
			}

			function waitAndCheckIsEditing() {
				$timeout(function() {
					if((!vm.isFocusOnRow && vm.editingIndex == null)){
						vm.focusIndex = null
					}

				}, 100);
			}

			function addNewRow(){
				if(vm.disableAdding){
					return;
				}

				vm.focusIndex = null;
				addNewMiscfees();

				if(!Array.isArray(vm.miscfeestypeslist)){
					return;
				}

				$timeout(function(){
					const lastRow = angular.element(document.querySelector('#miscfeesRow' + (vm.miscfeestypeslist.length - 1)));
					if(lastRow){
						lastRow.focus();
					}
				});
			}

			function addNewMiscfees(){
				if(!Array.isArray(vm.miscfeestypeslist)){
					return;
				}

				const miscfee = new miscfeestypes();
				

				vm.miscfeestypeslist.push({
					MiscFees: miscfee
				});
				vm.typeselected = miscfee
				if(typeof(vm.onAddMiscfees) == "function"){
					vm.onAddMiscfees(MiscFees);
				}
			}

			function removeEmptyRow(index){
				isloading = false
				if(!Array.isArray(vm.miscfeestypeslist) || !vm.miscfeestypeslist[index]){
					return
				}

				const miscfee = vm.miscfeestypeslist[index].MiscFees;

				if(!miscfee){
					return;
				}		

				if(!!miscfee.id_misc_fees){
					return;
				}	

				if(!!miscfee.name){
					return;
				}

				if(miscfee.price != null && labor.price != vm.suggestedPrice){
					return;
				}

				vm.miscfeestypeslist.splice(index, 1);

				if(typeof(vm.onRemoveMiscfees) == "function"){
					vm.onRemoveMiscfees(index);
				}
			}

			function initOutPutCallbacks(){
				vm.isFormValid = isFormValid;
			}

			function check(){
				var e = document.getElementById( "miscfeesRowTypes" + id);
				 (e)
			}

			function isFormValid(){
				if(!Array.isArray(vm.miscfeestypeslist)){
					return false;
				}

				return vm.miscfeestypeslist.every(function(item){
					return !!item && !!item.MiscFees && !!item.MiscFees.name && item.MiscFees.price != null && item.MiscFees.quantity != null && item.MiscFees.fk_misc_fees_type != null;
				});
			};

			function refreshlabourtypeoptions(select, selectedindex){
				removeAll(select)
				var result = vm.allmiscfeestypeslist
				for(var i = 0; i < result.length; i++){
					var opt = document.createElement('option');
					opt.value =parseInt(result[i].id_miscfee);;
					opt.innerHTML = result[i].name;
					if(parseInt(selectedindex) != null && i == parseInt(selectedindex) ){
						opt.selected = "selected"
						opt.value =parseInt(result[i].id_miscfee);;
						opt.innerHTML = result[i].name;
					}
					select.appendChild(opt);
					}
					return   
			}

			
			function initlabourtypeoptionfiled(select, selectedindex, id){
				var labour = [];
				var result = vm.allmiscfeestypeslist

					for(var i = 0; i < result.length; i++){
					var opt = document.createElement('option');
					opt.value =parseInt(result[i].id_miscfee);
					opt.innerHTML = result[i].name;
					if(parseInt(selectedindex) != null && i == parseInt(selectedindex) ){
						opt.selected = "selected"
						vm.miscfeestypeslist[id].MiscFees.fk_misc_fees_type = parseInt(result[i].id_miscfee);
					}
					select.appendChild(opt);
					labour.push(result[i])
					}
					return labour
			}

			$scope.onlaborrowclick = function(i) {

				if(!isloading){
					isloading = true
					var title = document.getElementById('miscfeesRowTypes'+i);
					var value = title.value.match(/\d/g);
					 (title)
					if(value != null){
						value = value.join("");
					}
					initlabourtypeoptionfiled(title,value, i)
					return
				}else{
					return
				}
			};

			function onmiscfeestypechange(id){
				var e = document.getElementById( "miscfeesRowTypes" + id);
				const value = e.value;
				for(var i = 0; i<vm.allmiscfeestypeslist.length;i++){
					if(parseInt(value) == vm.allmiscfeestypeslist[i].id_miscfee){

						vm.miscfeestypeslist[id].MiscFees.name = vm.allmiscfeestypeslist[i].name

						if(vm.miscfeestypeslist[id].MiscFees.price == undefined){
							vm.miscfeestypeslist[id].MiscFees.price = vm.allmiscfeestypeslist[i].default_retail_price
						}

						if(vm.miscfeestypeslist[id].MiscFees.quantity == undefined){
							vm.miscfeestypeslist[id].MiscFees.quantity = vm.allmiscfeestypeslist[i].default_quantity
						}
						vm.miscfeestypeslist[id].MiscFees.fk_misc_fees_type = vm.allmiscfeestypeslist[i].id_miscfee


					}
				}
				refreshlabourtypeoptions(e, e.selectedIndex)
			}

			function removeAll(selectBox) {
				var i, L = selectBox.options.length - 1;
				for(i = L; i >= 0; i--) {
					selectBox.remove(i);
				}
			}



			function getGivenItemIdAssociatedWorkOrderJobID(workOrderJob, Id, itemTypeId){
				if(workOrderJob.length <= 0){
					return undefined
				}
				var workOrderId = undefined;
				workOrderJob.forEach(function(workOrderJobItem){
					if(workOrderJobItem.work_order_job_json.length > 0){
						workOrderJobItem.work_order_job_json.forEach(function(work_order_job_json_item){
							if(parseInt(work_order_job_json_item.fk_id_item) == parseInt(Id) && parseInt(work_order_job_json_item.fk_id_work_order_job_item_type) == parseInt(itemTypeId)){
								workOrderId = workOrderJobItem.id_work_order_job
							}
						})
					}
				})
	
				return workOrderId
			};
	
			function getRGBAStyle(number, index, colorCache) {
				if (colorCache[number]) {
				  setTableRowBackgroundColor(colorCache[number], index);
				  return;
				}
				return;
			  }
	
			function getWorkOrderJobIdFromItemId(item, workOrderJobList, index, colorCache){
				if(!workOrderJobList || workOrderJobList.length <= 0){
					return 
				}
				var id = undefined;
				var colorString = ""
				var workOrderJobId
				if(item && item.MiscFees){
					id = item.MiscFees.id_misc_fees
					if(workOrderJobList && workOrderJobList.length > 0){
						workOrderJobId = getGivenItemIdAssociatedWorkOrderJobID(workOrderJobList, id, 3)
						colorString = getRGBAStyle(workOrderJobId, index, colorCache)
					}
	
				}

				return colorString
			}
	
			function setTableRowBackgroundColor(colorString, index) {
				var trElement = document.querySelector('tr[name="miscfeesTableRow' + index + '"]');
				if (trElement) {
				  trElement.style.backgroundColor = colorString;
				}else{
					return undefined
				}
			}
			 
		}
})();
(function ()
{
	"use strict";

	angular
		.module("app.workOrders")
		.component("laborTable", {
				bindings:{
					hideAdding:'=',
					disableAdding:'=',
					disableEditing:'=',
					laborList:'=',
					labourList: "=",
					onAddLabor: '<',
					onRemoveLabor: '<',
					selectable: "<",
					suggestedPrice: '<',
					isFormValid: '=',
					fk_id_labour_type: '=',
					workOrderJobList:'=',
					colorCache: '='
				},
				templateUrl: "app/main/workorders/components/labor-table.html",
				controller: componentController,
		  		controllerAs: 'vm'
			});

		function componentController(GeneralTools, $scope, LoginService, $q, MessageService, Labor, $timeout, LabourService){
			const vm = this;
			const companyID = LoginService.getCompanyID();
			const userID = LoginService.getUserID();

			vm.labourlist = [];
			LabourService.getLabour({
							companyID: companyID,
							userID: userID
				}).then(function(result) {
					for(var i = 0; i < result.length; i++){

					vm.labourlist.push(result[i])
					}
			});


			var countries = ["Afghanistan","Albania","Algeria","Andorra","Angola","Anguilla","Antigua &amp; Barbuda","Argentina","Armenia","Aruba","Australia","Austria","Azerbaijan","Bahamas","Bahrain","Bangladesh","Barbados","Belarus","Belgium","Belize","Benin","Bermuda","Bhutan","Bolivia","Bosnia &amp; Herzegovina","Botswana","Brazil","British Virgin Islands","Brunei","Bulgaria","Burkina Faso","Burundi","Cambodia","Cameroon","Canada","Cape Verde","Cayman Islands","Central Arfrican Republic","Chad","Chile","China","Colombia","Congo","Cook Islands","Costa Rica","Cote D Ivoire","Croatia","Cuba","Curacao","Cyprus","Czech Republic","Denmark","Djibouti","Dominica","Dominican Republic","Ecuador","Egypt","El Salvador","Equatorial Guinea","Eritrea","Estonia","Ethiopia","Falkland Islands","Faroe Islands","Fiji","Finland","France","French Polynesia","French West Indies","Gabon","Gambia","Georgia","Germany","Ghana","Gibraltar","Greece","Greenland","Grenada","Guam","Guatemala","Guernsey","Guinea","Guinea Bissau","Guyana","Haiti","Honduras","Hong Kong","Hungary","Iceland","India","Indonesia","Iran","Iraq","Ireland","Isle of Man","Israel","Italy","Jamaica","Japan","Jersey","Jordan","Kazakhstan","Kenya","Kiribati","Kosovo","Kuwait","Kyrgyzstan","Laos","Latvia","Lebanon","Lesotho","Liberia","Libya","Liechtenstein","Lithuania","Luxembourg","Macau","Macedonia","Madagascar","Malawi","Malaysia","Maldives","Mali","Malta","Marshall Islands","Mauritania","Mauritius","Mexico","Micronesia","Moldova","Monaco","Mongolia","Montenegro","Montserrat","Morocco","Mozambique","Myanmar","Namibia","Nauro","Nepal","Netherlands","Netherlands Antilles","New Caledonia","New Zealand","Nicaragua","Niger","Nigeria","North Korea","Norway","Oman","Pakistan","Palau","Palestine","Panama","Papua New Guinea","Paraguay","Peru","Philippines","Poland","Portugal","Puerto Rico","Qatar","Reunion","Romania","Russia","Rwanda","Saint Pierre &amp; Miquelon","Samoa","San Marino","Sao Tome and Principe","Saudi Arabia","Senegal","Serbia","Seychelles","Sierra Leone","Singapore","Slovakia","Slovenia","Solomon Islands","Somalia","South Africa","South Korea","South Sudan","Spain","Sri Lanka","St Kitts &amp; Nevis","St Lucia","St Vincent","Sudan","Suriname","Swaziland","Sweden","Switzerland","Syria","Taiwan","Tajikistan","Tanzania","Thailand","Timor L'Este","Togo","Tonga","Trinidad &amp; Tobago","Tunisia","Turkey","Turkmenistan","Turks &amp; Caicos","Tuvalu","Uganda","Ukraine","United Arab Emirates","United Kingdom","United States of America","Uruguay","Uzbekistan","Vanuatu","Vatican City","Venezuela","Vietnam","Virgin Islands (US)","Yemen","Zambia","Zimbabwe"];

			var isloading = false

			var init = true
			
			vm.translateToDollar = GeneralTools.inputTranslators.dollar;
			vm.decimalTranslator = GeneralTools.inputTranslators.decimal;
			vm.allInitCapitalizeTranslator = GeneralTools.inputTranslators.allInitCapitalize;
			vm.addLabor
			vm.onlabourtypechange = onlabourtypechange;
			vm.onlabourtextchange = onlabourtextchange;
			vm.hourInputOption = {
				decimalFractionSize:2,
				canBeNegative: false
			};

			vm.$onInit = initComponent;
			vm.$postLink = initOutPutCallbacks;

			vm.isAllSelected = isAllSelected;
			vm.selectAll = selectAll;

			vm.onRowFocus = onRowFocus;
			vm.onRowBlur = onRowBlur;
			vm.onInputFocus = onInputFocus;
			vm.onInputBlur = onInputBlur;
			vm.addNewRow = addNewRow;
			vm.getLabourTypeNameById = getLabourTypeNameById;
			vm.getWorkOrderJobIdFromItemId = getWorkOrderJobIdFromItemId;

			function initComponent(){
				$scope.$watch("vm.focusIndex", function(newValue, oldValue){
					if(vm.editingIndex != oldValue){
						removeEmptyRow(oldValue)
					}
				});
			}

			function selectAll(){
				if(!Array.isArray(vm.laborList)){
					return;
				}

				var allSelected = isAllSelected();

				vm.laborList.forEach(function(item, index){
					item.isSelected = !allSelected;
				});
			}

			function isAllSelected(){
				if(!Array.isArray(vm.laborList)){
					return;
				}

				return vm.laborList.every(function(item, index){
					return item.isSelected;
				})
			}

			function onRowFocus(index, isReturned) {
				vm.focusIndex = index;
				vm.isFocusOnRow = true;
				vm.editingIndex = null;
			  
				$timeout(function() {
				  var selectElement = angular.element('#labourRowTypes' + index);
				  if (selectElement) {
					selectElement.focus();
				  }
				});
			  }
			  

			function getLabourTypeNameById(id){
					for(var x = 0; x < vm.labourlist.length; x++){
						if(id == vm.labourlist[x].id_labour_type){
							return vm.labourlist[x].labour_name
						}
					}
			}
			
			function onRowBlur() {
				vm.isFocusOnRow = false;	
				waitAndCheckIsEditing();			
			}

			function onInputFocus(index) {
				vm.isFocusOnRow = false;
				vm.editingIndex = index;
			}

			function onInputBlur(){
				vm.editingIndex = null;
				waitAndCheckIsEditing();			
			}

			function waitAndCheckIsEditing() {
				$timeout(function() {
					if((!vm.isFocusOnRow && vm.editingIndex == null)){
						vm.focusIndex = null
					}

				}, 100);
			}

			function addNewRow(){
				if(vm.disableAdding){
					return;
				}

				vm.focusIndex = null;
				addNewLabor();

				if(!Array.isArray(vm.laborList)){
					return;
				}

				$timeout(function(){
					const lastRow = angular.element(document.querySelector('#laborRow' + (vm.laborList.length - 1)));
					if(lastRow){
						lastRow.focus();
					}
				});
			}

			function addNewLabor(){
				if(!Array.isArray(vm.laborList)){
					return;
				}

				const labor = new Labor();
				//labor.price = vm.suggestedPrice;
				//labor.fk_id_labour_type = 1;
				

				vm.laborList.push({
					laborData: labor
				});

				if(typeof(vm.onAddLabor) == "function"){
					vm.onAddLabor(labor);
				}
			}

			function removeEmptyRow(index){
				isloading = false
				if(!Array.isArray(vm.laborList) || !vm.laborList[index]){
					return
				}

				const labor = vm.laborList[index].laborData;

				if(!labor){
					return;
				}		

				if(!!labor.getResourceId()){
					return;
				}	

				if(!!labor.name){
					return;
				}

				if(labor.price != null && labor.price != vm.suggestedPrice){
					return;
				}

				if(labor.hour != null){
					return;
				}

				vm.laborList.splice(index, 1);

				if(typeof(vm.onRemoveLabor) == "function"){
					vm.onRemoveLabor(index);
				}
			}

			function initOutPutCallbacks(){
				vm.isFormValid = isFormValid;
			}

			function isFormValid(){
				if(!Array.isArray(vm.laborList)){
					return false;
				}
				return vm.laborList.every(function(item){

					return !!item && !!item.laborData && !!item.laborData.name && item.laborData.price != null && item.laborData.hour != null && item.laborData.fk_id_labour_type != null;
				});
			};

			function refreshlabourtypeoptions(select, selectedindex){
				var labour = [];
				var counter = true
				removeAll(select)
				LabourService.getLabour({
							companyID: companyID,
							userID: userID
				}).then(function(result) {
					for(var i = 0; i < result.length; i++){
					var opt = document.createElement('option');
					opt.value = result[i].id_labour_type;
					opt.innerHTML = result[i].labour_name;
					if(parseInt(selectedindex) != null && i == parseInt(selectedindex) ){
						opt.selected = "selected"
					}
					select.appendChild(opt);
					labour.push(result[i])
					}
					return 
				})	  
			}


			function initlabourtypeoptionfiled(select, selectedindex, id) {
				var labour = [];
				var result = vm.labourlist

				for (var i = 0; i < result.length; i++) {
					var opt = document.createElement('option');
					opt.value = parseInt(result[i].id_labour_type);
					opt.innerHTML = result[i].labour_name;
					if (parseInt(selectedindex) != null && parseInt(result[i].id_labour_type) == parseInt(selectedindex)) {
						opt.selected = "selected"
						vm.laborList[id].laborData.fk_id_labour_type = parseInt(result[i].id_labour_type);
					}
					select.appendChild(opt);
					labour.push(result[i])
				}
				return labour

			}

			$scope.onlaborrowclick = function(i) {
				if(!isloading){
					isloading = true
					var title = document.getElementById('labourRowTypes'+i);
					var value = title.value.match(/\d+/);
					if(value != null){
						value = value.join("");
					}
					return initlabourtypeoptionfiled(title,value, i)
				}else{
					return
				}
			};

			function onlabourtypechange(id){
				var e = document.getElementById( "labourRowTypes" + id);
				const value = e.value;

				for(var i = 0; i<vm.labourlist.length;i++){
					if(parseInt(value) == vm.labourlist[i].id_labour_type){
						if(!vm.laborList[id].laborData.edited || vm.laborList[id].laborData.edited == undefined || vm.laborList[id].laborData.name == undefined || vm.laborList[id].laborData.name == null || vm.laborList[id].laborData.name.length == 0){
							vm.laborList[id].laborData.name = vm.labourlist[i].labour_name
						}

						if(vm.laborList[id].laborData.hour == undefined){
							vm.laborList[id].laborData.hour = vm.labourlist[i].default_time
						}

						if(vm.laborList[id].laborData.price == undefined){
							vm.laborList[id].laborData.price = vm.labourlist[i].default_rate
						}
						vm.laborList[id].laborData.fk_id_labour_type = parseInt(value);

						vm.laborList[id].laborData.edited = false
					}
				}
				refreshlabourtypeoptions(e, e.selectedIndex)
			}

			function removeAll(selectBox) {
				while (selectBox.options.length > 0) {
					selectBox.remove(0);
				}
			}

			function getRGBAStyle(number, index, colorCache) {
				if (colorCache[number]) {
				  setTableRowBackgroundColor(colorCache[number], index);
				  return;
				}
			  }
	
			function getWorkOrderJobIdFromItemId(item, workOrderJobList, index, colorCache){
				if(!workOrderJobList || workOrderJobList.length <= 0){
					return 
				}
				var id = undefined;
				var colorString = ""
				var workOrderJobId

				if(item && item.laborData){
					id = item.laborData.id_labor
					if(workOrderJobList && workOrderJobList.length > 0){
						workOrderJobId = getGivenItemIdAssociatedWorkOrderJobID(workOrderJobList, id, 4)
						colorString = getRGBAStyle(workOrderJobId, index, colorCache)
					}
	
				}

				return colorString
			}
	
			function setTableRowBackgroundColor(colorString, index) {
				var trElement = document.querySelector('tr[name="labourTableRow' + index + '"]');
				if (trElement) {
				  trElement.style.backgroundColor = colorString;
				}
			}

			function getGivenItemIdAssociatedWorkOrderJobID(workOrderJob, Id, itemTypeId){
				if(workOrderJob.length <= 0){
					return undefined
				}
				var workOrderId = undefined;
				workOrderJob.forEach(function(workOrderJobItem){
					if(workOrderJobItem.work_order_job_json.length > 0){
						workOrderJobItem.work_order_job_json.forEach(function(work_order_job_json_item){
							if(parseInt(work_order_job_json_item.fk_id_item) == parseInt(Id) && parseInt(work_order_job_json_item.fk_id_work_order_job_item_type) == parseInt(itemTypeId)){
								workOrderId = workOrderJobItem.id_work_order_job
							}
						})
					}
				})
	
				return workOrderId
			};

			function onlabourtextchange(id){
				var e = document.getElementById( "labourRowTypes" + id);
				const value = e.value;

				for(var i = 0; i<vm.labourlist.length;i++){
					if(parseInt(value) == vm.labourlist[i].id_labour_type){
						if(vm.laborList[id].laborData.name != vm.labourlist[i].labour_name){
							vm.laborList[id].laborData.edited = true
						}else{
							vm.laborList[id].laborData.edited = false
						}
					}
				}
			}

		}
})();
(function ()
{
	"use strict";

	angular
		.module("app.workOrders")
		.component("customerContactCardList", {
				bindings:{
					customers: '=',
					phoneCategories: '<'
				},
				templateUrl: "app/main/workorders/components/customer-contact-card-list.html",
				controller: componentController,
		  		controllerAs: 'vm'
			});

		function componentController($scope, $q, LoginService, $state, GeneralTools, MessageService, CustomersService){
			const vm = this;	
			const companyID = LoginService.getCompanyID();

			vm.translateToPhoneString = translateToPhoneString;
			vm.currentIndex = 0;
			vm.customerMap = {};
			vm.prev = prev;
			vm.next = next;
			vm.isFirst = isFirst;
			vm.isLast = isLast;
			vm.getCustomerUrl = getCustomerUrl;
			vm.getPhoneCategory = getPhoneCategory;

			$scope.$watch("vm.customers", fetchCustomerDetail, true);

			function translateToPhoneString(numString){
				return GeneralTools.stringToPhoneNumberString(numString);
			}

			function prev(){
				if(isFirst()){
					return;
				}				

				vm.currentIndex -= 1;
				fetchCustomerDetail();
			}

			function next(){
				if(isLast()){
					return;
				}				

				vm.currentIndex += 1;
				fetchCustomerDetail();
			}

			function isFirst(){
				return vm.currentIndex <= 0;
			}

			function isLast(){
				if(!Array.isArray(vm.customers)){
					return;
				}

				return vm.currentIndex >= vm.customers.length -1;
			}

			function fetchCustomerDetail(){
				if(!Array.isArray(vm.customers)){
					return;
				}

				const customerBasicInfo = vm.customers[vm.currentIndex];

				if(!customerBasicInfo){
					return;
				}

				if(!vm.customerMap[customerBasicInfo.id_customer]){
					vm.customerMap[customerBasicInfo.id_customer] = {};
				}

				if(vm.customerMap[customerBasicInfo.id_customer].customerDetail){
					return;
				}
				
				vm.customerMap[customerBasicInfo.id_customer].isLoading = true;

				const resourcePath = {
					companyID: companyID,
					customerID: customerBasicInfo.id_customer
				}

				CustomersService.getCustomers(resourcePath)
					.then(function(result){
						if(!result || !Array.isArray(result.data) || result.data.length != 1 || !result.data[0]){
							return $q.reject("Customer data invalid, customer id: " + customerBasicInfo.id_customer);
						}

						vm.customerMap[customerBasicInfo.id_customer].customerDetail = result.data[0];
					})
					.catch(MessageService.showToast)
					.finally(function(){
						vm.customerMap[customerBasicInfo.id_customer].isLoading = false;
					});
			}

			function getCustomerUrl(customerID){
				return $state.href("app.view-customer", {customerID: customerID});
			}

			function getPhoneCategory(categoryID){
				if(!Array.isArray(vm.phoneCategories)){
					return;
				}

				const matchedItem = vm.phoneCategories.find(function(item){
					return !!item && item.id_phone_category == categoryID;
				});

				if(matchedItem){
					return matchedItem.category;
				}

				return "Other"
			}
		}
})();
(function ()
{
	"use strict";

	angular
		.module("app.workOrders")
		.component("workOrderInfoCustomerForm", {
				bindings:{
					onCustomerChange:'<'
				},
				templateUrl: "app/main/workorders/browse-workorders/work-order-info-customer-form.html",
				controller: componentController,
		  		controllerAs: 'vm'
			});

		function componentController(CustomersService, LoginService, $state){
			var vm = this;	
			var filterObj = {};
			var companyID = LoginService.getCompanyID();
			var customerFilterObj = {};
			vm.customerList = []
			
			var minSearchTextLength = 2;

			vm.$onInit = initComponent;
			vm.onSearchTextChange = onSearchTextChange;
			vm.selectCusomter = selectCusomter;
			vm.goToCustomerPage = goToCustomerPage;
			vm.getCustomerPageUrl = getCustomerPageUrl;
			vm.removeCusomter = removeCusomter;

			function initComponent(){

			}

			function onSearchTextChange(){
				if(vm.searchText == null || vm.searchText.length < minSearchTextLength){
					vm.customersFound = [];
					return;
				}

				var resourcePath = { companyID: companyID }
				var filterObj = CustomersService.customerSearchTextFilterBuilder(vm.searchText);

				CustomersService.getCustomers(resourcePath, filterObj, null, null)
					.then(function(response){
						vm.customersFound = response.data;

					})
			}

			function selectCusomter (customer){
				var idExists = vm.customerList.some(function(obj) {
					return obj.id_customer == customer.id_customer;
				});

				if (!idExists) {
					vm.customerList.push(customer)
				}

				if(typeof(vm.onCustomerChange) == "function"){
					vm.onCustomerChange(vm.customerList);
				}

			}

			function removeCusomter (customer){
				
				vm.customerList = vm.customerList.filter(function(obj) {
					return obj.id_customer !== customer.id_customer;
				});
				if(typeof(vm.onCustomerChange) == "function"){
					vm.onCustomerChange(vm.customerList);
				}
				
			}

			function goToCustomerPage (customer){
				if(customer){
					var url = $state.href('app.view-customer', {customerID: customer.getResourceID()});
					window.open(url,'_blank');
				}

			}

			function getCustomerPageUrl(customer){
				if(customer){
					return $state.href('app.view-customer', {customerID: customer.getResourceID()});
				}
			}

			vm.check = function check(){
				console.log(vm.customerList);
				console.log(vm.customer);
			}



		}
})();
(function ()
{
	'use strict';

	angular
		.module('app.workOrders')
		.controller('BrowseWorkOrderController', BrowseWorkOrderController);

	function BrowseWorkOrderController(LoginConst, VehicleService, DialogService, UserConfigService, UserConfigConstants, userConfig, $q, ToolsConstants, WorkOrderConstants, $location, HeaderHelper, MessageService, WorkOrderService, LoginService, $stateParams, GeneralTools, constants){
		const vm = this;
		const companyID = LoginService.getCompanyID();
		const userID = LoginService.getUserID();

		vm.displayOptions = [10, 20];
		vm.refreshWorkorderList = refreshWorkorderList;
		vm.applyCustomFilter = applyCustomFilter;
		vm.deleteCustomFilter = deleteCustomFilter;
		vm.isCustomFilterApplied = isCustomFilterApplied;
		vm.addCustomFilter = addCustomFilter;
		vm.vehicleMap = {};
		vm.isSortInvoiceDesc = isSortInvoiceDesc
		vm.toggleSortInvoiceNumber = toggleSortInvoiceNumber
		vm.onCustomerChange = onCustomerChange;

		init();

		function init(){
			initConstants();
			initCustomFilters();
			initStateParams();
			refreshWorkorderList(vm.currentPage);
		}

		function initCustomFilters(){
			if(!userConfig){
				return;
			}

			const pageConfig = userConfig.getPageConfigs(UserConfigConstants.pageKeyNames.browseWorkorders);

			if(pageConfig){
				vm.customFilters = pageConfig.filters;
			}	
		}

		function initStateParams(){	
			if(!$stateParams.invoiceNumber && !$stateParams.status && !$stateParams.priority && !$stateParams.priority && $stateParams.isAvailable == null){
				const localPageConfig = LoginService.getPageConfigs(LoginConst.pageConfigKeys.browseWorkorder);

				if(localPageConfig && localPageConfig.filters){
					vm.statusFilter = localPageConfig.filters.status
					vm.priorityFilter = localPageConfig.filters.priority
					vm.locationFilter = localPageConfig.filters.location
					vm.availabilityFilter = localPageConfig.filters.isAvailable
				}
			} else {
				vm.invoiceNumberFilter = GeneralTools.urlStringParamTranslator($stateParams.invoiceNumber);
				vm.statusFilter = GeneralTools.urlNumberParamTranslator($stateParams.status);
				vm.priorityFilter = GeneralTools.urlNumberParamTranslator($stateParams.priority);
				vm.locationFilter = GeneralTools.urlNumberParamTranslator($stateParams.location);
				vm.availabilityFilter = GeneralTools.urlBooleanParamTranslator($stateParams.isAvailable);
			}			

			vm.itemsPerPage = getDisplayOption(GeneralTools.urlNumberParamTranslator($stateParams.limit));
			vm.currentPage = GeneralTools.urlNumberParamTranslator($stateParams.page);

			vm.sortBy = WorkOrderConstants.keyNames.invoiceNumber;//GeneralTools.urlStringParamTranslator($stateParams.sortBy);
			vm.sortDirection = ToolsConstants.apiSortingDirections.DESC;//GeneralTools.urlStringParamTranslator($stateParams.sortDirection);
		}

		function initConstants(){
			if(!constants){
				return;
			}

			vm.workOrderStatus = constants.workOrderStatus;
			vm.workOrderPriorities = constants.workOrderPriorities;
			vm.locations = constants.locations;
			vm.customerListId = []
		}

		function getDisplayOption(itemPerPage){
			if(vm.displayOptions.indexOf(itemPerPage) == -1){
				return vm.displayOptions[0];
			}

			return itemPerPage;
		}

		function refreshWorkorderList(pageToGo){
			const resourcePath = {
				companyID: companyID
			};

			vm.isFetchingParts = true;
			WorkOrderService.getCompanyLevelWorkOrders(resourcePath, getWorkorderFilter(), getVehicleFilter(), getPagination(pageToGo), getSorting(), vm.customerListId)
				.then(function(result){
					if(!result){
						return $q.reject("Workorder data invalid");
					}

					const vehicleIdList = [];

					vm.workorderList = result.data.map(function(workorder){
						if(!workorder){
							return;
						}

						const workOrderListItem = { 
							workOrder: workorder,
							isLoading: true
						}
						fetchWorkOrderDetails(workOrderListItem);
						if(vehicleIdList.indexOf(workorder.fk_id_vehicle) == -1){
							vehicleIdList.push(workorder.fk_id_vehicle);
						}

						return workOrderListItem;
					});
					vehicleIdList.forEach(function(vehicleID){
						if(!vm.vehicleMap[vehicleID]){
							fetchVehicle(vehicleID);
						}
					});

					resetPagination(result.headerGetter);
					refreshUrl();
					savePageConfigToLocal();
				})
				.catch(MessageService.showToast)
				.finally(function(){
					vm.isFetchingParts = false;
				});
		}

		function savePageConfigToLocal(){
			var localPageConfig = LoginService.getPageConfigs(LoginConst.pageConfigKeys.browseWorkorder);

			if(!localPageConfig){
				localPageConfig = {};
			}

			if(!localPageConfig.filters){
				localPageConfig.filters = {};
			}

			localPageConfig.filters.status = vm.statusFilter
			localPageConfig.filters.priority = vm.priorityFilter
			localPageConfig.filters.location = vm.locationFilter
			localPageConfig.filters.isAvailable = vm.availabilityFilter

			LoginService.savePageConfigs(LoginConst.pageConfigKeys.browseWorkorder, localPageConfig);
		}

		function getSorting(){
			return {
				sortBy: vm.sortBy,
				sortDirection: vm.sortDirection
			};
		}

		function fetchWorkOrderDetails(workOrderListItem){
			if(!workOrderListItem || !workOrderListItem.workOrder){
				workOrderListItem.isLoading = false;
				return;
			}

			const queue = {
				labors: fetchWorkOrderLabors(workOrderListItem.workOrder.id_work_order, workOrderListItem.workOrder.fk_id_vehicle),
				miscfees: fetchWorkOrderMiscfees(workOrderListItem.workOrder.id_work_order, workOrderListItem.workOrder.fk_id_vehicle),
				parts: fetchWorkOrderParts(workOrderListItem.workOrder.id_work_order, workOrderListItem.workOrder.fk_id_vehicle),
				workorderpackge:fetchWorkOrderPackage(workOrderListItem.workOrder.id_work_order, workOrderListItem.workOrder.fk_id_vehicle),
				workorderwarranty:fetchWorkOrderWarranty(workOrderListItem.workOrder.id_work_order, workOrderListItem.workOrder.fk_id_vehicle),
				inventories: fetchWorkOrderInventories(workOrderListItem.workOrder.id_work_order, workOrderListItem.workOrder.fk_id_vehicle),
				payments: fetchWorkOrderPayments(workOrderListItem.workOrder.id_work_order, workOrderListItem.workOrder.fk_id_vehicle),
				discounts: fetchWorkOrderDiscounts(workOrderListItem.workOrder.id_work_order, workOrderListItem.workOrder.fk_id_vehicle)
			};

			$q.all(queue).then(function(results){
					if(!results){
						return $q.reject("Failed to get work order subresource with workOrder id:" + workOrderListItem.workOrder.id_work_order);
					}

					workOrderListItem.labors = results.labors;
					workOrderListItem.miscfees = results.miscfees;
					workOrderListItem.workorderpackge = results.workorderpackge;
					workOrderListItem.workorderwarranty = results.workorderwarranty;
					workOrderListItem.parts = results.parts;
					workOrderListItem.inventories = results.inventories;
					workOrderListItem.payments = results.payments;
					workOrderListItem.discounts = results.discounts;
				})
				.catch(MessageService.showToast)
				.finally(function(){
					workOrderListItem.isLoading = false;
				});
		}

		function fetchVehicle(vehicleID){
			const resourcePath = {
				companyID: companyID,
				vehicleID: vehicleID
			};

			VehicleService.getVehicle(resourcePath)
				.then(function(result){
					if(!result || !Array.isArray(result.data) || result.data.length != 1 || !result.data[0]){
						return $q.reject("vehicle data invalid.");
					}
					
					vm.vehicleMap[vehicleID] = result.data[0];
				});
		}

		function fetchWorkOrderInventories(workOrderID, vehicleID){
			const resourcePath = { 
				companyID: companyID,
				vehicleID: vehicleID,
				workorderID: workOrderID
			};

			return WorkOrderService.getWorkOrderInventories(resourcePath).$promise
		}

		function fetchWorkOrderParts(workOrderID, vehicleID){
			const resourcePath = { 
				companyID: companyID,
				vehicleID: vehicleID,
				workorderID: workOrderID
			};

			return WorkOrderService.getWorkOrderParts(resourcePath).$promise
		}

		function fetchWorkOrderLabors(workOrderID, vehicleID){
			const resourcePath = { 
				companyID: companyID,
				vehicleID: vehicleID,
				workorderID: workOrderID
			};

			return WorkOrderService.getLabors(resourcePath).$promise;
		}

		function fetchWorkOrderMiscfees(workOrderID, vehicleID){
			const resourcePath = { 
				companyID: companyID,
				vehicleID: vehicleID,
				workorderID: workOrderID
			};

			return WorkOrderService.getMiscfeestype(resourcePath).$promise;
		}

		function fetchWorkOrderPackage(workOrderID, vehicleID){
			const resourcePath = { 
				companyID: companyID,
				vehicleID: vehicleID,
				workorderID: workOrderID
			};

			return WorkOrderService.getWorkOrderPackages(resourcePath).$promise;
		}

		function fetchWorkOrderWarranty(workOrderID, vehicleID){
			const resourcePath = { 
				companyID: companyID,
				vehicleID: vehicleID,
				workorderID: workOrderID
			};

			return WorkOrderService.getWorkOrderWarranties(resourcePath).$promise;
		}

		function fetchWorkOrderDiscounts(workOrderID, vehicleID){
			const resourcePath = { 
				companyID: companyID,
				vehicleID: vehicleID,
				workorderID: workOrderID
			};

			return WorkOrderService.getDiscounts(resourcePath).$promise;
		}

		function fetchWorkOrderPayments(workOrderID, vehicleID){
			const resourcePath = { 
				companyID: companyID,
				vehicleID: vehicleID,
				workorderID: workOrderID
			};

			return WorkOrderService.getPayments(resourcePath).$promise;
		}

		function getVehicleFilter(){
			var filterString = '';

			if(vm.locationFilter){
				const locationFilter = GeneralTools.equalFilterBuilder("fk_id_location", vm.locationFilter);
				filterString = GeneralTools.stringConnector(filterString, locationFilter, ToolsConstants.apiFilters.andConnector);
			}

			var isSold;

			if(vm.availabilityFilter === true){
				const availabilityFilter = GeneralTools.equalFilterBuilder("purchase_info.is_canceled", false);
				filterString = GeneralTools.stringConnector(filterString, availabilityFilter, ToolsConstants.apiFilters.andConnector);
				isSold = false;
			} else if (vm.availabilityFilter === false) {
				isSold = true;
			}

			if(filterString || isSold != null){
				return { 
					vehicleFilters: filterString, 
					isSold: isSold
				};
			}
		}

		function getWorkorderFilter(){
			var filterString = '';

			if(vm.invoiceNumberFilter){
				const invoiceNumberFilter = GeneralTools.containFilterBuilder(WorkOrderConstants.keyNames.invoiceNumber, vm.invoiceNumberFilter);
				filterString = GeneralTools.stringConnector(filterString, invoiceNumberFilter, ToolsConstants.apiFilters.andConnector);
			}

			if(vm.statusFilter){
				const statusFilter = GeneralTools.equalFilterBuilder(WorkOrderConstants.keyNames.status, vm.statusFilter);
				filterString = GeneralTools.stringConnector(filterString, statusFilter, ToolsConstants.apiFilters.andConnector);
			}

			if(vm.priorityFilter){
				const priorityFilter = GeneralTools.equalFilterBuilder(WorkOrderConstants.keyNames.priority, vm.priorityFilter);
				filterString = GeneralTools.stringConnector(filterString, priorityFilter, ToolsConstants.apiFilters.andConnector);
			}

			if(filterString){
				return { filters: filterString };
			}
		}

		function resetPagination(headerGetter){
			vm.totalCount = HeaderHelper.getPaginationTotalItem(headerGetter);
			vm.currentPage = HeaderHelper.getPaginationCurrentPage(headerGetter);
		}

		function refreshUrl(){
			const urlParams = {};

			if(vm.itemsPerPage){
				urlParams.limit = vm.itemsPerPage;
			}

			if(vm.currentPage){
				urlParams.page = vm.currentPage;
			}

			if(vm.sortBy){
				urlParams.sortBy = vm.sortBy;
			}

			if(vm.sortDirection){
				urlParams.sortDirection = vm.sortDirection;
			}

			if(vm.invoiceNumberFilter){
				urlParams.invoiceNumber = vm.invoiceNumberFilter;
			}

			if(vm.statusFilter){
				urlParams.status = vm.statusFilter;
			}

			if(vm.priorityFilter){
				urlParams.priority = vm.priorityFilter;
			}

			if(vm.locationFilter){
				urlParams.location = vm.locationFilter;
			}

			if(typeof(vm.availabilityFilter) == "boolean"){
				urlParams.isAvailable = vm.availabilityFilter;
			}

			if(vm.customerListId.length > 0){
				urlParams.cl = vm.customerListId
			}


			$location.search(urlParams).replace();
		}

		function getPagination(page){
			return {
				page: page,
				limit: vm.itemsPerPage
			}
		}

		function deleteCustomFilter(filter, index){
			if(!filter){
				return;
			}
			var dialogOptions = {};

			dialogOptions.titleString = "Remove Filter";
			dialogOptions.contentString = "Are you sure to remove filter: " + filter.name;

			var confirmOption = {};

			confirmOption.optionName = "YES";
			confirmOption.onClick = function(){
				confirmDeleteCustomFilter(index);
				DialogService.close();
			}

			var cancelOption = {};

			cancelOption.optionName = "NO";
			cancelOption.onClick = function(){
				DialogService.close();
			}

			dialogOptions.options = [confirmOption, cancelOption];

			DialogService.showOptionsDialog(dialogOptions);
		}

		function confirmDeleteCustomFilter(index) {
			const currentPageConfig = userConfig.getPageConfigs(UserConfigConstants.pageKeyNames.browseWorkorders);	

			if(currentPageConfig && Array.isArray(currentPageConfig.filters)){
				currentPageConfig.filters.splice(index, 1);
			}

			userConfig.setPageConfigs(UserConfigConstants.pageKeyNames.browseWorkorders, currentPageConfig);		

			vm.isDeletingCustomFilter = true;
			
			updateUserConfig(userConfig)
				.then(function(){
					vm.customFilters = currentPageConfig.filters;
					MessageService.showToast("Filter is removed.");
				})
				.catch(MessageService.showToast)
				.finally(function(){
					vm.isDeletingCustomFilter = false;
				});
		}

		function applyCustomFilter(filter){
			if(!filter || !filter.filters || isCustomFilterApplied(filter)){
				return;
			}

			vm.statusFilter = filter.filters.status;
			vm.priorityFilter = filter.filters.priority;
			vm.locationFilter = filter.filters.location;
			vm.availabilityFilter = filter.filters.isAvailable;
			refreshWorkorderList(1);
		}

		function isCustomFilterApplied(filter){
			if(!filter || !filter.filters){
				return;
			}

			return vm.statusFilter == filter.filters.status && 
				vm.priorityFilter == filter.filters.priority && 
				vm.locationFilter == filter.filters.location && 
				vm.availabilityFilter == filter.filters.isAvailable
		}

		function addCustomFilter(){
			if(!vm.customFilterName){
				MessageService.showToast("Please enter a filter name.");
				return
			}

			var currentPageConfig = userConfig.getPageConfigs(UserConfigConstants.pageKeyNames.browseWorkorders);

			if(!currentPageConfig){
				currentPageConfig = {};
			}

			if(!Array.isArray(currentPageConfig.filters)){
				currentPageConfig.filters = [];
			}

			currentPageConfig.filters.push({
				name: vm.customFilterName,
				filters:{
					status: vm.statusFilter,
					priority: vm.priorityFilter,
					location: vm.locationFilter,
					isAvailable: vm.availabilityFilter
				}
			});

			userConfig.setPageConfigs(UserConfigConstants.pageKeyNames.browseWorkorders, currentPageConfig);		

			vm.isSavingCustomFilter = true;
			
			updateUserConfig(userConfig)
				.then(function(){
					vm.customFilters = currentPageConfig.filters;
					vm.customFilterName = null;
					MessageService.showToast("New filter is saved.");
				})
				.catch(MessageService.showToast)
				.finally(function(){
					vm.isSavingCustomFilter = false;
				});
		}

		function updateUserConfig(userConfig){
			if(!userConfig){
				return $q.reject("User config invalid");
			}

			const resourcePath = {
				companyID: companyID,
				userID: userID
			}

			const requestBody = {
				config: userConfig.config
			}

			return UserConfigService.updateUserConfig(resourcePath, requestBody);
		}


		function isSortInvoiceDesc(){

			return vm.sortDirection == "DESC"
		}


		function toggleSortInvoiceNumber(){
			if(vm.sortDirection == ToolsConstants.apiSortingDirections.DESC){
				vm.sortDirection = ToolsConstants.apiSortingDirections.ASC
				refreshWorkorderList(vm.currentPage);
			}else{
				vm.sortDirection = ToolsConstants.apiSortingDirections.DESC
				refreshWorkorderList(vm.currentPage);
			}
		}

		
		function onCustomerChange(customerList){
			const previousCustomerListId = vm.customerListId.slice();

			vm.customerListId = customerList.map(function(obj) {
				return obj.id_customer;
			});
			const hasChanged = JSON.stringify(vm.customerListId) !== JSON.stringify(previousCustomerListId);

			if(hasChanged){
				refreshWorkorderList(vm.currentPage);
			}

		}
	}
})();
(function ()
{
	'use strict';

	angular
		.module('app.workOrders')
		.controller('BrowseWarrantyWorkOrderController', BrowseWarrantyWorkOrderController);

	function BrowseWarrantyWorkOrderController(LoginConst, VehicleService, DialogService, UserConfigService, WorkOrderSummaryCalculator, UserConfigConstants, userConfig, $q, ToolsConstants, WorkOrderConstants, $location, HeaderHelper, MessageService, WorkOrderService, LoginService, $stateParams, GeneralTools, constants){
		const vm = this;
		const companyID = LoginService.getCompanyID();
		const userID = LoginService.getUserID();

		vm.displayOptions = [10, 20];
		vm.refreshWorkorderList = refreshWorkorderList;
		vm.applyCustomFilter = applyCustomFilter;
		vm.deleteCustomFilter = deleteCustomFilter;
		vm.isCustomFilterApplied = isCustomFilterApplied;
		vm.addCustomFilter = addCustomFilter;
		vm.vehicleMap = {};
		vm.totaloutstanding = 0;
		vm.overall_outstanding = 0;
		const keyNameCompletedDate = "work_order.completed_date";
		const dateFormat = "YYYY-MM-DD";
		
		init();

		function init(){
			initConstants();
			initCustomFilters();
			initStateParams();
			refreshWorkorderList(vm.currentPage);
		}

		function initCustomFilters(){
			if(!userConfig){
				return;
			}

			const pageConfig = userConfig.getPageConfigs(UserConfigConstants.pageKeyNames.browseWorkorders);

			if(pageConfig){
				vm.customFilters = pageConfig.filters;
			}	
		}

		function initStateParams(){	
			if(!$stateParams.invoiceNumber && !$stateParams.status && !$stateParams.priority && !$stateParams.priority && $stateParams.isAvailable == null){
				const localPageConfig = LoginService.getPageConfigs(LoginConst.pageConfigKeys.browseWorkorder);

				if(localPageConfig && localPageConfig.filters){
					vm.statusFilter = localPageConfig.filters.status
					vm.priorityFilter = localPageConfig.filters.priority
					vm.locationFilter = localPageConfig.filters.location
					vm.availabilityFilter = localPageConfig.filters.isAvailable
				}
			} else {
				vm.invoiceNumberFilter = GeneralTools.urlStringParamTranslator($stateParams.invoiceNumber);
				vm.statusFilter = GeneralTools.urlNumberParamTranslator($stateParams.status);
				vm.priorityFilter = GeneralTools.urlNumberParamTranslator($stateParams.priority);
				vm.locationFilter = GeneralTools.urlNumberParamTranslator($stateParams.location);
				vm.availabilityFilter = GeneralTools.urlBooleanParamTranslator($stateParams.isAvailable);
			}			

			vm.itemsPerPage = getDisplayOption(GeneralTools.urlNumberParamTranslator($stateParams.limit));
			vm.currentPage = GeneralTools.urlNumberParamTranslator($stateParams.page);

			vm.sortBy = WorkOrderConstants.keyNames.invoiceNumber;//GeneralTools.urlStringParamTranslator($stateParams.sortBy);
			vm.sortDirection = ToolsConstants.apiSortingDirections.DESC;//GeneralTools.urlStringParamTranslator($stateParams.sortDirection);

			vm.startDateFilter = GeneralTools.urlDateParamTranslator($stateParams.startDate);
			vm.endDateFilter = GeneralTools.urlDateParamTranslator($stateParams.endDate);
		}

		function getTimeRangeFilter(dateObj, isBeforeDate) {
			const momentObj = moment(dateObj);

			if (!dateObj || !momentObj.isValid()) {
				return;
			}

			if (isBeforeDate) {
				return GeneralTools.equalOrLesshanFilterBuilder(keyNameCompletedDate, momentObj.format(dateFormat));
			}

			return GeneralTools.equalOrGreaterThanFilterBuilder(keyNameCompletedDate, momentObj.format(dateFormat));
		}


		function initConstants(){
			if(!constants){
				return;
			}

			vm.workOrderStatus = constants.workOrderStatus;
			vm.workOrderPriorities = constants.workOrderPriorities;
			vm.locations = constants.locations;
		}

		function getDisplayOption(itemPerPage){
			if(vm.displayOptions.indexOf(itemPerPage) == -1){
				return vm.displayOptions[0];
			}

			return itemPerPage;
		}

		function refreshWorkorderList(pageToGo){
			vm.totaloutstanding = 0
			vm.overall_outstanding = 0;
			const resourcePath = {
				companyID: companyID
			};

			vm.isFetchingParts = true;

			WorkOrderService.getCompanyLevelWarrantyPaymentWorkOrders(resourcePath, getWorkorderFilter(), getVehicleFilter(), getPagination(pageToGo), getSorting())
				.then(function(result){
					if(!result){
						return $q.reject("Workorder data invalid");
					}

					const vehicleIdList = [];

					vm.workorderList = result.data.map(function(workorder){
						if(!workorder){
							return;
						}

						const workOrderListItem = { 
							workOrder: workorder,
							isLoading: true
						}
						fetchWorkOrderDetails(workOrderListItem);
						if(vehicleIdList.indexOf(workorder.fk_id_vehicle) == -1){
							vehicleIdList.push(workorder.fk_id_vehicle);
						}

						// if(workorder.total_amount){
						// 	vm.overall_outstanding = workorder.total_amount
						// }

						return workOrderListItem;
					});
					vehicleIdList.forEach(function(vehicleID){
						if(!vm.vehicleMap[vehicleID]){
							fetchVehicle(vehicleID);
						}
					});

					resetPagination(result.headerGetter);
					refreshUrl();
					savePageConfigToLocal();
				})
				.then(function(){
					const queue = { 
						warrantyOverallPayment: fetchWarrantyOverallPayment()
					}

					$q.all(queue).then(function(results){
						if(results && results.warrantyOverallPayment){
							vm.overall_outstanding = results.warrantyOverallPayment.overall_amount
						}
					})
				})
				.catch(MessageService.showToast)
				.finally(function(){
					vm.isFetchingParts = false;
				});
		}





		function savePageConfigToLocal(){
			var localPageConfig = LoginService.getPageConfigs(LoginConst.pageConfigKeys.browseWorkorder);

			if(!localPageConfig){
				localPageConfig = {};
			}

			if(!localPageConfig.filters){
				localPageConfig.filters = {};
			}

			localPageConfig.filters.status = vm.statusFilter
			localPageConfig.filters.priority = vm.priorityFilter
			localPageConfig.filters.location = vm.locationFilter
			localPageConfig.filters.isAvailable = vm.availabilityFilter

			LoginService.savePageConfigs(LoginConst.pageConfigKeys.browseWorkorder, localPageConfig);
		}

		function getSorting(){
			return {
				sortBy: vm.sortBy,
				sortDirection: vm.sortDirection
			};
		}

		function fetchWorkOrderDetails(workOrderListItem){
			if(!workOrderListItem || !workOrderListItem.workOrder){
				workOrderListItem.isLoading = false;
				return;
			}
			
			const queue = {
				labors: fetchWorkOrderLabors(workOrderListItem.workOrder.id_work_order, workOrderListItem.workOrder.fk_id_vehicle),
				parts: fetchWorkOrderParts(workOrderListItem.workOrder.id_work_order, workOrderListItem.workOrder.fk_id_vehicle),
				inventories: fetchWorkOrderInventories(workOrderListItem.workOrder.id_work_order, workOrderListItem.workOrder.fk_id_vehicle),
				payments: fetchWorkOrderPayments(workOrderListItem.workOrder.id_work_order, workOrderListItem.workOrder.fk_id_vehicle),
				discounts: fetchWorkOrderDiscounts(workOrderListItem.workOrder.id_work_order, workOrderListItem.workOrder.fk_id_vehicle),

				miscfees: fetchMiscfeesData(workOrderListItem.workOrder.id_work_order, workOrderListItem.workOrder.fk_id_vehicle),
				workOrderWarrantyListData: fetchWorkOrderWarrantyListData(workOrderListItem.workOrder.id_work_order, workOrderListItem.workOrder.fk_id_vehicle),
				workOrderPackageListData: fetchWorkOrderPackageListData(workOrderListItem.workOrder.id_work_order, workOrderListItem.workOrder.fk_id_vehicle),
				
			};

			$q.all(queue).then(function(results){
					if(!results){
						return $q.reject("Failed to get work order subresource with workOrder id:" + workOrderListItem.workOrder.id_work_order);
					}

					workOrderListItem.labors = results.labors;
					workOrderListItem.parts = results.parts;
					workOrderListItem.inventories = results.inventories;
					workOrderListItem.payments = results.payments;
					workOrderListItem.discounts = results.discounts;

					workOrderListItem.miscfees = results.miscfees;
					workOrderListItem.workOrderWarrantyListData = results.workOrderWarrantyListData;
					workOrderListItem.workOrderPackageListData = results.workOrderPackageListData;
					
					refreshList(workOrderListItem)
				})
				.catch(MessageService.showToast)
				.finally(function(){
					workOrderListItem.isLoading = false;
				});
		}

		function refreshList(workorderData){
			if(!workorderData){
				return
			}

			const workOrderSummaryCalculator = new WorkOrderSummaryCalculator();

			if(workorderData.workOrder){
				
				workOrderSummaryCalculator.setTaxRate(workorderData.workOrder.tax_rate);
				workOrderSummaryCalculator.setSubsidizedAmount(workorderData.workOrder.subsidized_amount);
				workOrderSummaryCalculator.setSubsidizedPercentage(workorderData.workOrder.subsidized_percentage);
				workOrderSummaryCalculator.setIsSubsidizedByPercentage(workorderData.workOrder.is_subsidized_by_percentage);
			}
			workOrderSummaryCalculator.setParts(workorderData.parts);
			workOrderSummaryCalculator.setInventories(workorderData.inventories);
			workOrderSummaryCalculator.setLabors(workorderData.labors);
			workOrderSummaryCalculator.setDiscounts(workorderData.discounts);
			workOrderSummaryCalculator.setPayments(workorderData.payments);
			workOrderSummaryCalculator.setMiscfees(workorderData.miscfees);
			workOrderSummaryCalculator.setWorkOrderPackageList(workorderData.workOrderPackageListData);
			workOrderSummaryCalculator.setWorkOrderWarrantyList(workorderData.workOrderWarrantyListData);
			workOrderSummaryCalculator.setRDRedeemed(workorderData.rogerDollarRedeem);

			workorderData.partsAndInventories = combinePartsAndInventories(workorderData.parts, workorderData.inventories);

			workorderData.totalPartsRetail = workOrderSummaryCalculator.getPartsAndInventoryTotalRetail();
			workorderData.totalLaborsCost = workOrderSummaryCalculator.getTotalLaborsCost();
			
			workorderData.outstanding = workOrderSummaryCalculator.getOutstanding();

			if(workorderData.outstanding){
				vm.totaloutstanding = vm.totaloutstanding + workorderData.outstanding
			}

	}

	function combinePartsAndInventories(parts, inventories){
		if(!Array.isArray(parts)){
			parts = [];
		}

		if(!Array.isArray(inventories)){
			inventories = [];
		}

		var list = [];

		parts.forEach(function(part){
			list.push({
				name: part.name,
				isFromInventory: false,
				isOrdered: part.is_ordered
			});
		});

		inventories.forEach(function(inventory){
			list.push({
				name: inventory.name,
				isFromInventory: true
			});
		});

		return list;
	}

		function fetchVehicle(vehicleID){
			const resourcePath = {
				companyID: companyID,
				vehicleID: vehicleID
			};

			VehicleService.getVehicle(resourcePath)
				.then(function(result){
					if(!result || !Array.isArray(result.data) || result.data.length != 1 || !result.data[0]){
						return $q.reject("vehicle data invalid.");
					}
					
					vm.vehicleMap[vehicleID] = result.data[0];
				});
		}

		function fetchWorkOrderInventories(workOrderID, vehicleID){
			const resourcePath = { 
				companyID: companyID,
				vehicleID: vehicleID,
				workorderID: workOrderID
			};

			return WorkOrderService.getWorkOrderInventories(resourcePath).$promise
		}

		function fetchWorkOrderParts(workOrderID, vehicleID){
			const resourcePath = { 
				companyID: companyID,
				vehicleID: vehicleID,
				workorderID: workOrderID
			};

			return WorkOrderService.getWorkOrderParts(resourcePath).$promise
		}

		function fetchWorkOrderLabors(workOrderID, vehicleID){
			const resourcePath = { 
				companyID: companyID,
				vehicleID: vehicleID,
				workorderID: workOrderID
			};

			return WorkOrderService.getLabors(resourcePath).$promise;
		}

		function fetchWorkOrderDiscounts(workOrderID, vehicleID){
			const resourcePath = { 
				companyID: companyID,
				vehicleID: vehicleID,
				workorderID: workOrderID
			};

			return WorkOrderService.getDiscounts(resourcePath).$promise;
		}

		function fetchMiscfeesData(workOrderID, vehicleID){
			const resourcePath = { 
				companyID: companyID,
				vehicleID: vehicleID,
				workorderID: workOrderID
			};

			return WorkOrderService.getMiscfeestype(resourcePath).$promise
		}

		function fetchWorkOrderWarrantyListData(workOrderID, vehicleID){
			const resourcePath = { 
				companyID: companyID,
				vehicleID: vehicleID,
				workorderID: workOrderID
			};

			return WorkOrderService.getWorkOrderWarranties(resourcePath).$promise;
		}

		function fetchWorkOrderPackageListData(workOrderID, vehicleID){
			const resourcePath = { 
				companyID: companyID,
				vehicleID: vehicleID,
				workorderID: workOrderID
			};

			return WorkOrderService.getWorkOrderPackages(resourcePath).$promise
		}

		function fetchWorkOrderPayments(workOrderID, vehicleID){
			const resourcePath = { 
				companyID: companyID,
				vehicleID: vehicleID,
				workorderID: workOrderID
			};

			return WorkOrderService.getPayments(resourcePath).$promise;
		}

		function fetchWarrantyOverallPayment(){
			const resourcePath = { 
				companyID: companyID,
			};

			return WorkOrderService.getWarrantyPaymentOverallPaymentAmount(resourcePath);
		}

		function getVehicleFilter(){
			var filterString = '';

			if(vm.locationFilter){
				const locationFilter = GeneralTools.equalFilterBuilder("fk_id_location", vm.locationFilter);
				filterString = GeneralTools.stringConnector(filterString, locationFilter, ToolsConstants.apiFilters.andConnector);
			}

			var isSold;

			if(vm.availabilityFilter === true){
				const availabilityFilter = GeneralTools.equalFilterBuilder("purchase_info.is_canceled", false);
				filterString = GeneralTools.stringConnector(filterString, availabilityFilter, ToolsConstants.apiFilters.andConnector);
				isSold = false;
			} else if (vm.availabilityFilter === false) {
				isSold = true;
			}

			if(filterString || isSold != null){
				return { 
					vehicleFilters: filterString, 
					isSold: isSold
				};
			}
		}

		function getWorkorderFilter(){
			var filterString = '';

			if(vm.invoiceNumberFilter){
				const invoiceNumberFilter = GeneralTools.containFilterBuilder(WorkOrderConstants.keyNames.invoiceNumber, vm.invoiceNumberFilter);
				filterString = GeneralTools.stringConnector(filterString, invoiceNumberFilter, ToolsConstants.apiFilters.andConnector);
			}

			if(vm.statusFilter){
				const statusFilter = GeneralTools.equalFilterBuilder(WorkOrderConstants.keyNames.status, vm.statusFilter);
				filterString = GeneralTools.stringConnector(filterString, statusFilter, ToolsConstants.apiFilters.andConnector);
			}

			if (vm.startDateFilter) {
				filterString = GeneralTools.stringConnector(filterString, getTimeRangeFilter(vm.startDateFilter, false), ToolsConstants.apiFilters.andConnector);
			}

			if (vm.endDateFilter) {
				filterString = GeneralTools.stringConnector(filterString, getTimeRangeFilter(vm.endDateFilter, true), ToolsConstants.apiFilters.andConnector);
			}

			if(vm.priorityFilter){
				const priorityFilter = GeneralTools.equalFilterBuilder(WorkOrderConstants.keyNames.priority, vm.priorityFilter);
				filterString = GeneralTools.stringConnector(filterString, priorityFilter, ToolsConstants.apiFilters.andConnector);
			}
			if(filterString){
				return { filters: filterString };
			}
		}

		function resetPagination(headerGetter){
			vm.totalCount = HeaderHelper.getPaginationTotalItem(headerGetter);
			vm.currentPage = HeaderHelper.getPaginationCurrentPage(headerGetter);
		}

		function refreshUrl(){
			const urlParams = {};

			if(vm.itemsPerPage){
				urlParams.limit = vm.itemsPerPage;
			}

			if(vm.currentPage){
				urlParams.page = vm.currentPage;
			}

			if(vm.sortBy){
				urlParams.sortBy = vm.sortBy;
			}

			if(vm.sortDirection){
				urlParams.sortDirection = vm.sortDirection;
			}

			if(vm.invoiceNumberFilter){
				urlParams.invoiceNumber = vm.invoiceNumberFilter;
			}

			if(vm.statusFilter){
				urlParams.status = vm.statusFilter;
			}

			if(vm.priorityFilter){
				urlParams.priority = vm.priorityFilter;
			}

			if(vm.locationFilter){
				urlParams.location = vm.locationFilter;
			}

			if(typeof(vm.availabilityFilter) == "boolean"){
				urlParams.isAvailable = vm.availabilityFilter;
			}

			const startDateMoment = moment(vm.startDateFilter);
			const endDateMoment = moment(vm.endDateFilter);

			if (vm.startDateFilter && startDateMoment.isValid()) {
				urlParams.startDate = startDateMoment.format(dateFormat);
			}

			if (vm.endDateFilter && endDateMoment.isValid()) {
				urlParams.endDate = endDateMoment.format(dateFormat);
			}

			$location.search(urlParams).replace();
		}

		function getPagination(page){
			return {
				page: page,
				limit: vm.itemsPerPage
			}
		}

		function deleteCustomFilter(filter, index){
			if(!filter){
				return;
			}
			var dialogOptions = {};

			dialogOptions.titleString = "Remove Filter";
			dialogOptions.contentString = "Are you sure to remove filter: " + filter.name;

			var confirmOption = {};

			confirmOption.optionName = "YES";
			confirmOption.onClick = function(){
				confirmDeleteCustomFilter(index);
				DialogService.close();
			}

			var cancelOption = {};

			cancelOption.optionName = "NO";
			cancelOption.onClick = function(){
				DialogService.close();
			}

			dialogOptions.options = [confirmOption, cancelOption];

			DialogService.showOptionsDialog(dialogOptions);
		}

		function confirmDeleteCustomFilter(index) {
			const currentPageConfig = userConfig.getPageConfigs(UserConfigConstants.pageKeyNames.browseWorkorders);	

			if(currentPageConfig && Array.isArray(currentPageConfig.filters)){
				currentPageConfig.filters.splice(index, 1);
			}

			userConfig.setPageConfigs(UserConfigConstants.pageKeyNames.browseWorkorders, currentPageConfig);		

			vm.isDeletingCustomFilter = true;
			
			updateUserConfig(userConfig)
				.then(function(){
					vm.customFilters = currentPageConfig.filters;
					MessageService.showToast("Filter is removed.");
				})
				.catch(MessageService.showToast)
				.finally(function(){
					vm.isDeletingCustomFilter = false;
				});
		}

		function applyCustomFilter(filter){
			if(!filter || !filter.filters || isCustomFilterApplied(filter)){
				return;
			}

			vm.statusFilter = filter.filters.status;
			vm.priorityFilter = filter.filters.priority;
			vm.locationFilter = filter.filters.location;
			vm.availabilityFilter = filter.filters.isAvailable;
			refreshWorkorderList(1);
		}

		function isCustomFilterApplied(filter){
			if(!filter || !filter.filters){
				return;
			}

			return vm.statusFilter == filter.filters.status && 
				vm.priorityFilter == filter.filters.priority && 
				vm.locationFilter == filter.filters.location && 
				vm.availabilityFilter == filter.filters.isAvailable
		}

		function addCustomFilter(){
			if(!vm.customFilterName){
				MessageService.showToast("Please enter a filter name.");
				return
			}

			var currentPageConfig = userConfig.getPageConfigs(UserConfigConstants.pageKeyNames.browseWorkorders);

			if(!currentPageConfig){
				currentPageConfig = {};
			}

			if(!Array.isArray(currentPageConfig.filters)){
				currentPageConfig.filters = [];
			}

			currentPageConfig.filters.push({
				name: vm.customFilterName,
				filters:{
					status: vm.statusFilter,
					priority: vm.priorityFilter,
					location: vm.locationFilter,
					isAvailable: vm.availabilityFilter
				}
			});

			userConfig.setPageConfigs(UserConfigConstants.pageKeyNames.browseWorkorders, currentPageConfig);		

			vm.isSavingCustomFilter = true;
			
			updateUserConfig(userConfig)
				.then(function(){
					vm.customFilters = currentPageConfig.filters;
					vm.customFilterName = null;
					MessageService.showToast("New filter is saved.");
				})
				.catch(MessageService.showToast)
				.finally(function(){
					vm.isSavingCustomFilter = false;
				});
		}

		function updateUserConfig(userConfig){
			if(!userConfig){
				return $q.reject("User config invalid");
			}

			const resourcePath = {
				companyID: companyID,
				userID: userID
			}

			const requestBody = {
				config: userConfig.config
			}

			return UserConfigService.updateUserConfig(resourcePath, requestBody);
		}

		vm.isSortInvoiceDesc = function(){

			return vm.sortDirection == "DESC"
		}

		vm.toggleSortInvoiceNumber = function(){

			if(vm.sortDirection == ToolsConstants.apiSortingDirections.DESC){
				vm.sortDirection = ToolsConstants.apiSortingDirections.ASC
				refreshWorkorderList(vm.currentPage);
			}else{
				vm.sortDirection = ToolsConstants.apiSortingDirections.DESC
				refreshWorkorderList(vm.currentPage);
			}
		}
	}
})();
(function ()
{
	'use strict';

	angular
		.module('app.workOrders')
		.controller('BrowsePendingWorkOrderController', BrowsePendingWorkOrderController);

	function BrowsePendingWorkOrderController(LoginConst, VehicleService, WorkOrderSummaryCalculator, DialogService, UserConfigService, UserConfigConstants, userConfig, $q, ToolsConstants, WorkOrderConstants, $location, HeaderHelper, MessageService, WorkOrderService, LoginService, $stateParams, GeneralTools, constants){
		const vm = this;
		const companyID = LoginService.getCompanyID();
		const userID = LoginService.getUserID();

		vm.displayOptions = [10, 20];
		vm.refreshWorkorderList = refreshWorkorderList;
		vm.applyCustomFilter = applyCustomFilter;
		vm.deleteCustomFilter = deleteCustomFilter;
		vm.isCustomFilterApplied = isCustomFilterApplied;
		vm.addCustomFilter = addCustomFilter;
		vm.vehicleMap = {};
		vm.totaloutstanding = 0;
		vm.overall_outstanding = 0;
		const keyNameCompletedDate = "work_order.completed_date";
		const dateFormat = "YYYY-MM-DD";

		init();

		function init(){
			initConstants();
			initCustomFilters();
			initStateParams();
			refreshWorkorderList(vm.currentPage);
		}

		function initCustomFilters(){
			if(!userConfig){
				return;
			}

			const pageConfig = userConfig.getPageConfigs(UserConfigConstants.pageKeyNames.browseWorkorders);

			if(pageConfig){
				vm.customFilters = pageConfig.filters;
			}	
		}

		function initStateParams(){	
			if(!$stateParams.invoiceNumber && !$stateParams.status && !$stateParams.priority && !$stateParams.priority && $stateParams.isAvailable == null){
				const localPageConfig = LoginService.getPageConfigs(LoginConst.pageConfigKeys.browseWorkorder);

				if(localPageConfig && localPageConfig.filters){
					vm.statusFilter = localPageConfig.filters.status
					vm.priorityFilter = localPageConfig.filters.priority
					vm.locationFilter = localPageConfig.filters.location
					vm.availabilityFilter = localPageConfig.filters.isAvailable
				}
			} else {
				vm.invoiceNumberFilter = GeneralTools.urlStringParamTranslator($stateParams.invoiceNumber);
				vm.statusFilter = GeneralTools.urlNumberParamTranslator($stateParams.status);
				vm.priorityFilter = GeneralTools.urlNumberParamTranslator($stateParams.priority);
				vm.locationFilter = GeneralTools.urlNumberParamTranslator($stateParams.location);
				vm.availabilityFilter = GeneralTools.urlBooleanParamTranslator($stateParams.isAvailable);
			}			

			vm.itemsPerPage = getDisplayOption(GeneralTools.urlNumberParamTranslator($stateParams.limit));
			vm.currentPage = GeneralTools.urlNumberParamTranslator($stateParams.page);

			vm.sortBy = WorkOrderConstants.keyNames.invoiceNumber;//GeneralTools.urlStringParamTranslator($stateParams.sortBy);
			vm.sortDirection = ToolsConstants.apiSortingDirections.DESC;//GeneralTools.urlStringParamTranslator($stateParams.sortDirection);

			vm.startDateFilter = GeneralTools.urlDateParamTranslator($stateParams.startDate);
			vm.endDateFilter = GeneralTools.urlDateParamTranslator($stateParams.endDate);
		}

		function getTimeRangeFilter(dateObj, isBeforeDate) {
			const momentObj = moment(dateObj);

			if (!dateObj || !momentObj.isValid()) {
				return;
			}

			if (isBeforeDate) {
				return GeneralTools.equalOrLesshanFilterBuilder(keyNameCompletedDate, momentObj.format(dateFormat));
			}

			return GeneralTools.equalOrGreaterThanFilterBuilder(keyNameCompletedDate, momentObj.format(dateFormat));
		}


		function initConstants(){
			if(!constants){
				return;
			}

			vm.workOrderStatus = constants.workOrderStatus;
			vm.workOrderPriorities = constants.workOrderPriorities;
			vm.locations = constants.locations;
		}

		function getDisplayOption(itemPerPage){
			if(vm.displayOptions.indexOf(itemPerPage) == -1){
				return vm.displayOptions[0];
			}

			return itemPerPage;
		}

		function refreshWorkorderList(pageToGo){
			vm.totaloutstanding = 0
			vm.overall_outstanding = 0;
			const resourcePath = {
				companyID: companyID
			};

			vm.isFetchingParts = true;

			WorkOrderService.getCompanyLevelPendingWorkOrders(resourcePath, getWorkorderFilter(), getVehicleFilter(), getPagination(pageToGo), getSorting())
				.then(function(result){
					if(!result){
						return $q.reject("Workorder data invalid");
					}

					const vehicleIdList = [];

					vm.workorderList = result.data.map(function(workorder){
						if(!workorder){
							return;
						}

						const workOrderListItem = { 
							workOrder: workorder,
							isLoading: true
						}


						fetchWorkOrderDetails(workOrderListItem);

						if(vehicleIdList.indexOf(workorder.fk_id_vehicle) == -1){
							vehicleIdList.push(workorder.fk_id_vehicle);
						}
						return workOrderListItem;
					});
					vehicleIdList.forEach(function(vehicleID){
						if(!vm.vehicleMap[vehicleID]){
							fetchVehicle(vehicleID);
						}
					});

					resetPagination(result.headerGetter);
					refreshUrl();
					savePageConfigToLocal();
				})
				.then(function(){
					const queue = { 
						warrantyOverallPayment: fetchPendingWarrantyOverallPayment()
					}

					$q.all(queue).then(function(results){
						if(results && results.warrantyOverallPayment){
							vm.overall_outstanding = results.warrantyOverallPayment.overall_amount
						}
					})
				})
				.catch(MessageService.showToast)
				.finally(function(){
					vm.isFetchingParts = false;
				});
		}
		function savePageConfigToLocal(){
			var localPageConfig = LoginService.getPageConfigs(LoginConst.pageConfigKeys.browseWorkorder);

			if(!localPageConfig){
				localPageConfig = {};
			}

			if(!localPageConfig.filters){
				localPageConfig.filters = {};
			}

			localPageConfig.filters.status = vm.statusFilter
			localPageConfig.filters.priority = vm.priorityFilter
			localPageConfig.filters.location = vm.locationFilter
			localPageConfig.filters.isAvailable = vm.availabilityFilter

			LoginService.savePageConfigs(LoginConst.pageConfigKeys.browseWorkorder, localPageConfig);
		}

		function getSorting(){
			return {
				sortBy: vm.sortBy,
				sortDirection: vm.sortDirection
			};
		}

		function fetchWorkOrderDetails(workOrderListItem){
			if(!workOrderListItem || !workOrderListItem.workOrder){
				workOrderListItem.isLoading = false;
				return;
			}

			const queue = {
				labors: fetchWorkOrderLabors(workOrderListItem.workOrder.id_work_order, workOrderListItem.workOrder.fk_id_vehicle),
				parts: fetchWorkOrderParts(workOrderListItem.workOrder.id_work_order, workOrderListItem.workOrder.fk_id_vehicle),
				inventories: fetchWorkOrderInventories(workOrderListItem.workOrder.id_work_order, workOrderListItem.workOrder.fk_id_vehicle),
				payments: fetchWorkOrderPayments(workOrderListItem.workOrder.id_work_order, workOrderListItem.workOrder.fk_id_vehicle),
				discounts: fetchWorkOrderDiscounts(workOrderListItem.workOrder.id_work_order, workOrderListItem.workOrder.fk_id_vehicle),
				miscfees: fetchMiscfeesData(workOrderListItem.workOrder.id_work_order, workOrderListItem.workOrder.fk_id_vehicle),
				workOrderWarrantyListData: fetchWorkOrderWarrantyListData(workOrderListItem.workOrder.id_work_order, workOrderListItem.workOrder.fk_id_vehicle),
				workOrderPackageListData: fetchWorkOrderPackageListData(workOrderListItem.workOrder.id_work_order, workOrderListItem.workOrder.fk_id_vehicle),
				rogerDollarRedeem: fetchRogerDollarRedeemData(workOrderListItem.workOrder.id_work_order, workOrderListItem.workOrder.fk_id_vehicle),
			};

			$q.all(queue).then(function(results){
					if(!results){
						return $q.reject("Failed to get work order subresource with workOrder id:" + workOrderListItem.workOrder.id_work_order);
					}

					workOrderListItem.labors = results.labors;
					workOrderListItem.parts = results.parts;
					workOrderListItem.inventories = results.inventories;
					workOrderListItem.payments = results.payments;
					workOrderListItem.discounts = results.discounts;

					workOrderListItem.miscfees = results.miscfees;
					workOrderListItem.workOrderWarrantyListData = results.workOrderWarrantyListData;
					workOrderListItem.workOrderPackageListData = results.workOrderPackageListData;
					workOrderListItem.rogerDollarRedeem = results.rogerDollarRedeem;


					refreshList(workOrderListItem)
				})
				.catch(MessageService.showToast)
				.finally(function(){
					workOrderListItem.isLoading = false;
				});
		}

		
		function refreshList(workorderData){
			if(!workorderData){
				return
			}

			const workOrderSummaryCalculator = new WorkOrderSummaryCalculator();

			if(workorderData.workOrder){
				
				workOrderSummaryCalculator.setTaxRate(workorderData.workOrder.tax_rate);
				workOrderSummaryCalculator.setSubsidizedAmount(workorderData.workOrder.subsidized_amount);
				workOrderSummaryCalculator.setSubsidizedPercentage(workorderData.workOrder.subsidized_percentage);
				workOrderSummaryCalculator.setIsSubsidizedByPercentage(workorderData.workOrder.is_subsidized_by_percentage);
			}
			workOrderSummaryCalculator.setParts(workorderData.parts);
			workOrderSummaryCalculator.setInventories(workorderData.inventories);
			workOrderSummaryCalculator.setLabors(workorderData.labors);
			workOrderSummaryCalculator.setDiscounts(workorderData.discounts);
			workOrderSummaryCalculator.setPayments(workorderData.payments);
			workOrderSummaryCalculator.setMiscfees(workorderData.miscfees);
			workOrderSummaryCalculator.setWorkOrderPackageList(workorderData.workOrderPackageListData);
			workOrderSummaryCalculator.setWorkOrderWarrantyList(workorderData.workOrderWarrantyListData);
			workOrderSummaryCalculator.setRDRedeemed(workorderData.rogerDollarRedeem);

			workorderData.partsAndInventories = combinePartsAndInventories(workorderData.parts, workorderData.inventories);

			workorderData.totalPartsRetail = workOrderSummaryCalculator.getPartsAndInventoryTotalRetail();
			workorderData.totalLaborsCost = workOrderSummaryCalculator.getTotalLaborsCost();

			workorderData.outstanding = workOrderSummaryCalculator.getOutstanding();
			if(workorderData.outstanding){
				vm.totaloutstanding = vm.totaloutstanding + workorderData.outstanding
			}
	}

	function combinePartsAndInventories(parts, inventories){
		if(!Array.isArray(parts)){
			parts = [];
		}

		if(!Array.isArray(inventories)){
			inventories = [];
		}

		var list = [];

		parts.forEach(function(part){
			list.push({
				name: part.name,
				isFromInventory: false,
				isOrdered: part.is_ordered
			});
		});

		inventories.forEach(function(inventory){
			list.push({
				name: inventory.name,
				isFromInventory: true
			});
		});

		return list;
	}

		function fetchVehicle(vehicleID){
			const resourcePath = {
				companyID: companyID,
				vehicleID: vehicleID
			};

			VehicleService.getVehicle(resourcePath)
				.then(function(result){
					if(!result || !Array.isArray(result.data) || result.data.length != 1 || !result.data[0]){
						return $q.reject("vehicle data invalid.");
					}
					
					vm.vehicleMap[vehicleID] = result.data[0];
				});
		}

		function fetchWorkOrderInventories(workOrderID, vehicleID){
			const resourcePath = { 
				companyID: companyID,
				vehicleID: vehicleID,
				workorderID: workOrderID
			};

			return WorkOrderService.getWorkOrderInventories(resourcePath).$promise
		}

		function fetchWorkOrderParts(workOrderID, vehicleID){
			const resourcePath = { 
				companyID: companyID,
				vehicleID: vehicleID,
				workorderID: workOrderID
			};

			return WorkOrderService.getWorkOrderParts(resourcePath).$promise
		}

		function fetchWorkOrderLabors(workOrderID, vehicleID){
			const resourcePath = { 
				companyID: companyID,
				vehicleID: vehicleID,
				workorderID: workOrderID
			};

			return WorkOrderService.getLabors(resourcePath).$promise;
		}

		function fetchWorkOrderDiscounts(workOrderID, vehicleID){
			const resourcePath = { 
				companyID: companyID,
				vehicleID: vehicleID,
				workorderID: workOrderID
			};

			return WorkOrderService.getDiscounts(resourcePath).$promise;
		}

		function fetchWorkOrderPayments(workOrderID, vehicleID){
			const resourcePath = { 
				companyID: companyID,
				vehicleID: vehicleID,
				workorderID: workOrderID
			};

			return WorkOrderService.getPayments(resourcePath).$promise;
		}

		function fetchWorkOrderWarrantyListData(workOrderID, vehicleID){
			const resourcePath = { 
				companyID: companyID,
				vehicleID: vehicleID,
				workorderID: workOrderID
			};

			return WorkOrderService.getWorkOrderWarranties(resourcePath).$promise;
		}

		function fetchWorkOrderPackageListData(workOrderID, vehicleID){
			const resourcePath = { 
				companyID: companyID,
				vehicleID: vehicleID,
				workorderID: workOrderID
			};

			return WorkOrderService.getWorkOrderPackages(resourcePath).$promise
		}

		function fetchMiscfeesData(workOrderID, vehicleID){
			const resourcePath = { 
				companyID: companyID,
				vehicleID: vehicleID,
				workorderID: workOrderID
			};

			return WorkOrderService.getMiscfeestype(resourcePath).$promise
		}

		function fetchRogerDollarRedeemData(workOrderID, vehicleID){
			const resourcePath = { 
				companyID: companyID,
				vehicleID: vehicleID,
				workorderID: workOrderID
			};

			return WorkOrderService.getredeemedRD(resourcePath).$promise;
		}

		function getVehicleFilter(){
			var filterString = '';

			if(vm.locationFilter){
				const locationFilter = GeneralTools.equalFilterBuilder("fk_id_location", vm.locationFilter);
				filterString = GeneralTools.stringConnector(filterString, locationFilter, ToolsConstants.apiFilters.andConnector);
			}

			var isSold;

			if(vm.availabilityFilter === true){
				const availabilityFilter = GeneralTools.equalFilterBuilder("purchase_info.is_canceled", false);
				filterString = GeneralTools.stringConnector(filterString, availabilityFilter, ToolsConstants.apiFilters.andConnector);
				isSold = false;
			} else if (vm.availabilityFilter === false) {
				isSold = true;
			}

			if(filterString || isSold != null){
				return { 
					vehicleFilters: filterString, 
					isSold: isSold
				};
			}
		}

		function getWorkorderFilter(){
			var filterString = '';

			if(vm.invoiceNumberFilter){
				const invoiceNumberFilter = GeneralTools.containFilterBuilder(WorkOrderConstants.keyNames.invoiceNumber, vm.invoiceNumberFilter);
				filterString = GeneralTools.stringConnector(filterString, invoiceNumberFilter, ToolsConstants.apiFilters.andConnector);
			}

			if(vm.statusFilter){
				const statusFilter = GeneralTools.equalFilterBuilder(WorkOrderConstants.keyNames.status, vm.statusFilter);
				filterString = GeneralTools.stringConnector(filterString, statusFilter, ToolsConstants.apiFilters.andConnector);
			}

			if(vm.priorityFilter){
				const priorityFilter = GeneralTools.equalFilterBuilder(WorkOrderConstants.keyNames.priority, vm.priorityFilter);
				filterString = GeneralTools.stringConnector(filterString, priorityFilter, ToolsConstants.apiFilters.andConnector);
			}

			if (vm.startDateFilter) {
				filterString = GeneralTools.stringConnector(filterString, getTimeRangeFilter(vm.startDateFilter, false), ToolsConstants.apiFilters.andConnector);
			}

			if (vm.endDateFilter) {
				filterString = GeneralTools.stringConnector(filterString, getTimeRangeFilter(vm.endDateFilter, true), ToolsConstants.apiFilters.andConnector);
			}

			if(filterString){
				return { filters: filterString };
			}
		}

		function resetPagination(headerGetter){
			vm.totalCount = HeaderHelper.getPaginationTotalItem(headerGetter);
			vm.currentPage = HeaderHelper.getPaginationCurrentPage(headerGetter);
		}

		function refreshUrl(){
			const urlParams = {};

			if(vm.itemsPerPage){
				urlParams.limit = vm.itemsPerPage;
			}

			if(vm.currentPage){
				urlParams.page = vm.currentPage;
			}

			if(vm.sortBy){
				urlParams.sortBy = vm.sortBy;
			}

			if(vm.sortDirection){
				urlParams.sortDirection = vm.sortDirection;
			}

			if(vm.invoiceNumberFilter){
				urlParams.invoiceNumber = vm.invoiceNumberFilter;
			}

			if(vm.statusFilter){
				urlParams.status = vm.statusFilter;
			}

			if(vm.priorityFilter){
				urlParams.priority = vm.priorityFilter;
			}

			if(vm.locationFilter){
				urlParams.location = vm.locationFilter;
			}

			if(typeof(vm.availabilityFilter) == "boolean"){
				urlParams.isAvailable = vm.availabilityFilter;
			}

			const startDateMoment = moment(vm.startDateFilter);
			const endDateMoment = moment(vm.endDateFilter);

			if (vm.startDateFilter && startDateMoment.isValid()) {
				urlParams.startDate = startDateMoment.format(dateFormat);
			}

			if (vm.endDateFilter && endDateMoment.isValid()) {
				urlParams.endDate = endDateMoment.format(dateFormat);
			}

			$location.search(urlParams).replace();
		}

		function getPagination(page){
			return {
				page: page,
				limit: vm.itemsPerPage
			}
		}

		function deleteCustomFilter(filter, index){
			if(!filter){
				return;
			}
			var dialogOptions = {};

			dialogOptions.titleString = "Remove Filter";
			dialogOptions.contentString = "Are you sure to remove filter: " + filter.name;

			var confirmOption = {};

			confirmOption.optionName = "YES";
			confirmOption.onClick = function(){
				confirmDeleteCustomFilter(index);
				DialogService.close();
			}

			var cancelOption = {};

			cancelOption.optionName = "NO";
			cancelOption.onClick = function(){
				DialogService.close();
			}

			dialogOptions.options = [confirmOption, cancelOption];

			DialogService.showOptionsDialog(dialogOptions);
		}

		function confirmDeleteCustomFilter(index) {
			const currentPageConfig = userConfig.getPageConfigs(UserConfigConstants.pageKeyNames.browseWorkorders);	

			if(currentPageConfig && Array.isArray(currentPageConfig.filters)){
				currentPageConfig.filters.splice(index, 1);
			}

			userConfig.setPageConfigs(UserConfigConstants.pageKeyNames.browseWorkorders, currentPageConfig);		

			vm.isDeletingCustomFilter = true;
			
			updateUserConfig(userConfig)
				.then(function(){
					vm.customFilters = currentPageConfig.filters;
					MessageService.showToast("Filter is removed.");
				})
				.catch(MessageService.showToast)
				.finally(function(){
					vm.isDeletingCustomFilter = false;
				});
		}

		function applyCustomFilter(filter){
			if(!filter || !filter.filters || isCustomFilterApplied(filter)){
				return;
			}

			vm.statusFilter = filter.filters.status;
			vm.priorityFilter = filter.filters.priority;
			vm.locationFilter = filter.filters.location;
			vm.availabilityFilter = filter.filters.isAvailable;
			refreshWorkorderList(1);
		}

		function isCustomFilterApplied(filter){
			if(!filter || !filter.filters){
				return;
			}

			return vm.statusFilter == filter.filters.status && 
				vm.priorityFilter == filter.filters.priority && 
				vm.locationFilter == filter.filters.location && 
				vm.availabilityFilter == filter.filters.isAvailable
		}

		function addCustomFilter(){
			if(!vm.customFilterName){
				MessageService.showToast("Please enter a filter name.");
				return
			}

			var currentPageConfig = userConfig.getPageConfigs(UserConfigConstants.pageKeyNames.browseWorkorders);

			if(!currentPageConfig){
				currentPageConfig = {};
			}

			if(!Array.isArray(currentPageConfig.filters)){
				currentPageConfig.filters = [];
			}

			currentPageConfig.filters.push({
				name: vm.customFilterName,
				filters:{
					status: vm.statusFilter,
					priority: vm.priorityFilter,
					location: vm.locationFilter,
					isAvailable: vm.availabilityFilter
				}
			});

			userConfig.setPageConfigs(UserConfigConstants.pageKeyNames.browseWorkorders, currentPageConfig);		

			vm.isSavingCustomFilter = true;
			
			updateUserConfig(userConfig)
				.then(function(){
					vm.customFilters = currentPageConfig.filters;
					vm.customFilterName = null;
					MessageService.showToast("New filter is saved.");
				})
				.catch(MessageService.showToast)
				.finally(function(){
					vm.isSavingCustomFilter = false;
				});
		}

		function updateUserConfig(userConfig){
			if(!userConfig){
				return $q.reject("User config invalid");
			}

			const resourcePath = {
				companyID: companyID,
				userID: userID
			}

			const requestBody = {
				config: userConfig.config
			}

			return UserConfigService.updateUserConfig(resourcePath, requestBody);
		}
		
		vm.isSortInvoiceDesc = function(){

			return vm.sortDirection == "DESC"
		}

		vm.toggleSortInvoiceNumber = function(){

			if(vm.sortDirection == ToolsConstants.apiSortingDirections.DESC){
				vm.sortDirection = ToolsConstants.apiSortingDirections.ASC
				refreshWorkorderList(vm.currentPage);
			}else{
				vm.sortDirection = ToolsConstants.apiSortingDirections.DESC
				refreshWorkorderList(vm.currentPage);
			}
		}

		function fetchPendingWarrantyOverallPayment(){
			const resourcePath = { 
				companyID: companyID,
			};

			return WorkOrderService.getPendingWarrantyPaymentOverallPaymentAmount(resourcePath);
		}
	}
})();
(function ()
{
	'use strict';

	angular
		.module('app.workOrders')
		.controller('BrowsePartNoAppointmentWorkOrderController', BrowsePartNoAppointmentWorkOrderController);

	function BrowsePartNoAppointmentWorkOrderController(LoginConst, VehicleService, WorkOrderSummaryCalculator,  $window, DialogService, UserConfigService, UserConfigConstants, userConfig, $q, ToolsConstants, WorkOrderConstants, $location, HeaderHelper, MessageService, WorkOrderService, LoginService, $stateParams, GeneralTools, constants){
		const vm = this;
		const companyID = LoginService.getCompanyID();
		const userID = LoginService.getUserID();

		vm.displayOptions = [10, 20];
		vm.refreshWorkorderList = refreshWorkorderList;
		vm.applyCustomFilter = applyCustomFilter;
		vm.deleteCustomFilter = deleteCustomFilter;
		vm.isCustomFilterApplied = isCustomFilterApplied;
		vm.addCustomFilter = addCustomFilter;
		vm.vehicleMap = {};
		vm.totaloutstanding = 0;
		vm.overall_outstanding = 0;
		const keyNameCompletedDate = "work_order.completed_date";
		const dateFormat = "YYYY-MM-DD";
		vm.initialEnter = true
		vm.isRefreshing = true
		init();

		function init(){
			initConstants();
			initCustomFilters();
			initStateParams();
			refreshWorkorderList(vm.currentPage);
		}

		function initCustomFilters(){
			if(!userConfig){
				return;
			}

			const pageConfig = userConfig.getPageConfigs(UserConfigConstants.pageKeyNames.browseWorkorders);

			if(pageConfig){
				vm.customFilters = pageConfig.filters;
			}	
		}

		function initStateParams(){	
			if(!$stateParams.invoiceNumber && !$stateParams.status && !$stateParams.priority && !$stateParams.priority && $stateParams.isAvailable == null){
				const localPageConfig = LoginService.getPageConfigs(LoginConst.pageConfigKeys.browseWorkorder);

				if(localPageConfig && localPageConfig.filters){
					vm.statusFilter = localPageConfig.filters.status
					vm.priorityFilter = localPageConfig.filters.priority
					vm.locationFilter = localPageConfig.filters.location
					vm.availabilityFilter = localPageConfig.filters.isAvailable
				}
			} else {
				vm.invoiceNumberFilter = GeneralTools.urlStringParamTranslator($stateParams.invoiceNumber);
				vm.statusFilter = GeneralTools.urlNumberParamTranslator($stateParams.status);
				vm.priorityFilter = GeneralTools.urlNumberParamTranslator($stateParams.priority);
				vm.locationFilter = GeneralTools.urlNumberParamTranslator($stateParams.location);
				vm.availabilityFilter = GeneralTools.urlBooleanParamTranslator($stateParams.isAvailable);
			}			

			vm.itemsPerPage = getDisplayOption(GeneralTools.urlNumberParamTranslator($stateParams.limit));
			vm.currentPage = GeneralTools.urlNumberParamTranslator($stateParams.page);

			vm.sortBy = WorkOrderConstants.keyNames.invoiceNumber;//GeneralTools.urlStringParamTranslator($stateParams.sortBy);
			vm.sortDirection = ToolsConstants.apiSortingDirections.DESC;//GeneralTools.urlStringParamTranslator($stateParams.sortDirection);

			vm.startDateFilter = GeneralTools.urlDateParamTranslator($stateParams.startDate);
			vm.endDateFilter = GeneralTools.urlDateParamTranslator($stateParams.endDate);
		}

		function getTimeRangeFilter(dateObj, isBeforeDate) {
			const momentObj = moment(dateObj);

			if (!dateObj || !momentObj.isValid()) {
				return;
			}

			if (isBeforeDate) {
				return GeneralTools.equalOrLesshanFilterBuilder(keyNameCompletedDate, momentObj.format(dateFormat));
			}

			return GeneralTools.equalOrGreaterThanFilterBuilder(keyNameCompletedDate, momentObj.format(dateFormat));
		}


		function initConstants(){
			if(!constants){
				return;
			}

			vm.workOrderStatus = constants.workOrderStatus;
			vm.workOrderPriorities = constants.workOrderPriorities;
			vm.locations = constants.locations;
		}

		function getDisplayOption(itemPerPage){
			if(vm.displayOptions.indexOf(itemPerPage) == -1){
				return vm.displayOptions[0];
			}

			return itemPerPage;
		}

		function refreshWorkorderList(pageToGo){
			vm.totaloutstanding = 0
			vm.overall_outstanding = 0;
			const resourcePath = {
				companyID: companyID
			};

			vm.isFetchingParts = true;

			WorkOrderService.getCompanyLevelIncompletePartWitouthAppointmentWorkOrders(resourcePath, getWorkorderFilter(), getVehicleFilter(), getPagination(pageToGo), getSorting())
			.then(function(result){
				if(!result){
					return $q.reject("Workorder data invalid");
				}

				const vehicleIdList = [];

				vm.workorderList = result.data.map(function(workorder){
					if(!workorder){
						return;
					}

					const workOrderListItem = { 
						workOrder: workorder,
						isLoading: true
					}
					fetchWorkOrderDetails(workOrderListItem);




					if(vehicleIdList.indexOf(workorder.fk_id_vehicle) == -1){
						vehicleIdList.push(workorder.fk_id_vehicle);
					}
					return workOrderListItem;
				});
				vehicleIdList.forEach(function(vehicleID){
					if(!vm.vehicleMap[vehicleID]){
						fetchVehicle(vehicleID);
					}
				});

				resetPagination(result.headerGetter);
				refreshUrl();
				savePageConfigToLocal();
			})
			.then(function(){
				const queue = { 
					warrantyOverallPayment: fetchOverallOutstandingPayment()
				}

				$q.all(queue).then(function(results){
					if(results && results.warrantyOverallPayment){
						vm.overall_outstanding = results.warrantyOverallPayment.overall_amount
					}
				})
			})
			.catch(MessageService.showToast)
			.finally(function(){
				vm.isFetchingParts = false;
			});
			

		}
		function savePageConfigToLocal(){
			var localPageConfig = LoginService.getPageConfigs(LoginConst.pageConfigKeys.browseWorkorder);

			if(!localPageConfig){
				localPageConfig = {};
			}

			if(!localPageConfig.filters){
				localPageConfig.filters = {};
			}

			localPageConfig.filters.status = vm.statusFilter
			localPageConfig.filters.priority = vm.priorityFilter
			localPageConfig.filters.location = vm.locationFilter
			localPageConfig.filters.isAvailable = vm.availabilityFilter

			LoginService.savePageConfigs(LoginConst.pageConfigKeys.browseWorkorder, localPageConfig);
		}

		function getSorting(){
			return {
				sortBy: vm.sortBy,
				sortDirection: vm.sortDirection
			};
		}

		function fetchWorkOrderDetails(workOrderListItem){
			if(!workOrderListItem || !workOrderListItem.workOrder){
				workOrderListItem.isLoading = false;
				return;
			}
			

			const queue = {
				labors: fetchWorkOrderLabors(workOrderListItem.workOrder.id_work_order, workOrderListItem.workOrder.fk_id_vehicle),
				parts: fetchWorkOrderParts(workOrderListItem.workOrder.id_work_order, workOrderListItem.workOrder.fk_id_vehicle),
				inventories: fetchWorkOrderInventories(workOrderListItem.workOrder.id_work_order, workOrderListItem.workOrder.fk_id_vehicle),
				payments: fetchWorkOrderPayments(workOrderListItem.workOrder.id_work_order, workOrderListItem.workOrder.fk_id_vehicle),
				discounts: fetchWorkOrderDiscounts(workOrderListItem.workOrder.id_work_order, workOrderListItem.workOrder.fk_id_vehicle),
				miscfees: fetchMiscfeesData(workOrderListItem.workOrder.id_work_order, workOrderListItem.workOrder.fk_id_vehicle),
				workOrderWarrantyListData: fetchWorkOrderWarrantyListData(workOrderListItem.workOrder.id_work_order, workOrderListItem.workOrder.fk_id_vehicle),
				workOrderPackageListData: fetchWorkOrderPackageListData(workOrderListItem.workOrder.id_work_order, workOrderListItem.workOrder.fk_id_vehicle),
				rogerDollarRedeem: fetchRogerDollarRedeemData(workOrderListItem.workOrder.id_work_order, workOrderListItem.workOrder.fk_id_vehicle),
			};

			$q.all(queue).then(function(results){
					if(!results){
						return $q.reject("Failed to get work order subresource with workOrder id:" + workOrderListItem.workOrder.id_work_order);
					}

					workOrderListItem.labors = results.labors;
					workOrderListItem.parts = results.parts;
					workOrderListItem.inventories = results.inventories;
					workOrderListItem.payments = results.payments;
					workOrderListItem.discounts = results.discounts;

					workOrderListItem.miscfees = results.miscfees;
					workOrderListItem.workOrderWarrantyListData = results.workOrderWarrantyListData;
					workOrderListItem.workOrderPackageListData = results.workOrderPackageListData;
					workOrderListItem.rogerDollarRedeem = results.rogerDollarRedeem;

					refreshList(workOrderListItem)
				})
				.catch(MessageService.showToast)
				.finally(function(){
					workOrderListItem.isLoading = false;
				});
		}

		
		function refreshList(workorderData){
			if(!workorderData){
				return
			}

			const workOrderSummaryCalculator = new WorkOrderSummaryCalculator();

			if(workorderData.workOrder){
				
				workOrderSummaryCalculator.setTaxRate(workorderData.workOrder.tax_rate);
				workOrderSummaryCalculator.setSubsidizedAmount(workorderData.workOrder.subsidized_amount);
				workOrderSummaryCalculator.setSubsidizedPercentage(workorderData.workOrder.subsidized_percentage);
				workOrderSummaryCalculator.setIsSubsidizedByPercentage(workorderData.workOrder.is_subsidized_by_percentage);
			}
			workOrderSummaryCalculator.setParts(workorderData.parts);
			workOrderSummaryCalculator.setInventories(workorderData.inventories);
			workOrderSummaryCalculator.setLabors(workorderData.labors);
			workOrderSummaryCalculator.setDiscounts(workorderData.discounts);
			workOrderSummaryCalculator.setPayments(workorderData.payments);
			workOrderSummaryCalculator.setMiscfees(workorderData.miscfees);
			workOrderSummaryCalculator.setWorkOrderPackageList(workorderData.workOrderPackageListData);
			workOrderSummaryCalculator.setWorkOrderWarrantyList(workorderData.workOrderWarrantyListData);
			workOrderSummaryCalculator.setRDRedeemed(workorderData.rogerDollarRedeem);
			workorderData.partsAndInventories = combinePartsAndInventories(workorderData.parts, workorderData.inventories);

			workorderData.totalPartsRetail = workOrderSummaryCalculator.getPartsAndInventoryTotalRetail();
			workorderData.totalLaborsCost = workOrderSummaryCalculator.getTotalLaborsCost();

			workorderData.outstanding = workOrderSummaryCalculator.getOutstanding();

			if(workorderData.outstanding){
				vm.totaloutstanding = vm.totaloutstanding + workorderData.outstanding
			}
			//vm.vehicleOutstandingMap[vehicleID] += workOrderSummaryCalculator.getOutstanding() + 0
	}

	function combinePartsAndInventories(parts, inventories){
		if(!Array.isArray(parts)){
			parts = [];
		}

		if(!Array.isArray(inventories)){
			inventories = [];
		}

		var list = [];

		parts.forEach(function(part){
			list.push({
				name: part.name,
				isFromInventory: false,
				isOrdered: part.is_ordered
			});
		});

		inventories.forEach(function(inventory){
			list.push({
				name: inventory.name,
				isFromInventory: true
			});
		});

		return list;
	}

		function fetchVehicle(vehicleID){
			const resourcePath = {
				companyID: companyID,
				vehicleID: vehicleID
			};

			VehicleService.getVehicle(resourcePath)
				.then(function(result){
					if(!result || !Array.isArray(result.data) || result.data.length != 1 || !result.data[0]){
						return $q.reject("vehicle data invalid.");
					}
					
					vm.vehicleMap[vehicleID] = result.data[0];
				});
		}

		function fetchWorkOrderInventories(workOrderID, vehicleID){
			const resourcePath = { 
				companyID: companyID,
				vehicleID: vehicleID,
				workorderID: workOrderID
			};

			return WorkOrderService.getWorkOrderInventories(resourcePath).$promise
		}

		function fetchWorkOrderParts(workOrderID, vehicleID){
			const resourcePath = { 
				companyID: companyID,
				vehicleID: vehicleID,
				workorderID: workOrderID
			};

			return WorkOrderService.getWorkOrderParts(resourcePath).$promise
		}

		function fetchWorkOrderLabors(workOrderID, vehicleID){
			const resourcePath = { 
				companyID: companyID,
				vehicleID: vehicleID,
				workorderID: workOrderID
			};

			return WorkOrderService.getLabors(resourcePath).$promise;
		}

		function fetchWorkOrderDiscounts(workOrderID, vehicleID){
			const resourcePath = { 
				companyID: companyID,
				vehicleID: vehicleID,
				workorderID: workOrderID
			};

			return WorkOrderService.getDiscounts(resourcePath).$promise;
		}

		function fetchWorkOrderPayments(workOrderID, vehicleID){
			const resourcePath = { 
				companyID: companyID,
				vehicleID: vehicleID,
				workorderID: workOrderID
			};

			return WorkOrderService.getPayments(resourcePath).$promise;
		}

		function fetchWorkOrderWarrantyListData(workOrderID, vehicleID){
			const resourcePath = { 
				companyID: companyID,
				vehicleID: vehicleID,
				workorderID: workOrderID
			};

			return WorkOrderService.getWorkOrderWarranties(resourcePath).$promise;
		}

		function fetchWorkOrderPackageListData(workOrderID, vehicleID){
			const resourcePath = { 
				companyID: companyID,
				vehicleID: vehicleID,
				workorderID: workOrderID
			};

			return WorkOrderService.getWorkOrderPackages(resourcePath).$promise
		}

		function fetchMiscfeesData(workOrderID, vehicleID){
			const resourcePath = { 
				companyID: companyID,
				vehicleID: vehicleID,
				workorderID: workOrderID
			};

			return WorkOrderService.getMiscfeestype(resourcePath).$promise
		}

		function fetchRogerDollarRedeemData(workOrderID, vehicleID){
			const resourcePath = { 
				companyID: companyID,
				vehicleID: vehicleID,
				workorderID: workOrderID
			};

			return WorkOrderService.getredeemedRD(resourcePath).$promise;
		}

		function getVehicleFilter(){
			var filterString = '';

			if(vm.locationFilter){
				const locationFilter = GeneralTools.equalFilterBuilder("fk_id_location", vm.locationFilter);
				filterString = GeneralTools.stringConnector(filterString, locationFilter, ToolsConstants.apiFilters.andConnector);
			}

			var isSold;

			if(vm.availabilityFilter === true){
				const availabilityFilter = GeneralTools.equalFilterBuilder("purchase_info.is_canceled", false);
				filterString = GeneralTools.stringConnector(filterString, availabilityFilter, ToolsConstants.apiFilters.andConnector);
				isSold = false;
			} else if (vm.availabilityFilter === false) {
				isSold = true;
			}

			if(filterString || isSold != null){
				return { 
					vehicleFilters: filterString, 
					isSold: isSold
				};
			}
		}

		function getWorkorderFilter(){

			var filterString = '';

			if(vm.invoiceNumberFilter){
				const invoiceNumberFilter = GeneralTools.containFilterBuilder(WorkOrderConstants.keyNames.invoiceNumber, vm.invoiceNumberFilter);
				filterString = GeneralTools.stringConnector(filterString, invoiceNumberFilter, ToolsConstants.apiFilters.andConnector);
			}

			if(vm.statusFilter){
				const statusFilter = GeneralTools.equalFilterBuilder(WorkOrderConstants.keyNames.status, vm.statusFilter);
				filterString = GeneralTools.stringConnector(filterString, statusFilter, ToolsConstants.apiFilters.andConnector);
			}

			if(vm.priorityFilter){
				const priorityFilter = GeneralTools.equalFilterBuilder(WorkOrderConstants.keyNames.priority, vm.priorityFilter);
				filterString = GeneralTools.stringConnector(filterString, priorityFilter, ToolsConstants.apiFilters.andConnector);
			}

			if (vm.startDateFilter) {
				filterString = GeneralTools.stringConnector(filterString, getTimeRangeFilter(vm.startDateFilter, false), ToolsConstants.apiFilters.andConnector);
			}

			if (vm.endDateFilter) {
				filterString = GeneralTools.stringConnector(filterString, getTimeRangeFilter(vm.endDateFilter, true), ToolsConstants.apiFilters.andConnector);
			}

			if(filterString){
				return { filters: filterString };
			}
		}

		function resetPagination(headerGetter){
			vm.totalCount = HeaderHelper.getPaginationTotalItem(headerGetter);
			vm.currentPage = HeaderHelper.getPaginationCurrentPage(headerGetter);
		}

		function refreshUrl(){
			const urlParams = {};

			if(vm.itemsPerPage){
				urlParams.limit = vm.itemsPerPage;
			}

			if(vm.currentPage){
				urlParams.page = vm.currentPage;
			}

			if(vm.sortBy){
				urlParams.sortBy = vm.sortBy;
			}

			if(vm.sortDirection){
				urlParams.sortDirection = vm.sortDirection;
			}

			if(vm.invoiceNumberFilter){
				urlParams.invoiceNumber = vm.invoiceNumberFilter;
			}

			if(vm.statusFilter){
				urlParams.status = vm.statusFilter;
			}

			if(vm.priorityFilter){
				urlParams.priority = vm.priorityFilter;
			}

			if(vm.locationFilter){
				urlParams.location = vm.locationFilter;
			}

			if(typeof(vm.availabilityFilter) == "boolean"){
				urlParams.isAvailable = vm.availabilityFilter;
			}

			const startDateMoment = moment(vm.startDateFilter);
			const endDateMoment = moment(vm.endDateFilter);

			if (vm.startDateFilter && startDateMoment.isValid()) {
				urlParams.startDate = startDateMoment.format(dateFormat);
			}

			if (vm.endDateFilter && endDateMoment.isValid()) {
				urlParams.endDate = endDateMoment.format(dateFormat);
			}

			$location.search(urlParams).replace();
		}

		function getPagination(page){
			return {
				page: page,
				limit: vm.itemsPerPage
			}
		}

		function deleteCustomFilter(filter, index){
			if(!filter){
				return;
			}
			var dialogOptions = {};

			dialogOptions.titleString = "Remove Filter";
			dialogOptions.contentString = "Are you sure to remove filter: " + filter.name;

			var confirmOption = {};

			confirmOption.optionName = "YES";
			confirmOption.onClick = function(){
				confirmDeleteCustomFilter(index);
				DialogService.close();
			}

			var cancelOption = {};

			cancelOption.optionName = "NO";
			cancelOption.onClick = function(){
				DialogService.close();
			}

			dialogOptions.options = [confirmOption, cancelOption];

			DialogService.showOptionsDialog(dialogOptions);
		}

		function confirmDeleteCustomFilter(index) {
			const currentPageConfig = userConfig.getPageConfigs(UserConfigConstants.pageKeyNames.browseWorkorders);	

			if(currentPageConfig && Array.isArray(currentPageConfig.filters)){
				currentPageConfig.filters.splice(index, 1);
			}

			userConfig.setPageConfigs(UserConfigConstants.pageKeyNames.browseWorkorders, currentPageConfig);		

			vm.isDeletingCustomFilter = true;
			
			updateUserConfig(userConfig)
				.then(function(){
					vm.customFilters = currentPageConfig.filters;
					MessageService.showToast("Filter is removed.");
				})
				.catch(MessageService.showToast)
				.finally(function(){
					vm.isDeletingCustomFilter = false;
				});
		}

		function applyCustomFilter(filter){
			if(!filter || !filter.filters || isCustomFilterApplied(filter)){
				return;
			}

			vm.statusFilter = filter.filters.status;
			vm.priorityFilter = filter.filters.priority;
			vm.locationFilter = filter.filters.location;
			vm.availabilityFilter = filter.filters.isAvailable;
			refreshWorkorderList(1);
		}

		function isCustomFilterApplied(filter){
			if(!filter || !filter.filters){
				return;
			}

			return vm.statusFilter == filter.filters.status && 
				vm.priorityFilter == filter.filters.priority && 
				vm.locationFilter == filter.filters.location && 
				vm.availabilityFilter == filter.filters.isAvailable
		}

		function addCustomFilter(){
			if(!vm.customFilterName){
				MessageService.showToast("Please enter a filter name.");
				return
			}

			var currentPageConfig = userConfig.getPageConfigs(UserConfigConstants.pageKeyNames.browseWorkorders);

			if(!currentPageConfig){
				currentPageConfig = {};
			}

			if(!Array.isArray(currentPageConfig.filters)){
				currentPageConfig.filters = [];
			}

			currentPageConfig.filters.push({
				name: vm.customFilterName,
				filters:{
					status: vm.statusFilter,
					priority: vm.priorityFilter,
					location: vm.locationFilter,
					isAvailable: vm.availabilityFilter
				}
			});

			userConfig.setPageConfigs(UserConfigConstants.pageKeyNames.browseWorkorders, currentPageConfig);		

			vm.isSavingCustomFilter = true;
			
			updateUserConfig(userConfig)
				.then(function(){
					vm.customFilters = currentPageConfig.filters;
					vm.customFilterName = null;
					MessageService.showToast("New filter is saved.");
				})
				.catch(MessageService.showToast)
				.finally(function(){
					vm.isSavingCustomFilter = false;
				});
		}

		function updateUserConfig(userConfig){
			if(!userConfig){
				return $q.reject("User config invalid");
			}

			const resourcePath = {
				companyID: companyID,
				userID: userID
			}

			const requestBody = {
				config: userConfig.config
			}

			return UserConfigService.updateUserConfig(resourcePath, requestBody);
		}

		vm.isSortInvoiceDesc = function(){

			return vm.sortDirection == "DESC"
		}

		vm.toggleSortInvoiceNumber = function(){

			if(vm.sortDirection == ToolsConstants.apiSortingDirections.DESC){
				vm.sortDirection = ToolsConstants.apiSortingDirections.ASC
				refreshWorkorderList(vm.currentPage);
			}else{
				vm.sortDirection = ToolsConstants.apiSortingDirections.DESC
				refreshWorkorderList(vm.currentPage);
			}
		}

		function fetchOverallOutstandingPayment(){
			const resourcePath = { 
				companyID: companyID,
			};

			return WorkOrderService.getOutstandingOverallPaymentAmount(resourcePath);
		}

		function fetchGetReconstructOustandingReportTable(){
			// if(vm.initialEnter){
			// 	const resourcePath = { 
			// 		companyID: companyID,
			// 	};
			// 	vm.initialEnter = false
			// 	return WorkOrderService.getReconstructOustandingReportTable(resourcePath);
			// }else{
			// 	return true
			// }

				const resourcePath = { 
					companyID: companyID,
				};
			return WorkOrderService.getReconstructOustandingReportTable(resourcePath);

		}

		vm.reloadOutstandingReportTable = function(){
			vm.isRefreshing = false;
			$q.all({refresh: fetchGetReconstructOustandingReportTable()})
			.then(function(results){
				if(results.refresh){
					vm.isRefreshing = true
				}
			})
			.catch(MessageService.showToast)
			.finally(function(){
				$window.location.reload();
			});
		}
	}
})();
(function ()
{
	'use strict';

	angular
		.module('app.workOrders')
		.controller('BrowsePartAppointmentWorkOrderController', BrowsePartAppointmentWorkOrderController);

	function BrowsePartAppointmentWorkOrderController(LoginConst, VehicleService, WorkOrderSummaryCalculator,  $window, DialogService, UserConfigService, UserConfigConstants, userConfig, $q, ToolsConstants, WorkOrderConstants, $location, HeaderHelper, MessageService, WorkOrderService, LoginService, $stateParams, GeneralTools, constants){
		const vm = this;
		const companyID = LoginService.getCompanyID();
		const userID = LoginService.getUserID();

		vm.displayOptions = [10, 20];
		vm.refreshWorkorderList = refreshWorkorderList;
		vm.applyCustomFilter = applyCustomFilter;
		vm.deleteCustomFilter = deleteCustomFilter;
		vm.isCustomFilterApplied = isCustomFilterApplied;
		vm.addCustomFilter = addCustomFilter;
		vm.vehicleMap = {};
		vm.totaloutstanding = 0;
		vm.overall_outstanding = 0;
		const keyNameCompletedDate = "work_order.completed_date";
		const dateFormat = "YYYY-MM-DD";
		vm.initialEnter = true
		vm.isRefreshing = true
		init();

		function init(){
			initConstants();
			initCustomFilters();
			initStateParams();
			refreshWorkorderList(vm.currentPage);
		}

		function initCustomFilters(){
			if(!userConfig){
				return;
			}

			const pageConfig = userConfig.getPageConfigs(UserConfigConstants.pageKeyNames.browseWorkorders);

			if(pageConfig){
				vm.customFilters = pageConfig.filters;
			}	
		}

		function initStateParams(){	
			if(!$stateParams.invoiceNumber && !$stateParams.status && !$stateParams.priority && !$stateParams.priority && $stateParams.isAvailable == null){
				const localPageConfig = LoginService.getPageConfigs(LoginConst.pageConfigKeys.browseWorkorder);

				if(localPageConfig && localPageConfig.filters){
					vm.statusFilter = localPageConfig.filters.status
					vm.priorityFilter = localPageConfig.filters.priority
					vm.locationFilter = localPageConfig.filters.location
					vm.availabilityFilter = localPageConfig.filters.isAvailable
				}
			} else {
				vm.invoiceNumberFilter = GeneralTools.urlStringParamTranslator($stateParams.invoiceNumber);
				vm.statusFilter = GeneralTools.urlNumberParamTranslator($stateParams.status);
				vm.priorityFilter = GeneralTools.urlNumberParamTranslator($stateParams.priority);
				vm.locationFilter = GeneralTools.urlNumberParamTranslator($stateParams.location);
				vm.availabilityFilter = GeneralTools.urlBooleanParamTranslator($stateParams.isAvailable);
			}			

			vm.itemsPerPage = getDisplayOption(GeneralTools.urlNumberParamTranslator($stateParams.limit));
			vm.currentPage = GeneralTools.urlNumberParamTranslator($stateParams.page);

			vm.sortBy = WorkOrderConstants.keyNames.invoiceNumber;//GeneralTools.urlStringParamTranslator($stateParams.sortBy);
			vm.sortDirection = ToolsConstants.apiSortingDirections.DESC;//GeneralTools.urlStringParamTranslator($stateParams.sortDirection);

			vm.startDateFilter = GeneralTools.urlDateParamTranslator($stateParams.startDate);
			vm.endDateFilter = GeneralTools.urlDateParamTranslator($stateParams.endDate);
		}

		function getTimeRangeFilter(dateObj, isBeforeDate) {
			const momentObj = moment(dateObj);

			if (!dateObj || !momentObj.isValid()) {
				return;
			}

			if (isBeforeDate) {
				return GeneralTools.equalOrLesshanFilterBuilder(keyNameCompletedDate, momentObj.format(dateFormat));
			}

			return GeneralTools.equalOrGreaterThanFilterBuilder(keyNameCompletedDate, momentObj.format(dateFormat));
		}


		function initConstants(){
			if(!constants){
				return;
			}

			vm.workOrderStatus = constants.workOrderStatus;
			vm.workOrderPriorities = constants.workOrderPriorities;
			vm.locations = constants.locations;
		}

		function getDisplayOption(itemPerPage){
			if(vm.displayOptions.indexOf(itemPerPage) == -1){
				return vm.displayOptions[0];
			}

			return itemPerPage;
		}

		function refreshWorkorderList(pageToGo){
			vm.totaloutstanding = 0
			vm.overall_outstanding = 0;
			const resourcePath = {
				companyID: companyID
			};

			vm.isFetchingParts = true;

			WorkOrderService.getCompanyLevelIncompletePartWithAppointmentWorkOrders(resourcePath, getWorkorderFilter(), getVehicleFilter(), getPagination(pageToGo), getSorting())
			.then(function(result){
				if(!result){
					return $q.reject("Workorder data invalid");
				}

				const vehicleIdList = [];

				vm.workorderList = result.data.map(function(workorder){
					if(!workorder){
						return;
					}

					const workOrderListItem = { 
						workOrder: workorder,
						isLoading: true
					}
					fetchWorkOrderDetails(workOrderListItem);




					if(vehicleIdList.indexOf(workorder.fk_id_vehicle) == -1){
						vehicleIdList.push(workorder.fk_id_vehicle);
					}
					return workOrderListItem;
				});
				vehicleIdList.forEach(function(vehicleID){
					if(!vm.vehicleMap[vehicleID]){
						fetchVehicle(vehicleID);
					}
				});

				resetPagination(result.headerGetter);
				refreshUrl();
				savePageConfigToLocal();
			})
			.then(function(){
				const queue = { 
					warrantyOverallPayment: fetchOverallOutstandingPayment()
				}

				$q.all(queue).then(function(results){
					if(results && results.warrantyOverallPayment){
						vm.overall_outstanding = results.warrantyOverallPayment.overall_amount
					}
				})
			})
			.catch(MessageService.showToast)
			.finally(function(){
				vm.isFetchingParts = false;
			});
			

		}
		function savePageConfigToLocal(){
			var localPageConfig = LoginService.getPageConfigs(LoginConst.pageConfigKeys.browseWorkorder);

			if(!localPageConfig){
				localPageConfig = {};
			}

			if(!localPageConfig.filters){
				localPageConfig.filters = {};
			}

			localPageConfig.filters.status = vm.statusFilter
			localPageConfig.filters.priority = vm.priorityFilter
			localPageConfig.filters.location = vm.locationFilter
			localPageConfig.filters.isAvailable = vm.availabilityFilter

			LoginService.savePageConfigs(LoginConst.pageConfigKeys.browseWorkorder, localPageConfig);
		}

		function getSorting(){
			return {
				sortBy: vm.sortBy,
				sortDirection: vm.sortDirection
			};
		}

		function fetchWorkOrderDetails(workOrderListItem){
			if(!workOrderListItem || !workOrderListItem.workOrder){
				workOrderListItem.isLoading = false;
				return;
			}
			

			const queue = {
				labors: fetchWorkOrderLabors(workOrderListItem.workOrder.id_work_order, workOrderListItem.workOrder.fk_id_vehicle),
				parts: fetchWorkOrderParts(workOrderListItem.workOrder.id_work_order, workOrderListItem.workOrder.fk_id_vehicle),
				inventories: fetchWorkOrderInventories(workOrderListItem.workOrder.id_work_order, workOrderListItem.workOrder.fk_id_vehicle),
				payments: fetchWorkOrderPayments(workOrderListItem.workOrder.id_work_order, workOrderListItem.workOrder.fk_id_vehicle),
				discounts: fetchWorkOrderDiscounts(workOrderListItem.workOrder.id_work_order, workOrderListItem.workOrder.fk_id_vehicle),
				miscfees: fetchMiscfeesData(workOrderListItem.workOrder.id_work_order, workOrderListItem.workOrder.fk_id_vehicle),
				workOrderWarrantyListData: fetchWorkOrderWarrantyListData(workOrderListItem.workOrder.id_work_order, workOrderListItem.workOrder.fk_id_vehicle),
				workOrderPackageListData: fetchWorkOrderPackageListData(workOrderListItem.workOrder.id_work_order, workOrderListItem.workOrder.fk_id_vehicle),
				rogerDollarRedeem: fetchRogerDollarRedeemData(workOrderListItem.workOrder.id_work_order, workOrderListItem.workOrder.fk_id_vehicle),
			};

			$q.all(queue).then(function(results){
					if(!results){
						return $q.reject("Failed to get work order subresource with workOrder id:" + workOrderListItem.workOrder.id_work_order);
					}

					workOrderListItem.labors = results.labors;
					workOrderListItem.parts = results.parts;
					workOrderListItem.inventories = results.inventories;
					workOrderListItem.payments = results.payments;
					workOrderListItem.discounts = results.discounts;

					workOrderListItem.miscfees = results.miscfees;
					workOrderListItem.workOrderWarrantyListData = results.workOrderWarrantyListData;
					workOrderListItem.workOrderPackageListData = results.workOrderPackageListData;
					workOrderListItem.rogerDollarRedeem = results.rogerDollarRedeem;

					refreshList(workOrderListItem)
				})
				.catch(MessageService.showToast)
				.finally(function(){
					workOrderListItem.isLoading = false;
				});
		}

		
		function refreshList(workorderData){
			if(!workorderData){
				return
			}

			const workOrderSummaryCalculator = new WorkOrderSummaryCalculator();

			if(workorderData.workOrder){
				
				workOrderSummaryCalculator.setTaxRate(workorderData.workOrder.tax_rate);
				workOrderSummaryCalculator.setSubsidizedAmount(workorderData.workOrder.subsidized_amount);
				workOrderSummaryCalculator.setSubsidizedPercentage(workorderData.workOrder.subsidized_percentage);
				workOrderSummaryCalculator.setIsSubsidizedByPercentage(workorderData.workOrder.is_subsidized_by_percentage);
			}
			workOrderSummaryCalculator.setParts(workorderData.parts);
			workOrderSummaryCalculator.setInventories(workorderData.inventories);
			workOrderSummaryCalculator.setLabors(workorderData.labors);
			workOrderSummaryCalculator.setDiscounts(workorderData.discounts);
			workOrderSummaryCalculator.setPayments(workorderData.payments);
			workOrderSummaryCalculator.setMiscfees(workorderData.miscfees);
			workOrderSummaryCalculator.setWorkOrderPackageList(workorderData.workOrderPackageListData);
			workOrderSummaryCalculator.setWorkOrderWarrantyList(workorderData.workOrderWarrantyListData);
			workOrderSummaryCalculator.setRDRedeemed(workorderData.rogerDollarRedeem);
			workorderData.partsAndInventories = combinePartsAndInventories(workorderData.parts, workorderData.inventories);

			workorderData.totalPartsRetail = workOrderSummaryCalculator.getPartsAndInventoryTotalRetail();
			workorderData.totalLaborsCost = workOrderSummaryCalculator.getTotalLaborsCost();

			workorderData.outstanding = workOrderSummaryCalculator.getOutstanding();

			if(workorderData.outstanding){
				vm.totaloutstanding = vm.totaloutstanding + workorderData.outstanding
			}
			//vm.vehicleOutstandingMap[vehicleID] += workOrderSummaryCalculator.getOutstanding() + 0
	}

	function combinePartsAndInventories(parts, inventories){
		if(!Array.isArray(parts)){
			parts = [];
		}

		if(!Array.isArray(inventories)){
			inventories = [];
		}

		var list = [];

		parts.forEach(function(part){
			list.push({
				name: part.name,
				isFromInventory: false,
				isOrdered: part.is_ordered
			});
		});

		inventories.forEach(function(inventory){
			list.push({
				name: inventory.name,
				isFromInventory: true
			});
		});

		return list;
	}

		function fetchVehicle(vehicleID){
			const resourcePath = {
				companyID: companyID,
				vehicleID: vehicleID
			};

			VehicleService.getVehicle(resourcePath)
				.then(function(result){
					if(!result || !Array.isArray(result.data) || result.data.length != 1 || !result.data[0]){
						return $q.reject("vehicle data invalid.");
					}
					
					vm.vehicleMap[vehicleID] = result.data[0];
				});
		}

		function fetchWorkOrderInventories(workOrderID, vehicleID){
			const resourcePath = { 
				companyID: companyID,
				vehicleID: vehicleID,
				workorderID: workOrderID
			};

			return WorkOrderService.getWorkOrderInventories(resourcePath).$promise
		}

		function fetchWorkOrderParts(workOrderID, vehicleID){
			const resourcePath = { 
				companyID: companyID,
				vehicleID: vehicleID,
				workorderID: workOrderID
			};

			return WorkOrderService.getWorkOrderParts(resourcePath).$promise
		}

		function fetchWorkOrderLabors(workOrderID, vehicleID){
			const resourcePath = { 
				companyID: companyID,
				vehicleID: vehicleID,
				workorderID: workOrderID
			};

			return WorkOrderService.getLabors(resourcePath).$promise;
		}

		function fetchWorkOrderDiscounts(workOrderID, vehicleID){
			const resourcePath = { 
				companyID: companyID,
				vehicleID: vehicleID,
				workorderID: workOrderID
			};

			return WorkOrderService.getDiscounts(resourcePath).$promise;
		}

		function fetchWorkOrderPayments(workOrderID, vehicleID){
			const resourcePath = { 
				companyID: companyID,
				vehicleID: vehicleID,
				workorderID: workOrderID
			};

			return WorkOrderService.getPayments(resourcePath).$promise;
		}

		function fetchWorkOrderWarrantyListData(workOrderID, vehicleID){
			const resourcePath = { 
				companyID: companyID,
				vehicleID: vehicleID,
				workorderID: workOrderID
			};

			return WorkOrderService.getWorkOrderWarranties(resourcePath).$promise;
		}

		function fetchWorkOrderPackageListData(workOrderID, vehicleID){
			const resourcePath = { 
				companyID: companyID,
				vehicleID: vehicleID,
				workorderID: workOrderID
			};

			return WorkOrderService.getWorkOrderPackages(resourcePath).$promise
		}

		function fetchMiscfeesData(workOrderID, vehicleID){
			const resourcePath = { 
				companyID: companyID,
				vehicleID: vehicleID,
				workorderID: workOrderID
			};

			return WorkOrderService.getMiscfeestype(resourcePath).$promise
		}

		function fetchRogerDollarRedeemData(workOrderID, vehicleID){
			const resourcePath = { 
				companyID: companyID,
				vehicleID: vehicleID,
				workorderID: workOrderID
			};

			return WorkOrderService.getredeemedRD(resourcePath).$promise;
		}

		function getVehicleFilter(){
			var filterString = '';

			if(vm.locationFilter){
				const locationFilter = GeneralTools.equalFilterBuilder("fk_id_location", vm.locationFilter);
				filterString = GeneralTools.stringConnector(filterString, locationFilter, ToolsConstants.apiFilters.andConnector);
			}

			var isSold;

			if(vm.availabilityFilter === true){
				const availabilityFilter = GeneralTools.equalFilterBuilder("purchase_info.is_canceled", false);
				filterString = GeneralTools.stringConnector(filterString, availabilityFilter, ToolsConstants.apiFilters.andConnector);
				isSold = false;
			} else if (vm.availabilityFilter === false) {
				isSold = true;
			}

			if(filterString || isSold != null){
				return { 
					vehicleFilters: filterString, 
					isSold: isSold
				};
			}
		}

		function getWorkorderFilter(){
			var filterString = '';

			if(vm.invoiceNumberFilter){
				const invoiceNumberFilter = GeneralTools.containFilterBuilder(WorkOrderConstants.keyNames.invoiceNumber, vm.invoiceNumberFilter);
				filterString = GeneralTools.stringConnector(filterString, invoiceNumberFilter, ToolsConstants.apiFilters.andConnector);
			}

			if(vm.statusFilter){
				const statusFilter = GeneralTools.equalFilterBuilder(WorkOrderConstants.keyNames.status, vm.statusFilter);
				filterString = GeneralTools.stringConnector(filterString, statusFilter, ToolsConstants.apiFilters.andConnector);
			}

			if(vm.priorityFilter){
				const priorityFilter = GeneralTools.equalFilterBuilder(WorkOrderConstants.keyNames.priority, vm.priorityFilter);
				filterString = GeneralTools.stringConnector(filterString, priorityFilter, ToolsConstants.apiFilters.andConnector);
			}

			if (vm.startDateFilter) {
				filterString = GeneralTools.stringConnector(filterString, getTimeRangeFilter(vm.startDateFilter, false), ToolsConstants.apiFilters.andConnector);
			}

			if (vm.endDateFilter) {
				filterString = GeneralTools.stringConnector(filterString, getTimeRangeFilter(vm.endDateFilter, true), ToolsConstants.apiFilters.andConnector);
			}

			if(filterString){
				return { filters: filterString };
			}
		}

		function resetPagination(headerGetter){
			vm.totalCount = HeaderHelper.getPaginationTotalItem(headerGetter);
			vm.currentPage = HeaderHelper.getPaginationCurrentPage(headerGetter);
		}

		function refreshUrl(){
			const urlParams = {};

			if(vm.itemsPerPage){
				urlParams.limit = vm.itemsPerPage;
			}

			if(vm.currentPage){
				urlParams.page = vm.currentPage;
			}

			if(vm.sortBy){
				urlParams.sortBy = vm.sortBy;
			}

			if(vm.sortDirection){
				urlParams.sortDirection = vm.sortDirection;
			}

			if(vm.invoiceNumberFilter){
				urlParams.invoiceNumber = vm.invoiceNumberFilter;
			}

			if(vm.statusFilter){
				urlParams.status = vm.statusFilter;
			}

			if(vm.priorityFilter){
				urlParams.priority = vm.priorityFilter;
			}

			if(vm.locationFilter){
				urlParams.location = vm.locationFilter;
			}

			if(typeof(vm.availabilityFilter) == "boolean"){
				urlParams.isAvailable = vm.availabilityFilter;
			}

			const startDateMoment = moment(vm.startDateFilter);
			const endDateMoment = moment(vm.endDateFilter);

			if (vm.startDateFilter && startDateMoment.isValid()) {
				urlParams.startDate = startDateMoment.format(dateFormat);
			}

			if (vm.endDateFilter && endDateMoment.isValid()) {
				urlParams.endDate = endDateMoment.format(dateFormat);
			}

			$location.search(urlParams).replace();
		}

		function getPagination(page){
			return {
				page: page,
				limit: vm.itemsPerPage
			}
		}

		function deleteCustomFilter(filter, index){
			if(!filter){
				return;
			}
			var dialogOptions = {};

			dialogOptions.titleString = "Remove Filter";
			dialogOptions.contentString = "Are you sure to remove filter: " + filter.name;

			var confirmOption = {};

			confirmOption.optionName = "YES";
			confirmOption.onClick = function(){
				confirmDeleteCustomFilter(index);
				DialogService.close();
			}

			var cancelOption = {};

			cancelOption.optionName = "NO";
			cancelOption.onClick = function(){
				DialogService.close();
			}

			dialogOptions.options = [confirmOption, cancelOption];

			DialogService.showOptionsDialog(dialogOptions);
		}

		function confirmDeleteCustomFilter(index) {
			const currentPageConfig = userConfig.getPageConfigs(UserConfigConstants.pageKeyNames.browseWorkorders);	

			if(currentPageConfig && Array.isArray(currentPageConfig.filters)){
				currentPageConfig.filters.splice(index, 1);
			}

			userConfig.setPageConfigs(UserConfigConstants.pageKeyNames.browseWorkorders, currentPageConfig);		

			vm.isDeletingCustomFilter = true;
			
			updateUserConfig(userConfig)
				.then(function(){
					vm.customFilters = currentPageConfig.filters;
					MessageService.showToast("Filter is removed.");
				})
				.catch(MessageService.showToast)
				.finally(function(){
					vm.isDeletingCustomFilter = false;
				});
		}

		function applyCustomFilter(filter){
			if(!filter || !filter.filters || isCustomFilterApplied(filter)){
				return;
			}

			vm.statusFilter = filter.filters.status;
			vm.priorityFilter = filter.filters.priority;
			vm.locationFilter = filter.filters.location;
			vm.availabilityFilter = filter.filters.isAvailable;
			refreshWorkorderList(1);
		}

		function isCustomFilterApplied(filter){
			if(!filter || !filter.filters){
				return;
			}

			return vm.statusFilter == filter.filters.status && 
				vm.priorityFilter == filter.filters.priority && 
				vm.locationFilter == filter.filters.location && 
				vm.availabilityFilter == filter.filters.isAvailable
		}

		function addCustomFilter(){
			if(!vm.customFilterName){
				MessageService.showToast("Please enter a filter name.");
				return
			}

			var currentPageConfig = userConfig.getPageConfigs(UserConfigConstants.pageKeyNames.browseWorkorders);

			if(!currentPageConfig){
				currentPageConfig = {};
			}

			if(!Array.isArray(currentPageConfig.filters)){
				currentPageConfig.filters = [];
			}

			currentPageConfig.filters.push({
				name: vm.customFilterName,
				filters:{
					status: vm.statusFilter,
					priority: vm.priorityFilter,
					location: vm.locationFilter,
					isAvailable: vm.availabilityFilter
				}
			});

			userConfig.setPageConfigs(UserConfigConstants.pageKeyNames.browseWorkorders, currentPageConfig);		

			vm.isSavingCustomFilter = true;
			
			updateUserConfig(userConfig)
				.then(function(){
					vm.customFilters = currentPageConfig.filters;
					vm.customFilterName = null;
					MessageService.showToast("New filter is saved.");
				})
				.catch(MessageService.showToast)
				.finally(function(){
					vm.isSavingCustomFilter = false;
				});
		}

		function updateUserConfig(userConfig){
			if(!userConfig){
				return $q.reject("User config invalid");
			}

			const resourcePath = {
				companyID: companyID,
				userID: userID
			}

			const requestBody = {
				config: userConfig.config
			}

			return UserConfigService.updateUserConfig(resourcePath, requestBody);
		}

		vm.isSortInvoiceDesc = function(){

			return vm.sortDirection == "DESC"
		}

		vm.toggleSortInvoiceNumber = function(){

			if(vm.sortDirection == ToolsConstants.apiSortingDirections.DESC){
				vm.sortDirection = ToolsConstants.apiSortingDirections.ASC
				refreshWorkorderList(vm.currentPage);
			}else{
				vm.sortDirection = ToolsConstants.apiSortingDirections.DESC
				refreshWorkorderList(vm.currentPage);
			}
		}

		function fetchOverallOutstandingPayment(){
			const resourcePath = { 
				companyID: companyID,
			};

			return WorkOrderService.getOutstandingOverallPaymentAmount(resourcePath);
		}

		function fetchGetReconstructOustandingReportTable(){
			// if(vm.initialEnter){
			// 	const resourcePath = { 
			// 		companyID: companyID,
			// 	};
			// 	vm.initialEnter = false
			// 	return WorkOrderService.getReconstructOustandingReportTable(resourcePath);
			// }else{
			// 	return true
			// }

				const resourcePath = { 
					companyID: companyID,
				};
			return WorkOrderService.getReconstructOustandingReportTable(resourcePath);

		}

		vm.reloadOutstandingReportTable = function(){
			vm.isRefreshing = false;
			$q.all({refresh: fetchGetReconstructOustandingReportTable()})
			.then(function(results){
				if(results.refresh){
					vm.isRefreshing = true
				}
			})
			.catch(MessageService.showToast)
			.finally(function(){
				$window.location.reload();
			});
		}
	}
})();
(function ()
{
	'use strict';

	angular
		.module('app.workOrders')
		.controller('BrowseOutstandingWorkOrderController', BrowseOutstandingWorkOrderController);

	function BrowseOutstandingWorkOrderController(LoginConst, VehicleService, WorkOrderSummaryCalculator,  $window, DialogService, UserConfigService, UserConfigConstants, userConfig, $q, ToolsConstants, WorkOrderConstants, $location, HeaderHelper, MessageService, WorkOrderService, LoginService, $stateParams, GeneralTools, constants){
		const vm = this;
		const companyID = LoginService.getCompanyID();
		const userID = LoginService.getUserID();

		vm.displayOptions = [10, 20];
		vm.refreshWorkorderList = refreshWorkorderList;
		vm.applyCustomFilter = applyCustomFilter;
		vm.deleteCustomFilter = deleteCustomFilter;
		vm.isCustomFilterApplied = isCustomFilterApplied;
		vm.addCustomFilter = addCustomFilter;
		vm.vehicleMap = {};
		vm.totaloutstanding = 0;
		vm.overall_outstanding = 0;
		const keyNameCompletedDate = "work_order.completed_date";
		const dateFormat = "YYYY-MM-DD";
		vm.initialEnter = true
		vm.isRefreshing = true
		init();

		function init(){
			initConstants();
			initCustomFilters();
			initStateParams();
			refreshWorkorderList(vm.currentPage);
		}

		function initCustomFilters(){
			if(!userConfig){
				return;
			}

			const pageConfig = userConfig.getPageConfigs(UserConfigConstants.pageKeyNames.browseWorkorders);

			if(pageConfig){
				vm.customFilters = pageConfig.filters;
			}	
		}

		function initStateParams(){	
			if(!$stateParams.invoiceNumber && !$stateParams.status && !$stateParams.priority && !$stateParams.priority && $stateParams.isAvailable == null){
				const localPageConfig = LoginService.getPageConfigs(LoginConst.pageConfigKeys.browseWorkorder);

				if(localPageConfig && localPageConfig.filters){
					vm.statusFilter = localPageConfig.filters.status
					vm.priorityFilter = localPageConfig.filters.priority
					vm.locationFilter = localPageConfig.filters.location
					vm.availabilityFilter = localPageConfig.filters.isAvailable
				}
			} else {
				vm.invoiceNumberFilter = GeneralTools.urlStringParamTranslator($stateParams.invoiceNumber);
				vm.statusFilter = GeneralTools.urlNumberParamTranslator($stateParams.status);
				vm.priorityFilter = GeneralTools.urlNumberParamTranslator($stateParams.priority);
				vm.locationFilter = GeneralTools.urlNumberParamTranslator($stateParams.location);
				vm.availabilityFilter = GeneralTools.urlBooleanParamTranslator($stateParams.isAvailable);
			}			

			vm.itemsPerPage = getDisplayOption(GeneralTools.urlNumberParamTranslator($stateParams.limit));
			vm.currentPage = GeneralTools.urlNumberParamTranslator($stateParams.page);

			vm.sortBy = WorkOrderConstants.keyNames.invoiceNumber;//GeneralTools.urlStringParamTranslator($stateParams.sortBy);
			vm.sortDirection = ToolsConstants.apiSortingDirections.DESC;//GeneralTools.urlStringParamTranslator($stateParams.sortDirection);

			vm.startDateFilter = GeneralTools.urlDateParamTranslator($stateParams.startDate);
			vm.endDateFilter = GeneralTools.urlDateParamTranslator($stateParams.endDate);
		}

		function getTimeRangeFilter(dateObj, isBeforeDate) {
			const momentObj = moment(dateObj);

			if (!dateObj || !momentObj.isValid()) {
				return;
			}

			if (isBeforeDate) {
				return GeneralTools.equalOrLesshanFilterBuilder(keyNameCompletedDate, momentObj.format(dateFormat));
			}

			return GeneralTools.equalOrGreaterThanFilterBuilder(keyNameCompletedDate, momentObj.format(dateFormat));
		}


		function initConstants(){
			if(!constants){
				return;
			}

			vm.workOrderStatus = constants.workOrderStatus;
			vm.workOrderPriorities = constants.workOrderPriorities;
			vm.locations = constants.locations;
		}

		function getDisplayOption(itemPerPage){
			if(vm.displayOptions.indexOf(itemPerPage) == -1){
				return vm.displayOptions[0];
			}

			return itemPerPage;
		}

		function refreshWorkorderList(pageToGo){
			vm.totaloutstanding = 0
			vm.overall_outstanding = 0;
			const resourcePath = {
				companyID: companyID
			};

			vm.isFetchingParts = true;

			// $q.all({refresh: fetchGetReconstructOustandingReportTable()}).then(function(results){
			// 	WorkOrderService.getCompanyLevelOutstandingWorkOrders(resourcePath, getWorkorderFilter(), getVehicleFilter(), getPagination(pageToGo), getSorting())
			// 	.then(function(result){
			// 		if(!result){
			// 			return $q.reject("Workorder data invalid");
			// 		}

			// 		const vehicleIdList = [];

			// 		vm.workorderList = result.data.map(function(workorder){
			// 			if(!workorder){
			// 				return;
			// 			}

			// 			const workOrderListItem = { 
			// 				workOrder: workorder,
			// 				isLoading: true
			// 			}
			// 			fetchWorkOrderDetails(workOrderListItem);




			// 			if(vehicleIdList.indexOf(workorder.fk_id_vehicle) == -1){
			// 				vehicleIdList.push(workorder.fk_id_vehicle);
			// 			}
			// 			return workOrderListItem;
			// 		});
			// 		vehicleIdList.forEach(function(vehicleID){
			// 			if(!vm.vehicleMap[vehicleID]){
			// 				fetchVehicle(vehicleID);
			// 			}
			// 		});

			// 		resetPagination(result.headerGetter);
			// 		refreshUrl();
			// 		savePageConfigToLocal();
			// 	})
			// 	.then(function(){
			// 		const queue = { 
			// 			warrantyOverallPayment: fetchOverallOutstandingPayment()
			// 		}

			// 		$q.all(queue).then(function(results){
			// 			if(results && results.warrantyOverallPayment){
			// 				vm.overall_outstanding = results.warrantyOverallPayment.overall_amount
			// 			}
			// 		})
			// 	})
			// })


			WorkOrderService.getCompanyLevelOutstandingWorkOrders(resourcePath, getWorkorderFilter(), getVehicleFilter(), getPagination(pageToGo), getSorting())
			.then(function(result){
				if(!result){
					return $q.reject("Workorder data invalid");
				}

				const vehicleIdList = [];

				vm.workorderList = result.data.map(function(workorder){
					if(!workorder){
						return;
					}

					const workOrderListItem = { 
						workOrder: workorder,
						isLoading: true
					}
					fetchWorkOrderDetails(workOrderListItem);




					if(vehicleIdList.indexOf(workorder.fk_id_vehicle) == -1){
						vehicleIdList.push(workorder.fk_id_vehicle);
					}
					return workOrderListItem;
				});
				vehicleIdList.forEach(function(vehicleID){
					if(!vm.vehicleMap[vehicleID]){
						fetchVehicle(vehicleID);
					}
				});

				resetPagination(result.headerGetter);
				refreshUrl();
				savePageConfigToLocal();
			})
			.then(function(){
				const queue = { 
					warrantyOverallPayment: fetchOverallOutstandingPayment()
				}

				$q.all(queue).then(function(results){
					if(results && results.warrantyOverallPayment){
						vm.overall_outstanding = results.warrantyOverallPayment.overall_amount
					}
				})
			})
			.catch(MessageService.showToast)
			.finally(function(){
				vm.isFetchingParts = false;
			});
			

		}
		function savePageConfigToLocal(){
			var localPageConfig = LoginService.getPageConfigs(LoginConst.pageConfigKeys.browseWorkorder);

			if(!localPageConfig){
				localPageConfig = {};
			}

			if(!localPageConfig.filters){
				localPageConfig.filters = {};
			}

			localPageConfig.filters.status = vm.statusFilter
			localPageConfig.filters.priority = vm.priorityFilter
			localPageConfig.filters.location = vm.locationFilter
			localPageConfig.filters.isAvailable = vm.availabilityFilter

			LoginService.savePageConfigs(LoginConst.pageConfigKeys.browseWorkorder, localPageConfig);
		}

		function getSorting(){
			return {
				sortBy: vm.sortBy,
				sortDirection: vm.sortDirection
			};
		}

		function fetchWorkOrderDetails(workOrderListItem){
			if(!workOrderListItem || !workOrderListItem.workOrder){
				workOrderListItem.isLoading = false;
				return;
			}
			

			const queue = {
				labors: fetchWorkOrderLabors(workOrderListItem.workOrder.id_work_order, workOrderListItem.workOrder.fk_id_vehicle),
				parts: fetchWorkOrderParts(workOrderListItem.workOrder.id_work_order, workOrderListItem.workOrder.fk_id_vehicle),
				inventories: fetchWorkOrderInventories(workOrderListItem.workOrder.id_work_order, workOrderListItem.workOrder.fk_id_vehicle),
				payments: fetchWorkOrderPayments(workOrderListItem.workOrder.id_work_order, workOrderListItem.workOrder.fk_id_vehicle),
				discounts: fetchWorkOrderDiscounts(workOrderListItem.workOrder.id_work_order, workOrderListItem.workOrder.fk_id_vehicle),
				miscfees: fetchMiscfeesData(workOrderListItem.workOrder.id_work_order, workOrderListItem.workOrder.fk_id_vehicle),
				workOrderWarrantyListData: fetchWorkOrderWarrantyListData(workOrderListItem.workOrder.id_work_order, workOrderListItem.workOrder.fk_id_vehicle),
				workOrderPackageListData: fetchWorkOrderPackageListData(workOrderListItem.workOrder.id_work_order, workOrderListItem.workOrder.fk_id_vehicle),
				rogerDollarRedeem: fetchRogerDollarRedeemData(workOrderListItem.workOrder.id_work_order, workOrderListItem.workOrder.fk_id_vehicle),
			};

			$q.all(queue).then(function(results){
					if(!results){
						return $q.reject("Failed to get work order subresource with workOrder id:" + workOrderListItem.workOrder.id_work_order);
					}

					workOrderListItem.labors = results.labors;
					workOrderListItem.parts = results.parts;
					workOrderListItem.inventories = results.inventories;
					workOrderListItem.payments = results.payments;
					workOrderListItem.discounts = results.discounts;

					workOrderListItem.miscfees = results.miscfees;
					workOrderListItem.workOrderWarrantyListData = results.workOrderWarrantyListData;
					workOrderListItem.workOrderPackageListData = results.workOrderPackageListData;
					workOrderListItem.rogerDollarRedeem = results.rogerDollarRedeem;

					refreshList(workOrderListItem)
				})
				.catch(MessageService.showToast)
				.finally(function(){
					workOrderListItem.isLoading = false;
				});
		}

		
		function refreshList(workorderData){
			if(!workorderData){
				return
			}

			const workOrderSummaryCalculator = new WorkOrderSummaryCalculator();

			if(workorderData.workOrder){
				
				workOrderSummaryCalculator.setTaxRate(workorderData.workOrder.tax_rate);
				workOrderSummaryCalculator.setSubsidizedAmount(workorderData.workOrder.subsidized_amount);
				workOrderSummaryCalculator.setSubsidizedPercentage(workorderData.workOrder.subsidized_percentage);
				workOrderSummaryCalculator.setIsSubsidizedByPercentage(workorderData.workOrder.is_subsidized_by_percentage);
			}
			workOrderSummaryCalculator.setParts(workorderData.parts);
			workOrderSummaryCalculator.setInventories(workorderData.inventories);
			workOrderSummaryCalculator.setLabors(workorderData.labors);
			workOrderSummaryCalculator.setDiscounts(workorderData.discounts);
			workOrderSummaryCalculator.setPayments(workorderData.payments);
			workOrderSummaryCalculator.setMiscfees(workorderData.miscfees);
			workOrderSummaryCalculator.setWorkOrderPackageList(workorderData.workOrderPackageListData);
			workOrderSummaryCalculator.setWorkOrderWarrantyList(workorderData.workOrderWarrantyListData);
			workOrderSummaryCalculator.setRDRedeemed(workorderData.rogerDollarRedeem);
			workorderData.partsAndInventories = combinePartsAndInventories(workorderData.parts, workorderData.inventories);

			workorderData.totalPartsRetail = workOrderSummaryCalculator.getPartsAndInventoryTotalRetail();
			workorderData.totalLaborsCost = workOrderSummaryCalculator.getTotalLaborsCost();

			workorderData.outstanding = workOrderSummaryCalculator.getOutstanding();

			if(workorderData.outstanding){
				vm.totaloutstanding = vm.totaloutstanding + workorderData.outstanding
			}
			//vm.vehicleOutstandingMap[vehicleID] += workOrderSummaryCalculator.getOutstanding() + 0
	}

	function combinePartsAndInventories(parts, inventories){
		if(!Array.isArray(parts)){
			parts = [];
		}

		if(!Array.isArray(inventories)){
			inventories = [];
		}

		var list = [];

		parts.forEach(function(part){
			list.push({
				name: part.name,
				isFromInventory: false,
				isOrdered: part.is_ordered
			});
		});

		inventories.forEach(function(inventory){
			list.push({
				name: inventory.name,
				isFromInventory: true
			});
		});

		return list;
	}

		function fetchVehicle(vehicleID){
			const resourcePath = {
				companyID: companyID,
				vehicleID: vehicleID
			};

			VehicleService.getVehicle(resourcePath)
				.then(function(result){
					if(!result || !Array.isArray(result.data) || result.data.length != 1 || !result.data[0]){
						return $q.reject("vehicle data invalid.");
					}
					
					vm.vehicleMap[vehicleID] = result.data[0];
				});
		}

		function fetchWorkOrderInventories(workOrderID, vehicleID){
			const resourcePath = { 
				companyID: companyID,
				vehicleID: vehicleID,
				workorderID: workOrderID
			};

			return WorkOrderService.getWorkOrderInventories(resourcePath).$promise
		}

		function fetchWorkOrderParts(workOrderID, vehicleID){
			const resourcePath = { 
				companyID: companyID,
				vehicleID: vehicleID,
				workorderID: workOrderID
			};

			return WorkOrderService.getWorkOrderParts(resourcePath).$promise
		}

		function fetchWorkOrderLabors(workOrderID, vehicleID){
			const resourcePath = { 
				companyID: companyID,
				vehicleID: vehicleID,
				workorderID: workOrderID
			};

			return WorkOrderService.getLabors(resourcePath).$promise;
		}

		function fetchWorkOrderDiscounts(workOrderID, vehicleID){
			const resourcePath = { 
				companyID: companyID,
				vehicleID: vehicleID,
				workorderID: workOrderID
			};

			return WorkOrderService.getDiscounts(resourcePath).$promise;
		}

		function fetchWorkOrderPayments(workOrderID, vehicleID){
			const resourcePath = { 
				companyID: companyID,
				vehicleID: vehicleID,
				workorderID: workOrderID
			};

			return WorkOrderService.getPayments(resourcePath).$promise;
		}

		function fetchWorkOrderWarrantyListData(workOrderID, vehicleID){
			const resourcePath = { 
				companyID: companyID,
				vehicleID: vehicleID,
				workorderID: workOrderID
			};

			return WorkOrderService.getWorkOrderWarranties(resourcePath).$promise;
		}

		function fetchWorkOrderPackageListData(workOrderID, vehicleID){
			const resourcePath = { 
				companyID: companyID,
				vehicleID: vehicleID,
				workorderID: workOrderID
			};

			return WorkOrderService.getWorkOrderPackages(resourcePath).$promise
		}

		function fetchMiscfeesData(workOrderID, vehicleID){
			const resourcePath = { 
				companyID: companyID,
				vehicleID: vehicleID,
				workorderID: workOrderID
			};

			return WorkOrderService.getMiscfeestype(resourcePath).$promise
		}

		function fetchRogerDollarRedeemData(workOrderID, vehicleID){
			const resourcePath = { 
				companyID: companyID,
				vehicleID: vehicleID,
				workorderID: workOrderID
			};

			return WorkOrderService.getredeemedRD(resourcePath).$promise;
		}

		function getVehicleFilter(){
			var filterString = '';

			if(vm.locationFilter){
				const locationFilter = GeneralTools.equalFilterBuilder("fk_id_location", vm.locationFilter);
				filterString = GeneralTools.stringConnector(filterString, locationFilter, ToolsConstants.apiFilters.andConnector);
			}

			var isSold;

			if(vm.availabilityFilter === true){
				const availabilityFilter = GeneralTools.equalFilterBuilder("purchase_info.is_canceled", false);
				filterString = GeneralTools.stringConnector(filterString, availabilityFilter, ToolsConstants.apiFilters.andConnector);
				isSold = false;
			} else if (vm.availabilityFilter === false) {
				isSold = true;
			}

			if(filterString || isSold != null){
				return { 
					vehicleFilters: filterString, 
					isSold: isSold
				};
			}
		}

		function getWorkorderFilter(){
			var filterString = '';

			if(vm.invoiceNumberFilter){
				const invoiceNumberFilter = GeneralTools.containFilterBuilder(WorkOrderConstants.keyNames.invoiceNumber, vm.invoiceNumberFilter);
				filterString = GeneralTools.stringConnector(filterString, invoiceNumberFilter, ToolsConstants.apiFilters.andConnector);
			}

			if(vm.statusFilter){
				const statusFilter = GeneralTools.equalFilterBuilder(WorkOrderConstants.keyNames.status, vm.statusFilter);
				filterString = GeneralTools.stringConnector(filterString, statusFilter, ToolsConstants.apiFilters.andConnector);
			}

			if(vm.priorityFilter){
				const priorityFilter = GeneralTools.equalFilterBuilder(WorkOrderConstants.keyNames.priority, vm.priorityFilter);
				filterString = GeneralTools.stringConnector(filterString, priorityFilter, ToolsConstants.apiFilters.andConnector);
			}

			if (vm.startDateFilter) {
				filterString = GeneralTools.stringConnector(filterString, getTimeRangeFilter(vm.startDateFilter, false), ToolsConstants.apiFilters.andConnector);
			}

			if (vm.endDateFilter) {
				filterString = GeneralTools.stringConnector(filterString, getTimeRangeFilter(vm.endDateFilter, true), ToolsConstants.apiFilters.andConnector);
			}

			if(filterString){
				return { filters: filterString };
			}
		}

		function resetPagination(headerGetter){
			vm.totalCount = HeaderHelper.getPaginationTotalItem(headerGetter);
			vm.currentPage = HeaderHelper.getPaginationCurrentPage(headerGetter);
		}

		function refreshUrl(){
			const urlParams = {};

			if(vm.itemsPerPage){
				urlParams.limit = vm.itemsPerPage;
			}

			if(vm.currentPage){
				urlParams.page = vm.currentPage;
			}

			if(vm.sortBy){
				urlParams.sortBy = vm.sortBy;
			}

			if(vm.sortDirection){
				urlParams.sortDirection = vm.sortDirection;
			}

			if(vm.invoiceNumberFilter){
				urlParams.invoiceNumber = vm.invoiceNumberFilter;
			}

			if(vm.statusFilter){
				urlParams.status = vm.statusFilter;
			}

			if(vm.priorityFilter){
				urlParams.priority = vm.priorityFilter;
			}

			if(vm.locationFilter){
				urlParams.location = vm.locationFilter;
			}

			if(typeof(vm.availabilityFilter) == "boolean"){
				urlParams.isAvailable = vm.availabilityFilter;
			}

			const startDateMoment = moment(vm.startDateFilter);
			const endDateMoment = moment(vm.endDateFilter);

			if (vm.startDateFilter && startDateMoment.isValid()) {
				urlParams.startDate = startDateMoment.format(dateFormat);
			}

			if (vm.endDateFilter && endDateMoment.isValid()) {
				urlParams.endDate = endDateMoment.format(dateFormat);
			}

			$location.search(urlParams).replace();
		}

		function getPagination(page){
			return {
				page: page,
				limit: vm.itemsPerPage
			}
		}

		function deleteCustomFilter(filter, index){
			if(!filter){
				return;
			}
			var dialogOptions = {};

			dialogOptions.titleString = "Remove Filter";
			dialogOptions.contentString = "Are you sure to remove filter: " + filter.name;

			var confirmOption = {};

			confirmOption.optionName = "YES";
			confirmOption.onClick = function(){
				confirmDeleteCustomFilter(index);
				DialogService.close();
			}

			var cancelOption = {};

			cancelOption.optionName = "NO";
			cancelOption.onClick = function(){
				DialogService.close();
			}

			dialogOptions.options = [confirmOption, cancelOption];

			DialogService.showOptionsDialog(dialogOptions);
		}

		function confirmDeleteCustomFilter(index) {
			const currentPageConfig = userConfig.getPageConfigs(UserConfigConstants.pageKeyNames.browseWorkorders);	

			if(currentPageConfig && Array.isArray(currentPageConfig.filters)){
				currentPageConfig.filters.splice(index, 1);
			}

			userConfig.setPageConfigs(UserConfigConstants.pageKeyNames.browseWorkorders, currentPageConfig);		

			vm.isDeletingCustomFilter = true;
			
			updateUserConfig(userConfig)
				.then(function(){
					vm.customFilters = currentPageConfig.filters;
					MessageService.showToast("Filter is removed.");
				})
				.catch(MessageService.showToast)
				.finally(function(){
					vm.isDeletingCustomFilter = false;
				});
		}

		function applyCustomFilter(filter){
			if(!filter || !filter.filters || isCustomFilterApplied(filter)){
				return;
			}

			vm.statusFilter = filter.filters.status;
			vm.priorityFilter = filter.filters.priority;
			vm.locationFilter = filter.filters.location;
			vm.availabilityFilter = filter.filters.isAvailable;
			refreshWorkorderList(1);
		}

		function isCustomFilterApplied(filter){
			if(!filter || !filter.filters){
				return;
			}

			return vm.statusFilter == filter.filters.status && 
				vm.priorityFilter == filter.filters.priority && 
				vm.locationFilter == filter.filters.location && 
				vm.availabilityFilter == filter.filters.isAvailable
		}

		function addCustomFilter(){
			if(!vm.customFilterName){
				MessageService.showToast("Please enter a filter name.");
				return
			}

			var currentPageConfig = userConfig.getPageConfigs(UserConfigConstants.pageKeyNames.browseWorkorders);

			if(!currentPageConfig){
				currentPageConfig = {};
			}

			if(!Array.isArray(currentPageConfig.filters)){
				currentPageConfig.filters = [];
			}

			currentPageConfig.filters.push({
				name: vm.customFilterName,
				filters:{
					status: vm.statusFilter,
					priority: vm.priorityFilter,
					location: vm.locationFilter,
					isAvailable: vm.availabilityFilter
				}
			});

			userConfig.setPageConfigs(UserConfigConstants.pageKeyNames.browseWorkorders, currentPageConfig);		

			vm.isSavingCustomFilter = true;
			
			updateUserConfig(userConfig)
				.then(function(){
					vm.customFilters = currentPageConfig.filters;
					vm.customFilterName = null;
					MessageService.showToast("New filter is saved.");
				})
				.catch(MessageService.showToast)
				.finally(function(){
					vm.isSavingCustomFilter = false;
				});
		}

		function updateUserConfig(userConfig){
			if(!userConfig){
				return $q.reject("User config invalid");
			}

			const resourcePath = {
				companyID: companyID,
				userID: userID
			}

			const requestBody = {
				config: userConfig.config
			}

			return UserConfigService.updateUserConfig(resourcePath, requestBody);
		}

		vm.isSortInvoiceDesc = function(){

			return vm.sortDirection == "DESC"
		}

		vm.toggleSortInvoiceNumber = function(){

			if(vm.sortDirection == ToolsConstants.apiSortingDirections.DESC){
				vm.sortDirection = ToolsConstants.apiSortingDirections.ASC
				refreshWorkorderList(vm.currentPage);
			}else{
				vm.sortDirection = ToolsConstants.apiSortingDirections.DESC
				refreshWorkorderList(vm.currentPage);
			}
		}

		function fetchOverallOutstandingPayment(){
			const resourcePath = { 
				companyID: companyID,
			};

			return WorkOrderService.getOutstandingOverallPaymentAmount(resourcePath);
		}

		function fetchGetReconstructOustandingReportTable(){
			// if(vm.initialEnter){
			// 	const resourcePath = { 
			// 		companyID: companyID,
			// 	};
			// 	vm.initialEnter = false
			// 	return WorkOrderService.getReconstructOustandingReportTable(resourcePath);
			// }else{
			// 	return true
			// }

				const resourcePath = { 
					companyID: companyID,
				};
			return WorkOrderService.getReconstructOustandingReportTable(resourcePath);

		}

		vm.reloadOutstandingReportTable = function(){
			vm.isRefreshing = false;
			$q.all({refresh: fetchGetReconstructOustandingReportTable()})
			.then(function(results){
				if(results.refresh){
					vm.isRefreshing = true
				}
			})
			.catch(MessageService.showToast)
			.finally(function(){
				$window.location.reload();
			});
		}
	}
})();
(function ()
{
	'use strict';

	angular
		.module('app.vehicles', [])
		.constant("VehicleConstants", {
			eventNames:{
				changePurchaseMode:"changePurchaseMode"
			},
			vehicleImagePlaceholder: "assets/images/placeholder-vans.png",
			// These permissions should be fetched from backend in the future.
			permissions:{
				canSeeTasks:["developer", "company_manager", "detailer", "mechanic", "accountant", "sales_manager", "salesman", "advertizing", "vehicle_helper_add", "vehicle_helper_delete", "service_advisor", "mechanic_apprentice"],
				canAddTasks:["developer", "company_manager", "detailer", "mechanic", "accountant", "sales_manager", "salesman", "advertizing", "vehicle_helper_add", "vehicle_helper_delete", "service_advisor", "mechanic_apprentice"],		
				toSaleVehicle: ["developer", "company_manager", "sales_manager", "salesman"],
				canEditVehicle: ["developer", "company_manager", "sales_manager", "salesman", "advertizing", "vehicle_manager", "vehicle_helper_add", "vehicle_helper_delete", "accountant"],
				canSeeSafety:["developer", "company_manager", "service_advisor", "detailer", "mechanic", "salesman", "sales_manager", "mechanic_apprentice"],
				canAddSafety:["developer", "company_manager", "mechanic", "service_advisor", "mechanic_apprentice"],
				canSeeDisclosure: ["developer", "accountant", "mechanic", "salesman", "company_manager", "service_advisor"],
				canSeePurchaseInfo: ["developer", "accountant", "mechanic", "salesman", "company_manager", "service_advisor"],
				canSeeSaleInfo:["developer", "company_manager", "detailer", "mechanic", "accountant", "sales_manager", "salesman", "advertizing", "service_advisor", "mechanic_apprentice"]
			},
			detailPageTabNames:{
				task:"task",
				safety:"safety",
				deliverStatus: "deliverStatus",
				disclosures: "disclosures",
				customers: "customers",
				workorders: "workorders"
			},
			editPageTabNames:{
				generalInfo:"generalInfo",
 				specs:"specs",
 				features:"features",
 				purchaseInfo:"purchaseInfo",
 				advertizing:"advertizing",
 				saleInfo:"saleInfo"
			},
			purchaseSteps:{
				paymentOption:{
					stepName:"paymentOption",
					stepTitle:"Payment Option",
					cashOption:"cash",
					financeOption:"finance"
				},
				personalInfo:{
					stepName:"personalInfo",
					stepTitle:"Personal Info"
				},
				TradeInOption:{
					stepName:"TradeInOption",
					stepTitle:"Trade In Option"
				}
				,
				plateOption:{
					stepName:"plateOption",
					stepTitle:"Plate Option"
				},
				warranty:{
					stepName:"warranty",
					stepTitle:"Warranty"
				},
				extras:{
					stepName:"extras",
					stepTitle:"extras"
				},
				deposit:{
					stepName:"deposit",
					stepTitle:"Deposit"
				}
			}
		})
		.config(config);

	/** @ngInject */
	function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider, loginInfoProvider)
	{	  

		$stateProvider
			.state('app.vehicles', {
				url : '/vehicles?available&searchText&year&make&model&location&priceLevel&mileageLevel&sortBy&sortDirection&enableTimeRangeFilter&timeRangeFilterTag&startDate&endDate',
				reloadOnSearch : false,
				views	: {
					'content@app': {
						templateUrl: 'app/main/vehicles/browse-vehicles/browse-vehicles.html',
						controller : 'BrowseVehicleController as vm'
					}
				},
				resolve :{
					locations:function(MessageService, LoginService, VehicleService, $q){
						if(!LoginService.getUserStatus() || !LoginService.getUserStatus().isLogin){
							return $q.resolve();
						}

						return VehicleService.getCachedLocations({companyID: LoginService.getCompanyID()}).catch(MessageService.showToast);
					},
					basicInventoryInfos:function(MessageService, LoginService, VehicleService, $q){
						const companyID = LoginService.getCompanyID();
						const queue = {year: VehicleService.getInventoryInfos(companyID, null, {columnName:"year"})};

						return $q.all(queue).catch(MessageService.showToast);
					}
				}
			})

			.state('app.vehicle', {
				url	  : '/vehicle/{vehicleID}',
				reloadOnSearch : false,
				views	: {
					'content@app': {
						templateUrl: 'app/main/vehicles/vehicle-details/vehicle-details.html',
						controller : 'VehicleDetailsController as vm'
					}
				},
				resolve:{
					vehicle:function($stateParams, VehicleService, MessageService, LoginService){
						var resourcePath = {
							companyID: LoginService.getCompanyID(),
							vehicleID: $stateParams.vehicleID
						}

						return VehicleService.getVehicle(resourcePath).catch(MessageService.showToast);			
					},
					vehicleImages:function($stateParams, VehicleService, MessageService){
						var vehicleID = $stateParams.vehicleID;
						return VehicleService.getVehicleImages(vehicleID).catch(MessageService.showToast);	
					},
					smallVehicleImages:function($stateParams, VehicleService, MessageService){
						var vehicleID = $stateParams.vehicleID;
						return VehicleService.getVehicleImages(vehicleID, null, 'small').catch(MessageService.showToast);	
					},
					locations:function(MessageService, LoginService, VehicleService, $q){
						if(!LoginService.getUserStatus() || !LoginService.getUserStatus().isLogin){
							return $q.resolve();
						}

						return VehicleService.getCachedLocations({companyID: LoginService.getCompanyID()}).catch(MessageService.showToast);
					},
					purchaseInfos: function($q, $stateParams, MessageService, LoginService, PurchaseInfoService, RoleCheckService, VehicleConstants){
						var companyID = LoginService.getCompanyID();
						var vehicleID = $stateParams.vehicleID;

						if(!LoginService.getUserStatus() || !LoginService.getUserStatus().isLogin || !RoleCheckService.deepCheckRole(VehicleConstants.permissions.canSeePurchaseInfo)){
							return $q.resolve();
						}

						const resourcePath = {
							companyID : companyID,
							vehicleID : vehicleID
						};

						return PurchaseInfoService.getPurchaseInfos(resourcePath).catch(MessageService.showToast);							
					}
				}
			})
			.state('app.vehicle.general', {
				url	  : '/general',
				reloadOnSearch : false,
				views	: {
					'childPage@app.vehicle': {
						templateUrl: 'app/main/vehicles/vehicle-details/vehicle-details-general.html',
						controller : 'VehicleDetailsGeneralController as vm'
					}
				},
				resolve:{
					vehicleFeatures:function($stateParams, VehicleService, MessageService, LoginService){
						var resourcePath = {
							vehicleID : $stateParams.vehicleID,
							companyID: LoginService.getCompanyID()
						}

						return VehicleService.getVehicleFeatures(resourcePath).catch(MessageService.showToast);						
					}
				}
			})
			.state('app.vehicle.purchase', {
				url	  : '/purchase',
				reloadOnSearch : false,
				views	: {
					'childPage@app.vehicle': {
						templateUrl: 'app/main/vehicles/vehicle-details/vehicle-details-purchase.html',
						controller : 'VehicleDetailsPurchaseController as vm'
					}
				},
				resolve:{
					disclosures:function($q, purchaseInfos, $stateParams, LoginService, PurchaseInfoService, MessageService, RoleCheckService, VehicleConstants){
						if(!Array.isArray(purchaseInfos) || !RoleCheckService.deepCheckRole(VehicleConstants.permissions.canSeeDisclosure)){
							return;
						}
						const companyID = LoginService.getCompanyID();
						const queue = [];

						purchaseInfos.forEach(function(purchaseInfo){
							if(!purchaseInfo){
								return;
							}

							var resourcePath = {
								companyID : companyID,
								vehicleID : $stateParams.vehicleID,
								purchaseinfoID: purchaseInfo.getResourceID()
							};

							queue.push(PurchaseInfoService.getPurchaseDisclosures(resourcePath));
						})

						return $q.all(queue).then(function(results){
								if(!Array.isArray(results)){
									return $q.reject("disclosures results invalid.");
								}

								var disclosureList = [];

								results.forEach(function(data){
									disclosureList = disclosureList.concat(data);
								});

								return $q.resolve(disclosureList);
							})
							.catch(MessageService.showToast);
					},
					constants:function(WorkOrderService, $q, LoginService, FinanceApplicationService, CustomersService, SaleInfoService, MessageService){
						var resourcePath = {companyID: LoginService.getCompanyID()};

						const queue = {
							phoneCategories: CustomersService.getCachedPhoneCategories(),
							emailCategories: CustomersService.getCachedEmailCategories(),
							plateOptions: SaleInfoService.getCachedPlateOptions(resourcePath),
							warranties: SaleInfoService.getWarrantyOptions(resourcePath),
							paymentOptions: SaleInfoService.getCachedPaymentOptions(),
							presetExtrasOptions: SaleInfoService.getPresetExtrasOptions(resourcePath),
							paymentMethods: SaleInfoService.getCachedPaymentMethods(),
							workOrderPriorities: WorkOrderService.getCachedWorkOrderPriorities(),
						}

						return $q.all(queue).catch(MessageService.showToast);
					}
				}
			})
			.state('app.vehicle.tasks', {
				url	  : '/tasks?taskStatus&taskUser&taskSearchText&taskPriority&taskCategory',
				reloadOnSearch : false,
				views	: {
					'childPage@app.vehicle': {
						templateUrl: 'app/main/vehicles/vehicle-details/vehicle-details-tasks.html',
						controller : 'VehicleDetailsTasksController as vm'
					}
				},
				resolve:{
					constants:function(TasksService, $q, MessageService){
						const queue = {
							taskCategories: TasksService.getCachedTaskCategories(),
							taskPriorities: TasksService.getCachedTaskPriorities(),
							taskStatus: TasksService.getCachedTaskStatus()
						}

						return $q.all(queue).catch(MessageService.showToast);
					},				
					userOptions:function(MessageService, LoginService, UserService, $q){
						if(!LoginService.getUserStatus() || !LoginService.getUserStatus().isLogin){
							return $q.resolve();
						}

						var resourcePath = {companyID: LoginService.getCompanyID()};
						return UserService.getUsers(resourcePath, null).catch(MessageService.showToast);
					}
				}
			})
			.state('app.vehicle.safety', {
				url	  : '/safety',
				reloadOnSearch : false,
				views	: {
					'childPage@app.vehicle': {
						templateUrl: 'app/main/vehicles/vehicle-details/vehicle-details-safety.html',
						controller : 'VehicleDetailsSafetyController as vm'
					}
				},
				resolve:{
					safeties:function($q, $stateParams, SafetyService, MessageService, LoginService, RoleCheckService){
						if(!LoginService.getUserStatus() || !LoginService.getUserStatus().isLogin){
							return $q.resolve();
						}

						var resourcePath = {
							companyID : LoginService.getCompanyID(),
							vehicleID : $stateParams.vehicleID
						};
						return SafetyService.getSafeties(resourcePath).catch(MessageService.showToast);
					}
				}
			})
			.state('app.vehicle.delivery', {
				url	  : '/delivery',
				reloadOnSearch : false,
				views	: {
					'childPage@app.vehicle': {
						templateUrl: 'app/main/vehicles/vehicle-details/vehicle-details-delivery.html',
						controller : 'VehicleDetailsDeliveryController as vm'
					}
				},
				resolve:{
					constants:function($q, WorkOrderService, MessageService){
						const queue = {
							workOrderPriorities: WorkOrderService.getCachedWorkOrderPriorities(),
						}
						
						return $q.all(queue).catch(MessageService.showToast);
					},
					saleInfos:function($stateParams, SaleInfoService, MessageService, LoginService, $q){
						if(!LoginService.getUserStatus() || !LoginService.getUserStatus().isLogin){
							return $q.resolve();
						}
						
						var resourcePath = {
							companyID : LoginService.getCompanyID(),
							vehicleID : $stateParams.vehicleID
						};

						return SaleInfoService.getVehicleSaleInfos(resourcePath).catch(MessageService.showToast);
					}
				}
			})
			.state('app.vehicle.workorder', {
				url	  : '/workorder',
				reloadOnSearch : false,
				views	: {
					'childPage@app.vehicle': {
						templateUrl: 'app/main/vehicles/vehicle-details/vehicle-details-workorder.html',
						controller : 'VehicleDetailsWorkorderController as vm'
					}
				},
				resolve:{
					constants:function($q, WorkOrderService, MessageService){
						const queue = {
							workOrderStatus: WorkOrderService.getCachedWorkOrderStatus(),
							workOrderPriorities: WorkOrderService.getCachedWorkOrderPriorities(),
						}
						
						return $q.all(queue).catch(MessageService.showToast);
					},
					workorders:function($stateParams, WorkOrderService, MessageService, LoginService, $q, ToolsConstants, WorkOrderConstants){
						if(!LoginService.getUserStatus() || !LoginService.getUserStatus().isLogin){
							return $q.resolve();
						}
						
						var resourcePath = {
							companyID : LoginService.getCompanyID(),
							vehicleID : $stateParams.vehicleID
						};

						const sorting = {
							sortBy: WorkOrderConstants.keyNames.invoiceNumber,
							sortDirection: ToolsConstants.apiSortingDirections.DESC
						}

						return WorkOrderService.getWorkOrders(resourcePath, sorting).$promise.catch(MessageService.showToast);
					}
				}
			})
			.state('app.vehicle.customer', {
				url	  : '/customer?newCustomerID',
				reloadOnSearch : false,
				views	: {
					'childPage@app.vehicle': {
						templateUrl: 'app/main/vehicles/vehicle-details/vehicle-details-customer.html',
						controller : 'VehicleDetailsCustomerController as vm'
					}
				},
				resolve:{
					serviceMap:function(WorkOrderService, MessageService, LoginService, $stateParams, GeneralTools){
						const resourcePath = {
							companyID: LoginService.getCompanyID()
						};

						const filter = {
							filters: GeneralTools.equalFilterBuilder("fk_id_vehicle", $stateParams.vehicleID)
						}

						return WorkOrderService.getAllMatchedServiceMaps(resourcePath, filter).catch(MessageService.showToast);
					},
					saleInfos:function($stateParams, SaleInfoService, MessageService, LoginService, $q){
						if(!LoginService.getUserStatus() || !LoginService.getUserStatus().isLogin){
							return $q.resolve();
						}
						
						var resourcePath = {
							companyID : LoginService.getCompanyID(),
							vehicleID : $stateParams.vehicleID
						};

						return SaleInfoService.getVehicleSaleInfos(resourcePath).catch(MessageService.showToast);
					}
				}
			})
			.state('app.vehicle.other', {
				url	  : '/other',
				reloadOnSearch : false,
				views	: {
					'childPage@app.vehicle': {
						templateUrl: 'app/main/vehicles/vehicle-details/vehicle-details-other.html',
						controller : 'VehicleDetailsOtherController as vm'
					}
				},
				resolve:{
					disclosures:function($q, purchaseInfos, $stateParams, LoginService, PurchaseInfoService, MessageService, RoleCheckService, VehicleConstants){
						if(!Array.isArray(purchaseInfos) || !RoleCheckService.deepCheckRole(VehicleConstants.permissions.canSeeDisclosure)){
							return;
						}
						const companyID = LoginService.getCompanyID();
						const queue = [];

						purchaseInfos.forEach(function(purchaseInfo){
							if(!purchaseInfo){
								return;
							}

							var resourcePath = {
								companyID : companyID,
								vehicleID : $stateParams.vehicleID,
								purchaseinfoID: purchaseInfo.getResourceID()
							};

							queue.push(PurchaseInfoService.getPurchaseDisclosures(resourcePath));
						})

						return $q.all(queue).then(function(results){
								if(!Array.isArray(results)){
									return $q.reject("disclosures results invalid.");
								}

								var disclosureList = [];

								results.forEach(function(data){
									disclosureList = disclosureList.concat(data);
								});

								return $q.resolve(disclosureList);
							})
							.catch(MessageService.showToast);
					// },
					// constants: function(TasksService, $q, MessageService, WorkOrderService ){
					// 	const queue = {
					// 		taskCategories: TasksService.getCachedTaskCategories(),
					// 		taskPriorities: TasksService.getCachedTaskPriorities(),
					// 		taskStatus: TasksService.getCachedTaskStatus(),
					// 		workOrderPriorities: WorkOrderService.getCachedWorkOrderPriorities(),,
					// 		workOrderStatus: WorkOrderService.getWorkOrderStatus(),
					// 	}

					// 	return $q.all(queue).catch(MessageService.showToast);
					// },
					// workorders:function($stateParams, WorkOrderService, MessageService, LoginService, $q, ToolsConstants, WorkOrderConstants, GeneralTools){
					// 	if(!LoginService.getUserStatus() || !LoginService.getUserStatus().isLogin){
					// 		return $q.resolve();
					// 	}
						
					// 	var resourcePath = {
					// 		companyID : LoginService.getCompanyID(),
					// 		vehicleID : $stateParams.vehicleID
					// 	};

					// 	const sorting = {
					// 		sortBy: WorkOrderConstants.keyNames.invoiceNumber,
					// 		sortDirection: ToolsConstants.apiSortingDirections.DESC,
					// 		filters: GeneralTools.stringConnector(GeneralTools.notEqualFilterBuilder("fk_id_work_order_status", 4), GeneralTools.notEqualFilterBuilder("fk_id_work_order_status", 3), ToolsConstants.apiFilters.andConnector)
					// 	}

					// 	return WorkOrderService.getWorkOrders(resourcePath, sorting).$promise.catch(MessageService.showToast);
					},
					testDriveVehicleHistory:function($stateParams, VehicleService, MessageService, LoginService){
						var resourcePath = {
							vehicleID : $stateParams.vehicleID,
							companyID: LoginService.getCompanyID()
						}

						return VehicleService.getTestDriveVehicleHistory(resourcePath).catch(MessageService.showToast);						
					},
				}
			})

			.state('app.add-vehicle', {
					url	  : "/add-vehicle?redirectState&redirectParams&newVehicleIdParamName",
					views	: {
						'content@app': {
							templateUrl: 'app/main/vehicles/add-vehicle/add-vehicle.html',
							controller : 'AddVehicleController as vm'
						}
					},
					resolve:{
						presetFeatureOptions:function(VehicleService, MessageService){
							return VehicleService.getPresetFeatures().catch(MessageService.showToast);						
						},
						locations:function(MessageService, LoginService, VehicleService){
							return VehicleService.getCachedLocations({companyID: LoginService.getCompanyID()}).catch(MessageService.showToast);
						}
					}
			})

			.state('app.batch-import-vehicles', {
					url	  : "/batch-import-vehicles",
					views	: {
						'content@app': {
							templateUrl: 'app/main/vehicles/batch-import-vehicles/batch-import-vehicles.html',
							controller : 'BatchImportVehiclesController as vm'
						}
					},
					resolve:{
						presetFeatures:function(VehicleService, MessageService){
							return VehicleService.getPresetFeatures().catch(MessageService.showToast);						
						},
						workorderPriorities:function(WorkOrderService, MessageService){
							return WorkOrderService.getCachedWorkOrderPriorities().catch(MessageService.showToast);
						}
					}
			})

			.state('app.edit-vehicle', {
				url	  : '/edit-vehicle/{vehicleID}?tab',
				views	: {
					'content@app': {
						templateUrl: 'app/main/vehicles/edit-vehicle/edit-vehicle.html',
						controller : 'EditVehicleController as vm'
					}
				},
				resolve:{
					vehicleToBeEdit:function($stateParams, VehicleService, MessageService, LoginService){
						var resourcePath = {
							companyID : LoginService.getCompanyID(),
							vehicleID : $stateParams.vehicleID
						};

						return VehicleService.getVehicle(resourcePath).catch(MessageService.showToast);
					},

					presetFeatures:function(VehicleService, MessageService){
						return VehicleService.getPresetFeatures().catch(MessageService.showToast);						
					},

					vehicleFeatures:function($stateParams, VehicleService, MessageService, LoginService){
						var resourcePath = {
							vehicleID : $stateParams.vehicleID,
							companyID: LoginService.getCompanyID()
						}

						return VehicleService.getVehicleFeatures(resourcePath).catch(MessageService.showToast);						
					},

					purchaseInfos:function($stateParams, PurchaseInfoService, MessageService, LoginService){
						var resourcePath = {
							companyID : LoginService.getCompanyID(),
							vehicleID : $stateParams.vehicleID
						};

						return PurchaseInfoService.getPurchaseInfos(resourcePath).catch(MessageService.showToast);
					},

					saleInfos:function($stateParams, SaleInfoService, MessageService, LoginService){
						var resourcePath = {
							companyID : LoginService.getCompanyID(),
							vehicleID : $stateParams.vehicleID
						};

						return SaleInfoService.getVehicleSaleInfos(resourcePath).catch(MessageService.showToast);
					},

					vehicleImages:function($stateParams, VehicleService, MessageService){
						var vehicleID = $stateParams.vehicleID;
						return VehicleService.getVehicleImages(vehicleID).catch(MessageService.showToast);
					},	

					vehicleFiles:function($stateParams, VehicleService, MessageService){
						var vehicleID = $stateParams.vehicleID;
						return VehicleService.getVehicleFiles(vehicleID).catch(MessageService.showToast);
					},	

					vehicleBrands:function(VehicleService, MessageService){
						return VehicleService.getCachedVehicleBrands().catch(MessageService.showToast);
					},
					
					locations:function(MessageService, LoginService, VehicleService){
						return VehicleService.getCachedLocations({companyID: LoginService.getCompanyID()}).catch(MessageService.showToast);
					}
				}			
			})
			.state('app.purchase-complete', {
				url : '/purchasecomplete?saleInfoID&vehicleID&signatureID',
				views	: {
					'content@app': {
						templateUrl: 'app/main/vehicles/purchase-complete/purchase-complete.html',
						controller : 'PurchaseCompleteController as vm'
					}
				}
			})
			.state('app.deliver-schedule', {
				url : '/deliver-schedule?mechanicCompleted&detailCompleted&licensingCompleted&location',
				reloadOnSearch:false,
				views	: {
					'content@app': {
						templateUrl: 'app/main/vehicles/deliver-schedule/deliver-schedule.html',
						controller : 'DeliverScheduleController as vm'
					}
				},
				resolve:{
					locations:function(MessageService, LoginService, VehicleService, $q){
						if(!LoginService.getUserStatus() || !LoginService.getUserStatus().isLogin){
							return $q.resolve();
						}

						return VehicleService.getCachedLocations({companyID: LoginService.getCompanyID()}).catch(MessageService.showToast);
					},
					workorderPriorities:function(WorkOrderService, MessageService){						
						return WorkOrderService.getCachedWorkOrderPriorities().catch(MessageService.showToast);
					},
					userConfig:function(MessageService, LoginService, UserConfigService, $q){
						if(!LoginService.getUserStatus() || !LoginService.getUserStatus().isLogin){
							return $q.resolve();
						}

						const resourcePath = {
							companyID: LoginService.getCompanyID(),
							userID: LoginService.getUserID()
						};

						return UserConfigService.getUserConfig(resourcePath).catch(MessageService.showToast);
					}
				}
			})

			.state('app.load-calculator', {
				url : '/LoanCalculator',
				reloadOnSearch:false,
				views	: {
					'content@app': {
						templateUrl: 'app/main/vehicles/load-calculator/load-calculator.html',
						controller : 'LoadCalculatorController as vm'
					}
				},
				resolve:{
					locations:function(MessageService, LoginService, VehicleService, $q){
						if(!LoginService.getUserStatus() || !LoginService.getUserStatus().isLogin){
							return $q.resolve();
						}

						return VehicleService.getCachedLocations({companyID: LoginService.getCompanyID()}).catch(MessageService.showToast);
					},
					workorderPriorities:function(WorkOrderService, MessageService){						
						return WorkOrderService.getCachedWorkOrderPriorities().catch(MessageService.showToast);
					},
					userConfig:function(MessageService, LoginService, UserConfigService, $q){
						if(!LoginService.getUserStatus() || !LoginService.getUserStatus().isLogin){
							return $q.resolve();
						}

						const resourcePath = {
							companyID: LoginService.getCompanyID(),
							userID: LoginService.getUserID()
						};

						return UserConfigService.getUserConfig(resourcePath).catch(MessageService.showToast);
					}
				}
			})
			.state('app.vehicle-was-available', {
				url : '/vehicle-was-available',
				reloadOnSearch:false,
				views	: {
					'content@app': {
						templateUrl: 'app/main/vehicles/vehicle-was-available/vehicle-was-available.html',
						controller : 'VehicleWasAvailableController as vm'
					}
				}
			})


			msNavigationServiceProvider.saveItem("vehicles", {
				title : "VEHICLES",
				icon : "icon-car",
				weight: 3,
				requiredRoles:[]			 
			});

			msNavigationServiceProvider.saveItem('vehicles.browse-vehicles', {
				title: 'Browse Vehicles',
				state: 'app.vehicles',
				requiredRoles:[]	
			});   

			msNavigationServiceProvider.saveItem('vehicles.deliver-schedule', {
				title: 'Delivery Schedule',
				state: 'app.deliver-schedule',
				requiredRoles:[]	
			});


			msNavigationServiceProvider.saveItem('vehicles.load-calculator', {
				title: 'Loan Calculator',
				state: 'app.load-calculator',
				requiredRoles:[]	
			});

			
			msNavigationServiceProvider.saveItem("vehicles.manage", {
				title : "Manage",
				weight: 3,
				requiredRoles:["developer", "company_manager", "vehicle_manager", "vehicle_helper_add", "accountant"]			 
			});

			msNavigationServiceProvider.saveItem('vehicles.manage.vehicle-was-available', {
				title: 'Vehicle Was Available',
				state: 'app.vehicle-was-available',
				requiredRoles:["developer", "company_manager", "accountant"]			 
			});

			msNavigationServiceProvider.saveItem('vehicles.manage.add-vehicle', {
				title: 'Add One Vehicle',
				state: 'app.add-vehicle',
				requiredRoles:["developer", "company_manager", "vehicle_manager", "vehicle_helper_add"]		 
			});

			msNavigationServiceProvider.saveItem('vehicles.manage.batch-import-vehicles', {
				title: 'Add Many Vehicles',
				state: 'app.batch-import-vehicles',
				requiredRoles:["developer", "company_manager", "vehicle_manager", "vehicle_helper_add"]	 
			});
	}

})();
(function ()
{
	'use strict';

	angular
		.module('app.vehicles')
		.service("VinAuditService", VinAuditService);

	/** @ngInject */
	function VinAuditService($q, $resource, VinAuditConstants, $filter, UnitTranslator, MessageService, ApiConst)
	{   
		var decodeVinUrl 		= VinAuditConstants.vinAudit.apis.decodeVin.url;
		var decodeVinConfigs 	= VinAuditConstants.vinAudit.apis.decodeVin.configs;

		var querySpecsUrl		= VinAuditConstants.vinAudit.apis.querySpecs.url;
		var querySpecsConfigs	= VinAuditConstants.vinAudit.apis.querySpecs.configs;

		this.querySpecs = function(queryParams){
			var api = $resource(querySpecsUrl, querySpecsConfigs);
			var defer = $q.defer();
			api.get(queryParams,
					function(response, header){
						if(response == null || !Array.isArray(response.specification)){
							return defer.resolve([]);
						}
						defer.resolve(response.specification);
					},
					function(error){
						defer.reject(error);
					});

			return defer.promise;
		}

		this.decodeVin = function(vin){
			var api = $resource(decodeVinUrl, decodeVinConfigs);
			var defer = $q.defer();
			var param = {vin:vin};

			api.get(param,
					function(response, header){
						var result = {}

						if(!response.success){
							defer.reject(response.error)
							return;
						}

						result.attributes = extractAttributes(response)
						result.features   = extractFeatures(response);

						defer.resolve(result);
					},
					function(error){
						defer.reject(error);
					});

			return defer.promise;
		}

		function extractAttributes(rawData){
			var attributes = {}

			if(rawData == null || rawData.attributes == null){
				return attributes;
			}

			var rawAttributes = rawData.attributes;

	 		attributes.vin = rawAttributes["VIN"];
	 		attributes.year = rawAttributes["Year"];
	 		attributes.make = rawAttributes["Make"];
	 		attributes.model = rawAttributes["Model"];
	 		attributes.trim = rawAttributes["Trim"];
	 		attributes.made_in = rawAttributes["Made In"];
	 		attributes.body_type = rawAttributes["Vehicle Style"];
	 		attributes.doors = rawAttributes["Doors"];
	 		attributes.fuel_type = rawAttributes["Fuel Type"];
	 		attributes.drive_train = rawAttributes["Driven Wheels"];
	 		attributes.engine = rawAttributes["Engine"];
	 		attributes.engine_size = rawAttributes["Engine Size"];
	 		attributes.engine_cylinders 	= rawAttributes["Engine Cylinders"];
	 		attributes.transmission_type 	= rawAttributes["Transmission Type"];
	 		attributes.transmission_gears 	= rawAttributes["Transmission Gears"]; 		
	 		attributes.standard_seating 	= rawAttributes["Standard Seating"];
	 		attributes.optional_seating 	= rawAttributes["Optional Seating"];

	 		attributes.curb_weight 				= UnitTranslator.poundToKilogram(getNumberFromString(rawAttributes["Curb Weight"]), 0);
	 		attributes.gross_weight 			= UnitTranslator.poundToKilogram(getNumberFromString(rawAttributes["Gross Weight"]), 0);
	 		attributes.overall_height 			= UnitTranslator.inchToMillimeter(getNumberFromString(rawAttributes["Overall Height"]), 0);
	 		attributes.overall_length 			= UnitTranslator.inchToMillimeter(getNumberFromString(rawAttributes["Overall Length"]), 0);
	 		attributes.overall_width 			= UnitTranslator.inchToMillimeter(getNumberFromString(rawAttributes["Overall Width"]), 0);
	 		attributes.city_fuel_efficiency 	= UnitTranslator.milePerGallonToGallonPerHundredkm(getNumberFromString(rawAttributes["City Mileage"]), 0);
	 		attributes.highway_fuel_efficiency 	= UnitTranslator.milePerGallonToGallonPerHundredkm(getNumberFromString(rawAttributes["Highway Mileage"]), 0);
	 		attributes.fuel_capacity 			= UnitTranslator.gallonToLiter(getNumberFromString(rawAttributes["Fuel Capacity"]), 0);

	 		return attributes;
		}

		function isEmptyString (string){
			if(string.trim() == ''){
				return true;
			}
			return false;
		}

		function getNumberFromString(valueString){
			if(valueString == null || isEmptyString(valueString)){
				return;
			}

			var value = valueString.split(' ')[0];

			value = new Number(value)

			if(isNaN(value)){
				return;
			}

			return value;
		}

		function extractFeatures(rawData){

			var featureList = [] 

			if(rawData == null || !Array.isArray(rawData.equipments)){
				return featureList;
			}

			rawData.equipments.forEach(function(rawFeature){
				var feature = {};

				feature.category = rawFeature.group;
				feature.name = rawFeature.name;
				feature.value = rawFeature.value;
				featureList.push(feature);
			})
			
			return featureList;
		}
	}
})();
(function ()
{
	'use strict';

	angular
		.module("app.vehicles")
		.constant("VinAuditConstants", {

			vinAudit:{
				apis: {
					decodeVin:{
						url: "https://specifications.vinaudit.com/getspecifications.php",
						configs :{
							format:"json",
	                        key:"3G2NRDX44OSEHZA",
	                        include:"attributes,equipments,ratings,recalls,warranty"
						}
					},
					querySpecs:{
						url:"https://specifications.vinaudit.com/getlist.php",
						configs :{
							format:"json",
	                        key:"3G2NRDX44OSEHZA"
						}
					}
				},
				units:{
					fuelEfficiency : {
						ratio	: 235.21458329475,
						unit 	: " L/100km"
					},
					fuelCapacity : {
						ratio	: 3.78541,
						unit 	: " L"
					},
					dimension : {
						ratio	: 25.4,
						unit 	: " mm"
					},
					weight : {
						ratio	: 1,
						unit 	: " kg"
					}
				}
			}
		})
})();
(function ()
{
	'use strict';

	angular
		.module("app.vehicles")
		.factory("Vinaudit", VinauditClass)

	/** @ngInject */
	function VinauditClass($q, $resource, VinAuditConstants, $filter, UnitTranslator, MessageService, ApiConst)
	{	   
		var decodeVinUrl 		= VinAuditConstants.vinAudit.apis.decodeVin.url;
		var decodeVinConfigs 	= VinAuditConstants.vinAudit.apis.decodeVin.configs;

		var querySpecsUrl		= VinAuditConstants.vinAudit.apis.querySpecs.url;
		var querySpecsConfigs	= VinAuditConstants.vinAudit.apis.querySpecs.configs;

		function vinDecoder(){}

		vinDecoder.prototype.getAttributes = function(rawData){
			var attributes = {}

			if(rawData == null || rawData.attributes == null){
				return attributes;
			}

			var rawAttributes = rawData.attributes;

	 		attributes.vin = rawAttributes["VIN"];
	 		attributes.year = rawAttributes["Year"];
	 		attributes.make = rawAttributes["Make"];
	 		attributes.model = rawAttributes["Model"];
	 		attributes.trim = rawAttributes["Trim"];
	 		attributes.made_in = rawAttributes["Made In"];
	 		attributes.body_type = rawAttributes["Vehicle Style"];
	 		attributes.doors = rawAttributes["Doors"];
	 		attributes.fuel_type = rawAttributes["Fuel Type"];
	 		attributes.drive_train = rawAttributes["Driven Wheels"];
	 		attributes.engine = rawAttributes["Engine"];
	 		attributes.engine_size = rawAttributes["Engine Size"];
	 		attributes.engine_cylinders 	= rawAttributes["Engine Cylinders"];
	 		attributes.transmission_type 	= rawAttributes["Transmission Type"];
	 		attributes.transmission_gears 	= rawAttributes["Transmission Gears"]; 		
	 		attributes.standard_seating 	= rawAttributes["Standard Seating"];
	 		attributes.optional_seating 	= rawAttributes["Optional Seating"];

	 		attributes.curb_weight 				= UnitTranslator.poundToKilogram(getNumberFromString(rawAttributes["Curb Weight"]), 0);
	 		attributes.gross_weight 			= UnitTranslator.poundToKilogram(getNumberFromString(rawAttributes["Gross Weight"]), 0);
	 		attributes.overall_height 			= UnitTranslator.inchToMillimeter(getNumberFromString(rawAttributes["Overall Height"]), 0);
	 		attributes.overall_length 			= UnitTranslator.inchToMillimeter(getNumberFromString(rawAttributes["Overall Length"]), 0);
	 		attributes.overall_width 			= UnitTranslator.inchToMillimeter(getNumberFromString(rawAttributes["Overall Width"]), 0);
	 		attributes.city_fuel_efficiency 	= UnitTranslator.milePerGallonToGallonPerHundredkm(getNumberFromString(rawAttributes["City Mileage"]), 0);
	 		attributes.highway_fuel_efficiency 	= UnitTranslator.milePerGallonToGallonPerHundredkm(getNumberFromString(rawAttributes["Highway Mileage"]), 0);
	 		attributes.fuel_capacity 			= UnitTranslator.gallonToLiter(getNumberFromString(rawAttributes["Fuel Capacity"]), 0);

	 		return attributes;
		}

		function isEmptyString (string){
			if(string.trim() == ''){
				return true;
			}
			return false;
		}

		function getNumberFromString(valueString){
			if(valueString == null || isEmptyString(valueString)){
				return;
			}

			var value = valueString.split(' ')[0];

			value = new Number(value)

			if(isNaN(value)){
				return;
			}

			return value;
		}

		vinDecoder.prototype.querySpecs = function(queryParams){
			var api = $resource(querySpecsUrl, querySpecsConfigs);
			var defer = $q.defer();

			api.get(queryParams,
					function(response, header){
						if(response == null || !Array.isArray(response.specification)){
							return defer.resolve([]);
						}
						defer.resolve(response.specification);
					},
					function(error){
						defer.reject(error);
					});

			return defer.promise;
		}

		vinDecoder.prototype.decodeVin = function(vin){

			var api = $resource(decodeVinUrl, decodeVinConfigs);
			var defer = $q.defer();
			var param = {vin:vin};

			api.get(param,
					function(response, header){
						var result = {}

						if(!response.success){
							defer.reject(response.error)
							return;
						}

						result.attributes = vinDecoder.prototype.getAttributes(response)
						result.features   = vinDecoder.prototype.getFeatures(response);

						defer.resolve(result);
					},
					function(error){
						defer.reject(error);
					});

			return defer.promise;
		}

		vinDecoder.prototype.getFeatures = function (rawData){

			var featureList = [] 

			if(rawData == null || !Array.isArray(rawData.equipments)){
				return featureList;
			}

			rawData.equipments.forEach(function(rawFeature){
				var feature = {};

				feature.category = rawFeature.group;
				feature.name = rawFeature.name;
				feature.value = rawFeature.value;
				featureList.push(feature);
			})
			
			return featureList;
		}

		vinDecoder.prototype.getSpecsOptions = function (rawData){
			var specification = []
			if(rawData == null || !Array.isArray(rawData.specification)){
				return specification;
			}
			specification = rawData.specification;

			return specification;
		}

		return vinDecoder;
	}

})();
(function ()
{
	'use strict';

	angular
		.module('app.vehicles')
		.controller('VehicleWasAvailableController', VehicleWasAvailableController)

	function VehicleWasAvailableController($state, api, LoginService, MessageService, Vehicle, ReportService, ProgressService){	 
		const vm = this;
		const companyID = LoginService.getCompanyID();

		vm.updateVehicleList = updateVehicleList;
		vm.getVehiclePageUrl = getVehiclePageUrl;

		vm.generateSaleReport = generateSaleReport;
		vm.generatePurchaseReport = generatePurchaseReport;
		vm.generateProfitReport = generateProfitReport;

		function getVehiclePageUrl(vehicleID) {
			return $state.href("app.edit-vehicle", {vehicleID: vehicleID});
		}

		function updateVehicleList() {
			const date = moment(vm.date).format("YYYY-MM-DD");
			ProgressService.setMode("indeterminate");
			ProgressService.isVisble(true);
			api.vehiclesWasAvailable.getVehicle(
				{companyID: companyID, date: date}, 
				function(response, header) {
					vm.vehicleList = response.map(function(data){
						var vehicle = new Vehicle();
						vehicle.setAttributes(data); 
						return vehicle;
					});
					ProgressService.isVisble(false);
				},
				function(error) {
					MessageService.showToast(error);
				}
			);
		}

		function generateSaleReport() {
			vm.isBusy = true;
			ProgressService.setMode("indeterminate");
			ProgressService.isVisble(true);
			ReportService.generateSaleReportVTemp(companyID, vm.date)
				.catch(MessageService.showToast)
				.finally(function() {
					ProgressService.isVisble(false);
					vm.isBusy = false;
				})
		}

		function generatePurchaseReport() {
			vm.isBusy = true;
			ProgressService.setMode("indeterminate");
			ProgressService.isVisble(true);
			ReportService.generatePurchaseReportVTemp(companyID, vm.date)
				.catch(MessageService.showToast)
				.finally(function() {
					ProgressService.isVisble(false);
					vm.isBusy = false;
				})
		}

		function generateProfitReport() {
			vm.isBusy = true;
			ProgressService.setMode("indeterminate");
			ProgressService.isVisble(true);
			ReportService.generateProfitReportVTemp(companyID, vm.date)
				.catch(MessageService.showToast)
				.finally(function() {
					ProgressService.isVisble(false);
					vm.isBusy = false;
				})
		}
	}
})();
(function ()
{
	'use strict';

	angular
		.module("app.vehicles")
		.factory("VehicleFeature", VehicleFeature)

	/** @ngInject */
	function VehicleFeature()
	{	   
		function feature(featureData){
			if(featureData == null){
				return;
			}

			var keyList = Object.keys(featureData);

			for(var i = 0; i < keyList.length; i++){
				var key = keyList[i];
				var value = featureData[key];

				this[key] = value;
			}

		}

		feature.prototype.getResourceID = function(){
			return this.id_vehicle_feature;
		}

		feature.prototype.isValid = function(){
			if(this.category == null || this.category.trim() == ''
					|| this.name == null || this.name.trim() == ''){
				return false;
			}

			return true;
		}


		feature.prototype.pullDataFromPresetFeature = function(presetFeature){
			if(presetFeature == null){
				return;
			}

			this.name = presetFeature.name;
			this.category = presetFeature.category;
			this.value = presetFeature.value; 
		}

		return feature;
	}


})();
(function ()
{
	'use strict';

	angular
		.module("app.vehicles")
		.factory("PresetVehicleFeature", PresetVehicleFeature)

	/** @ngInject */
	function PresetVehicleFeature()
	{	   
		function feature(featureData){
			if(featureData == null){
				return;
			}

			var keyList = Object.keys(featureData);

			for(var i = 0; i < keyList.length; i++){
				var key = keyList[i];
				var value = featureData[key];

				this[key] = value;
			}
		}

		feature.prototype.getResourceID = function(){
			return this.id_preset_feature;
		}

		feature.prototype.isValid = function(){
			if(this.category == null || this.category.trim() == ''
					|| this.name == null || this.name.trim() == ''){
				return false;
			}

			return true;
		}

		feature.prototype.isSameFeature = function(feature){
			if(feature == null){
				return;
			}

			if(this.name == feature.name &&
					this.category == feature.category &&
					this.value == feature.value){
				return true;
			}

			return false;
		}

		return feature;
	}


})();
(function ()
{
	'use strict';

	angular
		.module("app.vehicles")
		.factory("VehicleImage", VehicleImage)

	/** @ngInject */
	function VehicleImage()
	{	   
		function vehicleImage(imageData){
			if(imageData == null){
				return;
			}

			var keyList = Object.keys(imageData);

			for(var i = 0; i < keyList.length; i++){
				var key = keyList[i];
				var value = imageData[key];

				this[key] = value;
			}

			if(this.tag == null){
				this.tag = [];
			}
		}

		vehicleImage.prototype.getResourceID = function () {
	 		return this.id_vehicle_image;
		}	

		vehicleImage.prototype.setResourceID = function (vehicleImageID) {
	 		this.id_vehicle_image = id_vehicle_image;
		}	

		vehicleImage.prototype.setIndex = function(index){
			this.index = index;
		}

		vehicleImage.prototype.getIndex = function(){
			return this.index;
		}

		vehicleImage.prototype.isInteriorImage = function(){
			return checkTag(this.tag, "interior");
		}	

		vehicleImage.prototype.isExteriorImage = function(){
			return checkTag(this.tag, "exterior");
		}	

		vehicleImage.prototype.isHighlightImage = function(){
			return checkTag(this.tag, "highlight");
		}		

		function checkTag(tagList, tagName){	
			if(tagList == null){
				return false;
			}

			for(var i = 0; i < tagList.length; i++){
				var tag = tagList[i];

				if(tag == tagName){
					return true;
				}
			}
		}

		vehicleImage.prototype.changeExteriorTag = function(){
			console.log("changeExteriorTag is called", this.tag);
			var indexOfExteriorTag = this.tag.indexOf("exterior");
			var indexOfInteriorTag = this.tag.indexOf("interior");

			if(indexOfExteriorTag == -1){
				addTag(this.tag, "exterior");
				removeTag(this.tag, "interior");	
				console.log("indexOfExteriorTag == -1", this.tag);	
			}else{
				removeTag(this.tag, "exterior");	
				console.log("indexOfExteriorTag != -1", this.tag);		
			}
		}	

		vehicleImage.prototype.changeInteriorTag = function(){
			var indexOfExteriorTag = this.tag.indexOf("exterior");
			var indexOfInteriorTag = this.tag.indexOf("interior");

			if(indexOfInteriorTag == -1){
				addTag(this.tag, "interior");
				removeTag(this.tag, "exterior");	
			}else{
				removeTag(this.tag, "interior");
			}

		}	

		vehicleImage.prototype.changeHighlightTag = function(){
			var indexOfHighlightTag = this.tag.indexOf("highlight");

			if(indexOfHighlightTag == -1){
				addTag(this.tag, "highlight");
			}else{
				removeTag(this.tag, "highlight");	
			}
		}			

		function removeTag(tagList, tagName){
			var indexOfTag = tagList.indexOf(tagName);
			if( indexOfTag == -1 ){
				return;
			}
			tagList.splice(indexOfTag, 1);
		}		

		function addTag(tagList, tagName){
			var indexOfTag = tagList.indexOf(tagName);
			if( indexOfTag == -1 ){
				tagList.push(tagName);
			}		
		}	

		return vehicleImage;
	}


})();
(function ()
{
	"use strict";

	angular
		.module("app.vehicles")
		.component("workOrderSummaryWarrantyList", {
				bindings:{
					hiddenColumns: '<',
					vehicleMap:'=',
					workOrderList:'=',
					workOrderStatus: '<',
					workorderPriorities: '<',
					toggleSortInvoiceNumber: '<',
					isSortInvoiceDesc: '<',
				},
				templateUrl: "app/main/vehicles/vehicle-details/work-order-summary-warranty-list.html",
				controller: componentController,
		  		controllerAs: 'vm'
			});

		function componentController($scope, CustomersService, LoginService,WorkOrderSummaryCalculator, $state, PartConstants){
			var vm = this;
			vm.maxDisplay = 4;

			$scope.$watch("vm.workOrderList", refreshList, true);

			vm.getWorkOrderStatus = getWorkOrderStatus;
			vm.getWorkOrderUrl = getWorkOrderUrl;
			vm.getWorkOrderListItemInvoiceNumber = getWorkOrderListItemInvoiceNumber;
			vm.getWorkorderPriority = getWorkorderPriority;
			vm.getVehicleUrl = getVehicleUrl;
			vm.getPartsStyleClass = getPartsStyleClass;
			vm.getCustomerName = getCustomerName;
			vm.getCustomerUrl = getCustomerUrl;

			function getWorkorderPriority(priorityID){
				if(!Array.isArray(vm.workorderPriorities)){
					return;
				}

				const matchedPriority = vm.workorderPriorities.find(function(priority){
					return !!priority && priority.id_work_order_priority == priorityID;
				});

				if(matchedPriority){
					return matchedPriority.name;
				}
			}

			function getWorkOrderUrl (workOrder){
				if(workOrder){
					return $state.href("app.edit-workorder.general", {workOrderID: workOrder.id_work_order, vehicleID: workOrder.fk_id_vehicle});
				}
			}

			function getWorkOrderStatus(workOrderStatusID){
				if(!Array.isArray(vm.workOrderStatus)){
					return;
				}

				const matchedStatus = vm.workOrderStatus.find(function(status){
					if(!status){
						return;
					}
					return status.id_work_order_status == workOrderStatusID;
				});

				if(matchedStatus){
					return matchedStatus.status;
				}

				return "Unknown"
			}

			function refreshList(){
				if(!Array.isArray(vm.workOrderList)){
					return;
				}
	
				vm.workOrderList.forEach(function(item){
					if(!item){
						return
					}

					const workOrderSummaryCalculator = new WorkOrderSummaryCalculator();

					if(item.workOrder){
						workOrderSummaryCalculator.setTaxRate(item.workOrder.tax_rate);
						workOrderSummaryCalculator.setSubsidizedAmount(item.workOrder.subsidized_amount);
						workOrderSummaryCalculator.setSubsidizedPercentage(item.workOrder.subsidized_percentage);
						workOrderSummaryCalculator.setIsSubsidizedByPercentage(item.workOrder.is_subsidized_by_percentage);
					}

					workOrderSummaryCalculator.setParts(item.parts);
					workOrderSummaryCalculator.setInventories(item.inventories);
					workOrderSummaryCalculator.setLabors(item.labors);
					workOrderSummaryCalculator.setDiscounts(item.discounts);
					workOrderSummaryCalculator.setPayments(item.payments);

					workOrderSummaryCalculator.setMiscfees(item.miscfees);
					workOrderSummaryCalculator.setWorkOrderPackageList(item.workOrderPackageListData);
					workOrderSummaryCalculator.setWorkOrderWarrantyList(item.workOrderWarrantyListData);
					workOrderSummaryCalculator.setRDRedeemed(item.rogerDollarRedeem);

					item.partsAndInventories = combinePartsAndInventories(item.parts, item.inventories);

					item.totalPartsRetail = workOrderSummaryCalculator.getPartsAndInventoryTotalRetail();
					item.totalLaborsCost = workOrderSummaryCalculator.getTotalLaborsCost();

					item.outstanding = workOrderSummaryCalculator.getOutstanding();
				})
			}

			function getWorkOrderListItemInvoiceNumber(item){
				if(item && item.workOrder){
					return item.workOrder.invoice_number
				}
			}

			function combinePartsAndInventories(parts, inventories){
				if(!Array.isArray(parts)){
					parts = [];
				}

				if(!Array.isArray(inventories)){
					inventories = [];
				}

				var list = [];

				parts.forEach(function(part){
					list.push({
						name: part.name,
						isFromInventory: false,
						isOrdered: part.is_ordered
					});
				});

				inventories.forEach(function(inventory){
					list.push({
						name: inventory.name,
						isFromInventory: true
					});
				});

				return list;
			}

			function getVehicleUrl(vehicleID){
				return $state.href("app.vehicle.general", {vehicleID: vehicleID});
			}

			function getCustomerUrl(workorder){
				return $state.href("app.view-customer", {customerID: workorder.customer_json[0]});
			}

			function getCustomerName(workorder){
				return workorder.customer_name_json[0]
			}

			function getPartsStyleClass(part){
				if(!part || part.isFromInventory){
					return;
				}

				if(!part.isOrdered){
					return [PartConstants.styleClasses.notOrdered];
				}
			}

			vm.setSorting = function (){
				vm.toggleSortInvoiceNumber()
			}
		}
})();
(function ()
{
	"use strict";

	angular
		.module("app.vehicles")
		.component("workOrderSummarySmallList", {
				bindings:{
					hiddenColumns: '<',
					vehicleMap:'=',
					workOrderList:'=',
					workOrderStatus: '<',
					workorderPriorities: '<'
				},
				templateUrl: "app/main/vehicles/vehicle-details/work-order-summary-small-list.html",
				controller: componentController,
		  		controllerAs: 'vm'
			});

		function componentController($scope, WorkOrderSummaryCalculator, $state, PartConstants){
			var vm = this;
			vm.maxDisplay = 4;
			$scope.$watch("vm.workOrderList", refreshList, true);

			vm.getWorkOrderStatus = getWorkOrderStatus;
			vm.getWorkOrderUrl = getWorkOrderUrl;
			vm.getWorkOrderListItemInvoiceNumber = getWorkOrderListItemInvoiceNumber;
			vm.getWorkorderPriority = getWorkorderPriority;
			vm.getVehicleUrl = getVehicleUrl;
			vm.getPartsStyleClass = getPartsStyleClass;
			vm.getOutstandingInvoiceListLength = getOutstandingInvoiceListLength;
			vm.toggleItemList = toggleItemList;
			vm.gettotaloutstanding = gettotaloutstanding;

			function getWorkorderPriority(priorityID){
				if(!Array.isArray(vm.workorderPriorities)){
					return;
				}

				const matchedPriority = vm.workorderPriorities.find(function(priority){
					return !!priority && priority.id_work_order_priority == priorityID;
				});

				if(matchedPriority){
					return matchedPriority.name;
				}
			}

			function getWorkOrderUrl (workOrder){
				if(workOrder){
					return $state.href("app.edit-workorder.general", {workOrderID: workOrder.id_work_order, vehicleID: workOrder.fk_id_vehicle});
				}
			}

			function getWorkOrderStatus(workOrderStatusID){
				if(!Array.isArray(vm.workOrderStatus)){
					return;
				}

				const matchedStatus = vm.workOrderStatus.find(function(status){
					if(!status){
						return;
					}
					return status.id_work_order_status == workOrderStatusID;
				});

				if(matchedStatus){
					return matchedStatus.status;
				}

				return "Unknown"
			}

			function refreshList(){
				if(!Array.isArray(vm.workOrderList)){
					return;
				}
	
				vm.workOrderList.forEach(function(item){
					if(!item){
						return
					}

					const workOrderSummaryCalculator = new WorkOrderSummaryCalculator();

					if(item.workOrder){
						workOrderSummaryCalculator.setTaxRate(item.workOrder.tax_rate);
						workOrderSummaryCalculator.setSubsidizedAmount(item.workOrder.subsidized_amount);
						workOrderSummaryCalculator.setSubsidizedPercentage(item.workOrder.subsidized_percentage);
						workOrderSummaryCalculator.setIsSubsidizedByPercentage(item.workOrder.is_subsidized_by_percentage);
					}

					workOrderSummaryCalculator.setParts(item.parts);
					workOrderSummaryCalculator.setInventories(item.inventories);
					workOrderSummaryCalculator.setLabors(item.labors);
					workOrderSummaryCalculator.setDiscounts(item.discounts);
					workOrderSummaryCalculator.setPayments(item.payments);

					item.partsAndInventories = combinePartsAndInventories(item.parts, item.inventories);

					item.totalPartsRetail = workOrderSummaryCalculator.getPartsAndInventoryTotalRetail();
					item.totalLaborsCost = workOrderSummaryCalculator.getTotalLaborsCost();

					item.outstanding = workOrderSummaryCalculator.getOutstanding();
				})
			}

			function getWorkOrderListItemInvoiceNumber(item){
				if(item && item.workOrder){
					return item.workOrder.invoice_number
				}
			}

			function combinePartsAndInventories(parts, inventories){
				if(!Array.isArray(parts)){
					parts = [];
				}

				if(!Array.isArray(inventories)){
					inventories = [];
				}

				var list = [];

				parts.forEach(function(part){
					list.push({
						name: part.name,
						isFromInventory: false,
						isOrdered: part.is_ordered
					});
				});

				inventories.forEach(function(inventory){
					list.push({
						name: inventory.name,
						isFromInventory: true
					});
				});

				return list;
			}

			function getVehicleUrl(vehicleID){
				return $state.href("app.vehicle.general", {vehicleID: vehicleID});
			}

			function getPartsStyleClass(part){
				if(!part || part.isFromInventory){
					return;
				}

				if(!part.isOrdered){
					return [PartConstants.styleClasses.notOrdered];
				}
			}

			function getOutstandingInvoiceListLength(workOrderList){
				var total = 0;
				workOrderList.forEach(function(workorder){
					total = total + workorder.outstanding + 0;
				})
				return total
			}

			function toggleItemList() {
				var itemList = document.getElementById("item-list");
				var tab = document.querySelector(".tab");
	
				if (itemList.style.display === "none") {
					itemList.style.display = "block";
					tab.classList.add("active");
				} else {
					itemList.style.display = "none";
					tab.classList.remove("active");
				}
			}

			
			function gettotaloutstanding(workOrderList) {
				var outstanding = 0;
				workOrderList.forEach(function(workorder){
					if(workorder.outstanding){
						outstanding += workorder.outstanding;
					}
				})
				return outstanding;
			}
		}
})();
(function ()
{
	"use strict";

	angular
		.module("app.vehicles")
		.component("workOrderSummaryPendingList", {
				bindings:{
					hiddenColumns: '<',
					vehicleMap:'=',
					workOrderList:'=',
					workOrderStatus: '<',
					workorderPriorities: '<',
					toggleSortInvoiceNumber: '<',
					isSortInvoiceDesc: '<',
				},
				templateUrl: "app/main/vehicles/vehicle-details/work-order-summary-pending-list.html",
				controller: componentController,
		  		controllerAs: 'vm'
			});

		function componentController($scope, CustomersService, LoginService,WorkOrderSummaryCalculator, $state, PartConstants){
			var vm = this;
			vm.maxDisplay = 4;

			$scope.$watch("vm.workOrderList", refreshList, true);

			vm.getWorkOrderStatus = getWorkOrderStatus;
			vm.getWorkOrderUrl = getWorkOrderUrl;
			vm.getWorkOrderListItemInvoiceNumber = getWorkOrderListItemInvoiceNumber;
			vm.getWorkorderPriority = getWorkorderPriority;
			vm.getVehicleUrl = getVehicleUrl;
			vm.getPartsStyleClass = getPartsStyleClass;
			vm.getCustomerName = getCustomerName;
			vm.getCustomerUrl = getCustomerUrl;

			function getWorkorderPriority(priorityID){
				if(!Array.isArray(vm.workorderPriorities)){
					return;
				}

				const matchedPriority = vm.workorderPriorities.find(function(priority){
					return !!priority && priority.id_work_order_priority == priorityID;
				});

				if(matchedPriority){
					return matchedPriority.name;
				}
			}

			function getWorkOrderUrl (workOrder){
				if(workOrder){
					return $state.href("app.edit-workorder.general", {workOrderID: workOrder.id_work_order, vehicleID: workOrder.fk_id_vehicle});
				}
			}

			function getWorkOrderStatus(workOrderStatusID){
				if(!Array.isArray(vm.workOrderStatus)){
					return;
				}

				const matchedStatus = vm.workOrderStatus.find(function(status){
					if(!status){
						return;
					}
					return status.id_work_order_status == workOrderStatusID;
				});

				if(matchedStatus){
					return matchedStatus.status;
				}

				return "Unknown"
			}

			function refreshList(){
				if(!Array.isArray(vm.workOrderList)){
					return;
				}
	
				vm.workOrderList.forEach(function(item){
					if(!item){
						return
					}

					const workOrderSummaryCalculator = new WorkOrderSummaryCalculator();

					if(item.workOrder){
						workOrderSummaryCalculator.setTaxRate(item.workOrder.tax_rate);
						workOrderSummaryCalculator.setSubsidizedAmount(item.workOrder.subsidized_amount);
						workOrderSummaryCalculator.setSubsidizedPercentage(item.workOrder.subsidized_percentage);
						workOrderSummaryCalculator.setIsSubsidizedByPercentage(item.workOrder.is_subsidized_by_percentage);
					}

					workOrderSummaryCalculator.setParts(item.parts);
					workOrderSummaryCalculator.setInventories(item.inventories);
					workOrderSummaryCalculator.setLabors(item.labors);
					workOrderSummaryCalculator.setDiscounts(item.discounts);
					workOrderSummaryCalculator.setPayments(item.payments);
					
					workOrderSummaryCalculator.setMiscfees(item.miscfees);
					workOrderSummaryCalculator.setWorkOrderPackageList(item.workOrderPackageListData);
					workOrderSummaryCalculator.setWorkOrderWarrantyList(item.workOrderWarrantyListData);
					workOrderSummaryCalculator.setRDRedeemed(item.rogerDollarRedeem);
					
					item.partsAndInventories = combinePartsAndInventories(item.parts, item.inventories);

					item.totalPartsRetail = workOrderSummaryCalculator.getPartsAndInventoryTotalRetail();
					item.totalLaborsCost = workOrderSummaryCalculator.getTotalLaborsCost();

					item.outstanding = workOrderSummaryCalculator.getOutstanding();
				})
			}

			function getWorkOrderListItemInvoiceNumber(item){
				if(item && item.workOrder){
					return item.workOrder.invoice_number
				}
			}

			function combinePartsAndInventories(parts, inventories){
				if(!Array.isArray(parts)){
					parts = [];
				}

				if(!Array.isArray(inventories)){
					inventories = [];
				}

				var list = [];

				parts.forEach(function(part){
					list.push({
						name: part.name,
						isFromInventory: false,
						isOrdered: part.is_ordered
					});
				});

				inventories.forEach(function(inventory){
					list.push({
						name: inventory.name,
						isFromInventory: true
					});
				});

				return list;
			}

			function getVehicleUrl(vehicleID){
				return $state.href("app.vehicle.general", {vehicleID: vehicleID});
			}

			function getCustomerUrl(workorder){
				return $state.href("app.view-customer", {customerID: workorder.customer_json[0]});
			}

			function getCustomerName(workorder){
				return workorder.customer_name_json[0]
			}

			function getPartsStyleClass(part){
				if(!part || part.isFromInventory){
					return;
				}

				if(!part.isOrdered){
					return [PartConstants.styleClasses.notOrdered];
				}
			}
			
			vm.setSorting = function (){
				vm.toggleSortInvoiceNumber()
			}
		}
})();
(function ()
{
	"use strict";

	angular
		.module("app.vehicles")
		.component("workOrderSummaryOutstandingList", {
				bindings:{
					hiddenColumns: '<',
					vehicleMap:'=',
					workOrderList:'=',
					workOrderStatus: '<',
					workorderPriorities: '<',
					toggleSortInvoiceNumber: '<',
					isSortInvoiceDesc: '<',
				},
				templateUrl: "app/main/vehicles/vehicle-details/work-order-summary-outstanding-list.html",
				controller: componentController,
		  		controllerAs: 'vm'
			});

		function componentController($scope, WorkOrderSummaryCalculator, $state, PartConstants){
			var vm = this;
			vm.maxDisplay = 4;

			$scope.$watch("vm.workOrderList", refreshList, true);

			vm.getWorkOrderStatus = getWorkOrderStatus;
			vm.getWorkOrderUrl = getWorkOrderUrl;
			vm.getWorkOrderListItemInvoiceNumber = getWorkOrderListItemInvoiceNumber;
			vm.getWorkorderPriority = getWorkorderPriority;
			vm.getVehicleUrl = getVehicleUrl;
			vm.getPartsStyleClass = getPartsStyleClass;
			vm.getCustomerName = getCustomerName;
			vm.getCustomerUrl = getCustomerUrl;

			function getWorkorderPriority(priorityID){
				if(!Array.isArray(vm.workorderPriorities)){
					return;
				}

				const matchedPriority = vm.workorderPriorities.find(function(priority){
					return !!priority && priority.id_work_order_priority == priorityID;
				});

				if(matchedPriority){
					return matchedPriority.name;
				}
			}

			function getWorkOrderUrl (workOrder){
				if(workOrder){
					return $state.href("app.edit-workorder.general", {workOrderID: workOrder.id_work_order, vehicleID: workOrder.fk_id_vehicle});
				}
			}

			function getWorkOrderStatus(workOrderStatusID){
				if(!Array.isArray(vm.workOrderStatus)){
					return;
				}

				const matchedStatus = vm.workOrderStatus.find(function(status){
					if(!status){
						return;
					}
					return status.id_work_order_status == workOrderStatusID;
				});

				if(matchedStatus){
					return matchedStatus.status;
				}

				return "Unknown"
			}

			function refreshList(){
				if(!Array.isArray(vm.workOrderList)){
					return;
				}
	
				vm.workOrderList.forEach(function(item){
					if(!item){
						return
					}

					const workOrderSummaryCalculator = new WorkOrderSummaryCalculator();

					if(item.workOrder){
						workOrderSummaryCalculator.setTaxRate(item.workOrder.tax_rate);
						workOrderSummaryCalculator.setSubsidizedAmount(item.workOrder.subsidized_amount);
						workOrderSummaryCalculator.setSubsidizedPercentage(item.workOrder.subsidized_percentage);
						workOrderSummaryCalculator.setIsSubsidizedByPercentage(item.workOrder.is_subsidized_by_percentage);
					}

					workOrderSummaryCalculator.setParts(item.parts);
					workOrderSummaryCalculator.setInventories(item.inventories);
					workOrderSummaryCalculator.setLabors(item.labors);
					workOrderSummaryCalculator.setDiscounts(item.discounts);
					workOrderSummaryCalculator.setPayments(item.payments);
					workOrderSummaryCalculator.setMiscfees(item.miscfees);
					workOrderSummaryCalculator.setWorkOrderPackageList(item.workOrderPackageListData);
					workOrderSummaryCalculator.setWorkOrderWarrantyList(item.workOrderWarrantyListData);
					workOrderSummaryCalculator.setRDRedeemed(item.rogerDollarRedeem);

					item.partsAndInventories = combinePartsAndInventories(item.parts, item.inventories);

					item.totalPartsRetail = workOrderSummaryCalculator.getPartsAndInventoryTotalRetail();
					item.totalLaborsCost = workOrderSummaryCalculator.getTotalLaborsCost();

					item.outstanding = workOrderSummaryCalculator.getOutstanding();
				})
			}

			function getWorkOrderListItemInvoiceNumber(item){
				if(item && item.workOrder){
					return item.workOrder.invoice_number
				}
			}

			function combinePartsAndInventories(parts, inventories){
				if(!Array.isArray(parts)){
					parts = [];
				}

				if(!Array.isArray(inventories)){
					inventories = [];
				}

				var list = [];

				parts.forEach(function(part){
					list.push({
						name: part.name,
						isFromInventory: false,
						isOrdered: part.is_ordered
					});
				});

				inventories.forEach(function(inventory){
					list.push({
						name: inventory.name,
						isFromInventory: true
					});
				});

				return list;
			}

			function getVehicleUrl(vehicleID){
				return $state.href("app.vehicle.general", {vehicleID: vehicleID});
			}

			function getPartsStyleClass(part){
				if(!part || part.isFromInventory){
					return;
				}

				if(!part.isOrdered){
					return [PartConstants.styleClasses.notOrdered];
				}
			}

			
			function getCustomerUrl(workorder){
				return $state.href("app.view-customer", {customerID: workorder.customer_json[0]});
			}

			function getCustomerName(workorder){
				return workorder.customer_name_json[0]
			}
			
			vm.setSorting = function (){
				vm.toggleSortInvoiceNumber()
			}
		}
})();
(function ()
{
	"use strict";

	angular
		.module("app.vehicles")
		.component("workOrderSummaryList", {
				bindings:{
					hiddenColumns: '<',
					vehicleMap:'=',
					workOrderList:'=',
					workOrderStatus: '<',
					workorderPriorities: '<',
					toggleSortInvoiceNumber: '<',
					isSortInvoiceDesc: '<',
				},
				templateUrl: "app/main/vehicles/vehicle-details/work-order-summary-list.html",
				controller: componentController,
		  		controllerAs: 'vm'
			});

		function componentController($scope, WorkOrderSummaryCalculator, $state, PartConstants){
			var vm = this;
			vm.maxDisplay = 4;

			$scope.$watch("vm.workOrderList", refreshList, true);

			vm.getWorkOrderStatus = getWorkOrderStatus;
			vm.getWorkOrderUrl = getWorkOrderUrl;
			vm.getWorkOrderListItemInvoiceNumber = getWorkOrderListItemInvoiceNumber;
			vm.getWorkorderPriority = getWorkorderPriority;
			vm.getVehicleUrl = getVehicleUrl;
			vm.getPartsStyleClass = getPartsStyleClass;

			function getWorkorderPriority(priorityID){
				if(!Array.isArray(vm.workorderPriorities)){
					return;
				}

				const matchedPriority = vm.workorderPriorities.find(function(priority){
					return !!priority && priority.id_work_order_priority == priorityID;
				});

				if(matchedPriority){
					return matchedPriority.name;
				}
			}

			function getWorkOrderUrl (workOrder){
				if(workOrder){
					return $state.href("app.edit-workorder.general", {workOrderID: workOrder.id_work_order, vehicleID: workOrder.fk_id_vehicle});
				}
			}

			function getWorkOrderStatus(workOrderStatusID){
				if(!Array.isArray(vm.workOrderStatus)){
					return;
				}

				const matchedStatus = vm.workOrderStatus.find(function(status){
					if(!status){
						return;
					}
					return status.id_work_order_status == workOrderStatusID;
				});

				if(matchedStatus){
					return matchedStatus.status;
				}

				return "Unknown"
			}

			function refreshList(){
				if(!Array.isArray(vm.workOrderList)){
					return;
				}
				vm.workOrderList.forEach(function(item){
			
					if(!item){
						return
					}

					const workOrderSummaryCalculator = new WorkOrderSummaryCalculator();

					if(item.workOrder){
						workOrderSummaryCalculator.setTaxRate(item.workOrder.tax_rate);
						workOrderSummaryCalculator.setSubsidizedAmount(item.workOrder.subsidized_amount);
						workOrderSummaryCalculator.setSubsidizedPercentage(item.workOrder.subsidized_percentage);
						workOrderSummaryCalculator.setIsSubsidizedByPercentage(item.workOrder.is_subsidized_by_percentage);
					}

					workOrderSummaryCalculator.setParts(item.parts);
					workOrderSummaryCalculator.setInventories(item.inventories);
					workOrderSummaryCalculator.setLabors(item.labors);
					workOrderSummaryCalculator.setMiscfees(item.miscfees);
					workOrderSummaryCalculator.setWorkOrderPackageList(item.workorderpackge);
					workOrderSummaryCalculator.setWorkOrderWarrantyList(item.workorderwarranty);
					workOrderSummaryCalculator.setDiscounts(item.discounts);
					workOrderSummaryCalculator.setPayments(item.payments);
					workOrderSummaryCalculator.setRDRedeemed(item.rogerDollarRedeemData);

					item.partsAndInventories = combinePartsAndInventories(item.parts, item.inventories);
					item.totalPartsRetail = workOrderSummaryCalculator.getPartsAndInventoryTotalRetail();
					item.totalLaborsCost = workOrderSummaryCalculator.getTotalLaborsCost();
					item.totalMiscfeesCost = workOrderSummaryCalculator.getTotalMiscfeesCost();
					item.totalWorkOrderPackageCost = workOrderSummaryCalculator.getTotalWorkOrderPackageListCost();
					item.totalWorkOrderWarrantyCost = workOrderSummaryCalculator.getTotalWorkOrderWarrantyListCost();
					item.outstanding = workOrderSummaryCalculator.getOutstanding();
				})
			}

			function getWorkOrderListItemInvoiceNumber(item){
				if(item && item.workOrder){
					return item.workOrder.invoice_number
				}
			}

			function combinePartsAndInventories(parts, inventories){
				if(!Array.isArray(parts)){
					parts = [];
				}

				if(!Array.isArray(inventories)){
					inventories = [];
				}

				var list = [];

				parts.forEach(function(part){
					list.push({
						name: part.name,
						isFromInventory: false,
						isOrdered: part.is_ordered
					});
				});

				inventories.forEach(function(inventory){
					list.push({
						name: inventory.name,
						isFromInventory: true
					});
				});

				return list;
			}

			function getVehicleUrl(vehicleID){
				return $state.href("app.vehicle.general", {vehicleID: vehicleID});
			}

			function getPartsStyleClass(part){
				if(!part || part.isFromInventory){
					return;
				}

				if(!part.isOrdered){
					return [PartConstants.styleClasses.notOrdered];
				}
			}

			vm.setSorting = function (){
				vm.toggleSortInvoiceNumber()
			}
		}
})();
(function () {
    'use strict';

    angular
        .module('app.vehicles')
        .component('vehicleImageGallery', {
            bindings: {
                vehicleImages: '=',
                numberInLarge: '<',
                numberInMedium: '<',
                numberInSmall: '<',
                smallVehicleImages: '=',
            },
            templateUrl: 'app/main/vehicles/vehicle-details/vehicle-image-gallery.html',
            controller: componentController,
            controllerAs: 'vm'
        });

    function componentController($filter, $scope, $timeout) {
        const vm = this;
        const imagePlaceholder = '../../assets/images/placeholder-vans.png';

        $scope.$watch('vm.workOrderList.length', refreshGallery);

        vm.$onInit = initComponent;
        vm.pauseAndPlay = pauseAndPlay;
        vm.numberInLarge_3 = 1;

        function initComponent() {
            initSlick();
        }

        function pauseAndPlay() {
            vm.isPlaying = !vm.isPlaying;
        }

        function refreshGallery() {
            if (!Array.isArray(vm.vehicleImages)) {
                return;
            }

            vm.slideShowList = [];
            vm.galleryList = [];

            vm.vehicleImages = $filter('orderBy')(vm.vehicleImages, 'index');
            vm.smallVehicleImages = $filter('orderBy')(vm.smallVehicleImages, 'index');
            for (var i = 0; i < vm.vehicleImages.length; i++) {
                if (vm.vehicleImages[i].is_online) {
                    vm.slideShowList.push(vm.smallVehicleImages[i]);
                    var item = {};
                    item.src = vm.vehicleImages[i].url;
                    vm.galleryList.push(item);
                }
            }
            for (var i = 0; i < 3; i++) {
                if (!vm.slideShowList[i]) {
                    vm.slideShowList[i] = {
                        index: i,
                        url: imagePlaceholder,
                        isPlaceHolder: true
                    };
                }
            }
            

            vm.slideShowList.sort(compare);
            var lastItem = vm.slideShowList.slice(-1)[0];
            if (vm.slideShowList.length > 0 && lastItem.file_type && lastItem.file_type.includes('video')) {
                vm.isPlaying = false;
            }
        }

        function initSlick() {
            vm.isPlaying = true;

            vm.slickConfig = {
                arrows: false,
                autoplay: true,
                autoplaySpeed: 10000,
                infinite: true,
                method: {},
                slidesToShow: vm.numberInLarge,
                slidesToScroll: 1,
                responsive: [
                    {
                        breakpoint: 1200,
                        settings: {
                            slidesToShow: vm.numberInLarge,
                            slidesToScroll: 1,
                            infinite: false
                        }
                    },
                    {
                        breakpoint: 992,
                        settings: {
                            slidesToShow: vm.numberInMedium,
                            slidesToScroll: 1
                        }
                    },
                    {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: vm.numberInSmall,
                            slidesToScroll: 1
                        }
                    }
                ]
            };

            vm.slickConfig.event = {
                breakpoint: function (event, slick, breakpoint) {
                    slick.paused = !vm.isPlaying;
                }
            };

        }

        function compare(a, b) {
            if (a && a.file_type && a.file_type.includes('video')) {
                return 1;
            }
            if (b && b.file_type && b.file_type.includes('video')) {
                return -1;
            }
            return 0;
        }

        vm.initializeVideo = function (isFirst, index) {
            if (isFirst && vm.slideShowList[index].file_type.includes('video')) {
                vm.firstVideoIndex = index;
            } else {
                vm.isPlaying = true;
                vm.slickConfig.autoplay = true;
            }
        };

        vm.startSlideshow = function () {
            if (vm.firstVideoIndex !== undefined) {
                var videoElement = document.querySelector('#initialVideo');
                videoElement.play();
                videoElement.onended = function () {
                    $timeout(function () {
                        vm.isPlaying = true;
                        vm.slickConfig.autoplay = true;
                        $scope.$apply();
                    }, 0);
                };
            } else {
                vm.isPlaying = true;
                vm.slickConfig.autoplay = true;
            }
        };

        vm.autoPlayVideo = function () {
            $timeout(function () {
                var videoElement = document.getElementById('initialVideo');
                if (videoElement) {
                    videoElement.play().catch(function (error) {
                        console.error('Failed to play the video automatically:', error);
                    });
					videoElement.addEventListener('ended', vm.onVideoEnded);
                }
            }, 0);
        };

		vm.onVideoEnded = function () {
			var playPauseButton = document.getElementById('playPauseButton');
			if (playPauseButton) {
				playPauseButton.click();
			}
		};



    }
})();

(function ()
{
	'use strict';

	angular
		.module('app.vehicles')
		.controller('VehicleDetailsController', VehicleDetailsController)

	function VehicleDetailsController($timeout, $scope, MessageService, vehicle, locations, vehicleImages, smallVehicleImages, $state, purchaseInfos, RoleCheckService, VehicleConstants){	 
		const vm = this;
		const isLogin = RoleCheckService.isLogin();
		const canSeeSaleInfo = RoleCheckService.deepCheckRole(VehicleConstants.permissions.canSeeSaleInfo);
		const canSeeServiceMap = isLogin;
		const canSeeTasks = RoleCheckService.deepCheckRole(VehicleConstants.permissions.canSeeTasks);
		
		vm.canSaleVehicle = RoleCheckService.deepCheckRole(VehicleConstants.permissions.toSaleVehicle);
		vm.canEditVehicle = RoleCheckService.deepCheckRole(VehicleConstants.permissions.canEditVehicle);

		vm.getLocationByID = getLocationByID;
		vm.onPurchaseButtonClick = onPurchaseButtonClick;
		vm.isPurchasingVehicle = isPurchasingVehicle;
		vm.goToEditVehicle = goToEditVehicle;

		init();

		function init(){
			if(vehicle == null || !Array.isArray(vehicle.data) || vehicle.data.length <= 0){
				MessageService.showToast("Can not find any vehicles");
				$state.go("app.homepage"); 
				return;
			}

			vm.vehicle = vehicle.data[0];
			vm.latestPurchaseInfo = getLastPurchaseInfo(purchaseInfos);
			vm.isVehicleAvailable = vm.vehicle && !vm.vehicle.is_sold && vm.latestPurchaseInfo && !vm.latestPurchaseInfo.is_canceled;

			initNavBar();
			initLocations();
			initVehicleImages();	
			redirect();
		}

		function getLastPurchaseInfo(purchaseInfoList){
			if(!Array.isArray(purchaseInfoList)){
				return;
			}

			var latestPurchaseInfo;

			purchaseInfoList.forEach(function(purchaseInfo){	
				if(!latestPurchaseInfo || (purchaseInfo && purchaseInfo.purchase_date && latestPurchaseInfo.purchase_date && moment(purchaseInfo.purchase_date).isAfter(moment(latestPurchaseInfo.purchase_date)))){
					latestPurchaseInfo = purchaseInfo;
				}
			});

			return latestPurchaseInfo;
		}

		$scope.$on('$stateChangeSuccess', function(event, toState, toParams, fromState, fromParams){
			vm.currentState = toState.name;
			redirect();
		});

		function initNavBar(){
			vm.navItem = [{
				state:"app.vehicle.general",
				name:"GENERAL"
			}];

			if(isLogin && canSeeTasks){
				vm.navItem.push({
					state:"app.vehicle.tasks",
					name:"TASKS"
				});
			}

			if(RoleCheckService.deepCheckRole(VehicleConstants.permissions.canSeeSafety)){
				vm.navItem.push({
					state:"app.vehicle.safety",
					name:"SAFTIES"
				})
			}

			if(isLogin){
				vm.navItem.push({
					state:"app.vehicle.other",
					name:"OTHER"
				});

				vm.navItem.push({
					state:"app.vehicle.workorder",
					name:"WORK ORDERS"
				});
			}

			if(isLogin && vm.vehicle && vm.vehicle.is_sold && canSeeSaleInfo && canSeeTasks){
				vm.navItem.push({
					state:"app.vehicle.delivery",
					name:"DELIVERY"
				});
			}

			if(isLogin && !vm.isVehicleAvailable && canSeeSaleInfo && canSeeServiceMap){
				vm.navItem.push({
					state:"app.vehicle.customer",
					name:"CUSTOMERS"
				});
			}
		}

		function redirect(){
			if($state.current.name == "app.vehicle"){
				$state.go("app.vehicle.general");
			}
		}

		function getLocationByID(locationID){
			if(!Array.isArray(vm.locations)){
				return;
			}

			return vm.locations.find(function(item){
				return !!item && item.id_location == locationID;
			});
		}

		function initLocations(){
			if(Array.isArray(locations)){
				vm.locations = locations;
			}else{
				vm.locations = [];
			}
		}

		function initVehicleImages(){
			if(Array.isArray(vehicleImages)){
				vm.vehicleImages = vehicleImages;
			} else {
				vm.vehicleImages = [];
			}
			if(Array.isArray(smallVehicleImages)){
				vm.smallVehicleImages = smallVehicleImages;
			} else {
				vm.smallVehicleImages = [];
			}
		}

		function onPurchaseButtonClick(){
			if(isPurchasingVehicle()){
				$state.go("app.vehicle.general");
			} else {
				$state.go("app.vehicle.purchase");
			}
		}

		function isPurchasingVehicle(){
			return vm.currentState == "app.vehicle.purchase";
		}

		function goToEditVehicle (){
			$state.go("app.edit-vehicle", {vehicleID: vm.vehicle.getResourceID()});
		}
	}
})();
(function ()
{
	'use strict';

	angular
		.module('app.vehicles')
		.controller('VehicleDetailsWorkorderController', VehicleDetailsWorkorderController)

	function VehicleDetailsWorkorderController(SaleInfoService, VehicleService, RoleCheckService, $state, WorkOrder, vehicle, WorkOrderConstants, ToolsConstants, $timeout, constants, WorkOrderService, MessageService, LoginService, $stateParams, $q, workorders){	 
		const vm = this;
		const companyID = LoginService.getCompanyID();
		const vehicleID = $stateParams.vehicleID;
		const isMechanic = RoleCheckService.checkRole(["mechanic"]);

		var latestSaleInfo;

		vm.canAddWorkorder = RoleCheckService.deepCheckRole(["vehicle_manager", "salesman", "service_advisor", "mechanic"]);
		vm.canEditComment = RoleCheckService.deepCheckRole(["service_advisor"]);
		vm.hiddenColumns = {
			labors: isMechanic,
			parts: isMechanic,
			outstanding: isMechanic,
			vehicle: true
		}
		vm.saveComment = saveComment;
		vm.createNewWorkOrder = createNewWorkOrder;
		vm.packageItemsMap = {};
		vm.workOrderPackageItemsMap = {};
		vm.getExpiryDate = getExpiryDate;
		init();

		function init(){
			if(vehicle == null || !Array.isArray(vehicle.data) || vehicle.data.length <= 0){
				MessageService.showToast("Can not find any vehicles");
				$state.go("app.homepage"); 
				return;
			}

			vm.vehicle = vehicle.data[0];
			vm.workorderComment = vm.vehicle.work_order_comments;
			vm.constants = constants;

			$timeout(function(){
				if(!Array.isArray(workorders)){
					return;
				}

				vm.workOrderList = workorders.map(function(workOrder){
					return { 
						workOrder: workOrder,
						isLoading: true
					};
				});	
				initCompletedWorkOrderPackageItems();
				initCompletedWorkOrderWarranty();
			});

			$timeout(initWorkOrderTab);

			if(vm.vehicle && vm.vehicle.is_sold){
				initSaleInfo();
			}

		}

		function initSaleInfo(){
			const resourcePath = {
				companyID: companyID,
				vehicleID: vehicleID
			};

			SaleInfoService.getVehicleSaleInfos(resourcePath)
				.then(function(saleInfos){
					if(Array.isArray(saleInfos) && saleInfos[0]){
						latestSaleInfo = saleInfos[0];

						initSalePackages(latestSaleInfo.id_sale_info);
						initSaleWarranty(latestSaleInfo);
					}
				});
		}

		function initCompletedWorkOrderPackageItems(){
			if(vm.workOrderList.length <= 0){
				return
			}
			const resourcePath = {
				companyID: companyID,
				vehicleID: $stateParams.vehicleID,
				workorderID: vm.workOrderList[0].workOrder.id_work_order

			};

			const body = {
				iscompleted: true
			}
			WorkOrderService.getWorkOrderPackages(resourcePath, body).$promise
				.then(function(workorderPackages){
					if(!Array.isArray(workorderPackages)){
						return $q.reject("Failed to fetch available items, workorderPackages are invalid");
					}
					
					const queue = {};
					vm.workorderPackages = workorderPackages
					workorderPackages.forEach(function(workorderPackage){

						if(workorderPackage && workorderPackage.isAvailable()){
							const resourcePath = {
								companyID: companyID,
								vehicleID: $stateParams.vehicleID,
								workorderID: vm.workOrderList[0].workOrder.id_work_order,
								packageID: workorderPackage.id_work_order_package
							};

							queue[workorderPackage.id_work_order_package] = $q.all({
								packageData: workorderPackage,
								packageItems: WorkOrderService.getWorkOrderpackageItems(resourcePath).$promise
							});
						}
					});
					return $q.all(queue);
				})
				.then(function(result){
					if(!result){
						return $q.reject("Failed to fetch work order available items, items are invalid");
					}
					Object.keys(result).forEach(function(packageID){	
						if(result[packageID] && Array.isArray(result[packageID].packageItems)){
							result[packageID].packageItems = result[packageID].packageItems.filter(function(packageItem){
								return packageItem && packageItem.quantity > 0;
							});
						}

						if(result[packageID].packageItems.length <= 0){
							delete result[packageID];
						}
					});

					vm.availableWorkOrderItems = result;
				})
				.catch(MessageService.showToast);
		}

		function initCompletedWorkOrderWarranty(){

			if(vm.workOrderList && vm.workOrderList[0]){
				const resourcePath = {
					companyID: companyID,
					vehicleID: $stateParams.vehicleID,
					workorderID: vm.workOrderList[0].workOrder.id_work_order,
				};
	
				const body = {
					iscompleted: true
				}
	
				WorkOrderService.getWorkOrderWarranties(resourcePath, body).$promise
					.then(function(result){
						if(!result){
							return $q.reject("Failed to fetch work order available warranty, warranty are invalid");
						}
						vm.completedWorkOrderWarranty = result

					})
					.catch(MessageService.showToast);
			}

		}

		function getExpiryDate(duration_month){
			if(typeof(duration_month) == "number"){
				const month =  moment().month();
				return moment().month(month + duration_month).format("YYYY-MM-DD");
			}
		}

		function initSalePackages(saleInfoID){
			const resourcePath = {
				companyID: companyID,
				vehicleID: vehicleID,
				saleinfoID: saleInfoID
			}

			SaleInfoService.getSalePackages(resourcePath).$promise.then(function(salePackages){
				if(!Array.isArray(salePackages)){
					return $q.reject("salePackages is invalid");
				}

				vm.salePackages = salePackages;

				vm.salePackages.forEach(function(salePackage){
					fecthSalePackageItems(saleInfoID, salePackage.id_sale_package)
				});
			});
		}

		function fecthSalePackageItems(saleInfoID, packageID){
			const resourcePath = {
				companyID: companyID,
				vehicleID: $stateParams.vehicleID,
				saleinfoID: saleInfoID,
				packageID: packageID
			};

			SaleInfoService.getSalePackageItems(resourcePath).$promise.then(function(items){
				vm.packageItemsMap[packageID] = items;
			})
			
			.catch(MessageService.showToast);
		}

		function initSaleWarranty(saleInfo){
			if(!saleInfo){
				return;
			}

			const resourcePath = {
				companyID: companyID,
				vehicleID: vehicleID,
				saleinfoID: saleInfo.id_sale_info
			}

			SaleInfoService.getSaleWarranties(resourcePath).then(function(warranties){
				if(!Array.isArray(warranties) || !warranties[0]){
					return;
				}

				vm.warranty = warranties[0];
				var saleMileage = 0;
				var warrantyMileage = 0;

				if(typeof(saleInfo.mileage) == "number"){
					saleMileage = saleInfo.mileage;
				}

				if(typeof(vm.warranty.duration_mileage) == "number"){
					warrantyMileage = vm.warranty.duration_mileage;	
				}

				vm.totalWarrantyCoveredMileage = saleMileage + warrantyMileage;

				const saleDate = saleInfo.getSaleDateMomentObj();

				if(saleDate && saleDate.isValid() && typeof(vm.warranty.duration_month) == "number"){
					const month = saleDate.month();

					vm.warrantyExpiryDate = saleDate.month(month + vm.warranty.duration_month).format("YYYY-MM-DD");
				}

			});
		}

		function initWorkOrderTab(){
			if(!Array.isArray(vm.workOrderList)){
				return;
			}

			vm.workOrderList.forEach(function(workOrderListItem){
				fetchWorkOrderSubResources(workOrderListItem);
			});
		}

		function fetchWorkOrderSubResources(workOrderListItem){
			if(!workOrderListItem || !workOrderListItem.workOrder || isMechanic){
				workOrderListItem.isLoading = false;
				return;
			}

			const queue = {
				labors: fetchWorkOrderLabors(workOrderListItem.workOrder.id_work_order),
				parts: fetchWorkOrderParts(workOrderListItem.workOrder.id_work_order),
				miscfees: fetchWorkOrderMiscfees(workOrderListItem.workOrder.id_work_order, workOrderListItem.workOrder.fk_id_vehicle),
				workorderpackge:fetchWorkOrderPackage(workOrderListItem.workOrder.id_work_order, workOrderListItem.workOrder.fk_id_vehicle),
				workorderwarranty:fetchWorkOrderWarranty(workOrderListItem.workOrder.id_work_order, workOrderListItem.workOrder.fk_id_vehicle),
				inventories: fetchWorkOrderInventories(workOrderListItem.workOrder.id_work_order),
				payments: fetchWorkOrderPayments(workOrderListItem.workOrder.id_work_order),
				discounts: fetchWorkOrderDiscounts(workOrderListItem.workOrder.id_work_order),
				rogerDollarRedeem: fetchRogerDollarRedeemData($stateParams.vehicleID, workOrderListItem.workOrder.id_work_order),
			};

			$q.all(queue).then(function(results){
					if(!results){
						return $q.reject("Failed to get work order subresource with workOrder id:" + workOrderListItem.workOrder.id_work_order);
					}

					workOrderListItem.labors = results.labors;
					workOrderListItem.miscfees = results.miscfees;
					workOrderListItem.workorderpackge = results.workorderpackge;
					workOrderListItem.workorderwarranty = results.workorderwarranty;
					workOrderListItem.parts = results.parts;
					workOrderListItem.inventories = results.inventories;
					workOrderListItem.payments = results.payments;
					workOrderListItem.discounts = results.discounts;
					workOrderListItem.rogerDollarRedeemData = results.rogerDollarRedeem;
				})
				.catch(MessageService.showToast)
				.finally(function(){
					workOrderListItem.isLoading = false;
				});
		}

		function fetchWorkOrderInventories(workOrderID){
			const resourcePath = { 
				companyID: companyID,
				vehicleID: vehicleID,
				workorderID: workOrderID
			};

			return WorkOrderService.getWorkOrderInventories(resourcePath).$promise
		}

		function fetchWorkOrderParts(workOrderID){
			const resourcePath = { 
				companyID: companyID,
				vehicleID: vehicleID,
				workorderID: workOrderID
			};

			return WorkOrderService.getWorkOrderParts(resourcePath).$promise
		}

		function fetchWorkOrderLabors(workOrderID){
			const resourcePath = { 
				companyID: companyID,
				vehicleID: vehicleID,
				workorderID: workOrderID
			};

			return WorkOrderService.getLabors(resourcePath).$promise;
		}

		function fetchWorkOrderMiscfees(workOrderID, vehicleID){
			const resourcePath = { 
				companyID: companyID,
				vehicleID: vehicleID,
				workorderID: workOrderID
			};

			return WorkOrderService.getMiscfeestype(resourcePath).$promise;
		}

		function fetchWorkOrderPackage(workOrderID, vehicleID){
			const resourcePath = { 
				companyID: companyID,
				vehicleID: vehicleID,
				workorderID: workOrderID
			};

			return WorkOrderService.getWorkOrderPackages(resourcePath).$promise;
		}

		function fetchWorkOrderWarranty(workOrderID, vehicleID){
			const resourcePath = { 
				companyID: companyID,
				vehicleID: vehicleID,
				workorderID: workOrderID
			};

			return WorkOrderService.getWorkOrderWarranties(resourcePath).$promise;
		}

		function fetchWorkOrderDiscounts(workOrderID){
			const resourcePath = { 
				companyID: companyID,
				vehicleID: vehicleID,
				workorderID: workOrderID
			};

			return WorkOrderService.getDiscounts(resourcePath).$promise;
		}

		function fetchWorkOrderPayments(workOrderID){
			const resourcePath = { 
				companyID: companyID,
				vehicleID: vehicleID,
				workorderID: workOrderID
			};

			return WorkOrderService.getPayments(resourcePath).$promise;
		}

		function fetchRogerDollarRedeemData(vehicleID, workOrderID) {
			const resourcePath = {
				companyID: companyID,
				vehicleID: vehicleID,
				workorderID: workOrderID
			};

			return WorkOrderService.getredeemedRD(resourcePath).$promise;
		}

		function createNewWorkOrder(){
			const resourcePath = {
				companyID: companyID,
				vehicleID: vehicleID
			}

			const workOrder = new WorkOrder();

			workOrder.quote_date = moment().format(WorkOrderConstants.dateFormat);
			workOrder.fk_id_work_order_status = WorkOrderConstants.statusIDs.quoted;
			workOrder.tax_rate = ToolsConstants.taxRate;

			var lowestPriority;

			if(vm.constants){
				lowestPriority = WorkOrderService.getLowestWorkOrderPriority(vm.constants.workOrderPriorities);
			}
			
			if(lowestPriority){
				workOrder.fk_id_work_order_priority = lowestPriority.id_work_order_priority;
			}

			vm.isCreatingWorkOrder = true;

			return VehicleService.isVehicleAvailable(vehicleID)
				.then(function(isVehicleAvailable){
					if(isVehicleAvailable){
						workOrder.is_subsidized_by_percentage = true;
						workOrder.subsidized_percentage = 1;
					}

					return WorkOrderService.createWorkOrder(resourcePath, workOrder);
				})
				.then(function(newWorkOrderID){
					$state.go("app.edit-workorder.general", {vehicleID: vehicleID, workOrderID: newWorkOrderID});
				})
				.catch(function(error){
					MessageService.showToast(error)
					vm.isCreatingWorkOrder = false;
				});
		}

		function saveComment(){
			if(vm.workorderComment == vm.vehicle.work_order_comments){
				vm.showTextarea = false;
				return;
			}

			const resourcePath = {
				companyID: companyID,
				vehicleID: vehicleID
			}
			
			const requestBody = {
				work_order_comments: vm.workorderComment
			};

			VehicleService.updateVehicle(resourcePath, requestBody)
				.then(function(){
					vm.vehicle.work_order_comments = vm.workorderComment;
					MessageService.showToast("Comment is updated");
					vm.showTextarea = false;
				})
				.catch(MessageService.showToast);
		}

		vm.getCoveredMile = function (duration_mileage, mileage){
			if(duration_mileage){
				return mileage + duration_mileage
			}else{
				return mileage
			}
		}
	}
})();
(function ()
{
	'use strict';

	angular
		.module('app.vehicles')
		.controller('VehicleDetailsTasksController', VehicleDetailsTasksController)

	function VehicleDetailsTasksController(VehicleConstants, vehicle, LoginService, LoginConst, TaskConstants, RoleCheckService, locations, constants, $stateParams, $location, userOptions, Task, $state){	 
		const vm = this;

		vm.canAddTasks = RoleCheckService.deepCheckRole(VehicleConstants.permissions.canAddTasks);
		vm.onTaskFilterChange = onTaskFilterChange;
		vm.createNewTask = createNewTask;
		init();

		function init(){
			if(!RoleCheckService.isLogin()){
				$state.go("app.homepage");
				return;
			}

			initTaskConstants();
			vm.userOptions = userOptions;
			initTaskFilters();
		}

		function initTaskFilters(){
			var pageConfigs;
			vm.taskFilters = {};

			if(Object.keys($location.search()).length > 0){				
				pageConfigs = $stateParams;
				if(!pageConfigs.taskStatus){
					pageConfigs.taskStatus = TaskConstants.notCompletedStatusFilterTag;
				}
			} else {
				pageConfigs = {
					taskStatus: TaskConstants.notCompletedStatusFilterTag
				}
			}

			if(pageConfigs){
				vm.taskFilters.status = pageConfigs.taskStatus;
				vm.taskFilters.searchText = pageConfigs.taskSearchText;
				vm.taskFilters.priority = pageConfigs.taskPriority;
				vm.taskFilters.category = pageConfigs.taskCategory;	
			}

			vm.taskFilters.vehicleId = $stateParams.vehicleID;
		}

		function initTaskConstants(){
			vm.constants = constants;
			if(vm.constants){
				vm.constants.locations = locations;
			}
		}

		function onTaskFilterChange(taskFilters){
			var stateParams = {};

			if(taskFilters){
				stateParams.taskStatus = taskFilters.status;
				stateParams.taskUser = taskFilters.userId;
				stateParams.taskSearchText = taskFilters.searchText;
				stateParams.taskPriority = taskFilters.priority;
				stateParams.taskCategory = taskFilters.category;
			}
			
			$location.search(stateParams).replace();
		}

		function createNewTask(){			
			var params = {}

			if(!!vehicle && Array.isArray(vehicle.data) && vehicle.data.length == 1 && !!vehicle.data[0]){
				var newTask = new Task();	
				newTask.setAssignedVehicle(vehicle.data[0]);
				params.newTask = newTask;
			}

			$state.go("app.add-task", params);
		}
	}
})();
(function ()
{
	'use strict';

	angular
		.module('app.vehicles')
		.controller('VehicleDetailsSafetyController', VehicleDetailsSafetyController)

	function VehicleDetailsSafetyController(RoleCheckService, VehicleConstants, safeties, $state, $stateParams){	 
		const vm = this;
		const vehicleID = $stateParams.vehicleID;

		vm.getSafetyUrl = getSafetyUrl;
		vm.createSafety = createSafety;
		vm.canAddSafety = RoleCheckService.checkRole(VehicleConstants.permissions.canAddSafety);

		init();

		function init(){
			if(!RoleCheckService.checkRole(VehicleConstants.permissions.canSeeSafety)){
				$state.go("app.homepage");
				return;
			}

			initSafeties()
		}

		function initSafeties(){
			if(!Array.isArray(safeties)){
				vm.safeties = [];
			}

			vm.safeties = safeties;
		}

		function createSafety (){
			$state.go("app.create-safety", {vehicleID: $stateParams.vehicleID});
		}

		function getSafetyUrl (safety){
			var params = {
				vehicleID: vehicleID,
				safetyID: safety.getResourceID()
			}

			return $state.href('app.edit-safety', params, {absolute: true});
		}
	}
})();
(function ()
{
	'use strict';

	angular
		.module('app.vehicles')
		.controller('VehicleDetailsPurchaseController', VehicleDetailsPurchaseController)

	function VehicleDetailsPurchaseController(LoginService, LoginConst, $rootScope, $state, vehicle, purchaseInfos, constants, disclosures, RoleCheckService, VehicleConstants){	 
		const vm = this;

		init();

		function init(){
			initSaleMode();
			vm.latestPurchaseInfo = getLastPurchaseInfo(purchaseInfos);

			if(	!RoleCheckService.checkRole(VehicleConstants.permissions.toSaleVehicle) ||
				!vehicle || !Array.isArray(vehicle.data) || vehicle.data.length <= 0 || !vehicle.data[0] || vehicle.data[0].is_sold ||
				!vm.latestPurchaseInfo || vm.latestPurchaseInfo.is_canceled){
				$state.go("app.homepage"); 
				return;
			} 

			vm.vehicle = vehicle.data[0];
			vm.constants = constants;
			vm.disclosures = disclosures;
		}

		function getLastPurchaseInfo(purchaseInfoList){
			if(!Array.isArray(purchaseInfoList)){
				return;
			}

			var latestPurchaseInfo;

			purchaseInfoList.forEach(function(purchaseInfo){	
				if(!latestPurchaseInfo || (purchaseInfo && purchaseInfo.purchase_date && latestPurchaseInfo.purchase_date && moment(purchaseInfo.purchase_date).isAfter(moment(latestPurchaseInfo.purchase_date)))){
					latestPurchaseInfo = purchaseInfo;
				}
			});

			return latestPurchaseInfo;
		}

		function initSaleMode(){
			var salesMode = LoginService.getPageConfigs(LoginConst.pageConfigKeys.salesMode);

			vm.isSalesmanMode = salesMode && salesMode.title == "Salesman";

			$rootScope.$on(VehicleConstants.eventNames.changePurchaseMode, function(event, salesMode){
				vm.isSalesmanMode = salesMode.title == "Salesman";
			});
		}
	}
})();
(function ()
{
	'use strict';

	angular
		.module('app.vehicles')
		.controller('VehicleDetailsOtherController', VehicleDetailsOtherController)

		function VehicleDetailsOtherController($state, vehicle, disclosures, locations, MessageService, VehicleService, LoginService, RoleCheckService, VehicleConstants, TasksService, GeneralTools, TaskConstants, testDriveVehicleHistory){	
		const vm = this;
		const companyID = LoginService.getCompanyID();
		vm.updateVehicleLocation = updateVehicleLocation;
		vm.retrieveTaskList = retrieveTaskList;
		vm.canSeeDisclosure = RoleCheckService.checkRole(VehicleConstants.permissions.canSeeDisclosure);
		vm.filters = {}
		const equalOperator = "eq";
		//vm.constants = constants;
		init();

		function init(){
			if(!RoleCheckService.isLogin()){
				$state.go("app.homepage");
				return;
			}

			initVehicle();
			//retrieveTaskList();
			vm.locations = locations;
			vm.disclosures = disclosures;
			vm.testDriveVehicleHistory = testDriveVehicleHistory
			// $timeout(function(){
			// 	if(!Array.isArray(workorders)){
			// 		return;
			// 	}

			// 	vm.workOrderList = workorders.map(function(workOrder){
			// 		return { 
			// 			workOrder: workOrder,
			// 			isLoading: true
			// 		};
			// 	});	
			// 	refreshList()
			// });
		}

		function initVehicle(){
			if(vehicle == null || !Array.isArray(vehicle.data) || vehicle.data.length <= 0){
				MessageService.showToast("Can not find any vehicles");
				$state.go("app.homepage"); 
				return;
			}

			vm.vehicle = vehicle.data[0];			
		}

		function updateVehicleLocation(){
			if(!vm.vehicle){
				return;
			}

			var resourcePath = {
				companyID: companyID,
				vehicleID: vm.vehicle.getResourceID()
			};

			VehicleService.updateVehicle(resourcePath, {fk_id_location: vm.vehicle.fk_id_location})
				.then(function(){
					MessageService.showToast("Location Upated.");
				})
				.catch(MessageService.showToast);
		}

		vm.getVehicleVin = function (vehicle){
			if(vehicle == null){
				return;
			}

			if(vehicle.vin == null || vehicle.vin.trim() == ''){
				return "N/A";
			}

			return vehicle.vin
		}

		vm. getVehicleLocation = function (locationID){
			if(!vm.constants || !Array.isArray(vm.constants.locations)){
				return "Unkown Location";
			}

			const matchedLocation = vm.constants.locations.find(function(location){
				return location && location.id_location == locationID;
			});

			return matchedLocation;			
		}

		vm.getVehicleName = function (vehicle){
			if(vehicle == null){
				return;
			}

			if((vehicle.year == null) &&
				(vehicle.make == null || vehicle.make.trim() == '') &&
				(vehicle.model == null || vehicle.model.trim() == '')){
				return "N/A";
			}
				
			return vehicle.year + " " + vehicle.make + " " + vehicle.model;
		}

		vm. getVehiclePageUrl = function (vehicle){
			return $state.href('app.vehicle.tasks', {vehicleID: vehicle.id_vehicle}); 
		}
		
		vm. getDueDate = function (task){
			if(task == null || task.due_date == null || task.due_date.trim() == ''){
				return "N/A";
			}

			return task.due_date;
		}

		vm.getDueTime = function (task){
			var dueTime = moment(task.due_time, "HH:mm:ss");

			if(task == null || task.due_date == null || task.due_date.trim() == '' || !dueTime.isValid()){
				return '';
			}

			return dueTime.format("h:mm a");
		}

		
		vm. getCategoryName = function (categoryID){
			var categoryObj = vm.constants.taskCategories.find(function(category){
				return category.id_task_category == categoryID;
			})

			if(categoryObj == null){
				return "Unkown Category";
			}

			return categoryObj.name;
		}


		vm.getPriorityName = function(priorityID){
			var priorityObj = vm.constants.taskPriorities.find(function(priority){
				return priority.id_task_priority == priorityID;
			})

			if(priorityObj == null){
				return "Unkown Priority";
			}

			return priorityObj.name;
		}

		vm.getStatusName = function (statusID){
			var statusObj = vm.constants.taskStatus.find(function(status){
				return status.id_task_status == statusID;
			})

			if(statusObj == null){
				return "Unkown Status";
			}

			return statusObj.name;
		}

		vm.getTaskName = function(task){
			if(task == null || task.name == null || task.name.trim() == ''){
				return "Unkown";
			}

			return task.name;
		}

		vm.getTaskPageUrl = function(task){
			return $state.href('app.edit-task', {taskID: task.getResourceId()}, {absolute: true}); 
		}

		function getPagination(pageToGo){	
			var pagination = {};

			var pageNumber = parseInt(pageToGo);
			var itemsPerPageNumber = parseInt(vm.itemsPerPage);

			if(isNaN(pageNumber)){
				pageNumber = TaskConstants.defaultPage;
			}

			if(isNaN(itemsPerPageNumber)){
				itemsPerPageNumber = TaskConstants.defaultLimitPerPage;
			}

			pagination.page = pageNumber;
			pagination.limit = itemsPerPageNumber;

			return pagination;
		}

		function getPagesAfterCurrentPage (tatalPages, currentPage) {
			var pageNumbers = [];

			for(var i = 1; i <= 5; i++){
				var pageNumber = currentPage + i;
				if( pageNumber <= tatalPages){
					pageNumbers.push(pageNumber);
				}
			}
			return pageNumbers;
		}
		
		function getPagesBeforeCurrentPage (currentPage) {
			var pageNumbers = [];

			for(var i = 5; i > 0; i--){
				var pageNumber = currentPage - i;
				if( pageNumber > 0){
					pageNumbers.push(pageNumber);
				}
			}

			return pageNumbers;
		}

		function extractPaginationFromResponseHeader(headerGetter){
			var pagination = {};

			pagination.currentPage = parseInt(headerGetter("pagination-page"));
			pagination.totalItem = parseInt(headerGetter("pagination-total-item"));
			pagination.itemsPerPage = parseInt(headerGetter("pagination-limit"));

			return pagination;
		}

		function resetPagination(pagination){
			vm.totalTask = pagination.totalItem;
			vm.totalPage = Math.ceil(pagination.totalItem / pagination.itemsPerPage);

			vm.currentPage = pagination.currentPage;

			vm.pagesBeforeCurrentPage = getPagesBeforeCurrentPage(vm.currentPage);
			vm.pagesAfterCurrentPage = getPagesAfterCurrentPage(vm.totalPage, vm.currentPage);
		}

		function buildOperatorFilterString(key, value, operator){
			if(value != null){
				value = value.toString();
			}

			if(typeof(key) != "string" || key.trim() == '' ||
				typeof(value) != "string" || value.trim() == '' ||
				typeof(operator) != "string" || operator.trim() == ''){
				return '';
			}

			return '(' + key + ' ' + operator + ' ' + value + ')';
		}

		function resetSelectedTasks(){
			if(!Array.isArray(vm.tasks)){
				return;
			}
			vm.allChecked = false;
			vm.selectedTaskList = {};

			vm.tasks.forEach(function(task){
				vm.selectedTaskList[task.id_task] = false;
			});
		}

		function getFilter(){

			var filterString = '';
			var statusFilter = '';

			var vehicleFilter 		= buildOperatorFilterString("id_vehicle", vm.vehicle.getResourceID(), equalOperator);
			var notStartFilter = buildOperatorFilterString("fk_id_task_status", 1, equalOperator);
			var inPorgStartFilter = buildOperatorFilterString("fk_id_task_status", 2, equalOperator);

			statusFilter = GeneralTools.stringConnector(statusFilter, notStartFilter, " OR ");
			statusFilter = GeneralTools.stringConnector(statusFilter, inPorgStartFilter, " OR ");
			statusFilter = '(' + statusFilter + ')';

			filterString = GeneralTools.stringConnector(filterString, statusFilter, " AND ");
			filterString = GeneralTools.stringConnector(filterString, vehicleFilter, " AND ");


			return { filters: filterString };
		}

		function retrieveTaskList(pageToGo){
			var resourcePath = { companyID: companyID };
			vm.isFetchingTaskData = true;

			TasksService.getTasks(resourcePath, getFilter(), getPagination(pageToGo))
				.then(function(result){
					if(result == null){
						return $q.reject("Task data is invalid.");
					}

					vm.tasks = result.data;
					resetSelectedTasks();
					resetPagination(extractPaginationFromResponseHeader(result.headerGetter));
				})
				.catch(MessageService.showToast)
				.finally(function(){
					vm.isFetchingTaskData = false;
				});
		}

		vm.getWorkOrderUrl = function  (workOrder){
			if(workOrder){
				return $state.href("app.edit-workorder.general", {workOrderID: workOrder.id_work_order, vehicleID: workOrder.fk_id_vehicle});
			}
		}

		vm.getWorkorderPriority=function (priorityID){
			if(!Array.isArray(vm.constants.workOrderPriorities)){
				return;
			}

			const matchedPriority = vm.constants.workOrderPriorities.find(function(priority){
				return !!priority && priority.id_work_order_priority == priorityID;
			});

			if(matchedPriority){
				return matchedPriority.name;
			}
		}

		vm.getWorkOrderStatus = function (workOrderStatusID){
			if(!Array.isArray(vm.constants.workOrderStatus)){
				return;
			}

			const matchedStatus = vm.constants.workOrderStatus.find(function(status){
				if(!status){
					return;
				}
				return status.id_work_order_status == workOrderStatusID;
			});

			if(matchedStatus){
				return matchedStatus.status;
			}

			return "Unknown"
		}

		function refreshList(){
			if(!Array.isArray(vm.workOrderList)){
				return;
			}
			vm.workOrderList.forEach(function(item){
		
				if(!item){
					return
				}

				const workOrderSummaryCalculator = new WorkOrderSummaryCalculator();

				if(item.workOrder){
					workOrderSummaryCalculator.setTaxRate(item.workOrder.tax_rate);
					workOrderSummaryCalculator.setSubsidizedAmount(item.workOrder.subsidized_amount);
					workOrderSummaryCalculator.setSubsidizedPercentage(item.workOrder.subsidized_percentage);
					workOrderSummaryCalculator.setIsSubsidizedByPercentage(item.workOrder.is_subsidized_by_percentage);
				}

				workOrderSummaryCalculator.setParts(item.parts);
				workOrderSummaryCalculator.setInventories(item.inventories);
				workOrderSummaryCalculator.setLabors(item.labors);
				workOrderSummaryCalculator.setMiscfees(item.miscfees);
				workOrderSummaryCalculator.setWorkOrderPackageList(item.workorderpackge);
				workOrderSummaryCalculator.setWorkOrderWarrantyList(item.workorderwarranty);
				workOrderSummaryCalculator.setDiscounts(item.discounts);
				workOrderSummaryCalculator.setPayments(item.payments);
				workOrderSummaryCalculator.setRDRedeemed(item.rogerDollarRedeemData);

				item.partsAndInventories = combinePartsAndInventories(item.parts, item.inventories);
				item.totalPartsRetail = workOrderSummaryCalculator.getPartsAndInventoryTotalRetail();
				item.totalLaborsCost = workOrderSummaryCalculator.getTotalLaborsCost();
				item.totalMiscfeesCost = workOrderSummaryCalculator.getTotalMiscfeesCost();
				item.totalWorkOrderPackageCost = workOrderSummaryCalculator.getTotalWorkOrderPackageListCost();
				item.totalWorkOrderWarrantyCost = workOrderSummaryCalculator.getTotalWorkOrderWarrantyListCost();
				item.outstanding = workOrderSummaryCalculator.getOutstanding();
			})
		}

		function combinePartsAndInventories(parts, inventories){
			if(!Array.isArray(parts)){
				parts = [];
			}

			if(!Array.isArray(inventories)){
				inventories = [];
			}

			var list = [];

			parts.forEach(function(part){
				list.push({
					name: part.name,
					isFromInventory: false,
					isOrdered: part.is_ordered
				});
			});

			inventories.forEach(function(inventory){
				list.push({
					name: inventory.name,
					isFromInventory: true
				});
			});

			return list;
		}

		vm.getCustomerProfileUrl = function(customerID){
			return $state.href("app.view-customer", { customerID: customerID });
		}
	}
})();
(function ()
{
	'use strict';

	angular
		.module('app.vehicles')
		.controller('VehicleDetailsGeneralController', VehicleDetailsGeneralController)

	function VehicleDetailsGeneralController(MessageService, vehicle, vehicleFeatures, $state){	 
		const vm = this;

		vm.hasMoreFeatures = hasMoreFeatures;
		vm.openUrlInNewTab = openUrlInNewTab;

		init();

		function init(){
			if(vehicle == null || !Array.isArray(vehicle.data) || vehicle.data.length <= 0){
				MessageService.showToast("Can not find any vehicles");
				$state.go("app.homepage"); 
				return;
			}

			vm.vehicle = vehicle.data[0];
			initVehicleFeatures();
		}

		function initVehicleFeatures(){
			if(!Array.isArray(vehicleFeatures)){
				return;
			}

			vm.vehicleFeatures = {};

			vehicleFeatures.forEach(function(feature){
				var category = feature.category;

				if(vm.vehicleFeatures[category] == null){
					vm.vehicleFeatures[category] = [];
				}

				vm.vehicleFeatures[category].push(feature);
			})
		}

		function hasMoreFeatures(){
			return vm.vehicleFeatures && Object.keys(vm.vehicleFeatures).length > 0;
		}

		function openUrlInNewTab(url) {
			window.open(url, '_blank');
		}
	}
})();
(function ()
{
	'use strict';

	angular
		.module('app.vehicles')
		.controller('VehicleDetailsDeliveryController', VehicleDetailsDeliveryController)

	function VehicleDetailsDeliveryController(constants, $stateParams, saleInfos, RoleCheckService, vehicle, $state){	 
		const vm = this;

		init();

		function init(){
			if(!RoleCheckService.isLogin() || !vehicle || !Array.isArray(vehicle.data) || !vehicle.data[0] || !vehicle.data[0].is_sold){
				$state.go("app.homepage");
				return;
			}

			vm.saleInfos = saleInfos
			vm.vehicleID = $stateParams.vehicleID;

			if(constants){
				vm.workorderPriorities = constants.workOrderPriorities;
			}			
		}

	}
})();
(function ()
{
	'use strict';

	angular
		.module('app.vehicles')
		.controller('VehicleDetailsCustomerController', VehicleDetailsCustomerController)

	function VehicleDetailsCustomerController(DialogService, $location, WorkOrderService, ToolsConstants, GeneralTools, LoginService, $q, $stateParams, saleInfos, RoleCheckService, vehicle, $state, serviceMap, CustomersService, MessageService){	 
		const vm = this;
		const companyID = LoginService.getCompanyID();

		vm.canAddCustomer = RoleCheckService.deepCheckRole(["salesman", "service_advisor"]);

		vm.vehicleID = $stateParams.vehicleID;
		vm.phoneNumberTranslator = GeneralTools.inputTranslators.phoneNumber;
		vm.capitalizeTranslator = GeneralTools.inputTranslators.initCapitalize;
		vm.queryCustomer = queryCustomer;
		vm.getCustomerPageUrl = getCustomerPageUrl;
		vm.onAddCustomerClick = onAddCustomerClick;
		vm.deleteCustomer = deleteCustomer;
		vm.selectCustomer = selectCustomer;
		vm.customerSelected;
		vm.customerSelectedName;
		vm.workOrderDateRangeEnd;
		vm.workOrderDateRangeStart = moment().format("MM/DD/YYYY")
		vm.isAdding = false;
		vm.fetchCustomerData = fetchCustomerData;

		init();

		function init(){
			vm.customerList = {};
			if(!Array.isArray(saleInfos)){
				return;
			}
			vm.saleInfos = saleInfos
			saleInfos.forEach(function(saleInfo){
				if(!saleInfo || saleInfo.is_canceled){
					return;
				}

				if(!vm.customerList[saleInfo.fk_id_customer]){
					vm.customerList[saleInfo.fk_id_customer] = {};
				}

				if(!Array.isArray(vm.customerList[saleInfo.fk_id_customer].saleInfos)){
					vm.customerList[saleInfo.fk_id_customer].saleInfos = [];
				}

				vm.customerList[saleInfo.fk_id_customer].saleInfos.push(saleInfo);
			})

			if(!Array.isArray(serviceMap)){
				return;
			}
			vm.serviceMap = serviceMap
			serviceMap.forEach(function(item){
				if(!item || !item.customer){
					return;
				}

				if(!vm.customerList[item.customer.id_customer]){
					vm.customerList[item.customer.id_customer] = {};
				}

				vm.customerList[item.customer.id_customer].customerInfo = {
					id_customer: item.customer.id_customer,
					first_name: item.customer.first_name,
					last_name: item.customer.last_name,
					work_order_filter_end:  item.customer.work_order_filter_end,
					work_order_filter_start: item.customer.work_order_filter_start,
					is_From_Service_Map: true
				}

				vm.customerList[item.customer.id_customer].serviceMapID = item.id_service_map;
			});

			const queue = [];

			Object.keys(vm.customerList).forEach(function(customerID){
				if(!vm.customerList[customerID] || !vm.customerList[customerID].customerInfo){
					queue.push(fetchCustomerData(customerID));
				}
			});

			vm.fetchingCustomersData = true;

			$q.all(queue)
				.then(function(result){
					if(!Array.isArray(result)){
						return $q.reject("Customers data invalid");
					}

					result.forEach(function(customer){
						if(!customer){
							return;
						}

						if(!vm.customerList[customer.id_customer]){
							vm.customerList[customer.id_customer] = {};
						}

						vm.customerList[customer.id_customer].customerInfo = customer;
						vm.customerList[customer.id_customer].customerInfo.work_order_filter_end = vm.customerList[customer.id_customer].saleInfos[0].work_order_filter_end
						vm.customerList[customer.id_customer].customerInfo.work_order_filter_start = vm.customerList[customer.id_customer].saleInfos[0].work_order_filter_start
						vm.customerList[customer.id_customer].customerInfo.is_From_sale_info =  true
					});

					if($stateParams.newCustomerID){
						return fetchCustomerData($stateParams.newCustomerID).then(addCustomer);
					}
					
					return $q.resolve()
				})
				.catch(MessageService.showToast)
				.finally(function(){
					$location.search({}).replace();
					vm.fetchingCustomersData = false;
				});
		}

		function fetchCustomerData(customerID){
			const resourcePath = {
				companyID: companyID,
				customerID: customerID
			};

			return CustomersService.getCustomers(resourcePath)
				.then(function(result){
					if(!result || !Array.isArray(result.data) || result.data.length != 1 || !result.data[0]){
						return $q.reject("customer data invalid");
					}

					return $q.resolve(result.data[0]);
				})
		}

		function queryCustomer(){
			const resourcePath = {
				companyID: companyID
			};

			const filter = getCustomerFilter();

			if(!filter){
				return;
			}

			vm.isQueryingCustomer = true;

			CustomersService.getCustomers(resourcePath, filter)
				.then(function(result){
					if(!result || !Array.isArray(result.data)){
						return $q.reject("customer data invalid");
					}

					vm.matchedCustomers = result.data;
				})
				.catch(MessageService.showToast)
				.finally(function(){
					vm.isQueryingCustomer = false;
				});
		}

		function getCustomerFilter(){
			var filterString = '';

			if(vm.firstNameFilter){
				filterString = GeneralTools.containFilterBuilder("first_name", vm.firstNameFilter)
			}

			if(vm.lastNameFilter){
				filterString = GeneralTools.stringConnector(filterString, GeneralTools.containFilterBuilder("last_name", vm.lastNameFilter), ToolsConstants.apiFilters.andConnector);
			}

			if(vm.phoneNumberFilter){
				filterString = GeneralTools.stringConnector(filterString, GeneralTools.containFilterBuilder("phone_number", vm.phoneNumberFilter), ToolsConstants.apiFilters.andConnector);
			}

			if(filterString){
				return { filters: filterString };
			}
		}

		function getCustomerPageUrl(customerID){
			return $state.href("app.view-customer", {customerID: customerID});
		}

		// function onAddCustomerClick(customer){
		// 	addCustomer(customer).catch(MessageService.showToast);
		// }
		function onAddCustomerClick(){
			vm.isAdding = true
			addCustomer(vm.customerSelected).catch(MessageService.showToast);
		}

		function addCustomer(customer){
			if(!customer){
				MessageService.showToast("customer data invalid.");
				return;
			}

			const resourcePath = {
				companyID: companyID
			};

			const newServiceMap = {
				vehicle:{
					id_vehicle: vm.vehicleID,
				},
				customer:{
					id_customer: customer.id_customer,
					work_order_filter_end: vm.workOrderDateRangeEnd,
					work_order_filter_start: vm.workOrderDateRangeStart
				}
			};

			return WorkOrderService.createServiceMap(resourcePath, newServiceMap)
				.then(function(newServiceMapID){
					if(vm.customerList){
						vm.customerList[customer.id_customer] = {
							serviceMapID: newServiceMapID,
							customerInfo:{
								first_name: customer.first_name,
								last_name: customer.last_name,
								work_order_filter_end:  vm.workOrderDateRangeEnd,
								work_order_filter_start: vm.workOrderDateRangeStart
							}
						}
					}

					vm.customerSelected = null
					vm.customerSelectedName = null
					vm.workOrderDateRangeEnd = null
					vm.workOrderDateRangeStart = null
					vm.isAdding = false

					return $q.resolve();
				});			
		}


		function deleteCustomer(serviceMapID, customerID, customerName){
			const dialogOptions = {};

			dialogOptions.titleString = "Warning";
			dialogOptions.contentString = "Are you sure to delete customer " + customerName + " from vehicle?";

			const confirmOption = {};

			confirmOption.optionName = "YES";
			confirmOption.onClick = function(){
				confirmDeleteCustomerCallback(serviceMapID, customerID);
				DialogService.close();
			}

			var cancelOption = {};

			cancelOption.optionName = "NO";
			cancelOption.onClick = function(){
				DialogService.close();
			}

			dialogOptions.options = [confirmOption, cancelOption];

			DialogService.showOptionsDialog(dialogOptions);

		}

		function confirmDeleteCustomerCallback(serviceMapID, customerID){
			var resourcePath = {
				companyID: companyID,
				servicemapID: serviceMapID
			}
			
			vm.isDeletingCustomer = true;

			WorkOrderService.deleteServiceMap(resourcePath)
				.then(function(){
					if(!vm.customerList){
						return;
					}

					delete vm.customerList[customerID];

					MessageService.showToast("Customer removed");
				})
				.catch(MessageService.showToast)
				.finally(function(){
					vm.isDeletingCustomer = false;
			})
		}

		function selectCustomer(customer){
			vm.customerSelected = customer;
			vm.customerSelectedName = customer.first_name + " " + customer.last_name
			vm.firstNameFilter = null
			vm.lastNameFilter = null
			vm.phoneNumberFilter= null


		}
	}
})();
(function ()
{
	"use strict";

	angular
		.module("app.vehicles")
		.component("vehicleCustomerList", {
				bindings:{
					disableDelete: '=',
					onDeleteClick: '<',
					customerList: '=',
					vehicleId: '<',
					saleInfos: '=',
					serviceMap: '=',
					fetchCustomerData: '<'
				},
				templateUrl: "app/main/vehicles/vehicle-details/vehicle-customer-list.html",
				controller: componentController,
		  		controllerAs: 'vm'
			});

		function componentController($state, $stateParams, ProgressService, VehicleService, LoginService, MessageService, DialogService){
			const vm = this;
			
			vm.getCustomerPageUrl = getCustomerPageUrl;
			vm.getSaleInfoPageUrl = getSaleInfoPageUrl;
			vm.hasCustomer = hasCustomer;
			vm.editingDate = false
			vm.startDateList = {}
			vm.endDateList = {}
			vm.workOrderFilterStartDatePicker
			vm.workOrderFilterEndDatePicker
			vm.vehicleID = $stateParams.vehicleID;
			vm.deleteCustomerTimeRange = deleteCustomerTimeRange;
			const companyID = LoginService.getCompanyID();

			function getSaleInfoPageUrl(saleInfoID){
				return $state.href("app.edit-sale-info", {vehicleID: vm.vehicleId, saleInfoID: saleInfoID});
			}

			function getCustomerPageUrl(customerID){
				return $state.href("app.view-customer", {customerID: customerID});
			}

			function hasCustomer(){
				return !!vm.customerList && Object.keys(vm.customerList).length > 0;
			}

			vm.editStartDate = function editStartDate(item, customerID){

				forceStopEditing();
				if(item.work_order_filter_start){
					vm.workOrderFilterStartDatePicker = moment(item.work_order_filter_start)
				}
				vm.startDateList[item.id_customer] = true

			}

			vm.saveStartDate = function saveStartDate(item, customerID){
				if(checkDateValid(item)){
					updateTimeRange(item, true, customerID)
					vm.startDateList[item.id_customer] = false
				}else{
					MessageService.showToast("Incorrect start date, please select a valid date!");
					return 
				}

			}

			vm.editEndDate = function editEndDate(item, customerID){
				forceStopEditing();
				if(item.work_order_filter_end){
					vm.workOrderFilterEndDatePicker = moment(item.work_order_filter_end)
				}
				
				vm.endDateList[item.id_customer] = true
			}

			vm.saveEndDate = function editEndDate(item, customerID){
				if(checkDateValid(item)){
					updateTimeRange(item, false, customerID)
					vm.endDateList[item.id_customer] = false
				}else{
					MessageService.showToast("Incorrect end date, please select a valid date!");
					return
				}

			}

			vm.deleteStartDate = function deleteStartDate(item, customerID){
				deleteTimeRange(item, true, customerID)
			}

			vm.deleteEndDate = function deleteEndDate(item, customerID){
				deleteTimeRange(item, false, customerID)
			}

			function forceStopEditing(){
				for (var key in vm.startDateList) {
					if (vm.startDateList.hasOwnProperty(key)) {
						vm.startDateList[key] = false;
					}
				}

				for (var key in vm.endDateList) {
					if (vm.endDateList.hasOwnProperty(key)) {
						vm.endDateList[key] = false;
					}
				}
			}

			function updateTimeRange(item, dateTypeBoolean, customerID){
				if(!vm.vehicleID || !item){
					return;
				}
	
				ProgressService.addTaskToQueue();
				var requestBody = {}

				if(item.is_From_Service_Map){
					requestBody.is_From_Service_Map = true
				}

				if(item.is_From_sale_info){
					requestBody.is_From_sale_info = true
				}

				if(item.is_From_Service_Map == undefined && item.is_From_sale_info == undefined){
					requestBody.is_From_Service_Map = true
				}

				if(dateTypeBoolean){
					requestBody.editingStartDate = true
				}else{
					requestBody.editingEndtDate = true
				}

				requestBody.work_order_filter_end = vm.workOrderFilterEndDatePicker
				requestBody.work_order_filter_start = vm.workOrderFilterStartDatePicker

				VehicleService.updateWorkOrderFilter(companyID,  vm.vehicleID, customerID, requestBody).$promise
					.then(function(vehicles){

						if(dateTypeBoolean && vm.workOrderFilterStartDatePicker){
							item.work_order_filter_start = moment(vm.workOrderFilterStartDatePicker).format("YYYY-MM-DD")
						}
						
						if(!dateTypeBoolean && vm.workOrderFilterEndDatePicker){
							item.work_order_filter_end = moment(vm.workOrderFilterEndDatePicker).format("YYYY-MM-DD")
						}

						vm.workOrderFilterEndDatePicker = undefined
						vm.workOrderFilterStartDatePicker = undefined
						MessageService.showToast("Success!");

					})
					.catch(MessageService.showToast)
					.finally(ProgressService.removeTaskFromQueue)
			}

			function deleteTimeRange(item, dateTypeBoolean, customerID){
				if(!vm.vehicleID || !item){
					return;
				}
	
				ProgressService.addTaskToQueue();
				var requestBody = {}

				if(item.is_From_Service_Map){
					requestBody.is_From_Service_Map = true
				}

				if(item.is_From_sale_info){
					requestBody.is_From_sale_info = true
				}

				if(item.is_From_Service_Map == undefined && item.is_From_sale_info == undefined){
					requestBody.is_From_Service_Map = true
				}

				if(dateTypeBoolean){
					requestBody.editingStartDate = true
					requestBody.work_order_filter_start = null
					
				}else{
					requestBody.editingEndtDate = true
					requestBody.work_order_filter_end = null
				}


				
				
				VehicleService.updateWorkOrderFilter(companyID,  vm.vehicleID, customerID, requestBody).$promise
					.then(function(result){

						if(dateTypeBoolean){
							item.work_order_filter_start = undefined
						}else{
							item.work_order_filter_end = undefined
						}

						vm.workOrderFilterEndDatePicker = undefined
						vm.workOrderFilterStartDatePicker = undefined


					})
					.catch(MessageService.showToast)
					.finally(ProgressService.removeTaskFromQueue)
			}

			function checkDateValid(item){
				var startDateTempHolder = item.work_order_filter_start
				var endDateTempHolder = item.work_order_filter_end
				if( vm.workOrderFilterStartDatePicker){
					if(endDateTempHolder == null){
						return true
					}
					if(moment(vm.workOrderFilterStartDatePicker).isBefore(endDateTempHolder)){
						return true
					}
				}
				else if(vm.workOrderFilterEndDatePicker){
					if(startDateTempHolder == null){
						return true
					}

					if(moment(vm.workOrderFilterEndDatePicker).isAfter(startDateTempHolder)){
						return true
					}
				}
				else if(vm.workOrderFilterStartDatePicker == undefined)
				{
					return true
				}
				else if(vm.workOrderFilterEndDatePicker == undefined)
				{
					return true
				}else{
					return false
				}


				
			}

			function deleteCustomerTimeRange(item, text, customerID){
				const dialogOptions = {};
				dialogOptions.titleString = "Warning";
				//dialogOptions.contentString = "Are you sure to delete customer: " + item.first_name + " " + item.last_name + "'s time range filter ";
				if(text == 0){
					dialogOptions.contentString += "Are you sure you want to delete invoices from? The user will be able to see all invoices in the past ?"
					if(item.work_order_filter_start == null){
						return
					}
				}
			
				if(text == 1){
					dialogOptions.contentString += "Are you sure you want to delete invoices to? The user will be able to see all invoices in the future"
					if(item.work_order_filter_end == null){
						return
					}
				}
				
				const confirmOption = {};
				confirmOption.optionName = "YES";
				confirmOption.onClick = function(){
					// confirmDeleteCustomerCallback(serviceMapID, customerID);
					if(text == 0 ){
						deleteTimeRange(item, true, customerID)
					}else{
						deleteTimeRange(item, false, customerID)
					}
					DialogService.close();
				}
	
				var cancelOption = {};
	
				cancelOption.optionName = "NO";
				cancelOption.onClick = function(){
					DialogService.close();
				}
	
				dialogOptions.options = [confirmOption, cancelOption];
	
				DialogService.showOptionsDialog(dialogOptions);
	
			}

			function init(){
				vm.customerList = {};
				if(!Array.isArray(saleInfos)){
					return;
				}
				saleInfos.forEach(function(saleInfo){
					if(!saleInfo || saleInfo.is_canceled){
						return;
					}
	
					if(!vm.customerList[saleInfo.fk_id_customer]){
						vm.customerList[saleInfo.fk_id_customer] = {};
					}
	
					if(!Array.isArray(vm.customerList[saleInfo.fk_id_customer].saleInfos)){
						vm.customerList[saleInfo.fk_id_customer].saleInfos = [];
					}
	
					vm.customerList[saleInfo.fk_id_customer].saleInfos.push(saleInfo);
				})
	
				if(!Array.isArray(serviceMap)){
					return;
				}
				serviceMap.forEach(function(item){
					if(!item || !item.customer){
						return;
					}
	
					if(!vm.customerList[item.customer.id_customer]){
						vm.customerList[item.customer.id_customer] = {};
					}
	
					vm.customerList[item.customer.id_customer].customerInfo = {
						id_customer: item.customer.id_customer,
						first_name: item.customer.first_name,
						last_name: item.customer.last_name,
						work_order_filter_end:  item.customer.work_order_filter_end,
						work_order_filter_start: item.customer.work_order_filter_start,
						is_From_Service_Map: true
					}
	
					vm.customerList[item.customer.id_customer].serviceMapID = item.id_service_map;
				});
	
				const queue = [];
	
				Object.keys(vm.customerList).forEach(function(customerID){
					if(!vm.customerList[customerID] || !vm.customerList[customerID].customerInfo){
						queue.push(vm.fetchCustomerData(customerID));
					}
				});
	
				vm.fetchingCustomersData = true;
	
				$q.all(queue)
					.then(function(result){
						if(!Array.isArray(result)){
							return $q.reject("Customers data invalid");
						}
	
						result.forEach(function(customer){
							if(!customer){
								return;
							}
	
							if(!vm.customerList[customer.id_customer]){
								vm.customerList[customer.id_customer] = {};
							}
	
							vm.customerList[customer.id_customer].customerInfo = customer;
							vm.customerList[customer.id_customer].customerInfo.work_order_filter_end = vm.customerList[customer.id_customer].saleInfos[0].work_order_filter_end
							vm.customerList[customer.id_customer].customerInfo.work_order_filter_start = vm.customerList[customer.id_customer].saleInfos[0].work_order_filter_start
							vm.customerList[customer.id_customer].customerInfo.is_From_sale_info =  true
						});
	
						if($stateParams.newCustomerID){
							return vm.fetchCustomerData($stateParams.newCustomerID).then(addCustomer);
						}
						return $q.resolve()
					})
					.catch(MessageService.showToast)
					.finally(function(){
						$location.search({}).replace();
						vm.fetchingCustomersData = false;
					});
			}


		}
})();
(function ()
{
	"use strict";

	angular
		.module("app.vehicles")
		.component("deliverStaus", {
				bindings:{
					saleInfos:'<',
					vehicleId:'<',
					workorderPriorities: '<'
				},
				templateUrl: "app/main/vehicles/vehicle-details/deliver-status.html",
				controller: componentController,
		  		controllerAs: 'vm'
			});

		function componentController(WorkOrderConstants, WorkOrderService, ToolsConstants, GeneralTools, $filter, $state, $q, $scope, SaleInfoService, MessageService, LoginService, ProgressService, PurchaseInfoService, TasksService, TaskConstants){
			var vm = this;	
			var originSaleInfos;
			var companyID = LoginService.getCompanyID();

			vm.completedTaskStatus = 3;
			vm.mechanicTaskCatagory = 5;
			vm.detailTaskCatagory = 2;

			vm.$onInit = initComponent;

			vm.getSaleInfoUrl = getSaleInfoUrl;
			vm.onIsDeliveredChange = onIsDeliveredChange;
			vm.saveChanges = saveChanges;
			vm.setDeliveryDueDate = setDeliveryDueDate;
			vm.getTaskUrl = getTaskUrl;
			vm.getWorkorderUrl = getWorkorderUrl;
			vm.getWorkorderPriority = getWorkorderPriority;

			function initComponent(){
				initSaleInfos();
				initNotCompletedTasks();
				initActiveWorkorders();
			}

			function getWorkorderPriority(priorityID){
				if(!Array.isArray(vm.workorderPriorities)){
					return;
				}

				const matchedPriority = vm.workorderPriorities.find(function(priority){
					return !!priority && priority.id_work_order_priority == priorityID;
				});

				if(matchedPriority){
					return matchedPriority.name;
				}
			}

			function initActiveWorkorders(){
				const resourcePath = {
					companyID: companyID,
					vehicleID: vm.vehicleId
				}

				const filters = {filters: GeneralTools.equalFilterBuilder(WorkOrderConstants.keyNames.status, WorkOrderConstants.statusIDs.quoted)};

				WorkOrderService.getWorkOrders(resourcePath, filters).$promise
					.then(function(workorders){
						vm.quotedWorkorders = workorders
					})
					.catch(MessageService.showToast);
			}

			function initNotCompletedTasks(){
				var taskResourcePath = {companyID: companyID};
				var filterString = '';
				const vehicleFilter = GeneralTools.equalFilterBuilder("id_vehicle", vm.vehicleId);
				const categoryFilter = GeneralTools.equalFilterBuilder("fk_id_task_category", TaskConstants.taskCategoryDetailFk);
				const notStartFilter = GeneralTools.equalFilterBuilder("fk_id_task_status", TaskConstants.taskStatusNotStartFk);
				const inProgressFilter = GeneralTools.equalFilterBuilder("fk_id_task_status", TaskConstants.taskStatusInProgressFk);
				const statusFilter = GeneralTools.addBracketToString(GeneralTools.stringConnector(notStartFilter, inProgressFilter, ToolsConstants.apiFilters.orConnector));

				filterString = GeneralTools.stringConnector(vehicleFilter, categoryFilter, ToolsConstants.apiFilters.andConnector);	
				filterString = GeneralTools.stringConnector(filterString, statusFilter, ToolsConstants.apiFilters.andConnector);

				vm.notCompletedDetailTasks = [];
				vm.notCompletedMechanicTasks = [];

				TasksService.getAllMatchedTasks(taskResourcePath, { filters: filterString })
					.then(function(tasks){
						if(!Array.isArray(tasks)){
							return $q.reject("Tasks data in deliver status is invalid");
						}

						vm.notCompletedDetailTasks = tasks;
					})
					.catch(MessageService.showToast)
			}

			function getTaskUrl(task){
				return $state.href('app.edit-task', {taskID: task.id_task}, {absolute: true});
			}

			function initSaleInfos(){
				vm.deliveryDueDatePickerValues = [];
				vm.pickupAppointmentReminderDate = null;

				if(Array.isArray(vm.saleInfos)){
					vm.saleInfos.forEach(function(saleInfo){
						vm.deliveryDueDatePickerValues[saleInfo.getResourceID()] = saleInfo.getDeliveryDueDateMomentObj();
						if(!saleInfo.is_canceled){
							vm.pickupAppointmentReminderDate = moment(saleInfo.delivery_due_date)
							.subtract(1, 'days')
							.hour(11)
							.minute(0)
							.second(0)
							.toDate();
						}
					});
				}

				originSaleInfos = angular.copy(vm.saleInfos);
			}

			function onIsDeliveredChange(saleInfo){
				if(saleInfo == null){
					return;
				}

				if(saleInfo.is_delivered == true){
					saleInfo.setDeliveryDate(moment());
				} else {
					saleInfo.setDeliveryDate(null);
				}
			}

			function setDeliveryDueDate (saleInfo, date){
				saleInfo.setDeliveryDueDate(moment(date));
				vm.pickupAppointmentReminderDate = moment(date)
					.subtract(1, 'days')
					.hour(11)
					.minute(0)
					.second(0)
					.toDate();
			}

			function getSaleInfoUrl (saleInfo){
				var param = {
					vehicleID: vm.vehicleId,
					saleInfoID: saleInfo.getResourceID()
				};

				return $state.href('app.edit-sale-info', param, {absolute: true}); 
			}

			function getWorkorderUrl(workorderID){
				const param = {
					vehicleID: vm.vehicleId,
					workOrderID: workorderID
				}

				return $state.href('app.edit-workorder.general', param); 
			}

			function saveChanges (saleInfo, index){
				if($scope.saleInfoForms["form" + index].$invalid){
					MessageService.showToast("Please make sure the form is valid");
					return;
				}

				var originSaleInfo = originSaleInfos.find(function(item){
					return item.getResourceID() == saleInfo.getResourceID();
				});

				var saleInfoRequestBody = SaleInfoService.updateSaleInfoRequestBodyGenerator(saleInfo, originSaleInfo);

				if(saleInfoRequestBody == null || Object.keys(saleInfoRequestBody).length <= 0 
					|| (Object.keys(saleInfoRequestBody).length == 1 && Object.keys(saleInfoRequestBody)[0] == "$$hashKey")){
					MessageService.showToast("No changes detected.");
					return;
				}

				var resourcePath = {
					companyID: companyID,
					vehicleID: vm.vehicleId,
					saleinfoID: saleInfo.getResourceID()
				}

				ProgressService.setMode("indeterminate");
				ProgressService.isVisble(true);

				SaleInfoService.updateVehicleSaleInfo(resourcePath, saleInfoRequestBody)
					.then(function(){
						MessageService.showToast("Success.");
						originSaleInfos = angular.copy(vm.saleInfos);
					})
					.catch(MessageService.showToast)
					.finally(function(){
						ProgressService.isVisble(false);
					});
			}

			vm.saveChangesWithPromise = function (saleInfo, index) {
				if ($scope.saleInfoForms['form' + index].$invalid) {
					MessageService.showToast('Please make sure the form is valid');
					return $q.reject('form invalid');
				}

				const origin = originSaleInfos.find(function(item) {
					return item.getResourceID() === saleInfo.getResourceID();
				});
				const body = SaleInfoService.updateSaleInfoRequestBodyGenerator(saleInfo, origin);
				const keys = body && Object.keys(body) || [];
				if (!body || keys.length === 0 || (keys.length === 1 && keys[0] === '$$hashKey')) {
					MessageService.showToast('No changes detected.');
					return $q.reject('no changes');
				}

				ProgressService.setMode('indeterminate');
				ProgressService.isVisble(true);
				return SaleInfoService
					.updateVehicleSaleInfo({
						companyID: companyID,
						vehicleID: vm.vehicleId,
						saleinfoID: saleInfo.getResourceID()
					},
						body
					)
					.then(function (resp) {
						MessageService.showToast('Save successful.');
						originSaleInfos = angular.copy(vm.saleInfos);
						return resp;        
					})
					.catch(function (err) {
						MessageService.showToast(err);
						return $q.reject(err);
					})
					.finally(function () {
						ProgressService.isVisble(false);
					});
			};

			vm.createPickupAppointment = function (saleInfo, index, method) {
				// vm.saveChangesWithPromise(saleInfo, index)
				// 	.then(function () {
				// 		return vm.schedulePickup(saleInfo, method);
				// 	})
				// 	.then(function (pickupResp) {
				// 		MessageService.showToast('Pick‑up appointment scheduled!');
				// 	})
				// 	.catch(function (err) {
				// 		console.warn('Skipped scheduling because:', err);
				// 	});
				return vm.schedulePickup(saleInfo, method)
			};

			vm.pendingCopyUrl = null;
			vm.showCopyPanel = false;

			// vm.schedulePickup = function (saleInfo, method) {
			// const resourcePath = {
			// 	companyID: companyID,
			// 	vehicleID: vm.vehicleId,
			// 	saleinfoID: saleInfo.getResourceID()
			// };
			// saleInfo.method = method;

			// ProgressService.setMode("indeterminate");
			// ProgressService.isVisble(true);

			// SaleInfoService.createPickUpAccess(resourcePath, saleInfo)
			// 	.then(function (result) {
			// 	if (method === 'copy' && result && result.url) {
			// 		const text = result.url;
			// 		console.log(result)
			// 		// Try navigator.clipboard first (requires HTTPS or localhost)
			// 		const copy = (navigator.clipboard && window.isSecureContext)
			// 		? navigator.clipboard.writeText(text)
			// 		: new Promise(function(resolve, reject) {
			// 			try {
			// 				const ta = document.createElement('textarea');
			// 				ta.value = text;
			// 				ta.setAttribute('readonly', '');
			// 				ta.style.position = 'fixed';
			// 				ta.style.top = '-9999px';
			// 				document.body.appendChild(ta);
			// 				ta.select();
			// 				const ok = document.execCommand('copy');
			// 				document.body.removeChild(ta);
			// 				ok ? resolve() : reject(new Error('execCommand failed'));
			// 			} catch (e) { reject(e); }
			// 			});

			// 		return copy
			// 		.then(function () { MessageService.showToast("URL copied to clipboard."); })
			// 		.catch(function (e) { 
			// 			console.error(e);
			// 			MessageService.showToast("Could not copy URL. It's shown in console.");
			// 		});
			// 	}

			// 	MessageService.showToast("Success.");
			// 	})
			// 	.catch(function (err) {
			// 	// Your toast likely expects a string
			// 	console.log(err);
			// 	MessageService.showToast(err && err.length > 0 ? err : "Something went wrong.");
			// 	})
			// 	.finally(function () {
			// 	ProgressService.isVisble(false);
			// 	});
			// };

			vm.schedulePickup = function (saleInfo, method) {
			const resourcePath = { companyID: companyID, vehicleID: vm.vehicleId, saleinfoID: saleInfo.getResourceID() };
			saleInfo.method = method;

			ProgressService.setMode("indeterminate");
			ProgressService.isVisble(true);

			return SaleInfoService.createPickUpAccess(resourcePath, saleInfo)
				.then(function (result) {
				if (!result || !result.url) {
					MessageService.showToast("No URL returned.");
					return;
				}

				if (method === 'copy') {
					// <-- minimal change: save URL and show a small panel with a real "Copy" button
					vm.pendingCopyUrl = result.url;
					vm.showCopyPanel = true;
					MessageService.showToast("Link ready. Tap 'Copy URL'.");
					return;
				}

				MessageService.showToast("Success.");
				})
				.catch(function (err) {
				console.log(err);
				MessageService.showToast(err && err.length > 0 ? err : "Something went wrong.");
				})
				.finally(function () {
				ProgressService.isVisble(false);
				});
			};

			// New tiny helper called by the real button click
			vm.copyNow = function () {
			if (!vm.pendingCopyUrl) return;

			// Prefer modern API if available (will succeed because this is a direct tap)
			if (navigator.clipboard && window.isSecureContext) {
				navigator.clipboard.writeText(vm.pendingCopyUrl)
				.then(function () {
					MessageService.showToast("URL copied to clipboard.");
					vm.showCopyPanel = false;
				})
				.catch(fallbackCopy);
			} else {
				fallbackCopy();
			}

			function fallbackCopy() {
				try {
				// iOS-friendly: on-screen, transparent input (not off-screen)
				var input = document.createElement('input');
				input.value = vm.pendingCopyUrl;
				input.setAttribute('readonly', '');
				input.style.position = 'fixed';
				input.style.top = '0';
				input.style.left = '0';
				input.style.opacity = '0';
				input.style.pointerEvents = 'none';
				document.body.appendChild(input);
				input.focus();
				input.setSelectionRange(0, input.value.length); // iOS
				var ok = document.execCommand('copy');
				document.body.removeChild(input);

				if (ok) {
					MessageService.showToast("URL copied to clipboard.");
					vm.showCopyPanel = false;
				} else {
					// Last-resort: show the text so the user can long-press to copy
					MessageService.showToast("Copy failed. Long-press to copy.");
				}
				} catch (e) {
				MessageService.showToast("Copy failed. Long-press to copy.");
				}
			}
			};


			// function saveChanges (saleInfo, index){
			// 	if($scope.saleInfoForms["form" + index].$invalid){
			// 		MessageService.showToast("Please make sure the form is valid");
			// 		return;
			// 	}

			// 	var originSaleInfo = originSaleInfos.find(function(item){
			// 		return item.getResourceID() == saleInfo.getResourceID();
			// 	});

			// 	var saleInfoRequestBody = SaleInfoService.updateSaleInfoRequestBodyGenerator(saleInfo, originSaleInfo);

			// 	if(saleInfoRequestBody == null || Object.keys(saleInfoRequestBody).length <= 0 
			// 		|| (Object.keys(saleInfoRequestBody).length == 1 && Object.keys(saleInfoRequestBody)[0] == "$$hashKey")){
			// 		MessageService.showToast("No changes detected.");
			// 		return;
			// 	}

			// 	var resourcePath = {
			// 		companyID: companyID,
			// 		vehicleID: vm.vehicleId,
			// 		saleinfoID: saleInfo.getResourceID()
			// 	}

			// 	ProgressService.setMode("indeterminate");
			// 	ProgressService.isVisble(true);

			// 	SaleInfoService.updateVehicleSaleInfo(resourcePath, saleInfoRequestBody)
			// 		.then(function(){
			// 			MessageService.showToast("Success.");
			// 			originSaleInfos = angular.copy(vm.saleInfos);
			// 		})
			// 		.catch(MessageService.showToast)
			// 		.finally(function(){
			// 			ProgressService.isVisble(false);
			// 		});
			// }

			vm.containUnsaveChanges = containUnsaveChanges;

			function containUnsaveChanges(){
				if(!Array.isArray(vm.saleInfos) || !Array.isArray(originSaleInfos) || vm.saleInfos.length != originSaleInfos.length){
					return false;
				}
				for(var i = 0; i < vm.saleInfos.length; i++){
					var currentSaleInfo = vm.saleInfos[i];
					var originSaleInfo = originSaleInfos.find(function(item){
						return item.getResourceID() == currentSaleInfo.getResourceID();
					});
					if(currentSaleInfo == null || originSaleInfo == null){
						return false;
					}
					var requestBody = SaleInfoService.updateSaleInfoRequestBodyGenerator(currentSaleInfo, originSaleInfo);
					if(requestBody != null && Object.keys(requestBody).length > 0
						&& !(Object.keys(requestBody).length == 1 && Object.keys(requestBody)[0] == "$$hashKey")){
						return true;
					}
				}
				return false;
			}
		}
})();
(function ()
{
	'use strict';

	angular
		.module("app.vehicles")
		.factory("VehiclesPaymentCalculator", VehiclesPaymentCalculatorClass)

	/** @ngInject */
	function VehiclesPaymentCalculatorClass(GeneralTools)
	{	 
		function VehiclesPaymentCalculatorClass(){}

		VehiclesPaymentCalculatorClass.prototype.setpaymentCalculator = function (payment) {
			if(payment){
				this.setNewVehiclePrice(payment.newVehiclePrice);
				this.setTradeInVehiclePrice(payment.tradeInVehiclePrice);
				this.setExistVehicleLoan(payment.existVehicleLoan);
				this.setDownPayment(payment.downPayment);
				this.setloanDuration(payment.loanDuration);
				this.setProvincialSalestax(payment.provincialSalestax);
				this.setExpectedInterestRate(payment.expectedInterestRate);
				this.setWarrntyCost(payment.warrntyCost);
				this.setSurcharge(payment.surcharge);
				this.setCertificationPrice(payment.certification);
				this.setExtraSecondPrice(payment.extraSecondPrice);

			}
		}

		VehiclesPaymentCalculatorClass.prototype.setExtraSecondPrice = function (extraSecondPrice) {
			if(!extraSecondPrice){
				this.extraSecondPrice = 0
			}else{
				this.extraSecondPrice = extraSecondPrice;
			}
		}

		VehiclesPaymentCalculatorClass.prototype.getExtraSecondPrice = function () {
			return GeneralTools.preciseNumber(GeneralTools.parseNumber(this.extraSecondPrice), 2);
		}

		VehiclesPaymentCalculatorClass.prototype.setCertificationPrice = function (certificationPrice) {
			if(!certificationPrice){
				this.certificationPrice = 0
			}else{
				this.certificationPrice = certificationPrice;
			}
		}

		VehiclesPaymentCalculatorClass.prototype.getCertificationPrice = function () {
			return GeneralTools.preciseNumber(GeneralTools.parseNumber(this.certificationPrice), 2);
		}

		VehiclesPaymentCalculatorClass.prototype.setNewVehiclePrice = function (newVehiclePrice) {
			if(!newVehiclePrice){
				this.newVehiclePrice = 0
			}else{
				this.newVehiclePrice = newVehiclePrice;
			}
		}

		VehiclesPaymentCalculatorClass.prototype.getNewVehiclePrice = function () {
			return GeneralTools.preciseNumber(GeneralTools.parseNumber(this.newVehiclePrice), 2);
		}

		VehiclesPaymentCalculatorClass.prototype.setTradeInVehiclePrice = function (tradeInVehiclePrice) {
			if(!tradeInVehiclePrice){
				this.tradeInVehiclePrice = 0
			}else{
				this.tradeInVehiclePrice = tradeInVehiclePrice;
			}
		}

		VehiclesPaymentCalculatorClass.prototype.getTradeInVehiclePrice = function () {
			return GeneralTools.preciseNumber(GeneralTools.parseNumber(this.tradeInVehiclePrice), 2);
		}

		VehiclesPaymentCalculatorClass.prototype.setExistVehicleLoan = function (existVehicleLoan) {
			if(!existVehicleLoan){
				this.existVehicleLoan = 0
			}else{
				this.existVehicleLoan = existVehicleLoan;
			}
		}

		VehiclesPaymentCalculatorClass.prototype.getExistVehicleLoan = function () {
			return GeneralTools.preciseNumber(GeneralTools.parseNumber(this.existVehicleLoan), 2);
		}

		VehiclesPaymentCalculatorClass.prototype.setDownPayment = function (downPayment) {
			if(!downPayment){
				this.downPayment = 0
			}else{
				this.downPayment = downPayment;
			}
		}

		VehiclesPaymentCalculatorClass.prototype.getDownPayment = function () {
			return GeneralTools.preciseNumber(GeneralTools.parseNumber(this.downPayment), 2);
		}

		VehiclesPaymentCalculatorClass.prototype.setloanDuration = function (loanDuration) {
			if(!loanDuration){
				this.loanDuration = 0
			}else{
				this.loanDuration = loanDuration;
			}
		}

		VehiclesPaymentCalculatorClass.prototype.getloanDuration = function () {
			return this.loanDuration;
		}

		VehiclesPaymentCalculatorClass.prototype.setProvincialSalestax = function (provincialSalestax) {
			if(!provincialSalestax){
				this.provincialSalestax = 0
			}else{
				this.provincialSalestax = provincialSalestax * 100;
			}
		}

		VehiclesPaymentCalculatorClass.prototype.getProvincialSalestax = function () {
			return GeneralTools.preciseNumber(GeneralTools.parseNumber(this.provincialSalestax), 2);
		}

		VehiclesPaymentCalculatorClass.prototype.setExpectedInterestRate = function (expectedInterestRate) {
			if(!expectedInterestRate){
				this.expectedInterestRate = 0
			}else{
				this.expectedInterestRate = expectedInterestRate * 100;
			}
		}

		VehiclesPaymentCalculatorClass.prototype.getExpectedInterestRate = function () {
			return GeneralTools.preciseNumber(GeneralTools.parseNumber(this.expectedInterestRate), 2);
		}

		VehiclesPaymentCalculatorClass.prototype.setWarrntyCost = function (warrntyCost) {
			if(!warrntyCost){
				this.warrntyCost = 0
			}else{
				this.warrntyCost = warrntyCost;
			}
		}

		VehiclesPaymentCalculatorClass.prototype.getWarrntyCost = function () {
			return GeneralTools.preciseNumber(GeneralTools.parseNumber(this.warrntyCost), 2);
		}

		VehiclesPaymentCalculatorClass.prototype.setSurcharge = function (surcharge) {
			if(!surcharge){
				this.surcharge = 0
			}else{
				this.surcharge = surcharge;
			}
		}

		VehiclesPaymentCalculatorClass.prototype.getSurcharge = function () {
			return GeneralTools.preciseNumber(GeneralTools.parseNumber(this.surcharge), 2);
		}

		VehiclesPaymentCalculatorClass.prototype.getTotalFinanceAmountWithOutExtra = function () {
			var total = 0
			if(this.getNewVehiclePrice() <= 0){
				return total
			}else{
				var totalAmountFinance = this.getNewVehiclePrice() - this.getTradeInVehiclePrice() + this.getWarrntyCost() + this.getCertificationPrice() + this.getExtraSecondPrice()
				var saleTaxAmount =  totalAmountFinance * (this.getProvincialSalestax()/100)
				total = totalAmountFinance + saleTaxAmount - this.getDownPayment() + this.getExistVehicleLoan()
				total = GeneralTools.preciseNumber(total, 2);
				if(total <= 0){
					return 0
				}else{
					return total
				}
			}

		}

		VehiclesPaymentCalculatorClass.prototype.getTotalFinanceAmount = function () {
			var total = 0
			if(this.getNewVehiclePrice() <= 0){
				return total
			}else{
				var totalAmountFinance = this.getNewVehiclePrice() - this.getTradeInVehiclePrice() + this.getSurcharge() + this.getWarrntyCost() + this.getCertificationPrice() + this.getExtraSecondPrice()
				var saleTaxAmount =  totalAmountFinance * (this.getProvincialSalestax()/100)
				total = totalAmountFinance + saleTaxAmount - this.getDownPayment() + this.getExistVehicleLoan()
				total = GeneralTools.preciseNumber(total, 2);
				if(total <= 0){
					return 0
				}else{
					return total
				}
			}

		}

		VehiclesPaymentCalculatorClass.prototype.getMonthlyTotalInterest = function () {
			if (this.getloanDuration() <= 0) {
				return 0;
			} else {
				var monthlyInterestRate = (this.getExpectedInterestRate() / 100) / 12;

				var principal = this.getTotalFinanceAmount();
		
				var numberOfPayments = this.getloanDuration();
		
				var monthlyPayment = 0;

				if (monthlyInterestRate === 0) {
					monthlyPayment = principal / numberOfPayments;
				} else {
					monthlyPayment = (principal * monthlyInterestRate * Math.pow(1 + monthlyInterestRate, numberOfPayments)) / (Math.pow(1 + monthlyInterestRate, numberOfPayments) - 1);
				}

				var totalAmountPaid = monthlyPayment * numberOfPayments;
		
				var totalInterest = totalAmountPaid - principal;

				totalInterest = GeneralTools.preciseNumber(totalInterest, 2);
		
				return totalInterest;
			}
		}

		VehiclesPaymentCalculatorClass.prototype.getMonthlyPayment = function () {
			if (this.getloanDuration() <= 0) {
				return 0;
			} else {
				var monthlyInterestRate = (this.getExpectedInterestRate() / 100) / 12;
		
				var principal = this.getTotalFinanceAmount();
		
				var numberOfPayments = this.getloanDuration();
		
				var monthlyPayment = 0
				
				if (monthlyInterestRate === 0) {
					monthlyPayment = principal / numberOfPayments;
				} else {
					monthlyPayment = (principal * monthlyInterestRate * Math.pow(1 + monthlyInterestRate, numberOfPayments)) / (Math.pow(1 + monthlyInterestRate, numberOfPayments) - 1);
				}

				monthlyPayment = GeneralTools.preciseNumber(monthlyPayment, 2);

				return monthlyPayment;
			}
		}
		
		VehiclesPaymentCalculatorClass.prototype.getBiWeeklyInterest = function () {
				if (this.getloanDuration() <= 0) {
					return 0;
				} else {
					var biWeeklyInterestRate = (this.getExpectedInterestRate() / 100) / 26;
			
					var principal = this.getTotalFinanceAmount();
			
					var numberOfPayments =  GeneralTools.preciseNumber(((this.getloanDuration() / 12) * 26), 2); 


					var monthlyPayment = 0;
			
					if (biWeeklyInterestRate === 0) {
						monthlyPayment = principal / numberOfPayments;
					} else {
						monthlyPayment = (principal * biWeeklyInterestRate * Math.pow(1 + biWeeklyInterestRate, numberOfPayments)) / (Math.pow(1 + biWeeklyInterestRate, numberOfPayments) - 1);
					}

					var totalAmountPaid = monthlyPayment * numberOfPayments;

					var totalInterest = totalAmountPaid - principal;
	
					totalInterest = GeneralTools.preciseNumber(totalInterest, 2);
			
					return totalInterest;
				}
		}

		VehiclesPaymentCalculatorClass.prototype.getBiWeeklyPayment = function () {
			if (this.getloanDuration() <= 0) {
				return 0;
			} else {
				var biWeeklyInterestRate = ((this.getExpectedInterestRate() / 100) / 26)
				
				var principal = this.getTotalFinanceAmount();
		
				var numberOfBiWeeklyPayments =  GeneralTools.preciseNumber(((this.getloanDuration() / 12) * 26), 2); 

				var biWeeklyPayment = 0;
				
				if (biWeeklyInterestRate === 0) {
					biWeeklyPayment = principal / numberOfBiWeeklyPayments;
				} else {
					biWeeklyPayment = ((principal * biWeeklyInterestRate * Math.pow(1 + biWeeklyInterestRate, numberOfBiWeeklyPayments)) / (Math.pow(1 + biWeeklyInterestRate, numberOfBiWeeklyPayments) - 1)).toFixed(10);
				}

				biWeeklyPayment = Number(biWeeklyPayment)
				
				biWeeklyPayment = GeneralTools.preciseNumber(biWeeklyPayment, 2);

				return biWeeklyPayment;
			}
		}
		
		VehiclesPaymentCalculatorClass.prototype.getWeeklyPayment = function () {
			if (this.getloanDuration() <= 0) {
				return 0;
			} else {
				var weeklyInterestRate = (this.getExpectedInterestRate() / 100) / 52;
		
				var principal = this.getTotalFinanceAmount();
		
				var numberOfWeeklyPayments = GeneralTools.preciseNumber(((this.getloanDuration() / 12) * 52), 2);
		
				var weeklyPayment = 0;
				
				if (weeklyInterestRate === 0) {
					weeklyPayment = principal / numberOfWeeklyPayments;
				} else {
					weeklyPayment = (principal * weeklyInterestRate * Math.pow(1 + weeklyInterestRate, numberOfWeeklyPayments)) / (Math.pow(1 + weeklyInterestRate, numberOfWeeklyPayments) - 1);
				}

				weeklyPayment = GeneralTools.preciseNumber(weeklyPayment, 2);
				
				return weeklyPayment;
			}
		}
		
		VehiclesPaymentCalculatorClass.prototype.getWeeklyInterest = function () {
			if (this.getloanDuration() <= 0) {
				return 0;
			} else {
				var weeklyInterestRate = (this.getExpectedInterestRate() / 100) / 52;
		
				var principal = this.getTotalFinanceAmount();
		
				var numberOfWeeklyPayments = GeneralTools.preciseNumber(((this.getloanDuration() / 12) * 52), 2);
		
				var monthlyPayment = 0;

				if (weeklyInterestRate === 0) {
					monthlyPayment = principal / numberOfWeeklyPayments;
				} else {
					monthlyPayment = (principal * weeklyInterestRate * Math.pow(1 + weeklyInterestRate, numberOfWeeklyPayments)) / (Math.pow(1 + weeklyInterestRate, numberOfWeeklyPayments) - 1);
				}

				var totalAmountPaid = monthlyPayment * numberOfWeeklyPayments;
				
				var totalInterest = totalAmountPaid - principal;

				totalInterest = GeneralTools.preciseNumber(totalInterest, 2);
		
				return totalInterest;
			}
		}

		VehiclesPaymentCalculatorClass.prototype.getMonthlyObligation = function () {
			if (this.getloanDuration() <= 0) {
				return 0;
			} else {
				var totalInterest = Number(this.getMonthlyTotalInterest())

				var principal = Number(this.getTotalFinanceAmount())

				var monthlyPayment = totalInterest + principal

				monthlyPayment = GeneralTools.preciseNumber(monthlyPayment, 2);

				return monthlyPayment;
			}
		}

		VehiclesPaymentCalculatorClass.prototype.getBiWeeklyObligation = function () {
			if (this.getloanDuration() <= 0) {
				return 0;
			} else {
				var totalInterest = Number(this.getBiWeeklyInterest())

				var principal = Number(this.getTotalFinanceAmount())

				var biWeeklyPayment = totalInterest + principal

				biWeeklyPayment = GeneralTools.preciseNumber(biWeeklyPayment, 2);
				
				return biWeeklyPayment;
			}
		}

		VehiclesPaymentCalculatorClass.prototype.getWeeklyObligation = function () {
			if (this.getloanDuration() <= 0) {
				return 0;
			} else {
				var totalInterest = Number(this.getWeeklyInterest())

				var principal = Number(this.getTotalFinanceAmount())

				var WeeklyPayment = totalInterest + principal

				WeeklyPayment = GeneralTools.preciseNumber(WeeklyPayment, 2);
				
				return WeeklyPayment;
			}
		}
	
		return VehiclesPaymentCalculatorClass;
	}


})();
(function ()
{
	"use strict";

	angular
		.module("app.vehicles")
		.component("purchaseSteps", {
				bindings:{
					vehicle:'<',
					constants:'<',
					disclosures: '<',
					latestPurchaseInfo: '<',
					isSalesmanMode: '<'
				},
				templateUrl: "app/main/vehicles/purchase-steps/purchase-steps.html",
				controller: componentController,
		  		controllerAs: 'vm'
			});

		function componentController(DialogService, LoginConst, SaleInfoSignatureService, ImageCompresser, FileUploadService, $timeout, GoogleService, SalePackage, PresetPackagesService, WorkOrder, ToolsConstants, WorkOrderConstants, WorkOrderService, $stateParams, $sce, $filter, $scope, Customer, VehicleConstants, CustomerConstants, GeneralTools, SaleInfo, TradeInVehicle, CustomersService, LoginService, $state, $q, SaleInfoService, MessageService, SaleExtras, SaleInfoPayment, ProgressService, SaleWarranty, VinAuditService, UserService, TasksService, TaskConstants, AppraisalForm){
			var vm = this;	
			var filterObj = {};
			var companyID = LoginService.getCompanyID();
			var customerID;		
			var newSaleInfoID;
			var signatureID;
			var saleManagerRoles = ["sales_manager"];
			var taskCategoryFkAdvertising = 7; 
			var taskCategoryFkFinance = 4; 
			var taskCategoryFkDocumentation = 3;
			var matUserID = 25;
			var rayUserID = 29;
			var originCustomer;
			var needToUpdateImage;
			vm.emailPatern = ToolsConstants.regexs.email
			vm.$onInit = initComponent;
			vm.$postLink = initOutputCallbacks;

			vm.selectPaymentOption = selectPaymentOption;
			vm.submitStepper = submitStepper;

			vm.selectedExtras = [];
			vm.selectedPackages = [];

			vm.translateToDollar = GeneralTools.inputTranslators.dollar;
			vm.translateToPhoneNumber = GeneralTools.inputTranslators.phoneNumber;
			vm.translateToFirstCap = GeneralTools.inputTranslators.initCapitalize;
			vm.translateToPostalCode = GeneralTools.inputTranslators.postalCode;
			vm.translateToMonth = GeneralTools.inputTranslators.month;
			vm.translateToSIN = GeneralTools.inputTranslators.SIN;
			vm.translateToVIN = GeneralTools.inputTranslators.VIN;
			vm.translateToAllCapitalize = GeneralTools.inputTranslators.allCapitalize;

			vm.setCustomerBirthday = setCustomerBirthday;
			vm.setCustomerLicenseExpiryDate = setCustomerLicenseExpiryDate;

			vm.setTradeInOption = setTradeInOption;
			vm.setPlateOption = setPlateOption;

			vm.selectWarranty = selectWarranty;

			vm.createNewExtra = createNewExtra;

			vm.queryCustomers = queryCustomers;

			vm.goToCustomerPage = goToCustomerPage;

			vm.loadCusomter = loadCusomter;

			vm.setDeliveryDueDate = setDeliveryDueDate;

			vm.decodeVIN = decodeVIN;

			vm.onDisclosureAdded = onDisclosureAdded;
        	vm.onDisclosureRemoved = onDisclosureRemoved;

        	vm.queryUser = queryUser;

        	vm.selecteSaleManager = selecteSaleManager;

        	vm.onScroll = onScroll;

        	vm.isOnLeftEnd = true;

        	vm.packageItemMaxDisplay = 2;

			vm.getValidTimeString = getValidTimeString;
			
			vm.onPostcodeChange = onPostcodeChange;

			vm.selectAddress = selectAddress;

			vm.getAddressName = getAddressName;

			vm.onPostcodeBlur = onPostcodeBlur;

			vm.onPostcodeFocus = onPostcodeFocus;

			vm.finishCustomerInfoForm = finishCustomerInfoForm;

			var minSearchTextLength = 2;
			vm.showAddPaymentMethodBoolean = false;
			vm.creditCardExpiryDate = null;
			vm.card_number = null;
			vm.card_firstname = null;
			vm.card_lastname = null;
			vm.card_address = null;
			vm.card_city = null;
			vm.card_province = null;
			vm.card_postcode = null;
			vm.copyboolean = true;
			vm.customerCreditCards = [
				{
					cardType: 'Visa',
					cardNumber: 'XXXX4242',
					expiryDate: new Date(),
				},
				{
					cardType: 'Master Card',
					cardNumber: 'XXXX4242',
					expiryDate: new Date(),
				},
				{
					cardType: 'American Express',
					cardNumber: 'XXXX4242',
					expiryDate: new Date(),
				}
			];
			vm.creditCardSelected = null;
	

			function initComponent(){
				initConstants();
				initCustomer();
				initSaleInfo();
				initPlateOpitons();
				initWarranty();
				initPresetExtrasOptions();
				initDeposit();
				initDisclosures();
				vm.submitButtonControl = true;
				initPackages();
				initFileUploader();
				initDisclosuresSteps();
			}

			$scope.$watch("vm.customer", function () {
				$scope.$emit(
					vm.onCustomerChange());
			})
	

			function initDisclosuresSteps(){
				$scope.$watch("vm.isSalesmanMode", function(){
					if(vm.stepApi){
						vm.stepApi.toggleStep("Disclosures", vm.isSalesmanMode);
					}
				});
			}

			function initFileUploader(){
				vm.imageUploader = FileUploadService.getNewUploader();
				vm.imageUploader.filters.push(FileUploadService.getSizeFilter(20));
				vm.imageUploader.filters.push(FileUploadService.getImageFilter(20));

				vm.imageUploader.onAfterAddingFile = function(fileItem){
					needToUpdateImage = true;

					var imageSrc = URL.createObjectURL(fileItem._file);
					vm.customerLicenseImageSrc = $sce.trustAsResourceUrl(imageSrc);
					FileUploadService.changeFileName(fileItem, "Driver License");

					var imageCompresser = new ImageCompresser();
		
					imageCompresser.photo(fileItem._file, 1024, "file", false, function(file){
						fileItem._file 		= file;
						fileItem.file.size 	= file.size;			
					});
				};
			}

			function initDisclosures(){
				if(!Array.isArray(vm.disclosures)){
					vm.disclosures = [];
				}
			}

			function initPresetExtrasOptions(){
				if(vm.constants == null || !Array.isArray(vm.constants.presetExtrasOptions)){
					return;
				}

				vm.extraCardList = vm.constants.presetExtrasOptions.map(function(item){
					return {
						name: item.name,
						cost: item.cost,
						presetExtra: item,
						isSelected: false
					}
				});

				$scope.$watch("vm.extraCardList", function(){
					vm.selectedExtras = vm.extraCardList.reduce(function(selectedExtras, item){
						if(!item.isSelected){
							return selectedExtras;
						}

						if(item.presetExtra){
							var newExtra = new SaleExtras();
							newExtra.pullDataFromPresetExtra(item.presetExtra);
							selectedExtras.push(newExtra);
							return selectedExtras;
						}

						if(item.customExtra){
							selectedExtras.push(item.customExtra);
							return selectedExtras;
						}
					},[]);
				}, true)
			}

			function initPlateOpitons(){
				if(vm.constants == null || !Array.isArray(vm.constants.plateOptions)){
					return;
				}

				vm.plateOptions = vm.constants.plateOptions;
			}

			function initDeposit(){
				vm.deposit = new SaleInfoPayment();
			}

			function initWarranty(){
				if(!Array.isArray(vm.constants.warranties) == null){
					return;
				}

				var currentDate = new Date();
				var vehicleAge = currentDate.getFullYear() - vm.vehicle.year;

				vm.availableWarranties = vm.constants.warranties.filter(function(warranty){
					return (vm.vehicle.mileage <= warranty.max_mileage 
							&& vm.vehicle.mileage >= warranty.min_mileage 
							&& vehicleAge <= warranty.max_vehicle_year);
				});

				if(vm.vehicle.is_certified && vm.availableWarranties.length > 0){
					vm.isWarrantyAvaliable = true;
				} else {
					vm.isWarrantyAvaliable = false;
				}
			}

			function initSaleInfo(){
				vm.saleInfo = new SaleInfo();
				vm.saleInfo.sale_price = vm.vehicle.advertise_price;
				vm.saleInfo.mileage    = vm.vehicle.mileage;

				if(vm.constants && Array.isArray(vm.constants.paymentOptions) && vm.constants.paymentOptions[0]){
					vm.saleInfo.setPaymentOptionID(vm.constants.paymentOptions[0].id_payment_option);
				}
			}

			function initConstants(){
				vm.vehicleConstants = VehicleConstants;
			}

			function initCustomer (){
				vm.customer = new Customer();
				vm.customerEmail = {};
				vm.customerPhoneNumber = {};
				vm.customerPhoneNumber.fk_id_phone_category = "2";

				var currentDate = new Date();

				vm.maxBirthdayDate = new Date(
						currentDate.getFullYear() - CustomerConstants.minAge,
						currentDate.getMonth(),
						currentDate.getDate()
				);
			}

			function initOutputCallbacks(){
			}

			function onPostcodeFocus(){
				vm.showAddressList = true;

				if(!Array.isArray(vm.addressList)){
					onPostcodeChange();
				}
			}

			function onPostcodeChange(){
				if(!vm.customer.address_postal_code || vm.customer.address_postal_code.length < 6){
					vm.addressList = [];
					vm.fetchingAddress = false;
					return;
				}

				vm.fetchingAddress = true;

				GoogleService.decodePostcode(companyID, vm.customer.address_postal_code).$promise
					.then(function(addressList){
						vm.addressList = addressList;
					})
					.catch(MessageService.showToast)
					.finally(function(){
						vm.fetchingAddress = false;
					})
			}

			function onPostcodeBlur(){
				$timeout(function(){
					vm.showAddressList = false;

				}, 100);
			}

			function selectAddress(address){
				if(!address){
					return;
				}

				if(address.streetNumber){
					vm.customer.address_street_number = address.streetNumber;
				}

				if(address.street){
					vm.customer.address_street = address.street;
				}

				if(address.city){
					vm.customer.address_city = address.city;
				}

				if(address.province){
					vm.customer.address_province = address.province;
				}
			}

			function getAddressName(address){
				if(!address){
					return;
				}

				var addressName = address.street + " " + address.city;

				if(address.province){
					addressName += ", " + address.province;
				}

				return addressName;
			}

			function selectPaymentOption(option){
				vm.saleInfo.setPaymentOptionID(option.id_payment_option);

				vm.stepApi.goToNextStep();
			}

			function tasksBaseOnSaleInfoID(saleinfoID){
				var taskList = [];

				taskList.push(createTradeInVehicle(saleinfoID));
				taskList.push(createWarranty(saleinfoID));
				taskList.push(createSaleExtra(saleinfoID));
				taskList.push(createSalePayment(saleinfoID));
				taskList.push(createSaleDisclosures(saleinfoID));
				taskList.push(createDefaultTasks(vm.vehicle.getResourceID()));
				taskList.push(createSalePackages(saleinfoID));

				return $q.all(taskList);
			}

			function createSalePackages(saleInfoID){
				if(!Array.isArray(vm.selectedPackages)){
					return $q.reject("Selected packages data invalid");
				}

				const queue = [];

				vm.selectedPackages.forEach(function(salePackage){
					queue.push(createSalePackage(salePackage, saleInfoID));
				});

				return $q.all(queue);
			}

			function createSalePackage(salePackage, saleInfoID){
				const resourcePath = {
					companyID: companyID,
					vehicleID: $stateParams.vehicleID,
					saleinfoID: saleInfoID
				}

				return SaleInfoService.createSalePackage(resourcePath, salePackage).$promise
			}

			function createSaleDisclosures(saleinfoID){
				if(!Array.isArray(vm.disclosures)){
					return $q.resolve();
				}

				var tasks = [];

				vm.disclosures.forEach(function(disclosure){
					var resourcePath = {
						companyID: companyID,
						vehicleID: vm.vehicle.getResourceID(),
						saleinfoID: saleinfoID
					}

					delete disclosure.id_disclosure;

					tasks.push(SaleInfoService.createSaleDisclosure(resourcePath, disclosure));
				});

				return $q.all(tasks);
			}

			function createSaleExtra(saleinfoID){
				var resourcePath = {
					companyID: companyID,
					vehicleID: vm.vehicle.getResourceID(),
					saleinfoID: saleinfoID
				}

				var taskList = [];

				vm.selectedExtras.forEach(function(extra){
					taskList.push(SaleInfoService.createSaleExtras(resourcePath, extra));
				});

				return $q.all(taskList);
			}

			function createWarranty(saleinfoID){
				if(vm.saleWarranty == null){
					return $q.resolve();
				}

				var resourcePath = {
					companyID:companyID,
					vehicleID:vm.vehicle.getResourceID(),
					saleinfoID:saleinfoID
				}

				return SaleInfoService.createSaleWarranty(resourcePath, vm.saleWarranty);

			}

			function createSalePayment(saleinfoID){
				var resourcePath = {
					companyID:companyID,
					vehicleID:vm.vehicle.getResourceID(),
					saleinfoID:saleinfoID
				}
				vm.deposit.addingFromSaleInfo = false;
				return SaleInfoService.createSalePayment(resourcePath, vm.deposit);
			}
		
			function createTradeInVehicle(saleinfoID){
				if(vm.isTradingInVehicle != true){
					return $q.resolve();
				}

				var resourcePath = {
					companyID:companyID,
					vehicleID:vm.vehicle.getResourceID(),
					saleinfoID:saleinfoID
				}

				return SaleInfoService.createTradeInVehicle(resourcePath, vm.tradeInVehicle);				
			}	

			function submitStepper (){
				if(!vm.stepApi.isLastStep()){
					return;
				}

				vm.isSubmitting = true;
				vm.submitButtonControl = undefined;

				saveCustomerTask()
					.then(function(_customerID){
						customerID = _customerID;
						return saveCustomerImage(customerID);
					})
					.then(function(){
						return createSaleInfoTask();
					})
					.then(function(_saleInfoID){
						newSaleInfoID = _saleInfoID;
						return tasksBaseOnSaleInfoID(_saleInfoID);
					})
					.then(function(){
						return setupWorkOrder();
					})
					.then(function(){
						return createSignature(newSaleInfoID);
					})
					.then(function(_signatureID){
						signatureID = _signatureID;
						$state.go("app.purchase-complete", {
							vehicleID: vm.vehicle.getResourceID(), 
							saleInfoID: newSaleInfoID,
							signatureID: signatureID
						});
					})
					.catch(function(message){
						vm.errorMessage = message;
					})
					.finally(function(){
						vm.submitButtonControl = true;
					});
			}

			function createSignature(saleInfoID){
				const resourcePath = {
					companyID: companyID,
					vehicleID: vm.vehicle.getResourceID(),
					saleinfoID: saleInfoID
				}

				const defer = $q.defer()

				SaleInfoSignatureService.createSaleInfoSignature(resourcePath, null, null)
					.then(defer.resolve)
					.catch(function(message){
						if(typeof(message) == "string" && message.startsWith("Missing email address")){
							defer.resolve();
						} else {
							defer.reject(message);
						}
					})
				
				return defer.promise;
			}

			function saveCustomerImage(customerID){
				if(vm.imageUploader.queue.length <= 0 || !needToUpdateImage){
					return $q.resolve();
				}

				const fileItem = vm.imageUploader.queue[vm.imageUploader.queue.length - 1];

				if(!fileItem){
					return $q.reject("file item invalid.");
				}

				const defer = $q.defer();

				fileItem.url = FileUploadService.getUrlForPostCustomerLicenseImage({
					companyID: companyID,
					customerID: customerID
				});

				fileItem.onError = function(response, status, headers){
					defer.reject(headers.message);
				}

				fileItem.onSuccess = function(){
					defer.resolve();
				};

				fileItem.upload();

				return defer.promise;
			}

			function setupWorkOrder(){
				const resourcePath = {
					companyID: companyID,
					vehicleID: $stateParams.vehicleID
				}

				return WorkOrderService.getWorkOrders(resourcePath).$promise
					.then(function(result){
						if(!Array.isArray(result)){
							return $q.reject("Work order data invalid");
						}
						
						var latestQuotedWorkOrder;

						result = $filter('orderBy')(result, "invoice_number", true)

						result.forEach(function(workorder){
							if(!workorder || workorder.isDeclinded() || workorder.isCompletedElseWhere() || workorder.isCompleted()){
								return;
							}

							if(!latestQuotedWorkOrder || workorder.getQuoteDateMomentObj().isAfter(latestQuotedWorkOrder.getQuoteDateMomentObj())){
								latestQuotedWorkOrder = workorder;
							}
						});

						if(latestQuotedWorkOrder){						
							return activateWorkOrder(latestQuotedWorkOrder);
						}

						return createNewWorkOrder();
					});
			}

			function createNewWorkOrder(){
				const resourcePath = {
					companyID: companyID,
					vehicleID: $stateParams.vehicleID
				}

				const workOrder = new WorkOrder();

				workOrder.quote_date = moment().format(WorkOrderConstants.dateFormat);
				workOrder.fk_id_work_order_status = WorkOrderConstants.statusIDs.quoted;
				workOrder.tax_rate = ToolsConstants.taxRate;
				workOrder.is_subsidized_by_percentage = true;
				workOrder.subsidized_percentage = 1;

				const highestPriority = getHighestWorkOrderPriority()
				if(highestPriority){
					workOrder.fk_id_work_order_priority = highestPriority.id_work_order_priority;
				}

				return WorkOrderService.createWorkOrder(resourcePath, workOrder);
			}

			function activateWorkOrder(latestQuotedWorkOrder){
				if(!latestQuotedWorkOrder){
					return $q.reject("Can not activate an invalid workorder.");
				}

				const resourcePath = {
					companyID: companyID,
					vehicleID: $stateParams.vehicleID,
					workorderID: latestQuotedWorkOrder.id_work_order
				}

				const requestBody = {};
				const highestPriority = getHighestWorkOrderPriority()

				if(!highestPriority || (latestQuotedWorkOrder.fk_id_work_order_priority != highestPriority.id_work_order_priority)){
					requestBody.fk_id_work_order_priority = highestPriority.id_work_order_priority;
				}

				if(latestQuotedWorkOrder.is_subsidized_by_percentage != true){
					requestBody.is_subsidized_by_percentage = true;
				}

				if(latestQuotedWorkOrder.subsidized_percentage != 1){
					requestBody.subsidized_percentage = 1;
				}

				if(Object.keys(requestBody).length <= 0){
					return $q.resolve();
				}

				return WorkOrderService.updateWorkOrder(resourcePath, requestBody);
			}

			function getHighestWorkOrderPriority(){
				if(!vm.constants || !Array.isArray(vm.constants.workOrderPriorities)){
					return;
				}

				var highestPriority;

				vm.constants.workOrderPriorities.forEach(function(priority){
					if(!priority){
						return;
					}

					if(!highestPriority || (priority.value < highestPriority.value)){
						highestPriority = priority
					}
				});

				return highestPriority;
			}

			function createDefaultTasks(vehicleID){
				var tasks = [];
				tasks.push(createDefaultTask(vehicleID, TaskConstants.deleteAdvertisementTaskName, taskCategoryFkAdvertising));
				tasks.push(createDefaultTask(vehicleID, TaskConstants.confirmFundsInTheAccountTaskName, taskCategoryFkFinance));
				
				if(vm.tradeInVehicle){
					tasks.push(createDefaultTask(vehicleID, TaskConstants.CreateTradeInFormTaskName, taskCategoryFkDocumentation, LoginService.getUserID()));

					if(vm.tradeInVehicle.trade_lien_payout){
						tasks.push(createDefaultTask(vehicleID, TaskConstants.tradeInLienPayoutTaskName, taskCategoryFkFinance, [rayUserID, matUserID]));
					}
				}

				if(vm.saleWarranty){
					tasks.push(createDefaultTask(vehicleID, TaskConstants.purchaseWarrantyTaskName, taskCategoryFkDocumentation, matUserID));
				}

				if(vm.vehicle.is_certified == false){
					tasks.push(createDefaultTask(vehicleID, TaskConstants.checkIfVehicleHasTradeInFormTaskName, taskCategoryFkDocumentation, LoginService.getUserID()));
				}

				return $q.all(tasks);
			}

			function createDefaultTask(vehicleID, taskName, category, userID){
				var resourcePath = { companyID: companyID };

				var requestBody = {
					assigned_to_vehicle: {id_vehicle: vehicleID},
					fk_id_task_category: category,
					fk_id_task_priority: 3,
					fk_id_task_status: 1,
					name: taskName
				}

				if(Array.isArray(userID)){
					requestBody.assigned_to_users = userID.map(function(id){
						return {id_user: id}
					})
				} else if (userID){
					requestBody.assigned_to_users = [{id_user: userID}];
				}

				return TasksService.createTask(resourcePath, requestBody)
			}

			function createSaleInfoTask(){
				var resourcePath = {
					companyID:companyID,
					vehicleID:vm.vehicle.getResourceID()
				}

				vm.saleInfo.setCustomerID(customerID);
				vm.saleInfo.setSaleDate(moment());

				return SaleInfoService.createVehicleSaleInfo(resourcePath, vm.saleInfo);
			}

			function saveCustomerTask(){
				if(vm.customer.getResourceID() != null){
					var changedProperties = CustomersService.updateRequestBodyGenerator(originCustomer, vm.customer)

					if(Object.keys(changedProperties).length == 0){
						return $q.resolve(vm.customer.getResourceID());
					}

					return CustomersService.updateCustomer(changedProperties, vm.customer.getResourcePath()).then(function(){
						return $q.resolve(vm.customer.getResourceID());
					})
				}

				var resourcePath = {companyID: companyID}	

				if(vm.customerPhoneNumber.phone_number){
					vm.customer.phone_numbers = [vm.customerPhoneNumber];
				}

				if(vm.customerEmail.email_address){
					vm.customer.emails = [vm.customerEmail];
				}

				return CustomersService.createCustomer(resourcePath, vm.customer);
			}

			function setCustomerBirthday(date){
				vm.customer.setBirthday(moment(date));
			}	

			function setCustomerLicenseExpiryDate (date){
				vm.customer.setLicenseExpiryDate(moment(date));
			}

			function setDeliveryDueDate(date){
				vm.saleInfo.setDeliveryDueDate(moment(date));
			}

			function setTradeInOption(isTradingInVehicle){
				vm.isTradingInVehicle = isTradingInVehicle;

				if(isTradingInVehicle == true){
					initTradeInVehicle();
				} else {
					vm.tradeInVehicle = null;
					vm.stepApi.goToNextStep();
				}
			}

			function initTradeInVehicle(){
				if(vm.tradeInVehicle == null){
					vm.tradeInVehicle = new TradeInVehicle();
				}
			}

			function setPlateOption(plateOption){
				vm.saleInfo.licensing_option = plateOption.name;
				vm.saleInfo.licensing_fee = plateOption.cost;
				vm.selectedPlateOption = plateOption.id_plate_option;
				vm.stepApi.goToNextStep();
			}

			function selectWarranty(warrantyOption){
				if(!warrantyOption){
					return;
				}
				
				if(vm.selectedWarrantyID == warrantyOption.id_warranty){
					vm.warrantyFeatures = null;
					vm.selectedWarrantyID = null;
					vm.saleWarranty = null;
				} else {
					vm.selectedWarrantyID = warrantyOption.id_warranty;
					vm.warrantyFeatures = warrantyOption.features;
					vm.saleWarranty = new SaleWarranty();
					vm.saleWarranty.pullDataFromWarranty(warrantyOption);
				}
			}

			function createNewExtra(){
				var cost = parseFloat(vm.customExtraCost);

				if(typeof(vm.customExtraName) != "string" || vm.customExtraName.trim() == '' || isNaN(cost)){
					MessageService.showToast("Invalid Item.");
					return;
				}

				var existingExtra = vm.extraCardList.find(function(extra){
					return extra.name.toLowerCase() == vm.customExtraName.toLowerCase();
				});

				if(existingExtra != null){
					MessageService.showToast("Duplicated Name.");
					return;
				}

				var newExtra = new SaleExtras();

				newExtra.setName(vm.customExtraName);
				newExtra.setCost(cost);

				vm.extraCardList.push({
					name: newExtra.name,
					cost: newExtra.cost,
					isSelected: true,
					customExtra: newExtra
				});

				vm.customExtraCost = null;
				vm.customExtraName = null;
			}

			function queryCustomers(){
				vm.customersFound = [];
				filterObj.filters = '';
				
				var firstNameFilter = nameFilterBuilder();
				var phoneNumberFilter =	phoneNumberFilterBuilder();
				var emailFilter = emailFilterBuilder();

				filterObj.filters = stringConnector(filterObj.filters, firstNameFilter, " AND ");
				filterObj.filters = stringConnector(filterObj.filters, phoneNumberFilter, " AND ");
				filterObj.filters = stringConnector(filterObj.filters, emailFilter, " AND ");

				if(filterObj.filters == null || filterObj.filters.trim() == ''){
					return;
				}
				var resourcePath = {companyID: companyID};
				CustomersService.getCustomers(resourcePath, filterObj, null)
					.then(function(response){

						if(Array.isArray(response.data) && response.data.length > 0){
							vm.customersFound = response.data;
						}

					})
					.catch(function(error){});
			}

			function phoneNumberFilterBuilder(){
				var filterString = '';

				if(vm.customerPhoneNumber && vm.customerPhoneNumber.phone_number){
					filterString = filterStringBuiler("phone_number", vm.customerPhoneNumber.phone_number);
				}

				return filterString;
			}

			function emailFilterBuilder(){
				var filterString = '';

				if(vm.customerEmail && vm.customerEmail.email_address){
					filterString = filterStringBuiler("email_address", vm.customerEmail.email_address);
				}

				return filterString;
			}

			function nameFilterBuilder(){
				var filterString = '';
				var firstNameFilterString = '';
				var lastNameFilterString = '';

				if(vm.customer.first_name != null && vm.customer.first_name.trim() != ''){
					firstNameFilterString = filterStringBuiler("first_name", vm.customer.first_name);
				}

				if(vm.customer.last_name != null && vm.customer.last_name.trim() != ''){
					lastNameFilterString = filterStringBuiler("last_name", vm.customer.last_name);
				}

				filterString = stringConnector(filterString, firstNameFilterString, " AND ");
				filterString = stringConnector(filterString, lastNameFilterString, " AND ");

				if(filterString.indexOf("AND") != -1){
					filterString = ' ( ' +  filterString + ' ) ';
				}

				return filterString;
			}

			function filterStringBuiler(columnName, value){
				if(columnName == null || columnName.trim() == '' || value == null || value == ''){
					return '';
				}

				return "contains(" + columnName + ",'" + value + "')";
			}

			function stringConnector(baseString, stringToAppend, connector){
				if(stringToAppend == null || stringToAppend.trim() == ''){
					return baseString;
				}

				if(baseString == null){
					baseString == '';
				}

				if (baseString.trim() != ''){
					baseString += connector
				}

				baseString += stringToAppend

				return baseString;
			}		

			function goToCustomerPage (customer){
				var url = $state.href('app.view-customer', {customerID: customer.getResourceID()});
				window.open(url,'_blank');
			}

			function loadCusomter (customer){
				vm.customer = customer;
				vm.birthdayPickerValue = customer.getBirthdayMomentObj();
				vm.expiryDatePickerValue = customer.getLicenseExpiryDateMomentObj();

				if(!Array.isArray(vm.customer.emails)){
					vm.customer.emails = [{}];
				}

				if(!Array.isArray(vm.customer.phone_numbers)){
					vm.customer.phone_numbers = [{}];
				}

				originCustomer = angular.copy(customer);

				vm.customerPhoneNumber = vm.customer.phone_numbers[0];
				vm.customerEmail = vm.customer.emails[0];

				getCustomersLicenseImage(vm.customer);
			}

			function getCustomersLicenseImage(customer){
				if(!customer){
					MessageService.showToast("Failed to fetch customer license image, customer data invalid.");
					return;
				}

				if(!customer.fk_license_image){
					return;
				}

				var licenseImage; 
				var resourcePath = {
					companyID: LoginService.getCompanyID(),
					customerID: customer.id_customer
				}

				vm.fetchingCustomerLicense = true;

				CustomersService.getCustomerLicenseImageInfo(resourcePath)
					.then(function(file){
						if(!file){
							return $q.reject("License image info data is invalid.");
						}

						licenseImage = file;
						resourcePath.uuid = file.uuid;
						return CustomersService.downloadCustomerLicenseImage(resourcePath);
					})
					.then(function(response){
						if(response == null){
							return $q.reject("License image data is invalid.");
						}

						vm.customerLicenseImageSrc = parseImage(response.data, licenseImage.getFileType());
						needToUpdateImage = false;
					})
					.catch(MessageService.showToast)
					.finally(function(){
						vm.fetchingCustomerLicense = false
					});
			}

			function parseImage(rawData, fileType){
				var stream 		= new Uint8Array(rawData);
				var blob 		= new Blob([stream], {type: fileType});
				var rawUrl 		= URL.createObjectURL(blob);
				return $sce.trustAsResourceUrl(rawUrl);
			}

			function decodeVIN (){
				ProgressService.setMode("indeterminate");
				ProgressService.isVisble(true);

				if(!vm.tradeInVehicle){
					return;
				}

				VinAuditService.decodeVin(vm.tradeInVehicle.vin)
					.then(function(result){
						if(result == null || result.attributes == null){
							return;
						}
						vm.tradeInVehicle.year = result.attributes.year;
						vm.tradeInVehicle.make = result.attributes.make;
						vm.tradeInVehicle.model = result.attributes.model;
					})
					.catch(MessageService.showToast)
					.finally(function(){
						ProgressService.isVisble(false);
					})
			}

			function onDisclosureRemoved(diclosure, index){
	        	vm.disclosures.splice(index, 1);
	        }

	        function onDisclosureAdded (diclosure){
				vm.disclosures.push(diclosure);
				vm.cleanNewDisclouser();	
	        }

	        function queryUser (searchText){
				var defer = $q.defer();
				var resourcePath = {companyID: LoginService.getCompanyID()};

				UserService.getUsers(resourcePath, searchText)
					.then(function(users){
						defer.resolve(filterSaleManager(users));
					})
					.catch(function(error){
						defer.reject();
						MessageService.showToast(error)
					})
				return defer.promise;
			}

			function filterSaleManager(users){
				var inspectors = [];

				if(!Array.isArray(users)){
					return inspectors;
				}

				users.forEach(function(user){
					if(checkInspectorRole(user.roles)){
						inspectors.push(user)
					}
				})

				return inspectors;
			}

			function checkInspectorRole(userRole){
				var isSaleManager = false;

				if(!Array.isArray(userRole)){
					return isSaleManager;
				}

				userRole.forEach(function(role){
					if(saleManagerRoles.indexOf(role) != -1){
						isSaleManager = true;
					}
				});

				return isSaleManager;
			}

			function selecteSaleManager(user){
				if(user == null){
					vm.saleInfo.sale_manager = null;
					return;
				}

				vm.saleInfo.sale_manager = user.id_user;
			}

			function initPackages(){
				PresetPackagesService.getPresetPackages({companyID: companyID}).$promise.then(function(presetPackages){
					if(!Array.isArray(presetPackages)){
						return;
					}

					vm.packageCardList = presetPackages.reduce(function(packageCardList, presetPackage){
						if(presetPackage && presetPackage.isActive()){
							packageCardList.push({
								name: presetPackage.name,
								price: presetPackage.price,
								isSelected: false,
								items: presetPackage.items.map(function(item){
									return item.name + ' * ' + item.quantity;
								}),
								presetPackage: presetPackage
							});
						}

						return packageCardList;
					}, []);

					$scope.$watch("vm.packageCardList", function(){
						vm.selectedPackages = vm.packageCardList.reduce(function(selectedPackages, packageCard){
							if(packageCard.isSelected){
								const salePackage = new SalePackage();
								salePackage.pullDataFromPresetPackage(packageCard.presetPackage);
								selectedPackages.push(salePackage);
							}
							
							return selectedPackages;
						}, []);
					}, true);
				});			
			}

			function onScroll(scope, element, attrs, event){
				if(!element || !element[0]){
					return;
				}
				const scrollLeft = element.scrollLeft();

				if(scrollLeft <= 0){
					vm.isOnLeftEnd = true;
				}else if(scrollLeft + element.innerWidth() >= element[0].scrollWidth){
					vm.isOnRightEnd = true;
				}else{
					vm.isOnLeftEnd = false;
					vm.isOnRightEnd = false;
				}

				$scope.$apply();				
			}
			
			function getValidTimeString(validTime){
				if(typeof(validTime) != "number"){
					return;
				}

				var validTimeString = '';

				const year = Math.floor(validTime / 12);
				const month = validTime % 12;

				const yearUnit = year > 1 ? " Years" : " Year";
				const monthUnit = month > 1 ? " Months" : " Month";

				if(year > 0){
					validTimeString = GeneralTools.stringConnector(validTimeString, year + yearUnit, ' & ');
				}

				if(month > 0){
					validTimeString = GeneralTools.stringConnector(validTimeString, month + monthUnit, ' & ');
				}

				return validTimeString
			}

			function finishCustomerInfoForm(){
				if(!vm.customerEmail.email_address){
					DialogService.showYesOrNoDialog("Missing Email Address", "Would you like to provide an email to get a digital copy of bill of sale?", "Yes", "Skip")
						.then(function(isYes){
							if(!isYes){
								vm.stepApi.goToNextStep();
							}
						});
				} else {
					vm.stepApi.goToNextStep();
				}
			}

			vm.onSearchTextChange = function (){
				if(vm.searchText == null || vm.searchText.length < minSearchTextLength){
					vm.customersFound = [];
					return;
				}

				var resourcePath = { companyID: companyID }
				var filterObj = CustomersService.customerSearchTextFilterBuilder(vm.searchText);

				CustomersService.getCustomers(resourcePath, filterObj, null, null)
					.then(function(response){
						vm.customersFound = response.data;

					})
			}

			
			// vm.onCustomerSearchTextChange = function (){
			// 	if(vm.searchCustomerText == null || vm.searchCustomerText.length < minSearchTextLength){
			// 		vm.customersFound = [];
			// 		return;
			// 	}

			// 	var resourcePath = { companyID: companyID }
			// 	var filterObj = CustomersService.customerSearchTextFilterBuilder(vm.searchCustomerText);

			// 	CustomersService.getCustomers(resourcePath, filterObj, null, null)
			// 		.then(function(response){
			// 			vm.customersFound = response.data;

			// 		})
			// }

			vm.selectCusomter = function  (customer){
				vm.customer = customer;
				if(typeof(vm.onCustomerSelect) == "function"){
					vm.onCustomerSelect(vm.customer);
				}
			}

			vm.goToCustomerPage = function  (customer){
				var url = $state.href('app.view-customer', {customerID: customer.getResourceID()});
				window.open(url,'_blank');
			}

			vm.getCustomerPageUrl = function (){
				return $state.href('app.view-customer', {customerID: vm.customer.getResourceID()});
			}

			
		vm.showAddPaymentMethod = function showAddPaymentMethod(){
			vm.showAddPaymentMethodBoolean = !vm.showAddPaymentMethodBoolean 
		}

		vm.onCreditCardNumberChange = function(card_number){
			if(card_number && card_number.length !== 16){
				$scope.workordercustomerCreditCardForm.cardNumber.$setValidity('valid', false);
			}else{
				$scope.workordercustomerCreditCardForm.cardNumber.$setValidity('valid', true);
			}

		}

		vm.oncreditCardExpiryDateChange = function(creditCardExpiryDate){
			if(creditCardExpiryDate){
				var parts = creditCardExpiryDate.split('/');
				var month = parseInt(parts[0], 10);
				var year = parseInt(parts[1], 10);
			
				var currentDate = new Date();
				var currentYear = currentDate.getFullYear() % 100;
				var currentMonth = currentDate.getMonth() + 1; 
			
				if (year > currentYear || (year === currentYear && month >= currentMonth)) {
					$scope.workordercustomerCreditCardForm.creditCardExpiryDate.$setValidity('valid', true);
				} else {
					$scope.workordercustomerCreditCardForm.creditCardExpiryDate.$setValidity('valid', false);
				}
			}

		}

		vm.addSlash = function(event) {
			var value = event.target.value;
			if (value.length === 2 && event.charCode >= 48 && event.charCode <= 57) {
				event.target.value = value + '/';
			}
		};

		vm.pullinfoFromCustomer = function(){
			
			if(vm.customer && vm.customer.first_name){
				vm.card_firstname = vm.customer.first_name;
			}
			
			if(vm.customer && vm.customer.last_name){
				vm.card_lastname = vm.customer.last_name;
			}

			if(vm.customer && vm.customer.address_street_number && vm.customer.address_street){
				vm.card_address = vm.customer.address_street_number + ' ' + vm.customer.address_street; 
			}

			if(vm.customer && vm.customer.address_city){
				vm.card_city = vm.customer.address_city;
			}
			
			if(vm.customer && vm.customer.address_province){
				vm.card_province = vm.customer.address_province;
			}

			if(vm.customer && vm.customer.address_postal_code){
				vm.card_postcode = vm.customer.address_postal_code;
			}

			vm.copyboolean = !vm.copyboolean
		}

		vm.clearCustomerInfo = function(){
			vm.card_firstname = null;
			vm.card_lastname = null;
			vm.card_address = null;
			vm.card_city = null;
			vm.card_province = null;
			vm.card_postcode = null;
			vm.copyboolean = !vm.copyboolean
		}

		vm.onCustomerChange = function(){
		}

		vm.printAppraisalForm= function(){
        	var appraisalForm = new AppraisalForm(vm.tradeInVehicle, vm.customer, LoginService.getFirstname() + " " + LoginService.getLastname(), vm.customerPhoneNumber, vm.customerEmail, vm.vehicle);
			ProgressService.setMode("indeterminate");

			appraisalForm.open()
				.catch(MessageService.showToast)
				.finally(function(){
					ProgressService.isVisble(false);
				})
        }
}
})();
(function ()
{
	'use strict';

	angular
		.module('app.vehicles')
		.controller('PurchaseCompleteController', PurchaseCompleteController);

	function PurchaseCompleteController(LoginConst, $timeout, $state, VehicleService, CustomersService, SaleInfoService, $q, $stateParams, LoginService, MessageService, ProgressService, BillOfSale, SaleInfoSignatureService, HellosignService, EmailService, FileViewService, GeneralTools){   
		var vm = this;
		var companyID = LoginService.getCompanyID();
		var newSaleSignatureID;
		var blob;
		
		vm.signingRecords = {};
		vm.popoverStyle = {visibility:"hidden"};
		vm.togglePopover = togglePopover;
		vm.finishSignRequest = finishSignRequest;
		vm.printBillOfSale = printBillOfSale;
		vm.isAnyEmailReceiverSelected = isAnyEmailReceiverSelected;
		vm.sendSigningPageLinkByEmail = sendSigningPageLinkByEmail;
		vm.copySigningPageLink = copySigningPageLink;
		vm.printSignedFile = printSignedFile;

		init();

		function init(){
			vm.isLoading = true;
			ProgressService.setMode("indeterminate");
			ProgressService.isVisble(true);

		 	SaleInfoService.getSaleInfos({
					companyID:companyID,
					saleinfoID: $stateParams.saleInfoID
				})
				.then(function(saleInfos){
					if(!isOneItemInArray(saleInfos)){
						return $q.reject("Sale info data invalid");
					}

					vm.saleInfo = saleInfos[0];

					const queue = [
						initVehicle(vm.saleInfo.fk_id_vehicle),
						initCustomer(vm.saleInfo.fk_id_customer)
					]

					if($stateParams.signatureID){
						queue.push(initSignature());
					}
					
					return $q.all(queue);
				})
				.then(initPopover)
				.catch(MessageService.showToast)
				.finally(function(){
					vm.isLoading = false;
					ProgressService.isVisble(false);
				});
		}

		
		
		function togglePopover(visibility){
			$timeout(function(){
				if(typeof(visibility) === "boolean"){
					vm.popoverStyle.visibility = visibility ? "visible" : "hidden";
				} else {
					vm.popoverStyle.visibility = vm.popoverStyle.visibility == "hidden" ? "visible" : "hidden";
				}
			})
		}
								
		function initPopover(){
			togglePopover(false);

			$timeout(function(){
				const signButton = document.querySelector('#sign');
				const popover = document.querySelector('#popover');
				const arrow = document.querySelector('#arrow');

				Popper.createPopper(signButton, popover, {
					placement: 'right',
					modifiers: [
						{
							name: 'arrow',
							options: {
								element: arrow,
							},
						},
						{
							name: 'offset',
							options: {
								offset: [0, 12],
							},
						},
						{
							name: 'flip',
							options: {
								fallbackPlacements: ['bottom'],
								boundary: 'document'
							}
						}
					  ]		  
				});
			})
		}

		function printBillOfSale (){
			var billOfSale = new BillOfSale($stateParams.vehicleID, $stateParams.saleInfoID);
			billOfSale.open();
		}

		function initSignature(){
			var resourcePath = {
				companyID: companyID,
				saleinfoID: $stateParams.saleInfoID,
				vehicleID: $stateParams.vehicleID,
				signatureID: $stateParams.signatureID
			};

			return SaleInfoSignatureService.getSaleSignatures(resourcePath)
				.then(function(signatures){
					if(!isOneItemInArray(signatures)){
						return $q.reject("Signature data invalid");
					}
					vm.signature = signatures[0];
					return refreshSignatureDetail();
				})
				.then(function(){
					if(vm.signatureDetail.is_complete){
						return initSignatureFile();
					}
				});
		}

		function initCustomer(customerID){
			return CustomersService.getCustomers({
					companyID: companyID,
					customerID: customerID
				})
				.then(function(customers){
					if(!isOneItemInArray(customers.data)){
						return $q.reject("Vehicle data invalid");
					}
					vm.customer = customers.data[0];
				});
		}

		function initVehicle(vehicleID){
			return VehicleService.getVehicle({
					companyID: companyID,
					vehicleID: vehicleID
				})
				.then(function(vehicles){
					if(!isOneItemInArray(vehicles.data)){
						return $q.reject("Vehicle data invalid");
					}
					vm.vehicle = vehicles.data[0];
				});
		}

		function isOneItemInArray(array){
			return Array.isArray(array) && array.length == 1 && array[0];
		}

		function finishSignRequest(signRequestForSigner){
			if(!vm.signingRecords[signRequestForSigner.signature_id]){
				vm.signingRecords[signRequestForSigner.signature_id] = {};
			}

			vm.signingRecords[signRequestForSigner.signature_id].isSigning = true;
			
			HellosignService.finishSignatureRequest(signRequestForSigner.signature_id)
				.then(function(){
					return refreshSignatureDetail();
				})
				.then(function(signatureDetail){
					if(signatureDetail.is_complete){
						return initSignatureFile();
					}
				})
				.catch(MessageService.showToast)
				.finally(function(){
					vm.signingRecords[signRequestForSigner.signature_id].isSigning = false;
				});
		}

		function refreshSignatureDetail(){
			var resourcePath = {
				companyID: companyID,
				saleinfoID: $stateParams.saleInfoID,
				vehicleID: $stateParams.vehicleID,
				signatureID: $stateParams.signatureID
			};

			return SaleInfoSignatureService.getSaleSignatureDetail(resourcePath)
				.then(function(signatureDetail){
					vm.isAllSigned = HellosignService.isAllSignersCompleted(signatureDetail)

					if(vm.isAllSigned && !signatureDetail.is_complete){
						togglePopover(false);
						return SaleInfoSignatureService.trackSignatureState(resourcePath, vm.signature.hellosign_signature_request_id);
					}

					return signatureDetail;
				})
				.then(function(signatureDetail){
					vm.signatureDetail = signatureDetail;

					if(vm.signatureDetail.is_complete){
						togglePopover(false);
					}

					return signatureDetail;
				});
		}

		function initSignatureFile(){
			var resourcePath = {
				companyID: companyID,
				saleinfoID: $stateParams.saleInfoID,
				vehicleID: $stateParams.vehicleID,
				signatureID: $stateParams.signatureID
			};

			return SaleInfoSignatureService.getSaleSignatureFile(resourcePath)
				.then(function(files){
					if(!isOneItemInArray(files)){
						return $q.reject("File data invalid");
					}

					vm.signatureFile = files[0];
					vm.signatureFileUrl = FileViewService.generateUrlByUUID(vm.signatureFile.uuid);

					renderPrivateFile(vm.signatureFile);
				});
		}

		function renderPrivateFile(fileData){
			vm.renderingFile = true;

			return FileViewService.downloadFile(fileData.getResourcePath())
				.then(function(response){
					var stream 	= new Uint8Array(response.data);

					blob = new Blob([stream], {type: fileData.getFileType()});
					
					vm.previewFileUrl = URL.createObjectURL(blob);
				})
				.catch(MessageService.showToast)
				.finally(function(){
					vm.renderingFile = false;
				})
		}

		function isAnyEmailReceiverSelected(){
			if(vm.signatureDetail && Array.isArray(vm.signatureDetail.signatures)){
				for(var i in vm.signatureDetail.signatures){
					if(vm.signatureDetail.signatures[i].isEmailReceiver){
						return true;
					}
				}
			}

			return false;
		}

		

		function sendSigningPageLinkByEmail(signerDetail){
			if(!vm.signingRecords[signerDetail.signature_id]){
				vm.signingRecords[signerDetail.signature_id] = {};
			}

			vm.signingRecords[signerDetail.signature_id].isSending = true;

			EmailService.sendSigningRequest(signerDetail, vm.signatureDetail, vm.vehicle)
				.then(function(){
					vm.signingRecords[signerDetail.signature_id].isSent = true;
				})
				.catch(function(error){
					if(error){
						MessageService.showToast(error);
					}
				})
				.finally(function(){
					vm.signingRecords[signerDetail.signature_id].isSending = false;
				});
		}

		function copySigningPageLink(signerDetail){
			if(!signerDetail || !signerDetail.signature_id){
				MessageService.showToast("Signing link is not available.");
				return;
			}

			if(!vm.signingRecords[signerDetail.signature_id]){
				vm.signingRecords[signerDetail.signature_id] = {};
			}

			var signingPageUrl = $state.href('app.signing-page', {signerSignatureId: signerDetail.signature_id}, {absolute: true});

			GeneralTools.copyToClipboard(signingPageUrl);

			vm.signingRecords[signerDetail.signature_id].isCopied = true;
			MessageService.showToast("Signing link copied to clipboard.");
		}

		function printSignedFile(){
			var win = window.open(URL.createObjectURL(blob), "_blank");	
			win.onload = function(){
				win.print();
			}
		}
	}
})();
(function ()
{
	'use strict';

	angular
		.module("app.vehicles")
		.factory("VehiclesLoanCalculator", VehiclesLoanCalculatorClass)

	/** @ngInject */
	function VehiclesLoanCalculatorClass(GeneralTools)
	{	 
		function VehiclesLoanCalculatorClass(){}

		VehiclesLoanCalculatorClass.prototype.setpaymentCalculator = function (loan) {
			if(loan){
				this.setNewVehiclePrice(loan.monthlyPayment);
				this.setTradeInVehiclePrice(loan.tradeInVehiclePrice);
				this.setExistVehicleLoan(loan.existVehicleLoan);
				this.setDownPayment(loan.downPayment);
				this.setloanDuration(loan.loanDuration);
				this.setProvincialSalestax(loan.provincialSalestax);
				this.setExpectedInterestRate(loan.expectedInterestRate);
				this.setWarrntyCost(loan.warrntyCost);
			}
		}

		VehiclesLoanCalculatorClass.prototype.setNewVehiclePrice = function (newVehiclePrice) {
			if(!newVehiclePrice){
				this.newVehiclePrice = 0
			}else{
				this.newVehiclePrice = newVehiclePrice;
			}
		}

		VehiclesLoanCalculatorClass.prototype.getNewVehiclePrice = function () {
			return GeneralTools.preciseNumber(GeneralTools.parseNumber(this.newVehiclePrice), 2);
		}

		VehiclesLoanCalculatorClass.prototype.setTradeInVehiclePrice = function (tradeInVehiclePrice) {
			if(!tradeInVehiclePrice){
				this.tradeInVehiclePrice = 0
			}else{
				this.tradeInVehiclePrice = tradeInVehiclePrice;
			}
		}

		VehiclesLoanCalculatorClass.prototype.getTradeInVehiclePrice = function () {
			return GeneralTools.preciseNumber(GeneralTools.parseNumber(this.tradeInVehiclePrice), 2);
		}

		VehiclesLoanCalculatorClass.prototype.setExistVehicleLoan = function (existVehicleLoan) {
			if(!existVehicleLoan){
				this.existVehicleLoan = 0
			}else{
				this.existVehicleLoan = existVehicleLoan;
			}
		}

		VehiclesLoanCalculatorClass.prototype.getExistVehicleLoan = function () {
			return GeneralTools.preciseNumber(GeneralTools.parseNumber(this.existVehicleLoan), 2);
		}

		VehiclesLoanCalculatorClass.prototype.setDownPayment = function (downPayment) {
			if(!downPayment){
				this.downPayment = 0
			}else{
				this.downPayment = downPayment;
			}
		}

		VehiclesLoanCalculatorClass.prototype.getDownPayment = function () {
			return GeneralTools.preciseNumber(GeneralTools.parseNumber(this.downPayment), 2);
		}

		VehiclesLoanCalculatorClass.prototype.setloanDuration = function (loanDuration) {
			if(!loanDuration){
				this.loanDuration = 0
			}else{
				this.loanDuration = loanDuration;
			}
		}

		VehiclesLoanCalculatorClass.prototype.getloanDuration = function () {
			return GeneralTools.preciseNumber(GeneralTools.parseNumber(this.loanDuration), 2);
		}
		
		VehiclesLoanCalculatorClass.prototype.setProvincialSalestax = function (provincialSalestax) {
			if(!provincialSalestax){
				this.provincialSalestax = 0
			}else{
				this.provincialSalestax = provincialSalestax;
			}
		}

		VehiclesLoanCalculatorClass.prototype.getProvincialSalestax = function () {
			return GeneralTools.preciseNumber(GeneralTools.parseNumber(this.provincialSalestax), 2);
		}

		VehiclesLoanCalculatorClass.prototype.setExpectedInterestRate = function (expectedInterestRate) {
			if(!expectedInterestRate){
				this.expectedInterestRate = 0
			}else{
				this.expectedInterestRate = expectedInterestRate;
			}
		}

		VehiclesLoanCalculatorClass.prototype.getExpectedInterestRate = function () {
			return GeneralTools.preciseNumber(GeneralTools.parseNumber(this.expectedInterestRate), 2);
		}

		VehiclesLoanCalculatorClass.prototype.setWarrntyCost = function (warrntyCost) {
			if(!warrntyCost){
				this.warrntyCost = 0
			}else{
				this.warrntyCost = warrntyCost;
			}
		}

		VehiclesLoanCalculatorClass.prototype.getExpectedInterestRate = function () {
			return GeneralTools.preciseNumber(GeneralTools.parseNumber(this.warrntyCost), 2);
		}

		VehiclesLoanCalculatorClass.prototype.getTargetVehiclePrice = function () {
			return 114514
		}

		VehiclesLoanCalculatorClass.prototype.getTotalInterestToPaid = function () {
			return 1919
		}

		



		return VehiclesLoanCalculatorClass;
	}


})();
(function () {
	'use strict';

	angular
		.module('app.vehicles')
		.controller('LoadCalculatorController', LoadCalculatorController);

	function LoadCalculatorController($filter, ToolsConstants, workorderPriorities, WorkOrderService, WorkOrderConstants, $stateParams, $location, $anchorScroll, $state, MessageService, $mdSidenav, $q, LoginService, VehicleService, ProgressService, $scope, GeneralTools, SaleInfoService, VehicleConstants, locations, userConfig, UserConfigService, VehiclesPaymentCalculator) {
		const vm = this;
		const companyID = LoginService.getCompanyID();
		const userID = LoginService.getUserID();
		vm.translateToDollar = GeneralTools.inputTranslators.dollar;
		vm.translateToMonth = GeneralTools.inputTranslators.month;
		vm.translateToPercentage = GeneralTools.inputTranslators.percentage;

		vm.calculatingPayment = false;
		vm.calculatingLoan = true;
		vm.showVehiclePriceDetail = false;
		vm.VehiclesPaymentCalculator = new VehiclesPaymentCalculator();
		vm.refreshPayment = refreshPayment;
		vm.init = init;
		vm.getDropDownButtonClass = getDropDownButtonClass;
		vm.filter = $filter
		vm.downPaymentLimit = 200000
		vm.tempFirstKeyDownValueForRate=null
		vm.tempFirstKeyDownValueForTax=null
		vm.interestRateInputOption = {
			decimalFractionSize:2,
			canBeNegative:false
		};



		$scope.termOptions = [];
		for (var i = 0; i <= 96; i += 3) {
			$scope.termOptions.push(i);
		}
		vm.tempWarrantyCost = 0;
		vm.tempVehiclePrice = 0;

		vm.paymentCalculator = {
			newVehiclePrice: 24000,
			basicVehiclePrice: 24000,
			tradeInVehiclePrice: 0,
			existVehicleLoan: 0,
			downPayment: 0,
			loanDuration: 96,
			provincialSalestax: 0.13,
			expectedInterestRate: 0.0699,
			warrntyCost: 0,
			surcharge: 2000,
			totalFinanceAmount: 0,
			extraSecondPrice: 0,
			certification: 995,
		}

		vm.paymentTable = [
			{
				title: 'Monthly',
				amount: 1,
				interest: 2,
				totalObligation: 0

			},
			{
				title: 'Bi-weekly',
				amount: 1,
				interest: 2,
				totalObligation: 0
			},
			{
				title: 'Weekly',
				amount: 1,
				interest: 2,
				totalObligation: 0
			}
		]

		init()
		function init() {
			vm.refreshPayment()
		}

		vm.onCalculatePaymentClick = function () {
			vm.calculatingPayment = !vm.calculatingPayment
			vm.calculatingLoan = !vm.calculatingLoan
		}

		vm.onCalculateLoanClick = function () {
			vm.calculatingPayment = !vm.calculatingPayment
			vm.calculatingLoan = !vm.calculatingLoan
		}

		function refreshPayment() {
			if (!vm.paymentCalculator) {
				return;
			}
		
			// Allow deletion to set `expectedInterestRate` to null or below 0.3 before enforcing max limit
			if (vm.paymentCalculator.expectedInterestRate !== null && 
				vm.paymentCalculator.expectedInterestRate.toString().length > 0 &&
				vm.paymentCalculator.expectedInterestRate > 0.3) {
				vm.paymentCalculator.expectedInterestRate = 0.3;
			}
		
			if (vm.paymentCalculator.provincialSalestax == null && vm.tempFirstKeyDownValueForTax != null) {
				vm.paymentCalculator.provincialSalestax = vm.tempFirstKeyDownValueForTax / 100;
				vm.tempFirstKeyDownValueForTax = null
			}
		
			if (vm.paymentCalculator.expectedInterestRate == null && vm.tempFirstKeyDownValueForRate != null) {
				vm.paymentCalculator.expectedInterestRate = vm.tempFirstKeyDownValueForRate / 100;
				vm.tempFirstKeyDownValueForRate = null
			}
			if (vm.paymentCalculator.provincialSalestax > 0.15) {
				vm.paymentCalculator.provincialSalestax = 0.15;
			}
		
			vm.paymentCalculator.loanDuration = Math.floor(vm.paymentCalculator.loanDuration / 3) * 3;
			vm.VehiclesPaymentCalculator.setpaymentCalculator(vm.paymentCalculator);
			vm.paymentCalculator.totalFinanceAmount = vm.VehiclesPaymentCalculator.getTotalFinanceAmountWithOutExtra();
		
			vm.paymentTable[0].amount = vm.filter('currency')(vm.VehiclesPaymentCalculator.getMonthlyPayment(), '$', 2);
			vm.paymentTable[0].interest = vm.filter('currency')(vm.VehiclesPaymentCalculator.getMonthlyTotalInterest(), '$', 2);
			vm.paymentTable[0].totalObligation = vm.filter('currency')(vm.VehiclesPaymentCalculator.getMonthlyObligation(), '$', 2);
		
			vm.paymentTable[1].amount = vm.filter('currency')(vm.VehiclesPaymentCalculator.getBiWeeklyPayment(), '$', 2);
			vm.paymentTable[1].interest = vm.filter('currency')(vm.VehiclesPaymentCalculator.getBiWeeklyInterest(), '$', 2);
			vm.paymentTable[1].totalObligation = vm.filter('currency')(vm.VehiclesPaymentCalculator.getBiWeeklyObligation(), '$', 2);
		
			vm.paymentTable[2].amount = vm.filter('currency')(vm.VehiclesPaymentCalculator.getWeeklyPayment(), '$', 2);
			vm.paymentTable[2].interest = vm.filter('currency')(vm.VehiclesPaymentCalculator.getWeeklyInterest(), '$', 2);
			vm.paymentTable[2].totalObligation = vm.filter('currency')(vm.VehiclesPaymentCalculator.getWeeklyObligation(), '$', 2);
		}
		

		function getDropDownButtonClass() {
			const classList = [];

			classList.push('text-secondary');

			if (vm.showVehiclePriceDetail) {
				classList.push('icon-menu-up');
			} else {
				classList.push('icon-arrow-down-drop');
			}

			return classList;
		}

		vm.adjustPrices = function () {
			var currentTotal = vm.paymentCalculator.basicVehiclePrice + vm.paymentCalculator.warrntyCost;
			var difference = vm.paymentCalculator.newVehiclePrice - currentTotal;

			if (difference > 0) {
				vm.paymentCalculator.basicVehiclePrice += difference;
			} else {
				if (vm.paymentCalculator.basicVehiclePrice + difference >= 0) {
					vm.paymentCalculator.basicVehiclePrice += difference;
				} else {
					vm.paymentCalculator.warrntyCost += (vm.paymentCalculator.basicVehiclePrice + difference);
					vm.paymentCalculator.basicVehiclePrice = 0;
				}
			}
		};

        $scope.showElement = window.innerWidth >= 1168;
		vm.flexValue = window.innerWidth >= 1168 ? '70' : '25';

        angular.element(window).bind('resize', function() {
            $scope.$apply(function() {
                $scope.showElement = window.innerWidth >= 1168; 
				vm.flexValue = window.innerWidth >= 1168 ? '70' : '25';
            });
        });

		vm.captureFirstKeydownForRate = function(event) {
			if (event.key >= '0' && event.key <= '9') {
				vm.tempFirstKeyDownValueForRate = event.key
			}
		};

		vm.captureFirstKeydownForTax = function(event) {
			if (event.key >= '0' && event.key <= '9') {
				vm.tempFirstKeyDownValueForTax = event.key
			}
			
		};
		
	}
})();
(function ()
{
	"use strict";

	angular
		.module("app.vehicles")
		.component("vehicleSpecsForm", {
				bindings:{
					vehicle:'=',
					isFormValid:'='
				},
				templateUrl: "app/main/vehicles/components/vehicle-specs-form.html",
				controller: componentController,
		  		controllerAs: 'vm'
			});

		function componentController($filter, $state, $q, $scope, VehicleService, MessageService, GeneralTools, Vehicle, VinAuditService, ProgressService){
			var vm = this;	

			vm.$onInit = initComponent;
			vm.$postLink = initOutPutCallbacks;

			vm.log = log

			function initComponent(){
				initVehicle();
			}

			function initVehicle(){
				if(vm.vehicle == null){
					vm.vehicle = new Vehicle();
				}
			}

			function initOutPutCallbacks(){
				vm.isFormValid = validateForm;
			}

			function validateForm (){
				$scope.specsForm.$submitted = true;

				return $scope.specsForm.$valid;
			}

			function log(){
				console.log($scope)
			}
		}
})();
(function ()
{
	"use strict";

	angular
		.module("app.vehicles")
		.component("vehicleGeneralForm", {
				bindings:{
					vehicle:'=',
					isFormValid:'=',
					onDecodeVin:'<',
					orginVehicle:"=",
					onMetchedVehicleClick: '<',
					enableMerge:'<',
					onMergeClick:'<'
				},
				templateUrl: "app/main/vehicles/components/vehicle-general-form.html",
				controller: componentController,
		  		controllerAs: 'vm'
			});

		function componentController($filter, $state, $q, $scope, VehicleService, MessageService, GeneralTools, Vehicle, VinAuditService, ProgressService, RoleCheckService, TaskConstants){
			var vm = this;	
			var vinApi;
			var allSpecItems;
			var filteredSpecItems;
			var rolesCanEditVehicle = ["developer", "company_manager", "advertizing", "vehicle_manager", "vehicle_helper_add", "vehicle_helper_delete", "service_advisor"];
			vm.$onInit = initComponent;
			vm.$postLink = initOutPutCallbacks;

			vm.translateToVIN = GeneralTools.inputTranslators.VIN;
			vm.checkOutVehicleByVin = checkOutVehicleByVin;
			vm.mergeVehicle = mergeVehicle;
			//vm.decodeVIN = decodeVIN;
			vm.filterByKeyword = filterByKeyword;
			vm.refreshSpecsList = refreshSpecsList;
			vm.exploreTrim = exploreTrim;
			vm.hasPermission = hasPermission;

			function initComponent(){
				initVehicle();
				initValidators();
				initSpecsOptions();
				
			}

			function initOutPutCallbacks(){
				vm.isFormValid = validateForm;
			}

			function validateForm (){
				$scope.generalForm.$submitted = true;

				return $scope.generalForm.$valid;
			}

			function initVehicle (){
				if(vm.vehicle == null){
					vm.vehicle = new Vehicle();
				}
			}

			function initValidators (){
				vm.vinValidations = [
					{
						name:"duplicateCheck",
						validateFn:vinExistingValidation
					}
				]

				vm.stockNumberValidations = [
					{
						name:"duplicateCheck",
						validateFn:stockNumberExistingValidation
					}
				]
			}

			function initSpecsOptions (){
				VinAuditService.querySpecs({fields:"year,make,model"}).then(function(specs){
					allSpecItems = specs
					initSpecsList(allSpecItems);
				});
	 		}

			function initSpecsList(list){
		 		if(list == null){
		 			return;
		 		}

		 		vm.yearMap = new Map();
				vm.makeMap = new Map();
				vm.modelMap = new Map();

		 		list.forEach(function(item){
		 			var year = item.year;
		 			var make = item.make;
		 			var model = item.model;

		 			if(!vm.yearMap.has(year)){
		 				vm.yearMap.set(year, []);
		 			}

		 			vm.yearMap.get(year).push(item)

		 			if(!vm.makeMap.has(make)){
		 				vm.makeMap.set(make, []);
		 			}

		 			vm.makeMap.get(make).push(item)

		 			if(!vm.modelMap.has(model)){
		 				vm.modelMap.set(model, []);
		 			}

		 			vm.modelMap.get(model).push(item)
		 		})
		 	}

			function exploreTrim () {
				if(vm.vehicle.year == '' || vm.vehicle.year == null ||
					vm.vehicle.make == '' || vm.vehicle.make == null ||
					vm.vehicle.model == '' || vm.vehicle.model == null){
					return [];
				}

				var params = {
					fields:'trim',
					year:vm.vehicle.year,
					make:vm.vehicle.make,
					model:vm.vehicle.model,
				};

				return VinAuditService.querySpecs(params);
			}

			function refreshSpecsList(){
		 		filteredSpecItems = allSpecItems;
		 		initSpecsList(filteredSpecItems);

		 		if(vm.yearMap == null ||vm.makeMap == null ||vm.modelMap == null ){
		 			return;
		 		}

		 		if(vm.yearMap.has(vm.vehicle.year)){
		 			filteredSpecItems = vm.yearMap.get(vm.vehicle.year);
		 			initSpecsList(filteredSpecItems);
		 		}

		 		if(vm.makeMap.has(vm.vehicle.make)){
		 			filteredSpecItems = vm.makeMap.get(vm.vehicle.make);
		 			initSpecsList(filteredSpecItems);
		 		}

		 		if(vm.modelMap.has(vm.vehicle.model)){
		 			filteredSpecItems = vm.modelMap.get(vm.vehicle.model);
		 			initSpecsList(filteredSpecItems);
		 		}	
		 	}

			function filterByKeyword (map, keyword){
		 		var keyList = [];

		 		if(map == null){
		 			return []
		 		}

		 		map.forEach(function(value, key){
		 			keyList.push(key);
		 		})

		 		if(keyword == '' || keyword == null){
		 			return keyList;
		 		}

		 		return $filter('filter')(keyList, keyword);
		 	}

		 	function mergeVehicle(){
				VehicleService.checkVehicleIDByVin(vm.vehicle.vin)
						.then(function(vehicleID){
							if(typeof(vm.onMergeClick) == "function"){
								vm.onMergeClick(vehicleID)
								return;
							}
						})
						.catch(MessageService.showToast);
			}

			function checkOutVehicleByVin(){
				VehicleService.checkVehicleIDByVin(vm.vehicle.vin)
						.then(function(vehicleID){
							if(typeof(vm.onMetchedVehicleClick) == "function"){
								vm.onMetchedVehicleClick(vehicleID)
								return;
							}

							goToVehiclePage(vehicleID);
						})
						.catch(MessageService.showToast);
			}

			function goToVehiclePage (vehicleID){
				$state.go("app.vehicle.general", {vehicleID: vehicleID}); 
			}

			function vinExistingValidation(modelValue, viewValue){
				var defer = $q.defer();

				if(modelValue == null){
					return $q.resolve();
				}

				if(vm.orginVehicle && vm.orginVehicle.vin == modelValue){
					return $q.resolve();
				}

				VehicleService.checkVinExistance(modelValue)
					.then(function(isExisting){
						if(isExisting){
							defer.reject();
						}else{
							defer.resolve();
						}
					})
					.catch(MessageService.showToast)

				return defer.promise;
			}

			function stockNumberExistingValidation(modelValue, viewValue){
				var defer = $q.defer();

				if(modelValue == null){
					return $q.resolve();
				}

				if(vm.orginVehicle && vm.orginVehicle.stock_number == modelValue){
					return $q.resolve();
				}

				VehicleService.checkStockNumberExistance(modelValue)
					.then(function(isExisting){
						if(isExisting){
							defer.reject();
						}else{
							defer.resolve();
						}

						$scope.generalForm.$submitted = true;
					})
					.catch(MessageService.showToast)

				return defer.promise;
			}

			function hasPermission(){
				return RoleCheckService.checkRole(rolesCanEditVehicle);
			}

			
		vm.handlePaste = function(html) {
            var tempDiv = document.createElement("DIV");
            tempDiv.innerHTML = html;
            
            Array.from(tempDiv.querySelectorAll("*")).forEach(function(el) {
                el.style.backgroundColor = "";
            });

            return tempDiv.innerHTML;
        }
		}
})();
(function ()
{
	"use strict";

	angular
		.module("app.vehicles")
		.component("vehicleFeatureList", {
				bindings:{
					presetFeatureOption:'<',
					onDecodeVin:'=',
					features:'=',
					addFeature:'='
				},
				templateUrl: "app/main/vehicles/components/vehicle-feature-list.html",
				controller: componentController,
		  		controllerAs: 'vm'
			});

		function componentController($filter, $state, $q, $scope, VehicleService, MessageService, GeneralTools, Vehicle, VinAuditService, ProgressService,  VehicleFeature){
			var vm = this;	

			vm.categories = [];
			vm.$onInit = initComponent;
			vm.$postLink = postLink;
			vm.matchedFeatures = [];
			vm.presetFeatureFilter = {};
			vm.matchedFeatureFilter = {};
			vm.newFeature = new VehicleFeature();

			vm.selecteCategory = selecteCategory;
			vm.onSearchTextChange = onSearchTextChange;

			vm.removeFeature = removeFeature;

			vm.onFeatureOptionClick = onFeatureOptionClick;

			vm.createNewFeature = createNewFeature;

			vm.onDecodeVin = onDecodeVin;

			function initComponent(){
				initWatchers()
				initVehicleFeatures();
			}

			function initVehicleFeatures(){
				if(!Array.isArray(vm.features)){
					vm.features = [];
					return;
				}

				vm.features.forEach(function(feature){
					if(feature.category != "Auto trader"){
						return;
					}

					vm.presetFeatureOption.forEach(function(featureOption){
						if(featureOption.name == feature.name){
							featureOption.isSelected = true;
							addFeatureToList(featureOption, vm.matchedFeatures);
						}
					})
				})
			}

			function postLink(){
				vm.addFeature = addFeature;
				vm.onDecodeVin = onDecodeVin;
			}

			function onDecodeVin(featureList){
				vm.matchedFeatures = [];
				vm.features = [];

				if(!Array.isArray(featureList)){
					return;
				}

				featureList.forEach(function(feature){
					addFeature(feature);
				});
			}

			function initFeatures(){
				if(Array.isArray(vm.presetFeatureOption)){
					vm.features = vm.features.concat(vm.presetFeatureOption);
				}else{
					vm.features = [];
				}
			}

			function createNewFeature(){
				if(vm.newFeature.isValid()){
					var newFeature = new VehicleFeature();

					newFeature.name = vm.newFeature.name;
					newFeature.category = vm.newFeature.category;
					newFeature.value = vm.newFeature.value;

					addFeature(newFeature);
					vm.newFeature = new VehicleFeature();
				} else {
					MessageService.showToast("New feature is invalid")
				}
			}

			function onFeatureOptionClick(presetFeature){
				if(presetFeature.isSelected){
					removeFeature(presetFeature);
				}else{
					var newFeature = new VehicleFeature();
					newFeature.pullDataFromPresetFeature(presetFeature);
					addFeature(newFeature);
				}
			}

			function addFeature(featureToAdd){
				addFeatureToList(featureToAdd, vm.features);

				var matchedFeatures = $filter('filter')(vm.presetFeatureOption, featureToAdd.name);

				matchedFeatures.forEach(function(presetFeature){
					var newFeature = new VehicleFeature();
					newFeature.pullDataFromPresetFeature(presetFeature);

					addFeatureToList(newFeature, vm.features);		
					addFeatureToList(presetFeature, vm.matchedFeatures);
					presetFeature.isSelected = true;
				});
			}

			function unselectPresetFeatureOption(featureToUnselect){
				if(!Array.isArray(vm.presetFeatureOption)){
					return;
				}

				vm.presetFeatureOption.forEach(function(featureOption){
					if(featureToUnselect.name == featureOption.name && featureToUnselect.category == featureOption.category && featureToUnselect.value == featureOption.value){
						featureOption.isSelected = false;
					}
				});
			}

			function removeFeature(featureToRemove){
				//remove from selected feature list
				removeFeatureFromList(featureToRemove, vm.features);

				//remove from matched feature list 
				removeFeatureFromList(featureToRemove, vm.matchedFeatures);

				//unselect in option list
				unselectPresetFeatureOption(featureToRemove);
			}

			function removeFeatureFromList(featureToRemove, featureList){
				if(!Array.isArray(featureList)){
					featureList = [];
				}

				var index = featureList.findIndex(function(feature){
					return featureToRemove.name == feature.name && featureToRemove.category == feature.category && featureToRemove.value == feature.value;
				});

				if(index == -1){
					return;
				}

				featureList.splice(index, 1);
			}

			function addFeatureToList(featureToAdd, featureList){
				if(!Array.isArray(featureList)){
					featureList = [];
				}

				var existingFeature = featureList.find(function(feature){
					return featureToAdd.name == feature.name && featureToAdd.category == feature.category && featureToAdd.value == feature.value;
				});

				if(existingFeature == null){
					featureList.push(featureToAdd);
				}

				return featureList;
			}

			function onSearchTextChange(){

			}

			function selecteCategory(category){
				if(vm.selectedCategory == category){
					vm.selectedCategory = null;
				}else{
					vm.selectedCategory = category;
				}
			}

			function initWatchers(){
				$scope.$watch("vm.features.length", updateCategories);
			}

			function updateCategories(){
				vm.features.forEach(function(feature){
					if(vm.categories.indexOf(feature.category) == -1){
						vm.categories.push(feature.category);
					}
				});
			}
		}
})();
(function ()
{
	"use strict";

	angular
		.module("app.workOrders")
		.component("workorderCustomerSection", {
				bindings:{
					serviceMaps: '=',
					onCustomerAdd: '<',
					onCustomerCreate: '<',
					onServiceMapDelete:'<',
					firstNameSearchText: '=',
					lastNameSearchText: '=',
					phoneNumberSearchText: '=',
					isProcessing: '='
				},
				templateUrl: "app/main/workorders/components/vehicle-customer-section.html",
				controller: componentController,
		  		controllerAs: 'vm'
			});

		function componentController($q, LoginService, $state, CustomersService, GeneralTools, MessageService){
			const vm = this;
			const companyID = LoginService.getCompanyID();
			const firstNameKeyName = "first_name";
			const lastNameKeyName = "last_name";
			const phoneNumberKeyName = "phone_number";
			
			vm.$onInit = initComponent;

			vm.translateToPhoneNumber = GeneralTools.inputTranslators.phoneNumber;

			vm.getCustomerPageUrl = getCustomerPageUrl;
			vm.onSearchTextChange = onSearchTextChange;
			vm.cleanAll = cleanAll;

			function initComponent(){
			}

			function cleanAll(){
				vm.firstNameSearchText = undefined;
				vm.lastNameSearchText = undefined;
				vm.phoneNumberSearchText = undefined;
				vm.matchedCustomers = undefined;
			}

			function getCustomerPageUrl(customerID){
				return $state.href("app.view-customer", {customerID: customerID});
			}

			function onSearchTextChange(){
				vm.matchedCustomers = [];

				const resourcePath = {
					companyID: companyID
				}

				const filter = getFilter();

				if(!filter){
					vm.matchedCustomers = null;
					return;
				}

				CustomersService.getCustomers(resourcePath, filter)
					.then(function(response){
						if(!response || !Array.isArray(response.data)){
							return $q.reject("Customer result invalid.");
						}

						vm.matchedCustomers = response.data;
					})
					.catch(MessageService.showToast);
			}

			function getFilter(){
				var filterString = '';

				if(vm.firstNameSearchText){
					const firstNameFilter = GeneralTools.containFilterBuilder(firstNameKeyName, vm.firstNameSearchText);
					filterString = GeneralTools.stringConnector(filterString, firstNameFilter, " AND ");
				}

				if(vm.lastNameSearchText){
					const lastNameFilter = GeneralTools.containFilterBuilder(lastNameKeyName, vm.lastNameSearchText);
					filterString = GeneralTools.stringConnector(filterString, lastNameFilter, " AND ");
				}	

				if(vm.phoneNumberSearchText){
					const phoneNumberFilter = GeneralTools.containFilterBuilder(phoneNumberKeyName, vm.phoneNumberSearchText);
					filterString = GeneralTools.stringConnector(filterString, phoneNumberFilter, " OR ");
				}

				if(filterString){
					return {filters: filterString};
				}
			}
		}
})();
(function ()
{
	"use strict";

	angular
		.module("app.vehicles")
		.component("vehicleAdvertizingForm", {
				bindings:{
					locations:"<",
					vehicleBrands:'<',
					vehicleFiles:'=',
					vehicleImages:'=',
					importVehicleImages:'=',
					vehicle:'=',
					isFormValid:'='
				},
				templateUrl: "app/main/vehicles/components/vehicle-advertizing-form.html",
				controller: componentController,
		  		controllerAs: 'vm'
			});

		function componentController($filter, $state, $q, $scope, VehicleService, MessageService, GeneralTools, Vehicle, ProgressService, FileUploadService, ImageCompresser, $sce, LoginService, DialogService, FileViewService, VehicleBrochure, VehicleImage, ApiConst, $http){
			var vm = this;	

			vm.host 		= ApiConst.host;
			vm.apiPortoal 	= ApiConst.apiPortoal;
			vm.apiVersion 	= ApiConst.apiVersion;
			vm.http 		= ApiConst.http;
	
			vm.baseUrl		= vm.http + vm.host + '/' + vm.apiPortoal + '/' + vm.apiVersion + '/';

			var sizeFilter 	 = FileUploadService.getSizeFilter(100);
			var videoFilter  = FileUploadService.getVideoFilter();
			var imageFilter  = FileUploadService.getImagevideoFilter();
			var customFilter = FileUploadService.getCustomFilter(["pdf", "jpg", "jpeg", "png", "mp4"]);

			vm.$onInit = initComponent;
			vm.$postLink = initOutPutCallbacks;

			vm.translateToDollar = GeneralTools.inputTranslators.dollar;
			
			vm.fileUploader = FileUploadService.getNewUploader();
			vm.fileUploader.filters.push(customFilter);
			vm.fileUploader.filters.push(sizeFilter);

			vm.imageUploader = FileUploadService.getNewUploader();
			vm.imageUploader.filters.push(imageFilter);
			vm.imageUploader.filters.push(sizeFilter);

			vm.videofileUploader = FileUploadService.getNewUploader();
			vm.videofileUploader.filters.push(videoFilter);
			vm.videofileUploader.filters.push(FileUploadService.getSizeFilter(100));

			vm.updateVehicleImageOnlineStatus = updateVehicleImageOnlineStatus;
			vm.deleteVehicleImage = deleteVehicleImage;	
			vm.onImageDrop = onImageDrop;
			vm.onFileDelete = onFileDelete;
			vm.printBrochure = printBrochure;
			vm.downloadAllImages = downloadAllImages
			vm.isDownloading = false
			vm.downloadOnlineImagesOnly = false

			vm.downloadTotal = 0
			vm.downloadFinished = 0
			vm.isUpdatingFile = false;

			$scope.termOptions = [];
			for (var i = 0; i <= 96; i += 12) {
				$scope.termOptions.push(i);
			}

			function initComponent(){
				initVehicle();
				initVehicleImages();
				initVehicleFiles();
			}

			function initIsInProperty(){
				if(vm.vehicle.is_in_property == true){
					vm.inProperty = true;
				}

				if(vm.vehicle.is_in_property == false){
					vm.notInProperty = true;
				}
			}

			function initVehicleFiles(){
				if(!Array.isArray(vm.vehicleFiles)){
					vm.vehicleFiles = [];
				}
			}

			function initVehicleImages(){
				if(!Array.isArray(vm.vehicleImages)){
					vm.vehicleImages = [];
				}
			}

			function initVehicle(){
				if(vm.vehicle == null){
					vm.vehicle = new Vehicle();
				}
			}

			function initOutPutCallbacks(){
				vm.isFormValid = validateForm;
				vm.importVehicleImages = importVehicleImages;
			}

			function importVehicleImages(image){
				vm.imageUploader.addToQueue(image, {isImporting: true});
			}

			function validateForm (){
				$scope.adevertizingForm.$submitted = true;

				return $scope.adevertizingForm.$valid;
			}

			function updateVehicleImageOnlineStatus(vehicleImage){
				vehicleImage.isProcessing = true;
				var requestBody = {is_online: vehicleImage.is_online};

				updateVehicleImage(vehicleImage.id_vehicle_image, requestBody)
					.catch(function(error){
						MessageService.showToast(error);
					})
					.finally(function(){
						vehicleImage.isProcessing = false;
					});
			}

			function updateVehicleImage (vehicleImageID, requestBody){
				var resourcePath = {
					imageID: vehicleImageID,
					vehicleID: vm.vehicle.getResourceID(),
					companyID: LoginService.getCompanyID()
				};

				return VehicleService.updateVehicleImage(resourcePath, requestBody)
						
			}

			function deleteVehicleImage (image) {
				image.isProcessing = true;

				var resourcePath = {
					imageID: image.id_vehicle_image,
					vehicleID: vm.vehicle.getResourceID(),
					companyID: LoginService.getCompanyID()
				};

				VehicleService.deleteVehicleImage(resourcePath) 
					.then(function(result){
						vm.vehicleImages.splice(vm.vehicleImages.indexOf(image), 1)
						MessageService.showToast("Success !");
					})
					.catch(MessageService.showToast)
					.finally(function(){
						image.isProcessing = false;
					});			
			}		

			function downloadAllImages(){
				if(vm.isDownloading){
					return
				}
				vm.downloadTotal = 0
				vm.downloadFinished = 0
				vm.isDownloading = true
				
				var tasks = $q.resolve()

				var fileNamePrefix =  vm.vehicle.year + ' ' + vm.vehicle.make + ' ' + vm.vehicle.model

				var count = 1

				vm.vehicleImages.forEach(function(image, index){
					if(vm.downloadOnlineImagesOnly && !image.is_online){
						return
					}

					vm.downloadTotal++

					tasks = tasks.then(function(){
						vm.downloadFinished++
						return saveFile(image.url, fileNamePrefix + ' ' + count++ + '.' + image.file_type.substring(image.file_type.lastIndexOf("/") + 1))
					})
				})

				tasks
					.then(function(error){
						MessageService.showToast("Download finished.");
					})
					.catch(function(error){
						MessageService.showToast(error);
					})
					.finally(function(){
						vm.isDownloading = false
					})
			}

			function saveFile(url, filename) {
				return new Promise(function(resolve, reject) {
						// Get file name from url.
						var xhr = new XMLHttpRequest();
						xhr.responseType = 'blob';
						xhr.onload = function() {
							resolve(xhr);
						};
						xhr.onerror = reject;
						xhr.open('GET', $sce.trustAsResourceUrl(url));
						xhr.send();
					})
					.then(function(xhr) {
						return new Promise(function(resolve, reject) {
							var a = document.createElement('a');
							a.href = $sce.trustAsResourceUrl(window.URL.createObjectURL(xhr.response)) ; // xhr.response is a blob
							a.download = filename; // Set the file name.
							a.style.display = 'none';
							document.body.appendChild(a);
							a.click();
							document.body.removeChild(a);
							
							setTimeout(function(){		
								resolve()	
							}, 200);
						})
					});
			}

			vm.imageUploader.onAfterAddingAll = function (addedFileItems) {
				addedFileItems.sort(function (a, b) {
					var nameA = a.file.name.toLowerCase();
					var nameB = b.file.name.toLowerCase();
			
					return String.naturalCompare(nameA.toLowerCase(), nameB.toLowerCase())
				});
				
				addedFileItems.reduce(function (promise, fileItem) {
					return promise.then(function () {
						return new Promise(function (resolve, reject) {
							var imageCompresser = new ImageCompresser();
							var url = URL.createObjectURL(fileItem._file);
							fileItem.imageSrc = $sce.trustAsResourceUrl(url);
			
							if (fileItem.isImporting) {
								fileItem.url = FileUploadService.getUrlForCreateVehicleImage(vm.vehicle.getResourceID());
								fileItem.upload();
								resolve();
							} 
							else if(fileItem.file.type == 'video/mp4'){
								fileItem.url = FileUploadService.getUrlForCreateVehicleImage(vm.vehicle.getResourceID());
								fileItem.upload();
								resolve();
							}
							else {
								imageCompresser.vehiclePhoto(fileItem._file, function (compressedImages) {
									fileItem._file = compressedImages.original;
									fileItem.medium = compressedImages.medium;
									fileItem.small = compressedImages.small;
									fileItem.thumbnail = compressedImages.thumbnail;
									fileItem.file.size = compressedImages.original.size;
									fileItem.url = FileUploadService.getUrlForCreateVehicleImage(vm.vehicle.getResourceID());
								
									fileItem.upload();
									resolve();
								});
							}
						});
					});
				}, Promise.resolve());
			};

			vm.imageUploader.onCompleteItem = function(item, response) {
				var vehicleImageID;
				
				if (response.data) {
					vehicleImageID = response.data;
					var smallFile = new File([item.small], 'small.jpg', { type: 'image/jpeg' });
					var mediumFile = new File([item.medium], 'medium.jpg', { type: 'image/jpeg' });
					var thumbnailFile = new File([item.thumbnail], 'thumbnail.jpg', { type: 'image/jpeg' });
					var uploadHeaders = {
						'Content-Type': undefined,
						token: LoginService.getToken()
					};
					var companyID = LoginService.getCompanyID();
			
					var mediumFormData = new FormData();
					mediumFormData.append('idVehicleImage', vehicleImageID);
					mediumFormData.append('file', mediumFile);
			
					$http.post(vm.baseUrl + 'companies/' + companyID + '/vehicles/'+  vm.vehicle.getResourceID() + '/images/upload/medium', mediumFormData, {
						headers: uploadHeaders
					})
					.then(function(response) {
			
						var thumbnailFormData = new FormData();
						thumbnailFormData.append('idVehicleImage', vehicleImageID);
						thumbnailFormData.append('file', thumbnailFile);
			
						return $http.post(vm.baseUrl + 'companies/' + companyID + '/vehicles/'+  vm.vehicle.getResourceID() + '/images/upload/thumbnail', thumbnailFormData, {
							headers: uploadHeaders
						});
					})
					.then(function(response) {
			
						var smallFormData = new FormData();
						smallFormData.append('idVehicleImage', vehicleImageID);
						smallFormData.append('file', smallFile);
			
						return $http.post(vm.baseUrl + 'companies/' + companyID + '/vehicles/'+  vm.vehicle.getResourceID() + '/images/upload/small', smallFormData, {
							headers: uploadHeaders
						});
					})
					.catch(function(error) {
						console.error('Error uploading medium or small image:', error);
					});
				}
			};

			vm.imageUploader.onSuccessItem = function(item, response, status, headers){
				if(!FileUploadService.isUploadSuccess(headers)){
					MessageService.showToast(headers.message);
					return;
				}

				var imageID = response.data
				var vehicleImage;	
				VehicleService.getVehicleImages(vm.vehicle.getResourceID(), imageID)
						.then(function(result){
							item.remove();
							vm.vehicleImages.push(result[0]);

						})
						.catch(MessageService.showToast);
			}

			vm.imageUploader.onCompleteAll = function(){
				MessageService.showToast("All images are uploaded");
			}

			function onImageDrop (vehicleImage,  $index){
				var indexInArray = vm.vehicleImages.findIndex(function(item){
					return vehicleImage.id_vehicle_image == item.id_vehicle_image;
				});

				vehicleImage.isProcessing = true;
				var previousItemIndex = indexInArray - 1; 
				var newImageIndex;

				if(previousItemIndex < 0){
					newImageIndex = 1;
				}else{
					newImageIndex = vm.vehicleImages[previousItemIndex].index + 1
				}

				updateVehicleImage(vehicleImage.id_vehicle_image, {index: newImageIndex})
					.then(function(){
						return VehicleService.getVehicleImages(vm.vehicle.getResourceID());
					})
					.then(function(images){
						updateImagesIndex(images);
					})
					.catch(function(error){
						if(Array.isArray(imagesWithLatestStatus)){
							return $q.reject("Vehicle Images are invalid");
						}
						MessageService.showToast(error);
					})
					.finally(function(){
						vehicleImage.isProcessing = false;
					});;
			}

			function updateImagesIndex(imagesWithLatestStatus){
				vm.vehicleImages

				if(!Array.isArray(imagesWithLatestStatus)){
					return;
				}

				var imageMap = {};

				imagesWithLatestStatus.forEach(function(image){
					imageMap[image.id_vehicle_image] = image.index;
				});

				vm.vehicleImages.forEach(function(image){
					image.index = imageMap[image.id_vehicle_image];
				})
			}

			vm.fileUploader.onAfterAddingFile = function(fileItem){
				fileItem.url = FileUploadService.getUrlForCreateVehicleFile(vm.vehicle.getResourceID());
				fileItem.upload();
			}

			vm.fileUploader.onSuccessItem = function(item, response, status, headers){
				if(!FileUploadService.isUploadSuccess(headers)){
					MessageService.showToast(headers.message);
					return;
				}

				var fileID = response.data
				VehicleService.getVehicleFiles(vm.vehicle.getResourceID(), fileID) 
					.then(function(result){
						if(item.isCarproof){
							vm.vehicle.car_proof = FileViewService.generateUrlByUUID(result[0].uuid);
						}

						if(item.isCarfax){
							vm.vehicle.car_fax = FileViewService.generateUrlByUUID(result[0].uuid);
						}

						item.remove();
						vm.vehicleFiles.push(result[0]);
					})
					.catch(MessageService.showToast)
			}

			function onFileDelete(file, index){
				var dialogOptions = {};

				dialogOptions.titleString = "Delete file";
				dialogOptions.contentString = "Are you sure to delete file " + file.file_name + '?';

				var confirmOption = {};

				confirmOption.optionName = "YES";
				confirmOption.onClick = function(){
					confirmDeleteFile(file, index);
					DialogService.close();
				}

				var cancelOption = {};

				cancelOption.optionName = "NO";
				cancelOption.onClick = function(){
					DialogService.close();
				}

				dialogOptions.options = [confirmOption, cancelOption];

				DialogService.showOptionsDialog(dialogOptions);
			}

			function confirmDeleteFile (uploadedFile, index){
	        	vm.isDeletingFile = true;

				var resourcePath = {
					fileID: uploadedFile.id_vehicle_file,
					vehicleID: vm.vehicle.getResourceID(),
					companyID: LoginService.getCompanyID()
				};

	        	VehicleService.deleteVehicleFile(resourcePath)
	        		.then(function(){
	        			vm.vehicleFiles.splice(index, 1)
	        		})
	        		.catch(MessageService.showToast)
	        		.finally(function(){
			        	vm.isDeletingFile = false;
	        		})
	        }

	        function printBrochure(){
				var vehicleBrochure = new VehicleBrochure(vm.vehicle.getResourceID());
				vm.isPrintingBrochure = true;
				vehicleBrochure.open(vm.vehicle.interest_rate)
					.catch(MessageService.showToast)
					.finally(function(){
						vm.isPrintingBrochure = false;
					});
			}

			vm.isVehicleContainBoostVin = function(){
				if(!vm.vehicle.boost_vin || vm.vehicle.boost_vin.length != 17){
					return true
				}
				return false
			}

			vm.updateAllVehicleImagesContentType = function() {
				if (!vm.vehicleImages || vm.vehicleImages.length === 0) {
					MessageService.showToast("No Image found");
					return;
				} else {
					vm.isUpdatingFile = true;
			
					const updatePromises = vm.vehicleImages.map(function(images) {
						var resourcePath = {
							companyID: LoginService.getCompanyID(),
							vehicleID: vm.vehicle.getResourceID()
						};
						return VehicleService.updateVehicleImagesContentType(resourcePath, images)
							.then(function() {
								MessageService.showToast("Image are updated");
							})
							.catch(MessageService.showToast);
					});
					Promise.all(updatePromises)
						.then(function() {
							vm.isUpdatingFile = false;
							MessageService.showToast("All images are updated");
						})
						.catch(function(error) {
							console.error("Error updating images:", error);
						});
				}
			};

			vm.unselectAllImages = function () {
				vm.vehicleImages.forEach(function(image) {
					image.isProcessing = true;
				});

				const requests = vm.vehicleImages.map(function(image) {
					const requestBody = { is_online: false };
					var resourcePath = {
						imageID: image.id_vehicle_image,
						vehicleID: vm.vehicle.getResourceID(),
						companyID: LoginService.getCompanyID()
					};

					return VehicleService.updateVehicleImage(resourcePath, requestBody)
						.catch(function(error) {
							MessageService.showToast(error);
						});
				});

				Promise.all(requests)
					.finally(function() {
						vm.vehicleImages.forEach(function(image) {
							image.is_online = false;
							image.isProcessing = false;
						});
						MessageService.showToast("All images are updated");
					});
			};

			vm.selectAllImages = function () {
				vm.vehicleImages.forEach(function(image) {
					image.isProcessing = true;
				});

				const requests = vm.vehicleImages.map(function(image) {
					const requestBody = { is_online: true };
					var resourcePath = {
						imageID: image.id_vehicle_image,
						vehicleID: vm.vehicle.getResourceID(),
						companyID: LoginService.getCompanyID()
					};

					return VehicleService.updateVehicleImage(resourcePath, requestBody)
						.catch(function(error){
							MessageService.showToast(error);
						});
				});

				Promise.all(requests)
					.finally(function()  {
						vm.vehicleImages.forEach(function(image){
							image.is_online = true;
							image.isProcessing = false;
						});
						MessageService.showToast("All images are updated");
					});
			};

		}
})();
(function ()
{
	'use strict';

	angular
		.module('app.vehicles')
		.service("ImportConfirmDialogService", ImportConfirmDialogService);

	/** @ngInject */
	function ImportConfirmDialogService($mdDialog, MessageService, $q)
	{   
		this.showDialog = function(inputParams){
			return $mdDialog.show({
				controller		 	: 'ImportConfirmDialogController',
				controllerAs	   	: 'vm',
				templateUrl			: 'app/main/vehicles/edit-vehicle/import-confirmation-dialog.html',
				clickOutsideToClose	: false,
				escapeToClose 		: false,
				focusOnOpen			: false, 		
				multiple: true,
				locals				: {
					inputParams: inputParams
				}
			});
		}


	}
})();
(function ()
{
	'use strict';

	angular
		.module('app.vehicles')
		.controller('ImportConfirmDialogController', ImportConfirmDialogController);

	function ImportConfirmDialogController($mdDialog, $state, inputParams){   
		var vm = this;

		var propertyNameMap = [
			{
				displayName:"Advertise Price",
				carDepotProName: "advertise_price",
				linkProName: "internet_price"
			},
			{
				displayName:"Year",
				carDepotProName: "year",
				linkProName: "year"
			},
			{
				displayName:"Make",
				carDepotProName: "make",
				linkProName: "make"
			},
			{
				displayName:"Model",
				carDepotProName: "model",
				linkProName: "model"
			},
			{
				displayName:"Trim",
				carDepotProName: "trim",
				linkProName: "trim"
			},
			{
				displayName:"Mileage",
				carDepotProName: "mileage",
				linkProName: "odometer"
			},
			{
				displayName:"Stock Number",
				carDepotProName: "stock_number",
				linkProName: "stock_number"
			},
			{
				displayName:"Doors",
				carDepotProName: "doors",
				linkProName: "doors"
			},
			{
				displayName:"Engine",
				carDepotProName: "engine",
				linkProName: "engine"
			},
			{
				displayName:"Body Type",
				carDepotProName: "body_type",
				linkProName: "body_style"
			},
			{
				displayName:"Exterior Color",
				carDepotProName: "exterior_color",
				linkProName: "exterior_color"
			},
			{
				displayName:"Interior Color",
				carDepotProName: "interior_color",
				linkProName: "interior_color"
			},
			{
				displayName:"City Fuel Efficiency",
				carDepotProName: "city_fuel_efficiency",
				linkProName: "fuel_economy_city_km"
			},
			{
				displayName:"Highway Fuel Efficiency",
				carDepotProName: "highway_fuel_efficiency",
				linkProName: "fuel_economy_highway_km"
			},
			{
				displayName:"Drive Trian",
				carDepotProName: "drive_train",
				linkProName: "drive_train"
			},
			{
				displayName:"Fuel Type",
				carDepotProName: "fuel_type",
				linkProName: "fuel_type"
			},
			{
				displayName:"Transmission Type",
				carDepotProName: "transmission_type",
				linkProName: "transmission"
			}
		]

		vm.confirm = confirm;
		vm.cancel = cancel;

		vm.selectAllImages = selectAllImages;

		init();

		function init(){
			if(!inputParams){
				return;
			}

			initImportedVehiclePropertyList(inputParams.currentVehicleData, inputParams.vehicleDataToImport);
			initImportedVehicleImageList(inputParams.vehicleImagesToImport)
		}

		function initImportedVehicleImageList(importedImages){
			if(!Array.isArray(importedImages)){
				return;
			}

			vm.allImageChecked = true;

			vm.importedImages = [];

			importedImages.forEach(function(imageUrl){
				var imageItem = {
					imageUrl: imageUrl,
					needed: true
				}

				vm.importedImages.push(imageItem);
			});
		}

		function initImportedVehiclePropertyList(currentVehicleData, importedVehicleData){
			if(!importedVehicleData || !currentVehicleData){
				return;
			}

			vm.changeList = [];

			propertyNameMap.forEach(function(item){
				var currentValue = currentVehicleData[item.carDepotProName];
				var importedValue = importedVehicleData[item.linkProName];

				if(currentValue == importedValue){
					return;
				}

				var changes = {
					propertyName: item.carDepotProName,
					currentValue: currentValue,
					importedValue: importedValue,
					displayName: item.displayName,
					applyChange: true
				}

				if(item.carDepotProName == "mileage" && currentValue){
					changes.applyChange = false;
				}

				vm.changeList.push(changes);
			})
		}

		function selectAllImages(){
			vm.importedImages.forEach(function(imageItem){
				imageItem.needed = vm.allImageChecked;
			});
		}

		function confirm(){
			var vehicleDataToImport = {};
			vehicleDataToImport.is_online = true;

			vm.changeList.forEach(function(changes){
				if(changes.applyChange){
					vehicleDataToImport[changes.propertyName] = changes.importedValue;
				}
			});

			var vehicleImagesToImport = [];

			vm.importedImages.forEach(function(imageItem){
				if(imageItem.needed){
					vehicleImagesToImport.push(imageItem.imageUrl);
				}
			});

			$mdDialog.hide({
				vehicleDataToImport: vehicleDataToImport,
				vehicleImagesToImport: vehicleImagesToImport
			})
		}

		function cancel(){
			$mdDialog.cancel("Import Canceled")
		}

	}
})();
(function ()
{
	'use strict';

	angular
		.module('app.vehicles')
		.controller('EditVehicleController', EditVehicleController);

	function EditVehicleController($rootScope, $location, $scope, $mdDialog, $stateParams, $sce, ImageCompresser, ApiConst, RoleCheckService, DialogService, $mdDateLocale, $window, $state, LoginService, FileUploader, FileUploadService, Vinaudit, Vehicle, $filter, $q, $timeout, VehicleService, MessageService, ProgressService, presetFeatures, VehicleFeature, vehicleToBeEdit, vehicleFeatures, VehicleImage, vehicleImages, vehicleFiles, FileViewService, SaleInfoService, FinanceApplicationService, CustomersService, vehicleBrands, GeneralTools, purchaseInfos, VehicleBrochure, saleInfos, locations, TaskConstants, ImportConfirmDialogService, VehicleConstants){
		var vm = this;

		var allSpecItems;
		var vinAudit = new Vinaudit();
		var filteredSpecItems;
		var changesRecord = new Map();
		var companyID = LoginService.getCompanyID();
		var originVehicleFeatures;

	 	vm.decodeVIN = decodeVIN;
		vm.saveChange = saveChange;
		vm.deleteVehicle = deleteVehicle;

		vm.getSaleInfoUrl = getSaleInfoUrl;
		vm.addNewSaleInfo = addNewSaleInfo;
		vm.importFromRmLink = importFromRmLink;
		vm.getPurchaseInfoUrl = getPurchaseInfoUrl;
		vm.addNewPurchaseInfo = addNewPurchaseInfo;
		vm.onMergeClick = onMergeClick;

 		init();

 		function init(){	
 			initVehicle();
 			initPresetFeatures();
 			initVehicleFeatures();
 			initPurchaseInfos();
 			initSaleInfos();
 			initVehicleImages();
 			initVehicleFiles();
 			initVehicleBrands();
 			initLocations();
 			initTabs();
 		}

 		function initLocations(){
 			vm.locations = locations;
 		} 

 		function initVehicleBrands(){
 			vm.vehicleBrands = vehicleBrands;
 		}

 		function initTabs(){
 			vm.tabs = VehicleConstants.editPageTabNames;

 			if(vm.tabs[$stateParams.tab]){
 				vm.currentTab = vm.tabs[$stateParams.tab];
 			}else{
 				vm.currentTab = vm.tabs.generalInfo;
 			}
 		}
 		
 		function initVehicleFiles(){
 			vm.vehicleFiles = vehicleFiles;
 			if(vm.vehicleFiles == null){
 				vm.vehicleFiles = [];
 			}
 		}

 		function initPresetFeatures (){
 			vm.presetFeatureOptions = presetFeatures;
	 	}

 		function initVehicleFeatures (){
 			vm.features = vehicleFeatures;
 			originVehicleFeatures = angular.copy(vm.features);
	 	}

 		function initVehicle(){
 			if(vehicleToBeEdit == null || !Array.isArray(vehicleToBeEdit.data) || vehicleToBeEdit.data.length <= 0){
				MessageService.showToast("vehicle data invalid");
				return;
			}

			vm.vehicle = vehicleToBeEdit.data[0];

			vm.originVehicle = angular.copy(vm.vehicle);
			vm.vehiclePageUrl = $state.href('app.vehicle.general', {vehicleID: vm.vehicle.getResourceID()}, {absolute: true});
 		}

 		function initPurchaseInfos(){
 			vm.purchaseInfos = purchaseInfos;

 			if(!Array.isArray(vm.purchaseInfos)){
 				return;
 			}

 			vm.validPurchaseInfo = vm.purchaseInfos.find(function(purchaseInfo){
 				return !purchaseInfo.is_canceled;
 			});
 		}

 		function initSaleInfos(){
 			vm.saleInfos = saleInfos;
 		}

 		function decodeVIN(){
	 		ProgressService.setMode("indeterminate");
			ProgressService.isVisble(true);

			vm.vehicle.generateStockNumber();

			vinAudit.decodeVin(vm.vehicle.vin)
				.then(function(result){
					vm.vehicle.setAttributes(result.attributes);

					var newFeatureList = [];
					result.features.forEach(function(featureData){
						newFeatureList.push(new VehicleFeature(featureData));
					}); 

					vm.refreshFeature(newFeatureList);

					ProgressService.isVisble(false);
				})
				.catch(function(errorMessage){
					ProgressService.isVisble(false);
					MessageService.showToast("Failed to decode VIN ! " + errorMessage);
				});
	 	}

		function importFromRmLink(event){
			if(vm.rmLink == null || vm.rmLink.trim() == ''){
				MessageService.showToast("Link is empty.");
				return;
			}
			
			vm.isParsingLink = true;
			ProgressService.setMode("indeterminate");
			ProgressService.isVisble(true);

			var vehicleImagesToImport;

			VehicleService.extractVehicleInfoFromRM(vm.rmLink)
				.then(function(data){
					if(data == null || (data.vehicleInfo == null && (data.vehicleImages == null || data.vehicleImages.length <= 0))){
						return $q.reject("Can not extract any data from this link.");
					}

					var inputParams = {
						currentVehicleData: vm.vehicle,
						vehicleDataToImport: data.vehicleInfo,
						vehicleImagesToImport: data.vehicleImages
					}

					return ImportConfirmDialogService.showDialog(inputParams)
				})
				.then(function(dataToImport){
					if(!dataToImport){
						return $q.reject("Import canceled");
					}

					vehicleImagesToImport = dataToImport.vehicleImagesToImport;
					return saveImportedVehicleData(dataToImport.vehicleDataToImport)
				})
				.then(function(){
					MessageService.showToast("Vehicle data is saved");
					if(!Array.isArray(vehicleImagesToImport) || vehicleImagesToImport.length <= 0){
						return $q.resolve();
					}

					MessageService.showToast("Start uploading images");
					return saveImagesFromRmLink(vehicleImagesToImport)
				})
				.catch(function(error){
					if(!error){
						MessageService.showToast("Import is canceled");
					}
					MessageService.showToast(error);
				})
				.finally(function(){
					vm.isParsingLink = false;
					ProgressService.isVisble(false);
				})
		}

		function saveImportedVehicleData(importedVehicleData){
			if(!importedVehicleData && Object.keys(importedVehicleData).length <= 0){
				return $q.resolve();
			}

			var resourcePath = {
				companyID: companyID,
				vehicleID: vm.vehicle.getResourceID()
			}

			return VehicleService.updateVehicle(resourcePath, importedVehicleData)
				.then(function(){
					Object.assign(vm.vehicle, importedVehicleData);
					vm.originVehicle = angular.copy(vm.vehicle);
					return $q.resolve();
				})
				.catch(function(){
					return $q.reject("Failed to save imported vehicle data");
				});
		}


		function parseVehicleInfoFromRmLink (rawData){
			if(rawData ==  null){
				return;
			}

			vm.vehicle.advertise_price 			= rawData.internetPrice;
			vm.vehicle.year 					= rawData.modelYear;
			vm.vehicle.make 					= rawData.make;
			vm.vehicle.model 					= rawData.model;
			vm.vehicle.trim 					= rawData.trim;
			vm.vehicle.stock_number 			= rawData.stockNumber;
			vm.vehicle.doors 					= rawData.doors;
			vm.vehicle.engine 					= rawData.engine;
			vm.vehicle.body_type 				= rawData.bodyStyle;
			vm.vehicle.city_fuel_efficiency 	= rawData.cityFuelEfficiency;
			vm.vehicle.drive_train 				= rawData.driveLine;
			vm.vehicle.exterior_color 			= rawData.exteriorColor;
			vm.vehicle.interior_color 			= rawData.interiorColor;
			vm.vehicle.fuel_type 				= rawData.fuelType;
			vm.vehicle.highway_fuel_efficiency 	= rawData.highwayFuelEfficiency;
			
			vm.vehicle.transmission_type 		= rawData.transmission;

			if(!vm.vehicle.mileage){
				vm.vehicle.mileage = rawData.odometer;
			}			
		}

		function saveImagesFromRmLink(imageUrlList){
			if(!Array.isArray(imageUrlList)){
				return $q.resolve();
			}

			var taskList = [];

			imageUrlList.forEach(function(url){
				taskList.push(downloadImageTask(url));
			})

			return $q.all(taskList).then(function(files){
				files.forEach(function(file){
					vm.importVehicleImages(file);
				})
				return $q.resolve()
			})
		}

		function downloadImageTask(url){
			return VehicleService.downloadImageFromUrl(url)
				.then(function(arrayBuffer){
					var fileNameStartPoint = url.lastIndexOf('/') + 1;
					var fileTypeStartPoint = url.lastIndexOf('.') + 1;

					var imageName = url.substring(fileNameStartPoint, url.length);
					var imageType = "image/" + url.substring(fileTypeStartPoint, url.length);

        			var bytes = new Uint8Array(arrayBuffer.data);
        			var blob = new Blob([bytes], {type: imageType});

					var file = new File([blob], imageName, {type: imageType});
					file.imageUrl = url;
					return $q.resolve(file);
				})
		}




	 	function isAllFormsValid(){
	 		var invalidForms = [];

	 		if(vm.isGeneralFormValid && !vm.isGeneralFormValid()){
	 			invalidForms.push("General");
	 		}

	 		if(vm.isSpecsFormValid && !vm.isSpecsFormValid()){
	 			invalidForms.push("Specs");
	 		}

	 		if(vm.isAdvertizingFormValid && !vm.isAdvertizingFormValid()){
	 			invalidForms.push("Advertizing");
	 		}

	 		if(invalidForms.length <= 0){
	 			return true;
	 		}

	 		MessageService.showToast("Something wrong in " + invalidForms);
	 		return false;
	 	}

 		function saveChange(){
 			if(!isAllFormsValid()){
 				return;
 			}

 			var taskQueue = [];

 			var featuresToCreate = VehicleService.getFeaturesToCreate(vm.features);
 			var featuresToDelete = VehicleService.getFeaturesToDelete(originVehicleFeatures, vm.features);

 			if(Array.isArray(featuresToCreate)){
 				featuresToCreate.forEach(function(feature){
					taskQueue.push(createVehicleFeatures(feature));
				})
 			}

 			if(Array.isArray(featuresToDelete)){
 				featuresToDelete.forEach(function(feature){
					taskQueue.push(deleteVehicleFeatures(feature));
				})
 			}

 			var vehicleRequestBody = VehicleService.updateVehicleRequestBodyGenerator(vm.vehicle, vm.originVehicle)

			if(vehicleRequestBody && Object.keys(vehicleRequestBody).length > 0){
				var resourcePath = {
					companyID: companyID,
					vehicleID: vm.vehicle.getResourceID()
				}
				taskQueue.push(VehicleService.updateVehicle(resourcePath, vehicleRequestBody));
			}

			if(taskQueue.length == 0){
				MessageService.showToast("No changes detected !");
				return;
			}

			ProgressService.setMode("indeterminate");
			ProgressService.isVisble(true);

			$q.all(taskQueue)
		 		.then(function(response){
			 		ProgressService.isVisble(false);
			 		MessageService.showToast("Success !");

			 		vm.originVehicle = angular.copy(vm.vehicle);
			 		originVehicleFeatures = angular.copy(vm.features);
			 	})
			 	.catch(function(errorMessage){
					ProgressService.isVisble(false);
		 			MessageService.showToast(errorMessage);
			 	});
 		}

		function getSaleInfoUrl (saleInfo){
			var param = {
				vehicleID:vm.vehicle.getResourceID(),
				saleInfoID: saleInfo.getResourceID()
			};

			return $state.href('app.edit-sale-info', param, {absolute: true}); 
		}

		function getPurchaseInfoUrl(purchaseInfo){
			var param = {
				vehicleID:vm.vehicle.getResourceID(),
				purchaseInfoID: purchaseInfo.getResourceID()
			};

			return $state.href('app.edit-purchase-info', param, {absolute: true}); 
		}

		function addNewSaleInfo (){
			$state.go("app.vehicle.purchase", {vehicleID: vm.vehicle.getResourceID()}); 
		}

		function addNewPurchaseInfo (){
			var params = {
				vehicleID: vm.vehicle.getResourceID()
			}
			$state.go("app.add-purchase-info", params); 
		}

		function initVehicleImages(){
 			vm.vehicleImageList = vehicleImages;
 		}

 		function createVehicleFeatures(feature){
 			if(feature == null){
 				return $q.reject("Failed to create feature");
 			}

 			var defer = $q.defer();
 			var resourcePath = {
 				companyID: LoginService.getCompanyID(),
 				vehicleID: vm.vehicle.getResourceID()
 			}

			VehicleService.createVehicleFeature(resourcePath, feature)
					.then(function(newFeatureID){
						feature.id_vehicle_feature = newFeatureID;
						defer.resolve()
					})
					.catch(function(error){
						defer.reject(error);
					});

			return defer.promise;
 		}

 		function deleteVehicleFeatures(feature){
 			if(feature == null){
 				return $q.reject("Failed to create feature");
 			}

 			var resourcePath = {
 				companyID: LoginService.getCompanyID(),
 				vehicleID: vm.vehicle.getResourceID(),
 				vehiclefeatureID: feature.getResourceID()
 			}

			return VehicleService.deleteVehicleFeature(resourcePath, feature)
 		}

		function deleteVehicle (){
			var dialogOptions = {};

			dialogOptions.inputBoxPlaceHolder	= "Enter here";
			dialogOptions.cancelButtonString	= "CANCEL";
			dialogOptions.confirmButtonString	= "CONFIRM";
			dialogOptions.titleString			= "ARE YOU SURE TO DELETE THIS VEHICLE";
			dialogOptions.contentString			= "Please Type \"CONFIRM\" below:";

			dialogOptions.confirmCallback				= confirmDeleteVehicleCallback;
			dialogOptions.enableConfirmButtonCallback	= enableDeleteVehicleButtonCallback;

			DialogService.showConfirmDialog(dialogOptions);
		}

		function enableDeleteVehicleButtonCallback(inputString){
			if(inputString === "CONFIRM"){
				return true;
			}
			return false;
		}

		function confirmDeleteVehicleCallback(){
			ProgressService.setMode("indeterminate");
			ProgressService.isVisble(true);

			vm.vehicle.setParentResourceID(companyID);

			VehicleService.deleteVehicle(vm.vehicle.getResourceID())
					.then(function(response){
						ProgressService.isVisble(false);
						MessageService.showToast("Success !");
	 					$state.go("app.vehicles")
					})
					.catch(function(errorMessage){
						ProgressService.isVisble(false);
						MessageService.showToast(errorMessage);
					});
		}

		function onMergeClick(destinationCehicleID){
			var dialogOptions = {};

			dialogOptions.inputBoxPlaceHolder	= "Enter here";
			dialogOptions.cancelButtonString	= "CANCEL";
			dialogOptions.confirmButtonString	= "CONFIRM";
			dialogOptions.titleString			= "VEHICLE MERGE";
			dialogOptions.contentString			= "This will merge the vehicle customers, tasks safeties & work orders.  Type \"CONFIRM\" to continue:";

			dialogOptions.confirmCallback = function(){
				const resourcePath = {
					companyID: companyID,
					vehicleID: $stateParams.vehicleID
				};

				ProgressService.setMode("indeterminate");
				ProgressService.isVisble(true);

				VehicleService.mergeVehicle(resourcePath, destinationCehicleID)
					.then(function(){
						$state.go("app.vehicle.general", {vehicleID: destinationCehicleID});
					})
					.catch(MessageService.showToast)
					.finally(function(){
						ProgressService.isVisble(false);
					});
			};

			dialogOptions.enableConfirmButtonCallback	= enableMergeVehicleButtonCallback;

			DialogService.showConfirmDialog(dialogOptions);		

		}

		function enableMergeVehicleButtonCallback(inputString){
			if(inputString === "CONFIRM"){
				return true;
			}
			return false;
		}
	}

})();
(function ()
{
	'use strict';

	angular
		.module('app.vehicles')
		.controller('DeliverScheduleController', DeliverScheduleController);

	function DeliverScheduleController($filter, ToolsConstants, workorderPriorities, WorkOrderService, WorkOrderConstants, $stateParams, $location, $anchorScroll, $state, MessageService, $mdSidenav, $q, LoginService, VehicleService, ProgressService, $scope, GeneralTools, SaleInfoService, VehicleConstants, locations, userConfig, UserConfigService){   
		const vm = this;
		const companyID = LoginService.getCompanyID();
		const userID = LoginService.getUserID();
		const andConnector = " AND ";
		var pageConfig;

		vm.userFilters = [];
		vm.gotoAnchor = gotoAnchor;
		vm.refreshDeliverySchedule = refreshDeliverySchedule;
		vm.applyFilter = applyFilter;
		vm.saveCurrentFilter = saveCurrentFilter;
		vm.deleteFilter = deleteFilter;
		vm.onMechanicFilterChange = onMechanicFilterChange;

		init();

		function init(){
			initLocations();
			initWorkorderPriorities();
			initFilters();
			initUserConfig();
			refreshDeliverySchedule();
		}

		function initWorkorderPriorities(){
			vm.workorderPriorities = workorderPriorities;
		}

		function initUserConfig(){
			if(!userConfig){
				return;
			}

			pageConfig = userConfig.getDeliveryPageConfig();

			if(!pageConfig){
				return;
			}

			if(!Array.isArray(pageConfig.filterList)){
				pageConfig.filterList = [];
			}

			vm.userFilters = pageConfig.filterList;
		}

		function initFilters(){
			vm.mechanicFilter = filterTranslator($stateParams.mechanicCompleted);
			vm.detailFilter = filterTranslator($stateParams.detailCompleted);
			vm.licensingFilter = filterTranslator($stateParams.licensingCompleted);
			vm.locationFilter = filterTranslator($stateParams.location);
		}

		function deleteFilter(index){
			if(!Array.isArray(vm.userFilters) || !userConfig){
				MessageService.showToast("Failed to delete, param invalid.");
				return;
			}
				
			vm.userFilters.splice(index, 1);
			
			userConfig.setDeliveryPageConfig({filterList: vm.userFilters});
			updatePageConfig(userConfig);
		}

		function saveCurrentFilter(currentFilterName){
			if(!currentFilterName){
				return MessageService.showToast("Please input filter name.");
			}

			var filter = {
				mechanicCompleted: vm.mechanicFilter,
				detailCompleted: vm.detailFilter,
				licensingCompleted: vm.licensingFilter,
				location: vm.locationFilter,
			}

			vm.userFilters.push({filter:filter, name:currentFilterName});

			userConfig.setDeliveryPageConfig({filterList: vm.userFilters});

			updatePageConfig(userConfig);
		}

		function updatePageConfig(userConfig){
			if(!userConfig){
				MessageService.showToast("Failed to update page config, param invalid");
				return;
			}
				
			const resourcePath = {
				companyID: companyID,
				userID: userID
			};

			const requestBody = {
				config: userConfig.config
			}

			vm.isLoading = true;

			UserConfigService.updateUserConfig(resourcePath, requestBody)
				.catch(MessageService.showToast)
				.finally(function(){
					vm.isLoading = false;
				});
		}

		function applyFilter(filterObj){
			if(!filterObj || !filterObj.filter){
				MessageService.showToast("filter invalid");
				return;
			}

			vm.mechanicFilter = filterTranslator(filterObj.filter.mechanicCompleted);
			vm.detailFilter = filterTranslator(filterObj.filter.detailCompleted);
			vm.licensingFilter = filterTranslator(filterObj.filter.licensingCompleted);
			vm.locationFilter = filterTranslator(filterObj.filter.location);

			refreshDeliverySchedule();
		}

		function initLocations(){
			vm.locations = locations;

			if(!Array.isArray(vm.locations)){
				vm.locations = [];
			}
		}

		function saleInfoFilterBuilder(){
			var filterString = "(is_delivered eq false) AND (is_canceled eq false)";

			/*if(vm.mechanicFilter != undefined){
				filterString = GeneralTools.stringConnector(filterString, filterStringBuilder("is_mechanic_completed", vm.mechanicFilter), andConnector)
			}*/

			if(vm.detailFilter != undefined){
				filterString = GeneralTools.stringConnector(filterString, filterStringBuilder("is_detail_completed", vm.detailFilter), andConnector)
			}

			if(vm.licensingFilter != undefined){
				filterString = GeneralTools.stringConnector(filterString, filterStringBuilder("is_licensing_completed", vm.licensingFilter), andConnector)
			}

			return { filters: filterString };
		}

		function filterStringBuilder(key, value){
			return "(" + key + " eq " + value + ")"
		}

		function filterTranslator(filterValue){
			if(filterValue === "true" || filterValue === true){
				return true;
			}

			if(filterValue === "false" || filterValue === false){
				return false;
			}

			if(!isNaN(parseInt(filterValue))){
				return parseInt(filterValue);
			}

			return undefined;
		}

		function vehicleFilterBuilder(){
			if(vm.locationFilter != undefined){
				return { filters:filterStringBuilder("fk_id_location", vm.locationFilter) };
			}
		}

		function refreshDeliverySchedule(){
			var saleInfoFilters = saleInfoFilterBuilder();
			var vehicleFilters = vehicleFilterBuilder();

			const resourcePath = {companyID: companyID};
			const sorting = {
				sortBy: "delivery_due_date",
				sortDirection: "ASC"
			};

			var saleInfoList;
			var vehicleList;

			vm.isLoading = true;

			ProgressService.setMode("indeterminate");
			ProgressService.isVisble(true);

			SaleInfoService.getSaleInfos(resourcePath, saleInfoFilters, null, sorting)
				.then(function(_saleInfoList){
					saleInfoList = _saleInfoList;

					if(!Array.isArray(saleInfoList)){
						return $q.reject("failed to refreshDeliverySchedule, saleInfoList invalid");
					}

					const vehicleIdList = [];

					saleInfoList.forEach(function(saleInfo){
						if(vehicleIdList.indexOf(saleInfo.fk_id_vehicle) == -1){
							vehicleIdList.push(saleInfo.fk_id_vehicle);
						}
					});

					return fetchVehiclesByVehicleIdList(vehicleIdList, vehicleFilters);
				})
				.then(function(_vehicleList){
					vehicleList = _vehicleList;
					
					return fetchWorkordersByVehicleList(vehicleList);
				})
				.then(function(workorderMap){
					vm.dateMap = groupDeliveryDetailsByDate(buildDeliveryDetailList(saleInfoList, vehicleList, workorderMap));
					vm.dateMapSize = Object.keys(vm.dateMap);
					refreshDeliverySummary(vm.dateMap);
					refreshUrl();
				})
				.catch(MessageService.showToast)
				.finally(function(){
					vm.isLoading = false;
					ProgressService.isVisble(false);
				});
		}

		function fetchWorkordersByVehicleList(vehicleList){
			if(!Array.isArray(vehicleList)){
				return $q.reject("Failed to fetch workorders, vehicle list invalid.");
			}

			const queue = {};

			vehicleList.forEach(function(vehicle){
				if(vehicle){
					const vehicleID = vehicle.getResourceID();
					queue[vehicleID] = fetchWorkorder(vehicleID);
				}			
			});

			return $q.all(queue);
		}

		function fetchWorkorder(vehicleID){
			const resourcePath = {
				companyID: companyID,
				vehicleID: vehicleID
			}

			const quotedFilter = GeneralTools.equalFilterBuilder("fk_id_work_order_status", WorkOrderConstants.statusIDs.quoted);
			const completedFilter = GeneralTools.equalFilterBuilder("fk_id_work_order_status", WorkOrderConstants.statusIDs.completed);
			const onLotFilter = GeneralTools.equalFilterBuilder("fk_id_work_order_status", WorkOrderConstants.statusIDs.onlot);	
			const bookFilter = GeneralTools.equalFilterBuilder("fk_id_work_order_status", WorkOrderConstants.statusIDs.booked);	
			const startedFilter = GeneralTools.equalFilterBuilder("fk_id_work_order_status", WorkOrderConstants.statusIDs.started);	

			var filters = GeneralTools.stringConnector(quotedFilter, completedFilter, ToolsConstants.apiFilters.orConnector);
			filters = GeneralTools.stringConnector(filters, onLotFilter, ToolsConstants.apiFilters.orConnector);
			filters = GeneralTools.stringConnector(filters, bookFilter, ToolsConstants.apiFilters.orConnector);
			filters = GeneralTools.stringConnector(filters, startedFilter, ToolsConstants.apiFilters.orConnector);

			return WorkOrderService.getWorkOrders(resourcePath, filters).$promise
				.then(function(workorders){
					if(!Array.isArray(workorders)){
						return $q.reject("workorders data invalid.");
					}

					const queue = [];
					var isCompletedWorkorderFound = false;

					workorders = $filter("orderBy")(workorders, "invoice_number", true);

					workorders.forEach(function(workorder){
						if(!workorder){
							return;
						}

						if(workorder.isCompleted()){
							if(isCompletedWorkorderFound){
								return;
							}							
							isCompletedWorkorderFound = true;
						}

						queue.push($q.all({
							workorder: $q.resolve(workorder),
							partsAndInventories: fetchPartsAndInventories(vehicleID, workorder.id_work_order),
							labors: fetchLabors(vehicleID, workorder.id_work_order)
						}))
					});

					return $q.all(queue)
				});
		}

		function fetchPartsAndInventories(vehicleID, workorderID){
			return $q.all({
					parts: fetchWorkOrderParts(vehicleID, workorderID), 
					inventories: fetchWorkOrderInventories(vehicleID, workorderID)
				})
				.then(function(results){
					if(!results || !Array.isArray(results.parts) || !Array.isArray(results.inventories)){
						return $q.reject("Parts and inventories data invalid");
					}

					const partsAndInventories = [];

					results.parts.forEach(function(part){
						if(part){
							partsAndInventories.push({
								name: part.name,
								notOrdered: !part.is_ordered
							});
						}
					});

					results.inventories.forEach(function(inventory){
						if(inventory){
							partsAndInventories.push({name: inventory.name});
						}
					});

					return $q.resolve(partsAndInventories);
				});
		}

		function fetchWorkOrderInventories(vehicleID, workOrderID){
			const resourcePath = { 
				companyID: companyID,
				vehicleID: vehicleID,
				workorderID: workOrderID
			};

			return WorkOrderService.getWorkOrderInventories(resourcePath).$promise
		}

		function fetchWorkOrderParts(vehicleID, workOrderID){
			const resourcePath = { 
				companyID: companyID,
				vehicleID: vehicleID,
				workorderID: workOrderID
			};

			return WorkOrderService.getWorkOrderParts(resourcePath).$promise
		}

		function fetchLabors(vehicleID, workOrderID){
			const resourcePath = { 
				companyID: companyID,
				vehicleID: vehicleID,
				workorderID: workOrderID
			};

			return WorkOrderService.getLabors(resourcePath).$promise;
		}

		function refreshUrl(){
			const filters = {}

			if(vm.mechanicFilter != undefined){
				filters.mechanicCompleted = vm.mechanicFilter;
			}

			if(vm.detailFilter != undefined){
				filters.detailCompleted = vm.detailFilter;
			}

			if(vm.licensingFilter != undefined){
				filters.licensingCompleted = vm.licensingFilter;
			}

			if(vm.locationFilter != undefined){
				filters.location = vm.locationFilter;
			}

			$location.search(filters).replace();
		}

		function groupDeliveryDetailsByDate(deliveryDetailList){
			var dateMap = {};

			if(!Array.isArray(deliveryDetailList)){
				return;
			}

			deliveryDetailList.forEach(function(deliveryDetail){
				if(!deliveryDetail || !deliveryDetail.saleInfoData){
					return;
				}

				const date = deliveryDetail.saleInfoData.delivery_due_date;

				if(!Array.isArray(dateMap[date])){
					dateMap[date] = [];
				}

				dateMap[date].push(deliveryDetail);
			});

			return dateMap;
		}

		function buildDeliveryDetailList(saleInfoList, vehicleList, workorderMap){
			if(!Array.isArray(saleInfoList) || !Array.isArray(vehicleList) || !workorderMap){
				return;
			}

			const deliveryDetailList = [];

			saleInfoList.forEach(function(saleInfo){
				var matchedVehicle = vehicleList.find(function(vehicle){
					if(!vehicle){
						return
					}
					return vehicle.getResourceID() == saleInfo.fk_id_vehicle;
				});

				if(!matchedVehicle || vm.mechanicFilter === !isAllWorkorderCompleted(workorderMap[matchedVehicle.getResourceID()])){
					return;
				}

				deliveryDetailList.push({
					vehicleData: matchedVehicle,
					saleInfoData: saleInfo,
					locationInfo: getLocationInfo(matchedVehicle.fk_id_location),
					workorderDetails: workorderMap[matchedVehicle.getResourceID()]
				});
			});

			return deliveryDetailList;
		}

		function isAllWorkorderCompleted(workorderDetails){
			if(!Array.isArray(workorderDetails)){
				return;
			}

			if(workorderDetails.length == 0){
				return true;
			}

			return workorderDetails.every(function(item){
				if(!item || !item.workorder){
					return;
				}

				return item.workorder.isCompleted();
			});
		}

		function getLocationInfo(locationID){
				if(!Array.isArray(vm.locations)){
					return;
				}

				return vm.locations.find(function(location){
					return location.id_location == locationID;
				});
			}

		function fetchVehiclesByVehicleIdList(vehicleIdList, vehicleFilters){
			if(!Array.isArray(vehicleIdList)){
				return;
			}

			var queue = [];

			vehicleIdList.forEach(function(vehicleID){
				const resourcePath = {
					companyID: companyID,
					vehicleID: vehicleID
				}

				queue.push(VehicleService.getVehicle(resourcePath, vehicleFilters));
			});

			return $q.all(queue).then(function(results){
				return results.map(function(result){
					return result.data[0];
				});
			})
		}

		function refreshDeliverySummary(dateMap){
			if(!dateMap){
				return;
			}

			var dateList = Object.keys(dateMap);
			var deliverySummaryDateMap = {};
			var totalSummary = {
				totalMechanicTasks: 0,
				totalDetailTasks: 0,
				totalLicensingTasks: 0,
				completedMechanicTasks: 0,
				completedDetailTasks: 0,
				completedLicensingTasks: 0
			}

			dateList.forEach(function(date){
				var deliveryDetailList = dateMap[date];

				deliverySummaryDateMap[date] = {
					totalMechanicTasks: 0,
					completedMechanicTasks: 0,
					totalDetailTasks: 0,
					completedDetailTasks: 0,
					totalLicensingTasks: 0,
					completedLicensingTasks: 0,
				};

				deliveryDetailList.forEach(function(deliveryDetail){
					if(!deliveryDetail || !deliveryDetail.saleInfoData){
						return;
					}
					var saleInfo = deliveryDetail.saleInfoData;

					deliverySummaryDateMap[date].totalMechanicTasks++;
					deliverySummaryDateMap[date].totalDetailTasks++;
					deliverySummaryDateMap[date].totalLicensingTasks++;

					totalSummary.totalMechanicTasks++;
					totalSummary.totalDetailTasks++;
					totalSummary.totalLicensingTasks++;

					if(isAllWorkorderCompleted(deliveryDetail.workorderDetails)){
						deliverySummaryDateMap[date].completedMechanicTasks++;
						totalSummary.completedMechanicTasks++;
					}

					if(saleInfo.is_detail_completed){
						deliverySummaryDateMap[date].completedDetailTasks++;
						totalSummary.completedDetailTasks++;
					}

					if(saleInfo.is_licensing_completed){
						deliverySummaryDateMap[date].completedLicensingTasks++;
						totalSummary.completedLicensingTasks++;
					}
				})
			})

			vm.deliverySummaryDateMap = deliverySummaryDateMap;
			vm.totalSummary = totalSummary;
		}

		function gotoAnchor(date) {
			var newHash = date;
			if ($location.hash() !== newHash) {
				// set the $location.hash to `newHash` and
				// $anchorScroll will automatically scroll to it
				$location.hash(date);
			} else {
				// call $anchorScroll() explicitly,
				// since $location.hash hasn't changed
				$anchorScroll();
			}
		};

		function onMechanicFilterChange(){
			const currentFilter = filterTranslator($stateParams.mechanicCompleted);

			if(currentFilter == null && vm.mechanicFilter != null){
				filterDeliveryScheduleByWorkorder();
			} else {
				refreshDeliverySchedule();
			}
		}

		function filterDeliveryScheduleByWorkorder(){
			if(!vm.dateMap){
				return;
			}

			Object.keys(vm.dateMap).forEach(function(date){
				if(!vm.dateMap[date]){
					return;
				}

				vm.dateMap[date] = vm.dateMap[date].filter(function(deliveryDetail){
					if(!deliveryDetail){
						return;
					}

					return vm.mechanicFilter === isAllWorkorderCompleted(deliveryDetail.workorderDetails);
				});

				if(vm.dateMap[date].length <= 0){
					delete vm.dateMap[date];
				}
			});

			vm.dateMapSize = Object.keys(vm.dateMap);
			refreshDeliverySummary(vm.dateMap);
			refreshUrl();
		}
	}
})();
(function ()
{
	"use strict";

	angular
		.module("app.vehicles")
		.component("deliverDateSummary", {
				bindings:{
					summary:'='
				},
				templateUrl: "app/main/vehicles/deliver-schedule/deliver-date-summary.html",
				controller: componentController,
		  		controllerAs: 'vm'
			});

		function componentController($filter, $state, $q, $scope, VehicleService, MessageService, GeneralTools, Vehicle, VinAuditService, VehicleFeature, LoginService, VehicleConstants, TaskConstants){
			var vm = this;	
			var companyID = LoginService.getCompanyID();
			var vehicleList = [];

			vm.$onInit = initComponent;

			function initComponent(){

			}


		}
})();
(function ()
{
	"use strict";

	angular
		.module("app.vehicles")
		.component("deliverDateDetail", {
				bindings:{
					date:'<',
					deliveryList:'=',
					workorderPriorities: '<'
				},
				templateUrl: "app/main/vehicles/deliver-schedule/deliver-date-detail.html",
				controller: componentController,
		  		controllerAs: 'vm'
			});

		function componentController($state, VehicleConstants, TaskConstants){
			var vm = this;	
			const maxDisplay = 4;

			vm.getMaxDisplay = getMaxDisplay;
			vm.$onInit = initComponent;
			vm.getUrlForVehiclePage = getUrlForVehiclePage;
			vm.getWorkorderUrl = getWorkorderUrl;
			vm.getWorkorderPriority = getWorkorderPriority;
			vm.isAllWorkorderCompleted = isAllWorkorderCompleted;

			function getWorkorderPriority(priorityID){
				if(!Array.isArray(vm.workorderPriorities)){
					return;
				}

				const matchedPriority = vm.workorderPriorities.find(function(priority){
					return !!priority && priority.id_work_order_priority == priorityID;
				});

				if(matchedPriority){
					return matchedPriority.name;
				}
			}

			function getWorkorderUrl(vehicleID, workorderID){
				const param = {
					vehicleID: vehicleID,
					workOrderID: workorderID
				}

				return $state.href('app.edit-workorder.general', param); 
			}

			function initComponent(){

			}

			function getUrlForVehiclePage(vehicle){
				return $state.href('app.vehicle.delivery', {vehicleID:vehicle.getResourceID()}, {absolute: true}); 
			}

			function getMaxDisplay(listLength){
				if(listLength >= (maxDisplay + 1)){
					return maxDisplay - 1;
				}

				return maxDisplay
			}

			function isAllWorkorderCompleted(workorderDetail){
				if(!Array.isArray(workorderDetail)){
					return;
				}

				if(workorderDetail.length == 0){
					return true;
				}

				return workorderDetail.every(function(item){
					if(!item || !item.workorder){
						return;
					}

					return item.workorder.isCompleted();
				});
			}
		}
})();
(function ()
{
	"use strict";

	angular
		.module("app.vehicles")
		.component("vehicleSearch", {
				bindings:{
					defaulFilter: '<',
					locations:'<',
					notFoundMessage:'<',
					onSelect:'<',
					onBlur:'<',
					onFocus:'<'
				},
				templateUrl: "app/main/vehicles/browse-vehicles/vehicle-search.html",
				controller: componentController,
		  		controllerAs: 'vm'
			});

		function componentController($scope, TaskConstants, $state, LoginService, VehicleService, $q, GeneralTools){
			var vm = this;

			const isLoggedIn = !isNaN(parseInt(LoginService.getUserID()));
			const companyID = LoginService.getCompanyID();
			const andConnector = " AND ";

			vm.$onInit = initComponent;
			vm.queryVehicle = queryVehicle;
			vm.getVehicleLocation = getVehicleLocation;
			vm.getUrlForDetailPage = getUrlForDetailPage;
			vm.select = select;
			vm.onBlurCallback = onBlurCallback
			vm.onFocusCallback = onFocusCallback

		
			function initComponent(){
				if(!vm.defaulFilter){
					vm.defaulFilter = { filters: ''};

					if(isLoggedIn){
						vm.defaulFilter.isSold = false;
						vm.defaulFilter.filters = GeneralTools.stringConnector(vm.defaulFilter.filters, GeneralTools.equalFilterBuilder("purchase_info.is_canceled", false), andConnector);
					}
				}
			}

			function getVehicleLocation(vehicle){
				if(!vehicle || !Array.isArray(vm.locations)){
					return;
				}

				return vm.locations.find(function(location){
					return location.id_location == vehicle.fk_id_location;
				});
			}
			
			function getUrlForDetailPage (vehicle){
				var param = {vehicleID:vehicle.getResourceID()};

				return $state.href('app.vehicle.general', param, {absolute: true}); 
			}

			function queryVehicle(){
				const resourcePath = {
					companyID: companyID
				}

				const filter = angular.copy(vm.defaulFilter);
				const searchFilterString = VehicleService.searchTextFilterBuilder(vm.searchText);

				filter.filters = GeneralTools.stringConnector(filter.filters, searchFilterString, andConnector);

				return VehicleService.getVehicle(resourcePath, filter, null, null)
					.then(function(result){
						if(result == null || !Array.isArray(result.data)){
							return $q.reject("result invalid.");
						}

						return $q.resolve(result.data);
					})
			}

			function select(vehicle){
				if(vm.onSelect){
					vm.onSelect(vehicle);
				}
			}

			function onBlurCallback(){
				if(vm.onBlur){
					vm.onBlur()
				}
			}

			function onFocusCallback(){
				if(vm.onFocus){
					vm.onFocus()
				}
			}
		}
})();
(function ()
{
	"use strict";

	angular
		.module("app.vehicles")
		.component("vehicleCard", {
				bindings:{
					vehicle: '=',
					locations: '<'
				},
				templateUrl: "app/main/vehicles/browse-vehicles/vehicle-card.html",
				controller: componentController,
		  		controllerAs: 'vm'
			});

		function componentController($scope, TaskConstants, $state){
			var vm = this;	

			vm.$onInit = initComponent;
			vm.getVehicleLocation = getVehicleLocation;
			vm.getUrlForDetailPage = getUrlForDetailPage;
		
			function initComponent(){
			}

			function getVehicleLocation(vehicle){
				if(!vehicle || !Array.isArray(vm.locations)){
					return;
				}

				return vm.locations.find(function(location){
					return location.id_location == vehicle.fk_id_location;
				});
			}
			
			function getUrlForDetailPage (vehicle){
				var param = {vehicleID:vehicle.getResourceID()};

				return $state.href('app.vehicle.general', param, {absolute: true}); 
			}
		}
})();
(function ()
{
	"use strict";

	angular
		.module("app.vehicles")
		.component("inventoryInfoList", {
				bindings:{
					inventoryInfoList:'=',
					title:'=',
					tag:'=',
					itemNameBuilder:'=',
					onItemChange:'=',
					selectedItem:'=',
					isProcessing:'='
				},
				templateUrl: "app/main/vehicles/browse-vehicles/inventory-info-list.html",
				controller: componentController,
		  		controllerAs: 'vm'
			});

		function componentController($scope){
			var vm = this;	

			vm.showFilter = true;
			
			vm.$onInit = initComponent;

		
			function initComponent(){
			}

			
		}
})();
(function ()
{
	'use strict';

	angular
		.module('app.vehicles')
		.controller('BrowseVehicleController', BrowseVehicleController);

	function BrowseVehicleController(EmailService, $location, $filter, $stateParams, $resource, ReportService, GeneralTools, $scope, $state, MessageService, $mdSidenav, $q, LoginService, VehicleService, ProgressService, locations, TaskConstants, HeaderHelper, RoleCheckService, ToolsConstants, basicInventoryInfos){   
		const vm = this;
		const filterConsts = ToolsConstants.apiFilters;
		const priceFilterInterval = 10000;
		const mileageFilterInterval = 20000;
		const companyID = LoginService.getCompanyID();
		const isLoggedIn = !isNaN(parseInt(LoginService.getUserID()));
		const dateFormat = "YYYY-MM-DD";
		const hasPermissionToUseTimeRangeFilter = RoleCheckService.checkRole(["developer", "company_manager", "accountant", "sales_manager"]);
		vm.hasPermissionAccountant = RoleCheckService.checkRole(["accountant", "developer"]);

		var allYearInventoryInfo;
		var isLastPage = false;

		vm.availableAvailabilityFilterTag = "available";
		vm.onlineAvailabilityFilterTag = "online";
		vm.allAvailabilityFilterTag = "all";
		vm.yearFilterTag = "year";
		vm.makeFilterTag = "make";
		vm.modelFilterTag = "model";
		vm.priceFilterTag = "price";
		vm.mileageFilterTag = "mileage";
		vm.locationFilterTag = "location";
		vm.soldTimeRageFilterTag = "sold";
		vm.purchaseTimeRageFilterTag = "purchase";
		vm.startDateFilterTage = "startDate";
		vm.endDateFilterTag = "endDate";

		vm.locationInventoryInfoItemNameBuilder = locationInventoryInfoItemNameBuilder;
		vm.priceInventoryInfoItemNameBuilder = priceInventoryInfoItemNameBuilder;
		vm.mileageInventoryInfoItemNameBuilder = mileageInventoryInfoItemNameBuilder;
		vm.onInventoryFilterChange = onInventoryFilterChange;

		vm.onScroll = onScroll;
		vm.loadMore = loadMore;
		vm.refresh = refresh;
		vm.filterByTimeRange = filterByTimeRange;

		vm.generateSaleReport = generateSaleReport;
		vm.generatePurchaseReport = generatePurchaseReport;
		vm.generateProfitReport = generateProfitReport;

		vm.removeFilter = removeFilter;
		vm.resetFilters = resetFilters;

		vm.getVehicleLocation = getVehicleLocation;
		vm.getMileageRangeString = getMileageRangeString;
		vm.getPriceRangeString = getPriceRangeString;

		vm.isDefaultFilter = isDefaultFilter;

		vm.sendSigningPageLinkByEmail = sendSigningPageLinkByEmail;

		vm.generateNewSaleReport = generateNewSaleReport;
		vm.generateNewProfitReport = generateNewProfitReport;
		vm.generateNewPurchaseReport = generateNewPurchaseReport;

		init();

		function init(){
			initLocations();
			initBasicInventoryInfos();
			initFilters();
			refresh()
		}

		function initBasicInventoryInfos(){
			if(!basicInventoryInfos){
				return;
			}

			allYearInventoryInfo = basicInventoryInfos.year;
		}

		function initLocations(){
			vm.locations = locations;

			if(!Array.isArray(vm.locations)){
				vm.locations = [];
			}
		}

		function isDefaultFilter(){
			if(isLoggedIn && vm.availableFilter !== vm.availableAvailabilityFilterTag){
				return false;
			}

			if(!isLoggedIn && vm.availableFilter !== vm.allAvailabilityFilterTag){
				return false
			}

			if(!isLoggedIn && vm.availableFilter !== vm.onlineAvailabilityFilterTag){
				return false
			}

			if(vm.yearFilter !== undefined){
				return false;
			}

			if(vm.makeFilter !== undefined){
				return false;
			}

			if(vm.modelFilter !== undefined){
				return false;
			}

			if(vm.priceFilterLevel !== undefined){
				return false;
			}

			if(vm.mileageFilterLevel !== undefined){
				return false;
			}

			if(vm.locationFilter !== undefined){
				return false;
			}

			if(vm.startDate !== undefined){
				return false;
			}

			if(vm.endDate !== undefined){
				return false;
			}

			return true;
		}

		function resetFilters(){
			$stateParams = {enableTimeRangeFilter: vm.enableTimeRangeFilter};
			initFilters();
			refresh();
		}

		function removeFilter(filterTag){
			switch(filterTag){
				case vm.availableAvailabilityFilterTag:
					vm.availableFilter = vm.allAvailabilityFilterTag;
					break;
				case vm.onlineAvailabilityFilterTag:
					vm.availableFilter = vm.onlineAvailabilityFilterTag;
					break
				case vm.yearFilterTag:
					vm.yearFilter = undefined;
					break;
				case vm.makeFilterTag:
					vm.makeFilter = undefined;
					break;
				case vm.modelFilterTag:
					vm.modelFilter = undefined;
					break;
				case vm.priceFilterTag:
					vm.priceFilterLevel = undefined;
					break;
				case vm.mileageFilterTag:
					vm.mileageFilterLevel = undefined;
					break;
				case vm.locationFilterTag:
					vm.locationFilter = undefined;
					break;
				case vm.timeRangeFilterTag:
					vm.timeRangeFilterTag = undefined;
					break;
				case vm.startDateFilterTage:
					vm.startDate = undefined;
					break;
				case vm.endDateFilterTag:
					vm.endDate = undefined;
					break;
			}
			refresh();
		}

		function refresh(){
			if(vm.isFetchingData){
				return;
			}

			vm.isFetchingData = true;

			refreshAllInventoryInfos()
				.then(function(){
					return refreshVehicles();
				})
				.then(function(){
					refreshUrl();
				})
				.catch(MessageService.showToast)
				.finally(function(){
					vm.isFetchingData = false;
				});
		}

		function refreshUrl(){
			const urlParams = {};

			urlParams.searchText = vm.searchText === undefined ? undefined : vm.searchText + '';
			urlParams.available = vm.availableFilter === undefined ? undefined : vm.availableFilter + '';
			urlParams.year = vm.yearFilter === undefined ? undefined : vm.yearFilter + '';
			urlParams.make = vm.makeFilter === undefined ? undefined : vm.makeFilter + '';
			urlParams.model = vm.modelFilter === undefined ? undefined : vm.modelFilter + '';
			urlParams.location = vm.locationFilter === undefined ? undefined : vm.locationFilter + '';
			urlParams.priceLevel = vm.priceFilterLevel === undefined ? undefined : vm.priceFilterLevel + '';
			urlParams.mileageLevel = vm.mileageFilterLevel === undefined ? undefined : vm.mileageFilterLevel + '';
			urlParams.sortBy = vm.sortBy === undefined ? undefined : vm.sortBy + '';
			urlParams.sortDirection = vm.sortDirection === undefined ? undefined : vm.sortDirection + '';

			urlParams.enableTimeRangeFilter = vm.enableTimeRangeFilter === undefined ? undefined : vm.enableTimeRangeFilter + '';
			urlParams.timeRangeFilterTag = vm.timeRangeFilterTag === undefined ? undefined : vm.timeRangeFilterTag + '';

			if(vm.startDate !== undefined && moment(vm.startDate).isValid()){
				urlParams.startDate = moment(vm.startDate).format(dateFormat);
			}

			if(vm.endDate !== undefined && moment(vm.endDate).isValid()){
				urlParams.endDate = moment(vm.endDate).format(dateFormat);
			}

			$location.search(urlParams).replace();
		}

		function onInventoryFilterChange(tag, selectedItem){
			switch(tag){
				case vm.yearFilterTag:
					vm.yearFilter = extractFilterValueFromInventoryInfoItem(selectedItem);
					break;
				case vm.makeFilterTag:
					vm.makeFilter = extractFilterValueFromInventoryInfoItem(selectedItem);
					if(vm.makeFilter === undefined){
						vm.modelFilter = undefined;
					}
					break;
				case vm.modelFilterTag:
					vm.modelFilter = extractFilterValueFromInventoryInfoItem(selectedItem);
					break;
				case vm.priceFilterTag:
					vm.priceFilterLevel = extractFilterValueFromInventoryInfoItem(selectedItem);
					break;
				case vm.mileageFilterTag:
					vm.mileageFilterLevel = extractFilterValueFromInventoryInfoItem(selectedItem);
					break;
				case vm.locationFilterTag:
					vm.locationFilter = extractFilterValueFromInventoryInfoItem(selectedItem);
					break;
			}

			refresh();
		}

		function extractFilterValueFromInventoryInfoItem(inventoryInfo){
			if(!inventoryInfo){
				return undefined;
			}

			return inventoryInfo.dataGroup;
		}

		function refreshVehicles(){
			const vehicleFilter = buildVehicleFilter();
			const sortingFilter = buildSortingFilter();

			var resourcePath = {companyID: companyID};

			return VehicleService.getVehicle(resourcePath, vehicleFilter, null, sortingFilter)
				.then(function(result){
					if(result == null || !Array.isArray(result.data)){
						return;
					}

					vm.vehicles = result.data;

					resetPagination(result);
					return $q.resolve()
				});
		}

		function resetPagination(result){
			if(!result){
				return;
			}

			vm.totalMatchedVehicle = HeaderHelper.getPaginationTotalItem(result.headerGetter);
			vm.currentPage = HeaderHelper.getPaginationCurrentPage(result.headerGetter);
			isLastPage = HeaderHelper.isLastPage(result.headerGetter);
		}

		function onScroll(scope, element, attrs, event){
			if(!element || !element[0]){
				return;
			}
			
			if(element.scrollTop() + element.innerHeight() >= element[0].scrollHeight){
				loadMore();
			}
		}

		function loadMore (){
			if(vm.isFetchingData || isLastPage){
				return;
			}

			const vehicleFilter = buildVehicleFilter();
			const sortingFilter = buildSortingFilter();

			var resourcePath = {companyID: companyID};
			var pagination = {
				page: vm.currentPage + 1
			}

			vm.isFetchingData = true;

			VehicleService.getVehicle(resourcePath, vehicleFilter, pagination, sortingFilter)
				.then(function(result){
					if(result == null || !Array.isArray(result.data)){
						return;
					}

					resetPagination(result);

					vm.vehicles = vm.vehicles.concat(result.data);
				})
				.catch(MessageService.showToast)
				.finally(function(){
					vm.isFetchingData = false;
				});
		}

		function initFilters(){		
			vm.availableFilter = GeneralTools.urlStringParamTranslator($stateParams.available);
			vm.searchText = GeneralTools.urlStringParamTranslator($stateParams.searchText);
			vm.yearFilter = GeneralTools.urlNumberParamTranslator($stateParams.year);
			vm.makeFilter = GeneralTools.urlStringParamTranslator($stateParams.make);
			vm.modelFilter = GeneralTools.urlStringParamTranslator($stateParams.model);
			vm.priceFilterLevel = GeneralTools.urlNumberParamTranslator($stateParams.priceLevel);	
			vm.mileageFilterLevel = GeneralTools.urlNumberParamTranslator($stateParams.mileageLevel);		
			vm.sortBy = GeneralTools.urlStringParamTranslator($stateParams.sortBy);
			vm.sortDirection = GeneralTools.urlStringParamTranslator($stateParams.sortDirection);

			if(isLoggedIn){
				vm.locationFilter = GeneralTools.urlNumberParamTranslator($stateParams.location);
				vm.availableFilter = vm.availableFilter === vm.allAvailabilityFilterTag? vm.allAvailabilityFilterTag : vm.availableAvailabilityFilterTag;
			}else{
				vm.availableFilter = vm.allAvailabilityFilterTag;
			}

			// Init time range filter
			if(!hasPermissionToUseTimeRangeFilter){
				return;
			}

			vm.enableTimeRangeFilter = GeneralTools.urlBooleanParamTranslator($stateParams.enableTimeRangeFilter);
			vm.timeRangeFilterTag = GeneralTools.urlStringParamTranslator($stateParams.timeRangeFilterTag);
			vm.startDate = GeneralTools.urlDateParamTranslator($stateParams.startDate);
			vm.endDate = GeneralTools.urlDateParamTranslator($stateParams.endDate);
		}

		function refreshAllInventoryInfos() {
			const priceInventoryParam = {columnName:"advertise_price", dataType:"number", interval:priceFilterInterval};
			const mileageInventoryParam = {columnName:"mileage", dataType:"number", interval:mileageFilterInterval};

			const queue = {
				year: VehicleService.getInventoryInfos(companyID, buildVehicleFilter(vm.yearFilterTag), {columnName:"year"}),
				make: VehicleService.getInventoryInfos(companyID, buildVehicleFilter(vm.makeFilterTag), {columnName:"make"}),	
				location: VehicleService.getInventoryInfos(companyID, buildVehicleFilter(vm.locationFilterTag), {columnName:"fk_id_location"}),
				price: VehicleService.getInventoryInfos(companyID, buildVehicleFilter(vm.priceFilterTag), priceInventoryParam),
				mileage: VehicleService.getInventoryInfos(companyID, buildVehicleFilter(vm.mileageFilterTag), mileageInventoryParam)
			};

			if(vm.makeFilter === undefined){
				queue.model = $q.resolve();
			}else{
				queue.model = VehicleService.getInventoryInfos(companyID, buildVehicleFilter(vm.modelFilterTag), {columnName:"model"});
			}

			return $q.all(queue).then(function(result) {
				if(!result){
					return $q.reject("Failed to refresh inventory infos, Inventory infos invalid");
				}

				vm.yearInventoryInfo = result.year;
				vm.makeInventoryInfo = result.make;
				vm.modelInventoryInfo = result.model;
				vm.locationInventoryInfo = result.location;
				vm.priceInventoryInfo = result.price;
				vm.mileageInventoryInfo = result.mileage;

				vm.selectedYearInventoryItem = findMatchedInventoryItemByGroupValue(vm.yearInventoryInfo, vm.yearFilter);
				vm.selectedMakeInventoryItem = findMatchedInventoryItemByGroupValue(vm.makeInventoryInfo, vm.makeFilter);
				vm.selectedModelInventoryItem = findMatchedInventoryItemByGroupValue(vm.modelInventoryInfo, vm.modelFilter);
				vm.selectedLocationInventoryItem = findMatchedInventoryItemByGroupValue(vm.locationInventoryInfo, vm.locationFilter);
				vm.selectedPriceInventoryItem = findMatchedInventoryItemByGroupValue(vm.priceInventoryInfo, vm.priceFilterLevel);
				vm.selectedMileageInventoryItem = findMatchedInventoryItemByGroupValue(vm.mileageInventoryInfo, vm.mileageFilterLevel);

				if(vm.selectedMakeInventoryItem === undefined){
					vm.modelFilter = undefined;
					vm.selectedMakeInventoryItem = undefined;
				}

				return $q.resolve();
			});
		}


		function findMatchedInventoryItemByGroupValue(inventoryInfoList, filterValue){
			if(filterValue === undefined || !Array.isArray(inventoryInfoList)){
				return undefined;
			}

			return inventoryInfoList.find(function(inventoryInfo){
				if(typeof(inventoryInfo.dataGroup) == "string" && typeof(filterValue) == "string"){
					return inventoryInfo.dataGroup.trim().toLowerCase() === filterValue.trim().toLowerCase();
				}

				return inventoryInfo.dataGroup === filterValue;
			});
		}


		function buildVehicleFilter(skipTag){
			const vehicleFilter = { filters: '' };

			if(vm.enableTimeRangeFilter){
				vehicleFilter.filters = GeneralTools.stringConnector(vehicleFilter.filters, timeRangeFilterStringBuilder(), filterConsts.andConnector);
			}

			if(vm.availableFilter === vm.availableAvailabilityFilterTag && !vm.enableTimeRangeFilter){
				vehicleFilter.isSold = false;
				vehicleFilter.filters = GeneralTools.stringConnector(vehicleFilter.filters, GeneralTools.equalFilterBuilder("purchase_info.is_canceled", false), filterConsts.andConnector);
			}

			if(vm.availableFilter === vm.onlineAvailabilityFilterTag && !vm.enableTimeRangeFilter){
				// vehicleFilter.filters = GeneralTools.stringConnector(vehicleFilter.filters, GeneralTools.notEqualFilterBuilder("boost_vin", null), filterConsts.andConnector);
				vehicleFilter.filters = GeneralTools.stringConnector(vehicleFilter.filters, GeneralTools.equalFilterBuilder("is_online", true), filterConsts.andConnector);
				// vehicleFilter.isSold = false;
				// vehicleFilter.filters = GeneralTools.stringConnector(vehicleFilter.filters, GeneralTools.equalFilterBuilder("purchase_info.is_canceled", false), filterConsts.andConnector);
			}

			if(vm.yearFilter !== undefined && skipTag != vm.yearFilterTag){
				vehicleFilter.filters = GeneralTools.stringConnector(vehicleFilter.filters, GeneralTools.equalFilterBuilder("year", vm.yearFilter), filterConsts.andConnector);
			}

			if(vm.makeFilter !== undefined && skipTag != vm.makeFilterTag){
				vehicleFilter.filters = GeneralTools.stringConnector(vehicleFilter.filters, GeneralTools.equalFilterBuilder("make", vm.makeFilter), filterConsts.andConnector);
			}

			if(vm.modelFilter !== undefined && skipTag != vm.modelFilterTag){
				vehicleFilter.filters = GeneralTools.stringConnector(vehicleFilter.filters, GeneralTools.equalFilterBuilder("model", vm.modelFilter), filterConsts.andConnector);
			}

			if(vm.locationFilter !== undefined && skipTag != vm.locationFilterTag){
				vehicleFilter.filters = GeneralTools.stringConnector(vehicleFilter.filters, GeneralTools.equalFilterBuilder("fk_id_location", vm.locationFilter), filterConsts.andConnector);
			}

			if(vm.priceFilterLevel !== undefined && skipTag != vm.priceFilterTag){
				if(vm.priceFilterLevel === null){
					vehicleFilter.filters = GeneralTools.stringConnector(vehicleFilter.filters, GeneralTools.equalFilterBuilder("advertise_price", null), filterConsts.andConnector);
				} else {
					const minPrice = vm.priceFilterLevel * priceFilterInterval;
					const maxPrice = minPrice + priceFilterInterval;

					vehicleFilter.filters = GeneralTools.stringConnector(vehicleFilter.filters, GeneralTools.leftEqualRangeFilterBuilder("advertise_price", minPrice, maxPrice), filterConsts.andConnector);
				}
			}

			if(vm.mileageFilterLevel !== undefined && skipTag != vm.mileageFilterTag){
				if(vm.mileageFilterLevel === null){
					vehicleFilter.filters = GeneralTools.stringConnector(vehicleFilter.filters, GeneralTools.equalFilterBuilder("vehicle.mileage", null), filterConsts.andConnector);
				} else {
					const minMlieage = vm.mileageFilterLevel * mileageFilterInterval;
					const maxMlieage = minMlieage + mileageFilterInterval;

					vehicleFilter.filters = GeneralTools.stringConnector(vehicleFilter.filters, GeneralTools.leftEqualRangeFilterBuilder("vehicle.mileage", minMlieage, maxMlieage), filterConsts.andConnector);
				}	
			}

			if(vm.searchText !== undefined ){
				vehicleFilter.filters = GeneralTools.stringConnector(vehicleFilter.filters, buildSearchTextFilter(), filterConsts.andConnector);
			}

			return vehicleFilter;
		}

		function buildSearchTextFilter(){
			if(!vm.searchText){
				return;
			}

			var filter = '';
			const keywordList = vm.searchText.split(' ');

			keywordList.forEach(function(keyword){
				if(!keyword){
					return;
				}

				const regex = /^[0-9]*$/g;
				const yearNumber = regex.test(keyword) ? Number(keyword) : NaN;

				const yearKeyWord = findMatchedInventoryItemByGroupValue(allYearInventoryInfo, yearNumber);

				if(yearKeyWord){
					filter = GeneralTools.stringConnector(filter, GeneralTools.equalFilterBuilder("year", keyword), filterConsts.andConnector);
				}else{
					filter = GeneralTools.stringConnector(filter, generalSearchTextFilterBuilder(keyword), filterConsts.andConnector);
				}
			});

			if(filter){
				filter = '(' + filter + ')';
			}

			return filter;
		}

		function generalSearchTextFilterBuilder(keyword){
			if(!keyword){
				return;
			}

			var filter = '';

			filter = GeneralTools.stringConnector(filter, GeneralTools.containFilterBuilder("vin", keyword), filterConsts.orConnector);
			filter = GeneralTools.stringConnector(filter, GeneralTools.containFilterBuilder("make", keyword), filterConsts.orConnector);
			filter = GeneralTools.stringConnector(filter, GeneralTools.containFilterBuilder("model", keyword), filterConsts.orConnector);
			filter = GeneralTools.stringConnector(filter, GeneralTools.containFilterBuilder("stock_number", keyword), filterConsts.orConnector);

			if(filter){
				filter = '(' + filter + ')';
			}

			return filter;
		}

		function buildSortingFilter() {
			const sorting = {};

			if(vm.sortBy !== undefined){
				sorting.sortBy = vm.sortBy;
			}

			if(vm.sortDirection !== undefined){
				sorting.sortDirection = vm.sortDirection;
			}
			
			return sorting;
		}

		function locationInventoryInfoItemNameBuilder(item){
			if(!item){
				return "Unknown";
			}

			const matchedLocation = getVehicleLocation(item.dataGroup);

			if(matchedLocation){
				return matchedLocation.name;
			}else{
				return "Unknown";
			}
		}

		function priceInventoryInfoItemNameBuilder(item){
			if(!item){
				return "Unknown";
			}

			return getPriceRangeString(item.dataGroup);
		}

		function getPriceRangeString(priceLevel){
			const level = parseInt(priceLevel);

			if(isNaN(level)){
				return "Unknown";
			}

			const minPriceNumber = level * priceFilterInterval;

			const minPrice = $filter('currency')(minPriceNumber, '$', 0);
			const maxPrice = $filter('currency')(minPriceNumber + priceFilterInterval - 1, '$', 0);

			return minPrice + ' - ' + maxPrice;
		}

		function mileageInventoryInfoItemNameBuilder(item){
			if(!item){
				return "Unknown";
			}

			return getMileageRangeString(item.dataGroup)
		}

		function getMileageRangeString(mileageLevel){
			const level = parseInt(mileageLevel);

			if(isNaN(level)){
				return "Unknown";
			}

			const minMileageNumber = level * mileageFilterInterval;

			const minMileage = $filter('number')(minMileageNumber, 0);
			const maxMileage = $filter('number')(minMileageNumber + mileageFilterInterval - 1, 0);

			return minMileage + ' Km - ' + maxMileage + " Km";
		}

		function timeRangeFilterStringBuilder(){
			var filterString = '';
			var keyName;
			var startDateFilterString;
			var endDateFilterString;
			var isCancelFilterString;

			switch(vm.timeRangeFilterTag){
				case vm.purchaseTimeRageFilterTag:
					keyName = "purchase_date";
					isCancelFilterString = GeneralTools.equalFilterBuilder("purchase_info.is_canceled", false);
					break;
				case vm.soldTimeRageFilterTag:
					keyName = "sale_date";
					isCancelFilterString = GeneralTools.equalFilterBuilder("sale_info.is_canceled", false);
					break
			}

			if(!keyName){
				return filterString;
			}

			if(vm.startDate){
				var dateString = moment(vm.startDate).format(dateFormat);
				startDateFilterString = GeneralTools.equalOrGreaterThanFilterBuilder(keyName, dateString);
			}

			if(vm.endDate){
				var dateString = moment(vm.endDate).format(dateFormat);
				endDateFilterString = GeneralTools.equalOrLesshanFilterBuilder(keyName, dateString);
			}

			filterString = GeneralTools.stringConnector(filterString, startDateFilterString, " AND ");
			filterString = GeneralTools.stringConnector(filterString, endDateFilterString, " AND ");
			filterString = GeneralTools.stringConnector(filterString, isCancelFilterString, " AND ");
			
			return filterString
		}
		
		function filterByTimeRange(){
			if((vm.startDate || vm.endDate) && vm.timeRangeFilterTag){
				refresh();
			}
		}

		function generateSaleReport(){
			var resourcePath = {companyID: companyID};
			
			ProgressService.setMode("indeterminate");
			ProgressService.isVisble(true);
			vm.isFetchingData = true;

			const startDateMoment = vm.startDate? moment(vm.startDate):null;
			const endDateMoment = vm.endDate? moment(vm.endDate):null;

			ReportService.generateSaleReport(resourcePath, buildVehicleFilter(), startDateMoment, endDateMoment)
				.then(function(){
					MessageService.showToast("OK")
				})
				.catch(MessageService.showToast)
				.finally(function(){
					ProgressService.isVisble(false);
					vm.isFetchingData = false;
				});
		}

		function generatePurchaseReport(){
			var resourcePath = {companyID: companyID};
			
			ProgressService.setMode("indeterminate");
			ProgressService.isVisble(true);
			vm.isFetchingData = true;

			const startDateMoment = vm.startDate? moment(vm.startDate):null;
			const endDateMoment = vm.endDate? moment(vm.endDate):null;

			ReportService.generatePurchaseReport(resourcePath, buildVehicleFilter(), startDateMoment, endDateMoment)
				.then(function(){
					MessageService.showToast("OK")
				})
				.catch(MessageService.showToast)
				.finally(function(){
					ProgressService.isVisble(false);
					vm.isFetchingData = false;
				});
		}

		function generateProfitReport(){
			var resourcePath = {companyID: companyID};
			
			ProgressService.setMode("indeterminate");
			ProgressService.isVisble(true);
			vm.isFetchingData = true;

			const startDateMoment = vm.startDate? moment(vm.startDate):null;
			const endDateMoment = vm.endDate? moment(vm.endDate):null;

			ReportService.generateProfitReport(resourcePath, buildVehicleFilter(), startDateMoment, endDateMoment)
				.then(function(){
					MessageService.showToast("OK")
				})
				.catch(MessageService.showToast)
				.finally(function(){
					ProgressService.isVisble(false);
					vm.isFetchingData = false;
				});
		}

		function getVehicleLocation(locationID){
			if(!Array.isArray(vm.locations)){
				return;
			}

			return vm.locations.find(function(location){
				return location.id_location == locationID;
			});
		}

		function sendSigningPageLinkByEmail(signerDetail, signatureRequestDetail){
			//signerDetail.isSending = true;
			
			
			EmailService.sendSigningRequest(true, signatureRequestDetail, false)
				.then(function(){
					//signerDetail.isSent = true;
				})
				.catch(MessageService.showToast)
				.finally(function(){
					//signerDetail.isSending = false;
				})
		}

		
		function generateNewSaleReport(){
			var resourcePath = {companyID: companyID};
			
			ProgressService.setMode("indeterminate");
			ProgressService.isVisble(true);
			vm.isFetchingData = true;

			const startDateMoment = vm.startDate? moment(vm.startDate):null;
			const endDateMoment = vm.endDate? moment(vm.endDate):null;

			ReportService.generateSaleReportVersion2(resourcePath, buildVehicleFilter(), startDateMoment, endDateMoment)
				.then(function(){
					MessageService.showToast("OK")
				})
				.catch(MessageService.showToast)
				.finally(function(){
					ProgressService.isVisble(false);
					vm.isFetchingData = false;
				});
		}

		function generateNewPurchaseReport(){
			var resourcePath = {companyID: companyID};
			
			ProgressService.setMode("indeterminate");
			ProgressService.isVisble(true);
			vm.isFetchingData = true;

			const startDateMoment = vm.startDate? moment(vm.startDate):null;
			const endDateMoment = vm.endDate? moment(vm.endDate):null;

			ReportService.generatePurchaseInfoReportVersion3(resourcePath, buildVehicleFilter(), startDateMoment, endDateMoment)
				.then(function(){
					MessageService.showToast("OK")
				})
				.catch(MessageService.showToast)
				.finally(function(){
					ProgressService.isVisble(false);
					vm.isFetchingData = false;
				});
		}

		function generateNewProfitReport(){
			var resourcePath = {companyID: companyID};
			
			ProgressService.setMode("indeterminate");
			ProgressService.isVisble(true);
			vm.isFetchingData = true;

			const startDateMoment = vm.startDate? moment(vm.startDate):null;
			const endDateMoment = vm.endDate? moment(vm.endDate):null;

			ReportService.generateProfitReportVersion2(resourcePath, buildVehicleFilter(), startDateMoment, endDateMoment)
				.then(function(){
					MessageService.showToast("OK")
				})
				.catch(MessageService.showToast)
				.finally(function(){
					ProgressService.isVisble(false);
					vm.isFetchingData = false;
				});
		}
	}
})();
(function ()
{
	'use strict';

	angular
		.module('app.vehicles')
		.controller('BatchImportVehiclesController', BatchImportVehiclesController);

	function BatchImportVehiclesController(workorderPriorities, WorkOrderConstants, WorkOrder, WorkOrderService, $q, $mdDialog, $state, DialogService, VehicleService, MessageService, ProgressService, Vehicle, VinAuditService, VehicleFeature, $filter, LoginService, TasksService, TaskConstants, FileUploadService, GeneralTools, PurchaseInfo, presetFeatures, ToolsConstants, Vinaudit, PurchaseInfoService){	 
		var vm = this;
		var rogersMotersLocation = 1;
		var vinAudit = new Vinaudit();

		var xlsType = "xls";
		var csvType = "csv";

		var adesaVin = "VIN";
		var adesaYearMakeModel = "Year/Make/Model";
		var adesaMileage = "Odometer";
		var adesaExternalColor = "Exterior Color";

		var adesaVendorSeller = "Seller Name";
		var adesaPurchaseDate = "Purchase Date";
		var adesaBuyerFee = "Buy Fee";
		var adesaShippingCost = "Shipping Cost";
		var adesaTaxRate = "Tax";
		var adesaPurchasePrice = "Purchase Price";

		var manheimVin = "Vin";
		var manheimYear = "Year";
		var manheimMake = "Make";
		var manheimModel = "Model";
		var manheimTrim = "Trim";
		var manheimExteriorColor = "Exterior Colour";
		var manheimInteriorColor = "Interior Colour";
		var manheimMileage = "Odometer";
		var manheimEngine = "Engine";

		var manheimPurchaseDate = "Sale Invoice Date";
		var manheimPurchasePrice = "Sale Price";
		var manheimVendorSeller = "Seller Dealer Name";

		var manheimErrorString = " INC";

		var adesaAuctionID = 1;
		var manheimAuctionID = 2;

		var taskCategoryFkDetail = 2;
		var taskCategoryFkAdvertising = 7; 
		var taskCategoryFkMechanic = 5; 
		var taskCategoryFkDocumentation = 3; 

		var companyID = LoginService.getCompanyID();

		vm.fileUploader = FileUploadService.getNewUploader();
		vm.fileUploader.filters.push(FileUploadService.getSizeFilter(20));

		vm.vehicleAndPurchaseList = [];

		vm.importData = importData;

		init()

		function init(){}

		function importData(){
			var datasToImport = vm.getSelectedItems();
			if(!Array.isArray(datasToImport) || datasToImport.length <= 0){
				MessageService.showToast("No item selected");
				return;
			}

			var queue = [];

			ProgressService.setMode("indeterminate");
			ProgressService.isVisble(true);
			vm.isProcessingTask = true;

			datasToImport.forEach(function(item){
				queue.push(importVehicleAndPurchase(item));
			});

			$q.all(queue)
				.then(function(){
					MessageService.showToast("ok")
				})
				.catch(MessageService.showToast)
				.finally(function(){
					ProgressService.isVisble(false);
					vm.isProcessingTask = false;
				});
		}

		function importVehicleAndPurchase(vehicleAndPurchase){
			var importVehiclePromise;
			var vehicleID;

			if(vehicleAndPurchase.vehicleID){
				importVehiclePromise = updateVehicle(vehicleAndPurchase.vehicleID, vehicleAndPurchase.vehicle);
			} else {
				importVehiclePromise = createVehicle(vehicleAndPurchase.vehicle);
			}

			return importVehiclePromise
				.then(function(result){
					vehicleID = result

					var queue = [];
					queue.push(createPurchaseInfo(vehicleID, vehicleAndPurchase.purchaseInfo));
					queue.push(createDefaultTasks(vehicleID));

					return $q.all(queue);
				})
				.then(function(){
					vm.finishItem(vehicleAndPurchase.vehicle.vin, vehicleID);
					return $q.resolve();
				})
		}

		function createDefaultTasks(vehicleID){
			var tasks = [];

			tasks.push(createDefaultTask(vehicleID, TaskConstants.newCarCleanTaskName, taskCategoryFkDetail));
			tasks.push(createDefaultTask(vehicleID, TaskConstants.processVehicleTaskName, taskCategoryFkAdvertising));
			//tasks.push(createDefaultTask(vehicleID, TaskConstants.newCarOilChangeTaskName, taskCategoryFkMechanic));
			tasks.push(createDefaultTask(vehicleID, TaskConstants.createFolderAndTagKeyTaskName, taskCategoryFkDocumentation));

			return $q.all(tasks);
		}

		function createDefaultTask(vehicleID, taskName, category){
			var resourcePath = { companyID: companyID };

			var requestBody = {
				assigned_to_vehicle: {id_vehicle: vehicleID},
				fk_id_task_category: category,
				fk_id_task_priority: 3,
				fk_id_task_status: 1,
				name: taskName
			}

			return TasksService.createTask(resourcePath, requestBody)
		}

		function createPurchaseInfo(vehicleID, purchaseInfo){
			var resourcePath = {
				companyID: companyID,
				vehicleID: vehicleID
			}
			return PurchaseInfoService.createPurchaseInfo(resourcePath, purchaseInfo);
		}

		function updateVehicle(vehicleID, vehicle){
			var resourcePath = {
				companyID: companyID,
				vehicleID: vehicleID
			};

			return VehicleService.updateVehicle(resourcePath,  {mileage : vehicle.mileage}).then(function(){
				return $q.resolve(vehicleID);
			});
		}

		function createVehicle(vehicle){
			var decodeVinTask = $q.defer();

			var matchedFeatures = [];
			var newFeatureList = [];
			var newVehicleID;

			vehicle.generateStockNumber();
			vehicle.fk_id_location = rogersMotersLocation;

			vinAudit.decodeVin(vehicle.vin)
				.then(function(result){
					decodeVinTask.resolve(result);
				})
				.catch(function(error){
					MessageService.showToast(error + ", Vin: " + vehicle.vin);
					decodeVinTask.resolve();
				})

			return decodeVinTask.promise
				.then(function(result){
					if(result){
						vehicle.setAttributes(result.attributes);
						result.features.forEach(function(featureData){
							var newFeature = new VehicleFeature(featureData);
							newFeatureList.push(newFeature);
							matchedFeatures = matchedFeatures.concat($filter('filter')(presetFeatures, newFeature.name));
						});
					}

					return VehicleService.createVehicle({companyID: companyID}, vehicle);
				})
				.then(function(vehicleID){
					newVehicleID = vehicleID;

					var resourcePath = {
						companyID: companyID,
						vehicleID: vehicleID
					}

					matchedFeatures.forEach(function(presetFeature){
						var newFeature = new VehicleFeature();
						newFeature.pullDataFromPresetFeature(presetFeature);

						addFeatureToList(newFeature, newFeatureList);
					});

					if(matchedFeatures.length <= 0){
						return $q.resolve();
					}

					return VehicleService.createBatchVehicleFeature(resourcePath, newFeatureList);
				})
				.then(function(){
					return $q.resolve(newVehicleID);
				})
		}

		function addFeatureToList(featureToAdd, featureList){
			if(!Array.isArray(featureList)){
				featureList = [];
			}

			var existingFeature = featureList.find(function(feature){
				return featureToAdd.name == feature.name && featureToAdd.category == feature.category && featureToAdd.value == feature.value;
			});

			if(existingFeature == null){
				featureList.push(featureToAdd);
			}

			return featureList;
		}

		vm.fileUploader.onAfterAddingFile = function(item){
			var promise;
			var vehicleAndPurchaseList

			ProgressService.setMode("indeterminate");
			ProgressService.isVisble(true);
			vm.isProcessingTask = true;

			var fileName = item._file.name;

			switch(fileName.substring(fileName.lastIndexOf('.') + 1, fileName.length).toLowerCase()){
				case xlsType:
					promise = parseXLS(item._file).then(function(data){
						return $q.resolve(adesaDataHandler(data));
					});
					break;
				case csvType:
					promise = parseCSV(item._file).then(function(data){
						return $q.resolve(manheimDataHandler(data));
					});
					break;
				default:
					promise = $q.reject("Can not parse file type: " + item._file.type);
			}

			promise.then(function(data){
					vehicleAndPurchaseList = data;

					if(!vehicleAndPurchaseList){
						return $q.reject("Failed to read file");
					}

					return tryToGetVehiclesIdByVin(vehicleAndPurchaseList);
				})
				.then(function(checkResult){
					vehicleAndPurchaseList.forEach(function(item){
						item.vehicleID = checkResult[item.vehicle.vin];
					});

					vm.initList(vehicleAndPurchaseList); 
				})
				.catch(MessageService.showToast)
				.finally(function(){
					ProgressService.isVisble(false);
					vm.isProcessingTask = false;
				});
		}

		function tryToGetVehiclesIdByVin(vehicleAndPurchaseList){
			if(!Array.isArray(vehicleAndPurchaseList)){
				return $q.reject("Failed to check vehicles exist.");
			}

			var invalidItem = vehicleAndPurchaseList.find(function(item){
				return !item || !item.vehicle || !item.vehicle.vin;
			});

			if(invalidItem){
				return $q.reject("Import file is missing VIN data. Please check that the file matches the expected auction import format.");
			}

			var queue = {};

			vehicleAndPurchaseList.forEach(function(item){
				queue[item.vehicle.vin] = tryToGetVehicleIdByVin(item);
			});

			return $q.all(queue);
		}

		function tryToGetVehicleIdByVin(vehicleAndPurchaseItem){
			if(!vehicleAndPurchaseItem){
				return $q.reject("Failed to check vehicle exist due to invalid input param");
			}

			var resourcePath = { companyID: companyID };
			var filters = {filters: "(vin eq " + vehicleAndPurchaseItem.vehicle.vin + ")"}

			return VehicleService.getVehicle(resourcePath, filters)
				.then(function(response){
					if(!response || !Array.isArray(response.data)){
						return $q.reject("Failed to check vehicle exist due to invalid response");
					}

					if(response.data[0]){
						return $q.resolve(response.data[0].getResourceID());
					} else {
						return $q.resolve();
					}
				});
		}

		function parseCSV(file){
			var defer = $q.defer();

			Papa.parse(file, {
				skipEmptyLines: true,
				complete: function(results) {
					if(results.errors.length > 0){
						defer.reject(results.errors[0].message);
					} else {
						defer.resolve(results.data);
					}
				},				
				error: function(error){
					defer.reject(error);
				}
			});

			return defer.promise;
		}

		function manheimDataHandler(allRows){
			if(!Array.isArray(allRows)){
				return;
			}

			var headerRow = allRows[0];
			var valueRows = allRows.slice(1);

			return valueRows.map(function(row, index){

				// Fix known error and throw unknown error
				if(row.length != headerRow.length){
					var errorStrIndex = row.indexOf(manheimErrorString);

					if(errorStrIndex != -1){
						row[errorStrIndex - 1] = row[errorStrIndex - 1] + manheimErrorString;
						row.splice(errorStrIndex, 1);
					} else {
						throw new Error("Row " + (index + 1) + " column doesn't matched");
					}
				}

				// Change 2-D array to array of objects 
				var rowData = {};
				headerRow.forEach(function(columName, index){
					rowData[columName] = row[index]
				});

				return {
					vehicle: extractVehicleInfoFromManheim(rowData),
					purchaseInfo: extractPurchaseInfoFromManheim(rowData)
				};
			});
		}

		function extractVehicleInfoFromManheim(data){
			var vehicle = new Vehicle();

			vehicle.vin = data[manheimVin];
			vehicle.year = data[manheimYear];
			vehicle.make = data[manheimMake];
			vehicle.model = data[manheimModel];
			vehicle.trim = data[manheimTrim];
			vehicle.exterior_color = data[manheimExteriorColor];
			vehicle.interior_color = data[manheimInteriorColor];
			vehicle.mileage = data[manheimMileage];
			vehicle.engine = data[manheimEngine];

			return vehicle;
		}

		function extractPurchaseInfoFromManheim(data){
			var purchaseInfo = new PurchaseInfo();

			purchaseInfo.purchase_date = moment(data[manheimPurchaseDate]).format("YYYY-MM-DD");
			purchaseInfo.purchase_price = data[manheimPurchasePrice];
			purchaseInfo.vendor_seller = data[manheimVendorSeller];
			purchaseInfo.fk_id_auction = manheimAuctionID;

			return purchaseInfo;
		}

		function parseXLS(file) {
			var defer = $q.defer()

			var reader = new FileReader();

			reader.onload = function(rawData) {
				var processedData = GeneralTools.parseXlsToJson(rawData);

				if(processedData){
					defer.resolve(processedData);
				}else{
					defer.reject("Can not extract any data from .xls file");
				}
			};

			reader.onerror = function(error) {
				defer.reject(error);
			};

			reader.readAsBinaryString(file);

			return defer.promise;
		};

		function adesaDataHandler(data){
			if(!data || !Array.isArray(data.Purchases)){
				return;
			}

			var allRows = data.Purchases;
			var headerRow = allRows[2];
			var valueRows = allRows.slice(3);

			// Change 2-D array to array of objects 
			return valueRows.map(function(row, index){
				var rowData = {};

				if(row.length != headerRow.length){
					throw new Error("Row " + (index + 1) + " column doesn't matched")
				}

				headerRow.forEach(function(columName, index){
					rowData[columName] = row[index]
				});

				return {
					vehicle: extractVehicleInfoFromAdesa(rowData),
					purchaseInfo: extractPurchaseInfoFromAdesa(rowData)
				};
			});
		}

		function extractPurchaseInfoFromAdesa(adesaData){
			var purchaseInfo = new PurchaseInfo();

			var priceString = adesaData[adesaPurchasePrice];
			purchaseInfo.purchase_price = priceString.substring(0, priceString.indexOf('.')).replace(/\D*/gi, '');

			purchaseInfo.vendor_seller = adesaData[adesaVendorSeller];
			purchaseInfo.purchase_date = moment(adesaData[adesaPurchaseDate], "MM-DD-YY").format("YYYY-MM-DD");
			purchaseInfo.tax_rate = adesaData[adesaTaxRate]? adesaData[adesaTaxRate]:ToolsConstants.taxRate;
			purchaseInfo.buyer_fee = adesaData[adesaBuyerFee];
			purchaseInfo.shipping_cost = adesaData[adesaShippingCost];
			purchaseInfo.fk_id_auction = adesaAuctionID;

			return purchaseInfo;
		}

		function extractVehicleInfoFromAdesa(adesaData){
			var vehicle = new Vehicle();

			var yearMakeModel = adesaData[adesaYearMakeModel].split('/');
			vehicle.year = yearMakeModel[0];
			vehicle.make = yearMakeModel[1];
			vehicle.model = yearMakeModel[2];

			vehicle.vin = adesaData[adesaVin];
			vehicle.mileage = adesaData[adesaMileage].replace(/\D*/gi, '');
			vehicle.exterior_color = adesaData[adesaExternalColor];

			return vehicle;
		}
	}
})();

(function ()
{
	"use strict";

	angular
		.module("app.vehicles")
		.component("batchImportList", {
				bindings:{
					finishItem: '=',
					getSelectedItems: '=',
					initList: '='
				},
				templateUrl: "app/main/vehicles/batch-import-vehicles/batch-import-list.html",
				controller: componentController,
		  		controllerAs: 'vm'
			});

		function componentController($filter, $state, $q, $scope, VehicleService, MessageService, GeneralTools, Vehicle, VinAuditService, ProgressService, VehicleConstants){
			var vm = this;	

			vm.$onInit = initComponent;
			vm.$postLink = initOutPutCallbacks;

			vm.selectAll = selectAll
			vm.isShowSelectAll = isShowSelectAll;

			vm.refreshIsSelectAll = refreshIsSelectAll;
			vm.isAllSelected = isAllSelected;

			function initComponent(){
				vm.vehicleAndPurchaseList = []
			}

			function initOutPutCallbacks(){
				vm.initList = initList;
				vm.getSelectedItems = getSelectedItems;
				vm.finishItem = finishItem;
			}

			function isShowSelectAll(){
				return !vm.vehicleAndPurchaseList.every(function(item){
					return item.isFinished
				})
			}

			function finishItem(vin, vehicleID){
				vm.vehicleAndPurchaseList.forEach(function(item){
					if(item.vehicle.vin == vin){
						item.isFinished = true;
						item.url = getUrlForVehiclePage(vehicleID);
					}
				});

				refreshIsSelectAll();
			}

			function getSelectedItems(){
				return vm.vehicleAndPurchaseList.filter(function(item){
					return item.isSelected && !item.isFinished;
				});
			}

			function selectAll(){
				var allSelected = isAllSelected();

				vm.vehicleAndPurchaseList.forEach(function(item){
					item.isSelected = !allSelected;
				});

				refreshIsSelectAll();
			}

			function initList(vehicleAndPurchaseList){
				if(!Array.isArray(vehicleAndPurchaseList)){
					return;
				}

				vm.hasExistingVehicles = false;

				vehicleAndPurchaseList.forEach(function(item){
					if(item.vehicleID){
						item.url = getUrlForVehiclePage(item.vehicleID)
						vm.hasExistingVehicles = true;
					}else{
						item.isSelected = true;
					}
				});

				vm.vehicleAndPurchaseList = vehicleAndPurchaseList;

				refreshIsSelectAll()
			}

			function getUrlForVehiclePage (vehicleID){
				var param = {vehicleID:vehicleID, tab: VehicleConstants.editPageTabNames.purchaseInfo};

				return $state.href('app.edit-vehicle', param, {absolute: true}); 
			}

			function refreshIsSelectAll(){
				var isAllSelected = true;
				var isAllUnselected = true;

				vm.vehicleAndPurchaseList.forEach(function(item){
					if(item.isFinished){
						return
					}

					if(item.isSelected){
						isAllUnselected = false;
					} else {
						isAllSelected = false;
					}
				})

				vm.isIndeterminate = !isAllSelected && !isAllUnselected;
			}

			function isAllSelected (){
				return vm.vehicleAndPurchaseList.every(function(item){
					return item.isSelected
				});
			}
		}
})();
(function ()
{
	'use strict';

	angular
		.module('app.vehicles')
		.controller('AddVehicleController', AddVehicleController);

	function AddVehicleController($stateParams, locations, $q, $mdDialog, $state, DialogService, VehicleService, MessageService, ProgressService, Vehicle, presetFeatureOptions, VinAuditService, VehicleFeature, $filter, LoginService, TasksService, TaskConstants){   
		var vm = this;
		
		vm.redirect = redirect;
		vm.decodeVin = decodeVin;
		vm.features = [];
		vm.categories = [];
		vm.save = save;
		var newVehicleID;
		var companyID = LoginService.getCompanyID();

		var taskCategoryFkDetail = 2;
		var taskCategoryFkAdvertising = 7; 
		var taskCategoryFkMechanic = 5; 
		var taskCategoryFkDocumentation = 3; 

		init()

		function init(){		
			initConstants();
			initVehicle();
		}

		function initLocations(){
 			vm.locations = locations;
 		} 

		function initConstants(){
			initPresetFeatures();
			initLocations();
		}

		function initVehicle(){
			vm.vehicle = new Vehicle();

			if(!Array.isArray(vm.locations)){
				return;
			}

			var defaultLocation = vm.locations.find(function(location){
				return location.is_default_location;
			});

			vm.vehicle.fk_id_location = defaultLocation.id_location;
		}

		function decodeVin(){
			ProgressService.setMode("indeterminate");
			ProgressService.isVisble(true);

			vm.vehicle.generateStockNumber();

			VinAuditService.decodeVin(vm.vehicle.vin)
				.then(function(result){
					vm.vehicle.setAttributes(result.attributes);

					var newFeatureList = [];
					result.features.forEach(function(featureData){
						newFeatureList.push(new VehicleFeature(featureData));
					}); 

					if(vm.refreshFeature){
						vm.refreshFeature(newFeatureList);
					}		
				})
				.catch(MessageService.showToast)
				.finally(function(){
					ProgressService.isVisble(false);
				})
		}

		function initPresetFeatures (){
			vm.presetFeatureOptions = presetFeatureOptions;
	 	}

		function save(){
			if(!vm.isGeneralFormValid()){
				MessageService.showToast("Something is invalid in General tab.");
				return;
			}

			if(!vm.isSpecsFormValid()){
				MessageService.showToast("Something is invalid in Specs tab.");
				return;
			}

			var resourcePath = {
				companyID: companyID
			}

			ProgressService.setMode("indeterminate");
			ProgressService.isVisble(true);
			vm.isProcessingData = true;

			VehicleService.createVehicle(resourcePath, vm.vehicle)
				.then(function(vehicleID){
					var createFeatureTasks = [];
					newVehicleID = vehicleID;

					var featureResourcePath = {
						companyID: companyID,
						vehicleID: vehicleID
					};

					return VehicleService.createBatchVehicleFeature(featureResourcePath, vm.features);
				})
				.then(function(){
					MessageService.showToast("Success");		
					redirect(newVehicleID);
				})
				.catch(MessageService.showToast)
				.finally(function(){
					ProgressService.isVisble(false);
				});
		}

		function redirect(newVehicleID){
			if(!$stateParams.redirectState){
				$state.go("app.vehicle.general", {vehicleID: newVehicleID});
				return;
			}

			var redirectParams = {};

			if($stateParams.redirectParams){
				try{
					redirectParams = JSON.parse($stateParams.redirectParams);
				} catch (error) {}
			}

			if($stateParams.newVehicleIdParamName){
				redirectParams[$stateParams.newVehicleIdParamName] = newVehicleID;
			}

			$state.go($stateParams.redirectState, redirectParams);
		}
	}
})();
(function ()
{
	'use strict';

	angular
		.module('app.settings.users')
		.service("UserService", UserService);

	/** @ngInject */
	function UserService($state, api, ToolsFactory, Const, MessageService, $q, User, $http, LoginService, ApiConst)
	{   
		var codeKey = Const.header.code;
		var messageKey = Const.header.message;
		var successCode = Const.code.success;

		this.addUser = function (companyID, newUser, callback){

			newUser.companyID = companyID;

			api.users.addUser(
				newUser,
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);
						callback(errorMessage);
						return;
					}

					var newUserID = response.data;
					callback(null, newUserID);
				},
				function(error){
					var errorMessage = error.status + ': ' + error.statusText;
					callback(errorMessage);
				}
			);		  
		}		
		this.updateUser = function (userID, companyID, updateUser, callback){

			updateUser.companyID = companyID;
			updateUser.userID = userID;

			api.users.updateUser(
				updateUser,
				function(response,header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);
						callback(errorMessage);
						return;
					}

					callback(null, null);
				},
				function(error){
					var errorMessage = error.status + ': ' + error.statusText;
					callback(errorMessage);
				}
			);		  
		}

		this.deleteUser = function (userID, companyID, callback){
			api.users.deleteUser(
				{   
					userID:userID,
					companyID:companyID
				},
				function(response,header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);
						callback(errorMessage);
						return;
					}

					callback(null, userID);
				},
				function(error){
					var errorMessage = error.status + ': ' + error.statusText;
					callback(errorMessage);
				}
			);		  
		}		

		this.checkRoles = function(loginUserRoles, targetUserRoles){
			var result = false

			if(!Array.isArray(loginUserRoles)){
				return result;
			}
			if(!Array.isArray(targetUserRoles)){
				targetUserRoles = [];
			}

			for(var i = 0; i < targetUserRoles.length; i++){
				var targetUserRole = targetUserRoles[i]
				if(loginUserRoles.indexOf(targetUserRole) == -1){
					return result;
				}
			}
			return true;
		}

		this.checkAvailability= function(columnName, value, callback){
			api.check.checkExistence.check(
				{   
					tableName:"user",
					columnName:columnName,
					value:value
				},
				function(response, header){
					var statusCode  = header(codeKey);					
					if(statusCode != successCode){
						MessageService.showToast(statusCode + " : "+ header("message"));
						return;
					}					
					callback(!response.data)					
				},
				function(error){
					console.log(error);
				}
			); 
		}

		this.getUsers = function(resourcePath, searchText){
			var defer = $q.defer();
			var paramInUrl = {};

			paramInUrl.companyID = resourcePath.companyID;
			paramInUrl.userID = resourcePath.userID;
			paramInUrl.searchText = searchText;

			api.users.getUsers(
				paramInUrl,
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);
						defer.reject(errorMessage);
						return;
					}

					var userList = [];

					response.forEach(function(data){
						var user = new User();

						user.setAttributes(data); 
						userList.push(user);
					})

					defer.resolve(userList);
				},
				function(error){
					console.error(error);
					defer.reject("Failed to get users");
				}
			);

			return defer.promise;
		}

		this.getUsersOutstandingTask = function(resourcePath){
			//prevent loading outstanding task on public page.
            var userStatus = LoginService.getUserStatus();

            if (!userStatus || !userStatus.isLogin) {
                return  Promise.resolve(null);
            }
			var defer = $q.defer();
			var paramInUrl = {};

			paramInUrl.companyID = resourcePath.companyID;
			paramInUrl.userID = resourcePath.userID;

			api.userOutstandingTask.getUserOutstandingTasks(
				paramInUrl,
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);
						defer.reject(errorMessage);
						return;
					}

					var counter = 0;
					response.forEach(function(data){
						counter++;
					})
					
					defer.resolve(counter);
				},
				function(error){
					console.error(error);
					defer.reject("Failed to get users");
				}
			);

			return defer.promise;
		}

		function getBackendBaseUrl() {
			var domain;

			switch (window.location.host) {
				case ApiConst.productDomain:
					domain = ApiConst.productDomain;
					break;
				case ApiConst.productBackupDomain:
					domain = ApiConst.productBackupDomain;
					break;
				case ApiConst.testDomain:
					domain = ApiConst.testDomain;
					break;
				default:
					// local frontend is localhost:3001
					// local backend is localhost:3000
					domain = "localhost:3000";
					break;
			}

			return ApiConst.http + domain;
		}

		this.forceLogoutUser = function (userID, callback) {
			if (!userID || isNaN(userID)) {
				callback("Invalid user ID.");
				return;
			}

			var backendBaseUrl = getBackendBaseUrl();

			$http({
				method: "POST",
				url: backendBaseUrl + "/api/v1/users/" + userID + "/force-logout",
				headers: {
					token: LoginService.getToken()
				}
			}).then(
				function (response) {
					callback(null, response.data);
				},
				function (error) {
					var errorMessage = "Failed to force logout user.";

					if (error && error.data && error.data.message) {
						errorMessage = error.data.message;
					} else if (error && error.status) {
						errorMessage = error.status + ": " + error.statusText;
					}

					callback(errorMessage);
				}
			);
		};
	}
})();
(function ()
{
    'use strict';

    angular
        .module('app.settings.users')
        .provider('userTempValue', userTempValue);

    /** @ngInject */
    function userTempValue()
    {
        this.$get = function(){

            var provider = {

                setTempCompanyID:setTempCompanyID,
                getTempCompanyID:getTempCompanyID,
                setTempUserID:setTempUserID,
                getTempUserID:getTempUserID
            };

            function setTempCompanyID (companyID){
                window.localStorage.setItem("companyID",companyID);
            }
            function getTempCompanyID () {
                var companyID = window.localStorage.getItem("companyID")
                return companyID;
            }        
            
            function setTempUserID (userID){
                window.localStorage.setItem("userID",userID);
            }
            function getTempUserID (){
                var userID = window.localStorage.getItem("userID")
                return userID;
            }     

            return provider;             
        }
    }

})();
(function ()
{
	'use strict';

	angular
		.module("app.settings.users")
		.factory("User", UserClass)

	/** @ngInject */
	function UserClass()
	{	   
		function User(){}

		User.prototype.setAttributes = function (attributes) {
	 		if(attributes == null){
	 			return;
	 		}

	 		var keyList = Object.keys(attributes);

	 		for(var i = 0; i < keyList.length; i++){
	 			var key = keyList[i];
	 			var value = attributes[key];

	 			this.setAttribute(key, value);
	 		}
		}

		User.prototype.setAttribute = function (key, value) {
	 		this[key] = value;
		}

		User.prototype.getResourcePath= function () {
			var resourcePath = {};

			resourcePath.userID = this.id_user
			resourcePath.companyID = this.fk_id_company

	 		return resourcePath;
		}	

		User.prototype.getResourceID = function () {
	 		return this.id_user;
		}	

		User.prototype.getParentResourceID = function () {
	 		return this.fk_id_company;
		}					

		return User;
	}


})();
(function ()
{
	'use strict';

	angular
		.module("app.settings.miscfeestypes")
		.factory("miscfeestypes", miscfeestypesClass)

	/** @ngInject */
	function miscfeestypesClass()
	{	   
		function miscfeestypes(){}

		miscfeestypes.prototype.setAttributes = function (attributes) {
	 		if(attributes == null){
	 			return;
	 		}

	 		var keyList = Object.keys(attributes);

	 		for(var i = 0; i < keyList.length; i++){
	 			var key = keyList[i];
	 			var value = attributes[key];

	 			this.setAttribute(key, value);
	 		}
		}

		miscfeestypes.prototype.setAttribute = function (key, value) {
	 		this[key] = value;
		}

		miscfeestypes.prototype.getResourcePath= function () {
			var resourcePath = {};

			resourcePath.userID = this.id_user
			resourcePath.companyID = this.fk_id_company

	 		return resourcePath;
		}	

		miscfeestypes.prototype.getResourceID = function () {
	 		return this.id_user;
		}	

		miscfeestypes.prototype.getParentResourceID = function () {
	 		return this.fk_id_company;
		}					

		return miscfeestypes;
	}


})();
(function ()
{
	'use strict';

	angular
		.module('app.settings.miscfeestypes')
		.service("miscfeestypesService", miscfeestypesService);

	/** @ngInject */
	function miscfeestypesService($state, api, ToolsFactory, Const, MessageService, $q, miscfeestypes)
	{   

		var codeKey = Const.header.code;
		var messageKey = Const.header.message;
		var successCode = Const.code.success;

		this.addmiscfeestypes = function (companyID, newmiscfeestypes, callback){
			newmiscfeestypes.companyID = companyID;
			newmiscfeestypes.workorderID = 0;
			newmiscfeestypes.vehicleID = 0;
			api.miscfeestypes.createmiscfeestypes(
				newmiscfeestypes,
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);
						callback(errorMessage);
						return;
					}

					var miscfeestypesID = response.data;
					callback(null, miscfeestypesID);
				},
				function(error){
					var errorMessage = error.status + ': ' + error.statusText;
					callback(errorMessage);
				}
			);		  
		}

		this.deletemiscfeestypes = function (miscfeestypes, callback){

			api.miscfeestypes.deletemiscfeestypes(
				{
					miscfeeID :miscfeestypes.id_miscfee,
					companyID:miscfeestypes.fk_id_company,
					workorderID: 0,
					vehicleID: 0
				},	
				function(response,header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);
						callback(errorMessage);
						return;
					}

					callback(null, miscfeestypes);
				},
				function(error){
					var errorMessage = error.status + ': ' + error.statusText;
					callback(errorMessage);
				}
			);		  
		}		

		this.updatemiscfeestypes = function (miscfeestypes, callback){

			miscfeestypes.miscfeeID = miscfeestypes.id_miscfee;
			miscfeestypes.companyID = miscfeestypes.fk_id_company;

			miscfeestypes.workorderID = 0;
			miscfeestypes.vehicleID = 0;

			api.miscfeestypes.updatemiscfeestypes(
				miscfeestypes,	
				function(response,header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);
						callback(errorMessage);
						return;
					}

					callback(null, null);
				},
				function(error){
					var errorMessage = error.status + ': ' + error.statusText;
					callback(errorMessage);
				}
			);		  
		}

		this.getMiscFeesTypes = function(resourcePath, searchText){
			var defer = $q.defer();
			var paramInUrl = {};

			

			paramInUrl.companyID = resourcePath.companyID;
			paramInUrl.userID = resourcePath.userID;
			paramInUrl.searchText = searchText;
			paramInUrl.vehicleID = resourcePath.vehicleID;
			paramInUrl.workorderID = resourcePath.workorderID;


			api.miscfeestypes.getmiscfeestypes(
				paramInUrl,
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);
						defer.reject(errorMessage);
						return;
					}

					var miscfeesList = [];

					response.forEach(function(data){
						var mimiscfeestypesscfees = new miscfeestypes();

						mimiscfeestypesscfees.setAttributes(data); 
						miscfeesList.push(mimiscfeestypesscfees);
					})

					defer.resolve(miscfeesList);
				},
				function(error){
					console.error(error);
					defer.reject("Failed to get Misc Fees types");
				}
			);

			return defer.promise;
		}
	}
})();
(function ()
{
    'use strict';

    angular
        .module('app.settings.miscfeestypes')
        .provider('miscfeestypesTempValue', miscfeestypesTempValue);

    /** @ngInject */
    function miscfeestypesTempValue()
    {
        this.$get = function(){

            var provider = {

                setTempCompanyID:setTempCompanyID,
                getTempCompanyID:getTempCompanyID,
                setTempmiscfeestypesID:setTempmiscfeestypesID,
                getTempmiscfeestypesID:getTempmiscfeestypesID
            };

            function setTempCompanyID (companyID){
                window.localStorage.setItem("companyID",companyID);
            }
            function getTempCompanyID () {
                var companyID = window.localStorage.getItem("companyID")
                return companyID;
            }        
            
            function setTempmiscfeestypesID (miscfeestypesTypesID){
                window.localStorage.setItem("miscfeestypesTypesID",miscfeestypesTypesID);
            }
            function getTempmiscfeestypesID (){
                var miscfeestypesTypesID = window.localStorage.getItem("miscfeestypesTypesID")
                return miscfeestypesTypesID;
            }     

            return provider;             
        }
    }

})();
(function ()
{
	'use strict';

	angular
		.module('app.settings.packages')
		.service("PresetPackagesService", PresetPackagesService);

	/** @ngInject */
	function PresetPackagesService(LoginService, GeneralTools, Const, $q, MessageService, $filter, $resource, PresetPackage)
	{
		const baseUrl = GeneralTools.getBaseUrl();
		const errMsgFailedToFetchPackage = "Failed to fetch preset packages";
		const errMsgFailedToFetchNewPackageID = "Failed to fetch new preset package ID";
		const baseHeader = GeneralTools.getBaseHeader();
		const noCacheHeader = GeneralTools.getNoCacheHeader();

		const packageItemTypesApi = $resource(
			baseUrl + "packageitemtypes",
			{},
			{
				get:{
					method:"GET",
					isArray:true,
					cancellable: true,
					interceptor:{
						response: function(result){
							const statusCode  = result.headers(Const.header.code);

							if(statusCode != Const.code.success){
								console.error(statusCode, result.headers(Const.header.message));
								return $q.reject(errMsgFailedToFetchPackage);
							}

							return result.data;
						},
						responseError: function (error){
							if(error && error.xhrStatus == Const.xhrStatus.abort){
								return $q.reject();
							}
							console.error(error);
							return $q.reject(error);
						}
					}
				}
			}
		);
	
		const presetPackagesApi = $resource(
			baseUrl + "companies/:companyID/presetpackages/:presetpackageID",
			{	
				companyID: "@companyID",
				presetpackageID: "@presetpackageID"
			},
			{	
				getPackages:{
					method:"GET",
					isArray:true,
					headers: noCacheHeader,
					cancellable: true,
					interceptor:{
						response: function(result){
							const statusCode  = result.headers(Const.header.code);

							if(statusCode != Const.code.success){
								console.error(statusCode, result.headers(Const.header.message));
								return $q.reject(errMsgFailedToFetchPackage);
							}

							return result.data.map(function(data){
								var presetPackage = new PresetPackage();

								presetPackage.setAttributes(data);
								return presetPackage;
							});
						},
						responseError: function (error){
							if(error && error.xhrStatus == Const.xhrStatus.abort){
								return $q.reject();
							}
							console.error(error);
							return $q.reject(error);
						}
					}
				},	
				updatePackage:{
					method:"PUT",
					headers: baseHeader,
					interceptor:{
						response: function(result){
							const statusCode  = result.headers(Const.header.code);

							if(result.headers(Const.header.code) != Const.code.success){
								console.error(statusCode, result.headers(Const.header.message));
								return $q.reject(errMsgFailedToFetchPackage);
							}

							return $q.resolve();
						},
						responseError: function (error){
							if(error && error.xhrStatus == Const.xhrStatus.abort){
								return $q.reject();
							}
							console.error(error);
							return $q.reject(error);
						}
					}
				},
				postPackage:{
					method:"POST",
					headers: baseHeader,
					interceptor:{
						response: function(result){
							const statusCode  = result.headers(Const.header.code);

							if(statusCode != Const.code.success){
								console.error(statusCode, result.headers(Const.header.message));
								return $q.reject(errMsgFailedToFetchPackage);
							}

							if(!result.data){
								console.error(errMsgFailedToFetchNewPackageID);
								return $q.reject(errMsgFailedToFetchNewPackageID);
							}

							return result.data.data;
						},
						responseError: function (error){
							if(error && error.xhrStatus == Const.xhrStatus.abort){
								return $q.reject();
							}
							console.error(error);
							return $q.reject(error);
						}
					}
				},
				deletePackage:{
					method:"DELETE",
					headers: baseHeader,
					interceptor:{
						response: function(result){
							const statusCode  = result.headers(Const.header.code);

							if(result.headers(Const.header.code) != Const.code.success){
								console.error(statusCode, result.headers(Const.header.message));
								return $q.reject(errMsgFailedToFetchPackage);
							}

							return $q.resolve();
						},
						responseError: function (error){
							if(error && error.xhrStatus == Const.xhrStatus.abort){
								return $q.reject();
							}
							console.error(error);
							return $q.reject(error);
						}
					}
				}								
		});

		this.getPackageItemTypes = function(){
			return packageItemTypesApi.get();
		}		

		this.getPresetPackages = function(resourcePath){
			return presetPackagesApi.getPackages(resourcePath);
		}

		this.createPresetPackages = function(resourcePath, requesetBody){
			return presetPackagesApi.postPackage(resourcePath, requesetBody);
		}

		this.deletePresetPackages = function(resourcePath){
			return presetPackagesApi.deletePackage(resourcePath);
		}

		this.updatePresetPackages = function(resourcePath, requesetBody){
			return presetPackagesApi.updatePackage(resourcePath, requesetBody);
		}
	}
})();
(function ()
{
	'use strict';

	angular
		.module('app.settings.packages')
		.controller('PresetPackagesController', PresetPackagesController);

	function PresetPackagesController($q, DialogService, LoginService, $scope, GeneralTools, PresetPackagesService, PresetPackage, $timeout, MessageService, jobtypes, $mdDialog, apiResolver){   
		const vm = this;
		const companyID = LoginService.getCompanyID();
		
		vm.today = new Date();
		vm.setActiveExpDate = setActiveExpDate
		vm.translateToDollar = GeneralTools.inputTranslators.dollar;
		vm.decimalTranslator = GeneralTools.inputTranslators.decimal;
		vm.quantityInputOption = {
			decimalFractionSize:0
		};
		
		vm.addItem = addItem;
		vm.addPackage = addPackage;
		vm.deletePackages = deletePackages;
		vm.removeNewItem = removeNewItem;
		vm.jobTyppList = jobtypes
		vm.newAssignedJobHolder = "";
		vm.initPackageTypes = initPackageTypes;

		init();

		function init(){
			//initPackageTypes();
			initNewPresetPackage();
			initPresetPackages();
		}

		function initPackageTypes(){
			PresetPackagesService.getPackageItemTypes().$promise.then(function(packageItemTypes){
				vm.packageItemTypes = packageItemTypes;
			})
			.catch(MessageService.showToast);
		}

		function initNewPresetPackage(){
			vm.newPresetPackage = new PresetPackage();
			vm.newPresetPackage.items = [];
		}

		function initPresetPackages(){
			PresetPackagesService.getPresetPackages({companyID: companyID}).$promise.then(function(presetPackages){
				if(!Array.isArray(presetPackages)){
					return;
				}

				vm.presetPackages = presetPackages;
			})
			.catch(MessageService.showToast);
		}

		function addItem(){
			if(!$scope.packageItemForm.$valid){
				MessageService.showToast("Something wrong in package item form");
				return;
			}

			vm.newPresetPackage.items.push({
				name: vm.newPackageItemName,
				quantity: vm.newPackageItemQuantity,
				job: vm.newAssignedJobHolder
				//fk_id_package_item_type: vm.newPackageItemType
			});

			resetPackageItemForm();
		}

		function resetPackageItemForm(){
			vm.newPackageItemName = null;
			vm.newPackageItemQuantity = null;
			vm.newAssignedJobHolder = null;
			//vm.newPackageItemType = null;

			$scope.packageItemForm.$setPristine(true);
			$scope.packageItemForm.$setUntouched();
		}

		function setActiveExpDate(){
			if(!vm.newPackageActiveExpiryDate){
				vm.newPresetPackage.active_expiry_date = null;
				return
			}

			vm.newPresetPackage.setActiveExpiryDate(moment(vm.newPackageActiveExpiryDate));

			if(!vm.newPresetPackage.active_expiry_date){
				vm.newPackageActiveExpiryDate = null
			}
		}

		function addPackage(){

			if(!$scope.newPackageForm.$valid){			
				MessageService.showToast("Something wrong in the package form.");
				return;
			}

			
			if(!$scope.newPackageForm2.$valid){			
				MessageService.showToast("Something wrong in the package form.");
				return;
			}

			if(!Array.isArray(vm.newPresetPackage.items) || vm.newPresetPackage.items.length <= 0){
				MessageService.showToast("Please add an item to the package.");
				return;
			}

			const resourcePath = {
				companyID: companyID
			}

			vm.newPresetPackage.items.forEach(function(item){
				item.fk_id_job = item.job.id_job
			})

			if(!vm.newPresetPackage.valid_mileage){
				vm.newPresetPackage.valid_mileage = null
			}

			vm.isSaving = true;
			
			PresetPackagesService.createPresetPackages(resourcePath, vm.newPresetPackage).$promise
				.then(function(newPresetPackageID){
					vm.newPresetPackage.id_preset_package = newPresetPackageID
					vm.presetPackages.push(angular.copy(vm.newPresetPackage));
					resetNewPackageForm();
					MessageService.showToast("Package added");
				})
				.catch(MessageService.showToast)
				.finally(function(){
					vm.isSaving = false;
				});
		}

		function deletePackages(){
			if(!vm.getSelectedPackages){
				return;
			}

			const selectedPackages = vm.getSelectedPackages();

			if(!Array.isArray(selectedPackages) ){
				return;
			}

			if(selectedPackages.length <= 0){
				MessageService.showToast("Please select a package.");
				return;
			}

			vm.isDeleting = true;

			DialogService.showYesOrNoDialog("Delete Packages", "Delete " + selectedPackages.length + " packages")
				.then(function(isYes){
					if(!isYes){
						return $q.reject();
					}

					const queue = [];

					selectedPackages.forEach(function(presetPackage){
						queue.push(deletePresetPackage(presetPackage));
					});

					return $q.all(queue);
				})
				.then(function(){
					MessageService.showToast("Packages deleted");
				})
				.catch(function(error){
					if(error){
						MessageService.showToast(error);
					}
				})
				.finally(function(){
					vm.isDeleting = false;
				});
		}

		function deletePresetPackage(presetPackage){
			const resourcePath = {
				companyID: companyID,
				presetpackageID: presetPackage.id_preset_package
			}

			return PresetPackagesService.deletePresetPackages(resourcePath).$promise				
				.then(function(){
					const index = vm.presetPackages.findIndex(function(item){
						return !!item && item.id_preset_package == presetPackage.id_preset_package;
					});

					vm.presetPackages.splice(index, 1);
					return $q.resolve();	
				});
		}

		function removeNewItem(index){
			if(vm.newPresetPackage && Array.isArray(vm.newPresetPackage.items)){
				vm.newPresetPackage.items.splice(index, 1);
			}
		}

		function resetNewPackageForm(){
			initNewPresetPackage();
			vm.newPackageActiveExpiryDate = null;
			$scope.newPackageForm.$setPristine();
			$scope.newPackageForm.$setUntouched();
			$scope.newPackageForm2.$setPristine();
			$scope.newPackageForm2.$setUntouched();
		}
	}
})();
(function ()
{
	"use strict";

	angular
		.module("app.settings.packages")
		.component("presetPackageList", {
				bindings:{
					presetPackages: '<',
					packageItemTypes: '<',
					getSelectedPackages: '=',
					jobList:'<',
					refreshPresetPackages: '='
				},
				templateUrl: "app/main/settings/preset-packages/preset-package-list.html",
				controller: componentController,
		  		controllerAs: 'vm'
			});

		function componentController(GeneralTools, MessageService, WorkOrderService, LoginService,PresetPackagesService, $mdDialog){
			var vm = this;

			const companyID = LoginService.getCompanyID();
			vm.$onInit = initComponent;
			vm.$postLink = initCallbacks;
			vm.showItems = {};
			vm.selectedMap = {};
			vm.getItemType = getItemType;
			vm.getPackgeItemCoverage= getPackgeItemCoverage;
			vm.getJobNameWithId = getJobNameWithId;
			vm.dialogedit = dialogedit
			vm.refreshPresetPackagesv2 = refreshPresetPackagesv2;
			function initComponent(){
				initJobTypes();

			}

			function initCallbacks(){
				vm.getSelectedPackages = getSelectedPackages;
				// vm.refreshPresetPackages = refreshPresetPackages;
			}

			function getSelectedPackages(){
				if(!Array.isArray(vm.presetPackages)){
					return;
				}

				return vm.presetPackages.filter(function(presetPackage){
					return !!presetPackage && vm.selectedMap[presetPackage.id_preset_package];
				});
			}

			function getItemType(item){
				if(!item || !Array.isArray(vm.packageItemTypes)){
					return;
				}

				const matchItem = vm.packageItemTypes.find(function(packageType){
					return packageType && packageType.id_preset_package == item.fk_id_package_type;
				});

				if(matchItem){
					return matchItem.name;
				}

				return "Unknown";
			}

			function initJobTypes(){
	
			}

			function getPackgeItemCoverage(item, typeId){
			}

			function getJobNameWithId(item){
				var jobName = undefined

				if(!item){
					return undefined
				}

				if(item.fk_id_job && vm.jobList.length > 0){
					vm.jobList.forEach(function(job){
						
						if(job.id_job == item.fk_id_job){
							jobName = job.name
						}
					})
				}


				return jobName
			}

			function refreshPresetPackagesv2(){
				PresetPackagesService.getPresetPackages({companyID: companyID}).$promise.then(function(presetPackages){
					if(!Array.isArray(presetPackages)){
						return;
					}
	
					vm.presetPackages = presetPackages;
				})
				.catch(MessageService.showToast);
			}

			function dialogedit(autocartpackage){
				$mdDialog.show({
					controller         : 'EditpackagesController',
					controllerAs       : 'vm',
					templateUrl        : 'app/main/settings/preset-packages/edit-packages/edit-packages.html',
					clickOutsideToClose: true,
					locals             : {
						autocartpackage      : autocartpackage,
						jobtypes: 			vm.jobList,
						refreshPresetPackages: vm.refreshPresetPackagesv2
					}
				});
			}

			

		}
})();


(function ()
{
	'use strict';

	angular
		.module("app.settings.packages")
		.factory("PresetPackage", PresetPackageClass)

	/** @ngInject */
	function PresetPackageClass(PresetPackageConstants)
	{	 
		function PresetPackage(){}

		PresetPackage.prototype.setAttributes = function (attributes) {
	 		if(attributes == null){
	 			return;
	 		}

	 		var keyList = Object.keys(attributes);

	 		for(var i = 0; i < keyList.length; i++){
	 			var key = keyList[i];
	 			var value = attributes[key];

	 			this.setAttribute(key, value);
	 		}
		}

		PresetPackage.prototype.setAttribute = function (key, value) {
	 		this[key] = value;
		}

		PresetPackage.prototype.getResourceId = function () {
	 		return this.id_preset_package;
		}	

		PresetPackage.prototype.setActiveExpiryDate = function (momentObj) {
	 		if(momentObj && momentObj.isValid()){
				this.active_expiry_date = momentObj.format(PresetPackageConstants.dateFormat);
				return true;
			}
			this.active_expiry_date = null;
			return false;
		}	

		PresetPackage.prototype.getActiveExpiryDateMomentObj = function (){
			if(this.active_expiry_date){
				return moment(this.active_expiry_date, PresetPackageConstants.dateFormat);
			}
		}

		PresetPackage.prototype.isActive = function (){
			const expiryDate = this.getActiveExpiryDateMomentObj();
			if(!expiryDate){
				return true;
			}
			const now = moment();

			return now.isSameOrBefore(expiryDate, "Date");
		}

		return PresetPackage;
	}


})();
(function ()
{
	'use strict';

	angular
		.module("app.settings.parttype")
		.factory("PartTypesClass", PartTypesClass)

	/** @ngInject */
	function PartTypesClass()
	{	   
		function PartType(){}

		PartType.prototype.setAttributes = function (attributes) {
	 		if(attributes == null){
	 			return;
	 		}

	 		var keyList = Object.keys(attributes);

	 		for(var i = 0; i < keyList.length; i++){
	 			var key = keyList[i];
	 			var value = attributes[key];

	 			this.setAttribute(key, value);
	 		}
		}

		PartType.prototype.setAttribute = function (key, value) {
	 		this[key] = value;
		}

		PartType.prototype.getResourcePath= function () {
			var resourcePath = {};

			resourcePath.userID = this.id_user
			resourcePath.companyID = this.fk_id_company

	 		return resourcePath;
		}	

		PartType.prototype.getResourceID = function () {
	 		return this.id_user;
		}	

		PartType.prototype.getParentResourceID = function () {
	 		return this.fk_id_company;
		}					

		return PartType;
	}


})();
(function ()
{
	'use strict';

	angular
		.module('app.settings.parttype')
		.service("PartTypesService", PartTypesService);

	/** @ngInject */
	function PartTypesService($state ,api, ToolsFactory, Const, MessageService, $q, PartTypesClass)
	{   

		var codeKey = Const.header.code;
		var messageKey = Const.header.message;
		var successCode = Const.code.success;


		this.getparttypes = function(resourcePath, searchText){
			var defer = $q.defer();
			var paramInUrl = {};

			

			paramInUrl.companyID = resourcePath.companyID;
			paramInUrl.userID = resourcePath.userID;
			paramInUrl.searchText = searchText;

			api.parttype.getparttypes(
				paramInUrl,
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);
						defer.reject(errorMessage);
						return;
					}

					var parttypeList = [];

					response.forEach(function(data){
						var parttype = new PartTypesClass();

						parttype.setAttributes(data); 
						parttypeList.push(parttype);
					})

					defer.resolve(parttypeList);
				},
				function(error){
					console.error(error);
					defer.reject("Failed to get preset part");
				}
			);

			return defer.promise;
		}


		this.createparttype = function (companyID, newparttype, callback){
			newparttype.companyID = companyID;
			api.parttype.createparttype(
				newparttype,
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);
						callback(errorMessage);
						return;
					}

					var newparttypeID = response.data;
					callback(null, newparttypeID);
				},
				function(error){
					var errorMessage = error.status + ': ' + error.statusText;
					callback(errorMessage);
				}
			);		  
		}		

		this.deleteparttype = function (parttypeID, companyID, callback){
			api.parttype.deleteparttype(
				{
					parttypesID :parttypeID.id_part_type,
					companyID:companyID
				},	
				function(response,header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);
						callback(errorMessage);
						return;
					}

					callback(null, parttypeID);
				},
				function(error){
					var errorMessage = error.status + ': ' + error.statusText;
					callback(errorMessage);
				}
			);		  
		}	

		this.updateparttype = function (parttypedata, callback){
			parttypedata.parttypesID = parttypedata.id_part_type;
			parttypedata.companyID = parttypedata.fk_id_company;
			api.parttype.updateparttype(
				parttypedata,	
				function(response,header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);
						callback(errorMessage);
						return;
					}

					callback(null, null);
				},
				function(error){
					var errorMessage = error.status + ': ' + error.statusText;
					callback(errorMessage);
				}
			);		  
		}

	}
})();
(function ()
{
    'use strict';

    angular
        .module('app.settings.parttype')
        .provider('parttypesTempValue', parttypesTempValue);

    /** @ngInject */
    function parttypesTempValue()
    {
        this.$get = function(){

            var provider = {
                setTempCompanyID:setTempCompanyID,
                getTempCompanyID:getTempCompanyID,
                setTempParttypesID:setTempParttypesID,
                getTempParttypesID:getTempParttypesID
            };

            function setTempCompanyID (companyID){
                window.localStorage.setItem("companyID",companyID);
            }
            function getTempCompanyID () {
                var companyID = window.localStorage.getItem("companyID")
                return companyID;
            }        
            
            function setTempParttypesID (parttypesID){
                window.localStorage.setItem("parttypesID",parttypesID);
            }
            function getTempParttypesID (){
                var parttypesID = window.localStorage.getItem("parttypesID")
                return parttypesID;
            }     

            return provider;             
        }
    }

})();
(function ()
{
	'use strict';

	angular
		.module('app.settings.labour')
		.service("LabourService", LabourService);

	/** @ngInject */
	function LabourService($state, api, ToolsFactory, Const, MessageService, $q, Labour)
	{   

		var codeKey = Const.header.code;
		var messageKey = Const.header.message;
		var successCode = Const.code.success;

		this.addLabour = function (companyID, newLabour, callback){
			newLabour.companyID = companyID;
			api.labour.addLabour(
				newLabour,
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);
						callback(errorMessage);
						return;
					}

					var newLabourID = response.data;
					callback(null, newLabourID);
				},
				function(error){
					var errorMessage = error.status + ': ' + error.statusText;
					callback(errorMessage);
				}
			);		  
		}		
		this.updateUser = function (userID, companyID, updateUser, callback){

			updateUser.companyID = companyID;
			updateUser.userID = userID;

			api.users.updateUser(
				updateUser,
				function(response,header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);
						callback(errorMessage);
						return;
					}

					callback(null, null);
				},
				function(error){
					var errorMessage = error.status + ': ' + error.statusText;
					callback(errorMessage);
				}
			);		  
		}

		this.deleteLabour = function (labourtypeID, callback){
			api.labour.deleteLabour(
				{labourTypesID :labourtypeID.id_labour_type,
					companyID:labourtypeID.fk_id_company
				},	
				function(response,header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);
						callback(errorMessage);
						return;
					}

					callback(null, labourtypeID);
				},
				function(error){
					var errorMessage = error.status + ': ' + error.statusText;
					callback(errorMessage);
				}
			);		  
		}		

		this.checkRoles = function(loginUserRoles, targetUserRoles){
			var result = false

			if(!Array.isArray(loginUserRoles)){
				return result;
			}
			if(!Array.isArray(targetUserRoles)){
				targetUserRoles = [];
			}

			for(var i = 0; i < targetUserRoles.length; i++){
				var targetUserRole = targetUserRoles[i]
				if(loginUserRoles.indexOf(targetUserRole) == -1){
					return result;
				}
			}
			return true;
		}

		this.checkAvailability= function(columnName, value, callback){
			api.check.checkExistence.check(
				{   
					tableName:"user",
					columnName:columnName,
					value:value
				},
				function(response, header){
					var statusCode  = header(codeKey);					
					if(statusCode != successCode){
						MessageService.showToast(statusCode + " : "+ header("message"));
						return;
					}					
					callback(!response.data)					
				},
				function(error){
					console.log(error);
				}
			); 
		}

		this.getUsers = function(resourcePath, searchText){
			var defer = $q.defer();
			var paramInUrl = {};

			

			paramInUrl.companyID = resourcePath.companyID;
			paramInUrl.userID = resourcePath.userID;
			paramInUrl.searchText = searchText;

			api.users.getUsers(
				paramInUrl,
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);
						defer.reject(errorMessage);
						return;
					}

					var userList = [];

					response.forEach(function(data){
						var user = new User();

						user.setAttributes(data); 
						userList.push(user);
					})

					defer.resolve(userList);
				},
				function(error){
					console.error(error);
					defer.reject("Failed to get users");
				}
			);

			return defer.promise;
		}

		this.getLabour = function(resourcePath, searchText){
			var defer = $q.defer();
			var paramInUrl = {};

			

			paramInUrl.companyID = resourcePath.companyID;
			paramInUrl.userID = resourcePath.userID;
			paramInUrl.searchText = searchText;

			api.labour.getLabour(
				paramInUrl,
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);
						defer.reject(errorMessage);
						return;
					}

					var labourList = [];

					response.forEach(function(data){
						var labour = new Labour();

						labour.setAttributes(data); 
						labourList.push(labour);
					})

					defer.resolve(labourList);
				},
				function(error){
					console.error(error);
					defer.reject("Failed to get labour");
				}
			);

			return defer.promise;
		}

		this.getAllLabour = function(){
			var defer = $q.defer();

			api.labour(
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);
						defer.reject(errorMessage);
						return;
					}

					var userList = [];

					response.forEach(function(data){
						var user = new User();

						user.setAttributes(data); 
						userList.push(user);
					})

					defer.resolve(userList);
				},
				function(error){
					console.error(error);
					defer.reject("Failed to get Labour");
				}
			);

			return defer.promise;
		}

		this.updateLabour = function (labourdata, callback){
			labourdata.labourTypesID = labourdata.id_labour_type;
			labourdata.companyID = labourdata.fk_id_company;
			api.labour.updateLabour(
				labourdata,	
				function(response,header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);
						callback(errorMessage);
						return;
					}

					callback(null, null);
				},
				function(error){
					var errorMessage = error.status + ': ' + error.statusText;
					callback(errorMessage);
				}
			);		  
		}
	}
})();
(function ()
{
    'use strict';

    angular
        .module('app.settings.labour')
        .provider('labourTempValue', labourTempValue);

    /** @ngInject */
    function labourTempValue()
    {
        this.$get = function(){

            var provider = {

                setTempCompanyID:setTempCompanyID,
                getTempCompanyID:getTempCompanyID,
                setTempLabourID:setTempLabourID,
                getTempLabourID:getTempLabourID
            };

            function setTempCompanyID (companyID){
                window.localStorage.setItem("companyID",companyID);
            }
            function getTempCompanyID () {
                var companyID = window.localStorage.getItem("companyID")
                return companyID;
            }        
            
            function setTempLabourID (labourTypesID){
                window.localStorage.setItem("labourTypesID",labourTypesID);
            }
            function getTempLabourID (){
                var labourTypesID = window.localStorage.getItem("labourTypesID")
                return labourTypesID;
            }     

            return provider;             
        }
    }

})();
(function ()
{
	'use strict';

	angular
		.module("app.settings.labour")
		.factory("Labour", LabourClass)

	/** @ngInject */
	function LabourClass()
	{	   
		function Labour(){}

		Labour.prototype.setAttributes = function (attributes) {
	 		if(attributes == null){
	 			return;
	 		}

	 		var keyList = Object.keys(attributes);

	 		for(var i = 0; i < keyList.length; i++){
	 			var key = keyList[i];
	 			var value = attributes[key];

	 			this.setAttribute(key, value);
	 		}
		}

		Labour.prototype.setAttribute = function (key, value) {
	 		this[key] = value;
		}

		Labour.prototype.getResourcePath= function () {
			var resourcePath = {};

			resourcePath.userID = this.id_user
			resourcePath.companyID = this.fk_id_company

	 		return resourcePath;
		}	

		Labour.prototype.getResourceID = function () {
	 		return this.id_user;
		}	

		Labour.prototype.getParentResourceID = function () {
	 		return this.fk_id_company;
		}					

		return Labour;
	}


})();
(function ()
{
	'use strict';

	angular
		.module("app.settings.jobtypes")
		.factory("jobtypes", jobtypesClass)

	/** @ngInject */
	function jobtypesClass()
	{	   
		function jobtypes(){}

		jobtypes.prototype.setAttributes = function (attributes) {
	 		if(attributes == null){
	 			return;
	 		}

	 		var keyList = Object.keys(attributes);

	 		for(var i = 0; i < keyList.length; i++){
	 			var key = keyList[i];
	 			var value = attributes[key];

	 			this.setAttribute(key, value);
	 		}
		}

		jobtypes.prototype.setAttribute = function (key, value) {
	 		this[key] = value;
		}

		jobtypes.prototype.getResourcePath= function () {
			var resourcePath = {};

			resourcePath.userID = this.id_user
			resourcePath.companyID = this.fk_id_company

	 		return resourcePath;
		}	

		jobtypes.prototype.getResourceID = function () {
	 		return this.id_user;
		}	

		jobtypes.prototype.getParentResourceID = function () {
	 		return this.fk_id_company;
		}					

		return jobtypes;
	}


})();
(function ()
{
	'use strict';

	angular
		.module('app.settings.jobtypes')
		.service("jobtypesService", jobtypesService);

	/** @ngInject */
	function jobtypesService($state, api, ToolsFactory, Const, MessageService, $q, jobtypes, $resource, GeneralTools, LoginService)
	{   

		const xhrStatusAbort = "abort";
		var codeKey = Const.header.code;
		var messageKey = Const.header.message;
		var successCode = Const.code.success;
		var header = {}
		header.token = LoginService.getToken();
		header["Cache-Control"] = "no-cache, no-store, must-revalidate";
		header["Pragma"] = "no-cache";
		header["Expires"] = 0;
		const baseUrl = GeneralTools.getBaseUrl();


		const jobTypeLoacal = $resource(
			baseUrl + "companies/:companyID/customerportalslider/:customerportalsliderID",
			{
				companyID: "@companyID",
				customerportalsliderID: "@customerportalsliderID",
			},
			{
				getAllCustomerPortalSlider: {
					method: "GET",
					isArray: true,
					headers: header,
					cancellable: true,
					interceptor: {
						response: function (result) {
							var statusCode = result.headers(codeKey);

							if (statusCode != successCode) {
								var errorMessage = statusCode + ': ' + result.headers(messageKey);
								console.error("Failed to get All Customer Portal Sliders.");
								return $q.reject(errorMessage);
							}

							return result.data.map(function (data) {
								// var discount = new WorkOrderRDRedeemed();

								// discount.setAttributes(data);
								return data;
							});
						},
						responseError: function (error) {
							if (error && error.xhrStatus == xhrStatusAbort) {
								return $q.reject();
							}
							console.error("Failed to get All Customer Portal Sliders.");
							return $q.reject(error);
						}
					}
				},
				updateSlider: {
					method: "PUT",
					headers: {
						token: LoginService.getToken()
					}
				},
				deleteSlider: {
					method: "DELETE",
					headers: {
						token: LoginService.getToken()
					}
				}
			}
		);




		this.addjob = function (companyID, job, callback){
			job.companyID = companyID;
			api.jobtypes.createJob(
				job,
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);
						callback(errorMessage);
						return;
					}

					var miscfeestypesID = response.data;
					callback(null, miscfeestypesID);
				},
				function(error){
					var errorMessage = error.status + ': ' + error.statusText;
					callback(errorMessage);
				}
			);		  
		}

		this.deletemiscfeestypes = function (miscfeestypes, callback){

			api.miscfeestypes.deletemiscfeestypes(
				{
					miscfeeID :miscfeestypes.id_miscfee,
					companyID:miscfeestypes.fk_id_company,
					workorderID: 0,
					vehicleID: 0
				},	
				function(response,header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);
						callback(errorMessage);
						return;
					}

					callback(null, miscfeestypes);
				},
				function(error){
					var errorMessage = error.status + ': ' + error.statusText;
					callback(errorMessage);
				}
			);		  
		}		

		this.updatejob = function (job, callback){

			job.jobTypesID = job.id_job;
			job.companyID = job.fk_id_company;
			api.jobtypes.updateJob(
				job,	
				function(response,header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);
						callback(errorMessage);
						return;
					}

					callback(null, null);
				},
				function(error){
					var errorMessage = error.status + ': ' + error.statusText;
					callback(errorMessage);
				}
			);		  
		}

		this.getjobtypes = function(resourcePath, searchText){
			var defer = $q.defer();
			var paramInUrl = {};
			
			paramInUrl.companyID = resourcePath.companyID;
			paramInUrl.userID = resourcePath.userID;
			paramInUrl.searchText = searchText;
			paramInUrl.jobTypesID = resourcePath.jobTypesID

			return api.jobtypes.getJob(paramInUrl);

			// api.jobtypes.getJob(
			// 	paramInUrl,
			// 	function(response, header){
			// 		var statusCode  = header(codeKey);

			// 		if(statusCode != successCode){
			// 			var errorMessage = statusCode + ': ' + header(messageKey);
			// 			defer.reject(errorMessage);
			// 			return;
			// 		}

			// 		var jobtypesList = [];

			// 		response.forEach(function(data){
			// 			var jobtype = new jobtypes();

			// 			jobtype.setAttributes(data); 
			// 			jobtypesList.push(jobtypes);
			// 		})

			// 		defer.resolve(jobtypesList);
			// 	},
			// 	function(error){
			// 		console.error(error);
			// 		defer.reject("Failed to get Job types");
			// 	}
			// );

			// return defer.promise;
		}

		this.deletejob = function (job, callback){

			api.jobtypes.deleteJob(
				{
					jobTypesID :job.id_job,
					companyID:job.fk_id_company,
				},	
				function(response,header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);
						callback(errorMessage);
						return;
					}

					callback(null, job);
				},
				function(error){
					var errorMessage = error.status + ': ' + error.statusText;
					callback(errorMessage);
				}
			);		  
		}		

		const ServicesCatogory = $resource(
			baseUrl + "companies/:companyID/servicesCatogory/:servicesCatogoryID",
			{
				companyID: "@companyID",
				servicesCatogoryID: "@servicesCatogoryID",


			},
			{
				getServicesCatogory: {
					method: "GET",
					isArray: true,
					headers: header,
					cancellable: true,
					interceptor: {
						response: function (result) {
							var statusCode = result.headers(codeKey);

							if (statusCode != successCode) {
								var errorMessage = statusCode + ': ' + result.headers(messageKey);
								console.error("Failed to get Services Catogory.");
								return $q.reject(errorMessage);
							}

							return result.data.map(function (data) {
								return data;
							});
						},
						responseError: function (error) {
							if (error && error.xhrStatus == xhrStatusAbort) {
								return $q.reject();
							}
							console.error("Failed to get Services Catogory.");
							return $q.reject(error);
						}
					}
				}
			}
		);

		this.getAllServicesCatogory = function(resourcePath){	
			return ServicesCatogory.getServicesCatogory(resourcePath);
		}

	}
})();
(function ()
{
    'use strict';

    angular
        .module('app.settings.jobtypes')
        .provider('jobtypesTempValue',jobtypesTempValue);

    /** @ngInject */
    function jobtypesTempValue()
    {
        this.$get = function(){

            var provider = {
                setTempCompanyID:setTempCompanyID,
                getTempCompanyID:getTempCompanyID,
                setTempjobtypesID:setTempjobtypesID,
                getTempjobtypesID:getTempjobtypesID
            };

            function setTempCompanyID (companyID){
                window.localStorage.setItem("companyID",companyID);
            }
            function getTempCompanyID () {
                var companyID = window.localStorage.getItem("companyID")
                return companyID;
            }        
            
            function setTempjobtypesID (jobtypesTypesID){
                window.localStorage.setItem("jobTypesID",jobtypesTypesID);
            }
            function getTempjobtypesID (){
                var jobTypesID = window.localStorage.getItem("jobTypesID")
                return jobTypesID;
            }     

            return provider;             
        }
    }

})();
(function () {
	'use strict';

	angular.module('app.settings.goto', []).config(config);

	/** @ngInject */
	function config($stateProvider) {
		$stateProvider.state('app.settings.goto', {
			url: '/goto',
			views: {
				'content@app': {
					templateUrl: 'app/main/settings/goto/goto-settings.html',
					controller: 'GotoSettingsController as vm',
				},
			},
		});
	}
})();

(function () {
	'use strict';

	angular
		.module('app.settings.goto')
		.controller('GotoSettingsController', GotoSettingsController);

	/** @ngInject */
	function GotoSettingsController(
		$location,
		$window,
		GotoService,
		MessageService,
		RoleCheckService
	) {
		var vm = this;

		vm.status = {
			configured: false,
			channelConnected: false,
			channelConnecting: false,
		};
		vm.isLoading = true;
		vm.isProcessing = false;

		vm.connectSite = connectSite;
		vm.disconnectSite = disconnectSite;

		init();

		function init() {
			if (!RoleCheckService.checkRole(['developer', 'company_manager'])) {
				MessageService.showToast('You do not have permission to manage GoTo settings.');
				return;
			}

			handleOAuthReturn();
			refreshStatus();
		}

		function refreshStatus() {
			vm.isLoading = true;

			return GotoService.getSiteStatus()
				.then(function (status) {
					vm.status = status || vm.status;
				})
				.catch(function (error) {
					var message =
						error && error.data && error.data.message
							? error.data.message
							: 'Failed to load GoTo site status.';
					MessageService.showToast(message);
				})
				.finally(function () {
					vm.isLoading = false;
				});
		}

		function connectSite() {
			vm.isProcessing = true;

			GotoService.getSiteAuthorizationUrl()
				.then(function (payload) {
					if (!payload || !payload.url) {
						throw new Error('GoTo authorization URL was not returned.');
					}

					$window.location.href = payload.url;
				})
				.catch(function (error) {
					var message =
						error && error.data && error.data.message
							? error.data.message
							: error.message || 'Failed to start GoTo authorization.';
					MessageService.showToast(message);
				})
				.finally(function () {
					vm.isProcessing = false;
				});
		}

		function disconnectSite() {
			vm.isProcessing = true;

			GotoService.disconnectSite()
				.then(function (status) {
					vm.status = status || vm.status;
					MessageService.showToast('Site-wide GoTo connection removed.');
				})
				.catch(function (error) {
					var message =
						error && error.data && error.data.message
							? error.data.message
							: 'Failed to disconnect site-wide GoTo.';
					MessageService.showToast(message);
				})
				.finally(function () {
					vm.isProcessing = false;
				});
		}

		function handleOAuthReturn() {
			var params = $location.search() || {};

			if (params.goto === 'site-connected') {
				MessageService.showToast('Site-wide GoTo connected.');
				$location.search('goto', null);
				refreshStatus();
			} else if (params.goto === 'error') {
				MessageService.showToast(
					params.message
						? decodeURIComponent(params.message)
						: 'GoTo authorization failed.'
				);
				$location.search('goto', null);
				$location.search('message', null);
			}
		}
	}
})();

(function ()
{
	'use strict';

	angular
		.module('app.settings.googleService', [])
		.constant("GoogleServiceConstants", {
			apiKey:"AIzaSyBVtNAzCAvJsF1M0z8bIRBUi8KJeqPuCBY",
			clientID:"1092801090665-7ivl5fsrqdqddmpeaj7f2pne80pfvvp9.apps.googleusercontent.com",
			discoveryDocs:{
				gmail:"https://www.googleapis.com/discovery/v1/apis/gmail/v1/rest"
			},
			scopes:{
				gmail:"https://mail.google.com/"
			}
		})
		.config(config);

	/** @ngInject */
	function config($stateProvider)
	{
		$stateProvider
			.state("app.settings.google-service",{
				url:"/google-service",
				views	: {
					'content@app': {
						templateUrl: 'app/main/settings/google-service/google-service.html',
						controller : 'GoogleServiceController as vm'
					}
				},
				resolve: {
					tokenInfo:function(LoginService, GoogleService, MessageService){
						return GoogleService.getGoogleServiceInfo({companyID: LoginService.getCompanyID()})
							.then(function(googleServiceInfo){
								return GoogleService.validateAccessToken(googleServiceInfo.accessToken);
							})
							.catch(MessageService.showToast);			
					}
				}
			});
	}


})();
(function ()
{
	'use strict';

	angular
		.module('app.settings.googleService')
		.service("GoogleService", GoogleService);

	/** @ngInject */
	function GoogleService(api, Const, $q, $resource, GeneralTools)
	{
		var codeKey = Const.header.code;
		var messageKey = Const.header.message;
		var successCode = Const.code.success;
		const baseUrl = GeneralTools.getBaseUrl();
		const baseHeader = GeneralTools.getBaseHeader();

		const decodePostcodeApi = $resource(
			baseUrl + "companies/@companyID/googleservice/decodepostcode",
			{
				companyID: "@companyID"
			},
			{
				get:{
					method:"GET",
					cancellable: true,
					isArray: true,
					headers: baseHeader,
					interceptor:{
						response: function(result){
							const statusCode  = result.headers(Const.header.code);
							const message = result.headers(Const.header.message)
							if(statusCode != Const.code.success){
								console.error(statusCode, message);
								return $q.reject(message);
							}

							return result.data;
						},
						responseError: function (error){
							if(error && error.xhrStatus == Const.xhrStatus.abort){
								return $q.reject();
							}
							console.error(error);
							return $q.reject(error);
						}
					}
				}
			}
		);

		this.decodePostcode = function(companyID, postcode){
			return decodePostcodeApi.get({companyID:companyID, postcode: postcode});
		}

		this.getGoogleServiceInfo = function(resourcePath){
			var defer = $q.defer();

			api.googleServiceInfo.getInfo(
				resourcePath,
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);
						defer.reject(errorMessage);
						return;
					}

					defer.resolve(response);
				},
				function(error){
					console.error(error);
					defer.reject("Failed to get google service info");
				}
			);

			return defer.promise;
		}

		this.authorizeGoogleService = function(resourcePath, requestBody){
			var defer = $q.defer();

			api.googleServiceInfo.authorize(
				resourcePath,
				requestBody,
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);
						defer.reject(errorMessage);
						return;
					}

					defer.resolve(response.data);
				},
				function(error){
					console.error(error);
					defer.reject("Failed to authorize google service");
				}
			);

			return defer.promise;
		}

		this.validateAccessToken = function(token){
			var defer = $q.defer();

			$resource("https://www.googleapis.com/oauth2/v3/tokeninfo")
				.get(
					{access_token:token},
					function(response){
						defer.resolve(response);
					},
					function(){
						defer.resolve(null);
					}
				);

			return defer.promise;
		}
	}
})();
(function ()
{
	'use strict';

	angular
		.module('app.settings.googleService')
		.controller('GoogleServiceController', GoogleServiceController);

	function GoogleServiceController($q, $resource, $scope, MessageService, GoogleService, LoginService, tokenInfo, GoogleServiceConstants){   
		var vm = this;
		var companyID = LoginService.getCompanyID();
		var param ={
			apiKey: GoogleServiceConstants.apiKey,
			clientId: GoogleServiceConstants.clientID,
			discoveryDocs: [GoogleServiceConstants.discoveryDocs.gmail],
			scope: GoogleServiceConstants.scopes.gmail
		}

		var GoogleAuth;
		var getCurrentGoogleUserDefer;

		vm.signIn = signIn

		init();

		function init(){
			vm.tokenInfo = tokenInfo? tokenInfo:{};
			console.log(vm.tokenInfo)
			initGoogleApi();
		}

		function loadGoogleApi(){
			var defer = $q.defer();

			gapi.load("client:auth2", 
				{
					callback: function() {
						defer.resolve();
					},
					onerror: function() {
						defer.reject("Failed to init google api.");
					}
				}
			);

			return defer.promise;
		}		

		function initGoogleApi(){
			vm.isProcessing = true;
			loadGoogleApi()
				.then(function(){
					return gapi.client.init(param);
				})
				.then(function(){
					GoogleAuth = gapi.auth2.getAuthInstance();
					console.log("GoogleAuth.currentUser", GoogleAuth)
					GoogleAuth.currentUser.listen(onGoogleAccountChange)
				})
				.catch(MessageService.showToast)
				.finally(function(){
					vm.isProcessing = false;
				})
		}

		function onGoogleAccountChange(googleUser){
			console.log("onGoogleAccountChange", googleUser)
			if(!getCurrentGoogleUserDefer){
				getCurrentGoogleUserDefer = $q.defer();
			}

			getCurrentGoogleUserDefer.resolve(googleUser)
		}

		function signIn(){
			getCurrentGoogleUserDefer = $q.defer();
			var authResult;
			var currentGoogleUserEmail;

			vm.isProcessing = true;

			GoogleAuth.grantOfflineAccess()
				.then(function(_authResult){
					authResult = _authResult;
					return getCurrentGoogleUserDefer.promise;
				})
				.then(function(googleUser){
					currentGoogleUserEmail = googleUser.getBasicProfile().getEmail();

					var resourcePath = {
						companyID: companyID
					}

					var requestBody = {
						code:authResult.code,
						gmail:currentGoogleUserEmail
					}

					return GoogleService.authorizeGoogleService(resourcePath, requestBody);
				})
				.then(function(){
					vm.tokenInfo.email = currentGoogleUserEmail;
					$scope.$apply();
					vm.isProcessing = false;
				})
				.catch(function(error){
					MessageService.showToast(error);
					vm.isProcessing = false;
				});
		}
	}
})();
(function ()
{
	'use strict';

	angular
		.module('app.settings.customerportalslider')
		.service("customerPortalSliderService", customerPortalSliderService);

	/** @ngInject */
	function customerPortalSliderService($state ,api, ToolsFactory, Const, MessageService, $q, CustomerPortalSliderClass, LoginService, $resource, GeneralTools)
	{   

		var codeKey = Const.header.code;
		var messageKey = Const.header.message;
		var successCode = Const.code.success;
		const xhrStatusAbort = "abort";
		
		var header = {}
		header.token = LoginService.getToken();
		header["Cache-Control"] = "no-cache, no-store, must-revalidate";
		header["Pragma"] = "no-cache";
		header["Expires"] = 0;
		const baseUrl = GeneralTools.getBaseUrl();


		const customerPortalSlider = $resource(
			baseUrl + "companies/:companyID/customerportalslider/:customerportalsliderID",
			{
				companyID: "@companyID",
				customerportalsliderID: "@customerportalsliderID",
			},
			{
				getAllCustomerPortalSlider: {
					method: "GET",
					isArray: true,
					headers: header,
					cancellable: true,
					interceptor: {
						response: function (result) {
							var statusCode = result.headers(codeKey);

							if (statusCode != successCode) {
								var errorMessage = statusCode + ': ' + result.headers(messageKey);
								console.error("Failed to get All Customer Portal Sliders.");
								return $q.reject(errorMessage);
							}

							return result.data.map(function (data) {
								// var discount = new WorkOrderRDRedeemed();

								// discount.setAttributes(data);
								return data;
							});
						},
						responseError: function (error) {
							if (error && error.xhrStatus == xhrStatusAbort) {
								return $q.reject();
							}
							console.error("Failed to get All Customer Portal Sliders.");
							return $q.reject(error);
						}
					}
				},
				updateSlider: {
					method: "PUT",
					headers: {
						token: LoginService.getToken()
					}
				},
				deleteSlider: {
					method: "DELETE",
					headers: {
						token: LoginService.getToken()
					}
				}
			}
		);


		const customerPortalSliderV2 = $resource(
			baseUrl + "companies/:companyID/customerportalsliderV2/:customerportalsliderIDV2",
			{
				companyID: "@companyID",
				customerportalsliderIDV2: "@customerportalsliderIDV2",
			},
			{
				deleteSlider: {
					method: "POST",
					headers: {
						token: LoginService.getToken()
					}
				},
				createSlider: {
					method: "PUT",
					headers: {
						token: LoginService.getToken()
					}
				},
			}
		);


		this.getAllCustomerPortalSlider = function(resourcePath){	
			return customerPortalSlider.getAllCustomerPortalSlider(resourcePath);
		}

		this.getGivenCustomerPortalSlider = function(resourcePath){	
			return customerPortalSlider.getAllCustomerPortalSlider(resourcePath);
		}


		this.updateSlider = function(resourcePath, requestBody){
			var defer = $q.defer();
			customerPortalSlider.updateSlider(
				resourcePath,
				requestBody,
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);
						defer.reject(errorMessage);
						return;
					}

					defer.resolve(response.data);
				},
				function(error){
					console.error("Failed to update slider info.");
					defer.reject(error);
				}
			);

			return defer.promise;
		}


		this.DeleteSlider = function(resourcePath, requestBody){
			var defer = $q.defer();
			customerPortalSlider.deleteSlider(
				resourcePath,
				requestBody,
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);
						defer.reject(errorMessage);
						return;
					}

					defer.resolve(response.data);
				},
				function(error){
					console.error("Failed to Delete slider.");
					defer.reject(error);
				}
			);

			return defer.promise;
		}

		this.DeleteSliderV2 = function(resourcePath, requestBody){
			var defer = $q.defer();
			customerPortalSliderV2.deleteSlider(
				resourcePath,
				requestBody,
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);
						defer.reject(errorMessage);
						return;
					}

					defer.resolve(response.data);
				},
				function(error){
					console.error("Failed to Delete slider.");
					defer.reject(error);
				}
			);

			return defer.promise;
		}

		this.createSlider = function(resourcePath, requestBody){
			var defer = $q.defer();
			customerPortalSliderV2.createSlider(
				resourcePath,
				requestBody,
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);
						defer.reject(errorMessage);
						return;
					}

					defer.resolve(response.data);
				},
				function(error){
					console.error("Failed to create slider.");
					defer.reject(error);
				}
			);

			return defer.promise;
		}

	}
})();
(function ()
{
    'use strict';

    angular
        .module('app.settings.customerportalslider')
        .provider('customerPortalSliderTempValue', customerPortalSliderTempValue);

    /** @ngInject */
    function customerPortalSliderTempValue()
    {
        this.$get = function(){

            var provider = {
                setTempCompanyID:setTempCompanyID,
                getTempCompanyID:getTempCompanyID,
                setTempParttypesID:setTempParttypesID,
                getTempParttypesID:getTempParttypesID
            };

            function setTempCompanyID (companyID){
                window.localStorage.setItem("companyID",companyID);
            }
            function getTempCompanyID () {
                var companyID = window.localStorage.getItem("companyID")
                return companyID;
            }        
            
            function setTempParttypesID (parttypesID){
                window.localStorage.setItem("parttypesID",parttypesID);
            }
            function getTempParttypesID (){
                var parttypesID = window.localStorage.getItem("parttypesID")
                return parttypesID;
            }     

            return provider;             
        }
    }

})();
(function ()
{
	'use strict';

	angular
		.module("app.settings.customerportalslider")
		.factory("CustomerPortalSliderClass", CustomerPortalSliderClass)

	/** @ngInject */
	function CustomerPortalSliderClass()
	{	   
		function CustomerPortalSlider(){}

		CustomerPortalSlider.prototype.setAttributes = function (attributes) {
	 		if(attributes == null){
	 			return;
	 		}

	 		var keyList = Object.keys(attributes);

	 		for(var i = 0; i < keyList.length; i++){
	 			var key = keyList[i];
	 			var value = attributes[key];

	 			this.setAttribute(key, value);
	 		}
		}

		CustomerPortalSlider.prototype.setAttribute = function (key, value) {
	 		this[key] = value;
		}

		CustomerPortalSlider.prototype.getResourcePath= function () {
			var resourcePath = {};

			resourcePath.userID = this.id_user
			resourcePath.companyID = this.fk_id_company

	 		return resourcePath;
		}	

		CustomerPortalSlider.prototype.getResourceID = function () {
	 		return this.id_user;
		}	

		CustomerPortalSlider.prototype.getParentResourceID = function () {
	 		return this.fk_id_company;
		}					

		return CustomerPortalSliderClass;
	}


})();
(function ()
{
	'use strict';

	angular
		.module("app.settings.customerportalservicescatogory")
		.factory("CustomerPortalServicesCatogoryClass", CustomerPortalServicesCatogoryClass)

	/** @ngInject */
	function CustomerPortalServicesCatogoryClass()
	{	   
		function CustomerPortalServicesCatogoryClass(){}

		CustomerPortalServicesCatogoryClass.prototype.setAttributes = function (attributes) {
	 		if(attributes == null){
	 			return;
	 		}

	 		var keyList = Object.keys(attributes);

	 		for(var i = 0; i < keyList.length; i++){
	 			var key = keyList[i];
	 			var value = attributes[key];

	 			this.setAttribute(key, value);
	 		}
		}

		CustomerPortalServicesCatogoryClass.prototype.setAttribute = function (key, value) {
	 		this[key] = value;
		}

		CustomerPortalServicesCatogoryClass.prototype.getResourcePath= function () {
			var resourcePath = {};

			resourcePath.userID = this.id_user
			resourcePath.companyID = this.fk_id_company

	 		return resourcePath;
		}	

		CustomerPortalServicesCatogoryClass.prototype.getResourceID = function () {
	 		return this.id_user;
		}	

		CustomerPortalServicesCatogoryClass.prototype.getParentResourceID = function () {
	 		return this.fk_id_company;
		}					

		return CustomerPortalSliderClass;
	}


})();
(function ()
{
	'use strict';

	angular
		.module('app.settings.customerportalservicescatogory')
		.service("customerportalservicescatogoryService", customerportalservicescatogoryService);

	/** @ngInject */
	function customerportalservicescatogoryService($state ,api, ToolsFactory, Const, MessageService, $q, CustomerPortalSliderClass, LoginService, $resource, GeneralTools)
	{   

		var codeKey = Const.header.code;
		var messageKey = Const.header.message;
		var successCode = Const.code.success;
		const xhrStatusAbort = "abort";
		var header = {}
		header.token = LoginService.getToken();
		header["Cache-Control"] = "no-cache, no-store, must-revalidate";
		header["Pragma"] = "no-cache";
		header["Expires"] = 0;
		const baseUrl = GeneralTools.getBaseUrl();


		const customerPortalAppointmentServicesCatogory = $resource(
			baseUrl + "companies/:companyID/customerportalappointmentservicescatogory/:customerportalappointmentservicescatogoryID",
			{
				companyID: "@companyID",
				customerportalappointmentservicescatogoryID: "@customerportalappointmentservicescatogoryID",
			},
			{
				getCustomerPortalAppointmentServicesCatogory: {
					method: "GET",
					isArray: true,
					headers: header,
					cancellable: true,
					interceptor: {
						response: function (result) {
							var statusCode = result.headers(codeKey);

							if (statusCode != successCode) {
								var errorMessage = statusCode + ': ' + result.headers(messageKey);
								console.error("Failed to get All Customer Portal Appointment Services Catogory.");
								return $q.reject(errorMessage);
							}

							return result.data.map(function (data) {
								// var discount = new WorkOrderRDRedeemed();

								// discount.setAttributes(data);
								return data;
							});
						},
						responseError: function (error) {
							if (error && error.xhrStatus == xhrStatusAbort) {
								return $q.reject();
							}
							console.error("Failed to get All Customer Portal Appointment Services Catogory.");
							return $q.reject(error);
						}
					}
				},
				updateCustomerPortalAppointmentServicesCatogory: {
					method: "PUT",
					headers: {
						token: LoginService.getToken()
					}
				},
				deleteCustomerPortalAppointmentServicesCatogory: {
					method: "DELETE",
					headers: {
						token: LoginService.getToken()
					}
				},
				createCustomerPortalAppointmentServicesCatogory: {
					method: "POST",
					headers: {
						token: LoginService.getToken()
					}
				},
			}
		);


		this.getAllCustomerPortalAppointmentServicesCatogory = function(resourcePath){	
			return customerPortalAppointmentServicesCatogory.getCustomerPortalAppointmentServicesCatogory(resourcePath);
		}

		this.updateCustomerPortalAppointmentServicesCatogory = function(resourcePath, requestBody){
			var defer = $q.defer();
			customerPortalAppointmentServicesCatogory.updateCustomerPortalAppointmentServicesCatogory(
				resourcePath,
				requestBody,
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);
						defer.reject(errorMessage);
						return;
					}

					defer.resolve(response.data);
				},
				function(error){
					console.error("Failed to update Customer Portal Appointment Services Catogory info.");
					defer.reject(error);
				}
			);

			return defer.promise;
		}


		this.deleteCustomerPortalAppointmentServicesCatogory = function(resourcePath, requestBody){
			var defer = $q.defer();
			customerPortalAppointmentServicesCatogory.deleteCustomerPortalAppointmentServicesCatogory(
				resourcePath,
				requestBody,
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);
						defer.reject(errorMessage);
						return;
					}

					defer.resolve(response.data);
				},
				function(error){
					console.error("Failed to Delete slider.");
					defer.reject(error);
				}
			);

			return defer.promise;
		}

		this.createCustomerPortalAppointmentServicesCatogory = function(resourcePath, requestBody){
			var defer = $q.defer();
			customerPortalAppointmentServicesCatogory.createCustomerPortalAppointmentServicesCatogory(
				resourcePath,
				requestBody,
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);
						defer.reject(errorMessage);
						return;
					}

					defer.resolve(response.data);
				},
				function(error){
					console.error("Failed to update Customer Portal Appointment Services Catogory info.");
					defer.reject(error);
				}
			);

			return defer.promise;
		}

	}
})();
(function ()
{
    'use strict';

    angular
        .module('app.settings.customerportalservicescatogory')
        .provider('customerportalservicescatogoryTempValue', customerportalservicescatogoryTempValue);

    /** @ngInject */
    function customerportalservicescatogoryTempValue()
    {
        this.$get = function(){

            var provider = {
                setTempCompanyID:setTempCompanyID,
                getTempCompanyID:getTempCompanyID,
                setTempParttypesID:setTempParttypesID,
                getTempParttypesID:getTempParttypesID
            };

            function setTempCompanyID (companyID){
                window.localStorage.setItem("companyID",companyID);
            }
            function getTempCompanyID () {
                var companyID = window.localStorage.getItem("companyID")
                return companyID;
            }        
            
            function setTempParttypesID (parttypesID){
                window.localStorage.setItem("parttypesID",parttypesID);
            }
            function getTempParttypesID (){
                var parttypesID = window.localStorage.getItem("parttypesID")
                return parttypesID;
            }     

            return provider;             
        }
    }

})();
(function ()
{
	'use strict';

	angular
		.module('app.settings.coupon')
		.service("CouponService", CouponService);

	/** @ngInject */
	function CouponService($state, api, ToolsFactory, Const, MessageService, $q, Coupon)
	{   

		var codeKey = Const.header.code;
		var messageKey = Const.header.message;
		var successCode = Const.code.success;

		this.addCoupon = function (companyID, newCoupon, callback){
			newCoupon.companyID = companyID;
			api.coupon.addCoupon(
				newCoupon,
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);
						callback(errorMessage);
						return;
					}

					var newCouponID = response.data;
					callback(null, newCouponID);
				},
				function(error){
					var errorMessage = error.status + ': ' + error.statusText;
					callback(errorMessage);
				}
			);		  
		}		
		this.updateUser = function (userID, companyID, updateUser, callback){

			updateUser.companyID = companyID;
			updateUser.userID = userID;

			api.users.updateUser(
				updateUser,
				function(response,header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);
						callback(errorMessage);
						return;
					}

					callback(null, null);
				},
				function(error){
					var errorMessage = error.status + ': ' + error.statusText;
					callback(errorMessage);
				}
			);		  
		}

		this.deleteCoupon = function (coupontypeID, callback){
			api.coupon.deleteCoupon(
				{couponTypesID :coupontypeID.id_coupon_type,
					companyID:coupontypeID.fk_id_company
				},	
				function(response,header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);
						callback(errorMessage);
						return;
					}

					callback(null, coupontypeID);
				},
				function(error){
					var errorMessage = error.status + ': ' + error.statusText;
					callback(errorMessage);
				}
			);		  
		}		

		this.checkRoles = function(loginUserRoles, targetUserRoles){
			var result = false

			if(!Array.isArray(loginUserRoles)){
				return result;
			}
			if(!Array.isArray(targetUserRoles)){
				targetUserRoles = [];
			}

			for(var i = 0; i < targetUserRoles.length; i++){
				var targetUserRole = targetUserRoles[i]
				if(loginUserRoles.indexOf(targetUserRole) == -1){
					return result;
				}
			}
			return true;
		}

		this.checkAvailability= function(columnName, value, callback){
			api.check.checkExistence.check(
				{   
					tableName:"user",
					columnName:columnName,
					value:value
				},
				function(response, header){
					var statusCode  = header(codeKey);					
					if(statusCode != successCode){
						MessageService.showToast(statusCode + " : "+ header("message"));
						return;
					}					
					callback(!response.data)					
				},
				function(error){
					callback(false);
					console.log(error);
				}
			); 
		}

		this.getUsers = function(resourcePath, searchText){
			var defer = $q.defer();
			var paramInUrl = {};

			

			paramInUrl.companyID = resourcePath.companyID;
			paramInUrl.userID = resourcePath.userID;
			paramInUrl.searchText = searchText;

			api.users.getUsers(
				paramInUrl,
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);
						defer.reject(errorMessage);
						return;
					}

					var userList = [];

					response.forEach(function(data){
						var user = new User();

						user.setAttributes(data); 
						userList.push(user);
					})

					defer.resolve(userList);
				},
				function(error){
					console.error(error);
					defer.reject("Failed to get users");
				}
			);

			return defer.promise;
		}

		this.getCoupon = function(resourcePath, searchText){
			var defer = $q.defer();
			var paramInUrl = {};

			

			paramInUrl.companyID = resourcePath.companyID;
			paramInUrl.userID = resourcePath.userID;
			paramInUrl.searchText = searchText;

			api.coupon.getCoupon(
				paramInUrl,
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);
						defer.reject(errorMessage);
						return;
					}

					var couponList = [];

					response.forEach(function(data){
						var coupon = new Coupon();

						coupon.setAttributes(data); 
						couponList.push(coupon);
					})

					defer.resolve(couponList);
				},
				function(error){
					console.error(error);
					defer.reject("Failed to get coupon");
				}
			);

			return defer.promise;
		}

		this.getAllCoupon = function(){
			var defer = $q.defer();

			api.coupon(
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);
						defer.reject(errorMessage);
						return;
					}

					var userList = [];

					response.forEach(function(data){
						var user = new User();

						user.setAttributes(data); 
						userList.push(user);
					})

					defer.resolve(userList);
				},
				function(error){
					console.error(error);
					defer.reject("Failed to get Coupon");
				}
			);

			return defer.promise;
		}

		this.updateCoupon = function (coupondata, callback){
			coupondata.companyID = 1;
			coupondata.couponId = coupondata.id_coupon;

			api.coupon.updateCoupon(
				coupondata,	
				function(response,header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);
						callback(errorMessage);
						return;
					}

					callback(null, null);
				},
				function(error){
					var errorMessage = error.status + ': ' + error.statusText;
					callback(errorMessage);
				}
			);		  	
		}

		this.deleteCoupon = function (coupon, callback){
			api.coupon.deleteCoupon(
				{
					couponId:coupon.id_coupon,
					companyID:1
				},
				function(response,header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);
						callback(errorMessage);
						return;
					}
					callback(null, coupon);
				},
				function(error){
					var errorMessage = error.status + ': ' + error.statusText;
					callback(errorMessage);
				}
			);
		}
	}
})();
(function ()
{
    'use strict';

    angular
        .module('app.settings.coupon')
        .provider('couponTempValue', couponTempValue);

    /** @ngInject */
    function couponTempValue()
    {
        this.$get = function(){

            var provider = {

                setTempCompanyID:setTempCompanyID,
                getTempCompanyID:getTempCompanyID,
                setTempLabourID:setTempLabourID,
                getTempLabourID:getTempLabourID
            };

            function setTempCompanyID (companyID){
                window.localStorage.setItem("companyID",companyID);
            }
            function getTempCompanyID () {
                var companyID = window.localStorage.getItem("companyID")
                return companyID;
            }        
            
            function setTempLabourID (couponTypesID){
                window.localStorage.setItem("couponTypesID",couponTypesID);
            }
            function getTempLabourID (){
                var couponTypesID = window.localStorage.getItem("couponTypesID")
                return couponTypesID;
            }     

            return provider;             
        }
    }

})();
(function ()
{
	'use strict';

	angular
		.module("app.settings.coupon")
		.factory("Coupon", CouponClass)

	/** @ngInject */
	function CouponClass()
	{	   
		function Coupon(){}

		Coupon.prototype.setAttributes = function (attributes) {
	 		if(attributes == null){
	 			return;
	 		}

	 		var keyList = Object.keys(attributes);

	 		for(var i = 0; i < keyList.length; i++){
	 			var key = keyList[i];
	 			var value = attributes[key];

	 			this.setAttribute(key, value);
	 		}
		}

		Coupon.prototype.setAttribute = function (key, value) {
	 		this[key] = value;
		}

		Coupon.prototype.getResourcePath= function () {
			var resourcePath = {};

			resourcePath.userID = this.id_user
			resourcePath.companyID = this.fk_id_company

	 		return resourcePath;
		}	

		Coupon.prototype.getResourceID = function () {
	 		return this.id_user;
		}	

		Coupon.prototype.getParentResourceID = function () {
	 		return this.fk_id_company;
		}					

		return Coupon;
	}


})();
(function ()
{
	'use strict';

	angular
		.module("app.settings.warranty")
		.factory("Warranty", WarrantyClass)

	/** @ngInject */
	function WarrantyClass(WarrantyConstants)
	{	 
		function Warranty(){}

		Warranty.prototype.setAttributes = function (attributes) {
	 		if(attributes == null){
	 			return;
	 		}

	 		var keyList = Object.keys(attributes);

	 		for(var i = 0; i < keyList.length; i++){
	 			var key = keyList[i];
	 			var value = attributes[key];

	 			this.setAttribute(key, value);
	 		}
		}

		Warranty.prototype.setAttribute = function (key, value) {
	 		this[key] = value;
		}

		Warranty.prototype.getResourcePath= function () {
			var resourcePath = {};

			resourcePath.userID = this.id_user
			resourcePath.companyID = this.fk_id_company

	 		return resourcePath;
		}	

		// Warranty.prototype.setActiveExpiryDate = function (momentObj) {
	 	// 	if(momentObj && momentObj.isValid()){
		// 		this.active_expiry_date = momentObj.format(PresetPackageConstants.dateFormat);
		// 		return true;
		// 	}
		// 	this.active_expiry_date = null;
		// 	return false;
		// }	

		// Warranty.prototype.getActiveExpiryDateMomentObj = function (){
		// 	if(this.active_expiry_date){
		// 		return moment(this.active_expiry_date, PresetPackageConstants.dateFormat);
		// 	}
		// }

		// Warranty.prototype.isActive = function (){
		// 	const expiryDate = this.getActiveExpiryDateMomentObj();
		// 	if(!expiryDate){
		// 		return true;
		// 	}
		// 	const now = moment();

		// 	return now.isSameOrBefore(expiryDate, "Date");
		// }

		return Warranty;
	}


})();
(function ()
{
	'use strict';

	angular
		.module('app.settings.warranty')
		.service("WarrantyService", WarrantyService);

	/** @ngInject */
	function WarrantyService(LoginService, GeneralTools, Const, $q, MessageService, $filter, $resource, PresetPackage)
	{
		const baseUrl = GeneralTools.getBaseUrl();
		var codeKey = Const.header.code;
		var successCode = Const.code.success;
		const errMsgFailedToFetchWarranty = "Failed to fetch preset Warranty";
		const errMsgFailedToFetchNewWarrantyID = "Failed to fetch new preset Warranty ID";
		const baseHeader = GeneralTools.getBaseHeader();
		const noCacheHeader = GeneralTools.getNoCacheHeader();

		var header = {}
		header.token 			= LoginService.getToken();
		header["Cache-Control"] = "no-cache, no-store, must-revalidate";
		header["Pragma"] 		= "no-cache";
		header["Expires"] 		= 0;

		const warrantyApi = $resource(
			baseUrl + "companies/:companyID/warranties/:warrantyID",
			{	
				companyID:"@companyID",
				warrantyID:"@warrantyID"
			},
			{
				getWrranties:{
					method:"GET",
					isArray:true,
					headers: header
				},
				createWarranty:{
					method:"POST",
					headers: header
				},
				updateWarranty:{
					method:"PUT",
					headers: baseHeader,
					interceptor:{
						response: function(result){
							const statusCode  = result.headers(Const.header.code);

							if(result.headers(Const.header.code) != Const.code.success){
								console.error(statusCode, result.headers(Const.header.message));
								return $q.reject(errMsgFailedToFetchPackage);
							}

							return $q.resolve();
						},
						responseError: function (error){
							if(error && error.xhrStatus == Const.xhrStatus.abort){
								return $q.reject();
							}
							console.error(error);
							return $q.reject(error);
						}
					}
				},
				deleteWarranty:{
					method:"DELETE",
					headers: baseHeader,
					interceptor:{
						response: function(result){
							const statusCode  = result.headers(Const.header.code);

							if(result.headers(Const.header.code) != Const.code.success){
								console.error(statusCode, result.headers(Const.header.message));
								return $q.reject(errMsgFailedToFetchPackage);
							}

							return $q.resolve();
						},
						responseError: function (error){
							if(error && error.xhrStatus == Const.xhrStatus.abort){
								return $q.reject();
							}
							console.error(error);
							return $q.reject(error);
						}
					}
				}							
		});
		
		const warrantyfeatureAPI = $resource(
			baseUrl + "companies/:companyID/warrantyfeature/:warrantyfeatureID",
			{	
				companyID:"@companyID",
				warrantyID:"@warrantyfeatureID"
			},
			{
				getWarrantyfeature:{
					method:"GET",
					isArray:true,
					headers: header
				},
				createWarrantyfeature:{
					method:"POST",
					headers: header
				},
				deleteWarrantyFeature:{
					method:"DELETE",
					headers: baseHeader,
					interceptor:{
						response: function(result){
							const statusCode  = result.headers(Const.header.code);

							if(result.headers(Const.header.code) != Const.code.success){
								console.error(statusCode, result.headers(Const.header.message));
								return $q.reject(errMsgFailedToFetchPackage);
							}

							return $q.resolve();
						},
						responseError: function (error){
							if(error && error.xhrStatus == Const.xhrStatus.abort){
								return $q.reject();
							}
							console.error(error);
							return $q.reject(error);
						}
					}
				}						
		});

		this.getWarranty = function(resourcePath){
			return warrantyApi.getWrranties(resourcePath);
		}	

		this.createWarranty = function(resourcePath, callback){
			return warrantyApi.createWarranty(resourcePath,
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);
						callback(errorMessage);
						return;
					}

					var miscfeestypesID = response.data;
					callback(null, miscfeestypesID);
				},
				function(error){
					var errorMessage = error.status + ': ' + error.statusText;
					callback(errorMessage);
				});
		}

		this.updateWarranty = function(resourcePath, callback){
			return warrantyApi.updateWarranty(resourcePath,
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);
						callback(errorMessage);
						return;
					}

					var miscfeestypesID = response.data;
					callback(null, miscfeestypesID);
				},
				function(error){
					var errorMessage = error.status + ': ' + error.statusText;
					callback(errorMessage);
				});
		}

		this.deleteWarranty = function(resourcePath, callback){
			return warrantyApi.deleteWarranty(resourcePath,
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);
						callback(errorMessage);
						return;
					}

					callback(null, resourcePath);
				},
				function(error){
					var errorMessage = error.status + ': ' + error.statusText;
					callback(errorMessage);
				});
		}

		this.getWarrantyFeature = function(resourcePath){
			return warrantyfeatureAPI.getWarrantyfeature(resourcePath);
		}

		this.createWarrantyFeature = function(resourcePath){
			return warrantyfeatureAPI.createWarrantyfeature(resourcePath);
		}
		
		this.deleteWarrantyFeature = function(resourcePath, callback){
			return warrantyfeatureAPI.deleteWarrantyFeature(resourcePath);
		}
	}
})();
(function ()
{
	'use strict';

	angular
		.module('app.tasks', [])
		.constant("TaskConstants", {
			defaultLimitPerPage:20,
			defaultPage:1,

			notCompletedStatusFilterTag: "notCompleted",

			defaultSortDirection:"ASC",
			dueDateFormat:"YYYY-MM-DD",
			dueTimeFormat:"HH:mm:ss",
			createdDateFormatIgnoreTime:"YYYY-MM-DD",

			verifyFinanceDepositTaskName: "Verify Finance Deposit",
			confirmFundsInTheAccountTaskName: "Confirm funds in the account",
			deleteAdvertisementTaskName: "Delete Advertisement",
			purchaseWarrantyTaskName: "Purchase warranty",
			CreateTradeInFormTaskName:"Create a trade in form for vehicle traded in",
			tradeInLienPayoutTaskName:"Trade In Lien Payout",
			checkIfVehicleHasTradeInFormTaskName:"Check if this vehicle has a trade in form",

			newCarCleanTaskName:"New Car Clean",
			processVehicleTaskName:"Process Vehicle",
			newCarOilChangeTaskName:"New Car Oil Change",
			createFolderAndTagKeyTaskName:"Create Folder and Tag Key",

			taskStatusNotStartFk:1,
			taskStatusInProgressFk:2,
			taskStatusCompletedFk:3,

			taskCategoryBodyWorkFk:1,
			taskCategoryDetailFk:2,
			taskCategoryDocumentationFk:3,
			taskCategoryFinanceFk:4,
			taskCategoryMechanicFk:5,
			taskCategoryOtherFk:6,
			taskCategoryAdvertisingFk:7,
			taskCategoryAccessoryFk:8,
		})
		.config(config)
		.run(run)

	function run(msNavigationService, LoginService, UserService, TaskConstants){
		var taskTitle = "TASKS";

		var params = {
			userID:LoginService.getUserID(),
			companyID:LoginService.getCompanyID()
		};  

		UserService.getUsersOutstandingTask(params)
		.then(function(outstandingTask){
			if (outstandingTask) {
				taskTitle = "TASKS - (" + outstandingTask + ")";
			}

			msNavigationService.saveItem("tasks", {
				title : taskTitle,
				icon : "icon-car",
				weight: 3,
				requiredRoles:[]			 
			});
	

		});


		msNavigationService.saveItem('tasks.browse-tasks', {
			title: 'Browse Tasks',
			state: 'app.tasks',
			stateParams:{userId: LoginService.getUserID(), status:TaskConstants.notCompletedStatusFilterTag},
			requiredRoles:[]	
		});   

		msNavigationService.saveItem('tasks.add-task', {
			title: 'Add Task',
			state: 'app.add-task',
			requiredRoles:[]			 
		});	
	}

	/** @ngInject */
	function config($stateProvider)
	{	  

		$stateProvider
			.state('app.tasks', {
				url : '/tasks?searchText&userId&vehicleId&category&priority&status&location',
				reloadOnSearch : false,
				views	: {
					'content@app': {
						templateUrl: 'app/main/tasks/browse-tasks/browse-tasks.html',
						controller : 'BrowseTasksController as vm'
					}
				},
				resolve :{
					taskCategories:function(MessageService, TasksService){
						return TasksService.getCachedTaskCategories().catch(MessageService.showToast);
					},
					taskPriorities:function(MessageService, TasksService){
						return TasksService.getCachedTaskPriorities().catch(MessageService.showToast);
					},
					taskStatus:function(MessageService, TasksService){
						return TasksService.getCachedTaskStatus().catch(MessageService.showToast);
					},
					userOptions:function(MessageService, LoginService, UserService){
						var resourcePath = {companyID: LoginService.getCompanyID()};
						return UserService.getUsers(resourcePath, null).catch(MessageService.showToast);
					},
					locations:function(MessageService, LoginService, VehicleService, $q){
						return VehicleService.getCachedLocations({companyID: LoginService.getCompanyID()}).catch(MessageService.showToast);
					}
				}
			})
			.state('app.add-task', {
				url : '/addtask',
				views	: {
					'content@app': {
						templateUrl: 'app/main/tasks/add-task/add-task.html',
						controller : 'AddTasksController as vm'
					}
				},
				resolve :{
					taskCategories:function(MessageService, TasksService){
						return TasksService.getCachedTaskCategories().catch(MessageService.showToast);
					},
					taskPriorities:function(MessageService, TasksService){
						return TasksService.getCachedTaskPriorities().catch(MessageService.showToast);
					},
					taskStatus:function(MessageService, TasksService){
						return TasksService.getCachedTaskStatus().catch(MessageService.showToast);
					},
				},
				params:{
					newTask:null
				}
			})
			.state('app.edit-task', {
				url : '/edittask/{taskID}',
				views	: {
					'content@app': {
						templateUrl: 'app/main/tasks/edit-task/edit-task.html',
						controller : 'EditTasksController as vm'
					}
				},
				resolve :{
					taskToBeEdited:function($stateParams, MessageService, TasksService, LoginService){
						var resourcePath = {};
						resourcePath.companyID = LoginService.getCompanyID();
						resourcePath.taskID = $stateParams.taskID;

						return TasksService.getTasks(resourcePath, null).catch(MessageService.showToast);
					},
					taskFiles:function($stateParams, MessageService, TasksService, LoginService){
						var resourcePath = {};
						resourcePath.companyID = LoginService.getCompanyID();
						resourcePath.taskID = $stateParams.taskID;
						
						return TasksService.getTaskFiles(resourcePath).catch(MessageService.showToast);
					},
					taskCategories:function(MessageService, TasksService){
						return TasksService.getCachedTaskCategories().catch(MessageService.showToast);
					},
					taskPriorities:function(MessageService, TasksService){
						return TasksService.getCachedTaskPriorities().catch(MessageService.showToast);
					},
					taskStatus:function(MessageService, TasksService){
						return TasksService.getCachedTaskStatus().catch(MessageService.showToast);
					}
				}
			});
	}

})();
(function ()
{
	"use strict";

	angular
		.module("app.tasks")
		.component("taskFileUploader", {
				bindings:{
					fileUploader:'=',
					uploadedFiles:'=',
					onCopyLinkClick:'<',
					onDeleteClick:'<',
					removeFileFormQueue:'<'
				},
				templateUrl: "app/main/tasks/edit-task/task-file-uploader.html",
				controller: componentController,
		  		controllerAs: 'vm'
			});

		function componentController(FileUploadService, FileViewService){
			var vm = this;	

			vm.$onInit = initComponent;

			vm.getFileUrl = getFileUrl;

			function initComponent(){
				if(vm.fileUploader == null){
					vm.fileUploader = FileUploadService.getNewUploader();
				}
			}

			function getFileUrl(uuid){
				return FileViewService.generateUrlByUUID(uuid);
			}
		}
})();
(function ()
{
	'use strict';

	angular
		.module('app.tasks')
		.controller('EditTasksController', EditTasksController);

	function EditTasksController(TaskConstants, $state, MessageService, ProgressService, taskCategories, taskPriorities, taskStatus, taskToBeEdited, TasksService, LoginService, DialogService, FileUploadService, taskFiles, FileViewService, GeneralTools, VehicleConstants){   
		
		if(taskToBeEdited == null || !Array.isArray(taskToBeEdited.data)){
			MessageService.showToast("Task not found.");
			$state.go("app.homepage");
			return;
		}

		var vm = this;
		var confirmDeleteTaskString = "CONFIRM";

		vm.taskToBeEdited = taskToBeEdited.data[0];
		var originTask = angular.copy(vm.taskToBeEdited);

		vm.constants = {};
		vm.constants.taskCategories = taskCategories;
		vm.constants.taskPriorities = taskPriorities;
		vm.constants.taskStatus 	= taskStatus;
		vm.fileUploader = FileUploadService.getNewUploader();
		vm.fileUploader.filters.push(FileUploadService.getSizeFilter(20));
		vm.taskFiles = taskFiles;

		vm.saveChanges = saveChanges;
		vm.deleteTask = deleteTask;
		vm.deleteFile = deleteFile;
		vm.copyLinkToClipboard = copyLinkToClipboard;
 		vm.removeFileFormQueue = removeFileFormQueue;

		function saveChanges(){
			if(!vm.isTaskInfoFormValid()){
				MessageService.showToast("Please make sure all feild is valid!");
				return;
			}

			var reqBody = TasksService.putRequestBodyGenerator(originTask, vm.taskToBeEdited)

			if(Object.keys(reqBody).length <= 0){
				MessageService.showToast("No changes detected.");
				return;
			}

			ProgressService.setMode("indeterminate");
			ProgressService.isVisble(true);
			vm.isProcessingTask = true;

			TasksService.updateTask(reqBody, vm.taskToBeEdited.getResourcePath())
				.then(function(response){
					originTask = angular.copy(vm.taskToBeEdited);
					MessageService.showToast("Success");

					if(vm.taskToBeEdited.assigned_to_vehicle && vm.taskToBeEdited.assigned_to_vehicle.id_vehicle){
						$state.go("app.vehicle.tasks", {vehicleID: vm.taskToBeEdited.assigned_to_vehicle.id_vehicle});
						return;
					}

					if(Array.isArray(vm.taskToBeEdited.assigned_to_users) && vm.taskToBeEdited.assigned_to_users[0]){
						$state.go("app.tasks", {userId: vm.taskToBeEdited.assigned_to_users[0].id_user, status:TaskConstants.notCompletedStatusFilterTag});
						return;
					}
				})
				.catch(function(error){					
					MessageService.showToast(error);
				})
				.finally(function(){
					ProgressService.isVisble(false);
					vm.isProcessingTask = false;
				});
		}

		function deleteTask(){		
			var dialogOptions = {};

			dialogOptions.inputBoxPlaceHolder	= "Enter here";
			dialogOptions.cancelButtonString	= "CANCEL";
			dialogOptions.confirmButtonString	= "CONFIRM";
			dialogOptions.titleString			= "ARE YOU SURE TO DELETE THIS TASK";
			dialogOptions.contentString			= "Please Type \"" + confirmDeleteTaskString + "\" below:";

			dialogOptions.confirmCallback				= confirmDeleteTaskCallback;
			dialogOptions.enableConfirmButtonCallback	= enableDeleteTaskButtonCallback;

			DialogService.showConfirmDialog(dialogOptions);
		}

		function confirmDeleteTaskCallback(){
			ProgressService.setMode("indeterminate");
			ProgressService.isVisble(true);
			
			TasksService.deleteTask(vm.taskToBeEdited.getResourcePath())
				.then(function(response){
					MessageService.showToast("Success!");
					ProgressService.isVisble(false);
					$state.go("app.tasks");
				})
				.catch(function(error){
					MessageService.showToast(error);
					ProgressService.isVisble(false);
				});
		}

		function enableDeleteTaskButtonCallback(inputString){
			if(inputString === confirmDeleteTaskString){
				return true;
			}
			return false;
		}

		function deleteFile (file, index){
			var dialogOptions = {};

			dialogOptions.titleString = "Delete file";
			dialogOptions.contentString = "Are you sure to delete file " + file.file_name + '?';

			var confirmOption = {};

			confirmOption.optionName = "YES";
			confirmOption.onClick = function(){
				confirmDeleteFile(file, index);
				DialogService.close();
			}

			var cancelOption = {};

			cancelOption.optionName = "NO";
			cancelOption.onClick = function(){
				DialogService.close();
			}

			dialogOptions.options = [confirmOption, cancelOption];

			DialogService.showOptionsDialog(dialogOptions);
		}

		function confirmDeleteFile (file, index){
			ProgressService.setMode("indeterminate");
			ProgressService.isVisble(true);

			var resourcePath = {
				companyID: vm.taskToBeEdited.getResourcePath().companyID,
				taskID: vm.taskToBeEdited.getResourcePath().taskID,
				fileID: file.id_task_file
			}

			TasksService.deleteTaskFile(resourcePath) 
				.then(function(result){
					vm.taskFiles.splice(index, 1);
					MessageService.showToast("File is deleted!")
					ProgressService.isVisble(false);
				}).catch(function(error){
					ProgressService.isVisble(false);
					MessageService.showToast(error);
				});
		}

		function copyLinkToClipboard(uuid){
			MessageService.showToast("Link Copied!");
			GeneralTools.copyToClipboard(FileViewService.generateUrlByUUID(uuid));
		}

		vm.fileUploader.onAfterAddingFile = function(fileItem){				
			ProgressService.setMode("indeterminate");
			ProgressService.isVisble(true);
				
			fileItem.url = FileUploadService.getUrlForPostTaskFile(vm.taskToBeEdited.getResourcePath());
			fileItem.upload();
		}

		vm.fileUploader.onSuccessItem = function(item, response, status, headers){
			if(!FileUploadService.isUploadSuccess(headers)){
				ProgressService.isVisble(false);
				MessageService.showToast(headers.message);
				return;
			}

			var resourcePath = {
				companyID: vm.taskToBeEdited.getResourcePath().companyID,
				taskID: vm.taskToBeEdited.getResourcePath().taskID,
				fileID: response.data
			}

			TasksService.getTaskFiles(resourcePath) 
				.then(function(result){
					item.remove();
					vm.taskFiles.unshift(result[0]);
					MessageService.showToast("File is uploaded!")	
				})
				.catch(MessageService.showToast)
				.finally(function(){
					ProgressService.isVisble(false);	
				})
		}

		function removeFileFormQueue (fileItem){
			fileItem.remove();
		}
	}
})();

(function ()
{
	"use strict";

	angular
		.module("app.tasks")
		.component("tasksTable", {
				bindings:{
					onFilterChange:'<',
					constants: '<',
					userOptions:'<',
					filters:'=',
					onMultipleFinished: '='
				},
				templateUrl: "app/main/tasks/browse-tasks/tasks-table.html",
				controller: componentController,
		  		controllerAs: 'vm'
			});

		function componentController($stateParams, $state, $scope, $filter, UserService, MessageService, LoginService, TasksService, ProgressService, VehicleConstants, GeneralTools, TaskConstants, $q, DialogService, UserConfigService){
			const vm = this;
			const isLoggedIn = LoginService.isLoggedIn();
			const companyID = LoginService.getCompanyID();
			const userID = LoginService.getUserID();
			const equalOperator = "eq";
			const lessThanOperator = "lt";
			const greaterThanOperator = "gt";
			const completedStatus = 3;
			const deleteSaleInfoConfirmString = "CONFIRM";

			var userConfig;
			
			vm.notCompletedTag = "notCompleted";

			vm.$onInit = initComponent;

			vm.getVehicleName = getVehicleName;
			vm.getVehicleVin = getVehicleVin;
			vm.getCategoryName = getCategoryName;
			vm.getPriorityName = getPriorityName;
			vm.getStatusName = getStatusName;
			vm.getTaskName = getTaskName;
			vm.getDueDate = getDueDate;
			vm.getDueTime = getDueTime;
			vm.getTaskPageUrl = getTaskPageUrl;
			vm.getVehiclePageUrl = getVehiclePageUrl;
			vm.getPriorityColor = getPriorityColor;
			vm.getStatusIcon = getStatusIcon;
			vm.getVehicleLocation = getVehicleLocation;

			vm.retrieveTaskList = retrieveTaskList;
			vm.selectAll = selectAll;
			vm.completeMultipleTasks = completeMultipleTasks;
			vm.deleteMultipleTasks = deleteMultipleTasks;

			vm.saveCustomFilter = saveCustomFilter;
			vm.deleteCustomFilter = deleteCustomFilter;
			vm.applyCustomFilter = applyCustomFilter;
			vm.isVechileIdSpecified = isVechileIdSpecified;

			function initComponent(){			
				initDisplayOption();
				initFilter();

				if(!isVechileIdSpecified()){
					initCustomFilters();
				}

				retrieveTaskList();
			}

			function initFilter(){
				if(!vm.filters){
					vm.filters = {}
				}
			}

			function initCustomFilters(){
				vm.customFilters = [];

				vm.isProcessingFilter = true;

				const resourcePath = {
					companyID: companyID,
					userID: userID
				};

				UserConfigService.getUserConfig(resourcePath)
					.then(function(_userConfig){
						userConfig = _userConfig;
						const customFilters = userConfig.getCustomTaskFilterList();

						if(Array.isArray(customFilters)){
							vm.customFilters = customFilters
						}
					})
					.catch(MessageService.showToast)
					.finally(function(){
						vm.isProcessingFilter = false;
					});
			}

			function saveCustomFilter(filterName){
				if(!filterName){
					MessageService.showToast("Filter name can not be empty.");
					return;
				}

				if(!userConfig){
					MessageService.showToast("UserConfig invalid.");
					return;
				}

				const filter = {
					searchText: vm.filters.searchText,
					userID: vm.filters.userId,
					category: vm.filters.category,
					status: vm.filters.status,
					priority: vm.filters.priority,
					location: vm.filters.location,
				}

				vm.customFilters.push({name:filterName, filter:filter});

				userConfig.setCustomTaskFilterList(vm.customFilters);
				updatePageConfig(userConfig);
			}

			function updatePageConfig(userConfig){
				if(!userConfig){
					MessageService.showToast("Failed to update page config, param invalid");
					return;
				}
					
				const resourcePath = {
					companyID: companyID,
					userID: userID
				};

				const requestBody = {
					config: userConfig.config
				}

				vm.isProcessingFilter = true;

				UserConfigService.updateUserConfig(resourcePath, requestBody)
					.catch(MessageService.showToast)
					.finally(function(){
						vm.isProcessingFilter = false;
					});
			}

			function deleteCustomFilter(index){
				if(!Array.isArray(vm.customFilters) || !userConfig){
					MessageService.showToast("Failed to delete, param invalid.");
					return;
				}

				vm.customFilters.splice(index, 1);
			
				userConfig.setCustomTaskFilterList(vm.customFilters);
				updatePageConfig(userConfig);
			}

			function applyCustomFilter(filterObj){
				if(!filterObj || !filterObj.filter || !vm.filters){
					MessageService.showToast("Can not apply invalid filter.");
					return;
				}

				vm.filters.searchText = filterObj.filter.searchText;
				vm.filters.userId = filterObj.filter.userID;
				vm.filters.category = filterObj.filter.category;
				vm.filters.status = filterObj.filter.status;
				vm.filters.priority = filterObj.filter.priority;
				vm.filters.location = filterObj.filter.location;

				retrieveTaskList();
			}

			function initDisplayOption(){
				vm.displayOptions = [20, 50, 100];
				vm.itemsPerPage = vm.displayOptions[0];
			}

			function selectAll(){
				var idList = Object.keys(vm.selectedTaskList);

				idList.forEach(function(taskID){
					vm.selectedTaskList[taskID] = vm.allChecked;
				});
			}

			function resetSelectedTasks(){
				if(!Array.isArray(vm.tasks)){
					return;
				}
				vm.allChecked = false;
				vm.selectedTaskList = {};

				vm.tasks.forEach(function(task){
					vm.selectedTaskList[task.id_task] = false;
				});
			}

			function retrieveTaskList(pageToGo){
				var resourcePath = { companyID: companyID };
				vm.isFetchingTaskData = true;

				TasksService.getTasks(resourcePath, getFilter(), getPagination(pageToGo))
					.then(function(result){
						if(result == null){
							return $q.reject("Task data is invalid.");
						}

						vm.tasks = result.data;
						resetSelectedTasks();
						resetPagination(extractPaginationFromResponseHeader(result.headerGetter));
					})
					.catch(MessageService.showToast)
					.finally(function(){
						vm.isFetchingTaskData = false;
					});
			}

			function getPagination(pageToGo){	
				var pagination = {};

				var pageNumber = parseInt(pageToGo);
				var itemsPerPageNumber = parseInt(vm.itemsPerPage);

				if(isNaN(pageNumber)){
					pageNumber = TaskConstants.defaultPage;
				}

				if(isNaN(itemsPerPageNumber)){
					itemsPerPageNumber = TaskConstants.defaultLimitPerPage;
				}

				pagination.page = pageNumber;
				pagination.limit = itemsPerPageNumber;

				return pagination;
			}

			function resetPagination(pagination){
				vm.totalTask = pagination.totalItem;
				vm.totalPage = Math.ceil(pagination.totalItem / pagination.itemsPerPage);

				vm.currentPage = pagination.currentPage;

				vm.pagesBeforeCurrentPage = getPagesBeforeCurrentPage(vm.currentPage);
				vm.pagesAfterCurrentPage = getPagesAfterCurrentPage(vm.totalPage, vm.currentPage);
			}

			function getPagesBeforeCurrentPage (currentPage) {
				var pageNumbers = [];

				for(var i = 5; i > 0; i--){
					var pageNumber = currentPage - i;
					if( pageNumber > 0){
						pageNumbers.push(pageNumber);
					}
				}

				return pageNumbers;
			}

			function getPagesAfterCurrentPage (tatalPages, currentPage) {
				var pageNumbers = [];

				for(var i = 1; i <= 5; i++){
					var pageNumber = currentPage + i;
					if( pageNumber <= tatalPages){
						pageNumbers.push(pageNumber);
					}
				}
				return pageNumbers;
			}

			function extractPaginationFromResponseHeader(headerGetter){
				var pagination = {};

				pagination.currentPage = parseInt(headerGetter("pagination-page"));
				pagination.totalItem = parseInt(headerGetter("pagination-total-item"));
				pagination.itemsPerPage = parseInt(headerGetter("pagination-limit"));

				return pagination;
			}

			function getFilter(){
				var filterString = '';

				var searchTextFilter 	= buildSearchTextFilterString("name", vm.filters.searchText);
				var assignUserFilter 	= buildOperatorFilterString("fk_id_user", vm.filters.userId, equalOperator);
				var categoryFilter 		= buildOperatorFilterString("fk_id_task_category", vm.filters.category, equalOperator);
				var priorityFilter 		= buildOperatorFilterString("fk_id_task_priority", vm.filters.priority, equalOperator);
				var vehicleFilter 		= buildOperatorFilterString("id_vehicle", vm.filters.vehicleId, equalOperator);
				var locationFilter	 	= buildOperatorFilterString("fk_id_location", vm.filters.location, equalOperator);
				var statusFilter 		= '';

				if(vm.filters.status == vm.notCompletedTag){
					var notStartFilter = buildOperatorFilterString("fk_id_task_status", 1, equalOperator);
					var inPorgStartFilter = buildOperatorFilterString("fk_id_task_status", 2, equalOperator);

					statusFilter = GeneralTools.stringConnector(statusFilter, notStartFilter, " OR ");
					statusFilter = GeneralTools.stringConnector(statusFilter, inPorgStartFilter, " OR ");
					statusFilter = '(' + statusFilter + ')';
				}else{
					statusFilter = buildOperatorFilterString("fk_id_task_status", vm.filters.status, equalOperator);
				}

				filterString = GeneralTools.stringConnector(filterString, searchTextFilter, " AND ");
				filterString = GeneralTools.stringConnector(filterString, assignUserFilter, " AND ");
				filterString = GeneralTools.stringConnector(filterString, categoryFilter, " AND ");
				filterString = GeneralTools.stringConnector(filterString, priorityFilter, " AND ");
				filterString = GeneralTools.stringConnector(filterString, statusFilter, " AND ");
				filterString = GeneralTools.stringConnector(filterString, locationFilter, " AND ");
				filterString = GeneralTools.stringConnector(filterString, vehicleFilter, " AND ");

				if(vm.onFilterChange){
					vm.onFilterChange(vm.filters);
				}
				
				return { filters: filterString };
			}

			function isVechileIdSpecified(){
				return vm.filters && !isNaN(parseInt(vm.filters.vehicleId));
			}

			function buildSearchTextFilterString(key, value){
				if(value != null){
					value = value.toString();
				}

				if(typeof(key) != "string" || key.trim() == '' ||
					typeof(value) != "string" || value.trim() == ''){
					return '';
				}

				return "CONTAINS(" + key + " , '" + value + " ')";
			}

			function buildOperatorFilterString(key, value, operator){
				if(value != null){
					value = value.toString();
				}

				if(typeof(key) != "string" || key.trim() == '' ||
					typeof(value) != "string" || value.trim() == '' ||
					typeof(operator) != "string" || operator.trim() == ''){
					return '';
				}

				return '(' + key + ' ' + operator + ' ' + value + ')';
			}

			function getTaskPageUrl(task){
				return $state.href('app.edit-task', {taskID: task.getResourceId()}, {absolute: true}); 
			}

			function getVehiclePageUrl(vehicle){
				return $state.href('app.vehicle.tasks', {vehicleID: vehicle.id_vehicle}); 
			}

			function getTaskName (task){
				if(task == null || task.name == null || task.name.trim() == ''){
					return "Unkown";
				}

				return task.name;
			}

			function getStatusName(statusID){
				var statusObj = vm.constants.taskStatus.find(function(status){
					return status.id_task_status == statusID;
				})

				if(statusObj == null){
					return "Unkown Status";
				}

				return statusObj.name;
			}

			function getCategoryName(categoryID){
				var categoryObj = vm.constants.taskCategories.find(function(category){
					return category.id_task_category == categoryID;
				})

				if(categoryObj == null){
					return "Unkown Category";
				}

				return categoryObj.name;
			}

			function getPriorityName(priorityID){
				var priorityObj = vm.constants.taskPriorities.find(function(priority){
					return priority.id_task_priority == priorityID;
				})

				if(priorityObj == null){
					return "Unkown Priority";
				}

				return priorityObj.name;
			}

			function getPriorityColor (priorityID){
				var priorityObj = vm.constants.taskPriorities.find(function(priority){
					return priority.id_task_priority == priorityID;
				});

				if(priorityObj == null || priorityObj.value == null){
					return;
				}

				var style = {}
				var greenColorValue = priorityObj.value * 120;

				style["background-color"] = "rgb(255, " + greenColorValue + ", 0)"
				return style;
			}	

			function getStatusIcon (statusID){
				var statusObj = vm.constants.taskStatus.find(function(status){
					return status.id_task_status == statusID;
				});

				switch(statusObj.value){
					case 0:
						return ['icon-calendar-clock'];
					case 1:
						return ['icon-timer-sand text-blue'];					
					case 2:
						return ['icon-checkbox-marked-circle text-green'];
				}
			}	

			function getDueDate(task){
				if(task == null || task.due_date == null || task.due_date.trim() == ''){
					return "N/A";
				}

				return task.due_date;
			}

			function getDueTime(task){
				var dueTime = moment(task.due_time, "HH:mm:ss");

				if(task == null || task.due_date == null || task.due_date.trim() == '' || !dueTime.isValid()){
					return '';
				}

				return dueTime.format("h:mm a");
			}

			function getVehicleName(vehicle){
				if(vehicle == null){
					return;
				}

				if((vehicle.year == null) &&
					(vehicle.make == null || vehicle.make.trim() == '') &&
					(vehicle.model == null || vehicle.model.trim() == '')){
					return "N/A";
				}
					
				return vehicle.year + " " + vehicle.make + " " + vehicle.model;
			}

			function getVehicleVin(vehicle){
				if(vehicle == null){
					return;
				}

				if(vehicle.vin == null || vehicle.vin.trim() == ''){
					return "N/A";
				}

				return vehicle.vin
			} 

			function completeMultipleTasks(){
				if(!vm.selectedTaskList || !Array.isArray(vm.tasks)){
					MessageService.showToast("Tasks data invalid")
					return;
				}

				var queue = [];

				vm.tasks.forEach(function(task){
					if(vm.selectedTaskList[task.id_task] && task.fk_id_task_status != completedStatus){
						queue.push(updateTaskStatus(task.id_task, completedStatus));
					}
				});

				if(queue.length <= 0){
					MessageService.showToast("No task selected or all Selected tasks are completed");
					return;
				}

				ProgressService.setMode("indeterminate");
				ProgressService.isVisble(true);
				vm.isProcessingTask = true;

				$q.all(queue)
					.then(function(){
						retrieveTaskList();
						if(vm.onMultipleFinished){
							vm.onMultipleFinished();
						}
					})
					.catch(MessageService.showToast)
					.finally(function(){
						ProgressService.isVisble(false);
						vm.isProcessingTask = false;
					});
			}

			function updateTaskStatus(taskID, status){
				var defer = $q.defer();
				var requestBody = { fk_id_task_status: status};
				var resourcePath = { companyID: companyID, taskID: taskID}

				TasksService.updateTask(requestBody, resourcePath)
					.then(function(){					
						var taskToUpdate = vm.tasks.find(function(task){
							return task.id_task == taskID;
						});

						taskToUpdate.fk_id_task_status = status;

						defer.resolve();
					})
					.catch(function(error){
						defer.reject(error);
					});

				return defer.promise;
			}

			function deleteMultipleTasks (){
				var dialogOptions = {};
				var numberOfSelectedTasks = 0;

				vm.tasks.forEach(function(task){
					if(vm.selectedTaskList[task.id_task]){
						numberOfSelectedTasks++;
					}
				});

				if(numberOfSelectedTasks <= 0){
					MessageService.showToast("No tasks selected")
					return;
				}

				dialogOptions.inputBoxPlaceHolder	= "Enter here";
				dialogOptions.cancelButtonString	= "CANCEL";
				dialogOptions.confirmButtonString	= "CONFIRM";
				dialogOptions.titleString			= "Are you sure to delete " + numberOfSelectedTasks + " task(s)";
				dialogOptions.contentString			= "Please Type \"" + deleteSaleInfoConfirmString + "\" below:";

				dialogOptions.confirmCallback				= confirmDeleteMultipleTasks;
				dialogOptions.enableConfirmButtonCallback	= enableDeleteMultipleTasksButtonCallback;

				DialogService.showConfirmDialog(dialogOptions);
			}

			function enableDeleteMultipleTasksButtonCallback(inputString){
				return inputString === deleteSaleInfoConfirmString;
			}

			function confirmDeleteMultipleTasks(){
				if(!vm.selectedTaskList || !Array.isArray(vm.tasks)){
					MessageService.showToast("Tasks data invalid")
					return;
				}

				var queue = [];

				vm.tasks.forEach(function(task){
					if(vm.selectedTaskList[task.id_task]){
						queue.push(deleteTask(task.id_task));
					}
				});

				if(queue.length <= 0){
					MessageService.showToast("No task selected");
					return;
				}

				ProgressService.setMode("indeterminate");
				ProgressService.isVisble(true);
				vm.isProcessingTask = true;

				$q.all(queue)
					.then(function(){
						retrieveTaskList();
						if(vm.onMultipleFinished){
							vm.onMultipleFinished();
						}
					})
					.catch(MessageService.showToast)
					.finally(function(){
						ProgressService.isVisble(false);
						vm.isProcessingTask = false;
					});
			}

			function deleteTask(taskID){
				var defer = $q.defer();
				var resourcePath = { companyID: companyID, taskID: taskID}

				TasksService.deleteTask(resourcePath)
					.then(function(){		
						var indexToRemove;			
						vm.tasks.forEach(function(task, index){
							if(task.id_task == taskID){
								indexToRemove = index;
							}
						});

						vm.tasks.splice(indexToRemove, 1);
						defer.resolve();
					})
					.catch(function(error){
						defer.reject(error);
					});

				return defer.promise;
			}

			function getVehicleLocation(locationID){
				if(!vm.constants || !Array.isArray(vm.constants.locations)){
					return "Unkown Location";
				}

				const matchedLocation = vm.constants.locations.find(function(location){
					return location && location.id_location == locationID;
				});

				return matchedLocation;			
			}
		}
})();
(function ()
{
	'use strict';

	angular
		.module('app.tasks')
		.controller('BrowseTasksController', BrowseTasksController);

	function BrowseTasksController($location, $stateParams, $state, MessageService, ProgressService, taskCategories, taskPriorities, taskStatus, DialogService, TasksService, userOptions, locations){   
		var vm = this;
		vm.onFilterChange = onFilterChange;

		init();

		function init(){
			initFilter();
			initConstants();
		}

		function initFilter(){
			vm.filters = $stateParams
		}

		function onFilterChange(filters){
			$location.search(filters).replace();
		}

		function initConstants(){
			vm.userOptions = userOptions;
			vm.constants = {};
			vm.constants.taskCategories = taskCategories;
			vm.constants.taskPriorities = taskPriorities;
			vm.constants.taskStatus = taskStatus;
			vm.constants.locations = locations;
		}
	}
})();
(function ()
{
	'use strict';

	angular
		.module('app.tasks')
		.controller('AddTasksController', AddTasksController);

	function AddTasksController(TaskConstants, $q, $state, MessageService, ProgressService, taskCategories, taskPriorities, taskStatus, Task, TasksService, LoginService, FileUploadService, $stateParams, VehicleConstants){   
		var vm = this;
		var fileUploadTask = $q.defer();
		var newTaskID;

		vm.createTask = createTask;
		vm.cancle = cancle;
		vm.removeFileFormQueue = removeFileFormQueue;

		init();

		function init(){
			initNewTask();
			initConstants();
			initFileUploader();
		}

		function initNewTask(){
			if($stateParams.newTask == null){
				vm.task = new Task();
			}else{
				vm.task = $stateParams.newTask;
			}
		}

		function initConstants(){
			vm.constants = {};
			vm.constants.taskCategories = taskCategories;
			vm.constants.taskPriorities = taskPriorities;
			vm.constants.taskStatus = taskStatus;
		}

		function initFileUploader(){
			vm.uploadedFiles = [];
			vm.fileUploader = FileUploadService.getNewUploader();
			vm.fileUploader.filters.push(FileUploadService.getSizeFilter(20));
		}

		function createTask(){
			if(!vm.isTaskInfoFormValid()){
				MessageService.showToast("Please make sure all feild is valid!");
				return;
			}

			var resourcePath = { companyID: LoginService.getCompanyID() };			
			var requestBody = TasksService.postRequestBodyGenerator(vm.task);

			ProgressService.setMode("indeterminate");
			ProgressService.isVisble(true);
			vm.isProcessingTask = true;

			TasksService.createTask(resourcePath, requestBody)
				.then(function(response){
					newTaskID = response;
					return performFileUploadTask(response);
				})
				.then(function(response){
					MessageService.showToast("Success!");

					if(vm.task.assigned_to_vehicle && vm.task.assigned_to_vehicle.id_vehicle){
						$state.go("app.vehicle.tasks", {vehicleID: vm.task.assigned_to_vehicle.id_vehicle});
						return;
					}

					if(Array.isArray(vm.task.assigned_to_users) && vm.task.assigned_to_users[0]){
						$state.go("app.tasks", {userId: vm.task.assigned_to_users[0].id_user});
						return;
					}

					$state.go("app.edit-task", {taskID: newTaskID})
				})
				.catch(function(error){
					console.error(error);
					vm.isProcessingTask = false;
					MessageService.showToast("Error! Failed To Create Tasks")
				})
				.finally(function(){
					ProgressService.isVisble(false);				
				});
		}

		function performFileUploadTask (newTaskID){
			if(vm.fileUploader.queue.length <= 0){
				return $q.all([]);
			}

			var resourcePath = {
				companyID:LoginService.getCompanyID(),
				taskID:newTaskID
			}

			vm.fileUploader.queue.forEach(function(fileItem){
				fileItem.url = FileUploadService.getUrlForPostTaskFile(resourcePath);
			})
			
			vm.fileUploader.uploadAll();

			return $q.all([fileUploadTask.promise]);
		}

		vm.fileUploader.onSuccessItem = function(fileItem, response, status, headers){
			if(!FileUploadService.isUploadSuccess(headers)){
				MessageService.showToast(headers.message);
				return;
			}

			vm.uploadedFiles.push({file_name: fileItem.file.name})
			fileItem.remove();
		}

		vm.fileUploader.onCompleteAll = function(){
			fileUploadTask.resolve();
		}

		function removeFileFormQueue (fileItem){
			fileItem.remove();
		}

		function cancle(){
			$state.go("app.tasks");
		}
	}
})();
(function ()
{
	"use strict";

	angular
		.module("app.saleInfo")
		.component("saleSummary", {
				bindings:{
					vehicle:'=',
					saleInfo:'=',
					warranty:'=',
					saleExtras:'=',	
					salePackages:'=',
					tradeInVehicle:'=',
					promotions:'=',
					payments:'=',
					plateOptions:'<',
					onAnchorClicked: '<',
					ignoreOptions:'<',
					hideEye:'<'
				},
				templateUrl: "app/main/sale-info/components/sale-summary.html",
				controller: componentController,
		  		controllerAs: 'vm'
			});

		function componentController($scope, GeneralTools, SaleCalculator, SaleInfoConstants){
			var vm = this;	
			var saleCalculator = new SaleCalculator();

			vm.generalAnchor = SaleInfoConstants.saleInfoSummaryAnchors.GENERAL;
			vm.warrantyAnchor = SaleInfoConstants.saleInfoSummaryAnchors.WARRANTY;
			vm.paymentsAnchor = SaleInfoConstants.saleInfoSummaryAnchors.PAYMENTS;
			vm.tradeInAnchor = SaleInfoConstants.saleInfoSummaryAnchors.TRADE_IN;
			vm.extrasAnchor = SaleInfoConstants.saleInfoSummaryAnchors.EXTRAS;
			vm.packagesAnchor = SaleInfoConstants.saleInfoSummaryAnchors.PACKAGES;
			vm.promotionsAnchor = SaleInfoConstants.saleInfoSummaryAnchors.PROMOTIONS;
			vm.financingAnchor = SaleInfoConstants.saleInfoSummaryAnchors.FINANCING;
			vm.showNetFund = true; 
			vm.$onInit = onInit;
			vm.$postLink = postLink;

			function onInit(){			
				updateSummary();
			}

			function postLink(){
				$scope.$watch("vm.saleInfo.sale_price", updateSummary);
				$scope.$watch("vm.saleInfo.tax_rate", updateSummary);
				$scope.$watch("vm.saleInfo.finance_application_fee", updateSummary);
				$scope.$watch("vm.saleInfo.lien_registration", updateSummary);
				$scope.$watch("vm.saleInfo.bank_admin_fee", updateSummary);
				$scope.$watch("vm.saleInfo.licensing_fee", updateSummary);
				$scope.$watch("vm.saleInfo.cost_of_borrowing", updateSummary);
				$scope.$watch("vm.saleInfo.interest_rate", updateSummary);
				$scope.$watch("vm.saleInfo.dealer_reserve", updateSummary);
				$scope.$watch("vm.warranty.retail", updateSummary);
				$scope.$watch("vm.saleExtras.length", updateSummary);
				$scope.$watch("vm.salePackages.length", updateSummary);
				$scope.$watch("vm.tradeInVehicle.trade_in_price", updateSummary);
				$scope.$watch("vm.tradeInVehicle.trade_lien_payout", updateSummary);
				$scope.$watch("vm.promotions.length", updateSummary);
				$scope.$watch("vm.payments.length", updateSummary);
				$scope.$watch("vm.ignoreOptions", updateSummary, true);
			}
			
			function inputFinancingInfoToCalculator(saleInfo, calculator){
				calculator.setFinanceApplicationFee(saleInfo.finance_application_fee);
				calculator.setLienRegistrationFee(saleInfo.lien_registration);
				calculator.setBankAdminFee(saleInfo.bank_admin_fee);
				calculator.setCostOfBorrowing(saleInfo.cost_of_borrowing);
				calculator.setDealerReserve(saleInfo.dealer_reserve);
			}

			function updateSummary(){
				if(!vm.ignoreOptions){
					vm.ignoreOptions = {}
				}
				
				if(vm.saleInfo != null){
					saleCalculator.setSalePrice(vm.saleInfo.sale_price);
					saleCalculator.setOmvic(vm.saleInfo.omvic);
					saleCalculator.setTaxRate(vm.saleInfo.tax_rate);
					saleCalculator.setLicensingPrice(vm.saleInfo.licensing_fee);

					if(vm.ignoreOptions.financing){
						const saleInfoCopy = angular.copy(vm.saleInfo);
						saleInfoCopy.clearFinancingInfos();
						inputFinancingInfoToCalculator(saleInfoCopy, saleCalculator);
					} else {
						inputFinancingInfoToCalculator(vm.saleInfo, saleCalculator);
					}
				}

				if(vm.warranty != null && !vm.ignoreOptions.warranty){
					saleCalculator.setWarrantyPrice(vm.warranty.retail);
				}else{
					saleCalculator.setWarrantyPrice(null);	
				}

				if(vm.tradeInVehicle != null && !vm.ignoreOptions.tradeIn){
					saleCalculator.setTradeInPrice(vm.tradeInVehicle.trade_in_price);	
					saleCalculator.setTradeLienPayout(vm.tradeInVehicle.trade_lien_payout);
				}else{
					saleCalculator.setTradeInPrice(null);	
					saleCalculator.setTradeLienPayout(null);
				}

				if(vm.ignoreOptions.packages){
					saleCalculator.setSalePackages([]);
				} else {	
					saleCalculator.setSalePackages(vm.salePackages);
				}

				if(vm.ignoreOptions.extras){
					saleCalculator.setSaleExtras([]);		
				} else {
					saleCalculator.setSaleExtras(vm.saleExtras);
				}

				if(vm.ignoreOptions.promotions){
					saleCalculator.setPromotions([]);
					saleCalculator.setSaleDiscount(0);
				} else {
					saleCalculator.setPromotions(vm.promotions);
				}

				if(vm.ignoreOptions.payments){
					saleCalculator.setPayments([]);
				} else {
					saleCalculator.setPayments(vm.payments);
				}

				
				vm.discountDetails = saleCalculator.getTotalPromotionsDiscountDetailList();
				vm.subTotalBeforeTradeIn = saleCalculator.getSubTotalBeforeTradeIn();
				vm.hst = saleCalculator.getTax();
				vm.licensingPrice = saleCalculator.getLicensingPrice();
				vm.omvic = saleCalculator.getOmvic();

				vm.subTotalBeforePayments = saleCalculator.getSubTotalBeforePayments();

				vm.totalAmountToBeFinanced = saleCalculator.getTotalAmountToBeFinanced();

				vm.totalBalanceDue = saleCalculator.getTotalBalanceDue();

				vm.totalToBeDeposited = saleCalculator.getTotalToBeDeposited();

				vm.totalOwning = saleCalculator.getTotalOwning();
			}

			vm.toggleNetFund = function() {
				vm.showNetFund = !vm.showNetFund;

				if(vm.tradeInVehicle && vm.tradeInVehicle.trade_lien_payout && !vm.ignoreOptions.tradeIn){
					if(vm.showNetFund && vm.tradeInVehicle.trade_in_price){
						vm.tradeInVehicle.trade_in_price = vm.tradeInVehicle.trade_in_price * 2;
						updateSummary();
	
					}else{
						vm.tradeInVehicle.trade_in_price = vm.tradeInVehicle.trade_in_price / 2;
						updateSummary();
					}
				}else{
					return;
				}

			};
		}
})();
(function ()
{
	"use strict";

	angular
		.module("app.saleInfo")
		.component("saleInfoWarrantyForm", {
				bindings:{
					vehicle:'<',
					warrantOptions:'<',
					currentWarranty:'='
				},
				templateUrl: "app/main/sale-info/components/sale-info-warranty-form.html",
				controller: componentController,
		  		controllerAs: 'vm',
		  		require: {
			        form : '^form'
			    }
			});

		function componentController(GeneralTools, MessageService, Warranty, SaleWarranty){
			var vm = this;	

			vm.translateToDollar = GeneralTools.inputTranslators.dollar;
			vm.translateToPhoneNumber = GeneralTools.inputTranslators.phoneNumber;
			vm.translateToFirstCap = GeneralTools.inputTranslators.initCapitalize;
			vm.translateToPostalCode = GeneralTools.inputTranslators.postalCode;
			vm.translateToMonth = GeneralTools.inputTranslators.month;
			vm.translateToSIN = GeneralTools.inputTranslators.SIN;
			vm.translateToVIN = GeneralTools.inputTranslators.VIN;

			vm.$onInit = initComponent;
			vm.$postLink = initOutputCallbacks;

			vm.pullDataFromWarrantyOption = pullDataFromWarrantyOption

			function initComponent(){
				initAvailableWarranties();
			}

			function initOutputCallbacks(){

			}

			function pullDataFromWarrantyOption(warranty){
				if(warranty == null){
					MessageService.showToast("Warranty data is invalid.");
					return;
				}

				if(vm.currentWarranty == null){
					vm.currentWarranty = new SaleWarranty();
				}

				vm.currentWarranty.pullDataFromWarranty(warranty);
			}

			function initCurrentWarranty(){
				if(!Array.isArray(vm.warrantOptions)){
					return;
				}

				vm.currentWarranty = vm.warrantOptions.find(function(warranty){
					return warranty.getResourceID() == vm.selectedWarrantyId;
				})
			}

			function initAvailableWarranties(){
				
				if(!Array.isArray(vm.warrantOptions)){
					return;
				}

				var currentDate = new Date();
				var vehicleAge = currentDate.getFullYear() - vm.vehicle.year;

				vm.availableWarranties = vm.warrantOptions.filter(function(warranty){
					return (vm.vehicle.mileage <= warranty.max_mileage 
							&& vm.vehicle.mileage >= warranty.min_mileage 
							&& vehicleAge <= warranty.max_vehicle_year);
				});
			}

/*			vm.removeCurrentWarrany = removeCurrentWarrany;
			vm.selectWarranty = selectWarranty;

			function initComponent(){
				initCurrentWarranty();
				initAvailableWarranty();
			}

			function initOutputCallbacks(){

			}

			function initCurrentWarranty(){
				if(!Array.isArray(vm.warrantOptions)){
					return;
				}

				vm.currentWarranty = vm.warrantOptions.find(function(warranty){
					return warranty.getResourceID() == vm.selectedWarrantyId;
				})
			}

			function initAvailableWarranties(){
				if(!Array.isArray(vm.warrantOptions)){
					return;
				}

				var currentDate = new Date();
				var vehicleAge = currentDate.getFullYear() - vm.vehicle.year;

				vm.availableWarranty = vm.warrantOptions.find(function(warranty){
					return (vm.vehicle.mileage <= warranty.max_mileage 
							&& vm.vehicle.mileage >= warranty.min_mileage 
							&& vehicleAge <= warranty.max_vehicle_year 
							&& !warranty.isExpired());
				});
			}

			function removeCurrentWarrany(){
				vm.currentWarranty = null;
				vm.selectedWarrantyId = null;
			}

			function selectWarranty(selectedWarranty){
				vm.currentWarranty = selectedWarranty;
				vm.selectedWarrantyId = selectedWarranty.getResourceID();
			}*/
		}
})();
(function ()
{
	"use strict";

	angular
		.module("app.saleInfo")
		.component("saleInfoTradeInForm", {
				bindings:{
					tradeInVehicle:'=',
					customer:'=',
				},
				templateUrl: "app/main/sale-info/components/sale-info-trade-in-form.html",
				controller: componentController,
		  		controllerAs: 'vm',
		  		require: {
			        form : '^form'
			    }
			});

		function componentController(GeneralTools, MessageService, VinAuditService, LoginService, AppraisalForm, ProgressService){
			var vm = this;	

			vm.translateToDollar = GeneralTools.inputTranslators.dollar;
			vm.translateToPhoneNumber = GeneralTools.inputTranslators.phoneNumber;
			vm.translateToFirstCap = GeneralTools.inputTranslators.initCapitalize;
			vm.translateToPostalCode = GeneralTools.inputTranslators.postalCode;
			vm.translateToMonth = GeneralTools.inputTranslators.month;
			vm.translateToSIN = GeneralTools.inputTranslators.SIN;
			vm.translateToVIN = GeneralTools.inputTranslators.VIN;

			vm.$onInit = initComponent;
			vm.$postLink = initOutputCallbacks;

			vm.decodeVin = decodeVin;

			function initComponent(){
			}

			function initOutputCallbacks(){

			}

			function decodeVin(vin){
				vm.isDecodingVin = true;

				VinAuditService.decodeVin(vm.tradeInVehicle.vin)
					.then(function(result){
						if(result == null || result.attributes == null){
							return;
						}
						vm.tradeInVehicle.year = result.attributes.year;
						vm.tradeInVehicle.make = result.attributes.make;
						vm.tradeInVehicle.model = result.attributes.model;
					})
					.catch(MessageService.showToast)
					.finally(function(){
						vm.isDecodingVin = false
					})
			}

			vm.printAppraisalForm= function(){
				var appraisalForm = new AppraisalForm(vm.tradeInVehicle, vm.customer, LoginService.getFirstname() + " " + LoginService.getLastname(), vm.vehicle);
				ProgressService.setMode("indeterminate");
				appraisalForm.open()
				.catch(MessageService.showToast)
				.finally(function(){
						ProgressService.isVisble(false);
				})
			}
		}
})();
(function ()
{
	"use strict";

	angular
		.module("app.saleInfo")
		.component("saleInfoSignatureList", {
				bindings:{
					saleInfo: '<',
					vehicle: '<',
					signatures: '<',
					ignoreOptions: '<'
				},
				templateUrl: "app/main/sale-info/components/sale-info-sign.html",
				controller: componentController,
		  		controllerAs: 'vm'
			});

		function componentController($q, $state, LoginService, SaleInfoService, MessageService, BillOfSale, CustomersService, UserService, HellosignService, FileViewService, DialogService, EmailService, SaleInfoSignatureService, GeneralTools){
			var vm = this;	

			var companyID = LoginService.getCompanyID();

			vm.signatureList = {};
			vm.$onInit = initComponent;

			vm.createNewSignatureRequest = createNewSignatureRequest;
			vm.finishSignRequest = finishSignRequest;
			vm.deleteSignatures = deleteSignatures;
			vm.getFileURL = getFileURL;
			vm.sendSigningPageLinkByEmail = sendSigningPageLinkByEmail;
			vm.copySigningPageLink = copySigningPageLink;
			vm.getSeletedSignatureCount = getSeletedSignatureCount;

			function initComponent(){
				if(!Array.isArray(vm.signatures)){
					return;
				}

				initSignatureList();
			}

			function initSignatureList(){
				vm.signatures.forEach(function(signature){
					var signatureID = signature.getResourceID();

					if(!vm.signatureList[signatureID]){
						vm.signatureList[signatureID] = {};
					}

					vm.signatureList[signatureID].info = signature;

					fetchSignatureData(signature);
				})
			}

			function createNewSignatureRequest(){
				var resourcePath = {
					companyID: companyID,
					vehicleID: vm.vehicle.getResourceID(),
					saleinfoID: vm.saleInfo.getResourceID()
				}

				var newSaleSignatureID;
				vm.isCreatingSignature = true;

				SaleInfoSignatureService.createSaleInfoSignature(resourcePath, null, null, vm.ignoreOptions)
					.then(function(_newSaleSignatureID){
						newSaleSignatureID = _newSaleSignatureID;
						resourcePath.signatureID = newSaleSignatureID;

						return SaleInfoSignatureService.getSaleSignatures(resourcePath)
					})
					.then(function(response){
						vm.signatureList[newSaleSignatureID] = {info:response[0]};

						return fetchSignatureDetail(newSaleSignatureID);
					})
					.catch(MessageService.showToast)
					.finally(function(){
						vm.isCreatingSignature = false;
					});
			}

			function fetchSignatureData(signature){
				var signatureID = signature.getResourceID();
				var fetchDataPromise;

				if(!vm.signatureList[signatureID]){
					vm.signatureList[signatureID] = {};
				}

				vm.signatureList[signatureID].isProcessing = true;

				if(signature.fk_id_file){
					fetchDataPromise = fetchSignatureFile(signatureID);
				}else{
					fetchDataPromise = fetchSignatureDetail(signatureID)
						.then(function(signerDetail){
							if(signerDetail.is_complete){
								return fetchSignatureFile(signatureID);	
							}
						})
				}

				fetchDataPromise
					/* .then(function(result){
						console.log(result)
						if(vm.signatureList[signatureID].file){
							return $q.resolve();
						}

						if(vm.signatureList[signatureID].detail 
							&& HellosignService.isAllSignersCompleted(vm.signatureList[signatureID].detail) 
							&& vm.signatureList[signatureID].detail.is_complete == true){
							return fetchSignatureFile(signatureID);
						}
					}) */
					.catch(MessageService.showToast)
					.finally(function(){
						vm.signatureList[signatureID].isProcessing = false;
					});
			}

			function fetchSignatureFile(signatureID){
				var resourcePath = {
					companyID: companyID,
					saleinfoID: vm.saleInfo.getResourceID(),
					vehicleID: vm.vehicle.getResourceID(),
					signatureID: signatureID
				};

				return SaleInfoSignatureService.getSaleSignatureFile(resourcePath)
					.then(function(response){
						vm.signatureList[signatureID].info.fk_id_file = response[0].id_file;
						vm.signatureList[signatureID].file = response[0];
						return $q.resolve();
					});
			}			

			function fetchSignatureDetail(signatureID){
				var resourcePath = {
					companyID: companyID,
					saleinfoID: vm.saleInfo.getResourceID(),
					vehicleID: vm.vehicle.getResourceID(),
					signatureID: signatureID
				};

				return SaleInfoSignatureService.getSaleSignatureDetail(resourcePath)
					.then(function(signatureDetail){
						vm.signatureList[signatureID].detail = signatureDetail;
						if(HellosignService.isAllSignersCompleted(signatureDetail) && !signatureDetail.is_complete){
							return SaleInfoSignatureService.trackSignatureState(resourcePath, vm.signatureList[signatureID].info.hellosign_signature_request_id)
						}

						return $q.resolve(signatureDetail);
					})
					.then(function(response){
						vm.signatureList[signatureID].detail = response;
						return $q.resolve(response);
					})
			}

			function finishSignRequest(signRequestForSigner, signatureID){
				signRequestForSigner.isSigning = true;
				
				HellosignService.finishSignatureRequest(signRequestForSigner.signature_id)
					.then(function(response){
						return fetchSignatureDetail(signatureID);
					})
					.then(function(response){
						if(response.is_complete){
							return fetchSignatureFile(signatureID);	
						}
					})
					.catch(MessageService.showToast)
					.finally(function(){
						signRequestForSigner.isSigning = false;
					});
			}

			function getSeletedSignatureCount(){
				var count = 0;

				var idList = Object.keys(vm.signatureList);

				idList.forEach(function(signatureID){
					if(vm.signatureList[signatureID].isSelected){
						count++
					}
				});

				return count;
			}

			function deleteSignatures(){
				var dialogOptions = {};

				dialogOptions.titleString = "Delete Signature";
				dialogOptions.contentString = "Are you sure to delete " + getSeletedSignatureCount() + " signature(s)?";

				var confirmOption = {};

				confirmOption.optionName = "YES";
				confirmOption.onClick = function(){
					confirmDeleteSignatures();
					DialogService.close();
				}

				var cancelOption = {};

				cancelOption.optionName = "NO";
				cancelOption.onClick = function(){
					DialogService.close();
				}

				dialogOptions.options = [confirmOption, cancelOption];

				DialogService.showOptionsDialog(dialogOptions);
			}

			function confirmDeleteSignatures(){
				var queue = [];
				var idList = Object.keys(vm.signatureList);

				vm.isDeleting = true;

				idList.forEach(function(signatureID){
					if(vm.signatureList[signatureID].isSelected){
						queue.push(deleteSignature(signatureID));
					}
				});

				$q.all(queue)
					.catch(MessageService.showToast)
					.finally(function(){
						vm.isDeleting = false;
					})
			}


			function deleteSignature (signatureID){
				var resourcePath = {
					companyID: companyID,
					saleinfoID: vm.saleInfo.getResourceID(),
					vehicleID: vm.vehicle.getResourceID(),
					signatureID: signatureID
				};

				if(!vm.signatureList[signatureID]){
					vm.signatureList[signatureID] = {};
				}

				vm.signatureList[signatureID].isProcessing = true;

				return SaleInfoSignatureService.deleteSaleSignatures(resourcePath)
					.then(function(){
						delete vm.signatureList[signatureID];
						return $q.resolve();
					})
					.finally(function(){
						if(vm.signatureList[signatureID]){
							vm.signatureList[signatureID].isProcessing = false;
						}	
					})
			}

			function getFileURL(file){
				return FileViewService.generateUrlByUUID(file.uuid);
			}

			function sendSigningPageLinkByEmail(signerDetail, signatureRequestDetail){
				signerDetail.isSending = true;
				
				EmailService.sendSigningRequest(signerDetail, signatureRequestDetail, vm.vehicle)
					.then(function(){
						signerDetail.isSent = true;
					})
					.catch(MessageService.showToast)
					.finally(function(){
						signerDetail.isSending = false;
					})
			}

			function copySigningPageLink(signerDetail){
				if(!signerDetail || !signerDetail.signature_id){
					MessageService.showToast("Signing link is not available.");
					return;
				}

				var signingPageUrl = $state.href('app.signing-page', {signerSignatureId: signerDetail.signature_id}, {absolute: true});

				GeneralTools.copyToClipboard(signingPageUrl);

				signerDetail.isCopied = true;
				MessageService.showToast("Signing link copied to clipboard.");
			}
		}
})();
(function ()
{
	"use strict";

	angular
		.module("app.saleInfo")
		.component("saleInfoPromotionList", {
				bindings:{
					soldDate:'<',
					onAddPromotion:"<",
					onRemovePromotion:"<",
					promotionOptions:"<",
					currentPromotions:"="
				},
				templateUrl: "app/main/sale-info/components/sale-info-promotion-list.html",
				controller: componentController,
		  		controllerAs: 'vm'
			});

		function componentController(SalePromotion, $scope, $q){
			var vm = this;

			$scope.$watch("vm.currentPromotions", updatePromotionMap, true);
			$scope.$watch("vm.promotionOptions", updatePromotionMap, true);

			vm.togglePromotion = togglePromotion;

			function updatePromotionMap(){
				const presetPromotionCardMap = {};
				const customPromotionCardList = [];
				const presetPromotionCardList = [];

				vm.currentPromotions.forEach(function(promotion){
					if(promotion.fk_id_promotion){
						presetPromotionCardMap[promotion.fk_id_promotion] = {
							name: promotion.name,
							description: promotion.description,
							isSelected: true,
							salePromotion: promotion
						};

						return;
					}

					customPromotionCardList.push({
						name: promotion.name,
						subTitle: "Custom",
						description: promotion.description,
						isSelected: true,
						isExpired: false,
						salePromotion: promotion
					})
				});

				vm.promotionOptions.forEach(function(promotionOption){
					const presetPromotionCard = presetPromotionCardMap[promotionOption.id_promotion];
					const expiryDate = promotionOption.expiry_date ? promotionOption.expiry_date : "N/A";
					const subTitle = "Exp:" + expiryDate;
					const isExpired = promotionOption.isExpired();

					if(presetPromotionCard){
						presetPromotionCard.subTitle = subTitle;
						presetPromotionCard.isExpired = isExpired;
						presetPromotionCard.promotionOption = promotionOption;
						presetPromotionCardList.push(presetPromotionCard)
						return;
					}

					const expriyDateMoment = promotionOption.getExpiryDateMomentObj()

					if(vm.soldDate && expriyDateMoment){
						const soldDateMoment = moment(vm.soldDate);
						if(soldDateMoment.isValid() && expriyDateMoment.isBefore(soldDateMoment)){
							return;
						}
					}

					presetPromotionCardList.push({
						name: promotionOption.name,
						subTitle: subTitle,
						description: promotionOption.description,
						isSelected: false,
						isExpired: isExpired,
						promotionOption: promotionOption
					});
				});
				
				vm.promotionCardList = presetPromotionCardList.concat(customPromotionCardList);
			}

			function togglePromotion(item){
				if(item.isDisabled){
					return;
				}

				var promise = $q.resolve();

				if(item.isSelected){
					if(typeof(vm.onRemovePromotion) == "function"){
						promise = vm.onRemovePromotion(item.salePromotion)
					}
				} else if(typeof(vm.onAddPromotion) == "function"){
					const salePromotion = new SalePromotion();
					salePromotion.pullDataFromPromotionOption(item.promotionOption);

					promise = vm.onAddPromotion(salePromotion)
				}

				if(promise && promise.constructor.name == "Promise"){
					item.isDisabled = true;
					promise.finally(function(){
						item.isDisabled = false;
					})
				}
			}
		}
})();
(function ()
{
	"use strict";

	angular
		.module("app.saleInfo")
		.component("saleInfoPlateOptionForm", {
				bindings:{
					plateOptions:'<',
					selectedPlateId:"="
				},
				templateUrl: "app/main/sale-info/components/sale-info-plate-option-form.html",
				controller: componentController,
		  		controllerAs: 'vm'
			});

		function componentController(GeneralTools){
			var vm = this;

			vm.translateToDollar = GeneralTools.inputTranslators.dollar;
			vm.translateToPhoneNumber = GeneralTools.inputTranslators.phoneNumber;
			vm.translateToFirstCap = GeneralTools.inputTranslators.initCapitalize;
			vm.translateToPostalCode = GeneralTools.inputTranslators.postalCode;
			vm.translateToMonth = GeneralTools.inputTranslators.month;
			vm.translateToSIN = GeneralTools.inputTranslators.SIN;
			vm.translateToVIN = GeneralTools.inputTranslators.VIN;

			vm.$onInit = initComponent;
			vm.$postLink = initOutputCallbacks;

			vm.chengeCurrentPlateOption = chengeCurrentPlateOption;

			function initComponent(){
				initPlateOptions();
				initCurrentPlateOption();
			}

			function initOutputCallbacks(){

			}

			function initCurrentPlateOption(){
				if(!Array.isArray(vm.plateOptions)){
					return;
				}
				
				vm.currentPlateOption = vm.plateOptions.find(function(plateOption){
					return plateOption.getResourceID() == vm.selectedPlateId;
				});
			}

			function initPlateOptions(){
				if(!Array.isArray(vm.plateOptions)){
					return;
				}

				vm.availablePlateOptions = [];

				vm.plateOptions.forEach(function(plateOption){
					if(plateOption == null || plateOption.isExpired()){
						return;
					}

					vm.availablePlateOptions.push(plateOption);
				});
			}

			function chengeCurrentPlateOption(plateOptionID){
				vm.currentPlateOption = vm.plateOptions.find(function(plateOption){
					return plateOption.getResourceID() == plateOptionID;
				});
			}
		}
})();
(function ()
{
	"use strict";

	angular
		.module("app.saleInfo")
		.component("saleInfoPaymentForm", {
				bindings:{
					vehicleId:'<',
					saleInfoId:'<',
					constants:'<',
					currentPayments:'=',
					currentPaymentOption:'=',
					isProcessingData:'=',
					onAddPayment:'<',
					onRemovePayment:'<',
					newPayment:'=',
					newPaymentFileUploader:'=',
					customerId: '=',
					voidCreditCardPayment: "<",
					refundCreditCardPayment: "<",
				},
				templateUrl: "app/main/sale-info/components/sale-info-payment-form.html",
				controller: componentController,
		  		controllerAs: 'vm',
		  		require: {
			        form : '^form'
			    }
			});

		function componentController(GeneralTools, LoginService, SaleInfoService, MessageService, SaleInfoPayment, ProgressService, FileUploadService, FileViewService,  DialogService, $scope, CustomersService){
			var vm = this;	
			var companyID = LoginService.getCompanyID();
			var filesMap = {};
			vm.timePickerFormat = "LT";
			vm.translateToDollar = GeneralTools.inputTranslators.dollar;
			vm.translateToPhoneNumber = GeneralTools.inputTranslators.phoneNumber;
			vm.translateToFirstCap = GeneralTools.inputTranslators.initCapitalize;
			vm.translateToPostalCode = GeneralTools.inputTranslators.postalCode;
			vm.translateToMonth = GeneralTools.inputTranslators.month;
			vm.translateToSIN = GeneralTools.inputTranslators.SIN;
			vm.translateToVIN = GeneralTools.inputTranslators.VIN;

			vm.$onInit = initComponent;
			vm.$postLink = initOutputCallbacks;

			vm.getPaymentMethod = getPaymentMethod;
			vm.getPaymentFiles = getPaymentFiles;
			vm.deletePaymentFile = deletePaymentFile;

			vm.fileUploader = FileUploadService.getNewUploader();
			vm.fileUploader.filters.push(FileUploadService.getSizeFilter(20));

			vm.newPaymentfileUploader = FileUploadService.getNewUploader();
			vm.newPaymentfileUploader.filters.push(FileUploadService.getSizeFilter(20));
			
			vm.getFileUrl = getFileUrl;

			vm.togglePaymentTimeEditor = togglePaymentTimeEditor;

			vm.customerCreditCards = [];
			vm.creditCardSelected = {
				customerProfileID: null,
				paymentProfileID: null
			};

			$scope.$watch("vm.customerId", function () {
				$scope.$emit(
					vm.onCustomerChange());
			})

			function togglePaymentTimeEditor(){
				vm.showPaymentTimeEditor = !vm.showPaymentTimeEditor;
			}

			function initComponent(){
				vm.newPayment = new SaleInfoPayment();

				const currentTime = moment();
				vm.paymentDatePickerValue = currentTime;
				vm.paymentTimePickerValue = currentTime.clone();

				resetPaymentDate(vm.paymentDatePickerValue, vm.paymentTimePickerValue);
			}

			function resetPaymentDate(date, time){
				var dateTime;

				if(!date){
					dateTime = moment();
				} else {
					dateTime = moment(date).clone().startOf("day");

					if(time){
						dateTime = copyTimeToMoment(time, dateTime);
					}
				}

				vm.newPayment.payment_date = dateTime.utc().format("YYYY-MM-DD[T]HH:mm:ss[Z]");
			}

			function copyTimeToMoment(source, target){
				if(!source){
					return target;
				}
				
				if(!target){
					return source;
				}

				target.hour(source.hour());
				target.minute(source.minute());
				target.second(source.second());

				return target;
			}

			function initOutputCallbacks (){
				
			}

			vm.addPayment = function(){
				if(typeof(vm.onAddPayment) != "function"){
					return;
				}
				vm.newPayment.invoice_number = 'SI'+vm.saleInfoId
				vm.newPayment.description = 'Vehicle sale info payment (sale id: ' + vm.saleInfoId + ')'
				if(vm.newPayment.fk_id_payment_method == 11){
					vm.newPayment.customerProfileID = vm.creditCardSelected.customerProfileID !== undefined ||  vm.creditCardSelected.customerProfileID !== null ? vm.creditCardSelected.customerProfileID : null;
					vm.newPayment.paymentProfileID = vm.creditCardSelected.paymentProfileID !== undefined || vm.creditCardSelected.paymentProfileID !== null ? vm.creditCardSelected.paymentProfileID : null;
				}

				resetPaymentDate(vm.paymentDatePickerValue, castToMoment(vm.paymentTimePickerValue, vm.timePickerFormat));
				vm.onAddPayment(vm.newPayment);
				vm.showPaymentTimeEditor = false;
			}


			function castToMoment(value, format){
				if(!value){
					return;
				}

				switch (value.constructor.name){
					case "M":
						return value;
					case "Moment":
						return value;
					case "String":
						return moment(value, format);
					case "Date":
						return moment(value);
				}
			}

			vm.fileUploader.onAfterAddingFile = function(fileItem){		
				var resourcePath = {
					companyID: companyID,
					vehicleID: vm.vehicleId,
					saleInfoID: vm.saleInfoId,
					paymentID: fileItem.paymentID
				}
				
				fileItem.url = FileUploadService.getUrlForPostPaymentFile(resourcePath);
				fileItem.upload();

				vm.isProcessingData = true;
			}

			vm.fileUploader.onSuccessItem = function(fileItem, response, status, headers){
				if(!FileUploadService.isUploadSuccess(headers)){
					MessageService.showToast(headers.message);
					return;
				}

				var resourcePath = {
					companyID: companyID,
					vehicleID: vm.vehicleId,
					saleinfoID: vm.saleInfoId,
					paymentID: fileItem.paymentID,
					fileID: response.data
				}

				SaleInfoService.getPaymentFiles(resourcePath)
					.then(function(response){
						filesMap[fileItem.paymentID].push(response[0])
						fileItem.remove();
					})
					.catch(MessageService.showToast)
			}

			vm.fileUploader.onCompleteAll = function(){
				MessageService.showToast("Success!");
				vm.isProcessingData = false;
			}


			function getPaymentMethod(methodID){
				if(vm.constants == null || !Array.isArray(vm.constants.paymentMethods)){
					return 'N/A';
				}

				var paymentOption = vm.constants.paymentMethods.find(function(paymentMethod){
					return paymentMethod.id_payment_method == methodID;
				})

				if(paymentOption == null){
					return 'N/A';
				}

				return paymentOption.name;
			}

			function getPaymentFiles (payment){		
				var paymentID = payment.getResourceID();
				if(vm.isProcessingData == true){
					return;
				}

				vm.selectedPayment = payment;

				if(Array.isArray(filesMap[paymentID])){
					vm.paymentFileList = filesMap[paymentID];
					return
				}

				vm.paymentFileList = [];

				vm.isProcessingData = true;
				
				var resourcePath = {
					companyID: companyID,
					vehicleID: vm.vehicleId,
					saleinfoID: vm.saleInfoId,
					paymentID: paymentID
				}

				SaleInfoService.getPaymentFiles(resourcePath)
					.then(function(fileList){
						filesMap[paymentID] = fileList;
						vm.paymentFileList = filesMap[paymentID];
					})
					.catch(MessageService.showToast)
					.finally(function(){
						vm.isProcessingData = false;
					});
			}

			function deletePaymentFile (file){
				var dialogOptions = {};

				dialogOptions.titleString = "Delete file";
				dialogOptions.contentString = "Are you sure to delete file - " + file.file_name + '?';

				var confirmOption = {};

				confirmOption.optionName = "YES";
				confirmOption.onClick = function(){
					confirmDeletePaymentFileCallback (file)
					DialogService.close();
				}

				var cancelOption = {};

				cancelOption.optionName = "NO";
				cancelOption.onClick = function(){
					DialogService.close();
				}

				dialogOptions.options = [confirmOption, cancelOption];

				DialogService.showOptionsDialog(dialogOptions);
			}	

			function confirmDeletePaymentFileCallback (file){
				var paymentID = vm.selectedPayment.getResourceID();
				var fileID = file.id_payment_file;
				var resourcePath = {
					companyID: companyID,
					vehicleID: vm.vehicleId,
					saleinfoID: vm.saleInfoId,
					paymentID: paymentID,
					fileID: fileID
				}

				vm.isProcessingData = true;

				SaleInfoService.deletePaymentFiles(resourcePath)
					.then(function(response){
						var index = filesMap[paymentID].findIndex(function(file){
							return file.id_payment_file == fileID;
						})

						filesMap[paymentID].splice(index, 1);
						MessageService.showToast("Success!");
					})
					.catch(MessageService.showToast)
					.finally(function(){
						vm.isProcessingData = false;
					})
			}	

			function getFileUrl(file){
				return FileViewService.generateUrlByUUID(file.uuid);
			}	

			vm.onCustomerChange = function(){
				if(vm.customerId){
					var resourcePath = {}; 
					resourcePath.companyID = LoginService.getCompanyID();
					resourcePath.customerID = vm.customerId
					CustomersService.getCreditCards(resourcePath)
					.then(function(result){
						vm.customerCreditCards = result
					})
				}
			}
		}
})();
(function ()
{
	"use strict";

	angular
		.module("app.saleInfo")
		.component("saleInfoPackageList", {
				bindings:{
					soldDate:'<',
					presetPackages: '<',
					packageItemsMap:'<',
					salePackages:'<',
					saleInfo: '<',
					onPresetPackageSelect: '<',
					onPurchasePackageRemove: '<',
					jobList:'<'
				},
				templateUrl: "app/main/sale-info/components/sale-info-package-list.html",
				controller: componentController,
		  		controllerAs: 'vm'
			});

		function componentController(GeneralTools, MessageService, $scope, $q){
			var vm = this;

			vm.showSalePackageItems = {};
			vm.selectedMap = {};
			vm.packageItemMaxDisplay = 2;
			vm.packageMap = {};
			vm.togglePackage = togglePackage;
			vm.showItems = {};
			vm.jobList;

			$scope.$watch("vm.presetPackages", updatePackageMap, true);
			$scope.$watch("vm.salePackages", updatePackageMap, true);
			$scope.$watch("vm.packageItemsMap", updatePackageMap, true);

			function updatePackageMap(){
				if(!Array.isArray(vm.salePackages) || !Array.isArray(vm.presetPackages) || !vm.packageItemsMap){
					return;
				}

				const packageList = [];
				const purchasedPackageMap = {};

				vm.salePackages.forEach(function(salePackage){
					var purchasedPackage = {};	


					purchasedPackage.name = salePackage.name;
					purchasedPackage.price = salePackage.price;
					purchasedPackage.expired = !salePackage.isAvailable();
					purchasedPackage.isPurchased = true;

					purchasedPackage.date = "Exp:" + salePackage.expiry_date;
					purchasedPackage.salePackage = salePackage;

					const salePackageItems = vm.packageItemsMap[salePackage.id_sale_package];

					if(Array.isArray(salePackageItems)){
						const quantityMap = {};
						salePackageItems.forEach(function(item){
							quantityMap[item.fk_id_preset_package_item] = item.quantity;
						});
						purchasedPackage.quantityMap = quantityMap;
					}

					purchasedPackageMap[salePackage.fk_id_preset_package] = purchasedPackage;
				});

				vm.presetPackages.forEach(function(presetPackage){
					var purchasedPackage = purchasedPackageMap[presetPackage.id_preset_package];

					if(purchasedPackage){
						purchasedPackage.presetPackage = presetPackage;

						if(vm.saleInfo.mileage && presetPackage.valid_mileage != 0 && presetPackage.valid_mileage){
							purchasedPackage.valid_mileage =  "Cover mileage under:" +  (vm.saleInfo.mileage + presetPackage.valid_mileage);
						}else{
							purchasedPackage.valid_mileage =  "No mileage limit on cover";
						}
						
						purchasedPackage.items = presetPackage.items.map(function(presetItem){
							if(purchasedPackage.quantityMap){
								const currentQuantity = purchasedPackage.quantityMap[presetItem.id_preset_package_item];
								return presetItem.name + '(' + currentQuantity + '/' + presetItem.quantity + ')';
							}		
						});

						packageList.push(purchasedPackage);
						return;
					}

					
					if(vm.soldDate){
						const soldDateMoment = moment(vm.soldDate);
						if(soldDateMoment.isValid() && moment(presetPackage.active_expiry_date).isBefore(soldDateMoment)){
							return;
						}
					}
					
					packageList.push({
						name: presetPackage.name,
						isPurchased: false,
						expired: !presetPackage.isActive(),
						price: presetPackage.price,
						valid_mileage: presetPackage.valid_mileage,
						date: GeneralTools.getValidTimeString(presetPackage.valid_time),
						presetPackage: presetPackage,
						items: presetPackage.items.map(function(item){
							return item.name + ' * ' + item.quantity;
						})
					});
				});

				vm.packageList = packageList;
			}

			function togglePackage(_package){
				if(_package.isDisabled){
					return;
				}

				var promise = $q.resolve();

				if(_package.isPurchased){
					if(typeof(vm.onPurchasePackageRemove) == "function"){
						promise = vm.onPurchasePackageRemove(_package.salePackage, _package.presetPackage);
					}
				} else if(typeof(vm.onPresetPackageSelect) == "function"){
					if(_package.presetPackage.valid_mileage && _package.presetPackage.valid_mileage != 0){
						_package.presetPackage.expiry_mileage = _package.presetPackage.valid_mileage + vm.saleInfo.mileage;
					}else{
						_package.presetPackage.expiry_mileage = null;
					}
					promise = vm.onPresetPackageSelect(_package.presetPackage);
				}

				if(promise && promise.constructor.name == "Promise"){
					_package.isDisabled = true;
					promise.finally(function(){
						_package.isDisabled = false;
					})
				}

			}
		}
})();
(function ()
{
	"use strict";

	angular
		.module("app.saleInfo")
		.component("saleInfoGeneralForm", {
				bindings:{
					saleInfo:'=',
					plateOptions:'<'
				},
				templateUrl: "app/main/sale-info/components/sale-info-general-form.html",
				controller: componentController,
		  		controllerAs: 'vm',
		  		require: {
			        form : '^form'
			    }
			});

		function componentController(RoleCheckService, $q, ToolsConstants, GeneralTools, SaleInfo, LoginService, UserService, MessageService){
			var vm = this;	
			vm.canSeeCancel = RoleCheckService.deepCheckRole(["sales_manager"]);
			vm.saleManagerRoles = ["sales_manager"];
			vm.salesmanRoles = ["salesman"];

			vm.$onInit = initComponent;

			vm.setPlateOption = setPlateOption;

			vm.translateToDollar = GeneralTools.inputTranslators.dollar;
			vm.translateToPercentage = GeneralTools.inputTranslators.percentage;

			vm.taxRateInputOption = {
				decimalFractionSize:0,
				canBeNegative:false
			};

			vm.queryUser = queryUser;
			vm.selectSaleManager = selectSaleManager;
			vm.selectSoldBy = selectSoldBy

			function initComponent(){
				initSaleInfo();
				initSaleManger();
				initSoldBy();
			}

			function initSoldBy(){
				if(!vm.saleInfo || !vm.saleInfo.sold_by){
					return;
				}

				var resourcePath = {
					companyID: LoginService.getCompanyID(),
					userID: vm.saleInfo.sold_by
				};

				UserService.getUsers(resourcePath, null)
					.then(function(users){
						if(!Array.isArray(users) || users[0] == null){
							return $q.reject("User data is invalid.");
						}

						vm.currentSoldBy = users[0];
						selectSoldBy(vm.currentSoldBy);
					})
					.catch(MessageService.showToast)
			}

			function initSaleManger(){
				if(!vm.saleInfo || !vm.saleInfo.sale_manager){
					return;
				}

				var resourcePath = {
					companyID: LoginService.getCompanyID(),
					userID: vm.saleInfo.sale_manager
				};

				UserService.getUsers(resourcePath, null)
					.then(function(users){
						if(!Array.isArray(users) || users[0] == null){
							return $q.reject("User data is invalid.");
						}

						vm.currentSaleManager = users[0];
						selectSaleManager(vm.currentSaleManager);
					})
					.catch(MessageService.showToast)
			}

			function initSaleInfo(){
				if(!vm.saleInfo){
					vm.saleInfo = new SaleInfo();
				}

				if(vm.saleInfo.tax_rate == null){
					vm.saleInfo.tax_rate = ToolsConstants.taxRate;
				}
			}

			function setPlateOption(){
				var plateOption = vm.plateOptions.find(function(option){
					return option.id_plate_option == vm.selectedPlateId;
				});

				vm.saleInfo.licensing_option = plateOption.name;
				vm.saleInfo.licensing_fee = plateOption.cost;
			}

			function queryUser (searchText, requiredRoles){
				var defer = $q.defer();
				var resourcePath = {companyID: LoginService.getCompanyID()};

				UserService.getUsers(resourcePath, searchText)
					.then(function(users){
						defer.resolve(filterUserByRoles(users, requiredRoles));
					})
					.catch(function(error){
						defer.reject();
						MessageService.showToast(error)
					})

				return defer.promise;
			}

			function filterUserByRoles(users, requiredRoles){
				var saleManagers = [];

				if(!Array.isArray(users)){
					return saleManagers;
				}

				users.forEach(function(user){
					if(hasReqiuredRoles(user.roles, requiredRoles)){
						saleManagers.push(user)
					}
				})

				return saleManagers;
			}

			function hasReqiuredRoles(userRole, requiredRoles){
				var hasRoles = false;

				if(!Array.isArray(userRole)){
					return hasRoles;
				}

				if(!Array.isArray(requiredRoles)){
					requiredRoles = [];
				}

				userRole.forEach(function(role){
					if(requiredRoles.indexOf(role) != -1){
						hasRoles = true;
					}
				});

				return hasRoles;
			}

			function selectSoldBy(user){
				if(user == null){
					vm.saleInfo.sold_by = null;
					return;
				} 

				if(!hasReqiuredRoles(user.roles, vm.salesmanRoles)){
					vm.currentSalesmanInvalid = true;
				}else{
					vm.currentSalesmanInvalid = false;
				}

				vm.saleInfo.sold_by = user.id_user;
			}

			function selectSaleManager(user){
				if(user == null){
					vm.saleInfo.sale_manager = null;
					return;
				} 

				if(!hasReqiuredRoles(user.roles, vm.saleManagerRoles)){
					vm.currentSaleManagerInvalid = true;
				}else{
					vm.currentSaleManagerInvalid = false;
				}

				vm.saleInfo.sale_manager = user.id_user;
			}
		}
})();
(function ()
{
	"use strict";

	angular
		.module("app.saleInfo")
		.component("saleInfoFinanceApplicationForm", {
				bindings:{
					financeApplication:'=',
					constants:'<',
					saleInfo:'='
				},
				templateUrl: "app/main/sale-info/components/sale-info-finance-application-form.html",
				controller: componentController,
		  		controllerAs: 'vm',
		  		require: {
			        form : '^form'
			    }
			});

		function componentController($timeout, $scope, GeneralTools, CustomersService, LoginService, $state, MessageService, GoogleService){
			var vm = this;	
			var filterObj = {};
			var companyID = LoginService.getCompanyID();
			var minSearchTextLength = 2;


			vm.translateToDollar = GeneralTools.inputTranslators.dollar;
			vm.translateToPhoneNumber = GeneralTools.inputTranslators.phoneNumber;
			vm.translateToFirstCap = GeneralTools.inputTranslators.initCapitalize;
			vm.translateToPostalCode = GeneralTools.inputTranslators.postalCode;
			vm.translateToMonth = GeneralTools.inputTranslators.month;
			vm.translateToSIN = GeneralTools.inputTranslators.SIN;
			vm.translateToVIN = GeneralTools.inputTranslators.VIN;
			vm.translateToAllCapitalize = GeneralTools.inputTranslators.allCapitalize;

			vm.$onInit = initComponent;
			vm.$postLink = initOutputCallbacks;

			vm.setLivingArrangementTime = setLivingArrangementTime;
			vm.setEmploymentTime = setEmploymentTime;
			vm.onSearchTextChange = onSearchTextChange;
			vm.selectApplicant = selectApplicant;
			vm.goToCustomerPage = goToCustomerPage;
			vm.setEmployerPhoneNumber = setEmployerPhoneNumber;
			vm.onPostcodeChange = onPostcodeChange;
			vm.dismissAddressList = dismissAddressList;
			vm.selectAddress = selectAddress;
			vm.getAddressName = getAddressName;
			vm.onPostcodeFocus = onPostcodeFocus;

			vm.livingArrangementTimeCheck = [
					{
						name:"minValue",
						validateFn:function(modelValue, viewValue){
							return modelValue * 12 >= 24;
						}
					}
				]

			vm.currentApplicantCheck = [
					{
						name:"applicant",
						validateFn:function(modelValue, viewValue){
							return vm.financeApplication.getCustomerID() != null;
						}
					}
				]

			function initComponent(){
				vm.loanLengthOptions = [24, 36, 48, 60, 72, 84, 96];
				
				if(vm.financeApplication != null){
					initLivingArrangementTime(vm.financeApplication.living_arrangement_time);
					initEmploymentTime(vm.financeApplication.employment_time)
					initEmployerPhoneNumber();
				}

				fetchApplicantData();
			}

			function initOutputCallbacks(){

			}

			function initEmployerPhoneNumber(){
				if(vm.financeApplication && vm.financeApplication.employer_phone_number){
					vm.employerPhoneNumber = vm.financeApplication.employer_phone_number.phone_number;
				}
			}

			function fetchApplicantData(){
				if(vm.financeApplication == null || vm.financeApplication.getCustomerID() == null){
					return;
				}

				var resourcePath = {
					companyID:companyID,
					customerID:vm.financeApplication.getCustomerID()
				};

				CustomersService.getCustomers(resourcePath, null, null, null)
					.then(function(responseData){
						if(responseData == null || !Array.isArray(responseData.data)){
							MessageService.showToast("Customer data invalid");
							return;
						}

						vm.currentApplicant = responseData.data[0];
					})
					.catch(MessageService.showToast)
			}

			function initLivingArrangementTime(totalMonth){
				var monthNumber = parseInt(totalMonth)
				if(isNaN(monthNumber)){
					return;
				}

				vm.livingArrangementYear = Math.floor(monthNumber / 12);
				vm.livingArrangementMonth = monthNumber % 12;
			}

			function initEmploymentTime(totalMonth){
				var monthNumber = parseInt(totalMonth)
				if(isNaN(monthNumber)){
					return;
				}

				vm.employmentYear = Math.floor(monthNumber / 12);
				vm.employmentMonth = monthNumber % 12;
			}

			function setLivingArrangementTime(year, month){		
				vm.financeApplication.living_arrangement_time = translateToTotalMonth(year, month);
			}

			function setEmploymentTime(year, month){
				vm.financeApplication.employment_time = translateToTotalMonth(year, month);
			}

			function translateToTotalMonth(year, month){
				var yearNumber = parseInt(year);
				var monthNumber = parseInt(month);

				var totalMonth = 0;

				if(!isNaN(monthNumber)){
					totalMonth += monthNumber;
				}

				if(!isNaN(yearNumber)){
					totalMonth += yearNumber * 12;
				}

				return totalMonth;
			}	

			function onSearchTextChange(){
				if(vm.searchText == null || vm.searchText.length < minSearchTextLength){
					vm.financeApplicationsFound = [];
					return;
				}

				var resourcePath = { companyID: companyID }
				var filterObj = CustomersService.customerSearchTextFilterBuilder(vm.searchText);

				CustomersService.getCustomers(resourcePath, filterObj, null, null)
					.then(function(response){
						vm.financeApplicationsFound = response.data;
					})
			}

			function selectApplicant(customer){
				vm.financeApplication.setCustomerID(customer.getResourceID());
				vm.currentApplicant = customer;
				$scope.financeApplicationForm.searchApplicant.$validate();
			}

			function goToCustomerPage(customer){
				var url = $state.href('app.view-customer', {customerID: customer.getResourceID()});
				window.open(url,'_blank');
			}

			function setEmployerPhoneNumber(){
				if(!vm.employerPhoneNumber || vm.employerPhoneNumber.trim() == ''){
	        		vm.financeApplication.employer_phone_number = null;
	        	}else{
	        		vm.financeApplication.employer_phone_number = {phone_number: vm.employerPhoneNumber};
	        	}
			}

			function onPostcodeFocus(){
				vm.showAddressList = true;

				if(!Array.isArray(vm.addressList)){
					onPostcodeChange();
				}
			}

			function onPostcodeChange(){
				if(!vm.financeApplication.address_postal_code || vm.financeApplication.address_postal_code.length < 6){
					vm.addressList = [];
					vm.fetchingAddress = false;
					return;
				}

				vm.fetchingAddress = true;

				GoogleService.decodePostcode(companyID, vm.financeApplication.address_postal_code).$promise
					.then(function(addressList){
						vm.addressList = addressList;
					})
					.catch(MessageService.showToast)
					.finally(function(){
						vm.fetchingAddress = false;
					})
			}

			function dismissAddressList(){
				$timeout(function(){
					vm.showAddressList = false;
				}, 100);
			}

			function selectAddress(address){
				if(!address){
					return;
				}

				if(address.streetNumber){
					vm.financeApplication.address_street_number = address.streetNumber;
				}

				if(address.street){
					vm.financeApplication.address_street = address.street;
				}

				if(address.city){
					vm.financeApplication.address_city = address.city;
				}

				if(address.province){
					vm.financeApplication.address_province = address.province;
				}
			}

			function getAddressName(address){
				if(!address){
					return;
				}

				var addressName = address.street + " " + address.city;

				if(address.province){
					addressName += ", " + address.province;
				}

				return addressName;
			}
		}
})();
(function ()
{
	"use strict";

	angular
		.module("app.saleInfo")
		.component("saleInfoFileList", {
				bindings:{
					onFileDelete:'<',
					isProcessingData:'=',
					uploadedFiles:'=',
					fileUploader:'='
				},
				templateUrl: "app/main/sale-info/components/sale-info-file-list.html",
				controller: componentController,
		  		controllerAs: 'vm'
			});

		function componentController(FileUploadService, FileViewService){
			var vm = this;	

			vm.$onInit = initComponent;
			vm.getFileURL = getFileURL;

			function initComponent(){
				initFileUploader();
				initUploadedFiles();
			}

			function initFileUploader(){
				if(vm.fileUploader == null){
					vm.fileUploader = FileUploadService.getNewUploader();
					vm.fileUploader.filters.push(FileUploadService.getSizeFilter(20));
				}
			}

			function initUploadedFiles(){
				if(!Array.isArray(vm.uploadedFiles)){
					vm.uploadedFiles = [];
				}
			}

			function getFileURL(file){
				return FileViewService.generateUrlByUUID(file.uuid);
			}	
		}
})();
(function ()
{
	"use strict";

	angular
		.module("app.saleInfo")
		.component("saleInfoExtraList", {
				bindings:{
					onRemoveExtras:'<',
					onAddExtras:'<',
					presetExtrasOptions:'<',
					currentExtras:'=',
				},
				templateUrl: "app/main/sale-info/components/sale-info-extra-list.html",
				controller: componentController,
		  		controllerAs: 'vm'
			});

		function componentController(GeneralTools, MessageService, SaleExtras, $scope, $q){
			var vm = this;

			vm.translateToDollar = GeneralTools.inputTranslators.dollar;
			vm.addCreateNewExtra = addCreateNewExtra;
			vm.toggleItem = toggleItem;

			$scope.$watch("vm.presetExtrasOptions", updateExtrasMap, true);
			$scope.$watch("vm.currentExtras", updateExtrasMap, true);


			function addCreateNewExtra(){
				var cost = parseFloat(vm.newExtraCost);

				if(typeof(vm.newExtraName) != "string" || vm.newExtraName.trim() == '' || isNaN(cost)){
					MessageService.showToast("Invalid Item.")
					return;
				}

				var newExtra = new SaleExtras();

				newExtra.cost = vm.newExtraCost;
				newExtra.name = vm.newExtraName;

				const promise = vm.onAddExtras((newExtra));

				vm.isAddingCustomerExtra = true;

				if(promise && promise.constructor.name == "Promise"){
					promise.then(function(){
							vm.newExtraCost = undefined;
							vm.newExtraName = undefined;
						})
						.finally(function(){
							vm.isAddingCustomerExtra = false;
						});
				}
			}

			function toggleItem(item){
				if(item.isDisabled){
					return;
				}

				var promise = $q.resolve();
				
				if(item.isSelected){
					if(typeof(vm.onRemoveExtras) == "function"){
						promise = vm.onRemoveExtras(item.currentExtra);
					}
				} else if(typeof(vm.onAddExtras) == "function"){
					const extra = new SaleExtras();
					extra.pullDataFromPresetExtra(item.presetExtra)
					promise = vm.onAddExtras(extra);
				}

				if(promise && promise.constructor.name == "Promise"){
					item.isDisabled = true;
					promise.finally(function(){
						item.isDisabled = false;
					})
				}
			}

			function updateExtrasMap(){
				if(!Array.isArray(vm.currentExtras) || !Array.isArray(vm.presetExtrasOptions)){
					return;
				}

				const extraList = [];
				const presetExtraMap = {};

				vm.presetExtrasOptions.forEach(function(presetExtra){
					const extra = {
						name: presetExtra.name,
						cost: presetExtra.cost,
						presetExtra: presetExtra,
						isSelected: false
					};

					extraList.push(extra);
					presetExtraMap[presetExtra.id_preset_extras] = extra;
				});

				vm.currentExtras.forEach(function(currentExtra){
					if(currentExtra.fk_id_preset_extras && presetExtraMap[currentExtra.fk_id_preset_extras]){
						presetExtraMap[currentExtra.fk_id_preset_extras].isSelected = true;
						presetExtraMap[currentExtra.fk_id_preset_extras].currentExtra = currentExtra;
						return;
					}

					extraList.push({
						name: currentExtra.name,
						cost: currentExtra.cost,
						currentExtra: currentExtra,
						isSelected: true
					})
				});
				
				vm.extraList = extraList;
			}
		}
})();
(function ()
{
	"use strict";

	angular
		.module("app.saleInfo")
		.component("saleDisclosureList", {
				bindings:{
					disclosures:'=',
					onDisclosureAdded:'=',
					onDisclosureRemoved:'=',
					cleanNewDisclouser:'=',
					isProcessingData:'='
				},
				templateUrl: "app/main/sale-info/components/sale-info-disclosure-list.html",
				controller: componentController,
		  		controllerAs: 'vm'
			});

		function componentController(GeneralTools, Disclosure, MessageService){
			var vm = this;		

			vm.translateToDollar = GeneralTools.inputTranslators.dollar;

			vm.$onInit = initComponent;
			vm.$postLink = initOutputCallback;

			vm.addDisclosure = addDisclosure;

			function initComponent(){
			}

			function initOutputCallback(){
				vm.cleanNewDisclouser = cleanNewDisclouser;
			}

			function cleanNewDisclouser(){
				vm.description = null;
				vm.amount = null;
			}

			function addDisclosure(){
				var disclosure = new Disclosure();

				disclosure.description = vm.description;
				disclosure.amount = vm.amount;

				if(!disclosure.isDisclosureValid()){
					MessageService.showToast("Disclosure is invalid.");
					return;
				}

				vm.onDisclosureAdded(disclosure);
			}


		}
})();
(function ()
{
	"use strict";

	angular
		.module("app.saleInfo")
		.component("saleInfoDeliverStatusForm", {
				bindings:{
					saleInfo:'=',
					quotedWorkorders:'<',
					workorderPriorities:'<'
				},
				templateUrl: "app/main/sale-info/components/sale-info-deliver-status-form.html",
				controller: componentController,
		  		controllerAs: 'vm',
		  		require: {
			        form : '^form'
			    }
			});

		function componentController($state){
			var vm = this;	

			vm.$onInit = initComponent;
			vm.setDelivered = setDelivered;

			vm.setDeliveryDate = setDeliveryDate;
			vm.setDeliveryDueDate = setDeliveryDueDate;
			vm.getWorkorderUrl = getWorkorderUrl;
			vm.getWorkorderPriority = getWorkorderPriority;

			function initComponent(){
				vm.deliverDueDatePickerValue = vm.saleInfo.getDeliveryDueDateMomentObj();
				vm.deliverDatePickerValue = vm.saleInfo.getDeliveryDateMomentObj();
			}

			function setDeliveryDate (date){
				vm.saleInfo.setDeliveryDate(moment(date))
			}

			function setDeliveryDueDate (date){
				vm.saleInfo.setDeliveryDueDate(moment(date))
			}

			function setDelivered (){
				if(vm.saleInfo.is_delivered){
					vm.saleInfo.setDeliveryDate(moment());
				} else {
					vm.saleInfo.setDeliveryDate(null);
				}

				vm.deliverDatePickerValue = vm.saleInfo.getDeliveryDateMomentObj();
			}

			function getWorkorderUrl(workorder){
				if(!workorder){
					return;
				}

				const param = {
					vehicleID: workorder.fk_id_vehicle,
					workOrderID: workorder.id_work_order
				}

				return $state.href('app.edit-workorder.general', param); 
			}

			function getWorkorderPriority(priorityID){
				if(!Array.isArray(vm.workorderPriorities)){
					return;
				}

				const matchedPriority = vm.workorderPriorities.find(function(priority){
					return !!priority && priority.id_work_order_priority == priorityID;
				});

				if(matchedPriority){
					return matchedPriority.name;
				}
			}
			vm.log = function(){
				console.log(vm.saleInfo.general_comments)
			}
		}	
})();
(function ()
{
	"use strict";

	angular
		.module("app.saleInfo")
		.component("saleInfoCustomerForm", {
				bindings:{
					customer:'=',
					constants:'<',
					onCustomerSelect:'<'
				},
				templateUrl: "app/main/sale-info/components/sale-info-customer-form.html",
				controller: componentController,
		  		controllerAs: 'vm'
			});

		function componentController(CustomersService, LoginService, $state){
			var vm = this;	
			var filterObj = {};
			var companyID = LoginService.getCompanyID();
			var customerFilterObj = {};
			
			var minSearchTextLength = 2;

			vm.$onInit = initComponent;

			vm.onSearchTextChange = onSearchTextChange;
			vm.selectCusomter = selectCusomter;
			vm.goToCustomerPage = goToCustomerPage;
			vm.getCustomerPageUrl = getCustomerPageUrl;

			function initComponent(){

			}

			function onSearchTextChange(){
				if(vm.searchText == null || vm.searchText.length < minSearchTextLength){
					vm.customersFound = [];
					return;
				}

				var resourcePath = { companyID: companyID }
				var filterObj = CustomersService.customerSearchTextFilterBuilder(vm.searchText);

				CustomersService.getCustomers(resourcePath, filterObj, null, null)
					.then(function(response){
						vm.customersFound = response.data;

					})
			}

			function selectCusomter (customer){
				vm.customer = customer;
				if(typeof(vm.onCustomerSelect) == "function"){
					vm.onCustomerSelect(vm.customer);
				}
			}

			function goToCustomerPage (customer){
				var url = $state.href('app.view-customer', {customerID: customer.getResourceID()});
				window.open(url,'_blank');
			}

			function getCustomerPageUrl(){
				return $state.href('app.view-customer', {customerID: vm.customer.getResourceID()});
			}

		}
})();
(function ()
{
	"use strict";

	angular
		.module("app.saleInfo")
		.component("saleInfoAdditionalFinanceInfoForm", {
				bindings:{
					saleInfo:'='
				},
				templateUrl: "app/main/sale-info/components/sale-info-additional-finance-info-form.html",
				controller: componentController,
		  		controllerAs: 'vm',
		  		require: {
			        form : '^form'
			    }
			});

		function componentController(GeneralTools, SaleInfo){
			var vm = this;	

			vm.$onInit = initComponent;

			vm.translateToDollar = GeneralTools.inputTranslators.dollar;
			vm.translateToPercentage = GeneralTools.inputTranslators.percentage;
			vm.onDatePickerChange = onDatePickerChange;

			vm.interestRateInputOption = {
				decimalFractionSize:2,
				canBeNegative:false
			};

			function initComponent(){
				initSaleInfo();
			}


			function initSaleInfo(){
				if(!vm.saleInfo){
					vm.saleInfo = new SaleInfo();
				}

				if(vm.saleInfo.payment_start_date){
					vm.paymentStartDate = moment(vm.saleInfo.payment_start_date, "YYYY-MM-DD");
				}
			}

			function onDatePickerChange(){
				if(vm.paymentStartDate){
					vm.saleInfo.payment_start_date = moment(vm.paymentStartDate).format("YYYY-MM-DD")
				} else {
					vm.saleInfo.payment_start_date = null
				}
				
			}
		}
})();
(function ()
{
	"use strict";
	angular.module("app.safety",[])
		.constant("SafetyConstants", {
			inspectDateFormat: "YYYY-MM-DD"
		})
		.config(config);

	/** @ngInject */
	function config($stateProvider)
	{	  

		$stateProvider
			.state('app.create-safety', {
				url :"/vehicle/{vehicleID}/createsafety",
				views	: {
						'content@app': {
							templateUrl: 'app/main/safety/create-safety.html',
							controller : 'CreateSafetyController as vm'
						}
					},
				resolve:{
					vehicle:function($stateParams, VehicleService, MessageService, LoginService){
						var resourcePath = { 
							companyID: LoginService.getCompanyID(),
							vehicleID: $stateParams.vehicleID
						}
						return VehicleService.getVehicle(resourcePath).catch(MessageService.showToast);			
					},
					imageTags:function($stateParams, SafetyService, MessageService){
						return SafetyService.getCachedSafetyImageTags().catch(MessageService.showToast);			
					}
				}
			})
			.state('app.edit-safety', {
				url :"/vehicle/{vehicleID}/safety/{safetyID}/edit",
				views	: {
						'content@app': {
							templateUrl: 'app/main/safety/edit-safety.html',
							controller : 'EditSafetyController as vm'
						}
					},
				resolve:{
					vehicle:function($stateParams, VehicleService, MessageService, LoginService){
						var resourcePath = { 
							companyID: LoginService.getCompanyID(),
							vehicleID: $stateParams.vehicleID
						}
						return VehicleService.getVehicle(resourcePath).catch(MessageService.showToast);			
					},
					safety:function($stateParams, SafetyService, MessageService, LoginService){
						var resourcePath = {
							companyID: LoginService.getCompanyID(),
							vehicleID : $stateParams.vehicleID,
							safetyID : $stateParams.safetyID
						};

						return SafetyService.getSafeties(resourcePath).catch(MessageService.showToast);			
					},
					imageTags:function($stateParams, SafetyService, MessageService){
						return SafetyService.getCachedSafetyImageTags().catch(MessageService.showToast);			
					},
					images:function($stateParams, SafetyService, MessageService, LoginService){
						var resourcePath = {
							companyID: LoginService.getCompanyID(),
							vehicleID : $stateParams.vehicleID,
							safetyID : $stateParams.safetyID
						};

						return SafetyService.getSafetyImages(resourcePath).catch(MessageService.showToast);			
					}
				}
			});

	}

})();


(function ()
{
	"use strict";

	angular
		.module("app.safety")
		.component("safetyImagesList", {
				bindings:{
					imageUploader: '=',
					tag: '=',
					images: '=',
					onDeleteClicked: '='
				},
				templateUrl: "app/main/safety/components/safety-images-list.html",
				controller: componentController,
		  		controllerAs: 'vm'
			});

		function componentController(GeneralTools, $scope){
			var vm = this;	

			vm.$onInit = initComponent;
			vm.$postLink = initOutputCallbacks;

			function initComponent(){
				if(!Array.isArray(vm.images)){
					vm.images = [];
				}

				refreshGallery();
			}

			function initOutputCallbacks (){
				$scope.$watch("vm.images.length", refreshGallery);
			}

			function refreshGallery(){
				if(!Array.isArray(vm.images)){
					vm.images = [];
				}

				vm.galleryList = [];

				vm.images.forEach(function(image){
					vm.galleryList.push({src: image.url});
				});
			}
		}
})();
(function ()
{
	"use strict";

	angular
		.module("app.safety")
		.component("safetyGeneralInfoForm", {
				bindings:{
					safety: '=',
					defaultInspectorId: "<",
					isFormValid:'='
				},
				templateUrl: "app/main/safety/components/safety-general-info-form.html",
				controller: componentController,
		  		controllerAs: 'vm'
			});

		function componentController($q, Safety, MessageService, LoginService, UserService, $scope){
			var vm = this;	
			var inspectorRoles = ["mechanic"];

			vm.$onInit = initComponent;
			vm.$postLink = initOutputCallbacks;
			vm.queryUser = queryUser;
			vm.selecteInspector = selecteInspector;
			vm.setSafetyResultFailOption = setSafetyResultFailOption;
			vm.setSafetyResultPassOption = setSafetyResultPassOption;
			vm.setInspectionDate = setInspectionDate;

			function initComponent(){
				initSafety();
				initInspector();
				initInspectionDate();
				initInspectResult();
			}

			function initOutputCallbacks(){
				vm.isFormValid = isFormValid;
			}

			function initInspectResult(){
				if(vm.safety.is_pass == true){
					vm.safetyResultPass = true;
					return;
				}

				if(vm.safety.is_pass == false){
					vm.safetyResultFail = true;
					return;
				}

				vm.safetyResultPass = false;
				vm.safetyResultFail = false;
			}

			function isFormValid(){
				$scope.safetyGeneralInfoForm.$submitted = true;

				return $scope.safetyGeneralInfoForm.$valid;
			}

			function setInspectionDate (date){
				vm.safety.setInspectionDate(moment(date));
			}

			function initInspectionDate(){
				vm.inspectionDatePickerValue = vm.safety.getInspectionDateMomentObj();
			}

			function setSafetyResultFailOption(){
				vm.safetyResultPass = false;

				setSaftyResult();
			}

			function setSafetyResultPassOption (){
				vm.safetyResultFail = false;

				setSaftyResult();
			}

			function setSaftyResult(){
				if(vm.safetyResultPass == false && vm.safetyResultFail == false){
					vm.safety.is_pass = null;
				}

				if(vm.safetyResultPass == true){
					vm.safety.is_pass = true;
				}

				if(vm.safetyResultFail == true){
					vm.safety.is_pass = false;
				}
			}

			function selecteInspector(user){
				if(user == null){
					vm.safety.inspected_by = null;
					return;
				} 

				if(!checkInspectorRole(user.roles)){
					vm.currentInspectorInvalid = true;
				}else{
					vm.currentInspectorInvalid = false;
				}
						
				vm.safety.inspected_by = user.getResourceID();				
			}

			function initInspector(){
				var inspectorID;

				if(vm.safety.inspected_by == null){
					inspectorID = vm.defaultInspectorId;
				} else {
					inspectorID = vm.safety.inspected_by;
				}

				if(inspectorID == null){
					return;
				}

				var resourcePath = {
					companyID: LoginService.getCompanyID(),
					userID: inspectorID
				};

				UserService.getUsers(resourcePath, null)
					.then(function(users){
						if(!Array.isArray(users) || users[0] == null){
							return $q.reject("User data is invalid.");
						}

						if(checkInspectorRole(users[0].roles)){
							vm.currentInspector = users[0];
							selecteInspector(vm.currentInspector);
							return;
						}

						if(vm.safety.inspected_by){
							vm.currentInspector = users[0];
							selecteInspector(vm.currentInspector);
						}
					})
					.catch(MessageService.showToast)
			}

			function queryUser (searchText){
				var defer = $q.defer();
				var resourcePath = {companyID: LoginService.getCompanyID()};

				UserService.getUsers(resourcePath, searchText)
					.then(function(users){
						defer.resolve(filterInspector(users));
					})
					.catch(function(error){
						defer.reject();
						MessageService.showToast(error)
					})

				return defer.promise;
			}

			function filterInspector(users){
				var inspectors = [];

				if(!Array.isArray(users)){
					return inspectors;
				}

				users.forEach(function(user){
					if(checkInspectorRole(user.roles)){
						inspectors.push(user)
					}
				})

				return inspectors;
			}

			function checkInspectorRole(userRole){
				var isInspector = false;

				if(!Array.isArray(userRole)){
					return isInspector;
				}

				userRole.forEach(function(role){
					if(inspectorRoles.indexOf(role) != -1){
						isInspector = true;
					}
				});

				return isInspector;
			}

			function initSafety(){
				if(vm.safety == null){
					vm.safety = new Safety();
				}
			}

			function log(){
				console.log(vm.safety)
			}
		}
})();
(function ()
{
	"use strict";

	angular
		.module("app.safety")
		.component("safetyConnerInfoForm", {
				bindings:{
					rotorThickness:				'=',
					padThicknessInner:			'=',
					padThicknessOuter:			'=',
					shoeLiningThickness:		'=',
					drumDiameter: 				'=',
					treadDepth:					'=',
					inflationPressure:			'=',
					correctedLargerThan5Psi:	'=',
					finalReading:				'=',
					isFormValid: 				'='
				},
				templateUrl: "app/main/safety/components/safety-conner-info-form.html",
				controller: componentController,
		  		controllerAs: 'vm'
			});

		function componentController(GeneralTools, $scope){
			var vm = this;	

			vm.translateToDecimal = GeneralTools.inputTranslators.decimal;
			vm.inputControlOptions = {
				decimalFractionSize:2,
				canBeNegative:false
			}

			vm.$onInit = initComponent;
			vm.$postLink = initOutputCallbacks;

			function initComponent(){
			}

			function initOutputCallbacks (){
				vm.isFormValid = isFormValid;
			}

			function isFormValid(){
				$scope.connerInfoForm.$submitted = true;
				return $scope.connerInfoForm.$valid;
			}
		}
})();
(function ()
{
	'use strict';

	angular
		.module('app.returnInvoice', [])
		.constant("ReturnInvoiceConstants", {
			keyNames:{
				returnDate: "return_invoice.return_date",
				invoiceNumber: "return_invoice.invoice_number",
				supplier: "return_invoice.fk_id_supplier"
			},
			invoiceNumberPattern:/^[\w\d\-]*$/,
			returnDateFormat: "YYYY-MM-DD"
		})
		.config(config)
		.run(run)

	function run(msNavigationService, LoginService, ReturnInvoiceConstants){
		/*msNavigationService.saveItem("return-invoice", {
			title : "RETURN INVOICE",
			icon : "icon-car",
			weight: 3,
			requiredRoles:[]			 
		});

		msNavigationService.saveItem('return-invoice.browse-return-invoices', {
			title: 'Browse Invoices',
			state: 'app.browse-return-invoices',
			requiredRoles:[]	
		});*/

/*		msNavigationService.saveItem('inventory.add-return-invoice', {
			title: 'Add Inventory',
			state: 'app.add-return-invoice',
			requiredRoles:[]			 
		});

		*/
	}

	/** @ngInject */
	function config($stateProvider)
	{	  
		$stateProvider
			.state('app.browse-return-invoices', {
				url : '/returninvoices?supplier&invoiceNumber&startDate&endDate&type&name&code&limit&page&sortBy&sortDirection',
				reloadOnSearch : false,
				views	: {
					'content@app': {
						templateUrl: 'app/main/return-invoice/browse-return-invoices/browse-return-invoices.html',
						controller : 'BrowseReturnInvoiceController as vm'
					}
				},
				resolve :{
					constants:function(MessageService, PurchaseInvoiceService, InventoryService, $q, LoginService){
						const resourcePath = { companyID: LoginService.getCompanyID() };
						const queue = { 
							suppliers: PurchaseInvoiceService.getCachedSuppliers(resourcePath),
							inventoryTypes: InventoryService.getInventoryTypes() 
						};

						return $q.all(queue).catch(MessageService.showToast);
					}
				}
			})
			.state('app.edit-return-invoice', {
				url : '/editreturninvocie/{returnInvoiceID}',
				views	: {
					'content@app': {
						templateUrl: 'app/main/return-invoice/edit-return-invoice/edit-return-invoice.html',
						controller : 'EditReturnInvoiceController as vm'
					}
				},
				resolve :{
					constants:function(MessageService, PurchaseInvoiceService, InventoryService, $q, LoginService){
						const resourcePath = { companyID: LoginService.getCompanyID() };
						const queue = { 
							suppliers: PurchaseInvoiceService.getCachedSuppliers(resourcePath),
							partTypes: InventoryService.getInventoryTypes() 
						};

						return $q.all(queue).catch(MessageService.showToast);
					},
					returnInvoice:function(MessageService, ReturnInvoiceService, $q, LoginService, $stateParams){
						const resourcePath = { 
							companyID: LoginService.getCompanyID(),
							returninvoiceID: $stateParams.returnInvoiceID
						};

						return ReturnInvoiceService.getReturnInvoices(resourcePath).catch(MessageService.showToast);
					},
					parts:function(MessageService, PartService, $q, LoginService, $stateParams, PartConstants){
						const resourcePath = { 
							companyID: LoginService.getCompanyID()
						};

						const filters = { filters: '(' + PartConstants.keyNames.returnInvoiceID + ' eq ' + $stateParams.returnInvoiceID + ')'}

						return PartService.getAllMatchedParts(resourcePath, filters).catch(MessageService.showToast);
					},
					files:function(MessageService, ReturnInvoiceService, $q, LoginService, $stateParams, PartConstants){
						const resourcePath = { 
							companyID: LoginService.getCompanyID(),
							returninvoiceID: $stateParams.returnInvoiceID
						};

						return ReturnInvoiceService.getReturnInvoiceFiles(resourcePath).catch(MessageService.showToast);
					}
				}
			})

/*		
			
			.state('app.add-return-invoice', {
				url : '/addinventory',
				views	: {
					'content@app': {
						templateUrl: 'app/main/inventory/add-return-invoice/add-return-invoice.html',
						controller : 'AddInventoryController as vm'
					}
				},
				resolve :{
					constants:function(MessageService, InventoryService, $q, LoginService){
						const resourcePath = { companyID: LoginService.getCompanyID() };
						const queue = { 
							inventoryTypes: InventoryService.getInventoryTypes()
						};

						return $q.all(queue).catch(MessageService.showToast);
					}
				}
			});*/
			
	}

})();
(function ()
{
	'use strict';

	angular
		.module('app.returnInvoice')
		.controller('EditReturnInvoiceController', EditReturnInvoiceController);

	function EditReturnInvoiceController($sce,  files, FileViewService, DialogService, PartTableItem, PartService, Part, PurchaseInvoiceService, $stateParams, FileUploadService, LoginService, ReturnInvoiceService, GeneralTools, $q, constants, returnInvoice, parts, MessageService){  
		const vm = this;
		const companyID = LoginService.getCompanyID();
		const returnInvoiceID = $stateParams.returnInvoiceID
		const confirmString = "CONFIRM";

		var originParts;

		vm.hiddenColumns = {
			returnInvoice: true
		}
		vm.purchaseInvoiceMap = {};
		vm.fileUploader = FileUploadService.getNewUploader();
		vm.fileUploader.filters.push(FileUploadService.getSizeFilter(20));
		vm.onFileDelete = onFileDelete;
		vm.addNewPart = addNewPart;
		vm.removeSelectedParts = removeSelectedParts;
		vm.pullDataFromInventory = pullDataFromInventory;
		vm.isAnyPartSelected = isAnyPartSelected;

		vm.save = save;

		init();

		function init(){
			initConstants();
			initReturnInvoice();
			initParts();
			initFiles();
		}

		function initFiles(){
			if(!Array.isArray(files)){
				return;
			}

			vm.fileList = [];

			files.forEach(function(file){
				vm.fileList.push({fileData: file});
			});

			initFilesPreviewUrl();
		}

		function initFilesPreviewUrl(){
			if(!Array.isArray(vm.fileList)){
				return;
			}

			vm.fileList.forEach(function(item){
				if(!item || !item.fileData){
					return;
				}

				if(!item.fileData.isImage()){
					return;
				}

				if(item.fileData.isPublic()){
					item.previewUrl = item.fileData.getURL();
				} else {
					initPreviewUrl(item.fileData);
				}
			});
		}

		function initPreviewUrl(file){
			if(!file || !Array.isArray(vm.fileList)){
				return;
			}

			const options = {
				width:200,
				quality:30
			};

			FileViewService.downloadFile(file.getResourcePath(), options)
				.then(function(response){
					const item = vm.fileList.find(function(item){
						return item && item.fileData && item.fileData.id_return_invoice_file == file.id_return_invoice_file;
					});
					
					item.previewUrl = URL.createObjectURL(new Blob([new Uint8Array(response.data)], {type: file.getFileType()}));
				});
		}

		function initParts(){
			const returnInvoiceIdList = [];
			vm.partList = [];

			if(!Array.isArray(parts)){
				MessageService.showToast("Parts data is invaild.");
				return;
			}

			parts.forEach(function(part){
				const item = new PartTableItem();
				item.setPartData(part)
				vm.partList.push(item);

				const returnInvoiceID = part.fk_id_return_invoice;

				if(!!returnInvoiceID && returnInvoiceIdList.indexOf(returnInvoiceID) == -1){
					returnInvoiceIdList.push(returnInvoiceID);
				}
			});

			resetOriginParts();
			resetSummaryPartList();
			initPurchaseInvoices(returnInvoiceIdList);
			vm.returnInvoiceMap = {};
			vm.returnInvoiceMap[returnInvoiceID] = vm.returnInvoice;
		}

		function initPurchaseInvoices(invoiceIdList){
			if(!Array.isArray(invoiceIdList)){
				return;
			}

			invoiceIdList.forEach(function(invoiceID){
				if(!!invoiceID){
					initPurchaseInvoice(invoiceID);
				}
			});
		}

		function initPurchaseInvoice(invoiceID){
			const resourcePath = {
				companyID: companyID,
				purchaseinvoiceID: invoiceID
			};

			PurchaseInvoiceService.getPurchaseInvoices(resourcePath)
				.then(function(result){
					if(!result || !Array.isArray(result.data) || result.data.length != 1 || !result.data[0]){
						return $q.reject("invoice with id: " + invoiceID + " is invaild");
					}

					vm.purchaseInvoiceMap[invoiceID] = result.data[0];
				});
		}

		function resetOriginParts(){
			const parts = [];

			vm.partList.forEach(function(item){
				if(!item || !item.partData || !item.partData.id_part){
					return;
				}

				parts.push(item.partData);
			});

			originParts = angular.copy(parts);
		}

		function initConstants(){
			if(!constants){
				return;
			}

			vm.suppliers = constants.suppliers;
			vm.partTypes = constants.partTypes;
		}

		function initReturnInvoice(){
			if(!returnInvoice || !Array.isArray(returnInvoice.data) || returnInvoice.data.length != 1 || !returnInvoice.data[0]){
				MessageService.showToast("ReturnInvoice data invalid");
				return;
			}
			vm.returnInvoice = returnInvoice.data[0];

			vm.originReturnInvoice = angular.copy(vm.returnInvoice);
		}

		function save(){
			if(!vm.isReturnInfoFormValid()){
				MessageService.showToast("Something wrong in work order infos.");
				return;
			}

			if(!vm.isPartTableValid()){
				MessageService.showToast("Something wrong in parts table.");
				return;
			}

			const queue = [];
			const returnInvoiceRequestBody = GeneralTools.updateResourceRequestBodyGenerator(vm.returnInvoice, vm.originReturnInvoice);
			const partsRequestBody = getPartsRequestBodys();

			if(returnInvoiceRequestBody){
				queue.push(updateReturnInvoice(returnInvoiceRequestBody));
			}

			if(partsRequestBody){
				queue.push(saveParts(partsRequestBody));
			}

			if(queue.length <= 0){
				MessageService.showToast("No changes detected.");
				return;
			}

			vm.isSaving = true;

			$q.all(queue)
				.then(function(){
					MessageService.showToast("Success.")
				})
				.catch(MessageService.showToast)
				.finally(function(){
					vm.isSaving = false;
				});
		}

		function saveParts(requestBody){
			if(!requestBody){
				return;
			}

			return $q.all([createParts(requestBody.partsToCreate),updateParts(requestBody.partsToUpdate)])
				.then(function(){
					resetOriginParts();
					return $q.resolve();
				});
		}

		function createParts(requestBodyList){
			if(!Array.isArray(requestBodyList)){
				return $q.reject("createParts requestBodyList invalid");
			}

			const queue = [];

			requestBodyList.forEach(function(item){
				if(!item){
					return;
				}

				queue.push(createPart(item.requestBody, item.index));
			});

			return $q.all(queue);
		}

		function createPart(requestBody, index){
			const resourcePath = {
				companyID: companyID
			}

			return PartService.createPart(resourcePath, requestBody)
				.then(function(newPartId){
					vm.partList[index].partData.id_part = newPartId;
					return $q.resolve();
				})
		}

		function updateParts(requestBodyList){
			if(!Array.isArray(requestBodyList)){
				return $q.reject("updateParts requestBodyList invalid");
			}

			const queue = [];

			requestBodyList.forEach(function(item){
				if(!item){
					return;
				}

				const resourcePath = {
					companyID: companyID,
					partID: item.partID
				}

				queue.push(PartService.updatePart(resourcePath, item.requestBody));
			});

			return $q.all(queue);
		}

		function getPartsRequestBodys(){
			const partsToCreate = [];
			const partsToUpdate = [];

			vm.partList.forEach(function(item, index){
				if(!item || !item.partData){
					return;
				}

				if(!item.partData.id_part){
					partsToCreate.push({
						index: index,
						requestBody: item.partData
					});
					return;
				}

				const changedProperties = getUpdatePartRequestBody(item.partData);

				if(!!changedProperties){
					partsToUpdate.push({
						requestBody: changedProperties,
						partID: item.partData.id_part
					});
				}
			});

			if(partsToCreate.length <= 0 && partsToUpdate.length <= 0){
				return;
			}

			return {
				partsToCreate: partsToCreate,
				partsToUpdate: partsToUpdate
			};
		}

		function getUpdatePartRequestBody(part){
			if(!part || !part.id_part){
				return;
			}

			const originPart = originParts.find(function(item){
				if(!item){
					return;
				}

				return item.id_part == part.id_part;
			});

			if(!originPart){
				return;
			}

			const changedProperties = GeneralTools.updateResourceRequestBodyGenerator(part, originPart);

			if(!!changedProperties){
				return changedProperties;
			}
		}

		function updateReturnInvoice(requestBody){
			const resourcePath = { 
				companyID: companyID,
				returninvoiceID: returnInvoiceID
			};

			return ReturnInvoiceService.updateReturnInvoice(resourcePath, requestBody)
				.then(function(){
					vm.originReturnInvoice = angular.copy(vm.returnInvoice);
					return $q.resolve();
				});
		}

		function resetSummaryPartList(){
			const partList = [];

			if(!Array.isArray(vm.partList)){
				return;
			}

			vm.partList.forEach(function(item){
				if(item){
					partList.push(item.partData);
				}	
			});

			vm.summaryPartList = partList;
		}

		function pullDataFromInventory(item, inventory){
			if(!item || !inventory){
				return;
			}
			
			item.name = inventory.name;
			item.code = inventory.code;
			item.retailPrice = inventory.retail_price;
			item.suggestedRetailPrice = inventory.retail_price;
			item.cost = inventory.purchase_price;
			item.updateProperties();
		}

		function addNewPart(){
			MessageService.showToast("Please add part in purchase invoice page first.");	
		}

		function isAnyPartSelected(){
			if(!Array.isArray(vm.partList)){
				return;
			}

			const selectedPart = vm.partList.find(function(item) {
				return !!item && !!item.isSelected;
			});

			return !!selectedPart;
		}

		function removeSelectedParts(){
			const existingPartIdList = [];
			const newPartIndexList = [];

			vm.partList.forEach(function(item, index){
				if(!item || !item.isSelected){
					return;
				}

				if(!!item.partData.id_part){
					existingPartIdList.push(item.partData.id_part);
				} else {
					newPartIndexList.push(index);
				}
			});

			if(existingPartIdList.length > 0){
				showDeletePartsDialog(existingPartIdList, newPartIndexList);
			} else {
				removeNewParts(newPartIndexList);
				resetSummaryPartList();
				MessageService.showToast("Parts are removed.");
			}
		}

		function removeNewParts(newPartIndexList){
			if(!Array.isArray(newPartIndexList)){
				return;
			}

			newPartIndexList.reverse();

			newPartIndexList.forEach(function(index){
				vm.partList.splice(index, 1);
			});
		}

		function showDeletePartsDialog(existingPartIdList, newPartIndexList){
			var dialogOptions = {};

			dialogOptions.titleString = "Remove Parts";
			dialogOptions.contentString = "Are you sure to remove selected items";

			var confirmOption = {};

			confirmOption.optionName = "YES";
			confirmOption.onClick = function(){
				confirmDeleteParts(existingPartIdList, newPartIndexList);
				DialogService.close();
			}

			var cancelOption = {};

			cancelOption.optionName = "NO";
			cancelOption.onClick = function(){
				DialogService.close();
			}

			dialogOptions.options = [confirmOption, cancelOption];

			DialogService.showOptionsDialog(dialogOptions);
		}

		function confirmDeleteParts(existingPartIdList, newPartIndexList){
			removeNewParts(newPartIndexList);

			if(!Array.isArray(existingPartIdList)){
				return;
			}

			vm.isDeleting = true;

			const queue = [];

			existingPartIdList.forEach(function(partID){
				queue.push(deletePart(partID));
			});

			$q.all(queue)
				.then(function(){
					resetOriginParts();
					resetSummaryPartList();
					MessageService.showToast("Parts are removed.");
				})
				.catch(MessageService.showToast)
				.finally(function(){
					vm.isDeleting = false;
				})
		}

		function deletePart(partID){
			const resourcePath = {
				companyID: companyID,
				partID: partID
			}

			return PartService.deletePart(resourcePath)
				.then(function(){
					const index = vm.partList.findIndex(function(item){
						return !!item && item.partData.id_part == partID;
					});

					vm.partList.splice(index, 1);

					return $q.resolve();
				});
		}

		vm.fileUploader.onAfterAddingFile = function(fileItem){
			if(fileItem.file.type.indexOf("image") != -1){
				var url = URL.createObjectURL(fileItem._file);
				fileItem.imageSrc = $sce.trustAsResourceUrl(url);
			}
			
			fileItem.url = FileUploadService.getUrlForCreateReturnInvoiceFile(vm.returnInvoice.id_return_invoice);
			fileItem.upload();
		}

		vm.fileUploader.onCompleteItem = function(item, response, status, headers){
			if(!FileUploadService.isUploadSuccess(headers)){
				MessageService.showToast(headers.message);
				return;
			}

			var resourcePath = {
				companyID: companyID,
				returninvoiceID: vm.returnInvoice.id_return_invoice,
				fileID: response.data
			};

			ReturnInvoiceService.getReturnInvoiceFiles(resourcePath)
				.then(function(files){
					if(!Array.isArray(files)){
						return $q.reject("Return info file data is invalid.");
					}

					vm.fileList.push({fileData: files[0]});
					item.remove();
					initPreviewUrl(files[0]);
				})
				.catch(MessageService.showToast);
		}

		function onFileDelete(fileItem){
			if(!fileItem || !fileItem.fileData){
				return;
			}
			const dialogOptions = {};

			dialogOptions.titleString = "Delete File";
			dialogOptions.contentString = "Are you sure to delete " + fileItem.fileData.file_name + '?';

			const confirmOption = {};

			confirmOption.optionName = "YES";
			confirmOption.onClick = function(){
				confirmDeleteFileCallback(fileItem.fileData);
				DialogService.close();
			}

			var cancelOption = {};

			cancelOption.optionName = "NO";
			cancelOption.onClick = function(){
				DialogService.close();
			}

			dialogOptions.options = [confirmOption, cancelOption];

			DialogService.showOptionsDialog(dialogOptions);

		}

		function confirmDeleteFileCallback(file){
			if(!file){
				return;
			}

			const resourcePath = {
				companyID: companyID,
				returninvoiceID: vm.returnInvoice.id_return_invoice,
				fileID: file.id_return_invoice_file
			}

			vm.isDeletingFile = true;

			ReturnInvoiceService.deleteReturnInvoiceFile(resourcePath)
				.then(function(){
					const index = vm.fileList.findIndex(function(item){
						return !!item && !!item.fileData && item.fileData.id_return_invoice_file == file.id_return_invoice_file;
					});

					vm.fileList.splice(index, 1);
				})
				.catch(MessageService.showToast)
				.finally(function(){
					vm.isDeletingFile = false;
				})
		}
	}
})();
(function ()
{
	'use strict';

	angular
		.module('app.returnInvoice')
		.controller('BrowseReturnInvoiceController', BrowseReturnInvoiceController);

	function BrowseReturnInvoiceController(PartConstants, ReturnInvoiceConstants, $stateParams, $q, ReturnInvoiceService, LoginService, MessageService, ProgressService, HeaderHelper, GeneralTools, ToolsConstants, $location, constants){   
		const vm = this;
		const companyID = LoginService.getCompanyID();

		vm.displayOptions = [10, 25, 50, 100];

		vm.refreshInvoiceList = refreshInvoiceList;
		vm.onSortingChanged = onSortingChanged;

		init();

		function init(){
			initConstants();
			initStateParams();
			refreshInvoiceList(vm.currentPage);
		}

		function initConstants(){
			if(!constants){
				return;
			}

			vm.inventoryTypes = constants.inventoryTypes;
			vm.suppliers = constants.suppliers
		}

		function initStateParams(){	
			vm.supplierFilter = GeneralTools.urlNumberParamTranslator($stateParams.supplier);
			vm.invoiceSearchText = GeneralTools.urlStringParamTranslator($stateParams.invoiceNumber);
			vm.startDateFilter = GeneralTools.urlDateParamTranslator($stateParams.startDate);
			vm.endDateFilter = GeneralTools.urlDateParamTranslator($stateParams.endDate);

			vm.inventoryTypeFilter = GeneralTools.urlNumberParamTranslator($stateParams.type);
			vm.nameSearchText = GeneralTools.urlStringParamTranslator($stateParams.name);
			vm.codeSearchText = GeneralTools.urlStringParamTranslator($stateParams.code);

			vm.itemsPerPage = getDisplayOption(GeneralTools.urlNumberParamTranslator($stateParams.limit));
			vm.currentPage = GeneralTools.urlNumberParamTranslator($stateParams.page);

			vm.sortBy = GeneralTools.urlStringParamTranslator($stateParams.sortBy);
			vm.sortDirection = GeneralTools.urlStringParamTranslator($stateParams.sortDirection);
		}

		function getDisplayOption(itemPerPage){
			if(vm.displayOptions.indexOf(itemPerPage) == -1){
				return vm.displayOptions[0];
			}

			return itemPerPage;
		}

		function refreshInvoiceList(pageToGo) {
			const resourcePath = {
				companyID: companyID
			}

			ProgressService.setMode("indeterminate");
			ProgressService.isVisble(true);

			ReturnInvoiceService.getReturnInvoices(resourcePath, getFilter(), getPagination(pageToGo), getSorting())
				.then(function(result){
					if(!result){
						return $q.reject("Return Invoice result invalid.");
					}

					vm.returnInoviceList = result.data;

					resetPagination(result.headerGetter);
					refreshUrl();
				})
				.catch(MessageService.showToast)
				.finally(function(){
					ProgressService.isVisble(false);
				});
		}

		function getFilter(){
			var filterString = '';

			if(vm.supplierFilter){
				filterString = GeneralTools.stringConnector(filterString, GeneralTools.equalFilterBuilder(ReturnInvoiceConstants.keyNames.supplier, vm.supplierFilter), ToolsConstants.apiFilters.andConnector);
			}

			if(vm.invoiceSearchText){
				filterString = GeneralTools.stringConnector(filterString, GeneralTools.containFilterBuilder(ReturnInvoiceConstants.keyNames.invoiceNumber, vm.invoiceSearchText), ToolsConstants.apiFilters.andConnector);
			}

			if(vm.startDateFilter){
				filterString = GeneralTools.stringConnector(filterString, getTimeRangeFilter(vm.startDateFilter, false), ToolsConstants.apiFilters.andConnector);
			}

			if(vm.endDateFilter){
				filterString = GeneralTools.stringConnector(filterString, getTimeRangeFilter(vm.endDateFilter, true), ToolsConstants.apiFilters.andConnector);
			}

			if(vm.inventoryTypeFilter){
				filterString = GeneralTools.stringConnector(filterString, GeneralTools.equalFilterBuilder(PartConstants.keyNames.type, vm.inventoryTypeFilter), ToolsConstants.apiFilters.andConnector);
			}

			if(vm.nameSearchText){
				filterString = GeneralTools.stringConnector(filterString, GeneralTools.containFilterBuilder(PartConstants.keyNames.name, vm.nameSearchText), ToolsConstants.apiFilters.andConnector);
			}

			if(vm.codeSearchText){
				filterString = GeneralTools.stringConnector(filterString, GeneralTools.containFilterBuilder(PartConstants.keyNames.code, vm.codeSearchText), ToolsConstants.apiFilters.andConnector);
			}

			if(filterString){
				return { filters: filterString };
			}
		}

		function getTimeRangeFilter(dateObj, isBeforeDate){
			const momentObj = moment(dateObj);

			if(!dateObj || !momentObj.isValid()){
				return;
			}

			if(isBeforeDate){
				return GeneralTools.equalOrLesshanFilterBuilder(ReturnInvoiceConstants.keyNames.returnDate, momentObj.format(ReturnInvoiceConstants.returnDateFormat));
			}

			return GeneralTools.equalOrGreaterThanFilterBuilder(ReturnInvoiceConstants.keyNames.returnDate, momentObj.format(ReturnInvoiceConstants.returnDateFormat));
		}

		function getPagination(page){
			return {
				page: page,
				limit: vm.itemsPerPage
			}
		}

		function getSorting(){
			return {
				sortBy: vm.sortBy,
				sortDirection: vm.sortDirection
			};
		}

		function resetPagination(headerGetter){
			vm.totalCount = HeaderHelper.getPaginationTotalItem(headerGetter);
			vm.currentPage = HeaderHelper.getPaginationCurrentPage(headerGetter);
		}

		function refreshUrl(){
			const urlParams = {};
			const startDateMoment = moment(vm.startDateFilter);
			const endDateMoment = moment(vm.endDateFilter);

			urlParams.limit = vm.itemsPerPage === undefined ? undefined : vm.itemsPerPage + '';
			urlParams.page = vm.currentPage === undefined ? undefined : vm.currentPage + '';
			urlParams.supplier = vm.supplierFilter === undefined ? undefined : vm.supplierFilter + '';
			urlParams.invoiceNumber = vm.invoiceSearchText === undefined ? undefined : vm.invoiceSearchText + '';
			urlParams.type = vm.inventoryTypeFilter === undefined ? undefined : vm.inventoryTypeFilter + '';
			urlParams.name = vm.nameSearchText === undefined ? undefined : vm.nameSearchText + '';
			urlParams.code = vm.codeSearchText === undefined ? undefined : vm.codeSearchText + '';
			urlParams.sortBy = vm.sortBy === undefined ? undefined : vm.sortBy + '';
			urlParams.sortDirection = vm.sortDirection === undefined ? undefined : vm.sortDirection + '';

			if(vm.startDateFilter && startDateMoment.isValid()){
				urlParams.startDate = startDateMoment.format(ReturnInvoiceConstants.returnDateFormat);
			}

			if(vm.endDateFilter && endDateMoment.isValid()){
				urlParams.endDate = endDateMoment.format(ReturnInvoiceConstants.returnDateFormat);
			}

			$location.search(urlParams).replace();
		}

		function onSortingChanged(sortBy, sortDirection){
			vm.sortBy = sortBy;
			vm.sortDirection = sortDirection;

			refreshInvoiceList(1);
		}
	}
})();
(function ()
{
	"use strict";

	angular
		.module("app.returnInvoice")
		.component("returnInvoiceList", {
				bindings:{
					returnInvoiceList:'=',
					suppliers:'<',
					sortBy:'<',
					sortDirection:'<',
					onSortingChanged: '<'
				},
				templateUrl: "app/main/return-invoice/components/return-invoice-list.html",
				controller: componentController,
		  		controllerAs: 'vm'
			});

		function componentController(GeneralTools, Inventory, $scope, $state, ReturnInvoiceConstants, ToolsConstants){
			const vm = this;
			const keyNames = ReturnInvoiceConstants.keyNames;
			const sortingDirections = ToolsConstants.apiSortingDirections;

			vm.directionDesc = sortingDirections.DESC;
			vm.directionAsc = sortingDirections.ASC;

			vm.sortTagInvoiceNumber = keyNames.invoiceNumber;
			vm.sortTagDate = keyNames.returnDate;
			vm.sortTagSupplier = keyNames.supplier;

			vm.$onInit = initComponent;
			vm.getInvoicePageUrl = getInvoicePageUrl;
			vm.changeSorting = changeSorting;
			vm.getSupplierName = getSupplierName;

			function initComponent(){
				if(!Array.isArray(vm.suppliers)){
					vm.suppliers = [];
				}
			}

			function getSupplierName(supplierID) {
				const matchedSupplier = vm.suppliers.find(function(supplier){
					return !!supplier && supplier.id_supplier == supplierID;
				});
				
				if(!!matchedSupplier){
					return matchedSupplier.name;
				}

				return "Unknown";
			}

			function getInvoicePageUrl(returnInvoice){
				if(!returnInvoice){
					return;
				}

				return $state.href("app.edit-return-invoice", {returnInvoiceID: returnInvoice.id_return_invoice});
			}

			function changeSorting(sortTag) {
				if(vm.sortBy == sortTag){
					vm.sortDirection = vm.sortDirection == vm.directionAsc ? vm.directionDesc : vm.directionAsc;
				} else {
					vm.sortDirection = vm.directionAsc;
				}

				vm.sortBy = sortTag;

				if(typeof(vm.onSortingChanged) == "function"){
					vm.onSortingChanged(vm.sortBy, vm.sortDirection);
				}
			}
		}
})();
(function ()
{
	"use strict";

	angular
		.module("app.returnInvoice")
		.component("returnInvoiceInfoForm", {
				bindings:{
					returnInvoice:'=',
					suppliers:'<',
					isFormValid:'=',
					isProcessingData: "=",
					originInvoice:'<'
				},
				templateUrl: "app/main/return-invoice/components/return-invoice-info-form.html",
				controller: componentController,
		  		controllerAs: 'vm'
			});

		function componentController(GeneralTools, ReturnInvoice, ReturnInvoiceService, $scope, LoginService, $q, MessageService, $state, ReturnInvoiceConstants, ToolsConstants){
			const vm = this;
			const companyID = LoginService.getCompanyID();

			var exsitingReturnInvoiceID;

			vm.invoiceNumberPattern = ReturnInvoiceConstants.invoiceNumberPattern;
			vm.$onInit = initComponent;
			vm.$postLink = initOutPutCallbacks;
			vm.getReturnInvoicePageUrl = getReturnInvoicePageUrl;
			vm.setReturnDate = setReturnDate;

			vm.translateToDollar = GeneralTools.inputTranslators.dollar;
			vm.translateToPercentage = GeneralTools.inputTranslators.percentage;

			vm.taxRateInputOption = {
				decimalFractionSize:0,
				canBeNegative:false
			};

			vm.duplicateValidatorName = "duplicateCheck";

			vm.invoiceNumberValidation = [
				{
					name:vm.duplicateValidatorName,
					validateFn:checkInvoiceNumber
				}
			]

			vm.suppplierValidation = [
				{
					name:vm.duplicateValidatorName,
					validateFn:checkSupplier
				}
			]

			function initComponent(){
				initSuppliers();
				initReturnInvoice();
			}

			function  initSuppliers(argument) {
				if(!Array.isArray(vm.suppliers)){
					vm.suppliers = [];
				}
			}

			function initReturnInvoice(argument) {
				if(!vm.returnInvoice){
					vm.returnInvoice = new ReturnInvoice();
				}

				vm.datePickerValue = vm.returnInvoice.getReturnDateMomentObj();
			}

			function setReturnDate(){
				vm.returnInvoice.setReturnDate(moment(vm.datePickerValue));
			}

			function initOutPutCallbacks(){
				vm.isFormValid = isFormValid;
			}

			function isFormValid(){
				$scope.returnInvoiceInfoForm.$submitted = true;
				return $scope.returnInvoiceInfoForm.$valid;
			};

			function checkInvoiceNumber(modelValue, viewValue){
				if(vm.originInvoice.invoice_number == modelValue && vm.originInvoice.fk_id_supplier == vm.returnInvoice.fk_id_supplier){
					$scope.returnInvoiceInfoForm.supplier.$setValidity(vm.duplicateValidatorName, true);
					return $q.resolve();
				}

				return duplicateCheck(modelValue, vm.returnInvoice.fk_id_supplier)
					.then(function(){
						$scope.returnInvoiceInfoForm.supplier.$setValidity(vm.duplicateValidatorName, true);
						return $q.resolve()
					});
			}

			function checkSupplier(modelValue, viewValue){
				if(vm.originInvoice.fk_id_supplier == modelValue && vm.originInvoice.invoice_number == vm.returnInvoice.invoice_number){
					$scope.returnInvoiceInfoForm.invoiceNumber.$setValidity(vm.duplicateValidatorName, true)
					return $q.resolve();
				}

				return duplicateCheck(vm.returnInvoice.invoice_number, modelValue)
					.then(function(){
						$scope.returnInvoiceInfoForm.invoiceNumber.$setValidity(vm.duplicateValidatorName, true)
						return $q.resolve()
					});
			}

			function duplicateCheck(invoiceNumber, supplierID){
				var defer = $q.defer();

				if(!invoiceNumber || !supplierID){
					return $q.resolve();
				}

				var filterString = '';

				filterString = GeneralTools.equalFilterBuilder(ReturnInvoiceConstants.keyNames.invoiceNumber, invoiceNumber);
				filterString = GeneralTools.stringConnector(filterString, GeneralTools.equalFilterBuilder(ReturnInvoiceConstants.keyNames.supplier, supplierID), ToolsConstants.apiFilters.andConnector);

				const resourcePath = { companyID: companyID };
				const filter = {filters: filterString};

				ReturnInvoiceService.getReturnInvoices(resourcePath, filter)
					.then(function(result){
						if(result && Array.isArray(result.data) && result.data.length > 0){
							exsitingReturnInvoiceID = result.data[0].id_return_invoice;
							defer.reject();
						} else {
							exsitingReturnInvoiceID = null;
							defer.resolve();
						}
					})
					.catch(MessageService.showToast)

				return defer.promise;
			}

			function getReturnInvoicePageUrl() {
				if(exsitingReturnInvoiceID){
					return $state.href("app.edit-return-invoice", {returnInvoiceID: exsitingReturnInvoiceID});
				}
			}
		}
})();
(function ()
{
	'use strict';

	angular
		.module('app.purchaseInvoice', [])
		.constant("PurchaseInvoiceConstants", {
			keyNames:{
				purchaseDate: "purchase_invoice.purchase_date",
				invoiceNumber: "purchase_invoice.invoice_number",
				supplier: "purchase_invoice.fk_id_supplier",

				partType: "part.fk_id_part_type",
				partName: "part.name",
				partCode: "part.code"
			},
			invoiceNumberPattern:/^[\w\d\-]*$/,
			purchaseDateFormat: "YYYY-MM-DD"
		})
		.config(config)
		.run(run)

	function run(msNavigationService, LoginService, PurchaseInvoiceConstants){
		/*msNavigationService.saveItem("purchase-invoice", {
			title : "PURCHASE INVOICE",
			icon : "icon-car",
			weight: 3,
			requiredRoles:[]			 
		});

		msNavigationService.saveItem('purchase-invoice.browse-purchase-invoices', {
			title: 'Browse Invoices',
			state: 'app.browse-purchase-invoices',
			requiredRoles:[]	
		});*/

/*		msNavigationService.saveItem('inventory.add-purchase-invoice', {
			title: 'Add Inventory',
			state: 'app.add-purchase-invoice',
			requiredRoles:[]			 
		});

		*/
	}

	/** @ngInject */
	function config($stateProvider)
	{	  
		$stateProvider
			.state('app.browse-purchase-invoices', {
				url : '/purchaseinvoices?supplier&invoiceNumber&startDate&endDate&type&name&code&limit&page&sortBy&sortDirection',
				reloadOnSearch : false,
				views	: {
					'content@app': {
						templateUrl: 'app/main/purchase-invoice/browse-purchase-invoices/browse-purchase-invoices.html',
						controller : 'BrowsePurchaseInvoiceController as vm'
					}
				},
				resolve :{
					constants:function(MessageService, PurchaseInvoiceService, InventoryService, $q, LoginService){
						const resourcePath = { companyID: LoginService.getCompanyID() };
						const queue = { 
							suppliers: PurchaseInvoiceService.getCachedSuppliers(resourcePath),
							inventoryTypes: InventoryService.getInventoryTypes() 
						};

						return $q.all(queue).catch(MessageService.showToast);
					}
				}
			})
			.state('app.edit-purchase-invoice', {
				url : '/editpurchaseinvocie/{purchaseInvoiceID}',
				views	: {
					'content@app': {
						templateUrl: 'app/main/purchase-invoice/edit-purchase-invoice/edit-purchase-invoice.html',
						controller : 'EditPurchaseInvoiceController as vm'
					}
				},
				resolve :{
					constants:function(MessageService, PurchaseInvoiceService, InventoryService, $q, LoginService){
						const resourcePath = { companyID: LoginService.getCompanyID() };
						const queue = { 
							suppliers: PurchaseInvoiceService.getCachedSuppliers(resourcePath),
							partTypes: InventoryService.getInventoryTypes() 
						};

						return $q.all(queue).catch(MessageService.showToast);
					},
					purchaseInvoice:function(MessageService, PurchaseInvoiceService, $q, LoginService, $stateParams){
						const resourcePath = { 
							companyID: LoginService.getCompanyID(),
							purchaseinvoiceID: $stateParams.purchaseInvoiceID
						};

						return PurchaseInvoiceService.getPurchaseInvoices(resourcePath).catch(MessageService.showToast);
					},
					parts:function(MessageService, PartService, $q, LoginService, $stateParams, PartConstants){
						const resourcePath = { 
							companyID: LoginService.getCompanyID()
						};

						const filters = { filters: '(' + PartConstants.keyNames.purchaseInvoiceID + ' eq ' + $stateParams.purchaseInvoiceID + ')'}

						return PartService.getAllMatchedParts(resourcePath, filters).catch(MessageService.showToast);
					},
					files:function(MessageService, PurchaseInvoiceService, $q, LoginService, $stateParams, PartConstants){
						const resourcePath = { 
							companyID: LoginService.getCompanyID(),
							purchaseinvoiceID: $stateParams.purchaseInvoiceID
						};

						return PurchaseInvoiceService.getPurchaseInvoiceFiles(resourcePath).catch(MessageService.showToast);
					}
				}
			})

/*		
			
			.state('app.add-purchase-invoice', {
				url : '/addinventory',
				views	: {
					'content@app': {
						templateUrl: 'app/main/inventory/add-purchase-invoice/add-purchase-invoice.html',
						controller : 'AddInventoryController as vm'
					}
				},
				resolve :{
					constants:function(MessageService, InventoryService, $q, LoginService){
						const resourcePath = { companyID: LoginService.getCompanyID() };
						const queue = { 
							inventoryTypes: InventoryService.getInventoryTypes()
						};

						return $q.all(queue).catch(MessageService.showToast);
					}
				}
			});*/
			
	}

})();
(function ()
{
	'use strict';

	angular
		.module('app.purchaseInvoice')
		.controller('EditPurchaseInvoiceController', EditPurchaseInvoiceController);

	function EditPurchaseInvoiceController($scope, PartConstants, WorkOrderPart, PartTableItem, $sce, FileViewService, ReturnInvoiceService, $stateParams, GeneralTools, ToolsConstants, $timeout, $q, MessageService, constants, LoginService, ProgressService, DialogService, $state, purchaseInvoice, PurchaseInvoiceService, parts, Part, PartService, files, FileUploadService){   
		const vm = this;
		const companyID = LoginService.getCompanyID();
		const purchaseInvoiceID = $stateParams.purchaseInvoiceID;
		const confirmString = "CONFIRM";
		const uploadingWarning = "File is still uploading, are you sure to leave?"
		var originParts;
		
		const partTableTabAll = {
			name: "all",
			title: "All",
			rowClass: getRowClass
		};

		const partTableTabReturned = {
			name: "returned",
			title: "RETURNED",
			filter: isPartReturned,
			rowClass: getRowClass
		};

		vm.partTableTabs = [
			partTableTabAll,
			partTableTabReturned
		];

		vm.fileUploader = FileUploadService.getNewUploader();
		vm.fileUploader.filters.push(FileUploadService.getSizeFilter(20));
		vm.returnInvoiceMap = {};

		vm.onPartTableTabChange = onPartTableTabChange
		vm.pullDataFromInventory = pullDataFromInventory;
		vm.deletePurchaseInvoice = deletePurchaseInvoice;

		vm.onFileDelete = onFileDelete;
		vm.addNewPart = addNewPart;
		vm.isAnyPartSelected = isAnyPartSelected;
		vm.removeSelectedParts = removeSelectedParts;	
		vm.save = save;

		init();

		function init(){
			initConstants();
			initPurchaseInvoice();
			initParts();
			initFiles();
			initObservers();
		}

		function initObservers(){
			$scope.$on("$stateChangeStart", function(event, toState, toParams, fromState, fromParams){
				if(!vm.fileUploader.isUploading){
					return;
				}

				event.preventDefault();
				DialogService.showYesOrNoDialog(null, uploadingWarning)
					.then(function(isYes){
						if(isYes){
							vm.fileUploader.cancelAll()
							$state.go(toState.name, toParams);
							return;
						}
					})
					.catch(function(error){
						if(error){
							MessageService.showToast(error);
						}
					});
			});
		}

		function initFiles(){
			if(!Array.isArray(files)){
				return;
			}

			vm.fileList = [];

			files.forEach(function(file){
				vm.fileList.push({fileData: file});
			});

			initFilesPreviewUrl();
		}

		function initFilesPreviewUrl(){
			if(!Array.isArray(vm.fileList)){
				return;
			}

			vm.fileList.forEach(function(item){
				if(!item || !item.fileData){
					return;
				}

				if(!item.fileData.isImage() && !item.fileData.isPdf()){
					return;
				}

				if(item.fileData.isPublic()){
					item.previewUrl = item.fileData.getURL();
				} else {
					initPreviewUrl(item.fileData);
				}
			});
		}

		function initPreviewUrl(file){
			if(!file || !Array.isArray(vm.fileList)){
				return;
			}

			const options = {
				width:200,
				quality:30
			};

			FileViewService.downloadFile(file.getResourcePath(), options)
				.then(function(response){
					const item = vm.fileList.find(function(item){
						return item && item.fileData && item.fileData.id_purchase_invoice_file == file.id_purchase_invoice_file;
					});
					
					item.previewUrl = URL.createObjectURL(new Blob([new Uint8Array(response.data)], {type: file.getFileType()}));
				});
		}

		function initConstants(){
			if(!constants){
				return;
			}

			vm.suppliers = constants.suppliers;
			vm.partTypes = constants.partTypes;
		}

		function initParts(){
			const returnInvoiceIdList = [];
			vm.partList = [];

			if(!Array.isArray(parts)){
				MessageService.showToast("Parts data is invaild.");
				return;
			}

			parts.forEach(function(part){
				const item = new PartTableItem();
				item.setPartData(part)
				vm.partList.push(item);

				const returnInvoiceID = part.fk_id_return_invoice;

				if(!!returnInvoiceID && returnInvoiceIdList.indexOf(returnInvoiceID) == -1){
					returnInvoiceIdList.push(returnInvoiceID);
				}
			});

			resetOriginParts();
			resetSummaryPartList();
			initReturnInvoices(returnInvoiceIdList);
			vm.invoiceMap = {};
			vm.invoiceMap[purchaseInvoiceID] = vm.purchaseInvoice;
		}

		function initReturnInvoices(invoiceIdList){
			if(!Array.isArray(invoiceIdList)){
				return;
			}

			invoiceIdList.forEach(function(invoiceID){
				if(!!invoiceID){
					initReturnInvoice(invoiceID);
				}
			});
		}

		function initReturnInvoice(invoiceID){
			const resourcePath = {
				companyID: companyID,
				returninvoiceID: invoiceID
			};

			ReturnInvoiceService.getReturnInvoices(resourcePath)
				.then(function(result){
					if(!result || !Array.isArray(result.data) || result.data.length != 1 || !result.data[0]){
						return $q.reject("invoice with id: " + invoiceID + " is invaild");
					}

					vm.returnInvoiceMap[invoiceID] = result.data[0];
				});
		}

		function resetOriginParts(){
			const parts = [];

			vm.partList.forEach(function(item){
				if(!item || !item.partData || !item.partData.id_part){
					return;
				}

				parts.push(item.partData);
			});

			originParts = angular.copy(parts);
		}

		function initPurchaseInvoice(){
			if(!purchaseInvoice || !Array.isArray(purchaseInvoice.data) || purchaseInvoice.data.length != 1 || !purchaseInvoice.data[0]){
				MessageService.showToast("PurchaseInvoice data invalid");
				return;
			}
			vm.purchaseInvoice = purchaseInvoice.data[0];

			vm.originPurchaseInvoice = angular.copy(vm.purchaseInvoice);
		}

		vm.fileUploader.onAfterAddingFile = function(fileItem){
			if((fileItem.file.type.indexOf("image") != -1 || fileItem.file.type.indexOf("pdf") != -1)){
				var url = URL.createObjectURL(fileItem._file);
				fileItem.previewUrl = $sce.trustAsResourceUrl(url);
			}
			
			fileItem.url = FileUploadService.getUrlForCreatePurchaseInvoiceFile(vm.purchaseInvoice.id_purchase_invoice);
			fileItem.upload();
		}

		vm.fileUploader.onCompleteItem = function(item, response, status, headers){
			if(!FileUploadService.isUploadSuccess(headers) && headers.message){
				MessageService.showToast(headers.message);
				return;
			}

			var resourcePath = {
				companyID: companyID,
				purchaseinvoiceID: vm.purchaseInvoice.id_purchase_invoice,
				fileID: response.data
			};

			PurchaseInvoiceService.getPurchaseInvoiceFiles(resourcePath)
				.then(function(files){
					if(!Array.isArray(files)){
						return $q.reject("Purchase info file data is invalid.");
					}

					vm.fileList.push({
						fileData: files[0],
						previewUrl: item.previewUrl
					});
					item.remove();
				})
				.catch(MessageService.showToast);
		}

		function onFileDelete(fileItem){
			if(!fileItem || !fileItem.fileData){
				return;
			}
			const dialogOptions = {};

			dialogOptions.titleString = "Delete File";
			dialogOptions.contentString = "Are you sure to delete " + fileItem.fileData.file_name + '?';

			const confirmOption = {};

			confirmOption.optionName = "YES";
			confirmOption.onClick = function(){
				confirmDeleteFileCallback(fileItem.fileData);
				DialogService.close();
			}

			var cancelOption = {};

			cancelOption.optionName = "NO";
			cancelOption.onClick = function(){
				DialogService.close();
			}

			dialogOptions.options = [confirmOption, cancelOption];

			DialogService.showOptionsDialog(dialogOptions);

		}

		function confirmDeleteFileCallback(file){
			if(!file){
				return;
			}

			const resourcePath = {
				companyID: companyID,
				purchaseinvoiceID: vm.purchaseInvoice.id_purchase_invoice,
				fileID: file.id_purchase_invoice_file
			}

			vm.isDeletingFile = true;

			PurchaseInvoiceService.deletePurchaseInvoiceFile(resourcePath)
				.then(function(){
					const index = vm.fileList.findIndex(function(item){
						return !!item && !!item.fileData && item.fileData.id_purchase_invoice_file == file.id_purchase_invoice_file;
					});

					vm.fileList.splice(index, 1);
				})
				.catch(MessageService.showToast)
				.finally(function(){
					vm.isDeletingFile = false;
				})
		}

		function addNewPart(){
			const part = getNewBasicPart();
			const item = new PartTableItem();

			item.setPartData(part)
			vm.partList.push(item);

			resetSummaryPartList();
		}

		function getNewBasicPart(){
			const part = new WorkOrderPart();

			part.setAttributes({
				is_ordered: true,
				fk_id_purchase_invoice: purchaseInvoiceID,
				fk_id_part_type: PartConstants.partTypeIDs.OTHER,
				purchase_tax_rate: ToolsConstants.taxRate
			});

			if(vm.partTableTabs[vm.currentPartTableTabIndex] && vm.partTableTabs[vm.currentPartTableTabIndex].name == partTableTabReturned.name){
				part.is_returned = true;
			}

			return part;
		}

		function save(){
			if(!vm.isPurchaseInfoFormValid()){
				MessageService.showToast("Something wrong in work order infos.");
				return;
			}

			if(!vm.isPartTableValid()){
				MessageService.showToast("Something wrong in parts table.");
				return;
			}

			const queue = [];
			const purchaseInvoiceRequestBody = GeneralTools.updateResourceRequestBodyGenerator(vm.purchaseInvoice, vm.originPurchaseInvoice);
			const partsRequestBody = getPartsRequestBodys();

			if(purchaseInvoiceRequestBody){
				queue.push(updatePurchaseInvoice(purchaseInvoiceRequestBody));
			}

			if(partsRequestBody){
				queue.push(saveParts(partsRequestBody));
			}

			if(queue.length <= 0){
				MessageService.showToast("No changes detected.");
				return;
			}

			vm.isSaving = true;

			$q.all(queue)
				.then(function(){
					MessageService.showToast("Success.")
				})
				.catch(MessageService.showToast)
				.finally(function(){
					vm.isSaving = false;
				});
		}

		function getPartsRequestBodys(){
			const partsToCreate = [];
			const partsToUpdate = [];

			vm.partList.forEach(function(item, index){
				if(!item || !item.partData){
					return;
				}

				if(!item.partData.id_part){
					partsToCreate.push({
						index: index,
						requestBody: item.partData
					});
					return;
				}

				const changedProperties = getUpdatePartRequestBody(item.partData);

				if(!!changedProperties){
					partsToUpdate.push({
						requestBody: changedProperties,
						partID: item.partData.id_part
					});
				}
			});

			if(partsToCreate.length <= 0 && partsToUpdate.length <= 0){
				return;
			}

			return {
				partsToCreate: partsToCreate,
				partsToUpdate: partsToUpdate
			};
		}

		function getUpdatePartRequestBody(part){
			if(!part || !part.id_part){
				return;
			}

			const originPart = originParts.find(function(item){
				if(!item){
					return;
				}

				return item.id_part == part.id_part;
			});

			if(!originPart){
				return;
			}

			const changedProperties = GeneralTools.updateResourceRequestBodyGenerator(part, originPart);

			if(!!changedProperties){
				return changedProperties;
			}
		}

		function updatePurchaseInvoice(requestBody){
			const resourcePath = { 
				companyID: companyID,
				purchaseinvoiceID: purchaseInvoiceID
			};

			return PurchaseInvoiceService.updatePurchaseInvoice(resourcePath, requestBody)
				.then(function(){
					vm.originPurchaseInvoice = angular.copy(vm.purchaseInvoice);
					return $q.resolve();
				});
		}

		function saveParts(requestBody){
			if(!requestBody){
				return;
			}

			return $q.all([createParts(requestBody.partsToCreate),updateParts(requestBody.partsToUpdate)])
				.then(function(){
					resetOriginParts();
					return $q.resolve();
				});
		}

		function createParts(requestBodyList){
			if(!Array.isArray(requestBodyList)){
				return $q.reject("createParts requestBodyList invalid");
			}

			const queue = [];

			requestBodyList.forEach(function(item){
				if(!item){
					return;
				}

				queue.push(createPart(item.requestBody, item.index));
			});

			return $q.all(queue);
		}

		function createPart(requestBody, index){
			const resourcePath = {
				companyID: companyID
			}

			return PartService.createPart(resourcePath, requestBody)
				.then(function(newPartId){
					vm.partList[index].partData.id_part = newPartId;
					return $q.resolve();
				})
		}

		function updateParts(requestBodyList){
			if(!Array.isArray(requestBodyList)){
				return $q.reject("updateParts requestBodyList invalid");
			}

			const queue = [];

			requestBodyList.forEach(function(item){
				if(!item){
					return;
				}

				const resourcePath = {
					companyID: companyID,
					partID: item.partID
				}

				queue.push(PartService.updatePart(resourcePath, item.requestBody));
			});

			return $q.all(queue);
		}

		function isAnyPartSelected(){
			if(!Array.isArray(vm.partList)){
				return;
			}

			const hasFilter = !!vm.partTableTabs[vm.currentPartTableTabIndex] && typeof(vm.partTableTabs[vm.currentPartTableTabIndex].filter) == "function";

			const selectedPart = vm.partList.find(function(item) {
				return (!hasFilter || vm.partTableTabs[vm.currentPartTableTabIndex].filter(item)) && !!item && !!item.isSelected;
			});

			return !!selectedPart;
		}

		function removeSelectedParts(){
			const existingPartIdList = [];
			const newPartIndexList = [];

			vm.partList.forEach(function(item, index){
				if(!item || !item.isSelected){
					return;
				}

				if(!!item.partData.id_part){
					existingPartIdList.push(item.partData.id_part);
				} else {
					newPartIndexList.push(index);
				}
			});

			if(existingPartIdList.length > 0){
				showDeletePartsDialog(existingPartIdList, newPartIndexList);
			} else {
				removeNewParts(newPartIndexList);
				resetSummaryPartList();
				MessageService.showToast("Parts are removed.");
			}
		}

		function removeNewParts(newPartIndexList){
			if(!Array.isArray(newPartIndexList)){
				return;
			}

			newPartIndexList.reverse();

			newPartIndexList.forEach(function(index){
				vm.partList.splice(index, 1);
			});
		}

		function showDeletePartsDialog(existingPartIdList, newPartIndexList){
			var dialogOptions = {};

			dialogOptions.titleString = "Remove Parts";
			dialogOptions.contentString = "Are you sure to remove selected items";

			var confirmOption = {};

			confirmOption.optionName = "YES";
			confirmOption.onClick = function(){
				confirmDeleteParts(existingPartIdList, newPartIndexList);
				DialogService.close();
			}

			var cancelOption = {};

			cancelOption.optionName = "NO";
			cancelOption.onClick = function(){
				DialogService.close();
			}

			dialogOptions.options = [confirmOption, cancelOption];

			DialogService.showOptionsDialog(dialogOptions);
		}

		function confirmDeleteParts(existingPartIdList, newPartIndexList){
			removeNewParts(newPartIndexList);

			if(!Array.isArray(existingPartIdList)){
				return;
			}

			vm.isDeleting = true;

			const queue = [];

			existingPartIdList.forEach(function(partID){
				queue.push(deletePart(partID));
			});

			$q.all(queue)
				.then(function(){
					resetOriginParts();
					resetSummaryPartList();
					MessageService.showToast("Parts are removed.");
				})
				.catch(MessageService.showToast)
				.finally(function(){
					vm.isDeleting = false;
				})
		}

		function deletePart(partID){
			const resourcePath = {
				companyID: companyID,
				partID: partID
			}

			return PartService.deletePart(resourcePath)
				.then(function(){
					const index = vm.partList.findIndex(function(item){
						return !!item && item.partData.id_part == partID;
					});

					vm.partList.splice(index, 1);

					return $q.resolve();
				});
		}
		
		function deletePurchaseInvoice (){
			var dialogOptions = {};

			dialogOptions.inputBoxPlaceHolder = "Enter here";
			dialogOptions.cancelButtonString = "CANCEL";
			dialogOptions.confirmButtonString = "CONFIRM";
			dialogOptions.titleString = "ARE YOU SURE TO DELETE THIS INVENTORY";
			dialogOptions.contentString = "Please Type \"" + confirmString + "\" below:";

			dialogOptions.confirmCallback = confirmDeletePurchaseInvoiceCallback;
			dialogOptions.enableConfirmButtonCallback = enableDeleteVehicleButtonCallback;

			DialogService.showConfirmDialog(dialogOptions);
		}

		function enableDeleteVehicleButtonCallback(inputString){
			if(inputString === confirmString){
				return true;
			}
			return false;
		}

		function confirmDeletePurchaseInvoiceCallback(){
			const resourcePath = { 
				companyID: companyID,
				purchaseinvoiceID: vm.purchaseInvoice.id_purchase_invoice
			};

			vm.isDeleting = true;
			ProgressService.setMode("indeterminate");
			ProgressService.isVisble(true);

			PurchaseInvoiceService.deletePurchaseInvoice(resourcePath)
				.then(function(){
					MessageService.showToast("Success");
					$state.go("app.browse-purchase-invoices");
				})
				.catch(MessageService.showToast)
				.finally(function(){
					vm.isDeleting = false;
					ProgressService.isVisble(false);
				});
		}

		function pullDataFromInventory(item, inventory){
			if(!item || !inventory){
				return;
			}
			
			item.name = inventory.name;
			item.code = inventory.code;
			item.retailPrice = inventory.retail_price;
			item.suggestedRetailPrice = inventory.retail_price;
			item.cost = inventory.purchase_price;
			item.updateProperties();
		}

		function getRowClass(item) {
			if(!item){
				return;
			} 

			if(item.inventoryData){
				return [PartConstants.styleClasses.orderedInvoiced];
			}

			if(!item.partData){
				return;
			}

			if(item.partData.is_returned){
				return [PartConstants.styleClasses.returnedForTable];
			}

			if(!item.partData.is_ordered){
				return [PartConstants.styleClasses.notOrdered];
			}

			if(item.partData.fk_id_purchase_invoice){
				return [PartConstants.styleClasses.orderedInvoiced];
			} else {
				return [PartConstants.styleClasses.orderedUninvoiced];
			}
		}

		function isPartOrdered(item){
			if(!item){
				return;
			}

			if(!!item.inventoryData){
				return true;
			}

			if(!!item.partData && item.partData.is_ordered && !item.partData.is_returned){
				return true;
			}
		}

		function isPartNotOrdered(item){
			return !!item && !!item.partData && !item.partData.is_ordered && !item.partData.is_returned;
		}

		function isPartReturned (item){
			return !!item && !!item.partData && item.partData.is_returned;
		}

		function getNotOrderTabClass(){
			if(!Array.isArray(vm.partList)){
				return;
			}

			var anyItemInCurrentTab = false;
			const matchedItem = vm.partList.find(function(item){
				if(!item || !item.partData || !isPartNotOrdered(item)){
					return;
				}

				anyItemInCurrentTab = true;
			});

			if(!anyItemInCurrentTab){
				return;
			}

			return [PartConstants.styleClasses.notOrdered];
		}

		function getOrderedTabClass() {
			if(!Array.isArray(vm.partList)){
				return;
			}

			var anyItemInCurrentTab = false;
			const matchedItem = vm.partList.find(function(item){
				if(!item || !item.partData || !isPartOrdered(item)){
					return;
				}

				anyItemInCurrentTab = true;

				if(!item.partData.fk_id_purchase_invoice || !item.partData.is_ordered){
					return true;
				}
			});

			if(!anyItemInCurrentTab){
				return;
			}

			if(matchedItem){
				return [PartConstants.styleClasses.orderedUninvoiced];
			}

			return [PartConstants.styleClasses.orderedInvoiced];
		}

		function onPartTableTabChange(tab){
			if(!tab){
				return;
			}

			switch(tab.name){
				case partTableTabAll.name:
					vm.hiddenColumns = {
						suggestedRetailPrice: true,
						invoice: true,
						returnInvoice: true
					}
					return;
/*				case partTableTabOrdered.name:
					vm.hiddenColumns = {
						suggestedRetailPrice: true,
						invoice: true,
						returnInvoice: true
					}
					return;
				case partTableTabNotOrdered.name:
					vm.hiddenColumns = {
						suggestedRetailPrice: true,
						invoice: true,
						returnInvoice: true
					}
					return;*/
				case partTableTabReturned.name:
					vm.hiddenColumns = {
						invoice: true,
						suggestedRetailPrice: true,
						returnInvoice: true
					}
					return;
			}
		}

		function resetSummaryPartList(){
			const partList = [];

			if(!Array.isArray(vm.partList)){
				return;
			}

			vm.partList.forEach(function(item){
				if(item){
					partList.push(item.partData);
				}	
			});

			vm.summaryPartList = partList;
		}
	}
})();
(function ()
{
	"use strict";

	angular
		.module("app.purchaseInvoice")
		.component("purchaseInvoiceReturnList", {
				bindings:{
					purchaseInvoiceList:'=',
					suppliers:'<',
					sortBy:'<',
					sortDirection:'<',
					onSortingChanged: '<',
					invoiceTotalCost: '='
				},
				templateUrl: "app/main/purchase-invoice/components/purchase-invoice-return-list.html",
				controller: componentController,
		  		controllerAs: 'vm'
			});

		function componentController(GeneralTools, Inventory, $scope, $state, PurchaseInvoiceConstants, ToolsConstants){
			const vm = this;
			const keyNames = PurchaseInvoiceConstants.keyNames;
			const sortingDirections = ToolsConstants.apiSortingDirections;

			vm.directionDesc = sortingDirections.DESC;
			vm.directionAsc = sortingDirections.ASC;

			vm.sortTagInvoiceNumber = keyNames.invoiceNumber;
			vm.sortTagDate = keyNames.purchaseDate;
			vm.sortTagSupplier = keyNames.supplier;

			vm.sortTagTotalCost = 'totalcost';

			vm.totalOrder = 0;

			vm.$onInit = initComponent;
			vm.getInvoicePageUrl = getInvoicePageUrl;
			vm.changeSorting = changeSorting;
			vm.getSupplierName = getSupplierName;
			vm.toggleItemList = toggleItemList;

			function initComponent(){
				if(!Array.isArray(vm.suppliers)){
					vm.suppliers = [];
				}
			}

			function toggleItemList() {
				var itemList = document.getElementById("item-return-list");
				var tab = document.querySelector(".tab");
	
				if (itemList.style.display === "none") {
					itemList.style.display = "block";
					tab.classList.add("active");
				} else {
					itemList.style.display = "none";
					tab.classList.remove("active");
				}
			}

			function getSupplierName(supplierID) {
				const matchedSupplier = vm.suppliers.find(function(supplier){
					return !!supplier && supplier.id_supplier == supplierID;
				});
				
				if(!!matchedSupplier){
					return matchedSupplier.name;
				}

				return "Unknown";
				
			}

			function getInvoicePageUrl(purchaseInvoice){
				if(!purchaseInvoice){
					return;
				}

				return $state.href("app.edit-purchase-invoice", {purchaseInvoiceID: purchaseInvoice.id_purchase_invoice});
			}

			function changeSorting(sortTag) {
				if(vm.sortBy == sortTag){
					vm.sortDirection = vm.sortDirection == vm.directionAsc ? vm.directionDesc : vm.directionAsc;
				} else {
					vm.sortDirection = vm.directionAsc;
				}

				vm.sortBy = sortTag;

				if(typeof(vm.onSortingChanged) == "function"){
					vm.onSortingChanged(vm.sortBy, vm.sortDirection);
				}
			}


		}
})();
(function ()
{
	"use strict";

	angular
		.module("app.purchaseInvoice")
		.component("purchaseInvoiceOutstandingList", {
				bindings:{
					purchaseInvoiceList:'=',
					suppliers:'<',
					sortBy:'<',
					sortDirection:'<',
					onSortingChanged: '<',
					invoiceTotalCost: '='
				},
				templateUrl: "app/main/purchase-invoice/components/purchase-invoice-outstanding-list.html",
				controller: componentController,
		  		controllerAs: 'vm'
			});

		function componentController(GeneralTools, Inventory, $scope, $state, PurchaseInvoiceConstants, ToolsConstants){
			const vm = this;
			const keyNames = PurchaseInvoiceConstants.keyNames;
			const sortingDirections = ToolsConstants.apiSortingDirections;

			vm.directionDesc = sortingDirections.DESC;
			vm.directionAsc = sortingDirections.ASC;

			vm.sortTagInvoiceNumber = keyNames.invoiceNumber;
			vm.sortTagDate = keyNames.purchaseDate;
			vm.sortTagSupplier = keyNames.supplier;

			vm.sortTagTotalCost = 'totalcost';

			vm.totalOrder = 0;

			vm.$onInit = initComponent;
			vm.getInvoicePageUrl = getInvoicePageUrl;
			vm.changeSorting = changeSorting;
			vm.getSupplierName = getSupplierName;
			vm.toggleItemList = toggleItemList;

			function initComponent(){
				if(!Array.isArray(vm.suppliers)){
					vm.suppliers = [];
				}
			}

			function toggleItemList() {
				var itemList = document.getElementById("item-outstanding-list");
				var tab = document.querySelector(".tab");
	
				if (itemList.style.display === "none") {
					itemList.style.display = "block";
					tab.classList.add("active");
				} else {
					itemList.style.display = "none";
					tab.classList.remove("active");
				}
			}

			function getSupplierName(supplierID) {
				const matchedSupplier = vm.suppliers.find(function(supplier){
					return !!supplier && supplier.id_supplier == supplierID;
				});
				
				if(!!matchedSupplier){
					return matchedSupplier.name;
				}

				return "Unknown";
				
			}

			function getInvoicePageUrl(purchaseInvoice){
				if(!purchaseInvoice){
					return;
				}

				return $state.href("app.edit-purchase-invoice", {purchaseInvoiceID: purchaseInvoice.id_purchase_invoice});
			}

			function changeSorting(sortTag) {
				if(vm.sortBy == sortTag){
					vm.sortDirection = vm.sortDirection == vm.directionAsc ? vm.directionDesc : vm.directionAsc;
				} else {
					vm.sortDirection = vm.directionAsc;
				}

				vm.sortBy = sortTag;

				if(typeof(vm.onSortingChanged) == "function"){
					vm.onSortingChanged(vm.sortBy, vm.sortDirection);
				}
			}


		}
})();
(function ()
{
	"use strict";

	angular
		.module("app.purchaseInvoice")
		.component("purchaseInvoiceList", {
				bindings:{
					purchaseInvoiceList:'=',
					suppliers:'<',
					sortBy:'<',
					sortDirection:'<',
					onSortingChanged: '<',
					invoicePartList:'='
				},
				templateUrl: "app/main/purchase-invoice/components/purchase-invoice-list.html",
				controller: componentController,
		  		controllerAs: 'vm'
			});

		function componentController(GeneralTools, Inventory, $scope, $state, PurchaseInvoiceConstants, ToolsConstants){
			const vm = this;
			const keyNames = PurchaseInvoiceConstants.keyNames;
			const sortingDirections = ToolsConstants.apiSortingDirections;

			vm.directionDesc = sortingDirections.DESC;
			vm.directionAsc = sortingDirections.ASC;

			vm.sortTagInvoiceNumber = keyNames.invoiceNumber;
			vm.sortTagDate = keyNames.purchaseDate;
			vm.sortTagSupplier = keyNames.supplier;

			vm.$onInit = initComponent;
			vm.getInvoicePageUrl = getInvoicePageUrl;
			vm.changeSorting = changeSorting;
			vm.getSupplierName = getSupplierName;

			function initComponent(){
				if(!Array.isArray(vm.suppliers)){
					vm.suppliers = [];
				}
			}

			function getSupplierName(supplierID) {
				const matchedSupplier = vm.suppliers.find(function(supplier){
					return !!supplier && supplier.id_supplier == supplierID;
				});
				
				if(!!matchedSupplier){
					return matchedSupplier.name;
				}

				return "Unknown";
			}

			function getInvoicePageUrl(purchaseInvoice){
				if(!purchaseInvoice){
					return;
				}

				return $state.href("app.edit-purchase-invoice", {purchaseInvoiceID: purchaseInvoice.id_purchase_invoice});
			}

			function changeSorting(sortTag) {
				if(vm.sortBy == sortTag){
					vm.sortDirection = vm.sortDirection == vm.directionAsc ? vm.directionDesc : vm.directionAsc;
				} else {
					vm.sortDirection = vm.directionAsc;
				}

				vm.sortBy = sortTag;

				if(typeof(vm.onSortingChanged) == "function"){
					vm.onSortingChanged(vm.sortBy, vm.sortDirection);
				}
			}
		}
})();
(function ()
{
	"use strict";

	angular
		.module("app.purchaseInvoice")
		.component("purchaseInvoiceInfoForm", {
				bindings:{
					purchaseInvoice:'=',
					suppliers:'<',
					isFormValid:'=',
					isProcessingData: "=",
					originInvoice:'<'
				},
				templateUrl: "app/main/purchase-invoice/components/purchase-invoice-info-form.html",
				controller: componentController,
		  		controllerAs: 'vm'
			});

		function componentController(GeneralTools, PurchaseInvoice, PurchaseInvoiceService, $scope, LoginService, $q, MessageService, $state, PurchaseInvoiceConstants, ToolsConstants){
			const vm = this;
			const companyID = LoginService.getCompanyID();

			var exsitingPurchaseInvoiceID;

			vm.invoiceNumberPattern = PurchaseInvoiceConstants.invoiceNumberPattern;
			vm.$onInit = initComponent;
			vm.$postLink = initOutPutCallbacks;
			vm.getPurchaseInvoicePageUrl = getPurchaseInvoicePageUrl;
			vm.setPurchaseDate = setPurchaseDate;

			vm.translateToDollar = GeneralTools.inputTranslators.dollar;
			vm.translateToPercentage = GeneralTools.inputTranslators.percentage;

			vm.taxRateInputOption = {
				decimalFractionSize:0,
				canBeNegative:false
			};

			vm.duplicateValidatorName = "duplicateCheck";

			vm.invoiceNumberValidation = [
				{
					name:vm.duplicateValidatorName,
					validateFn:checkInvoiceNumber
				}
			]

			vm.suppplierValidation = [
				{
					name:vm.duplicateValidatorName,
					validateFn:checkSupplier
				}
			]

			function initComponent(){
				initSuppliers();
				initPurchaseInvoice();
			}

			function  initSuppliers(argument) {
				if(!Array.isArray(vm.suppliers)){
					vm.suppliers = [];
				}
			}

			function initPurchaseInvoice(argument) {
				if(!vm.purchaseInvoice){
					vm.purchaseInvoice = new PurchaseInvoice();
				}

				vm.datePickerValue = vm.purchaseInvoice.getPurchaseDateMomentObj();
			}

			function setPurchaseDate(){
				vm.purchaseInvoice.setPurchaseDate(moment(vm.datePickerValue));
			}

			function initOutPutCallbacks(){
				vm.isFormValid = isFormValid;
			}

			function isFormValid(){
				$scope.purchaseInvoiceInfoForm.$submitted = true;
				return $scope.purchaseInvoiceInfoForm.$valid;
			};

			function checkInvoiceNumber(modelValue, viewValue){
				if(vm.originInvoice.invoice_number == modelValue && vm.originInvoice.fk_id_supplier == vm.purchaseInvoice.fk_id_supplier){
					$scope.purchaseInvoiceInfoForm.supplier.$setValidity(vm.duplicateValidatorName, true);
					return $q.resolve();
				}

				return duplicateCheck(modelValue, vm.purchaseInvoice.fk_id_supplier)
					.then(function(){
						$scope.purchaseInvoiceInfoForm.supplier.$setValidity(vm.duplicateValidatorName, true);
						return $q.resolve()
					});
			}

			function checkSupplier(modelValue, viewValue){
				if(vm.originInvoice.fk_id_supplier == modelValue && vm.originInvoice.invoice_number == vm.purchaseInvoice.invoice_number){
					$scope.purchaseInvoiceInfoForm.invoiceNumber.$setValidity(vm.duplicateValidatorName, true)
					return $q.resolve();
				}

				return duplicateCheck(vm.purchaseInvoice.invoice_number, modelValue)
					.then(function(){
						$scope.purchaseInvoiceInfoForm.invoiceNumber.$setValidity(vm.duplicateValidatorName, true)
						return $q.resolve()
					});
			}

			function duplicateCheck(invoiceNumber, supplierID){
				var defer = $q.defer();

				if(!invoiceNumber || !supplierID){
					return $q.resolve();
				}

				var filterString = '';

				filterString = GeneralTools.equalFilterBuilder(PurchaseInvoiceConstants.keyNames.invoiceNumber, invoiceNumber);
				filterString = GeneralTools.stringConnector(filterString, GeneralTools.equalFilterBuilder(PurchaseInvoiceConstants.keyNames.supplier, supplierID), ToolsConstants.apiFilters.andConnector);

				const resourcePath = { companyID: companyID };
				const filter = {filters: filterString};

				PurchaseInvoiceService.getPurchaseInvoices(resourcePath, filter)
					.then(function(result){
						if(result && Array.isArray(result.data) && result.data.length > 0){
							exsitingPurchaseInvoiceID = result.data[0].id_purchase_invoice;
							defer.reject();
						} else {
							exsitingPurchaseInvoiceID = null;
							defer.resolve();
						}
					})
					.catch(MessageService.showToast)

				return defer.promise;
			}

			function getPurchaseInvoicePageUrl() {
				if(exsitingPurchaseInvoiceID){
					return $state.href("app.edit-purchase-invoice", {purchaseInvoiceID: exsitingPurchaseInvoiceID});
				}
			}
		}
})();
(function ()
{
	"use strict";

	angular
		.module("app.purchaseInvoice")
		.component("purchaseInvoiceCostList", {
				bindings:{
					purchaseInvoiceList:'=',
					suppliers:'<',
					sortBy:'<',
					sortDirection:'<',
					onSortingChanged: '<',
					invoiceTotalCost: '='
				},
				templateUrl: "app/main/purchase-invoice/components/purchase-invoice-cost-list.html",
				controller: componentController,
		  		controllerAs: 'vm'
			});

		function componentController(GeneralTools, Inventory, $scope, $state, PurchaseInvoiceConstants, ToolsConstants){
			const vm = this;
			const keyNames = PurchaseInvoiceConstants.keyNames;
			const sortingDirections = ToolsConstants.apiSortingDirections;

			vm.directionDesc = sortingDirections.DESC;
			vm.directionAsc = sortingDirections.ASC;

			vm.sortTagInvoiceNumber = keyNames.invoiceNumber;
			vm.sortTagDate = keyNames.purchaseDate;
			vm.sortTagSupplier = keyNames.supplier;

			vm.sortTagTotalCost = 'totalcost';

			vm.totalOrder = 0;

			vm.$onInit = initComponent;
			vm.getInvoicePageUrl = getInvoicePageUrl;
			vm.changeSorting = changeSorting;
			vm.getSupplierName = getSupplierName;
			vm.toggleItemList = toggleItemList;

			function initComponent(){
				if(!Array.isArray(vm.suppliers)){
					vm.suppliers = [];
				}
			}

			function toggleItemList() {
				var itemList = document.getElementById("item-list");
				var tab = document.querySelector(".tab");
	
				if (itemList.style.display === "none") {
					itemList.style.display = "block";
					tab.classList.add("active");
				} else {
					itemList.style.display = "none";
					tab.classList.remove("active");
				}
			}

			function getSupplierName(supplierID) {
				const matchedSupplier = vm.suppliers.find(function(supplier){
					return !!supplier && supplier.id_supplier == supplierID;
				});
				
				if(!!matchedSupplier){
					return matchedSupplier.name;
				}

				return "Unknown";
				
			}

			function getInvoicePageUrl(purchaseInvoice){
				if(!purchaseInvoice){
					return;
				}

				return $state.href("app.edit-purchase-invoice", {purchaseInvoiceID: purchaseInvoice.id_purchase_invoice});
			}

			function changeSorting(sortTag) {
				if(vm.sortBy == sortTag){
					vm.sortDirection = vm.sortDirection == vm.directionAsc ? vm.directionDesc : vm.directionAsc;
				} else {
					vm.sortDirection = vm.directionAsc;
				}

				vm.sortBy = sortTag;

				if(typeof(vm.onSortingChanged) == "function"){
					vm.onSortingChanged(vm.sortBy, vm.sortDirection);
				}
			}


		}
})();
(function ()
{
	"use strict";

	angular
		.module("app.purchaseInvoice")
		.component("purchaseInvoiceSummary", {
				bindings:{
					partList: '=',
					isReturnedInvoice: '<'
				},
				templateUrl: "app/main/purchase-invoice/components/invoice-summary.html",
				controller: componentController,
		  		controllerAs: 'vm'
			});

		function componentController(GeneralTools, Inventory, $scope, $state, ToolsConstants, InvoiceSummaryCalculator){
			const vm = this;

			const summaryCalculator = new InvoiceSummaryCalculator();

			vm.$postLink = postLink;

			function postLink(){
				$scope.$watch("vm.partList", updateSummary, true);
			}

			function updateSummary(){
				if(Array.isArray(vm.partList)){

					const parts = vm.partList.filter(function(item){
						if(!item){
							return;
						}

						if(item.is_returned){
							return vm.isReturnedInvoice;
						} else {
							return true;
						}
					});

					summaryCalculator.setParts(parts);
				}

				vm.totalPartsCost = summaryCalculator.getTotalPartsCost();
				vm.totalPartsRetail = summaryCalculator.getTotalPartsRetail();
			}
		}
})();
(function () {
	'use strict';

	angular
		.module('app.purchaseInvoice')
		.controller('BrowsePurchaseInvoiceController', BrowsePurchaseInvoiceController);

	function BrowsePurchaseInvoiceController($scope, PurchaseInvoiceConstants, $stateParams, $q, PartConstants, PurchaseInvoiceService, LoginService, MessageService, ProgressService, HeaderHelper, GeneralTools, ToolsConstants, PartService, $location, constants) {
		const vm = this;
		const companyID = LoginService.getCompanyID();
		const filterConsts = ToolsConstants.apiFilters;
		const dateFormat = PurchaseInvoiceConstants.purchaseDateFormat;
		const keyNames = PurchaseInvoiceConstants.keyNames;

		const keyNamePurchaseDate = keyNames.purchaseDate;
		const keyNameInvoiceNumber = keyNames.invoiceNumber;
		const keyNameSupplier = keyNames.supplier;

		const keyNamePartType = keyNames.partType;
		const keyNamePartName = keyNames.partName;
		const keyNamePartCode = keyNames.partCode;
		vm.totalOrder = 0;
		vm.totalReturn = 0;
		vm.totaloutstanding = 0;
		vm.displayOptions = [10, 25, 50, 100];
		$scope.filtertracker = "none";
		vm.refreshInvoiceList = refreshInvoiceList;
		vm.onSortingChanged = onSortingChanged;
		vm.showItems = {};

		init();

		$scope.$watch('filtertracker', function (newValue, oldValue) {
			refreshInvoiceList(vm.currentPage);
		});

		function init() {
			initConstants();
			initStateParams();
			//refreshInvoiceList(vm.currentPage);
		}

		function initConstants() {
			if (!constants) {
				return;
			}

			vm.inventoryTypes = constants.inventoryTypes;
			vm.suppliers = constants.suppliers
		}

		function initStateParams() {
			vm.supplierFilter = GeneralTools.urlNumberParamTranslator($stateParams.supplier);
			vm.invoiceSearchText = GeneralTools.urlStringParamTranslator($stateParams.invoiceNumber);
			vm.startDateFilter = GeneralTools.urlDateParamTranslator($stateParams.startDate);
			vm.endDateFilter = GeneralTools.urlDateParamTranslator($stateParams.endDate);


			vm.inventoryTypeFilter = GeneralTools.urlNumberParamTranslator($stateParams.type);
			vm.nameSearchText = GeneralTools.urlStringParamTranslator($stateParams.name);
			vm.codeSearchText = GeneralTools.urlStringParamTranslator($stateParams.code);

			vm.itemsPerPage = getDisplayOption(GeneralTools.urlNumberParamTranslator($stateParams.limit));
			vm.currentPage = GeneralTools.urlNumberParamTranslator($stateParams.page);

			vm.sortBy = GeneralTools.urlStringParamTranslator($stateParams.sortBy);
			vm.sortDirection = GeneralTools.urlStringParamTranslator($stateParams.sortDirection);
		}

		function getDisplayOption(itemPerPage) {
			if (vm.displayOptions.indexOf(itemPerPage) == -1) {
				return vm.displayOptions[0];
			}

			return itemPerPage;
		}

		function refreshInvoiceList(pageToGo) {
			vm.totalOrder = 0;
			vm.totalReturn = 0;
			vm.totaloutstanding = 0;
			const resourcePath = { companyID: companyID };
			let resultHeaderGetter = null;
		
			ProgressService.setMode("indeterminate");
			ProgressService.isVisble(true);
		
			PurchaseInvoiceService.getPurchaseInvoices(resourcePath, getFilter(), getPagination(pageToGo), getSorting())
				.then(function (result) {
					if (!result) {
						return $q.reject("Purchase Invoice result invalid.");
					}
		
					vm.purchaseInoviceList = result.data;
					vm.sortedPurchaseInvoiceList = angular.copy(vm.purchaseInoviceList);
					vm.returnInvoiceList = []
					vm.outstandingInvoiceList = []
					vm.filterPurchaseInoviceList = [];
		
					resultHeaderGetter = result.headerGetter;

					return initInvoiceParts(vm.sortedPurchaseInvoiceList);
				})
				.then(function() {
					applyFilterAfterPartsLoaded();
					resetPagination(resultHeaderGetter);
					refreshUrl();
				})
				.catch(MessageService.showToast)
				.finally(function () {
					ProgressService.isVisble(false);
				});
		}

		function initInvoiceParts(purchaseInoviceList) {
			if (!Array.isArray(purchaseInoviceList)) {
				return $q.resolve();
			}
		
			const promises = purchaseInoviceList.map(function (invoice) {
				const resourcePath = { companyID: LoginService.getCompanyID() };
				const filters = { filters: '(' + PartConstants.keyNames.purchaseInvoiceID + ' eq ' + invoice.id_purchase_invoice + ')' };
		
				return PartService.getAllMatchedParts(resourcePath, filters)
					.then(function (result) {
						var totalcost = 0;
						var totalretail = 0;
						var totalreturncost = 0;
						var totalreturnretail = 0;
		
						if (result) {
							invoice.partList = result;
						}
		
						invoice.partList.forEach(function (part) {
							if (part.is_ordered && part.is_returned) {
								if (part.purchase_price && part.quantity) {
									totalcost += part.purchase_price * part.quantity;
									totalreturncost += part.purchase_price * part.quantity;
								}
								if (part.retail_price && part.quantity) {
									totalretail += part.retail_price * part.quantity;
									totalreturnretail += part.retail_price * part.quantity;
								}
							} else if (part.is_ordered && !part.is_returned) {
								if (part.purchase_price && part.quantity) {
									totalcost += part.purchase_price * part.quantity;
								}
								if (part.retail_price && part.quantity) {
									totalretail += part.retail_price * part.quantity;
								}
							}
						});
		
						invoice.totalcost = totalcost.toFixed(2);
						invoice.totalretail = totalretail.toFixed(2);
						invoice.totalreturncost = totalreturncost.toFixed(2);
						invoice.totalreturnretail = totalreturnretail.toFixed(2);
		
						vm.totalOrder += totalcost;
						vm.totalReturn += totalreturncost;
						vm.totaloutstanding = vm.totalOrder - vm.totalReturn;
		
						if (invoice.totalreturncost > 0) {
							vm.returnInvoiceList.push(angular.copy(invoice));
						} else {
							vm.outstandingInvoiceList.push(angular.copy(invoice));
						}
					});
			});
		
			return $q.all(promises);
		}

		function applyFilterAfterPartsLoaded() {
			vm.filterPurchaseInoviceList = [];
		
			vm.sortedPurchaseInvoiceList.forEach(function (invoice) {
				switch ($scope.filtertracker) {
					case "order":
						vm.filterPurchaseInoviceList.push(invoice);
						break;
					case "return":
						if (invoice.totalreturncost > 0) {
							vm.filterPurchaseInoviceList.push(angular.copy(invoice));
						}
						break;
					case "outstanding":
						if (invoice.totalreturncost <= 0 && invoice.totalcost >= 0) {
							vm.filterPurchaseInoviceList.push(angular.copy(invoice));
						}
						break;
					case "none":
						vm.filterPurchaseInoviceList.push(invoice);
						break;
				}
			});
		}	

		function getFilter() {
			var filterString = '';

			if (vm.supplierFilter) {
				filterString = GeneralTools.stringConnector(filterString, GeneralTools.equalFilterBuilder(keyNameSupplier, vm.supplierFilter), filterConsts.andConnector);
			}

			if (vm.invoiceSearchText) {
				filterString = GeneralTools.stringConnector(filterString, GeneralTools.containFilterBuilder(keyNameInvoiceNumber, vm.invoiceSearchText), filterConsts.andConnector);
			}

			if (vm.startDateFilter) {
				filterString = GeneralTools.stringConnector(filterString, getTimeRangeFilter(vm.startDateFilter, false), filterConsts.andConnector);
			}

			if (vm.endDateFilter) {
				filterString = GeneralTools.stringConnector(filterString, getTimeRangeFilter(vm.endDateFilter, true), filterConsts.andConnector);
			}

			if (vm.inventoryTypeFilter) {
				filterString = GeneralTools.stringConnector(filterString, GeneralTools.equalFilterBuilder(keyNamePartType, vm.inventoryTypeFilter), filterConsts.andConnector);
			}

			if (vm.nameSearchText) {
				filterString = GeneralTools.stringConnector(filterString, GeneralTools.containFilterBuilder(keyNamePartName, vm.nameSearchText), filterConsts.andConnector);
			}

			if (vm.codeSearchText) {
				filterString = GeneralTools.stringConnector(filterString, GeneralTools.containFilterBuilder(keyNamePartCode, vm.codeSearchText), filterConsts.andConnector);
			}

			if (filterString) {
				return { filters: filterString };
			}
		}

		function getTimeRangeFilter(dateObj, isBeforeDate) {
			const momentObj = moment(dateObj);

			if (!dateObj || !momentObj.isValid()) {
				return;
			}

			if (isBeforeDate) {
				return GeneralTools.equalOrLesshanFilterBuilder(keyNamePurchaseDate, momentObj.format(dateFormat));
			}

			return GeneralTools.equalOrGreaterThanFilterBuilder(keyNamePurchaseDate, momentObj.format(dateFormat));
		}

		function getPagination(page) {
			return {
				page: page,
				limit: vm.itemsPerPage
			}
		}

		function getSorting() {
			return {
				sortBy: vm.sortBy,
				sortDirection: vm.sortDirection
			};
		}

		function resetPagination(headerGetter) {
			vm.totalCount = HeaderHelper.getPaginationTotalItem(headerGetter);
			vm.currentPage = HeaderHelper.getPaginationCurrentPage(headerGetter);
		}

		function refreshUrl() {
			const urlParams = {};
			const startDateMoment = moment(vm.startDateFilter);
			const endDateMoment = moment(vm.endDateFilter);

			urlParams.limit = vm.itemsPerPage === undefined ? undefined : vm.itemsPerPage + '';
			urlParams.page = vm.currentPage === undefined ? undefined : vm.currentPage + '';
			urlParams.supplier = vm.supplierFilter === undefined ? undefined : vm.supplierFilter + '';
			urlParams.invoiceNumber = vm.invoiceSearchText === undefined ? undefined : vm.invoiceSearchText + '';
			urlParams.type = vm.inventoryTypeFilter === undefined ? undefined : vm.inventoryTypeFilter + '';
			urlParams.name = vm.nameSearchText === undefined ? undefined : vm.nameSearchText + '';
			urlParams.code = vm.codeSearchText === undefined ? undefined : vm.codeSearchText + '';
			urlParams.sortBy = vm.sortBy === undefined ? undefined : vm.sortBy + '';
			urlParams.sortDirection = vm.sortDirection === undefined ? undefined : vm.sortDirection + '';

			if (vm.startDateFilter && startDateMoment.isValid()) {
				urlParams.startDate = startDateMoment.format(dateFormat);
			}

			if (vm.endDateFilter && endDateMoment.isValid()) {
				urlParams.endDate = endDateMoment.format(dateFormat);
			}

			$location.search(urlParams).replace();
		}

		function onSortingChanged(sortBy, sortDirection) {
			vm.sortBy = sortBy;
			vm.sortDirection = sortDirection;

			refreshInvoiceList(1);
		}

		vm.clearSelection = clearSelection;
		function clearSelection() {
			var options = document.getElementsByName("options");
			for (var i = 0; i < options.length; i++) {
				options[i].checked = false;
			}
			$scope.filtertracker = "none"
		}
	}
})();
(function ()
{
	"use strict";
	angular.module("app.purchaseInfo",[])
		.constant("PurchaseInfoConstants", {
			purchaseDateFormat:"YYYY-MM-DD"
		})
		.config(config);

	/** @ngInject */
	function config($stateProvider, msNavigationServiceProvider)
	{	  

		$stateProvider
			.state('app.add-purchase-info', {
				url :"/vehicle/{vehicleID}/addpurchaseinfo",
				views	: {
						'content@app': {
							templateUrl: 'app/main/purchase-info/add-purchase-info/add-purchase-info.html',
							controller : 'AddPurchaseInfoController as vm'
						}
					},
				resolve:{
					fetchedVehicleResult:function($stateParams, VehicleService, MessageService, LoginService){
						var resourcePath = {
							companyID : LoginService.getCompanyID(),
							vehicleID : $stateParams.vehicleID
						};

						return VehicleService.getVehicle(resourcePath).catch(MessageService.showToast);
					},
					auctions:function(PurchaseInfoService, MessageService){
						return PurchaseInfoService.getAuction().catch(MessageService.showToast);						
					},
					workorderPriorities:function(WorkOrderService, MessageService){
						return WorkOrderService.getCachedWorkOrderPriorities().catch(MessageService.showToast);
					},
					purchaseInfoPriceType:function($stateParams, PurchaseInfoService, MessageService, LoginService){
						var resourcePath = {
							companyID : LoginService.getCompanyID(),
							vehicleID : $stateParams.vehicleID,
						};

						return PurchaseInfoService.getCachedPurchaseInfoPriceType(resourcePath).catch(MessageService.showToast);
					},
				}
			})
			.state('app.edit-purchase-info', {
				url :"/vehicle/{vehicleID}/editpurchaseinfo/{purchaseInfoID}",
				views	: {
						'content@app': {
							templateUrl: 'app/main/purchase-info/edit-purchase-info/edit-purchase-info.html',
							controller : 'EditPurchaseInfoController as vm'
						}
					},
				resolve:{
					fetchedVehicleResult:function($stateParams, VehicleService, MessageService, LoginService){
						var resourcePath = {
							companyID : LoginService.getCompanyID(),
							vehicleID : $stateParams.vehicleID
						};

						return VehicleService.getVehicle(resourcePath).catch(MessageService.showToast);
					},
					auctions:function(PurchaseInfoService, MessageService){
						return PurchaseInfoService.getAuction().catch(MessageService.showToast);						
					},
					purchaseInfos:function($stateParams, PurchaseInfoService, MessageService, LoginService){
						var resourcePath = {
							companyID : LoginService.getCompanyID(),
							vehicleID : $stateParams.vehicleID,
							purchaseinfoID : $stateParams.purchaseInfoID
						};

						return PurchaseInfoService.getPurchaseInfos(resourcePath).catch(MessageService.showToast);
					},
					disclosures:function($stateParams, PurchaseInfoService, MessageService, LoginService){
						var resourcePath = {
							companyID : LoginService.getCompanyID(),
							vehicleID : $stateParams.vehicleID,
							purchaseinfoID : $stateParams.purchaseInfoID
						};

						return PurchaseInfoService.getPurchaseDisclosures(resourcePath).catch(MessageService.showToast);
					},
					purchaseInfoFiles:function($stateParams, PurchaseInfoService, MessageService, LoginService){
						var resourcePath = {
							companyID : LoginService.getCompanyID(),
							vehicleID : $stateParams.vehicleID,
							purchaseinfoID : $stateParams.purchaseInfoID
						};

						return PurchaseInfoService.getPurchaseInfoFiles(resourcePath).catch(MessageService.showToast);
					},
					purchaseInfoPrice:function($stateParams, PurchaseInfoService, MessageService, LoginService){
						var resourcePath = {
							companyID : LoginService.getCompanyID(),
							vehicleID : $stateParams.vehicleID,
							purchaseinfoID : $stateParams.purchaseInfoID
						};

						return PurchaseInfoService.getPurchaseInfoPrices(resourcePath).catch(MessageService.showToast);
					},
					purchaseInfoPriceType:function($stateParams, PurchaseInfoService, MessageService, LoginService){
						var resourcePath = {
							companyID : LoginService.getCompanyID(),
							vehicleID : $stateParams.vehicleID,
						};

						return PurchaseInfoService.getCachedPurchaseInfoPriceType(resourcePath).catch(MessageService.showToast);
					},
				}
			});

	}

})();
(function () {
	'use strict';

	angular
		.module('app.purchaseInfo')
		.controller('EditPurchaseInfoController', EditPurchaseInfoController);

	function EditPurchaseInfoController(SaleInfoConstants, WorkOrderService, TaskConstants, $q, RoleCheckService, $stateParams, $state, MessageService, ProgressService, LoginService, auctions, PurchaseInfo, fetchedVehicleResult, PurchaseInfoService, FileUploadService, purchaseInfos, disclosures, purchaseInfoFiles, DialogService, TasksService, SaleInfoService, GeneralTools, VehicleConstants, purchaseInfoPrice, purchaseInfoPriceType, PurchaseInfoPrices) {
		var vm = this;
		var companyID = LoginService.getCompanyID();
		var vehicleID = $stateParams.vehicleID;
		var purchaseInfoID;
		var uploadFilesDefer = $q.defer();

		var originPurchaseInfo;
		var originalPurchaseInfoPriceList;

		vm.updatePurchaseInfo = updatePurchaseInfo;
		vm.deletePurchaseInfo = deletePurchaseInfo;
		vm.onDisclosureAdded = onDisclosureAdded;
		vm.onDisclosureRemoved = onDisclosureRemoved;
		vm.onFileDelete = onFileDelete;
		vm.getPurchaseInfoUrl = getPurchaseInfoUrl;
		vm.purchaseInfoPrice = [];
		vm.purchaseInfoPriceType = [];
		vm.isProcessingData = false;
		vm.createPurchaseInfoPrice = createPurchaseInfoPrice;
		vm.updatePurchaseInfoPrice = updatePurchaseInfoPrice;
		vm.isUserHaveVehicleManagerRole = RoleCheckService.deepCheckRole(["vehicle_manager", "vehicle_helper_add"]);


		init();

		function init() {
			if(!vm.isUserHaveVehicleManagerRole){
				$state.go("app.homepage");
			}
			initAuctions();
			initPurchaseInfo();
			initVehicle();
			initDisclosures();
			initPurchaseInfoFiles()
			initFileUploader();
			initResourcesBasedOnTimeRange();
			initPurchaseInfoPrice();
			initPurchaseInfoPriceType();
		}

		function initResourcesBasedOnTimeRange() {
			var currentPurchaseInfoID = vm.purchaseInfo.getResourceID();
			if (currentPurchaseInfoID == null) {
				initTotalCost();
				return;
			}

			var resourcePath = {
				companyID: companyID,
				vehicleID: vehicleID
			}

			var purchaseInfos;

			PurchaseInfoService.getPurchaseInfos(resourcePath)
				.then(function (_purchaseInfos) {
					purchaseInfos = _purchaseInfos;
					const timeRange = findTimeRangeBetweenCurrentAndNextPurchase(currentPurchaseInfoID, purchaseInfos);
					initTasks(timeRange);
					initPreviousDisclosures(purchaseInfos, vm.purchaseInfo.getPurchaseDateMomentObj());
					return SaleInfoService.getVehicleSaleInfos(resourcePath)
				})
				.then(function (saleInfos) {
					const timeRange = findTimeRangeForWarranty(currentPurchaseInfoID, purchaseInfos, saleInfos);
					initWorkorders(timeRange);
				})
				.catch(MessageService.showToast);
		}

		function initPreviousDisclosures(purchaseInfos, currentPurchaseDate) {
			if (!Array.isArray(purchaseInfos) || !currentPurchaseDate || !currentPurchaseDate.isValid()) {
				return;
			}

			const queue = [];

			vm.isFetchingDisclosures = true;

			purchaseInfos.forEach(function (purchaseInfo) {
				if (!purchaseInfo) {
					return;
				}

				const purchaseDate = purchaseInfo.getPurchaseDateMomentObj();

				if (purchaseDate.isSameOrAfter(currentPurchaseDate)) {
					return;
				}

				var resourcePath = {
					companyID: companyID,
					vehicleID: $stateParams.vehicleID,
					purchaseinfoID: purchaseInfo.getResourceID()
				};

				queue.push($q.all({
					purchaseInfo: purchaseInfo,
					disclosures: PurchaseInfoService.getPurchaseDisclosures(resourcePath)
				}));
			});

			$q.all(queue).then(function (result) {
				vm.allDisclosures = result;
			})
				.catch(MessageService.showToast)
				.finally(function () {
					vm.isFetchingDisclosures = false;
				})
		}

		function initWorkorders(timeRange) {
			if (!timeRange) {
				return $q.reject("Workorder time range is invalid");
			}

			const resourcePath = {
				companyID: companyID,
				vehicleID: vehicleID
			};

			const queue = [];

			WorkOrderService.getWorkOrders(resourcePath).$promise
				.then(function (workorders) {
					if (!Array.isArray(workorders)) {
						return $q.reject("workorders data invalid.");
					}

					workorders.forEach(function (workorder) {
						if (!workorder) {
							return
						}

						const completedDate = workorder.getCompletedDateTimeMomentObj();
						if (!completedDate || !workorder.isCompleted()) {
							return;
						}

						if (timeRange.from && completedDate.isBefore(timeRange.from)) {
							return;
						}

						if (timeRange.to && completedDate.isAfter(timeRange.to)) {
							return;
						}

						if (!queue[workorder.id_work_order]) {
							queue.push($q.all({
								workorderData: $q.resolve(workorder),
								partData: fetchPartsData(workorder.id_work_order),
								inventoryData: fetchInventoriesData(workorder.id_work_order)
							}));
						}
					});

					return $q.all(queue);
				})
				.then(function (result) {
					vm.workorderList = result;
				})
				.catch(MessageService.showToast);
		}

		function fetchPartsData(workOrderID) {
			const resourcePath = {
				companyID: companyID,
				vehicleID: vehicleID,
				workorderID: workOrderID
			};

			return WorkOrderService.getWorkOrderParts(resourcePath).$promise
		}

		function fetchInventoriesData(workOrderID) {
			const resourcePath = {
				companyID: companyID,
				vehicleID: vehicleID,
				workorderID: workOrderID
			};

			return WorkOrderService.getWorkOrderInventories(resourcePath).$promise
		}

		function initTasks(timeRange) {
			if (!timeRange) {
				return $q.reject("Task time range is invalid");
			}

			var tasksFilter = tasksFilterBuilder(timeRange);

			if (!tasksFilter) {
				return $q.reject("Task filter is invalid");
			}

			var resourcePath = { companyID: LoginService.getCompanyID() };

			TasksService.getAllMatchedTasks(resourcePath, { filters: tasksFilter })
				.then(function (tasks) {
					if (!Array.isArray(tasks)) {
						return $q.reject("Tasks data invalid.");
					}

					vm.tasks = tasks;
				})
				.catch(MessageService.showToast);
		}

		function initPurchaseInfoFiles() {
			vm.purchaseInfoFiles = purchaseInfoFiles;
		}

		function initFileUploader() {
			var customFilter = FileUploadService.getCustomFilter(["pdf", "jpg", "jpeg", "png", "mp4"]);
			var sizeFilter = FileUploadService.getSizeFilter(40);

			vm.purchaseInfoFileUploader = FileUploadService.getNewUploader();
			vm.purchaseInfoFileUploader.filters.push(customFilter);
			vm.purchaseInfoFileUploader.filters.push(sizeFilter);
		}

		function initDisclosures() {
			vm.disclosures = disclosures;
		}

		function initVehicle() {
			if (fetchedVehicleResult == null || !Array.isArray(fetchedVehicleResult.data)) {
				MessageService.showToast("Vehicle Data is invalid.");
				return;
			}

			vm.vehicle = fetchedVehicleResult.data[0];
			vm.vehiclePageUrl = $state.href('app.edit-vehicle', { vehicleID: vm.vehicle.getResourceID(), tab: VehicleConstants.editPageTabNames.purchaseInfo }, { absolute: true });
		}

		function initPurchaseInfo() {
			if (!Array.isArray(purchaseInfos)) {
				return;
			}
			vm.purchaseInfo = purchaseInfos[0];
			originPurchaseInfo = angular.copy(vm.purchaseInfo);
			purchaseInfoID = vm.purchaseInfo.getResourceID()
		}

		function initAuctions() {
			vm.auctions = auctions;
		}


		function updatePurchaseInfo() {
			if (!vm.isPurchaseInfoFormValid()) {
				MessageService.showToast("Please make sure all the fields are valid.");
				return;
			}

			let containPurchaseInfoChange = false;
			let containPurchaseInfoPriceChange = false;

			let changedProperties = PurchaseInfoService.updatePurchaseInfoRequestBodyGenerator(vm.purchaseInfo, originPurchaseInfo);
			let purchasePriceChangeProperties = PurchaseInfoService.updatePurchaseInfoRequestBodyGenerator(vm.purchaseInfoPrice, originalPurchaseInfoPriceList);

			if (changedProperties != null && Object.keys(changedProperties).length > 0) {
				containPurchaseInfoChange = true;
			}

			if (purchasePriceChangeProperties != null && Object.keys(purchasePriceChangeProperties).length > 0) {
				containPurchaseInfoPriceChange = true;
			}

			if (!containPurchaseInfoChange && !containPurchaseInfoPriceChange) {
				MessageService.showToast("No change detected.");
				return;
			}

			let resourcePath = {
				companyID: companyID,
				vehicleID: vehicleID,
				purchaseinfoID: purchaseInfoID
			};

			ProgressService.setMode("indeterminate");
			ProgressService.isVisble(true);

			let priceListUpdatePromise = containPurchaseInfoPriceChange ? savePurchaseInfoPriceListChange() : Promise.resolve([]);

			return priceListUpdatePromise
				.then(function (response) {
					if (containPurchaseInfoPriceChange) {
						return getPurchaseInfoPrice()
					}

				})
				.then(function () {

					let purchaseInfoUpdatePromise = containPurchaseInfoChange ?
						PurchaseInfoService.updatePurchaseInfo(resourcePath, changedProperties) :
						Promise.resolve();

					return purchaseInfoUpdatePromise
						.then(function () {
							if (containPurchaseInfoChange) {
								MessageService.showToast("Update purchase info success.");
								originPurchaseInfo = angular.copy(vm.purchaseInfo);
								if (changedProperties.purchase_date) {
									initResourcesBasedOnTimeRange();
								}
							}
						})
				})
				.catch(MessageService.showToast)
				.finally(function () {
					ProgressService.isVisble(false);
				});
		}




		function onDisclosureAdded(disclosure) {
			ProgressService.setMode("indeterminate");
			ProgressService.isVisble(true);
			vm.isProcessingData = true;

			var resourcePath = {
				companyID: companyID,
				vehicleID: vehicleID,
				purchaseinfoID: purchaseInfoID
			}

			PurchaseInfoService.createPurchaseDisclosure(resourcePath, disclosure)
				.then(function (newDisclosureID) {
					disclosure.setResourceID(newDisclosureID);
					vm.disclosures.push(disclosure);
					vm.cleanNewDisclouser();
				})
				.catch(MessageService.showToast)
				.finally(function () {
					ProgressService.isVisble(false);
					vm.isProcessingData = false;
				});
		}


		function onDisclosureRemoved(diclosure, index) {
			var resourcePath = {
				companyID: companyID,
				vehicleID: vehicleID,
				purchaseinfoID: purchaseInfoID,
				disclosureID: diclosure.getResourceID()
			}

			ProgressService.setMode("indeterminate");
			ProgressService.isVisble(true);
			vm.isProcessingData = true;

			PurchaseInfoService.deletePurchaseDisclosure(resourcePath)
				.then(function () {
					vm.disclosures.splice(index, 1);
				})
				.catch(MessageService.showToast)
				.finally(function () {
					ProgressService.isVisble(false);
					vm.isProcessingData = false;
				});
		}

		vm.purchaseInfoFileUploader.onAfterAddingFile = function (fileItem) {
			fileItem.url = FileUploadService.getUrlForCreatePurchaseInfoFile(vehicleID, purchaseInfoID);
			fileItem.upload();
		}

		vm.purchaseInfoFileUploader.onCompleteItem = function (item, response, status, headers) {
			if (!FileUploadService.isUploadSuccess(headers)) {
				MessageService.showToast(headers.message);
				return;
			}

			var resourcePath = {
				companyID: companyID,
				vehicleID: vehicleID,
				purchaseinfoID: purchaseInfoID,
				fileID: response.data
			}

			PurchaseInfoService.getPurchaseInfoFiles(resourcePath)
				.then(function (files) {
					if (!Array.isArray(files)) {
						return $q.reject("Purchase info file data is invalid.");
					}
					vm.purchaseInfoFiles.push(files[0]);
					item.remove();
				})
				.catch(MessageService.showToast);
		}


		function onFileDelete(uploadedFile, index) {
			vm.isDeletingFile = true;

			var resourcePath = {
				companyID: companyID,
				vehicleID: vehicleID,
				purchaseinfoID: purchaseInfoID,
				fileID: uploadedFile.id_purchase_info_file
			}

			PurchaseInfoService.deletePurchaseFile(resourcePath)
				.then(function () {
					vm.purchaseInfoFiles.splice(index, 1)
				})
				.catch(MessageService.showToast)
				.finally(function () {
					vm.isDeletingFile = false;
				})
		}

		function deletePurchaseInfo() {

			var dialogOptions = {};

			dialogOptions.titleString = "Delete purchase info";
			dialogOptions.contentString = "Are you sure to delete purchase info";

			var confirmOption = {};

			confirmOption.optionName = "YES";
			confirmOption.onClick = function () {
				confirmDeletePurchaseInfoCallback();
				DialogService.close();
			}

			var cancelOption = {};

			cancelOption.optionName = "NO";
			cancelOption.onClick = function () {
				DialogService.close();
			}

			dialogOptions.options = [confirmOption, cancelOption];

			DialogService.showOptionsDialog(dialogOptions);
		}

		function confirmDeletePurchaseInfoCallback() {
			ProgressService.setMode("indeterminate");
			ProgressService.isVisble(true);
			vm.isProcessingData = true;

			var resourcePath = {
				companyID: companyID,
				vehicleID: vehicleID,
				purchaseinfoID: purchaseInfoID
			}

			PurchaseInfoService.deletePurchaseInfo(resourcePath)
				.then(function (response) {
					MessageService.showToast("Success.")
					$state.go("app.edit-vehicle", { vehicleID: vehicleID, tab: "purchaseInfo" });
				})
				.catch(MessageService.showToast)
				.finally(function () {
					ProgressService.isVisble(false);
					vm.isProcessingData = false;
				})
		}

		function tasksFilterBuilder(timeRange) {
			var filterString = "(id_vehicle eq " + vehicleID + ") AND (cost gt 0)";

			if (!timeRange) {
				return filterString;
			}

			var fromFilterString = '';
			var toFilterString = '';

			if (timeRange.from) {
				const timeString = timeRange.from.utc().format("YYYY-MM-DD HH:mm:ss");
				fromFilterString = "((created_date gt " + timeString + ") OR (created_date eq " + timeString + "))";
			}

			if (timeRange.to) {
				const timeString = timeRange.to.utc().format("YYYY-MM-DD HH:mm:ss");
				toFilterString = "((created_date lt " + timeString + ") OR (created_date eq " + timeString + "))";
			}

			filterString = GeneralTools.stringConnector(filterString, fromFilterString, " AND ");
			filterString = GeneralTools.stringConnector(filterString, toFilterString, " AND ");

			return filterString;
		}

		function findTimeRangeBetweenCurrentAndNextPurchase(currentPurchaseInfoID, allPurchaseInfos) {
			//allPurchaseInfos and allSaleInfos is ordered by date from backend;
			if (!Array.isArray(allPurchaseInfos)) {
				allPurchaseInfos = [];
			}

			var timeRange = {};
			var currentPurchaseInfo;
			var nextPurchaseInfo;

			currentPurchaseInfo = allPurchaseInfos.find(function (purchaseInfo) {
				return currentPurchaseInfoID == purchaseInfo.getResourceID();
			});

			if (currentPurchaseInfo == null) {
				return;
			}

			var currentPurchaseInfoDate = currentPurchaseInfo.getPurchaseDateMomentObj();

			nextPurchaseInfo = allPurchaseInfos.reverse().find(function (purchaseInfo) {
				var purchaseDate = purchaseInfo.getPurchaseDateMomentObj();

				if (!purchaseInfo.is_canceled && purchaseDate && currentPurchaseInfoDate) {
					return purchaseDate.isAfter(currentPurchaseInfoDate);
				}
			});

			timeRange.from = currentPurchaseInfoDate;

			if (nextPurchaseInfo) {
				timeRange.to = nextPurchaseInfo.getPurchaseDateMomentObj();
			}

			return timeRange;
		}

		function findTimeRangeForWarranty(currentPurchaseInfoID, purchaseInfos, saleInfos) {
			const timeRangeBetweenCurrentAndNextPurchase = findTimeRangeBetweenCurrentAndNextPurchase(currentPurchaseInfoID, purchaseInfos);

			if (!timeRangeBetweenCurrentAndNextPurchase || !Array.isArray(saleInfos)) {
				return;
			}

			const currentPurchaseDate = timeRangeBetweenCurrentAndNextPurchase.from;
			const nextPurchaseDate = timeRangeBetweenCurrentAndNextPurchase.to;

			if (!currentPurchaseDate) {
				return;
			}

			const nextSaleInfo = saleInfos.reverse().find(function (saleInfo) {
				if (!saleInfo || saleInfo.is_canceled) {
					return;
				}
				const saleDate = saleInfo.getSaleDateMomentObj();
				return saleDate && saleDate.isValid() && currentPurchaseDate.isSameOrBefore(saleDate);
			});

			if (!nextSaleInfo) {
				return timeRangeBetweenCurrentAndNextPurchase;
			}

			const timeRange = { from: currentPurchaseDate };

			const saleDate = nextSaleInfo.getSaleDateMomentObj();

			var warrantyDate;

			if (saleDate) {
				warrantyDate = saleDate.date(saleDate.date() + SaleInfoConstants.warrantyLength);
			}

			if (!nextPurchaseDate || (warrantyDate && warrantyDate.isBefore(nextPurchaseDate))) {
				timeRange.to = warrantyDate;
			} else {
				timeRange.to = nextPurchaseDate;
			}

			return timeRange;
		}

		function getPurchaseInfoUrl(purchaseInfoID) {
			return $state.href("app.edit-purchase-info", { vehicleID: vehicleID, purchaseInfoID: purchaseInfoID });
		}

		function initPurchaseInfoPrice() {
			vm.purchaseInfoPrice = purchaseInfoPrice;
			originalPurchaseInfoPriceList = angular.copy(vm.purchaseInfoPrice);
		}

		function initPurchaseInfoPriceType() {
			vm.purchaseInfoPriceType = purchaseInfoPriceType;
		}

		function createPurchaseInfoPrice(requestBody) {
			var resourcePath = {
				companyID: companyID,
				vehicleID: vehicleID,
				purchaseinfoID: purchaseInfoID
			}
			// vm.isProcessingData = true;
			PurchaseInfoService.createPurchaseInfoPrice(resourcePath, requestBody)
				.then(function (result) {
					vm.purchaseInfoPrice = result;
					// MessageService.showToast("Success.")
					return result;

				})
				.catch(MessageService.showToast)
				.finally(function () {
					// vm.isProcessingData = true;
					// ProgressService.isVisble(false);
				})
		}

		vm.deletePurchaseInfoPrice = function (purchaseinfopriceID) {
			const indexToRemove = vm.purchaseInfoPrice.findIndex(function (item) {
				return item.id_price === purchaseinfopriceID
			});

			var resourcePath = {
				companyID: companyID,
				vehicleID: vehicleID,
				purchaseinfoID: purchaseInfoID,
				purchaseinfopriceID: purchaseinfopriceID
			}

			vm.isProcessingData = true;
			PurchaseInfoService.deletePurchaseInfoPrice(resourcePath)
				.then(function (response) {
					vm.purchaseInfoPrice.splice(indexToRemove, 1);
					MessageService.showToast("Success.")

				})
				.catch(MessageService.showToast)
				.finally(function () {
					ProgressService.isVisble(false);
					vm.isProcessingData = false;
				})
		}

		function updatePurchaseInfoPrice(purchaseinfopriceID, purchaseinfoprice) {
			if (!purchaseinfopriceID || !purchaseinfoprice) {
				MessageService.showToast("Please make sure all the fields are valid.");
				return;
			}

			var resourcePath = {
				companyID: companyID,
				vehicleID: vehicleID,
				purchaseinfoID: purchaseInfoID,
				purchaseinfopriceID: purchaseinfopriceID
			}

			// ProgressService.setMode("indeterminate");
			// ProgressService.isVisble(true);
			// vm.isProcessingData = true;
			PurchaseInfoService.updatePurchaseInfoPrice(resourcePath, purchaseinfoprice)
				.then(function () {
					// MessageService.showToast("Success.")
				})
				.catch(MessageService.showToast)
				.finally(function () {
					// vm.isProcessingData = false;
					// ProgressService.isVisble(false);
				})
		}

		function savePurchaseInfoPriceListChange() {
			if (!Array.isArray(vm.purchaseInfoPrice)) {
				return $q.reject("Purchase Info Price is not an array");
			}

			var resourcePath;
			var tasks = vm.purchaseInfoPrice.map(function (purchaseInfoPriceItem) {
				if (purchaseInfoPriceItem.amount != null && purchaseInfoPriceItem.description != null && purchaseInfoPriceItem.fk_id_price_type != null && purchaseInfoPriceItem.rate != null && purchaseInfoPriceItem.id_price == null) {
					resourcePath = {
						companyID: companyID,
						vehicleID: vehicleID,
						purchaseinfoID: purchaseInfoID
					};
					return PurchaseInfoService.createPurchaseInfoPrice(resourcePath, purchaseInfoPriceItem);
				} else {
					resourcePath = {
						companyID: companyID,
						vehicleID: vehicleID,
						purchaseinfoID: purchaseInfoID,
						purchaseinfopriceID: purchaseInfoPriceItem.id_price
					}
					return PurchaseInfoService.updatePurchaseInfoPrice(resourcePath, purchaseInfoPriceItem)
				}
			});

			return $q.all(tasks);
		}

		function getPurchaseInfoPrice() {
			var resourcePath = {
				companyID: companyID,
				vehicleID: vehicleID,
				purchaseinfoID: purchaseInfoID
			}
			PurchaseInfoService.getPurchaseInfoPrices(resourcePath)
				.then(function (result) {
					vm.purchaseInfoPrice = result;
					vm.originalPurchaseInfoPriceList = angular.copy(vm.purchaseInfoPrice);
					MessageService.showToast("Update purchase info price success.");
				})

		}

	}
})();
(function ()
{
	"use strict";

	angular
		.module("app.purchaseInfo")
		.component("purchaseInfoForm", {
				bindings:{
					vehicleId:'<',
					purchaseInfo:'=',
					auctions:'<',
					isFormValid:"=",
					purchaseInfoPriceType:"<",
					purchaseInfoPrice:"<",
					createPurchaseInfoPrice:"=",
					deletePurchaseInfoPrice:"=",
					updatePurchaseInfoPrice:"=",
					addingPurchaseInfo:"<",
					processingData:"<"

				},
				templateUrl: "app/main/purchase-info/components/purchase-info-form.html",
				controller: componentController,
		  		controllerAs: 'vm'
			});

		function componentController(GeneralTools, $scope, ToolsConstants, LoginService, MessageService){
			var vm = this;		
			var companyID = LoginService.getCompanyID();

			vm.translateToDollar = GeneralTools.inputTranslators.dollar;
			vm.translateToPercentage = GeneralTools.inputTranslators.percentage;
			vm.purchasePriceTypeSelection;
			vm.purchasePriceTempHolder = {
				amount: null,
				description: null,
				rate: null,
				fk_id_price_type: null,
				fk_id_purchase_info: null
			};

			vm.disableCostDescription = false;
			//vm.addingPurchaseInfo = false;


			vm.taxRateInputOption = {
				decimalFractionSize:3,
				canBeNegative:false
			};

			vm.$onInit = initComponent;
			vm.$postLink = initOutputCallbacks;
			vm.AddPurchaseInfoPrice = AddPurchaseInfoPrice;
			vm.setPurchaseDate = setPurchaseDate;

			function initComponent(){
				initPurchaseDate();
				initTaxRate();
				//vm.addingPurchaseInfo = vm.purchaseInfoPrice.length == 0;
			}

			function initTaxRate(){
				if(vm.purchaseInfo == null){
					return;
				}

				if(vm.purchaseInfo.tax_rate == null){
					vm.purchaseInfo.tax_rate = ToolsConstants.taxRate;
				}
			}

			function initOutputCallbacks (){
				vm.isFormValid = isFormValid;
			}

			function initPurchaseDate(){
				if(vm.purchaseInfo == null){
					return;
				}
				vm.purchaseDatePickerValue = vm.purchaseInfo.getPurchaseDateMomentObj();
			}

			function setPurchaseDate(date){
				vm.purchaseInfo.setPurchaseDate(moment(date));
			}	

			function isFormValid(){
				$scope.purchaseInfoForm.$submitted = true;
				return $scope.purchaseInfoForm.$valid;
			}

			function AddPurchaseInfoPrice(){
				if(!vm.purchasePriceTypeSelection.id_price_type){
					MessageService.showToast("Please select a cost type");
					return;
				}else{
					vm.purchasePriceTempHolder.fk_id_price_type = vm.purchasePriceTypeSelection.id_price_type;
					vm.purchasePriceTempHolder.fk_id_purchase_info = vm.purchaseInfo.id_purchase_info;
					vm.createPurchaseInfoPrice(vm.purchasePriceTempHolder);
					resetPurchasePriceTempHolder()

				}
			}

			vm.onPriceTypeChange = function() {
				if(vm.purchasePriceTypeSelection.editable){
					vm.disableCostDescription = false;
				}else{
					vm.disableCostDescription = true;
					vm.purchasePriceTempHolder.description = vm.purchasePriceTypeSelection.text_column
				}
			};

			vm.removePurchaseInfoPrice = function(purchaseInfoPrice, index){
				if(purchaseInfoPrice.id_price){
					vm.deletePurchaseInfoPrice(purchaseInfoPrice.id_price);
				}else{
					vm.purchaseInfoPrice.splice(index, 1);
				}
			}

			vm.postPurchaseInfoPrice = function(purchaseInfoPrice, index){
				if(purchaseInfoPrice.amount == null || purchaseInfoPrice.description == null || purchaseInfoPrice.fk_id_price_type == null || purchaseInfoPrice.rate == null){
					MessageService.showToast("Please fill out all fields before saving");
					return;
				}
				else if(purchaseInfoPrice.id_price){
					vm.updatePurchaseInfoPrice(purchaseInfoPrice.id_price, purchaseInfoPrice);
				}else{
					var result = vm.createPurchaseInfoPrice(purchaseInfoPrice, index);
				}
			}

			function resetPurchasePriceTempHolder(){
				vm.purchasePriceTempHolder = {
					amount: null,
					description: null,
					rate: null,
					fk_id_price_type: null,
					fk_id_purchase_info: null
				};
			}

			vm.getPriceTypeTextById = function(id){
				var priceType = vm.purchaseInfoPriceType.find(function(auction){
					return auction.id_price_type == id;
				});
				return priceType.text_column;
			}

			vm.AddPurchaseInfoPriceRow = function () {
				if (vm.addingPurchaseInfo) {
					 if(vm.checkPurchaseInfoPrice()){
						MessageService.showToast("Please fill out the previous row before adding another")
					}else{
						vm.purchaseInfoPrice.push({
							id_price: null,
							fk_id_price_type: null,
							fk_id_purchase_info: vm.purchaseInfo.id_purchase_info,
							description: null,
							amount: null,
							rate: null,
							editable: true
						});
					}
				} else {
					if (!vm.checkPurchaseInfoPrice()) {
						vm.purchaseInfoPrice.push({
							id_price: null,
							fk_id_price_type: null,
							fk_id_purchase_info: vm.purchaseInfo.id_purchase_info,
							description: null,
							amount: null,
							rate: null,
							editable: true
						});
					} 
					else {
						MessageService.showToast("Please fill out the previous row and save before adding another")
					}
				}

			};

			vm.onPriceTypRoweChange = function(price) {
				var priceType = vm.purchaseInfoPriceType.find(function(price_type){
					return price_type.id_price_type == price.fk_id_price_type;
				});
				if(!priceType.editable){
					price.description = priceType.text_column
					price.editable = false;
				}else{
					price.description = '';
					price.editable = true;
				}
				
			};

			vm.checkPurchaseInfoPrice = function(){
				var result = false
				if(vm.purchaseInfoPrice.length == 0){
					return result;
				}else{
					vm.purchaseInfoPrice.forEach(function(price){
						if(price.amount == null || !price.description == null || price.fk_id_price_type == null || price.rate == null){
							result = true
						}
					})
					return result
				}
			}


		}
})();
(function ()
{
	"use strict";

	angular
		.module("app.purchaseInfo")
		.component("purchaseDisclosureList", {
				bindings:{
					disclosures:'=',
					onDisclosureAdded:'=',
					onDisclosureRemoved:'=',
					cleanNewDisclouser:'=',
					isProcessingData:'='
				},
				templateUrl: "app/main/purchase-info/components/purchase-info-disclosure-list.html",
				controller: componentController,
		  		controllerAs: 'vm'
			});

		function componentController(GeneralTools, Disclosure, MessageService){
			var vm = this;		

			vm.translateToDollar = GeneralTools.inputTranslators.dollar;

			vm.$onInit = initComponent;
			vm.$postLink = initOutputCallback;

			vm.addDisclosure = addDisclosure;

			function initComponent(){
			}

			function initOutputCallback(){
				vm.cleanNewDisclouser = cleanNewDisclouser;
			}

			function cleanNewDisclouser(){
				vm.description = null;
				vm.amount = null;
			}

			function addDisclosure(){
				var disclosure = new Disclosure();

				disclosure.description = vm.description;
				disclosure.amount = vm.amount;

				if(!disclosure.isDisclosureValid()){
					MessageService.showToast("Disclosure is invalid.");
					return;
				}

				vm.onDisclosureAdded(disclosure);
			}


		}
})();
(function ()
{
	"use strict";

	angular
		.module("app.purchaseInfo")
		.component("purchaseCostSummary", {
				bindings:{
					purchaseInfo:'=',
					tasks:'=',
					workorderList: '=',
					purchaseInfoPrice:"<",
				},
				templateUrl: "app/main/purchase-info/components/purchase-cost-summary.html",
				controller: componentController,
		  		controllerAs: 'vm'
			});

		function componentController($state, $scope, GeneralTools, MessageService, PurchaseCalculator){
			var vm = this;		
			var purchaseCalculator = new PurchaseCalculator();
			vm.$onInit = initComponent;
			vm.$postLink = postLink;

			vm.getTaskUrl = getTaskUrl;
			vm.getWorkorderUrl = getWorkorderUrl;

			vm.totalCostVersion2 = 0;
			vm.subTotalBeforeTax_2;
			vm.totalTax;
			vm.groupedPrices = [];

			function initComponent(){
				updateSummary();
			}

			function postLink(){
				$scope.$watch("vm.purchaseInfo.purchase_price", updateSummary);
				$scope.$watch("vm.purchaseInfo.licensing_cost", updateSummary);
				$scope.$watch("vm.purchaseInfo.tax_rate", updateSummary);
				$scope.$watch("vm.purchaseInfo.buyer_fee", updateSummary);
				$scope.$watch("vm.purchaseInfo.shipping_cost", updateSummary);
				$scope.$watch("vm.purchaseInfo.other_cost", updateSummary);
				$scope.$watch("vm.tasks.length", updateSummary);
				$scope.$watch("vm.workorderList", updateSummary, true);
				$scope.$watch("vm.purchaseInfoPrice.length", updateSummary);
				$scope.$watch(function() {return vm.purchaseInfoPrice;},updateSummary,true);
			}

			function updateSummary(){
				if(vm.purchaseInfo){
					purchaseCalculator.setPurchasePrice(vm.purchaseInfo.purchase_price);
					purchaseCalculator.setBuyerFee(vm.purchaseInfo.buyer_fee);
					purchaseCalculator.setShippingCost(vm.purchaseInfo.shipping_cost);
					purchaseCalculator.setOtherCost(vm.purchaseInfo.other_cost);
					purchaseCalculator.setTaxRate(vm.purchaseInfo.tax_rate);
					purchaseCalculator.setLicensingCost(vm.purchaseInfo.licensing_cost);
				}

				if(vm.workorderList){
					purchaseCalculator.setWorkorderList(vm.workorderList);
				}

				purchaseCalculator.setTasks(vm.tasks);

				vm.totalTax = ((purchaseCalculator.getTaskTotalCost() + purchaseCalculator.getWorkorderTotalCost()) * 0.13);
				
				vm.subTotalBeforeTax_2 = 0;
				catogorizePurchaseInfoPrice();

				vm.workorderListDetails = purchaseCalculator.getWorkorderDetails();
				vm.subTotalBeforeTax = purchaseCalculator.getSubTotalBeforeTax() 
				vm.subTotalBeforeTax_2 += purchaseCalculator.getTaskTotalCost() + purchaseCalculator.getWorkorderTotalCost();
				vm.hst = purchaseCalculator.getTax();
				vm.totalCost = purchaseCalculator.getTotalCost();
				vm.totalCostVersion2 = 0;
				vm.totalCostVersion2 = vm.subTotalBeforeTax_2 + vm.totalTax;
			}

			function getTaskUrl(task){
				return $state.href('app.edit-task', {taskID: task.id_task}, {absolute: true});
			}

			function getWorkorderUrl(workorderID){
				return $state.href('app.edit-workorder.general', {vehicleID:vm.purchaseInfo.fk_id_vehicle, workOrderID: workorderID});
			}

			function catogorizePurchaseInfoPrice(){	
				vm.groupedPrices = vm.purchaseInfoPrice.reduce(function (acc, item) {
					vm.subTotalBeforeTax_2 += item.amount;
					if(item.rate > 0){
						var group = acc.find(function (g) {
							return g.rate === item.rate;
						});
					
						if (group) {
							group.items.push(item);
							group.total += item.amount * item.rate;
							vm.totalTax += item.amount * item.rate;
							
						} else {
							acc.push({ rate: item.rate, items: [item], total: item.amount * item.rate });
							vm.totalTax += item.amount * item.rate;
						}
					}
					return acc;
				}, []);
			}
		}
})();
(function ()
{
    'use strict';

    angular
        .module('app.purchaseInfo')
        .controller('AddPurchaseInfoController', AddPurchaseInfoController);

    function AddPurchaseInfoController(DialogService, VehicleService, workorderPriorities, WorkOrderService, WorkOrderConstants, ToolsConstants, WorkOrder, $q, $stateParams, $state, MessageService, ProgressService, LoginService, auctions, PurchaseInfo, fetchedVehicleResult, PurchaseInfoService, FileUploadService, TaskConstants, TasksService, purchaseInfoPriceType){   
        var vm = this;
        var companyID = LoginService.getCompanyID();
        var vehicleID;
        var uploadFilesDefer = $q.defer();

        var taskCategoryFkDetail = 2;
		var taskCategoryFkAdvertising = 7; 
		var taskCategoryFkMechanic = 5; 
		var taskCategoryFkDocumentation = 3; 
		vm.purchaseInfoPrice = [];
		vm.purchaseInfoPriceType = [];

		const dialogOptions = {
			titleString: "Please Update Vehicle",
			contentString: "Purchase info is added, please update the mileage and carfax of the vehicle.",
			clickOutsideToClose: false,
			options: [{
				optionName: "GOT IT!",
				onClick: function(){
					DialogService.close();
				}
			}]
		};

        vm.createPurchaseInfo = createPurchaseInfo;
        vm.onDisclosureAdded = onDisclosureAdded;
        vm.onDisclosureRemoved = onDisclosureRemoved;

        init();

        function init(){
        	initAuctions();
        	initPurchaseInfo();
        	initVehicle();
        	initDisclosures();
        	initFileUploader();
			initPurchaseInfoPriceType();
        }

        function initFileUploader(){
			var customFilter = FileUploadService.getCustomFilter(["pdf", "jpg", "jpeg", "png"]);
			var sizeFilter 	 = FileUploadService.getSizeFilter(20);

			vm.purchaseInfoFileUploader = FileUploadService.getNewUploader();
			vm.purchaseInfoFileUploader.filters.push(customFilter);
			vm.purchaseInfoFileUploader.filters.push(sizeFilter);
        }

        function initDisclosures(){
        	vm.disclosures = [];
        }

        function initVehicle(){
        	if(fetchedVehicleResult == null || !Array.isArray(fetchedVehicleResult.data)){
        		MessageService.showToast("Vehicle Data is invalid.");
        		return;
        	}

        	vm.vehicle = fetchedVehicleResult.data[0];
        	vm.vehiclePageUrl = $state.href('app.vehicle.general', {vehicleID: vm.vehicle.getResourceID()});
        	vehicleID = vm.vehicle.getResourceID();
        }

        function initPurchaseInfo(){
        	vm.purchaseInfo = new PurchaseInfo();
        }

        function initAuctions(){
        	vm.auctions = auctions;
        }

        function createPurchaseInfo(){
        	if(!vm.isPurchaseInfoFormValid()){
        		MessageService.showToast("Please make sure all the fields are valid.");
        		return;
        	}

        	var resourcePath = {
        		companyID: companyID,
        		vehicleID: vehicleID
        	}

        	ProgressService.setMode("indeterminate");
			ProgressService.isVisble(true);

        	PurchaseInfoService.createPurchaseInfo(resourcePath, vm.purchaseInfo)
        		.then(function(purchaseInfoID){
        			return $q.all([
        				uploadFiles(purchaseInfoID), 
        				createDisclosures(purchaseInfoID), 
        				createDefaultTasks(vehicleID),
						createPurchaseInfoPriceList(purchaseInfoID)
        			]);
        		})
        		.then(function(){
					DialogService.showOptionsDialog(dialogOptions);
					$state.go("app.edit-vehicle", {vehicleID: vehicleID, tab: "purchaseInfo"});
        		})
        		.catch(MessageService.showToast)
        		.finally(function(){
        			ProgressService.isVisble(false);
        		});
        }

        function createDefaultTasks(vehicleID){
			var tasks = [];

			tasks.push(createDefaultTask(vehicleID, TaskConstants.newCarCleanTaskName, taskCategoryFkDetail));
			tasks.push(createDefaultTask(vehicleID, TaskConstants.processVehicleTaskName, taskCategoryFkAdvertising));
			//tasks.push(createDefaultTask(vehicleID, TaskConstants.newCarOilChangeTaskName, taskCategoryFkMechanic));
			tasks.push(createDefaultTask(vehicleID, TaskConstants.createFolderAndTagKeyTaskName, taskCategoryFkDocumentation));

			return $q.all(tasks);
		}

		function createDefaultTask(vehicleID, taskName, category){
			var resourcePath = { companyID: companyID };

			var requestBody = {
				assigned_to_vehicle: {id_vehicle: vehicleID},
				fk_id_task_category: category,
				fk_id_task_priority: 3,
				fk_id_task_status: 1,
				name: taskName
			}

			return TasksService.createTask(resourcePath, requestBody)
		}


        function uploadFiles(purchaseInfoID){
        	if(vm.purchaseInfoFileUploader.queue.length <= 0){
        		return $q.resolve();
        	}

        	vm.purchaseInfoFileUploader.queue.forEach(function(fileItem){
        		fileItem.url = FileUploadService.getUrlForCreatePurchaseInfoFile(vehicleID, purchaseInfoID);
        	});

        	vm.purchaseInfoFileUploader.uploadAll()
        	return uploadFilesDefer.promise;
        }

        vm.purchaseInfoFileUploader.onCompleteAll = function(){
        	uploadFilesDefer.resolve();
        }

        function createDisclosures(purchaseInfoID){
        	if(!Array.isArray(vm.disclosures)){
        		return $q.reject("Disclosures is not an array");
        	}

        	var tasks = [];

        	var resourcePath = {
        		companyID: companyID,
        		vehicleID: vehicleID,
        		purchaseinfoID: purchaseInfoID
        	}

        	vm.disclosures.forEach(function(disclosure){
        		tasks.push(createDisclosure(resourcePath, disclosure));
        	});

        	return $q.all(tasks);
        }

        function createDisclosure(resourcePath, disclosure){
        	var defer = $q.defer();

        	PurchaseInfoService.createPurchaseDisclosure(resourcePath, disclosure)
        		.then(function(newDisclosureID){
        			disclosure.setResourceID(newDisclosureID);
        			defer.resolve();
        		})
        		.catch(function(error){
        			defer.reject(error);
        		});

        	return defer.promise;
        }

        function onDisclosureRemoved(diclosure, index){
        	vm.disclosures.splice(index, 1);
        }

        function onDisclosureAdded (diclosure){
			vm.disclosures.push(diclosure);
			vm.cleanNewDisclouser();	
        }

		function initPurchaseInfoPriceType(){
			vm.purchaseInfoPriceType = purchaseInfoPriceType;
		}

		vm.tempCreatePurchaseInfoPrice= function(requestBody){	
			vm.purchaseInfoPrice.push(requestBody);
		}

		function createPurchaseInfoPriceList(purchaseInfoID) {
			if (!Array.isArray(vm.purchaseInfoPrice)) {
				return $q.reject("Purchase Info Price is not an array");
			}
		
			var resourcePath = {
				companyID: companyID,
				vehicleID: vehicleID,
				purchaseinfoID: purchaseInfoID
			};
			var tasks = vm.purchaseInfoPrice.map(function (purchaseInfoPriceItem) {
				if(purchaseInfoPriceItem.amount != null && purchaseInfoPriceItem.description != null && purchaseInfoPriceItem.fk_id_price_type != null && purchaseInfoPriceItem.rate != null){
					return createPurchaseInfoPrice(resourcePath, purchaseInfoPriceItem); 
				}
			});
		
			return $q.all(tasks);
		}
		
		function createPurchaseInfoPrice(resourcePath, purchaseInfoPriceItem) {
			return PurchaseInfoService.createPurchaseInfoPrice(resourcePath, purchaseInfoPriceItem)
				.then(function (result) {
				})
				.catch(function (error) {
					return $q.reject(error);
				});
		}

		vm.deletePurchaseInfoPrice = function(purchaseinfopriceID, index){
			vm.purchaseInfoPrice.splice(index, 1);
		}

		vm.updatePurchaseInfoPrice = function(purchaseinfopriceID, purchaseinfoprice){
			MessageService.showToast("Success.")
		}
    }
})();
(function ()
{
	'use strict';

	angular
		.module('app.inventory', [])
		.constant("InventoryConstants", {
			keyNames:{
				type: "inventory.fk_id_part_type",
				name: "inventory.name",
				code: "inventory.code",
				purchasePrice: "inventory.purchase_price",
				retailPrice: "inventory.retail_price",
				quantity: "inventory.quantity"			
			}
		})
		.config(config)
		.run(run)

	function run(msNavigationService, LoginService, InventoryConstants){
		/*msNavigationService.saveItem("inventory", {
			title : "INVENTORY",
			icon : "icon-car",
			weight: 3,
			requiredRoles:[]			 
		});

		msNavigationService.saveItem('inventory.add-inventory', {
			title: 'Add Inventory',
			state: 'app.add-inventory',
			requiredRoles:[]			 
		});

		msNavigationService.saveItem('inventory.manage-inventory', {
			title: 'Manage Inventory',
			state: 'app.manage-inventory',
			requiredRoles:[]	
		});*/
	}

	/** @ngInject */
	function config($stateProvider)
	{	  

		$stateProvider
			.state('app.manage-inventory', {
				url : '/inventory?type&name&code&limit&sortBy&sortDirection&page',
				reloadOnSearch : false,
				views	: {
					'content@app': {
						templateUrl: 'app/main/inventory/manage-inventory/manage-inventory.html',
						controller : 'ManageInventoryController as vm'
					}
				},
				resolve :{
					constants:function(MessageService, InventoryService, $q, LoginService){
						const resourcePath = { companyID: LoginService.getCompanyID() };
						const queue = { 
							//suppliers: InventoryService.getSuppliers(resourcePath),
							inventoryTypes: InventoryService.getInventoryTypes() 
						};

						return $q.all(queue).catch(MessageService.showToast);
					}
				}
			})
			.state('app.edit-inventory', {
				url : '/editinventory/{inventoryID}',
				views	: {
					'content@app': {
						templateUrl: 'app/main/inventory/edit-inventory/edit-inventory.html',
						controller : 'EditInventoryController as vm'
					}
				},
				resolve :{
					constants:function(MessageService, InventoryService, $q, LoginService){
						const queue = { inventoryTypes: InventoryService.getInventoryTypes() }

						return $q.all(queue).catch(MessageService.showToast);
					},
					inventory:function(MessageService, InventoryService, $q, LoginService, $stateParams){
						const resourcePath = { 
							companyID: LoginService.getCompanyID(),
							inventoryID: $stateParams.inventoryID
						};

						return InventoryService.getInventories(resourcePath).catch(MessageService.showToast);
					}
				}
			})
			/*.state('app.add-inventory', {
				url : '/addinventory',
				views	: {
					'content@app': {
						templateUrl: 'app/main/inventory/add-inventory/add-inventory.html',
						controller : 'AddInventoryController as vm'
					}
				},
				resolve :{
					constants:function(MessageService, InventoryService, $q, LoginService){
						const resourcePath = { companyID: LoginService.getCompanyID() };
						const queue = { 
							inventoryTypes: InventoryService.getInventoryTypes()
						};

						return $q.all(queue).catch(MessageService.showToast);
					}
				}
			});*/
			
	}

})();
(function ()
{
	'use strict';

	angular
		.module('app.inventory')
		.controller('ManageInventoryController', ManageInventoryController);

	function ManageInventoryController($mdDialog, $stateParams, $q, InventoryService, LoginService, MessageService, ProgressService, HeaderHelper, constants, GeneralTools, ToolsConstants, $location, InventoryConstants){   
		const vm = this;
		const companyID = LoginService.getCompanyID();
		const filterConsts = ToolsConstants.apiFilters;
		const keyNames = InventoryConstants.keyNames;
		const keyNameInventoryType = keyNames.type;
		const keyNameInventoryName = keyNames.name;
		const keyNameCode = keyNames.code;

		vm.displayOptions = [10, 25, 50, 100];
		vm.refreshInventoryList = refreshInventoryList;
		vm.onSortingChanged = onSortingChanged;
		vm.addInventory = addInventory;

		init();

		function init(){
			initConstants();
			initStateParams();
			refreshInventoryList(vm.currentPage);
		}

		function initStateParams(){
			vm.itemsPerPage = getDisplayOption(GeneralTools.urlNumberParamTranslator($stateParams.limit));
			vm.currentPage = GeneralTools.urlNumberParamTranslator($stateParams.page);

			vm.inventoryType = GeneralTools.urlNumberParamTranslator($stateParams.type);
			vm.nameSearchText = GeneralTools.urlStringParamTranslator($stateParams.name);
			vm.codeSearchText = GeneralTools.urlStringParamTranslator($stateParams.code);

			vm.sortBy = GeneralTools.urlStringParamTranslator($stateParams.sortBy);
			vm.sortDirection = GeneralTools.urlStringParamTranslator($stateParams.sortDirection);
		}

		function getDisplayOption(itemPerPage){
			if(vm.displayOptions.indexOf(itemPerPage) == -1){
				return vm.displayOptions[0];
			}

			return itemPerPage;
		}

		function initConstants(){
			if(!constants){
				return;
			}

			vm.inventoryTypes = constants.inventoryTypes;
		}

		function refreshInventoryList(page){
			const resourcePath = {
				companyID: companyID
			}

			vm.isFetchingData = true;
			ProgressService.setMode("indeterminate");
			ProgressService.isVisble(true);

			InventoryService.getInventories(resourcePath, getFilter(), getPagination(page), getSorting())
				.then(function(result){
					if(!result){
						return $q.reject("Inventory result invalid.");
					}

					vm.inventoryList = result.data;

					resetPagination(result.headerGetter);
					refreshUrl();
				})
				.catch(MessageService.showToast)
				.finally(function(){
					vm.isFetchingData = false;
					ProgressService.isVisble(false);
				});
		}

		function getSorting(){
			return {
				sortBy: vm.sortBy,
				sortDirection: vm.sortDirection
			};
		}

		function refreshUrl(){
			const urlParams = {};

			urlParams.limit = vm.itemsPerPage === undefined ? undefined : vm.itemsPerPage + '';
			urlParams.page = vm.currentPage === undefined ? undefined : vm.currentPage + '';

			urlParams.type = vm.inventoryType === undefined ? undefined : vm.inventoryType + '';
			urlParams.name = vm.nameSearchText === undefined ? undefined : vm.nameSearchText + '';
			urlParams.code = vm.codeSearchText === undefined ? undefined : vm.codeSearchText + '';

			urlParams.sortBy = vm.sortBy === undefined ? undefined : vm.sortBy + '';
			urlParams.sortDirection = vm.sortDirection === undefined ? undefined : vm.sortDirection + '';

			$location.search(urlParams).replace();
		}

		function getPagination(page){
			return {
				page: page,
				limit: vm.itemsPerPage
			}
		}

		function getFilter(){
			var filterString = '';

			if(vm.inventoryType){
				filterString = GeneralTools.stringConnector(filterString, GeneralTools.equalFilterBuilder(keyNameInventoryType, vm.inventoryType), filterConsts.andConnector);
			}

			if(vm.nameSearchText){
				filterString = GeneralTools.stringConnector(filterString, GeneralTools.containFilterBuilder(keyNameInventoryName, vm.nameSearchText), filterConsts.andConnector);
			}

			if(vm.codeSearchText){
				vm.codeSearchText = vm.codeSearchText.replace(/[^a-zA-Z0-9]/g, '');
				filterString = GeneralTools.stringConnector(filterString, GeneralTools.containFilterBuilder(keyNameCode, vm.codeSearchText), filterConsts.andConnector);
			}

			if(filterString){
				return { filters: filterString };
			}
		}

		function resetPagination(headerGetter){
			vm.totalCount = HeaderHelper.getPaginationTotalItem(headerGetter);
			vm.currentPage = HeaderHelper.getPaginationCurrentPage(headerGetter);
		}

		function onSortingChanged(sortBy, sortDirection){
			vm.sortBy = sortBy;
			vm.sortDirection = sortDirection;

			refreshInventoryList(1);
		}

		function addInventory(){
			$mdDialog.show({
				controller: 'AddInventoryDialogController',
				controllerAs: 'vm',
				templateUrl: 'app/main/inventory/add-inventory/add-inventory-dialog.html',
				clickOutsideToClose: true,
				locals: {
					inventoryTypes: vm.inventoryTypes
				}
			})
			.then(function(id){
				MessageService.showToast("Inventory added", id);
				refreshInventoryList(1);
			})
			.catch(function(error){
				if(error){
					MessageService.showToast(error);
				}
			});
		}
	}
})();
(function ()
{
	'use strict';

	angular
		.module('app.inventory')
		.controller('EditInventoryController', EditInventoryController);

	function EditInventoryController(MessageService, constants, inventory, Inventory, InventoryService, LoginService, ProgressService, DialogService, $state){   
		const vm = this;
		const companyID = LoginService.getCompanyID();
		const confirmString = "CONFIRM";

		vm.save = save;
		vm.deleteInventory = deleteInventory;

		init();

		function init(){
			initConstants();
			initInventory();
		}

		function initConstants(){
			if(!constants){
				return;
			}

			vm.inventoryTypes = constants.inventoryTypes;
		}

		function initInventory(){
			if(!inventory || !Array.isArray(inventory.data) || inventory.data.length != 1 || !inventory.data[0]){
				MessageService.showToast("Inventory data invalid");
				return;
			}
			vm.inventory = inventory.data[0];

			vm.originInventory = angular.copy(vm.inventory);
		}

		function save(){
			if(!vm.isFormValid()){
				MessageService.showToast("Please make sure every field is valid.")
				return;
			}

			const requestBody = InventoryService.updateInventoryRequestBodyGenerator(vm.inventory, vm.originInventory);

			if(Object.keys(requestBody).length <= 0){
				MessageService.showToast("No changes detected.")
				return;
			}

			const resourcePath = { 
				companyID: companyID,
				inventoryID: vm.inventory.id_inventory
			};

			vm.isSaving = true;
			ProgressService.setMode("indeterminate");
			ProgressService.isVisble(true);

			InventoryService.updateInventory(resourcePath, requestBody)
				.then(function(){
					MessageService.showToast("Success");
					vm.originInventory = angular.copy(vm.inventory);
				})
				.catch(MessageService.showToast)
				.finally(function(){
					vm.isSaving = false;
					ProgressService.isVisble(false);
				});
		}

		function deleteInventory (){
			var dialogOptions = {};

			dialogOptions.inputBoxPlaceHolder = "Enter here";
			dialogOptions.cancelButtonString = "CANCEL";
			dialogOptions.confirmButtonString = "CONFIRM";
			dialogOptions.titleString = "ARE YOU SURE TO DELETE THIS INVENTORY";
			dialogOptions.contentString = "Please Type \"" + confirmString + "\" below:";

			dialogOptions.confirmCallback = confirmDeleteInventoryCallback;
			dialogOptions.enableConfirmButtonCallback = enableDeleteVehicleButtonCallback;

			DialogService.showConfirmDialog(dialogOptions);
		}

		function enableDeleteVehicleButtonCallback(inputString){
			if(inputString === confirmString){
				return true;
			}
			return false;
		}

		function confirmDeleteInventoryCallback(){
			const resourcePath = { 
				companyID: companyID,
				inventoryID: vm.inventory.id_inventory
			};

			vm.isDeleting = true;
			ProgressService.setMode("indeterminate");
			ProgressService.isVisble(true);

			InventoryService.deleteInventory(resourcePath)
				.then(function(){
					MessageService.showToast("Success");
					$state.go("app.manage-inventory");
				})
				.catch(MessageService.showToast)
				.finally(function(){
					vm.isDeleting = false;
					ProgressService.isVisble(false);
				});
		}
	}
})();
(function ()
{
	'use strict';

	angular
		.module('app.inventory')
		.controller('AddInventoryController', AddInventoryController);

	function AddInventoryController(ToolsConstants, MessageService, constants, Inventory, InventoryService, LoginService, ProgressService, $state){   
		const vm = this;
		const companyID = LoginService.getCompanyID();

		vm.createInventory = createInventory;

		init();

		function init(){
			initConstants();
			initInventory();
		}

		function initConstants(){
			if(!constants){
				return;
			}

			vm.inventoryTypes = constants.inventoryTypes;
		}

		function initInventory(){
			vm.inventory = new Inventory();

			vm.inventory.purchase_tax_rate = ToolsConstants.taxRate;
		}

		function createInventory(){
			if(!vm.isFormValid()){
				MessageService.showToast("Please make sure every field is valid.")
				return;
			}

			if(!vm.isFormValid()){
				MessageService.showToast("Please make sure every field is valid.")
				return;
			}

			const resourcePath = { 
				companyID: companyID
			};

			vm.isSavingInventoryData = true;
			ProgressService.setMode("indeterminate");
			ProgressService.isVisble(true);

			InventoryService.createInventory(resourcePath, vm.inventory)
				.then(function(){
					MessageService.showToast("Success");

					const param = {
						name: vm.inventory.name,
						code: vm.inventory.code,
						type: vm.inventory.fk_id_part_type,
					};

					$state.go("app.manage-inventory", param);
				})
				.catch(MessageService.showToast)
				.finally(function(){
					vm.isSavingInventoryData = false;
					ProgressService.isVisble(false);
				});
		}
	}
})();
(function ()
{
	'use strict';

	angular
		.module('app.inventory')
		.controller('AddInventoryDialogController', AddInventoryDialogController);

	function AddInventoryDialogController(LoginService, Inventory, $mdDialog, MessageService, inventoryTypes, ToolsConstants, InventoryService){   
		const vm = this;
		const companyID = LoginService.getCompanyID();

		vm.inventory = new Inventory();
		vm.inventory.purchase_tax_rate = ToolsConstants.taxRate;

		vm.inventoryTypes = inventoryTypes
		vm.closeDialog = closeDialog;
		vm.createInventory = createInventory

		function createInventory() {
			if(!vm.isFormValid()){
				MessageService.showToast("Please make sure every field is valid.")
				return;
			}
			const resourcePath = { 
				companyID: companyID
			};

			vm.isSavingInventoryData = true;
			InventoryService.createInventory(resourcePath, vm.inventory)
				.then(function(newInventoryID){
					$mdDialog.hide(newInventoryID);
				})
				.catch(MessageService.showToast)
				.finally(function(){
					vm.isSavingInventoryData = false;
				})
		}

		function closeDialog (){
			$mdDialog.cancel();
		}

		

	}
})();
(function ()
{
	"use strict";

	angular
		.module("app.inventory")
		.component("inventoryList", {
				bindings:{
					inventoryList:'=',
					sortBy:'<',
					sortDirection:'<',
					onSortingChanged: '<',
					inventoryTypes:'<'
				},
				templateUrl: "app/main/inventory/components/inventory-list.html",
				controller: componentController,
		  		controllerAs: 'vm'
			});

		function componentController(GeneralTools, Inventory, $scope, $state, ToolsConstants, InventoryConstants){
			const vm = this;
			const sortingDirections = ToolsConstants.apiSortingDirections;
			const keyNames = InventoryConstants.keyNames;

			vm.directionDesc = sortingDirections.DESC;
			vm.directionAsc = sortingDirections.ASC;

			vm.sortTagName = keyNames.name;
			vm.sortTagCode = keyNames.code;
			vm.sortTagType = keyNames.type;
			vm.sortTagPurchasePrice = keyNames.purchasePrice;
			vm.sortTagRetailPrice = keyNames.retailPrice;
			vm.sortTagQuantity = keyNames.quantity;

			vm.$onInit = initComponent;
			vm.getTypeName = getTypeName
			vm.getInventoryPageUrl = getInventoryPageUrl;
			vm.changeSorting = changeSorting;

			function initComponent(){
				if(!Array.isArray(vm.inventoryTypes)){
					vm.inventoryTypes = [];
				}
			}

			function getTypeName(typeID) {
				const matchedType = vm.inventoryTypes.find(function(type){
					return !!type && type.id_part_type == typeID;
				});
				
				if(!!matchedType){
					return matchedType.name;
				}

				return "Unknown";
			}

			function getInventoryPageUrl(inventory){
				if(!inventory){
					return;
				}

				return $state.href("app.edit-inventory", {inventoryID: inventory.id_inventory});
			}

			function changeSorting(sortTag) {
				if(vm.sortBy == sortTag){
					vm.sortDirection = vm.sortDirection == vm.directionAsc ? vm.directionDesc : vm.directionAsc;
				} else {
					vm.sortDirection = vm.directionAsc;
				}

				vm.sortBy = sortTag;

				if(typeof(vm.onSortingChanged) == "function"){
					vm.onSortingChanged(vm.sortBy, vm.sortDirection);
				}
			}
		}
})();
(function ()
{
	"use strict";

	angular
		.module("app.inventory")
		.component("inventoryInfoForm", {
				bindings:{
					inventory:'=',
					inventoryTypes:'<',
					isFormValid:'=',
					isProcessingData: "=",
					onDuplicatedUrlClick: "<",
					originCode:'<'
				},
				templateUrl: "app/main/inventory/components/inventory-info-form.html",
				controller: componentController,
		  		controllerAs: 'vm'
			});

		function componentController(GeneralTools, Inventory, $scope, InventoryService, LoginService, $q, MessageService, $state, InventoryConstants){
			const vm = this;
			const companyID = LoginService.getCompanyID();

			var exsitingInventoryID;

			vm.$onInit = initComponent;
			vm.$postLink = initOutPutCallbacks;
			vm.checkOutInventory = checkOutInventory;

			vm.translateToDollar = GeneralTools.inputTranslators.dollar;
			vm.translateToPercentage = GeneralTools.inputTranslators.percentage;

			vm.taxRateInputOption = {
				decimalFractionSize:0,
				canBeNegative:false
			};

			vm.codeValidations = [
				{
					name:"duplicateCheck",
					validateFn:codeExistingValidation
				}
			]

			function initComponent(){
				initInventoryTypes();
				initInventory();
			}

			function  initInventoryTypes(argument) {
				if(!Array.isArray(vm.inventoryTypes)){
					vm.inventoryTypes = [];
				}
			}

			function initInventory(argument) {
				if(!vm.inventory){
					vm.inventory = new Inventory();
				}
			}

			function initOutPutCallbacks(){
				vm.isFormValid = isFormValid;
			}

			function isFormValid(){
				$scope.inventoryInfoForm.$submitted = true;
				return $scope.inventoryInfoForm.$valid;
			};

			function codeExistingValidation(modelValue, viewValue){
				var defer = $q.defer();

				if(modelValue == null){
					return $q.resolve();
				}

				if(vm.originCode == modelValue){
					return $q.resolve();
				}

				const resourcePath = { companyID: companyID };
				const filters = {filters: GeneralTools.equalFilterBuilder(InventoryConstants.keyNames.code, modelValue)};

				InventoryService.getInventories(resourcePath, filters)
					.then(function(result){
						if(result && Array.isArray(result.data) && result.data.length > 0){
							exsitingInventoryID = result.data[0].id_inventory;
							defer.reject();
						} else {
							exsitingInventoryID = null;
							defer.resolve();
						}
					})
					.catch(MessageService.showToast)

				return defer.promise;
			}

			function checkOutInventory() {
				if(typeof(vm.onDuplicatedUrlClick) == "function"){
					vm.onDuplicatedUrlClick(exsitingInventoryID);
				}

				if(exsitingInventoryID){
					$state.go("app.edit-inventory", {inventoryID: exsitingInventoryID});
				}
			}
		}
})();
(function ()
{
	'use strict';

	angular
		.module('app.parts', [])
		.constant("PartConstants", {
			keyNames:{
				type: "part.fk_id_part_type",
				name: "part.name",
				code: "part.code",
				purchasePrice: "part.purchase_price",
				retailPrice: "part.retail_price",
				quantity: "part.quantity",
				purchaseInvoiceID: "part.fk_id_purchase_invoice",
				returnInvoiceID: "part.fk_id_return_invoice"		
			},
			styleClasses:{
				notOrdered: "text-red",
				orderedUninvoiced: "text-orange",
				orderedInvoiced: "text-green",
				returnedForTable: "strikeout",
				returnedForDiv: "strike",
				inventoryNotEnough: "text-deep-yellow"
			},
			partTypeIDs:{
				OIL: 1,
				FILTER: 2,
				TIRE: 3,
				BRAKES: 4,
				OTHER: 5,
				RIM: 6,
				WIPERS: 7
			}
		})
		.config(config)
		.run(run)

	function run(msNavigationService, LoginService, PartConstants){

		/*msNavigationService.saveItem("part", {
			title : "PARTS",
			icon : "icon-car",
			weight: 3,
			requiredRoles:[]
		});

		msNavigationService.saveItem('part.browse-parts', {
			title: 'Browse Parts',
			state: 'app.browse-parts',
			requiredRoles:[]	
		});*/
	}

	/** @ngInject */
	function config($stateProvider)
	{	  

		$stateProvider
			.state('app.browse-parts', {
				url : '/parts?type&code&name&uninvoiced&sortBy&sortDirection&limit&page',
				reloadOnSearch : false,
				views	: {
					'content@app': {
						templateUrl: 'app/main/parts/browse-parts/browse-parts.html',
						controller : 'BrowsePartsController as vm'
					}
				},
				resolve:{
					constants:function(MessageService, PurchaseInvoiceService, InventoryService, $q, LoginService){
						const resourcePath = { companyID: LoginService.getCompanyID() };
						const queue = { 
							suppliers: PurchaseInvoiceService.getCachedSuppliers(resourcePath),
							partTypes: InventoryService.getInventoryTypes() 
						};

						return $q.all(queue).catch(MessageService.showToast);
					}
				}
			})
/*		
			.state('app.edit-part', {
				url : '/editpart/{partID}',
				views	: {
					'content@app': {
						templateUrl: 'app/main/part/edit-part/edit-part.html',
						controller : 'EditPartController as vm'
					}
				},
				resolve :{
					constants:function(MessageService, PartService, $q, LoginService){
						const queue = { partTypes: PartService.getPartTypes() }

						return $q.all(queue).catch(MessageService.showToast);
					},
					part:function(MessageService, PartService, $q, LoginService, $stateParams){
						const resourcePath = { 
							companyID: LoginService.getCompanyID(),
							partID: $stateParams.partID
						};

						return PartService.getInventories(resourcePath).catch(MessageService.showToast);
					}
				}
			})
			.state('app.add-part', {
				url : '/addpart',
				views	: {
					'content@app': {
						templateUrl: 'app/main/part/add-part/add-part.html',
						controller : 'AddPartController as vm'
					}
				},
				resolve :{
					constants:function(MessageService, PartService, $q, LoginService){
						const resourcePath = { companyID: LoginService.getCompanyID() };
						const queue = { 
							partTypes: PartService.getPartTypes()
						};

						return $q.all(queue).catch(MessageService.showToast);
					}
				}
			});*/
			
	}

})();
(function ()
{
	"use strict";

	angular
		.module("app.parts")
		.component("partsTable", {
				bindings:{
					hideAdding:'<',
					disableSelect:'<',
					disableAdding:'<',
					disableEditing:'<',
					tabs:'<',
					onTabChange:'<',
					onInventoryQuantityChange:'<',
					matchedInventories: '=',
					currentTabIndex:'=',
					hiddenColumns: '<',
					suppliers: '<',
					types:'<',
					partList:'=',
					onAddNewPart: '<',
					onPartMatchInventory: '<',
					invoiceMap:"=",
					returnInvoiceMap:"=",
					isFormValid:'=',
					workOrderJobList:'=',
					colorCache: '=',
					defaultRetailPercentadge: '=',
					isFromPurchaseInvoice: '=',
				},
				templateUrl: "app/main/parts/components/parts-table.html",
				controller: componentController,
		  		controllerAs: 'vm'
			});

		function componentController(WorkOrderInventory, ReturnInvoiceService, GeneralTools, $scope, $state, ToolsConstants, InventoryConstants, $q, LoginService, InventoryService, Part, $timeout, PurchaseInvoiceService, PurchaseInvoiceConstants, ReturnInvoiceConstants, PurchaseInvoice, MessageService, PartTypesService){
			const vm = this;
			const companyID = LoginService.getCompanyID();
			const isOrderedKeyName = "isOrdered";
			const isReturnedKeyName = "isReturned";
			const userID = LoginService.getUserID();
			
			var isloading = false
			vm.maxCodeLength = 50;
			vm.maxNameLength = 250;
			vm.translateToDollar = GeneralTools.inputTranslators.dollar;
			vm.decimalTranslator = GeneralTools.inputTranslators.decimal;
			vm.allInitCapitalizeTranslator = GeneralTools.inputTranslators.allInitCapitalize;
			vm.isFromPurchaseInvoice = vm.isFromPurchaseInvoice || false;
			vm.quantityInputOption = {
				decimalFractionSize:2
			};

			vm.$onInit = initComponent;
			vm.$postLink = initOutPutCallbacks;
			vm.onQuantityChange = onQuantityChange;
			vm.pullDataFromMatchedInventory = pullDataFromMatchedInventory;
			vm.isApplyButtonEnabled = isApplyButtonEnabled;
			vm.applyGroupEdit = applyGroupEdit;
			vm.getDropDownButtonClass = getDropDownButtonClass;
			vm.selectPurchaseInvoice = selectPurchaseInvoice;
			vm.selectReturnInvoice = selectReturnInvoice;
			vm.queryPurchaseInvoice = queryPurchaseInvoice;
			vm.queryReturnInvoice = queryReturnInvoice;
			vm.getSupplierName = getSupplierName;
			vm.getTypeName = getTypeName;
			vm.queryInventoryByName = queryInventoryByName;
			vm.queryInventoryByCode = queryInventoryByCode;
			vm.isAnySelected = isAnySelected;
			vm.isAllSelected = isAllSelected;
			vm.selectAll = selectAll;
			vm.onRowFocus = onRowFocus;
			vm.onRowBlur = onRowBlur;
			vm.onInputFocus = onInputFocus;
			vm.onInputBlur = onInputBlur;
			vm.addNewRow = addNewRow;	
			vm.getInvoiceSupplier = getInvoiceSupplier;
			vm.getInvoiceNumber = getInvoiceNumber;	
			vm.getInvoiceLink = getInvoiceLink;
			vm.getReturnInvoiceSupplier = getReturnInvoiceSupplier;
			vm.getReturnInvoiceNumber = getReturnInvoiceNumber;
			vm.getReturnInvoiceLink = getReturnInvoiceLink;
			vm.getPartNumber = getPartNumber;
			vm.onPartTypeSelected = onPartTypeSelected;
			vm.getWorkOrderJobIdFromItemId = getWorkOrderJobIdFromItemId;
			vm.onCostChange = onCostChange;
			vm.onRetailChange = onRetailChange;
			vm.getWorkOrderLink = getWorkOrderLink;

			vm.parttypelist = [];


			function onPartTypeSelected(id){
				var value = vm.partList[id].type
				//vm.parttypelist[id].laborData.fk_id_labour_type = parseInt(value);
				// vm.laborList[id].laborData.labour_name = text;
				for(var i = 0; i<vm.parttypelist.length;i++){
					// if(parseInt(value) == vm.parttypelist[i].id_part_type){
					// 	vm.partList[id].retailPrice = parseInt(vm.parttypelist[i].default_retail)
					// 	vm.partList[id].updateProperty("retailPrice")
					// }
				}
				// refreshlabourtypeoptions(e, e.selectedIndex)
			}
			

			function initComponent() {
				$scope.$watch("vm.focusIndex", function (newValue, oldValue) {
					if (vm.editingIndex != oldValue) {
						removeEmptyRow(oldValue)
					}
				});

				$scope.$watch("vm.partList", refreshGroupEditorUI, true);
				$scope.$watch("vm.currentTabIndex", cleanGroupEditorUI);
				$scope.$watch("vm.purchaseInvoiceSearchText", onPurchaseInvoiceSearchTextChange);
				$scope.$watch("vm.returnInvoiceSearchText", onReturnInvoiceSearchTextChange);

				vm.partList.forEach(function(item){
					onRetailChange(item)
				})

				PartTypesService.getparttypes({
					companyID: companyID,
					userID: userID
				}).then(function (result) {
					for (var i = 0; i < result.length; i++) {
						// if(result[i].deleted != 1){

						// }
						vm.parttypelist.push(result[i])
					}
				});
			}

			function cleanGroupEditorUI(){
				vm.showGroupEdit = false;

				vm.supplierID = undefined;
				vm.selectedPurchaseInvoice = undefined;
				vm.selectedReturnInvoice = undefined;
				vm.purchaseInvoiceSearchText = undefined;
				vm.returnInvoiceSearchText = undefined;
				vm.ordered = undefined;
				vm.returned = undefined;

				refreshGroupEditorUI();
			}

			function refreshGroupEditorUI(){
				if(!Array.isArray(vm.partList)){
					return;
				}
				const hasFilter = Array.isArray(vm.tabs) && !!vm.tabs[vm.currentTabIndex] && typeof(vm.tabs[vm.currentTabIndex].filter) == "function";
				const supplierList = [];
				const returnInvoiceSupplierList = [];
				var isPartSelected = false;
				var isInventorySelected = false;
				var allHavePurchaseInvoice = true;
				var allReturned = true;
				var allNotReturned = true;
				var allOrdered = true;
				var allNotOrdered = true;

				vm.partList.forEach(function(item){
					if((hasFilter && !vm.tabs[vm.currentTabIndex].filter(item)) || !item || !item.isSelected){
						return;
					}

					if(item.inventoryData){
						isInventorySelected = true;
						return;
					}

					if(!item.partData){
						return;
					}

					isPartSelected = true;

					addSupplierIdToList(supplierList, getPurchaseInvoiceSupplierID(item));
					const returnSupplierID = getReturnInvoiceSupplierID(item);
					addSupplierIdToList(supplierList, returnSupplierID);
					addSupplierIdToList(returnInvoiceSupplierList, returnSupplierID);

					if(!item.partData.fk_id_purchase_invoice){
						allHavePurchaseInvoice = false;
					}

					if(item.partData.is_returned){
						allNotReturned = false;
					} else {
						allReturned = false;
					}

					if(item.partData.is_ordered){
						allNotOrdered = false;
					} else {
						allOrdered = false;
					}
				});

				if(!isPartSelected || isInventorySelected){
					vm.enableDropDownButton = false;
					vm.showGroupEdit = false;
					return;
				}

				vm.enableDropDownButton = true;

				// Refresh supplier selector.
				vm.enableSupplierSelector = supplierList.length <= 0;
				vm.supplierID = supplierList.length == 1 ? supplierList[0] : undefined;

				// Refresh purchase invoice inputs
				vm.enablePurchaseInvoiceInput = supplierList.length <= 0 && allNotReturned;

				// Refresh return invoice inputs
				vm.enableReturnInvoiceInput = supplierList.length <= 1 && allHavePurchaseInvoice && returnInvoiceSupplierList.length <= 0;

				if(allNotReturned && (allOrdered || allNotOrdered) && supplierList.length <= 0){
					vm.enableOrderedCheckBox = true;
					vm.ordered = allOrdered;
				} else {
					vm.enableOrderedCheckBox = false;
					if(allOrdered){
						vm.ordered = true;
					} else if (allNotOrdered){
						vm.ordered = false;
					} else {
						vm.ordered = undefined;
					}
				}

				if(allHavePurchaseInvoice && allOrdered && (allReturned || allNotReturned) && returnInvoiceSupplierList.length <= 0){
					vm.enableReturnedCheckBox = true;
					vm.returned = allReturned;
				} else {
					vm.enableReturnedCheckBox = false;
					if(allReturned){
						vm.returned = true;
					} else if (allNotReturned){
						vm.returned = false;
					} else {
						vm.returned = undefined;
					}
				}
			}

			function isApplyButtonEnabled() {
				if((vm.returnInvoiceSearchText || vm.purchaseInvoiceSearchText) && !vm.supplierID){
					return false;
				}

				return (vm.enableReturnInvoiceInput && vm.returnInvoiceSearchText && vm.supplierID) || 
					(vm.enablePurchaseInvoiceInput && vm.purchaseInvoiceSearchText && vm.supplierID) || 
					(vm.enableOrderedCheckBox && vm.ordered !== checkSelectedPartStatus(isOrderedKeyName)) || 
					(vm.enableReturnedCheckBox && vm.returned !== checkSelectedPartStatus(isReturnedKeyName));
			}

			function applyGroupEdit(){
				const purchaseInvoiceNumber = vm.enablePurchaseInvoiceInput ? vm.purchaseInvoiceSearchText : undefined;
				const returnInvoiceNumber = vm.enableReturnInvoiceInput ? vm.returnInvoiceSearchText : undefined;
				const queue = [];
				const indexList = getSelectedItemIndexs();

				if(!Array.isArray(indexList) || indexList.length <= 0){
					return;
				}

				if(vm.supplierID && purchaseInvoiceNumber){
					queue.push(applyPurchaseInvoice(vm.supplierID, purchaseInvoiceNumber, indexList));
				}

				if(vm.supplierID && returnInvoiceNumber){
					queue.push(applyReturnInvoice(vm.supplierID, returnInvoiceNumber, indexList));
				}

				if(vm.ordered !== undefined){
					applyChangeToSelectedParts(isOrderedKeyName, vm.ordered, indexList);
				}

				if(vm.returned !== undefined){
					applyChangeToSelectedParts(isReturnedKeyName, vm.returned, indexList);
				}

				vm.isApplyingChanges = true;

				$q.all(queue)
					.then(function(){
						unselectAll();
						cleanGroupEditorUI();
					})
					.catch(MessageService.showToast)
					.finally(function() {
						vm.isApplyingChanges = false;
					})
			}

			function unselectAll() {
				if(!Array.isArray(vm.partList)){
					return;
				}

				vm.partList.forEach(function(item){
					if(item && item.isSelected){
						item.isSelected = false;
					}
				});
			}

			function applyPurchaseInvoice(supplierID, invoiceNumber, indexList) {
				if(!invoiceNumber){
					return;
				}

				var filterString = '';
				var invoice;
				const resourcePath = {
					companyID: companyID
				}	

				if(supplierID){
					filterString = GeneralTools.equalFilterBuilder(PurchaseInvoiceConstants.keyNames.supplier, supplierID)
				}

				const invoiceFilter = GeneralTools.equalFilterBuilder(PurchaseInvoiceConstants.keyNames.invoiceNumber, invoiceNumber);
				filterString = GeneralTools.stringConnector(filterString, invoiceFilter, ToolsConstants.apiFilters.andConnector);

				return PurchaseInvoiceService.getPurchaseInvoices(resourcePath, {filters: filterString})
					.then(function(result) {
						if(result && Array.isArray(result.data) && result.data.length == 1 && result.data[0]){
							invoice = result.data[0];
							return $q.resolve(result.data[0].id_purchase_invoice);
						}

						invoice = {
							fk_id_supplier: supplierID,
							invoice_number: invoiceNumber
						};

						return PurchaseInvoiceService.createPurchaseInvoice(resourcePath, invoice);
					})
					.then(function(invoiceID){
						vm.invoiceMap[invoiceID] = invoice;
						applyChangeToSelectedParts("purchaseInvoiceID", invoiceID, indexList);
						return $q.resolve();
					});
			}

			function getSelectedItemIndexs() {
				if(!Array.isArray(vm.partList)){
					return;
				}

				const hasFilter = Array.isArray(vm.tabs) && !!vm.tabs[vm.currentTabIndex] && typeof(vm.tabs[vm.currentTabIndex].filter) == "function";
				const indexList = [];

				vm.partList.find(function(item, index){
					if((hasFilter && !vm.tabs[vm.currentTabIndex].filter(item)) || !item || !item.isSelected){
						return;
					}

					indexList.push(index)
				});

				return indexList
			}

			function applyChangeToSelectedParts(key, value, indexList) {
				if(!Array.isArray(indexList)){
					return;
				}

				

				indexList.forEach(function(index) {
					if(vm.partList[index] && vm.partList[index].partData){
						vm.partList[index][key] = value;
						vm.partList[index].updateProperty(key);
					}
				});
			}

			function applyReturnInvoice(supplierID, invoiceNumber, indexList) {
				if(!invoiceNumber){
					return;
				}

				var filterString = '';
				var invoice;
				const resourcePath = {
					companyID: companyID
				}	

				if(supplierID){
					filterString = GeneralTools.equalFilterBuilder(ReturnInvoiceConstants.keyNames.supplier, supplierID)
				}

				const invoiceFilter = GeneralTools.equalFilterBuilder(ReturnInvoiceConstants.keyNames.invoiceNumber, invoiceNumber);
				filterString = GeneralTools.stringConnector(filterString, invoiceFilter, ToolsConstants.apiFilters.andConnector);

				return ReturnInvoiceService.getReturnInvoices(resourcePath, {filters: filterString})
					.then(function(result) {
						if(result && Array.isArray(result.data) && result.data.length == 1 && result.data[0]){
							invoice = result.data[0];
							return $q.resolve(result.data[0].id_return_invoice);
						}

						invoice = {
							fk_id_supplier: supplierID,
							invoice_number: invoiceNumber
						};

						return ReturnInvoiceService.createReturnInvoice(resourcePath, invoice);
					})
					.then(function(invoiceID){
						vm.returnInvoiceMap[invoiceID] = invoice;
						applyChangeToSelectedParts("returnInvoiceID", invoiceID, indexList);
						return $q.resolve();
					});
			}

			function onPurchaseInvoiceSearchTextChange(){
				if(!!vm.purchaseInvoiceSearchText){
					vm.ordered = true;
					vm.enableOrderedCheckBox = false;
				} else {
					refreshGroupEditorUI();
				}
			}

			function onReturnInvoiceSearchTextChange(){
				if(!!vm.returnInvoiceSearchText){
					vm.returned = true;
					vm.enableReturnedCheckBox = false;
				} else {
					refreshGroupEditorUI();
				}				
			}

			function checkSelectedPartStatus(key){
				if(!Array.isArray(vm.partList)){
					return;
				}

				const hasFilter = Array.isArray(vm.tabs) && !!vm.tabs[vm.currentTabIndex] && typeof(vm.tabs[vm.currentTabIndex].filter) == "function";
				var all = true;
				var allNot = true;

				vm.partList.find(function(item){
					if((hasFilter && !vm.tabs[vm.currentTabIndex].filter(item)) || !item || !item.isSelected || !item.partData){
						return;
					} 

					if(!!item[key]){
						allNot = false;
					} else {
						all = false;
					}

					return !all && !allNot;
				});

				if(!all && !allNot){
					return undefined;
				}

				if(all){
					return true;
				}

				if(allNot){
					return false;
				}
			}

			function addNewRow(){
				if(vm.disableAdding){
					return;
				}

				vm.focusIndex = null;

				if(typeof(vm.onAddNewPart) != "function"){
					return;
				}

				vm.onAddNewPart();

				if(!Array.isArray(vm.partList)){
					return;
				}

				$timeout(function(){
					const lastRow = angular.element(document.querySelector('#partRow' + (vm.partList.length - 1)));
					if(lastRow){
						lastRow.focus();
					}
				});
			}

			function onRowFocus(index){
				vm.focusIndex = index
				vm.isFocusOnRow = true;	
				vm.editingIndex = null;

				$timeout(function(){
					const qtyInput = angular.element(document.querySelector('#partRowQty' + index));
					if(qtyInput){
						qtyInput.focus();
					}			
				});
			}

			function onRowBlur() {
				vm.isFocusOnRow = false;	
				waitAndCheckIsEditing();			
			}

			function onInputFocus(index, isFirstCheckBox) {
				vm.isFocusOnRow = false;
				vm.editingIndex = index;
			}

			function onInputBlur(){
				vm.editingIndex = null;
				waitAndCheckIsEditing();			
			}

			function waitAndCheckIsEditing() {
				$timeout(function() {
					if((!vm.isFocusOnRow && vm.editingIndex == null)){
						vm.focusIndex = null
					}

				}, 100);
			}

			function removeEmptyRow(index){
				isloading = false
				if(!Array.isArray(vm.partList) || !vm.partList[index]){
					return;
				}

				const item = vm.partList[index]

				if(!item){
					return;
				}		

				if(!!item.id){
					return;
				}	

				if(!!item.name){
					return;
				}

				if(!!item.code){
					return;
				}

				if(item.purchaseInvoiceID != null && !vm.hiddenColumns.invoice){
					return;
				}

				if(item.returnInvoiceID != null && !vm.hiddenColumns.returnInvoice){
					return;
				}

				if(item.cost != null){
					return;
				}

				if(item.suggestedRetailPrice != null){
					return;
				}

				if(item.retailPrice != null){
					return;
				}

				if(item.quantity != null){
					return;
				}

				vm.partList.splice(index, 1);
			}

			function initOutPutCallbacks(){
				vm.isFormValid = isFormValid;
			}

			function isFormValid(){
				if(!Array.isArray(vm.partList)){
					return false;
				}

				const isValid = vm.partList.every(function(item){
					if(!item){
						return false;
					}

					if(!!item.inventoryData){
						return true;
					}

					if(!item.partData || !item.partData.name){
						return false
					}

					if(item.partData.name.length > vm.maxNameLength){
						return false
					}

					if(!!item.partData.code && item.partData.code.length > vm.maxCodeLength){
						return false
					}

					return true
				});

				return isValid;
			};

			function selectAll(){
				if(!Array.isArray(vm.partList)){
					return;
				}

				const hasFilter = Array.isArray(vm.tabs) && !!vm.tabs[vm.currentTabIndex] && typeof(vm.tabs[vm.currentTabIndex].filter) == "function";
				const allSelected = isAllSelected();

				vm.partList.forEach(function(item, index){
					if(!hasFilter || vm.tabs[vm.currentTabIndex].filter(item)){
						item.isSelected = !allSelected;
					} 
				});
			}

			function isAllSelected(){
				if(!Array.isArray(vm.partList)){
					return;
				}

				const hasFilter = Array.isArray(vm.tabs) && !!vm.tabs[vm.currentTabIndex] && typeof(vm.tabs[vm.currentTabIndex].filter) == "function";
				var hasItemInCurrentTab = false;

				const allSelected = vm.partList.every(function(item, index){
					if(hasFilter && !vm.tabs[vm.currentTabIndex].filter(item)){
						return true	
					}
					hasItemInCurrentTab = true;
					return item.isSelected;
				});

				return allSelected && hasItemInCurrentTab;
			}

			function isAnySelected(){
				const indexList = getSelectedItemIndexs();
				return Array.isArray(indexList) && indexList.length > 0;
			}

			function getTypeName(typeID) {

				if(!Array.isArray(vm.types)){
					return;
				}

				const matchedType = vm.types.find(function(type){
					return !!type && type.id_part_type == typeID && type.Deleted == 0;
				});
				
				if(!!matchedType){
					return matchedType.name;
				}

				return "Type";
			}

			function queryInventoryByName(searchText) {
				const filters = {
					filters:  GeneralTools.containFilterBuilder(InventoryConstants.keyNames.name, searchText)
				}

				return queryInventory(filters);
			}

			function queryInventoryByCode(searchText) {
				const filters = {
					filters:  GeneralTools.containFilterBuilder(InventoryConstants.keyNames.code, searchText)
				}
				
				return queryInventory(filters);
			}

			function queryInventory(filters) {
				const defer = $q.defer();
				const resourcePath = {
					companyID: companyID
				}

				InventoryService.getInventories(resourcePath, filters)
					.then(function(result) {
						if(!result || !Array.isArray(result.data)){
							defer.reject("Inventory data invaild.");
							return;
						}

						result.data.forEach(function(inventory){
							if(!inventory){
								return;
								
							}

							if(!vm.matchedInventories){
								vm.matchedInventories = {};
							}

							vm.matchedInventories[inventory.code] = inventory;
						});

						defer.resolve(result.data);
					})
					.catch(defer.reject);

				return defer.promise;
			}

			function getInvoiceSupplier(invoiceID){
				var supplierID;

				if(vm.invoiceMap && vm.invoiceMap[invoiceID]){
					supplierID = vm.invoiceMap[invoiceID].fk_id_supplier;
				}

				return getSupplierName(supplierID);	 
			}

			function getReturnInvoiceSupplier(invoiceID){
				var supplierID;
				var supplier;

				if(vm.returnInvoiceMap && vm.returnInvoiceMap[invoiceID]){
					supplierID = vm.returnInvoiceMap[invoiceID].fk_id_supplier;
				}

				return getSupplierName(supplierID);
			}

			function getSupplierName(supplierID){
				var supplier;

				if(Array.isArray(vm.suppliers) && !!supplierID){
					supplier = vm.suppliers.find(function(supplier){
						return !!supplier && supplier.id_supplier == supplierID;
					})
				}

				if(!!supplier){
					return supplier.name;
				}
			}

			function getInvoiceNumber(invoiceID){
				if(!invoiceID){
					return "Inv.";
				}
				
				if(vm.invoiceMap && vm.invoiceMap[invoiceID]){
					return vm.invoiceMap[invoiceID].invoice_number;
				}
			}

			function getReturnInvoiceNumber(invoiceID){
				if(!invoiceID){
					return "Re. Inv.";
				}
				
				if(vm.returnInvoiceMap && vm.returnInvoiceMap[invoiceID]){
					return vm.returnInvoiceMap[invoiceID].invoice_number;
				}
			}

			function getInvoiceLink(invoiceID){
				if(!!invoiceID){
					return $state.href("app.edit-purchase-invoice", {purchaseInvoiceID: invoiceID});
				}	
			}

			function getReturnInvoiceLink(invoiceID){
				if(!!invoiceID){
					return $state.href("app.edit-return-invoice", {returnInvoiceID: invoiceID});
				}
			}

			function getWorkOrderLink(fk_id_vehicle, workorderID){
				if(!!fk_id_vehicle && !!workorderID){
					return $state.href('app.edit-workorder.general', {vehicleID:fk_id_vehicle, workOrderID: workorderID});
				}
			}



			function getPartNumber(tab){
				if(!Array.isArray(vm.partList)){
					return;
				}

				if(typeof(tab.filter) != "function"){
					return vm.partList.length; 
				}

				var number = 0;

				vm.partList.forEach(function(item){
					if(tab.filter(item)){
						number++;
					}
				});

				return number + '/' + vm.partList.length;
			}

			function getDropDownButtonClass(){
				const classList = [];

				if(vm.enableDropDownButton){
					classList.push('text-secondary');
				} else {				
					classList.push('text-grey');
				}

				if(vm.showGroupEdit){
					classList.push('icon-menu-up');
				} else {
					classList.push('icon-arrow-down-drop');
				}

				return classList;
			}

			function addSupplierIdToList(list, supplierID){
				if(Array.isArray(list) && supplierID != null && list.indexOf(supplierID) == -1){
					list.push(supplierID);
				}

				return list;
			}

			function getPurchaseInvoiceSupplierID(item){
				if(!item || !item.partData || !item.partData.fk_id_purchase_invoice || !vm.invoiceMap){
					return;
				}

				const invoice = vm.invoiceMap[item.partData.fk_id_purchase_invoice];

				if(!!invoice){
					return invoice.fk_id_supplier;
				}
			}

			function getReturnInvoiceSupplierID(item){
				if(!item || !item.partData || !item.partData.fk_id_return_invoice || !vm.returnInvoiceMap){
					return;
				}

				const invoice = vm.returnInvoiceMap[item.partData.fk_id_return_invoice];

				if(!!invoice){
					return invoice.fk_id_supplier;
				}
			}

			function queryPurchaseInvoice(supplierID, purchaseInvoiceSearchText){
				if(!purchaseInvoiceSearchText){
					return;
				}

				const resourcePath = {
					companyID: companyID
				}

				var filterString = '';

				if(supplierID){
					filterString = GeneralTools.equalFilterBuilder(PurchaseInvoiceConstants.keyNames.supplier, supplierID)
				}

				const invoiceFilter = GeneralTools.containFilterBuilder(PurchaseInvoiceConstants.keyNames.invoiceNumber, purchaseInvoiceSearchText);
				filterString = GeneralTools.stringConnector(filterString, invoiceFilter, ToolsConstants.apiFilters.andConnector);

				return PurchaseInvoiceService.getPurchaseInvoices(resourcePath, {filters: filterString})
					.then(function(result) {
						if(!result || !Array.isArray(result.data)){
							defer.reject("Purchase Invoice data invaild.");
							return;
						}

						return $q.resolve(result.data);
					})
					.catch(MessageService.showToast);
			}

			function queryReturnInvoice(supplierID, returnInvoiceSearchText){
				if(!returnInvoiceSearchText){
					return;
				}

				const resourcePath = {
					companyID: companyID
				}

				var filterString = '';

				if(supplierID){
					filterString = GeneralTools.equalFilterBuilder(ReturnInvoiceConstants.keyNames.supplier, supplierID)
				}

				const invoiceFilter = GeneralTools.containFilterBuilder(ReturnInvoiceConstants.keyNames.invoiceNumber, returnInvoiceSearchText);
				filterString = GeneralTools.stringConnector(filterString, invoiceFilter, ToolsConstants.apiFilters.andConnector);

				return ReturnInvoiceService.getReturnInvoices(resourcePath, {filters: filterString})
					.then(function(result) {
						if(!result || !Array.isArray(result.data)){
							defer.reject("Return Invoice data invaild.");
							return;
						}

						return $q.resolve(result.data);
					})
					.catch(MessageService.showToast);
			}

			function selectPurchaseInvoice(){
				if(!vm.supplierID && vm.selectedPurchaseInvoice){
					vm.supplierID = vm.selectedPurchaseInvoice.fk_id_supplier
				}
			}

			function selectReturnInvoice(){
				if(!vm.supplierID && vm.selectedReturnInvoice){
					vm.supplierID = vm.selectedReturnInvoice.fk_id_supplier
				}
			}

			function pullDataFromMatchedInventory(item){
				if(!item || !vm.matchedInventories){
					return;
				}

				const inventory = vm.matchedInventories[item.code];

				if(inventory && typeof(vm.onPartMatchInventory) == "function"){
					vm.onPartMatchInventory(item, inventory);
				}
			}

			function onQuantityChange(item){
				if(!!item && !!item.inventoryData && typeof(vm.onInventoryQuantityChange) == "function"){
					vm.onInventoryQuantityChange(item);
				}
			}
			function getGivenItemIdAssociatedWorkOrderJobID(workOrderJob, Id, itemTypeId){
				if(workOrderJob.length <= 0){
					return undefined
				}
				var workOrderId = undefined;
				workOrderJob.forEach(function(workOrderJobItem){
					if(workOrderJobItem.work_order_job_json.length > 0){
						workOrderJobItem.work_order_job_json.forEach(function(work_order_job_json_item){
							if(parseInt(work_order_job_json_item.fk_id_item) == parseInt(Id) && parseInt(work_order_job_json_item.fk_id_work_order_job_item_type) == parseInt(itemTypeId)){
								workOrderId = workOrderJobItem.id_work_order_job
							}
						})
					}
				})
	
				return workOrderId
			};
	
			function getRGBAStyle(number, index, colorCache) {
				if (colorCache[number]) {
				  setTableRowBackgroundColor(colorCache[number], index);
				  return;
				}
				return
			  }
	
			function getWorkOrderJobIdFromItemId(item, workOrderJobList, index, colorCache){
				if(!workOrderJobList || workOrderJobList.length <= 0){
					return 
				}
				var id = undefined;
				var colorString = ""
				var workOrderJobId
				if(item && item.inventoryData){
					id = item.inventoryData.id_work_order_inventory
					if(workOrderJobList && workOrderJobList.length > 0){
						workOrderJobId = getGivenItemIdAssociatedWorkOrderJobID(workOrderJobList, id, 2)
						colorString = getRGBAStyle(workOrderJobId, index, colorCache)
					}
	
				}
				if(item && item.partData){
					id = item.partData.id_work_order_part
					if(workOrderJobList && workOrderJobList.length > 0){
						workOrderJobId = getGivenItemIdAssociatedWorkOrderJobID(workOrderJobList, id, 1)
						colorString = getRGBAStyle(workOrderJobId, index, colorCache)
					}
				}
				return colorString
			}
	
			function setTableRowBackgroundColor(colorString, index) {
				var trElement = document.querySelector('tr[name="partTableRow' + index + '"]');
				if (trElement) {
				  trElement.style.backgroundColor = colorString;
				}
			}

			function onCostChange(item) {
				if (item && item.cost && item.cost > 0) {
					let calculatedPrice = Number((item.cost * vm.defaultRetailPercentadge + item.cost).toFixed(2));
			
					if ((!item.retailPrice || calculatedPrice > item.retailPrice) && !item.edited) {
						item.retailPrice = calculatedPrice;
					}
			
					if ((!item.suggestedRetailPrice || calculatedPrice > item.suggestedRetailPrice) && !item.edited) {
						item.suggestedRetailPrice = calculatedPrice;
					}
			
					if (item.partData) {
						if ((!item.partData.retail_price || calculatedPrice > item.partData.retail_price) && !item.edited) {
							item.partData.retail_price = calculatedPrice;
						}
					}
				}
			}

			function onRetailChange(item) {
				if(item && item.partData){
					if((item.retailPrice == null && item.partData.retail_price == null) || (item.retailPrice == 0 && item.partData.retail_price == 0) ){
						item.edited = false
					}else{
						item.edited = true
					}
				}
			}
		
		}
})();
(function ()
{
	"use strict";

	angular
		.module("app.parts")
		.component("partsList", {
				bindings:{
					parts: '=',
					partTypes: '<',
					sortBy:'<',
					sortDirection:'<',
					onSortingChanged: '<',
					getSelectedParts:'=',
					cleanSelectedParts:'='
				},
				templateUrl: "app/main/parts/components/parts-list.html",
				controller: componentController,
		  		controllerAs: 'vm'
			});

		function componentController(ToolsConstants, PartConstants){
			const vm = this;

			vm.directionDesc = ToolsConstants.apiSortingDirections.DESC;
			vm.directionAsc = ToolsConstants.apiSortingDirections.ASC;

			vm.sortTagQuantity = PartConstants.keyNames.quantity;
			vm.sortTagCode = PartConstants.keyNames.code;
			vm.sortTagName = PartConstants.keyNames.name;
			vm.sortTagType = PartConstants.keyNames.type;

			vm.selectedMap = {};
			vm.getPartType = getPartType;
			vm.isAllSelected = isAllSelected;
			vm.selectAll = selectAll;
			vm.changeSorting = changeSorting;

			vm.$postLink = postLink;

			function isAllSelected(){
				if(!Array.isArray(vm.parts) || vm.parts.length <= 0 || !vm.selectedMap){
					return;
				}

				return vm.parts.every(function(part){
					return !!part && vm.selectedMap[part.id_part];
				});
			}

			function selectAll(){
				if(!Array.isArray(vm.parts) || !vm.selectedMap){
					return;
				}

				const allSelected = isAllSelected();

				vm.parts.forEach(function(part){
					if(!part){
						return;
					}

					vm.selectedMap[part.id_part] = !allSelected;
				});
			}

			function getPartType(typeID){
				if(!Array.isArray(vm.partTypes)){
					return;
				}

				const matchedType = vm.partTypes.find(function(partType){
					return !!partType && partType.id_part_type == typeID;
				});

				if(!!matchedType){
					return matchedType.name;
				}
			}

			function changeSorting(sortTag) {
				if(vm.sortBy == sortTag){
					vm.sortDirection = vm.sortDirection == vm.directionAsc ? vm.directionDesc : vm.directionAsc;
				} else {
					vm.sortDirection = vm.directionAsc;
				}

				vm.sortBy = sortTag;

				if(typeof(vm.onSortingChanged) == "function"){
					vm.onSortingChanged(vm.sortBy, vm.sortDirection);
				}
			}

			function postLink() {
				vm.getSelectedParts = getSelectedParts;
				vm.cleanSelectedParts = cleanSelectedParts;
			}

			function getSelectedParts(){
				if(!Array.isArray(vm.pars)){
					return;
				}

				return vm.parts.filter(function(part){
					return !!part && vm.selectedMap[part.id_part];
				});
			}

			function cleanSelectedParts(){
				vm.selectedMap = {};
			}
		}
})();
(function ()
{
	'use strict';

	angular
		.module("app.parts")
		.factory("PartTableItem", PartTableItemClass)

	/** @ngInject */
	function PartTableItemClass($filter)
	{	 
		function PartTableItem(){}

		PartTableItem.prototype.setPartData = function (part) {
			if(!part){
				return;
			}

			delete this.inventoryData;

			this.partData = part;
			this.id = part.getResourceId();
			this.quantity = part.quantity;
			this.code = part.code;
			this.name = part.name;
			this.type = part.fk_id_part_type;
			this.purchaseInvoiceID = part.fk_id_purchase_invoice;
			this.returnInvoiceID = part.fk_id_return_invoice;
			this.cost = part.purchase_price;
			this.suggestedRetailPrice = part.suggested_retail_price;
			this.retailPrice = part.retail_price;
			this.isReturned = part.is_returned;
			this.isOrdered = part.is_ordered;
		}

		PartTableItem.prototype.setInventoryData = function (inventory) {
			if(!inventory){
				return;
			}

			delete this.partData;

			this.inventoryData = inventory;
			this.id = inventory.id_work_order_inventory;
			this.quantity = inventory.quantity;
			this.code = inventory.code;
			this.name = inventory.name;
			this.type = inventory.fk_id_part_type;
			this.cost = inventory.purchase_price;
			this.suggestedRetailPrice = inventory.retail_price;
			this.retailPrice = inventory.retail_price;
			this.quantityInStock = inventory.quantity_in_stock;
		}

		PartTableItem.prototype.isNew = function(){
			return !this.id;
		}

		PartTableItem.prototype.updateProperties = function(){
			const _this = this;
			Object.keys(this).forEach(function(key){
				_this.updateProperty(key);
			});
		}

		PartTableItem.prototype.updateProperty = function(key) {
			switch(key){
				case "id":
					if(this.partData){
						this.partData.setResourceId(this.id);
					} else if(this.inventoryData){
						this.inventoryData.id_work_order_inventory = this.id;
					}
					break;
				case "quantity":
					if(this.partData){
						this.partData.quantity = this.quantity;
					} else if(this.inventoryData){
						this.inventoryData.quantity = this.quantity;
					}
					break;
				case "code":
					if(this.partData){
						this.partData.code = this.code;
					} else if(this.inventoryData){
						this.inventoryData.code = this.code;
					}
					break;
				case "name":
					if(this.partData){
						this.partData.name = this.name;
					} else if(this.inventoryData){
						this.inventoryData.name = this.name;
					}
					break;
				case "type":
					if(this.partData){
						this.partData.fk_id_part_type = this.type;
					} else if(this.inventoryData){
						this.inventoryData.fk_id_part_type = this.type;
					}
					break;
				case "purchaseInvoiceID":
					if(this.partData){
						this.partData.fk_id_purchase_invoice = this.purchaseInvoiceID;
					}
					break;
				case "returnInvoiceID":
					if(this.partData){
						this.partData.fk_id_return_invoice = this.returnInvoiceID;
					}
					break;
				case "cost":
					if(this.partData){
						this.partData.purchase_price = this.cost;
					} else if(this.inventoryData){
						this.inventoryData.purchase_price = this.cost;
					}
					break;
				case "suggestedRetailPrice":
					if(this.partData){
						this.partData.suggested_retail_price = this.suggestedRetailPrice;
					} else if(this.inventoryData){
						this.inventoryData.suggested_retail_price = this.suggestedRetailPrice;
					}
					break;
				case "retailPrice":
					if(this.partData){
						this.partData.retail_price = this.retailPrice;
					} else if(this.inventoryData){
						this.inventoryData.retail_price = this.retailPrice;
					}
					break;
				case "isReturned":
					if(this.partData){
						this.partData.is_returned = this.isReturned;
					}
					break;
				case "isOrdered":
					if(this.partData){
						this.partData.is_ordered = this.isOrdered;
					}
					break;
				case "quantityInStock":
					if(this.inventoryData){
						this.inventoryData.quantity_in_stock = this.quantityInStock;
					}
					break;
			}
		}

		return PartTableItem;
	}


})();
(function ()
{
	'use strict';

	angular
		.module('app.parts')
		.controller('BrowsePartsController', BrowsePartsController);

	function BrowsePartsController(PurchaseInvoiceConstants, PurchaseInvoiceService, $location, HeaderHelper, $stateParams, constants, PartService, LoginService, MessageService, $q, GeneralTools, ToolsConstants, PartConstants){   
		const vm = this;
		const companyID = LoginService.getCompanyID();

		vm.displayOptions = [10, 25, 50, 100];
		vm.refreshPartList = refreshPartList;
		vm.onSortingChanged = onSortingChanged;
		vm.queryPurchaseInvoice = queryPurchaseInvoice;
		vm.getSupplierName = getSupplierName;
		vm.isApplyButtonDisabled = isApplyButtonDisabled;
		vm.isAnyPartSelected = isAnyPartSelected;

		init();

		function init(){
			initConstants();
			initStateParams();
			refreshPartList(vm.currentPage);
		}

		function initStateParams(){	
			vm.uninvoicedFilter = GeneralTools.urlBooleanParamTranslator($stateParams.uninvoiced);
			vm.partTypeFilter = GeneralTools.urlNumberParamTranslator($stateParams.type);
			vm.nameFilter = GeneralTools.urlStringParamTranslator($stateParams.name);
			vm.codeFilter = GeneralTools.urlStringParamTranslator($stateParams.code);

			vm.itemsPerPage = getDisplayOption(GeneralTools.urlNumberParamTranslator($stateParams.limit));
			vm.currentPage = GeneralTools.urlNumberParamTranslator($stateParams.page);

			vm.sortBy = GeneralTools.urlStringParamTranslator($stateParams.sortBy);
			vm.sortDirection = GeneralTools.urlStringParamTranslator($stateParams.sortDirection);
		}

		function getDisplayOption(itemPerPage){
			if(vm.displayOptions.indexOf(itemPerPage) == -1){
				return vm.displayOptions[0];
			}

			return itemPerPage;
		}

		function initConstants(){
			if(!constants){
				return;
			}

			vm.partTypes = constants.partTypes;
			vm.suppliers = constants.suppliers
		}

		function refreshPartList(pageToGo){
			const resourcePath = {
				companyID: companyID
			};

			vm.isFetchingParts = true;

			PartService.getParts(resourcePath, getFilter(), getPagination(pageToGo), getSorting())
				.then(function(result){

					if(!result){
						return $q.reject("Parts data invalid");
					}

					vm.parts = result.data;

					resetPagination(result.headerGetter);
					refreshUrl();
				})
				.catch(MessageService.showToast)
				.finally(function(){
					vm.isFetchingParts = false;
				});
		}

		function resetPagination(headerGetter){
			vm.totalCount = HeaderHelper.getPaginationTotalItem(headerGetter);
			vm.currentPage = HeaderHelper.getPaginationCurrentPage(headerGetter);
		}

		function refreshUrl(){
			const urlParams = {};

			if(vm.itemsPerPage){
				urlParams.limit = vm.itemsPerPage;
			}

			if(vm.currentPage){
				urlParams.page = vm.currentPage;
			}

			if(vm.sortBy){
				urlParams.sortBy = vm.sortBy;
			}

			if(vm.sortDirection){
				urlParams.sortDirection = vm.sortDirection;
			}

			if(vm.uninvoicedFilter){
				urlParams.uninvoiced = vm.uninvoicedFilter;
			}

			if(vm.partTypeFilter){
				urlParams.type = vm.partTypeFilter;
			}

			if(vm.nameFilter){
				urlParams.name = vm.nameFilter;
			}

			if(vm.codeFilter){
				urlParams.code = vm.codeFilter;
			}

			$location.search(urlParams).replace();
		}

		function getFilter(){
			var filterString = '';

			if(vm.uninvoicedFilter){
				const uninvoicedFilter = GeneralTools.equalFilterBuilder(PartConstants.keyNames.purchaseInvoiceID, null);
				filterString = GeneralTools.stringConnector(filterString, uninvoicedFilter, ToolsConstants.apiFilters.andConnector);
			}

			if(vm.partTypeFilter){
				const partTypeFilter = GeneralTools.equalFilterBuilder(PartConstants.keyNames.type, vm.partTypeFilter);
				filterString = GeneralTools.stringConnector(filterString, partTypeFilter, ToolsConstants.apiFilters.andConnector);
			}

			if(vm.nameFilter){
				const nameFilter = GeneralTools.containFilterBuilder(PartConstants.keyNames.name, vm.nameFilter);
				filterString = GeneralTools.stringConnector(filterString, nameFilter, ToolsConstants.apiFilters.andConnector);
			}

			if(vm.codeFilter){
				const codeFilter = GeneralTools.containFilterBuilder(PartConstants.keyNames.code, vm.codeFilter);
				filterString = GeneralTools.stringConnector(filterString, codeFilter, ToolsConstants.apiFilters.andConnector);
			}

			if(filterString){
				return { filters: filterString };
			}
		}

		function getPagination(page){
			return {
				page: page,
				limit: vm.itemsPerPage
			}
		}

		function getSorting(){
			return {
				sortBy: vm.sortBy,
				sortDirection: vm.sortDirection
			};
		}

		function onSortingChanged(sortBy, sortDirection){
			vm.sortBy = sortBy;
			vm.sortDirection = sortDirection;

			refreshPartList(1);
		}

		function queryPurchaseInvoice(supplierID, purchaseInvoiceSearchText){
			if(!purchaseInvoiceSearchText){
				return;
			}

			const resourcePath = {
				companyID: companyID
			}

			var filterString = '';

			if(supplierID){
				filterString = GeneralTools.equalFilterBuilder(PurchaseInvoiceConstants.keyNames.supplier, supplierID)
			}

			const invoiceFilter = GeneralTools.containFilterBuilder(PurchaseInvoiceConstants.keyNames.invoiceNumber, purchaseInvoiceSearchText);
			filterString = GeneralTools.stringConnector(filterString, invoiceFilter, ToolsConstants.apiFilters.andConnector);

			return PurchaseInvoiceService.getPurchaseInvoices(resourcePath, {filters: filterString})
				.then(function(result) {
					if(!result || !Array.isArray(result.data)){
						defer.reject("Purchase Invoice data invaild.");
						return;
					}
					vm.cleanSelectedParts();
					return $q.resolve(result.data);
				})
				.catch(MessageService.showToast);
		}

		function getSupplierName(supplierID){
			var supplier;

			if(Array.isArray(vm.suppliers) && !!supplierID){
				supplier = vm.suppliers.find(function(supplier){
					return !!supplier && supplier.id_supplier == supplierID;
				})
			}

			if(!!supplier){
				return supplier.name;
			}
		}

		function  isApplyButtonDisabled() {
			//return isAnyPartSelected() && vm.supplierID && vm.
		}

		function isAnyPartSelected() {
			if(typeof(vm.getSelectedParts) == "function"){
				const selectedParts = vm.getSelectedParts();
				return Array.isArray(selectedParts) && selectedParts.length > 0;
			}
		}

	}
})();
(function () {
	'use strict';

	angular
		.module('app.customers')
		.controller('ViewCustomerController', ViewCustomerController);

	function ViewCustomerController($scope, TestDrive, serviceMap, WorkOrderSummaryCalculator, SaleInfoService, ToolsConstants, RoleCheckService, WorkOrderService, VehicleService, $q, testDrives, creditCard, GeneralTools, constants, FileViewService, $sce, LoginService, CustomersService, CustomerConstants, $state, MessageService, $stateParams, customers, customAppointment, DialogService, $location, apiResolver) {
		const vm = this;
		const companyID = LoginService.getCompanyID();
		const customerID = $stateParams.customerID;
		const otherCategory = "Other";
		const vehicleMap = {};
		const workOrderMap = {};
		vm.vehicleOutstandingMap = {};
		vm.vehicleImgPlaceholder = CustomerConstants.profileImagePlaceHolder;
		vm.totalOutstanding;
		vm.workOrderList = {};
		const addVehicleUrlParams = {
			redirectState: "app.vehicle.customer",
			redirectParams: JSON.stringify({ newCustomerID: customerID }),
			newVehicleIdParamName: "vehicleID"
		}

		const isMechanic = RoleCheckService.checkRole(["mechanic"]);
		const isServiceAdvisor = RoleCheckService.checkRole(["service_advisor"]);
		vm.canRemoveTestDrive = RoleCheckService.checkRole(["sales_manager"]) || RoleCheckService.checkRole(["developer"]) || RoleCheckService.checkRole(["company_manager"]);
		vm.hiddenColumns = {
			labors: !(isMechanic && isServiceAdvisor) && isMechanic,
			parts: !(isMechanic && isServiceAdvisor) && isMechanic,
			outstanding: !(isMechanic && isServiceAdvisor) && isMechanic,
			quoted: !(isMechanic && isServiceAdvisor) && isMechanic,
			vehicle: true
		}

		let calendarFilters = [10];  // custom calendar filter
		let calendarFiltersString = JSON.stringify(calendarFilters);
		vm.addAppointmentUrl = $state.href("app.workorder-schedule", { calendarFilters: calendarFiltersString, customerID: customerID });
		vm.constants = {
			workOrderPriorities: [],
			workOrderStatus: []
		}
		vm.selectedMap = {};

		vm.customAppointmentHolder = {
			title: null,
			length: 30,
			category: 'Other'
		}

		$scope.lengthOptions = [];
		for (var i = 15; i <= 120; i += 15) {
			$scope.lengthOptions.push(i);
		}

		$scope.categoryOptions = [];
		$scope.categoryOptions.push('TestDrive');
		$scope.categoryOptions.push('PickUp');
		$scope.categoryOptions.push('Other');


		vm.constants.workOrderPriorities = [
			{
				id_work_order_priority: 1,
				name: "0-HIGH",
				value: 0
			},
			{
				id_work_order_priority: 2,
				name: "1-MEDIUM",
				value: 1
			},
			{
				id_work_order_priority: 3,
				name: "2-LOW",
				value: 2
			},
		]

		vm.constants.workOrderStatus = [
			{
				id_work_order_status: 1,
				status: "Quoted"
			},
			{
				id_work_order_status: 2,
				status: "Declined"
			},
			{
				id_work_order_status: 3,
				status: "Completed Eleswhere"
			},
			{
				id_work_order_status: 4,
				status: "Completed"
			},
			{
				id_work_order_status: 5,
				status: "Booked"
			},
			{
				id_work_order_status: 6,
				status: "On Lot"
			},
			{
				id_work_order_status: 7,
				status: "Started"
			},
		]

		vm.filterVehicle = {
			1: {
				data: "B"
			},
			2: {
				data: "C"
			},
			2279: {
				data: "A"
			}
		}

		vm.addVehicleUrl = $state.href("app.add-vehicle", addVehicleUrlParams);
		vm.editCustomerUrl = $state.href("app.edit-customer", { customerID: customerID });
		vm.getPhoneNumberCategory = getPhoneNumberCategory;
		vm.getEmailCategory = getEmailCategory;
		vm.formatPhoneNumber = formatPhoneNumber;
		vm.getCustomerAddress = getCustomerAddress;
		vm.getVehiclePageUrl = getVehiclePageUrl;
		vm.queryVehicles = queryVehicles;
		vm.addTestDriveVehicle = addTestDriveVehicle;
		vm.gettotalvehicleoutstanding = gettotalvehicleoutstanding;
		vm.toggleItemvehicleList = toggleItemvehicleList;
		vm.toggleItemdriveList = toggleItemdriveList;
		vm.toggleItemoutstandingList = toggleItemoutstandingList;
		vm.showItems = {};
		vm.showPendingItems = {};
		vm.customerCreditCards = getCustomerCreditCard();
		vm.getCustomerCreditCard = getCustomerCreditCard;

		vm.removeSelectedAppointments = removeSelectedAppointments;
		vm.updateAppointmentStatus = updateAppointmentStatus;
		vm.isAnyItemSelected = isAnyItemSelected;
		vm.disableDeleteButton = disableDeleteButton;

		vm.disableAddAppointment = true;


		init();

		function init() {
			initConstants();
			initCustomer();
			initCustomerProfileImage();
			initCustomerLicenseImage();
			initTestDrives();
			initVehicles();
			initTabs();
			initCreditCards();
			initCustomAppointment();

			window.localStorage.removeItem("customAppointmentHolderLength");
			window.localStorage.removeItem("customAppointmentHolderTitle");
			window.localStorage.removeItem('customAppointmentHolderCategory');
			window.localStorage.removeItem('customAppointmentHolderCreateBy');
		}




		function initTabs() {
			vm.tabs = {
				Vehicles
					:
					"Vehicles",
				Outstanding
					:
					"Outstanding",
				Appointments
					:
					"Appointments",
				Quoted
					:
					"Quoted",
				TestDrives
					:
					"TestDrives",

			}
			if (vm.tabs[$stateParams.tab]) {
				vm.currentTab = vm.tabs[$stateParams.tab];
				$scope.tab = vm.tabs[$stateParams.tab]
				$location.search('tab', null);
			} else {
				vm.currentTab = vm.tabs.Vehicles;
				$scope.tab = vm.tabs.Vehicles;
			}
		}

		$scope.$watch('tab', function (newValue, oldValue) {
			if (newValue !== oldValue) {

			}
		});


		function initVehicles() {
			const queue = {
				purchasedVehiclesIdList: fetchPurchasedVehiclesIdList(),
				serviceVehiclesIdList: getServiceVehiclesIdList()
			};

			vm.vehicles = {};
			vm.workOder = {};

			$q.all(queue)
				.then(function (result) {
					if (!result || !Array.isArray(result.purchasedVehiclesIdList) || !Array.isArray(result.serviceVehiclesIdList)) {
						return $q.reject("Failed to init vehicles.");
					}

					result.purchasedVehiclesIdList.forEach(function (vehicleID) {
						vm.vehicles[vehicleID] = {
							isPurchased: true
						}
						vm.workOder[vehicleID] = []
						vm.vehicleOutstandingMap[vehicleID] = 0
					});

					result.serviceVehiclesIdList.forEach(function (vehicleID) {
						if (!vm.vehicles[vehicleID]) {
							vm.vehicles[vehicleID] = {};
						}

						if (!vm.workOder[vehicleID]) {
							vm.workOder[vehicleID] = [];
						}

						if (!vm.vehicleOutstandingMap[vehicleID]) {
							vm.vehicleOutstandingMap[vehicleID] = 0;
						}
					});

					const subQueue = [];
					Object.keys(vm.vehicles).forEach(function (vehicleID) {
						subQueue.push(fetchVehicle(vehicleID));
					});




					return $q.all(subQueue);
				})
				.then(function (vehiclesData) {
					if (!Array.isArray(vehiclesData)) {
						return $q.reject("vehiclesData invalid.");
					}

					var workOrderQueue = [];
					vehiclesData.forEach(function (vehicle) {
						if (!vehicle) {
							return;
						}

						const vehicleID = vehicle.getResourceID();;
						if (vm.vehicles[vehicleID]) {
							vm.vehicles[vehicleID].vehicleData = vehicle;
							if(vehicle && vehicle.workOrders && vehicle.workOrders.length > 0){
								vehicle.workOrders.forEach(function (workOrder) {
									workOrderQueue.push(workOrder);
								})

							}
							
						}

					});
					return $q.resolve(workOrderQueue)
				})
				.then(function (workorderData) {
					if (!Array.isArray(workorderData)[0] && !Array.isArray(workorderData)) {
						return;
					}

					for (var i = 0; i < workorderData.length; i++) {
						var workOrderVehicleID = workorderData[i].fk_id_vehicle
						if (vm.workOder[workOrderVehicleID]) {
							vm.workOder[workOrderVehicleID].push(workorderData[i]);
						}
					}
					const sortedArray = [];

					for (var key in vm.workOder) {
						if (vm.workOder.hasOwnProperty(key)) {
							const array = vm.workOder[key];
							for (var i = 0; i < array.length; i++) {
								sortedArray.push(array[i]);
							}
						}
					}
					sortedArray.sort(function (a, b) {
						const dateA = new Date(a.quote_date);
						const dateB = new Date(b.quote_date);
						return dateA - dateB;
					});

					vm.vehicleOrderList = [];

					for (var key in vm.vehicles) {
						if (vm.vehicles.hasOwnProperty(key)) {
							vm.vehicleOrderList.push(key)
						}
					}

					Object.keys(vm.workOder).forEach(function (vehicleID) {
						vm.workOder[vehicleID] = vm.workOder[vehicleID].map(function (workorder) {
							if (!workorder) {
								return;
							}
							const workOrderListItem = {
								workOrder: workorder,
								isLoading: true
							}
							fetchWorkOrderDetails(workOrderListItem, vehicleID);

							return workOrderListItem;
						});


					});
				})
				.catch(MessageService.showToast);
		}

		function initCreditCards() {
			if (!Array.isArray(creditCard)) {
				vm.creditCards = [];
			} else {
				vm.creditCards = creditCard;
			}
		}

		function initCustomAppointment() {
			if (!Array.isArray(customAppointment)) {
				vm.customAppointment = [];
			} else {
				vm.customAppointment = customAppointment;
			}
		}

		function getServiceVehiclesIdList() {
			if (!Array.isArray(serviceMap)) {
				return $q.reject("Service map data invalid.");
			}

			const idList = [];
			serviceMap.forEach(function (item) {
				if (item && item.vehicle) {
					addUniqueNumberToArray(idList, item.vehicle.id_vehicle);
				}
			});

			return $q.resolve(idList);
		}

		function fetchPurchasedVehiclesIdList() {
			var resourcePath = { companyID: companyID };

			var filterString = '';
			filterString = GeneralTools.equalFilterBuilder("fk_id_customer", customerID);
			filterString = GeneralTools.stringConnector(filterString, GeneralTools.equalFilterBuilder("is_canceled", false), ToolsConstants.apiFilters.andConnector);

			const filters = { filters: filterString };
			const sorting = {
				sortBy: "sale_date",
				sortDirection: ToolsConstants.apiSortingDirections.ASC
			}

			const idList = [];

			return SaleInfoService.getSaleInfos(resourcePath, filters, null, sorting)
				.then(function (saleInfos) {
					if (!Array.isArray(saleInfos)) {
						return $q.reject("Sale info data invalid.");
					}

					saleInfos.forEach(function (saleInfo) {
						addUniqueNumberToArray(idList, saleInfo.fk_id_vehicle);
					});

					return $q.resolve(idList);
				});
		}

		function addUniqueNumberToArray(array, number) {
			if (Array.isArray(array) || array.indexOf(number) == -1) {
				array.push(number);
			}

			return array;
		}

		function initTestDrives() {
			vm.testDrives = [];
			const queue = {};

			if (!Array.isArray(testDrives)) {
				return;
			}


			testDrives.forEach(function (testDrive) {
				if (!testDrive || !testDrive.vehicle) {
					return;
				}


				vm.testDrives.push({
					testDriveData: testDrive
				});

				if (!queue[testDrive.vehicle.id_vehicle]) {
					queue[testDrive.vehicle.id_vehicle] = fetchVehicle(testDrive.vehicle.id_vehicle);
				}
			});

			$q.all(queue)
				.then(function (result) {
					if (!result) {
						return $q.reject("Failed to get test drive vehicle data.")
					}
					vm.testDrives.forEach(function (testDrive) {
						if (!testDrive || !testDrive.testDriveData) {
							return;
						}

						testDrive.vehicleData = result[testDrive.testDriveData.vehicle.id_vehicle];

					}


					);
				})
				.catch(MessageService.showToast);
		}

		function fetchVehicle(vehicleID) {
			if (!!vehicleMap[vehicleID]) {
				return $q.resolve(vehicleMap[vehicleID]);
			}

			const resourcePath = {
				companyID: companyID,
				vehicleID: vehicleID
			};

			return VehicleService.getVehicleDetails(resourcePath)
				.then(function (result) {
					if (!result || !Array.isArray(result.data) || result.data.length != 1 || !result.data[0]) {
						return $q.reject("Failed to get test drive vehicle data with vehicle id: " + vehicleID);
					}

					if (!vehicleMap[vehicleID]) {
						vehicleMap[vehicleID] = result.data[0];
					}

					return $q.resolve(result.data[0])
				})
		}

		function fetchedWorkOrderInfo(vehicleID) {
			if (!!workOrderMap[vehicleID]) {
				return $q.resolve(workOrderMap[vehicleID]);
			}

			const resourcePath = {
				companyID: companyID,
				vehicleID: vehicleID
			};
			return WorkOrderService.getWorkOrderDetails(resourcePath).$promise
				.then(function (result) {
					if (result.length >= 2) {
						result.sort(function (a, b) { return new Date(b.quote_date) - new Date(a.quote_date) });
					}
					if (!workOrderMap[vehicleID]) {
						workOrderMap[vehicleID] = result;
					}
					return $q.resolve(result)
				})
		}

		function initCustomer() {
			if (!customers || !Array.isArray(customers.data) || customers.data.length != 1 || !customers.data[0]) {
				MessageService.showToast("Customer data invalid.");
				$state.go("app.homepage");
				return;
			}

			vm.customer = customers.data[0];
		}

		function initCustomerProfileImage() {
			vm.profileImageSrc = CustomerConstants.profileImagePlaceHolder;

			if (!vm.customer || !vm.customer.fk_profile_image) {
				return;
			}

			const resourcePath = {
				companyID: companyID,
				customerID: customerID
			}
			var profileImage;

			vm.isLoadingProfileImage = true;

			CustomersService.getCustomerProfileImageInfo(resourcePath)
				.then(function (file) {
					if (file == null) {
						return $q.reject("Profile image info data is invalid.")
					}
					profileImage = file;
					resourcePath.uuid = file.uuid;
					return CustomersService.downloadCustomerProfileImage(resourcePath);
				})
				.then(function (response) {
					if (response == null) {
						return $q.reject("Profile image data is invalid.")
					}

					vm.profileImageSrc = parseImage(response.data, profileImage.getFileType());
					vm.profileImageLink = FileViewService.generateUrlByUUID(profileImage.getUUID());
				})
				.catch(MessageService.showToast)
				.finally(function () {
					vm.isLoadingProfileImage = false;
				});
		}

		function initCustomerLicenseImage() {
			vm.licenseImageSrc = CustomerConstants.licenseImagePlaceHolder;

			if (!vm.customer || !vm.customer.fk_license_image) {
				return;
			}

			const resourcePath = {
				companyID: companyID,
				customerID: customerID
			}
			var licenseImage;

			vm.isLoadingLicenseImage = true;

			CustomersService.getCustomerLicenseImageInfo(resourcePath)
				.then(function (file) {
					if (file == null) {
						return $q.reject("License image info data is invalid.")
					}
					licenseImage = file;
					resourcePath.uuid = file.uuid;
					return CustomersService.downloadCustomerLicenseImage(resourcePath);
				})
				.then(function (response) {
					if (response == null) {
						return $q.reject("License image data is invalid.")
					}

					vm.licenseImageSrc = parseImage(response.data, licenseImage.getFileType());
					vm.licenseImageLink = FileViewService.generateUrlByUUID(licenseImage.getUUID());
				})
				.catch(MessageService.showToast)
				.finally(function () {
					vm.isLoadingLicenseImage = false;
				});
		}

		function parseImage(rawData, fileType) {
			var stream = new Uint8Array(rawData);
			var blob = new Blob([stream], { type: fileType });
			var rawUrl = URL.createObjectURL(blob);
			return $sce.trustAsResourceUrl(rawUrl);
		}

		function getPhoneNumberCategory(categoryID) {
			if (!constants || !constants.phoneCategories) {
				return;
			}

			const matchedCategory = constants.phoneCategories.find(function (category) {
				return category && category.id_phone_category == categoryID;
			});

			if (matchedCategory) {
				return matchedCategory.category;
			}

			return otherCategory;
		}

		function getEmailCategory(categoryID) {
			if (!constants || !constants.emailCategories) {
				return;
			}

			const matchedCategory = constants.emailCategories.find(function (category) {
				return category && category.id_email_category == categoryID;
			});

			if (matchedCategory) {
				return matchedCategory.name;
			}

			return otherCategory;
		}

		function formatPhoneNumber(string) {
			return GeneralTools.stringToPhoneNumberString(string);
		}

		function getCustomerAddress() {
			if (!vm.customer) {
				return;
			}

			var addressString = '';

			addressString = GeneralTools.stringConnector(addressString, vm.customer.address_street_number, ' ');
			addressString = GeneralTools.stringConnector(addressString, vm.customer.address_street, ' ');
			addressString = GeneralTools.stringConnector(addressString, vm.customer.address_city, ', ');
			addressString = GeneralTools.stringConnector(addressString, vm.customer.address_province, ', ');
			addressString = GeneralTools.stringConnector(addressString, vm.customer.address_postal_code, '  ');

			return addressString;
		}

		function getCustomerCreditCard() {
			// if (!vm.customer) {
			// 	return;
			// }
			var cards = [
				{
					cardType: 'Visa',
					cardNumber: 'XXXX4242',
					expiryDate: new Date(),
				},
				{
					cardType: 'Master Card',
					cardNumber: 'XXXX4242',
					expiryDate: new Date(),
				},
				{
					cardType: 'American Express',
					cardNumber: 'XXXX4242',
					expiryDate: new Date(),
				}
			]

			return cards;
		}

		function getVehiclePageUrl(vehicleID) {
			return $state.href("app.vehicle.general", { vehicleID: vehicleID });
		}

		function queryVehicles() {
			if (!vm.testDriveSearchText) {
				return;
			}

			var filterString = GeneralTools.addBracketToString(VehicleService.searchTextFilterBuilder(vm.testDriveSearchText));
			filterString = GeneralTools.stringConnector(filterString, GeneralTools.equalFilterBuilder("purchase_info.is_canceled", false), ToolsConstants.apiFilters.andConnector);

			const filters = {
				filters: filterString,
				isSold: false
			};

			const resourcePath = { companyID: companyID };

			return VehicleService.getVehicle(resourcePath, filters)
				.then(function (result) {
					if (result == null || !Array.isArray(result.data)) {
						return $q.reject();
					}

					return $q.resolve(result.data);
				})
				.catch(function (error) {
					return $q.reject();
				});
		}

		function addTestDriveVehicle(vehicleToBeAdded) {
			if (vehicleToBeAdded == null) {
				return;
			}

			var testDrive = new TestDrive();
			testDrive.setTestDriveVehicle(vehicleToBeAdded);

			var requestBody = CustomersService.postTestDriveRequestBodyGenerator(testDrive)
			var resourcePath = {
				customerID: $stateParams.customerID,
				companyID: companyID
			}

			CustomersService.createTestDrive(requestBody, resourcePath)
				.then(function (newTestDriveID) {
					resourcePath.testdriveID = newTestDriveID;
					return CustomersService.getTestDrives(resourcePath);
				})
				.then(function (newTestDriveData) {
					var newTestDrive = new TestDrive();
					newTestDrive.setAttributes(newTestDriveData[0]);
					vm.testDrives.push({
						vehicleData: vehicleToBeAdded,
						testDriveData: newTestDrive
					});

					vm.testDriveSearchText = null;
					MessageService.showToast("Success!");
				})
				.catch(MessageService.showToast);
		}

		function fetchWorkOrderDetails(workOrderListItem, vehicleID) {
			if (!workOrderListItem || !workOrderListItem.workOrder) {
				workOrderListItem.isLoading = false;
				return;
			}
			
			const queue = {
				labors: $q.when(workOrderListItem.workOrder.labors),
				parts: $q.when(workOrderListItem.workOrder.parts),
				inventories: $q.when(workOrderListItem.workOrder.inventories),
				payments: $q.when(workOrderListItem.workOrder.payments),
				discounts: $q.when(workOrderListItem.workOrder.discounts),
				miscfee: $q.when(workOrderListItem.workOrder.miscfee),
				workOrderWarranties: $q.when(workOrderListItem.workOrder.workOrderWarranties),
				workOrderPackages: $q.when(workOrderListItem.workOrder.workOrderPackages)
			};

			$q.all(queue).then(function (results) {
				if (!results) {
					return $q.reject("Failed to get work order subresource with workOrder id:" + workOrderListItem.workOrder.id_work_order);
				}

				workOrderListItem.labors = results.labors;
				workOrderListItem.parts = results.parts;
				workOrderListItem.inventories = results.inventories;
				workOrderListItem.payments = results.payments;
				workOrderListItem.discounts = results.discounts;
				workOrderListItem.miscfee = results.miscfee
				workOrderListItem.workOrderWarranties = results.workOrderWarranties
				workOrderListItem.workOrderPackages = results.workOrderPackages

				if (workOrderListItem.payments.length > 0) {
					workOrderListItem.payments.forEach(function (payment) {
						if (payment.fk_id_payment_method == 6 && payment.paymentStatus == "PENDING") {
							vm.showPendingItems[vehicleID] = true;
						}
					})
				}
				refreshList(workOrderListItem, vehicleID)
			})
				.catch(MessageService.showToast)
				.finally(function () {
					workOrderListItem.isLoading = false;
				});
		}

		function fetchWorkOrderOutstanding(workOrderID, vehicleID) {
			const resourcePath = {
				companyID: companyID,
				vehicleID: vehicleID,
				workorderID: workOrderID
			};

			return WorkOrderService.getWorkOrderInventories(resourcePath).$promise
		}

		function fetchWorkOrderInventories(workOrderID, vehicleID) {
			const resourcePath = {
				companyID: companyID,
				vehicleID: vehicleID,
				workorderID: workOrderID
			};

			return WorkOrderService.getWorkOrderInventories(resourcePath).$promise
		}

		function fetchWorkOrderMiscfees(workOrderID, vehicleID) {
			const resourcePath = {
				companyID: companyID,
				vehicleID: vehicleID,
				workorderID: workOrderID
			};

			return WorkOrderService.getMiscfeestype(resourcePath).$promise;
		}

		function fetchWorkOrderWarranty(workOrderID, vehicleID) {
			const resourcePath = {
				companyID: companyID,
				vehicleID: vehicleID,
				workorderID: workOrderID
			};

			return WorkOrderService.getWorkOrderWarranties(resourcePath).$promise;
		}

		function fetchWorkOrderPackage(workOrderID, vehicleID) {
			const resourcePath = {
				companyID: companyID,
				vehicleID: vehicleID,
				workorderID: workOrderID
			};

			return WorkOrderService.getWorkOrderPackages(resourcePath).$promise;
		}


		function fetchWorkOrderParts(workOrderID, vehicleID) {
			const resourcePath = {
				companyID: companyID,
				vehicleID: vehicleID,
				workorderID: workOrderID
			};

			return WorkOrderService.getWorkOrderParts(resourcePath).$promise
		}

		function fetchWorkOrderLabors(workOrderID, vehicleID) {
			const resourcePath = {
				companyID: companyID,
				vehicleID: vehicleID,
				workorderID: workOrderID
			};

			return WorkOrderService.getLabors(resourcePath).$promise;
		}

		function fetchWorkOrderDiscounts(workOrderID, vehicleID) {
			const resourcePath = {
				companyID: companyID,
				vehicleID: vehicleID,
				workorderID: workOrderID
			};

			return WorkOrderService.getDiscounts(resourcePath).$promise;
		}

		function fetchWorkOrderPayments(workOrderID, vehicleID) {
			const resourcePath = {
				companyID: companyID,
				vehicleID: vehicleID,
				workorderID: workOrderID
			};

			return WorkOrderService.getPayments(resourcePath).$promise;
		}

		function refreshList(workorderData, vehicleID) {
			if (!workorderData) {
				return
			}
			const workOrderSummaryCalculator = new WorkOrderSummaryCalculator();

			if (workorderData.workOrder) {

				workOrderSummaryCalculator.setTaxRate(workorderData.workOrder.tax_rate);
				workOrderSummaryCalculator.setSubsidizedAmount(workorderData.workOrder.subsidized_amount);
				workOrderSummaryCalculator.setSubsidizedPercentage(workorderData.workOrder.subsidized_percentage);
				workOrderSummaryCalculator.setIsSubsidizedByPercentage(workorderData.workOrder.is_subsidized_by_percentage);
			}
			workOrderSummaryCalculator.setParts(workorderData.parts);
			workOrderSummaryCalculator.setInventories(workorderData.inventories);
			workOrderSummaryCalculator.setLabors(workorderData.labors);
			workOrderSummaryCalculator.setDiscounts(workorderData.discounts);
			workOrderSummaryCalculator.setPayments(workorderData.payments);
			workOrderSummaryCalculator.setMiscfees(workorderData.miscfee);
			workOrderSummaryCalculator.setWorkOrderWarrantyList(workorderData.workOrderWarranties);
			workOrderSummaryCalculator.setWorkOrderPackageList(workorderData.workOrderPackages);
			workorderData.partsAndInventories = combinePartsAndInventories(workorderData.parts, workorderData.inventories);

			workorderData.totalPartsRetail = workOrderSummaryCalculator.getPartsAndInventoryTotalRetail();
			workorderData.totalLaborsCost = workOrderSummaryCalculator.getTotalLaborsCost();


			workorderData.outstanding = workOrderSummaryCalculator.getOutstanding();
			//workorderData.outstanding = workorderData.workOrder.outstanding;
			if (workorderData.workOrder.fk_id_work_order_status == 4 || workorderData.workOrder.fk_id_work_order_status == 3) {
				vm.vehicleOutstandingMap[vehicleID] += workorderData.outstanding + 0
			} else {
				vm.vehicleOutstandingMap[vehicleID] += 0
			}
		}

		function combinePartsAndInventories(parts, inventories) {
			if (!Array.isArray(parts)) {
				parts = [];
			}

			if (!Array.isArray(inventories)) {
				inventories = [];
			}

			var list = [];

			parts.forEach(function (part) {
				list.push({
					name: part.name,
					isFromInventory: false,
					isOrdered: part.is_ordered
				});
			});

			inventories.forEach(function (inventory) {
				list.push({
					name: inventory.name,
					isFromInventory: true
				});
			});

			return list;
		}

		function gettotalvehicleoutstanding() {
			var total = 0;

			if (!vm.vehicleOutstandingMap) {
				return 0
			}

			Object.keys(vm.vehicleOutstandingMap).forEach(function (vehicleID) {
				if (!vm.vehicleOutstandingMap[vehicleID]) {
					return total
				}
				total += vm.vehicleOutstandingMap[vehicleID]
			});

			return total
		}

		function toggleItemvehicleList() {
			var itemList = document.getElementById("item-vehicle-list");
			var tab = document.querySelector(".taba");

			if (itemList.style.display === "none") {
				itemList.style.display = "block";
				tab.classList.add("active");
			} else {
				itemList.style.display = "none";
				tab.classList.remove("active");
			}

			var itemList = document.getElementById("item-drives-list");
			var tab = document.querySelector(".tabc");
			itemList.style.display = "none";
			tab.classList.remove("active");

			var itemList = document.getElementById("item-outstanding-list");
			var tab = document.querySelector(".tabb");
			itemList.style.display = "none";
			tab.classList.remove("active");

		}

		function toggleItemdriveList() {
			var itemList = document.getElementById("item-drives-list");
			var tab = document.querySelector(".tabc");

			if (itemList.style.display === "none") {
				itemList.style.display = "block";
				tab.classList.add("active");
			} else {
				itemList.style.display = "none";
				tab.classList.remove("active");
			}

			var itemList = document.getElementById("item-vehicle-list");
			var tab = document.querySelector(".taba");
			itemList.style.display = "none";
			tab.classList.remove("active");

			var itemList = document.getElementById("item-outstanding-list");
			var tab = document.querySelector(".tabb");
			itemList.style.display = "none";
			tab.classList.remove("active");
		}

		function toggleItemoutstandingList() {
			var itemList = document.getElementById("item-outstanding-list");
			var tab = document.querySelector(".tabb");

			if (itemList.style.display === "none") {
				itemList.style.display = "block";
				tab.classList.add("active");
			} else {
				itemList.style.display = "none";
				tab.classList.remove("active");
			}

			var itemList = document.getElementById("item-vehicle-list");
			var tab = document.querySelector(".taba");
			itemList.style.display = "none";
			tab.classList.remove("active");

			var itemList = document.getElementById("item-drives-list");
			var tab = document.querySelector(".tabc");
			itemList.style.display = "none";
			tab.classList.remove("active");
		}
		vm.getselectedtotaloutstanding = getselectedtotaloutstanding;
		vm.getVehicleQuoted = getVehicleQuoted;

		function getVehicleQuoted(workOrderList) {
			var containQuopted = false;
			workOrderList.forEach(function (workorder) {
				if (workorder.outstanding && (workorder.workOrder.fk_id_work_order_status == 1)) {
					containQuopted = true
				}
			})
			return containQuopted;
		}

		function getselectedtotaloutstanding(workOrderList) {
			var outstanding = 0;
			workOrderList.forEach(function (workorder) {
				if (workorder && workorder.workOrder.fk_id_work_order_status == 4) {
					outstanding += workorder.outstanding;
				}
			})
			return outstanding;
		}

		vm.getWorkOrderUrl = getWorkOrderUrl;

		function getWorkOrderUrl(workOrder) {
			if (workOrder) {
				return $state.href("app.edit-workorder.general", { workOrderID: workOrder.workOrder.id_work_order, vehicleID: workOrder.workOrder.fk_id_vehicle });
			}
		}

		$scope.activeTab = 'list1';

		$scope.openTab = function (tabName) {
			$scope.activeTab = tabName;
		};

		vm.downloadOutstandingStatment = function downloadOutstandingStatment() {
			var oustandingStatmentArray = []
			const headers = [
				"invoice id",
				"completed date",
				"year",
				"make",
				"model",
				"cost",
				"outstanding amount"
			];
			var oustandingObject = {}
			var totalPartCost = 0;
			var totalInventoryCost = 0;
			for (var vehicleID in vm.vehicles) {
				vm.workOder[vehicleID].forEach(function (workorder) {
					totalPartCost = 0;
					totalInventoryCost = 0;
					oustandingObject = {}
					if (workorder.outstanding && (workorder.workOrder.fk_id_work_order_status == 4 || workorder.workOrder.fk_id_work_order_status == 3)) {
						oustandingObject.id_work_order = workorder.workOrder.id_work_order
						oustandingObject.year = vm.vehicles[vehicleID].vehicleData.year
						oustandingObject.make = vm.vehicles[vehicleID].vehicleData.make
						oustandingObject.model = vm.vehicles[vehicleID].vehicleData.model
						oustandingObject.completed_date = moment(workorder.workOrder.completed_date).format("YYYY-MM-DD")
						oustandingObject.outstanding = workorder.outstanding
						oustandingObject.invoice_number = workorder.workOrder.invoice_number
						if(workorder.parts){
							workorder.parts.forEach(function(part){
								totalPartCost += part.retail_price * part.quantity
							})
						}
						if(workorder.inventories){
							workorder.inventories.forEach(function(inventory){
								totalInventoryCost += inventory.retail_price * inventory.quantity
							})
						}
						oustandingObject.partAndInventoryCost = totalPartCost + totalInventoryCost;
						oustandingStatmentArray.push(oustandingObject)
					}
				})
			}
			const csv = [headers.join(",")].concat(
				oustandingStatmentArray.map(function (item) {
					return [
						item.invoice_number,
						item.completed_date,
						item.year,
						item.make,
						item.model,
						item.partAndInventoryCost,
						item.outstanding
					].join(",");
				})
			).join("\n");

			const blob = new Blob([csv], { type: 'text/csv' });

			const link = document.createElement('a');
			link.href = window.URL.createObjectURL(blob);
			link.download = 'outstanding Statment.csv';
			link.style.display = 'none';

			document.body.appendChild(link);
			link.click();

			document.body.removeChild(link);

		}

		function initConstants() {
			if (!constants) {

				MessageService.showToast("constants invalid");
				return;
			}

			vm.appointmentStatus = constants.appointmentStatus;
		}

		function removeSelectedAppointments() {
			var dialogOptions = {};

			dialogOptions.titleString = "Delete Appointments";
			dialogOptions.contentString = "Are you sure to delete selected appointments";

			var confirmOption = {};

			confirmOption.optionName = "YES";
			confirmOption.onClick = function () {
				confirmDeleteSelectedAppointments();
				DialogService.close();
			}

			var cancelOption = {};

			cancelOption.optionName = "NO";
			cancelOption.onClick = function () {
				DialogService.close();
			}

			dialogOptions.options = [confirmOption, cancelOption];

			DialogService.showOptionsDialog(dialogOptions);
		}

		function confirmDeleteSelectedAppointments() {
			if (!vm.selectedMap || !Array.isArray(vm.customAppointment)) {
				return;
			}

			const queue = [];
			vm.isDeletingAppointment = true;

			vm.customAppointment.forEach(function (appointment) {

				if (!appointment || !vm.selectedMap[appointment.id_appointment]) {
					return;
				}

				queue.push(deleteAppointment(appointment.id_appointment));
			});

			$q.all(queue)
				.then(function () {
					MessageService.showToast("Appointments is deleted.");
				})
				.catch(MessageService.showToast)
				.finally(function () {
					vm.isDeletingAppointment = false;
				})
		}

		function deleteAppointment(appointmentID) {
			const resourcePath = {
				companyID: companyID,
				customerID: customerID,
				customAppointmentID: appointmentID
			};

			return CustomersService.deleteCustomAppointment(resourcePath)
				.then(function () {
					const index = vm.customAppointment.findIndex(function (appointment) {
						return appointment && appointment.id_appointment == appointmentID;
					});

					vm.customAppointment.splice(index, 1);
					return $q.resolve();
				});
		}

		function updateAppointmentStatus(appointment) {
			if (!appointment) {
				return;
			}

			vm.isUpdatingAppointment = true;

			const resourcePath = {
				companyID: companyID,
				customerID: customerID,
				customAppointmentID: appointment.id_appointment
			};
			const requestBody = {
				fk_id_appointment_status: appointment.fk_id_appointment_status,
				title: appointment.title,
			};

			CustomersService.updateCustomAppointment(resourcePath, requestBody)
				.then(function () {
					MessageService.showToast("Appointment is updated.");
				})
				.catch(MessageService.showToast)
				.finally(function () {
					vm.isUpdatingAppointment = false;
				});
		}

		function isAnyItemSelected() {
			if (!vm.selectedMap || !Array.isArray(vm.customAppointment)) {
				return;
			}

			const selectedItem = vm.customAppointment.find(function (appointment) {
				return !!appointment && vm.selectedMap[appointment.id_appointment];
			});

			return !!selectedItem;
		}

		function disableDeleteButton() {
			return !isAnyItemSelected() || vm.isUpdatingAppointment || vm.isDeletingAppointment;
		}

		vm.updateLength = function () {
			vm.disableAddAppointment = true;
			if (vm.customAppointmentHolder.length != null && vm.customAppointmentHolder.title != null && vm.customAppointmentHolder.category != null) {
				vm.disableAddAppointment = false;
			}
		}

		vm.updateTitle = function () {
			vm.disableAddAppointment = true;
			if (vm.customAppointmentHolder.length != null && vm.customAppointmentHolder.title != null && vm.customAppointmentHolder.category != null) {
				vm.disableAddAppointment = false;
			}
		}

		vm.redirectToAddAppointment = function () {

			var appointmentNote = vm.customAppointmentHolder.title

			// if (vm.customer.getFullName()) {
			// 	vm.customAppointmentHolder.title = '[' + vm.customer.getFullName() + ']'
			// }

			// if (getCustomerPhoneNumber(vm.customer)) {
			// 	vm.customAppointmentHolder.title += " - " + '[ Customer Phone Number: ' + getCustomerPhoneNumber(vm.customer) + ']';
			// }

			// if (appointmentNote) {
			// 	vm.customAppointmentHolder.title += " - " + '[' + appointmentNote + ']';
			// }

			// if (LoginService.getUsername()) {
			// 	vm.customAppointmentHolder.title += " - " + '[ Booked by: ' + LoginService.getUsername() + ']';
			// }

			vm.customAppointmentHolder.title = appointmentNote 
			window.localStorage.setItem('customAppointmentHolderLength', vm.customAppointmentHolder.length);
			window.localStorage.setItem('customAppointmentHolderTitle', vm.customAppointmentHolder.title);
			window.localStorage.setItem('customAppointmentHolderCategory', vm.customAppointmentHolder.category);
			window.localStorage.setItem('customAppointmentHolderCreateBy', LoginService.getUserID());
			$location.url(vm.addAppointmentUrl);
		};

		function getCustomerPhoneNumber(customer) {
			if (!customer || !Array.isArray(customer.phone_numbers) || customer.phone_numbers.length <= 0) {
				return;
			}
			var custoemrPhoneNumber = customer.phone_numbers[0].phone_number;
			return custoemrPhoneNumber;
		}

		vm.removeTestDriveVehicleDialog = function(testDrive) {
			var dialogOptions = {};

			dialogOptions.titleString = "Confirm";
			dialogOptions.contentString = "Are you sure you want to delete this test drive?";

			var confirmOption = {};

			confirmOption.optionName = "YES";
			confirmOption.onClick = function () {
				vm.removeTestDriveVehicle(testDrive);
				DialogService.close();
			}

			var cancelOption = {};

			cancelOption.optionName = "NO";
			cancelOption.onClick = function () {
				DialogService.close();
			}

			dialogOptions.options = [confirmOption, cancelOption];

			DialogService.showOptionsDialog(dialogOptions);
		}

		vm.removeTestDriveVehicle = function (testDrive) {
			if (!testDrive || !testDrive.testDriveData || !testDrive.testDriveData.id_test_drive) {
				return;
			}
			var resourcePath = {
				customerID: $stateParams.customerID,
				companyID: companyID,
				testdriveID: testDrive.testDriveData.id_test_drive
			}

			CustomersService.deleteTestDrive(resourcePath)
				.then(function () {
					const index = vm.testDrives.findIndex(function (item) {
						return item && item.testDriveData && item.testDriveData.id_test_drive == testDrive.testDriveData.id_test_drive;
					});
					if (index >= 0) {
						vm.testDrives.splice(index, 1);
					}

					vm.testDriveSearchText = null;
					MessageService.showToast("Success!");
				})
				.catch(MessageService.showToast);
		}

		function checkInspectorRole(userRole){
			var isSaleManager = false;

			if(!Array.isArray(userRole)){
				return isSaleManager;
			}

			userRole.forEach(function(role){
				if(saleManagerRoles.indexOf(role) != -1){
					isSaleManager = true;
				}
			});

			return isSaleManager;
		}

	}
})();
(function ()
{
	'use strict';

	angular
		.module('app.customers')
		.controller('EditCustomerController', EditCustomerController);

	function EditCustomerController(VehicleService, $location, $stateParams, WorkOrderService, serviceMap, $q, $state, MessageService, ProgressService, CustomersService, customerToBeEdit, emailCategories, phoneCategories, FileUploadService, customerFiles, FileViewService, testDrives, creditCard, TestDrive, DialogService, $filter, $sce, CustomerConstants, ImageCompresser, LoginService){   
		var vm = this;
		var companyID = LoginService.getCompanyID();
		var originCustomer;	
		var deleteCustomerConfirmString = "CONFIRM";

		vm.ServiceVehicleNotFoundMessage = "No vehicle matches, create a new one."

		const serviceVehicleNotFoundUrlParams = {
			redirectState: $state.current.name,
			redirectParams: JSON.stringify({customerID: $stateParams.customerID}),
			newVehicleIdParamName: CustomerConstants.newVehicleIdParamName
		}

		vm.ServiceVehicleNotFoundUrl = $state.href("app.add-vehicle", serviceVehicleNotFoundUrlParams);

		if(customerToBeEdit == null || customerToBeEdit.data == null || customerToBeEdit.data[0] == null){
			MessageService.showToast("Can not find customer.");
			$state.go("app.homepage");
			return;
		}

		init();

		function init(){
			initConstants();
			initFunctions();
			initCustomer();
			initCustomerImages();
			initUploaders();
			initCustomerFiles();
			initTestDrives();
			initServiceMap();
			initCreditCards();
		}

		function initServiceMap(){
			if(Array.isArray){
				vm.serviceMap = serviceMap;
			} else {
				vm.serviceMap = [];
			}

			if($stateParams[CustomerConstants.newVehicleIdParamName]){
				tryToAddNewServiceVehicle($stateParams[CustomerConstants.newVehicleIdParamName]);
			}		
		}

		function initConstants(){
			vm.constants = {}
			vm.constants.phoneCategories = phoneCategories;
			vm.constants.emailCategories = emailCategories;
		}

		function initFunctions(){
			vm.updateCustomer = updateCustomer;
			vm.deleteUploadedFile = deleteUploadedFile;
			vm.removeFileFromQueue = removeFileFromQueue;
			vm.addTestDriveVehicle = addTestDriveVehicle;
			vm.removeTestDriveVehicle = removeTestDriveVehicle;
			vm.deleteCustomer = deleteCustomer;
			vm.onSeviceVehicleSelect = onSeviceVehicleSelect;
			vm.showRemoveServiceMapDialog = showRemoveServiceMapDialog;
		}

		function initTestDrives(){
			if(!Array.isArray(testDrives)){
				vm.testDrives = [];
			}else{
				vm.testDrives = testDrives;
			}
		}

		function initCreditCards(){
			if(!Array.isArray(creditCard)){
				vm.creditCards = [];
			}else{
				vm.creditCards = creditCard;
			}
		}

		function initCustomerFiles(){
			if(!Array.isArray(customerFiles)){
				vm.uploadedFiles = [];
			}else{
				vm.uploadedFiles = customerFiles;
			}
		}

		function initCustomer(){
			vm.customer = customerToBeEdit.data[0];

			if(!Array.isArray(vm.customer.phone_numbers)){
				vm.customer.phone_numbers = [];
			}

			if(!Array.isArray(vm.customer.emails)){
				vm.customer.emails = [];
			}

			originCustomer = angular.copy(vm.customer);
		}

		function initCustomerImages(){
			vm.profileImageSrc = CustomerConstants.profileImagePlaceHolder
			vm.licenseImageSrc = CustomerConstants.licenseImagePlaceHolder

			if(vm.customer.fk_profile_image != null){
				initCustomerProfileImage();
			}

			if(vm.customer.fk_license_image != null){
				initCustomerLicenseImage();
			}
		}

		function initCustomerLicenseImage(){
			var licenseImage; 
			var resourcePath = {
				companyID: companyID,
				customerID: vm.customer.getResourceID()
			}

			isProcessingLicenseImage(true);

			CustomersService.getCustomerLicenseImageInfo(resourcePath)
				.then(function(file){
					if(file == null){
						return $q.reject("License image info data is invalid.")
					}
					licenseImage = file;
					resourcePath.uuid = file.uuid;
					return CustomersService.downloadCustomerLicenseImage(resourcePath);
				})
				.then(function(response){
					if(response == null){
						return $q.reject("License image data is invalid.")
					}

					vm.licenseImageSrc = parseImage(response.data, licenseImage.getFileType());
					vm.licenseImageLink = FileViewService.generateUrlByUUID(licenseImage.getUUID());
				})
				.catch(MessageService.showToast)
				.finally(function(){
					isProcessingLicenseImage(false)
				});
		}

		function initCustomerProfileImage(){
			var profileImage; 
			var resourcePath = {
				companyID: companyID,
				customerID: vm.customer.getResourceID()
			}

			isProcessingProfileImage(true);

			CustomersService.getCustomerProfileImageInfo(resourcePath)
				.then(function(file){
					if(file == null){
						return $q.reject("Profile image info data is invalid.")
					}
					profileImage = file;
					resourcePath.uuid = file.uuid;
					return CustomersService.downloadCustomerProfileImage(resourcePath);
				})
				.then(function(response){
					if(response == null){
						return $q.reject("Profile image data is invalid.")
					}

					vm.profileImageSrc = parseImage(response.data, profileImage.getFileType());
					vm.profileImageLink = FileViewService.generateUrlByUUID(profileImage.getUUID());
				})
				.catch(MessageService.showToast)
				.finally(function(){
					isProcessingProfileImage(false)
				});
		}

		function initUploaders(){
			vm.imageUploader = FileUploadService.getNewUploader();
			vm.imageUploader.filters.push(FileUploadService.getSizeFilter(20));
			vm.imageUploader.filters.push(FileUploadService.getImageFilter(20));
			
			vm.fileUploader = FileUploadService.getNewUploader();
			vm.fileUploader.filters.push(FileUploadService.getSizeFilter(20));
		}

		vm.imageUploader.onAfterAddingFile = function(fileItem){
			var imageSrc = URL.createObjectURL(fileItem._file);
			var resourcePath = vm.customer.getResourcePath();

			var imageCompresser = new ImageCompresser();

			imageCompresser.photo(fileItem._file, 1024, "file", false, function(file){
				
				if(fileItem.isLicenseImage == true){
					vm.licenseImageSrc = $sce.trustAsResourceUrl(imageSrc);
					FileUploadService.changeFileName(fileItem, "Driver License");
					fileItem.url = FileUploadService.getUrlForPostCustomerLicenseImage(resourcePath);	
					isProcessingLicenseImage(true);
				}

				if(fileItem.isProfileImage == true){			
					vm.profileImageSrc = $sce.trustAsResourceUrl(imageSrc);
					FileUploadService.changeFileName(fileItem, "Profile Image");
					fileItem.url = FileUploadService.getUrlForPostCustomerProfileImage(resourcePath);
					isProcessingProfileImage(true);		
				}
				fileItem._file 		= file;
				fileItem.file.size 	= file.size;
				fileItem.upload();				
			});
		};

		vm.imageUploader.onSuccessItem = function(fileItem, response, status, headers){
			var resourcePath = {
				companyID: companyID,
				customerID: vm.customer.getResourceID()
			}

			if(!FileUploadService.isUploadSuccess(headers)){
				MessageService.showToast(headers.message);
				return;
			}

			if(fileItem.isProfileImage == true){		
				CustomersService.getCustomerProfileImageInfo(resourcePath)
					.then(function(profileImage){
						if(profileImage == null){
							return $q.reject("Profile image info data is invalid.")
						}

						vm.profileImageLink = FileViewService.generateUrlByUUID(profileImage.getUUID());
					})
					.catch(MessageService.showToast)
					.finally(function(){
						isProcessingProfileImage(false);
					});
			}

			if(fileItem.isLicenseImage == true){
				CustomersService.getCustomerLicenseImageInfo(resourcePath)
					.then(function(licenseImage){
						if(licenseImage == null){
							return $q.reject("Profile image info data is invalid.")
						}

						vm.licenseImageLink = FileViewService.generateUrlByUUID(licenseImage.getUUID());
					})
					.catch(MessageService.showToast)
					.finally(function(){
						isProcessingLicenseImage(false);
					});
			}

			

			MessageService.showToast("Image updated!");
		}


		function parseImage(rawData, fileType){
			var stream 		= new Uint8Array(rawData);
			var blob 		= new Blob([stream], {type: fileType});
			var rawUrl 		= URL.createObjectURL(blob);
			return $sce.trustAsResourceUrl(rawUrl);
		}

		function isProcessingProfileImage(isProcessing){
			vm.blurProfileImg = isProcessing;
			vm.showProfileImgProgress = isProcessing;
		}

		function isProcessingLicenseImage(isProcessing){
			vm.blurLicenseImg = isProcessing;
			vm.showLicenseImgProgress = isProcessing;
		}

		function deleteUploadedFile(file, index){
			var dialogOptions = {};

			dialogOptions.titleString = "Delete file";
			dialogOptions.contentString = "Are you sure to delete file " + file.file_name + '?';

			var confirmOption = {};

			confirmOption.optionName = "YES";
			confirmOption.onClick = function(){
				confirmDeleteFile(file, index);
				DialogService.close();
			}

			var cancelOption = {};

			cancelOption.optionName = "NO";
			cancelOption.onClick = function(){
				DialogService.close();
			}

			dialogOptions.options = [confirmOption, cancelOption];

			DialogService.showOptionsDialog(dialogOptions);
		}

		function confirmDeleteFile (file, index){
			ProgressService.setMode("indeterminate");
			ProgressService.isVisble(true);

			var resourcePath = {
				companyID: vm.customer.getResourcePath().companyID,
				customerID: vm.customer.getResourcePath().customerID,
				fileID: file.id_customer_file
			}

			CustomersService.deleteCustomerFile(resourcePath) 
				.then(function(){
					vm.uploadedFiles.splice(index, 1);
					MessageService.showToast("File is deleted!")
					ProgressService.isVisble(false);
				}).catch(function(error){
					ProgressService.isVisble(false);
					MessageService.showToast(error);
				});
		}

		vm.fileUploader.onAfterAddingFile = function(fileItem){				
			ProgressService.setMode("indeterminate");
			ProgressService.isVisble(true);

			fileItem.url = FileUploadService.getUrlForPostCustomerFile(vm.customer.getResourcePath());
			fileItem.upload();
		}

		vm.fileUploader.onSuccessItem = function(item, response, status, headers){
			if(!FileUploadService.isUploadSuccess(headers)){
				ProgressService.isVisble(false);
				MessageService.showToast(headers.message);
				return;
			}

			var resourcePath = {
				companyID: vm.customer.getResourcePath().companyID,
				customerID: vm.customer.getResourcePath().customerID,
				fileID: response.data
			}

			CustomersService.getCustomerFiles(resourcePath) 
				.then(function(result){
					item.remove();
					vm.uploadedFiles.unshift(result[0]);
					MessageService.showToast("File is uploaded!")
					ProgressService.isVisble(false);	
				}).catch(function(error){
					ProgressService.isVisble(false);
					MessageService.showToast(error);
				});
		}

		function removeFileFromQueue (fileItem){
			fileItem.remove();
		}

		function addTestDriveVehicle (vehicleToBeAdded){
			if(vehicleToBeAdded == null){
				return;
			}

			var testDrive = new TestDrive();
			testDrive.setTestDriveVehicle(vehicleToBeAdded);

			var requestBody = CustomersService.postTestDriveRequestBodyGenerator(testDrive)
			var resourcePath = vm.customer.getResourcePath();

			ProgressService.setMode("indeterminate");
			ProgressService.isVisble(true);

			vm.isProcessingTestDrive = true;

			CustomersService.createTestDrive(requestBody, resourcePath)
					.then(function(newTestDriveID){
						resourcePath.testdriveID = newTestDriveID;
						return CustomersService.getTestDrives(resourcePath);
					})
					.then(function(newTestDriveData){
						var newTestDrive = new TestDrive();
						newTestDrive.setAttributes(newTestDriveData[0]);
						vm.testDrives.unshift(newTestDrive);
						MessageService.showToast("Success!");
					})
					.catch(MessageService.showToast)
					.finally(function(){
						ProgressService.isVisble(false);
						vm.isProcessingTestDrive = false;
					});
		}

		function removeTestDriveVehicle (testDrive, index){
			var dialogOptions = {};

			dialogOptions.titleString = "Delete test drive";
			dialogOptions.contentString = "Are you sure to delete test drive at " + $filter('date')(testDrive.date, 'yyyy-MM-dd HH:mm:ss') + '?';

			var confirmOption = {};

			confirmOption.optionName = "YES";
			confirmOption.onClick = function(){
				confirmRemoveTestDrive(testDrive, index);
				DialogService.close();
			}

			var cancelOption = {};

			cancelOption.optionName = "NO";
			cancelOption.onClick = function(){
				DialogService.close();
			}

			dialogOptions.options = [confirmOption, cancelOption];

			DialogService.showOptionsDialog(dialogOptions);
		}

		function confirmRemoveTestDrive(testDrive, index){
			ProgressService.setMode("indeterminate");
			ProgressService.isVisble(true);
			vm.isProcessingTestDrive = true;

			CustomersService.deleteTestDrive(testDrive.getResourcePath())
					.then(function(){
						vm.testDrives.splice(index, 1);
						MessageService.showToast("Success!");
					})
					.catch(MessageService.showToast)
					.finally(function(){
						vm.isProcessingTestDrive = false;
						ProgressService.isVisble(false);
					});			
		}

		function updateCustomer(){

			if(!vm.isBasicFormValid() || !vm.isDetailFormValid()){
				MessageService.showToast("Please make sure all the fields are valid.");
				return;
			}

			var changedProperties = CustomersService.updateRequestBodyGenerator(originCustomer, vm.customer);

			if(Object.keys(changedProperties).length <= 0){
				MessageService.showToast("No changes detected.");
				return;
			}
			
			if(vm.isSimilarCustomerFound()){
				var dialogOptions = {};

				dialogOptions.titleString = "Similar Customer Found";
				dialogOptions.contentString = "Are you sure to update customer?";

				var confirmOption = {};

				confirmOption.optionName = "YES";
				confirmOption.onClick = function(){
					performUpdateCustomerRequest(changedProperties);
					DialogService.close();
				}

				var cancelOption = {};

				cancelOption.optionName = "NO";
				cancelOption.onClick = function(){
					DialogService.close();
				}

				dialogOptions.options = [confirmOption, cancelOption];

				DialogService.showOptionsDialog(dialogOptions);

				return;
			}

			performUpdateCustomerRequest(changedProperties);
		}

		function performUpdateCustomerRequest(changedProperties){
			ProgressService.setMode("indeterminate");
			ProgressService.isVisble(true);
			vm.isProcessingCustomer = true;

			CustomersService.updateCustomer(changedProperties, originCustomer.getResourcePath())
				.then(function(){
					originCustomer = angular.copy(vm.customer);
					MessageService.showToast("Success");
					$state.go("app.view-customer", {customerID: $stateParams.customerID});
				})
				.catch(function(error){
					MessageService.showToast(error);					
				})
				.finally(function(){
					vm.isProcessingCustomer = false;
					ProgressService.isVisble(false);
				});
		}

		function deleteCustomer(){		
			var dialogOptions = {};

			dialogOptions.inputBoxPlaceHolder	= "Enter here";
			dialogOptions.cancelButtonString	= "CANCEL";
			dialogOptions.confirmButtonString	= "CONFIRM";
			dialogOptions.titleString			= "ARE YOU SURE TO DELETE THIS CUSTOMER";
			dialogOptions.contentString			= "Please Type \"" + deleteCustomerConfirmString + "\" below:";

			dialogOptions.confirmCallback				= confirmDeleteCustomerCallback;
			dialogOptions.enableConfirmButtonCallback	= enableDeleteCustomerButtonCallback;

			DialogService.showConfirmDialog(dialogOptions);
		}

		function confirmDeleteCustomerCallback(){
			ProgressService.setMode("indeterminate");
			ProgressService.isVisble(true);
			
			CustomersService.deleteCustomer(vm.customer.getResourcePath())
				.then(function(){
					MessageService.showToast("Success!");
					ProgressService.isVisble(false);
					$state.go("app.customers");
				})
				.catch(function(error){
					MessageService.showToast(error);
					ProgressService.isVisble(false);
				});
		}

		function enableDeleteCustomerButtonCallback(inputString){
			if(inputString === deleteCustomerConfirmString){
				return true;
			}
			return false;
		}

		function onSeviceVehicleSelect(vehicle){
			addServiceVehicle(vehicle).then(vm.cleanSearchBox).catch(MessageService.showToast);
		}

		function addServiceVehicle(vehicle){
			if(!vehicle){
				MessageService.showToast("Vehicle data invalid.");
				return;
			}

			const resourcePath = {
				companyID: companyID
			};

			const newServiceMap = {
				vehicle:{
					id_vehicle: vehicle.getResourceID()
				},
				customer:{
					id_customer: $stateParams.customerID
				}
			};

			return WorkOrderService.createServiceMap(resourcePath, newServiceMap)
				.then(function(newServiceMapID){
					if(Array.isArray(vm.serviceMap)){
						newServiceMap.id_service_map = newServiceMapID;
						newServiceMap.vehicle.year = vehicle.year;
						newServiceMap.vehicle.make = vehicle.make;
						newServiceMap.vehicle.model = vehicle.model;
						vm.serviceMap.push(newServiceMap)
					}
					return $q.resolve();		
				})			
		}

		function showRemoveServiceMapDialog(serviceMap, index){
			if(!serviceMap){
				MessageService.showToast("Service map data invalid.");
				return;
			}

			var dialogOptions = {};

			dialogOptions.titleString = "Remove service vehicle";
			dialogOptions.contentString = "Are you sure to remove service vehicle?";

			var confirmOption = {};

			confirmOption.optionName = "YES";
			confirmOption.onClick = function(){
				removeServiceMap(serviceMap, index);
				DialogService.close();
			}

			var cancelOption = {};

			cancelOption.optionName = "NO";
			cancelOption.onClick = function(){
				DialogService.close();
			}

			dialogOptions.options = [confirmOption, cancelOption];

			DialogService.showOptionsDialog(dialogOptions);
		}

		function removeServiceMap(serviceMap, index){
			if(!serviceMap){
				return $q.reject("Service map data invalid.");
			}

			const resourcePath = {
				companyID: companyID,
				servicemapID: serviceMap.id_service_map
			}
			vm.isDeletingServiceMap = true;

			WorkOrderService.deleteServiceMap(resourcePath)
				.then(function(){
					if(Array.isArray(vm.serviceMap)){
						vm.serviceMap.splice(index, 1);
					}
					MessageService.showToast("Service vehicle is removed.")
				})
				.catch(MessageService.showToast)
				.finally(function(){
					vm.isDeletingServiceMap = false;
					ProgressService.isVisble(false);
				});
		}

		function tryToAddNewServiceVehicle(newVehicleID){
			const vehicleResourcePath = {
				companyID: companyID,
				vehicleID: newVehicleID
			};

			VehicleService.getVehicle(vehicleResourcePath)
				.then(function(result){
					if(!result || !Array.isArray(result.data) || result.data.length != 1){
						return $q.reject("Failed to add service vehicle:" + newVehicleID);
					}

					return addServiceVehicle(result.data[0]);
				})
				.catch(MessageService.showToast)
				.finally(function(){
					$location.search({}).replace();
				})
		}
	}
})();
(function ()
{
	'use strict';

	angular
		.module('app.customers')
		.controller('BrowseCustomersController', BrowseCustomersController);

	function BrowseCustomersController($location){   
		var vm = this;

		vm.updateUrl = updateUrl;

		function updateUrl(urlParams){
			$location.search(urlParams).replace();
		}
	}
})();
(function ()
{
	'use strict';

	angular
		.module('app.customers')
		.controller('AddCustomerController', AddCustomerController);

	function AddCustomerController($scope, $mdDialog, $state, emailCategories, phoneCategories, MessageService, ProgressService, CustomersService, Customer, FileUploadService, LoginService, TestDrive, $q, $sce, ImageCompresser, $stateParams, DialogService){   
		var vm = this;
		var isFileUploadFinished = true;
		var isImageUploadFinished = true;
		var licenseImageFileInToUpload;
		var profileImageFileToUpload;
		var uploadFileTask = $q.defer();
		var uploadImageTask = $q.defer();
		
		init();

		function init(){
			initConstants();
			initFunctions();
			initNewCustomer();
			initFileUploader();
			initCustomerFiles();
		}

		function initCustomerFiles (){
			vm.uploadedFiles = [];
		}

		function initFunctions(){
			vm.removeFileFromQueue = removeFileFromQueue;
			vm.addTestDriveVehicle = addTestDriveVehicle;
			vm.removeTestDriveVehicle = removeTestDriveVehicle;
		}

		function initConstants(){
			vm.constants = {}
			vm.constants.phoneCategories = phoneCategories;
			vm.constants.emailCategories = emailCategories;
			vm.createCustomer = createCustomer;
		}

		function initNewCustomer(){
			if($stateParams.newCustomer != null){
				vm.customer = $stateParams.newCustomer;
			}else{
				vm.customer = new Customer();
			}
		}

		function initFileUploader(){
			vm.imageUploader = FileUploadService.getNewUploader();
			vm.imageUploader.filters.push(FileUploadService.getSizeFilter(20));
			vm.imageUploader.filters.push(FileUploadService.getImageFilter(20));
			
			vm.fileUploader = FileUploadService.getNewUploader();
			vm.fileUploader.filters.push(FileUploadService.getSizeFilter(20));
		}

		function addTestDriveVehicle (vehicle){
			if(vehicle == null){
				return;
			}

			if(!Array.isArray(vm.testDrives)){
				vm.testDrives = [];
			}

			if(vehicle == null){
				return;
			}

			var testDrive = new TestDrive();
			testDrive.setTestDriveVehicle(vehicle);

			vm.testDrives.unshift(testDrive)
		}

		function removeTestDriveVehicle(testDrive, index){
			vm.testDrives.splice(index, 1);
		}

		function createCustomer(){	
			var newCustomerID;	
			if(!vm.isBasicFormValid() || !vm.isDetailFormValid()){
				MessageService.showToast("Please make sure all the fields are valid.");
				return;
			}

			if(vm.isSimilarCustomerFound()){
				var dialogOptions = {};

				dialogOptions.titleString = "Similar Customer Found";
				dialogOptions.contentString = "Are you sure to create customer?";

				var confirmOption = {};

				confirmOption.optionName = "YES";
				confirmOption.onClick = function(){
					performCreateCustomerRequest();
					DialogService.close();
				}

				var cancelOption = {};

				cancelOption.optionName = "NO";
				cancelOption.onClick = function(){
					DialogService.close();
				}

				dialogOptions.options = [confirmOption, cancelOption];

				DialogService.showOptionsDialog(dialogOptions);

				return;
			}

			performCreateCustomerRequest();
		}

		function performCreateCustomerRequest(){
			var newCustomerID;	
			var resourcePath = {companyID: LoginService.getCompanyID()};

			ProgressService.setMode("indeterminate");
			ProgressService.isVisble(true);
			vm.processingCustomer = true;

			CustomersService.createCustomer(resourcePath, vm.customer)
				.then(function(customerID){	
					newCustomerID = customerID
					return taskListBaseOnNewCustomerID(newCustomerID);
				})
				.then(function(response){					
					MessageService.showToast("Success!")

					if(!$stateParams.redirectState){
						$state.go("app.customers", CustomersService.getUrlParamsForBrowseCusmotersByCustomerObj(vm.customer));
						return;
					}

					var redirectParams;

					if($stateParams.redirectParams){
						try{
							redirectParams = JSON.parse($stateParams.redirectParams);
						} catch(error) {

						}
					}

					if(!redirectParams){
						redirectParams = {};
					}

					redirectParams.newCustomerID = newCustomerID;

					$state.go($stateParams.redirectState, redirectParams);
				})
				.catch(function(error){
					MessageService.showToast(error);
				})
				.finally(function(){
					ProgressService.isVisble(false);
					vm.processingCustomer = false;
				});
		}

		function taskListBaseOnNewCustomerID(newCustomerID){
			var taskList = []; 

			if(vm.fileUploader.queue.length > 0){
				setQueueFileUrl(newCustomerID);
				taskList.push(uploadFileTask.promise);
				vm.fileUploader.uploadAll();
			}

			if(vm.imageUploader.queue.length > 0){
				setQueueImageUrl(newCustomerID);	
				taskList.push(uploadImageTask.promise);
				vm.imageUploader.uploadAll();
			}

			var resourcePath = {
				companyID: LoginService.getCompanyID(),
				customerID: newCustomerID
			}

			vm.testDrives.forEach(function(testDrive){
				var requestBody = CustomersService.postTestDriveRequestBodyGenerator(testDrive)
				taskList.push(CustomersService.createTestDrive(requestBody, resourcePath));
			})

			return $q.all(taskList);
		}


		function setQueueImageUrl(customerID){
			var resourcePath = {
					companyID: LoginService.getCompanyID(),
					customerID: customerID
				};

			vm.imageUploader.queue.forEach(function(fileItem){

				if(fileItem.isLicenseImage){
					fileItem.url = FileUploadService.getUrlForPostCustomerLicenseImage(resourcePath);
				}

				if(fileItem.isProfileImage){
					fileItem.url = FileUploadService.getUrlForPostCustomerProfileImage(resourcePath);
				}
			})			
		}

		function setQueueFileUrl(customerID){
			var resourcePath = {
					companyID: LoginService.getCompanyID(),
					customerID: customerID
				};
				
			vm.fileUploader.queue.forEach(function(fileItem){
				fileItem.url = FileUploadService.getUrlForPostCustomerFile(resourcePath);
			})
		}

		function removeFileFromQueue (file, index){
			vm.fileUploader.removeFromQueue(file);
		}

		vm.fileUploader.onSuccessItem = function(item, response, status, headers){
			if(!FileUploadService.isUploadSuccess(headers)){
				MessageService.showToast(headers.message);
				return;
			}
			
			vm.fileUploader.removeFromQueue(item);	
			vm.uploadedFiles.unshift({file_name: item.file.name});
		}

		vm.fileUploader.onCompleteAll = function(){
			uploadFileTask.resolve();
		}

		vm.imageUploader.onCompleteAll = function(){
			uploadImageTask.resolve();
		}

		vm.imageUploader.onAfterAddingFile = function(fileItem){
			var imageSrc = URL.createObjectURL(fileItem._file);
			vm.imageUploader.clearQueue();

			if(fileItem.isLicenseImage == true){
				vm.licenseImageSrc = $sce.trustAsResourceUrl(imageSrc);
				FileUploadService.changeFileName(fileItem, "Driver License");
				licenseImageFileInToUpload = fileItem;	
			}

			if(fileItem.isProfileImage == true){
				vm.profileImageSrc = $sce.trustAsResourceUrl(imageSrc);
				FileUploadService.changeFileName(fileItem, "Profile Image");
				profileImageFileToUpload = fileItem;
			}

			var imageCompresser = new ImageCompresser();

			if(profileImageFileToUpload != null){
				imageCompresser.photo(profileImageFileToUpload._file, 1024, "file", false, function(file){
					profileImageFileToUpload._file 		= file;
					profileImageFileToUpload.file.size 	= file.size;

					vm.imageUploader.queue.push(profileImageFileToUpload);
				});
			}

			if(licenseImageFileInToUpload != null){
				imageCompresser.photo(licenseImageFileInToUpload._file, 1024, "file", false, function(file){
					licenseImageFileInToUpload._file 		= file;
					licenseImageFileInToUpload.file.size 	= file.size;

					vm.imageUploader.queue.push(licenseImageFileInToUpload);
				});
			}
		};
	}
})();
(function ()
{
    'use strict';

    angular
        .module('app.core',
            [
                'ngAnimate',
                'ngAria',
                'ngCookies',
                'ngMessages',
                'ngResource',
                'ngSanitize',
                'ngMaterial',
                'pascalprecht.translate',
                'ui.router'
            ]);
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsWidgetController', MsWidgetController)
        .directive('msWidget', msWidgetDirective)
        .directive('msWidgetFront', msWidgetFrontDirective)
        .directive('msWidgetBack', msWidgetBackDirective);

    /** @ngInject */
    function MsWidgetController($scope, $element)
    {
        var vm = this;

        // Data
        vm.flipped = false;

        // Methods
        vm.flip = flip;

        //////////

        /**
         * Flip the widget
         */
        function flip()
        {
            if ( !isFlippable() )
            {
                return;
            }

            // Toggle flipped status
            vm.flipped = !vm.flipped;

            // Toggle the 'flipped' class
            $element.toggleClass('flipped', vm.flipped);
        }

        /**
         * Check if widget is flippable
         *
         * @returns {boolean}
         */
        function isFlippable()
        {
            return (angular.isDefined($scope.flippable) && $scope.flippable === true);
        }
    }

    /** @ngInject */
    function msWidgetDirective()
    {
        return {
            restrict  : 'E',
            scope     : {
                flippable: '=?'
            },
            controller: 'MsWidgetController',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    //////////
                };
            }
        };
    }

    /** @ngInject */
    function msWidgetFrontDirective()
    {
        return {
            restrict  : 'E',
            require   : '^msWidget',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget-front');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    // Methods
                    scope.flipWidget = MsWidgetCtrl.flip;
                };
            }
        };
    }

    /** @ngInject */
    function msWidgetBackDirective()
    {
        return {
            restrict  : 'E',
            require   : '^msWidget',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget-back');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    // Methods
                    scope.flipWidget = MsWidgetCtrl.flip;
                };
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsTimelineController', MsTimelineController)
        .directive('msTimeline', msTimelineDirective)
        .directive('msTimelineItem', msTimelineItemDirective);

    /** @ngInject */
    function MsTimelineController()
    {
        var vm = this;

        // Data
        vm.scrollEl = undefined;

        // Methods
        vm.setScrollEl = setScrollEl;
        vm.getScrollEl = getScrollEl;

        //////////

        /**
         * Set scroll element
         *
         * @param scrollEl
         */
        function setScrollEl(scrollEl)
        {
            vm.scrollEl = scrollEl;
        }

        /**
         * Get scroll element
         *
         * @returns {undefined|*}
         */
        function getScrollEl()
        {
            return vm.scrollEl;
        }
    }

    /** @ngInject */
    function msTimelineDirective()
    {
        return {
            scope     : {
                msTimeline: '=?',
                loadMore  : '&?msTimelineLoadMore'
            },
            controller: 'MsTimelineController',
            compile   : function (tElement)
            {
                tElement.addClass('ms-timeline');

                return function postLink(scope, iElement, iAttrs, MsTimelineCtrl)
                {
                    // Create an element for triggering the load more action and append it
                    var loadMoreEl = angular.element('<div class="ms-timeline-loader md-accent-bg md-whiteframe-4dp"><span class="spinner animate-rotate"></span></div>');
                    iElement.append(loadMoreEl);

                    // Default config
                    var config = {
                        scrollEl: '#content'
                    };

                    // Extend the configuration
                    config = angular.extend(config, scope.msTimeline, {});
                    
                    // Grab the scrollable element and store it in the controller for general use
                    var scrollEl = angular.element(config.scrollEl);
                    MsTimelineCtrl.setScrollEl(scrollEl);

                    // Threshold
                    var threshold = 144;

                    // Register onScroll event for the first time
                    registerOnScroll();

                    /**
                     * onScroll Event
                     */
                    function onScroll()
                    {
                        if ( scrollEl.scrollTop() + scrollEl.height() + threshold > loadMoreEl.position().top )
                        {
                            // Show the loader
                            loadMoreEl.addClass('show');

                            // Unregister scroll event to prevent triggering the function over and over again
                            unregisterOnScroll();

                            // Trigger load more event
                            scope.loadMore().then(
                                // Success
                                function ()
                                {
                                    // Hide the loader
                                    loadMoreEl.removeClass('show');

                                    // Register the onScroll event again
                                    registerOnScroll();
                                },

                                // Error
                                function ()
                                {
                                    // Remove the loader completely
                                    loadMoreEl.remove();
                                }
                            );
                        }
                    }

                    /**
                     * onScroll event registerer
                     */
                    function registerOnScroll()
                    {
                        scrollEl.on('scroll', onScroll);
                    }

                    /**
                     * onScroll event unregisterer
                     */
                    function unregisterOnScroll()
                    {
                        scrollEl.off('scroll', onScroll);
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        unregisterOnScroll();
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msTimelineItemDirective($timeout, $q)
    {
        return {
            scope  : true,
            require: '^msTimeline',
            compile: function (tElement)
            {
                tElement.addClass('ms-timeline-item').addClass('hidden');

                return function postLink(scope, iElement, iAttrs, MsTimelineCtrl)
                {
                    var threshold = 72,
                        itemLoaded = false,
                        itemInViewport = false,
                        scrollEl = MsTimelineCtrl.getScrollEl();

                    //////////

                    init();

                    /**
                     * Initialize
                     */
                    function init()
                    {
                        // Check if the timeline item has ms-card
                        if ( iElement.find('ms-card') )
                        {
                            // If the ms-card template loaded...
                            scope.$on('msCard::cardTemplateLoaded', function (event, args)
                            {
                                var cardEl = angular.element(args[0]);

                                // Test the card to see if there is any image on it
                                testForImage(cardEl).then(function ()
                                {
                                    $timeout(function ()
                                    {
                                        itemLoaded = true;
                                    });
                                });
                            });
                        }
                        else
                        {
                            // Test the element to see if there is any image on it
                            testForImage(iElement).then(function ()
                            {
                                $timeout(function ()
                                {
                                    itemLoaded = true;
                                });
                            });
                        }

                        // Check if the loaded element also in the viewport
                        scrollEl.on('scroll', testForVisibility);

                        // Test for visibility for the first time without waiting for the scroll event
                        testForVisibility();
                    }

                    // Item ready watcher
                    var itemReadyWatcher = scope.$watch(
                        function ()
                        {
                            return itemLoaded && itemInViewport;
                        },
                        function (current, old)
                        {
                            if ( angular.equals(current, old) )
                            {
                                return;
                            }

                            if ( current )
                            {
                                iElement.removeClass('hidden').addClass('animate');

                                // Unbind itemReadyWatcher
                                itemReadyWatcher();
                            }
                        }, true);

                    /**
                     * Test the given element for image
                     *
                     * @param element
                     * @returns promise
                     */
                    function testForImage(element)
                    {
                        var deferred = $q.defer(),
                            imgEl = element.find('img');

                        if ( imgEl.length > 0 )
                        {
                            imgEl.on('load', function ()
                            {
                                deferred.resolve('Image is loaded');
                            });
                        }
                        else
                        {
                            deferred.resolve('No images');
                        }

                        return deferred.promise;
                    }

                    /**
                     * Test the element for visibility
                     */
                    function testForVisibility()
                    {
                        if ( scrollEl.scrollTop() + scrollEl.height() > iElement.position().top + threshold )
                        {
                            $timeout(function ()
                            {
                                itemInViewport = true;
                            });

                            // Unbind the scroll event
                            scrollEl.off('scroll', testForVisibility);
                        }
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsStepperController', MsStepperController)
        .directive('msHorizontalStepper', msHorizontalStepperDirective)
        .directive('msHorizontalStepperStep', msHorizontalStepperStepDirective)
        .directive('msVerticalStepper', msVerticalStepperDirective)
        .directive('msVerticalStepperStep', msVerticalStepperStepDirective);

    /** @ngInject */
    function MsStepperController($timeout)
    {
        var vm = this;

        // Data
        vm.mainForm = undefined;

        vm.orientation = 'horizontal';
        vm.steps = [];
        vm.currentStep = undefined;
        vm.currentStepNumber = 1;

        // Methods
        vm.setOrientation = setOrientation;
        vm.registerMainForm = registerMainForm;
        vm.registerStep = registerStep;
        vm.setupSteps = setupSteps;
        vm.resetForm = resetForm;

        vm.setCurrentStep = setCurrentStep;

        vm.gotoStep = gotoStep;
        vm.gotoPreviousStep = gotoPreviousStep;
        vm.gotoNextStep = gotoNextStep;
        vm.gotoFirstStep = gotoFirstStep;
        vm.gotoLastStep = gotoLastStep;
        vm.toggleStep = toggleStep;

        vm.isFirstStep = isFirstStep;
        vm.isLastStep = isLastStep;

        vm.isStepCurrent = isStepCurrent;
        vm.isStepDisabled = isStepDisabled;
        vm.isStepOptional = isStepOptional;
        vm.isStepHidden = isStepHidden;
        vm.filterHiddenStep = filterHiddenStep;
        vm.isStepValid = isStepValid;
        vm.isStepNumberValid = isStepNumberValid;

        vm.isFormValid = isFormValid;

        //////////

        function refreshDisplayNumber(){
            var displayNumber = 1;
            vm.steps.forEach(function(step){
                if(!step.isHidden){
                    step.displayNumber = displayNumber;
                    displayNumber++;
                }
            });
        }

        function toggleStep(title, visibility){
            const step = vm.steps.find(function(step){
                return step.stepTitle == title;
            });

            if(!step){
                return;
            }

            if(typeof(visibility) == "boolean"){
                step.isHidden = !visibility;
            } else {
                step.isHidden = !step.isHidden;
            }

            if(step.isHidden && vm.currentStepNumber == step.stepNumber){
                gotoPreviousStep();
            }

            refreshDisplayNumber();
        }

        /**
         * Set the orientation of the stepper
         *
         * @param orientation
         */
        function setOrientation(orientation)
        {
            vm.orientation = orientation || 'horizontal';
        }

        /**
         * Register the main form
         *
         * @param form
         */
        function registerMainForm(form)
        {
            vm.mainForm = form;
        }

        /**
         * Register a step
         *
         * @param element
         * @param scope
         * @param form
         */
        function registerStep(element, scope, form)
        {	
        	/* if(scope.hideStep == true){
        		return
        	} */

            var step = {
                element           : element,
                scope             : scope,
                form              : form,
                stepNumber        : scope.step || (vm.steps.length + 1),
                stepTitle         : scope.stepTitle,
                stepTitleTranslate: scope.stepTitleTranslate,
                hideActionButtons : scope.hideActionButtons,
                onStepChange	  : scope.onStepChange,
                isHidden          : scope.isHidden
            };

            // Push the step into steps array
            vm.steps.push(step);

            // Sort steps by stepNumber
            vm.steps.sort(function (a, b)
            {
                return a.stepNumber - b.stepNumber;
            });

            toggleStep(step.stepTitle, !scope.hideStep);
            //refreshDisplayNumber();

            return step;
        }

        /**
         * Setup steps for the first time
         */
        function setupSteps()
        {
            vm.setCurrentStep(vm.currentStepNumber);
        }

        /**
         * Reset steps and the main form
         */
        function resetForm()
        {
/*            // Timeout is required here because we need to
            // let form model to reset before setting the
            // statuses
            $timeout(function ()
            {
                // Reset all the steps
                for ( var x = 0; x < vm.steps.length; x++ )
                {
                    vm.steps[x].form.$setPristine();
                    vm.steps[x].form.$setUntouched();
                }

                // Reset the main form
                vm.mainForm.$setPristine();
                vm.mainForm.$setUntouched();

                // Go to first step
                gotoFirstStep();
            });*/
        }

        /**
         * Set current step
         *
         * @param stepNumber
         */
        function setCurrentStep(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return;
            }

            // Update the current step number
            vm.currentStepNumber = stepNumber;

            if ( vm.orientation === 'horizontal' )
            {
                // Hide all steps
                for ( var i = 0; i < vm.steps.length; i++ )
                {
                    vm.steps[i].element.hide();
                }

                // Show the current step
                vm.steps[vm.currentStepNumber - 1].element.show();
            }
            else if ( vm.orientation === 'vertical' )
            {
                // Hide all step content
                for ( var j = 0; j < vm.steps.length; j++ )
                {
                    vm.steps[j].element.find('.ms-stepper-step-content').hide();
                }

                // Show the current step content
                vm.steps[vm.currentStepNumber - 1].element.find('.ms-stepper-step-content').show();
            }

            const currentStep = vm.steps[vm.currentStepNumber - 1];

            if(currentStep && typeof(currentStep.onStepChange) == "function"){
            	currentStep.onStepChange(currentStep);
            }
        }

        /**
         * Go to a step
         *
         * @param stepNumber
         */
        function gotoStep(stepNumber)
        {
            // If the step we are about to go
            // is hidden, bail...
            if ( isStepHidden(stepNumber) )
            {
                return;
            }

            vm.setCurrentStep(stepNumber);
        }

        /**
         * Go to the previous step
         */
        function gotoPreviousStep()
        {
            var stepNumber = vm.currentStepNumber - 1;

            // Test the previous steps and make sure we
            // will land to the one that is not hidden
            for ( var s = stepNumber; s >= 1; s-- )
            {
                if ( !isStepHidden(s) )
                {
                    stepNumber = s;
                    break;
                }
            }

            vm.setCurrentStep(stepNumber);
        }

        /**
         * Go to the next step
         */
        function gotoNextStep()
        {
            var stepNumber = vm.currentStepNumber + 1;

            // Test the following steps and make sure we
            // will land to the one that is not hidden
            for ( var s = stepNumber; s <= vm.steps.length; s++ )
            {
                if ( !isStepHidden(s) )
                {
                    stepNumber = s;
                    break;
                }
            }

            vm.setCurrentStep(stepNumber);
        }

        /**
         * Go to the first step
         */
        function gotoFirstStep()
        {
            vm.setCurrentStep(1);
        }

        /**
         * Go to the last step
         */
        function gotoLastStep()
        {
            vm.setCurrentStep(vm.steps.length);
        }

        /**
         * Check if the current step is the first step
         *
         * @returns {boolean}
         */
        function isFirstStep()
        {
            return vm.currentStepNumber === 1;
        }

        /**
         * Check if the current step is the last step
         *
         * @returns {boolean}
         */
        function isLastStep()
        {
            return vm.currentStepNumber === vm.steps.length;
        }

        /**
         * Check if the given step is the current one
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepCurrent(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            return vm.currentStepNumber === stepNumber;
        }

        /**
         * Check if the given step should be disabled
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepDisabled(stepNumber,step)
        {	

            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            var disabled = false;

            for ( var i = 1; i < stepNumber; i++ )
            {
                if ( !isStepValid(i) )
                {
                    disabled = true;
                    break;
                }
            }

            return disabled;
        }

        /**
         * Check if the given step is optional
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepOptional(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            return vm.steps[stepNumber - 1].scope.optionalStep;
        }

        /**
         * Check if the given step is hidden
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepHidden(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            return !!vm.steps[stepNumber - 1].scope.hideStep || vm.steps[stepNumber - 1].isHidden;
        }

        /**
         * Check if the given step is hidden as a filter
         *
         * @param step
         * @returns {boolean}
         */
        function filterHiddenStep(step)
        {
            return !isStepHidden(step.stepNumber);
        }

        /**
         * Check if the given step is valid
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepValid(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            // If the step is optional, always return true
            if ( isStepOptional(stepNumber) )
            {
                return true;
            }

            return vm.steps[stepNumber - 1].form.$valid;
        }

        /**
         * Check if the given step number is a valid step number
         *
         * @param stepNumber
         * @returns {boolean}
         */
        function isStepNumberValid(stepNumber)
        {
            return !(angular.isUndefined(stepNumber) || stepNumber < 1 || stepNumber > vm.steps.length);
        }

        /**
         * Check if the entire form is valid
         *
         * @returns {boolean}
         */
        function isFormValid()
        {
            return vm.mainForm.$valid;
        }
    }

    /** @ngInject */
    function msHorizontalStepperDirective()
    {
        return {
            restrict        : 'A',
            scope           : {},
            require         : ['form', 'msHorizontalStepper'],
            priority        : 1001,
            controller      : 'MsStepperController as MsStepper',
            bindToController: {
                model: '=ngModel'
            },
            transclude      : true,
            templateUrl     : 'app/core/directives/ms-stepper/templates/horizontal/horizontal.html',
            compile         : function (tElement)
            {
                tElement.addClass('ms-stepper');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Register the main form and setup
                    // the steps for the first time
                    MsStepperCtrl.setOrientation('horizontal');
                    MsStepperCtrl.registerMainForm(FormCtrl);
                    MsStepperCtrl.setupSteps();
                };
            }
        };
    }

    /** @ngInject */
    function msHorizontalStepperStepDirective()
    {	
    	var directiveController;

        return {
            restrict: 'EA',
            require : ['form', '^msHorizontalStepper'],
            priority: 1000,
            scope   : {
                step              : '=?',
                stepTitle         : '=?',
                stepTitleTranslate: '=?',
                optionalStep      : '=?',
                hideStep          : '=?',
                stepperApi        : '=?',
                hideActionButtons : '=?',
                onStepChange 	  : '=?'
            },
            controller: function($scope) {
            	var api = {};//this; // Instead of adding methods to the $scope (which you still can), add them to the this object
        	
		        api.goToNextStep = function() {
		        	directiveController.gotoNextStep();
		        };

		        api.goToPreviousStep = function() {
		        	directiveController.gotoPreviousStep();
                };
                
                api.toggleStep = function(title, visibility) {
		        	directiveController.toggleStep(title, visibility);
		        };

		        api.isLastStep = function() {
		        	return directiveController.isLastStep();
                };
		        $scope.stepperApi = api;
	        },
            compile : function (tElement)
            {
                tElement.addClass('ms-stepper-step');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {	
                    var FormCtrl = ctrls[0],
                    MsStepperCtrl = ctrls[1];

                    directiveController = MsStepperCtrl;

                    // Is it an optional step?
                    scope.optionalStep = angular.isDefined(iAttrs.optionalStep);

                    // Register the step
                    MsStepperCtrl.registerStep(iElement, scope, FormCtrl);

                    // Hide the step by default
                    iElement.hide();
                };
            }
        };
    }

    /** @ngInject */
    function msVerticalStepperDirective($timeout)
    {
        return {
            restrict        : 'A',
            scope           : {},
            require         : ['form', 'msVerticalStepper'],
            priority        : 1001,
            controller      : 'MsStepperController as MsStepper',
            bindToController: {
                model: '=ngModel'
            },
            transclude      : true,
            templateUrl     : 'app/core/directives/ms-stepper/templates/vertical/vertical.html',
            compile         : function (tElement)
            {
                tElement.addClass('ms-stepper');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Register the main form and setup
                    // the steps for the first time

                    // Timeout is required in vertical stepper
                    // as we are using transclusion in steps.
                    // We have to wait for them to be transcluded
                    // and registered to the controller
                    $timeout(function ()
                    {
                        MsStepperCtrl.setOrientation('vertical');
                        MsStepperCtrl.registerMainForm(FormCtrl);
                        MsStepperCtrl.setupSteps();
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msVerticalStepperStepDirective()
    {
        return {
            restrict   : 'E',
            require    : ['form', '^msVerticalStepper'],
            priority   : 1000,
            scope      : {
                step              : '=?',
                stepTitle         : '=?',
                stepTitleTranslate: '=?',
                optionalStep      : '=?',
                hideStep          : '=?'
            },
            transclude : true,
            templateUrl: 'app/core/directives/ms-stepper/templates/vertical/step/vertical-step.html',
            compile    : function (tElement)
            {
                tElement.addClass('ms-stepper-step');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Is it an optional step?
                    scope.optionalStep = angular.isDefined(iAttrs.optionalStep);

                    // Register the step
                    scope.stepInfo = MsStepperCtrl.registerStep(iElement, scope, FormCtrl);

                    // Expose the controller to the scope
                    scope.MsStepper = MsStepperCtrl;

                    // Hide the step content by default
                    iElement.find('.ms-stepper-step-content').hide();
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msSplashScreen', msSplashScreenDirective);

    /** @ngInject */
    function msSplashScreenDirective($animate)
    {
        return {
            restrict: 'E',
            link    : function (scope, iElement)
            {
                var splashScreenRemoveEvent = scope.$on('msSplashScreen::remove', function ()
                {
                    $animate.leave(iElement).then(function ()
                    {
                        // De-register scope event
                        splashScreenRemoveEvent();

                        // Null-ify everything else
                        scope = iElement = null;
                    });
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msSidenavHelper', msSidenavHelperDirective);

    /** @ngInject */
    function msSidenavHelperDirective()
    {
        return {
            restrict: 'A',
            require : '^mdSidenav',
            link    : function (scope, iElement, iAttrs, MdSidenavCtrl)
            {
                // Watch md-sidenav open & locked open statuses
                // and add class to the ".page-layout" if only
                // the sidenav open and NOT locked open
                scope.$watch(function ()
                {
                    return MdSidenavCtrl.isOpen() && !MdSidenavCtrl.isLockedOpen();
                }, function (current)
                {
                    if ( angular.isUndefined(current) )
                    {
                        return;
                    }

                    iElement.parent().toggleClass('full-height', current);
                    angular.element('html').toggleClass('sidenav-open', current);
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsShortcutsController', MsShortcutsController)
        .directive('msShortcuts', msShortcutsDirective);

    /** @ngInject */
    function MsShortcutsController($scope, $cookies, $document, $timeout, $q, msNavigationService)
    {
        var vm = this;

        // Data
        vm.query = '';
        vm.queryOptions = {
            debounce: 300
        };
        vm.resultsLoading = false;
        vm.selectedResultIndex = 0;
        vm.ignoreMouseEvents = false;
        vm.mobileBarActive = false;

        vm.results = null;
        vm.shortcuts = [];

        vm.sortableOptions = {
            ghostClass   : 'ghost',
            forceFallback: true,
            fallbackClass: 'dragging',
            onSort       : function ()
            {
                vm.saveShortcuts();
            }
        };

        // Methods
        vm.populateResults = populateResults;
        vm.loadShortcuts = loadShortcuts;
        vm.saveShortcuts = saveShortcuts;
        vm.addShortcut = addShortcut;
        vm.removeShortcut = removeShortcut;
        vm.handleResultClick = handleResultClick;

        vm.absorbEvent = absorbEvent;
        vm.handleKeydown = handleKeydown;
        vm.handleMouseenter = handleMouseenter;
        vm.temporarilyIgnoreMouseEvents = temporarilyIgnoreMouseEvents;
        vm.ensureSelectedResultIsVisible = ensureSelectedResultIsVisible;
        vm.toggleMobileBar = toggleMobileBar;

        //////////

        init();

        function init()
        {
            // Load the shortcuts
            vm.loadShortcuts().then(
                // Success
                function (response)
                {
                    vm.shortcuts = response;

                    // Add shortcuts as results by default
                    if ( vm.shortcuts.length > 0 )
                    {
                        vm.results = response;
                    }
                }
            );

            // Watch the model changes to trigger the search
            $scope.$watch('MsShortcuts.query', function (current, old)
            {
                if ( angular.isUndefined(current) )
                {
                    return;
                }

                if ( angular.equals(current, old) )
                {
                    return;
                }

                // Show the loader
                vm.resultsLoading = true;

                // Populate the results
                vm.populateResults().then(
                    // Success
                    function (response)
                    {
                        vm.results = response;
                    },
                    // Error
                    function ()
                    {
                        vm.results = [];
                    }
                ).finally(
                    function ()
                    {
                        // Hide the loader
                        vm.resultsLoading = false;
                    }
                );
            });
        }

        /**
         * Populate the results
         */
        function populateResults()
        {
            var results = [],
                flatNavigation = msNavigationService.getFlatNavigation(),
                deferred = $q.defer();

            // Iterate through the navigation array and
            // make sure it doesn't have any groups or
            // none ui-sref items
            for ( var x = 0; x < flatNavigation.length; x++ )
            {
                if ( flatNavigation[x].uisref )
                {
                    results.push(flatNavigation[x]);
                }
            }

            // If there is a query, filter the results
            if ( vm.query )
            {
                results = results.filter(function (item)
                {
                    if ( angular.lowercase(item.title).search(angular.lowercase(vm.query)) > -1 )
                    {
                        return true;
                    }
                });

                // Iterate through one last time and
                // add required properties to items
                for ( var i = 0; i < results.length; i++ )
                {
                    // Add false to hasShortcut by default
                    results[i].hasShortcut = false;

                    // Test if the item is in the shortcuts list
                    for ( var y = 0; y < vm.shortcuts.length; y++ )
                    {
                        if ( vm.shortcuts[y]._id === results[i]._id )
                        {
                            results[i].hasShortcut = true;
                            break;
                        }
                    }
                }
            }
            else
            {
                // If the query is empty, that means
                // there is nothing to search for so
                // we will populate the results with
                // current shortcuts if there is any
                if ( vm.shortcuts.length > 0 )
                {
                    results = vm.shortcuts;
                }
            }

            // Reset the selected result
            vm.selectedResultIndex = 0;

            // Fake the service delay
            $timeout(function ()
            {
                // Resolve the promise
                deferred.resolve(results);
            }, 250);

            // Return a promise
            return deferred.promise;
        }

        /**
         * Load shortcuts
         */
        function loadShortcuts()
        {
            var deferred = $q.defer();

            // For the demo purposes, we will
            // load the shortcuts from the cookies.
            // But here you can make an API call
            // to load them from the DB.
            var shortcuts = angular.fromJson($cookies.get('FUSE.shortcuts'));

            // No cookie available. Generate one
            // for the demo purposes...
            if ( angular.isUndefined(shortcuts) )
            {
                shortcuts = [
                    {
                        'title'      : 'Sample',
                        'icon'       : 'icon-tile-four',
                        'state'      : 'app.sample',
                        'weight'     : 1,
                        'children'   : [],
                        '_id'        : 'sample',
                        '_path'      : 'apps.sample',
                        'uisref'     : 'app.sample',
                        'hasShortcut': true
                    }
                ];

                $cookies.put('FUSE.shortcuts', angular.toJson(shortcuts));
            }

            // Resolve the promise
            deferred.resolve(shortcuts);

            return deferred.promise;
        }

        /**
         * Save the shortcuts
         */
        function saveShortcuts()
        {
            var deferred = $q.defer();

            // For the demo purposes, we will
            // keep the shortcuts in the cookies.
            // But here you can make an API call
            // to save them to the DB.
            $cookies.put('FUSE.shortcuts', angular.toJson(vm.shortcuts));

            // Fake the service delay
            $timeout(function ()
            {
                deferred.resolve({'success': true});
            }, 250);

            return deferred.promise;
        }

        /**
         * Add item as shortcut
         *
         * @param item
         */
        function addShortcut(item)
        {
            // Update the hasShortcut status
            item.hasShortcut = true;

            // Add as a shortcut
            vm.shortcuts.push(item);

            // Save the shortcuts
            vm.saveShortcuts();
        }

        /**
         * Remove item from shortcuts
         *
         * @param item
         */
        function removeShortcut(item)
        {
            // Update the hasShortcut status
            item.hasShortcut = false;

            // Remove the shortcut
            for ( var x = 0; x < vm.shortcuts.length; x++ )
            {
                if ( vm.shortcuts[x]._id === item._id )
                {
                    // Remove the x-th item from the array
                    vm.shortcuts.splice(x, 1);

                    // If we aren't searching for anything...
                    if ( !vm.query )
                    {
                        // If all the shortcuts have been removed,
                        // null-ify the results
                        if ( vm.shortcuts.length === 0 )
                        {
                            vm.results = null;
                        }
                        // Otherwise update the selected index
                        else
                        {
                            if ( x >= vm.shortcuts.length )
                            {
                                vm.selectedResultIndex = vm.shortcuts.length - 1;
                            }
                        }
                    }
                }
            }

            // Save the shortcuts
            vm.saveShortcuts();
        }

        /**
         * Handle the result click
         *
         * @param item
         */
        function handleResultClick(item)
        {
            // Add or remove the shortcut
            if ( item.hasShortcut )
            {
                vm.removeShortcut(item);
            }
            else
            {
                vm.addShortcut(item);
            }
        }

        /**
         * Absorb the given event
         *
         * @param event
         */
        function absorbEvent(event)
        {
            event.preventDefault();
        }

        /**
         * Handle keydown
         *
         * @param event
         */
        function handleKeydown(event)
        {
            var keyCode = event.keyCode,
                keys = [38, 40];

            // Prevent the default action if
            // one of the keys are pressed that
            // we are listening
            if ( keys.indexOf(keyCode) > -1 )
            {
                event.preventDefault();
            }

            switch ( keyCode )
            {
                // Enter
                case 13:

                    // Trigger result click
                    vm.handleResultClick(vm.results[vm.selectedResultIndex]);

                    break;

                // Up Arrow
                case 38:

                    // Decrease the selected result index
                    if ( vm.selectedResultIndex - 1 >= 0 )
                    {
                        // Decrease the selected index
                        vm.selectedResultIndex--;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                // Down Arrow
                case 40:

                    // Increase the selected result index
                    if ( vm.selectedResultIndex + 1 < vm.results.length )
                    {
                        // Increase the selected index
                        vm.selectedResultIndex++;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                default:
                    break;
            }
        }

        /**
         * Handle mouseenter
         *
         * @param index
         */
        function handleMouseenter(index)
        {
            if ( vm.ignoreMouseEvents )
            {
                return;
            }

            // Update the selected result index
            // with the given index
            vm.selectedResultIndex = index;
        }

        /**
         * Set a variable for a limited time
         * to make other functions to ignore
         * the mouse events
         */
        function temporarilyIgnoreMouseEvents()
        {
            // Set the variable
            vm.ignoreMouseEvents = true;

            // Cancel the previous timeout
            $timeout.cancel(vm.mouseEventIgnoreTimeout);

            // Set the timeout
            vm.mouseEventIgnoreTimeout = $timeout(function ()
            {
                vm.ignoreMouseEvents = false;
            }, 250);
        }

        /**
         * Ensure the selected result will
         * always be visible on the results
         * area
         */
        function ensureSelectedResultIsVisible()
        {
            var resultsEl = $document.find('#ms-shortcut-add-menu').find('.results'),
                selectedItemEl = angular.element(resultsEl.find('.result')[vm.selectedResultIndex]);

            if ( resultsEl && selectedItemEl )
            {
                var top = selectedItemEl.position().top - 8,
                    bottom = selectedItemEl.position().top + selectedItemEl.outerHeight() + 8;

                // Start ignoring mouse events
                vm.temporarilyIgnoreMouseEvents();

                if ( resultsEl.scrollTop() > top )
                {
                    resultsEl.scrollTop(top);
                }

                if ( bottom > (resultsEl.height() + resultsEl.scrollTop()) )
                {
                    resultsEl.scrollTop(bottom - resultsEl.height());
                }
            }
        }

        /**
         * Toggle mobile bar
         */
        function toggleMobileBar()
        {
            vm.mobileBarActive = !vm.mobileBarActive;
        }
    }

    /** @ngInject */
    function msShortcutsDirective()
    {
        return {
            restrict        : 'E',
            scope           : {},
            require         : 'msShortcuts',
            controller      : 'MsShortcutsController as MsShortcuts',
            bindToController: {},
            templateUrl     : 'app/core/directives/ms-shortcuts/ms-shortcuts.html',
            compile         : function (tElement)
            {
                // Add class
                tElement.addClass('ms-shortcuts');

                return function postLink(scope, iElement)
                {
                    // Data

                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsSearchBarController', MsSearchBarController)
        .directive('msSearchBar', msSearchBarDirective);

    /** @ngInject */
    function MsSearchBarController($scope, $element, $timeout)
    {
        var vm = this;

        // Data
        vm.collapsed = true;
        vm.query = '';
        vm.queryOptions = {
            debounce: vm.debounce || 0
        };
        vm.resultsLoading = false;
        vm.results = null;
        vm.selectedResultIndex = 0;
        vm.ignoreMouseEvents = false;

        // Methods
        vm.populateResults = populateResults;

        vm.expand = expand;
        vm.collapse = collapse;

        vm.absorbEvent = absorbEvent;
        vm.handleKeydown = handleKeydown;
        vm.handleMouseenter = handleMouseenter;
        vm.temporarilyIgnoreMouseEvents = temporarilyIgnoreMouseEvents;
        vm.handleResultClick = handleResultClick;
        vm.ensureSelectedResultIsVisible = ensureSelectedResultIsVisible;

        //////////

        init();

        function init()
        {
            // Watch the model changes to trigger the search
            $scope.$watch('MsSearchBar.query', function (current, old)
            {
                if ( angular.isUndefined(current) )
                {
                    return;
                }

                if ( angular.equals(current, old) )
                {
                    return;
                }

                if ( vm.collapsed )
                {
                    return;
                }

                // Evaluate the onSearch function to access the
                // function itself
                var onSearchEvaluated = $scope.$parent.$eval(vm.onSearch, {query: current}),
                    isArray = angular.isArray(onSearchEvaluated),
                    isPromise = (onSearchEvaluated && !!onSearchEvaluated.then);

                if ( isArray )
                {
                    // Populate the results
                    vm.populateResults(onSearchEvaluated);
                }

                if ( isPromise )
                {
                    // Show the loader
                    vm.resultsLoading = true;

                    onSearchEvaluated.then(
                        // Success
                        function (response)
                        {
                            // Populate the results
                            vm.populateResults(response);
                        },
                        // Error
                        function ()
                        {
                            // Assign an empty array to show
                            // the no-results screen
                            vm.populateResults([]);
                        }
                    ).finally(function ()
                        {
                            // Hide the loader
                            vm.resultsLoading = false;
                        }
                    );
                }
            });
        }

        /**
         * Populate the results
         *
         * @param results
         */
        function populateResults(results)
        {
            // Before doing anything,
            // make sure the search bar is expanded
            if ( vm.collapsed )
            {
                return;
            }

            var isArray = angular.isArray(results),
                isNull = results === null;

            // Only accept arrays and null values
            if ( !isArray && !isNull )
            {
                return;
            }

            // Reset the selected result
            vm.selectedResultIndex = 0;

            // Populate the results
            vm.results = results;
        }

        /**
         * Expand
         */
        function expand()
        {
            // Set collapsed status
            vm.collapsed = false;

            // Call expand on scope
            $scope.expand();

            // Callback
            if ( vm.onExpand && angular.isFunction(vm.onExpand) )
            {
                vm.onExpand();
            }
        }

        /**
         * Collapse
         */
        function collapse()
        {
            // Empty the query
            vm.query = '';

            // Empty results to hide the results view
            vm.populateResults(null);

            // Set collapsed status
            vm.collapsed = true;

            // Call collapse on scope
            $scope.collapse();

            // Callback
            if ( vm.onCollapse && angular.isFunction(vm.onCollapse) )
            {
                vm.onCollapse();
            }
        }

        /**
         * Absorb the given event
         *
         * @param event
         */
        function absorbEvent(event)
        {
            event.preventDefault();
        }

        /**
         * Handle keydown
         *
         * @param event
         */
        function handleKeydown(event)
        {
            var keyCode = event.keyCode,
                keys = [27, 38, 40];

            // Prevent the default action if
            // one of the keys are pressed that
            // we are listening
            if ( keys.indexOf(keyCode) > -1 )
            {
                event.preventDefault();
            }

            switch ( keyCode )
            {
                // Enter
                case 13:

                    // Trigger result click
                    vm.handleResultClick(vm.results[vm.selectedResultIndex]);

                    break;

                // Escape
                case 27:

                    // Collapse the search bar
                    vm.collapse();

                    break;

                // Up Arrow
                case 38:

                    // Decrease the selected result index
                    if ( vm.selectedResultIndex - 1 >= 0 )
                    {
                        // Decrease the selected index
                        vm.selectedResultIndex--;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                // Down Arrow
                case 40:

                    if ( !vm.results )
                    {
                        return;
                    }

                    // Increase the selected result index
                    if ( vm.selectedResultIndex + 1 < vm.results.length )
                    {
                        // Increase the selected index
                        vm.selectedResultIndex++;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                default:
                    break;
            }
        }

        /**
         * Handle mouseenter
         *
         * @param index
         */
        function handleMouseenter(index)
        {
            if ( vm.ignoreMouseEvents )
            {
                return;
            }

            // Update the selected result index
            // with the given index
            vm.selectedResultIndex = index;
        }

        /**
         * Set a variable for a limited time
         * to make other functions to ignore
         * the mouse events
         */
        function temporarilyIgnoreMouseEvents()
        {
            // Set the variable
            vm.ignoreMouseEvents = true;

            // Cancel the previous timeout
            $timeout.cancel(vm.mouseEventIgnoreTimeout);

            // Set the timeout
            vm.mouseEventIgnoreTimeout = $timeout(function ()
            {
                vm.ignoreMouseEvents = false;
            }, 250);
        }

        /**
         * Handle the result click
         *
         * @param item
         */
        function handleResultClick(item)
        {
            if ( vm.onResultClick )
            {
                vm.onResultClick({item: item});
            }

            // Collapse the search bar
            vm.collapse();
        }

        /**
         * Ensure the selected result will
         * always be visible on the results
         * area
         */
        function ensureSelectedResultIsVisible()
        {
            var resultsEl = $element.find('.ms-search-bar-results'),
                selectedItemEl = angular.element(resultsEl.find('.result')[vm.selectedResultIndex]);

            if ( resultsEl && selectedItemEl )
            {
                var top = selectedItemEl.position().top - 8,
                    bottom = selectedItemEl.position().top + selectedItemEl.outerHeight() + 8;

                // Start ignoring mouse events
                vm.temporarilyIgnoreMouseEvents();

                if ( resultsEl.scrollTop() > top )
                {
                    resultsEl.scrollTop(top);
                }

                if ( bottom > (resultsEl.height() + resultsEl.scrollTop()) )
                {
                    resultsEl.scrollTop(bottom - resultsEl.height());
                }
            }
        }
    }

    /** @ngInject */
    function msSearchBarDirective($document)
    {
        return {
            restrict        : 'E',
            scope           : {},
            require         : 'msSearchBar',
            controller      : 'MsSearchBarController as MsSearchBar',
            bindToController: {
                debounce     : '=?',
                onSearch     : '@',
                onResultClick: '&?',
                onExpand     : '&?',
                onCollapse   : '&?'
            },
            templateUrl     : 'app/core/directives/ms-search-bar/ms-search-bar.html',
            compile         : function (tElement)
            {
                // Add class
                tElement.addClass('ms-search-bar');

                return function postLink(scope, iElement)
                {
                    // Data
                    var inputEl,
                        bodyEl = $document.find('body');

                    // Methods
                    scope.collapse = collapse;
                    scope.expand = expand;

                    //////////

                    // Initialize
                    init();

                    /**
                     * Initialize
                     */
                    function init()
                    {
                        // Grab the input element
                        inputEl = iElement.find('#ms-search-bar-input');
                    }

                    /**
                     * Expand action
                     */
                    function expand()
                    {
                        // Add expanded class
                        iElement.addClass('expanded');

                        // Add helper class to the body
                        bodyEl.addClass('ms-search-bar-expanded');

                        // Focus on the input
                        inputEl.focus();
                    }

                    /**
                     * Collapse action
                     */
                    function collapse()
                    {
                        // Remove expanded class
                        iElement.removeClass('expanded');

                        // Remove helper class from the body
                        bodyEl.removeClass('ms-search-bar-expanded');
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msScrollConfig', msScrollConfigProvider)
        .directive('msScroll', msScrollDirective);

    /** @ngInject */
    function msScrollConfigProvider()
    {
        // Default configuration
        var defaultConfiguration = {
            wheelSpeed            : 1,
            wheelPropagation      : false,
            swipePropagation      : true,
            minScrollbarLength    : null,
            maxScrollbarLength    : null,
            useBothWheelAxes      : false,
            useKeyboard           : true,
            suppressScrollX       : false,
            suppressScrollY       : false,
            scrollXMarginOffset   : 0,
            scrollYMarginOffset   : 0,
            stopPropagationOnClick: true
        };

        // Methods
        this.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            defaultConfiguration = angular.extend({}, defaultConfiguration, configuration);
        }

        /**
         * Service
         */
        this.$get = function ()
        {
            var service = {
                getConfig: getConfig
            };

            return service;

            //////////

            /**
             * Return the config
             */
            function getConfig()
            {
                return defaultConfiguration;
            }
        };
    }

    /** @ngInject */
    function msScrollDirective($timeout, msScrollConfig, msUtils, fuseConfig)
    {
        return {
            restrict: 'AE',
            compile : function (tElement)
            {
                // Do not replace scrollbars if
                // 'disableCustomScrollbars' config enabled
                if ( fuseConfig.getConfig('disableCustomScrollbars') )
                {
                    return;
                }

                // Do not replace scrollbars on mobile devices
                // if 'disableCustomScrollbarsOnMobile' config enabled
                if ( fuseConfig.getConfig('disableCustomScrollbarsOnMobile') && msUtils.isMobile() )
                {
                    return;
                }

                // Add class
                tElement.addClass('ms-scroll');

                return function postLink(scope, iElement, iAttrs)
                {
                    var options = {};

                    // If options supplied, evaluate the given
                    // value. This is because we don't want to
                    // have an isolated scope but still be able
                    // to use scope variables.
                    // We don't want an isolated scope because
                    // we should be able to use this everywhere
                    // especially with other directives
                    if ( iAttrs.msScroll )
                    {
                        options = scope.$eval(iAttrs.msScroll);
                    }

                    // Extend the given config with the ones from provider
                    options = angular.extend({}, msScrollConfig.getConfig(), options);

                    // Initialize the scrollbar
                    $timeout(function ()
                    {
                        PerfectScrollbar.initialize(iElement[0], options);
                    }, 0);

                    // Update the scrollbar on element mouseenter
                    iElement.on('mouseenter', updateScrollbar);

                    // Watch scrollHeight and update
                    // the scrollbar if it changes
                    scope.$watch(function ()
                    {
                        return iElement.prop('scrollHeight');
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        updateScrollbar();
                    });

                    // Watch scrollWidth and update
                    // the scrollbar if it changes
                    scope.$watch(function ()
                    {
                        return iElement.prop('scrollWidth');
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        updateScrollbar();
                    });

                    /**
                     * Update the scrollbar
                     */
                    function updateScrollbar()
                    {
                        PerfectScrollbar.update(iElement[0]);
                    }

                    // Cleanup on destroy
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('mouseenter');
                        PerfectScrollbar.destroy(iElement[0]);
                    });
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msResponsiveTable', msResponsiveTableDirective);

    /** @ngInject */
    function msResponsiveTableDirective()
    {
        return {
            restrict: 'A',
            link    : function (scope, iElement)
            {
                // Wrap the table
                var wrapper = angular.element('<div class="ms-responsive-table-wrapper"></div>');
                iElement.after(wrapper);
                wrapper.append(iElement);

                //////////
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msNavigationService', msNavigationServiceProvider)
        .controller('MsNavigationController', MsNavigationController)
        // Vertical
        .directive('msNavigation', msNavigationDirective)
        .controller('MsNavigationNodeController', MsNavigationNodeController)
        .directive('msNavigationNode', msNavigationNodeDirective)
        .directive('msNavigationItem', msNavigationItemDirective)
        //Horizontal
        .directive('msNavigationHorizontal', msNavigationHorizontalDirective)
        .controller('MsNavigationHorizontalNodeController', MsNavigationHorizontalNodeController)
        .directive('msNavigationHorizontalNode', msNavigationHorizontalNodeDirective)
        .directive('msNavigationHorizontalItem', msNavigationHorizontalItemDirective);

    /** @ngInject */
    function msNavigationServiceProvider($stateProvider)
    {
        // Inject $log service
        var $log = angular.injector(['ng']).get('$log');

        // Navigation array
        var navigation = [];

        var service = this;

        // Methods
        service.saveItem = saveItem;
        service.deleteItem = deleteItem;
        service.sortByWeight = sortByWeight;

        //////////

        /**
         * Create or update the navigation item
         *
         * @param path
         * @param item
         */
        function saveItem(path, item)
        {
            if ( !angular.isString(path) )
            {
                $log.error('path must be a string (eg. `dashboard.project`)');
                return;
            }

            var parts = path.split('.');

            // Generate the object id from the parts
            var id = parts[parts.length - 1];

            // Get the parent item from the parts
            var parent = _findOrCreateParent(parts);

            // Decide if we are going to update or create
            var updateItem = false;

            for ( var i = 0; i < parent.length; i++ )
            {
                if ( parent[i]._id === id )
                {
                    updateItem = parent[i];

                    break;
                }
            }

            // Update
            if ( updateItem )
            {
                angular.extend(updateItem, item);

                // Add proper ui-sref
                updateItem.uisref = _getUiSref(updateItem);
            }
            // Create
            else
            {
                // Create an empty children array in the item
                item.children = [];

                // Add the default weight if not provided or if it's not a number
                if ( angular.isUndefined(item.weight) || !angular.isNumber(item.weight) )
                {
                    item.weight = 1;
                }

                // Add the item id
                item._id = id;

                // Add the item path
                item._path = path;

                // Add proper ui-sref
                item.uisref = _getUiSref(item);

                // Push the item into the array
                parent.push(item);
            }
        }

        /**
         * Delete navigation item
         *
         * @param path
         */
        function deleteItem(path)
        {
            if ( !angular.isString(path) )
            {
                $log.error('path must be a string (eg. `dashboard.project`)');
                return;
            }

            // Locate the item by using given path
            var item = navigation,
                parts = path.split('.');

            for ( var p = 0; p < parts.length; p++ )
            {
                var id = parts[p];

                for ( var i = 0; i < item.length; i++ )
                {
                    if ( item[i]._id === id )
                    {
                        // If we have a matching path,
                        // we have found our object:
                        // remove it.
                        if ( item[i]._path === path )
                        {
                            item.splice(i, 1);
                            return true;
                        }

                        // Otherwise grab the children of
                        // the current item and continue
                        item = item[i].children;
                        break;
                    }
                }
            }

            return false;
        }

        /**
         * Sort the navigation items by their weights
         *
         * @param parent
         */
        function sortByWeight(parent)
        {
            // If parent not provided, sort the root items
            if ( !parent )
            {
                parent = navigation;
                parent.sort(_byWeight);
            }

            // Sort the children
            for ( var i = 0; i < parent.length; i++ )
            {
                var children = parent[i].children;

                if ( children.length > 1 )
                {
                    children.sort(_byWeight);
                }

                if ( children.length > 0 )
                {
                    sortByWeight(children);
                }
            }
        }

        /* ----------------- */
        /* Private Functions */
        /* ----------------- */

        /**
         * Find or create parent
         *
         * @param parts
         * @returns {Array|Boolean}
         * @private
         */
        function _findOrCreateParent(parts)
        {
            // Store the main navigation
            var parent = navigation;

            // If it's going to be a root item
            // return the navigation itself
            if ( parts.length === 1 )
            {
                return parent;
            }

            // Remove the last element from the parts as
            // we don't need that to figure out the parent
            parts.pop();

            // Find and return the parent
            for ( var i = 0; i < parts.length; i++ )
            {
                var _id = parts[i],
                    createParent = true;

                for ( var p = 0; p < parent.length; p++ )
                {
                    if ( parent[p]._id === _id )
                    {
                        parent = parent[p].children;
                        createParent = false;

                        break;
                    }
                }

                // If there is no parent found, create one, push
                // it into the current parent and assign it as a
                // new parent
                if ( createParent )
                {
                    var item = {
                        _id     : _id,
                        _path   : parts.join('.'),
                        title   : _id,
                        weight  : 1,
                        children: []
                    };

                    parent.push(item);
                    parent = item.children;
                }
            }

            return parent;
        }

        /**
         * Sort by weight
         *
         * @param x
         * @param y
         * @returns {number}
         * @private
         */
        function _byWeight(x, y)
        {
            return parseInt(x.weight) - parseInt(y.weight);
        }

        /**
         * Setup the ui-sref using state & state parameters
         *
         * @param item
         * @returns {string}
         * @private
         */
        function _getUiSref(item)
        {	
            var uisref = '';

            if ( angular.isDefined(item.state) )
            {
                uisref = item.state;

                if ( angular.isDefined(item.stateParams) && angular.isObject(item.stateParams) )
                {
                    uisref = uisref + '(' + angular.toJson(item.stateParams) + ')';
                }
            }

            return uisref;
        }

        /* ----------------- */
        /* Service           */
        /* ----------------- */

        this.$get = function ()
        {
            var activeItem = null,
                navigationScope = null,
                folded = null,
                foldedOpen = null;

            var service = {
                saveItem          : saveItem,
                deleteItem        : deleteItem,
                sort              : sortByWeight,
                clearNavigation   : clearNavigation,
                setActiveItem     : setActiveItem,
                getActiveItem     : getActiveItem,
                getNavigation     : getNavigation,
                getFlatNavigation : getFlatNavigation,
                setNavigationScope: setNavigationScope,
                setFolded         : setFolded,
                getFolded         : getFolded,
                setFoldedOpen     : setFoldedOpen,
                getFoldedOpen     : getFoldedOpen,
                toggleFolded      : toggleFolded
            };

            return service;

            //////////

            /**
             * Clear the entire navigation
             */
            function clearNavigation()
            {
                // Clear the navigation array
                navigation = [];

                // Clear the vm.navigation from main controller
                if ( navigationScope )
                {
                    navigationScope.vm.navigation = navigation;
                }
            }

            /**
             * Set active item
             *
             * @param node
             * @param scope
             */
            function setActiveItem(node, scope)
            {
                activeItem = {
                    node : node,
                    scope: scope
                };
            }

            /**
             * Return active item
             */
            function getActiveItem()
            {
                return activeItem;
            }

            /**
             * Return navigation array
             *
             * @param root
             * @returns Array
             */
            function getNavigation(root)
            {
                if ( root )
                {
                    for ( var i = 0; i < navigation.length; i++ )
                    {
                        if ( navigation[i]._id === root )
                        {
                            return [navigation[i]];
                        }
                    }

                    return null;
                }

                return navigation;
            }

            /**
             * Return flat navigation array
             *
             * @param root
             * @returns Array
             */
            function getFlatNavigation(root)
            {
                // Get the correct navigation array
                var navigation = getNavigation(root);

                // Flatten the navigation object
                return _flattenNavigation(navigation);
            }

            /**
             * Store navigation's scope for later use
             *
             * @param scope
             */
            function setNavigationScope(scope)
            {
                navigationScope = scope;
            }

            /**
             * Set folded status
             *
             * @param status
             */
            function setFolded(status)
            {
                folded = status;
            }

            /**
             * Return folded status
             *
             * @returns {*}
             */
            function getFolded()
            {
                return folded;
            }

            /**
             * Set folded open status
             *
             * @param status
             */
            function setFoldedOpen(status)
            {
                foldedOpen = status;
            }

            /**
             * Return folded open status
             *
             * @returns {*}
             */
            function getFoldedOpen()
            {
                return foldedOpen;
            }


            /**
             * Toggle fold on stored navigation's scope
             */
            function toggleFolded()
            {
                navigationScope.toggleFolded();
            }

            /**
             * Flatten the given navigation
             *
             * @param navigation
             * @private
             */
            function _flattenNavigation(navigation)
            {
                var flatNav = [];

                for ( var x = 0; x < navigation.length; x++ )
                {
                    // Copy and clear the children of the
                    // navigation that we want to push
                    var navToPush = angular.copy(navigation[x]);
                    navToPush.children = [];

                    // Push the item
                    flatNav.push(navToPush);

                    // If there are child items in this navigation,
                    // do some nested function magic
                    if ( navigation[x].children.length > 0 )
                    {
                        flatNav = flatNav.concat(_flattenNavigation(navigation[x].children));
                    }
                }

                return flatNav;
            }
        };
    }

    /** @ngInject */
    function MsNavigationController($scope, msNavigationService)
    {
        var vm = this;

        // Data
        if ( $scope.root )
        {
            vm.navigation = msNavigationService.getNavigation($scope.root);
        }
        else
        {
            vm.navigation = msNavigationService.getNavigation();
        }

        // Methods
        vm.toggleHorizontalMobileMenu = toggleHorizontalMobileMenu;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Sort the navigation before doing anything else
            msNavigationService.sort();
        }

        /**
         * Toggle horizontal mobile menu
         */
        function toggleHorizontalMobileMenu()
        {
            angular.element('body').toggleClass('ms-navigation-horizontal-mobile-menu-active');
        }
    }

    /** @ngInject */
    function msNavigationDirective($rootScope, $timeout, $mdSidenav, msNavigationService)
    {
        return {
            restrict   : 'E',
            scope      : {
                folded: '=',
                root  : '@'
            },
            controller : 'MsNavigationController as vm',
            templateUrl: 'app/core/directives/ms-navigation/templates/vertical.html',
            transclude : true,
            compile    : function (tElement)
            {
                tElement.addClass('ms-navigation');

                return function postLink(scope, iElement)
                {
                    var bodyEl = angular.element('body'),
                        foldExpanderEl = angular.element('<div id="ms-navigation-fold-expander"></div>'),
                        foldCollapserEl = angular.element('<div id="ms-navigation-fold-collapser"></div>'),
                        sidenav = $mdSidenav('navigation');

                    // Store the navigation in the service for public access
                    msNavigationService.setNavigationScope(scope);

                    // Initialize
                    init();

                    /**
                     * Initialize
                     */
                    function init()
                    {
                        // Set the folded status for the first time.
                        // First, we have to check if we have a folded
                        // status available in the service already. This
                        // will prevent navigation to act weird if we already
                        // set the fold status, remove the navigation and
                        // then re-initialize it, which happens if we
                        // change to a view without a navigation and then
                        // come back with history.back() function.

                        // If the service didn't initialize before, set
                        // the folded status from scope, otherwise we
                        // won't touch anything because the folded status
                        // already set in the service...
                        if ( msNavigationService.getFolded() === null )
                        {
                            msNavigationService.setFolded(scope.folded);
                        }

                        if ( msNavigationService.getFolded() )
                        {
                            // Collapse everything.
                            // This must be inside a $timeout because by the
                            // time we call this, the 'msNavigation::collapse'
                            // event listener is not registered yet. $timeout
                            // will ensure that it will be called after it is
                            // registered.
                            $timeout(function ()
                            {
                                $rootScope.$broadcast('msNavigation::collapse');
                            });

                            // Add class to the body
                            bodyEl.addClass('ms-navigation-folded');

                            // Set fold expander
                            setFoldExpander();
                        }
                    }

                    // Sidenav locked open status watcher
                    scope.$watch(function ()
                    {
                        return sidenav.isLockedOpen();
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        var folded = msNavigationService.getFolded();

                        if ( folded )
                        {
                            if ( current )
                            {
                                // Collapse everything
                                $rootScope.$broadcast('msNavigation::collapse');
                            }
                            else
                            {
                                // Expand the active one and its parents
                                var activeItem = msNavigationService.getActiveItem();
                                if ( activeItem )
                                {
                                    activeItem.scope.$emit('msNavigation::stateMatched');
                                }
                            }
                        }
                    });

                    // Folded status watcher
                    scope.$watch('folded', function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        setFolded(current);
                    });

                    /**
                     * Set folded status
                     *
                     * @param folded
                     */
                    function setFolded(folded)
                    {
                        // Store folded status on the service for global access
                        msNavigationService.setFolded(folded);

                        if ( folded )
                        {
                            // Collapse everything
                            $rootScope.$broadcast('msNavigation::collapse');

                            // Add class to the body
                            bodyEl.addClass('ms-navigation-folded');

                            // Set fold expander
                            setFoldExpander();
                        }
                        else
                        {
                            // Expand the active one and its parents
                            var activeItem = msNavigationService.getActiveItem();
                            if ( activeItem )
                            {
                                activeItem.scope.$emit('msNavigation::stateMatched');
                            }

                            // Remove body class
                            bodyEl.removeClass('ms-navigation-folded ms-navigation-folded-open');

                            // Remove fold collapser
                            removeFoldCollapser();
                        }
                    }

                    /**
                     * Set fold expander
                     */
                    function setFoldExpander()
                    {
                        iElement.parent().append(foldExpanderEl);

                        // Let everything settle for a moment
                        // before registering the event listener
                        $timeout(function ()
                        {
                            foldExpanderEl.on('mouseenter touchstart', onFoldExpanderHover);
                        });
                    }

                    /**
                     * Set fold collapser
                     */
                    function setFoldCollapser()
                    {
                        bodyEl.find('#main').append(foldCollapserEl);
                        foldCollapserEl.on('mouseenter touchstart', onFoldCollapserHover);
                    }

                    /**
                     * Remove fold collapser
                     */
                    function removeFoldCollapser()
                    {
                        foldCollapserEl.remove();
                    }

                    /**
                     * onHover event of foldExpander
                     */
                    function onFoldExpanderHover(event)
                    {
                        if ( event )
                        {
                            event.preventDefault();
                        }

                        // Set folded open status
                        msNavigationService.setFoldedOpen(true);

                        // Expand the active one and its parents
                        var activeItem = msNavigationService.getActiveItem();
                        if ( activeItem )
                        {
                            activeItem.scope.$emit('msNavigation::stateMatched');
                        }

                        // Add class to the body
                        bodyEl.addClass('ms-navigation-folded-open');

                        // Remove the fold opener
                        foldExpanderEl.remove();

                        // Set fold collapser
                        setFoldCollapser();
                    }

                    /**
                     * onHover event of foldCollapser
                     */
                    function onFoldCollapserHover(event)
                    {
                        if ( event )
                        {
                            event.preventDefault();
                        }

                        // Set folded open status
                        msNavigationService.setFoldedOpen(false);

                        // Collapse everything
                        $rootScope.$broadcast('msNavigation::collapse');

                        // Remove body class
                        bodyEl.removeClass('ms-navigation-folded-open');

                        // Remove the fold collapser
                        foldCollapserEl.remove();

                        // Set fold expander
                        setFoldExpander();
                    }

                    /**
                     * Public access for toggling folded status externally
                     */
                    scope.toggleFolded = function ()
                    {
                        var folded = msNavigationService.getFolded();

                        setFolded(!folded);
                    };

                    /**
                     * On $stateChangeStart
                     */
                    scope.$on('$stateChangeStart', function ()
                    {
                        // Close the sidenav
                        sidenav.close();
                    });

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        foldCollapserEl.off('mouseenter touchstart');
                        foldExpanderEl.off('mouseenter touchstart');
                    });
                };
            }
        };
    }

    /** @ngInject */
    function MsNavigationNodeController($scope, $element, $rootScope, $animate, $state, msNavigationService)
    {
        var vm = this;

        // Data
        vm.element = $element;
        vm.node = $scope.node;
        vm.hasChildren = undefined;
        vm.collapsed = undefined;
        vm.collapsable = undefined;
        vm.group = undefined;
        vm.animateHeightClass = 'animate-height';

        // Methods
        vm.toggleCollapsed = toggleCollapsed;
        vm.collapse = collapse;
        vm.expand = expand;
        vm.getClass = getClass;
        vm.isHidden = isHidden;

        vm.goToPage

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Setup the initial values

            // Has children?
            vm.hasChildren = vm.node.children.length > 0;

            // Is group?
            vm.group = !!(angular.isDefined(vm.node.group) && vm.node.group === true);

            // Is collapsable?
            if ( !vm.hasChildren || vm.group )
            {
                vm.collapsable = false;
            }
            else
            {
                vm.collapsable = !!(angular.isUndefined(vm.node.collapsable) || typeof vm.node.collapsable !== 'boolean' || vm.node.collapsable === true);
            }

            // Is collapsed?
            if ( !vm.collapsable )
            {
                vm.collapsed = false;
            }
            else
            {
                vm.collapsed = !!(angular.isUndefined(vm.node.collapsed) || typeof vm.node.collapsed !== 'boolean' || vm.node.collapsed === true);
            }

            // Expand all parents if we have a matching state or
            // the current state is a child of the node's state
            if ( vm.node.state === $state.current.name || $state.includes(vm.node.state) )
            {
                // If state params are defined, make sure they are
                // equal, otherwise do not set the active item
                if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                {
                    return;
                }

                $scope.$emit('msNavigation::stateMatched');

                // Also store the current active menu item
                msNavigationService.setActiveItem(vm.node, $scope);
            }

            $scope.$on('msNavigation::stateMatched', function ()
            {
                // Expand if the current scope is collapsable and is collapsed
                if ( vm.collapsable && vm.collapsed )
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.collapsed = false;
                    });
                }
            });

            // Listen for collapse event
            $scope.$on('msNavigation::collapse', function (event, path)
            {
                if ( vm.collapsed || !vm.collapsable )
                {
                    return;
                }

                // If there is no path defined, collapse
                if ( angular.isUndefined(path) )
                {
                    vm.collapse();
                }
                // If there is a path defined, do not collapse
                // the items that are inside that path. This will
                // prevent parent items from collapsing
                else
                {
                    var givenPathParts = path.split('.'),
                        activePathParts = [];

                    var activeItem = msNavigationService.getActiveItem();
                    if ( activeItem )
                    {
                        activePathParts = activeItem.node._path.split('.');
                    }

                    // Test for given path
                    if ( givenPathParts.indexOf(vm.node._id) > -1 )
                    {
                        return;
                    }

                    // Test for active path
                    if ( activePathParts.indexOf(vm.node._id) > -1 )
                    {
                        return;
                    }

                    vm.collapse();
                }
            });

            // Listen for $stateChangeSuccess event
            $scope.$on('$stateChangeSuccess', function ()
            {
                if ( vm.node.state === $state.current.name )
                {
                    // If state params are defined, make sure they are
                    // equal, otherwise do not set the active item
                    if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                    {
                        return;
                    }

                    // Update active item on state change
                    msNavigationService.setActiveItem(vm.node, $scope);

                    // Collapse everything except the one we're using
                    $rootScope.$broadcast('msNavigation::collapse', vm.node._path);
                }

                // Expand the parents if we the current
                // state is a child of the node's state
                if ( $state.includes(vm.node.state) )
                {
                    // If state params are defined, make sure they are
                    // equal, otherwise do not set the active item
                    if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                    {
                        return;
                    }

                    // Emit the stateMatched
                    $scope.$emit('msNavigation::stateMatched');
                }
            });
        }

        /**
         * Toggle collapsed
         */
        function toggleCollapsed()
        {
            if ( vm.collapsed )
            {
                vm.expand();
            }
            else
            {
                vm.collapse();
            }
        }

        /**
         * Collapse
         */
        function collapse()
        {
            // Grab the element that we are going to collapse
            var collapseEl = vm.element.children('ul');

            // Grab the height
            var height = collapseEl[0].offsetHeight;

            $scope.$evalAsync(function ()
            {
                // Set collapsed status
                vm.collapsed = true;

                // Add collapsing class to the node
                vm.element.addClass('');

                // Animate the height
                $animate.animate(collapseEl,
                    {
                        'display': 'block',
                        'height' : height + 'px'
                    },
                    {
                        'height': '0px'
                    },
                    vm.animateHeightClass
                ).then(
                    function ()
                    {
                        // Clear the inline styles after animation done
                        collapseEl.css({
                            'display': '',
                            'height' : ''
                        });

                        // Clear collapsing class from the node
                        vm.element.removeClass('collapsing');
                    }
                );

                // Broadcast the collapse event so child items can also be collapsed
                $scope.$broadcast('msNavigation::collapse');
            });
        }

        /**
         * Expand
         */
        function expand()
        {
            // Grab the element that we are going to expand
            var expandEl = vm.element.children('ul');

            // Move the element out of the dom flow and
            // make it block so we can get its height
            expandEl.css({
                'position'  : 'absolute',
                'visibility': 'hidden',
                'display'   : 'block',
                'height'    : 'auto'
            });

            // Grab the height
            var height = expandEl[0].offsetHeight;

            // Reset the style modifications
            expandEl.css({
                'position'  : '',
                'visibility': '',
                'display'   : '',
                'height'    : ''
            });

            $scope.$evalAsync(function ()
            {
                // Set collapsed status
                vm.collapsed = false;

                // Add expanding class to the node
                vm.element.addClass('expanding');

                // Animate the height
                $animate.animate(expandEl,
                    {
                        'display': 'block',
                        'height' : '0px'
                    },
                    {
                        'height': height + 'px'
                    },
                    vm.animateHeightClass
                ).then(
                    function ()
                    {
                        // Clear the inline styles after animation done
                        expandEl.css({
                            'height': ''
                        });

                        // Clear expanding class from the node
                        vm.element.removeClass('expanding');
                    }
                );

                // If item expanded, broadcast the collapse event from rootScope so that the other expanded items
                // can be collapsed. This is necessary for keeping only one parent expanded at any time
                $rootScope.$broadcast('msNavigation::collapse', vm.node._path);
            });
        }

        /**
         * Return the class
         *
         * @returns {*}
         */
        function getClass()
        {
            return vm.node.class;
        }

        /**
         * Check if node should be hidden
         *
         * @returns {boolean}
         */
        function isHidden()
        {
            if ( angular.isDefined(vm.node.hidden) && angular.isFunction(vm.node.hidden) )
            {
                return vm.node.hidden();
            }

            return false;
        }
    }

    /** @ngInject */
    function msNavigationNodeDirective()
    {
        return {
            restrict        : 'A',
            bindToController: {
                node: '=msNavigationNode'
            },
            controller      : 'MsNavigationNodeController as vm',
            compile         : function (tElement)
            {
                tElement.addClass('ms-navigation-node');

                return function postLink(scope, iElement, iAttrs, MsNavigationNodeCtrl)
                {
                    // Add custom classes
                    iElement.addClass(MsNavigationNodeCtrl.getClass());

                    // Add group class if it's a group
                    if ( MsNavigationNodeCtrl.group )
                    {
                        iElement.addClass('group');
                    }
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationItemDirective()
    {
        return {
            restrict: 'A',
            require : '^msNavigationNode',
            compile : function (tElement)
            {
                tElement.addClass('ms-navigation-item');

                return function postLink(scope, iElement, iAttrs, MsNavigationNodeCtrl)
                {
                    // If the item is collapsable...
                    if ( MsNavigationNodeCtrl.collapsable )
                    {

                        iElement.on('click', MsNavigationNodeCtrl.toggleCollapsed);
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('click');
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationHorizontalDirective(msNavigationService)
    {
        return {
            restrict   : 'E',
            scope      : {
                root: '@'
            },
            controller : 'MsNavigationController as vm',
            templateUrl: 'app/core/directives/ms-navigation/templates/horizontal.html',
            transclude : true,
            compile    : function (tElement)
            {
                tElement.addClass('ms-navigation-horizontal');

                return function postLink(scope)
                {
                    // Store the navigation in the service for public access
                    msNavigationService.setNavigationScope(scope);
                };
            }
        };
    }

    /** @ngInject */
    function MsNavigationHorizontalNodeController($scope, $element, $rootScope, $state, msNavigationService)
    {
        var vm = this;

        // Data
        vm.element = $element;
        vm.node = $scope.node;
        vm.hasChildren = undefined;
        vm.group = undefined;

        // Methods
        vm.getClass = getClass;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Setup the initial values

            // Is active
            vm.isActive = false;

            // Has children?
            vm.hasChildren = vm.node.children.length > 0;

            // Is group?
            vm.group = !!(angular.isDefined(vm.node.group) && vm.node.group === true);

            // Mark all parents as active if we have a matching state
            // or the current state is a child of the node's state
            if ( vm.node.state === $state.current.name || $state.includes(vm.node.state) )
            {
                // If state params are defined, make sure they are
                // equal, otherwise do not set the active item
                if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                {
                    return;
                }

                $scope.$emit('msNavigation::stateMatched');

                // Also store the current active menu item
                msNavigationService.setActiveItem(vm.node, $scope);
            }

            $scope.$on('msNavigation::stateMatched', function ()
            {
                // Mark as active if has children
                if ( vm.hasChildren )
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.isActive = true;
                    });
                }
            });

            // Listen for clearActive event
            $scope.$on('msNavigation::clearActive', function ()
            {
                if ( !vm.hasChildren )
                {
                    return;
                }

                var activePathParts = [];

                var activeItem = msNavigationService.getActiveItem();
                if ( activeItem )
                {
                    activePathParts = activeItem.node._path.split('.');
                }

                // Test for active path
                if ( activePathParts.indexOf(vm.node._id) > -1 )
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.isActive = true;
                    });
                }
                else
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.isActive = false;
                    });
                }

            });

            // Listen for $stateChangeSuccess event
            $scope.$on('$stateChangeSuccess', function ()
            {
                if ( vm.node.state === $state.current.name || $state.includes(vm.node.state) )
                {
                    // If state params are defined, make sure they are
                    // equal, otherwise do not set the active item
                    if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                    {
                        return;
                    }

                    // Update active item on state change
                    msNavigationService.setActiveItem(vm.node, $scope);

                    // Clear all active states except the one we're using
                    $rootScope.$broadcast('msNavigation::clearActive');
                }
            });
        }

        /**
         * Return the class
         *
         * @returns {*}
         */
        function getClass()
        {
            return vm.node.class;
        }
    }

    /** @ngInject */
    function msNavigationHorizontalNodeDirective()
    {
        return {
            restrict        : 'A',
            bindToController: {
                node: '=msNavigationHorizontalNode'
            },
            controller      : 'MsNavigationHorizontalNodeController as vm',
            compile         : function (tElement)
            {
                tElement.addClass('ms-navigation-horizontal-node');

                return function postLink(scope, iElement, iAttrs, MsNavigationHorizontalNodeCtrl)
                {
                    // Add custom classes
                    iElement.addClass(MsNavigationHorizontalNodeCtrl.getClass());

                    // Add group class if it's a group
                    if ( MsNavigationHorizontalNodeCtrl.group )
                    {
                        iElement.addClass('group');
                    }
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationHorizontalItemDirective($mdMedia)
    {
        return {
            restrict: 'A',
            require : '^msNavigationHorizontalNode',
            compile : function (tElement)
            {
                tElement.addClass('ms-navigation-horizontal-item');

                return function postLink(scope, iElement, iAttrs, MsNavigationHorizontalNodeCtrl)
                {
                    iElement.on('click', onClick);

                    function onClick()
                    {
                        if ( !MsNavigationHorizontalNodeCtrl.hasChildren || $mdMedia('gt-md') )
                        {
                            return;
                        }

                        iElement.toggleClass('expanded');
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('click');
                    });
                };
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msRandomClass', msRandomClassDirective);

    /** @ngInject */
    function msRandomClassDirective()
    {
        return {
            restrict: 'A',
            scope   : {
                msRandomClass: '='
            },
            link    : function (scope, iElement)
            {
                var randomClass = scope.msRandomClass[Math.floor(Math.random() * (scope.msRandomClass.length))];
                iElement.addClass(randomClass);
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('msNavFoldService', msNavFoldService)
        .directive('msNavIsFolded', msNavIsFoldedDirective)
        .controller('MsNavController', MsNavController)
        .directive('msNav', msNavDirective)
        .directive('msNavTitle', msNavTitleDirective)
        .directive('msNavButton', msNavButtonDirective)
        .directive('msNavToggle', msNavToggleDirective);

    /** @ngInject */
    function msNavFoldService()
    {
        var foldable = {};

        var service = {
            setFoldable    : setFoldable,
            isNavFoldedOpen: isNavFoldedOpen,
            toggleFold     : toggleFold,
            openFolded     : openFolded,
            closeFolded    : closeFolded
        };

        return service;

        //////////

        /**
         * Set the foldable
         *
         * @param scope
         * @param element
         */
        function setFoldable(scope, element)
        {
            foldable = {
                'scope'  : scope,
                'element': element
            };
        }

        /**
         * Is folded open
         */
        function isNavFoldedOpen()
        {
            return foldable.scope.isNavFoldedOpen();
        }

        /**
         * Toggle fold
         */
        function toggleFold()
        {
            foldable.scope.toggleFold();
        }

        /**
         * Open folded navigation
         */
        function openFolded()
        {
            foldable.scope.openFolded();
        }

        /**
         * Close folded navigation
         */
        function closeFolded()
        {
            foldable.scope.closeFolded();
        }
    }

    /** @ngInject */
    function msNavIsFoldedDirective($document, $rootScope, msNavFoldService)
    {
        return {
            restrict: 'A',
            link    : function (scope, iElement, iAttrs)
            {
                var isFolded = (iAttrs.msNavIsFolded === 'true'),
                    isFoldedOpen = false,
                    body = angular.element($document[0].body),
                    openOverlay = angular.element('<div id="ms-nav-fold-open-overlay"></div>'),
                    closeOverlay = angular.element('<div id="ms-nav-fold-close-overlay"></div>'),
                    sidenavEl = iElement.parent();

                // Initialize the service
                msNavFoldService.setFoldable(scope, iElement, isFolded);

                // Set the fold status for the first time
                if ( isFolded )
                {
                    fold();
                }
                else
                {
                    unfold();
                }

                /**
                 * Is nav folded open
                 */
                function isNavFoldedOpen()
                {
                    return isFoldedOpen;
                }

                /**
                 * Toggle fold
                 */
                function toggleFold()
                {
                    isFolded = !isFolded;

                    if ( isFolded )
                    {
                        fold();
                    }
                    else
                    {
                        unfold();
                    }
                }

                /**
                 * Fold the navigation
                 */
                function fold()
                {
                    // Add classes
                    body.addClass('ms-nav-folded');

                    // Collapse everything and scroll to the top
                    $rootScope.$broadcast('msNav::forceCollapse');
                    iElement.scrollTop(0);

                    // Append the openOverlay to the element
                    sidenavEl.append(openOverlay);

                    // Event listeners
                    openOverlay.on('mouseenter touchstart', function (event)
                    {
                        openFolded(event);
                        isFoldedOpen = true;
                    });
                }

                /**
                 * Open folded navigation
                 */
                function openFolded(event)
                {
                    if ( angular.isDefined(event) )
                    {
                        event.preventDefault();
                    }

                    body.addClass('ms-nav-folded-open');

                    // Update the location
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    // Remove open overlay
                    sidenavEl.find(openOverlay).remove();

                    // Append close overlay and bind its events
                    sidenavEl.parent().append(closeOverlay);
                    closeOverlay.on('mouseenter touchstart', function (event)
                    {
                        closeFolded(event);
                        isFoldedOpen = false;
                    });
                }

                /**
                 * Close folded navigation
                 */
                function closeFolded(event)
                {
                    if ( angular.isDefined(event) )
                    {
                        event.preventDefault();
                    }

                    // Collapse everything and scroll to the top
                    $rootScope.$broadcast('msNav::forceCollapse');
                    iElement.scrollTop(0);

                    body.removeClass('ms-nav-folded-open');

                    // Remove close overlay
                    sidenavEl.parent().find(closeOverlay).remove();

                    // Append open overlay and bind its events
                    sidenavEl.append(openOverlay);
                    openOverlay.on('mouseenter touchstart', function (event)
                    {
                        openFolded(event);
                        isFoldedOpen = true;
                    });
                }

                /**
                 * Unfold the navigation
                 */
                function unfold()
                {
                    body.removeClass('ms-nav-folded ms-nav-folded-open');

                    // Update the location
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    iElement.off('mouseenter mouseleave');
                }

                // Expose functions to the scope
                scope.toggleFold = toggleFold;
                scope.openFolded = openFolded;
                scope.closeFolded = closeFolded;
                scope.isNavFoldedOpen = isNavFoldedOpen;

                // Cleanup
                scope.$on('$destroy', function ()
                {
                    openOverlay.off('mouseenter touchstart');
                    closeOverlay.off('mouseenter touchstart');
                    iElement.off('mouseenter mouseleave');
                });
            }
        };
    }


    /** @ngInject */
    function MsNavController()
    {
        var vm = this,
            disabled = false,
            toggleItems = [],
            lockedItems = [];

        // Data

        // Methods
        vm.isDisabled = isDisabled;
        vm.enable = enable;
        vm.disable = disable;
        vm.setToggleItem = setToggleItem;
        vm.getLockedItems = getLockedItems;
        vm.setLockedItem = setLockedItem;
        vm.clearLockedItems = clearLockedItems;

        //////////

        /**
         * Is navigation disabled
         *
         * @returns {boolean}
         */
        function isDisabled()
        {
            return disabled;
        }

        /**
         * Disable the navigation
         */
        function disable()
        {
            disabled = true;
        }

        /**
         * Enable the navigation
         */
        function enable()
        {
            disabled = false;
        }

        /**
         * Set toggle item
         *
         * @param element
         * @param scope
         */
        function setToggleItem(element, scope)
        {
            toggleItems.push({
                'element': element,
                'scope'  : scope
            });
        }

        /**
         * Get locked items
         *
         * @returns {Array}
         */
        function getLockedItems()
        {
            return lockedItems;
        }

        /**
         * Set locked item
         *
         * @param element
         * @param scope
         */
        function setLockedItem(element, scope)
        {
            lockedItems.push({
                'element': element,
                'scope'  : scope
            });
        }

        /**
         * Clear locked items list
         */
        function clearLockedItems()
        {
            lockedItems = [];
        }
    }

    /** @ngInject */
    function msNavDirective($rootScope, $mdComponentRegistry, msNavFoldService)
    {
        return {
            restrict  : 'E',
            scope     : {},
            controller: 'MsNavController',
            compile   : function (tElement)
            {
                tElement.addClass('ms-nav');

                return function postLink(scope)
                {
                    // Update toggle status according to the ui-router current state
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    // Update toggles on state changes
                    var stateChangeSuccessEvent = $rootScope.$on('$stateChangeSuccess', function ()
                    {
                        $rootScope.$broadcast('msNav::expandMatchingToggles');

                        // Close navigation sidenav on stateChangeSuccess
                        $mdComponentRegistry.when('navigation').then(function (navigation)
                        {
                            navigation.close();

                            if ( msNavFoldService.isNavFoldedOpen() )
                            {
                                msNavFoldService.closeFolded();
                            }
                        });
                    });

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        stateChangeSuccessEvent();
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msNavTitleDirective()
    {
        return {
            restrict: 'A',
            compile : function (tElement)
            {
                tElement.addClass('ms-nav-title');

                return function postLink()
                {

                };
            }
        };
    }

    /** @ngInject */
    function msNavButtonDirective()
    {
        return {
            restrict: 'AE',
            compile : function (tElement)
            {
                tElement.addClass('ms-nav-button');

                return function postLink()
                {

                };
            }
        };
    }

    /** @ngInject */
    function msNavToggleDirective($rootScope, $q, $animate, $state)
    {
        return {
            restrict: 'A',
            require : '^msNav',
            scope   : true,
            compile : function (tElement, tAttrs)
            {
                tElement.addClass('ms-nav-toggle');

                // Add collapsed attr
                if ( angular.isUndefined(tAttrs.collapsed) )
                {
                    tAttrs.collapsed = true;
                }

                tElement.attr('collapsed', tAttrs.collapsed);

                return function postLink(scope, iElement, iAttrs, MsNavCtrl)
                {
                    var classes = {
                        expanded         : 'expanded',
                        expandAnimation  : 'expand-animation',
                        collapseAnimation: 'collapse-animation'
                    };

                    // Store all related states
                    var links = iElement.find('a');
                    var states = [];
                    var regExp = /\(.*\)/g;

                    angular.forEach(links, function (link)
                    {
                        var state = angular.element(link).attr('ui-sref');

                        if ( angular.isUndefined(state) )
                        {
                            return;
                        }

                        // Remove any parameter definition from the state name before storing it
                        state = state.replace(regExp, '');

                        states.push(state);
                    });

                    // Store toggle-able element and its scope in the main nav controller
                    MsNavCtrl.setToggleItem(iElement, scope);

                    // Click handler
                    iElement.children('.ms-nav-button').on('click', toggle);

                    // Toggle function
                    function toggle()
                    {
                        // If navigation is disabled, do nothing...
                        if ( MsNavCtrl.isDisabled() )
                        {
                            return;
                        }

                        // Disable the entire navigation to prevent spamming
                        MsNavCtrl.disable();

                        if ( isCollapsed() )
                        {
                            // Clear the locked items list
                            MsNavCtrl.clearLockedItems();

                            // Emit pushToLockedList event
                            scope.$emit('msNav::pushToLockedList');

                            // Collapse everything but locked items
                            $rootScope.$broadcast('msNav::collapse');

                            // Expand and then...
                            expand().then(function ()
                            {
                                // Enable the entire navigation after animations completed
                                MsNavCtrl.enable();
                            });
                        }
                        else
                        {
                            // Collapse with all children
                            scope.$broadcast('msNav::forceCollapse');
                        }
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.children('.ms-nav-button').off('click');
                    });

                    /*---------------------*/
                    /* Scope Events        */
                    /*---------------------*/

                    /**
                     * Collapse everything but locked items
                     */
                    scope.$on('msNav::collapse', function ()
                    {
                        // Only collapse toggles that are not locked
                        var lockedItems = MsNavCtrl.getLockedItems();
                        var locked = false;

                        angular.forEach(lockedItems, function (lockedItem)
                        {
                            if ( angular.equals(lockedItem.scope, scope) )
                            {
                                locked = true;
                            }
                        });

                        if ( locked )
                        {
                            return;
                        }

                        // Collapse and then...
                        collapse().then(function ()
                        {
                            // Enable the entire navigation after animations completed
                            MsNavCtrl.enable();
                        });
                    });

                    /**
                     * Collapse everything
                     */
                    scope.$on('msNav::forceCollapse', function ()
                    {
                        // Collapse and then...
                        collapse().then(function ()
                        {
                            // Enable the entire navigation after animations completed
                            MsNavCtrl.enable();
                        });
                    });

                    /**
                     * Expand toggles that match with the current states
                     */
                    scope.$on('msNav::expandMatchingToggles', function ()
                    {
                        var currentState = $state.current.name;
                        var shouldExpand = false;

                        angular.forEach(states, function (state)
                        {
                            if ( currentState === state )
                            {
                                shouldExpand = true;
                            }
                        });

                        if ( shouldExpand )
                        {
                            expand();
                        }
                        else
                        {
                            collapse();
                        }
                    });

                    /**
                     * Add toggle to the locked list
                     */
                    scope.$on('msNav::pushToLockedList', function ()
                    {
                        // Set expanded item on main nav controller
                        MsNavCtrl.setLockedItem(iElement, scope);
                    });

                    /*---------------------*/
                    /* Internal functions  */
                    /*---------------------*/

                    /**
                     * Is element collapsed
                     *
                     * @returns {bool}
                     */
                    function isCollapsed()
                    {
                        return iElement.attr('collapsed') === 'true';
                    }

                    /**
                     * Is element expanded
                     *
                     * @returns {bool}
                     */
                    function isExpanded()
                    {
                        return !isCollapsed();
                    }

                    /**
                     * Expand the toggle
                     *
                     * @returns $promise
                     */
                    function expand()
                    {
                        // Create a new deferred object
                        var deferred = $q.defer();

                        // If the menu item is already expanded, do nothing..
                        if ( isExpanded() )
                        {
                            // Reject the deferred object
                            deferred.reject({'error': true});

                            // Return the promise
                            return deferred.promise;
                        }

                        // Set element attr
                        iElement.attr('collapsed', false);

                        // Grab the element to expand
                        var elementToExpand = angular.element(iElement.find('ms-nav-toggle-items')[0]);

                        // Move the element out of the dom flow and
                        // make it block so we can get its height
                        elementToExpand.css({
                            'position'  : 'absolute',
                            'visibility': 'hidden',
                            'display'   : 'block',
                            'height'    : 'auto'
                        });

                        // Grab the height
                        var height = elementToExpand[0].offsetHeight;

                        // Reset the style modifications
                        elementToExpand.css({
                            'position'  : '',
                            'visibility': '',
                            'display'   : '',
                            'height'    : ''
                        });

                        // Animate the height
                        scope.$evalAsync(function ()
                        {
                            $animate.animate(elementToExpand,
                                {
                                    'display': 'block',
                                    'height' : '0px'
                                },
                                {
                                    'height': height + 'px'
                                },
                                classes.expandAnimation
                            ).then(
                                function ()
                                {
                                    // Add expanded class
                                    elementToExpand.addClass(classes.expanded);

                                    // Clear the inline styles after animation done
                                    elementToExpand.css({'height': ''});

                                    // Resolve the deferred object
                                    deferred.resolve({'success': true});
                                }
                            );
                        });

                        // Return the promise
                        return deferred.promise;
                    }

                    /**
                     * Collapse the toggle
                     *
                     * @returns $promise
                     */
                    function collapse()
                    {
                        // Create a new deferred object
                        var deferred = $q.defer();

                        // If the menu item is already collapsed, do nothing..
                        if ( isCollapsed() )
                        {
                            // Reject the deferred object
                            deferred.reject({'error': true});

                            // Return the promise
                            return deferred.promise;
                        }

                        // Set element attr
                        iElement.attr('collapsed', true);

                        // Grab the element to collapse
                        var elementToCollapse = angular.element(iElement.find('ms-nav-toggle-items')[0]);

                        // Grab the height
                        var height = elementToCollapse[0].offsetHeight;

                        // Animate the height
                        scope.$evalAsync(function ()
                        {
                            $animate.animate(elementToCollapse,
                                {
                                    'height': height + 'px'
                                },
                                {
                                    'height': '0px'
                                },
                                classes.collapseAnimation
                            ).then(
                                function ()
                                {
                                    // Remove expanded class
                                    elementToCollapse.removeClass(classes.expanded);

                                    // Clear the inline styles after animation done
                                    elementToCollapse.css({
                                        'display': '',
                                        'height' : ''
                                    });

                                    // Resolve the deferred object
                                    deferred.resolve({'success': true});
                                }
                            );
                        });

                        // Return the promise
                        return deferred.promise;
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('msMaterialColorPickerController', msMaterialColorPickerController)
        .directive('msMaterialColorPicker', msMaterialColorPicker);

    /** @ngInject */
    function msMaterialColorPickerController($scope, $mdColorPalette, $mdMenu, fuseGenerator)
    {
        var vm = this;
        vm.palettes = $mdColorPalette; // Material Color Palette
        vm.selectedPalette = false;
        vm.selectedHues = false;
        $scope.$selectedColor = {};

        // Methods
        vm.activateHueSelection = activateHueSelection;
        vm.selectColor = selectColor;
        vm.removeColor = removeColor;

        /**
         * Initialize / Watch model changes
         */
        $scope.$watch('ngModel', setSelectedColor);

        /**
         * Activate Hue Selection
         * @param palette
         * @param hues
         */
        function activateHueSelection(palette, hues)
        {
            vm.selectedPalette = palette;
            vm.selectedHues = hues;
        }

        /**
         * Select Color
         * @type {selectColor}
         */
        function selectColor(palette, hue)
        {
            // Update Selected Color
            updateSelectedColor(palette, hue);

            // Update Model Value
            updateModel();

            // Hide The picker
            $mdMenu.hide();
        }

        function removeColor()
        {
            vm.selectedColor = {
                palette: '',
                hue    : '',
                class  : ''
            };

            activateHueSelection(false, false);

            updateModel();
        }

        /**
         * Set SelectedColor by model type
         */
        function setSelectedColor()
        {
            if ( !vm.modelCtrl.$viewValue || vm.modelCtrl.$viewValue === '' )
            {
                removeColor();
                return;
            }

            var palette, hue;

            // If ModelType Class
            if ( vm.msModelType === 'class' )
            {
                var color = vm.modelCtrl.$viewValue.split('-');
                if ( color.length >= 5 )
                {
                    palette = color[1] + '-' + color[2];
                    hue = color[3];
                }
                else
                {
                    palette = color[1];
                    hue = color[2];
                }
            }

            // If ModelType Object
            else if ( vm.msModelType === 'obj' )
            {
                palette = vm.modelCtrl.$viewValue.palette;
                hue = vm.modelCtrl.$viewValue.hue || 500;
            }

            // Update Selected Color
            updateSelectedColor(palette, hue);
        }

        /**
         * Update Selected Color
         * @param palette
         * @param hue
         */
        function updateSelectedColor(palette, hue)
        {
            vm.selectedColor = {
                palette     : palette,
                hue         : hue,
                class       : 'md-' + palette + '-' + hue + '-bg',
                bgColorValue: fuseGenerator.rgba(vm.palettes[palette][hue].value),
                fgColorValue: fuseGenerator.rgba(vm.palettes[palette][hue].contrast)
            };

            // If Model object not Equals the selectedColor update it
            // it can be happen when the model only have pallete and hue values
            if ( vm.msModelType === 'obj' && !angular.equals(vm.selectedColor, vm.modelCtrl.$viewValue) )
            {
                // Update Model Value
                updateModel();
            }

            activateHueSelection(palette, vm.palettes[palette]);

            $scope.$selectedColor = vm.selectedColor;
        }

        /**
         * Update Model Value by model type
         */
        function updateModel()
        {
            if ( vm.msModelType === 'class' )
            {
                vm.modelCtrl.$setViewValue(vm.selectedColor.class);
            }
            else if ( vm.msModelType === 'obj' )
            {
                vm.modelCtrl.$setViewValue(vm.selectedColor);
            }
        }
    }

    /** @ngInject */
    function msMaterialColorPicker()
    {
        return {
            require    : ['msMaterialColorPicker', 'ngModel'],
            restrict   : 'E',
            scope      : {
                ngModel    : '=',
                msModelType: '@?'
            },
            controller : 'msMaterialColorPickerController as vm',
            transclude : true,
            templateUrl: 'app/core/directives/ms-material-color-picker/ms-material-color-picker.html',
            link       : function (scope, element, attrs, controllers, transclude)
            {
                var ctrl = controllers[0];

                /**
                 *  Pass model controller to directive controller
                 */
                ctrl.modelCtrl = controllers[1];

                /**
                 * ModelType: 'obj', 'class'(default)
                 * @type {string|string}
                 */
                ctrl.msModelType = scope.msModelType || 'class';

                transclude(scope, function (clone)
                {
                    clone = clone.filter(function (i, el)
                    {
                        return ( el.nodeType === 1 ) ? true : false;
                    });

                    if ( clone.length )
                    {
                        element.find('ms-color-picker-button').replaceWith(clone);
                    }
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msInfoBar', msInfoBarDirective);

    /** @ngInject */
    function msInfoBarDirective($document)
    {
        return {
            restrict   : 'E',
            scope      : {},
            transclude : true,
            templateUrl: 'app/core/directives/ms-info-bar/ms-info-bar.html',
            link       : function (scope, iElement)
            {
                var body = $document.find('body'),
                    bodyClass = 'ms-info-bar-active';

                // Add body class
                body.addClass(bodyClass);

                /**
                 * Remove the info bar
                 */
                function removeInfoBar()
                {
                    body.removeClass(bodyClass);
                    iElement.remove();
                    scope.$destroy();
                }

                // Expose functions
                scope.removeInfoBar = removeInfoBar;
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('msMasonryController', msMasonryController)
        .directive('msMasonry', msMasonry)
        .directive('msMasonryItem', msMasonryItem);

    /** @ngInject */
    function msMasonryController($scope, $window, $mdMedia, $timeout)
    {
        var vm = this,
            defaultOpts = {
                columnCount     : 5,
                respectItemOrder: false,
                reLayoutDebounce: 400,
                responsive      : {
                    md: 3,
                    sm: 2,
                    xs: 1
                }
            },
            reLayoutTimeout = true;

        vm.options = null;
        vm.container = [];
        vm.containerPos = '';
        vm.columnWidth = '';
        vm.items = [];

        // Methods
        vm.reLayout = reLayout;
        vm.initialize = initialize;
        vm.waitImagesLoaded = waitImagesLoaded;

        function initialize()
        {
            vm.options = !vm.options ? defaultOpts : angular.extend(defaultOpts, vm.options);


            watchContainerResize();
        }

        $scope.$on('msMasonry:relayout', function ()
        {
            reLayout();
        });

        function waitImagesLoaded(element, callback)
        {
            if ( typeof imagesLoaded !== 'undefined' )
            {
                var imgLoad = $window.imagesLoaded(element);

                imgLoad.on('done', function ()
                {
                    callback();
                });
            }
            else
            {
                callback();
            }
        }

        function watchContainerResize()
        {
            $scope.$watch(
                function ()
                {
                    return vm.container.width();
                },
                function (newValue, oldValue)
                {
                    if ( newValue !== oldValue )
                    {
                        reLayout();
                    }
                }
            );
        }

        function reLayout()
        {
            // Debounce for relayout
            if ( reLayoutTimeout )
            {
                $timeout.cancel(reLayoutTimeout);
            }

            reLayoutTimeout = $timeout(function ()
            {
                start();

                $scope.$broadcast('msMasonry:relayoutFinished');

            }, vm.options.reLayoutDebounce);

            // Start relayout
            function start()
            {
                vm.containerPos = vm.container[0].getBoundingClientRect();

                updateColumnOptions();

                $scope.$broadcast('msMasonry:relayoutStarted');

                vm.items = vm.container.find('ms-masonry-item');

                //initialize lastRowBottomArr
                var referenceArr = Array.apply(null, new Array(vm.columnCount)).map(function ()
                {
                    return 0;
                });

                // set item positions
                for ( var i = 0; i < vm.items.length; i++ )
                {
                    var item = vm.items[i],
                        xPos, yPos, column, refTop;

                    item = angular.element(item);

                    if ( item.scope() )
                    {
                        item.scope().$broadcast('msMasonryItem:startReLayout');
                    }

                    item.css({'width': vm.columnWidth});

                    if ( vm.options.respectItemOrder )
                    {
                        column = i % vm.columnCount;
                        refTop = referenceArr[column];
                    }
                    else
                    {
                        refTop = Math.min.apply(Math, referenceArr);
                        column = referenceArr.indexOf(refTop);
                    }

                    referenceArr[column] = refTop + item[0].getBoundingClientRect().height;

                    xPos = Math.round(column * vm.columnWidth);
                    yPos = refTop;

                    item.css({'transform': 'translate3d(' + xPos + 'px,' + yPos + 'px,0px)'});
                    item.addClass('placed');

                    if ( item.scope() )
                    {
                        item.scope().$broadcast('msMasonryItem:finishReLayout');
                    }
                }
            }
        }

        function updateColumnOptions()
        {
            vm.columnCount = vm.options.columnCount;

            if ( $mdMedia('gt-md') )
            {
                vm.columnCount = vm.options.columnCount;
            }
            else if ( $mdMedia('md') )
            {
                vm.columnCount = (vm.columnCount > vm.options.responsive.md ? vm.options.responsive.md : vm.columnCount);
            }
            else if ( $mdMedia('sm') )
            {
                vm.columnCount = (vm.columnCount > vm.options.responsive.sm ? vm.options.responsive.sm : vm.columnCount);
            }
            else
            {
                vm.columnCount = vm.options.responsive.xs;
            }

            vm.columnWidth = vm.containerPos.width / vm.columnCount;

        }
    }

    /** @ngInject */
    function msMasonry($timeout)
    {
        return {
            restrict  : 'AEC',
            controller: 'msMasonryController',
            compile   : compile
        };
        function compile(element, attributes)
        {
            return {
                pre : function preLink(scope, iElement, iAttrs, controller)
                {
                    controller.options = angular.fromJson(attributes.options || '{}');
                    controller.container = element;
                },
                post: function postLink(scope, iElement, iAttrs, controller)
                {
                    $timeout(function ()
                    {
                        controller.initialize();
                    });
                }
            };
        }
    }

    /** @ngInject */
    function msMasonryItem()
    {
        return {
            restrict: 'AEC',
            require : '^msMasonry',
            priority: 1,
            link    : link
        };

        function link(scope, element, attributes, controller)
        {
            controller.waitImagesLoaded(element, function ()
            {
                controller.reLayout();

            });

            scope.$on('msMasonryItem:finishReLayout', function ()
            {
                scope.$watch(function ()
                {
                    return element.height();
                }, function (newVal, oldVal)
                {
                    if ( newVal !== oldVal )
                    {
                        controller.reLayout();
                    }
                });
            });

            element.on('$destroy', function ()
            {
                controller.reLayout();
            });
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsFormWizardController', MsFormWizardController)
        .directive('msFormWizard', msFormWizardDirective)
        .directive('msFormWizardForm', msFormWizardFormDirective);

    /** @ngInject */
    function MsFormWizardController()
    {
        var vm = this;

        // Data
        vm.forms = [];
        vm.selectedIndex = 0;

        // Methods
        vm.registerForm = registerForm;

        vm.previousStep = previousStep;
        vm.nextStep = nextStep;
        vm.firstStep = firstStep;
        vm.lastStep = lastStep;

        vm.totalSteps = totalSteps;
        vm.isFirstStep = isFirstStep;
        vm.isLastStep = isLastStep;

        vm.currentStepInvalid = currentStepInvalid;
        vm.previousStepInvalid = previousStepInvalid;
        vm.formsIncomplete = formsIncomplete;
        vm.resetForm = resetForm;

        //////////

        /**
         * Register form
         *
         * @param form
         */
        function registerForm(form)
        {
            vm.forms.push(form);
        }

        /**
         * Go to previous step
         */
        function previousStep()
        {
            if ( isFirstStep() )
            {
                return;
            }

            vm.selectedIndex--;
        }

        /**
         * Go to next step
         */
        function nextStep()
        {
            if ( isLastStep() )
            {
                return;
            }

            vm.selectedIndex++;
        }

        /**
         * Go to first step
         */
        function firstStep()
        {
            vm.selectedIndex = 0;
        }

        /**
         * Go to last step
         */
        function lastStep()
        {
            vm.selectedIndex = totalSteps() - 1;
        }

        /**
         * Return total steps
         *
         * @returns {int}
         */
        function totalSteps()
        {
            return vm.forms.length;
        }

        /**
         * Is first step?
         *
         * @returns {boolean}
         */
        function isFirstStep()
        {
            return vm.selectedIndex === 0;
        }

        /**
         * Is last step?
         *
         * @returns {boolean}
         */
        function isLastStep()
        {
            return vm.selectedIndex === totalSteps() - 1;
        }

        /**
         * Is current step invalid?
         *
         * @returns {boolean}
         */
        function currentStepInvalid()
        {
            return angular.isDefined(vm.forms[vm.selectedIndex]) && vm.forms[vm.selectedIndex].$invalid;
        }

        /**
         * Is previous step invalid?
         *
         * @returns {boolean}
         */
        function previousStepInvalid()
        {
            return vm.selectedIndex > 0 && angular.isDefined(vm.forms[vm.selectedIndex - 1]) && vm.forms[vm.selectedIndex - 1].$invalid;
        }

        /**
         * Check if there is any incomplete forms
         *
         * @returns {boolean}
         */
        function formsIncomplete()
        {
            for ( var x = 0; x < vm.forms.length; x++ )
            {
                if ( vm.forms[x].$invalid )
                {
                    return true;
                }
            }

            return false;
        }

        /**
         * Reset form
         */
        function resetForm()
        {
            // Go back to the first step
            vm.selectedIndex = 0;

            // Make sure all the forms are back in the $pristine & $untouched status
            for ( var x = 0; x < vm.forms.length; x++ )
            {
                vm.forms[x].$setPristine();
                vm.forms[x].$setUntouched();
            }
        }
    }

    /** @ngInject */
    function msFormWizardDirective()
    {
        return {
            restrict  : 'E',
            scope     : true,
            controller: 'MsFormWizardController as msWizard',
            compile   : function (tElement)
            {
                tElement.addClass('ms-form-wizard');

                return function postLink()
                {

                };
            }
        };
    }

    /** @ngInject */
    function msFormWizardFormDirective()
    {
        return {
            restrict: 'A',
            require : ['form', '^msFormWizard'],
            compile : function (tElement)
            {
                tElement.addClass('ms-form-wizard-form');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var formCtrl = ctrls[0],
                        MsFormWizardCtrl = ctrls[1];

                    MsFormWizardCtrl.registerForm(formCtrl);
                };
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msDatepickerFixConfig', msDatepickerFixConfigProvider)
        .directive('msDatepickerFix', msDatepickerFix);

    /** @ngInject */
    function msDatepickerFixConfigProvider()
    {
        var service = this;

        // Default configuration
        var defaultConfig = {
            // To view
            formatter: function (val)
            {
                if ( !val )
                {
                    return '';
                }

                return val === '' ? val : new Date(val);
            },
            // To model
            parser   : function (val)
            {
                if ( !val )
                {
                    return '';
                }

                return moment(val).add(moment(val).utcOffset(), 'm').toDate();
            }
        };

        // Methods
        service.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            defaultConfig = angular.extend({}, defaultConfig, configuration);
        }

        /**
         * Service
         */
        service.$get = function ()
        {
            return defaultConfig;
        };
    }

    /** @ngInject */
    function msDatepickerFix(msDatepickerFixConfig)
    {
        return {
            require : 'ngModel',
            priority: 1,
            link    : function (scope, elem, attrs, ngModel)
            {
                ngModel.$formatters.push(msDatepickerFixConfig.formatter); // to view
                ngModel.$parsers.push(msDatepickerFixConfig.parser); // to model
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msCard', msCardDirective);

    /** @ngInject */
    function msCardDirective()
    {
        return {
            restrict: 'E',
            scope   : {
                templatePath: '=template',
                card        : '=ngModel',
                vm          : '=viewModel'
            },
            template: '<div class="ms-card-content-wrapper" ng-include="templatePath" onload="cardTemplateLoaded()"></div>',
            compile : function (tElement)
            {
                // Add class
                tElement.addClass('ms-card');

                return function postLink(scope, iElement)
                {
                    // Methods
                    scope.cardTemplateLoaded = cardTemplateLoaded;

                    //////////

                    /**
                     * Emit cardTemplateLoaded event
                     */
                    function cardTemplateLoaded()
                    {
                        scope.$emit('msCard::cardTemplateLoaded', iElement);
                    }
                };
            }
        };
    }
})();
(function ()
{
	'use strict';

	angular
		.module('app.workOrders')
		.service("WorkOrderService", WorkOrderService);

	/** @ngInject */
	function WorkOrderService(WorkOrderAppointment, WorkOrderInventory, $state, WorkOrderPackage, $resource, api, WorkOrderRDGenerated, WorkOrderWarranty, WorkOrderJob, Warranty, GeneralTools, WorkOrderRDRedeemed, ToolsFactory, Const, $q, MessageService, LoginService, $filter, WorkOrder, HeaderHelper, WorkOrderPart, Labor, WorkOrderDiscount, WorkOrderPayment, ServiceMap, WorkOrderMechanic, WorkOrderLog, ConstantCacheService)
	{   
		var codeKey = Const.header.code;
		var messageKey = Const.header.message;
		var successCode = Const.code.success;
		const xhrStatusAbort = "abort";
		const baseUrl = GeneralTools.getBaseUrl();
		const noCacheHeader = GeneralTools.getNoCacheHeader();
		const baseHeader = GeneralTools.getBaseHeader();
		var header = {}
		header.token = LoginService.getToken();
		header["Cache-Control"] = "no-cache, no-store, must-revalidate";
		header["Pragma"] = "no-cache";
		header["Expires"] = 0;
		const errMsgFailedToFetchPackage = "Failed to fetch preset packages";
		const errMsgFailedToFetchNeWorkOrderWarrantyID = "";

		this.getLowestWorkOrderPriority = function(workOrderPriorities){
			if(!Array.isArray(workOrderPriorities)){
				return;
			}

			var lowestPriority;

			workOrderPriorities.forEach(function(priority){
				if(!priority){
					return;
				}

				if(!lowestPriority || (priority.value > lowestPriority.value)){
					lowestPriority = priority
				}
			});

			return lowestPriority;
		}

		this.createWorkOrder = function(resourcePath, requestBody){
			var defer = $q.defer();

			api.workOrders.postWorkOrder(
				resourcePath,
				requestBody,
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);
						defer.reject(errorMessage);
						return;
					}

					defer.resolve(response.data);
				},
				function(error){
					console.error("Failed to create workOrder.");
					defer.reject(error);
				}
			);

			return defer.promise;
		}

		this.getWorkOrderPriorities = function(){			
			var defer = $q.defer();

			api.getConstants.workOrderPriorities.get(
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);
						defer.reject(errorMessage);
						return;
					}

					defer.resolve(response);
				},
				function(error){
					console.error("Failed to get work order priorities.");
					defer.reject(error);
				}
			);

			return defer.promise;
		}

		this.getCachedWorkOrderPriorities = function () {
			return ConstantCacheService.get('work_order_priorities', function () {
				return this.getWorkOrderPriorities();
			}.bind(this));
		}

		this.getWorkOrderStatus = function(){			
			var defer = $q.defer();

			api.getConstants.workOrderStatus.get(
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);
						defer.reject(errorMessage);
						return;
					}

					defer.resolve(response);
				},
				function(error){
					console.error("Failed to get work order status.");
					defer.reject(error);
				}
			);

			return defer.promise;
		}

		this.getCachedWorkOrderStatus = function () {
			return ConstantCacheService.get('work_order_status', this.getWorkOrderStatus);
		}

		this.updateWorkOrder = function(resourcePath, requestBody){
			var defer = $q.defer();

			api.workOrders.updateWorkOrder(
				resourcePath,
				requestBody,
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);

						defer.reject(errorMessage);
						return;
					}
					defer.resolve(response);

				},
				function(error){
					console.error(error);
					defer.reject("Failed to update workOrder.");
				}
			);	

			return defer.promise;			
		}

		this.updateWorkOrderPayment = function(resourcePath, requestBody){
			var defer = $q.defer();
			requestBody.forEach(function(item){
				resourcePath.paymentID = item.paymentID
				resourcePath.fk_payment_status = item.fk_payment_status
				api.workOrderPayments.updateWorkOrderPayment(
					resourcePath,
					function(response, header){
						var statusCode  = header(codeKey);
	
						if(statusCode != successCode){
							var errorMessage = statusCode + ': ' + header(messageKey);
							defer.reject(errorMessage);
							return;
						}
	
						defer.resolve(response.data);
					},
					function(error){
						console.error("Failed to update payment status.");
						defer.reject(error);
					}
				);
			})
			return defer.promise;

			
		}

		this.getWorkOrders = function(resourcePath, filters, pagination, sorting){			
			var defer = $q.defer();
			var queryParams = Object.assign({}, resourcePath, filters, pagination, sorting);
			return api.workOrders.getWorkOrders(queryParams);
		}

		this.getWorkOrderDetails = function(resourcePath, filters, pagination, sorting){			
			var defer = $q.defer();
			var queryParams = Object.assign({}, resourcePath, filters, pagination, sorting);
			return api.workOrderDetails.getWorkOrders(queryParams);
		}

		this.getCompanyLevelWarrantyPaymentWorkOrders = function(resourcePath, workorderFilters, vehicleFilters, pagination, sorting){		
			var defer = $q.defer();
			var queryParams = Object.assign({}, resourcePath, workorderFilters, vehicleFilters, pagination, sorting, {containWarrantyPayment: true});
			api.companyLevelWorkOrders.getWorkOrders(
				queryParams,
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);
						defer.reject(errorMessage);
						return;
					}

					var workOrderList = [];

					response.forEach(function(data){
						var workOrder = new WorkOrder();

						workOrder.setAttributes(data);
						workOrderList.push(workOrder);
					})

					var result = {
						data: workOrderList,
						headerGetter: header
					}

					defer.resolve(result);
				},
				function(error){
					console.error("Failed to get workOrder.");
					defer.reject(error);
				}
			);

			return defer.promise;
		}

		this.getCompanyLevelOutstandingWorkOrders = function(resourcePath, workorderFilters, vehicleFilters, pagination, sorting){		
			var defer = $q.defer();
			var queryParams = Object.assign({}, resourcePath, workorderFilters, vehicleFilters, pagination, sorting, {containOutstanding: true});
			api.companyLevelWorkOrders.getWorkOrders(
				queryParams,
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);
						defer.reject(errorMessage);
						return;
					}

					var workOrderList = [];

					response.forEach(function(data){
						var workOrder = new WorkOrder();

						workOrder.setAttributes(data);
						workOrderList.push(workOrder);
					})

					var result = {
						data: workOrderList,
						headerGetter: header
					}

					defer.resolve(result);
				},
				function(error){
					console.error("Failed to get workOrder.");
					defer.reject(error);
				}
			);

			return defer.promise;
		}

		this.getCompanyLevelPendingWorkOrders = function(resourcePath, workorderFilters, vehicleFilters, pagination, sorting){		
			var defer = $q.defer();
			var queryParams = Object.assign({}, resourcePath, workorderFilters, vehicleFilters, pagination, sorting, {containPending: true});
			api.companyLevelWorkOrders.getWorkOrders(
				queryParams,
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);
						defer.reject(errorMessage);
						return;
					}

					var workOrderList = [];

					response.forEach(function(data){
						var workOrder = new WorkOrder();

						workOrder.setAttributes(data);
						workOrderList.push(workOrder);
					})

					var result = {
						data: workOrderList,
						headerGetter: header
					}

					defer.resolve(result);
				},
				function(error){
					console.error("Failed to get workOrder.");
					defer.reject(error);
				}
			);

			return defer.promise;
		}

		this.getCompanyLevelIncompletePartWithAppointmentWorkOrders = function(resourcePath, workorderFilters, vehicleFilters, pagination, sorting){		
			var defer = $q.defer();
			var queryParams = Object.assign({}, resourcePath, workorderFilters, vehicleFilters, pagination, sorting, {containOrderedPartAndAppointment: true});
			api.companyLevelWorkOrders.getWorkOrders(
				queryParams,
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);
						defer.reject(errorMessage);
						return;
					}

					var workOrderList = [];

					response.forEach(function(data){
						var workOrder = new WorkOrder();

						workOrder.setAttributes(data);
						workOrderList.push(workOrder);
					})

					var result = {
						data: workOrderList,
						headerGetter: header
					}

					defer.resolve(result);
				},
				function(error){
					console.error("Failed to get workOrder.");
					defer.reject(error);
				}
			);

			return defer.promise;
		}

		this.getCompanyLevelIncompletePartWitouthAppointmentWorkOrders = function(resourcePath, workorderFilters, vehicleFilters, pagination, sorting){		
			var defer = $q.defer();
			var queryParams = Object.assign({}, resourcePath, workorderFilters, vehicleFilters, pagination, sorting, {containOrderedPartWithoutAppointmentExcludeFullySubsidized: true});
			api.companyLevelWorkOrders.getWorkOrders(
				queryParams,
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);
						defer.reject(errorMessage);
						return;
					}

					var workOrderList = [];

					response.forEach(function(data){
						var workOrder = new WorkOrder();

						workOrder.setAttributes(data);
						workOrderList.push(workOrder);
					})

					var result = {
						data: workOrderList,
						headerGetter: header
					}

					defer.resolve(result);
				},
				function(error){
					console.error("Failed to get workOrder.");
					defer.reject(error);
				}
			);

			return defer.promise;
		}

		this.getCompanyLevelWorkOrders = function(resourcePath, workorderFilters, vehicleFilters, pagination, sorting, customerListId){		
			var defer = $q.defer();
			var queryParams = Object.assign({}, resourcePath, workorderFilters, vehicleFilters, pagination, sorting, {customerListId: customerListId});
			api.companyLevelWorkOrders.getWorkOrders(
				queryParams,
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);
						defer.reject(errorMessage);
						return;
					}

					var workOrderList = [];

					response.forEach(function(data){
						var workOrder = new WorkOrder();

						workOrder.setAttributes(data);
						workOrderList.push(workOrder);
					})

					var result = {
						data: workOrderList,
						headerGetter: header
					}

					defer.resolve(result);
				},
				function(error){
					console.error("Failed to get workOrder.");
					defer.reject(error);
				}
			);

			return defer.promise;
		}

		this.getWorkOrderParts = function(resourcePath){
			return api.workOrderParts.getParts(resourcePath);
		}

		this.getWorkOrderInventories = function(resourcePath){
			return api.workOrderInventories.getInventories(resourcePath);
		}

		this.updateWorkOrderInventory = function(resourcePath, requestBody){			
			var defer = $q.defer();

			api.workOrderInventories.updateInventory(
				resourcePath,
				requestBody,
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);
						defer.reject(errorMessage);
						return;
					}

					defer.resolve(response);
				},
				function(error){
					console.error("Failed to update workOrder inventory.");
					defer.reject(error);
				}
			);

			return defer.promise;
		}

		this.createWorkOrderInventory = function(resourcePath, requestBody){
			var defer = $q.defer();

			api.workOrderInventories.postInventory(
				resourcePath,
				requestBody,
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);
						defer.reject(errorMessage);
						return;
					}

					defer.resolve(response.data);
				},
				function(error){
					console.error("Failed to create work order inventory.");
					defer.reject(error);
				}
			);

			return defer.promise;
		}

		this.deleteWorkOrderInventory = function(resourcePath){
			var defer = $q.defer();

			api.workOrderInventories.deleteInventory(
				resourcePath,
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);
						defer.reject(errorMessage);
						return;
					}

					defer.resolve(response);
				},
				function(error){
					console.error("Failed to delete inventory.");
					defer.reject(error);
				}
			);

			return defer.promise;
		}

		this.getLabors = function(resourcePath){	
			return api.labors.getLabors(resourcePath);
		}

		this.getMiscfeestype = function(resourcePath){
			return api.miscfeestypes.getmiscfeestypes(resourcePath);
		}

		this.getJobtypes = function(resourcePath){
			return api.jobtypes.getJob(resourcePath);
		}

		this.createServiceMap = function(resourcePath, requestBody){
			var defer = $q.defer();

			api.serviceMaps.postServiceMap(
				resourcePath,
				requestBody,
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);
						defer.reject(errorMessage);
						return;
					}

					defer.resolve(response.data);
				},
				function(error){
					console.error("Failed to create service map.");
					defer.reject(error);
				}
			);

			return defer.promise;
		}

		this.getAllMatchedServiceMaps = function(resourcePath, filters, sorting){
			const limit = 100;
			const _this = this;
			var serviceMapList = [];
			
			return _this.getServiceMaps(resourcePath, filters, {page: 1, limit: limit}, sorting)
				.then(function(response){
					if(!response || !Array.isArray(response.data)){
						return $q.reject("Failed to fetch serviceMaps for report.");
					}

					serviceMapList = serviceMapList.concat(response.data);

					var totalItem = HeaderHelper.getPaginationTotalItem(response.headerGetter);
					var currentPage = HeaderHelper.getPaginationCurrentPage(response.headerGetter);
					var itemsPerPage = HeaderHelper.getPaginationItemsPerPage(response.headerGetter);

					var queue = [];

					if(response.data.length < totalItem){
						var totalPage = Math.ceil(totalItem/itemsPerPage);

						for(var i = 2; i <= totalPage; i++){
							queue.push(_this.getServiceMaps(resourcePath, filters, {page: i, limit: limit}, sorting));
						}
					}

					return $q.all(queue);
				})
				.then(function(responseList){
					if(!Array.isArray(responseList)){
						return $q.reject("Failed to fetch serviceMaps for report.");
					}

					for(var i = 0; i < responseList.length; i++){
						var response = responseList[i];

						if(!response || !Array.isArray(response.data)){
							return $q.reject("Failed to fetch serviceMaps for report.");
						}

						serviceMapList = serviceMapList.concat(response.data);
					}

					return $q.resolve(serviceMapList);
				});
		}

		this.getServiceMaps = function(resourcePath, filters, pagination, sorting){			
			var defer = $q.defer();
			var queryParams = Object.assign({}, resourcePath, filters, pagination, sorting);

			api.serviceMaps.getServiceMaps(
				queryParams,
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);
						defer.reject(errorMessage);
						return;
					}

					var serviceMapList = [];

					response.forEach(function(data){
						var serviceMap = new ServiceMap();

						serviceMap.setAttributes(data);
						serviceMapList.push(serviceMap);
					})

					var result = {
						data: serviceMapList,
						headerGetter: header
					}

					defer.resolve(result);
				},
				function(error){
					console.error("Failed to get serviceMap.");
					defer.reject(error);
				}
			);

			return defer.promise;
		}

		this.deleteServiceMap = function(resourcePath){
			var defer = $q.defer();

			api.serviceMaps.deleteServiceMap(
				resourcePath,
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);
						defer.reject(errorMessage);
						return;
					}

					defer.resolve(response);
				},
				function(error){
					console.error("Failed to delete service map.");
					defer.reject(error);
				}
			);

			return defer.promise;
		}

		this.getMechanics = function(resourcePath){			
			var defer = $q.defer();

			api.workOrderMechanics.getMechanics(
				resourcePath,
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);
						defer.reject(errorMessage);
						return;
					}

					var mechanicList = [];

					response.forEach(function(data){
						var mechanic = new WorkOrderMechanic();

						mechanic.setAttributes(data);
						mechanicList.push(mechanic);
					})

					defer.resolve(mechanicList);
				},
				function(error){
					console.error("Failed to get workOrder mechanics.");
					defer.reject(error);
				}
			);

			return defer.promise;
		}

		this.addMechanic = function(resourcePath, requestBody){
			var defer = $q.defer();

			api.workOrderMechanics.postMechanic(
				resourcePath,
				requestBody,
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);
						defer.reject(errorMessage);
						return;
					}

					defer.resolve(response.data);
				},
				function(error){
					console.error("Failed to add mechanic.");
					defer.reject(error);
				}
			);

			return defer.promise;
		}
		

		this.removeMechanic = function(resourcePath){
			var defer = $q.defer();

			api.workOrderMechanics.deleteMechanic(
				resourcePath,
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);
						defer.reject(errorMessage);
						return;
					}

					defer.resolve(response);
				},
				function(error){
					console.error("Failed to remove mechanic.");
					defer.reject(error);
				}
			);

			return defer.promise;
		}

		this.updateWorkOrderParts = function(resourcePath, requestBody){			
			var defer = $q.defer();

			api.workOrderParts.updatePart(
				resourcePath,
				requestBody,
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);
						defer.reject(errorMessage);
						return;
					}

					defer.resolve(response);
				},
				function(error){
					console.error("Failed to update workOrder parts.");
					defer.reject(error);
				}
			);

			return defer.promise;
		}

		this.createWorkOrderPart = function(resourcePath, requestBody){
			var defer = $q.defer();

			api.workOrderParts.postPart(
				resourcePath,
				requestBody,
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);
						defer.reject(errorMessage);
						return;
					}

					defer.resolve(response.data);
				},
				function(error){
					console.error("Failed to create work order part.");
					defer.reject(error);
				}
			);

			return defer.promise;
		}

		this.deleteWorkOrderPart = function(resourcePath){
			var defer = $q.defer();

			api.workOrderParts.deletePart(
				resourcePath,
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);
						defer.reject(errorMessage);
						return;
					}

					defer.resolve(response);
				},
				function(error){
					console.error("Failed to delete part.");
					defer.reject(error);
				}
			);

			return defer.promise;
		}

		this.getSuggestedLaborPrice = function(resourcePath){			
			var defer = $q.defer();

			api.suggestedlaborPrice.getLaborPrice(
				resourcePath,
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);
						defer.reject(errorMessage);
						return;
					}

					defer.resolve(response);
				},
				function(error){
					console.error("Failed to get suggested labor price.");
					defer.reject(error);
				}
			);

			return defer.promise;
		}

		this.getCachedSuggestedLaborPrice = function(resourcePath) {
			var cacheKey = getSuggestedLaborPriceCacheKey(resourcePath);
			var ttl = 30 * 60 * 1000; // 30 minutes

			return ConstantCacheService.get(cacheKey, function () {
				return this.getSuggestedLaborPrice(resourcePath);
			}.bind(this), ttl);
		}

		function getSuggestedLaborPriceCacheKey(resourcePath) {
			if (resourcePath && resourcePath.companyID) {
				return 'suggested_labor_price_company_' + resourcePath.companyID;
			}

			return 'suggested_labor_price';
		}

		this.createLabor = function(resourcePath, requestBody){

			delete requestBody.labour_name

			var defer = $q.defer();

			api.labors.postLabor(
				resourcePath,
				requestBody,
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);
						defer.reject(errorMessage);
						return;
					}
					defer.resolve(response.data);
				},
				function(error){
					console.error("Failed to create labor.");
					defer.reject(error);
				}
			);

			return defer.promise;
		}

		this.createmiscfees = function(resourcePath, requestBody){

			var defer = $q.defer();

			api.miscfeestypes.createmiscfeestypes(
				resourcePath,
				requestBody,
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);
						defer.reject(errorMessage);
						return;
					}
					defer.resolve(response.data);
				},
				function(error){
					console.error("Failed to create misc fee.");
					defer.reject(error);
				}
			);

			return defer.promise;
		}

		this.updateLabor = function(resourcePath, requestBody){
			var defer = $q.defer();
			delete requestBody.labour_name
			api.labors.updateLabor(
				resourcePath,
				requestBody,
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);

						defer.reject(errorMessage);
						return;
					}
					defer.resolve(response);

				},
				function(error){
					console.error(error);
					defer.reject("Failed to update labor.");
				}
			);	

			return defer.promise;			
		}

		this.updateMiscfees = function(resourcePath, requestBody){
			var defer = $q.defer();
			api.miscfeestypes.updatemiscfeestypes(
				resourcePath,
				requestBody,
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);

						defer.reject(errorMessage);
						return;
					}
					defer.resolve(response);

				},
				function(error){
					console.error(error);
					defer.reject("Failed to update labor.");
				}
			);	

			return defer.promise;			
		}

		this.deleteLabor = function(resourcePath){
			var defer = $q.defer();

			api.labors.deleteLabor(
				resourcePath,
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);
						defer.reject(errorMessage);
						return;
					}

					defer.resolve(response);
				},
				function(error){
					console.error("Failed to delete labor.");
					defer.reject(error);
				}
			);

			return defer.promise;
		}

		
		this.deleteMiscfees = function(resourcePath){
			var defer = $q.defer();

			api.miscfeestypes.deletemiscfeestypes(
				resourcePath,
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);
						defer.reject(errorMessage);
						return;
					}

					defer.resolve(response);
				},
				function(error){
					console.error("Failed to delete Misc fees.");
					defer.reject(error);
				}
			);

			return defer.promise;
		}

		this.getDiscounts = function(resourcePath){	
			return api.workOrderDiscounts.getDiscounts(resourcePath);
		}

		this.getCoupons = function(resourcePath){	
			return api.workOrderCoupons.getCoupons(resourcePath);
		}

		this.addWorkOrderCoupons = function(resourcePath, requestBody){	
			var defer = $q.defer();

			api.workOrderCoupons.addWorkOrderDiscount(
				resourcePath,
				requestBody,
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);
						defer.reject(errorMessage);
						return;
					}

					const discount = new WorkOrderDiscount();
					discount.setAttributes(response);
					defer.resolve(discount);
				},
				function(error){
					console.error("Failed to create discount.");
					defer.reject(error);
				}
			);

			return defer.promise;
		}

		this.createDiscount = function(resourcePath, requestBody){
			var defer = $q.defer();

			api.workOrderDiscounts.postDiscount(
				resourcePath,
				requestBody,
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);
						defer.reject(errorMessage);
						return;
					}

					defer.resolve(response.data);
				},
				function(error){
					console.error("Failed to create discount.");
					defer.reject(error);
				}
			);

			return defer.promise;
		}

		this.deleteDiscount = function(resourcePath){
			var defer = $q.defer();

			api.workOrderDiscounts.deleteDiscount(
				resourcePath,
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);
						defer.reject(errorMessage);
						return;
					}

					defer.resolve(response);
				},
				function(error){
					console.error("Failed to delete discount.");
					defer.reject(error);
				}
			);

			return defer.promise;
		}

		this.getPayments = function(resourcePath){
			return api.workOrderPayments.getPayments(resourcePath);
		}

		this.createPayment = function(resourcePath, requestBody){
			var defer = $q.defer();
			api.workOrderPayments.postPayment(
				resourcePath,
				requestBody,
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);
						defer.reject(errorMessage);
						return;
					}

					defer.resolve(response.data);
				},
				function(error){
					console.error("Failed to create payment.");
					defer.reject(error);
				}
			);

			return defer.promise;
		}

		this.deletePayment = function(resourcePath){
			var defer = $q.defer();

			api.workOrderPayments.deletePayment(
				resourcePath,
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);
						defer.reject(errorMessage);
						return;
					}

					defer.resolve(response);
				},
				function(error){
					console.error("Failed to delete payment.");
					defer.reject(error);
				}
			);

			return defer.promise;
		}


		this.getFiles = function(resourcePath){			
			var defer = $q.defer();

			api.workOrderFiles.getFiles(
				resourcePath,
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);
						defer.reject(errorMessage);
						return;
					}

					defer.resolve(response);
				},
				function(error){
					console.error("Failed to get workOrder files.");
					defer.reject(error);
				}
			);

			return defer.promise;
		}

		this.deleteFile = function(resourcePath){			
			var defer = $q.defer();

			api.workOrderFiles.deleteFile(
				resourcePath,
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);
						defer.reject(errorMessage);
						return;
					}

					defer.resolve(response);
				},
				function(error){
					console.error("Failed to delete workOrder file.");
					defer.reject(error);
				}
			);

			return defer.promise;
		}

		this.getAllMatchedAppointments = function(resourcePath, filters, sorting){
			const limit = 100;
			const _this = this;
			var appointmentList = [];
			
			return _this.getAppointments(resourcePath, filters, {page: 1, limit: limit}, sorting)
				.then(function(response){
					if(!response || !Array.isArray(response.data)){
						return $q.reject("Failed to fetch appointments for report.");
					}

					appointmentList = appointmentList.concat(response.data);

					var totalItem = HeaderHelper.getPaginationTotalItem(response.headerGetter);
					var currentPage = HeaderHelper.getPaginationCurrentPage(response.headerGetter);
					var itemsPerPage = HeaderHelper.getPaginationItemsPerPage(response.headerGetter);

					var queue = [];

					if(response.data.length < totalItem){
						var totalPage = Math.ceil(totalItem/itemsPerPage);

						for(var i = 2; i <= totalPage; i++){
							queue.push(_this.getAppointments(resourcePath, filters, {page: i, limit: limit}, sorting));
						}
					}

					return $q.all(queue);
				})
				.then(function(responseList){
					if(!Array.isArray(responseList)){
						return $q.reject("Failed to fetch appointments for report.");
					}

					for(var i = 0; i < responseList.length; i++){
						var response = responseList[i];

						if(!response || !Array.isArray(response.data)){
							return $q.reject("Failed to fetch appointments for report.");
						}

						appointmentList = appointmentList.concat(response.data);
					}

					return $q.resolve(appointmentList);
				});
		}

		this.getAppointments = function(resourcePath, filters, pagination, sorting){			
			var defer = $q.defer();
			var queryParams = Object.assign({}, resourcePath, filters, pagination, sorting);

			api.workOrderAppointments.getAppointments(
				queryParams,
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);
						defer.reject(errorMessage);
						return;
					}

					var appointmentList = [];

					response.forEach(function(data){
						var appointment = new WorkOrderAppointment();

						appointment.setAttributes(data);
						appointmentList.push(appointment);
					})

					var result = {
						data: appointmentList,
						headerGetter: header
					}

					defer.resolve(result);
				},
				function(error){
					console.error("Failed to get appointment.");
					defer.reject(error);
				}
			);

			return defer.promise;
		}

		this.createAppointment = function(resourcePath, requestBody){
			var defer = $q.defer();

			api.workOrderAppointments.postAppointment(
				resourcePath,
				requestBody,
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);
						defer.reject(errorMessage);
						return;
					}

					defer.resolve(response.data);
				},
				function(error){
					console.error("Failed to create work order appointment.");
					defer.reject(error);
				}
			);

			return defer.promise;
		}

		this.updateAppointment = function(resourcePath, requestBody){
			var defer = $q.defer();

			api.workOrderAppointments.updateAppointment(
				resourcePath,
				requestBody,
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);

						defer.reject(errorMessage);
						return;
					}
					defer.resolve(response);

				},
				function(error){
					console.error(error);
					defer.reject("Failed to update work order appointment.");
				}
			);	

			return defer.promise;
		}

		this.deleteAppointment = function(resourcePath){			
			var defer = $q.defer();

			api.workOrderAppointments.deleteAppointment(
				resourcePath,
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);
						defer.reject(errorMessage);
						return;
					}

					defer.resolve(response);
				},
				function(error){
					console.error("Failed to delete workOrder appointment.");
					defer.reject(error);
				}
			);

			return defer.promise;
		}

		this.deleteWorkOrder = function(resourcePath){
			var defer = $q.defer();

			api.workOrders.deleteWorkOrder(
				resourcePath,
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);
						defer.reject(errorMessage);
						return;
					}

					defer.resolve(response);
				},
				function(error){
					var errorMessage = error.status + ': ' + error.statusText;
					defer.reject(errorMessage);
				}
			);

			return defer.promise;
		}

		this.getWorkorderPaymentStatus = function(){			
			return api.getConstants.getWorkorderPaymentStatus.get();
		}

		const workOrderpackage = $resource(
			baseUrl + "companies/:companyID/vehicles/:vehicleID/workorders/:workorderID/packages/:packageID",
			{	
				companyID: "@companyID",
				vehicleID: "@vehicleID",
				workorderID: "@workorderID",
				packageID: "@packageID"
			},
			{	
				getWorkorderPackages:{
					method:"GET",
					isArray:true,
					headers: noCacheHeader,
					cancellable: true,
					interceptor:{
						response: function(result){
							const statusCode  = result.headers(Const.header.code);

							if(statusCode != Const.code.success){
								console.error(statusCode, result.headers(Const.header.message));
								return $q.reject(errMsgFailedToFetchPackage);
							}

							return result.data.map(function(data){
								var workorderPackage = new WorkOrderPackage();

								workorderPackage.setAttributes(data);
								return workorderPackage;
							});
						},
						responseError: function (error){
							if(error && error.xhrStatus == Const.xhrStatus.abort){
								return $q.reject();
							}
							console.error(error);
							return $q.reject(error);
						}
					}
				},	
				createWorkorderPackage:{
					method:"POST",
					headers: baseHeader,
					interceptor:{
						response: function(result){
							const statusCode  = result.headers(Const.header.code);

							if(statusCode != Const.code.success){
								console.error(statusCode, result.headers(Const.header.message));
								return $q.reject(errMsgFailedToFetchPackage);
							}

							if(!result.data){
								console.error(errMsgFailedToFetchNewPackageID);
								return $q.reject(errMsgFailedToFetchNewPackageID);
							}

							return result.data.data;
						},
						responseError: function (error){
							if(error && error.xhrStatus == Const.xhrStatus.abort){
								return $q.reject();
							}
							console.error(error);
							return $q.reject(error);
						}
					}
				},
				deleteWorkorderPackage:{
					method:"DELETE",
					headers: baseHeader,
					interceptor:{
						response: function(result){
							const statusCode  = result.headers(Const.header.code);

							if(result.headers(Const.header.code) != Const.code.success){
								console.error(statusCode, result.headers(Const.header.message));
								return $q.reject(errMsgFailedToFetchPackage);
							}

							return $q.resolve();
						},
						responseError: function (error){
							if(error && error.xhrStatus == Const.xhrStatus.abort){
								return $q.reject();
							}
							console.error(error);
							return $q.reject(error);
						}
					}
				}								
		});

		const workOrderPackageItems = $resource(
			baseUrl + "companies/:companyID/vehicles/:vehicleID/workorders/:workorderID/packages/:packageID/packageitems/:packageitemID",
			{	
				companyID: "@companyID",
				vehicleID: "@vehicleID",
				workorderID: "@workorderID",
				packageID: "@packageID",
				packageitemID: "@packageitemID"
			},
			{	
				getWorkOrderpackageItems:{
					method:"GET",
					isArray:true,
					headers: noCacheHeader,
					cancellable: true,
					interceptor:{
						response: function(result){
							const statusCode  = result.headers(Const.header.code);

							if(statusCode != Const.code.success){
								console.error(statusCode, result.headers(Const.header.message));
								return $q.reject(errMsgFailedToFetchPackage);
							}
							
							return result.data;
						},
						responseError: function (error){
							if(error && error.xhrStatus == Const.xhrStatus.abort){
								return $q.reject();
							}
							console.error(error);
							return $q.reject(error);
						}
					}
				}								
		});

		const redeemWorkOrderPackageItemApi = $resource(
			baseUrl + "companies/:companyID/vehicles/:vehicleID/workorders/:workorderID/packages/:packageID/packageitems/:packageitemID/redeem",
			{	
				companyID: "@companyID",
				vehicleID: "@vehicleID",
				workorderID: "@workorderID",
				packageID: "@packageID",
				packageitemID: "@packageitemID"
			},
			{	
				redeemWorkOrderItem:{
					method:"PUT",
					headers: baseHeader,
					interceptor:{
						response: function(result){
							const statusCode  = result.headers(Const.header.code);

							if(result.headers(Const.header.code) != Const.code.success){
								console.error(statusCode, result.headers(Const.header.message));
								return $q.reject(errMsgFailedToFetchPackage);
							}

							return $q.resolve();
						},
						responseError: function (error){
							if(error && error.xhrStatus == Const.xhrStatus.abort){
								return $q.reject();
							}
							console.error(error);
							return $q.reject(error);
						}
					}
				}								
		});

		const workOrderWarranties = $resource(
			baseUrl + "companies/:companyID/vehicles/:vehicleID/workorders/:workorderID/warranties/:warrantyID",
			{
				companyID: "@companyID",
				vehicleID: "@vehicleID",
				workorderID: "@workorderID",
				warrantyID: "@warrantyID",
			},
			{
				getWorkOrderWarranties: {
					method:"GET",
					isArray:true,
					headers: noCacheHeader,
					cancellable: true,
					interceptor:{
						response: function(result){

							const statusCode  = result.headers(Const.header.code);
							if(statusCode != Const.code.success){
								console.error(statusCode, result.headers(Const.header.message));
								return $q.reject(errMsgFailedToFetchPackage);
							}
							return result.data.map(function(data){
								var workOrderWarranty = new WorkOrderWarranty();

								workOrderWarranty.setAttributes(data);
								return workOrderWarranty;
							});
						},
						responseError: function (error){
							if(error && error.xhrStatus == Const.xhrStatus.abort){
								return $q.reject();
							}
							console.error(error);
							return $q.reject(error);
						}
					}
				},	
				createWarranty: {
					method: "POST",
					headers: {
						token: LoginService.getToken()
					}
				},
				updateWarranty: {
					method: "PUT",
					headers: {
						token: LoginService.getToken()
					}
				},
				deleteWorkOrderWarranty: {
					method:"DELETE",
					headers: baseHeader,
					interceptor:{
						response: function(result){
							const statusCode  = result.headers(Const.header.code);

							if(result.headers(Const.header.code) != Const.code.success){
								console.error(statusCode, result.headers(Const.header.message));
								return $q.reject(errMsgFailedToFetchPackage);
							}

							return $q.resolve();
						},
						responseError: function (error){
							if(error && error.xhrStatus == Const.xhrStatus.abort){
								return $q.reject();
							}
							console.error(error);
							return $q.reject(error);
						}
					}
				}
			});

		this.getWorkOrderPackages = function(resourcePath, body){
			if(body){
				resourcePath.iscompleted = body.iscompleted
				return workOrderpackage.getWorkorderPackages(resourcePath, body);
			}else{
				return workOrderpackage.getWorkorderPackages(resourcePath);
			}
			
		}

		this.createWorkOrderPackage = function(resourcePath, requesetBody){
			return workOrderpackage.createWorkorderPackage(resourcePath, requesetBody);
		}

		this.deleteWorkOrderPackage = function(resourcePath){
			return workOrderpackage.deleteWorkorderPackage(resourcePath);
		}

		this.getWorkOrderpackageItems = function(resourcePath){
			return workOrderPackageItems.getWorkOrderpackageItems(resourcePath);
		}

		this.redeemWorkOrderPackageItem = function(resourcePath){
			return redeemWorkOrderPackageItemApi.redeemWorkOrderItem(resourcePath);
		}

		this.sendCustomerRegistrationEmail = function(resourcePath, requestBody){
			var defer = $q.defer();

			api.customeregistration.sendCustomerRegistrationEmail(
				resourcePath,
				requestBody,
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);
						defer.reject(errorMessage);
						return;
					}

					defer.resolve(response.data);
				},
				function(error){
					console.error("Failed to send customer registration email.");
					defer.reject(error);
				}
			);

			return defer.promise;
		}

		
		this.createWorkOrderWarranty = function(resourcePath, requestBody){
			// return workOrderWarranties.createWarranty(resourcePath, requestBody);			

			var defer = $q.defer();

			workOrderWarranties.createWarranty(
				resourcePath,
				requestBody,
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);
						defer.reject(errorMessage);
						return;
					}

					defer.resolve(response.data);
				},
				function(error){
					console.error("Failed to create work order warranty.");
					defer.reject(error);
				}
			);

			return defer.promise;
		}

		this.getWorkOrderWarranties = function(resourcePath, body){
			if(body){
				resourcePath.iscompleted = body.iscompleted
				return workOrderWarranties.getWorkOrderWarranties(resourcePath, body);
			}else{
				return workOrderWarranties.getWorkOrderWarranties(resourcePath);
			}
		}

		this.getWorkOrderWarrantyOptions = function(resourcePath){
			var defer = $q.defer();

			api.warranties.getWrranties(
				resourcePath,
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);

						defer.reject(errorMessage);
						return;
					}

					if(!Array.isArray(response)){
						defer.reject("Warranty option is not an array");
						return;
					}

					var warrantyList = [];

					response.forEach(function(warrantyData){
						if(warrantyData == null){
							return;
						}

						var warranty = new Warranty();
						warranty.setAttributes(warrantyData);

						warrantyList.push(warranty);
					});

					defer.resolve(warrantyList);

				},
				function(error){
					console.error(error);
					defer.reject("Failed to get Work Order Warranties options");
				}
			);	

			return defer.promise;			
		}

		this.updateWorkOrderWarranty = function(resourcePath, requestBody){
			var defer = $q.defer();

			workOrderWarranties.updateWarranty(
				resourcePath,
				requestBody,
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);

						defer.reject(errorMessage);
						return;
					}
					defer.resolve(response);

				},
				function(error){
					console.error(error);
					defer.reject("Failed to update work order warranty.");
				}
			);	

			return defer.promise;			
		}

		this.deleteWorkOrderWarranty = function(resourcePath){
			return workOrderWarranties.deleteWorkOrderWarranty(resourcePath);
		}




		const workOrderRogerDollarGenerated = $resource(
			baseUrl + "companies/:companyID/vehicles/:vehicleID/workorders/:workorderID/rgdollars/:rgdollarID",
			{
				companyID: "@companyID",
				vehicleID: "@vehicleID",
				workorderID: "@workorderID",
				rgdollarID: "@rgdollarID",
			},
			{
				getRDGenerated: {
					method: "GET",
					isArray: true,
					headers: header,
					cancellable: true,
					interceptor: {
						response: function (result) {
							var statusCode = result.headers(codeKey);

							if (statusCode != successCode) {
								var errorMessage = statusCode + ': ' + result.headers(messageKey);
								console.error("Failed to get WorkOrder Rogers Dollar Generated.");
								return $q.reject(errorMessage);
							}

							return result.data.map(function (data) {
								var discount = new WorkOrderRDGenerated();

								discount.setAttributes(data);
								return discount;
							});
						},
						responseError: function (error) {
							if (error && error.xhrStatus == xhrStatusAbort) {
								return $q.reject();
							}
							console.error("Failed to get WorkOrder Rogers Dollar Generated.");
							return $q.reject(error);
						}
					}
				},

				generateRDdollar: {
					method: "POST",
					headers: {
						token: LoginService.getToken()
					}
				}
			});

		this.generateRD = function(resourcePath, requestBody){
			var defer = $q.defer();
			workOrderRogerDollarGenerated.generateRDdollar(
				resourcePath,
				requestBody,
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);
						defer.reject(errorMessage);
						return;
					}

					defer.resolve(response.data);
				},
				function(error){
					console.error("Failed to create work order warranty.");
					defer.reject(error);
				}
			);

			return defer.promise;
		}

		this.getgeneratedRD = function(resourcePath){	
			return workOrderRogerDollarGenerated.getRDGenerated(resourcePath);
		}

		const workOrderRogerDollarRedeem = $resource(
			baseUrl + "companies/:companyID/vehicles/:vehicleID/workorders/:workorderID/rgdollarsredeem/:rgdollarsredeemID",
			{
				companyID: "@companyID",
				vehicleID: "@vehicleID",
				workorderID: "@workorderID",
				rgdollarsredeemID: "@rgdollarsredeemID",
			},
			{

				getRDRedeemed: {
					method: "GET",
					isArray: true,
					headers: header,
					cancellable: true,
					interceptor: {
						response: function (result) {
							var statusCode = result.headers(codeKey);

							if (statusCode != successCode) {
								var errorMessage = statusCode + ': ' + result.headers(messageKey);
								console.error("Failed to get WorkOrder Rogers Dollar Redeemed.");
								return $q.reject(errorMessage);
							}

							return result.data.map(function (data) {
								var discount = new WorkOrderRDRedeemed();

								discount.setAttributes(data);
								return discount;
							});
						},
						responseError: function (error) {
							if (error && error.xhrStatus == xhrStatusAbort) {
								return $q.reject();
							}
							console.error("Failed to get WorkOrder Rogers Dollar Redeemed.");
							return $q.reject(error);
						}
					}
				},


				redeemRDdollar: {
					method: "POST",
					headers: {
						token: LoginService.getToken()
					}
				},

				deleteRogersDollarRedeem: {
					method: "DELETE",
					headers: {
						token: LoginService.getToken()
					}
				}
			});

		this.redeemRogerDollar = function(resourcePath, requestBody){
			var defer = $q.defer();
			workOrderRogerDollarRedeem.redeemRDdollar(
				resourcePath,
				requestBody,
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);
						defer.reject(errorMessage);
						return;
					}

					defer.resolve(response.data);
				},
				function(error){
					console.error("Failed to redeem rogers dollar.");
					defer.reject(error);
				}
			);

			return defer.promise;
		}

		this.getredeemedRD = function(resourcePath){	
			return workOrderRogerDollarRedeem.getRDRedeemed(resourcePath);
		}


		this.deleteRDRedeem = function(resourcePath){
			var defer = $q.defer();
			workOrderRogerDollarRedeem.deleteRogersDollarRedeem(
				resourcePath,
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);
						defer.reject(errorMessage);
						return;
					}

					defer.resolve(response);
				},
				function(error){
					console.error("Failed to delete RDRedeem.");
					defer.reject(error);
				}
			);

			return defer.promise;
		}




		const workOrderJob = $resource(
			baseUrl + "companies/:companyID/vehicles/:vehicleID/workorders/:workorderID/workorderjob/:workorderjobID",
			{
				companyID: "@companyID",
				vehicleID: "@vehicleID",
				workorderID: "@workorderID",
				workorderjob: "@workorderjobID"
			},
			{
				getJob: {
					method: "GET",
					isArray: true,
					headers: header,
					cancellable: true,
					interceptor: {
						response: function (result) {
							var statusCode = result.headers(codeKey);

							if (statusCode != successCode) {
								var errorMessage = statusCode + ': ' + result.headers(messageKey);
								console.error("Failed to get WorkOrder Job.");
								return $q.reject(errorMessage);
							}

							return result.data.map(function (data) {
								var job = new WorkOrderJob();

								job.setAttributes(data);
								return job;
							});
						},
						responseError: function (error) {
							if (error && error.xhrStatus == xhrStatusAbort) {
								return $q.reject();
							}
							console.error("Failed to get WorkOrder Job.");
							return $q.reject(error);
						}
					}
				},
				createWorkOrderJob: {
					method: "POST",
					headers: {
						token: LoginService.getToken()
					}
				},
					// updatePart: {
					// 	method: "PUT",
					// 	headers: {
					// 		token: LoginService.getToken()
					// 	}
					// },
					deleteWorkOrderJob: {
						method: "DELETE",
						headers: {
							token: LoginService.getToken()
						}
					}
		});

		this.getWorkOrderJob = function(resourcePath){
			return workOrderJob.getJob(resourcePath);
		}

		this.createWorkOrderJob = function(resourcePath, requestBody){
			var defer = $q.defer();

			workOrderJob.createWorkOrderJob(
				resourcePath,
				requestBody,
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);
						defer.reject(errorMessage);
						return;
					}

					defer.resolve(response.data);
				},
				function(error){
					console.error("Failed to create work order job.");
					defer.reject(error);
				}
			);

			return defer.promise;
		}

		this.deleteWorkOrderJob = function(resourcePath){
			var defer = $q.defer();
			
			workOrderJob.deleteWorkOrderJob(
				resourcePath,
				function(response, header){
					var statusCode  = header(codeKey);
					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);
						defer.reject(errorMessage);
						return;
					}
					defer.resolve(response.data);
				},
				function(error){
					console.error("Failed to delete work order job.");
					defer.reject(error);
				}
			);
			return defer.promise;
		}

		this.cancelCustomerPortalAppointmentByAdmin = function(resourcePath){			
			var defer = $q.defer();
			api.customerportalappointments.cancelCustomerPortalAppointmentByAdmin(
				resourcePath,
				function(response, header){
					var statusCode  = header(codeKey);
					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);
						defer.reject(errorMessage);
						return;
					}

					defer.resolve(response);
				},
				function(error){
					console.error("Failed cancel appointment.");
					defer.reject(error);
				}
			);

			return defer.promise;
		}

		function buildPdfBlobFromDocDefinition(docDefinition) {
			return new Promise(function(resolve, reject)  {
				const pdfDoc = pdfMake.createPdf(docDefinition);
				pdfDoc.getBlob(function (blob) {
					if (!blob) return reject(new Error('Failed to create PDF blob'));
					resolve(blob);
				});
			});
		}

		this.sendWorkOrderPDFEmail = function(resourcePath, requestBody) {
		const defer = $q.defer();

			buildPdfBlobFromDocDefinition(requestBody.pdf_data)
				.then(function (pdfBlob) {
					const fd = new FormData();

					const fileName = (requestBody.is_quoted ? 'Quote_' : 'Invoice_') + requestBody.invoice_number + '.pdf';
					fd.append('pdf', pdfBlob, fileName);
					fd.append('customerID', requestBody.customerID);
					fd.append('customer_name', requestBody.customer_name || '');
					fd.append('email_address', requestBody.email_address || '');
					fd.append('invoice_number', requestBody.invoice_number || '');
					fd.append('is_quoted', String(requestBody.is_quoted));

					api.workOrderPdfEmail.sendWorkOrderPDF(
						resourcePath,
						fd,
						function (response, header) {
							const code = header('x-code') || 200; // or your real header key
							if (code != 200) {
								const msg = header('x-message') || 'Failed';
								defer.reject(code + ': ' + msg);
								return;
							}
							defer.resolve(response);
						},
						function (error) {
							console.error(error);
							defer.reject('Failed to send work order PDF.');
						}
					);
				})
				.catch(function (err) {
					console.error(err);
					defer.reject('Failed to build PDF.');
				});

			return defer.promise;
		};




		// this.sendWorkOrderPDFEmail = function(resourcePath, requestBody){
		// 	var defer = $q.defer();

		// 	api.workOrderPdfEmail.sendWorkOrderPDF(
		// 		resourcePath,
		// 		requestBody,
		// 		function(response, header){
		// 			var statusCode  = header(codeKey);

		// 			if(statusCode != successCode){
		// 				var errorMessage = statusCode + ': ' + header(messageKey);

		// 				defer.reject(errorMessage);
		// 				return;
		// 			}
		// 			defer.resolve(response);

		// 		},
		// 		function(error){
		// 			console.error(error);
		// 			defer.reject("Failed to update workOrder.");
		// 		}
		// 	);	

		// 	return defer.promise;			
		// }

		this.getWarrantyPaymentOverallPaymentAmount=function(resourcePath){			
			var defer = $q.defer();
			api.warrantiesOverAllPaymentAmount.getWarrantyPaymentOverallPaymentAmount(
				resourcePath,
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);
						defer.reject(errorMessage);
						return;
					}
					defer.resolve({overall_amount: response.overall_amount});
				},
				function(error){
					console.error("Failed cancel get Warranty Payment Overall Payment Amount.");
					defer.reject(error);
				}
			);

			return defer.promise;
		}

		this.getPendingWarrantyPaymentOverallPaymentAmount=function(resourcePath){			
			var defer = $q.defer();
			api.pendingwarrantiesOverAllPaymentAmount.getPendingWarrantyPaymentOverallPaymentAmount(
				resourcePath,
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);
						defer.reject(errorMessage);
						return;
					}
					defer.resolve({overall_amount: response.overall_amount});
				},
				function(error){
					console.error("Failed cancel get Warranty Payment Overall Payment Amount.");
					defer.reject(error);
				}
			);

			return defer.promise;
		}

		this.getOutstandingOverallPaymentAmount=function(resourcePath){			
			var defer = $q.defer();
			api.outstandingOverallPaymentAmount.getPendingWarrantyPaymentOverallPaymentAmount(
				resourcePath,
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);
						defer.reject(errorMessage);
						return;
					}
					defer.resolve({overall_amount: response.overall_amount});
				},
				function(error){
					console.error("Failed cancel get Warranty Payment Overall Payment Amount.");
					defer.reject(error);
				}
			);

			return defer.promise;
		}


		this.getReconstructOustandingReportTable=function(resourcePath){			
			var defer = $q.defer();
			api.reconstructOustandingReportTable.getReconstructOustandingReportTable(
				resourcePath,
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);
						defer.reject(errorMessage);
						return;
					}
					defer.resolve({result: response});
				},
				function(error){
					console.error("Failed cancel get Reconstruct Oustanding Report Table.");
					defer.reject(error);
				}
			);

			return defer.promise;
		}

		this.voidCreditCardsPayment = function(resourcePath, paymentProfile){
			var defer = $q.defer();
			api.voidCreditCardsPayment.voidtransaction(
				paymentProfile,
				resourcePath,
				function(response, header){
					var statusCode  = header(codeKey);
					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);
						defer.reject(errorMessage);
						return;
					}

					defer.resolve(response);
				},
				function(error){
					console.error("Failed to void credit card payment.");
					defer.reject(error);
				}
			);

			return defer.promise;
		}

		
		this.refundCreditCardsPayment = function(resourcePath, paymentProfile){
			var defer = $q.defer();
			api.refundCreditCardsPayment.refundtransaction(
				paymentProfile,
				resourcePath,
				function(response, header){
					var statusCode  = header(codeKey);
					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);
						defer.reject(errorMessage);
						return;
					}

					defer.resolve(response);
				},
				function(error){
					console.error("Failed to void credit card payment.");
					defer.reject(error);
				}
			);

			return defer.promise;
		}

		this.getWorkOrdersForReport = function(resourcePath, filters, pagination, sorting){			
			var defer = $q.defer();
			var queryParams = Object.assign({}, resourcePath, filters, pagination, sorting);
			return api.workOrdersReport.getWorkOrdersForReport(queryParams);
		}

		this.getWorkOrderLog = function(resourcePath){
			var defer = $q.defer();
			api.workOrderLog.getWorkOrderLog(
				resourcePath,
				function(response, header){
					var statusCode  = header(codeKey);
					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);
						defer.reject(errorMessage);
						return;
					}
					defer.resolve(response);
					
				},
				function(error){
					console.error("Failed to get work order log.");
					defer.reject(error);
				}
			);

			return defer.promise;
		}

		this.recordWorkOrderPrint = function(resourcePath, requestBody){
			var defer = $q.defer();

			api.workOrderPrint.recordWorkOrderPrint(
				resourcePath,
				requestBody,
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);

						defer.reject(errorMessage);
						return;
					}
					defer.resolve(response);

				},
				function(error){
					console.error(error);
					defer.reject("Failed to update workOrder.");
				}
			);	

			return defer.promise;			
		}
	}
})();
(function ()
{
	'use strict';

	angular
		.module("app.workOrders")
		.factory("WorkOrderWarranty", WorkOrderWarrantyClass)

	/** @ngInject */
	function WorkOrderWarrantyClass()
	{	   
		function WorkOrderWarranty(){}

		WorkOrderWarranty.prototype.setAttributes = function (attributes) {
	 		var keyList = Object.keys(attributes);

	 		for(var i = 0; i < keyList.length; i++){
	 			var key = keyList[i];
	 			var value = attributes[key];

	 			this.setAttribute(key, value);
	 		}
		}

		WorkOrderWarranty.prototype.setAttribute = function (key, value) {
	 		this[key] = value;
		}

		WorkOrderWarranty.prototype.setResourceID = function (id) {
	 		this.id_sale_warranty = id;
		}

		WorkOrderWarranty.prototype.getResourceID = function () {
	 		return this.id_sale_warranty;
		}

		WorkOrderWarranty.prototype.pullDataFromWarranty = function (warranty) {
	 		if(warranty == null){
	 			return;
	 		}

	 		this.name = warranty.name;
	 		this.description = warranty.description;
	 		this.cost = warranty.cost;
	 		this.retail = warranty.retail;
	 		this.duration_month = warranty.duration_month;
	 		this.duration_mileage = warranty.duration_mileage;
	 		this.provider = warranty.provider;
		}

		return WorkOrderWarranty;
	}


})();
(function ()
{
	'use strict';

	angular
		.module("app.workOrders")
		.factory("WorkOrderRDRedeemed", WorkOrderRDRedeemedClass)

	/** @ngInject */
	function WorkOrderRDRedeemedClass()
	{	 
		function WorkOrderRDRedeemed(){}

		WorkOrderRDRedeemed.prototype.setAttributes = function (attributes) {
	 		if(attributes == null){
	 			return;
	 		}

	 		var keyList = Object.keys(attributes);

	 		for(var i = 0; i < keyList.length; i++){
	 			var key = keyList[i];
	 			var value = attributes[key];

	 			this.setAttribute(key, value);
	 		}
		}

		WorkOrderRDRedeemed.prototype.setAttribute = function (key, value) {
	 		this[key] = value;
		}

		WorkOrderRDRedeemed.prototype.getResourceId = function () {
	 		return this.id_rd_generated;
		}	

		return WorkOrderRDRedeemed;
	}


})();
(function ()
{
	'use strict';

	angular
		.module("app.workOrders")
		.factory("WorkOrderRDGenerated", WorkOrderRDGeneratedClass)

	/** @ngInject */
	function WorkOrderRDGeneratedClass()
	{	 
		function WorkOrderRDGenerated(){}

		WorkOrderRDGenerated.prototype.setAttributes = function (attributes) {
	 		if(attributes == null){
	 			return;
	 		}

	 		var keyList = Object.keys(attributes);

	 		for(var i = 0; i < keyList.length; i++){
	 			var key = keyList[i];
	 			var value = attributes[key];

	 			this.setAttribute(key, value);
	 		}
		}

		WorkOrderRDGenerated.prototype.setAttribute = function (key, value) {
	 		this[key] = value;
		}

		WorkOrderRDGenerated.prototype.getResourceId = function () {
	 		return this.id_rd_generated;
		}	

		return WorkOrderRDGenerated;
	}


})();
(function ()
{
	'use strict';

	angular
		.module("app.workOrders")
		.factory("WorkOrderPayment", WorkOrderPaymentClass)

	/** @ngInject */
	function WorkOrderPaymentClass()
	{	 
		function WorkOrderPayment(){}

		WorkOrderPayment.prototype.setAttributes = function (attributes) {
	 		if(attributes == null){
	 			return;
	 		}

	 		var keyList = Object.keys(attributes);

	 		for(var i = 0; i < keyList.length; i++){
	 			var key = keyList[i];
	 			var value = attributes[key];

	 			this.setAttribute(key, value);
	 		}
		}

		WorkOrderPayment.prototype.setAttribute = function (key, value) {
	 		this[key] = value;
		}

		WorkOrderPayment.prototype.getResourceId = function () {
	 		return this.id_work_order_payment;
		}	

		WorkOrderPayment.prototype.setCustomer = function (customer) {
	 		if(!customer){
	 			return;
	 		}

	 		this.customer = {
				id_customer: customer.id_customer,
				first_name: customer.first_name,
				last_name: customer.last_name
			}
		}

		WorkOrderPayment.prototype.setReceivedBy = function (userInfo) {
	 		if(!userInfo){
	 			return;
	 		}

	 		this.received_by = {
				id_user: userInfo.userID,
				first_name: userInfo.firstName,
				last_name: userInfo.lastName
			}
		}

		WorkOrderPayment.prototype.isValid = function () {
	 		if(!this.customer || this.customer.id_customer == null){
	 			return false;
	 		}

	 		if(this.amount == null){
	 			return false;
	 		}

	 		if(this.fk_id_payment_method == null){
	 			return false;
	 		}

			if(this.fk_id_payment_method == 11 && (this.paymentProfileID == null || this.customerProfileID == null)){
				return false;
			}
	 		return true;
		}	

		return WorkOrderPayment;
	}


})();
(function ()
{
	'use strict';

	angular
		.module("app.workOrders")
		.factory("WorkOrderPart", WorkOrderPartClass)

	/** @ngInject */
	function WorkOrderPartClass()
	{	 
		function WorkOrderPart(){}

		WorkOrderPart.prototype.setAttributes = function (attributes) {
	 		if(attributes == null){
	 			return;
	 		}

	 		var keyList = Object.keys(attributes);

	 		for(var i = 0; i < keyList.length; i++){
	 			var key = keyList[i];
	 			var value = attributes[key];

	 			this.setAttribute(key, value);
	 		}
		}

		WorkOrderPart.prototype.setAttribute = function (key, value) {
	 		this[key] = value;
		}

		WorkOrderPart.prototype.getResourceId = function () {
	 		return this.id_work_order_part;
		}

		WorkOrderPart.prototype.setResourceId = function (id) {
	 		this.id_work_order_part = id;
		}

		WorkOrderPart.prototype.isValid = function () {
	 		return this.quantity != null && !!this.name
		}	

		return WorkOrderPart;
	}


})();
(function ()
{
	'use strict';

	angular
		.module("app.workOrders")
		.factory("WorkOrderPackage", WorkOrderPackageClass)

	/** @ngInject */
	function WorkOrderPackageClass(WorkOrderConstants)
	{	   
		function WorkOrderPackage(){}

		WorkOrderPackage.prototype.setAttributes = function (attributes) {
	 		var keyList = Object.keys(attributes);

	 		for(var i = 0; i < keyList.length; i++){
	 			var key = keyList[i];
	 			var value = attributes[key];

	 			this.setAttribute(key, value);
	 		}
		}

		WorkOrderPackage.prototype.setAttribute = function (key, value) {
	 		this[key] = value;
		}

		WorkOrderPackage.prototype.setResourceID = function (id) {
	 		this.id_work_order_package = id;
		}

		WorkOrderPackage.prototype.getResourceID = function () {
	 		return this.id_work_order_package;
		}	

		WorkOrderPackage.prototype.pullDataFromPresetPackage = function (presetPackage) {
	 		if(presetPackage == null){
	 			return;
			}
			this.fk_id_preset_package = presetPackage.id_preset_package;
			this.name = presetPackage.name;
			this.price = presetPackage.price;
			this.expiry_mileage = presetPackage.expiry_mileage;
			const today = moment();
			this.expiry_date = today.month(presetPackage.valid_time + today.month()).format("YYYY-MM-DD");
		}

		WorkOrderPackage.prototype.getExpiryDateMomentObj = function (){
			if(this.expiry_date){
				return moment(this.expiry_date, WorkOrderConstants.dateFormat);
			}
		}

		WorkOrderPackage.prototype.isAvailable = function (){
			const expiryDate = this.getExpiryDateMomentObj();

			if(!expiryDate){
				return;
			}
			const now = moment();

			return now.isSameOrBefore(expiryDate, "Date");
		}

		return WorkOrderPackage;
	}
})();
(function ()
{
	'use strict';

	angular
		.module("app.workOrders")
		.factory("WorkOrderMechanic", WorkOrderMechanicClass)

	/** @ngInject */
	function WorkOrderMechanicClass()
	{	 
		function WorkOrderMechanic(){}

		WorkOrderMechanic.prototype.setAttributes = function (attributes) {
	 		if(attributes == null){
	 			return;
	 		}

	 		var keyList = Object.keys(attributes);

	 		for(var i = 0; i < keyList.length; i++){
	 			var key = keyList[i];
	 			var value = attributes[key];

	 			this.setAttribute(key, value);
	 		}
		}

		WorkOrderMechanic.prototype.setAttribute = function (key, value) {
	 		this[key] = value;
		}

		WorkOrderMechanic.prototype.getResourceId = function () {
	 		return this.id_work_order_mechanic;
		}

		WorkOrderMechanic.prototype.setUser = function (user) {
			if(!!user){
				this.id_user = user.id_user;
				this.first_name = user.first_name;
				this.last_name = user.last_name;
				this.roles = user.roles;
			}
		}

		WorkOrderMechanic.prototype.setPrimary = function (isPrimary) {
	 		this.is_primary = isPrimary;
		}		

		return WorkOrderMechanic;
	}


})();
(function ()
{
	'use strict';

	angular
		.module("app.workOrders")
		.factory("WorkOrderLog", WorkOrderLogClass)

	/** @ngInject */
	function WorkOrderLogClass()
	{	 
		function WorkOrderLog(){}

		WorkOrderLog.prototype.setAttributes = function (attributes) {
	 		if(attributes == null){
	 			return;
	 		}

	 		var keyList = Object.keys(attributes);

	 		for(var i = 0; i < keyList.length; i++){
	 			var key = keyList[i];
	 			var value = attributes[key];

				// cast timestamp to local time
				if(key == "timestamp"){
					value = moment.utc(value).local().format("YYYY-MM-DD HH:mm:ss");
				}

	 			this.setAttribute(key, value);
	 		}
		}

		WorkOrderLog.prototype.setAttribute = function (key, value) {
	 		this[key] = value;
		}

		WorkOrderLog.prototype.getResourceId = function () {
	 		return this.id_work_order_discount;
		}	

		return WorkOrderLog;
	}


})();
(function ()
{
	'use strict';

	angular
		.module("app.workOrders")
		.factory("WorkOrderJob", WorkOrderJobClass)

	/** @ngInject */
	function WorkOrderJobClass()
	{	 
		function WorkOrderJob(){}

		WorkOrderJob.prototype.setAttributes = function (attributes) {
	 		if(attributes == null){
	 			return;
	 		}

	 		var keyList = Object.keys(attributes);

	 		for(var i = 0; i < keyList.length; i++){
	 			var key = keyList[i];
	 			var value = attributes[key];

	 			this.setAttribute(key, value);
	 		}
		}

		WorkOrderJob.prototype.setAttribute = function (key, value) {
	 		this[key] = value;
		}

		WorkOrderJob.prototype.getResourceId = function () {
	 		return this.id_work_order_part;
		}

		WorkOrderJob.prototype.setResourceId = function (id) {
	 		this.id_work_order_part = id;
		}

		WorkOrderJob.prototype.isValid = function () {
	 		return this.quantity != null && !!this.name
		}	

		return WorkOrderJob;
	}


})();
(function ()
{
	'use strict';

	angular
		.module("app.workOrders")
		.factory("WorkOrderInventory", WorkOrderInventoryClass)

	/** @ngInject */
	function WorkOrderInventoryClass()
	{	 
		function WorkOrderInventory(){}

		WorkOrderInventory.prototype.setAttributes = function (attributes) {
	 		if(attributes == null){
	 			return;
	 		}

	 		var keyList = Object.keys(attributes);

	 		for(var i = 0; i < keyList.length; i++){
	 			var key = keyList[i];
	 			var value = attributes[key];

	 			this.setAttribute(key, value);
	 		}
		}

		WorkOrderInventory.prototype.setAttribute = function (key, value) {
	 		this[key] = value;
		}

		WorkOrderInventory.prototype.getResourceId = function () {
	 		return this.id_work_order_inventory;
		}

		WorkOrderInventory.prototype.pullDataFromInventory = function (inventory) {
	 		if(!inventory){
	 			return;
	 		}

	 		this.fk_id_inventory = inventory.id_inventory;
	 		this.fk_id_part_type = inventory.fk_id_part_type;
	 		this.name = inventory.name;
	 		this.code = inventory.code;
	 		this.purchase_price = inventory.purchase_price;
	 		this.purchase_tax_rate = inventory.purchase_tax_rate;
	 		this.retail_price = inventory.retail_price;
	 		this.quantity_in_stock = inventory.quantity;
		}

		return WorkOrderInventory;
	}


})();
(function ()
{
	'use strict';

	angular
		.module("app.workOrders")
		.factory("WorkOrderDiscount", WorkOrderDiscountClass)

	/** @ngInject */
	function WorkOrderDiscountClass()
	{	 
		function WorkOrderDiscount(){}

		WorkOrderDiscount.prototype.setAttributes = function (attributes) {
	 		if(attributes == null){
	 			return;
	 		}

	 		var keyList = Object.keys(attributes);

	 		for(var i = 0; i < keyList.length; i++){
	 			var key = keyList[i];
	 			var value = attributes[key];

	 			this.setAttribute(key, value);
	 		}
		}

		WorkOrderDiscount.prototype.setAttribute = function (key, value) {
	 		this[key] = value;
		}

		WorkOrderDiscount.prototype.getResourceId = function () {
	 		return this.id_work_order_discount;
		}	

		return WorkOrderDiscount;
	}


})();
(function ()
{
	'use strict';

	angular
		.module("app.workOrders")
		.factory("WorkOrderCoupon", WorkOrderCouponClass)

	/** @ngInject */
	function WorkOrderCouponClass()
	{	 
		function WorkOrderCoupon(){}

		WorkOrderCoupon.prototype.setAttributes = function (attributes) {
	 		if(attributes == null){
	 			return;
	 		}

	 		var keyList = Object.keys(attributes);

	 		for(var i = 0; i < keyList.length; i++){
	 			var key = keyList[i];
	 			var value = attributes[key];

	 			this.setAttribute(key, value);
	 		}
		}

		WorkOrderCoupon.prototype.setAttribute = function (key, value) {
	 		this[key] = value;
		}

		WorkOrderCoupon.prototype.getResourceId = function () {
	 		return this.id_work_order_discount;
		}	

		return WorkOrderCoupon;
	}


})();
(function ()
{
	'use strict';

	angular
		.module("app.workOrders")
		.factory("WorkOrder", WorkOrderClass)

	/** @ngInject */
	function WorkOrderClass($filter, WorkOrderConstants)
	{	 
		function WorkOrder(){}

		WorkOrder.prototype.setAttributes = function (attributes) {
	 		if(attributes == null){
	 			return;
	 		}

	 		var keyList = Object.keys(attributes);

	 		for(var i = 0; i < keyList.length; i++){
	 			var key = keyList[i];
	 			var value = attributes[key];

	 			this.setAttribute(key, value);
	 		}
		}

		WorkOrder.prototype.setAttribute = function (key, value) {
	 		this[key] = value;
		}

		WorkOrder.prototype.getResourceId = function () {
	 		return this.id_work_order;
		}	

		WorkOrder.prototype.setQuoteDate = function (momentObj) {
	 		if(momentObj && momentObj.isValid()){
				this.quote_date = momentObj.format(WorkOrderConstants.dateFormat);
				return true;
			}
			this.quote_date = null;
			return false;
		}	

		WorkOrder.prototype.getQuoteDateMomentObj = function (){
			if(this.quote_date){
				return moment(this.quote_date, WorkOrderConstants.dateFormat);
			}
		}

		/*WorkOrder.prototype.setStartDateTime = function (momentObj) {
	 		if(momentObj && momentObj.isValid()){
				this.start_date = momentObj.format(WorkOrderConstants.dateTimeFormat);
				return true;
			}
			this.start_date = null;
			return false;
		}	

		WorkOrder.prototype.getStartDateTimeMomentObj = function (){
			if(this.start_date){
				return moment(this.start_date);
			}
		}*/

		WorkOrder.prototype.setCompletedDateTime = function (momentObj) {
	 		if(momentObj && momentObj.isValid()){
				this.completed_date = momentObj.format(WorkOrderConstants.dateTimeFormat);
				return true;
			}
			this.completed_date = null;
			return false;
		}	

		WorkOrder.prototype.getCompletedDateTimeMomentObj = function (){
			if(this.completed_date){
				return moment(this.completed_date);
			}
		}

		WorkOrder.prototype.isQuoted = function (){
			return this.fk_id_work_order_status == WorkOrderConstants.statusIDs.quoted;
		}

		WorkOrder.prototype.isDeclinded = function (){
			return this.fk_id_work_order_status == WorkOrderConstants.statusIDs.declined;
		}

		WorkOrder.prototype.isCompletedElseWhere = function (){
			return this.fk_id_work_order_status == WorkOrderConstants.statusIDs.completedEleswhere;
		}

		WorkOrder.prototype.isCompleted = function (){
			return this.fk_id_work_order_status == WorkOrderConstants.statusIDs.completed;
		}

		WorkOrder.prototype.isBooked = function (){
			return this.fk_id_work_order_status == WorkOrderConstants.statusIDs.booked;
		}

		WorkOrder.prototype.isOnLot = function (){
			return this.fk_id_work_order_status == WorkOrderConstants.statusIDs.onlot;
		}

		WorkOrder.prototype.isStarted = function (){
			return this.fk_id_work_order_status == WorkOrderConstants.statusIDs.started;
		}

		return WorkOrder;
	}


})();
(function ()
{
	'use strict';

	angular
		.module("app.workOrders")
		.factory("WorkOrderAppointment", WorkOrderAppointmentClass)

	/** @ngInject */
	function WorkOrderAppointmentClass()
	{	 
		function WorkOrderAppointment(){}

		WorkOrderAppointment.prototype.setAttributes = function (attributes) {
	 		if(attributes == null){
	 			return;
	 		}

	 		var keyList = Object.keys(attributes);

	 		for(var i = 0; i < keyList.length; i++){
	 			var key = keyList[i];
	 			var value = attributes[key];

	 			this.setAttribute(key, value);
	 		}
		}

		WorkOrderAppointment.prototype.setAttribute = function (key, value) {
	 		this[key] = value;
		}

		WorkOrderAppointment.prototype.getResourceId = function () {
	 		return this.id_work_order_appointment;
		}

		WorkOrderAppointment.prototype.setResourceId = function (id) {
	 		this.id_work_order_appointment = id;
		}

		return WorkOrderAppointment;
	}


})();
(function ()
{
	'use strict';

	angular
		.module("app.workOrders")
		.factory("ServiceMap", ServiceMapClass)

	/** @ngInject */
	function ServiceMapClass()
	{	 
		function ServiceMap(){}

		ServiceMap.prototype.setAttributes = function (attributes) {
	 		if(attributes == null){
	 			return;
	 		}

	 		var keyList = Object.keys(attributes);

	 		for(var i = 0; i < keyList.length; i++){
	 			var key = keyList[i];
	 			var value = attributes[key];

	 			this.setAttribute(key, value);
	 		}
		}

		ServiceMap.prototype.setAttribute = function (key, value) {
	 		this[key] = value;
		}

		ServiceMap.prototype.setVehicle = function (vehicle) {
	 		if(!vehicle){
	 			return;
	 		}

	 		this.vehicle = {
	 			id_vehicle: vehicle.getResourceID(),
	 			year: vehicle.year,
	 			make: vehicle.make,
	 			model: vehicle.model
	 		}
		}

		ServiceMap.prototype.setCustomer = function (customer) {
	 		if(!customer){
	 			return;
	 		}

	 		this.customer = {
	 			id_customer: customer.getResourceID(),
	 			first_name: customer.first_name,
	 			last_name: customer.last_name
	 		}
		}

		ServiceMap.prototype.getResourceId = function () {
	 		return this.id_service_map;
		}	

		ServiceMap.prototype.setResourceId = function (id) {
	 		this.id_service_map = id
		}	

		return ServiceMap;
	}


})();
(function ()
{
	'use strict';

	angular
		.module("app.workOrders")
		.factory("Labor", LaborClass)

	/** @ngInject */
	function LaborClass()
	{	 
		function Labor(){}

		Labor.prototype.setAttributes = function (attributes) {
	 		if(attributes == null){
	 			return;
	 		}

	 		var keyList = Object.keys(attributes);

	 		for(var i = 0; i < keyList.length; i++){
	 			var key = keyList[i];
	 			var value = attributes[key];

	 			this.setAttribute(key, value);
	 		}
		}

		Labor.prototype.setAttribute = function (key, value) {
	 		this[key] = value;
		}

		Labor.prototype.getResourceId = function () {
	 		return this.id_labor;
		}

		Labor.prototype.isValid = function () {
	 		return this.hour != null && this.price != null && !!this.name;
		}	

		return Labor;
	}


})();
(function ()
{
    "use strict";

    angular
        .module("app.uiCtrl", [])
        .factory("UICtrlFactory", UICtrlFactory);

    //may be useful in future, keep it for now    
    function UICtrlFactory(){
        var factory = {};
        return factory;
    }   
})();



(function ()
{
    "use strict";

    angular
        .module("app.uiCtrl")
        .service("UICtrlService", UICtrlService);

    //may be useful in future, keep it for now 
    function UICtrlService(){   
    }
})();
(function ()
{
    "use strict";

    angular
        .module("app.uiCtrl")
        .directive("restrict", visibilityControl)
        .directive("restrict", disabledControl);

    function visibilityControl(UICtrlConst, LoginService)
    {   
        var directive = {

            /**
             * define the restrict type:
             *
             * E：<directiveName></directiveName>
             * A：<div directiveName='expression'></div>
             * C： <div class='directiveName'></div>
             * M：<--directive:directiveName expression-->
             */
            restrict: UICtrlConst.restrictType,

            //define the priority, example:  ng-repeat 1000,  ng-init 450
            prioriry: UICtrlConst.prioriry,

            // enable/disable the element to be controlled by other controller
            scope: UICtrlConst.scope,

            //this function is for data binding, keep it for now
            link: function(){
            },

            /**
             * angular will go through the whole HTML, this function will
             * be called in order according to prioriry.
             * here will be used to control the visibility of elements for different user role
             */
            compile:  function(element, attr, linker){
                var userStatus = LoginService.getUserStatus();
                var userInfo = {};
                var userRoles = [];
                var isLogin = false;
                var attrString = attr.rolescansee; 
                
                if(typeof(attrString) == "undefined"){
                    return;                       
                } 

                var rolescansee = attrString.split(' ')

                if(typeof(rolescansee) == "undefined"){
                    element.children().remove();
                    element.hide();
                    return;                       
                } 

                if(typeof(userStatus) == "undefined"){
                    element.children().remove();
                    element.hide();
                    return;                       
                } 

                isLogin = userStatus.isLogin;

                if(isLogin) {
                    userInfo = userStatus.userInfo
                }

                if(rolescansee.indexOf("logout") != -1 && !isLogin){             
                    return;
                }    

                if(rolescansee.indexOf("login") != -1 && isLogin){                 
                    return;
                }                 

                if(Array.isArray(userInfo.roles)){
                    userRoles = userInfo.roles
                }      

                for(var i = 0; i < rolescansee.length; i++){
                    var currentRequiredRole = rolescansee[i];
                    if(userRoles.indexOf(currentRequiredRole) != -1){
                        return;
                    }
                }
                element.children().remove();
                element.hide();     

            }
        }
        return directive;  
    }

    function disabledControl(UICtrlConst, LoginService)
    {   
        var directive = {

            /**
             * define the restrict type:
             *
             * E：<directiveName></directiveName>
             * A：<div directiveName='expression'></div>
             * C： <div class='directiveName'></div>
             * M：<--directive:directiveName expression-->
             */
            restrict: UICtrlConst.restrictType,

            //define the priority, example:  ng-repeat 1000,  ng-init 450
            prioriry: UICtrlConst.prioriry,

            // enable/disable the element to be controlled by other controller
            scope: UICtrlConst.scope,

            //this function is for data binding, keep it for now
            link: function(){
            },

            /**
             * angular will go through the whole HTML, this function will
             * be called in order according to prioriry.
             * here will be used to control the visibility of elements for different user role
             */
            compile:  function(element, attr, linker){
 
                var userStatus = LoginService.getUserStatus();
                var userInfo = {};
                var userRoles = [];
                var isLogin = false;
                var attrString = attr.rolescanedit; 

                if(typeof(attrString) == "undefined"){ 
                    return;                       
                } 
                
                var rolescanedit = attrString.split(' ')

                if(typeof(rolescanedit) == "undefined"){
                    element.attr("disabled","disabled");
                    return;                       
                } 

                if(typeof(userStatus) == "undefined"){
                    element.attr("disabled","disabled");
                    return;                       
                } 

                isLogin = userStatus.isLogin;

                if(isLogin) {
                    userInfo = userStatus.userInfo
                }

                if(rolescanedit.indexOf("logout") != -1 && !isLogin){             
                    return;
                }    

                if(rolescanedit.indexOf("login") != -1 && isLogin){                 
                    return;
                }                 

                if(Array.isArray(userInfo.roles)){
                    userRoles = userInfo.roles
                }      

                for(var i = 0; i < rolescanedit.length; i++){
                    var currentRequiredRole = rolescanedit[i];
                    if(userRoles.indexOf(currentRequiredRole) != -1){
                        return;
                    }
                }
                element.attr("disabled","disabled");                 
            }
        }
        return directive;  
    }    


})();
/**
 *  Description: define the constants for uiControl module
 */
(function ()
{
	"use strict";

	angular
		.module("app.uiCtrl")
		.constant("UICtrlConst", {
			restrictType : 'A',
			prioriry     : 100000,
			scope        : false
		});    
})();
(function ()
{
    "use strict";

    angular
        .module("app.userInfoObj", [])
        .factory("UserInfoObjFactory", UserInfoObjFactory);
    
    //Description: provide method to create userInfo obj 
    function UserInfoObjFactory(){
        var factory = {};
        factory.createUserInfoObj=function(userName, token){
            var userInfo = {};

            //if userName and token not null, put it in user obj
            if(userName != null && token != null){
                userInfo.userName = userName;
                userInfo.token = token;
            } else {
                userInfo = null;
            }
            return userInfo;
        }
        return factory;
    }   
})();



(function ()
{
    "use strict";

    angular
        .module("app.userInfoObj")
        .service("userInfoObjService", userInfoObjService);

    //Description: encapsulation of UserInfoObjFactory, provide methods to create userinfo
    function userInfoObjService(UserInfoObjFactory)
    {   
        this.createUserInfoObj = function(userName, token){
        	return UserInfoObjFactory.createUserInfoObj(userName, token);
        }       
    }
})();
(function ()
{
	'use strict';

	angular
		.module('app.vehicles')
		.service("VehicleService", VehicleService);

	/** @ngInject */
	function VehicleService($state, api, ToolsFactory, Const, Vehicle, VehicleFeature, Vinaudit, $q, MessageService, LoginService, PurchaseInfo, VehicleImage, $resource, GeneralTools, PresetVehicleFeature, UnitTranslator, HeaderHelper, TestDrive, ConstantCacheService)
	{   
		var codeKey = Const.header.code;
		var messageKey = Const.header.message;
		var successCode = Const.code.success;
		var requestIdentifier = 0;

		const baseUrl = GeneralTools.getBaseUrl();
		const baseHeader = GeneralTools.getBaseHeader();
		const noCacheHeader = GeneralTools.getNoCacheHeader();

		const searchVehicleByCustomerInfo = $resource(
			baseUrl + "companies/:companyID/vehicles/searchbycustomerinfo",
			{companyID:"@companyID"},
			{
				get:{
					method:"GET",
					isArray:true,
					cancellable: true,
					interceptor:{
						response: function(result){
							const statusCode  = result.headers(Const.header.code);

							if(statusCode != Const.code.success){
								console.error(statusCode, result.headers(Const.header.message));
								return $q.reject(result.headers(Const.header.message));
							}

							var vehicleList = [];

							result.data.forEach(function(data){
								var vehicle = new Vehicle();

								vehicle.setAttributes(data); 
								vehicleList.push(vehicle);
							})

							return vehicleList;
						},
						responseError: function (error){
							if(error && error.xhrStatus == Const.xhrStatus.abort){
								return $q.reject();
							}
							console.error(error);
							return $q.reject(error);
						}
					}
				}
			}
		);

		this.searchByCustomerInfo = function(companyID, filters){
			const params = angular.copy(filters);

			if(params){
				params.companyID = companyID;
			}

			return searchVehicleByCustomerInfo.get(params);
		}

		this.isVehicleAvailable = function(vehicleID){
			const filterString = GeneralTools.equalFilterBuilder("purchase_info.is_canceled", false);

			const filters = { 
				filters: filterString,
				isSold: false
			};

			const resourcePath = {
				companyID: LoginService.getCompanyID(),
				vehicleID: vehicleID
			}

			return this.getVehicle(resourcePath, filters)
				.then(function(result){
					if(!result || !Array.isArray(result.data)){
						return $q.reject("Failed to check if vehicle available.");
					}

					const isVehicleAvailable = result.data.length == 1 && !!result.data[0];
					return $q.resolve(isVehicleAvailable);
				})
		}

		this.getAllMatchedVehicles = function(vehicleResourcePath, vehicleFilters){
			var vehicleList = [];
			var _this = this;
			
			return _this.getVehicle(vehicleResourcePath, vehicleFilters, {page: 1, limit: 100})
				.then(function(response){
					if(!response || !Array.isArray(response.data)){
						return $q.reject("Failed to fetch vehicles for report.");
					}

					vehicleList = vehicleList.concat(response.data);

					var totalItem = HeaderHelper.getPaginationTotalItem(response.headerGetter);
					var currentPage = HeaderHelper.getPaginationCurrentPage(response.headerGetter);
					var itemsPerPage = HeaderHelper.getPaginationItemsPerPage(response.headerGetter);

					var queue = [];

					if(response.data.length < totalItem){
						var totalPage = Math.ceil(totalItem/itemsPerPage);

						for(var i = 2; i <= totalPage; i++){
							queue.push(_this.getVehicle(vehicleResourcePath, vehicleFilters, {page: i, limit: 100}));
						}
					}

					return $q.all(queue);
				})
				.then(function(responseList){
					if(!Array.isArray(responseList)){
						return $q.reject("Failed to fetch vehicles for report.");
					}

					for(var i = 0; i < responseList.length; i++){
						var response = responseList[i];

						if(!response || !Array.isArray(response.data)){
							return $q.reject("Failed to fetch vehicles for report.");
						}

						vehicleList = vehicleList.concat(response.data);
					}

					return $q.resolve(vehicleList);
				});
		}

		this.updateVehicleRequestBodyGenerator = function(currentVehicle, originVehicle){
			if(currentVehicle == null || originVehicle == null){
				return;
			}

			var keyList = Object.keys(currentVehicle);
			var changedProperties = {};

			keyList.forEach(function(key){
				var currentValue = currentVehicle[key];
				var originValue = originVehicle[key];

				if(currentValue == originValue){
					return;
				}

				changedProperties[key] = currentValue;
			});

			return changedProperties;
		}

		this.getFeaturesToCreate = function(featureList){
			if(!Array.isArray(featureList)){
				return;
			}

			return featureList.filter(function(feature){
				return feature.getResourceID() == null;
			});
		}

		this.getFeaturesToDelete = function(originFeatureList, currentFeatureList){
			if(!Array.isArray(originFeatureList) || !Array.isArray(currentFeatureList)){
				return;
			}

			var featureMap = {};

			currentFeatureList.forEach(function(feature){
				var featureID =  feature.getResourceID();
				if(featureID == null){
					return;
				}

				if(featureMap[featureID] == null){
					featureMap[featureID] = true;
				}
			})

			return originFeatureList.filter(function(feature){
				var featureID = feature.getResourceID();
				if(featureID == null){
					return;
				}

				return featureMap[featureID] != true
			});
		}

		this.searchTextFilterBuilder = function(searchText){
			if(typeof(searchText) != "string" || searchText.trim() == ''){
				return '';
			}

			var filterString = '';
			var keywordList = searchText.split(' ');

			var numberKeywords = [];
			var nonNumberKeywords = [];

			var numberKeywordFilterString = '';
			var nonNumberKeywordFilterString = '';

			keywordList.forEach(function(keyword){
				if(isNaN(parseInt(keyword))){
					nonNumberKeywords.push(keyword);
				} else {
					numberKeywords.push(keyword);
				}
			});

			numberKeywords.forEach(function(keyword){
				numberKeywordFilterString = GeneralTools.stringConnector(numberKeywordFilterString, filterStringBuiler("year", keyword), " OR ");
				numberKeywordFilterString = GeneralTools.stringConnector(numberKeywordFilterString, filterStringBuiler("vin", keyword), " OR ");
				numberKeywordFilterString = GeneralTools.stringConnector(numberKeywordFilterString, filterStringBuiler("stock_number", keyword), " OR ");
				
				numberKeywordFilterString = GeneralTools.stringConnector(numberKeywordFilterString, filterStringBuiler("make", keyword), " OR ");
				numberKeywordFilterString = GeneralTools.stringConnector(numberKeywordFilterString, filterStringBuiler("model", keyword), " OR ");
				numberKeywordFilterString = GeneralTools.stringConnector(numberKeywordFilterString, filterStringBuiler("trim", keyword), " OR ");
			});

			nonNumberKeywords.forEach(function(keyword){
				nonNumberKeywordFilterString = GeneralTools.stringConnector(nonNumberKeywordFilterString, filterStringBuiler("vin", keyword), " OR ");
				nonNumberKeywordFilterString = GeneralTools.stringConnector(nonNumberKeywordFilterString, filterStringBuiler("stock_number", keyword), " OR ");
				nonNumberKeywordFilterString = GeneralTools.stringConnector(nonNumberKeywordFilterString, filterStringBuiler("make", keyword), " OR ");
				nonNumberKeywordFilterString = GeneralTools.stringConnector(nonNumberKeywordFilterString, filterStringBuiler("model", keyword), " OR ");
				nonNumberKeywordFilterString = GeneralTools.stringConnector(nonNumberKeywordFilterString, filterStringBuiler("trim", keyword), " OR ");
			});

			if(numberKeywordFilterString != ''){
				numberKeywordFilterString = '(' + numberKeywordFilterString + ')';
			}

			if(nonNumberKeywordFilterString != ''){
				nonNumberKeywordFilterString = '(' + nonNumberKeywordFilterString + ')';
			}

			filterString = GeneralTools.stringConnector(filterString, numberKeywordFilterString, " AND ");
			filterString = GeneralTools.stringConnector(filterString, nonNumberKeywordFilterString, " AND ");

			return '(' + filterString + ')';
		}

		function filterStringBuiler(columnName, value){
			if(typeof(columnName) != "string" || columnName.trim() == '' 
					|| typeof(value) != "string" || value.trim() == ''){
				return '';
			}

			return "contains(" + columnName + ",'" + value + "')";
		}

		this.getVehicle = function(resourcePath, filters, pagination, sorting){
			var defer = $q.defer();
			var queryParams = Object.assign({}, resourcePath, filters, pagination, sorting);

			api.vehicles.getVehicle(
				queryParams,
				function(response, header){
					var statusCode  = header(codeKey);
					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);
						defer.reject(errorMessage);
						return;
					}

					var vehicleList = [];
					
					response.forEach(function(data){
						var vehicle = new Vehicle();
						vehicle.setAttributes(data); 
						vehicleList.push(vehicle);
					})

					var result = {
						data: vehicleList,
						headerGetter: header
					}
					defer.resolve(result);

				},
				function(error){
					console.error(error);
					defer.reject("Failed to get vehicles");
				}
			);

			return defer.promise;
		}

		this.getVehicleForProfileReport = function(resourcePath, filters, pagination, sorting){
			var defer = $q.defer();
			var queryParams = Object.assign({}, resourcePath, filters, pagination, sorting);

			api.vehiclesReport.getVehicleForReport(
				queryParams,
				function(response, header){
					var statusCode  = header(codeKey);
					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);
						defer.reject(errorMessage);
						return;
					}

					var vehicleList = [];
					
					response.forEach(function(data){
						var vehicle = new Vehicle();
						vehicle.setAttributes(data); 
						vehicleList.push(vehicle);
					})

					var result = {
						data: vehicleList,
						headerGetter: header
					}
					defer.resolve(result);

				},
				function(error){
					console.error(error);
					defer.reject("Failed to get vehicles");
				}
			);

			return defer.promise;
		}

		this.createVehicle = function(resourcePath, requestBody){
			var defer = $q.defer();

			api.vehicles.addVehicle(
				resourcePath,
				requestBody,
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);
						defer.reject(errorMessage);
						return;
					}

					defer.resolve(response.data);
				},
				function(error){
					console.error(error);
					defer.reject("Failed to create vehicle.");
				}
			);

			return defer.promise;
		}

		this.mergeVehicle = function(resourcePath, destinationVehicleID){
			var defer = $q.defer();

			if(resourcePath){
				resourcePath.destinationVehicleID = destinationVehicleID;
			}

			api.mergeVehicle.merge(
				resourcePath,
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);
						defer.reject(errorMessage);
						return;
					}
					defer.resolve(response);
				},
				function(error){
					console.error(error);
					defer.reject("Failed to merge vehicle.");
				}
			);

			return defer.promise;
		}

		this.updateVehicle = function(resourcePath, requestBody){
			var defer = $q.defer();

			api.vehicles.updateVehicle(
				resourcePath,
				requestBody,
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);
						defer.reject(errorMessage);
						return;
					}
					defer.resolve(response);
				},
				function(error){
					console.error(error);
					defer.reject("Failed to update vehicle.");
				}
			);

			return defer.promise;
		}

		this.deleteVehicle = function(vehicleID){
			var defer = $q.defer();
			api.vehicles.deleteVehicle(
				{
					vehicleID:vehicleID,
					companyID:LoginService.getCompanyID()
				},
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);
						defer.reject(errorMessage);
						return;
					}

					defer.resolve(response);
				},
				function(error){
					var errorMessage = error.status + ': ' + error.statusText;
					defer.reject(errorMessage);
				}
			);
			return defer.promise;
		}

		this.checkVinAvailable = function(vinInVM, vinInView, originVin, requestIdentifier){
			var defer 	= $q.defer();

			if(vinInVM == null || vinInVM.trim() == '' || vinInVM == originVin){
				defer.resolve();
				return defer.promise;
			}

			var params 	= {
						tableName:"vehicle",
						columnName:"vin",
						value:vinInVM,
						requestIdentifier:requestIdentifier
					};

			api.check.checkExistence.check(
				params,
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);
						MessageService.showToast(errorMessage);
						defer.reject();
						return;
					}

					if(response.data){
						defer.reject();
						
					}else{
						defer.resolve();
					}
				},
				function(error){
					var errorMessage = error.status + ': ' + error.statusText;
					MessageService.showToast(errorMessage);
					defer.reject();
				}
			);
			return defer.promise;
		}

		this.checkVinExistance = function(vin){
			var defer 	= $q.defer();
			var params 	= {
						tableName:"vehicle",
						columnName:"vin",
						value:vin
					};

			api.check.checkExistence.check(
				params,
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);
						MessageService.showToast(errorMessage);
						defer.reject();
						return;
					}

					if(response == null){
						defer.reject();
						return;
					}

					defer.resolve(response.data);
				},
				function(error){
					console.error(error)
					defer.reject("Failed to check vin existance");
				}
			);
			return defer.promise;
		}

		this.checkStockNumberExistance = function(stockNumber){
			var defer 	= $q.defer();
			var params 	= {
						tableName:"vehicle",
						columnName:"stock_number",
						value:stockNumber
					};

			api.check.checkExistence.check(
				params,
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);
						MessageService.showToast(errorMessage);
						defer.reject();
						return;
					}

					if(response == null){
						defer.reject();
						return;
					}

					defer.resolve(response.data);
				},
				function(error){
					console.error(error)
					defer.reject("Failed to check stock number existance");
				}
			);
			return defer.promise;
		}


		this.checkStockNumberAvailable = function(stockNumInVM, stockNumInView, originStockNum, requestIdentifier){
			var defer = $q.defer();

			if(stockNumInVM == null || stockNumInVM.trim() == '' || stockNumInVM == originStockNum){
				defer.resolve();
				return defer.promise;
			}

			var params = {
					tableName:"vehicle",
					columnName:"stock_number",
					value:stockNumInVM,
					requestIdentifier:requestIdentifier++
				}

			api.check.checkExistence.check(
				params,
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);
						MessageService.showToast(errorMessage);
						defer.reject();
						return;
					}

					if(response.data){
						defer.reject();		
					}else{
						defer.resolve();
					}
				},
				function(error){
					var errorMessage = error.status + ': ' + error.statusText;
					MessageService.showToast(errorMessage);
					defer.reject();
				}
			);

			return defer.promise;
		}

		this.checkVehicleIDByVin = function(vin){
			var defer = $q.defer();

			api.check.getVehicleIdByVin.get(
				{vin:vin},
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);
						defer.reject(errorMessage);
						return;
					}

					defer.resolve(response.data);
				},
				function(error){
					console.error(error);
					defer.reject("Failed to get vehicle id");
				}
			);

			return defer.promise;
		}

		this.getVehicleFiles = function(vehicleID, fileID){
			var defer = $q.defer();

			var param = {
					vehicleID:vehicleID,
					companyID:LoginService.getCompanyID()
				};

			if(fileID != null){
				param.fileID = fileID;
			}

			api.vehicleFiles.getVehicleFiles(
				param,
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);

						defer.reject(errorMessage);
						return;
					}
					defer.resolve(response);

				},
				function(error){
					var errorMessage = error.status + ': ' + error.statusText;

					defer.reject(errorMessage);
				}
			);	

			return defer.promise;		
		}

		this.deleteVehicleFile = function(resourcePath){
			var defer = $q.defer();

			api.vehicleFiles.deleteVehicleFile(
				resourcePath,
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);

						defer.reject(errorMessage);
						return;
					}
					defer.resolve(response);

				},
				function(error){
					console.log(error)
					defer.reject("Failed to delete vehicle file");
				}
			);	

			return defer.promise;	
		}

		this.getPresetFeatures = function(){
			var defer = $q.defer();

			api.presetFeatures.getFeatures(
				{companyID : LoginService.getCompanyID()},
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);
						defer.reject(errorMessage);
						return;
					}

					var featureList = [];

					response.forEach(function(data){
						var feature = new PresetVehicleFeature(data);

						featureList.push(feature);				
					})

					defer.resolve(featureList);

				},
				function(error){
					console.error(error);
					defer.reject("Failed to get preset feature options");
				}
			);

			return defer.promise;			
		}

		this.getVehicleFeatures = function(resourcePath){
			var defer = $q.defer();

			api.vehicleFeatures.getFeatures(
				resourcePath,
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);
						defer.reject(errorMessage);
						return;
					}

					var featureList = [];

					response.forEach(function(data){
						var feature = new VehicleFeature(data);

						featureList.push(feature);				
					})

					defer.resolve(featureList);
				},
				function(error){
					console.error(error);
					defer.reject("Failed to get preset feature options");
				}
			);

			return defer.promise;			
		}

		this.deleteVehicleFeature = function(resourcePath){
			var defer = $q.defer();

			api.vehicleFeatures.deleteFeature(
				resourcePath,
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);
						defer.reject(errorMessage);
						return;
					}

					defer.resolve(response);
				},
				function(error){
					console.error(error);
					defer.reject("Failed to delete vehicle feature");
				}
			);

			return defer.promise;
		}

		this.createVehicleFeature = function(resourcePath, requestBody){
			var defer = $q.defer();

			api.vehicleFeatures.createFeature(
				resourcePath,
				requestBody,
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);
						defer.reject(errorMessage);
						return;
					}

					defer.resolve(response.data);
				},
				function(error){
					console.error(error);
					defer.reject("Failed to create vehicle feature");
				}
			);

			return defer.promise;			
		}

		this.createBatchVehicleFeature = function(resourcePath, requestBody){
			var defer = $q.defer();

			api.batchVehicleFeatures.createFeatures(
				resourcePath,
				requestBody,
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);
						defer.reject(errorMessage);
						return;
					}

					defer.resolve();
				},
				function(error){
					console.error(error);
					defer.reject("Failed to create vehicle features");
				}
			);

			return defer.promise;			
		}



		this.getPurchaseInfoFile = function(vehicleID, purchaseinfoID, purchaseinfofileID){
			var defer = $q.defer();

			api.purchaseInfoFile.getFile(
				{
					companyID 			: LoginService.getCompanyID(),
					vehicleID 			: vehicleID,
					purchaseinfoID 		: purchaseinfoID,
					purchaseinfofileID	: purchaseinfofileID
				},
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);
						defer.reject(errorMessage);
						return;
					}

					defer.resolve(response)
				},
				function(error){
					var errorMessage = error.status + ': ' + error.statusText;
					defer.reject(errorMessage);
				}
			);

			return defer.promise;			
		}

		this.deletePurchaseInfoFile = function(vehicleID, purchaseinfoID, purchaseinfofileID){
			var defer = $q.defer();

			var param = {
					companyID 			: LoginService.getCompanyID(),
					vehicleID 			: vehicleID,
					purchaseinfoID 		: purchaseinfoID,
					purchaseinfofileID	: purchaseinfofileID
				};

			api.purchaseInfoFile.deleteFile(
				param,
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);

						defer.reject(errorMessage);
						return;
					}
					defer.resolve(response);

				},
				function(error){
					var errorMessage = error.status + ': ' + error.statusText;

					defer.reject(errorMessage);
				}
			);	

			return defer.promise;	
		}

		this.getFileByUUID = function(uuid){
			var defer = $q.defer();

			api.files.getFileByUUID(
				{uuid : uuid},
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);
						defer.reject(errorMessage);
						return;
					}
					
					defer.resolve(response);
				},
				function(error){
					var errorMessage = error.status + ': ' + error.statusText;
					defer.reject(errorMessage);
				}
			);

			return defer.promise;			
		}

		this.getVehicleImages = function(vehicleID, imageID, imageVersion){
			var defer = $q.defer();
			var version = imageVersion || null;
			var param = {
					imageID:imageID,
					vehicleID:vehicleID,
					companyID:LoginService.getCompanyID(),
					imageVersion:version
				};

			api.vehicleImages.getImage(
				param,
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);
						defer.reject(errorMessage);
						return;
					}

					var imageList = [];

					response.forEach(function(data){
						var image = new VehicleImage(data);
						imageList.push(image);
					})

					defer.resolve(imageList);					
				},
				function(error){
					var errorMessage = error.status + ': ' + error.statusText;

					defer.reject(errorMessage);
				}
			);	

			return defer.promise;		
		}

		this.updateVehicleImage = function(resourcePath, requestBody){
			var defer = $q.defer();

			api.vehicleImages.updateImage(
				resourcePath,
				requestBody,
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);
						defer.reject(errorMessage);
						return;
					}

					defer.resolve(null);					
				},
				function(error){
					var errorMessage = error.status + ': ' + error.statusText;

					defer.reject(errorMessage);
				}
			);	

			return defer.promise;		
		}

		this.deleteVehicleImage = function(resourcePath){
			var defer = $q.defer();

			api.vehicleImages.deleteImage(
				resourcePath,
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);

						defer.reject(errorMessage);
						return;
					}
					defer.resolve(response);

				},
				function(error){
					console.error(error);
					defer.reject("Failed to delete vehicle image");
				}
			);	

			return defer.promise;	
		}

		this.getVehicleBrands = function(){
			var defer = $q.defer();

			api.getConstants.getVehicleBrands.get(
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);
						defer.reject(errorMessage);
						return;
					}

					defer.resolve(response);

				},
				function(error){
					console.error(error);
					defer.reject("Failed to get vehicle brands");
				}
			);

			return defer.promise;			
		}

		this.getCachedVehicleBrands = function () {
			return ConstantCacheService.get('vehicle_brands', function () {
				return this.getVehicleBrands();
			}.bind(this));
		}

		this.extractVehicleInfoFromRM = function(url){
			var defer = $q.defer();

			if(url == null){
				defer.reject("Url is null.");
				return defer.promise;
			}

			api.webProxy.get(
				{url: url},
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);
						defer.reject(errorMessage);
						return;
					}
					var extractedData = extractVehicleInfoFromHtmlString(response.data);

					if(extractedData){
						defer.resolve(extractedData);
					}else{
						defer.reject("Failed to extract data.");
					}
					
				},
				function(error){
					console.error(error);
					defer.reject("Failed to parse url");
				}
			)

			return defer.promise;
		}

		function extractVehicleInfoFromHtmlString(htmlString){
			
			var vehicleInfo;
			var startPoint = "var vmsData = {";
			var endPoint = '};';

			if(!htmlString){
				return;
			}

			var startPointIndex = htmlString.indexOf(startPoint) - 1;
			var endPointIndex = htmlString.indexOf(endPoint, startPointIndex) + 1;

			var vehicleInfoJsonString = htmlString.slice(startPointIndex + startPoint.length, endPointIndex)

			try{
				vehicleInfo = angular.fromJson(vehicleInfoJsonString).vehicle;
			}catch(error){
				console.error("Failed to extract vehicle infos.");
				return null;
			}

			if(vehicleInfo.highwayFuelEfficiency){
				vehicleInfo.highwayFuelEfficiency = UnitTranslator.milePerGallonToGallonPerHundredkm(vehicleInfo.highwayFuelEfficiency, 1);
			}

			if(vehicleInfo.cityFuelEfficiency){
				vehicleInfo.cityFuelEfficiency = UnitTranslator.milePerGallonToGallonPerHundredkm(vehicleInfo.cityFuelEfficiency, 1);
			}

			var imageUrlList = [];

			if(Array.isArray(vehicleInfo.image)){
				imageUrlList = vehicleInfo.image.map(function(image){
					if(image && image.image_original){
						return image.image_original.substring(0, image.image_original.lastIndexOf('-'));
					}			
				});
			}

			return {
				vehicleInfo: vehicleInfo,
				vehicleImages: imageUrlList
			}
		}

		this.downloadImageFromUrl = function(url){
        	var defer = $q.defer()

        	var api = $resource(url, {}, {
	        		download:{
	        			method:"GET",
	        			responseType:'arraybuffer',
						transformResponse: function (data) { 
							return { data: data } 
						}
	        		}
	        	});
        	
        	api.download(
        		function(response){
        			defer.resolve(response)
        		},
        		function(error){
        			defer.reject(error)
        		}
        	);

        	return defer.promise;
		}

		this.getLocations = function(resourcePath){
			var defer = $q.defer();

			api.locations.getLocations(
				resourcePath,
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);
						defer.reject(errorMessage);
						return;
					}

					defer.resolve(response);
				},
				function(error){
					console.error(error);
					defer.reject("Failed to get locations");
				}
			);

			return defer.promise;
		}

		this.getCachedLocations = function(resourcePath) {
			var cacheKey = getLocationsCacheKey(resourcePath);
			var ttl = 60 * 60 * 1000;

			return ConstantCacheService.get(cacheKey, function () {
				return this.getLocations(resourcePath);
			}.bind(this), ttl);
		}

		function getLocationsCacheKey(resourcePath) {
			if (resourcePath && resourcePath.companyID) {
				return 'locations_company_' + resourcePath.companyID;
			}

			return 'locations';
		}

		this.getInventoryInfos = function(companyID, filters, inventoryParam) {
			var defer = $q.defer();

			var queryParams = Object.assign({}, {companyID: companyID}, filters, inventoryParam);

			api.vehicleInventoryInfo.getInventoryInfo(
				queryParams,
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);
						defer.reject(errorMessage);
						return;
					}

					defer.resolve(response);
				},
				function(error){
					console.error(error);
					defer.reject("Failed to get inventory infos");
				}
			);

			return defer.promise;
		}

		this.getCommonParts = function(companyID, filters) {
			var defer = $q.defer();

			var queryParams = Object.assign({}, {companyID: companyID}, filters);

			api.vehicleCommonParts.getCommonParts(
				queryParams,
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);
						defer.reject(errorMessage);
						return;
					}

					defer.resolve(response);
				},
				function(error){
					console.error(error);
					defer.reject("Failed to get inventory infos");
				}
			);

			return defer.promise;
		}

		this.getCommonPartsFromInventory = function(companyID, filters) {
			var defer = $q.defer();

			var queryParams = Object.assign({}, {companyID: companyID}, filters);

			api.vehicleCommonPartsFromInventory.getCommonParts(
				queryParams,
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);
						defer.reject(errorMessage);
						return;
					}

					defer.resolve(response);
				},
				function(error){
					console.error(error);
					defer.reject("Failed to get inventory infos");
				}
			);

			return defer.promise;
		}

		this.getMostRecentParts = function(companyID, filters) {
			var defer = $q.defer();

			var queryParams = Object.assign({}, {companyID: companyID}, filters);

			api.vehicleMostRecentParts.getMostRecentParts(
				queryParams,
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);
						defer.reject(errorMessage);
						return;
					}

					defer.resolve(response);
				},
				function(error){
					console.error(error);
					defer.reject("Failed to get inventory infos");
				}
			);

			return defer.promise;
		}

		this.getMostRecentPartsFromInventory = function(companyID, filters) {
			var defer = $q.defer();

			var queryParams = Object.assign({}, {companyID: companyID}, filters);

			api.vehicleMostRecentPartsFromInventory.getMostRecentParts(
				queryParams,
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);
						defer.reject(errorMessage);
						return;
					}

					defer.resolve(response);
				},
				function(error){
					console.error(error);
					defer.reject("Failed to get inventory infos");
				}
			);

			return defer.promise;
		}

		this.getMostRecentLabour = function(companyID, filters) {
			var defer = $q.defer();

			var queryParams = Object.assign({}, {companyID: companyID}, filters);

			api.vehicleMostRecentLabourFromPastWorkOrder.getMostRecentLabourFromPastWorkOrder(
				queryParams,
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);
						defer.reject(errorMessage);
						return;
					}

					defer.resolve(response);
				},
				function(error){
					console.error(error);
					defer.reject("Failed to get recent labour infos");
				}
			);

			return defer.promise;
		}

		this.getMostRecentMiscfee = function(companyID, filters) {
			var defer = $q.defer();

			var queryParams = Object.assign({}, {companyID: companyID}, filters);

			api.vehicleMostRecentMiscfeeFromPastWorkOrder.getMostRecentMiscfeeFromPastWorkOrder(
				queryParams,
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);
						defer.reject(errorMessage);
						return;
					}

					defer.resolve(response);
				},
				function(error){
					console.error(error);
					defer.reject("Failed to get recent misc fee infos");
				}
			);

			return defer.promise;
		}

		const updateWorkOrderFilterTimeRange = $resource(
			baseUrl + "companies/:companyID/vehicles/:vehicleID/workordertimerangefilter/:workordertimerangefilterID",
			{
				companyID:"@companyID",
				vehicleID: "@vehicleID",
				workordertimerangefilter: "@workordertimerangefilterID"
			},
			{
				get:{
					method:"POST",
					headers: baseHeader,
					interceptor:{
						response: function(result){
							const statusCode  = result.headers(Const.header.code);

							if(statusCode != Const.code.success){
								console.error(statusCode, result.headers(Const.header.message));
								return $q.reject(result.headers(Const.header.message));
							}
							return result;
						},
						responseError: function (error){
							if(error && error.xhrStatus == Const.xhrStatus.abort){
								return $q.reject();
							}
							console.error(error);
							return $q.reject(error);
						}
					}
				}
			}
		);

		this.updateWorkOrderFilter = function(companyID, vehicleID, customerID, requestBody){
			const params = angular.copy(requestBody)

			if(params){
				params.companyID = companyID;
				params.vehicleID = vehicleID;
				params.workordertimerangefilterID = customerID
			}
			return updateWorkOrderFilterTimeRange.get(params);
		}

		this.updateVehicleImagesContentType = function(resourcePath, requestBody){
			var defer = $q.defer();

			api.vehicleImagesContentType.updateContentTypeImage(
				resourcePath,
				requestBody,
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);
						defer.reject(errorMessage);
						return;
					}

					defer.resolve(true);					
				},
				function(error){
					var errorMessage = error.status + ': ' + error.statusText;
					defer.reject(errorMessage);
				}
			);	

			return defer.promise;		
		}

		this.getAllMatchedVehiclesForProfileReport = function(vehicleResourcePath, vehicleFilters){
			var vehicleList = [];
			var _this = this;
			
			return _this.getVehicleForProfileReport(vehicleResourcePath, vehicleFilters, {page: 1, limit: 100})
				.then(function(response){
					if(!response || !Array.isArray(response.data)){
						return $q.reject("Failed to fetch vehicles for report.");
					}

					vehicleList = vehicleList.concat(response.data);

					var totalItem = HeaderHelper.getPaginationTotalItem(response.headerGetter);
					var currentPage = HeaderHelper.getPaginationCurrentPage(response.headerGetter);
					var itemsPerPage = HeaderHelper.getPaginationItemsPerPage(response.headerGetter);

					var queue = [];

					if(response.data.length < totalItem){
						var totalPage = Math.ceil(totalItem/itemsPerPage);

						for(var i = 2; i <= totalPage; i++){
							queue.push(_this.getVehicleForProfileReport(vehicleResourcePath, vehicleFilters, {page: i, limit: 100}));
						}
					}

					return $q.all(queue);
				})
				.then(function(responseList){
					if(!Array.isArray(responseList)){
						return $q.reject("Failed to fetch vehicles for report.");
					}

					for(var i = 0; i < responseList.length; i++){
						var response = responseList[i];

						if(!response || !Array.isArray(response.data)){
							return $q.reject("Failed to fetch vehicles for report.");
						}

						vehicleList = vehicleList.concat(response.data);
					}

					return $q.resolve(vehicleList);
				});
		}

		this.getVehicleDetails = function(resourcePath, filters, pagination, sorting){
			var defer = $q.defer();
			var queryParams = Object.assign({}, resourcePath, filters, pagination, sorting);

			api.vehicleDetails.getVehicleDetails(
				queryParams,
				function(response, header){
					var statusCode  = header(codeKey);
					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);
						defer.reject(errorMessage);
						return;
					}

					var vehicleList = [];
					
					response.forEach(function(data){
						var vehicle = new Vehicle();
						vehicle.setAttributes(data); 
						vehicleList.push(vehicle);
					})

					var result = {
						data: vehicleList,
						headerGetter: header
					}
					defer.resolve(result);

				},
				function(error){
					console.error(error);
					defer.reject("Failed to get vehicles");
				}
			);

			return defer.promise;
		}

		this.getTestDriveVehicleHistory = function(resourcePath){			
			var defer = $q.defer();

			api.testDrivesVehicleHistory.getTestDrivesVehicleHistory(
				resourcePath,
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);
						defer.reject(errorMessage);
						return;
					}

					var testDriveList = [];

					response.forEach(function(data){
						var testDrive = new TestDrive();

						testDrive.setAttributes(data);
						testDriveList.push(testDrive);
					})

					defer.resolve(testDriveList);
				},
				function(error){
					defer.reject(error);
				}
			);

			return defer.promise;
		}
	}
})();
(function ()
{
	'use strict';

	angular
		.module("app.vehicles")
		.factory("Vehicle", VehicleClass)

	/** @ngInject */
	function VehicleClass(VehicleFeature,  $filter, GeneralTools)
	{	   
		function Vehicle(){

		}

		Vehicle.prototype.setAttributes = function (attributes) {
	 		var keyList = Object.keys(attributes);

	 		for(var i = 0; i < keyList.length; i++){
	 			var key = keyList[i];
	 			var value = attributes[key];

	 			if(key == 'fk_id_company'){
	 				key = "companyID";
	 			}

	 			if(key == 'id_vehicle'){
	 				key = "vehicleID";
	 			}

	 			this.setAttribute(key, value);
	 		}
		}

		Vehicle.prototype.setAttribute = function (key, value) {
	 		this[key] = value;
		}

		Vehicle.prototype.setResourceID = function (id) {
	 		this.vehicleID = id;
		}

		Vehicle.prototype.getResourceID = function () {
	 		return this.vehicleID;
		}	

		Vehicle.prototype.setParentResourceID = function (id) {
	 		this.companyID = id;
		}

		Vehicle.prototype.getParentResourceID = function () {
	 		return this.companyID;
		}

		Vehicle.prototype.addFeature = function (feature) {
			if(!Array.isArray(this.features)){
				this.features = [];
			}

			if(this.features.indexOf(feature) == -1){
				this.features.push(feature);
			}
		}

		Vehicle.prototype.clearFeatures = function (feature) {
			this.features = [];
		}

		Vehicle.prototype.addFeatures = function (featureList) {
			featureList.forEach(function(feature){
				Vehicle.prototype.addFeature(feature);
			})
		}		

		Vehicle.prototype.getFeatureCategories = function () {
			if(this.features == null || this.features.length <=0 ){
				return;
			}
			var categories = [];
			this.features.forEach(function(feature){

				if(feature.id_preset_feature == null && categories.indexOf(feature.category) == -1){
					categories.push(feature.category);
				}
			})
			return categories;
		}	

		Vehicle.prototype.generateStockNumber = function(){

			if(this.vin != null){
				var endIndex 	= this.vin.length;
				var startIndex 	= endIndex - 8;
				this.stock_number = "R" + this.vin.slice(startIndex, endIndex) + '9';
			}		
		}

		Vehicle.prototype.setMileage = function(){

			if(this.mileage == null || this.mileage == ''){
				this.mileage = null;
				return;
			}

			this.mileage = this.mileage.replace(',', '');
			this.mileage = this.mileage.split(' ')[0];
			this.mileage = $filter('number')(this.mileage, 0);
			this.mileage = this.mileage 

		}

		Vehicle.prototype.isOnline = function () {
	 		if(this.is_online == true){
	 			return true;
	 		}
	 		return false;
		}

		Vehicle.prototype.getYearMakeModel = function () {
	 		var yearMakeModel = ''

	 		yearMakeModel = GeneralTools.stringConnector(yearMakeModel, this.year, ' ');
	 		yearMakeModel = GeneralTools.stringConnector(yearMakeModel, this.make, ' ');
	 		yearMakeModel = GeneralTools.stringConnector(yearMakeModel, this.model, ' ');

	 		if(yearMakeModel.trim() == ''){
	 			return "Unknown"
	 		}

	 		return yearMakeModel;
		}


		return Vehicle;
	}


})();
(function ()
{
	'use strict';

	angular
		.module("app.saleInfo")
		.factory("VehicleBrochure", VehicleBrochureClass)

	/** @ngInject */
	function VehicleBrochureClass($filter, $state, api, ToolsFactory, Const, $q, MessageService, GeneralTools, VehicleService, LoginService)
	{
		function VehicleBrochure(vehicleID, interestRate){
			this.companyID = LoginService.getCompanyID();
			this.vehicleID = vehicleID;
			this.interestRate = interestRate;
		}

		VehicleBrochure.prototype.open = function(interestRate) {
			var defer = $q.defer();
			var _this = this;
			var resourcePath = {
				companyID: _this.companyID,
				vehicleID: _this.vehicleID
			}

			VehicleService.getVehicle(resourcePath)
				.then(function(vehicles){
					if(!vehicles || !Array.isArray(vehicles.data)){
						return $q.reject("Vehicle data is invalid");
					}

					return fillBrochure(vehicles.data[0], interestRate);
				})
				.then(function(){
					defer.resolve();
				})
				.catch(function(error){
					defer.reject(error);
				});

			return defer.promise;
		}

		function fillBrochure(vehicle, interestRate){
			if(!vehicle){
				return $q.reject("Vehicle data is invalid");
			}

			return GeneralTools.getCanvas("assets/images/brochure/posternorate.png", 720, 970)
				.then(function(canvas){			
					var context = canvas.getContext('2d');
					context.font = "650 26px Arial";
					

					fillTextOnCanvasContext(vehicle.year, context, 150,179);
					fillTextOnCanvasContext(vehicle.make, context, 150,221);
					fillTextOnCanvasContext(vehicle.model, context, 150,259);
					fillTextOnCanvasContext(vehicle.transmission_type, context, 150,299);
					fillTextOnCanvasContext($filter("number")(vehicle.mileage), context, 150,340);


					context.font = "700 33px Arial";
					fillTextOnCanvasContext($filter("currency")(vehicle.advertise_price, '$', 0), context, 511, 185);

					context.font = "800 42px Arial";
					fillTextOnCanvasContext( interestRate + "%", context, 35,440);

					pdfMake.createPdf(getPdfContent(canvas)).print();

					return $q.resolve();
				})
		}

		function fillTextOnCanvasContext(text, context, xPosition, yPosition){
			if(text == null || context == null){
				return;
			}

			context.fillText(text, xPosition, yPosition);
		}

		function getPdfContent(canvas){
			var docDefinition = {
				pageSize: { width: 590.00, height: 792.00}, //pageSize: { width: 612.00, height: 792.00}, 'LETTER'
				pageMargins: [0, 0, 0, 0]
        	};

        	var contents = [];

        	contents.unshift({	
				image: canvas.toDataURL("image/jpg", 1.0),
				fit: [630, 792]
			})

        	docDefinition.content = contents;
        	
        	return docDefinition;
		}

		return VehicleBrochure;
	}


})();
(function ()
{
	'use strict';

	angular
		.module("app.userConfig", [])
		.constant("UserConfigConstants", {
			pageKeyNames:{
				workOrderSchedule: "workOrderSchedule",
				workOrderActiveSchedule: "workOrderActiveSchedule",
				browseWorkorders: "browseWorkorders",
				customerPortalAppointment: "customerPortalAppointment"
			}
		})
		.service("UserConfigService", UserConfigService)

	function UserConfigService(api, Const, $q, UserConfig){
		const codeKey = Const.header.code;
		const messageKey = Const.header.message;
		const successCode = Const.code.success;

		this.getUserConfig = function(resourcePath){
			var defer = $q.defer();

			api.userConfig.getConfig(
				resourcePath,
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);

						defer.reject(errorMessage);
						return;
					}

					const userConfig = new UserConfig();
					userConfig.setAttributes(response)
					defer.resolve(userConfig);
				},
				function(error){
					console.error(error);
					defer.reject("Failed to get user config.");
				}
			);	

			return defer.promise;
		}

		this.updateUserConfig = function(resourcePath, requestBody){
			var defer = $q.defer();
			api.userConfig.updateConfig(
				resourcePath,
				requestBody,
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);

						defer.reject(errorMessage);
						return;
					}

					defer.resolve(null);
				},
				function(error){
					console.error(error);
					defer.reject("Failed to update user config.");
				}
			);	

			return defer.promise;
		}
	}


})();
(function ()
{
	"use strict";

	angular
		.module("app.userConfig")
		.component("customFilterList", {
				bindings:{
					filters: '=',
					isLoading: '=',
					onApply: '<',
					onDelete: '<',
					onSave: '<'
				},
				templateUrl: "app/main/user-config/custom-filter-list.html",
				controller: componentController,
		  		controllerAs: 'vm'
			});

		function componentController(){
			var vm = this;	

			vm.$onInit = initComponent;
			vm.saveFilter = saveFilter;

			function initComponent(){

			}

			function saveFilter(){
				if(vm.onSave){
					vm.onSave(vm.currentFilterName);
				}
				
				vm.currentFilterName = null;
			}
		}
})();
(function ()
{
	'use strict';

	angular
		.module("app.userConfig")
		.factory("UserConfig", UserConfigClass)
		
	function UserConfigClass($filter)
	{	 
		const deliveryPageConfigFilterNames = ["mechanicCompleted", "detailCompleted", "licensingCompleted", "location"];
		const deliveryPageConfigPropertyNames = ["name", "filter"];

		function UserConfig(){}

		UserConfig.prototype.setAttributes = function (attributes) {
	 		if(attributes == null){
	 			return;
	 		}

	 		var keyList = Object.keys(attributes);

	 		for(var i = 0; i < keyList.length; i++){
	 			var key = keyList[i];
	 			var value = attributes[key];

	 			this.setAttribute(key, value);
	 		}
		}

		UserConfig.prototype.setAttribute = function (key, value) {
	 		this[key] = value;
		}

		UserConfig.prototype.getResourceId = function(){
	 		return this.id_user_config;
		}

		UserConfig.prototype.getAllConfigs = function(){
			var config;

			if(!this.config){
				return;
			}

			try{
				return JSON.parse(this.config);
			} catch (error) {
				console.error(error);
				return;
			}
		}

		UserConfig.prototype.setAllConfigs = function(config){
			try{
				this.config = JSON.stringify(config);
			} catch (error) {
				console.error(error);
			}
		}

		UserConfig.prototype.getPageConfigs = function(key){
			const config = this.getAllConfigs();

			if(config){
				return config[key];
			}
		}

		UserConfig.prototype.setPageConfigs = function(key, value){
			var currentConfigs = this.getAllConfigs();

			if(!currentConfigs){
				currentConfigs = {};
			}

			currentConfigs[key] = value;

			this.setAllConfigs(currentConfigs);
		}

		UserConfig.prototype.getCustomTaskFilterList = function(){
			const config = this.getAllConfigs();

			if(config){
				return config.customTaskFilterList;
			}
		}

		UserConfig.prototype.setCustomTaskFilterList = function(filterList){
			const currentConfigs = this.getAllConfigs();
			const config = currentConfigs? currentConfigs:{};

			if(!Array.isArray(filterList)){
				console.error("Failed to setCustomTaskFilterList, params invalid");
				return;
			}

			config.customTaskFilterList = [];

			filterList.forEach(function(item){
				if(!item || !item.filter){
					return;
				}

				const filterObj = {filter:{}};

				filterObj.name = item.name;

				filterObj.filter.searchText = item.filter.searchText;
				filterObj.filter.userID = item.filter.userID;
				filterObj.filter.category = item.filter.category;
				filterObj.filter.status = item.filter.status;
				filterObj.filter.priority = item.filter.priority;
				filterObj.filter.location = item.filter.location;

				config.customTaskFilterList.push(filterObj)
			});

			this.setAllConfigs(config);
		}

		UserConfig.prototype.getDeliveryPageConfig = function(){
			const config = this.getAllConfigs();

			if(config){
				return config.deliveryPageConfig
			}
		}

		UserConfig.prototype.setDeliveryPageConfig = function(pageConfig){
			const currentConfigs = this.getAllConfigs();
			const config = currentConfigs? currentConfigs:{};

			if(!pageConfig || !Array.isArray(pageConfig.filterList)){
				console.error("Failed to setDeliveryPageConfig, params invalid");
				return;
			}

			config.deliveryPageConfig = {filterList:[]};

			pageConfig.filterList.forEach(function(item){
				Object.keys(item).forEach(function(propertyName){
					if(deliveryPageConfigPropertyNames.indexOf(propertyName) == -1){
						delete item[propertyName];
					}

					if(item.filter){
						Object.keys(item.filter).forEach(function(filterName){
							if(deliveryPageConfigFilterNames.indexOf(filterName) == -1){
								delete item.filter[filterName];
							}
						});
					}
				});

				config.deliveryPageConfig.filterList.push(item);
			});

			this.setAllConfigs(config);
		}
		
		return UserConfig;
	}
})();
(function ()
{
    "use strict";

    angular
        .module("app.token", [])
        .factory("TokenFactory", TokenFactory);

    //will be finished later 
    function TokenFactory(){
        var factory = {};     
        factory.renewToken = function(){            
        }
        factory.tokenValidation = function(){
        }
        return factory;
    }   
})();



(function ()
{
    "use strict";

    angular
        .module("app.token")
        .service("TokenService", TokenService);

    //will be finished later 
    function TokenService(TokenFactory)
    {          
        this.renewToken = function(){
        };
        this.tokenValidation = function(){
        };       
    }
})();
(function ()
{
    "use strict";

    angular
        .module("app.tools", [])
        .factory("ToolsFactory", ToolsFactory);

    //will be finished later 
    function ToolsFactory(){
        var factory = {};   

        factory.checkCode = function(code, codeType){

            if(code == null || typeof(code) != "number"){
                return;
            }

            if(codeType == null || typeof(codeType) != "number"){
                return;
            }            
            
            return (getFirstDigit(code) == getFirstDigit(codeType));
        }         

        factory.removeItemFromArray = function(array, element) {         
            while (array.indexOf(element) != -1) {
                array.splice(array.indexOf(element), 1);
            }
        }

        factory.addUniqueItemToArray = function(array, element) {
           
            if (array.indexOf(element) == -1) {
                array.push(element);
            }
        }

        factory.dividDataByPage = function(rawData, itemPerPage){            
            var totalItem = rawData.length;
            var processedData = [];
            var totalPage = Math.ceil(totalItem/itemPerPage); 

            for(var i = 0 ; i < totalPage; i++ ){
                processedData[i] = rawData.slice(i*itemPerPage, (i+1)*itemPerPage);
            }

            return processedData;
        }

        factory.pageListBuilder = function(totalPage, currentPage){
            var pages = []; 

            var firstPage;
            var lastPage;          

            if(totalPage <= 9){
                firstPage = 1;
                lastPage = totalPage;
            }else if(currentPage <= 5){
                firstPage = 1;
                lastPage = firstPage + 8;
            }else if((totalPage - currentPage ) <= 5){
                lastPage = totalPage;
                firstPage = lastPage - 8;
            }else{
                firstPage = currentPage - 4 ;
                lastPage = currentPage + 4 ;
            }               
            
            for(var i = firstPage; i <= lastPage; i++){
                var page = {};  
                page.pageNumber=i;

                if(i == currentPage){                   
                    page.isDisabled="disabled";

                }
                pages.push(page);              
            }
            return pages;
        }


        factory.errorHandler = function(header){

            window.alert("code" + header("code") +' : '+ header("message"));
        }

		factory.isSameArray =function(array_1, array_2) {

			if (array_1 === array_2){ 
				return true;
			}
			if (array_1 == null || array_2 == null) {
				return false;
			}
			if (array_1.length != array_2.length){ 
				return false;
			}   

			array_1.sort();
			array_2.sort();

			for (var i = 0; i < array_1.length; ++i) {
				if (array_1[i] !== array_2[i]) {
					return false;
				}
			}
			return true;
		}

        return factory;


    }   

    function getFirstDigit (number) {
        number = Math.floor(number);
        while (number >= 10){
            number = Math.floor(number/10);
        } 
        return number;
    }



})();


(function ()
{
	'use strict';

	angular
		.module("app.tools")
		.constant("ToolsConstants", {

			taxRate: 0.13,

			units:{
				milePerGallonToGallonPerHundredkm : {
					ratio	: 235.21458329475,
					unit 	: " L/100km"
				},
				gallonToLiter : {
					ratio	: 3.78541,
					unit 	: " L"
				},
				inchToMillimeter : {
					ratio	: 25.4,
					unit 	: " mm"
				},
				poundToKilogram : {
					ratio	: 0.453592,
					unit 	: " Kg"
				}
			},

			regexs:{
				email: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
			},
			
			apiFilters:{
				andConnector: " AND ",
				orConnector: " OR ",
				equalOperator: " eq ",
				notEqualOperator: " ne ",
				greaterOperator: " gt ",
				lessOperator: " lt ",
				containOperator: "contains"
			},

			apiSortingDirections:{
				DESC: "DESC",
				ASC: "ASC"
			},

			dollar:{
				fractionSize: 2,
				canBeNegative: true
			}
		})
})();
(function ()
{
	'use strict';

	angular
		.module("app.tools")
		.service("UnitTranslator", UnitTranslator)
		.service("GeneralTools", GeneralTools)

	function GeneralTools(LoginService, ApiConst, $location, $q, $window, Const, ToolsConstants, $filter, $anchorScroll){
		const filterConsts = ToolsConstants.apiFilters;
		const token = LoginService.getToken();

		const phoneNumberTranslator = {
			inputToModel: stringToIntegerString,
			inputToView: stringToPhoneNumberString,
			modelToView: stringToPhoneNumberString
		};

		const dollarTranslator = {
			inputToModel: stringToDecimal,
			inputToView: stringToDollarString,
			modelToView: numberToDollarString
		};

		const initCapitalizeTranslator = {
			inputToModel: initCapitalize,
			inputToView: initCapitalize
		};

		const allCapitalizeTranslator = {
			inputToModel: allCapitalize,
			inputToView: allCapitalize
		};

		const allInitCapitalizeTranslator = {
			inputToModel: allInitCapitalize,
			inputToView: allInitCapitalize
		};

		const postalCodeTranslator = {
			inputToModel: stringToWordString,
			inputToView: stringToPostalCodeString,
			modelToView: stringToPostalCodeString
		};

		const monthTranslator = {
			inputToModel: stringToMonthNumber,
			inputToView: stringToMonthString
		}

		const sinTranslator = {
			inputToModel: stringToIntegerString,
			inputToView: stringToSinString,
			modelToView: stringToSinString
		};

		const vinTranslator = {
			inputToModel: stringToVinString,
			inputToView: stringToVinString
		};

		const decimalTranslator = {
			inputToModel: stringToDecimal,
			inputToView: stringToDecimalString
		};

		const percentageTranslator = {
			inputToModel: percentageStringToDecimal,
			inputToView: stringToPercentageString,
			modelToView: decimalToPercentageString
		};

		this.inputTranslators = {
			dollar: dollarTranslator,
			phoneNumber: phoneNumberTranslator,
			initCapitalize: initCapitalizeTranslator,
			allCapitalize: allCapitalizeTranslator,
			allInitCapitalize:allInitCapitalizeTranslator,
			postalCode: postalCodeTranslator,
			month: monthTranslator,
			SIN: sinTranslator,
			VIN: vinTranslator,
			decimal: decimalTranslator,
			percentage: percentageTranslator
		};

		this.stringToPhoneNumberString = stringToPhoneNumberString;
		this.preciseNumber = preciseNumber;

		this.isTouchScreenDevice = function(){
			var prefixes = ' -webkit- -moz- -o- -ms- '.split(' ');
			
			if (('ontouchstart' in window) || window.DocumentTouch && document instanceof DocumentTouch) {
				return true;
			}
		
			// include the 'heartz' as a way to have a non matching MQ to help terminate the join
			// https://git.io/vznFH
			var query = ['(', prefixes.join('touch-enabled),('), 'heartz', ')'].join('');
			return window.matchMedia(query).matches;
		}

		this.getValidTimeString = function(validTime){
			if(typeof(validTime) != "number"){
				return;
			}

			var validTimeString = '';

			const year = Math.floor(validTime / 12);
			const month = validTime % 12;

			const yearUnit = year > 1 ? " Years" : " Year";
			const monthUnit = month > 1 ? " Months" : " Month";

			if(year > 0){
				validTimeString = stringConnector(validTimeString, year + yearUnit, ' & ');
			}

			if(month > 0){
				validTimeString = stringConnector(validTimeString, month + monthUnit, ' & ');
			}

			return validTimeString
		}

		this.getSortingFilter = function(sortBy, isDESC){
			if(!sortBy){
				return;
			}
			
			return {
				sortBy: sortBy,
				sortDirection: isDESC ? ToolsConstants.apiSortingDirections.ASC : ToolsConstants.apiSortingDirections.DESC
			}
		}

		this.getRandomColorString = function(){
			var num = Math.round(0xffffff * Math.random());
			var r = num >> 16;
			var g = num >> 8 & 255;
			var b = num & 255;

			return "rgba(" + r + ", " + g + ", " + b + ", 1)";
		}

		this.getBaseUrl = function(){
			return ApiConst.http + ApiConst.host + '/' + ApiConst.apiPortoal + '/' + ApiConst.apiVersion + '/';
		}

		this.getNoCacheHeader = function(){
			const header = {};

			header["Cache-Control"] = "no-cache, no-store, must-revalidate";
			header["Pragma"] = "no-cache";
			header["Expires"] = 0;
			header.token = token;
			
			return header;
		}

		this.getBaseHeader = function(){			
			return { token: token };
		}

		this.scrollToTag = function (tag){
			var newHash = tag;
			if ($location.hash() !== newHash) {
				// set the $location.hash to `newHash` and
				// $anchorScroll will automatically scroll to it
				$location.hash(tag);
			} else {
				// call $anchorScroll() explicitly,
				// since $location.hash hasn't changed
				$anchorScroll();
			}
		}

		this.updateResourceRequestBodyGenerator = function(currentObj, originObj){
			if(currentObj == null || originObj == null){
				return;
			}

			var keyList = Object.keys(currentObj);
			var changedProperties = {};

			keyList.forEach(function(key){
				var currentValue = currentObj[key];
				var originValue = originObj[key];
				if((currentValue == originValue) || (isEmpty(currentValue) && isEmpty(originValue)) || key == "$$hashKey"){
					return;
				}

				changedProperties[key] = currentValue;
			});

			if(Object.keys(changedProperties).length > 0){
				return changedProperties;
			}
		}

		function isEmpty(value){
			if(value == null){
				return true;
			}

			if(typeof(value) == "string"){
				return value.trim() === '';
			}

			return false;
		}

		this.addBracketToString = function (string) {
			return '(' + string + ')';
		}

		this.notEqualRangeFilterBuilder = function (key, minValue, maxValue) {
			const greaterThanFilter = this.greaterThanFilterBuilder(key, minValue);
			const lessFilter = this.lessThanFilterBuilder(key, maxValue);

			if(greaterThanFilter && lessFilter){
				return " ( " + greaterThanFilter  + filterConsts.andConnector + lessFilter + " ) ";
			}
		}

		this.equalRangeFilterBuilder = function (key, minValue, maxValue) {
			const equalOrGreaterFilter = this.equalOrGreaterThanFilterBuilder(key, minValue);
			const equalOrLesshanFilter = this.equalOrLesshanFilterBuilder(key, maxValue);

			if(equalOrGreaterFilter && equalOrLesshanFilter){
				return " ( " + equalOrGreaterFilter  + filterConsts.andConnector + equalOrLesshanFilter + " ) ";
			}
		}

		this.rightEqualRangeFilterBuilder = function (key, minValue, maxValue) {
			const greaterThanFilter = this.greaterThanFilterBuilder(key, minValue);
			const equalOrLesshanFilter = this.equalOrLesshanFilterBuilder(key, maxValue);

			if(greaterThanFilter && equalOrLesshanFilter){
				return " ( " + greaterThanFilter  + filterConsts.andConnector + equalOrLesshanFilter + " ) ";
			}
		}

		this.leftEqualRangeFilterBuilder = function (key, minValue, maxValue) {
			const equalOrGreaterFilter = this.equalOrGreaterThanFilterBuilder(key, minValue);
			const lessFilter = this.lessThanFilterBuilder(key, maxValue);

			if(equalOrGreaterFilter && lessFilter){
				return " ( " + equalOrGreaterFilter  + filterConsts.andConnector + lessFilter + " ) ";
			}
		}

		this.equalOrGreaterThanFilterBuilder = function(key, value) {
			const equalFilter = this.equalFilterBuilder(key, value);
			const greaterFilter = this.greaterThanFilterBuilder(key, value);

			if(equalFilter && greaterFilter){
				return " ( " + equalFilter  + filterConsts.orConnector + greaterFilter + " ) ";
			}
		}

		this.equalOrLesshanFilterBuilder = function(key, value) {
			const equalFilter = this.equalFilterBuilder(key, value);
			const lessFilter = this.lessThanFilterBuilder(key, value);

			if(equalFilter && lessFilter){
				return " ( " + equalFilter  + filterConsts.orConnector + lessFilter + " ) ";
			}
		}

		this.equalFilterBuilder = function(key, value) {
			return "( " + key + filterConsts.equalOperator + value + " )";
		}

		this.notEqualFilterBuilder = function(key, value) {
			return "( " + key + filterConsts.notEqualOperator + value + " )";
		}

		this.greaterThanFilterBuilder = function(key, value) {
			return "( " + key + filterConsts.greaterOperator + value + " )";
		}

		this.lessThanFilterBuilder = function(key, value) {
			return "( " + key + filterConsts.lessOperator + value + " )";
		}

		this.containFilterBuilder = function(key, value) {
			return filterConsts.containOperator + "(" + key + ",'" + value + "')";
		}

		this.urlObjectParamTranslator = function(paramValue){
			try{
				return JSON.parse(paramValue);
			} catch (err){
				return undefined;
			}
		}

		this.urlDateParamTranslator = function(paramValue){
			const dateString = this.urlStringParamTranslator(paramValue);
			const momentObj = moment(dateString);

			if(dateString && momentObj.isValid()){
				return new Date(momentObj);
			}

			return undefined;
		}

		this.urlBooleanParamTranslator = function(paramValue){
			if(paramValue === true || paramValue === "true"){
				return true;
			}

			if(paramValue === false || paramValue === "false"){
				return false;
			}

			if(paramValue === null || paramValue === "null"){
				return null;
			}

			return undefined;
		}

		this.urlNumberParamTranslator = function(paramValue){
			if(paramValue === null || paramValue === "null"){
				return null;
			}

			const numberValue = parseFloat(paramValue);

			if(isNaN(numberValue)){
				return undefined;
			}else{
				return numberValue
			}
		}

		this.urlStringParamTranslator = function(paramValue){
			if(paramValue === null || paramValue === "null"){
				return null;
			}

			if(typeof(paramValue) == "string"){
				return paramValue;
			}

			return undefined;
		}

		this.parseXlsToJson = function(fileReaderOnloadData){
			var data;
			var cfb;
			var workbook;
			var result = {};

			try{
				data = fileReaderOnloadData.target.result;
				cfb = XLS.CFB.read(data, {type: 'binary'});
				workbook = XLS.parse_xlscfb(cfb);

				// Loop Over Each Sheet
				workbook.SheetNames.forEach(function(sheetName) {
					// Obtain The Current Row As CSV
					var sCSV = XLS.utils.make_csv(workbook.Sheets[sheetName]);	 
					var data = XLS.utils.sheet_to_json(workbook.Sheets[sheetName], {header:1});	 
					
					result[sheetName] = data;
				});

			} catch (error) {
				console.error(error);
				return;
			}

			return result;
		}

		this.parseNumber = function(number){
			var parsedNumber = parseFloat(number);

			if(isNaN(parsedNumber)){
				return 0;
			}

			return parsedNumber
		}

		this.getCanvas = function (imageSrc, width, height){
			var defer = $q.defer();
			var image = new Image();

			image.onload = function(){
				const canvas = document.createElement('canvas');

				canvas.width = width;
				canvas.crossOrigin = "Anonymous";
				canvas.height = height;

				var context = canvas.getContext('2d');

				context.drawImage(image, 0, 0);

				defer.resolve(canvas);
    		}

    		image.src = imageSrc;
    		return defer.promise;
		}

		this.addToTotal = function(totalAmount, addOnAmount){
			var totalNumber = parseFloat(totalAmount);
			var addOnNumber = parseFloat(addOnAmount);

			if(isNaN(totalNumber) || totalNumber == undefined){
				totalNumber = 0;
			}

			if(isNaN(addOnNumber) || addOnNumber == undefined){
				addOnNumber = 0;
			}

			return totalNumber + addOnNumber;
		}

		// this.generalExcelSheet = function(data, fileName){
		// 	if(!data){
		// 		console.error("data invalid");
		// 		return;
		// 	}
		// 	var sheetNameList = Object.keys(data);

		// 	var wb = new Workbook();

		// 	sheetNameList.forEach(function(sheetName){
		// 		wb.SheetNames.push(sheetName);
		// 		wb.Sheets[sheetName] = getSheet(data[sheetName]);
		// 	})

		// 	var wbout = XLSX.write(wb, {bookType:'xlsx', bookSST:true, type: 'binary'});

		// 	saveAs(new Blob([s2ab(wbout)],{type:"application/octet-stream"}), fileName + '.xlsx');
		// }
		this.generalExcelSheet = function(data, fileName, userMap){
			if (!data) {
				console.error("data invalid");
				return;
			}

			var wb = new Workbook();

			// Add original sheets
			Object.keys(data).forEach(function(sheetName){
				wb.SheetNames.push(sheetName);
				wb.Sheets[sheetName] = getSheet(data[sheetName]);
			});

			// ➕ Add a tab for each user in the Map
			if (userMap instanceof Map) {
				userMap.forEach(function(entries, fk_id_user) {
					if (!entries.length) return;

					var userName = entries[0].userName || ('User_' + fk_id_user);
					var sheetName = userName.length > 31 ? userName.slice(0, 31) : userName;

					var aoa = [
						["VIN", "Year", "Make", "Model", "Customer Name", "Customer URL"]
					];

					for (var i = 0; i < entries.length; i++) {
						var entry = entries[i];
						aoa.push([
							entry.vin,
							entry.year,
							entry.make,
							entry.model,
							entry.customName,
							entry.customerUrl
						]);
					}

					wb.SheetNames.push(sheetName);
					wb.Sheets[sheetName] = createSheetFromAOA(aoa);
				});
			}

			// Export
			var wbout = XLSX.write(wb, {bookType:'xlsx', bookSST:true, type: 'binary'});
			saveAs(new Blob([s2ab(wbout)], {type:"application/octet-stream"}), fileName + '.xlsx');
		}


		function datenum(v, date1904) {
			if(date1904) v+=1462;
			var epoch = Date.parse(v);
			return (epoch - new Date(Date.UTC(1899, 11, 30))) / (24 * 60 * 60 * 1000);
		};

		function getSheet(data) {
			var ws = {};
			var range = {s: {c:10000000, r:10000000}, e: {c:0, r:0 }};
			for(var R = 0; R != data.length; ++R) {
				for(var C = 0; C != data[R].length; ++C) {
					if(range.s.r > R) range.s.r = R;
					if(range.s.c > C) range.s.c = C;
					if(range.e.r < R) range.e.r = R;
					if(range.e.c < C) range.e.c = C;
					var cell = {v: data[R][C] };
					if(cell.v == null) continue;
					var cell_ref = XLSX.utils.encode_cell({c:C,r:R});
					
					if(typeof cell.v === 'number') cell.t = 'n';
					else if(typeof cell.v === 'boolean') cell.t = 'b';
					else if(cell.v instanceof Date) {
						cell.t = 'n'; cell.z = XLSX.SSF._table[14];
						cell.v = datenum(cell.v);
					}
					else cell.t = 's';
					
					ws[cell_ref] = cell;
				}
			}
			if(range.s.c < 10000000) ws['!ref'] = XLSX.utils.encode_range(range);
			return ws;
		};

		function Workbook() {
			if(!(this instanceof Workbook)) return new Workbook();
			this.SheetNames = [];
			this.Sheets = {};
		}

		function s2ab(s) {
			var buf = new ArrayBuffer(s.length);
			var view = new Uint8Array(buf);
			for (var i=0; i!=s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF;
			return buf;
		}

		this.getHarmonizedSalesTax = function(basePrice, taxRate){
			var rate = parseFloat(taxRate);

			if(isNaN(rate)){
				rate = ToolsConstants.taxRate;
			}

			return basePrice * rate;
		}

		function stringToPercentageString(inputValue, options, originModelValue){
			if(!inputValue){
				return '';
			}

			var decimalString = stringToDecimalString(inputValue, options);

			if(options && typeof(options.maxValue) == "number"){
				const decimal = parseFloat(decimalString);

				if(decimal > options.maxValue){
					decimalString = options.maxValue.toString();
				}	
			}

			if(inputValue.indexOf('%') == -1 && typeof(originModelValue) == "number" && !isNaN(originModelValue)){
				decimalString = decimalString.slice(0, decimalString.length - 1);
			}

			if(decimalString){
				decimalString = decimalString + '%';
			}

			return decimalString;
		}

		function decimalToPercentageString(inputValue, options){
			var fractionSize = ToolsConstants.dollar.fractionSize;

			if(options && typeof(options.decimalFractionSize) == "number"){
				fractionSize = options.decimalFractionSize;
			}

			if(typeof(inputValue) != "number" || isNaN(inputValue)){
				return '';
			}

			return preciseNumber(inputValue * 100, 2 + fractionSize) + '%';//inputValue * 100 + '%';
		}

		function percentageStringToDecimal(inputValue, options){
			var fractionSize = ToolsConstants.dollar.fractionSize;

			if(options && typeof(options.decimalFractionSize) == "number"){
				fractionSize = options.decimalFractionSize;
			}

			var decimal = stringToDecimal(inputValue, options);

			if(options && typeof(options.maxValue) == "number" && decimal > options.maxValue){
				decimal = options.maxValue;
			}

			if(typeof(decimal) != "number" || isNaN(decimal)){
				return null;
			}

			var value = preciseNumber(decimal / 100, 2 + fractionSize);

			return value;
		}

	
		function stringToVinString(inputValue, options){
			if(!inputValue){
				return '';
			}

			inputValue = inputValue.slice(0, 17);


			inputValue = stringToWordString(inputValue);
			inputValue = allCapitalize(inputValue);

			return inputValue;
		}

		function stringToMonthString(string, options){
			string = stringToMonthNumber(string);

			if(typeof(string) == "number" && !isNaN(string)){
				return string.toString();
			}

			return '';
		}

		function stringToMonthNumber(string, options){
			const numberString = extractIntegerString(string, false);
			var monthString;

			for (var i = 0; i <= numberString.length; i++)
			{
				var num = parseInt(numberString.substr(0,i));
				if (num > 11)
					break;
				else
					monthString = num;
			}

			const month = parseInt(monthString);

			if(isNaN(month)){
				return null;
			}

			return month;	
		}

		function stringToWordString(inputValue, options){
			if(!inputValue){
				return '';
			}

			return inputValue.replace(/[^A-Za-z0-9]/gi, '');
		}

		function stringToPostalCodeString(string, options){
			string = allCapitalize(string);
			string = stringToWordString(string);

			string = string.slice(0, 6);

			if(string.length > 3){
				string = [string.slice(0, 3), ' ', string.slice(3)].join('');
			}

			return string;
		}
		
		function initCapitalize(string, options){
			if(!string){
				return '';
			}

			return string.charAt(0).toUpperCase() + string.slice(1);
		}

		function allCapitalize(inputValue, options){
			if(!inputValue){
				return '';
			}

			return inputValue.toUpperCase();
		}

		function allInitCapitalize(inputValue, options){
			if(!inputValue){
				return '';
			}

			const words = inputValue.split(' ');
			var newString = '';

			words.map(function(word, index){
				newString += initCapitalize(word)

				if(index < words.length - 1){
					newString += ' ';
				}			
			})

			return newString;
		}

		function extractDecimalString(inputValue, fractionSize, canBeNegative) {
			if(!inputValue){
				return '';
			}

			var indexOfDot = inputValue.indexOf('.')
			var stringBeforeDot = '';
			var stringAfterDot = '';
			var decimal = '';
			var minusSign = '';

			if((inputValue[0] == '-' || inputValue[1] == '-') && canBeNegative === true){
				minusSign = '-';
			}

			if(indexOfDot == -1){
				stringBeforeDot = inputValue;
			} else {
				stringBeforeDot = inputValue.slice(0, indexOfDot);
				stringAfterDot = inputValue.slice(indexOfDot + 1, inputValue.length);
			}

			stringBeforeDot = stringBeforeDot.replace(/\D*/gi, '');

			const integer = parseInt(stringBeforeDot);

			// remove 0 in front of the number
			if(!isNaN(integer)){
				stringBeforeDot = integer.toString();
			}

			stringAfterDot = stringAfterDot.replace(/\D*/gi, '');

			if(!isNaN(parseInt(fractionSize))){
				stringAfterDot = stringAfterDot.slice(0, fractionSize);
			}

			if(indexOfDot == -1 || fractionSize === 0){
				decimal = stringBeforeDot + stringAfterDot;
			}else {
				stringBeforeDot = (stringBeforeDot == null || stringBeforeDot.trim() == '')? '0':stringBeforeDot;
				decimal = stringBeforeDot + '.' + stringAfterDot;
			}

			return minusSign + decimal;
		}

		function extractIntegerString(inputValue, canBeNegative) {
			if(!inputValue){
				return '';
			}

			var numberString = '';
			var minusSign = '';

			if((inputValue[0] == '-' || inputValue[1] == '-') && canBeNegative === true){
				minusSign = '-';
			}

			inputValue = inputValue.replace(/\D*/gi, '');

			const integer = parseInt(inputValue);

			// remove 0 in front of the number
			if(isNaN(integer)){
				return '';
			}

			return minusSign + integer.toString();
		}

		function stringToDecimalString(string, options){
			var canBeNegative = ToolsConstants.dollar.canBeNegative;
			var fractionSize = ToolsConstants.dollar.fractionSize;

			if(options){
				if(typeof(options.decimalFractionSize) == "number"){
					fractionSize = options.decimalFractionSize;
				}
				
				if(typeof(options.canBeNegative) == "boolean"){
					canBeNegative = options.canBeNegative;
				}
			}

			return extractDecimalString(string, fractionSize, canBeNegative);
		}

		function stringToDollarString(string, options){
			var canBeNegative = ToolsConstants.dollar.canBeNegative;
			var fractionSize = ToolsConstants.dollar.fractionSize;

			if(options){
				if(typeof(options.decimalFractionSize) == "number"){
					fractionSize = options.decimalFractionSize;
				}
				
				if(typeof(options.canBeNegative) == "boolean"){
					canBeNegative = options.canBeNegative;
				}
			}

			var dollarString = extractDecimalString(string, fractionSize, canBeNegative);
			const number = parseFloat(dollarString);

			if(!dollarString || isNaN(number)){
				return '';
			}

			if(number < 0){
				dollarString = '-$' + dollarString.replace('-', '');
			} else {
				dollarString = '$' + dollarString;
			}

			return dollarString;
		}

		function stringToDecimal(string, options){
			var canBeNegative = ToolsConstants.dollar.canBeNegative;
			var fractionSize = ToolsConstants.dollar.fractionSize;

			if(options){
				if(typeof(options.decimalFractionSize) == "number"){
					fractionSize = options.decimalFractionSize;
				}
				
				if(typeof(options.canBeNegative) == "boolean"){
					canBeNegative = options.canBeNegative;
				}
			}

			const numberString = extractDecimalString(string, fractionSize, canBeNegative);
			const number = parseFloat(numberString);

			if(isNaN(number)){
				return null;
			}

			return number
		}

		function numberToDollarString(number, options){
			if(typeof(number) != "number" || isNaN(number)){
				return '';
			}

			var fractionSize = ToolsConstants.dollar.fractionSize;

			if(options && typeof(options.decimalFractionSize) == "number"){
				fractionSize = options.decimalFractionSize;
			}

			if(number < 0){
				return '-$' + number * -1;
			}

			return '$' + number;
		}

		function stringToIntegerString(string, options){
			return extractIntegerString(string);
		}

		function stringToPhoneNumberString(string, options){
			string = extractIntegerString(string);

			if (string.length === 11 && string.charAt(0) === '1') {
				string = string.slice(1);
			}

			string = string.slice(0, 10);

			var digits = string.length;

			if(digits > 3 && digits <= 6){
				string = ['(', string.slice(0, 3), ') ', string.slice(3)].join('');
			}

			if(digits > 6){
				string = ['(', string.slice(0, 3), ') ', string.slice(3, 6), '-', string.slice(6)].join('');
			}

			return string;
		}

		function stringToSinString(string, options){
			string = extractIntegerString(string);
			string = string.slice(0, 9);

			var digits = string.length;

			if(digits > 3 && digits <= 6){
				string = [string.slice(0, 3), ' - ', string.slice(3)].join('');
			}

			if(digits > 6){
				string = [string.slice(0, 3), ' - ', string.slice(3, 6), ' - ', string.slice(6)].join('');
			}

			return string;
		}

		this.isEmailAddressValid = function(emailAddress){
			return ToolsConstants.regexs.email.test(emailAddress);
		}

		this.getCurrentBrowser = function(){

			var userAgent = $window.navigator.userAgent;

			var browsers = {chrome: /chrome/i, safari: /safari/i, firefox: /firefox/i, edge: /edge/i};

			return userAgent;

			for(var key in browsers) {
				if (browsers[key].test(userAgent)) {
					return key;
				}
			};

			return 'unknown';
		}

		this.isMobileOrTabletDevice = function(){
			var check = false;
			(function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
			return check;
		}

		var codeKey 	= Const.header.code;
		var messageKey 	= Const.header.message;
		var successCode = Const.code.success;

		this.isHttpRequestSuccess = function(reponseHeader){
			var statusCode  = reponseHeader(codeKey);

			if(statusCode != successCode){
				return false;
			}

			return true;
		}

		this.copyToClipboard = function(text){
			const element = document.createElement('textarea');
			element.value = text;
			element.setAttribute('readonly', '');
			element.style.position = 'absolute';
			element.style.left = '-9999px';
			document.body.appendChild(element);
			element.select();
			document.execCommand('copy');
			document.body.removeChild(element);
		}

		this.downloadFileByUrl = function(url, fileName){
			var a = document.createElement("a");
		    document.body.appendChild(a);
		    a.style = "display: none";
		    a.href = url;
	        a.download = fileName;
	        a.click();
		}

		this.getBlobByUrl = function(url, type){
			var defer = $q.defer();

			var xhr = new XMLHttpRequest();
			xhr.open('GET', url, true);
			xhr.responseType = 'blob';

			xhr.onload = function(e) {
				if (this.status == 200) {					
					defer.resolve(new Blob([this.response], {type: type}));
				}else{
					defer.reject(this.status);
				}
			};

			xhr.onerror = function(error){
				defer.reject(error);
			}

			xhr.send();

			return defer.promise;
		}
		
		this.stringConnector = stringConnector
		
		function stringConnector(baseString, stringToAppend, connector){
			if(!stringToAppend){
				return baseString;
			}

			if(typeof(baseString) != "string"){
				baseString = '';
			}

			if (baseString.trim() != ''){
				baseString += connector
			}

			baseString += stringToAppend

			return baseString;
		}
	}

	function preciseNumber(number, fractionSize) {
		var number = parseFloat(number);

		if(isNaN(number)){
			return
		}

		var precision = Math.pow(10, fractionSize);

		return Math.round( number * precision ) / precision;
	}

	function UnitTranslator(ToolsConstants, $filter)
	{   
		var units = ToolsConstants.units;

		function isEmptyString (string){
			if(string.trim() == ''){
				return true;
			}
			return false;
		}

		function getNumberFromString (valueString, $filter){
			var value = valueString.split(' ')[0];

			value = parseInt(value);

			return value;
		}

		this.milePerGallonToGallonPerHundredkm = function  (value, precision){
			value = units.milePerGallonToGallonPerHundredkm.ratio / value;

			return preciseNumber(value, precision);
		}

		this.gallonToLiter = function (value, precision){


			value = units.gallonToLiter.ratio * value;
			//value = $filter('number')(value, 1);

			return preciseNumber(value, precision);
		}

		this.inchToMillimeter = function (value, precision){

			value = units.inchToMillimeter.ratio * value;
			//value = $filter('number')(value, 0);

			return preciseNumber(value, precision);
		}

		this.poundToKilogram = function (value, precision){

			value = units.poundToKilogram.ratio * value;
			//value = $filter('number')(value, 0);

			return preciseNumber(value, precision);
		}
	}
	function createSheetFromAOA(data) {
		var ws = {};
		var range = { s: { c: 0, r: 0 }, e: { c: 0, r: 0 } };
		for (var R = 0; R !== data.length; ++R) {
			for (var C = 0; C !== data[R].length; ++C) {
				var cell = { v: data[R][C] };
				if (cell.v == null) continue;

				var cell_ref = XLSX.utils.encode_cell({ c: C, r: R });

				if (typeof cell.v === 'number') cell.t = 'n';
				else if (typeof cell.v === 'boolean') cell.t = 'b';
				else cell.t = 's';

				ws[cell_ref] = cell;

				if (range.e.r < R) range.e.r = R;
				if (range.e.c < C) range.e.c = C;
			}
		}
		ws['!ref'] = XLSX.utils.encode_range(range);
		return ws;
	}
})();
(function ()
{
	'use strict';

	angular
		.module("app.tools")
		.constant("headerKeys", {
			totalItem:"pagination-total-item",
			itemPerPage:"pagination-limit",
			currentPage:"pagination-page"
		})
		.service("HeaderHelper", HeaderHelper)

	function HeaderHelper($q, $window, Const, ToolsConstants, $filter, headerKeys){

		this.getPaginationTotalItem = function(headerGetter){
			if(typeof(headerGetter) != "function"){
				return;
			}

			return parseInt(headerGetter(headerKeys.totalItem));
		}

		this.getPaginationItemsPerPage = function(headerGetter){
			if(typeof(headerGetter) != "function"){
				return;
			}

			return parseInt(headerGetter(headerKeys.itemPerPage));
		}

		this.getPaginationCurrentPage = function(headerGetter){
			if(typeof(headerGetter) != "function"){
				return;
			}

			return parseInt(headerGetter(headerKeys.currentPage));
		}

		this.getTotalPage = function(headerGetter){
			return Math.ceil(this.getPaginationTotalItem(headerGetter)/this.getPaginationItemsPerPage(headerGetter));
		}

		this.isLastPage = function(headerGetter){
			return this.getTotalPage(headerGetter) <= this.getPaginationCurrentPage(headerGetter);
		}
	}


})();
(function () {
    'use strict';

    angular
        .module('app.tools')
        .factory('ConstantCacheService', ConstantCacheService);

    /** @ngInject */
    function ConstantCacheService($window, $q) {
        var memoryCache = {};
        var PREFIX = 'autocart_constant_cache_';
        var DEFAULT_TTL = 12 * 60 * 60 * 1000; // 12 hours

        return {
            get: get,
            clear: clear,
            clearAll: clearAll
        };

        function get(key, requestFn, ttl) {
            ttl = ttl || DEFAULT_TTL;

            var storageKey = PREFIX + key;

            if (memoryCache[storageKey]) {
                return memoryCache[storageKey];
            }

            var cachedValue = getFromLocalStorage(storageKey, ttl);

            if (cachedValue !== null && cachedValue !== undefined) {
                memoryCache[storageKey] = $q.resolve(cachedValue);
                return memoryCache[storageKey];
            }

            memoryCache[storageKey] = toPromise(requestFn())
                .then(function (result) {
                    saveToLocalStorage(storageKey, result);
                    return result;
                })
                .catch(function (error) {
                    delete memoryCache[storageKey];
                    return $q.reject(error);
                });

            return memoryCache[storageKey];
        }

        function toPromise(value) {
            if (value && value.$promise) {
                return value.$promise;
            }

            return $q.resolve(value);
        }

        function getFromLocalStorage(storageKey, ttl) {
            try {
                var rawValue = $window.localStorage.getItem(storageKey);

                if (!rawValue) {
                    return null;
                }

                var cachedItem = JSON.parse(rawValue);

                if (!cachedItem || !cachedItem.createdAt) {
                    return null;
                }

                if (Date.now() - cachedItem.createdAt > ttl) {
                    $window.localStorage.removeItem(storageKey);
                    return null;
                }

                return cachedItem.value;
            } catch (error) {
                $window.localStorage.removeItem(storageKey);
                return null;
            }
        }

        function saveToLocalStorage(storageKey, value) {
            try {
                $window.localStorage.setItem(storageKey, JSON.stringify({
                    createdAt: Date.now(),
                    value: value
                }));
            } catch (error) {
                // Ignore localStorage error. Memory cache still works.
            }
        }

        function clear(key) {
            var storageKey = PREFIX + key;

            delete memoryCache[storageKey];
            $window.localStorage.removeItem(storageKey);
        }

        function clearAll() {
            Object.keys(memoryCache).forEach(function (storageKey) {
                delete memoryCache[storageKey];
            });

            for (var i = $window.localStorage.length - 1; i >= 0; i--) {
                var storageKey = $window.localStorage.key(i);

                if (storageKey && storageKey.indexOf(PREFIX) === 0) {
                    $window.localStorage.removeItem(storageKey);
                }
            }
        }
    }
})();
(function ()
{
	'use strict';

	angular
		.module('app.settings', ["app.settings.users", "app.settings.googleService", "app.settings.packages", "app.settings.labour", "app.settings.parttype",  "app.settings.customerportalslider", "app.settings.miscfeestypes", "app.settings.jobtypes", "app.settings.warranty", "app.settings.customerportalservicescatogory", "app.settings.coupon", "app.settings.goto"])
		.config(config);

	/** @ngInject */
	function config($stateProvider, msNavigationServiceProvider)
	{	  
		$stateProvider
			.state('app.settings', {
				url : '/settings'
			})

		msNavigationServiceProvider.saveItem('settings', {
			title : 'SETTINGS',
			icon : "icon-settings",
			weight: 3,
			requiredRoles:[]		
		});

		msNavigationServiceProvider.saveItem('settings.users', {
			title: 'Users',
			requiredRoles:[]
		});

		msNavigationServiceProvider.saveItem('settings.users.add-user', {
			title: 'Add User',
			state: 'app.settings.users.add-user',
			requiredRoles:["developer", "company_manager"]			 
		});

		msNavigationServiceProvider.saveItem('settings.users.view-user', {
			title: 'View Users',
			state: 'app.settings.users.view-user',
			requiredRoles:["developer", "company_manager"]
		});

		msNavigationServiceProvider.saveItem('settings.google-service', {
			title: 'Google Services',
			state: 'app.settings.google-service',
			requiredRoles:["developer", "company_manager"]
		});

		msNavigationServiceProvider.saveItem('settings.parttype', {
			title: 'Parts',
			requiredRoles:[]
		});

		msNavigationServiceProvider.saveItem('settings.parttype.view-parttypes', {
			title: 'View Parts',
			state: 'app.settings.parttype.view-parttypes',
			requiredRoles:["developer", "company_manager"]
		});

		msNavigationServiceProvider.saveItem('settings.parttype.add-parttype', {
			title: 'Add Part',
			state: 'app.settings.parttype.add-parttype',
			requiredRoles:["developer", "company_manager"]			 
		});

		msNavigationServiceProvider.saveItem('settings.labour', {
			title: 'Labours',
			requiredRoles:[]
		});

		
		msNavigationServiceProvider.saveItem('settings.labour.view-labour', {
			title: 'View Labours',
			state: 'app.settings.labour.view-labour',
			requiredRoles:["developer", "company_manager"]
		});

		msNavigationServiceProvider.saveItem('settings.labour.add-labour', {
			title: 'Add Labour',
			state: 'app.settings.labour.add-labour',
			requiredRoles:["developer", "company_manager"]			 
		});

			msNavigationServiceProvider.saveItem('settings.coupon', {
				title: 'Coupon',
				requiredRoles:[]
			});

			msNavigationServiceProvider.saveItem('settings.coupon.view-coupon', {
				title: 'View Coupons',
				state: 'app.settings.coupon.view-coupon',
				requiredRoles:["developer", "company_manager"]
			});

			msNavigationServiceProvider.saveItem('settings.coupon.add-coupon', {
				title: 'Add Coupons',
				state: 'app.settings.coupon.add-coupon',
				requiredRoles:["developer", "company_manager"]			 
			});

		msNavigationServiceProvider.saveItem('settings.miscfeestypes', {
			title: 'Miscellaneous Fees',
			requiredRoles:[]
		});

		msNavigationServiceProvider.saveItem('settings.miscfeestypes.view-miscfeestypes', {
			title: 'View Miscellaneous Fees',
			state: 'app.settings.miscfeestypes.view-miscfeestypes',
			requiredRoles:["developer", "company_manager"]
		});

		msNavigationServiceProvider.saveItem('settings.miscfeestypes.add-miscfeestypes', {
			title: 'Add Miscellaneous Fee',
			state: 'app.settings.miscfeestypes.add-miscfeestypes',
			requiredRoles:["developer", "company_manager"]			 
		});

		msNavigationServiceProvider.saveItem('settings.jobtypes', {
			title: 'Jobs',
			requiredRoles:[]
		});

		msNavigationServiceProvider.saveItem('settings.jobtypes.view-jobtypes', {
			title: 'View Jobs',
			state: 'app.settings.jobtypes.view-jobtypes',
			requiredRoles:["developer", "company_manager"]
		});

		msNavigationServiceProvider.saveItem('settings.jobtypes.add-job', {
			title: 'Add Job',
			state: 'app.settings.jobtypes.add-job',
			requiredRoles:["developer", "company_manager"]
		});

		msNavigationServiceProvider.saveItem('settings.packages', {
			title: 'Packages',
			requiredRoles:[]
		});

		msNavigationServiceProvider.saveItem('settings.packages.Packages', {
			title: 'View Packages',
			state: 'app.settings.packages.presetPackages',
			requiredRoles:["developer", "company_manager"]
		});

		msNavigationServiceProvider.saveItem('settings.packages.viewPackages', {
			title: 'Add Package',
			state: 'app.settings.packages.viewPackages',
			requiredRoles:["developer", "company_manager"]
		});
		
		msNavigationServiceProvider.saveItem('settings.warranty', {
			title: 'Warranties',
			requiredRoles:[]
		});

		msNavigationServiceProvider.saveItem('settings.warranty.view-Warranty', {
			title: 'View Warranties',
			state: 'app.settings.warranty.view-Warranty',
			requiredRoles:["developer", "company_manager"]
		});

		msNavigationServiceProvider.saveItem('settings.warranty.add-Warranty', {
			title: 'Add Warranty',
			state: 'app.settings.warranty.add-Warranty',
			requiredRoles:["developer", "company_manager"]
		});

		msNavigationServiceProvider.saveItem('settings.warranty.add-WarrantyFeature', {
			title: 'Add Warranty Feature',
			state: 'app.settings.warranty.add-WarrantyFeature',
			requiredRoles:["developer", "company_manager"]
		});

		msNavigationServiceProvider.saveItem('settings.customerportalslider', {
			title: 'Customer Portal Sliders',
			requiredRoles:[]
		});

		msNavigationServiceProvider.saveItem('settings.customerportalslider.view-customerportalslider', {
			title: 'View Sliders',
			state: 'app.settings.customerportalslider.view-customerportalslider',
			requiredRoles:["developer", "company_manager"]
		});

		msNavigationServiceProvider.saveItem('settings.customerportalslider.add-customerportalslider', {
			title: 'Add Slider',
			state: 'app.settings.customerportalslider.add-customerportalslider',
			requiredRoles:["developer", "company_manager"]			 
		});

		msNavigationServiceProvider.saveItem('settings.customerportalservicescatogory', {
			title: 'Services Categories',
			requiredRoles:[]
		});

		msNavigationServiceProvider.saveItem('settings.customerportalservicescatogory.view-customerportalservicescatogory', {
			title: 'View Categories',
			state: 'app.settings.customerportalservicescatogory.view-customerportalservicescatogory',
			requiredRoles:["developer", "company_manager"]
		});

		msNavigationServiceProvider.saveItem('settings.customerportalservicescatogory.add-customerportalservicescatogory', {
			title: 'Add Category',
			state: 'app.settings.customerportalservicescatogory.add-customerportalservicescatogory',
			requiredRoles:["developer", "company_manager"]			 
		});

		msNavigationServiceProvider.saveItem('settings.goto', {
			title: 'GoTo',
			state: 'app.settings.goto',
			requiredRoles: ['developer', 'company_manager'],
		});
		
		msNavigationServiceProvider.saveItem('reports', {
			title: 'REPORTS',
			icon: "icon-settings",
			weight: 3,
			requiredRoles: ["developer", "company_manager"]	
		});

		msNavigationServiceProvider.saveItem('reports.service-report', {
			title: 'Service Reports',
			state: "app.servicereports",
			requiredRoles: ["developer", "company_manager"]	
		});
	}

})();
(function ()
{
    'use strict';

    angular
        .module('app.settings')
        .run(InitUserInfo);

    /** @ngInject */
    function InitUserInfo(LoginService)
    {
    }
})();
(function ()
{
    "use strict";

    angular
        .module("app.session", [])
        .factory("SessionFactory", SessionFactory);

    function SessionFactory(SessionConst, LogService, LogConst, Const){
        var factory = {};

        /**
         *  Description: save userInfo obj in session
         *  @param userInfo object  
         */
        factory.setSession = function(userInfo){
            if(userInfo == null || typeof(userInfo) != "object"){               
                window.sessionStorage[SessionConst.sessionName] = null;
                LogService.log(new Error, Const.code.system_error, LogConst.errString.err_param); 
                return;
            }       

            //turn an obj into string and store it into the session
            window.sessionStorage[SessionConst.sessionName] = JSON.stringify(userInfo);               
        }

        /**
         *  Description: get userInfo obj from session
         *  @param userInfo object  
         */
        factory.getSession = function(){
            var session = window.sessionStorage[SessionConst.sessionName];
            if(typeof(session) == "undefined" || session == null){
                return null;
            }
            return JSON.parse(window.sessionStorage[SessionConst.sessionName]);        
        }

        /**
         *  Description: clear userInfo object from session
         */
        factory.clearSession = function(){
            window.sessionStorage.clear();
        }

        return factory;
    }   
})();
(function ()
{
    'use strict';

    angular
        .module('app.session')
        .service('SessionService', SessionService);

    //Description: encapsulation of SessionFactory, provide methods to manage session
    function SessionService(SessionFactory)
    {   
        this.saveUserStatus = function(userInfoObj){
            SessionFactory.setSession(userInfoObj);
        };
        this.getUserStatus = function(){
            return SessionFactory.getSession();
        };
        this.clearUserStatus = function(){
            SessionFactory.clearSession();
        };        
    }
})();
/**
 *  Description: define the constants for session
 */
(function ()
{
    "use strict";

    angular
        .module("app.session")
        .constant("SessionConst", {
        	sessionName : "carDepotUser"
        });    
})();
(function ()
{
	'use strict';

	angular
		.module('app.tasks')
		.service("TasksService", TasksService);

	/** @ngInject */
	function TasksService($state, api, ToolsFactory, Const, $q, MessageService, LoginService, $filter, Task, HeaderHelper, ConstantCacheService)
	{   
		var codeKey = Const.header.code;
		var messageKey = Const.header.message;
		var successCode = Const.code.success;

		this.getAllMatchedTasks = function(resourcePath, filters){
			var taskList = [];
			var _this = this;

			return _this.getTasks(resourcePath, filters, {page: 1, limit: 100})
				.then(function(response){
					if(!response || !Array.isArray(response.data)){
						return $q.reject("Failed to fetch vehicles for report.");
					}

					taskList = taskList.concat(response.data);

					var totalItem = HeaderHelper.getPaginationTotalItem(response.headerGetter);
					var currentPage = HeaderHelper.getPaginationCurrentPage(response.headerGetter);
					var itemsPerPage = HeaderHelper.getPaginationItemsPerPage(response.headerGetter);

					var queue = [];

					if(response.data.length < totalItem){
						var totalPage = Math.ceil(totalItem/itemsPerPage);

						for(var i = 2; i <= totalPage; i++){
							queue.push(_this.getTasks(resourcePath, filters, {page: i, limit: 100}));
						}
					}

					return $q.all(queue);
				})
				.then(function(responseList){
					if(!Array.isArray(responseList)){
						return $q.reject("Failed to fetch vehicles for report.");
					}

					for(var i = 0; i < responseList.length; i++){
						var response = responseList[i];

						if(!response || !Array.isArray(response.data)){
							return $q.reject("Failed to fetch vehicles for report.");
						}

						taskList = taskList.concat(response.data);
					}

					return $q.resolve(taskList);
				});
		}

		this.postRequestBodyGenerator = function(newTask){
			var reqBody = {}; 

			if(newTask == null || Object.keys(newTask).length <= 0){
				return;
			}

			Object.keys(newTask).forEach(function(key){
				var value = newTask[key];

				switch(key){
					case "assigned_to_users":
						reqBody[key] = assignedUserPropertyBuilder(value);
						break;

					case "assigned_to_vehicle":
						reqBody[key] = assignedVehiclePropertyBuilder(value);
						break;

					default:
						reqBody[key] = value;
						break;
				}
			});

			return reqBody;
		}

		this.putRequestBodyGenerator = function(oldTask, newTask){
			var reqBody = {}; 

			if(newTask == null || Object.keys(newTask).length <= 0){
				return reqBody;
			}

			if(oldTask == null){
				oldTask = {};
			}

			Object.keys(newTask).forEach(function(key){
				var oldValue = oldTask[key];
				var newValue = newTask[key];

				switch(key){
					case "assigned_to_users":
/*						if(!Array.isArray(newValue) || !Array.isArray(oldValue)){
							return;
						}*/
						if(isAssignedUserListIdentical(oldValue, newValue) === false){
							reqBody[key] = assignedUserPropertyBuilder(newValue);
						}
						break;

					case "assigned_to_vehicle":
						if(oldValue == null && newValue == null){
							return;
						}
						if(oldValue != null && newValue != null && oldValue.id_vehicle == newValue.id_vehicle){
							return;
						}
						reqBody[key] = assignedVehiclePropertyBuilder(newValue);
						break;

					case "created_by":
						break;

					default :
						if(oldValue != newValue){
							reqBody[key] = newValue;
						}
						break;
				}
			});

			return reqBody;
		}

		function assignedUserPropertyBuilder(userList){
			if(!Array.isArray(userList)){
				return;
			}

			return userList.map(function(user){
				return {id_user: user.id_user};
			});
		}

		function assignedVehiclePropertyBuilder(vehicle){
			if(vehicle == null){
				return null;
			}

			return {id_vehicle: vehicle.id_vehicle};
		}

		function isAssignedUserListIdentical(userList_1, userList_2){
			if(!Array.isArray(userList_1)){
				userList_1 = [];
			}

			if(!Array.isArray(userList_2)){
				userList_2 = [];
			}

			if(userList_1.length != userList_2.length){
				return false;
			}

			var userMap = new Map();

			userList_1.forEach(function(user){
				userMap.set(user.id_user, null);
			});

			return userList_2.every(function(user){
				return userMap.has(user.id_user);
			})
		}

		this.updateTask = function(changeProperties, resourcePath){
			var defer = $q.defer();

			api.tasks.updateTask(
				resourcePath,
				changeProperties,
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);
						defer.reject(errorMessage);
						return;
					}

					defer.resolve(response);
				},
				function(error){
					var errorMessage = error.status + ': ' + error.statusText;
					defer.reject(errorMessage);
				}
			);

			return defer.promise;
		}

		this.getTasks = function(resourcePath, filters, pagination, sorting){			
			var defer = $q.defer();
			var queryParams = Object.assign({}, resourcePath, filters, pagination, sorting);

			api.tasks.getTasks(
				queryParams,
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);
						defer.reject(errorMessage);
						return;
					}

					var taskList = [];

					response.forEach(function(data){
						var task = new Task();

						task.setAttributes(data);
						taskList.push(task);
					})

					var result = {
						data: taskList,
						headerGetter: header
					}

					defer.resolve(result);
				},
				function(error){
					console.error("Failed to get tasks.");
					defer.reject(error);
				}
			);

			return defer.promise;
		}

		this.getTaskCategories = function(){			
			var defer = $q.defer();

			api.getConstants.getTaskCategories.get(
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);
						defer.reject(errorMessage);
						return;
					}

					defer.resolve(response);
				},
				function(error){
					defer.reject(error);
				}
			);

			return defer.promise;
		}

		this.getCachedTaskCategories = function () {
			return ConstantCacheService.get('task_categories', function () {
				return this.getTaskCategories();
			}.bind(this));
		}
		
		this.getTaskPriorities = function(){			
			var defer = $q.defer();

			api.getConstants.getTaskPriorities.get(
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);
						defer.reject(errorMessage);
						return;
					}

					defer.resolve(response);
				},
				function(error){
					defer.reject(error);
				}
			);

			return defer.promise;
		}

		this.getCachedTaskPriorities = function () {
			return ConstantCacheService.get('task_priorities', function () {
				return this.getTaskPriorities();
			}.bind(this));
		}

		this.getTaskStatus = function(){			
			var defer = $q.defer();

			api.getConstants.getTaskStatus.get(
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);
						defer.reject(errorMessage);
						return;
					}

					defer.resolve(response);
				},
				function(error){
					defer.reject(error);
				}
			);

			return defer.promise;
		}

		this.getCachedTaskStatus = function () {
			return ConstantCacheService.get('task_status', function () {
				return this.getTaskStatus();
			}.bind(this));
		}

		this.createTask = function(resourcePath, requestBody){
			var defer = $q.defer();

			api.tasks.createTask(
				resourcePath,
				requestBody,
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);
						defer.reject(errorMessage);
						return;
					}

					defer.resolve(response.data);
				},
				function(error){
					defer.reject(error);
				}
			);

			return defer.promise;
		}

		this.deleteTask = function(resourcePath){
			var defer = $q.defer();

			api.tasks.deleteTask(
				resourcePath,
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);
						defer.reject(errorMessage);
						return;
					}

					defer.resolve(response);
				},
				function(error){
					var errorMessage = error.status + ': ' + error.statusText;
					defer.reject(errorMessage);
				}
			);

			return defer.promise;
		}

		this.getTaskFiles = function(resourcePath){
			var defer = $q.defer();

			api.taskFiles.getFiles(
				resourcePath,
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);

						defer.reject(errorMessage);
						return;
					}

					
					defer.resolve(response);
				},
				function(error){
					defer.reject(error);
				}
			);	

			return defer.promise;		
		}

		this.deleteTaskFile = function(resourcePath){
			var defer = $q.defer();
			api.taskFiles.deleteFile(
				resourcePath,
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);
						defer.reject(errorMessage);
						return;
					}
					console.log("file is deleted", response)
					defer.resolve(response);
				},
				function(error){
					defer.reject(error);
				}
			);

			return defer.promise;
		}
	}
})();
(function ()
{
	"use strict";

	angular
		.module("app.tasks")
		.component("taskInfoForm", {
				bindings:{
					task:'=',
					constants:'<',
					isFormValid:'='
				},
				templateUrl: "app/main/tasks/task-info-form.html",
				controller: componentController,
		  		controllerAs: 'vm'
			});

		function componentController(TaskConstants, $state, $scope, $filter, UserService, LoginService, VehicleService, Task, MessageService, VehicleConstants, $q, GeneralTools){
			var vm = this;
			var otherTaskCatagoryID = 6;

			vm.$onInit = initComponent;
			vm.$postLink = initOutPutCallbacks;

			vm.translateToDollar = GeneralTools.inputTranslators.dollar;

			vm.onUserSelected = onUserSelected;
			vm.onVehicleSelected = onVehicleSelected;
			vm.removeAssignVehicle = removeAssignVehicle;
			vm.removeAssignUser = removeAssignUser;
			vm.queryUsers = queryUsers;
			vm.queryVehicles = queryVehicles;
			vm.getUrlForVehiclePage = getUrlForVehiclePage;

			vm.setDueDate = setDueDate;
			vm.setDueTime = setDueTime;

			vm.getAssignedVehicleName = getAssignedVehicleName;

			vm.timePickerFormat = "LT";

			function initComponent(){
				if(vm.task == null){
					vm.task = new Task();
				}

				if(vm.constants == null){
					console.error("Task constants is missing");
					return;
				}

				if(vm.task.fk_id_task_status == null && Array.isArray(vm.constants.taskStatus)){
					vm.task.fk_id_task_status = vm.constants.taskStatus[0].id_task_status;
				}

				if(vm.task.fk_id_task_priority == null && Array.isArray(vm.constants.taskPriorities)){
					vm.task.fk_id_task_priority = vm.constants.taskPriorities[vm.constants.taskPriorities.length -1].id_task_priority;
				}

				if(vm.task.fk_id_task_category == null && Array.isArray(vm.constants.taskCategories)){
					vm.task.fk_id_task_category = otherTaskCatagoryID;
				}

				vm.taskNameInputOptions = {
					icon: "icon-note-multiple-outline",
					placeholder: "Task Name",
					required:true
				};

				vm.taskCostInputOptions = {
					icon: "icon-note-multiple-outline",
					placeholder: "Cost",
					invalidPatternMessage:"Only number and charactors allowed!",
					inputPattern: new RegExp('^[0-9]*$')
				};

				vm.commentsInputOptions = {
					icon: "icon-note-multiple-outline",
					placeholder: "Comments"
				};	

				vm.dateTimeValidator = {}

				vm.datePickerValue = vm.task.getDueDateMomentObj();
				vm.timePickerValue = vm.task.getDueTimeMomentObj();

				if(!Array.isArray(vm.task.assigned_to_users)){
					vm.task.assigned_to_users = [];
				}
			}

			function onUserSelected (selectedUser){
				vm.searchTextForUser = null;
				if(selectedUser == null){
					return;
				}

				if(!vm.task.addAssignedUser(selectedUser)){
					MessageService.showToast("User already assgined!");
				}
			}

			function onVehicleSelected (selectedVehicle){
				vm.searchTextForVehicle = null;
				if(selectedVehicle == null){
					return;
				}

				if(!vm.task.setAssignedVehicle(selectedVehicle)){
					MessageService.showToast("Failed to assgined vehicle!");
				}
			}

			function queryUsers (searchText){
				var resourcePath = {companyID: LoginService.getCompanyID()};

				return UserService.getUsers(resourcePath, searchText);
			}

			function queryVehicles (searchText){
				var resourcePath = {companyID: LoginService.getCompanyID()};

				var filters = { filters: VehicleService.searchTextFilterBuilder(searchText)};

				return VehicleService.getVehicle(resourcePath, filters, null, null)
					.then(function(result){
						if(result == null || !Array.isArray(result.data)){
							return $q.reject();
						}

						return $q.resolve(result.data);
					})
					.catch(function(error){
						return $q.reject();
					});
			}

			function removeAssignVehicle(){
				vm.task.removeAssignVehicle();
			};

			function removeAssignUser(userID){
				vm.task.removeAssignUser(userID);
				//validateAssignedUsers();
			};

			function initOutPutCallbacks(){
				vm.isFormValid = function(){
					validateDueDate();
					//validateAssignedUsers();

					$scope.taskInfoForm.$submitted = true;
					return $scope.taskInfoForm.$valid;
				};
			}

			function validateAssignedUsers(){
				if(vm.task.assigned_to_users == null || vm.task.assigned_to_users.length <= 0){
					vm.assignedUsersValidator = {isError: true};
					$scope.taskInfoForm.$valid = false;
				}else{
					vm.assignedUsersValidator = null;
				}
			}

			function setDueDate (dateObject){
				vm.task.setDueDate(moment(dateObject));
				validateDueDate()
			}

			function setDueTime (timePickerValue){
				var momentObject;

				switch (timePickerValue.constructor.name){
					case "M":
						momentObject = timePickerValue
						break;
					case "Moment":
						momentObject = timePickerValue
						break;
					case "String":
						momentObject = moment(timePickerValue, vm.timePickerFormat);
						break;
				}

				vm.task.setDueTime(momentObject);
				validateDueDate()
			}

			function validateDueDate(){
				var dueTime = vm.task.getDueTimeMomentObj();
				var dueDate = vm.task.getDueDateMomentObj();

				if(dueDate != null && !dueDate.isValid()){
					vm.dateTimeValidator.inValidDueDate = true;
					$scope.taskInfoForm.$valid = false;
				}else{
					vm.dateTimeValidator.inValidDueDate = null;
				}

				if(dueTime != null && !dueTime.isValid()){
					vm.dateTimeValidator.inValidDueTime = true;
					$scope.taskInfoForm.$valid = false;
				}else{
					vm.dateTimeValidator.inValidDueTime = null;
				}

				if(dueTime != null && dueDate == null){
					vm.dateTimeValidator.inValidDueDateMissing = true;
					$scope.taskInfoForm.$valid = false;
				}else{
					vm.dateTimeValidator.inValidDueDateMissing = null;
				}
			}

			function getUrlForVehiclePage(vehicle){
				return $state.href('app.vehicle.tasks', {vehicleID: vehicle.id_vehicle}); 
			}

			function getAssignedVehicleName(task){
				if(task == null || task.assigned_to_vehicle == null){
					return;
				}

				var vehicleName = '';

				vehicleName = GeneralTools.stringConnector(vehicleName, task.assigned_to_vehicle.year, ' ');
				vehicleName = GeneralTools.stringConnector(vehicleName, task.assigned_to_vehicle.make, ' ');
				vehicleName = GeneralTools.stringConnector(vehicleName, task.assigned_to_vehicle.model, ' ');

				if(vehicleName.trim() == ''){
					return "N/A";
				}

				return vehicleName;
			}
		}
})();
(function ()
{
	'use strict';

	angular
		.module("app.tasks")
		.factory("Task", TaskClass)

	/** @ngInject */
	function TaskClass($filter, TaskConstants)
	{	 
		function Task(){}

		Task.prototype.setAttributes = function (attributes) {
	 		if(attributes == null){
	 			return;
	 		}

	 		var keyList = Object.keys(attributes);

	 		for(var i = 0; i < keyList.length; i++){
	 			var key = keyList[i];
	 			var value = attributes[key];

	 			this.setAttribute(key, value);
	 		}
		}

		Task.prototype.setAttribute = function (key, value) {
	 		this[key] = value;
		}

		Task.prototype.getResourceId = function () {
	 		return this.id_task;
		}	

		Task.prototype.getResourcePath = function () {
			var resourcePath = {};
			resourcePath.taskID = this.id_task
			resourcePath.companyID = this.fk_id_company
	 		return resourcePath;
		}	

		Task.prototype.addAssignedUser = function(userToBeAdded){
			var isSuccess = false;

			if(userToBeAdded == null){
				return isSuccess;
			}

			if(this.assigned_to_users == null){
				this.assigned_to_users = [];
			}

			var duplicatedUser = this.assigned_to_users.find(function(user){
				return user.id_user == userToBeAdded.getResourceID();
			});

			if(duplicatedUser != null){
				return isSuccess;
			}

			this.assigned_to_users.push({
				id_user: userToBeAdded.getResourceID(),
				first_name: userToBeAdded.first_name,
				last_name: userToBeAdded.last_name
			});

			isSuccess = true;
			
			return isSuccess;
		}

		Task.prototype.setAssignedVehicle = function(vehicleToBeSet){
			var isSuccess = false;

			if(vehicleToBeSet == null){
				return isSuccess;
			}

			this.assigned_to_vehicle = {
				id_vehicle: vehicleToBeSet.getResourceID(),
				vin: vehicleToBeSet.vin,
				year: vehicleToBeSet.year,
				make: vehicleToBeSet.make,
				model: vehicleToBeSet.model
			};
			
			isSuccess = true;

			return isSuccess
		}

		Task.prototype.removeAssignVehicle = function (){
			this.assigned_to_vehicle = null;
		}

		Task.prototype.removeAssignUser = function (userID){
			if(this.assigned_to_users == null){
				return;
			}

			var index = this.assigned_to_users.findIndex(function(user){
				return user.id_user == userID
			});

			this.assigned_to_users.splice(index, 1);
		}	

		Task.prototype.setDueDate = function (momentObj){
			if(momentObj != null && momentObj.isValid()){
				this.due_date = momentObj.format(TaskConstants.dueDateFormat);
				return true;
			}
			this.due_date = null;
			return false;
		}	

		Task.prototype.getDueDateMomentObj = function (){
			if(this.due_date != null){
				return moment(this.due_date, TaskConstants.dueDateFormat);
			}
		}	

		Task.prototype.setDueTime = function (momentObj){
			if(momentObj != null && momentObj.isValid()){
				this.due_time = momentObj.format(TaskConstants.dueTimeFormat);
				return true;
			}

			this.due_time = null;

			return false;
		}	

		Task.prototype.getDueTimeMomentObj = function(){
			if(this.due_time != null){
				return moment(this.due_time, TaskConstants.dueTimeFormat);
			}
		}

		Task.prototype.getCreatedDateMomentObj = function (){
			if(this.created_date != null){
				return moment(this.created_date);
			}
		}

		return Task;
	}


})();
(function ()
{
    'use strict';

    angular
        .module('app.sample', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider
            .state('app.sample', {
                url    : '/sample',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/sample/sample.html',
                        controller : 'SampleController as vm'
                    }
                },
                resolve: {
                    SampleData: function (msApi)
                    {
                        return msApi.resolve('sample@get');
                    }
                }
            });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/sample');

        // Api
        msApiProvider.register('sample', ['app/data/sample/sample.json']);

        // Navigation
        msNavigationServiceProvider.saveItem('fuse', {
            title : 'SAMPLE',
            group : true,
            weight: 1
        });

        msNavigationServiceProvider.saveItem('fuse.sample', {
            title    : 'Sample',
            icon     : 'icon-tile-four',
            state    : 'app.sample',
            /*stateParams: {
                'param1': 'page'
             },*/
            translate: 'SAMPLE.SAMPLE_NAV',
            weight   : 1
        });
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.sample')
        .controller('SampleController', SampleController);

    /** @ngInject */
    function SampleController(SampleData)
    {
        var vm = this;

        // Data
        vm.helloText = SampleData.data.helloText;

        // Methods

        //////////
    }
})();

(function ()
{
	"use strict";

	angular
		.module("app.roleCheck", [])
		.service("RoleCheckService", RoleCheckService);

	function RoleCheckService(LoginService, Const)
	{	
		const userRoles = LoginService.getUserRoles();
		const userStatus = LoginService.getUserStatus();
		const userSubRoles = LoginService.getUserSubRoles();

		this.getAssignableRoleTitles = function () {
			var titles = Array.isArray(userSubRoles) ? userSubRoles.slice() : [];

			if (this.deepCheckRole(["developer", "company_manager"])) {
				(Const.assignablePermissionRoles || []).forEach(function (roleTitle) {
					if (titles.indexOf(roleTitle) === -1) {
						titles.push(roleTitle);
					}
				});
			}

			return titles;
		};

		this.getRoleDisplayName = function (roleTitle) {
			if (Const.roleDisplayName && Const.roleDisplayName[roleTitle]) {
				return Const.roleDisplayName[roleTitle];
			}

			return roleTitle;
		};


		this.checkRole = function(requiredRoleList){
			if(requiredRoleList == null || requiredRoleList.length <=0){
				return true;
			}

			for(var i = 0; i < requiredRoleList.length; i++){
				var requiredRole = requiredRoleList[i];
				if( userRoles != null && userRoles.indexOf(requiredRole) != -1){
					return true
				}
			}

			return false
		}

		this.deepCheckRole = function(requiredRoleList){
			if(requiredRoleList == null || requiredRoleList.length <=0){
				return true;
			}

			for(var i = 0; i < requiredRoleList.length; i++){
				var requiredRole = requiredRoleList[i];

				if(Array.isArray(userRoles) && userRoles.indexOf(requiredRole) != -1){
					return true
				}

				if(Array.isArray(userSubRoles) && userSubRoles.indexOf(requiredRole) != -1){
					return true
				}
			}

			return false
		}

		this.isLogin = function(){
			return !!userStatus && userStatus.isLogin;
		}
	}   
})();
(function ()
{
	'use strict';

	angular
		.module('app.saleInfo')
		.service("SaleInfoService", SaleInfoService);

	/** @ngInject */
	function SaleInfoService(PresetPromotion, GeneralTools, $resource, SalePackage, $state, api, ToolsFactory, Const, $q, MessageService, LoginService, SalePromotion, SaleInfo, TradeInVehicle, SalePlateOption, SalePresetExtras, Warranty, SaleExtras, SaleInfoPayment, MyFile, SaleWarranty, Disclosure, SaleInfoSignature, ConstantCacheService)
	{   
		var codeKey = Const.header.code;
		var messageKey = Const.header.message;
		var successCode = Const.code.success;

		const baseUrl = GeneralTools.getBaseUrl();
		const errMsgFailedToFetchPackage = "Failed to fetch sale packages";
		const errMsgFailedToFetchNewPackageID = "Failed to fetch new sale package ID";
		const baseHeader = GeneralTools.getBaseHeader();
		const noCacheHeader = GeneralTools.getNoCacheHeader();

		const salePackagesApi = $resource(
			baseUrl + "companies/:companyID/vehicles/:vehicleID/saleinfos/:saleinfoID/packages/:packageID",
			{	
				companyID: "@companyID",
				vehicleID: "@vehicleID",
				saleinfoID: "@saleinfoID",
				packageID: "@packageID"
			},
			{	
				getPackages:{
					method:"GET",
					isArray:true,
					headers: noCacheHeader,
					cancellable: true,
					interceptor:{
						response: function(result){
							const statusCode  = result.headers(Const.header.code);

							if(statusCode != Const.code.success){
								console.error(statusCode, result.headers(Const.header.message));
								return $q.reject(errMsgFailedToFetchPackage);
							}

							return result.data.map(function(data){
								var salePackage = new SalePackage();

								salePackage.setAttributes(data);
								return salePackage;
							});
						},
						responseError: function (error){
							if(error && error.xhrStatus == Const.xhrStatus.abort){
								return $q.reject();
							}
							console.error(error);
							return $q.reject(error);
						}
					}
				},	
				postPackage:{
					method:"POST",
					headers: baseHeader,
					interceptor:{
						response: function(result){
							const statusCode  = result.headers(Const.header.code);

							if(statusCode != Const.code.success){
								console.error(statusCode, result.headers(Const.header.message));
								return $q.reject(errMsgFailedToFetchPackage);
							}

							if(!result.data){
								console.error(errMsgFailedToFetchNewPackageID);
								return $q.reject(errMsgFailedToFetchNewPackageID);
							}

							return result.data.data;
						},
						responseError: function (error){
							if(error && error.xhrStatus == Const.xhrStatus.abort){
								return $q.reject();
							}
							console.error(error);
							return $q.reject(error);
						}
					}
				},
				deletePackage:{
					method:"DELETE",
					headers: baseHeader,
					interceptor:{
						response: function(result){
							const statusCode  = result.headers(Const.header.code);

							if(result.headers(Const.header.code) != Const.code.success){
								console.error(statusCode, result.headers(Const.header.message));
								return $q.reject(errMsgFailedToFetchPackage);
							}

							return $q.resolve();
						},
						responseError: function (error){
							if(error && error.xhrStatus == Const.xhrStatus.abort){
								return $q.reject();
							}
							console.error(error);
							return $q.reject(error);
						}
					}
				}								
		});

		const salePackageItemsApi = $resource(
			baseUrl + "companies/:companyID/vehicles/:vehicleID/saleinfos/:saleinfoID/packages/:packageID/packageitems/:packageitemID",
			{	
				companyID: "@companyID",
				vehicleID: "@vehicleID",
				saleinfoID: "@saleinfoID",
				packageID: "@packageID",
				packageitemID: "@packageitemID"
			},
			{	
				getItems:{
					method:"GET",
					isArray:true,
					headers: noCacheHeader,
					cancellable: true,
					interceptor:{
						response: function(result){
							const statusCode  = result.headers(Const.header.code);

							if(statusCode != Const.code.success){
								console.error(statusCode, result.headers(Const.header.message));
								return $q.reject(errMsgFailedToFetchPackage);
							}
							
							return result.data;
						},
						responseError: function (error){
							if(error && error.xhrStatus == Const.xhrStatus.abort){
								return $q.reject();
							}
							console.error(error);
							return $q.reject(error);
						}
					}
				}								
		});
		const redeemSalePackageItemApi = $resource(
			baseUrl + "companies/:companyID/vehicles/:vehicleID/saleinfos/:saleinfoID/packages/:packageID/packageitems/:packageitemID/redeem",
			{	
				companyID: "@companyID",
				vehicleID: "@vehicleID",
				saleinfoID: "@saleinfoID",
				packageID: "@packageID",
				packageitemID: "@packageitemID"
			},
			{	
				redeem:{
					method:"PUT",
					headers: baseHeader,
					interceptor:{
						response: function(result){
							const statusCode  = result.headers(Const.header.code);

							if(result.headers(Const.header.code) != Const.code.success){
								console.error(statusCode, result.headers(Const.header.message));
								return $q.reject(errMsgFailedToFetchPackage);
							}

							return $q.resolve();
						},
						responseError: function (error){
							if(error && error.xhrStatus == Const.xhrStatus.abort){
								return $q.reject();
							}
							console.error(error);
							return $q.reject(error);
						}
					}
				}								
		});

		this.updateSaleWarrantyRequestBodyGenerator = function(currentSaleWarranty, originSaleWarranty){
			if(currentSaleWarranty == null || originSaleWarranty == null){
				return;
			}

			var keyList = Object.keys(currentSaleWarranty);
			var changedProperties = {};

			keyList.forEach(function(key){
				var currentValue = currentSaleWarranty[key];
				var originValue = originSaleWarranty[key];

				if(currentValue == originValue){
					return;
				}

				changedProperties[key] = currentValue;
			});

			return changedProperties;
		}

		this.updateTradeInVehicleRequestBodyGenerator = function(currentTradeInVehicle, originTradeInVehicle){
			if(currentTradeInVehicle == null || originTradeInVehicle == null){
				return;
			}

			var keyList = Object.keys(currentTradeInVehicle);
			var changedProperties = {};

			keyList.forEach(function(key){
				var currentValue = currentTradeInVehicle[key];
				var originValue = originTradeInVehicle[key];

				if(currentValue == originValue){
					return;
				}

				changedProperties[key] = currentValue;
			});

			return changedProperties;
		}

		this.updateSaleInfoRequestBodyGenerator = function(currentSaleInfo, originSaleInfo){
			if(currentSaleInfo == null || originSaleInfo == null){
				return;
			}

			var keyList = Object.keys(currentSaleInfo);
			var changedProperties = {};

			keyList.forEach(function(key){
				var currentValue = currentSaleInfo[key];
				var originValue = originSaleInfo[key];

				if(currentValue == originValue){
					return;
				}

				changedProperties[key] = currentValue;
			});

			return changedProperties;
		}

		this.deletePaymentFiles = function(resourcePath){
			var defer = $q.defer();

			api.paymentFiles.deletePaymentFiles(
				resourcePath,
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);
						defer.reject(errorMessage);
						return;
					}

					defer.resolve(response);
				},
				function(error){
					console.error(error);
					defer.reject("Failed to delete payment file");
				}
			);

			return defer.promise;
		}

		this.deleteSalePayment = function(resourcePath){
			var defer = $q.defer();

			api.salePayment.deleteSalePayment(
				resourcePath,
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);
						defer.reject(errorMessage);
						return;
					}

					defer.resolve(response);
				},
				function(error){
					console.error(error);
					defer.reject("Failed to delete payment");
				}
			);

			return defer.promise;
		}

		this.getPaymentFiles = function(resourcePath){
			var defer = $q.defer();

			api.paymentFiles.getPaymentFiles(
				resourcePath,
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);

						defer.reject(errorMessage);
						return;
					}

					if(!Array.isArray(response)){
						defer.reject("Payment file list is not an array.");
						return;
					}

					var fileList = [];

					response.forEach(function(fileData){
						if(fileData == null){
							return;
						}

						var file = new MyFile();
						file.setAttributes(fileData);

						fileList.push(file);
					});

					defer.resolve(fileList);

				},
				function(error){
					console.error(error)
					defer.reject("Failed to get sale payment files");
				}
			);	

			return defer.promise;			
		}	

		this.getSalePayments = function(resourcePath){
			var defer = $q.defer();

			api.salePayment.getSalePayments(
				resourcePath,
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);

						defer.reject(errorMessage);
						return;
					}

					if(!Array.isArray(response)){
						defer.reject("Payment data is not an array");
						return;
					}

					var paymentList = [];

					response.forEach(function(paymentData){
						if(paymentData == null){
							return;
						}

						var payment = new SaleInfoPayment();
						payment.setAttributes(paymentData);

						paymentList.push(payment);
					});

					defer.resolve(paymentList);

				},
				function(error){
					console.error(error)
					defer.reject("Failed to get sale payments");
				}
			);	

			return defer.promise;			
		}	

		this.getSalePromotions = function(resourcePath){
			var defer = $q.defer();

			api.salePromotions.getSalePromotion(
				resourcePath,
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);

						defer.reject(errorMessage);
						return;
					}

					if(!Array.isArray(response)){
						defer.reject("Promotion data is not an array");
						return;
					}

					var promotionList = [];

					response.forEach(function(promotionData){
						if(promotionData == null){
							return;
						}

						var promotion = new SalePromotion();
						promotion.setAttributes(promotionData);

						promotionList.push(promotion);
					});

					defer.resolve(promotionList);

				},
				function(error){
					console.error(error)
					defer.reject("Failed to get sale promotions");
				}
			);	

			return defer.promise;			
		}	

		this.getPromotions = function(resourcePath){
			var defer = $q.defer();

			api.promotions.getPromotion(
				resourcePath,
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);

						defer.reject(errorMessage);
						return;
					}

					if(!Array.isArray(response)){
						defer.reject("Promotion data is not an array");
						return;
					}

					var promotionList = [];

					response.forEach(function(promotionData){
						if(promotionData == null){
							return;
						}

						var promotion = new PresetPromotion();
						promotion.setAttributes(promotionData);

						promotionList.push(promotion);
					});

					defer.resolve(promotionList);

				},
				function(error){
					console.error(error)
					defer.reject("Failed to get promotion options");
				}
			);	

			return defer.promise;			
		}	

		this.getSaleCustomExtras = function(resourcePath){
			var defer = $q.defer();

			api.saleCustomExtras.getCustomExtras(
				resourcePath,
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);

						defer.reject(errorMessage);
						return;
					}

					if(!Array.isArray(response)){
						defer.reject("Sale custom extras is not an array");
						return;
					}

					var customExtrasList = [];

					response.forEach(function(customExtraData){
						if(customExtraData == null){
							return;
						}

						var customExtra = new SaleExtras();
						customExtra.setAttributes(customExtraData);

						customExtrasList.push(customExtra);
					});

					defer.resolve(customExtrasList);

				},
				function(error){
					console.error(error)
					defer.reject("Failed to get plate options");
				}
			);	

			return defer.promise;			
		}		
		
		this.getPlateOptions = function(resourcePath){
			var defer = $q.defer();

			api.plateOptions.getPlateOptions(
				resourcePath,
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);

						defer.reject(errorMessage);
						return;
					}

					if(!Array.isArray(response)){
						defer.reject("Plate option is not an array");
						return;
					}

					var plateOptionList = [];

					response.forEach(function(plateOptionData){
						if(plateOptionData == null){
							return;
						}

						var plateOption = new SalePlateOption();
						plateOption.setAttributes(plateOptionData);

						plateOptionList.push(plateOption);
					});

					defer.resolve(plateOptionList);

				},
				function(error){
					console.error(error)
					defer.reject("Failed to get plate options");
				}
			);	

			return defer.promise;			
		}

		this.getCachedPlateOptions = function (resourcePath) {
			var cacheKey = getPlateOptionsCacheKey(resourcePath);

			return ConstantCacheService.get(cacheKey, function () {
				return this.getPlateOptions(resourcePath);
			}.bind(this)).then(function (result) {
				return buildSalePlateOptionList(result);
			});
		}

		function getPlateOptionsCacheKey(resourcePath) {
			if (resourcePath && resourcePath.companyID) {
				return 'plate_options_company_' + resourcePath.companyID;
			}

			return 'plate_options';
		}

		function buildSalePlateOptionList(dataList) {
			if (!Array.isArray(dataList)) {
				return [];
			}

			var plateOptionList = [];

			dataList.forEach(function (data) {
				if (!data) {
					return;
				}

				if (typeof data.setAttributes === 'function') {
					plateOptionList.push(data);
					return;
				}

				var plateOption = new SalePlateOption();
				plateOption.setAttributes(data);
				plateOptionList.push(plateOption);
			});

			return plateOptionList;
		}

		this.getWarrantyOptions = function(resourcePath){
			var defer = $q.defer();

			api.warranties.getWrranties(
				resourcePath,
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);

						defer.reject(errorMessage);
						return;
					}

					if(!Array.isArray(response)){
						defer.reject("Warranty option is not an array");
						return;
					}

					var warrantyList = [];

					response.forEach(function(warrantyData){
						if(warrantyData == null){
							return;
						}

						var warranty = new Warranty();
						warranty.setAttributes(warrantyData);

						warrantyList.push(warranty);
					});

					defer.resolve(warrantyList);

				},
				function(error){
					console.error(error);
					defer.reject("Failed to get Warranties options");
				}
			);	

			return defer.promise;			
		}

		this.getPaymentOptions = function(){
			var defer = $q.defer();

			api.getConstants.getPaymentOptions.get(
				{},
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);

						defer.reject(errorMessage);
						return;
					}
					defer.resolve(response);

				},
				function(error){
					console.error(error);
					defer.reject("Failed to get payment options");
				}
			);	

			return defer.promise;			
		}

		this.getCachedPaymentOptions = function () {
			return ConstantCacheService.get('payment_options', function () {
				return this.getPaymentOptions();
			}.bind(this));
		}

		this.createVehicleSaleInfo = function(resourcePath, requestBody){
			var defer = $q.defer();

			api.vehicleSaleInfos.createVehicleSaleInfo(
				resourcePath,
				requestBody,
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);

						defer.reject(errorMessage);
						return;
					}
					defer.resolve(response.data);

				},
				function(error){
					console.error(error);
					defer.reject("Failed to create sale info");
				}
			);	

			return defer.promise;			
		}

		this.updateVehicleSaleInfo = function(resourcePath, requestBody){
			var defer = $q.defer();

			api.vehicleSaleInfos.updateVehicleSaleInfo(
				resourcePath,
				requestBody,
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);

						defer.reject(errorMessage);
						return;
					}
					defer.resolve(response);

				},
				function(error){
					console.error(error);
					defer.reject("Failed to update sale info.");
				}
			);	

			return defer.promise;			
		}		

		this.deleteVehicleSaleInfo = function(resourcePath){
			var defer = $q.defer();

			api.vehicleSaleInfos.deleteVehicleSaleInfo(
				resourcePath,
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);
						defer.reject(errorMessage);
						return;
					}

					defer.resolve(response);
				},
				function(error){
					console.error(error);
					defer.reject("Failed to delete sale info.");
				}
			);

			return defer.promise;
		}

		this.createTradeInVehicle = function(resourcePath, requestBody){
			var defer = $q.defer();

			api.tradeInVehicles.createTradeInVehicle(
				resourcePath,
				requestBody,
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);

						defer.reject(errorMessage);
						return;
					}
					defer.resolve(response.data);

				},
				function(error){
					console.error(error);
					defer.reject("Failed to create trade in vehicle");
				}
			);	

			return defer.promise;			
		}	

		this.updateTradeInVehicle = function(resourcePath, requestBody){
			var defer = $q.defer();

			api.tradeInVehicles.updateTradeInVehicle(
				resourcePath,
				requestBody,
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);

						defer.reject(errorMessage);
						return;
					}
					defer.resolve(response);

				},
				function(error){
					console.error(error);
					defer.reject("Failed to update sale info.");
				}
			);	

			return defer.promise;			
		}				

		this.deleteTradeInVehicle = function(resourcePath){
			var defer = $q.defer();

			api.tradeInVehicles.deleteTradeInVehicle(
				resourcePath,
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);

						defer.reject(errorMessage);
						return;
					}
					defer.resolve(response);

				},
				function(error){
					console.error(error);
					defer.reject("Failed to delete trade in vehicle.");
				}
			);	

			return defer.promise;			
		}	

		this.getPresetExtrasOptions = function(resourcePath){
			var defer = $q.defer();

			api.presetExtras.getPresetExtras(
				resourcePath,
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);

						defer.reject(errorMessage);
						return;
					}

					if(!Array.isArray(response)){
						defer.reject("Preset extras option is not an array");
						return;
					}

					var presetExtrasList = [];

					response.forEach(function(presetExtraData){
						if(presetExtraData == null){
							return;
						}

						var presetExtra = new SalePresetExtras();
						presetExtra.setAttributes(presetExtraData);

						presetExtrasList.push(presetExtra);
					});

					defer.resolve(presetExtrasList);

				},
				function(error){
					console.error(error);
					defer.reject("Failed to get preset extras options");
				}
			);	

			return defer.promise;			
		}

		this.getSaleExtras = function(resourcePath){
			var defer = $q.defer();

			api.saleExtras.getExtras(
				resourcePath,
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);

						defer.reject(errorMessage);
						return;
					}

					var saleExtraList = [];

					response.forEach(function(resourceData){
						var saleExtras = new SaleExtras();
						saleExtras.setAttributes(resourceData);

						saleExtraList.push(saleExtras);
					})
					defer.resolve(saleExtraList);

				},
				function(error){
					console.error(error);
					defer.reject("Failed to get sale infos");
				}
			);	

			return defer.promise;			
		}

		this.createSaleExtras = function(resourcePath, requestBody){
			var defer = $q.defer();

			api.saleExtras.createExtra(
				resourcePath,
				requestBody,
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);

						defer.reject(errorMessage);
						return;
					}
					defer.resolve(response.data);

				},
				function(error){
					console.error(error);
					defer.reject("Failed to create sale extra");
				}
			);	

			return defer.promise;			
		}

		this.deleteExtras = function(resourcePath){
			var defer = $q.defer();

			api.saleExtras.deleteExtra(
				resourcePath,
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);

						defer.reject(errorMessage);
						return;
					}
					defer.resolve(response);

				},
				function(error){
					console.error(error);
					defer.reject("Failed to delete extra");
				}
			);	

			return defer.promise;			
		}

		this.redeemPromotionCode = function(resourcePath, promtionCode){
			var defer = $q.defer();

			resourcePath.code = promtionCode;

			api.redeemPromotionCode.redeemCode(
				resourcePath,
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);

						defer.reject(errorMessage);
						return;
					}

					var promotion = new SalePromotion();
					promotion.setAttributes(response);

					if(promotion.getResourceID() == null){
						defer.resolve();
					} else {
						defer.resolve(promotion);
					}
				},
				function(error){
					console.error(error);
					defer.reject("Failed to redeem promotion code");
				}
			);	

			return defer.promise;			
		}

		this.getPaymentMethods = function(){
			var defer = $q.defer();

			api.getConstants.getPaymentMethods.get(
				{},
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);

						defer.reject(errorMessage);
						return;
					}
					defer.resolve(response);

				},
				function(error){
					console.error(error);
					defer.reject("Failed to get payment methods");
				}
			);	

			return defer.promise;			
		}

		this.getCachedPaymentMethods = function () {
			return ConstantCacheService.get('payment_methods', function () {
				return this.getPaymentMethods();
			}.bind(this));
		}

		this.createSalePayment = function(resourcePath, requestBody){
			var defer = $q.defer();

			api.salePayment.createSalePayment(
				resourcePath,
				requestBody,
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);

						defer.reject(errorMessage);
						return;
					}
					defer.resolve(response.data);

				},
				function(error){
					console.error(error);
					defer.reject("Failed to create sale payment");
				}
			);	

			return defer.promise;			
		}

		this.createSalePromotion = function(resourcePath, requestBody){
			var defer = $q.defer();

			api.salePromotions.createSalePromotion(
				resourcePath,
				requestBody,
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);

						defer.reject(errorMessage);
						return;
					}
					defer.resolve(response);

				},
				function(error){
					console.error(error);
					defer.reject("Failed to create sale promotion");
				}
			);	

			return defer.promise;			
		}	

		this.deleteSalePromotion = function(resourcePath){
			var defer = $q.defer();

			api.salePromotions.deleteSalePromotion(
				resourcePath,
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);

						defer.reject(errorMessage);
						return;
					}
					defer.resolve(response);

				},
				function(error){
					console.error(error);
					defer.reject("Failed to delete promotion.");
				}
			);	

			return defer.promise;			
		}

		this.getSaleInfos = function(resourcePath, filters, pagination, sorting){
			var defer = $q.defer();
			var queryParams = Object.assign({}, resourcePath, filters, pagination, sorting);

			api.saleInfos.getSaleInfos(
				queryParams,
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);

						defer.reject(errorMessage);
						return;
					}

					var saleInfoList = [];

					response.forEach(function(resourceData){
						var saleInfo = new SaleInfo();
						saleInfo.setAttributes(resourceData);

						saleInfoList.push(saleInfo);
					})

					defer.resolve(saleInfoList);
				},
				function(error){
					console.error(error);
					defer.reject("Failed to get sale infos");
				}
			);	

			return defer.promise;			
		}	

		this.getVehicleSaleInfos = function(resourcePath){
			var defer = $q.defer();

			api.vehicleSaleInfos.getVehicleSaleInfos(
				resourcePath,
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);

						defer.reject(errorMessage);
						return;
					}

					var saleInfoList = [];

					response.forEach(function(resourceData){
						var saleInfo = new SaleInfo();
						saleInfo.setAttributes(resourceData);

						saleInfoList.push(saleInfo);
					})
					defer.resolve(saleInfoList);

				},
				function(error){
					console.error(error);
					defer.reject("Failed to get sale infos");
				}
			);	

			return defer.promise;			
		}	

		this.getTradeInVehicles = function(resourcePath){
			var defer = $q.defer();

			api.tradeInVehicles.getTradeInVehicles(
				resourcePath,
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);

						defer.reject(errorMessage);
						return;
					}

					var tradeInVehicleList = [];

					response.forEach(function(resourceData){
						var tradeInVechile = new TradeInVehicle();
						tradeInVechile.setAttributes(resourceData);

						tradeInVehicleList.push(tradeInVechile);
					})
					defer.resolve(tradeInVehicleList);

				},
				function(error){
					console.error(error);
					defer.reject("Failed to get trade in vehicles");
				}
			);	

			return defer.promise;			
		}	

		this.getSaleInfoFiles = function(resourcePath){
			var defer = $q.defer();

			api.saleInfoFiles.getFiles(
				resourcePath,
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);

						defer.reject(errorMessage);
						return;
					}

					if(!Array.isArray(response)){
						defer.reject("Sale info file list is not an array.");
						return;
					}

					var fileList = [];

					response.forEach(function(fileData){
						if(fileData == null){
							return;
						}

						var file = new MyFile();
						file.setAttributes(fileData);

						fileList.push(file);
					});

					defer.resolve(fileList);
				},
				function(error){
					console.error(error);
					defer.reject("Failed to get sale info files");
				}
			);	

			return defer.promise;			
		}	

		this.deleteSaleInfoFiles = function(resourcePath){
			var defer = $q.defer();

			api.saleInfoFiles.deleteFile(
				resourcePath,
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);
						defer.reject(errorMessage);
						return;
					}

					defer.resolve(response);
				},
				function(error){
					console.error(error);
					defer.reject("Failed to delete sale info file");
				}
			);

			return defer.promise;
		}	

		this.createSaleWarranty = function(resourcePath, requestBody){
			var defer = $q.defer();

			api.saleWarranties.createWarranty(
				resourcePath,
				requestBody,
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);

						defer.reject(errorMessage);
						return;
					}
					defer.resolve(response.data);

				},
				function(error){
					console.error(error);
					defer.reject("Failed to create sale warranty");
				}
			);	

			return defer.promise;			
		}

		this.getSaleWarranties = function(resourcePath){
			var defer = $q.defer();

			api.saleWarranties.getWrranties(
				resourcePath,
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);

						defer.reject(errorMessage);
						return;
					}

					if(!Array.isArray(response)){
						defer.reject("Warranty data is not an array");
						return;
					}

					var warrantyList = [];

					response.forEach(function(warrantyData){
						if(warrantyData == null){
							return;
						}

						var warranty = new SaleWarranty();
						warranty.setAttributes(warrantyData);

						warrantyList.push(warranty);
					});

					defer.resolve(warrantyList);

				},
				function(error){
					console.error(error)
					defer.reject("Failed to get sale warranty");
				}
			);	

			return defer.promise;			
		}

		this.updateSaleWarranty = function(resourcePath, requestBody){
			var defer = $q.defer();

			api.saleWarranties.updateWarranty(
				resourcePath,
				requestBody,
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);

						defer.reject(errorMessage);
						return;
					}
					defer.resolve(response);

				},
				function(error){
					console.error(error);
					defer.reject("Failed to update sale warranty.");
				}
			);	

			return defer.promise;			
		}

		this.deleteSaleWarranty = function(resourcePath){
			var defer = $q.defer();

			api.saleWarranties.deleteWarranty(
				resourcePath,
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);
						defer.reject(errorMessage);
						return;
					}

					defer.resolve(response);
				},
				function(error){
					console.error(error);
					defer.reject("Failed to delete sale warranty");
				}
			);

			return defer.promise;
		}

		this.createSaleDisclosure = function(resourcePath, requestBody){
			var defer = $q.defer();

			api.saleDisclosure.createDisclosure(
				resourcePath,
				requestBody,
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);
						defer.reject(errorMessage);
						return;
					}

					defer.resolve(response.data);
				},
				function(error){
					console.error("Failed to create sale disclosure");
					defer.reject(error);
				}
			);

			return defer.promise;			
		}

		this.getSaleDisclosures = function(resourcePath){
			var defer = $q.defer();

			api.saleDisclosure.getDisclosures(
				resourcePath,
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);
						defer.reject(errorMessage);
						return;
					}

					var disclosureList = [];

					response.forEach(function(data){
						var disclosure = new Disclosure();

						disclosure.setAttributes(data); 
						disclosureList.push(disclosure);
					})

					defer.resolve(disclosureList);
				},
				function(error){
					console.error(error);
					defer.reject("Failed to get sale disclosures.");
				}
			);

			return defer.promise;			
		}

		this.deleteSaleDisclosure = function(resourcePath){
			var defer = $q.defer();

			api.saleDisclosure.deleteDisclosure(
				resourcePath,
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);
						defer.reject(errorMessage);
						return;
					}

					defer.resolve(response);
				},
				function(error){
					console.error(error);
					defer.reject("Failed to delete sale disclosure");
				}
			);

			return defer.promise;
		}

		this.getSalePackages = function(resourcePath){
			return salePackagesApi.getPackages(resourcePath);
		}

		this.createSalePackage = function(resourcePath, requesetBody){
			return salePackagesApi.postPackage(resourcePath, requesetBody);
		}

		this.deleteSalePackage = function(resourcePath){
			return salePackagesApi.deletePackage(resourcePath);
		}

		this.getSalePackageItems = function(resourcePath){
			return salePackageItemsApi.getItems(resourcePath);
		}

		this.redeemSalePackageItem = function(resourcePath){
			return redeemSalePackageItemApi.redeem(resourcePath);
		}

		this.createPickUpAccess = function(resourcePath, requestBody){
			var defer = $q.defer();

			api.pickupAccess.createPickupAccess(
				resourcePath,
				requestBody,
				function(response, header){
					var statusCode  = header(codeKey);
					console.log(statusCode);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);

						defer.reject(errorMessage);
						return;
					}
					console.log(response);

					defer.resolve(response);

				},
				function(error){
					console.error(error);
					defer.reject("Failed to create pick up access.");
				}
			);	

			return defer.promise;			
		}	
	}
})();
(function ()
{
	'use strict';

	angular
		.module('app.saleInfo')
		.service("SaleInfoSignatureService", SaleInfoSignatureService);

	/** @ngInject */
	function SaleInfoSignatureService(MyFile, ApiConst, api, Const, $q, SaleInfoSignature, SaleInfoService, BillOfSale, CustomersService, UserService, HellosignService)
	{
		var codeKey = Const.header.code;
		var messageKey = Const.header.message;
		var successCode = Const.code.success;

		var domain;

		switch(window.location.host){
			case ApiConst.productDomain:
				domain = ApiConst.productDomain;
				break;
			case ApiConst.productBackupDomain:
				domain = ApiConst.productBackupDomain;
				break;
			case ApiConst.testDomain:
					domain = ApiConst.testDomain;
					break;
			default:
				domain = 'localhost:3000';
				break;
		}

		const socketUrl = ApiConst.http + domain + "/hellosign-callback";

		this.createSaleInfoSignature = function(saleInfoResourcePath, subject, message, ignoreOption){
			var companyID = saleInfoResourcePath.companyID;
			var vehicleID = saleInfoResourcePath.vehicleID;
			var saleinfoID = saleInfoResourcePath.saleinfoID;

			var billOfSale = new BillOfSale(vehicleID, saleinfoID, ignoreOption);
			var preparetion = {};

			preparetion.billOfSaleFile = billOfSale.getPdfFile();
			preparetion.signers = getSigners(saleInfoResourcePath);

			var fileResourcePath = "companies/" + companyID + "/vehicles/" + vehicleID + "/saleinfos/" + saleinfoID +  "/signatures";

			var signatureInfos = {
				subject: "Bill Of Sale",
				message: "Please sign the bill of sale."
			};

			if(subject){
				signatureInfos.subject = subject;
			}

			if(message){
				signatureInfos.message = message;
			}

			return $q.all(preparetion)
				.then(function(result){
					return HellosignService.createSignatureRequest(fileResourcePath, result.billOfSaleFile, result.signers, signatureInfos);
				})
				.then(function(response){
					return $q.resolve(response.data)
				})
		}

		this.getSaleSignatures = function(resourcePath){
			var defer = $q.defer();

			api.saleInfoSignatures.getSignatures(
				resourcePath,
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);
						defer.reject(errorMessage);
						return;
					}

					var resourceList = [];

					response.forEach(function(data){
						var resource = new SaleInfoSignature();

						resource.setAttributes(data); 
						resourceList.push(resource);
					})

					defer.resolve(resourceList);
				},
				function(error){
					console.error(error);
					defer.reject("Failed to get sale signatures.");
				}
			);

			return defer.promise;			
		}

		this.deleteSaleSignatures = function(resourcePath){
			var defer = $q.defer();

			api.saleInfoSignatures.deleteSignature(
				resourcePath,
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);
						defer.reject(errorMessage);
						return;
					}

					defer.resolve(response);
				},
				function(error){
					console.error(error);
					defer.reject("Failed to delete sale signatures.");
				}
			);

			return defer.promise;			
		}

		this.getSaleSignatureDetail = getSaleSignatureDetail

		function getSaleSignatureDetail(resourcePath){
			var defer = $q.defer();

			api.saleInfoSignaturesDetail.fetchDetail(
				resourcePath,
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);
						defer.reject(errorMessage);
						return;
					}

					defer.resolve(response);
				},
				function(error){
					console.error(error);
					defer.reject("Failed to get sale signature request detail.");
				}
			);

			return defer.promise;			
		}

		this.previewSaleInfoSignatureFile = function(resourcePath){
			var defer = $q.defer();

			api.previewSaleInfoSignatureFile.fetchFile(
				resourcePath,
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);
						defer.reject(errorMessage);
						return;
					}

					defer.resolve(response);
				},
				function(error){
					console.error(error);
					defer.reject("Failed to get sale signature request file.");
				}
			);

			return defer.promise;			
		}

		this.saveSaleSignatureFile = function(resourcePath){
			var defer = $q.defer();

			api.saleInfoSignatureFile.saveFile(
				resourcePath,
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);
						defer.reject(errorMessage);
						return;
					}

					defer.resolve(response.data);
				},
				function(error){
					console.error(error);
					defer.reject("Failed to save sale signature request file.");
				}
			);

			return defer.promise;			
		}

		this.getSaleSignatureFile = function(resourcePath){
			var defer = $q.defer();
			api.saleInfoSignatureFile.getFile(
				resourcePath,
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);
						defer.reject(errorMessage);
						return;
					}

					const fileList = response.map(function(fileData){
						var file = new MyFile();

						file.setAttributes(fileData);
						return file;
					});

					defer.resolve(fileList);
				},
				function(error){
					console.error(error);
					defer.reject("Failed to get sale signature request file.");
				}
			);

			return defer.promise;			
		}

		this.trackSignatureState = function(resourcePath, signatureRequestID){
			var defer = $q.defer();

			var ioOption = {
				autoConnect:false,
				query:{signatureID: signatureRequestID},
				transports:['polling'],
				path: ApiConst.socketIoPath,
			}

			var socket = io.connect(socketUrl, ioOption);

			socket.on("timeout", function(message){
				defer.reject("timeout");
			})

			socket.on("connect", function(){
				console.log("connect", socket.id)
			})

			socket.on("error", function(error){
				defer.reject(error);
			})

			socket.on("signature_completed", function(signatureID){
				console.log("on signature_completed", signatureID)
				defer.resolve();
				socket.disconnect()
			})

			socket.connect();

			return defer.promise.then(function(){
				return getSaleSignatureDetail(resourcePath);
			});
		}

		function getSigners(saleInfoResourcePath){
			if(!saleInfoResourcePath){
				return $q.reject("Failed to get signers for sale info, because saleInfoResourcePath is invalid.");
			}
			var companyID = saleInfoResourcePath.companyID;

			return SaleInfoService.getVehicleSaleInfos(saleInfoResourcePath)
				.then(function(saleInfos){
					if(!Array.isArray(saleInfos) || !saleInfos[0]){
						return $q.reject("Failed to get signers for sale info, because sale info data is invalid.");
					}

					var saleInfo = saleInfos[0];

					var salesmanID = saleInfo.sold_by;
					var saleManagerID = saleInfo.sale_manager;
					var customerID = saleInfo.fk_id_customer;

					var queue = {};

					queue.salesman = getUserSigner({companyID: companyID, userID: salesmanID});
					queue.saleManager = getUserSigner({companyID: companyID, userID: saleManagerID});
					queue.customer = getCustomerSigner({companyID: companyID, customerID: customerID});

					return $q.all(queue);
				})
		}

		function getCustomerSigner(resourcePath){
			return CustomersService.getCustomers(resourcePath)
				.then(function(result){
					if(!result || !Array.isArray(result.data) || !result.data[0]){
						return $q.reject("Invalid customer data");
					}

					var customer = result.data[0];

					if(!Array.isArray(customer.emails) || !customer.emails[0] || !customer.emails[0].email_address){
						return $q.reject("Missing email address: " + customer.first_name + ' ' + customer.last_name + " does not have an email.");
					}

					return $q.resolve({
						name: customer.first_name + ' ' + customer.last_name,
						email: customer.emails[0].email_address
					});
				});
		}

		function getUserSigner(resourcePath){
			return UserService.getUsers(resourcePath)
				.then(function(result){
					if(!Array.isArray(result) || !result[0]){
						return $q.reject("Invalid user data");
					}

					var user = result[0];

					if(!user.email){
						return $q.reject("Missing email address: " + user.first_name + ' ' + user.last_name + " does not have an email.");
					}

					return $q.resolve({
						userID: user.id_user,
						name: user.first_name + ' ' + user.last_name,
						email: user.email
					});
				});
		}
	}
})();
(function ()
{
	'use strict';

	angular
		.module('app.saleInfo')
		.controller('EditSaleInfoController', EditSaleInfoController);

	function EditSaleInfoController(jobtypes, SalePromotion, $sce, FileViewService, $rootScope, $timeout, SaleInfoConstants, SalePackage, PresetPackagesService, WorkOrderConstants, $stateParams, WorkOrderService, api, ApiConst, $state, $q, $scope, MessageService, ProgressService, constants, vehicle, Vehicle, saleInfo, SaleInfo, CustomersService, LoginService, SaleInfoService, FinanceApplicationService, FinanceApplication, TradeInVehicle, tradeInVehicle, SaleExtras, SaleInfoPayment, FileUploadService, DialogService, saleExtras, promotions, payments, saleFiles, saleWarranty, SaleWarranty, Warranty, disclosures, BillOfSale, TasksService, PurchaseInfoService, GeneralTools, TaskConstants, VehicleConstants, signatures){   
		var vm = this;
		var companyID = LoginService.getCompanyID()
		var originSaleInfo;
		var originFinanceApplicaiton;
		var originTradeInVehicle;
		var originSaleWarranty;
		var originCustomerID;
		var uploadNewPaymentFilesPromise;
		var deleteSaleInfoConfirmString = "CONFIRM";
		var financeOptionID = 2;
		var allPurchaseAndSaleInfos;
		var billOfSaleUploader;

		var taskCategoryFkAdvertising = 7; 
		var taskCategoryFkFinance = 4; 
		var taskCategoryFkDocumentation = 3; 
		var matUserID = 25;
		var rayUserID = 29;
		var isIgnoringUnsavedChanges = false;
		const unsavedChangeWarning = "This page has unsaved content."
		const saveAndContinueStr = "save & continue";
		const ignoreAndContinueStr = "ignore & continue";

		vm.translateToInitCapitalize = GeneralTools.inputTranslators.initCapitalize;
		vm.translateToDollar = GeneralTools.inputTranslators.dollar;
		vm.saleDiscountInputOption = {
			decimalFractionSize:2
		};
		vm.jobTyppList = jobtypes
		vm.packageItemsMap = {};
		
		vm.initNewFinanceApplication = initNewFinanceApplication;
		vm.removeFinanceApplication = removeFinanceApplication;

		vm.initNewTradeInVechile = initNewTradeInVechile;
		vm.removeTradeInVehicle = removeTradeInVehicle;

		vm.initNewSaleWarranty = initNewSaleWarranty;
		vm.removeSaleWarranty = removeSaleWarranty;

		vm.addExtras = addExtras;
		vm.removeExtras = removeExtras;

		vm.addPromotion = addPromotion;
		vm.removePromotion = removePromotion;
		vm.addCustomPromotion = addCustomPromotion;

		vm.addPayment = addPayment;
		vm.removePayment = removePayment;

		vm.deleteSaleInfoFile = deleteSaleInfoFile;

		vm.onDisclosureAdded = onDisclosureAdded;
		vm.onDisclosureRemoved = onDisclosureRemoved;

		vm.saveChanges = saveChanges;
		vm.deleteSaleInfo = deleteSaleInfo;

		vm.printBillOfSale = printBillOfSale;

		vm.deletePackage = deletePackage;
		vm.addPackage = addPackage;

		vm.onAnchorClicked = onAnchorClicked;
		vm.onSectionActivated = onSectionActivated;
		vm.activateSection = activateSection;
		vm.onCustomerSelect = onCustomerSelect;
		vm.ignoreOptions = {};

		vm.generalCollapseSectionID = SaleInfoConstants.saleInfoSummaryAnchors.GENERAL;
		vm.paymentsCollapseSectionID = SaleInfoConstants.saleInfoSummaryAnchors.PAYMENTS;
		vm.financingCollapseSectionID = SaleInfoConstants.saleInfoSummaryAnchors.FINANCING;
		vm.tradeInCollapseSectionID = SaleInfoConstants.saleInfoSummaryAnchors.TRADE_IN;
		vm.warrantyCollapseSectionID = SaleInfoConstants.saleInfoSummaryAnchors.WARRANTY;
		vm.extrasCollapseSectionID = SaleInfoConstants.saleInfoSummaryAnchors.EXTRAS;
		vm.packagesCollapseSectionID = SaleInfoConstants.saleInfoSummaryAnchors.PACKAGES;
		vm.promotionsCollapseSectionID = SaleInfoConstants.saleInfoSummaryAnchors.PROMOTIONS;
		vm.disclosuresCollapseSectionID = "DISCLOSURES";
		vm.sectionTitleTag = "title";

		init();

		function init (){
			initSectionOptions();
			initConstants();
			initFileUploader();
			initVehicle();
			initSaleInfo();
			initCustomer();
			initFinanceApplication();
			initTradeInVehicle();
			initSaleWarranty();
			initExtras();
			initPromotions();
			initPayments();
			initSaleFiles();
			initDisclosures();
			initSignatures();
			initActiveWorkorders();
			initPresetPackages();
			initPackages();
			initPageChangeListener();
		}

		function initPageChangeListener(){
			$scope.$on("$stateChangeStart", function(event, toState, toParams, fromState, fromParams){
				if(!hasUnsavedChanges() || isIgnoringUnsavedChanges){
					return;
				}

				event.preventDefault();
				$rootScope.$root.loadingProgress = false;

				DialogService.showYesOrNoDialog(null, unsavedChangeWarning, saveAndContinueStr, ignoreAndContinueStr)
					.then(function(isToSaveChanges){
						if(isToSaveChanges){
							return saveChanges();
						}
						
						isIgnoringUnsavedChanges = true;		
						return $q.resolve();
					})
					.then(function(){
						$state.go(toState.name, toParams);
					})
					.catch(function(error){
						if(error){
							MessageService.showToast(error);
						}
					});
			});
		}

		function onCustomerSelect(customer){
			vm.saleInfo.setCustomerID(customer.getResourceID());
		}

		function hasUnsavedChanges(){
			return isTradeInVehicleChanged() || isSaleinfoChanged() || isWarrantyChanged();
		}

		function isTradeInVehicleChanged(){
			if(vm.tradeInVehicle && vm.tradeInVehicle.getResourceID() == null){
				return true;
			}

			var tradeInVehicleRequestBody = GeneralTools.updateResourceRequestBodyGenerator(vm.tradeInVehicle, originTradeInVehicle);

			return tradeInVehicleRequestBody && Object.keys(tradeInVehicleRequestBody).length > 0;
		}

		function isSaleinfoChanged(){
			var saleInfoRequestBody = GeneralTools.updateResourceRequestBodyGenerator(vm.saleInfo, originSaleInfo);
			return saleInfoRequestBody && Object.keys(saleInfoRequestBody).length > 0;
		}

		function isWarrantyChanged(){
			if(vm.saleWarranty && vm.saleWarranty.getResourceID() == null){
				return true;
			}

			var saleWarrantyRequestBody = GeneralTools.updateResourceRequestBodyGenerator(vm.saleWarranty, originSaleWarranty);

			return saleWarrantyRequestBody && Object.keys(saleWarrantyRequestBody).length > 0;
		}

		function initSectionOptions(){
			vm.sectionOptions = {
				financing: { 
					name: "Financing",
					id: vm.financingCollapseSectionID
				},
				tradeIn: { 
					name: "Trade In" ,
					id: vm.tradeInCollapseSectionID
				},
				warranty: { 
					name: "Warranty" ,
					id: vm.warrantyCollapseSectionID
				},
				extras: { 
					name: "Extras" ,
					id: vm.extrasCollapseSectionID
				},
				promotions: { 
					name: "Discounts" ,
					id: vm.promotionsCollapseSectionID
				}
			};

			$scope.$watch("vm.sectionOptions", function(){
				vm.ignoreOptions.financing = !vm.sectionOptions.financing.active;
				vm.ignoreOptions.tradeIn = !vm.sectionOptions.tradeIn.active;
				vm.ignoreOptions.warranty = !vm.sectionOptions.warranty.active;
				vm.ignoreOptions.extras = !vm.sectionOptions.extras.active;
				vm.ignoreOptions.packages = !vm.sectionOptions.extras.active;
			}, true);
		}

		function activateSection(item){
			item.active = true;
			onSectionActivated(item);
		}

		function onSectionActivated(item){
			if(item.active){
				$timeout(function(){
					onAnchorClicked(item.id);
				})
			}
		}

		function onAnchorClicked(id){
			if(id == SaleInfoConstants.saleInfoSummaryAnchors.PACKAGES){
				id = SaleInfoConstants.saleInfoSummaryAnchors.EXTRAS;
			}

			const element = angular.element(document.querySelector('#' + id));
			if(!element){
				return;
			}
			
			const titleElementID = id + vm.sectionTitleTag;

			if(element.hasClass('show')){
				GeneralTools.scrollToTag(titleElementID);
				return
			}
			
			element.collapse('show');		
			element.on('shown.bs.collapse', function () {
				$timeout(function(){
					GeneralTools.scrollToTag(titleElementID);
				})
			});
		}

		function initPresetPackages(){
			PresetPackagesService.getPresetPackages({companyID: companyID}).$promise.then(function(presetPackages){
				vm.presetPackages = presetPackages;
			});
		}

		function initPackages(){
			const resourcePath = {
				companyID: companyID,
				vehicleID: $stateParams.vehicleID,
				saleinfoID: $stateParams.saleInfoID
			};

			SaleInfoService.getSalePackages(resourcePath).$promise.then(function(salePackages){
				if(!Array.isArray(salePackages)){
					return $q.reject("salePackages is invalid");
				}

				vm.salePackages = salePackages;

				if(vm.salePackages.length > 0){
					vm.sectionOptions.extras.active = true;
				}

				salePackages.forEach(function(salePackage){
					fecthSalePackageItems(salePackage.id_sale_package)
				});					 
			})
			.catch(MessageService.showToast);
		}

		function fecthSalePackageItems(packageID){
			const resourcePath = {
				companyID: companyID,
				vehicleID: $stateParams.vehicleID,
				saleinfoID: $stateParams.saleInfoID,
				packageID: packageID
			};

			SaleInfoService.getSalePackageItems(resourcePath).$promise.then(function(items){
				vm.packageItemsMap[packageID] = items;
			})
			.catch(MessageService.showToast);
		}

		function initActiveWorkorders(){
				const resourcePath = {
					companyID: companyID,
					vehicleID: $stateParams.vehicleID
				}

				const filters = {filters: GeneralTools.equalFilterBuilder(WorkOrderConstants.keyNames.status, WorkOrderConstants.statusIDs.quoted)};

				WorkOrderService.getWorkOrders(resourcePath, filters).$promise
					.then(function(workorders){
						vm.quotedWorkorders = workorders;
					})
					.catch(MessageService.showToast);
			}

		function initSignatures(){
			if(Array.isArray(signatures)){
				vm.signatures = signatures;
			}else{
				vm.signatures = [];
			}
		}

		function initDisclosures(){
			if(Array.isArray(disclosures)){
				vm.disclosures = disclosures;
			}else{
				vm.disclosures = [];
			}
		}

		function initFileUploader(){
			vm.saleInfofileUploader = FileUploadService.getNewUploader();
			vm.saleInfofileUploader.filters.push(FileUploadService.getSizeFilter(50));

			vm.newPaymentFileUploader = FileUploadService.getNewUploader();
			vm.newPaymentFileUploader.filters.push(FileUploadService.getSizeFilter(20));
		}

		function initSaleFiles(){	
			if(Array.isArray(saleFiles)){
				vm.saleInfoFiles = saleFiles.map(function(fileData){
					return {fileData: fileData}
				});
			}else{
				vm.saleInfoFiles = [];
			}

			initFilesPreviewUrl();
		}

		function initFilesPreviewUrl(){
			if(!Array.isArray(vm.saleInfoFiles)){
				return;
			}

			vm.saleInfoFiles.forEach(function(item){
				if(!item || !item.fileData){
					return;
				}

				if(!item.fileData.isImage() && !item.fileData.isPdf()){
					return;
				}

				if(item.fileData.isPublic()){
					item.previewUrl = item.fileData.getURL();
				} else {
					initPreviewUrl(item.fileData);
				}
			});
		}
		
		function initPreviewUrl(file){
			if(!file || !Array.isArray(vm.saleInfoFiles)){
				return;
			}

			const options = {
				width:200,
				quality:30
			};

			FileViewService.downloadFile(file.getResourcePath(), options)
				.then(function(response){
					const item = vm.saleInfoFiles.find(function(item){
						return item && item.fileData && item.fileData.id_sale_info_file == file.id_sale_info_file;
					});
					
					item.previewUrl = URL.createObjectURL(new Blob([new Uint8Array(response.data)], {type: file.getFileType()}));
				});
		}

		function initPayments(){
			if(Array.isArray(payments)){
				vm.payments = payments;
			}else{
				vm.payments = [];
			}
		}

		function initPromotions(){
			if(Array.isArray(promotions)){
				vm.promotions = promotions;
			}else{
				vm.promotions = [];
			}

			if(vm.promotions.length > 0){
				vm.sectionOptions.promotions.active = true;
			}
		}

		function initExtras(){
			if(Array.isArray(saleExtras)){
				vm.saleExtras = saleExtras;
			}else{
				vm.saleExtras = [];
			}

			if(vm.saleExtras.length > 0){
				vm.sectionOptions.extras.active = true;
			}
		}

		function initVehicle(){
			if(vehicle == null || !Array.isArray(vehicle.data) || vehicle.data[0] == null){
				MessageService.showToast("Vehicle of this sale info is invalid.")
				return;
			} 

			vm.vehicle = vehicle.data[0];
			vm.vehiclePageUrl = $state.href('app.edit-vehicle', {vehicleID: vm.vehicle.getResourceID(), tab:VehicleConstants.editPageTabNames.saleInfo}, {absolute: true});
			vm.vehicleDetailPageUrl = $state.href('app.vehicle.general', {vehicleID: vm.vehicle.getResourceID()});
		}

		function initSaleWarranty(){
			if(!Array.isArray(saleWarranty)){
				return;
			}

			vm.saleWarranty = saleWarranty[0];
			originSaleWarranty = angular.copy(vm.saleWarranty);

			if(vm.saleWarranty){
				vm.sectionOptions.warranty.active = true;
			}
		}

		function initTradeInVehicle(){
			if(!Array.isArray(tradeInVehicle)){
				return;
			}

			vm.tradeInVehicle = tradeInVehicle[0];
			originTradeInVehicle = angular.copy(vm.tradeInVehicle);

			if(vm.tradeInVehicle){
				vm.sectionOptions.tradeIn.active = true;
			}
		}

		function initSaleInfo(){
			if(!Array.isArray(saleInfo) || saleInfo[0] == null){
				vm.saleInfo = new SaleInfo();
			} else {
				vm.saleInfo = saleInfo[0];
			}

			originSaleInfo = angular.copy(vm.saleInfo);
		}

		function initFinanceApplication(){
			if(vm.saleInfo.hasFinancingInfos()){
				vm.sectionOptions.financing.active = true;
			}
		}

		function initConstants(){
			if(constants == null){
				MessageService.showToast("constants is null.");
				return; 
			}

			vm.cusomterFormConstants = {
				emailCategories: constants.emailCategories,
				phoneCategories: constants.phoneCategories
			}

			vm.financeApplicationConstants = {
				employmentStatus: constants.employmentStatus,
				livingArrangementTypes: constants.livingArrangementTypes
			}

			vm.paymentFormConstants = {
				paymentOptions: constants.paymentOptions,
				paymentMethods: constants.paymentMethods
			}

			vm.plateOptions 		= constants.plateOptions;
			vm.warrantyOptions 		= constants.warrantyOptions;
			vm.presetExtrasOptions 	= constants.presetExtrasOptions;
			vm.promotionOptions 	= constants.promotionOptions;
			vm.workorderPriorities = constants.workorderPriorities;
		}

		function initCustomer(){
			var customerID = vm.saleInfo.getCustomerID();
			originCustomerID = customerID;
			if(customerID == null){
				MessageService.showToast("Customer ID is null.");
				return; 
			}

			var resourcePath = {
					companyID:companyID,
					customerID:customerID
				};

			vm.isFetchingCustomerData = true;

			CustomersService.getCustomers(resourcePath, null, null, null)
				.then(function(responseData){
					if(responseData == null || !Array.isArray(responseData.data)){
						MessageService.showToast("Customer data invalid");
						return;
					}

					vm.customer = responseData.data[0];
				})
				.catch(MessageService.showToast)
				.finally(function(){
					vm.isFetchingCustomerData = false;
				})
		}

		function initNewFinanceApplication (){
			vm.financeApplication = new FinanceApplication();

			if(vm.customer != null && vm.customer.getResourceID() != null){
				vm.financeApplication.setCustomerID(vm.customer.getResourceID());
			}

			if(vm.saleInfo != null && vm.saleInfo.getResourceID() != null){
				vm.financeApplication.setSaleInfoID(vm.saleInfo.getResourceID());
			}
		}

		function removeFinanceApplication (){
			var dialogOptions = {};

			dialogOptions.titleString = "Remove finance application";
			dialogOptions.contentString = "Are you sure to detach finance application from this sale info?";

			var confirmOption = {};

			confirmOption.optionName = "YES";
			confirmOption.onClick = function(){
				confirmDetachFinanceApplicationCallback();
				DialogService.close();
			}

			var cancelOption = {};

			cancelOption.optionName = "NO";
			cancelOption.onClick = function(){
				DialogService.close();
			}

			dialogOptions.options = [confirmOption, cancelOption];

			DialogService.showOptionsDialog(dialogOptions);
		}

		function confirmDetachFinanceApplicationCallback(){
			if(vm.financeApplication == null){
				MessageService.showToast("Success");
				return;
			}

			if(vm.financeApplication.getResourceID() == null){
				vm.financeApplication = null;
				MessageService.showToast("Success");
				return;
			}

			var resourcePath = {
				companyID: companyID,
				financeapplicationID: vm.financeApplication.getResourceID()
			}

			vm.isProcessingData = true;
			ProgressService.setMode("indeterminate");
			ProgressService.isVisble(true);

			FinanceApplicationService.updateFinanceApplication(resourcePath, {fk_id_sale_info:null})
				.then(function(response){
					vm.financeApplication = null;
					originFinanceApplicaiton = null;
					MessageService.showToast("Success");
				})
				.catch(MessageService.showToast)
				.finally(function(){
					vm.isProcessingData = false;
					ProgressService.isVisble(false);
				});
		}

		function initNewSaleWarranty (){
			vm.saleWarranty = new SaleWarranty();
		}

		function removeSaleWarranty (){
			var dialogOptions = {};

			dialogOptions.titleString = "Remove warranty";
			dialogOptions.contentString = "Are you sure to remove warranty from this sale info?";

			var confirmOption = {};

			confirmOption.optionName = "YES";
			confirmOption.onClick = function(){
				confirmRemoveWarrantyCallback();
				DialogService.close();
			}

			var cancelOption = {};

			cancelOption.optionName = "NO";
			cancelOption.onClick = function(){
				DialogService.close();
			}

			dialogOptions.options = [confirmOption, cancelOption];

			DialogService.showOptionsDialog(dialogOptions);
		}

		function confirmRemoveWarrantyCallback(){
			if(vm.saleWarranty == null){
				MessageService.showToast("Success");
				return;
			}

			if(vm.saleWarranty.getResourceID() == null){
				vm.saleWarranty = null;
				MessageService.showToast("Success");
				return;
			}

			var resourcePath = {
				companyID: companyID,
				vehicleID: vm.vehicle.getResourceID(),
				saleinfoID: vm.saleInfo.getResourceID(),
				warrantyID: vm.saleWarranty.getResourceID()
			}

			vm.isProcessingData = true;
			ProgressService.setMode("indeterminate");
			ProgressService.isVisble(true);

			SaleInfoService.deleteSaleWarranty(resourcePath)
				.then(function(response){
					vm.saleWarranty = null;
					MessageService.showToast("Warranty is removed");
					originSaleWarranty = null;

					return updateDefaultTasksForWarranty();
				})
				.catch(MessageService.showToast)
				.finally(function(){
					vm.isProcessingData = false;
					ProgressService.isVisble(false);
				})
		}
		
		function initNewTradeInVechile (){
			vm.tradeInVehicle = new TradeInVehicle();
		}

		function removeTradeInVehicle (){
			var dialogOptions = {};

			dialogOptions.titleString = "Remove trade in vehicle";
			dialogOptions.contentString = "Are you sure to remove trade in vehicle from this sale info?";

			var confirmOption = {};

			confirmOption.optionName = "YES";
			confirmOption.onClick = function(){
				confirmRemoveTradeInVehicleCallback();
				DialogService.close();
			}

			var cancelOption = {};

			cancelOption.optionName = "NO";
			cancelOption.onClick = function(){
				DialogService.close();
			}

			dialogOptions.options = [confirmOption, cancelOption];

			DialogService.showOptionsDialog(dialogOptions);
		}		

		function confirmRemoveTradeInVehicleCallback(){
			if(vm.tradeInVehicle == null){
				MessageService.showToast("Success");
				return;
			}

			if(vm.tradeInVehicle.getResourceID() == null){
				vm.tradeInVehicle = null;
				MessageService.showToast("Success");
				return;
			}

			var resourcePath = {
				companyID: companyID,
				vehicleID: vm.vehicle.getResourceID(),
				saleinfoID: vm.saleInfo.getResourceID(),
				tradeinvehicleID: vm.tradeInVehicle.getResourceID()
			}

			vm.isProcessingData = true;
			ProgressService.setMode("indeterminate");
			ProgressService.isVisble(true);

			SaleInfoService.deleteTradeInVehicle(resourcePath)
				.then(function(response){
					vm.tradeInVehicle = null;
					MessageService.showToast("Trade in vehicle is removed");
					originTradeInVehicle = null;
					return updateDefaultTaskForTradeInVehicle();
				})
				.catch(MessageService.showToast)
				.finally(function(){
					vm.isProcessingData = false;
					ProgressService.isVisble(false);
				})
		}

		function addExtras(extra){
			var resourcePath = {
				companyID: companyID,
				vehicleID: vm.vehicle.getResourceID(),
				saleinfoID: vm.saleInfo.getResourceID()
			};

			vm.isAddingExtra = true;

			return SaleInfoService.createSaleExtras(resourcePath, extra)
				.then(function(response){		
					extra.setResourceID(response);
					vm.saleExtras.push(extra);
				})
				.catch(MessageService.showToast)
				.finally(function(){
					vm.isAddingExtra = false;
				})
		}

		function removeExtras(extra){
			var dialogPromise = $q.resolve(true);

			vm.isRemovingExtra = true;
			if(!extra.fk_id_preset_extras){			
				dialogPromise = DialogService.showYesOrNoDialog("Unselect Extra", "This is a custom extra, are you sure you want to remove it?")
			}

			return dialogPromise
				.then(function(isYes){
					if(isYes){
						var resourcePath = {
							companyID: companyID,
							vehicleID: vm.vehicle.getResourceID(),
							saleinfoID: vm.saleInfo.getResourceID(),
							saleextraID: extra.getResourceID()
						};
	
						return SaleInfoService.deleteExtras(resourcePath); 
					}
					return $q.reject();
				})
				.then(function(){
					var itemIndex = vm.saleExtras.findIndex(function(item){
						return item.getResourceID() == extra.getResourceID()
					})
					vm.saleExtras.splice(itemIndex, 1);
				})
				.catch(function(error){
					if(error){
						MessageService.showToast(error);
					}
				})
				.finally(function(){
					vm.isRemovingExtra = false;
				});
		}

		function addCustomPromotion(){
			const salePromotion = new SalePromotion();

			salePromotion.setAttributes({
				name: vm.customPromotionName,
				description: vm.customPromotionDescription,
				discount_amount: vm.customPromotionAmount,
			});
			
			vm.isAddingCustomPromotion = true;

			addPromotion(salePromotion)
				.then(function(){
					vm.customPromotionName = null;
					vm.customPromotionDescription = null;
					vm.customPromotionAmount = null;
				})
				.finally(function(){
					vm.isAddingCustomPromotion = false;
				});
		}

		function addPromotion(promotion){
			if(vm.isProcessingData){
				return;
			}

			if(promotion.fk_id_promotion){
				for(var i in vm.promotions){
					if(vm.promotions[i].fk_id_promotion == promotion.fk_id_promotion){
						MessageService.showToast("This item is already selected.")
						return;
					}
				}
			}

			var resourcePath = {
				companyID: companyID,
				vehicleID: vm.vehicle.getResourceID(),
				saleinfoID: vm.saleInfo.getResourceID()
			};

			return SaleInfoService.createSalePromotion(resourcePath, promotion)
				.then(function(response){
					promotion.setResourceID(response.data);
					vm.promotions.push(promotion);
				})
				.catch(MessageService.showToast);
		}

		function removePromotion(promotion){
			var resourcePath = {
				companyID: companyID,
				vehicleID: vm.vehicle.getResourceID(),
				saleinfoID: vm.saleInfo.getResourceID(),
				promotionID: promotion.getResourceID()
			};

			var dialogPromise = $q.resolve(true);

			if(!promotion.fk_id_promotion){
				dialogPromise = DialogService.showYesOrNoDialog("Unselect Discount", "This is a custom discount, you can NOT select it again.")
			}

			return dialogPromise.then(function(isYes){
					if(isYes){
						return SaleInfoService.deleteSalePromotion(resourcePath);
					}

					return $q.reject();
				})
				.then(function(){
					var itemIndex = vm.promotions.findIndex(function(item){
						return item.getResourceID() == promotion.getResourceID();
					})
					vm.promotions.splice(itemIndex, 1);
				})
				.catch(function(error){
					if(error){
						MessageService.showToast(error);
					}
				});
		}

		function addPayment(){
			if(vm.isProcessingData){
				return;
			}

			if(vm.newPayment == null 
					|| vm.newPayment.fk_id_payment_method == null 
					|| vm.newPayment.amount == null){
				MessageService.showToast("Payment is invalid.");
				return;
			}

			var resourcePath = {
				companyID: companyID,
				vehicleID: vm.vehicle.getResourceID(),
				saleinfoID: vm.saleInfo.getResourceID()
			};

			vm.isProcessingData = true;
			ProgressService.setMode("indeterminate");
			ProgressService.isVisble(true);
			vm.newPayment.addingFromSaleInfo = true;
			SaleInfoService.createSalePayment(resourcePath, vm.newPayment)
				.then(function(newPaymentID){
					resourcePath.paymentID = newPaymentID;

					var tasksBaseOnNewPaymentID = {
						uploadFile:uploadNewPaymentFiles(newPaymentID),
						getPayment:SaleInfoService.getSalePayments(resourcePath)
					}

					return $q.all(tasksBaseOnNewPaymentID);
				})
				.then(function(response){
					if(response == null || !Array.isArray(response.getPayment)){
						return $q.reject("Payment data is invalid");
					}

					vm.payments.push(response.getPayment[0]);
					vm.newPayment = new SaleInfoPayment();
					MessageService.showToast("Payment is added.")	

				})
				.catch(MessageService.showToast)
				.finally(function(){
					vm.isProcessingData = false;
					ProgressService.isVisble(false);
				})
		}

		function uploadNewPaymentFiles(paymentID){
			uploadNewPaymentFilesPromise = $q.defer();

			if(!Array.isArray(vm.newPaymentFileUploader.queue) || vm.newPaymentFileUploader.queue.length <= 0){
				return $q.resolve();
			}

			var resourcePath = {
				companyID: companyID,
				vehicleID: vm.vehicle.getResourceID(),
				saleInfoID: vm.saleInfo.getResourceID(),
				paymentID: paymentID
			}
			
			vm.newPaymentFileUploader.queue.forEach(function(fileItem){
				fileItem.url = FileUploadService.getUrlForPostPaymentFile(resourcePath);
			})

			vm.newPaymentFileUploader.uploadAll();

			return uploadNewPaymentFilesPromise.promise;
		}

		vm.newPaymentFileUploader.onCompleteAll = function(){
			vm.newPaymentFileUploader.clearQueue();
			uploadNewPaymentFilesPromise.resolve();
		}

		vm.newPaymentFileUploader.onErrorItem = function(item){
			uploadNewPaymentFilesPromise.reject("Failed to upload " + item.file.name);
		}

		function removePayment(payment){
			var dialogOptions = {};

			dialogOptions.titleString = "Delete payment";
			dialogOptions.contentString = "Are you sure to delete payment - " + payment.payment_date;

			var confirmOption = {};

			confirmOption.optionName = "YES";
			confirmOption.onClick = function(){
				confirmRemovePaymentCallback(payment)
				DialogService.close();
			}

			var cancelOption = {};

			cancelOption.optionName = "NO";
			cancelOption.onClick = function(){
				DialogService.close();
			}

			dialogOptions.options = [confirmOption, cancelOption];

			DialogService.showOptionsDialog(dialogOptions);	
		}

		function confirmRemovePaymentCallback(payment){
			if(vm.isProcessingData){
				return;
			}

			var resourcePath = {
				companyID: companyID,
				vehicleID: vm.vehicle.getResourceID(),
				saleinfoID: vm.saleInfo.getResourceID(),
				paymentID: payment.getResourceID()
			};

			vm.isProcessingData = true;
			ProgressService.setMode("indeterminate");
			ProgressService.isVisble(true);

			SaleInfoService.deleteSalePayment(resourcePath)
				.then(function(response){
					var itemIndex = vm.payments.findIndex(function(item){
						return item.getResourceID() == payment.getResourceID()
					})
					vm.payments.splice(itemIndex, 1);

					MessageService.showToast("Payment is removed.")
				})
				.catch(MessageService.showToast)
				.finally(function(){
					vm.isProcessingData = false;
					ProgressService.isVisble(false);
				})		
		}

		function deleteSaleInfoFile (file){
			var dialogOptions = {};

			dialogOptions.titleString = "Delete file";
			dialogOptions.contentString = "Are you sure to file " + file.fileData.file_name + '?';

			var confirmOption = {};

			confirmOption.optionName = "YES";
			confirmOption.onClick = function(){
				confirmDeleteSaleInfoFileCallback(file.fileData);
				DialogService.close();
			}

			var cancelOption = {};

			cancelOption.optionName = "NO";
			cancelOption.onClick = function(){
				DialogService.close();
			}

			dialogOptions.options = [confirmOption, cancelOption];

			DialogService.showOptionsDialog(dialogOptions);
		}

		function confirmDeleteSaleInfoFileCallback (file){
			var resourcePath = {
				companyID: companyID,
				vehicleID: vm.vehicle.getResourceID(),
				saleinfoID: vm.saleInfo.getResourceID(),
				fileID: file.id_sale_info_file
			}

			vm.isProcessingData = true;
			ProgressService.setMode("indeterminate");
			ProgressService.isVisble(true);

			SaleInfoService.deleteSaleInfoFiles(resourcePath)
				.then(function(response){
					var itemIndex = vm.saleInfoFiles.findIndex(function(item){
						return item.fileData.id_sale_info_file == file.id_sale_info_file;
					})
					vm.saleInfoFiles.splice(itemIndex, 1);

					MessageService.showToast("File is deleted.");				
				})
				.catch(MessageService.showToast)
				.finally(function(){
					vm.isProcessingData = false;
					ProgressService.isVisble(false);
				})
		}

		vm.saleInfofileUploader.onAfterAddingFile = function(fileItem){	
			var resourcePath = {
				companyID: companyID,
				vehicleID: vm.vehicle.getResourceID(),
				saleInfoID: vm.saleInfo.getResourceID()
			}

			if((fileItem.file.type.indexOf("image") != -1 || fileItem.file.type.indexOf("pdf") != -1)){
				var url = URL.createObjectURL(fileItem._file);
				fileItem.previewUrl = $sce.trustAsResourceUrl(url);
			}
			
			fileItem.url = FileUploadService.getUrlForPostSaleInfoFile(resourcePath);
			fileItem.upload();

			vm.isProcessingData = true;
		}

		vm.saleInfofileUploader.onSuccessItem = function(fileItem, response, status, headers){
			if(!FileUploadService.isUploadSuccess(headers)){
				MessageService.showToast(headers.message);
				return;
			}

			var resourcePath = {
				companyID: companyID,
				vehicleID: vm.vehicle.getResourceID(),
				saleinfoID: vm.saleInfo.getResourceID(),
				fileID: response.data
			}

			SaleInfoService.getSaleInfoFiles(resourcePath)
				.then(function(response){
					if(!Array.isArray(response)){
						return $q.reject("Sale info file data is invalid.");
					}

					if(!Array.isArray(vm.saleInfoFiles)){
						vm.saleInfoFiles = [];
					}

					vm.saleInfoFiles.push({
						fileData: response[0],
						previewUrl: fileItem.previewUrl
					});
					fileItem.remove();
				})
				.catch(MessageService.showToast)
		}

		vm.saleInfofileUploader.onCompleteAll = function(){
			vm.isProcessingData = false;
		}

		function updateSaleWarranty (){
			var resourcePath = {
				companyID: companyID,
				vehicleID: vm.vehicle.getResourceID(),
				saleinfoID: vm.saleInfo.getResourceID()
			}

			if(vm.saleWarranty == null){
				return $q.resolve();;
			}

			if(vm.saleWarranty.getResourceID() == null){
				return SaleInfoService.createSaleWarranty(resourcePath, vm.saleWarranty)
							.then(function(saleWarrantyID){
								vm.saleWarranty.setResourceID(saleWarrantyID);
								return updateDefaultTasksForWarranty();
							});
			}

			var saleWarrantyRequestBody = GeneralTools.updateResourceRequestBodyGenerator(vm.saleWarranty, originSaleWarranty);

			if(saleWarrantyRequestBody == null || Object.keys(saleWarrantyRequestBody).length <= 0){
				return $q.resolve();;
			}

			resourcePath.warrantyID = vm.saleWarranty.getResourceID();

			return SaleInfoService.updateSaleWarranty(resourcePath, vm.saleWarranty)
				.then(function(){
					return updateDefaultTasksForWarranty();
				});
		}

		function updateDefaultTasksForWarranty(){
			return getTasksBetweenCurrentSaleAndNextPurchase()
				.then(function(tasks){
					if(!tasks || !Array.isArray(tasks.data)){
						return $q.reject("Task data is invalid");	
					}

					var purchaseWarrantyTaskIDs = [];

					tasks.data.forEach(function(task){
						if(task.name == TaskConstants.purchaseWarrantyTaskName){
							purchaseWarrantyTaskIDs.push(task.id_task);
						}
					});

					var queue = [];

					if(!vm.saleWarranty){
						purchaseWarrantyTaskIDs.forEach(function(taskID){
							queue.push(TasksService.deleteTask({companyID: companyID, taskID: taskID}));
						});

						return $q.all(queue);
					}

					if(purchaseWarrantyTaskIDs.length <= 0){
						queue.push(createDefaultTask(vm.vehicle.getResourceID(), TaskConstants.purchaseWarrantyTaskName, taskCategoryFkDocumentation, matUserID))
					}

					return $q.all(queue);
				});
		}

		function updateTradeInVehicleTask(){
			var resourcePath = {
				companyID: companyID,
				vehicleID: vm.vehicle.getResourceID(),
				saleinfoID: vm.saleInfo.getResourceID()
			}

			var queue = [];

			if(vm.tradeInVehicle == null){
				return $q.resolve();;
			}

			if(vm.tradeInVehicle.getResourceID() == null){
				return SaleInfoService.createTradeInVehicle(resourcePath, vm.tradeInVehicle)
							.then(function(tradeInVehicleID){
								vm.tradeInVehicle.setResourceID(tradeInVehicleID);
								return updateDefaultTaskForTradeInVehicle();
							});
			}

			var tradeInVehicleRequestBody = GeneralTools.updateResourceRequestBodyGenerator(vm.tradeInVehicle, originTradeInVehicle);

			if(tradeInVehicleRequestBody == null || Object.keys(tradeInVehicleRequestBody).length <= 0){
				return $q.resolve();;
			}

			resourcePath.tradeinvehicleID = vm.tradeInVehicle.getResourceID();

			return SaleInfoService.updateTradeInVehicle(resourcePath, vm.tradeInVehicle)
				.then(function(){
					return updateDefaultTaskForTradeInVehicle();
				})
		}

		function updateDefaultTaskForTradeInVehicle(){
			return getTasksBetweenCurrentSaleAndNextPurchase()
				.then(function(tasks){
					if(!tasks || !Array.isArray(tasks.data)){
						return $q.reject("Task data is invalid");	
					}

					var createTradeInFormTaskIDs = [];
					var tradeInLienPayoutTaskIDs = [];

					tasks.data.forEach(function(task){
						if(task.name == TaskConstants.CreateTradeInFormTaskName){
							createTradeInFormTaskIDs.push(task.id_task);
						}

						if(task.name == TaskConstants.tradeInLienPayoutTaskName){
							tradeInLienPayoutTaskIDs.push(task.id_task);
						}
					});

					var queue = [];

					// no trade in vehcile, remove all related tasks
					if(!vm.tradeInVehicle){
						createTradeInFormTaskIDs.forEach(function(taskID){
							queue.push(TasksService.deleteTask({companyID: companyID, taskID: taskID}));
						});

						tradeInLienPayoutTaskIDs.forEach(function(taskID){
							queue.push(TasksService.deleteTask({companyID: companyID, taskID: taskID}));
						});

						return $q.all(queue);
					}

					// has trade in vehcile
					if(createTradeInFormTaskIDs.length <= 0){
						queue.push(createDefaultTask(vm.vehicle.getResourceID(), TaskConstants.CreateTradeInFormTaskName, taskCategoryFkDocumentation, LoginService.getUserID()));
					}

					if(vm.tradeInVehicle.trade_lien_payout){
						if(tradeInLienPayoutTaskIDs.length <= 0){
							queue.push(createDefaultTask(vm.vehicle.getResourceID(), TaskConstants.tradeInLienPayoutTaskName, taskCategoryFkFinance, [rayUserID, matUserID]));
						}
					}else{
						tradeInLienPayoutTaskIDs.forEach(function(taskID){
							queue.push(TasksService.deleteTask({companyID: companyID, taskID: taskID}));
						});
					}

					return $q.all(queue);
				});
		}

		function updateFinanceApplicationTask(){
			var resourcePath = {
					companyID: companyID,
					customerID: vm.financeApplicationApplicantID
				}

			if(vm.financeApplication == null){
				return $q.resolve();;
			}

			if(vm.financeApplication.getResourceID() == null){
				return FinanceApplicationService.createFinanceApplication(resourcePath, vm.financeApplication)
							.then(function(financeApplicationID){
								vm.financeApplication.setResourceID(financeApplicationID);
								return $q.resolve();
							});
			}

			var financeApplicationRequestBody = FinanceApplicationService.updateFinanceApplicationRequestBodyGenerator(vm.financeApplication, originFinanceApplicaiton);

			if(financeApplicationRequestBody == null || Object.keys(financeApplicationRequestBody).length <= 0){
				return $q.resolve();;
			}

			resourcePath.financeapplicationID = vm.financeApplication.getResourceID();

			return FinanceApplicationService.updateFinanceApplication(resourcePath, financeApplicationRequestBody);
		}

		function updateSaleInfoTask(){
			var vehicleID = vm.vehicle.getResourceID();

			var saleInfoRequestBody = GeneralTools.updateResourceRequestBodyGenerator(vm.saleInfo, originSaleInfo);

			if(saleInfoRequestBody == null || Object.keys(saleInfoRequestBody).length <= 0){
				return $q.resolve();
			}

			var tasks = [];

			if(saleInfoRequestBody.fk_id_payment_option || saleInfoRequestBody.lien_registration != null){
				tasks.push(updateDefaultTasksForFinanceApplication());
			}

			var resourcePath = {
				companyID: companyID,
				vehicleID: vehicleID,
				saleinfoID: vm.saleInfo.getResourceID()
			}

			tasks.push(SaleInfoService.updateVehicleSaleInfo(resourcePath, saleInfoRequestBody));

			return $q.all(tasks);
		}

		function updateDefaultTasksForFinanceApplication(){
			var vehicleID = vm.vehicle.getResourceID();

			return getTasksBetweenCurrentSaleAndNextPurchase()
				.then(function(tasks){
					if(!tasks || !Array.isArray(tasks.data)){
						return $q.reject("Task data is invalid");	
					}

					var verifyFinanceDepositTaskIDs = [];
					var confirmFundsInTheAccountTaskIDs = [];

					tasks.data.forEach(function(task){
						if(task.name == TaskConstants.verifyFinanceDepositTaskName){
							verifyFinanceDepositTaskIDs.push(task.id_task);
						}

						if(task.name == TaskConstants.confirmFundsInTheAccountTaskName){
							confirmFundsInTheAccountTaskIDs.push(task.id_task);
						}
					});

					var queue = [];

					if(vm.saleInfo.fk_id_payment_option == financeOptionID || vm.saleInfo.lien_registration){
						if(verifyFinanceDepositTaskIDs.length <= 0){
							queue.push(createDefaultTask(vm.vehicle.getResourceID(), TaskConstants.verifyFinanceDepositTaskName, taskCategoryFkFinance));
						}

						confirmFundsInTheAccountTaskIDs.forEach(function(taskID){
							queue.push(TasksService.deleteTask({companyID: companyID, taskID: taskID}));
						});
					}else{
						if(confirmFundsInTheAccountTaskIDs.length <= 0){
							queue.push(createDefaultTask(vm.vehicle.getResourceID(), TaskConstants.confirmFundsInTheAccountTaskName, taskCategoryFkFinance));
						}

						verifyFinanceDepositTaskIDs.forEach(function(taskID){
							queue.push(TasksService.deleteTask({companyID: companyID, taskID: taskID}));
						});
					}

					return $q.all(queue);
				})
		}

		function createDefaultTask(vehicleID, taskName, category, userID){
			var resourcePath = { companyID: companyID };

			var requestBody = {
				assigned_to_vehicle: {id_vehicle: vehicleID},
				fk_id_task_category: category,
				fk_id_task_priority: 3,
				fk_id_task_status: 1,
				name: taskName
			}

			if(Array.isArray(userID)){
				requestBody.assigned_to_users = userID.map(function(id){
					return {id_user: id}
				})
			} else if (userID){
				requestBody.assigned_to_users = [{id_user: userID}];
			}
			
			return TasksService.createTask(resourcePath, requestBody)
		}

		function tasksFilterBuilder(timeRange, vehicleId){
			var filterString = '';

			if(vehicleId){
				filterString = "(id_vehicle eq " + vehicleId + ")";
			}

			if(!timeRange){
				return filterString;
			}

			var fromFilterString = '';
			var toFilterString = '';

			if(timeRange.from){
				fromFilterString = "((created_date gt " + timeRange.from + ") OR (created_date eq " + timeRange.from + "))";	
			}

			if(timeRange.to){
				toFilterString = "((created_date lt " + timeRange.to + ") OR (created_date eq " + timeRange.to + "))";	
			}

			filterString = GeneralTools.stringConnector(filterString, fromFilterString, " AND ");
			filterString = GeneralTools.stringConnector(filterString, toFilterString, " AND ");

			return filterString;
		}

		function findTimeRangeBetweenCurrentSaleAndNextPurcahseInfo(currentSaleInfoID, allSaleInfos, allPurchaseInfos){
			if(!Array.isArray(allPurchaseInfos)){
				allPurchaseInfos = [];
			}

			if(!Array.isArray(allSaleInfos)){
				allSaleInfos = [];
			}

			var timeRange = {};
			var nextPurchaseInfo;
			var currentSaleInfo;

			currentSaleInfo = allSaleInfos.find(function(saleInfo){
				return currentSaleInfoID == saleInfo.getResourceID();
			});

			if(currentSaleInfo == null){
				return;
			}

			var currentSaleInfoDate = currentSaleInfo.getSaleDateMomentObj();

			nextPurchaseInfo = allPurchaseInfos.reverse().find(function(purchaseInfo){
				var purchaseDate = purchaseInfo.getPurchaseDateMomentObj();

				if(currentSaleInfoDate && purchaseDate){
					return !purchaseInfo.is_canceled && purchaseDate.isAfter(currentSaleInfoDate);
				}
			});

			timeRange.from = currentSaleInfoDate.utc().format("YYYY-MM-DD HH:mm:ss");

			if(nextPurchaseInfo){
				timeRange.to = nextPurchaseInfo.getPurchaseDateMomentObj().utc().format("YYYY-MM-DD HH:mm:ss");
			}

			return timeRange;
		}

		function getTasksBetweenCurrentSaleAndNextPurchase(){
			var vehicleID = vm.vehicle.getResourceID()
			var resourcePath = {
				companyID: companyID,
				vehicleID: vehicleID,
			}
			var taskResourcePath = { companyID: companyID };
			var pagination = {limit: "unlimited"};
			var queue = {};

			if(allPurchaseAndSaleInfos){
				return $q.resolve(allPurchaseAndSaleInfos);
			}

			queue.purchaseInfos = PurchaseInfoService.getPurchaseInfos(resourcePath);
			queue.saleInfos = SaleInfoService.getVehicleSaleInfos(resourcePath);

			return $q.all(queue)
				.then(function(result){
					var allPurchaseInfos = result.purchaseInfos;
					var allSaleInfos = result.saleInfos

					var timeRange = findTimeRangeBetweenCurrentSaleAndNextPurcahseInfo(vm.saleInfo.getResourceID(), allSaleInfos, allPurchaseInfos)

					if(!timeRange){
						return $q.reject("Task time range is invalid");
					}

					var filterString = tasksFilterBuilder(timeRange, vehicleID);

					if(!filterString){
						return $q.reject("Task filter is invalid");
					}

					return TasksService.getTasks(taskResourcePath, {filters: filterString}, pagination);
				});
		}

		function getValidationMassage(){
			var formNames = [];

			if($scope.saleInfoForm.generalForm != null && $scope.saleInfoForm.generalForm.$invalid){
				formNames.push("GENERAL");
			}

			if($scope.saleInfoForm.financeApplicationForm != null && $scope.saleInfoForm.financeApplicationForm.$invalid){
				formNames.push("FINANCE APPLICATION");
			}

			if($scope.saleInfoForm.tradeInForm != null && $scope.saleInfoForm.tradeInForm.$invalid){
				formNames.push("TRADE IN");
			}

			if($scope.saleInfoForm.paymentForm != null && $scope.saleInfoForm.paymentForm.$invalid){
				formNames.push("PAYMENT");
			}

			if($scope.saleInfoForm.detailForm != null && $scope.saleInfoForm.detailForm.$invalid){
				formNames.push("DETAILS");
			}

			if($scope.saleInfoForm.warrantyForm != null && $scope.saleInfoForm.warrantyForm.$invalid){
				formNames.push("WARRANTY");
			}

			if(formNames.length <= 0){
				return '';
			}

			return "Something wrong in: " + formNames.toString();
		}

		function saveChanges(){
			if($scope.saleInfoForm.$invalid){
				MessageService.showToast(getValidationMassage());
				return $q.reject();
			}
			
			var tasks = [updateSaleInfoTask(), updateFinanceApplicationTask(), updateTradeInVehicleTask(), updateSaleWarranty()];

			vm.isProcessingData = true;
			ProgressService.setMode("indeterminate");
			ProgressService.isVisble(true);

			return $q.all(tasks)
				.then(function(response){
					originSaleInfo 				= angular.copy(vm.saleInfo);
					originFinanceApplicaiton 	= angular.copy(vm.financeApplication);
					originTradeInVehicle 		= angular.copy(vm.tradeInVehicle);
					originSaleWarranty 			= angular.copy(vm.saleWarranty);
					MessageService.showToast("Success");
				})
				.catch(MessageService.showToast)
				.finally(function(){
					ProgressService.isVisble(false);
					vm.isProcessingData = false;
				});
		}

		function deleteSaleInfo (){
			var dialogOptions = {};

			dialogOptions.inputBoxPlaceHolder	= "Enter here";
			dialogOptions.cancelButtonString	= "CANCEL";
			dialogOptions.confirmButtonString	= "CONFIRM";
			dialogOptions.titleString			= "ARE YOU SURE TO DELETE THIS SALE INFO";
			dialogOptions.contentString			= "Please Type \"" + deleteSaleInfoConfirmString + "\" below:";

			dialogOptions.confirmCallback				= confirmDeleteSaleInfoCallback;
			dialogOptions.enableConfirmButtonCallback	= enableDeleteSaleInfoButtonCallback;

			DialogService.showConfirmDialog(dialogOptions);
		}

		function enableDeleteSaleInfoButtonCallback(inputString){
			return inputString === deleteSaleInfoConfirmString;
		}

		function confirmDeleteSaleInfoCallback(saleInfo){
			ProgressService.setMode("indeterminate");
			ProgressService.isVisble(true);
			vm.isProcessingData = true;

			var resourcePath = {
				companyID: companyID,
				vehicleID: vm.vehicle.getResourceID(),
				saleinfoID: vm.saleInfo.getResourceID()
			}

			SaleInfoService.deleteVehicleSaleInfo(resourcePath)
					.then(function(response){
						$state.go("app.edit-vehicle", {vehicleID: vm.vehicle.getResourceID(), tab:"saleInfo"});
						MessageService.showToast("Success !");
					})
					.catch(MessageService.showToast)
					.finally(function(){
						vm.isProcessingData = false;
						ProgressService.isVisble(false);
					})
		}

		function onDisclosureAdded (disclosure){
			ProgressService.setMode("indeterminate");
			ProgressService.isVisble(true);
			vm.isProcessingData = true;

			var resourcePath = {
				companyID: companyID,
				vehicleID: vm.vehicle.getResourceID(),
				saleinfoID: vm.saleInfo.getResourceID()
			}

			SaleInfoService.createSaleDisclosure(resourcePath, disclosure)
				.then(function(newDisclosureID){
					disclosure.setResourceID(newDisclosureID);
					vm.disclosures.push(disclosure);
					vm.cleanNewDisclouser();
				})
				.catch(MessageService.showToast)
				.finally(function(){
					ProgressService.isVisble(false);
					vm.isProcessingData = false;
				});
		}

		function onDisclosureRemoved(diclosure, index){
        	var resourcePath = {
        		companyID: companyID,
        		vehicleID: vm.vehicle.getResourceID(),
				saleinfoID: vm.saleInfo.getResourceID(),
        		disclosureID: diclosure.getResourceID()
        	}

        	ProgressService.setMode("indeterminate");
			ProgressService.isVisble(true);
			vm.isProcessingData = true;

        	SaleInfoService.deleteSaleDisclosure(resourcePath)
        		.then(function(){
        			vm.disclosures.splice(index, 1);
        		})
        		.catch(MessageService.showToast)
        		.finally(function(){
        			ProgressService.isVisble(false);
					vm.isProcessingData = false;
        		});
        }

        function printBillOfSale(){
        	var billOfSale = new BillOfSale(vm.vehicle.getResourceID(), vm.saleInfo.getResourceID(), vm.ignoreOptions);

			ProgressService.setMode("indeterminate");
			ProgressService.isVisble(true);

			billOfSale.open()
				.catch(MessageService.showToast)
				.finally(function(){
					ProgressService.isVisble(false);
				})
        }

        function initSignatureRequests(signatureRequests){
        	if(!Array.isArray(signatureRequests)){
        		return;
        	}
        	var queue = [];

        	signatureRequests.forEach(function(signatureRequest){
        		var defer = $q.defer();
        		signatureRequest.defer = defer;
        		queue.push(signatureRequest.defer.promise)
        	})

        	vm.signatureRequests = signatureRequests;

        	$q.all(queue).then(function(){
        		MessageService.showToast("finish all signing")
        	});
        }

		function deletePackage(salePackage, presetPackage){
			vm.isDeletingPackage = true;

			const newSalePackage = new SalePackage();
			newSalePackage.pullDataFromPresetPackage(presetPackage)

			var dialogPromise = $q.resolve(true);

			if(!salePackage.getExpiryDateMomentObj().isSame(newSalePackage.getExpiryDateMomentObj()) || (presetPackage.valid_mileage && salePackage.expiry_mileage && presetPackage.valid_mileage != 0 && (salePackage.expiry_mileage - saleInfo[0].mileage - presetPackage.valid_mileage) != 0)){			
				dialogPromise = DialogService.showYesOrNoDialog("Unselect Package", "Unselecting this package will result in resetting the expiry date and covering mileage if you choose to add it again.")
			}

			return dialogPromise
				.then(function(isYes){
					if(isYes){
						const resourcePath = {
							companyID: companyID,
							vehicleID: $stateParams.vehicleID,
							saleinfoID: $stateParams.saleInfoID,
							packageID: salePackage.id_sale_package
						}

						return SaleInfoService.deleteSalePackage(resourcePath).$promise;
					}
					
					return $q.reject();
				})
				.then(function(){
					const index = vm.salePackages.findIndex(function(item){
						return !!item && item.id_sale_package == salePackage.id_sale_package;
					});

					vm.salePackages.splice(index, 1);
				})
				.catch(function(error){
					if(error){
						MessageService.showToast(error);
					}
				})
				.finally(function(){
					vm.isDeletingPackage = false;
				});
		}

		function addPackage(presetPackage){
			vm.isAddingPackages = true;

			const resourcePath = {
				companyID: companyID,
				vehicleID: $stateParams.vehicleID,
				saleinfoID: $stateParams.saleInfoID
			}

			const salePackage = new SalePackage();
			salePackage.pullDataFromPresetPackage(presetPackage);

			return SaleInfoService.createSalePackage(resourcePath, salePackage).$promise
				.then(function(salePackageID){
					salePackage.id_sale_package = salePackageID;
					vm.salePackages.push(salePackage);
					vm.packageItemsMap[salePackageID] = [];
					
					presetPackage.items.forEach(function(item){
						vm.packageItemsMap[salePackageID].push({
							name: item.name,
							quantity: item.quantity,
							origin_quantity: item.quantity,
							fk_id_preset_package_item: item.id_preset_package_item
						});
					});
				})
				.catch(MessageService.showToast)
				.finally(function(){
					vm.isAddingPackages = false;
				});
		}

				
		vm.voidCreditCardPayment = function(payment, index){
			if(!payment){
				MessageService.showToast("Payment data invalid");
				return;
			}

			var dialogOptions = {};

			dialogOptions.titleString = "Void Payment";
			dialogOptions.contentString = "Are you sure to void credit card payment - $" + payment.amount;

			var confirmOption = {};

			confirmOption.optionName = "YES";
			confirmOption.onClick = function(){
				confirmVoidCreditCardPayment(vm.customer, vm.customer.authorize_net_profile_id, payment.authorize_trans_id, index);
				DialogService.close();
			}

			var cancelOption = {};

			cancelOption.optionName = "NO";
			cancelOption.onClick = function(){
				DialogService.close();
			}

			dialogOptions.options = [confirmOption, cancelOption];

			DialogService.showOptionsDialog(dialogOptions);
		}

		function confirmVoidCreditCardPayment(customer, authorize_net_profile_id, authorize_trans_id, index){
			const resourcePath = {
				companyID: companyID,
				customerID: customer.id_customer,
				authorizeNetProfile: authorize_net_profile_id
			}
			
			vm.isDeletingPayment = true;
			var requestBody = {
				companyID: companyID,
				customerID: customer.id_customer,
				authorize_trans_id: authorize_trans_id,
				authorizeNetProfile: authorize_net_profile_id
			}
			WorkOrderService.voidCreditCardsPayment(requestBody, resourcePath)
				.then(function(result){
					if(Array.isArray(vm.payments)){
						vm.payments[index].is_canceled = 1
						vm.payments[index].message = result.message
						vm.payments[index].authorize_trans_id = result.authorize_trans_id
						vm.payments[index].authorize_trans_detail_copy = result.authorize_trans_detail_copy
					}		
					MessageService.showToast("Credit Card payment is void.");
				})
				.catch(MessageService.showToast)
				.finally(function(){
					vm.isDeletingPayment = false;
				});

		}

		vm.refundCreditCardPayment = function (payment, index){
			if(!payment){
				MessageService.showToast("Payment data invalid");
				return;
			}

			var dialogOptions = {};

			dialogOptions.titleString = "Refund Payment";
			dialogOptions.contentString = "Are you sure to refund credit card payment - $" + payment.amount;

			var confirmOption = {};

			confirmOption.optionName = "YES";
			confirmOption.onClick = function(){
				confirmRefundCreditCardPayment(vm.customer, vm.customer.authorize_net_profile_id, payment.authorize_trans_id, payment.amount, index);
				DialogService.close();
			}

			var cancelOption = {};

			cancelOption.optionName = "NO";
			cancelOption.onClick = function(){
				DialogService.close();
			}

			dialogOptions.options = [confirmOption, cancelOption];

			DialogService.showOptionsDialog(dialogOptions);
		}

		function confirmRefundCreditCardPayment(customer, authorize_net_profile_id, authorize_trans_id, amount, index){
			const resourcePath = {
				companyID: companyID,
				customerID: customer.id_customer,
				authorizeNetProfile: authorize_net_profile_id
			}
			
			vm.isDeletingPayment = true;
			var requestBody = {
				companyID: companyID,
				customerID: customer.id_customer,
				authorize_trans_id: authorize_trans_id,
				authorizeNetProfile: authorize_net_profile_id,
				amount: amount
			}
			WorkOrderService.refundCreditCardsPayment(requestBody, resourcePath)
				.then(function(result){
					if(Array.isArray(vm.payments)){
						vm.payments[index].is_refund = 1
						vm.payments[index].message = result.message
						vm.payments[index].authorize_trans_id = result.authorize_trans_id
						vm.payments[index].authorize_trans_detail_copy = result.authorize_trans_detail_copy
					}		
					MessageService.showToast("Credit card payment is refound.");
				})
				.catch(MessageService.showToast)
				.finally(function(){
					vm.isDeletingPayment = false;
				});

		}
	}
})();
(function ()
{
	'use strict';

	angular
		.module("app.saleInfo")
		.factory("Warranty", WarrantyClass)

	/** @ngInject */
	function WarrantyClass()
	{	   
		function Warranty(){}

		Warranty.prototype.setAttributes = function (attributes) {
	 		var keyList = Object.keys(attributes);

	 		for(var i = 0; i < keyList.length; i++){
	 			var key = keyList[i];
	 			var value = attributes[key];

	 			this.setAttribute(key, value);
	 		}
		}

		Warranty.prototype.setAttribute = function (key, value) {
	 		this[key] = value;
		}

		Warranty.prototype.setResourceID = function (id) {
	 		this.id_warranty = id;
		}

		Warranty.prototype.getResourceID = function () {
	 		return this.id_warranty;
		}

		return Warranty;
	}


})();
(function ()
{
	'use strict';

	angular
		.module("app.saleInfo")
		.factory("TradeInVehicle", TradeInVehicleClass)

	/** @ngInject */
	function TradeInVehicleClass()
	{	   
		function TradeInVehicle(){}

		TradeInVehicle.prototype.setAttributes = function (attributes) {
	 		var keyList = Object.keys(attributes);

	 		for(var i = 0; i < keyList.length; i++){
	 			var key = keyList[i];
	 			var value = attributes[key];

	 			this.setAttribute(key, value);
	 		}
		}

		TradeInVehicle.prototype.setAttribute = function (key, value) {
	 		this[key] = value;
		}

		TradeInVehicle.prototype.setResourceID = function (id) {
	 		this.id_trade_in_vehicle = id;
		}

		TradeInVehicle.prototype.getResourceID = function () {
	 		return this.id_trade_in_vehicle;
		}	

		TradeInVehicle.prototype.getResourcePath = function () {
	 		return {
	 			tradeInVehicleID: this.id_trade_in_vehicle,
	 		}
		}

		return TradeInVehicle;
	}


})();
(function ()
{
	'use strict';

	angular
		.module("app.saleInfo")
		.factory("SaleWarranty", SaleWarrantyClass)

	/** @ngInject */
	function SaleWarrantyClass()
	{	   
		function SaleWarranty(){}

		SaleWarranty.prototype.setAttributes = function (attributes) {
	 		var keyList = Object.keys(attributes);

	 		for(var i = 0; i < keyList.length; i++){
	 			var key = keyList[i];
	 			var value = attributes[key];

	 			this.setAttribute(key, value);
	 		}
		}

		SaleWarranty.prototype.setAttribute = function (key, value) {
	 		this[key] = value;
		}

		SaleWarranty.prototype.setResourceID = function (id) {
	 		this.id_sale_warranty = id;
		}

		SaleWarranty.prototype.getResourceID = function () {
	 		return this.id_sale_warranty;
		}

		SaleWarranty.prototype.pullDataFromWarranty = function (warranty) {
	 		if(warranty == null){
	 			return;
	 		}

	 		this.name = warranty.name;
	 		this.description = warranty.description;
	 		this.cost = warranty.cost;
	 		this.retail = warranty.retail;
	 		this.duration_month = warranty.duration_month;
	 		this.duration_mileage = warranty.duration_mileage;
	 		this.provider = warranty.provider;
		}

		return SaleWarranty;
	}


})();
(function ()
{
	'use strict';

	angular
		.module("app.saleInfo")
		.factory("SalePackage", SalePackageClass)

	/** @ngInject */
	function SalePackageClass(SaleInfoConstants)
	{	   
		function SalePackage(){}

		SalePackage.prototype.setAttributes = function (attributes) {
	 		var keyList = Object.keys(attributes);

	 		for(var i = 0; i < keyList.length; i++){
	 			var key = keyList[i];
	 			var value = attributes[key];

	 			this.setAttribute(key, value);
	 		}
		}

		SalePackage.prototype.setAttribute = function (key, value) {
	 		this[key] = value;
		}

		SalePackage.prototype.setResourceID = function (id) {
	 		this.id_sale_package = id;
		}

		SalePackage.prototype.getResourceID = function () {
	 		return this.id_sale_package;
		}	

		SalePackage.prototype.pullDataFromPresetPackage = function (presetPackage) {
	 		if(presetPackage == null){
	 			return;
			}
			this.fk_id_preset_package = presetPackage.id_preset_package;
			this.name = presetPackage.name;
			this.price = presetPackage.price;
			this.expiry_mileage = presetPackage.expiry_mileage;
			const today = moment();
			this.expiry_date = today.month(presetPackage.valid_time + today.month()).format("YYYY-MM-DD");
		}

		SalePackage.prototype.getExpiryDateMomentObj = function (){
			if(this.expiry_date){
				return moment(this.expiry_date, SaleInfoConstants.salePackageDateFormat);
			}
		}

		SalePackage.prototype.isAvailable = function (){
			const expiryDate = this.getExpiryDateMomentObj();

			if(!expiryDate){
				return;
			}
			const now = moment();

			return now.isSameOrBefore(expiryDate, "Date");
		}

		return SalePackage;
	}
})();
(function ()
{
	'use strict';

	angular
		.module("app.saleInfo")
		.factory("SaleInfoSignature", SaleInfoSignatureClass)

	/** @ngInject */
	function SaleInfoSignatureClass($filter)
	{	   
		function SaleInfoSignature(){}

		SaleInfoSignature.prototype.setAttributes = function (attributes) {
	 		if(attributes == null){
	 			return;
	 		}

	 		var keyList = Object.keys(attributes);

	 		for(var i = 0; i < keyList.length; i++){
	 			var key = keyList[i];
	 			var value = attributes[key];

	 			this.setAttribute(key, value);
	 		}
		}

		SaleInfoSignature.prototype.setAttribute = function (key, value) {
	 		this[key] = value;
		}

		SaleInfoSignature.prototype.setResourceID = function (id) {
	 		this.id_sale_info_signature = id;
		}

		SaleInfoSignature.prototype.getResourceID = function () {
	 		return this.id_sale_info_signature;
		}	

		SaleInfoSignature.prototype.getCreatedTimeMomentObj = function (){
			if(this.created_time != null){
				return moment(this.created_time);
			}
		}

		return SaleInfoSignature;
	}

})();
(function ()
{
	'use strict';

	angular
		.module("app.saleInfo")
		.factory("SaleInfoPayment", SaleInfoPaymentClass)

	/** @ngInject */
	function SaleInfoPaymentClass($filter)
	{	   
		function SaleInfoPayment(){}

		SaleInfoPayment.prototype.setAttributes = function (attributes) {
	 		if(attributes == null){
	 			return;
	 		}

	 		var keyList = Object.keys(attributes);

	 		for(var i = 0; i < keyList.length; i++){
	 			var key = keyList[i];
	 			var value = attributes[key];

	 			this.setAttribute(key, value);
	 		}
		}

		SaleInfoPayment.prototype.setAttribute = function (key, value) {
	 		this[key] = value;
		}

		SaleInfoPayment.prototype.setResourceID = function (id) {
	 		this.id_payment = id;
		}

		SaleInfoPayment.prototype.getResourceID = function () {
	 		return this.id_payment;
		}	

		SaleInfoPayment.prototype.setPaymentDate = function (momentObj) {
	 		if(momentObj != null && momentObj.isValid()){
				this.payment_date = momentObj.utc().format('YYYY-MM-DD[T]HH:mm:ss[Z]');
				return true;
			}
			this.payment_date = null;
			return false;
		}	

		SaleInfoPayment.prototype.getPaymentDateMomentObj = function (){
			if(this.payment_date != null){
				return moment(this.payment_date, 'YYYY-MM-DD[T]HH:mm:ss[Z]');
			}
		}

		return SaleInfoPayment;
	}

})();
(function ()
{
	'use strict';

	angular
		.module("app.saleInfo")
		.factory("SaleInfo", SaleInfoClass)

	/** @ngInject */
	function SaleInfoClass($filter, SaleInfoConstants)
	{	   
		function SaleInfo(){}

		SaleInfo.prototype.setAttributes = function (attributes) {
	 		if(attributes == null){
	 			return;
	 		}

	 		var keyList = Object.keys(attributes);

	 		for(var i = 0; i < keyList.length; i++){
	 			var key = keyList[i];
	 			var value = attributes[key];

	 			this.setAttribute(key, value);
	 		}
		}

		SaleInfo.prototype.setAttribute = function (key, value) {
	 		this[key] = value;
		}

		SaleInfo.prototype.setResourceID = function (id) {
	 		this.id_sale_info = id;
		}

		SaleInfo.prototype.getResourceID = function () {
	 		return this.id_sale_info;
		}	

		SaleInfo.prototype.setCustomerID = function (id) {
	 		this.setAttribute("fk_id_customer", id);
		}

		SaleInfo.prototype.getCustomerID = function (id) {
	 		return this.fk_id_customer;
		}

		SaleInfo.prototype.setFinanceApplicationID = function (id) {
	 		this.setAttribute("fk_id_finance_application", id);
		}

		SaleInfo.prototype.getFinanceApplicationID = function (id) {
	 		return this.fk_id_finance_application;
		}

		SaleInfo.prototype.setVehicleID = function (id) {
	 		this.setAttribute("fk_id_vehicle", id);
		}

		SaleInfo.prototype.getVehicleID = function (id) {
	 		return this.fk_id_vehicle;
		}

/*		SaleInfo.prototype.setPlateOptionID = function (id) {
	 		this.setAttribute("fk_id_plate_option", id);
		}

		SaleInfo.prototype.getPlateOptionID = function (id) {
	 		return this.fk_id_plate_option;
		}*/

		SaleInfo.prototype.setWarrantyID = function (id) {
	 		this.setAttribute("fk_id_sale_warranty", id);
		}

		SaleInfo.prototype.getWarrantyID = function (id) {
	 		return this.fk_id_sale_warranty;
		}

		SaleInfo.prototype.setPaymentOptionID = function (id) {
	 		this.setAttribute("fk_id_payment_option", id);
		}	

		SaleInfo.prototype.getPaymentOptionID = function (id) {
	 		return this.fk_id_payment_option;
		}	

		SaleInfo.prototype.getSaleDate = function() {
	 		return this.sale_date;
		}	

		SaleInfo.prototype.getSaleDateMomentObj = function() {
	 		if(this.sale_date != null){
				return moment(this.sale_date, SaleInfoConstants.saleDateFormat);
			}
		}	

		SaleInfo.prototype.setSaleDate = function (momentObj) {
	 		if(momentObj != null && momentObj.isValid()){
				this.sale_date = momentObj.format(SaleInfoConstants.saleDateFormat);
				return true;
			}
			this.sale_date = null;
			return false;
		}	

		SaleInfo.prototype.setDeliveryDueDate = function (momentObj) {
	 		if(momentObj != null && momentObj.isValid()){
				this.delivery_due_date = momentObj.format(SaleInfoConstants.deliveryDueDateFormat);
				return true;
			}
			this.delivery_due_date = null;
			return false;
		}	

		SaleInfo.prototype.getDeliveryDueDateMomentObj = function (){
			if(this.delivery_due_date != null){
				return moment(this.delivery_due_date, SaleInfoConstants.deliveryDueDateFormat);
			}
		}

		SaleInfo.prototype.setDeliveryDate = function (momentObj) {
	 		if(momentObj != null && momentObj.isValid()){
				this.delivery_date = momentObj.format(SaleInfoConstants.deliveryDateFormat);
				return true;
			}
			this.delivery_date = null;
			return false;
		}	

		SaleInfo.prototype.getDeliveryDateMomentObj = function (){
			if(this.delivery_date != null){
				return moment(this.delivery_date, SaleInfoConstants.deliveryDateFormat);
			}
		}

		SaleInfo.prototype.clearFinancingInfos = function (){
			this.finance_application_fee = 0;
			this.lien_registration = 0;
			this.bank_admin_fee = 0;
			this.cost_of_borrowing = 0;
			this.dealer_reserve = 0;	
		}

		SaleInfo.prototype.hasFinancingInfos = function (){
			return this.finance_application_fee 
				|| this.bank_admin_fee 
				|| this.cost_of_borrowing 
				|| this.lien_registration 
				|| this.dealer_reserve;	
		}

		return SaleInfo;
	}

})();
(function ()
{
	'use strict';

	angular
		.module("app.saleInfo")
		.factory("SaleExtras", SaleExtrasClass)

	/** @ngInject */
	function SaleExtrasClass()
	{	   
		function SaleExtras(){}

		SaleExtras.prototype.setAttributes = function (attributes) {
	 		var keyList = Object.keys(attributes);

	 		for(var i = 0; i < keyList.length; i++){
	 			var key = keyList[i];
	 			var value = attributes[key];

	 			this.setAttribute(key, value);
	 		}
		}

		SaleExtras.prototype.setAttribute = function (key, value) {
	 		this[key] = value;
		}

		SaleExtras.prototype.setResourceID = function (id) {
	 		this.id_sale_extras = id;
		}

		SaleExtras.prototype.getResourceID = function () {
	 		return this.id_sale_extras;
		}	

		SaleExtras.prototype.setName = function (name) {
	 		this.setAttribute("name", name);
		}	

		SaleExtras.prototype.getName = function () {
	 		return this.name;
		}	

		SaleExtras.prototype.setCost = function (cost) {
	 		this.setAttribute("cost", cost);
		}	

		SaleExtras.prototype.getCost = function () {
	 		return this.cost;
		}

		SaleExtras.prototype.pullDataFromPresetExtra = function (presetExtra) {
	 		if(presetExtra == null){
	 			return;
	 		}

			this.fk_id_preset_extras = presetExtra.id_preset_extras;
			this.name = presetExtra.name;
			this.cost = presetExtra.cost;
		}	

		return SaleExtras;
	}


})();
(function ()
{
	'use strict';

	angular
		.module("app.saleInfo")
		.factory("SaleCalculator", SaleCalculatorClass)

	/** @ngInject */
	function SaleCalculatorClass(GeneralTools, ToolsConstants, SaleInfoConstants)
	{	   
		function SaleCalculator(){}

		SaleCalculator.prototype.setSalePrice = function(salePrice) {
			this.salePrice = parseNumber(salePrice);
		}

		SaleCalculator.prototype.setSaleDiscount = function(discount) {
			this.saleDiscount = parseNumber(discount);
		}	

		SaleCalculator.prototype.getSaleDiscount = function() {
			return this.saleDiscount;
		}	

		SaleCalculator.prototype.getSalePrice = function() {
			return this.salePrice;
		}

		SaleCalculator.prototype.setCommissionPayout = function(commissionPayout) {
			this.commissionPayout = parseNumber(commissionPayout);
		}

		SaleCalculator.prototype.getCommissionPayout = function() {
			return this.commissionPayout;
		}

		SaleCalculator.prototype.setFinanceApplicationFee = function(financeApplicationFee) {
			this.financeApplicationFee = parseNumber(financeApplicationFee);
		}

		SaleCalculator.prototype.getFinanceApplicationFee = function() {
			return this.financeApplicationFee;
		}
		SaleCalculator.prototype.setLienRegistrationFee = function(lienRegistrationFee) {
			if(isNaN(parseFloat(lienRegistrationFee))){
				this.lienRegistrationFee = null;
			}else{
				this.lienRegistrationFee = parseNumber(lienRegistrationFee);
			}
		}

		SaleCalculator.prototype.getLienRegistrationFee = function() {
			if(isNaN(parseFloat(this.lienRegistrationFee))){
				return;
			}

			return this.lienRegistrationFee;
		}
		
		SaleCalculator.prototype.setBankAdminFee = function(bankAdminFee) {
			this.bankAdminFee = parseNumber(bankAdminFee);
		}

		SaleCalculator.prototype.getBankAdminFee = function() {
			return this.bankAdminFee;
		}

		SaleCalculator.prototype.setDealerReserve = function(dealerReserve) {
			this.dealerReserve = parseNumber(dealerReserve);
		}

		SaleCalculator.prototype.getDealerReserve = function() {
			return this.dealerReserve;
		}

		SaleCalculator.prototype.setTradeLienPayout = function(tradeLienPayout) {
			this.tradeLienPayout = parseNumber(tradeLienPayout);
		}

		SaleCalculator.prototype.getTradeLienPayout = function() {
			return this.tradeLienPayout;
		}

		SaleCalculator.prototype.setWarrantyPrice = function(warrantyPrice) {
			this.warrantyPrice = parseNumber(warrantyPrice);
		}

		SaleCalculator.prototype.getWarrantyPrice = function() {
			return this.warrantyPrice;
		}

		SaleCalculator.prototype.setSaleExtras = function(saleExtras) {
			this.saleExtras = saleExtras;
		}

		SaleCalculator.prototype.setSalePackages = function(salePackages) {
			this.salePackages = salePackages;
		}

		SaleCalculator.prototype.setCostOfBorrowing = function(costOfBorrowing){
			this.costOfBorrowing = parseNumber(costOfBorrowing);;
		}

		SaleCalculator.prototype.getCostOfBorrowing = function() {
			return this.costOfBorrowing;
		}

		SaleCalculator.prototype.getTotalSaleExtrasPrice = function() {
			var totalSaleExtrasPrice = 0;

			if(!Array.isArray(this.saleExtras)){
				return totalSaleExtrasPrice;
			}

			this.saleExtras.forEach(function(extraItem){
				totalSaleExtrasPrice = GeneralTools.addToTotal(totalSaleExtrasPrice, extraItem.cost);
			})

			return totalSaleExtrasPrice;
		}

		SaleCalculator.prototype.getTotalSalePackagePrice = function() {
			var totalSalePackagesPrice = 0;

			if(!Array.isArray(this.salePackages)){
				return totalSalePackagesPrice;
			}

			this.salePackages.forEach(function(packageItem){
				totalSalePackagesPrice = GeneralTools.addToTotal(totalSalePackagesPrice, packageItem.price);
			})

			return totalSalePackagesPrice;
		}

		SaleCalculator.prototype.getTotalAccessoriesPrice = function(){
			const totalPrice = GeneralTools.addToTotal(this.getTotalSaleExtrasPrice(), this.getTotalSalePackagePrice());
			return GeneralTools.preciseNumber(totalPrice, 2);
		}

		SaleCalculator.prototype.setPromotions = function(promotions) {
			this.promotions = promotions;
		}

		SaleCalculator.prototype.getTotalPromotionsDiscountDetailList = function() {
			var subTotalForPromitions = 0;

			subTotalForPromitions = GeneralTools.addToTotal(subTotalForPromitions, this.getSalePrice());
			subTotalForPromitions = GeneralTools.addToTotal(subTotalForPromitions, this.getWarrantyPrice());
			subTotalForPromitions = GeneralTools.addToTotal(subTotalForPromitions, this.getFinanceApplicationFee());
			subTotalForPromitions = GeneralTools.addToTotal(subTotalForPromitions, this.getTotalSaleExtrasPrice());
			subTotalForPromitions = GeneralTools.addToTotal(subTotalForPromitions, this.getTotalSalePackagePrice());

			var percentagePromotions = [];
			var nonPercentagePromotions = [];
			var detailList = [];

			if(Array.isArray(this.promotions)){
				this.promotions.forEach(function(promotion){
					if(promotion.isPercentage()){
						percentagePromotions.push(promotion);
					}else{
						nonPercentagePromotions.push(promotion);
					}
				});
			}

			nonPercentagePromotions.forEach(function(promotion){
				var discountAmount = promotion.getDiscountAmount(subTotalForPromitions);

				subTotalForPromitions = GeneralTools.addToTotal(subTotalForPromitions, discountAmount * -1);

				detailList.push({
					promotion: promotion,
					discountAmount: discountAmount
				});
			})

			percentagePromotions.forEach(function(promotion){
				var discountAmount = promotion.getDiscountAmount(subTotalForPromitions);
				
				subTotalForPromitions = GeneralTools.addToTotal(subTotalForPromitions, discountAmount * -1);

				detailList.push({
					promotion: promotion,
					discountAmount: discountAmount
				});
			})

			return detailList;
		}

		SaleCalculator.prototype.getTotalPromotionsDiscount = function() {
			const detailList = this.getTotalPromotionsDiscountDetailList();

			if(!Array.isArray(detailList)){
				return totalDiscount;
			}

			return detailList.reduce(function(totalDiscount, detail){
				return GeneralTools.addToTotal(totalDiscount, detail.discountAmount);
			}, 0);
		}

		SaleCalculator.prototype.getOmvic = function() {
			return this.omvic
		}

		SaleCalculator.prototype.setOmvic = function(omvic) {
			this.omvic = parseNumber(omvic);
		}

		SaleCalculator.prototype.getSubTotalBeforeTradeIn = function() {
			var subTotal = 0;

			subTotal = GeneralTools.addToTotal(subTotal, this.getSalePrice());
			subTotal = GeneralTools.addToTotal(subTotal, this.getWarrantyPrice());
			subTotal = GeneralTools.addToTotal(subTotal, this.getFinanceApplicationFee());
			subTotal = GeneralTools.addToTotal(subTotal, this.getTotalSaleExtrasPrice());
			subTotal = GeneralTools.addToTotal(subTotal, this.getTotalSalePackagePrice());
			subTotal = GeneralTools.addToTotal(subTotal, this.getTotalPromotionsDiscount() * -1);
			subTotal = GeneralTools.addToTotal(subTotal, this.getSaleDiscount() * -1);

			return subTotal;
		}

		SaleCalculator.prototype.setTradeInPrice = function(tradeInPrice) {
			this.tradeInPrice = parseNumber(tradeInPrice);
		}

		SaleCalculator.prototype.getTradeInPrice = function() {
			return this.tradeInPrice;
		}

		SaleCalculator.prototype.setTaxRate = function(taxRate) {
			var rate = parseFloat(taxRate);

			if(isNaN(rate)){
				rate = ToolsConstants.taxRate;
			}

			this.taxRate = rate;
		}

		SaleCalculator.prototype.getTaxRate = function() {
			return this.taxRate;
		}

		SaleCalculator.prototype.getTax = function() {
			var subTotalForTax = GeneralTools.addToTotal(this.getSubTotalBeforeTradeIn(), this.getTradeInPrice() * -1);
			
			if(subTotalForTax < 0){
				return 0;
			}

			return GeneralTools.getHarmonizedSalesTax(subTotalForTax, this.getTaxRate());
		}

		SaleCalculator.prototype.setLicensingPrice = function(licensingPrice) {
			this.licensingPrice = licensingPrice;
		}

		SaleCalculator.prototype.getLicensingPrice = function() {
			return this.licensingPrice;
		}

		SaleCalculator.prototype.getSubTotalBeforePayments = function() {
			var subTotal = 0;

			subTotal = GeneralTools.addToTotal(subTotal, this.getSubTotalBeforeTradeIn());
			subTotal = GeneralTools.addToTotal(subTotal, this.getTradeInPrice() * -1);
			subTotal = GeneralTools.addToTotal(subTotal, this.getTax());
			subTotal = GeneralTools.addToTotal(subTotal, this.getLicensingPrice());
			subTotal = GeneralTools.addToTotal(subTotal, this.getLienRegistrationFee());
			subTotal = GeneralTools.addToTotal(subTotal, this.getBankAdminFee());
			subTotal = GeneralTools.addToTotal(subTotal, this.getTradeLienPayout());
			subTotal = GeneralTools.addToTotal(subTotal, this.getOmvic());

			return subTotal;
		}

		SaleCalculator.prototype.setPayments = function(payments) {
			this.payments = payments;
		}

		SaleCalculator.prototype.getTotalPaymentsPrice = function() {
			var totalPrice = 0;

			if(!Array.isArray(this.payments)){
				return totalPrice;
			}

			this.payments.forEach(function(payment){
				if(payment.fk_id_payment_method == 11 ){
					if(payment.message == "Approved"){
						totalPrice = GeneralTools.addToTotal(totalPrice, payment.amount);
					}
				}else{
					totalPrice = GeneralTools.addToTotal(totalPrice, payment.amount);
				}
				
			})
			
			return totalPrice;
		}

		SaleCalculator.prototype.getTotalAmountToBeFinanced = function() {
			return this.getSubTotalBeforePayments() - this.getTotalPaymentsPrice();
		}

		SaleCalculator.prototype.getTotalBalanceDue = function() {
			if(this.getLienRegistrationFee() != null){
				return this.getTotalAmountToBeFinanced() + this.getCostOfBorrowing();
			}

			return this.getSubTotalBeforePayments() - this.getTotalPaymentsPrice();
		}

		SaleCalculator.prototype.getTotalToBeDeposited = function() {
			var lienRegistrationFee = this.getLienRegistrationFee();

			if(typeof(lienRegistrationFee) != "number" || isNaN(lienRegistrationFee)){
				lienRegistrationFee = 0;
			}

			const totalToBeDeposited = this.getSubTotalBeforePayments() + this.getDealerReserve() - lienRegistrationFee - this.getBankAdminFee();
			return GeneralTools.preciseNumber(totalToBeDeposited, 2);
		}

		SaleCalculator.prototype.getTotalOwning = function() {
			const totalOwning = this.getTotalToBeDeposited() - this.getTotalPaymentsPrice();
			return GeneralTools.preciseNumber(totalOwning, 2);
		}

		function parseNumber(number){
			var parsedNumber = parseFloat(number);

			if(isNaN(parsedNumber)){
				return 0;
			}

			return parsedNumber
		}


		return SaleCalculator;
	}


})();
(function ()
{
	'use strict';

	angular
		.module("app.saleInfo")
		.factory("SalePromotion", SalePromotionClass)

	/** @ngInject */
	function SalePromotionClass()
	{	   
		function SalePromotion(){}

		SalePromotion.prototype.setAttributes = function (attributes) {
	 		var keyList = Object.keys(attributes);

	 		for(var i = 0; i < keyList.length; i++){
	 			var key = keyList[i];
	 			var value = attributes[key];

	 			this.setAttribute(key, value);
	 		}
		}

		SalePromotion.prototype.setAttribute = function (key, value) {
	 		this[key] = value;
		}

		SalePromotion.prototype.setResourceID = function (id) {
	 		this.id_sale_info_promotion = id;
		}

		SalePromotion.prototype.getResourceID = function () {
	 		return this.id_sale_info_promotion;
		}	

		SalePromotion.prototype.getDiscountAmount = function (originPrice) {
			if(this.discount_amount != null){
				return this.discount_amount; 
			}

			if(this.discount_percentage != null){
				return this.discount_percentage * originPrice; 
			}
		}		

		SalePromotion.prototype.isPercentage = function () {
			return this.discount_percentage != null;
		}

		SalePromotion.prototype.pullDataFromPromotionOption = function (promotionOption) {
			if(!promotionOption){
				return;
			}

			this.fk_id_promotion = promotionOption.getResourceID();
			this.name = promotionOption.name;
			this.description = promotionOption.description;
			this.is_percentage = promotionOption.is_percentage;

			if(promotionOption.is_percentage){
				this.discount_percentage = promotionOption.discount_percentage;
			} else {
				this.discount_amount = promotionOption.discount_amount;
			}
		}

		return SalePromotion;
	}


})();
(function ()
{
	'use strict';

	angular
		.module("app.saleInfo")
		.factory("PresetPromotion", PresetPromotionClass)

	/** @ngInject */
	function PresetPromotionClass()
	{	   
		function PresetPromotion(){}

		PresetPromotion.prototype.setAttributes = function (attributes) {
	 		var keyList = Object.keys(attributes);

	 		for(var i = 0; i < keyList.length; i++){
	 			var key = keyList[i];
	 			var value = attributes[key];

	 			this.setAttribute(key, value);
	 		}
		}

		PresetPromotion.prototype.setAttribute = function (key, value) {
	 		this[key] = value;
		}

		PresetPromotion.prototype.setResourceID = function (id) {
	 		this.id_promotion = id;
		}

		PresetPromotion.prototype.getResourceID = function () {
	 		return this.id_promotion;
		}	

		PresetPromotion.prototype.isExpired = function () {
			if(!this.expiry_date){
				return false;
			}

			if(moment(this.expiry_date).isValid() != true){
				return true;
			}

			return moment().isAfter(this.expiry_date, "date");
        }
        
        PresetPromotion.prototype.getExpiryDateMomentObj = function () {
            if(this.expiry_date){
                return moment(this.expiry_date);
            }
		}

		PresetPromotion.prototype.isPercentage = function () {
			return this.discount_percentage != null;
		}

		return PresetPromotion;
	}


})();
(function ()
{
	'use strict';

	angular
		.module("app.saleInfo")
		.factory("SalePresetExtras", SalePresetExtrasClass)

	/** @ngInject */
	function SalePresetExtrasClass()
	{	   
		function SalePresetExtras(){}

		SalePresetExtras.prototype.setAttributes = function (attributes) {
	 		var keyList = Object.keys(attributes);

	 		for(var i = 0; i < keyList.length; i++){
	 			var key = keyList[i];
	 			var value = attributes[key];

	 			this.setAttribute(key, value);
	 		}
		}

		SalePresetExtras.prototype.setAttribute = function (key, value) {
	 		this[key] = value;
		}

		SalePresetExtras.prototype.setResourceID = function (id) {
	 		this.id_preset_extras = id;
		}

		SalePresetExtras.prototype.getResourceID = function () {
	 		return this.id_preset_extras;
		}	

		SalePresetExtras.prototype.isExpired = function () {
			if(moment(this.expiry_date).isValid() != true){
				return true;
			}			
			return moment().isAfter(this.expiry_date, "date")
		}

		return SalePresetExtras;
	}


})();
(function ()
{
	'use strict';

	angular
		.module("app.saleInfo")
		.factory("SalePlateOption", SalePlateOptionClass)

	/** @ngInject */
	function SalePlateOptionClass()
	{	   
		function SalePlateOption(){}

		SalePlateOption.prototype.setAttributes = function (attributes) {
	 		var keyList = Object.keys(attributes);

	 		for(var i = 0; i < keyList.length; i++){
	 			var key = keyList[i];
	 			var value = attributes[key];

	 			this.setAttribute(key, value);
	 		}
		}

		SalePlateOption.prototype.setAttribute = function (key, value) {
	 		this[key] = value;
		}

		SalePlateOption.prototype.setResourceID = function (id) {
	 		this.id_plate_option = id;
		}

		SalePlateOption.prototype.getResourceID = function () {
	 		return this.id_plate_option;
		}	

		SalePlateOption.prototype.isExpired = function () {
			if(moment(this.expiry_date).isValid() != true){
				return true;
			}
			
			return moment().isAfter(this.expiry_date, "date")
		}

		return SalePlateOption;
	}


})();
(function ()
{
	'use strict';

	angular
		.module("app.saleInfo")
		.factory("BillOfSale", BillOfSaleClass)

	/** @ngInject */
	function BillOfSaleClass($filter, $state, api, ToolsFactory, Const, $q, MessageService, LoginService, SalePromotion, SaleInfo, TradeInVehicle, SalePlateOption, SalePresetExtras, Warranty, SaleInfoPayment, MyFile, SaleWarranty, SaleInfoService, CustomersService, GeneralTools, VehicleService, SaleCalculator, PurchaseInfoService, UserService)
	{
		const defaultFontStyle = "20px Arial";
		const dealerRegistrationNumber = "4880563";
		const hstNumber = 'HST: 875901308RT0001'

		function BillOfSale(vehicleID, saleInfoID, ignoreOptions){
			this.saleInfoID = saleInfoID;
			this.vehicleID = vehicleID;

			if(typeof(ignoreOptions) == "object"){
				this.ignoreOptions = ignoreOptions;
			} else {
				this.ignoreOptions = {};
			}			
		}

		BillOfSale.prototype.getSaleInfoID = function() {
			return this.saleInfoID
		}

		BillOfSale.prototype.getVehicleID = function() {
			return this.saleInfoID
		}

		BillOfSale.prototype.fetchDatas = function(){
			var defer = $q.defer();
			var _this = this;

			var saleInfoResourcePath = {
				companyID: LoginService.getCompanyID(),
				vehicleID: _this.vehicleID,
				saleinfoID: _this.saleInfoID
			}

			var vehicleResourcePath = {
				companyID: LoginService.getCompanyID(),
				vehicleID: _this.vehicleID
			}

			var tasks = {
				phoneCategories: 	CustomersService.getCachedPhoneCategories(),
				emailCategories: 	CustomersService.getCachedEmailCategories(),
				plateOptions: 		SaleInfoService.getCachedPlateOptions({companyID:LoginService.getCompanyID()}),
				vehicle: 			VehicleService.getVehicle(vehicleResourcePath),
				vehicleBrands: 		VehicleService.getCachedVehicleBrands(),
				saleInfo: 			SaleInfoService.getVehicleSaleInfos(saleInfoResourcePath),
				tradeInVehicle: 	SaleInfoService.getTradeInVehicles(saleInfoResourcePath),
				saleExtras: 		SaleInfoService.getSaleExtras(saleInfoResourcePath),
				salePackages: 		SaleInfoService.getSalePackages(saleInfoResourcePath).$promise,
				promotions: 		SaleInfoService.getSalePromotions(saleInfoResourcePath),
				payments: 			SaleInfoService.getSalePayments(saleInfoResourcePath),
				disclosures: 		SaleInfoService.getSaleDisclosures(saleInfoResourcePath)
			}

			$q.all(tasks)
				.then(function(result){
					if(result == null || !Array.isArray(result.saleInfo)){
						return $q.reject("Fail to get data.");
					}

					if(result.vehicle == null || !Array.isArray(result.vehicle.data)){
						return $q.reject("Vehicle data is invalid.");
					}

					_this.setEmailCategories(result.emailCategories);
					_this.setPayments(result.payments);
					_this.setPhoneCategories(result.phoneCategories);
					_this.setPlateOptions(result.plateOptions);
					_this.setSaleExtras(result.saleExtras);
					_this.setSalePackages(result.salePackages);
					_this.setPromotions(result.promotions);
					_this.setSaleInfo(result.saleInfo);
					_this.setTradeInVehicle(result.tradeInVehicle);
					_this.setVehicle(result.vehicle.data);
					_this.setVehicleBrands(result.vehicleBrands)
					_this.setDisclosures(result.disclosures);

					return getResourceBasedOnSaleInfoData(result.saleInfo[0], _this.vehicleID);
				})
				.then(function(resultBasedOnSaleInfo){

					if(resultBasedOnSaleInfo.customer == null || !Array.isArray(resultBasedOnSaleInfo.customer.data)){
						return $q.reject("Customer data is invalid.");
					}

					_this.setCustomer(resultBasedOnSaleInfo.customer.data);
					_this.setWarranty(resultBasedOnSaleInfo.warranty);
					_this.setSalePerson(resultBasedOnSaleInfo.salePerson);
					_this.setSaleManager(resultBasedOnSaleInfo.saleManager);
					
					defer.resolve(_this);
				})
				.catch(function(error){
					defer.reject(error);
					MessageService.showToast(error);
				});	

			return defer.promise;	
		}

		BillOfSale.prototype.open = function() {
			return this.fetchDatas()
				.then(function(billOfSaleData){
					return renderBillOfSaleTask(billOfSaleData);
				})
				.then(function(pdfMake){
					pdfMake.print();
					return $q.resolve();
				})
		}

		BillOfSale.prototype.getPdfFile = function() {
			var defer = $q.defer()

			this.fetchDatas()
				.then(function(billOfSaleData){
					return renderBillOfSaleTask(billOfSaleData);
				})
				.then(function(pdfMake){
					pdfMake.getBlob(function(blob){
						var file = new File([blob], "bill_of_sale.pdf", {type: "application/pdf"});
						defer.resolve(file);
					});
				})
				.catch(function(error){
					defer.reject(error);
				})

			return defer.promise;
		}

		BillOfSale.prototype.setSaleExtras = function(saleExtras) {
			if(this.ignoreOptions.extras){
				this.saleExtras = [];
			} else {
				this.saleExtras = saleExtras;
			}
		}

		BillOfSale.prototype.setSalePackages = function(salePackages) {
			if(this.ignoreOptions.packages){
				this.salePackages = [];
			} else {
				this.salePackages = salePackages;
			}
			
		}

		BillOfSale.prototype.setSaleManager = function(users) {
			if(!Array.isArray(users)){
				return;
			}

			this.saleManager = users[0];
		}

		BillOfSale.prototype.setCustomer = function(customer) {
			if(!Array.isArray(customer)){
				return;
			}

			this.customer = customer[0];
		}

		BillOfSale.prototype.setSalePerson = function(users) {
			if(!Array.isArray(users)){
				return;
			}

			this.salePerson = users[0];
		}

		BillOfSale.prototype.setWarranty = function(warranty) {
			if(!Array.isArray(warranty)){
				return;
			}

			if(!this.ignoreOptions.warranty){
				this.warranty = warranty[0];
			}
		}

		BillOfSale.prototype.setDisclosures = function(disclosures) {
			if(this.ignoreOptions.disclosures){
				this.disclosures = [];
			} else {
				this.disclosures = disclosures;
			}
		}

		BillOfSale.prototype.setVehicle = function(vehicle) {
			if(!Array.isArray(vehicle)){
				return;
			}

			this.vehicle = vehicle[0];
		}

		BillOfSale.prototype.setVehicleBrands = function(brands) {
			if(!Array.isArray(brands)){
				return;
			}

			this.vehicleBrands = brands;
		}

		BillOfSale.prototype.setTradeInVehicle = function(tradeInVehicle) {
			if(!Array.isArray(tradeInVehicle)){
				return;
			}

			if(!this.ignoreOptions.tradeIn){
				this.tradeInVehicle = tradeInVehicle[0];
			}		
		}

		BillOfSale.prototype.setSaleInfo = function(saleInfo) {
			if(!Array.isArray(saleInfo)){
				return;
			}

			this.saleInfo = saleInfo[0];

			if(this.ignoreOptions.financing){
				this.saleInfo.clearFinancingInfos();		
			}

			if(this.ignoreOptions.promotions){
				this.saleInfo.discount = 0;		
			}
		}

		BillOfSale.prototype.setPromotions = function(promotions) {
			if(this.ignoreOptions.promotions){
				this.promotions = [];
			} else {
				this.promotions = promotions;
			}
		}

		BillOfSale.prototype.setPresetExtras = function(presetExtras) {
			this.presetExtras = presetExtras;
		}

		BillOfSale.prototype.setPlateOptions = function(plateOptions) {
			this.plateOptions = plateOptions;
		}

		BillOfSale.prototype.setPhoneCategories = function(phoneCategories) {
			this.phoneCategories = phoneCategories;
		}

		BillOfSale.prototype.setPayments = function(payments) {
			this.payments = payments;
		}

		BillOfSale.prototype.setEmailCategories = function(emailCategories) {
			this.emailCategories = emailCategories;
		}

		BillOfSale.prototype.setCustomExtras = function(customExtras) {
			this.customExtras = customExtras;
		}

		function getResourceBasedOnSaleInfoData (saleInfo, vehicleID){
			var companyID = LoginService.getCompanyID();
			var tasks = {};

			if(saleInfo.getCustomerID() != null){
				var customerResourcePath = {
					companyID: companyID,
					customerID: saleInfo.getCustomerID(),
				}
				tasks.customer = CustomersService.getCustomers(customerResourcePath, null, null, null);
			}

			if(saleInfo.getWarrantyID() != null){
				var warrantyResourcePath = {
					companyID: companyID,
					vehicleID: vehicleID,
					saleinfoID: saleInfo.getResourceID(),
					warrantyID: saleInfo.getWarrantyID()
				}
				tasks.warranty = SaleInfoService.getSaleWarranties(warrantyResourcePath);
			}

			if(saleInfo.getWarrantyID() != null){
				var warrantyResourcePath = {
					companyID: companyID,
					vehicleID: vehicleID,
					saleinfoID: saleInfo.getResourceID(),
					warrantyID: saleInfo.getWarrantyID()
				}
				tasks.warranty = SaleInfoService.getSaleWarranties(warrantyResourcePath);
			}

			if(saleInfo.sold_by != null){
				var userResourcePath = {
					companyID: companyID,
					userID: saleInfo.sold_by
				}
				tasks.salePerson = UserService.getUsers(userResourcePath)
			}

			if(saleInfo.sale_manager != null){
				var userResourcePath = {
					companyID: companyID,
					userID: saleInfo.sale_manager
				}
				tasks.saleManager = UserService.getUsers(userResourcePath)
			}

			return $q.all(tasks)
		}

		function renderBillOfSaleTask(billOfSale){
			return getBillOfSalePatternCanvas()
				.then(function(pages){
					if(!pages){
						return $q.reject("Failed to get bill of sale image pattern");
					}
					var page1 = pages.page1;

					page1 = fillDatesSection(page1, billOfSale);
					page1 = fillPurchaserInfomation(page1, billOfSale);
					page1 = fillInsuranceInfomation(page1, billOfSale);
					page1 = fillTradeInVehicleInfomation(page1, billOfSale);
					page1 = fillComments(page1, billOfSale);
					page1 = fillVehicleInfomation(page1, billOfSale);
					page1 = fillSalePersonSection(page1, billOfSale);
					page1 = fillVendorSection(page1, billOfSale);
					page1 = fillWarrantyInfomation(page1, billOfSale);
					page1 = fillTermsOfFinancing(page1, billOfSale);
					page1 = fillTermsOfSettelmentSection(page1, billOfSale);

					return $q.resolve(pdfMake.createPdf(getPdfContent(page1, pages.page2)));
				})
				.catch(function(error){
					return $q.reject(error);
				});
		}

		function fillTermsOfFinancing(canvas, billOfSale) {
			if(!billOfSale || !billOfSale.saleInfo || !canvas){
				return canvas;
			}

			const saleInfoData = billOfSale.saleInfo;

			if(isNaN(parseFloat(saleInfoData.lien_registration))){
				return canvas;
			}

			var context = canvas.getContext('2d');	
			context.font = "20px Arial";

			fillTextOnCanvasContext($filter('currency')(saleInfoData.payment_amount, '$', 2), context, 595, 1147);
			fillTextOnCanvasContext(saleInfoData.number_of_payments, context, 775, 1147);
			fillTextOnCanvasContext(saleInfoData.payment_start_date, context, 587, 1177);
			fillTextOnCanvasContext(saleInfoData.creditApproval, context, 695, 1177);
			fillTextOnCanvasContext("✓", context, 798, 1236);

			return canvas;
		}

		function fillTermsOfSettelmentSection(canvas, billOfSale){
			if(billOfSale == null || billOfSale.saleInfo == null){
				return canvas;
			}

			var saleManagerData = billOfSale.saleManager;
			var context = canvas.getContext('2d');	
			context.font = "20px Arial";

			var saleCalculator = new SaleCalculator();

			var saleInfoData = billOfSale.saleInfo;

			saleCalculator.setSalePrice(saleInfoData.sale_price);
			saleCalculator.setOmvic(saleInfoData.omvic);
			saleCalculator.setTaxRate(saleInfoData.tax_rate);
			saleCalculator.setLicensingPrice(saleInfoData.licensing_fee);
			saleCalculator.setFinanceApplicationFee(saleInfoData.finance_application_fee);
			saleCalculator.setLienRegistrationFee(saleInfoData.lien_registration);
			saleCalculator.setBankAdminFee(saleInfoData.bank_admin_fee);
			saleCalculator.setCostOfBorrowing(saleInfoData.cost_of_borrowing);
			saleCalculator.setDealerReserve(saleInfoData.dealer_reserve);
			saleCalculator.setSaleDiscount(saleInfoData.discount);

			if(billOfSale.warranty != null){
				saleCalculator.setWarrantyPrice(billOfSale.warranty.retail);
				fillTextOnCanvasContext($filter('currency')(billOfSale.warranty.retail, '$', 2), context, 1113, 629);
			}

			if(billOfSale.tradeInVehicle != null){
				fillTextOnCanvasContext($filter('currency')(billOfSale.tradeInVehicle.trade_in_price, '$', 2), context, 1114, 901);
				saleCalculator.setTradeInPrice(billOfSale.tradeInVehicle.trade_in_price);
				saleCalculator.setTradeLienPayout(billOfSale.tradeInVehicle.trade_lien_payout);
			}

			saleCalculator.setSalePackages(billOfSale.salePackages);
			saleCalculator.setSaleExtras(billOfSale.saleExtras);
			saleCalculator.setPromotions(billOfSale.promotions);
			saleCalculator.setPayments(billOfSale.payments);

			fillTextOnCanvasContext($filter('currency')(saleInfoData.sale_price, '$', 2), context, 1114, 595);
			fillTextOnCanvasContext($filter('currency')(saleCalculator.getSubTotalBeforeTradeIn(), '$', 2), context, 1114, 865);
			fillTextOnCanvasContext($filter('currency')(saleCalculator.getTax(), '$', 2), context, 1114, 967);
			fillTextOnCanvasContext($filter('currency')(saleCalculator.getLicensingPrice(), '$', 2), context, 1114, 1035);
			fillTextOnCanvasContext($filter('currency')(saleCalculator.getTradeLienPayout(), '$', 2), context, 1114, 1100);
			fillTextOnCanvasContext($filter('currency')(saleCalculator.getSubTotalBeforePayments(), '$', 2), context, 1114, 1170);
			fillTextOnCanvasContext($filter('currency')(saleCalculator.getTotalPaymentsPrice(), '$', 2), context, 1114, 1205);

			if(saleInfoData.bank_admin_fee){
				context.font = "12px Arial";
				fillTextOnCanvasContext("BANK ADMIN FEE", context, 908, 1337);
				context.font = "20px Arial";
				fillTextOnCanvasContext($filter('currency')(saleInfoData.bank_admin_fee, '$', 2), context, 1114, 1339);
			}

			context.font = "12px Arial";
			fillTextOnCanvasContext("OMVIC", context, 908, 1066);
			context.font = "20px Arial";
			fillTextOnCanvasContext($filter('currency')(saleCalculator.getOmvic(), '$', 2), context, 1114, 1068);

			if(!isNaN(parseFloat(saleInfoData.lien_registration))){
				fillTextOnCanvasContext($filter('currency')(saleInfoData.lien_registration, '$', 2), context, 1114, 1374);
				fillTextOnCanvasContext($filter('currency')(saleCalculator.getTotalAmountToBeFinanced(), '$', 2), context, 1114, 1441);
				fillTextOnCanvasContext($filter('number')(saleInfoData.interest_rate * 100, 2), context, 1025, 1473);
				fillTextOnCanvasContext($filter('currency')(saleInfoData.cost_of_borrowing, '$', 2), context, 1114, 1473);
			}

			context.font = "25px Arial";
			fillTextOnCanvasContext($filter('number')(saleCalculator.getTotalBalanceDue(), 2), context, 1054, 1518);

			canvas = fillSettleItems(canvas, billOfSale, saleCalculator);

			return canvas;
		}

		function fillSettleItems (canvas, billOfSale, saleCalculator){
			if(billOfSale == null ){
				return canvas;
			}

			var settlementItems = [];
			
			var yPosition = 663;
			var hightOfItem = 10;
			var margin = 25;
			var totalHight = 170;
			
			if(billOfSale.saleInfo && billOfSale.saleInfo.finance_application_fee){
				settlementItems.push({name : "Finance Application Fee", cost: billOfSale.saleInfo.finance_application_fee});
			}

			if(Array.isArray(billOfSale.saleExtras)){
				billOfSale.saleExtras.forEach(function(saleExtra){
					settlementItems.push({name : saleExtra.name, cost: saleExtra.cost});
				});
			}

			if(Array.isArray(billOfSale.salePackages)){
				billOfSale.salePackages.forEach(function(salePackage){
					settlementItems.push({name : salePackage.name, cost: salePackage.price});
				});
			}

			if((Array.isArray(billOfSale.promotions) && billOfSale.promotions.length > 0) || billOfSale.saleInfo.discount){
				const totalDiscount = GeneralTools.addToTotal(saleCalculator.getTotalPromotionsDiscount(), billOfSale.saleInfo.discount);

				settlementItems.push({name : "Custom Discounts", cost: -1 * totalDiscount});
			}

			if(settlementItems.length > 6){
				var hightOfAllItem = settlementItems.length * hightOfItem;	
				var hightOfAllMargin = totalHight - hightOfAllItem;

				margin = hightOfAllMargin/(settlementItems.length - 1);
			}

			var contextForNumber = canvas.getContext('2d');	
			contextForNumber.font = "20px Arial";

			settlementItems.forEach(function(item){
				fillTextOnCanvasContext($filter('currency')(item.cost, '$', 2), contextForNumber, 1113, yPosition);

				yPosition += margin + hightOfItem;
			})

			var contextForText = canvas.getContext('2d');	
			contextForText.font = "15px Arial";
			yPosition = 663;

			settlementItems.forEach(function(item){
				fillTextOnCanvasContext(item.name, contextForText, 908, yPosition);

				yPosition += margin + hightOfItem;
			})

			return canvas;
		}

		function fillVendorSection(canvas, billOfSale){
			if(billOfSale == null || billOfSale.saleManager == null){
				return canvas;
			}

			var saleManagerData = billOfSale.saleManager;
			var context = canvas.getContext('2d');	
			context.font = defaultFontStyle;

			fillTextOnCanvasContext(saleManagerData.first_name + ' ' + saleManagerData.last_name, context, 235, 1571);
			fillTextOnCanvasContext(dealerRegistrationNumber, context, 48, 1571);
			fillTextOnCanvasContext(hstNumber, context, 1008, 185);
			

			if(billOfSale.saleInfo != null && billOfSale.saleInfo.getSaleDateMomentObj() != null){
				fillTextOnCanvasContext(billOfSale.saleInfo.getSaleDateMomentObj().format("YYYY-MM-DD"), context, 48, 1670);
			}

			return canvas;
		}

		function fillSalePersonSection(canvas, billOfSale){
			if(billOfSale == null || billOfSale.salePerson == null){
				return canvas;
			}

			var salePersonData = billOfSale.salePerson;
			var context = canvas.getContext('2d');	
			context.font = defaultFontStyle;

			fillTextOnCanvasContext(salePersonData.first_name + ' ' + salePersonData.last_name, context, 48, 1452);
			fillTextOnCanvasContext(salePersonData.registration_number, context, 361, 1452);


			return canvas;
		}

		function fillDatesSection(canvas, billOfSale){
			if(billOfSale == null || billOfSale.saleInfo == null){
				return canvas;
			}

			var saleInfoData = billOfSale.saleInfo;
			var context = canvas.getContext('2d');	
			context.font = "25px Arial";

			var saleDate = saleInfoData.getSaleDateMomentObj();
			if(saleDate != null){
				fillTextOnCanvasContext(saleDate.date(), context, 1021, 278);
				fillTextOnCanvasContext(saleDate.months() + 1, context, 1097, 278);
				fillTextOnCanvasContext(saleDate.year(), context, 1170, 278);
			}

			return canvas;
		}

		function fillWarrantyInfomation(canvas, billOfSale){
			var context = canvas.getContext('2d');	
			context.font = defaultFontStyle;

			if(billOfSale == null || billOfSale.warranty == null){
				fillTextOnCanvasContext('x', context, 850, 809);
				return canvas;
			}

			var warrantyData = billOfSale.warranty;

			fillTextOnCanvasContext('x', context, 800, 809);
			fillTextOnCanvasContext($filter('number')(warrantyData.retail, 2), context, 800, 849);
			fillTextOnCanvasContext(warrantyData.provider, context, 578, 881);
			fillTextOnCanvasContext(warrantyData.duration_month, context, 501, 918);
			fillTextOnCanvasContext(warrantyData.name, context, 602, 959);

			writeLines(context, warrantyData.description, 497, 986, 40, 33);

			if(warrantyData.duration_mileage == null){
				fillTextOnCanvasContext("Unlimited", context, 670, 918);
			}else{
				fillTextOnCanvasContext($filter("number")(warrantyData.duration_mileage, 0), context, 670, 918);
			}

			return canvas;
		}


		function writeLines(context, contentString, startXPosition, startYPosition, maxCharPerLine, lineHight) {
			var currentYPosition = startYPosition;
			var words = contentString ? contentString.split(' ') : [];
			var lines = [''];

			words.forEach(function(word){
				if(!word){
					return;
				}

				var lastLineIndex = lines.length - 1;
				var lastLine = lines[lastLineIndex];
				var charsInCurrentLine = lastLine.length;

				if((charsInCurrentLine + word.length ) > maxCharPerLine){
					lines.push(word);
				}else{
					lines[lastLineIndex] = lastLine? (lastLine + ' ' + word ): word;
				}
			})

			lines.forEach(function(line){
				fillTextOnCanvasContext(line, context, startXPosition, currentYPosition);
				currentYPosition += lineHight;
			});
		}

		function fillVehicleInfomation(canvas, billOfSale){
			if(!billOfSale|| !billOfSale.vehicle || !billOfSale.saleInfo){
				return canvas;
			}

			var vehicleData = billOfSale.vehicle;
			var saleInfoData = billOfSale.saleInfo;
			var context = canvas.getContext('2d');

			context.font = "17px Arial";

			if(saleInfoData.getDeliveryDueDateMomentObj() != null){
				fillTextOnCanvasContext(saleInfoData.getDeliveryDueDateMomentObj().format("dddd, MMMM Do YYYY"), context, 856, 491);
			}

			fillTextOnCanvasContext(vehicleData.year, context, 647, 344);
			fillTextOnCanvasContext(vehicleData.make, context, 697, 344);
			fillTextOnCanvasContext(vehicleData.model, context, 837, 344);
			fillTextOnCanvasContext(vehicleData.exterior_color, context, 1072, 344);
			
			fillTextOnCanvasContext('x', context, 747, 412);

			var vehicleBrand = billOfSale.vehicleBrands.find(function(brand){
				return brand.id_vehicle_brand == vehicleData.fk_id_vehicle_brand;
			})

			if(vehicleBrand){
				fillTextOnCanvasContext(vehicleBrand.name, context, 1039, 535);
			}

			var contextForStockNumber = canvas.getContext('2d');
			contextForStockNumber.font = "12px Arial";;
			fillTextOnCanvasContext(vehicleData.stock_number, contextForStockNumber, 1153, 344);



			var contextForLargeFont = canvas.getContext('2d');
			contextForLargeFont.font = "18px Arial";

			var vinStartPoint = 650;

			if(vehicleData.vin){
				for(var i = 0; i < vehicleData.vin.length; i++){
					var char = vehicleData.vin.charAt(i);
					fillTextOnCanvasContext(char, contextForLargeFont, vinStartPoint, 389);
					vinStartPoint += 35;
				}
			}

			var mileageStartPoint = 650;

			if(saleInfoData.mileage && saleInfoData.mileage.toString().length < 6){
				mileageStartPoint = mileageStartPoint + (6 - saleInfoData.mileage.toString().length) * 32;
			}

			fillTextOnCanvasContext(insertSpaceInString(saleInfoData.mileage), contextForLargeFont, mileageStartPoint, 450);

			if(vehicleData.is_certified){
				fillTextOnCanvasContext('x', context, 857, 516);
			}else {
				fillTextOnCanvasContext('x', context, 857, 538);
			}		

			return canvas;
		}

		function fillComments(canvas, billOfSale){
			if(billOfSale == null){
				return canvas;
			}

			var context = canvas.getContext('2d');
			var yPosition = 1003;

			context.font = defaultFontStyle;

			var commentItems = [];

			if(billOfSale.warranty == null){
				commentItems.push("Extented warranty declined")
			}

			if(Array.isArray(billOfSale.disclosures)){
				billOfSale.disclosures.forEach(function(disclosure){
					var item = '';

					if(disclosure.description){
						item += disclosure.description;
					}

					if(disclosure.amount){
						item += " " + $filter('currency')(disclosure.amount, '$', 2);
					}

					commentItems.push(item);
				})
			}

			commentItems.forEach(function(item){
				fillTextOnCanvasContext(item, context, 48, yPosition);
				yPosition += 35;
			});

			return canvas;
		}

		function fillTradeInVehicleInfomation(canvas, billOfSale){
			if(billOfSale == null || billOfSale.tradeInVehicle == null){
				return canvas;
			}

			var tradeInVehicleData = billOfSale.tradeInVehicle;
			var context = canvas.getContext('2d');	
			context.font = "17px Arial";

			fillTextOnCanvasContext(tradeInVehicleData.year, context, 48, 740);
			fillTextOnCanvasContext(tradeInVehicleData.make, context, 97, 740);
			fillTextOnCanvasContext(tradeInVehicleData.model, context, 231, 740);
			fillTextOnCanvasContext(tradeInVehicleData.color, context, 429, 740);
			fillTextOnCanvasContext('x', context, 281, 827);

			var mileageStartPoint = 55;
			if(tradeInVehicleData.mileage && tradeInVehicleData.mileage.toString().length < 6){
				mileageStartPoint = mileageStartPoint + (6 - tradeInVehicleData.mileage.toString().length) * 32;
			}
			fillTextOnCanvasContext(insertSpaceInString(tradeInVehicleData.mileage), context, mileageStartPoint, 833);

			var vinStartPoint = 46;

			if(tradeInVehicleData.vin){
				for(var i = 0; i < tradeInVehicleData.vin.length; i++){
					var char = tradeInVehicleData.vin.charAt(i);
					fillTextOnCanvasContext(char, context, vinStartPoint, 777);
					vinStartPoint += 26;
				}
			}

			return canvas;
		}

		function insertSpaceInString(string){
			if(string == null){
				return;
			}

			string = string.toString();

			var stringWithSpace = '';

			for(var i = 0; i < string.length; i++){
				var currentCharactor = string[i];

				stringWithSpace += currentCharactor + "     "
			}

			return stringWithSpace;
		}

		function fillInsuranceInfomation(canvas, billOfSale){
			if(billOfSale == null || billOfSale.customer == null){
				return canvas;
			}

			var customerData = billOfSale.customer;
			var context = canvas.getContext('2d');	
			context.font = defaultFontStyle;

			fillTextOnCanvasContext(customerData.insurance_company, context, 192, 605);
			fillTextOnCanvasContext(customerData.policy_number, context, 103, 639);

			return canvas;
		}

		function fillPurchaserInfomation(canvas, billOfSale){
			if(billOfSale == null || billOfSale.customer == null){
				return canvas;
			}
			var customerData = billOfSale.customer;
			var phoneCategories = billOfSale.phoneCategories;
			var context = canvas.getContext('2d');	
			var fullName = customerData.first_name + ' ' + customerData.last_name;

			context.font = defaultFontStyle;

			const address = GeneralTools.stringConnector(customerData.address_street_number, customerData.address_street, ' ');

			fillTextOnCanvasContext(customerData.first_name, context, 130, 344);
			fillTextOnCanvasContext(customerData.last_name, context, 430, 344);
			fillTextOnCanvasContext(address, context, 48, 386);
			fillTextOnCanvasContext(customerData.address_city, context, 48, 428);
			fillTextOnCanvasContext(customerData.address_province, context, 344, 428);
			fillTextOnCanvasContext(customerData.address_postal_code, context, 492, 428);
			fillTextOnCanvasContext(getDefaultPhoneNumberString(customerData.phone_numbers, phoneCategories), context, 48, 472);
			fillTextOnCanvasContext(customerData.drivers_license, context, 48, 507);
			fillTextOnCanvasContext(customerData.license_expiry_date, context, 466, 507);

			if(Array.isArray(customerData.emails) && customerData.emails[0] != null){
				fillTextOnCanvasContext(customerData.emails[0].email_address, context, 48, 540);
			}

			return canvas;	
		}

		function getDefaultPhoneNumberString(phoneNumbers, phoneCategories){
			var defaultPhoneNumber;
			var phoneNumberString = '';

			if(!Array.isArray(phoneNumbers)){
				return phoneNumberString;
			}

			if(!Array.isArray(phoneCategories)){
				return GeneralTools.stringToPhoneNumberString(phoneNumbers[0]);
			}

			phoneCategories.some(function(category){

				defaultPhoneNumber =  phoneNumbers.find(function(phoneNumber){
					return phoneNumber.fk_id_phone_category == category.id_phone_category;
				});

				if(defaultPhoneNumber != null){
					phoneNumberString = GeneralTools.stringToPhoneNumberString(defaultPhoneNumber.phone_number) + ' (' + category.category + ')'
					return true;
				}

				return false
			});

			if(defaultPhoneNumber == null){
				return GeneralTools.stringToPhoneNumberString(phoneNumbers[0].phone_number);
			}

			return phoneNumberString;
		}	

		function fillTextOnCanvasContext(text, context, xPosition, yPosition){
			if(text == null || context == null){
				return;
			}

			context.fillText(text, xPosition, yPosition);
		}

		function getPdfContent(page1, page2){
			return {
				pageSize: 'LETTER', //pageSize: { width: 612.00, height: 792.00},
				//pageMargins: [16, -20, 0, 0]
				content: [
					{	
						margin: [ 0, -70, 0, 0 ],
						image: page1.toDataURL("image/jpg", 1.0),
						fit: [612, 792],
						pageBreak: "after"
					},
					{	
						margin: [ 0, -35, 0, 0 ],
						image: page2.toDataURL("image/jpg", 1.0),
						fit: [612, 792]
					}
				],
				defaultStyle: {
					alignment: "center"
				}
        	};
		}

		function getBillOfSalePatternCanvas(){
			var tasks = {
				page1: GeneralTools.getCanvas("assets/images/billofsales/page_1.jpg", 1275, 1750),
				page2: GeneralTools.getCanvas("assets/images/billofsales/page_2.jpg", 1275, 1750),
			}

    		return $q.all(tasks);
		}

		return BillOfSale;
	}


})();
(function ()
{
	'use strict';

	angular
		.module('app.safety')
		.service("SafetyService", SafetyService);

	/** @ngInject */
	function SafetyService($state, api, ToolsFactory, Const, $q, MessageService, LoginService, $filter, FinanceApplication, Safety, ConstantCacheService)
	{   
		var codeKey = Const.header.code;
		var messageKey = Const.header.message;
		var successCode = Const.code.success;

		this.updateSafetyRequestBodyGenerator = function(currentSafety, originSafety){
			if(currentSafety == null || originSafety == null){
				return;
			}

			var keyList = Object.keys(currentSafety);
			var changedProperties = {};

			keyList.forEach(function(key){
				var currentValue = currentSafety[key];
				var originValue = originSafety[key];

				if(currentValue == originValue){
					return;
				}

				changedProperties[key] = currentValue;
			});

			return changedProperties;
		}

		this.updateSafety = function(resourcePath, requestBody){
			var defer = $q.defer();

			api.safety.updateSafety(
				resourcePath,
				requestBody,
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);

						defer.reject(errorMessage);
						return;
					}
					defer.resolve(response);

				},
				function(error){
					console.error(error);
					defer.reject("Failed to update safety.");
				}
			);	

			return defer.promise;			
		}	

		this.createSafety = function(resourcePath, requestBody){
			var defer = $q.defer();

			api.safety.createSafety(
				resourcePath,
				requestBody,
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);

						defer.reject(errorMessage);
						return;
					}
					defer.resolve(response.data);

				},
				function(error){
					console.error(error);
					defer.reject("Failed to create safety.");
				}
			);	

			return defer.promise;			
		}


		this.getSafeties = function(resourcePath){
			var defer = $q.defer();

			api.safety.getSafeties(
				resourcePath,
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);

						defer.reject(errorMessage);
						return;
					}

					var safetyList = [];

					response.forEach(function(resourceData){
						var safety = new Safety();
						safety.setAttributes(resourceData);

						safetyList.push(safety);
					})

					defer.resolve(safetyList);
				},
				function(error){
					console.error(error);
					defer.reject("Failed to get safeties");
				}
			);	

			return defer.promise;			
		}

		this.deleteSafety = function(resourcePath){
			var defer = $q.defer();

			api.safety.deleteSafety(
				resourcePath,
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);
						defer.reject(errorMessage);
						return;
					}

					defer.resolve(response);
				},
				function(error){
					console.error(error);
					defer.reject("Failed to delete safety");
				}
			);

			return defer.promise;
		}

		this.getSafetyImages = function(resourcePath){
			var defer = $q.defer();

			api.safetyImages.getImages(
				resourcePath,
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);

						defer.reject(errorMessage);
						return;
					}

					defer.resolve(response);
				},
				function(error){
					console.error(error);
					defer.reject("Failed to get safeties");
				}
			);	

			return defer.promise;			
		}


		this.deleteSafetyImage = function(resourcePath){
			var defer = $q.defer();

			api.safetyImages.deleteImage(
				resourcePath,
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);

						defer.reject(errorMessage);
						return;
					}

					defer.resolve(response);
				},
				function(error){
					console.error(error);
					defer.reject("Failed to delete safety image");
				}
			);	

			return defer.promise;			
		}

		this.getSafetyImageTags = function(){
			var defer = $q.defer();

			api.getConstants.getSafetyImageTags.get(
				{},
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);

						defer.reject(errorMessage);
						return;
					}
					defer.resolve(response);

				},
				function(error){
					console.error(error);
					defer.reject("Fail to get safety image tags.");
				}
			);	

			return defer.promise;			
		}

		this.getCachedSafetyImageTags = function () {
			return ConstantCacheService.get('safety_image_tags', function () {
				return this.getSafetyImageTags();
			}.bind(this));
		}
	}
})();
(function ()
{
	'use strict';

	angular
		.module('app.safety')
		.controller('EditSafetyController', EditSafetyController);

	function EditSafetyController($scope, $stateParams, $state, vehicle, Vehicle, MessageService, ProgressService, Safety, safety, LoginService, SafetyService, DialogService, VehicleConstants, SafetyReport, TaskConstants, FileUploadService, $sce, ImageCompresser, imageTags, images, LightGalleryService){   
		var vm = this;
		var originSafety;

		vm.save = save;
		vm.deleteSafety = deleteSafety;
		vm.printSafetyReport = printSafetyReport;
		vm.deleteImage = deleteImage;
		//vm.openGallery = openGallery;

		init();

		function init(){
			initImages();
			initImageUploader();
			initSafety();
			initVehicle();
		}

/*		vm.videoUploader = FileUploadService.getNewUploader();

		function initGoogleApi(){
			gapi.load("client:auth2", loadClientLibrary);
		}

		var GoogleAuth;

		var param ={
			apiKey: 'AIzaSyDYOloUroCOyVJBwEB5nK2Ifgya3RTJJTM',
			discoveryDocs: ['https://www.googleapis.com/discovery/v1/apis/gmail/v1/rest'],
			scope: "https://mail.google.com/",
			clientId:"775540318999-m65h5qk9skualddtglgaqgva6i8m0n63.apps.googleusercontent.com"
		}

		function loadClientLibrary (){
			gapi.client.init(param).then(function(){
				GoogleAuth = gapi.auth2.getAuthInstance();
				console.log(GoogleAuth)
			})
		}

		vm.auth = function() {
			GoogleAuth.grantOfflineAccess()
				.then(function(authResult){
					console.log(authResult)

					//{code:"4/JwHaTgX3av8nHKNsKpC4OqvuARhgk9RHMt87lnOS9KWJnuCI99JTkA0yAlCwiHZQA6KG0rJ7sOh9EmALEkjTulY"}
				});
		}*/

/*		vm.videoUploader.onAfterAddingFile = function(fileItem){
			var user = GoogleAuth.currentUser.get();
			var token = user.getAuthResponse().access_token;

			var invocation = new XMLHttpRequest();
			

			invocation.onloadstart = function(param){
				console.log("onloadstart", param)
			}
			invocation.onprogress = function(param){
				console.log("onprogress", param)
			}
			invocation.onabort = function(param){
				console.log("onabort", param)
			}
			invocation.onerror = function(param){
				console.log("onerror", param)
			}
			invocation.onload = function(param){
				console.log("onload", param)
			}
			invocation.ontimeout = function(param){
				console.log("ontimeout", param)
			}
			invocation.onloadend = function(param){
				console.log("onloadend", param)
				console.log("response", JSON.parse(invocation.response))				
			}

			var parameters = JSON.stringify({
				snippet: { "title": "testing123"  }
			});

			var jsonBlob = new Blob([ parameters ], { "type" : "application\/json" });

			var formData = new FormData();
			formData.append("snippet", jsonBlob, "file.json");
			formData.append("file", fileItem._file);

			invocation.open('POST', "https://www.googleapis.com/upload/youtube/v3/videos?part=snippet", true);
			invocation.setRequestHeader('Authorization', 'Bearer ' + "ya29.GlzpBsDfPTSrQnV0mQKBmtzW6t1_yVGDGqT-Mo_9RHn2ST8yJmH1jmkYiTfux-4oWGiMo3-JrLZyBzAQaI5cXiiQgat3PgFYFPaSnWK6Iv_7XEX2d0PL1MExomHBZQ");
			invocation.send(formData);
		}
*/
/*		function openGallery(){
			lightGallery(document.getElementById('video-gallery'), {
			    videojs: true
			}); 
		}*/

		function initImages(){
			if(!Array.isArray(images) || !Array.isArray(imageTags)){
				return;
			}

			vm.imageList = imageTags.map(function(tag){
				var listItem = {};

				listItem.tag = tag;

				listItem.images = images.filter(function(image){
					return image.fk_id_safety_image_tag == tag.id_safety_image_tag;
				})

				if(!Array.isArray(listItem.images)){
					listItem.images = [];
				}

				return listItem;
			});
		}

		function initImageUploader(){
			vm.imageUploader = FileUploadService.getNewUploader();
			vm.imageUploader.filters.push(FileUploadService.getImageFilter());
			vm.imageUploader.filters.push(FileUploadService.getSizeFilter(20));
		}

		function initVehicle(){
			if(vehicle == null || !Array.isArray(vehicle.data) || vehicle.data[0] == null){
				MessageService.showToast("Vehicle data is invalid");
				$state.go("app.homepage")
				return;
			}

			vm.vehicle = vehicle.data[0];
			vm.vehiclePageUrl = $state.href('app.vehicle.safety', {vehicleID: vm.vehicle.getResourceID()});
		}

		function initSafety(){
			if(!Array.isArray(safety) || safety[0] == null){
				MessageService.showToast("Safety data is invalid");
				$state.go("app.homepage");
				return;
			}

			vm.safety = safety[0];
			originSafety = angular.copy(vm.safety);
		}

		function deleteSafety(){
			var dialogOptions = {};

			dialogOptions.titleString = "Delete safety";
			dialogOptions.contentString = "Are you sure to delete this safety?";

			var confirmOption = {};

			confirmOption.optionName = "YES";
			confirmOption.onClick = function(){
				confirmDeleteSafetyCallback();
				DialogService.close();
			}

			var cancelOption = {};

			cancelOption.optionName = "NO";
			cancelOption.onClick = function(){
				DialogService.close();
			}

			dialogOptions.options = [confirmOption, cancelOption];

			DialogService.showOptionsDialog(dialogOptions);
		}

		function confirmDeleteSafetyCallback (){
			var resourcePath = {
				companyID: LoginService.getCompanyID(),
				vehicleID: vm.vehicle.getResourceID(),
				safetyID: vm.safety.getResourceID()
			}

			vm.isProcessingData = true;
			ProgressService.setMode("indeterminate");
			ProgressService.isVisble(true);

			SafetyService.deleteSafety(resourcePath)
				.then(function(response){
					MessageService.showToast("Safety is deleted.");
					$state.go("app.vehicle.safety", {vehicleID: vm.vehicle.getResourceID()});
				})
				.catch(MessageService.showToast)
				.finally(function(){
					vm.isProcessingData = false;
					ProgressService.isVisble(false);
				})
		}

		function save (){
			if(!isAllFormValid()){
				return;
			}

			var requestBody = SafetyService.updateSafetyRequestBodyGenerator(vm.safety, originSafety);

			if(requestBody == null || Object.keys(requestBody).length <= 0){
				MessageService.showToast("No changes detected");
				return;
			}

			var resourcePath = {
				companyID: LoginService.getCompanyID(),
				vehicleID: vm.vehicle.getResourceID(),
				safetyID: vm.safety.getResourceID()
			}

			vm.isProcessingData = true;
			ProgressService.setMode("indeterminate");
			ProgressService.isVisble(true);

			SafetyService.updateSafety(resourcePath, requestBody)
				.then(function(response){
					MessageService.showToast("Success");
					originSafety = angular.copy(vm.safety);
				})
				.catch(MessageService.showToast)
				.finally(function(){
					vm.isProcessingData = false;
					ProgressService.isVisble(false);
				});
		}

		function isAllFormValid(){
			if(!vm.frontLeftConnerInfoFormValid()){
				MessageService.showToast("Please make sure front left conner form is valid");
				return false;
			}

			if(!vm.frontRightConnerInfoFormValid()){
				MessageService.showToast("Please make sure front right conner form is valid");
				return false;
			}

			if(!vm.rearLeftConnerInfoFormValid()){
				MessageService.showToast("Please make sure rear left conner form is valid");
				return false;
			}

			if(!vm.rearRightConnerInfoFormValid()){
				MessageService.showToast("Please make sure rear right conner form is valid");
				return false;
			}

			if(!vm.isGeneralFormValid()){
				MessageService.showToast("Please make sure general form is valid");
				return false;
			}

			return true;
		}

		function printSafetyReport(){
			var safetyReport = new SafetyReport(vm.safety.getResourceID(),vm.vehicle.getResourceID());

			ProgressService.setMode("indeterminate");
			ProgressService.isVisble(true);

			safetyReport.open()
				.then(function(){
					MessageService.showToast("Safety report is opened");
				})
				.catch(MessageService.showToast)
				.finally(function(){
					ProgressService.isVisble(false);
				});
		}

		vm.imageUploader.onAfterAddingFile = function(fileItem){
/*			var resumable = new Resumable({
				target:FileUploadService.getUrlForCreateSafetyImage(vm.vehicle.getResourceID(), vm.safety.getResourceID()),
				headers:{token:LoginService.getToken()},
				query: {tag:"sometag"},
				testChunks: false,
				generateUniqueIdentifier:function(param){
					return uuid.v4();
				}
			});


			resumable.on('fileSuccess', function(file){
				console.log("fileSuccess", file)
			});

			resumable.on('fileProgress', function(file){
				console.log("fileProgress", file)
			});

			resumable.on('fileAdded', function(file){
				console.log("fileAdded", file)

				resumable.upload();
			});

			resumable.on('fileRetry', function(file){
				console.log("fileRetry", file)
			});

			resumable.on('fileError', function(file, message){
				console.log("fileError", {message:message, file:file})
			});

			resumable.on('complete', function(){
				console.log("complete")
			});

			resumable.on('progress', function(){
				console.log("progress")
			});

			resumable.on('error', function(message, file){
				console.log("error", {message:message, file:file})
			});

			resumable.on('pause', function(){
				console.log("pause")
			});

			resumable.on('cancel', function(){
				console.log("cancel")
			});

			resumable.addFile(fileItem._file);*/
			

			var imageCompresser = new ImageCompresser(); 

			var url = URL.createObjectURL(fileItem._file);
			fileItem.imageSrc = $sce.trustAsResourceUrl(url);

			imageCompresser.photo(fileItem._file, 1024, "file", false, function(file){
				fileItem._file 		= file;
				fileItem.file.size 	= file.size;
				fileItem.url 		= FileUploadService.getUrlForCreateSafetyImage(vm.vehicle.getResourceID(), vm.safety.getResourceID());	
				fileItem.formData 	= [{tag:fileItem.tag}];	
				fileItem.upload();
			});
		}

		vm.imageUploader.onCompleteItem = function(item, response, status, headers){
			if(!FileUploadService.isUploadSuccess(headers)){
				MessageService.showToast(headers.message);
				return;
			}

			var resourcePath = {
         		companyID: LoginService.getCompanyID(),
        		vehicleID: vm.vehicle.getResourceID(),
        		safetyID: vm.safety.getResourceID(),
        		imageID: response.data
         	}

         	SafetyService.getSafetyImages(resourcePath)
         		.then(function(images){
         			if(!Array.isArray(images) || !images[0]){
         				return $q.reject("Safety image data is invalid.");
         			}

         			vm.imageList.forEach(function(item){
         				if(item.tag.id_safety_image_tag == images[0].fk_id_safety_image_tag){
         					item.images.push(images[0]);
         				}
         			});

         			item.remove();
         		})
         		.catch(MessageService.showToast);
		}

		function deleteImage(image, index){
			var dialogOptions = {};

			dialogOptions.titleString = "Delete Image";
			dialogOptions.contentString = "Are you sure to delete this image?";

			var confirmOption = {};

			confirmOption.optionName = "YES";
			confirmOption.onClick = function(){
				confirmDeleteImage(image, index);
				DialogService.close();
			}

			var cancelOption = {};

			cancelOption.optionName = "NO";
			cancelOption.onClick = function(){
				DialogService.close();
			}

			dialogOptions.options = [confirmOption, cancelOption];

			DialogService.showOptionsDialog(dialogOptions);
		}

		function confirmDeleteImage(image, index){

			image.isProcessing = true;

			var resourcePath = {
         		companyID: LoginService.getCompanyID(),
        		vehicleID: vm.vehicle.getResourceID(),
        		safetyID: vm.safety.getResourceID(),
        		imageID: image.id_safety_image
         	}

         	SafetyService.deleteSafetyImage(resourcePath)
         		.then(function(){
         			vm.imageList.forEach(function(item){
         				if(item.tag.id_safety_image_tag == image.fk_id_safety_image_tag){
         					item.images.splice(index, 1);
         				}
         			});
         		})
         		.catch(MessageService.showToast)
         		.finally(function(){
         			image.isProcessing = false;
         		});
		}	
	}
})();
(function ()
{
    'use strict';

    angular
        .module('app.safety')
        .controller('CreateSafetyController', CreateSafetyController);

    function CreateSafetyController($q, $sce, TaskConstants, $stateParams, $state, vehicle, Vehicle, MessageService, ProgressService, Safety, LoginService, SafetyService, VehicleConstants, imageTags, FileUploadService, ImageCompresser){   
        var vm = this;
        var uploadImagesDefer; 

        vm.save = save;


        init();

        function init(){
        	initImageUploader();
        	initInitImageTags();
        	initVehicle();
        	initSafety();
        	initDefaultInspectorID();
        }

        function initInitImageTags(){
        	vm.imageTags = imageTags;
        }

        function initImageUploader(){
			vm.imageUploader = FileUploadService.getNewUploader();
			vm.imageUploader.filters.push(FileUploadService.getImageFilter());
			vm.imageUploader.filters.push(FileUploadService.getSizeFilter(20));
		}

        function initDefaultInspectorID(){
        	vm.myUserID = LoginService.getUserID()
        }
        

        function initSafety(){
        	vm.safety = new Safety();
        }

        function initVehicle(){
        	if(vehicle == null || !Array.isArray(vehicle.data) || vehicle.data[0] == null){
        		MessageService.showToast("Vehicle data is invalid");
        		return;
        	}

        	vm.vehicle = vehicle.data[0];
        	vm.vehiclePageUrl = $state.href('app.vehicle.safety', {vehicleID: vm.vehicle.getResourceID()});
        }

        function save(){
        	if(!isAllFormValid()){
        		return;
        	}

        	var resourcePath = {
        		companyID: LoginService.getCompanyID(),
        		vehicleID: vm.vehicle.getResourceID()
        	}

        	vm.isProcessingData = true;
			ProgressService.setMode("indeterminate");
			ProgressService.isVisble(true);
			var newSafetyID;

        	SafetyService.createSafety(resourcePath, vm.safety)
        		.then(function(response){
        			newSafetyID = response;
        			return uploadImages(newSafetyID);
        		})
        		.then(function(){
        			MessageService.showToast("Success")
        			$state.go("app.vehicle.safety", {vehicleID: vm.vehicle.getResourceID()});
        		})
        		.catch(MessageService.showToast)
        		.finally(function(){
        			vm.isProcessingData = false;
        			ProgressService.isVisble(false);
        		});
        }

        vm.imageUploader.onAfterAddingFile = function(fileItem) {
			var url = URL.createObjectURL(fileItem._file);
			fileItem.imageSrc = $sce.trustAsResourceUrl(url);

			
			fileItem.formData 	= [{tag:fileItem.tag}];	
		}

        function uploadImages(safeyID){
        	uploadImagesDefer = $q.defer();
        	var vehicleID = vm.vehicle.getResourceID();

        	var queue = [];

        	vm.imageUploader.queue.forEach(function(fileItem){
        		queue.push(compressImages(fileItem));
        	})

        	if(queue.length <= 0){
        		uploadImagesDefer.resolve();
        		return;
        	}

        	$q.all(queue).then(function(fileItemList){
        		fileItemList.forEach(function(fileItem){
        			fileItem.url = FileUploadService.getUrlForCreateSafetyImage(vehicleID, safeyID);
        			fileItem.upload();	
        		})
        		
        	});

        	return uploadImagesDefer.promise;
        }

        vm.imageUploader.onCompleteAll = function(){
        	uploadImagesDefer.resolve();
        }

        vm.imageUploader.onCompleteItem = function(item, response, status, headers){
        	if(!FileUploadService.isUploadSuccess(headers)){
        		uploadImagesDefer.reject("Failed to upload image: " + item.file.name)
        	}
        }

        function compressImages(fileItem){
        	var defer = $q.defer();
        	var imageCompresser = new ImageCompresser(); 

        	imageCompresser.photo(fileItem._file, 1024, "file", false, function(file){
				fileItem._file 		= file;
				fileItem.file.size 	= file.size;
				defer.resolve(fileItem);
			});

			return defer.promise;
        }


		function isAllFormValid(){
			if(!vm.frontLeftConnerInfoFormValid()){
				MessageService.showToast("Please make sure front left conner form is valid");
				return false;
			}

			if(!vm.frontRightConnerInfoFormValid()){
				MessageService.showToast("Please make sure front right conner form is valid");
				return false;
			}

			if(!vm.rearLeftConnerInfoFormValid()){
				MessageService.showToast("Please make sure rear left conner form is valid");
				return false;
			}

			if(!vm.rearRightConnerInfoFormValid()){
				MessageService.showToast("Please make sure rear right conner form is valid");
				return false;
			}

			if(!vm.isGeneralFormValid()){
				MessageService.showToast("Please make sure general form is valid");
				return false;
			}

			return true;
		}
    }
})();
(function ()
{
	'use strict';

	angular
		.module("app.saleInfo")
		.factory("SafetyReport", SafetyReportClass)

	/** @ngInject */
	function SafetyReportClass($filter, $state, Const, $q, MessageService, LoginService, SafetyService, VehicleService, UserService, GeneralTools)
	{	   
		const defaultFontStyle = "17px Arial";

		function SafetyReport(safetyID, vehicleID){

			this.companyID = LoginService.getCompanyID();

			this.setVehicleID(vehicleID);
			this.setSafetyID(safetyID);
		}

		SafetyReport.prototype.getVehicleID = function() {
			return this.vehicleID
		}

		SafetyReport.prototype.setVehicleID = function(id) {
			this.vehicleID = id;
		}

		SafetyReport.prototype.getSafetyID = function() {
			return this.safetyID
		}

		SafetyReport.prototype.setSafetyID = function(id) {
			this.safetyID = id;
		}

		SafetyReport.prototype.open = function() {
			var defer = $q.defer();
			var _this = this;

			var safetyResourcePath = {
				companyID: _this.companyID,
				vehicleID: _this.vehicleID,
				safetyID: _this.safetyID
			}

			var vehicleResourcePath = {
				companyID: _this.companyID,
				vehicleID: _this.vehicleID
			}

			var getResourceDataTasks = {};

			getResourceDataTasks.vehicleData = VehicleService.getVehicle(vehicleResourcePath);
			getResourceDataTasks.safetyData = SafetyService.getSafeties(safetyResourcePath);

			$q.all(getResourceDataTasks)
				.then(function(resources){
					if(resources == null){
						return $q.reject("Fail to get safety resources data.");
					}

					if(resources.vehicleData == null || !Array.isArray(resources.vehicleData.data)){
						return $q.reject("Vehicle data is invalid.");
					}

					if(!Array.isArray(resources.safetyData)){
						return $q.reject("Safety data is invalid.");
					}

					_this.vehicleData = resources.vehicleData.data[0];
					_this.safetyData = resources.safetyData[0];

					var inspectorResourcePath = {
						companyID: _this.companyID,
						userID: _this.safetyData.getInspectorID()
					};

					return UserService.getUsers(inspectorResourcePath, null);
				})
				.then(function(resource){
					if(!Array.isArray(resource)){
						return $q.reject("Safety data is invalid.");
					}

					_this.inspectorData = resource[0];

					return fillSafetyReportTask(_this);
				})
				.then(function(){
					defer.resolve();					
				})
				.catch(function(error){
					defer.reject(error);
				})

			return defer.promise;
		}

		function fillSafetyReportTask(SafetyReportData){
			if(SafetyReportData == null){
				return $q.reject("Safety report data is invalid.");
			}

			return GeneralTools.getCanvas("assets/images/safetyreport/page_1.jpg", 1275, 1750)
				.then(function(canvas){			
					canvas = fillCompanyInfo(canvas);
					canvas = fillVehicleDataOnImage(SafetyReportData, canvas);
					canvas = fillSafetyGeneralDataOnImage(SafetyReportData, canvas);
					canvas = fillSafetyCommentOnImage(SafetyReportData.safetyData, canvas);
					canvas = fillInspectionDateOnImage(SafetyReportData.safetyData, canvas);
					canvas = fillFourConnersOnImage(SafetyReportData.safetyData, canvas);
					canvas = fillGasTankOnImage(SafetyReportData.safetyData, canvas);

					pdfMake.createPdf(getPdfContent(canvas)).print();

					return $q.resolve();
				})
		}

		function fillSafetyCommentOnImage(safetyData, canvas){
			if(safetyData == null || safetyData.inspection_comments == null){
				return canvas;
			}

			var context = canvas.getContext('2d');
			context.font = defaultFontStyle;

			var maxLineLength = 60;
			var xPosition = 80;
			var startYPosition = 1200;
			var currentYPosition = startYPosition;
			var lineHight = 30; 

			var words = safetyData.inspection_comments.split(' ');
			var lines = [''];

			words.forEach(function(word){
				var currentLineIndex = lines.length - 1;
				var currentLine = lines[currentLineIndex];
				var currentLineLength = currentLine.length;

				if((currentLineLength + word.length + 1) > maxLineLength){
					lines.push(word);
				}else{
					lines[currentLineIndex] = currentLine + ' ' + word;
				}
			})

			lines.forEach(function(line){
				fillTextOnCanvasContext(line, context, xPosition, currentYPosition);
				currentYPosition += lineHight;
			})

			return canvas;			
		}

		function fillSafetyGeneralDataOnImage(SafetyReportData, canvas){
			if(SafetyReportData == null || SafetyReportData.inspectorData == null || SafetyReportData.safetyData == null ){
				return canvas;
			}
			var context = canvas.getContext('2d');
			context.font = defaultFontStyle;

			var inspectorName = SafetyReportData.inspectorData.first_name + ' ' +  SafetyReportData.inspectorData.last_name;

			fillTextOnCanvasContext(inspectorName, context, 68, 599);

			if(SafetyReportData.safetyData.is_pass == true){
				fillTextOnCanvasContext('X', context, 71, 703);
			}

			if(SafetyReportData.safetyData.is_pass == false){
				fillTextOnCanvasContext('X', context, 171, 703);
			}

			var contextForSpaceString = canvas.getContext('2d');
			contextForSpaceString.font = "23px Arial";;
			fillTextOnCanvasContext(insertSpaceInString(SafetyReportData.inspectorData.registration_number, 3), context, 175, 646);
			fillTextOnCanvasContext(insertSpaceInString(SafetyReportData.safetyData.safety_certificate_number, 3), context, 262, 710);
			return canvas;
		}

		function fillVehicleDataOnImage (safetyReportData, canvas){
			if(!safetyReportData || !safetyReportData.vehicleData){
				return canvas;
			}

			const vehicleData = safetyReportData.vehicleData;
			var context = canvas.getContext('2d');
			context.font = defaultFontStyle;

			fillTextOnCanvasContext(vehicleData.year, context, 70, 408);
			fillTextOnCanvasContext(vehicleData.make, context, 152, 408);
			fillTextOnCanvasContext(vehicleData.model, context, 400, 408);

			fillTextOnCanvasContext('X', context, 280, 507);

			var contextForLargeFont = canvas.getContext('2d');
			contextForLargeFont.font = "18px Arial";

			var vinStartPoint = 69;

			if(vehicleData.vin){
				for(var i = 0; i < vehicleData.vin.length; i++){
					var char = vehicleData.vin.charAt(i);
					fillTextOnCanvasContext(char, contextForLargeFont, vinStartPoint, 454);
					vinStartPoint += 32;
				}
			}

			if(safetyReportData.safetyData && safetyReportData.safetyData.mileage){
				var mileageStartPoint = 68;

				if(safetyReportData.safetyData.mileage.toString().length < 6){
					mileageStartPoint = mileageStartPoint + (6 - safetyReportData.safetyData.mileage.toString().length) * 32;
				}
	
				fillTextOnCanvasContext(insertSpaceInString(safetyReportData.safetyData.mileage.toString(), 4), contextForLargeFont, mileageStartPoint, 513);
			}

			return canvas;
		}

		function insertSpaceInString(string, spaceSize){
			if(string == null){
				return;
			}

			var space = '';

			for(var i = 0; i < spaceSize; i++){
				space += ' ';
			}

			var stringWithSpace = '';

			for(var i = 0; i < string.length; i++){
				var currentCharactor = string[i];

				stringWithSpace += currentCharactor + space
			}

			return stringWithSpace;
		}

		function fillCompanyInfo (canvas){
			var context = canvas.getContext('2d');
			context.font = defaultFontStyle;

			fillTextOnCanvasContext("Roger’s Motors Ontario Inc", context, 97, 165);
			fillTextOnCanvasContext("1035 Speers Road, Oakville ON L6L 2X5", context, 97, 195);
			fillTextOnCanvasContext("License Number: 2551607 ", context, 97, 225);


			return canvas;	
		}

		function fillGasTankOnImage(safetyData, canvas){
			if(safetyData == null){
				return canvas;
			}
			var context = canvas.getContext('2d');
			context.font = defaultFontStyle;

			var gasPercentage = parseFloat(safetyData.gas_tank);
			var emptyPosition = 860;
			var fullPosition = 1075;

			var xPosition = (fullPosition - emptyPosition) * gasPercentage + emptyPosition;

			fillTextOnCanvasContext('X', context, xPosition, 1558);

			return canvas;			
		}

		function fillInspectionDateOnImage (safetyData, canvas){
			if(safetyData == null){
				return canvas;
			}
			var context = canvas.getContext('2d');
			context.font = defaultFontStyle;

			var inspectionDate = safetyData.getInspectionDateMomentObj();

			if(inspectionDate != null){
				fillTextOnCanvasContext(inspectionDate.year() , context, 877, 124);
				fillTextOnCanvasContext(inspectionDate.months() + 1, context, 1007, 124);
				fillTextOnCanvasContext(inspectionDate.date(), context, 1145, 124);
			}

			return canvas;	
		}

		function fillFourConnersOnImage(safetyData, canvas){
			if(safetyData == null){
				return canvas;
			}
			var context = canvas.getContext('2d');
			context.font = defaultFontStyle;

			fillTextOnCanvasContext('X', context, 968, 199);

			fillTextOnCanvasContext(safetyData.front_left_rotor_thickness, context, 826, 380);
			fillTextOnCanvasContext(safetyData.front_left_pad_thickness_inner, context, 826, 496);
			fillTextOnCanvasContext(safetyData.front_left_pad_thickness_outer, context, 826, 587);
			fillTextOnCanvasContext(safetyData.front_left_shoe_lining_thickness, context, 826, 721);
			fillTextOnCanvasContext(safetyData.front_left_drum_diameter, context, 826, 812);
			fillTextOnCanvasContext(safetyData.front_left_tread_depth, context, 666, 531);
			fillTextOnCanvasContext(safetyData.front_left_inflation_pressure, context, 666, 608);
			fillTextOnCanvasContext(safetyData.front_left_pressure_initial_reading, context, 666, 738);
			fillTextOnCanvasContext(safetyData.front_left_pressure_final_reading, context, 666, 813);

			fillTextOnCanvasContext(safetyData.front_right_rotor_thickness, context, 958, 380);
			fillTextOnCanvasContext(safetyData.front_right_pad_thickness_inner, context, 958, 496);
			fillTextOnCanvasContext(safetyData.front_right_pad_thickness_outer, context, 958, 587);
			fillTextOnCanvasContext(safetyData.front_right_shoe_lining_thickness, context, 958, 721);
			fillTextOnCanvasContext(safetyData.front_right_drum_diameter, context, 958, 812);
			fillTextOnCanvasContext(safetyData.front_right_tread_depth, context, 1147, 531);
			fillTextOnCanvasContext(safetyData.front_right_inflation_pressure, context, 1147, 608);
			fillTextOnCanvasContext(safetyData.front_right_pressure_initial_reading, context, 1147, 738);
			fillTextOnCanvasContext(safetyData.front_right_pressure_final_reading, context, 1147, 813);

			fillTextOnCanvasContext(safetyData.rear_left_rotor_thickness, context, 826, 968);
			fillTextOnCanvasContext(safetyData.rear_left_pad_thickness_inner, context, 826, 1084);
			fillTextOnCanvasContext(safetyData.rear_left_pad_thickness_outer, context, 826, 1173);
			fillTextOnCanvasContext(safetyData.rear_left_shoe_lining_thickness, context, 826, 1308);
			fillTextOnCanvasContext(safetyData.rear_left_drum_diameter, context, 826, 1399);
			fillTextOnCanvasContext(safetyData.rear_left_tread_depth, context, 666, 1033);
			fillTextOnCanvasContext(safetyData.rear_left_inflation_pressure, context, 666, 1108);
			fillTextOnCanvasContext(safetyData.rear_left_pressure_initial_reading, context, 666, 1237);
			fillTextOnCanvasContext(safetyData.rear_left_pressure_final_reading, context, 666, 1313);

			fillTextOnCanvasContext(safetyData.rear_right_rotor_thickness, context, 958, 968);
			fillTextOnCanvasContext(safetyData.rear_right_pad_thickness_inner, context, 958, 1084);
			fillTextOnCanvasContext(safetyData.rear_right_pad_thickness_outer, context, 958, 1173);
			fillTextOnCanvasContext(safetyData.rear_right_shoe_lining_thickness, context, 958, 1308);
			fillTextOnCanvasContext(safetyData.rear_right_drum_diameter, context, 958, 1399);
			fillTextOnCanvasContext(safetyData.rear_right_tread_depth, context, 1147, 1033);
			fillTextOnCanvasContext(safetyData.rear_right_inflation_pressure, context, 1147, 1108);
			fillTextOnCanvasContext(safetyData.rear_right_pressure_initial_reading, context, 1147, 1237);
			fillTextOnCanvasContext(safetyData.rear_right_pressure_final_reading, context, 1147, 1313);
			
			return canvas;
		}


		function getPdfContent(canvas){
			var docDefinition = {
				pageSize: 'LETTER', //pageSize: { width: 612.00, height: 792.00},
				pageMargins: [0, 0, 0, 0]
        	};

        	var contents = [];

        	contents.unshift({	
				image: canvas.toDataURL("image/jpg", 1.0),
				fit: [612, 792]
			})

        	docDefinition.content = contents;
        	
        	return docDefinition;
		}

/*		function getSafetyReportPatternCanvas(){
			const canvas = document.createElement('canvas')

	        var img = angular.element(document.querySelector( '#safetyReportPatternPage' ));

	        if(img == null){
	        	return;
	        }

	        canvas.width = 1275;
			canvas.crossOrigin = "Anonymous";
			canvas.height = 1650;

			var context = canvas.getContext('2d');

			context.drawImage(img.get(0), 0, 0);

			return canvas;
		}*/

		function fillTextOnCanvasContext(text, context, xPosition, yPosition){
			if(text == null || context == null){
				return;
			}

			context.fillText(text, xPosition, yPosition);
		}

		return SafetyReport;
	}
})();
(function ()
{
	'use strict';

	angular
		.module("app.saleInfo")
		.factory("Safety", SafetyClass)

	/** @ngInject */
	function SafetyClass($filter, SafetyConstants)
	{	   
		function Safety(){}

		Safety.prototype.setAttributes = function (attributes) {
	 		if(attributes == null){
	 			return;
	 		}

	 		var keyList = Object.keys(attributes);

	 		for(var i = 0; i < keyList.length; i++){
	 			var key = keyList[i];
	 			var value = attributes[key];

	 			this.setAttribute(key, value);
	 		}
		}

		Safety.prototype.setAttribute = function (key, value) {
	 		this[key] = value;
		}

		Safety.prototype.setResourceID = function (id) {
	 		this.id_safety = id;
		}

		Safety.prototype.getResourceID = function () {
	 		return this.id_safety;
		}	

		Safety.prototype.setInspectorID = function (id) {
	 		this.setAttribute("inspected_by", id);
		}

		Safety.prototype.getInspectorID = function (id) {
	 		return this.inspected_by;
		}

		Safety.prototype.setInspectionDate = function (momentObj) {
	 		if(momentObj != null && momentObj.isValid()){
				this.inspection_date = momentObj.format(SafetyConstants.inspectDateFormat);
				return true;
			}
			this.inspection_date = null;
			return false;
		}	

		Safety.prototype.getInspectionDateMomentObj = function (){
			if(this.inspection_date != null){
				return moment(this.inspection_date, SafetyConstants.inspectDateFormat);
			}
		}

		return Safety;
	}

})();
(function ()
{
	'use strict';

	angular
		.module('app.returnInvoice')
		.service("ReturnInvoiceService", ReturnInvoiceService);

	/** @ngInject */
	function ReturnInvoiceService(MyFile, $state, api, ToolsFactory, Const, $q, MessageService, LoginService, $filter, ReturnInvoice, HeaderHelper)
	{   
		var codeKey = Const.header.code;
		var messageKey = Const.header.message;
		var successCode = Const.code.success;

		this.getReturnInvoices = function(resourcePath, filters, pagination, sorting){			
			var defer = $q.defer();
			var queryParams = Object.assign({}, resourcePath, filters, pagination, sorting);

			api.returnInvoice.getReturnInvoices(
				queryParams,
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);
						defer.reject(errorMessage);
						return;
					}

					var returnInvoiceList = [];

					response.forEach(function(data){
						var returnInvoice = new ReturnInvoice();

						returnInvoice.setAttributes(data);
						returnInvoiceList.push(returnInvoice);
					})

					var result = {
						data: returnInvoiceList,
						headerGetter: header
					}

					defer.resolve(result);
				},
				function(error){
					console.error("Failed to get returnInvoice.");
					defer.reject(error);
				}
			);

			return defer.promise;
		}

		this.createReturnInvoice = function(resourcePath, requestBody){
			var defer = $q.defer();

			api.returnInvoice.postReturnInvoice(
				resourcePath,
				requestBody,
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);
						defer.reject(errorMessage);
						return;
					}

					defer.resolve(response.data);
				},
				function(error){
					console.error("Failed to create returnInvoice.");
					defer.reject(error);
				}
			);

			return defer.promise;
		}

		this.updateReturnInvoice = function(resourcePath, requestBody){
			var defer = $q.defer();

			api.returnInvoice.updateReturnInvoice(
				resourcePath,
				requestBody,
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);

						defer.reject(errorMessage);
						return;
					}
					defer.resolve(response);

				},
				function(error){
					console.error(error);
					defer.reject("Failed to update returnInvoice.");
				}
			);	

			return defer.promise;			
		}

		this.getReturnInvoiceFiles = function(resourcePath){
			var defer = $q.defer();

			api.returnInvoiceFile.getFiles(
				resourcePath,
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);
						defer.reject(errorMessage);
						return;
					}

					var fileList = [];

					response.forEach(function(data){
						var file = new MyFile();

						file.setAttributes(data);
						fileList.push(file);
					})

					defer.resolve(fileList);
				},
				function(error){
					console.error(error);
					defer.reject("Failed to get return invoice files.");
				}
			);

			return defer.promise;			
		}

		this.deleteReturnInvoiceFile = function(resourcePath){
			var defer = $q.defer();

			api.returnInvoiceFile.deleteFile(
				resourcePath,
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);
						defer.reject(errorMessage);
						return;
					}

					defer.resolve(response);
				},
				function(error){
					console.error(error);
					defer.reject("Failed to delete return invoice file.");
				}
			);

			return defer.promise;
		}
	}
})();
(function ()
{
	'use strict';

	angular
		.module("app.returnInvoice")
		.factory("ReturnInvoice", ReturnInvoiceClass)

	/** @ngInject */
	function ReturnInvoiceClass($filter, ReturnInvoiceConstants)
	{	 
		function ReturnInvoice(){}

		ReturnInvoice.prototype.setAttributes = function (attributes) {
	 		if(attributes == null){
	 			return;
	 		}

	 		var keyList = Object.keys(attributes);

	 		for(var i = 0; i < keyList.length; i++){
	 			var key = keyList[i];
	 			var value = attributes[key];

	 			this.setAttribute(key, value);
	 		}
		}

		ReturnInvoice.prototype.setAttribute = function (key, value) {
	 		this[key] = value;
		}

		ReturnInvoice.prototype.getResourceId = function () {
	 		return this.id_return_invoice;
		}	

		ReturnInvoice.prototype.setReturnDate = function (momentObj) {
	 		if(momentObj && momentObj.isValid()){
				this.return_date = momentObj.format(ReturnInvoiceConstants.returnDateFormat);
				return true;
			}
			this.return_date = null;
			return false;
		}	

		ReturnInvoice.prototype.getReturnDateMomentObj = function (){
			if(this.return_date){
				return moment(this.return_date, ReturnInvoiceConstants.returnDateFormat);
			}
		}

		return ReturnInvoice;
	}


})();
(function ()
{
	'use strict';

	angular.module('app.register-page', [])
		.config(config);

	/** @ngInject */
	function config($stateProvider, msNavigationServiceProvider)
	{	  
		$stateProvider
			.state('app.register-page', {
				url: '/register-page?uuid',
				reloadOnSearch : false,
				views: {
					'content@app': {
						templateUrl: 'app/main/register/register-page.html',
						controller: 'RegisterController as vm'
					}
				},
				resolve :{
					customerInfo:function($q, MessageService, RegisterService, $stateParams){
						const resourcePath = $stateParams.uuid

						return RegisterService.getRegisteruuid(resourcePath).$promise.catch(MessageService.showToast);
					},
				}
			});
	}
})();
(function ()
{
	'use strict';

	angular
		.module('app.register-page')
		.service("RegisterService", RegisterService);

	/** @ngInject */
	function RegisterService(LoginService, GeneralTools, Const, $q, MessageService, $resource)
	{

		var codeKey = Const.header.code;
		var successCode = Const.code.success;
		const baseUrl = GeneralTools.getBaseUrl();
		const errMsgFailedToGetRedirectUrl = "Failed to fetch redirct url";
		const baseHeader = GeneralTools.getBaseHeader();
		const noCacheHeader = GeneralTools.getNoCacheHeader();
		const registerUrlApi = $resource(
			baseUrl + "register",
			{
				
			},
			{
				getCustomerRegistration:{
					method:"GET",
					cancellable: true,
					interceptor:{
						response: function(result){
							const statusCode  = result.headers(Const.header.code);

							if(statusCode != Const.code.success){
								console.error(statusCode, result.headers(Const.header.message));
								return $q.reject(errMsgFailedToGetRedirectUrl);
							}

							return result.data;
						},
						responseError: function (error){
							if(error && error.xhrStatus == Const.xhrStatus.abort){
								return $q.reject();
							}
							console.error(error);
							return $q.reject(error);
						}
					}
				}
			}
		);

		const checkcustomerusername = $resource(
			baseUrl + "checkcustomerusernameexisting",
			{},
			{
				check: {
					method: 'GET',
					cache: false,
					headers: header
				}
			}
		);

		const registernewcustomer = $resource(
			baseUrl + "registercustomer",
			{},
			{
				register: {
					method: 'POST',
					cache: false,
					headers: header
				}
			}
		);

		const publicUpdateCustomerEmail = $resource(
			baseUrl + "updatecustomeremail",
			{},
			{
				updateEmail: {
					method: 'POST',
					cache: false,
					headers: header
				}
			}
		);

		const publicUpdateCustomerPhoneNumber = $resource(
			baseUrl + "updatecustomerphone",
			{},
			{
				updatePhoneNumber: {
					method: 'POST',
					cache: false,
					headers: header
				}
			}
		);

		var header = {}
		header.token = LoginService.getToken();
		header["Cache-Control"] = "no-cache, no-store, must-revalidate";
		header["Pragma"] = "no-cache";
		header["Expires"] = 0;

		this.getRegisteruuid = function(uuid){
			return registerUrlApi.getCustomerRegistration({uuid: uuid});
		}

		this.checkCustomerUsername= function(username, uuid, callback){
			checkcustomerusername.check(
				{uuid: uuid, username: username},
				function(response, header){
					var statusCode  = header(codeKey);					
					if(statusCode != successCode){
						MessageService.showToast(statusCode + " : "+ header("message"));
						return;
					}
								
					callback(!response.data)					
				},
				function(error){
					console.log(error);
				}
			); 
		}

		this.registerNewCustomer = function(newUser, callback){
			registernewcustomer.register(
				newUser,
				function(response, header){
					var statusCode  = header(codeKey);					
					if(statusCode != successCode){
						MessageService.showToast(statusCode + " : "+ header("message"));
						return;
					}			
					callback(response.data)					
				},
				function(error){
					console.log(error);
				}
			)
		}

		this.publicUpdateCustomerEmailAddress = function(newUser, callback){
			publicUpdateCustomerEmail.updateEmail(
				newUser,
				function(response, header){
					var statusCode  = header(codeKey);					
					if(statusCode != successCode){
						MessageService.showToast(statusCode + " : "+ header("message"));
						return;
					}		
					callback(response.data)					
				},
				function(error){
					console.log(error);
				}
			)
		}

		this.publicUpdateCustomerPhoneNumber = function(newUser, callback){
			publicUpdateCustomerPhoneNumber.updatePhoneNumber(
				newUser,
				function(response, header){
					var statusCode  = header(codeKey);					
					if(statusCode != successCode){
						MessageService.showToast(statusCode + " : "+ header("message"));
						return;
					}		
					callback(response.data)					
				},
				function(error){
					console.log(error);
				}
			)
		}
	}
})();
(function () {
	'use strict';

	angular
		.module('app.register-page')
		.controller('RegisterController', RegisterController);

	function RegisterController($scope, $stateParams, RegisterService, ProgressService, MessageService, GeneralTools, customerInfo, ApiConst) {
		const vm = this;
		vm.registerCompleted = false;
		vm.isDirecting = true;
		vm.checkUsername = checkUsername;
		vm.addUser = addUser;
		vm.checkEmail = checkEmail;
		vm.translateToPhoneNumber = GeneralTools.inputTranslators.phoneNumber;
		vm.uuiderror = false;
		vm.containEmailFromCustomerInfo = false;
		vm.emails;
		vm.phoneNumbers;
		vm.emailsBackUp;
		vm.phoneNumbersBackUp;
		vm.customerInfo
		vm.customer = {
			username: undefined,
			password: undefined
		};
		vm.copyToUsername = copyToUsername;
		vm.isResettingPassWord = false;
		vm.editEmailContent = editEmailContent;
		vm.finishEditEmailContent = finishEditEmailContent;
		vm.editPhoneNumberContent = editPhoneNumberContent;
		vm.finishEditPhoneNumberContent = finishEditPhoneNumberContent;
		vm.allEditionSet = allEditionSet;
		vm.editingEmailList = {};
		vm.editingPhonenumberList = {};
		vm.reverseEmailById = reverseEmailById;
		vm.reversePhoneById = reversePhoneById;
		
		init()

		vm.domain;
		switch(window.location.host){
			case ApiConst.productDomain:
				vm.domain = ApiConst.productDomain
				break;
			case ApiConst.productBackupDomain:
				vm.domain = ApiConst.productBackupDomain
				break;
			case ApiConst.testDomain:
				vm.domain = ApiConst.testDomain
				break;
			default:
				vm.domain = 'localhost:3001'
				break;
		}
		vm.domain = vm.domain + "/redirect-page?code=004"

		console.log(vm.domain)
		function editEmailContent(item){

            vm.editingEmailList[item] = true
        }

        function finishEditEmailContent(item){
			var emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
			var isValidEmail = emailRegex.test(item.email_address);
			if(isValidEmail){
				UpdateCustomerEmailInfo(item)
				vm.editingEmailList[item.id_email] = false
			}else{
				MessageService.showToast("Email Address Invalid.")	
			}

        }

		function editPhoneNumberContent(item){
            vm.editingPhonenumberList[item] = true
        }

        function finishEditPhoneNumberContent(item){
			var phoneRegex = /^\d{6,14}$/;
			var isValidPhoneNumber = phoneRegex.test(item.phone_number);

			if(isValidPhoneNumber){
				UpdateCustomerPhoneNumberInfo(item)
				vm.editingPhonenumberList[item.id_phone_number] = false
			}else{
				MessageService.showToast("Phone Number Invalid.")	
			}

        }

		function allEditionSet(){
			var Emailvalues = Object.values(vm.editingEmailList);
			var Phonevalues = Object.values(vm.editingPhonenumberList);

			var allEmailTrue = Emailvalues.every(function(value) {
				return value === false;
			  });

			var allPhoneTrue = Phonevalues.every(function(value) {
				return value === false;
			});

			var isEmailEmpty = Emailvalues.length === 0;

			var isPhoneEmpty = Phonevalues.length === 0;

			return (allEmailTrue || isEmailEmpty) && (allPhoneTrue || isPhoneEmpty)
		}


		function init(){

			if(!customerInfo){
				vm.uuiderror = true
			}
			vm.vehicleName = customerInfo.resourceData.first_name + " " + customerInfo.resourceData.last_name;
			vm.emails = angular.copy(customerInfo.resourceData.emails)
			vm.phoneNumbers = angular.copy(customerInfo.resourceData.phone_numbers)

			vm.emailsBackUp = angular.copy(customerInfo.resourceData.emails)
			vm.phoneNumbersBackUp = angular.copy(customerInfo.resourceData.phone_numbers)

			if(customerInfo && customerInfo.resourceData && customerInfo.is_reset_password == 1){
				vm.isResettingPassWord = true;
			}

			if(vm.emails && vm.emails.length > 0 &&  vm.emails[0].email_address && vm.customer){
				vm.containEmailFromCustomerInfo = true
				vm.customer.username = vm.emails[0].email_address
				checkUsername()
			}

			if(vm.isResettingPassWord && customerInfo.resourceData.username){
				vm.customer.username = customerInfo.resourceData.username
			}

			initConstants();
		}

		function checkUsername() {
			
			if (!vm.customer || !vm.customer.username || vm.isResettingPassWord) {
				return;
			}
			var uuid = $stateParams.uuid

			var username = vm.customer.username;
			if (username != null) {
				vm.isCheckingUsername = true;
				RegisterService.checkCustomerUsername(username, uuid, checkUsernameCallback);
			}
		}

		function initConstants(){
			vm.constants = {}
			vm.constants.phoneCategories = [
				{
					id_phone_category: 1,
					category: "Home"
				},
				{
					id_phone_category: 2,
					category: "Mobile"
				},
				{
					id_phone_category: 3,
					category: "Work"
				},
				{
					id_phone_category: 4,
					category: "Other"
				},
			];
			vm.constants.emailCategories = [
				{
					id_email_category: 1,
					name: "Home"
				},
				{
					id_email_category: 2,
					name: "Work"
				},
				{
					id_email_category: 3,
					name: "Other"
				}
			];
		}

		function checkUsernameCallback(result) {
			vm.isCheckingUsername = false;
			vm.isUsernameAvailable = result;
		}

		function addUser() {
			vm.disableAddButton = true;
			ProgressService.isVisble(true);

			var newUser = {
				uuid: $stateParams.uuid,
				username: vm.customer.username,
				password: vm.customer.password,
				// first_name: vm.customer.first_name,
				// last_name: vm.customer.last_name,
				// phone_number: vm.customer.phone_number,
				// address_street_number: vm.customer.address_street_number,
				// address_street: vm.customer.address_street,
				// address_city: vm.customer.address_city,
				// address_province: vm.customer.address_province,
				// address_postal_code: vm.customer.address_postal_code,

			};
			RegisterService.registerNewCustomer(newUser, addUserCallback);
		}

		
		function addUserCallback (error, newUserID){	
			
			if(error){
				ProgressService.isVisble(false);
				MessageService.showToast(error);
				vm.disableAddButton = false;
				return
			}

			ProgressService.isVisble(false);
			MessageService.showToast("Success !")	
			vm.registerCompleted = true
			return;	 
		}

		function checkEmail(email) {
			if (!vm.customer || !vm.customer.email || !email) {
				return;
			}else{
				vm.isEmailAvailable = true
			}
		}

		function copyToUsername(email){
			vm.customer.username = email
			checkUsername() 
		}


		function UpdateCustomerEmailInfo(item) {
			vm.disableAddButton = true;
			ProgressService.isVisble(true);

			var newUser = {
				uuid: $stateParams.uuid,
				emailAddress: item.email_address,
				emailId: item.id_email,

			};

			RegisterService.publicUpdateCustomerEmailAddress(newUser, updateCustomerCallBack);
		}

		
		function UpdateCustomerPhoneNumberInfo(item) {
			vm.disableAddButton = true;
			ProgressService.isVisble(true);

			var newUser = {
				uuid: $stateParams.uuid,
				phone_number: item.phone_number,
				id_phone_number: item.id_phone_number,

			};

			RegisterService.publicUpdateCustomerPhoneNumber(newUser, updateCustomerCallBack);
		}


		function updateCustomerCallBack (error, newUserID){	
			
			if(!error){
				ProgressService.isVisble(false);
				MessageService.showToast(error);
				
				return
			}

			ProgressService.isVisble(false);
			MessageService.showToast("Success !")	
			vm.disableAddButton = false;
			return;	 
		}

		function reverseEmailById(item){
			if(!item){
				return
			}
			var temp;
			vm.emailsBackUp.forEach(function(email_item){
				if(email_item.id_email == item){
					temp = email_item.email_address
				}
			})
			if(temp){
				vm.emails.forEach(function(email_item){
					if(email_item.id_email == item){
						email_item.email_address = temp;
					}
				})
			}
			MessageService.showToast("Reverse !")
		}

		function reversePhoneById(item){

			if(!item){
				return
			}

			var temp;
			vm.phoneNumbersBackUp.forEach(function(Phone_number){
				if(Phone_number.id_phone_number == item){
					temp = Phone_number.phone_number
				}
			})

			if(temp){
				vm.phoneNumbers.forEach(function(Phone_number){
					if(Phone_number.id_phone_number == item){
						Phone_number.phone_number = temp;
					}
				})
			}
			MessageService.showToast("Reverse !")

		}


	}
})();
(function ()
{
	'use strict';

	angular.module('app.reports', [])
		.config(config);

	/** @ngInject */
	function config($stateProvider, msNavigationServiceProvider)
	{	  
		$stateProvider
			.state('app.servicereports', {
				url: '/servicereports?tab&from&to',
				reloadOnSearch : false,
				views: {
					'content@app': {
						templateUrl: 'app/main/reports/reports.html',
						controller: 'ReportsController as vm'
					}
				}
			});
	}
})();
(function ()
{
	"use strict";

	angular
		.module("app.reports")
		.component("serviceReportTable", {
				bindings:{
					reportDatas:'<'
				},
				templateUrl: "app/main/reports/service-profit-table.html",
				controller: componentController,
		  		controllerAs: 'vm'
			});

		function componentController($state, GeneralTools, MessageService, ToolsConstants, $filter){
			var vm = this;

			vm.sortTagSubsidized = "subsidized";
			vm.sortTagIncome= "totalIncome";
			vm.sortTagCost = "totalCost";
			vm.sortTagProfit = "profit";
			vm.sortTagPayment = "totalPayment";
			vm.sortTagOutstanding = "workorder_outstanding";
			vm.sortTagWorkOrderProfit = "workorder_profit";

			vm.$onInit = initComponent;
			vm.$postLink = initCallbacks;
			vm.getTotal = getTotal;
			vm.getWorkorderUrl = getWorkorderUrl;
			vm.changeSorting = changeSorting;

			function initComponent(){
			}

			function initCallbacks(){
			}

			function changeSorting(tag){
				vm.sortBy = tag;
				vm.isDESC = !vm.isDESC;
				vm.reportDatas = $filter('orderBy')(angular.copy(vm.reportDatas), tag, vm.isDESC);
			}

			function getTotal(){
				if(!Array.isArray(vm.reportDatas)){
					return;
				}

				var subsidized = 0;
				var cost = 0;
				var income = 0;
				var profit = 0;
				var payment = 0;
				var totaloutstanding = 0;
				var totalprofit = 0;
				vm.reportDatas.forEach(function(item){
					if(item){
						subsidized += GeneralTools.parseNumber(item.subsidized);
						cost += GeneralTools.parseNumber(item.totalCost);
						income += GeneralTools.parseNumber(item.totalIncome);
						profit += GeneralTools.parseNumber(item.profit);
						payment += GeneralTools.parseNumber(item.totalPayment);
						totaloutstanding += GeneralTools.parseNumber(item.workorder_outstanding);
						totalprofit += GeneralTools.parseNumber(item.workorder_profit);
					}
				});

				return {
					subsidized: GeneralTools.preciseNumber(subsidized, 2),
					cost: GeneralTools.preciseNumber(cost, 2),
					income: GeneralTools.preciseNumber(income, 2),
					profit: GeneralTools.preciseNumber(profit, 2),
					payment:  GeneralTools.preciseNumber(payment, 2),
					totaloutstanding: GeneralTools.preciseNumber(totaloutstanding, 2),
					totalprofit: GeneralTools.preciseNumber(totalprofit, 2),
				}
			}

			function getWorkorderUrl(reportData){
				if(reportData && $state){
					return $state.href("app.edit-workorder.general", {vehicleID: reportData.vehicleID, workOrderID: reportData.workorderID});
				}		
			}
		}
})();
(function ()
{
	'use strict';

	angular
		.module('app.reports')
		.service("ReportService", ReportService);

	/** @ngInject */
	function ReportService(WorkOrderMechanic, SaleInfoConstants, WorkOrderSummaryCalculator, WorkOrderPart,WorkOrderRDRedeemed, Labor, WorkOrderWarranty, WorkOrderPackage, miscfeestypes, WorkOrderDiscount, WorkOrder, WorkOrderInventory, Const, $resource, WorkOrderService, Vehicle, api, $state, $q, MessageService, $filter, VehicleService, PurchaseInfoService, GeneralTools, SaleInfoService, BillOfSale, SaleCalculator, LoginService, TasksService, PurchaseCalculator, PurchaseInfo, SaleInfo, TradeInVehicle, CustomersService, SalePromotion, SaleInfoPayment, Disclosure, SaleExtras, SalePackage, Customer, SaleWarranty, User, Task, PurchaseInfoPrices, $location)
	{   
		const companyID = LoginService.getCompanyID();
		const baseUrl = GeneralTools.getBaseUrl();
		const errMsgFailedToFetchMechanicHourReport = "Failed to fetch mechanic hours report";
		const baseHeader = GeneralTools.getBaseHeader();
		const noCacheHeader = GeneralTools.getNoCacheHeader();

		const purchaseInfoPriceType = [
			{
				id_price_type: 1,
				text_column: "Purchase Price"
			},
			{
				id_price_type: 2,
				text_column: "Buyer Fee"
			},
			{
				id_price_type: 3,
				text_column: "Licensing Cost"
			},
			{
				id_price_type: 4,
				text_column: "Shipping Cost"
			},
			{
				id_price_type: 5,
				text_column: "Other Cost"
			}
		] 

		var purchaseReportHeader = [
			"Item Number", 
			"Purchased Date", 
			"Vendor", 
			"Vendor Description", 
			"Year", 
			"Make", 
			"Model", 
			"Vin",
			"Purchased Price",
			"Buyer Fee",
			"Other Cost",
			"Shipping Cost",
			"Sub Total",
			"Tax Rate",
			"HST",
			"Total",
			"Cheque Number"];

		var newPurchaseReportHeader = 
		[
			"Item Number", 
			"Purchased Date", 
			"Vendor", 
			"Vendor Description", 
			"Year", 
			"Make", 
			"Model", 
			"Vin",
			"Purchased Price",
			"Buyer Fee",
			"Licensing Cost",
			"Shipping Cost",
			"Other Cost",
			"Sub Total",
			"Tax Rate",
			"Tax Total",
			"Total",
			"Cheque Number"
		];

		var soldReportHeader = [
			"Item Number", 
			"Sale Date",
			"Sold By",
			"Commission Payout",
			"Year", 
			"Make", 
			"Model", 
			"VIN", 
			"Sale Price", 
			"Warranty",
			"Finance fee",
			"Accessories",
			"Promotion Deduction",
			"Sub Total",
			"Trade In",
			"Net Total Minus Trade In",
			"HST %",
			"HST",
			null,
			"Net Licence fee",
			"Licence Fee HST",
			"Gross Licence Fee",
			null,
			"Net Dealer Reserve",
			"Dealer Reserve HST",
			"Gross Dealer Reserve",
			null,
			"Total HST On Sales Report To HST",
			"Total Net Sales Report To HST",
			"Line Fee Go To Bank Directly",
			null,
			"Total Included HST Total",
			null,
			"Deposit",
			"Sub Total 2",
			"Total Balance",
			"Customer Name"];

		var profitReportHeader = [
			"Item Number",  
			"Year", 
			"Make", 
			"Model", 
			"VIN", 
			"Sale Date",
			"Sale Price", 
			"Warranty",
			"Finance fee",
			"Accessories",
			"Promotion Deduction",
			"Sale Licensing",
			"Net Dealer Reserve",
			"Purchase Date",
			"Purchase Price",
			"Warranty Cost",
			"Buyer fee",
			"Shipping Cost",
			"Other Cost",
			"Tasks Cost",
			"Work Order Cost",
			"Licensing Cost (sale)",
			"Licensing Cost (purchase)",
			"Commission Payout",
			"Total income",
			"Total Cost",
			"Net Profit",
			"Salesman"
		];

		var newProfitReportHeader = [
			"Item Number",  
			"Year", 
			"Make", 
			"Model", 
			"VIN", 
			"Sale Date",
			"Sale Price", 
			"Warranty",
			"Finance fee",
			"Accessories",
			"Promotion Deduction",
			"Sale Licensing",
			"Net Dealer Reserve",
			"Purchase Date",
			"Purchase Price",
			"Warranty Cost",
			"Buyer fee",
			"Shipping Cost",
			"Other Cost",
			"Tasks Cost",
			"Work Order Cost",
			"Licensing Cost (sale)",
			"Licensing Cost (purchase)",
			"Commission Payout",
			"Total income",
			"Total Cost",
			"Net Profit",
			"Salesman"
		];

		const workorderDetailApi = $resource(
			baseUrl + "companies/:companyID/reports/workordersdetail",
			{companyID: "@companyID"},
			{
				get:{
					method:"GET",
					isArray:true,
					cancellable: true,
					headers: noCacheHeader,
					interceptor:{
						response: function(result){
							const statusCode  = result.headers(Const.header.code);

							if(statusCode != Const.code.success){
								console.error(statusCode, result.headers(Const.header.message));
								return $q.reject(errMsgFailedToFetchMechanicHourReport);
							}

							return result.data;
						},
						responseError: function (error){
							if(error && error.xhrStatus == Const.xhrStatus.abort){
								return $q.reject();
							}
							console.error(error);
							return $q.reject(error);
						}
					}
				},
				getnosub:{
					method:"POST",
					isArray:true,
					cancellable: true,
					headers: noCacheHeader,
					interceptor:{
						response: function(result){
							const statusCode  = result.headers(Const.header.code);

							if(statusCode != Const.code.success){
								console.error(statusCode, result.headers(Const.header.message));
								return $q.reject(errMsgFailedToFetchMechanicHourReport);
							}

							return result.data;
						},
						responseError: function (error){
							if(error && error.xhrStatus == Const.xhrStatus.abort){
								return $q.reject();
							}
							console.error(error);
							return $q.reject(error);
						}
					}
				},
			}
		);

		this.getServiceProfitReportData = getServiceProfitReportData

		this.getNoSubsidizedServiceProfitReportData = getNoSubsidizedServiceProfitReportData

		this.getMechanicHoursReportData = getMechanicHoursReportData

		this.downloadNoSubServiceProfitReport = function(companyID, from, to, customerListId){
			return getNoSubsidizedServiceProfitReportData(companyID, from, to, customerListId).then(function(serviceProfitReportData){
				GeneralTools.generalExcelSheet(buildServiceProfitExeclSheetObj(serviceProfitReportData), "No Subsidized Service Profit Report");
				return $q.resolve();
			});
		}

		this.downloadServiceProfitReport = function(companyID, from, to, customerListId){
			return getServiceProfitReportData(companyID, from, to, customerListId).then(function(serviceProfitReportData){
				GeneralTools.generalExcelSheet(buildServiceProfitExeclSheetObj(serviceProfitReportData), "Service Profit Report");
				return $q.resolve();
			});
		}

		this.downloadMechanicHoursReport = function(companyID, from, to, customerListId){
			return getMechanicHoursReportData(companyID, from, to, customerListId).then(function(mechanicHoursReportData){
				GeneralTools.generalExcelSheet(buildMechanicHoursExeclSheetObj(mechanicHoursReportData), "Mechanic Hours Report");
				return $q.resolve();
			});
		}

		function getNoSubsidizedServiceProfitReportData(companyID, from, to, customerListId){
			const params = {
				companyID: companyID,
				from: from,
				to: to,
				customerListId: customerListId
			};

			const body = {
				nosub: true
			}

			return workorderDetailApi.getnosub(params, body).$promise.then(extractServiceProfitReportDataFromWorkorderDetails);
		}

		function getServiceProfitReportData(companyID, from, to, customerListId){
			const params = {
				companyID: companyID,
				from: from,
				to: to,
				customerListId: customerListId
			};

			return workorderDetailApi.get(params).$promise.then(extractServiceProfitReportDataFromWorkorderDetails);
		}

		function getMechanicHoursReportData(companyID, from, to, customerListId){
			const params = {
				companyID: companyID,
				from: from,
				to: to,
				customerListId: customerListId
			};
			return workorderDetailApi.get(params).$promise.then(extractMechanicHoursReportData);
		}

		function extractMechanicHoursReportData(workorderDetails){
			if(!Array.isArray(workorderDetails)){
				return;
			}

			const reportObjList = workorderDetails.map(castWorkorderDetailRawDataToReportObj);

			const mechanicMap = {};

			reportObjList.forEach(function(reportObj){
				if(!reportObj || !reportObj.work_order || !reportObj.calculator || !Array.isArray(reportObj.labors) || !Array.isArray(reportObj.mechanics)){
					return;
				}

				const soldDate = reportObj.sale_date ? moment(reportObj.sale_date) : null;
				const purchasedDate = reportObj.purchase_date ? moment(reportObj.purchase_date) : null;
				const isForService = isWorkorderForService(purchasedDate, soldDate, reportObj.work_order);

				reportObj.mechanics.forEach(function(mechanic){
					if(!mechanic){
						return;
					}

					if(!mechanicMap[mechanic.id_user]){
						mechanicMap[mechanic.id_user] = {
							first_name: mechanic.first_name,
							last_name: mechanic.last_name,
							workorderForService:[],
							workorderForRM:[]
						}
					}

					const mechanicHourDetail = {
						invoiceNumber: reportObj.work_order.invoice_number,
						workorderID: reportObj.work_order.id_work_order,
						vehicleID: reportObj.id_vehicle,
						labors: reportObj.labors,
						totalLaborHours: reportObj.calculator.getTotalLaborsHours(), 
						mechanicCount: reportObj.mechanics.length
					}

					if(isForService){
						mechanicMap[mechanic.id_user].workorderForService.push(mechanicHourDetail);
					} else {
						mechanicMap[mechanic.id_user].workorderForRM.push(mechanicHourDetail);
					}
				});
			});

			return Object.keys(mechanicMap).map(function(userID){
				return mechanicMap[userID];
			});
		}

		function extractServiceProfitReportDataFromWorkorderDetails(workorderDetails){
			if(!Array.isArray(workorderDetails)){
				return;
			}
			const reportObjList = workorderDetails.map(castWorkorderDetailRawDataToReportObj);
			if(!Array.isArray(reportObjList)){
				return;
			}

			const profitDataList = [];

			reportObjList.forEach(function(reportObj){
				if(!reportObj || !reportObj.work_order || !reportObj.calculator){
					return;
				}

				const soldDate = reportObj.sale_date ? moment(reportObj.sale_date) : null;
				const purchasedDate = reportObj.purchase_date ? moment(reportObj.purchase_date) : null;
				const completedDate = reportObj.work_order.completed_date ? moment(reportObj.work_order.completed_date) : null;
				const subsidized = reportObj.calculator.getSubsidization();
				var profit = reportObj.calculator.getProfit();

				if(!isWorkorderForService(purchasedDate, soldDate, reportObj.work_order)){
					return;
				}

				if (isWorkorderUnderWarranty(completedDate, soldDate)){
					profit += subsidized;
				}

				var customerName = null;
				if(reportObj.customer && reportObj.customer[0] && reportObj.customer[0].first_name && reportObj.customer[0].last_name){
					customerName = reportObj.customer[0].first_name + ' ' + reportObj.customer[0].last_name;
				}

				profitDataList.push({
					workorderID: reportObj.work_order.id_work_order,
					vehicleID: reportObj.id_vehicle,
					invoiceNumber: reportObj.work_order.invoice_number,
					completedDate: completedDate,
					soldDate: soldDate,
					warrantyDate: getWarrantyDate(completedDate, soldDate),
					partsCost: reportObj.calculator.getPartsAndInventoryTotalCost(),
					partsIncome: reportObj.calculator.getPartsAndInventoryTotalRetail(),
					laborsIncome: reportObj.calculator.getTotalLaborsCost(),
					miscfeesCost: reportObj.calculator.getTotalMiscfeesCost(),
					workorderpackageCost: reportObj.calculator.getTotalWorkOrderPackageListCost(),
					workorderwarrantyCost: reportObj.calculator.getTotalWorkOrderWarrantyListCost(),
					discounts: reportObj.calculator.getTotalDiscountAmount(),
					subsidized: subsidized,
					totalCost: reportObj.calculator.getTotalCost(),
					totalIncome: reportObj.calculator.getTotalBeforeTax(),
					profit: profit,
					totalPayment: 0+reportObj.work_order.total_payment - reportObj.calculator.getTotalBeforeTax(),
					workorder_subtotal: 0+reportObj.work_order.workorder_subtotal,
					workorder_tax: 0+reportObj.work_order.workorder_tax,
					workorder_outstanding: 0+reportObj.work_order.workorder_outstanding,
					workorder_profit: (reportObj.work_order.total_payment - reportObj.calculator.getTotalCost() - (reportObj.work_order.workorder_subtotal * 0.13)),
					customer: customerName
				});
			});

			return profitDataList;			
		}

		function isWorkorderForService(purchasedDate, soldDate, workorder){
			if(!workorder){
				return;
			}

			const completedDate = workorder.completed_date ? moment(workorder.completed_date) : null;
			const hasWarranty = isWorkorderUnderWarranty(completedDate, soldDate);
			const isAllSubsidized = workorder.subsidized_percentage == 1 && workorder.subsidized_percentage == 1;
			const isSold = soldDate && soldDate.isValid() && purchasedDate && purchasedDate.isValid() && soldDate.isSameOrAfter(purchasedDate);

			// Vehicle not available and not under warranty and not all subsidized
			return (isSold || !purchasedDate) && (!hasWarranty || !isAllSubsidized);
		}

		function isWorkorderUnderWarranty(completedDate, soldDate){
			var warrantyDate = getWarrantyDate(completedDate, soldDate);
			return completedDate && warrantyDate && completedDate.isSameOrBefore(warrantyDate);
		}

		function getWarrantyDate(completedDate, soldDate){
			if(soldDate && soldDate.isValid() && completedDate && completedDate.isValid()){
				return angular.copy(soldDate).date(soldDate.date() + SaleInfoConstants.warrantyLength);
			}
		}

		function castWorkorderDetailRawDataToReportObj(workorderDetail){
			if(!workorderDetail){
				return;
			}
			const workorder = new WorkOrder();
			workorder.setAttributes(workorderDetail.work_order);
			workorderDetail.work_order = workorder;

			if(Array.isArray(workorderDetail.inventories)){
				workorderDetail.inventories = workorderDetail.inventories.map(function(data){
					const inventory = new WorkOrderInventory();
					inventory.setAttributes(data);
					return inventory;
				});
			}

			if(Array.isArray(workorderDetail.parts)){
				workorderDetail.parts = workorderDetail.parts.map(function(data){
					const part = new WorkOrderPart();
					part.setAttributes(data);
					return part;
				});
			}

			if(Array.isArray(workorderDetail.labors)){
				workorderDetail.labors = workorderDetail.labors.map(function(data){
					const labor = new Labor();
					labor.setAttributes(data);
					return labor;
				});
			}

			if(Array.isArray(workorderDetail.miscfees)){
				workorderDetail.miscfees = workorderDetail.miscfees.map(function(data){
					const miscfees = new miscfeestypes();
					miscfees.setAttributes(data);
					return miscfees;
				});
			}

			
			if(Array.isArray(workorderDetail.workorderpackage)){
				workorderDetail.workorderpackage = workorderDetail.workorderpackage.map(function(data){
					const workorderpackage = new WorkOrderPackage();
					workorderpackage.setAttributes(data);
					return workorderpackage;
				});
			}

			if(Array.isArray(workorderDetail.workorderwarranty)){
				workorderDetail.workorderwarranty = workorderDetail.workorderwarranty.map(function(data){
					const workorderwarranty = new WorkOrderWarranty();
					workorderwarranty.setAttributes(data);
					return workorderwarranty;
				});
			}


			if(Array.isArray(workorderDetail.discounts)){
				workorderDetail.discounts = workorderDetail.discounts.map(function(data){
					const discount = new WorkOrderDiscount();
					discount.setAttributes(data);
					return discount;
				});
			}

			if(Array.isArray(workorderDetail.rogerdollarredeem)){
				workorderDetail.rogerdollarredeem = workorderDetail.rogerdollarredeem.map(function(data){
					const discount = new WorkOrderRDRedeemed();
					discount.setAttributes(data);
					return discount;
				});
			}

			if(Array.isArray(workorderDetail.mechanics)){
				workorderDetail.mechanics = workorderDetail.mechanics.map(function(data){
					const mechanic = new WorkOrderMechanic();
					mechanic.setAttributes(data);
					return mechanic;
				});
			}

			const workOrderSummaryCalculator = new WorkOrderSummaryCalculator();
			workOrderSummaryCalculator.setWorkorder(workorderDetail.work_order);
			workOrderSummaryCalculator.setParts(workorderDetail.parts);
			workOrderSummaryCalculator.setInventories(workorderDetail.inventories);
			workOrderSummaryCalculator.setLabors(workorderDetail.labors);
			workOrderSummaryCalculator.setMiscfees(workorderDetail.miscfees);
			workOrderSummaryCalculator.setWorkOrderPackageList(workorderDetail.workorderpackage);
			workOrderSummaryCalculator.setWorkOrderWarrantyList(workorderDetail.workorderwarranty);
			workOrderSummaryCalculator.setDiscounts(workorderDetail.discounts);
			workOrderSummaryCalculator.setRDRedeemed(workorderDetail.rogerdollarredeem);
			workorderDetail.calculator = workOrderSummaryCalculator;

			return workorderDetail;			
		}

		function buildServiceProfitExeclSheetObj(profitDataList){
			if(!Array.isArray(profitDataList)){
				return;
			}

			const header = [
					"Invoice Number",
					"Work Order Complete Time",
					"Sold Date",
					"Warranty Date",			
					"Parts Cost",
					"Parts Income",
					"Labors Income",
					"Misc fees Cost",
					"Work Order Package Cost",
					"Work Order Warranty Cost",
					"Discounts",
					"Subsidized",
					"Total Cost",
					"Total Income (After Tax)",	
					"Total Profit",
					"Customer Name"
				]

			const execlSheetObj = {Profit: [header]};
			profitDataList.forEach(function(profitData){
				if(!profitData){
					return;
				}
				execlSheetObj.Profit.push([
					profitData.invoiceNumber,
					profitData.completedDate ? profitData.completedDate.format("YYYY-MM-DD HH:mm:ss") : null,
					profitData.soldDate ? profitData.soldDate.format("YYYY-MM-DD") : null,
					profitData.warrantyDate ? profitData.warrantyDate.format("YYYY-MM-DD") : null,
					profitData.partsCost,
					profitData.partsIncome,
					profitData.laborsIncome,
					profitData.miscfeesCost,
					profitData.workorderpackageCost,
					profitData.workorderwarrantyCost,
					profitData.discounts,
					profitData.subsidized,
					profitData.totalCost,
					profitData.totalIncome,
					profitData.profit,
					profitData.customer	
				]);
			});

			return execlSheetObj;
		}

		function buildMechanicHoursExeclSheetObj(mechanicReportDataList){
			if(!Array.isArray(mechanicReportDataList)){
				return;
			}

			const execlSheetObj = {};
			const header = [
				"Invoice Number",
				"Hour",
				"Mechanic Count",
				"Hour / Mechanic Count"
			]

			mechanicReportDataList.forEach(function(mechanicReportData, index){
				if(!mechanicReportData){
					return;
				}

				const fullName = (index + 1) + mechanicReportData.first_name + ' ' + mechanicReportData.last_name;
				const rmTabName = fullName + "(RM)";
				const serviceTabName = fullName + "(Service)";

				// if(Array.isArray(mechanicReportData.workorderForRM)){
				// 	execlSheetObj[rmTabName] = [header];
				// 	mechanicReportData.workorderForRM.forEach(function(data){
				// 		execlSheetObj[rmTabName].push(castMechanicRportDataLaborObjToExcelSheetLaborObj(data));
				// 	});
				// }

				if(Array.isArray(mechanicReportData.workorderForService)){
					execlSheetObj[serviceTabName] = [header];
					mechanicReportData.workorderForService.forEach(function(data){
						execlSheetObj[serviceTabName].push(castMechanicRportDataLaborObjToExcelSheetLaborObj(data));
					});
				}
			});
			return execlSheetObj;
		}

		function castMechanicRportDataLaborObjToExcelSheetLaborObj(data){
			if(!data){
				return;
			}

			return [
				data.invoiceNumber,
				data.totalLaborHours,
				data.mechanicCount,
				GeneralTools.preciseNumber(data.totalLaborHours / data.mechanicCount, 2)
			]
		}

		function getVehicleWasAvailable(companyID, date) {
			const defer = $q.defer();

			api.vehiclesWasAvailable.getVehicle(
				{companyID: companyID, date: date}, 
				function(response, header) {
					const vehicleList = response.map(function(data){
						var vehicle = new Vehicle();
						vehicle.setAttributes(data); 
						return vehicle;
					});

					defer.resolve(vehicleList)
				},
				defer.reject
			);

			return defer.promise;
		}

		this.generateSaleReportVTemp = function(companyID, date){
			var defer = $q.defer();
			var vehicleList = [];
			const endDateMoment = moment(date);

			getVehicleWasAvailable(companyID, date)
				.then(function(vehicles){
					var tasks = {};
					vehicleList = vehicles;
					vehicles.forEach(function(vehicle){
						var vehicleID = vehicle.getResourceID();
						var saleInfoResourcePath = {
							companyID: companyID,
							vehicleID: vehicleID
						}

						tasks[vehicleID] = SaleInfoService.getVehicleSaleInfos(saleInfoResourcePath);
					})

					return $q.all(tasks);
				})
				.then(function(result){
					var vehicleIdList = Object.keys(result);
					var tasks = [];

					vehicleIdList.forEach(function(vehicleID, index){
						var saleInfoList = result[vehicleID];

						if(!Array.isArray(saleInfoList)){
							return;
						}

						saleInfoList.forEach(function(saleInfo){
							if(!isInDateRange(saleInfo.getSaleDateMomentObj(), null, endDateMoment) || saleInfo.is_canceled){
								return;
							}

						 	var billOfSale = new BillOfSale(vehicleID, saleInfo.getResourceID());

						 	tasks.push(billOfSale.fetchDatas());
						});
					});

					return $q.all(tasks);
				})
				.then(function(result){	
					var billOfSaleList = $filter('orderBy')(result, "saleInfo.sale_date");

					GeneralTools.generalExcelSheet({soldReport:buildSaleReportData(vehicleList, billOfSaleList)}, "Sold Report");
					defer.resolve();
				})
				.catch(function(error){
					defer.reject(error);
				});

			return defer.promise;
		}

		this.generatePurchaseReportVTemp = function(companyID, date){
			var defer = $q.defer();
			var vehicleList = [];
			var auctionOptions;
			const endDateMoment = moment(date);

			PurchaseInfoService.getAuction()
				.then(function(auctions){
					auctionOptions = auctions;
					return getVehicleWasAvailable(companyID, date);
				})
				.then(function(vehicles){
					if(!Array.isArray(vehicles)){
						return $q.reject("Failed to general purchase report, because vehicle data is invalid.");
					}

					var tasks = [];
					vehicleList = vehicles;

					vehicleList.forEach(function(vehicle){
						var vehicleID = vehicle.getResourceID();
						var purchaseInfoResourcePath = {
							companyID: companyID,
							vehicleID: vehicleID
						}

						tasks.push(PurchaseInfoService.getPurchaseInfos(purchaseInfoResourcePath));
					})

					return $q.all(tasks);
				})
				.then(function(result){
					var purchaseInfoList  = [];

					result.forEach(function(itemList){
						purchaseInfoList = purchaseInfoList.concat(itemList);
					})

					purchaseInfoList = reorganizePurchaseInfoList(purchaseInfoList, null, endDateMoment);

					GeneralTools.generalExcelSheet(buildPurcahseReportData(vehicleList, purchaseInfoList, auctionOptions), "Purchase Report");

					defer.resolve();	
				})
				.catch(function(error){
					console.error("Failed to general report.");
					defer.reject(error);
				})

			return defer.promise;
		}

		this.generateProfitReportVTemp = function(companyID, date){
			var defer = $q.defer();
			const endDateMoment = moment(date);

			getVehicleWasAvailable(companyID, date)
				.then(function(vehicles){
					var queue = {};

					vehicles.forEach(function(vehicle){
						var vehicleID = vehicle.getResourceID();
						var resourcePath = {
							companyID: companyID,
							vehicleID: vehicleID
						}

						queue[vehicleID] = $q.all({
							saleInfos:SaleInfoService.getVehicleSaleInfos(resourcePath),
							purchaseInfos:PurchaseInfoService.getPurchaseInfos(resourcePath),
						});
					})

					return $q.all(queue);
				})
				.then(function(result){
					var vehicleIdList = Object.keys(result);
					var queue = [];

					vehicleIdList.forEach(function(vehicleID){
						var saleInfoList = result[vehicleID].saleInfos;
						var purchaseInfoList = result[vehicleID].purchaseInfos;

						if(!Array.isArray(saleInfoList)){
							return;
						}

						saleInfoList.forEach(function(saleInfo){
							if(!isInDateRange(saleInfo.getSaleDateMomentObj(), null, endDateMoment) || saleInfo.is_canceled){
								return;
							}

							var previousPurchaseInfo = findPurchaseInfoSameOrBeforeDate(saleInfo.getSaleDateMomentObj(), purchaseInfoList);
							const nextPurchaseInfo = findPurchaseInfoAfterDate(saleInfo.getSaleDateMomentObj(), purchaseInfoList);

							if(!previousPurchaseInfo){
								queue.push($q.reject("Can not find previous purchase info. vehicleID: " + vehicleID));
								return;
							}

							var billOfSale = new BillOfSale(vehicleID, saleInfo.getResourceID());
							const warrantyTimeRange = getWarrantyTimeRange(previousPurchaseInfo, saleInfo, nextPurchaseInfo);

							queue.push($q.all({
								purchaseInfo: $q.resolve(previousPurchaseInfo),
								tasks: getTasksForPurchaseInfo(previousPurchaseInfo.getResourceID(), purchaseInfoList, vehicleID),
								workordersDetail: getWorkordersDetailByTimeRange(warrantyTimeRange, vehicleID),
								billOfSale: billOfSale.fetchDatas()
							}));
						});
					});

					return $q.all(queue);					
				})
				.then(function(result){
					GeneralTools.generalExcelSheet({profitReport:buildProfitReportData(result)}, "Profit Report");
					defer.resolve();
				})
				.catch(function(error){
					defer.reject(error);
				});

				return defer.promise;	
		}

		function getWarrantyTimeRange(previousPurchaseInfo, currentSaleInfo, nextPurchaseInfo){
			if(!previousPurchaseInfo || !currentSaleInfo){
				return;
			}

			const previousPurchaseDate = previousPurchaseInfo.getPurchaseDateMomentObj();
			var nextPurchaseDate;

			if(nextPurchaseInfo){
				nextPurchaseDate = nextPurchaseInfo.getPurchaseDateMomentObj();
			}

			if(!previousPurchaseDate){
				return;
			}

			const timeRange = {from: previousPurchaseDate};

			const saleDate = currentSaleInfo.getSaleDateMomentObj();

			var warrantyDate;

			if(saleDate){
				warrantyDate = saleDate.date(saleDate.date() + SaleInfoConstants.warrantyLength);
			}

			if(!nextPurchaseDate || (warrantyDate && warrantyDate.isBefore(nextPurchaseDate))){
				timeRange.to = warrantyDate;
			} else {
				timeRange.to = nextPurchaseDate;
			}

			return timeRange;			
		}

		function getWorkordersDetailByTimeRange(timeRange, vehicleID){
			if(!timeRange){
				return $q.reject("Failed to fetch workorders detail, time range invalid.");
			}

			const resourcePath = {
				companyID: companyID,
				vehicleID: vehicleID
			};

			const queue = [];

			return WorkOrderService.getWorkOrders(resourcePath).$promise
				.then(function(workorders){
					if(!Array.isArray(workorders)){
						return $q.reject("workorders data invalid.");
					}
					
					workorders.forEach(function(workorder){
						if(!workorder){
							return
						}

						const completedDate = workorder.getCompletedDateTimeMomentObj();
						if(!completedDate || !workorder.isCompleted()){
							return;
						}

						if(timeRange.from && completedDate.isBefore(timeRange.from)){
							return;
						}

						if(timeRange.to && completedDate.isAfter(timeRange.to)){
							return;
						}

						if(!queue[workorder.id_work_order]){
							queue.push($q.all({
								workorderData: $q.resolve(workorder),
								partData: fetchPartsData(companyID, vehicleID, workorder.id_work_order),
								inventoryData: fetchInventoriesData(companyID, vehicleID, workorder.id_work_order)
							}));
						}
					});

					return $q.all(queue);
				});
		}

		function fetchPartsData(companyID, vehicleID, workOrderID){
			const resourcePath = { 
				companyID: companyID,
				vehicleID: vehicleID,
				workorderID: workOrderID
			};

			return WorkOrderService.getWorkOrderParts(resourcePath).$promise
		}

		function fetchInventoriesData(companyID, vehicleID, workOrderID){
			const resourcePath = { 
				companyID: companyID,
				vehicleID: vehicleID,
				workorderID: workOrderID
			};

			return WorkOrderService.getWorkOrderInventories(resourcePath).$promise
		}

		this.generateProfitReport = function(vehicleResourcePath, vehicleFilters, startDateMomnet, endDateMoment){
			var defer = $q.defer();

			VehicleService.getAllMatchedVehicles(vehicleResourcePath, vehicleFilters)
				.then(function(vehicles){
					var queue = {};

					vehicles.forEach(function(vehicle){
						var vehicleID = vehicle.getResourceID();
						var resourcePath = {
							companyID: vehicleResourcePath.companyID,
							vehicleID: vehicleID
						}

						queue[vehicleID] = $q.all({
							saleInfos:SaleInfoService.getVehicleSaleInfos(resourcePath),
							purchaseInfos:PurchaseInfoService.getPurchaseInfos(resourcePath),
						});
					})

					return $q.all(queue);
				})
				.then(function(result){
					var vehicleIdList = Object.keys(result);
					var queue = [];

					vehicleIdList.forEach(function(vehicleID){
						var saleInfoList = result[vehicleID].saleInfos;
						var purchaseInfoList = result[vehicleID].purchaseInfos;

						if(!Array.isArray(saleInfoList)){
							return;
						}

						saleInfoList.forEach(function(saleInfo){
							if(!isInDateRange(saleInfo.getSaleDateMomentObj(), startDateMomnet, endDateMoment) || saleInfo.is_canceled){
								return;
							}

							var previousPurchaseInfo = findPurchaseInfoSameOrBeforeDate(saleInfo.getSaleDateMomentObj(), purchaseInfoList);
							const nextPurchaseInfo = findPurchaseInfoAfterDate(saleInfo.getSaleDateMomentObj(), purchaseInfoList);

							if(!previousPurchaseInfo){
								queue.push($q.reject("Can not find previous purchase info. vehicleID: " + vehicleID));
								return;
							}

							var billOfSale = new BillOfSale(vehicleID, saleInfo.getResourceID());
							const warrantyTimeRange = getWarrantyTimeRange(previousPurchaseInfo, saleInfo, nextPurchaseInfo);

							queue.push($q.all({
								purchaseInfo: $q.resolve(previousPurchaseInfo),
								tasks: getTasksForPurchaseInfo(previousPurchaseInfo.getResourceID(), purchaseInfoList, vehicleID),
								workordersDetail: getWorkordersDetailByTimeRange(warrantyTimeRange, vehicleID),
								billOfSale: billOfSale.fetchDatas(),
								price: PurchaseInfoService.getPurchaseInfoPrices({companyID: LoginService.getCompanyID(), vehicleID: vehicleID, purchaseinfoID: previousPurchaseInfo.getResourceID()})
							}));
						});
					});

					return $q.all(queue);					
				})
				.then(function(result){
					GeneralTools.generalExcelSheet({profitReport:buildProfitReportData(result)}, "Profit Report");
					defer.resolve();
				})
				.catch(function(error){
					defer.reject(error);
				});

				return defer.promise;	
		}

		function buildProfitReportData(dataList){
			var profitReport = [newProfitReportHeader];

			dataList = $filter('orderBy')(dataList, "billOfSale.saleInfo.sale_date")

			dataList.forEach(function(data, index){
				profitReport.push(getProfitReportSheetDataRowVersion2(data.purchaseInfo, data.billOfSale, data.tasks, data.workordersDetail, data.price, index + 1));
			});

			return profitReport;
		}

		function getTasksForPurchaseInfo(purchaseInfoID, purchaseInfoList, vehicleID){
			var timeRange = findTimeRangeBetweenCurrentAndNextPurchase(purchaseInfoID, purchaseInfoList)

			if(!timeRange){
				return $q.reject("Task time range is invalid");
			}

			var tasksFilter = tasksFilterBuilder(timeRange, vehicleID);

			if(!tasksFilter){
				return $q.reject("Task filter is invalid");
			}

			var resourcePath = {companyID: LoginService.getCompanyID()};

			return TasksService.getAllMatchedTasks(resourcePath,  {filters: tasksFilter})
				.then(function(tasks){
					if(!Array.isArray(tasks)){
						return $q.reject("Tasks data invalid.");
					}

					return $q.resolve(tasks);
				})
		}

		function tasksFilterBuilder(timeRange, vehicleID){
			var filterString = "(id_vehicle eq " + vehicleID + ") AND (cost gt 0)";

			if(!timeRange){
				return filterString;
			}

			var fromFilterString = '';
			var toFilterString = '';

			if(timeRange.from){
				const timeString = timeRange.from.utc().format("YYYY-MM-DD HH:mm:ss");
				fromFilterString = "((created_date gt " + timeString + ") OR (created_date eq " + timeString + "))";	
			}

			if(timeRange.to){
				const timeString = timeRange.to.utc().format("YYYY-MM-DD HH:mm:ss");
				toFilterString = "((created_date lt " + timeString + ") OR (created_date eq " + timeString + "))";	
			}

			filterString = GeneralTools.stringConnector(filterString, fromFilterString, " AND ");
			filterString = GeneralTools.stringConnector(filterString, toFilterString, " AND ");

			return filterString;
		}

		function findTimeRangeBetweenCurrentAndNextPurchase(currentPurchaseInfoID, allPurchaseInfos){
			//allPurchaseInfos and allSaleInfos is ordered by date from backend;
			if(!Array.isArray(allPurchaseInfos)){
				allPurchaseInfos = [];
			}

			var timeRange = {};
			var currentPurchaseInfo;
			var nextPurchaseInfo;

			currentPurchaseInfo = allPurchaseInfos.find(function(purchaseInfo){
				return currentPurchaseInfoID == purchaseInfo.getResourceID();
			});

			if(currentPurchaseInfo == null){
				return;
			}

			var currentPurchaseInfoDate = currentPurchaseInfo.getPurchaseDateMomentObj();

			nextPurchaseInfo = allPurchaseInfos.reverse().find(function(purchaseInfo){
				var purchaseDate = purchaseInfo.getPurchaseDateMomentObj();

				if(purchaseDate && currentPurchaseInfoDate){
					return purchaseDate.isAfter(currentPurchaseInfoDate);
				}
			});

			timeRange.from = currentPurchaseInfoDate//.utc().format("YYYY-MM-DD HH:mm:ss");

			if(nextPurchaseInfo){
				timeRange.to = nextPurchaseInfo.getPurchaseDateMomentObj()//.utc().format("YYYY-MM-DD HH:mm:ss");
			}			

			return timeRange;
		}

		function findPurchaseInfoSameOrBeforeDate(momentObj, purchaseInfos){
			if(!momentObj || !momentObj.isValid() || !Array.isArray(purchaseInfos)){
				return;
			}

			var reversedPurchaseList = $filter('orderBy')(purchaseInfos, "purchase_date", true);

			return reversedPurchaseList.find(function(purchaseInfo){
				return !purchaseInfo.is_canceled && purchaseInfo.getPurchaseDateMomentObj().isSameOrBefore(momentObj);
			});
		}

		function findPurchaseInfoAfterDate(momentObj, purchaseInfos){
			if(!momentObj || !momentObj.isValid() || !Array.isArray(purchaseInfos)){
				return;
			}

			var sortedPurchaseList = $filter('orderBy')(purchaseInfos, "purchase_date");

			return sortedPurchaseList.find(function(purchaseInfo){
				return !purchaseInfo.is_canceled && purchaseInfo.getPurchaseDateMomentObj().isAfter(momentObj);
			});
		}

		this.generateSaleReport = function(vehicleResourcePath, vehicleFilters, startDateMomnet, endDateMoment){
			var defer = $q.defer();
			var vehicleList = [];

			VehicleService.getAllMatchedVehicles(vehicleResourcePath, vehicleFilters)
				.then(function(vehicles){
					var tasks = {};
					vehicleList = vehicles;
					vehicles.forEach(function(vehicle){
						var vehicleID = vehicle.getResourceID();
						var saleInfoResourcePath = {
							companyID: vehicleResourcePath.companyID,
							vehicleID: vehicleID
						}

						tasks[vehicleID] = SaleInfoService.getVehicleSaleInfos(saleInfoResourcePath);
					})

					return $q.all(tasks);
				})
				.then(function(result){
					var vehicleIdList = Object.keys(result);
					var tasks = [];

					vehicleIdList.forEach(function(vehicleID, index){
						var saleInfoList = result[vehicleID];

						if(!Array.isArray(saleInfoList)){
							return;
						}

						saleInfoList.forEach(function(saleInfo){
							if(!isInDateRange(saleInfo.getSaleDateMomentObj(), startDateMomnet, endDateMoment) || saleInfo.is_canceled){
								return;
							}

						 	var billOfSale = new BillOfSale(vehicleID, saleInfo.getResourceID());

						 	tasks.push(billOfSale.fetchDatas());
						});
					});

					return $q.all(tasks);
				})
				.then(function(result){	
					var billOfSaleList = $filter('orderBy')(result, "saleInfo.sale_date");

					GeneralTools.generalExcelSheet({soldReport:buildSaleReportData(vehicleList, billOfSaleList)}, "Sold Report");
					defer.resolve();
				})
				.catch(function(error){
					defer.reject(error);
				});

			return defer.promise;
		}

		this.generatePurchaseReport = function(vehicleResourcePath, vehicleFilters, startDateMomnet, endDateMoment){
			var defer = $q.defer();
			var vehicleList = [];
			var auctionOptions;

			PurchaseInfoService.getAuction()
				.then(function(auctions){
					auctionOptions = auctions;
					return VehicleService.getAllMatchedVehicles(vehicleResourcePath, vehicleFilters);
				})
				.then(function(vehicles){
					if(!Array.isArray(vehicles)){
						return $q.reject("Failed to general purchase report, because vehicle data is invalid.");
					}

					var tasks = [];
					vehicleList = vehicles;

					vehicleList.forEach(function(vehicle){
						var vehicleID = vehicle.getResourceID();
						var purchaseInfoResourcePath = {
							companyID: vehicleResourcePath.companyID,
							vehicleID: vehicleID
						}

						tasks.push(PurchaseInfoService.getPurchaseInfos(purchaseInfoResourcePath));
					})

					return $q.all(tasks);
				})
				.then(function(result){
					var purchaseInfoList  = [];

					result.forEach(function(itemList){
						purchaseInfoList = purchaseInfoList.concat(itemList);
					})

					purchaseInfoList = reorganizePurchaseInfoList(purchaseInfoList, startDateMomnet, endDateMoment);

					GeneralTools.generalExcelSheet(buildPurcahseReportData(vehicleList, purchaseInfoList, auctionOptions), "Purchase Report");

					defer.resolve();	
				})
				.catch(function(error){
					console.error("Failed to general report.");
					defer.reject(error);
				})

			return defer.promise;
		}

		function buildSaleReportData(vehicleList, billOfSaleList){
			var vehicleMap = {};
			var soldSheet = [];

			if(!Array.isArray(vehicleList) || !Array.isArray(vehicleList)){
				return;
			}

			vehicleList.forEach(function(vehicle){
				var vehicleID = vehicle.getResourceID();;

				if(!vehicleMap[vehicleID]){
					vehicleMap[vehicleID] = vehicle;
				}
			});

			soldSheet.push(soldReportHeader);
			
			billOfSaleList.forEach(function(billOfSale, index){
				if(!billOfSale || !billOfSale.saleInfo){
					return;
				}
				soldSheet.push(getSaleReportSheetDataRow(billOfSale, vehicleMap[billOfSale.saleInfo.fk_id_vehicle], index + 1));
			});

			return soldSheet;
		}

		function getProfitReportSheetDataRow(purchaseInfo, billOfSale, tasks, workordersDetail, purchaseInfoPrice, itemNumber){
			if(!billOfSale){
				return;
			}

			var billOfSaleCalculator = getGetBillOfSaleCalculator(billOfSale);
			var purchaseCalculator = getGetPurchaseCalculator(purchaseInfo, tasks, workordersDetail);

			var year;
			var make;
			var model;
			var vin;
			var salePerson;

			if(billOfSale.vehicle){
				year = billOfSale.vehicle.year;
				make = billOfSale.vehicle.make;
				model = billOfSale.vehicle.model;
				vin = billOfSale.vehicle.vin;
			}

			if(billOfSale.salePerson){
				salePerson = billOfSale.salePerson.first_name + ' ' + billOfSale.salePerson.last_name;
			}

			var saleDate;
			var dealerReserve = 0;
			var licensingCostInSale = 0;
			var commissionPayout = 0;

			if(billOfSale.saleInfo){
				saleDate = billOfSale.saleInfo.sale_date;
				dealerReserve = castToNumber(castToNumber(billOfSale.saleInfo.dealer_reserve, 2) / (1 + billOfSaleCalculator.getTaxRate()), 2);
				licensingCostInSale = castToNumber(billOfSale.saleInfo.licensing_cost, 2);
				commissionPayout = castToNumber(billOfSale.saleInfo.commission_payout, 2);
			}

			var warrantyCost = 0;

			if(billOfSale.warranty){
				warrantyCost = castToNumber(billOfSale.warranty.cost, 2);
			}

			var purchaseDate;

			if(purchaseInfo){
				purchaseDate = purchaseInfo.purchase_date;
			}

			var saleLicensingPrice = castToNumber(billOfSaleCalculator.getLicensingPrice(), 2);
			var licensingCostInPurchase = castToNumber(purchaseCalculator.getLicensingCost(), 2);

			var totalCost = castToNumber(purchaseCalculator.getSubTotalBeforeTax() + licensingCostInPurchase + licensingCostInSale + warrantyCost + commissionPayout, 2);
			var totalIncome = castToNumber(billOfSaleCalculator.getSubTotalBeforeTradeIn() + saleLicensingPrice + dealerReserve, 2);

			return [
				itemNumber,
				year,
				make,
				model,
				vin,
				saleDate,
				castToNumber(billOfSaleCalculator.getSalePrice(), 2),
				castToNumber(billOfSaleCalculator.getWarrantyPrice(), 2),
				castToNumber(billOfSaleCalculator.getFinanceApplicationFee(), 2),
				castToNumber(billOfSaleCalculator.getTotalAccessoriesPrice(), 2),
				castToNumber(billOfSaleCalculator.getTotalPromotionsDiscount(), 2),
				saleLicensingPrice,
				dealerReserve,
				purchaseDate,
				castToNumber(purchaseCalculator.getPurchasePrice(), 2),
				warrantyCost,
				castToNumber(purchaseCalculator.getBuyerFee(), 2),
				castToNumber(purchaseCalculator.getShippingCost(), 2),
				castToNumber(purchaseCalculator.getOtherCost(), 2),
				castToNumber(purchaseCalculator.getTaskTotalCost(), 2),	
				purchaseCalculator.getWorkorderTotalCost(),	
				licensingCostInSale,
				licensingCostInPurchase,
				commissionPayout,
				totalIncome,
				totalCost,	
				castToNumber(totalIncome - totalCost, 2),
				salePerson
			];
		}


		function getSaleReportSheetDataRow(billOfSale, vehicle, itemNumber){
			if(!billOfSale){
				return;
			}

			var saleDate;
			var salePrice;
			var financeFee;
			var taxRate = 0;
			var grossLicenceFee = 0;
			var licenceFeeHST = 0;
			var netLicenceFee = 0;
			var grossDealerReserve = 0;
			var dealerReserveHST = 0;
			var netDealerReserve = 0;
			var lineFeeGoToBankDirectly = 0;
			var soldBy;
			var commissionPayout = 0;
			var customerName = '';

			if(billOfSale.saleInfo){
				saleDate = billOfSale.saleInfo.sale_date;
				salePrice = billOfSale.saleInfo.sale_price;
				financeFee = billOfSale.saleInfo.finance_application_fee;
				taxRate = billOfSale.saleInfo.tax_rate;
				grossLicenceFee = billOfSale.saleInfo.licensing_fee;
				netLicenceFee = getNetPriceBaseOnGrossPrice(grossLicenceFee, taxRate);
				licenceFeeHST = grossLicenceFee - netLicenceFee;
				grossDealerReserve = billOfSale.saleInfo.dealer_reserve;
				netDealerReserve = getNetPriceBaseOnGrossPrice(grossDealerReserve, taxRate);
				dealerReserveHST = grossDealerReserve - netDealerReserve;
				lineFeeGoToBankDirectly = billOfSale.saleInfo.lien_registration;
				commissionPayout = billOfSale.saleInfo.commission_payout;
			}

			if(billOfSale.salePerson){
				soldBy = billOfSale.salePerson.first_name + ' ' + billOfSale.salePerson.last_name;
			}

			var warranty = 0;
			if(billOfSale.warranty){
				warranty = billOfSale.warranty.retail;
			}

			var tradeInPrice = 0;
			if(billOfSale.tradeInVehicle && billOfSale.tradeInVehicle.trade_in_price){
				tradeInPrice = billOfSale.tradeInVehicle.trade_in_price;
			}
			var year;
			var make;
			var model;
			var vin;

			if(vehicle){
				year = vehicle.year;
				make = vehicle.make;
				model = vehicle.model;
				vin = vehicle.vin;
			}

			var calculator = getGetBillOfSaleCalculator(billOfSale);
			var accessories = 0;
			var promotionsDiscounts = 0;
			var subTotalBeforTradeIn = 0;
			var netTotalMinusTradeIn = 0;
			var HST = 0;
			var deposit = 0;
			var totalBalance = 0;
			if(calculator){
				accessories = calculator.getTotalAccessoriesPrice();
				promotionsDiscounts = calculator.getTotalPromotionsDiscount();
				subTotalBeforTradeIn = calculator.getSubTotalBeforeTradeIn();
				netTotalMinusTradeIn = subTotalBeforTradeIn - tradeInPrice;
				HST = calculator.getTax();
				deposit = calculator.getTotalPaymentsPrice();
				//totalBalance = calculator.getTotalBalanceDue();
			}

			var TotalHstOnSalesReportToHst = 0;
			TotalHstOnSalesReportToHst = GeneralTools.addToTotal(TotalHstOnSalesReportToHst, HST);
			TotalHstOnSalesReportToHst = GeneralTools.addToTotal(TotalHstOnSalesReportToHst, licenceFeeHST);
			TotalHstOnSalesReportToHst = GeneralTools.addToTotal(TotalHstOnSalesReportToHst, dealerReserveHST);

			var TotalNetOnSalesReportToHst = 0;
			TotalNetOnSalesReportToHst = GeneralTools.addToTotal(TotalNetOnSalesReportToHst, netTotalMinusTradeIn);
			TotalNetOnSalesReportToHst = GeneralTools.addToTotal(TotalNetOnSalesReportToHst, netLicenceFee);
			TotalNetOnSalesReportToHst = GeneralTools.addToTotal(TotalNetOnSalesReportToHst, netDealerReserve);

			var totalIncludedHstTotal = 0;
			totalIncludedHstTotal = GeneralTools.addToTotal(totalIncludedHstTotal, TotalHstOnSalesReportToHst);
			totalIncludedHstTotal = GeneralTools.addToTotal(totalIncludedHstTotal, TotalNetOnSalesReportToHst);
			totalIncludedHstTotal = GeneralTools.addToTotal(totalIncludedHstTotal, lineFeeGoToBankDirectly);

			var subTotal2 = 0;
			subTotal2 = GeneralTools.addToTotal(subTotal2, totalIncludedHstTotal);
			subTotal2 = GeneralTools.addToTotal(subTotal2, grossDealerReserve * -1);
			subTotal2 = GeneralTools.addToTotal(subTotal2, lineFeeGoToBankDirectly * -1);

			totalBalance = GeneralTools.addToTotal(subTotal2, deposit * -1);
			totalBalance = GeneralTools.addToTotal(totalBalance, lineFeeGoToBankDirectly);

			if(billOfSale.customer){
				customerName = billOfSale.customer.first_name + ' ' + billOfSale.customer.last_name;
			}


			return [
				itemNumber,
				saleDate,
				soldBy,
				castToNumber(commissionPayout, 2),
				year,
				make,
				model,
				vin,
				castToNumber(salePrice, 2),
				castToNumber(warranty, 2),
				castToNumber(financeFee, 2),
				castToNumber(accessories, 2),
				castToNumber(promotionsDiscounts, 2),
				castToNumber(subTotalBeforTradeIn, 2),
				castToNumber(tradeInPrice, 2),
				castToNumber(netTotalMinusTradeIn, 2),
				castToNumber(taxRate, 2),
				castToNumber(HST, 2),
				null,
				castToNumber(netLicenceFee, 2),
				castToNumber(licenceFeeHST, 2),
				castToNumber(grossLicenceFee, 2),
				null,
				castToNumber(netDealerReserve, 2),
				castToNumber(dealerReserveHST, 2),
				castToNumber(grossDealerReserve, 2),
				null,
				castToNumber(TotalHstOnSalesReportToHst, 2),
				castToNumber(TotalNetOnSalesReportToHst, 2),
				castToNumber(lineFeeGoToBankDirectly, 2),
				null,
				castToNumber(totalIncludedHstTotal, 2),
				null,
				castToNumber(deposit, 2),
				castToNumber(subTotal2, 2),
				castToNumber(totalBalance, 2),
				customerName
			];
		}

		function castToNumber(variable, fractionSize){
			var number = parseFloat(variable);

			if(isNaN(number)){
				number = 0;
			}

			var precision = Math.pow(10, fractionSize);

			return Math.round( number * precision ) / precision;
		}

		function getNetPriceBaseOnGrossPrice(grossPrice, taxRate){
			var grossPriceNumber = parseFloat(grossPrice);
			var taxRateNumber = parseFloat(taxRate);

			if(isNaN(grossPriceNumber) || isNaN(taxRateNumber)){
				return 0;
			}

			return castToNumber(grossPriceNumber / (1 + taxRate), 2);
		}

		function getGetPurchaseCalculator(purchaseInfo, tasks, workordersDetail){
			var purchaseCalculator = new PurchaseCalculator();

			if(purchaseInfo){
				purchaseCalculator.setPurchasePrice(purchaseInfo.purchase_price);
				purchaseCalculator.setBuyerFee(purchaseInfo.buyer_fee);
				purchaseCalculator.setShippingCost(purchaseInfo.shipping_cost);
				purchaseCalculator.setOtherCost(purchaseInfo.other_cost);
				purchaseCalculator.setTaxRate(purchaseInfo.tax_rate);
				purchaseCalculator.setLicensingCost(purchaseInfo.licensing_cost);
			}

			purchaseCalculator.setWorkorderList(workordersDetail);
			purchaseCalculator.setTasks(tasks);

			return purchaseCalculator;
		}

		function getGetBillOfSaleCalculator(billOfSale){
			var saleCalculator = new SaleCalculator();

			if(!billOfSale){
				return;
			}

			if(billOfSale.saleInfo != null){
				saleCalculator.setSalePrice(billOfSale.saleInfo.sale_price);
				saleCalculator.setOmvic(billOfSale.saleInfo.omvic);
				saleCalculator.setTaxRate(billOfSale.saleInfo.tax_rate);
				saleCalculator.setLicensingPrice(billOfSale.saleInfo.licensing_fee);
				saleCalculator.setFinanceApplicationFee(billOfSale.saleInfo.finance_application_fee);
				saleCalculator.setLienRegistrationFee(billOfSale.saleInfo.lien_registration);
				saleCalculator.setBankAdminFee(billOfSale.saleInfo.bank_admin_fee);
			}
			
			if(billOfSale.warranty != null){
				saleCalculator.setWarrantyPrice(billOfSale.warranty.retail);
			}else{
				saleCalculator.setWarrantyPrice(null);	
			}

			if(billOfSale.tradeInVehicle != null){
				saleCalculator.setTradeInPrice(billOfSale.tradeInVehicle.trade_in_price);	
				saleCalculator.setTradeLienPayout(billOfSale.tradeInVehicle.trade_lien_payout);
			}else{
				saleCalculator.setTradeInPrice(null);	
				saleCalculator.setTradeLienPayout(null);
			}
			saleCalculator.setSalePackages(billOfSale.salePackages);
			saleCalculator.setSaleExtras(billOfSale.saleExtras);
			saleCalculator.setPromotions(billOfSale.promotions);
			saleCalculator.setPayments(billOfSale.payments);

			return saleCalculator;
		}

		function reorganizePurchaseInfoList(purchaseInfoList, startDateMomnet, endDateMoment){
			if(!Array.isArray(purchaseInfoList)){
				return;
			}

			purchaseInfoList = $filter('orderBy')(purchaseInfoList, "purchase_date");

			return purchaseInfoList.filter(function(purchaseInfo){
				return !purchaseInfo.is_canceled && isInDateRange(purchaseInfo.getPurchaseDateMomentObj(), startDateMomnet, endDateMoment);
			})
		}

		function isInDateRange(dateMomentToCheck, startDateMomnet, endDateMoment){
			if(!dateMomentToCheck){
				return false;
			}

			if(startDateMomnet && !dateMomentToCheck.isSameOrAfter(startDateMomnet)){
				return false;
			}

			if(endDateMoment && !dateMomentToCheck.isSameOrBefore(endDateMoment)){
				return false;
			}

			return true;
		}

		function buildPurcahseReportData(vehicles, purchaseInfos, auctionOptions){
			if(!Array.isArray(vehicles) || !Array.isArray(purchaseInfos)){
				return
			}

			if(!Array.isArray(auctionOptions)){
				auctionOptions = [];
			}

			var vehicleMap = {};
			var purchaseSheet = [];
			var sumPurchasePrice = 0;
			var sumBuyerFee = 0;
			var sumOtherCost = 0;
			var sumShippingCost = 0;
			var sumSubTotal = 0;
			var sumTax = 0;
			var sumTotal = 0;

			vehicles.forEach(function(vehicle){
				var vehicleID = vehicle.getResourceID();
				if(!vehicleMap[vehicleID]){
					vehicleMap[vehicleID] = vehicle;
				}
			})
			purchaseSheet.push(purchaseReportHeader);
			purchaseInfos.forEach(function(purchaseInfo, index){
				var vehicle = vehicleMap[purchaseInfo.fk_id_vehicle];
				var subTotal = 0;

				subTotal = GeneralTools.addToTotal(subTotal, purchaseInfo.purchase_price);
				subTotal = GeneralTools.addToTotal(subTotal, purchaseInfo.buyer_fee);
				subTotal = GeneralTools.addToTotal(subTotal, purchaseInfo.other_cost);
				subTotal = GeneralTools.addToTotal(subTotal, purchaseInfo.shipping_cost);

				//var tax = GeneralTools.getHarmonizedSalesTax(subTotal, purchaseInfo.tax_rate);
				var taxTotal = purchaseInfo.purchase_price_after_tax + purchaseInfo.buyer_fee_after_tax + purchaseInfo.other_cost_after_tax + purchaseInfo.shipping_cost_after_tax;
				
				var total = GeneralTools.addToTotal(subTotal, purchaseInfo.purchase_price_after_tax);
				var total = GeneralTools.addToTotal(subTotal, purchaseInfo.licensing_cost_after_tax);
				var total = GeneralTools.addToTotal(subTotal, purchaseInfo.buyer_fee_after_tax);
				var total = GeneralTools.addToTotal(subTotal, purchaseInfo.other_cost_after_tax);
				var total = GeneralTools.addToTotal(subTotal, purchaseInfo.shipping_cost_after_tax);

				var auction = auctionOptions.find(function(auctionOption){
					return auctionOption.id_auction == purchaseInfo.fk_id_auction;
				});

				var venderDescription;

				if(auction){
					venderDescription = auction.auction_name
				}
				purchaseSheet.push([
					index + 1,
					purchaseInfo.purchase_date,
					venderDescription,
					purchaseInfo.vendor_seller,
					vehicle.year,
					vehicle.make,
					vehicle.model,
					vehicle.vin,
					castToNumber(purchaseInfo.purchase_price, 2),
					castToNumber(purchaseInfo.buyer_fee, 2),
					castToNumber(purchaseInfo.other_cost, 2),
					castToNumber(purchaseInfo.shipping_cost, 2),
					castToNumber(subTotal, 2),
					// castToNumber(purchaseInfo.tax_rate, 2),
					purchaseInfo.unique_rates,
					castToNumber(taxTotal, 2),
					castToNumber(total, 2),
					purchaseInfo.check_number,])

				sumPurchasePrice = GeneralTools.addToTotal(sumPurchasePrice, purchaseInfo.purchase_price);
				sumBuyerFee = GeneralTools.addToTotal(sumBuyerFee, purchaseInfo.buyer_fee);
				sumOtherCost = GeneralTools.addToTotal(sumOtherCost, purchaseInfo.other_cost);
				sumShippingCost = GeneralTools.addToTotal(sumShippingCost, purchaseInfo.shipping_cost);
				sumSubTotal = GeneralTools.addToTotal(sumSubTotal, subTotal);
				sumTax = GeneralTools.addToTotal(sumTax, taxTotal);
				sumTotal = GeneralTools.addToTotal(sumTotal, total);
			})

			purchaseSheet.push([
					"Total",
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					castToNumber(sumPurchasePrice, 2),
					castToNumber(sumBuyerFee, 2),
					castToNumber(sumOtherCost, 2),
					castToNumber(sumShippingCost, 2),
					castToNumber(sumSubTotal, 2),
					null,
					castToNumber(sumTax, 2),

					castToNumber(sumTotal, 2),
					null])

			return {purchaseSheet:purchaseSheet};
		}

		function buildPurchaseReportDataVersion2(vehicles, purchaseInfos, auctionOptions) {
			if (!Array.isArray(vehicles) || !Array.isArray(purchaseInfos)) {
				return;
			}
		
			if (!Array.isArray(auctionOptions)) {
				auctionOptions = [];
			}
		
			var vehicleMap = {};
			var purchaseSheet = [];
			var totalSummary = {
				purchasePrice: 0,
				buyerFee: 0,
				shippingCost: 0,
				subTotal: 0,
				tax: 0,
				total: 0,
				licensingCost: 0,
				otherCost: 0
			};
		
			vehicles.forEach(function (vehicle) {
				var vehicleID = vehicle.getResourceID();
				if (!vehicleMap[vehicleID]) {
					vehicleMap[vehicleID] = vehicle;
				}
			});
		
			purchaseSheet.push(newPurchaseReportHeader);
		
			purchaseInfos.forEach(function (purchaseInfo, index) {
				var purchaseCalculator = getGetPurchaseCalculator(purchaseInfo, purchaseInfo.tasks, purchaseInfo.workordersDetail);
		
				var localSums = {
					purchasePrice: 0,
					buyerFee: 0,
					licensingCost: 0,
					shippingCost: 0,
					otherCost: 0,
					subTotal: 0,
					tax: 0,
					total: 0,
					taxRate: "",
					groupedPricesByTax: [],
					groupedPricesByType: []
				};
		
				localSums.groupedPricesByTax = groupPricesByTax(purchaseInfo.prices, localSums);
				localSums.groupedPricesByType = groupPricesByType(purchaseInfo.prices, localSums);
				if(localSums.groupedPricesByType.length > 0){
					localSums.groupedPricesByType.forEach(function(item){
						switch(item.fk_id_price_type){
							case 1:
								localSums.purchasePrice = item.total;
								break;
							case 2:
								localSums.buyerFee = item.total;
								break;
							case 3:
								localSums.licensingCost = item.total;
								break;
							case 4:
								localSums.shippingCost = item.total;
								break;
							case 5:
								localSums.otherCost = item.total;
								break;
						}
					})
				}
		
				localSums.subTotal += purchaseCalculator.getTaskTotalCost() + purchaseCalculator.getWorkorderTotalCost();
				localSums.tax += (purchaseCalculator.getTaskTotalCost() + purchaseCalculator.getWorkorderTotalCost()) * 0.13;
				localSums.total = localSums.subTotal + localSums.tax;
		
				if (localSums.taxRate.length > 0) {
					localSums.taxRate = localSums.taxRate.slice(0, -2); // Remove last comma
				}
		
				var vehicle = vehicleMap[purchaseInfo.fk_id_vehicle];
				var auction = auctionOptions.find(function (option) {
					return option.id_auction === purchaseInfo.fk_id_auction;
				});
		
				var vendorDescription = auction ? auction.auction_name : '';
		
				purchaseSheet.push([
					index + 1,
					purchaseInfo.purchase_date,
					vendorDescription,
					purchaseInfo.vendor_seller,
					vehicle.year,
					vehicle.make,
					vehicle.model,
					vehicle.vin,
					castToNumber(localSums.purchasePrice, 2),
					castToNumber(localSums.buyerFee, 2),
					castToNumber(localSums.licensingCost, 2),
					castToNumber(localSums.shippingCost, 2),
					castToNumber(localSums.otherCost, 2),
					castToNumber(localSums.subTotal, 2),
					localSums.taxRate,
					castToNumber(localSums.tax, 2),
					castToNumber(localSums.total, 2),
					purchaseInfo.check_number
				]);
		
				updateTotalSummary(totalSummary, localSums);
			});
		
			purchaseSheet.push([
				"Total",
				null,
				null,
				null,
				null,
				null,
				null,
				null,
				castToNumber(totalSummary.purchasePrice, 2),
				castToNumber(totalSummary.buyerFee, 2),
				castToNumber(totalSummary.licensingCost, 2),
				castToNumber(totalSummary.shippingCost, 2),
				castToNumber(totalSummary.otherCost, 2),
				castToNumber(totalSummary.subTotal, 2),
				null,
				castToNumber(totalSummary.tax, 2),
				castToNumber(totalSummary.total, 2),
				null
			]);
		
			return { purchaseSheet: purchaseSheet };
		}
		
		// Helper function to group prices by tax rate
		function groupPricesByTax(prices, localSums) {
			return prices.reduce(function (acc, item) {
				var group = acc.find(function (g) {
					return g.rate === item.rate;
				});
				localSums.tax += item.amount * item.rate;
				if (group) {
					group.items.push(item);
					group.total += item.amount * item.rate;
				} else {
					acc.push({ rate: item.rate, items: [item], total: item.amount * item.rate });
					if (item.rate > 0) {
						localSums.taxRate += (item.rate * 100).toFixed(2) + "%" + ", ";
					}
				}
				return acc;
			}, []);
		}
		
		// Helper function to group prices by price type
		function groupPricesByType(prices, localSums) {
			return prices.reduce(function (acc, item) {
				var group = acc.find(function (g) {
					return g.fk_id_price_type === item.fk_id_price_type;
				});
				localSums.subTotal += item.amount;
				if (group) {
					group.items.push(item);
					group.total += item.amount;
				} else {
					acc.push({ fk_id_price_type: item.fk_id_price_type, items: [item], total: item.amount });
				}
				return acc;
			}, []);
		}
		
		// Helper function to update total summary
		function updateTotalSummary(totalSummary, localSums) {
			totalSummary.purchasePrice += localSums.purchasePrice;
			totalSummary.buyerFee += localSums.buyerFee;
			totalSummary.licensingCost += localSums.licensingCost;
			totalSummary.shippingCost += localSums.shippingCost;
			totalSummary.otherCost += localSums.otherCost;
			totalSummary.subTotal += localSums.subTotal;
			totalSummary.tax += localSums.tax;
			totalSummary.total += localSums.total;
		}

		function getPricesForPurchaseInfo(purchaseInfoID, vehicleID){
			var resourcePath = {
				companyID: LoginService.getCompanyID(),
				vehicleID: item.fk_id_vehicle,
				purchaseinfoID: item.id_purchase_info
			};

			var resourcePath = {companyID: LoginService.getCompanyID()};

			return PurchaseInfoService.getPurchaseInfoPrices(resourcePath)
				.then(function(tasks){
					if(!Array.isArray(tasks)){
						return $q.reject("PurchaseInfo Prices data invalid.");
					}

					return $q.resolve(tasks);
				})
		}

		this.generatePurchaseInfoReportVersion2 = function(vehicleResourcePath, vehicleFilters, startDateMomnet, endDateMoment) {
			var defer = $q.defer();
			var saleInfoList = [];
			var purchaseInfoList = [];
			var vehicleIdList = [];
			var vehicleList = [];
			var auctionOptions;

			PurchaseInfoService.getAuction()
				.then(function(auctions){
					auctionOptions = auctions;
					return VehicleService.getAllMatchedVehicles(vehicleResourcePath, vehicleFilters);
				})
				.then(function(vehicles) {
					var queue = {};
					vehicleList = vehicles;
					vehicles.forEach(function(vehicle) {
						var vehicleID = vehicle.getResourceID();
						var resourcePath = {
							companyID: vehicleResourcePath.companyID,
							vehicleID: vehicleID
						};
		
						queue[vehicleID] = $q.all({
							saleInfos: SaleInfoService.getVehicleSaleInfos(resourcePath),
							purchaseInfos: PurchaseInfoService.getPurchaseInfos(resourcePath),
						});
					});
		
					return $q.all(queue);
				})
				.then(function(result) {
					vehicleIdList = Object.keys(result);
					var queue = [];
		
					vehicleIdList.forEach(function(vehicleID) {
						saleInfoList = result[vehicleID].saleInfos;
						purchaseInfoList = result[vehicleID].purchaseInfos;
		
						if (!Array.isArray(purchaseInfoList)) {
							return;
						}
		
						purchaseInfoList.forEach(function(purchaseInfo) {
							const workOrderTimerange = findTimeRangeForWorkOrderTimeRange(purchaseInfo.getResourceID(), purchaseInfoList, saleInfoList);
		
							queue.push(
								$q.all({
									tasks: getTasksForPurchaseInfo(purchaseInfo.getResourceID(), purchaseInfoList, vehicleID),
									workordersDetail: getWorkordersDetailByTimeRange(workOrderTimerange, vehicleID),
									prices: PurchaseInfoService.getPurchaseInfoPrices({
										companyID: LoginService.getCompanyID(),
										vehicleID: vehicleID,
										purchaseinfoID: purchaseInfo.getResourceID()
									})
								}).then(function(taskResult) {
									purchaseInfo.tasks = taskResult.tasks;
									purchaseInfo.workordersDetail = taskResult.workordersDetail;
									purchaseInfo.prices = taskResult.prices;
		
									return purchaseInfo;
								})
							);
						});
					});
		
					return $q.all(queue);
				})
				.then(function(result) {
					var purchaseInfoList  = [];
					result.forEach(function(itemList){
						purchaseInfoList = purchaseInfoList.concat(itemList);
					})
					purchaseInfoList = reorganizePurchaseInfoList(purchaseInfoList, startDateMomnet, endDateMoment);
					GeneralTools.generalExcelSheet(buildPurchaseReportDataVersion2(vehicleList, purchaseInfoList, auctionOptions), "Purchase Report");
					defer.resolve();
				})
				.catch(function(error) {
					defer.reject(error);
				});
		
			return defer.promise;
		};
		


		this.generatePurchaseInfoReportVersion3 = function(vehicleResourcePath, vehicleFilters, startDateMomnet, endDateMoment) {
			var defer = $q.defer();
			var vehicleList = [];
			var auctionOptions;

			PurchaseInfoService.getAuction()
				.then(function(auctions){
					auctionOptions = auctions;
					return VehicleService.getAllMatchedVehiclesForProfileReport(vehicleResourcePath, vehicleFilters);
				})
				.then(function(vehicles) {
					var queue = [];
					vehicleList = vehicles;

					if(!Array.isArray(vehicles)){
						return $q.reject("Failed to generate purchase report, vehicle data is invalid.");
					}

					vehicles.forEach(function(vehicle) {
						var vehicleID = vehicle.getResourceID();
						var saleInfoList = buildSaleInfoListFromProfileReportVehicle(vehicle);
						var purchaseInfoList = buildPurchaseInfoListFromProfileReportVehicle(vehicle);
						var workOrderList = buildWorkOrderListFromProfileReportVehicle(vehicle);
						var taskList = buildTaskListFromProfileReportVehicle(vehicle);

						if(!Array.isArray(purchaseInfoList)){
							return;
						}

						purchaseInfoList.forEach(function(purchaseInfo) {
							if(!purchaseInfo || purchaseInfo.is_canceled || !isInDateRange(purchaseInfo.getPurchaseDateMomentObj(), startDateMomnet, endDateMoment)){
								return;
							}

							const workOrderTimerange = findTimeRangeForWorkOrderTimeRange(purchaseInfo.getResourceID(), purchaseInfoList.slice(), saleInfoList.slice());

							queue.push(
								$q.all({
									tasks: getTasksForPurchaseInfoWithTaskListVersion3(purchaseInfo.getResourceID(), purchaseInfoList, vehicleID, taskList),
									workordersDetail: getWorkordersDetailByTimeRangeVersion2(workOrderTimerange, vehicleID, workOrderList),
									prices: $q.resolve(getPurchaseInfoPricesWithList(purchaseInfo.getResourceID(), purchaseInfoList))
								}).then(function(result) {
									purchaseInfo.tasks = result.tasks;
									purchaseInfo.workordersDetail = result.workordersDetail;
									purchaseInfo.prices = result.prices;

									return purchaseInfo;
								})
							);
						});
					});

					return $q.all(queue);
				})
				.then(function(purchaseInfoList) {
					purchaseInfoList = reorganizePurchaseInfoList(purchaseInfoList, startDateMomnet, endDateMoment);
					GeneralTools.generalExcelSheet(buildPurchaseReportDataVersion2(vehicleList, purchaseInfoList, auctionOptions), "Purchase Report");
					defer.resolve();
				})
				.catch(function(error) {
					defer.reject(error);
				});

			return defer.promise;
		};

		function buildSaleInfoListFromProfileReportVehicle(vehicle){
			var saleInfoList = [];

			if(!vehicle || !Array.isArray(vehicle.saleInfos)){
				return saleInfoList;
			}

			vehicle.saleInfos.forEach(function(data){
				var rawData = getProfileReportResourceData(data);

				if(!rawData){
					return;
				}

				var saleInfo = new SaleInfo();
				saleInfo.setAttributes(rawData);
				saleInfoList.push(saleInfo);
			});

			return saleInfoList;
		}

		function buildPurchaseInfoListFromProfileReportVehicle(vehicle){
			var purchaseInfoList = [];

			if(!vehicle || !Array.isArray(vehicle.purchaseInfos)){
				return purchaseInfoList;
			}

			vehicle.purchaseInfos.forEach(function(data){
				var rawData = getProfileReportResourceData(data);
				var purchaseInfoPrices = [];

				if(!rawData){
					return;
				}

				if(Array.isArray(rawData.purchaseInfoPrices)){
					rawData.purchaseInfoPrices.forEach(function(priceData){
						var rawPriceData = getProfileReportResourceData(priceData);

						if(!rawPriceData){
							return;
						}

						var price = new PurchaseInfoPrices();
						price.setAttributes(rawPriceData);
						purchaseInfoPrices.push(price);
					});
				}

				rawData.purchaseInfoPrices = purchaseInfoPrices;

				var purchaseInfo = new PurchaseInfo();
				purchaseInfo.setAttributes(rawData);
				purchaseInfoList.push(purchaseInfo);
			});

			return purchaseInfoList;
		}

		function buildWorkOrderListFromProfileReportVehicle(vehicle){
			var workOrderList = [];

			if(!vehicle || !Array.isArray(vehicle.workOrders)){
				return workOrderList;
			}

			vehicle.workOrders.forEach(function(data){
				var rawData = getProfileReportResourceData(data);

				if(!rawData){
					return;
				}

				var workOrder = new WorkOrder();
				workOrder.setAttributes(rawData);
				workOrderList.push(workOrder);
			});

			return workOrderList;
		}

		function buildTaskListFromProfileReportVehicle(vehicle){
			var taskList = [];

			if(!vehicle || !Array.isArray(vehicle.tasks)){
				return taskList;
			}

			vehicle.tasks.forEach(function(data){
				var rawData = getProfileReportResourceData(data);

				if(!rawData){
					return;
				}

				var task = new Task();
				task.setAttributes(rawData);
				taskList.push(task);
			});

			return taskList;
		}

		function getProfileReportResourceData(data){
			if(!data){
				return null;
			}

			return data.resourceData ? data.resourceData : data;
		}

		function findTimeRangeForWorkOrderTimeRange(currentPurchaseInfoID, purchaseInfos, saleInfos){
			const timeRangeBetweenCurrentAndNextPurchase = findTimeRangeBetweenCurrentAndNextPurchase(currentPurchaseInfoID, purchaseInfos);

			if(!timeRangeBetweenCurrentAndNextPurchase || !Array.isArray(saleInfos)){
				return;
			}

			const currentPurchaseDate = timeRangeBetweenCurrentAndNextPurchase.from;
			const nextPurchaseDate = timeRangeBetweenCurrentAndNextPurchase.to;

			if(!currentPurchaseDate){
				return;
			}

			const nextSaleInfo = saleInfos.reverse().find(function(saleInfo){
				if(!saleInfo || saleInfo.is_canceled){
					return;
				}
				const saleDate = saleInfo.getSaleDateMomentObj();
				return saleDate && saleDate.isValid() && currentPurchaseDate.isSameOrBefore(saleDate);
			});

			if(!nextSaleInfo){
				return timeRangeBetweenCurrentAndNextPurchase;
			}

			const timeRange = {from: currentPurchaseDate};

			const saleDate = nextSaleInfo.getSaleDateMomentObj();

			var warrantyDate;

			if(saleDate){
				warrantyDate = saleDate.date(saleDate.date() + SaleInfoConstants.warrantyLength);
			}

			if(!nextPurchaseDate || (warrantyDate && warrantyDate.isBefore(nextPurchaseDate))){
				timeRange.to = warrantyDate;
			} else {
				timeRange.to = nextPurchaseDate;
			}

			return timeRange;
		}

		function getProfitReportSheetDataRowVersion2(purchaseInfo, billOfSale, tasks, workordersDetail, purchaseInfoPrice, itemNumber){
			if(!billOfSale){
				return;
			}

			var billOfSaleCalculator = getGetBillOfSaleCalculator(billOfSale);
			var purchaseCalculator = getGetPurchaseCalculator(purchaseInfo, tasks, workordersDetail);

			var localSums = {
				purchasePrice: 0,
				buyerFee: 0,
				licensingCost: 0,
				shippingCost: 0,
				otherCost: 0,
				subTotal: 0,
				tax: 0,
				total: 0,
				taxRate: "",
				groupedPricesByTax: [],
				groupedPricesByType: []
			};

			localSums.groupedPricesByTax = groupPricesByTax(purchaseInfoPrice, localSums);
			localSums.groupedPricesByType = groupPricesByType(purchaseInfoPrice, localSums);
			if(localSums.groupedPricesByType.length > 0){
				localSums.groupedPricesByType.forEach(function(item){
					switch(item.fk_id_price_type){
						case 1:
							localSums.purchasePrice = item.total;
							break;
						case 2:
							localSums.buyerFee = item.total;
							break;
						case 3:
							localSums.licensingCost = item.total;
							break;
						case 4:
							localSums.shippingCost = item.total;
							break;
						case 5:
							localSums.otherCost = item.total;
							break;
					}
				})
			}
	
			localSums.subTotal += purchaseCalculator.getTaskTotalCost() + purchaseCalculator.getWorkorderTotalCost();
			localSums.tax += (purchaseCalculator.getTaskTotalCost() + purchaseCalculator.getWorkorderTotalCost()) * 0.13;
			localSums.total = localSums.subTotal + localSums.tax;
	
			if (localSums.taxRate.length > 0) {
				localSums.taxRate = localSums.taxRate.slice(0, -2); // Remove last comma
			}

			var year;
			var make;
			var model;
			var vin;
			var salePerson;

			if(billOfSale.vehicle){
				year = billOfSale.vehicle.year;
				make = billOfSale.vehicle.make;
				model = billOfSale.vehicle.model;
				vin = billOfSale.vehicle.vin;
			}

			if(billOfSale.salePerson){
				salePerson = billOfSale.salePerson.first_name + ' ' + billOfSale.salePerson.last_name;
			}

			var saleDate;
			var dealerReserve = 0;
			var licensingCostInSale = 0;
			var commissionPayout = 0;

			if(billOfSale.saleInfo){
				saleDate = billOfSale.saleInfo.sale_date;
				dealerReserve = castToNumber(castToNumber(billOfSale.saleInfo.dealer_reserve, 2) / (1 + billOfSaleCalculator.getTaxRate()), 2);
				licensingCostInSale = castToNumber(billOfSale.saleInfo.licensing_cost, 2);
				commissionPayout = castToNumber(billOfSale.saleInfo.commission_payout, 2);
			}

			var warrantyCost = 0;

			if(billOfSale.warranty){
				warrantyCost = castToNumber(billOfSale.warranty.cost, 2);
			}

			var purchaseDate;

			if(purchaseInfo){
				purchaseDate = purchaseInfo.purchase_date;
			}

			var saleLicensingPrice = castToNumber(billOfSaleCalculator.getLicensingPrice(), 2);

			var totalCost = castToNumber(localSums.subTotal + licensingCostInSale + warrantyCost + commissionPayout, 2);
			var totalIncome = castToNumber(billOfSaleCalculator.getSubTotalBeforeTradeIn() + saleLicensingPrice + dealerReserve, 2);
			
			return [
				itemNumber,
				year,
				make,
				model,
				vin,
				saleDate,
				castToNumber(billOfSaleCalculator.getSalePrice(), 2),
				castToNumber(billOfSaleCalculator.getWarrantyPrice(), 2),
				castToNumber(billOfSaleCalculator.getFinanceApplicationFee(), 2),
				castToNumber(billOfSaleCalculator.getTotalAccessoriesPrice(), 2),
				castToNumber(billOfSaleCalculator.getTotalPromotionsDiscount(), 2),
				saleLicensingPrice,
				dealerReserve,
				purchaseDate,
				castToNumber(localSums.purchasePrice, 2),
				warrantyCost,
				castToNumber(localSums.buyerFee, 2),
				castToNumber(localSums.shippingCost, 2),
				castToNumber(localSums.otherCost, 2),
				castToNumber(purchaseCalculator.getTaskTotalCost(), 2),	
				purchaseCalculator.getWorkorderTotalCost(),	
				licensingCostInSale,
				castToNumber(localSums.licensingCost, 2),
				commissionPayout,
				totalIncome,
				totalCost,	
				castToNumber(totalIncome - totalCost, 2),
				salePerson
			];
		}

		this.generateProfitReportVersion2 = function(vehicleResourcePath, vehicleFilters, startDateMomnet, endDateMoment){
			var defer = $q.defer();
			var phoneCategories = [];
			var emailCategories = [];
			var plateOptions = [];
			var vehicleBrands = [];
			var usersTestDriverList = [];
			var vehicleMap = new Map();
			var testDriverMap = new Map();
			var userTestDriverChecked = false;

			$q.all([
				CustomersService.getCachedPhoneCategories(),
				CustomersService.getCachedEmailCategories(),
				SaleInfoService.getCachedPlateOptions({ companyID: LoginService.getCompanyID() }),
				VehicleService.getCachedVehicleBrands({ companyID: LoginService.getCompanyID() })
			  ])
			  .then(function(results) {
				if (Array.isArray(phoneCategories)) {
				  phoneCategories = results[0];
				}
				if (Array.isArray(emailCategories)) {
				  emailCategories = results[1];
				}
				if (Array.isArray(plateOptions)) {
				  plateOptions = results[2];
				}
				if (Array.isArray(vehicleBrands)) {
				  vehicleBrands = results[3];
				}
			  
				return VehicleService.getAllMatchedVehiclesForProfileReport(vehicleResourcePath, vehicleFilters);
			})
			.then(function(vehicles){
				var queue = {};
				vehicles.forEach(function(vehicle){
					var vehicleID = vehicle.getResourceID();
					vehicleMap.set(vehicleID, vehicle);
					var saleInfoList = [];
					var purchaseInfoList = [];
					var workOrderList = [];
					var taskList = [];
					vehicle.saleInfos.forEach(function(resourceData){
						var saleInfoTradeInList = []
						var saleInfoPromotionList = [];
						var saleInfoPaymetList = [];
						var saleInfoDisclosureList = [];
						var saleInfoPackageList = [];
						var saleInfoExtraList = [];
						var saleInfo = new SaleInfo();
						saleInfo.setAttributes(resourceData.resourceData);
				

						if(saleInfo.tradeInVehicle){
							saleInfo.tradeInVehicle.forEach(function(tradeIn){
								var _tradeInVechile = new TradeInVehicle();
								_tradeInVechile.setAttributes(tradeIn.resourceData);
								saleInfoTradeInList.push(_tradeInVechile);
							})
						}

						if(saleInfo.promotions){
							saleInfo.promotions.forEach(function(promotion){
								var _promotion = new SalePromotion();
								_promotion.setAttributes(promotion.resourceData);
								saleInfoPromotionList.push(_promotion);
							})

						}

						if(saleInfo.payments){
							saleInfo.payments.forEach(function(payment){
								var _payment = new SaleInfoPayment();
								_payment.setAttributes(payment.resourceData);
								saleInfoPaymetList.push(_payment);
							})
						}

						if(saleInfo.disclosures){
							saleInfo.disclosures.forEach(function(disclosure){
								var _disclosure = new Disclosure();
								_disclosure.setAttributes(disclosure);
								saleInfoDisclosureList.push(_disclosure);
							})
						}

						if(saleInfo.salePackages){
							saleInfo.salePackages.forEach(function(temp){
								var _salePackages = new SalePackage();
								_salePackages.setAttributes(temp.resourceData);
								saleInfoPackageList.push(_salePackages)
							})
						}

						if(saleInfo.saleExtra){
							saleInfo.saleExtra.forEach(function(extra){
								var _saleExtras = new SaleExtras();
								_saleExtras.setAttributes(extra.resourceData);
								saleInfoExtraList.push(_saleExtras);
							})
						}

						if(saleInfo.customer){
							if(saleInfo.customer){
								var customer = new Customer();
								customer.setAttributes(saleInfo.customer);
								saleInfo.customer = customer;
							}
						}

						if(saleInfo.warranty && saleInfo.warranty.length > 0){
							var warranty = new SaleWarranty();
							warranty.setAttributes(saleInfo.warranty[0]);
							saleInfo.warranty = warranty;

						}

						if(saleInfo.salePerson && saleInfo.salePerson.length > 0){
							var salePerson = new User();
							salePerson.setAttributes(saleInfo.salePerson[0]);
							saleInfo.salePerson = salePerson
						}

						if(saleInfo.saleManager && saleInfo.saleManager.length > 0){
							var saleManager = new User();
							saleManager.setAttributes(saleInfo.saleManager[0]);
							saleInfo.saleManager = saleManager;
						}

						saleInfo.tradeInVehicle = saleInfoTradeInList;
						saleInfo.promotions = saleInfoPromotionList;
						saleInfo.payments = saleInfoPaymetList;
						saleInfo.disclosures = saleInfoDisclosureList;
						saleInfo.salePackages = saleInfoPackageList;
						saleInfo.saleExtra = saleInfoExtraList;
						saleInfoList.push(saleInfo);
					})

					vehicle.purchaseInfos.forEach(function(data){
						var purchaseInfoPrices = [];
						if(data && data.resourceData.purchaseInfoPrices && data.resourceData.purchaseInfoPrices.length > 0){
							data.resourceData.purchaseInfoPrices.forEach(function(price){
								var _price = new PurchaseInfoPrices();
								_price.setAttributes(price.resourceData);
								purchaseInfoPrices.push(_price);
							})
						}
						data.resourceData.purchaseInfoPrices = purchaseInfoPrices;
						var purchaseInfo = new PurchaseInfo();
						purchaseInfo.setAttributes(data.resourceData); 
						purchaseInfoList.push(purchaseInfo);
					})



					if(vehicle.workOrders && vehicle.workOrders.length > 0){
						vehicle.workOrders.forEach(function(data){
							const workorder = new WorkOrder();
							workorder.setAttributes(data);
							workOrderList.push(workorder);
						})
					}

					if(vehicle.tasks && vehicle.tasks.length > 0){
						vehicle.tasks.forEach(function(data){
							const task = new Task();
							task.setAttributes(data);
							taskList.push(task);
						})

					}
					if(vehicle.testDrive && vehicle.testDrive.length > 0 && !userTestDriverChecked){
						userTestDriverChecked = true;
						vehicle.testDrive.forEach(function(data){
							usersTestDriverList.push({
								vin: data.vin,
								year: data.year,
								make: data.make,
								model: data.model,
								customName: data.customerName,
								userName: data.userName,
								customerUrl: getBaseUrl() + "/customer/" + data.fk_id_customer,
								fk_id_user: data.fk_id_user
							})
							testDriverMap.set(data.fk_id_user, []);
						})
					}

					queue[vehicleID] = $q.all({
						saleInfos: $q.resolve(saleInfoList),
						purchaseInfos: $q.resolve(purchaseInfoList),
						workorders: $q.resolve(workOrderList),
						tasks: $q.resolve(taskList)
					});
				})
				return $q.all(queue);
			})
			.then(function(result){
				usersTestDriverList.forEach(function(testDriver){
					if(testDriverMap.has(testDriver.fk_id_user)){
						testDriverMap.get(testDriver.fk_id_user).push(testDriver);
					}
				});
				var vehicleIdList = Object.keys(result);
				var queue = [];
				vehicleIdList.forEach(function(vehicleID){
					var saleInfoList = result[vehicleID].saleInfos;
					var purchaseInfoList = result[vehicleID].purchaseInfos;
					var workOrderList = result[vehicleID].workorders;
					var taskList = result[vehicleID].tasks;
					if(!Array.isArray(saleInfoList)){
						return;
					}

					saleInfoList.forEach(function(saleInfo){
						if(!isInDateRange(saleInfo.getSaleDateMomentObj(), startDateMomnet, endDateMoment) || saleInfo.is_canceled){
							return;
						}

						var previousPurchaseInfo = findPurchaseInfoSameOrBeforeDate(saleInfo.getSaleDateMomentObj(), purchaseInfoList);
						const nextPurchaseInfo = findPurchaseInfoAfterDate(saleInfo.getSaleDateMomentObj(), purchaseInfoList);

						if(!previousPurchaseInfo){
							queue.push($q.reject("Can not find previous purchase info. vehicleID: " + vehicleID));
							return;
						}

						var billOfSale = new BillOfSale(vehicleID, saleInfo.getResourceID());
						billOfSale.setEmailCategories(phoneCategories)
						billOfSale.setPayments(saleInfo.payments)
						billOfSale.setPlateOptions(plateOptions)
						billOfSale.setSaleExtras(saleInfo.saleExtra)
						billOfSale.setSalePackages(saleInfo.salePackages)
						billOfSale.setPromotions(saleInfo.promotions)
						billOfSale.setSaleInfo([saleInfo])
						billOfSale.setTradeInVehicle([saleInfo.tradeInVehicle])
						billOfSale.setVehicle([vehicleMap.get(Number(vehicleID))])
						billOfSale.setVehicleBrands(vehicleBrands)
						billOfSale.setDisclosures(saleInfo.disclosures)

						billOfSale.setCustomer([saleInfo.customer])
						billOfSale.setWarranty([saleInfo.warranty])
						billOfSale.setSalePerson([saleInfo.salePerson]);
						billOfSale.setSaleManager([saleInfo.saleManager]);
						


						const warrantyTimeRange = getWarrantyTimeRange(previousPurchaseInfo, saleInfo, nextPurchaseInfo);
						queue.push($q.all({
							purchaseInfo: $q.resolve(previousPurchaseInfo),
							tasks: getTasksForPurchaseInfoWithTaskList(previousPurchaseInfo.getResourceID(), purchaseInfoList, vehicleID, taskList),
							workordersDetail: getWorkordersDetailByTimeRangeVersion2(warrantyTimeRange, vehicleID, workOrderList),
							billOfSale: $q.resolve(billOfSale),
							price: getPurchaseInfoPricesWithList(previousPurchaseInfo.getResourceID(), purchaseInfoList)	
						}));
					});
				});

				return $q.all(queue);					
			})
			.then(function(result){
				GeneralTools.generalExcelSheet({profitReport:buildProfitReportData(result)}, "Profit Report", testDriverMap);
				defer.resolve();
			})
			.catch(function(error){
				defer.reject(error);
			});

			return defer.promise;	
		}

		function getWorkordersDetailByTimeRangeVersion2(timeRange, vehicleID, workOrderList){
			if(!timeRange){
				return $q.reject("Failed to fetch workorders detail, time range invalid.");
			}

			const queue = [];

			if(workOrderList && workOrderList.length > 0){
				workOrderList.forEach(function(workorder){
					const completedDate = workorder.getCompletedDateTimeMomentObj();
					if(!completedDate || !workorder.isCompleted()){
						return;
					}

					if(timeRange.from && completedDate.isBefore(timeRange.from)){
						return;
					}

					if(timeRange.to && completedDate.isAfter(timeRange.to)){
						return;
					}

					if(!queue[workorder.id_work_order]){
						queue.push($q.all({
							workorderData: $q.resolve(workorder),
							partData: $q.resolve(workorder.parts),
							inventoryData: $q.resolve(workorder.inventories)
						}));
					}
				});
			}else{
				return $q.resolve([]);
			}
			

			return $q.all(queue);
		}

		this.generateSaleReportVersion2 = function(vehicleResourcePath, vehicleFilters, startDateMomnet, endDateMoment){
			var defer = $q.defer();
			var vehicleList = [];
			var phoneCategories = [];
			var emailCategories = [];
			var plateOptions = [];
			var vehicleBrands = [];
			var vehicleMap = new Map();

			$q.all([
				CustomersService.getCachedPhoneCategories(),
				CustomersService.getCachedEmailCategories(),
				SaleInfoService.getCachedPlateOptions({ companyID: LoginService.getCompanyID() }),
				VehicleService.getCachedVehicleBrands({ companyID: LoginService.getCompanyID() })
			])
			.then(function(results) {
				
				if (Array.isArray(phoneCategories)) {
				phoneCategories = results[0];
				}
				if (Array.isArray(emailCategories)) {
				emailCategories = results[1];
				}
				if (Array.isArray(plateOptions)) {
				plateOptions = results[2];
				}
				if (Array.isArray(vehicleBrands)) {
				vehicleBrands = results[3];
				}
			
				return VehicleService.getAllMatchedVehiclesForProfileReport(vehicleResourcePath, vehicleFilters);
			})
			.then(function(vehicles){
				var tasks = {};
				vehicleList = vehicles;
				vehicles.forEach(function(vehicle){
					vehicleMap.set(vehicleID, vehicle);
					var saleInfoList = [];
					var vehicleID = vehicle.getResourceID();
					vehicle.saleInfos.forEach(function(resourceData){
						var saleInfoTradeInList = []
						var saleInfoPromotionList = [];
						var saleInfoPaymetList = [];
						var saleInfoDisclosureList = [];
						var saleInfoPackageList = [];
						var saleInfoExtraList = [];
						var saleInfo = new SaleInfo();
						saleInfo.setAttributes(resourceData.resourceData);

						if(saleInfo.tradeInVehicle){
							saleInfo.tradeInVehicle.forEach(function(tradeIn){
								var _tradeInVechile = new TradeInVehicle();
								_tradeInVechile.setAttributes(tradeIn.resourceData);
								saleInfoTradeInList.push(_tradeInVechile);
							})
						}
						if(saleInfo.promotions){
							saleInfo.promotions.forEach(function(promotion){
								var _promotion = new SalePromotion();
								_promotion.setAttributes(promotion.resourceData);
								saleInfoPromotionList.push(_promotion);
							})
		
						}
						if(saleInfo.payments){
							saleInfo.payments.forEach(function(payment){
								var _payment = new SaleInfoPayment();
								_payment.setAttributes(payment);
								saleInfoPaymetList.push(_payment);
							})
						}
		
						if(saleInfo.disclosures){
							saleInfo.disclosures.forEach(function(disclosure){
								var _disclosure = new Disclosure();
								_disclosure.setAttributes(disclosure);
								saleInfoDisclosureList.push(_disclosure);
							})
						}
		
						if(saleInfo.salePackages){
							saleInfo.salePackages.forEach(function(temp){
								var _salePackages = new SalePackage();
								_salePackages.setAttributes(temp.resourceData);
								saleInfoPackageList.push(_salePackages)
							})
						}
		
						if(saleInfo.saleExtra){
							saleInfo.saleExtra.forEach(function(extra){
								var _saleExtras = new SaleExtras();
								_saleExtras.setAttributes(extra.resourceData);
								saleInfoExtraList.push(_saleExtras);
							})
						}
		
						if(saleInfo.customer){
							if(saleInfo.customer){
								var customer = new Customer();
								customer.setAttributes(saleInfo.customer);
								saleInfo.customer = customer;
							}
						}
		
						if(saleInfo.warranty && saleInfo.warranty.length > 0){
							var warranty = new SaleWarranty();
							warranty.setAttributes(saleInfo.warranty[0]);
							saleInfo.warranty = warranty;
		
						}
		
						if(saleInfo.salePerson && saleInfo.salePerson.length > 0){
							var salePerson = new User();
							salePerson.setAttributes(saleInfo.salePerson[0]);
							saleInfo.salePerson = salePerson
						}
		
						if(saleInfo.saleManager && saleInfo.saleManager.length > 0){
							var saleManager = new User();
							saleManager.setAttributes(saleInfo.saleManager[0]);
							saleInfo.saleManager = saleManager;
						}
						
						if(saleInfoTradeInList.length > 0){
							saleInfo.tradeInVehicle = saleInfoTradeInList[0];

						}
						saleInfo.promotions = saleInfoPromotionList;
						saleInfo.payments = saleInfoPaymetList;
						saleInfo.disclosures = saleInfoDisclosureList;
						saleInfo.salePackages = saleInfoPackageList;
						saleInfo.saleExtra = saleInfoExtraList;
						saleInfoList.push(saleInfo);


					})
					tasks[vehicleID] = saleInfoList;
				})

				return $q.all(tasks);
			})
			.then(function(result){
				var vehicleIdList = Object.keys(result);
				var tasks = [];

				vehicleIdList.forEach(function(vehicleID, index){
					var saleInfoList = result[vehicleID];

					if(!Array.isArray(saleInfoList)){
						return;
					}

					saleInfoList.forEach(function(saleInfo){
						if(!isInDateRange(saleInfo.getSaleDateMomentObj(), startDateMomnet, endDateMoment) || saleInfo.is_canceled){
							return;
						}

						var billOfSale = new BillOfSale(vehicleID, saleInfo.getResourceID());
						billOfSale.setEmailCategories(phoneCategories)
						billOfSale.setPayments(saleInfo.payments)
						billOfSale.setPlateOptions(plateOptions)
						billOfSale.setSaleExtras(saleInfo.saleExtra)
						billOfSale.setSalePackages(saleInfo.salePackages)
						billOfSale.setPromotions(saleInfo.promotions)
						billOfSale.setSaleInfo([saleInfo])
						billOfSale.setTradeInVehicle([saleInfo.tradeInVehicle])
						billOfSale.setVehicle([vehicleMap.get(Number(vehicleID))])
						billOfSale.setVehicleBrands(vehicleBrands)
						billOfSale.setDisclosures(saleInfo.disclosures)
		
						billOfSale.setCustomer([saleInfo.customer])
						billOfSale.setWarranty([saleInfo.warranty])
						billOfSale.setSalePerson([saleInfo.salePerson]);
						billOfSale.setSaleManager([saleInfo.saleManager]);
						tasks.push(billOfSale);
					});
				});

				return $q.all(tasks);
			})
			.then(function(result){	
				var billOfSaleList = $filter('orderBy')(result, "saleInfo.sale_date");

				GeneralTools.generalExcelSheet({soldReport:buildSaleReportData(vehicleList, billOfSaleList)}, "Sold Report");
				defer.resolve();
			})
			.catch(function(error){
				defer.reject(error);
			});

		return defer.promise;
		}

		function getTasksForPurchaseInfoWithTaskList(purchaseInfoID, purchaseInfoList, vehicleID, taskList){
			var timeRange = findTimeRangeBetweenCurrentAndNextPurchase(purchaseInfoID, purchaseInfoList)

			if(!timeRange){
				return $q.reject("Task time range is invalid");
			}

			var tasksFilter = tasksFilterBuilder(timeRange, vehicleID);

			if(!tasksFilter){
				return $q.reject("Task filter is invalid");
			}

			if(!taskList || taskList.length === 0){
				return $q.resolve([]);
			}

			var result = filterObjects(taskList, timeRange, vehicleID);

			if(result.length > 0){
				return $q.resolve(result);
			}

			return $q.resolve([])

				
		}


		function getTasksForPurchaseInfoWithTaskListVersion3(purchaseInfoID, purchaseInfoList, vehicleID, taskList){
			var timeRange = findTaskTimeRangeForPurchaseReportVersion3(purchaseInfoID, purchaseInfoList);

			if(!timeRange){
				return $q.reject("Task time range is invalid");
			}

			var tasksFilter = tasksFilterBuilder(timeRange, vehicleID);

			if(!tasksFilter){
				return $q.reject("Task filter is invalid");
			}

			if(!taskList || taskList.length === 0){
				return $q.resolve([]);
			}

			return $q.resolve(filterObjectsForPurchaseReportVersion3(taskList, timeRange, vehicleID));
		}

		function findTaskTimeRangeForPurchaseReportVersion3(currentPurchaseInfoID, purchaseInfoList){
			if(!Array.isArray(purchaseInfoList)){
				purchaseInfoList = [];
			}

			var currentPurchaseInfo = purchaseInfoList.find(function(purchaseInfo){
				return purchaseInfo && currentPurchaseInfoID == purchaseInfo.getResourceID();
			});

			if(!currentPurchaseInfo){
				return;
			}

			var currentPurchaseDate = currentPurchaseInfo.getPurchaseDateMomentObj();

			if(!currentPurchaseDate){
				return;
			}

			// Keep task range compatible with generatePurchaseInfoReportVersion2().
			// In version 2, findTimeRangeForWorkOrderTimeRange() mutates the purchaseInfoList
			// with .reverse() before getTasksForPurchaseInfo() runs. Since backend purchase infos
			// arrive newest-first, the task helper effectively searches from newest to oldest.
			// This means the task end date is the latest later purchase, not always the
			// immediate next purchase. We reproduce that behavior here without mutating
			// the shared list or changing generateProfitReportVersion2().
			var purchaseInfoListNewestFirst = $filter('orderBy')(purchaseInfoList, "purchase_date", true);
			var nextPurchaseInfo = purchaseInfoListNewestFirst.find(function(purchaseInfo){
				if(!purchaseInfo){
					return false;
				}

				var purchaseDate = purchaseInfo.getPurchaseDateMomentObj();
				return purchaseDate && purchaseDate.isValid() && purchaseDate.isAfter(currentPurchaseDate);
			});

			var timeRange = {from: currentPurchaseDate};

			if(nextPurchaseInfo){
				timeRange.to = nextPurchaseInfo.getPurchaseDateMomentObj();
			}

			return timeRange;
		}

		function filterObjectsForPurchaseReportVersion3(taskList, timeRange, vehicleID) {
			if(!taskList || taskList.length === 0){
				return [];
			}

			return taskList.filter(function(task){
				const taskDate = moment(task.created_date);

				if(!taskDate || !taskDate.isValid()){
					return false;
				}

				if(task.cost == null || task.cost <= 0){
					return false;
				}

				if(vehicleID && task.fk_assigned_to_vehicle != vehicleID){
					return false;
				}

				if(timeRange.from && taskDate.isBefore(timeRange.from)){
					return false;
				}

				if(timeRange.to && taskDate.isAfter(timeRange.to)){
					return false;
				}

				return true;
			});
		}

		function filterObjects(taskList, timeRange, vehicleID) {
			if(!taskList || taskList.length === 0){
				return [];
			}

			var result = taskList.filter(function(task){
				const taskDate = moment(task.created_date);
				if(!taskDate){
					return false;
				}
				if(task.cost == null || task.cost <= 0){
					return false;

				}
				if(vehicleID && task.fk_assigned_to_vehicle != vehicleID){
					return false;
				}
				if((timeRange.from && (taskDate.isSameOrAfter(timeRange.from))) || (timeRange.to && taskDate.isSameOrBefore(timeRange.to))){
					return true;
				}
				return false;
			});

			return result;
		}

		
		function getPurchaseInfoPricesWithList(purchaseInfoId, PurchaseInfoPriceList){
			if(!PurchaseInfoPriceList || PurchaseInfoPriceList.length === 0){
				return []
			}
			var result = [];

			PurchaseInfoPriceList.forEach(function(purchaseInfo){
				if(purchaseInfo && purchaseInfo.purchaseInfoPrices && purchaseInfo.purchaseInfoPrices.length > 0){
					purchaseInfo.purchaseInfoPrices.forEach(function(price){
						if(price.fk_id_purchase_info === purchaseInfoId){
							result.push(price);
						}
					})
				}
			});
			return result
		}

		function getBaseUrl() {
			return $location.protocol() + "://" + $location.host();
		}
	}
})();
(function ()
{
	'use strict';

	angular
		.module('app.reports')
		.controller('ReportsController', ReportsController);

	function ReportsController($location, $scope, $stateParams, GeneralTools, LoginService, ReportService, MessageService, ProgressService){
		const vm = this;
		const companyID = LoginService.getCompanyID();
		const dateFormat = "YYYY-MM-DD";
		var chart;
		var originStartDateForProfitReport;
		var originEndDateForProfitReport;
		var originStartDateForHourReport;
		var originEndDateForHourReport;
		var originStartDateForNoSubProfitReport;
		var originEndDateForNoSubProfitReport;
		var originCustomerListId;

		vm.mechanicHourTabIndx = 0;
		vm.profitTabIndex = 1;
		vm.noSubsidized = 2;

		vm.refreshReport = refreshReport;
		vm.downloadReport = downloadReport;
		vm.onCustomerChange = onCustomerChange;

		$scope.$watch("vm.isBusy", function(){
			if(vm.isBusy){
				ProgressService.setMode("indeterminate");
				ProgressService.isVisble(true);
			} else {
				ProgressService.isVisble(false);
			}
		});

		init();

		function init(){
			const tabIndex = GeneralTools.urlStringParamTranslator($stateParams.tab);
			const startDate = GeneralTools.urlDateParamTranslator($stateParams.from);

			vm.currentTabIndex = tabIndex ? tabIndex : 0;
			vm.startDate = startDate ? startDate : new Date(moment().date(1));
			vm.endDate = GeneralTools.urlDateParamTranslator($stateParams.to);
			vm.customerListId = []
		}

		function resetOriginDateFilterForNoSubProfitReport(){
			originStartDateForNoSubProfitReport = angular.copy(vm.startDate);
			originEndDateForNoSubProfitReport = angular.copy(vm.endDate);
			originCustomerListId = angular.copy(vm.customerListId);
		}
		
		function resetOriginDateFilterForProfitReport(){
			originStartDateForProfitReport = angular.copy(vm.startDate);
			originEndDateForProfitReport = angular.copy(vm.endDate);
			originCustomerListId = angular.copy(vm.customerListId);
		}

		function resetOriginDateFilterForHourReport(){
			originStartDateForHourReport = angular.copy(vm.startDate);
			originEndDateForHourReport = angular.copy(vm.endDate);
			originCustomerListId = angular.copy(vm.customerListId);
		}

		function refreshReport(){
			switch(vm.currentTabIndex){
				case vm.profitTabIndex:
					refreshServiceReport();
					break;
				case vm.mechanicHourTabIndx:
					refreshMechanicHoursReport();
					break;
				case vm.noSubsidized:
					refreshNoSubsidizedServiceReport();
					break;
			}
			refreshUrl();
		}

		function downloadReport(){
			switch(vm.currentTabIndex){
				case vm.profitTabIndex:
					downloadServiceReport();
					break;
				case vm.mechanicHourTabIndx:
					downloadMechanicHoursReport();
					break;
				case vm.noSubsidized:
					downloadNoSubsidizedServiceReport();
					break;
			}
		}

		function refreshMechanicHoursReport(){
			if(isFilterSame(originStartDateForHourReport, originEndDateForHourReport) && vm.mechanicHourReportDatas && isCustomerListIdSame(originCustomerListId)){
				return;
			}
			vm.isBusy = true;

			ReportService.getMechanicHoursReportData(companyID, getFromFilter(vm.startDate), getToFilter(vm.endDate), vm.customerListId)
				.then(function(mechanicHourReportDatas){
					vm.mechanicHourReportDatas = mechanicHourReportDatas;
					refreshChart(mechanicHourReportDatas);
					resetOriginDateFilterForHourReport();
				})
				.catch(MessageService.showToast)
				.finally(function(){
					vm.isBusy = false;
				});	
		}

		function refreshUrl(){
			const params = {};

			if(vm.startDate){
				params.from = moment(vm.startDate).format(dateFormat);
			}

			if(vm.endDate){
				params.to = moment(vm.endDate).format(dateFormat);
			}

			params.tab = vm.currentTabIndex;


			params.cl = vm.customerListId
			$location.search(params).replace();
		}

		function refreshChart(mechanicHourReportDatas){
			if(chart){
				chart.data = extractPieChartDataFromMechanicHourReportDatas(mechanicHourReportDatas);
				chart.update();
			} else {
				const ctx = document.getElementById('myChart').getContext('2d');
				chart = new Chart(ctx, {
					type: 'pie',
					data: extractPieChartDataFromMechanicHourReportDatas(mechanicHourReportDatas),
					options: {}
				});
			}			
		}

		function extractPieChartDataFromMechanicHourReportDatas(mechanicHourReportDatas){
			if(!Array.isArray(mechanicHourReportDatas)){
				return;
			}

			var data = [];
			var backgroundColor = [];
			var labels = [];

			mechanicHourReportDatas.forEach(function(mechanicHourReportData, index){
				if(!mechanicHourReportData){
					return;
				}

				const dataForService = getTotalLaborHours(mechanicHourReportData.workorderForService);
				const dataForRM = getTotalLaborHours(mechanicHourReportData.workorderForRM);
				const totalHours = GeneralTools.preciseNumber(dataForService + dataForRM, 2)

				labels.push(mechanicHourReportData.first_name + ' ' + mechanicHourReportData.last_name);
				data.push(totalHours);
				backgroundColor.push(GeneralTools.getRandomColorString());
			});

			return {		
				datasets: [{
					data: data,
					backgroundColor: backgroundColor
				}],
				labels: labels
			};
		}

		function getTotalLaborHours(workorderList){
			if(!Array.isArray(workorderList)){
				return;
			}

			var total = 0;

			workorderList.forEach(function(data){
				if(data){
					total += GeneralTools.parseNumber(data.totalLaborHours);
				}
			});

			return GeneralTools.preciseNumber(total, 2);
		}

		function downloadMechanicHoursReport(){
			vm.isBusy = true;

			ReportService.downloadMechanicHoursReport(companyID, getFromFilter(vm.startDate), getToFilter(vm.endDate), vm.customerListId)
				.catch(MessageService.showToast)
				.finally(function(){
					vm.isBusy = false;
				});	
		}

		function downloadServiceReport(){
			vm.isBusy = true;

			ReportService.downloadServiceProfitReport(companyID, getFromFilter(vm.startDate), getToFilter(vm.endDate), vm.customerListId)
				.catch(MessageService.showToast)
				.finally(function(){
					vm.isBusy = false;
				});	
		}

		function downloadNoSubsidizedServiceReport(){
			vm.isBusy = true;

			ReportService.downloadNoSubServiceProfitReport(companyID, getFromFilter(vm.startDate), getToFilter(vm.endDate), vm.customerListId)
				.catch(MessageService.showToast)
				.finally(function(){
					vm.isBusy = false;
				});	
		}

		function refreshServiceReport(){
			if(isFilterSame(originStartDateForProfitReport, originEndDateForProfitReport) && vm.serviceReportDatas && isCustomerListIdSame(originCustomerListId)){
				return;
			}

			vm.isBusy = true;

			ReportService.getServiceProfitReportData(companyID, getFromFilter(vm.startDate), getToFilter(vm.endDate), vm.customerListId)
				.then(function(serviceReportDatas){
					vm.serviceReportDatas = serviceReportDatas;
					resetOriginDateFilterForProfitReport();
				})
				.catch(MessageService.showToast)
				.finally(function(){
					vm.isBusy = false;
				});	
		}

		function refreshNoSubsidizedServiceReport(){
			if(isFilterSame(originStartDateForNoSubProfitReport, originEndDateForNoSubProfitReport) && vm.noSubServiceReportDatas && isCustomerListIdSame(originCustomerListId)){
				return;
			}

			vm.isBusy = true;

			ReportService.getNoSubsidizedServiceProfitReportData(companyID, getFromFilter(vm.startDate), getToFilter(vm.endDate), vm.customerListId)
				.then(function(serviceReportDatas){
					vm.noSubServiceReportDatas = serviceReportDatas;
					resetOriginDateFilterForNoSubProfitReport();
				})
				.catch(MessageService.showToast)
				.finally(function(){
					vm.isBusy = false;
				});	
		}

		function getFromFilter(date){
			if(date){
				return moment(date).format(dateFormat);
			}
		}

		function getToFilter(date){
			if(date){
				const endDateMomentObj = moment(date);
				return endDateMomentObj.date(endDateMomentObj.date() + 1).format(dateFormat);
			}
		}

		function isFilterSame(originStartDate, originEndDate){
			return getFromFilter(originStartDate) === getFromFilter(vm.startDate) && getToFilter(originEndDate) === getToFilter(vm.endDate);
		}

		function isCustomerListIdSame(originCustomerListId){
			if (originCustomerListId.length !== vm.customerListId.length) {
				return false;
			}
			
			// Sort the arrays
			const sortedArray1 = originCustomerListId.slice().sort();
			const sortedArray2 = vm.customerListId.slice().sort();
			
			// Iterate over the sorted arrays to compare elements
			for (let i = 0; i < sortedArray1.length; i++) {
				if (sortedArray1[i] !== sortedArray2[i]) {
					return false;
				}
			}
			
			return true;
		}

		function onCustomerChange(customerList){
			const previousCustomerListId = vm.customerListId.slice();

			vm.customerListId = customerList.map(function(obj) {
				return obj.id_customer;
			});
			const hasChanged = JSON.stringify(vm.customerListId) !== JSON.stringify(previousCustomerListId);

			if(hasChanged){
				vm.refreshReport()
			}

		}
	}
})();
(function ()
{
	"use strict";

	angular
		.module("app.reports")
		.component("reportInfoCustomerForm", {
				bindings:{
					onCustomerChange:'<'
				},
				templateUrl: "app/main/reports/report-info-customer-form.html",
				controller: componentController,
		  		controllerAs: 'vm'
			});

		function componentController(CustomersService, LoginService, $state){
			var vm = this;	
			var filterObj = {};
			var companyID = LoginService.getCompanyID();
			var customerFilterObj = {};
			vm.customerList = []
			
			var minSearchTextLength = 2;

			vm.$onInit = initComponent;
			vm.onSearchTextChange = onSearchTextChange;
			vm.selectCusomter = selectCusomter;
			vm.goToCustomerPage = goToCustomerPage;
			vm.getCustomerPageUrl = getCustomerPageUrl;
			vm.removeCusomter = removeCusomter;

			function initComponent(){

			}

			function onSearchTextChange(){
				if(vm.searchText == null || vm.searchText.length < minSearchTextLength){
					vm.customersFound = [];
					return;
				}

				var resourcePath = { companyID: companyID }
				var filterObj = CustomersService.customerSearchTextFilterBuilder(vm.searchText);

				CustomersService.getCustomers(resourcePath, filterObj, null, null)
					.then(function(response){
						vm.customersFound = response.data;

					})
			}

			function selectCusomter (customer){
				var idExists = vm.customerList.some(function(obj) {
					return obj.id_customer == customer.id_customer;
				});

				if (!idExists) {
					vm.customerList.push(customer)
				}

				if(typeof(vm.onCustomerChange) == "function"){
					vm.onCustomerChange(vm.customerList);
				}

			}

			function removeCusomter (customer){
				
				vm.customerList = vm.customerList.filter(function(obj) {
					return obj.id_customer !== customer.id_customer;
				});
				if(typeof(vm.onCustomerChange) == "function"){
					vm.onCustomerChange(vm.customerList);
				}
				
			}

			function goToCustomerPage (customer){
				if(customer){
					var url = $state.href('app.view-customer', {customerID: customer.getResourceID()});
					window.open(url,'_blank');
				}

			}

			function getCustomerPageUrl(customer){
				if(customer){
					return $state.href('app.view-customer', {customerID: customer.getResourceID()});
				}
			}

			vm.check = function check(){
				console.log(vm.customerList);
				console.log(vm.customer);
			}



		}
})();
(function ()
{
	"use strict";

	angular
		.module("app.reports")
		.component("mechanicHourTable", {
				bindings:{
					mechanicHourDetail: '<'
				},
				templateUrl: "app/main/reports/mechanic-hour-detail.html",
				controller: componentController,
		  		controllerAs: 'vm'
			});

		function componentController($state, GeneralTools, MessageService){
			const vm = this;
			
			vm.$onInit = initComponent;
			vm.$postLink = initCallbacks;

			vm.getTotalHours = getTotalHours;

			vm.getWorkorderUrl = getWorkorderUrl;

			function initComponent(){
			}

			function initCallbacks(){
			}

			function getTotalHours(workorderList){
				if(!Array.isArray(workorderList)){
					return;
				}

				var totalHours = 0;

				workorderList.forEach(function(workorderData){
					if(workorderData){
						totalHours += workorderData.totalLaborHours;
					}
				});

				return GeneralTools.preciseNumber(totalHours, 2);
			}

			function getWorkorderUrl(workorderData){
				if(workorderData){
					return $state.href("app.edit-workorder.general", {vehicleID: workorderData.vehicleID, workOrderID: workorderData.workorderID});
				}		
			}
		}
})();
(function ()
{
	'use strict';

	angular
		.module('app.purchaseInvoice')
		.service("PurchaseInvoiceService", PurchaseInvoiceService);

	/** @ngInject */
	function PurchaseInvoiceService($state, api, ToolsFactory, Const, $q, MessageService, LoginService, $filter, PurchaseInvoice, HeaderHelper, MyFile, ConstantCacheService)
	{   
		var codeKey = Const.header.code;
		var messageKey = Const.header.message;
		var successCode = Const.code.success;

		this.updatePurchaseInvoiceRequestBodyGenerator = function(currentPurchaseInvoice, originPurchaseInvoice){
			if(currentPurchaseInvoice == null || originPurchaseInvoice == null){
				return;
			}

			var keyList = Object.keys(currentPurchaseInvoice);
			var changedProperties = {};

			keyList.forEach(function(key){
				var currentValue = currentPurchaseInvoice[key];
				var originValue = originPurchaseInvoice[key];

				if(currentValue == originValue){
					return;
				}

				changedProperties[key] = currentValue;
			});

			return changedProperties;
		}

		this.getSuppliers = function(resourcePath){			
			var defer = $q.defer();

			api.suppliers.getSuppliers(
				resourcePath,
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);
						defer.reject(errorMessage);
						return;
					}

					defer.resolve(response);
				},
				function(error){
					console.error("Failed to get suppliers.");
					defer.reject(error);
				}
			);

			return defer.promise;
		}

		this.getCachedSuppliers = function(resourcePath) {
			var cacheKey = getSuppliersCacheKey(resourcePath);
			var ttl = 12 * 60 * 60 * 1000; // 12 hours

			return ConstantCacheService.get(cacheKey, function () {
				return this.getSuppliers(resourcePath);
			}.bind(this), ttl);
		}

		function getSuppliersCacheKey(resourcePath) {
			if (resourcePath && resourcePath.companyID) {
				return 'suppliers_company_' + resourcePath.companyID;
			}

			return 'suppliers';
		}

		this.getPurchaseInvoices = function(resourcePath, filters, pagination, sorting){			
			var defer = $q.defer();
			var queryParams = Object.assign({}, resourcePath, filters, pagination, sorting);

			api.purchaseInvoice.getPurchaseInvoices(
				queryParams,
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);
						defer.reject(errorMessage);
						return;
					}

					var purchaseInvoiceList = [];

					response.forEach(function(data){
						var purchaseInvoice = new PurchaseInvoice();

						purchaseInvoice.setAttributes(data);
						purchaseInvoiceList.push(purchaseInvoice);
					})

					var result = {
						data: purchaseInvoiceList,
						headerGetter: header
					}

					defer.resolve(result);
				},
				function(error){
					console.error("Failed to get purchaseInvoice.");
					defer.reject(error);
				}
			);

			return defer.promise;
		}

		this.createPurchaseInvoice = function(resourcePath, requestBody){
			var defer = $q.defer();

			api.purchaseInvoice.postPurchaseInvoice(
				resourcePath,
				requestBody,
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);
						defer.reject(errorMessage);
						return;
					}

					defer.resolve(response.data);
				},
				function(error){
					console.error("Failed to create purchaseInvoice.");
					defer.reject(error);
				}
			);

			return defer.promise;
		}

		this.updatePurchaseInvoice = function(resourcePath, requestBody){
			var defer = $q.defer();

			api.purchaseInvoice.updatePurchaseInvoice(
				resourcePath,
				requestBody,
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);

						defer.reject(errorMessage);
						return;
					}
					defer.resolve(response);

				},
				function(error){
					console.error(error);
					defer.reject("Failed to update purchaseInvoice.");
				}
			);	

			return defer.promise;			
		}

		this.getPurchaseInvoiceFiles = function(resourcePath){
			var defer = $q.defer();

			api.purchaseInvoiceFile.getFiles(
				resourcePath,
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);
						defer.reject(errorMessage);
						return;
					}

					var fileList = [];

					response.forEach(function(data){
						var file = new MyFile();

						file.setAttributes(data);
						fileList.push(file);
					})

					defer.resolve(fileList);
				},
				function(error){
					console.error(error);
					defer.reject("Failed to get purchase invoice files.");
				}
			);

			return defer.promise;			
		}

		this.deletePurchaseInvoiceFile = function(resourcePath){
			var defer = $q.defer();

			api.purchaseInvoiceFile.deleteFile(
				resourcePath,
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);
						defer.reject(errorMessage);
						return;
					}

					defer.resolve(response);
				},
				function(error){
					console.error(error);
					defer.reject("Failed to delete purchase invoice file.");
				}
			);

			return defer.promise;
		}

		this.deletePurchaseInvoice = function(resourcePath){
			var defer = $q.defer();

			api.purchaseInvoice.deletePurchaseInvoice(
				resourcePath,
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);
						defer.reject(errorMessage);
						return;
					}

					defer.resolve(response);
				},
				function(error){
					var errorMessage = error.status + ': ' + error.statusText;
					defer.reject(errorMessage);
				}
			);

			return defer.promise;
		}
/*		

		

		this.getPurchaseInvoiceTypes = function(resourcePath){			
			var defer = $q.defer();

			api.partTypes.getPartTypes(
				resourcePath,
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);
						defer.reject(errorMessage);
						return;
					}

					defer.resolve(response);
				},
				function(error){
					console.error("Failed to get purchaseInvoice types.");
					defer.reject(error);
				}
			);

			return defer.promise;
		}

		

		

		*/
	}
})();
(function ()
{
	'use strict';

	angular
		.module("app.purchaseInvoice")
		.factory("PurchaseInvoice", PurchaseInvoiceClass)

	/** @ngInject */
	function PurchaseInvoiceClass($filter, PurchaseInvoiceConstants)
	{	 
		function PurchaseInvoice(){}

		PurchaseInvoice.prototype.setAttributes = function (attributes) {
	 		if(attributes == null){
	 			return;
	 		}

	 		var keyList = Object.keys(attributes);

	 		for(var i = 0; i < keyList.length; i++){
	 			var key = keyList[i];
	 			var value = attributes[key];

	 			this.setAttribute(key, value);
	 		}
		}

		PurchaseInvoice.prototype.setAttribute = function (key, value) {
	 		this[key] = value;
		}

		PurchaseInvoice.prototype.getResourceId = function () {
	 		return this.id_purchase_invoice;
		}	

		PurchaseInvoice.prototype.setPurchaseDate = function (momentObj) {
	 		if(momentObj && momentObj.isValid()){
				this.purchase_date = momentObj.format(PurchaseInvoiceConstants.purchaseDateFormat);
				return true;
			}
			this.purchase_date = null;
			return false;
		}	

		PurchaseInvoice.prototype.getPurchaseDateMomentObj = function (){
			if(this.purchase_date){
				return moment(this.purchase_date, PurchaseInvoiceConstants.purchaseDateFormat);
			}
		}

		return PurchaseInvoice;
	}


})();
(function ()
{
	'use strict';

	angular
		.module("app.purchaseInvoice")
		.factory("InvoiceSummaryCalculator", InvoiceSummaryCalculatorClass)

	/** @ngInject */
	function InvoiceSummaryCalculatorClass(GeneralTools)
	{	 
		function InvoiceSummaryCalculator(){}

		InvoiceSummaryCalculator.prototype.setParts = function (parts) {
			this.parts = parts;
		}

		InvoiceSummaryCalculator.prototype.getParts = function () {
			return this.parts;
		}
		//GeneralTools.preciseNumber(GeneralTools.parseNumber(this.subsidizedAmount), 2);

		InvoiceSummaryCalculator.prototype.getTotalPartsCost = function () {
			const parts = this.getParts();
			var total = 0;

			if(!Array.isArray(parts)){
				return total;
			}

			parts.forEach(function(part){
				if(!!part ){
					total += GeneralTools.parseNumber(part.purchase_price) * GeneralTools.parseNumber(part.quantity);
				}
			});

			return GeneralTools.preciseNumber(total , 2);
		}

		InvoiceSummaryCalculator.prototype.getTotalPartsRetail = function () {
			const parts = this.getParts();
			var total = 0;

			if(!Array.isArray(parts)){
				return total;
			}

			parts.forEach(function(part){
				if(!!part ){
					total += GeneralTools.parseNumber(part.retail_price) * GeneralTools.parseNumber(part.quantity);
				}
			});

			return GeneralTools.preciseNumber(total , 2);
		}

		return InvoiceSummaryCalculator;
	}
})();
(function ()
{
	'use strict';

	angular.module('app.redirect-page', [])
		.config(config);

	/** @ngInject */
	function config($stateProvider, msNavigationServiceProvider)
	{	  
		$stateProvider
			.state('app.redirect-page', {
				url: '/redirect-page?code',
				reloadOnSearch : false,
				views: {
					'content@app': {
						templateUrl: 'app/main/redirect-page/redirect-page.html',
						controller: 'RedirectPageController as vm'
					}
				}
			});
	}
})();
(function ()
{
	'use strict';

	angular
		.module('app.redirect-page')
		.service("RedirectPageService", RedirectPageService);

	/** @ngInject */
	function RedirectPageService(LoginService, GeneralTools, Const, $q, MessageService, $resource)
	{
		const baseUrl = GeneralTools.getBaseUrl();
		const errMsgFailedToGetRedirectUrl = "Failed to fetch redirct url";
		const baseHeader = GeneralTools.getBaseHeader();
		const noCacheHeader = GeneralTools.getNoCacheHeader();

		const redirctUrlApi = $resource(
			baseUrl + "redircturl",
			{},
			{
				get:{
					method:"GET",
					cancellable: true,
					interceptor:{
						response: function(result){
							const statusCode  = result.headers(Const.header.code);

							if(statusCode != Const.code.success){
								console.error(statusCode, result.headers(Const.header.message));
								return $q.reject(errMsgFailedToGetRedirectUrl);
							}

							return result.data;
						},
						responseError: function (error){
							if(error && error.xhrStatus == Const.xhrStatus.abort){
								return $q.reject();
							}
							console.error(error);
							return $q.reject(error);
						}
					}
				}
			}
		);

		this.getRedirectUrl = function(code){
			return redirctUrlApi.get({code: code});
		}		
	}
})();
(function ()
{
	'use strict';

	angular
		.module('app.redirect-page')
		.controller('RedirectPageController', RedirectPageController);

	function RedirectPageController($scope, $stateParams, RedirectPageService){
		const vm = this;

		vm.isDirecting = true;

		RedirectPageService.getRedirectUrl($stateParams.code).$promise
			.then(function(redirctUrl){
				if(!redirctUrl){
					return $q.reject();
				}
				if(redirctUrl.data[0] != "/"){
					window.open("https://" + redirctUrl.data, "_self");
				}else{
					window.open(window.location.origin + redirctUrl.data, "_self");
				}
			})
			.catch(function(){
				vm.countdown = 5;
				vm.isDirecting = false;

				var counter = setInterval(function(){
					vm.countdown--;
					$scope.$apply();

					if (vm.countdown <= 0){
						clearInterval(counter);
						vm.isDirecting = true;
						window.open(window.location.origin, "_self");
						return;
					}

				}, 1000);	
			});
	}
})();
(function ()
{
	'use strict';

	angular
		.module('app.purchaseInfo')
		.service("PurchaseInfoService", PurchaseInfoService);

	/** @ngInject */
	function PurchaseInfoService($state, api, ToolsFactory, Const, $q, MessageService, LoginService, $filter, FinanceApplication, PurchaseInfo, PurchaseInfoPrices, PurchaseInfoPriceType, Disclosure, MyFile, ConstantCacheService)
	{   
		var codeKey = Const.header.code;
		var messageKey = Const.header.message;
		var successCode = Const.code.success;


		this.updatePurchaseInfoRequestBodyGenerator = function(currentPurchaseinfo, originPurchaseInfo){
			if(currentPurchaseinfo == null || originPurchaseInfo == null){
				return;
			}

			var keyList = Object.keys(currentPurchaseinfo);
			var changedProperties = {};

			keyList.forEach(function(key){
				var currentValue = currentPurchaseinfo[key];
				var originValue = originPurchaseInfo[key];

				if(currentValue == originValue){
					return;
				}

				changedProperties[key] = currentValue;
			});

			return changedProperties;
		}

		this.getAuction = function(auctionID){
			var defer = $q.defer();

			api.auction.getAuction(
				{
					companyID : LoginService.getCompanyID(),
					auctionID : auctionID
				},
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);
						defer.reject(errorMessage);
						return;
					}

					defer.resolve(response);
				},
				function(error){
					console.error("Failed to get auctions");
					defer.reject(error);
				}
			);

			return defer.promise;
		}

		this.createPurchaseInfo = function(resourcePath, requestBody){
			var defer = $q.defer();

			api.purchaseInfo.createPurchaseInfo(
				resourcePath,
				requestBody,
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);
						defer.reject(errorMessage);
						return;
					}

					defer.resolve(response.data);
				},
				function(error){
					console.error("Failed to create purchase info");
					defer.reject(error);
				}
			);

			return defer.promise;
		}

		this.createPurchaseDisclosure = function(resourcePath, requestBody){
			var defer = $q.defer();

			api.purchaseDisclosure.createDisclosure(
				resourcePath,
				requestBody,
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);
						defer.reject(errorMessage);
						return;
					}

					defer.resolve(response.data);
				},
				function(error){
					console.error("Failed to create purchase disclosure");
					defer.reject(error);
				}
			);

			return defer.promise;			
		}

		this.getPurchaseDisclosures = function(resourcePath){
			var defer = $q.defer();

			api.purchaseDisclosure.getDisclosures(
				resourcePath,
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);
						defer.reject(errorMessage);
						return;
					}

					var disclosureList = [];

					response.forEach(function(data){
						var disclosure = new Disclosure();

						disclosure.setAttributes(data); 
						disclosureList.push(disclosure);
					})

					defer.resolve(disclosureList);
				},
				function(error){
					console.error(error);
					defer.reject("Failed to get purchase disclosures.");
				}
			);

			return defer.promise;			
		}

		this.deletePurchaseDisclosure = function(resourcePath){
			var defer = $q.defer();

			api.purchaseDisclosure.deleteDisclosure(
				resourcePath,
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);
						defer.reject(errorMessage);
						return;
					}

					defer.resolve(response);
				},
				function(error){
					console.error(error);
					defer.reject("Failed to delete purchase disclosure");
				}
			);

			return defer.promise;
		}

		this.getPurchaseInfoFiles = function(resourcePath){
			var defer = $q.defer();

			api.purchaseInfoFile.getFiles(
				resourcePath,
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);
						defer.reject(errorMessage);
						return;
					}

					if(!Array.isArray(response)){
						defer.reject("Purchase info file list is not an array.");
						return;
					}

					var fileList = [];

					response.forEach(function(fileData){
						if(fileData == null){
							return;
						}

						var file = new MyFile();
						file.setAttributes(fileData);

						fileList.push(file);
					});

					defer.resolve(fileList);
				},
				function(error){
					console.error(error);
					defer.reject("Failed to get purchase info files.");
				}
			);

			return defer.promise;			
		}

		this.deletePurchaseFile = function(resourcePath){
			var defer = $q.defer();

			api.purchaseInfoFile.deleteFile(
				resourcePath,
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);
						defer.reject(errorMessage);
						return;
					}

					defer.resolve(response);
				},
				function(error){
					console.error(error);
					defer.reject("Failed to delete purchase info file.");
				}
			);

			return defer.promise;
		}

		this.getPurchaseInfos = function(resourcePath){
			var defer = $q.defer();

			api.purchaseInfo.getPurchaseInfos(
				resourcePath,
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);
						defer.reject(errorMessage);
						return;
					}

					var purchaseInfoList = [];

					response.forEach(function(data){
						var purchaseInfo = new PurchaseInfo();

						purchaseInfo.setAttributes(data); 
						purchaseInfoList.push(purchaseInfo);
					})

					defer.resolve(purchaseInfoList);
				},
				function(error){
					console.error(error);
					defer.reject("Failed to get purchase info.");
				}
			);

			return defer.promise;			
		}

		this.updatePurchaseInfo = function(resourcePath, requestBody){
			var defer = $q.defer();

			api.purchaseInfo.updatePurchaseInfo(
				resourcePath,
				requestBody,
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);
						defer.reject(errorMessage);
						return;
					}
					
					defer.resolve(null);
				},
				function(error){
					console.error(error);
					defer.reject("Failed to update purchase info.");
				}
			);

			return defer.promise;
		}

		this.deletePurchaseInfo = function(resourcePath){
			var defer = $q.defer();

			api.purchaseInfo.deletePurchaseInfo(
				resourcePath,
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);
						defer.reject(errorMessage);
						return;
					}

					defer.resolve(null);
				},
				function(error){
					console.error(error);
					defer.reject("Failed to delete purchase info");
				}
			);

			return defer.promise;			
		}

		this.getPurchaseInfoPrices = function(resourcePath){
			var defer = $q.defer();

			api.purchaseInfoPrices.getPurchaseInfoPrices(
				resourcePath,
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);
						defer.reject(errorMessage);
						return;
					}

					var purchaseInfoPriceList = [];

					response.forEach(function(data){
						var purchaseInfoPrice = new PurchaseInfoPrices();

						purchaseInfoPrice.setAttributes(data); 
						purchaseInfoPriceList.push(purchaseInfoPrice);
					})

					defer.resolve(purchaseInfoPriceList);
				},
				function(error){
					console.error(error);
					defer.reject("Failed to get purchase info price.");
				}
			);

			return defer.promise;			
		}

		this.createPurchaseInfoPrice = function(resourcePath, requestBody){
			var defer = $q.defer();

			api.purchaseInfoPrices.createPurchaseInfoPrice(
				resourcePath,
				requestBody,
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);
						defer.reject(errorMessage);
						return;
					}

					var purchaseInfoPriceList = [];

					response.forEach(function(data){
						var purchaseInfoPrice = new PurchaseInfoPrices();

						purchaseInfoPrice.setAttributes(data); 
						purchaseInfoPriceList.push(purchaseInfoPrice);
					})

					defer.resolve(purchaseInfoPriceList);
				},
				function(error){
					console.error(error);
					defer.reject("Failed to create purchase info price.");
				}
			);

			return defer.promise;			
		}
		
		this.updatePurchaseInfoPrice = function(resourcePath, requestBody){
			var defer = $q.defer();

			api.purchaseInfoPrices.updatePurchaseInfoPrice(
				resourcePath,
				requestBody,
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);
						defer.reject(errorMessage);
						return;
					}

					defer.resolve(null);
				},
				function(error){
					console.error(error);
					defer.reject("Failed to update purchase info Price.");
				}
			);

			return defer.promise;
		}


		this.deletePurchaseInfoPrice = function(resourcePath){
			var defer = $q.defer();
			api.purchaseInfoPrices.deletePurchaseInfoPrice(
				resourcePath,
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);
						defer.reject(errorMessage);
						return;
					}

					defer.resolve(null);
				},
				function(error){
					console.error(error);
					defer.reject("Failed to delete purchase info Price.");
				}
			);

			return defer.promise;			
		}

		this.getPurchaseInfoPriceType = function(resourcePath){
			var defer = $q.defer();

			api.purchaseInfoPriceType.getpurchaseInfoPriceType(
				resourcePath,
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);
						defer.reject(errorMessage);
						return;
					}

					var purchaseInfoPriceList = [];

					response.forEach(function(data){
						var purchaseInfoPrice = new PurchaseInfoPriceType();

						purchaseInfoPrice.setAttributes(data); 
						purchaseInfoPriceList.push(purchaseInfoPrice);
					})

					defer.resolve(purchaseInfoPriceList);
				},
				function(error){
					console.error(error);
					defer.reject("Failed to get purchase info price type.");
				}
			);

			return defer.promise;			
		}

		this.getCachedPurchaseInfoPriceType = function (resourcePath) {
			var cacheKey = getPurchaseInfoPriceTypeCacheKey(resourcePath);

			return ConstantCacheService.get(cacheKey, function () {
				return this.getPurchaseInfoPriceType(resourcePath);
			}.bind(this)).then(function (result) {
				return buildPurchaseInfoPriceTypeList(result);
			});
		}

		function getPurchaseInfoPriceTypeCacheKey(resourcePath) {
			if (resourcePath && resourcePath.companyID) {
				return 'purchase_info_price_type_company_' + resourcePath.companyID;
			}

			return 'purchase_info_price_type';
		}

		function buildPurchaseInfoPriceTypeList(dataList) {
			if (!Array.isArray(dataList)) {
				return [];
			}

			var purchaseInfoPriceList = [];

			dataList.forEach(function (data) {
				if (data && typeof data.setAttributes === 'function') {
					purchaseInfoPriceList.push(data);
					return;
				}

				var purchaseInfoPrice = new PurchaseInfoPriceType();
				purchaseInfoPrice.setAttributes(data);
				purchaseInfoPriceList.push(purchaseInfoPrice);
			});

			return purchaseInfoPriceList;
		}

	}
})();
(function ()
{
	'use strict';

	angular
		.module("app.purchaseInfo")
		.factory("PurchaseInfoPriceType", PurchaseInfoPriceType)

	/** @ngInject */
	function PurchaseInfoPriceType(PurchaseInfoConstants)
	{	   
		function PurchaseInfoPriceType(){
		}

		PurchaseInfoPriceType.prototype.setAttributes = function (attributes) {
	 		var keyList = Object.keys(attributes);

	 		for(var i = 0; i < keyList.length; i++){
	 			var key = keyList[i];
	 			var value = attributes[key];

	 			this.setAttribute(key, value);
	 		}
		}	
			
		PurchaseInfoPriceType.prototype.setAttribute = function (key, value) {
	 		this[key] = value;
		}

		PurchaseInfoPriceType.prototype.getResourceID = function(){
			return this.id_price;
		}		

		PurchaseInfoPriceType.prototype.setResourceID = function(resourceID){
			this.id_price = resourceID;
		}

		return PurchaseInfoPriceType;
	}


})();


(function ()
{
	'use strict';

	angular
		.module("app.purchaseInfo")
		.factory("PurchaseInfoPrices", PurchaseInfoPrices)

	/** @ngInject */
	function PurchaseInfoPrices(PurchaseInfoConstants)
	{	   
		function PurchaseInfoPrices(){
		}

		PurchaseInfoPrices.prototype.setAttributes = function (attributes) {
	 		var keyList = Object.keys(attributes);

	 		for(var i = 0; i < keyList.length; i++){
	 			var key = keyList[i];
	 			var value = attributes[key];

	 			this.setAttribute(key, value);
	 		}
		}	
			
		PurchaseInfoPrices.prototype.setAttribute = function (key, value) {
	 		this[key] = value;
		}

		PurchaseInfoPrices.prototype.getResourceID = function(){
			return this.id_price;
		}		

		PurchaseInfoPrices.prototype.setResourceID = function(resourceID){
			this.id_price = resourceID;
		}

		return PurchaseInfoPrices;
	}


})();


(function ()
{
	'use strict';

	angular
		.module("app.purchaseInfo")
		.factory("PurchaseInfo", PurchaseInfo)

	/** @ngInject */
	function PurchaseInfo(PurchaseInfoConstants)
	{	   
		function purchaseInfo(){
		}

		purchaseInfo.prototype.setAttributes = function (attributes) {
	 		var keyList = Object.keys(attributes);

	 		for(var i = 0; i < keyList.length; i++){
	 			var key = keyList[i];
	 			var value = attributes[key];

	 			this.setAttribute(key, value);
	 		}
		}	
			
		purchaseInfo.prototype.setAttribute = function (key, value) {
	 		this[key] = value;
		}

		purchaseInfo.prototype.getResourceID = function(){
			return this.id_purchase_info;
		}		

		purchaseInfo.prototype.setResourceID = function(resourceID){
			this.id_purchase_info = resourceID;
		}

		purchaseInfo.prototype.setPurchaseDate = function (momentObj) {
	 		if(momentObj != null && momentObj.isValid()){
				this.purchase_date = momentObj.format(PurchaseInfoConstants.purchaseDateFormat);
				return true;
			}
			this.purchase_date = null;
			return false;
		}	

		purchaseInfo.prototype.getPurchaseDateMomentObj = function (){
			if(this.purchase_date != null){
				return moment(this.purchase_date, PurchaseInfoConstants.purchaseDateFormat);
			}
		}

		return purchaseInfo;
	}


})();


(function ()
{
	'use strict';

	angular
		.module("app.purchaseInfo")
		.factory("PurchaseCalculator", PurchaseCalculator)

	/** @ngInject */
	function PurchaseCalculator(GeneralTools)
	{	   
		function purchaseCalculator(){
		}

		purchaseCalculator.prototype.setPurchasePrice = function(purchasePrice) {
			this.purchasePrice = GeneralTools.parseNumber(purchasePrice);
		}

		purchaseCalculator.prototype.getPurchasePrice = function() {
			return this.purchasePrice;
		}

		purchaseCalculator.prototype.setBuyerFee = function(buyerFee) {
			this.buyerFee = GeneralTools.parseNumber(buyerFee);
		}

		purchaseCalculator.prototype.setShippingCost = function(shippingCost) {
			this.shippingCost = GeneralTools.parseNumber(shippingCost);
		}

		purchaseCalculator.prototype.getBuyerFee = function() {
			return this.buyerFee;
		}

		purchaseCalculator.prototype.getShippingCost = function(shippingCost) {
			return this.shippingCost;
		}

		purchaseCalculator.prototype.setOtherCost = function(otherCost) {
			this.otherCost = GeneralTools.parseNumber(otherCost);
		}

		purchaseCalculator.prototype.getOtherCost = function() {
			return this.otherCost;
		}

		purchaseCalculator.prototype.setTaxRate = function(taxRate) {
			this.taxRate = GeneralTools.parseNumber(taxRate);
		}

		purchaseCalculator.prototype.getTaxRate = function() {
			return this.taxRate;
		}

		purchaseCalculator.prototype.setTasks = function(tasks) {
			this.tasks = tasks;
		}

		purchaseCalculator.prototype.getWorkorderList = function() {
			return this.workorderList;
		}

		purchaseCalculator.prototype.setWorkorderList = function(workorderList) {
			this.workorderList = workorderList;
		}

		purchaseCalculator.prototype.getWorkorderDetails = function() {
			const workorderList = this.getWorkorderList();

			if(!Array.isArray(workorderList)){
				return;
			}

			return workorderList.map(function(item){
				if(!item || !item.workorderData || !item.workorderData.isCompleted()){
					return;
				}
				
				var totalSubsidization = 0;

				if(item.workorderData.is_subsidized_by_percentage){
					const totalCost = getTotalPartCost(item.partData) + getTotalInventoryCost(item.inventoryData);
					totalSubsidization = GeneralTools.preciseNumber(totalCost * GeneralTools.parseNumber(item.workorderData.subsidized_percentage), 2);
				} else {
					totalSubsidization = GeneralTools.parseNumber(item.workorderData.subsidized_amount);
				}

				item.totalSubsidization = totalSubsidization;

				return item;
			});
		}

		purchaseCalculator.prototype.getWorkorderTotalCost = function() {
			var total = 0;
			const workorderDetails = this.getWorkorderDetails();

			if(!Array.isArray(workorderDetails)){
				return total;
			}

			workorderDetails.forEach(function(item){
				if(!item){
					return;
				}

				total += GeneralTools.parseNumber(item.totalSubsidization);
			});

			return GeneralTools.preciseNumber(total , 2);
		}

		function getTotalInventoryCost(inventories) {
			var total = 0;

			if(!Array.isArray(inventories)){
				return total;
			}

			inventories.forEach(function(inventory){
				if(!!inventory){
					total += GeneralTools.parseNumber(inventory.purchase_price) * GeneralTools.parseNumber(inventory.quantity);
				}
			});

			return GeneralTools.preciseNumber(total , 2);
		}

		function getTotalPartCost(parts) {
			var total = 0;

			if(!Array.isArray(parts)){
				return total;
			}

			parts.forEach(function(part){
				if(!!part && !part.is_returned){
					total += GeneralTools.parseNumber(part.purchase_price) * GeneralTools.parseNumber(part.quantity);
				}
			});

			return GeneralTools.preciseNumber(total , 2);
		}

		purchaseCalculator.prototype.getTaskTotalCost = function() {
			var totalTaskCost = 0;

			if(!Array.isArray(this.tasks)){
				return 0;
			}

			this.tasks.forEach(function(task){
				totalTaskCost = GeneralTools.addToTotal(totalTaskCost, task.cost);
			})

			return totalTaskCost;
		}

		purchaseCalculator.prototype.setLicensingCost = function(LicensingCost) {
			this.LicensingCost = LicensingCost;
		}

		purchaseCalculator.prototype.getLicensingCost = function() {
			return this.LicensingCost;
		}

		purchaseCalculator.prototype.getSubTotalBeforeTax = function() {
			var subTotal = 0;

			subTotal = GeneralTools.addToTotal(subTotal, this.purchasePrice);
			subTotal = GeneralTools.addToTotal(subTotal, this.buyerFee);
			subTotal = GeneralTools.addToTotal(subTotal, this.shippingCost);
			subTotal = GeneralTools.addToTotal(subTotal, this.otherCost);
			subTotal = GeneralTools.addToTotal(subTotal, this.getTaskTotalCost());
			subTotal = GeneralTools.addToTotal(subTotal, this.getWorkorderTotalCost());

			return subTotal;
		}

		purchaseCalculator.prototype.getTax = function() {
			return GeneralTools.getHarmonizedSalesTax(this.getSubTotalBeforeTax(), this.taxRate);
		}

		purchaseCalculator.prototype.getTotalCost = function() {
			var total = 0;

			total = GeneralTools.addToTotal(total, this.getSubTotalBeforeTax());
			total = GeneralTools.addToTotal(total, this.getTax());
			total = GeneralTools.addToTotal(total, this.LicensingCost);

			return total;
		}

		return purchaseCalculator;
	}
})();


(function ()
{
	'use strict';

	angular
		.module("app.purchaseInfo")
		.factory("AppraisalForm", AppraisalFormClass)

	/** @ngInject */
	function AppraisalFormClass($filter, $state, api, ToolsFactory, Const, $q, MessageService, LoginService, SalePromotion, SaleInfo, TradeInVehicle, SalePlateOption, SalePresetExtras, Warranty, SaleInfoPayment, MyFile, SaleWarranty, SaleInfoService, CustomersService, GeneralTools, VehicleService, SaleCalculator, PurchaseInfoService, UserService)
	{
		const defaultFontStyle = "20px Arial";
		const dealerRegistrationNumber = "4880563";
		const hstNumber = 'HST: 875901308RT0001'

		function AppraisalForm(tradeInVehicle, customer, UserName, vehicle){
			this.UserName = UserName;
			this.customer = customer;
			this.tradeInVehicle = tradeInVehicle;

			if(customer.emails != null && customer.emails.length > 0){
				this.customerEmail = customer.emails[0];
			}

			if(customer.phone_numbers != null && customer.phone_numbers.length > 0){
				this.phoneNumber = customer.phone_numbers[0];
			}
			this.vehicle = vehicle;

			// this.customer = {
			// 	first_name: "TestName",
			// 	last_name: "TestName",
			// 	birthday: "2006-01-01",
			// 	drivers_license: "1231231234",
			// 	license_expiry_date: "2026-03-18",
			// 	address_postal_code: "QWEEWQ",
			// 	address_street_number: "60",
			// 	address_street: "HELLO",
			// 	address_city: "WORLD",
			// 	address_province: "ON"
			// }
			
			// this.tradeInVehicle = {
			// 	vin: "5N1AT2MV2JC705942",
			// 	year: "2018",
			// 	make: "Nissan",
			// 	model: "Rogue",
			// 	color: "Black",
			// 	trade_in_price: 1000,
			// 	mileage: 140749,
			// 	trade_lien_payout: 10000
			// }

			// this.phoneNumber = {
			// 	phone_number: "1231231234",
			// 	fk_id_phone_category: 3,
			// 	allow_notification: true
			// }

			// this.customerEmail = {
			// 	email_address: "123@123.com",
			// 	fk_id_email_category: "2"
			// }
		}

		AppraisalForm.prototype.getCustomer = function() {
			return this.customer
		}

		AppraisalForm.prototype.getTradeInVehicle = function() {
			return this.tradeInVehicle
		}

		AppraisalForm.prototype.getUserName = function() {
			return this.UserName
		}

		AppraisalForm.prototype.fetchDatas = function(){
			var defer = $q.defer();
			var _this = this;

			var tasks = {
				customer: 	_this.customer,
				tradeInVehicle: 	_this.tradeInVehicle,
				UserName: 		_this.UserName,
				phoneNumber: 	_this.phoneNumber,
				customerEmail: 	_this.customerEmail,
				vehicle: 		_this.vehicle
			}
			$q.all(tasks);
			defer.resolve(tasks);
			return defer.promise;
		}

		AppraisalForm.prototype.open = function() {
			return this.fetchDatas()
				.then(function(appraisalFormData){
					return renderAppraisalFormTask(appraisalFormData);
				})
				.then(function(pdfMake){
					pdfMake.print();
					return $q.resolve();
				})
		}

		AppraisalForm.prototype.getPdfFile = function() {
			var defer = $q.defer()

			this.fetchDatas()
				.then(function(appraisalFormData){
					return renderAppraisalFormTask(appraisalFormData);
				})
				.then(function(pdfMake){
					pdfMake.getBlob(function(blob){
						var file = new File([blob], "appraisal_form.pdf", {type: "application/pdf"});
						defer.resolve(file);
					});
				})
				.catch(function(error){
					defer.reject(error);
				})

			return defer.promise;
		}

		function renderAppraisalFormTask(appraisalFormData){
			return getAppraisalFormPatternCanvas()
				.then(function(pages){
					if(!pages){
						return $q.reject("Failed to get bill of sale image pattern");
					}
					var page1 = pages.page1;

					page1 = fillUserNameSection(page1, appraisalFormData);
					page1 = fillCustomerSection(page1, appraisalFormData);
					page1 = fillTradeInVehicleSection(page1, appraisalFormData);
					page1 = fillTradeInCustomerPhoneSection(page1, appraisalFormData);
					page1 = fillTradeInCustomerEmailSection(page1, appraisalFormData);
					page1 = fillStockNumberSection(page1, appraisalFormData);
			
					return $q.resolve(pdfMake.createPdf(getPdfContent(page1)));
				})
				.catch(function(error){
					return $q.reject(error);
				});
		}

		function fillUserNameSection(canvas, appraisalFormData){
			if(appraisalFormData == null || appraisalFormData.UserName == null){
				return canvas;
			}

			var AppraisalFormUserName = appraisalFormData.UserName;
			var context = canvas.getContext('2d');	
			context.font = "40px Arial";

			if(AppraisalFormUserName != null){
				fillTextOnCanvasContext(AppraisalFormUserName, context, 350, 485);
				fillTextOnCanvasContext(moment().format('MMMM D, YYYY'), context, 410, 375);
			}

			return canvas;
		}

		function fillCustomerSection(canvas, appraisalFormData){
			if(appraisalFormData == null || appraisalFormData.customer == null){
				return canvas;
			}

			var customerFirstName = appraisalFormData.customer.first_name;
			var customerLastName = appraisalFormData.customer.last_name;
			var customerAddressPostalCode = appraisalFormData.customer.address_postal_code;
			var customerAddressStreetNumber = appraisalFormData.customer.address_street_number;
			var customerAddressStreet = appraisalFormData.customer.address_street;
			var customerAddressCity = appraisalFormData.customer.address_city;
			var customerAddressProvince = appraisalFormData.customer.address_province;

			var context = canvas.getContext('2d');	
			context.font = "40px Arial";

			if(customerLastName != null){
				fillTextOnCanvasContext(customerLastName, context, 110, 590);
			}

			if(customerFirstName != null){
				fillTextOnCanvasContext(customerFirstName, context, 1285, 590);
			}

			if(customerAddressPostalCode != null){
				fillTextOnCanvasContext(customerAddressPostalCode, context, 2150, 690);
			}

			if(customerAddressStreetNumber != null){
				fillTextOnCanvasContext(customerAddressStreetNumber, context, 110, 690);
			}

			if(customerAddressStreet != null){
				fillTextOnCanvasContext(customerAddressStreet, context, 610, 690);
			}

			if(customerAddressCity != null){
				fillTextOnCanvasContext(customerAddressCity, context, 1275, 690);
			}

			if(customerAddressProvince != null){
				fillTextOnCanvasContext(customerAddressProvince, context, 1765, 690);
			}

			return canvas;
		}

		function fillTradeInVehicleSection(canvas, appraisalFormData){
			if(appraisalFormData == null || appraisalFormData.tradeInVehicle == null){
				return canvas;
			}

			var tradeInVehicleVin = appraisalFormData.tradeInVehicle.vin;
			var tradeInVehicleYear = appraisalFormData.tradeInVehicle.year;
			var tradeInVehicleMake = appraisalFormData.tradeInVehicle.make;
			var tradeInVehicleModel = appraisalFormData.tradeInVehicle.model;
			var tradeInVehicleColor = appraisalFormData.tradeInVehicle.color;
			var tradeInVehicleMileage = appraisalFormData.tradeInVehicle.mileage;
			
			var context = canvas.getContext('2d');	
			context.font = "40px Arial";

			if(tradeInVehicleVin != null){
				for(var i = 0; i < tradeInVehicleVin.length; i++){
					fillTextOnCanvasContext(tradeInVehicleVin[i], context, 123 + (i * 54), 925);
				}
			}

			if(tradeInVehicleYear != null){
				fillTextOnCanvasContext(tradeInVehicleYear, context, 1090, 945);
			}

			if(tradeInVehicleMake != null){
				fillTextOnCanvasContext(tradeInVehicleMake, context, 1295, 945);
			}

			if(tradeInVehicleModel != null){
				fillTextOnCanvasContext(tradeInVehicleModel, context, 1555, 945);
			}

			if(tradeInVehicleColor != null){
				fillTextOnCanvasContext(tradeInVehicleColor, context, 2080, 945);
			}

			if(tradeInVehicleMileage != null){
				fillTextOnCanvasContext(tradeInVehicleMileage, context, 625, 1475);
			}

			return canvas;
			
		}

		function fillTradeInCustomerPhoneSection(canvas, appraisalFormData){
			if(appraisalFormData == null || appraisalFormData.phoneNumber == null){
				return canvas;
			}

			var AppraisalFormCustomerPhone = appraisalFormData.phoneNumber;
			var context = canvas.getContext('2d');	
			context.font = "40px Arial";

			if(AppraisalFormCustomerPhone != null){
				if(AppraisalFormCustomerPhone.fk_id_phone_category != null){
					switch(AppraisalFormCustomerPhone.fk_id_phone_category){
						case 1 || "1":
							fillTextOnCanvasContext(AppraisalFormCustomerPhone.phone_number, context, 110, 790);
							break;
						case 2 || "2":
							fillTextOnCanvasContext(AppraisalFormCustomerPhone.phone_number, context, 1275, 790);
							break;
						case 3 || "3":
							fillTextOnCanvasContext(AppraisalFormCustomerPhone.phone_number, context, 705, 790);
							break;
						default:
							fillTextOnCanvasContext(AppraisalFormCustomerPhone.phone_number, context, 110, 790);
							break;
					}
				}
			}

			return canvas;
		}

		function fillTradeInCustomerEmailSection(canvas, appraisalFormData){
			if(appraisalFormData == null || appraisalFormData.customerEmail == null){
				return canvas;
			}

			var AppraisalFormCustomerEmail = appraisalFormData.customerEmail;
			var context = canvas.getContext('2d');	
			context.font = "40px Arial";

			if(AppraisalFormCustomerEmail != null){
				fillTextOnCanvasContext(AppraisalFormCustomerEmail.email_address, context, 2100, 790);
			}

			return canvas;
		}

		function fillStockNumberSection(canvas, appraisalFormData){
			if(appraisalFormData == null || appraisalFormData.vehicle == null){
				return canvas;
			}

			var AppraisalFormStocknumber = appraisalFormData.vehicle.stock_number;
			var context = canvas.getContext('2d');	
			context.font = "40px Arial";

			if(AppraisalFormStocknumber != null){
				fillTextOnCanvasContext(AppraisalFormStocknumber, context, 1080, 375);
			}

			return canvas;
		}


		function getAppraisalFormPatternCanvas(){
			var tasks = {
				page1: GeneralTools.getCanvas("assets/images/billofsales/Appraisal_Form.jpg", 2550, 3488),
			}

    		return $q.all(tasks);
		}

		function fillTextOnCanvasContext(text, context, xPosition, yPosition){
			if(text == null || context == null){
				return;
			}

			context.fillText(text, xPosition, yPosition);
		}

		function getPdfContent(page1){
			const scale = Math.min(630 / page1.width, 792 / page1.height);
			return {
				pageSize: 'LETTER',
				content: [
					{	
						margin: [ 0, -45, 0, 0 ],
						image: page1.toDataURL("image/jpg", 1.0),
						fit: [page1.width * scale, page1.height * scale],
					},
				],
				defaultStyle: {
					alignment: "center"
				}
        	};
		}

		return AppraisalForm;
	}


})();
(function ()
{
	'use strict';

	angular
		.module('app.inventory')
		.service("InventoryService", InventoryService);

	/** @ngInject */
	function InventoryService($state, api, ToolsFactory, Const, $q, MessageService, LoginService, $filter, Inventory, HeaderHelper)
	{   
		var codeKey = Const.header.code;
		var messageKey = Const.header.message;
		var successCode = Const.code.success;

		this.updateInventoryRequestBodyGenerator = function(currentInventory, originInventory){
			if(currentInventory == null || originInventory == null){
				return;
			}

			var keyList = Object.keys(currentInventory);
			var changedProperties = {};

			keyList.forEach(function(key){
				var currentValue = currentInventory[key];
				var originValue = originInventory[key];

				if(currentValue == originValue){
					return;
				}

				changedProperties[key] = currentValue;
			});

			return changedProperties;
		}

		this.getInventories = function(resourcePath, filters, pagination, sorting){			
			var defer = $q.defer();
			var queryParams = Object.assign({}, resourcePath, filters, pagination, sorting);

			api.inventory.getInventories(
				queryParams,
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);
						defer.reject(errorMessage);
						return;
					}

					var inventoryList = [];

					response.forEach(function(data){
						var inventory = new Inventory();

						inventory.setAttributes(data);
						inventoryList.push(inventory);
					})

					var result = {
						data: inventoryList,
						headerGetter: header
					}

					defer.resolve(result);
				},
				function(error){
					console.error("Failed to get inventory.");
					defer.reject(error);
				}
			);

			return defer.promise;
		}

		this.getInventoryTypes = function(){			
			var defer = $q.defer();

			api.partTypes.getPartTypes(
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);
						defer.reject(errorMessage);
						return;
					}

					defer.resolve(response);
				},
				function(error){
					console.error("Failed to get inventory types.");
					defer.reject(error);
				}
			);

			return defer.promise;
		}

		this.updateInventory = function(resourcePath, requestBody){
			var defer = $q.defer();

			api.inventory.updateInventory(
				resourcePath,
				requestBody,
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);

						defer.reject(errorMessage);
						return;
					}
					defer.resolve(response);

				},
				function(error){
					console.error(error);
					defer.reject("Failed to update inventory.");
				}
			);	

			return defer.promise;			
		}

		this.createInventory = function(resourcePath, requestBody){
			var defer = $q.defer();

			api.inventory.postInventory(
				resourcePath,
				requestBody,
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);
						defer.reject(errorMessage);
						return;
					}

					defer.resolve(response.data);
				},
				function(error){
					console.error("Failed to create inventory.");
					defer.reject(error);
				}
			);

			return defer.promise;
		}

		this.deleteInventory = function(resourcePath){
			var defer = $q.defer();

			api.inventory.deleteInventory(
				resourcePath,
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);
						defer.reject(errorMessage);
						return;
					}

					defer.resolve(response);
				},
				function(error){
					var errorMessage = error.status + ': ' + error.statusText;
					defer.reject(errorMessage);
				}
			);

			return defer.promise;
		}

		this.modifyInventoryQuantity = function(resourcePath, quantityToAdd){
			var defer = $q.defer();

			api.modifyInventoryQuantity.modify(
				resourcePath,
				{quantity: quantityToAdd},
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);

						defer.reject(errorMessage);
						return;
					}
					defer.resolve(response);

				},
				function(error){
					console.error(error);
					defer.reject("Failed to modify inventory quantity.");
				}
			);	

			return defer.promise;				
		}
	}
})();
(function ()
{
	'use strict';

	angular
		.module("app.inventory")
		.factory("Inventory", InventoryClass)

	/** @ngInject */
	function InventoryClass($filter, InventoryConstants)
	{	 
		function Inventory(){}

		Inventory.prototype.setAttributes = function (attributes) {
	 		if(attributes == null){
	 			return;
	 		}

	 		var keyList = Object.keys(attributes);

	 		for(var i = 0; i < keyList.length; i++){
	 			var key = keyList[i];
	 			var value = attributes[key];

	 			this.setAttribute(key, value);
	 		}
		}

		Inventory.prototype.setAttribute = function (key, value) {
	 		this[key] = value;
		}

		Inventory.prototype.getResourceId = function () {
	 		return this.id_inventory;
		}	

		return Inventory;
	}


})();
(function ()
{
	'use strict';

	angular
		.module('app.parts')
		.service("PartService", PartService);

	/** @ngInject */
	function PartService($state, api, ToolsFactory, Const, $q, MessageService, LoginService, $filter, Part, HeaderHelper)
	{   
		var codeKey = Const.header.code;
		var messageKey = Const.header.message;
		var successCode = Const.code.success;

		this.getAllMatchedParts = function(resourcePath, filters, sorting){
			const limit = 100;
			const _this = this;
			var partList = [];
			
			return _this.getParts(resourcePath, filters, {page: 1, limit: limit}, sorting)
				.then(function(response){
					if(!response || !Array.isArray(response.data)){
						return $q.reject("Failed to fetch parts for report.");
					}

					partList = partList.concat(response.data);

					var totalItem = HeaderHelper.getPaginationTotalItem(response.headerGetter);
					var currentPage = HeaderHelper.getPaginationCurrentPage(response.headerGetter);
					var itemsPerPage = HeaderHelper.getPaginationItemsPerPage(response.headerGetter);

					var queue = [];

					if(response.data.length < totalItem){
						var totalPage = Math.ceil(totalItem/itemsPerPage);

						for(var i = 2; i <= totalPage; i++){
							queue.push(_this.getParts(resourcePath, filters, {page: i, limit: limit}, sorting));
						}
					}

					return $q.all(queue);
				})
				.then(function(responseList){
					if(!Array.isArray(responseList)){
						return $q.reject("Failed to fetch parts for report.");
					}

					for(var i = 0; i < responseList.length; i++){
						var response = responseList[i];

						if(!response || !Array.isArray(response.data)){
							return $q.reject("Failed to fetch parts for report.");
						}

						partList = partList.concat(response.data);
					}

					return $q.resolve(partList);
				});
		}

		this.getParts = function(resourcePath, filters, pagination, sorting){			
			var defer = $q.defer();
			var queryParams = Object.assign({}, resourcePath, filters, pagination, sorting);

			api.parts.getParts(
				queryParams,
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);
						defer.reject(errorMessage);
						return;
					}

					var partList = [];

					response.forEach(function(data){
						var part = new Part();

						part.setAttributes(data);
						partList.push(part);
					})

					var result = {
						data: partList,
						headerGetter: header
					}

					defer.resolve(result);
				},
				function(error){
					console.error("Failed to get part.");
					defer.reject(error);
				}
			);

			return defer.promise;
		}


		this.createPart = function(resourcePath, requestBody){
			var defer = $q.defer();

			api.parts.postPart(
				resourcePath,
				requestBody,
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);
						defer.reject(errorMessage);
						return;
					}

					defer.resolve(response.data);
				},
				function(error){
					console.error("Failed to create part.");
					defer.reject(error);
				}
			);

			return defer.promise;
		}

		this.updatePart = function(resourcePath, requestBody){
			var defer = $q.defer();

			api.parts.updatePart(
				resourcePath,
				requestBody,
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);

						defer.reject(errorMessage);
						return;
					}
					defer.resolve(response);

				},
				function(error){
					console.error(error);
					defer.reject("Failed to update part.");
				}
			);	

			return defer.promise;			
		}

		this.deletePart = function(resourcePath){
			var defer = $q.defer();

			api.parts.deletePart(
				resourcePath,
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);
						defer.reject(errorMessage);
						return;
					}

					defer.resolve(response);
				},
				function(error){
					var errorMessage = error.status + ': ' + error.statusText;
					defer.reject(errorMessage);
				}
			);

			return defer.promise;
		}
	}
})();
(function ()
{
	'use strict';

	angular
		.module("app.parts")
		.factory("Part", PartClass)

	/** @ngInject */
	function PartClass($filter, PartConstants)
	{	 
		function Part(){}

		Part.prototype.setAttributes = function (attributes) {
	 		if(attributes == null){
	 			return;
	 		}

	 		var keyList = Object.keys(attributes);

	 		for(var i = 0; i < keyList.length; i++){
	 			var key = keyList[i];
	 			var value = attributes[key];

	 			this.setAttribute(key, value);
	 		}
		}

		Part.prototype.setAttribute = function (key, value) {
	 		this[key] = value;
		}

		Part.prototype.getResourceId = function () {
	 		return this.id_part;
		}

		Part.prototype.setResourceId = function (id) {
	 		this.id_part = id
		}

		return Part;
	}


})();
(function ()
{  
     "use strict";

    angular
        .module("app.login", ['app.session'])
        .provider('loginInfo', loginProvider)
        .config(config)
        .factory("LoginFactory", LoginFactory);

    /**
     *  Description: --define the webpage url of login page.
     *               --define the area of the module in DOM.
     *               --bind the controller with the webpage.
     *  @param: $stateProvider object
     *  @param: LoginConst object
     */
    function config($stateProvider, LoginConst, loginInfoProvider)
    {   

        $stateProvider
            .state("app.login", {
                url   : LoginConst.loginPageUrl, 

                views : {
                    "content@app": {
                        templateUrl : "app/main/login/login.html",
                        controller  : "LoginController as vm"
                    }
                }
            });
    }

    function loginProvider(){   

        this.$get = function(){
        	document.cookie = "username=John Doe"
            return ;
        }
    }

    /**
     *  Description: provide methods to save, get and clear userStatus locally
     *  @params SessionService object
     *  @params CookieService object  
     *  @params LogService object  
     *  @params LogConst object  
     */
    function LoginFactory(SessionService, CookieService, LogService, LogConst, Const){
        var factory = {};

        var property_isLogin = Const.property.userStatus.isLogin;
        var property_userInfo = Const.property.userStatus.userInfo;

        
        /**
         *  Description: try to get user status from cookie or session.
         *               if userSataus exists, that means user has logged in.
         *               if userSataus doesnt exists, that means user has not logged in.
         *  @return: userStatus  object  this obj should be like the obj below:
         *
         *   userStatus={
         *       isVerifed: boolean
         *       userInfo:{             (this property will not exist if user is not logged in)
         *           userName: string
         *           token: string
         *       }
         *   }
         */
        factory.getUserStatus = function(){
            var userStatus = {};

            //check session to get user status, if null check cookie
            if(SessionService.getUserStatus() != null){
                userStatus[property_isLogin] = true;
                userStatus[property_userInfo] = SessionService.getUserStatus();
                return userStatus;             
            }

            //check cookie to get user status 
            if(CookieService.getUserStatus() != null){
                userStatus[property_isLogin] = true;
                userStatus[property_userInfo] = CookieService.getUserStatus();
                return userStatus;
            }

            //can not find any user status, that means user has not logged in
            userStatus[property_isLogin] = false;           
            return userStatus;
        }

        /**
         *   Description: save userInfo object in session and cookies
         *   @param: userInfo   object   this obj should be like the obj below: 
         * 
         *      userInfo={
         *          userName: string
         *          token: string
         *      }         
         */
        factory.saveUserStatus = function(userInfo){           
            if(userInfo == null || typeof(userInfo) != "object"){
                 LogService.log(new Error, Const.code.system_error, LogConst.errString.err_param);
            }   
            SessionService.saveUserStatus(userInfo);
            CookieService.saveUserStatus(userInfo);            
        }

        factory.updateOutstandingTask = function(userInfo, outstandingTask){           
            if(outstandingTask == null){
                return
            }
            userInfo.companyInfo.outstandingTask = outstandingTask;
            SessionService.saveUserStatus(userInfo);
            CookieService.saveUserStatus(userInfo);            
        }

        /**
         *   Description: clear userInfo object in session and cookies
         */
        factory.clearUserStatus = function(){          
            SessionService.clearUserStatus(); 
            CookieService.clearUserStatus();
        }


        return factory;
    }   
})();

(function ()
{
	'use strict';

	angular
		.module('app.login')
		.service('LoginService', LoginService);

	//Description: encapsulation of LoginFactory, provide methods for get, save and clear userStatus
	function LoginService(LoginFactory, ToolsFactory, $location, $state){  
		var subscribers = [];

		this.saveUserStatus = function(userInfo){			
			LoginFactory.saveUserStatus(userInfo);
			informSubscribers();
		}
		this.getUserStatus = function(){
			return LoginFactory.getUserStatus();
		}
		this.clearUserStatus = function(){
			return LoginFactory.clearUserStatus();
		}

		this.subscribe = function(callback){
			if(typeof(callback) != "function"){
				return;
			}

			ToolsFactory.addUniqueItemToArray(subscribers, callback);
		}

		this.getUserInfo = function(){
			return getUserInfo();
		}

		this.getUserID = function(){
			var userInfo = getUserInfo();
			if(userInfo == null){
				return;
			}
			return userInfo.userID;
		}

		this.getUsername = function(){
			var userInfo = getUserInfo();
			if(userInfo == null){
				return;
			}			
			return userInfo.username;			
		}	

		this.getCompanyInfo = function(){
			return getCompanyInfo();			
		}

		this.getCompanyID = function(){
			var companyInfo = getCompanyInfo();
			if(companyInfo == null){
				return 1;
			}
			return companyInfo.companyID;
		}

		this.getCompanyName = function(){
			var companyInfo = getCompanyInfo();
			if(companyInfo == null){
				return;
			}
			return companyInfo.companyName;			
		}		

		this.getFirstname = function(){
			var userInfo = getUserInfo();
			if(userInfo == null){
				return;
			}			
			return userInfo.firstName;		
		}

		this.getLastname = function(){
			var userInfo = getUserInfo();
			if(userInfo == null){
				return;
			}			
			return userInfo.lastName;				
		}

		this.getProfileImageID = function(){
			var profileImage = getProfielImage()
			if(profileImage == null){
				return;
			}
			return profileImage.imageID;
		}

		this.getProfileImageURL = function(){
			var profileImage = getProfielImage()
			if(profileImage == null){
				return;
			}
			return profileImage.url;
		}	

		this.getUserRoles = function(){
			var userInfo = getUserInfo();
			if(userInfo == null){
				return;
			}			
			return userInfo.roles;	
		}

		this.getUserSubRoles = function(){
			var userInfo = getUserInfo();
			if(userInfo == null){
				return;
			}			
			return userInfo.subRoles;				
		}

		this.getToken = function(){
			var userInfo = getUserInfo();
			if(userInfo == null){
				return;
			}
			return userInfo.token;				
		}

		this.isLoggedIn = function(){
			const userStaus = LoginFactory.getUserStatus();

			return userStaus && userStaus.isLogin;
		}

		this.getPageConfigs = function(key){
			const userInfos = this.getUserInfo();
			if(userInfos && userInfos.pageConfigs){
				return userInfos.pageConfigs[key];
			}
		}

		this.savePageConfigs = function(key, value){
			const userInfos = this.getUserInfo();

			if(!userInfos){
				return;
			}

			if(!userInfos.pageConfigs){
				userInfos.pageConfigs = {};
			}

			userInfos.pageConfigs[key] = value ;
			this.saveUserStatus(userInfos);
		}

		function informSubscribers(){
			subscribers.forEach(function(callback){
				callback.call();
			})
		}

		function getUserInfo () {
			var userStatus = LoginFactory.getUserStatus();
			var currentLocation = $state.current.name;

			if(userStatus != null && userStatus.userInfo != null){
				return userStatus.userInfo;
			}  
		}

		function getCompanyInfo(){
			var userInfo = getUserInfo();

			if(!userInfo){
				return;
			}
			return userInfo.companyInfo;			
		}

		function getProfielImage(){
			var userInfo = getUserInfo();
			if(userInfo == null){
				return;
			}
			return userInfo.profileImage;			
		}		

		this.getOutstandingTask = function(){
			var companyInfo = getCompanyInfo();
			
			if(companyInfo == null){
				return;
			}
			return companyInfo.outstandingTask;				
		}

		this.setOutstandingTask = function(outstandingTask){
			var userInfo = getUserInfo();
			if(userInfo == null || outstandingTask == null){
				return;
			}
			LoginFactory.updateOutstandingTask(userInfo, outstandingTask);
		}
	}
})();
(function ()
{
    "use strict";

    angular
        .module("app.login")
        .controller("LoginController", LoginController);

    /** @ngInject */
    function LoginController($scope, LoginService, api, userInfoObjService, LogService, LogConst, Const, LoginConst)
    {   
        //init ui
        init();

        //
        var property_code = Const.property.loginResponse.code;
        var property_username = Const.property.loginResponse.username;
        var property_token = Const.property.loginResponse.token;

        var str_warn_login_input_empty          = LogConst.warnString.warn_login_input_empty;
        var str_warn_login_username_pwd_invalid = LogConst.warnString.warn_login_username_pwd_invalid;
        var str_warn_token_not_found            = LogConst.warnString.warn_token_not_found;
        var str_warn_username_not_found         = LogConst.warnString.warn_username_not_found;

        var log_type_err = LogConst.logType.error;

        var str_err_http_request = LogConst.errString.err_http_request;
        var str_err_http_response = LogConst.errString.err_http_response;

        /**
         *  Description: when the login button is clicked, send a http request to verify user,   
         */
        $scope.login = function(){

            //input form vaildation, only accept a-zA-Z0-9, not null required 
            if(!$scope.loginForm.$valid){ 
                LogService.log(new Error, Const.code.user_error, LogConst.errString.err_param); 

                //show the alert to user
                $scope.verifyNotice = {isVisible : true, content:str_warn_login_input_empty};
                return;
            }  

            //call the api which is defined in index.api.js 
            api.login.save( 
                {   
                    //attach params to the request body
                    username: $scope.loginForm.username, 
                    password: $scope.loginForm.password 
                },
                
                function(response,header){  
                    var responseCode = parseInt(header(Const.header.code), 10);
                    var hasHeaderCode = !isNaN(responseCode);
                    var hasLoginPayload = response && response.token;

                    if((hasHeaderCode && responseCode !== Const.code.success) || (!hasHeaderCode && !hasLoginPayload)){
                        $scope.verifyNotice = {
                            isVisible : true,
                            content: header(Const.header.message) || response && response.message || str_warn_login_username_pwd_invalid
                        };
                        return;
                    }

                    var userInfoObj = {
                        firstName :response.firstname,
                        lastName :response.lastname,
                        username: response.username,
                        token:response.token,
                        roles:response.roles,
                        subRoles:response.subRoles,
                        companyInfo: response.companyInfo,
                        userID: response.userID,
                        profileImage : response.profileImage
                    };

                    //save userinfo locally
                    LoginService.saveUserStatus(userInfoObj);
 
                    //check if user login in because scaning work order qr code
                    if(window.localStorage.getItem("accessingWorkOrderWothQRCode") == "true" && window.localStorage.getItem("accessingWorkOrderWothQRCodeURL") != undefined){
                        var targetUrl = angular.copy(window.localStorage.getItem("accessingWorkOrderWothQRCodeURL"))
                        window.localStorage.removeItem("accessingWorkOrderWothQRCode");
                        window.localStorage.removeItem("accessingWorkOrderWothQRCodeURL");
                        location.href = targetUrl

                    }else{
                    //go to home page
                    location.href = '/';
                    }

                },

                //handle the request error
                function(response){ 
                    $scope.verifyNotice = {isVisible : true, content:str_warn_login_input_empty};
                    LogService.log(new Error, Const.code.system_error, response); 
                }
            );
        };

        /**
         *  Description: when the dismiss button is clicked, dismiss the alert
         */
        $scope.dismissAlert = function(){
            $scope.verifyNotice = {isVisible : false};
        };

        function init (){
            $scope.logo = {initial : Const.logo.initial};           
        }

    }
})();
/**
 *  Description: define the webpage url for loginPage
 */
(function ()
{
    "use strict";

    angular
        .module("app.login")
        .constant("LoginConst", {
            loginPageUrl: "/loginpage",
            pageConfigKeys:{
            	workorderSchedule: "workorderSchedule",
            	vehicleDetailTask: "vehicleDetailTask",
            	browseWorkorder: "browseWorkorder",
                editWorkorder: "editWorkorder",
                salesMode:"salesMode"
            }
        });   
})();
(function ()
{
    "use strict";

    angular
        .module("app.log", [])
        .factory("LogFactory", LogFactory);

        //Description: provide methods to manage logs 
        function LogFactory(LogConst, Const, ToolsFactory){
            var str_general_at_file = LogConst.generalString.general_at_file;
            var str_general_at_line = LogConst.generalString.general_at_line;  
            var code_success        = Const.code.success;

            var factory = {};

            /**
             *  Description: print logs on the console
             *  @param  logString
             */
            factory.logToConsole = function(code, fileNameStr, lineNumberStr, messageStr){
                var logStr = messageStr + str_general_at_file + fileNameStr + str_general_at_line + lineNumberStr;

                if (code == code_success)
                {   
                    console.log(logStr);    
                }
                else if (code < code_success)
                {
                    console.error(logStr);
                }
                else if (code > code_success)
                {
                    console.warn(logStr);
                }
            }

            return factory;
        }
})();
(function ()
{
    "use strict";

    angular
        .module("app.log")
        .service("LogService", LogService);

    //Description: encapsulation of LogFactory provide method to manage logs  
    function LogService(LogFactory, LogConst, Const)
    {       
        var property_fileName = Const.property.error.fileName;
        var property_sourceURL = Const.property.error.sourceURL;
        var property_lineNumber = Const.property.error.lineNumber;
        var property_line = Const.property.error.line;

        var str_general_at_file = LogConst.generalString.general_at_file;
        var str_general_at_line = LogConst.generalString.general_at_line;

        //set all strings to unknown as defaul 
        var fileNameStr = LogConst.generalString.general_unknown;
        var lineNumberStr = LogConst.generalString.general_unknown;
        var messageStr = LogConst.errString.err_unknown;
        
        /**
         *  Description: save userInfo obj in cookie
         *  @param error   object   this param is to provide fileName and lineNumber
         *  @param code    number
         *  @param message string           
         */        
        this.log=function(error, code, message){

            /**
             *  get file name and line number for the error obj.
             *  because there will be 2 different set of properties in the error obj according  
             *  to different browser, so check both, if the param is valid, put it in the logStr
             */   
            if(error.hasOwnProperty(property_fileName) && error[property_fileName]!= null){
                fileNameStr = error[property_fileName];
            }else if (error.hasOwnProperty(property_sourceURL) && error[property_sourceURL] != null){
                fileNameStr = error[property_sourceURL];
            }

            if(error.hasOwnProperty(property_lineNumber) && error[property_lineNumber] != null){
                lineNumberStr = error[property_lineNumber];
            }else if (error.hasOwnProperty(property_line) && error[property_line] != null){
                lineNumberStr = error[property_line];
            }

            if(message != null){
                messageStr = message;
            }

            //handle logStr
            LogFactory.logToConsole(code, fileNameStr, lineNumberStr, messageStr);
        }   
    }
})();
var type_error				= "error";
var type_warn				= "warning";
var type_message			= "message";

var err_param				= " params are null or undefined";
var err_mysql_conn			= " mysql connection error";
var err_user_verify			= " user verification error";
var err_role_query			= " role query error";
var err_token_create		= " token creation error";
var err_token_verify		= " token verification error";
var err_http_response		= " http response error";
var err_http_request		= " http request error";
var err_unknown				= " unknown_error";

var warn_login_username_pwd_invalid	= " username or password invaild";
var warn_login_input_empty	= " username or password is empty";
var warn_another_example	= " another_warning_example";
var warn_token_not_found	= " token not found";
var warn_username_not_found	= " username not found";

var msg_unknown_message		= " unknown_message";

var general_unknown			= " unknown";
var general_at				= " @";
var general_file			= " file: ";
var general_line			= " line: ";

/**
 *  Description: provide all the constant strings defined above  
 */
(function ()
{
	"use strict";

	angular
		.module("app.log")
		.constant("LogConst",{
			logType : {
				error			: type_error,
				warning			: type_warn,
				message			: type_message
			},
			errString : {
				err_param	      : type_error + err_param,
				err_mysql_conn    : type_error + err_mysql_conn,
				err_user_verify   : type_error + err_user_verify,
				err_role_query    : type_error + err_role_query,
				err_token_create  : type_error + err_token_create,
				err_token_verify  : type_error + err_token_verify,
				err_http_response : type_error + err_http_response,
				err_http_request  : type_error + err_http_request,
				err_unknown       : type_error + err_unknown
			},
			warnString : {
				warn_login_username_pwd_invalid :	warn_login_username_pwd_invalid,
				warn_login_input_empty			:	warn_login_input_empty,
				warn_token_not_found			:	warn_token_not_found,
				warn_username_not_found			:	warn_username_not_found	

			},
			messageString : {
				msg_unknown_message	 :  type_message + msg_unknown_message
			},
			generalString : {
				general_unknown : general_unknown,
				general_at		: general_at,
				general_at_file	: general_at + general_file,	
				general_at_line	: general_at + general_line
			}        	
		});    
})();
(function ()
{
    "use strict";

    angular
        .module("app.homepage", [])
        .config(config);

    /**
     *  Description: --define the webpage url of homepage.
     *               --define the area of the module in DOM.
     *               --bind the controller with the webpage.
     */
    function config($stateProvider)
    {
        $stateProvider
            .state("app.homepage", {
                url   : '/',

                views : {
                    "content@app": {
                        templateUrl : "app/main/homepage/homepage.html",
                        controller  : "HomeController as vm"
                    }
                }
            });
    }   
})();
(function ()
{
    'use strict';

    angular
        .module('app.homepage')
        .controller('HomeController', HomeController);

    function HomeController(VehicleService, $q, $resource, $state, FileUploadService){   
        var vm = this;
        
        $state.go("app.vehicles");
    }
})();
(function ()
{
    "use strict";

    angular
        .module("app.lightGallery", [])
        .config(config);

    function config($stateProvider){}   
})();
(function ()
{
	'use strict';

	angular
		.module('app.lightGallery')
		.service("LightGalleryService", LightGalleryService);

	/** @ngInject */
	function LightGalleryService()
	{   
		this.openGallery = function(){
			const actualMedia = document.createElement('div');
			actualMedia.style.display = "none"
			actualMedia.setAttribute('id', '1234');

			var videlem = document.createElement("video");
			videlem.className += 'lg-video-object lg-html5'
			videlem.setAttribute('controls', '');
			videlem.setAttribute('preload', 'none');


			var sourceMP4 = document.createElement("source"); 
			sourceMP4.type = "video/mp4";
			sourceMP4.src = "https://cardepot-01.nyc3.digitaloceanspaces.com/6f2ff320-3686-4f49-8d66-a79a36408794_SampleVideo_640x360_2mb.mp4";


			videlem.appendChild(sourceMP4);
			actualMedia.appendChild(videlem);

			document.body.appendChild(actualMedia);

			var ul = document.createElement("ul"); 
			ul.setAttribute('id', 'asdf');

			var li = document.createElement("li"); 
			li.setAttribute('data-poster', 'https://cardepot-01.nyc3.digitaloceanspaces.com/62166c2f-4113-4ab1-8dc1-86d6cfde17f0_997d764f-d46c-41d6-84c3-1086f9421c6a_600x600_600x600_600x600_14.jpg');
			li.setAttribute('data-sub-html', 'video caption1');
			li.setAttribute('data-html', '#1234');

			ul.appendChild(li);

			document.body.appendChild(ul);


			lightGallery(document.getElementById('asdf'),{
				thumbnail: false,
				dynamic: true,
				dynamicEl:[
					{
						html:"lg-html5"
					}
				]
			});
		}

		/*

		this.copyToClipboard = function(text){
			const element = document.createElement('textarea');
			element.value = text;
			element.setAttribute('readonly', '');
			element.style.position = 'absolute';
			element.style.left = '-9999px';
			document.body.appendChild(element);
			element.select();
			document.execCommand('copy');
			document.body.removeChild(element);
		}

		*/
	}
})();
(function ()
{
	'use strict';

	angular.module('app.hellosign', [])
		.constant("HellosignConstants", {
			signerStatusCode: {
				signed: "signed"
			},
			clientID:{
				product:"e2ffeaa090cb2c626f2e401962f7e231",
				productBackup:"1c311067b386f101a1970f47901e5c1f",
				test:"256206be68412364a4883aa6ac7b0de4"
			}

		})
		.config(config);

	function config($stateProvider){

		$stateProvider
			.state("app.signing-page", {
				url   : '/sign/:signerSignatureId?successRedirUrl&successRedirTitle&failRedirUrl&failRedirTitle',
				views : {
					"content@app": {
						templateUrl : "app/main/hellosign/signing-page.html",
						controller  : "SigningPageController as vm"
					}
				}
			});
	} 

})();
(function ()
{
	'use strict';

	angular
		.module('app.hellosign')
		.controller('SigningPageController', SigningPageController);

	function SigningPageController($state, $stateParams, ProgressService, MessageService, HellosignService){  
		var vm = this;
	
		vm.isProcessing = true;

		HellosignService.finishSignatureRequest($stateParams.signerSignatureId)
			.then(function(response){
				vm.message = "Signature Completed!"

				vm.redirectUrl = $stateParams.successRedirUrl;
				vm.redirectTitle = $stateParams.successRedirTitle? $stateParams.successRedirTitle:$stateParams.successRedirUrl;
			})
			.catch(function(error){
				vm.message = error;

				vm.redirectUrl = $stateParams.failRedirUrl;
				vm.redirectTitle = $stateParams.failRedirTitle? $stateParams.failRedirTitle:$stateParams.failRedirUrl;
			})
			.finally(function(){
				vm.isProcessing = false;
			})
	}
})();
(function ()
{
	'use strict';

	angular
		.module('app.hellosign')
		.service("HellosignService", HellosignService);

	/** @ngInject */
	function HellosignService(ApiConst, $state, api, ToolsFactory, Const, $q, MessageService, LoginService, $filter, FileUploadService, HellosignConstants, SaleInfoService)
	{
		var codeKey = Const.header.code;
		var messageKey = Const.header.message;
		var successCode = Const.code.success;

		var billOfSaleUploader = FileUploadService.getNewUploader();
		billOfSaleUploader.filters.push(FileUploadService.getSizeFilter(20));

		var host 		= ApiConst.host;
		var apiPortoal 	= ApiConst.apiPortoal;
		var apiVersion 	= ApiConst.apiVersion;
		var http 		= ApiConst.http;

		var clientID;
		var skipDomainVerification = false;

		switch(window.location.host){
			case ApiConst.productDomain:
				clientID = HellosignConstants.clientID.product;
				break;
			case ApiConst.productBackupDomain:
				clientID = HellosignConstants.clientID.productBackup;
				break;
			default:
				clientID = HellosignConstants.clientID.test;
				skipDomainVerification = true;
				break;
		}

		HelloSign.init(clientID);

		this.finishSignatureRequest = function(signatureIdForSigner){
			var defer = $q.defer();

			getEmbededUrl(signatureIdForSigner)
				.then(function(embeddedUrl){
					HelloSign.open({
						skipDomainVerification: skipDomainVerification,
						url: embeddedUrl,	 
						allowCancel: true,
						messageListener: function(eventData){
							if(eventData && eventData.event == "signature_request_signed"){
								defer.resolve(eventData);
							}else{
								defer.reject(eventData.event);
							}
						}	
					});
				})
				.catch(defer.reject);

			return defer.promise;
		}

		function getEmbededUrl(signatureIdForSigner){
			var defer = $q.defer();

			var param = {
				companyID: LoginService.getCompanyID(),
				signatureID: signatureIdForSigner
			}

			api.embededHellosign.getEmbededUrl(
				param,
				function(res, header){
					if(res.embeddedUrl){
						defer.resolve(res.embeddedUrl);
					}else{
						defer.reject(res.message);
					}
					
				},
				function(error){
					defer.reject(error);
				}
			);

			return defer.promise;			
		}

		this.createSignatureRequest = function(resourceUrl, file, signers, signatureInfos){
			var defer = $q.defer();

			billOfSaleUploader.onAfterAddingFile = function(fileItem){
				var baseUrl	= http + host + '/' + apiPortoal + '/' + apiVersion + '/';

				fileItem.formData = [
					{signers: JSON.stringify(signers)},
					{signatureInfos: JSON.stringify(signatureInfos)}
				];

				fileItem.url = baseUrl + resourceUrl;
				fileItem.upload();
			}

			billOfSaleUploader.onCompleteItem = function(item, response, status, headers){
				if(response && headers.code == successCode.toString()){
					defer.resolve(response);
				}else{
					defer.reject(headers.message);
				}
			}

			billOfSaleUploader.addToQueue(file)

			return defer.promise;
		}

		this.isAllSignersCompleted = function (signature){	
			if(!signature || !Array.isArray(signature.signatures)){
				return
			}

			var unfinishedSigner = signature.signatures.find(function(signer){
				return signer.status_code != HellosignConstants.signerStatusCode.signed;
			});

			return !unfinishedSigner;
		}

		this.openSigningPageInNewTab = function(embeddedUrl){
			var url = $state.href('app.signing-page', {embeddedUrl: embeddedUrl});
			window.open(url,'_blank');
		}

	}
})();
(function ()
{
	"use strict";

	angular
		.module("app.fileView", [])
		.config(config);

	/**
	 *  Description: --define the webpage url of homepage.
	 *			   --define the area of the module in DOM.
	 *			   --bind the controller with the webpage.
	 */
	function config($stateProvider)
	{
		$stateProvider
			.state("app.fileView", {
				url   : '/file/{uuid}',

				views : {
					"content@app": {
						templateUrl : "app/main/file-view/file-view.html",
						controller  : "FileViewController as vm"
					}
				},

				resolve :{
					fileData:function($stateParams, MessageService, FileViewService){
						return FileViewService.getFileByUUID($stateParams.uuid).catch(function(error){console.log(error)});
					}
				}
			})
	}   
})();
(function ()
{
	'use strict';

	angular
		.module('app.fileView')
		.service("PdfViewerService", PdfViewerService);

	/** @ngInject */
	function PdfViewerService($q)
	{   
		const pdfJs = window['pdfjs-dist/build/pdf'];
		pdfJs.GlobalWorkerOptions.workerSrc = 'https://cdn.jsdelivr.net/npm/pdfjs-dist@2.4.456/build/pdf.worker.js';

		this.getPdfjs = function(){
			return pdfJs;
		}

		this.renderPage = function(page, canvas){
			if(!page || !canvas){
				return $q.reject("page or canvas invalid when renderPage");
			}

			const viewport = page.getViewport({scale: 1});
			canvas.height = viewport.height;
			canvas.width = viewport.width;

			const renderContext = {
				canvasContext: canvas.getContext('2d'),
				viewport: viewport
			}

			return page.render(renderContext).promise;
		}
	}
})();
(function ()
{
	"use strict";

	angular
		.module("app.fileView")
		.component("pdfViewer", {
				bindings:{
					src:'<',
					options:'<'
				},
				templateUrl: "app/main/file-view/pdf-viewer.html",
				controller: componentController,
		  		controllerAs: 'vm'
			});

		function componentController($q, MessageService, $element, PdfViewerService, $scope){
			const vm = this;	
			const pdfJs = PdfViewerService.getPdfjs();
			const canvasContainer = $element.children("#canvasContainer");
			var canvasList;

			vm.$onInit = initComponent;
			vm.$postLink = initOutPutCallbacks;

			function initComponent(){
				$scope.$watch("vm.src", render);
			}

			function initOutPutCallbacks(){

			}

			function render(){
				if(!vm.src){
					return;
				}

				pdfJs.getDocument(vm.src)
					.promise
					.then(getAllPages)
					.then(renderAllPages)
					.catch(MessageService.showToast)
					.finally(function(){

					});
			}

			function getAllPages(pdfDoc){
				if(!pdfDoc){
					return $q.reject("pdfDoc invalid when getAllPages");
				}

				var totalPageNum = pdfDoc.numPages;
				var queue = [];

				for(var i = 1; i <= totalPageNum; i++){
					queue.push(pdfDoc.getPage(i));
				}

				return $q.all(queue);
			}

			function renderAllPages(pages){
				if(!Array.isArray(pages)){
					return $q.reject("pages is not an array when renderAllPages");
				}

				var queue = [];
				canvasList = [];

				pages.forEach(function(page){
					var canvas = createCanvas();
					canvasList.push(canvas)
					queue.push(PdfViewerService.renderPage(page, canvas));
				});

				return $q.all(queue);
			}

			function createCanvas(){
				const canvas = document.createElement("canvas");
				canvasContainer.append(canvas);
				return canvas;
			}
		}
})();
(function ()
{
	'use strict';

	angular
		.module("app.fileView")
		.factory("MyFile", MyFileClass)

	/** @ngInject */
	function MyFileClass(ApiConst)
	{	   
		var http 			= ApiConst.http;
		var host 			= ApiConst.host;
		var apiPortoal 		= ApiConst.apiPortoal;
		var apiVersion 		= ApiConst.apiVersion;	
		
		function MyFile(){}

		MyFile.prototype.setAttributes = function (attributes) {
	 		var keyList = Object.keys(attributes);

	 		for(var i = 0; i < keyList.length; i++){
	 			var key = keyList[i];
	 			var value = attributes[key];

	 			this.setAttribute(key, value);
	 		}
		}

		MyFile.prototype.setAttribute = function (key, value) {
	 		this[key] = value;
		}

		MyFile.prototype.setResourceID = function (id) {
	 		this.id_file = id;
		}

		MyFile.prototype.getResourceID = function () {
	 		return this.id_file;
		}	

		MyFile.prototype.getResourcePath = function () {
	 		var baseUrl	= http + host + '/' + apiPortoal + '/' + apiVersion + '/';
			return baseUrl + this.api_path + "/" + this.uuid + "/download";
		}	

		MyFile.prototype.getFileType = function () {
			return this.file_type;
		}	

		MyFile.prototype.isPublic = function () {
			return this.is_public;
		}	

		MyFile.prototype.getURL = function () {
			return this.url;
		}

		MyFile.prototype.getUUID = function () {
			return this.uuid;
		}

		MyFile.prototype.getFileName = function () {
			return this.file_name;
		}

		MyFile.prototype.isImage = function () {
			return !!this.file_type && this.file_type.indexOf("image") != -1;
		}

		MyFile.prototype.isPdf = function () {
			return !!this.file_type && this.file_type.indexOf("pdf") != -1;
		}

		return MyFile;
	}

})();
(function ()
{
	'use strict';

	angular
		.module('app.fileView')
		.service("FileViewService", FileViewService);

	/** @ngInject */
	function FileViewService($state, MyFile, $q, api, Const, $resource, LoginService)
	{   
		var codeKey = Const.header.code;
		var messageKey = Const.header.message;
		var successCode = Const.code.success;

		this.openFileInNewTab = function(uuid){
			var url = $state.href('app.fileView', {uuid: uuid});
			window.open(url,'_blank');
		}

		this.generateUrlByUUID = function(uuid){
			return $state.href('app.fileView', {uuid: uuid}, {absolute: true});
		}

		this.getFileByUUID = function(uuid){
			var defer = $q.defer();

			api.files.getFileByUUID(
				{uuid : uuid},
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);
						defer.reject(errorMessage);
						return;
					}

					var file = new MyFile();
					file.setAttributes(response)
					
					defer.resolve(file);
				},
				function(error){
					console.error(error);
					defer.reject("Failed to get file");
				}
			);

			return defer.promise;			
		}

		this.downloadFile = function(resourcePath, imageOptions){
			var defer = $q.defer();

			var api = resourceApiBuilder(resourcePath, imageOptions);

			api.download(
				{},
				function(response, header){
					var statusCode  = header(codeKey);
					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);
						defer.reject(errorMessage);
						return;
					}

					defer.resolve(response);
				},
				function(error){
					console.error(error);
					defer.resolve("Failed to download file");
				}
			);

			return defer.promise;
		}

		function resourceApiBuilder(resourcePath, imageOptions){
			return $resource(
				resourcePath,
				imageOptions,
				{
					download:{
						method:"GET",
						headers: { 
							token: LoginService.getToken()
						}
					}
				}
			);
		}
	}
})();
(function ()
{
	'use strict';

	angular
		.module('app.fileView')
		.controller('FileViewController', FileViewController);

	function FileViewController($q, fileData, $sce, $scope, ProgressService, MessageService, FileViewService, $state, GeneralTools, $http){  
		var vm = this;
		var blob;

		vm.download = download

		initFileView();

		function initFileView(){
			vm.file = fileData;

			if(!vm.file){
				MessageService.showToast("File is empty.")
				return;
			}

			if(vm.file.getFileType().indexOf("pdf") != -1){
				vm.isPdf = true;
			} else if(vm.file.getFileType().indexOf("image") != -1){
				vm.isImage = true;
			}

			vm.otherType = !vm.isPdf && !vm.isImage;

			if(!!vm.file.isPublic()){
				renderPublicFile(fileData);
			}else{
				renderPrivateFile(fileData);
			}
		}

		function renderPublicFile(fileData){
			var url = fileData.getURL();

			if(!vm.isImage){
				url = "https://docs.google.com/viewer?embedded=true&url=" + url;
			}

			vm.fileUrl = $sce.trustAsResourceUrl(url);
		}

		function renderPrivateFile(fileData){
			ProgressService.setMode("indeterminate");
			ProgressService.isVisble(true);	

			FileViewService.downloadFile(fileData.getResourcePath())
				.then(function(response){
					var stream 	= new Uint8Array(response.data);

					blob = new Blob([stream], {type: vm.file.getFileType()});
					
					vm.fileUrl = URL.createObjectURL(blob);
				})
				.catch(MessageService.showToast)
				.finally(function(){
					ProgressService.isVisble(false);
				});
		}

		function download(){
			var url = !!vm.file.isPublic()? fileData.getURL():URL.createObjectURL(blob);

			// when blob url is used by print or download, it is somehow not available, so generate a new one
			GeneralTools.downloadFileByUrl(url, vm.file.getFileName());
		}
	}
})();
(function ()
{
	"use strict";
	angular.module("app.financeApplication",[]);

})();
(function ()
{
	'use strict';

	angular
		.module('app.financeApplication')
		.service("FinanceApplicationService", FinanceApplicationService);

	/** @ngInject */
	function FinanceApplicationService($state, api, ToolsFactory, Const, $q, MessageService, LoginService, $filter, FinanceApplication, ConstantCacheService)
	{   
		var codeKey = Const.header.code;
		var messageKey = Const.header.message;
		var successCode = Const.code.success;

		this.updateFinanceApplicationRequestBodyGenerator = function(currentFinanceApplication, originFinanceApplication){
			if(currentFinanceApplication == null || originFinanceApplication == null){
				return;
			}

			var keyList = Object.keys(currentFinanceApplication);
			var changedProperties = {};

			keyList.forEach(function(key){
				var currentValue = currentFinanceApplication[key];
				var originValue = originFinanceApplication[key];

				if(key == "employer_phone_number" && isSamePhoneNumber(currentValue, originValue)){
					return;
				}

				if(currentValue == originValue){
					return;
				}

				changedProperties[key] = currentValue;
			});

			return changedProperties;
		}

		function isSamePhoneNumber(phoneNumber1, phoneNumber2){
			// one of them is null
			if(!phoneNumber1 != !phoneNumber2){
				return false;
			}

			// both not null
			if(phoneNumber1 && phoneNumber2){
				return phoneNumber1.phone_number == phoneNumber2.phone_number;
			}

			// both null
			return true;
		}

		this.getLivingArrangementTypes = function(){
			var defer = $q.defer();

			api.getConstants.getLivingArrangementTypes.get(
				{},
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);

						defer.reject(errorMessage);
						return;
					}
					defer.resolve(response);

				},
				function(error){
					console.error(error);
					defer.reject("Fail to get living arrangment types.");
				}
			);	

			return defer.promise;			
		}

		this.getCachedLivingArrangementTypes = function () {
			return ConstantCacheService.get('living_arrangement_types', function () {
				return this.getLivingArrangementTypes();
			}.bind(this));
		}

		this.getEmploymentStatus = function(){
			var defer = $q.defer();

			api.getConstants.getEmploymentStatus.get(
				{},
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);

						defer.reject(errorMessage);
						return;
					}
					defer.resolve(response);

				},
				function(error){
					console.error(error);
					defer.reject("Fail to get employment status.");
				}
			);	

			return defer.promise;			
		}

		this.getCachedEmploymentStatus = function () {
			return ConstantCacheService.get('employment_status', function () {
				return this.getEmploymentStatus();
			}.bind(this));
		}

		this.createFinanceApplication = function(resourcePath, requestBody){
			var defer = $q.defer();

			api.financeApplications.createFinanceApplication(
				resourcePath,
				requestBody,
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);

						defer.reject(errorMessage);
						return;
					}
					defer.resolve(response.data);

				},
				function(error){
					console.error(error);
					defer.reject("Failed to create finance appliction");
				}
			);	

			return defer.promise;			
		}

		this.updateFinanceApplication = function(resourcePath, requestBody){
			var defer = $q.defer();

			api.financeApplications.updateFinanceApplication(
				resourcePath,
				requestBody,
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);

						defer.reject(errorMessage);
						return;
					}
					defer.resolve(response);

				},
				function(error){
					console.error(error);
					defer.reject("Failed to update finance application.");
				}
			);	

			return defer.promise;			
		}	

		this.getFinanceApplications = function(resourcePath){
			var defer = $q.defer();

			api.financeApplications.getFinanceApplications(
				resourcePath,
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);

						defer.reject(errorMessage);
						return;
					}

					var financeApplicationList = [];

					response.forEach(function(resourceData){
						var financeApplication = new FinanceApplication();
						financeApplication.setAttributes(resourceData);

						financeApplicationList.push(financeApplication);
					})

					defer.resolve(financeApplicationList);
				},
				function(error){
					console.error(error);
					defer.reject("Failed to get finance appliction");
				}
			);	

			return defer.promise;			
		}	
	}
})();
(function ()
{
	'use strict';

	angular
		.module("app.financeApplication")
		.factory("FinanceApplication", FinanceApplicationClass)

	/** @ngInject */
	function FinanceApplicationClass($filter)
	{	   
		function FinanceApplication(){}

		FinanceApplication.prototype.setAttributes = function (attributes) {
	 		if(attributes == null){
	 			return;
	 		}

	 		var keyList = Object.keys(attributes);

	 		for(var i = 0; i < keyList.length; i++){
	 			var key = keyList[i];
	 			var value = attributes[key];

	 			this.setAttribute(key, value);
	 		}
		}

		FinanceApplication.prototype.setAttribute = function (key, value) {
	 		this[key] = value;
		}
		

		FinanceApplication.prototype.setSaleInfoID = function (id) {
	 		this.fk_id_sale_info = id;
		}

		FinanceApplication.prototype.getSaleInfoID = function () {
	 		return this.fk_id_sale_info;
		}

		FinanceApplication.prototype.setCustomerID = function (id) {
	 		this.fk_id_customer = id;
		}

		FinanceApplication.prototype.getCustomerID = function () {
	 		return this.fk_id_customer;
		}

		FinanceApplication.prototype.setResourceID = function (id) {
	 		this.id_finance_application = id;
		}

		FinanceApplication.prototype.getResourceID = function () {
	 		return this.id_finance_application;
		}			

		FinanceApplication.prototype.setLivingArrangementType = function (livingArrangementType) {
	 		if(livingArrangementType == null){
	 			return;
	 		}

	 		this.fk_id_living_arrangement_type = livingArrangementType.id_living_arrangement_type;
		}

		return FinanceApplication;
	}

})();
(function ()
{
	"use strict";

	angular
		.module("app.fileUpload",[])
		.directive('ngThumb', ['$window', function($window) {
			var helper = {
				support: !!($window.FileReader && $window.CanvasRenderingContext2D),
				isFile: function(item) {
					return angular.isObject(item) && item instanceof $window.File;
				},
				isImage: function(file) {
					var type =  '|' + file.type.slice(file.type.lastIndexOf('/') + 1) + '|';
					return '|jpg|png|jpeg|bmp|gif|'.indexOf(type) !== -1;
				}
			};


			var directive = {

				restrict: 'A',
				template: '<canvas class="rounded" style="object-fit: cover;"/>',
				link: function(scope, element, attributes) {
					if (!helper.support) return;

					var params = scope.$eval(attributes.ngThumb);

					if (!helper.isFile(params.file)) return;
					if (!helper.isImage(params.file)) return;

					var canvas = element.find('canvas');
					var reader = new FileReader();

					reader.onload = onLoadFile;
					reader.readAsDataURL(params.file);

					function onLoadFile(event) {
						var img = new Image();
						img.onload = onLoadImage;
						img.src = event.target.result;
					}

					function onLoadImage() {
						var width = params.width || this.width / this.height * params.height;
						var height = params.height || this.height / this.width * params.width;
						canvas.attr({ width: width, height: height });

						canvas[0].getContext('2d').drawImage(this, 0, 0, width, height);
					}
				}

			};
			return directive;
		}]);
})();
(function ()
{
	'use strict';

	angular
		.module('app.fileUpload')
		.service("FileUploadService", fileUploadService);

	/** @ngInject */
	function fileUploadService(LoginService, ApiConst, FileUploader, Const, MessageService)
	{		
		FileUploader.FileSelect.prototype.isEmptyAfterSelection = function() {
			return true
		};	

		var host 		= ApiConst.host;
		var apiPortoal 	= ApiConst.apiPortoal;
		var apiVersion 	= ApiConst.apiVersion;
		var http 		= ApiConst.http;

		var baseUrl		= http + host + '/' + apiPortoal + '/' + apiVersion + '/';

		var companies			= ApiConst.resources.companies.resourceName;
		var users				= ApiConst.resources.users.resourceName;	
		var profileImage		= ApiConst.resources.profileImages.resourceName;
		var vehicles			= ApiConst.resources.vehicles.resourceName;	
		var vehicleImages		= ApiConst.resources.vehicleImages.resourceName;
		var customerportalslider= ApiConst.resources.customerportalslider.resourceName;	
		var servicescategory    = ApiConst.resources.servicescategory.resourceName;	
		var vehicleFiles		= ApiConst.resources.vehicleFiles.resourceName;
		var purchaseInfos		= ApiConst.resources.purchaseInfos.resourceName;
		var customers			= ApiConst.resources.customers.resourceName;	
		var tasks				= ApiConst.resources.tasks.resourceName;	
		var saleInfos			= ApiConst.resources.saleInfos.resourceName;	
		var payments			= ApiConst.resources.payments.resourceName;
		var files				= ApiConst.resources.files.resourceName;
		var safeties			= ApiConst.resources.safeties.resourceName;
		var safetyImages		= ApiConst.resources.safetyImages.resourceName;
		const purchaseInvoice = ApiConst.resources.purchaseInvoice.resourceName;
		const returnInvoice = ApiConst.resources.returnInvoice.resourceName;
		const workOrders = ApiConst.resources.workOrder.resourceName;

		var codeKey 	= Const.header.code;
		var successCode = Const.code.success;

		this.isUploadSuccess = function(header){
			return header[codeKey] == successCode;
		}

		this.changeFileName = function (fileItem, newFileName){
			if(fileItem == null || fileItem._file == null){
				return;
			}

			var originFileName = fileItem._file.name;
			var indexOfFileType = originFileName.lastIndexOf('.');
			var fileType = originFileName.substring(indexOfFileType, originFileName.length);

			fileItem.file.name = newFileName + fileType;
		}

		this.getUrlForCreateReturnInvoiceFile = function(returnInvoiceID){
			return baseUrl + companies + '/' + LoginService.getCompanyID() + '/' + returnInvoice + '/' + returnInvoiceID + '/' + files;
		}

		this.getUrlForCreatePurchaseInvoiceFile = function(purchaseInvoiceID){
			return baseUrl + companies + '/' + LoginService.getCompanyID() + '/' + purchaseInvoice + '/' + purchaseInvoiceID + '/' + files;
		}

		this.getUrlForCreateWorkOrderFile = function(vehicleID, workOrderID){
			return baseUrl + companies + '/' + LoginService.getCompanyID() + '/' + vehicles + '/' + vehicleID + '/' + workOrders + '/' + workOrderID + '/' + files;
		}

		this.getUrlForCreateSafetyImage = function(vehicleID, safetyID){
			var companyID = LoginService.getCompanyID();

			var url = baseUrl 	+ 
					companies	+ '/' + companyID				+ '/' + 
					vehicles	+ '/' + vehicleID				+ '/' + 
					safeties	+ '/' + safetyID				+ '/' + 
					safetyImages;

			return url;
		}

		this.getUrlForPostSaleInfoFile = function(resourcePath){
			var companyID = resourcePath.companyID;
			var vehicleID = resourcePath.vehicleID;
			var saleInfoID = resourcePath.saleInfoID;

			var url = baseUrl 	+ 
					companies	+ '/' + companyID	+ '/' + 
					vehicles	+ '/' + vehicleID	+ '/' +
					saleInfos	+ '/' + saleInfoID	+ '/' +  files;

			return url;
		}

		this.getUrlForPostPaymentFile = function(resourcePath){
			var companyID = resourcePath.companyID;
			var vehicleID = resourcePath.vehicleID;
			var saleInfoID = resourcePath.saleInfoID;
			var paymentID = resourcePath.paymentID;

			var url = baseUrl 	+ 
					companies	+ '/' + companyID	+ '/' + 
					vehicles	+ '/' + vehicleID	+ '/' +
					saleInfos	+ '/' + saleInfoID	+ '/' + 
					payments	+ '/' + paymentID	+ '/' +  files;

			return url;
		}

		this.getUrlForPostCustomerProfileImage = function(resourcePath){
			var companyID = resourcePath.companyID;
			var customerID = resourcePath.customerID;

			var url = baseUrl 	+ 
					companies	+ '/' + companyID	+ '/' + 
					customers	+ '/' + customerID	+ '/profileimage';

			return url;
		}

		this.getUrlForPostCustomerLicenseImage = function(resourcePath){
			var companyID = resourcePath.companyID;
			var customerID = resourcePath.customerID;

			var url = baseUrl 	+ 
					companies	+ '/' + companyID	+ '/' + 
					customers	+ '/' + customerID	+ '/licenseimage';

			return url;
		}
	
		this.getUrlForPostTaskFile = function(resourcePath){
			var companyID = resourcePath.companyID;
			var taskID = resourcePath.taskID;

			var url = baseUrl 	+ 
					companies	+ '/' + companyID	+ '/' + 
					tasks		+ '/' + taskID		+ '/' + 
					files;

			return url;
		}

		this.getUrlForPostCustomerFile = function(resourcePath){
			var companyID = resourcePath.companyID;
			var customerID = resourcePath.customerID;

			var url = baseUrl 	+ 
					companies	+ '/' + companyID				+ '/' + 
					customers	+ '/' + customerID				+ '/' + 
					files;

			return url;
		}

		this.getUrlForCreateVehicleImage = function(vehicleID){
			var companyID = LoginService.getCompanyID();

			var url = baseUrl 	+ 
					companies	+ '/' + companyID				+ '/' + 
					vehicles	+ '/' + vehicleID				+ '/' + 
					vehicleImages;

			return url;
		}

		this.getUrlForCreateCustomerPortalSliderImage = function(customerportalsliderID){
			var companyID = LoginService.getCompanyID();

			var url = baseUrl 	+ 
					companies	+ '/' + companyID				+ '/' + 
					customerportalslider	+ '/' + customerportalsliderID

			return url;
		}

		this.getUrlForCreateJobTypeServicesCategoryImage = function(jobTypeID){
			var companyID = LoginService.getCompanyID();

			var url = baseUrl 	+ 
					companies	+ '/' + companyID				+ '/' + 
					servicescategory	+ '/' + jobTypeID

			return url;
		}

		this.getUrlForCreateVehicleFile = function(vehicleID){
			var companyID = LoginService.getCompanyID();
			var url = baseUrl 	+  
					companies	+ '/' + companyID		+ '/' + 
					vehicles	+ '/' + vehicleID	+ '/' + 
					files;

			return url;
		}

		this.getUrlForCreatePurchaseInfoFile = function(vehicleID, purchaseInfoID){
			var companyID = LoginService.getCompanyID();
			var url = baseUrl 	+ 
					companies		+ '/' + 	companyID		+ '/' + 
					vehicles		+ '/' + 	vehicleID		+ '/' + 
					purchaseInfos 	+ '/' + 	purchaseInfoID	+ '/' +
					files;

			return url;
		}

		this.getUrlForCreateProfileImage = function(targetUserID){
			var companyID = LoginService.getCompanyID();
			var url = baseUrl 	+ 
					companies	+ '/' + companyID		+ '/' + 
					users		+ '/' + targetUserID	+ '/' + 
					profileImage;

			return url;
		}

		this.getUrlForUpdateProfileImage = function(targetUserID, imageID){
			var companyID = LoginService.getCompanyID();
			var url = baseUrl 	+ 
					companies		+ '/' + companyID		+ '/' + 
					users			+ '/' + targetUserID	+ '/' + 
					profileImage	+ '/' + imageID;

			return url;
		}

		this.getNewUploader = function(){
			var uploader = new FileUploader({	  	
				headers:{
					token:LoginService.getToken()
				}
			});

			return uploader;
		}

		this.getImageFilter = function(){
			var filter = {
				name: 'imageFilter',
				fn: function(item, options) {
						var type = '|' + item.type.slice(item.type.lastIndexOf('/') + 1) + '|';

						if('|jpg|png|jpeg|'.indexOf(type) == -1){
							MessageService.showToast("Only jpg, png, jpeg accepted")
							return false;
						}
						return true;
					}
			};

			return filter;
		}

		this.getImagevideoFilter = function(){
			var filter = {
				name: 'imageFilter',
				fn: function(item, options) {
						var type = '|' + item.type.slice(item.type.lastIndexOf('/') + 1) + '|';

						if('|jpg|png|jpeg|mp4|'.indexOf(type) == -1){
							MessageService.showToast("Only jpg, png, jpeg accepted")
							return false;
						}
						return true;
					}
			};

			return filter;
		}

		this.getVideoFilter = function(){
			var filter = {
				name: 'imageFilter',
				fn: function(item, options) {
						var type = '|' + item.type.slice(item.type.lastIndexOf('/') + 1) + '|';
						if('|mp4|'.indexOf(type) == -1){
							MessageService.showToast("Only jpg, png, jpeg accepted")
							return false;
						}
						return true;
					}
			};

			return filter;
		}


		this.getDocumentFilter = function(){
			var filter = {
				name: 'documentFilter',
				fn: function(item, options) {
						var type = '|' + item.type.slice(item.type.lastIndexOf('/') + 1) + '|';

						if('|pdf|doc|docx|xls|xlsx|xps'.indexOf(type) == -1){
							MessageService.showToast("Only PDF, DOC, DOCX, XLS, SLSX, XPS accepted")
							return false;
						}
						return true;
					}
			};

			return filter;
		}

		this.getCustomFilter = function(acceptedFileTypes){

			if(acceptedFileTypes == null){
				return;
			}

			var filter = {
				name: 'documentFilter',
				fn: function(item, options) {
						var type = item.type.slice(item.type.lastIndexOf('/') + 1);

						if(acceptedFileTypes.indexOf(type) == -1){

							MessageService.showToast("Only " + acceptedFileTypes + " accepted")
							return false;
						}
						return true;
					}
			};

			return filter;			
		}

		this.getSizeFilter = function(size_MB){
			var maxSize = size_MB * 1048576

			var filter = {
				name: 'sizeFilter',
				fn: function(item, options) {

						if(item.size > maxSize){
							MessageService.showToast("Only file size less than " + size_MB + "MB accepted")
							return false;
						}
						return true;
					}
			};

			return filter;
		}	

		this.getFixedDuplicatedFileName = function(fileNameToBeFixed){

			var indexOfLeftBracket 		= fileNameToBeFixed.lastIndexOf('(');
			var indexOfRightBracket 	= fileNameToBeFixed.lastIndexOf(").");
			var stringInsideBracket 	= fileNameToBeFixed.slice(indexOfLeftBracket + 1, indexOfRightBracket);
			var numberOfDuplicatedFiles = new Number(stringInsideBracket);

			if(indexOfLeftBracket != -1 && 
					indexOfLeftBracket != -1 && 
					indexOfLeftBracket < indexOfRightBracket &&
					!isNaN(numberOfDuplicatedFiles.valueOf())){

				var stringBeforeLeftBracket = fileNameToBeFixed.slice(0, indexOfLeftBracket + 1);
				var stringAfterRightBracket = fileNameToBeFixed.slice(indexOfRightBracket, fileNameToBeFixed.length);
				var newNumberOfDuplicatedFiles =  numberOfDuplicatedFiles.valueOf() + 1;

				return stringBeforeLeftBracket + newNumberOfDuplicatedFiles +  stringAfterRightBracket;
			}

			var fileName = fileNameToBeFixed.slice(0, fileNameToBeFixed.lastIndexOf('.'));
			var fileType = fileNameToBeFixed.slice(fileNameToBeFixed.lastIndexOf('.') + 1, fileNameToBeFixed.length);

			return fileName.replace(fileName, fileName + "(2)." + fileType);	

		}

		this.getDuplicatedNumberInFileName = function(fileName){
			var indexOfLeftBracket 		= fileName.lastIndexOf('(');
			var indexOfRightBracket 	= fileName.lastIndexOf(").");
			var stringInsideBracket 	= fileName.slice(indexOfLeftBracket + 1, indexOfRightBracket);
			var numberOfDuplicatedFiles = new Number(stringInsideBracket);

			if(indexOfLeftBracket != -1 && 
					indexOfLeftBracket != -1 && 
					indexOfLeftBracket < indexOfRightBracket &&
					!isNaN(numberOfDuplicatedFiles.valueOf())){

				return numberOfDuplicatedFiles.valueOf();
			}
		}

		this.isSuccessResponse = function(header){

		}
	}
})();
(function ()
{
	"use strict";

	angular
		.module("app.fileUpload")
		.component("fileSection", {
				bindings:{
					fileUploader:'=',
					isProcessingData:'=',
					uploadedFiles:'=',
					onFileDelete:'='
				},
				templateUrl: "app/main/file-upload/file-section.html",
				controller: componentController,
		  		controllerAs: 'vm'
			});

		function componentController(FileViewService, FileUploadService, GeneralTools, MessageService){
			var vm = this;	

			vm.$onInit = initComponent;
			vm.getFileURL = getFileURL;
			vm.copyLink = copyLink;

			function initComponent(){	
				initUploadedFiles();
				initFileUploader();
			}

			function initFileUploader(){
				/*if(vm.fileUploader == null){
					vm.fileUploader = FileUploadService.getNewUploader();
					vm.fileUploader.filters.push(FileUploadService.getSizeFilter(20));
				}*/
			}

			function getFileURL(file){
				return FileViewService.generateUrlByUUID(file.uuid);
			}

			function initUploadedFiles(){
				if(!Array.isArray(vm.uploadedFiles)){
					vm.uploadedFiles = [];
				}
			}

			function copyLink(file){
				GeneralTools.copyToClipboard(FileViewService.generateUrlByUUID(file.uuid));
				MessageService.showToast("Link is copied to clipboard");
			}
		}
})();
(function ()
{
	"use strict";

	angular
		.module("app.fileUpload")
		.component("fileSectionPreview", {
				bindings:{
					fileList:"=",
					fileUploader:'=',
					isProcessingData:'=',
					onFileDelete:'='
				},
				templateUrl: "app/main/file-upload/file-section-preview.html",
				controller: componentController,
		  		controllerAs: 'vm'
			});

		function componentController(FileViewService, FileUploadService, GeneralTools, MessageService){
			var vm = this;	
			vm.selectedIndex = 0;

			vm.onFocus = onFocus;
			vm.getFileURL = getFileURL;
			vm.canBePreviewed = canBePreviewed;

			function onFocus(index){
				vm.selectedIndex = index;
			}

			function getFileURL(file){
				if(file){
					return FileViewService.generateUrlByUUID(file.uuid);
				}	
			}

			function canBePreviewed(file){
				return !!file && (file.isImage() || file.isPdf());
			}


		}
})();
(function ()
{
	'use strict';

	angular
		.module("app.fileUpload")
		.factory("ImageCompresser", ImageCompresserClass)

	/** @ngInject */
	function ImageCompresserClass()
	{	   
		function ImageCompresser(){}

		ImageCompresser.prototype.photo = function(file, maxSize, outputType, uploadingVehicleImage, callback) {
			var _this = this;
			var reader = new FileReader();
			reader.onload = function (readerEvent) {
				_this.resize(readerEvent.target.result, maxSize, outputType, uploadingVehicleImage, callback);
			}
			reader.readAsDataURL(file);
		}

		ImageCompresser.prototype.resize = function(dataURL, maxSize, outputType, uploadingVehicleImage, callback) {
			var _this = this;
			var image = new Image();
			if(uploadingVehicleImage){
				image.onload = function (imageEvent) {
					var canvas = document.createElement('canvas');
					canvas.width = image.width;
					canvas.height = image.height;
					canvas.getContext('2d').drawImage(image, 0, 0, image.width, image.height);
					_this.output(canvas, outputType, uploadingVehicleImage, callback);
				}
			}
			else{
				image.onload = function (imageEvent) {
					// Resize image
					var canvas = document.createElement('canvas'),
						width = image.width,
						height = image.height;
					if (width > height) {
						if (width > maxSize) {
							height *= maxSize / width;
							width = maxSize;
						}
					} else {
						if (height > maxSize) {
							width *= maxSize / height;
							height = maxSize;
						}
					}
					canvas.width = width;
					canvas.height = height;
					canvas.getContext('2d').drawImage(image, 0, 0, width, height);
					_this.output(canvas, outputType, uploadingVehicleImage, callback);
				}
			}

			image.src = dataURL;
		}

		ImageCompresser.prototype.output = function (canvas, outputType, uploadingVehicleImage, callback) {
			switch (outputType) {
				case 'file':
					canvas.toBlob(function (blob) {
						callback(blob);
					}, 'image/jpeg', 0.8);
					break;

				case 'dataURL':
					callback(canvas.toDataURL('image/jpeg', 0.8));
					break;
			}

		}

		ImageCompresser.prototype.vehiclePhoto = function(file, callback) {
			var _this = this;
			var reader = new FileReader();
			reader.onload = function (readerEvent) {
				var originalDataURL = readerEvent.target.result;
				_this.resize(originalDataURL, 512, 'file', false, function (small) {
					_this.resize(originalDataURL, 1920, 'file', false, function (medium) {
						_this.resize(originalDataURL, 150, 'file', false, function (thumbnail) {
							callback({
								thumbnail: thumbnail, 
								medium: medium, 
								original: file,
								small: small
							});
						});
					});
				});
			};
			reader.readAsDataURL(file);
		};
		

		return ImageCompresser;
	}


})();
(function ()
{
    "use strict";

    angular
        .module("app.emailService", [])
        .config(config);

    function config($stateProvider){}   
})();
(function ()
{
	'use strict';

	angular
		.module('app.emailService')
		.service("EmailService", EmailService);

	/** @ngInject */
	function EmailService($state, $q, api, Const, $resource, LoginService, GeneralTools)
	{   
		var codeKey = Const.header.code;
		var messageKey = Const.header.message;
		var successCode = Const.code.success;

		const baseUrl = GeneralTools.getBaseUrl();
		const errMsgFailedToSendSignedBillOfSaleFile = "Failed to send bill of sale file by email.";
		const baseHeader = GeneralTools.getBaseHeader();
		const noCacheHeader = GeneralTools.getNoCacheHeader();

		const signedBillOfSaleFileApi = $resource(
			baseUrl + "companies/:companyID/vehicles/:vehicleID/saleinfos/:saleinfoID/signatures/:signatureID/sendsignedfile",
			{	
				companyID: "@companyID",
				vehicleID: "@vehicleID",
				saleinfoID: "@saleinfoID",
				signatureID: "@signatureID"
			},
			{	
				send:{
					method:"POST",
					headers: baseHeader,
					interceptor:{
						response: function(result){
							const statusCode  = result.headers(Const.header.code);

							if(statusCode != Const.code.success){
								console.error(statusCode, result.headers(Const.header.message));
								return $q.reject(errMsgFailedToSendSignedBillOfSaleFile);
							}

							return result;
						},
						responseError: function (error){
							if(error && error.xhrStatus == Const.xhrStatus.abort){
								return $q.reject();
							}
							console.error(error);
							return $q.reject(error);
						}
					}
				}							
		});

		this.sendSignedBillOfSale = function(resourcePath, receiverIDs){

			const requestBody = {receiverIDs: receiverIDs}

			return signedBillOfSaleFileApi.send(resourcePath, requestBody);
		}

		this.sendSigningRequest = function(signerDetail, signatureRequestDetail, vehicleData){
			var defer = $q.defer();

			var requestBody = buildSigningRequestBody(signerDetail, signatureRequestDetail, vehicleData);
			var resourcePath = {companyID: LoginService.getCompanyID()}
			
			if(!requestBody){
				return $q.reject("Request body is invalid.");
			}

			api.sendEmail.send(
				resourcePath,
				requestBody,
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);
						defer.reject(errorMessage);
						return;
					}

					defer.resolve(null);
				},
				function(error){
					console.error(error);
					defer.reject("Failed to send email.");
				}
			);

			return defer.promise;
		}


		function buildSigningRequestBody(signerDetail, signatureRequestDetail, vehicleData){
			return {	
				senderName: LoginService.getCompanyName(),
				receivers:[signerDetail.signer_email_address],
				subject:"Signature Request",
				html:buildSigningRequestHtml(signerDetail, signatureRequestDetail, vehicleData)
			};
		}

		// All the company info including header and footer images src should be pulled from database in the future.
		function buildSigningRequestHtml(signerDetail, signatureRequestDetail, vehicleData){
			let signerInfos;
			try {
				signerInfos = JSON.parse(signatureRequestDetail.metadata.signerInfos);
			  } catch (error) {
				signerInfos = signatureRequestDetail.metadata.signerInfos;
			  }
			var signingPageUrl = $state.href('app.signing-page', {signerSignatureId: signerDetail.signature_id}, {absolute: true});

			var title = "";
			var subtitle = "Signed bill of sale is attached below.";
			
			var yearMakeModel = vehicleData.year + ' ' + vehicleData.make + ' ' + vehicleData.model;
			var vin = vehicleData.vin ? vehicleData.vin : "Unknown";
			var mileage = vehicleData.mileage ? vehicleData.mileage.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : "Unknown";
			mileage += " KM"
			var landingImage = vehicleData.landingImage ? vehicleData.landingImage : "https://www.autocart.ca/assets/images/placeholder-vans.png";

			if(signerInfos.customer.email == signerDetail.signer_email_address){
				title = "Congratulations " + signerDetail.signer_name + '!';
				subtitle = "You are almost the proud new owner of a " + yearMakeModel + ', all we need now is your signature.'
			} else if (signerInfos.salesman.email == signerDetail.signer_email_address){
				title = "Congratulations " + signerDetail.signer_name + ' on your recent sale!';
				subtitle = 'All we need now is your signature.';
			} else {
				title = "Congratulations " + signerDetail.signer_name + ', ' + signerInfos.salesman.name + ' sold a vehicle!';
				subtitle = 'Please review everything and sign.';
			}

			return '<div style="width: 100%; text-align: center; font-family: Arial, Helvetica, sans-serif;"> <div style="margin:auto; max-width: 480px;background-color: rgb(23, 24, 26);"> <div style="text-align: center; padding: 20px 35px 0 35px;"> <div style=" height: 50px; width: 200px; margin:auto; background-size: contain; background-position: center; background-repeat: no-repeat; background-image: url(\'https://www.autocart.ca/assets/images/rogers-motors-logo2019.png\'); "> </div><div style="text-align: center;color: rgb(131, 131, 124);margin-top: 30px; font-size: 18px;">'
				+ title 
				+ '</div><div style="text-align: center;color: rgb(131, 131, 124);margin-top: 10px; font-size: 18px;">'
				+ subtitle 
				+ '</div></div><div style=" padding-top: 100%; width: 100%; background-size: contain; background-position: center; background-repeat: no-repeat; background-image: url(\''
				+ landingImage 
				+ '\'); "> </div><div style="text-align: center; padding: 0 35px 20px 35px;color: white;font-size: 20px;"> <div style="margin-bottom: 40px;">'
				+ yearMakeModel 
				+ '</div><div style="margin: auto; width: 250px; background-color: white; border: 0px solid white; border-radius: 30px; text-align: center; padding: 15px 0; font-size: 14px; font-weight: bold;"> <a href="'
				+ signingPageUrl
				+ '" style="text-decoration: none;color: black;">SIGN NOW</a> </div></div><div style="text-align: left; padding: 20px 35px 20px 35px; background-color: rgb(246, 246, 246);font-size: 12px;"> <div style="margin-bottom: 10px;"> <a href="tel:8887505952" style="text-decoration: none; color: rgb(125, 126, 129);"> Sales: <span style="color: rgb(98,98,98);font-weight: bold;">(888) 750-5952</span> </a> </div><div > <a target="_blank" href="https://www.google.com/maps/place/Rogers+Motors/@43.432119,-79.7044688,15z/data=!4m5!3m4!1s0x0:0x6532ad3b3a269a29!8m2!3d43.432119!4d-79.7044688" style="text-decoration: none; color: rgb(125, 126, 129);"> Address: <span style="color: rgb(98,98,98);font-weight: bold;">1035 Speers Rd, Oakville, ON, L6L2X5</span> </a> </div></div></div></div>'
			}
	}
})();
(function ()
{
	'use strict';

	angular
		.module("app.disclosure", [])
		.factory("Disclosure", Disclosure)

	/** @ngInject */
	function Disclosure()
	{	   
		function disclosure(){
		}

		disclosure.prototype.setAttributes = function (attributes) {
	 		var keyList = Object.keys(attributes);

	 		for(var i = 0; i < keyList.length; i++){
	 			var key = keyList[i];
	 			var value = attributes[key];

	 			this.setAttribute(key, value);
	 		}
		}	
			
		disclosure.prototype.setAttribute = function (key, value) {
	 		this[key] = value;
		}

		disclosure.prototype.getResourceID = function(){
			return this.id_disclosure;
		}		

		disclosure.prototype.setResourceID = function(resourceID){
			this.id_disclosure = resourceID;
		}

		disclosure.prototype.isDisclosureValid = function(){
			var isDescriptionEmpty = typeof(this.description) != "string" || this.description.trim() == '';

			return !isDescriptionEmpty; 
		}
		

		return disclosure;
	}


})();


(function ()
{
    "use strict";

    angular
        .module("app.cookie", ["ngCookies"])
        .factory("CookieFactory", CookieFactory);

    //Description: provide methods to save, get and disable a cookie
    function CookieFactory(CookieConst, LogService, LogConst, $cookies, Const){
        var factory = {};

        /**
         *  Description: save userInfo obj in cookie
         *  @param userInfo object  
         */
        factory.setCookie = function(userInfo) {             
            if(userInfo == null || typeof(userInfo) != "object"){                
                LogService.log(new Error, Const.code.system_error, LogConst.errString.err_param); 
                return;
            }

            //create a config object for the cookie
            var config = {};

            //put expire time into the config object
            var date = new Date();
            date.setTime(date.getTime() + (CookieConst.expireTime));
            config[CookieConst.property_expires] = date.toGMTString();

            //put secure property in to config object,
            //If true, the cookie will only be available through a secured connection.
            config[CookieConst.isSecure] = true;

            //set cookie
            $cookies.putObject(CookieConst.cookieName, userInfo, config);
        }

        /**
         *  Description: get userInfo obj from a cookie
         *  @return userInfo object  
         */
        factory.getCookie = function(){
            var cookie = $cookies.getObject(CookieConst.cookieName);
            if(cookie == null || typeof(cookie) != "object"){
                return null;
            }
            return cookie;
        }

        //Description: remove cookie by cookie name
        factory.clearCookie = function(){
            $cookies.remove(CookieConst.cookieName);
        }

        return factory;
    }    
})();
(function ()
{
    'use strict';

    angular
        .module('app.cookie')
        .service('CookieService', CookieService);

    //Description: encapsulation of CookieFactory, provide method to manage cookie
    function CookieService(CookieFactory)
    {   
        this.saveUserStatus = function(userInfo){
            CookieFactory.setCookie(userInfo);
        };
        this.getUserStatus = function(){
            return CookieFactory.getCookie();
        };
        this.clearUserStatus = function(){
            CookieFactory.clearCookie();
        };
    }
})();
/**
 *  Description: define the constants for cookie
 */
(function ()
{
    "use strict";

    angular
        .module("app.cookie")
        .constant("CookieConst", {
            cookieName    : "carDepotUser",

            //the path to store cookie 
            path                : "/",

            isSecure            : true,

            //unit is millisecond
            expireTime          : 365  * 24 * 60 * 60 * 1000,

            property_expires    : "expires",

            property_path       : "path",

            property_secure     : "secure",

            visitorCacheKeys: {
                bookMyService: "bookMyService"
            }
        });    
})();
(function ()
{
	"use strict";

	angular.module("app.directives", []);

})();
(function ()
{
	"use strict";

	angular
		.module("app.directives")
		.directive('stopEvent', function () {
			return {
				restrict: 'A',
				link: function (scope, element, attr) {

					element.bind('click', function (e) {
						e.stopPropagation();
					});
				}
			};
		});
})();
(function ()
{
	"use strict";

	angular
		.module("app.directives")
		.directive('elementScrollListener', elementScrollListener);

		function elementScrollListener() {
		    return {
		    	restrict: 'A',
		    	scope:{
		            onScroll: '='
		        },
		        link: function (scope, element, attrs) {
					element.bind('scroll', function(event){
						scope.onScroll(scope, element, attrs, event);
				    })
				}
		    };
		}


})();
(function ()
{
	"use strict";

	angular
		.module("app.directives")
		.directive('inputPattern', inputPattern)

	function inputPattern (){
		var directive = {};

		directive.require 	= 'ngModel';
		directive.restrict	= 'A';

		directive.link = function($scope, $elem, $attr, ctrl){

            $elem.on('keypress', function(event) {
            	
		        if ( !patternFilter() ){ 
		        	event.preventDefault();
		        }
		        
		        function patternFilter() {
		       		return $attr.ngPattern.test(String.fromCharCode(event.which))
		        }
	      	})
		}

		return directive;
	}

})();
(function ()
{
	"use strict";

	angular
		.module("app.directives")
		.directive('inputControl', inputControl)

	function inputControl (){
		var directive = {};

		directive.require = 'ngModel';
		directive.scope = {
			customValidations: '=',
			customAsyncValidations: '=',
			inputTranslate: '=',
			inputOptions: '=',
			model: '=ngModel'
		};

		directive.link = {} ;

		directive.link.post = function($scope, $elem, $attr, ctrl){
			if(Array.isArray($scope.customValidations)){
				$scope.customValidations.forEach(function(validator){
					ctrl.$validators[validator.name] = function(modelValue, viewValue) {
							return validator.validateFn(modelValue, viewValue);
						};
				})
			}

			if(Array.isArray($scope.customAsyncValidations)){
				$scope.customAsyncValidations.forEach(function(validator){
					ctrl.$asyncValidators[validator.name] = function(modelValue, viewValue) {
							return validator.validateFn(modelValue, viewValue);
						};
				})
			}	

			if($scope.inputTranslate){
				if(typeof($scope.inputTranslate.inputToView) != "function"){
					$scope.inputTranslate.inputToView = function(inputValue){ return inputValue; }
				}

				if(typeof($scope.inputTranslate.inputToModel) != "function"){
					$scope.inputTranslate.inputToModel = function(inputValue){ return inputValue; }
				}

				if(typeof($scope.inputTranslate.modelToView) != "function"){
					$scope.inputTranslate.modelToView = function(inputValue){ return inputValue; }
				}

				ctrl.$parsers.push(function (inputValue){
					const viewValue = $scope.inputTranslate.inputToView(inputValue, $scope.inputOptions, ctrl.$modelValue)

					if(viewValue != inputValue){
						ctrl.$setViewValue(viewValue);
						ctrl.$render();
						return ctrl.$modelValue;
					}	

					return $scope.inputTranslate.inputToModel(inputValue, $scope.inputOptions, ctrl.$modelValue);
				});


				ctrl.$formatters.push(function (modelValue){
					return $scope.inputTranslate.modelToView(modelValue, $scope.inputOptions);
				});
			}
		}

		return directive;
	}

	function processViewValue(inputValue, handler, inputOptions, modelValue){
		var viewValue = handler(inputValue, inputOptions, modelValue);

		if(inputValue === viewValue){
			return viewValue;
		} else {
			return processViewValue(viewValue, handler, inputOptions, modelValue);
		}
	}

})();
(function ()
{
	"use strict";

	angular
		.module("app.directives")
		.directive('lightGallery', lightGallery)

		function lightGallery($parse, $window){
			return {
				restrict: 'AE',

				scope: {
					galleryOptions: '=',
					imagesource: '@'
				},

				link: function(scope, element, attr) {
						scope.elem = element;

						scope.elem.on("click", function(){

							var object = $parse(angular.element(this).attr("imagesource"));
							var dynamicEl =[]
							for (var i = 0; i < object().length; i++) {
								if(!object()[i].src.includes('.mp4')){
									var obj ={}
									obj.src = object()[i].src;
									obj.thumb = object()[i].src;
									dynamicEl.push(obj)
								}
							}

							var options = {
								thumbContHeight:200,
								showThumbByDefault:true,
								dynamic: true,
								dynamicEl: dynamicEl
							};

							options.index = parseInt(attr["index"])
							scope.elem.lightGallery(options);
						});

						scope.$on('$stateChangeStart', function() {
							var outer = angular.element(document.querySelector('#lg-outer'));
							outer.remove();
						});	

				}
			};
		}
})();
(function ()
{
	"use strict";

	angular
		.module("app.directives")
		.directive('focusControl', focusControl);

		function focusControl($timeout) {
		    return {
		        link: function ( scope, element, attrs ) {
		            scope.$watch( attrs.focusControl, function ( val ) {
		                if ( angular.isDefined( val ) && val ) {
		                    $timeout( function () { element[0].focus(); } );
		                }
		            }, true);
		            
/*		            element.bind('blur', function () {
		                if ( angular.isDefined( attrs.ngFocusLost ) ) {
		                    scope.$apply( attrs.ngFocusLost );
		                    
		                }
		            });*/
		        }
		    };
		}


})();
(function ()
{
	"use strict";

	angular
		.module("app.directives")
		.directive('clickOutside', function ($document) {
			return {
                link: function postLink(scope, element, attrs) {
                    var onClick = function (event) {
                        var isChild = element[0].contains(event.target);
                        var isSelf = element[0] == event.target;
                        var isInside = isChild || isSelf;
                        if (!isInside) {
                            scope.$apply(attrs.clickOutside)
                        }
                    }
                    scope.$watch(attrs.isActive, function(newValue, oldValue) {
                        if (newValue !== oldValue && newValue == true) {
                            $document.bind('click', onClick);
                        }
                        else if (newValue !== oldValue && newValue == false) {
                            $document.unbind('click', onClick);
                        }
                    });
                }
            };
		});
})();
(function ()
{
    "use strict";

    angular
        .module("app.directives")
        .directive('autoExpandTextarea', autoExpandTextarea);

    function autoExpandTextarea() {
        return {
            restrict: 'A',
            scope: {
                autoExpandTextarea: '='
            },
            link: function ($scope, $element) {
                var defaultRows = $element.attr('rows') || 9;

                function expand() {
                    $element[0].style.height = 'auto';
                    $element[0].style.height = $element[0].scrollHeight + 'px';
                    $element[0].style.overflow = 'hidden';
                }

                function collapse() {
                    $element[0].style.height = '';
                    $element[0].style.overflow = '';
                    $element.attr('rows', defaultRows);
                }

                $scope.$watch('autoExpandTextarea', function (expanded) {
                    if (expanded) {
                        expand();
                    } else {
                        collapse();
                    }
                });

                $element.on('input', function () {
                    if ($scope.autoExpandTextarea) {
                        expand();
                    }
                });
            }
        };
    }

})();

(function ()
{
	'use strict';

	angular
		.module('app.customers')
		.service("CustomersService", CustomersService);

	/** @ngInject */
	function CustomersService($resource, $state, api, ToolsFactory, Const, Customer, $q, MessageService, LoginService, $filter, TestDrive, CreditCard, CustomAppointment, GeneralTools, MyFile, ConstantCacheService, $http)
	{   
		var codeKey = Const.header.code;
		var messageKey = Const.header.message;
		var successCode = Const.code.success;

		var customerPagination;

		const baseUrl = GeneralTools.getBaseUrl();
		const errMsgFailedToBookAppointment = "Failed to book appointment";

		this.customerPublicSearch = function(companyID, params){
			const queryParams = angular.copy(params || {});

			return $http({
				method: 'GET',
				url: baseUrl + 'companies/' + companyID + '/customers/publicsearch',
				params: queryParams,
				headers: {
					token: LoginService.getToken(),
				},
			}).then(function (result) {
				const statusCode = result.headers(Const.header.code);

				if (statusCode != Const.code.success) {
					console.error(statusCode, result.headers(Const.header.message));
					return $q.reject(errMsgFailedToBookAppointment);
				}

				return (result.data || []).map(function (data) {
					var customer = new Customer();

					customer.setAttributes(data);
					return customer;
				});
			}, function (error) {
				if (error && error.xhrStatus == Const.xhrStatus.abort) {
					return $q.reject();
				}

				console.error(error);
				return $q.reject(error);
			});
		}

		this.getUrlParamsForBrowseCusmotersByCustomerObj = function(customer){
			if(!customer){
				return;
			}

			var phoneNumber;
			var email;

			if(Array.isArray(customer.phone_numbers) && customer.phone_numbers[0]){
				phoneNumber = customer.phone_numbers[0].phone_number;
			}

			if(Array.isArray(customer.emails) && customer.emails[0]){
				email = customer.emails[0].email_address;
			}

			return {
				firstName: customer.first_name? customer.first_name:undefined,
				lastName: customer.last_name? customer.last_name:undefined,
				email: email,
				phoneNumber: phoneNumber
			};
		}

		this.postTestDriveRequestBodyGenerator = function(testDrive){
			return {
				vehicle:{
					id_vehicle: testDrive.vehicle.getResourceID()
				}
			};
		}

		this.updateRequestBodyGenerator = function(originCustomer, changedCustomer)
		{
			var keyList = Object.keys(originCustomer);
			var changedProperties = {};
			
	 		for(var i = 0; i < keyList.length; i++)
	 		{
	 			var key = keyList[i];
	 			var originValue = originCustomer[key];

	 			switch(key){
	 				case "phone_numbers":
		 				if(isPhoneNumberListChanged(originCustomer.phone_numbers, changedCustomer.phone_numbers)){
		 					changedProperties.phone_numbers = changedCustomer.phone_numbers;
		 				}
	 					break;

	 				case "emails":
		 				if(isEmailListChanged(originCustomer.emails, changedCustomer.emails)){
		 					changedProperties.emails = changedCustomer.emails;
		 				}
	 					break;

	 				default:
		 				if(originValue != changedCustomer[key]){
			 				changedProperties[key] = changedCustomer[key];
			 			}
			 			break;
	 			}
	 		}

	 		return changedProperties;
		}

		this.isTestDriveVehicleListChanged = function(list1, list2){
			if(list1 == null){
				list1 = [];
			}

			if(list2 == null){
				list2 = [];
			}

			if(list1.length != list2.length){
				return true;
			}

			for(var i = 0; i < list1.length; i++){
				var itemFromList1 = list1[i];
				var itemFromList2 = list2[i];

				if(itemFromList1.vin != itemFromList2.vin || itemFromList1.vehicleID != itemFromList2.vehicleID){
					return true
				}
			}

			return false;
		}

		function isEmailListChanged(list1, list2){
			if(list1 == null){
				list1 = [];
			}

			if(list2 == null){
				list2 = [];
			}

			if(list1.length != list2.length){
				return true;
			}

			for(var i = 0; i < list1.length; i++){
				var itemFromList1 = list1[i];
				var itemFromList2 = list2[i];

				if(itemFromList1.email_address != itemFromList2.email_address 
						|| itemFromList1.fk_id_email_category != itemFromList2.fk_id_email_category
						|| itemFromList1.allow_notification != itemFromList2.allow_notification ){
					return true
				}
			}

			return false;
		}

		function isPhoneNumberListChanged(list1, list2){
			if(list1 == null){
				list1 = [];
			}

			if(list2 == null){
				list2 = [];
			}

			if(list1.length != list2.length){
				return true;
			}

			for(var i = 0; i < list1.length; i++){
				var itemFromList1 = list1[i];
				var itemFromList2 = list2[i];

				if(itemFromList1.phone_number != itemFromList2.phone_number 
						|| itemFromList1.fk_id_phone_category != itemFromList2.fk_id_phone_category
						|| itemFromList1.allow_notification != itemFromList2.allow_notification ){
					return true
				}
			}

			return false;
		}

		this.getCustomers = function(resourcePath, filters, pagination, sorting){			
			var defer = $q.defer();
			var queryParams = Object.assign({}, resourcePath, filters, pagination, sorting);

			api.customers.getCustomers(
				queryParams,
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);
						defer.reject(errorMessage);
						return;
					}

					var customerList = [];

					response.forEach(function(data){
						var customer = new Customer();

						customer.setAttributes(data);
						customerList.push(customer);
					})
					
					var result = {
						data: customerList,
						headerGetter: header
					}

					defer.resolve(result);
				},
				function(error){
					console.error(error);
					defer.reject("Failed to get customers");
				}
			);

			return defer.promise;
		}

		this.getPhoneCategories = function(){			
			var defer = $q.defer();

			api.getConstants.getPhoneCategories.get(
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);
						defer.reject(errorMessage);
						return;
					}

					defer.resolve(response);
				},
				function(error){
					console.error(error);
					defer.reject("Failed to get phone categories");
				}
			);

			return defer.promise;
		}

		this.getCachedPhoneCategories = function () {
			return ConstantCacheService.get('phone_categories', function () {
				return this.getPhoneCategories();
			}.bind(this));
		}

		this.getEmailCategories = function(){			
			var defer = $q.defer();

			api.getConstants.getEmailCategories.get(
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);
						defer.reject(errorMessage);
						return;
					}

					defer.resolve(response);
				},
				function(error){
					console.error(error);
					defer.reject("Failed to get email categories");
				}
			);

			return defer.promise;
		}

		this.getCachedEmailCategories = function () {
			return ConstantCacheService.get('email_categories', function () {
				return this.getEmailCategories();
			}.bind(this));
		}

		this.createCustomer = function(resourcePath, requestBody){
			var defer = $q.defer();
			var companyID = LoginService.getCompanyID();

			api.customers.createCustomer(
				resourcePath,
				requestBody,
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);
						defer.reject(errorMessage);
						return;
					}

					defer.resolve(response.data);
				},
				function(error){
					console.error(error);
					defer.reject("Faild to create customer");
				}
			);

			return defer.promise;
		}

		this.updateCustomer = function(changeProperties, resourcePath){
			var defer = $q.defer();

			api.customers.updateCustomer(
				resourcePath,
				changeProperties,
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);
						defer.reject(errorMessage);
						return;
					}

					defer.resolve(response);
				},
				function(error){
					defer.reject(error);
				}
			);

			return defer.promise;
		}

		this.deleteCustomer = function(resourcePath){
			var defer = $q.defer();

			api.customers.deleteCustomer(
				resourcePath,
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);
						defer.reject(errorMessage);
						return;
					}

					defer.resolve(response);
				},
				function(error){
					defer.reject(error);
				}
			);

			return defer.promise;
		}

		this.getCustomerFiles = function(resourcePath){
			var defer = $q.defer();

			api.customerFiles.getFiles(
				resourcePath,
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);

						defer.reject(errorMessage);
						return;
					}
					defer.resolve(response);

				},
				function(error){
					defer.reject(error);
				}
			);	

			return defer.promise;		
		}

		this.deleteCustomerFile = function(resourcePath){
			var defer = $q.defer();

			api.customerFiles.deleteFile(
				resourcePath,
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);
						defer.reject(errorMessage);
						return;
					}

					defer.resolve(response);
				},
				function(error){
					defer.reject(error);
				}
			);

			return defer.promise;
		}

		this.getTestDrives = function(resourcePath){			
			var defer = $q.defer();

			api.testDrives.getTestDrives(
				resourcePath,
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);
						defer.reject(errorMessage);
						return;
					}

					var testDriveList = [];

					response.forEach(function(data){
						var testDrive = new TestDrive();

						testDrive.setAttributes(data);
						testDriveList.push(testDrive);
					})

					defer.resolve(testDriveList);
				},
				function(error){
					defer.reject(error);
				}
			);

			return defer.promise;
		}

		this.createTestDrive = function(newTestDrive, resourcePath){			
			var defer = $q.defer();
			
			api.testDrives.createTestDrive(
				resourcePath,
				newTestDrive,
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);
						defer.reject(errorMessage);
						return;
					}

					defer.resolve(response.data);
				},
				function(error){
					defer.reject(error);
				}
			);

			return defer.promise;
		}

		this.deleteTestDrive = function(resourcePath){
			var defer = $q.defer();

			api.testDrives.deleteTestDrive(
				resourcePath,
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);
						defer.reject(errorMessage);
						return;
					}

					defer.resolve(response);
				},
				function(error){
					defer.reject(error);
				}
			);

			return defer.promise;
		}

		this.getCustomerProfileImageInfo = function(resourcePath){
			var defer = $q.defer();

			api.customerProfileImageInfo.getInfo(
				resourcePath,
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);
						defer.reject(errorMessage);
						return;
					}

					if(!response){
						defer.resolve(null);
						return;
					}

					var profileImage = new MyFile();
					profileImage.setAttributes(response);

					defer.resolve(profileImage);
				},
				function(error){
					console.error("Failed to get customer profile image info.")
					defer.reject(error);
				}
			);

			return defer.promise;
		}

		this.getCustomerLicenseImageInfo = function(resourcePath){
			var defer = $q.defer();

			api.customerLicenseImageInfo.getInfo(
				resourcePath,
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);
						defer.reject(errorMessage);
						return;
					}

					if(!response){
						defer.resolve(null);
						return;
					}

					var licenseImage = new MyFile();
					licenseImage.setAttributes(response);
					
					defer.resolve(licenseImage);
				},
				function(error){
					console.error("Failed to get customer license image info.")
					defer.reject(error);
				}
			);

			return defer.promise;
		}

		this.downloadCustomerProfileImage = function(resourcePath){
			var defer = $q.defer();

			api.downloadCustomerProfileImage.download(
				resourcePath,
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);
						defer.reject(errorMessage);
						return;
					}

					defer.resolve(response);
				},
				function(error){
					defer.reject(error);
				}
			);

			return defer.promise;
		}

		this.downloadCustomerLicenseImage = function(resourcePath){
			var defer = $q.defer();

			api.downloadCustomerLicenseImage.download(
				resourcePath,
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);
						defer.reject(errorMessage);
						return;
					}

					defer.resolve(response);
				},
				function(error){
					defer.reject(error);
				}
			);

			return defer.promise;
		}

		this.customerSearchTextFilterBuilder = function(searchText){
			var quotationPattern =  /(["'])(?:(?=(\\?))\2.)*?\1/gi;
			var numberPattern = new RegExp('^[0-9]*$');
			var customerFilterObj = {};

			var keywordsInsideQuotes = []

			var keywordsStringWithoutQuotes = searchText.replace(quotationPattern, function(keywordStr){

				var keywordContent = keywordStr.replace(/['"]+/g, '')

				if(keywordContent != ''){
					keywordsInsideQuotes.push(keywordContent);
				}
				
				return '';
			})

			var keywordsWithoutQuotes = keywordsStringWithoutQuotes.split(' ');

			var rawkeywordList = keywordsWithoutQuotes.concat(keywordsInsideQuotes);

			var keywordList = rawkeywordList.filter(function(keyword){
				return keyword != '';
			})

			var phoneNumberKeywords = [];
			var emailKeywords = [];
			var firstNameKeyword = '';
			var lastNameKeyword = '';

			keywordList.forEach(function(keyword){
				if(numberPattern.test(keyword)){
					phoneNumberKeywords.push(keyword);
					return;
				}

				if(keyword.indexOf('@') != -1 || keyword.indexOf('.') != -1 ){
					emailKeywords.push(keyword);
					return;
				}

				if(firstNameKeyword == ''){
					firstNameKeyword = keyword;
					return;
				}

				if(lastNameKeyword == ''){
					lastNameKeyword = keyword;
					return;
				}
			});

			var phoneNumbersFilter = '';
			var emailsFilter = '';

			phoneNumberKeywords.forEach(function(keyword){
				var filterElement = filterStringBuiler("phone_number", keyword);
				phoneNumbersFilter = GeneralTools.stringConnector(phoneNumbersFilter, filterElement, " OR ");
			});

			emailKeywords.forEach(function(keyword){
				var filterElement = filterStringBuiler("email_address", keyword);
				emailsFilter = GeneralTools.stringConnector(emailsFilter, filterElement, " OR ");
			});

			var firstNameFilter = filterStringBuiler("first_name", firstNameKeyword);
			var lastNameFilter = filterStringBuiler("last_name", lastNameKeyword);

			var nameFilter = '';

			nameFilter = GeneralTools.stringConnector(nameFilter, firstNameFilter, " AND ");
			nameFilter = GeneralTools.stringConnector(nameFilter, lastNameFilter, " AND ");

			if(nameFilter != null && nameFilter.trim() != '' && nameFilter.indexOf("AND") != -1){
				nameFilter = ' ( ' + nameFilter + ' ) ';
			}

			customerFilterObj.filters = ''

			customerFilterObj.filters = GeneralTools.stringConnector(customerFilterObj.filters, nameFilter, " AND ");
			customerFilterObj.filters = GeneralTools.stringConnector(customerFilterObj.filters, phoneNumbersFilter, " AND ");
			customerFilterObj.filters = GeneralTools.stringConnector(customerFilterObj.filters, emailsFilter, " AND ");	

			return customerFilterObj;
		}

		function filterStringBuiler(columnName, value){
			if(!columnName|| !columnName.trim() || !value || !value.trim()){
				return '';
			}

			return "contains(" + columnName + ",'" + value + "')";
		}

		
		this.getCreditCards = function(resourcePath){			
			var defer = $q.defer();
			api.creditCards.getCreditCards(
				resourcePath,
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);
						defer.reject(errorMessage);
						return;
					}

					var creditCardList = [];

					response.forEach(function(data){
						var creditCard = new CreditCard();

						creditCard.setAttributes(data);
						creditCardList.push(creditCard);
					})

					defer.resolve(creditCardList);
				},
				function(error){
					defer.reject(error);
				}
			);

			return defer.promise;
		}

		this.SaveClientPaymentProfile = function(paymentProfile, resourcePath){			
			var defer = $q.defer();
			
			api.creditCards.saveClientPaymentProfile(
				resourcePath,
				paymentProfile,
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);
						defer.reject(errorMessage);
						return;
					}
					var creditCardList = [];

					response.forEach(function(data){
						var creditCard = new CreditCard();

						creditCard.setAttributes(data);
						creditCardList.push(creditCard);
					})
					defer.resolve(creditCardList);
				},
				function(error){
					defer.reject(error);
				}
			);

			return defer.promise;
		}

		this.deleteClientPaymentProfile = function(paymentProfile, resourcePath){
			var defer = $q.defer();

			api.deleteCreditCards.deleteClientPaymentProfile(
				resourcePath,
				paymentProfile,
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);
						defer.reject(errorMessage);
						return;
					}

					var creditCardList = [];

					response.forEach(function(data){
						var creditCard = new CreditCard();

						creditCard.setAttributes(data);
						creditCardList.push(creditCard);
					})
					defer.resolve(creditCardList);
				},
				function(error){
					defer.reject(error);
				}
			);

			return defer.promise;
		}

		this.getCustomAppointment = function(resourcePath){			
			var defer = $q.defer();
			api.customAppointment.getCustomAppointment(
				resourcePath,
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);
						defer.reject(errorMessage);
						return;
					}

					var customAppointmentList = [];

					response.forEach(function(data){
						var customAppointment = new CustomAppointment();

						customAppointment.setAttributes(data);
						customAppointmentList.push(customAppointment);
					})

					defer.resolve(customAppointmentList);
				},
				function(error){
					defer.reject(error);
				}
			);

			return defer.promise;
		}

		this.updateCustomAppointment = function(resourcePath, requestBody){
			var defer = $q.defer();

			api.customAppointment.updateCustomAppointment(
				resourcePath,
				requestBody,
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);

						defer.reject(errorMessage);
						return;
					}
					defer.resolve(response);

				},
				function(error){
					console.error(error);
					defer.reject("Failed to update custom appointment.");
				}
			);	

			return defer.promise;
		}

		this.deleteCustomAppointment = function(resourcePath){			
			var defer = $q.defer();

			api.customAppointment.deleteCustomAppointment(
				resourcePath,
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);
						defer.reject(errorMessage);
						return;
					}

					defer.resolve(response);
				},
				function(error){
					console.error("Failed to delete workOrder appointment.");
					defer.reject(error);
				}
			);

			return defer.promise;
		}
	}
})();
(function ()
{
	"use strict";

	angular
		.module("app.customers")
		.component("customerSearch", {
				bindings:{
					defaulFilter: '<',
					locations:'<',
					notFoundMessage:'<',
					onSelect:'<',
					onBlur:'<',
					onFocus:'<'
				},
				templateUrl: "app/main/customers/customer-search.html",
				controller: componentController,
		  		controllerAs: 'vm'
			});

		function componentController($scope, TaskConstants, $state, LoginService, CustomersService, $q, GeneralTools){
			var vm = this;

			const companyID = LoginService.getCompanyID();
			const andConnector = " AND ";

			vm.$onInit = initComponent;
			vm.queryCustomer = queryCustomer;
			vm.getUrlForDetailPage = getUrlForDetailPage;
			vm.select = select;
			vm.onBlurCallback = onBlurCallback
			vm.onFocusCallback = onFocusCallback
			
			function initComponent(){
				if(!vm.defaulFilter){
					vm.defaulFilter = { filters: ''};
				}
			}

			function getVehicleLocation(vehicle){
				if(!vehicle || !Array.isArray(vm.locations)){
					return;
				}

				return vm.locations.find(function(location){
					return location.id_location == vehicle.fk_id_location;
				});
			}
			
			function getUrlForDetailPage (customer){
				return $state.href('app.view-customer', {customerID:customer.getResourceID()}); 
			}

			function queryCustomer(){
				const resourcePath = {
					companyID: companyID
				}

				const filter = angular.copy(vm.defaulFilter);

				const searchFilterString = CustomersService.customerSearchTextFilterBuilder(vm.searchText).filters;

				filter.filters = GeneralTools.stringConnector(filter.filters, searchFilterString, andConnector);

				return CustomersService.getCustomers(resourcePath, filter, null, null)
					.then(function(result){
						if(result == null || !Array.isArray(result.data)){
							return $q.reject("result invalid.");
						}

						return $q.resolve(result.data);
					})
			}

			function select(customer){
				if(vm.onSelect){
					vm.onSelect(customer);
				}
			}

			function onBlurCallback(){
				if(vm.onBlur){
					vm.onBlur()
				}
			}

			function onFocusCallback(){
				if(vm.onFocus){
					vm.onFocus()
				}
			}
		}
})();
(function ()
{
	"use strict";

	angular
		.module("app.customers")
		.component("customerDetailInfoForm", {
				bindings:{
					customer:'=',
					isFormValid:'='
				},
				templateUrl: "app/main/customers/customer-detail-info-form.html",
				controller: componentController,
		  		controllerAs: 'vm'
			});

		function componentController(LoginService, MessageService, GoogleService, $timeout, $scope, Customer, CustomerConstants, GeneralTools){
			var vm = this;
			const companyID = LoginService.getCompanyID();
			vm.$onInit = initComponent;
			vm.$postLink = initOutputCallback

			vm.setLicenseExpiryDate = setLicenseExpiryDate;
			vm.setCustomerBirthday = setCustomerBirthday;
			vm.translateToPostalCode = GeneralTools.inputTranslators.postalCode;
			vm.onPostcodeChange = onPostcodeChange;
			vm.dismissAddressList = dismissAddressList;
			vm.selectAddress = selectAddress;
			vm.getAddressName = getAddressName;
			vm.onPostcodeFocus = onPostcodeFocus;
			vm.translateToFirstCap = GeneralTools.inputTranslators.initCapitalize;
			vm.translateToAllCapitalize = GeneralTools.inputTranslators.allCapitalize;

			function initComponent(){
				if(vm.customer == null){
					vm.customer = new Customer();
				}

				vm.expiryDatePickerValue = vm.customer.getLicenseExpiryDateMomentObj();
				vm.birthdayPickerValue = vm.customer.getBirthdayMomentObj();

				var currentDate = new Date();

				vm.maxBirthdayDate = new Date(
						currentDate.getFullYear() - CustomerConstants.minAge,
						currentDate.getMonth(),
						currentDate.getDate()
				);
			}

			function onPostcodeFocus(){
				vm.showAddressList = true;

				if(!Array.isArray(vm.addressList)){
					onPostcodeChange();
				}
			}

			function setLicenseExpiryDate(date){
				vm.customer.setLicenseExpiryDate(moment(date));
			}

			function setCustomerBirthday(date){
				vm.customer.setBirthday(moment(date));
			}		
			
			function initOutputCallback(){
				vm.isFormValid = isFormValid;
			}

			function isFormValid(){
				$scope.custormerDetialInfoForm.$submitted = true;
				return $scope.custormerDetialInfoForm.$valid;
			}

			function onPostcodeChange(){
				if(!vm.customer.address_postal_code || vm.customer.address_postal_code.length < 6){
					vm.addressList = [];
					vm.fetchingAddress = false;
					return;
				}

				vm.fetchingAddress = true;

				GoogleService.decodePostcode(companyID, vm.customer.address_postal_code).$promise
					.then(function(addressList){
						vm.addressList = addressList;
					})
					.catch(MessageService.showToast)
					.finally(function(){
						vm.fetchingAddress = false;
					})
			}

			function dismissAddressList(){
				$timeout(function(){
					vm.showAddressList = false;
				}, 100);
			}

			function selectAddress(address){
				if(!address){
					return;
				}

				if(address.streetNumber){
					vm.customer.address_street_number = address.streetNumber;
				}

				if(address.street){
					vm.customer.address_street = address.street;
				}

				if(address.city){
					vm.customer.address_city = address.city;
				}

				if(address.province){
					vm.customer.address_province = address.province;
				}
			}

			function getAddressName(address){
				if(!address){
					return;
				}

				var addressName = address.street + " " + address.city;

				if(address.province){
					addressName += ", " + address.province;
				}

				return addressName;
			}
		}
})();

(function ()
{
	"use strict";

	angular
		.module("app.customers")
		.component("customerBasicInfoForm", {
				bindings:{
					customer:'=',
					fileUploader:'=',
					constants:'<',

					profileImageSrc:'<',
					profileImageLink:'<',
					blurProfileImg:'=',
					showProfileImgProgress:'=',

					licenseImageSrc:'<',
					licenseImageLink:'<',
					blurLicenseImg:'=',
					showLicenseImgProgress:'=',
					
					isFormValid:'=',
					isSimilarCustomerFound:'='
				},
				templateUrl: "app/main/customers/customer-basic-info-form.html",
				controller: componentController,
		  		controllerAs: 'vm'
			});

		function componentController(GeneralTools, $state, $scope, $filter, $sce, CustomersService, MessageService, LoginService, Customer, FileUploadService, CustomerConstants){
			var vm = this;
			var resourcePath = {companyID: LoginService.getCompanyID()};
			var profileImageFile;
			var licenseImageFile;
			var filterObj = {};

			vm.translateToPhoneNumber = GeneralTools.inputTranslators.phoneNumber;
			vm.translateToInitCap = GeneralTools.inputTranslators.allInitCapitalize;
			vm.addPhoneNumber = addPhoneNumber;
			vm.removePhoneNumber = removePhoneNumber;
			vm.addEmail = addEmail;
			vm.removeEmail = removeEmail;
			vm.queryCustomers = queryCustomers;

			vm.$onInit = initComponent;
			vm.$postLink = initOutputCallbacks;

			function initComponent(){
				if(vm.profileImageSrc == null){
					vm.profileImageSrc = CustomerConstants.licenseImagePlaceHolder;
				}
				
				if(vm.licenseImageSrc == null){
					vm.licenseImageSrc = CustomerConstants.licenseImagePlaceHolder;
				}

				if(vm.customer == null){
					vm.customer = new Customer();
				}

				if(vm.fileUploader == null){
					vm.fileUploader = FileUploadService.getNewUploader();
					vm.fileUploader.filters.push(FileUploadService.getSizeFilter(20));
				}
			}

			function initOutputCallbacks(){
				vm.isFormValid = isFormValid;
				vm.isSimilarCustomerFound = isSimilarCustomerFound;
			}

			function isSimilarCustomerFound(){
				return vm.numberOfCustomerFound > 0;
			}

			function isFormValid(){
				$scope.custormerBasicInfoForm.$submitted = true;
				return $scope.custormerBasicInfoForm.$valid;
			}

			function addPhoneNumber(){
				vm.addPhoneNumberButtonClicked = true;
				vm.customer.addPhoneNumber({fk_id_phone_category: 2});
			}

			function removePhoneNumber(phoneNumber){
				vm.customer.removePhoneNumber(phoneNumber);
				queryCustomers();
			}

			function addEmail(){
				vm.addEmailButtonClicked = true;
				vm.customer.addEmail({fk_id_email_category: 3});
			}

			function removeEmail(email){
				vm.customer.removeEmail(email);
				queryCustomers();
			}

			function queryCustomers(){
				vm.numberOfCustomerFound = 0;
				filterObj.filters = '';
				
				var firstNameFilter = nameFilterBuilder();
				var phoneNumberFilter =	phoneNumberFilterBuilder();
				var emailFilter = emailFilterBuilder();

				filterObj.filters = stringConnector(filterObj.filters, firstNameFilter, " AND ");
				filterObj.filters = stringConnector(filterObj.filters, phoneNumberFilter, " AND ");
				filterObj.filters = stringConnector(filterObj.filters, emailFilter, " AND ");

				if(filterObj.filters == null || filterObj.filters.trim() == ''){
					return;
				}

				CustomersService.getCustomers(resourcePath, filterObj, null)
					.then(function(response){
						if(Array.isArray(response.data) && response.data.length == 1 && response.data[0].getResourceID() == vm.customer.getResourceID()){
							vm.numberOfCustomerFound = 0;
						}else{
							vm.numberOfCustomerFound = response.headerGetter("pagination-total-item");
						}
						updateFoundCustomersLink();
					})
					.catch(function(error){});
			}

			function phoneNumberFilterBuilder(){
				var filterString = '';

				if(!Array.isArray(vm.customer.phone_numbers)){
					return filterString;
				}

				vm.customer.phone_numbers.forEach(function(phoneNumber){
					if(phoneNumber.phone_number != null){
						var filterElement = filterStringBuiler("phone_number", phoneNumber.phone_number);

						filterString = stringConnector(filterString, filterElement, " OR ");
					}
				});

				return filterString;
			}

			function emailFilterBuilder(){
				var filterString = '';

				if(!Array.isArray(vm.customer.emails)){
					return filterString;
				}

				vm.customer.emails.forEach(function(email){
					if(email.email_address != null){
						var filterElement = filterStringBuiler("email_address", email.email_address);

						filterString = stringConnector(filterString, filterElement, " OR ");
					}
				});

				return filterString;
			}

			function nameFilterBuilder(){
				var filterString = '';
				var firstNameFilterString = '';
				var lastNameFilterString = '';

				if(vm.customer.first_name != null && vm.customer.first_name.trim() != ''){
					firstNameFilterString = filterStringBuiler("first_name", vm.customer.first_name);
				}

				if(vm.customer.last_name != null && vm.customer.last_name.trim() != ''){
					lastNameFilterString = filterStringBuiler("last_name", vm.customer.last_name);
				}

				filterString = stringConnector(filterString, firstNameFilterString, " AND ");
				filterString = stringConnector(filterString, lastNameFilterString, " AND ");

				if(filterString.indexOf("AND") != -1){
					filterString = ' ( ' +  filterString + ' ) ';
				}

				return filterString;
			}

			function filterStringBuiler(columnName, value){
				if(columnName == null || columnName.trim() == '' || value == null){
					return '';
				}

				return "contains(" + columnName + ",'" + value + "')";
			}

			function stringConnector(baseString, stringToAppend, connector){
				if(stringToAppend == null || stringToAppend.trim() == ''){
					return baseString;
				}

				if(baseString == null){
					baseString == '';
				}

				if (baseString.trim() != ''){
					baseString += connector
				}

				baseString += stringToAppend

				return baseString;
			}

			function updateFoundCustomersLink(){
				vm.foundCustomersLink = $state.href('app.customers', CustomersService.getUrlParamsForBrowseCusmotersByCustomerObj(vm.customer), {absolute: true});
			}
		}
})();
(function ()
{
	'use strict';

	angular
		.module("app.customers")
		.factory("TestDrive", TestDriveClass)

	/** @ngInject */
	function TestDriveClass(LoginService)
	{	   
		function TestDrive(){}

		TestDrive.prototype.setAttributes = function (attributes) {
	 		if(attributes == null){
	 			return;
	 		}

	 		if(attributes.vehicle == null){
				attributes.vehicle = {};
			}

	 		var keyList = Object.keys(attributes);

	 		for(var i = 0; i < keyList.length; i++){
	 			var key = keyList[i];
	 			var value = attributes[key];

	 			this.setAttribute(key, value);
	 		}
		}

		TestDrive.prototype.setAttribute = function (key, value) {
	 		this[key] = value;
		}

		TestDrive.prototype.getResourcePath = function () {
			var resourcePath = {};

			resourcePath.companyID = LoginService.getCompanyID();
			resourcePath.customerID = this.fk_id_customer;
			resourcePath.testdriveID = this.id_test_drive;

	 		return resourcePath;
		}	

		TestDrive.prototype.getResourceID = function () {
	 		return this.id_test_drive;
		}

		TestDrive.prototype.getParentResourceID = function () {
	 		return this.fk_id_customer;
		}		

		TestDrive.prototype.setTestDriveVehicle = function(vehicle){
			this.vehicle = vehicle;
		}

		return TestDrive;
	}
})();
(function ()
{
	'use strict';

	angular
		.module("app.customers")
		.factory("Customer", CustomerClass)

	/** @ngInject */
	function CustomerClass($filter, CustomerConstants, GeneralTools)
	{	   
		function Customer(){}

		Customer.prototype.setAttributes = function (attributes) {
	 		if(attributes == null){
	 			return;
	 		}

	 		var keyList = Object.keys(attributes);

	 		for(var i = 0; i < keyList.length; i++){
	 			var key = keyList[i];
	 			var value = attributes[key];

	 			this.setAttribute(key, value);
	 		}
		}

		Customer.prototype.setAttribute = function (key, value) {
	 		this[key] = value;
		}

		Customer.prototype.getResourcePath= function () {
			var resourcePath = {};
			resourcePath.customerID = this.id_customer
			resourcePath.companyID = this.fk_id_company
	 		return resourcePath;
		}

		Customer.prototype.getResourceID = function () {
	 		return this.id_customer;
		}

		Customer.prototype.getParentResourceID = function () {
	 		return this.fk_id_company;
		}	

		Customer.prototype.setLicenseExpiryDate = function (momentObj) {
	 		if(momentObj != null && momentObj.isValid()){
				this.license_expiry_date = momentObj.format(CustomerConstants.licenseExpiryDateFormat);
				return true;
			}
			this.license_expiry_date = null;
			return false;
		}	

		Customer.prototype.getLicenseExpiryDateMomentObj = function (){
			if(this.license_expiry_date != null){
				return moment(this.license_expiry_date, CustomerConstants.licenseExpiryDateFormat);
			}
		}

		Customer.prototype.setBirthday = function (momentObj) {
	 		if(momentObj != null && momentObj.isValid()){
				this.birthday = momentObj.format(CustomerConstants.birthdayDateFormate);
				return true;
			}
			this.birthday = null;
			return false;
		}	

		Customer.prototype.getBirthdayMomentObj = function (){
			if(this.birthday != null){
				return moment(this.birthday, CustomerConstants.birthdayDateFormate);
			}
		}

		Customer.prototype.addPhoneNumber = function (phoneNumberObj){
			if(phoneNumberObj == null){
				return;
			}

			if(!Array.isArray(this.phone_numbers)){
				this.phone_numbers = [];
			}

			this.phone_numbers.push(phoneNumberObj);
		}

		Customer.prototype.removePhoneNumber = function (phoneNumberObj){
			if(!Array.isArray(this.phone_numbers)){
				return;
			}

			this.phone_numbers.splice(this.phone_numbers.indexOf(phoneNumberObj), 1);
		}

		Customer.prototype.addEmail = function (emailObj){
			if(emailObj == null){
				return;
			}

			if(!Array.isArray(this.emails)){
				this.emails = [];
			}

			this.emails.push(emailObj);
		}

		Customer.prototype.removeEmail = function (emailObj){
			if(!Array.isArray(this.emails)){
				return;
			}
			
			this.emails.splice(this.emails.indexOf(emailObj), 1);
		}

		Customer.prototype.getFullName = function (){
			var firstName = '';
			var lastName = '';

			if(!!this.first_name){
				firstName = this.first_name;
			}

			if(!!this.last_name){
				lastName = this.last_name;
			}

			return firstName + ' ' + lastName;
		}

		Customer.prototype.getFullAddress = function (){
			var address = '';

			address = GeneralTools.stringConnector(address, this.address_street_number, ' ');
			address = GeneralTools.stringConnector(address, this.address_street, ' ');
			address = GeneralTools.stringConnector(address, this.address_city, ', ');
			address = GeneralTools.stringConnector(address, this.address_province, ', ');
			address = GeneralTools.stringConnector(address, this.address_postal_code, ' ');

			return address;
		}

		Customer.prototype.getPhoneNumber = function (){
			if(this.phone_numbers && this.phone_numbers.length > 0){
				return this.phone_numbers[0].phone_number;

			}else{
				return null
			}
		}
		return Customer;
	}


})();
(function ()
{
	'use strict';

	angular
		.module("app.customers")
		.factory("CustomAppointment", CustomAppointmentClass)

	/** @ngInject */
	function CustomAppointmentClass(LoginService)
	{	   
		function CustomAppointment(){}

		CustomAppointment.prototype.setAttributes = function (attributes) {
	 		if(attributes == null){
	 			return;
	 		}

	 		var keyList = Object.keys(attributes);

	 		for(var i = 0; i < keyList.length; i++){
	 			var key = keyList[i];
	 			var value = attributes[key];

	 			this.setAttribute(key, value);
	 		}
		}

		CustomAppointment.prototype.setAttribute = function (key, value) {
	 		this[key] = value;
		}

		CustomAppointment.prototype.getResourcePath = function () {
			var resourcePath = {};

			// resourcePath.companyID = LoginService.getCompanyID();
			// resourcePath.customerID = this.fk_id_customer;
			// resourcePath.testdriveID = this.id_test_drive;

	 		return resourcePath;
		}	

		CustomAppointment.prototype.getResourceID = function () {
	 		return this.id_test_drive;
		}

		CustomAppointment.prototype.getParentResourceID = function () {
	 		return this.fk_id_customer;
		}		

		CustomAppointment.prototype.setTestDriveVehicle = function(vehicle){
			this.vehicle = vehicle;
		}

		return CustomAppointment;
	}
})();
(function ()
{
	'use strict';

	angular
		.module("app.customers")
		.factory("CreditCard", CreditCardClass)

	/** @ngInject */
	function CreditCardClass(LoginService)
	{	   
		function CreditCard(){}

		CreditCard.prototype.setAttributes = function (attributes) {
	 		if(attributes == null){
	 			return;
	 		}

	 		var keyList = Object.keys(attributes);

	 		for(var i = 0; i < keyList.length; i++){
	 			var key = keyList[i];
	 			var value = attributes[key];

	 			this.setAttribute(key, value);
	 		}
		}

		CreditCard.prototype.setAttribute = function (key, value) {
	 		this[key] = value;
		}

		CreditCard.prototype.getResourcePath = function () {
			var resourcePath = {};

			// resourcePath.companyID = LoginService.getCompanyID();
			// resourcePath.customerID = this.fk_id_customer;
			// resourcePath.testdriveID = this.id_test_drive;

	 		return resourcePath;
		}	

		CreditCard.prototype.getResourceID = function () {
	 		return this.id_test_drive;
		}

		CreditCard.prototype.getParentResourceID = function () {
	 		return this.fk_id_customer;
		}		

		CreditCard.prototype.setTestDriveVehicle = function(vehicle){
			this.vehicle = vehicle;
		}

		return CreditCard;
	}
})();
(function ()
{
	'use strict';

	angular
		.module('app.appointments', [])
		.constant("AppointmentConstants", {
			keyNames:{
				appointmentStatus: "fk_id_appointment_status",
				calendar: "fk_id_calendar",
				start: "start",
				end: "end"
			},
			statusIDs:{
				NO_SHOW: 1,
				CANCELLED: 2,
				POSTPONED: 3,
			},
			customerPortalStatusID:{
				Proposed: 1,
				Confirmed: 2,
				Cancelled: 3,
				Cancel_Requested: 4,
				Postpone_Requested: 5,
			}
		})
		.config(config)

	/** @ngInject */
	function config($stateProvider)
	{	  


	}

})();
(function ()
{
	'use strict';

	angular
		.module('app.appointments')
		.service("AppointmentsService", AppointmentsService);

	/** @ngInject */
	function AppointmentsService($state, api, ToolsFactory, Const, $q, MessageService, LoginService, $filter, Appointment, HeaderHelper, ConstantCacheService)
	{   
		var codeKey = Const.header.code;
		var messageKey = Const.header.message;
		var successCode = Const.code.success;

		this.getAllMatchedAppointments = function(resourcePath, filters, sorting){
			const limit = 100;
			const _this = this;
			var appointmentList = [];
			
			return _this.getAppointments(resourcePath, filters, {page: 1, limit: limit}, sorting)
				.then(function(response){
					if(!response || !Array.isArray(response.data)){
						return $q.reject("Failed to fetch appointments for report.");
					}

					appointmentList = appointmentList.concat(response.data);

					var totalItem = HeaderHelper.getPaginationTotalItem(response.headerGetter);
					var currentPage = HeaderHelper.getPaginationCurrentPage(response.headerGetter);
					var itemsPerPage = HeaderHelper.getPaginationItemsPerPage(response.headerGetter);

					var queue = [];

					if(response.data.length < totalItem){
						var totalPage = Math.ceil(totalItem/itemsPerPage);

						for(var i = 2; i <= totalPage; i++){
							queue.push(_this.getAppointments(resourcePath, filters, {page: i, limit: limit}, sorting));
						}
					}

					return $q.all(queue);
				})
				.then(function(responseList){
					if(!Array.isArray(responseList)){
						return $q.reject("Failed to fetch appointments for report.");
					}

					for(var i = 0; i < responseList.length; i++){
						var response = responseList[i];

						if(!response || !Array.isArray(response.data)){
							return $q.reject("Failed to fetch appointments for report.");
						}

						appointmentList = appointmentList.concat(response.data);
					}

					return $q.resolve(appointmentList);
				});
		}

		this.getAppointments = function(resourcePath, filters, pagination, sorting){			
			var defer = $q.defer();
			var queryParams = Object.assign({}, resourcePath, filters, pagination, sorting);

			api.appointments.getAppointments(
				queryParams,
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);
						defer.reject(errorMessage);
						return;
					}

					var appointmentList = [];

					response.forEach(function(data){
						var appointment = new Appointment();

						appointment.setAttributes(data);
						appointmentList.push(appointment);
					})

					var result = {
						data: appointmentList,
						headerGetter: header
					}

					defer.resolve(result);
				},
				function(error){
					console.error("Failed to get appointment.");
					defer.reject(error);
				}
			);

			return defer.promise;
		}

		this.createAppointment = function(resourcePath, requestBody){
			var defer = $q.defer();

			api.appointments.postAppointment(
				resourcePath,
				requestBody,
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);
						defer.reject(errorMessage);
						return;
					}

					defer.resolve(response.data);
				},
				function(error){
					console.error("Failed to create appointment.");
					defer.reject(error);
				}
			);

			return defer.promise;
		}

		this.updateAppointment = function(resourcePath, requestBody){
			var defer = $q.defer();

			api.appointments.updateAppointment(
				resourcePath,
				requestBody,
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);

						defer.reject(errorMessage);
						return;
					}
					defer.resolve(response);

				},
				function(error){
					console.error(error);
					defer.reject("Failed to update appointment.");
				}
			);	

			return defer.promise;
		}

		this.getCalendars = function(resourcePath){
			var defer = $q.defer();

			api.calendars.getCalendars(
				resourcePath,
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);
						defer.reject(errorMessage);
						return;
					}

					defer.resolve(response);
				},
				function(error){
					console.error("Failed to get calendars.");
					defer.reject(error);
				}
			);

			return defer.promise;
		}

		this.getCachedCalendars = function(resourcePath) {
			var cacheKey = getCalendarsCacheKey(resourcePath);
			var ttl = 30 * 60 * 1000; // 30 minutes

			return ConstantCacheService.get(cacheKey, function () {
				return this.getCalendars(resourcePath);
			}.bind(this), ttl);
		}

		function getCalendarsCacheKey(resourcePath) {
			if (resourcePath && resourcePath.companyID) {
				return 'calendars_company_' + resourcePath.companyID;
			}

			return 'calendars';
		}

		this.updateCalendars = function(resourcePath, requestBody){
			var defer = $q.defer();
			api.calendars.updateCalendar(
				resourcePath,
				requestBody,
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);
						defer.reject(errorMessage);
						return;
					}

					defer.resolve(response);
				},
				function(error){
					console.error("Failed to update calendars.");
					defer.reject(error);
				}
			);

			return defer.promise;
		}


		this.getCustomerPortalAppointmentCalendars = function(resourcePath){
			var defer = $q.defer();

			api.customerportalcalendars.getCustomerPortalCalendars(
				resourcePath,
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);
						defer.reject(errorMessage);
						return;
					}

					defer.resolve(response);
				},
				function(error){
					console.error("Failed to get calendars.");
					defer.reject(error);
				}
			);

			return defer.promise;
		}


		this.getAllMatchedCustomerPortalAppointments = function(resourcePath, filters, sorting){
			const limit = 100;
			const _this = this;
			var appointmentList = [];
			
			return _this.getCustomerPortalAppointments(resourcePath, filters, {page: 1, limit: limit}, sorting)
				.then(function(response){
					if(!response || !Array.isArray(response.data)){
						return $q.reject("Failed to fetch appointments for report.");
					}

					appointmentList = appointmentList.concat(response.data);

					var totalItem = HeaderHelper.getPaginationTotalItem(response.headerGetter);
					var currentPage = HeaderHelper.getPaginationCurrentPage(response.headerGetter);
					var itemsPerPage = HeaderHelper.getPaginationItemsPerPage(response.headerGetter);

					var queue = [];

					if(response.data.length < totalItem){
						var totalPage = Math.ceil(totalItem/itemsPerPage);

						for(var i = 2; i <= totalPage; i++){
							queue.push(_this.getCustomerPortalAppointments(resourcePath, filters, {page: i, limit: limit}, sorting));
						}
					}

					return $q.all(queue);
				})
				.then(function(responseList){
					if(!Array.isArray(responseList)){
						return $q.reject("Failed to fetch appointments for report.");
					}

					for(var i = 0; i < responseList.length; i++){
						var response = responseList[i];

						if(!response || !Array.isArray(response.data)){
							return $q.reject("Failed to fetch appointments for report.");
						}

						appointmentList = appointmentList.concat(response.data);
					}

					return $q.resolve(appointmentList);
				});
		}

		this.getCustomerPortalAppointments = function(resourcePath, filters, pagination, sorting){			
			var defer = $q.defer();
			var queryParams = Object.assign({}, resourcePath, filters, pagination, sorting);

			api.customerportalappointments.getCustomerPortalAppointments(
				queryParams,
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);
						defer.reject(errorMessage);
						return;
					}

					var appointmentList = [];

					response.forEach(function(data){
						var appointment = new Appointment();

						appointment.setAttributes(data);
						appointmentList.push(appointment);
					})

					var result = {
						data: appointmentList,
						headerGetter: header
					}

					defer.resolve(result);
				},
				function(error){
					console.error("Failed to get appointment.");
					defer.reject(error);
				}
			);

			return defer.promise;
		}

		this.getAppointmentStatus = function(resourcePath){
			var defer = $q.defer();

			api.getConstants.appointmentStatus.get(
				resourcePath,
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);
						defer.reject(errorMessage);
						return;
					}

					defer.resolve(response);
				},
				function(error){
					console.error("Failed to get appointment status.");
					defer.reject(error);
				}
			);

			return defer.promise;
		}

		this.getCachedAppointmentStatus = function(resourcePath) {
			return ConstantCacheService.get('appointment_status', function () {
				return this.getAppointmentStatus(resourcePath);
			}.bind(this));
		}

		this.deleteAppointment = function(resourcePath){
			var defer = $q.defer();

			api.appointments.deleteAppointment(
				resourcePath,
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);
						defer.reject(errorMessage);
						return;
					}

					defer.resolve(response);
				},
				function(error){
					console.error("Failed to delete appointment.");
					defer.reject(error);
				}
			);

			return defer.promise;
		}

		this.createCustomAppointment = function(resourcePath, requestBody){
			var defer = $q.defer();

			api.customAppointment.postCustomAppointment(
				resourcePath,
				requestBody,
				function(response, header){
					var statusCode  = header(codeKey);

					if(statusCode != successCode){
						var errorMessage = statusCode + ': ' + header(messageKey);
						defer.reject(errorMessage);
						return;
					}

					defer.resolve(response.data);
				},
				function(error){
					console.error("Failed to create custom appointment.");
					defer.reject(error);
				}
			);

			return defer.promise;
		}
	}
})();
(function ()
{
	'use strict';

	angular
		.module("app.appointments")
		.factory("Appointment", AppointmentClass)

	/** @ngInject */
	function AppointmentClass($filter, AppointmentConstants)
	{	 
		function Appointment(){}

		Appointment.prototype.setAttributes = function (attributes) {
	 		if(attributes == null){
	 			return;
	 		}

	 		var keyList = Object.keys(attributes);

	 		for(var i = 0; i < keyList.length; i++){
	 			var key = keyList[i];
	 			var value = attributes[key];

	 			this.setAttribute(key, value);
	 		}
		}

		Appointment.prototype.setAttribute = function (key, value) {
	 		this[key] = value;
		}

		Appointment.prototype.getResourceId = function () {
	 		return this.id_appointment;
		}	

		return Appointment;
	}


})();
/**
 *  Description: define the constants
 */
(function ()
{
	"use strict";

	angular
		.module("app.const", [])
		.constant("Const", {
			xhrStatus:{
				abort: "abort"
			},
			logo: {
				initial	: "RM",
				title	: "Rogers Motors"
			},
			header: {
				code			: "code",
				message			: "message"
			},			
			code: {
				success			: 200,
				system_error	: 500,
				user_error		: 400
			},
			property:{
				userStatus:{
					isLogin		: "isLogin",
					userInfo	: "userInfo"
				},
				loginResponse:{
					code		: "code",
					message		: "message",
					token		: "token",
					username	: "username"
				},
				error:{
					fileName	: "fileName",
					sourceURL	: "sourceURL",
					lineNumber	: "lineNumber",
					line		: "line"
				}
			},
			roleDescription: {
				developer:"Developer can do any thing",
				company_manager:"Company manager can do any thing inside a company",
				sales_manager:"Sales manager can do any thing to a salesman",
				salesman:"salesman can do nothing",
				advertizing:"Advertizing can advertise",
				vehicle_manager:"vehicle_manager can add or delete a vehicle",
				goto_all_calls:"Can view all dealership GoTo call history",
			},
			roleDisplayName: {
				goto_all_calls: "GoTo (all dealership calls)",
			},
			assignablePermissionRoles: ["goto_all_calls"],
		});
})();
(function ()
{
	'use strict';

	angular.module('app.bookAppointment', [])
		.config(config);

	/** @ngInject */
	function config($stateProvider, msNavigationServiceProvider)
	{	  
		$stateProvider
			.state('app.book-appointment', {
				url: '/bookappointment',
				reloadOnSearch : false,
				views: {
					'content@app': {
						templateUrl: 'app/main/book-appointment/book-appointment.html',
						controller: 'BookAppointmentController as vm'
					}
				}
			});
	}
})();
(function ()
{
	'use strict';

	angular
		.module('app.bookAppointment')
		.service("BookAppointmentService", BookAppointmentService);

	/** @ngInject */
	function BookAppointmentService(LoginService, GeneralTools, Const, $q, MessageService, $resource)
	{
		const baseUrl = GeneralTools.getBaseUrl();
		const baseHeader = GeneralTools.getBaseHeader();
		const noCacheHeader = GeneralTools.getNoCacheHeader();

		const customerBookAppointmentApi = $resource(
			baseUrl + "companies/:companyID/workorderappointments/makeCustomerAppointment",
			{
				companyID:"@companyID"
			},
			{
				bookAppointment:{
					method:"POST",
					cancellable: true,
					interceptor:{
						response: function(result){
							const statusCode  = result.headers(Const.header.code);
							const message = result.headers(Const.header.message)
							if(statusCode != Const.code.success){
								console.error(statusCode, message);
								return $q.reject(message);
							}

							return result.data;
						},
						responseError: function (error){
							if(error && error.xhrStatus == Const.xhrStatus.abort){
								return $q.reject();
							}
							console.error(error);
							return $q.reject(error);
						}
					}
				}
			}
		);

		const predefinedAppointments = $resource(
			baseUrl + "predefinedappointments",
			{},
			{
				get:{
					method:"GET",
					cancellable: true,
					isArray: true,
					interceptor:{
						response: function(result){
							const statusCode  = result.headers(Const.header.code);
							const message = result.headers(Const.header.message)
							if(statusCode != Const.code.success){
								console.error(statusCode, message);
								return $q.reject(message);
							}

							return result.data;
						},
						responseError: function (error){
							if(error && error.xhrStatus == Const.xhrStatus.abort){
								return $q.reject();
							}
							console.error(error);
							return $q.reject(error);
						}
					}
				}
			}
		);

		this.getPredefinedAppointments = function(companyID){
			return predefinedAppointments.get({companyID: companyID});
		}

		this.customerBookAppointment = function(companyID, requestBody){
			if(!requestBody){
				return {$promise: $q.reject("requestBody invalid.")};
			}

			const params = angular.copy(requestBody);
			params.companyID = companyID;

			return customerBookAppointmentApi.bookAppointment(params);
		}		
	}
})();
(function ()
{
	'use strict';

	angular
		.module('app.bookAppointment')
		.controller('BookAppointmentController', BookAppointmentController);

	function BookAppointmentController(VehicleConstants, CookieConst, $cookies, CustomersService, BookAppointmentService, WorkOrderConstants, AppointmentConstants, ToolsConstants, AppointmentsService, $q, $scope, GeneralTools, LoginService, VehicleService, MessageService, ProgressService, WorkOrderService){
		const vm = this;
		const companyID = LoginService.getCompanyID();
		const pageCache = $cookies.getObject(CookieConst.visitorCacheKeys.bookMyService);
		const errorMessageWorkorderInvalid = "Work order data invalid.";
		const timeRangeFilterFormat = "YYYY-MM-DD HH:mm:ss";
		const requestBodyTimeRangeFormat = "YYYY-MM-DD[T]HH:mm:ss[Z]";

		// Unit: day.
		const maxDayRange = 15;

		// Unit: minute.
		const defaultSlotInterval = 30;
		const defaultAppointmentDuration = 60;
		
		const vehicleMap = {};
		const customerMap = {};
		const quotedWorkorderMap = {};
		const startDayIndex = 1;
		const slotsBetweenAppointments = 2;
		
		var selectedCustomerCopy;
		var selectedDateNameCopy;
		var publicCalendarsCache;
		var appointmentsCache;

		vm.translateToPhoneNumber = GeneralTools.inputTranslators.phoneNumber;
		vm.selectVehicle = selectVehicle;
		vm.canDateBeSelect = canDateBeSelect;
		vm.makeAppointment = makeAppointment;
		vm.searchCustomer = searchCustomer;
		vm.selectCustomer = selectCustomer;
		vm.beforeStepChange = beforeStepChange;
		vm.selectService = selectService;
		vm.nextStep = nextStep;
		vm.selectTimeSlot = selectTimeSlot;
		vm.contactUsPhoneLink = "tel:9056180350,3";
		vm.imagePlaceholder = VehicleConstants.vehicleImagePlaceholder;
		vm.isSelectServiceStepCompleted = isSelectServiceStepCompleted;
		vm.getAppointmentDescription = getAppointmentDescription;

		const searchCustomerStep = {
			isCompleted: function(){
				return !!vm.selectedCustomer;
			},
			onInit: initCustomerStep
		};

		const selectVehicleStep = {
			isCompleted: function(){
				return !!vm.selectedVehicle;
			},
			onInit: initVehicleStep
		};

		const selectServiceStep = {
			isCompleted: isSelectServiceStepCompleted,
			onInit: initSelectServiceStep
		};

		const selectDateStep = {
			isCompleted: function(){
				return !!vm.selectedDate;
			},
			onInit: initCalendarPicker
		};

		const selectTimeSlotStep = {
			isCompleted: function(){
				return !!vm.selectedTimeSlot;
			},
			onInit: initAvailableTimeSlot
		};

		const confirmStep = {
			isCompleted: function(){
				return vm.finishBooking;
			}
		};

		const listener = {
			onQueueChange: function(queue){
				vm.isBusy = queue > 0;
			}
		};

		init();

		function init(){
			ProgressService.registerListener(listener);

			$scope.$on("$stateChangeStart", function(){
				ProgressService.removeListener(listener);
			});

			initStepper();
		}

		function initStepper(){
			vm.steps = [
				searchCustomerStep,
				selectVehicleStep,
				selectServiceStep,
				selectDateStep,
				selectTimeSlotStep,
				confirmStep,
			];
		}

		function isSelectServiceStepCompleted(){
			var selectedPredefindedAppointment;

			if(Array.isArray(vm.predefindAppointments)){
				selectedPredefindedAppointment = vm.predefindAppointments.find(function(predefindAppointment){
					return predefindAppointment.isSelected;
				});
			}

			if(vm.isOtherServiceSelected){
				return !!vm.otherServiceDetail;
			}

			return selectedPredefindedAppointment;
		}

		function initSelectServiceStep(){
			if(vm.predefindAppointments){
				return;
			}

			ProgressService.addTaskToQueue();

			BookAppointmentService.getPredefinedAppointments(companyID).$promise
				.then(function(predefindAppointments){
					vm.predefindAppointments = predefindAppointments;
				})
				.catch(MessageService.showToast)
				.finally(ProgressService.removeTaskFromQueue)
		}

		function initCustomerStep(){
			if(Array.isArray(vm.customers)){
				return;
			}

			if(pageCache){
				vm.phoneNumber = pageCache.phoneNumber.toString();
				vm.email = pageCache.email;

				searchCustomer();
			}
		}

		function initAvailableTimeSlot(){
			if(!vm.availableSlots){
				return;
			}
			const dateName = moment(vm.selectedDate).format("YYYY-MM-DD");

			vm.timeSlotList = vm.availableSlots[dateName];

			if(selectedDateNameCopy != dateName){
				selectedDateNameCopy = dateName;
				vm.selectedTimeSlot = null;
			}
		}

		function initCalendarPicker(){
			if(!vm.selectedVehicle){
				return;
			}

			vm.calendarWarningMessage = null;
			vm.availableSlots = null;

			const vehicleID = vm.selectedVehicle.getResourceID();

			ProgressService.addTaskToQueue();

			getQuotedWorkorder(vehicleID)
				.then(function(quotedWorkorder){
					vm.quotedWorkorder = quotedWorkorder;

					if(vm.quotedWorkorder){		
						return $q.reject("Sorry, we found an active work order (invoice#: " + vm.quotedWorkorder.invoice_number + " ) in our system");
					}

					return getAvailableTimeSlots();
				})
				.then(function(availableSlots){
					if(!availableSlots || Object.keys(availableSlots).length <= 0){
						return $q.reject("Sorry, no time slot is available");
					}

					vm.availableSlots = availableSlots;
				})
				.catch(function(error){
					vm.calendarWarningMessage = error;
				})
				.finally(ProgressService.removeTaskFromQueue);
		}


		function selectService(predefindAppointment, isOtherService){
			if(isOtherService){
				vm.isOtherServiceSelected = !vm.isOtherServiceSelected;
			} else {
				predefindAppointment.isSelected = !predefindAppointment.isSelected;
			}

			vm.selectedDate = null;
		}

		function isSelectedCustomerChanged(){
			if(!selectedCustomerCopy && !vm.selectedCustomer){
				return false;
			}

			if(selectedCustomerCopy && vm.selectedCustomer){
				return selectedCustomerCopy.id_customer != vm.selectedCustomer.id_customer;
			}

			return true;
		}

		function selectCustomer(customer){
			if(!customer){
				return;
			}

			vm.selectedCustomer = customer;

			nextStep();
		}

		function initVehicleStep(){
			if(!vm.selectedCustomer){
				return;
			}

			const cachedVehicleList = vehicleMap[vm.selectedCustomer.id_customer];

			if(Array.isArray(cachedVehicleList)){
				resetVehicleList(cachedVehicleList);
				vm.noVehicleFound = cachedVehicleList.length <= 0;
				return;
			}

			ProgressService.addTaskToQueue();

			VehicleService.searchByCustomerInfo(companyID,  {customerID: vm.selectedCustomer.id_customer}).$promise
				.then(function(vehicles){
					vehicleMap[vm.selectedCustomer.id_customer] = vehicles;
					resetVehicleList(vehicles);
					vm.noVehicleFound = !Array.isArray(vehicles) || vehicles.length <= 0;
				})
				.catch(MessageService.showToast)
				.finally(ProgressService.removeTaskFromQueue)
		}


		function nextStep(){
			if(typeof(vm.nextStepByStepper) == "function"){
				vm.nextStepByStepper();
			}
		}

		function searchCustomer(){
			const isPhoneNumberValid = vm.phoneNumber && vm.phoneNumber.toString().length == 10;
			const isEmailValid = vm.email && GeneralTools.isEmailAddressValid(vm.email);

			if(!isPhoneNumberValid && !isEmailValid){
				resetCustomerList();
				vm.noCustomerFound = false;
				return;
			}

			const params = {
				phoneNumber: vm.phoneNumber,
				email: vm.email
			};

			const key = JSON.stringify(params);
			const cachedCustomer = customerMap[key];

			if(Array.isArray(customerMap[key])){
				resetCustomerList(cachedCustomer);
				vm.noCustomerFound = cachedCustomer.length <= 0;
				return;
			}

			ProgressService.addTaskToQueue();

			CustomersService.customerPublicSearch(companyID, params).$promise
				.then(function(customers){
					customerMap[key] = customers;
					resetCustomerList(customers);
					vm.noCustomerFound = !Array.isArray(customers) || customers.length <= 0
					$cookies.put(CookieConst.visitorCacheKeys.bookMyService, JSON.stringify({phoneNumber: vm.phoneNumber, email: vm.email}));
				})
				.catch(MessageService.showToast)
				.finally(ProgressService.removeTaskFromQueue)
		}

		function resetCustomerList(customers){
			vm.customers = customers;
			vm.selectedCustomer = null;
		}

		function selectVehicle(vehicle){
			if(!vehicle){
				return;
			}

			vm.selectedVehicle = vehicle;

			nextStep();
		}

		function getQuotedWorkorder(vehicleID){
			const cachedWorkorder = quotedWorkorderMap[vehicleID];

			if(cachedWorkorder !== undefined){
				return $q.resolve(cachedWorkorder);
			}

			const resourcePath = {
				companyID: companyID,
				vehicleID: vehicleID
			};

			return WorkOrderService.getWorkOrders(resourcePath).$promise
				.then(function(workorders){
					if(!Array.isArray(workorders)){
						return $q.reject(errorMessageWorkorderInvalid);
					}

					const quotedWorkorder = workorders.find(function(workorder){
						return workorder.isQuoted();
					});

					quotedWorkorderMap[vehicleID] = quotedWorkorder ? quotedWorkorder : null;

					return $q.resolve(quotedWorkorder);
				});
		}

		function getCalendarAppointments(startTime, endTime, publicCalendars){
			var filterString = '';

			if(!startTime || !startTime.isValid() || !endTime || !endTime.isValid()){
				return $q.reject("Time range invalid.")
			}

			const startTimeString = startTime.clone().utc().format(timeRangeFilterFormat);
			const endTimeString = endTime.clone().utc().format(timeRangeFilterFormat);

			const startTimeFilter = GeneralTools.equalRangeFilterBuilder(AppointmentConstants.keyNames.start, startTimeString, endTimeString);
			const endTimeFilter = GeneralTools.equalRangeFilterBuilder(AppointmentConstants.keyNames.end, startTimeString, endTimeString);
			var timeFilter = GeneralTools.stringConnector(startTimeFilter, endTimeFilter, ToolsConstants.apiFilters.orConnector);
			timeFilter = GeneralTools.addBracketToString(timeFilter);

			const statusFilter = GeneralTools.equalFilterBuilder(AppointmentConstants.keyNames.appointmentStatus, null);	
			filterString = GeneralTools.stringConnector(timeFilter, statusFilter, ToolsConstants.apiFilters.andConnector);

			var calendarFilter = buildCalendarFilter(publicCalendars);

			if(calendarFilter){
				calendarFilter = GeneralTools.addBracketToString(calendarFilter);
				filterString = GeneralTools.stringConnector(timeFilter, calendarFilter, ToolsConstants.apiFilters.andConnector);			
			}

			return AppointmentsService.getAllMatchedAppointments({ companyID: companyID }, {filters: filterString});
		}

		function getAvailableTimeSlots(){
			var getPublicCalendersTask;

			if(Array.isArray(publicCalendarsCache)){
				getPublicCalendersTask = $q.resolve(publicCalendarsCache);
			} else {
				getPublicCalendersTask = getPublicCalenders()
			}

			const startTime = moment();
			const endTime = getEndTime(startTime);

			return getPublicCalendersTask.then(function(publicCalendars){
					publicCalendarsCache = publicCalendars;

					if(Array.isArray(appointmentsCache)){
						return $q.resolve(appointmentsCache);
					} 

					return getCalendarAppointments(startTime, endTime, publicCalendarsCache);
				})
				.then(function(appointments){
					return $q.resolve(buildAvailableTimeSlots(startTime, endTime, appointments));
				});
		}

		function getEndTime(startTime){
			if(!startTime || !startTime.isValid()){
				return;
			}

			const businessHour = getBusinessHourObj(startTime.clone().add(maxDayRange, 'days').day());

			if(businessHour){
				return moment(businessHour.endTime, businessHour.format).date(startTime.date() + maxDayRange).startOf('minute');
			}
		}

		function getBusinessHourObj(dayOfWeek){
			return WorkOrderConstants.businessHours.find(function(businessHour){
				if(Array.isArray(businessHour.daysOfWeek)){
					return businessHour.daysOfWeek.indexOf(dayOfWeek) != -1
				}
			});
		}

		function getAppointmentDuration(){
			var appointmentDuration = 0;

			vm.predefindAppointments.forEach(function(predefindAppointment){
				if(predefindAppointment && predefindAppointment.isSelected){
					appointmentDuration += predefindAppointment.duration;
				}
			});

			if(vm.isOtherServiceSelected){
				appointmentDuration += defaultAppointmentDuration;
			}

			return appointmentDuration;
		}


		function getMinutesSinceMidNight(momentObj){
			if(!momentObj || !momentObj.isValid()){
				return;
			}

			return momentObj.diff(momentObj.clone().startOf('day'), 'minutes');
		}

		function notOverLappingWithAppointments(startTime, endTime, appointments){
			if(!startTime || !startTime.isValid() || !endTime || !endTime.isValid() || !Array.isArray(appointments)){
				return;
			}

			return appointments.every(function(appointment){
				const appmtStartTime = moment(appointment.start);
				const appmtEndTime = moment(appointment.end);

				return startTime.isSameOrAfter(appmtEndTime) || endTime.isSameOrBefore(appmtStartTime);
			});
		}

		function buildAvailableTimeSlots(startTime, endTime, appointments){
			if(!startTime || !startTime.isValid() || !endTime || !endTime.isValid() || !Array.isArray(appointments)){
				return;
			}

			const availableSlotMap = {};
			const appointmentDuration = getAppointmentDuration();
			const slotInterval = defaultSlotInterval > appointmentDuration ? appointmentDuration : defaultSlotInterval;
			const slotsForAppmt = Math.ceil(appointmentDuration / slotInterval);
			
			for(var dayIndex = 0; dayIndex < maxDayRange; dayIndex++){
				const currentDay = startTime.clone().date(startTime.date() + dayIndex + startDayIndex);
				const currentDayName = currentDay.format("YYYY-MM-DD");
				const businessHourObj = getBusinessHourObj(currentDay.day())

				if(!businessHourObj){
					continue;
				}

				availableSlotMap[currentDayName] = [];

				// Get business hour time range.
				var startTimeOfCurrentDay = moment(businessHourObj.startTime, businessHourObj.format).dayOfYear(currentDay.dayOfYear());
				var endTimeOfCurrentDay = moment(businessHourObj.endTime, businessHourObj.format).dayOfYear(currentDay.dayOfYear());

				if(startTime.isAfter(startTimeOfCurrentDay)){
					startTimeOfCurrentDay = startTime.clone();
				}

				if(startTimeOfCurrentDay.isAfter(endTimeOfCurrentDay)){
					continue;
				}

				// Go through and check every slot in business hour time range.
				const startSlot = Math.ceil(getMinutesSinceMidNight(startTimeOfCurrentDay) / slotInterval);
				const endSlot = Math.ceil(getMinutesSinceMidNight(endTimeOfCurrentDay) / slotInterval);
				var slotCount = 0;
				var lastAvailableSlot = null;

				for(var i = startSlot; i < endSlot; i++){
					const startTimeInMin = i * slotInterval;

					const slotStartTime = currentDay.clone().startOf("day").minutes(startTimeInMin);
					const slotEndTime = currentDay.clone().startOf("day").minutes(startTimeInMin + slotInterval);

					if(!notOverLappingWithAppointments(slotStartTime, slotEndTime, appointments)){
						slotCount = 0;
						continue;
					}

					slotCount++;

					if(slotCount < slotsForAppmt){
						continue;
					}

					if(lastAvailableSlot && (i - lastAvailableSlot) < slotsBetweenAppointments){
						continue;
					}

					lastAvailableSlot = i;

					availableSlotMap[currentDayName].push({
						start: slotEndTime.clone().subtract(appointmentDuration, "minutes"),
						end: slotEndTime
					});
				}
			}

			return availableSlotMap;
		}


		function buildCalendarFilter(calendars){
			if(!Array.isArray(calendars)){
				return;
			}

			var calendarFilter = '';

			calendars.forEach(function(calendar){
				if(!calendar){
					return;
				}

				const filterStr = GeneralTools.equalFilterBuilder(AppointmentConstants.keyNames.calendar, calendar.id_calendar);
				calendarFilter = GeneralTools.stringConnector(calendarFilter, filterStr, ToolsConstants.apiFilters.orConnector);
			});

			return calendarFilter;
		}

		function getPublicCalenders(){
			return AppointmentsService.getCachedCalendars({ companyID: companyID })
				.then(function(calendars){
					if(!Array.isArray(calendars)){
						return $q.reject("Calendar is invalid.");
					}

					const publicCalendars = calendars.filter(function(calendar){
						return calendar.is_public;
					});

					return $q.resolve(publicCalendars);
				})
		}

		function resetVehicleList(vehicles){
			vm.vehicles = vehicles;

			if(isSelectedCustomerChanged()){
				selectedCustomerCopy = angular.copy(vm.selectedCustomer);
				vm.selectedVehicle = null;
			}
		}

		function canDateBeSelect(date){
			if(!vm.availableSlots || vm.isBusy || vm.finishBooking){
				return false;
			}

			const dateName = moment(date).format("YYYY-MM-DD");

			return Array.isArray(vm.availableSlots[dateName]) && vm.availableSlots[dateName].length > 0;
		}

		function makeAppointment(){
			const defaultCalendar = getDefaultCalendar();

			if(!vm.selectedCustomer || !vm.selectedVehicle || !defaultCalendar || !vm.selectedTimeSlot){
				MessageService.showToast("Failed to make appointment, something wrong.");
				return;
			}

			var title = vm.selectedCustomer.getFullName() + "'s " + 
				vm.selectedVehicle.getYearMakeModel() + " " + 
				getAppointmentDescription() + 
				" (Appointment made by customer)";

			const requestBody = {
				start: vm.selectedTimeSlot.start.clone().utc().format(requestBodyTimeRangeFormat),
				end: vm.selectedTimeSlot.end.clone().utc().format(requestBodyTimeRangeFormat),
				title: title,
				calendarID: defaultCalendar.id_calendar,
				vehicleID: vm.selectedVehicle.getResourceID()  
			}

			ProgressService.addTaskToQueue();

			BookAppointmentService.customerBookAppointment(companyID, requestBody).$promise
				.then(function(){
					vm.finishBooking = true;
				})
				.catch(MessageService.showToast)
				.finally(ProgressService.removeTaskFromQueue);
		}

		function getAppointmentDescription(){
			if(!Array.isArray(vm.predefindAppointments)){
				return;
			}

			var description = '';

			vm.predefindAppointments.forEach(function(predefindAppointment){
				if(predefindAppointment && predefindAppointment.isSelected){
					description = GeneralTools.stringConnector(description, predefindAppointment.name, " / ");
				}
			})

			if(vm.isOtherServiceSelected && vm.otherServiceDetail){
				description = GeneralTools.stringConnector(description, vm.otherServiceDetail, " / ");
			}

			return description;
		}

		function beforeStepChange(currentIndex, indexToGo){
			if(currentIndex > indexToGo){
				vm.animteClass = ['slide-left-to-right'];
			} else {
				vm.animteClass = ['slide-right-to-left'];
			}
		}

		function selectTimeSlot(timeSlot){
			vm.selectedTimeSlot = timeSlot;
			nextStep();
		}

		function getDefaultCalendar(){
			if(Array.isArray(publicCalendarsCache)){
				return publicCalendarsCache[0];
			}
		}
	}
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsThemeOptionsController', MsThemeOptionsController)
        .directive('msThemeOptions', msThemeOptions);

    /** @ngInject */
    function MsThemeOptionsController($cookies, fuseTheming)
    {
        var vm = this;

        // Data
        vm.themes = fuseTheming.themes;

        vm.layoutModes = [
            {
                label: 'Boxed',
                value: 'boxed'
            },
            {
                label: 'Wide',
                value: 'wide'
            }
        ];
        vm.layoutStyles = [
            {
                label : 'Vertical Navigation',
                value : 'verticalNavigation',
                figure: '/assets/images/theme-options/vertical-nav.jpg'
            },
            {
                label : 'Vertical Navigation with Fullwidth Toolbar',
                value : 'verticalNavigationFullwidthToolbar',
                figure: '/assets/images/theme-options/vertical-nav-with-full-toolbar.jpg'
            },
            {
                label : 'Vertical Navigation with Fullwidth Toolbar 2',
                value : 'verticalNavigationFullwidthToolbar2',
                figure: '/assets/images/theme-options/vertical-nav-with-full-toolbar-2.jpg'
            },
            {
                label : 'Horizontal Navigation',
                value : 'horizontalNavigation',
                figure: '/assets/images/theme-options/horizontal-nav.jpg'
            },
            {
                label : 'Content with Toolbar',
                value : 'contentWithToolbar',
                figure: '/assets/images/theme-options/content-with-toolbar.jpg'
            },
            {
                label : 'Content Only',
                value : 'contentOnly',
                figure: '/assets/images/theme-options/content-only.jpg'
            },
        ];

        vm.layoutMode = 'wide';
        vm.layoutStyle = $cookies.get('layoutStyle') || 'verticalNavigation';

        // Methods
        vm.setActiveTheme = setActiveTheme;
        vm.getActiveTheme = getActiveTheme;
        vm.updateLayoutMode = updateLayoutMode;
        vm.updateLayoutStyle = updateLayoutStyle;

        //////////

        /**
         * Set active theme
         *
         * @param themeName
         */
        function setActiveTheme(themeName)
        {
            fuseTheming.setActiveTheme(themeName);
        }

        /**
         * Get active theme
         *
         * @returns {service.themes.active|{name, theme}}
         */
        function getActiveTheme()
        {
            return fuseTheming.themes.active;
        }

        /**
         * Update layout mode
         */
        function updateLayoutMode()
        {
            var bodyEl = angular.element('body');

            // Update class on body element
            bodyEl.toggleClass('boxed', (vm.layoutMode === 'boxed'));
        }

        /**
         * Update layout style
         */
        function updateLayoutStyle()
        {
            // Update the cookie
            $cookies.put('layoutStyle', vm.layoutStyle);

            // Reload the page to apply the changes
            location.reload();
        }
    }

    /** @ngInject */
    function msThemeOptions($mdSidenav)
    {
        return {
            restrict   : 'E',
            scope      : {},
            controller : 'MsThemeOptionsController as vm',
            templateUrl: 'app/core/theme-options/theme-options.html',
            compile    : function (tElement)
            {
                tElement.addClass('ms-theme-options');

                return function postLink(scope)
                {
                    /**
                     * Toggle options sidenav
                     */
                    function toggleOptionsSidenav()
                    {
                        // Toggle the fuse theme options panel
                        $mdSidenav('fuse-theme-options').toggle();
                    }

                    // Expose the toggle function
                    scope.toggleOptionsSidenav = toggleOptionsSidenav;
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .service('fuseTheming', fuseThemingService);

    /** @ngInject */
    function fuseThemingService($cookies, $log, $mdTheming)
    {
        var service = {
            getRegisteredPalettes: getRegisteredPalettes,
            getRegisteredThemes  : getRegisteredThemes,
            setActiveTheme       : setActiveTheme,
            setThemesList        : setThemesList,
            themes               : {
                list  : {},
                active: {
                    'name' : '',
                    'theme': {}
                }
            }
        };

        return service;

        //////////

        /**
         * Get registered palettes
         *
         * @returns {*}
         */
        function getRegisteredPalettes()
        {
            return $mdTheming.PALETTES;
        }

        /**
         * Get registered themes
         *
         * @returns {*}
         */
        function getRegisteredThemes()
        {
            return $mdTheming.THEMES;
        }

        /**
         * Set active theme
         *
         * @param themeName
         */
        function setActiveTheme(themeName)
        {
            // If theme does not exist, fallback to the default theme
            if ( angular.isUndefined(service.themes.list[themeName]) )
            {
                // If there is no theme called "default"...
                if ( angular.isUndefined(service.themes.list.default) )
                {
                    $log.error('You must have at least one theme named "default"');
                    return;
                }

                $log.warn('The theme "' + themeName + '" does not exist! Falling back to the "default" theme.');

                // Otherwise set theme to default theme
                service.themes.active.name = 'default';
                service.themes.active.theme = service.themes.list.default;
                $cookies.put('selectedTheme', service.themes.active.name);

                return;
            }

            service.themes.active.name = themeName;
            service.themes.active.theme = service.themes.list[themeName];
            $cookies.put('selectedTheme', themeName);
        }

        /**
         * Set available themes list
         *
         * @param themeList
         */
        function setThemesList(themeList)
        {
            service.themes.list = themeList;
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .config(config);

    /** @ngInject */
    function config($mdThemingProvider, fusePalettes, fuseThemes)
    {
        // Inject Cookies Service
        var $cookies;
        angular.injector(['ngCookies']).invoke([
            '$cookies', function (_$cookies)
            {
                $cookies = _$cookies;
            }
        ]);

        // Check if custom theme exist in cookies
        var customTheme = $cookies.getObject('customTheme');
        if ( customTheme )
        {
            fuseThemes['custom'] = customTheme;
        }

        $mdThemingProvider.alwaysWatchTheme(true);

        // Define custom palettes
        angular.forEach(fusePalettes, function (palette)
        {
            $mdThemingProvider.definePalette(palette.name, palette.options);
        });

        // Register custom themes
        angular.forEach(fuseThemes, function (theme, themeName)
        {
            $mdThemingProvider.theme(themeName)
                .primaryPalette(theme.primary.name, theme.primary.hues)
                .accentPalette(theme.accent.name, theme.accent.hues)
                .warnPalette(theme.warn.name, theme.warn.hues)
                .backgroundPalette(theme.background.name, theme.background.hues);
        });
    }

})();
(function ()
{
    'use strict';

    var fuseThemes = {
        default  : {
            primary   : {
                name: 'fuse-paleblue',
                hues: {
                    'default': '700',
                    'hue-1'  : '500',
                    'hue-2'  : '600',
                    'hue-3'  : '400'
                }
            },
            accent    : {
                name: 'light-blue',
                hues: {
                    'default': '600',
                    'hue-1'  : '400',
                    'hue-2'  : '700',
                    'hue-3'  : 'A100'
                }
            },
            warn      : {
                name: 'red'
            },
            background: {
                name: 'grey',
                hues: {
                    'default': 'A100',
                    'hue-1'  : 'A100',
                    'hue-2'  : '100',
                    'hue-3'  : '300'
                }
            }
        },
        'pinkTheme': {
            primary   : {
                name: 'blue-grey',
                hues: {
                    'default': '800',
                    'hue-1'  : '600',
                    'hue-2'  : '400',
                    'hue-3'  : 'A100'
                }
            },
            accent    : {
                name: 'pink',
                hues: {
                    'default': '400',
                    'hue-1'  : '300',
                    'hue-2'  : '600',
                    'hue-3'  : 'A100'
                }
            },
            warn      : {
                name: 'blue'
            },
            background: {
                name: 'grey',
                hues: {
                    'default': 'A100',
                    'hue-1'  : 'A100',
                    'hue-2'  : '100',
                    'hue-3'  : '300'
                }
            }
        },
        'tealTheme': {
            primary   : {
                name: 'fuse-blue',
                hues: {
                    'default': '900',
                    'hue-1'  : '600',
                    'hue-2'  : '500',
                    'hue-3'  : 'A100'
                }
            },
            accent    : {
                name: 'teal',
                hues: {
                    'default': '500',
                    'hue-1'  : '400',
                    'hue-2'  : '600',
                    'hue-3'  : 'A100'
                }
            },
            warn      : {
                name: 'deep-orange'
            },
            background: {
                name: 'grey',
                hues: {
                    'default': 'A100',
                    'hue-1'  : 'A100',
                    'hue-2'  : '100',
                    'hue-3'  : '300'
                }
            }
        }
    };

    angular
        .module('app.core')
        .constant('fuseThemes', fuseThemes);
})();
(function () {
    'use strict';

    var fusePalettes = [
        {
            name: 'fuse-blue',
            options: {
                '50': '#ebf1fa',
                '100': '#c2d4ef',
                '200': '#9ab8e5',
                '300': '#78a0dc',
                '400': '#5688d3',
                '500': '#3470ca',
                '600': '#2e62b1',
                '700': '#275498',
                '800': '#21467e',
                '900': '#1a3865',
                'A100': '#c2d4ef',
                'A200': '#9ab8e5',
                'A400': '#5688d3',
                'A700': '#275498',
                'contrastDefaultColor': 'light',
                'contrastDarkColors': '50 100 200 A100',
                'contrastStrongLightColors': '300 400'
            }
        },
        {
            name: 'fuse-paleblue',
            options: {
                '50': '#ececee',
                '100': '#c5c6cb',
                '200': '#9ea1a9',
                '300': '#7d818c',
                '400': '#5c616f',
                '500': '#3c4252',
                '600': '#353a48',
                '700': '#2d323e',
                '800': '#262933',
                '900': '#1e2129',
                'A100': '#c5c6cb',
                'A200': '#9ea1a9',
                'A400': '#5c616f',
                'A700': '#2d323e',
                'contrastDefaultColor': 'light',
                'contrastDarkColors': '50 100 200 A100',
                'contrastStrongLightColors': '300 400'
            }
        }
    ];

    angular
        .module('app.core')
        .constant('fusePalettes', fusePalettes);
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('fuseGenerator', fuseGeneratorService);

    /** @ngInject */
    function fuseGeneratorService($cookies, $log, fuseTheming)
    {
        // Storage for simplified themes object
        var themes = {};

        var service = {
            generate: generate,
            rgba    : rgba
        };

        return service;

        //////////

        /**
         * Generate less variables for each theme from theme's
         * palette by using material color naming conventions
         */
        function generate()
        {
            // Get registered themes and palettes and copy
            // them so we don't modify the original objects
            var registeredThemes = angular.copy(fuseTheming.getRegisteredThemes());
            var registeredPalettes = angular.copy(fuseTheming.getRegisteredPalettes());

            // First, create a simplified object that stores
            // all registered themes and their colors

            // Iterate through registered themes
            angular.forEach(registeredThemes, function (registeredTheme)
            {
                themes[registeredTheme.name] = {};

                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(registeredTheme.colors, function (colorType, colorTypeName)
                {
                    themes[registeredTheme.name][colorTypeName] = {
                        'name'  : colorType.name,
                        'levels': {
                            'default': {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues.default].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 4)
                            },
                            'hue1'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 4)
                            },
                            'hue2'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 4)
                            },
                            'hue3'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 4)
                            }
                        }
                    };
                });
            });

            // Process themes one more time and then store them in the service for external use
            processAndStoreThemes(themes);

            // Iterate through simplified themes
            // object and create style variables
            var styleVars = {};

            // Iterate through registered themes
            angular.forEach(themes, function (theme, themeName)
            {
                styleVars = {};
                styleVars['@themeName'] = themeName;

                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(theme, function (colorTypes, colorTypeName)
                {
                    // Iterate through color levels (default, hue1, hue2 & hue3)
                    angular.forEach(colorTypes.levels, function (colors, colorLevelName)
                    {
                        // Iterate through color name (color, contrast1, contrast2, contrast3 & contrast4)
                        angular.forEach(colors, function (color, colorName)
                        {
                            styleVars['@' + colorTypeName + ucfirst(colorLevelName) + ucfirst(colorName)] = color;
                        });
                    });
                });

                // Render styles
                render(styleVars);
            });
        }

        // ---------------------------
        //  INTERNAL HELPER FUNCTIONS
        // ---------------------------

        /**
         * Process and store themes for global use
         *
         * @param _themes
         */
        function processAndStoreThemes(_themes)
        {
            // Here we will go through every registered theme one more time
            // and try to simplify their objects as much as possible for
            // easier access to their properties.
            var themes = angular.copy(_themes);

            // Iterate through themes
            angular.forEach(themes, function (theme)
            {
                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(theme, function (colorType, colorTypeName)
                {
                    theme[colorTypeName] = colorType.levels;
                    theme[colorTypeName].color = colorType.levels.default.color;
                    theme[colorTypeName].contrast1 = colorType.levels.default.contrast1;
                    theme[colorTypeName].contrast2 = colorType.levels.default.contrast2;
                    theme[colorTypeName].contrast3 = colorType.levels.default.contrast3;
                    theme[colorTypeName].contrast4 = colorType.levels.default.contrast4;
                    delete theme[colorTypeName].default;
                });
            });

            // Store themes and set selected theme for the first time
            fuseTheming.setThemesList(themes);

            // Remember selected theme.
            var selectedTheme = $cookies.get('selectedTheme');

            if ( selectedTheme )
            {
                fuseTheming.setActiveTheme(selectedTheme);
            }
            else
            {
                fuseTheming.setActiveTheme('default');
            }
        }


        /**
         * Render css files
         *
         * @param styleVars
         */
        function render(styleVars)
        {
            var cssTemplate = '/* Content hack because they wont fix */\n/* https://github.com/angular/material/pull/8067 */\n[md-theme="@themeName"] md-content.md-hue-1,\nmd-content.md-@themeName-theme.md-hue-1 {\n    color: @backgroundHue1Contrast1;\n    background-color: @backgroundHue1Color;\n}\n\n[md-theme="@themeName"] md-content.md-hue-2,\nmd-content.md-@themeName-theme.md-hue-2 {\n    color: @backgroundHue2Contrast1;\n    background-color: @backgroundHue2Color;\n}\n\n[md-theme="@themeName"] md-content.md-hue-3,\n md-content.md-@themeName-theme.md-hue-3 {\n    color: @backgroundHue3Contrast1;\n    background-color: @backgroundHue3Color;\n}\n\n/* Text Colors */\n[md-theme="@themeName"] a {\n    color: @accentDefaultColor;\n}\n\n[md-theme="@themeName"] .secondary-text,\n[md-theme="@themeName"] .icon {\n    color: @backgroundDefaultContrast2;\n}\n\n[md-theme="@themeName"] .hint-text,\n[md-theme="@themeName"] .disabled-text {\n    color: @backgroundDefaultContrast3;\n}\n\n[md-theme="@themeName"] .fade-text,\n[md-theme="@themeName"] .divider {\n    color: @backgroundDefaultContrast4;\n}\n\n/* Primary */\n[md-theme="@themeName"] .md-primary-bg {\n    background-color: @primaryDefaultColor;\n    color: @primaryDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg .secondary-text,\n[md-theme="@themeName"] .md-primary-bg .icon {\n    color: @primaryDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg .hint-text,\n[md-theme="@themeName"] .md-primary-bg .disabled-text {\n    color: @primaryDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg .fade-text,\n[md-theme="@themeName"] .md-primary-bg .divider {\n    color: @primaryDefaultContrast4;\n}\n\n/* Primary, Hue-1 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 {\n    background-color: @primaryHue1Color;\n    color: @primaryHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .icon {\n    color: @primaryHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .disabled-text {\n    color: @primaryHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .divider {\n    color: @primaryHue1Contrast4;\n}\n\n/* Primary, Hue-2 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 {\n    background-color: @primaryHue2Color;\n    color: @primaryHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .icon {\n    color: @primaryHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .disabled-text {\n    color: @primaryHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .divider {\n    color: @primaryHue2Contrast4;\n}\n\n/* Primary, Hue-3 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 {\n    background-color: @primaryHue3Color;\n    color: @primaryHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .icon {\n    color: @primaryHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .disabled-text {\n    color: @primaryHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .divider {\n    color: @primaryHue3Contrast4;\n}\n\n/* Primary foreground */\n[md-theme="@themeName"] .md-primary-fg {\n    color: @primaryDefaultColor !important;\n}\n\n/* Primary foreground, Hue-1 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-1 {\n    color: @primaryHue1Color !important;\n}\n\n/* Primary foreground, Hue-2 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-2 {\n    color: @primaryHue2Color !important;\n}\n\n/* Primary foreground, Hue-3 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-3 {\n    color: @primaryHue3Color !important;\n}\n\n/* Accent */\n[md-theme="@themeName"] .md-accent-bg {\n    background-color: @accentDefaultColor;\n    color: @accentDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg .secondary-text,\n[md-theme="@themeName"] .md-accent-bg .icon {\n    color: @accentDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg .hint-text,\n[md-theme="@themeName"] .md-accent-bg .disabled-text {\n    color: @accentDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg .fade-text,\n[md-theme="@themeName"] .md-accent-bg .divider {\n    color: @accentDefaultContrast4;\n}\n\n/* Accent, Hue-1 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 {\n    background-color: @accentHue1Color;\n    color: @accentHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .icon {\n    color: @accentHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .disabled-text {\n    color: @accentHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .divider {\n    color: @accentHue1Contrast4;\n}\n\n/* Accent, Hue-2 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 {\n    background-color: @accentHue2Color;\n    color: @accentHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .icon {\n    color: @accentHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .disabled-text {\n    color: @accentHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .divider {\n    color: @accentHue2Contrast4;\n}\n\n/* Accent, Hue-3 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 {\n    background-color: @accentHue3Color;\n    color: @accentHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .icon {\n    color: @accentHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .disabled-text {\n    color: @accentHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .divider {\n    color: @accentHue3Contrast4;\n}\n\n/* Accent foreground */\n[md-theme="@themeName"] .md-accent-fg {\n    color: @accentDefaultColor !important;\n}\n\n/* Accent foreground, Hue-1 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-1 {\n    color: @accentHue1Color !important;\n}\n\n/* Accent foreground, Hue-2 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-2 {\n    color: @accentHue2Color !important;\n}\n\n/* Accent foreground, Hue-3 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-3 {\n    color: @accentHue3Color !important;\n}\n\n/* Warn */\n[md-theme="@themeName"] .md-warn-bg {\n    background-color: @warnDefaultColor;\n    color: @warnDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg .secondary-text,\n[md-theme="@themeName"] .md-warn-bg .icon {\n    color: @warnDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg .hint-text,\n[md-theme="@themeName"] .md-warn-bg .disabled-text {\n    color: @warnDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg .fade-text,\n[md-theme="@themeName"] .md-warn-bg .divider {\n    color: @warnDefaultContrast4;\n}\n\n/* Warn, Hue-1 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 {\n    background-color: @warnHue1Color;\n    color: @warnHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .icon {\n    color: @warnHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .disabled-text {\n    color: @warnHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .divider {\n    color: @warnHue1Contrast4;\n}\n\n/* Warn, Hue-2 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 {\n    background-color: @warnHue2Color;\n    color: @warnHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .icon {\n    color: @warnHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .disabled-text {\n    color: @warnHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .divider {\n    color: @warnHue2Contrast4;\n}\n\n/* Warn, Hue-3 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 {\n    background-color: @warnHue3Color;\n    color: @warnHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .icon {\n    color: @warnHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .disabled-text {\n    color: @warnHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .divider {\n    color: @warnHue3Contrast4;\n}\n\n/* Warn foreground */\n[md-theme="@themeName"] .md-warn-fg {\n    color: @warnDefaultColor !important;\n}\n\n/* Warn foreground, Hue-1 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-1 {\n    color: @warnHue1Color !important;\n}\n\n/* Warn foreground, Hue-2 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-2 {\n    color: @warnHue2Color !important;\n}\n\n/* Warn foreground, Hue-3 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-3 {\n    color: @warnHue3Color !important;\n}\n\n/* Background */\n[md-theme="@themeName"] .md-background-bg {\n    background-color: @backgroundDefaultColor;\n    color: @backgroundDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg .secondary-text,\n[md-theme="@themeName"] .md-background-bg .icon {\n    color: @backgroundDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg .hint-text,\n[md-theme="@themeName"] .md-background-bg .disabled-text {\n    color: @backgroundDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg .fade-text,\n[md-theme="@themeName"] .md-background-bg .divider {\n    color: @backgroundDefaultContrast4;\n}\n\n/* Background, Hue-1 */\n[md-theme="@themeName"] .md-background-bg.md-hue-1 {\n    background-color: @backgroundHue1Color;\n    color: @backgroundHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .icon {\n    color: @backgroundHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .disabled-text {\n    color: @backgroundHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .divider {\n    color: @backgroundHue1Contrast4;\n}\n\n/* Background, Hue-2 */\n[md-theme="@themeName"] .md-background-bg.md-hue-2 {\n    background-color: @backgroundHue2Color;\n    color: @backgroundHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .icon {\n    color: @backgroundHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .disabled-text {\n    color: @backgroundHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .divider {\n    color: @backgroundHue2Contrast4;\n}\n\n/* Background, Hue-3 */\n[md-theme="@themeName"] .md-background-bg.md-hue-3 {\n    background-color: @backgroundHue3Color;\n    color: @backgroundHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .icon {\n    color: @backgroundHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .disabled-text {\n    color: @backgroundHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .divider {\n    color: @backgroundHue3Contrast4;\n}\n\n/* Background foreground */\n[md-theme="@themeName"] .md-background-fg {\n    color: @backgroundDefaultColor !important;\n}\n\n/* Background foreground, Hue-1 */\n[md-theme="@themeName"] .md-background-fg.md-hue-1 {\n    color: @backgroundHue1Color !important;\n}\n\n/* Background foreground, Hue-2 */\n[md-theme="@themeName"] .md-background-fg.md-hue-2 {\n    color: @backgroundHue2Color !important;\n}\n\n/* Background foreground, Hue-3 */\n[md-theme="@themeName"] .md-background-fg.md-hue-3 {\n    color: @backgroundHue3Color !important;\n}';

            var regex = new RegExp(Object.keys(styleVars).join('|'), 'gi');
            var css = cssTemplate.replace(regex, function (matched)
            {
                return styleVars[matched];
            });

            var headEl = angular.element('head');
            var styleEl = angular.element('<style type="text/css"></style>');
            styleEl.html(css);
            headEl.append(styleEl);
        }

        /**
         * Convert color array to rgb/rgba
         * Also apply contrasts if needed
         *
         * @param color
         * @param _contrastLevel
         * @returns {string}
         */
        function rgba(color, _contrastLevel)
        {
            var contrastLevel = _contrastLevel || false;

            // Convert 255,255,255,0.XX to 255,255,255
            // According to Google's Material design specs, white primary
            // text must have opacity of 1 and we will fix that here
            // because Angular Material doesn't care about that spec
            if ( color.length === 4 && color[0] === 255 && color[1] === 255 && color[2] === 255 )
            {
                color.splice(3, 4);
            }

            // If contrast level provided, apply it to the current color
            if ( contrastLevel )
            {
                color = applyContrast(color, contrastLevel);
            }

            // Convert color array to color string (rgb/rgba)
            if ( color.length === 3 )
            {
                return 'rgb(' + color.join(',') + ')';
            }
            else if ( color.length === 4 )
            {
                return 'rgba(' + color.join(',') + ')';
            }
            else
            {
                $log.error('Invalid number of arguments supplied in the color array: ' + color.length + '\n' + 'The array must have 3 or 4 colors.');
            }
        }

        /**
         * Apply given contrast level to the given color
         *
         * @param color
         * @param contrastLevel
         */
        function applyContrast(color, contrastLevel)
        {
            var contrastLevels = {
                'white': {
                    '1': '1',
                    '2': '0.7',
                    '3': '0.3',
                    '4': '0.12'
                },
                'black': {
                    '1': '0.87',
                    '2': '0.54',
                    '3': '0.26',
                    '4': '0.12'
                }
            };

            // If white
            if ( color[0] === 255 && color[1] === 255 && color[2] === 255 )
            {
                color[3] = contrastLevels.white[contrastLevel];
            }
            // If black
            else if ( color[0] === 0 && color[1] === 0 && color[2] === 0 )
            {
                color[3] = contrastLevels.black[contrastLevel];
            }

            return color;
        }

        /**
         * Uppercase first
         */
        function ucfirst(string)
        {
            return string.charAt(0).toUpperCase() + string.slice(1);
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('msUtils', msUtils);

    /** @ngInject */
    function msUtils($window)
    {
        // Private variables
        var mobileDetect = new MobileDetect($window.navigator.userAgent),
            browserInfo = null;

        var service = {
            exists       : exists,
            detectBrowser: detectBrowser,
            guidGenerator: guidGenerator,
            isMobile     : isMobile,
            toggleInArray: toggleInArray
        };

        return service;

        //////////

        /**
         * Check if item exists in a list
         *
         * @param item
         * @param list
         * @returns {boolean}
         */
        function exists(item, list)
        {
            return list.indexOf(item) > -1;
        }

        /**
         * Returns browser information
         * from user agent data
         *
         * Found at http://www.quirksmode.org/js/detect.html
         * but modified and updated to fit for our needs
         */
        function detectBrowser()
        {
            // If we already tested, do not test again
            if ( browserInfo )
            {
                return browserInfo;
            }

            var browserData = [
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Edge',
                    versionSearch: 'Edge',
                    identity     : 'Edge'
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: 'Chrome',
                    identity : 'Chrome'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'OmniWeb',
                    versionSearch: 'OmniWeb/',
                    identity     : 'OmniWeb'
                },
                {
                    string       : $window.navigator.vendor,
                    subString    : 'Apple',
                    versionSearch: 'Version',
                    identity     : 'Safari'
                },
                {
                    prop    : $window.opera,
                    identity: 'Opera'
                },
                {
                    string   : $window.navigator.vendor,
                    subString: 'iCab',
                    identity : 'iCab'
                },
                {
                    string   : $window.navigator.vendor,
                    subString: 'KDE',
                    identity : 'Konqueror'
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: 'Firefox',
                    identity : 'Firefox'
                },
                {
                    string   : $window.navigator.vendor,
                    subString: 'Camino',
                    identity : 'Camino'
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: 'Netscape',
                    identity : 'Netscape'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'MSIE',
                    identity     : 'Explorer',
                    versionSearch: 'MSIE'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Trident/7',
                    identity     : 'Explorer',
                    versionSearch: 'rv'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Gecko',
                    identity     : 'Mozilla',
                    versionSearch: 'rv'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Mozilla',
                    identity     : 'Netscape',
                    versionSearch: 'Mozilla'
                }
            ];

            var osData = [
                {
                    string   : $window.navigator.platform,
                    subString: 'Win',
                    identity : 'Windows'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'Mac',
                    identity : 'Mac'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'Linux',
                    identity : 'Linux'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'iPhone',
                    identity : 'iPhone'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'iPod',
                    identity : 'iPod'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'iPad',
                    identity : 'iPad'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'Android',
                    identity : 'Android'
                }
            ];

            var versionSearchString = '';

            function searchString(data)
            {
                for ( var i = 0; i < data.length; i++ )
                {
                    var dataString = data[i].string;
                    var dataProp = data[i].prop;

                    versionSearchString = data[i].versionSearch || data[i].identity;

                    if ( dataString )
                    {
                        if ( dataString.indexOf(data[i].subString) !== -1 )
                        {
                            return data[i].identity;

                        }
                    }
                    else if ( dataProp )
                    {
                        return data[i].identity;
                    }
                }
            }

            function searchVersion(dataString)
            {
                var index = dataString.indexOf(versionSearchString);

                if ( index === -1 )
                {
                    return;
                }

                return parseInt(dataString.substring(index + versionSearchString.length + 1));
            }

            var browser = searchString(browserData) || 'unknown-browser';
            var version = searchVersion($window.navigator.userAgent) || searchVersion($window.navigator.appVersion) || 'unknown-version';
            var os = searchString(osData) || 'unknown-os';

            // Prepare and store the object
            browser = browser.toLowerCase();
            version = browser + '-' + version;
            os = os.toLowerCase();

            browserInfo = {
                browser: browser,
                version: version,
                os     : os
            };

            return browserInfo;
        }

        /**
         * Generates a globally unique id
         *
         * @returns {*}
         */
        function guidGenerator()
        {
            var S4 = function ()
            {
                return (((1 + Math.random()) * 0x10000) || 0).toString(16).substring(1);
            };
            return (S4() + S4() + S4() + S4() + S4() + S4());
        }

        /**
         * Return if current device is a
         * mobile device or not
         */
        function isMobile()
        {
            return mobileDetect.mobile();
        }

        /**
         * Toggle in array (push or splice)
         *
         * @param item
         * @param array
         */
        function toggleInArray(item, array)
        {
            if ( array.indexOf(item) === -1 )
            {
                array.push(item);
            }
            else
            {
                array.splice(array.indexOf(item), 1);
            }
        }
    }
}());
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msApi', msApiProvider);

    /** @ngInject **/
    function msApiProvider()
    {
        /* ----------------- */
        /* Provider          */
        /* ----------------- */
        var provider = this;

        // Inject the $log service
        var $log = angular.injector(['ng']).get('$log');

        // Data
        var baseUrl = '';
        var api = [];

        // Methods
        provider.setBaseUrl = setBaseUrl;
        provider.getBaseUrl = getBaseUrl;
        provider.getApiObject = getApiObject;
        provider.register = register;

        //////////

        /**
         * Set base url for API endpoints
         *
         * @param url {string}
         */
        function setBaseUrl(url)
        {
            baseUrl = url;
        }

        /**
         * Return the base url
         *
         * @returns {string}
         */
        function getBaseUrl()
        {
            return baseUrl;
        }

        /**
         * Return the api object
         *
         * @returns {object}
         */
        function getApiObject()
        {
            return api;
        }

        /**
         * Register API endpoint
         *
         * @param key
         * @param resource
         */
        function register(key, resource)
        {
            if ( !angular.isString(key) )
            {
                $log.error('"path" must be a string (eg. `dashboard.project`)');
                return;
            }

            if ( !angular.isArray(resource) )
            {
                $log.error('"resource" must be an array and it must follow $resource definition');
                return;
            }

            // Store the API object
            api[key] = {
                url          : baseUrl + (resource[0] || ''),
                paramDefaults: resource[1] || [],
                actions      : resource[2] || [],
                options      : resource[3] || {}
            };
        }

        /* ----------------- */
        /* Service           */
        /* ----------------- */
        this.$get = function ($log, $q, $resource, $rootScope)
        {
            // Data

            // Methods
            var service = {
                setBaseUrl: setBaseUrl,
                getBaseUrl: getBaseUrl,
                register  : register,
                resolve   : resolve,
                request   : request
            };

            return service;

            //////////

            /**
             * Resolve an API endpoint
             *
             * @param action {string}
             * @param parameters {object}
             * @returns {promise|boolean}
             */
            function resolve(action, parameters)
            {
                // Emit an event
                $rootScope.$broadcast('msApi::resolveStart');
                
                var actionParts = action.split('@'),
                    resource = actionParts[0],
                    method = actionParts[1],
                    params = parameters || {};

                if ( !resource || !method )
                {
                    $log.error('msApi.resolve requires correct action parameter (resourceName@methodName)');
                    return false;
                }

                // Create a new deferred object
                var deferred = $q.defer();

                // Get the correct resource definition from api object
                var apiObject = api[resource];

                

                if ( !apiObject )
                {
                    $log.error('Resource "' + resource + '" is not defined in the api service!');
                    deferred.reject('Resource "' + resource + '" is not defined in the api service!');
                }
                else
                {
                    // Generate the $resource object based on the stored API object
                    var resourceObject = $resource(apiObject.url, apiObject.paramDefaults, apiObject.actions, apiObject.options);

                    // Make the call...
                    resourceObject[method](params,

                        // Success
                        function (response)
                        {
                            deferred.resolve(response);

                            // Emit an event
                            $rootScope.$broadcast('msApi::resolveSuccess');
                        },

                        // Error
                        function (response)
                        {
                            deferred.reject(response);

                            // Emit an event
                            $rootScope.$broadcast('msApi::resolveError');
                        }
                    );
                }

                // Return the promise
                return deferred.promise;
            }

            /**
             * Make a request to an API endpoint
             *
             * @param action {string}
             * @param [parameters] {object}
             * @param [success] {function}
             * @param [error] {function}
             *
             * @returns {promise|boolean}
             */
            function request(action, parameters, success, error)
            {
                // Emit an event
                $rootScope.$broadcast('msApi::requestStart');
                
                var actionParts = action.split('@'),
                    resource = actionParts[0],
                    method = actionParts[1],
                    params = parameters || {};

                if ( !resource || !method )
                {
                    $log.error('msApi.resolve requires correct action parameter (resourceName@methodName)');
                    return false;
                }

                // Create a new deferred object
                var deferred = $q.defer();

                // Get the correct resource definition from api object
                var apiObject = api[resource];

                if ( !apiObject )
                {
                    $log.error('Resource "' + resource + '" is not defined in the api service!');
                    deferred.reject('Resource "' + resource + '" is not defined in the api service!');
                }
                else
                {
                    // Generate the $resource object based on the stored API object
                    var resourceObject = $resource(apiObject.url, apiObject.paramDefaults, apiObject.actions, apiObject.options);

                    // Make the call...
                    resourceObject[method](params,

                        // SUCCESS
                        function (response)
                        {
                            // Emit an event
                            $rootScope.$broadcast('msApi::requestSuccess');
                            
                            // Resolve the promise
                            deferred.resolve(response);

                            // Call the success function if there is one
                            if ( angular.isDefined(success) && angular.isFunction(success) )
                            {
                                success(response);
                            }
                        },

                        // ERROR
                        function (response)
                        {
                            // Emit an event
                            $rootScope.$broadcast('msApi::requestError');
                            
                            // Reject the promise
                            deferred.reject(response);

                            // Call the error function if there is one
                            if ( angular.isDefined(error) && angular.isFunction(error) )
                            {
                                error(response);
                            }
                        }
                    );
                }

                // Return the promise
                return deferred.promise;
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('apiResolver', apiResolverService);

    /** @ngInject */
    function apiResolverService($q, $log, api, Const, ToolsFactory)
    {
        var service = {
            resolve: resolve
        };

        return service;

        //////////
        /**
         * Resolve api
         * @param action
         * @param parameters
         */
        function resolve(action, parameters)
        {
            var actionParts = action.split('@'),
                resource = actionParts[0],
                method = actionParts[1],
                params = parameters || {};

            if ( !resource || !method )
            {
                $log.error('apiResolver.resolve requires correct action parameter (ResourceName@methodName)');
                return false;
            }

            // Create a new deferred object
            var deferred = $q.defer();


            //api.updateToken();

            // Get the correct api object from api service
            var apiObject = getApiObject(resource);



            if ( !apiObject )
            {
                $log.error('Resource "' + resource + '" is not defined in the api service!');
                deferred.reject('Resource "' + resource + '" is not defined in the api service!');
            }
            else
            {

                apiObject[method](params,

                    // Success
                    function (response, header)
                    {   
                        var codeKey = Const.header.code;
                        var messageKey = Const.header.message;
                        var successCode = Const.code.success;
                        var statusCode  = header(codeKey);
                        var message  = header(messageKey);

                        if(statusCode != null && statusCode != successCode){
                            ToolsFactory.errorHandler(header);
                            location.href = '/';
                            return;
                        }
                        deferred.resolve(response);
                    },

                    // Error
                    function (response)
                    {	
                        deferred.reject(response);
                        location.href = '/';
                    }
                );
            }
            // Return the promise
            return deferred.promise;
        }

        /**
         * Get correct api object
         *
         * @param resource
         * @returns {*}
         */
        function getApiObject(resource)
        {
            // Split the resource in case if we have a dot notated object
            var resourceParts = resource.split('.'),
                apiObject = api;

            // Loop through the resource parts and go all the way through
            // the api object and return the correct one
            for ( var l = 0; l < resourceParts.length; l++ )
            {
                if ( angular.isUndefined(apiObject[resourceParts[l]]) )
                {
                    $log.error('Resource part "' + resourceParts[l] + '" is not defined!');
                    apiObject = false;
                    break;
                }

                apiObject = apiObject[resourceParts[l]];
            }

            if ( !apiObject )
            {
                return false;
            }


            return apiObject;
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('filterByTags', filterByTags)
        .filter('filterSingleByTags', filterSingleByTags);

    /** @ngInject */
    function filterByTags()
    {
        return function (items, tags)
        {
            if ( items.length === 0 || tags.length === 0 )
            {
                return items;
            }

            var filtered = [];

            items.forEach(function (item)
            {
                var match = tags.every(function (tag)
                {
                    var tagExists = false;

                    item.tags.forEach(function (itemTag)
                    {
                        if ( itemTag.name === tag.name )
                        {
                            tagExists = true;
                            return;
                        }
                    });

                    return tagExists;
                });

                if ( match )
                {
                    filtered.push(item);
                }
            });

            return filtered;
        };
    }

    /** @ngInject */
    function filterSingleByTags()
    {
        return function (itemTags, tags)
        {
            if ( itemTags.length === 0 || tags.length === 0 )
            {
                return;
            }

            if ( itemTags.length < tags.length )
            {
                return [];
            }

            var filtered = [];

            var match = tags.every(function (tag)
            {
                var tagExists = false;

                itemTags.forEach(function (itemTag)
                {
                    if ( itemTag.name === tag.name )
                    {
                        tagExists = true;
                        return;
                    }
                });

                return tagExists;
            });

            if ( match )
            {
                filtered.push(itemTags);
            }

            return filtered;
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('filterByPropIds', filterByPropIds);

    /** @ngInject */
    function filterByPropIds()
    {
        return function (items, parameter, ids)
        {
            if ( items.length === 0 || !ids || ids.length === 0 )
            {
                return items;
            }

            var filtered = [];

            for ( var i = 0; i < items.length; i++ )
            {
                var item = items[i];
                var match = false;

                for ( var j = 0; j < ids.length; j++ )
                {
                    var id = ids[j];
                    if ( item[parameter].indexOf(id) > -1 )
                    {
                        match = true;
                        break;
                    }
                }

                if ( match )
                {
                    filtered.push(item);
                }

            }

            return filtered;

        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('filterByIds', filterByIds);

    /** @ngInject */
    function filterByIds()
    {
        return function (items, ids)
        {

            if ( items.length === 0 || !ids )
            {
                return items;
            }

            if ( ids.length === 0 )
            {
                return [];
            }

            var filtered = [];

            for ( var i = 0; i < items.length; i++ )
            {
                var item = items[i];
                var match = false;

                for ( var j = 0; j < ids.length; j++ )
                {
                    var id = ids[j];
                    if ( item.id === id )
                    {
                        match = true;
                        break;
                    }
                }

                if ( match )
                {
                    filtered.push(item);
                }

            }

            return filtered;

        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('toTrusted', toTrustedFilter)
        .filter('htmlToPlaintext', htmlToPlainTextFilter)
        .filter('nospace', nospaceFilter)
        .filter('humanizeDoc', humanizeDocFilter);

    /** @ngInject */
    function toTrustedFilter($sce)
    {
        return function (value)
        {
            return $sce.trustAsHtml(value);
        };
    }

    /** @ngInject */
    function htmlToPlainTextFilter()
    {
        return function (text)
        {
            return String(text).replace(/<[^>]+>/gm, '');
        };
    }

    /** @ngInject */
    function nospaceFilter()
    {
        return function (value)
        {
            return (!value) ? '' : value.replace(/ /g, '');
        };
    }

    /** @ngInject */
    function humanizeDocFilter()
    {
        return function (doc)
        {
            if ( !doc )
            {
                return;
            }
            if ( doc.type === 'directive' )
            {
                return doc.name.replace(/([A-Z])/g, function ($1)
                {
                    return '-' + $1.toLowerCase();
                });
            }
            return doc.label || doc.name;
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('altDate', altDate);

    /** @ngInject */
    function altDate()
    {
        return function (value)
        {
            var diff = Date.now() - new Date(value);

            /**
             * If in a hour
             * e.g. "2 minutes ago"
             */
            if ( diff < (60 * 60 * 1000) )
            {
                return moment(value).fromNow();
            }
            /*
             * If in the day
             * e.g. "11:23"
             */
            else if ( diff < (60 * 60 * 24 * 1000) )
            {
                return moment(value).format('HH:mm');
            }
            /*
             * If in week
             * e.g "Tuesday"
             */
            else if ( diff < (60 * 60 * 24 * 7 * 1000) )
            {
                return moment(value).format('dddd');
            }
            /*
             * If more than a week
             * e.g. 03/29/2016
             */
            else
            {
                return moment(value).calendar();
            }

        };
    }

})();
(function () {
    'use strict';

    angular
        .module('app.core')
        .directive('hljs', hljsDirective);

    /** @ngInject */
    function hljsDirective($timeout, $q, $interpolate) {
        return {
            restrict: 'E',
            compile : function (element, attr) {
                var code;
                //No attribute? code is the content
                if (!attr.code) {
                    code = element.html();
                    element.empty();
                }

                return function (scope, element, attr) {

                    if (attr.code) {
                        // Attribute? code is the evaluation
                        code = scope.$eval(attr.code);
                    }
                    var shouldInterpolate = scope.$eval(attr.shouldInterpolate);

                    $q.when(code).then(function (code) {
                        if (code) {
                            if (shouldInterpolate) {
                                code = $interpolate(code)(scope);
                            }
                            var contentParent = angular.element(
                                '<pre><code class="highlight" ng-non-bindable></code></pre>'
                            );
                            element.append(contentParent);
                            // Defer highlighting 1-frame to prevent GA interference...
                            $timeout(function () {
                                render(code, contentParent);
                            }, 34, false);
                        }
                    });

                    function render(contents, parent) {

                        var codeElement = parent.find('code');
                        var lines = contents.split('\n');

                        // Remove empty lines
                        lines = lines.filter(function (line) {
                            return line.trim().length;
                        });

                        // Make it so each line starts at 0 whitespace
                        var firstLineWhitespace = lines[0].match(/^\s*/)[0];
                        var startingWhitespaceRegex = new RegExp('^' + firstLineWhitespace);
                        lines = lines.map(function (line) {
                            return line
                                .replace(startingWhitespaceRegex, '')
                                .replace(/\s+$/, '');
                        });

                        var highlightedCode = hljs.highlight(attr.language || attr.lang, lines.join('\n'), true);
                        highlightedCode.value = highlightedCode.value
                            .replace(/=<span class="hljs-value">""<\/span>/gi, '')
                            .replace('<head>', '')
                            .replace('<head/>', '');
                        codeElement.append(highlightedCode.value).addClass('highlight');
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('fuseConfig', fuseConfigProvider);

    /** @ngInject */
    function fuseConfigProvider()
    {
        // Default configuration
        var fuseConfiguration = {
            'disableCustomScrollbars'        : false,
            'disableMdInkRippleOnMobile'     : true,
            'disableCustomScrollbarsOnMobile': true
        };

        // Methods
        this.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            fuseConfiguration = angular.extend({}, fuseConfiguration, configuration);
        }

        /**
         * Service
         */
        this.$get = function ()
        {
            var service = {
                getConfig: getConfig,
                setConfig: setConfig
            };

            return service;

            //////////

            /**
             * Returns a config value
             */
            function getConfig(configName)
            {
                if ( angular.isUndefined(fuseConfiguration[configName]) )
                {
                    return false;
                }

                return fuseConfiguration[configName];
            }

            /**
             * Creates or updates config object
             *
             * @param configName
             * @param configValue
             */
            function setConfig(configName, configValue)
            {
                fuseConfiguration[configName] = configValue;
            }
        };
    }

})();
(function ()
{
	"use strict";

	angular
		.module("app.components")
		.component("stepper", {
				bindings:{
					steps: "=",
					currentStepIndex: "=",
					beforeStepChange: "<",
					goToStep: "=",
					next:"=",
					isDisabled: "="
				},
				templateUrl: "app/components/stepper/stepper.html",
				controller: componentController,
		  		controllerAs: "vm"
			});

		function componentController(){
			var vm = this;	

			vm.$postLink = postLink;
			vm.$onInit = onInit;
			vm.isStepCompleted = isStepCompleted;
			vm.isCurrentStep = isCurrentStep;
			vm.getStepIconClass = getStepIconClass;
			vm.isNextDisabled = isNextDisabled;
			vm.isStepBlocked = isStepBlocked;

			function onInit(){
				goToStep(0);
			}

			function postLink(){
				vm.goToStep = goToStep;
				vm.next = next;
			}

			function next(){
				if(Number.isInteger(vm.currentStepIndex)){
					goToStep(vm.currentStepIndex + 1);
				}
			}

			function isStepBlocked(index){
				if(vm.isDisabled){
					return true;
				}

				if(index == 0){
					return false;
				}

				return !vm.isStepCompleted(index - 1);
			}

			function isNextDisabled(){
				return vm.isDisabled || !vm.isStepCompleted(vm.currentStepIndex);
			}

			function getStepIconClass(index){
				const isCurrent = isCurrentStep(index);
				const iconClasses = [isStepBlocked(index) ? ["text-grey"] : ["text-secondary"]];

				if(isStepCompleted(index)){
					iconClasses.push(isCurrent ? ["icon-check-circle"] : ["icon-check-circle-outline"]);
				} else {
					iconClasses.push(isCurrent ? ["icon-circle"] : ["icon-circle-outline"]);
				}

				return iconClasses;
			}

			function isCurrentStep(index){
				return index == vm.currentStepIndex;
			}

			function goToStep(stepIndex){
				if(isCurrentStep(stepIndex) || isStepBlocked(stepIndex)){
					return;
				}

				if(typeof(vm.beforeStepChange) == "function"){
					vm.beforeStepChange(vm.currentStepIndex, stepIndex);
				}

				vm.currentStepIndex = stepIndex;
				initStep(stepIndex);
			}

			function initStep(stepIndex){
				if(!Number.isInteger(stepIndex) || !Array.isArray(vm.steps) || !vm.steps[stepIndex] || isStepBlocked(stepIndex)){
					return false;
				}

				if(typeof(vm.steps[stepIndex].onInit) == "function"){
					vm.steps[stepIndex].onInit();
				}
			}

			function isStepCompleted(stepIndex){
				if(!Number.isInteger(stepIndex) || !Array.isArray(vm.steps) || !vm.steps[stepIndex]){
					return false;
				}

				for(var i = 0; i <= stepIndex; i++){
					const step = vm.steps[i];

					if(!step){
						return false;
					}

					if(typeof(step.isCompleted) == "boolean" && !step.isCompleted){
						return false;
					}

					if(typeof(step.isCompleted) == "function" && !step.isCompleted()){
						return false;
					} 
				}

				return true;
			}
		}
})();
(function ()
{
	"use strict";

	angular
		.module("app.components")
		.component("pagination", {
				bindings:{
					currentPage:'=',
					totalCount:'=',
					itemPerPage:'=',
					onPageChange: '=',
					showRange: '<',
				},
				templateUrl: "app/components/pagination/pagination.html",
				controller: componentController,
		  		controllerAs: 'vm'
			});

		function componentController($scope, $filter){
			const vm = this;

			vm.$onInit = initComponent;

			$scope.$watch("vm.currentPage", resetPagination);
			$scope.$watch("vm.totalCount", resetPagination);
			$scope.$watch("vm.itemPerPage", resetPagination);

			function initComponent(){
				if(isNaN(parseInt(vm.showRange))){
					vm.showRange = 5;
				}			
			}

			function resetPagination(){
				const totalCount = parseInt(vm.totalCount);
				const itemPerPage = parseInt(vm.itemPerPage);
				const currentPage = parseInt(vm.currentPage);

				if(isNaN(totalCount) || isNaN(itemPerPage) || isNaN(currentPage)){
					return;
				}

				vm.totalPage = Math.ceil(totalCount / itemPerPage);

				vm.pagesBeforeCurrentPage = getPagesBeforeCurrentPage(vm.currentPage);
				vm.pagesAfterCurrentPage = getPagesAfterCurrentPage(vm.totalPage);
			}

			function getPagesBeforeCurrentPage () {
				var pageNumbers = [];

				for(var i = vm.showRange; i > 0; i--){
					var pageNumber = vm.currentPage - i;
					if( pageNumber > 0){
						pageNumbers.push(pageNumber);
					}
				}

				return pageNumbers;
			}

			function getPagesAfterCurrentPage (tatalPages) {
				var pageNumbers = [];

				for(var i = 1; i <= vm.showRange; i++){
					var pageNumber = vm.currentPage + i;
					if( pageNumber <= tatalPages){
						pageNumbers.push(pageNumber);
					}
				}
				return pageNumbers;
			}
		}
})();
(function ()
{
	"use strict";

	angular
		.module("app.components")
		.component("customNavBar", {
				bindings:{
					navItems:'<',
					currentState: '='
				},
				templateUrl: "app/components/custom-nav-bar/custom-nav-bar.html",
				controller: componentController,
		  		controllerAs: 'vm'
			});

		function componentController($location, $scope, $filter, $state, $rootScope, $timeout){
			var vm = this;	

			vm.getLink = getLink;
			vm.goToState = goToState;
			vm.getCurrentTabName = getCurrentTabName;
			vm.toggleMenu = toggleMenu;

			$rootScope.$on('$stateChangeSuccess', function(event, current) {
				vm.currentState = current.name;
			});

			function getLink(state, params){
				return $state.href(state, params);
			}

			function goToState(state){
				$state.go(state);
			}

			function getCurrentTabName(){
				if(!Array.isArray(vm.navItems)){
					return;
				}

				const currentNavItem = vm.navItems.find(function(navItem){
					return navItem.state == vm.currentState;
				}); 

				if(currentNavItem){
					return currentNavItem.name;
				}
			}

			function toggleMenu(){
				vm.showMenu = ! vm.showMenu

				if(vm.showMenu){
					$timeout(function(){
						const navListMenu = angular.element(document.querySelector('#navListMenu'));
						if(navListMenu){
							navListMenu.focus();
						}
					});
				}
			}
		}
})();
(function ()
{
	"use strict";

	angular
		.module("app.components")
		.component("textareaInputBox", {
				bindings:{
					options:'<',
					value:'=',
					inputName:'<'
				},
				templateUrl: "app/components/input-box/textarea-input-box.html",
				controller: componentController,
		  		controllerAs: 'vm',
		  		require: {
			        form : '^form'
			    }
			});

		function componentController($scope, $filter){
			var vm = this;	

		}
})();
(function ()
{
	"use strict";

	angular
		.module("app.components")
		.component("textareaInputBoxNoIcon", {
				bindings:{
					options:'<',
					value:'=',
					inputName:'<'
				},
				templateUrl: "app/components/input-box/textarea-input-box-no-icon.html",
				controller: componentController,
		  		controllerAs: 'vm',
		  		require: {
			        form : '^form'
			    }
			});

		function componentController($scope, $filter){
			var vm = this;	

		}
})();
(function ()
{
	"use strict";

	angular
		.module("app.components")
		.component("inputBox", {
				bindings:{
					options:'<',
					value:'=',
					inputName:'<',
					onChange:'<'
				},
				templateUrl: "app/components/input-box/input-box.html",
				controller: componentController,
		  		controllerAs: 'vm',
		  		require: {
			        form : '^form'
			    }
			});

		function componentController($scope, $filter){
			var vm = this;	
		}
})();
(function ()
{
	"use strict";

	angular
		.module("app.components")
		.component("inputBoxNoIcon", {
				bindings:{
					options:'<',
					value:'=',
					inputName:'<',
					onChange:'<'
				},
				templateUrl: "app/components/input-box/input-box-no-icon.html",
				controller: componentController,
		  		controllerAs: 'vm',
		  		require: {
			        form : '^form'
			    }
			});

		function componentController($scope, $filter){
			var vm = this;	
		}
})();
(function ()
{
    'use strict';

    angular
        .module('app.toolbar', [])
        .config(config);

    /** @ngInject */
    function config($translatePartialLoaderProvider)
    {
        $translatePartialLoaderProvider.addPart('app/toolbar');
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.toolbar')
        .controller('ToolbarController', ToolbarController);

    /** @ngInject */
    function ToolbarController(LoginConst, VehicleConstants, $rootScope, $scope,$q, $state, $timeout, $mdSidenav, $translate, $mdToast, msNavigationService, LoginService, Const, $stateParams, UserService)
    {
        var vm = this;
        vm.isPublicPage = false;
        
        // Data 
        $rootScope.global = {
            search: ''
        };

        vm.bodyEl = angular.element('body');
        vm.userStatusOptions = [
            {
                'title': 'Salesman',
                'icon' : 'icon-eye',
                'color': '#4CAF50'
            },
            {
                'title': 'Customer',
                'icon' : 'icon-eye-off',
                'color': '#F44336'
            }
        ];
        vm.languages = {
            en: {
                'title'      : 'English',
                'translation': 'TOOLBAR.ENGLISH',
                'code'       : 'en',
                'flag'       : 'us'
            },
            es: {
                'title'      : 'Spanish',
                'translation': 'TOOLBAR.SPANISH',
                'code'       : 'es',
                'flag'       : 'es'
            },
            tr: {
                'title'      : 'Turkish',
                'translation': 'TOOLBAR.TURKISH',
                'code'       : 'tr',
                'flag'       : 'tr'
            }
        };

        // Methods
        vm.toggleSidenav = toggleSidenav;
        vm.logout = logout;
        vm.changeLanguage = changeLanguage;
        vm.setUserStatus = setUserStatus;
        vm.toggleHorizontalMobileMenu = toggleHorizontalMobileMenu;
        vm.toggleMsNavigationFolded = toggleMsNavigationFolded;
        vm.search = search;
        vm.searchResultClick = searchResultClick;
        vm.goToMyProfile = goToMyProfile;
        vm.goToHomePage = goToHomePage;
        vm.goToLoginPage = goToLoginPage;
        vm.goToVehiclesPage = goToVehiclesPage;
        //vm.login=login;

        //////////

        init();

        LoginService.subscribe(updateToolbar);

        /**
         * Initialize
         */
        function init()
        {
            // Select the first status as a default

            var salesMode = LoginService.getPageConfigs(LoginConst.pageConfigKeys.salesMode);

            if(!salesMode){
                salesMode = vm.userStatusOptions[0];
            }

            setUserStatus(salesMode);

            // Get the selected language directly from angular-translate module setting
            vm.selectedLanguage = vm.languages[$translate.preferredLanguage()];

            $scope.logo = {initial : Const.logo.initial, text : Const.logo.title};

            updateToolbar();

            checkCurrentPageisPublic();

            initUserOutstandingTask();
            
        }

        

        $rootScope.$on("LOGOUT", function(){
            console.log("LOGOUT")
            LoginService.clearUserStatus();
            updateToolbar();

        });

        function updateToolbar(){
            vm.isLoggedIn = LoginService.isLoggedIn();

            if(LoginService.getUserInfo()){
                $scope.usermenu_username = LoginService.getFirstname() + " " + LoginService.getLastname();
                vm.profileImage = LoginService.getProfileImageURL();
            }else{
                $scope.usermenu_username = "";
                vm.profileImage = null;;
            }
        }

        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }

        /**
         * Sets User Status
         * @param status
         */
        function setUserStatus(status)
        {
            vm.userStatus = status;

            $scope.$emit(VehicleConstants.eventNames.changePurchaseMode, status);
            LoginService.savePageConfigs(LoginConst.pageConfigKeys.salesMode, status);
        }

        function goToMyProfile(){
            var params = {
                    userID:LoginService.getUserID(),
                    companyID:LoginService.getCompanyID()
                };            
            $state.go("app.settings.users.my-profile", params, {reload: true});
        }

        function goToLoginPage (){
        	$state.go("app.login");
        }

        function goToVehiclesPage (){
        	$state.go("app.vehicles");
        }

        function goToHomePage(){
            $state.go("app.homepage");
        }

        /**
         * Logout Function
         */
        function logout()
        {
            LoginService.clearUserStatus();

            //when user logout go to home page
            window.location.href = "/";        
        }

        /**
         * Change Language
         */
        function changeLanguage(lang)
        {
            vm.selectedLanguage = lang;

            /**
             * Show temporary message if user selects a language other than English
             *
             * angular-translate module will try to load language specific json files
             * as soon as you change the language. And because we don't have them, there
             * will be a lot of errors in the page potentially breaking couple functions
             * of the template.
             *
             * To prevent that from happening, we added a simple "return;" statement at the
             * end of this if block. If you have all the translation files, remove this if
             * block and the translations should work without any problems.
             */
            if ( lang.code !== 'en' )
            {
                var message = 'Fuse supports translations through angular-translate module, but currently we do not have any translations other than English language. If you want to help us, send us a message through ThemeForest profile page.';

                $mdToast.show({
                    template : '<md-toast id="language-message" layout="column" layout-align="center start"><div class="md-toast-content">' + message + '</div></md-toast>',
                    hideDelay: 7000,
                    position : 'top right',
                    parent   : '#content'
                });

                return;
            }

            // Change the language
            $translate.use(lang.code);
        }

        /**
         * Toggle horizontal mobile menu
         */
        function toggleHorizontalMobileMenu()
        {
            vm.bodyEl.toggleClass('ms-navigation-horizontal-mobile-menu-active');
        }

        /**
         * Toggle msNavigation folded
         */
        function toggleMsNavigationFolded()
        {
            msNavigationService.toggleFolded();
        }

        /**
         * Search action
         *
         * @param query
         * @returns {Promise}
         */
        function search(query)
        {
            var navigation = [],
                flatNavigation = msNavigationService.getFlatNavigation(),
                deferred = $q.defer();

            // Iterate through the navigation array and
            // make sure it doesn't have any groups or
            // none ui-sref items
            for ( var x = 0; x < flatNavigation.length; x++ )
            {
                if ( flatNavigation[x].uisref )
                {
                    navigation.push(flatNavigation[x]);
                }
            }

            // If there is a query, filter the navigation;
            // otherwise we will return the entire navigation
            // list. Not exactly a good thing to do but it's
            // for demo purposes.
            if ( query )
            {
                navigation = navigation.filter(function (item)
                {
                    if ( angular.lowercase(item.title).search(angular.lowercase(query)) > -1 )
                    {
                        return true;
                    }
                });
            }

            // Fake service delay
            $timeout(function ()
            {
                deferred.resolve(navigation);
            }, 1000);

            return deferred.promise;
        }

        /**
         * Search result click action
         *
         * @param item
         */
        function searchResultClick(item)
        {
            // If item has a link
            if ( item.uisref )
            {
                // If there are state params,
                // use them...
                if ( item.stateParams )
                {
                    $state.go(item.state, item.stateParams);
                }
                else
                {
                    $state.go(item.state);
                }
            }
        }

        function checkCurrentPageisPublic(url){
            var str = "";
            str = window.location.href
            if(str.includes("uuid")){
                vm.isPublicPage = true;
                var ele = document.getElementById("toolbar").style.display = "none";
            }else{
                vm.isPublicPage = false;
                var ele = document.getElementById("toolbar").style.display = "true";
            }

        }

        function initUserOutstandingTask(){
            var params = {
                userID:LoginService.getUserID(),
                companyID:LoginService.getCompanyID()
            };  
            return UserService.getUsersOutstandingTask(params)
            .then(function(outstandingTask){
                if(outstandingTask !== null){
                    return LoginService.setOutstandingTask(outstandingTask);
                }
                return outstandingTask;
            });
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.message', [])
        .config(config);

    /** @ngInject */
    function config()
    {
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.message')
        .service("MessageService", MessageService);

    /** @ngInject */
    function MessageService($mdToast, LoginService, $state, $rootScope)
    {   
        this.showToast = function (message){
            var text = normalizeMessage(message);

            if(isEmptyMessage(text)){
                text = "Request failed. Please try again.";
            }

            if(text.startsWith("463")){

                $rootScope.$emit("LOGOUT");
                $state.go("app.login");          

                
            }else if(text.startsWith("refresh")){
                var refreshText = text.slice(8).trim();

                if(isEmptyMessage(refreshText)){
                    refreshText = "Updated successfully.";
                }

                $mdToast.show(
                    $mdToast.simple()
                      .textContent(refreshText)
                      .position("bottom left")
                      .hideDelay(2000)
                  ); 

            }
            else {
                $mdToast.show(
                    $mdToast.simple()
                      .textContent(text)
                      .position("bottom left")
                      .hideDelay(2000)
                  );   
            }
        };

        function normalizeMessage(message){
            if(typeof(message) === "string"){
                return message.trim();
            }

            if(typeof(message) === "number"){
                return String(message);
            }

            if(!message || typeof(message) !== "object"){
                return "";
            }

            if(typeof(message.message) === "string"){
                return message.message.trim();
            }

            if(typeof(message.data) === "string"){
                return message.data.trim();
            }

            if(message.data && typeof(message.data.message) === "string"){
                return message.data.message.trim();
            }

            if(message.status && message.statusText){
                return (String(message.status) + " " + String(message.statusText)).trim();
            }

            return "";
        }

        function isEmptyMessage(text){
            if(!text){
                return true;
            }

            var normalized = text.trim().toLowerCase();

            return normalized === "null" ||
                normalized === "undefined" ||
                normalized === "null null" ||
                normalized === "null: null";
        }
    
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.message')
        .controller('MessageController', MessageController);

    /** @ngInject */
    function MessageController()
    {
        var vm = this;
    }

})();
(function ()
{
	'use strict';

	angular
		.module('app.progress',[])
		.service("ProgressService", progressService);

	/** @ngInject */
	function progressService()
	{   
		var listeners = [];
		var _progressBar = {};
		var queue = 0;


		this.register = function (progressBar){
			_progressBar = progressBar;
		}

		this.isVisble = function(boolean){
			_progressBar.isVisble = boolean;
		}

		this.updateProgress = function(progress){
			_progressBar.progress = progress;
		}

		this.setMode = function(mode){
			_progressBar.mode = mode;
		}

		this.addTaskToQueue = function(){
			queue++;

			if(queue < 0){
				queue = 1;
			}

			onQueueChange();
		}

		this.removeTaskFromQueue = function(){
			queue--;

			if(queue < 0){
				queue = 0;
			}

			onQueueChange();
		};

		this.registerListener = function(listener){
			listeners.push(listener);
		}

		this.removeListener = function(listener){
			var index = listeners.findIndex(function(_listener){
				return _listener === listener;
			});

			if(index != -1){
				listeners.splice(index, 1);
			}
		}

		function onQueueChange(){
			if(queue > 0){
				_progressBar.mode = "indeterminate";
				_progressBar.isVisble = true;
			} else {
				_progressBar.isVisble = false;
			}

			listeners.forEach(function(listener){
				if(listener && typeof(listener.onQueueChange) == "function"){
					listener.onQueueChange(queue);
				}
			});
		}
	}
})();
(function ()
{
    'use strict';

    angular
        .module('app.progress')
        .controller('ProgressController', progressController);

    /** @ngInject */
    function progressController(ProgressService)
    {
        var vm = this;
        vm.progress = {};

        vm.progress.mode = "indeterminate"
        vm.progress.isVisble = false;

        ProgressService.register(vm.progress);
    }

})();
/**
 *  all the module will be registered in here
 */
(function ()
{
    'use strict';

    /**
     * Main module of the Fuse
     */
    angular
        .module('fuse', [
            // Core
            'app.core',

            // Navigation
            'app.navigation',

            // Toolbar
            'app.toolbar',

            'app.homepage',

            'app.login',

            "app.forceLogout",

            'app.session',

            'app.userInfoObj',

            'app.cookie',

            'app.uiCtrl',

            'app.token',

            'app.log',

            'app.const', 

            "app.tools",

            "app.settings",

            "app.message",

            "angularFileUpload",

            "app.fileUpload",

            "app.progress",

            "app.fileView",

            "app.formValidator",

            "app.dialog",

            "slickCarousel",

            "thatisuday.ng-image-gallery",

            "dndLists",

            "ngclipboard",

            "app.vehicles",

            "app.roleCheck",

            "app.customers",

            "app.goto",

            "app.components",

            "app.tasks",

            "app.directives",

            "moment-picker",

            "app.financeApplication",

            "app.saleInfo",

            "app.safety",

            "app.purchaseInfo",

            "app.disclosure",

            "app.reports",

            "app.hellosign",

            "app.lightGallery",

            "app.emailService",

            "app.userConfig",

            "app.inventory",

            "app.purchaseInvoice",

            "app.parts",

            "app.workOrders",

            "app.returnInvoice",

            "app.appointments",

            "app.bookAppointment",

            "app.redirect-page",

            "app.register-page"
        ]);
})();
(function ()
{
    'use strict';

    angular
        .module('fuse')
        .controller('MainController', MainController);

    /** @ngInject */
    function MainController($scope, $rootScope)
    {
        // Data

        //////////

        // Remove the splash screen
        $scope.$on('$viewContentAnimationEnded', function (event)
        {
            if ( event.targetScope.$id === $scope.$id )
            {
                $rootScope.$broadcast('msSplashScreen::remove');
            }
        });
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.navigation', [])
        .config(config);

    /** @ngInject */
    function config()
    {
        
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.navigation')
        .controller('NavigationController', NavigationController);

    /** @ngInject */
    function NavigationController($scope, msNavigationService, RoleCheckService)
    {
        var vm = this;

        // Data
        vm.bodyEl = angular.element('body');
        vm.folded = true;
        vm.msScrollOptions = {
            suppressScrollX: true
        };

        // Methods
        vm.toggleMsNavigationFolded = toggleMsNavigationFolded;

        //////////

        /**
         * Toggle folded status
         */
        function toggleMsNavigationFolded()
        {
            vm.folded = !vm.folded;
        }

        // Close the mobile menu on $stateChangeSuccess
        $scope.$on('$stateChangeSuccess', function ()
        {
            vm.bodyEl.removeClass('ms-navigation-horizontal-mobile-menu-active');
        });

        var allItems = angular.copy(msNavigationService.getNavigation());

        

        filterItems(allItems);

        function filterItems (itemList) {
			var i = itemList.length

			while (i--) {
				var item = itemList[i];

				//no children, check role
				if(item.children.length == 0 && RoleCheckService.checkRole(item.requiredRoles)){
					continue;
				}

				//has children, filter children then check what is left
				if(item.children.length != 0 && filterItems(item.children).length > 0){
					continue;
        		}

				itemList.splice(i, 1);
        		msNavigationService.deleteItem(item._path);
			}

        	return itemList;
        }
    }

})();
(function ()
{
	'use strict';

	angular
		.module('app.workOrders')
		.controller('YesOrNoDialogController', YesOrNoDialogController);

	function YesOrNoDialogController(title, message, $mdDialog, MessageService, noButtonText, yesButtonText, yesButtonID){   
		const vm = this;

		vm.yesButtonID = yesButtonID;
		vm.title = title ? title : "Warning";
		vm.message = message ? message : "Are you sure.";
		vm.cancel = cancel;
		vm.select = select;
		vm.noButtonText = noButtonText ? noButtonText : "NO";
		vm.yesButtonText = yesButtonText ? yesButtonText : "YES";

		function select(isSave) {
			$mdDialog.hide(isSave);
		}

		function cancel (){
			$mdDialog.cancel();
		}
	}
})();
(function ()
{
	'use strict';

	angular
		.module('app.workOrders')
		.controller('WarningDialogController', WarningDialogController);

	function WarningDialogController(title, message, $mdDialog, MessageService, yesButtonText, yesButtonID){   
		const vm = this;

		vm.yesButtonID = yesButtonID;
		vm.title = title ? title : "Warning";
		vm.message = message ? message : "Are you sure.";
		vm.cancel = cancel;
		vm.select = select;
		// vm.noButtonText = noButtonText ? noButtonText : "NO";
		vm.yesButtonText = yesButtonText ? yesButtonText : "YES";

		function select(isSave) {
			$mdDialog.hide(isSave);
		}

		function cancel (){
			$mdDialog.cancel();
		}
	}
})();
(function ()
{
	'use strict';

	angular
		.module('app.dialog', [])
		.service("DialogService", DialogService);

	/** @ngInject */
	function DialogService( $mdDialog, MessageService)
	{   
		const yesButtonID = "yesButton";

		this.showConfirmDialog = function(dialogOptions){
			var locals = {};

			if(dialogOptions == null){
				MessageService.showToast("Dialog option is null");
				return;
			}

			$mdDialog.show({
				controller		 	: 'ConfirmDialogController',
				controllerAs	   	: 'vm',
				templateUrl			: 'app/dialog/confirm-prompt-dialog.html',
				clickOutsideToClose	: true,
				multiple: true,
				locals				: {
					dialogOptions 	: dialogOptions
				}
			});
		}

		this.showOptionsDialog = function(dialogOptions){
			var locals = {};

			if(dialogOptions == null){
				MessageService.showToast("Dialog option is null");
				return;
			}

			$mdDialog.show({
				controller		 	: 'OptionsDialogController',
				controllerAs	   	: 'vm',
				templateUrl			: 'app/dialog/options-prompt-dialog.html',
				clickOutsideToClose	: dialogOptions.clickOutsideToClose === false ? false : true,
				multiple: true,
				locals				: {
					dialogOptions 	: dialogOptions
				},
				onRemoving			: function(element, removePromise){
					dialogOptions.onClose();
				}
			});
		}

		this.showYesOrNoDialog = function(title, message, yesButtonText, noButtonText){
			return $mdDialog.show({
				controller: 'YesOrNoDialogController',
				controllerAs: 'vm',
				templateUrl: 'app/dialog/yes-or-no-dialog.html',
				clickOutsideToClose: true,
				onComplete: function(scope, element, options){
					const yesButton = element.find('#' + yesButtonID);
					if(yesButton){
						yesButton.focus();
					}
				},
				locals: {
					title: title,
					message: message,
					noButtonText: noButtonText,
					yesButtonText: yesButtonText,
					yesButtonID: yesButtonID
				}
			});
		}

		this.showWarningDialog = function(title, message, yesButtonText){
			return $mdDialog.show({
				controller: 'WarningDialogController',
				controllerAs: 'vm',
				templateUrl: 'app/dialog/warningdialog.html',
				clickOutsideToClose: true,
				onComplete: function(scope, element, options){
					const yesButton = element.find('#' + yesButtonID);
					if(yesButton){
						yesButton.focus();
					}
				},
				locals: {
					title: title,
					message: message,
					yesButtonText: yesButtonText,
					yesButtonID: yesButtonID
				}
			});
		}

		this.close = function (){
			$mdDialog.hide();
		}
	}
})();
(function ()
{
	'use strict';

	angular.module('app.dialog')
		.controller('OptionsDialogController', OptionsDialogController);

	/** @ngInject */
	function OptionsDialogController(dialogOptions, $mdDialog)
	{	

		var vm = this;

		init();

		function init(){
			if(dialogOptions == null){
				return;
			}

			vm.closeDialog = closeDialog;

			vm.titleString			= dialogOptions.titleString;
			vm.contentString		= dialogOptions.contentString;	
				
			if(dialogOptions.options == null || dialogOptions.length <= 0){
				return;
			}

			vm.options = dialogOptions.options;
		}

		function closeDialog (){
			$mdDialog.hide();
		}



	}
})();

(function ()
{
	'use strict';

	angular.module('app.dialog')
		.controller('ConfirmDialogController', ConfirmDialogController);

	/** @ngInject */
	function ConfirmDialogController(dialogOptions, $mdDialog)
	{
		var vm = this;
		var confirmCallback;
		var cancelCallback;
		var enableConfirmButtonCallback;
		
		init();

		function init(){
			if(dialogOptions == null){
				return;
			}

			vm.inputBoxPlaceHolder	= dialogOptions.inputBoxPlaceHolder;
			vm.cancelButtonString	= dialogOptions.cancelButtonString;
			vm.confirmButtonString	= dialogOptions.confirmButtonString;
			vm.titleString			= dialogOptions.titleString;
			vm.contentString		= dialogOptions.contentString;	
			
			confirmCallback				= dialogOptions.confirmCallback;
			cancelCallback				= dialogOptions.cancelCallback;
			enableConfirmButtonCallback	= dialogOptions.enableConfirmButtonCallback;

			enableConfirmButton();
		}

		vm.enableConfirmButton	= enableConfirmButton;   	
		vm.confirm				= confirm;
		vm.cancel				= cancel;
		vm.closeDialog			= closeDialog;

		function confirm(){
			if(confirmCallback != null){
				confirmCallback(vm.inputString);
			}
			$mdDialog.hide();
		}

		function cancel(){
			if(cancelCallback != null){
				cancelCallback(vm.inputString);
			}			
			$mdDialog.hide();
		}	

		function enableConfirmButton(){
			if(enableConfirmButtonCallback == null){
				vm.isConfirmButtonActive = true;
				return;
			}				

			if(enableConfirmButtonCallback(vm.inputString)){
				vm.isConfirmButtonActive = true;
			}else{
				vm.isConfirmButtonActive = false;
			}
		}

		function closeDialog (){
			$mdDialog.hide();
		}

	}
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .run(runBlock);

    /** @ngInject */
    function runBlock(msUtils, fuseGenerator, fuseConfig)
    {
        /**
         * Generate extra classes based on registered themes so we
         * can use same colors with non-angular-material elements
         */
        fuseGenerator.generate();

        /**
         * Disable md-ink-ripple effects on mobile
         * if 'disableMdInkRippleOnMobile' config enabled
         */
        if ( fuseConfig.getConfig('disableMdInkRippleOnMobile') && msUtils.isMobile() )
        {
            var bodyEl = angular.element('body');
            bodyEl.attr('md-no-ink', true);
        }

        /**
         * Put isMobile() to the html as a class
         */
        if ( msUtils.isMobile() )
        {
            angular.element('html').addClass('is-mobile');
        }

        /**
         * Put browser information to the html as a class
         */
        var browserInfo = msUtils.detectBrowser();
        if ( browserInfo )
        {
            var htmlClass = browserInfo.browser + ' ' + browserInfo.version + ' ' + browserInfo.os;
            angular.element('html').addClass(htmlClass);
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .config(config);

    /** @ngInject */
    function config($ariaProvider, $logProvider, msScrollConfigProvider, fuseConfigProvider)
    {
        // Enable debug logging
        $logProvider.debugEnabled(true);

        /*eslint-disable */

        // ng-aria configuration
        $ariaProvider.config({
            tabindex: false
        });

        // Fuse theme configurations
        fuseConfigProvider.config({
            'disableCustomScrollbars'        : false,
            'disableCustomScrollbarsOnMobile': true,
            'disableMdInkRippleOnMobile'     : true
        });

        // msScroll configuration
        msScrollConfigProvider.config({
            wheelPropagation: true
        });

        /*eslint-enable */
    }
})();
(function ()
{
    'use strict';

    angular
        .module('fuse')
        .run(runBlock);

    /** @ngInject */
    function runBlock($rootScope, $timeout, $state, msNavigationService, RoleCheckService)
    {
        // Activate loading indicator


        var stateChangeStartEvent = $rootScope.$on('$stateChangeStart', function ()
        {	
            $rootScope.loadingProgress = true;
        });

        // De-activate loading indicator
        var stateChangeSuccessEvent = $rootScope.$on('$stateChangeSuccess', function ()
        {
            $timeout(function ()
            {
                $rootScope.loadingProgress = false;
            });
        });

        // Store state in the root scope for easy access
        $rootScope.state = $state;

        // Cleanup
        $rootScope.$on('$destroy', function ()
        {
            stateChangeStartEvent();
            stateChangeSuccessEvent();
        });

		msNavigationService.saveItem("service", {
			title : "SERVICE",
			icon : "icon-car",
			weight: 3,
			requiredRoles:[]			 
		});

		msNavigationService.saveItem('service.schedule', {
			title: 'Schedule',
			state: 'app.workorder-schedule',
			requiredRoles:[]	
		});

		msNavigationService.saveItem('service.new-schedule', {
			title: 'Active Schedule',
			state: 'app.workorder-new-schedule',
			requiredRoles:[]	
		});
		// msNavigationService.saveItem('service.CustomerAppointment', {
		// 	title: 'Customer Appointment',
		// 	state: 'app.customerportal-appointment',
		// 	requiredRoles:[]	
		// });

		msNavigationService.saveItem('service.inventory', {
			title: 'Inventory',
			state: "app.manage-inventory",
			requiredRoles:[]	
		});

		if(!RoleCheckService.checkRole(["mechanic"])){
			msNavigationService.saveItem('service.purchase-invoice', {
				title: 'Purchase Invoice',
				state: 'app.browse-purchase-invoices',
				requiredRoles:[]	
			});
		}

		msNavigationService.saveItem("service.workorders", {
			title : "Work Orders",
			requiredRoles:[],
			state: 'app.browse-workorder'		 
		});

        msNavigationService.saveItem("service.outstandingworkorders", {
			title : "Outstanding Work Orders",
			requiredRoles:[],
			state: 'app.browse-outstanding-workorder'		 
		});

		msNavigationService.saveItem("service.partappointmentworkorders", {
			title : "Ordered Part Work Orders",
			requiredRoles:[],
			state: 'app.browse-part-appointment-workorder'		 
		});

		msNavigationService.saveItem("service.partnoappointmentworkorders", {
			title : "Ordered Part No appointment Work Orders",
			requiredRoles:[],
			state: 'app.browse-part-no-appointment-workorder'		 
		});

        msNavigationService.saveItem("service.warrantyworkorders", {
			title : "Warranty Work Orders",
			requiredRoles:[],
			state: 'app.browse-warranty-workorder'		 
		});

		msNavigationService.saveItem("service.pendingworkorders", {
			title : "Pending Payment Work Orders",
			requiredRoles:[],
			state: 'app.browse-pending-workorder'		 
		});

		// msNavigationService.saveItem("service.bookappointment", {
		// 	title : "test",
		// 	requiredRoles:[],
		// 	state: 'app.book-appointment'		 
		// });
    }
})();
(function ()
{
    'use strict';

    angular
        .module('fuse')
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider, $locationProvider)
    {
        $locationProvider.html5Mode(true);

        $urlRouterProvider.otherwise('/');

        /**
         * Layout Style Switcher
         *
         * This code is here for demonstration purposes.
         * If you don't need to switch between the layout
         * styles like in the demo, you can set one manually by
         * typing the template urls into the `State definitions`
         * area and remove this code
        var $cookies;

        angular.injector(['ngCookies']).invoke([
            '$cookies', function (_$cookies)
            {
                $cookies = _$cookies;
            }
        ]);

        // Get active layout
        var layoutStyle = 'verticalNavigationFullwidthToolbar2';

        var layouts = {
            verticalNavigation  : {
                main      : 'app/core/layouts/vertical-navigation.html',
                toolbar   : 'app/toolbar/layouts/vertical-navigation/toolbar.html',
                navigation: 'app/navigation/layouts/vertical-navigation/navigation.html'
            },
            verticalNavigationFullwidthToolbar  : {
                main      : 'app/core/layouts/vertical-navigation-fullwidth-toolbar.html',
                toolbar   : 'app/toolbar/layouts/vertical-navigation-fullwidth-toolbar/toolbar.html',
                navigation: 'app/navigation/layouts/vertical-navigation/navigation.html'
            },
            verticalNavigationFullwidthToolbar2  : {
                main      : 'app/core/layouts/vertical-navigation-fullwidth-toolbar-2.html',
                toolbar   : 'app/toolbar/layouts/vertical-navigation-fullwidth-toolbar-2/toolbar.html',
                navigation: 'app/navigation/layouts/vertical-navigation-fullwidth-toolbar-2/navigation.html'
            },
            horizontalNavigation: {
                main      : 'app/core/layouts/horizontal-navigation.html',
                toolbar   : 'app/toolbar/layouts/horizontal-navigation/toolbar.html',
                navigation: 'app/navigation/layouts/horizontal-navigation/navigation.html'
            },
            contentOnly         : {
                main      : 'app/core/layouts/content-only.html',
                toolbar   : '',
                navigation: ''
            },
            contentWithToolbar  : {
                main      : 'app/core/layouts/content-with-toolbar.html',
                toolbar   : 'app/toolbar/layouts/content-with-toolbar/toolbar.html',
                navigation: ''
            }
        };
        // END - Layout Style Switcher
         */
        // Inject $cookies


        // State definitions
        $stateProvider
            .state('app', {
                abstract: true,
                views   : {
                    'main@'         : {
                        templateUrl: 'app/core/layouts/vertical-navigation-fullwidth-toolbar-2.html',
                        controller : 'MainController as vm'
                    },
                    'toolbar@app'   : {
                        templateUrl: 'app/toolbar/layouts/vertical-navigation-fullwidth-toolbar-2/toolbar.html',
                        controller : 'ToolbarController as vm'
                    },
                    'navigation@app': {
                        templateUrl: 'app/navigation/layouts/vertical-navigation-fullwidth-toolbar-2/navigation.html',
                        controller : 'NavigationController as vm'
                    },
/*                    'quickPanel@app': {
                        templateUrl: 'app/quick-panel/quick-panel.html',
                        controller : 'QuickPanelController as vm'
                    },*/
                    'message@app': {
                        templateUrl: 'app/message/message.html',
                        controller : 'MessageController as vm'
                    }, 
                    'progress@app': {
                        templateUrl: 'app/progress/progress.html',
                        controller : 'ProgressController as vm'
                    },                    
                }
            });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('fuse')
        .controller('IndexController', IndexController);

    /** @ngInject */
    function IndexController(fuseTheming, UICtrlService, Const, $scope, $rootScope, $state)
    {
        var vm = this;
        // Data
        vm.themes = fuseTheming.themes;
        
        init();

        function init(){
            $scope.index = {title:Const.logo.title,logo:Const.logo.initial};
            $scope.title = "asdfadsf";
        }  
    }
})();
(function ()
{
	'use strict';

	angular
		.module('fuse')
		.constant('ApiConst',{

			productDomain: "www.autocart.ca",
			productBackupDomain: "backup.autocart.ca",
			testDomain: "test.autocart.ca",

			http:  window.location.protocol + "//",
			//test
			//host: window.location.host == 'localhost:3002'? 'localhost:3001' : window.location.host,
			//prod
			host: window.location.host == 'localhost:3001'? 'localhost:3000' : window.location.host,

			apiPortoal: "api",

			apiVersion:"v1",

			socketIoPath: "/api/v1/socket.io",

			resources:{
				companies:{
					resourceName:"companies",
					urlParamName:"companyID"
				},				
				users:{
					resourceName:"users",
					urlParamName:"userID"
				},
				profileImages:{
					resourceName:"profileimages",
					urlParamName:"profileimageID"
				},
				presetFeatures:{
					resourceName:"presetfeatures",
					urlParamName:"presetfeatureID"
				},	
				auctions:{
					resourceName:"auctions",
					urlParamName:"auctionID"
				},								
				vehicles:{
					resourceName:"vehicles",
					urlParamName:"vehicleID"
				},
				customerportalslider:{
					resourceName:"customerportalslider",
					urlParamName:"customerportalsliderID"
				},
				servicescategory:{
					resourceName:"servicesCatogory",
					urlParamName:"servicesCatogoryID"
				},
				vehiclePresetFeatures:{
					resourceName:"vehiclepresetfeatures",
					urlParamName:"vehiclepresetfeatureID"
				},
				vehicleUniqueFeatures:{
					resourceName:"vehicleuniquefeatures",
					urlParamName:"vehicleuniquefeatureID"
				},				
				vehicleImages:{
					resourceName:"images",
					urlParamName:"imageID"
				},
				vehicleFiles:{
					resourceName:"vehiclefiles",
					urlParamName:"vehiclefileID"
				},
				purchaseInfos:{
					resourceName:"purchaseinfos",
					urlParamName:"purchaseinfoID"
				},
				customers:{
					resourceName:"customers",
					urlParamName:"customerID"
				}	,
				tasks:{
					resourceName:"tasks",
					urlParamName:"taskID"
				},
				saleInfos:{
					resourceName:"saleinfos",
					urlParamName:"saleinfoID"
				},
				payments:{
					resourceName:"payments",
					urlParamName:"paymentID"
				},
				files:{
					resourceName:"files",
					urlParamName:"fileID"
				},				
				safeties:{
					resourceName:"safeties",
					urlParamName:"safetyID"
				},				
				safetyImages:{
					resourceName:"images",
					urlParamName:"imageID"
				},				
				purchaseInvoice:{
					resourceName:"purchaseinvoices",
					urlParamName:"purchaseinvoiceID"
				},
				returnInvoice:{
					resourceName:"returninvoices",
					urlParamName:"returninvoiceID"
				},			
				workOrder:{
					resourceName:"workorders",
					urlParamName:"workorderID"
				}						
			},

			nonResources:{

				login:{
					name:"login"
				},

				check:{
					name:"check",
					params:{
	                    tableName:"tableName",
	                    columnName:"columnName",
	                    value:"value"						
					}
				},

				download:{
					name:"download"
				}
			}
		});
})();

(function ()
{
    'use strict';

    angular
        .module('fuse')
        .config(config);

    /** @ngInject */
    function config($translateProvider, momentPickerProvider,  $mdAriaProvider)
    {
        // Put your common app configurations here

        // angular-translate configuration
        $translateProvider.useLoader('$translatePartialLoader', {
            urlTemplate: '{part}/i18n/{lang}.json'
        });
        $translateProvider.preferredLanguage('en');
        $translateProvider.useSanitizeValueStrategy('sanitize');

        momentPickerProvider.options({
            minutesFormat: "LT",
            hoursFormat:"h a"
        });

        $mdAriaProvider.disableWarnings();
    }

})();
(function () {
	'use strict';

	angular
		.module('fuse')
		.factory('api', apiService);


	/** @ngInject */
	function apiService($resource, ApiConst, LoginService, $q, Const, WorkOrder, WorkOrderPart, WorkOrderInventory, Labor, miscfeestypes, jobtypes, WorkOrderDiscount, WorkOrderLog, WorkOrderCoupon, WorkOrderPayment, $location, Coupon, PartTypesClass) {
		/*		var _token;
				var factory = {};
				factory.getApi = function() {*//**
		 * You can use this service to define your API urls. The "api" service
		 * is designed to work in parallel with "apiResolver" service which you can
		 * find in the "app/core/services/api-resolver.service.js" file.
		 *
		 * You can structure your API urls whatever the way you want to structure them.
		 * You can either use very simple definitions, or you can use multi-dimensional
		 * objects.
		 *
		 * Here's a very simple API url definition example:
		 *
		 *	  api.getBlogList = $resource('http://api.example.com/getBlogList');
		 *
		 * While this is a perfectly valid $resource definition, most of the time you will
		 * find yourself in a more complex situation where you want url parameters:
		 *
		 *	  api.getBlogById = $resource('http://api.example.com/blog/:id', {id: '@id'});
		 *
		 * You can also define your custom methods. Custom method definitions allow you to
		 * add hardcoded parameters to your API calls that you want to sent every time you
		 * make that API call:
		 *
		 *	  api.getBlogById = $resource('http://api.example.com/blog/:id', {id: '@id'}, {
		 *		 'getFromHomeCategory' : {method: 'GET', params: {blogCategory: 'home'}}
		 *	  });
		 *
		 * In addition to these definitions, you can also create multi-dimensional objects.
		 * They are nothing to do with the $resource object, it's just a more convenient
		 * way that we have created for you to packing your related API urls together:
		 *
		 *	  api.blog = {
		 *				   list	 : $resource('http://api.example.com/blog'),
		 *				   getById  : $resource('http://api.example.com/blog/:id', {id: '@id'}),
		 *				   getByDate: $resource('http://api.example.com/blog/:date', {id: '@date'}, {
		 *					   get: {
		 *							method: 'GET',
		 *							params: {
		 *								getByDate: true
		 *							}
		 *					   }
		 *				   })
		 *	   }
		 *
		 * If you look at the last example from above, we overrode the 'get' method to put a
		 * hardcoded parameter. Now every time we make the "getByDate" call, the {getByDate: true}
		 * object will also be sent along with whatever data we are sending.
		 *
		 * All the above methods are using standard $resource service. You can learn more about
		 * it at: https://docs.angularjs.org/api/ngResource/service/$resource
		 *
		 * -----
		 *
		 * After you defined your API urls, you can use them in Controllers, Services and even
		 * in the UIRouter state definitions.
		 *
		 * If we use the last example from above, you can do an API call in your Controllers and
		 * Services like this:
		 *
		 *	  function MyController (api)
		 *	  {
		 *		  // Get the blog list
		 *		  api.blog.list.get({},
		 *
		 *			  // Success
		 *			  function (response)
		 *			  {
		 *				  console.log(response);
		 *			  },
		 *
		 *			  // Error
		 *			  function (response)
		 *			  {
		 *				  console.error(response);
		 *			  }
		 *		  );
		 *
		 *		  // Get the blog with the id of 3
		 *		  var id = 3;
		 *		  api.blog.getById.get({'id': id},
		 *
		 *			  // Success
		 *			  function (response)
		 *			  {
		 *				  console.log(response);
		 *			  },
		 *
		 *			  // Error
		 *			  function (response)
		 *			  {
		 *				  console.error(response);
		 *			  }
		 *		  );
		 *
		 *		  // Get the blog with the date by using custom defined method
		 *		  var date = 112314232132;
		 *		  api.blog.getByDate.get({'date': date},
		 *
		 *			  // Success
		 *			  function (response)
		 *			  {
		 *				  console.log(response);
		 *			  },
		 *
		 *			  // Error
		 *			  function (response)
		 *			  {
		 *				  console.error(response);
		 *			  }
		 *		  );
		 *	  }
		 *
		 * Because we are directly using $resource service, all your API calls will return a
		 * $promise object.
		 *
		 * --
		 *
		 * If you want to do the same calls in your UI Router state definitions, you need to use
		 * "apiResolver" service we have prepared for you:
		 *
		 *	  $stateProvider.state('app.blog', {
		 *		  url	  : '/blog',
		 *		  views	: {
		 *			   'content@app': {
		 *				   templateUrl: 'app/main/apps/blog/blog.html',
		 *				   controller : 'BlogController as vm'
		 *			   }
		 *		  },
		 *		  resolve  : {
		 *			  Blog: function (apiResolver)
		 *			  {
		 *				  return apiResolver.resolve('blog.list@get');
		 *			  }
		 *		  }
		 *	  });	 
		 *
		 *  You can even use parameters with apiResolver service:
		 *
		 *	  $stateProvider.state('app.blog.show', {
		 *		  url	  : '/blog/:id',
		 *		  views	: {
		 *			   'content@app': {
		 *				   templateUrl: 'app/main/apps/blog/blog.html',
		 *				   controller : 'BlogController as vm'
		 *			   }
		 *		  },
		 *		  resolve  : {
		 *			  Blog: function (apiResolver, $stateParams)
		 *			  {
		 *				  return apiResolver.resolve('blog.getById@get', {'id': $stateParams.id);
		 *			  }
		 *		  }
		 *	  });
		 *
		 *  And the "Blog" object will be available in your BlogController:
		 *
		 *	  function BlogController(Blog)
		 *	  {
		 *		  var vm = this;
		 *
		 *		  // Data
		 *		  vm.blog = Blog;
		 *
		 *		  ...
		 *	  }
		 */
		const codeKey = Const.header.code;
		const messageKey = Const.header.message;
		const successCode = Const.code.success;
		const xhrStatusAbort = Const.xhrStatus.abort;

		var host = ApiConst.host;
		var http = ApiConst.http;

		var apiPortoal = ApiConst.apiPortoal;
		var apiVersion = ApiConst.apiVersion;

		var baseUrl = http + host + '/' + apiPortoal + '/' + apiVersion + '/';

		var api = {};

		var header = {}
		header.token = LoginService.getToken();
		header["Cache-Control"] = "no-cache, no-store, must-revalidate";
		header["Pragma"] = "no-cache";
		header["Expires"] = 0;

		var accessingUrl = ""
		accessingUrl += $location.$$absUrl

		if(accessingUrl.includes("?qr=true")){
			window.localStorage.setItem('accessingWorkOrderWothQRCode', 'true');
			window.localStorage.setItem('accessingWorkOrderWothQRCodeURL', accessingUrl);
		}else{
			window.localStorage.removeItem("accessingWorkOrderWothQRCode");
			window.localStorage.removeItem("accessingWorkOrderWothQRCodeURL");
		}

		api.login = $resource(baseUrl + "login");

		api.users = $resource(
			baseUrl + "companies/:companyID/users/:userID",
			{
				companyID: "@companyID",
				userID: "@userID"
			},
			{
				getUsers: {
					method: "GET",
					isArray: true,
					headers: header
				},
				getUser: {
					method: "GET",
					isArray: true,
					headers: header
				},
				addUser: {
					method: "POST",
					headers: {
						token: LoginService.getToken()
					}
				},
				updateUser: {
					method: "PUT",
					headers: {
						token: LoginService.getToken()
					}
				},
				deleteUser: {
					method: "DELETE",
					headers: {
						token: LoginService.getToken()
					}
				}
			});

		api.customeregistration = $resource(
			baseUrl + "companies/:companyID/vehicles/:vehicleID/customers/:customerVehicleID",
			{
				companyID: "@companyID",
				vehicleID: "@vehicleID",
				customerVehicleID: "@customerVehicleID"
			},
			{
				sendCustomerRegistrationEmail: {
					method: "POST",
					headers: {
						token: LoginService.getToken()
					}
				},
			});

		api.labour = $resource(
			baseUrl + "companies/:companyID/labour/:labourTypesID",
			{
				companyID: "@companyID",
				labourTypesID: "@labourTypesID",
			},
			{
				getLabour: {
					method: "GET",
					isArray: true,
					headers: header,
					interceptor: {
						response: function (result) {
							var statusCode = result.headers(codeKey);

							if (statusCode != successCode) {
								var errorMessage = statusCode + ': ' + result.headers(messageKey);
								console.error("Failed to get labour.");
								return $q.reject(errorMessage);
							}

							return result.data.map(function (data) {
								var labour = new Labor();
								labour.setAttributes(data);
								return labour;
							});
						},
						responseError: function (error) {
							if (error && error.xhrStatus == xhrStatusAbort) {
								return $q.reject();
							}
							console.error("Failed to get labour.");
							return $q.reject(error);
						}
					}
				},
				getlabourr: {
					method: "GET",
					isArray: true,
					headers: header
				},
				addLabour: {
					method: "POST",
					headers: {
						token: LoginService.getToken()
					}
				},
				updateLabour: {
					method: "PUT",
					headers: {
						token: LoginService.getToken()
					}
				},
				deleteLabour: {
					method: "DELETE",
					headers: {
						token: LoginService.getToken()
					}
				}
			});


		api.parttype = $resource(
			baseUrl + "companies/:companyID/parttype/:parttypesID",
			{
				companyID: "@companyID",
				parttypesID: "@parttypesID",
			},
			{
				getparttypes: {
					method: "GET",
					isArray: true,
					headers: header,
					interceptor: {
						response: function (result) {
							var statusCode = result.headers(codeKey);

							if (statusCode != successCode) {
								var errorMessage = statusCode + ': ' + result.headers(messageKey);
								console.error("Failed to get Part Type.");
								return $q.reject(errorMessage);
							}

							return result.data.map(function (data) {
								var labour = new PartTypesClass();
								labour.setAttributes(data);
								return labour;
							});
						},
						responseError: function (error) {
							if (error && error.xhrStatus == xhrStatusAbort) {
								return $q.reject();
							}
							console.error("Failed to get Part Type.");
							return $q.reject(error);
						}
					}

				},
				// getlabourr:{
				// 	method:"GET",
				// 	isArray:true,
				// 	headers: header
				// },
				createparttype: {
					method: "POST",
					headers: {
						token: LoginService.getToken()
					}
				},
				updateparttype: {
					method: "PUT",
					headers: {
						token: LoginService.getToken()
					}
				},
				deleteparttype: {
					method: "DELETE",
					headers: {
						token: LoginService.getToken()
					}
				}
			});

		api.miscfeestypes = $resource(
			baseUrl + "companies/:companyID/vehicles/:vehicleID/workorders/:workorderID/miscfeestypes/:miscfeeID",
			{
				companyID: "@companyID",
				vehicleID: "@vehicleID",
				workorderID: "@workorderID",
				miscfeeID: "@miscfeeID",


			},
			{
				getmiscfeestypes: {
					method: "GET",
					isArray: true,
					headers: header,
					cancellable: true,
					interceptor: {
						response: function (result) {
							var statusCode = result.headers(codeKey);

							if (statusCode != successCode) {
								var errorMessage = statusCode + ': ' + result.headers(messageKey);
								console.error("Failed to get Misc Fees.");
								return $q.reject(errorMessage);
							}

							return result.data.map(function (data) {
								var mimiscfeestypesscfees = new miscfeestypes();
								mimiscfeestypesscfees.setAttributes(data);
								return mimiscfeestypesscfees;
							});
						},
						responseError: function (error) {
							if (error && error.xhrStatus == xhrStatusAbort) {
								return $q.reject();
							}
							console.error("Failed to Misc Fees.");
							return $q.reject(error);
						}
					}
				},
				createmiscfeestypes: {
					method: "POST",
					headers: {
						token: LoginService.getToken()
					}
				},
				updatemiscfeestypes: {
					method: "PUT",
					headers: {
						token: LoginService.getToken()
					}
				},
				deletemiscfeestypes: {
					method: "DELETE",
					headers: {
						token: LoginService.getToken()
					}
				}
			});

		api.jobtypes = $resource(
			baseUrl + "companies/:companyID/jobtypes/:jobTypesID",
			{
				companyID: "@companyID",
				jobTypesID: "@jobTypesID",


			},
			{
				getJob: {
					method: "GET",
					isArray: true,
					headers: header,
					cancellable: true,
					interceptor: {
						response: function (result) {
							var statusCode = result.headers(codeKey);

							if (statusCode != successCode) {
								var errorMessage = statusCode + ': ' + result.headers(messageKey);
								console.error("Failed to get Job types.");
								return $q.reject(errorMessage);
							}

							return result.data.map(function (data) {
								var jobtype = new jobtypes();

								jobtype.setAttributes(data);
								return jobtype;
							});
						},
						responseError: function (error) {
							if (error && error.xhrStatus == xhrStatusAbort) {
								return $q.reject();
							}
							console.error("Failed to Misc Fees.");
							return $q.reject(error);
						}
					}
				},
				deleteJob: {
					method: "DELETE",
					headers: {
						token: LoginService.getToken()
					}
				},
				updateJob: {
					method: "PUT",
					headers: {
						token: LoginService.getToken()
					}
				},
				createJob: {
					method: "POST",
					headers: {
						token: LoginService.getToken()
					}
				},
			}
		)

		api.batchVehicleFeatures = $resource(
			baseUrl + "companies/:companyID/vehicles/:vehicleID/batchvehiclefeatures",
			{
				companyID: "@companyID",
				vehicleID: "@vehicleID"
			},
			{
				createFeatures: {
					method: "POST",
					headers: {
						token: LoginService.getToken()
					}
				}
			});

		api.vehicleFeatures = $resource(
			baseUrl + "companies/:companyID/vehicles/:vehicleID/vehiclefeatures/:vehiclefeatureID",
			{
				companyID: "@companyID",
				vehicleID: "@vehicleID",
				vehiclefeatureID: "@vehiclefeatureID"
			},
			{
				getFeatures: {
					method: "GET",
					isArray: true,
					headers: header
				},
				createFeature: {
					method: "POST",
					headers: {
						token: LoginService.getToken()
					}
				},
				deleteFeature: {
					method: "DELETE",
					headers: {
						token: LoginService.getToken()
					}
				}
			});

		api.vehicles = $resource(
			baseUrl + "companies/:companyID/vehicles/:vehicleID",
			{
				companyID: "@companyID",
				vehicleID: "@vehicleID"
			},
			{
				getVehicle: {
					method: "GET",
					isArray: true,
					headers: header
				},
				addVehicle: {
					method: "POST",
					headers: {
						token: LoginService.getToken()
					}
				},
				updateVehicle: {
					method: "PUT",
					headers: {
						token: LoginService.getToken()
					}
				},
				deleteVehicle: {
					method: "DELETE",
					headers: {
						token: LoginService.getToken()
					}
				}
			});

		api.vehiclesWasAvailable = $resource(
			baseUrl + "companies/:companyID/vehicles/wasavailableon",
			{
				companyID: "@companyID"
			},
			{
				getVehicle: {
					method: "GET",
					isArray: true,
					headers: header
				}
			});

		api.mergeVehicle = $resource(
			baseUrl + "companies/:companyID/vehicles/:vehicleID/merge?destinationVehicleID=:destinationVehicleID",
			{
				companyID: "@companyID",
				vehicleID: "@vehicleID",
				destinationVehicleID: "@destinationVehicleID"
			},
			{
				merge: {
					method: "PUT",
					headers: {
						token: LoginService.getToken()
					}
				}
			});

		api.vehicleInventoryInfo = $resource(
			baseUrl + "companies/:companyID/vehicles/getinventoryinfo",
			{
				companyID: "@companyID"
			},
			{
				getInventoryInfo: {
					method: "GET",
					isArray: true,
					headers: header
				}
			});

		api.vehicleCommonParts = $resource(
			baseUrl + "companies/:companyID/vehicles/commentparts",
			{
				companyID: "@companyID"
			},
			{
				getCommonParts: {
					method: "GET",
					isArray: true,
					headers: header
				}
			});

		api.vehicleCommonPartsFromInventory = $resource(
			baseUrl + "companies/:companyID/vehicles/commentpartsfrominventory",
			{
				companyID: "@companyID"
			},
			{
				getCommonParts: {
					method: "GET",
					isArray: true,
					headers: header
				}
			});

		api.vehicleMostRecentParts = $resource(
			baseUrl + "companies/:companyID/vehicles/mostrecentparts",
			{
				companyID: "@companyID"
			},
			{
				getMostRecentParts: {
					method: "GET",
					isArray: true,
					headers: header
				}
			});

		api.vehicleMostRecentPartsFromInventory = $resource(
			baseUrl + "companies/:companyID/vehicles/mostrecentpartsfrominventory",
			{
				companyID: "@companyID"
			},
			{
				getMostRecentParts: {
					method: "GET",
					isArray: true,
					headers: header
				}
			});

		api.vehicleMostRecentLabourFromPastWorkOrder = $resource(
				baseUrl + "companies/:companyID/vehicles/mostrecentlabourfrompastworkorder",
				{
					companyID: "@companyID"
				},
				{
					getMostRecentLabourFromPastWorkOrder: {
						method: "GET",
						isArray: true,
						headers: header
					}
			});

		api.vehicleMostRecentMiscfeeFromPastWorkOrder = $resource(
				baseUrl + "companies/:companyID/vehicles/mostrecentmiscfeefrompastworkorder",
				{
					companyID: "@companyID"
				},
				{
					getMostRecentMiscfeeFromPastWorkOrder: {
						method: "GET",
						isArray: true,
						headers: header
					}
			});

		api.vehicleImages = $resource(
			baseUrl + "companies/:companyID/vehicles/:vehicleID/images/:imageID",
			{
				companyID: "@companyID",
				vehicleID: "@vehicleID",
				imageID: "@imageID"
			},
			{
				getImage: {
					method: "GET",
					isArray: true,
					headers: header
				},
				deleteImage: {
					method: "DELETE",
					headers: {
						token: LoginService.getToken()
					}
				},
				updateImage: {
					method: "PUT",
					headers: {
						token: LoginService.getToken()
					}
				}
			});


		api.presetFeatures = $resource(
			baseUrl + "companies/:companyID/vehiclefeatures/:vehiclefeatureID",
			{
				companyID: "@companyID",
				vehiclefeatureID: "@vehiclefeatureID"
			},
			{
				getFeatures: {
					method: "GET",
					isArray: true,
					headers: header
				}
			});

		api.vehicleFiles = $resource(
			baseUrl + "companies/:companyID/vehicles/:vehicleID/files/:fileID",
			{
				companyID: "@companyID",
				vehicleID: "@vehicleID",
				fileID: "@fileID"
			},
			{
				getVehicleFiles: {
					method: "GET",
					isArray: true,
					headers: header
				},
				deleteVehicleFile: {
					method: "DELETE",
					headers: {
						token: LoginService.getToken()
					}
				}
			});

		api.customers = $resource(
			baseUrl + "companies/:companyID/customers/:customerID",
			{
				companyID: "@companyID",
				customerID: "@customerID"
			},
			{
				getCustomers: {
					method: "GET",
					isArray: true,
					headers: header
				},
				createCustomer: {
					method: "POST",
					headers: {
						token: LoginService.getToken()
					}
				},
				updateCustomer: {
					method: "PUT",
					headers: {
						token: LoginService.getToken()
					}
				},
				deleteCustomer: {
					method: "DELETE",
					headers: {
						token: LoginService.getToken()
					}
				}
			});

		api.testDrives = $resource(
			baseUrl + "companies/:companyID/customers/:customerID/testdrives/:testdriveID",
			{
				companyID: "@companyID",
				customerID: "@customerID",
				testdriveID: "@testdriveID"
			},
			{
				getTestDrives: {
					method: "GET",
					isArray: true,
					headers: header
				},
				createTestDrive: {
					method: "POST",
					headers: {
						token: LoginService.getToken()
					}
				},
				deleteTestDrive: {
					method: "DELETE",
					headers: {
						token: LoginService.getToken()
					}
				}
			});

		api.customerFiles = $resource(
			baseUrl + "companies/:companyID/customers/:customerID/files/:fileID",
			{
				companyID: "@companyID",
				customerID: "@customerID",
				fileID: "@fileID"
			},
			{
				getFiles: {
					method: "GET",
					isArray: true,
					headers: header
				},
				deleteFile: {
					method: "DELETE",
					headers: {
						token: LoginService.getToken()
					}
				}
			});



		api.customerProfileImageInfo = $resource(
			baseUrl + "companies/:companyID/customers/:customerID/profileimage",
			{
				companyID: "@companyID",
				customerID: "@customerID"
			},
			{
				getInfo: {
					method: "GET",
					headers: header
				}
			});

		api.downloadCustomerProfileImage = $resource(
			baseUrl + "companies/:companyID/customers/:customerID/profileimage/:uuid/download",
			{
				companyID: "@companyID",
				customerID: "@customerID",
				uuid: "@uuid"
			},
			{
				download: {
					method: "GET",
					headers: header
				}
			});

		api.customerLicenseImageInfo = $resource(
			baseUrl + "companies/:companyID/customers/:customerID/licenseimage",
			{
				companyID: "@companyID",
				customerID: "@customerID"
			},
			{
				getInfo: {
					method: "GET",
					headers: header
				}
			});

		api.downloadCustomerLicenseImage = $resource(
			baseUrl + "companies/:companyID/customers/:customerID/licenseimage/:uuid/download",
			{
				companyID: "@companyID",
				customerID: "@customerID",
				uuid: "@uuid"
			},
			{
				download: {
					method: "GET",
					headers: header
				}
			});

		api.auction = $resource(
			baseUrl + "companies/:companyID/auctions/:auctionID",
			{
				companyID: "@companyID",
				auctionID: "@auctionID"
			},
			{
				getAuction: {
					method: "GET",
					isArray: true,
					headers: header
				}
			});

		api.purchaseInfo = $resource(
			baseUrl + "companies/:companyID/vehicles/:vehicleID/purchaseinfos/:purchaseinfoID",
			{
				companyID: "@companyID",
				vehicleID: "@vehicleID",
				purchaseinfoID: "@purchaseinfoID"
			},
			{
				getPurchaseInfos: {
					method: "GET",
					isArray: true,
					headers: header
				},
				createPurchaseInfo: {
					method: "POST",
					headers: {
						token: LoginService.getToken()
					}
				},
				updatePurchaseInfo: {
					method: "PUT",
					headers: {
						token: LoginService.getToken()
					}
				},
				deletePurchaseInfo: {
					method: "DELETE",
					headers: {
						token: LoginService.getToken()
					}
				}
			});

		api.purchaseDisclosure = $resource(
			baseUrl + "companies/:companyID/vehicles/:vehicleID/purchaseinfos/:purchaseinfoID/disclosures/:disclosureID",
			{
				companyID: "@companyID",
				vehicleID: "@vehicleID",
				purchaseinfoID: "@purchaseinfoID",
				disclosureID: "@disclosureID"
			},
			{
				getDisclosures: {
					method: "GET",
					isArray: true,
					headers: header
				},
				createDisclosure: {
					method: "POST",
					headers: {
						token: LoginService.getToken()
					}
				},
				deleteDisclosure: {
					method: "DELETE",
					headers: {
						token: LoginService.getToken()
					}
				}
			});

		api.purchaseInfoFile = $resource(
			baseUrl + "companies/:companyID/vehicles/:vehicleID/purchaseinfos/:purchaseinfoID/files/:fileID",
			{
				companyID: "@companyID",
				vehicleID: "@vehicleID",
				purchaseinfoID: "@purchaseinfoID",
				fileID: "@fileID"
			},
			{
				getFiles: {
					method: "GET",
					isArray: true,
					headers: header
				},
				deleteFile: {
					method: "DELETE",
					headers: {
						token: LoginService.getToken()
					}
				}
			});

		api.files = $resource(
			baseUrl + "files",
			{},
			{
				getFileByUUID: {
					method: "GET",
					headers: header
				}
			});

		api.tasks = $resource(
			baseUrl + "companies/:companyID/tasks/:taskID",
			{
				companyID: "@companyID",
				taskID: "@taskID"
			},
			{
				getTasks: {
					method: "GET",
					isArray: true,
					headers: header
				},
				createTask: {
					method: "POST",
					headers: {
						token: LoginService.getToken()
					}
				},
				updateTask: {
					method: "PUT",
					headers: {
						token: LoginService.getToken()
					}
				},
				deleteTask: {
					method: "DELETE",
					headers: {
						token: LoginService.getToken()
					}
				}
			});

		api.taskFiles = $resource(
			baseUrl + "companies/:companyID/tasks/:taskID/files/:fileID",
			{
				companyID: "@companyID",
				taskID: "@taskID",
				fileID: "@fileID"
			},
			{
				getFiles: {
					method: "GET",
					isArray: true,
					headers: header
				},
				deleteFile: {
					method: "DELETE",
					headers: {
						token: LoginService.getToken()
					}
				}
			});

		api.financeApplications = $resource(
			baseUrl + "companies/:companyID/financeapplications/:financeapplicationID",
			{
				companyID: "@companyID",
				financeapplicationID: "@financeapplicationID"
			},
			{
				getFinanceApplications: {
					method: "GET",
					isArray: true,
					headers: header
				},
				createFinanceApplication: {
					method: "POST",
					headers: {
						token: LoginService.getToken()
					}
				},
				updateFinanceApplication: {
					method: "PUT",
					headers: {
						token: LoginService.getToken()
					}
				},
				deleteFinanceApplication: {
					method: "DELETE",
					headers: {
						token: LoginService.getToken()
					}
				}
			});

		api.safety = $resource(
			baseUrl + "companies/:companyID/vehicles/:vehicleID/safeties/:safetyID",
			{
				companyID: "@companyID",
				vehicleID: "@vehicleID",
				safetyID: "@safetyID"
			},
			{
				getSafeties: {
					method: "GET",
					isArray: true,
					headers: header
				},
				createSafety: {
					method: "POST",
					headers: {
						token: LoginService.getToken()
					}
				},
				updateSafety: {
					method: "PUT",
					headers: {
						token: LoginService.getToken()
					}
				},
				deleteSafety: {
					method: "DELETE",
					headers: {
						token: LoginService.getToken()
					}
				}
			});

		api.safetyImages = $resource(
			baseUrl + "companies/:companyID/vehicles/:vehicleID/safeties/:safetyID/images/:imageID",
			{
				companyID: "@companyID",
				vehicleID: "@vehicleID",
				safetyID: "@safetyID",
				imageID: "@imageID"
			},
			{
				getImages: {
					method: "GET",
					isArray: true,
					headers: header
				},
				deleteImage: {
					method: "DELETE",
					headers: {
						token: LoginService.getToken()
					}
				}
			});

		api.vehicleSaleInfos = $resource(
			baseUrl + "companies/:companyID/vehicles/:vehicleID/saleinfos/:saleinfoID",
			{
				companyID: "@companyID",
				vehicleID: "@vehicleID",
				saleinfoID: "@saleinfoID"
			},
			{
				getVehicleSaleInfos: {
					method: "GET",
					isArray: true,
					headers: header
				},
				createVehicleSaleInfo: {
					method: "POST",
					headers: {
						token: LoginService.getToken()
					}
				},
				updateVehicleSaleInfo: {
					method: "PUT",
					headers: {
						token: LoginService.getToken()
					}
				},
				deleteVehicleSaleInfo: {
					method: "DELETE",
					headers: {
						token: LoginService.getToken()
					}
				}
			});

		api.pickupAccess = $resource(
			baseUrl + "companies/:companyID/pickup/vehicles/:vehicleID/saleinfos/:saleinfoID/",
			{
				companyID: "@companyID",
				vehicleID: "@vehicleID",
				saleinfoID: "@saleinfoID"
			},
			{
				createPickupAccess: {
					method: "POST",
					headers: {
						token: LoginService.getToken()
					}
				}
			});

		api.saleInfos = $resource(
			baseUrl + "companies/:companyID/saleinfos/:saleinfoID",
			{
				companyID: "@companyID",
				saleinfoID: "@saleinfoID"
			},
			{
				getSaleInfos: {
					method: "GET",
					isArray: true,
					headers: header
				},
				createSaleInfo: {
					method: "POST",
					headers: {
						token: LoginService.getToken()
					}
				},
				updateSaleInfo: {
					method: "PUT",
					headers: {
						token: LoginService.getToken()
					}
				},
				deleteSaleInfo: {
					method: "DELETE",
					headers: {
						token: LoginService.getToken()
					}
				}
			});

		api.saleDisclosure = $resource(
			baseUrl + "companies/:companyID/vehicles/:vehicleID/saleinfos/:saleinfoID/disclosures/:disclosureID",
			{
				companyID: "@companyID",
				vehicleID: "@vehicleID",
				saleinfoID: "@saleinfoID",
				disclosureID: "@disclosureID"
			},
			{
				getDisclosures: {
					method: "GET",
					isArray: true,
					headers: header
				},
				createDisclosure: {
					method: "POST",
					headers: {
						token: LoginService.getToken()
					}
				},
				deleteDisclosure: {
					method: "DELETE",
					headers: {
						token: LoginService.getToken()
					}
				}
			});

		api.tradeInVehicles = $resource(
			baseUrl + "companies/:companyID/vehicles/:vehicleID/saleinfos/:saleinfoID/tradeinvehicles/:tradeinvehicleID",
			{
				companyID: "@companyID",
				vehicleID: "@vehicleID",
				saleinfoID: "@saleinfoID",
				tradeinvehicleID: "@tradeinvehicleID",
			},
			{
				getTradeInVehicles: {
					method: "GET",
					isArray: true,
					headers: header
				},
				createTradeInVehicle: {
					method: "POST",
					headers: {
						token: LoginService.getToken()
					}
				},
				updateTradeInVehicle: {
					method: "PUT",
					headers: {
						token: LoginService.getToken()
					}
				},
				deleteTradeInVehicle: {
					method: "DELETE",
					headers: {
						token: LoginService.getToken()
					}
				}
			});

		api.saleWarranties = $resource(
			baseUrl + "companies/:companyID/vehicles/:vehicleID/saleinfos/:saleinfoID/warranties/:warrantyID",
			{
				companyID: "@companyID",
				vehicleID: "@vehicleID",
				saleinfoID: "@saleinfoID",
				warrantyID: "@warrantyID",
			},
			{
				getWrranties: {
					method: "GET",
					isArray: true,
					headers: header
				},
				createWarranty: {
					method: "POST",
					headers: {
						token: LoginService.getToken()
					}
				},
				updateWarranty: {
					method: "PUT",
					headers: {
						token: LoginService.getToken()
					}
				},
				deleteWarranty: {
					method: "DELETE",
					headers: {
						token: LoginService.getToken()
					}
				}
			});


		api.saleExtras = $resource(
			baseUrl + "companies/:companyID/vehicles/:vehicleID/saleinfos/:saleinfoID/saleextras/:saleextraID",
			{
				companyID: "@companyID",
				vehicleID: "@vehicleID",
				saleinfoID: "@saleinfoID",
				saleextraID: "@saleextraID",
			},
			{
				getExtras: {
					method: "GET",
					isArray: true,
					headers: header
				},
				createExtra: {
					method: "POST",
					headers: {
						token: LoginService.getToken()
					}
				},
				deleteExtra: {
					method: "DELETE",
					headers: {
						token: LoginService.getToken()
					}
				}
			});
		api.promotions = $resource(
			baseUrl + "companies/:companyID/promotions/:promotionID",
			{
				companyID: "@companyID",
				promotionID: "@promotionID"
			},
			{
				getPromotion: {
					method: "GET",
					isArray: true,
					headers: header
				}
			});

		api.salePromotions = $resource(
			baseUrl + "companies/:companyID/vehicles/:vehicleID/saleinfos/:saleinfoID/promotions/:promotionID",
			{
				companyID: "@companyID",
				vehicleID: "@vehicleID",
				saleinfoID: "@saleinfoID",
				promotionID: "@promotionID",
			},
			{
				getSalePromotion: {
					method: "GET",
					isArray: true,
					headers: header
				},
				createSalePromotion: {
					method: "POST",
					headers: {
						token: LoginService.getToken()
					}
				},
				deleteSalePromotion: {
					method: "DELETE",
					headers: {
						token: LoginService.getToken()
					}
				}
			});

		api.salePayment = $resource(
			baseUrl + "companies/:companyID/vehicles/:vehicleID/saleinfos/:saleinfoID/payments/:paymentID",
			{
				companyID: "@companyID",
				vehicleID: "@vehicleID",
				saleinfoID: "@saleinfoID",
				paymentID: "@paymentID",
			},
			{
				getSalePayments: {
					method: "GET",
					isArray: true,
					headers: header
				},
				createSalePayment: {
					method: "POST",
					headers: {
						token: LoginService.getToken()
					}
				},
				deleteSalePayment: {
					method: "DELETE",
					headers: {
						token: LoginService.getToken()
					}
				}
			});

		api.saleInfoFiles = $resource(
			baseUrl + "companies/:companyID/vehicles/:vehicleID/saleinfos/:saleinfoID/files/:fileID",
			{
				companyID: "@companyID",
				vehicleID: "@vehicleID",
				saleinfoID: "@saleinfoID",
				fileID: "@fileID",
			},
			{
				getFiles: {
					method: "GET",
					isArray: true,
					headers: header
				},
				postFile: {
					method: "POST",
					headers: {
						token: LoginService.getToken()
					}
				},
				deleteFile: {
					method: "DELETE",
					headers: {
						token: LoginService.getToken()
					}
				}
			});

		api.saleInfoSignatures = $resource(
			baseUrl + "companies/:companyID/vehicles/:vehicleID/saleinfos/:saleinfoID/signatures/:signatureID",
			{
				companyID: "@companyID",
				vehicleID: "@vehicleID",
				saleinfoID: "@saleinfoID",
				signatureID: "@signatureID",
			},
			{
				getSignatures: {
					method: "GET",
					isArray: true,
					headers: header
				},
				deleteSignature: {
					method: "DELETE",
					headers: {
						token: LoginService.getToken()
					}
				}
			});

		api.saleInfoSignaturesDetail = $resource(
			baseUrl + "companies/:companyID/vehicles/:vehicleID/saleinfos/:saleinfoID/signatures/:signatureID/fetchdetail",
			{
				companyID: "@companyID",
				vehicleID: "@vehicleID",
				saleinfoID: "@saleinfoID",
				signatureID: "@signatureID",
			},
			{
				fetchDetail: {
					method: "GET",
					headers: header
				}
			});

		api.saleInfoSignatureFile = $resource(
			baseUrl + "companies/:companyID/vehicles/:vehicleID/saleinfos/:saleinfoID/signatures/:signatureID/files",
			{
				companyID: "@companyID",
				vehicleID: "@vehicleID",
				saleinfoID: "@saleinfoID",
				signatureID: "@signatureID",
			},
			{
				getFile: {
					method: "GET",
					isArray: true,
					headers: header
				},
				saveFile: {
					method: "POST",
					headers: header
				}
			});

		api.previewSaleInfoSignatureFile = $resource(
			baseUrl + "companies/:companyID/vehicles/:vehicleID/saleinfos/:saleinfoID/signatures/:signatureID/files/preview",
			{
				companyID: "@companyID",
				vehicleID: "@vehicleID",
				saleinfoID: "@saleinfoID",
				signatureID: "@signatureID",
			},
			{
				fetchFile: {
					method: "GET",
					headers: header
				}
			});


		api.paymentFiles = $resource(
			baseUrl + "companies/:companyID/vehicles/:vehicleID/saleinfos/:saleinfoID/payments/:paymentID/files/:fileID",
			{
				companyID: "@companyID",
				vehicleID: "@vehicleID",
				saleinfoID: "@saleinfoID",
				paymentID: "@paymentID",
				fileID: "@fileID",
			},
			{
				getPaymentFiles: {
					method: "GET",
					isArray: true,
					headers: header
				},
				deletePaymentFiles: {
					method: "DELETE",
					headers: {
						token: LoginService.getToken()
					}
				}
			});

		api.redeemPromotionCode = $resource(
			baseUrl + "companies/:companyID/promotions/redeem",
			{
				companyID: "@companyID"
			},
			{
				redeemCode: {
					method: "GET",
					headers: header
				}
			});


		api.plateOptions = $resource(
			baseUrl + "companies/:companyID/plateoptions/:plateoptionID",
			{
				companyID: "@companyID",
				plateoptionID: "@plateoptionID"
			},
			{
				getPlateOptions: {
					method: "GET",
					isArray: true,
					headers: header
				}
			});

		api.warranties = $resource(
			baseUrl + "companies/:companyID/warranties/:warrantyID",
			{
				companyID: "@companyID",
				warrantyID: "@warrantyID"
			},
			{
				getWrranties: {
					method: "GET",
					isArray: true,
					headers: header
				}
			});

		api.presetExtras = $resource(
			baseUrl + "companies/:companyID/saleextras/:saleextraID",
			{
				companyID: "@companyID",
				saleextraID: "@saleextraID"
			},
			{
				getPresetExtras: {
					method: "GET",
					isArray: true,
					headers: header
				}
			});

		api.locations = $resource(
			baseUrl + "companies/:companyID/locations/:locationID",
			{
				companyID: "@companyID",
				locationID: "@locationID"
			},
			{
				getLocations: {
					method: "GET",
					isArray: true,
					headers: header
				}
			});

		api.embededHellosign = $resource(
			baseUrl + "companies/:companyID/hellosign/getembededurl/:signatureID",
			{
				companyID: "@companyID",
				signatureID: "@signatureID"
			},
			{
				getEmbededUrl: {
					method: "GET",
					headers: header
				}
			});

		api.googleServiceInfo = $resource(
			baseUrl + "companies/:companyID/googleserviceinfo",
			{
				companyID: "@companyID"
			},
			{
				getInfo: {
					method: "GET",
					headers: header
				},
				authorize: {
					method: "POST",
					headers: header
				}
			});

		api.userConfig = $resource(
			baseUrl + "companies/:companyID/users/:userID/config",
			{
				companyID: "@companyID",
				userID: "@userID"
			},
			{
				getConfig: {
					method: "GET",
					headers: header
				},
				updateConfig: {
					method: "PUT",
					headers: header
				}
			});

		api.suppliers = $resource(
			baseUrl + "companies/:companyID/suppliers",
			{
				companyID: "@companyID"
			},
			{
				getSuppliers: {
					method: "GET",
					isArray: true,
					headers: header
				}
			});

		api.purchaseInvoice = $resource(
			baseUrl + "companies/:companyID/purchaseinvoices/:purchaseinvoiceID",
			{
				companyID: "@companyID",
				purchaseinvoiceID: "@purchaseinvoiceID",
			},
			{
				getPurchaseInvoices: {
					method: "GET",
					isArray: true,
					headers: header
				},
				postPurchaseInvoice: {
					method: "POST",
					headers: {
						token: LoginService.getToken()
					}
				},
				updatePurchaseInvoice: {
					method: "PUT",
					headers: {
						token: LoginService.getToken()
					}
				},
				deletePurchaseInvoice: {
					method: "DELETE",
					headers: {
						token: LoginService.getToken()
					}
				}
			});

		api.returnInvoice = $resource(
			baseUrl + "companies/:companyID/returninvoices/:returninvoiceID",
			{
				companyID: "@companyID",
				returninvoiceID: "@returninvoiceID",
			},
			{
				getReturnInvoices: {
					method: "GET",
					isArray: true,
					headers: header
				},
				postReturnInvoice: {
					method: "POST",
					headers: {
						token: LoginService.getToken()
					}
				},
				updateReturnInvoice: {
					method: "PUT",
					headers: {
						token: LoginService.getToken()
					}
				},
				deleteReturnInvoice: {
					method: "DELETE",
					headers: {
						token: LoginService.getToken()
					}
				}
			});

		api.returnInvoiceFile = $resource(
			baseUrl + "companies/:companyID/returninvoices/:returninvoiceID/files/:fileID",
			{
				companyID: "@companyID",
				returninvoiceID: "@returninvoiceID",
				fileID: "@fileID"
			},
			{
				getFiles: {
					method: "GET",
					isArray: true,
					headers: header
				},
				deleteFile: {
					method: "DELETE",
					headers: {
						token: LoginService.getToken()
					}
				}
			});

		api.purchaseInvoiceFile = $resource(
			baseUrl + "companies/:companyID/purchaseinvoices/:purchaseinvoiceID/files/:fileID",
			{
				companyID: "@companyID",
				purchaseinvoiceID: "@purchaseinvoiceID",
				fileID: "@fileID"
			},
			{
				getFiles: {
					method: "GET",
					isArray: true,
					headers: header
				},
				deleteFile: {
					method: "DELETE",
					headers: {
						token: LoginService.getToken()
					}
				}
			});

		api.inventory = $resource(
			baseUrl + "companies/:companyID/inventories/:inventoryID",
			{
				companyID: "@companyID",
				inventoryID: "@inventoryID",
			},
			{
				getInventories: {
					method: "GET",
					isArray: true,
					headers: header
				},
				postInventory: {
					method: "POST",
					headers: {
						token: LoginService.getToken()
					}
				},
				updateInventory: {
					method: "PUT",
					headers: {
						token: LoginService.getToken()
					}
				},
				deleteInventory: {
					method: "DELETE",
					headers: {
						token: LoginService.getToken()
					}
				}
			});

		api.modifyInventoryQuantity = $resource(
			baseUrl + "companies/:companyID/inventories/:inventoryID/modifyquantity",
			{
				companyID: "@companyID",
				inventoryID: "@inventoryID",
			},
			{
				modify: {
					method: "PUT",
					headers: {
						token: LoginService.getToken()
					}
				}
			});



		api.parts = $resource(
			baseUrl + "companies/:companyID/parts/:partID",
			{
				companyID: "@companyID",
				partID: "@partID",
			},
			{
				getParts: {
					method: "GET",
					isArray: true,
					headers: header
				},
				postPart: {
					method: "POST",
					headers: {
						token: LoginService.getToken()
					}
				},
				updatePart: {
					method: "PUT",
					headers: {
						token: LoginService.getToken()
					}
				},
				deletePart: {
					method: "DELETE",
					headers: {
						token: LoginService.getToken()
					}
				}
			});

		api.serviceMaps = $resource(
			baseUrl + "companies/:companyID/servicemaps/:servicemapID",
			{
				companyID: "@companyID",
				servicemapID: "@servicemapID",
			},
			{
				getServiceMaps: {
					method: "GET",
					isArray: true,
					headers: header
				},
				postServiceMap: {
					method: "POST",
					headers: {
						token: LoginService.getToken()
					}
				},
				deleteServiceMap: {
					method: "DELETE",
					headers: {
						token: LoginService.getToken()
					}
				}
			});

		api.companyLevelWorkOrders = $resource(
			baseUrl + "companies/:companyID/workorders/:workorderID",
			{
				companyID: "@companyID",
				workorderID: "@workorderID",
			},
			{
				getWorkOrders: {
					method: "GET",
					isArray: true,
					headers: header
				}
		});

		api.workOrderDetails = $resource(
			baseUrl + "companies/:companyID/vehicles/:vehicleID/details/workorders/:workorderID",
			{
				companyID: "@companyID",
				vehicleID: "@vehicleID",
				workorderID: "@workorderID",
			},
			{
				getWorkOrders: {
					method: "GET",
					isArray: true,
					headers: header,
					cancellable: true,
					interceptor: {
						response: function (result) {
							var statusCode = result.headers(codeKey);

							if (statusCode != successCode) {
								var errorMessage = statusCode + ': ' + result.headers(messageKey);
								console.error("Failed to get workOrder.");
								return $q.reject(errorMessage);
							}

							return result.data.map(function (data) {
								var workOrder = new WorkOrder();

								workOrder.setAttributes(data);
								return workOrder
							});
						},
						responseError: function (error) {
							if (error && error.xhrStatus == xhrStatusAbort) {
								return $q.reject();
							}
							console.error("Failed to get workOrder.");
							return $q.reject(error);
						}
					}
				},
		});

		api.warrantiesOverAllPaymentAmount = $resource(
			baseUrl + "companies/:companyID/overallwarrantypaymentamount",
			{
				companyID: "@companyID",
			},
			{
				getWarrantyPaymentOverallPaymentAmount: {
					method: "GET",
					headers: header
				}
		});
		
		
		api.pendingwarrantiesOverAllPaymentAmount = $resource(
			baseUrl + "companies/:companyID/overallpendingwarrantypaymentamount",
			{
				companyID: "@companyID",
			},
			{
				getPendingWarrantyPaymentOverallPaymentAmount: {
					method: "GET",
					headers: header
				}
		});

		api.reconstructOustandingReportTable = $resource(
			baseUrl + "companies/:companyID/reconstuctingworkorderoutstandingreportpage",
			{
				companyID: "@companyID",
			},
			{
				getReconstructOustandingReportTable: {
					method: "GET",
					headers: header
				}
		});

		api.outstandingOverallPaymentAmount = $resource(
			baseUrl + "companies/:companyID/overalloutstandingpaymentamount",
			{
				companyID: "@companyID",
			},
			{
				getPendingWarrantyPaymentOverallPaymentAmount: {
					method: "GET",
					headers: header
				}
		});

		api.workOrders = $resource(
			baseUrl + "companies/:companyID/vehicles/:vehicleID/workorders/:workorderID",
			{
				companyID: "@companyID",
				vehicleID: "@vehicleID",
				workorderID: "@workorderID",
			},
			{
				getWorkOrders: {
					method: "GET",
					isArray: true,
					headers: header,
					cancellable: true,
					interceptor: {
						response: function (result) {
							var statusCode = result.headers(codeKey);

							if (statusCode != successCode) {
								var errorMessage = statusCode + ': ' + result.headers(messageKey);
								console.error("Failed to get workOrder.");
								return $q.reject(errorMessage);
							}

							return result.data.map(function (data) {
								var workOrder = new WorkOrder();

								workOrder.setAttributes(data);
								return workOrder
							});
						},
						responseError: function (error) {
							if (error && error.xhrStatus == xhrStatusAbort) {
								return $q.reject();
							}
							console.error("Failed to get workOrder.");
							return $q.reject(error);
						}
					}
				},
				postWorkOrder: {
					method: "POST",
					headers: {
						token: LoginService.getToken()
					}
				},
				updateWorkOrder: {
					method: "PUT",
					headers: {
						token: LoginService.getToken()
					}
				},
				recordWorkOrderPrint: {
					method: "PUT",
					headers: {
						token: LoginService.getToken()
					}
				},
				deleteWorkOrder: {
					method: "DELETE",
					headers: {
						token: LoginService.getToken()
					}
				}
		});

		// api.workOrderPdfEmail = $resource(
		// 	baseUrl + "companies/:companyID/vehicles/:vehicleID/workorders/:workorderID/sendworkorderpdfemail",
		// 	{
		// 		companyID: "@companyID",
		// 		vehicleID: "@vehicleID",
		// 		workorderID: "@workorderID",
		// 	},
		// 	{
		// 		sendWorkOrderPDF: {
		// 			method: "PUT",
		// 			headers: {
		// 				token: LoginService.getToken()
		// 			}
		// 		},
		// });

		api.workOrderPdfEmail = $resource(
			baseUrl + "companies/:companyID/vehicles/:vehicleID/workorders/:workorderID/sendworkorderpdfemail",
			{
				companyID: "@companyID",
				vehicleID: "@vehicleID",
				workorderID: "@workorderID",
			},
			{
				sendWorkOrderPDF: {
				method: "PUT",                // POST is safer for multipart
				headers: {
					token: LoginService.getToken(),
					'Content-Type': undefined    // let the browser set multipart boundary
				},
				transformRequest: angular.identity, // don't serialize FormData
				// hasBody: true // (not required, but harmless)
				}
			}
		);

		api.workOrderParts = $resource(
			baseUrl + "companies/:companyID/vehicles/:vehicleID/workorders/:workorderID/parts/:partID",
			{
				companyID: "@companyID",
				vehicleID: "@vehicleID",
				workorderID: "@workorderID",
				partID: "@partID"
			},
			{
				getParts: {
					method: "GET",
					isArray: true,
					headers: header,
					cancellable: true,
					interceptor: {
						response: function (result) {
							var statusCode = result.headers(codeKey);

							if (statusCode != successCode) {
								var errorMessage = statusCode + ': ' + result.headers(messageKey);
								console.error("Failed to get WorkOrderPart.");
								return $q.reject(errorMessage);
							}

							return result.data.map(function (data) {
								var part = new WorkOrderPart();

								part.setAttributes(data);
								return part;
							});
						},
						responseError: function (error) {
							if (error && error.xhrStatus == xhrStatusAbort) {
								return $q.reject();
							}
							console.error("Failed to get WorkOrderPart.");
							return $q.reject(error);
						}
					}
				},
				postPart: {
					method: "POST",
					headers: {
						token: LoginService.getToken()
					}
				},
				updatePart: {
					method: "PUT",
					headers: {
						token: LoginService.getToken()
					}
				},
				deletePart: {
					method: "DELETE",
					headers: {
						token: LoginService.getToken()
					}
				}
			});

		api.workOrderInventories = $resource(
			baseUrl + "companies/:companyID/vehicles/:vehicleID/workorders/:workorderID/inventories/:inventoryID",
			{
				companyID: "@companyID",
				vehicleID: "@vehicleID",
				workorderID: "@workorderID",
				inventoryID: "@inventoryID"
			},
			{
				getInventories: {
					method: "GET",
					isArray: true,
					headers: header,
					cancellable: true,
					interceptor: {
						response: function (result) {
							var statusCode = result.headers(codeKey);

							if (statusCode != successCode) {
								var errorMessage = statusCode + ': ' + result.headers(messageKey);
								console.error("Failed to get WorkOrderInventory.");
								return $q.reject(errorMessage);
							}

							return result.data.map(function (data) {
								var inventory = new WorkOrderInventory();

								inventory.setAttributes(data);
								return inventory;
							});
						},
						responseError: function (error) {
							if (error && error.xhrStatus == xhrStatusAbort) {
								return $q.reject();
							}
							console.error("Failed to get WorkOrderInventory.");
							return $q.reject(error);
						}
					}
				},
				postInventory: {
					method: "POST",
					headers: {
						token: LoginService.getToken()
					}
				},
				updateInventory: {
					method: "PUT",
					headers: {
						token: LoginService.getToken()
					}
				},
				deleteInventory: {
					method: "DELETE",
					headers: {
						token: LoginService.getToken()
					}
				}
			});

		api.workOrderDiscounts = $resource(
			baseUrl + "companies/:companyID/vehicles/:vehicleID/workorders/:workorderID/discounts/:discountID",
			{
				companyID: "@companyID",
				vehicleID: "@vehicleID",
				workorderID: "@workorderID",
				discountID: "@discountID"
			},
			{
				getDiscounts: {
					method: "GET",
					isArray: true,
					headers: header,
					cancellable: true,
					interceptor: {
						response: function (result) {
							var statusCode = result.headers(codeKey);

							if (statusCode != successCode) {
								var errorMessage = statusCode + ': ' + result.headers(messageKey);
								console.error("Failed to get WorkOrderDiscount.");
								return $q.reject(errorMessage);
							}

							return result.data.map(function (data) {
								var discount = new WorkOrderDiscount();

								discount.setAttributes(data);
								return discount;
							});
						},
						responseError: function (error) {
							if (error && error.xhrStatus == xhrStatusAbort) {
								return $q.reject();
							}
							console.error("Failed to get WorkOrderDiscount.");
							return $q.reject(error);
						}
					}
				},
				postDiscount: {
					method: "POST",
					headers: {
						token: LoginService.getToken()
					}
				},
				deleteDiscount: {
					method: "DELETE",
					headers: {
						token: LoginService.getToken()
					}
				}
			});

		api.workOrderPayments = $resource(
			baseUrl + "companies/:companyID/vehicles/:vehicleID/workorders/:workorderID/payments/:paymentID",
			{
				companyID: "@companyID",
				vehicleID: "@vehicleID",
				workorderID: "@workorderID",
				paymentID: "@paymentID"
			},
			{
				getPayments: {
					method: "GET",
					isArray: true,
					headers: header,
					cancellable: true,
					interceptor: {
						response: function (result) {
							var statusCode = result.headers(codeKey);

							if (statusCode != successCode) {
								var errorMessage = statusCode + ': ' + result.headers(messageKey);
								console.error("Failed to get WorkOrderPayment.");
								return $q.reject(errorMessage);
							}

							return result.data.map(function (data) {
								var payment = new WorkOrderPayment();

								payment.setAttributes(data);
								return payment;
							});
						},
						responseError: function (error) {
							if (error && error.xhrStatus == xhrStatusAbort) {
								return $q.reject();
							}
							console.error("Failed to get WorkOrderPayment.");
							return $q.reject(error);
						}
					}
				},
				postPayment: {
					method: "POST",
					headers: {
						token: LoginService.getToken()
					}
				},
				deletePayment: {
					method: "DELETE",
					headers: {
						token: LoginService.getToken()
					}
				},
				updateWorkOrderPayment: {
					method: "PUT",
					headers: {
						token: LoginService.getToken()
					}
				}
			});

		api.workOrderMechanics = $resource(
			baseUrl + "companies/:companyID/vehicles/:vehicleID/workorders/:workorderID/mechanics/:mechanicID",
			{
				companyID: "@companyID",
				vehicleID: "@vehicleID",
				workorderID: "@workorderID",
				mechanicID: "@mechanicID"
			},
			{
				getMechanics: {
					method: "GET",
					isArray: true,
					headers: header
				},
				postMechanic: {
					method: "POST",
					headers: {
						token: LoginService.getToken()
					}
				},
				deleteMechanic: {
					method: "DELETE",
					headers: {
						token: LoginService.getToken()
					}
				}
			});

		api.workOrderFiles = $resource(
			baseUrl + "companies/:companyID/vehicles/:vehicleID/workorders/:workorderID/files/:fileID",
			{
				companyID: "@companyID",
				vehicleID: "@vehicleID",
				workorderID: "@workorderID",
				fileID: "@fileID"
			},
			{
				getFiles: {
					method: "GET",
					isArray: true,
					headers: header
				},
				deleteFile: {
					method: "DELETE",
					headers: {
						token: LoginService.getToken()
					}
				}
			});

		api.labors = $resource(
			baseUrl + "companies/:companyID/vehicles/:vehicleID/workorders/:workorderID/labors/:laborID",
			{
				companyID: "@companyID",
				vehicleID: "@vehicleID",
				workorderID: "@workorderID",
				laborID: "@laborID"
			},
			{
				getLabors: {
					method: "GET",
					isArray: true,
					headers: header,
					cancellable: true,
					interceptor: {
						response: function (result) {
							var statusCode = result.headers(codeKey);

							if (statusCode != successCode) {
								var errorMessage = statusCode + ': ' + result.headers(messageKey);
								console.error("Failed to get Labor.");
								return $q.reject(errorMessage);
							}

							return result.data.map(function (data) {
								var labor = new Labor();

								labor.setAttributes(data);
								return labor;
							});
						},
						responseError: function (error) {
							if (error && error.xhrStatus == xhrStatusAbort) {
								return $q.reject();
							}
							console.error("Failed to get Labor.");
							return $q.reject(error);
						}
					}
				},
				postLabor: {
					method: "POST",
					headers: {
						token: LoginService.getToken()
					}
				},
				updateLabor: {
					method: "PUT",
					headers: {
						token: LoginService.getToken()
					}
				},
				deleteLabor: {
					method: "DELETE",
					headers: {
						token: LoginService.getToken()
					}
				}
			});

		api.suggestedlaborPrice = $resource(
			baseUrl + "companies/:companyID/laborprice",
			{
				companyID: "@companyID"
			},
			{
				getLaborPrice: {
					method: "GET",
					headers: header
				}
			});

		api.calendars = $resource(
			baseUrl + "companies/:companyID/calendars/:calendarID",
			{
				companyID: "@companyID",
				calendarID: "@calendarID",
			},
			{
				getCalendars: {
					method: "GET",
					isArray: true,
					headers: header
				},
				postCalendar: {
					method: "POST",
					headers: {
						token: LoginService.getToken()
					}
				},
				updateCalendar: {
					method: "PUT",
					headers: {
						token: LoginService.getToken()
					}
				}
			});

		api.customerportalcalendars = $resource(
				baseUrl + "companies/:companyID/customerportalcalendars/:customerPortalCalendarID",
				{
					companyID: "@companyID",
					customerPortalCalendarID: "@customerPortalCalendarID",
				},
				{
					getCustomerPortalCalendars: {
						method: "GET",
						isArray: true,
						headers: header
					},
				});
		api.customerportalappointments = $resource(
					baseUrl + "companies/:companyID/customerportalappointment/:customerportalappointmentID",
					{
						companyID: "@companyID",
						customerportalappointmentID: "@customerportalappointmentID",
					},
					{
						getCustomerPortalAppointments: {
							method: "GET",
							isArray: true,
							headers: header
						},
						cancelCustomerPortalAppointmentByAdmin: {
							method: "DELETE",
							headers: header
						},
			});

		api.appointments = $resource(
			baseUrl + "companies/:companyID/appointments/:appointmentID",
			{
				companyID: "@companyID",
				appointmentID: "@appointmentID",
			},
			{
				getAppointments: {
					method: "GET",
					isArray: true,
					headers: header
				},
				postAppointment: {
					method: "POST",
					headers: {
						token: LoginService.getToken()
					}
				},
				updateAppointment: {
					method: "PUT",
					headers: {
						token: LoginService.getToken()
					}
				},
				deleteAppointment: {
					method: "DELETE",
					headers: {
						token: LoginService.getToken()
					}
				}
			});

		api.workOrderAppointments = $resource(
			baseUrl + "companies/:companyID/workorderappointments/:workorderappointmentID",
			{
				companyID: "@companyID",
				workorderappointmentID: "@workorderappointmentID",
			},
			{
				getAppointments: {
					method: "GET",
					isArray: true,
					headers: header
				},
				postAppointment: {
					method: "POST",
					headers: {
						token: LoginService.getToken()
					}
				},
				updateAppointment: {
					method: "PUT",
					headers: {
						token: LoginService.getToken()
					}
				},
				deleteAppointment: {
					method: "DELETE",
					headers: {
						token: LoginService.getToken()
					}
				}
			});

		api.sendEmail = $resource(
			baseUrl + "companies/:companyID/emails/send",
			{
				companyID: "@companyID"
			},
			{
				send: {
					method: "POST",
					headers: header
				}
			});

		api.check = {}
		api.check.checkExistence = $resource(
			baseUrl + "checkexisting",
			{},
			{
				check: {
					method: 'GET',
					cache: false,
					headers: header
				}
			}
		);

		api.check.getVehicleIdByVin = $resource(baseUrl + "getvehicleidbyvin");

		api.getConstants = {}

		api.getConstants.getPhoneCategories = $resource(
			baseUrl + "getphonecategories",
			{},
			{
				get: {
					method: "GET",
					isArray: true
				}
			}
		);

		api.getConstants.getWorkorderPaymentStatus = $resource(
			baseUrl + "getworkorderpaymentstatus",
			{},
			{
				get: {
					method: "GET",
					isArray: true
				}
			}
		);

		api.getConstants.getEmailCategories = $resource(
			baseUrl + "getemailcategories",
			{},
			{
				get: {
					method: "GET",
					isArray: true
				}
			}
		);

		api.getConstants.getTaskCategories = $resource(
			baseUrl + "gettaskcategories",
			{},
			{
				get: {
					method: "GET",
					isArray: true
				}
			}
		);
		api.getConstants.getTaskPriorities = $resource(
			baseUrl + "gettaskpriorities",
			{},
			{
				get: {
					method: "GET",
					isArray: true
				}
			}
		);
		api.getConstants.getTaskStatus = $resource(
			baseUrl + "gettaskstatus",
			{},
			{
				get: {
					method: "GET",
					isArray: true
				}
			}
		);

		api.getConstants.getLivingArrangementTypes = $resource(
			baseUrl + "getlivingarrangmenttypes",
			{},
			{
				get: {
					method: "GET",
					isArray: true
				}
			}
		);

		api.getConstants.getEmploymentStatus = $resource(
			baseUrl + "getemploymentstatus",
			{},
			{
				get: {
					method: "GET",
					isArray: true
				}
			}
		);


		api.getConstants.getPaymentOptions = $resource(
			baseUrl + "getpaymentoptions",
			{},
			{
				get: {
					method: "GET",
					isArray: true
				}
			}
		);

		api.getConstants.getPaymentMethods = $resource(
			baseUrl + "getpaymentmethods",
			{},
			{
				get: {
					method: "GET",
					isArray: true
				}
			}
		);

		api.getConstants.getVehicleBrands = $resource(
			baseUrl + "vehiclebrands",
			{},
			{
				get: {
					method: "GET",
					isArray: true
				}
			}
		);

		api.getConstants.getSafetyImageTags = $resource(
			baseUrl + "safetyimagetags",
			{},
			{
				get: {
					method: "GET",
					isArray: true
				}
			}
		);

		api.getConstants.workOrderStatus = $resource(
			baseUrl + "workorderstatus",
			{},
			{
				get: {
					method: "GET",
					isArray: true
				}
			}
		);

		api.getConstants.workOrderPriorities = $resource(
			baseUrl + "workorderpriorities",
			{},
			{
				get: {
					method: "GET",
					isArray: true
				}
			}
		);


		api.getConstants.appointmentStatus = $resource(
			baseUrl + "appointmentstatus",
			{},
			{
				get: {
					method: "GET",
					isArray: true
				}
			}
		);

		api.partTypes = $resource(
			baseUrl + "getparttypes",
			{},
			{
				getPartTypes: {
					method: "GET",
					isArray: true,
					headers: header
				}
			}
		);

		api.webProxy = $resource(baseUrl + "webpageproxy");

		api.creditCards = $resource(
			baseUrl + "companies/:companyID/customers/:customerID/authorizeNetProfile/:authorizeNetProfileId",
			{
				companyID: "@companyID",
				customerID: "@customerID",
				authorizeNetProfile: "@authorizeNetProfileId"
			},
			{
				getCreditCards: {
					method: "GET",
					isArray: true,
					headers: header
				},
				saveClientPaymentProfile: {
					method: "POST",
					isArray: true,
					headers: {
						token: LoginService.getToken()
					}
				}
		});

		api.deleteCreditCards = $resource(
			baseUrl + "companies/:companyID/customers/:customerID/authorizeNetProfile/:authorizeNetProfileId/delete",
			{
				companyID: "@companyID",
				customerID: "@customerID",
				authorizeNetProfile: "@authorizeNetProfileId"
			},
			{
				deleteClientPaymentProfile: {
					method: "POST",
					isArray: true,
					headers: {
						token: LoginService.getToken()
					}
				}
		});

		api.voidCreditCardsPayment = $resource(
			baseUrl + "companies/:companyID/customers/:customerID/authorizeNetProfile/:authorizeNetProfileId/void",
			{
				companyID: "@companyID",
				customerID: "@customerID",
				authorizeNetProfile: "@authorizeNetProfileId"
			},
			{
				voidtransaction: {
					method: "POST",
					
					headers: {
						token: LoginService.getToken()
					}
				}
		});

		api.refundCreditCardsPayment = $resource(
			baseUrl + "companies/:companyID/customers/:customerID/authorizeNetProfile/:authorizeNetProfileId/refund",
			{
				companyID: "@companyID",
				customerID: "@customerID",
				authorizeNetProfile: "@authorizeNetProfileId"
			},
			{
				refundtransaction: {
					method: "POST",
					headers: {
						token: LoginService.getToken()
					}
				}
		});

		api.vehicleImagesContentType = $resource(
			baseUrl + "companies/:companyID/vehicles/:vehicleID/images/contenttype",
			{
				companyID: "@companyID",
				vehicleID: "@vehicleID"
			},
			{
				updateContentTypeImage: {
					method: "POST",
					headers: {
						token: LoginService.getToken()
					}
				},
		});

		api.customAppointment = $resource(
			baseUrl + "companies/:companyID/customers/:customerID/customAppointment/:customAppointmentID",
			{
				companyID: "@companyID",
				customerID: "@customerID",	
				customAppointmentID: "@customAppointmentID"
			},
			{
				getCustomAppointment: {
					method: "GET",
					isArray: true,
					headers: header
				},
				updateCustomAppointment: {
					method: "PUT",
					headers: {
						token: LoginService.getToken()
					}
				},
				deleteCustomAppointment: {
					method: "DELETE",
					headers: {
						token: LoginService.getToken()
					}
				},
				postCustomAppointment: {
					method: "POST",
					headers: {
						token: LoginService.getToken()
					}
				},
		});

		api.coupon = $resource(
			baseUrl + "companies/:companyID/coupon/:couponId",
			{
				companyID: "@companyID",
				couponId: "@couponId",
			},
			{
				getCoupon: {
					method: "GET",
					isArray: true,
					headers: header,
					interceptor: {
						response: function (result) {
							var statusCode = result.headers(codeKey);

							if (statusCode != successCode) {
								var errorMessage = statusCode + ': ' + result.headers(messageKey);
								console.error("Failed to get coupon.");
								return $q.reject(errorMessage);
							}

							return result.data.map(function (data) {
								var labour = new Coupon();
								labour.setAttributes(data);
								return labour;
							});
						},
						responseError: function (error) {
							if (error && error.xhrStatus == xhrStatusAbort) {
								return $q.reject();
							}
							console.error("Failed to get coupon.");
							return $q.reject(error);
						}
					}
				},
				updateCoupon:{
					method: "PUT",
					headers: {
						token: LoginService.getToken()
					}
				},
				addCoupon:{
					method: "POST",
					headers: {
						token: LoginService.getToken()
					}
				},
				deleteCoupon:{
					method: "DELETE",
					headers: {
						token: LoginService.getToken()
					}
				}
		});

		api.userOutstandingTask = $resource(
			baseUrl + "companies/:companyID/outstandingtask/users/:userID",
			{
				companyID: "@companyID",
				userID: "@userID"
			},
			{
				getUserOutstandingTasks: {
					method: "GET",
					isArray: true,
					headers: header
				},
		});

		api.purchaseInfoPrices = $resource(
			baseUrl + "companies/:companyID/vehicles/:vehicleID/purchaseinfos/:purchaseinfoID/purchaseinfoprices/:purchaseinfopriceID",
			{
				companyID: "@companyID",
				vehicleID: "@vehicleID",
				purchaseinfoID: "@purchaseinfoID",
				purchaseinfopriceID: "@purchaseinfopriceID"
			},
			{
				getPurchaseInfoPrices: {
					method: "GET",
					isArray: true,
					headers: header
				},
				createPurchaseInfoPrice: {
					method: "POST",
					isArray: true,
					headers: {
						token: LoginService.getToken()
					}
				},
				updatePurchaseInfoPrice: {
					method: "PUT",
					headers: {
						token: LoginService.getToken()
					}
				},
				deletePurchaseInfoPrice: {
					method: "DELETE",
					headers: {
						token: LoginService.getToken()
					}
				}
			});

		api.purchaseInfoPriceType = $resource(
				baseUrl + "companies/:companyID/vehicles/:vehicleID/purchaseinfopricetype/:purchaseinfopriceTypeID",
				{
					companyID: "@companyID",
					vehicleID: "@vehicleID",
					purchaseinfopriceTypeID: "@purchaseinfopriceTypeID"
				},
				{
					getpurchaseInfoPriceType: {
						method: "GET",
						isArray: true,
						headers: header
					},
				});

		api.vehiclesReport = $resource(
			baseUrl + "companies/:companyID/profilereport/vehicles/:vehicleID",
			{
				companyID: "@companyID",
				vehicleID: "@vehicleID"
			},
			{
				getVehicleForReport: {
					method: "GET",
					isArray: true,
					headers: header
				}
			});
			
		api.workOrdersReport = $resource(
			baseUrl + "companies/:companyID/vehicles/:vehicleID/profilereport/workorders/:workorderID",
			{
				companyID: "@companyID",
				vehicleID: "@vehicleID",
				workorderID: "@workorderID",
			},
			{
				getWorkOrdersForReport: {
					method: "GET",
					isArray: true,
					headers: header,
					cancellable: true,
					interceptor: {
						response: function (result) {
							var statusCode = result.headers(codeKey);

							if (statusCode != successCode) {
								var errorMessage = statusCode + ': ' + result.headers(messageKey);
								console.error("Failed to get workOrder.");
								return $q.reject(errorMessage);
							}

							return result.data.map(function (data) {
								var workOrder = new WorkOrder();

								workOrder.setAttributes(data);
								return workOrder
							});
						},
						responseError: function (error) {
							if (error && error.xhrStatus == xhrStatusAbort) {
								return $q.reject();
							}
							console.error("Failed to get workOrder.");
							return $q.reject(error);
						}
					}
				}
		});

		api.workOrderCoupons = $resource(
			baseUrl + "companies/:companyID/vehicles/:vehicleID/workorders/:workorderID/coupon/:couponID",
			{
				companyID: "@companyID",
				vehicleID: "@vehicleID",
				workorderID: "@workorderID",
				couponID: "@couponID"
			},
			{
				getCoupons: {
					method: "GET",
					isArray: true,
					headers: header,
					cancellable: true,
					interceptor: {
						response: function (result) {
							var statusCode = result.headers(codeKey);

							if (statusCode != successCode && result.data.length > 0) {
								var errorMessage = statusCode + ': ' + result.headers(messageKey);
								console.error("Failed to get WorkOrder Coupon.");
								return $q.reject(errorMessage);
							}
							return result.data.map(function (data) {
								var coupon = new WorkOrderCoupon();

								coupon.setAttributes(data);
								return coupon;
							});
						},
						responseError: function (error) {
							if (error && error.xhrStatus == xhrStatusAbort) {
								return $q.reject();
							}
							console.error("Failed to get WorkOrder Coupon.");
							return $q.reject(error);
						}
					}
				},
				addWorkOrderDiscount: {
					method: "POST",
					headers: {
						token: LoginService.getToken()
					}
				},
				// deleteDiscount: {
				// 	method: "DELETE",
				// 	headers: {
				// 		token: LoginService.getToken()
				// 	}
				// }
			});

		api.vehicleDetails = $resource(
			baseUrl + "companies/:companyID/details/vehicles/:vehicleID",
			{
				companyID: "@companyID",
				vehicleID: "@vehicleID"
			},
			{
				getVehicleDetails: {
					method: "GET",
					isArray: true,
					headers: header
				}
		});
		api.workOrderLog = $resource(
			baseUrl + "companies/:companyID/vehicles/:vehicleID/workorders/:workorderID/workorderlogs/:workorderlogID",
			{
				companyID: "@companyID",
				vehicleID: "@vehicleID",
				workorderID: "@workorderID",
				workorderlogID: "@workorderlogID"
			},
			{
				getWorkOrderLog: {
					method: "GET",
					isArray: true,
					headers: header,
					interceptor: {
						response: function (result) {
							var statusCode = result.headers(codeKey);

							if (statusCode != successCode) {
								var errorMessage = statusCode + ': ' + result.headers(messageKey);
								console.error("Failed to get WorkOrderLog.");
								return $q.reject(errorMessage);
							}

							return result.data.map(function (data) {
								var log = new WorkOrderLog();

								log.setAttributes(data);
								return log;
							});
						},
						responseError: function (error) {
							if (error && error.xhrStatus == xhrStatusAbort) {
								return $q.reject();
							}
							console.error("Failed to get WorkOrderLog.");
							return $q.reject(error);
						}
					}
				}
		});

		api.workOrderPrint = $resource(
			baseUrl + "companies/:companyID/vehicles/:vehicleID/workorders/:workorderID/print",
			{
				companyID: "@companyID",
				vehicleID: "@vehicleID",
				workorderID: "@workorderID",
			},
			{
				recordWorkOrderPrint: {
					method: "PUT",
					headers: {
						token: LoginService.getToken()
					}
				}
		});
		api.testDrivesVehicleHistory = $resource(
			baseUrl + "companies/:companyID/testdrives/history/vehicles/:vehicleID",
			{
				companyID: "@companyID",
			},
			{
				getTestDrivesVehicleHistory: {
					method: "GET",
					isArray: true,
					headers: header
				},
			});
		

		return api;
	}
})();
(function ()
{
	'use strict';

	angular
		.module('app.settings.users')
		.config(config);

	/** @ngInject */
	function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider, userTempValueProvider)
	{	   
		var userTempValueService = userTempValueProvider.$get();

		$stateProvider
			.state("app.settings.users",{
				url:"/users"
			})
			.state("app.settings.users.view-user",{
				url:"/view-user",
				views	: {
					'content@app': {
						templateUrl: 'app/main/settings/users/view-user/view-user.html',
						controller : 'ViewUserController as vm'
					}
				},
				resolve :{
					users:function(apiResolver, LoginService){
						return apiResolver.resolve('users@getUsers', {companyID: LoginService.getCompanyID()});
					}
				}
			})
			.state('app.settings.users.my-profile', {
				url	  : '/my-profile',
				views	: {
					'content@app': {
						templateUrl: 'app/main/settings/users/my-profile/my-profile.html',
						controller : 'MyProfileController as vm'
					}
				},
				resolve:{
					user:function(apiResolver, $stateParams){
						var companyID = $stateParams.companyID;
						var userID = $stateParams.userID;

						if(typeof(companyID) == "number"){
							userTempValueService.setTempCompanyID(companyID);
						}else{
							companyID = userTempValueService.getTempCompanyID(companyID);
						}

						if(typeof(userID) == "number"){
							userTempValueService.setTempUserID(userID);
						}else{
							userID = userTempValueService.getTempUserID(userID);
						}

						return apiResolver.resolve('users@getUser', {'companyID' : companyID, "userID" : userID});						
					}
				},
				params: {
					userID: null,
					companyID: null
				}				
			})
			.state('app.settings.users.add-user', {
				url	  : '/add-user',
				views	: {
					'content@app': {
						templateUrl: 'app/main/settings/users/add-user/add-user.html',
						controller : 'AddUserController as vm'
					}
				}
			})
			.state('app.settings.users.edit-user', {
				url	  : '/edit-user',
				views	: {
					'content@app': {
						templateUrl: 'app/main/settings/users/edit-user/edit-user.html',
						controller : 'EditUserController as vm'
					}
				},
				resolve:{
					user:function(apiResolver, $stateParams){
						var companyID = $stateParams.companyID;
						var userID = $stateParams.userID;

						if(typeof(companyID) == "number"){
							userTempValueService.setTempCompanyID(companyID);
						}else{
							companyID = userTempValueService.getTempCompanyID(companyID);
						}

						if(typeof(userID) == "number"){
							userTempValueService.setTempUserID(userID);
						}else{
							userID = userTempValueService.getTempUserID(userID);
						}

						return apiResolver.resolve('users@getUser', {'companyID' : companyID, "userID" : userID});						
					}
				},
				params: {
					userID: null,
					companyID: null
				}
			});
	}


})();
(function ()
{
	'use strict';

	angular
		.module('app.settings.parttype')
		.config(config);

	/** @ngInject */
	function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider, parttypesTempValueProvider)
	{	   
		var parttypesTempValue = parttypesTempValueProvider.$get();

		$stateProvider
			.state("app.settings.parttype",{
				url:"/parttype"
			})
			.state("app.settings.parttype.view-parttypes",{
				url:"/view-parttype",
				views	: {
					'content@app': {
						templateUrl: 'app/main/settings/parttype/view-parttypes/view-parttypes.html',
						controller : 'ViewParttypesController as vm'
					}
				},
				resolve :{
					parttype:function(apiResolver, LoginService){
						//return "hooh"
						return apiResolver.resolve('parttype@getparttypes', {companyID: LoginService.getCompanyID()});
					}
				}
			})
			.state('app.settings.parttype.add-parttype', {
				url	  : '/add-parttype',
				views	: {
					'content@app': {
						templateUrl: 'app/main/settings/parttype/add-parttype/add-parttype.html',
						controller : 'AddParttypeController as vm'
					}
				}
			})

			.state('app.settings.parttype.edit-parttype', {
				url	  : '/edit-parttype',
				views	: {
					'content@app': {
						templateUrl: 'app/main/settings/parttype/edit-parttype/edit-parttype.html',
						controller : 'EditPromptDialogControllerparttype as vm'
					}
				},
				resolve:{
					parttype:function(apiResolver, $stateParams){
						var companyID = $stateParams.companyID;
						var userID = $stateParams.id_part_type;

						var parttypename = $stateParams.name;
						var parttypetail = $stateParams.default_retail;

						if(typeof(companyID) == "number"){
							parttypesTempValue.setTempCompanyID(companyID);
						}else{
							companyID = parttypesTempValue.getTempCompanyID(companyID);
						}

						if(typeof(userID) == "number"){
							parttypesTempValue.setTempParttypesID(userID);
						}else{
							userID = parttypesTempValue.getTempParttypesID(userID);
						}
						return apiResolver.resolve('parttype@getparttypes', {'id_part_type' : userID, "fk_id_company" : companyID, "name": parttypename, "default_retail": parttypetail});
					}
				},
				params: {
					id_part_type: null,
					companyID: null,
					name: null,
					default_retail: null,
				}
			});
	}


})();
(function () {
	'use strict';

	angular.module('app.goto', []).service('GotoService', GotoService);

	var GOTO_STATUS_EVENT = 'goto:statusUpdated';

	/** @ngInject */
	function GotoService($http, GeneralTools, LoginService, ApiConst) {
		var baseUrl = GeneralTools.getBaseUrl() + 'goto/';
		var cachedStatus = {
			authenticated: false,
			canDial: false,
		};

		function authHeaders() {
			return {
				token: LoginService.getToken(),
			};
		}

		function updateCachedStatus(status) {
			if (status) {
				cachedStatus = status;
			}
		}

		this.getCachedStatus = function () {
			return cachedStatus;
		};

		this.getStatus = function () {
			return $http
				.get(baseUrl + 'status', { headers: authHeaders() })
				.then(function (response) {
					updateCachedStatus(response.data);
					return response.data;
				});
		};

		this.refreshStatus = this.getStatus;

		this.getCalls = function (scope) {
			var params = {};

			if (scope) {
				params.scope = scope;
			}

			return $http
				.get(baseUrl + 'calls', { headers: authHeaders(), params: params })
				.then(function (response) {
					return response.data;
				});
		};

		this.getAuthorizationUrl = function () {
			return $http
				.get(baseUrl + 'auth/url', { headers: authHeaders() })
				.then(function (response) {
					return response.data.url;
				});
		};

		this.connect = function () {
			return $http
				.post(baseUrl + 'connect', {}, { headers: authHeaders() })
				.then(function (response) {
					updateCachedStatus(response.data);
					return response.data;
				});
		};

		this.disconnect = function () {
			return $http
				.post(baseUrl + 'disconnect', {}, { headers: authHeaders() })
				.then(function (response) {
					updateCachedStatus(response.data);
					return response.data;
				});
		};

		this.dial = function (phoneNumber) {
			return $http
				.post(
					baseUrl + 'dial',
					{ phoneNumber: phoneNumber },
					{ headers: authHeaders() }
				)
				.then(function (response) {
					return response.data;
				});
		};

		this.getSocketUrl = function () {
			var domain;

			switch (window.location.host) {
				case ApiConst.productDomain:
					domain = ApiConst.productDomain;
					break;
				case ApiConst.productBackupDomain:
					domain = ApiConst.productBackupDomain;
					break;
				case ApiConst.testDomain:
					domain = ApiConst.testDomain;
					break;
				default:
					domain = 'localhost:3000';
					break;
			}

			return ApiConst.http + domain + '/goto-calls';
		};

		this.getSiteStatus = function () {
			return $http
				.get(baseUrl + 'site/status', { headers: authHeaders() })
				.then(function (response) {
					return response.data;
				});
		};

		this.getSiteAuthorizationUrl = function () {
			return $http
				.get(baseUrl + 'site/auth/url', { headers: authHeaders() })
				.then(function (response) {
					return response.data;
				});
		};

		this.disconnectSite = function () {
			return $http
				.post(baseUrl + 'site/disconnect', {}, { headers: authHeaders() })
				.then(function (response) {
					return response.data;
				});
		};
	}

	angular.module('app.goto').component('gotoCallPanel', {
		templateUrl: 'app/main/goto/goto-call-panel.html',
		controller: GotoCallPanelController,
		controllerAs: 'vm',
	});

	angular.module('app.goto').component('gotoDialButton', {
		templateUrl: 'app/main/goto/goto-dial-button.html',
		bindings: {
			phoneNumber: '<',
			displayName: '<',
		},
		controller: GotoDialButtonController,
		controllerAs: 'vm',
	});

	/** @ngInject */
	function GotoDialButtonController(
		$scope,
		$mdDialog,
		GeneralTools,
		GotoService,
		MessageService
	) {
		var vm = this;

		vm.isGoToConnected = false;
		vm.isDialing = false;
		vm.disabledTooltip = 'Connect to GoTo to make calls';

		vm.$onInit = function () {
			syncFromCache();
			GotoService.refreshStatus().then(syncFromCache).catch(function () {
				// ignore status load errors for the dial affordance
			});
			$scope.$on(GOTO_STATUS_EVENT, function (event, status) {
				syncFromCache(status);
			});
		};

		vm.onDial = function ($event) {
			if ($event) {
				$event.stopPropagation();
				$event.preventDefault();
			}

			if (!vm.isGoToConnected || vm.isDialing || !vm.phoneNumber) {
				return;
			}

			var confirm = $mdDialog
				.confirm()
				.title('Confirm call')
				.textContent(buildConfirmMessage())
				.ok('Call')
				.cancel('Cancel');

			$mdDialog.show(confirm).then(placeCall);
		};

		vm.onCopy = function ($event) {
			if ($event) {
				$event.stopPropagation();
				$event.preventDefault();
			}

			if (!vm.phoneNumber) {
				return;
			}

			var textToCopy = getUnformattedPhoneNumber();

			GeneralTools.copyToClipboard(textToCopy);
			MessageService.showToast('Phone number copied.');
		};

		function getUnformattedPhoneNumber() {
			var digits = String(vm.phoneNumber || '').replace(/\D/g, '');

			if (digits.length === 11 && digits.charAt(0) === '1') {
				digits = digits.slice(1);
			}

			return digits;
		}

		function getFormattedPhoneNumber() {
			return (
				GeneralTools.stringToPhoneNumberString(vm.phoneNumber) ||
				String(vm.phoneNumber).trim()
			);
		}

		function buildConfirmMessage() {
			var formattedPhone = getFormattedPhoneNumber();
			var name = getDialDisplayName();

			if (name) {
				return 'Call ' + name + ' at ' + formattedPhone + '?';
			}

			return 'Call ' + formattedPhone + '?';
		}

		function getDialDisplayName() {
			var name = String(vm.displayName || '').trim();

			if (!name) {
				return null;
			}

			var lowered = name.toLowerCase();

			if (lowered === 'unknown' || lowered === 'unknown caller') {
				return null;
			}

			return name;
		}

		function placeCall() {
			vm.isDialing = true;
			GotoService.dial(vm.phoneNumber)
				.then(function () {
					MessageService.showToast('Calling...');
				})
				.catch(function (error) {
					var message =
						error && error.data && error.data.message
							? error.data.message
							: 'Failed to place call.';
					MessageService.showToast(message);
				})
				.finally(function () {
					vm.isDialing = false;
				});
		}

		function syncFromCache(status) {
			var nextStatus = status || GotoService.getCachedStatus();
			vm.isGoToConnected = !!(nextStatus && nextStatus.authenticated);
		}
	}

	/** @ngInject */
	function GotoCallPanelController(
		$interval,
		$location,
		$mdMenu,
		$rootScope,
		$state,
		$window,
		ApiConst,
		GotoService,
		CustomersService,
		LoginService,
		MessageService,
		RoleCheckService
	) {
		var vm = this;
		var pollPromise = null;
		var socket = null;
		var refreshRequestId = 0;
		var CALL_SCOPE_STORAGE_KEY = 'gotoCallScope';

		vm.status = { connected: false, authenticated: false };
		vm.activeCalls = [];
		vm.incomingCalls = [];
		vm.liveCalls = [];
		vm.historicalCalls = [];
		vm.historicalGroups = [];
		vm.canToggleDealershipCallScope = RoleCheckService.checkRole(['goto_all_calls']);
		vm.showAllDealershipCalls = vm.canToggleDealershipCallScope
			? readCallScopePreference()
			: false;

		vm.onMenuOpen = onMenuOpen;
		vm.onMenuClose = onMenuClose;
		vm.connectGoTo = connectGoTo;
		vm.disconnectGoTo = disconnectGoTo;
		vm.openCustomerForCall = openCustomerForCall;
		vm.onOpenCustomerProfile = onOpenCustomerProfile;
		vm.getDirectionLabel = getDirectionLabel;
		vm.formatCallTime = formatCallTime;
		vm.onCallScopeToggle = onCallScopeToggle;

		vm.$onInit = function () {
			handleOAuthReturn();
			refreshStatusFromServer().then(refreshCalls);
			initSocket();
		};

		vm.$onDestroy = function () {
			stopPolling();
			if (socket) {
				socket.disconnect();
				socket = null;
			}
		};

		function initSocket() {
			if (typeof io === 'undefined') {
				return;
			}

			socket = io(GotoService.getSocketUrl(), { path: ApiConst.socketIoPath });
			socket.on('calls_updated', function () {
				refreshCalls();
			});
			socket.on('connection_status', function (payload) {
				if (payload) {
					vm.status = Object.assign({}, vm.status, payload);
					publishStatus(vm.status);
				}

				if (payload && payload.refreshStatus) {
					refreshStatusFromServer();
				}
			});
		}

		function onMenuOpen() {
			refreshStatusFromServer().then(refreshCalls);
			startPolling();
		}

		function onMenuClose() {
			stopPolling();
		}

		function startPolling() {
			stopPolling();
			pollPromise = $interval(refreshCalls, 5000);
		}

		function stopPolling() {
			if (pollPromise) {
				$interval.cancel(pollPromise);
				pollPromise = null;
			}
		}

		function readCallScopePreference() {
			try {
				return $window.localStorage.getItem(CALL_SCOPE_STORAGE_KEY) !== 'user';
			} catch (error) {
				return true;
			}
		}

		function writeCallScopePreference() {
			try {
				$window.localStorage.setItem(
					CALL_SCOPE_STORAGE_KEY,
					vm.showAllDealershipCalls ? 'dealership' : 'user'
				);
			} catch (error) {
				// ignore storage failures
			}
		}

		function getCallScopeParam() {
			if (!vm.canToggleDealershipCallScope || !vm.status.canViewAllDealershipCalls) {
				return 'user';
			}

			return vm.showAllDealershipCalls ? 'dealership' : 'user';
		}

		function onCallScopeToggle() {
			if (!vm.canToggleDealershipCallScope || !vm.status.canViewAllDealershipCalls) {
				return;
			}

			vm.showAllDealershipCalls = !vm.showAllDealershipCalls;
			writeCallScopePreference();
			refreshCalls();
		}

		function closeCallPanel() {
			$mdMenu.hide();
		}

		function publishStatus(status) {
			if (!status) {
				return;
			}

			$rootScope.$broadcast(GOTO_STATUS_EVENT, status);
		}

		function refreshStatusFromServer() {
			return GotoService.getStatus()
				.then(function (status) {
					if (status) {
						vm.status = Object.assign({}, vm.status, status);
						if (!vm.status.canViewAllDealershipCalls) {
							vm.showAllDealershipCalls = false;
						}
						publishStatus(status);
					}
				})
				.catch(function (error) {
					console.error(error);
				});
		}

		function refreshCalls() {
			var scope = getCallScopeParam();
			var requestId = ++refreshRequestId;

			GotoService.getCalls(scope)
				.then(function (payload) {
					if (requestId !== refreshRequestId) {
						return;
					}

					applyCallsPayload(payload);
				})
				.catch(function (error) {
					console.error(error);
				});
		}

		function applyCallsPayload(payload) {
			if (!payload) {
				return;
			}

			vm.status = payload.status || vm.status;
			if (!vm.status.canViewAllDealershipCalls) {
				vm.showAllDealershipCalls = false;
			}
			publishStatus(vm.status);
			vm.activeCalls = payload.active || [];
			vm.incomingCalls = payload.incoming || [];
			vm.historicalCalls = payload.historical || [];
			vm.liveCalls = buildLiveCalls(vm.incomingCalls, vm.activeCalls);
			vm.historicalGroups = buildHistoricalGroups(vm.historicalCalls);
		}

		function decorateCallLabels(call) {
			call.phoneLabel = call.displayNumber || call.phoneNumber || 'Unknown number';
			call.callerLabel =
				call.callerName && call.callerName !== 'Unknown'
					? call.callerName
					: 'Unknown caller';
		}

		function buildLiveCalls(incomingCalls, activeCalls) {
			var calls = (incomingCalls || []).concat(activeCalls || []);

			return calls.map(function (call) {
				var decorated = Object.assign({}, call);
				decorateCallLabels(decorated);
				decorated.statusLabel = decorated.status === 'ringing' ? 'Ringing' : 'Active';
				decorated.statusClass =
					decorated.status === 'ringing' ? 'is-ringing' : 'is-active';
				decorated.timeLabel = formatCallTime(decorated);
				return decorated;
			});
		}

		function isSameDay(left, right) {
			return (
				left.getFullYear() === right.getFullYear() &&
				left.getMonth() === right.getMonth() &&
				left.getDate() === right.getDate()
			);
		}

		function formatDateLabel(isoString) {
			if (!isoString) {
				return 'Unknown date';
			}

			var date = new Date(isoString);
			if (isNaN(date.getTime())) {
				return 'Unknown date';
			}

			var today = new Date();
			var yesterday = new Date();
			yesterday.setDate(today.getDate() - 1);

			if (isSameDay(date, today)) {
				return 'Today';
			}

			if (isSameDay(date, yesterday)) {
				return 'Yesterday';
			}

			return date.toLocaleDateString(undefined, {
				weekday: 'short',
				month: 'short',
				day: 'numeric',
				year: 'numeric',
			});
		}

		function getCallTimestamp(call) {
			return call.endedAt || call.startedAt || null;
		}

		function formatCallTime(call) {
			var isoString = getCallTimestamp(call);
			if (!isoString) {
				return '';
			}

			var date = new Date(isoString);
			if (isNaN(date.getTime())) {
				return '';
			}

			return date.toLocaleTimeString(undefined, {
				hour: 'numeric',
				minute: '2-digit',
			});
		}

		function formatOutcomeLabel(outcome) {
			return outcome
				.toLowerCase()
				.split('_')
				.map(function (part) {
					return part.charAt(0).toUpperCase() + part.slice(1);
				})
				.join(' ');
		}

		function getCallTypeLabel(call) {
			var outcome = String((call && call.callerOutcome) || '').toUpperCase();
			var direction = String((call && call.direction) || '').toUpperCase();

			if (outcome === 'MISSED') {
				return 'Missed';
			}

			if (
				outcome === 'LEFT_DIAL_PLAN' ||
				outcome === 'ANSWERED_ELSEWHERE' ||
				outcome === 'COMPLETED_ELSEWHERE'
			) {
				return 'Completed elsewhere';
			}

			if (outcome === 'VOICEMAIL') {
				return 'Voicemail';
			}

			if (outcome === 'ABANDONED') {
				return 'Abandoned';
			}

			if (outcome === 'BUSY') {
				return 'Busy';
			}

			if (outcome === 'FAILED') {
				return 'Failed';
			}

			if (outcome === 'NORMAL' || !outcome) {
				if (direction === 'INBOUND') {
					return 'Incoming';
				}

				if (direction === 'OUTBOUND') {
					return 'Outgoing';
				}

				return 'Call';
			}

			return formatOutcomeLabel(outcome);
		}

		function getCallTypeClass(call) {
			var outcome = String((call && call.callerOutcome) || '').toUpperCase();

			if (outcome === 'MISSED') {
				return 'is-missed';
			}

			if (
				outcome === 'LEFT_DIAL_PLAN' ||
				outcome === 'ANSWERED_ELSEWHERE' ||
				outcome === 'COMPLETED_ELSEWHERE'
			) {
				return 'is-completed-elsewhere';
			}

			if (outcome === 'VOICEMAIL') {
				return 'is-voicemail';
			}

			if (outcome === 'ABANDONED') {
				return 'is-abandoned';
			}

			if (outcome === 'BUSY') {
				return 'is-busy';
			}

			if (outcome === 'FAILED') {
				return 'is-failed';
			}

			return getDirectionClass(call);
		}

		function getDirectionLabel(call) {
			return getCallTypeLabel(call);
		}

		function getDirectionClass(call) {
			var direction = String((call && call.direction) || '').toUpperCase();

			if (direction === 'INBOUND') {
				return 'is-incoming';
			}

			if (direction === 'OUTBOUND') {
				return 'is-outgoing';
			}

			return 'is-unknown';
		}

		function buildHistoricalGroups(calls) {
			var sortedCalls = (calls || []).slice().sort(function (left, right) {
				var leftTime = new Date(getCallTimestamp(left) || 0).getTime();
				var rightTime = new Date(getCallTimestamp(right) || 0).getTime();
				return rightTime - leftTime;
			});

			var groups = [];
			var groupMap = {};

			sortedCalls.forEach(function (call) {
				var dateKey = formatDateLabel(getCallTimestamp(call));

				if (!groupMap[dateKey]) {
					groupMap[dateKey] = {
						dateLabel: dateKey,
						calls: [],
					};
					groups.push(groupMap[dateKey]);
				}

				call.directionLabel = getCallTypeLabel(call);
				call.directionClass = getCallTypeClass(call);
				call.timeLabel = formatCallTime(call);
				decorateCallLabels(call);

				groupMap[dateKey].calls.push(call);
			});

			return groups;
		}

		function connectGoTo() {
			GotoService.getAuthorizationUrl()
				.then(function (url) {
					$window.open(url, '_blank', 'noopener');
				})
				.catch(function (error) {
					MessageService.showToast(
						error && error.data && error.data.message
							? error.data.message
							: 'Failed to start GoTo authorization.'
					);
				});
		}

		function disconnectGoTo() {
			GotoService.disconnect()
				.then(function (status) {
					vm.status = status || vm.status;
					publishStatus(vm.status);
					vm.liveCalls = [];
					vm.incomingCalls = [];
					vm.historicalCalls = [];
					vm.historicalGroups = [];
					MessageService.showToast('GoTo account disconnected.');
				})
				.catch(function (error) {
					var message =
						error && error.data && error.data.message
							? error.data.message
							: 'Failed to disconnect GoTo.';
					MessageService.showToast(message);
				});
		}

		function handleOAuthReturn() {
			var params = $location.search() || {};

			if (params.goto === 'connected') {
				refreshStatusFromServer().then(refreshCalls);
				MessageService.showToast('GoTo account linked.');
				$location.search('goto', null);
			} else if (params.goto === 'error') {
				MessageService.showToast(
					params.message
						? decodeURIComponent(params.message)
						: 'GoTo authorization failed.'
				);
				$location.search('goto', null);
				$location.search('message', null);
			}
		}

		function normalizePhoneForCustomerSearch(value) {
			var digits = String(value).replace(/\D/g, '');

			if (digits.length === 11 && digits.charAt(0) === '1') {
				return digits.slice(1);
			}

			return digits;
		}

		function parseCallerName(callerName) {
			var name = String(callerName || '').trim();

			if (!name || name.toLowerCase() === 'unknown') {
				return {
					firstName: null,
					lastName: null,
				};
			}

			var parts = name.split(/\s+/).filter(Boolean);

			if (parts.length === 1) {
				return {
					firstName: parts[0],
					lastName: null,
				};
			}

			return {
				firstName: parts[0],
				lastName: parts.slice(1).join(' '),
			};
		}

		function buildCustomerSearchParams(call, normalizedPhone) {
			var params = {
				phoneNumber: normalizedPhone,
				page: 1,
				limit: 10,
				sortBy: 'first_name',
				sortDirection: 'ASC',
			};
			var parsedName = parseCallerName(call.callerName || call.callerLabel);

			if (parsedName.firstName) {
				params.firstName = parsedName.firstName;
			}

			if (parsedName.lastName) {
				params.lastName = parsedName.lastName;
			}

			return params;
		}

		function navigateToCustomerSearch(searchParams) {
			closeCallPanel();
			$state.go('app.customers', searchParams, { reload: true });
		}

		function onOpenCustomerProfile($event, call) {
			if ($event) {
				$event.stopPropagation();
				$event.preventDefault();
			}

			openCustomerForCall(call);
		}

		function openCustomerForCall(call) {
			var rawPhone = call.phoneNumber || call.displayNumber || call.phoneLabel;

			if (!rawPhone || rawPhone === 'Unknown number') {
				MessageService.showToast('No phone number available for this call.');
				return;
			}

			var normalizedPhone = normalizePhoneForCustomerSearch(rawPhone);
			var companyID = LoginService.getCompanyID();
			var searchParams = buildCustomerSearchParams(call, normalizedPhone);

			CustomersService.customerPublicSearch(companyID, {
				phoneNumber: normalizedPhone,
			})
				.then(function (customers) {
					if (customers.length === 1) {
						closeCallPanel();
						$state.go('app.view-customer', {
							customerID: customers[0].getResourceID(),
						});
						return;
					}

					navigateToCustomerSearch(searchParams);
				})
				.catch(function (error) {
					if (error) {
						MessageService.showToast(
							error || 'Failed to look up customer for this phone number.'
						);
					}

					navigateToCustomerSearch(searchParams);
				});
		}
	}
})();

(function ()
{
	"use strict";

	angular.module("app.formValidator",[])
	.directive('formValidator', formValidator);

	function formValidator ($q, $timeout, VehicleService, api){

		var directive = {};
		var requestIdentifier = 0;

		directive.require 	= 'ngModel';
		directive.restrict	= 'A';

        directive.scope	= { 
        	asyncValidateApi: '=', 
        	asyncValidateParams: '='
        };


		directive.link = function($scope, $elem, $attr, ctrl){

			if($scope.asyncValidateApi != null){
				ctrl.$dirty = true;
				ctrl.$asyncValidators.formValidator = function(modelValue, viewValue) {
					return $scope.asyncValidateApi(modelValue, viewValue, $scope.asyncValidateParams, requestIdentifier++);
	            }	
			}

            $elem.on('keypress', function(event) {
		        if ( !patternFilter() ){ 
		        	event.preventDefault();
		        }
		        
		        function patternFilter() {
		       		return $attr.ngPattern.test(String.fromCharCode(event.which))
		        }

	      	})
		}

		return directive;
	}


})();
(function ()
{
    "use strict";

    angular
        .module("app.forceLogout", [
            "app.login"
        ])
        .config(config)
        .factory("ForceLogoutInterceptor", ForceLogoutInterceptor);

    /** @ngInject */
    function config($httpProvider)
    {
        $httpProvider.interceptors.push("ForceLogoutInterceptor");
    }

    /** @ngInject */
    function ForceLogoutInterceptor($q, $injector)
    {
        var isHandlingForceLogout = false;

        function isLoginPage()
        {
            return window.location.pathname === "/loginpage" ||
                   window.location.href.indexOf("/loginpage") !== -1;
        }

        function isLoginRequest(response)
        {
            var url = response && response.config && response.config.url
                ? response.config.url
                : "";

            return url.indexOf("/api/v1/login") !== -1;
        }

        function clearUserStatus()
        {
            var LoginService = $injector.get("LoginService");
            LoginService.clearUserStatus();
        }

        return {
            responseError: function(response)
            {
                var code = response && response.data ? response.data.code : null;

                var shouldRedirectToLogin =
                    response &&
                    response.status === 401 &&
                    (
                        code === "FORCE_LOGOUT" ||
                        code === "USER_INACTIVE"
                    );

                if (shouldRedirectToLogin && !isHandlingForceLogout) {
                    isHandlingForceLogout = true;

                    var LoginService = $injector.get("LoginService");

                    LoginService.clearUserStatus();

                    if (code === "FORCE_LOGOUT") {
                        window.alert("Your account has been logged out by an administrator.");
                    }
                    else if (code === "USER_INACTIVE") {
                        window.alert("Your account is not active.");
                    }

                    window.location.href = "/loginpage";
                }

                return $q.reject(response);
            }
        };
    }

})();
angular.module("fuse").run(["$templateCache", function($templateCache) {$templateCache.put("app/dialog/confirm-prompt-dialog.html","<div class=\"card\"><div class=\"modal-header bg-red\"><h5 class=\"modal-title mr-5\">{{vm.titleString}}</h5><button \ntype=\"button\" class=\"close\" ng-click=\"vm.closeDialog()\"><span aria-hidden=\"true\">&times;</span></button></div><div \nclass=\"card-body\"><p>{{vm.contentString}}</p><input type=\"text\" class=\"form-control my-2\" \nplaceholder=\"{{vm.inputBoxPlaceHolder}}\" ng-model=\"vm.inputString\" ng-change=\"vm.enableConfirmButton()\"><md-button \nclass=\"bg-red pull-right\" ng-click=\"vm.confirm()\" ng-disabled=\"!vm.isConfirmButtonActive\">{{vm.confirmButtonString}}\n</md-button><md-button class=\"bg-red pull-right\" ng-click=\"vm.cancel()\">{{vm.cancelButtonString}}</md-button></div>\n</div>");
$templateCache.put("app/dialog/options-prompt-dialog.html","<div class=\"card\"><div class=\"modal-header bg-red\"><h5 class=\"modal-title mr-5\">{{vm.titleString}}</h5><button \ntype=\"button\" class=\"close\" ng-click=\"vm.closeDialog()\"><span aria-hidden=\"true\">&times;</span></button></div><div \nclass=\"card-body\"><p class=\"pre-wrap\">{{vm.contentString}}</p><div layout=\"column\"><md-button flex \nng-repeat=\"option in vm.options\" class=\"bg-red\" ng-click=\"option.onClick(); vm.closeDialog()\">{{option.optionName}}\n</md-button></div></div></div>");
$templateCache.put("app/dialog/warningdialog.html","<div class=\"card\" style=\"max-width: 400px\"><div class=\"modal-header bg-yellow\"><h5 class=\"modal-title mr-5\">\n{{vm.title}}</h5><button type=\"button\" class=\"close\" ng-click=\"vm.cancel()\"><span aria-hidden=\"true\">&times;</span>\n</button></div><div class=\"card-body\"><p class=\"pre-wrap\">{{vm.message}}</p><div layout-gt-sm=\"row\" layout=\"column\">\n<md-button flex class=\"btn btn-success\" ng-click=\"vm.select(true)\"><div id=\"{{::vm.yesButtonID}}\" \nclass=\"tabbable-button\" tabindex=\"0\">{{vm.yesButtonText}}</div></md-button></div></div></div>");
$templateCache.put("app/dialog/yes-or-no-dialog.html","<div class=\"card\" style=\"max-width: 400px\"><div class=\"modal-header bg-yellow\"><h5 class=\"modal-title mr-5\">\n{{vm.title}}</h5><button type=\"button\" class=\"close\" ng-click=\"vm.cancel()\"><span aria-hidden=\"true\">&times;</span>\n</button></div><div class=\"card-body\"><p class=\"pre-wrap\">{{vm.message}}</p><div layout-gt-sm=\"row\" layout=\"column\">\n<md-button style=\"width: 15rem\" flex class=\"btn btn-danger\" ng-click=\"vm.select(false)\"><div>{{vm.noButtonText}}</div>\n</md-button><md-button style=\"width: 25rem\" flex class=\"btn btn-success\" ng-click=\"vm.select(true)\"><div \nid=\"{{::vm.yesButtonID}}\" class=\"tabbable-button\" tabindex=\"0\">{{vm.yesButtonText}}</div></md-button></div></div></div>");
$templateCache.put("app/message/message.html","<div class=\"alert alert-warning alert-dismissible fade show\" role=\"alert\"><button type=\"button\" class=\"close\" \ndata-dismiss=\"alert\" aria-label=\"Close\"><span aria-hidden=\"true\">&times;</span></button> <strong>Holy guacamole!\n</strong> You should check in on some of those fields below.</div>");
$templateCache.put("app/progress/progress.html","<md-progress-linear ng-model=\"vm.progress\" md-mode=\"{{vm.progress.mode}}\" value=\"{{vm.progress.progress}}\" \nng-if=\"vm.progress.isVisble\"></md-progress-linear>");
$templateCache.put("app/core/layouts/content-only.html","<div id=\"layout-content-only\" class=\"template-layout\" layout=\"column\" flex><md-content id=\"content\" \nclass=\"animate-slide-up md-hue-2\" ui-view=\"content\" flex></md-content></div>");
$templateCache.put("app/core/layouts/content-with-toolbar.html","<div id=\"layout-content-with-toolbar\" class=\"template-layout\" layout=\"column\" flex><md-toolbar id=\"toolbar\" \nclass=\"md-menu-toolbar md-whiteframe-1dp\" ui-view=\"toolbar\"></md-toolbar><md-content id=\"content\" \nclass=\"animate-slide-up md-hue-2\" ui-view=\"content\" flex></md-content><md-sidenav id=\"quick-panel\" \nclass=\"md-sidenav-right md-whiteframe-4dp\" md-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav>\n</div>");
$templateCache.put("app/core/layouts/horizontal-navigation.html","<div id=\"layout-horizontal-navigation\" class=\"template-layout\" layout=\"column\" flex><div \nid=\"toolbar-navigation-container\" class=\"md-whiteframe-1dp\" layout=\"column\" layout-align=\"space-between start\">\n<md-toolbar id=\"toolbar\" class=\"md-menu-toolbar md-whiteframe-1dp\" ui-view=\"toolbar\"></md-toolbar><div \nid=\"horizontal-navigation\" ui-view=\"navigation\" layout=\"row\" layout-align=\"start end\" flex></div></div><div \nid=\"content-container\" flex layout=\"column\"><md-content id=\"content\" class=\"animate-slide-up md-hue-2\" ms-scroll \nui-view=\"content\" flex></md-content></div><md-sidenav id=\"quick-panel\" class=\"md-sidenav-right md-whiteframe-4dp\" \nmd-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav></div>");
$templateCache.put("app/core/layouts/vertical-navigation-fullwidth-toolbar-2.html","<div id=\"layout-vertical-navigation-fullwidth-toolbar-2\" class=\"template-layout\" layout=\"column\"><md-toolbar \nid=\"toolbar\" class=\"hideWhenLogout md-menu-toolbar md-whiteframe-1dp md-accent\" ui-view=\"toolbar\"></md-toolbar><div \nui-view=\"progress\" class=\"fixed-bottom\"></div><div id=\"main-container\" layout=\"row\" flex><md-sidenav \nid=\"vertical-navigation\" class=\"md-primary-bg\" md-is-locked-open=\"$mdMedia(\'gt-sm\')\" md-component-id=\"navigation\" \nms-scroll ui-view=\"navigation\"></md-sidenav><div id=\"content-container\" flex layout=\"column\"><md-content id=\"content\" \nclass=\"md-hue-2 animate-slide-up\" style=\"overflow-x: hidden\" set-class-when-at-top=\"\" ui-view=\"content\" flex>\n</md-content></div></div></div>");
$templateCache.put("app/core/layouts/vertical-navigation-fullwidth-toolbar.html","<div id=\"layout-vertical-navigation-fullwidth-toolbar\" class=\"template-layout\" layout=\"column\" flex><md-toolbar \nid=\"toolbar\" class=\"md-menu-toolbar md-whiteframe-1dp md-accent\" ui-view=\"toolbar\"></md-toolbar><div \nid=\"main-container\" layout=\"row\" flex><md-sidenav id=\"vertical-navigation\" class=\"md-primary-bg\" \nmd-is-locked-open=\"$mdMedia(\'gt-sm\')\" md-component-id=\"navigation\" ms-scroll ui-view=\"navigation\"></md-sidenav><div \nid=\"content-container\" flex layout=\"column\"><md-content id=\"content\" class=\"animate-slide-up md-hue-2\" ms-scroll \nui-view=\"content\" flex></md-content></div><md-sidenav id=\"quick-panel\" class=\"md-sidenav-right md-whiteframe-4dp\" \nmd-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav></div></div>");
$templateCache.put("app/core/layouts/vertical-navigation.html","<div id=\"layout-vertical-navigation\" class=\"template-layout\" layout=\"row\" flex><md-sidenav id=\"vertical-navigation\" \nclass=\"md-primary-bg\" md-is-locked-open=\"$mdMedia(\'gt-sm\')\" md-component-id=\"navigation\" ms-scroll \nui-view=\"navigation\"></md-sidenav><div id=\"content-container\" flex layout=\"column\"><md-toolbar id=\"toolbar\" \nclass=\"md-menu-toolbar md-whiteframe-1dp\" ui-view=\"toolbar\"></md-toolbar><md-content id=\"content\" \nclass=\"animate-slide-up md-hue-2\" ms-scroll ui-view=\"content\" flex></md-content></div><md-sidenav id=\"quick-panel\" \nclass=\"md-sidenav-right md-whiteframe-4dp\" md-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav>\n</div>");
$templateCache.put("app/core/theme-options/theme-options.html","");
$templateCache.put("app/components/custom-nav-bar/custom-nav-bar.html","<div layout=\"row\" hide-xs hide-sm show-gt-sm style=\"overflow-x: auto\"><md-button ng-repeat=\"navItem in vm.navItems\" \nstyle=\"padding: 0 20px\" class=\"mx-0 mb-0 my-0\" ng-href=\"{{vm.getLink(navItem.state, navItem.params)}}\" \nng-class=\"vm.currentState == navItem.state? [\'custom-nav-item\', \'text-black\']:[\'text-grey\']\">{{::navItem.name}}\n</md-button></div><div style=\"position: relative\" show-xs show-sm hide-gt-sm id=\"navListMenu\" tabindex=\"0\" \nng-blur=\"vm.showMenu = false;\"><div layout=\"row\" layout-align=\"end center\"><md-button class=\"mx-0\" disabled=\"disabled\">\n{{vm.getCurrentTabName()}}</md-button><button><i class=\"icon-menu\" ng-click=\"vm.toggleMenu()\"></i></button></div><div \nclass=\"bg-white simple-border-no-radius\" ng-if=\"vm.showMenu\" \nstyle=\"position: absolute; top: 100%; z-index: 99; width: 100%\"><div ng-repeat=\"navItem in vm.navItems\" \nng-if=\"vm.currentState != navItem.state\"><div layout=\"row\" layout-align=\"end center\"><a class=\"text-grey m-2\" \nng-click=\"vm.goToState(navItem.state); vm.showMenu = false\">{{::navItem.name}}</a></div><md-divider></md-divider></div>\n</div></div>");
$templateCache.put("app/components/input-box/input-box-no-icon.html","<md-input-container class=\"md-icon-float input-box\"><input ng-change=\"vm.onChange(vm.value)\" \nng-required=\"{{vm.options.required}}\" name=\"{{vm.inputName}}\" ng-model=\"vm.value\" autocomplete=\"off\" \nplaceholder=\"{{vm.options.placeholder}}\" maxlength=\"{{vm.options.maxLength}}\" minlength=\"{{vm.options.minLength}}\" \nng-pattern=\"vm.options.inputPattern\" type=\"{{vm.options.inputType}}\"><div ng-messages=\"vm.form[vm.inputName].$error\">\n<div ng-message=\"pattern\">{{vm.options.invalidPatternMessage}}</div><div ng-message=\"maxlength\">\nInput content can not be over {{vm.options.maxLength}} charactors</div><div ng-message=\"minlength\">\nInput content can not be less than {{vm.options.maxLength}} charactors</div><div ng-message=\"required\">\nThis field is required</div><div ng-message=\"email\">Please enter a valid email.</div><div ng-message=\"number\">\nPlease enter a valid number.</div></div></md-input-container>");
$templateCache.put("app/components/input-box/input-box.html","<md-input-container class=\"md-icon-float input-box\"><md-icon ng-class=\"[vm.options.icon]\"></md-icon><input \nng-change=\"vm.onChange(vm.value)\" ng-required=\"{{vm.options.required}}\" name=\"{{vm.inputName}}\" ng-model=\"vm.value\" \nautocomplete=\"off\" placeholder=\"{{vm.options.placeholder}}\" maxlength=\"{{vm.options.maxLength}}\" \nminlength=\"{{vm.options.minLength}}\" ng-pattern=\"vm.options.inputPattern\" type=\"{{vm.options.inputType}}\"><div \nng-messages=\"vm.form[vm.inputName].$error\"><div ng-message=\"pattern\">{{vm.options.invalidPatternMessage}}</div><div \nng-message=\"maxlength\">Input content can not be over {{vm.options.maxLength}} charactors</div><div \nng-message=\"minlength\">Input content can not be less than {{vm.options.maxLength}} charactors</div><div \nng-message=\"required\">This field is required</div><div ng-message=\"email\">Please enter a valid email.</div><div \nng-message=\"number\">Please enter a valid number.</div></div></md-input-container>");
$templateCache.put("app/components/input-box/textarea-input-box-no-icon.html","<md-input-container class=\"md-icon-float input-box\"><textarea ng-required=\"{{vm.options.required}}\" \nname=\"{{vm.inputName}}\" ng-model=\"vm.value\" autocomplete=\"off\" placeholder=\"{{vm.options.placeholder}}\" \nmaxlength=\"{{vm.options.maxLength}}\" minlength=\"{{vm.options.minLength}}\" ng-pattern=\"vm.options.inputPattern\" \nmax-rows=\"{{vm.options.maxRows}}\" rows=\"{{vm.options.rows}}\">\r\n	<div ng-messages=\"vm.form[vm.inputName].$error\">\r\n		\n<div ng-message=\"pattern\">{{vm.options.invalidPatternMessage}}</div>\r\n		<div ng-message=\"maxlength\">\nInput content can not be over {{vm.options.maxLength}} charactors</div>\r\n		<div ng-message=\"minlength\">\nInput content can not be less than {{vm.options.maxLength}} charactors</div>\r\n		<div ng-message=\"required\">\nThis field is required</div>\r\n	</div>\r\n</textarea></md-input-container>");
$templateCache.put("app/components/input-box/textarea-input-box.html","<md-input-container class=\"md-icon-float input-box\"><md-icon ng-class=\"[vm.options.icon]\"></md-icon><textarea \nng-required=\"{{vm.options.required}}\" name=\"{{vm.inputName}}\" ng-model=\"vm.value\" autocomplete=\"off\" \nplaceholder=\"{{vm.options.placeholder}}\" maxlength=\"{{vm.options.maxLength}}\" minlength=\"{{vm.options.minLength}}\" \nng-pattern=\"vm.options.inputPattern\" max-rows=\"{{vm.options.maxRows}}\">\r\n	<div \nng-messages=\"vm.form[vm.inputName].$error\">\r\n		<div ng-message=\"pattern\">{{vm.options.invalidPatternMessage}}</div>\r\n		\n<div ng-message=\"maxlength\">Input content can not be over {{vm.options.maxLength}} charactors</div>\r\n		<div \nng-message=\"minlength\">Input content can not be less than {{vm.options.maxLength}} charactors</div>\r\n		<div \nng-message=\"required\">This field is required</div>\r\n	</div>\r\n</textarea></md-input-container>");
$templateCache.put("app/components/pagination/pagination.html","<div flex layout=\"row\" layout-align=\"center center\" ng-if=\"vm.totalPage > 1\" layout-align=\"center center\"><button \nclass=\"\" ng-click=\"vm.onPageChange(1)\" ng-style=\"{visibility: vm.currentPage != 1 ? \'visible\':\'hidden\'}\"><i \nclass=\"icon-page-first text-secondary\"></i></button><div ng-repeat=\"page in vm.pagesBeforeCurrentPage\" \nclass=\"text-secondary mx-1\" ng-click=\"vm.onPageChange(page)\">{{page}}</div><div class=\"mx-1\">{{vm.currentPage}}</div>\n<div ng-repeat=\"page in vm.pagesAfterCurrentPage\" class=\"text-secondary mx-1\" ng-click=\"vm.onPageChange(page)\">{{page}}\n</div><button class=\"\" ng-click=\"vm.onPageChange(vm.totalPage)\" \nng-style=\"{visibility: vm.currentPage != vm.totalPage ? \'visible\':\'hidden\'}\"><i class=\"icon-page-last text-secondary\">\n</i></button></div>");
$templateCache.put("app/components/stepper/stepper.html","<div layout=\"row\" layout-align=\"space-between center\"><div><button ng-disabled=\"vm.isDisabled\" \nng-style=\"{visibility: !!vm.steps[vm.currentStepIndex - 1]? \'visible\':\'hidden\'}\" \nng-click=\"vm.goToStep(vm.currentStepIndex - 1)\"><i class=\"icon-arrow-left-drop-circle\" \nng-class=\"vm.isDisabled ? [\'text-grey\']:[\'text-secondary\']\"></i></button></div><div layout=\"row\" \nlayout-align=\"center center\"><div ng-repeat=\"step in vm.steps\" class=\"mx-1\"><button \nng-disabled=\"vm.isStepBlocked($index)\" ng-click=\"vm.goToStep($index)\"><i ng-class=\"vm.getStepIconClass($index)\"></i>\n</button></div></div><div><button ng-disabled=\"vm.isNextDisabled()\" \nng-style=\"{visibility: !!vm.steps[vm.currentStepIndex + 1]? \'visible\':\'hidden\'}\" \nng-click=\"vm.goToStep(vm.currentStepIndex + 1)\"><i class=\"icon-arrow-right-drop-circle\" \nng-class=\"vm.isNextDisabled() ? [\'text-grey\']:[\'text-secondary\']\"></i></button></div></div>");
$templateCache.put("app/main/customers/customer-basic-info-form.html","<form layout=\"column\" layout-gt-sm=\"row\" name=\"custormerBasicInfoForm\"><div flex-gt-sm=\"55\" layout=\"column\"><div \nlayout=\"column\" layout-gt-sm=\"row\"><md-input-container flex-gt-sm=\"25\" \nclass=\"input-box info-form-item small-input-box\"><input type=\"text\" ng-change=\"vm.queryCustomers()\" autocorrect=\"off\" \nspellcheck=\"false\" ng-required=\"true\" name=\"firstName\" ng-model=\"vm.customer.first_name\" autocomplete=\"off\" \nplaceholder=\"First Name\" ng-model-options=\"{ debounce: 700 }\" maxlength=\"50\" input-control \ninput-translate=\"vm.translateToInitCap\"><div ng-messages=\"custormerBasicInfoForm.firstName.$error\"><div \nng-message=\"maxlength\">Input content can not be over 50 charactors</div><div ng-message=\"required\">\nThis field is required</div></div></md-input-container><md-input-container flex-gt-sm=\"25\" \nclass=\"input-box info-form-item small-input-box\"><input type=\"text\" autocorrect=\"off\" spellcheck=\"false\" \nng-model-options=\"{ debounce: 700 }\" ng-change=\"vm.queryCustomers()\" ng-required=\"true\" name=\"lastName\" \nng-model=\"vm.customer.last_name\" autocomplete=\"off\" placeholder=\"Last Name\" maxlength=\"50\" input-control \ninput-translate=\"vm.translateToInitCap\"><div ng-messages=\"custormerBasicInfoForm.lastName.$error\"><div \nng-message=\"maxlength\">Input content can not be over 50 charactors</div><div ng-message=\"required\">\nThis field is required</div></div></md-input-container></div><div layout=\"column\" layout-gt-md=\"row\"><div \nlayout=\"column\" flex-gt-md=\"50\" class=\"basic-info-form-contact-list\"><div class=\"animate-fade-in-out\" layout=\"row\" \nlayout-align=\"space-between center\" ng-repeat=\"phoneNumber in vm.customer.phone_numbers track by $index\"><div \nlayout=\"row\" flex=\"35\" flex-gt-md=\"40\" class=\"info-form-item\" layout-align=\"start center\"><md-button \nclass=\"md-icon-button\" flex=\"none\"><md-icon class=\"icon-minus-circle text-red\" \nng-click=\"vm.removePhoneNumber(phoneNumber)\"></md-icon></md-button><md-select class=\"md-no-underline small-selector\" \ntabindex=\"-1\" ng-model=\"phoneNumber.fk_id_phone_category\" placeholder=\"category\"><md-option \nng-repeat=\"phoneCategory in vm.constants.phoneCategories\" value=\"{{phoneCategory.id_phone_category}}\">\n{{phoneCategory.category}}</md-option></md-select></div><div layout=\"row\" flex=\"65\" flex-gt-md=\"60\" \nclass=\"info-form-item small-input-box\"><md-input-container flex=\"grow\"><input \nfocus-control=\"$index == vm.customer.phone_numbers.length - 1 && vm.addPhoneNumberButtonClicked\" \nng-change=\"vm.queryCustomers()\" ng-required=\"true\" name=\"{{\'phoneNumber\' + $index}}\" \nng-model=\"phoneNumber.phone_number\" autocomplete=\"off\" placeholder=\"Phone Number\" ng-model-options=\"{ debounce: 700 }\" \ninput-control input-translate=\"vm.translateToPhoneNumber\"><div \nng-messages=\"custormerBasicInfoForm[\'phoneNumber\' + $index].$error\"><div ng-message=\"required\">This field is required\n</div></div></md-input-container><md-switch ng-model=\"phoneNumber.allow_notification\" md-invert \nclass=\"basic-info-form-contact-list-switch\"></md-switch></div></div><div layout=\"row\" layout-align=\"start center\" \nclass=\"basic-info-form-contact-list-button\"><md-button class=\"md-icon-button\" flex=\"none\" \nng-click=\"vm.addPhoneNumber()\"><md-icon class=\"icon-plus-circle text-green tabbable-button\" tabindex=\"0\"></md-icon>\n</md-button>Add Phone Number</div></div><md-divider></md-divider><div layout=\"column\" flex-gt-md=\"50\" \nclass=\"basic-info-form-contact-list\"><div class=\"animate-fade-in-out\" layout=\"row\" layout-align=\"space-between center\" \nng-repeat=\"email in vm.customer.emails track by $index\"><div layout=\"row\" flex=\"35\" flex-gt-md=\"40\" \nclass=\"info-form-item\" layout-align=\"start center\"><md-button class=\"md-icon-button\" flex=\"none\"><md-icon \nclass=\"icon-minus-circle text-red\" ng-click=\"vm.removeEmail(email)\"></md-icon></md-button><md-select \nclass=\"md-no-underline small-selector\" tabindex=\"-1\" ng-model=\"email.fk_id_email_category\" placeholder=\"category\">\n<md-option ng-repeat=\"emailCategory in vm.constants.emailCategories\" value=\"{{emailCategory.id_email_category}}\">\n{{emailCategory.name}}</md-option></md-select></div><div layout=\"row\" flex=\"65\" flex-gt-md=\"60\" \nclass=\"info-form-item small-input-box\"><md-input-container flex=\"grow\"><input \nfocus-control=\"$index == vm.customer.emails.length - 1 && vm.addEmailButtonClicked\" type=\"email\" \nng-change=\"vm.queryCustomers()\" ng-required=\"true\" name=\"{{\'email\' + $index}}\" ng-model=\"email.email_address\" \nautocomplete=\"off\" placeholder=\"Email Address\" ng-model-options=\"{ debounce: 700 }\" maxlength=\"50\"><div \nng-messages=\"custormerBasicInfoForm[\'email\' + $index].$error\"><div ng-message=\"maxlength\">\nInput content can not be over 50 charactors</div><div ng-message=\"required\">This field is required</div><div \nng-message=\"email\">Invalid email address</div></div></md-input-container><md-switch \nng-model=\"email.allow_notification\" md-invert class=\"basic-info-form-contact-list-switch\"></md-switch></div></div><div \nlayout=\"row\" layout-align=\"start center\" class=\"basic-info-form-contact-list-button\"><md-button class=\"md-icon-button\" \nflex=\"none\"><md-icon class=\"icon-plus-circle text-green tabbable-button\" tabindex=\"0\" ng-click=\"vm.addEmail()\">\n</md-icon></md-button>Add Email</div></div></div><a ng-href=\"{{vm.foundCustomersLink}}\" \nclass=\"basic-info-form-customer-found-message animate-fade-in-out\" ng-if=\"vm.numberOfCustomerFound > 0\">\nSimilar customers found!</a></div><div flex-gt-sm=\"45\" layout=\"column\" layout-gt-md=\"row\"><div layout=\"column\" \nlayout-align=\"center center\" layout-padding class=\"basic-info-form-img-block\"><div style=\"position: relative\"><a \nng-href=\"{{vm.profileImageLink}}\"><img ng-class=\"vm.blurProfileImg? [\'opacity-50\']:[\'\']\" nv-file-drop=\"\" \nnv-file-over=\"\" uploader=\"vm.fileUploader\" class=\"basic-info-form-img card\" ng-src=\"{{vm.profileImageSrc}}\" \noptions=\"{isProfileImage:true}\" style=\"image-orientation: 90deg\"></a><md-progress-circular \nstyle=\"position: absolute; left: 70px; top:50px\" ng-if=\"vm.showProfileImgProgress\" \nclass=\"md-hue-2 basic-info-form-img-progress\" md-diameter=\"35px\"></md-progress-circular></div><md-button \nng-if=\"!vm.showProfileImgProgress\" class=\"btn-secondary btn-sm basic-info-form-file-select-button\">\nSelect Profile Image <input options=\"{isProfileImage:true}\" class=\"fileInput\" nv-file-select=\"false\" \nuploader=\"vm.fileUploader\" type=\"file\" accept=\"image/*\"></md-button><md-button ng-if=\"vm.showProfileImgProgress\" \nng-disabled=\"true\" class=\"md-secondary md-raised btn-sm basic-info-form-file-select-button\">Select Profile Image\n</md-button></div><div layout=\"column\" layout-align=\"center center\" layout-padding class=\"basic-info-form-img-block\">\n<div style=\"position: relative\"><a ng-href=\"{{vm.licenseImageLink}}\"><img \nng-class=\"vm.blurLicenseImg? [\'opacity-50\']:[\'\']\" nv-file-drop=\"\" nv-file-over=\"\" uploader=\"vm.fileUploader\" \nclass=\"basic-info-form-img card\" ng-src=\"{{vm.licenseImageSrc}}\" options=\"{isLicenseImage:true}\"></a>\n<md-progress-circular style=\"position: absolute; left: 70px; top:50px\" ng-if=\"vm.showLicenseImgProgress\" \nclass=\"md-hue-2 basic-info-form-img-progress\" md-diameter=\"35px\"></md-progress-circular></div><md-button \nng-if=\"!vm.showLicenseImgProgress\" class=\"btn-secondary btn-sm basic-info-form-file-select-button\">Select License \n<input options=\"{isLicenseImage:true}\" class=\"fileInput\" nv-file-select=\"false\" uploader=\"vm.fileUploader\" type=\"file\" \naccept=\"image/*\"></md-button><md-button ng-if=\"vm.showLicenseImgProgress\" ng-disabled=\"true\" \nclass=\"md-secondary md-raised btn-sm basic-info-form-file-select-button\">Select License</md-button></div></div></form>");
$templateCache.put("app/main/customers/customer-detail-info-form.html","<div layout=\"row\"><form flex=\"100\" flex-gt-sm=\"55\" name=\"custormerDetialInfoForm\" style=\"font-size: 13px\"><div \nlayout=\"row\" layout-wrap><md-input-container flex=\"50\" flex-gt-sm=\"25\"><label>License</label><input \nng-model=\"vm.customer.drivers_license\"></md-input-container><md-input-container flex=\"50\" flex-gt-sm=\"25\"><label>\nLicense expiry:</label><md-datepicker md-hide-icons=\"calendar\" ng-model=\"vm.expiryDatePickerValue\" \nng-change=\"vm.setLicenseExpiryDate(vm.expiryDatePickerValue)\" name=\"licenseExpiryDate\"></md-datepicker><div \nng-messages=\"custormerDetialInfoForm.licenseExpiryDate.$error\"><div ng-message=\"valid\">Invalid date.</div></div>\n</md-input-container><md-input-container flex=\"50\" flex-gt-sm=\"25\"><label>Insurance</label><input \nng-model=\"vm.customer.insurance_company\"></md-input-container><md-input-container flex=\"50\" flex-gt-sm=\"25\"><label>\nPolicy Number</label><input ng-model=\"vm.customer.policy_number\"></md-input-container></div><div layout=\"row\" \nlayout-wrap><md-input-container flex=\"100\" flex-gt-sm=\"50\" style=\"position: relative\"><label>Postcode</label><input \ninput-control input-translate=\"vm.translateToPostalCode\" ng-focus=\"vm.onPostcodeFocus()\" \nng-blur=\"vm.dismissAddressList()\" ng-model=\"vm.customer.address_postal_code\" ng-change=\"vm.onPostcodeChange()\"><div \nng-if=\"vm.showAddressList\" style=\"position: absolute; top: 30px; width: 100%;z-index: 100\" class=\"input-box-padding\">\n<md-content class=\"simple-border-no-radius\" style=\"max-height: 150px\"><md-progress-linear ng-if=\"vm.fetchingAddress\" \nmd-mode=\"indeterminate\"></md-progress-linear><div ng-click=\"vm.selectAddress(address)\" class=\"p-1\" \nng-if=\"!vm.fetchingAddress\" ng-repeat=\"address in vm.addressList\">{{vm.getAddressName(address)}}</div></md-content>\n</div></md-input-container></div><div layout=\"row\" layout-wrap><md-input-container flex=\"50\" flex-gt-sm=\"25\"><label>\nStreet #</label><input ng-model=\"vm.customer.address_street_number\"></md-input-container><md-input-container flex=\"50\" \nflex-gt-sm=\"25\"><label>Street</label><input ng-model=\"vm.customer.address_street\"></md-input-container>\n<md-input-container flex=\"50\" flex-gt-sm=\"25\"><label>City</label><input ng-model=\"vm.customer.address_city\" \ninput-control input-translate=\"vm.translateToFirstCap\"></md-input-container><md-input-container flex=\"50\" \nflex-gt-sm=\"25\"><label>Province</label><input input-control input-translate=\"vm.translateToAllCapitalize\" \nng-model=\"vm.customer.address_province\"></md-input-container></div><div layout=\"row\" layout-wrap><md-input-container \nflex=\"50\" flex-gt-sm=\"25\"><label>Birthday:</label><md-datepicker md-hide-icons=\"calendar\" \nng-model=\"vm.birthdayPickerValue\" ng-change=\"vm.setCustomerBirthday(vm.birthdayPickerValue)\" \nmd-max-date=\"vm.maxBirthdayDate\" name=\"birthday\"></md-datepicker><div \nng-messages=\"custormerDetialInfoForm.birthday.$error\" ng-if=\"custormerDetialInfoForm.birthday.$invalid\"><div \nng-message=\"valid\">Invalid date.</div><div ng-message=\"maxdate\">Must be over 16 years old.</div></div>\n</md-input-container></div><div layout=\"row\" layout-wrap><textarea flex=\"100\" rows=\"3\" ng-model=\"vm.customer.note\" \nclass=\"detail-info-form-note-input\" placeholder=\"Note:\"></textarea></div></form></div>");
$templateCache.put("app/main/customers/customer-search.html","<md-autocomplete ng-blur=\"vm.onBlurCallback()\" ng-focus=\"vm.onFocusCallback()\" md-no-cache=\"false\" \nmd-selected-item=\"vm.selectedCustomer\" md-search-text=\"vm.searchText\" md-delay=\"700\" md-select-on-focus=\"true\" \nmd-selected-item-change=\"vm.select(customer)\" md-items=\"customer in vm.queryCustomer(ctrl.searchText)\" \nmd-item-text=\"customer.getFullName() \" placeholder=\"Search customer by name, phonenumber\" \nmd-menu-class=\"vehicle-search-menu\" md-menu-container-class=\"vehicle-search-container\"><md-item-template><div \nlayout=\"row\" layout-align=\"start center\"><div class=\"item-detail\" style=\"font-size: 13px\"><span><a stop-event \nng-href=\"{{vm.getUrlForDetailPage(customer)}}\">{{customer.getFullName()}}</a></span><div>\n{{customer.phone_numbers[0].phone_number}}</div></div></div><md-divider></md-divider></md-item-template><md-not-found>\n{{::vm.notFoundMessage}}</md-not-found></md-autocomplete>");
$templateCache.put("app/main/book-appointment/book-appointment.html","<div layout=\"column\" style=\"min-height: 100%; position: relative\"><div flex=\"grow\"><div ng-class=\"vm.animteClass\" \nng-if=\"vm.currentStepIndex == 0\"><div class=\"sticky bg-default content-padding-full\"><h3 \nclass=\"text-secondary font-weight-bold\">Customer Lookup</h3><md-divider class=\"content-padding-bottom-full\">\n</md-divider><div layout=\"row\"><div flex><md-input-container class=\"input-box small-input-box\"><input \nng-disabled=\"vm.isBusy || vm.finishBooking\" name=\"mileage\" ng-model=\"vm.phoneNumber\" autocomplete=\"off\" \nplaceholder=\"Phone Number\" input-control input-translate=\"vm.translateToPhoneNumber\" ng-change=\"vm.searchCustomer()\">\n</md-input-container></div><div flex><md-input-container class=\"input-box small-input-box\"><input \nng-disabled=\"vm.isBusy || vm.finishBooking\" name=\"mileage\" ng-model=\"vm.email\" autocomplete=\"off\" placeholder=\"Email\" \nmaxlength=\"50\" ng-change=\"vm.searchCustomer()\" ng-model-options=\"{ debounce: 700 }\"></md-input-container></div></div>\n</div><div layout=\"row\" class=\"content-padding-x-full content-padding-bottom-full\" \nng-repeat=\"customer in vm.customers\"><md-button class=\"md-raised p-0 m-0 rounded-0\" flex=\"100\" \nng-click=\"vm.selectCustomer(customer)\" ng-disabled=\"vm.isBusy || vm.finishBooking\"><div class=\"bg-light-blue\" \nlayout=\"row\" layout-align=\"end end\" style=\"height:130px\"><div class=\"px-2 text-white\"><h4 class=\"text-truncate\"><i \nng-if=\"customer.id_customer == vm.selectedCustomer.id_customer\" class=\"icon-check-circle-outline text-yellow mr-2\"></i>\n {{customer.getFullName()}}</h4></div></div></md-button></div><div \nclass=\"content-padding-x-full content-padding-bottom-full\"><div ng-if=\"vm.noCustomerFound\" style=\"height: 130px\" \nclass=\"card bg-warning\" layout=\"row\" layout-align=\"center center\"><div class=\"px-2 text-white\"><h6>\nSorry, we can not find your info in the system, please <a ng-href=\"{{::vm.contactUsPhoneLink}}\">contact us</a>\n to make an appointment.</h6></div></div></div></div><div ng-class=\"vm.animteClass\" ng-if=\"vm.currentStepIndex == 1\" \nclass=\"\"><div class=\"sticky bg-default content-padding-full\"><h3 class=\"text-secondary font-weight-bold\">Select Vehicle\n</h3><md-divider></md-divider></div><div layout=\"row\" class=\"content-padding-x-full content-padding-bottom-full\" \nng-repeat=\"vehicle in vm.vehicles\"><md-button class=\"md-raised p-0 m-0 rounded-0\" flex=\"100\" \nng-disabled=\"vm.isBusy || vm.finishBooking\" ng-click=\"vm.selectVehicle(vehicle)\"><div class=\"bg-light-blue\" \nlayout=\"row\" layout-align=\"space-between end\" style=\"height: 130px\"><img \nstyle=\"height: 130px; width: 150px; object-fit: cover\" \nng-src=\"{{vehicle.landingImage ? vehicle.landingImage : vm.imagePlaceholder}}\"><div flex=\"60\" \nclass=\"px-2 text-white text-right\"><div class=\"text-truncate\">{{vehicle.vin}}</div><h6 class=\"mt-0 text-truncate\"><i \nng-if=\"vm.selectedVehicle.getResourceID() == vehicle.getResourceID()\" \nclass=\"icon-check-circle-outline text-yellow mr-2\"></i> {{vehicle.getYearMakeModel()}}</h6></div></div></md-button>\n</div><div ng-if=\"vm.noVehicleFound\" style=\"height: 130px\" class=\"card bg-warning\" layout=\"row\" \nlayout-align=\"center center\"><div class=\"px-2 text-white\"><h6>Sorry, we not found your vehicle in the system, please <a\n ng-href=\"{{::vm.contactUsPhoneLink}}\">contact us</a> to make an appointment.</h6></div></div></div><div \nng-class=\"vm.animteClass\" ng-if=\"vm.currentStepIndex == 2\"><div class=\"content-padding-full bg-default sticky\"><h3 \nclass=\"text-secondary font-weight-bold\">Select a Service</h3><md-divider></md-divider></div><div layout=\"row\" \nlayout-wrap class=\"content-padding-x-half\"><div flex=\"50\" ng-repeat=\"predefindAppointment in vm.predefindAppointments\" \nlayout=\"row\" class=\"content-padding-x-half content-padding-bottom-full\"><md-button class=\"md-raised p-0 m-0 rounded-0\" \nflex=\"100\" ng-disabled=\"vm.isBusy || vm.finishBooking\" ng-click=\"vm.selectService(predefindAppointment)\"><div \nclass=\"bg-light-blue\" layout=\"row\" layout-align=\"start end\" style=\"height: 130px; font-size: 13px; position: relative\">\n<img ng-if=\"predefindAppointment.image\" style=\"height: 100%;width: 100%; object-fit: cover\" \nng-src=\"{{predefindAppointment.image}}\"><div class=\"px-2 text-white text-right text-truncate bg-black\" \nstyle=\"position: absolute;width: 100%;bottom: 0;left: 0; opacity: 0.7\"><i style=\"font-size: 17px\" \nclass=\"icon-check-circle-outline text-yellow\" ng-if=\"predefindAppointment.isSelected\"></i>\n {{predefindAppointment.name}}</div></div></md-button></div><div flex=\"50\" layout=\"row\" \nclass=\"content-padding-x-half content-padding-bottom-full\"><md-button class=\"md-raised p-0 m-0 rounded-0\" flex=\"100\" \nng-disabled=\"vm.isBusy || vm.finishBooking\" ng-click=\"vm.selectService(null, true)\"><div class=\"bg-light-blue\" \nlayout=\"row\" layout-align=\"end end\" style=\"height: 130px;font-size: 13px\"><div class=\"px-2 text-white text-right\"><i \nstyle=\"font-size: 17px\" class=\"icon-check-circle-outline text-yellow\" ng-if=\"vm.isOtherServiceSelected\"></i> Other\n</div></div></md-button></div></div><div class=\"content-padding-x-full content-padding-bottom-full\"><div layout=\"row\" \nclass=\"content-padding-bottom-full\" ng-if=\"vm.isOtherServiceSelected\" ng-if=\"vm.isOtherServiceSelected\"><textarea \nng-disabled=\"vm.isBusy || vm.finishBooking\" maxlength=\"500\" class=\"content-padding-half\" flex style=\"height: 130px\" \nplaceholder=\"Please specify the service you need.\" ng-model=\"vm.otherServiceDetail\">		\r\n					</textarea></div><div \nlayout=\"row\" layout-align=\"center center\"><md-button flex=\"100\" \nng-disabled=\"!vm.isSelectServiceStepCompleted() || vm.isBusy || vm.finishBooking\" class=\"md-raised p-0 m-0 rounded-0\" \nng-click=\"vm.nextStep()\"><div \nng-class=\"!vm.isSelectServiceStepCompleted() || vm.isBusy || vm.finishBooking ? [\'bg-grey\'] : [\'bg-light-blue\']\" \nlayout=\"row\" layout-align=\"end end\" style=\"height: 65px\"><div class=\"px-2 text-white text-right\">next</div></div>\n</md-button></div></div></div><div ng-class=\"vm.animteClass\" ng-if=\"vm.currentStepIndex == 3\" \nclass=\"content-padding-full\"><div class=\"content-padding-bottom-full sticky\"><h3 \nclass=\"text-secondary font-weight-bold\">Pick a Date</h3><md-divider></md-divider></div><div layout=\"row\" \nlayout-align=\"center center\"><md-calendar ng-if=\"vm.availableSlots\" md-date-filter=\"vm.canDateBeSelect\" \nng-model=\"vm.selectedDate\" ng-change=\"vm.nextStep()\"></md-calendar><div flex=\"100\" ng-if=\"vm.calendarWarningMessage\" \nstyle=\"height: 130px\" class=\"card bg-warning\" layout=\"row\" layout-align=\"center center\"><div class=\"px-2 text-white\">\n<h6>{{vm.calendarWarningMessage}}, please <a ng-href=\"{{::vm.contactUsPhoneLink}}\">contact us</a>\n to make an appointment.</h6></div></div></div></div><div ng-class=\"vm.animteClass\" ng-if=\"vm.currentStepIndex == 4\" \nclass=\"content-padding-half\"><div class=\"content-padding-half\"><h3 class=\"text-secondary font-weight-bold\">\n{{vm.selectedDate | date:\'EEEE, MMM d\'}}</h3><md-divider></md-divider></div><div layout=\"row\" layout-wrap><div \nflex=\"50\" ng-repeat=\"slot in vm.timeSlotList\" layout=\"row\" class=\"content-padding-half\"><md-button \nclass=\"md-raised p-0 m-0 rounded-0\" flex=\"100\" ng-disabled=\"vm.isBusy || vm.finishBooking\" \nng-click=\"vm.selectTimeSlot(slot)\"><div class=\"bg-light-blue\" layout=\"row\" layout-align=\"end end\" style=\"height: 65px\">\n<div class=\"px-2 text-white text-right\"><span><i class=\"icon-check-circle-outline text-yellow\" \nng-if=\"vm.selectedTimeSlot == slot\"></i> {{slot.start.format(\"h:mm a\")}} - {{slot.end.format(\"h:mm a\")}}</span></div>\n</div></md-button></div></div></div><div ng-class=\"vm.animteClass\" ng-if=\"vm.currentStepIndex == 5\" \nclass=\"content-padding-full\"><div class=\"content-padding-bottom-full\"><h3 class=\"text-secondary font-weight-bold\">\nReview Details</h3><md-divider></md-divider></div><div layout=\"row\" class=\"content-padding-bottom-full\"><div \nclass=\"text-grey font-weight-bold\" style=\"width: 120px\">CUSTOMER:</div><div flex=\"grow\">\n{{vm.selectedCustomer.getFullName()}}</div></div><div layout=\"row\" class=\"content-padding-bottom-full\"><div \nclass=\"text-grey font-weight-bold\" style=\"width: 120px\">VEHICLE:</div><div flex=\"grow\">\n{{vm.selectedVehicle.getYearMakeModel()}}</div></div><div layout=\"row\" class=\"content-padding-bottom-full\"><div \nclass=\"text-grey font-weight-bold\" style=\"width: 120px\">SERVICE:</div><div flex=\"grow\">\n{{vm.getAppointmentDescription()}}</div></div><div layout=\"row\" class=\"content-padding-bottom-full\"><div \nclass=\"text-grey font-weight-bold\" style=\"width: 120px\">TIME:</div><div class=\"font-weight-bold\" flex=\"grow\">\n{{vm.selectedTimeSlot.start.format(\"h:mm a\")}} - {{vm.selectedTimeSlot.end.format(\"h:mm a\")}}, {{vm.selectedDate | date:\'EEEE MMMM d y\'}}\n</div></div><div layout=\"row\" layout-align=\"center center\"><div style=\"height: 65px\" ng-if=\"vm.finishBooking\"><h3 \nclass=\"font-weight-bold text-green\">Appointment is booked!</h3></div><md-button style=\"height: 65px; font-size: 20px\" \nng-if=\"!vm.finishBooking\" flex=\"100\" ng-disabled=\"vm.isBusy\" \nclass=\"md-raised p-0 m-0 rounded-0 bg-light-blue text-white\" ng-click=\"vm.makeAppointment()\">schedule appointment\n</md-button></div></div></div><div class=\"content-padding-x-full content-padding-bottom-full\"><stepper \nnext=\"vm.nextStepByStepper\" is-disabled=\"vm.isBusy || vm.finishBooking\" go-to-step=\"vm.goToStepByStepper\" \nsteps=\"vm.steps\" current-step-index=\"vm.currentStepIndex\" before-step-change=\"vm.beforeStepChange\"></stepper></div><div\n layout=\"row\" class=\"content-padding-x-full content-padding-bottom-full\"><div flex=\"100\"><div><div class=\"text-grey\">\nContact us</div><div class=\"content-padding-y-half\"><md-divider></md-divider></div></div><div \nclass=\"content-padding-bottom-half\" layout=\"row\" layout-align=\"start center\"><div class=\"content-padding-right-half\"><i\n class=\"icon-phone\"></i></div><a ng-href=\"{{::vm.contactUsPhoneLink}}\" target=\"_blank\">(905)-618-0350</a></div><div \nlayout=\"row\" layout-align=\"start center\"><div class=\"content-padding-right-half\"><i class=\"icon-email\"></i></div><a \nhref=\"mailto:rmservice@gmail.com\" target=\"_blank\">rmservice@gmail.com</a></div></div></div></div>");
$templateCache.put("app/main/file-upload/file-section-preview.html","<div nv-file-drop uploader=\"vm.fileUploader\"><div layout=\"row\" layout-align=\"center center\"><div \nclass=\"simple-border p-1 preview-box\" layout=\"row\" layout-align=\"center center\" style=\"position: relative\"><img flex \nclass=\"preview-img\" \nng-if=\"vm.canBePreviewed(vm.fileList[vm.selectedIndex].fileData) && vm.fileList[vm.selectedIndex].previewUrl\" \nng-src=\"{{vm.fileList[vm.selectedIndex].previewUrl}}\"><md-progress-circular \nng-if=\"vm.canBePreviewed(vm.fileList[vm.selectedIndex].fileData) && !vm.fileList[vm.selectedIndex].previewUrl\" \nmd-diameter=\"30\"></md-progress-circular><i ng-class=\"!!vm.fileList[vm.selectedIndex] ? [\'\']:[\'text-white\']\" \nclass=\"icon-file\" style=\"width: 75px; font-size: 75px\" \nng-if=\"!vm.canBePreviewed(vm.fileList[vm.selectedIndex].fileData)\"></i> <button \nstyle=\"position: absolute; top: 0; right:0\" ng-if=\"!!vm.fileList[vm.selectedIndex]\" \nng-click=\"vm.onFileDelete(vm.fileList[vm.selectedIndex], $index)\" ng-disabled=\"vm.isProcessingData\"><i \nng-class=\"vm.isProcessingData ? [\'\']:[\'text-red\']\" class=\"icon-close-circle\"></i></button></div></div><div \nlayout=\"column\" layout-align=\"center center\" class=\"preview-file-name\"><a \nng-href=\"{{vm.getFileURL(vm.fileList[vm.selectedIndex].fileData)}}\" class=\"text-nowrap text-truncate\">\n{{vm.fileList[vm.selectedIndex].fileData.getFileName()}}</a></div><md-divider></md-divider><div layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" style=\"overflow-x: scroll\" class=\"p-1\"><div \nng-focus=\"vm.onFocus($index)\" tabindex=\"0\" ng-repeat=\"item in vm.fileList track by $index\" class=\"mx-1\" \nng-class=\"vm.selectedIndex == $index ? [\'bg-grey\']:[\'\']\"><div layout=\"row\" layout-align=\"center center\" \nclass=\"preview-list-item\"><img class=\"preview-list-item-img\" \nng-if=\"vm.canBePreviewed(item.fileData) && item.previewUrl\" ng-src=\"{{item.previewUrl}}\"><i \nclass=\"icon-file preview-list-item-icon\" ng-if=\"!vm.canBePreviewed(item.fileData)\"></i><md-tooltip \nmd-direction=\"bottom\">{{item.fileData.getFileName()}}</md-tooltip><md-progress-circular \nng-if=\"vm.canBePreviewed(item.fileData) && !item.previewUrl\" md-diameter=\"20\"></md-progress-circular></div></div><div \nng-repeat=\"item in vm.fileUploader.queue track by $index\" class=\"mx-1\"><div style=\"position: relative\" layout=\"row\" \nlayout-align=\"center center\" class=\"preview-list-item\"><i ng-if=\"!item.previewUrl\" \nclass=\"icon-file preview-list-item-icon opacity-50\"></i> <img class=\"opacity-50 preview-list-item-img\" \nng-if=\"item.previewUrl\" ng-src=\"{{item.previewUrl}}\"><md-tooltip md-direction=\"bottom\">{{item.file.name}}</md-tooltip>\n<i ng-if=\"item.isSuccess\" class=\"text-green icon-check-circle\" \nstyle=\"position: absolute; top:70; left: 105; font-size: 20px\"></i><md-progress-circular ng-if=\"item.isUploading\" \nstyle=\"position: absolute; top:70; left: 105\" md-diameter=\"20\"></md-progress-circular></div></div><div \nng-if=\"!(vm.fileList.length > 0) && !(vm.fileUploader.queue.length > 0)\" layout=\"column\" layout-align=\"center center\" \nclass=\"preview-item-not-found\"><div>No file found.</div></div></div><div layout=\"row\" layout-align=\"center center\">\n<md-button class=\"md-icon-button\"><md-icon class=\"icon-plus-circle text-green\"></md-icon><input multiple=\"multiple\" \nclass=\"fileInput\" nv-file-select=\"false\" uploader=\"vm.fileUploader\" type=\"file\"></md-button></div></div><md-divider>\n</md-divider></div>");
$templateCache.put("app/main/file-upload/file-section.html","<md-divider></md-divider><div class=\"pt-5\" nv-file-drop uploader=\"vm.fileUploader\"><div \nng-if=\"!(vm.uploadedFiles.length > 0) && !(vm.fileUploader.queue.length > 0)\">No file item</div><div layout=\"row\" \nlayout-align=\"space-between center\" ng-repeat=\"uploadedFile in vm.uploadedFiles\"><div flex=\"80\" \nclass=\"text-nowrap text-truncate\"><a href=\"{{vm.getFileURL(uploadedFile)}}\">{{uploadedFile.file_name}}</a></div><div \nlayout=\"row\" layout-align=\"end center\"><md-button class=\"md-icon-button mx-0\" ng-disabled=\"vm.isProcessingData\" \nng-disabled=\"vm.isProcessingData\" ng-click=\"vm.copyLink(uploadedFile)\"><md-icon \nclass=\"icon-content-copy text-secondary\"></md-icon></md-button><md-button class=\"md-icon-button mx-0\" \nng-disabled=\"vm.isProcessingData\" ng-click=\"vm.onFileDelete(uploadedFile, $index)\"><md-icon class=\"icon-minus-circle\" \nng-class=\"vm.isProcessingData == true ? [\'text-grey\']:[\'text-red\']\"></md-icon></md-button></div></div><div \nlayout=\"row\" layout-align=\"space-between center\" ng-repeat=\"file in vm.fileUploader.queue\"><div flex=\"80\" \nclass=\"text-nowrap text-truncate\">{{file.file.name}}</div><div layout=\"row\" layout-align=\"end center\"><md-button \nng-if=\"file.isUploading\" class=\"md-icon-button mx-0\" layout=\"row\" layout-align=\"center center\"><md-progress-circular \nmd-diameter=\"18\"></md-progress-circular></md-button><md-button ng-if=\"!file.isUploading && !file.isSuccess\" \nng-disabled=\"file.isUploading\" ng-click=\"file.remove()\" class=\"md-icon-button mx-0\" layout=\"row\" \nlayout-align=\"end center\"><md-icon class=\"icon-minus-circle text-red\"></md-icon></md-button><md-button \nng-if=\"file.isSuccess\" class=\"md-icon-button mx-0\" layout=\"row\" layout-align=\"end center\"><md-icon \nclass=\"icon-check-circle text-green\"></md-icon></md-button></div></div></div><div layout=\"row\" \nlayout-align=\"center center\"><md-button class=\"md-icon-button\"><md-icon class=\"icon-plus-circle text-green\"></md-icon>\n<input multiple=\"multiple\" class=\"fileInput\" nv-file-select=\"false\" uploader=\"vm.fileUploader\" type=\"file\"></md-button>\n</div><md-divider></md-divider>");
$templateCache.put("app/main/file-view/file-view.html","<div layout=\"column\" layout-fill layout-align=\"start center\"><div style=\"width: 100%\" flex=\"nogrow\" layout=\"row\" \nng-if=\"vm.fileUrl\" layout-align=\"end center\" class=\"bg-grey\"><button ng-click=\"vm.download()\" class=\"m-2\"><i \nclass=\"icon-download text-white\"></i></button></div><img flex ng-if=\"vm.isImage\" ng-src=\"{{vm.fileUrl}}\" \nstyle=\"object-fit: contain\"><iframe layout-fill ng-if=\"!!vm.file.isPublic() && !vm.isImage\" src=\"{{vm.fileUrl}}\" \nname=\"fileViewIframe\" id=\"fileViewIframe\"><a href=\"{{vm.fileUrl}}\" onclick=\"print(); return false\">\nclick here to print this page</a></iframe><md-content layout-fill ng-if=\"!vm.file.isPublic() && vm.isPdf\"><pdf-viewer \nsrc=\"vm.fileUrl\"></pdf-viewer></md-content><div layout-margin layout=\"row\" layout-align=\"center center\" \nng-if=\"!vm.file.isPublic() && vm.otherType\"><i class=\"icon-alert-circle\"></i><div>\nCan not render file type: {{vm.file.getFileType()}}</div></div></div>");
$templateCache.put("app/main/file-view/pdf-viewer.html","<div layout=\"column\" id=\"canvasContainer\" layout-margin layout-align=\"center center\"></div>");
$templateCache.put("app/main/goto/goto-call-panel.html","<md-menu md-position-mode=\"target-right target\" md-on-open=\"vm.onMenuOpen()\" md-on-close=\"vm.onMenuClose()\"><md-button \nclass=\"md-icon-button goto-call-button\" ng-class=\"{\'is-active-call\': vm.activeCalls.length > 0}\" \nng-click=\"$mdOpenMenu($event)\" aria-label=\"GoTo calls\"><md-icon md-font-icon=\"icon-phone\" class=\"icon\"></md-icon><span \nclass=\"goto-call-badge\" ng-if=\"vm.incomingCalls.length > 0\">{{vm.incomingCalls.length}}</span></md-button>\n<md-menu-content width=\"5\" class=\"goto-call-menu\"><div class=\"goto-call-menu-header\" layout=\"row\" \nlayout-align=\"space-between center\"><div><div class=\"goto-call-menu-title\">GoTo Calls</div><div \nclass=\"goto-call-menu-user\" ng-if=\"vm.status.authenticated && vm.status.gotoUserName\">\nGoTo account: {{vm.status.gotoUserName}}</div><div class=\"goto-call-menu-scope\" \nng-if=\"vm.status.authenticated && !vm.status.canViewAllDealershipCalls\"><span>Showing your GoTo calls</span></div><div \nclass=\"goto-call-scope-toggle-row\" \nng-if=\"vm.status.authenticated && vm.canToggleDealershipCallScope && vm.status.canViewAllDealershipCalls\" \nmd-prevent-menu-close ng-click=\"vm.onCallScopeToggle()\" role=\"switch\" aria-checked=\"{{vm.showAllDealershipCalls}}\" \naria-label=\"Toggle between all dealership calls and my calls only\" tabindex=\"0\"><span class=\"goto-call-scope-label\">\n{{vm.showAllDealershipCalls ? \'All dealership calls\' : \'My calls only\'}} </span><span class=\"goto-call-switch\" \nng-class=\"{\'is-on\': vm.showAllDealershipCalls}\"><span class=\"goto-call-switch-thumb\"></span></span></div></div><div \nclass=\"goto-call-menu-actions\" layout=\"row\" layout-align=\"end center\"><md-button \nclass=\"md-primary md-raised goto-connect-button\" ng-if=\"!vm.status.authenticated\" ng-click=\"vm.connectGoTo()\">Connect\n</md-button><md-button class=\"md-warn goto-connect-button\" ng-if=\"vm.status.authenticated\" md-prevent-menu-close \nng-click=\"vm.disconnectGoTo()\">Disconnect</md-button></div></div><md-divider></md-divider><div \nclass=\"goto-call-section goto-call-section-list\"><div class=\"goto-call-section-title\">Calls</div><div \nng-if=\"vm.liveCalls.length === 0 && vm.historicalCalls.length === 0\" class=\"goto-call-empty\">No calls</div><div \nclass=\"goto-call-item\" md-prevent-menu-close ng-repeat=\"call in vm.liveCalls track by call.id\"><div \nclass=\"goto-call-historical-row\"><div class=\"goto-call-historical-top\"><span class=\"goto-call-direction\" \nng-class=\"call.statusClass\">{{call.statusLabel}}</span> <span class=\"goto-call-time\" ng-if=\"call.timeLabel\">\n{{call.timeLabel}}</span></div><div class=\"goto-call-body\" layout=\"row\" layout-align=\"start center\"><md-button \nclass=\"md-icon-button goto-profile-button\" type=\"button\" md-prevent-menu-close \nng-click=\"vm.onOpenCustomerProfile($event, call)\" title=\"Open customer\" aria-label=\"Open customer\"><md-icon \nmd-font-icon=\"icon-account\" class=\"icon goto-profile-button-icon\"></md-icon></md-button><div \nclass=\"goto-call-details flex\"><div class=\"goto-call-phone\">{{call.phoneLabel || \'Unknown number\'}}</div><div \nclass=\"goto-call-name\">{{call.callerLabel}}</div></div><goto-dial-button class=\"goto-call-dial-actions\" \nphone-number=\"call.phoneNumber || call.displayNumber\" display-name=\"call.callerLabel\" \nng-if=\"call.phoneNumber || call.displayNumber\"></goto-dial-button></div></div></div><div \nng-repeat=\"group in vm.historicalGroups track by group.dateLabel\"><div class=\"goto-call-date-header\">\n{{group.dateLabel}}</div><div class=\"goto-call-item\" md-prevent-menu-close \nng-repeat=\"call in group.calls track by call.id\"><div class=\"goto-call-historical-row\"><div \nclass=\"goto-call-historical-top\"><span class=\"goto-call-direction\" ng-class=\"call.directionClass\">\n{{call.directionLabel}}</span> <span class=\"goto-call-time\">{{call.timeLabel}}</span></div><div class=\"goto-call-body\" \nlayout=\"row\" layout-align=\"start center\"><md-button class=\"md-icon-button goto-profile-button\" type=\"button\" \nmd-prevent-menu-close ng-click=\"vm.onOpenCustomerProfile($event, call)\" title=\"Open customer\" \naria-label=\"Open customer\"><md-icon md-font-icon=\"icon-account\" class=\"icon goto-profile-button-icon\"></md-icon>\n</md-button><div class=\"goto-call-details flex\"><div class=\"goto-call-phone\">{{call.phoneLabel || \'Unknown number\'}}\n</div><div class=\"goto-call-name\">{{call.callerLabel}}</div></div><goto-dial-button class=\"goto-call-dial-actions\" \nphone-number=\"call.phoneNumber || call.displayNumber\" display-name=\"call.callerLabel\" \nng-if=\"call.phoneNumber || call.displayNumber\"></goto-dial-button></div></div></div></div></div></md-menu-content>\n</md-menu>");
$templateCache.put("app/main/goto/goto-dial-button.html","<span class=\"goto-dial-button-host\" layout=\"row\" layout-align=\"start center\"><md-button \nclass=\"md-icon-button goto-dial-button\" type=\"button\" md-prevent-menu-close \nng-disabled=\"!vm.isGoToConnected || vm.isDialing || !vm.phoneNumber\" ng-click=\"vm.onDial($event)\" \ntitle=\"{{vm.isGoToConnected ? \'Call\' : vm.disabledTooltip}}\" \naria-label=\"{{vm.isGoToConnected ? \'Call\' : vm.disabledTooltip}}\"><md-icon md-font-icon=\"icon-phone\" \nclass=\"icon goto-dial-button-icon\"></md-icon></md-button><md-button class=\"md-icon-button goto-copy-button\" \ntype=\"button\" md-prevent-menu-close ng-disabled=\"!vm.phoneNumber\" ng-click=\"vm.onCopy($event)\" \ntitle=\"Copy phone number\" aria-label=\"Copy phone number\"><md-icon md-font-icon=\"icon-content-copy\" \nclass=\"icon goto-copy-button-icon\"></md-icon></md-button></span>");
$templateCache.put("app/main/hellosign/signing-page.html","<div layout=\"column\" layout-fill layout-align=\"center center\"><md-progress-circular ng-if=\"vm.isProcessing\" \nclass=\"md-accent\" md-diameter=\"60\"></md-progress-circular><div layout=\"column\" layout-fill \nlayout-align=\"center center\"><h1>{{vm.message}}</h1><a ng-if=\"vm.redirectUrl\" ng-href=\"{{vm.redirectUrl}}\">\n{{vm.redirectTitle}}</a></div></div>");
$templateCache.put("app/main/homepage/homepage.html","");
$templateCache.put("app/main/login/login.html","<div id=\"login\" class=\"p-8\"><div class=\"form-wrapper md-elevation-8 p-8\"><div ng-model=\"logo\" \nclass=\"logo bg-secondary\"><span>{{logo.initial}}</span></div><div class=\"title mt-4 mb-8\">Log in to your account</div>\n<div ng-model=\"verifyNotice\" class=\"alert alert-dismissible alert-success center\" ng-if=\"verifyNotice.isVisible\">\n<button ng-click=\"dismissAlert()\" type=\"button\" class=\"close\">&times;</button> <strong>{{verifyNotice.content}}\n</strong></div><form name=\"loginForm\" novalidate method=\"post\"><div class=\"form-group mb-4\"><label \nfor=\"loginFormInputEmail\">User Name</label><input ng-init=\"vm.focus()\" type=\"text\" name=\"loginFormUserName\" \nclass=\"form-control\" id=\"loginFormInputEmail\" aria-describedby=\"emailHelp\" required ng-pattern=\"/^[a-zA-Z0-9@._]*$/\" \nng-model=\"loginForm.username\"></div><div class=\"form-group mb-4\"><label for=\"loginFormInputPassword\">Password</label>\n<input type=\"password\" name=\"loginFormInputPassword\" class=\"form-control\" id=\"loginFormInputPassword\" required \nng-pattern=\"/^[a-zA-Z0-9@._]*$/\" ng-model=\"loginForm.password\"></div><div \nclass=\"remember-forgot-password row no-gutters align-items-center justify-content-between pt-4\"><div \nclass=\"form-check remember-me mb-4\"><label class=\"form-check-label\"><input type=\"checkbox\" class=\"form-check-input\" \naria-label=\"Remember Me\"> <span class=\"checkbox-icon\"></span> <span class=\"form-check-description\">Remember Me</span>\n</label></div><a href=\"#\" class=\"forgot-password text-secondary mb-4\">Forgot Password?</a></div><button type=\"submit\" \nclass=\"submit-button btn btn-block btn-secondary my-4 mx-auto\" aria-label=\"LOG IN\" ng-click=\"login()\">LOG IN</button>\n</form></div></div>");
$templateCache.put("app/main/redirect-page/redirect-page.html","<div ng-if=\"vm.isDirecting\">Redirecting...</div><div ng-if=\"!vm.isDirecting \">\nThis page is invalid, rediecting to homepage. ({{vm.countdown}})</div>");
$templateCache.put("app/main/register/register-page.html","<div ng-if=\"vm.vehicleName\" class=\"header py-6 bg-primary text-auto px-2\"><span class=\"h3\">\nDear {{vm.vehicleName}}, Please use the following form to register</span></div><div class=\"content-wrapper\" \nng-if=\"vm.vehicleName\" layout=\"column\" style=\"max-width: 800px\"><div class=\"container-fluid px-10 py-7\" \nng-hide=\"vm.registerCompleted\"><div class=\"row\"><div class=\"col px-0 profile-box info-box general card mx-2 my-3\">\n<header class=\"h1 text-auto p-4\" \nstyle=\"background-image: url(\'assets/images/banner.png\'); background-size: contain;  background-repeat: no-repeat; height: 100px;\r\n				width: 50%\">\n<div class=\"title\"></div></header><div class=\"jumbotron mx-3 my-7 row\"><div class=\"col-7\"><div \nng-hide=\"vm.isResettingPassWord\"><div class=\"title font-weight-bold mb-1\">\nWe fond the following email address and phone number form your profile.</div><div class=\"animate-fade-in-out\" \nlayout=\"row\" layout-align=\"space-between center\" ng-repeat=\"email in vm.emails track by $index\"><div \nng-if=\"!vm.editingEmailList[email.id_email]\">{{email.email_address}}</div><div \nng-if=\"vm.editingEmailList[email.id_email]\"><input name=\"Email Address\" class=\"info form-control\" type=\"email\" \nng-model=\"email.email_address\"></div><div><button ng-if=\"!vm.editingEmailList[email.id_email]\" type=\"submit\" \nng-click=\"vm.editEmailContent(email.id_email)\"><p title=\"Edit\"><i class=\"icon-pen text-secondary ng-scope\"></i></p>\n</button> <button ng-if=\"vm.editingEmailList[email.id_email]\" type=\"submit\" \nng-click=\"vm.finishEditEmailContent(email)\"><p title=\"Save\"><i class=\"icon-check-all text-secondary ng-scope\"></i></p>\n</button> <button ng-if=\"vm.editingEmailList[email.id_email]\" type=\"submit\" \nng-click=\"vm.reverseEmailById(email.id_email)\"><p title=\"Reverse\"><i class=\"icon-refresh text-secondary ng-scope\"></i>\n</p></button> <button type=\"submit\" ng-click=\"vm.copyToUsername(email.email_address)\"><p title=\"Use as username\"><i \nclass=\"icon-cursor-pointer text-secondary ng-scope\"></i></p></button></div></div><md-divider \nclass=\"form-divider-horizontal\"></md-divider><div class=\"animate-fade-in-out\" layout=\"row\" \nlayout-align=\"space-between center\" ng-repeat=\"phonenumber in vm.phoneNumbers track by $index\"><div \nng-if=\"!vm.editingPhonenumberList[phonenumber.id_phone_number]\">{{phonenumber.phone_number}}</div><div \nng-if=\"vm.editingPhonenumberList[phonenumber.id_phone_number]\"><input name=\"Phone Number\" class=\"info form-control\" \ntype=\"email\" ng-model=\"phonenumber.phone_number\"></div><div><button \nng-if=\"!vm.editingPhonenumberList[phonenumber.id_phone_number]\" type=\"submit\" \nng-click=\"vm.editPhoneNumberContent(phonenumber.id_phone_number)\"><p title=\"Edit\"><i \nclass=\"icon-pen text-secondary ng-scope\"></i></p></button> <button \nng-if=\"vm.editingPhonenumberList[phonenumber.id_phone_number]\" type=\"submit\" \nng-click=\"vm.finishEditPhoneNumberContent(phonenumber)\"><p title=\"Save\"><i \nclass=\"icon-check-all text-secondary ng-scope\"></i></p></button> <button \nng-if=\"vm.editingPhonenumberList[phonenumber.id_phone_number]\" type=\"submit\" \nng-click=\"vm.reversePhoneById(phonenumber.id_phone_number)\"><p title=\"Reverse\"><i \nclass=\"icon-refresh text-secondary ng-scope\"></i></p></button></div></div><md-divider class=\"form-divider-horizontal\">\n</md-divider><span class=\"badge badge-pill badge-warning\" ng-hide=\"(vm.allEditionSet() == true)\">\nPlease save you edition before proceed.</span></div><form name=\"addUser\"><div class=\"info-line mb-6\"><div \nclass=\"title font-weight-bold mb-1\">Email address <span class=\"badge badge-pill badge-warning pull-right\" \nng-if=\"(vm.isUsernameAvailable == false)\">Email address in use</span><div \nclass=\"badge badge-pill badge-warning pull-right\" ng-if=\"addUser.username.$dirty && addUser.username.$invalid\">\nMust be a valid email address</div><i class=\"icon s-4 text-green icon-check-circle-outline\" \nng-if=\"addUser.username.$dirty && (vm.isUsernameAvailable == true) && addUser.username.$valid\"></i>\n<md-progress-circular class=\"pull-right mx-2\" md-diameter=\"20px\" \nng-if=\"addUser.username.$dirty && vm.isCheckingUsername\"></md-progress-circular></div><input name=\"username\" \nclass=\"info form-control\" type=\"email\" ng-model=\"vm.customer.username\" \nng-blur=\"vm.checkUsername(vm.customer.username)\" ng-focus=\"vm.isUsernameAvailable = undefined\" \nng-disabled=\"vm.isResettingPassWord\" required></div><div class=\"info-line mb-6\"><div \nclass=\"title font-weight-bold mb-1\">Password<div class=\"badge badge-pill badge-warning pull-right\" role=\"alert\" \nng-if=\"addUser.password.$dirty && addUser.password.$invalid\">Must be between 6-20 characters</div></div><input \nname=\"password\" class=\"info form-control\" type=\"password\" ng-model=\"vm.customer.password\" required ng-maxlength=\"20\" \nng-minlength=\"6\"></div><button type=\"submit\" class=\"btn bg-blue\" ng-click=\"vm.addUser()\" \nng-disabled=\"addUser.username.$invalid || addUser.password.$invalid || vm.disableAddButton || (vm.isUsernameAvailable == false) || !vm.allEditionSet()\" \nstyle=\"width: 15rem\">Register</button></form></div></div></div></div></div><div class=\"container-fluid px-10 py-7\" \nng-hide=\"!vm.registerCompleted\"><div class=\"col px-0 profile-box info-box general card mx-2 my-3\" class=\"row\" \nflex=\"40\"><header class=\"h1 text-auto p-4\" \nstyle=\"background-image: url(\'assets/images/banner.png\'); background-size: contain;  background-repeat: no-repeat; height: 100px;\r\n			width: 50%\">\n<div class=\"title\"></div></header><div class=\"jumbotron mx-3 my-7 row\" flex layout-align=\"space-between center\"><div \nclass=\"col-7\"><header class=\"h1 text-auto p-4\"><div class=\"title\">Registration Complete</div></header><p>\nThank you for registering! Your account has been created successfully.</p><a href=\"https://portal.autocart.ca/\">\nClick here to log in</a></div></div></div></div></div><div ng-if=\"vm.uuiderror\"><div fxlayout=\"column\" \nfxlayoutalign=\"center center\"><h2>Permission denied</h2><div>\nIt appears you do not have permission to perform this operation. Please contact the email sender for anupdated link.\n</div></div></div><style>.content-div {\r\n		flex: 50px\r\n	}</style>");
$templateCache.put("app/main/reports/mechanic-hour-detail.html","<div layout=\"row\" layout-align=\"space-between center\"><div>\n{{vm.mechanicHourDetail.first_name + \' \' + vm.mechanicHourDetail.last_name}} ({{vm.getTotalHours(vm.mechanicHourDetail.workorderForService) + vm.getTotalHours(vm.mechanicHourDetail.workorderForRM) | number : 2}} hrs)\n</div><i ng-click=\"vm.showDetail = !vm.showDetail\" \nng-class=\"vm.showDetail ? [\'icon-chevron-up\']:[\'icon-chevron-down\']\"></i></div><md-divider \nclass=\"content-padding-bottom-half\"></md-divider><div ng-if=\"vm.showDetail\"><div class=\"content-padding-bottom-half\">\n<div class=\"card\"><div class=\"card-header py-1 bg-grey\"><div class=\"text-white font-weight-bold\" layout=\"row\" \nlayout-align=\"space-between center\"><div>Customer Work Orders</div><div>\nTotal Hours ({{vm.getTotalHours(vm.mechanicHourDetail.workorderForService)}})</div></div></div><div class=\"card-body\">\n<md-content style=\"font-size: 13px; height: 130px\"><div \nng-if=\"!(vm.mechanicHourDetail.workorderForService.length > 0)\">No item found</div><div layout=\"row\" \nlayout-align=\"space-between start\" ng-repeat=\"item in vm.mechanicHourDetail.workorderForService\"><a \nng-href=\"{{vm.getWorkorderUrl(item)}}\">{{item.invoiceNumber}}</a><div>\n{{item.totalLaborHours / item.mechanicCount | number:2}}</div></div></md-content></div></div></div><div><div \nclass=\"card\"><div class=\"card-header py-1 bg-grey\"><div class=\"text-white font-weight-bold\" layout=\"row\" \nlayout-align=\"space-between center\"><div>RM Work Orders</div><div>\nTotal Hours ({{vm.getTotalHours(vm.mechanicHourDetail.workorderForRM)}})</div></div></div><div class=\"card-body\">\n<md-content style=\"font-size: 13px; height: 130px\"><div ng-if=\"!(vm.mechanicHourDetail.workorderForRM.length > 0)\">\nNo item found</div><div layout=\"row\" layout-align=\"space-between start\" \nng-repeat=\"item in vm.mechanicHourDetail.workorderForRM\"><a ng-href=\"{{vm.getWorkorderUrl(item)}}\">\n{{item.invoiceNumber}}</a><div>{{item.totalLaborHours / item.mechanicCount | number:2}}</div></div></md-content></div>\n</div></div></div>");
$templateCache.put("app/main/reports/report-info-customer-form.html","<div layout=\"column\" layout-gt-sm=\"row\" class=\"px-1\"><div flex-gt-sm=\"50\"><div flex-gt-sm=\"75\" class=\"card\" \nstyle=\"font-size: 13px\" ng-if=\"vm.customerList.length > 0\" ng-repeat=\"customer in vm.customerList\"><div layout=\"row\" \nlayout-align=\"start center\" class=\"p-2\"><div layout=\"column\"><div class=\"text-secondary\" style=\"font-size: 15px\"><a \nhref=\"{{vm.getCustomerPageUrl(customer)}}\" class=\"text-nowrap text-truncate\">\n{{customer.first_name}} {{customer.last_name}}</a></div><div class=\"text-grey\"><div layout=\"row\"><span \nclass=\"badge badge-secondary mx-0\" ng-click=\"vm.removeCusomter(customer)\">Remove</span></div></div></div><br></div>\n</div></div><div flex-gt-sm=\"50\"><md-input-container \nclass=\"pr-0 input-box info-form-item small-input-box purchase-step-payment-input-box\"><input ng-model=\"vm.searchText\" \nng-model-options=\"{ debounce: 700 }\" placeholder=\"Search Customer\" ng-change=\"vm.onSearchTextChange()\" \nautocomplete=\"off\"></md-input-container><div ng-if=\"vm.customersFound.length > 0\" style=\"font-size: 13px\"><div \nclass=\"card\"><div class=\"card-header\">Potential Matches</div><div class=\"card-body scrollable py-1\" \nstyle=\"max-height: 200px\" ms-scroll><div layout=\"column\"><div \nng-click=\"vm.selectedCustomerID = customer.getResourceID()\" layout=\"row\" class=\"pl-1 py-1 customer-found\" \nlayout-align=\"space-between center\" ng-class=\"vm.selectedCustomerID == customer.getResourceID()? [\'bg-light\']:[\'\']\" \nng-repeat=\"customer in vm.customersFound\"><span flex=\"50\" class=\"text-nowrap text-truncate\">\n{{customer.first_name}} {{customer.last_name}}</span><div layout=\"row\" class=\"mt-1 px-2\" \nng-if=\"vm.selectedCustomerID == customer.getResourceID()\"><span class=\"badge badge-secondary mr-1\" \nng-click=\"vm.goToCustomerPage(customer)\">View</span> <span class=\"badge badge-secondary mx-0\" \nng-click=\"vm.selectCusomter(customer)\">Add</span></div></div></div></div></div></div></div></div>");
$templateCache.put("app/main/reports/reports.html","<div style=\"width: 100%\" class=\"bg-secondary header-backgroud\" layout=\"row\" layout-align=\"center center\"><div flex \nclass=\"content-max-width content-padding-full\"><span class=\"h2 white-fg\">Service Reports</span></div></div><div \nstyle=\"width: 100%\" layout=\"row\" layout-align=\"center start\"><div flex class=\"content-max-width content-padding-full\">\n<div layout=\"row\" layout-align=\"space-between center\"><form name=\"dateRangeForm\" layout=\"row\" \nlayout-align=\"start center\"><div><md-input-container class=\"input-box small-input-box\"><label>From</label>\n<md-datepicker md-max-date=\"vm.endDate\" ng-disabled=\"vm.isBusy\" md-hide-icons=\"calendar\" ng-model=\"vm.startDate\" \nname=\"startDate\"></md-datepicker><div ng-messages=\"dateRangeForm.startDate.$error\"><div ng-message=\"valid\">\nInvalid date.</div><div ng-message=\"maxdate\">Should be before end date</div></div></md-input-container></div><div>\n<md-input-container class=\"input-box small-input-box\"><label>To</label><md-datepicker md-min-date=\"vm.startDate\" \nng-disabled=\"vm.isBusy\" md-hide-icons=\"calendar\" ng-model=\"vm.endDate\" name=\"endDate\"></md-datepicker><div \nng-messages=\"dateRangeForm.endDate.$error\"><div ng-message=\"valid\">Invalid date.</div><div ng-message=\"mindate\">\nshould be after start date</div></div></md-input-container></div><div><md-input-container \nclass=\"input-box small-input-box pb-20 pl-5\"><md-button class=\"btn-secondary mx-0\" ng-click=\"vm.refreshReport()\" \nng-disabled=\"vm.isBusy\">Generate Report</md-button></md-input-container></div></form><div class=\"mb-3\"><button \nng-disabled=\"vm.isBusy\" ng-click=\"vm.downloadReport()\"><i class=\"icon-download text-secondary\" \nng-class=\"vm.isBusy ? [\'\'] : [\'text-secondary\']\"></i></button></div></div><div flex=\"100\"><form name=\"saleInfoForm\" \nid=\"accordionExample\"><div class=\"card\"><div class=\"card-header\" id=\"customerSection\"><h2 class=\"mb-0\"><button \nclass=\"btn btn-link btn-block text-left px-0\" type=\"button\" data-toggle=\"collapse\" \ndata-target=\"#collapseCustomerSection\" aria-expanded=\"true\" aria-controls=\"collapseCustomerSection\">Customer</button>\n</h2></div><div id=\"collapseCustomerSection\" class=\"collapse\" aria-labelledby=\"customerSection\" \ndata-parent=\"#accordionExample\"><div class=\"card-body\"><report-info-customer-form \non-customer-change=\"vm.onCustomerChange\"></report-info-customer-form></div></div></div></form></div><br><md-tabs \nmd-dynamic-height md-border-bottom md-selected=\"vm.currentTabIndex\"><md-tab label=\"Mechanic Hours\" \nng-disabled=\"vm.isBusy\"></md-tab><md-tab label=\"Profit\" ng-disabled=\"vm.isBusy\"></md-tab><md-tab \nlabel=\"No 100% Subsidized\" ng-disabled=\"vm.isBusy\"></md-tab></md-tabs><div layout=\"row\" layout-wrap \nclass=\"content-padding-y-full\" ng-show=\"vm.currentTabIndex == vm.mechanicHourTabIndx\"><div flex=\"100\" flex-gt-sm=\"30\">\n<div ng-repeat=\"mechanicHourDetail in vm.mechanicHourReportDatas\" class=\"content-padding-y-half\"><mechanic-hour-table \nmechanic-hour-detail=\"mechanicHourDetail\"></mechanic-hour-table></div><div \nng-if=\"!(vm.mechanicHourReportDatas.length > 0)\">No item found</div></div><div flex=\"100\" flex-gt-sm=\"70\"><canvas \nid=\"myChart\"></canvas></div></div><service-report-table ng-if=\"vm.currentTabIndex == vm.profitTabIndex\" \nreport-datas=\"vm.serviceReportDatas\"></service-report-table><service-report-table \nng-if=\"vm.currentTabIndex == vm.noSubsidized\" report-datas=\"vm.noSubServiceReportDatas\"></service-report-table></div>\n</div>");
$templateCache.put("app/main/reports/service-profit-table.html","<table class=\"table table-hover\" style=\"table-layout: fixed;width:100%; min-width:200px\"><thead class=\"sticky-thead\">\n<tr><th class=\"text-nowrap bg-light\">Invoice #</th><th class=\"text-nowrap bg-light\" \nng-click=\"vm.changeSorting(vm.sortTagSubsidized)\">Subsidized ({{vm.getTotal().subsidized | currency:\'$\':2}})<md-icon \nng-style=\"{visibility: vm.sortBy == vm.sortTagSubsidized? \'visible\':\'hidden\'}\" \nng-class=\"vm.isDESC? [\'icon-chevron-up\']:[\'icon-chevron-down\']\"></md-icon></th><th class=\"text-nowrap bg-light\" \nng-click=\"vm.changeSorting(vm.sortTagCost)\">Cost ({{vm.getTotal().cost | currency:\'$\':2}})<md-icon \nng-style=\"{visibility: vm.sortBy == vm.sortTagCost? \'visible\':\'hidden\'}\" \nng-class=\"vm.isDESC? [\'icon-chevron-up\']:[\'icon-chevron-down\']\"></md-icon></th><th class=\"text-nowrap bg-light\" \nng-click=\"vm.changeSorting(vm.sortTagIncome)\">Retail ({{vm.getTotal().income | currency:\'$\':2}})<md-icon \nng-style=\"{visibility: vm.sortBy == vm.sortTagIncome? \'visible\':\'hidden\'}\" \nng-class=\"vm.isDESC? [\'icon-chevron-up\']:[\'icon-chevron-down\']\"></md-icon></th><th class=\"text-nowrap bg-light\" \nng-click=\"vm.changeSorting(vm.sortTagProfit)\">Potential Profit ({{vm.getTotal().profit | currency:\'$\':2}})<md-icon \nng-style=\"{visibility: vm.sortBy == vm.sortTagProfit? \'visible\':\'hidden\'}\" \nng-class=\"vm.isDESC? [\'icon-chevron-up\']:[\'icon-chevron-down\']\"></md-icon></th><th class=\"text-nowrap bg-light\" \nng-click=\"vm.changeSorting(vm.sortTagWorkOrderProfit)\">Actual Profit ({{vm.getTotal().totalprofit | currency:\'$\':2}})\n<md-icon ng-style=\"{visibility: vm.sortBy == vm.sortTagWorkOrderProfit? \'visible\':\'hidden\'}\" \nng-class=\"vm.isDESC? [\'icon-chevron-up\']:[\'icon-chevron-down\']\"></md-icon></th></tr></thead><tbody><tr \nng-repeat=\"reportData in vm.reportDatas\"><td><a ng-href=\"{{vm.getWorkorderUrl(reportData)}}\">\n{{reportData.invoiceNumber}}</a></td><td>{{reportData.subsidized | currency:\'$\':2}}</td><td>\n{{reportData.totalCost | currency:\'$\':2}}</td><td>{{reportData.totalIncome | currency:\'$\':2}}</td><td>\n{{reportData.profit | currency:\'$\':2}}</td><td>{{reportData.workorder_profit|| 0 | currency:\'$\':2}}</td></tr><tr \nng-if=\"!(vm.reportDatas.length > 0)\"><td colspan=\"7\">No item found.</td></tr></tbody></table>");
$templateCache.put("app/main/sale-info/edit-sale-info.html","<div style=\"width: 100%\" class=\"bg-secondary header-backgroud\" layout=\"row\" layout-align=\"center center\"><div flex \nclass=\"content-max-width content-padding-x-full text-white\"><span class=\"h2\">{{::vm.vehicle.getYearMakeModel()}}</span>\n<div>VIN: {{::vm.vehicle.vin}}</div><div>SALE DATE: {{::vm.saleInfo.sale_date | date:\'mediumDate\'}}</div><span \nclass=\"text-black\"><a class=\"text-black\" style=\"text-decoration: underline\" ng-href=\"{{vm.vehicleDetailPageUrl}}\">\nVEHICLE INFO</a> <span class=\"mx-2\">></span> <a class=\"text-black\" style=\"text-decoration: underline\" \nng-href=\"{{vm.vehiclePageUrl}}\">EDIT VEHICLE</a> <span class=\"mx-2\">></span> SALE INFO</span></div></div><div \nstyle=\"width: 100%\" layout=\"row\" layout-align=\"center start\"><div layout=\"row\" layout-wrap flex \nclass=\"content-max-width content-padding-x-half\"><div flex=\"100\" flex-gt-sm=\"70\" \nclass=\"accordion content-padding-x-half content-padding-y-full\"><div class=\"sticky card\"><div class=\"px-2\" \nlayout=\"row\" layout-wrap><div class=\"mr-3\" ng-repeat=\"(key, item) in vm.sectionOptions\" layout=\"row\" \nlayout-align=\"start center\"><div ng-click=\"vm.activateSection(item)\">{{::item.name}}</div><md-checkbox \nclass=\"my-2 mx-1\" ng-model=\"item.active\" ng-change=\"vm.onSectionActivated(item)\"></md-checkbox></div></div></div><form \nname=\"saleInfoForm\" id=\"accordionExample\"><div class=\"card\"><div class=\"card-header\" id=\"customerSection\"><h2 \nclass=\"mb-0\"><button class=\"btn btn-link btn-block text-left px-0\" type=\"button\" data-toggle=\"collapse\" \ndata-target=\"#collapseCustomerSection\" aria-expanded=\"true\" aria-controls=\"collapseCustomerSection\">Customer</button>\n</h2></div><div id=\"collapseCustomerSection\" class=\"collapse show\" aria-labelledby=\"customerSection\" \ndata-parent=\"#accordionExample\"><div class=\"card-body\"><sale-info-customer-form \non-customer-select=\"vm.onCustomerSelect\" ng-if=\"vm.customer != null\" constants=\"vm.cusomterFormConstants\" \ncustomer=\"vm.customer\"></sale-info-customer-form></div></div></div><div class=\"card\" \nid=\"{{::vm.generalCollapseSectionID + vm.sectionTitleTag}}\"><div class=\"card-header\"><h2 class=\"mb-0\"><button \nclass=\"btn btn-link btn-block text-left px-0\" type=\"button\" data-toggle=\"collapse\" \ndata-target=\"{{::\'#\' + vm.generalCollapseSectionID}}\">General <span ng-if=\"saleInfoForm.generalForm.$invalid\"><i \nclass=\"icon-alert-circle text-red\"></i></span></button></h2></div><div id=\"{{::vm.generalCollapseSectionID}}\" \nclass=\"collapse\" data-parent=\"#accordionExample\"><div class=\"card-body\"><sale-info-general-form \nsale-info=\"vm.saleInfo\" plate-options=\"vm.plateOptions\"></sale-info-general-form></div></div></div><div class=\"card\">\n<div class=\"card-header\" id=\"deliverySection\"><h2 class=\"mb-0\"><button class=\"btn btn-link btn-block text-left px-0\" \ntype=\"button\" data-toggle=\"collapse\" data-target=\"#collapseDeliverySection\" aria-expanded=\"true\" \naria-controls=\"collapseDeliverySection\">Delivery</button></h2></div><div id=\"collapseDeliverySection\" class=\"collapse\" \naria-labelledby=\"deliverySection\" data-parent=\"#accordionExample\"><div class=\"card-body\"><sale-info-deliver-status-form\n workorder-priorities=\"vm.workorderPriorities\" quoted-workorders=\"vm.quotedWorkorders\" sale-info=\"vm.saleInfo\">\n</sale-info-deliver-status-form></div></div></div><div class=\"card\" ng-if=\"vm.sectionOptions.financing.active\" \nid=\"{{::vm.financingCollapseSectionID + vm.sectionTitleTag}}\"><div class=\"card-header\" id=\"financingSection\"><h2 \nclass=\"mb-0\"><button class=\"btn btn-link btn-block text-left px-0\" type=\"button\" data-toggle=\"collapse\" \ndata-target=\"{{::\'#\'+vm.financingCollapseSectionID}}\">{{::vm.sectionOptions.financing.name}} <span \nng-if=\"saleInfoForm.financeApplicationForm.$invalid\"><i class=\"icon-alert-circle text-red\"></i></span></button></h2>\n</div><div id=\"{{vm.financingCollapseSectionID}}\" class=\"collapse\" data-parent=\"#accordionExample\"><div \nclass=\"card-body\"><sale-info-additional-finance-info-form sale-info=\"vm.saleInfo\">\n</sale-info-additional-finance-info-form></div></div></div><div class=\"card\" ng-if=\"vm.sectionOptions.tradeIn.active\" \nid=\"{{::vm.tradeInCollapseSectionID + vm.sectionTitleTag}}\"><div class=\"card-header\" id=\"tradeInSection\"><h2 \nclass=\"mb-0\"><button class=\"btn btn-link btn-block text-left px-0\" type=\"button\" data-toggle=\"collapse\" \ndata-target=\"{{::\'#\' + vm.tradeInCollapseSectionID}}\">{{::vm.sectionOptions.tradeIn.name}} <span \nng-if=\"saleInfoForm.tradeInForm.$invalid\"><i class=\"icon-alert-circle text-red\"></i></span></button></h2></div><div \nid=\"{{::vm.tradeInCollapseSectionID}}\" class=\"collapse\" data-parent=\"#accordionExample\"><div class=\"card-body\"><div \nlayout=\"row\" layout-align=\"start center\" style=\"font-size: 13px\"><div layout=\"row\" layout-align=\"center center\" \nng-if=\"!vm.tradeInVehicle\"><span>New trade in vehicle</span><md-button class=\"md-icon-button mx-0 btn-sm\" \nng-click=\"vm.initNewTradeInVechile()\"><md-icon class=\"icon-plus-circle text-green purchase-step-extra-item-icon\">\n</md-icon></md-button></div><div layout=\"row\" layout-align=\"center center\" ng-if=\"vm.tradeInVehicle\"><span>\nRemove trade in vehicle</span><md-button class=\"md-icon-button mx-0 btn-sm\" ng-click=\"vm.removeTradeInVehicle()\">\n<md-icon class=\"icon-delete-circle text-danger purchase-step-extra-item-icon\"></md-icon></md-button></div></div>\n<sale-info-trade-in-form ng-if=\"vm.tradeInVehicle != null\" trade-in-vehicle=\"vm.tradeInVehicle\" customer=\"vm.customer\">\n</sale-info-trade-in-form></div></div></div><div class=\"card\" ng-if=\"vm.sectionOptions.warranty.active\" \nid=\"{{::vm.warrantyCollapseSectionID + vm.sectionTitleTag}}\"><div class=\"card-header\" id=\"warrantySection\"><h2 \nclass=\"mb-0\"><button class=\"btn btn-link btn-block text-left px-0\" type=\"button\" data-toggle=\"collapse\" \ndata-target=\"{{::\'#\' + vm.warrantyCollapseSectionID}}\">{{::vm.sectionOptions.warranty.name}} <span \nng-if=\"saleInfoForm.warrantyForm.$invalid\"><i class=\"icon-alert-circle text-red\"></i></span></button></h2></div><div \nid=\"{{::vm.warrantyCollapseSectionID}}\" class=\"collapse\" data-parent=\"#accordionExample\"><div class=\"card-body\"><div \nlayout=\"row\" layout-align=\"start center\" style=\"font-size: 13px\"><div layout=\"row\" layout-align=\"center center\" \nng-if=\"!vm.saleWarranty\"><span>New warranty</span><md-button class=\"md-icon-button mx-0 btn-sm\" \nng-click=\"vm.initNewSaleWarranty()\"><md-icon class=\"icon-plus-circle text-green purchase-step-extra-item-icon\">\n</md-icon></md-button></div><div layout=\"row\" layout-align=\"center center\" ng-if=\"vm.saleWarranty\"><span>\nRemove warranty</span><md-button class=\"md-icon-button mx-0 btn-sm\" ng-click=\"vm.removeSaleWarranty()\"><md-icon \nclass=\"icon-delete-circle text-danger purchase-step-extra-item-icon\"></md-icon></md-button></div></div>\n<sale-info-warranty-form vehicle=\"vm.vehicle\" warrant-options=\"vm.warrantyOptions\" current-warranty=\"vm.saleWarranty\">\n</sale-info-warranty-form></div></div></div><div class=\"card\" ng-if=\"vm.sectionOptions.extras.active\" \nid=\"{{::vm.extrasCollapseSectionID + vm.sectionTitleTag}}\"><div class=\"card-header\" id=\"extrasSection\"><h2 \nclass=\"mb-0\"><button class=\"btn btn-link btn-block text-left px-0\" type=\"button\" data-toggle=\"collapse\" \ndata-target=\"{{::\'#\' + vm.extrasCollapseSectionID}}\">{{::vm.sectionOptions.extras.name}}</button></h2></div><div \nid=\"{{::vm.extrasCollapseSectionID}}\" class=\"collapse\" data-parent=\"#accordionExample\"><div class=\"card-body\" \nstyle=\"font-size: 13px\"><div class=\"font-weight-bold\">Packages:</div><sale-info-package-list \nsold-date=\"vm.saleInfo.sale_date\" preset-packages=\"vm.presetPackages\" package-items-map=\"vm.packageItemsMap\" \nsale-packages=\"vm.salePackages\" sale-info=\"vm.saleInfo\" job-list=\"vm.jobTyppList\" \non-preset-package-select=\"vm.addPackage\" on-purchase-package-remove=\"vm.deletePackage\"></sale-info-package-list><div \nclass=\"mt-8 font-weight-bold\">Extras:</div><sale-info-extra-list on-remove-extras=\"vm.removeExtras\" \non-add-extras=\"vm.addExtras\" current-extras=\"vm.saleExtras\" preset-extras-options=\"vm.presetExtrasOptions\">\n</sale-info-extra-list></div></div></div><div class=\"card\" ng-if=\"vm.sectionOptions.promotions.active\" \nid=\"{{::vm.promotionsCollapseSectionID + vm.sectionTitleTag}}\"><div class=\"card-header\" id=\"promotionsSection\"><h2 \nclass=\"mb-0\"><button class=\"btn btn-link btn-block text-left px-0\" type=\"button\" data-toggle=\"collapse\" \ndata-target=\"{{::\'#\' + vm.promotionsCollapseSectionID}}\">{{::vm.sectionOptions.promotions.name}}</button></h2></div>\n<div id=\"{{::vm.promotionsCollapseSectionID}}\" class=\"collapse\" data-parent=\"#accordionExample\"><div class=\"card-body\">\n<sale-info-promotion-list sold-date=\"vm.saleInfo.sale_date\" on-add-promotion=\"vm.addPromotion\" \non-remove-promotion=\"vm.removePromotion\" current-promotions=\"vm.promotions\" promotion-options=\"vm.promotionOptions\">\n</sale-info-promotion-list><div layout=\"row\" layout-wrap><md-input-container flex-gt-sm=\"25\" flex=\"50\" \nclass=\"input-box info-form-item small-input-box purchase-step-payment-input-box\"><input \nng-disabled=\"vm.isAddingCustomPromotion\" maxlength=\"10\" autocorrect=\"off\" autocapitalize=\"none\" spellcheck=\"false\" \nng-model=\"vm.customPromotionName\" autocomplete=\"off\" placeholder=\"Name\" input-control \ninput-translate=\"vm.translateToInitCapitalize\"></md-input-container><md-input-container flex-gt-sm=\"25\" flex=\"50\" \nclass=\"input-box info-form-item small-input-box purchase-step-payment-input-box\"><input \nng-disabled=\"vm.isAddingCustomPromotion\" maxlength=\"10\" autocorrect=\"off\" autocapitalize=\"none\" spellcheck=\"false\" \nng-model=\"vm.customPromotionDescription\" autocomplete=\"off\" input-control \ninput-translate=\"vm.translateToInitCapitalize\" placeholder=\"Description\"></md-input-container><md-input-container \nflex-gt-sm=\"25\" flex=\"50\" class=\"input-box info-form-item small-input-box purchase-step-payment-input-box\"><input \nng-disabled=\"vm.isAddingCustomPromotion\" maxlength=\"10\" autocorrect=\"off\" autocapitalize=\"none\" spellcheck=\"false\" \nng-model=\"vm.customPromotionAmount\" autocomplete=\"off\" placeholder=\"Amount\" input-control \ninput-translate=\"vm.translateToDollar\" input-options=\"vm.saleDiscountInputOption\"></md-input-container><div \nflex-gt-sm=\"25\" flex=\"50\" layout=\"row\" layout-align=\"center center\" layout-align-gt-sm=\"start center\"><md-button \nng-disabled=\"vm.isAddingCustomPromotion\" ng-click=\"vm.addCustomPromotion()\" \nclass=\"mb-5 btn btn-outline-success md-raised\">ADD</md-button></div></div></div></div></div><div class=\"card\" \nid=\"{{::vm.paymentsCollapseSectionID + vm.sectionTitleTag}}\"><div class=\"card-header\"><h2 class=\"mb-0\"><button \nclass=\"btn btn-link btn-block text-left px-0\" type=\"button\" data-toggle=\"collapse\" \ndata-target=\"{{::\'#\' + vm.paymentsCollapseSectionID}}\">Payment <span ng-if=\"saleInfoForm.paymentForm.$invalid\"><i \nclass=\"icon-alert-circle text-red\"></i></span></button></h2></div><div id=\"{{::vm.paymentsCollapseSectionID}}\" \nclass=\"collapse\" data-parent=\"#accordionExample\"><div class=\"card-body\"><sale-info-payment-form \nnew-payment=\"vm.newPayment\" new-payment-file-uploader=\"vm.newPaymentFileUploader\" on-add-payment=\"vm.addPayment\" \non-remove-payment=\"vm.removePayment\" is-processing-data=\"vm.isProcessingData\" vehicle-id=\"vm.vehicle.getResourceID()\" \nsale-info-id=\"vm.saleInfo.getResourceID()\" constants=\"vm.paymentFormConstants\" \ncurrent-payment-option=\"vm.saleInfo.fk_id_payment_option\" current-payments=\"vm.payments\" \ncustomer-id=\"vm.saleInfo.fk_id_customer\" void-credit-card-payment=\"vm.voidCreditCardPayment\" \nrefund-credit-card-payment=\"vm.refundCreditCardPayment\"></sale-info-payment-form></div></div></div><div class=\"card\" \nid=\"{{::vm.disclosuresCollapseSectionID + vm.sectionTitleTag}}\"><div class=\"card-header\" id=\"disclosuresSection\"><h2 \nclass=\"mb-0\"><button class=\"btn btn-link btn-block text-left px-0\" type=\"button\" data-toggle=\"collapse\" \ndata-target=\"{{::\'#\' + vm.disclosuresCollapseSectionID}}\">Disclosures</button></h2></div><div \nid=\"{{::vm.disclosuresCollapseSectionID}}\" class=\"collapse\" data-parent=\"#accordionExample\"><div class=\"card-body\">\n<purchase-disclosure-list disclosures=\"vm.disclosures\" on-disclosure-added=\"vm.onDisclosureAdded\" \non-disclosure-removed=\"vm.onDisclosureRemoved\" clean-new-disclouser=\"vm.cleanNewDisclouser\" \nis-processing-data=\"vm.isProcessingData\"></purchase-disclosure-list></div></div></div><div class=\"card\"><div \nclass=\"card-header\" id=\"filesSection\"><h2 class=\"mb-0\"><button class=\"btn btn-link btn-block text-left px-0\" \ntype=\"button\" data-toggle=\"collapse\" data-target=\"#collapseFilesSection\" aria-expanded=\"true\" \naria-controls=\"collapseFilesSection\">Files ({{vm.saleInfoFiles.length}})</button></h2></div><div \nid=\"collapseFilesSection\" class=\"collapse\" aria-labelledby=\"filesSection\" data-parent=\"#accordionExample\"><div \nclass=\"card-body\"><file-section-preview is-processing-data=\"vm.isProcessingData\" \non-file-delete=\"vm.deleteSaleInfoFile\" file-uploader=\"vm.saleInfofileUploader\" file-list=\"vm.saleInfoFiles\">\n</file-section-preview></div></div></div></form><md-button class=\"btn btn-secondary mx-0\" ng-click=\"vm.saveChanges()\" \nng-disabled=\"vm.isProcessingData\">save</md-button></div><div flex=\"100\" flex-gt-sm=\"30\" class=\"content-padding-x-half\">\n<div class=\"sticky content-padding-y-full\"><sale-summary vehicle=\"vm.vehicle\" sale-info=\"vm.saleInfo\" \nwarranty=\"vm.saleWarranty\" sale-extras=\"vm.saleExtras\" sale-packages=\"vm.salePackages\" plate-options=\"vm.plateOptions\" \ntrade-in-vehicle=\"vm.tradeInVehicle\" promotions=\"vm.promotions\" payments=\"vm.payments\" \non-anchor-clicked=\"vm.onAnchorClicked\" ignore-options=\"vm.ignoreOptions\"></sale-summary><div layout=\"row\"><md-button \nflex class=\"btn btn-secondary mx-0\" ng-click=\"vm.printBillOfSale()\">Print</md-button></div><sale-info-signature-list \nsignatures=\"vm.signatures\" sale-info=\"vm.saleInfo\" vehicle=\"vm.vehicle\" ignore-options=\"vm.ignoreOptions\">\n</sale-info-signature-list></div></div></div></div>");
$templateCache.put("app/main/safety/create-safety.html","<div class=\"page-layout carded fullwidth single-scroll\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"column\"><div layout=\"row\"><span class=\"h2 white-fg\">\nCreate safety</span></div><h6><a class=\"badge badge-primary\" href=\"{{::vm.vehiclePageUrl}}\">\n{{::vm.vehicle.getYearMakeModel()}}</a></h6></div><div class=\"content-card page-content-container\" layout=\"column\" \nflex><md-content class=\"content\" flex ms-scroll><div layout=\"column\" layout-gt-sm=\"row\" class=\"mb-5\" layout-margin><div\n flex-gt-sm=\"45\" class=\"simple-border p-2\"><div class=\"mb-2\">Front Left</div><safety-conner-info-form \nrotor-thickness=\"vm.safety.front_left_rotor_thickness\" pad-thickness-inner=\"vm.safety.front_left_pad_thickness_inner\" \npad-thickness-outer=\"vm.safety.front_left_pad_thickness_outer\" \nshoe-lining-thickness=\"vm.safety.front_left_shoe_lining_thickness\" drum-diameter=\"vm.safety.front_left_drum_diameter\" \ntread-depth=\"vm.safety.front_left_tread_depth\" inflation-pressure=\"vm.safety.front_left_inflation_pressure\" \ncorrected-larger-than-5-psi=\"vm.safety.front_left_pressure_initial_reading\" \nfinal-reading=\"vm.safety.front_left_pressure_final_reading\" is-form-valid=\"vm.frontLeftConnerInfoFormValid\">\n</safety-conner-info-form></div><div flex-gt-sm=\"45\" class=\"simple-border p-2\"><div class=\"mb-2\">Front Right</div>\n<safety-conner-info-form rotor-thickness=\"vm.safety.front_right_rotor_thickness\" \npad-thickness-inner=\"vm.safety.front_right_pad_thickness_inner\" \npad-thickness-outer=\"vm.safety.front_right_pad_thickness_outer\" \nshoe-lining-thickness=\"vm.safety.front_right_shoe_lining_thickness\" \ndrum-diameter=\"vm.safety.front_right_drum_diameter\" tread-depth=\"vm.safety.front_right_tread_depth\" \ninflation-pressure=\"vm.safety.front_right_inflation_pressure\" \ncorrected-larger-than-5-psi=\"vm.safety.front_right_pressure_initial_reading\" \nfinal-reading=\"vm.safety.front_right_pressure_final_reading\" is-form-valid=\"vm.frontRightConnerInfoFormValid\">\n</safety-conner-info-form></div></div><div layout=\"column\" layout-gt-sm=\"row\" class=\"mb-5\" layout-margin><div \nflex-gt-sm=\"45\" class=\"simple-border p-2\"><div class=\"mb-2\">Rear Left</div><safety-conner-info-form \nrotor-thickness=\"vm.safety.rear_left_rotor_thickness\" pad-thickness-inner=\"vm.safety.rear_left_pad_thickness_inner\" \npad-thickness-outer=\"vm.safety.rear_left_pad_thickness_outer\" \nshoe-lining-thickness=\"vm.safety.rear_left_shoe_lining_thickness\" drum-diameter=\"vm.safety.rear_left_drum_diameter\" \ntread-depth=\"vm.safety.rear_left_tread_depth\" inflation-pressure=\"vm.safety.rear_left_inflation_pressure\" \ncorrected-larger-than-5-psi=\"vm.safety.rear_left_pressure_initial_reading\" \nfinal-reading=\"vm.safety.rear_left_pressure_final_reading\" is-form-valid=\"vm.rearLeftConnerInfoFormValid\">\n</safety-conner-info-form></div><div flex-gt-sm=\"45\" class=\"simple-border p-2\"><div class=\"mb-2\">Rear Right</div>\n<safety-conner-info-form rotor-thickness=\"vm.safety.rear_right_rotor_thickness\" \npad-thickness-inner=\"vm.safety.rear_right_pad_thickness_inner\" \npad-thickness-outer=\"vm.safety.rear_right_pad_thickness_outer\" \nshoe-lining-thickness=\"vm.safety.rear_right_shoe_lining_thickness\" drum-diameter=\"vm.safety.rear_right_drum_diameter\" \ntread-depth=\"vm.safety.rear_right_tread_depth\" inflation-pressure=\"vm.safety.rear_right_inflation_pressure\" \ncorrected-larger-than-5-psi=\"vm.safety.rear_right_pressure_initial_reading\" \nfinal-reading=\"vm.safety.rear_right_pressure_final_reading\" is-form-valid=\"vm.rearRightConnerInfoFormValid\">\n</safety-conner-info-form></div></div><div layout=\"row\" layout-wrap layout-margin><safety-images-list \nng-repeat=\"tag in vm.imageTags\" flex=\"100\" flex-gt-sm=\"45\" tag=\"tag\" images=\"[]\" image-uploader=\"vm.imageUploader\" \non-delete-clicked=\"vm.removeImage\"></safety-images-list></div><div layout=\"row\"><safety-general-info-form \nflex-gt-sm=\"45\" flex=\"100\" default-inspector-id=\"vm.myUserID\" safety=\"vm.safety\" is-form-valid=\"vm.isGeneralFormValid\">\n</safety-general-info-form></div><div layout=\"row\"><md-button class=\"mx-0 btn-secondary\" ng-click=\"vm.save()\" \nng-disabled=\"vm.isProcessingData\">save</md-button></div></md-content></div></div></div>");
$templateCache.put("app/main/safety/edit-safety.html","<div class=\"page-layout carded fullwidth single-scroll\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"column\"><div layout=\"row\" \nlayout-algin=\"space-between center\"><div flex layout=\"row\" layout-algin=\"start center\"><span class=\"h2 white-fg\">\nEdit safety</span><md-button class=\"btn btn-primary\" ng-click=\"vm.printSafetyReport()\" \nng-disabled=\"vm.isProcessingData\">print</md-button></div><md-button flex=\"nogrow\" class=\"md-icon-button mx-0\" \nng-click=\"vm.deleteSafety()\" ng-disabled=\"vm.isProcessingData\"><md-icon class=\"icon-delete-forever text-red\"></md-icon>\n</md-button></div><h6><a class=\"badge badge-primary\" href=\"{{::vm.vehiclePageUrl}}\">{{::vm.vehicle.getYearMakeModel()}}\n</a></h6></div><div class=\"content-card page-content-container\" layout=\"column\" flex><md-content class=\"content\" flex \nms-scroll><div layout=\"column\" layout-gt-sm=\"row\" class=\"mb-5\" layout-margin><div flex-gt-sm=\"45\" \nclass=\"simple-border p-2\"><div class=\"mb-2\">Front Left</div><safety-conner-info-form \nrotor-thickness=\"vm.safety.front_left_rotor_thickness\" pad-thickness-inner=\"vm.safety.front_left_pad_thickness_inner\" \npad-thickness-outer=\"vm.safety.front_left_pad_thickness_outer\" \nshoe-lining-thickness=\"vm.safety.front_left_shoe_lining_thickness\" drum-diameter=\"vm.safety.front_left_drum_diameter\" \ntread-depth=\"vm.safety.front_left_tread_depth\" inflation-pressure=\"vm.safety.front_left_inflation_pressure\" \ncorrected-larger-than-5-psi=\"vm.safety.front_left_pressure_initial_reading\" \nfinal-reading=\"vm.safety.front_left_pressure_final_reading\" is-form-valid=\"vm.frontLeftConnerInfoFormValid\">\n</safety-conner-info-form></div><div flex-gt-sm=\"45\" class=\"simple-border p-2\"><div class=\"mb-2\">Front Right</div>\n<safety-conner-info-form rotor-thickness=\"vm.safety.front_right_rotor_thickness\" \npad-thickness-inner=\"vm.safety.front_right_pad_thickness_inner\" \npad-thickness-outer=\"vm.safety.front_right_pad_thickness_outer\" \nshoe-lining-thickness=\"vm.safety.front_right_shoe_lining_thickness\" \ndrum-diameter=\"vm.safety.front_right_drum_diameter\" tread-depth=\"vm.safety.front_right_tread_depth\" \ninflation-pressure=\"vm.safety.front_right_inflation_pressure\" \ncorrected-larger-than-5-psi=\"vm.safety.front_right_pressure_initial_reading\" \nfinal-reading=\"vm.safety.front_right_pressure_final_reading\" is-form-valid=\"vm.frontRightConnerInfoFormValid\">\n</safety-conner-info-form></div></div><div layout=\"column\" layout-gt-sm=\"row\" class=\"mb-5\" layout-margin><div \nflex-gt-sm=\"45\" class=\"simple-border p-2\"><div class=\"mb-2\">Rear Left</div><safety-conner-info-form \nrotor-thickness=\"vm.safety.rear_left_rotor_thickness\" pad-thickness-inner=\"vm.safety.rear_left_pad_thickness_inner\" \npad-thickness-outer=\"vm.safety.rear_left_pad_thickness_outer\" \nshoe-lining-thickness=\"vm.safety.rear_left_shoe_lining_thickness\" drum-diameter=\"vm.safety.rear_left_drum_diameter\" \ntread-depth=\"vm.safety.rear_left_tread_depth\" inflation-pressure=\"vm.safety.rear_left_inflation_pressure\" \ncorrected-larger-than-5-psi=\"vm.safety.rear_left_pressure_initial_reading\" \nfinal-reading=\"vm.safety.rear_left_pressure_final_reading\" is-form-valid=\"vm.rearLeftConnerInfoFormValid\">\n</safety-conner-info-form></div><div flex-gt-sm=\"45\" class=\"simple-border p-2\"><div class=\"mb-2\">Rear Right</div>\n<safety-conner-info-form rotor-thickness=\"vm.safety.rear_right_rotor_thickness\" \npad-thickness-inner=\"vm.safety.rear_right_pad_thickness_inner\" \npad-thickness-outer=\"vm.safety.rear_right_pad_thickness_outer\" \nshoe-lining-thickness=\"vm.safety.rear_right_shoe_lining_thickness\" drum-diameter=\"vm.safety.rear_right_drum_diameter\" \ntread-depth=\"vm.safety.rear_right_tread_depth\" inflation-pressure=\"vm.safety.rear_right_inflation_pressure\" \ncorrected-larger-than-5-psi=\"vm.safety.rear_right_pressure_initial_reading\" \nfinal-reading=\"vm.safety.rear_right_pressure_final_reading\" is-form-valid=\"vm.rearRightConnerInfoFormValid\">\n</safety-conner-info-form></div></div><div layout=\"row\" layout-wrap layout-margin><safety-images-list \nng-repeat=\"item in vm.imageList\" flex=\"100\" flex-gt-sm=\"45\" tag=\"item.tag\" images=\"item.images\" \nimage-uploader=\"vm.imageUploader\" on-delete-clicked=\"vm.deleteImage\"></safety-images-list></div><div layout=\"row\" \nlayout-margin><safety-general-info-form flex-gt-sm=\"45\" flex=\"100\" safety=\"vm.safety\" \nis-form-valid=\"vm.isGeneralFormValid\"></safety-general-info-form></div><div layout=\"row\" layout-margin><md-button \nclass=\"btn-secondary\" ng-click=\"vm.save()\" ng-disabled=\"vm.isProcessingData\">save</md-button></div></md-content></div>\n</div></div>");
$templateCache.put("app/main/sample/sample.html","<h1>{{vm.helloText}}</h1>");
$templateCache.put("app/main/tasks/task-info-form.html","<form layout=\"column\" name=\"taskInfoForm\"><div ng-if=\"vm.task.created_by\" class=\"mb-10\">\nCreated by: {{::vm.task.created_by.first_name}} {{::vm.task.created_by.last_name}} -- {{::vm.task.getCreatedDateMomentObj().format(\'LLLL\')}}\n</div><div layout=\"row\"><md-input-container flex-gt-sm=\"25\" flex=\"100\" \nclass=\"input-box small-input-box task-info-form-item\"><input ng-required=\"true\" name=\"taskName\" \nng-model=\"vm.task.name\" autocomplete=\"off\" placeholder=\"Task Name\" maxlength=\"100\"><div \nng-messages=\"taskInfoForm.taskName.$error\"><div ng-message=\"maxlength\">Input content can not be over 50 charactors\n</div><div ng-message=\"required\">This field is required</div></div></md-input-container></div><div layout=\"row\">\n<md-input-container flex-gt-sm=\"25\" flex=\"100\" class=\"input-box small-input-box task-info-form-item\"><input \nname=\"taskCost\" ng-model=\"vm.task.cost\" autocomplete=\"off\" placeholder=\"Task Cost\" maxlength=\"10\" input-control \ninput-translate=\"vm.translateToDollar\"></md-input-container></div><div layout=\"row\" \nclass=\"task-info-form-selector-block\"><div flex=\"33\"><div class=\"task-info-form-selector-title\">Status</div><md-select \nclass=\"md-no-underline small-selector task-info-form-item task-info-form-selector\" \nng-model=\"vm.task.fk_id_task_status\" placeholder=\"Status\"><md-option ng-repeat=\"status in vm.constants.taskStatus \" \nvalue=\"{{status.id_task_status}}\">{{status.name}}</md-option></md-select></div><div flex=\"33\"><div \nclass=\"task-info-form-selector-title\">Priority</div><md-select \nclass=\"md-no-underline small-selector task-info-form-item task-info-form-selector\" \nng-model=\"vm.task.fk_id_task_priority\" placeholder=\"Priority\"><md-option \nng-repeat=\"priority in vm.constants.taskPriorities | orderBy: priority.id_task_priority :true \" \nvalue=\"{{priority.id_task_priority}}\">{{priority.value}}-{{priority.name}}</md-option></md-select></div><div flex=\"33\">\n<div class=\"task-info-form-selector-title\">Category</div><md-select \nclass=\"md-no-underline small-selector task-info-form-item task-info-form-selector\" \nng-model=\"vm.task.fk_id_task_category\" placeholder=\"Category\"><md-option \nng-repeat=\"category in vm.constants.taskCategories | orderBy:\'name\'\" value=\"{{category.id_task_category}}\">\n{{category.name}}</md-option></md-select></div></div><div layout=\"row\" class=\"mt-5\"><div layout=\"row\" \nclass=\"task-info-form-datetime-picker\" style=\"width: 500px\" layout-align=\"space-between center\"><md-input-container \nclass=\"small-input-box mr-5 mb-0\"><label>Due Date:</label><md-datepicker md-hide-icons=\"calendar\" \nng-model=\"vm.datePickerValue\" md-placeholder=\"MM/DD/YYYY\" ng-change=\"vm.setDueDate(vm.datePickerValue)\" name=\"dueDate\">\n</md-datepicker><div ng-messages=\"taskInfoForm.dueDate.$error\"><div ng-message=\"valid\">\nDate format should be MM/DD/YYYY.</div></div></md-input-container><div moment-picker=\"vm.timePickerValue\" \nformat=\"{{vm.timePickerFormat}}\" show-header=\"false\" set-on-select=\"true\" max-view=\"minute\" min-view=\"day\" \nchange=\"vm.setDueTime(vm.timePickerValue)\"><md-input-container class=\"input-box small-input-box mb-0\"><label>Due Time:\n</label><input name=\"dueTime\" placeholder=\"HH:mm\" ng-model=\"vm.timePickerValue\" \nng-model-options=\"{ updateOn: \'blur\' }\" ng-change=\"vm.setDueTime(vm.timePickerValue)\"></md-input-container></div></div>\n</div><div ng-messages=\"vm.dateTimeValidator\" ng-messages-multiple><div ng-message=\"inValidDueDate\" class=\"text-red\" \nstyle=\"font-size: 13px\">Due date is invalid.</div><div ng-message=\"inValidDueTime\" class=\"text-red\" \nstyle=\"font-size: 13px\">Due time is invalid.</div><div ng-message=\"inValidDueDateMissing\" class=\"text-red\" \nstyle=\"font-size: 13px\">Please select a date.</div></div><textarea flex flex-gt-sm=\"55\" rows=\"3\" \nng-model=\"vm.task.comments\" style=\"max-width: 500px\" class=\"info-form-item my-5 detail-info-form-note-input\" \nplaceholder=\"Comments:\"></textarea><md-divider></md-divider><div layout=\"column\" layout-gt-sm=\"row\"><div \nclass=\"task-info-autocoplete-selector\" flex=\"grow\" style=\"max-width: 500px\"><md-autocomplete autocomplete=\"off\" \nplaceholder=\"Search User to assign task to\" md-no-cache=\"true\" md-delay=\"700\" \nmd-selected-item-change=\"vm.onUserSelected(user)\" md-search-text=\"vm.searchTextForUser\" \nmd-items=\"user in vm.queryUsers(vm.searchTextForUser)\" md-menu-class=\"task-info-autocoplete-selector-dropdown-menu\" \nmd-menu-container-class=\"task-info-autocoplete-selector-dropdown-menu-container\" md-autoselect=\"true\">\n<md-item-template><div layout=\"row\" layout-align=\"start center\"><img \nng-src=\"{{user.profileimage == null || user.profileimage[0] == null || user.profileimage[0].url == null ? \'assets/images/default-user-profile-photo.png\':user.profileimage[0].url}} \" \nclass=\"task-info-autocoplete-selector-dropdown-menu-image\"><div flex><p \nclass=\"task-info-autocoplete-selector-dropdown-menu-detail\"><span class=\"text-nowrap text-truncate\">\n{{user.first_name}} {{user.last_name}}</span></p></div></div></md-item-template><md-not-found>\nNo matches found, please be more specific.</md-not-found></md-autocomplete><div \nclass=\"task-info-autocoplete-selector-selected-list\"><div ng-repeat=\"assignedUser in vm.task.assigned_to_users\" \nclass=\"task-info-autocoplete-selector-selected-list-item animate-fade-in-out\"><div layout=\"row\" \nlayout-align=\"start center\"><div flex><p class=\"task-info-autocoplete-selector-dropdown-menu-detail\"><span \nclass=\"text-nowrap text-truncate\"><a ng-href=\"{{vm.getUrlForDetailPage(assignedUser.id_user)}}\">\n{{assignedUser.first_name}} {{assignedUser.last_name}}</a></span></p></div><div flex=\"nogrow\"><md-button \nclass=\"md-icon-button\" flex=\"none\"><md-icon class=\"icon-minus-circle text-red\" \nng-click=\"vm.removeAssignUser(assignedUser.id_user)\"></md-icon></md-button></div></div></div></div></div><div \nshow-gt-sm style=\"width: 20px\"></div><div class=\"task-info-autocoplete-selector\" flex=\"grow\" style=\"max-width: 500px\">\n<md-autocomplete autocomplete=\"off\" placeholder=\"Search vehicle to assign task to\" md-no-cache=\"true\" md-delay=\"700\" \nmd-selected-item-change=\"vm.onVehicleSelected(vehicle)\" md-search-text=\"vm.searchTextForVehicle\" \nmd-items=\"vehicle in vm.queryVehicles(vm.searchTextForVehicle)\" \nmd-menu-class=\"task-info-autocoplete-selector-dropdown-menu\" \nmd-menu-container-class=\"task-info-autocoplete-selector-dropdown-menu-container\" md-autoselect=\"true\">\n<md-item-template><div layout=\"row\" layout-align=\"start center\"><img \nng-src=\"{{vehicle.landingImage == null || vehicle.landingImage.trim() == \'\' ? \'assets/images/placeholder-vans.png\':vehicle.landingImage}} \" \nclass=\"task-info-autocoplete-selector-dropdown-menu-image\"><div flex><p \nclass=\"task-info-autocoplete-selector-dropdown-menu-detail\"><span class=\"text-nowrap text-truncate\">\n{{vehicle.year}} {{vehicle.make}} {{vehicle.model}}</span></p><p \nclass=\"task-info-autocoplete-selector-dropdown-menu-detail\"><span class=\"text-nowrap text-truncate text-secondary\">\nVIN: {{vehicle.vin}}</span></p></div></div></md-item-template><md-not-found>No matches found, please be more specific.\n</md-not-found></md-autocomplete><div class=\"task-info-autocoplete-selector-selected-list\"><div layout=\"row\" \nlayout-align=\"start center\" ng-if=\"vm.task.assigned_to_vehicle != null\" \nclass=\"task-info-autocoplete-selector-selected-list-item animate-fade-in-out\"><div flex><p \nclass=\"task-info-autocoplete-selector-dropdown-menu-detail\"><span class=\"text-nowrap text-truncate\"><a \nng-href=\"{{vm.getUrlForVehiclePage(vm.task.assigned_to_vehicle)}}\">{{vm.getAssignedVehicleName(vm.task)}}</a></span>\n</p><p class=\"task-info-autocoplete-selector-dropdown-menu-detail\"><span class=\"text-nowrap text-truncate\">\nVIN: {{vm.task.assigned_to_vehicle.vin}}</span></p></div><div flex=\"nogrow\"><md-button class=\"md-icon-button\" \nflex=\"none\"><md-icon class=\"icon-minus-circle text-red\" ng-click=\"vm.removeAssignVehicle()\"></md-icon></md-button>\n</div></div></div></div></div></form>");
$templateCache.put("app/main/user-config/custom-filter-list.html","<md-divider></md-divider><div class=\"py-2\"><div ng-repeat=\"filter in vm.filters track by $index\"><div layout=\"row\" \nlayout-align=\"space-between center\"><a href=\"\" ng-click=\"vm.onApply(filter)\">{{filter.name}}</a> <button \nng-disabled=\"vm.isLoading\" ng-click=\"vm.onDelete($index)\"><i class=\"icon-delete-forever m-0 p-0\" \nng-class=\"vm.isLoading? [\'text-grey\']:[\'text-red\']\"></i></button></div></div><div ng-if=\"vm.filters.length <= 0\">\nYou have no custom filter.</div></div><md-divider></md-divider><div layout=\"row\" layout-align=\"space-between center\" \nclass=\"mt-2\"><md-input-container flex=\"70\" \nclass=\"input-box info-form-item small-input-box purchase-step-payment-input-box\"><input type=\"text\" autocorrect=\"off\" \nautocapitalize=\"none\" spellcheck=\"false\" ng-model=\"vm.currentFilterName\" autocomplete=\"off\" placeholder=\"Filter Name\">\n</md-input-container><md-button class=\"btn-sm btn-secondary mx-0\" ng-click=\"vm.saveFilter(vm.currentFilterName)\" \nng-disabled=\"vm.isLoading\">save</md-button></div>");
$templateCache.put("app/core/directives/ms-material-color-picker/ms-material-color-picker.html","<md-menu md-position-mode=\"target-right target\"><div ng-click=\"$mdOpenMenu($event)\"><ms-color-picker-button><md-button \naria-label=\"Row Color\" md-menu-origin ng-click=\"$mdOpenMenu($event)\" ng-class=\"vm.selectedColor.class\"><span \nng-show=\"vm.selectedColor.palette\">{{vm.selectedColor.palette}} {{vm.selectedColor.hue}} </span><span \nng-show=\"!vm.selectedColor.palette\">Select Color</span></md-button></ms-color-picker-button></div><md-menu-content \nclass=\"ms-material-color-picker-menu-content\" layout-column><header \nng-class=\"vm.selectedColor.class || \'md-accent-bg\'\" class=\"md-whiteframe-4dp\" layout=\"row\" \nlayout-align=\"space-between center\"><md-button md-prevent-menu-close ng-click=\"vm.activateHueSelection(false,false)\" \nclass=\"md-icon-button\" ng-class=\"{\'hidden\':!vm.selectedPalette}\" aria-label=\"Palette\"><md-icon \nmd-font-icon=\"icon-arrow-left\" class=\"s20\"></md-icon></md-button><span ng-if=\"vm.selectedColor.palette\">\n{{vm.selectedColor.palette}} {{vm.selectedColor.hue}} </span><span ng-if=\"!vm.selectedColor.palette\">Select Color\n</span><md-button class=\"remove-color-button md-icon-button\" ng-click=\"vm.removeColor()\" aria-label=\"Remove Color\">\n<md-icon md-font-icon=\"icon-delete\" class=\"s20\"></md-icon></md-button></header><div class=\"colors\" ms-scroll><div \nng-show=\"!vm.selectedPalette\" layout=\"row\" layout-wrap><div class=\"color\" ng-class=\"\'md-\'+palette+\'-500-bg\'\" \nng-repeat=\"(palette, hues) in vm.palettes\" ng-click=\"vm.activateHueSelection(palette,hues)\" layout=\"row\" \nlayout-align=\"start end\" md-prevent-menu-close md-ink-ripple><span class=\"label\">{{palette}}</span></div></div><div \nng-show=\"vm.selectedPalette\" layout=\"row\" layout-wrap><div class=\"color\" \nng-class=\"\'md-\'+vm.selectedPalette+\'-\'+hue+\'-bg\'\" ng-repeat=\"(hue, values) in vm.selectedHues\" \nng-click=\"vm.selectColor(vm.selectedPalette,hue)\" layout=\"row\" layout-align=\"start end\" md-ink-ripple><span \nclass=\"label\">{{hue}} </span><i ng-if=\"vm.selectedPalette == vm.selectedColor.palette && hue == vm.selectedColor.hue\" \nclass=\"s16 icon-check\"></i></div></div></div></md-menu-content></md-menu>");
$templateCache.put("app/core/directives/ms-search-bar/ms-search-bar.html","<div flex layout=\"row\" layout-align=\"start center\"><label for=\"ms-search-bar-input\"><md-button \nclass=\"ms-search-bar-expander md-icon-button\" aria-label=\"Expand Search Bar\" ng-click=\"MsSearchBar.expand()\" \nng-if=\"!MsSearchBar.resultsLoading || MsSearchBar.collapsed\"><md-icon md-font-icon=\"icon-magnify\" class=\"icon s24\">\n</md-icon></md-button><div class=\"ms-search-bar-loader\" layout=\"row\" layout-align=\"center center\" \nng-if=\"MsSearchBar.resultsLoading && !MsSearchBar.collapsed\"><md-progress-circular class=\"md-accent\" md-diameter=\"32\" \nmd-mode=\"indeterminate\"></md-progress-circular></div></label><input id=\"ms-search-bar-input\" type=\"text\" \nplaceholder=\"Search\" flex ng-model=\"MsSearchBar.query\" ng-model-options=\"MsSearchBar.queryOptions\" \nng-blur=\"MsSearchBar.collapse()\" ng-keydown=\"MsSearchBar.handleKeydown($event)\"><md-button \nclass=\"ms-search-bar-collapser md-icon-button\" ng-click=\"MsSearchBar.collapse()\" aria-label=\"Collapse Search Bar\">\n<md-icon md-font-icon=\"icon-close\" class=\"icon s24\"></md-icon></md-button><div class=\"ms-search-bar-results\" \nng-if=\"MsSearchBar.results\" ms-scroll><div class=\"no-results\" ng-if=\"MsSearchBar.results.length === 0\">No Results!\n</div><div class=\"result\" ng-repeat=\"result in MsSearchBar.results\" ng-click=\"MsSearchBar.handleResultClick(result)\" \nng-mouseenter=\"MsSearchBar.handleMouseenter($index)\" ng-mousedown=\"MsSearchBar.absorbEvent($event)\" \nng-class=\"{\'selected\': $index == MsSearchBar.selectedResultIndex}\" md-ink-ripple><div layout=\"row\" \nlayout-align=\"start center\"><div class=\"icon-container\" layout=\"row\" layout-align=\"center center\"><i \nng-if=\"result.icon\" class=\"icon {{result.icon}}\"></i><div ng-if=\"!result.icon\" class=\"square md-accent-bg\"></div></div>\n<div><div class=\"title\">{{result.title}}</div><div class=\"description\" ng-if=\"result.description\">\n{{result.description}}</div></div></div></div></div></div>");
$templateCache.put("app/core/directives/ms-shortcuts/ms-shortcuts.html","<div class=\"shortcuts-container\" layout=\"row\" layout-align=\"space-between center\" flex \nng-class=\"{\'mobile-bar-active\': MsShortcuts.mobileBarActive}\"><div layout=\"row\" layout-align=\"start center\" flex><div \nclass=\"shortcuts hide show-gt-xs\" layout=\"row\" layout-align=\"start center\" ms-scroll \nng-if=\"MsShortcuts.shortcuts.length > 0\" ng-sortable=\"MsShortcuts.sortableOptions\"><div \nng-repeat=\"shortcut in MsShortcuts.shortcuts\" layout=\"row\" layout-align=\"center center\"><md-button \nclass=\"md-icon-button shortcut\" aria-label=\"{{shortcut.title}}\" ui-sref=\"{{shortcut.uisref}}\"><md-icon \nng-if=\"shortcut.icon\" md-font-icon=\"{{shortcut.icon}}\" class=\"icon s24\"></md-icon><div ng-if=\"!shortcut.icon\" \nclass=\"first-letter\">{{shortcut.title.charAt(0)}}</div><md-tooltip md-direction=\"bottom\">{{shortcut.title}}\n</md-tooltip></md-button></div></div><md-menu md-offset=\"8 56\" class=\"shortcut-menu hide show-gt-xs\"><md-button \nclass=\"md-icon-button add-shortcut-button\" aria-label=\"Add shortcut\" ng-click=\"$mdOpenMenu($event)\"><md-icon \nmd-menu-origin md-font-icon=\"icon-star\" class=\"icon amber-600-fg s24\"></md-icon><md-tooltip md-direction=\"bottom\">\nClick to add/remove shortcut</md-tooltip></md-button><md-menu-content><div id=\"ms-shortcut-add-menu\"><div \nclass=\"shortcut-search\" layout=\"row\" layout-align=\"start center\"><div class=\"search-icon\" layout=\"row\" \nlayout-align=\"center center\" ng-if=\"!MsShortcuts.resultsLoading\"><md-icon md-menu-align-target \nmd-font-icon=\"icon-magnify\" class=\"icon s24\"></md-icon></div><div class=\"shortcut-loader\" layout=\"row\" \nlayout-align=\"center center\" ng-if=\"MsShortcuts.resultsLoading\"><md-progress-circular class=\"md-accent\" \nmd-diameter=\"20\" md-mode=\"indeterminate\"></md-progress-circular></div><input type=\"text\" placeholder=\"Search\" flex \nng-model=\"MsShortcuts.query\" ng-model-options=\"MsShortcuts.queryOptions\" \nng-keydown=\"MsShortcuts.handleKeydown($event)\"></div><div class=\"results\" ng-if=\"MsShortcuts.results\" ms-scroll><div \nclass=\"no-results\" ng-if=\"MsShortcuts.results.length === 0\">No Results!</div><div class=\"result\" \nng-repeat=\"result in MsShortcuts.results\" ng-click=\"MsShortcuts.handleResultClick(result)\" \nng-mouseenter=\"MsShortcuts.handleMouseenter($index)\" ng-mousedown=\"MsShortcuts.absorbEvent($event)\" \nng-class=\"{\'selected\': $index == MsShortcuts.selectedResultIndex}\" md-prevent-menu-close=\"md-prevent-menu-close\" \nmd-ink-ripple><div layout=\"row\" layout-align=\"start space-between\"><div layout=\"row\" layout-align=\"start center\" flex>\n<div class=\"icon icon-container\" layout=\"row\" layout-align=\"center center\"><i ng-if=\"result.icon\" \nclass=\"{{result.icon}}\"></i><div ng-if=\"!result.icon\" class=\"square md-accent-bg\"></div></div><div><div class=\"title\">\n{{result.title}}</div></div></div><md-icon md-font-icon=\"icon-pin\" class=\"icon s18\" \nng-class=\"{\'fade-text\': !result.hasShortcut}\"></md-icon></div></div></div></div></md-menu-content></md-menu></div>\n<md-button class=\"md-icon-button toggle-mobile-menu hide-gt-xs\" aria-label=\"Add shortcut\" \nng-click=\"MsShortcuts.toggleMobileBar()\"><md-icon md-menu-origin md-font-icon=\"icon-star\" \nclass=\"icon amber-600-fg s24\" ng-hide=\"MsShortcuts.mobileBarActive\"></md-icon><md-icon md-menu-origin \nmd-font-icon=\"icon-close\" class=\"icon s24\" ng-hide=\"!MsShortcuts.mobileBarActive\"></md-icon></md-button></div>");
$templateCache.put("app/core/directives/ms-info-bar/ms-info-bar.html","<div id=\"ms-info-bar\" layout=\"row\" layout-align=\"start center\" flex><div id=\"ms-info-bar-message\" ng-transclude flex>\n</div><md-button id=\"ms-info-bar-close\" class=\"md-icon-button\" aria-label=\"Close\" ng-click=\"removeInfoBar()\"><md-icon \nmd-font-icon=\"icon-close s24\"></md-icon></md-button></div>");
$templateCache.put("app/main/customers/add-customer/add-customer.html","<div class=\"page-layout carded fullwidth single-scroll\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\" layout=\"column\" flex><div class=\"header\"><span class=\"h2 white-fg\">Create Customer</span></div><div \nclass=\"content-card page-content-container\" layout=\"column\" flex><md-content class=\"content\" flex ms-scroll>\n<customer-basic-info-form constants=\"vm.constants\" customer=\"vm.customer\" \nis-similar-customer-found=\"vm.isSimilarCustomerFound\" profile-image-src=\"vm.profileImageSrc\" \nlicense-image-src=\"vm.licenseImageSrc\" file-uploader=\"vm.imageUploader\" is-form-valid=\"vm.isBasicFormValid\">\n</customer-basic-info-form><md-divider class=\"form-divider-horizontal\"></md-divider><customer-detail-info-form \ncustomer=\"vm.customer\" is-form-valid=\"vm.isDetailFormValid\"></customer-detail-info-form><md-divider \nclass=\"form-divider-horizontal\"></md-divider><customer-file-uploader file-uploader=\"vm.fileUploader\" \nuploaded-files=\"vm.uploadedFiles\" on-delete-queue-file-click=\"vm.removeFileFromQueue\"></customer-file-uploader>\n<md-divider class=\"form-divider-horizontal\"></md-divider><test-drive-list on-option-selected=\"vm.addTestDriveVehicle\" \non-remove-click=\"vm.removeTestDriveVehicle\" on-detail-click=\"vm.goToTestDriveVehiclePage\" \ndisable-remove-button=\"vm.disableRemoveTestDriveButton\" test-drives=\"vm.testDrives\"></test-drive-list><div \nlayout=\"row\"><div layout=\"row\" flex flex-gt-sm=\"55\" layout-align=\"end center\"><md-button \nclass=\"btn-secondary mx-0 text-black\" ng-click=\"vm.createCustomer()\" ng-disabled=\"vm.processingCustomer\">create\n</md-button></div></div></md-content></div></div></div>");
$templateCache.put("app/main/customers/browse-customers/browse-customers.html","<div class=\"page-layout carded fullwidth single-scroll\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\" layout=\"column\" flex><div class=\"header\"><span class=\"h2 white-fg\">Browse Customers</span></div><div \nclass=\"content-card page-content-container\" layout=\"column\" flex><md-content class=\"content\" flex ms-scroll><div \nlayout=\"row\" layout-align=\"center center\"><customer-table flex class=\"customer-table\" \ncustomers-in-current-page=\"vm.customersInCurrentPage\" on-search-param-change=\"vm.updateUrl\"></customer-table></div>\n</md-content></div></div></div>");
$templateCache.put("app/main/customers/edit-customer/edit-customer.html","<div class=\"page-layout carded fullwidth single-scroll\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\" layout=\"column\" flex><div class=\"header\"><span class=\"h2 white-fg\">Edit Customer</span></div><div \nclass=\"content-card page-content-container\" layout=\"column\" flex><md-content class=\"content\" flex ms-scroll>\n<customer-basic-info-form is-similar-customer-found=\"vm.isSimilarCustomerFound\" constants=\"vm.constants\" \ncustomer=\"vm.customer\" file-uploader=\"vm.imageUploader\" is-form-valid=\"vm.isBasicFormValid\" \nprofile-image-src=\"vm.profileImageSrc\" profile-image-link=\"vm.profileImageLink\" blur-profile-img=\"vm.blurProfileImg\" , \nshow-profile-img-progress=\"vm.showProfileImgProgress\" , license-image-src=\"vm.licenseImageSrc\" \nlicense-image-link=\"vm.licenseImageLink\" blur-license-img=\"vm.blurLicenseImg\" , \nshow-license-img-progress=\"vm.showLicenseImgProgress\"></customer-basic-info-form><md-divider \nclass=\"form-divider-horizontal\"></md-divider><customer-detail-info-form customer=\"vm.customer\" \nis-form-valid=\"vm.isDetailFormValid\"></customer-detail-info-form><md-divider class=\"form-divider-horizontal\">\n</md-divider><customer-file-uploader file-uploader=\"vm.fileUploader\" uploaded-files=\"vm.uploadedFiles\" \non-delete-uploaded-file-click=\"vm.deleteUploadedFile\" on-delete-queue-file-click=\"vm.removeFileFromQueue\">\n</customer-file-uploader><md-divider class=\"form-divider-horizontal\"></md-divider><test-drive-list \non-option-selected=\"vm.addTestDriveVehicle\" on-remove-click=\"vm.removeTestDriveVehicle\" \non-detail-click=\"vm.goToTestDriveVehiclePage\" disable-remove-button=\"vm.isProcessingTestDrive\" \ntest-drives=\"vm.testDrives\"></test-drive-list><md-divider class=\"form-divider-horizontal\"></md-divider><div \nclass=\"mt-3 mb-1 font-weight-bold\">Purchased Vehicles:</div><customer-purchased-vehicles \ncustomer-id=\"vm.customer.id_customer\"></customer-purchased-vehicles><div layout=\"row\"><div layout=\"row\" flex \nflex-gt-sm=\"55\" layout-align=\"space-between center\"><md-button class=\"btn-danger mx-0 text-black\" \nng-click=\"vm.deleteCustomer()\" \nng-disabled=\"vm.isProcessingCustomer || vm.fileUploader.isUploading || vm.imageUploader.isUploading || vm.isProcessingTestDrive\">\ndelete</md-button><md-button class=\"btn-secondary mx-0 text-black\" ng-click=\"vm.updateCustomer()\" \nng-disabled=\"vm.isProcessingCustomer\">update</md-button></div></div></md-content></div></div></div>");
$templateCache.put("app/main/customers/view-customer/view-customer.html","<head><style>\n#item-vehicle-list {\r\n			display: none;\r\n		}\r\n\r\n		#item-outstanding-list {\r\n			display: none;\r\n		}\r\n\r\n		#item-drives-list {\r\n			display: none;\r\n		}\r\n\r\n		.tabcontent {\r\n			border-top: none;\r\n		}\r\n\r\n		.taba {\r\n			background-color: #2196f3;\r\n			border: 1px solid #ccc;\r\n			cursor: pointer;\r\n			padding: 10px;\r\n			width: 100%;\r\n		}\r\n\r\n		.taba.active {\r\n			background-color: #ddd;\r\n		}\r\n\r\n		.tabb {\r\n			background-color: #2196f3;\r\n			border: 1px solid #ccc;\r\n			cursor: pointer;\r\n			padding: 10px;\r\n			width: 100%;\r\n		}\r\n\r\n		.tabb.active {\r\n			background-color: #ddd;\r\n		}\r\n\r\n		.tabc {\r\n			background-color: #2196f3;\r\n			border: 1px solid #ccc;\r\n			cursor: pointer;\r\n			padding: 10px;\r\n			width: 100%;\r\n		}\r\n\r\n		.tabc.active {\r\n			background-color: #ddd;\r\n		}\n</style></head><div layout=\"row\" style=\"height: 100%\" layout-align=\"center start\"><div flex class=\"content-max-width\" \nlayout-padding><div class=\"sticky bg-default\"><div layout=\"row\" layout-align=\"space-between start\"><div layout=\"row\"><a\n ng-href=\"{{vm.profileImageLink}}\"><img ng-class=\"vm.isLoadingProfileImage? [\'opacity-50\']:[\'\']\" \nclass=\"basic-info-form-img card mr-3\" ng-src=\"{{vm.profileImageSrc}}\"> </a><a ng-href=\"{{vm.licenseImageLink}}\"><img \nstyle=\"object-fit: cover\" ng-class=\"vm.isLoadingLicenseImage? [\'opacity-50\']:[\'\']\" \nclass=\"basic-info-form-img card mr-3\" ng-src=\"{{vm.licenseImageSrc}}\"></a></div><a href=\"{{vm.editCustomerUrl}}\">Edit\n</a></div><h4>{{::vm.customer.getFullName()}}</h4><md-divider></md-divider></div><div layout=\"row\" \nlayout-align=\"space-between center\"><div><div layout=\"row\" layout-align=\"start start\" \nng-if=\"vm.customer.phone_numbers.length > 0\"><div class=\"view-customer-subtitle\">Phone</div><div><div layout=\"row\" \nlayout-align=\"start center\" ng-repeat=\"phone in vm.customer.phone_numbers\"><span class=\"view-customer-sub-subtitle\">\n{{::vm.getPhoneNumberCategory(phone.fk_id_phone_category)}}</span> <span>{{::vm.formatPhoneNumber(phone.phone_number)}}\n</span><goto-dial-button phone-number=\"phone.phone_number\" display-name=\"vm.customer.getFullName()\"></goto-dial-button>\n</div></div></div><div layout=\"row\" layout-align=\"start start\" ng-if=\"vm.customer.emails.length > 0\"><div \nclass=\"view-customer-subtitle\">Email</div><div><div layout=\"row\" layout-align=\"start center\" \nng-repeat=\"email in vm.customer.emails\"><span class=\"view-customer-sub-subtitle\">\n{{::vm.getEmailCategory(email.fk_id_email_category)}}</span> <span>{{::email.email_address}}</span></div></div></div>\n<div layout=\"row\" layout-align=\"start start\" ng-if=\"!!vm.getCustomerAddress()\"><div class=\"view-customer-subtitle\">\nAddress</div><span>{{::vm.getCustomerAddress()}}</span></div><div layout=\"row\" layout-align=\"start start\" \nng-if=\"!!vm.customer.birthday\"><div class=\"view-customer-subtitle\">Birthday</div><span>{{::vm.customer.birthday}}\n</span></div><div layout=\"row\" layout-align=\"start start\" ng-if=\"!!vm.customer.drivers_license\"><div \nclass=\"view-customer-subtitle\">License</div><span>{{::vm.customer.drivers_license}}</span> <span class=\"ml-3\" \nng-if=\"vm.customer.license_expiry_date\">Exp: {{::vm.customer.license_expiry_date}}</span></div><div layout=\"row\" \nlayout-align=\"start start\" ng-if=\"!!vm.customer.insurance_company\"><div class=\"view-customer-subtitle\">Insurance</div>\n<span>{{::vm.customer.insurance_company}}</span></div><div layout=\"row\" layout-align=\"start start\" \nng-if=\"!!vm.customer.policy_number\"><div class=\"view-customer-subtitle\">Policy #</div><span>\n{{::vm.customer.policy_number}}</span></div><div layout=\"row\" layout-align=\"start start\" ng-if=\"vm.customer.note\"><div \nflex=\"noshrink\" class=\"view-customer-subtitle\">Note</div><div flex=\"grow\" class=\"pre-wrap\">{{::vm.customer.note}}</div>\n</div><div layout=\"row\" layout-align=\"start start\" ng-if=\"vm.creditCards.length > 0\"><div \nclass=\"view-customer-subtitle\">Credit Card</div><div><div layout=\"row\" layout-align=\"start center\" \nng-repeat=\"card in vm.creditCards track by $index\"><span>{{card.cardType}} -- <span>{{card.cardNumber}}</span></span> \n<span class=\"margin-left-full\">-- {{card.expiryDate | date:\'MM/yy\'}}</span></div></div></div></div><a \nng-href=\"{{vm.addVehicleUrl}}\">Add New Vehicle</a></div><div class=\"content-card page-content-container\" \nlayout=\"column\" style=\"background-color: rgb(245,245,245) !important\" flex><md-content class=\"content\" flex ms-scroll \nstyle=\"background-color: rgb(245,245,245) !important\"><md-tabs md-dynamic-height md-border-bottom \nstyle=\"background-color: rgb(245,245,245) !important\"><md-tab label=\"Vehicles\" layout=\"row\" \nmd-active=\"vm.currentTab == vm.tabs.Vehicles\" ng-click=\"openTab(\'list1\')\"><div layout-padding layout=\"row\" layout-wrap \nlayout-align=\"start center\" id=\"list1\" class=\"tabcontent\"><div ng-repeat=\"vehicleID in vm.vehicleOrderList\" flex=\"100\" \nflex-gt-sm=\"33\"><div class=\"card my-3\"><a style=\"text-decoration:none\"><div layout=\"row\" \nlayout-align=\"space-around center\"><div><a ng-href=\"{{vm.getVehiclePageUrl(vehicleID)}}\"><i><img flex=\"noshrink\" \nclass=\"view-customer-vehicle-card-img\" \nng-src=\"{{vm.vehicles[vehicleID].vehicleData.landingImage ? vm.vehicles[vehicleID].vehicleData.landingImage:  vm.vehicleImgPlaceholder}}\">\n</i></a></div><div class=\"ml-2 text-black\" flex=\"grow\" layout=\"column\"><div layout=\"row\"><a \nng-href=\"{{vm.getVehiclePageUrl(vehicleID)}}\" class=\"ml-2 text-black\">\n{{vm.vehicles[vehicleID].vehicleData.getYearMakeModel()}}</a><div><i \nng-click=\"vm.showPendingItems[vehicleID] = !vm.showPendingItems[vehicleID]\" \nng-class=\"vm.showPendingItems[vehicleID]? [\'icon-chevron-up\']:[\'icon-chevron-down\']\"></i></div></div><div layout=\"row\" \nclass=\"ml-2 text-grey\" ng-if=\"vm.showPendingItems[vehicleID]\" ng-repeat=\"invoice in vm.workOder[vehicleID]\"><div \nng-if=\"invoice.payments.length > 0\"><div ng-repeat=\"payment in invoice.payments\"><div \nng-if=\"payment.paymentStatus == \'PENDING\'\"><a ng-href=\"{{vm.getWorkOrderUrl(invoice)}}\">\n{{invoice.workOrder.invoice_number}} </a>PENDING: ${{payment.amount}}</div></div></div></div></div></div></a></div>\n</div></div></md-tab><md-tab label=\"Appointments\" layout=\"row\" md-active=\"vm.currentTab == vm.tabs.Appointments\" \nng-click=\"openTab(\'list4\')\"><div class=\"content-padding-half\" id=\"list4\" class=\"tabcontent\"><custom-appointment-list \ndisable-editing=\"vm.isUpdatingAppointment || vm.isDeletingAppointment\" appointment-status=\"vm.appointmentStatus\" \nselected-map=\"vm.selectedMap\" on-status-changed=\"vm.updateAppointmentStatus\" appointments=\"vm.customAppointment\">\n</custom-appointment-list><div class=\"mt-2 px-1\" layout=\"row\" layout-align=\"space-between center\"><button \nng-click=\"vm.removeSelectedAppointments()\" ng-disabled=\"vm.disableDeleteButton()\"><i class=\"icon-delete-forever\" \nng-class=\"vm.disableDeleteButton() ? [\'\']:[\'text-red\']\"></i></button></div><div llayout=\"row\" layout-wrap>\n<md-input-container flex=\"100\" class=\"input-box info-form-item small-input-box mt-10\"><label for=\"term\">\nAppointment Details</label><textarea style=\"width:100%\" rows=\"3\" ng-model=\"vm.customAppointmentHolder.title\" \nclass=\"info-form-item detail-info-form-note-input\" maxlength=\"250\" ng-change=\"vm.updateLength()\" \nplaceholder=\"Appointment Details:\">\r\n									</textarea><div ng-messages=\"adevertizingForm.advertise_mileage.$error\">\n<div ng-message=\"maxlength\">Input content can not be over 10 charactors</div><div ng-message=\"pattern\">\nOnly number accepted!</div></div></md-input-container></div><div llayout=\"row\" layout-wrap><md-input-container \nflex=\"20\" class=\"input-box info-form-item small-input-box\"><label for=\"appointmentCatogory\">Category</label><md-select \nname=\"category\" ng-model=\"vm.customAppointmentHolder.category\" placeholder=\"Category\" ng-change=\"vm.updateLength()\" \naria-label=\"Category\" md-no-asterisk><md-option ng-value=\"i\" ng-repeat=\"i in categoryOptions\">{{i}}</md-option>\n</md-select></md-input-container><md-input-container flex=\"20\" class=\"input-box info-form-item small-input-box\"><label \nfor=\"appointmentTitle\">Appointment length</label><md-select name=\"length\" ng-model=\"vm.customAppointmentHolder.length\" \nplaceholder=\"Length (Mins)\" ng-change=\"vm.updateLength()\" aria-label=\"Length\" md-no-asterisk><md-option ng-value=\"i\" \nng-repeat=\"i in lengthOptions\">{{i}}</md-option></md-select></md-input-container></div><div class=\"mt-2 px-1\" \nlayout=\"row\" layout-align=\"space-between center\"><button type=\"button\" class=\"btn btn-outline-secondary mx-0\" \nng-disabled=\"vm.disableAddAppointment\" ng-click=\"vm.redirectToAddAppointment()\">Add Appointment</button></div><br><br>\n</div></md-tab><md-tab label=\"Quoted\" layout=\"row\" md-active=\"vm.currentTab == vm.tabs.Quoted\" \nng-click=\"openTab(\'list2\')\"><div layout-padding layout=\"row\" layout-wrap layout-align=\"start center\" id=\"list1\" \nclass=\"tabcontent\"><div ng-repeat=\"(vehicleID, item) in vm.vehicles\" flex=\"100\" flex-gt-sm=\"33\" \nng-if=\"vm.getVehicleQuoted(vm.workOder[vehicleID])\"><div class=\"card my-3\"><a style=\"text-decoration:none\"><div \nlayout=\"row\" layout-align=\"space-around center\"><div><a ng-href=\"{{vm.getVehiclePageUrl(vehicleID)}}\"><i><img \nflex=\"noshrink\" class=\"view-customer-vehicle-card-img\" \nng-src=\"{{item.vehicleData.landingImage ? item.vehicleData.landingImage:  vm.vehicleImgPlaceholder}}\"></i></a></div>\n<div class=\"ml-2 text-black\" flex=\"grow\" layout=\"column\"><div layout=\"row\"><a \nng-href=\"{{vm.getVehiclePageUrl(vehicleID)}}\" class=\"ml-2 text-black\">{{item.vehicleData.getYearMakeModel()}}</a><div>\n<i ng-click=\"vm.showItems[vehicleID] = !vm.showItems[vehicleID]\" \nng-class=\"vm.showItems[vehicleID]? [\'icon-chevron-up\']:[\'icon-chevron-down\']\"></i></div></div><div layout=\"row\" \nclass=\"ml-2 text-grey\" ng-if=\"vm.showItems[vehicleID]\" ng-repeat=\"invoice in vm.workOder[vehicleID]\"><div \nng-if=\"invoice.workOrder.fk_id_work_order_status == 1\"><a ng-href=\"{{vm.getWorkOrderUrl(invoice)}}\">\n{{invoice.workOrder.invoice_number}}</a></div></div></div></div></a></div></div></div></md-tab><md-tab \nlabel=\"Outstanding(${{vm.gettotalvehicleoutstanding().toFixed(2)}})\" layout=\"row\" \nmd-active=\"vm.currentTab == vm.tabs.Outstanding\" ng-click=\"openTab(\'list2\')\"><div layout-padding layout=\"row\" \nlayout-wrap layout-align=\"start center\" id=\"list1\" class=\"tabcontent\"><div \nng-repeat=\"(vehicleID, item) in vm.vehicles\" flex=\"100\" flex-gt-sm=\"33\" \nng-if=\"vm.getselectedtotaloutstanding(vm.workOder[vehicleID]) != 0\"><div class=\"card my-3\"><a \nstyle=\"text-decoration:none\"><div layout=\"row\" layout-align=\"space-around center\"><div><a \nng-href=\"{{vm.getVehiclePageUrl(vehicleID)}}\"><i><img flex=\"noshrink\" class=\"view-customer-vehicle-card-img\" \nng-src=\"{{item.vehicleData.landingImage ? item.vehicleData.landingImage:  vm.vehicleImgPlaceholder}}\"></i></a></div>\n<div class=\"ml-2 text-black\" flex=\"grow\" layout=\"column\"><div layout=\"row\"><a \nng-href=\"{{vm.getVehiclePageUrl(vehicleID)}}\" class=\"ml-2 text-black\">\n{{item.vehicleData.getYearMakeModel()}} (${{vm.getselectedtotaloutstanding(vm.workOder[vehicleID]).toFixed(2)}})</a>\n<div><i ng-click=\"vm.showItems[vehicleID] = !vm.showItems[vehicleID]\" \nng-class=\"vm.showItems[vehicleID]? [\'icon-chevron-up\']:[\'icon-chevron-down\']\"></i></div></div><div layout=\"row\" \nclass=\"ml-2 text-grey\" ng-if=\"vm.showItems[vehicleID]\" ng-repeat=\"invoice in vm.workOder[vehicleID]\"><div \nng-if=\"invoice.outstanding != 0 && (invoice.workOrder.fk_id_work_order_status == 3 || invoice.workOrder.fk_id_work_order_status == 4)\">\n<a ng-href=\"{{vm.getWorkOrderUrl(invoice)}}\">{{invoice.workOrder.invoice_number}} </a>${{invoice.outstanding}}</div>\n</div></div></div></a></div></div></div><md-button class=\"bg-blue pull-right\" \nng-click=\"vm.downloadOutstandingStatment()\">Download Statment</md-button></md-tab><md-tab label=\"Test Drives\" \nlayout=\"row\" md-active=\"vm.currentTab == vm.tabs.TestDrives\" ng-click=\"openTab(\'list3\')\"><div flex=\"100\" \nflex-gt-sm=\"50\" id=\"list3\" class=\"tabcontent\"><div layout-padding flex=\"100\" layout=\"row\" \nlayout-align=\"space-between center\"><div flex-gt-sm=\"20\">Test Drives</div><md-autocomplete flex-gt-sm=\"80\" \nstyle=\"background-color: rgb(245,245,245) !important\" autocomplete=\"off\" placeholder=\"Search\" md-autoselect=\"ture\" \nmd-search-text=\"vm.testDriveSearchText\" md-delay=\"700\" md-selected-item-change=\"vm.addTestDriveVehicle(vehicle)\" \nmd-items=\"vehicle in vm.queryVehicles()\" md-item-text=\"vehicle.getYearMakeModel()\" md-clear-button=\"false\" \nmd-menu-class=\"vehicle-search-menu\" md-menu-container-class=\"vehicle-search-container\"><md-item-template><div \nlayout=\"row\" layout-align=\"start center\"><div flex=\"none\" class=\"mr-2\"><img \nstyle=\"width: 45px;height:45px; object-fit: contain\" \nng-src=\"{{vehicle.landingImage? vehicle.landingImage:\'../../assets/images/placeholder-vans.png\'}}\"></div><div \nclass=\"item-detail\" style=\"font-size: 13px\"><span><a stop-event ng-href=\"{{vm.getUrlForDetailPage(vehicle)}}\">\n{{vehicle.getYearMakeModel()}}</a> <span class=\"text-red\" \nng-if=\"vm.getVehicleLocation(vehicle) && !vm.getVehicleLocation(vehicle).is_default_location\">\n({{vm.getVehicleLocation(vehicle).name}})</span></span><div>{{vehicle.vin}}</div></div></div></md-item-template>\n</md-autocomplete></div></div><div layout-padding layout=\"row\" layout-wrap layout-align=\"start center\" \nclass=\"tabcontent\"><div ng-repeat=\"testDrive in vm.testDrives\" flex=\"100\" flex-gt-sm=\"33\"><div class=\"card my-3\" \nstyle=\"position: relative\"><md-button class=\"md-icon-button\" \nstyle=\"position: absolute; top: 8px; right: 8px; z-index: 10\" ng-click=\"vm.removeTestDriveVehicleDialog(testDrive)\" \nng-if=\"vm.canRemoveTestDrive\"><md-icon class=\"icon-minus-circle text-red\"></md-icon></md-button><a \nng-href=\"{{vm.getVehiclePageUrl(testDrive.testDriveData.vehicle.id_vehicle)}}\" style=\"text-decoration: none\"><div \nlayout=\"row\"><img flex=\"noshrink\" class=\"view-customer-vehicle-card-img\" \nng-src=\"{{testDrive.vehicleData.landingImage ? testDrive.vehicleData.landingImage : vm.vehicleImgPlaceholder}}\"><div \nclass=\"ml-2 text-black\" flex=\"grow\" layout=\"column\" layout-align=\"center start\"><div><span>\n{{testDrive.vehicleData.getYearMakeModel()}}</span></div><div>{{testDrive.testDriveData.date | date:\'medium\'}}</div>\n<div ng-if=\"testDrive.testDriveData.userName\">Added by {{testDrive.testDriveData.userName}}</div></div></div></a></div>\n</div></div></md-tab></md-tabs></md-content></div></div></div>");
$templateCache.put("app/main/inventory/add-inventory/add-inventory-dialog.html","<div class=\"card\" style=\"max-width: 500px\"><div class=\"modal-header bg-secondary\"><h5 class=\"modal-title mr-5\">\nAdd Inventory</h5><button type=\"button\" class=\"close\" ng-click=\"vm.closeDialog()\"><span aria-hidden=\"true\">&times;\n</span></button></div><div class=\"card-body\"><inventory-info-form inventory=\"vm.inventory\" \ninventory-types=\"vm.inventoryTypes\" is-processing-data=\"vm.isSavingInventoryData\" is-form-valid=\"vm.isFormValid\" \non-duplicated-url-click=\"vm.closeDialog\"></inventory-info-form><div layout=\"row\" layout-align=\"center center\">\n<md-button class=\"btn btn-secondary mx-0\" ng-disabled=\"vm.isSavingInventoryData\" ng-click=\"vm.createInventory()\">create\n</md-button></div></div><md-progress-linear md-mode=\"indeterminate\" ng-disabled=\"!vm.isSavingInventoryData\">\n</md-progress-linear></div>");
$templateCache.put("app/main/inventory/add-inventory/add-inventory.html","<div class=\"page-layout carded fullwidth single-scroll\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\" layout=\"column\" flex><div class=\"header\"><span class=\"h2 white-fg\">Create Inventory</span></div><div \nclass=\"content-card page-content-container\" layout=\"column\" flex><md-content class=\"content\" flex ms-scroll><div \nlayout=\"row\"><inventory-info-form flex=\"100\" flex-gt-sm=\"40\" inventory=\"vm.inventory\" \ninventory-types=\"vm.inventoryTypes\" is-processing-data=\"vm.isSavingInventoryData\" is-form-valid=\"vm.isFormValid\">\n</inventory-info-form></div><md-button class=\"btn btn-secondary mx-0\" ng-disabled=\"vm.isSavingInventoryData\" \nng-click=\"vm.createInventory()\">create</md-button></md-content></div></div></div>");
$templateCache.put("app/main/inventory/components/inventory-info-form.html","<form name=\"inventoryInfoForm\" layout=\"row\" layout-wrap><md-input-container flex=\"50\" \nclass=\"input-box small-input-box input-box-padding\"><input ng-required=\"true\" name=\"name\" ng-model=\"vm.inventory.name\" \nautocomplete=\"off\" placeholder=\"Name\" maxlength=\"100\" ng-disabled=\"vm.isProcessingData\"><div \nng-messages=\"inventoryInfoForm.name.$error\"><div ng-message=\"maxlength\">Input content can not be over 50 charactors\n</div><div ng-message=\"required\">This field is required</div></div></md-input-container><md-input-container flex=\"50\" \nclass=\"input-box small-input-box input-box-padding\"><input ng-required=\"true\" name=\"code\" ng-model=\"vm.inventory.code\" \nautocomplete=\"off\" placeholder=\"Code\" maxlength=\"100\" ng-pattern=\"/^[0-9A-Za-z]*$/\" ng-disabled=\"vm.isProcessingData\" \nng-model-options=\"{ debounce: 700 }\" input-control custom-async-validations=\"vm.codeValidations\"><div \nng-messages=\"inventoryInfoForm.code.$error\" multiple=\"multiple\"><div ng-message=\"maxlength\">\nInput content can not be over 50 charactors</div><div ng-message=\"required\">This field is required</div><div \nng-message=\"pattern\">Only letter or number accepted</div><div ng-message=\"duplicateCheck\">\nInventory is already in the system ! <a href=\"\" ng-click=\"vm.checkOutInventory()\">view inventory.</a></div><div \nng-if=\"inventoryInfoForm.code.$pending\" class=\"text-blue\" style=\"font-size: 13px\">checking if code exist...</div></div>\n</md-input-container><md-input-container flex=\"50\" class=\"input-box small-input-box input-box-padding\"><label>Type\n</label><md-select ng-model=\"vm.inventory.fk_id_part_type\" ng-required=\"true\" name=\"type\" \nng-disabled=\"vm.isProcessingData\"><md-option ng-repeat=\"type in vm.inventoryTypes | orderBy:\'name\'\" \nng-value=\"type.id_part_type\">{{type.name}}</md-option></md-select><div ng-messages=\"inventoryInfoForm.type.$error\"><div\n ng-message=\"required\">This field is required</div></div></md-input-container><md-input-container flex=\"50\" \nclass=\"input-box small-input-box input-box-padding\"><input ng-required=\"true\" name=\"quantity\" \nng-model=\"vm.inventory.quantity\" autocomplete=\"off\" placeholder=\"Quantity\" maxlength=\"5\" ng-pattern=\"/^[0-9]*$/\" \nng-disabled=\"vm.isProcessingData\"><div ng-messages=\"inventoryInfoForm.quantity.$error\"><div ng-message=\"maxlength\">\nInput content can not be over 50 charactors</div><div ng-message=\"required\">This field is required</div><div \nng-message=\"pattern\">Only number accepted</div></div></md-input-container><md-input-container flex=\"50\" \nclass=\"input-box small-input-box input-box-padding\"><input ng-required=\"true\" name=\"purchasePrice\" \nng-model=\"vm.inventory.purchase_price\" autocomplete=\"off\" placeholder=\"Purchase Price\" maxlength=\"10\" input-control \ninput-translate=\"vm.translateToDollar\" ng-disabled=\"vm.isProcessingData\"><div \nng-messages=\"inventoryInfoForm.purchasePrice.$error\"><div ng-message=\"maxlength\">\nInput content can not be over 50 charactors</div><div ng-message=\"required\">This field is required</div><div \nng-message=\"parse\">This field is required</div></div></md-input-container><md-input-container flex=\"50\" \nclass=\"input-box small-input-box input-box-padding\"><input ng-required=\"true\" name=\"suggestRetailValue\" \nng-model=\"vm.inventory.retail_price\" autocomplete=\"off\" placeholder=\"Retail Value\" maxlength=\"10\" input-control \ninput-translate=\"vm.translateToDollar\" ng-disabled=\"vm.isProcessingData\"><div \nng-messages=\"inventoryInfoForm.suggestRetailValue.$error\"><div ng-message=\"maxlength\">\nInput content can not be over 50 charactors</div><div ng-message=\"required\">This field is required</div><div \nng-message=\"parse\">This field is required</div></div></md-input-container><div flex=\"50\">\nTax rate: {{vm.inventory.purchase_tax_rate * 100 | number}}%</div></form>");
$templateCache.put("app/main/inventory/components/inventory-list.html","<table flex class=\"table table-hover table-responsive\" style=\"table-layout: fixed\"><thead><tr class=\"text-nowrap\"><th \nng-click=\"vm.changeSorting(vm.sortTagName)\">Name<md-icon \nng-style=\"{visibility: vm.sortBy == vm.sortTagName? \'visible\':\'hidden\'}\" \nng-class=\"vm.sortDirection == vm.directionDesc? [\'icon-chevron-up\']:[\'icon-chevron-down\']\"></md-icon></th><th \nng-click=\"vm.changeSorting(vm.sortTagCode)\">Code<md-icon \nng-style=\"{visibility: vm.sortBy == vm.sortTagCode? \'visible\':\'hidden\'}\" \nng-class=\"vm.sortDirection == vm.directionDesc? [\'icon-chevron-up\']:[\'icon-chevron-down\']\"></md-icon></th><th \nng-click=\"vm.changeSorting(vm.sortTagType)\">Type<md-icon \nng-style=\"{visibility: vm.sortBy == vm.sortTagType? \'visible\':\'hidden\'}\" \nng-class=\"vm.sortDirection == vm.directionDesc? [\'icon-chevron-up\']:[\'icon-chevron-down\']\"></md-icon></th><th \nng-click=\"vm.changeSorting(vm.sortTagQuantity)\">Quantity<md-icon \nng-style=\"{visibility: vm.sortBy == vm.sortTagQuantity? \'visible\':\'hidden\'}\" \nng-class=\"vm.sortDirection == vm.directionDesc? [\'icon-chevron-up\']:[\'icon-chevron-down\']\"></md-icon></th><th \nng-click=\"vm.changeSorting(vm.sortTagPurchasePrice)\">Cost<md-icon \nng-style=\"{visibility: vm.sortBy == vm.sortTagPurchasePrice? \'visible\':\'hidden\'}\" \nng-class=\"vm.sortDirection == vm.directionDesc? [\'icon-chevron-up\']:[\'icon-chevron-down\']\"></md-icon></th><th \nng-click=\"vm.changeSorting(vm.sortTagRetailPrice)\">Retail<md-icon \nng-style=\"{visibility: vm.sortBy == vm.sortTagRetailPrice? \'visible\':\'hidden\'}\" \nng-class=\"vm.sortDirection == vm.directionDesc? [\'icon-chevron-up\']:[\'icon-chevron-down\']\"></md-icon></th></tr></thead>\n<tbody><tr ng-repeat=\"inventory in vm.inventoryList\" class=\"text-nowrap\"><td><a \nng-href=\"{{vm.getInventoryPageUrl(inventory)}}\">{{inventory.name}}</a></td><td>{{inventory.code}}</td><td>\n{{vm.getTypeName(inventory.fk_id_part_type)}}</td><td>{{inventory.quantity | number:0}}</td><td>\n{{inventory.purchase_price | currency:\'$\':2}}</td><td>{{inventory.retail_price | currency:\'$\':2}}</td></tr><tr \nng-if=\"!(vm.inventoryList.length > 0)\"><td>No Inventory Found</td></tr></tbody></table>");
$templateCache.put("app/main/inventory/edit-inventory/edit-inventory.html","<div class=\"page-layout carded fullwidth single-scroll\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\" layout=\"column\" flex><div class=\"header\"><span class=\"h2 white-fg\">Edit Inventory</span><div \nlayout=\"row\" layout-align=\"end center\"><button ng-click=\"vm.deleteInventory()\" \nng-disabled=\"vm.isSaving || vm.isDeleting\"><i class=\"icon-delete-forever text-red\"></i></button></div></div><div \nclass=\"content-card page-content-container\" layout=\"column\" flex><md-content class=\"content\" flex ms-scroll><div \nlayout=\"row\"><inventory-info-form flex=\"100\" flex-gt-sm=\"40\" origin-code=\"vm.originInventory.code\" \ninventory=\"vm.inventory\" inventory-types=\"vm.inventoryTypes\" is-processing-data=\"vm.isSaving || vm.isDeleting\" \nis-form-valid=\"vm.isFormValid\"></inventory-info-form></div><md-button class=\"btn btn-secondary mx-0\" \nng-disabled=\"vm.isSaving || vm.isDeleting\" ng-click=\"vm.save()\">save</md-button></md-content></div></div></div>");
$templateCache.put("app/main/inventory/manage-inventory/manage-inventory.html","<div class=\"page-layout carded fullwidth single-scroll\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\" layout=\"column\" flex><div class=\"header\"><span class=\"h2 white-fg\">Manage Inventory</span></div><div \nclass=\"content-card page-content-container\" layout=\"column\" flex><md-content class=\"content\" flex ms-scroll><div \nlayout=\"row\" layout-wrap><div flex=\"100\" flex-gt-sm=\"50\"><md-button class=\"btn-secondary\" ng-click=\"vm.addInventory()\" \nng-disabled=\"vm.isAddingInventory\">Add</md-button></div><div flex=\"100\" flex-gt-sm=\"50\" layout=\"row\" layout-wrap>\n<md-input-container flex=\"50\" flex-gt-sm=\"33\"><label>Type</label><md-select ng-model=\"vm.inventoryType\" \nng-disabled=\"vm.isProcessingData\" ng-change=\"vm.refreshInventoryList(1)\"><md-option \nng-repeat=\"partType in vm.inventoryTypes | orderBy:\'name\'\" ng-value=\"partType.id_part_type\">{{partType.name}}\n</md-option><md-option ng-value=\"undefined\">All</md-option></md-select></md-input-container><md-input-container \nflex=\"50\" flex-gt-sm=\"33\"><input ng-model=\"vm.nameSearchText\" ng-model-options=\"{ debounce: 700 }\" placeholder=\"Name\" \nng-change=\"vm.refreshInventoryList(1)\" autocomplete=\"off\"></md-input-container><md-input-container flex=\"100\" \nflex-gt-sm=\"33\"><input ng-model=\"vm.codeSearchText\" ng-model-options=\"{ debounce: 700 }\" placeholder=\"Code\" \nng-change=\"vm.refreshInventoryList(1)\" autocomplete=\"off\"></md-input-container></div></div><inventory-list \ninventory-list=\"vm.inventoryList\" inventory-types=\"vm.inventoryTypes\" sort-by=\"vm.sortBy\" \nsort-direction=\"vm.sortDirection\" on-sorting-changed=\"vm.onSortingChanged\"></inventory-list><div layout=\"row\" \nlayout-padding layout-align=\"end center\"><pagination item-per-page=\"vm.itemsPerPage\" current-page=\"vm.currentPage\" \ntotal-count=\"vm.totalCount\" on-page-change=\"vm.refreshInventoryList\"></pagination><div>Total Item: {{vm.totalCount}}\n</div><div>Display:</div><md-select ng-change=\"vm.refreshInventoryList(1)\" ng-model=\"vm.itemsPerPage\" \nplaceholder=\"Display\"><md-option ng-repeat=\"option in vm.displayOptions\" ng-value=\"option\">{{option}}</md-option>\n</md-select></div></md-content></div></div></div>");
$templateCache.put("app/main/parts/browse-parts/browse-parts.html","<div style=\"width: 100%\" class=\"bg-secondary header-backgroud\" layout=\"row\" layout-align=\"center center\"><div flex \nclass=\"content-max-width content-padding-x-full\"><span class=\"h2 white-fg\">Parts</span></div></div><div \nstyle=\"width: 100%\" layout=\"row\" layout-align=\"center start\"><div flex \nclass=\"py-3 content-max-width content-padding-x-full\"><div layout=\"row\" layout-wrap><md-input-container flex=\"50\" \nflex-gt-sm=\"25\" class=\"input-box-padding\"><label>Preset Part</label><md-select ng-model=\"vm.partTypeFilter\" \nng-change=\"vm.refreshPartList(1)\"><md-option ng-repeat=\"partType in vm.partTypes | orderBy:\'name\'\" \nng-value=\"partType.id_part_type\">{{partType.name}}</md-option><md-option ng-value=\"undefined\">All</md-option>\n</md-select></md-input-container><md-input-container flex=\"50\" flex-gt-sm=\"25\" class=\"input-box-padding\"><input \nng-model=\"vm.nameFilter\" ng-model-options=\"{ debounce: 700 }\" placeholder=\"Part Name\" \nng-change=\"vm.refreshPartList(1)\" autocomplete=\"off\"></md-input-container><md-input-container flex=\"50\" \nflex-gt-sm=\"25\" class=\"input-box-padding\"><input ng-model=\"vm.codeFilter\" ng-model-options=\"{ debounce: 700 }\" \nplaceholder=\"Part Code\" ng-change=\"vm.refreshPartList(1)\" autocomplete=\"off\"></md-input-container><md-input-container \nflex=\"50\" flex-gt-sm=\"25\" class=\"input-box-padding\"><md-checkbox ng-model=\"vm.uninvoicedFilter\" \nng-change=\"vm.refreshPartList(1)\">Uninvoiced</md-checkbox></md-input-container></div><parts-list parts=\"vm.parts\" \npart-types=\"vm.partTypes\" on-sorting-changed=\"vm.onSortingChanged\" get-selected-parts=\"vm.getSelectedParts\" \nclean-selected-parts=\"vm.cleanSelectedParts\"></parts-list><div layout=\"row\" layout-align=\"space-between center\"><div \nlayout=\"row\" layout-align=\"start center\"><div>Invoice</div><i class=\"text-secondary\" \nng-click=\"vm.showInvoiceSection = !vm.showInvoiceSection\" \nng-class=\"vm.showInvoiceSection ? [\'icon-menu-up\']:[\'icon-arrow-down-drop\']\"></i></div><div layout=\"row\" \nlayout-align=\"end center\"><pagination class=\"mr-3\" item-per-page=\"vm.itemsPerPage\" current-page=\"vm.currentPage\" \ntotal-count=\"vm.totalCount\" on-page-change=\"vm.refreshPartList\"></pagination><div class=\"mr-3\">\nTotal Item: {{vm.totalCount}}</div><div>Display:</div><md-select ng-change=\"vm.refreshPartList(1)\" \nng-model=\"vm.itemsPerPage\" placeholder=\"Display\"><md-option ng-repeat=\"option in vm.displayOptions\" ng-value=\"option\">\n{{option}}</md-option></md-select></div></div><div layout=\"row\" layout-align=\"start center\"><md-input-container \nflex=\"50\" flex-gt-sm=\"25\" class=\"input-box small-input-box input-box-padding\"><md-select placeholder=\"Suppiler\" \nng-model=\"vm.supplierID\" ng-disabled=\"vm.isApplyingChanges\"><md-option \nng-repeat=\"supplier in vm.suppliers | orderBy:\'name\'\" ng-value=\"supplier.id_supplier\">{{supplier.name}}</md-option>\n</md-select></md-input-container><md-autocomplete flex=\"50\" flex-gt-sm=\"25\" md-floating-label=\"Invoice #\" \nclass=\"input-box small-input-box input-box-padding\" md-autoselect=\"true\" ng-disabled=\"vm.isApplyingChanges\" \nautocomplete=\"off\" md-search-text=\"vm.purchaseInvoiceSearchText\" md-delay=\"700\" md-no-cache=\"true\" \nmd-select-on-focus=\"true\" md-selected-item=\"vm.selectedPurchaseInvoice\" \nmd-selected-item-change=\"vm.selectPurchaseInvoice()\" \nmd-items=\"invoice in vm.queryPurchaseInvoice(vm.supplierID, vm.purchaseInvoiceSearchText)\" \nmd-item-text=\"invoice.invoice_number\" md-menu-class=\"part-search-menu\" md-clear-button=\"false\" \nmd-menu-container-class=\"part-search-container\"><md-item-template><div>\n{{invoice.invoice_number + \', \' + vm.getSupplierName(invoice.fk_id_supplier)}}</div></md-item-template>\n</md-autocomplete><div flex><button class=\"btn btn-sm btn-secondary\" \nng-disabled=\"vm.isApplyingChanges || vm.isApplyButtonDisabled()\"><div class=\"tabbable-button\" tabindex=\"0\">Apply</div>\n</button></div></div></div></div>");
$templateCache.put("app/main/parts/components/parts-list.html","<md-content><table class=\"table strike-able table-hover\" style=\"table-layout: fixed;width:100%; min-width:500px\">\n<thead><tr><th class=\"text-nowrap bg-light\" style=\"width: 35px\"><md-checkbox ng-if=\"vm.parts.length > 0\" \nng-checked=\"vm.isAllSelected()\" ng-click=\"vm.selectAll()\" class=\"m-0 p-0\"></md-checkbox></th><th \nng-click=\"vm.changeSorting(vm.sortTagQuantity)\" class=\"text-nowrap bg-light\" style=\"width: 80px\">Qty.<md-icon \nng-style=\"{visibility: vm.sortBy == vm.sortTagQuantity? \'visible\':\'hidden\'}\" \nng-class=\"vm.sortDirection == vm.directionDesc? [\'icon-chevron-up\']:[\'icon-chevron-down\']\"></md-icon></th><th \nng-click=\"vm.changeSorting(vm.sortTagCode)\" class=\"text-nowrap bg-light\" style=\"width: 120px\">Code<md-icon \nng-style=\"{visibility: vm.sortBy == vm.sortTagCode? \'visible\':\'hidden\'}\" \nng-class=\"vm.sortDirection == vm.directionDesc? [\'icon-chevron-up\']:[\'icon-chevron-down\']\"></md-icon></th><th \nng-click=\"vm.changeSorting(vm.sortTagName)\" class=\"text-nowrap bg-light\">Name<md-icon \nng-style=\"{visibility: vm.sortBy == vm.sortTagName? \'visible\':\'hidden\'}\" \nng-class=\"vm.sortDirection == vm.directionDesc? [\'icon-chevron-up\']:[\'icon-chevron-down\']\"></md-icon></th><th \nng-click=\"vm.changeSorting(vm.sortTagType)\" class=\"text-nowrap bg-light\" style=\"width: 90px\">Type<md-icon \nng-style=\"{visibility: vm.sortBy == vm.sortTagType? \'visible\':\'hidden\'}\" \nng-class=\"vm.sortDirection == vm.directionDesc? [\'icon-chevron-up\']:[\'icon-chevron-down\']\"></md-icon></th></tr></thead>\n<tbody><tr ng-repeat=\"part in vm.parts\"><td><md-checkbox ng-model=\"vm.selectedMap[part.id_part]\" class=\"m-0 p-0\">\n</md-checkbox></td><td>{{part.quantity}}</td><td>{{part.code}}</td><td style=\"word-wrap: break-word\">{{part.name}}</td>\n<td>{{vm.getPartType(part.fk_id_part_type)}}</td></tr><tr ng-if=\"!(vm.parts.length > 0)\"><td colspan=\"5\">No item found.\n</td></tr></tbody></table></md-content>");
$templateCache.put("app/main/parts/components/parts-table.html","<div style=\"position: relative\"><md-tabs md-dynamic-height md-border-bottom ng-if=\"vm.tabs.length > 0\" \nmd-selected=\"vm.currentTabIndex\"><md-tab md-tab-class=\"part-table-tab\" ng-repeat=\"tab in vm.tabs\" \nmd-on-select=\"vm.onTabChange(tab)\"><md-tab-label><div ng-class=\"tab.tabClass()\">\n{{tab.title + \' (\' + vm.getPartNumber(tab) + \')\'}}</div></md-tab-label></md-tab></md-tabs><div \nstyle=\"position: absolute; top: 0; left: 0; width: 100%; height: 100%\" class=\"bg-white opacity-50\" \nng-if=\"vm.disableSelect\"></div></div><md-content><table class=\"table strike-able table-hover\" \nstyle=\"table-layout: fixed;width:100%; min-width:800px\"><thead><tr><th class=\"text-nowrap bg-light\" \nstyle=\"width: 35px\"><md-checkbox ng-disabled=\"vm.disableSelect\" ng-if=\"vm.partList.length > 0\" \nng-checked=\"vm.isAllSelected()\" ng-click=\"vm.selectAll()\" class=\"m-0 p-0\"></md-checkbox></th><th \nclass=\"text-nowrap bg-light\" style=\"width: 80px\">Qty.</th><th class=\"text-nowrap bg-light\" style=\"width: 120px\">Code\n</th><th class=\"text-nowrap bg-light\">Name</th><th class=\"text-nowrap bg-light\" style=\"width: 90px\">Type</th><th \nng-if=\"!vm.hiddenColumns.cost\" class=\"text-nowrap bg-light\" style=\"width: 90px\">Cost</th><th \nng-if=\"!vm.hiddenColumns.suggestedRetailPrice\" class=\"text-nowrap bg-light\" style=\"width: 90px\">S. Retail</th><th \nclass=\"text-nowrap bg-light\" style=\"width: 90px\">Retail</th><th ng-if=\"!vm.hiddenColumns.invoice\" \nclass=\"text-nowrap bg-light\" style=\"width: 100px\">Inv.</th><th ng-if=\"!vm.hiddenColumns.returnInvoice\" \nclass=\"text-nowrap bg-light\" style=\"width: 100px\">Re. Inv.</th><th ng-if=\"vm.isFromPurchaseInvoice\" \nclass=\"text-nowrap bg-light\" style=\"width: 100px\">Work Order</th></tr></thead><tbody><tr \nng-if=\"vm.tabs[vm.currentTabIndex].filter ? vm.tabs[vm.currentTabIndex].filter(item) : true\" \nng-class=\"vm.tabs[vm.currentTabIndex].rowClass(item)\" ng-click ng-repeat=\"item in vm.partList track by $index\" \ntabindex=\"0\" ng-focus=\"vm.onRowFocus($index)\" ng-blur=\"vm.onRowBlur()\" id=\"{{\'partRow\' + $index}}\" \nng-style=\"vm.getWorkOrderJobIdFromItemId(item, vm.workOrderJobList , $index, vm.colorCache)\" \nname=\"{{\'partTableRow\' + $index}}\"><td><md-checkbox ng-disabled=\"vm.disableSelect\" tabindex=\"-1\" \nng-blur=\"vm.onInputBlur()\" ng-focus=\"vm.onInputFocus($index);\" class=\"m-0 p-0\" ng-model=\"item.isSelected\">\n</md-checkbox></td><td><div ng-if=\"vm.focusIndex != $index || (vm.disableEditing && !item.isNew())\" \nclass=\"text-nowrap text-truncate mb-2 mt-3\">{{item.quantity | number}}</div><div layout=\"row\" \nng-if=\"vm.focusIndex == $index && !(vm.disableEditing && !item.isNew())\"><input flex id=\"{{\'partRowQty\' + $index}}\" \nautocorrect=\"off\" autocapitalize=\"none\" spellcheck=\"false\" autocomplete=\"off\" \nng-change=\"item.updateProperty(\'quantity\'); \" ng-focus=\"vm.onInputFocus($index)\" \nng-blur=\"vm.onInputBlur(); vm.onQuantityChange(item)\" class=\"m-0 pl-2 py-2\" ng-model=\"item.quantity\" input-control \nplaceholder=\"Qty.\" input-translate=\"vm.decimalTranslator\" input-options=\"vm.quantityInputOption\" maxlength=\"10\"></div>\n</td><td style=\"position: relative\"><div \nng-if=\"vm.focusIndex != $index || (vm.disableEditing && !item.isNew()) || item.inventoryData\" \nclass=\"text-nowrap text-truncate mb-2 mt-3 text-uppercase\">{{item.code}}</div><div layout=\"row\" \nng-if=\"vm.focusIndex == $index && !(vm.disableEditing && !item.isNew()) && item.partData\"><md-autocomplete flex \nclass=\"autocomplete-uppercase\" autocomplete=\"off\" placeholder=\"Code\" md-autoselect=\"ture\" \nng-focus=\"vm.onInputFocus($index)\" ng-blur=\"vm.onInputBlur(); vm.pullDataFromMatchedInventory(item)\" \nmd-search-text-change=\"item.updateProperty(\'code\');\" md-search-text=\"item.code\" md-delay=\"700\" \nmd-selected-item-change=\"vm.onPartMatchInventory(item, matchedInventory)\" \nmd-items=\"matchedInventory in vm.queryInventoryByCode(item.code)\" md-item-text=\"matchedInventory.code\" \nmd-menu-class=\"part-search-menu\" md-clear-button=\"false\" md-menu-container-class=\"part-search-container\">\n<md-item-template><div>{{matchedInventory.code + \' (\' + matchedInventory.quantity + \')\'}}</div></md-item-template>\n</md-autocomplete></div><a ng-click=\"vm.pullDataFromMatchedInventory(item)\" \nstyle=\"position: absolute;bottom: 0%;font-size: 10px\" class=\"text-secondary\" \nng-if=\"vm.matchedInventories[item.partData.code] && !item.partData.is_ordered\">Use from inventory</a><div \nstyle=\"position: absolute;bottom: 0%;font-size: 10px\" class=\"text-red\" ng-if=\"item.code.length > vm.maxCodeLength\">\nCode length is over {{::vm.maxCodeLength}}</div></td><td style=\"position: relative\"><div class=\"mb-2 mt-3\" \nng-if=\"vm.focusIndex != $index || (vm.disableEditing && !item.isNew()) || item.inventoryData\" \nstyle=\"word-wrap: break-word\">{{item.name}}</div><div layout=\"row\" \nng-if=\"vm.focusIndex == $index && !(vm.disableEditing && !item.isNew()) && item.partData\"><input \nng-change=\"item.updateProperty(\'name\')\" autocorrect=\"off\" autocapitalize=\"none\" spellcheck=\"false\" autocomplete=\"off\" \nflex placeholder=\"Name\" ng-focus=\"vm.onInputFocus($index)\" ng-blur=\"vm.onInputBlur()\" class=\"m-0 pl-2 py-2\" \nng-model=\"item.name\" input-control input-translate=\"vm.allInitCapitalizeTranslator\"></div><div \nstyle=\"position: absolute;bottom: 0%;font-size: 10px\" class=\"text-red\" ng-if=\"!item.name\">Required</div><div \nstyle=\"position: absolute;bottom: 0%;font-size: 10px\" class=\"text-red\" ng-if=\"item.name.length > vm.maxNameLength\">\nName length is over {{::vm.maxNameLength}}</div></td><td><div \nng-if=\"vm.focusIndex != $index || (vm.disableEditing && !item.isNew()) || item.inventoryData\" \nclass=\"text-nowrap text-truncate mb-2 mt-3\">{{vm.getTypeName(item.type)}}</div><div layout=\"row\" \nng-if=\"vm.focusIndex == $index && !(vm.disableEditing && !item.isNew()) && item.partData\"><md-select \nid=\"{{\'PartTypeRowTypes\' + $index}}\" flex ng-change=\"item.updateProperty(\'type\'); vm.onPartTypeSelected({{$index}})\" \nng-focus=\"vm.onInputFocus($index)\" ng-blur=\"vm.onInputBlur()\" \nclass=\"text-black small-selector purchase-step-selector m-0\" ng-model=\"item.type\" placeholder=\"Type\"><md-option \nng-repeat=\"type in vm.parttypelist\" ng-focus=\"vm.onInputFocus($index)\" ng-value=\"{{::type.id_part_type}}\">\n{{::type.name}}</md-option></md-select></div></td><td ng-if=\"!vm.hiddenColumns.cost \"><div \nng-if=\"vm.focusIndex != $index || (vm.disableEditing && !item.isNew()) || item.inventoryData\" \nclass=\"text-nowrap text-truncate mb-2 mt-3\">{{item.cost | currency:\'$\':\'2\'}}</div><div layout=\"row\" \nng-if=\"vm.focusIndex == $index && !(vm.disableEditing && !item.isNew()) && item.partData\"><input \nng-change=\"item.updateProperty(\'cost\'); vm.onCostChange(item)\" autocorrect=\"off\" autocapitalize=\"none\" \nspellcheck=\"false\" autocomplete=\"off\" flex placeholder=\"Cost\" ng-focus=\"vm.onInputFocus($index)\" \nng-blur=\"vm.onInputBlur()\" class=\"m-0 pl-2 py-2\" ng-model=\"item.cost\" input-control \ninput-translate=\"vm.translateToDollar\" maxlength=\"10\"></div></td><td ng-if=\"!vm.hiddenColumns.suggestedRetailPrice \">\n<div ng-if=\"vm.focusIndex != $index || (vm.disableEditing && !item.isNew()) || item.inventoryData\" \nclass=\"text-nowrap text-truncate mb-2 mt-3\">{{item.suggestedRetailPrice | currency:\'$\':\'2\'}}</div><div layout=\"row\" \nng-if=\"vm.focusIndex == $index && !(vm.disableEditing && !item.isNew()) && item.partData\"><input \nng-change=\"item.updateProperty(\'suggestedRetailPrice\')\" autocorrect=\"off\" autocapitalize=\"none\" spellcheck=\"false\" \nautocomplete=\"off\" flex placeholder=\"S. Retail\" ng-focus=\"vm.onInputFocus($index)\" ng-blur=\"vm.onInputBlur()\" \nclass=\"m-0 pl-2 py-2\" ng-model=\"item.suggestRetailPrice\" input-control input-translate=\"vm.translateToDollar\" \nmaxlength=\"10\"></div></td><td><div ng-if=\"vm.focusIndex != $index || (vm.disableEditing && !item.isNew())\" \nclass=\"text-nowrap text-truncate mb-2 mt-3\">{{item.retailPrice | currency:\'$\':\'2\'}}</div><div layout=\"row\" \nng-if=\"vm.focusIndex == $index && !(vm.disableEditing && !item.isNew())\"><input \nng-change=\"item.updateProperty(\'retailPrice\'); vm.onRetailChange(item)\" autocorrect=\"off\" autocapitalize=\"none\" \nspellcheck=\"false\" autocomplete=\"off\" flex placeholder=\"Retail\" ng-focus=\"vm.onInputFocus($index)\" \nng-blur=\"vm.onInputBlur()\" class=\"m-0 pl-2 py-2\" ng-model=\"item.retailPrice\" input-control \ninput-translate=\"vm.translateToDollar\" maxlength=\"10\"></div></td><td ng-if=\"!vm.hiddenColumns.invoice\"><div \nng-if=\"!!item.inventoryData\">N/A</div><div ng-if=\"!!item.partData && item.purchaseInvoiceID != null\" \nclass=\"text-nowrap text-truncate mb-2 mt-3\"><div>{{vm.getInvoiceSupplier(item.purchaseInvoiceID)}}</div><a \ntabindex=\"-1\" ng-href=\"{{vm.getInvoiceLink(item.purchaseInvoiceID)}}\">{{vm.getInvoiceNumber(item.purchaseInvoiceID)}}\n</a></div></td><td ng-if=\"!vm.hiddenColumns.returnInvoice\"><div ng-if=\"!!item.inventoryData\">N/A</div><div \nng-if=\"!!item.partData && item.returnInvoiceID != null\" class=\"text-nowrap text-truncate mb-2 mt-3\"><div>\n{{vm.getReturnInvoiceSupplier(item.returnInvoiceID)}}</div><a tabindex=\"-1\" \nng-href=\"{{vm.getReturnInvoiceLink(item.returnInvoiceID)}}\">{{vm.getReturnInvoiceNumber(item.returnInvoiceID)}}</a>\n</div></td><td ng-if=\"vm.isFromPurchaseInvoice\"><div ng-if=\"!!item.partData.fk_id_work_order != null\" \nclass=\"text-nowrap text-truncate mb-2 mt-3\"><a tabindex=\"-1\" \nng-href=\"{{vm.getWorkOrderLink(item.partData.fk_id_vehicle, item.partData.fk_id_work_order)}}\">\n{{item.partData.invoice_number}}</a></div></td></tr><tr ng-click=\"vm.addNewRow()\" ng-if=\"!vm.hideAdding\"><td>\n<md-checkbox ng-disabled=\"vm.disableSelect\" class=\"m-0 p-0\" ng-model=\"vm.defaultCheckBox\" ng-focus=\"vm.addNewRow()\">\n</md-checkbox></td><td><div class=\"text-nowrap text-truncate mb-2 mt-3 text-grey\">Qty.</div></td><td><div \nclass=\"text-nowrap text-truncate mb-2 mt-3 text-grey\">Code</div></td><td><div \nclass=\"text-nowrap text-truncate mb-2 mt-3 text-grey\">Name</div></td><td><div \nclass=\"text-nowrap text-truncate mb-2 mt-3 text-grey\">Type</div></td><td ng-if=\"!vm.hiddenColumns.cost\"><div \nclass=\"text-nowrap text-truncate mb-2 mt-3 text-grey\">Cost</div></td><td \nng-if=\"!vm.hiddenColumns.suggestedRetailPrice\"><div class=\"text-nowrap text-truncate mb-2 mt-3 text-grey\">S. Retail\n</div></td><td><div class=\"text-nowrap text-truncate mb-2 mt-3 text-grey\">Retail</div></td><td \nng-if=\"!vm.hiddenColumns.invoice\"><div class=\"text-nowrap text-truncate mb-2 mt-3 text-grey\">Inv.</div></td><td \nng-if=\"!vm.hiddenColumns.returnInvoice\"><div class=\"text-nowrap text-truncate mb-2 mt-3 text-grey\">Re. Inv.</div></td>\n</tr></tbody></table></md-content><div class=\"bg-white\"><div layout-wrap layout=\"row\" ng-if=\"vm.showGroupEdit\" \nclass=\"px-3\"><div layout=\"row\" layout-align=\"start center\" flex=\"100\" flex-gt-sm=\"60\"><md-autocomplete flex \nmd-floating-label=\"Inv. {{!vm.enablePurchaseInvoiceInput || vm.isApplyingChanges ? \'(disabled)\':\'\'}}\" \nclass=\"input-box small-input-box input-box-padding\" \nng-disabled=\"!vm.enablePurchaseInvoiceInput || vm.isApplyingChanges\" autocomplete=\"off\" \nmd-search-text=\"vm.purchaseInvoiceSearchText\" md-delay=\"700\" md-no-cache=\"true\" md-select-on-focus=\"true\" \nmd-selected-item=\"vm.selectedPurchaseInvoice\" md-selected-item-change=\"vm.selectPurchaseInvoice()\" \nmd-items=\"invoice in vm.queryPurchaseInvoice(vm.supplierID, vm.purchaseInvoiceSearchText)\" \nmd-item-text=\"invoice.invoice_number\" md-menu-class=\"part-search-menu\" md-clear-button=\"false\" \nmd-menu-container-class=\"part-search-container\"><md-item-template><div>\n{{invoice.invoice_number + \', \' + vm.getSupplierName(invoice.fk_id_supplier)}}</div></md-item-template>\n</md-autocomplete><md-input-container flex class=\"input-box small-input-box input-box-padding\"><md-select \nplaceholder=\"Suppiler {{!vm.enableSupplierSelector || vm.isApplyingChanges || !vm.purchaseInvoiceSearchText ? \'(disabled)\':\'\'}}\" \nng-model=\"vm.supplierID\" \nng-disabled=\"!vm.enableSupplierSelector || vm.isApplyingChanges || !vm.purchaseInvoiceSearchText\"><md-option \nng-repeat=\"supplier in vm.suppliers | orderBy:\'name\'\" ng-value=\"supplier.id_supplier\">\n{{supplier.name}}{{!vm.enableSupplierSelector || vm.isApplyingChanges || !vm.purchaseInvoiceSearchText ? \' (disabled)\':\'\'}}\n</md-option></md-select></md-input-container></div><div layout=\"row\" layout-align=\"start center\" flex=\"100\" \nflex-gt-sm=\"40\"><div flex layout=\"row\" class=\"mr-3\" layout-align=\"start center\"><md-checkbox class=\"m-0 p-0\" \nng-model=\"vm.ordered\" ng-disabled=\"!vm.enableOrderedCheckBox || vm.isApplyingChanges\">Ordered</md-checkbox></div><div \nflex layout=\"row\" class=\"mr-3\" layout-align=\"start center\"><md-checkbox class=\"m-0 p-0\" ng-model=\"vm.returned\" \nng-disabled=\"!vm.enableReturnedCheckBox || vm.isApplyingChanges\">Returned</md-checkbox></div><div flex><button \nclass=\"btn btn-sm btn-secondary\" ng-click=\"vm.applyGroupEdit()\" \nng-disabled=\"!vm.isApplyButtonEnabled() || vm.isApplyingChanges\"><div class=\"tabbable-button\" tabindex=\"0\">Apply</div>\n</button></div></div><div flex=\"100\" style=\"font-size: 13px; height: 20px\" class=\"px-1\"><div \nng-if=\"((vm.enableReturnInvoiceInput && vm.returnInvoiceSearchText) || (vm.enablePurchaseInvoiceInput && vm.purchaseInvoiceSearchText)) && !vm.supplierID\">\nPlease select a supplier.</div></div></div><div layout=\"row\" layout-align=\"center center\"><div style=\"width: 100px\">\n<md-divider></md-divider></div><button class=\"m-1\" style=\"z-index: 99\" ng-click=\"vm.showGroupEdit = !vm.showGroupEdit\" \nng-disabled=\"!vm.enableDropDownButton\"><i ng-class=\"vm.getDropDownButtonClass()\"></i></button><div \nstyle=\"width: 100px\"><md-divider></md-divider></div></div></div>");
$templateCache.put("app/main/purchase-info/add-purchase-info/add-purchase-info.html","<div class=\"page-layout carded fullwidth single-scroll\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"column\"><div layout=\"row\"><span class=\"h2 white-fg\">\nAdd Purchase Info</span></div><h6><a class=\"badge badge-primary\" href=\"{{::vm.vehiclePageUrl}}\">\n{{::vm.vehicle.getYearMakeModel()}}</a></h6></div><div class=\"content-card page-content-container\" layout=\"column\" \nflex><md-content class=\"content\" flex ms-scroll><div layout=\"column\" layout-gt-sm=\"row\"><div flex=\"100\" \nflex-gt-sm=\"40\"><div class=\"mb-10\"><purchase-info-form vehicle-id=\"vm.vehicle.getResourceID()\" \npurchase-info=\"vm.purchaseInfo\" auctions=\"vm.auctions\" is-form-valid=\"vm.isPurchaseInfoFormValid\" \npurchase-info-price-type=\"vm.purchaseInfoPriceType\" purchase-info-price=\"vm.purchaseInfoPrice\" \ncreate-purchase-info-price=\"vm.tempCreatePurchaseInfoPrice\" delete-purchase-info-price=\"vm.deletePurchaseInfoPrice\" \nupdate-purchase-info-price=\"vm.updatePurchaseInfoPrice\" adding-purchase-info=\"true\" \nis-processing-data=\"vm.isProcessingData\"></purchase-info-form></div><div class=\"mb-10\">Disclosures:\n<purchase-disclosure-list disclosures=\"vm.disclosures\" on-disclosure-added=\"vm.onDisclosureAdded\" \non-disclosure-removed=\"vm.onDisclosureRemoved\" clean-new-disclouser=\"vm.cleanNewDisclouser\" \nis-processing-data=\"vm.isProcessingData\"></purchase-disclosure-list></div><div class=\"mb-10\">Files:<file-section \nuploaded-files=\"vm.purchaseInfoFiles\" file-uploader=\"vm.purchaseInfoFileUploader\"></file-section></div></div></div>\n<md-button class=\"btn-secondary mx-0\" ng-click=\"vm.createPurchaseInfo()\">Create</md-button></md-content></div></div>\n</div><img id=\"safetyReportPatternPage\" style=\"display:none\" src=\"assets/images/safetyreport/page_1.jpg\" \ncrossorigin=\"anonymous\">");
$templateCache.put("app/main/purchase-info/components/purchase-cost-summary.html","<div class=\"card\" style=\"font-size: 13px\"><div class=\"card-header py-1 bg-black\"><div \nclass=\"text-white font-weight-bold\">Purchase Cost Summary</div></div><div class=\"card-body\"><div \nng-repeat=\"price in vm.purchaseInfoPrice\"><div layout=\"row\" layout-align=\"space-between center\"><div>\n{{price.description}}</div><div>{{price.amount | currency:\'$\':2}}</div></div></div><div class=\"mt-3\"><div \nclass=\"font-weight-bold\">Tasks</div><md-divider class=\"my-1\"></md-divider><div \nng-if=\"vm.tasks.length <= 0 && vm.workorderListDetails.length <= 0\">No item found</div><div layout=\"row\" \nlayout-align=\"space-between center\" ng-repeat=\"task in vm.tasks\"><a flex=\"70\" class=\"text-nowrap text-truncate\" \nhref=\"{{vm.getTaskUrl(task)}}\">{{task.name}}</a><div>{{task.cost | currency:\'$\':2}}</div></div><div layout=\"row\" \nlayout-align=\"space-between center\" ng-repeat=\"item in vm.workorderListDetails\" ng-if=\"item.totalSubsidization\"><a \nflex=\"70\" class=\"text-nowrap text-truncate\" ng-href=\"{{vm.getWorkorderUrl(item.workorderData.id_work_order)}}\">\n{{item.workorderData.invoice_number}}</a><div>{{item.totalSubsidization | currency:\'$\':2}}</div></div></div><div \nlayout=\"row\" class=\"mt-3 font-weight-bold\" layout-align=\"space-between center\"><div>Sub Total</div><div>\n{{vm.subTotalBeforeTax_2 | currency:\'$\':2}}</div></div><div ng-repeat=\"price in vm.groupedPrices\"><div layout=\"row\" \nlayout-align=\"space-between center\" class=\"mt-3 font-weight-bold\"><div>Tax ({{(price.rate * 100).toFixed(2)}}%)</div>\n<div>{{price.total | currency:\'$\':2}}</div></div></div><div layout=\"row\" class=\"mt-3 font-weight-bold\" \nlayout-align=\"space-between center\"><div>Total Tax</div><div>{{vm.totalTax | currency:\'$\':2}}</div></div><div \nlayout=\"row\" class=\"font-weight-bold mt-5\" layout-align=\"space-between center\" style=\"font-size: 16px\"><div>TOTAL COST\n</div><div>{{vm.totalCostVersion2 | currency:\'$\':2}}</div></div></div></div>");
$templateCache.put("app/main/purchase-info/components/purchase-info-disclosure-list.html","<md-divider></md-divider><div class=\"py-5 pl-2\"><div ng-if=\"!vm.disclosures.length > 0\">No item found</div><div \nng-repeat=\"disclosure in vm.disclosures\" layout=\"row\" layout-align=\"space-between center\"><div flex=\"70\" \nclass=\"text-truncate text-nowrap\">{{disclosure.description}}</div><div flex-offset=\"5\" flex=\"20\">\n{{disclosure.amount | currency:\'$\':2}}</div><span flex=\"5\" ng-class=\"vm.isProcessingData? [\'text-grey\']:[\'text-red\']\" \nng-click=\"vm.isProcessingData? null:vm.onDisclosureRemoved(disclosure, $index)\">&#x2715</span></div></div><md-divider \nclass=\"mb-2\"></md-divider><div layout=\"row\" layout-align=\"space-between center\"><md-input-container flex=\"60\" \nclass=\"input-box info-form-item small-input-box purchase-step-payment-input-box\"><input type=\"text\" autocorrect=\"off\" \nautocapitalize=\"none\" spellcheck=\"false\" name=\"description\" ng-model=\"vm.description\" autocomplete=\"off\" \nplaceholder=\"Description\"></md-input-container><md-input-container flex=\"30\" \nclass=\"input-box info-form-item small-input-box purchase-step-payment-input-box\"><input type=\"text\" autocorrect=\"off\" \nautocapitalize=\"none\" spellcheck=\"false\" name=\"Amount\" ng-model=\"vm.amount\" autocomplete=\"off\" placeholder=\"Amount\" \nmaxlength=\"10\" input-control input-translate=\"vm.translateToDollar\"></md-input-container><div flex=\"10\"><span \nclass=\"badge mx-0\" ng-class=\"vm.isProcessingData? [\'badge-info\']:[\'badge-secondary\']\" \nng-click=\"vm.isProcessingData? null:vm.addDisclosure()\">Add</span></div></div>");
$templateCache.put("app/main/purchase-info/components/purchase-info-form.html","<form name=\"purchaseInfoForm\" style=\"font-size: 13px\"><div layout=\"row\"><md-input-container flex=\"50\" \nclass=\"info-form-item small-input-box purchase-step-payment-input-box\"><label>Purchase Date:</label><md-datepicker \nrequired md-hide-icons=\"calendar\" ng-model=\"vm.purchaseDatePickerValue\" \nng-change=\"vm.setPurchaseDate(vm.purchaseDatePickerValue)\" name=\"purchaseDate\"></md-datepicker><div \nng-messages=\"purchaseInfoForm.purchaseDate.$error\"><div ng-message=\"valid\">Invalid date.</div><div \nng-message=\"required\">This field is required.</div></div></md-input-container><div layout=\"row\" flex=\"50\" \nlayout-align=\"space-between center\"><div ng-class=\"vm.purchaseInfo.is_canceled? [\'text-red\']:[]\">Is Canceled:</div>\n<md-checkbox flex ng-model=\"vm.purchaseInfo.is_canceled\" class=\"my-0 py-0 ml-3\" \nng-class=\"vm.purchaseInfo.is_canceled? [\'md-warn\']:[]\"></md-checkbox></div></div><div layout=\"row\"><md-input-container \nflex=\"50\" class=\"input-box info-form-item small-input-box purchase-step-payment-input-box\"><input type=\"text\" \nautocorrect=\"off\" autocapitalize=\"none\" spellcheck=\"false\" name=\"vendorSeller\" \nng-model=\"vm.purchaseInfo.vendor_seller\" autocomplete=\"off\" placeholder=\"Vendor Seller\" maxlength=\"250\"><div \nng-messages=\"purchaseInfoForm.vendorSeller.$error\"><div ng-message=\"maxlength\">\nInput content can not be over 250 charactors</div></div></md-input-container><md-select \nclass=\"md-no-underline simple-border small-selector purchase-step-selector\" ng-model=\"vm.purchaseInfo.fk_id_auction\" \nplaceholder=\"Auction\"><md-option ng-repeat=\"auction in vm.auctions\" value=\"{{::auction.id_auction}}\">\n{{::auction.auction_name}}</md-option></md-select></div><div layout=\"row\"><md-input-container flex=\"50\" \nclass=\"input-box info-form-item small-input-box purchase-step-payment-input-box\"><input type=\"text\" autocorrect=\"off\" \nautocapitalize=\"none\" spellcheck=\"false\" name=\"checkNumber\" ng-model=\"vm.purchaseInfo.check_number\" autocomplete=\"off\" \nplaceholder=\"Check Number\" maxlength=\"10\"><div ng-messages=\"purchaseInfoForm.checkNumber.$error\"><div \nng-message=\"maxlength\">Input content can not be over 10 charactors</div></div></md-input-container></div><div \nlayout=\"row\"><md-input-container flex=\"50\" \nclass=\"input-box info-form-item small-input-box purchase-step-payment-input-box\"><input type=\"text\" autocorrect=\"off\" \nautocapitalize=\"none\" spellcheck=\"false\" name=\"licensePlate\" ng-model=\"vm.purchaseInfo.license_plate\" \nautocomplete=\"off\" placeholder=\"License Plate\" maxlength=\"10\"><div ng-messages=\"purchaseInfoForm.licensePlate.$error\">\n<div ng-message=\"maxlength\">Input content can not be over 10 charactors</div></div></md-input-container>\n<md-input-container flex=\"50\" class=\"input-box info-form-item small-input-box purchase-step-payment-input-box pr-0\">\n<input type=\"text\" autocorrect=\"off\" autocapitalize=\"none\" spellcheck=\"false\" name=\"mileage\" \nng-model=\"vm.purchaseInfo.mileage\" autocomplete=\"off\" placeholder=\"Mileage\" ng-pattern=\"/^[0-9]*$/\" maxlength=\"10\"><div\n ng-messages=\"purchaseInfoForm.mileage.$error\"><div ng-message=\"maxlength\">Input content can not be over 10 charactors\n</div><div ng-message=\"pattern\">Only number accepted</div></div></md-input-container></div><div layout=\"row\"><table \nclass=\"table table-hover\" style=\"table-layout: fixed; width: 100%; min-width: 500px\"><thead><tr><th \nclass=\"text-nowrap bg-light\" style=\"width: 15%\"></th><th class=\"text-nowrap bg-light\" style=\"width: 20%\">Cost Type</th>\n<th class=\"text-nowrap bg-light\" style=\"width: 35%\">Description</th><th class=\"text-nowrap bg-light\" \nstyle=\"width: 15%\">Amount</th><th class=\"text-nowrap bg-light\" style=\"width: 15%\">Rate</th></tr></thead><tbody \nclass=\"bg-white\"><tr ng-repeat=\"price in vm.purchaseInfoPrice track by $index\" tabindex=\"-1\" ng-blur=\"vm.onRowBlur()\" \nid=\"{{\'laborRow\' + $index}}\" name=\"{{\'labourTableRow\' + $index}}\"><td><div layout=\"row\"><md-button \nclass=\"md-icon-button\" ng-click=\"vm.removePurchaseInfoPrice(price, $index)\" ng-disable=\"vm.isProcessingData\"><md-icon \nclass=\"icon-trash text-red tabbable-button\"></md-icon></md-button></div></td><td><md-input-container \nclass=\"input-box info-form-item small-input-box purchase-step-payment-input-box\" style=\"margin-top: 0px\"><md-select \nng-model=\"price.fk_id_price_type\" placeholder=\"Cost Type\" ng-change=\"vm.onPriceTypRoweChange(price)\"><md-option \nng-repeat=\"price_type in vm.purchaseInfoPriceType\" ng-value=\"price_type.id_price_type\">{{price_type.text_column}}\n</md-option></md-select></md-input-container></td><td style=\"position: relative\"><md-input-container \nclass=\"input-box info-form-item small-input-box purchase-step-payment-input-box\"><input class=\"bg-white\" \nng-disabled=\"!price.editable\" type=\"text\" autocorrect=\"off\" autocapitalize=\"none\" spellcheck=\"false\" \nname=\"Description\" ng-model=\"price.description\" autocomplete=\"off\" maxlength=\"250\"><div \nng-messages=\"purchaseInfoForm.Description.$error\"><div ng-message=\"maxlength\">\nInput content cannot be over 250 characters</div></div></md-input-container><div \nstyle=\"position: absolute; bottom: 0%; font-size: 12px\" class=\"text-red\" ng-if=\"!price.description\">Required</div></td>\n<td style=\"position: relative\"><md-input-container \nclass=\"input-box info-form-item small-input-box purchase-step-payment-input-box\"><input class=\"bg-white\" type=\"text\" \nautocorrect=\"off\" autocapitalize=\"none\" spellcheck=\"false\" name=\"Price\" ng-model=\"price.amount\" autocomplete=\"off\" \nmaxlength=\"10\" input-control input-translate=\"vm.translateToDollar\"></md-input-container><div \nstyle=\"position: absolute; bottom: 0%; font-size: 12px\" class=\"text-red\" ng-if=\"price.amount == null\">Required</div>\n</td><td style=\"position: relative\"><md-input-container \nclass=\"input-box info-form-item small-input-box purchase-step-payment-input-box\"><input class=\"bg-white\" type=\"text\" \nautocorrect=\"off\" autocapitalize=\"none\" spellcheck=\"false\" name=\"priceRate\" ng-model=\"price.rate\" autocomplete=\"off\" \nmaxlength=\"9\" input-control input-translate=\"vm.translateToPercentage\" input-options=\"vm.taxRateInputOption\" \nstep=\"0.001\" min=\"0\" max=\"1\"></md-input-container><div style=\"position: absolute; bottom: 0%; font-size: 12px\" \nclass=\"text-red\" ng-if=\"price.rate == null\">Required</div></td></tr></tbody></table></div><div layout=\"row\" \nlayout-align=\"center center\"><md-button class=\"md-icon-button\" ng-click=\"vm.AddPurchaseInfoPriceRow()\" \nng-disable=\"vm.isProcessingData\"><md-icon class=\"icon-plus-circle text-black tabbable-button\"></md-icon></md-button>\n</div><md-divider class=\"my-10\"></md-divider><div layout=\"row\"><div flex=\"100\" layout=\"row\" layout-wrap><div \nflex-gt-sm=\"50\" layout=\"column\" class=\"content-padding-half\"><div>Notes:</div><textarea rows=\"9\" \nng-model=\"vm.purchaseInfo.notes\" class=\"info-form-item detail-info-form-note-input\">\r\n				</textarea></div></div></div>\n</form>");
$templateCache.put("app/main/purchase-info/edit-purchase-info/edit-purchase-info.html","<div class=\"page-layout carded fullwidth single-scroll\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"column\"><div layout=\"row\"><span class=\"h2 white-fg\">\nEdit Purchase Info</span><md-button class=\"btn btn-danger\" ng-click=\"vm.deletePurchaseInfo()\" \nng-disabled=\"vm.isProcessingData\">delete</md-button></div><h6><a class=\"badge badge-primary\" \nhref=\"{{::vm.vehiclePageUrl}}\">{{::vm.vehicle.getYearMakeModel()}}</a></h6></div><div \nclass=\"content-card page-content-container\" layout=\"column\" flex><md-content class=\"content\" flex ms-scroll><div \nlayout=\"column\" layout-gt-sm=\"row\" layout-align-gt-sm=\"space-between start\"><div flex=\"100\" flex-gt-sm=\"60\"><div \nclass=\"mb-10\"><purchase-info-form vehicle-id=\"vm.vehicle.getResourceID()\" purchase-info=\"vm.purchaseInfo\" \nauctions=\"vm.auctions\" is-form-valid=\"vm.isPurchaseInfoFormValid\" purchase-info-price-type=\"vm.purchaseInfoPriceType\" \npurchase-info-price=\"vm.purchaseInfoPrice\" create-purchase-info-price=\"vm.createPurchaseInfoPrice\" \ndelete-purchase-info-price=\"vm.deletePurchaseInfoPrice\" update-purchase-info-price=\"vm.updatePurchaseInfoPrice\" \nadding-purchase-info=\"false\" , processing-data=\"vm.isProcessingData\"></purchase-info-form></div><div class=\"mb-10\">\nDisclosures:<purchase-disclosure-list disclosures=\"vm.disclosures\" on-disclosure-added=\"vm.onDisclosureAdded\" \non-disclosure-removed=\"vm.onDisclosureRemoved\" clean-new-disclouser=\"vm.cleanNewDisclouser\" \nis-processing-data=\"vm.isProcessingData\"></purchase-disclosure-list>Previous Disclosures:<md-divider></md-divider><div \nclass=\"px-2 pt-2\"><div class=\"mb-2\" ng-if=\"!(vm.allDisclosures.length > 0) && !vm.isFetchingDisclosures\">\nNo previous disclosure</div><div ng-repeat=\"data in vm.allDisclosures\" class=\"mb-2\"><a \nng-href=\"{{vm.getPurchaseInfoUrl(data.purchaseInfo.getResourceID())}}\">{{data.purchaseInfo.purchase_date}}</a><div \nng-repeat=\"disclosure in data.disclosures\" layout=\"row\" layout-align=\"space-between center\"><div>\n{{disclosure.description}}</div><div>{{disclosure.amount | currency:\'$\'}}</div></div></div></div><md-divider>\n</md-divider></div><div class=\"mb-10\">Files:<file-section uploaded-files=\"vm.purchaseInfoFiles\" \nfile-uploader=\"vm.purchaseInfoFileUploader\" on-file-delete=\"vm.onFileDelete\" is-processing-data=\"vm.isDeletingFile\">\n</file-section></div></div><purchase-cost-summary flex=\"100\" flex-gt-sm=\"25\" purchase-info=\"vm.purchaseInfo\" \ntasks=\"vm.tasks\" workorder-list=\"vm.workorderList\" purchase-info-price=\"vm.purchaseInfoPrice\"></purchase-cost-summary>\n</div><md-button class=\"btn-secondary mx-0\" ng-click=\"vm.updatePurchaseInfo()\">Update</md-button></md-content></div>\n</div></div><img id=\"safetyReportPatternPage\" style=\"display:none\" src=\"assets/images/safetyreport/page_1.jpg\" \ncrossorigin=\"anonymous\">");
$templateCache.put("app/main/purchase-invoice/browse-purchase-invoices/browse-purchase-invoices.html","<div class=\"page-layout carded fullwidth single-scroll\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\" layout=\"column\" flex><div class=\"header\"><span class=\"h2 white-fg\">Browse Invoices</span></div><div \nclass=\"content-card page-content-container\" layout=\"column\" flex><md-content class=\"content\" flex ms-scroll><div \nlayout=\"row\" layout-wrap><div flex=\"100\" flex-gt-md=\"66\" layout=\"row\" layout-wrap><md-input-container flex=\"50\" \nflex-gt-sm=\"25\" class=\"input-box-padding\"><input ng-model=\"vm.invoiceSearchText\" ng-model-options=\"{ debounce: 700 }\" \nplaceholder=\"invoice number\" ng-change=\"vm.refreshInvoiceList(1)\" autocomplete=\"off\"></md-input-container>\n<md-input-container flex=\"50\" flex-gt-sm=\"25\" class=\"input-box-padding\"><label>Supplier</label><md-select \nng-model=\"vm.supplierFilter\" ng-change=\"vm.refreshInvoiceList(1)\"><md-option \nng-repeat=\"supplier in vm.suppliers | orderBy:\'name\'\" ng-value=\"supplier.id_supplier\">{{supplier.name}}</md-option>\n<md-option ng-value=\"undefined\">All</md-option></md-select></md-input-container><form name=\"datePickerForm\" flex=\"100\" \nflex-gt-sm=\"50\" layout=\"row\"><md-input-container flex class=\"small-input-box\"><label>From</label><md-datepicker \nmd-hide-icons=\"calendar\" ng-model=\"vm.startDateFilter\" md-max-date=\"vm.endDateFilter\" \nng-change=\"vm.refreshInvoiceList(1)\" name=\"startDate\"></md-datepicker><div \nng-messages=\"datePickerForm.startDate.$error\"><div ng-message=\"valid\">Invalid date.</div><div ng-message=\"maxdate\">\nMust before end date</div></div></md-input-container><md-input-container flex class=\"small-input-box\"><label>To</label>\n<md-datepicker md-hide-icons=\"calendar\" ng-model=\"vm.endDateFilter\" md-min-date=\"vm.startDateFilter\" \nng-change=\"vm.refreshInvoiceList(1)\" name=\"endDate\"></md-datepicker><div ng-messages=\"datePickerForm.endDate.$error\">\n<div ng-message=\"valid\">Invalid date.</div><div ng-message=\"mindate\">Must after start date</div></div>\n</md-input-container></form></div><div flex=\"100\" flex-gt-md=\"33\" layout=\"row\" layout-align=\"start center\"><div \nclass=\"mb-3 text-blue\" ng-click=\"vm.showPartFilters = !vm.showPartFilters\">\n{{vm.showPartFilters? \"Hide Part filters\" : \"Show Part filters\"}}</div></div></div><div layout=\"row\" \nng-if=\"vm.showPartFilters\"><div flex=\"100\" flex-gt-md=\"66\" layout=\"row\" layout-wrap><md-input-container flex=\"50\" \nflex-gt-sm=\"25\" class=\"input-box-padding\"><label>Preset Part</label><md-select ng-model=\"vm.inventoryTypeFilter\" \nng-change=\"vm.refreshInvoiceList(1)\"><md-option ng-repeat=\"partType in vm.inventoryTypes | orderBy:\'name\'\" \nng-value=\"partType.id_part_type\">{{partType.name}}</md-option><md-option ng-value=\"undefined\">All</md-option>\n</md-select></md-input-container><md-input-container flex=\"50\" flex-gt-sm=\"25\" class=\"input-box-padding\"><input \nng-model=\"vm.nameSearchText\" ng-model-options=\"{ debounce: 700 }\" placeholder=\"Part Name\" \nng-change=\"vm.refreshInvoiceList(1)\" autocomplete=\"off\"></md-input-container><md-input-container flex=\"50\" \nflex-gt-sm=\"25\" class=\"input-box-padding\"><input ng-model=\"vm.codeSearchText\" ng-model-options=\"{ debounce: 700 }\" \nplaceholder=\"Part Code\" ng-change=\"vm.refreshInvoiceList(1)\" autocomplete=\"off\"></md-input-container></div></div><br>\n<div layout=\"row\" layout-align=\"space-around start\" flex=\"50\"><label><input type=\"radio\" name=\"options\" value=\"order\" \nng-model=\"filtertracker\" ngclick=\"refreshInvoiceList(vm.currentPage)\"> Total Ordered (${{vm.totalOrder.toFixed(2)}})\n</label><label><input type=\"radio\" name=\"options\" value=\"return\" ng-model=\"filtertracker\" \nngclick=\"refreshInvoiceList(vm.currentPage)\"> Total Return (${{vm.totalReturn.toFixed(2)}})</label><label><input \ntype=\"radio\" name=\"options\" value=\"outstanding\" ng-model=\"filtertracker\" ngclick=\"refreshInvoiceList(vm.currentPage)\">\n Total Outstanding (${{vm.totaloutstanding.toFixed(2)}})</label><div><button type=\"submit\" class=\"btn bg-blue\" \nstyle=\"width: 15rem\" ng-click=\"vm.clearSelection()\">Clear Filter</button></div><div></div></div><purchase-invoice-list \npurchase-invoice-list=\"vm.filterPurchaseInoviceList\" suppliers=\"vm.suppliers\" sort-by=\"vm.sortBy\" \nsort-direction=\"vm.sortDirection\" on-sorting-changed=\"vm.onSortingChanged\" invoice-part-list=\"vm.invoicePartList\">\n</purchase-invoice-list><div layout=\"row\" layout-padding layout-align=\"end center\"><pagination \nitem-per-page=\"vm.itemsPerPage\" current-page=\"vm.currentPage\" total-count=\"vm.totalCount\" \non-page-change=\"vm.refreshInvoiceList\"></pagination><div>Total Item: {{vm.totalCount}}</div><div>\nOn Page Item: {{vm.filterPurchaseInoviceList.length}}</div><div>Display:</div><md-select \nng-change=\"vm.refreshInvoiceList(1)\" ng-model=\"vm.itemsPerPage\" placeholder=\"Display\"><md-option \nng-repeat=\"option in vm.displayOptions\" ng-value=\"option\">{{option}}</md-option></md-select></div></md-content></div>\n</div></div>");
$templateCache.put("app/main/purchase-invoice/components/invoice-summary.html","<div class=\"card\" style=\"font-size: 13px\"><div class=\"card-header py-1 bg-black\"><div \nclass=\"text-white font-weight-bold\">Summary</div></div><div class=\"card-body\"><div class=\"mt-3\" \nng-if=\"vm.partList.length > 0 && !vm.isAllPartsReturned()\"><div class=\"font-weight-bold\">Parts</div><div layout=\"row\" \nlayout-align=\"end center\" style=\"font-size: 10px\" class=\"text-grey\"><div flex=\"25\" class=\"text-nowrap text-truncate\">\nCost</div><div flex=\"25\" class=\"text-right text-nowrap text-truncate\">Retail</div></div><md-divider class=\"mb-1\">\n</md-divider><div layout=\"row\" layout-align=\"start center\" ng-repeat=\"partItem in vm.partList track by $index\" \nng-class=\"partItem.is_returned && !vm.isReturnedInvoice ? [\'strike\'] : []\"><div flex=\"10\" \nclass=\"text-nowrap text-truncate\">{{partItem.quantity}}</div><div flex=\"40\" class=\"text-nowrap text-truncate\">\n{{partItem.name}}</div><div flex=\"25\" class=\"text-nowrap text-truncate\">\n{{partItem.purchase_price * partItem.quantity | currency:\'$\':2}}</div><div flex=\"25\" \nclass=\"text-nowrap text-truncate text-right\">{{partItem.retail_price * partItem.quantity | currency:\'$\':2}}</div></div>\n<md-divider class=\"my-1\"></md-divider><div layout=\"row\" layout-align=\"end center\"><div flex=\"25\" \nclass=\"text-nowrap text-truncate\">{{vm.totalPartsCost | currency:\'$\':2}}</div><div flex=\"25\" \nclass=\"text-right text-nowrap text-truncate\">{{vm.totalPartsRetail | currency:\'$\':2}}</div></div></div></div></div>");
$templateCache.put("app/main/purchase-invoice/components/purchase-invoice-cost-list.html","<head><style>\n/* Hide the list by default */\r\n		#item-list {\r\n			display: none;\r\n		}\r\n\r\n		/* Style for the clickable tab */\r\n		.tab {\r\n			background-color: #f2f2f2;\r\n			border: 1px solid #ccc;\r\n			cursor: pointer;\r\n			padding: 10px;\r\n			width: 100%;\r\n		}\r\n\r\n		/* Style for the active tab */\r\n		.tab.active {\r\n			background-color: #ddd;\r\n		}\n</style></head><div class=\"tab\" ng-click=\"vm.toggleItemList()\">$Total Ordered (${{vm.invoiceTotalCost.toFixed(2)}})\n</div><ul id=\"item-list\"><li ng-repeat=\"invoice in vm.purchaseInvoiceList\"><a \nng-href=\"{{vm.getInvoicePageUrl(invoice)}}\">{{invoice.invoice_number}} </a>Cost: ${{invoice.totalcost}}</li></ul>");
$templateCache.put("app/main/purchase-invoice/components/purchase-invoice-info-form.html","<form name=\"purchaseInvoiceInfoForm\" layout=\"row\" layout-wrap><md-input-container flex=\"33\" \nclass=\"input-box small-input-box input-box-padding\"><label>Supplier</label><md-select \nng-model=\"vm.purchaseInvoice.fk_id_supplier\" ng-required=\"true\" ng-model-options=\"{allowInvalid: true}\" input-control \ncustom-async-validations=\"vm.suppplierValidation\" name=\"supplier\" ng-disabled=\"vm.isProcessingData\"><md-option \nng-repeat=\"supplier in vm.suppliers | orderBy:\'name\'\" ng-value=\"supplier.id_supplier\">{{supplier.name}}</md-option>\n</md-select><div ng-messages=\"purchaseInvoiceInfoForm.supplier.$error\"><div ng-message=\"required\">\nThis field is required</div><div ng-message=\"{{::vm.duplicateValidatorName}}\">Invoice is already in the system ! <a \nng-href=\"{{vm.getPurchaseInvoicePageUrl()}}\">view invoice.</a></div><div \nng-if=\"purchaseInvoiceInfoForm.supplier.$pending\" class=\"text-blue\" style=\"font-size: 13px\">\nchecking if invoice exist...</div></div></md-input-container><md-input-container flex=\"33\" \nclass=\"input-box small-input-box input-box-padding\"><input ng-required=\"true\" name=\"invoiceNumber\" \nng-model=\"vm.purchaseInvoice.invoice_number\" autocomplete=\"off\" placeholder=\"Invoice Number\" maxlength=\"100\" \nng-pattern=\"vm.invoiceNumberPattern\" ng-disabled=\"vm.isProcessingData\" \nng-model-options=\"{debounce: 700, allowInvalid: true}\" input-control \ncustom-async-validations=\"vm.invoiceNumberValidation\"><div ng-messages=\"purchaseInvoiceInfoForm.invoiceNumber.$error\" \nmultiple=\"multiple\"><div ng-message=\"maxlength\">Input content can not be over 50 charactors</div><div \nng-message=\"required\">This field is required</div><div ng-message=\"pattern\">Contains invalid character</div><div \nng-message=\"{{::vm.duplicateValidatorName}}\">Invoice is already in the system ! <a \nng-href=\"{{vm.getPurchaseInvoicePageUrl()}}\">view invoice.</a></div><div \nng-if=\"purchaseInvoiceInfoForm.invoiceNumber.$pending\" class=\"text-blue\" style=\"font-size: 13px\">\nchecking if invoice exist...</div></div></md-input-container><md-input-container flex=\"33\" \nclass=\"input-box small-input-box input-box-padding\"><label>Purchase Date</label><md-datepicker \nng-disabled=\"vm.isProcessingData\" md-hide-icons=\"calendar\" ng-model=\"vm.datePickerValue\" \nng-change=\"vm.setPurchaseDate()\" name=\"purchaseDate\"></md-datepicker><div \nng-messages=\"purchaseInvoiceInfoForm.purchaseDate.$error\"><div ng-message=\"valid\">Invalid date.</div></div>\n</md-input-container></form>");
$templateCache.put("app/main/purchase-invoice/components/purchase-invoice-list.html","<table flex class=\"table table-hover table-responsive\" style=\"table-layout: fixed\"><thead><tr class=\"text-nowrap\"><th \nng-click=\"vm.changeSorting(vm.sortTagInvoiceNumber)\">Invoice Number<md-icon \nng-style=\"{visibility: vm.sortBy == vm.sortTagInvoiceNumber? \'visible\':\'hidden\'}\" \nng-class=\"vm.sortDirection == vm.directionDesc? [\'icon-chevron-up\']:[\'icon-chevron-down\']\"></md-icon></th><th \nng-click=\"vm.changeSorting(vm.sortTagDate)\">Purchase Date<md-icon \nng-style=\"{visibility: vm.sortBy == vm.sortTagDate? \'visible\':\'hidden\'}\" \nng-class=\"vm.sortDirection == vm.directionDesc? [\'icon-chevron-up\']:[\'icon-chevron-down\']\"></md-icon></th><th \nng-click=\"vm.changeSorting(vm.sortTagSupplier)\">Supplier<md-icon \nng-style=\"{visibility: vm.sortBy == vm.sortTagSupplier? \'visible\':\'hidden\'}\" \nng-class=\"vm.sortDirection == vm.directionDesc? [\'icon-chevron-up\']:[\'icon-chevron-down\']\"></md-icon></th><th>\nTotal cost before tax</th><th>Total cost after tax</th></tr></thead><tbody><tr \nng-repeat=\"invoice in vm.purchaseInvoiceList\" class=\"text-nowrap\"><td><a ng-href=\"{{vm.getInvoicePageUrl(invoice)}}\">\n{{invoice.invoice_number}}</a></td><td>{{invoice.purchase_date}}</td><td>{{vm.getSupplierName(invoice.fk_id_supplier)}}\n</td><td>{{invoice.totalcost || 0 | currency:vm.currencySymbol}}</td><td>\n{{invoice.totalcost * 1.13 || 0 | currency:vm.currencySymbol}}</td></tr><tr \nng-if=\"!(vm.purchaseInvoiceList.length > 0)\"><td>No Invoice Found</td></tr></tbody></table>");
$templateCache.put("app/main/purchase-invoice/components/purchase-invoice-outstanding-list.html","<head><style>\n/* Hide the list by default */\r\n		#item-outstanding-list {\r\n			display: none;\r\n		}\r\n\r\n		/* Style for the clickable tab */\r\n		.tab {\r\n			background-color: #f2f2f2;\r\n			border: 1px solid #ccc;\r\n			cursor: pointer;\r\n			padding: 10px;\r\n			width: 100%;\r\n		}\r\n\r\n		/* Style for the active tab */\r\n		.tab.active {\r\n			background-color: #ddd;\r\n		}\n</style></head><div class=\"tab\" ng-click=\"vm.toggleItemList()\">$Total Outstanding (${{vm.invoiceTotalCost.toFixed(2)}})\n</div><ul id=\"item-outstanding-list\"><li ng-repeat=\"invoice in vm.purchaseInvoiceList\"><a \nng-href=\"{{vm.getInvoicePageUrl(invoice)}}\">{{invoice.invoice_number}} </a>Cost: ${{invoice.totalcost}}</li></ul>");
$templateCache.put("app/main/purchase-invoice/components/purchase-invoice-return-list.html","<head><style>\n/* Hide the list by default */\r\n		#item-return-list {\r\n			display: none;\r\n		}\r\n\r\n		/* Style for the clickable tab */\r\n		.tab {\r\n			background-color: #f2f2f2;\r\n			border: 1px solid #ccc;\r\n			cursor: pointer;\r\n			padding: 10px;\r\n			width: 100%;\r\n		}\r\n\r\n		/* Style for the active tab */\r\n		.tab.active {\r\n			background-color: #ddd;\r\n		}\n</style></head><div class=\"tab\" ng-click=\"vm.toggleItemList()\">$Total Return (${{vm.invoiceTotalCost.toFixed(2)}})\n</div><ul id=\"item-return-list\"><li ng-repeat=\"invoice in vm.purchaseInvoiceList\"><a \nng-href=\"{{vm.getInvoicePageUrl(invoice)}}\">{{invoice.invoice_number}} </a>Cost: ${{invoice.totalcost}}</li></ul>");
$templateCache.put("app/main/purchase-invoice/edit-purchase-invoice/edit-purchase-invoice.html","<div style=\"width: 100%\" class=\"bg-secondary header-backgroud\" layout=\"row\" layout-align=\"center center\"><div flex \nclass=\"content-max-width content-padding-x-full\"><div layout=\"row\" layout-align=\"start center\"><span \nclass=\"h2 white-fg\">Edit Purchase Invoice</span></div><div layout=\"row\" layout-align=\"end center\"><button \nng-click=\"vm.deletePurchaseInvoice()\" ng-disabled=\"vm.isSaving || vm.isDeleting\"><i class=\"icon-delete-forever\" \nng-class=\"vm.isSaving || vm.isDeletingParts || vm.isDeleting ? [\'text-grey\'] : [\'text-red\']\"></i></button></div></div>\n</div><div style=\"width: 100%\" layout=\"row\" layout-align=\"center start\"><div flex class=\"content-max-width\" \nlayout=\"row\" layout-wrap layout-padding><div flex=\"100\" flex-gt-sm=\"75\"><div layout=\"row\" class=\"mb-5\">\n<purchase-invoice-info-form flex=\"100\" flex-gt-sm=\"50\" origin-invoice=\"vm.originPurchaseInvoice\" \npurchase-invoice=\"vm.purchaseInvoice\" suppliers=\"vm.suppliers\" is-processing-data=\"vm.isSaving || vm.isDeleting\" \nis-form-valid=\"vm.isPurchaseInfoFormValid\"></purchase-invoice-info-form></div><h6>Parts</h6><md-content><parts-table \ndisable-select=\"vm.isSaving || vm.isDeletingParts || vm.isDeleting\" \ndisable-editing=\"vm.isSaving || vm.isDeletingParts || vm.isDeleting\" \ndisable-adding=\"vm.isSaving || vm.isDeletingParts || vm.isDeleting\" part-list=\"vm.partList\" suppliers=\"vm.suppliers\" \ntypes=\"vm.partTypes\" return-invoice-map=\"vm.returnInvoiceMap\" matched-inventories=\"vm.matchedInventories\" \non-part-match-inventory=\"vm.pullDataFromInventory\" on-add-new-part=\"vm.addNewPart\" hidden-columns=\"vm.hiddenColumns\" \ntabs=\"vm.partTableTabs\" current-tab-index=\"vm.currentPartTableTabIndex\" on-tab-change=\"vm.onPartTableTabChange\" \ninvoice-map=\"vm.invoiceMap\" is-form-valid=\"vm.isPartTableValid\" is-from-purchase-invoice=\"true\"></parts-table>\n</md-content><div layout=\"row\" layout-wrap class=\"mt-2\"><div flex=\"100\" flex-gt-sm=\"50\" flex-order=\"2\" \nflex-order-gt-sm=\"1\"><button ng-disabled=\"!vm.isAnyPartSelected() || vm.isSaving || vm.isDeleting\" \nng-click=\"vm.removeSelectedParts()\"><i class=\"icon-delete-forever\" \nng-class=\"(!vm.isAnyPartSelected() || vm.isSaving || vm.isDeleting ) ? [\'\']:[\'text-red\']\"></i></button></div></div><h6 \nclass=\"mt-10\">Files</h6><md-divider class=\"mb-3\"></md-divider><file-section-preview \nis-processing-data=\"vm.isDeletingFile || vm.isSaving || vm.isDeleting\" on-file-delete=\"vm.onFileDelete\" \nfile-uploader=\"vm.fileUploader\" file-list=\"vm.fileList\"></file-section-preview><md-button \nclass=\"btn btn-secondary mx-0\" ng-disabled=\"vm.isSaving || vm.isDeletingParts || vm.isDeleting\" ng-click=\"vm.save()\">\nsave</md-button></div><div flex=\"100\" flex-gt-sm=\"25\"><div class=\"sticky\"><purchase-invoice-summary \nis-returned-invoice=\"false\" part-list=\"vm.summaryPartList\"></purchase-invoice-summary></div></div></div></div>");
$templateCache.put("app/main/return-invoice/components/return-invoice-info-form.html","<form name=\"returnInvoiceInfoForm\" layout=\"row\" layout-wrap><md-input-container flex=\"33\" \nclass=\"input-box small-input-box input-box-padding\"><label>Supplier</label><md-select \nng-model=\"vm.returnInvoice.fk_id_supplier\" ng-required=\"true\" ng-model-options=\"{allowInvalid: true}\" input-control \ncustom-async-validations=\"vm.suppplierValidation\" name=\"supplier\" ng-disabled=\"vm.isProcessingData\"><md-option \nng-repeat=\"supplier in vm.suppliers | orderBy:\'name\'\" ng-value=\"supplier.id_supplier\">{{supplier.name}}</md-option>\n</md-select><div ng-messages=\"returnInvoiceInfoForm.supplier.$error\"><div ng-message=\"required\">This field is required\n</div><div ng-message=\"{{::vm.duplicateValidatorName}}\">Invoice is already in the system ! <a \nng-href=\"{{vm.getReturnInvoicePageUrl()}}\">view invoice.</a></div><div ng-if=\"returnInvoiceInfoForm.supplier.$pending\" \nclass=\"text-blue\" style=\"font-size: 13px\">checking if invoice exist...</div></div></md-input-container>\n<md-input-container flex=\"33\" class=\"input-box small-input-box input-box-padding\"><input ng-required=\"true\" \nname=\"invoiceNumber\" ng-model=\"vm.returnInvoice.invoice_number\" autocomplete=\"off\" placeholder=\"Invoice Number\" \nmaxlength=\"100\" ng-pattern=\"vm.invoiceNumberPattern\" ng-disabled=\"vm.isProcessingData\" \nng-model-options=\"{debounce: 700, allowInvalid: true}\" input-control \ncustom-async-validations=\"vm.invoiceNumberValidation\"><div ng-messages=\"returnInvoiceInfoForm.invoiceNumber.$error\" \nmultiple=\"multiple\"><div ng-message=\"maxlength\">Input content can not be over 50 charactors</div><div \nng-message=\"required\">This field is required</div><div ng-message=\"pattern\">Contains invalid character</div><div \nng-message=\"{{::vm.duplicateValidatorName}}\">Invoice is already in the system ! <a \nng-href=\"{{vm.getReturnInvoicePageUrl()}}\">view invoice.</a></div><div \nng-if=\"returnInvoiceInfoForm.invoiceNumber.$pending\" class=\"text-blue\" style=\"font-size: 13px\">\nchecking if invoice exist...</div></div></md-input-container><md-input-container flex=\"33\" \nclass=\"input-box small-input-box input-box-padding\"><label>Return Date</label><md-datepicker \nng-disabled=\"vm.isProcessingData\" md-hide-icons=\"calendar\" ng-model=\"vm.datePickerValue\" \nng-change=\"vm.setReturnDate()\" name=\"returnDate\"></md-datepicker><div \nng-messages=\"returnInvoiceInfoForm.returnDate.$error\"><div ng-message=\"valid\">Invalid date.</div></div>\n</md-input-container></form>");
$templateCache.put("app/main/return-invoice/components/return-invoice-list.html","<table flex class=\"table table-hover table-responsive\" style=\"table-layout: fixed\"><thead><tr class=\"text-nowrap\"><th \nng-click=\"vm.changeSorting(vm.sortTagInvoiceNumber)\">Invoice Number<md-icon \nng-style=\"{visibility: vm.sortBy == vm.sortTagInvoiceNumber? \'visible\':\'hidden\'}\" \nng-class=\"vm.sortDirection == vm.directionDesc? [\'icon-chevron-up\']:[\'icon-chevron-down\']\"></md-icon></th><th \nng-click=\"vm.changeSorting(vm.sortTagDate)\">Return Date<md-icon \nng-style=\"{visibility: vm.sortBy == vm.sortTagDate? \'visible\':\'hidden\'}\" \nng-class=\"vm.sortDirection == vm.directionDesc? [\'icon-chevron-up\']:[\'icon-chevron-down\']\"></md-icon></th><th \nng-click=\"vm.changeSorting(vm.sortTagSupplier)\">Supplier<md-icon \nng-style=\"{visibility: vm.sortBy == vm.sortTagSupplier? \'visible\':\'hidden\'}\" \nng-class=\"vm.sortDirection == vm.directionDesc? [\'icon-chevron-up\']:[\'icon-chevron-down\']\"></md-icon></th></tr></thead>\n<tbody><tr ng-repeat=\"invoice in vm.returnInvoiceList\" class=\"text-nowrap\"><td><a \nng-href=\"{{vm.getInvoicePageUrl(invoice)}}\">{{invoice.invoice_number}}</a></td><td>{{invoice.return_date}}</td><td>\n{{vm.getSupplierName(invoice.fk_id_supplier)}}</td></tr><tr ng-if=\"!(vm.returnInvoiceList.length > 0)\"><td>\nNo Invoice Found</td></tr></tbody></table>");
$templateCache.put("app/main/return-invoice/browse-return-invoices/browse-return-invoices.html","<div style=\"width: 100%\" class=\"bg-secondary header-backgroud\" layout=\"row\" layout-align=\"center center\"><div flex \nclass=\"content-max-width content-padding-x-full\"><div layout=\"row\" layout-align=\"start center\"><span \nclass=\"h2 white-fg\">Return Invoices</span></div></div></div><div style=\"width: 100%\" layout=\"row\" \nlayout-align=\"center start\"><div flex class=\"content-max-width\" layout-padding><div layout=\"row\" \nlayout-align=\"start center\" layout-wrap><div flex=\"100\" flex-gt-sm=\"50\" layout=\"row\" layout-wrap><md-input-container \nflex=\"50\" flex-gt-sm=\"25\" class=\"input-box-padding\"><input ng-model=\"vm.invoiceSearchText\" \nng-model-options=\"{ debounce: 700 }\" placeholder=\"invoice number\" ng-change=\"vm.refreshInvoiceList(1)\" \nautocomplete=\"off\"></md-input-container><md-input-container flex=\"50\" flex-gt-sm=\"25\" class=\"input-box-padding\"><label>\nSupplier</label><md-select ng-model=\"vm.supplierFilter\" ng-change=\"vm.refreshInvoiceList(1)\"><md-option \nng-repeat=\"supplier in vm.suppliers | orderBy:\'name\'\" ng-value=\"supplier.id_supplier\">{{supplier.name}}</md-option>\n<md-option ng-value=\"undefined\">All</md-option></md-select></md-input-container><form name=\"datePickerForm\" flex=\"100\" \nflex-gt-sm=\"50\" layout=\"row\"><md-input-container flex class=\"small-input-box\"><label>From</label><md-datepicker \nmd-hide-icons=\"calendar\" ng-model=\"vm.startDateFilter\" md-max-date=\"vm.endDateFilter\" \nng-change=\"vm.refreshInvoiceList(1)\" name=\"startDate\"></md-datepicker><div \nng-messages=\"datePickerForm.startDate.$error\"><div ng-message=\"valid\">Invalid date.</div><div ng-message=\"maxdate\">\nMust before end date</div></div></md-input-container><md-input-container flex class=\"small-input-box\"><label>To</label>\n<md-datepicker md-hide-icons=\"calendar\" ng-model=\"vm.endDateFilter\" md-min-date=\"vm.startDateFilter\" \nng-change=\"vm.refreshInvoiceList(1)\" name=\"endDate\"></md-datepicker><div ng-messages=\"datePickerForm.endDate.$error\">\n<div ng-message=\"valid\">Invalid date.</div><div ng-message=\"mindate\">Must after start date</div></div>\n</md-input-container></form></div><div flex=\"100\" flex-gt-sm=\"50\" class=\"mb-3 text-blue\" \nng-click=\"vm.showPartFilters = !vm.showPartFilters\">{{vm.showPartFilters? \"Hide Part filters\" : \"Show Part filters\"}}\n</div></div><div layout=\"row\" ng-if=\"vm.showPartFilters\"><div flex=\"100\" flex-gt-sm=\"50\" layout=\"row\" layout-wrap>\n<md-input-container flex=\"50\" flex-gt-sm=\"25\" class=\"input-box-padding\"><label>Preset Part</label><md-select \nng-model=\"vm.inventoryTypeFilter\" ng-change=\"vm.refreshInvoiceList(1)\"><md-option \nng-repeat=\"partType in vm.inventoryTypes | orderBy:\'name\'\" ng-value=\"partType.id_part_type\">{{partType.name}}\n</md-option><md-option ng-value=\"undefined\">All</md-option></md-select></md-input-container><md-input-container \nflex=\"50\" flex-gt-sm=\"25\" class=\"input-box-padding\"><input ng-model=\"vm.nameSearchText\" \nng-model-options=\"{ debounce: 700 }\" placeholder=\"Part Name\" ng-change=\"vm.refreshInvoiceList(1)\" autocomplete=\"off\">\n</md-input-container><md-input-container flex=\"50\" flex-gt-sm=\"25\" class=\"input-box-padding\"><input \nng-model=\"vm.codeSearchText\" ng-model-options=\"{ debounce: 700 }\" placeholder=\"Part Code\" \nng-change=\"vm.refreshInvoiceList(1)\" autocomplete=\"off\"></md-input-container></div></div><return-invoice-list \nreturn-invoice-list=\"vm.returnInoviceList\" suppliers=\"vm.suppliers\" sort-by=\"vm.sortBy\" \nsort-direction=\"vm.sortDirection\" on-sorting-changed=\"vm.onSortingChanged\"></return-invoice-list><div layout=\"row\" \nlayout-padding layout-align=\"end center\"><pagination item-per-page=\"vm.itemsPerPage\" current-page=\"vm.currentPage\" \ntotal-count=\"vm.totalCount\" on-page-change=\"vm.refreshInvoiceList\"></pagination><div>Total Item: {{vm.totalCount}}\n</div><div>Display:</div><md-select ng-change=\"vm.refreshInvoiceList(1)\" ng-model=\"vm.itemsPerPage\" \nplaceholder=\"Display\"><md-option ng-repeat=\"option in vm.displayOptions\" ng-value=\"option\">{{option}}</md-option>\n</md-select></div></div></div>");
$templateCache.put("app/main/return-invoice/edit-return-invoice/edit-return-invoice.html","<div style=\"width: 100%\" class=\"bg-secondary header-backgroud\" layout=\"row\" layout-align=\"center center\"><div flex \nclass=\"content-max-width content-padding-x-full\"><div layout=\"row\" layout-align=\"start center\"><span \nclass=\"h2 white-fg\">Edit Return Invoice</span></div><div layout=\"row\" layout-align=\"end center\"><button \nng-click=\"vm.deleteReturnInvoice()\" ng-disabled=\"vm.isSaving || vm.isDeleting\"><i class=\"icon-delete-forever text-red\">\n</i></button></div></div></div><div style=\"width: 100%\" layout=\"row\" layout-align=\"center start\"><div flex \nclass=\"content-max-width\" layout=\"row\" layout-wrap layout-padding><div flex=\"100\" flex-gt-sm=\"75\"><div layout=\"row\" \nclass=\"mb-5\"><return-invoice-info-form flex=\"100\" flex-gt-sm=\"50\" origin-invoice=\"vm.originReturnInvoice\" \nreturn-invoice=\"vm.returnInvoice\" suppliers=\"vm.suppliers\" is-processing-data=\"vm.isSaving || vm.isDeleting\" \nis-form-valid=\"vm.isReturnInfoFormValid\"></return-invoice-info-form></div><h6>Parts</h6><md-content><parts-table \npart-list=\"vm.partList\" suppliers=\"vm.suppliers\" types=\"vm.partTypes\" return-invoice-map=\"vm.returnInvoiceMap\" \nmatched-inventories=\"vm.matchedInventories\" on-part-match-inventory=\"vm.pullDataFromInventory\" \nhidden-columns=\"vm.hiddenColumns\" tabs=\"vm.partTableTabs\" current-tab-index=\"vm.currentPartTableTabIndex\" \non-tab-change=\"vm.onPartTableTabChange\" invoice-map=\"vm.purchaseInvoiceMap\" is-form-valid=\"vm.isPartTableValid\" \non-add-new-part=\"vm.addNewPart\"></parts-table></md-content><div layout=\"row\" layout-wrap class=\"mt-2\"><div flex=\"100\" \nflex-gt-sm=\"50\" flex-order=\"2\" flex-order-gt-sm=\"1\"><button \nng-disabled=\"!vm.isAnyPartSelected() || vm.isSaving || vm.isDeleting\" ng-click=\"vm.removeSelectedParts()\"><i \nclass=\"icon-delete-forever\" ng-class=\"(!vm.isAnyPartSelected() || vm.isSaving || vm.isDeleting ) ? [\'\']:[\'text-red\']\">\n</i></button></div></div><h6 class=\"mt-10\">Files</h6><md-divider class=\"mb-3\"></md-divider><file-section-preview \nis-processing-data=\"vm.isDeletingFile || vm.isSaving || vm.isDeleting\" on-file-delete=\"vm.onFileDelete\" \nfile-uploader=\"vm.fileUploader\" file-list=\"vm.fileList\"></file-section-preview><md-button \nclass=\"btn btn-secondary mx-0\" ng-disabled=\"vm.isSaving || vm.isDeletingParts\" ng-click=\"vm.save()\">save</md-button>\n</div><div flex=\"100\" flex-gt-sm=\"25\"><div class=\"sticky\"><purchase-invoice-summary is-returned-invoice=\"true\" \npart-list=\"vm.summaryPartList\"></purchase-invoice-summary></div></div></div></div>");
$templateCache.put("app/main/sale-info/components/sale-info-additional-finance-info-form.html","<div ng-form=\"additionalFinanceInfoForm\"><div layout=\"row\" layout-wrap><md-input-container flex=\"50\" flex-gt-sm=\"25\" \nclass=\"input-box info-form-item small-input-box purchase-step-payment-input-box\"><input type=\"text\" autocorrect=\"off\" \nautocapitalize=\"none\" spellcheck=\"false\" name=\"applicationFee\" maxlength=\"10\" \nng-model=\"vm.saleInfo.finance_application_fee\" autocomplete=\"off\" placeholder=\"Finance application fee\" input-control \ninput-translate=\"vm.translateToDollar\"></md-input-container><md-input-container flex=\"50\" flex-gt-sm=\"25\" \nclass=\"input-box info-form-item small-input-box purchase-step-payment-input-box\"><input type=\"text\" autocorrect=\"off\" \nautocapitalize=\"none\" spellcheck=\"false\" name=\"lienRegistration\" maxlength=\"10\" \nng-model=\"vm.saleInfo.lien_registration\" autocomplete=\"off\" placeholder=\"Lien registration\" input-control \ninput-translate=\"vm.translateToDollar\"></md-input-container><md-input-container flex=\"50\" flex-gt-sm=\"25\" \nclass=\"input-box info-form-item small-input-box purchase-step-payment-input-box\"><input type=\"text\" autocorrect=\"off\" \nautocapitalize=\"none\" spellcheck=\"false\" name=\"bankAdminFee\" maxlength=\"10\" ng-model=\"vm.saleInfo.bank_admin_fee\" \nautocomplete=\"off\" placeholder=\"Bank Admin Fee\" input-control input-translate=\"vm.translateToDollar\">\n</md-input-container><md-input-container flex=\"50\" flex-gt-sm=\"25\" \nclass=\"input-box info-form-item small-input-box purchase-step-payment-input-box\"><input type=\"text\" autocorrect=\"off\" \nautocapitalize=\"none\" spellcheck=\"false\" name=\"creditApproval\" ng-model=\"vm.saleInfo.creditApproval\" \nautocomplete=\"off\" placeholder=\"Credit Approval\" maxlength=\"40\" input-control></md-input-container></div><div \nlayout=\"row\" layout-wrap><md-input-container flex=\"50\" flex-gt-sm=\"25\" \nclass=\"input-box info-form-item small-input-box purchase-step-payment-input-box\"><input type=\"text\" autocorrect=\"off\" \nautocapitalize=\"none\" spellcheck=\"false\" name=\"interestRate\" maxlength=\"6\" ng-model=\"vm.saleInfo.interest_rate\" \nautocomplete=\"off\" placeholder=\"Interest Rate\" input-control input-options=\"vm.interestRateInputOption\" \ninput-translate=\"vm.translateToPercentage\"></md-input-container><md-input-container flex=\"50\" flex-gt-sm=\"25\" \nclass=\"input-box info-form-item small-input-box purchase-step-payment-input-box\"><input type=\"text\" autocorrect=\"off\" \nautocapitalize=\"none\" spellcheck=\"false\" name=\"costOfBorrowing\" maxlength=\"10\" \nng-model=\"vm.saleInfo.cost_of_borrowing\" autocomplete=\"off\" placeholder=\"Cost of Borrowing\" input-control \ninput-translate=\"vm.translateToDollar\"></md-input-container><md-input-container flex=\"50\" flex-gt-sm=\"25\" \nclass=\"input-box info-form-item small-input-box purchase-step-payment-input-box\"><input type=\"text\" autocorrect=\"off\" \nautocapitalize=\"none\" spellcheck=\"false\" name=\"numberOfPayments\" maxlength=\"10\" \nng-model=\"vm.saleInfo.number_of_payments\" autocomplete=\"off\" placeholder=\"Number of Payments\" ng-pattern=\"/^[0-9]*$/\" \nmaxlength=\"3\"><div ng-messages=\"additionalFinanceInfoForm.numberOfPayments.$error\"><div ng-message=\"maxlength\">\nInput content can not be over 3 charactors</div><div ng-message=\"pattern\">Only number accepted</div></div>\n</md-input-container><md-input-container flex=\"50\" flex-gt-sm=\"25\" \nclass=\"input-box info-form-item small-input-box purchase-step-payment-input-box\"><input type=\"text\" autocorrect=\"off\" \nautocapitalize=\"none\" spellcheck=\"false\" name=\"paymentAmount\" maxlength=\"10\" ng-model=\"vm.saleInfo.payment_amount\" \nautocomplete=\"off\" placeholder=\"Payment Amount\" input-control input-translate=\"vm.translateToDollar\">\n</md-input-container></div><md-input-container flex \nclass=\"info-form-item small-input-box purchase-step-payment-input-box\"><label>Start Date:</label><md-datepicker \nmd-hide-icons=\"calendar\" ng-model=\"vm.paymentStartDate\" name=\"paymentStartDate\" ng-change=\"vm.onDatePickerChange()\">\n</md-datepicker><div ng-messages=\"additionalFinanceInfoForm.paymentStartDate.$error\" \nng-if=\"additionalFinanceInfoForm.paymentStartDate.$invalid\"><div ng-message=\"valid\">Invalid date.</div></div>\n</md-input-container><div layout=\"row\"><md-input-container flex=\"50\" flex-gt-sm=\"25\" \nclass=\"input-box info-form-item small-input-box purchase-step-payment-input-box\"><input type=\"text\" autocorrect=\"off\" \nautocapitalize=\"none\" spellcheck=\"false\" name=\"dealerReserve\" maxlength=\"10\" ng-model=\"vm.saleInfo.dealer_reserve\" \nautocomplete=\"off\" placeholder=\"Dealer reserve\" input-control input-translate=\"vm.translateToDollar\">\n</md-input-container></div></div>");
$templateCache.put("app/main/sale-info/components/sale-info-customer-form.html","<div layout=\"column\" layout-gt-sm=\"row\" class=\"px-1\"><div flex-gt-sm=\"50\"><div flex-gt-sm=\"75\" class=\"card\" \nstyle=\"font-size: 13px\"><div layout=\"row\" layout-align=\"start center\" class=\"p-2\"><md-icon \nclass=\"icon-account-circle ml-0 mr-5\" style=\"font-size: 40px\"></md-icon><div layout=\"column\"><div \nclass=\"text-secondary\" style=\"font-size: 15px\"><a href=\"{{vm.getCustomerPageUrl()}}\" class=\"text-nowrap text-truncate\">\n{{vm.customer.first_name}} {{vm.customer.last_name}}</a></div><div class=\"text-grey\">current customer</div></div></div>\n<md-divider></md-divider><div class=\"p-2\"><div layout=\"row\" class=\"mb-1\" layout-align=\"start center\"><div flex=\"40\">\nBirty day:</div><div>{{vm.customer.birthday}}</div></div><div layout=\"row\" class=\"mb-1\" layout-align=\"start center\">\n<div flex=\"40\">Driver license:</div><div>{{vm.customer.drivers_license}}</div></div><div layout=\"row\" class=\"mb-1\" \nlayout-align=\"start center\"><div flex=\"40\">Driver license expiry:</div><div>{{vm.customer.license_expiry_date}}</div>\n</div><div layout=\"row\" class=\"mb-1\" layout-align=\"start start\"><div flex=\"40\">Phone numbers:</div><div><div \nng-repeat=\"phoneNumber in vm.customer.phone_numbers\" layout=\"row\" layout-align=\"center center\"><div>\n{{phoneNumber.phone_number}}</div></div></div></div><div layout=\"row\" class=\"mb-1\" layout-align=\"start start\"><div \nflex=\"40\">Emails:</div><div><div ng-repeat=\"email in vm.customer.emails\" layout=\"row\" layout-align=\"center center\">\n<div>{{email.email_address}}</div></div></div></div></div></div></div><div flex-gt-sm=\"50\"><md-input-container \nclass=\"pr-0 input-box info-form-item small-input-box purchase-step-payment-input-box\"><input ng-model=\"vm.searchText\" \nng-model-options=\"{ debounce: 700 }\" placeholder=\"Switch Customer\" ng-change=\"vm.onSearchTextChange()\" \nautocomplete=\"off\"></md-input-container><div ng-if=\"vm.customersFound.length > 0\" style=\"font-size: 13px\"><div \nclass=\"card\"><div class=\"card-header\">Potential Matches</div><div class=\"card-body scrollable py-1\" \nstyle=\"max-height: 200px\" ms-scroll><div layout=\"column\"><div \nng-click=\"vm.selectedCustomerID = customer.getResourceID()\" layout=\"row\" class=\"pl-1 py-1 customer-found\" \nlayout-align=\"space-between center\" ng-class=\"vm.selectedCustomerID == customer.getResourceID()? [\'bg-light\']:[\'\']\" \nng-repeat=\"customer in vm.customersFound\"><span flex=\"50\" class=\"text-nowrap text-truncate\">\n{{customer.first_name}} {{customer.last_name}}</span><div layout=\"row\" class=\"mt-1 px-2\" \nng-if=\"vm.selectedCustomerID == customer.getResourceID()\"><span class=\"badge badge-secondary mr-1\" \nng-click=\"vm.goToCustomerPage(customer)\">View</span> <span class=\"badge badge-secondary mx-0\" \nng-click=\"vm.selectCusomter(customer)\">Select</span></div></div></div></div></div></div></div></div>");
$templateCache.put("app/main/sale-info/components/sale-info-deliver-status-form.html","<div ng-form=\"detailForm\" style=\"font-size: 13px\"><md-switch ng-change=\"vm.setDelivered()\" \nng-model=\"vm.saleInfo.is_delivered\" md-invert class=\"email-list-switch\">Is Delivered:</md-switch><div layout=\"row\">\n<md-input-container flex=\"50\" flex-gt-sm=\"25\" class=\"info-form-item small-input-box purchase-step-payment-input-box\">\n<label>Delivery Date:</label><md-datepicker md-hide-icons=\"calendar\" ng-model=\"vm.deliverDatePickerValue\" \nng-change=\"vm.setDeliveryDate(vm.deliverDatePickerValue)\" name=\"deliverDate\"></md-datepicker><div \nng-messages=\"detailForm.deliverDate.$error\" ng-if=\"detailForm.deliverDate.$invalid\"><div ng-message=\"valid\">\nInvalid date.</div></div></md-input-container><md-input-container flex=\"50\" flex-gt-sm=\"25\" \nclass=\"info-form-item small-input-box purchase-step-payment-input-box\"><label>Pick up Date:</label><md-datepicker \nmd-hide-icons=\"calendar\" ng-model=\"vm.deliverDueDatePickerValue\" \nng-change=\"vm.setDeliveryDueDate(vm.deliverDueDatePickerValue)\" name=\"deliverDueDate\"></md-datepicker><div \nng-messages=\"detailForm.deliverDueDate.$error\" ng-if=\"detailForm.deliverDueDate.$invalid\"><div ng-message=\"valid\">\nInvalid date.</div></div></md-input-container></div><div layout=\"row\" layout-wrap><div flex=\"100\" class=\"pr-5\"><div \nclass=\"mt-5 mb-3\">General Comment:</div><textarea ng-change=\"vm.log()\" style=\"width:100%\" rows=\"3\" \nng-model=\"vm.saleInfo.general_comments\" class=\"info-form-item detail-info-form-note-input\" \nplaceholder=\"General Comment:\">\r\n			</textarea></div><div flex=\"100\" flex-gt-sm=\"50\" class=\"pr-5\"><md-checkbox \nclass=\"mt-8\" ng-model=\"vm.saleInfo.is_detail_completed\">Detail</md-checkbox><textarea style=\"width:100%\" rows=\"3\" \nng-model=\"vm.saleInfo.detail_comments\" class=\"info-form-item detail-info-form-note-input\" \nplaceholder=\"Detail Comment:\">\r\n			</textarea></div><div flex=\"100\" flex-gt-sm=\"50\" class=\"pr-5\"><md-checkbox \nclass=\"mt-8\" ng-model=\"vm.saleInfo.is_licensing_completed\">Licensing</md-checkbox><textarea style=\"width:100%\" \nrows=\"3\" ng-model=\"vm.saleInfo.licensing_comments\" class=\"info-form-item detail-info-form-note-input\" \nplaceholder=\"Licensing Comment:\">\r\n			</textarea></div></div><md-checkbox class=\"mx-0 mt-8\" disabled=\"disabled\" \nng-checked=\"vm.quotedWorkorders.length <= 0\">Mechanic</md-checkbox><div layout=\"row\" \nng-repeat=\"workorder in vm.quotedWorkorders\" class=\"mb-1\"><div class=\"mr-1\">&#9679</div><div><div><a \nng-href=\"{{::vm.getWorkorderUrl(workorder)}}\">{{workorder.invoice_number}}</a> <span \nng-if=\"workorder.fk_id_work_order_priority\">{{::vm.getWorkorderPriority(workorder.fk_id_work_order_priority)}}</span>\n</div><div class=\"pre-wrap\">{{::workorder.notes}}</div></div></div><div ng-if=\"!(vm.quotedWorkorders.length > 0)\">\nNo quoted workorder found.</div></div>");
$templateCache.put("app/main/sale-info/components/sale-info-disclosure-list.html","<md-divider></md-divider><div class=\"py-5 pl-2\"><div ng-if=\"!vm.disclosures.length > 0\">No item found</div><div \nng-repeat=\"disclosure in vm.disclosures\" layout=\"row\" layout-align=\"space-between center\"><div flex=\"70\" \nclass=\"text-truncate text-nowrap\">{{disclosure.description}}</div><div flex-offset=\"5\" flex=\"20\">\n{{disclosure.amount | currency:\'$\':2}}</div><span flex=\"5\" ng-class=\"vm.isProcessingData? [\'text-grey\']:[\'text-red\']\" \nng-click=\"vm.isProcessingData? null:vm.onDisclosureRemoved(disclosure, $index)\">&#x2715</span></div></div><md-divider \nclass=\"mb-2\"></md-divider><div layout=\"row\" layout-align=\"space-between center\"><md-input-container flex=\"60\" \nclass=\"input-box info-form-item small-input-box purchase-step-payment-input-box\"><input type=\"text\" autocorrect=\"off\" \nautocapitalize=\"none\" spellcheck=\"false\" name=\"description\" ng-model=\"vm.description\" autocomplete=\"off\" \nplaceholder=\"Description\"></md-input-container><md-input-container flex=\"30\" \nclass=\"input-box info-form-item small-input-box purchase-step-payment-input-box\"><input type=\"text\" autocorrect=\"off\" \nautocapitalize=\"none\" spellcheck=\"false\" name=\"Amount\" ng-model=\"vm.amount\" autocomplete=\"off\" placeholder=\"Amount\" \nmaxlength=\"10\" input-control input-translate=\"vm.translateToDollar\"></md-input-container><div flex=\"10\"><span \nclass=\"badge mx-0\" ng-class=\"vm.isProcessingData? [\'badge-info\']:[\'badge-secondary\']\" \nng-click=\"vm.isProcessingData? null:vm.addDisclosure()\">Add</span></div></div>");
$templateCache.put("app/main/sale-info/components/sale-info-extra-list.html","<div style=\"font-size: 13px\"><div style=\"overflow: auto;white-space: nowrap\"><div ng-click=\"vm.toggleItem(item)\" \nng-class=\"item.isSelected ? []:[\'raised-box\']\" class=\"text-left p-2 ml-1 mr-4 my-2 simple-border\" \nstyle=\"width: 150px; height: 150px;display: inline-block\" ng-repeat=\"item in vm.extraList\"><div layout=\"column\" \nlayout-algin=\"space-between center\" layout-fill><div flex=\"grow\"><div style=\"font-size: 15px\" \nclass=\"text-nowrap text-truncate mb-1 font-weight-bold\">{{item.name}}</div><div style=\"font-size: 12px\" \nclass=\"text-nowrap text-truncate\">{{item.cost | currency:\'$\':2}}</div><md-divider></md-divider></div><div layout=\"row\" \nlayout-align=\"center center\" ng-switch on=\"item.isDisabled\"><md-progress-circular ng-switch-when=\"true\" \nmd-diameter=\"25px\"></md-progress-circular><i ng-switch-default style=\"font-size: 30px\" \nng-class=\"item.isSelected ? [\'icon-checkbox-marked-circle-outline\', \'text-green\']:[\'icon-circle-outline\', \'opacity-50\']\">\n</i></div></div></div></div><div layout=\"row\" layout-align=\"start center\" layout-wrap><md-input-container \nflex-gt-sm=\"25\" flex=\"50\" class=\"input-box info-form-item small-input-box purchase-step-payment-input-box\"><input \ntype=\"text\" autocorrect=\"off\" autocapitalize=\"none\" spellcheck=\"false\" ng-model=\"vm.newExtraName\" autocomplete=\"off\" \nplaceholder=\"Custom Item\"></md-input-container><md-input-container flex-gt-sm=\"25\" flex=\"50\" \nclass=\"pr-0 input-box info-form-item small-input-box purchase-step-payment-input-box\"><input maxlength=\"10\" \nautocorrect=\"off\" autocapitalize=\"none\" spellcheck=\"false\" ng-model=\"vm.newExtraCost\" autocomplete=\"off\" \nplaceholder=\"Cost\" input-control input-translate=\"vm.translateToDollar\"></md-input-container><div flex-gt-sm=\"25\" \nflex=\"100\" layout=\"row\" layout-align=\"center center\" layout-align-gt-sm=\"start center\"><md-button \nng-disabled=\"vm.isAddingCustomerExtra\" ng-click=\"vm.addCreateNewExtra()\" \nclass=\"mb-5 btn btn-outline-success md-raised\">ADD</md-button></div></div></div>");
$templateCache.put("app/main/sale-info/components/sale-info-file-list.html","<div layout=\"row\"><div flex=\"100\" flex-gt-sm=\"50\" style=\"font-size: 13px\"><md-divider class=\"my-2\"></md-divider><div \nclass=\"px-2\"><div ng-if=\"!(vm.uploadedFiles.length > 0) && !(vm.fileUploader.queue.length > 0)\">No file item</div><div \nlayout=\"row\" layout-align=\"space-between center\" ng-repeat=\"uploadedFile in vm.uploadedFiles\"><div flex=\"80\" \nclass=\"text-nowrap text-truncate\"><a href=\"{{vm.getFileURL(uploadedFile)}}\">{{uploadedFile.file_name}}</a></div>\n<md-button restrict rolescansee=\"developer company_manager sales_manager accountant\" flex=\"20\" \nclass=\"md-icon-button mx-0\" ng-disabled=\"vm.isProcessingData\" ng-click=\"vm.onFileDelete(uploadedFile)\"><md-icon \nclass=\"icon-minus-circle purchase-step-extra-item-icon\" \nng-class=\"vm.isProcessingData == true ? [\'text-grey\']:[\'text-red\']\"></md-icon></md-button></div><div layout=\"row\" \nlayout-align=\"space-between center\" ng-repeat=\"file in vm.fileUploader.queue\"><div flex=\"80\" \nclass=\"text-nowrap text-truncate\">{{file.file.name}}</div><md-button flex=\"20\" layout=\"row\" \nlayout-align=\"center center\" class=\"md-icon-button mx-0\"><md-progress-circular md-diameter=\"18\"></md-progress-circular>\n</md-button></div></div><div layout=\"row\" layout-align=\"center center\"><md-button ng-if=\"!vm.isProcessingData\" \nclass=\"md-icon-button\"><md-icon class=\"icon-plus-circle text-green purchase-step-extra-item-icon\"></md-icon><input \nmultiple=\"multiple\" class=\"fileInput\" nv-file-select=\"false\" uploader=\"vm.fileUploader\" type=\"file\"></md-button>\n<md-button ng-if=\"vm.isProcessingData\" class=\"md-icon-button\"><md-icon \nclass=\"icon-plus-circle text-grey purchase-step-extra-item-icon\"></md-icon></md-button></div><md-divider></md-divider>\n</div></div>");
$templateCache.put("app/main/sale-info/components/sale-info-finance-application-form.html","<div ng-form=\"financeApplicationForm\" layout=\"column\" layout-gt-sm=\"row\"><div flex=\"45\" \nng-if=\"vm.financeApplication != null\"><div layout=\"row\" class=\"my-2\"><md-input-container \nng-if=\"vm.financeApplication.id_finance_application == null\" flex=\"100\" flex-gt-sm=\"50\" \nclass=\"input-box info-form-item small-input-box purchase-step-payment-input-box\"><input autocorrect=\"off\" \nautocapitalize=\"none\" spellcheck=\"false\" name=\"searchApplicant\" input-control \ncustom-validations=\"vm.currentApplicantCheck\" ng-model=\"vm.searchText\" \nng-model-options=\"{ debounce: 700, allowInvalid : true }\" placeholder=\"Search Applicant\" \nng-change=\"vm.onSearchTextChange()\" autocomplete=\"off\"><div \nng-messages=\"financeApplicationForm.searchApplicant.$error\"><div ng-message=\"applicant\">Please select an applicant.\n</div></div></md-input-container><div layout=\"row\" layout-align=\"start center\" class=\"px-0 pb-2\" flex-gt-sm=\"100\" \nflex=\"50\" style=\"font-size: 13px\"><md-icon class=\"icon-account-circle ml-0 mr-5\" style=\"font-size: 35px\"></md-icon><div\n layout=\"column\"><div class=\"text-secondary\" style=\"font-size: 15px\"><span class=\"text-nowrap text-truncate\">\n{{vm.currentApplicant.first_name}} {{vm.currentApplicant.last_name}}</span></div><div class=\"text-grey\">\ncurrent applicant</div></div></div></div><div layout=\"row\"><div flex=\"100\" class=\"py-3 pl-1 pr-5\" \nng-if=\"vm.customersFound.length > 0\" style=\"font-size: 13px\"><div class=\"card\"><div class=\"card-header\">Applicants\n</div><div class=\"card-body scrollable py-1\" style=\"max-height: 200px\" ms-scroll><div layout=\"column\"><div \nng-click=\"vm.selectedCustomerID = customer.getResourceID()\" layout=\"row\" class=\"pl-1 py-1 customer-found\" \nlayout-align=\"space-between center\" ng-class=\"vm.selectedCustomerID == customer.getResourceID()? [\'bg-light\']:[\'\']\" \nng-repeat=\"customer in vm.customersFound\"><span flex=\"50\" class=\"text-nowrap text-truncate\">\n{{customer.first_name}} {{customer.last_name}}</span><div layout=\"row\" class=\"mt-1 px-2\" \nng-if=\"vm.selectedCustomerID == customer.getResourceID()\"><span class=\"badge badge-secondary mr-1\" \nng-click=\"vm.goToCustomerPage(customer)\">View</span> <span class=\"badge badge-secondary mx-0\" \nng-click=\"vm.selectApplicant(customer)\">Select</span></div></div></div></div></div></div></div><md-input-container \nflex style=\"position: relative\" class=\"input-box info-form-item small-input-box purchase-step-payment-input-box\"><input\n ng-focus=\"vm.onPostcodeFocus()\" ng-blur=\"vm.dismissAddressList()\" ng-change=\"vm.onPostcodeChange()\" autocorrect=\"off\" \nautocapitalize=\"none\" spellcheck=\"false\" ng-required=\"true\" name=\"addressPostalCode\" \nng-model=\"vm.financeApplication.address_postal_code\" autocomplete=\"off\" placeholder=\"Postal Code\" input-control \ninput-translate=\"vm.translateToPostalCode\"><div ng-messages=\"financeApplicationForm.addressPostalCode.$error\"><div \nng-message=\"required\">Required</div></div><div ng-if=\"vm.showAddressList\" \nstyle=\"position: absolute; top: 30px; width: 100%;z-index: 100\" class=\"input-box-padding\"><md-content \nclass=\"simple-border-no-radius\" style=\"max-height: 150px\"><md-progress-linear ng-if=\"vm.fetchingAddress\" \nmd-mode=\"indeterminate\"></md-progress-linear><div ng-click=\"vm.selectAddress(address)\" class=\"p-1\" \nng-if=\"!vm.fetchingAddress\" ng-repeat=\"address in vm.addressList\">{{vm.getAddressName(address)}}</div></md-content>\n</div></md-input-container><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex \nclass=\"input-box info-form-item small-input-box purchase-step-payment-input-box\"><input type=\"text\" autocorrect=\"off\" \nautocapitalize=\"none\" spellcheck=\"false\" ng-required=\"true\" name=\"addressStreetNumber\" \nng-model=\"vm.financeApplication.address_street_number\" autocomplete=\"off\" placeholder=\"Street#\" maxlength=\"100\"><div \nng-messages=\"financeApplicationForm.addressStreetNumber.$error\"><div ng-message=\"maxlength\">\nInput content can not be over 100 charactors</div><div ng-message=\"required\">This field is required</div></div>\n</md-input-container><md-input-container flex \nclass=\"input-box info-form-item small-input-box purchase-step-payment-input-box\"><input type=\"text\" autocorrect=\"off\" \nautocapitalize=\"none\" spellcheck=\"false\" ng-required=\"true\" name=\"addressStreet\" \nng-model=\"vm.financeApplication.address_street\" autocomplete=\"off\" placeholder=\"Street\" maxlength=\"100\"><div \nng-messages=\"financeApplicationForm.addressStreet.$error\"><div ng-message=\"maxlength\">\nInput content can not be over 100 charactors</div><div ng-message=\"required\">This field is required</div></div>\n</md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex-gt-sm=\"50\" \nclass=\"input-box info-form-item small-input-box purchase-step-payment-input-box\"><input type=\"text\" autocorrect=\"off\" \nautocapitalize=\"none\" spellcheck=\"false\" ng-required=\"true\" name=\"addressCity\" \nng-model=\"vm.financeApplication.address_city\" autocomplete=\"off\" placeholder=\"City\" input-control \ninput-translate=\"vm.translateToFirstCap\" maxlength=\"50\"><div ng-messages=\"financeApplicationForm.addressCity.$error\">\n<div ng-message=\"maxlength\">Input content can not be over 50 charactors</div><div ng-message=\"required\">\nThis field is required</div></div></md-input-container><div flex-gt-sm=\"50\" layout=\"row\"><md-input-container flex \nclass=\"input-box info-form-item small-input-box purchase-step-payment-input-box\"><input type=\"text\" autocorrect=\"off\" \nautocapitalize=\"none\" spellcheck=\"false\" ng-required=\"true\" name=\"addressProvince\" \nng-model=\"vm.financeApplication.address_province\" autocomplete=\"off\" placeholder=\"Province\" maxlength=\"20\" \ninput-control input-translate=\"vm.translateToAllCapitalize\"><div \nng-messages=\"financeApplicationForm.addressProvince.$error\"><div ng-message=\"maxlength\">\nInput content can not be over 20 charactors</div><div ng-message=\"required\">Required</div></div></md-input-container>\n</div></div><div layout=\"column\" layout-gt-sm=\"row\"><div layout=\"column\" flex=\"50\" style=\"font-size: 13px\" \nclass=\"pr-5\"><md-input-container style=\"width: 100%\" class=\"md-no-underline small-selector purchase-step-selector\">\n<label>Living Arrangement Type</label><md-select style=\"width: 100%\" name=\"livingArrangementType\" \nng-model=\"vm.financeApplication.fk_id_living_arrangement_type\" placeholder=\"Living Arrangement Type\" \nng-required=\"true\"><md-option ng-repeat=\"livingArrangementType in vm.constants.livingArrangementTypes\" \nvalue=\"{{livingArrangementType.id_living_arrangement_type}}\">{{livingArrangementType.name}}</md-option></md-select><div\n ng-messages=\"financeApplicationForm.livingArrangementType.$error\"><div ng-message=\"required\">This field is required\n</div></div></md-input-container></div><md-input-container flex-gt-sm=\"50\" \nclass=\"input-box info-form-item small-input-box purchase-step-payment-input-box\"><input maxlength=\"10\" \nautocorrect=\"off\" autocapitalize=\"none\" spellcheck=\"false\" ng-required=\"true\" name=\"addressMonthlyPayment\" \nng-model=\"vm.financeApplication.address_monthly_payment\" autocomplete=\"off\" placeholder=\"Monthly Payment\" \ninput-control input-translate=\"vm.translateToDollar\"><div \nng-messages=\"financeApplicationForm.addressMonthlyPayment.$error\"><div ng-message=\"required\">This field is required\n</div></div></md-input-container></div><div layout=\"row\"><div layout=\"column\" layout-fill flex-gt-sm=\"50\" \nstyle=\"font-size: 13px\"><div layout=\"row\"><p class=\"mb-0\">Time of living in current address</p></div><div layout=\"row\">\n<md-input-container flex=\"50\" class=\"input-box info-form-item small-input-box purchase-step-payment-input-box\"><input \ninput-control custom-validations=\"vm.livingArrangementTimeCheck\" autocorrect=\"off\" autocapitalize=\"none\" \nspellcheck=\"false\" ng-required=\"vm.livingArrangementMonth == null || vm.livingArrangementMonth.trim() == \'\'\" \nname=\"addressTimeYear\" ng-model=\"vm.livingArrangementYear\" autocomplete=\"off\" placeholder=\"Year\" input-pattern \nmaxlength=\"2\" ng-pattern=\"/^[0-9]*$/\" \nng-change=\"vm.setLivingArrangementTime(vm.livingArrangementYear, vm.livingArrangementMonth)\"><div \nng-messages=\"financeApplicationForm.addressTimeYear.$error\"><div ng-message=\"maxlength\">\nInput content can not be over 2 digits</div><div ng-message=\"required\">This field is required</div><div \nng-message=\"pattern\">Invalid year.</div><div ng-message=\"minValue\">Must longer than 2 years</div></div>\n</md-input-container><md-input-container flex=\"50\" \nclass=\"input-box info-form-item small-input-box purchase-step-payment-input-box\"><input autocorrect=\"off\" \nautocapitalize=\"none\" spellcheck=\"false\" \nng-required=\"vm.livingArrangementYear == null || vm.livingArrangementYear.trim() == \'\'\" name=\"addressTimeMonth\" \nng-model=\"vm.livingArrangementMonth\" autocomplete=\"off\" placeholder=\"Month\" input-control \ninput-translate=\"vm.translateToMonth\" \nng-change=\"vm.setLivingArrangementTime(vm.livingArrangementYear, vm.livingArrangementMonth)\"><div \nng-messages=\"financeApplicationForm.addressTimeMonth.$error\"><div ng-message=\"required\">This field is required</div>\n</div></md-input-container></div></div></div><div layout=\"row\"><div flex=\"50\" class=\"pr-5\"><md-input-container \nstyle=\"width: 100%\" class=\"md-no-underline small-selector purchase-step-selector\"><label>Employment status</label>\n<md-select style=\"width: 100%\" name=\"employmentStatusSelector\" \nng-model=\"vm.financeApplication.fk_id_employment_status\" placeholder=\"Employment status\" ng-required=\"true\"><md-option \nng-repeat=\"employmentStatus in vm.constants.employmentStatus\" value=\"{{employmentStatus.id_employment_status}}\">\n{{employmentStatus.name}}</md-option></md-select><div \nng-messages=\"financeApplicationForm.employmentStatusSelector.$error\"><div ng-message=\"required\">This field is required\n</div></div></md-input-container></div></div><div layout=\"column\"><div layout=\"column\" layout-gt-sm=\"row\">\n<md-input-container class=\"input-box info-form-item small-input-box purchase-step-payment-input-box\"><input \ntype=\"text\" autocorrect=\"off\" autocapitalize=\"none\" spellcheck=\"false\" ng-required=\"true\" name=\"employerName\" \nng-model=\"vm.financeApplication.employer_name\" autocomplete=\"off\" placeholder=\"Name of employer\" maxlength=\"50\"><div \nng-messages=\"financeApplicationForm.employerName.$error\"><div ng-message=\"maxlength\">\nInput content can not be over 50 charactors</div><div ng-message=\"required\">This field is required</div></div>\n</md-input-container><md-input-container \nclass=\"input-box info-form-item small-input-box purchase-step-payment-input-box\"><input type=\"text\" autocorrect=\"off\" \nautocapitalize=\"none\" spellcheck=\"false\" ng-required=\"true\" name=\"jobTitle\" ng-model=\"vm.financeApplication.job_title\" \nautocomplete=\"off\" placeholder=\"Your Title\" maxlength=\"50\"><div ng-messages=\"financeApplicationForm.jobTitle.$error\">\n<div ng-message=\"maxlength\">Input content can not be over 50 charactors</div><div ng-message=\"required\">\nThis field is required</div></div></md-input-container></div></div><p style=\"font-size: 13px\" class=\"mb-0\">\nTime of working for current employment</p><div layout=\"column\" layout-gt-sm=\"row\"><div flex-gt-sm=\"50\" layout=\"row\">\n<md-input-container flex class=\"input-box info-form-item small-input-box purchase-step-payment-input-box\"><input \ntype=\"text\" autocorrect=\"off\" autocapitalize=\"none\" spellcheck=\"false\" \nng-required=\"vm.employmentMonth == null || vm.employmentMonth.trim() == \'\'\" name=\"employmentYear\" \nng-model=\"vm.employmentYear\" autocomplete=\"off\" placeholder=\"Year\" input-pattern maxlength=\"2\" ng-pattern=\"/^[0-9]*$/\" \nng-change=\"vm.setEmploymentTime(vm.employmentYear, vm.employmentMonth)\"><div \nng-messages=\"financeApplicationForm.employmentYear.$error\"><div ng-message=\"maxlength\">Invalid year</div><div \nng-message=\"required\">Required</div><div ng-message=\"pattern\">Invalid year</div></div></md-input-container>\n<md-input-container flex class=\"input-box info-form-item small-input-box purchase-step-payment-input-box\"><input \ntype=\"text\" autocorrect=\"off\" autocapitalize=\"none\" spellcheck=\"false\" \nng-required=\"vm.employmentYear == null || vm.employmentYear.trim() == \'\'\" name=\"employmentMonth\" \nng-model=\"vm.employmentMonth\" autocomplete=\"off\" placeholder=\"Month\" input-control \ninput-translate=\"vm.translateToMonth\" ng-change=\"vm.setEmploymentTime(vm.employmentYear, vm.employmentMonth)\"><div \nng-messages=\"financeApplicationForm.employmentMonth.$error\"><div ng-message=\"required\">Required</div></div>\n</md-input-container></div><md-input-container flex-gt-sm=\"50\" \nclass=\"input-box info-form-item small-input-box purchase-step-payment-input-box\"><input type=\"text\" autocorrect=\"off\" \nautocapitalize=\"none\" spellcheck=\"false\" ng-required=\"true\" name=\"employerPhone\" ng-model=\"vm.employerPhoneNumber\" \nng-change=\"vm.setEmployerPhoneNumber()\" autocomplete=\"off\" placeholder=\"Employer Phone Number\" input-control \ninput-translate=\"vm.translateToPhoneNumber\"><div ng-messages=\"financeApplicationForm.employerPhone.$error\"><div \nng-message=\"required\">This field is required</div></div></md-input-container></div><div layout=\"column\" \nlayout-gt-sm=\"row\"><md-input-container \nclass=\"input-box info-form-item small-input-box purchase-step-payment-input-box\"><input type=\"text\" autocorrect=\"off\" \nautocapitalize=\"none\" spellcheck=\"false\" ng-required=\"true\" name=\"annualIncome\" \nng-model=\"vm.financeApplication.annual_income\" autocomplete=\"off\" maxlength=\"10\" placeholder=\"Gross annual income\" \ninput-control input-translate=\"vm.translateToDollar\"><div ng-messages=\"financeApplicationForm.annualIncome.$error\"><div\n ng-message=\"required\">This field is required</div></div></md-input-container><md-input-container \nclass=\"input-box info-form-item small-input-box purchase-step-payment-input-box\"><input type=\"text\" autocorrect=\"off\" \nautocapitalize=\"none\" spellcheck=\"false\" name=\"sin\" ng-model=\"vm.financeApplication.sin\" autocomplete=\"off\" \nplaceholder=\"Social Insurance Number\" input-control input-translate=\"vm.translateToSIN\"></md-input-container></div><div\n layout=\"column\" layout-gt-sm=\"row\"><md-input-container style=\"width: 100%\" \nclass=\"pr-5 md-no-underline small-selector purchase-step-selector\"><label>Loan length (months)</label><md-select \nstyle=\"width: 100%\" name=\"loanLength\" ng-model=\"vm.financeApplication.loanLength\" placeholder=\"Loan length (months)\" \nng-required=\"true\"><md-option ng-repeat=\"loanLengthOptions in vm.loanLengthOptions\" value=\"{{loanLengthOptions}}\">\n{{loanLengthOptions}}</md-option></md-select><div ng-messages=\"financeApplicationForm.loanLength.$error\"><div \nng-message=\"required\">This field is required</div></div></md-input-container><md-input-container \nclass=\"input-box info-form-item small-input-box purchase-step-payment-input-box\"><input type=\"text\" autocorrect=\"off\" \nautocapitalize=\"none\" spellcheck=\"false\" ng-required=\"true\" name=\"downPayment\" maxlength=\"10\" \nng-model=\"vm.financeApplication.down_payment\" autocomplete=\"off\" placeholder=\"Preferred down payment\" input-control \ninput-translate=\"vm.translateToDollar\"><div ng-messages=\"financeApplicationForm.downPayment.$error\"><div \nng-message=\"required\">This field is required</div></div></md-input-container></div></div></div>");
$templateCache.put("app/main/sale-info/components/sale-info-general-form.html","<div ng-form=\"generalForm\" style=\"font-size: 13px\"><div layout=\"row\" class=\"mb-8\" layout-align=\"space-between center\" \nng-if=\"vm.canSeeCancel\"><div ng-class=\"vm.saleInfo.is_canceled? [\'text-red\']:[]\">Is Canceled:</div><md-checkbox flex \nng-model=\"vm.saleInfo.is_canceled\" class=\"my-0 py-0 ml-3\" ng-class=\"vm.saleInfo.is_canceled? [\'md-warn\']:[]\">\n</md-checkbox></div><div layout=\"row\" layout-wrap><div flex=\"100\" flex-gt-sm=\"50\" layout-wrap layout=\"row\">\n<md-input-container flex=\"50\" class=\"input-box info-form-item small-input-box purchase-step-payment-input-box\"><input \ntype=\"text\" autocorrect=\"off\" autocapitalize=\"none\" spellcheck=\"false\" ng-required=\"true\" name=\"salePrice\" \nng-model=\"vm.saleInfo.sale_price\" autocomplete=\"off\" placeholder=\"Sale Price\" maxlength=\"10\" input-control \ninput-translate=\"vm.translateToDollar\"><div ng-messages=\"generalForm.salePrice.$error\"><div ng-message=\"maxlength\">\nInput content can not be over 10 charactors</div><div ng-message=\"required\">This field is required</div></div>\n</md-input-container><md-input-container flex=\"50\" \nclass=\"input-box info-form-item small-input-box purchase-step-payment-input-box\"><input type=\"text\" autocorrect=\"off\" \nautocapitalize=\"none\" spellcheck=\"false\" ng-required=\"true\" name=\"taxRate\" ng-model=\"vm.saleInfo.tax_rate\" \nautocomplete=\"off\" placeholder=\"Tax Rate\" maxlength=\"3\" input-control input-options=\"vm.taxRateInputOption\" \ninput-translate=\"vm.translateToPercentage\"><div ng-messages=\"generalForm.taxRate.$error\"><div ng-message=\"maxlength\">\nInput content can not be over 4 charactors</div><div ng-message=\"required\">This field is required</div></div>\n</md-input-container><div style=\"position: relative\" flex=\"50\"><md-input-container \nclass=\"input-box info-form-item small-input-box purchase-step-payment-input-box\"><input type=\"text\" autocorrect=\"off\" \nautocapitalize=\"none\" spellcheck=\"false\" ng-required=\"true\" name=\"licensingOption\" \nng-model=\"vm.saleInfo.licensing_option\" autocomplete=\"off\" placeholder=\"licensing Option\" maxlength=\"20\"><div \nng-messages=\"generalForm.licensingOption.$error\"><div ng-message=\"maxlength\">\nInput content can not be over 20 charactors</div><div ng-message=\"required\">This field is required</div></div>\n</md-input-container><div style=\"position: absolute; top:0; right: 20px\" class=\"badge badge-secondary\" \nng-click=\"vm.showPresetLicensingOptions = !vm.showPresetLicensingOptions\">\n{{vm.showPresetLicensingOptions? \"Hide\":\"Show\"}} Options</div></div><md-input-container flex=\"50\" \nclass=\"input-box info-form-item small-input-box purchase-step-payment-input-box mx-0\"><input type=\"text\" \nautocorrect=\"off\" autocapitalize=\"none\" spellcheck=\"false\" ng-required=\"true\" name=\"licensingFee\" \nng-model=\"vm.saleInfo.licensing_fee\" autocomplete=\"off\" placeholder=\"licensing Fee\" maxlength=\"10\" input-control \ninput-translate=\"vm.translateToDollar\"><div ng-messages=\"generalForm.licensingFee.$error\"><div ng-message=\"maxlength\">\nInput content can not be over 100 charactors</div><div ng-message=\"required\">This field is required</div></div>\n</md-input-container><md-radio-group ng-if=\"vm.showPresetLicensingOptions\" flex=\"100\" ng-model=\"vm.selectedPlateId\" \nng-change=\"vm.setPlateOption(vm.selectedPlateId)\"><md-radio-button ng-repeat=\"plateOption in vm.plateOptions\" \nvalue=\"{{plateOption.id_plate_option}}\" class=\"md-primary\"><span>{{plateOption.name}} <span \nclass=\"badge badge-secondary ml-2\">{{plateOption.cost | currency:\'$\':0}}</span></span></md-radio-button>\n</md-radio-group><md-input-container flex=\"50\" \nclass=\"input-box info-form-item small-input-box purchase-step-payment-input-box\"><input type=\"text\" autocorrect=\"off\" \nautocapitalize=\"none\" spellcheck=\"false\" name=\"licensingCost\" ng-model=\"vm.saleInfo.licensing_cost\" autocomplete=\"off\" \nplaceholder=\"licensing Cost\" maxlength=\"10\" input-control input-translate=\"vm.translateToDollar\"><div \nng-messages=\"generalForm.licensingCost.$error\"><div ng-message=\"maxlength\">Input content can not be over 10 charactors\n</div></div></md-input-container><md-input-container flex=\"50\" \nclass=\"input-box info-form-item small-input-box purchase-step-payment-input-box\"><input type=\"text\" autocorrect=\"off\" \nautocapitalize=\"none\" spellcheck=\"false\" name=\"mileage\" ng-model=\"vm.saleInfo.mileage\" autocomplete=\"off\" \nplaceholder=\"Mileage\" ng-pattern=\"/^[0-9]*$/\" maxlength=\"10\"><div ng-messages=\"generalForm.mileage.$error\"><div \nng-message=\"maxlength\">Input content can not be over 10 charactors</div><div ng-message=\"pattern\">Only number accepted!\n</div></div></md-input-container></div><div flex=\"100\" flex-gt-sm=\"50\"><md-input-container \nclass=\"input-box info-form-item small-input-box purchase-step-payment-input-box\"><input type=\"text\" autocorrect=\"off\" \nautocapitalize=\"none\" spellcheck=\"false\" ng-model=\"vm.saleInfo.commission_payout\" autocomplete=\"off\" \nplaceholder=\"Commission Payout\" maxlength=\"10\" input-control input-translate=\"vm.translateToDollar\">\n</md-input-container><div class=\"mt-4 pr-5\" style=\"position: relative\"><md-autocomplete md-floating-label=\"Sold By:\" \nmd-no-cache=\"true\" md-selected-item=\"vm.currentSoldBy\" md-search-text=\"vm.soldBySearchText\" \nmd-selected-item-change=\"vm.selectSoldBy(item)\" md-items=\"item in vm.queryUser(vm.soldBySearchText, vm.salesmanRoles)\" \nmd-item-text=\"item.first_name + \' \' + item.last_name\" md-min-length=\"0\" placeholder=\"Search\"><md-item-template><span \nmd-highlight-text=\"vm.soldBySearchText\" md-highlight-flags=\"^i\">{{item.first_name}} {{item.last_name}}</span>\n</md-item-template><md-not-found>No states matching \"{{vm.soldBySearchText}}\" were found.</md-not-found>\n</md-autocomplete><span style=\"position: absolute; bottom: 20px; left:5px\" class=\"text-red\" \nng-if=\"vm.currentSalesmanInvalid && vm.saleInfo.sold_by\">This user is not a salesman</span></div><div class=\"pr-5\" \nstyle=\"position: relative\"><md-autocomplete md-floating-label=\"Manager:\" md-no-cache=\"true\" \nmd-selected-item=\"vm.currentSaleManager\" md-search-text=\"vm.saleManagerSearchText\" \nmd-selected-item-change=\"vm.selectSaleManager(item)\" \nmd-items=\"item in vm.queryUser(vm.saleManagerSearchText, vm.saleManagerRoles)\" \nmd-item-text=\"item.first_name + \' \' + item.last_name\" md-min-length=\"0\" placeholder=\"Search\"><md-item-template><span \nmd-highlight-text=\"vm.saleManagerSearchText\" md-highlight-flags=\"^i\">{{item.first_name}} {{item.last_name}}</span>\n</md-item-template><md-not-found>No states matching \"{{vm.saleManagerSearchText}}\" were found.</md-not-found>\n</md-autocomplete><span style=\"position: absolute; bottom: 20px; left:5px\" class=\"text-red\" \nng-if=\"vm.currentSaleManagerInvalid && vm.saleInfo.sale_manager\">This user is not a sale manager</span></div></div>\n</div><div flex=\"100\" flex-gt-sm=\"50\"><md-input-container \nclass=\"input-box info-form-item small-input-box purchase-step-payment-input-box\"><input type=\"text\" autocorrect=\"off\" \nautocapitalize=\"none\" spellcheck=\"false\" name=\"licensePlate\" ng-model=\"vm.saleInfo.license_plate\" autocomplete=\"off\" \nplaceholder=\"License Plate\" maxlength=\"10\" input-control></md-input-container></div></div>");
$templateCache.put("app/main/sale-info/components/sale-info-package-list.html","<div style=\"font-size: 13px\"><div style=\"overflow: auto;white-space: nowrap\"><div \nng-class=\"package.isPurchased ? []:[\'raised-box\']\" class=\"text-left p-2 ml-1 mr-4 my-2 simple-border\" \nclass=\"p-2 ml-1 mr-4\" style=\"min-width: 150px; min-height: 160px;display: inline-block\" \nng-repeat=\"package in vm.packageList\"><div layout=\"column\" layout-algin=\"space-between center\" layout-fill><div \nflex=\"grow\"><div style=\"font-size: 15px\" class=\"text-nowrap text-truncate mb-1 font-weight-bold\"><span \nng-if=\"package.expired\" class=\"text-red\">(Expired)</span> {{package.name}}</div><div style=\"font-size: 12px\" \nclass=\"text-nowrap text-truncate\">{{package.price | currency:\'$\':2}}</div><div style=\"font-size: 12px\" \nclass=\"text-nowrap text-truncate\">({{package.date}})</div><div style=\"font-size: 11px\" \nclass=\"text-nowrap text-truncate\">({{package.valid_mileage || 0}} Mileage)</div><md-divider></md-divider><div \nclass=\"text-nowrap text-truncate\" ng-repeat=\"item in package.items | limitTo:vm.packageItemMaxDisplay track by $index\" \nlayout=\"row\" ng-if=\"!vm.showItems[package.presetPackage.id_preset_package]\"><span class=\"mr-1 text-green\">&#x2713\n</span> {{item}}</div><div \nng-if=\"(package.items.length > vm.packageItemMaxDisplay) && !vm.showItems[package.presetPackage.id_preset_package]\">\n{{package.items.length - vm.packageItemMaxDisplay}} more...<md-tooltip class=\"multiline-tooltip\"><div layout=\"column\">\n<div ng-repeat=\"item in package.items | limitTo: package.items.length : vm.packageItemMaxDisplay track by $index\" \nlayout=\"row\">{{item}}</div></div></md-tooltip></div><div layout=\"row\" layout-align=\"start center\" \nng-click=\"vm.showItems[package.presetPackage.id_preset_package] = !vm.showItems[package.presetPackage.id_preset_package]\">\n<div class=\"text-nowrap text-truncate\" ng-if=\"!vm.showItems[package.presetPackage.id_preset_package]\">Show More</div>\n<div class=\"text-nowrap text-truncate\" ng-if=\"vm.showItems[package.presetPackage.id_preset_package]\">Show Less</div><i \nng-class=\"vm.showItems[package.presetPackage.id_preset_package]? [\'icon-chevron-up\']:[\'icon-chevron-down\']\"></i></div>\n<div style=\"font-size: 13px\" class=\"text-grey\" ng-if=\"vm.showItems[package.presetPackage.id_preset_package]\"><div \nlayout=\"row\" layout-align=\"space-between center\" ng-repeat=\"item in package.presetPackage.items\"><div \nng-repeat=\"job in vm.jobList\" ng-if=\"item.fk_id_job\"><div ng-if=\"job.id_job == item.fk_id_job\"><br>Job: {{job.name}}\n<div ng-repeat=\"part in job.job_part\">Part: {{part.part_name || \"None\"}} * {{part.fk_id_parttype || 0}}</div><div \nng-repeat=\"labour in job.job_labour\">Labour: {{labour.labour_name || \"None\"}} * {{labour.labour_quantity || 0}}</div>\n<div ng-repeat=\"miscfee in job.job_miscfee\">\nMisc Fees: {{miscfee.miscfees_name || \"None\"}} * {{miscfee.miscfees_quantity || 0}}</div></div></div></div></div></div>\n<div layout=\"row\" layout-align=\"center center\" ng-switch on=\"package.isDisabled\"><md-progress-circular \nng-switch-when=\"true\" md-diameter=\"25px\"></md-progress-circular><i ng-switch-default style=\"font-size: 30px\" \nng-class=\"package.isPurchased ? [\'icon-checkbox-marked-circle-outline\', \'text-green\']:[\'icon-circle-outline\', \'opacity-50\']\" \nng-click=\"vm.togglePackage(package)\"></i></div></div></div></div></div>");
$templateCache.put("app/main/sale-info/components/sale-info-payment-form.html","<div layout=\"column\" layout-gt-sm=\"column\" style=\"font-size: 13px\"><div flex=\"100\" flex-gt-sm=\"100\"><div>\nCurrent Payments</div><md-divider></md-divider><div ng-if=\"!(vm.currentPayments.length > 0)\">No payment item</div><div \nng-repeat=\"payment in vm.currentPayments\" \nng-class=\"vm.selectedPayment.getResourceID() == payment.getResourceID()? [\'bg-light\']:[\'\']\"><div layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><div class=\"mx-2 text-secondary\">\n{{::payment.payment_date | date:\"medium\"}}</div><div class=\"mr-2\">{{::payment.amount | currency:\'$\':0}}</div><div \nclass=\"badge badge-secondary\">{{vm.getPaymentMethod(payment.fk_id_payment_method)}}</div></div><div layout=\"row\" \nlayout-align=\"end center\"><md-button ng-disabled=\"vm.isProcessing\" \nng-click=\"vm.voidCreditCardPayment(payment, $index)\" class=\"btn-danger btn-sm mx-0 mr-3\" \nng-if=\"payment.fk_id_payment_method == 11 && payment.is_canceled === 0 && payment.is_refund === 0\">Void</md-button>\n<md-button ng-disabled=\"vm.isProcessing\" ng-click=\"vm.refundCreditCardPayment(payment, $index)\" \nclass=\"btn-danger btn-sm mx-0\" \nng-if=\"payment.fk_id_payment_method == 11 && payment.is_canceled === 0 && payment.is_refund === 0\">Refund</md-button>\n<md-button class=\"md-icon-button mx-0 btn-sm\" ng-click=\"vm.getPaymentFiles(payment)\" ng-disabled=\"vm.isProcessingData\">\n<md-icon class=\"icon-folder-open text-secondary purchase-step-extra-item-icon\"></md-icon></md-button><md-button \nclass=\"md-icon-button mx-0 btn-sm\" ng-click=\"vm.onRemovePayment(payment)\" ng-disabled=\"vm.isProcessingData\"><md-icon \nclass=\"icon-minus-circle text-red purchase-step-extra-item-icon\"></md-icon></md-button></div></div><div layout=\"row\" \nlayout-align=\"space-between center\" ng-if=\"payment.fk_id_payment_method == 11\"><div layout=\"row\" flex=\"70\"><div \nclass=\"json-container\" ng-if=\"payment.authorize_trans_detail_copy\"><div class=\"font-weight-bold\">Transaction Message:\n</div><div class=\"json-property\">API Response Description:</div><div>\n{{payment.authorize_trans_detail_copy.apiResponseDescription}}</div><div class=\"json-property\">\nOverall Status Description:</div><div>{{payment.authorize_trans_detail_copy.overallStatusDescription}}</div></div>\n</div><div layout=\"row\" class=\"text-nowrap text-truncate\" flex=\"30\"><div ng-if=\"payment.message\">\nMessage: {{payment.message}}</div><div ng-if=\"payment.is_refund != undefine\" \nng-class=\"!payment.is_refund ? [text-grey]:[\'text-red\']\">Is Refund: {{payment.is_refund == 1}}</div><div \nng-if=\"payment.is_canceled != undefine\" ng-class=\"!payment.is_canceled ? [text-grey]:[\'text-red\']\">\nIs Cancelled: {{payment.is_canceled == 1}}</div><div ng-if=\"payment.authorize_trans_id\">\nTransaction ID: {{payment.authorize_trans_id}}</div></div></div></div><md-divider></md-divider><div layout=\"row\" \nclass=\"pr-2 mt-3\" layout-align=\"space-between center\"><md-input-container flex=\"40\" \nclass=\"mt-6 input-box info-form-item small-input-box purchase-step-payment-input-box\"><input type=\"text\" \nautocorrect=\"off\" autocapitalize=\"none\" spellcheck=\"false\" ng-model=\"vm.newPayment.amount\" autocomplete=\"off\" \ninput-control input-translate=\"vm.translateToDollar\" placeholder=\"Amount\" maxlength=\"10\"></md-input-container>\n<md-input-container flex=\"40\" style=\"width: 100%\" class=\"md-no-underline small-selector purchase-step-selector\"><label>\nPayment Option</label><md-select style=\"width: 100%\" ng-model=\"vm.newPayment.fk_id_payment_method\" \nplaceholder=\"Payment Method\"><md-option ng-repeat=\"paymentMethod in vm.constants.paymentMethods\" \nvalue=\"{{::paymentMethod.id_payment_method}}\">{{::paymentMethod.name}}</md-option></md-select></md-input-container>\n<md-button ng-if=\"!vm.isProcessingData\" class=\"md-icon-button pr-4\"><md-icon \nclass=\"icon-folder-open text-secondary purchase-step-extra-item-icon\"></md-icon><input multiple=\"multiple\" \nclass=\"fileInput\" nv-file-select=\"false\" uploader=\"vm.newPaymentFileUploader\" type=\"file\"></md-button><md-button \nclass=\"md-icon-button pr-5\" ng-if=\"vm.isProcessingData\" ng-disabled=\"true\"><md-icon \nclass=\"icon-folder-open text-grey purchase-step-extra-item-icon\"></md-icon></md-button><md-button \nclass=\"md-icon-button pr-5\" ng-disabled=\"vm.isProcessingData\" ng-click=\"vm.addPayment()\"><md-icon \nclass=\"icon-plus-circle purchase-step-extra-item-icon\" ng-class=\"vm.isProcessingData? [\'text-grey\']:[\'text-green\']\">\n</md-icon></md-button></div><div layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"space-between center\" \nng-hide=\"vm.newPayment.fk_id_payment_method != 11 || vm.customerCreditCards.length == 0\"><md-select flex=\"100\" \nclass=\"small-selector purchase-step-selector input-box-padding\" ng-model=\"vm.creditCardSelected\" \nplaceholder=\"Credit Card\"><md-option ng-repeat=\"card in vm.customerCreditCards\" ng-value=\"card\">\n{{card.cardType}}--{{card.cardNumber}}--{{card.expiryDate | date:\'MM/yy\'}}</md-option></md-select></div></div><div \nlayout-align=\"space-between center\" \nng-hide=\"vm.customerCreditCards.length != 0 || vm.newPayment.fk_id_payment_method != 11\"><div layout=\"row\" \nlayout-align=\"space-between center\"><div>Selected Customer have no credit card.</div></div></div><div layout=\"row\" \nlayout-align=\"start center\" class=\"text-secondary\" style=\"font-size: 13px\" ng-click=\"vm.togglePaymentTimeEditor()\">\n<div>Edit Payment Time</div><i ng-class=\"vm.showPaymentTimeEditor ? [\'icon-chevron-up\']:[\'icon-chevron-down\']\"></i>\n</div><div ng-if=\"vm.showPaymentTimeEditor\" layout=\"row\"><md-input-container flex=\"40\" \nclass=\"input-box small-input-box\"><label>Payment Date</label><md-datepicker ng-disabled=\"vm.isProcessingData\" \nmd-hide-icons=\"calendar\" ng-model=\"vm.paymentDatePickerValue\" ng-change=\"vm.setPaymentDate(vm.paymentDatePickerValue)\">\n</md-datepicker></md-input-container><div flex=\"40\" moment-picker=\"vm.paymentTimePickerValue\" \nformat=\"{{::vm.timePickerFormat}}\" show-header=\"false\" set-on-select=\"true\" max-view=\"minute\" min-view=\"day\" \nchange=\"vm.setPaymentTime(vm.paymentTimePickerValue)\"><md-input-container class=\"input-box small-input-box\"><input \nng-disabled=\"vm.isProcessingData || vm.disabledInputs.completedDate\" name=\"completeTime\" placeholder=\"Payment Time\" \nng-model=\"vm.paymentTimePickerValue\" ng-model-options=\"{ updateOn: \'blur\' }\" \nng-change=\"vm.setPaymentTime(vm.paymentTimePickerValue)\"></md-input-container></div></div><div \nng-if=\"vm.newPaymentFileUploader.queue.length > 0\"><div class=\"px-2 pb-2\"><div layout=\"row\" \nlayout-align=\"space-between center\" style=\"font-size: 13px\" ng-repeat=\"file in vm.newPaymentFileUploader.queue\"><div \nflex=\"60\" class=\"text-nowrap text-truncate\">{{file.file.name}}</div><div layout=\"row\" layout-align=\"end center\" \nflex=\"60\"><md-button ng-if=\"file.isUploading\" class=\"md-icon-button mx-0\"><md-progress-circular md-diameter=\"18\">\n</md-progress-circular></md-button><md-button class=\"md-icon-button mx-0\" ng-if=\"file.isUploaded\"><md-icon \nclass=\"icon-check-circle text-green purchase-step-extra-item-icon\"></md-icon></md-button><md-button \nclass=\"md-icon-button mx-0\" ng-click=\"file.remove()\" ng-disabled=\"file.isUploading\"><md-icon \nclass=\"icon-minus-circle purchase-step-extra-item-icon\" ng-class=\"file.isUploading? [\'text-grey\']:[\'text-red\']\">\n</md-icon></md-button></div></div></div><md-divider></md-divider></div><div>&nbsp;</div></div><div flex=\"100\" \nflex-offset-gt-sm=\"0\" flex-offset=\"0\" flex-gt-sm=\"100\" ng-if=\"vm.selectedPayment != null\"><div layout=\"row\" \nlayout-align=\"start center\"><div class=\"mr-2\">Files of :</div><div class=\"mr-2 text-secondary\" style=\"font-size: 13px\">\n{{vm.selectedPayment.payment_date}}</div><div class=\"mr-2\" style=\"font-size: 13px\">\n{{vm.selectedPayment.amount | currency:\'$\':0}}</div><div class=\"badge badge-secondary\" style=\"font-size: 13px\">\n{{vm.getPaymentMethod(vm.selectedPayment.fk_id_payment_method)}}</div></div><md-divider></md-divider><div \nclass=\"px-2 pt-1\"><div layout=\"row\" layout-align=\"space-between center\" style=\"font-size: 13px\" \nng-repeat=\"file in vm.paymentFileList\"><div flex=\"80\" class=\"text-nowrap text-truncate\"><a \nhref=\"{{vm.getFileUrl(file)}}\">{{file.file_name}}</a></div><md-button flex=\"20\" class=\"md-icon-button mx-0 btn-sm\" \nng-click=\"vm.deletePaymentFile(file)\" ng-disabled=\"vm.isProcessingData\"><md-icon \nclass=\"icon-minus-circle text-red purchase-step-extra-item-icon\"></md-icon></md-button></div><div layout=\"row\" \nlayout-align=\"space-between center\" style=\"font-size: 13px\" ng-repeat=\"file in vm.fileUploader.queue\"><div flex=\"80\" \nclass=\"text-nowrap text-truncate\">{{file.file.name}}</div><md-button flex=\"20\" layout=\"row\" \nlayout-align=\"center center\" class=\"md-icon-button mx-0\"><md-progress-circular md-diameter=\"18\"></md-progress-circular>\n</md-button></div><div ng-if=\"!(vm.paymentFileList.length > 0) && !vm.isProcessingData\" style=\"font-size: 13px\">\nNo file item found</div><div layout=\"row\" layout-align=\"center center\"><md-button ng-if=\"!vm.isProcessingData\" \nclass=\"md-icon-button\"><md-icon class=\"icon-plus-circle text-green purchase-step-extra-item-icon\"></md-icon><input \nmultiple=\"multiple\" options=\"{paymentID: vm.selectedPayment.getResourceID()}\" class=\"fileInput\" nv-file-select=\"false\" \nuploader=\"vm.fileUploader\" type=\"file\"></md-button><md-button ng-if=\"vm.isProcessingData\" class=\"md-icon-button\">\n<md-icon class=\"icon-plus-circle text-grey purchase-step-extra-item-icon\"></md-icon></md-button></div></div>\n<md-divider></md-divider></div></div>");
$templateCache.put("app/main/sale-info/components/sale-info-plate-option-form.html","<div layout=\"row\"><div flex=\"100\" flex-gt-sm=\"50\"><div style=\"font-size: 13px\" layout=\"row\" \nlayout-align=\"start center\"><span>Current Plate Option: {{vm.currentPlateOption.name}} </span><span \nclass=\"badge badge-secondary mx-2\">{{vm.currentPlateOption.cost | currency:\'$\':0}}</span> <span \nclass=\"badge badge-warning\" ng-if=\"vm.currentPlateOption.isExpired()\">Expired</span></div><md-divider class=\"my-3\">\n</md-divider><md-radio-group ng-model=\"vm.selectedPlateId\" ng-change=\"vm.chengeCurrentPlateOption(vm.selectedPlateId)\">\n<md-radio-button ng-repeat=\"plateOption in vm.availablePlateOptions\" value=\"{{plateOption.id_plate_option}}\" \nclass=\"md-primary\"><div layout=\"row\" layout-align=\"space-between center\" style=\"font-size: 13px\"><div>\n{{plateOption.name}}</div><span class=\"badge badge-secondary ml-2\">{{plateOption.cost | currency:\'$\':0}}</span></div>\n</md-radio-button></md-radio-group></div></div>");
$templateCache.put("app/main/sale-info/components/sale-info-promotion-list.html","<div style=\"font-size: 13px\"><div style=\"overflow: auto;white-space: nowrap\"><div ng-click=\"vm.togglePromotion(item)\" \nng-class=\"item.isSelected ? []:[\'raised-box\']\" class=\"text-left p-2 ml-1 mr-4 my-2 simple-border\" \nstyle=\"width: 150px; height: 150px;display: inline-block\" ng-repeat=\"item in vm.promotionCardList\"><div \nlayout=\"column\" layout-algin=\"space-between center\" layout-fill><div flex=\"grow\"><div style=\"font-size: 15px\" \nclass=\"text-nowrap text-truncate mb-1 font-weight-bold\"><span class=\"text-red\" ng-if=\"item.isExpired\">(Expired)</span>\n {{item.name}}</div><div style=\"font-size: 12px\" class=\"text-nowrap text-truncate\">{{item.subTitle}}</div><md-divider>\n</md-divider><div class=\"text-nowrap text-truncate\">{{item.description}}</div></div><div layout=\"row\" \nlayout-align=\"center center\" ng-switch on=\"item.isDisabled\"><md-progress-circular ng-switch-when=\"true\" \nmd-diameter=\"25px\"></md-progress-circular><i ng-switch-default style=\"font-size: 30px\" \nng-class=\"item.isSelected ? [\'icon-checkbox-marked-circle-outline\', \'text-green\']:[\'icon-circle-outline\', \'opacity-50\']\">\n</i></div></div></div></div></div>");
$templateCache.put("app/main/sale-info/components/sale-info-sign.html","<div style=\"font-size: 13px\" class=\"py-2\"><div layout=\"row\" layout-align=\"space-between center\"><div class=\"mt-2\" \nstyle=\"font-size: 16px\">Signatures:</div><button ng-disabled=\"data.isProcessing || vm.getSeletedSignatureCount() <= 0\" \nng-click=\"vm.deleteSignatures()\"><i class=\"icon-delete-forever m-0 p-0\" \nng-class=\"data.isProcessing || vm.getSeletedSignatureCount() <= 0? [\'text-grey\']:[\'text-red\']\"></i></button></div>\n<md-divider></md-divider><div ng-repeat=\"(signatureID, data) in vm.signatureList\" class=\"mt-2\"><div layout=\"row\" \nlayout-align=\"space-between center\" class=\"mb-1\"><div layout=\"row\" layout-align=\"start center\"><md-checkbox \nclass=\"m-0 p-0\" ng-model=\"data.isSelected\"></md-checkbox><div class=\"mr-2 font-weight-bold\">\n{{::data.info.getCreatedTimeMomentObj().format(\'LLLL\')}}</div><i class=\"icon-check-circle text-green\" \nng-if=\"!data.isProcessing && data.info.fk_id_file\"></i> <i class=\"icon-alert text-yellow\" \nng-if=\"!data.isProcessing && !data.info.fk_id_file\"></i><md-progress-circular ng-if=\"data.isProcessing\" \nmd-mode=\"indeterminate\" md-diameter=\"19\"></md-progress-circular></div><div ng-click data-toggle=\"collapse\" \ndata-target=\"#signatureDetial{{signatureID}}\" class=\"collapse-text text-blue\" ng-class=\"$last? [\'\']:[\'collapsed\']\">\n<span>Detail</span><p>Hide</p></div></div><div ng-class=\"$last? [\'show\']:[\'collapse\']\" \nid=\"signatureDetial{{signatureID}}\"><div ng-if=\"!data.info.fk_id_file\"><div \nng-repeat=\"signerDetail in data.detail.signatures\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"start center\"><div>{{::signerDetail.signer_name}}</div></div><div ng-switch \non=\"signerDetail.status_code\"><i ng-switch-when=\"signed\" class=\"icon-check text-green\"></i><div \nng-switch-when=\"awaiting_signature\" layout=\"row\" layout-align=\"space-between center\"><button class=\"mr-2\" \nng-click=\"vm.copySigningPageLink(signerDetail)\"><i class=\"icon-content-copy\" \nng-class=\"signerDetail.isCopied ? [\'text-green\']:[\'text-secondary\']\"></i></button> <button class=\"mr-2\" ng-switch \non=\"signerDetail.isSending\" ng-disabled=\"signerDetail.isSending || signerDetail.isSent\" \nng-click=\"vm.sendSigningPageLinkByEmail(signerDetail, data.detail)\"><md-progress-circular ng-switch-when=\"true\" \nmd-diameter=\"17\"></md-progress-circular><i ng-switch-default class=\"icon-email\" \nng-class=\"signerDetail.isSent ? [\'\']:[\'text-secondary\']\"></i></button> <button style=\"width: 24px\" ng-switch \non=\"signerDetail.isSigning\" ng-disabled=\"signerDetail.isSigning\" \nng-click=\"vm.finishSignRequest(signerDetail, signatureID)\"><md-progress-circular ng-switch-when=\"true\" \nmd-diameter=\"17\"></md-progress-circular><i ng-switch-default class=\"icon-pen text-secondary\"></i></button></div><i \nng-switch-default class=\"icon-alert-circle text-red\"></i></div></div></div><div layout=\"row\" \nlayout-align=\"start center\" ng-if=\"data.file\"><a href=\"{{vm.getFileURL(data.file)}}\">{{data.file.file_name}}</a></div>\n</div></div><md-divider></md-divider><div layout=\"row\" layout-align=\"space-between center\"><div>New Signature</div>\n<md-progress-circular class=\"my-2\" ng-if=\"vm.isCreatingSignature\" md-diameter=\"23\"></md-progress-circular><md-button \nclass=\"btn-secondary btn-sm mx-0\" ng-if=\"!vm.isCreatingSignature\" ng-click=\"vm.createNewSignatureRequest()\">Add\n</md-button></div></div>");
$templateCache.put("app/main/sale-info/components/sale-info-trade-in-form.html","<div ng-form=\"tradeInForm\"><div layout=\"row\" layout-align=\"start center\"><md-input-container flex=\"50\" flex-gt-sm=\"25\" \nclass=\"input-box info-form-item small-input-box purchase-step-payment-input-box\"><input type=\"text\" autocorrect=\"off\" \nautocapitalize=\"none\" spellcheck=\"false\" name=\"tradeInVehicleVin\" ng-model=\"vm.tradeInVehicle.vin\" autocomplete=\"off\" \nplaceholder=\"Vin\" maxlength=\"17\" input-control input-translate=\"vm.translateToVIN\"><div \nng-messages=\"tradeInForm.tradeInVehicleVin.$error\"><div ng-message=\"maxlength\">\nInput content can not be over 50 charactors</div></div></md-input-container><button ng-disabled=\"vm.isDecodingVin\" \nng-click=\"vm.decodeVin(vm.tradeInVehicle.vin)\"><i class=\"icon-magnify\" \nng-class=\"vm.isDecodingVin? [\'text-grey\']:[\'text-secondary\']\"></i></button></div><div layout=\"row\" layout-wrap>\n<md-input-container flex=\"50\" flex-gt-sm=\"25\" \nclass=\"input-box info-form-item small-input-box purchase-step-payment-input-box\"><input type=\"text\" autocorrect=\"off\" \nautocapitalize=\"none\" spellcheck=\"false\" name=\"tradeInVehicleYear\" ng-model=\"vm.tradeInVehicle.year\" \nautocomplete=\"off\" placeholder=\"Year\" maxlength=\"4\" ng-pattern=\"/^[0-9]*$/\" input-pattern><div \nng-messages=\"tradeInForm.tradeInVehicleYear.$error\"><div ng-message=\"maxlength\">\nInput content can not be over 50 charactors</div><div ng-message=\"pattern\">Invalid value</div></div>\n</md-input-container><md-input-container flex=\"50\" flex-gt-sm=\"25\" \nclass=\"input-box info-form-item small-input-box purchase-step-payment-input-box\"><input type=\"text\" autocorrect=\"off\" \nautocapitalize=\"none\" spellcheck=\"false\" name=\"tradeInVehicleMake\" ng-model=\"vm.tradeInVehicle.make\" \nautocomplete=\"off\" placeholder=\"Make\" maxlength=\"50\"><div ng-messages=\"tradeInForm.tradeInVehicleMake.$error\"><div \nng-message=\"maxlength\">Input content can not be over 50 charactors</div></div></md-input-container><md-input-container \nflex=\"50\" flex-gt-sm=\"25\" class=\"input-box info-form-item small-input-box purchase-step-payment-input-box\"><input \ntype=\"text\" autocorrect=\"off\" autocapitalize=\"none\" spellcheck=\"false\" name=\"tradeInVehicleModel\" \nng-model=\"vm.tradeInVehicle.model\" autocomplete=\"off\" placeholder=\"Model\" maxlength=\"50\"><div \nng-messages=\"tradeInForm.tradeInVehicleModel.$error\"><div ng-message=\"maxlength\">\nInput content can not be over 50 charactors</div></div></md-input-container></div><div layout=\"row\" layout-wrap>\n<md-input-container flex=\"50\" flex-gt-sm=\"25\" \nclass=\"input-box info-form-item small-input-box purchase-step-payment-input-box\"><input type=\"text\" autocorrect=\"off\" \nautocapitalize=\"none\" spellcheck=\"false\" name=\"tradeInVehicleMileage\" ng-model=\"vm.tradeInVehicle.mileage\" \nautocomplete=\"off\" placeholder=\"Mileage\" ng-pattern=\"/^[0-9]*$/\" input-pattern maxlength=\"10\"><div \nng-messages=\"tradeInForm.tradeInVehicleMileage.$error\"><div ng-message=\"maxlength\">\nInput content can not be over 50 charactors</div><div ng-message=\"pattern\">Invalid value</div></div>\n</md-input-container><md-input-container flex=\"50\" flex-gt-sm=\"25\" \nclass=\"input-box info-form-item small-input-box purchase-step-payment-input-box\"><input type=\"text\" autocorrect=\"off\" \nautocapitalize=\"none\" spellcheck=\"false\" name=\"tradeInVehicleColor\" ng-model=\"vm.tradeInVehicle.color\" \nautocomplete=\"off\" placeholder=\"Color\" maxlength=\"50\"><div ng-messages=\"tradeInForm.tradeInVehicleColor.$error\"><div \nng-message=\"maxlength\">Input content can not be over 50 charactors</div></div></md-input-container></div><div \nlayout=\"row\" layout-wrap><md-input-container flex-gt-sm=\"25\" flex=\"50\" \nclass=\"input-box info-form-item small-input-box purchase-step-payment-input-box\"><input type=\"text\" autocorrect=\"off\" \nautocapitalize=\"none\" spellcheck=\"false\" name=\"tradeInPrice\" ng-model=\"vm.tradeInVehicle.trade_in_price\" \nautocomplete=\"off\" placeholder=\"Trade in price\" input-control input-translate=\"vm.translateToDollar\" maxlength=\"10\">\n<div ng-messages=\"tradeInForm.tradeInPrice.$error\"><div ng-message=\"maxlength\">\nInput content can not be over 50 charactors</div></div></md-input-container><md-input-container flex-gt-sm=\"25\" \nflex=\"50\" class=\"input-box info-form-item small-input-box purchase-step-payment-input-box\"><input type=\"text\" \nautocorrect=\"off\" autocapitalize=\"none\" spellcheck=\"false\" name=\"tradeLienPayout\" \nng-model=\"vm.tradeInVehicle.trade_lien_payout\" autocomplete=\"off\" placeholder=\"Lien Payout\" maxlength=\"10\" \ninput-control input-translate=\"vm.translateToDollar\"></md-input-container></div><div layout=\"row\" layout-wrap>\n<md-input-container flex-gt-sm=\"25\" flex=\"50\" \nclass=\"input-box info-form-item small-input-box purchase-step-payment-input-box\"><button \nclass=\"btn btn-secondary mx-0 md-button md-default-theme md-ink-ripple flex\" ng-click=\"vm.printAppraisalForm()\">\nPrint Appraisal Form</button></md-input-container></div></div>");
$templateCache.put("app/main/sale-info/components/sale-info-warranty-form.html","<div class=\"mb-5\" layout=\"column\" layout-gt-sm=\"row\" ng-form=\"warrantyForm\" style=\"font-size: 13px\"><div \nflex-gt-sm=\"45\"><div ng-if=\"vm.currentWarranty != null\"><div layout=\"row\"><md-input-container \nclass=\"input-box info-form-item small-input-box purchase-step-payment-input-box\"><input type=\"text\" autocorrect=\"off\" \nautocapitalize=\"none\" spellcheck=\"false\" ng-required=\"true\" name=\"name\" ng-model=\"vm.currentWarranty.name\" \nautocomplete=\"off\" placeholder=\"Name\"><div ng-messages=\"warrantyForm.name.$error\"><div ng-message=\"required\">\nThis field is required</div></div></md-input-container><md-input-container \nclass=\"input-box info-form-item small-input-box purchase-step-payment-input-box\"><input type=\"text\" autocorrect=\"off\" \nautocapitalize=\"none\" spellcheck=\"false\" name=\"provider\" ng-model=\"vm.currentWarranty.provider\" autocomplete=\"off\" \nplaceholder=\"Provider\"></md-input-container></div><div layout=\"row\"><md-input-container \nclass=\"input-box info-form-item small-input-box purchase-step-payment-input-box\"><input type=\"text\" autocorrect=\"off\" \nautocapitalize=\"none\" spellcheck=\"false\" ng-required=\"true\" name=\"coveredMonth\" \nng-model=\"vm.currentWarranty.duration_month\" autocomplete=\"off\" placeholder=\"Covered Month\" ng-pattern=\"/^[0-9]*$/\" \ninput-pattern maxlength=\"3\"><div ng-messages=\"warrantyForm.coveredMonth.$error\"><div ng-message=\"required\">\nThis field is required</div></div></md-input-container><md-input-container \nclass=\"input-box info-form-item small-input-box purchase-step-payment-input-box\"><input type=\"text\" autocorrect=\"off\" \nautocapitalize=\"none\" spellcheck=\"false\" name=\"coveredMileage\" ng-model=\"vm.currentWarranty.duration_mileage\" \nautocomplete=\"off\" placeholder=\"Covered Mileage\" ng-pattern=\"/^[0-9]*$/\" input-pattern maxlength=\"10\">\n</md-input-container></div><div layout=\"row\"><md-input-container restrict \nrolescansee=\"developer company_manager sales_manager\" flex=\"50\" \nclass=\"input-box info-form-item small-input-box purchase-step-payment-input-box\"><input maxlength=\"10\" type=\"text\" \nautocorrect=\"off\" autocapitalize=\"none\" spellcheck=\"false\" ng-required=\"true\" name=\"cost\" \nng-model=\"vm.currentWarranty.cost\" autocomplete=\"off\" placeholder=\"Cost\" input-control \ninput-translate=\"vm.translateToDollar\"><div ng-messages=\"warrantyForm.cost.$error\"><div ng-message=\"required\">\nThis field is required</div></div></md-input-container><md-input-container flex=\"50\" \nclass=\"input-box info-form-item small-input-box purchase-step-payment-input-box\"><input type=\"text\" autocorrect=\"off\" \nautocapitalize=\"none\" spellcheck=\"false\" ng-required=\"true\" name=\"retail\" ng-model=\"vm.currentWarranty.retail\" \nautocomplete=\"off\" placeholder=\"Retail\" input-control input-translate=\"vm.translateToDollar\" maxlength=\"10\"><div \nng-messages=\"warrantyForm.retail.$error\"><div ng-message=\"required\">This field is required</div></div>\n</md-input-container></div><div layout=\"row\"><md-input-container flex=\"50\" \nclass=\"input-box info-form-item small-input-box purchase-step-payment-input-box\"><input type=\"text\" autocorrect=\"off\" \nautocapitalize=\"none\" spellcheck=\"false\" name=\"max_claim\" ng-model=\"vm.currentWarranty.max_claim\" autocomplete=\"off\" \nplaceholder=\"max_claim\" input-control input-translate=\"vm.translateToDollar\" maxlength=\"10\"><div \nng-messages=\"warrantyForm.max_claim.$error\"><div ng-message=\"required\">This field is required</div></div>\n</md-input-container></div><md-input-container \nclass=\"input-box info-form-item small-input-box purchase-step-payment-input-box\"><input type=\"text\" autocorrect=\"off\" \nautocapitalize=\"none\" spellcheck=\"false\" name=\"description\" ng-model=\"vm.currentWarranty.description\" \nautocomplete=\"off\" placeholder=\"Description\"></md-input-container></div></div><div flex-gt-sm=\"45\" flex-offset=\"0\" \nflex-offset-gt-sm=\"10\"><md-divider></md-divider><div class=\"p-2\"><div ng-if=\"!(vm.availableWarranties.length > 0)\">\nPreset warranties are not available for this vehicle</div><div layout=\"column\" \nng-repeat=\"warranty in vm.availableWarranties\"><div layout=\"row\" layout-align=\"space-between center\"><div flex=\"50\" \nlayout=\"row\" layout-align=\"start center\"><div class=\"m-1 badge badge-secondary\" \nng-click=\"vm.pullDataFromWarrantyOption(warranty)\">Load</div><div>{{::warranty.name}}</div><md-button \nclass=\"md-icon-button mx-0\" \nng-click=\"vm.warrantyShowingFeature[warranty.getResourceID()] = !vm.warrantyShowingFeature[warranty.getResourceID()]\">\n<md-icon class=\"icon-more text-secondary purchase-step-extra-item-icon\"></md-icon></md-button></div><div flex=\"50\" \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"m-1\">{{::warranty.duration_month}} Months</div><div \nclass=\"m-1\">{{::warranty.duration_mileage}} Kms</div><div class=\"m-1 badge badge-warning\">\n{{::warranty.retail | currency:\'$\':0}}</div></div></div><div \nng-if=\"vm.warrantyShowingFeature[warranty.getResourceID()]\" class=\"px-5\" layout=\"row\" layout-wrap \nstyle=\"font-size: 13px\"><div layout=\"row\" flex=\"50\" ng-repeat=\"feature in warranty.features\"><span \nclass=\"text-secondary mr-2\">&#9679</span> <span>{{::feature.name}}<md-tooltip md-direction=\"right\" \nclass=\"multiline-tooltip\">{{::feature.description}}</md-tooltip></span></div></div></div></div><md-divider>\n</md-divider></div></div>");
$templateCache.put("app/main/sale-info/components/sale-summary.html","<style>.line-through {\r\n    	text-decoration: line-through;\r\n	}</style><div class=\"card\" style=\"font-size: 13px\"><div \nclass=\"card-header py-1 bg-black\"><div class=\"\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"text-white font-weight-bold\" ng-click=\"vm.onAnchorClicked(vm.generalAnchor)\">Sale Summary</div><div \nclass=\"text-white font-weight-bold\" ng-click=\"vm.toggleNetFund()\" ng-class=\"{\'line-through\': vm.showNetFund}\">Net Fund\n</div><i ng-if=\"!vm.hideEye\" class=\"text-white\" ng-click=\"vm.showSensitiveContent = !vm.showSensitiveContent\" \nng-class=\"vm.showSensitiveContent ? [\'icon-eye\'] : [\'icon-eye-off\']\"></i></div></div><div class=\"card-body\"><div \nlayout=\"row\" layout-align=\"space-between center\" ng-click=\"vm.onAnchorClicked(vm.generalAnchor)\"><div>Vehicle Price\n</div><div>{{vm.saleInfo.sale_price | currency:\'$\':2}}</div></div><div layout=\"row\" \nlayout-align=\"space-between center\" ng-if=\"vm.warranty.cost != null && !vm.ignoreOptions.warranty\" \nng-click=\"vm.onAnchorClicked(vm.warrantyAnchor)\"><div>Warranty</div><div>{{vm.warranty.retail | currency:\'$\':2}}</div>\n</div><div layout=\"row\" layout-align=\"space-between center\" \nng-if=\"vm.saleInfo.finance_application_fee && !vm.ignoreOptions.financing\" \nng-click=\"vm.onAnchorClicked(vm.financingAnchor)\"><div>Finance Application Fee</div><div>\n{{vm.saleInfo.finance_application_fee | currency:\'$\':2}}</div></div><div class=\"mt-3\" \nng-if=\"vm.saleExtras.length > 0 && !vm.ignoreOptions.extras\" ng-click=\"vm.onAnchorClicked(vm.extrasAnchor)\"><div \nclass=\"font-weight-bold\">Extras</div><md-divider class=\"my-1\"></md-divider><div layout=\"row\" \nlayout-align=\"space-between center\" ng-repeat=\"extra in vm.saleExtras\"><div>{{extra.name}}</div><div>\n{{extra.cost | currency:\'$\':2}}</div></div></div><div class=\"mt-3\" \nng-if=\"vm.salePackages.length > 0 && !vm.ignoreOptions.packages\" ng-click=\"vm.onAnchorClicked(vm.packagesAnchor)\"><div \nclass=\"font-weight-bold\">Packages</div><md-divider class=\"my-1\"></md-divider><div layout=\"row\" \nlayout-align=\"space-between center\" ng-repeat=\"package in vm.salePackages\"><div class=\"text-nowrap text-truncate\">\n{{package.name}}</div><div>{{package.price | currency:\'$\':2}}</div></div></div><div class=\"mt-3\" \nng-if=\"vm.discountDetails.length > 0 && !vm.ignoreOptions.promotions\" \nng-click=\"vm.onAnchorClicked(vm.promotionsAnchor)\"><div class=\"mt-3 font-weight-bold\">Discounts</div><md-divider \nclass=\"my-1\"></md-divider><div layout=\"row\" layout-align=\"space-between center\" \nng-repeat=\"detail in vm.discountDetails\"><div>{{detail.promotion.name}}</div><div>\n{{detail.discountAmount * -1 | currency:\'$\':2}}</div></div></div><div layout=\"row\" class=\"mt-3 font-weight-bold\" \nlayout-align=\"space-between center\"><div>Sub Total</div><div>{{vm.subTotalBeforeTradeIn | currency:\'$\':2}}</div></div>\n<div class=\"mt-3\" ng-if=\"vm.tradeInVehicle.trade_in_price != null && !vm.ignoreOptions.tradeIn\" \nng-click=\"vm.onAnchorClicked(vm.tradeInAnchor)\"><div class=\"mt-3 font-weight-bold\">Trade In</div><md-divider \nclass=\"my-1\"></md-divider><div layout=\"row\" layout-align=\"space-between center\"><div>\n{{vm.tradeInVehicle.year}} {{vm.tradeInVehicle.make}} {{vm.tradeInVehicle.model}}</div><div>\n{{vm.tradeInVehicle.trade_in_price * -1 | currency:\'$\':2}}</div></div></div><div layout=\"row\" \nclass=\"mt-3 font-weight-bold\" layout-align=\"space-between center\"><div>HST <span ng-if=\"vm.saleInfo.tax_rate\">\n({{vm.saleInfo.tax_rate * 100}}%)</span></div><div>{{vm.hst | currency:\'$\':2}}</div></div><div class=\"mt-3\"><div \nclass=\"font-weight-bold\">Not Taxed</div><md-divider class=\"my-1\"></md-divider><div layout=\"row\" \nlayout-align=\"space-between center\" ng-if=\"vm.saleInfo.licensing_option\" \nng-click=\"vm.onAnchorClicked(vm.generalAnchor)\"><div>{{vm.saleInfo.licensing_option}}</div><div>\n{{vm.saleInfo.licensing_fee | currency:\'$\':2}}</div></div><div ng-if=\"!vm.ignoreOptions.financing\" \nng-click=\"vm.onAnchorClicked(vm.financingAnchor)\"><div layout=\"row\" layout-align=\"space-between center\" \nng-if=\"vm.saleInfo.lien_registration\"><div>Lien Registration Fee</div><div>\n{{vm.saleInfo.lien_registration | currency:\'$\':2}}</div></div><div layout=\"row\" layout-align=\"space-between center\" \nng-if=\"vm.saleInfo.bank_admin_fee\"><div>Bank Admin Fee</div><div>{{vm.saleInfo.bank_admin_fee | currency:\'$\':2}}</div>\n</div></div><div layout=\"row\" layout-align=\"space-between center\" \nng-if=\"vm.tradeInVehicle.trade_lien_payout && !vm.ignoreOptions.tradeIn\" \nng-click=\"vm.onAnchorClicked(vm.tradeInAnchor)\"><div>Trade Lien Payout</div><div>\n{{vm.tradeInVehicle.trade_lien_payout | currency:\'$\':2}}</div></div><div layout=\"row\" \nlayout-align=\"space-between center\"><div>Omvic</div><div>{{vm.omvic | currency:\'$\':2}}</div></div></div><div \nlayout=\"row\" class=\"mt-3 font-weight-bold\" layout-align=\"space-between center\"><div>Sub Total</div><div>\n{{vm.subTotalBeforePayments | currency:\'$\':2}}</div></div><div class=\"mt-3\" ng-if=\"vm.payments.length > 0\" \nng-click=\"vm.onAnchorClicked(vm.paymentsAnchor)\"><div class=\"mt-3 font-weight-bold\">Payments</div><md-divider \nclass=\"my-1\"></md-divider><div layout=\"row\" layout-align=\"space-between center\" ng-repeat=\"payment in vm.payments\">\n<div>{{payment.payment_date | date:\"medium\"}}</div><div ng-hide=\"payment.message != \'Void\'\">Void</div><div \nng-hide=\"payment.message != \'Refund\'\">Refund</div><div ng-hide=\"payment.message != \'Declined\'\">Declined</div><div \nng-hide=\"payment.message != \'Approved\'\">Approved</div><div>{{payment.amount * -1 | currency:\'$\':2}}</div></div></div>\n<div class=\"mt-3\" ng-if=\"vm.saleInfo.lien_registration != null && !vm.ignoreOptions.financing\" \nng-click=\"vm.onAnchorClicked(vm.financingAnchor)\"><div class=\"mt-3 font-weight-bold\">Finance</div><md-divider \nclass=\"my-1\"></md-divider><div layout=\"row\" layout-align=\"space-between center\"><div>Total Amount To Be Financed</div>\n<div>{{vm.totalAmountToBeFinanced | currency:\'$\':2}}</div></div><div layout=\"row\" layout-align=\"space-between center\">\n<div>Cost Of Borrowing ({{vm.saleInfo.interest_rate * 100 | number : 2}}%)</div><div>\n{{vm.saleInfo.cost_of_borrowing | currency:\'$\':2}}</div></div></div><div layout=\"row\" class=\"font-weight-bold mt-5\" \nlayout-align=\"space-between center\" style=\"font-size: 16px\"><div>BALANCE DUE</div><div>\n{{vm.totalBalanceDue | currency:\'$\':2}}</div></div><div class=\"mt-3 text-grey\" ng-if=\"vm.showSensitiveContent\"><div \nclass=\"mt-3 font-weight-bold\">Funds</div><md-divider class=\"my-1\"></md-divider><div layout=\"row\" \nlayout-align=\"space-between center\"><div>Subtotal</div><div>{{vm.subTotalBeforePayments | currency:\'$\':2}}</div></div>\n<div ng-if=\"!vm.ignoreOptions.financing\" ng-click=\"vm.onAnchorClicked(vm.financingAnchor)\"><div layout=\"row\" \nlayout-align=\"space-between center\" ng-if=\"vm.saleInfo.dealer_reserve\"><div>Dealer Reserve</div><div>\n{{vm.saleInfo.dealer_reserve | currency:\'$\':2}}</div></div><div layout=\"row\" layout-align=\"space-between center\" \nng-if=\"vm.saleInfo.lien_registration\"><div>Lein Registration</div><div>\n{{vm.saleInfo.lien_registration | currency:\'$\':2}}</div></div><div layout=\"row\" layout-align=\"space-between center\" \nng-if=\"vm.saleInfo.bank_admin_fee\"><div>Bank Admin Fee</div><div>{{vm.saleInfo.bank_admin_fee | currency:\'$\':2}}</div>\n</div></div><div layout=\"row\" layout-align=\"space-between center\" \nng-if=\"vm.tradeInVehicle.trade_lien_payout && !vm.ignoreOptions.tradeIn\" \nng-click=\"vm.onAnchorClicked(vm.tradeInAnchor)\"><div>Lein Payout</div><div>\n{{vm.tradeInVehicle.trade_lien_payout | currency:\'$\':2}}</div></div><div layout=\"row\" \nlayout-align=\"space-between center\" \nng-if=\"vm.tradeInVehicle.trade_lien_payout && !vm.ignoreOptions.tradeIn && !vm.showNetFund\" \nng-click=\"vm.onAnchorClicked(vm.tradeInAnchor)\"><div>Net Fund</div><div>\n{{vm.tradeInVehicle.trade_lien_payout | currency:\'$\':2}}</div></div><div layout=\"row\" \nlayout-align=\"space-between center\"><div>Total to be deposited</div><div>{{vm.totalToBeDeposited | currency:\'$\':2}}\n</div></div><div layout=\"row\" layout-align=\"space-between center\"><div>Balance Owing</div><div>\n{{vm.totalOwning | currency:\'$\':2}}</div></div></div></div></div>");
$templateCache.put("app/main/safety/components/safety-conner-info-form.html","<form name=\"connerInfoForm\" style=\"font-size: 13px\"><span class=\"badge badge-secondary my-2\">Disk Break</span><div \nlayout=\"row\"><md-input-container flex=\"50\" \nclass=\"input-box info-form-item small-input-box purchase-step-payment-input-box\"><input type=\"text\" autocorrect=\"off\" \nautocapitalize=\"none\" spellcheck=\"false\" name=\"rotorThickness\" ng-model=\"vm.rotorThickness\" autocomplete=\"off\" \nplaceholder=\"Rotor Thickness (mm)\" maxlength=\"10\" input-control input-options=\"vm.inputControlOptions\" \ninput-translate=\"vm.translateToDecimal\"><div ng-messages=\"connerInfoForm.rotorThickness.$error\"><div \nng-message=\"maxlength\">Input content can not be over 10 charactors</div></div></md-input-container></div>\n<md-input-container class=\"input-box info-form-item small-input-box purchase-step-payment-input-box\"><input \ntype=\"text\" autocorrect=\"off\" autocapitalize=\"none\" spellcheck=\"false\" name=\"padThicknessInner\" \nng-model=\"vm.padThicknessInner\" autocomplete=\"off\" placeholder=\"Pad Thickness Meterial Thickness Inner (mm)\" \nmaxlength=\"10\" input-control input-options=\"vm.inputControlOptions\" input-translate=\"vm.translateToDecimal\"><div \nng-messages=\"connerInfoForm.padThicknessInner.$error\"><div ng-message=\"maxlength\">\nInput content can not be over 10 charactors</div></div></md-input-container><md-input-container \nclass=\"input-box info-form-item small-input-box purchase-step-payment-input-box\"><input type=\"text\" autocorrect=\"off\" \nautocapitalize=\"none\" spellcheck=\"false\" name=\"padThicknessOuter\" ng-model=\"vm.padThicknessOuter\" autocomplete=\"off\" \nplaceholder=\"Pad Thickness Meterial Thickness Outer (mm)\" maxlength=\"10\" input-control \ninput-options=\"vm.inputControlOptions\" input-translate=\"vm.translateToDecimal\"><div \nng-messages=\"connerInfoForm.padThicknessOuter.$error\"><div ng-message=\"maxlength\">\nInput content can not be over 10 charactors</div></div></md-input-container><span class=\"badge badge-secondary my-2\">\nBreak Drums</span><div layout=\"row\"><md-input-container flex=\"50\" \nclass=\"input-box info-form-item small-input-box purchase-step-payment-input-box\"><input type=\"text\" autocorrect=\"off\" \nautocapitalize=\"none\" spellcheck=\"false\" name=\"shoeLiningThickness\" ng-model=\"vm.shoeLiningThickness\" \nautocomplete=\"off\" placeholder=\"Shoe Lining Thickness (mm)\" maxlength=\"10\" input-control \ninput-options=\"vm.inputControlOptions\" input-translate=\"vm.translateToDecimal\"><div \nng-messages=\"connerInfoForm.shoeLiningThickness.$error\"><div ng-message=\"maxlength\">\nInput content can not be over 10 charactors</div></div></md-input-container><md-input-container flex=\"50\" \nclass=\"input-box info-form-item small-input-box purchase-step-payment-input-box\"><input type=\"text\" autocorrect=\"off\" \nautocapitalize=\"none\" spellcheck=\"false\" name=\"drumDiameter\" ng-model=\"vm.drumDiameter\" autocomplete=\"off\" \nplaceholder=\"Drum Diameter (mm)\" maxlength=\"10\" input-control input-options=\"vm.inputControlOptions\" \ninput-translate=\"vm.translateToDecimal\"><div ng-messages=\"connerInfoForm.drumDiameter.$error\"><div \nng-message=\"maxlength\">Input content can not be over 10 charactors</div></div></md-input-container></div><span \nclass=\"badge badge-secondary my-2\">Tire</span><div layout=\"row\"><md-input-container flex=\"50\" \nclass=\"input-box info-form-item small-input-box purchase-step-payment-input-box\"><input type=\"text\" autocorrect=\"off\" \nautocapitalize=\"none\" spellcheck=\"false\" name=\"treadDepth\" ng-model=\"vm.treadDepth\" autocomplete=\"off\" \nplaceholder=\"Tread Depth (mm)\" maxlength=\"10\" input-control input-options=\"vm.inputControlOptions\" \ninput-translate=\"vm.translateToDecimal\"><div ng-messages=\"connerInfoForm.treadDepth.$error\"><div \nng-message=\"maxlength\">Input content can not be over 10 charactors</div></div></md-input-container><md-input-container \nflex=\"50\" class=\"input-box info-form-item small-input-box purchase-step-payment-input-box\"><input type=\"text\" \nautocorrect=\"off\" autocapitalize=\"none\" spellcheck=\"false\" name=\"inflationPressure\" ng-model=\"vm.inflationPressure\" \nautocomplete=\"off\" placeholder=\"Inflation Pressure(PSI)\" maxlength=\"10\" input-control \ninput-options=\"vm.inputControlOptions\" input-translate=\"vm.translateToDecimal\"><div \nng-messages=\"connerInfoForm.inflationPressure.$error\"><div ng-message=\"maxlength\">\nInput content can not be over 10 charactors</div></div></md-input-container></div><div layout=\"row\"><md-input-container\n flex=\"50\" class=\"input-box info-form-item small-input-box purchase-step-payment-input-box\"><input type=\"text\" \nautocorrect=\"off\" autocapitalize=\"none\" spellcheck=\"false\" name=\"correctedLargerThan5Psi\" \nng-model=\"vm.correctedLargerThan5Psi\" autocomplete=\"off\" placeholder=\"Initial reading (PSI) (If Corrected > 5 PSI )\" \nmaxlength=\"10\" input-control input-options=\"vm.inputControlOptions\" input-translate=\"vm.translateToDecimal\"><div \nng-messages=\"connerInfoForm.correctedLargerThan5Psi.$error\"><div ng-message=\"maxlength\">\nInput content can not be over 10 charactors</div></div></md-input-container><md-input-container flex=\"50\" \nclass=\"input-box info-form-item small-input-box purchase-step-payment-input-box\"><input type=\"text\" autocorrect=\"off\" \nautocapitalize=\"none\" spellcheck=\"false\" name=\"finalReading\" ng-model=\"vm.finalReading\" autocomplete=\"off\" \nplaceholder=\"Final reading (PSI) (If Corrected > 5 PSI )\" maxlength=\"10\" input-control \ninput-options=\"vm.inputControlOptions\" input-translate=\"vm.translateToDecimal\"><div \nng-messages=\"connerInfoForm.finalReading.$error\"><div ng-message=\"maxlength\">\nInput content can not be over 10 charactors</div></div></md-input-container></div></form>");
$templateCache.put("app/main/safety/components/safety-general-info-form.html","<form name=\"safetyGeneralInfoForm\" style=\"font-size: 13px\"><div layout=\"row\" layout-align=\"start center\" class=\"mt-3\">\n<div flex=\"50\" layout=\"row\" layout-align=\"start center\" style=\"height: 60px\"><div class=\"text-nowrap text-truncate\">\nInspector: {{vm.currentInspector.first_name}} {{vm.currentInspector.last_name}}<span class=\"text-red\" \nng-if=\"vm.currentInspectorInvalid\">(not a mechanic)</span></div></div><md-autocomplete flex=\"50\" md-no-cache=\"true\" \nmd-selected-item=\"vm.currentInspector\" md-search-text=\"vm.searchText\" \nmd-selected-item-change=\"vm.selecteInspector(item)\" md-items=\"item in vm.queryUser(vm.searchText)\" \nmd-item-text=\"item.first_name + \' \' + item.last_name\" md-min-length=\"0\" placeholder=\"Search\"><md-item-template><span \nmd-highlight-text=\"vm.searchText\" md-highlight-flags=\"^i\">{{item.first_name}} {{item.last_name}}</span>\n</md-item-template><md-not-found>No states matching \"{{vm.searchText}}\" were found.</md-not-found></md-autocomplete>\n</div><div layout=\"row\" layout-align=\"start center\" style=\"height: 60px\"><div flex=\"50\">Gas Tank:</div><md-slider \nflex=\"grow\" ng-model=\"vm.safety.gas_tank\" min=\"0\" step=\"0.01\" max=\"1\" class=\"md-secondary\"></md-slider></div><div \nlayout=\"row\" layout-align=\"start center\" style=\"height: 60px\"><div flex=\"50\">Inspection Result:</div><md-checkbox \nclass=\"mb-0\" ng-model=\"vm.safetyResultPass\" ng-change=\"vm.setSafetyResultPassOption()\">Pass</md-checkbox><md-checkbox \nclass=\"mb-0\" ng-model=\"vm.safetyResultFail\" ng-change=\"vm.setSafetyResultFailOption()\">Fail</md-checkbox></div><div \nlayout=\"row\" layout-align=\"start center\" style=\"height: 60px\"><div flex>Inspection Date:</div><md-input-container flex \nclass=\"ml-5 info-form-item small-input-box purchase-step-payment-input-box\"><label>Inspection Date:</label>\n<md-datepicker md-hide-icons=\"calendar\" ng-model=\"vm.inspectionDatePickerValue\" \nng-change=\"vm.setInspectionDate(vm.inspectionDatePickerValue)\" name=\"inspectionDate\"></md-datepicker><div \nng-messages=\"safetyGeneralInfoForm.inspectionDate.$error\"><div ng-message=\"valid\">Invalid date.</div></div>\n</md-input-container></div><div layout=\"row\" layout-align=\"start center\" style=\"height: 60px\"><div flex>Mileage:</div>\n<md-input-container flex=\"50\" class=\"input-box info-form-item small-input-box purchase-step-payment-input-box pr-0\">\n<input type=\"text\" autocorrect=\"off\" autocapitalize=\"none\" spellcheck=\"false\" name=\"mileage\" \nng-model=\"vm.safety.mileage\" autocomplete=\"off\" placeholder=\"Mileage\" ng-pattern=\"/^[0-9]*$/\" maxlength=\"10\"><div \nng-messages=\"safetyGeneralInfoForm.mileage.$error\"><div ng-message=\"maxlength\">\nInput content can not be over 10 charactors</div><div ng-message=\"pattern\">Only number accepted</div></div>\n</md-input-container></div><div layout=\"row\" layout-align=\"start center\" style=\"height: 60px\"><div flex>\nSafety Certificate Number:</div><md-input-container flex=\"50\" \nclass=\"input-box info-form-item small-input-box purchase-step-payment-input-box pr-0\"><input type=\"text\" \nautocorrect=\"off\" autocapitalize=\"none\" spellcheck=\"false\" name=\"safetyCertificateNumber\" \nng-model=\"vm.safety.safety_certificate_number\" autocomplete=\"off\" placeholder=\"Safety Certified Number\" maxlength=\"10\">\n<div ng-messages=\"safetyGeneralInfoForm.safetyCertificateNumber.$error\"><div ng-message=\"maxlength\">\nInput content can not be over 10 charactors</div></div></md-input-container></div><div class=\"my-5\">\nInspection Comments:</div><textarea style=\"width:100%\" rows=\"3\" ng-model=\"vm.safety.inspection_comments\" \nclass=\"info-form-item detail-info-form-note-input\" placeholder=\"\">\r\n	</textarea></form>");
$templateCache.put("app/main/safety/components/safety-images-list.html","<div class=\"simple-border px-2 pb-2\"><div layout=\"row\" layout-align=\"space-between center\"><div>{{::vm.tag.name}}</div>\n<md-button class=\"btn-sm btn-secondary mx-0\">Add Images <input multiple=\"multiple\" \noptions=\"{tag:vm.tag.id_safety_image_tag}\" class=\"fileInput\" nv-file-select=\"false\" uploader=\"vm.imageUploader\" \ntype=\"file\" accept=\"image/*\"></md-button></div><md-content layout=\"row\" style=\"height: 80px\"><div \nonmousedown=\"return false\" class=\"mr-3\" flex=\"none\" ng-repeat=\"image in vm.images\" style=\"position: relative\"><img \nng-src=\"{{::image.url}}\" style=\"height: 80px; width: 100px; object-fit: cover\" ng-click light-gallery \nimagesource=\"{{vm.galleryList}}\" index=\"{{$index}}\"> <i ng-click=\"vm.onDeleteClicked(image, $index)\" \nng-if=\"!image.isProcessing\" style=\"position: absolute;top: 0% ; right: 0%\" \nclass=\"p-0 m-0 icon-delete-forever text-red\"></i><md-progress-circular style=\"position: absolute; left: 30%; top:30%\" \nng-if=\"image.isProcessing\" class=\"basic-info-form-img-progress\" md-diameter=\"30px\"></md-progress-circular></div><div \nng-if=\"imageInQueue.tag == vm.tag.id_safety_image_tag\" onmousedown=\"return false\" class=\"mr-3\" flex=\"none\" \nng-repeat=\"imageInQueue in vm.imageUploader.queue\" style=\"position: relative\"><img \nstyle=\"height: 80px; width: 100px; object-fit: cover\" class=\"opacity-50\" ng-src=\"{{::imageInQueue.imageSrc}}\"> <i \nng-click=\"imageInQueue.remove()\" ng-if=\"!imageInQueue.isUploading && !imageInQueue.isUploaded\" \nstyle=\"position: absolute;top: 0% ; right: 0%\" class=\"p-0 m-0 icon-delete-forever text-red\"></i><md-progress-circular \nng-if=\"imageInQueue.isUploading\" style=\"position: absolute; left: 30%; top:30%\" \nclass=\"md-hue-2 basic-info-form-img-progress\" md-diameter=\"35px\"></md-progress-circular></div></md-content></div>");
$templateCache.put("app/main/settings/google-service/google-service.html","<div ng-if=\"vm.tokenInfo.email\"><div>you are authorized by : {{vm.tokenInfo.email}}</div></div><div \nng-if=\"!vm.tokenInfo.email\">you are not authorized</div><md-button class=\"btn-secondary\" ng-disable=\"vm.isProcessing\" \nng-click=\"vm.signIn()\">{{vm.tokenInfo.email? \"Change account\": \"Sign in\"}}</md-button>");
$templateCache.put("app/main/settings/goto/goto-settings.html","<div id=\"goto-settings\" class=\"page-layout simple fullwidth\" layout=\"column\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"start center\"><div class=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div \nclass=\"h1\">GoTo</div><div class=\"subtitle secondary-text\">\nSite-wide call channel for live and historical dealership calls.</div></div></div><div class=\"content p-24\" \nlayout=\"column\"><md-card><md-card-title><md-card-title-text><span class=\"md-headline\">Site-wide connection</span> <span\n class=\"md-subhead\">\nConnect with a GoTo super admin account. The refresh token is stored in the database until you reconnect here.</span>\n</md-card-title-text></md-card-title><md-card-content layout=\"column\"><div ng-if=\"vm.isLoading\">Loading GoTo status...\n</div><div ng-if=\"!vm.isLoading\" layout=\"column\"><p><strong>Configured:</strong>\n {{ vm.status.configured ? \'Yes\' : \'No\' }}</p><p ng-if=\"vm.status.principal\"><strong>Connected as:</strong>\n {{ vm.status.principal }}</p><p><strong>Live channel:</strong> <span ng-if=\"vm.status.channelConnected\">Connected\n</span> <span ng-if=\"vm.status.channelConnecting\">Connecting...</span> <span \nng-if=\"!vm.status.channelConnected && !vm.status.channelConnecting\">Not connected</span></p><p \nng-if=\"vm.status.lastError\" class=\"warn-text\"><strong>Last error:</strong> {{ vm.status.lastError }}</p><p \nclass=\"secondary-text\">\nStaff can still connect their own GoTo accounts from the call panel for outbound dialing. This setting controls the shared incoming call feed.\n</p></div></md-card-content><md-card-actions layout=\"row\" layout-align=\"start center\"><md-button \nclass=\"md-raised md-primary\" ng-disabled=\"vm.isProcessing\" ng-click=\"vm.connectSite()\">\n{{ vm.status.configured ? \'Reconnect site-wide GoTo\' : \'Connect site-wide GoTo\' }}</md-button><md-button \nclass=\"md-raised\" ng-disabled=\"vm.isProcessing || !vm.status.configured\" ng-click=\"vm.disconnectSite()\">\nDisconnect site-wide GoTo</md-button></md-card-actions></md-card></div></div>");
$templateCache.put("app/main/settings/preset-packages/preset-package-list.html","<md-divider class=\"mb-1\"></md-divider><div ng-repeat=\"package in vm.presetPackages\" class=\"my-2\"><div layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\" \nng-click=\"vm.showItems[package.id_preset_package] = !vm.showItems[package.id_preset_package]\"><div \nclass=\"text-nowrap text-truncate\" ng-class=\"package.isActive()? [\'\']:[\'strike\', \'text-grey\']\">{{package.name}}</div><i \nng-class=\"vm.showItems[package.id_preset_package]? [\'icon-chevron-up\']:[\'icon-chevron-down\']\"></i></div><div><button \nstyle=\"width: 24px\" ng-click=\"vm.dialogedit(package)\"><i class=\"icon-pen text-secondary ng-scope\"></i></button>\n<md-checkbox class=\"m-0 p-0\" ng-model=\"vm.selectedMap[package.id_preset_package]\"></md-checkbox></div></div><div \nstyle=\"font-size: 13px\" class=\"text-grey\" ng-if=\"vm.showItems[package.id_preset_package]\"><div>\nPrice: {{package.price | currency:\'$\':2}}</div><div>Valid For (Month): {{package.valid_time}}</div><div>\nValid Until (Assigned Vehicle base Mileage + Mileage): {{package.valid_mileage || \"No Limit\"}}</div><div>\nSales Active Until: {{package.active_expiry_date || \"None\"}}</div><div ng-if=\"!(package.items.length > 0)\">\nNo item in this package</div><div layout=\"row\" layout-align=\"space-between center\" ng-repeat=\"item in package.items\">\n<div>{{item.name}} * {{item.quantity}}</div></div><md-divider \nng-if=\"(package.items[0].fk_id_job)  && vm.getJobNameWithId(item)\" class=\"mb-1\"></md-divider><div layout=\"column\" \nlayout-align=\"space-between left\" ng-repeat=\"item in package.items\"><br><p \nng-if=\"item.fk_id_job && vm.getJobNameWithId(item)\">Job ID: {{item.fk_id_job}}<br>\nJob Description: {{vm.getJobNameWithId(item)}}</p><div ng-repeat=\"job in vm.jobList\" \nng-if=\"item.fk_id_job && !item.coverage_json\"><div ng-if=\"job.id_job == item.fk_id_job\">{{job.name}}<div \nng-repeat=\"part in job.job_part\">Part: {{part.part_name || \"None\"}} * {{part.part_quantity || 0}}</div><div \nng-repeat=\"labour in job.job_labour\">Labours: {{labour.labour_name || \"None\"}} * {{labour.labour_quantity || 0}}</div>\n<div ng-repeat=\"miscfee in job.job_miscfee\">\nMisc Fees: {{miscfee.miscfees_name || \"None\"}} * {{miscfee.miscfees_quantity || 0}}</div></div></div><div \nng-repeat=\"coverageItem in item.coverage_json\" ng-if=\"item.coverage_json\"><div><div ng-repeat=\"part in coverageItem\"><a\n ng-if=\"part.part_name\">\nPart: {{part.part_name || \"None\"}} * {{part.part_quantity || 0}}, Coverage: ${{part.part_coverage}}</a></div><div \nng-repeat=\"labour in coverageItem\"><a ng-if=\"labour.labour_name\">\nLabours: {{labour.labour_name || \"None\"}} * {{labour.labour_quantity || 0}}, Coverage: ${{labour.labour_coverage}}</a>\n</div><div ng-repeat=\"miscfee in coverageItem\"><a ng-if=\"miscfee.miscfees_name\">\nMisc Fees: {{miscfee.miscfees_name || \"None\"}} * {{miscfee.miscfees_quantity || 0}}, Coverage: ${{miscfee.miscfees_coverage}}\n</a></div></div></div></div><md-divider ng-if=\"(package.items[0].fk_id_job)\" class=\"mb-1\"></md-divider></div></div><div\n ng-if=\"!(vm.presetPackages.length > 0)\">No item found</div><md-divider class=\"mt-1\"></md-divider>");
$templateCache.put("app/main/settings/preset-packages/preset-packages.html","<div style=\"width: 100%\" class=\"bg-secondary header-backgroud\" layout=\"row\" layout-align=\"center center\"><div flex \nclass=\"content-max-width content-padding-full\"><span class=\"h2 white-fg\">All Packages</span></div></div><div \nstyle=\"width: 100%\" layout=\"row\" layout-align=\"center start\"><div flex class=\"content-max-width content-padding-half\">\n<div layout=\"row\" class=\"content-padding-half\"><div flex=\"100\" flex-gt-sm=\"50\">Preset Packages:<preset-package-list \npackage-item-types=\"vm.packageItemTypes\" get-selected-packages=\"vm.getSelectedPackages\" \npreset-packages=\"vm.presetPackages\" job-list=\"vm.jobTyppList\" refresh-preset-packages=\"vm.initPresetPackages\">\n</preset-package-list><div layout=\"row\" layout-align=\"end center\"><button class=\"mr-2\" \nng-disabled=\"vm.isDeleting || !(vm.getSelectedPackages().length > 0)\" ng-click=\"vm.deletePackages()\"><i \nng-class=\"vm.isDeleting || !(vm.getSelectedPackages().length > 0)? [\'\'] : [\'text-red\']\" class=\"icon-delete-forever\">\n</i></button></div></div></div></div></div>");
$templateCache.put("app/main/tasks/edit-task/edit-task.html","<div class=\"page-layout carded fullwidth single-scroll\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\" layout=\"column\" flex><div class=\"header\"><span class=\"h2 white-fg\">Edit Task</span></div><div \nclass=\"content-card page-content-container\" layout=\"column\" flex><md-content class=\"content\" flex ms-scroll>\n<task-info-form constants=\"vm.constants\" task=\"vm.taskToBeEdited\" is-form-valid=\"vm.isTaskInfoFormValid\">\n</task-info-form><task-file-uploader file-uploader=\"vm.fileUploader\" uploaded-files=\"vm.taskFiles\" \non-delete-click=\"vm.deleteFile\" on-copy-link-click=\"vm.copyLinkToClipboard\" \nremove-file-form-queue=\"vm.removeFileFormQueue\"></task-file-uploader><div layout=\"row\" \nlayout-align=\"space-between center\" style=\"max-width: 500px\"><md-button class=\"btn-danger mx-0 text-black\" \nng-click=\"vm.deleteTask()\" ng-disabled=\"vm.fileUploader.isUploading || vm.isProcessingTask\">delete</md-button>\n<md-button class=\"btn-secondary mx-0 text-black\" ng-click=\"vm.saveChanges()\" \nng-disabled=\"vm.isProcessingTask || vm.fileUploader.isUploading\">save</md-button></div></md-content></div></div></div>");
$templateCache.put("app/main/tasks/edit-task/task-file-uploader.html","<div layout=\"column\" style=\"max-width: 500px\"><div layout=\"column\" layout-align=\"center center\" \nclass=\"task-file-uploader bg-white\" nv-file-drop=\"\" nv-file-over=\"\" uploader=\"vm.fileUploader\"><div>\nDrag and drop files here</div><div layout=\"row\"><md-button class=\"btn-secondary btn-sm task-file-uploader-button\">\nSelect Files <input class=\"fileInput\" nv-file-select=\"false\" uploader=\"vm.fileUploader\" multiple=\"multiple\" \ntype=\"file\"></md-button></div></div><md-content class=\"bg-transparent scrollable task-file-list\" ms-scroll><div \nlayout=\"row\" class=\"task-file-list-item\" layout-align=\"space-between center\" \nng-repeat=\"itemInQueue in vm.fileUploader.queue track by $index\"><div layout=\"row\" flex=\"60\" \nlayout-align=\"start center\"><div><md-icon flex=\"nogrow\" class=\"icon-file-outline\"></md-icon></div><div \nclass=\"text-nowrap text-truncate\">{{itemInQueue.file.name}}</div></div><div layout=\"row\" \nlayout-align=\"space-between center\"><md-progress-circular ng-if=\"itemInQueue.isUploading\" class=\"md-hue-2 mr-4\" \nmd-diameter=\"20px\"></md-progress-circular><md-button class=\"md-icon-button\" \nng-click=\"vm.removeFileFormQueue(itemInQueue)\" ng-disabled=\"itemInQueue.isUploading\"><md-icon \nclass=\"icon-minus-circle text-red\"></md-icon></md-button></div></div><div layout=\"row\" class=\"task-file-list-item\" \nlayout-align=\"space-between center\" ng-repeat=\"file in vm.uploadedFiles track by $index\"><div layout=\"row\" flex=\"60\" \nlayout-align=\"start center\"><div><md-icon flex=\"nogrow\" class=\"icon-file-outline\"></md-icon></div><div><a \nhref=\"{{vm.getFileUrl(file.uuid)}}\" class=\"text-nowrap text-truncate\">{{file.file_name}}</a><md-tooltip \nmd-direction=\"top\">{{file.file_name}}</md-tooltip></div></div><div layout=\"row\"><md-button class=\"md-icon-button\">\n<md-icon class=\"icon-content-copy text-secondary\" ng-click=\"vm.onCopyLinkClick(file.uuid)\"></md-icon></md-button>\n<md-button class=\"md-icon-button\"><md-icon class=\"icon-minus-circle text-red\" \nng-click=\"vm.onDeleteClick(file, $index)\"></md-icon></md-button></div></div></md-content></div>");
$templateCache.put("app/main/tasks/browse-tasks/browse-tasks.html","<div class=\"page-layout carded fullwidth single-scroll\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\" layout=\"column\" flex><div class=\"header\"><span class=\"h2 white-fg\">Browse Tasks</span></div><div \nclass=\"content-card page-content-container\" layout=\"column\" flex><md-content class=\"content\" flex ms-scroll><div \nlayout=\"row\" layout-align=\"center center\"><tasks-table flex=\"100\" on-filter-change=\"vm.onFilterChange\" \nconstants=\"vm.constants\" user-options=\"vm.userOptions\" filters=\"vm.filters\"></tasks-table></div></md-content></div>\n</div></div>");
$templateCache.put("app/main/tasks/browse-tasks/tasks-table.html","<div layout=\"column\"><div layout=\"row\" layout-wrap layout-align=\"space-between start\"><div flex=\"100\" flex-gt-sm=\"60\">\n<div layout=\"row\" layout-wrap layout-align=\"start center\"><md-input-container flex=\"50\" flex-gt-sm=\"20\"><label>User\n</label><md-select ng-model=\"vm.filters.userId\" ng-change=\"vm.retrieveTaskList()\"><md-option ng-value=\"undefined\" \nng-selected=\"!vm.filters.userId\">ALL</md-option><md-option ng-value=\"user.getResourceID()\" \nng-repeat=\"user in vm.userOptions | orderBy:\'first_name\'\">{{::user.first_name}} {{::user.last_name}}</md-option>\n</md-select></md-input-container><md-input-container flex=\"50\" flex-gt-sm=\"20\"><label>Category</label><md-select \nng-model=\"vm.filters.category\" ng-change=\"vm.retrieveTaskList()\"><md-option ng-value=\"undefined\" \nng-selected=\"!vm.filters.category\">ALL</md-option><md-option ng-value=\"category.id_task_category\" \nng-repeat=\"category in vm.constants.taskCategories  | orderBy:\'name\'\">{{::category.name}}</md-option></md-select>\n</md-input-container><md-input-container flex=\"50\" flex-gt-sm=\"20\"><label>Status</label><md-select \nng-model=\"vm.filters.status\" ng-change=\"vm.retrieveTaskList()\"><md-option ng-value=\"undefined\" \nng-selected=\"!vm.filters.status\">ALL</md-option><md-option ng-value=\"vm.notCompletedTag\">Not Completed</md-option>\n<md-option ng-value=\"status.id_task_status\" ng-repeat=\"status in vm.constants.taskStatus  | orderBy:\'name\'\">\n{{::status.name}}</md-option></md-select></md-input-container><md-input-container flex=\"50\" flex-gt-sm=\"20\"><label>\nPriority</label><md-select ng-model=\"vm.filters.priority\" ng-change=\"vm.retrieveTaskList()\"><md-option \nng-value=\"undefined\" ng-selected=\"!vm.filters.priority\">ALL</md-option><md-option ng-value=\"priority.id_task_priority\" \nng-repeat=\"priority in vm.constants.taskPriorities | orderBy:\'name\'\">{{::priority.name}}</md-option></md-select>\n</md-input-container><md-input-container flex=\"50\" flex-gt-sm=\"20\" ng-if=\"!vm.isVechileIdSpecified()\"><label>Location\n</label><md-select ng-model=\"vm.filters.location\" ng-change=\"vm.retrieveTaskList()\"><md-option ng-value=\"undefined\" \nng-selected=\"!vm.filters.location\">ALL</md-option><md-option ng-value=\"location.id_location\" \nng-repeat=\"location in vm.constants.locations | orderBy:\'name\'\">{{::location.name}}</md-option></md-select>\n</md-input-container></div><div layout=\"row\"><md-input-container flex=\"100\" flex-gt-sm=\"40\"><input \nng-model=\"vm.filters.searchText\" ng-model-options=\"{ debounce: 700 }\" placeholder=\"Search\" \nng-change=\"vm.retrieveTaskList()\" autocomplete=\"off\"></md-input-container></div></div><custom-filter-list flex=\"100\" \nflex-gt-sm=\"30\" ng-if=\"!vm.filters.vehicleId\" filters=\"vm.customFilters\" \nis-loading=\"vm.isFetchingTaskData || vm.isProcessingFilter\" on-apply=\"vm.applyCustomFilter\" \non-delete=\"vm.deleteCustomFilter\" on-save=\"vm.saveCustomFilter\"></custom-filter-list></div><table flex \nclass=\"table table-hover table-responsive\" style=\"table-layout: fixed\"><thead><tr><th class=\"text-nowrap\" \nstyle=\"width: 5%\" ng-if=\"vm.tasks.length > 0\"><md-checkbox ng-model=\"vm.allChecked\" class=\"m-0 p-0\" \nng-change=\"vm.selectAll()\"></md-checkbox></th><th ng-click=\"vm.sortingFilter = \'name\'; vm.isReverse = !vm.isReverse\" \nclass=\"text-nowrap\" style=\"width: 25%\">Task Name<md-icon \nng-style=\"{visibility: vm.sortingFilter == \'name\'? \'visible\':\'hidden\'}\" \nng-class=\"vm.isReverse? [\'icon-chevron-up\']:[\'icon-chevron-down\']\"></md-icon></th><th \nng-click=\"vm.sortingFilter = \'fk_id_status_priority\'; vm.isReverse = !vm.isReverse\" class=\"text-nowrap\" \nstyle=\"width: 10%\">Status<md-icon \nng-style=\"{visibility: vm.sortingFilter == \'fk_id_status_priority\'? \'visible\':\'hidden\'}\" \nng-class=\"vm.isReverse? [\'icon-chevron-up\']:[\'icon-chevron-down\']\"></md-icon></th><th \nng-click=\"vm.sortingFilter = \'fk_id_task_priority\'; vm.isReverse = !vm.isReverse\" class=\"text-nowrap\" \nstyle=\"width: 10%\">Priority<md-icon \nng-style=\"{visibility: vm.sortingFilter == \'fk_id_task_priority\'? \'visible\':\'hidden\'}\" \nng-class=\"vm.isReverse? [\'icon-chevron-up\']:[\'icon-chevron-down\']\"></md-icon></th><th \nng-click=\"vm.sortingFilter = \'fk_id_task_category\'; vm.isReverse = !vm.isReverse\" class=\"text-nowrap\" \nstyle=\"width: 10%\">Category<md-icon \nng-style=\"{visibility: vm.sortingFilter == \'fk_id_task_category\'? \'visible\':\'hidden\'}\" \nng-class=\"vm.isReverse? [\'icon-chevron-up\']:[\'icon-chevron-down\']\"></md-icon></th><th \nng-click=\"vm.sortingFilter = \'due_date\'; vm.isReverse = !vm.isReverse\" class=\"text-nowrap\" style=\"width: 10%\">Due Date\n<md-icon ng-style=\"{visibility: vm.sortingFilter == \'due_date\'? \'visible\':\'hidden\'}\" \nng-class=\"vm.isReverse? [\'icon-chevron-up\']:[\'icon-chevron-down\']\"></md-icon></th><th class=\"text-nowrap\" \nstyle=\"width: 10%\">Assigned to</th><th class=\"text-nowrap\" ng-if=\"!vm.vehicleId\" style=\"width: 20%\">Vehicle</th></tr>\n</thead><tbody><tr ng-if=\"!(vm.tasks.length > 0)\"><td>No item found.</td></tr><tr ng-repeat=\"task in vm.tasks\"><td>\n<md-checkbox ng-model=\"vm.selectedTaskList[task.id_task]\" class=\"m-0 p-0\"></md-checkbox></td><td><div \nclass=\"text-nowrap text-truncate\"><a href=\"{{vm.getTaskPageUrl(task)}}\">{{vm.getTaskName(task)}}</a></div></td><td><div\n class=\"text-nowrap text-truncate\">{{vm.getStatusName(task.fk_id_task_status)}}</div></td><td><div \nclass=\"text-nowrap text-truncate task-table-cell-priority\" ng-style=\"vm.getPriorityColor(task.fk_id_task_priority)\">\n{{vm.getPriorityName(task.fk_id_task_priority)}}</div></td><td><div class=\"text-nowrap text-truncate\">\n{{vm.getCategoryName(task.fk_id_task_category)}}</div></td><td><div class=\"text-nowrap text-truncate\"><span \nclass=\"mr-2\">{{vm.getDueDate(task)}}</span><span>{{vm.getDueTime(task)}}</span></div></td><td><div layout=\"column\" \nlayout-align=\"center center\" class=\"text-nowrap text-truncate task-table-cell-user\" style=\"font-size: 10px\"><div \nng-repeat=\"user in task.assigned_to_users | limitTo:2\">{{user.first_name}} {{user.last_name}}</div><div \nng-if=\"task.assigned_to_users.length > 2\">...</div></div></td><td ng-if=\"!vm.vehicleId\"><div layout=\"column\" \nng-if=\"task.assigned_to_vehicle != null\" class=\"task-table-cell-vehicle\" style=\"font-size: 13px\"><a \nhref=\"{{vm.getVehiclePageUrl(task.assigned_to_vehicle)}}\" class=\"text-nowrap text-truncate\">\n{{vm.getVehicleName(task.assigned_to_vehicle)}} <span class=\"text-red\" \nng-if=\"!vm.getVehicleLocation(task.assigned_to_vehicle.fk_id_location).is_default_location\">\n({{vm.getVehicleLocation(task.assigned_to_vehicle.fk_id_location).name}})</span></a><div \nclass=\"text-nowrap text-truncate\">{{vm.getVehicleVin(task.assigned_to_vehicle)}}</div><div \nclass=\"text-nowrap text-truncate\">{{task.assigned_to_vehicle.exterior_color}}</div></div></td></tr></tbody></table><div\n layout=\"column\" layout-align=\"center center\" layout-gt-sm=\"row\" layout-align-gt-sm=\"space-between center\"><div \nlayout=\"row\" layout-align=\"space-between center\"><md-button class=\"btn-secondary btn-sm\" \nng-disabled=\"vm.isProcessingTask\" ng-click=\"vm.completeMultipleTasks()\">Complete Selected</md-button><md-button \nrestrict rolescansee=\"developer company_manager accountant sales_manager salesman\" class=\"btn-danger btn-sm\" \nng-disabled=\"vm.isProcessingTask\" ng-click=\"vm.deleteMultipleTasks()\">Delete Selected</md-button></div><div \nlayout=\"row\" layout-align=\"center center\"><div flex layout=\"row\" layout-align=\"center center\" ng-if=\"vm.totalPage > 1\">\n<md-button class=\"md-icon-button\" ng-click=\"vm.retrieveTaskList(1)\" \nng-style=\"{visibility: vm.currentPage != 1 ? \'visible\':\'hidden\'}\"><md-icon class=\"icon-page-first text-secondary\">\n</md-icon></md-button><div ng-repeat=\"page in vm.pagesBeforeCurrentPage\" class=\"text-secondary mx-1\" \nng-click=\"vm.retrieveTaskList(page)\">{{page}}</div><div class=\"mx-1\">{{vm.currentPage}}</div><div \nng-repeat=\"page in vm.pagesAfterCurrentPage\" class=\"text-secondary mx-1\" ng-click=\"vm.retrieveTaskList(page)\">{{page}}\n</div><md-button class=\"md-icon-button\" ng-click=\"vm.retrieveTaskList(vm.totalPage)\" \nng-style=\"{visibility: vm.currentPage != vm.totalPage ? \'visible\':\'hidden\'}\"><md-icon \nclass=\"icon-page-last text-secondary\"></md-icon></md-button></div><div class=\"mx-5\">Total tasks: {{vm.totalTask}}</div>\n<div>Display:<select ng-init=\"vm.itemsPerPage = vm.displayOptions[0]\" ng-model=\"vm.itemsPerPage\" \nng-options=\"option for option in vm.displayOptions\" ng-change=\"vm.retrieveTaskList()\"></select></div></div></div></div>");
$templateCache.put("app/main/tasks/add-task/add-task.html","<div class=\"page-layout carded fullwidth single-scroll\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\" layout=\"column\" flex><div class=\"header\"><span class=\"h2 white-fg\">Create Task</span></div><div \nclass=\"content-card page-content-container\" layout=\"column\" flex><md-content class=\"content\" flex ms-scroll>\n<task-info-form constants=\"vm.constants\" task=\"vm.task\" is-form-valid=\"vm.isTaskInfoFormValid\"></task-info-form>\n<task-file-uploader file-uploader=\"vm.fileUploader\" uploaded-files=\"vm.uploadedFiles\" \nremove-file-form-queue=\"vm.removeFileFormQueue\"></task-file-uploader><div layout=\"row\" layout-align=\"end center\" \nstyle=\"max-width: 500px\"><md-button class=\"btn-secondary text-black\" ng-click=\"vm.createTask()\" \nng-disabled=\"vm.isProcessingTask\">create task</md-button></div></md-content></div></div></div>");
$templateCache.put("app/main/vehicles/add-vehicle/add-vehicle.html","<div class=\"page-layout carded fullwidth single-scroll\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"column\"><span class=\"h2 white-fg\">Add Vehicle</span>\n</div><div class=\"content-card page-content-container\" layout=\"column\" flex><md-content class=\"content\" flex ms-scroll>\n<md-tabs md-dynamic-height md-border-bottom><md-tab label=\"GENERAL\"><div layout=\"row\"><vehicle-general-form flex=\"100\" \nflex-gt-sm=\"40\" on-metched-vehicle-click=\"vm.redirect\" on-decode-vin=\"vm.decodeVin\" \nis-form-valid=\"vm.isGeneralFormValid\" vehicle=\"vm.vehicle\"></vehicle-general-form></div><div layout=\"row\">\n<md-input-container flex=\"20\" class=\"small-selector purchase-step-selector pr-5\"><label>Location</label><md-select \nstyle=\"width: 100%\" name=\"location\" ng-model=\"vm.vehicle.fk_id_location\" placeholder=\"Location\"><md-option \nng-repeat=\"location in vm.locations | orderBy:\'name\'\" ng-value=\"{{::location.id_location}}\">{{::location.name}}\n</md-option></md-select></md-input-container></div></md-tab><md-tab label=\"SPECS\"><div layout=\"row\"><vehicle-specs-form\n flex=\"100\" flex-gt-sm=\"40\" is-form-valid=\"vm.isSpecsFormValid\" vehicle=\"vm.vehicle\"></vehicle-specs-form></div>\n</md-tab><md-tab label=\"FEATURES\"><vehicle-feature-list preset-feature-option=\"vm.presetFeatureOptions\" \nadd-feature=\"vm.addFeature\" on-decode-vin=\"vm.refreshFeature\" features=\"vm.features\"></vehicle-feature-list></md-tab>\n</md-tabs><div><md-button class=\"btn-secondary mx-0\" ng-click=\"vm.save()\" ng-disabled=\"vm.isProcessingData\">save\n</md-button></div></md-content></div></div></div>");
$templateCache.put("app/main/vehicles/batch-import-vehicles/batch-import-list.html","<div class=\"p-2\" style=\"background-color: #00FFFF\" layout=\"row\" layout-align=\"start center\" \nng-if=\"vm.hasExistingVehicles\"><i class=\"icon-alert-circle-outline text-red mr-2\"></i> <span>Vehicle(s) marked as <span\n class=\"text-red\">red</span> are already in the system.</span></div><table class=\"table table-hover\" \nstyle=\"table-layout: fixed\"><thead><tr><th scope=\"col\" style=\"width: 5%\">#</th><th scope=\"col\" style=\"width: 20%\">\nVehicle</th><th scope=\"col\" style=\"width: 20%\">Vin</th><th scope=\"col\" style=\"width: 10%\">Mileage</th><th scope=\"col\" \nstyle=\"width: 10%\">Date</th><th scope=\"col\" style=\"width: 20%\">Seller</th><th scope=\"col\" style=\"width: 10%\">Price</th>\n<th scope=\"col\" style=\"width: 5%\"><md-checkbox md-indeterminate=\"vm.isIndeterminate\" ng-if=\"vm.isShowSelectAll()\" \nng-checked=\"vm.isAllSelected()\" ng-click=\"vm.selectAll()\" class=\"m-0 p-0\"></md-checkbox></th></tr></thead><tbody><tr \nng-if=\"!(vm.vehicleAndPurchaseList.length > 0)\"><td colspan=\"2\">No item found.</td></tr><tr \nng-repeat=\"item in vm.vehicleAndPurchaseList\" ng-class=\"item.vehicleID? [\'text-red\']:[]\"><th scope=\"row\">\n{{::$index + 1}}</th><td><div class=\"text-nowrap text-truncate\"><a ng-if=\"item.url\" href=\"{{item.url}}\">\n{{::item.vehicle.getYearMakeModel()}}</a> <span ng-if=\"!item.url\">{{::item.vehicle.getYearMakeModel()}}</span></div>\n</td><td><div class=\"text-nowrap text-truncate\">{{::item.vehicle.vin}}</div></td><td><div \nclass=\"text-nowrap text-truncate\">{{::item.vehicle.mileage | number : 0}} KM</div></td><td><div \nclass=\"text-nowrap text-truncate\">{{::item.purchaseInfo.purchase_date}}</div></td><td><div \nclass=\"text-nowrap text-truncate\">{{::item.purchaseInfo.vendor_seller}}</div></td><td><div \nclass=\"text-nowrap text-truncate\">{{::item.purchaseInfo.purchase_price | currency: \'$\': 0}}</div></td><td><md-checkbox \nng-if=\"!item.isFinished\" ng-change=\"vm.refreshIsSelectAll()\" ng-model=\"item.isSelected\" class=\"m-0 p-0\"></md-checkbox>\n<i ng-if=\"item.isFinished\" class=\"icon-check-circle text-green\"></i></td></tr></tbody></table>");
$templateCache.put("app/main/vehicles/batch-import-vehicles/batch-import-vehicles.html","<div class=\"page-layout carded fullwidth single-scroll\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"column\"><span class=\"h2 white-fg\">Batch Import</span>\n</div><div class=\"content-card page-content-container\" layout=\"column\" flex><md-content class=\"content\" flex ms-scroll>\n<div layout=\"row\" layout-align=\"start center\" class=\"mb-5\"><md-button class=\"btn-sm btn-secondary ml-0\" \nng-disabled=\"vm.isProcessingTask\">Select File <input class=\"fileInput\" nv-file-select=\"false\" \nuploader=\"vm.fileUploader\" type=\"file\" accept=\".csv, application/vnd.ms-excel\"></md-button></div><batch-import-list \nfinish-item=\"vm.finishItem\" get-selected-items=\"vm.getSelectedItems\" init-list=\"vm.initList\"></batch-import-list><div \nlayout=\"row\" layout-align=\"end center\"><md-button ng-disabled=\"vm.isProcessingTask\" \nclass=\"btn-sm btn-secondary mx-0 mt-5\" ng-click=\"vm.importData()\">Import</md-button></div></md-content></div></div>\n</div>");
$templateCache.put("app/main/vehicles/browse-vehicles/browse-vehicles.html","<div layout=\"row\" style=\"height: 100%\"><md-content class=\"bg-white\" flex=\"30\" flex-gt-sm=\"20\" \nstyle=\"height: 100%; min-width: 220px\" layout-padding ng-if=\"vm.showFilter\"><div restrict rolescansee=\"login\" \nclass=\"p-0\"><div layout=\"row\" layout-align=\"space-between center\"><div class=\"font-weight-bold\">\n{{vm.enableTimeRangeFilter ? \"TIME RANGE\" : \"AVAILABILITY\"}}</div><div restrict \nrolescansee=\"developer company_manager accountant sales_manager vehicle_manager\"><md-switch \nng-disabled=\"vm.isFetchingData\" class=\"m-0 p-0\" md-invert ng-model=\"vm.enableTimeRangeFilter\" ng-change=\"vm.refresh()\">\n<div style=\"font-size: 12px\" hide-xs hide-sm show-gt-md>{{!vm.enableTimeRangeFilter ? \"Time range\" : \"Availability\"}}\n</div></md-switch></div></div><md-divider class=\"my-1\"></md-divider><div ng-if=\"!vm.enableTimeRangeFilter\">\n<md-radio-group ng-disabled=\"vm.isFetchingData\" ng-model=\"vm.availableFilter\" ng-change=\"vm.refresh()\"><md-radio-button\n class=\"my-1 p-0\" ng-value=\"vm.allAvailabilityFilterTag\">All</md-radio-button><md-radio-button class=\"my-1 p-0\" \nng-value=\"vm.availableAvailabilityFilterTag\">Available</md-radio-button><md-radio-button class=\"my-1 p-0\" \nng-value=\"vm.onlineAvailabilityFilterTag\">Is Online</md-radio-button></md-radio-group></div><div \nng-if=\"vm.enableTimeRangeFilter\"><md-radio-group ng-disabled=\"vm.isFetchingData\" ng-model=\"vm.timeRangeFilterTag\" \nng-change=\"vm.filterByTimeRange()\"><md-radio-button class=\"my-1 p-0\" ng-value=\"vm.purchaseTimeRageFilterTag\">Purchase\n</md-radio-button><md-radio-button class=\"my-1 p-0\" ng-value=\"vm.soldTimeRageFilterTag\">Sold</md-radio-button>\n</md-radio-group><form layout=\"row\" layout-align=\"space-between center\" layout-wrap name=\"datePickerForm\" \nstyle=\"font-size: 13px\"><md-input-container flex=\"100\" flex-gt-md=\"50\"><label>From</label><md-datepicker \nng-disabled=\"vm.isFetchingData\" md-hide-icons=\"calendar\" ng-model=\"vm.startDate\" md-max-date=\"vm.endDate\" \nng-change=\"vm.filterByTimeRange()\" name=\"startDate\"></md-datepicker><div ng-messages=\"datePickerForm.startDate.$error\">\n<div ng-message=\"valid\">Invalid date.</div><div ng-message=\"maxdate\">Must before end date</div></div>\n</md-input-container><md-input-container flex=\"100\" flex-gt-md=\"50\"><label>To</label><md-datepicker \nng-disabled=\"vm.isFetchingData\" md-hide-icons=\"calendar\" ng-model=\"vm.endDate\" md-min-date=\"vm.startDate\" \nng-change=\"vm.filterByTimeRange()\" name=\"endDate\"></md-datepicker><div ng-messages=\"datePickerForm.endDate.$error\"><div\n ng-message=\"valid\">Invalid date.</div><div ng-message=\"mindate\">Must after start date</div></div></md-input-container>\n</form></div></div><inventory-info-list class=\"mt-3\" ng-show=\"vm.locationInventoryInfo.length > 0\" restrict \nrolescansee=\"login\" title=\"\'LOCATION\'\" tag=\"vm.locationFilterTag\" on-item-change=\"vm.onInventoryFilterChange\" \ninventory-info-list=\"vm.locationInventoryInfo\" item-name-builder=\"vm.locationInventoryInfoItemNameBuilder\" \nselected-item=\"vm.selectedLocationInventoryItem\" is-processing=\"vm.isFetchingData\"></inventory-info-list>\n<inventory-info-list class=\"mt-3\" ng-show=\"vm.yearInventoryInfo.length > 0\" title=\"\'YEAR\'\" tag=\"vm.yearFilterTag\" \non-item-change=\"vm.onInventoryFilterChange\" inventory-info-list=\"vm.yearInventoryInfo\" \nselected-item=\"vm.selectedYearInventoryItem\" is-processing=\"vm.isFetchingData\"></inventory-info-list>\n<inventory-info-list class=\"mt-3\" ng-show=\"vm.makeInventoryInfo.length > 0\" title=\"\'MAKE\'\" tag=\"vm.makeFilterTag\" \non-item-change=\"vm.onInventoryFilterChange\" inventory-info-list=\"vm.makeInventoryInfo\" \nselected-item=\"vm.selectedMakeInventoryItem\" is-processing=\"vm.isFetchingData\"></inventory-info-list>\n<inventory-info-list class=\"mt-3\" ng-show=\"vm.modelInventoryInfo.length > 0\" title=\"\'MODEL\'\" tag=\"vm.modelFilterTag\" \non-item-change=\"vm.onInventoryFilterChange\" inventory-info-list=\"vm.modelInventoryInfo\" \nselected-item=\"vm.selectedModelInventoryItem\" is-processing=\"vm.isFetchingData\"></inventory-info-list>\n<inventory-info-list class=\"mt-3\" ng-show=\"vm.priceInventoryInfo.length > 0\" title=\"\'PRICE\'\" tag=\"vm.priceFilterTag\" \non-item-change=\"vm.onInventoryFilterChange\" inventory-info-list=\"vm.priceInventoryInfo\" \nitem-name-builder=\"vm.priceInventoryInfoItemNameBuilder\" selected-item=\"vm.selectedPriceInventoryItem\" \nis-processing=\"vm.isFetchingData\"></inventory-info-list><inventory-info-list class=\"mt-3\" \nng-show=\"vm.mileageInventoryInfo.length > 0\" title=\"\'MILEAGE\'\" tag=\"vm.mileageFilterTag\" \non-item-change=\"vm.onInventoryFilterChange\" inventory-info-list=\"vm.mileageInventoryInfo\" \nitem-name-builder=\"vm.mileageInventoryInfoItemNameBuilder\" selected-item=\"vm.selectedMileageInventoryItem\" \nis-processing=\"vm.isFetchingData\"></inventory-info-list><div class=\"mt-3 p-0\" restrict \nrolescansee=\"developer company_manager accountant sales_manager\" ng-if=\"vm.hasPermissionAccountant\"><div layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"font-weight-bold\">REPORTS</div><button \nng-click=\"vm.showReportSection = !vm.showReportSection\"><i class=\"m-0 p-0 text-secondary\" \nng-class=\"vm.showReportSection? [\'icon-arrow-up-drop-circle-outline\']:[\'icon-arrow-down-drop-circle-outline\']\"></i>\n</button></div><md-divider class=\"my-1\"></md-divider><div ng-if=\"vm.showReportSection\"><div layout=\"row\" \nlayout-align=\"space-between center\"><div>Sale Report</div><button ng-disabled=\"vm.isFetchingData\" \nng-click=\"vm.generateSaleReport()\"><i class=\"m-0 p-0 icon-download\" \nng-class=\"vm.isFetchingData? [\'text-grey\']:[\'text-secondary\']\"></i></button></div><div layout=\"row\" \nlayout-align=\"space-between center\"><div>Purchase Report</div><button ng-disabled=\"vm.isFetchingData\" \nng-click=\"vm.generatePurchaseReport()\"><i class=\"m-0 p-0 icon-download\" \nng-class=\"vm.isFetchingData? [\'text-grey\']:[\'text-secondary\']\"></i></button></div><div layout=\"row\" \nlayout-align=\"space-between center\"><div>Profit Report</div><button ng-disabled=\"vm.isFetchingData\" \nng-click=\"vm.generateProfitReport()\"><i class=\"m-0 p-0 icon-download\" \nng-class=\"vm.isFetchingData? [\'text-grey\']:[\'text-secondary\']\"></i></button></div><div layout=\"row\" \nlayout-align=\"space-between center\"><div>New Sale Report</div><button ng-disabled=\"vm.isFetchingData\" \nng-click=\"vm.generateNewSaleReport()\"><i class=\"m-0 p-0 icon-download\" \nng-class=\"vm.isFetchingData? [\'text-grey\']:[\'text-secondary\']\"></i></button></div><div layout=\"row\" \nlayout-align=\"space-between center\"><div>New Purchase Report</div><button ng-disabled=\"vm.isFetchingData\" \nng-click=\"vm.generateNewPurchaseReport()\"><i class=\"m-0 p-0 icon-download\" \nng-class=\"vm.isFetchingData? [\'text-grey\']:[\'text-secondary\']\"></i></button></div><div layout=\"row\" \nlayout-align=\"space-between center\"><div>New Profit Report</div><button ng-disabled=\"vm.isFetchingData\" \nng-click=\"vm.generateNewProfitReport()\"><i class=\"m-0 p-0 icon-download\" \nng-class=\"vm.isFetchingData? [\'text-grey\']:[\'text-secondary\']\"></i></button></div></div></div></md-content><md-content \nclass=\"bg-light\" flex=\"grow\" element-scroll-listener on-scroll=\"vm.onScroll\"><div layout=\"column\" layout-gt-sm=\"row\" \nlayout-align-gt-sm=\"space-between center\" layout-margin><div layout=\"row\" flex-order=\"2\" flex-order-gt-sm=\"1\" \nlayout-align=\"start center\" flex-gt-sm=\"none\"><button class=\"mr-2\" ng-click=\"vm.showFilter = !vm.showFilter\"><i \nclass=\"m-0 p-0 icon-tune text-secondary\"></i></button><div style=\"font-size: 16px\">\n{{vm.totalMatchedVehicle? vm.totalMatchedVehicle:0 | number : 0}} Results</div></div><md-input-container class=\"mb-0\" \nmd-no-float flex-order=\"1\" flex-order-gt-sm=\"2\" flex-gt-sm=\"30\"><input type=\"text\" autocorrect=\"off\" \nautocapitalize=\"none\" spellcheck=\"false\" name=\"madeIn\" ng-model=\"vm.searchText\" autocomplete=\"off\" \nplaceholder=\"Search by Year, Make, Model, VIN, Stocknumber\" maxlength=\"50\" ng-model-options=\"{ debounce: 700 }\" \nng-change=\"vm.refresh()\"></md-input-container></div><div layout=\"row\" layout-align=\"start center\" layout-wrap \nlayout-margin><span flex=\"none\" \nng-if=\"vm.availableFilter === vm.availableAvailabilityFilterTag && !vm.enableTimeRangeFilter\" class=\"text-red\">\nAvailable <span class=\"text-grey applied-filter-remove\" ng-click=\"vm.removeFilter(vm.availableAvailabilityFilterTag)\">\n&#10005</span> </span><span flex=\"none\" ng-if=\"vm.startDate !== undefined && vm.enableTimeRangeFilter\" \nclass=\"text-red\"><span ng-if=\"vm.timeRangeFilterTag == vm.soldTimeRageFilterTag\">Sold</span> <span \nng-if=\"vm.timeRangeFilterTag == vm.purchaseTimeRageFilterTag\">Purchased</span>\n after: {{vm.startDate | date : \'mediumDate\'}} <span ng-if=\"!vm.isFetchingData\" \nclass=\"text-grey applied-filter-remove\" ng-click=\"vm.removeFilter(vm.startDateFilterTage)\">&#10005</span> </span><span \nflex=\"none\" ng-if=\"vm.endDate !== undefined && vm.enableTimeRangeFilter\" class=\"text-red\"><span \nng-if=\"vm.timeRangeFilterTag == vm.soldTimeRageFilterTag\">Sold</span> <span \nng-if=\"vm.timeRangeFilterTag == vm.purchaseTimeRageFilterTag\">Purchased</span>\n before: {{vm.endDate | date : \'mediumDate\'}} <span ng-if=\"!vm.isFetchingData\" class=\"text-grey applied-filter-remove\" \nng-click=\"vm.removeFilter(vm.endDateFilterTag)\">&#10005</span> </span><span flex=\"none\" \nng-if=\"vm.yearFilter !== undefined\" class=\"text-red\">{{vm.yearFilter? vm.yearFilter:\'Unknown\'}} <span \nclass=\"text-grey applied-filter-remove\" ng-click=\"vm.removeFilter(vm.yearFilterTag)\">&#10005</span> </span><span \nflex=\"none\" ng-if=\"vm.makeFilter !== undefined\" class=\"text-red\">{{vm.makeFilter? vm.makeFilter:\'Unknown\'}} <span \nclass=\"text-grey applied-filter-remove\" ng-click=\"vm.removeFilter(vm.makeFilterTag)\">&#10005</span> </span><span \nflex=\"none\" ng-if=\"vm.modelFilter !== undefined\" class=\"text-red\">{{vm.modelFilter? vm.modelFilter:\'Unknown\'}} <span \nclass=\"text-grey applied-filter-remove\" ng-click=\"vm.removeFilter(vm.modelFilterTag)\">&#10005</span> </span><span \nflex=\"none\" ng-if=\"vm.locationFilter !== undefined\" class=\"text-red\">\n{{vm.getVehicleLocation(vm.locationFilter).name? vm.getVehicleLocation(vm.locationFilter).name : \'Unknown\'}} <span \nclass=\"text-grey applied-filter-remove\" ng-click=\"vm.removeFilter(vm.locationFilterTag)\">&#10005</span> </span><span \nflex=\"none\" ng-if=\"vm.priceFilterLevel !== undefined\" class=\"text-red\">{{vm.getPriceRangeString(vm.priceFilterLevel)}} \n<span class=\"text-grey applied-filter-remove\" ng-click=\"vm.removeFilter(vm.priceFilterTag)\">&#10005</span> </span><span\n flex=\"none\" ng-if=\"vm.mileageFilterLevel !== undefined\" class=\"text-red\">\n{{vm.getMileageRangeString(vm.mileageFilterLevel)}} <span class=\"text-grey applied-filter-remove\" \nng-click=\"vm.removeFilter(vm.mileageFilterTag)\">&#10005</span> </span><span ng-if=\"!vm.isDefaultFilter()\" flex=\"none\" \nclass=\"text-red\" ng-click=\"vm.resetFilters()\">Reset filters</span></div><div layout=\"row\" layout-wrap><div \nclass=\"zoom\" flex-xs=\"100\" flex-sm=\"50\" flex-md=\"25\" flex-gt-md=\"20\" layout-padding ng-repeat=\"vehicle in vm.vehicles\">\n<vehicle-card class=\"p-0\" vehicle=\"vehicle\" locations=\"vm.locations\"></vehicle-card></div></div><div layout=\"row\" \nlayout-align=\"center center\" class=\"my-10\"><md-progress-circular ng-if=\"vm.isFetchingData\" md-diameter=\"40\">\n</md-progress-circular></div></md-content></div>");
$templateCache.put("app/main/vehicles/browse-vehicles/inventory-info-list.html","<div><div layout=\"row\" layout-align=\"space-between center\"><div class=\"font-weight-bold\">{{::vm.title}}</div><button \nng-click=\"vm.showFilter = !vm.showFilter\"><i class=\"m-0 p-0 text-secondary\" \nng-class=\"vm.showFilter? [\'icon-arrow-up-drop-circle-outline\']:[\'icon-arrow-down-drop-circle-outline\']\"></i></button>\n</div><md-divider class=\"my-1\"></md-divider><md-radio-group ng-if=\"vm.showFilter\" ng-disabled=\"vm.isProcessing\" \nng-model=\"vm.selectedItem\" ng-change=\"vm.onItemChange(vm.tag, vm.selectedItem)\"><md-radio-button class=\"my-1 p-0\" \nng-value=\"\">All</md-radio-button><md-radio-button class=\"my-1 p-0\" \nng-repeat=\"inventoryInfo in vm.inventoryInfoList | orderBy:\'dataGroup\'\" ng-value=\"inventoryInfo\">\n{{vm.itemNameBuilder? vm.itemNameBuilder(inventoryInfo) : inventoryInfo.dataGroup ? inventoryInfo.dataGroup : \'Unknown\'}} ({{inventoryInfo.count}})\n</md-radio-button></md-radio-group></div>");
$templateCache.put("app/main/vehicles/browse-vehicles/vehicle-card.html","<a ng-href=\"{{vm.getUrlForDetailPage(vm.vehicle)}}\" style=\"text-decoration:none\"><md-card class=\"widget widget1 card\">\n<div class=\"box sixteen-nine\"><img \nng-src=\"{{vm.vehicle.landingImage ? vm.vehicle.landingImage:\'../../assets/images/placeholder-vans.png\'}}\" \nstyle=\"object-fit: cover\" class=\"content fill-parent p-0\"></div><div class=\"widget-content p-2\" \nstyle=\"font-family:\'Lucida Sans Unicode\', \'Lucida Grande\', sans-serif\"><div class=\"title text-nowrap text-truncate\" \nstyle=\"font-weight:bold\">{{::vm.vehicle.getYearMakeModel()}} <span ng-if=\"!vm.vehicle.getYearMakeModel()\">Unknown\n</span></div><div class=\"text-grey\" style=\"font-size: 12px; font-weight:lighter\"><div><span ng-if=\"vm.vehicle.trim\" \nclass=\"text-nowrap text-truncate\">{{::vm.vehicle.trim}}</span> <span ng-if=\"!vm.vehicle.trim\">Unknown Trim</span></div>\n<div layout=\"row\" layout-align=\"start center\"><div ng-if=\"vm.vehicle.mileage\" class=\"text-nowrap text-truncate\">\n{{::vm.vehicle.mileage | number:0}} KM</div><div ng-if=\"!vm.vehicle.mileage\">Unknown Mileage</div><div \nng-if=\"vm.vehicle.mileage && vm.vehicle.stock_number\" class=\"mx-2\">|</div><div class=\"text-nowrap text-truncate\">\n{{::vm.vehicle.stock_number}}</div></div></div><div class=\"sub-title text-secondary h5 text-nowrap text-truncate\">\n<span><span ng-if=\"vm.vehicle.advertise_price\">${{::vm.vehicle.advertise_price | number:0}} </span><span \nng-if=\"!vm.vehicle.advertise_price\">$Unknown</span> <span \nng-if=\"vm.vehicle.fk_id_location && vm.getVehicleLocation(vm.vehicle).is_default_location == false\" \nstyle=\"font-size: 15px\" class=\"text-red mr-2\">({{::vm.getVehicleLocation(vm.vehicle).name}})</span></span></div></div>\n</md-card></a>");
$templateCache.put("app/main/vehicles/browse-vehicles/vehicle-search.html","<md-autocomplete ng-blur=\"vm.onBlurCallback()\" ng-focus=\"vm.onFocusCallback()\" md-no-cache=\"false\" \nmd-selected-item=\"vm.selectedItem\" md-search-text=\"vm.searchText\" md-delay=\"700\" md-select-on-focus=\"true\" \nmd-selected-item-change=\"vm.select(vehicle)\" md-items=\"vehicle in vm.queryVehicle(ctrl.searchText)\" \nmd-item-text=\"vehicle.getYearMakeModel()\" placeholder=\"Search vehicle by year, make, model, vin, stock#\" \nmd-menu-class=\"vehicle-search-menu\" md-menu-container-class=\"vehicle-search-container\"><md-item-template><div \nlayout=\"row\" layout-align=\"start center\"><div flex=\"none\" class=\"mr-2\"><img \nstyle=\"width: 60px;height:50px; object-fit: contain\" \nng-src=\"{{vehicle.landingImage? vehicle.landingImage:\'../../assets/images/placeholder-vans.png\'}}\"></div><div \nclass=\"item-detail\" style=\"font-size: 13px\"><span><a stop-event ng-href=\"{{vm.getUrlForDetailPage(vehicle)}}\">\n{{vehicle.getYearMakeModel()}}</a> <span class=\"text-red\" \nng-if=\"vm.getVehicleLocation(vehicle) && !vm.getVehicleLocation(vehicle).is_default_location\">\n({{vm.getVehicleLocation(vehicle).name}})</span></span><div>{{vehicle.vin}}</div></div></div><md-divider></md-divider>\n</md-item-template><md-not-found>{{::vm.notFoundMessage}}</md-not-found></md-autocomplete>");
$templateCache.put("app/main/vehicles/edit-vehicle/edit-vehicle.html","<div class=\"page-layout carded fullwidth single-scroll\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"column\"><span class=\"h2 white-fg\">Edit Vehicle</span>\n<div layout=\"row\" layout-align=\"space-between center\"><h6><a class=\"badge badge-primary\" \nhref=\"{{::vm.vehiclePageUrl}}\">{{::vm.vehicle.getYearMakeModel()}}</a></h6><div restrict \nrolescansee=\"developer company_manager\"><md-button class=\"mb-2 md-icon-button\" ng-click=\"vm.deleteVehicle()\"><md-icon \nclass=\"icon-delete-forever text-red\"></md-icon></md-button></div></div></div><div \nclass=\"content-card page-content-container\" layout=\"column\" flex><md-content class=\"content\" flex ms-scroll><md-tabs \nmd-dynamic-height md-border-bottom><md-tab label=\"GENERAL\" layout=\"row\" \nmd-active=\"vm.currentTab == vm.tabs.generalInfo\"><div flex=\"100\" flex-gt-sm=\"60\"><div layout=\"row\" \nlayout-align=\"start center\" restrict \nrolescansee=\"developer company_manager advertizing vehicle_manager vehicle_helper_add vehicle_helper_delete\">\n<md-input-container flex=\"50\" class=\"input-box info-form-item small-input-box\"><input ng-disabled=\"vm.isParsingLink\" \ntype=\"text\" autocorrect=\"off\" autocapitalize=\"none\" spellcheck=\"false\" ng-model=\"vm.rmLink\" autocomplete=\"off\" \nplaceholder=\"Import Link\"></md-input-container><md-button class=\"mx-0 mb-3 md-icon-button\" \nng-click=\"vm.importFromRmLink($event)\" ng-disabled=\"vm.isParsingLink\"><md-icon class=\"icon-import text-secondary\">\n</md-icon></md-button></div><vehicle-general-form orgin-vehicle=\"vm.originVehicle\" on-decode-vin=\"vm.decodeVIN\" \nis-form-valid=\"vm.isGeneralFormValid\" vehicle=\"vm.vehicle\" enable-merge=\"true\" on-merge-click=\"vm.onMergeClick\">\n</vehicle-general-form></div></md-tab><md-tab label=\"SPECS\" layout=\"row\" md-active=\"vm.currentTab == vm.tabs.specs\">\n<div flex=\"100\" flex-gt-sm=\"40\"><vehicle-specs-form is-form-valid=\"vm.isSpecsFormValid\" vehicle=\"vm.vehicle\">\n</vehicle-specs-form></div></md-tab><div restrict \nrolescansee=\"developer company_manager advertizing vehicle_manager vehicle_helper_add vehicle_helper_delete\"><md-tab \nlabel=\"FEATURES\" md-active=\"vm.currentTab == vm.tabs.features\"><vehicle-feature-list \npreset-feature-option=\"vm.presetFeatureOptions\" add-feature=\"vm.addFeature\" on-decode-vin=\"vm.refreshFeature\" \nfeatures=\"vm.features\"></vehicle-feature-list></md-tab></div><div restrict \nrolescansee=\"developer company_manager advertizing\"><md-tab label=\"ADVERTISING\" \nmd-active=\"vm.currentTab == vm.tabs.advertizing\"><div class=\"pt-3\"><vehicle-advertizing-form locations=\"vm.locations\" \nvehicle-brands=\"vm.vehicleBrands\" vehicle-files=\"vm.vehicleFiles\" import-vehicle-images=\"vm.importVehicleImages\" \nvehicle-images=\"vm.vehicleImageList\" is-form-valid=\"vm.isAdvertizingFormValid\" vehicle=\"vm.vehicle\">\n</vehicle-advertizing-form></div></md-tab></div><div restrict \nrolescansee=\"developer company_manager accountant sales_manager vehicle_manager vehicle_helper_add\"><md-tab \nlabel=\"PURCHASE INFO\" md-active=\"vm.currentTab == vm.tabs.purchaseInfo\"><div layout=\"row\"><div flex=\"100\" \nflex-gt-sm=\"30\"><div ng-if=\"!(vm.purchaseInfos.length > 0)\" class=\"p-2\">No Purchase Info.</div><div \nng-repeat=\"purchaseInfo in vm.purchaseInfos\" layout=\"row\" layout-align=\"start center\" class=\"my-2\"><icon \nclass=\"icon-file-document mr-2\"></icon><a href=\"{{vm.getPurchaseInfoUrl(purchaseInfo)}}\">\n{{::purchaseInfo.purchase_date? (purchaseInfo.purchase_date | date : \'fullDate\'):\'Unknow date\'}} </a><span \nng-if=\"purchaseInfo.is_canceled\" class=\"badge badge-danger ml-3\">Canceled</span></div><div layout=\"row\" \nlayout-align=\"start center\" class=\"my-2\" ng-click=\"vm.addNewPurchaseInfo()\"><icon \nclass=\"icon-plus-circle text-green mr-2\"></icon><div>New Purchase</div></div></div></div></md-tab></div><div restrict \nrolescansee=\"developer company_manager sale_manager salesman accountant\"><md-tab label=\"SALE INFO\" \nmd-active=\"vm.currentTab == vm.tabs.saleInfo\"><div layout=\"row\"><div flex=\"100\" flex-gt-sm=\"30\"><div \nng-if=\"!(vm.saleInfos.length > 0)\" class=\"p-2\">No sale info.</div><div ng-repeat=\"saleInfo in vm.saleInfos\" \nlayout=\"row\" layout-align=\"start center\" class=\"my-2\"><icon class=\"icon-file-document mr-2\"></icon><a \nhref=\"{{vm.getSaleInfoUrl(saleInfo)}}\">\n{{::saleInfo.sale_date? (saleInfo.sale_date | date : \'fullDate\'):\'Unknow date\'}} </a><span \nng-if=\"saleInfo.is_canceled\" class=\"badge badge-danger ml-3\">Canceled</span></div><div layout=\"row\" \nlayout-align=\"start center\" class=\"my-2\" ng-click=\"vm.addNewSaleInfo()\" \nng-if=\"!vm.vehicle.is_sold && vm.validPurchaseInfo\"><icon class=\"icon-plus-circle text-green mr-2\"></icon><div>New Sale\n</div></div></div></div></md-tab></div></md-tabs><md-button class=\"btn-secondary mx-0\" ng-click=\"vm.saveChange()\">SAVE\n</md-button></md-content></div></div></div>");
$templateCache.put("app/main/vehicles/edit-vehicle/import-confirmation-dialog.html","<md-dialog aria-label=\"Import Details\" style=\"min-width: 1000px\"><form ng-cloak><md-toolbar><div \nclass=\"md-toolbar-tools bg-secondary\"><h2>Import Details</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.cancel()\"><md-icon class=\"icon-close text-red\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content><div class=\"md-dialog-content\"><div layout=\"row\" layout-wrap><div flex=\"50\" \nng-repeat=\"change in vm.changeList\" class=\"p-2\"><div class=\"simple-border px-2 pt-2\"><div class=\"badge\" \nng-class=\"change.applyChange? [\'badge-secondary\']:[\'badge-info\']\">{{::change.displayName}}</div><div layout=\"row\" \nclass=\"my-1\" layout-align=\"start center\" style=\"font-size: 13px\"><div flex=\"40\" class=\"text-nowrap text-truncate\" \nng-class=\"change.applyChange? [\'text-black\']:[\'text-grey\']\">\n{{::change.currentValue != null? change.currentValue:\'Empty\'}}</div><div flex=\"10\" class=\"px-2\"><i \nclass=\"icon-arrow-right-thick\" ng-class=\"change.applyChange? [\'text-green\']:[\'text-grey\']\"></i></div><div flex=\"40\" \nclass=\"text-nowrap text-truncate\" ng-class=\"change.applyChange? [\'text-black\']:[\'text-grey\']\">\n{{::change.importedValue != null? change.importedValue: \"Empty\"}}</div><div flex=\"10\"><md-checkbox class=\"m-0 p-0\" \nng-model=\"change.applyChange\"></md-checkbox></div></div></div></div></div><div class=\"mt-5 p-2\"><md-checkbox \nclass=\"mx-0 my-3 p-0\" ng-model=\"vm.allImageChecked\" ng-change=\"vm.selectAllImages()\">Select All Images</md-checkbox>\n<md-grid-list md-cols=\"8\" md-row-height=\"4:3\" md-gutter=\"4px\"><md-grid-tile ng-repeat=\"image in vm.importedImages\" \nmd-rowspan=\"1\" md-colspan=\"1\"><image ng-class=\"image.needed? []:[\'opacity-50\']\" ng-src=\"{{::image. imageUrl}}\" \nstyle=\"object-fit: cover\"></image><md-grid-tile-footer style=\"height: 30px\" layout=\"row\" layout-align=\"end center\">\n<md-checkbox class=\"m-0 p-0\" ng-model=\"image.needed\"></md-checkbox></md-grid-tile-footer></md-grid-tile></md-grid-list>\n</div></div></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"end center\"><md-button \nclass=\"btn-secondary\" ng-click=\"vm.confirm()\">Confirm And Publish</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/vehicles/components/vehicle-advertizing-form.html","<form name=\"adevertizingForm\" class=\"py-3\" style=\"font-size: 13px\"><div class=\"badge badge-primary mb-2\" \nstyle=\"font-size: 17px\">Vehicle Images</div><div nv-file-drop uploader=\"vm.imageUploader\" class=\"simple-border\"><div \nlayout=\"row\" layout-align=\"start center\" class=\"bt-3\"><div class=\"pl-3\">Drag images here or</div><md-button \nclass=\"btn-secondary btn-sm\">Select Images or video <input class=\"fileInput\" nv-file-select=\"false\" \nuploader=\"vm.imageUploader\" multiple=\"multiple\" type=\"file\" accept=\"image/*,video/mp4\"></md-button><md-button \nclass=\"btn-secondary btn-sm\" ng-click=\"vm.updateAllVehicleImagesContentType(image)\" ng-disabled=\"vm.isUpdatingFile\">\nUpdate All Images Content type</md-button></div><div class=\"advertizingimages\"><div dnd-allowed-types=\"\'image\'\" \nlayout=\"row\" layout-wrap layout-margin dnd-list=\"vm.vehicleImages\" dnd-horizontal-list=\"true\"><div \ndnd-disable-if=\"image.isProcessing\" dnd-dragend=\"vm.onImageDrop(image, $index)\" dnd-draggable=\"image\" \ndnd-moved=\"vm.vehicleImages.splice($index, 1)\" dnd-effect-allowed=\"move\" dnd-type=\"\'image\'\" \nng-repeat=\"image in vm.vehicleImages\" style=\"position: relative\"><img ng-if=\"image.file_type.includes(\'image\')\" \nng-src=\"{{image.url}}\" style=\"width: 160px; height: 120px; object-fit: cover\"><video controls \nng-if=\"image.file_type.includes(\'video\')\" style=\"width: 160px; height: 120px; object-fit: cover\"><source \nng-src=\"{{image.url}}\" type=\"video/mp4\"></video><div layout=\"row\" layout-align=\"start center\" \nstyle=\"width: 160px; height: 25px;position: absolute;bottom: 0%\"><md-checkbox class=\"my-0 mx-1 p-0\" \nng-change=\"vm.updateVehicleImageOnlineStatus(image)\" ng-disabled=\"image.isProcessing\" ng-model=\"image.is_online\">\n</md-checkbox></div><md-button class=\"mx-0 md-icon-button\" ng-click=\"vm.deleteVehicleImage(image)\" \nng-disabled=\"image.isProcessing\" style=\"position: absolute;top: 0% ; right: 0%\"><md-icon \nclass=\"icon-delete-forever text-red\"></md-icon></md-button><md-progress-circular \nstyle=\"position: absolute; left: 40%; top:40%\" ng-if=\"image.isProcessing\" class=\"basic-info-form-img-progress\" \nmd-diameter=\"35px\"></md-progress-circular></div><div onmousedown=\"return false\" style=\"position: relative\" \nng-repeat=\"image in vm.imageUploader.queue\"><img class=\"opacity-50\" ng-src=\"{{image.imageSrc}}\" \nstyle=\"width: 160px; height: 120px; object-fit: cover\"><md-progress-circular \nstyle=\"position: absolute; left: 40%; top:40%\" ng-if=\"image.isUploading\" class=\"md-hue-2 basic-info-form-img-progress\" \nmd-diameter=\"35px\"></md-progress-circular></div></div></div><div layout=\"row\" layout-align=\"start center\" class=\"bt-3\">\n<md-button ng-click=\"vm.downloadAllImages()\" ng-disabled=\"vm.isDownloading\" class=\"btn-secondary btn-sm\">\nDownload All Images</md-button><md-button ng-click=\"vm.unselectAllImages()\" class=\"btn-secondary btn-sm\">Unselect All\n</md-button><md-button ng-click=\"vm.selectAllImages()\" class=\"btn-secondary btn-sm\">Select All</md-button><md-checkbox \nng-disabled=\"vm.isDownloading\" class=\"m-0 p-0\" ng-model=\"vm.downloadOnlineImagesOnly\" ng-focus=\"vm.addNewRow()\">\nOnline Only</md-checkbox><div ng-if=\"vm.isDownloading\" style=\"margin-left: 12px\">\n({{vm.downloadFinished}} / {{vm.downloadTotal}})</div></div></div><div class=\"badge badge-primary mb-2 mt-10\" \nstyle=\"font-size: 17px\">Vehicle Files</div><div layout=\"row\"><file-section flex=\"100\" flex-gt-sm=\"40\" \nuploaded-files=\"vm.vehicleFiles\" file-uploader=\"vm.fileUploader\" on-file-delete=\"vm.onFileDelete\" \nis-processing-data=\"vm.isDeletingFile\"></file-section></div><div class=\"badge badge-primary mb-2 mt-10\" \nstyle=\"font-size: 17px\">General</div><div layout=\"row\"><div flex=\"100\" flex-gt-sm=\"40\"><div layout=\"row\" \nlayout-align=\"start center\"><md-input-container flex=\"50\" class=\"input-box info-form-item small-input-box\"><input \ntype=\"text\" autocorrect=\"off\" autocapitalize=\"none\" spellcheck=\"false\" name=\"carProof\" ng-model=\"vm.vehicle.car_proof\" \nautocomplete=\"off\" placeholder=\"Carfax Cananda\" maxlength=\"500\"><div ng-messages=\"adevertizingForm.carProof.$error\">\n<div ng-message=\"maxlength\">Can not over 500 charactors</div></div></md-input-container><md-button flex=\"50\" \nclass=\"btn-secondary btn-sm mb-6\">Upload Car Proof <input class=\"fileInput\" nv-file-select=\"false\" \nuploader=\"vm.fileUploader\" type=\"file\" options=\"{isCarproof:true}\"></md-button></div><div layout=\"row\" \nlayout-align=\"start center\"><md-input-container flex=\"50\" class=\"input-box info-form-item small-input-box\"><input \ntype=\"text\" autocorrect=\"off\" autocapitalize=\"none\" spellcheck=\"false\" name=\"carFax\" ng-model=\"vm.vehicle.car_fax\" \nautocomplete=\"off\" placeholder=\"Carfax\" maxlength=\"500\"><div ng-messages=\"adevertizingForm.car_fax.$error\"><div \nng-message=\"maxlength\">Can not over 500 charactors</div></div></md-input-container><md-button flex=\"50\" \nclass=\"btn-secondary btn-sm mb-6\">Upload Car Fax <input class=\"fileInput\" nv-file-select=\"false\" \nuploader=\"vm.fileUploader\" type=\"file\" options=\"{isCarfax:true}\"></md-button></div><div layout=\"row\" \nlayout-align=\"start center\"><md-input-container flex=\"50\" class=\"input-box info-form-item small-input-box\"><input \ninput-control input-translate=\"vm.translateToDollar\" type=\"text\" autocorrect=\"off\" autocapitalize=\"none\" \nspellcheck=\"false\" name=\"advertisePrice\" ng-model=\"vm.vehicle.advertise_price\" autocomplete=\"off\" \nplaceholder=\"Advertise Price\" maxlength=\"10\"><div ng-messages=\"adevertizingForm.advertisePrice.$error\"><div \nng-message=\"maxlength\">Can not over 10 charactors</div></div></md-input-container><md-input-container flex=\"50\" \nclass=\"input-box info-form-item small-input-box\"><input step=\".01\" type=\"number\" autocorrect=\"off\" \nautocapitalize=\"none\" spellcheck=\"false\" name=\"interestRate\" ng-model=\"vm.vehicle.interest_rate\" autocomplete=\"off\" \nplaceholder=\"Interest Rate\" maxlength=\"5\" max=\"100\"></md-input-container></div><div layout=\"row\" \nlayout-align=\"start center\"><md-input-container flex=\"50\" class=\"input-box info-form-item small-input-box\"><label \nfor=\"term\">Term</label><md-select name=\"term\" ng-model=\"vm.vehicle.term\" placeholder=\"Term\" ng-change=\"updateTerm()\" \naria-label=\"Term\" md-no-asterisk><md-option ng-value=\"i\" ng-repeat=\"i in termOptions\">{{i}}</md-option></md-select>\n</md-input-container><md-input-container flex=\"50\" class=\"input-box info-form-item small-input-box mt-10\"><label \nfor=\"term\">Advertise Mileage</label><input type=\"text\" autocorrect=\"off\" autocapitalize=\"none\" spellcheck=\"false\" \nname=\"advertise_mileage\" ng-model=\"vm.vehicle.advertise_mileage\" autocomplete=\"off\" placeholder=\"Advertise Mileage\" \nmaxlength=\"10\" ng-pattern=\"/^[0-9]*$/\"><div ng-messages=\"adevertizingForm.advertise_mileage.$error\"><div \nng-message=\"maxlength\">Input content can not be over 10 charactors</div><div ng-message=\"pattern\">Only number accepted!\n</div></div></md-input-container></div><div layout=\"row\" layout-align=\"start center\"><md-input-container flex=\"50\" \nclass=\"small-selector purchase-step-selector pr-5\"><label>Brand</label><md-select style=\"width: 100%\" name=\"brand\" \nng-model=\"vm.vehicle.fk_id_vehicle_brand\" placeholder=\"Brand\"><md-option ng-repeat=\"brand in vm.vehicleBrands\" \nng-value=\"{{::brand.id_vehicle_brand}}\">{{::brand.name}}</md-option></md-select></md-input-container>\n<md-input-container flex=\"50\" class=\"small-selector purchase-step-selector pr-5\"><label>Location</label><md-select \nstyle=\"width: 100%\" name=\"location\" ng-model=\"vm.vehicle.fk_id_location\" placeholder=\"Location\"><md-option \nng-repeat=\"location in vm.locations | orderBy:\'name\'\" ng-value=\"{{::location.id_location}}\">{{::location.name}}\n</md-option></md-select></md-input-container></div><div layout=\"row\" layout-align=\"start center\"><md-input-container \nflex=\"50\" class=\"input-box info-form-item small-input-box\"><input input-control \nng-model-options=\"{allowInvalid: true}\" input-translate=\"vm.translateToVIN\" type=\"text\" autocorrect=\"off\" \nautocapitalize=\"none\" spellcheck=\"false\" name=\"boostVin\" ng-model=\"vm.vehicle.boost_vin\" autocomplete=\"off\" \nplaceholder=\"Boost VIN\" minlength=\"17\" maxlength=\"17\"><div ng-messages=\"adevertizingForm.boostVin.$error\"><div \nng-message=\"pattern\">Must be charactors or numbers</div><div ng-message=\"minlength, maxlength\">\nThe description must be 17 characters long.</div></div></md-input-container><md-input-container flex=\"50\" \nclass=\"input-box info-form-item small-input-box\"><input type=\"text\" autocorrect=\"off\" autocapitalize=\"none\" \nspellcheck=\"false\" name=\"numberOfOwners\" ng-model=\"vm.vehicle.number_of_owners\" autocomplete=\"off\" \nplaceholder=\"Number Of Owners\" maxlength=\"2\" ng-pattern=\"/^[0-9]*$/\"><div \nng-messages=\"adevertizingForm.numberOfOwners.$error\"><div ng-message=\"maxlength\">Can not over 2 charactors</div><div \nng-message=\"pattern\">Invalid Number</div></div></md-input-container></div><div layout=\"row\" \nlayout-align=\"start center\"><div flex=\"25\" layout=\"row\" layout-align=\"start center\"><div class=\"text-nowrap\">\nIs Certified:</div><md-input-container class=\"purchase-step-selector\"><md-checkbox class=\"my-2 mb-0 p-0\" \nng-model=\"vm.vehicle.is_certified\"></md-checkbox></md-input-container></div><div flex=\"25\" layout=\"row\" \nlayout-align=\"start center\"><div class=\"text-nowrap\">Is Online:</div><md-input-container \nclass=\"purchase-step-selector\"><md-checkbox ng-disabled=\"vm.isVehicleContainBoostVin()\" class=\"my-2 mb-0 p-0\" \nng-model=\"vm.vehicle.is_online\"></md-checkbox></md-input-container></div><div flex=\"25\" layout=\"row\" \nlayout-align=\"start center\"><div class=\"text-nowrap\">Exclude From Reports:</div><md-input-container \nclass=\"purchase-step-selector\"><md-checkbox class=\"my-2 mb-0 p-0\" ng-model=\"vm.vehicle.is_report_excluded\">\n</md-checkbox></md-input-container></div><md-progress-circular ng-if=\"vm.isPrintingBrochure\" class=\"md-hue-2 ml-3\" \nmd-diameter=\"20px\"></md-progress-circular></div><div layout=\"row\"></div><div layout=\"row\" layout-align=\"start center\">\n<md-button ng-if=\"vm.vehicle.is_online && !vm.isPrintingBrochure\" class=\"btn-secondary btn-sm mx-0\" \nng-click=\"vm.printBrochure()\">Print Brochure</md-button><md-progress-circular ng-if=\"vm.isPrintingBrochure\" \nclass=\"md-hue-2 ml-3\" md-diameter=\"20px\"></md-progress-circular></div></div></div></form>");
$templateCache.put("app/main/vehicles/components/vehicle-customer-section.html","<div layout=\"row\" layout-wrap layout-align=\"start center\" ng-if=\"!vm.isInitializingServiceMap\"><div \nng-repeat=\"serviceMap in vm.serviceMaps\" class=\"mr-5\"><a \nng-href=\"{{vm.getCustomerPageUrl(serviceMap.customer.id_customer)}}\">\n{{serviceMap.customer.first_name + \' \' + serviceMap.customer.last_name}} </a><span ng-disabled=\"vm.isProcessing\" \nng-click=\"vm.onServiceMapDelete(serviceMap, $index)\" class=\"text-red\">&#x2715</span></div></div><div layout=\"row\" \nlayout-wrap layout-align=\"start center\" class=\"mt-5\"><md-input-container flex=\"50\" flex-gt-sm=\"25\" \nclass=\"input-box small-input-box input-box-padding\"><input ng-model=\"vm.firstNameSearchText\" \nng-model-options=\"{ debounce: 700 }\" placeholder=\"First Name\" ng-change=\"vm.onSearchTextChange()\" autocomplete=\"off\">\n</md-input-container><md-input-container flex=\"50\" flex-gt-sm=\"25\" class=\"input-box small-input-box input-box-padding\">\n<input ng-model=\"vm.lastNameSearchText\" ng-model-options=\"{ debounce: 700 }\" placeholder=\"Last Name\" \nng-change=\"vm.onSearchTextChange()\" autocomplete=\"off\"></md-input-container><md-input-container flex=\"50\" \nflex-gt-sm=\"25\" class=\"input-box small-input-box input-box-padding\"><input ng-model=\"vm.phoneNumberSearchText\" \nng-model-options=\"{ debounce: 700 }\" placeholder=\"Phonenumber\" ng-change=\"vm.onSearchTextChange()\" autocomplete=\"off\" \ninput-control input-translate=\"vm.translateToPhoneNumber\"></md-input-container><div flex=\"50\" flex-gt-sm=\"25\"><button \nng-disabled=\"vm.isProcessing\" class=\"btn btn-sm btn-secondary mb-4\" ng-click=\"vm.onCustomerCreate()\">New</button></div>\n</div><div ng-if=\"vm.matchedCustomers\"><div ng-click=\"vm.cleanAll()\" class=\"text-red ml-2\">Clean Filters</div>\n<md-divider></md-divider><div layout=\"column\" class=\"px-2\"><div ng-repeat=\"customer in vm.matchedCustomers\" \nclass=\"my-1\" layout=\"row\" layout-align=\"space-between center\"><a \nng-href=\"{{vm.getCustomerPageUrl(customer.id_customer)}}\">{{customer.getFullName()}}</a><div \nng-disabled=\"vm.isProcessing\" class=\"badge\" ng-click=\"vm.onCustomerAdd(customer)\" \nng-class=\"vm.isProcessing ? [\'badge-info\']:[\'badge-secondary\']\">Add</div></div><div \nng-if=\"!(vm.matchedCustomers.length > 0)\">No customer match</div></div><md-divider></md-divider></div>");
$templateCache.put("app/main/vehicles/components/vehicle-feature-list.html","<div layout=\"column\" layout-gt-sm=\"row\"><div flex-gt-sm=\"25\" class=\"p-5\"><div layout=\"row\" \nlayout-align=\"space-between center\"><div>Preset Feature Options</div><div>{{vm.presetFeatureOption.length}} items</div>\n</div><md-divider></md-divider><div class=\"py-3\"><div class=\"simple-border pl-1 mb-2\"><input type=\"text\" name=\"\" \nstyle=\"width: 100%\" ng-model-options=\"{ debounce: 500 }\" ng-model=\"vm.presetFeatureFilter.name\" placeholder=\"Search\">\n</div><md-content class=\"content pl-0 py-0\" ms-scroll style=\"max-height: 450px\"><div class=\"my-1\" \nng-repeat=\"feature in vm.presetFeatureOption | filter: vm.presetFeatureFilter | orderBy: \'name\'\" \nng-click=\"vm.onFeatureOptionClick(feature)\">{{::feature.name}} <span ng-if=\"feature.isSelected\" \nclass=\"text-green ml-2\">&#x2713</span></div><div ng-if=\"!(vm.presetFeatureOption.length > 0)\">No item found</div>\n</md-content></div><md-divider></md-divider></div><div flex-gt-sm=\"25\" class=\"p-5\"><div layout=\"row\" \nlayout-align=\"space-between center\"><div>Matched Features</div><div>{{vm.matchedFeatures.length}} items</div></div>\n<md-divider></md-divider><div class=\"py-3\"><div class=\"simple-border pl-1 mb-2\"><input type=\"text\" name=\"\" \nstyle=\"width: 100%\" ng-model-options=\"{ debounce: 500 }\" ng-model=\"vm.matchedFeatureFilter.name\" placeholder=\"Search\">\n</div><md-content class=\"content pl-0 py-0\" ms-scroll style=\"max-height: 450px\"><div class=\"my-1\" \nng-repeat=\"feature in vm.matchedFeatures | filter: vm.matchedFeatureFilter | orderBy: \'name\'\"><span \nng-click=\"vm.removeFeature(feature)\" class=\"text-red mr-2\">&#x2715</span> {{::feature.name}}</div><div \nng-if=\"!(vm.matchedFeatures.length > 0)\">No item found</div></md-content></div><md-divider></md-divider></div><div \nflex-gt-sm=\"50\" class=\"p-5\"><div layout=\"row\" layout-align=\"space-between center\"><div>Selected Features</div><div>\n{{vm.features.length}} items</div></div><md-divider></md-divider><div class=\"py-3\"><div layout=\"row\"><div flex=\"50\" \nclass=\"simple-border pl-1 mb-2\"><input type=\"text\" name=\"\" style=\"width: 100%\" ng-model-options=\"{ debounce: 500 }\" \nng-model=\"vm.selectedFeatureFilter\" placeholder=\"Search\"></div></div><div layout=\"row\" class=\"mb-2\"><div flex=\"20\" \nclass=\"simple-border pl-1\"><input type=\"text\" name=\"\" style=\"width: 100%\" ng-model=\"vm.newFeature.category\" \nplaceholder=\"Category\"></div><div flex=\"20\" flex-offset=\"5\" class=\"simple-border pl-1\"><input type=\"text\" name=\"\" \nstyle=\"width: 100%\" ng-model=\"vm.newFeature.name\" placeholder=\"Name\"></div><div flex=\"20\" flex-offset=\"5\" \nclass=\"simple-border pl-1\"><input type=\"text\" name=\"\" style=\"width: 100%\" ng-model=\"vm.newFeature.value\" \nplaceholder=\"Value\"></div><div flex-offset=\"5\"><span class=\"badge badge-secondary\" ng-click=\"vm.createNewFeature()\">Add\n</span></div></div><md-content class=\"content pl-0 py-0\" ms-scroll style=\"max-height: 419px\"><div class=\"my-1\" \nng-repeat=\"feature in vm.features | filter: vm.selectedFeatureFilter | orderBy : \'category\' track by feature.name + $index\">\n<span ng-click=\"vm.removeFeature(feature)\" class=\"text-red mr-2\">&#x2715</span> <span class=\"text-grey\">\n{{feature.category}}</span> {{feature.name}} <span class=\"text-grey\">{{feature.value}}</span></div><div \nng-if=\"!(vm.features.length > 0)\">No item found</div></md-content></div><md-divider></md-divider></div></div>");
$templateCache.put("app/main/vehicles/components/vehicle-general-form.html","<form name=\"generalForm\" class=\"py-3\"><div layout=\"row\" layout-align=\"start center\"><md-input-container flex=\"50\" \nclass=\"input-box info-form-item small-input-box\"><input input-control ng-model-options=\"{allowInvalid: true}\" \ntype=\"text\" autocorrect=\"off\" autocapitalize=\"none\" spellcheck=\"false\" name=\"vin\" ng-model=\"vm.vehicle.vin\" \nautocomplete=\"off\" placeholder=\"VIN\" minlength=\"17\" maxlength=\"17\" input-translate=\"vm.translateToVIN\" \ncustom-async-validations=\"vm.vinValidations\" ng-disabled=\"!vm.hasPermission()\"><div \nng-messages=\"generalForm.vin.$error\" multiple=\"multiple\"><div ng-message=\"duplicateCheck\">VIN already exists, <span \nclass=\"text-secondary\" ng-click=\"vm.checkOutVehicleByVin()\">view </span><span ng-if=\"vm.enableMerge\">or <span \nng-click=\"vm.mergeVehicle()\" class=\"text-secondary\">merge </span></span><span>vehicle.</span></div><div \nng-message=\"pattern\">Must be charactors or numbers</div><div ng-message=\"required\">This field is required.</div><div \nng-message=\"minlength, maxlength\">The description must be 17 characters long.</div><div \nng-if=\"generalForm.vin.$pending\" class=\"text-blue\" style=\"font-size: 13px\">checking if vin is available...</div></div>\n</md-input-container><md-button ng-disabled=\"!vm.hasPermission()\" ng-click=\"vm.onDecodeVin()\"><md-icon \nclass=\"icon-magnify text-secondary\"></md-icon></md-button></div><div layout=\"row\" layout-align=\"start center\">\n<md-autocomplete ng-disabled=\"!vm.hasPermission()\" flex=\"50\" class=\"input-box info-form-item small-input-box\" \nng-required=\"true\" ng-pattern=\"/^[0-9]*$/\" md-autoselect=\"true\" md-input-name=\"year\" md-no-cache=\"true\" \nmd-search-text=\"vm.vehicle.year\" md-items=\"item in vm.filterByKeyword(vm.yearMap, vm.vehicle.year)\" \nmd-item-text=\"item\" md-min-length=\"0\" md-input-minlength=\"4\" md-input-maxlength=\"4\" \nmd-search-text-change=\"vm.refreshSpecsList()\" md-selected-item-change=\"vm.refreshSpecsList()\" \nng-blur=\"vm.refreshSpecsList()\" md-floating-label=\"Year\"><md-item-template><span md-highlight-text=\"vm.vehicle.year\">\n{{item}}</span></md-item-template><div ng-messages=\"generalForm.year.$error\"><div \nng-message=\"minlength, maxlength,pattern\">Invalid year</div><div ng-message=\"required\">This field is required.</div>\n</div></md-autocomplete><md-autocomplete ng-disabled=\"!vm.hasPermission()\" flex=\"50\" \nclass=\"input-box info-form-item small-input-box\" ng-required=\"true\" md-autoselect=\"true\" md-input-name=\"make\" \nmd-no-cache=\"true\" md-search-text=\"vm.vehicle.make\" md-items=\"item in vm.filterByKeyword(vm.makeMap, vm.vehicle.make)\" \nmd-item-text=\"item\" md-search-text-change=\"vm.refreshSpecsList()\" md-selected-item-change=\"vm.refreshSpecsList()\" \nng-blur=\"vm.refreshSpecsList()\" md-floating-label=\"Make\" md-min-length=\"0\" md-input-minlength=\"0\" \nmd-input-maxlength=\"30\"><md-item-template><span md-highlight-text=\"vm.vehicle.make\">{{item}}</span></md-item-template>\n<div ng-messages=\"generalForm.make.$error\"><div ng-message=\"required\">This field is required.</div></div>\n</md-autocomplete></div><div layout=\"row\" layout-align=\"start center\"><md-autocomplete \nng-disabled=\"!vm.hasPermission()\" flex=\"50\" class=\"input-box info-form-item small-input-box\" ng-required=\"true\" \nmd-autoselect=\"true\" md-input-name=\"model\" md-no-cache=\"true\" md-search-text=\"vm.vehicle.model\" \nmd-items=\"item in vm.filterByKeyword(vm.modelMap, vm.vehicle.model)\" md-item-text=\"item\" \nmd-search-text-change=\"vm.refreshSpecsList()\" md-selected-item-change=\"vm.refreshSpecsList()\" \nng-blur=\"vm.refreshSpecsList()\" md-floating-label=\"Model\" md-min-length=\"0\" md-input-minlength=\"0\" \nmd-input-maxlength=\"30\"><md-item-template><span md-highlight-text=\"vm.vehicle.model\">{{item}}</span></md-item-template>\n<div ng-messages=\"generalForm.model.$error\"><div ng-message=\"required\">This field is required.</div></div>\n</md-autocomplete><md-autocomplete ng-disabled=\"!vm.hasPermission()\" flex=\"50\" \nclass=\"input-box info-form-item small-input-box\" md-autoselect=\"true\" md-input-name=\"trim\" md-no-cache=\"true\" \nmd-search-text=\"vm.vehicle.trim\" md-items=\"item in vm.exploreTrim()\" md-item-text=\"item.trim\" md-min-length=\"0\" \nmd-input-minlength=\"0\" md-input-maxlength=\"100\" md-floating-label=\"Trim\"><md-item-template><span \nmd-highlight-text=\"vm.vehicle.model\">{{item.trim}}</span></md-item-template><div ng-messages=\"generalForm.trim.$error\">\n<div ng-message=\"minlength, maxlength\">Only 100 letters and/or number accepted!</div></div></md-autocomplete></div><div\n layout=\"row\" layout-align=\"start center\"><md-input-container flex=\"50\" \nclass=\"input-box info-form-item small-input-box\"><input type=\"text\" autocorrect=\"off\" autocapitalize=\"none\" \nspellcheck=\"false\" name=\"madeIn\" ng-model=\"vm.vehicle.made_in\" autocomplete=\"off\" placeholder=\"Made In\" maxlength=\"50\" \nng-disabled=\"!vm.hasPermission()\"><div ng-messages=\"generalForm.trim.$error\"><div ng-message=\"minlength, maxlength\">\nOnly 50 letters accepted!</div></div></md-input-container><md-input-container flex=\"50\" \nclass=\"input-box info-form-item small-input-box\"><input type=\"text\" autocorrect=\"off\" autocapitalize=\"none\" \nspellcheck=\"false\" name=\"mileage\" ng-model=\"vm.vehicle.mileage\" autocomplete=\"off\" placeholder=\"Mileage\" \nmaxlength=\"10\" ng-pattern=\"/^[0-9]*$/\" ng-disabled=\"!vm.hasPermission()\"><div ng-messages=\"generalForm.mileage.$error\">\n<div ng-message=\"maxlength\">Input content can not be over 10 charactors</div><div ng-message=\"pattern\">\nOnly number accepted!</div></div></md-input-container></div><div layout=\"row\" layout-align=\"start center\">\n<md-input-container flex=\"50\" class=\"input-box info-form-item small-input-box\"><input \nng-model-options=\"{ debounce: 700 }\" input-control custom-async-validations=\"vm.stockNumberValidations\" type=\"text\" \nautocorrect=\"off\" autocapitalize=\"none\" spellcheck=\"false\" name=\"stockNumber\" ng-model=\"vm.vehicle.stock_number\" \nautocomplete=\"off\" placeholder=\"Stock Number\" maxlength=\"30\" ng-disabled=\"!vm.hasPermission()\"><div \nng-messages=\"generalForm.stockNumber.$error\" multiple=\"multiple\"><div ng-message=\"maxlength\">\nInput content can not be over 30 charactors</div><div ng-message=\"duplicateCheck\">\nStock number is already in the system !</div><div ng-if=\"generalForm.stockNumber.$pending\" class=\"text-blue\" \nstyle=\"font-size: 13px\">checking if stock number is available...</div></div></md-input-container></div><div \nstyle=\"font-size: 13px\">Comments:</div><div layout=\"row\" layout-align=\"start center\" class=\"pr-5\"><text-angular \nta-toolbar=\"[[\'h1\',\'h2\',\'h3\'],[\'bold\',\'italics\',\'underline\'],[\'ul\',\'ol\'],[\'justifyLeft\',\'justifyCenter\',\'justifyRight\',\'justifyFull\']]\" \nta-text-editor-class=\"ta-editor\" ta-html-editor-class=\"ta-editor\" flex=\"100\" rows=\"3\" ng-model=\"vm.vehicle.comments\" \nclass=\"info-form-item detail-info-form-note-input\" placeholder=\"Comments:\" ta-paste=\"vm.handlePaste($html)\">\n</text-angular></div></form>");
$templateCache.put("app/main/vehicles/components/vehicle-specs-form.html","<form name=\"specsForm\" class=\"py-3\"><div class=\"badge badge-secondary mb-2\">BODY</div><div layout=\"row\" \nlayout-align=\"start center\"><md-input-container flex=\"50\" class=\"input-box info-form-item small-input-box\"><input \nrestrict rolescanedit=\"developer company_manager advertizing vehicle_manager vehicle_helper_add vehicle_helper_delete\" \ntype=\"text\" autocorrect=\"off\" autocapitalize=\"none\" spellcheck=\"false\" name=\"bodyType\" ng-model=\"vm.vehicle.body_type\" \nautocomplete=\"off\" placeholder=\"Body Type\" maxlength=\"50\"><div ng-messages=\"specsForm.bodyType.$error\"><div \nng-message=\"maxlength\">Can not over 50 charactors</div></div></md-input-container><md-input-container flex=\"50\" \nclass=\"input-box info-form-item small-input-box\"><input restrict \nrolescanedit=\"developer company_manager advertizing vehicle_manager vehicle_helper_add vehicle_helper_delete\" \ntype=\"text\" autocorrect=\"off\" autocapitalize=\"none\" spellcheck=\"false\" name=\"doors\" ng-model=\"vm.vehicle.doors\" \nautocomplete=\"off\" placeholder=\"Doors\" maxlength=\"50\"><div ng-messages=\"specsForm.doors.$error\"><div \nng-message=\"maxlength\">Can not over 50 charactors</div></div></md-input-container></div><div layout=\"row\" \nlayout-align=\"start center\"><md-input-container flex=\"50\" class=\"input-box info-form-item small-input-box\"><input \nrestrict rolescanedit=\"developer company_manager advertizing vehicle_manager vehicle_helper_add vehicle_helper_delete\" \ntype=\"text\" autocorrect=\"off\" autocapitalize=\"none\" spellcheck=\"false\" name=\"standardSeating\" \nng-model=\"vm.vehicle.standard_seating\" autocomplete=\"off\" placeholder=\"Standard Seating\" maxlength=\"50\"><div \nng-messages=\"specsForm.standardSeating.$error\"><div ng-message=\"maxlength\">Can not over 50 charactors</div></div>\n</md-input-container><md-input-container flex=\"50\" class=\"input-box info-form-item small-input-box\"><input restrict \nrolescanedit=\"developer company_manager advertizing vehicle_manager vehicle_helper_add vehicle_helper_delete\" \ntype=\"text\" autocorrect=\"off\" autocapitalize=\"none\" spellcheck=\"false\" name=\"optionalSeating\" \nng-model=\"vm.vehicle.optional_seating\" autocomplete=\"off\" placeholder=\"Optional Seating\" maxlength=\"50\"><div \nng-messages=\"specsForm.optionalSeating.$error\"><div ng-message=\"maxlength\">Can not over 50 charactors</div></div>\n</md-input-container></div><div layout=\"row\" layout-align=\"start center\"><md-input-container flex=\"50\" \nclass=\"input-box info-form-item small-input-box\"><input restrict \nrolescanedit=\"developer company_manager advertizing vehicle_manager vehicle_helper_add vehicle_helper_delete\" \ntype=\"text\" autocorrect=\"off\" autocapitalize=\"none\" spellcheck=\"false\" name=\"exteriorColor\" \nng-model=\"vm.vehicle.exterior_color\" autocomplete=\"off\" placeholder=\"Exterior Color\" maxlength=\"50\"><div \nng-messages=\"specsForm.exteriorColor.$error\"><div ng-message=\"maxlength\">Can not over 50 charactors</div></div>\n</md-input-container><md-input-container flex=\"50\" class=\"input-box info-form-item small-input-box\"><input restrict \nrolescanedit=\"developer company_manager advertizing vehicle_manager vehicle_helper_add vehicle_helper_delete\" \ntype=\"text\" autocorrect=\"off\" autocapitalize=\"none\" spellcheck=\"false\" name=\"interiorColor\" \nng-model=\"vm.vehicle.interior_color\" autocomplete=\"off\" placeholder=\"Interior Color\" maxlength=\"50\"><div \nng-messages=\"specsForm.interiorColor.$error\"><div ng-message=\"maxlength\">Can not over 50 charactors</div></div>\n</md-input-container></div><div class=\"badge badge-secondary mt-10 mb-2\">ENGINE</div><div layout=\"row\" \nlayout-align=\"start center\"><md-input-container flex=\"50\" class=\"input-box info-form-item small-input-box\"><input \nrestrict rolescanedit=\"developer company_manager advertizing vehicle_manager vehicle_helper_add vehicle_helper_delete\" \ntype=\"text\" autocorrect=\"off\" autocapitalize=\"none\" spellcheck=\"false\" name=\"engine\" ng-model=\"vm.vehicle.engine\" \nautocomplete=\"off\" placeholder=\"Engine\" maxlength=\"50\"><div ng-messages=\"specsForm.engine.$error\"><div \nng-message=\"maxlength\">Can not over 50 charactors</div></div></md-input-container><md-input-container flex=\"50\" \nclass=\"input-box info-form-item small-input-box\"><input restrict \nrolescanedit=\"developer company_manager advertizing vehicle_manager vehicle_helper_add vehicle_helper_delete\" \ntype=\"text\" autocorrect=\"off\" autocapitalize=\"none\" spellcheck=\"false\" name=\"engineCylinders\" \nng-model=\"vm.vehicle.engine_cylinders\" autocomplete=\"off\" placeholder=\"Engine Cylinders\" maxlength=\"50\"><div \nng-messages=\"specsForm.engineCylinders.$error\"><div ng-message=\"maxlength\">Can not over 50 charactors</div></div>\n</md-input-container></div><div layout=\"row\" layout-align=\"start center\"><md-input-container flex=\"50\" \nclass=\"input-box info-form-item small-input-box\"><input restrict \nrolescanedit=\"developer company_manager advertizing vehicle_manager vehicle_helper_add vehicle_helper_delete\" \ntype=\"text\" autocorrect=\"off\" autocapitalize=\"none\" spellcheck=\"false\" name=\"engineSize\" \nng-model=\"vm.vehicle.engine_size\" autocomplete=\"off\" placeholder=\"Engine Size\" maxlength=\"50\"><div \nng-messages=\"specsForm.engineSize.$error\"><div ng-message=\"maxlength\">Can not over 50 charactors</div></div>\n</md-input-container><md-input-container flex=\"50\" class=\"input-box info-form-item small-input-box\"><input restrict \nrolescanedit=\"developer company_manager advertizing vehicle_manager vehicle_helper_add vehicle_helper_delete\" \ntype=\"text\" autocorrect=\"off\" autocapitalize=\"none\" spellcheck=\"false\" name=\"driveTrain\" \nng-model=\"vm.vehicle.drive_train\" autocomplete=\"off\" placeholder=\"Drive Train\" maxlength=\"50\"><div \nng-messages=\"specsForm.driveTrain.$error\"><div ng-message=\"maxlength\">Can not over 50 charactors</div></div>\n</md-input-container></div><div layout=\"row\" layout-align=\"start center\"><md-input-container flex=\"50\" \nclass=\"input-box info-form-item small-input-box\"><input restrict \nrolescanedit=\"developer company_manager advertizing vehicle_manager vehicle_helper_add vehicle_helper_delete\" \ntype=\"text\" autocorrect=\"off\" autocapitalize=\"none\" spellcheck=\"false\" name=\"transmissionType\" \nng-model=\"vm.vehicle.transmission_type\" autocomplete=\"off\" placeholder=\"Transmission Type\" maxlength=\"50\"><div \nng-messages=\"specsForm.transmissionType.$error\"><div ng-message=\"maxlength\">Can not over 50 charactors</div></div>\n</md-input-container><md-input-container flex=\"50\" class=\"input-box info-form-item small-input-box\"><input restrict \nrolescanedit=\"developer company_manager advertizing vehicle_manager vehicle_helper_add vehicle_helper_delete\" \ntype=\"text\" autocorrect=\"off\" autocapitalize=\"none\" spellcheck=\"false\" name=\"transmissionGears\" \nng-model=\"vm.vehicle.transmission_gears\" autocomplete=\"off\" placeholder=\"Transmission Gears\" maxlength=\"50\"><div \nng-messages=\"specsForm.transmissionGears.$error\"><div ng-message=\"maxlength\">Can not over 50 charactors</div></div>\n</md-input-container></div><div class=\"badge badge-secondary mt-10 mb-2\">FUEL</div><div layout=\"row\" \nlayout-align=\"start center\"><md-input-container flex=\"50\" class=\"input-box info-form-item small-input-box\"><input \nrestrict rolescanedit=\"developer company_manager advertizing vehicle_manager vehicle_helper_add vehicle_helper_delete\" \ntype=\"text\" autocorrect=\"off\" autocapitalize=\"none\" spellcheck=\"false\" name=\"fuelType\" ng-model=\"vm.vehicle.fuel_type\" \nautocomplete=\"off\" placeholder=\"Fuel Type\" maxlength=\"50\"><div ng-messages=\"specsForm.fuelType.$error\"><div \nng-message=\"maxlength\">Can not over 50 charactors</div></div></md-input-container><md-input-container flex=\"50\" \nclass=\"input-box info-form-item small-input-box\"><input restrict \nrolescanedit=\"developer company_manager advertizing vehicle_manager vehicle_helper_add vehicle_helper_delete\" \ntype=\"text\" autocorrect=\"off\" autocapitalize=\"none\" spellcheck=\"false\" name=\"fuelCapacity\" \nng-model=\"vm.vehicle.fuel_capacity\" autocomplete=\"off\" placeholder=\"Fuel Capacity\" maxlength=\"50\"><div \nng-messages=\"specsForm.fuelCapacity.$error\"><div ng-message=\"maxlength\">Can not over 50 charactors</div></div>\n</md-input-container></div><div layout=\"row\" layout-align=\"start center\"><md-input-container flex=\"50\" \nclass=\"input-box info-form-item small-input-box\"><input restrict \nrolescanedit=\"developer company_manager advertizing vehicle_manager vehicle_helper_add vehicle_helper_delete\" \ntype=\"text\" autocorrect=\"off\" autocapitalize=\"none\" spellcheck=\"false\" name=\"cityFuelEfficiency\" \nng-model=\"vm.vehicle.city_fuel_efficiency\" autocomplete=\"off\" placeholder=\"City(L/100KM)\" maxlength=\"50\"><div \nng-messages=\"specsForm.cityFuelEfficiency.$error\"><div ng-message=\"maxlength\">Can not over 50 charactors</div></div>\n</md-input-container><md-input-container flex=\"50\" class=\"input-box info-form-item small-input-box\"><input restrict \nrolescanedit=\"developer company_manager advertizing vehicle_manager vehicle_helper_add vehicle_helper_delete\" \ntype=\"text\" autocorrect=\"off\" autocapitalize=\"none\" spellcheck=\"false\" name=\"highwayFuelEfficiency\" \nng-model=\"vm.vehicle.highway_fuel_efficiency\" autocomplete=\"off\" placeholder=\"Highway(L/100KM)\" maxlength=\"50\"><div \nng-messages=\"specsForm.highwayFuelEfficiency.$error\"><div ng-message=\"maxlength\">Can not over 50 charactors</div></div>\n</md-input-container></div><div class=\"badge badge-secondary mt-10 mb-2\">DIMENSIONS</div><div layout=\"row\" \nlayout-align=\"start center\"><md-input-container flex=\"50\" class=\"input-box info-form-item small-input-box\"><input \nrestrict rolescanedit=\"developer company_manager advertizing vehicle_manager vehicle_helper_add vehicle_helper_delete\" \ntype=\"text\" autocorrect=\"off\" autocapitalize=\"none\" spellcheck=\"false\" name=\"overallHeight\" \nng-model=\"vm.vehicle.overall_height\" autocomplete=\"off\" placeholder=\"Overall Height(MM)\" maxlength=\"50\"><div \nng-messages=\"specsForm.overallHeight.$error\"><div ng-message=\"maxlength\">Can not over 50 charactors</div></div>\n</md-input-container><md-input-container flex=\"50\" class=\"input-box info-form-item small-input-box\"><input restrict \nrolescanedit=\"developer company_manager advertizing vehicle_manager vehicle_helper_add vehicle_helper_delete\" \ntype=\"text\" autocorrect=\"off\" autocapitalize=\"none\" spellcheck=\"false\" name=\"overallLength\" \nng-model=\"vm.vehicle.overall_length\" autocomplete=\"off\" placeholder=\"Overall Length(MM)\" maxlength=\"50\"><div \nng-messages=\"specsForm.overallLength.$error\"><div ng-message=\"maxlength\">Can not over 50 charactors</div></div>\n</md-input-container></div><div layout=\"row\" layout-align=\"start center\"><md-input-container flex=\"50\" \nclass=\"input-box info-form-item small-input-box\"><input restrict \nrolescanedit=\"developer company_manager advertizing vehicle_manager vehicle_helper_add vehicle_helper_delete\" \ntype=\"text\" autocorrect=\"off\" autocapitalize=\"none\" spellcheck=\"false\" name=\"overallWidth\" \nng-model=\"vm.vehicle.overall_width\" autocomplete=\"off\" placeholder=\"Overall Width(MM)\" maxlength=\"50\"><div \nng-messages=\"specsForm.overallWidth.$error\"><div ng-message=\"maxlength\">Can not over 50 charactors</div></div>\n</md-input-container><md-input-container flex=\"50\" class=\"input-box info-form-item small-input-box\"><input restrict \nrolescanedit=\"developer company_manager advertizing vehicle_manager vehicle_helper_add vehicle_helper_delete\" \ntype=\"text\" autocorrect=\"off\" autocapitalize=\"none\" spellcheck=\"false\" name=\"curbWeight\" \nng-model=\"vm.vehicle.curb_weight\" autocomplete=\"off\" placeholder=\"Curb Weight(KG)\" maxlength=\"50\"><div \nng-messages=\"specsForm.curbWeight.$error\"><div ng-message=\"maxlength\">Can not over 50 charactors</div></div>\n</md-input-container></div><div layout=\"row\" layout-align=\"start center\"><md-input-container flex=\"50\" \nclass=\"input-box info-form-item small-input-box\"><input restrict \nrolescanedit=\"developer company_manager advertizing vehicle_manager vehicle_helper_add vehicle_helper_delete\" \ntype=\"text\" autocorrect=\"off\" autocapitalize=\"none\" spellcheck=\"false\" name=\"grossWeight\" \nng-model=\"vm.vehicle.gross_weight\" autocomplete=\"off\" placeholder=\"Gross Weight(KG)\" maxlength=\"50\"><div \nng-messages=\"specsForm.grossWeight.$error\"><div ng-message=\"maxlength\">Can not over 50 charactors</div></div>\n</md-input-container></div></form>");
$templateCache.put("app/main/vehicles/deliver-schedule/deliver-date-detail.html","<div layout=\"row\" class=\"m-1\" layout-align=\"start center\"><md-progress-circular ng-if=\"vm.isProcessingData\" \nclass=\"mx-2\" md-diameter=\"20\"></md-progress-circular></div><div ng-repeat=\"deliverDetail in vm.deliveryList\" \nclass=\"card mb-2 p-3\" ng-if=\"!vm.isProcessingData\"><div layout=\"row\" layout-align=\"start center\"><div layout=\"row\" \nlayout-align=\"start center\" class=\"mr-2\"><a href=\"{{vm.getUrlForVehiclePage(deliverDetail.vehicleData)}}\" \nstyle=\"font-size: 18px\">{{deliverDetail.vehicleData.getYearMakeModel()}}</a><div class=\"ml-2 text-red\" \nng-if=\"deliverDetail.locationInfo.is_default_location == false\" style=\"font-size: 18px\">\n({{deliverDetail.locationInfo.name}})</div></div><div \nng-if=\"deliverDetail.saleInfoData.is_mechanic_completed != false && deliverDetail.saleInfoData.is_detail_completed != false && deliverDetail.saleInfoData.is_licensing_completed != false\">\n<md-icon class=\"icon-check-circle text-green\"></md-icon></div></div><div layout=\"row\" \nlayout-align=\"space-between center\"><div>{{deliverDetail.vehicleData.vin}}</div><div layout=\"row\" \nlayout-align=\"start center\" class=\"my-2\"><div>Sale Date: {{deliverDetail.saleInfoData.sale_date}}</div><span \nng-if=\"deliverDetail.saleInfoData.is_canceled\" class=\"badge badge-danger\">Canceled</span> <span \nng-if=\"deliverDetail.saleInfoData.is_delivered\" class=\"badge badge-success\">Delivered</span></div></div><div \nng-if=\"deliverDetail.saleInfoData.general_comments\" layout=\"column\" layout-gt-sm=\"row\" layout-align=\"start start\" \nclass=\"my-3\" restrict rolescansee=\"developer company_manager accountant sales_manager salesman advertizing\"><div \nflex-gt-sm=\"25\">General Comments:</div><div flex-gt-sm=\"75\" class=\"pre-wrap\">\n{{deliverDetail.saleInfoData.general_comments}}</div></div><div layout=\"row\" layout-wrap class=\"my-3\"><div flex=\"100\" \nflex-gt-sm=\"25\"><md-checkbox class=\"my-0 ml-0 mr-2 p-0\" \nng-checked=\"vm.isAllWorkorderCompleted(deliverDetail.workorderDetails)\" ng-disabled=\"true\">Mechanic</md-checkbox></div>\n<div flex=\"100\" flex-gt-sm=\"75\"><div ng-if=\"!(deliverDetail.workorderDetails.length > 0)\">\nNo quoted or completed workorder.</div><div layout=\"row\" ng-repeat=\"item in deliverDetail.workorderDetails\"><div \nclass=\"mr-1\">&#9679</div><div class=\"pr-2\" style=\"width: 100%\" \nng-class=\"item.workorder.isCompleted() ? [\'text-green\']:[\'\']\"><div><a \nng-class=\"item.workorder.isCompleted() ? [\'text-green\']:[\'\']\" \nng-href=\"{{::vm.getWorkorderUrl(deliverDetail.vehicleData.getResourceID(), item.workorder.id_work_order)}}\">\n{{::item.workorder.invoice_number}} </a><span ng-if=\"item.workorder.fk_id_work_order_priority\">\n- {{::vm.getWorkorderPriority(item.workorder.fk_id_work_order_priority)}}</span></div><div class=\"pre-wrap\">\n{{::item.workorder.notes}}</div><div layout=\"row\" style=\"font-size: 12px; font-style: oblique\"><div flex=\"50\"><div \nlayout=\"row\" \nng-repeat=\"part in item.partsAndInventories | limitTo:vm.getMaxDisplay(item.partsAndInventories.length) track by $index\">\n<div class=\"mr-1\">&#9679</div><div class=\"text-nowrap text-truncate\" ng-class=\"part.notOrdered ? [\'text-red\']:[\'\']\">\n{{part.name}}</div></div><div \nng-if=\"item.partsAndInventories.length > vm.getMaxDisplay(item.partsAndInventories.length)\"><span>\n{{item.partsAndInventories.length - vm.getMaxDisplay(item.partsAndInventories.length)}} more...<md-tooltip \nclass=\"multiline-tooltip\"><div layout=\"column\"><div \nng-repeat=\"part in item.partsAndInventories | limitTo: item.partsAndInventories.length : vm.getMaxDisplay(item.partsAndInventories.length) track by $index\">\n{{part.name}}</div></div></md-tooltip></span></div></div><div flex=\"50\"><div layout=\"row\" \nng-repeat=\"labor in item.labors | limitTo:vm.getMaxDisplay(item.labors.length) track by $index\"><div class=\"mr-1\">\n&#9679</div><div class=\"text-nowrap text-truncate\">{{labor.name}}</div></div><div \nng-if=\"item.labors.length > vm.getMaxDisplay(item.labors.length)\"><span>\n{{item.labors.length - vm.getMaxDisplay(item.labors.length)}} more...<md-tooltip class=\"multiline-tooltip\"><div \nng-repeat=\"labor in item.labors | limitTo: item.labors.length : vm.getMaxDisplay(item.labors.length) track by $index\">\n{{labor.name}}</div></md-tooltip></span></div></div></div></div></div></div></div><div layout=\"column\" \nlayout-gt-sm=\"row\" layout-align=\"start start\" class=\"my-3\"><div flex-gt-sm=\"25\"><md-checkbox \nclass=\"my-0 ml-0 mr-2 p-0\" ng-model=\"deliverDetail.saleInfoData.is_detail_completed\" ng-disabled=\"true\">Detail\n</md-checkbox></div><p flex-gt-sm=\"75\" class=\"pre-wrap\">{{deliverDetail.saleInfoData.detail_comments}}</p></div><div \nlayout=\"column\" layout-gt-sm=\"row\" layout-align=\"start start\" class=\"my-3\" restrict \nrolescansee=\"developer company_manager accountant sales_manager salesman advertizing\"><div flex-gt-sm=\"25\"><md-checkbox\n class=\"my-0 ml-0 mr-2 p-0\" ng-model=\"deliverDetail.saleInfoData.is_licensing_completed\" ng-disabled=\"true\">Licensing\n</md-checkbox></div><div flex-gt-sm=\"75\" class=\"pre-wrap\">{{deliverDetail.saleInfoData.licensing_comments}}</div></div>\n</div>");
$templateCache.put("app/main/vehicles/deliver-schedule/deliver-date-summary.html","<div layout=\"column\"><div flex layout=\"row\" layout-align=\"start center\"><div>Mechanic</div><div \nclass=\"text-nowrap text-truncate\">: {{vm.summary.completedMechanicTasks}} / {{vm.summary.totalMechanicTasks}}</div><i \nng-if=\"vm.summary.completedMechanicTasks >= vm.summary.totalMechanicTasks\" \nclass=\"mr-1 icon icon-check-circle s18 text-green\"></i></div><div flex layout=\"row\" layout-align=\"start center\"><div>\nDetail</div><div class=\"text-nowrap text-truncate\">\n: {{vm.summary.completedDetailTasks}} / {{vm.summary.totalDetailTasks}}</div><i \nng-if=\"vm.summary.completedDetailTasks >= vm.summary.totalDetailTasks\" \nclass=\"icon icon-check-circle s18 text-green mr-1\"></i></div><div flex layout=\"row\" layout-align=\"start center\" \nrestrict rolescansee=\"developer company_manager accountant sales_manager salesman advertizing\"><div>Licensing</div><div\n class=\"text-nowrap text-truncate\">: {{vm.summary.completedLicensingTasks}} / {{vm.summary.totalLicensingTasks}}</div>\n<i ng-if=\"vm.summary.completedLicensingTasks >= vm.summary.totalLicensingTasks\" \nclass=\"icon icon-check-circle s18 text-green mr-1\"></i></div></div>");
$templateCache.put("app/main/vehicles/deliver-schedule/deliver-schedule.html","<div layout=\"column\" layout-gt-sm=\"row\" layout-margin><div flex-gt-sm=\"25\"><div class=\"sticky p-5 card\"><div \nlayout=\"row\" layout-align=\"start center\"><div class=\"delivery-schedule-filter-title\">Mechanic:</div><md-select \nng-disabled=\"vm.isLoading\" class=\"small-selector delivery-schedule-select\" ng-model=\"vm.mechanicFilter\" \nng-change=\"vm.onMechanicFilterChange()\"><md-option ng-value=\"undefined\">All</md-option><md-option ng-value=\"true\">\nCompleted</md-option><md-option ng-value=\"false\">Not Completed</md-option></md-select></div><div layout=\"row\" \nlayout-align=\"start center\"><div class=\"delivery-schedule-filter-title\">Detail:</div><md-select \nng-disabled=\"vm.isLoading\" class=\"small-selector delivery-schedule-select\" ng-model=\"vm.detailFilter\" \nng-change=\"vm.refreshDeliverySchedule()\"><md-option ng-value=\"undefined\">All</md-option><md-option ng-value=\"true\">\nCompleted</md-option><md-option ng-value=\"false\">Not Completed</md-option></md-select></div><div layout=\"row\" \nlayout-align=\"start center\"><div class=\"delivery-schedule-filter-title\">Licensing:</div><md-select \nng-disabled=\"vm.isLoading\" class=\"small-selector delivery-schedule-select\" ng-model=\"vm.licensingFilter\" \nng-change=\"vm.refreshDeliverySchedule()\"><md-option ng-value=\"undefined\">All</md-option><md-option ng-value=\"true\">\nCompleted</md-option><md-option ng-value=\"false\">Not Completed</md-option></md-select></div><div layout=\"row\" \nlayout-align=\"start center\"><div class=\"delivery-schedule-filter-title\">Location:</div><md-select \nng-disabled=\"vm.isLoading\" class=\"small-selector delivery-schedule-select\" ng-model=\"vm.locationFilter\" \nng-change=\"vm.refreshDeliverySchedule()\"><md-option ng-value=\"undefined\">All</md-option><md-option \nng-repeat=\"location in vm.locations | orderBy:\'name\'\" ng-value=\"{{location.id_location}}\">{{location.name}}</md-option>\n</md-select></div><div class=\"mt-5 mb-2\">My filters:</div><custom-filter-list filters=\"vm.userFilters\" \nis-loading=\"vm.isLoading\" on-apply=\"vm.applyFilter\" on-delete=\"vm.deleteFilter\" on-save=\"vm.saveCurrentFilter\">\n</custom-filter-list></div></div><div flex-gt-sm=\"50\" flex-order=\"2\" flex-order-gt-sm=\"1\"><div \nng-repeat=\"(date, deliveryList) in vm.dateMap\" class=\"mb-10\" id=\"{{date}}\"><div class=\"sticky\"><div class=\"card p-2\" \nstyle=\"background-color: #b3f0ff\"><div><h5>{{date == \'null\'? \"Delivery Date Not Set\":date | date: \'fullDate\' }}</h5>\n</div><deliver-date-summary date=\"date\" summary=\"vm.deliverySummaryDateMap[date]\"></deliver-date-summary></div></div>\n<deliver-date-detail class=\"mt-3\" date=\"date\" delivery-list=\"deliveryList\" \nworkorder-priorities=\"vm.workorderPriorities\"></deliver-date-detail></div><h5 ng-if=\"vm.dateMapSize <= 0\">\nCan not find matched results.</h5></div><div flex-gt-sm=\"25\" flex-order=\"1\" flex-order-gt-sm=\"2\"><div class=\"sticky\">\n<div class=\"card p-3\" hide-xs hide-sm show-gt-md><div ng-repeat=\"(date, summary) in vm.deliverySummaryDateMap\"><div \nclass=\"text-blue\" ng-click=\"vm.gotoAnchor(date)\">{{date == \'null\'? \"Delivery Date Not Set\":date | date: \'fullDate\' }}\n</div><deliver-date-summary summary=\"summary\"></deliver-date-summary><hr ng-if=\"!$last\" class=\"ml-2 p-0\" \nstyle=\"border-left: dotted; width: 1px; height: 20px; border-color: #889999\"></div></div><div class=\"card p-3 mt-5\">\n<md-card-title><div>Summary:</div></md-card-title><md-card-content><deliver-date-summary summary=\"vm.totalSummary\">\n</deliver-date-summary></md-card-content></div></div></div></div>");
$templateCache.put("app/main/vehicles/load-calculator/load-calculator.html","<style>\nmd-slider .md-track {\r\n		background-color: #ffffff !important;\r\n	}\r\n\r\n	md-slider .md-track-fill {\r\n		background-color: #d81e05 !important;\r\n	}\r\n\r\n	md-slider .md-track,\r\n	md-slider .md-track-fill {\r\n		height: 30px;\r\n		border-radius: 0;\r\n	}\r\n\r\n	md-slider .md-thumb {\r\n		width: 20px !important;\r\n		height: 50px !important;\r\n		border-radius: 0 !important;\r\n		margin-top: -1px !important;\r\n		background-color: #ffffff !important;\r\n		border-radius: 1px !important;\r\n		border-color: #cccccc !important;\r\n		border: 2px solid #cccccc;\r\n	}\r\n\r\n	md-slider .md-thumb.md-min {\r\n		background-color: #2196F3 !important;\r\n		border-color: black !important;\r\n	}\r\n\r\n	md-slider .md-thumb:after {\r\n		content: \'>\' !important;\r\n		position: absolute;\r\n		width: 0px;\r\n		height: 0px;\r\n		border-radius: 0px;\r\n		border-width: 0px;\r\n		border-style: solid;\r\n		-webkit-transition: inherit;\r\n		transition: inherit;\r\n		font-weight: 700;\r\n		font-size: 30px;\r\n	}\r\n\r\n	md-input-container.md-default-theme .md-input,\r\n	md-input-container .md-input {\r\n		color: #ffffff !important;\r\n		border-color: rgba(0, 0, 0, 0.12) !important;\r\n		background-color: #666666 !important;\r\n		border-radius: 3px;\r\n		border-width: 3px;\r\n		border-style: solid;\r\n		width: 130px;\r\n		height: 25px;\r\n		text-align: right;\r\n		font-size: 25px;\r\n		border: 0;\r\n	}\r\n\r\n	.gray-table {\r\n		background-color: rgb(245, 245, 245) !important;\r\n		/* Gray background for the entire table */\r\n	}\r\n\r\n	table {\r\n		border-collapse: separate;\r\n		text-indent: initial;\r\n		border-spacing: 12px;\r\n	}\r\n\r\n\r\n	.round-rectangle {\r\n		border-radius: 1px;\r\n		padding: 10px 20px;\r\n		background-color: #ffffff;\r\n		border-spacing: 12px;\r\n		font-size: large;\r\n	}\r\n\r\n	td {\r\n		padding: 10px !important;\r\n		/* Adjust the padding to add space between rows and columns */\r\n	}\r\n\r\n	h4 {\r\n		font-size: 21px;\r\n		font-size: 3rem;\r\n		font-weight: 400;\r\n		line-height: 1;\r\n		display: inline;\r\n		padding-top: 7px;\r\n		float: left;\r\n		color: #515151 !important;\r\n	}\r\n\r\n	h2 {\r\n		margin-bottom: .8rem;\r\n		font-family: inherit;\r\n		font-weight: 400;\r\n		line-height: 1.5;\r\n		color: inherit;\r\n	}\r\n\r\n	.text-element-on-small-screens {\r\n		font-size: 2rem;\r\n		line-height: 1.2em;\r\n		color: #515151 !important\r\n	}\r\n\r\n	.text-total-amount {\r\n		float: right;\r\n		font-size: 50px;\r\n		color: #515151 !important;\r\n		font-weight: 700;\r\n		line-height: 1;\r\n	}\r\n\r\n	@media screen and (max-width: 1168px) {\r\n		.element-to-hide-on-small-screens {\r\n			display: none;\r\n		}\r\n\r\n		form  {\r\n			font-size: 1.0rem;\r\n		}\r\n\r\n		.round-rectangle {\r\n			font-size: medium;\r\n		}\r\n		.input-box {\r\n		padding: 2px !important;\r\n		margin: 0 !important;\r\n	}\r\n\r\n	md-input-container .md-input {\r\n		height: 20px !important;\r\n		font-size: 14px !important;\r\n	}\r\n\r\n	md-slider .md-track,\r\n	md-slider .md-track-fill {\r\n		height: 20px !important;\r\n	}\r\n	}\r\n\r\n	@media screen and (max-width: 800px) {\r\n		h4 {\r\n			font-size: 2rem;\r\n			font-weight: 400;\r\n			line-height: 1;\r\n			display: inline;\r\n			padding-top: 7px;\r\n			float: left;\r\n			color: #515151 !important;\r\n		}\r\n\r\n		.text-total-amount {\r\n			float: right;\r\n			font-size: 30px;\r\n			color: #515151 !important;\r\n			font-weight: 700;\r\n			line-height: 1;\r\n		}\r\n\r\n		h2 {\r\n		margin-bottom: .8rem;\r\n		font-family: inherit;\r\n		font-weight: 400;\r\n		line-height: 1.5;\r\n		color: inherit;\r\n		font-size: 2.2rem;\r\n		}\r\n	}\r\n\r\n	@media screen and (max-width: 650px) {\r\n		.round-rectangle {\r\n			font-size: small;\r\n		}\r\n	}\r\n\r\n	@media screen and (max-width: 600px) {\r\n\r\n		.round-rectangle {\r\n			font-size: x-small;\r\n			border-radius: 1px;\r\n			padding: 5px 10px;\r\n			background-color: #ffffff;\r\n			border-spacing: 6px;\r\n		}\r\n\r\n		form  {\r\n			font-size: 0.8rem;\r\n		}\r\n\r\n		md-input-container.md-default-theme .md-input,\r\n		md-input-container .md-input {\r\n			width: 55px;\r\n			height: 16px;\r\n			font-size: 13px;\r\n		}\r\n\r\n		.text-element-on-small-screens {\r\n			font-size: 1.5rem;\r\n			color: #515151 !important;\r\n		}\r\n\r\n		h4 {\r\n			font-size: 1.5rem;\r\n			font-weight: 400;\r\n			line-height: 1;\r\n			display: inline;\r\n			padding-top: 7px;\r\n			float: left;\r\n			color: #515151 !important;\r\n		}\r\n\r\n		.text-total-amount {\r\n			float: right;\r\n			font-size: 20px;\r\n			color: #515151 !important;\r\n			font-weight: 700;\r\n			line-height: 1;\r\n		}\r\n		h2 {\r\n			margin-bottom: .8rem;\r\n			font-family: inherit;\r\n			font-weight: 400;\r\n			line-height: 1.5;\r\n			color: inherit;\r\n			font-size: 1rem;\r\n		}\r\n	}\r\n\r\n	@media screen and (max-width: 400px) {\r\n		.round-rectangle {\r\n			font-size: xx-small;\r\n			border-radius: 1px;\r\n			padding: 5px 10px;\r\n			background-color: #ffffff;\r\n			border-spacing: 1px;\r\n		}\r\n		md-input-container.md-default-theme .md-input,\r\n		md-input-container .md-input {\r\n			width: 40px;\r\n			height: 13px;\r\n			font-size: 10px;\r\n		}\r\n\r\n		.text-element-on-small-screens {\r\n			font-size: 1rem;\r\n			color: #515151 !important;\r\n		}\r\n\r\n		h4 {\r\n			font-size: 1rem;\r\n			font-weight: 400;\r\n			line-height: 1;\r\n			display: inline;\r\n			padding-top: 7px;\r\n			float: left;\r\n			color: #515151 !important;\r\n		}\r\n\r\n		.text-total-amount {\r\n			float: right;\r\n			font-size: 10px;\r\n			color: #515151 !important;\r\n			font-weight: 700;\r\n			line-height: 1;\r\n		}\r\n\r\n		h2 {\r\n			margin-bottom: .8rem;\r\n			font-family: inherit;\r\n			font-weight: 400;\r\n			line-height: 1.5;\r\n			color: inherit;\r\n			font-size: 1rem;\r\n		}\r\n\r\n	}\n</style><div class=\"content-wrapper\"><div class=\"container-fluid\"><div class=\"row justify-content-center\"><div \nclass=\"col bg-white\" style=\"height: 100%\"><div \nstyle=\"width: 100%; height: 300px; background-image: url(\'../../../../assets/images/loan-banner.png\'); background-size: 100% auto; background-repeat: no-repeat; background-position: center center\" \nclass=\"bg-white header-background\" layout=\"row\" layout-align=\"space-around center\"></div><div \nclass=\"page-content-card\"><form name=\"calculatingPaymentForm\"><div layout=\"row\" ng-hide=\"vm.calculatingPayment\" \nlayout-align=\"center center\"><div layout-align=\"space-around center\" flex=\"95\" \nstyle=\"background-color: rgb(245,245,245)\"><div layout=\"row\" layout-align=\"center center\" \nstyle=\"background-color: rgb(255, 255, 255) !important\"><div class=\"input-box info-form-item large-input-box\"><h5>&nbsp\n</h5></div></div><div layout=\"row\" layout-align=\"center center\"><div flex=\"25\" \nclass=\"input-box info-form-item large-input-box pt-7 flex-25\"><span class=\"text-element-on-small-screens\">Total Price\n</span></div><div layout=\"row\" layout-align=\"center center\" flex=\"{{vm.flexValue}}\"><div flex=\"70\" \nclass=\"element-to-hide-on-small-screens\"><md-slider tabindex=\"-1\" aria-label=\"Price slider\" \nng-model=\"vm.paymentCalculator.newVehiclePrice\" min=\"0\" max=\"400000\" ng-model-options=\"{ debounce: 500 }\" step=\"1\" \ndiscrete ng-change=\"vm.refreshPayment();\"></md-slider></div><div flex=\"30\" class=\"pt-7 ml-1 input-container-rectangle\">\n<md-input-container class=\"input-box info-form-item large-input-box\"><input input-control \ninput-translate=\"vm.translateToDollar\" autocorrect=\"off\" autocapitalize=\"none\" spellcheck=\"false\" \nname=\"advertisePrice\" ng-model=\"vm.paymentCalculator.newVehiclePrice\" autocomplete=\"off\" \nng-model-options=\"{ debounce: 500 }\" ng-change=\"vm.refreshPayment();\"></md-input-container></div></div></div><div \nlayout=\"row\" layout-align=\"center center\"><div style=\"width: 100px\"><md-divider></md-divider></div><button class=\"m-1\" \nstyle=\"z-index: 99\" ng-click=\"vm.showVehiclePriceDetail = !vm.showVehiclePriceDetail\"><i \nng-class=\"vm.getDropDownButtonClass()\"></i></button><div style=\"width: 100px\"><md-divider></md-divider></div></div><div\n layout=\"columns\" flex=\"100\" layout-align=\"center center\" ng-hide=\"!vm.showVehiclePriceDetail\"><div flex=\"25\" \nclass=\"input-box info-form-item large-input-box\"><span class=\"text-element-on-small-screens\">Price of your new vehicle\n</span></div><div layout=\"row\" layout-align=\"center center\"><div flex=\"50\" class=\"ml-1 input-container-rectangle\">\n<md-input-container class=\"input-box info-form-item large-input-box\"><input input-control \ninput-translate=\"vm.translateToDollar\" autocorrect=\"off\" autocapitalize=\"none\" spellcheck=\"false\" \nname=\"advertisePrice\" ng-model=\"vm.paymentCalculator.newVehiclePrice \" autocomplete=\"off\" \nng-change=\"vm.refreshPayment();\" ng-model-options=\"{ debounce: 500 }\"></md-input-container></div></div></div><div \nlayout=\"row\" layout-align=\"center center\" ng-hide=\"!vm.showVehiclePriceDetail\"><div flex=\"25\" \nclass=\"input-box info-form-item large-input-box\"><span class=\"text-element-on-small-screens\">Extra</span></div><div \nlayout=\"row\" layout-align=\"center center\"><div flex=\"50\" class=\"ml-1 input-container-rectangle\"><md-input-container \nclass=\"input-box info-form-item large-input-box\"><input input-control input-translate=\"vm.translateToDollar\" \nautocorrect=\"off\" autocapitalize=\"none\" spellcheck=\"false\" name=\"advertisePrice\" \nng-model=\"vm.paymentCalculator.surcharge\" autocomplete=\"off\" ng-change=\"vm.refreshPayment();\" \nng-model-options=\"{ debounce: 500 }\"></md-input-container></div></div></div><md-divider class=\"mb-2\" \nng-hide=\"!vm.showVehiclePriceDetail\"></md-divider><div layout=\"row\" layout-align=\"center center\"><div flex=\"25\" \nclass=\"input-box info-form-item large-input-box pt-7 flex-25\"><span class=\"text-element-on-small-screens\">Warranty Cost\n</span></div><div layout=\"row\" layout-align=\"center center\" flex=\"{{vm.flexValue}}\"><div flex=\"70\" \nclass=\"element-to-hide-on-small-screens\"><md-slider tabindex=\"-1\" aria-label=\"Price slider\" \nng-model-options=\"{ debounce: 500 }\" ng-model=\"vm.paymentCalculator.warrntyCost\" min=\"0\" max=\"200000\" step=\"1\" \ndiscrete ng-change=\"vm.refreshPayment();\"></md-slider></div><div flex=\"30\" class=\"pt-7 ml-1 input-container-rectangle\">\n<md-input-container class=\"input-box info-form-item large-input-box\"><input input-control \ninput-translate=\"vm.translateToDollar\" autocorrect=\"off\" autocapitalize=\"none\" spellcheck=\"false\" \nname=\"advertisePrice\" ng-model=\"vm.paymentCalculator.warrntyCost\" autocomplete=\"off\" ng-change=\"vm.refreshPayment();\" \nng-model-options=\"{ debounce: 500 }\"></md-input-container></div></div></div><div layout=\"row\" \nlayout-align=\"center center\"><div flex=\"25\" class=\"input-box info-form-item large-input-box pt-7 flex-25\"><span \nclass=\"text-element-on-small-screens\">Certification</span></div><div layout=\"row\" layout-align=\"center center\" \nflex=\"{{vm.flexValue}}\"><div flex=\"70\" class=\"element-to-hide-on-small-screens\"><md-slider tabindex=\"-1\" \naria-label=\"Price slider\" ng-model-options=\"{ debounce: 500 }\" ng-model=\"vm.paymentCalculator.certification\" min=\"0\" \nmax=\"10000\" step=\"1\" discrete ng-change=\"vm.refreshPayment();\"></md-slider></div><div flex=\"30\" \nclass=\"pt-7 ml-1 input-container-rectangle\"><md-input-container class=\"input-box info-form-item large-input-box\"><input\n input-control input-translate=\"vm.translateToDollar\" autocorrect=\"off\" autocapitalize=\"none\" spellcheck=\"false\" \nname=\"advertisePrice\" ng-model=\"vm.paymentCalculator.certification\" autocomplete=\"off\" \nng-change=\"vm.refreshPayment();\" ng-model-options=\"{ debounce: 500 }\"></md-input-container></div></div></div><div \nlayout=\"row\" layout-align=\"center center\"><div flex=\"25\" class=\"input-box info-form-item large-input-box pt-7 flex-25\">\n<span class=\"text-element-on-small-screens\">Extras</span></div><div layout=\"row\" layout-align=\"center center\" \nflex=\"{{vm.flexValue}}\"><div flex=\"70\" class=\"element-to-hide-on-small-screens\"><md-slider tabindex=\"-1\" \naria-label=\"Price slider\" ng-model-options=\"{ debounce: 500 }\" ng-model=\"vm.paymentCalculator.extraSecondPrice\" \nmin=\"0\" max=\"10000\" step=\"1\" discrete ng-change=\"vm.refreshPayment();\"></md-slider></div><div flex=\"30\" \nclass=\"pt-7 ml-1 input-container-rectangle\"><md-input-container class=\"input-box info-form-item large-input-box\"><input\n input-control input-translate=\"vm.translateToDollar\" autocorrect=\"off\" autocapitalize=\"none\" spellcheck=\"false\" \nname=\"advertisePrice\" ng-model=\"vm.paymentCalculator.extraSecondPrice\" autocomplete=\"off\" \nng-change=\"vm.refreshPayment();\" ng-model-options=\"{ debounce: 500 }\"></md-input-container></div></div></div><div \nlayout=\"row\" layout-align=\"center center\"><div flex=\"25\" class=\"input-box info-form-item large-input-box pt-7 flex-25\">\n<span class=\"text-element-on-small-screens\">Trade In</span></div><div layout=\"row\" layout-align=\"center center\" \nflex=\"{{vm.flexValue}}\"><div flex=\"70\" class=\"element-to-hide-on-small-screens\"><md-slider tabindex=\"-1\" \naria-label=\"Price slider\" ng-model-options=\"{ debounce: 500 }\" ng-model=\"vm.paymentCalculator.tradeInVehiclePrice\" \nmin=\"0\" max=\"200000\" step=\"1\" discrete ng-change=\"vm.refreshPayment();\"></md-slider></div><div flex=\"30\" \nclass=\"pt-7 ml-1 input-container-rectangle\"><md-input-container class=\"input-box info-form-item large-input-box\"><input\n input-control input-translate=\"vm.translateToDollar\" autocorrect=\"off\" autocapitalize=\"none\" spellcheck=\"false\" \nname=\"advertisePrice\" ng-model=\"vm.paymentCalculator.tradeInVehiclePrice\" autocomplete=\"off\" \nng-change=\"vm.refreshPayment();\" ng-model-options=\"{ debounce: 500 }\"></md-input-container></div></div></div><div \nlayout=\"row\" layout-align=\"center center\"><div flex=\"25\" class=\"input-box info-form-item large-input-box pt-7 flex-25\">\n<span class=\"text-element-on-small-screens\">Loan Balance</span></div><div layout=\"row\" layout-align=\"center center\" \nflex=\"{{vm.flexValue}}\"><div flex=\"70\" class=\"element-to-hide-on-small-screens\"><md-slider tabindex=\"-1\" \naria-label=\"Price slider\" ng-model-options=\"{ debounce: 500 }\" ng-model=\"vm.paymentCalculator.existVehicleLoan\" \nmin=\"0\" max=\"200000\" step=\"1\" discrete ng-change=\"vm.refreshPayment();\"></md-slider></div><div flex=\"30\" \nclass=\"pt-7 ml-1 input-container-rectangle\"><md-input-container class=\"input-box info-form-item large-input-box\"><input\n input-control input-translate=\"vm.translateToDollar\" autocorrect=\"off\" autocapitalize=\"none\" spellcheck=\"false\" \nname=\"advertisePrice\" ng-model=\"vm.paymentCalculator.existVehicleLoan\" autocomplete=\"off\" \nng-change=\"vm.refreshPayment();\" ng-model-options=\"{ debounce: 500 }\"></md-input-container></div></div></div><div \nlayout=\"row\" layout-align=\"center center\"><div flex=\"25\" class=\"input-box info-form-item large-input-box pt-7 flex-25\">\n<span class=\"text-element-on-small-screens\">Down Payment</span></div><div layout=\"row\" layout-align=\"center center\" \nflex=\"{{vm.flexValue}}\"><div flex=\"70\" class=\"element-to-hide-on-small-screens\"><md-slider tabindex=\"-1\" \naria-label=\"Price slider\" ng-model=\"vm.paymentCalculator.downPayment\" min=\"0\" max=\"200000\" step=\"1\" discrete \nng-change=\"vm.refreshPayment();\"></md-slider></div><div flex=\"30\" class=\"pt-7 ml-1 input-container-rectangle\">\n<md-input-container class=\"input-box info-form-item large-input-box\"><input input-control \ninput-translate=\"vm.translateToDollar\" autocorrect=\"off\" autocapitalize=\"none\" spellcheck=\"false\" \nname=\"advertisePrice\" ng-model=\"vm.paymentCalculator.downPayment\" autocomplete=\"off\" ng-change=\"vm.refreshPayment();\" \nng-model-options=\"{ debounce: 500 }\"></md-input-container></div></div></div><div layout=\"row\" \nlayout-align=\"center center\"><div flex=\"25\" class=\"input-box info-form-item large-input-box pt-7 flex-25\"><span \nclass=\"text-element-on-small-screens\">Duration</span></div><div layout=\"row\" layout-align=\"center center\" \nflex=\"{{vm.flexValue}}\"><div flex=\"70\" class=\"element-to-hide-on-small-screens\"><md-slider tabindex=\"-1\" \nng-model-options=\"{ debounce: 500 }\" aria-label=\"Price slider\" ng-model=\"vm.paymentCalculator.loanDuration\" min=\"0\" \nmax=\"96\" step=\"3\" discrete ng-change=\"vm.refreshPayment();\"></md-slider></div><div flex=\"30\" \nclass=\"pt-7 ml-1 input-container-rectangle\"><md-input-container class=\"input-box info-form-item large-input-box\"><input\n name=\"term\" ng-model=\"vm.paymentCalculator.loanDuration\" ng-model-options=\"{ debounce: 500 }\" \nng-change=\"vm.refreshPayment()\" aria-label=\"Term\" md-no-asterisk min=\"0\" max=\"96\" step=\"3\"></md-input-container></div>\n</div></div><md-divider class=\"mb-2\"></md-divider><div layout=\"row\" layout-align=\"center center\"><div flex=\"25\" \nclass=\"input-box info-form-item large-input-box pt-7 flex-25\"><span class=\"text-element-on-small-screens\">Tax</span>\n</div><div layout=\"row\" layout-align=\"center center\" flex=\"{{vm.flexValue}}\"><div flex=\"70\" \nclass=\"element-to-hide-on-small-screens\"><md-slider tabindex=\"-1\" aria-label=\"Price slider\" \nng-model=\"vm.paymentCalculator.provincialSalestax\" min=\"0\" max=\"0.15\" step=\"0.001\" discrete \nng-change=\"vm.refreshPayment();\"></md-slider></div><div flex=\"30\" class=\"pt-7 ml-1 input-container-rectangle\">\n<md-input-container><input class=\"input-box info-form-item large-input-box\" ng-change=\"vm.refreshPayment();\" \ntype=\"text\" autocorrect=\"off\" autocapitalize=\"none\" spellcheck=\"false\" name=\"interestRate\" maxlength=\"5\" \nng-model=\"vm.paymentCalculator.provincialSalestax\" autocomplete=\"off\" input-control \ninput-options=\"vm.interestRateInputOption\" input-translate=\"vm.translateToPercentage\" \nng-keydown=\"vm.captureFirstKeydownForTax($event)\"></md-input-container></div></div></div><div layout=\"row\" \nlayout-align=\"center center\"><div flex=\"25\" class=\"input-box info-form-item large-input-box pt-7 flex-25\"><span \nclass=\"text-element-on-small-screens\">Interest Rate</span></div><div layout=\"row\" layout-align=\"center center\" \nflex=\"{{vm.flexValue}}\"><div flex=\"70\" class=\"element-to-hide-on-small-screens\"><md-slider tabindex=\"-1\" \naria-label=\"Price slider\" ng-model=\"vm.paymentCalculator.expectedInterestRate\" min=\"0\" max=\"0.30\" step=\"0.001\" \ndiscrete ng-change=\"vm.refreshPayment();\"></md-slider></div><div flex=\"30\" class=\"pt-7 ml-1 input-container-rectangle\">\n<md-input-container class=\"input-box info-form-item large-input-box\"><input \nclass=\"input-box info-form-item large-input-box\" ng-change=\"vm.refreshPayment();\" type=\"text\" autocorrect=\"off\" \nautocapitalize=\"none\" spellcheck=\"false\" name=\"interestRate\" maxlength=\"5\" \nng-model=\"vm.paymentCalculator.expectedInterestRate\" autocomplete=\"off\" input-control \ninput-options=\"vm.interestRateInputOption\" input-translate=\"vm.translateToPercentage\" \nng-keydown=\"vm.captureFirstKeydownForRate($event)\"></md-input-container></div></div></div><div layout=\"row\" \nlayout-align=\"space-around center\" style=\"background-color: rgb(255, 255, 255) !important\"><div flex=\"40\" \nclass=\"input-box info-form-item large-input-box\"><h5>&nbsp</h5></div></div><div layout=\"row\" \nlayout-align=\"space-around center\" style=\"height: 100px\"><div flex=\"50\"><h4>Your total amount to be financed will be\n</h4></div><div><p class=\"text-total-amount\">{{vm.filter(\'currency\')(vm.paymentCalculator.totalFinanceAmount, \'$\', 2)}}\n</p></div></div><div layout=\"row\" layout-align=\"space-around center\" \nstyle=\"background-color: rgb(255, 255, 255) !important\"><div flex=\"40\" \nclass=\"input-box info-form-item large-input-box\"><h5>&nbsp</h5></div></div><div layout=\"row\" layout-align=\"center\" \nstyle=\"background-color: rgb(255, 255, 255) !important\"><div flex=\"80\" \nclass=\"input-box info-form-item large-input-box ml-5\"><h2>With the following payments:</h2></div><div flex=\"20\"></div>\n</div><div layout=\"row\" layout-align=\"center center\" style=\"background-color: rgb(245,245,245)\"><div flex=\"100\"><table \nclass=\"gray-table\"><thead><tr><th style=\"width: 30%\"><div class=\"table-header\"><span class=\"column-title\">\nPayment Frequency</span></div></th><th style=\"width: 5%\"><div class=\"table-header\"><span class=\"column-title\">\nPayment Amount</span></div></th><th style=\"width: 15%\"><div class=\"table-header\"><span class=\"column-title\">\nTotal Interest to be Paid<br>over the Duration of the Loan</span></div></th><th style=\"width: 5%\"><div \nclass=\"table-header\"><span class=\"column-title\">Total Obligation</span></div></th></tr></thead><tbody \nclass=\"gray-table\"><tr ng-repeat=\"payment in vm.paymentTable\"><td class=\"round-rectangle\">{{payment.title}}</td><td \nclass=\"round-rectangle\" style=\"font-weight: 1000\">{{payment.amount}}</td><td class=\"round-rectangle\">\n{{payment.interest}}</td><td class=\"round-rectangle\">{{payment.totalObligation}}</td></tr></tbody></table></div></div>\n<div layout=\"row\" layout-align=\"center center\" style=\"background-color: rgb(255, 255, 255) !important\"><div flex=\"40\" \nclass=\"input-box info-form-item large-input-box\"><h5>&nbsp</h5></div></div></div></div></form></div></div></div></div>\n</div>");
$templateCache.put("app/main/vehicles/payment-calculator/payment-calculator.html","");
$templateCache.put("app/main/vehicles/loan-calculator-class/loadCalculatorClass.html","");
$templateCache.put("app/main/vehicles/purchase-complete/purchase-complete.html","<div class=\"bg-img-congrats\"><div ng-if=\"!vm.isLoading\" style=\"position: relative; width: 100%; height: 100%\">\n<md-content class=\"bg-transparent\" style=\"position: absolute; width: 100%; height: 100%; top:0; left: 0\"><h1 \nclass=\"mt-10 text-center\">Congratulations {{::vm.customer.first_name}}!</h1><h4 class=\"text-center\">\nYou are now the pround new owner of a {{::vm.vehicle.getYearMakeModel()}}!</h4><div layout=\"row\" \nlayout-align=\"center center\" layout-wrap><div class=\"p-2\" flex=\"100\" flex-gt-sm=\"33\" layout=\"row\" \nlayout-align=\"center center\"><div style=\"width: 425px;height: 550px\" class=\"bg-card-congrats raised-box-dark\"><div \nclass=\"px-5 py-7\" style=\"width: 100%;height: 100%; position: relative\" layout=\"column\" layout-align=\"center center\">\n<img class=\"card\" style=\"height: 280px; object-fit: contain\" ng-src=\"{{vm.vehicle.landingImage}}\"><h5 \nclass=\"my-3 font-weight-bold\">{{::vm.vehicle.getYearMakeModel()}}</h5><div flex=\"grow\" class=\"font-weight-bold\" \nstyle=\"font-size: 13px; height: 150px\" layout=\"row\" layout=\"center center\" layout-fill><div layout=\"column\" \nlayout-align=\"center start\" flex><div style=\"width: 100%\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"mr-2 text-grey\">VIN:</div><div class=\"text-nowrap text-truncate\">{{::vm.vehicle.vin}}</div></div><div \nstyle=\"width: 100%\" layout=\"row\" layout-align=\"space-between center\"><div class=\"mr-2 text-grey\">Mileage:</div><div \nclass=\"text-nowrap text-truncate\">{{::vm.vehicle.mileage | number}} KM</div></div><div style=\"width: 100%\" \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"mr-2 text-grey\">Color:</div><div \nclass=\"text-nowrap text-truncate\">{{::vm.vehicle.exterior_color}}</div></div><div style=\"width: 100%\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"mr-2 text-grey\">Transmission:</div><div \nclass=\"text-nowrap text-truncate\">{{::vm.vehicle.transmission_type}}</div></div></div><md-divider class=\"mx-4\">\n</md-divider><div flex layout=\"column\" layout-align=\"center center\" style=\"position: relative\"><div \nng-if=\"!vm.isAllSigned\" layout=\"column\"><button class=\"btn btn-secondary btn-sm mb-2\" ng-click=\"vm.printBillOfSale()\">\nprint</button> <button ng-if=\"vm.signature\" id=\"sign\" type=\"button\" class=\"btn btn-secondary btn-sm mb-2\" \nng-click=\"vm.togglePopover()\">signatures</button></div><div style=\"width: 100px\"><i ng-if=\"vm.isAllSigned\" \nclass=\"icon-check-circle-outline text-green\" style=\"font-size: 100px\"></i></div><div \nstyle=\"position: absolute; bottom: 0\" ng-if=\"vm.previewFileUrl\"><button ng-click=\"vm.printSignedFile()\"><a \nng-href=\"{{vm.printUrl}}\" layout=\"row\" layout-align=\"center center\"><i class=\"icon-printer text-secondary\"></i><div>\nPrint</div></a></button></div></div></div></div></div></div><div style=\"position: relative\" ng-if=\"vm.isAllSigned\" \nflex=\"100\" flex-gt-sm=\"33\" layout=\"column\" layout-align=\"start center\" layout-gt-sm-align=\"center start\"><md-content \nstyle=\"width: 425px;height: 550px; position: relative\" class=\"card\"><pdf-viewer src=\"vm.previewFileUrl\"></pdf-viewer>\n</md-content><div layout=\"row\" layout-align=\"center center\" ng-if=\"!vm.previewFileUrl\" \nstyle=\"position: absolute;top:50%;width: 100%\"><md-progress-circular md-mode=\"indeterminate\" md-diameter=\"40\">\n</md-progress-circular></div></div></div></md-content></div><div click-outside=\"vm.togglePopover(false)\" \nis-active=\"vm.popoverStyle.visibility == \'visible\'\" ng-style=\"vm.popoverStyle\" class=\"card rounded\" \nstyle=\"position: absolute; top: 0; width: 300px\" id=\"popover\"><div id=\"arrow\" data-popper-arrow></div><div \nlayout=\"row\" class=\"pl-3 bg-secondary\" layout-align=\"space-between center\"><div class=\"text-white\">Signers</div><i \nstyle=\"font-size: 15px\" class=\"icon-close text-red\" ng-click=\"vm.togglePopover()\"></i></div><div class=\"p-3\"><div \nstyle=\"height: 30px\" layout=\"row\" layout-align=\"space-between center\" \nng-repeat=\"signature in vm.signatureDetail.signatures\"><div>{{signature.signer_name}}</div><div layout=\"row\" \nlayout-align=\"space-between center\"><button class=\"mr-2\" ng-show=\"signature.status_code != \'signed\'\" \nng-click=\"vm.copySigningPageLink(signature)\"><i class=\"icon-content-copy\" \nng-class=\"vm.signingRecords[signature.signature_id].isCopied ? [\'text-green\']:[\'text-secondary\']\"></i></button> <button\n class=\"mr-2\" \nng-disabled=\"vm.signingRecords[signature.signature_id].isSending || vm.signingRecords[signature.signature_id].isSent\" \nng-click=\"vm.sendSigningPageLinkByEmail(signature)\"><md-progress-circular style=\"width: 20px\" \nng-show=\"vm.signingRecords[signature.signature_id].isSending\" md-diameter=\"24\" class=\"\"></md-progress-circular><i \nng-show=\"!vm.signingRecords[signature.signature_id].isSending && signature.status_code != \'signed\'\" class=\"icon-email\" \nng-class=\"vm.signingRecords[signature.signature_id].isSent ? [\'\']:[\'text-secondary\']\"></i></button> <i \nng-show=\"signature.status_code == \'signed\'\" class=\"icon-check text-green\"></i> <button \nng-show=\"signature.status_code != \'signed\'\" ng-disabled=\"vm.signingRecords[signature.signature_id].isSigning\" \nng-click=\"vm.finishSignRequest(signature)\"><md-progress-circular \nng-show=\"vm.signingRecords[signature.signature_id].isSigning\" md-diameter=\"24\"></md-progress-circular><i \nng-show=\"!vm.signingRecords[signature.signature_id].isSigning\" class=\"icon-pen text-secondary\"></i></button></div>\n</div></div></div></div>");
$templateCache.put("app/main/vehicles/purchase-steps/purchase-steps.html","<div layout=\"row\" layout-wrap><form flex=\"100\" flex-gt-sm=\"80\" class=\"mb-3\" name=\"stepper\" ms-horizontal-stepper \nng-submit=\"vm.submitStepper()\" ng-model=\"vm.stepper\" novalidate><ms-horizontal-stepper-step stepper-api=\"vm.stepApi\" \nng-form=\"personalInfoForm\" step-title=\"vm.vehicleConstants.purchaseSteps.personalInfo.stepTitle\" layout=\"row\" \nlayout-align=\"center center\" hide-action-buttons=\"true\"><div class=\"accordion mt-5\" id=\"customerInfoForm\" \nflex-gt-sm=\"70\" flex=\"100\"><div class=\"card\"><div class=\"card-header purchase-step-info-form-header py-1 px-0\"><h5 \nclass=\"mb-0\" layout=\"row\" layout-align=\"space-between center\"><button class=\"btn btn-link\" type=\"button\" \ndata-toggle=\"collapse\" data-target=\"#personalInfo\" aria-expanded=\"true\" aria-controls=\"personalInfo\">\nPersonal Information</button><md-icon class=\"icon-check-circle text-green mr-3\" ng-if=\"personalForm.$valid\"></md-icon>\n</h5></div><div id=\"personalInfo\" class=\"collapse show\" data-parent=\"#customerInfoForm\"><div class=\"card-body\" \nng-form=\"personalForm\"><div layout=\"column\" layout-gt-sm=\"row\"><div flex-gt-sm=\"50\"><div layout=\"column\" \nlayout-gt-sm=\"row\"><md-input-container flex-gt-sm=\"50\" \nclass=\"input-box info-form-item small-input-box purchase-step-payment-input-box\"><input type=\"text\" \nng-change=\"vm.queryCustomers()\" autocorrect=\"off\" spellcheck=\"false\" ng-required=\"true\" name=\"firstName\" \nng-model=\"vm.customer.first_name\" input-control input-translate=\"vm.translateToFirstCap\" autocomplete=\"off\" \nplaceholder=\"First Name\" maxlength=\"25\" ng-model-options=\"{ debounce: 500 }\" class=\"text-capitalize\"><div \nng-messages=\"personalForm.firstName.$error\"><div ng-message=\"maxlength\">Input content can not be over 25 charactors\n</div><div ng-message=\"required\">This field is required</div></div></md-input-container><md-input-container \nflex-gt-sm=\"50\" class=\"input-box info-form-item small-input-box purchase-step-payment-input-box\"><input type=\"text\" \nautocorrect=\"off\" autocapitalize=\"none\" spellcheck=\"false\" ng-change=\"vm.queryCustomers()\" ng-required=\"true\" \nname=\"lastName\" ng-model=\"vm.customer.last_name\" autocomplete=\"off\" placeholder=\"Last Name\" maxlength=\"50\" \nng-model-options=\"{ debounce: 500 }\" input-control input-translate=\"vm.translateToFirstCap\" class=\"text-capitalize\">\n<div ng-messages=\"personalForm.lastName.$error\"><div ng-message=\"maxlength\">Input content can not be over 50 charactors\n</div><div ng-message=\"required\">This field is required</div></div></md-input-container></div><div layout=\"row\" \nlayout-align=\"start center\"><md-input-container flex-sm=\"60\" flex-gt-sm=\"50\" \nclass=\"input-box info-form-item small-input-box purchase-step-payment-input-box\"><input type=\"tel\" \nng-change=\"vm.queryCustomers()\" ng-required=\"true\" name=\"phoneNumber\" ng-model=\"vm.customerPhoneNumber.phone_number\" \nautocomplete=\"off\" placeholder=\"Phone Number\" input-control input-translate=\"vm.translateToPhoneNumber\" \nng-model-options=\"{ debounce: 500 }\"><div ng-messages=\"personalForm.phoneNumber.$error\"><div ng-message=\"required\">\nThis field is required</div><div ng-message=\"pattern\">Invalid phone number</div></div></md-input-container><md-select \nclass=\"md-no-underline small-selector purchase-step-selector\" tabindex=\"-1\" \nng-model=\"vm.customerPhoneNumber.fk_id_phone_category\" placeholder=\"category\"><md-option \nng-repeat=\"phoneCategory in vm.constants.phoneCategories\" value=\"{{phoneCategory.id_phone_category}}\">\n{{phoneCategory.category}}</md-option></md-select><md-switch ng-model=\"vm.customerPhoneNumber.allow_notification\" \nmd-invert class=\"basic-info-form-contact-list-switch purchase-step-switch\" style=\"font-size: 13px\"></md-switch></div>\n<div layout=\"row\" layout-align=\"start center\"><md-input-container flex-sm=\"60\" flex-gt-sm=\"50\" \nclass=\"input-box info-form-item small-input-box purchase-step-payment-input-box\"><input type=\"email\" \nng-change=\"vm.queryCustomers()\" name=\"email\" ng-model=\"vm.customerEmail.email_address\" autocomplete=\"off\" \nplaceholder=\"Email Address\" ng-model-options=\"{ debounce: 500 }\" maxlength=\"50\" ng-pattern=\"vm.emailPatern\"><div \nng-messages=\"personalForm.email.$error\"><div ng-message=\"maxlength\">Input content can not be over 50 charactors</div>\n<div ng-message=\"email\">Invalid email address</div><div ng-message=\"pattern\">Invalid email address</div></div>\n</md-input-container><md-select class=\"md-no-underline small-selector purchase-step-selector\" tabindex=\"-1\" \nng-model=\"vm.customerEmail.fk_id_email_category\" placeholder=\"category\"><md-option \nng-repeat=\"emailCategory in vm.constants.emailCategories\" value=\"{{emailCategory.id_email_category}}\">\n{{emailCategory.name}}</md-option></md-select><md-switch ng-model=\"vm.customerEmail.allow_notification\" md-invert \nclass=\"basic-info-form-contact-list-switch purchase-step-switch\" style=\"font-size: 13px\"></md-switch></div><div \nlayout=\"row\"><md-input-container class=\"info-form-item small-input-box purchase-step-payment-input-box\"><label>\nDate of Birth:</label><md-datepicker md-hide-icons=\"calendar\" ng-model=\"vm.birthdayPickerValue\" \nng-change=\"vm.setCustomerBirthday(vm.birthdayPickerValue)\" name=\"birthday\" md-max-date=\"vm.maxBirthdayDate\" \nmd-current-view=\"year\"></md-datepicker><div ng-messages=\"personalForm.birthday.$error\" \nng-if=\"personalForm.birthday.$invalid\"><div ng-message=\"valid\">Invalid date.</div><div ng-message=\"maxdate\">\nMust be over 16 years old.</div></div></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\">\n<md-input-container flex-gt-sm=\"50\" class=\"input-box info-form-item small-input-box purchase-step-payment-input-box\">\n<input type=\"text\" autocorrect=\"off\" autocapitalize=\"none\" spellcheck=\"false\" ng-required=\"true\" name=\"driversLicense\" \nng-model=\"vm.customer.drivers_license\" autocomplete=\"off\" placeholder=\"Driver License\" maxlength=\"50\" input-control \ninput-translate=\"vm.translateToAllCapitalize\"><div ng-messages=\"personalForm.driversLicense.$error\"><div \nng-message=\"maxlength\">Input content can not be over 50 charactors</div><div ng-message=\"required\">\nThis field is required</div></div></md-input-container><md-input-container \nclass=\"info-form-item small-input-box purchase-step-payment-input-box\"><label>Expiry Date:</label><md-datepicker \nmd-hide-icons=\"calendar\" ng-model=\"vm.expiryDatePickerValue\" \nng-change=\"vm.setCustomerLicenseExpiryDate(vm.expiryDatePickerValue)\" name=\"expiryDate\" md-current-view=\"year\">\n</md-datepicker><div ng-messages=\"personalForm.expiryDate.$error\"><div ng-message=\"valid\">Invalid date.</div><div \nng-message=\"required\">This field is required</div></div></md-input-container></div><md-input-container \nstyle=\"position: relative\" class=\"input-box info-form-item small-input-box purchase-step-payment-input-box\"><input \nng-focus=\"vm.onPostcodeFocus()\" ng-blur=\"vm.onPostcodeBlur()\" autocorrect=\"off\" autocapitalize=\"none\" \nspellcheck=\"false\" ng-required=\"vm.saleInfo.fk_id_payment_option == vm.financeOption.id_payment_option\" \nname=\"addressPostalCode\" ng-model=\"vm.customer.address_postal_code\" autocomplete=\"off\" placeholder=\"Postal Code\" \ninput-control input-translate=\"vm.translateToPostalCode\" ng-change=\"vm.onPostcodeChange()\"><div \nng-messages=\"personalForm.addressPostalCode.$error\"><div ng-message=\"required\">This field is required</div></div><div \nng-if=\"vm.showAddressList\" style=\"position: absolute; top: 30px; width: 100%;z-index: 100\" class=\"input-box-padding\">\n<md-content class=\"simple-border-no-radius\" style=\"max-height: 150px\"><md-progress-linear ng-if=\"vm.fetchingAddress\" \nmd-mode=\"indeterminate\"></md-progress-linear><div ng-click=\"vm.selectAddress(address)\" class=\"p-1\" \nng-if=\"!vm.fetchingAddress\" ng-repeat=\"address in vm.addressList\">{{vm.getAddressName(address)}}</div></md-content>\n</div></md-input-container><div layout=\"row\"><md-input-container \nclass=\"input-box info-form-item small-input-box purchase-step-payment-input-box\"><input type=\"text\" autocorrect=\"off\" \nautocapitalize=\"none\" spellcheck=\"false\" \nng-required=\"vm.saleInfo.fk_id_payment_option == vm.financeOption.id_payment_option\" name=\"addressStreetNumber\" \nng-model=\"vm.customer.address_street_number\" autocomplete=\"off\" placeholder=\"Street #\" maxlength=\"100\"><div \nng-messages=\"personalForm.addressStreetNumber.$error\"><div ng-message=\"maxlength\">\nInput content can not be over 100 charactors</div><div ng-message=\"required\">This field is required</div></div>\n</md-input-container><md-input-container \nclass=\"input-box info-form-item small-input-box purchase-step-payment-input-box\"><input type=\"text\" autocorrect=\"off\" \nautocapitalize=\"none\" spellcheck=\"false\" \nng-required=\"vm.saleInfo.fk_id_payment_option == vm.financeOption.id_payment_option\" name=\"addressStreet\" \nng-model=\"vm.customer.address_street\" autocomplete=\"off\" placeholder=\"Street\" maxlength=\"100\"><div \nng-messages=\"personalForm.addressStreet.$error\"><div ng-message=\"maxlength\">\nInput content can not be over 100 charactors</div><div ng-message=\"required\">This field is required</div></div>\n</md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex-gt-sm=\"50\" \nclass=\"input-box info-form-item small-input-box purchase-step-payment-input-box\"><input type=\"text\" autocorrect=\"off\" \nautocapitalize=\"none\" spellcheck=\"false\" \nng-required=\"vm.saleInfo.fk_id_payment_option == vm.financeOption.id_payment_option\" name=\"addressCity\" \nng-model=\"vm.customer.address_city\" autocomplete=\"off\" placeholder=\"City\" input-control \ninput-translate=\"vm.translateToFirstCap\" maxlength=\"50\"><div ng-messages=\"personalForm.addressCity.$error\"><div \nng-message=\"maxlength\">Input content can not be over 50 charactors</div><div ng-message=\"required\">\nThis field is required</div></div></md-input-container><md-input-container flex-gt-sm=\"50\" \nclass=\"input-box info-form-item small-input-box purchase-step-payment-input-box\"><input type=\"text\" autocorrect=\"off\" \nautocapitalize=\"none\" spellcheck=\"false\" \nng-required=\"vm.saleInfo.fk_id_payment_option == vm.financeOption.id_payment_option\" name=\"addressProvince\" \nng-model=\"vm.customer.address_province\" autocomplete=\"off\" placeholder=\"Province\" maxlength=\"20\" input-control \ninput-translate=\"vm.translateToAllCapitalize\"><div ng-messages=\"personalForm.addressProvince.$error\"><div \nng-message=\"maxlength\">Input content can not be over 20 charactors</div><div ng-message=\"required\">\nThis field is required</div></div></md-input-container></div></div><div flex-gt-sm=\"50\" layout-margin><div flex \nng-if=\"vm.customersFound.length > 0\" style=\"font-size: 13px\"><div class=\"card\"><div class=\"card-header\">\nPotential Matches</div><div class=\"card-body scrollable py-1\" style=\"max-height: 200px\" ms-scroll><md-content><div \nng-click=\"vm.selectedCustomerID = customer.getResourceID()\" layout=\"row\" class=\"pl-1 py-1 customer-found\" \nlayout-align=\"space-between center\" ng-class=\"vm.selectedCustomerID == customer.getResourceID()? [\'bg-light\']:[\'\']\" \nng-repeat=\"customer in vm.customersFound\"><span flex=\"50\" class=\"text-nowrap text-truncate\">\n{{customer.first_name}} {{customer.last_name}}</span><div layout=\"row\" class=\"mt-1 px-2\" \nng-if=\"vm.selectedCustomerID == customer.getResourceID()\"><span class=\"badge badge-secondary mr-1\" \nng-click=\"vm.goToCustomerPage(customer)\">View</span> <span class=\"badge badge-secondary mx-0\" \nng-click=\"vm.loadCusomter(customer)\">Load</span></div></div></md-content></div></div></div><div class=\"card p-2\">\n<md-progress-linear ng-if=\"vm.fetchingCustomerLicense\" md-mode=\"indeterminate\"></md-progress-linear><pinch-zoom \nid=\"customerLicenseImage\" min-scale=\"1\" ng-if=\"vm.customerLicenseImageSrc\"><img \nng-src=\"{{vm.customerLicenseImageSrc}}\"></pinch-zoom><img style=\"object-fit: contain\" \nng-if=\"!vm.customerLicenseImageSrc\" src=\"assets/images/driver-license-placeholder.jpg\"><div layout=\"column\" \nlayout-align=\"center center\"><md-button class=\"btn-secondary btn-sm basic-info-form-file-select-button\">\n{{vm.customer.fk_license_image ? \'UPDATE IMAGE\' : \'SELECT IMAGE\'}} <input class=\"fileInput\" nv-file-select=\"false\" \nuploader=\"vm.imageUploader\" type=\"file\" accept=\"image/*\"></md-button></div></div></div></div></div></div></div><div \nclass=\"mt-5\" layout=\"row\" layout-align=\"center center\"><button class=\"btn btn-secondary\" \nng-click=\"vm.finishCustomerInfoForm()\" ng-disabled=\"personalForm.$invalid\">NEXT</button></div></div>\n</ms-horizontal-stepper-step><ms-horizontal-stepper-step ng-form=\"tradeInVehicle\" step-title=\"\'Trade In Option\'\" \nhide-action-buttons=\"true\"><div layout=\"row\" layout-align=\"center center\"><div layout=\"column\" flex=\"100\" \nflex-gt-sm=\"50\" layout-align=\"center center\"><h>Do you have a car to trade in?</h><div layout=\"row\"><button flex=\"45\" \nclass=\"btn m-2\" ng-class=\"vm.isTradingInVehicle == true? [\'btn-secondary\']:[\'btn-outline-secondary\']\" \nng-click=\"vm.setTradeInOption(true)\">Yes</button> <button flex=\"45\" class=\"btn m-2\" \nng-class=\"vm.isTradingInVehicle == false? [\'btn-secondary\']:[\'btn-outline-secondary\']\" \nng-click=\"vm.setTradeInOption(false)\">No</button></div><input ng-model=\"vm.isTradingInVehicle\" ng-required=\"true\" \nname=\"isTradingInVehicle\" style=\"visibility: hidden\"><div class=\"card animate-fade-in-out mt-5\" \nng-form=\"tradeInVehicleInfo\" ng-if=\"vm.isTradingInVehicle\"><div class=\"card-header purchase-step-info-form-header\">\nVehicle Information</div><div class=\"card-body\"><div layout=\"row\" layout-align=\"start center\"><md-input-container \nflex=\"50\" class=\"input-box info-form-item small-input-box purchase-step-payment-input-box\"><input type=\"text\" \nautocorrect=\"off\" autocapitalize=\"none\" spellcheck=\"false\" ng-required=\"true\" name=\"tradeInVehicleVin\" \nng-model=\"vm.tradeInVehicle.vin\" autocomplete=\"off\" placeholder=\"VIN\" maxlength=\"17\" input-control \ninput-translate=\"vm.translateToVIN\"><div ng-messages=\"tradeInVehicleInfo.tradeInVehicleVin.$error\"><div \nng-message=\"maxlength\">Input content can not be over 50 charactors</div><div ng-message=\"required\">\nThis field is required</div></div></md-input-container><button class=\"btn-secondary btn-sm\" ng-click=\"vm.decodeVIN()\">\nExplode</button></div><div layout=\"row\" layout-align=\"center center\"><md-input-container \nclass=\"input-box info-form-item small-input-box purchase-step-payment-input-box\"><input type=\"text\" autocorrect=\"off\" \nautocapitalize=\"none\" spellcheck=\"false\" ng-required=\"true\" name=\"tradeInVehicleYear\" \nng-model=\"vm.tradeInVehicle.year\" autocomplete=\"off\" placeholder=\"Year\" maxlength=\"4\" ng-pattern=\"/^[0-9]*$/\" \ninput-pattern><div ng-messages=\"tradeInVehicleInfo.tradeInVehicleYear.$error\"><div ng-message=\"maxlength\">\nInput content can not be over 50 charactors</div><div ng-message=\"required\">This field is required</div></div>\n</md-input-container><md-input-container \nclass=\"input-box info-form-item small-input-box purchase-step-payment-input-box\"><input type=\"text\" autocorrect=\"off\" \nautocapitalize=\"none\" spellcheck=\"false\" ng-required=\"true\" name=\"tradeInVehicleMake\" \nng-model=\"vm.tradeInVehicle.make\" autocomplete=\"off\" placeholder=\"Make\" maxlength=\"50\"><div \nng-messages=\"tradeInVehicleInfo.tradeInVehicleMake.$error\"><div ng-message=\"maxlength\">\nInput content can not be over 50 charactors</div><div ng-message=\"required\">This field is required</div></div>\n</md-input-container></div><div layout=\"row\" layout-align=\"center center\"><md-input-container \nclass=\"input-box info-form-item small-input-box purchase-step-payment-input-box\"><input type=\"text\" autocorrect=\"off\" \nautocapitalize=\"none\" spellcheck=\"false\" ng-required=\"true\" name=\"tradeInVehicleModel\" \nng-model=\"vm.tradeInVehicle.model\" autocomplete=\"off\" placeholder=\"Model\" maxlength=\"50\"><div \nng-messages=\"tradeInVehicleInfo.tradeInVehicleModel.$error\"><div ng-message=\"maxlength\">\nInput content can not be over 50 charactors</div><div ng-message=\"required\">This field is required</div></div>\n</md-input-container><md-input-container \nclass=\"input-box info-form-item small-input-box purchase-step-payment-input-box\"><input type=\"text\" autocorrect=\"off\" \nautocapitalize=\"none\" spellcheck=\"false\" ng-required=\"true\" name=\"tradeInVehicleColor\" \nng-model=\"vm.tradeInVehicle.color\" autocomplete=\"off\" placeholder=\"Color\" maxlength=\"50\"><div \nng-messages=\"tradeInVehicleInfo.tradeInVehicleColor.$error\"><div ng-message=\"maxlength\">\nInput content can not be over 50 charactors</div><div ng-message=\"required\">This field is required</div></div>\n</md-input-container></div><div layout=\"row\"><md-input-container flex-gt-sm=\"50\" \nclass=\"input-box info-form-item small-input-box purchase-step-payment-input-box\"><input type=\"text\" autocorrect=\"off\" \nautocapitalize=\"none\" spellcheck=\"false\" name=\"tradeInVehicleMileage\" ng-model=\"vm.tradeInVehicle.mileage\" \nautocomplete=\"off\" placeholder=\"Mileage\" ng-pattern=\"/^[0-9]*$/\" input-pattern maxlength=\"10\"><div \nng-messages=\"tradeInVehicleInfo.tradeInVehicleMileage.$error\"><div ng-message=\"maxlength\">\nInput content can not be over 50 charactors</div><div ng-message=\"required\">This field is required</div></div>\n</md-input-container><md-input-container flex-gt-sm=\"50\" \nclass=\"input-box info-form-item small-input-box purchase-step-payment-input-box\"><input type=\"text\" autocorrect=\"off\" \nautocapitalize=\"none\" spellcheck=\"false\" name=\"tradeInPrice\" ng-model=\"vm.tradeInVehicle.trade_in_price\" \nautocomplete=\"off\" placeholder=\"Trade in price\" input-control input-translate=\"vm.translateToDollar\" maxlength=\"10\">\n<div ng-messages=\"tradeInVehicleInfo.tradeInPrice.$error\"><div ng-message=\"maxlength\">\nInput content can not be over 50 charactors</div><div ng-message=\"required\">This field is required</div></div>\n</md-input-container></div><div layout=\"row\"><md-input-container flex-gt-sm=\"50\" \nclass=\"input-box info-form-item small-input-box purchase-step-payment-input-box\"><input type=\"text\" autocorrect=\"off\" \nautocapitalize=\"none\" spellcheck=\"false\" name=\"tradeInVehicleTradeLienPayout\" \nng-model=\"vm.tradeInVehicle.trade_lien_payout\" autocomplete=\"off\" placeholder=\"Lien Payout\" input-control \ninput-translate=\"vm.translateToDollar\" maxlength=\"10\"><div \nng-messages=\"tradeInVehicleInfo.tradeInVehicleTradeLienPayout.$error\"><div ng-message=\"maxlength\">\nInput content can not be over 50 charactors</div></div></md-input-container></div></div></div><div class=\"mt-5\" \nclass=\"row\" layout-align=\"center center\" hide-xs ng-if=\"vm.isTradingInVehicle\"><button class=\"btn btn-secondary mx-2\" \nng-click=\"vm.stepApi.goToPreviousStep()\">LAST</button> <button class=\"btn btn-secondary mx-2\" \nng-click=\"vm.stepApi.goToNextStep()\" ng-disabled=\"tradeInVehicle.tradeInVehicleInfo.$invalid\">NEXT</button></div></div>\n</div></ms-horizontal-stepper-step><ms-horizontal-stepper-step ng-form=\"plateOptionForm\" step-title=\"\'Plate Option\'\" \nhide-action-buttons=\"true\"><div layout=\"row\" layout-align=\"center center\"><img class=\"my-3\" \nsrc=\"assets/images/license-plate.jpg\"></div><div layout=\"row\" layout-align=\"space-between center\" class=\"mt-5\">\n<md-button ng-repeat=\"plateOption in vm.plateOptions\" flex class=\"btn\" \nng-class=\"vm.selectedPlateOption == plateOption.id_plate_option ? [\'btn-secondary\', \'text-white\']:[\'btn-outline-secondary\', \'text-secondary\']\" \nng-click=\"vm.setPlateOption(plateOption)\"><span>{{plateOption.name}} {{plateOption.cost | currency:\'$\':0}}</span>\n</md-button></div><input ng-model=\"vm.selectedPlateOption\" ng-required=\"true\" name=\"plateOption\" \nstyle=\"visibility: hidden\"></ms-horizontal-stepper-step><ms-horizontal-stepper-step ng-form=\"warranty\" \nstep-title=\"\'Warranty\'\" hide-step=\"!vm.isWarrantyAvaliable\" \nng-style=\"vm.isWarrantyAvaliable? {\'visibility\':\'visible\'}:{\'visibility\':\'hidden\'}\"><div layout=\"column\"><div \nlayout=\"row\" layout-align=\"center center\"><img flex-gt-sm=\"60\" src=\"assets/images/warranty.jpg\" \nstyle=\"object-fit: contain\"></div><div style=\"font-size: 15px\" layout=\"row\" layout-align=\"center center\"><div \nstyle=\"overflow: auto;white-space: nowrap\"><div ng-click=\"vm.selectWarranty(warranty)\" \nng-class=\"vm.selectedWarrantyID == warranty.id_warranty ? []:[\'raised-box\']\" class=\"text-left p-2 m-2 simple-border\" \nstyle=\"width: 150px; height: 150px;display: inline-block\" ng-repeat=\"warranty in vm.availableWarranties\"><div \nlayout=\"column\" layout-algin=\"space-between center\" layout-fill><div style=\"font-size: 13px\" flex=\"grow\"><div \nstyle=\"font-size: 15px\" class=\"text-nowrap text-truncate mb-1 font-weight-bold\">{{::warranty.name}}</div><div \nstyle=\"font-size: 12px\" class=\"text-nowrap text-truncate\">{{::warranty.retail | currency:\'$\':0}}</div><md-divider>\n</md-divider><div>{{::warranty.duration_month}} Months</div><div>\n{{::(warranty.duration_mileage ? (warranty.duration_mileage | number) :\'Unlimited\') + \' KMs\'}}</div><div>\nHigh Tech Parts</div></div><div layout=\"row\" layout-align=\"center center\"><i style=\"font-size: 30px\" \nng-class=\"vm.selectedWarrantyID == warranty.id_warranty ? [\'icon-checkbox-marked-circle-outline\', \'text-green\']:[\'icon-circle-outline\', \'opacity-50\']\">\n</i></div></div></div></div></div><div layout=\"row\" layout-align=\"center center\" style=\"font-size: 13px\"><div \nflex=\"100\" flex-gt-sm=\"60\" layout=\"row\" layout-wrap><div flex=\"50\" ng-repeat=\"feature in vm.warrantyFeatures\"><span \nclass=\"text-secondary mr-2\">&#9679</span> <span>{{::feature.name}}<md-tooltip md-direction=\"right\" \nclass=\"multiline-tooltip\">{{::feature.description}}</md-tooltip></span></div></div></div></div>\n</ms-horizontal-stepper-step><ms-horizontal-stepper-step ng-form=\"extraOptionForm\" step-title=\"\'Extras\'\" \nstyle=\"font-size: 13px\"><div class=\"text-center font-weight-bold\" style=\"font-size: 20px\">PACKAGES:</div><div \nlayout=\"row\" layout-align=\"center center\"><div style=\"overflow: auto;white-space: nowrap\"><div \nng-click=\"package.isSelected = !package.isSelected\" ng-class=\"package.isSelected ? []:[\'raised-box\']\" \nclass=\"text-left p-2 ml-1 mr-4 my-2 simple-border\" style=\"width: 150px; height: 150px;display: inline-block\" \nng-repeat=\"package in vm.packageCardList\"><div layout=\"column\" layout-algin=\"space-between center\" layout-fill><div \nflex=\"grow\"><div style=\"font-size: 15px\" class=\"text-nowrap text-truncate mb-1 font-weight-bold\">{{package.name}}</div>\n<div style=\"font-size: 12px\" class=\"text-nowrap text-truncate\">{{package.price | currency:\'$\':2}}</div><md-divider>\n</md-divider><div class=\"text-nowrap text-truncate\" \nng-repeat=\"item in package.items | limitTo:vm.packageItemMaxDisplay\" layout=\"row\"><span class=\"mr-1 text-green\">&#x2713\n</span> {{item}}</div><div ng-if=\"package.items.length > vm.packageItemMaxDisplay\">\n{{package.items.length - vm.packageItemMaxDisplay}} more...<md-tooltip class=\"multiline-tooltip\"><div layout=\"column\">\n<div ng-repeat=\"item in package.items | limitTo: package.items.length : vm.packageItemMaxDisplay\" layout=\"row\">{{item}}\n</div></div></md-tooltip></div></div><div layout=\"row\" layout-align=\"center center\"><i style=\"font-size: 30px\" \nng-class=\"package.isSelected ? [\'icon-checkbox-marked-circle-outline\', \'text-green\']:[\'icon-circle-outline\', \'opacity-50\']\">\n</i></div></div></div></div></div><div class=\"text-center font-weight-bold mt-3\" style=\"font-size: 20px\">EXTRAS:</div>\n<div layout=\"row\" layout-align=\"center center\"><div style=\"overflow: auto;white-space: nowrap\"><div \nng-click=\"item.isSelected = !item.isSelected\" ng-class=\"item.isSelected ? []:[\'raised-box\']\" \nclass=\"text-left p-2 ml-1 mr-4 my-2 simple-border\" style=\"width: 150px; height: 150px;display: inline-block\" \nng-repeat=\"item in vm.extraCardList\"><div layout=\"column\" layout-algin=\"space-between center\" layout-fill><div \nflex=\"grow\"><div style=\"font-size: 15px\" class=\"text-nowrap text-truncate mb-1 font-weight-bold\">{{item.name}}</div>\n<div style=\"font-size: 12px\" class=\"text-nowrap text-truncate\">{{item.cost | currency:\'$\':2}}</div><md-divider>\n</md-divider></div><div layout=\"row\" layout-align=\"center center\"><i style=\"font-size: 30px\" \nng-class=\"item.isSelected ? [\'icon-checkbox-marked-circle-outline\', \'text-green\']:[\'icon-circle-outline\', \'opacity-50\']\">\n</i></div></div></div></div></div></ms-horizontal-stepper-step><ms-horizontal-stepper-step step-title=\"\'Disclosures\'\" \nhide-step=\"!vm.isSalesmanMode\" ng-form=\"disclosureForm\"><div style=\"font-size: 13px\" layout=\"row\" \nlayout-align=\"center center\"><purchase-disclosure-list flex=\"100\" flex-gt-sm=\"50\" disclosures=\"vm.disclosures\" \non-disclosure-added=\"vm.onDisclosureAdded\" on-disclosure-removed=\"vm.onDisclosureRemoved\" \nclean-new-disclouser=\"vm.cleanNewDisclouser\" is-processing-data=\"vm.isProcessingData\"></purchase-disclosure-list></div>\n</ms-horizontal-stepper-step><ms-horizontal-stepper-step ng-form=\"depositForm\" step-title=\"\'Deposit\'\"><div \nlayout=\"row\" layout-align=\"center center\"><div layout=\"column\" layout-align=\"center center\" flex=\"100\" \nng-if=\"vm.isSubmitting\" class=\"text-center\"><div ng-if=\"!vm.errorMessage\">\nFinalizing your sale, please be patient and do not refresh or close the browser during this operation.</div>\n<md-progress-circular ng-if=\"!vm.errorMessage\" class=\"mt-3\" md-mode=\"indeterminate\"></md-progress-circular><div \nng-if=\"vm.errorMessage\">Something wrong: {{vm.errorMessage}}</div></div><div layout=\"column\" flex=\"100\" \nflex-gt-sm=\"50\" ng-if=\"!vm.isSubmitting && !vm.errorMessage\"><div class=\"mb-5\" layout=\"column\" style=\"font-size: 12px\" \nng-if=\"vm.redeemedPromotions != null && vm.redeemedPromotions.length > 0\"><div>Selected Promotions</div><md-divider>\n</md-divider><div class=\"px-3 my-1\"><div layout=\"row\" layout-align=\"space-between center\" \nng-repeat=\"promotion in vm.redeemedPromotions\"><span class=\"badge badge-pill badge-danger my-1\">{{promotion.name}}\n</span> <span>{{promotion.description}}</span></div></div><md-divider></md-divider></div><md-input-container \nclass=\"info-form-item small-input-box purchase-step-payment-input-box\"><label>Pick Up Date:</label><md-datepicker \nmd-hide-icons=\"calendar\" ng-model=\"vm.deliveryDueDatePickeValue\" \nng-change=\"vm.setDeliveryDueDate(vm.deliveryDueDatePickeValue)\" name=\"deliveryDueDate\"></md-datepicker><div \nng-messages=\"depositForm.deliveryDueDate.$error\"><div ng-message=\"valid\">Invalid date.</div></div></md-input-container>\n<md-input-container class=\"input-box info-form-item small-input-box p-0\"><input type=\"text\" ng-required=\"true\" \nautocorrect=\"off\" autocapitalize=\"none\" spellcheck=\"false\" name=\"mileage\" ng-model=\"vm.saleInfo.mileage\" \nautocomplete=\"off\" placeholder=\"Mileage\" maxlength=\"10\" ng-pattern=\"/^[0-9]*$/\"><div \nng-messages=\"depositForm.mileage.$error\"><div ng-message=\"maxlength\">Input content can not be over 10 charactors</div>\n<div ng-message=\"pattern\">Only number accepted!</div><div ng-message=\"required\">this field is required!</div></div>\n</md-input-container><div layout=\"column\" style=\"font-size: 13px\"><p class=\"mb-0\">Deposit?</p><div layout=\"row\" \nclass=\"mt-2\" layout-align=\"center center\"><md-button flex class=\"m-0 purchase-step-button-group-first\" \nng-class=\"vm.depositOption == 1? [\'bg-secondary\']:[\'\']\" ng-click=\"vm.depositOption = 1; vm.deposit.amount = 1000;\">\n$1,000</md-button><md-button flex class=\"m-0 purchase-step-button-group-not-first\" \nng-class=\"vm.depositOption  == 2? [\'bg-secondary\']:[\'\']\" ng-click=\"vm.depositOption = 2; vm.deposit.amount = 2000;\">\n$2,000</md-button><md-button flex class=\"m-0 purchase-step-button-group-not-first\" \nng-class=\"vm.depositOption  == 3? [\'bg-secondary\']:[\'\']\" ng-click=\"vm.depositOption = 3; vm.deposit.amount = null\">\nOther</md-button></div><div class=\"text-red mb-2 animate-fade-in-out\" style=\"font-size: 12px\" \nng-if=\"vm.depositOption == null && depositForm.paymentMethod.$touched\">Please provide an amount.</div>\n<md-input-container class=\"pr-0 input-box info-form-item small-input-box purchase-step-payment-input-box\" \nng-if=\"vm.depositOption == 3\"><input maxlength=\"10\" autocorrect=\"off\" autocapitalize=\"none\" spellcheck=\"false\" \nname=\"depositAmount\" ng-model=\"vm.deposit.amount\" autocomplete=\"off\" placeholder=\"Deposit\" input-control \ninput-translate=\"vm.translateToDollar\" ng-required=\"true\"><div ng-messages=\"depositForm.depositAmount.$error\"><div \nng-message=\"maxlength\">Input content can not be over 50 charactors</div><div ng-message=\"required\">\nThis field is required</div></div></md-input-container><input ng-model=\"vm.depositOption\" ng-required=\"true\" \nname=\"depositOption\" style=\"visibility: hidden\"></div><md-input-container style=\"width: 100%\" \nclass=\"small-selector purchase-step-selector\"><label>Payment Method</label><md-select style=\"width: 100%\" \nname=\"paymentMethod\" ng-model=\"vm.deposit.fk_id_payment_method\" placeholder=\"Payment Method\" ng-required=\"true\">\n<md-option ng-repeat=\"payment in vm.constants.paymentMethods\" value=\"{{payment.id_payment_method}}\">{{payment.name}}\n</md-option></md-select><div ng-messages=\"depositForm.paymentMethod.$error\"><div ng-message=\"required\">\nThis field is required</div></div></md-input-container><div class=\"mb-2\" style=\"font-size: 13px\">Sale manager:</div>\n<md-autocomplete flex=\"50\" ng-required=\"true\" md-input-name=\"saleManager\" md-no-cache=\"true\" \nmd-selected-item=\"vm.currentSaleManager\" md-search-text=\"vm.searchText\" \nmd-selected-item-change=\"vm.selecteSaleManager(item)\" md-items=\"item in vm.queryUser(vm.searchText)\" \nmd-item-text=\"item.first_name + \' \' + item.last_name\" md-min-length=\"0\" placeholder=\"Search\"><md-item-template><span \nmd-highlight-text=\"vm.searchText\" md-highlight-flags=\"^i\">{{item.first_name}} {{item.last_name}}</span>\n</md-item-template><md-not-found>No states matching \"{{vm.searchText}}\" were found.</md-not-found></md-autocomplete>\n<div class=\"text-red mb-2 animate-fade-in-out\" style=\"font-size: 12px\" \nng-if=\"vm.saleInfo.sale_manager == null && depositForm.saleManager.$touched\">Please select a sale manager</div></div>\n</div><input ng-model=\"vm.submitButtonControl\" ng-required=\"true\" name=\"isProcessing\" style=\"visibility: hidden\">\n</ms-horizontal-stepper-step></form><div flex=\"100\" flex-gt-sm=\"20\" class=\"pl-3\"><sale-summary hide-eye=\"true\" \nvehicle=\"vm.vehicle\" sale-info=\"vm.saleInfo\" warranty=\"vm.saleWarranty\" sale-extras=\"vm.selectedExtras\" \nsale-packages=\"vm.selectedPackages\" plate-options=\"vm.plateOptions\" trade-in-vehicle=\"vm.tradeInVehicle\" \npromotions=\"vm.redeemedPromotions\" payments=\"vm.payments\"></sale-summary></div></div>");
$templateCache.put("app/main/vehicles/vehicle-details/deliver-status.html","<form class=\"accordion\" id=\"accordionExample\" name=\"saleInfoForms\"><div class=\"card\" \nng-repeat=\"saleInfo in vm.saleInfos\"><div class=\"card-header\" id=\"{{$index + \'heading\'}}\"><div layout=\"column\" \nlayout-gt-sm=\"row\" layout-align=\"space-between center\"><button class=\"btn btn-link\" type=\"button\" \ndata-toggle=\"collapse\" data-target=\"#{{$index + \'collapse\'}}\" aria-expanded=\"true\" \naria-controls=\"{{$index + \'collapse\'}}\"><span>Scheduled Pick Up Date: {{saleInfo.delivery_due_date}}</span> <span \nng-if=\"saleInfo.is_canceled\" class=\"badge badge-danger\">Canceled</span> <span ng-if=\"saleInfo.is_delivered\" \nclass=\"badge badge-success\">Delivered</span></button><div><a restrict \nrolescansee=\"developer company_manager sales_manager salesman accountant\" href=\"{{vm.getSaleInfoUrl(saleInfo)}}\">\nSale Date: {{::saleInfo.sale_date}}</a></div></div></div><div id=\"{{$index + \'collapse\'}}\" class=\"collapse\" \nng-class=\"$index == 0? [\'show\']:[]\" aria-labelledby=\"{{$index + \'heading\'}}\" data-parent=\"#accordionExample\"><div \nng-form=\"form{{$index}}\" style=\"font-size: 13px\"><div layout=\"column\" layout-gt-sm=\"row\" class=\"p-5\"><div flex=\"100\" \nflex-gt-sm=\"75\" layout=\"row\" layout-align=\"start center\"><md-checkbox restrict \nrolescanedit=\"developer company_manager accountant sales_manager salesman advertizing\" \nng-model=\"saleInfo.is_delivered\" class=\"mr-5\" ng-change=\"vm.onIsDeliveredChange(saleInfo)\">Is Delivered</md-checkbox>\n<md-input-container class=\"info-form-item small-input-box purchase-step-payment-input-box\"><label>Pick up date:</label>\n<md-datepicker restrict rolescanedit=\"developer company_manager accountant sales_manager salesman advertizing\" \nmd-hide-icons=\"calendar\" ng-model=\"vm.deliveryDueDatePickerValues[saleInfo.getResourceID()]\" \nng-change=\"vm.setDeliveryDueDate(saleInfo, vm.deliveryDueDatePickerValues[saleInfo.getResourceID()])\" \nname=\"deliveryDueDate\"></md-datepicker><div ng-messages=\"saleInfoForms[\'form\' + $index].deliveryDueDate.$error\"><div \nng-message=\"valid\">Invalid date.</div></div></md-input-container><div layout=\"column\"><div \nng-if=\"!saleInfo.pickup_access_sent && saleInfo.delivery_due_date\"><span>\nEmail & Text will be sent on: {{vm.pickupAppointmentReminderDate ? (vm.pickupAppointmentReminderDate | date:\'medium\') : \'Pickup date not set\'}}\n</span></div><div ng-if=\"saleInfo.pickup_access_sent && !saleInfo.pickup_appointment_time\"><span>\nNotification sent on: {{saleInfo.pickup_access_sent_time ? (saleInfo.pickup_access_sent_time | date:\'medium\') : \'Not Sent\'}}\n</span> <span><br>Delivery method: </span><span ng-if=\"saleInfo.pickup_access_sent_time_email\">Email</span> <span \nng-if=\"saleInfo.pickup_access_sent_time_sms\">Text</span> <span \nng-if=\"!saleInfo.pickup_access_sent_time_sms && !saleInfo.pickup_access_sent_time_email\">None</span></div><div \nng-if=\"saleInfo.pickup_access_sent && saleInfo.pickup_appointment_time\"><span>\nPickup Appointment Scheduled At: {{ saleInfo.pickup_appointment_time ? (saleInfo.pickup_appointment_time | date:\'medium\') : \'Not Scheduled\' }}\n</span></div></div></div></div></div><div layout=\"column\" layout-gt-sm=\"row\" class=\"p-5\" ng-if=\"!vm.showCopyPanel\"><div\n flex=\"100\" flex-gt-sm=\"50\" layout=\"row\" layout-align=\"start center\"><md-menu><md-button \nclass=\"btn-secondary mx-0 text-black\" \nng-disabled=\"vm.containUnsaveChanges() || !saleInfo.delivery_due_date || saleInfo.is_delivered\" \nng-click=\"$mdMenu.open($event)\">Schedule A PickUp</md-button><md-menu-content width=\"4\"><md-menu-item><md-button \nng-click=\"vm.createPickupAppointment(saleInfo, $index, \'email\')\">Send via Email</md-button></md-menu-item>\n<md-menu-item><md-button ng-click=\"vm.createPickupAppointment(saleInfo, $index, \'text\')\">Send via Text</md-button>\n</md-menu-item><md-menu-item><md-button ng-click=\"vm.createPickupAppointment(saleInfo, $index, \'both\')\">Send via Both\n</md-button></md-menu-item><md-menu-item><md-button ng-click=\"vm.createPickupAppointment(saleInfo, $index, \'copy\')\">\nCOPY URL</md-button></md-menu-item></md-menu-content></md-menu></div></div><div ng-if=\"vm.showCopyPanel\" \nclass=\"copy-panel p-5\" layout=\"column\" layout-align=\"start start\"><md-card flex=\"100\" flex-gt-sm=\"60\" class=\"p-3\" \nstyle=\"background:#f9f9f9; border-radius:8px; box-shadow:0 2px 4px rgba(0,0,0,0.1)\"><div layout=\"row\" \nlayout-align=\"space-between center\" flex><div flex layout=\"column\" layout-align=\"center start\"><label \nstyle=\"font-weight:600; margin-bottom:4px; color:#333\">Pick-up Link</label><input type=\"text\" \nng-model=\"vm.pendingCopyUrl\" readonly=\"readonly\" class=\"md-input\" \nstyle=\"width:100%; padding:8px 10px; border:1px solid #ccc; border-radius:4px; font-size:14px; background:#fff\"></div>\n</div><div layout=\"row\" layout-align=\"end center\" style=\"margin-top:10px\"><md-button \nclass=\"btn-secondary mx-0 text-black\" ng-click=\"vm.copyNow()\">Copy URL</md-button><md-button \nclass=\"btn-warning mx-0 text-black\" ng-click=\"vm.showCopyPanel = false\" style=\"margin-left:10px\">Close</md-button>\n</div></md-card></div><div layout=\"column\" layout-gt-sm=\"row\" class=\"p-5\" restrict \nrolescansee=\"developer company_manager accountant sales_manager salesman advertizing\"><div flex=\"100\" flex-gt-sm=\"50\">\n<div class=\"mb-2\">General Comment:</div><textarea style=\"width:100%\" rows=\"5\" ng-model=\"saleInfo.general_comments\" \nclass=\"info-form-item detail-info-form-note-input p-2\" placeholder=\"General Comment:\">\r\n							</textarea></div></div>\n<div layout=\"column\" layout-gt-sm=\"row\" class=\"p-5\"><div flex=\"100\" flex-gt-sm=\"50\"><md-checkbox class=\"mx-0\" \ndisabled=\"disabled\" ng-checked=\"vm.quotedWorkorders.length <= 0\">Mechanic</md-checkbox><div restrict \nrolescanedit=\"developer company_manager mechanic accountant sales_manager salesman advertizing service_advisor\"><div \nlayout=\"row\" ng-repeat=\"workorder in vm.quotedWorkorders\" class=\"mb-1\"><div class=\"mr-1\">&#9679</div><div><div><a \nng-href=\"{{::vm.getWorkorderUrl(workorder.id_work_order)}}\">{{workorder.invoice_number}}</a> <span \nng-if=\"workorder.fk_id_work_order_priority\">{{::vm.getWorkorderPriority(workorder.fk_id_work_order_priority)}}</span>\n</div><div class=\"pre-wrap\">{{::workorder.notes}}</div></div></div><div ng-if=\"!(vm.quotedWorkorders.length > 0)\">\nNo quoted workorder found.</div></div></div><div ng-if=\"vm.notCompletedMechanicTasks.length > 0\" flex-offset-gt-sm=\"5\">\n<div class=\"mb-4\">Incompleted Mechanic Tasks:</div><div ng-repeat=\"task in vm.notCompletedMechanicTasks\"><a \nhref=\"{{vm.getTaskUrl(task)}}\"><span class=\"badge badge-secondary\">{{::task.name}}</span></a></div></div></div><div \nlayout=\"column\" layout-gt-sm=\"row\" class=\"p-5\"><div flex=\"100\" flex-gt-sm=\"50\"><md-checkbox restrict \nrolescanedit=\"developer company_manager detailer accountant sales_manager salesman advertizing service_advisor\" \nclass=\"mx-0\" ng-model=\"saleInfo.is_detail_completed\">Detail</md-checkbox><textarea restrict \nrolescanedit=\"developer company_manager detailer accountant sales_manager salesman advertizing service_advisor\" \nstyle=\"width:100%\" rows=\"5\" ng-model=\"saleInfo.detail_comments\" class=\"info-form-item detail-info-form-note-input p-2\" \nplaceholder=\"Detail Comment:\">\r\n							</textarea></div><div ng-if=\"vm.notCompletedDetailTasks.length > 0\" \nflex-offset-gt-sm=\"5\"><div class=\"mb-4\">Incompleted Detail Tasks:</div><div \nng-repeat=\"task in vm.notCompletedDetailTasks\"><a href=\"{{vm.getTaskUrl(task)}}\"><span class=\"badge badge-secondary\">\n{{::task.name}}</span></a></div></div></div><div layout=\"column\" layout-gt-sm=\"row\" class=\"p-5\" restrict \nrolescansee=\"developer company_manager accountant sales_manager salesman advertizing\"><div flex=\"100\" flex-gt-sm=\"50\">\n<md-checkbox class=\"mx-0\" ng-model=\"saleInfo.is_licensing_completed\">Licensing</md-checkbox><textarea \nstyle=\"width:100%\" rows=\"5\" ng-model=\"saleInfo.licensing_comments\" \nclass=\"info-form-item detail-info-form-note-input p-2\" placeholder=\"Licensing Comment:\">\r\n							</textarea></div>\n</div><div layout=\"row\" layout-align=\"center center\"><md-button class=\"btn-secondary\" \nng-click=\"vm.saveChanges(saleInfo, $index)\">SAVE</md-button></div></div></div></form>");
$templateCache.put("app/main/vehicles/vehicle-details/vehicle-customer-list.html","<md-divider></md-divider><div class=\"my-1\" ng-repeat=\"(customerID, item) in vm.customerList\"><div layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"text-nowrap text-truncate\"><a \nng-href=\"{{vm.getCustomerPageUrl(customerID)}}\">{{item.customerInfo.first_name + \' \' + item.customerInfo.last_name}}\n</a></div><button ng-if=\"item.serviceMapID && (!item.saleInfos || item.saleInfos.length <= 0)\" \nng-disabled=\"vm.disableDelete\" \nng-click=\"vm.onDeleteClick(item.serviceMapID, customerID, item.customerInfo.first_name + \' \' + item.customerInfo.last_name)\">\n<i class=\"icon-delete-forever\" ng-class=\"vm.disableDelete ? [\'text-grey\'] : [\'text-red\']\"></i></button></div><div \nclass=\"ml-10\"><div ng-repeat=\"saleInfo in item.saleInfos\">&#9679 <a \nng-href=\"{{vm.getSaleInfoPageUrl(saleInfo.id_sale_info)}}\">Purchased on: {{saleInfo.sale_date | date:\'fullDate\'}}</a>\n</div></div><div class=\"ml-10\" layout=\"row\" layout-align=\"space-between center\"><a>&#9679 View Invoices From::</a><div \nng-if=\"!vm.startDateList[item.customerInfo.id_customer]\">\n{{(item.customerInfo.work_order_filter_start | date:\'MM/dd/yyyy\') || \" \"}}</div><div \nng-if=\"vm.startDateList[item.customerInfo.id_customer]\"><md-datepicker \nng-disabled=\"vm.isProcessingData || vm.disabledInputs.quotedDate\" md-hide-icons=\"calendar\" \nng-model=\"vm.workOrderFilterStartDatePicker\" name=\"quoteDate\" disable></md-datepicker></div><div><button \nng-if=\"!vm.startDateList[item.customerInfo.id_customer]\" ng-click=\"vm.editStartDate(item.customerInfo, customerID)\"><i \nclass=\"icon-pen text-secondary ng-scope\"></i></button> <button ng-if=\"vm.startDateList[item.customerInfo.id_customer]\" \nng-click=\"vm.saveStartDate(item.customerInfo, customerID)\"><i class=\"icon-check-all text-secondary ng-scope\"></i>\n</button> <button ng-click=\"vm.deleteCustomerTimeRange(item.customerInfo, 0, customerID)\"><i \nclass=\"icon-delete-forever\" ng-class=\"[\'text-red\']\"></i></button></div></div><div class=\"ml-10\" layout=\"row\" \nlayout-align=\"space-between center\"><a>&#9679 View Invoices To:</a><div \nng-if=\"!vm.endDateList[item.customerInfo.id_customer]\">\n{{(item.customerInfo.work_order_filter_end | date:\'MM/dd/yyyy\') || \" \"}}</div><div \nng-if=\"vm.endDateList[item.customerInfo.id_customer]\"><md-datepicker \nng-disabled=\"vm.isProcessingData || vm.disabledInputs.quotedDate\" md-hide-icons=\"calendar\" \nng-model=\"vm.workOrderFilterEndDatePicker\" name=\"quoteDate\" disable></md-datepicker></div><div><button \nng-if=\"!vm.endDateList[item.customerInfo.id_customer]\" ng-click=\"vm.editEndDate(item.customerInfo, customerID)\"><i \nclass=\"icon-pen text-secondary ng-scope\" title=\"Edit\"></i></button> <button \nng-if=\"vm.endDateList[item.customerInfo.id_customer]\" ng-click=\"vm.saveEndDate(item.customerInfo, customerID)\"><i \nclass=\"icon-check-all text-secondary ng-scope\" title=\"Check\"></i></button> <button \nng-click=\"vm.deleteCustomerTimeRange(item.customerInfo, 1, customerID)\"><i class=\"icon-delete-forever\" \nng-class=\"[\'text-red\']\" title=\"Delete\"></i></button></div></div></div><div class=\"my-1\" ng-if=\"!vm.hasCustomer()\">\nNo customer found</div><md-divider></md-divider>");
$templateCache.put("app/main/vehicles/vehicle-details/vehicle-details-customer.html","<div layout=\"row\" layout-align=\"center center\"><md-progress-circular ng-if=\"vm.fetchingCustomersData\" md-diameter=\"20\">\n</md-progress-circular></div><div layout=\"row\" ng-if=\"!vm.fetchingCustomersData\"><div flex=\"100\" flex-gt-sm=\"50\"><div \nclass=\"text-info mb-2\">Assigned Customers:</div><vehicle-customer-list disable-delete=\"vm.isDeletingCustomer\" \non-delete-click=\"vm.deleteCustomer\" customer-list=\"vm.customerList\" vehicle-id=\"vm.vehicleID\" sale-info=\"vm.saleInfos\" \nservice-map=\"vm.serviceMap\" fetch-customer-data=\"vm.fetchCustomerData\"></vehicle-customer-list><div \nng-if=\"vm.canAddCustomer\"><div class=\"mt-5 text-info\">Search Customer:</div><div layout=\"row\"><md-input-container \nflex=\"33\" class=\"input-box small-input-box\"><input type=\"text\" autocorrect=\"off\" autocapitalize=\"none\" \nspellcheck=\"false\" ng-model=\"vm.firstNameFilter\" autocomplete=\"off\" placeholder=\"First Name\" maxlength=\"50\" \ninput-control input-translate=\"vm.capitalizeTranslator\" ng-model-options=\"{ debounce: 700 }\" \nng-change=\"vm.queryCustomer()\"></md-input-container><md-input-container flex=\"33\" class=\"input-box small-input-box\">\n<input type=\"text\" autocorrect=\"off\" autocapitalize=\"none\" spellcheck=\"false\" ng-model=\"vm.lastNameFilter\" \nautocomplete=\"off\" placeholder=\"Last Name\" maxlength=\"50\" input-control input-translate=\"vm.capitalizeTranslator\" \nng-model-options=\"{ debounce: 700 }\" ng-change=\"vm.queryCustomer()\"></md-input-container><md-input-container flex=\"33\" \nclass=\"input-box small-input-box\"><input type=\"text\" autocorrect=\"off\" autocapitalize=\"none\" spellcheck=\"false\" \nng-model=\"vm.phoneNumberFilter\" autocomplete=\"off\" placeholder=\"Phone\" maxlength=\"20\" input-control \ninput-translate=\"vm.phoneNumberTranslator\" ng-model-options=\"{ debounce: 700 }\" ng-change=\"vm.queryCustomer()\">\n</md-input-container></div><md-progress-linear ng-disabled=\"!vm.isQueryingCustomer\"></md-progress-linear><div \nclass=\"card mb-2\" ng-if=\"vm.firstNameFilter || vm.lastNameFilter || vm.phoneNumberFilter\"><div \nclass=\"card-header py-1 bg-grey\"><div class=\"font-weight-bold\">Customers</div></div><div class=\"card-body\"><div \nclass=\"my-1\" ng-repeat=\"customer in vm.matchedCustomers\" layout=\"row\" layout-align=\"space-between center\"><a \nng-href=\"{{vm.getCustomerPageUrl(customer.id_customer)}}\">{{customer.first_name}} {{customer.last_name}}</a><div \nclass=\"text-secondary\" ng-click=\"vm.selectCustomer(customer)\" ng-if=\"!vm.customerList[customer.id_customer]\">Select\n</div><div class=\"text-green\" ng-if=\"vm.customerList[customer.id_customer]\">Added</div></div></div></div></div>\n<md-divider></md-divider><div flex=\"100\" flex-gt-sm=\"50\"><div class=\"mt-5 text-info\">Work Order Time Range:</div><div \nlayout=\"row\"><md-input-container flex=\"50\" class=\"input-box small-input-box div-no-bottom-margin\"><label>Start</label>\n<md-datepicker ng-disabled=\"vm.isProcessingData || vm.disabledInputs.quotedDate\" md-hide-icons=\"calendar\" \nng-model=\"vm.workOrderDateRangeStart\" name=\"quoteDate\" disable></md-datepicker><div \nng-messages=\"workOrderInfoForm.quoteDate.$error\"><div ng-message=\"valid\">Invalid date.</div></div></md-input-container>\n<md-input-container flex=\"50\" class=\"input-box small-input-box div-no-bottom-margin\"><label>End</label><md-datepicker \nng-disabled=\"vm.isProcessingData || vm.disabledInputs.quotedDate\" md-hide-icons=\"calendar\" \nng-model=\"vm.workOrderDateRangeEnd\" name=\"quoteDate\"></md-datepicker><div \nng-messages=\"workOrderInfoForm.quoteDate.$error\"><div ng-message=\"valid\">Invalid date.</div></div></md-input-container>\n</div><div layout=\"column\" class=\"div-top-padding\"><md-input-container flex=\"60\" \nclass=\"input-box small-input-box div-no-bottom-margin\"><label>Customer Selected</label><input type=\"text\" \nautocorrect=\"off\" autocapitalize=\"none\" spellcheck=\"false\" ng-model=\"vm.customerSelectedName\" autocomplete=\"off\" \nplaceholder=\"Customer Name\" maxlength=\"50\" input-control input-translate=\"vm.capitalizeTranslator\" disabled=\"disabled\">\n</md-input-container></div><div class=\"div-bottom-padding\"><md-button flex class=\"mx-0 btn-sm btn-secondary\" \nng-disabled=\"vm.isAdding\" ng-click=\"vm.onAddCustomerClick()\">Add Customer</md-button></div></div><md-divider>\n</md-divider></div></div><style>\n.div-top-padding {\r\n  	padding-top: 0px;\r\n}\r\n\r\n.div-no-bottom-margin {\r\n	margin-bottom: 0px;\r\n}\r\n\r\n.div-bottom-padding {\r\n  	padding-bottom: 20px;\r\n}\n</style>");
$templateCache.put("app/main/vehicles/vehicle-details/vehicle-details-delivery.html","<deliver-staus workorder-priorities=\"vm.workorderPriorities\" sale-infos=\"vm.saleInfos\" vehicle-id=\"vm.vehicleID\">\n</deliver-staus>");
$templateCache.put("app/main/vehicles/vehicle-details/vehicle-details-general.html","<div layout=\"row\" layout-wrap class=\"bg-transparent\"><div flex=\"100\" flex-gt-sm=\"33\" class=\"mb-5\"><p class=\"text-info\">\n<small>BASICS</small></p><div class=\"row mb-5\" ng-if=\"vm.vehicle.body_type\"><div \nclass=\"col-6 col-sm-6 col-md-auto col-lg-auto col-xl-auto pr-2\">Body Type :</div><div \nclass=\"col-6 col-sm-6 col-md-auto col-lg-auto col-xl-auto pl-0 uppercase\"><strong class=\"limit-text\">\n{{::vm.vehicle.body_type}}</strong></div></div><div class=\"row mb-5\" ng-if=\"vm.vehicle.interior_color\" style=\"\"><div \nclass=\"col-6 col-sm-6 col-md-auto col-lg-auto col-xl-auto pr-2\">Interior :</div><div \nclass=\"col-6 col-sm-6 col-md-auto col-lg-auto col-xl-auto pl-0 uppercase\"><strong>{{::vm.vehicle.interior_color}}\n</strong></div></div><div class=\"row mb-5\" ng-if=\"vm.vehicle.exterior_color\"><div \nclass=\"col-6 col-sm-6 col-md-auto col-lg-auto col-xl-auto pr-2\">Exterior :</div><div \nclass=\"col-6 col-sm-6 col-md-auto col-lg-auto col-xl-auto pl-0 uppercase\"><strong>{{::vm.vehicle.exterior_color}}\n</strong></div></div><div class=\"row mb-5\" ng-if=\"vm.vehicle.stock_number\"><div \nclass=\"col-6 col-sm-6 col-md-auto col-lg-auto col-xl-auto pr-2\">Stock Number :</div><div \nclass=\"col-6 col-sm-6 col-md-auto col-lg-auto col-xl-auto pl-0 uppercase\"><strong>{{::vm.vehicle.stock_number}}\n</strong></div></div><div class=\"row mb-5\" ng-if=\"vm.vehicle.stock_number\"><div \nclass=\"col-6 col-sm-6 col-md-auto col-lg-auto col-xl-auto pr-2\">Vin :</div><div \nclass=\"col-6 col-sm-6 col-md-auto col-lg-auto col-xl-auto pl-0 uppercase\"><strong>{{::vm.vehicle.vin}}</strong></div>\n</div></div><div flex=\"100\" flex-gt-sm=\"33\" class=\"mb-5\"><p class=\"text-info\"><small>PERFORMANCE</small></p><div \nclass=\"row mb-5\" ng-if=\"vm.vehicle.engine\"><div class=\"col-6 col-sm-6 col-md-auto col-lg-auto col-xl-auto pr-2\">\nEngine :</div><div class=\"col-6 col-sm-6 col-md-auto col-lg-auto col-xl-auto pl-0 uppercase\"><strong>\n{{::vm.vehicle.engine}}</strong></div></div><div class=\"row mb-5\" ng-if=\"vm.vehicle.transmission_type\"><div \nclass=\"col-6 col-sm-6 col-md-auto col-lg-auto col-xl-auto pr-2\">Transmission :</div><div \nclass=\"col-6 col-sm-6 col-md-auto col-lg-auto col-xl-auto pl-0 uppercase\"><strong>{{::vm.vehicle.transmission_type}}\n</strong></div></div><div class=\"row mb-5\" ng-if=\"vm.vehicle.drive_train\"><div \nclass=\"col-6 col-sm-6 col-md-auto col-lg-auto col-xl-auto pr-2\">Drive Type :</div><div \nclass=\"col-6 col-sm-6 col-md-auto col-lg-auto col-xl-auto pl-0 uppercase\"><strong>{{::vm.vehicle.drive_train}}</strong>\n</div></div><div class=\"row mb-5\" ng-if=\"vm.vehicle.fuel_type\"><div \nclass=\"col-6 col-sm-6 col-md-auto col-lg-auto col-xl-auto pr-2\">Fuel Type :</div><div \nclass=\"col-6 col-sm-6 col-md-auto col-lg-auto col-xl-auto pl-0 uppercase\"><strong>{{::vm.vehicle.fuel_type}}</strong>\n</div></div><div class=\"row mb-5\" ng-if=\"vm.vehicle.highway_fuel_efficiency\"><div \nclass=\"col-6 col-sm-6 col-md-auto col-lg-auto col-xl-auto pr-2\">HWY Fuel Efficiency :</div><div \nclass=\"col-6 col-sm-6 col-md-auto col-lg-auto col-xl-auto pl-0 uppercase\"><strong>\n{{::vm.vehicle.highway_fuel_efficiency}} L/100KM</strong></div></div><div class=\"row mb-5\" \nng-if=\"vm.vehicle.city_fuel_efficiency\"><div class=\"col-6 col-sm-6 col-md-auto col-lg-auto col-xl-auto pr-2\">\nCity Fuel Efficiency :</div><div class=\"col-6 col-sm-6 col-md-auto col-lg-auto col-xl-auto pl-0 uppercase\"><strong>\n{{::vm.vehicle.city_fuel_efficiency}} L/100KM</strong></div></div></div><div flex=\"100\" flex-gt-sm=\"33\" class=\"mb-5\"><p\n class=\"text-info\"><small>AUTO HISTORY</small></p><div class=\"table-responsive\"><table class=\"table\"><tbody><tr \nng-if=\"vm.vehicle.car_fax || vm.vehicle.car_proof\"><img restrict rolescansee=\"login\" \nng-if=\"vm.vehicle.car_proof !=null\" ng-click=\"vm.openUrlInNewTab(vm.vehicle.car_proof)\" class=\"mr-5\" \nstyle=\"max-width: 100px\" src=\"../../assets/images/carproof-new-logo-white.png\"><img restrict rolescansee=\"login\" \nng-if=\"vm.vehicle.car_fax !=null\" ng-click=\"vm.openUrlInNewTab(vm.vehicle.car_fax)\" style=\"max-width: 130px\" \nsrc=\"../../assets/images/carfax-logo-small.jpg\"></tr><tr><th scope=\"row\" class=\"align-middle px-0 py-0\"></th><td \nclass=\"align-middle pt-0\" style=\"width: 90%\"></td></tr><tr><th scope=\"row\" class=\"align-middle px-0 py-0\" \nstyle=\"width: 10%\"><md-icon class=\"icon-shield-half-full\"></md-icon></th><td class=\"align-middle py-0\" \nstyle=\"width: 90%\"><strong>Eligible for RogerCare</strong></td></tr><tr><th scope=\"row\" class=\"align-middle px-0 py-0\">\n</th><td class=\"align-middle pt-0\" style=\"width: 90%\">\nWe proudly offer RogersCare, which provides additional mechanical coverage.</td></tr></tbody></table></div></div><div \nflex=\"100\" class=\"mb-5\" ng-if=\"vm.vehicle.comments\"><p class=\"text-info\"><small>COMMENTS</small></p><div class=\"mb-5\" \nng-if=\"vm.vehicle.comments\" ng-bind-html=\"vm.vehicle.comments\"></div></div></div><md-divider class=\"mb-5\"></md-divider>\n<h5>Features</h5><p class=\"text-info mt-7\"><small>GENERAL</small></p><div layout=\"row\" layout-wrap><div flex=\"100\" \nflex-gt-sm=\"33\" class=\"\" flex-gt-md=\"25\" ng-if=\"vm.vehicle.doors\">Doors : {{::vm.vehicle.doors}}</div><div flex=\"100\" \nflex-gt-sm=\"33\" class=\"\" flex-gt-md=\"25\" ng-if=\"vm.vehicle.standard_seating\">\nStandard Seating: {{::vm.vehicle.standard_seating}}</div><div flex=\"100\" flex-gt-sm=\"33\" class=\"\" flex-gt-md=\"25\" \nng-if=\"vm.vehicle.Optional_seating\">Optional Seating : {{::vm.vehicle.Optional_seating}}</div><div flex=\"100\" \nflex-gt-sm=\"33\" class=\"\" flex-gt-md=\"25\" ng-if=\"vm.vehicle.engine_cylinders\">\nEngine Cylinders : {{::vm.vehicle.engine_cylinders}}</div><div flex=\"100\" flex-gt-sm=\"33\" class=\"\" flex-gt-md=\"25\" \nng-if=\"vm.vehicle.engine_size\">Engine Size: {{::vm.vehicle.engine_size}}</div><div flex=\"100\" flex-gt-sm=\"33\" class=\"\" \nflex-gt-md=\"25\" ng-if=\"vm.vehicle.transmission_gears\">Tansmission Gears : {{::vm.vehicle.transmission_gears}}</div><div\n flex=\"100\" flex-gt-sm=\"33\" class=\"\" flex-gt-md=\"25\" ng-if=\"vm.vehicle.fuel_capacity\">\nFuel Capacity : {{::vm.vehicle.fuel_capacity}} L</div></div><p class=\"text-info mt-7\"><small>DIMENTSIONS</small></p>\n<div layout=\"row\" layout-wrap><div flex=\"100\" flex-gt-sm=\"33\" class=\"\" flex-gt-md=\"25\" \nng-if=\"vm.vehicle.overall_height\">Overall Height : {{::vm.vehicle.overall_height | number:0}} MM</div><div flex=\"100\" \nflex-gt-sm=\"33\" class=\"\" flex-gt-md=\"25\" ng-if=\"vm.vehicle.overall_length\">\nOverall Lenght: {{::vm.vehicle.overall_length | number:0}} MM</div><div flex=\"100\" flex-gt-sm=\"33\" class=\"\" \nflex-gt-md=\"25\" ng-if=\"vm.vehicle.overall_width\">Overall Width : {{::vm.vehicle.overall_width | number:0}} MM</div><div\n flex=\"100\" flex-gt-sm=\"33\" class=\"\" flex-gt-md=\"25\" ng-if=\"vm.vehicle.gross_weight\">\nGross Weight : {{::vm.vehicle.gross_weight | number:0}} KG</div><div flex=\"100\" flex-gt-sm=\"33\" class=\"\" \nflex-gt-md=\"25\" ng-if=\"vm.vehicle.curb_weight\">Curb Weight : {{::vm.vehicle.curb_weight | number:0}} KG</div></div><div\n ng-if=\"vm.showMoreFeature\"><div ng-repeat=\"(category, featureList) in vm.vehicleFeatures\"><p class=\"text-info mt-7\">\n<small>{{::category}}</small></p><div layout=\"row\" layout-wrap><div flex=\"100\" flex-gt-sm=\"33\" class=\"\" \nflex-gt-md=\"25\" ng-repeat=\"feature in featureList\">{{::feature.name}}<span ng-if=\"feature.value\">: {{::feature.value}}\n</span></div></div></div></div><a ng-if=\"vm.hasMoreFeatures()\" style=\"font-size: 13px\" href=\"\" \nng-click=\"vm.showMoreFeature = !vm.showMoreFeature\">{{vm.showMoreFeature? \"Hide\":\"More\"}} </a>");
$templateCache.put("app/main/vehicles/vehicle-details/vehicle-details-other.html","<div ng-if=\"vm.canSeeDisclosure\" class=\"mb-2\"><div class=\"text-info\">DISCLOSURES:</div><div \nng-repeat=\"disclosure in vm.disclosures\" class=\"mt-2\" layout=\"row\" layout-align=\"start center\"><div class=\"mr-2\">&#9679\n</div><div class=\"mr-2\">{{disclosure.description}}</div><div class=\"badge badge-secondary\">\n{{disclosure.amount | currency:\'$\':2}}</div></div><div ng-if=\"!(vm.disclosures.length > 0)\">No disclosure found.</div>\n</div><div layout=\"row\" layout-align=\"start center\"><div class=\"mr-2 text-info\">LOCATION:</div><md-input-container>\n<md-select ng-change=\"vm.updateVehicleLocation()\" name=\"location\" ng-model=\"vm.vehicle.fk_id_location\" \nplaceholder=\"Location\"><md-option ng-repeat=\"location in vm.locations | orderBy:\'name\'\" \nng-value=\"{{::location.id_location}}\">{{::location.name}}</md-option></md-select></md-input-container></div><div \nlayout=\"row\" layout-align=\"start center\" class=\"mb-3\"><div class=\"mr-2 text-info\" style=\"font-size: 18px\">\nTest Drive History:</div></div><div layout=\"row\" layout-align=\"start center\"><div layout=\"column\" layout-wrap \nstyle=\"width: 100%\"><div ng-repeat=\"testDrive in vm.testDriveVehicleHistory\" flex=\"100\" flex-gt-sm=\"50\" \nstyle=\"padding: 10px\"><div class=\"card my-3\" \nstyle=\"padding: 16px; box-shadow: 0 2px 5px rgba(0,0,0,0.1); border-radius: 8px\"><a \nstyle=\"text-decoration: none; color: inherit\"><div layout=\"column\" layout-align=\"start start\"><div \nstyle=\"font-weight: bold; font-size: 16px; margin-bottom: 4px\">\n{{testDrive.vehicle.year}} {{testDrive.vehicle.make}} {{testDrive.vehicle.model}}</div><div \nstyle=\"color: #666; margin-bottom: 4px\">{{testDrive.date | date:\'medium\'}}</div><div ng-if=\"testDrive.userName\" \nstyle=\"color: #999\">Added by {{testDrive.userName}}</div><div ng-if=\"testDrive.fk_id_customer\"><a \nng-href=\"{{ vm.getCustomerProfileUrl(testDrive.fk_id_customer) }}\" target=\"_blank\" style=\"text-decoration: underline\">\n{{testDrive.customerName}}</a></div></div></a></div></div></div></div>");
$templateCache.put("app/main/vehicles/vehicle-details/vehicle-details-purchase.html","<purchase-steps is-salesman-mode=\"vm.isSalesmanMode\" vehicle=\"vm.vehicle\" constants=\"vm.constants\" \ndisclosures=\"vm.disclosures\" latest-purchase-info=\"vm.latestPurchaseInfo\"></purchase-steps>");
$templateCache.put("app/main/vehicles/vehicle-details/vehicle-details-safety.html","<div ng-repeat=\"safety in vm.safeties\" layout=\"row\" layout-align=\"start center\" style=\"height: 30px\"><div class=\"mr-2\">\n&#9679</div><a href=\"{{::vm.getSafetyUrl(safety)}}\">\n{{::safety.inspection_date? safety.inspection_date:\"Unknown Date\"}} </a><span ng-if=\"safety.is_pass != null\" \nclass=\"badge m-2\" ng-class=\"safety.is_pass? [\'badge-success\']:[\'badge-danger\']\">\n{{::safety.is_pass == true? \"Pass\":\"Fail\"}}</span></div><div ng-if=\"!(vm.safeties.length > 0)\">No safety found</div>\n<div layout=\"row\" layout-align=\"center center\" ng-if=\"vm.canAddSafety\"><md-button class=\"md-icon-button\"><md-icon \nclass=\"icon-plus-circle text-green\" ng-click=\"vm.createSafety()\"></md-icon></md-button></div>");
$templateCache.put("app/main/vehicles/vehicle-details/vehicle-details-tasks.html","<tasks-table on-filter-change=\"vm.onTaskFilterChange\" constants=\"vm.constants\" filters=\"vm.taskFilters\" \nuser-options=\"vm.userOptions\"></tasks-table><div layout=\"row\" layout-align=\"center center\" ng-if=\"vm.canAddTasks\">\n<md-button class=\"md-icon-button\"><md-icon class=\"icon-plus-circle text-green\" ng-click=\"vm.createNewTask()\"></md-icon>\n</md-button></div>");
$templateCache.put("app/main/vehicles/vehicle-details/vehicle-details-workorder.html","<div class=\"content-padding-half\"><div class=\"content-padding-half\"><div layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"font-weight-bold\">Work Order Comments</div><div \nng-if=\"vm.canEditComment\"><div class=\"text-secondary\" ng-if=\"!vm.showTextarea\" \nng-click=\"vm.showTextarea = !vm.showTextarea\">Edit</div><div class=\"text-secondary\" ng-if=\"vm.showTextarea\" \nng-click=\"vm.saveComment()\">Save</div></div></div><md-divider class=\"my-1\"></md-divider><div><div \nng-if=\"!vm.showTextarea\"><div class=\"text-pre-wrap\">{{vm.vehicle.work_order_comments}}</div><div \nng-if=\"!vm.vehicle.work_order_comments\">No Comments</div></div><div layout=\"row\" ng-if=\"vm.showTextarea\" \nclass=\"bg-blue\"><textarea flex=\"100\" rows=\"7\" ng-model=\"vm.workorderComment\">		\r\n				</textarea></div></div></div><div \nlayout=\"row\" layout-wrap><div flex=\"100\" flex-gt-sm=\"50\" class=\"content-padding-half\"><div class=\"font-weight-bold\">\nPackages:</div><div class=\"py-1\" ng-if=\"vm.vehicle.is_sold\"><div ng-repeat=\"salePackage in vm.salePackages\">\n<md-divider></md-divider>{{salePackage.name}}<div class=\"pl-5 text-grey\"><div \nng-repeat=\"item in vm.packageItemsMap[salePackage.id_sale_package]\"><span>\n{{item.name}}({{item.quantity}}/{{item.origin_quantity}})</span></div></div></div></div><div class=\"py-1\"><div \nng-repeat=\"workorderPackage in vm.availableWorkOrderItems\"><md-divider></md-divider>\n{{workorderPackage.packageData.name}}<div class=\"pl-5 text-grey\"><div \nng-repeat=\"item in workorderPackage.packageItems\"><span>{{item.name}}({{item.quantity}}/{{item.origin_quantity}})\n</span></div></div></div></div><md-divider></md-divider></div><div flex=\"100\" flex-gt-sm=\"50\" \nclass=\"content-padding-half\"><div class=\"font-weight-bold\">Warranties:</div><md-divider class=\"mb-1\"><div \nng-if=\"vm.warranty\"><div class=\"my-2\">Name: {{::vm.warranty.name}}</div><div class=\"my-2\">\nDescription: {{::vm.warranty.description}}</div><div class=\"my-2\">\nCovered Mileage: {{::vm.totalWarrantyCoveredMileage | number:0}} KM</div><div class=\"my-2\">\nExpriy Date: {{::vm.warrantyExpiryDate}}</div></div><md-divider class=\"mb-1\"><div \nng-if=\"vm.completedWorkOrderWarranty\" ng-repeat=\"workorwarranty in vm.completedWorkOrderWarranty\"><div class=\"my-2\">\nName: {{::workorwarranty.name}}</div><div class=\"my-2\">Max Claim: {{::workorwarranty.max_claim}}</div><div \nclass=\"my-2\">Current Milage: {{::workorwarranty.mileage}} KM</div><div class=\"my-2\">\nCovered Milage: {{workorwarranty.duration_mileage}} KM</div><div class=\"my-2\">\nCovered Milage Total: {{vm.getCoveredMile(workorwarranty.duration_mileage, workorwarranty.mileage)}} KM</div><div \nclass=\"my-2\">Description: {{::workorwarranty.description}}</div><div class=\"my-2\">\nCovered Months: {{::workorwarranty.duration_month | number:0}}</div><div class=\"my-2\">\nExpriy Date: {{::vm.getExpiryDate(workorwarranty.duration_month)}}</div><md-divider class=\"mt-1\"></md-divider></div>\n<div ng-if=\"!vm.warranty && !vm.completedWorkOrderWarranty\" class=\"my-2\">No warranty found.</div></md-divider>\n</md-divider></div></div><div layout=\"row\" layout-wrap></div><div class=\"content-padding-half\"><md-content>\n<work-order-summary-list hidden-columns=\"vm.hiddenColumns\" workorder-priorities=\"vm.constants.workOrderPriorities\" \nwork-order-status=\"vm.constants.workOrderStatus\" work-order-list=\"vm.workOrderList\"></work-order-summary-list>\n</md-content></div><div layout=\"row\" layout-align=\"center center\" ng-if=\"vm.canAddWorkorder\"><md-button \nclass=\"md-icon-button\" ng-disabled=\"vm.isCreatingWorkOrder\" ng-click=\"vm.createNewWorkOrder()\"><md-icon \nclass=\"icon-plus-circle text-green\"></md-icon></md-button></div></div>");
$templateCache.put("app/main/vehicles/vehicle-details/vehicle-details.html","<div><vehicle-image-gallery number-in-large=\"3\" number-in-medium=\"2\" number-in-small=\"1\" \nvehicle-images=\"vm.vehicleImages\" small-vehicle-images=\"vm.smallVehicleImages\"></vehicle-image-gallery><div \nclass=\"sticky\"><div class=\"bg-white p-3\" layout=\"row\" layout-align=\"center center\"><div flex=\"grow\" \nclass=\"content-max-width\" layout=\"row\" layout-align=\"space-between center\" layout-wrap><div><h5><span>\n{{::vm.vehicle.getYearMakeModel()}}</span> <span \nng-if=\"vm.getLocationByID(vm.vehicle.fk_id_location).is_default_location == false\" class=\"ml-2 text-red\" \nrolescansee=\"login\">({{vm.getLocationByID(vm.vehicle.fk_id_location).name}})</span></h5><div><span class=\"mr-3\">\n{{::vm.vehicle.trim}} </span><strong ng-if=\"vm.vehicle.mileage\">{{::vm.vehicle.mileage | number:0}} KM</strong></div>\n</div><div layout=\"row\" layout-align=\"space-between center\"><div><h5 ng-if=\"vm.vehicle.advertise_price != null\" \nclass=\"text-nowrap p-0 my-0 mr-3 font-weight-bold\">$ {{::vm.vehicle.advertise_price | number:0}}</h5></div><button \ntype=\"button\" class=\"btn btn-warning ml-0 mr-3\" ng-if=\"vm.canSaleVehicle && vm.isVehicleAvailable\" \nng-click=\"vm.onPurchaseButtonClick()\" style=\"width: 160px\">{{vm.isPurchasingVehicle()? \'Browse Details\':\'Purchase\'}}\n</button> <button type=\"button\" class=\"btn btn-outline-secondary mx-0\" ng-if=\"vm.canEditVehicle\" \nng-click=\"vm.goToEditVehicle()\">edit</button></div></div></div><div layout=\"row\" layout-align=\"center center\" \nclass=\"bg-default px-3\" ng-if=\"!vm.isPurchasingVehicle()\"><div class=\"content-max-width\" flex=\"grow\"><custom-nav-bar \ncurrent-state=\"vm.currentState\" nav-items=\"vm.navItem\" class=\"content-max-width\"></custom-nav-bar><md-divider>\n</md-divider></div></div></div><div layout=\"row\" layout-align=\"center center\" class=\"p-3\"><div \nclass=\"content-max-width\" flex=\"grow\" style=\"overflow-x: scroll\"><div ui-view=\"childPage\"></div></div></div></div>");
$templateCache.put("app/main/vehicles/vehicle-details/vehicle-image-gallery.html","<style>\n.video-container {\r\n    width: 100%;\r\n    height: 400px; \r\n    overflow: hidden;\r\n    display: flex;\r\n    justify-content : center;\r\n    align-items: center;\r\n}\r\n\r\n.video-container video {\r\n    width: 100%;\r\n    height: 100%;\r\n    object-fit: contain;\r\n}\n</style><div class=\"px-0\" style=\"position: relative\"><div class=\"video-container\" ng-if=\"!vm.isPlaying\"><video \nautoplay=\"true\" playsinline muted=\"true\" class=\"content fill-parent\" id=\"initialVideo\" ng-init=\"vm.autoPlayVideo()\">\n<source ng-src=\"{{vm.slideShowList.slice(-1)[0].url}}\" type=\"video/mp4\"></video></div><slick settings=\"vm.slickConfig\" \nng-if=\"vm.isPlaying\"><div ng-repeat=\"image in vm.slideShowList\" class=\"mx-0 px-0\"><div class=\"box sixteen-nine\"><img \nng-if=\"!image.isPlaceHolder && image.file_type.includes(\'image\')\" ng-src=\"{{image.url}}\" style=\"object-fit: cover\" \nng-click class=\"content fill-parent\" light-gallery imagesource=\"{{vm.galleryList}}\" index=\"{{$index}}\"> <img \nng-if=\"image.isPlaceHolder && image.file_type.includes(\'image\')\" ng-src=\"{{image.url}}\" style=\"object-fit: cover\" \nng-click class=\"content fill-parent\"><video controls ng-if=\"image.file_type.includes(\'video\')\" \nng-init=\"vm.initializeVideo($first, $index)\" style=\"object-fit: cover\" class=\"content fill-parent\" \nid=\"video-{{$index}}\"><source ng-src=\"{{vm.slideShowList.slice(-1)[0].url}}\" type=\"video/mp4\"></video></div></div>\n</slick><div layout=\"row\" layout-align=\"center center\" style=\"position: absolute; bottom: 5px; width: 100%\"><div \nstyle=\"z-index: 9999\"><md-button ng-hide=\"!vm.isPlaying\" class=\"md-icon-button\" \nng-click=\"vm.slickConfig.method.slickPrev()\"><md-icon class=\"icon-skip-backward text-black\"></md-icon></md-button>\n<md-button id=\"playPauseButton\" class=\"md-icon-button\" ng-click=\"vm.slickConfig.method.slickPlay(); vm.pauseAndPlay()\">\n<md-icon class=\"\" ng-class=\"vm.isPlaying ? [\'icon-play-circle-outline text-black\'] : [ \'icon-pause-circle-outline\' ]\">\n</md-icon></md-button><md-button ng-hide=\"!vm.isPlaying\" class=\"md-icon-button\" \nng-click=\"vm.slickConfig.method.slickNext()\"><md-icon class=\"icon-skip-forward text-black\"></md-icon></md-button></div>\n</div></div>");
$templateCache.put("app/main/vehicles/vehicle-details/work-order-summary-list.html","<table class=\"table table-hover\" style=\"table-layout: fixed;width:100%; min-width:1000px\"><thead><tr><th \nclass=\"text-nowrap bg-light\" style=\"width: 100px\" ng-click=\"vm.setSorting()\">Invoice #<md-icon \nng-class=\"vm.isSortInvoiceDesc() ? [\'icon-chevron-down\']:[\'icon-chevron-up\']\"></md-icon></th><th \nclass=\"text-nowrap bg-light\" style=\"width:100%\">Details</th><th class=\"text-nowrap bg-light\" style=\"width: 90px\">\nPriority</th><th class=\"text-nowrap bg-light\" style=\"width: 90px\">Parts</th><th class=\"text-nowrap bg-light\" \nstyle=\"width: 90px\">Labors</th><th class=\"text-nowrap bg-light\" style=\"width: 90px\">Misc fees</th><th \nclass=\"text-nowrap bg-light\" style=\"width: 90px\">Package</th><th class=\"text-nowrap bg-light\" style=\"width: 90px\">\nWarranty</th><th class=\"text-nowrap bg-light\" style=\"width: 100px\">Outstanding</th><th class=\"text-nowrap bg-light\" \nstyle=\"width: 150px\">Status</th></tr></thead><tbody><tr ng-if=\"!(vm.workOrderList.length > 0)\"><td colspan=\"100%\">\nNo item found.</td></tr><tr></tr><tr ng-repeat=\"item in vm.workOrderList\" \nng-class=\"item.workOrder.isCompleted() ? \'text-green\' : (item.workOrder.isCompletedElseWhere() ? \'text-orange\' : \'\')\">\n<td><a ng-href=\"{{vm.getWorkOrderUrl(item.workOrder)}}\" \nng-class=\"item.workOrder.isCompleted() ? \'text-green\' : (item.workOrder.isCompletedElseWhere() ? \'text-orange\' : \'\')\">\n{{item.workOrder.invoice_number ? item.workOrder.invoice_number : \'Uninvoiced\'}}</a></td><td><div><div \nclass=\"text-nowrap text-truncate\">{{item.workOrder.notes}}</div><div layout=\"row\" \nstyle=\"font-size: 12px; font-style: oblique\"><div flex><div ng-class=\"vm.getPartsStyleClass(part);\" layout=\"row\" \nng-repeat=\"part in item.partsAndInventories | limitTo:vm.maxDisplay track by $index\"><div class=\"mr-1\">&#9679</div>\n<span class=\"text-nowrap text-truncate\">{{part.name}}</span></div><div \nng-if=\"item.partsAndInventories.length > vm.maxDisplay\"><span>\n{{item.partsAndInventories.length - vm.maxDisplay}} more...<md-tooltip class=\"multiline-tooltip\"><div layout=\"column\">\n<div ng-repeat=\"part in item.partsAndInventories | limitTo: item.partsAndInventories.length : vm.maxDisplay\">\n{{part.name}}</div></div></md-tooltip></span></div><br ng-if=\"item.labors.length > 0\"><div layout=\"row\" \nng-repeat=\"labor in item.labors | limitTo:vm.maxDisplay  track by $index\"><div class=\"mr-1\">&#9679</div><span \nclass=\"text-nowrap text-truncate\">{{labor.name}}</span></div><div ng-if=\"item.labors.length > vm.maxDisplay\"><span>\n{{item.labors.length - vm.maxDisplay}} more...<md-tooltip class=\"multiline-tooltip\"><div \nng-repeat=\"labor in item.labors | limitTo: item.labors.length : vm.maxDisplay\">{{labor.name}}</div></md-tooltip></span>\n</div></div></div></div></td><td><div class=\"text-nowrap text-truncate\">\n{{vm.getWorkorderPriority(item.workOrder.fk_id_work_order_priority)}}</div></td><td><div \nclass=\"text-nowrap text-truncate\">{{item.isLoading ? \'Loading..\' : (item.totalPartsRetail | currency:\'$\':2)}}</div>\n</td><td><div class=\"text-nowrap text-truncate\">\n{{item.isLoading ? \'Loading..\' : (item.totalLaborsCost | currency:\'$\':2)}}</div></td><td><div \nclass=\"text-nowrap text-truncate\">{{item.isLoading ? \'Loading..\' : (item.totalMiscfeesCost | currency:\'$\':2)}}</div>\n</td><td><div class=\"text-nowrap text-truncate\">\n{{item.isLoading ? \'Loading..\' : (item.totalWorkOrderPackageCost | currency:\'$\':2)}}</div></td><td><div \nclass=\"text-nowrap text-truncate\">{{item.isLoading ? \'Loading..\' : (item.totalWorkOrderWarrantyCost | currency:\'$\':2)}}\n</div></td><td><div class=\"text-nowrap text-truncate\">\n{{item.isLoading ? \'Loading..\' : (item.outstanding | currency:\'$\':2)}}</div></td><td><div \nclass=\"text-nowrap text-truncate\">{{vm.getWorkOrderStatus(item.workOrder.fk_id_work_order_status)}}</div><div \nng-switch on=\"item.workOrder.isCompleted()\"><div ng-switch-when=\"true\">\n{{item.workOrder.completed_date | date: \"yyyy-MM-dd\"}}</div><div ng-switch-default>{{item.workOrder.quote_date}}</div>\n</div></td></tr></tbody></table>");
$templateCache.put("app/main/vehicles/vehicle-details/work-order-summary-outstanding-list.html","<table class=\"table table-hover\" style=\"table-layout: fixed;width:100%; min-width:1000px\"><thead><tr><th \nclass=\"text-nowrap bg-light\" style=\"width: 100px\" ng-click=\"vm.setSorting()\">Invoice #<md-icon \nng-class=\"vm.isSortInvoiceDesc() ? [\'icon-chevron-down\']:[\'icon-chevron-up\']\"></md-icon></th><th \nclass=\"text-nowrap bg-light\" style=\"width: 100px\">Customer</th><th ng-if=\"!vm.hiddenColumns.vehicle\" \nclass=\"text-nowrap bg-light\" style=\"width: 150px\">Vehicle</th><th class=\"text-nowrap bg-light\" style=\"width:100%\">\nDetails</th><th class=\"text-nowrap bg-light\" style=\"width: 90px\">Priority</th><th ng-if=\"!vm.hiddenColumns.parts\" \nclass=\"text-nowrap bg-light\" style=\"width: 90px\">Parts</th><th ng-if=\"!vm.hiddenColumns.labors\" \nclass=\"text-nowrap bg-light\" style=\"width: 90px\">Labors</th><th ng-if=\"!vm.hiddenColumns.outstanding\" \nclass=\"text-nowrap bg-light\" style=\"width: 100px\">Outstanding</th><th class=\"text-nowrap bg-light\" \nstyle=\"width: 150px\">Status</th></tr></thead><tbody><tr ng-if=\"!(vm.workOrderList.length > 0)\"><td colspan=\"100%\">\nNo item found.</td></tr><tr></tr><tr ng-repeat=\"item in vm.workOrderList\" \nng-class=\"item.workOrder.isCompleted()? [\'text-green\'] : [\'\']\"><td><a ng-href=\"{{vm.getWorkOrderUrl(item.workOrder)}}\" \nng-class=\"item.workOrder.isCompleted()? [\'text-green\'] : [\'\']\">\n{{item.workOrder.invoice_number ? item.workOrder.invoice_number : \'Uninvoiced\'}}</a></td><td \nng-if=\"!vm.hiddenColumns.vehicle\"><div><a ng-href=\"{{vm.getCustomerUrl(item.workOrder)}}\" \nclass=\"text-nowrap text-truncate\" ng-class=\"item.workOrder.isCompleted()? [\'text-green\'] : [\'\']\">\n{{vm.getCustomerName(item.workOrder)}}</a></div></td><td ng-if=\"!vm.hiddenColumns.vehicle\"><a \nng-href=\"{{vm.getVehicleUrl(item.workOrder.fk_id_vehicle)}}\" class=\"text-nowrap text-truncate\" \nng-class=\"item.workOrder.isCompleted()? [\'text-green\'] : [\'\']\">\n{{vm.vehicleMap[item.workOrder.fk_id_vehicle].getYearMakeModel()}}</a></td><td><div><div \nclass=\"text-nowrap text-truncate\">{{item.workOrder.notes}}</div><div layout=\"row\" \nstyle=\"font-size: 12px; font-style: oblique\"><div flex><div ng-class=\"vm.getPartsStyleClass(part);\" layout=\"row\" \nng-repeat=\"part in item.partsAndInventories | limitTo:vm.maxDisplay\"><div class=\"mr-1\">&#9679</div><span \nclass=\"text-nowrap text-truncate\">{{part.name}}</span></div><div \nng-if=\"item.partsAndInventories.length > vm.maxDisplay\"><span>\n{{item.partsAndInventories.length - vm.maxDisplay}} more...<md-tooltip class=\"multiline-tooltip\"><div layout=\"column\">\n<div ng-repeat=\"part in item.partsAndInventories | limitTo: item.partsAndInventories.length : vm.maxDisplay\">\n{{part.name}}</div></div></md-tooltip></span></div></div><div flex><div layout=\"row\" \nng-repeat=\"labor in item.labors | limitTo:vm.maxDisplay\"><div class=\"mr-1\">&#9679</div><span \nclass=\"text-nowrap text-truncate\">{{labor.name}}</span></div><div ng-if=\"item.labors.length > vm.maxDisplay\"><span>\n{{item.labors.length - vm.maxDisplay}} more...<md-tooltip class=\"multiline-tooltip\"><div \nng-repeat=\"labor in item.labors | limitTo: item.labors.length : vm.maxDisplay\">{{labor.name}}</div></md-tooltip></span>\n</div></div></div></div></td><td><div class=\"text-nowrap text-truncate\">\n{{vm.getWorkorderPriority(item.workOrder.fk_id_work_order_priority)}}</div></td><td ng-if=\"!vm.hiddenColumns.parts\">\n<div class=\"text-nowrap text-truncate\">{{item.isLoading ? \'Loading..\' : (item.totalPartsRetail | currency:\'$\':2)}}\n</div></td><td ng-if=\"!vm.hiddenColumns.labors\"><div class=\"text-nowrap text-truncate\">\n{{item.isLoading ? \'Loading..\' : (item.totalLaborsCost | currency:\'$\':2)}}</div></td><td \nng-if=\"!vm.hiddenColumns.outstanding\"><div class=\"text-nowrap text-truncate\">\n{{item.isLoading ? \'Loading..\' : (item.outstanding | currency:\'$\':2)}}</div></td><td><div \nclass=\"text-nowrap text-truncate\">{{vm.getWorkOrderStatus(item.workOrder.fk_id_work_order_status)}}</div><div \nng-switch on=\"item.workOrder.isCompleted()\"><div ng-switch-when=\"true\">\n{{item.workOrder.completed_date | date: \"yyyy-MM-dd\"}}</div><div ng-switch-default>{{item.workOrder.quote_date}}</div>\n</div></td></tr></tbody></table>");
$templateCache.put("app/main/vehicles/vehicle-details/work-order-summary-pending-list.html","<table class=\"table table-hover\" style=\"table-layout: fixed;width:100%; min-width:1000px\"><thead><tr><th \nclass=\"text-nowrap bg-light\" style=\"width: 100px\" ng-click=\"vm.setSorting()\">Invoice #<md-icon \nng-class=\"vm.isSortInvoiceDesc() ? [\'icon-chevron-down\']:[\'icon-chevron-up\']\"></md-icon></th><th \nclass=\"text-nowrap bg-light\" style=\"width: 100px\">Customer</th><th ng-if=\"!vm.hiddenColumns.vehicle\" \nclass=\"text-nowrap bg-light\" style=\"width: 150px\">Vehicle</th><th class=\"text-nowrap bg-light\" style=\"width:100%\">\nDetails</th><th class=\"text-nowrap bg-light\" style=\"width: 90px\">Priority</th><th ng-if=\"!vm.hiddenColumns.parts\" \nclass=\"text-nowrap bg-light\" style=\"width: 90px\">Parts</th><th ng-if=\"!vm.hiddenColumns.labors\" \nclass=\"text-nowrap bg-light\" style=\"width: 90px\">Labors</th><th ng-if=\"!vm.hiddenColumns.outstanding\" \nclass=\"text-nowrap bg-light\" style=\"width: 100px\">Outstanding</th><th class=\"text-nowrap bg-light\" \nstyle=\"width: 150px\">Status</th></tr></thead><tbody><tr ng-if=\"!(vm.workOrderList.length > 0)\"><td colspan=\"100%\">\nNo item found.</td></tr><tr></tr><tr ng-repeat=\"item in vm.workOrderList\" \nng-class=\"item.workOrder.isCompleted()? [\'text-green\'] : [\'\']\"><td><a ng-href=\"{{vm.getWorkOrderUrl(item.workOrder)}}\" \nng-class=\"item.workOrder.isCompleted()? [\'text-green\'] : [\'\']\">\n{{item.workOrder.invoice_number ? item.workOrder.invoice_number : \'Uninvoiced\'}}</a></td><td \nng-if=\"!vm.hiddenColumns.vehicle\"><div><a ng-href=\"{{vm.getCustomerUrl(item.workOrder)}}\" \nclass=\"text-nowrap text-truncate\" ng-class=\"item.workOrder.isCompleted()? [\'text-green\'] : [\'\']\">\n{{vm.getCustomerName(item.workOrder)}}</a></div></td><td ng-if=\"!vm.hiddenColumns.vehicle\"><a \nng-href=\"{{vm.getVehicleUrl(item.workOrder.fk_id_vehicle)}}\" class=\"text-nowrap text-truncate\" \nng-class=\"item.workOrder.isCompleted()? [\'text-green\'] : [\'\']\">\n{{vm.vehicleMap[item.workOrder.fk_id_vehicle].getYearMakeModel()}}</a></td><td><div><div \nclass=\"text-nowrap text-truncate\">{{item.workOrder.notes}}</div><div layout=\"row\" \nstyle=\"font-size: 12px; font-style: oblique\"><div flex><div ng-class=\"vm.getPartsStyleClass(part);\" layout=\"row\" \nng-repeat=\"part in item.partsAndInventories | limitTo:vm.maxDisplay\"><div class=\"mr-1\">&#9679</div><span \nclass=\"text-nowrap text-truncate\">{{part.name}}</span></div><div \nng-if=\"item.partsAndInventories.length > vm.maxDisplay\"><span>\n{{item.partsAndInventories.length - vm.maxDisplay}} more...<md-tooltip class=\"multiline-tooltip\"><div layout=\"column\">\n<div ng-repeat=\"part in item.partsAndInventories | limitTo: item.partsAndInventories.length : vm.maxDisplay\">\n{{part.name}}</div></div></md-tooltip></span></div></div><div flex><div layout=\"row\" \nng-repeat=\"labor in item.labors | limitTo:vm.maxDisplay\"><div class=\"mr-1\">&#9679</div><span \nclass=\"text-nowrap text-truncate\">{{labor.name}}</span></div><div ng-if=\"item.labors.length > vm.maxDisplay\"><span>\n{{item.labors.length - vm.maxDisplay}} more...<md-tooltip class=\"multiline-tooltip\"><div \nng-repeat=\"labor in item.labors | limitTo: item.labors.length : vm.maxDisplay\">{{labor.name}}</div></md-tooltip></span>\n</div></div></div></div></td><td><div class=\"text-nowrap text-truncate\">\n{{vm.getWorkorderPriority(item.workOrder.fk_id_work_order_priority)}}</div></td><td ng-if=\"!vm.hiddenColumns.parts\">\n<div class=\"text-nowrap text-truncate\">{{item.isLoading ? \'Loading..\' : (item.totalPartsRetail | currency:\'$\':2)}}\n</div></td><td ng-if=\"!vm.hiddenColumns.labors\"><div class=\"text-nowrap text-truncate\">\n{{item.isLoading ? \'Loading..\' : (item.totalLaborsCost | currency:\'$\':2)}}</div></td><td \nng-if=\"!vm.hiddenColumns.outstanding\"><div class=\"text-nowrap text-truncate\">\n{{item.isLoading ? \'Loading..\' : (item.outstanding | currency:\'$\':2)}}</div></td><td><div \nclass=\"text-nowrap text-truncate\">{{vm.getWorkOrderStatus(item.workOrder.fk_id_work_order_status)}}</div><div \nng-switch on=\"item.workOrder.isCompleted()\"><div ng-switch-when=\"true\">\n{{item.workOrder.completed_date | date: \"yyyy-MM-dd\"}}</div><div ng-switch-default>{{item.workOrder.quote_date}}</div>\n</div></td></tr></tbody></table>");
$templateCache.put("app/main/vehicles/vehicle-details/work-order-summary-small-list.html","<head><style>\n/* Hide the list by default */\r\n		#item-list {\r\n			display: none;\r\n		}\r\n\r\n		/* Style for the clickable tab */\r\n		.tab {\r\n			background-color: #f2f2f2;\r\n			border: 1px solid #ccc;\r\n			cursor: pointer;\r\n			padding: 10px;\r\n			width: 100%;\r\n		}\r\n\r\n		/* Style for the active tab */\r\n		.tab.active {\r\n			background-color: #ddd;\r\n		}\n</style></head><div class=\"tab\" ng-click=\"vm.toggleItemList()\">\nShow Outstanding Invoice (${{vm.gettotaloutstanding(vm.workOrderList).toFixed(2)}})</div><ul id=\"item-list\"><li \nng-if=\"vm.gettotaloutstanding(vm.workOrderList) != 0\" ng-repeat=\"invoice in vm.workOrderList\"><a \nng-href=\"{{vm.getWorkOrderUrl(invoice)}}\">{{invoice.workOrder.invoice_number}} </a>${{invoice.outstanding}}</li></ul>");
$templateCache.put("app/main/vehicles/vehicle-details/work-order-summary-warranty-list.html","<table class=\"table table-hover\" style=\"table-layout: fixed;width:100%; min-width:1000px\"><thead><tr><th \nclass=\"text-nowrap bg-light\" style=\"width: 100px\" ng-click=\"vm.setSorting()\">Invoice #<md-icon \nng-class=\"vm.isSortInvoiceDesc() ? [\'icon-chevron-down\']:[\'icon-chevron-up\']\"></md-icon></th><th \nclass=\"text-nowrap bg-light\" style=\"width: 100px\">Customer</th><th ng-if=\"!vm.hiddenColumns.vehicle\" \nclass=\"text-nowrap bg-light\" style=\"width: 150px\">Vehicle</th><th class=\"text-nowrap bg-light\" style=\"width:100%\">\nDetails</th><th class=\"text-nowrap bg-light\" style=\"width: 90px\">Priority</th><th ng-if=\"!vm.hiddenColumns.parts\" \nclass=\"text-nowrap bg-light\" style=\"width: 90px\">Parts</th><th ng-if=\"!vm.hiddenColumns.labors\" \nclass=\"text-nowrap bg-light\" style=\"width: 90px\">Labors</th><th ng-if=\"!vm.hiddenColumns.outstanding\" \nclass=\"text-nowrap bg-light\" style=\"width: 100px\">Outstanding</th><th class=\"text-nowrap bg-light\" \nstyle=\"width: 150px\">Status</th></tr></thead><tbody><tr ng-if=\"!(vm.workOrderList.length > 0)\"><td colspan=\"100%\">\nNo item found.</td></tr><tr></tr><tr ng-repeat=\"item in vm.workOrderList\" \nng-class=\"item.workOrder.isCompleted()? [\'text-green\'] : [\'\']\"><td><a ng-href=\"{{vm.getWorkOrderUrl(item.workOrder)}}\" \nng-class=\"item.workOrder.isCompleted()? [\'text-green\'] : [\'\']\">\n{{item.workOrder.invoice_number ? item.workOrder.invoice_number : \'Uninvoiced\'}}</a></td><td \nng-if=\"!vm.hiddenColumns.vehicle\"><div><a ng-href=\"{{vm.getCustomerUrl(item.workOrder)}}\" \nclass=\"text-nowrap text-truncate\" ng-class=\"item.workOrder.isCompleted()? [\'text-green\'] : [\'\']\">\n{{vm.getCustomerName(item.workOrder)}}</a></div></td><td ng-if=\"!vm.hiddenColumns.vehicle\"><a \nng-href=\"{{vm.getVehicleUrl(item.workOrder.fk_id_vehicle)}}\" class=\"text-nowrap text-truncate\" \nng-class=\"item.workOrder.isCompleted()? [\'text-green\'] : [\'\']\">\n{{vm.vehicleMap[item.workOrder.fk_id_vehicle].getYearMakeModel()}}</a></td><td><div><div \nclass=\"text-nowrap text-truncate\">{{item.workOrder.notes}}</div><div layout=\"row\" \nstyle=\"font-size: 12px; font-style: oblique\"><div flex><div ng-class=\"vm.getPartsStyleClass(part);\" layout=\"row\" \nng-repeat=\"part in item.partsAndInventories | limitTo:vm.maxDisplay\"><div class=\"mr-1\">&#9679</div><span \nclass=\"text-nowrap text-truncate\">{{part.name}}</span></div><div \nng-if=\"item.partsAndInventories.length > vm.maxDisplay\"><span>\n{{item.partsAndInventories.length - vm.maxDisplay}} more...<md-tooltip class=\"multiline-tooltip\"><div layout=\"column\">\n<div ng-repeat=\"part in item.partsAndInventories | limitTo: item.partsAndInventories.length : vm.maxDisplay\">\n{{part.name}}</div></div></md-tooltip></span></div></div><div flex><div layout=\"row\" \nng-repeat=\"labor in item.labors | limitTo:vm.maxDisplay\"><div class=\"mr-1\">&#9679</div><span \nclass=\"text-nowrap text-truncate\">{{labor.name}}</span></div><div ng-if=\"item.labors.length > vm.maxDisplay\"><span>\n{{item.labors.length - vm.maxDisplay}} more...<md-tooltip class=\"multiline-tooltip\"><div \nng-repeat=\"labor in item.labors | limitTo: item.labors.length : vm.maxDisplay\">{{labor.name}}</div></md-tooltip></span>\n</div></div></div></div></td><td><div class=\"text-nowrap text-truncate\">\n{{vm.getWorkorderPriority(item.workOrder.fk_id_work_order_priority)}}</div></td><td ng-if=\"!vm.hiddenColumns.parts\">\n<div class=\"text-nowrap text-truncate\">{{item.isLoading ? \'Loading..\' : (item.totalPartsRetail | currency:\'$\':2)}}\n</div></td><td ng-if=\"!vm.hiddenColumns.labors\"><div class=\"text-nowrap text-truncate\">\n{{item.isLoading ? \'Loading..\' : (item.totalLaborsCost | currency:\'$\':2)}}</div></td><td \nng-if=\"!vm.hiddenColumns.outstanding\"><div class=\"text-nowrap text-truncate\">\n{{item.isLoading ? \'Loading..\' : (item.outstanding | currency:\'$\':2)}}</div></td><td><div \nclass=\"text-nowrap text-truncate\">{{vm.getWorkOrderStatus(item.workOrder.fk_id_work_order_status)}}</div><div \nng-switch on=\"item.workOrder.isCompleted()\"><div ng-switch-when=\"true\">\n{{item.workOrder.completed_date | date: \"yyyy-MM-dd\"}}</div><div ng-switch-default>{{item.workOrder.quote_date}}</div>\n</div></td></tr></tbody></table>");
$templateCache.put("app/main/vehicles/vehicle-was-available/vehicle-was-available.html","<div style=\"width: 100%\" class=\"bg-secondary header-backgroud\" layout=\"row\" layout-align=\"center center\"><div flex \nclass=\"content-max-width content-padding-x-full\"><span class=\"h2 white-fg\">Vehicle Was Available</span></div></div><div\n style=\"width: 100%\" layout=\"row\" layout-align=\"center start\"><div flex \nclass=\"content-max-width content-padding-x-full\"><div layout=\"row\" layout-align=\"space-between center\"><div \nlayout=\"row\" layout-align=\"start center\"><md-datepicker class=\"mr-3\" ng-model=\"vm.date\" md-placeholder=\"Select a date\" \nng-change=\"vm.updateVehicleList()\"></md-datepicker><div ng-if=\"vm.vehicleList.length > 0\">\nTotal: {{vm.vehicleList.length}} vehicles</div></div><div layout=\"row\" layout-align=\"end center\"><md-button \nclass=\"btn btn-secondary\" ng-click=\"vm.generatePurchaseReport()\" ng-disabled=\"vm.isBusy || !vm.date\">purchase report\n</md-button><md-button class=\"btn btn-secondary\" ng-click=\"vm.generateSaleReport()\" \nng-disabled=\"vm.isBusy || !vm.date\">sale report</md-button><md-button class=\"btn btn-secondary\" \nng-click=\"vm.generateProfitReport()\" ng-disabled=\"vm.isBusy || !vm.date\">profit report</md-button></div></div>\n<md-content><table class=\"table strike-able table-hover\" style=\"table-layout: fixed;width:100%; min-width:700px\">\n<thead><tr><th class=\"text-nowrap bg-light\" style=\"width:100%\">Vehicle</th><th class=\"text-nowrap bg-light\" \nstyle=\"width: 250px\">VIN</th><th class=\"text-nowrap bg-light\" style=\"width: 150px\">Last Purchase</th><th \nclass=\"text-nowrap bg-light\" style=\"width: 150px\">Last Sale</th></tr></thead><tbody><tr \nng-repeat=\"vehicle in vm.vehicleList | orderBy:\'purchase_date\':true\"><td><a \nng-href=\"{{vm.getVehiclePageUrl(vehicle.getResourceID())}}\">{{vehicle.getYearMakeModel()}}</a></td><td>{{vehicle.vin}}\n</td><td>{{vehicle.purchase_date}}</td><td>{{vehicle.sale_date}}</td></tr><tr ng-if=\"!(vm.vehicleList.length > 0)\"><td \ncolspan=\"100%\">No item found.</td></tr></tbody></table></md-content></div></div>");
$templateCache.put("app/main/workorders/browse-outstanding-workorders/browse-outstanding-workorders.html","<head><style>.tab {\r\n			cursor: pointer;\r\n			padding: 10px;\r\n			width: 100%;\r\n		}</style></head><div \nstyle=\"width: 100%\" class=\"bg-secondary header-backgroud\" layout=\"row\" layout-align=\"center center\"><div flex \nclass=\"content-max-width content-padding-x-full\"><span class=\"h2 white-fg\">Contain Outstanding Work Orders</span></div>\n</div><div style=\"width: 100%\" layout=\"row\" layout-align=\"center start\"><div flex \nclass=\"content-max-width content-padding-x-full py-3\"><div layout=\"row\" layout=\"start center\" layout-wrap><form \nname=\"datePickerForm\" flex=\"100\" flex-gt-sm=\"50\" layout=\"row\"><md-input-container flex class=\"small-input-box\"><label>\nFrom</label><md-datepicker md-hide-icons=\"calendar\" ng-model=\"vm.startDateFilter\" md-max-date=\"vm.endDateFilter\" \nng-change=\"vm.refreshWorkorderList(1)\" name=\"startDate\"></md-datepicker><div \nng-messages=\"datePickerForm.startDate.$error\"><div ng-message=\"valid\">Invalid date.</div><div ng-message=\"maxdate\">\nMust before end date</div></div></md-input-container><md-input-container flex class=\"small-input-box\"><label>To</label>\n<md-datepicker md-hide-icons=\"calendar\" ng-model=\"vm.endDateFilter\" md-min-date=\"vm.startDateFilter\" \nng-change=\"vm.refreshWorkorderList(1)\" name=\"endDate\"></md-datepicker><div ng-messages=\"datePickerForm.endDate.$error\">\n<div ng-message=\"valid\">Invalid date.</div><div ng-message=\"mindate\">Must after start date</div></div>\n</md-input-container><md-input-container flex class=\"small-input-box\"><label>Reload Report Table</label><br><i \nng-click=\"vm.reloadOutstandingReportTable()\" \nng-class=\"[\'icon-reload\', {\'text-green\': vm.isRefreshing, \'text-black\': !vm.isRefreshing}]\" class=\"font-weight-bold\">\n</i></md-input-container></form></div><div class=\"tab\">\nTotal Outstanding of current display items: (${{vm.totaloutstanding.toFixed(2)}})</div><div class=\"tab\">\nTotal Outstanding of overall items: (${{vm.overall_outstanding.toFixed(2)}})</div><md-content>\n<work-order-summary-outstanding-list vehicle-map=\"vm.vehicleMap\" workorder-priorities=\"vm.workOrderPriorities\" \nwork-order-status=\"vm.workOrderStatus\" work-order-list=\"vm.workorderList\" \ntoggle-sort-invoice-number=\"vm.toggleSortInvoiceNumber\" is-sort-invoice-desc=\"vm.isSortInvoiceDesc\">\n</work-order-summary-outstanding-list></md-content><div layout=\"row\" layout-align=\"end center\"><pagination \nclass=\"mr-3\" item-per-page=\"vm.itemsPerPage\" current-page=\"vm.currentPage\" total-count=\"vm.totalCount\" \non-page-change=\"vm.refreshWorkorderList\"></pagination><div class=\"mr-3\">Total Item: {{vm.totalCount}}</div><div>\nDisplay:</div><md-select ng-change=\"vm.refreshWorkorderList(1)\" ng-model=\"vm.itemsPerPage\" placeholder=\"Display\">\n<md-option ng-repeat=\"option in vm.displayOptions\" ng-value=\"option\">{{option}}</md-option></md-select></div></div>\n</div>");
$templateCache.put("app/main/workorders/browse-part-appointment-workorders/browse-part-appointment-workorders.html","<head><style>.tab {\r\n			cursor: pointer;\r\n			padding: 10px;\r\n			width: 100%;\r\n		}</style></head><div \nstyle=\"width: 100%\" class=\"bg-secondary header-backgroud\" layout=\"row\" layout-align=\"center center\"><div flex \nclass=\"content-max-width content-padding-x-full\"><span class=\"h2 white-fg\">\nContain Ordered Part and appointment Work Orders</span></div></div><div style=\"width: 100%\" layout=\"row\" \nlayout-align=\"center start\"><div flex class=\"content-max-width content-padding-x-full py-3\"><div layout=\"row\" \nlayout=\"start center\" layout-wrap><form name=\"datePickerForm\" flex=\"100\" flex-gt-sm=\"50\" layout=\"row\">\n<md-input-container flex class=\"small-input-box\"><label>From</label><md-datepicker md-hide-icons=\"calendar\" \nng-model=\"vm.startDateFilter\" md-max-date=\"vm.endDateFilter\" ng-change=\"vm.refreshWorkorderList(1)\" name=\"startDate\">\n</md-datepicker><div ng-messages=\"datePickerForm.startDate.$error\"><div ng-message=\"valid\">Invalid date.</div><div \nng-message=\"maxdate\">Must before end date</div></div></md-input-container><md-input-container flex \nclass=\"small-input-box\"><label>To</label><md-datepicker md-hide-icons=\"calendar\" ng-model=\"vm.endDateFilter\" \nmd-min-date=\"vm.startDateFilter\" ng-change=\"vm.refreshWorkorderList(1)\" name=\"endDate\"></md-datepicker><div \nng-messages=\"datePickerForm.endDate.$error\"><div ng-message=\"valid\">Invalid date.</div><div ng-message=\"mindate\">\nMust after start date</div></div></md-input-container><md-input-container flex class=\"small-input-box\"><label>\nReload Report Table</label><br><i ng-click=\"vm.reloadOutstandingReportTable()\" \nng-class=\"[\'icon-reload\', {\'text-green\': vm.isRefreshing, \'text-black\': !vm.isRefreshing}]\" class=\"font-weight-bold\">\n</i></md-input-container></form></div><div class=\"tab\">\nTotal Outstanding of current display items: (${{vm.totaloutstanding.toFixed(2)}})</div><div class=\"tab\">\nTotal Outstanding of overall items: (${{vm.overall_outstanding.toFixed(2)}})</div><md-content>\n<work-order-summary-outstanding-list vehicle-map=\"vm.vehicleMap\" workorder-priorities=\"vm.workOrderPriorities\" \nwork-order-status=\"vm.workOrderStatus\" work-order-list=\"vm.workorderList\" \ntoggle-sort-invoice-number=\"vm.toggleSortInvoiceNumber\" is-sort-invoice-desc=\"vm.isSortInvoiceDesc\">\n</work-order-summary-outstanding-list></md-content><div layout=\"row\" layout-align=\"end center\"><pagination \nclass=\"mr-3\" item-per-page=\"vm.itemsPerPage\" current-page=\"vm.currentPage\" total-count=\"vm.totalCount\" \non-page-change=\"vm.refreshWorkorderList\"></pagination><div class=\"mr-3\">Total Item: {{vm.totalCount}}</div><div>\nDisplay:</div><md-select ng-change=\"vm.refreshWorkorderList(1)\" ng-model=\"vm.itemsPerPage\" placeholder=\"Display\">\n<md-option ng-repeat=\"option in vm.displayOptions\" ng-value=\"option\">{{option}}</md-option></md-select></div></div>\n</div>");
$templateCache.put("app/main/workorders/browse-part-no-appointment-workorders/browse-part-no-appointment-workorders.html","<head><style>.tab {\r\n			cursor: pointer;\r\n			padding: 10px;\r\n			width: 100%;\r\n		}</style></head><div \nstyle=\"width: 100%\" class=\"bg-secondary header-backgroud\" layout=\"row\" layout-align=\"center center\"><div flex \nclass=\"content-max-width content-padding-x-full\"><span class=\"h2 white-fg\">\nContain Ordered Part without appointment Work Orders</span></div></div><div style=\"width: 100%\" layout=\"row\" \nlayout-align=\"center start\"><div flex class=\"content-max-width content-padding-x-full py-3\"><div layout=\"row\" \nlayout=\"start center\" layout-wrap><form name=\"datePickerForm\" flex=\"100\" flex-gt-sm=\"50\" layout=\"row\">\n<md-input-container flex class=\"small-input-box\"><label>From</label><md-datepicker md-hide-icons=\"calendar\" \nng-model=\"vm.startDateFilter\" md-max-date=\"vm.endDateFilter\" ng-change=\"vm.refreshWorkorderList(1)\" name=\"startDate\">\n</md-datepicker><div ng-messages=\"datePickerForm.startDate.$error\"><div ng-message=\"valid\">Invalid date.</div><div \nng-message=\"maxdate\">Must before end date</div></div></md-input-container><md-input-container flex \nclass=\"small-input-box\"><label>To</label><md-datepicker md-hide-icons=\"calendar\" ng-model=\"vm.endDateFilter\" \nmd-min-date=\"vm.startDateFilter\" ng-change=\"vm.refreshWorkorderList(1)\" name=\"endDate\"></md-datepicker><div \nng-messages=\"datePickerForm.endDate.$error\"><div ng-message=\"valid\">Invalid date.</div><div ng-message=\"mindate\">\nMust after start date</div></div></md-input-container><md-input-container flex class=\"small-input-box\"><label>\nReload Report Table</label><br><i ng-click=\"vm.reloadOutstandingReportTable()\" \nng-class=\"[\'icon-reload\', {\'text-green\': vm.isRefreshing, \'text-black\': !vm.isRefreshing}]\" class=\"font-weight-bold\">\n</i></md-input-container></form></div><div class=\"tab\">\nTotal Outstanding of current display items: (${{vm.totaloutstanding.toFixed(2)}})</div><div class=\"tab\">\nTotal Outstanding of overall items: (${{vm.overall_outstanding.toFixed(2)}})</div><md-content>\n<work-order-summary-outstanding-list vehicle-map=\"vm.vehicleMap\" workorder-priorities=\"vm.workOrderPriorities\" \nwork-order-status=\"vm.workOrderStatus\" work-order-list=\"vm.workorderList\" \ntoggle-sort-invoice-number=\"vm.toggleSortInvoiceNumber\" is-sort-invoice-desc=\"vm.isSortInvoiceDesc\">\n</work-order-summary-outstanding-list></md-content><div layout=\"row\" layout-align=\"end center\"><pagination \nclass=\"mr-3\" item-per-page=\"vm.itemsPerPage\" current-page=\"vm.currentPage\" total-count=\"vm.totalCount\" \non-page-change=\"vm.refreshWorkorderList\"></pagination><div class=\"mr-3\">Total Item: {{vm.totalCount}}</div><div>\nDisplay:</div><md-select ng-change=\"vm.refreshWorkorderList(1)\" ng-model=\"vm.itemsPerPage\" placeholder=\"Display\">\n<md-option ng-repeat=\"option in vm.displayOptions\" ng-value=\"option\">{{option}}</md-option></md-select></div></div>\n</div>");
$templateCache.put("app/main/workorders/browse-pending-workorders/browse-pending-workorders.html","<head><style>.tab {\r\n			cursor: pointer;\r\n			padding: 10px;\r\n			width: 100%;\r\n		}</style></head><div \nstyle=\"width: 100%\" class=\"bg-secondary header-backgroud\" layout=\"row\" layout-align=\"center center\"><div flex \nclass=\"content-max-width content-padding-x-full\"><span class=\"h2 white-fg\">Contain Pending Warranty Payment Work Orders\n</span></div></div><div style=\"width: 100%\" layout=\"row\" layout-align=\"center start\"><div flex \nclass=\"content-max-width content-padding-x-full py-3\"><div layout=\"row\" layout=\"start center\" layout-wrap><form \nname=\"datePickerForm\" flex=\"100\" flex-gt-sm=\"50\" layout=\"row\"><md-input-container flex class=\"small-input-box\"><label>\nFrom</label><md-datepicker md-hide-icons=\"calendar\" ng-model=\"vm.startDateFilter\" md-max-date=\"vm.endDateFilter\" \nng-change=\"vm.refreshWorkorderList(1)\" name=\"startDate\"></md-datepicker><div \nng-messages=\"datePickerForm.startDate.$error\"><div ng-message=\"valid\">Invalid date.</div><div ng-message=\"maxdate\">\nMust before end date</div></div></md-input-container><md-input-container flex class=\"small-input-box\"><label>To</label>\n<md-datepicker md-hide-icons=\"calendar\" ng-model=\"vm.endDateFilter\" md-min-date=\"vm.startDateFilter\" \nng-change=\"vm.refreshWorkorderList(1)\" name=\"endDate\"></md-datepicker><div ng-messages=\"datePickerForm.endDate.$error\">\n<div ng-message=\"valid\">Invalid date.</div><div ng-message=\"mindate\">Must after start date</div></div>\n</md-input-container></form></div><div class=\"tab\">\nTotal Outstanding of current display items: (${{vm.totaloutstanding.toFixed(2)}})</div><div class=\"tab\">\nTotal Outstanding of overall items: (${{vm.overall_outstanding.toFixed(2)}})</div><md-content>\n<work-order-summary-pending-list vehicle-map=\"vm.vehicleMap\" workorder-priorities=\"vm.workOrderPriorities\" \nwork-order-status=\"vm.workOrderStatus\" work-order-list=\"vm.workorderList\" \ntoggle-sort-invoice-number=\"vm.toggleSortInvoiceNumber\" is-sort-invoice-desc=\"vm.isSortInvoiceDesc\">\n</work-order-summary-pending-list></md-content><div layout=\"row\" layout-align=\"end center\"><pagination class=\"mr-3\" \nitem-per-page=\"vm.itemsPerPage\" current-page=\"vm.currentPage\" total-count=\"vm.totalCount\" \non-page-change=\"vm.refreshWorkorderList\"></pagination><div class=\"mr-3\">Total Item: {{vm.totalCount}}</div><div>\nDisplay:</div><md-select ng-change=\"vm.refreshWorkorderList(1)\" ng-model=\"vm.itemsPerPage\" placeholder=\"Display\">\n<md-option ng-repeat=\"option in vm.displayOptions\" ng-value=\"option\">{{option}}</md-option></md-select></div></div>\n</div>");
$templateCache.put("app/main/workorders/browse-workorders/browse-workorders.html","<div style=\"width: 100%\" class=\"bg-secondary header-backgroud\" layout=\"row\" layout-align=\"center center\"><div flex \nclass=\"content-max-width content-padding-x-full\"><span class=\"h2 white-fg\">Work Orders</span></div></div><div \nstyle=\"width: 100%\" layout=\"row\" layout-align=\"center start\"><div flex \nclass=\"content-max-width content-padding-x-full py-3\"><div layout=\"row\" layout=\"start center\" layout-wrap>\n<md-input-container flex=\"100\" flex-gt-sm=\"20\" class=\"input-box-padding\"><input placeholder=\"Invoice #\" \nng-model=\"vm.invoiceNumberFilter\" ng-change=\"vm.refreshWorkorderList(1)\" ng-model-options=\"{debounce: 700}\">\n</md-input-container><md-input-container flex=\"50\" flex-gt-sm=\"20\" class=\"input-box-padding\"><label>Status</label>\n<md-select ng-model=\"vm.statusFilter\" ng-change=\"vm.refreshWorkorderList(1)\"><md-option \nng-repeat=\"status in vm.workOrderStatus | orderBy:\'status\'\" ng-value=\"status.id_work_order_status\">{{status.status}}\n</md-option><md-option ng-value=\"undefined\">All</md-option></md-select></md-input-container><md-input-container \nflex=\"50\" flex-gt-sm=\"20\" class=\"input-box-padding\"><label>Priority</label><md-select ng-model=\"vm.priorityFilter\" \nng-change=\"vm.refreshWorkorderList(1)\"><md-option ng-repeat=\"priority in vm.workOrderPriorities | orderBy:\'value\'\" \nng-value=\"priority.id_work_order_priority\">{{priority.name}}</md-option><md-option ng-value=\"undefined\">All</md-option>\n</md-select></md-input-container><md-input-container flex=\"50\" flex-gt-sm=\"20\" class=\"input-box-padding\"><label>\nLocations</label><md-select ng-model=\"vm.locationFilter\" ng-change=\"vm.refreshWorkorderList(1)\"><md-option \nng-repeat=\"location in vm.locations | orderBy:\'name\'\" ng-value=\"location.id_location\">{{location.name}}</md-option>\n<md-option ng-value=\"undefined\">All</md-option></md-select></md-input-container><md-input-container flex=\"50\" \nflex-gt-sm=\"20\" class=\"input-box-padding\"><label>Vehicle Availability</label><md-select \nng-model=\"vm.availabilityFilter\" ng-change=\"vm.refreshWorkorderList(1)\"><md-option ng-value=\"true\">Available\n</md-option><md-option ng-value=\"false\">Sold</md-option><md-option ng-value=\"undefined\">All</md-option></md-select>\n</md-input-container></div><div layout=\"row\" layout=\"start center\" layout-wrap><form name=\"saleInfoForm\" \nid=\"accordionExample\" flex=\"100\"><div class=\"card\"><div class=\"card-header\" id=\"customerSection\"><h2 class=\"mb-0\">\n<button class=\"btn btn-link btn-block text-left px-0\" type=\"button\" data-toggle=\"collapse\" \ndata-target=\"#collapseCustomerSection\" aria-expanded=\"true\" aria-controls=\"collapseCustomerSection\">Customer</button>\n</h2></div><div id=\"collapseCustomerSection\" class=\"collapse\" aria-labelledby=\"customerSection\" \ndata-parent=\"#accordionExample\"><div class=\"card-body\"><work-order-info-customer-form \non-customer-change=\"vm.onCustomerChange\"></work-order-info-customer-form></div></div></div></form></div><br><br><div \nlayout=\"row\" layout-align=\"start center\" layout-wrap style=\"font-size: 15px\"><span \nng-repeat=\"filter in vm.customFilters track by $index\" class=\"mr-2 mb-2 simple-border px-1\" \nng-class=\"vm.isCustomFilterApplied(filter) ? [\'text-secondary\'] : [\'\']\"><span ng-click=\"vm.applyCustomFilter(filter)\">\n{{filter.name}}</span> <span ng-disabled=\"vm.isDeletingCustomFilter\" stop-event class=\"ml-1 text-red\" \nng-click=\"vm.deleteCustomFilter(filter, $index)\">&times;</span></span><form class=\"mb-2\" name=\"customFilterForm\" \nng-submit=\"vm.addCustomFilter()\"><input ng-disabled=\"vm.isSavingCustomFilter\" class=\"bg-transparent\" type=\"text\" \nname=\"filterName\" ng-model=\"vm.customFilterName\" placeholder=\"Add Filter..\"></form></div><md-content>\n<work-order-summary-list vehicle-map=\"vm.vehicleMap\" workorder-priorities=\"vm.workOrderPriorities\" \nwork-order-status=\"vm.workOrderStatus\" work-order-list=\"vm.workorderList\" \ntoggle-sort-invoice-number=\"vm.toggleSortInvoiceNumber\" is-sort-invoice-desc=\"vm.isSortInvoiceDesc\">\n</work-order-summary-list></md-content><div layout=\"row\" layout-align=\"end center\"><pagination class=\"mr-3\" \nitem-per-page=\"vm.itemsPerPage\" current-page=\"vm.currentPage\" total-count=\"vm.totalCount\" \non-page-change=\"vm.refreshWorkorderList\"></pagination><div class=\"mr-3\">Total Item: {{vm.totalCount}}</div><div>\nDisplay:</div><md-select ng-change=\"vm.refreshWorkorderList(1)\" ng-model=\"vm.itemsPerPage\" placeholder=\"Display\">\n<md-option ng-repeat=\"option in vm.displayOptions\" ng-value=\"option\">{{option}}</md-option></md-select></div></div>\n</div>");
$templateCache.put("app/main/workorders/browse-workorders/work-order-info-customer-form.html","<div layout=\"column\" layout-gt-sm=\"row\" class=\"px-1\"><div flex-gt-sm=\"50\"><div flex-gt-sm=\"75\" class=\"card\" \nstyle=\"font-size: 13px\" ng-if=\"vm.customerList.length > 0\" ng-repeat=\"customer in vm.customerList\"><div layout=\"row\" \nlayout-align=\"start center\" class=\"p-2\"><div layout=\"column\"><div class=\"text-secondary\" style=\"font-size: 15px\"><a \nhref=\"{{vm.getCustomerPageUrl(customer)}}\" class=\"text-nowrap text-truncate\">\n{{customer.first_name}} {{customer.last_name}}</a></div><div class=\"text-grey\"><div layout=\"row\"><span \nclass=\"badge badge-secondary mx-0\" ng-click=\"vm.removeCusomter(customer)\">Remove</span></div></div></div><br></div>\n</div></div><div flex-gt-sm=\"50\"><md-input-container \nclass=\"pr-0 input-box info-form-item small-input-box purchase-step-payment-input-box\"><input ng-model=\"vm.searchText\" \nng-model-options=\"{ debounce: 700 }\" placeholder=\"Search Customer\" ng-change=\"vm.onSearchTextChange()\" \nautocomplete=\"off\"></md-input-container><div ng-if=\"vm.customersFound.length > 0\" style=\"font-size: 13px\"><div \nclass=\"card\"><div class=\"card-header\">Potential Matches</div><div class=\"card-body scrollable py-1\" \nstyle=\"max-height: 200px\" ms-scroll><div layout=\"column\"><div \nng-click=\"vm.selectedCustomerID = customer.getResourceID()\" layout=\"row\" class=\"pl-1 py-1 customer-found\" \nlayout-align=\"space-between center\" ng-class=\"vm.selectedCustomerID == customer.getResourceID()? [\'bg-light\']:[\'\']\" \nng-repeat=\"customer in vm.customersFound\"><span flex=\"50\" class=\"text-nowrap text-truncate\">\n{{customer.first_name}} {{customer.last_name}}</span><div layout=\"row\" class=\"mt-1 px-2\" \nng-if=\"vm.selectedCustomerID == customer.getResourceID()\"><span class=\"badge badge-secondary mr-1\" \nng-click=\"vm.goToCustomerPage(customer)\">View</span> <span class=\"badge badge-secondary mx-0\" \nng-click=\"vm.selectCusomter(customer)\">Add</span></div></div></div></div></div></div></div></div>");
$templateCache.put("app/main/workorders/browse-warranty-workorders/browse-warranty-workorders.html","<head><style>.tab {\r\n			cursor: pointer;\r\n			padding: 10px;\r\n			width: 100%;\r\n		}</style></head><div \nstyle=\"width: 100%\" class=\"bg-secondary header-backgroud\" layout=\"row\" layout-align=\"center center\"><div flex \nclass=\"content-max-width content-padding-x-full\"><span class=\"h2 white-fg\">Warranty Payment Work Orders</span></div>\n</div><div style=\"width: 100%\" layout=\"row\" layout-align=\"center start\"><div flex \nclass=\"content-max-width content-padding-x-full py-3\"><div layout=\"row\" layout=\"start center\" layout-wrap><form \nname=\"datePickerForm\" flex=\"100\" flex-gt-sm=\"50\" layout=\"row\"><md-input-container flex class=\"small-input-box\"><label>\nFrom</label><md-datepicker md-hide-icons=\"calendar\" ng-model=\"vm.startDateFilter\" md-max-date=\"vm.endDateFilter\" \nng-change=\"vm.refreshWorkorderList(1)\" name=\"startDate\"></md-datepicker><div \nng-messages=\"datePickerForm.startDate.$error\"><div ng-message=\"valid\">Invalid date.</div><div ng-message=\"maxdate\">\nMust before end date</div></div></md-input-container><md-input-container flex class=\"small-input-box\"><label>To</label>\n<md-datepicker md-hide-icons=\"calendar\" ng-model=\"vm.endDateFilter\" md-min-date=\"vm.startDateFilter\" \nng-change=\"vm.refreshWorkorderList(1)\" name=\"endDate\"></md-datepicker><div ng-messages=\"datePickerForm.endDate.$error\">\n<div ng-message=\"valid\">Invalid date.</div><div ng-message=\"mindate\">Must after start date</div></div>\n</md-input-container></form></div><div class=\"tab\">\nTotal Warranty Payment of display items: (${{vm.totaloutstanding.toFixed(2)}})</div><div class=\"tab\">\nTotal Warranty Payment of overall items: (${{vm.overall_outstanding.toFixed(2)}})</div><md-content>\n<work-order-summary-warranty-list vehicle-map=\"vm.vehicleMap\" workorder-priorities=\"vm.workOrderPriorities\" \nwork-order-status=\"vm.workOrderStatus\" work-order-list=\"vm.workorderList\" \ntoggle-sort-invoice-number=\"vm.toggleSortInvoiceNumber\" is-sort-invoice-desc=\"vm.isSortInvoiceDesc\">\n</work-order-summary-warranty-list></md-content><div layout=\"row\" layout-align=\"end center\"><pagination class=\"mr-3\" \nitem-per-page=\"vm.itemsPerPage\" current-page=\"vm.currentPage\" total-count=\"vm.totalCount\" \non-page-change=\"vm.refreshWorkorderList\"></pagination><div class=\"mr-3\">Total Item: {{vm.totalCount}}</div><div>\nDisplay:</div><md-select ng-change=\"vm.refreshWorkorderList(1)\" ng-model=\"vm.itemsPerPage\" placeholder=\"Display\">\n<md-option ng-repeat=\"option in vm.displayOptions\" ng-value=\"option\">{{option}}</md-option></md-select></div></div>\n</div>");
$templateCache.put("app/main/workorders/customer_portal_appointment/customer-portal-appointment.html","");
$templateCache.put("app/main/workorders/customer_portal_appointment/select-customer-portal-calendar-dialog.html","<div class=\"card\"><div class=\"modal-header bg-blue\"><h6 class=\"modal-title\">{{vm.calendars.title}}</h6><button \ntype=\"button\" class=\"close\" ng-click=\"vm.closeDialog()\"><span>&times;</span></button></div><div class=\"card-body\"><h1>\nAppointment Details</h1><table><tr><td>Appointment Type:</td><td>{{vm.calendars.appointment_type}}</td></tr><tr><td>\nAppointment Status:</td><td style=\"color: rgb(0, 255, 0)\">{{vm.calendars.appointment_status_name}}</td></tr><tr><td>\nCustomer Name:</td><td><a ng-click=\"vm.getCustomerUrl(vm.calendars.customer_id)\" \nstyle=\"cursor: pointer; text-decoration: underline; color: blue\">{{vm.calendars.name}}</a></td></tr><tr><td>\nCustomer Email:</td><td>{{vm.calendars.email}}</td></tr><tr><td>Customer Phone:</td><td>\n{{vm.getCustomerPhoneNumber(vm.calendars.phone)}}</td></tr><tr><td>Vehicle Name:</td><td><a \nng-click=\"vm.getVehicleUrl(vm.calendars.vehicle_id)\" style=\"cursor: pointer; text-decoration: underline; color: blue\">\n{{vm.calendars.vehicle_name}}</a></td></tr><tr><td>Start Time:</td><td>{{vm.calendars.start | date:\'medium\'}}</td></tr>\n<tr><td>End Time:</td><td>{{vm.calendars.end | date:\'medium\'}}</td></tr><tr><td>Additional Information:</td><td><div \nstyle=\"width: 200px; height: 100px; border: 1px solid rgb(110, 110, 110); overflow: auto\"><p \nstyle=\"word-wrap: break-word\">{{vm.calendars.additional_info}}</p></div></td></tr><tr \nng-if=\"vm.calendars.customer_request_information\"><td>Request Information:</td><td><div \nstyle=\"width: 200px; height: 100px; border: 1px solid rgb(110, 110, 110); overflow: auto\"><p \nstyle=\"word-wrap: break-word\">{{vm.calendars.customer_request_information}}</p></div></td></tr></table><br><md-divider>\n</md-divider></div></div>");
$templateCache.put("app/main/workorders/components/customer-contact-card-list.html","<div class=\"card\" style=\"font-size: 13px; height: 150px\"><div class=\"card-header py-1 bg-black\"><div \nclass=\"text-white font-weight-bold\" layout=\"row\" layout-align=\"space-between center\"><div><div ng-if=\"!vm.isFirst()\" \nng-click=\"vm.prev()\">&lt</div></div><a ng-href=\"{{vm.getCustomerUrl(vm.customers[vm.currentIndex].id_customer)}}\">\n{{vm.customers[vm.currentIndex].first_name + \' \' + vm.customers[vm.currentIndex].last_name}}</a><div><div \nng-if=\"!vm.isLast()\" ng-click=\"vm.next()\">&gt</div></div></div></div><div layout=\"row\" \nlayout-align=\"space-between start\" class=\"card-body\"><md-content><div \nng-if=\"!vm.customerMap[vm.customers[vm.currentIndex].id_customer].isLoading && !(vm.customerMap[vm.customers[vm.currentIndex].id_customer].customerDetail.phone_numbers.length > 0) && !(vm.customerMap[vm.customers[vm.currentIndex].id_customer].customerDetail.emails.length > 0)\">\nNo contact infos</div><div ng-if=\"vm.customerMap[vm.customers[vm.currentIndex].id_customer].isLoading\">loading...</div>\n<div layout=\"row\" layout-align=\"start center\" \nng-repeat=\"item in vm.customerMap[vm.customers[vm.currentIndex].id_customer].customerDetail.phone_numbers\"><div \nclass=\"text-grey\" style=\"width: 50px\">{{vm.getPhoneCategory(item.fk_id_phone_category)}}</div><span>\n{{vm.translateToPhoneString(item.phone_number)}}</span><goto-dial-button phone-number=\"item.phone_number\" \ndisplay-name=\"vm.customers[vm.currentIndex].first_name + \' \' + vm.customers[vm.currentIndex].last_name\">\n</goto-dial-button></div><div class=\"mt-2\" layout=\"row\" \nng-if=\"vm.customerMap[vm.customers[vm.currentIndex].id_customer].customerDetail.emails[0]\"><div class=\"text-grey\" \nstyle=\"width: 50px\">Email</div><a \nng-href=\"{{\'mailto:\' + vm.customerMap[vm.customers[vm.currentIndex].id_customer].customerDetail.emails[0].email_address}}\">\n{{vm.customerMap[vm.customers[vm.currentIndex].id_customer].customerDetail.emails[0].email_address}}</a></div><div \nclass=\"mt-2\" layout=\"row\" \nng-if=\"vm.customerMap[vm.customers[vm.currentIndex].id_customer].customerDetail.getFullAddress()\"><div \nclass=\"text-grey\" flex=\"noshrink\" style=\"width: 50px\">Address</div><a class=\"text-nowrap text-truncate\" \ntarget=\"_blank\" \nng-href=\"{{\'https://www.google.ca/maps/place/\' + vm.customerMap[vm.customers[vm.currentIndex].id_customer].customerDetail.getFullAddress()}}\">\n{{vm.customerMap[vm.customers[vm.currentIndex].id_customer].customerDetail.getFullAddress()}}</a></div></md-content>\n</div></div>");
$templateCache.put("app/main/workorders/components/labor-table.html","<table class=\"table table-hover\" style=\"table-layout: fixed;width:100%; min-width:500px\"><thead><tr><th \nclass=\"text-nowrap bg-light\" style=\"width: 35px\"><md-checkbox ng-disabled=\"vm.disableEditing\" \nng-if=\"vm.laborList.length > 0 && vm.selectable\" ng-checked=\"vm.isAllSelected()\" ng-click=\"vm.selectAll()\" \nclass=\"m-0 p-0\"></md-checkbox></th><th class=\"text-nowrap bg-light\">Preset Labour</th><th class=\"text-nowrap bg-light\">\nDescription</th><th class=\"text-nowrap bg-light\" style=\"width: 100px\">Time(hour)</th><th class=\"text-nowrap bg-light\" \nstyle=\"width: 100px\">Rate</th></tr></thead><tbody><tr ng-repeat=\"item in vm.laborList track by $index\" ng-click \ntabindex=\"-1\" ng-focus=\"vm.onRowFocus($index, item.laborData.is_returned)\" ng-blur=\"vm.onRowBlur()\" \nid=\"{{\'laborRow\' + $index}}\" \nng-style=\"vm.getWorkOrderJobIdFromItemId(item, vm.workOrderJobList , $index, vm.colorCache)\" \nname=\"{{\'labourTableRow\' + $index}}\"><td ng-if=\"vm.selectable\"><md-checkbox ng-disabled=\"vm.disableEditing\" \nng-blur=\"vm.onInputBlur()\" ng-focus=\"vm.onRowFocus($index, part.is_returned); vm.onInputFocus($index);\" \nclass=\"m-0 p-0\" tabindex=\"-1\" ng-model=\"item.isSelected\"></md-checkbox></td><td style=\"position: relative\"><div \nid=\"{{\'labourRowName\' + $index}}\" ng-if=\"vm.focusIndex != $index || vm.disableEditing\" \nclass=\"text-nowrap text-truncate mb-2 mt-3\" ng-class=\"item.laborData.fk_id_labour_type ? []:[\'text-grey\']\">\n{{vm.getLabourTypeNameById(item.laborData.fk_id_labour_type)}}</div><div layout=\"row\" \nng-if=\"vm.focusIndex == $index && !vm.disableEditing\"><select ng-change=\"vm.onlabourtypechange({{$index}})\" \nid=\"{{\'labourRowTypes\' + $index}}\" flex name=\"fk_id_labour_type\" ng-focus=\"vm.onInputFocus($index)\" \nng-blur=\"vm.onInputBlur()\" class=\"m-0 pl-2 py-2\" ng-model=\"item.laborData.fk_id_labour_type\" input-control>\n{{onlaborrowclick($index)}}</select></div><div style=\"position: absolute;bottom: 0%;font-size: 12px\" class=\"text-red\" \nng-if=\"!item.laborData.fk_id_labour_type\">Required</div></td><td style=\"position: relative\"><div \nng-if=\"vm.focusIndex != $index || vm.disableEditing\" class=\"text-nowrap text-truncate mb-2 mt-3\" \nng-class=\"item.laborData.name ? []:[\'text-grey\']\">{{item.laborData.name}}</div><div layout=\"row\" \nng-if=\"vm.focusIndex == $index && !vm.disableEditing\"><input id=\"{{\'laborRowName\' + $index}}\" autocorrect=\"off\" \nautocapitalize=\"none\" spellcheck=\"false\" autocomplete=\"off\" flex name=\"name\" ng-focus=\"vm.onInputFocus($index)\" \nng-blur=\"vm.onInputBlur()\" class=\"m-0 pl-2 py-2\" ng-model=\"item.laborData.name\" placeholder=\"Description\" \nmaxlength=\"250\" input-control input-translate=\"vm.allInitCapitalizeTranslator\" \nng-change=\"vm.onlabourtextchange({{$index}})\"></div><div style=\"position: absolute;bottom: 0%;font-size: 12px\" \nclass=\"text-red\" ng-if=\"!item.laborData.name\">Required</div></td><td style=\"position: relative\"><div \nng-if=\"vm.focusIndex != $index || vm.disableEditing\" class=\"text-nowrap text-truncate mb-2 mt-3\" \nng-class=\"item.laborData.hour == null ? [\'text-grey\']:[]\">{{item.laborData.hour}}</div><div layout=\"row\" \nng-if=\"vm.focusIndex == $index && !vm.disableEditing\"><input autocorrect=\"off\" autocapitalize=\"none\" \nspellcheck=\"false\" autocomplete=\"off\" flex placeholder=\"Quantity\" ng-focus=\"vm.onInputFocus($index)\" \nng-blur=\"vm.onInputBlur()\" class=\"m-0 pl-2 py-2\" ng-model=\"item.laborData.hour\" input-control \ninput-translate=\"vm.decimalTranslator\" input-options=\"vm.hourInputOption\" maxlength=\"4\"></div><div \nstyle=\"position: absolute;bottom: 0%;font-size: 12px\" class=\"text-red\" ng-if=\"item.laborData.hour == null\">Required\n</div></td><td style=\"position: relative\"><div ng-if=\"vm.focusIndex != $index || vm.disableEditing\" \nclass=\"text-nowrap text-truncate mb-2 mt-3\" ng-class=\"item.laborData.price == null ? [\'text-grey\']:[]\">\n{{item.laborData.price | currency:\'$\':\'2\'}}</div><div layout=\"row\" \nng-if=\"vm.focusIndex == $index && !vm.disableEditing\"><input autocorrect=\"off\" autocapitalize=\"none\" \nspellcheck=\"false\" autocomplete=\"off\" flex name=\"price\" placeholder=\"Rate\" ng-focus=\"vm.onInputFocus($index)\" \nng-blur=\"vm.onInputBlur()\" class=\"m-0 pl-2 py-2\" ng-model=\"item.laborData.price\" input-control \ninput-translate=\"vm.translateToDollar\" maxlength=\"10\"></div><div style=\"position: absolute;bottom: 0%;font-size: 12px\" \nclass=\"text-red\" ng-if=\"item.laborData.price == null\">Required</div></td></tr><tr ng-click=\"vm.addNewRow()\" \nng-if=\"!vm.hideAdding\"><td ng-if=\"vm.selectable\"><md-checkbox ng-disabled=\"vm.disableEditing\" class=\"m-0 p-0\" \nng-model=\"vm.defaultCheckBox\" ng-focus=\"vm.addNewRow()\"></md-checkbox></td><td><div \nclass=\"text-nowrap text-truncate mb-2 mt-3 text-grey\">Labor Types</div></td><td><div \nclass=\"text-nowrap text-truncate mb-2 mt-3 text-grey\">Description</div></td><td><div \nclass=\"text-nowrap text-truncate mb-2 mt-3 text-grey\">Quantity</div></td><td><div \nclass=\"text-nowrap text-truncate mb-2 mt-3 text-grey\">Rate</div></td></tr></tbody></table>");
$templateCache.put("app/main/workorders/components/miscfee-table.html","<table class=\"table table-hover\" style=\"table-layout: fixed;width:100%; min-width:500px\"><thead><tr><th \nclass=\"text-nowrap bg-light\" style=\"width: 35px\"><md-checkbox ng-disabled=\"vm.disableEditing\" \nng-if=\"vm.miscfeestypeslist.length > 0 && vm.selectable\" ng-checked=\"vm.isAllSelected()\" ng-click=\"vm.selectAll()\" \nclass=\"m-0 p-0\"></md-checkbox></th><th class=\"text-nowrap bg-light\">Preset Misc Fees</th><th \nclass=\"text-nowrap bg-light\">Description</th><th class=\"text-nowrap bg-light\" style=\"width: 100px\">Quantity</th><th \nclass=\"text-nowrap bg-light\" style=\"width: 100px\">Rate</th></tr></thead><tbody><tr \nng-repeat=\"item in vm.miscfeestypeslist track by $index\" ng-click tabindex=\"-1\" \nng-focus=\"vm.onRowFocus($index, item.MiscFees.is_returned)\" ng-blur=\"vm.onRowBlur()\" id=\"{{\'miscfeesRow\' + $index}}\" \nng-style=\"vm.getWorkOrderJobIdFromItemId(item, vm.workOrderJobList , $index, vm.colorCache)\" \nname=\"{{\'miscfeesTableRow\' + $index}}\"><td ng-if=\"vm.selectable\"><md-checkbox ng-disabled=\"vm.disableEditing\" \nng-blur=\"vm.onInputBlur()\" ng-focus=\"vm.onRowFocus($index, part.is_returned); vm.onInputFocus($index);\" \nclass=\"m-0 p-0\" ng-model=\"item.isSelected\"></md-checkbox></td><td style=\"position: relative\"><div \nid=\"{{\'miscfeeRowName\' + $index}}\" ng-if=\"vm.focusIndex != $index || vm.disableEditing\" \nclass=\"text-nowrap text-truncate mb-2 mt-3\" ng-class=\"item.MiscFees.fk_misc_fees_type ? []:[\'text-grey\']\">\n{{vm.getMiscFeesTypeNameById(item.MiscFees.fk_misc_fees_type)}}</div><div layout=\"row\" \nng-if=\"vm.focusIndex == $index && !vm.disableEditing\"><select ng-change=\"vm.onmiscfeestypechange({{$index}})\" \nid=\"{{\'miscfeesRowTypes\' + $index}}\" ng-focus=\"vm.onTypeInputFocus($index)\" ng-blur=\"vm.onInputBlur()\" \nclass=\"m-0 pl-2 py-2\" ng-options=\"option.name for option in vm.allmiscfeestypeslist track by option.id_miscfee\" \nng-model=\"vm.typeselected\"><option value=\"\">{{vm.getMiscFeesTypeNameById(item.MiscFees.fk_misc_fees_type)}}</option>\n</select></div><div style=\"position: absolute;bottom: 0%;font-size: 12px\" class=\"text-red\" \nng-if=\"!item.MiscFees.fk_misc_fees_type\">Required</div></td><td style=\"position: relative\"><div \nng-if=\"vm.focusIndex != $index || vm.disableEditing\" class=\"text-nowrap text-truncate mb-2 mt-3\" \nng-class=\"item.MiscFees.name ? []:[\'text-grey\']\">{{item.MiscFees.name}}</div><div layout=\"row\" \nng-if=\"vm.focusIndex == $index && !vm.disableEditing\"><input id=\"{{\'miscfeesRowName\' + $index}}\" autocorrect=\"off\" \nautocapitalize=\"none\" spellcheck=\"false\" autocomplete=\"off\" flex name=\"name\" ng-focus=\"vm.onInputFocus($index)\" \nng-blur=\"vm.onInputBlur()\" class=\"m-0 pl-2 py-2\" ng-model=\"item.MiscFees.name\" placeholder=\"Description\" \nmaxlength=\"250\" input-control input-translate=\"vm.allInitCapitalizeTranslator\"></div><div \nstyle=\"position: absolute;bottom: 0%;font-size: 12px\" class=\"text-red\" ng-if=\"!item.MiscFees.name\">Required</div></td>\n<td style=\"position: relative\"><div ng-if=\"vm.focusIndex != $index || vm.disableEditing\" \nclass=\"text-nowrap text-truncate mb-2 mt-3\" ng-class=\"item.MiscFees.quantity == null ? [\'text-grey\']:[]\">\n{{item.MiscFees.quantity}}</div><div layout=\"row\" ng-if=\"vm.focusIndex == $index && !vm.disableEditing\"><input \nautocorrect=\"off\" autocapitalize=\"none\" spellcheck=\"false\" autocomplete=\"off\" flex placeholder=\"Quantity\" \nng-focus=\"vm.onInputFocus($index)\" ng-blur=\"vm.onInputBlur()\" class=\"m-0 pl-2 py-2\" ng-model=\"item.MiscFees.quantity\" \ninput-control input-translate=\"vm.decimalTranslator\" input-options=\"vm.hourInputOption\" maxlength=\"4\"></div><div \nstyle=\"position: absolute;bottom: 0%;font-size: 12px\" class=\"text-red\" ng-if=\"item.MiscFees.quantity == null\">Required\n</div></td><td style=\"position: relative\"><div ng-if=\"vm.focusIndex != $index || vm.disableEditing\" \nclass=\"text-nowrap text-truncate mb-2 mt-3\" ng-class=\"item.MiscFees.price == null ? [\'text-grey\']:[]\">\n{{item.MiscFees.price | currency:\'$\':\'2\'}}</div><div layout=\"row\" \nng-if=\"vm.focusIndex == $index && !vm.disableEditing\"><input autocorrect=\"off\" autocapitalize=\"none\" \nspellcheck=\"false\" autocomplete=\"off\" flex name=\"price\" placeholder=\"Rate\" ng-focus=\"vm.onInputFocus($index)\" \nng-blur=\"vm.onInputBlur()\" class=\"m-0 pl-2 py-2\" ng-model=\"item.MiscFees.price\" input-control \ninput-translate=\"vm.translateToDollar\" maxlength=\"10\"></div><div style=\"position: absolute;bottom: 0%;font-size: 12px\" \nclass=\"text-red\" ng-if=\"item.MiscFees.price == null\">Required</div></td></tr><tr ng-click=\"vm.addNewRow()\" \nng-if=\"!vm.hideAdding\"><td ng-if=\"vm.selectable\"><md-checkbox ng-disabled=\"vm.disableEditing\" class=\"m-0 p-0\" \nng-model=\"vm.defaultCheckBox\" ng-focus=\"vm.addNewRow()\"></md-checkbox></td><td><div \nclass=\"text-nowrap text-truncate mb-2 mt-3 text-grey\">Misc Types</div></td><td><div \nclass=\"text-nowrap text-truncate mb-2 mt-3 text-grey\">Description</div></td><td><div \nclass=\"text-nowrap text-truncate mb-2 mt-3 text-grey\">Quantity</div></td><td><div \nclass=\"text-nowrap text-truncate mb-2 mt-3 text-grey\">Rate</div></td></tr></tbody></table>");
$templateCache.put("app/main/workorders/components/purchase-invoice-section.html","<div layout=\"row\" layout-align=\"start center\"><md-input-container flex \nclass=\"small-selector purchase-step-selector input-box-padding\"><label>Supplier</label><md-select \nng-model=\"vm.supplierID\" ng-change=\"vm.queryInvoice()\" placeholder=\"Supplier\"><md-option \nng-repeat=\"item in vm.suppliers\" ng-value=\"{{::item.id_supplier}}\">{{::item.name}}</md-option><md-option \nng-value=\"undefined\">All</md-option></md-select></md-input-container><input flex class=\"input-box-padding\" \nng-change=\"vm.queryInvoice()\" ng-model-options=\"{ debounce: 700 }\" maxlength=\"20\" ng-model=\"vm.invoiceNumber\" \nplaceholder=\"Invoice Number\"></div><div ng-if=\"vm.invoiceNumber\"><md-divider></md-divider><div class=\"px-2\"><div \nlayout=\"row\" class=\"my-1\" layout-align=\"space-between center\" \nng-repeat=\"invoice in vm.matchedInvoices track by $index\"><span>{{vm.getInvoiceSupplier(invoice.fk_id_supplier)}} <a \nng-href=\"{{vm.getInvoiceLink(invoice.id_purchase_invoice)}}\" class=\"mr-2\">{{invoice.invoice_number}}</a></span><div>\n<span class=\"badge badge-secondary\" ng-click=\"vm.selectInvoice(invoice)\">Select</span></div></div><div class=\"my-1\" \nng-if=\"!(vm.matchedInvoices.length > 0) && !vm.isCreating\">No item found, <span class=\"text-secondary\" \nng-click=\"vm.createInvoice()\">create invoice {{vm.invoiceNumber}}</span></div><div class=\"my-1\" \nng-if=\"!(vm.matchedInvoices.length > 0) && vm.isCreating\">Creating...</div></div><md-divider></md-divider></div>");
$templateCache.put("app/main/workorders/components/redeem-item-list.html","<div ng-repeat=\"(saleInfoID, data) in vm.packageDatas track by $index\" class=\"mb-1\"><div \nclass=\"font-weight-bold text-grey\">{{data.packageData.name}}<br>Expiry Date: {{data.packageData.expiry_date || \"None\"}}\n</div><md-divider class=\"my-1\"></md-divider><div ng-repeat=\"item in data.packageItems\"><div layout=\"row\" \nlayout-align=\"space-between center\"><div>{{item.name}} ({{item.quantity}}/{{item.origin_quantity}})<br>\n(Current Mileage:{{vm.saleInfo.mileage || 0}} / Coverage Mileage: {{item.covering_mileage || 0}})</div><button \nng-if=\"item.quantity > 0 && (item.covering_mileage > vm.saleInfo.mileage || item.covering_mileage == 0 || item.covering_mileage == null)\" \nng-disabled=\"vm.disableRedeem\" class=\"text-secondary\" ng-click=\"vm.onRedeemClick(data.packageData, item)\">Redeem\n</button></div></div><div ng-if=\"!(data.packageItems.length > 0)\">No item foundd</div></div><div \nng-if=\"!vm.anyItemAvailable()\">No item available.</div>");
$templateCache.put("app/main/workorders/components/return-invoice-section.html","<div layout=\"row\" layout-align=\"start center\"><md-input-container flex \nclass=\"small-selector purchase-step-selector input-box-padding\"><label>Supplier</label><md-select \nng-disabled=\"vm.disableSupplier\" ng-model=\"vm.supplierId\" ng-change=\"vm.queryInvoice()\" placeholder=\"Supplier\">\n<md-option ng-repeat=\"item in vm.suppliers\" ng-value=\"{{::item.id_supplier}}\">{{::item.name}}</md-option><md-option \nng-value=\"undefined\">All</md-option></md-select></md-input-container><input flex class=\"input-box-padding\" \nng-change=\"vm.queryInvoice()\" ng-model-options=\"{ debounce: 700 }\" maxlength=\"20\" ng-model=\"vm.invoiceNumber\" \nplaceholder=\"Invoice Number\"></div><div ng-if=\"vm.invoiceNumber\"><md-divider></md-divider><div class=\"px-2\"><div \nlayout=\"row\" class=\"my-1\" layout-align=\"space-between center\" \nng-repeat=\"invoice in vm.matchedInvoices track by $index\"><span>{{vm.getInvoiceSupplier(invoice.fk_id_supplier)}} <a \nng-href=\"{{vm.getInvoiceLink(invoice.id_return_invoice)}}\" class=\"mr-2\">{{invoice.invoice_number}}</a></span><div><span\n class=\"badge badge-secondary\" ng-click=\"vm.selectInvoice(invoice)\">Select</span></div></div><div class=\"my-1\" \nng-if=\"!(vm.matchedInvoices.length > 0) && !vm.isCreating\">No item found, <span class=\"text-secondary\" \nng-click=\"vm.createInvoice()\">create invoice {{vm.invoiceNumber}}</span></div><div class=\"my-1\" \nng-if=\"!(vm.matchedInvoices.length > 0) && vm.isCreating\">Creating...</div></div><md-divider></md-divider></div>");
$templateCache.put("app/main/workorders/components/workorder-appointment-list.html","<md-content><table class=\"table strike-able table-hover\" style=\"table-layout: fixed;width:100%; min-width:700px\">\n<thead><tr><th class=\"text-nowrap bg-light\" style=\"width: 35px\"><md-checkbox ng-disbaled=\"vm.disableEditing\" \nng-if=\"vm.appointments.length > 0\" ng-checked=\"vm.isAllSelected()\" ng-click=\"vm.selectAll()\" class=\"m-0 p-0\">\n</md-checkbox></th><th class=\"text-nowrap bg-light\" style=\"width:100%\">Description</th><th \nclass=\"text-nowrap bg-light\" style=\"width: 150px\">Status</th><th class=\"text-nowrap bg-light\" style=\"width: 230px\">Time\n</th></tr></thead><tbody><tr ng-repeat=\"appointment in vm.appointments\"><td><md-checkbox \nng-disbaled=\"vm.disableEditing\" class=\"m-0 p-0\" ng-model=\"vm.selectedMap[appointment.id_work_order_appointment]\">\n</md-checkbox></td><td><a ng-href=\"{{vm.getScheduleUrl(appointment)}}\">{{::appointment.title}}</a></td><td><div \nlayout=\"row\"><md-select flex ng-disbaled=\"vm.disableEditing\" ng-change=\"vm.onStatusChanged(appointment)\" \nclass=\"small-selector purchase-step-selector m-0\" ng-model=\"appointment.fk_id_appointment_status\" placeholder=\"Status\">\n<md-option ng-repeat=\"status in vm.appointmentStatus\" ng-value=\"{{::status.id_appointment_status}}\">{{::status.name}}\n</md-option><md-option ng-value=\"null\">NONE</md-option></md-select></div></td><td><div layout=\"row\" \nlayout-align=\"space-between center\"><div><div>Form:</div><div>To:</div></div><div class=\"text-right\"><div>\n{{::appointment.end | date:vm.dateFormat}}</div><div>{{::appointment.start | date:vm.dateFormat}}</div></div></div>\n</td></tr><tr ng-if=\"!(vm.appointments.length > 0)\"><td colspan=\"100%\">No item found.</td></tr></tbody></table>\n</md-content>");
$templateCache.put("app/main/workorders/components/workorder-completed-warranty.html","<div class=\"card\"><div class=\"card-body\" ng-repeat=\"item in vm.warranty\"><div layout=\"row\" layout-align=\"start center\">\n<div class=\"font-weight-bold\">{{item.name}}</div></div><div class=\"mr-3 mb-2\" layout=\"row\" layout-align=\"start center\">\n<div>{{item.description}}</div></div><div layout=\"row\" layout-align=\"start center\"><div class=\"font-weight-bold\">\nMaximum Warranty Payment per Claim</div></div><div class=\"mr-3 mb-2\" layout=\"row\" layout-align=\"start center\"><div>\n${{item.max_claim}}</div></div><div layout=\"row\" layout-align=\"start center\"><div class=\"font-weight-bold\">\nCovered Milage:</div></div><p>{{vm.getCoveredMile(item.duration_mileage, item.mileage)}}</p><div layout=\"row\" \nlayout-align=\"start center\"><div class=\"font-weight-bold\">Current Milage:</div></div><p>{{item.mileage}}</p><div \nlayout=\"row\" layout-align=\"start center\"><div class=\"font-weight-bold\">Expiry Date:</div></div><p>\n{{vm.getExpiryDate(item.duration_month)}}</p><div layout=\"row\" layout-align=\"start center\"><div \nclass=\"font-weight-bold\">Current Date:</div></div><p>{{vm.currentdate}}</p><md-divider></md-divider></div></div>");
$templateCache.put("app/main/workorders/components/workorder-coupons-list.html","<md-divider class=\"form-divider-horizontal\"></md-divider>Coupons<md-content><table \nclass=\"table strike-able table-hover\" style=\"table-layout: fixed;width:100%; min-width:200px\"><thead><tr><th \nclass=\"text-nowrap bg-light\" style=\"width: 35px\"><md-checkbox ng-if=\"vm.discounts.length > 0\" \nng-checked=\"vm.isAllSelected()\" ng-click=\"vm.selectAll()\" class=\"m-0 p-0\"></md-checkbox></th><th \nclass=\"text-nowrap bg-light\">Description</th><th class=\"text-nowrap bg-light\" style=\"width: 120px\">Amount</th></tr>\n</thead><tbody><tr ng-repeat=\"discount in vm.discounts\"><td><md-checkbox class=\"m-0 p-0\" \nng-model=\"vm.selectedMap[discount.id_work_order_discount]\"></md-checkbox></td><td>{{discount.description}}</td><td><div\n ng-if=\"discount.is_percentage\">-{{discount.percentage_off * 100}}%</div><div ng-if=\"!discount.is_percentage\">\n-{{discount.amount_off | currency:\'$\':2}}</div></td></tr><tr ng-if=\"!(vm.discounts.length > 0)\"><td colspan=\"3\">\nNo item found.</td></tr></tbody></table></md-content>");
$templateCache.put("app/main/workorders/components/workorder-customer-portal-appointment-list.html","<md-content><table class=\"table strike-able table-hover\" style=\"table-layout: fixed;width:100%; min-width:700px\">\n<thead><tr><th class=\"text-nowrap bg-light\" style=\"width: 35px\"><md-checkbox ng-disbaled=\"vm.disableEditing\" \nng-if=\"vm.appointments.length > 0\" ng-checked=\"vm.isAllSelected()\" ng-click=\"vm.selectAll()\" class=\"m-0 p-0\">\n</md-checkbox></th><th class=\"text-nowrap bg-light\" style=\"width:100%\">Description</th><th \nclass=\"text-nowrap bg-light\" style=\"width: 150px\">Status</th><th class=\"text-nowrap bg-light\" style=\"width: 230px\">Time\n</th></tr></thead><tbody><tr ng-repeat=\"appointment in vm.appointments\"><td><md-checkbox \nng-disbaled=\"vm.disableEditing\" class=\"m-0 p-0\" ng-model=\"vm.selectedMap[appointment.id_work_order_appointment]\">\n</md-checkbox></td><td><a ng-href=\"{{vm.getScheduleUrl(appointment)}}\">{{::appointment.appointment_type_name}}</a></td>\n<td><div layout=\"row\">{{appointment.appointment_status_name}}</div></td><td><div layout=\"row\" \nlayout-align=\"space-between center\"><div><div>Form:</div><div>To:</div></div><div class=\"text-right\"><div>\n{{::appointment.end | date:vm.dateFormat}}</div><div>{{::appointment.start | date:vm.dateFormat}}</div></div></div>\n</td></tr><tr ng-if=\"!(vm.appointments.length > 0)\"><td colspan=\"100%\">No item found.</td></tr></tbody></table>\n</md-content>");
$templateCache.put("app/main/workorders/components/workorder-discounts-list.html","<md-content><table class=\"table strike-able table-hover\" style=\"table-layout: fixed;width:100%; min-width:200px\">\n<thead><tr><th class=\"text-nowrap bg-light\" style=\"width: 35px\"><md-checkbox ng-if=\"vm.discounts.length > 0\" \nng-checked=\"vm.isAllSelected()\" ng-click=\"vm.selectAll()\" class=\"m-0 p-0\"></md-checkbox></th><th \nclass=\"text-nowrap bg-light\">Description</th><th class=\"text-nowrap bg-light\" style=\"width: 120px\">Amount</th></tr>\n</thead><tbody><tr ng-repeat=\"discount in vm.discounts\"><td><md-checkbox class=\"m-0 p-0\" \nng-model=\"vm.selectedMap[discount.id_work_order_discount]\"></md-checkbox></td><td>{{discount.description}}</td><td><div\n ng-if=\"discount.is_percentage\">-{{discount.percentage_off * 100}}%</div><div ng-if=\"!discount.is_percentage\">\n-{{discount.amount_off | currency:\'$\':2}}</div></td></tr><tr ng-if=\"!(vm.discounts.length > 0)\"><td colspan=\"3\">\nNo item found.</td></tr></tbody></table></md-content>");
$templateCache.put("app/main/workorders/components/workorder-info-form.html","<form name=\"workOrderInfoForm\" layout=\"row\" layout-wrap style=\"font-size: 13px\"><md-input-container flex=\"50\" \nclass=\"input-box small-input-box\"><input name=\"mileage\" ng-model=\"vm.workOrder.mileage\" autocomplete=\"off\" \nplaceholder=\"Mileage\" maxlength=\"10\" ng-disabled=\"vm.isProcessingData || vm.disabledInputs.mileage\" input-control \ninput-translate=\"vm.translateToNumber\" input-options=\"vm.numberInputOption\"><div \nng-messages=\"workOrderInfoForm.mileage.$error\"><div ng-message=\"maxlength\">Input content can not be over 10 charactors\n</div></div></md-input-container><md-input-container flex=\"50\" class=\"input-box small-input-box\"><label>Priority\n</label><md-select ng-model=\"vm.workOrder.fk_id_work_order_priority\" \nng-disabled=\"vm.isProcessingData || vm.disabledInputs.priority\"><md-option \nng-repeat=\"priority in vm.workOrderPriorities | orderBy:\'value\'\" ng-value=\"priority.id_work_order_priority\">\n{{priority.name}}</md-option></md-select></md-input-container><md-input-container flex=\"50\" \nclass=\"input-box small-input-box\"><label>Quote Date</label><md-datepicker \nng-disabled=\"vm.isProcessingData || vm.disabledInputs.quotedDate\" md-hide-icons=\"calendar\" \nng-model=\"vm.quoteDatePickerValue\" ng-change=\"vm.setQuoteDate()\" name=\"quoteDate\"></md-datepicker><div \nng-messages=\"workOrderInfoForm.quoteDate.$error\"><div ng-message=\"valid\">Invalid date.</div></div></md-input-container>\n<div flex=\"50\"><div layout=\"row\" layout-align=\"space-between center\"><md-input-container \nclass=\"input-box small-input-box\"><label>Completed Date</label><md-datepicker \nng-disabled=\"vm.isProcessingData || vm.disabledInputs.completedDate\" md-hide-icons=\"calendar\" \nng-model=\"vm.completeDatePickerValue\" ng-change=\"vm.setCompleteDate(vm.completeDatePickerValue)\" name=\"completeDate\">\n</md-datepicker><div ng-messages=\"workOrderInfoForm.completeDate.$error\"><div ng-message=\"valid\">\nDate format should be MM/DD/YYYY.</div></div></md-input-container><i \nng-click=\"vm.showCompleteTimePicker = !vm.showCompleteTimePicker\" class=\"icon-av-timer mb-4\"></i></div><div \nng-show=\"vm.showCompleteTimePicker\" moment-picker=\"vm.completeTimePickerValue\" format=\"{{::vm.timePickerFormat}}\" \nshow-header=\"false\" set-on-select=\"true\" max-view=\"minute\" min-view=\"day\" \nchange=\"vm.setCompleteTime(vm.completeTimePickerValue)\"><md-input-container class=\"input-box small-input-box\"><input \nng-disabled=\"vm.isProcessingData || vm.disabledInputs.completedDate\" name=\"completeTime\" placeholder=\"Completed Time\" \nng-model=\"vm.completeTimePickerValue\" ng-model-options=\"{ updateOn: \'blur\' }\" \nng-change=\"vm.setCompleteTime(vm.completeTimePickerValue)\"></md-input-container></div></div></form>");
$templateCache.put("app/main/workorders/components/workorder-job-type.html","<div class=\"card\"><div class=\"card-body\"><div \nng-repeat=\"option in vm.JobTypeList | orderBy:\'JobType.name\' track by $index\" class=\"mb-1\"><div layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><div class=\"font-weight-bold\">\n{{option.JobType.name}}</div><i ng-click=\"option.showDetail = !option.showDetail\" \nng-class=\"option.showDetail ? [\'icon-menu-up\']:[\'icon-arrow-down-drop\']\"></i></div><div class=\"text-secondary\" \nng-click=\"vm.onAddClick(option.JobType)\">Add</div></div><div ng-if=\"option.showDetail\" style=\"font-size: 12px\"><p \nclass=\"text-grey font-italic\" ng-if=\"option.JobType.for_customer_portal\">For Customer Portal</p><div \nng-repeat=\"items in option\"><div ng-repeat=\"job_part in items.job_part\"><div class=\"text-grey font-italic\">\n{{job_part.part_name}}</div><div class=\"mr-3 mb-2\" layout=\"row\" layout-align=\"start center\" ng-if=\"job_part.part_name\">\n<md-checkbox class=\"m-0 p-0\" ng-model=\"job_part.isSelected\"></md-checkbox><div>\n{{job_part.part_name}} ({{job_part.part_code}})<span ng-if=\"job_part.part_quantity\"> * {{job_part.part_quantity}}\n</span></div></div></div></div><div ng-repeat=\"items in option\"><div ng-if=\"items.job_labour[0].fk_id_labourtype\"><div \nclass=\"text-grey font-italic\">Labors</div><md-divider class=\"mb-1\"></md-divider><div \nng-repeat=\"labour in items.job_labour\" layout=\"row\" layout-align=\"start center\" class=\"mb-2\"><md-checkbox \nclass=\"m-0 p-0\" ng-model=\"labour.isSelected\"></md-checkbox><div>{{labour.labour_name}}<span \nng-if=\"labour.labour_quantity\"> * {{labour.labour_quantity}}</span></div></div></div></div><div \nng-repeat=\"items in option\"><div ng-if=\"items.job_miscfee[0].fk_id_miscfeestype\"><div class=\"text-grey font-italic\">\nMisc fees</div><md-divider class=\"mb-1\"></md-divider><div ng-repeat=\"miscfee in items.job_miscfee\" layout=\"row\" \nlayout-align=\"start center\" class=\"mb-2\"><md-checkbox class=\"m-0 p-0\" ng-model=\"miscfee.isSelected\"></md-checkbox><div>\n{{miscfee.miscfees_name}}<span ng-if=\"miscfee.miscfees_quantity\"> * {{miscfee.miscfees_quantity}}</span></div></div>\n</div></div></div></div></div></div>");
$templateCache.put("app/main/workorders/components/workorder-mechanic-section.html","<md-divider></md-divider><div class=\"px-2\"><div ng-repeat=\"mechanic in vm.mechanics\" layout=\"row\" \nlayout-align=\"space-between center\" class=\"my-1\"><div>{{mechanic.first_name + \' \' + mechanic.last_name}}</div><button \nng-if=\"!vm.disableDeleting\" ng-disabled=\"vm.isProcessing\" ng-click=\"vm.onRemoveMechanic(mechanic, $index)\" \nng-class=\"vm.isProcessing ? [text-grey]:[\'text-red\']\">&#x2715</button></div><div class=\"my-1\" \nng-if=\"!(vm.mechanics.length > 0)\">No mechanic found</div></div><md-divider></md-divider><div class=\"mt-3\" \nlayout=\"row\" layout-align=\"space-between center\" ng-if=\"!vm.disableAdding\"><md-autocomplete flex=\"100\" \nmd-no-cache=\"false\" md-select-on-focus=\"true\" md-selected-item=\"vm.selectedMechanic\" md-search-text=\"vm.searchText\" \nmd-selected-item-change=\"vm.addMechanic()\" md-delay=\"700\" md-select-on-focus=\"true\" \nmd-items=\"mechanic in vm.queryMechanic(vm.searchText)\" md-item-text=\"mechanic.first_name + \' \' + mechanic.last_name\" \nplaceholder=\"Search Mechanic\" md-menu-class=\"vehicle-search-menu\" md-menu-container-class=\"vehicle-search-container\">\n<md-item-template>{{mechanic.first_name + \' \' + mechanic.last_name}}</md-item-template><md-not-found>No user found\n</md-not-found></md-autocomplete></div>");
$templateCache.put("app/main/workorders/components/workorder-package-list.html","<div class=\"card\" style=\"font-size: 13px\"><div class=\"card-body\" style=\"overflow: auto;white-space: nowrap\"><div \nng-class=\"package.isPurchased ? []:[\'raised-box\']\" class=\"text-left p-2 ml-1 mr-4 my-2 simple-border\" \nclass=\"p-2 ml-1 mr-4\" style=\"min-width: 150px; min-height: 160px;display: inline-block\" \nng-repeat=\"package in vm.packageList\"><div layout=\"column\" layout-algin=\"space-between center\" layout-fill><div \nflex=\"grow\"><div style=\"font-size: 15px\" class=\"text-nowrap text-truncate mb-1 font-weight-bold\"><span \nng-if=\"package.expired\" class=\"text-red\">(Expired)</span> {{package.name}}</div><div style=\"font-size: 12px\" \nclass=\"text-nowrap text-truncate\">{{package.price | currency:\'$\':2}}</div><div style=\"font-size: 12px\" \nclass=\"text-nowrap text-truncate\">({{package.date}})</div><div style=\"font-size: 11px\" \nclass=\"text-nowrap text-truncate\">({{package.valid_mileage || 0}} Mileage)</div><md-divider></md-divider><div \nclass=\"text-nowrap text-truncate\" ng-repeat=\"item in package.items | limitTo:vm.packageItemMaxDisplay track by $index\" \nlayout=\"row\" ng-if=\"!vm.showItems[package.presetPackage.id_preset_package]\"><span class=\"mr-1 text-green\">&#x2713\n</span> {{item}}</div><div \nng-if=\"(package.items.length > vm.packageItemMaxDisplay) && !vm.showItems[package.presetPackage.id_preset_package]\">\n{{package.items.length - vm.packageItemMaxDisplay}} more...<md-tooltip class=\"multiline-tooltip\"><div layout=\"column\">\n<div ng-repeat=\"item in package.items | limitTo: package.items.length : vm.packageItemMaxDisplay track by $index\" \nlayout=\"row\">{{item}}</div></div></md-tooltip></div><div layout=\"row\" layout-align=\"start center\" \nng-click=\"vm.showItems[package.presetPackage.id_preset_package] = !vm.showItems[package.presetPackage.id_preset_package]\">\n<div class=\"text-nowrap text-truncate\" ng-if=\"!vm.showItems[package.presetPackage.id_preset_package]\">Show More</div>\n<div class=\"text-nowrap text-truncate\" ng-if=\"vm.showItems[package.presetPackage.id_preset_package]\">Show Less</div><i \nng-class=\"vm.showItems[package.presetPackage.id_preset_package]? [\'icon-chevron-up\']:[\'icon-chevron-down\']\"></i></div>\n<div style=\"font-size: 13px\" class=\"text-grey\" ng-if=\"vm.showItems[package.presetPackage.id_preset_package]\"><div \nlayout=\"row\" layout-align=\"space-between center\" ng-repeat=\"item in package.presetPackage.items\"><div \nng-repeat=\"job in vm.jobList\" ng-if=\"item.fk_id_job\"><div ng-if=\"job.JobType.id_job == item.fk_id_job\"><br>\nJob: {{job.JobType.name}}<div ng-repeat=\"part in job.JobType.job_part\">\nPart: {{part.part_name || \"None\"}} * {{part.fk_id_parttype || 0}}</div><div \nng-repeat=\"labour in job.JobType.job_labour\">Labour: {{labour.labour_name || \"None\"}} * {{labour.labour_quantity || 0}}\n</div><div ng-repeat=\"miscfee in job.JobType.job_miscfee\">\nMisc Fees: {{miscfee.miscfees_name || \"None\"}} * {{miscfee.miscfees_quantity || 0}}</div></div></div></div></div></div>\n<div layout=\"row\" layout-align=\"center center\" ng-switch on=\"package.isDisabled\"><md-progress-circular \nng-switch-when=\"true\" md-diameter=\"25px\"></md-progress-circular><i ng-switch-default style=\"font-size: 30px\" \nng-class=\"package.isPurchased ? [\'icon-checkbox-marked-circle-outline\', \'text-green\']:[\'icon-circle-outline\', \'opacity-50\']\" \nng-click=\"vm.togglePackage(package)\"></i></div></div></div></div></div>");
$templateCache.put("app/main/workorders/components/workorder-payment-creater.html","<div layout=\"row\" layout-align=\"space-between center\"><md-select flex=\"35\" \nclass=\"small-selector purchase-step-selector input-box-padding\" ng-model=\"vm.customersIndex\" placeholder=\"Customer\">\n<md-option ng-repeat=\"customer in vm.customers\" ng-value=\"$index\">{{::customer.first_name + \' \' + customer.last_name}}\n</md-option></md-select><md-select flex=\"25\" class=\"small-selector purchase-step-selector input-box-padding\" \nng-model=\"vm.paymentMethodID\" placeholder=\"Method\"><md-option ng-repeat=\"item in vm.paymentMethods\" \nng-value=\"{{::item.id_payment_method}}\">{{::item.name}}</md-option></md-select><md-select flex=\"25\" \nclass=\"small-selector purchase-step-selector input-box-padding\" ng-if=\"vm.paymentMethodID == 6\" \nng-model=\"vm.paymentstatus\" placeholder=\"Status\"><md-option ng-repeat=\"item in vm.paymentStatusList\" \nng-value=\"{{::item.id_payment_status}}\">{{::item.name}}</md-option></md-select><input flex=\"20\" \nng-if=\"!vm.isLaborDiscountPercentage\" class=\"input-box-padding\" maxlength=\"10\" ng-model=\"vm.amount\" input-control \ninput-translate=\"vm.translateToDollar\" placeholder=\"$\"><button flex=\"20\" class=\"btn btn-sm btn-secondary ml-3\" \nng-click=\"vm.add()\"><div tabindex=\"0\" class=\"tabbable-button\">Add</div></button></div>");
$templateCache.put("app/main/workorders/components/workorder-payments-list.html","<md-divider></md-divider><div layout=\"column\" class=\"p-2\"><div ng-repeat=\"payment in vm.payments\"><div layout=\"row\" \nlayout-align=\"start center\" class=\"my-1\"><div layout=\"row\" layout-align=\"start center\" flex=\"30\"><div flex><span \nclass=\"badge badge-primary text-nowrap text-truncate\">{{payment.amount | currency:\'$\':2}} </span><span \nclass=\"badge badge-secondary text-nowrap text-truncate\">{{vm.getPaymentMethod(payment.fk_id_payment_method)}}</span>\n</div></div><div flex class=\"text-nowrap text-truncate\" flex=\"30\"><div>{{payment.payment_date | date:\'medium\'}}</div>\n<div>Status: {{payment.paymentStatus}} <i ng-if=\"payment.fk_id_payment_method == 6\" \nng-click=\"vm.updateWarrantyPaymentStatus(payment)\" class=\"icon-autorenew mb-4\"></i></div></div><div \nlayout-align=\"space-between center\" flex=\"40\"><div>\n{{payment.received_by.first_name + \' \' + payment.received_by.last_name}}</div><a \nng-href=\"{{vm.getCustomerPageUrl(payment.customer.id_customer)}}\" class=\"text-nowrap text-truncate\">\n{{payment.customer.first_name + \' \' + payment.customer.last_name}}</a></div></div><div layout=\"row\" \nng-if=\"payment.fk_id_payment_method == 11\"><div class=\"json-container\" flex=\"70\" \nng-if=\"payment.authorize_trans_detail_copy\"><div class=\"font-weight-bold\">Transaction Message:</div><div \nclass=\"json-property\">API Response Description:</div><div>\n{{payment.authorize_trans_detail_copy.apiResponseDescription}}</div><div class=\"json-property\">\nOverall Status Description:</div><div>{{payment.authorize_trans_detail_copy.overallStatusDescription}}</div></div><div \nlayout=\"row\" class=\"text-nowrap text-truncate\" flex=\"30\"><div>&nbsp</div><div ng-if=\"payment.message\">\nMessage: {{payment.message}}</div><div ng-if=\"payment.is_refund != undefine\" \nng-class=\"!payment.is_refund ? [text-grey]:[\'text-red\']\">Is Refund: {{payment.is_refund == 1}}</div><div \nng-if=\"payment.is_canceled != undefine\" ng-class=\"!payment.is_canceled ? [text-grey]:[\'text-red\']\">\nIs Cancelled: {{payment.is_canceled == 1}}</div><div ng-if=\"payment.authorize_trans_id\">\nTransaction ID: {{payment.authorize_trans_id}}</div></div></div><div layout=\"row\" layout-align=\"end center\"><md-button \nng-disabled=\"vm.isProcessing\" class=\"btn btn-danger mx-0 mt-5 mb-0\" ng-click=\"vm.onRemovePayment(payment, $index)\">\n&#x2715 REMOVE</md-button><div style=\"margin-left: 10px; margin-right: 10px\" \nng-if=\"payment.fk_id_payment_method == 11 && payment.is_canceled === 0 && payment.is_refund === 0\"></div><md-button \nng-disabled=\"vm.isProcessing\" class=\"btn btn-danger mx-0 mt-5 mb-0\" \nng-click=\"vm.voidCreditCardPayment(payment, $index)\" \nng-if=\"payment.fk_id_payment_method == 11 && payment.is_canceled === 0 && payment.is_refund === 0\">Void</md-button><div\n style=\"margin-left: 10px; margin-right: 10px\" \nng-if=\"payment.fk_id_payment_method == 11 && payment.is_canceled === 0 && payment.is_refund === 0\"></div><md-button \nng-disabled=\"vm.isProcessing\" class=\"btn btn-danger mx-0 mt-5 mb-0\" \nng-click=\"vm.refundCreditCardPayment(payment, $index)\" \nng-if=\"payment.fk_id_payment_method == 11 && payment.is_canceled === 0 && payment.is_refund === 0\">Refund</md-button>\n</div><md-divider class=\"form-divider-horizontal\"></md-divider></div><div ng-if=\"!(vm.payments.length > 0)\">\nNo item found</div></div><md-divider></md-divider>");
$templateCache.put("app/main/workorders/components/workorder-preset-jobs.html","<div class=\"card\"><div class=\"card-body\"><div ng-repeat=\"presetJob in vm.presetJobs track by $index\" class=\"mb-1\"><div \nlayout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><div \nclass=\"font-weight-bold\">{{presetJob.title}}</div><i ng-click=\"presetJob.showDetail = !presetJob.showDetail\" \nng-class=\"presetJob.showDetail ? [\'icon-menu-up\']:[\'icon-arrow-down-drop\']\"></i></div><div class=\"text-secondary\" \nng-click=\"vm.onAddClick(presetJob)\">Add</div></div><div ng-if=\"presetJob.showDetail\" style=\"font-size: 12px\"><div \nng-repeat=\"(typeID, parts) in presetJob.partsMap\"><div class=\"text-grey font-italic\">{{vm.getPartType(typeID)}}</div>\n<md-divider class=\"mb-1\"></md-divider><div ng-repeat=\"part in parts\"><div class=\"mr-3 mb-2\" layout=\"row\" \nlayout-align=\"start center\"><md-checkbox class=\"m-0 p-0\" ng-model=\"part.isSelected\"></md-checkbox><div \nng-if=\"part.partData\">{{part.partData.name}}<span ng-if=\"part.partData.quantity\"> * {{part.partData.quantity}}</span>\n</div><div ng-if=\"part.inventoryData\">{{part.inventoryData.name}}<span ng-if=\"part.inventoryData.quantity\">\n * {{part.inventoryData.quantity}}</span></div></div></div></div><div ng-if=\"presetJob.labors.length > 0\"><div \nclass=\"text-grey font-italic\">Labors</div><md-divider class=\"mb-1\"></md-divider><div \nng-repeat=\"item in presetJob.labors\" layout=\"row\" layout-align=\"start center\" class=\"mb-2\"><md-checkbox \nclass=\"m-0 p-0\" ng-model=\"item.isSelected\"></md-checkbox><div>{{item.laborData.name}}<span ng-if=\"item.laborData.hour\">\n * {{item.laborData.hour}}</span></div></div></div></div></div></div></div>");
$templateCache.put("app/main/workorders/components/workorder-roger-dollar-redeem-list.html","<md-content ng-if=\" vm.workOrderRDRedeemedList.length > 0\"><table class=\"table strike-able table-hover\" \nstyle=\"table-layout: fixed;width:100%; min-width:200px\"><thead><tr><th class=\"text-nowrap bg-light\" \nstyle=\"width: 35px\"><md-checkbox ng-if=\" vm.workOrderRDRedeemedList.length > 0\" ng-checked=\"vm.isAllSelected()\" \nng-click=\"vm.selectAll()\" class=\"m-0 p-0\"></md-checkbox></th><th class=\"text-nowrap bg-light\">Roger Dollar Redemption\n</th><th class=\"text-nowrap bg-light\" style=\"width: 120px\">Amount</th></tr></thead><tbody><tr \nng-repeat=\"discount in vm.workOrderRDRedeemedList\"><td><md-checkbox class=\"m-0 p-0\" \nng-model=\"vm.selectedMap[vm.getRDRedeemItemID(discount)]\"></md-checkbox></td><td>\n{{vm.getRogersDollarRedeemCustomerName(discount.resourceData.fk_id_customer)}}</td><td><div>\n-{{(discount.resourceData.redeemed_amount || discount.redeemed_amount) | currency:\'$\':2}}</div></td></tr><tr \nng-if=\"!(vm.workOrderRDRedeemedList.length > 0)\"><td colspan=\"3\">No item found.</td></tr></tbody></table></md-content>");
$templateCache.put("app/main/workorders/components/workorder-status-bar.html","<div layout=\"column\" style=\"font-size: 1.5rem\" flex=\"100\"><md-select style=\"text-align: center\" \nng-disabled=\"vm.isProcessing || vm.isDisabled\" ng-model=\"vm.workOrderStatusTempHolder\" \nng-class=\"vm.workOrderStatusTempHolder.id_work_order_status == vm.workorder.fk_id_work_order_status ? [\'workorder-current-status-item\']:[]\" \nclass=\"workorder-status-bar-item\" ng-style=\"vm.getBackgroudColor(vm.workOrderStatusTempHolder.id_work_order_status)\">\n<md-option ng-repeat=\"item in vm.statusOptions\" ng-value=\"item\" ng-click=\"vm.onStatusClick(item)\" \nlayout-align=\"center center\">{{item.status}}</md-option></md-select></div>");
$templateCache.put("app/main/workorders/components/workorder-warranty-form.html","<div class=\"mb-5\" layout=\"column\" layout-gt-sm=\"row\" ng-form=\"warrantyForm\" style=\"font-size: 13px\" \nng-repeat=\"warranty in vm.currentWarranty\"><div flex-gt-sm=\"45\"><div layout=\"row\" layout-align=\"center center\"><span>\nRemove warranty</span><md-button class=\"md-icon-button mx-0 btn-sm\" ng-click=\"vm.onRemoveWarrantyclick(warranty)\">\n<md-icon class=\"icon-delete-circle text-danger purchase-step-extra-item-icon\"></md-icon></md-button></div><div \nng-if=\"vm.currentWarranty != null\"><div layout=\"row\"><md-input-container \nclass=\"input-box info-form-item small-input-box purchase-step-payment-input-box\"><input type=\"text\" autocorrect=\"off\" \nautocapitalize=\"none\" spellcheck=\"false\" ng-required=\"true\" name=\"name\" ng-model=\"warranty.name\" autocomplete=\"off\" \nplaceholder=\"Name\"><div ng-messages=\"warrantyForm.name.$error\"><div ng-message=\"required\">This field is required</div>\n</div></md-input-container><md-input-container \nclass=\"input-box info-form-item small-input-box purchase-step-payment-input-box\"><input type=\"text\" autocorrect=\"off\" \nautocapitalize=\"none\" spellcheck=\"false\" name=\"provider\" ng-model=\"warranty.provider\" autocomplete=\"off\" \nplaceholder=\"Provider\"></md-input-container></div><div layout=\"row\"><md-input-container \nclass=\"input-box info-form-item small-input-box purchase-step-payment-input-box\"><input type=\"text\" autocorrect=\"off\" \nautocapitalize=\"none\" spellcheck=\"false\" ng-required=\"true\" name=\"coveredMonth\" ng-model=\"warranty.duration_month\" \nautocomplete=\"off\" placeholder=\"Covered Month\" ng-pattern=\"/^[0-9]*$/\" input-pattern maxlength=\"2\"><div \nng-messages=\"warrantyForm.coveredMonth.$error\"><div ng-message=\"required\">This field is required</div></div>\n</md-input-container><md-input-container \nclass=\"input-box info-form-item small-input-box purchase-step-payment-input-box\"><input type=\"text\" autocorrect=\"off\" \nautocapitalize=\"none\" spellcheck=\"false\" name=\"coveredMileage\" ng-model=\"warranty.duration_mileage\" autocomplete=\"off\" \nplaceholder=\"Covered Mileage\" ng-pattern=\"/^[0-9]*$/\" input-pattern maxlength=\"10\"></md-input-container></div><div \nlayout=\"row\"><md-input-container restrict rolescansee=\"developer company_manager sales_manager\" flex=\"50\" \nclass=\"input-box info-form-item small-input-box purchase-step-payment-input-box\"><input maxlength=\"10\" type=\"text\" \nautocorrect=\"off\" autocapitalize=\"none\" spellcheck=\"false\" ng-required=\"true\" name=\"cost\" ng-model=\"warranty.cost\" \nautocomplete=\"off\" placeholder=\"Cost\" input-control input-translate=\"vm.translateToDollar\"><div \nng-messages=\"warrantyForm.cost.$error\"><div ng-message=\"required\">This field is required</div></div>\n</md-input-container><md-input-container flex=\"50\" \nclass=\"input-box info-form-item small-input-box purchase-step-payment-input-box\"><input type=\"text\" autocorrect=\"off\" \nautocapitalize=\"none\" spellcheck=\"false\" ng-required=\"true\" name=\"retail\" ng-model=\"warranty.retail\" \nautocomplete=\"off\" placeholder=\"Retail\" input-control input-translate=\"vm.translateToDollar\" maxlength=\"10\"><div \nng-messages=\"warrantyForm.retail.$error\"><div ng-message=\"required\">This field is required</div></div>\n</md-input-container></div><div layout=\"row\"><md-input-container flex=\"50\" \nclass=\"input-box info-form-item small-input-box purchase-step-payment-input-box\"><input type=\"text\" autocorrect=\"off\" \nautocapitalize=\"none\" spellcheck=\"false\" name=\"max_claim\" ng-model=\"warranty.max_claim\" autocomplete=\"off\" \nplaceholder=\"max_claim\" input-control input-translate=\"vm.translateToDollar\" maxlength=\"10\"><div \nng-messages=\"warrantyForm.max_claim.$error\"><div ng-message=\"required\">This field is required</div></div>\n</md-input-container></div><md-input-container \nclass=\"input-box info-form-item small-input-box purchase-step-payment-input-box\"><input type=\"text\" autocorrect=\"off\" \nautocapitalize=\"none\" spellcheck=\"false\" name=\"description\" ng-model=\"warranty.description\" autocomplete=\"off\" \nplaceholder=\"Description\"></md-input-container></div></div><div flex-gt-sm=\"45\" flex-offset=\"0\" flex-offset-gt-sm=\"10\">\n<md-divider></md-divider><div class=\"p-2\"><div ng-if=\"!(vm.availableWarranties.length > 0)\">\nPreset warranties are not available for this vehicle</div><div layout=\"column\" \nng-repeat=\"presetwarranty in vm.availableWarranties\"><div layout=\"row\" layout-align=\"space-between center\"><div \nflex=\"50\" layout=\"row\" layout-align=\"start center\"><div class=\"m-1 badge badge-secondary\" \nng-click=\"vm.pullDataFromWarrantyOption(warranty,presetwarranty)\">Load</div><div>{{::presetwarranty.name}}</div>\n<md-button class=\"md-icon-button mx-0\" \nng-click=\"vm.warrantyShowingFeature[presetwarranty.getResourceID()] = !vm.warrantyShowingFeature[presetwarranty.getResourceID()]\">\n<md-icon class=\"icon-more text-secondary purchase-step-extra-item-icon\"></md-icon></md-button></div><div flex=\"50\" \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"m-1\">{{::presetwarranty.duration_month}} Months</div><div \nclass=\"m-1\">{{::presetwarranty.duration_mileage}} Kms</div><div class=\"m-1 badge badge-warning\">\n{{::presetwarranty.retail | currency:\'$\':0}}</div></div></div><div \nng-if=\"vm.warrantyShowingFeature[presetwarranty.getResourceID()]\" class=\"px-5\" layout=\"row\" layout-wrap \nstyle=\"font-size: 13px\"><div layout=\"row\" flex=\"50\" ng-repeat=\"feature in presetwarranty.features\"><span \nclass=\"text-secondary mr-2\">&#9679</span> <span>{{::feature.name}}<md-tooltip md-direction=\"right\" \nclass=\"multiline-tooltip\">{{::feature.description}}</md-tooltip></span></div></div></div></div><md-divider>\n</md-divider></div></div>");
$templateCache.put("app/main/workorders/components/workorder-warranty.html","<div class=\"card\"><div class=\"card-body\"><div layout=\"row\" layout-align=\"start center\"><div class=\"font-weight-bold\">\n{{vm.warranty.name}}</div></div><div class=\"mr-3 mb-2\" layout=\"row\" layout-align=\"start center\"><div>\n{{vm.warranty.description}}</div></div><div layout=\"row\" layout-align=\"start center\"><div class=\"font-weight-bold\">\nCovered Milage:</div></div><p>{{vm.coveredMileage}}</p><div layout=\"row\" layout-align=\"start center\"><div \nclass=\"font-weight-bold\">Current Milage:</div></div><p>{{vm.currentmileage}}</p><div layout=\"row\" \nlayout-align=\"start center\"><div class=\"font-weight-bold\">Expiry Date:</div></div><p>{{vm.expiryDate}}</p><div \nlayout=\"row\" layout-align=\"start center\"><div class=\"font-weight-bold\">Current Date:</div></div><p>{{vm.currentdate}}\n</p></div></div>");
$templateCache.put("app/main/workorders/new-schedule/new-schedule.html","<style>\n.work-order-button {\r\n		display: flex;\r\n		flex-direction: column;\r\n		justify-content: center;\r\n		align-items: flex-start;\r\n		border: none;\r\n		cursor: pointer;\r\n		padding: 30px 40px;\r\n		border-radius: 20px;\r\n		box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);\r\n		width: auto;\r\n		/* Automatically adjust width */\r\n		max-width: 400px;\r\n		/* Set a maximum width to avoid overly wide buttons */\r\n		min-width: 200px;\r\n		/* Set a minimum width to maintain consistent sizing */\r\n		text-align: left;\r\n		color: #ffffff;\r\n		font-family: Arial, sans-serif;\r\n		word-wrap: break-word;\r\n		/* Break long words to prevent overflow */\r\n		overflow-wrap: break-word;\r\n		/* Alternative for long words */\r\n		white-space: normal;\r\n		/* Allow text to wrap to a new line */\r\n		transition: transform 0.2s ease, box-shadow 0.2s ease;\r\n	}\r\n\r\n	.work-order-button:hover {\r\n		transform: scale(1.05);\r\n		/* Slightly enlarge the button on hover */\r\n		box-shadow: 0 6px 12px rgba(0, 0, 0, 0.5);\r\n		/* Darker shadow on hover */\r\n	}\r\n\r\n	.large-input-box {\r\n		width: 100%;\r\n		/* Ensure it takes full width if needed */\r\n		font-size: 18px;\r\n		/* Increase font size for the input */\r\n	}\r\n\r\n	.large-input-box md-datepicker {\r\n		font-size: 18px;\r\n		/* Increase font size inside the datepicker */\r\n		height: 50px;\r\n		/* Adjust the height */\r\n		padding: 10px;\r\n		/* Add some padding */\r\n	}\r\n\r\n	.date-display {\r\n		font-size: 18px;\r\n		/* Increase the size of the displayed date text */\r\n		font-weight: bold;\r\n		/* Optional: Make the text bold */\r\n		margin-top: 10px;\r\n		/* Add space above the date text */\r\n	}\n</style><div style=\"width: 100%\" class=\"bg-secondary header-backgroud\" layout=\"row\" layout-align=\"center center\"><div \nflex class=\"content-max-width content-padding-x-full\"><span class=\"h2 white-fg\">Active Schedule</span></div></div><div \nstyle=\"width: 100%\" layout=\"row\" layout-align=\"center start\"><div flex class=\"content-padding-x-full\" layout=\"row\" \nlayout-wrap><div flex=\"100\" flex-gt-sm=\"15\" class=\"pr-3 py-2\"><div class=\"card py-2\"><div \nclass=\"card-header py-1 bg-secondary\"><span style=\"float: left\">Date</span></div><div class=\"card-body\"><div \nlayout=\"column\"><div><md-input-container flex class=\"input-box info-form-item large-input-box\"><label>Select Date\n</label><md-datepicker md-hide-icons=\"calendar\" ng-model=\"vm.DateFilter\" ng-change=\"vm.initCalendarGrid()\" \nname=\"startDate\"></md-datepicker></md-input-container></div><div class=\"date-display\">\n{{vm.DateFilter | date: \'fullDate\'}}</div></div></div></div><div class=\"card\"><div \nclass=\"card-header py-1 bg-secondary\"><span style=\"float: left\">Filters</span></div><div class=\"card-body\"><div \nlayout=\"column\"><div ng-repeat=\"calendar in vm.calendars\"><div \nstyle=\"display: flex; justify-content: space-between; align-items: center\"><div style=\"flex-grow: 1\"><md-checkbox \nng-style=\"{\'color\': calendar.color}\" ng-change=\"vm.refreshCalendarGrid()\" ng-model=\"calendar.isShow\">\n{{::calendar.name}}</md-checkbox></div></div></div></div><div layout=\"row\" layout-wrap><div layout=\"row\" \nlayout-align=\"start center\" ng-repeat=\"customFilter in vm.pageConfigs.customFilters track by $index\" \nng-class=\"vm.isCustomFilterApplied(customFilter) ? [\'text-secondary\']:[]\" class=\"mr-2 my-1 px-1 simple-border\"><div \nng-click=\"vm.selectCustomFilter(customFilter.name)\">{{customFilter.name}}</div><button \nng-disabled=\"vm.isSavingFilter || vm.isDeletingFilter\" ng-click=\"vm.deleteCustomFilter($index)\"><md-icon \nclass=\"icon-close text-red\"></md-icon></button></div><div ng-if=\"!(vm.pageConfigs.customFilters.length > 0)\">\nYou haven\'t saved any filter yet.</div></div><div layout=\"row\" layout-align=\"space-between center\" class=\"mt-3\"><input \nflex class=\"mr-2\" ng-model=\"vm.newCustomFilterName\" autocomplete=\"off\" placeholder=\"Filter Name\" maxlength=\"50\"> \n<button ng-disabled=\"!vm.newCustomFilterName || vm.isSavingFilter || vm.isDeletingFilter\" \nng-click=\"vm.addCustomFilter()\"><i class=\"icon-plus-circle\" ng-class=\"vm.newCustomFilterName? [\'text-green\']:[]\"></i>\n</button></div></div></div></div><div flex=\"100\" flex-gt-sm=\"85\" class=\"pr-3 py-2\"><div \nng-repeat=\"calendar in vm.calendars\"><div class=\"card\" ng-if=\"calendar.isShow\" style=\"margin-bottom: 10px\"><div \nclass=\"card-header py-1 bg-secondary\"><span style=\"float: left\">{{::calendar.name}}</span></div><div class=\"card-body\">\n<div \nstyle=\"display: flex; overflow-x: auto; padding-bottom: 10px; flex-wrap: nowrap; scrollbar-width: thin; scrollbar-color: #ccc #f1f1f1\">\n<div ng-repeat=\"workOrder in vm.calendarWorkOrder.get(calendar.id_calendar)\" \nstyle=\"margin: 10px 0; padding-right: 4px; flex: 0 0 auto\"><button class=\"work-order-button\" \nng-style=\"{\'background-color\': calendar.color}\" \nng-click=\"vm.redirectToUrl(workOrder.fk_id_work_order, workOrder.fk_id_vehicle)\"><span \nstyle=\"font-weight: bold; font-size: 2rem; margin-bottom: 5px\" ng-style=\"{color: vm.getElapsedTimeColor(workOrder)}\">\n{{ workOrder.title }}</span> <span style=\"font-size: 1.5rem\" ng-style=\"{color: vm.getElapsedTimeColor(workOrder)}\">\n{{ vm.calculateTimeElapsed(workOrder) }}</span></button></div></div></div></div></div></div></div></div>");
$templateCache.put("app/main/workorders/edit-workorder/edit-workorder-appointments.html","<div class=\"content-padding-half\"><workorder-appointment-list \ndisable-editing=\"vm.isUpdatingAppointment || vm.isDeletingAppointment\" appointment-status=\"vm.appointmentStatus\" \nselected-map=\"vm.selectedMap\" on-status-changed=\"vm.updateAppointmentStatus\" appointments=\"vm.appointments\">\n</workorder-appointment-list><div class=\"mt-2 px-1\" layout=\"row\" layout-align=\"space-between center\"><button \nng-click=\"vm.removeSelectedAppointments()\" ng-disabled=\"vm.disableDeleteButton()\"><i class=\"icon-delete-forever\" \nng-class=\"vm.disableDeleteButton() ? [\'\']:[\'text-red\']\"></i></button> <a ng-href=\"{{::vm.addAppointmentUrl}}\">\nAdd Appointment</a></div><br><br></div>");
$templateCache.put("app/main/workorders/edit-workorder/edit-workorder-discounts.html","<div id=\"{{::vm.discountsAnchorTag}}\" class=\"content-padding-half\"><workorder-discount-list \nselected-map=\"vm.selectedMap\" discounts=\"vm.discounts\"></workorder-discount-list><div layout=\"row\" layout-wrap \nlayout-align=\"space-between center\"><div flex=\"100\" flex-gt-sm=\"25\" class=\"mb-4\"><button \nng-disabled=\"vm.isAddingDiscount || vm.isDeletingDiscount || !vm.isAnyItemSelected()\" ng-click=\"vm.deleteDiscounts()\">\n<i class=\"icon-delete-forever\" \nng-class=\"vm.isAddingDiscount || vm.isDeletingDiscount || !vm.isAnyItemSelected() ? [\'text-grey\']:[\'text-red\']\"></i>\n</button></div><div flex=\"100\" flex-gt-sm=\"75\" layout=\"row\" layout-align=\"end center\"><div flex \nstyle=\"font-size: 13px\"><md-checkbox ng-change=\"vm.percentageTransaletor()\" ng-model=\"vm.isPercentage\">Percentage\n</md-checkbox></div><div ng-if=\"vm.isPercentage\"><md-input-container \nclass=\"input-box small-input-box input-box-padding\"><input ng-model=\"vm.amount\" autocomplete=\"off\" maxlength=\"4\" \ninput-control input-translate=\"vm.translateToPercentage\" input-options=\"vm.percentageInputOption\" \nplaceholder=\"Percentage\"></md-input-container></div><div flex ng-if=\"!vm.isPercentage\"><md-input-container \nclass=\"input-box small-input-box input-box-padding\"><input ng-model=\"vm.amount\" autocomplete=\"off\" maxlength=\"10\" \ninput-control input-translate=\"vm.translateToDollar\" input-options=\"vm.discountsInputOptions\" placeholder=\"Amount\">\n</md-input-container></div><md-input-container flex class=\"input-box small-input-box input-box-padding\"><input \nng-model=\"vm.description\" autocomplete=\"off\" placeholder=\"Description\" maxlength=\"200\"></md-input-container><md-button \nflex class=\"btn-sm btn-secondary mx-0 mb-6\" ng-click=\"vm.addDiscount()\" \nng-disabled=\"vm.isAddingDiscount || vm.isDeletingDiscount\"><div tabindex=\"0\" class=\"tabbable-button\">Add</div>\n</md-button></div></div><md-divider class=\"form-divider-horizontal\"></md-divider><div layout=\"row\" layout-wrap \nlayout-align=\"space-between center\"><md-input-container flex class=\"input-box small-input-box input-box-padding\"><input\n ng-model=\"vm.couponCode\" autocomplete=\"off\" placeholder=\"Coupon Code\" maxlength=\"200\"></md-input-container><md-button \nflex class=\"btn-sm btn-secondary mx-0 mb-6\" ng-click=\"vm.checkAndAddCouponDiscount()\" \nng-disabled=\"vm.isAddingDiscount || vm.isDeletingDiscount\"><div tabindex=\"0\" class=\"tabbable-button\">\nAdd Coupon Discount</div></md-button></div></div>");
$templateCache.put("app/main/workorders/edit-workorder/edit-workorder-extra.html","<div layout=\"row\" layout-wrap ng-hide=\"true\"><div class=\"content-padding-half\" flex=\"100\" flex-gt-sm=\"50\" \nflex-order=\"2\" flex-order-gt-sm=\"1\"><workorder-info-form work-order=\"vm.workOrder\" \nwork-order-priorities=\"vm.workOrderPriorities\" is-form-valid=\"vm.isInfoFormValid\" \nis-processing-data=\"vm.isSaving || vm.isSpliting\" refresh-dates=\"vm.refreshDates\" customer-list=\"vm.customerList\" \nselected-customer=\"vm.selectedCustomer\" work-order-rd-generated-list=\"vm.workOrderRDGeneratedList\">\n</workorder-info-form></div><div flex=\"100\" flex-gt-sm=\"50\" flex-order=\"1\" flex-order-gt-sm=\"2\" \nclass=\"content-padding-half\"><div class=\"card\" style=\"font-size: 13px\"><div class=\"card-header py-1 bg-black\" \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"text-white font-weight-bold\">Latest appointment</div><a \nng-if=\"vm.totalAppointments - 1 > 0\" ng-href=\"{{::vm.appointmentsTabUrl}}\">{{::vm.totalAppointments - 1}} more..</a>\n</div><div class=\"card-body\"><div ng-if=\"!!vm.upcomingAppointment\"><div layout=\"row\" \nlayout-align=\"space-between center\"><a ng-href=\"{{::vm.upcomingAppointmentUrl}}\">\n{{::vm.upcomingAppointment.start | date:\"medium\"}}<div class=\"pre-wrap\" ng-if=\"vm.upcomingAppointment.title\">\n{{::vm.upcomingAppointment.title}}</div><div class=\"pre-wrap\" ng-if=\"vm.upcomingAppointment.appointment_type_name\">\n{{::vm.upcomingAppointment.vehicle_name}}</div></a><div layout=\"column\" ng-if=\"vm.upcomingAppointment.title\"><div \nstyle=\"font-size: 11px\" ng-repeat=\"status in vm.appointmentStatus\" class=\"ml-2\"><input type=\"checkbox\" \nng-click=\"vm.updateUpcomingAppontmentStatus(status.id_appointment_status)\" ng-disabled=\"vm.isUpdatingAppointment\" \nng-checked=\"status.id_appointment_status == vm.upcomingAppointment.fk_id_appointment_status\"> {{::status.name}}</div>\n</div><div layout=\"column\" ng-if=\"vm.upcomingAppointment.appointment_type_name\"><div style=\"font-size: 11px\" \nng-repeat=\"(statusName, statusID) in vm.customerPortalAppointmentStatus\" class=\"ml-2\"><input type=\"checkbox\" \nng-click=\"vm.updateUpcomingCustomerPortalAppontmentStatus(statusID)\" ng-disabled=\"true\" \nng-checked=\"statusID == vm.upcomingAppointment.fk_id_customer_portal_appointment_status\"> {{::statusName}}</div></div>\n</div></div><div ng-if=\"!vm.upcomingAppointment\">No upcoming appointment.</div><div layout=\"row\" \nlayout-align=\"end center\"><a ng-href=\"{{::vm.addAppointmentUrl}}\">New Appointment</a></div></div></div><br><div \nclass=\"card\" style=\"font-size: 13px\"><div class=\"card-body\"><form layout=\"column\" layout-wrap \nname=\"custormerBasicInfoForm\"><md-input-container flex=\"100\" style=\"width: 100%\" \nclass=\"large-selector purchase-step-selector pr-5\"><label>Receiver</label><md-select \nng-disabled=\"!vm.workOrder.is_rogerdollar_generable\" ng-model=\"vm.customerRegistrationTempHolder\"><md-option \nng-value=\"customer\" ng-repeat=\"(customerId, customer) in vm.customerList\">\n{{ customer.customerInfo.first_name }} {{ customer.customerInfo.last_name }}</md-option></md-select>\n</md-input-container><md-input-container flex=\"grow\"><input type=\"email\" ng-change=\"vm.queryCustomers()\" \nng-required=\"true\" name=\"{{\'email\'}}\" ng-model=\"vm.clientEmailAddressHolder\" autocomplete=\"off\" \nplaceholder=\"Email Address\" ng-model-options=\"{ debounce: 700 }\" maxlength=\"50\"><div \nng-messages=\"custormerBasicInfoForm[\'email\'].$error\"><div ng-message=\"maxlength\">\nInput content can not be over 50 charactors</div><div ng-message=\"required\">This field is required</div><div \nng-message=\"email\">Invalid email address</div></div></md-input-container><div layout=\"row\"><md-button \nng-disabled=\"vm.isSaving || vm.isSpliting || vm.sendingRegistrationEmail\" flex class=\"mx-0 btn-sm btn-secondary\" \nng-class=\"{\' mx-0 btn-sm btn-secondary\': vm.customerRegistrationTempHolder.customerInfo.registration_sent == 0, \'mx-0 btn-sm btn-success\': vm.customerRegistrationTempHolder.customerInfo.registration_sent == 1}\" \nng-click=\"vm.onSendClientRegistrationEmail()\">send</md-button></div></form></div></div></div></div><div \nclass=\"content-padding-half\"><h5 id=\"{{::vm.packagesAnchorTag}}\">Packages</h5><workorder-package-list \nsold-date=\"vm.saleInfo.sale_date\" preset-packages=\"vm.presetPackages\" package-items-map=\"vm.workOrderPackageItemsMap\" \nsale-packages=\"vm.workorderPackages\" sale-info=\"vm.vehicle\" job-list=\"vm.JobTypeList\" \non-preset-package-select=\"vm.addWorkOrderPackage\" on-purchase-package-remove=\"vm.deleteWorkOrderPackage\">\n</workorder-package-list></div><div class=\"content-padding-half\"><form name=\"saleInfoForm\" id=\"accordionExample\"><h5 \nid=\"{{::vm.warrantyAnchorTag}}\">Warranty</h5><div class=\"card\" \nid=\"{{::vm.warrantyCollapseSectionID + vm.warrantyAnchorTag}}\"><div class=\"card-header\" id=\"warrantySection\"><h2 \nclass=\"mb-0\"><button class=\"btn btn-link btn-block text-left px-0\" type=\"button\" data-toggle=\"collapse\" \ndata-target=\"{{::\'#\' + vm.warrantyCollapseSectionID}}\">{{::vm.sectionOptions.warranty.name}} <span \nng-if=\"saleInfoForm.warrantyForm.$invalid\"></span></button></h2></div><div id=\"{{::vm.warrantyCollapseSectionID}}\" \nclass=\"collapse\" data-parent=\"#accordionExample\"><div class=\"card-body\"><workorder-warranty-form vehicle=\"vm.vehicle\" \nwarrant-options=\"vm.warrantyOptions\" current-warranty=\"vm.workorderWarranty\" is-form-valid=\"vm.isWarrntySectionValid\" \nremove-work-order-warranty=\"vm.removeWorkOrderWarranty\"></workorder-warranty-form></div><div layout=\"row\" \nlayout-align=\"center center\"><span>New warranty</span><md-button class=\"md-icon-button mx-0 btn-sm\" \nng-click=\"vm.initNewWorkOrderWarranty()\"><md-icon class=\"icon-plus-circle text-green purchase-step-extra-item-icon\">\n</md-icon></md-button><md-button class=\"btn btn-secondary class=md-icon-button mx-0 btn-sm\" \nng-click=\"vm.saveWorkOrderWarrantyButtonClick()\">Save Warranty Info</md-button></div></div></div></form></div><div \nlayout=\"row\" layout-align=\"space-between center\" class=\"content-padding-half\"><md-button \nng-disabled=\"vm.isSaving || vm.isSpliting\" class=\"btn btn-secondary mx-0 mt-5 mb-0\" ng-click=\"vm.onSaveClick()\">save\n</md-button></div>");
$templateCache.put("app/main/workorders/edit-workorder/edit-workorder-files.html","<div layout=\"row\" class=\"content-padding-half\"><file-section flex=\"100\" flex-gt-sm=\"50\" uploaded-files=\"vm.files\" \nfile-uploader=\"vm.fileUploader\" on-file-delete=\"vm.onFileDelete\" is-processing-data=\"vm.isDeletingFile\"></file-section>\n</div>");
$templateCache.put("app/main/workorders/edit-workorder/edit-workorder-general.html","<div class=\"content-padding-x-half\"><workorder-status-bar id=\"{{::vm.generalAnchorTag}}\" \nis-processing=\"vm.isSaving || vm.isSpliting || vm.isDeletingPartTableItems\" status-options=\"vm.workOrderStatus\" \non-status-click=\"vm.onStatusClick\" workorder=\"vm.workOrder\"></workorder-status-bar></div><div \nclass=\"content-padding-half\" ng-if=\"vm.workOrder.fk_id_work_order_status != vm.completedStatusID\"><div layout=\"row\" \nlayout-align=\"start center\" class=\"my-1\" ng-repeat=\"(inventoryID, item) in vm.demandMap\" \nng-if=\"item.totalInStock < item.totalDemand\"><div class=\"mr-2\"><i class=\"icon-alert-outline text-red\"></i></div><div>\n{{item.totalDemand | number}} {{item.name}} needed, but only {{item.totalInStock | number}} in stock.</div></div></div>\n<div layout=\"row\" layout-wrap><div class=\"content-padding-half\" flex=\"100\" flex-gt-sm=\"50\" flex-order=\"2\" \nflex-order-gt-sm=\"1\"><workorder-info-form work-order=\"vm.workOrder\" work-order-priorities=\"vm.workOrderPriorities\" \nis-form-valid=\"vm.isInfoFormValid\" is-processing-data=\"vm.isSaving || vm.isSpliting\" refresh-dates=\"vm.refreshDates\" \ncustomer-list=\"vm.customerList\" selected-customer=\"vm.selectedCustomer\" \nwork-order-rd-generated-list=\"vm.workOrderRDGeneratedList\"></workorder-info-form></div><div flex=\"100\" flex-gt-sm=\"50\" \nflex-order=\"1\" flex-order-gt-sm=\"2\" class=\"content-padding-half\"><div class=\"card\" style=\"font-size: 13px\"><div \nclass=\"card-header py-1 bg-black\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"text-white font-weight-bold\">Latest appointment</div><a ng-if=\"vm.totalAppointments - 1 > 0\" \nng-href=\"{{::vm.appointmentsTabUrl}}\">{{::vm.totalAppointments - 1}} more..</a></div><div class=\"card-body\"><div \nng-if=\"!!vm.upcomingAppointment\"><div layout=\"row\" layout-align=\"space-between center\"><a \nng-href=\"{{::vm.upcomingAppointmentUrl}}\">{{::vm.upcomingAppointment.start | date:\"medium\"}}<div class=\"pre-wrap\" \nng-if=\"vm.upcomingAppointment.title\">{{::vm.upcomingAppointment.title}}</div></a><div layout=\"column\" \nng-if=\"vm.upcomingAppointment.title\"><div style=\"font-size: 11px\" ng-repeat=\"status in vm.appointmentStatus\" \nclass=\"ml-2\"><input type=\"checkbox\" ng-click=\"vm.updateUpcomingAppontmentStatus(status.id_appointment_status)\" \nng-disabled=\"vm.isUpdatingAppointment\" \nng-checked=\"status.id_appointment_status == vm.upcomingAppointment.fk_id_appointment_status\"> {{::status.name}}</div>\n</div></div></div><div ng-if=\"!vm.upcomingAppointment\">No upcoming appointment.</div><div layout=\"row\" \nlayout-align=\"end center\"><a ng-href=\"{{::vm.addAppointmentUrl}}\">New Appointment</a></div></div></div><br><div \nclass=\"card\" style=\"font-size: 13px\"><div class=\"card-header py-1 bg-black\" layout=\"row\" flex=\"100\" \nlayout-align=\"space-between center\"><div class=\"text-white font-weight-bold\">Send Email to customer for registration <i\n ng-click=\"vm.showRegistrationEmailSection = !vm.showRegistrationEmailSection\" \nng-class=\"vm.showRegistrationEmailSection ? [\'icon-menu-up\']:[\'icon-arrow-down-drop\']\" \nclass=\"text-white font-weight-bold\"></i></div></div><div class=\"card-body\" ng-hide=\"vm.showRegistrationEmailSection\">\n<form layout=\"column\" layout-wrap name=\"custormerBasicInfoForm\"><md-input-container flex=\"100\" style=\"width: 100%\" \nclass=\"large-selector purchase-step-selector pr-5\"><label>Receiver</label><md-select \nng-model=\"vm.customerRegistrationTempHolder\"><md-option ng-value=\"customer\" \nng-repeat=\"(customerId, customer) in vm.customerList\">\n{{ customer.customerInfo.first_name }} {{ customer.customerInfo.last_name }}</md-option></md-select>\n</md-input-container><md-input-container flex=\"grow\"><input type=\"email\" ng-change=\"vm.queryCustomers()\" \nng-required=\"true\" name=\"{{\'email\'}}\" ng-model=\"vm.clientEmailAddressHolder\" autocomplete=\"off\" \nplaceholder=\"Email Address\" ng-model-options=\"{ debounce: 700 }\" maxlength=\"50\"><div \nng-messages=\"custormerBasicInfoForm[\'email\'].$error\"><div ng-message=\"maxlength\">\nInput content can not be over 50 charactors</div><div ng-message=\"required\">This field is required</div><div \nng-message=\"email\">Invalid email address</div></div></md-input-container><p \nng-hide=\"!vm.customerRegistrationTempHolder.customerInfo.registration_sent == 1\" \nclass=\"badge badge-pill badge-warning pull-right\">Registration email sent already.</p><p \nng-hide=\"!vm.customerRegistrationTempHolder.customerInfo.registration_sent == 1\" \nclass=\"badge badge-pill badge-warning pull-right\">\nLast email send time: {{vm.customerRegistrationTempHolder.customerInfo.email_send_time | date:\'yyyy-MM-dd HH:mm:ss\'}}\n</p><div layout=\"row\"><md-button ng-disabled=\"vm.isSaving || vm.isSpliting || vm.sendingRegistrationEmail\" flex \nclass=\"mx-0 btn-sm btn-secondary\" \nng-class=\"{\' mx-0 btn-sm btn-secondary\': vm.customerRegistrationTempHolder.customerInfo.registration_sent == 0, \'mx-0 btn-sm btn-success\': vm.customerRegistrationTempHolder.customerInfo.registration_sent == 1}\" \nng-click=\"vm.onSendClientRegistrationEmail()\"><a \nng-hide=\"vm.customerRegistrationTempHolder.customerInfo.registration_sent == 1\">Send</a> <a \nng-hide=\"!vm.customerRegistrationTempHolder.customerInfo.registration_sent == 1\">Resend</a></md-button></div></form>\n</div></div></div></div><div layout=\"row\" layout-wrap><div flex=\"100\" flex-gt-sm=\"50\" layout=\"column\" \nclass=\"content-padding-half\"><div>Notes:</div><textarea ng-disabled=\"vm.isSaving || vm.isSpliting\" rows=\"9\" \nng-model=\"vm.workOrder.notes\" class=\"info-form-item detail-info-form-note-input\">\r\n		</textarea></div><div flex=\"100\" \nflex-gt-sm=\"50\" layout=\"column\" class=\"content-padding-half\"><div>Mechanic Notes:</div><textarea \nng-disabled=\"vm.isSaving || vm.isSpliting\" rows=\"9\" ng-model=\"vm.workOrder.mechanic_notes\" \nclass=\"info-form-item detail-info-form-note-input\">\r\n		</textarea></div></div><div layout=\"row\" layout-wrap><div \nflex=\"100\" flex-gt-sm=\"100\" layout=\"column\" class=\"content-padding-half\"><div>AI Notes: <i \nng-click=\"vm.showAiNotesSection = !vm.showAiNotesSection\" \nng-class=\"vm.showAiNotesSection ? [\'icon-arrow-down-drop\']:[\'icon-menu-up\']\"></i> <i \nng-if=\"!vm.showAiNotesSection && !vm.aiNotesExpanded\" ng-click=\"vm.aiNotesExpanded = true\" class=\"icon-arrow-expand\" \nstyle=\"margin-left: 8px; cursor: pointer\" title=\"Expand to fit content\"></i> <i \nng-if=\"!vm.showAiNotesSection && vm.aiNotesExpanded\" ng-click=\"vm.aiNotesExpanded = false\" class=\"icon-arrow-compress\" \nstyle=\"margin-left: 8px; cursor: pointer\" title=\"Restore to original size\"></i></div><textarea \nng-disabled=\"vm.isSaving || vm.isSpliting\" rows=\"9\" ng-model=\"vm.workOrder.ai_notes\" \nclass=\"info-form-item detail-info-form-note-input\" ng-hide=\"vm.showAiNotesSection\" \nauto-expand-textarea=\"vm.aiNotesExpanded\">\r\n		</textarea></div></div><div layout=\"row\" layout-wrap><div flex=\"100\" \nflex-gt-sm=\"100\" layout=\"column\" class=\"content-padding-half\"><div>Printed Notes: <i \nng-click=\"vm.showPrintedNotesSection = !vm.showPrintedNotesSection\" \nng-class=\"vm.showPrintedNotesSection ? [\'icon-menu-up\']:[\'icon-arrow-down-drop\']\"></i></div><textarea \nng-disabled=\"vm.isSaving || vm.isSpliting\" rows=\"9\" ng-model=\"vm.workOrder.printed_notes\" \nclass=\"info-form-item detail-info-form-note-input\" ng-hide=\"vm.showPrintedNotesSection\">\r\n		</textarea></div></div><div\n layout=\"row\"><div flex=\"100\" flex-gt-sm=\"50\" class=\"content-padding-half\"><h5 class=\"m-0\">Technician</h5><div \nclass=\"mt-1\" ng-if=\"!vm.isAssignedToMechanic()\" layout=\"row\" layout-align=\"start center\" style=\"font-size: 13px\"><i \nclass=\"icon-alert-outline mr-2\" ng-class=\"vm.mechanics.length > 0 ? [\'text-warning\']:[\'text-red\']\"></i><div>\nPlease specify {{vm.mechanics.length > 0 ? \"supervising licensed technician.\" : \"the technician working on this workorder.\"}}\n</div><button class=\"text-secondary ml-2\" \nng-disabled=\"vm.isAddingMechanic || vm.isRemovingMechanic || vm.isSaving || vm.isSpliting\" \nng-if=\"vm.isMechanic && !vm.isAssignedToMe()\" ng-click=\"vm.assignWorkOrderToMe()\">(Assign to me)</button></div><div \nclass=\"mt-1\"><workorder-mechanic-section mechanics=\"vm.mechanics\" on-add-mechanic=\"vm.addMechanic\" \non-remove-mechanic=\"vm.removeMechanic\" \nis-processing=\"vm.isAddingMechanic || vm.isRemovingMechanic || vm.isSaving || vm.isSpliting\">\n</workorder-mechanic-section></div></div></div><div layout=\"row\"><div flex=\"100\" flex-gt-sm=\"50\" \nclass=\"content-padding-half\"><h5>Preset Jobs <i ng-click=\"vm.showPresetJobTable = !vm.showPresetJobTable\" \nng-class=\"vm.showPresetJobTable ? [\'icon-menu-up\']:[\'icon-arrow-down-drop\']\"></i></h5><workorder-job-type \non-add-click=\"vm.onPresetJobTypeAdd\" part-types=\"vm.partTypes\" jobtypelist=\"vm.JobTypeList\" \nget-recent-job-info=\"vm.getRecentJobInfo\" ng-hide=\"vm.showPresetJobTable\"></workorder-job-type></div></div><div \nlayout=\"row\"><div flex=\"100\" flex-gt-sm=\"50\" class=\"content-padding-half\" \nng-if=\"vm.completedWorkOrderWarranty.length >0\"><h5>Warranties: <i \nng-click=\"vm.showWarrantyfromWorkOrderTable = !vm.showWarrantyfromWorkOrderTable\" \nng-class=\"vm.showWarrantyfromWorkOrderTable ? [\'icon-menu-up\']:[\'icon-arrow-down-drop\']\"></i></h5>\n<workorder-completed-warranty warranty=\"vm.completedWorkOrderWarranty\" vehicle-info=\"vm.vehicle\" \ncovered-mileage=\"vm.totalWarrantyCoveredMileage\" expiry-date=\"vm.warrantyExpiryDate\" \nng-hide=\"vm.showWarrantyfromWorkOrderTable\"></workorder-completed-warranty><workorder-warranty warranty=\"vm.warranty\" \nvehicle-info=\"vm.vehicle\" covered-mileage=\"vm.totalWarrantyCoveredMileage\" expiry-date=\"vm.warrantyExpiryDate\" \nng-hide=\"vm.showWarrantyfromWorkOrderTable\" ng-if=\"vm.warranty\"></workorder-warranty></div></div><div layout=\"row\"><div\n flex=\"100\" flex-gt-sm=\"100\" class=\"content-padding-half\"><h5>Packages: <i \nng-click=\"vm.showPackagefromSaleInfoTable = !vm.showPackagefromSaleInfoTable\" \nng-class=\"vm.showPackagefromSaleInfoTable ? [\'icon-menu-up\']:[\'icon-arrow-down-drop\']\"></i></h5><redeem-item-list \non-redeem-click=\"vm.redeemSalePackageItem\" disable-redeem=\"vm.isRedeeming || vm.isSaving || vm.isSpliting\" \npackage-datas=\"vm.availableItems\" sale-info=\"vm.vehicle\" ng-hide=\"vm.showPackagefromSaleInfoTable\" \nng-if=\"vm.vehicle.is_sold\"></redeem-item-list><redeem-item-list on-redeem-click=\"vm.optionRedeemWorkOrderPackageItem\" \ndisable-redeem=\"vm.isRedeeming || vm.isSaving || vm.isSpliting\" package-datas=\"vm.availableWorkOrderItems\" \nsale-info=\"vm.vehicle\" ng-hide=\"vm.showPackagefromSaleInfoTable\"></redeem-item-list></div></div><div \nclass=\"content-padding-half\"><h5 id=\"{{::vm.partsAnchorTag}}\">Parts</h5><parts-table \ndisable-select=\"vm.isSaving || vm.isSpliting || vm.isDeletingPartTableItems\" \ndisable-adding=\"vm.isSaving || vm.isSpliting || vm.isDeletingPartTableItems\" \ndisable-editing=\"vm.isSaving || vm.isSpliting || vm.isDeletingPartTableItems || vm.workOrder.isCompleted()\" \nsuppliers=\"vm.suppliers\" types=\"vm.partTypes\" part-list=\"vm.partList\" invoice-map=\"vm.invoiceMap\" \nreturn-invoice-map=\"vm.returnInvoiceMap\" is-form-valid=\"vm.isPartTableValid\" \nmatched-inventories=\"vm.matchedInventories\" on-add-new-part=\"vm.addPart\" \non-part-match-inventory=\"vm.onConvertPartToInventory\" on-inventory-quantity-change=\"vm.refreshDemandMap\" \ncurrent-tab-index=\"vm.currentPartTableTabIndex\" on-tab-change=\"vm.onPartTableTabChange\" tabs=\"vm.partTableTabs\" \nhidden-columns=\"vm.hiddenColumns\" work-order-job-list=\"vm.workOrderJobList\" color-cache=\"vm.colorCache\" \ndefault-retail-percentadge=\"vm.defaultRetailPercentadge\"></parts-table><div layout=\"row\" layout-wrap \nlayout-align=\"space-between center\" class=\"ml-2 my-2\"><button ng-click=\"vm.removeSelectedParts()\"><i \nclass=\"icon-delete-forever\" \nng-class=\"vm.workOrder.isCompleted() || vm.isSaving || vm.isSpliting || !vm.isAnyPartSelectedInCurrentTab() || vm.isDeletingPartTableItems ? [\'text-grey\']:[\'text-red\']\">\n</i></button><div layout=\"column\" layout-wrap layout-align=\"space-between center\" class=\"ml-2 my-2 text-red\"><div \nng-hide=\"!vm.showRetailPriceError\">Caution: The retail prices of certain items may not be sufficiently high.</div><div \nng-hide=\"!vm.showCostError\">Caution: Certain parts have no cost value.</div></div><div layout=\"row\" \nlayout-align=\"start center\"><div>Discounts</div><i class=\"text-secondary\" \nng-click=\"vm.showPartDiscount = !vm.showPartDiscount\" \nng-class=\"vm.showPartDiscount ? [\'icon-menu-up\']:[\'icon-arrow-down-drop\']\"></i></div></div><div layout=\"row\" \nlayout-align=\"end center\" ng-if=\"vm.showPartDiscount\"><md-checkbox \nng-change=\"vm.percentageTransaletor(vm.isPartDiscountPercentage, \'partDiscountAmount\')\" \nng-model=\"vm.isPartDiscountPercentage\" class=\"m-0 p-0 ml-3\">Percentage</md-checkbox><input \nng-if=\"vm.isPartDiscountPercentage\" class=\"ml-3 workorder-discount-input\" maxlength=\"4\" \nng-model=\"vm.partDiscountAmount\" input-control input-translate=\"vm.translateToPercentage\" \ninput-options=\"vm.percentageInputOption\" placeholder=\"%\"><input ng-if=\"!vm.isPartDiscountPercentage\" \nclass=\"ml-3 workorder-discount-input\" maxlength=\"6\" ng-model=\"vm.partDiscountAmount\" input-control \ninput-translate=\"vm.translateToDollar\" placeholder=\"$\"><button ng-click=\"vm.addDiscountOnParts()\" \nng-disabled=\"vm.isSaving || vm.isSpliting || (!vm.isAnyPartSelectedInCurrentTab() && vm.isPartDiscountPercentage) || vm.isDeletingPartTableItems\" \nclass=\"btn btn-sm btn-secondary ml-3\"><div tabindex=\"0\" class=\"tabbable-button\">Apply</div></button></div></div><div \nclass=\"content-padding-half\"><h5 id=\"{{::vm.laborsAnchorTag}}\">Labour</h5><div>\nPrice: {{::vm.suggestedLaborPrice.price | currency:\'$\':2}}/Hour</div><md-content><labor-table \ndisable-editing=\"vm.isSaving || vm.isSpliting || vm.isDeletingLabors || vm.workOrder.isCompleted()\" \ndisable-adding=\"vm.isSaving || vm.isSpliting || vm.isDeletingLabors || vm.workOrder.isCompleted()\" \nlabor-list=\"vm.laborList\" selectable=\"true\" suggested-price=\"vm.suggestedLaborPrice.price\" \nis-form-valid=\"vm.isLaborTableValid\" work-order-job-list=\"vm.workOrderJobList\" color-cache=\"vm.colorCache\">\n</labor-table></md-content><div layout=\"row\" layout-wrap layout-align=\"space-between center\" class=\"ml-2 my-2\"><button \nng-disabled=\"vm.isSaving || vm.isSpliting || !vm.isAnyLaborSelected() || vm.isDeletingLabors\" \nng-click=\"vm.removeSelectedLabors()\"><i class=\"icon-delete-forever\" \nng-class=\"vm.workOrder.isCompleted() || vm.isSaving || vm.isSpliting || !vm.isAnyLaborSelected() || vm.isDeletingLabors? [\'text-grey\']:[\'text-red\']\">\n</i></button><div layout=\"row\" layout-align=\"start center\"><div>Discounts</div><i class=\"text-secondary\" \nng-click=\"vm.showLaborDiscount = !vm.showLaborDiscount\" \nng-class=\"vm.showLaborDiscount ? [\'icon-menu-up\']:[\'icon-arrow-down-drop\']\"></i></div></div><div layout=\"row\" \nlayout-align=\"end center\" ng-if=\"vm.showLaborDiscount\"><md-checkbox \nng-change=\"vm.percentageTransaletor(vm.isLaborDiscountPercentage, \'laborDiscountAmount\')\" \nng-model=\"vm.isLaborDiscountPercentage\" class=\"my-0 p-0 ml-3\">Percentage</md-checkbox><input \nng-if=\"vm.isLaborDiscountPercentage\" class=\"ml-3 workorder-discount-input\" maxlength=\"4\" \nng-model=\"vm.laborDiscountAmount\" input-control input-translate=\"vm.translateToPercentage\" \ninput-options=\"vm.percentageInputOption\" placeholder=\"%\"><input ng-if=\"!vm.isLaborDiscountPercentage\" \nclass=\"ml-3 workorder-discount-input\" maxlength=\"6\" ng-model=\"vm.laborDiscountAmount\" input-control \ninput-translate=\"vm.translateToDollar\" placeholder=\"$\"><button ng-click=\"vm.addDiscountOnLabors()\" \nng-disabled=\"vm.isSaving || vm.isSpliting || (!vm.isAnyLaborSelected() && vm.isLaborDiscountPercentage) || isDeletingLabors\" \nclass=\"btn btn-sm btn-secondary ml-3\"><div tabindex=\"0\" class=\"tabbable-button\">Apply</div></button></div></div><div \nclass=\"content-padding-half\"><h5 id=\"{{::vm.miscfeesAnchorTag}}\">Misc Fees</h5><md-content><miscfee-table \ndisable-editing=\"vm.isSaving || vm.isSpliting || vm.isDeletingLabors || vm.workOrder.isCompleted()\" \ndisable-adding=\"vm.isSaving || vm.isSpliting || vm.isDeletingLabors || vm.workOrder.isCompleted()\" \nmiscfeestypeslist=\"vm.MiscFeesList\" selectable=\"true\" suggested-price=\"vm.suggestedLaborPrice.price\" \nis-form-valid=\"vm.isMiscfeeTableValid\" work-order-job-list=\"vm.workOrderJobList\" color-cache=\"vm.colorCache\">\n</miscfee-table></md-content><div layout=\"row\" layout-wrap layout-align=\"space-between center\" class=\"ml-2 my-2\">\n<button ng-disabled=\"vm.isSaving || vm.isSpliting || !vm.isAnyMiscfeesSelected() || vm.isDeletingMiscfees\" \nng-click=\"vm.removeSelectedMiscfees()\"><i class=\"icon-delete-forever\" \nng-class=\"vm.workOrder.isCompleted() || vm.isSaving || vm.isSpliting || !vm.isAnyMiscfeesSelected() || vm.isDeletingMiscfees? [\'text-grey\']:[\'text-red\']\">\n</i></button></div></div><div layout=\"row\" layout-align=\"space-between center\" class=\"content-padding-half\"><md-button \nng-disabled=\"vm.isSaving || vm.isSpliting\" class=\"btn btn-warning mx-0 mt-5 mb-0\" ng-click=\"vm.splitWorkorder()\">split\n</md-button><md-button ng-disabled=\"vm.isSaving || vm.isSpliting\" class=\"btn btn-secondary mx-0 mt-5 mb-0\" \nng-click=\"vm.onSaveClick()\">save</md-button></div>");
$templateCache.put("app/main/workorders/edit-workorder/edit-workorder-logs.html","<style>\ntable {\r\n	  width: 100%;\r\n	  border-collapse: collapse;\r\n	  margin: 20px 0;\r\n	  font-size: 18px;\r\n	  text-align: left;\r\n	}\r\n	th, td {\r\n	  padding: 12px;\r\n	  border: 1px solid #ddd;\r\n	}\r\n	th {\r\n	  background-color: #f4f4f4;\r\n	}\r\n	tr:nth-child(even) {\r\n	  background-color: #f9f9f9;\r\n	}\n</style><div class=\"content-padding-half\"><div><div ng-repeat=\"log in vm.workorderlogs | orderBy:\'-timestamp\'\" \nstyle=\"margin-bottom: 15px; padding: 10px; border: 1px solid #ddd; border-radius: 5px; background-color: #f9f9f9\"><p>\n<span>At {{ log.timestamp }}</span>, <strong>{{ log.created_by }}</strong> <span>{{ log.log }}</span></p></div></div>\n</div>");
$templateCache.put("app/main/workorders/edit-workorder/edit-workorder-payments.html","<div id=\"{{::vm.paymentsAnchorTag}}\" class=\"content-padding-half\"><md-divider class=\"content-padding-bottom-full\">\n</md-divider><workorder-roger-dollar-redeem-list selected-map=\"vm.rogersDollarselectedMap\" \nwork-order-r-d-redeemed-list=\"vm.workOrderRDRedeemedList\" customer-list=\"vm.customerList\">\n</workorder-roger-dollar-redeem-list><div layout=\"row\" layout-wrap layout-align=\"space-between center\" \nng-if=\"vm.workOrderRDRedeemedList.length > 0\"><div flex=\"100\" flex-gt-sm=\"25\" class=\"mb-4\"><br><button \nng-disabled=\"vm.isAddingDiscount || vm.isDeletingDiscount || !vm.isAnyRogersDollarRedeemItemSelected()\" \nng-click=\"vm.deletRogerDollarRedeem()\"><i class=\"icon-delete-forever\" \nng-class=\"vm.isAddingDiscount || vm.isDeletingDiscount || !vm.isAnyRogersDollarRedeemItemSelected() ? [\'text-grey\']:[\'text-red\']\">\n</i></button></div></div><div layout=\"row\" layout-align=\"start center\"><div \nng-if=\"!vm.workOrder.is_subsidized_by_percentage\" flex=\"25\"><md-input-container \nclass=\"input-box small-input-box input-box-padding\"><input ng-model=\"vm.workOrder.subsidized_amount\" \nautocomplete=\"off\" placeholder=\"Subsidized Amount\" maxlength=\"10\" input-control input-translate=\"vm.translateToDollar\">\n</md-input-container></div><div ng-if=\"vm.workOrder.is_subsidized_by_percentage\" flex=\"25\"><md-input-container \nclass=\"input-box small-input-box input-box-padding\"><input ng-model=\"vm.workOrder.subsidized_percentage\" \nautocomplete=\"off\" placeholder=\"Subsidized Percentage\" maxlength=\"5\" input-control \ninput-translate=\"vm.translateToPercentage\" input-options=\"vm.subsidizedPercentageInputOptions\"></md-input-container>\n</div><div><md-checkbox ng-model=\"vm.workOrder.is_subsidized_by_percentage\">Percentage</md-checkbox></div></div><div \nlayout=\"row\"><workorder-payment-list flex=\"100\" payment-methods=\"vm.paymentMethods\" payments=\"vm.payments\" \non-remove-payment=\"vm.deletePayment\" void-credit-card-payment=\"vm.voidCreditCardPayment\" \nrefund-credit-card-payment=\"vm.refundCreditCardPayment\" \nis-processing=\"vm.isAddingPayment || vm.isDeletingPayment || vm.isSaving\"></workorder-payment-list></div><div \nlayout=\"row\"><workorder-payment-creater flex=\"100\" flex-gt-sm=\"100\" customers=\"vm.customers\" \npayment-methods=\"vm.paymentMethods\" on-add-payment=\"vm.addPayment\" clean-inputs=\"vm.cleanPaymentInputs\" \nis-processing=\"vm.isAddingPayment || vm.isDeletingPayment || vm.isSaving\" payment-status-list=\"vm.paymentstatuslist\" \nwork-order=\"vm.workOrder\"></workorder-payment-creater></div><div layout=\"row\" ng-if=\"vm.max_claim > 0\"><div \nclass=\"badge badge-pill badge-warning pull-right\">\nBased on the existing warranty, the maximum amount per claim covered under the warranty is: ${{vm.max_claim}}</div>\n</div><div layout=\"row\" layout-align=\"end center\"><md-button ng-disabled=\"vm.isSaving\" \nclass=\"btn btn-secondary mx-0 mt-5 mb-0\" ng-click=\"vm.onSaveClick()\">save</md-button></div></div>");
$templateCache.put("app/main/workorders/edit-workorder/edit-workorder.html","<div style=\"width: 100%\" class=\"bg-secondary header-backgroud\" layout=\"row\" layout-align=\"center center\" \nid=\"{{::vm.generalAnchorTag}}\"><div flex class=\"content-max-width content-padding-half\" layout=\"row\" \nlayout-align=\"space-between center\" layout-wrap><div layout=\"row\" layout-align=\"space-between center\" flex=\"100\" \nflex-gt-sm=\"75\"><div class=\"content-padding-half\"><div layout=\"row\"><div class=\"h2 white-fg\"><a class=\"text-white\" \nng-href=\"{{::vm.vehicleDetailPageUrl}}\">{{::vm.vehicle.getYearMakeModel()}}</a> - {{::vm.workOrder.invoice_number}}\n</div><button class=\"ml-3\" ng-click=\"vm.deleteWorkorder()\" ng-disabled=\"vm.isDeletingWorkorder\"><i \nclass=\"icon-delete-forever\" ng-class=\"vm.isDeletingWorkorder ? [\'text-grey\'] : [\'text-red\']\"></i></button></div><div \nng-if=\"vm.vehicle.vin\">VIN: {{::vm.vehicle.vin}}</div></div><img class=\"content-padding-half\" \nng-if=\"vm.vehicle.landingImage\" style=\"height: 148px\" ng-src=\"{{vm.vehicle.landingImage}}\"></div><div \nclass=\"content-padding-half\" flex=\"100\" flex-gt-sm=\"25\"><customer-contact-card-list customers=\"vm.customers\" \nphone-categories=\"vm.phoneCategories\" ng-if=\"vm.customers.length > 0\"></customer-contact-card-list></div></div></div>\n<div style=\"width: 100%\" layout=\"row\" layout-align=\"center start\"><div flex \nclass=\"content-max-width content-padding-x-half\" layout=\"row\" layout-wrap><div flex=\"100\" flex-gt-sm=\"75\"><div \nclass=\"content-padding-x-half\"><div layout=\"row\" layout-align=\"space-between center\"><custom-nav-bar \ncurrent-state=\"vm.currentState\" nav-items=\"vm.navItem\"></custom-nav-bar><i ng-click=\"vm.controlSensitiveContent()\" \nng-class=\"vm.showSensitiveContent ? [\'icon-eye\'] : [\'icon-eye-off\']\"></i></div><md-divider></md-divider></div><div \nclass=\"\" ui-view=\"childPage\"></div></div><div flex=\"100\" flex-gt-sm=\"25\"><div class=\"sticky content-padding-y-half\">\n<div class=\"content-padding-half\"><workorder-summary-card hidden-sections=\"vm.hiddenSummarySections\" \non-anchor-clicked=\"vm.onAnchorClicked\" workorder=\"vm.workOrder\" part-list=\"vm.summaryPartList\" \ninventory-list=\"vm.summaryInventoryList\" labor-list=\"vm.summarylaborList\" miscfees-list=\"vm.summarymiscfeesList\" \ndiscount-list=\"vm.summaryDiscountList\" payment-list=\"vm.summaryPaymentList\" \nwarranty-payment-list=\"vm.warrantyPaymentList\" credit-card-payment-list=\"vm.creditCardPaymentList\" \nwork-order-warranty-list=\"vm.workOrderWarrantyList\" work-order-package-list=\"vm.summaryWorkOrderPackageList\" \nworkorder-status-options=\"vm.workOrderStatus\" demand-map=\"vm.summaryDemandMap\" \nwork-order-rd-generated=\"vm.summaryworkOrderRDGenerated\" work-order-rd-redeemed=\"vm.summaryworkOrderRDRedeemed\">\n</workorder-summary-card></div><div class=\"content-padding-half\"><div class=\"card\" style=\"font-size: 13px\" \nng-if=\"!vm.isMechanic && vm.customers.length > 0\"><div class=\"card-header py-1 bg-black\"><div \nclass=\"text-white font-weight-bold\">Payment</div></div><div class=\"card-body\"><form layout=\"row\" \nlayout-align=\"center center\" layout-wrap ng-submit=\"vm.addPaymentShortCut()\"><md-input-container flex=\"100\" \nclass=\"input-box small-input-box\"><label>Customer</label><md-select ng-model=\"vm.paymentCustomer\"><md-option \nng-repeat=\"customer in vm.customers | orderBy:\'first_name\'\" ng-value=\"customer\">\n{{::customer.first_name + \' \' + customer.last_name}}</md-option></md-select></md-input-container><md-input-container \nflex=\"100\" class=\"input-box small-input-box\"><label>Method</label><md-select ng-model=\"vm.paymentMethodID\"><md-option \nng-repeat=\"paymentMethod in vm.paymentMethods | orderBy:\'name\'\" ng-value=\"paymentMethod.id_payment_method\">\n{{::paymentMethod.name}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" \nclass=\"input-box small-input-box\" ng-if=\"vm.paymentMethodID == 6\"><label>Status</label><md-select \nng-model=\"vm.paymentStatusID\"><md-option ng-repeat=\"item in vm.workorderpaymentstatus | orderBy:\'name\'\" \nng-value=\"item.id_payment_status\">{{::item.name}}</md-option></md-select></md-input-container><md-input-container \nflex=\"100\" class=\"input-box small-input-box\" ng-hide=\"vm.paymentMethodID != 11 || vm.customerCreditCards.length == 0\">\n<label>Credit Card</label><md-select ng-model=\"vm.creditCardSelected\"><md-option \nng-repeat=\"card in vm.customerCreditCards\" ng-value=\"card\">\n{{card.cardType}}--{{card.cardNumber}}--{{card.expiryDate | date:\'MM/yy\'}}</md-option></md-select></md-input-container>\n<md-input-container flex=\"100\" class=\"input-box small-input-box\" \nng-hide=\"vm.customerCreditCards.length != 0 || vm.paymentMethodID != 11\"><div>Selected customer have no credit card.\n</div></md-input-container><md-input-container flex=\"100\" class=\"input-box small-input-box\"><br><input \nng-model=\"vm.paymentAmount\" autocomplete=\"off\" placeholder=\"Amount\" maxlength=\"10\" input-control \ninput-translate=\"vm.translateToDollar\"></md-input-container><md-button flex=\"100\" \nclass=\"mx-0 btn-sm btn-secondary mb-5\" ng-click=\"vm.addPaymentShortCut()\" \nng-class=\"vm.isAddingPayment || !vm.paymentCustomer || !vm.paymentMethodID || vm.paymentAmount == null ? [\'text-grey\']:[\'\']\" \nng-disabled=\"vm.isAddingPayment || !vm.paymentCustomer || !vm.paymentMethodID || vm.paymentAmount == null\">Add Payment\n</md-button></form></div></div></div><div class=\"content-padding-half\"><div class=\"card\" style=\"font-size: 13px\" \nng-if=\"vm.isServiceAdvisor\"><div class=\"card-header py-1 bg-black\"><div class=\"text-white font-weight-bold\">\nSend Workorder Link to Customer</div></div><div class=\"card-body\"><div layout=\"row\" layout-align=\"center center\">\n<md-input-container ng-if=\"vm.customers.length > 0\" flex class=\"input-box small-input-box\"><label>Customer</label>\n<md-select ng-model=\"vm.trackingCustomerID\" ng-change=\"vm.onTrackingCustomerChange()\"><md-option \nng-repeat=\"customer in vm.customers | orderBy:\'first_name\'\" ng-value=\"customer.id_customer\">\n{{::customer.first_name + \' \' + customer.last_name}} <span ng-if=\"vm.getCustomerPhoneDisplay(customer)\">\n- {{vm.getCustomerPhoneDisplay(customer)}}</span></md-option></md-select></md-input-container></div><div layout=\"row\">\n<md-button flex class=\"mx-0 btn-sm btn-secondary\" ng-disabled=\"!vm.trackingCustomerID || vm.isSendingTrackingLink\" \nng-click=\"vm.sendTrackingLink()\"><div style=\"display: flex; justify-content: center\"><span \nng-if=\"!vm.isSendingTrackingLink\">Send Link via SMS</span><md-progress-circular ng-if=\"vm.isSendingTrackingLink\" \nmd-diameter=\"20\"></md-progress-circular></div></md-button></div></div></div><br><div class=\"card\" \nstyle=\"font-size: 13px\" ng-if=\"vm.isServiceAdvisor\"><div class=\"card-header py-1 bg-black\"><div \nclass=\"text-white font-weight-bold\">Print Workorder</div></div><div class=\"card-body\"><div layout=\"row\" \nlayout-align=\"center center\"><md-input-container ng-if=\"vm.customers.length > 0\" flex \nclass=\"input-box small-input-box\"><label>Customer</label><md-select ng-model=\"vm.printCustomerID\" \nng-change=\"vm.onPDFEmailCustomerChange()\"><md-option ng-repeat=\"customer in vm.customers | orderBy:\'first_name\'\" \nng-value=\"customer.id_customer\">{{::customer.first_name + \' \' + customer.last_name}}</md-option></md-select>\n</md-input-container><md-input-container flex class=\"input-box small-input-box\"><md-select \nng-init=\"vm.isQuoted = vm.workOrder.isQuoted()\" ng-model=\"vm.isQuoted\"><md-option ng-value=\"true\">Quoted</md-option>\n<md-option ng-value=\"false\">Invoice</md-option></md-select></md-input-container></div><div layout=\"row\" \nlayout-align=\"center center\" class=\"my-1\"><md-radio-group ng-model=\"vm.printMode\" layout=\"row\"><md-radio-button \nvalue=\"current\" class=\"mr-3\">Current Work Order</md-radio-button><md-radio-button value=\"dateRange\">Date Range\n</md-radio-button></md-radio-group></div><div layout=\"row\" layout-wrap ng-if=\"vm.printMode === \'dateRange\'\">\n<md-input-container flex class=\"input-box small-input-box\"><label>Start Date</label><input type=\"date\" \nng-model=\"vm.printStartDate\"></md-input-container><md-input-container flex class=\"input-box small-input-box ml-2\">\n<label>End Date</label><input type=\"date\" ng-model=\"vm.printEndDate\"></md-input-container></div><div layout=\"row\">\n<md-button flex class=\"mx-0 btn-sm btn-secondary\" ng-disabled=\"vm.isPrinting\" ng-click=\"vm.print()\">Print</md-button>\n</div><md-input-container flex=\"grow\" layout=\"row\"><input type=\"email\" ng-change=\"vm.queryCustomers()\" \nng-required=\"true\" name=\"{{\'email\'}}\" ng-model=\"vm.clientEmailAddressHolder\" autocomplete=\"off\" \nplaceholder=\"Email Address\" ng-model-options=\"{ debounce: 700 }\" maxlength=\"50\"><div \nng-messages=\"custormerBasicInfoForm[\'email\'].$error\"><div ng-message=\"maxlength\">\nInput content can not be over 50 charactors</div><div ng-message=\"required\">This field is required</div><div \nng-message=\"email\">Invalid email address</div></div></md-input-container><div layout=\"row\"><md-button flex \nclass=\"mx-0 btn-sm btn-secondary\" ng-disabled=\"vm.isSaving || vm.isSpliting || vm.sendingRegistrationEmail\" flex=\"\" \nng-click=\"vm.getPDFFromWorkOrder()\"><div style=\"display: flex; justify-content: center\"><span ng-if=\"!vm.isPrinting\">\nsend</span><md-progress-circular ng-if=\"vm.isPrinting\" md-diameter=\"20\"></md-progress-circular></div></md-button></div>\n</div></div><br><div class=\"card\" style=\"font-size: 13px\" ng-hide=\"!vm.isServiceAdvisor\"><div \nclass=\"card-header py-1 bg-black\"><div class=\"text-white font-weight-bold\">Print Workorder QR Code</div></div><div \nclass=\"card-body\"><div id=\"qrcode\"></div></div><div layout=\"row\"><md-button flex class=\"mx-0 btn-sm btn-secondary\" \nng-disabled=\"vm.isPrinting\" ng-click=\"vm.printQR()\">Print</md-button></div></div></div></div></div></div></div>");
$templateCache.put("app/main/workorders/schedule/calendar-event-title-editor-dialog.html","<div class=\"card\" style=\"width: 500px\"><div class=\"modal-header bg-secondary\"><h6 class=\"modal-title\">Edit</h6><button \ntype=\"button\" class=\"text-red\" ng-click=\"vm.deleteClicked()\">Delete Appointment</button></div><div class=\"card-body\">\n<div layout=\"row\"><textarea class=\"simple-border\" flex rows=\"3\" placeholder=\"Title\" ng-model=\"vm.title\">		\r\n			\n</textarea></div><div layout=\"row\" layout-align=\"center center\"><md-button class=\"btn-danger\" \nng-click=\"vm.closeDialog()\">cancel</md-button><md-button class=\"btn-secondary\" ng-click=\"vm.save()\">save</md-button>\n</div></div></div>");
$templateCache.put("app/main/workorders/schedule/schedule-warning-item.html","<div layout=\"row\" layout-align=\"space-between center\" \nng-click=\"vm.showWarningMessageDetail = !vm.showWarningMessageDetail\"><div class=\"font-weight-bold\">\n{{vm.title}} ({{vm.getCount()}})</div><i \nng-class=\"vm.showWarningMessageDetail ? [\'icon-menu-up\'] : [\'icon-arrow-down-drop\']\"></i></div><md-divider \nclass=\"my-1\"></md-divider><div ng-if=\"vm.showWarningMessageDetail\" layout=\"row\" layout-align=\"space-between start\" \nng-repeat=\"(workorderID, item) in vm.workorderAppointmentDetails\"><div><a \nng-href=\"{{vm.getWorkorderUrl(workorderID, item.workorder.fk_id_vehicle)}}\">{{item.workorder.invoice_number}}</a></div>\n<div><div class=\"text-right mb-1\" ng-repeat=\"appointment in item.appointments\">\n{{appointment.start | date: vm.warningMessageDateFormat}}<md-tooltip class=\"multiline-tooltip\">{{appointment.title}}\n</md-tooltip></div></div></div>");
$templateCache.put("app/main/workorders/schedule/schedule.html","<div style=\"width: 100%\" class=\"bg-secondary header-backgroud\" layout=\"row\" layout-align=\"center center\"><div flex \nclass=\"content-max-width content-padding-x-full\"><span class=\"h2 white-fg\">Schedule</span></div></div><div \nstyle=\"width: 100%\" layout=\"row\" layout-align=\"center start\"><div flex \nclass=\"content-max-width content-padding-x-full\" layout=\"row\" layout-wrap><div flex=\"100\" flex-gt-sm=\"25\" \nclass=\"pr-3 py-2\"><div class=\"card\"><div class=\"card-header py-1 bg-secondary\"><span style=\"float: left\">Filters</span>\n <span style=\"float: right\" restrict rolescansee=\"developer company_manager\">Notification</span></div><div \nclass=\"card-body\"><div layout=\"column\"><div ng-repeat=\"calendar in vm.calendars\"><div \nstyle=\"display: flex; justify-content: space-between; align-items: center\"><div style=\"flex-grow: 1\"><md-checkbox \nng-style=\"{\'color\': calendar.color}\" ng-change=\"vm.refreshCalendarGrid()\" ng-model=\"calendar.isShow\">\n{{::calendar.name}}</md-checkbox></div><button ng-style=\"{\'color\': calendar.color, \'margin-bottom\': \'20px\'}\" \nng-click=\"vm.refreshCalendarNotification(calendar)\" ng-model=\"calendar.notification\" restrict \nrolescansee=\"developer company_manager\"><md-icon class=\"icon-alarm-check text-secondary\" \nng-if=\"calendar.notification === true\"></md-icon><md-icon class=\"icon-alarm-off text-secondary\" \nng-if=\"calendar.notification !== true\"></md-icon></button></div></div></div><div layout=\"row\" layout-wrap><div \nlayout=\"row\" layout-align=\"start center\" ng-repeat=\"customFilter in vm.pageConfigs.customFilters track by $index\" \nng-class=\"vm.isCustomFilterApplied(customFilter) ? [\'text-secondary\']:[]\" class=\"mr-2 my-1 px-1 simple-border\"><div \nng-click=\"vm.selectCustomFilter(customFilter.name)\">{{customFilter.name}}</div><button \nng-disabled=\"vm.isSavingFilter || vm.isDeletingFilter\" ng-click=\"vm.deleteCustomFilter($index)\"><md-icon \nclass=\"icon-close text-red\"></md-icon></button></div><div ng-if=\"!(vm.pageConfigs.customFilters.length > 0)\">\nYou haven\'t saved any filter yet.</div></div><div layout=\"row\" layout-align=\"space-between center\" class=\"mt-3\"><input \nflex class=\"mr-2\" ng-model=\"vm.newCustomFilterName\" autocomplete=\"off\" placeholder=\"Filter Name\" maxlength=\"50\"> \n<button ng-disabled=\"!vm.newCustomFilterName || vm.isSavingFilter || vm.isDeletingFilter\" \nng-click=\"vm.addCustomFilter()\"><i class=\"icon-plus-circle\" ng-class=\"vm.newCustomFilterName? [\'text-green\']:[]\"></i>\n</button></div></div></div><div class=\"mt-3 card\" ng-if=\"vm.showWarningMessageBox()\"><div \nclass=\"card-header py-1 bg-yellow\">Warnings</div><md-progress-linear ng-disabled=\"!vm.isRefreshingWarningMessage\" \nmd-mode=\"indeterminate\"></md-progress-linear><div class=\"card-body\" style=\"font-size: 13px\"><div class=\"mb-3\" \nng-if=\"vm.underRateWorkordersCount > 0\"><schedule-warning-item title=\"\'Parts retail are under rate\'\" \nworkorder-appointment-details=\"vm.underRateWorkorders\"></schedule-warning-item></div><div class=\"mb-3\" \nng-if=\"vm.emptyWorkordersCount > 0\"><schedule-warning-item title=\"\'Empty work orders\'\" \nworkorder-appointment-details=\"vm.emptyWorkorders\"></schedule-warning-item></div><div class=\"mb-3\" \nng-if=\"vm.partsNotOrderedCount > 0\"><schedule-warning-item title=\"\'Parts not ordered\'\" \nworkorder-appointment-details=\"vm.partsNotOrdered\"></schedule-warning-item></div><div class=\"mb-3\" \nng-if=\"vm.inventoryInsufficientCount > 0\"><div layout=\"row\" layout-align=\"space-between center\" \nng-click=\"vm.showInventoryInsufficientWarningMessageDetail = !vm.showInventoryInsufficientWarningMessageDetail\"><div \nclass=\"font-weight-bold\">Inventory insufficient ({{vm.inventoryInsufficientCount}})</div><i \nng-class=\"vm.showInventoryInsufficientWarningMessageDetail ? [\'icon-menu-up\'] : [\'icon-arrow-down-drop\']\"></i></div>\n<md-divider class=\"my-1\"></md-divider><div ng-if=\"vm.showInventoryInsufficientWarningMessageDetail\" class=\"mb-2\" \nng-repeat=\"(inventoryID, item) in vm.inventoryInsufficient\"><div>{{item.name}} <span class=\"font-italic text-grey\">\n{{item.code}}</span></div><div layout=\"row\" layout-align=\"space-between start\" class=\"mb-1\" \nng-repeat=\"(workorderID, detail) in item.details\"><div><a \nng-href=\"{{vm.getWorkorderUrl(workorderID, detail.workorder.fk_id_vehicle)}}\">{{detail.workorder.invoice_number}}</a>\n</div><div><div class=\"text-right mb-1\" ng-repeat=\"appointment in detail.appointments\">\n{{appointment.start | date: vm.warningMessageDateFormat}}<md-tooltip class=\"multiline-tooltip\">{{appointment.title}}\n</md-tooltip></div></div></div></div></div><div class=\"mb-3\" ng-if=\"vm.passedDueTimeCount > 0\"><schedule-warning-item \ntitle=\"\'Passed due appointments\'\" workorder-appointment-details=\"vm.passedDueTime\"></schedule-warning-item></div><div \nclass=\"mb-3\" ng-if=\"vm.completedWithOutstandingCount > 0\"><schedule-warning-item title=\"\'Completed with outstanding\'\" \nworkorder-appointment-details=\"vm.completedWithOutstanding\"></schedule-warning-item></div></div></div><div \nclass=\"mt-3 card\"><div class=\"card-header py-1 bg-secondary\">New Appointment</div><div class=\"card-body\"><div \nstyle=\"border-style: dashed\" class=\"simple-border p-1 mb-1\"><div ng-click id=\"newAppointment\"><div \nclass=\"font-weight-bold\">Custom Appointment</div></div><div layout=\"row\"><textarea flex rows=\"3\" placeholder=\"Title\" \nng-model=\"vm.newAppointment.title\">		\r\n							</textarea></div></div><div id=\"newWorkOrderAppointment\" \nng-show=\"vm.showNewWorkOrderAppointment && !vm.loadingNewWorkorderAppointment\" ng-click style=\"border-style: dashed\" \nclass=\"simple-border p-1 mb-4\"><a ng-href=\"{{vm.workOrderUrl}}\" class=\"font-weight-bold\">\n{{::vm.workOrderInvoiceNumber}}</a><div class=\"pre-wrap\">{{::vm.workOrderAppointmentTitle}}</div></div><div \nng-if=\"vm.showNewWorkOrderAppointment && vm.loadingNewWorkorderAppointment\">Initializing work order appointment...\n</div><div id=\"newCustomAppointment\" ng-show=\"vm.showNewCustomAppointment && !vm.loadingNewCustomAppointment\" ng-click \nstyle=\"border-style: dashed\" class=\"simple-border p-1 mb-4\"><a ng-href=\"{{vm.CustomerUrl}}\" class=\"font-weight-bold\">\nCustomer Page</a><div class=\"pre-wrap\">{{::vm.customAppointmentTitle}}</div></div><div \nng-if=\"vm.showNewCustomAppointment && vm.loadingNewCustomAppointment\">Initializing custom appointment...</div></div>\n</div></div><div flex=\"100\" flex-gt-sm=\"75\" class=\"pt-1 pb-3\"><div \nng-class=\"vm.isLoadingEvents ? [\'full-calendar-opacity-50\']:[]\" id=\"calendar\"></div></div></div></div>");
$templateCache.put("app/main/workorders/schedule/select-calendar-dialog.html","<div class=\"card\"><div class=\"modal-header bg-red\"><h6 class=\"modal-title\">Select Calendar</h6><button type=\"button\" \nclass=\"close\" ng-click=\"vm.closeDialog()\"><span>&times;</span></button></div><div class=\"card-body\"><md-radio-group \nng-model=\"vm.selectedCalendar\" ng-change=\"vm.select(vm.selectedCalendar)\"><md-radio-button \nng-style=\"{\'color\':calendar.color}\" ng-repeat=\"calendar in vm.calendars\" ng-if=\"calendar.id_calendar != 8\" \nvalue=\"{{calendar.id_calendar}}\">{{::calendar.name}}</md-radio-button></md-radio-group></div></div>");
$templateCache.put("app/main/workorders/workorder-detail-nav/workorder-detail-nav.html","<div layout=\"row\" hide-xs hide-sm show-gt-sm style=\"overflow-x: auto\"><a ng-href=\"{{::vm.getLink(navItem.state)}}\" \nng-repeat=\"navItem in vm.navItems\"><md-button class=\"mx-0 mb-0\" \nng-class=\"vm.currentState == navItem.state? [\'custom-nav-item\', \'text-black\']:[\'text-grey\']\" \nng-click=\"vm.goToState(navItem.state)\">{{::navItem.name}}</md-button></a></div><div style=\"position: relative\" show-xs \nshow-sm hide-gt-sm><div layout=\"row\" layout-align=\"end center\"><md-button class=\"mx-0\" disabled=\"disabled\">\n{{vm.getCurrentTabName()}}</md-button><button><i class=\"icon-menu\" ng-click=\"vm.showMenu = ! vm.showMenu\"></i></button>\n</div><div class=\"bg-white simple-border-no-radius\" ng-if=\"vm.showMenu\" \nstyle=\"position: absolute; top: 100%; z-index: 99; width: 100%\"><div ng-repeat=\"navItem in vm.navItems\" \nng-if=\"vm.currentState != navItem.state\"><div layout=\"row\" layout-align=\"end center\"><a class=\"text-grey m-2\" \nng-href=\"{{::vm.getLink(navItem.state)}}\">{{::navItem.name}}</a></div><md-divider></md-divider></div></div></div>");
$templateCache.put("app/toolbar/layouts/content-with-toolbar/toolbar.html","<div layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><div class=\"logo\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"logo-image\">F</span> <span class=\"logo-text\">FUSE</span></div>\n<div class=\"toolbar-separator\"></div><ms-shortcuts></ms-shortcuts><div class=\"toolbar-separator\"></div></div><div \nlayout=\"row\" layout-align=\"start center\"><md-progress-circular id=\"toolbar-progress\" ng-if=\"$root.loadingProgress\" \nclass=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"32\"></md-progress-circular><div class=\"toolbar-separator\"></div>\n<md-menu-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button class=\"user-button\" \nng-click=\"$mdOpenMenu()\" aria-label=\"User settings\" translate translate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" \nsrc=\"assets/images/avatars/profile.jpg\"><md-icon md-font-icon ng-class=\"vm.userStatus.icon\" \nng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon status s16\"></md-icon></div><span class=\"username\" hide-sm>\nJohn Doe</span><md-icon md-font-icon=\"icon-chevron-down\" class=\"icon s16\" hide-sm></md-icon></div></md-button>\n<md-menu-content width=\"3\"><md-menu-item class=\"md-indent\" ui-sref=\"app.pages_profile\"><md-icon \nmd-font-icon=\"icon-account\" class=\"icon\"></md-icon><md-button>My Profile</md-button></md-menu-item><md-menu-item \nclass=\"md-indent\" ui-sref=\"app.mail\"><md-icon md-font-icon=\"icon-email\" class=\"icon\"></md-icon><md-button>Inbox\n</md-button></md-menu-item><md-menu-item class=\"md-indent\"><md-icon md-font-icon ng-class=\"vm.userStatus.icon\" \nng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon\"></md-icon><md-menu id=\"user-status-menu\"><md-button \nng-click=\"$mdOpenMenu()\" class=\"status\" ng-class=\"vm.userStatus.class\">{{vm.userStatus.title}}</md-button>\n<md-menu-content width=\"2\"><md-menu-item class=\"status md-indent\" ng-class=\"{\'selected\': status === vm.userStatus}\" \nng-repeat=\"status in vm.userStatusOptions\"><md-icon md-font-icon=\"{{status.icon}}\" ng-style=\"{\'color\': status.color }\" \nclass=\"icon\"></md-icon><md-button ng-click=\"vm.setUserStatus(status)\">{{status.title}}</md-button></md-menu-item>\n</md-menu-content></md-menu></md-menu-item><md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><md-icon \nmd-font-icon=\"icon-logout\" class=\"icon\"></md-icon><md-button ng-click=\"vm.logout()\">Logout</md-button></md-menu-item>\n</md-menu-content></md-menu></md-menu-bar><div class=\"toolbar-separator\"></div><ms-search-bar \non-search=\"vm.search(query)\" on-result-click=\"vm.searchResultClick(item)\" debounce=\"300\"></ms-search-bar><div \nclass=\"toolbar-separator\"></div><md-menu id=\"language-menu\" md-offset=\"0 72\" md-position-mode=\"target-right target\">\n<md-button class=\"language-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"Language\" md-menu-origin md-menu-align-target>\n<div layout=\"row\" layout-align=\"center center\"><img class=\"flag\" \nng-src=\"assets/images/flags/{{vm.selectedLanguage.flag}}.png\"> <span class=\"iso\">{{vm.selectedLanguage.code}}</span>\n</div></md-button><md-menu-content width=\"3\" id=\"language-menu-content\"><md-menu-item \nng-repeat=\"(iso, lang) in vm.languages\"><md-button ng-click=\"vm.changeLanguage(lang)\" aria-label=\"{{lang.title}}\" \ntranslate translate-attr-aria-label=\"{{lang.title}}\"><span layout=\"row\" layout-align=\"start center\"><img class=\"flag\" \nng-src=\"assets/images/flags/{{lang.flag}}.png\"> <span translate=\"{{lang.translation}}\">{{lang.title}}</span></span>\n</md-button></md-menu-item></md-menu-content></md-menu><div class=\"toolbar-separator\"></div><md-button \nid=\"quick-panel-toggle\" class=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'quick-panel\')\" \naria-label=\"Toggle quick panel\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_QUICK_PANEL\"><md-icon \nmd-font-icon=\"icon-format-list-bulleted\" class=\"icon\"></md-icon></md-button></div></div>");
$templateCache.put("app/main/workorders/workorder-summary/workorder-summary-card.html","<div class=\"card\" style=\"font-size: 13px\"><div class=\"card-header py-1 bg-black\"><div \nclass=\"text-white font-weight-bold\" ng-click=\"vm.onAnchorClicked(vm.generalAnchorTag)\"><span \nng-if=\"vm.workorder.invoice_number != null\">{{::vm.workorder.invoice_number}} - </span><span \nng-if=\"vm.workorder.fk_id_work_order_status != null\">{{vm.getWorkOrderStatus()}} - </span><span \nng-if=\"vm.workorder.mileage != null\">{{vm.workorder.mileage | number}}KM</span></div></div><div class=\"card-body\"><div \nng-if=\"!vm.hiddenSections.parts && (vm.partList.length > 0 || vm.inventoryList.length > 0)\"><div \nclass=\"font-weight-bold\" ng-click=\"vm.onAnchorClicked(vm.partsAnchorTag)\">Parts</div><md-divider class=\"my-1\">\n</md-divider><div layout=\"row\" layout-align=\"start center\" ng-repeat=\"partItem in vm.partList track by $index\" \nng-class=\"vm.getPartStyleClass(partItem)\"><div flex=\"20\" class=\"text-nowrap text-truncate\">\n{{partItem.quantity | number}}</div><div flex=\"50\" class=\"text-nowrap text-truncate\">{{partItem.name}}</div><div \nflex=\"30\" class=\"text-nowrap text-truncate text-right\">{{partItem.retail_price * partItem.quantity | currency:\'$\':2}}\n</div></div><div layout=\"row\" layout-align=\"start center\" ng-repeat=\"inventory in vm.inventoryList track by $index\" \nng-class=\"vm.getInventoryStyleClass(inventory)\"><div flex=\"20\" class=\"text-nowrap text-truncate\">\n{{inventory.quantity | number}}</div><div flex=\"50\" class=\"text-nowrap text-truncate\">{{inventory.name}}</div><div \nflex=\"30\" class=\"text-nowrap text-truncate text-right\">{{inventory.retail_price * inventory.quantity | currency:\'$\':2}}\n</div></div><md-divider class=\"my-1\"></md-divider><div layout=\"row\" layout-align=\"end center\"><div \nclass=\"text-right text-nowrap text-truncate\">{{vm.totalPartsAndInventoriesRetails | currency:\'$\':2}}</div></div></div>\n<div class=\"mt-3\" ng-if=\"!vm.hiddenSections.labors && vm.laborList.length > 0\"><div class=\"font-weight-bold\" \nng-click=\"vm.onAnchorClicked(vm.laborsAnchorTag)\">Labors</div><md-divider class=\"my-1\"></md-divider><div layout=\"row\" \nlayout-align=\"start center\" ng-repeat=\"laborItem in vm.laborList track by $index\"><div flex=\"20\" \nclass=\"text-nowrap text-truncate\">{{laborItem.hour}}</div><div flex=\"50\" class=\"text-nowrap text-truncate\">\n{{laborItem.name}}</div><div flex=\"30\" class=\"text-nowrap text-truncate text-right\">\n{{laborItem.price * laborItem.hour | currency:\'$\':2}}</div></div><md-divider class=\"my-1\"></md-divider><div \nlayout=\"row\" layout-align=\"end center\"><div class=\"text-right text-nowrap text-truncate\">\n{{vm.totalLaborsCost | currency:\'$\':2}}</div></div></div><div class=\"mt-3\" \nng-if=\"!vm.hiddenSections.miscfee && vm.miscfeesList.length > 0\"><div class=\"font-weight-bold\" \nng-click=\"vm.onAnchorClicked(vm.miscfeeAnchorTag)\">Misc Fee</div><md-divider class=\"my-1\"></md-divider><div \nlayout=\"row\" layout-align=\"start center\" ng-repeat=\"MiscfeesItem in vm.miscfeesList track by $index\"><div flex=\"20\" \nclass=\"text-nowrap text-truncate\">{{MiscfeesItem.quantity}}</div><div flex=\"50\" class=\"text-nowrap text-truncate\">\n{{MiscfeesItem.name}}</div><div flex=\"30\" class=\"text-nowrap text-truncate text-right\">\n{{MiscfeesItem.price * MiscfeesItem.quantity | currency:\'$\':2}}</div></div><md-divider class=\"my-1\"></md-divider><div \nlayout=\"row\" layout-align=\"end center\"><div class=\"text-right text-nowrap text-truncate\">\n{{vm.totalMiscfeesCost | currency:\'$\':2}}</div></div></div><div class=\"mt-3\" \nng-if=\"!vm.hiddenSections.parts && (vm.workOrderPackageList.length > 0 || vm.workOrderPackageList > 0)\"><div \nclass=\"font-weight-bold\" ng-click=\"vm.onAnchorClicked(vm.paymentsAnchorTag)\">Work Order Package</div><md-divider \nclass=\"my-1\"></md-divider><div layout=\"row\" layout-align=\"space-between center\" \nng-repeat=\"package in vm.workOrderPackageList track by $index\"><div class=\"text-nowrap text-truncate\"><span>\n{{package.name}}</span></div><div class=\"text-nowrap text-truncate\">{{package.price | currency:\'$\':2}}</div></div>\n<md-divider class=\"my-1\"></md-divider><div layout=\"row\" layout-align=\"end center\"><div \nclass=\"text-right text-nowrap text-truncate\">{{vm.totalPackageCost | currency:\'$\':2}}</div></div></div><div \nclass=\"mt-3\" ng-if=\"!vm.hiddenSections.parts && (vm.workOrderWarrantyList.length > 0 || vm.workOrderWarrantyList > 0)\">\n<div class=\"font-weight-bold\" ng-click=\"vm.onAnchorClicked(vm.paymentsAnchorTag)\">Work Order Warranty</div><md-divider \nclass=\"my-1\"></md-divider><div layout=\"row\" layout-align=\"space-between center\" \nng-repeat=\"warranty in vm.workOrderWarrantyList track by $index\"><div class=\"text-nowrap text-truncate\"><span>\n{{warranty.name}}</span></div><div class=\"text-nowrap text-truncate\">{{warranty.retail | currency:\'$\':2}}</div></div>\n<md-divider class=\"my-1\"></md-divider><div layout=\"row\" layout-align=\"end center\"><div \nclass=\"text-right text-nowrap text-truncate\">{{vm.totalWarrantyCost | currency:\'$\':2}}</div></div></div><div \nclass=\"mt-3\" ng-if=\"!vm.hiddenSections.discounts && vm.discountList.length > 0\"><div class=\"font-weight-bold\" \nng-click=\"vm.onAnchorClicked(vm.discountsAnchorTag)\">Discounts</div><md-divider class=\"my-1\"></md-divider><div \nlayout=\"row\" layout-align=\"space-between center\" ng-repeat=\"item in vm.discountDetailList track by $index\"><div \nng-if=\"!item.discountData.resourceData\" flex=\"50\" class=\"text-nowrap text-truncate\">{{item.discountData.description}} \n<span ng-if=\"item.discountData.is_percentage\">({{item.discountData.percentage_off * 100}}%)</span></div><div \nclass=\"text-nowrap text-truncate\" ng-if=\"!item.discountData.resourceData\">\n{{-1 * item.deductionAmount | currency:\'$\':2}}</div></div></div><div class=\"mt-3\" \nng-if=\"!vm.hiddenSections.discounts && vm.discountDetailList.length > 0\"><md-divider class=\"my-1\"></md-divider><div \nlayout=\"row\" layout-align=\"space-between center\" ng-repeat=\"item in vm.discountDetailList track by $index\"><div \nflex=\"50\" ng-if=\"item.discountData.resourceData\" class=\"text-nowrap text-truncate\">Rogers Dollar Redeem</div><div \nclass=\"text-nowrap text-truncate\" ng-if=\"item.discountData.resourceData\">{{-1 * item.deductionAmount | currency:\'$\':2}}\n</div></div></div><div class=\"mt-3\" ng-if=\"!vm.hiddenSections.payments && vm.paymentList.length > 0\"><div \nclass=\"font-weight-bold\" ng-click=\"vm.onAnchorClicked(vm.paymentsAnchorTag)\">Payments</div><md-divider class=\"my-1\">\n</md-divider><div layout=\"row\" layout-align=\"space-between center\" \nng-repeat=\"payment in vm.paymentList track by $index\"><div class=\"text-nowrap text-truncate\"><span>\n{{payment.payment_date | date:\'mediumDate\'}}</span> <span>\n{{payment.customer.first_name + \' \' + payment.customer.last_name}}</span></div><div class=\"text-nowrap text-truncate\">\n{{payment.amount | currency:\'$\':2}}</div></div></div><div class=\"mt-3\" \nng-if=\"!vm.hiddenSections.payments && vm.paymentList.length > 0 && vm.creditCardPaymentList.length > 0\"><div \nclass=\"font-weight-bold\" ng-click=\"vm.onAnchorClicked(vm.paymentsAnchorTag)\">Credit Card</div><md-divider class=\"my-1\">\n</md-divider><div layout=\"row\" layout-align=\"space-between center\" ng-if=\"vm.creditCardAmount > 0\"><div \nclass=\"text-nowrap text-truncate\">Credit-Card-Approved</div><div class=\"text-nowrap text-truncate\">\n{{vm.creditCardAmount | currency:\'$\':2}}</div></div><div layout=\"row\" layout-align=\"space-between center\" \nng-if=\"vm.voidedCreditCardAmount > 0\"><div class=\"text-nowrap text-truncate\">Credit-Card-Declined/Void</div><div \nclass=\"text-nowrap text-truncate\">{{vm.voidedCreditCardAmount | currency:\'$\':2}}</div></div><div layout=\"row\" \nlayout-align=\"space-between center\" ng-if=\"vm.refundCreditCardAmount > 0\"><div class=\"text-nowrap text-truncate\">\nCredit-Card-Refund</div><div class=\"text-nowrap text-truncate\">{{vm.refundCreditCardAmount | currency:\'$\':2}}</div>\n</div></div><div class=\"mt-3\" \nng-if=\"!vm.hiddenSections.payments && vm.paymentList.length > 0 && vm.warrantyPaymentList.length > 0\"><div \nclass=\"font-weight-bold\" ng-click=\"vm.onAnchorClicked(vm.paymentsAnchorTag)\">Warranty</div><md-divider class=\"my-1\">\n</md-divider><div layout=\"row\" layout-align=\"space-between center\" ng-if=\"vm.submittedWarrantyAmount > 0\"><div \nclass=\"text-nowrap text-truncate\">Warranty-Submitted</div><div class=\"text-nowrap text-truncate\">\n{{vm.submittedWarrantyAmount | currency:\'$\':2}}</div></div><div layout=\"row\" layout-align=\"space-between center\" \nng-if=\"vm.pendingWarrantyAmount > 0\"><div class=\"text-nowrap text-truncate\">Warranty-Pending</div><div \nclass=\"text-nowrap text-truncate\">{{vm.pendingWarrantyAmount | currency:\'$\':2}}</div></div><div layout=\"row\" \nlayout-align=\"space-between center\" ng-if=\"vm.recievedWarrantyAmount > 0\"><div class=\"text-nowrap text-truncate\">\nWarranty-Recieved</div><div class=\"text-nowrap text-truncate\">{{vm.recievedWarrantyAmount | currency:\'$\':2}}</div>\n</div></div><div ng-if=\"!vm.hiddenSections.outstanding\"><div class=\"font-weight-bold mt-3\">Total</div><md-divider \nclass=\"my-1\"></md-divider><div layout=\"row\" layout-align=\"space-between center\"><div class=\"text-nowrap text-truncate\">\nSubtotal</div><div class=\"text-nowrap text-truncate\">{{vm.subtotalBeforeSubtraction | currency:\'$\':2}}</div></div><div \nlayout=\"row\" layout-align=\"space-between center\" ng-if=\"vm.totalDiscountOff\"><div class=\"text-nowrap text-truncate\">\nDiscounts</div><div class=\"text-nowrap text-truncate\">{{vm.totalDiscountOff * -1 | currency:\'$\':2}}</div></div><div \nlayout=\"row\" layout-align=\"space-between center\" ng-if=\"vm.subsidization\"><div class=\"text-nowrap text-truncate\">\nSubsidized <span ng-if=\"vm.workorder.is_subsidized_by_percentage\">({{vm.workorder.subsidized_percentage * 100}}%)\n</span></div><div class=\"text-nowrap text-truncate\">{{vm.subsidization * -1 | currency:\'$\':2}}</div></div><div \nlayout=\"row\" layout-align=\"space-between center\" ng-if=\"vm.subtotalBeforeSubtraction != vm.totalBeforeTax\"><div \nclass=\"text-nowrap text-truncate\">Subtotal</div><div class=\"text-nowrap text-truncate\">\n{{vm.totalBeforeTax | currency:\'$\':2}}</div></div><div layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"text-nowrap text-truncate\">Tax ({{vm.workorder.tax_rate * 100}}%)</div><div class=\"text-nowrap text-truncate\">\n{{vm.totalTax | currency:\'$\':2}}</div></div><div layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"text-nowrap text-truncate\">Total</div><div class=\"text-nowrap text-truncate\">\n{{vm.totalAfterTax | currency:\'$\':2}}</div></div><div layout=\"row\" layout-align=\"space-between center\" \nng-if=\"vm.totalPayments\"><div class=\"text-nowrap text-truncate\">Payments</div><div class=\"text-nowrap text-truncate\">\n{{vm.totalPayments | currency:\'$\':2}}</div></div><div class=\"font-weight-bold mt-3\" style=\"font-size: 15px\" \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"text-nowrap text-truncate mr-3\">OUTSTANDING</div><div \nclass=\"text-nowrap text-truncate\">{{vm.outstanding | currency:\'$\':2}}</div></div><div class=\"mt-3\" \nng-if=\"vm.rogerDollarGeneratedAmount > 0\"><md-divider class=\"my-1\"></md-divider><div layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"text-nowrap text-truncate\">Rogers Dollar Generated</div><div \nclass=\"text-nowrap text-truncate\">{{vm.rogerDollarGeneratedAmount | currency:\'$\':2}}</div></div></div><div \nclass=\"mt-3\" ng-if=\"vm.rogerDollarRedeemAmount > 0\"><div layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"text-nowrap text-truncate\">Rogers Dollar Redeemed</div><div class=\"text-nowrap text-truncate\">\n{{vm.rogerDollarRedeemAmount | currency:\'$\':2}}</div></div></div></div><div ng-if=\"!vm.hiddenSections.profit\" \nclass=\"text-grey\"><div class=\"font-weight-bold mt-3\">Profit</div><md-divider class=\"my-1\"></md-divider><div \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"text-nowrap text-truncate\">Income</div><div \nclass=\"text-nowrap text-truncate\">{{vm.totalBeforeTax | currency:\'$\':2}}</div></div><div layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"text-nowrap text-truncate\">Cost</div><div \nclass=\"text-nowrap text-truncate\">{{vm.totalCost | currency:\'$\':2}}</div></div><div layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"text-nowrap text-truncate\">Profit</div><div \nclass=\"text-nowrap text-truncate\">{{vm.profit | currency:\'$\':2}}</div></div></div></div></div>");
$templateCache.put("app/main/workorders/workorder-summary/workorder-summary.html","<div style=\"height: 100%\"><div class=\"sticky\"><workorder-summary-card on-anchor-clicked=\"vm.onAnchorClicked\" \nworkorder=\"vm.workOrder\" part-list=\"vm.partList\" labor-list=\"vm.laborList\" miscfees-list=\"vm.miscfeeList\" \ndiscount-list=\"vm.discountList\" payment-list=\"vm.paymentList\" work-order-warranty-list=\"vm.workOrderWarrantyList\" \nworkorder-status-options=\"vm.workOrderStatus\"></workorder-summary-card><div ng-if=\"vm.defaultCustomer\"><div \nclass=\"mt-5\" style=\"font-size: 13px\"><span>Add Payment Of: <a ng-href=\"{{::vm.customerPageUrl}}\">\n{{::vm.defaultCustomer.first_name + \' \' + vm.defaultCustomer.last_name}}</a></span></div><md-divider class=\"my-1\">\n</md-divider><div layout=\"row\" layout-align=\"space-between center\"><md-select flex=\"grow\" \nclass=\"small-selector purchase-step-selector input-box-padding my-0 py-0\" ng-model=\"vm.paymentMethodID\" \nplaceholder=\"Method\"><md-option ng-repeat=\"item in vm.paymentMethods\" ng-value=\"{{::item.id_payment_method}}\">\n{{::item.name}}</md-option></md-select><input style=\"width: 70px\" ng-if=\"!vm.isLaborDiscountPercentage\" \nclass=\"input-box-padding\" maxlength=\"10\" ng-model=\"vm.paymentAmount\" input-control \ninput-translate=\"vm.translateToDollar\" placeholder=\"$\"><button ng-disabled=\"vm.isAddingPayment\" style=\"width: 70px\" \nclass=\"btn btn-sm btn-secondary ml-3\" ng-click=\"vm.addPayment()\"><div tabindex=\"0\">add</div></button></div></div></div>\n</div>");
$templateCache.put("app/toolbar/layouts/horizontal-navigation/toolbar.html","<div class=\"top-row\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\">\n<div class=\"navigation-toggle\" hide-gt-sm><md-button class=\"md-icon-button\" ng-click=\"vm.toggleHorizontalMobileMenu()\" \naria-label=\"Toggle Mobile Navigation\"><md-icon md-font-icon=\"icon-menu\"></md-icon></md-button></div><div class=\"logo\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"logo-image\">F</span> <span class=\"logo-text\">FUSE</span></div>\n</div><div layout=\"row\" layout-align=\"start center\"><md-progress-circular id=\"toolbar-progress\" \nng-if=\"$root.loadingProgress\" class=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"32\"></md-progress-circular>\n<ms-shortcuts></ms-shortcuts><md-menu-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button \nclass=\"user-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"User settings\" translate \ntranslate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" src=\"assets/images/avatars/profile.jpg\"><md-icon \nmd-font-icon ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon status s16\">\n</md-icon></div><span class=\"username\" hide-sm>John Doe</span><md-icon md-font-icon=\"icon-chevron-down\" \nclass=\"icon s16\" hide-sm></md-icon></div></md-button><md-menu-content width=\"3\"><md-menu-item class=\"md-indent\" \nui-sref=\"app.pages_profile\"><md-icon md-font-icon=\"icon-account\" class=\"icon\"></md-icon><md-button>My Profile\n</md-button></md-menu-item><md-menu-item class=\"md-indent\" ui-sref=\"app.mail\"><md-icon md-font-icon=\"icon-email\" \nclass=\"icon\"></md-icon><md-button>Inbox</md-button></md-menu-item><md-menu-item class=\"md-indent\"><md-icon \nmd-font-icon ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon\"></md-icon><md-menu \nid=\"user-status-menu\"><md-button ng-click=\"$mdOpenMenu()\" class=\"status\" ng-class=\"vm.userStatus.class\">\n{{vm.userStatus.title}}</md-button><md-menu-content width=\"2\"><md-menu-item class=\"status md-indent\" \nng-class=\"{\'selected\': status === vm.userStatus}\" ng-repeat=\"status in vm.userStatusOptions\"><md-icon \nmd-font-icon=\"{{status.icon}}\" ng-style=\"{\'color\': status.color }\" class=\"icon\"></md-icon><md-button \nng-click=\"vm.setUserStatus(status)\">{{status.title}}</md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-item><md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-logout\" \nclass=\"icon\"></md-icon><md-button ng-click=\"vm.logout()\">Logout</md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-bar><ms-search-bar on-search=\"vm.search(query)\" on-result-click=\"vm.searchResultClick(item)\" debounce=\"300\">\n</ms-search-bar><md-menu id=\"language-menu\" md-offset=\"0 72\" md-position-mode=\"target-right target\"><md-button \nclass=\"language-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"Language\" md-menu-origin md-menu-align-target><div \nlayout=\"row\" layout-align=\"center center\"><img class=\"flag\" \nng-src=\"assets/images/flags/{{vm.selectedLanguage.flag}}.png\"> <span class=\"iso\">{{vm.selectedLanguage.code}}</span>\n</div></md-button><md-menu-content width=\"3\" id=\"language-menu-content\"><md-menu-item \nng-repeat=\"(iso, lang) in vm.languages\"><md-button ng-click=\"vm.changeLanguage(lang)\" aria-label=\"{{lang.title}}\" \ntranslate translate-attr-aria-label=\"{{lang.title}}\"><span layout=\"row\" layout-align=\"start center\"><img class=\"flag\" \nng-src=\"assets/images/flags/{{lang.flag}}.png\"> <span translate=\"{{lang.translation}}\">{{lang.title}}</span></span>\n</md-button></md-menu-item></md-menu-content></md-menu><md-button id=\"quick-panel-toggle\" class=\"md-icon-button\" \nng-click=\"vm.toggleSidenav(\'quick-panel\')\" aria-label=\"Toggle quick panel\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_QUICK_PANEL\"><md-icon md-font-icon=\"icon-format-list-bulleted\" class=\"icon\">\n</md-icon></md-button></div></div>");
$templateCache.put("app/toolbar/layouts/vertical-navigation/toolbar.html","<div layout=\"row\" layout-align=\"start center\"><div layout=\"row\" layout-align=\"start center\" flex><md-button \nid=\"navigation-toggle\" class=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'navigation\')\" hide-gt-sm \naria-label=\"Toggle navigation\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon \nmd-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><ms-shortcuts></ms-shortcuts><div \nclass=\"toolbar-separator\"></div></div><div layout=\"row\" layout-align=\"start center\"><md-progress-circular \nid=\"toolbar-progress\" ng-disabled=\"!$root.loadingProgress\" class=\"md-accent\" md-diameter=\"32\"></md-progress-circular>\n<md-menu-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button class=\"user-button\" \nng-click=\"$mdOpenMenu()\" aria-label=\"User settings\" translate translate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" \nsrc=\"assets/images/avatars/profile.jpg\"><md-icon md-font-icon ng-class=\"vm.userStatus.icon\" \nng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon status s16\"></md-icon></div><span class=\"username\" hide \nshow-gt-sm>John Doe</span><md-icon md-font-icon=\"icon-chevron-down\" class=\"icon s16\" hide-xs></md-icon></div>\n</md-button><md-menu-content width=\"3\"><md-menu-item class=\"md-indent\" ui-sref=\"app.pages_profile\"><md-icon \nmd-font-icon=\"icon-account\" class=\"icon\"></md-icon><md-button>My Profile</md-button></md-menu-item><md-menu-item \nclass=\"md-indent\" ui-sref=\"app.mail\"><md-icon md-font-icon=\"icon-email\" class=\"icon\"></md-icon><md-button>Inbox\n</md-button></md-menu-item><md-menu-item class=\"md-indent\"><md-icon md-font-icon ng-class=\"vm.userStatus.icon\" \nng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon\"></md-icon><md-menu id=\"user-status-menu\"><md-button \nng-click=\"$mdOpenMenu()\" class=\"status\" ng-class=\"vm.userStatus.class\">{{vm.userStatus.title}}</md-button>\n<md-menu-content width=\"2\"><md-menu-item class=\"status md-indent\" ng-class=\"{\'selected\': status === vm.userStatus}\" \nng-repeat=\"status in vm.userStatusOptions\"><md-icon md-font-icon=\"{{status.icon}}\" ng-style=\"{\'color\': status.color }\" \nclass=\"icon\"></md-icon><md-button ng-click=\"vm.setUserStatus(status)\">{{status.title}}</md-button></md-menu-item>\n</md-menu-content></md-menu></md-menu-item><md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><md-icon \nmd-font-icon=\"icon-logout\" class=\"icon\"></md-icon><md-button ng-click=\"vm.logout()\">Logout</md-button></md-menu-item>\n</md-menu-content></md-menu></md-menu-bar><div class=\"toolbar-separator\"></div><ms-search-bar \non-search=\"vm.search(query)\" on-result-click=\"vm.searchResultClick(item)\" debounce=\"300\"></ms-search-bar><div \nclass=\"toolbar-separator\"></div><md-menu id=\"language-menu\" md-offset=\"0 72\" md-position-mode=\"target-right target\">\n<md-button class=\"language-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"Language\" md-menu-origin md-menu-align-target>\n<div layout=\"row\" layout-align=\"center center\"><img class=\"flag\" \nng-src=\"assets/images/flags/{{vm.selectedLanguage.flag}}.png\"> <span class=\"iso\">{{vm.selectedLanguage.code}}</span>\n</div></md-button><md-menu-content width=\"3\" id=\"language-menu-content\"><md-menu-item \nng-repeat=\"(iso, lang) in vm.languages\"><md-button ng-click=\"vm.changeLanguage(lang)\" aria-label=\"{{lang.title}}\" \ntranslate translate-attr-aria-label=\"{{lang.title}}\"><span layout=\"row\" layout-align=\"start center\"><img class=\"flag\" \nng-src=\"assets/images/flags/{{lang.flag}}.png\"> <span translate=\"{{lang.translation}}\">{{lang.title}}</span></span>\n</md-button></md-menu-item></md-menu-content></md-menu><div class=\"toolbar-separator\"></div><md-button \nid=\"quick-panel-toggle\" class=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'quick-panel\')\" \naria-label=\"Toggle quick panel\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_QUICK_PANEL\"><md-icon \nmd-font-icon=\"icon-format-list-bulleted\" class=\"icon\"></md-icon></md-button></div></div>");
$templateCache.put("app/toolbar/layouts/vertical-navigation-fullwidth-toolbar/toolbar.html","<div layout=\"row\" layout-align=\"start center\"><div layout=\"row\" layout-align=\"start center\" flex><md-button \nid=\"navigation-toggle\" class=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'navigation\')\" hide-gt-sm \naria-label=\"Toggle navigation\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon \nmd-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><ms-search-bar on-search=\"vm.search(query)\" \non-result-click=\"vm.searchResultClick(item)\" debounce=\"300\"></ms-search-bar><div class=\"toolbar-separator\"></div>\n<ms-shortcuts></ms-shortcuts><div class=\"toolbar-separator\"></div></div><div layout=\"row\" layout-align=\"start center\">\n<md-progress-circular id=\"toolbar-progress\" ng-if=\"$root.loadingProgress\" class=\"md-accent\" md-mode=\"indeterminate\" \nmd-diameter=\"32\"></md-progress-circular><md-menu-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button \nclass=\"user-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"User settings\" translate \ntranslate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" src=\"assets/images/avatars/profile.jpg\"><md-icon \nmd-font-icon ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon status s16\">\n</md-icon></div><span class=\"username\" hide-sm>John Doe</span><md-icon md-font-icon=\"icon-chevron-down\" \nclass=\"icon s16\" hide-sm></md-icon></div></md-button><md-menu-content width=\"3\"><md-menu-item class=\"md-indent\" \nui-sref=\"app.pages_profile\"><md-icon md-font-icon=\"icon-account\" class=\"icon\"></md-icon><md-button>My Profile\n</md-button></md-menu-item><md-menu-item class=\"md-indent\" ui-sref=\"app.mail\"><md-icon md-font-icon=\"icon-email\" \nclass=\"icon\"></md-icon><md-button>Inbox</md-button></md-menu-item><md-menu-item class=\"md-indent\"><md-icon \nmd-font-icon ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon\"></md-icon><md-menu \nid=\"user-status-menu\"><md-button ng-click=\"$mdOpenMenu()\" class=\"status\" ng-class=\"vm.userStatus.class\">\n{{vm.userStatus.title}}</md-button><md-menu-content width=\"2\"><md-menu-item class=\"status md-indent\" \nng-class=\"{\'selected\': status === vm.userStatus}\" ng-repeat=\"status in vm.userStatusOptions\"><md-icon \nmd-font-icon=\"{{status.icon}}\" ng-style=\"{\'color\': status.color }\" class=\"icon\"></md-icon><md-button \nng-click=\"vm.setUserStatus(status)\">{{status.title}}</md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-item><md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-logout\" \nclass=\"icon\"></md-icon><md-button ng-click=\"vm.logout()\">Logout</md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-bar><div class=\"toolbar-separator\"></div><md-menu id=\"language-menu\" md-offset=\"0 72\" \nmd-position-mode=\"target-right target\"><md-button class=\"language-button\" ng-click=\"$mdOpenMenu()\" \naria-label=\"Language\" md-menu-origin md-menu-align-target><div layout=\"row\" layout-align=\"center center\"><img \nclass=\"flag\" ng-src=\"assets/images/flags/{{vm.selectedLanguage.flag}}.png\"> <span class=\"iso\">\n{{vm.selectedLanguage.code}}</span></div></md-button><md-menu-content width=\"3\" id=\"language-menu-content\">\n<md-menu-item ng-repeat=\"(iso, lang) in vm.languages\"><md-button ng-click=\"vm.changeLanguage(lang)\" \naria-label=\"{{lang.title}}\" translate translate-attr-aria-label=\"{{lang.title}}\"><span layout=\"row\" \nlayout-align=\"start center\"><img class=\"flag\" ng-src=\"assets/images/flags/{{lang.flag}}.png\"> <span \ntranslate=\"{{lang.translation}}\">{{lang.title}}</span></span></md-button></md-menu-item></md-menu-content></md-menu>\n<div class=\"toolbar-separator\"></div><md-button id=\"quick-panel-toggle\" class=\"md-icon-button\" \nng-click=\"vm.toggleSidenav(\'quick-panel\')\" aria-label=\"Toggle quick panel\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_QUICK_PANEL\"><md-icon md-font-icon=\"icon-format-list-bulleted\" class=\"icon\">\n</md-icon></md-button></div></div>");
$templateCache.put("app/toolbar/layouts/vertical-navigation-fullwidth-toolbar-2/toolbar.html","<div layout=\"row\" layout-align=\"start center\" ng-if=\"!vm.isPublicPage\"><div layout=\"row\" layout-align=\"start center\" \nflex><div ng-model=\"logo\" class=\"logo\" layout=\"row\" layout-align=\"start center\"><button class=\"link logo-image\" \nng-click=\"vm.goToHomePage()\">{{logo.initial}}</button> <button class=\"link logo-text\" ng-click=\"vm.goToHomePage()\">\n{{logo.text}}</button></div><div id=\"separator\" class=\"toolbar-separator bg-white\"></div><div id=\"separator\" \nclass=\"toolbar-separator\" ng-if=\"vm.isLoggedIn\"></div><div id=\"nav-toggle-button\" ng-if=\"vm.isLoggedIn\"><md-button \nid=\"navigation-toggle\" class=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'navigation\')\" hide-gt-sm \naria-label=\"Toggle navigation\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon \nmd-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><md-button class=\"md-icon-button navigation-fold-toggle\" \nhide show-gt-sm aria-label=\"Toggle navigation fold\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION_FOLD\" ng-click=\"vm.toggleMsNavigationFolded()\"><md-icon \nclass=\"s18\" md-font-icon=\"icon-backburger\"></md-icon></md-button></div></div><div layout=\"row\" \nlayout-align=\"start center\"><md-progress-circular id=\"toolbar-progress\" ng-if=\"$root.loadingProgress\" \nclass=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"32\"></md-progress-circular><md-menu-bar ng-if=\"!vm.isLoggedIn\">\n<md-button ng-click=\"vm.goToLoginPage()\">Login</md-button></md-menu-bar><goto-call-panel ng-if=\"vm.isLoggedIn\">\n</goto-call-panel><md-menu-bar id=\"user-menu\" ng-if=\"vm.isLoggedIn\"><md-menu md-position-mode=\"left bottom\"><md-button \nclass=\"user-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"User settings\" translate \ntranslate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" \nng-src=\"{{vm.profileImage == null ? \'assets/images/default-user-profile-photo.png\': vm.profileImage}}\"><md-icon \nmd-font-icon ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon status s16\">\n</md-icon></div><span class=\"username\" ng-bind=\"usermenu_username\" hide-sm></span><md-icon \nmd-font-icon=\"icon-chevron-down\" class=\"icon s16\" hide-sm></md-icon></div></md-button><md-menu-content width=\"3\">\n<md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-account\" class=\"icon\"></md-icon><md-button \nng-click=\"vm.goToMyProfile()\">My Profile</md-button></md-menu-item><md-menu-item class=\"md-indent\"><md-icon \nmd-font-icon ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon\"></md-icon><md-menu \nid=\"user-status-menu\"><md-button ng-click=\"$mdOpenMenu()\" class=\"status\" ng-class=\"vm.userStatus.class\">\n{{vm.userStatus.title}}</md-button><md-menu-content width=\"2\"><md-menu-item class=\"status md-indent\" \nng-class=\"{\'selected\': status === vm.userStatus}\" ng-repeat=\"status in vm.userStatusOptions\"><md-icon \nmd-font-icon=\"{{status.icon}}\" ng-style=\"{\'color\': status.color }\" class=\"icon\"></md-icon><md-button \nng-click=\"vm.setUserStatus(status)\">{{status.title}}</md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-item><md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-logout\" \nclass=\"icon\"></md-icon><md-button ng-click=\"vm.logout()\">Logout</md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-bar></div></div>");
$templateCache.put("app/navigation/layouts/horizontal-navigation/navigation.html","<div layout=\"row\" layout-align=\"start center\"><ms-navigation-horizontal></ms-navigation-horizontal></div>");
$templateCache.put("app/navigation/layouts/vertical-navigation/navigation.html","<md-toolbar class=\"navigation-header md-whiteframe-1dp\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-image\">F</span> <span class=\"logo-text\">FUSE\n</span></div><md-icon class=\"fold-toggle s18\" md-font-icon=\"icon-backburger\" hide show-gt-sm \nng-click=\"vm.toggleMsNavigationFolded()\"></md-icon></md-toolbar><ms-navigation class=\"scrollable\" folded=\"vm.folded\" \nms-scroll=\"vm.msScrollOptions\"></ms-navigation>");
$templateCache.put("app/navigation/layouts/vertical-navigation-fullwidth-toolbar-2/navigation.html","<ms-navigation class=\"scrollable\" folded=\"vm.folded\" ms-scroll=\"vm.msScrollOptions\"></ms-navigation>");
$templateCache.put("app/core/directives/ms-navigation/templates/horizontal.html","<div class=\"navigation-toggle\" hide-gt-sm><md-button class=\"md-icon-button\" ng-click=\"vm.toggleHorizontalMobileMenu()\" \naria-label=\"Toggle Mobile Navigation\"><md-icon md-font-icon=\"icon-menu\"></md-icon></md-button></div><ul \nclass=\"horizontal\"><li ng-repeat=\"node in vm.navigation\" ms-navigation-horizontal-node=\"node\" \nng-class=\"{\'has-children\': vm.hasChildren}\" ng-include=\"\'navigation-horizontal-nested.html\'\"></li></ul><script \ntype=\"text/ng-template\" id=\"navigation-horizontal-nested.html\">\n<div ms-navigation-horizontal-item layout=\"row\" ng-if=\"!vm.isHidden()\">\r\n\r\n        <div class=\"ms-navigation-horizontal-button\" ng-if=\"!node.uisref && node.title\"\r\n             ng-class=\"{\'active md-accent-bg md-accent-fg\': vm.isActive}\">\r\n            <i class=\"icon s18 {{node.icon}}\" ng-if=\"node.icon\"></i>\r\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\r\n            <span class=\"badge white-fg\" style=\"background: {{node.badge.color}}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\r\n            <i class=\"icon-chevron-right s18 arrow\" ng-if=\"vm.hasChildren\"></i>\r\n        </div>\r\n\r\n        <a class=\"ms-navigation-horizontal-button\" ui-sref=\"{{node.uisref}}\" ui-sref-active=\"active md-accent-bg\"\r\n           ng-class=\"{\'active md-accent-bg md-accent-fg\': vm.isActive}\"\r\n           ng-if=\"node.uisref && node.title\">\r\n            <i class=\"icon s18 {{node.icon}}\" ng-if=\"node.icon\"></i>\r\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\r\n            <span class=\"badge white-fg\" style=\"background: {{node.badge.color}}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\r\n            <i class=\"icon-chevron-right s18 arrow\" ng-if=\"vm.hasChildren\"></i>\r\n        </a>\r\n\r\n    </div>\r\n\r\n    <ul ng-if=\"vm.hasChildren && !vm.isHidden()\">\r\n        <li ng-repeat=\"node in node.children\" ms-navigation-horizontal-node=\"node\"\r\n            ng-class=\"{\'has-children\': vm.hasChildren}\"\r\n            ng-include=\"\'navigation-horizontal-nested.html\'\"></li>\r\n    </ul>\n</script>");
$templateCache.put("app/core/directives/ms-navigation/templates/vertical.html","<ul><li ng-repeat=\"node in vm.navigation\" ms-navigation-node=\"node\" \nng-class=\"{\'collapsed\': vm.collapsed, \'has-children\': vm.hasChildren}\" ng-include=\"\'navigation-nested.html\'\"></li></ul>\n<script type=\"text/ng-template\" id=\"navigation-nested.html\">\n<div ms-navigation-item layout=\"row\" ng-if=\"!vm.isHidden()\">\r\n\r\n        <div class=\"ms-navigation-button\" ng-if=\"!node.uisref && node.title\">\r\n            <i class=\"icon s16 {{node.icon}}\" ng-if=\"node.icon\"></i>\r\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\r\n            <span class=\"badge white-fg\" ng-style=\"{\'background\': node.badge.color}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\r\n            <i class=\"icon-chevron-right s16 arrow\" ng-if=\"vm.collapsable && vm.hasChildren\"></i>\r\n        </div>\r\n\r\n        <a class=\"ms-navigation-button\" ui-sref=\"{{node.uisref}}\" ui-sref-opts=\"{reload: false}\"  ui-sref-active=\"active md-accent-bg\"\r\n           ng-if=\"node.uisref && node.title\">\r\n            <i class=\"icon s16 {{node.icon}}\" ng-if=\"node.icon\"></i>\r\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\r\n            <span class=\"badge white-fg\" ng-style=\"{\'background\': node.badge.color}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\r\n            <i class=\"icon-chevron-right s16 arrow\" ng-if=\"vm.collapsable && vm.hasChildren\"></i>\r\n        </a>\r\n\r\n    </div>\r\n\r\n    <ul ng-if=\"vm.hasChildren && !vm.isHidden()\">\r\n        <li ng-repeat=\"node in node.children\" ms-navigation-node=\"node\"\r\n            ng-class=\"{\'collapsed\': vm.collapsed, \'has-children\': vm.hasChildren}\"\r\n            ng-include=\"\'navigation-nested.html\'\"></li>\r\n    </ul>\n</script>");
$templateCache.put("app/main/customers/browse-customers/customers-table/customers-table.html","<div layout=\"column\"><div flex layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"start center\"><div class=\"mr-2\">Display:</div><md-input-container><md-select \nng-change=\"vm.onItemsPerPageChange()\" ng-model=\"vm.itemsPerPage\" placeholder=\"Display\"><md-option \nng-repeat=\"option in vm.displayOptions\" ng-value=\"option\">{{option}}</md-option></md-select></md-input-container></div>\n<div layout=\"column\" layout-gt-sm=\"row\" layout-align=\"start center\"><md-input-container class=\"mt-10 ml-5\"><input \nng-model=\"vm.firstNameSearchText\" ng-model-options=\"{ debounce: 700 }\" placeholder=\"First Name\" \nng-change=\"vm.onSearchTextChange()\" autocomplete=\"off\"></md-input-container><md-input-container class=\"mt-10 ml-5\">\n<input ng-model=\"vm.lastNameSearchText\" ng-model-options=\"{ debounce: 700 }\" placeholder=\"Last Name\" \nng-change=\"vm.onSearchTextChange()\" autocomplete=\"off\"></md-input-container><md-input-container class=\"mt-10 ml-5\">\n<input ng-model=\"vm.emailSearchText\" ng-model-options=\"{ debounce: 700 }\" placeholder=\"Email\" \nng-change=\"vm.onSearchTextChange()\" autocomplete=\"off\"></md-input-container><md-input-container class=\"mt-10 ml-5\">\n<input ng-model=\"vm.phoneNumberSearchText\" ng-model-options=\"{ debounce: 700 }\" placeholder=\"Phone Number\" \nng-change=\"vm.onSearchTextChange()\" autocomplete=\"off\" input-control input-translate=\"vm.translateToPhoneNumber\">\n</md-input-container></div></div><div layout=\"row\" layout-align=\"end center\"><md-button \nclass=\"btn-secondary btn-sm m-0 animate-fade-in-out\" ng-if=\"vm.isCreateCustomerButtonVisible\" \nng-click=\"vm.createCustomerByPhoneNumber()\">Create</md-button></div><table flex class=\"table table-hover\"><thead><tr>\n<th class=\"customer-table-column-name\" ng-click=\"vm.setSorting(\'first_name\')\">Name<md-icon \nng-style=\"{visibility: vm.sorting.sortBy == \'first_name\'? \'visible\':\'hidden\'}\" \nng-class=\"vm.sorting.sortDirection == \'ASC\'? [\'icon-chevron-down\']:[\'icon-chevron-up\']\"></md-icon></th><th \nclass=\"customer-table-column-phone-number\">Phone Number</th><th class=\"customer-table-column-email\">Email</th></tr>\n</thead><tbody><tr ng-repeat=\"customer in vm.customersInCurrentPage track by $index\"><td><a \nhref=\"{{vm.getCustomerPageUrl(customer)}}\">{{vm.getCustomerFullName(customer)}}</a></td><td><div \nclass=\"text-nowrap text-truncate\">{{vm.getCustomerPhoneNumber(customer)}}</div></td><td><div \nclass=\"text-nowrap text-truncate\">{{vm.getCustomerEmailAddress(customer)}}</div></td></tr><tr \nng-if=\"vm.customersInCurrentPage.length <= 0\"><td>No Customer Found</td></tr></tbody></table><div flex layout=\"row\" \nlayout-align=\"end center\"><div layout=\"row\" layout-align=\"start center\" ng-if=\"vm.totalPage > 1\"><md-button \nclass=\"md-icon-button mx-0\" ng-click=\"vm.goToPage(1)\" \nng-style=\"{visibility: vm.currentPage != 1 ? \'visible\':\'hidden\'}\"><md-icon class=\"icon-page-first text-secondary\">\n</md-icon></md-button><div ng-repeat=\"page in vm.pagesBeforeCurrentPage\" class=\"text-secondary mx-1\" \nng-click=\"vm.goToPage(page)\">{{page}}</div><div class=\"mx-1\">{{vm.currentPage}}</div><div \nng-repeat=\"page in vm.pagesAfterCurrentPage\" class=\"text-secondary mx-1\" ng-click=\"vm.goToPage(page)\">{{page}}</div>\n<md-button class=\"md-icon-button mx-0\" ng-click=\"vm.goToPage(vm.totalPage)\" \nng-style=\"{visibility: vm.currentPage != vm.totalPage ? \'visible\':\'hidden\'}\"><md-icon \nclass=\"icon-page-last text-secondary\"></md-icon></md-button></div><div class=\"ml-5\">\nTotal Customer Found: {{vm.totalCustomerFound}}</div></div></div>");
$templateCache.put("app/main/customers/edit-customer/customer-components/credit-card.html","");
$templateCache.put("app/main/customers/edit-customer/customer-components/customer-file-uploader.html","<div layout=\"row\"><div layout=\"column\" flex flex-gt-sm=\"55\"><div layout=\"column\" layout-align=\"center center\" \nclass=\"customer-file-uploader bg-white\" nv-file-drop=\"\" nv-file-over=\"\" uploader=\"vm.fileUploader\"><div>\nDrag and drop files here</div><md-button class=\"btn-secondary btn-sm customer-file-uploader-button\">Select Files <input\n class=\"fileInput\" nv-file-select=\"false\" uploader=\"vm.fileUploader\" multiple=\"multiple\" type=\"file\"></md-button></div>\n<md-content class=\"scrollable customer-file-list\" ms-scroll><div layout=\"row\" class=\"customer-file-list-item\" \nlayout-align=\"space-between center\" ng-repeat=\"itemInQueue in vm.fileUploader.queue track by $index\"><div layout=\"row\" \nflex=\"80\" layout-align=\"start center\"><div><md-icon flex=\"nogrow\" class=\"icon-file-outline\"></md-icon></div><div \nclass=\"text-nowrap text-truncate customer-file-list-item-name\">{{itemInQueue.file.name}}</div></div><div layout=\"row\" \nlayout-align=\"end center\"><md-progress-circular ng-if=\"itemInQueue.isUploading\" \nclass=\"md-hue-2 customer-file-list-item-spinner\" md-diameter=\"20px\"></md-progress-circular><md-button \nclass=\"md-icon-button\"><md-icon class=\"icon-minus-circle text-red\" ng-disabled=\"itemInQueue.isUploading\" \nng-click=\"vm.onDeleteQueueFileClick(itemInQueue, $index)\"></md-icon></md-button></div></div><div layout=\"row\" \nclass=\"customer-file-list-item\" layout-align=\"space-between center\" \nng-repeat=\"file in vm.uploadedFiles track by $index\"><div layout=\"row\" flex=\"80\" layout-align=\"start center\"><div>\n<md-icon flex=\"nogrow\" class=\"icon-file-outline\"></md-icon></div><div><a href=\"{{vm.getFileNameLink(file)}}\" \nclass=\"text-nowrap text-truncate customer-file-list-item-name\" ng-click=\"vm.onLinkClick(file.uuid)\">{{file.file_name}}\n</a><md-tooltip md-direction=\"top\">{{file.file_name}}</md-tooltip></div></div><div layout=\"row\" \nlayout-align=\"end center\"><md-button class=\"md-icon-button\"><md-icon class=\"icon-content-copy text-secondary\" \nng-click=\"vm.onCopyLinkClick(file)\"></md-icon></md-button><md-button class=\"md-icon-button\" restrict \nrolescansee=\"developer company_manager sales_manager\"><md-icon class=\"icon-minus-circle text-red\" \nng-click=\"vm.onDeleteUploadedFileClick(file, $index)\"></md-icon></md-button></div></div></md-content></div></div>");
$templateCache.put("app/main/customers/edit-customer/customer-components/customer-info-form.html","<form layout=\"column\" name=\"custormerInfoForm\"><input-box options=\"vm.firstNameInputOptions\" \nvalue=\"vm.customer.first_name\" input-name=\"\'firstName\'\"></input-box><input-box options=\"vm.lastNameInputOptions\" \nvalue=\"vm.customer.last_name\" input-name=\"\'lastName\'\"></input-box><input-box options=\"vm.driverLicenseInputOptions\" \nvalue=\"vm.customer.drivers_license\" input-name=\"\'driverLicense\'\"></input-box><div><md-icon \nclass=\"icon-duck customer-info-form-expire-datepicker-icon text-black\"></md-icon><md-input-container><label>\nLicense expiry date:</label><md-datepicker md-hide-icons=\"calendar\" ng-model=\"vm.datePickerValue\" \nng-change=\"vm.setLicenseExpiryDate(vm.datePickerValue)\" md-placeholder=\"Enter date\" name=\"licenseExpiryDate\">\n</md-datepicker><div ng-messages=\"custormerInfoForm.licenseExpiryDate.$error\"><div ng-message=\"valid\">Invalid date.\n</div></div></md-input-container></div><input-box options=\"vm.policyNumberInputOptions\" \nvalue=\"vm.customer.policy_number\" input-name=\"\'policyNumber\'\"></input-box><input-box \noptions=\"vm.insuranceCompanyInputOptions\" value=\"vm.customer.insurance_company\" input-name=\"\'insuranceCompany\'\">\n</input-box><textarea-input-box options=\"vm.noteInputOptions\" value=\"vm.customer.note\" input-name=\"\'note\'\">\n</textarea-input-box></form>");
$templateCache.put("app/main/customers/edit-customer/customer-components/email-list.html","<form layout=\"column\" name=\"customerEmailListForm\"><div layout=\"column\" layout-align=\"center start\" \nclass=\"email-creator bg-secondary\"><div flex=\"nogrow\" layout=\"row\" layout-align=\"space-between center\" \nclass=\"email-creator-input\"><input-box flex=\"50\" options=\"vm.emailCreatorInputOptions\" value=\"vm.newEmail\" \non-change=\"vm.onEmailCreatorInputChange\"></input-box><md-select flex=\"35\" \nclass=\"email-creator-category-select md-no-underline\" ng-model=\"vm.newEmailCategory\" placeholder=\"category\"><md-option \nng-repeat=\"categoryObj in vm.emailCategories\" value=\"{{categoryObj.id_email_category}}\">{{categoryObj.name}}\n</md-option></md-select><md-button flex=\"15\" class=\"btn-primary email-creator-add-button\" ng-click=\"vm.addNewEmail()\" \nng-disabled=\"vm.isAddEmailButtonDisabled\">Add</md-button></div><div flex=\"20 nogrow\" \nng-messages=\"vm.emailCreatorValidator\"><div ng-message=\"isEmailError\" class=\"input-validation-message\">\nEmail is invalid .</div></div></div><md-content class=\"bg-transparent scrollable email-list\" ms-scroll><div \nlayout=\"row\" layout-align=\"space-between center\" class=\"email-list-item bg-white\" ng-repeat=\"email in vm.emailList\">\n<input-box flex=\"60\" options=\"vm.emailEditorInputOptions\" value=\"email.email_address\" \ninput-name=\"\'emailEditor_\' + $index\"></input-box><md-select flex=\"17\" class=\"md-no-underline\" \nng-model=\"email.fk_id_email_category\" placeholder=\"category\"><md-option ng-repeat=\"categoryObj in vm.emailCategories\" \nvalue=\"{{categoryObj.id_email_category}}\">{{categoryObj.name}}</md-option></md-select><md-switch \nng-model=\"email.allow_notification\" md-invert class=\"email-list-switch\" aria-label=\"Switch 1\">Notification</md-switch>\n<md-button class=\"mb-2 md-icon-button\" ng-click=\"vm.removeEmail($index)\"><md-icon class=\"icon-delete-forever text-red\">\n</md-icon></md-button></div></md-content></form>");
$templateCache.put("app/main/customers/edit-customer/customer-components/phone-number-list.html","<form layout=\"column\" name=\"customerPhoneListForm\"><div layout=\"column\" layout-align=\"center start\" \nclass=\"phone-number-creator bg-secondary\"><div flex=\"nogrow\" layout=\"row\" layout-align=\"space-between center\" \nclass=\"phone-number-creator-input\"><input-box flex=\"50\" options=\"vm.phoneNumberCreatorInputOptions\" \nvalue=\"vm.newPhoneNumber\" on-change=\"vm.onPhoneNumberCreatorInputChange\"></input-box><md-select flex=\"35\" \nclass=\"phone-number-creator-category-select md-no-underline\" ng-model=\"vm.newPhoneCategory\" placeholder=\"category\">\n<md-option ng-repeat=\"categoryObj in vm.phoneCategories\" value=\"{{categoryObj.id_phone_category}}\">\n{{categoryObj.category}}</md-option></md-select><md-button flex=\"15\" \nclass=\"btn-primary phone-number-creator-add-button\" ng-click=\"vm.addNewPhoneNumber()\" \nng-disabled=\"vm.isAddNewPhoneNumberDisabled\">Add</md-button></div><div flex=\"20 nogrow\" \nng-messages=\"vm.phoneNumberCreatorValidator\"><div ng-message=\"isPhoneNumberError\" class=\"input-validation-message\">\nPhone number is invalid .</div></div></div><md-content class=\"bg-transparent scrollable phone-number-list\" ms-scroll>\n<div layout=\"row\" layout-align=\"space-between center\" class=\"phone-number-list-item bg-white\" \nng-repeat=\"phoneNumber in vm.phoneNumberList\"><input-box flex=\"60\" options=\"vm.phoneNumberEditorInputOptions\" \nvalue=\"phoneNumber.phone_number\" input-name=\"\'phoneNumberEditor_\' + $index\"></input-box><md-select flex=\"17\" \nclass=\"md-no-underline\" ng-model=\"phoneNumber.fk_id_phone_category\" placeholder=\"category\"><md-option \nng-repeat=\"categoryObj in vm.phoneCategories\" value=\"{{categoryObj.id_phone_category}}\">{{categoryObj.category}}\n</md-option></md-select><md-switch ng-model=\"phoneNumber.allow_notification\" md-invert \nclass=\"phone-number-list-switch\" aria-label=\"Switch 1\">Notification</md-switch><md-button class=\"mb-2 md-icon-button\" \nng-click=\"vm.removePhoneNumber($index)\"><md-icon class=\"icon-delete-forever text-red\"></md-icon></md-button></div>\n</md-content></form>");
$templateCache.put("app/main/customers/edit-customer/customer-components/purchased-vehicles.html","<div ng-if=\"!(vm.dataMap.length > 0)\">This customer has not purchased any vehicle.</div><div \nng-repeat=\"data in vm.dataMap\" layout=\"row\"><a href=\"{{::vm.getVehicleUrl(data.vehicleData)}}\"><span class=\"mr-2\">\n{{::data.saleInfoData.sale_date}} </span><span>{{::data.vehicleData.getYearMakeModel()}}</span></a></div>");
$templateCache.put("app/main/customers/edit-customer/customer-components/service-vehicle-list.html","<md-divider></md-divider><div class=\"px-2\"><div ng-if=\"!(vm.serviceMap.length > 0)\" class=\"my-1\">\nThis customer does not have any service vehicle.</div><div ng-repeat=\"item in vm.serviceMap\" layout=\"row\" class=\"my-1\" \nlayout-align=\"space-between center\"><a href=\"{{::vm.getVehicleUrl(item.vehicle.id_vehicle)}}\"><span class=\"mr-2\">\n{{::item.vehicle.year}} {{::item.vehicle.make}} {{::item.vehicle.model}} </span></a><button \nng-disabled=\"vm.isProcessing\" ng-click=\"vm.onRemoveItem(item, $index)\" \nng-class=\"vm.isProcessing ? [text-grey]:[\'text-red\']\">&#x2715</button></div></div><md-divider></md-divider>\n<md-autocomplete class=\"mt-3\" md-no-cache=\"false\" md-select-on-focus=\"true\" md-selected-item=\"vm.selectedVehicle\" \nmd-search-text=\"vm.searchText\" md-selected-item-change=\"vm.selectVehicle()\" md-delay=\"700\" md-select-on-focus=\"true\" \nmd-items=\"vehicle in vm.queryVehicle(vm.searchText)\" md-item-text=\"vehicle.getYearMakeModel()\" \nplaceholder=\"Search Vehicle\" md-menu-class=\"vehicle-search-menu\" md-menu-container-class=\"vehicle-search-container\">\n<md-item-template><div layout=\"row\" layout-align=\"start center\"><div flex=\"none\" class=\"mr-2\"><img \nstyle=\"width: 60px;height:50px; object-fit: contain\" \nng-src=\"{{vehicle.landingImage? vehicle.landingImage:\'../../assets/images/placeholder-vans.png\'}}\"></div><div \nclass=\"item-detail\" style=\"font-size: 13px\"><span><a stop-event ng-href=\"{{vm.getUrlForDetailPage(vehicle)}}\">\n{{vehicle.getYearMakeModel()}}</a> <span class=\"text-red\" \nng-if=\"vm.getVehicleLocation(vehicle) && !vm.getVehicleLocation(vehicle).is_default_location\">\n({{vm.getVehicleLocation(vehicle).name}})</span></span><div>{{vehicle.vin}}</div></div></div><md-divider></md-divider>\n</md-item-template><md-not-found><a ng-href=\"{{::vm.notFoundUrl}}\">\n{{::vm.notFoundMessage ? vm.notFoundMessage : \'No result.\'}}</a></md-not-found></md-autocomplete>");
$templateCache.put("app/main/customers/edit-customer/customer-components/test-drive-list.html","<div layout=\"row\"><div flex flex-gt-sm=\"55\"><md-autocomplete autocomplete=\"off\" \nplaceholder=\"Test Drive - Search by vehicle VIN, Year, Make, or Model\" md-no-cache=\"true\" md-delay=\"700\" \nmd-selected-item=\"vm.selectedItem\" md-selected-item-change=\"vm.selectItem(vm.selectedItem)\" \nmd-search-text=\"vm.searchText\" md-items=\"vehicle in vm.queryVehicles(vm.searchText)\" \nmd-menu-class=\"test-drive-vehicle-selector-dropdown-menu\" \nmd-menu-container-class=\"test-drive-vehicle-selector-dropdown-menu-container\" md-autoselect=\"true\"><md-item-template>\n<div layout=\"row\" layout-align=\"start center\"><img \nng-src=\"{{vehicle.landingImage == null || vehicle.landingImage.trim() == \'\' ? \'assets/images/placeholder-vans.png\':vehicle.landingImage}} \" \nclass=\"test-drive-vehicle-selector-dropdown-menu-image\"><div><div \nclass=\"test-drive-vehicle-selector-dropdown-menu-detail text-nowrap text-truncate\">{{vehicle.getYearMakeModel()}}</div>\n<div class=\"test-drive-vehicle-selector-dropdown-menu-detail text-nowrap text-truncate\">{{vehicle.stock_number}}</div>\n<div class=\"test-drive-vehicle-selector-dropdown-menu-detail text-nowrap text-truncate\">VIN: {{vehicle.vin}}</div>\n</div></div></md-item-template><md-not-found>No matches found, please be more specific.</md-not-found>\n</md-autocomplete><div layout=\"column\" class=\"test-drive-vehicle-list\"><div ng-repeat=\"testDrive in vm.testDrives\" \nclass=\"test-drive-vehicle-list-item bg-light animate-fade-in-out\" layout=\"row\" layout-align=\"space-between center\"><div\n flex=\"50 nogorw\" class=\"test-drive-vehicle-list-item-text\"><div class=\"text-nowrap text-truncate\"><a \nng-href=\"{{vm.getUrlForDetailPage(testDrive.vehicle.id_vehicle)}}\">\n{{testDrive.vehicle.year}} {{testDrive.vehicle.make}} {{testDrive.vehicle.model}}</a></div><div \nclass=\"text-nowrap text-truncate\" ng-if=\"testDrive.date != null\">Date: {{testDrive.date | date:\'yyyy-MM-dd HH:mm:ss\'}}\n</div></div><div><md-button class=\"md-icon-button\" flex=\"none\" ng-disabled=\"vm.disableRemoveButton\" \nng-click=\"vm.onRemoveClick(testDrive, $index)\"><md-icon class=\"icon-minus-circle\" \nng-class=\"vm.disableRemoveButton==true? [\'text-grey\']:[\'text-red\']\"></md-icon></md-button></div></div></div></div>\n</div>");
$templateCache.put("app/main/customers/view-customer/custom-appointment/custom-appointment-list.html","<style>\n.appointment-row-mobile {\r\n    padding: 15px;\r\n    margin-bottom: 15px;\r\n    background-color: #f9f9f9;\r\n    border: 1px solid #ddd;\r\n    border-radius: 5px;\r\n}\r\n\r\n.appointment-header {\r\n    margin-bottom: 10px;\r\n}\r\n\r\n.action-button {\r\n    background-color: transparent;\r\n    border: none;\r\n    cursor: pointer;\r\n    padding: 0;\r\n}\r\n\r\n.appointment-details-textarea {\r\n    font-size: 14px;\r\n    padding: 10px;\r\n    border: 1px solid #ccc;\r\n    border-radius: 4px;\r\n    box-shadow: none;\r\n}\r\n\r\n.appointment-status-select {\r\n    margin-bottom: 10px;\r\n}\r\n\r\n.appointment-category {\r\n    font-weight: 600;\r\n    color: #333;\r\n    margin-bottom: 10px;\r\n}\r\n\r\n.category-label {\r\n    font-weight: 500;\r\n    color: #666;\r\n}\r\n\r\n.appointment-time {\r\n    font-size: 14px;\r\n}\r\n\r\n.time-labels {\r\n    margin-right: 10px;\r\n}\r\n\r\n.time-label {\r\n    font-weight: 500;\r\n    color: #666;\r\n}\r\n\r\n.time-values {\r\n    text-align: right;\r\n}\r\n\r\n.time-value {\r\n    font-weight: 600;\r\n    color: #333;\r\n}\n</style><md-content><table class=\"table strike-able table-hover\" \nstyle=\"table-layout: fixed; width: 100%; min-width: 700px\" ng-show=\"!vm.isSmallScreen\"><thead><tr><th \nclass=\"text-nowrap bg-light\" style=\"width: 35px\"><md-checkbox ng-disabled=\"vm.disableEditing\" \nng-if=\"vm.appointments.length > 0\" ng-checked=\"vm.isAllSelected()\" ng-click=\"vm.selectAll()\" class=\"m-0 p-0\">\n</md-checkbox></th><th class=\"text-nowrap bg-light\" style=\"width: 35px\"></th><th class=\"text-nowrap bg-light\" \nstyle=\"width: 100%\">Appointment Detail</th><th class=\"text-nowrap bg-light\" style=\"width: 150px\">Status</th><th \nclass=\"text-nowrap bg-light\" style=\"width: 150px\">Category</th><th class=\"text-nowrap bg-light\" style=\"width: 230px\">\nTime</th></tr></thead><tbody><tr ng-repeat=\"appointment in vm.appointments\"><td><md-checkbox \nng-disabled=\"vm.disableEditing\" class=\"m-0 p-0\" ng-model=\"vm.selectedMap[appointment.id_appointment]\"></md-checkbox>\n</td><td><button ng-click=\"vm.updateAppointmentDetail(appointment)\" ng-disabled=\"!appointment.isTitleModified\"><i \nng-if=\"appointment.isTitleModified\" class=\"icon-check-all text-secondary ng-scope\"></i> <i \nng-if=\"!appointment.isTitleModified\" class=\"icon-pen text-secondary ng-scope\"></i></button></td><td><textarea \nstyle=\"width: 100%\" rows=\"5\" ng-model=\"appointment.title\" class=\"info-form-item detail-info-form-note-input\" \nmaxlength=\"250\" ng-change=\"vm.onAppointmentDetailChanged(appointment)\" placeholder=\"Appointment Details:\">\r\n					\n</textarea></td><td><div layout=\"row\"><md-select flex ng-disabled=\"false\" ng-change=\"vm.onStatusChanged(appointment)\" \nclass=\"small-selector purchase-step-selector m-0\" ng-model=\"appointment.fk_id_appointment_status\" placeholder=\"Status\">\n<md-option ng-repeat=\"status in vm.appointmentStatus\" ng-value=\"{{::status.id_appointment_status}}\">{{::status.name}}\n</md-option><md-option ng-value=\"null\">NONE</md-option></md-select></div></td><td><div layout=\"row\" \nlayout-align=\"space-between center\"><a>{{appointment.category}}</a></div></td><td><div layout=\"row\" \nlayout-align=\"space-between center\"><div><div>Form:</div><div>To:</div></div><div class=\"text-right\"><div>\n{{::appointment.start | date: vm.dateFormat}}</div><div>{{::appointment.end | date: vm.dateFormat}}</div></div></div>\n</td></tr><tr ng-if=\"!(vm.appointments.length > 0)\"><td colspan=\"100%\">No item found.</td></tr></tbody></table><div \nng-repeat=\"appointment in vm.appointments\" class=\"appointment-row-mobile\" layout=\"column\" layout-align=\"start start\" \nng-show=\"vm.isSmallScreen\"><div layout=\"row\" layout-align=\"space-between center\" class=\"appointment-header\">\n<md-checkbox ng-disabled=\"vm.disableEditing\" class=\"m-0 p-0\" ng-model=\"vm.selectedMap[appointment.id_appointment]\">\n</md-checkbox><button ng-click=\"vm.updateAppointmentDetail(appointment)\" ng-disabled=\"!appointment.isTitleModified\" \nclass=\"action-button\"><i ng-if=\"appointment.isTitleModified\" class=\"icon-check-all text-secondary ng-scope\"></i> <i \nng-if=\"!appointment.isTitleModified\" class=\"icon-pen text-secondary ng-scope\"></i></button></div><textarea \nstyle=\"width: 100%; margin-bottom: 10px\" rows=\"5\" ng-model=\"appointment.title\" \nclass=\"info-form-item detail-info-form-note-input\" maxlength=\"250\" \nng-change=\"vm.onAppointmentDetailChanged(appointment)\" placeholder=\"Appointment Details:\" \nclass=\"appointment-details-textarea\">\r\n		</textarea><md-select flex ng-disabled=\"false\" \nng-change=\"vm.onStatusChanged(appointment)\" \nclass=\"small-selector purchase-step-selector m-0 appointment-status-select\" \nng-model=\"appointment.fk_id_appointment_status\" placeholder=\"Status\"><md-option \nng-repeat=\"status in vm.appointmentStatus\" ng-value=\"{{::status.id_appointment_status}}\">{{::status.name}}</md-option>\n<md-option ng-value=\"null\">NONE</md-option></md-select><br><div class=\"appointment-category\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"category-label\">Category: &nbsp;</span> {{appointment.category}}</div>\n<div class=\"appointment-time\" layout=\"row\" layout-align=\"space-between center\"><div class=\"time-labels\"><div \nclass=\"time-label\">From:</div><div class=\"time-label\">To:</div></div><div class=\"time-values text-right\"><div \nclass=\"time-value\">{{::appointment.start | date: vm.dateFormat}}</div><div class=\"time-value\">\n{{::appointment.end | date: vm.dateFormat}}</div></div></div></div></md-content>");
$templateCache.put("app/main/settings/Warranty/add-Warranty/add-Warranty.html","<div class=\"content-wrapper\"><div class=\"header py-6 bg-primary text-auto px-2\"><span class=\"h3\">Add New Warranty\n</span></div><div class=\"container-fluid px-10 py-7\"><div class=\"row\"><div \nclass=\"col px-0 profile-box info-box general card mx-2 my-3\"><header class=\"h6 bg-secondary text-auto p-4\"><div \nclass=\"title\">General Information</div></header><div class=\"jumbotron mx-3 my-7 row\"><div class=\"col-7\"><form \nname=\"addwarranty\"><div class=\"info-line mb-6\"><div class=\"title font-weight-bold mb-1\">Warranty Name<div \nclass=\"badge badge-pill badge-warning pull-right\" ng-if=\"addwarranty.name.$dirty && addwarranty.name.$invalid\">\nMust be greater than 1 characters</div></div><input name=\"name\" class=\"info form-control\" type=\"text\" \nng-model=\"vm.warranty.name\" ng-blur=\"vm.checkPartTypedescription(vm.warranty.description)\" \nng-focus=\"vm.isUsernameAvailable = undefined\" required ng-pattern=\"regex\" ng-minlength=\"1\"></div><div \nclass=\"info-line mb-6\"><div class=\"title font-weight-bold mb-1\">Warranty Description</div><input name=\"description\" \nclass=\"info form-control\" type=\"text\" ng-model=\"vm.warranty.description\" \nng-blur=\"vm.checkPartTypedescription(vm.warranty.description)\" ng-focus=\"vm.isUsernameAvailable = undefined\" \nng-pattern=\"regex\" ng-minlength=\"1\"></div><div class=\"info-line mb-6\"><div class=\"title font-weight-bold mb-1\">Cost $\n</div><input name=\"cost\" class=\"info form-control\" type=\"number\" ng-model=\"vm.warranty.cost\" required \nng-maxlength=\"20\"></div><div class=\"info-line mb-6\"><div class=\"title font-weight-bold mb-1\">Retail $</div><input \nname=\"retail\" class=\"info form-control\" type=\"number\" ng-model=\"vm.warranty.retail\" ng-maxlength=\"20\"></div><div \nclass=\"info-line mb-6\"><div class=\"title font-weight-bold mb-1\">Months covered</div><input name=\"duration_month\" \nclass=\"info form-control\" type=\"number\" step=\"1\" ng-model=\"vm.warranty.duration_month\" required ng-maxlength=\"20\">\n</div><div class=\"info-line mb-6\"><div class=\"title font-weight-bold mb-1\">Mileage covered</div><input \nname=\"duration_month\" class=\"info form-control\" type=\"number\" step=\"1\" ng-model=\"vm.warranty.duration_mileage\" \nng-maxlength=\"20\"></div><div class=\"info-line mb-6\"><div class=\"title font-weight-bold mb-1\">Maximun Vehicle Years\n</div><input name=\"max_vehicle_year\" class=\"info form-control\" type=\"number\" step=\"1\" \nng-model=\"vm.warranty.max_vehicle_year\" required ng-maxlength=\"20\"></div><div class=\"info-line mb-6\"><div \nclass=\"title font-weight-bold mb-1\">Minimum Vehicle Mileage</div><input name=\"min_mileage\" class=\"info form-control\" \ntype=\"number\" step=\"1\" ng-model=\"vm.warranty.min_mileage\" required ng-maxlength=\"20\"></div><div class=\"info-line mb-6\">\n<div class=\"title font-weight-bold mb-1\">Maximun Vehicle Mileage</div><input name=\"max_mileage\" \nclass=\"info form-control\" type=\"number\" step=\"1\" ng-model=\"vm.warranty.max_mileage\" required ng-maxlength=\"20\"></div>\n<div class=\"info-line mb-6\"><div class=\"title font-weight-bold mb-1\">Maximun Warranty per Claim</div><input \nname=\"max_claim\" class=\"info form-control\" type=\"number\" step=\"1\" ng-model=\"vm.warranty.max_claim\" required \nng-maxlength=\"20\"></div><div class=\"info-line mb-6\"><div class=\"title font-weight-bold mb-1\">Warranty Provider<div \nclass=\"badge badge-pill badge-warning pull-right\" \nng-if=\"addwarranty.addwarranty.$dirty && addwarranty.addwarranty.$invalid\">Must be greater than 1 characters</div>\n</div><input name=\"provider\" class=\"info form-control\" type=\"text\" ng-model=\"vm.warranty.provider\" \nng-blur=\"vm.checkPartTypedescription(vm.warranty.provider)\" ng-focus=\"vm.isUsernameAvailable = undefined\" required \nng-pattern=\"regex\" ng-minlength=\"1\"></div><div class=\"info-line mb-6\"><div class=\"title font-weight-bold mb-1\">\nWarranty Feature:</div><div ng-repeat=\"feature in features\"><p><a class=\"littleboldertext\">\nID: {{feature.id_warranty_feature}} Name: {{feature.name}}</a><br><a class=\"littleboldertext\">Description: </a>\n{{feature.description}}<md-button class=\"bg-red pull-right\" ng-click=\"vm.removemiscfee(feature)\" \nng-disabled=\"!vm.isButtonActive\">Remove</md-button></p></div><div class=\"card-body\">Add New Warranty Feature<br><select\n class=\"m-0 pl-2 py-2\" \nng-options=\"option as option.name for option in vm.warrantyfeature track by option.id_warranty_feature\" \nng-model=\"vm.newwarrantyfeatureselected\"></select><md-button class=\"bg-blue pull-right\" ng-click=\"vm.addnewmiscfee()\" \nng-disabled=\"!vm.isButtonActive\">Add Warranty Feature</md-button></div></div><br><md-divider></md-divider><br><button \ntype=\"submit\" class=\"btn bg-blue\" ng-click=\"vm.addwarranty()\" ng-disabled=\"vm.disableAddButton\" style=\"width: 40rem\">\nCreate New Warranty</button></form></div></div></div></div></div></div>");
$templateCache.put("app/main/settings/Warranty/add-WarrantyFeature/add-WarrantyFeature.html","<div style=\"width: 100%\" class=\"bg-secondary header-backgroud\" layout=\"row\" layout-align=\"center center\"><div flex \nclass=\"content-max-width content-padding-full\"><span class=\"h2 white-fg\">All Warranty Feature</span></div></div><div \nstyle=\"width: 100%\" layout=\"row\" layout-align=\"center start\"><div flex class=\"content-max-width content-padding-half\">\n<div layout=\"row\" class=\"content-padding-half\"><div flex=\"100\" flex-gt-sm=\"50\">Warranty Features:<md-divider \nclass=\"mb-1\"></md-divider><div ng-repeat=\"item in vm.warrantyfeature\" class=\"my-2\"><div layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\" \nng-click=\"vm.showItems[item.id_warranty_feature] = !vm.showItems[item.id_warranty_feature]\"><div \nclass=\"text-nowrap text-truncate\">{{item.id_warranty_feature}}. {{item.name}}</div><i \nng-class=\"vm.showItems[item.id_warranty_feature]? [\'icon-chevron-up\']:[\'icon-chevron-down\']\"></i></div><div>\n<md-checkbox class=\"m-0 p-0\" ng-model=\"vm.selectedMap[item.id_warranty_feature]\"></md-checkbox></div></div><div \nstyle=\"font-size: 13px\" class=\"text-grey\" ng-if=\"vm.showItems[item.id_warranty_feature]\"><div>\nDescription: {{item.description}}</div></div></div><md-divider class=\"mt-1\"></md-divider><div layout=\"row\" \nlayout-align=\"end center\"><button class=\"mr-2\" ng-disabled=\"vm.isDeleting || !(vm.getSelectedPackages().length > 0)\" \nng-click=\"vm.deleteWarrantyFeature()\"><i \nng-class=\"vm.isDeleting || !(vm.getSelectedPackages().length > 0)? [\'\'] : [\'text-red\']\" class=\"icon-delete-forever\">\n</i></button></div></div></div><div layout=\"row\" class=\"content-padding-half\"><div flex=\"100\" flex-gt-sm=\"50\"><form \nlayout=\"column\" layout-algin=\"start center\" name=\"newWarrantyFeatureForm\">New Warranty Features:<md-input-container \nflex class=\"small-input-box\"><input ng-required=\"true\" name=\"newWarrantyFeatureName\" \nng-model=\"vm.newWarrantyFeatureName\" autocomplete=\"off\" placeholder=\"New Warranty Feature Name\" maxlength=\"200\"><div \nng-messages=\"newWarrantyFeatureForm.newWarrantyFeatureName.$error\"><div ng-message=\"required\">Required</div></div>\n</md-input-container><md-input-container flex class=\"small-input-box\"><textarea ng-required=\"true\" \nname=\"newWarrantyFeatureDescription\" ng-model=\"vm.newWarrantyFeatureDescription\" autocomplete=\"off\" \nplaceholder=\"New Warranty Feature Description\" maxlength=\"230\" input-control>\r\n						</textarea><div \nng-messages=\"newWarrantyFeatureForm.newWarrantyFeatureDescription.$error\"><div ng-message=\"required\">Required</div>\n</div></md-input-container></form><md-button ng-disabled=\"vm.isSaving\" class=\"mx-0 btn-secondary\" \nng-click=\"vm.addPackage()\"><div tabindex=\"0\" class=\"tabbable-button\">Add Warranty Feature</div></md-button></div></div>\n</div></div>");
$templateCache.put("app/main/settings/Warranty/edit-dialog/edit-warranty.html","<div class=\"card\"><div class=\"modal-header bg-blue\"><h5 class=\"modal-title mr-5\">\nEdit fields to change Warranty ID: {{vm.warranty.id_warranty}}</h5><button type=\"button\" class=\"close\" \nng-click=\"vm.closeDialog()\"><span aria-hidden=\"true\">&times;</span></button></div><div class=\"card-body\"><p>\nWarranty name</p><div class=\"badge badge-pill badge-warning pull-left\">Must be greater than 1 characters</div><input \ntype=\"text\" class=\"form-control my-2\" placeholder=\"Type here\" ng-model=\"vm.warrantytempholder.name\" \nng-change=\"vm.enableButton()\"></div><div class=\"card-body\"><p>Warranty Description</p><div \nclass=\"badge badge-pill badge-warning pull-left\">Could be Empty</div><input type=\"text\" class=\"form-control my-2\" \nplaceholder=\"Type here\" ng-model=\"vm.warrantytempholder.description\" ng-change=\"vm.enableButton()\"></div><div \nclass=\"card-body\"><p>Warranty Cost</p><div class=\"badge badge-pill badge-warning pull-left\">Must not be empty</div>\n<input type=\"number\" class=\"form-control my-2\" placeholder=\"Type here\" ng-model=\"vm.warrantytempholder.cost\" \nng-change=\"vm.enableButton()\"></div><div class=\"card-body\"><p>Warranty Retail</p><div \nclass=\"badge badge-pill badge-warning pull-left\">Could be Empty</div><input type=\"number\" class=\"form-control my-2\" \nplaceholder=\"Type here\" ng-model=\"vm.warrantytempholder.retail\" ng-change=\"vm.enableButton()\"></div><div \nclass=\"card-body\"><p>Warranty Months Covered</p><div class=\"badge badge-pill badge-warning pull-left\">Must not be empty\n</div><input type=\"number\" step=\"1\" class=\"form-control my-2\" placeholder=\"Type here\" \nng-model=\"vm.warrantytempholder.duration_month\" ng-change=\"vm.enableButton()\"></div><div class=\"card-body\"><p>\nWarranty Mileage Covered</p><div class=\"badge badge-pill badge-warning pull-left\">Could be Empty</div><input \ntype=\"number\" step=\"1\" class=\"form-control my-2\" placeholder=\"Type here\" \nng-model=\"vm.warrantytempholder.duration_mileage\" ng-change=\"vm.enableButton()\"></div><div class=\"card-body\"><p>\nWarranty Maximun Vehicle Year</p><div class=\"badge badge-pill badge-warning pull-left\">Must not be empty</div><input \ntype=\"number\" step=\"1\" class=\"form-control my-2\" placeholder=\"Type here\" \nng-model=\"vm.warrantytempholder.max_vehicle_year\" ng-change=\"vm.enableButton()\"></div><div class=\"card-body\"><p>\nWarranty Minimum Vehicle Mileage</p><div class=\"badge badge-pill badge-warning pull-left\">Must not be empty</div><input\n type=\"number\" step=\"1\" class=\"form-control my-2\" placeholder=\"Type here\" ng-model=\"vm.warrantytempholder.min_mileage\" \nng-change=\"vm.enableButton()\"></div><div class=\"card-body\"><p>Warranty Maximun Vehicle Mileage</p><div \nclass=\"badge badge-pill badge-warning pull-left\">Must not be empty</div><input type=\"number\" step=\"1\" \nclass=\"form-control my-2\" placeholder=\"Type here\" ng-model=\"vm.warrantytempholder.max_mileage\" \nng-change=\"vm.enableButton()\"></div><div class=\"card-body\"><p>Warranty Provider</p><div \nclass=\"badge badge-pill badge-warning pull-left\">Must be greater than 1 characters</div><input type=\"text\" \nclass=\"form-control my-2\" placeholder=\"Type here\" ng-model=\"vm.warrantytempholder.provider\" \nng-change=\"vm.enableButton()\"></div><div class=\"card-body\"><p>Warranty Max Claim</p><input type=\"text\" \nclass=\"form-control my-2\" placeholder=\"Type here\" ng-model=\"vm.warrantytempholder.max_claim\" \nng-change=\"vm.enableButton()\"></div><div class=\"card-body\" ng-if=\"vm.containfeature\"><h6>Features</h6><div \nng-repeat=\"feature in features\"><p><a class=\"littleboldertext\">ID:</a> {{feature.id_warranty_feature}} <a \nclass=\"littleboldertext\">Name:</a> {{feature.name}}</p><md-button class=\"bg-red pull-right\" \nng-click=\"vm.removewarrantyfeature(feature)\" ng-disabled=\"!vm.isButtonActive\">Remove</md-button><p \nclass=\"littleboldertext\">Description:</p>{{feature.description}}<br><br><br></div></div><md-divider></md-divider><div \nclass=\"card-body\">Add New Warranty Features<br><select class=\"m-0 pl-2 py-2\" \nng-options=\"option as option.name for option in vm.warrantyfeature track by option.id_warranty_feature\" \nng-model=\"vm.newwarrantyfeatureselected\"></select><md-button class=\"bg-blue pull-right\" \nng-click=\"vm.addnewwarrantyfeature()\" ng-disabled=\"!vm.isButtonActive\">Add Feature</md-button></div><md-divider>\n</md-divider><md-button class=\"bg-blue pull-right\" ng-click=\"vm.confirm()\" ng-disabled=\"!vm.isButtonActive\">Confirm\n</md-button></div>");
$templateCache.put("app/main/settings/Warranty/add-WarrantyFeature-list/add-WarrantyFeature-list.html","");
$templateCache.put("app/main/settings/Warranty/delete-dialog/delete-warranty.html","<div class=\"card\"><div class=\"modal-header bg-red\"><h5 class=\"modal-title mr-5\">\nAre you sure to delete Job type\"{{vm.warranty.name}}\"</h5><button type=\"button\" class=\"close\" \nng-click=\"vm.closeDialog()\"><span aria-hidden=\"true\">&times;</span></button></div><div class=\"card-body\"><p>\nPlease type the \"{{vm.warranty.name}}\" below to confirm</p><input type=\"text\" class=\"form-control my-2\" \nplaceholder=\"Type here\" ng-model=\"vm.confirmwarrantyname\" ng-change=\"vm.enableButton()\"><md-button \nclass=\"bg-red pull-right\" ng-click=\"vm.confirm()\" ng-disabled=\"!vm.isButtonActive\">Confirm!</md-button></div></div>");
$templateCache.put("app/main/settings/Warranty/view-Warranty/view-Warranty.html","<div class=\"content-wrapper\"><div class=\"header row py-6 bg-primary text-auto px-2\"><span class=\"col h3\">\nTotal Warranty Types: <span class=\"h3 text-blue\">{{vm.totalwarranty}}</span></span></div><div class=\"container-fluid\">\n<div class=\"row justify-content-center mx-10 my-10\"><div class=\"col bg-white\"><div class=\"page-content-card\"><table \nid=\"e-commerce-products-table\" class=\"table dataTable table-striped my-5\"><thead><tr><th><div class=\"table-header\">\n<span class=\"column-title\">ID</span></div></th><th><div class=\"table-header\"><span class=\"column-title\">Name</span>\n</div></th><th><div class=\"table-header\"><span class=\"column-title\">Description</span></div></th><th><div \nclass=\"table-header\"><span class=\"column-title\">Cost $</span></div></th><th><div class=\"table-header\"><span \nclass=\"column-title\">Retail $</span></div></th><th><div class=\"table-header\"><span class=\"column-title\">Month Duration\n</span></div></th><th><div class=\"table-header\"><span class=\"column-title\">Mileage Limit</span></div></th><th><div \nclass=\"table-header\"><span class=\"column-title\">Max vehicle year</span></div></th><th><div class=\"table-header\"><span \nclass=\"column-title\">Min mileage</span></div></th><th><div class=\"table-header\"><span class=\"column-title\">Max mileage\n</span></div></th><th><div class=\"table-header\"><span class=\"column-title\">Provider</span></div></th><th><div \nclass=\"table-header\"><span class=\"column-title\">Max per Claim $</span></div></th></tr></thead><tbody><tr \nng-repeat-start=\"item in vm.warranty\"><td><div layout=\"row\" layout-align=\"start center\" \nng-click=\"vm.showItems[item.id_warranty] = !vm.showItems[item.id_warranty]\"><div class=\"text-nowrap text-truncate\">\n{{item.id_warranty}}</div><i ng-class=\"vm.showItems[item.id_warranty]? [\'icon-chevron-up\']:[\'icon-chevron-down\']\"></i>\n</div></td><td>{{item.name}}</td><td>{{item.description}}</td><td>${{item.cost}}</td><td>${{item.retail}}</td><td>\n{{item.duration_month}}</td><td>{{item.duration_mileage}}</td><td>{{item.max_vehicle_year}}</td><td>\n{{item.min_mileage}}</td><td>{{item.max_mileage}}</td><td>{{item.provider}}</td><td>${{item.max_claim}}</td><td>\n<md-button class=\"bg-red\" restrict rolescansee=\"developer company_manager\" ng-disabled=\"!item.canBeChanged\" \nng-click=\"vm.dialogdelete(item)\" ng-if=\"!user.isOwner\">Delete</md-button></td><td><md-button class=\"bg-blue\" restrict \nrolescansee=\"developer company_manager\" ng-disabled=\"!item.canBeChanged\" ng-click=\"vm.dialogedit(item)\" \nng-if=\"!user.isOwner\">Edit</md-button></td></tr><tr ng-repeat-end><td colspan=\"12\"><table \nid=\"e-commerce-products-table\" class=\"table dataTable table-striped my-5\" ng-if=\"vm.showItems[item.id_warranty]\">\n<thead><tr><th><div class=\"table-header-2\"><span class=\"column-title\">warranty feature ID</span></div></th><th><div \nclass=\"table-header-2\"><span class=\"column-title\">name</span></div></th><th><div class=\"table-header-2\"><span \nclass=\"column-title\">description</span></div></th></tr></thead><tbody><tr ng-repeat=\"feature in item.features\"><td>\n{{feature.id_warranty_feature}}</td><td>{{feature.name}}</td><td>{{feature.description}}</td></tr></tbody></table></td>\n</tr></tbody></table></div></div></div></div></div>");
$templateCache.put("app/main/settings/coupon/add-coupon/add-coupon.html","<div class=\"content-wrapper\"><div class=\"header py-6 bg-primary text-auto px-2\"><span class=\"h3\">Add Coupon</span>\n</div><div class=\"container-fluid px-10 py-7\"><div class=\"row\"><div \nclass=\"col px-0 profile-box info-box general card mx-2 my-3\"><header class=\"h6 bg-secondary text-auto p-4\"><div \nclass=\"title\">Coupon Information</div></header><div class=\"jumbotron mx-3 my-7 row\"><div class=\"col-7\"><form \nname=\"addCouponForm\"><div class=\"info-line mb-6\"><div class=\"title font-weight-bold mb-1\">Coupon Code<div \nclass=\"badge badge-pill badge-warning pull-right\" role=\"alert\" \nng-if=\"addCouponForm.couponCode.$dirty && addCouponForm.couponCode.$invalid\">Must be at least 3 characters</div></div>\n<input name=\"couponCode\" class=\"info form-control\" type=\"text\" ng-model=\"vm.newCoupon.code\" required ng-minlength=\"3\" \nplaceholder=\"Enter code\"></div><div class=\"info-line mb-6\"><div class=\"title font-weight-bold mb-1\">Description<div \nclass=\"badge badge-pill badge-warning pull-right\" role=\"alert\" \nng-if=\"addCouponForm.description.$dirty && addCouponForm.description.$invalid\">Must be at least 5 characters</div>\n</div><input name=\"description\" class=\"info form-control\" type=\"text\" ng-model=\"vm.newCoupon.description\" required \nng-minlength=\"5\" placeholder=\"Enter description\"></div><div class=\"info-line mb-6\"><div \nclass=\"title font-weight-bold mb-1\">Discount Amount</div><input name=\"discountAmount\" class=\"info form-control\" \ntype=\"number\" ng-model=\"vm.newCoupon.discount\" required placeholder=\"Enter discount\"></div><div class=\"info-line mb-6\">\n<div class=\"title font-weight-bold mb-1\">Discount Type</div><select name=\"discountType\" class=\"info form-control\" \nng-model=\"vm.newCoupon.discount_type\" required><option value=\"percent\">Percent (%)</option><option value=\"fixed\">\nFixed ($)</option></select></div><div class=\"info-line mb-6\"><div class=\"title font-weight-bold mb-1\">Expiration Date\n</div><md-datepicker md-hide-icons=\"calendar\" ng-model=\"vm.newCoupon.expiration_date\" name=\"expirationDate\">\n</md-datepicker></div><div class=\"info-line mb-6\"><div class=\"title font-weight-bold mb-1\">Usage Limit</div><input \nname=\"discountAmount\" class=\"info form-control\" type=\"text\" ng-model=\"vm.newCoupon.usage_limit\" required \nplaceholder=\"Enter Usage Limit\" pattern=\"^\\d+$\" ng-pattern=\"/^\\d+$/\" ng-trim=\"false\"><div class=\"text-danger\" \nng-show=\"form.discountAmount.$error.pattern\">Only digits are allowed.</div></div><div class=\"info-line mb-6\"><div \nclass=\"title font-weight-bold mb-1\">Is Active</div><md-checkbox class=\"info\" ng-model=\"vm.newCoupon.is_active\">\n</md-checkbox></div><button type=\"submit\" class=\"btn bg-blue\" ng-click=\"vm.addCoupon()\" \nng-disabled=\"vm.disableAddButton\" style=\"width: 15rem\">Create Coupon</button></form></div></div></div></div></div>\n</div>");
$templateCache.put("app/main/settings/coupon/edit-coupon/edit-coupon.html","<div class=\"card\"><div class=\"modal-header bg-blue\"><h5 class=\"modal-title mr-5\">\nEdit fields to change Coupon ID: {{vm.coupon.id_coupon}}</h5><button type=\"button\" class=\"close\" \nng-click=\"vm.closeDialog()\"><span aria-hidden=\"true\">&times;</span></button></div><div class=\"card-body\"><p>Coupon Code\n</p><div class=\"badge badge-pill badge-warning pull-left\">Must be at least 3 characters</div><input type=\"text\" \nclass=\"form-control my-2\" placeholder=\"Enter code\" ng-model=\"vm.coupon.code\" ng-change=\"vm.enableButton()\"></div><div \nclass=\"card-body\"><p>Description</p><div class=\"badge badge-pill badge-warning pull-left\">Must be at least 5 characters\n</div><input type=\"text\" class=\"form-control my-2\" placeholder=\"Enter description\" ng-model=\"vm.coupon.description\" \nng-change=\"vm.enableButton()\"></div><div class=\"card-body\"><p>Discount Amount</p><input type=\"number\" \nclass=\"form-control my-2\" placeholder=\"Enter discount\" ng-model=\"vm.coupon.discount\" ng-change=\"vm.enableButton()\">\n</div><div class=\"card-body\"><p>Discount Type</p><select class=\"form-control my-2\" ng-model=\"vm.coupon.discount_type\" \nng-change=\"vm.enableButton()\"><option value=\"percent\">Percent (%)</option><option value=\"fixed\">Fixed ($)</option>\n</select></div><div class=\"card-body\"><p>Expiration Date</p><md-datepicker md-hide-icons=\"calendar\" \nng-model=\"vm.coupon.expiration_date\" name=\"expirationDate\"></md-datepicker></div><div class=\"card-body\"><p>Usage Limit\n</p><input type=\"number\" class=\"form-control my-2\" placeholder=\"Enter Usage Limit\" ng-model=\"vm.coupon.usage_limit\" \nng-change=\"vm.enableButton()\"></div><div class=\"card-body\"><p><strong>Is Active:</strong><md-checkbox \nclass=\"my-2 mb-0 p-0\" ng-model=\"vm.coupon.is_active\"></md-checkbox></p></div><md-button class=\"bg-blue pull-right\" \nng-click=\"vm.confirm()\" ng-disabled=\"!vm.isButtonActive\">Confirm</md-button></div>");
$templateCache.put("app/main/settings/coupon/view-coupon/view-coupon.html","<div class=\"content-wrapper\"><div class=\"header row py-6 bg-primary text-auto px-2\"><span class=\"col h3\">\nTotal Coupons: <span class=\"h3 text-blue\">{{vm.coupons.length}}</span></span><div class=\"col search-wrapper mr-10\" \nstyle=\"max-width: 40rem\"><div class=\"input-group\"><span class=\"input-group-btn\"><button type=\"button\" \nclass=\"btn btn-icon\"><i class=\"icon icon-magnify\"></i></button> </span><input id=\"coupon-search-input\" type=\"text\" \nclass=\"form-control\" placeholder=\"Search\" ng-model=\"vm.keyword\" aria-label=\"Search\" ng-change=\"vm.search()\"></div>\n</div></div><div class=\"container-fluid\"><div class=\"row justify-content-center mx-10 my-10\"><div class=\"col bg-white\">\n<div class=\"page-content-card\"><table id=\"coupon-table\" class=\"table dataTable table-striped my-5\"><thead><tr><th>\nCoupon ID</th><th>Code</th><th>Description</th><th>Discount</th><th>Expiration Date</th><th>Usage Limit</th><th>\nUsage Count</th><th>Actions</th></tr></thead><tbody><tr ng-repeat=\"coupon in vm.coupons | filter:vm.keyword\"><td>\n{{coupon.id_coupon}}</td><td>{{coupon.code}}</td><td>{{coupon.description}}</td><td>{{coupon.discount}} <span \nng-if=\"coupon.discount_type === \'percent\'\">%</span> <span ng-if=\"coupon.discount_type === \'fixed\'\">$</span></td><td>\n{{coupon.expiration_date | date:\'yyyy-MM-dd\'}}</td><td>{{coupon.usage_limit}}</td><td>{{coupon.usage_count}}</td><td>\n<button class=\"btn btn-primary\" ng-click=\"vm.dialogedit(coupon)\">Edit</button> <button class=\"btn btn-danger\" \nng-click=\"vm.deleteCoupon(coupon)\">Delete</button> <button class=\"btn btn-secondary\" \nng-click=\"vm.copyCouponURL(coupon)\">Copy Appointment URL</button></td></tr></tbody></table><div \nclass=\"row justify-content-center\"><ul class=\"pagination pagination-sm\"><li class=\"page-item\" \nng-click=\"vm.goToPage(1)\"><a class=\"page-link\" href=\"#\">&laquo;</a></li><li class=\"page-item\" \nng-repeat=\"page in vm.pages\" ng-click=\"vm.goToPage(page.pageNumber)\"><a class=\"page-link\" href=\"#\">{{page.pageNumber}}\n</a></li><li class=\"page-item\" ng-click=\"vm.goToLastPage()\"><a class=\"page-link\" href=\"#\">&raquo;</a></li></ul></div>\n</div></div></div></div></div>");
$templateCache.put("app/main/settings/coupon/dialogs/delete-prompt-dialog-coupon.html","<div class=\"card\"><div class=\"modal-header bg-red\"><h5 class=\"modal-title mr-5\">\nAre you sure to delete Coupon \"{{vm.labour.labour_name}}\"</h5><button type=\"button\" class=\"close\" \nng-click=\"vm.closeDialog()\"><span aria-hidden=\"true\">&times;</span></button></div><div class=\"card-body\"><p>\nPlease type the \"{{vm.labour.labour_name}}\" below to confirm</p><input type=\"text\" class=\"form-control my-2\" \nplaceholder=\"Type here\" ng-model=\"vm.confirmLabourname\" ng-change=\"vm.enableButton()\"><md-button \nclass=\"bg-red pull-right\" ng-click=\"vm.confirm()\" ng-disabled=\"!vm.isButtonActive\">Confirm!</md-button></div></div>");
$templateCache.put("app/main/settings/customer-portal-services-catogory/add-customerportalservicescatogory/add-customerportalservicescatogory.html","<div class=\"content-wrapper\"><div class=\"header py-6 bg-primary text-auto px-2\"><span class=\"h3\">\nAdd New Customer Portal Services Catogory</span></div><div class=\"container-fluid px-10 py-7\"><div class=\"row\"><div \nclass=\"col px-0 profile-box info-box general card mx-2 my-3\"><header class=\"h6 bg-secondary text-auto p-4\"><div \nclass=\"title\">General Information</div></header><div class=\"jumbotron mx-3 my-7 row\"><div class=\"col-7\"><form \nname=\"addslider\"><div class=\"info-line mb-6\"><div class=\"title font-weight-bold mb-1\">\nCustomer Portal Services Catogory Description</div><input name=\"name\" class=\"info form-control\" type=\"text\" \nng-model=\"vm.customerPortalServicesCatogory.name\" ng-pattern=\"regex\"></div><button type=\"submit\" class=\"btn bg-blue\" \nng-click=\"vm.addSlider()\" ng-disabled=\"vm.disableAddButton\" style=\"width: 40rem\">\nCreate Customer Portal Services Catogory</button></form></div></div></div></div></div></div>");
$templateCache.put("app/main/settings/customer-portal-services-catogory/delete-customerportalservicescatogory/delete-prompt-dialog-customerportalservicescatogory.html","<div class=\"card\"><div class=\"modal-header bg-red\"><h5 class=\"modal-title mr-5\">\nAre you sure to delete Preset Labour \"{{vm.customerPortalAppointmentServicesCatogory.name}}\"</h5><button type=\"button\" \nclass=\"close\" ng-click=\"vm.closeDialog()\"><span aria-hidden=\"true\">&times;</span></button></div><div class=\"card-body\">\n<p>Please type the \"{{vm.customerPortalAppointmentServicesCatogory.name}}\" below to confirm</p><input type=\"text\" \nclass=\"form-control my-2\" placeholder=\"Type here\" ng-model=\"vm.confirmLabourname\" ng-change=\"vm.enableButton()\">\n<md-button class=\"bg-red pull-right\" ng-click=\"vm.confirm()\" ng-disabled=\"!vm.isButtonActive\">Confirm!</md-button>\n</div></div>");
$templateCache.put("app/main/settings/customer-portal-services-catogory/edit-customerportalservicescatogory/edit-customerportalservicescatogory.html","<style>\n.card {\r\n    max-width: 600px;\r\n    margin: 0 auto;\r\n    padding: 20px;\r\n    border-radius: 10px;\r\n    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);\r\n  }\r\n  .modal-header {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    padding: 10px 20px;\r\n    border-top-left-radius: 10px;\r\n    border-top-right-radius: 10px;\r\n    background-color: #3498db;\r\n    color: white;\r\n  }\r\n  .modal-title {\r\n    margin: 0;\r\n    font-size: 1.5rem;\r\n    font-weight: bold;\r\n  }\r\n  .close {\r\n    color: white;\r\n    font-size: 1.5rem;\r\n  }\r\n  .close:hover {\r\n    color: #f1c40f;\r\n  }\r\n  p {\r\n    margin: 10px 0;\r\n    font-size: 1.2rem;\r\n    line-height: 1.5;\r\n  }\r\n  img {\r\n    display: block;\r\n    max-width: 100%;\r\n    height: auto;\r\n    margin-top: 20px;\r\n    border-radius: 5px;\r\n    box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.1);\r\n  }\n</style><div class=\"card\"><div class=\"modal-header\"><h5 class=\"modal-title\">Edit</h5><button type=\"button\" \nclass=\"close\" ng-click=\"vm.closeDialog()\">&times;</button></div><div><p><strong>\nCustomer Customer Portal Appointment Services Catogory ID:</strong>\n {{ vm.customerPortalAppointmentServicesCatogory.id_services_catogory }}</p><p ng-if=\"!vm.editingList.name\"><strong>\nDescription:</strong> {{ vm.customerPortalAppointmentServicesCatogory.name }} <button style=\"width: 24px\" \nng-click=\"vm.editContent(\'name\')\"><i class=\"icon-pen text-secondary ng-scope\"></i></button></p><div \nng-if=\"vm.editingList.name\"><md-input-container flex=\"100\" class=\"input-box small-input-box\"><br><input \nname=\"Description\" ng-model=\"vm.customerPortalAppointmentServicesCatogory.name\" autocomplete=\"off\" \nplaceholder=\"Description\"></md-input-container><button style=\"width: 24px\" ng-click=\"vm.finisheditContent(\'name\')\"><i \nclass=\"icon-check-all text-secondary ng-scope\"></i></button></div><div layout=\"row\"><md-button flex \nclass=\"mx-0 btn-sm btn-secondary\" ng-disabled=\"vm.isDeleting\" ng-click=\"vm.confirm()\">Save and Update</md-button></div>\n</div></div>");
$templateCache.put("app/main/settings/customer_portal_slider/add-customerportalslider/add-customerportalslider.html","<div class=\"content-wrapper\"><div class=\"header py-6 bg-primary text-auto px-2\"><span class=\"h3\">\nAdd New Customer Portal Main Page Slider</span></div><div class=\"container-fluid px-10 py-7\"><div class=\"row\"><div \nclass=\"col px-0 profile-box info-box general card mx-2 my-3\"><header class=\"h6 bg-secondary text-auto p-4\"><div \nclass=\"title\">General Information</div></header><div class=\"jumbotron mx-3 my-7 row\"><div class=\"col-7\"><form \nname=\"addslider\"><div class=\"info-line mb-6\"><div class=\"title font-weight-bold mb-1\">Slider Description</div><input \nname=\"name\" class=\"info form-control\" type=\"text\" ng-model=\"vm.slider.description\" ng-pattern=\"regex\"></div><div \nclass=\"info-line mb-6\"><div class=\"title font-weight-bold mb-1\">Slider Title</div><input name=\"name\" \nclass=\"info form-control\" type=\"text\" ng-model=\"vm.slider.title\" ng-pattern=\"regex\"></div><div class=\"info-line mb-6\">\n<div class=\"title font-weight-bold mb-1\">Slider Button Text</div><input name=\"name\" class=\"info form-control\" \ntype=\"text\" ng-model=\"vm.slider.button_text\" ng-pattern=\"regex\"></div><div class=\"info-line mb-6\"><div \nclass=\"title font-weight-bold mb-1\">Link</div><input name=\"name\" class=\"info form-control\" type=\"text\" \nng-model=\"vm.slider.link\" ng-pattern=\"regex\"></div><div class=\"info-line mb-6\"><div \nclass=\"title font-weight-bold mb-1\"><md-input-container class=\"purchase-step-selector\">For Mobile<md-checkbox \nclass=\"my-2 mb-0 p-0\" ng-model=\"vm.slider.for_mobile\"></md-checkbox></md-input-container></div></div><div \nclass=\"info-line mb-6\"><div class=\"title font-weight-bold mb-1\"><md-input-container class=\"purchase-step-selector\">\nFor Desktop<md-checkbox class=\"my-2 mb-0 p-0\" ng-model=\"vm.slider.for_desktop\"></md-checkbox></md-input-container>\n</div></div><div class=\"info-line mb-6\"><div class=\"title font-weight-bold mb-1\"><md-input-container \nclass=\"purchase-step-selector\">Is Enable<md-checkbox class=\"my-2 mb-0 p-0\" ng-model=\"vm.slider.is_enable\">\n</md-checkbox></md-input-container></div></div><button type=\"submit\" class=\"btn bg-blue\" ng-click=\"vm.addSlider()\" \nng-disabled=\"vm.disableAddButton\" style=\"width: 30rem\">Create customer portal slider</button></form></div></div></div>\n</div></div></div>");
$templateCache.put("app/main/settings/customer-portal-services-catogory/view-customerportalservicescatogory/view-customerportalservicescatogory.html","<div class=\"content-wrapper\"><div class=\"header row py-6 bg-primary text-auto px-2\"><span class=\"col h3\">\nTotal Services Catogory: <span class=\"h3 text-blue\">{{vm.totalUser}}</span></span><div \nclass=\"col search-wrapper mr-10\" style=\"max-width: 40rem\"><div class=\"input-group\"></div></div></div><div \nclass=\"container-fluid\"><div class=\"row justify-content-center mx-10 my-10\"><div class=\"col bg-white\"><div \nclass=\"page-content-card\"><table id=\"e-commerce-products-table\" class=\"table dataTable table-striped my-5\"><thead><tr>\n<th><div class=\"table-header\"><span class=\"column-title\">Services Catogory ID</span></div></th><th><div \nclass=\"table-header\"><span class=\"column-title\">Services Catogory Description</span></div></th><th restrict \nrolescansee=\"developer company_manager\"><div class=\"table-header\"></div></th><th><form></form></th></tr></thead><tbody>\n<tr ng-repeat=\"servicesCatogory in vm.customerPortalAppointmentServicesCatogory | filter:searchText\"><td>\n{{servicesCatogory.id_services_catogory}}</td><td>{{servicesCatogory.name}}</td><td></td><td><md-button class=\"bg-red\" \nrestrict rolescansee=\"developer company_manager\" ng-click=\"vm.dialogDelete(servicesCatogory)\" ng-if=\"!user.isOwner\">\nDelete</md-button></td><td><md-button class=\"bg-blue\" restrict rolescansee=\"developer company_manager\" \nng-click=\"vm.dialogedit(servicesCatogory)\" ng-if=\"!user.isOwner\">Edit</md-button></td></tr></tbody></table><div \nclass=\"row justify-content-center\"><ul class=\"pagination pagination-sm\"><li class=\"page-item\" \nng-click=\"vm.goToPage(1)\"><a class=\"page-link\" href=\"#\">&laquo;</a></li><li class=\"page-item {{page.isDisabled}}\" \nng-repeat=\"page in vm.pages\" ng-click=\"vm.goToPage(page.pageNumber)\"><a class=\"page-link\" href=\"#\">{{page.pageNumber}}\n</a></li><li class=\"page-item\" ng-click=\"vm.goToLastPage()\"><a class=\"page-link\" href=\"#\">&raquo;</a></li></ul></div>\n</div></div></div></div></div>");
$templateCache.put("app/main/settings/customer_portal_slider/detail-customerportalslider/detail-customerportalslider.html","<style>\n.card {\r\n    max-width: 600px;\r\n    margin: 0 auto;\r\n    padding: 20px;\r\n    border-radius: 10px;\r\n    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);\r\n  }\r\n  .modal-header {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    padding: 10px 20px;\r\n    border-top-left-radius: 10px;\r\n    border-top-right-radius: 10px;\r\n    background-color: #3498db;\r\n    color: white;\r\n  }\r\n  .modal-title {\r\n    margin: 0;\r\n    font-size: 1.5rem;\r\n    font-weight: bold;\r\n  }\r\n  .close {\r\n    color: white;\r\n    font-size: 1.5rem;\r\n  }\r\n  .close:hover {\r\n    color: #f1c40f;\r\n  }\r\n  p {\r\n    margin: 10px 0;\r\n    font-size: 1.2rem;\r\n    line-height: 1.5;\r\n  }\r\n  img {\r\n    display: block;\r\n    max-width: 100%;\r\n    height: auto;\r\n    margin-top: 20px;\r\n    border-radius: 5px;\r\n    box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.1);\r\n  }\n</style><div class=\"card\"><div class=\"modal-header\"><h5 class=\"modal-title\">Delete</h5><button type=\"button\" \nclass=\"close\" ng-click=\"vm.closeDialog()\">&times;</button></div><div><div class=\"card-body\"><p>\nPlease type the \"{{vm.confirmText}}\" below to confirm</p><input type=\"text\" class=\"form-control my-2\" \nplaceholder=\"Type here\" ng-model=\"vm.confirmmiscfeesname\" ng-change=\"vm.enableButton()\"><md-button \nclass=\"bg-red pull-right\" ng-click=\"vm.confirm()\" ng-disabled=\"!vm.isButtonActive\">Confirm!</md-button></div></div>\n</div>");
$templateCache.put("app/main/settings/customer_portal_slider/edit-customerportalslider/edit-customerportalslider.html","<style>\n.card {\r\n    max-width: 600px;\r\n    margin: 0 auto;\r\n    padding: 20px;\r\n    border-radius: 10px;\r\n    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);\r\n  }\r\n  .modal-header {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    padding: 10px 20px;\r\n    border-top-left-radius: 10px;\r\n    border-top-right-radius: 10px;\r\n    background-color: #3498db;\r\n    color: white;\r\n  }\r\n  .modal-title {\r\n    margin: 0;\r\n    font-size: 1.5rem;\r\n    font-weight: bold;\r\n  }\r\n  .close {\r\n    color: white;\r\n    font-size: 1.5rem;\r\n  }\r\n  .close:hover {\r\n    color: #f1c40f;\r\n  }\r\n  p {\r\n    margin: 10px 0;\r\n    font-size: 1.2rem;\r\n    line-height: 1.5;\r\n  }\r\n  img {\r\n    display: block;\r\n    max-width: 100%;\r\n    height: auto;\r\n    margin-top: 20px;\r\n    border-radius: 5px;\r\n    box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.1);\r\n  }\n</style><div class=\"card\"><div class=\"modal-header\"><h5 class=\"modal-title\">Edit</h5><button type=\"button\" \nclass=\"close\" ng-click=\"vm.closeDialog()\">&times;</button></div><div><p><strong>Customer Portal Slider ID:</strong>\n {{ vm.sliderItem.id_customer_portal_slider_file }}</p><p ng-if=\"!vm.editingList.description\"><strong>Description:\n</strong> {{ vm.sliderItem.description }} <button style=\"width: 24px\" ng-click=\"vm.editContent(\'description\')\"><i \nclass=\"icon-pen text-secondary ng-scope\"></i></button></p><div ng-if=\"vm.editingList.description\"><md-input-container \nflex=\"100\" class=\"input-box small-input-box\"><br><input name=\"Description\" ng-model=\"vm.sliderItem.description\" \nautocomplete=\"off\" placeholder=\"Description\"></md-input-container><button style=\"width: 24px\" \nng-click=\"vm.finisheditContent(\'description\')\"><i class=\"icon-check-all text-secondary ng-scope\"></i></button></div><p \nng-if=\"!vm.editingList.title\"><strong>Title:</strong> {{ vm.sliderItem.title }} <button style=\"width: 24px\" \nng-click=\"vm.editContent(\'title\')\"><i class=\"icon-pen text-secondary ng-scope\"></i></button></p><div \nng-if=\"vm.editingList.title\"><md-input-container flex=\"100\" class=\"input-box small-input-box\"><br><input name=\"Title\" \nng-model=\"vm.sliderItem.title\" autocomplete=\"off\" placeholder=\"Title\"></md-input-container><button style=\"width: 24px\" \nng-click=\"vm.finisheditContent(\'title\')\"><i class=\"icon-check-all text-secondary ng-scope\"></i></button></div><p \nng-if=\"!vm.editingList.button_text\"><strong>Button Text:</strong> {{ vm.sliderItem.button_text }} <button \nstyle=\"width: 24px\" ng-click=\"vm.editContent(\'button_text\')\"><i class=\"icon-pen text-secondary ng-scope\"></i></button>\n</p><div ng-if=\"vm.editingList.button_text\"><md-input-container flex=\"100\" class=\"input-box small-input-box\"><br><input\n name=\"Button Text\" ng-model=\"vm.sliderItem.button_text\" autocomplete=\"off\" placeholder=\"Button Text\">\n</md-input-container><button style=\"width: 24px\" ng-click=\"vm.finisheditContent(\'button_text\')\"><i \nclass=\"icon-check-all text-secondary ng-scope\"></i></button></div><p ng-if=\"!vm.editingList.link\"><strong>Link:\n</strong> {{ vm.sliderItem.link }} <button style=\"width: 24px\" ng-click=\"vm.editContent(\'link\')\"><i \nclass=\"icon-pen text-secondary ng-scope\"></i></button></p><div ng-if=\"vm.editingList.link\"><md-input-container \nflex=\"100\" class=\"input-box small-input-box\"><br><input name=\"Button Link\" ng-model=\"vm.sliderItem.link\" \nautocomplete=\"off\" placeholder=\"Button Link\"></md-input-container><button style=\"width: 24px\" \nng-click=\"vm.finisheditContent(\'link\')\"><i class=\"icon-check-all text-secondary ng-scope\"></i></button></div><p>\n<strong>For Mobile:</strong> {{ vm.sliderItem.for_mobile}}<md-checkbox class=\"my-2 mb-0 p-0\" \nng-model=\"vm.sliderItem.for_mobile\"></md-checkbox></p><p><strong>For Desktop:</strong> {{ vm.sliderItem.for_desktop }}\n<md-checkbox class=\"my-2 mb-0 p-0\" ng-model=\"vm.sliderItem.for_desktop\"></md-checkbox></p><p><strong>IS Enable:\n</strong> {{ vm.sliderItem.is_enable }}<md-checkbox class=\"my-2 mb-0 p-0\" ng-model=\"vm.sliderItem.is_enable\">\n</md-checkbox></p><p><strong>File Name:</strong> {{ vm.sliderItem.file_name }}</p><p><strong>UUID:</strong>\n {{ vm.sliderItem.uuid }}</p><p><strong>File Type:</strong> {{ vm.sliderItem.file_type }}</p><img \nsrc=\"{{ vm.sliderItem.url }}\" alt=\"{{ vm.sliderItem.file_name }}\"><div layout=\"row\"><md-button flex \nclass=\"mx-0 btn-sm btn-danger\" ng-disabled=\"vm.isDeleting\" ng-click=\"vm.confirmDeleting()\">Remove Image</md-button>\n</div><div layout=\"row\"><md-button flex class=\"mx-0 btn-sm btn-secondary\" ng-disabled=\"vm.isDeleting\">\nUpload to Replace Image <input class=\"fileInput\" nv-file-select=\"false\" uploader=\"vm.imageUploader\" \nmultiple=\"multiple\" type=\"file\" accept=\"image/*\"></md-button></div><div layout=\"row\"><md-button flex \nclass=\"mx-0 btn-sm btn-secondary\" ng-disabled=\"vm.isDeleting\" ng-click=\"vm.confirm()\">Save and Update</md-button></div>\n</div></div>");
$templateCache.put("app/main/settings/customer_portal_slider/view-customerportalslider/view-customerportalslider.html","<div class=\"content-wrapper\"><div class=\"header row py-6 bg-primary text-auto px-2\"><span class=\"col h3\">\nTotal Slider Count: <span class=\"h3 text-blue\">{{vm.customerPortalSliderList.length}}</span></span><div \nclass=\"col search-wrapper mr-10\" style=\"max-width: 40rem\"><div class=\"input-group\"></div></div></div><div \nclass=\"container-fluid\"><div class=\"row justify-content-center mx-10 my-10\"><div class=\"col bg-white\"><div \nclass=\"page-content-card\"><table id=\"e-commerce-products-table\" class=\"table dataTable table-striped my-5\"><thead><tr>\n<th><div class=\"table-header\"><span class=\"column-title\">Slider Image Preview</span></div></th><th><div \nclass=\"table-header\"></div></th><th><div class=\"table-header\"></div></th><th><div class=\"table-header\"></div></th></tr>\n</thead><tbody><tr ng-repeat=\"image in vm.customerPortalSliderList | filter:searchText\"><td><div flex=\"90\"><img \nsrc=\"{{image.url}}\"></div></td><td><md-button class=\"bg-red\" restrict rolescansee=\"developer company_manager\" \nng-click=\"vm.dialogDelete(image)\" ng-if=\"!user.isOwner\">Delete</md-button></td><td><md-button class=\"bg-blue\" restrict \nrolescansee=\"developer company_manager\" ng-click=\"vm.dialogedit(image)\">Edit</md-button></td></tr></tbody></table>\n</div></div></div></div></div>");
$templateCache.put("app/main/settings/jobtypes/dialogs/delete-prompt-dialog-job.html","<div class=\"card\"><div class=\"modal-header bg-red\"><h5 class=\"modal-title mr-5\">\nAre you sure to delete Job type\"{{vm.job.name}}\"</h5><button type=\"button\" class=\"close\" ng-click=\"vm.closeDialog()\">\n<span aria-hidden=\"true\">&times;</span></button></div><div class=\"card-body\"><p>\nPlease type the \"{{vm.job.name}}\" below to confirm</p><input type=\"text\" class=\"form-control my-2\" \nplaceholder=\"Type here\" ng-model=\"vm.confirmmiscfeesname\" ng-change=\"vm.enableButton()\"><md-button \nclass=\"bg-red pull-right\" ng-click=\"vm.confirm()\" ng-disabled=\"!vm.isButtonActive\">Confirm!</md-button></div></div>");
$templateCache.put("app/main/settings/jobtypes/add-job/add-job.html","<div class=\"content-wrapper\"><div class=\"header py-6 bg-primary text-auto px-2\"><span class=\"h3\">Add Job</span></div>\n<div class=\"container-fluid px-10 py-7\"><div class=\"row\"><div \nclass=\"col px-0 profile-box info-box general card mx-2 my-3\"><header class=\"h6 bg-secondary text-auto p-4\"><div \nclass=\"title\">General Information</div></header><div class=\"jumbotron mx-3 my-7 row\"><div class=\"col-7\"><form \nname=\"addmiscfeestypes\"><div class=\"info-line mb-6\"><div class=\"title font-weight-bold mb-1\">Description<div \nclass=\"badge badge-pill badge-warning pull-right\" \nng-if=\"addmiscfeestypes.name.$dirty && addmiscfeestypes.name.$invalid\">Must be greater than 1 characters</div></div>\n<input name=\"name\" class=\"info form-control\" type=\"text\" ng-model=\"vm.name\" \nng-blur=\"vm.checkmiscfeestypesdescription(vm.miscfeestypes.name)\" ng-focus=\"vm.isUsernameAvailable = undefined\" \nrequired ng-pattern=\"regex\" ng-minlength=\"1\"></div><div class=\"card-body\"><p><strong>For Customer Portal:</strong>\n {{vm.job.for_customer_portal}}<md-checkbox class=\"my-2 mb-0 p-0\" ng-model=\"vm.for_customer_portal\"></md-checkbox></p>\n</div><div class=\"card-body\" ng-if=\"vm.for_customer_portal\">Services Category:<br><select class=\"m-0 pl-2 py-2\" \nng-options=\"option as option.name for option in vm.servicesCatogoryList track by option.id_services_catogory\" \nng-model=\"vm.servicecatogoryselected\"></select></div><div class=\"info-line mb-6\"><div \nclass=\"title font-weight-bold mb-1\">Appointment Duration Hours <input name=\"default_time\" class=\"info form-control\" \ntype=\"number\" ng-model=\"vm.hours\" ng-maxlength=\"20\"></div><div class=\"info-line mb-6\"><div \nclass=\"title font-weight-bold mb-1\">Labour</div><div ng-repeat=\"labour in labour\"><p><a class=\"littleboldertext\">Name:\n</a> {{labour.labour_name}}</p><md-button class=\"bg-red pull-right\" ng-click=\"vm.removelabour(labour)\" \nng-disabled=\"!vm.isButtonActive\">Remove</md-button><p class=\"littleboldertext\">Quantity:</p><input type=\"number\" \nstep=\".01\" class=\"form-control my-2\" placeholder=\"Type here\" ng-model=\"labour.labour_quantity\" \nng-change=\"vm.enableButton()\"></div><md-divider></md-divider><div class=\"card-body\"><br><select class=\"m-0 pl-2 py-2\" \nng-options=\"option as option.labour_name for option in vm.labourtypelist track by option.id_labour_type\" \nng-model=\"vm.newlabourselected\"></select><md-button class=\"bg-blue pull-right\" ng-click=\"vm.addnewlabour()\" \nng-disabled=\"!vm.isButtonActive\">Add Labour</md-button></div><md-divider></md-divider></div><div \nclass=\"info-line mb-6\"><div class=\"title font-weight-bold mb-1\">Part</div><div ng-repeat=\"part in part\"><p><a \nclass=\"littleboldertext\">Name: </a>{{part.part_name}}</p><md-button class=\"bg-red pull-right\" \nng-click=\"vm.removepart(part)\" ng-disabled=\"!vm.isButtonActive\">Remove</md-button><p class=\"littleboldertext\">Code:</p>\n<input type=\"text\" class=\"form-control my-2\" placeholder=\"Type here\" ng-model=\"part.part_code\" \nng-change=\"vm.enableButton()\"><p class=\"littleboldertext\">Quantity:</p><input type=\"number\" step=\".01\" \nclass=\"form-control my-2\" placeholder=\"Type here\" ng-model=\"part.part_quantity\" ng-change=\"vm.enableButton()\"></div>\n<md-divider></md-divider><div class=\"card-body\"><br><select class=\"m-0 pl-2 py-2\" \nng-options=\"option as option.name for option in vm.parttypelist track by option.id_part_type\" \nng-model=\"vm.newpartselected\"></select><md-button class=\"bg-blue pull-right\" ng-click=\"vm.addnewpart()\" \nng-disabled=\"!vm.isButtonActive\">Add Part</md-button></div><md-divider></md-divider></div><div class=\"info-line mb-6\">\n<div class=\"title font-weight-bold mb-1\">Misc fees</div><div ng-repeat=\"miscfee in miscfees\"><p><a \nclass=\"littleboldertext\">ID: </a>{{miscfee.fk_id_miscfeestype}} <a class=\"littleboldertext\">Name: </a>\n{{miscfee.miscfees_name}}</p><md-button class=\"bg-red pull-right\" ng-click=\"vm.removemiscfee(miscfee)\" \nng-disabled=\"!vm.isButtonActive\">Remove</md-button><p class=\"littleboldertext\">Quantity</p><input type=\"number\" \nstep=\".01\" class=\"form-control my-2\" placeholder=\"Type here\" ng-model=\"miscfee.miscfees_quantity\" \nng-change=\"vm.enableButton()\"></div><md-divider></md-divider><div class=\"card-body\"><br><select class=\"m-0 pl-2 py-2\" \nng-options=\"option as option.name for option in vm.miscfeetypelist track by option.id_miscfee\" \nng-model=\"vm.newmiscfeeselected\"></select><md-button class=\"bg-blue pull-right\" ng-click=\"vm.addnewmiscfee()\" \nng-disabled=\"!vm.isButtonActive\">Add Misc fee</md-button></div><md-divider></md-divider></div><button type=\"submit\" \nclass=\"btn bg-blue\" ng-click=\"vm.addjob()\" ng-disabled=\"vm.disableAddButton\" style=\"width: 40rem\">Create Job</button>\n</div></form></div></div></div></div></div></div>");
$templateCache.put("app/main/settings/jobtypes/view-detail-job/view-detail-job.html","<div class=\"card\"><div class=\"modal-header bg-blue\"><h5 class=\"modal-title mr-5\">Job Details</h5><button type=\"button\" \nclass=\"close\" ng-click=\"vm.closeDialog()\"><span aria-hidden=\"true\">&times;</span></button></div><div \nclass=\"job-details\"><div class=\"job-details__info\"><p class=\"job-details__info-item\"><strong>Is for Customer Portal: <a\n ng-if=\"vm.job.for_customer_portal == 1\">TRUE</a> <a ng-if=\"!vm.job.for_customer_portal == 1\">FALSE</a></strong></p><p \nclass=\"job-details__info-item\"><strong>ID:</strong> {{vm.job.id_job}}</p><p class=\"job-details__info-item\"><strong>\nName:</strong> {{vm.job.name}}</p><p class=\"job-details__info-item\"><strong>Services Category:</strong>\n {{vm.job.services_catogory_name || \"None\"}}</p><p class=\"job-details__info-item\"><strong>Services Hours:</strong>\n {{vm.job.hours || 0}}</p></div><div class=\"job-details__parts\"><p class=\"job-details__parts-heading\"><strong>Parts:\n</strong></p><ul class=\"job-details__parts-list\"><li class=\"job-details__parts-item\" \nng-repeat=\"part in vm.job.job_part\">{{part.part_name}} ({{part.part_quantity}})</li></ul></div><div \nclass=\"job-details__fees\"><p class=\"job-details__fees-heading\"><strong>Miscellaneous Fees:</strong></p><ul \nclass=\"job-details__fees-list\"><li class=\"job-details__fees-item\" ng-repeat=\"miscfee in vm.job.job_miscfee\">\n{{miscfee.miscfees_name}} ({{miscfee.miscfees_quantity}})</li></ul></div><div class=\"job-details__labour\"><p \nclass=\"job-details__labour-heading\"><strong>Labour:</strong></p><ul class=\"job-details__labour-list\"><li \nclass=\"job-details__labour-item\" ng-repeat=\"labour in vm.job.job_labour\">\n{{labour.labour_name}} ({{labour.labour_quantity}})</li></ul></div><p class=\"job-details__image\" ng-if=\"vm.job.url\">\n<strong>Image:</strong></p><img ng-if=\"vm.job.url\" ng-src=\"{{ vm.job.url }}\" alt=\"Job Image\" \nstyle=\"max-width: 100%; height: auto\"></div></div><style>\n.job-details {\r\n  border: 1px solid #ccc;\r\n  border-radius: 4px;\r\n  padding: 10px;\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.job-details__heading {\r\n  font-size: 24px;\r\n  margin-top: 0;\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.job-details__info {\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.job-details__info-item {\r\n  margin-bottom: 5px;\r\n}\r\n\r\n.job-details__parts-heading,\r\n.job-details__fees-heading,\r\n.job-details__labour-heading {\r\n  margin-top: 0;\r\n  margin-bottom: 10px;\r\n  font-weight: bold;\r\n}\r\n\r\n.job-details__parts-list,\r\n.job-details__fees-list,\r\n.job-details__labour-list {\r\n  list-style: none;\r\n  margin: 0;\r\n  padding: 0;\r\n}\r\n\r\n.job-details__parts-item,\r\n.job-details__fees-item,\r\n.job-details__labour-item {\r\n  margin-bottom: 5px;\r\n}\r\n\r\n.job-details__image {\r\n  margin-top: 20px;\r\n}\r\n\r\n.card {\r\n  min-width: 500px;\r\n  min-height: 200px;\r\n}\n</style>");
$templateCache.put("app/main/settings/jobtypes/edit-job/edit-job.html","<div class=\"card\"><div class=\"modal-header bg-blue\"><h5 class=\"modal-title mr-5\">\nEdit fields to change Job ID: {{vm.job.id_job}}</h5><button type=\"button\" class=\"close\" ng-click=\"vm.closeDialog()\">\n<span aria-hidden=\"true\">&times;</span></button></div><div class=\"card-body\"><p>Description</p><div \nclass=\"badge badge-pill badge-warning pull-left\">Must be greater than 1 characters</div><input type=\"text\" \nclass=\"form-control my-2\" placeholder=\"Type here\" ng-model=\"vm.name\" ng-change=\"vm.enableButton()\"></div><md-divider>\n</md-divider><div class=\"card-body\"><p><strong>For Customer Portal:</strong> {{vm.job.for_customer_portal}}<md-checkbox\n class=\"my-2 mb-0 p-0\" ng-model=\"vm.job.for_customer_portal\"></md-checkbox></p></div><md-divider></md-divider><div \nclass=\"card-body\">Services Category:<br><select class=\"m-0 pl-2 py-2\" \nng-options=\"option as option.name for option in vm.servicesCatogoryList track by option.id_services_catogory\" \nng-model=\"vm.servicecatogoryselected\"></select></div><md-divider></md-divider><div class=\"card-body\" \nng-if=\"vm.containlabour\"><h6>Labour</h6><div ng-repeat=\"labour in labour\"><p><a class=\"littleboldertext\">ID:</a>\n {{labour.fk_id_labourtype}} <a class=\"littleboldertext\">Name:</a> {{labour.labour_name}}</p><md-button \nclass=\"bg-red pull-right\" ng-click=\"vm.removelabour(labour)\" ng-disabled=\"!vm.isButtonActive\">Remove</md-button><p \nclass=\"littleboldertext\">Time(Hour)</p><input type=\"number\" step=\".01\" class=\"form-control my-2\" \nplaceholder=\"Type here\" ng-model=\"labour.labour_quantity\" ng-change=\"vm.enableButton()\"></div></div><md-divider>\n</md-divider><div class=\"card-body\">Add Preset Labour<br><select class=\"m-0 pl-2 py-2\" \nng-options=\"option as option.labour_name for option in vm.labourtypes track by option.id_labour_type\" \nng-model=\"vm.newlabourselected\"></select><md-button class=\"bg-blue pull-right\" ng-click=\"vm.addnewlabour()\" \nng-disabled=\"!vm.isButtonActive\">Add Labour</md-button></div><md-divider></md-divider><div class=\"card-body\" \nng-if=\"vm.containpart\"><h6>Part</h6><div ng-repeat=\"part in part\"><p><a class=\"littleboldertext\">ID: </a>\n{{part.fk_id_parttype}} <a class=\"littleboldertext\">Name: </a>{{part.part_name}}</p><md-button \nclass=\"bg-red pull-right\" ng-click=\"vm.removepart(part)\" ng-disabled=\"!vm.isButtonActive\">Remove</md-button><p \nclass=\"littleboldertext\">Code</p><input type=\"text\" step=\".01\" class=\"form-control my-2\" placeholder=\"Type here\" \nng-model=\"part.part_code\" ng-change=\"vm.enableButton()\"><p class=\"littleboldertext\">Quantity</p><input type=\"number\" \nstep=\".01\" class=\"form-control my-2\" placeholder=\"Type here\" ng-model=\"part.part_quantity\" \nng-change=\"vm.enableButton()\"></div></div><md-divider></md-divider><div class=\"card-body\">Add Preset Part<br><select \nclass=\"m-0 pl-2 py-2\" ng-options=\"option as option.name for option in vm.parttypes track by option.id_part_type\" \nng-model=\"vm.newpartselected\"></select><md-button class=\"bg-blue pull-right\" ng-click=\"vm.addnewpart()\" \nng-disabled=\"!vm.isButtonActive\">Add Part</md-button></div><md-divider></md-divider><div class=\"card-body\" \nng-if=\"vm.containmiscfees\"><h6>Misc fee</h6><div ng-repeat=\"miscfee in miscfees\"><p><a class=\"littleboldertext\">ID: \n</a>{{miscfee.fk_id_miscfeestype}} <a class=\"littleboldertext\">Name: </a>{{miscfee.miscfees_name}}</p><md-button \nclass=\"bg-red pull-right\" ng-click=\"vm.removemiscfee(miscfee)\" ng-disabled=\"!vm.isButtonActive\">Remove</md-button><p \nclass=\"littleboldertext\">Quantity</p><input type=\"number\" step=\".01\" class=\"form-control my-2\" placeholder=\"Type here\" \nng-model=\"miscfee.miscfees_quantity\" ng-change=\"vm.enableButton()\"></div></div><md-divider></md-divider><div \nclass=\"card-body\">Add New Misc fee<br><select class=\"m-0 pl-2 py-2\" \nng-options=\"option as option.name for option in vm.miscfeetypes track by option.id_miscfee\" \nng-model=\"vm.newmiscfeeselected\"></select><md-button class=\"bg-blue pull-right\" ng-click=\"vm.addnewmiscfee()\" \nng-disabled=\"!vm.isButtonActive\">Add Misc fee</md-button></div><md-divider></md-divider><div class=\"card-body\"><p \nclass=\"job-details__image\" ng-if=\"vm.job.url\"><strong>Image:</strong></p><br><img ng-if=\"vm.job.url\" \nng-src=\"{{ vm.job.url }}\" alt=\"Job Image\" style=\"max-width: 100%; height: auto\"></div><md-divider></md-divider><div \nlayout=\"row\"><md-button flex class=\"bg-blue pull-right btn-secondary\" ng-disabled=\"vm.isDeleting\">\nUpload to Replace Image <input class=\"fileInput\" nv-file-select=\"false\" uploader=\"vm.imageUploader\" \nmultiple=\"multiple\" type=\"file\" accept=\"image/*\"></md-button></div><md-divider></md-divider><md-button \nclass=\"bg-blue pull-right\" ng-click=\"vm.confirm()\" ng-disabled=\"!vm.isButtonActive\">Confirm</md-button></div>");
$templateCache.put("app/main/settings/jobtypes/view-jobtypes/view-jobtypes.html","<div class=\"content-wrapper\"><div class=\"header row py-6 bg-primary text-auto px-2\"><span class=\"col h3\">\nTotal Job Types: <span class=\"h3 text-blue\">{{vm.totalUser}}</span></span><div class=\"col search-wrapper mr-10\" \nstyle=\"max-width: 40rem\"><div class=\"input-group\"><span class=\"input-group-btn\"><button type=\"button\" \nclass=\"btn btn-icon\"><i class=\"icon icon-magnify\"></i></button> </span><input id=\"products-search-input\" type=\"text\" \nclass=\"form-control\" placeholder=\"Search\" ng-model=\"vm.keyword\" aria-label=\"Search\" ng-change=\"vm.search()\"></div>\n</div></div><div class=\"container-fluid\"><div class=\"row justify-content-center mx-10 my-10\"><div class=\"col bg-white\">\n<div class=\"page-content-card\"><table id=\"e-commerce-products-table\" class=\"table dataTable table-striped my-5\"><thead>\n<tr><th><div class=\"table-header\"><span class=\"column-title\">Job ID</span></div></th><th><div class=\"table-header\">\n<span class=\"column-title\">Job Description</span></div></th><th restrict rolescansee=\"developer company_manager\"><div \nclass=\"table-header\"></div></th></tr></thead><tbody><tr ng-repeat=\"job in vm.jobtypes | filter:searchText\"><td>\n{{job.id_job}}</td><td>{{job.name}}</td><td><md-button class=\"bg-red\" restrict rolescansee=\"developer company_manager\" \nng-disabled=\"!job.canBeChanged\" ng-click=\"vm.dialogdelete(job)\" ng-if=\"!user.isOwner\">Delete</md-button></td><td>\n<md-button class=\"bg-blue\" restrict rolescansee=\"developer company_manager\" ng-click=\"vm.dialogdetail(job)\" \nng-if=\"!user.isOwner\">View Detail</md-button></td><td><md-button class=\"bg-blue\" restrict \nrolescansee=\"developer company_manager\" ng-disabled=\"!job.canBeChanged\" ng-click=\"vm.dialogedit(job)\" \nng-if=\"!user.isOwner\">Edit</md-button></td></tr></tbody></table><div class=\"row justify-content-center\"><ul \nclass=\"pagination pagination-sm\"><li class=\"page-item\" ng-click=\"vm.goToPage(1)\"><a class=\"page-link\" href=\"#\">&laquo;\n</a></li><li class=\"page-item {{page.isDisabled}}\" ng-repeat=\"page in vm.pages\" \nng-click=\"vm.goToPage(page.pageNumber)\"><a class=\"page-link\" href=\"#\">{{page.pageNumber}}</a></li><li \nclass=\"page-item\" ng-click=\"vm.goToLastPage()\"><a class=\"page-link\" href=\"#\">&raquo;</a></li></ul></div></div></div>\n</div></div></div>");
$templateCache.put("app/main/settings/labour/add-labour/add-labour.html","<div class=\"content-wrapper\"><div class=\"header py-6 bg-primary text-auto px-2\"><span class=\"h3\">Add Preset Labour\n</span></div><div class=\"container-fluid px-10 py-7\"><div class=\"row\"><div \nclass=\"col px-0 profile-box info-box general card mx-2 my-3\"><header class=\"h6 bg-secondary text-auto p-4\"><div \nclass=\"title\">General Information</div></header><div class=\"jumbotron mx-3 my-7 row\"><div class=\"col-7\"><form \nname=\"addLabour\"><div class=\"info-line mb-6\"><div class=\"title font-weight-bold mb-1\">Description</div><input \nname=\"labour_name\" class=\"info form-control\" type=\"text\" ng-model=\"vm.labour.labour_name\" \nng-blur=\"vm.checkLabourdescription(vm.labour.labour_name)\" ng-focus=\"vm.isUsernameAvailable = undefined\" required \nng-pattern=\"regex\" ng-minlength=\"1\"></div><div class=\"info-line mb-6\"><div class=\"title font-weight-bold mb-1\">\nDefault Rate $<div class=\"badge badge-pill badge-warning pull-right\" role=\"alert\" \nng-if=\"addUser.firstName.$dirty && addUser.firstName.$invalid\">Must be between 1-20 characters</div></div><input \nname=\"default_rate\" class=\"info form-control\" type=\"number\" ng-model=\"vm.labour.default_rate\" required \nng-maxlength=\"20\"></div><div class=\"info-line mb-6\"><div class=\"title font-weight-bold mb-1\">Default time (hour)<div \nclass=\"badge badge-pill badge-warning pull-right\" role=\"alert\" \nng-if=\"addUser.lastName.$dirty && addUser.lastName.$invalid\">Must be between 1-20 characters</div></div><input \nname=\"default_time\" class=\"info form-control\" type=\"number\" ng-model=\"vm.labour.default_time\" required \nng-maxlength=\"20\"></div><button type=\"submit\" class=\"btn bg-blue\" ng-click=\"vm.addLabour()\" \nng-disabled=\"vm.disableAddButton\" style=\"width: 15rem\">Create Labour</button></form></div></div></div></div></div>\n</div>");
$templateCache.put("app/main/settings/labour/dialogs/delete-prompt-dialog-labour.html","<div class=\"card\"><div class=\"modal-header bg-red\"><h5 class=\"modal-title mr-5\">\nAre you sure to delete Preset Labour \"{{vm.labour.labour_name}}\"</h5><button type=\"button\" class=\"close\" \nng-click=\"vm.closeDialog()\"><span aria-hidden=\"true\">&times;</span></button></div><div class=\"card-body\"><p>\nPlease type the \"{{vm.labour.labour_name}}\" below to confirm</p><input type=\"text\" class=\"form-control my-2\" \nplaceholder=\"Type here\" ng-model=\"vm.confirmLabourname\" ng-change=\"vm.enableButton()\"><md-button \nclass=\"bg-red pull-right\" ng-click=\"vm.confirm()\" ng-disabled=\"!vm.isButtonActive\">Confirm!</md-button></div></div>");
$templateCache.put("app/main/settings/labour/edit-labour/edit-labour.html","<div class=\"card\"><div class=\"modal-header bg-blue\"><h5 class=\"modal-title mr-5\">\nEdit fields to change Preset Labour ID: {{vm.labour.id_labour_type}}</h5><button type=\"button\" class=\"close\" \nng-click=\"vm.closeDialog()\"><span aria-hidden=\"true\">&times;</span></button></div><div class=\"card-body\"><p>Description\n</p><input type=\"text\" class=\"form-control my-2\" placeholder=\"Type here\" ng-model=\"vm.labourName\" \nng-change=\"vm.enableButton()\"></div><div class=\"card-body\"><p>Default Rate $</p><input type=\"number\" \nclass=\"form-control my-2\" placeholder=\"Type here\" ng-model=\"vm.labourRate\" ng-change=\"vm.enableButton()\"></div><div \nclass=\"card-body\"><p>Default (hour)</p><input type=\"number\" class=\"form-control my-2\" placeholder=\"Type here\" \nng-model=\"vm.labourTime\" ng-change=\"vm.enableButton()\"></div><md-button class=\"bg-blue pull-right\" \nng-click=\"vm.confirm()\" ng-disabled=\"!vm.isButtonActive\">Confirm!</md-button></div>");
$templateCache.put("app/main/settings/labour/view-labour/view-labour.html","<div class=\"content-wrapper\"><div class=\"header row py-6 bg-primary text-auto px-2\"><span class=\"col h3\">\nTotal Preset labours: <span class=\"h3 text-blue\">{{vm.totalUser}}</span></span><div class=\"col search-wrapper mr-10\" \nstyle=\"max-width: 40rem\"><div class=\"input-group\"><span class=\"input-group-btn\"><button type=\"button\" \nclass=\"btn btn-icon\"><i class=\"icon icon-magnify\"></i></button> </span><input id=\"products-search-input\" type=\"text\" \nclass=\"form-control\" placeholder=\"Search\" ng-model=\"vm.keyword\" aria-label=\"Search\" ng-change=\"vm.search()\"></div>\n</div></div><div class=\"container-fluid\"><div class=\"row justify-content-center mx-10 my-10\"><div class=\"col bg-white\">\n<div class=\"page-content-card\"><table id=\"e-commerce-products-table\" class=\"table dataTable table-striped my-5\"><thead>\n<tr><th><div class=\"table-header\"><span class=\"column-title\">Labour ID</span></div></th><th><div class=\"table-header\">\n<span class=\"column-title\">Description</span></div></th><th><div class=\"table-header\"><span class=\"column-title\">\nDefault Rate $</span></div></th><th><div class=\"table-header\"><span class=\"column-title\">Default Time (hour)</span>\n</div></th><th restrict rolescansee=\"developer company_manager\"><div class=\"table-header\"></div></th><th><form></form>\n</th></tr></thead><tbody><tr ng-repeat=\"labour in vm.labour | filter:searchText\"><td>{{labour.id_labour_type}}</td><td>\n{{labour.labour_name}}</td><td>${{labour.default_rate}}</td><td>{{labour.default_time}}</td><td></td><td><md-button \nclass=\"bg-red\" restrict rolescansee=\"developer company_manager\" ng-disabled=\"!labour.canBeChanged\" \nng-click=\"vm.dialogTest(labour)\" ng-if=\"!user.isOwner\">Delete</md-button></td><td><md-button class=\"bg-blue\" restrict \nrolescansee=\"developer company_manager\" ng-disabled=\"!labour.canBeChanged\" ng-click=\"vm.dialogedit(labour)\" \nng-if=\"!user.isOwner\">Edit</md-button></td></tr></tbody></table><div class=\"row justify-content-center\"><ul \nclass=\"pagination pagination-sm\"><li class=\"page-item\" ng-click=\"vm.goToPage(1)\"><a class=\"page-link\" href=\"#\">&laquo;\n</a></li><li class=\"page-item {{page.isDisabled}}\" ng-repeat=\"page in vm.pages\" \nng-click=\"vm.goToPage(page.pageNumber)\"><a class=\"page-link\" href=\"#\">{{page.pageNumber}}</a></li><li \nclass=\"page-item\" ng-click=\"vm.goToLastPage()\"><a class=\"page-link\" href=\"#\">&raquo;</a></li></ul></div></div></div>\n</div></div></div>");
$templateCache.put("app/main/settings/parttype/add-parttype/add-parttype.html","<div class=\"content-wrapper\"><div class=\"header py-6 bg-primary text-auto px-2\"><span class=\"h3\">Add Preset Part</span>\n</div><div class=\"container-fluid px-10 py-7\"><div class=\"row\"><div \nclass=\"col px-0 profile-box info-box general card mx-2 my-3\"><header class=\"h6 bg-secondary text-auto p-4\"><div \nclass=\"title\">General Information</div></header><div class=\"jumbotron mx-3 my-7 row\"><div class=\"col-7\"><form \nname=\"addPartType\"><div class=\"info-line mb-6\"><div class=\"title font-weight-bold mb-1\">Description<div \nclass=\"badge badge-pill badge-warning pull-right\" ng-if=\"addPartType.name.$dirty && addPartType.name.$invalid\">\nMust be greater than 1 characters</div></div><input name=\"name\" class=\"info form-control\" type=\"text\" \nng-model=\"vm.parttype.name\" ng-blur=\"vm.checkPartTypedescription(vm.parttype.name)\" \nng-focus=\"vm.isUsernameAvailable = undefined\" required ng-pattern=\"regex\" ng-minlength=\"1\"></div><button type=\"submit\" \nclass=\"btn bg-blue\" ng-click=\"vm.addPartType()\" ng-disabled=\"vm.disableAddButton\" style=\"width: 16rem\">Create Part\n</button></form></div></div></div></div></div></div>");
$templateCache.put("app/main/settings/parttype/edit-parttype/edit-parttype.html","<div class=\"card\"><div class=\"modal-header bg-blue\"><h5 class=\"modal-title mr-5\">\nEdit fields to change Preset Part ID: {{vm.parttype.id_part_type}}</h5><button type=\"button\" class=\"close\" \nng-click=\"vm.closeDialog()\"><span aria-hidden=\"true\">&times;</span></button></div><div class=\"card-body\"><p>Description\n</p><input type=\"text\" class=\"form-control my-2\" placeholder=\"Type here\" ng-model=\"vm.name\" \nng-change=\"vm.enableButton()\"></div><md-button class=\"bg-blue pull-right\" ng-click=\"vm.confirm()\" \nng-disabled=\"!vm.isButtonActive\">Confirm!</md-button></div>");
$templateCache.put("app/main/settings/parttype/view-parttypes/view-parttypes.html","<div class=\"content-wrapper\"><div class=\"header row py-6 bg-primary text-auto px-2\"><span class=\"col h3\">\nTotal Preset Parts: <span class=\"h3 text-blue\">{{vm.totalUser}}</span></span><div class=\"col search-wrapper mr-10\" \nstyle=\"max-width: 40rem\"><div class=\"input-group\"><span class=\"input-group-btn\"><button type=\"button\" \nclass=\"btn btn-icon\"><i class=\"icon icon-magnify\"></i></button> </span><input id=\"products-search-input\" type=\"text\" \nclass=\"form-control\" placeholder=\"Search\" ng-model=\"vm.keyword\" aria-label=\"Search\" ng-change=\"vm.search()\"></div>\n</div></div><div class=\"container-fluid\"><div class=\"row justify-content-center mx-10 my-10\"><div class=\"col bg-white\">\n<div class=\"page-content-card\"><table id=\"e-commerce-products-table\" class=\"table dataTable table-striped my-5\"><thead>\n<tr><th><div class=\"table-header\"><span class=\"column-title\">Part ID</span></div></th><th><div class=\"table-header\">\n<span class=\"column-title\">Description</span></div></th><th restrict rolescansee=\"developer company_manager\"><div \nclass=\"table-header\"></div></th><th><form></form></th></tr></thead><tbody><tr \nng-repeat=\"parttype in vm.parttype | filter:searchText\"><td>{{parttype.id_part_type}}</td><td>{{parttype.name}}</td>\n<td></td><td><md-button class=\"bg-red\" restrict rolescansee=\"developer company_manager\" \nng-disabled=\"!parttype.canBeChanged\" ng-click=\"vm.deleteparttype(parttype)\" ng-if=\"!user.isOwner\">Delete</md-button>\n</td><td><md-button class=\"bg-blue\" restrict rolescansee=\"developer company_manager\" \nng-disabled=\"!parttype.canBeChanged\" ng-click=\"vm.dialogedit(parttype)\" ng-if=\"!user.isOwner\">Edit</md-button></td>\n</tr></tbody></table><div class=\"row justify-content-center\"><ul class=\"pagination pagination-sm\"><li \nclass=\"page-item\" ng-click=\"vm.goToPage(1)\"><a class=\"page-link\" href=\"#\">&laquo;</a></li><li \nclass=\"page-item {{page.isDisabled}}\" ng-repeat=\"page in vm.pages\" ng-click=\"vm.goToPage(page.pageNumber)\"><a \nclass=\"page-link\" href=\"#\">{{page.pageNumber}}</a></li><li class=\"page-item\" ng-click=\"vm.goToLastPage()\"><a \nclass=\"page-link\" href=\"#\">&raquo;</a></li></ul></div></div></div></div></div></div>`");
$templateCache.put("app/main/settings/preset-packages/edit-packages/edit-packages.html","<style>\n.card {\r\n		max-width: 600px;\r\n		min-width: 600px;\r\n		margin: 0 auto;\r\n		padding: 20px;\r\n		border-radius: 10px;\r\n		box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);\r\n	}\r\n\r\n	.modal-header {\r\n		display: flex;\r\n		justify-content: space-between;\r\n		align-items: center;\r\n		padding: 10px 20px;\r\n		border-top-left-radius: 10px;\r\n		border-top-right-radius: 10px;\r\n		background-color: #3498db;\r\n		color: white;\r\n	}\r\n\r\n	.modal-title {\r\n		margin: 0;\r\n		font-size: 1.5rem;\r\n		font-weight: bold;\r\n	}\r\n\r\n	.close {\r\n		color: white;\r\n		font-size: 1.5rem;\r\n	}\r\n\r\n	.close:hover {\r\n		color: #f1c40f;\r\n	}\r\n\r\n	p {\r\n		margin: 10px 0;\r\n		font-size: 1.2rem;\r\n		line-height: 1.5;\r\n	}\r\n\r\n	img {\r\n		display: block;\r\n		max-width: 100%;\r\n		height: auto;\r\n		margin-top: 20px;\r\n		border-radius: 5px;\r\n		box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.1);\r\n	}\n</style><div class=\"card\"><div class=\"modal-header\"><h5 class=\"modal-title\">Edit</h5><button type=\"button\" \nclass=\"close\" ng-click=\"vm.closeDialog()\">&times;</button></div><div><h3>Package Details</h3><p>\nID: {{ vm.autocartpackage.id_preset_package }}</p><p ng-if=\"!vm.editingList.name\"><strong>Name:</strong>\n {{ vm.autocartpackage.name }} <button style=\"width: 24px\" ng-click=\"vm.editContent(\'name\')\"><i \nclass=\"icon-pen text-secondary ng-scope\"></i></button></p><div ng-if=\"vm.editingList.name\"><md-input-container \nflex=\"100\" class=\"input-box small-input-box\"><br><input name=\"Name\" ng-model=\" vm.autocartpackage.name\" \nautocomplete=\"off\" placeholder=\"Name\"></md-input-container><button style=\"width: 24px\" \nng-click=\"vm.finisheditContent(\'name\')\"><i class=\"icon-check-all text-secondary ng-scope\"></i></button></div><p \nng-if=\"!vm.editingList.active_expiry_date\"><strong>Active Expiry Date:</strong>\n {{ vm.autocartpackage.active_expiry_date }} <button style=\"width: 24px\" \nng-click=\"vm.editContent(\'active_expiry_date\')\"><i class=\"icon-pen text-secondary ng-scope\"></i></button></p><div \nng-if=\"vm.editingList.active_expiry_date\"><md-input-container flex=\"100\" class=\"input-box small-input-box\">\n<md-datepicker md-hide-icons=\"calendar\" ng-model=\"vm.autocartpackage.active_expiry_date\" name=\"active_expiry_date\" \ndisable></md-datepicker></md-input-container><button style=\"width: 24px\" \nng-click=\"vm.finisheditContent(\'active_expiry_date\')\"><i class=\"icon-check-all text-secondary ng-scope\"></i></button>\n</div><p ng-if=\"!vm.editingList.valid_time\"><strong>Valid Time:</strong> {{ vm.autocartpackage.valid_time }} <button \nstyle=\"width: 24px\" ng-click=\"vm.editContent(\'valid_time\')\"><i class=\"icon-pen text-secondary ng-scope\"></i></button>\n</p><div ng-if=\"vm.editingList.valid_time\"><md-input-container flex=\"100\" class=\"input-box small-input-box\"><br><input \nname=\"Valid Time\" ng-model=\" vm.autocartpackage.valid_time\" autocomplete=\"off\" placeholder=\"Valid Time\" min=\"0\" \nstep=\"1\"></md-input-container><button style=\"width: 24px\" ng-click=\"vm.finisheditContent(\'valid_time\')\"><i \nclass=\"icon-check-all text-secondary ng-scope\"></i></button></div><p ng-if=\"!vm.editingList.price\"><strong>Price:\n</strong> {{ vm.autocartpackage.price }} <button style=\"width: 24px\" ng-click=\"vm.editContent(\'price\')\"><i \nclass=\"icon-pen text-secondary ng-scope\"></i></button></p><div ng-if=\"vm.editingList.price\"><md-input-container \nflex=\"100\" class=\"input-box small-input-box\"><br><input name=\"Price\" ng-model=\" vm.autocartpackage.price\" \nautocomplete=\"off\" placeholder=\"Price\" min=\"0\" step=\"1\"></md-input-container><button style=\"width: 24px\" \nng-click=\"vm.finisheditContent(\'price\')\"><i class=\"icon-check-all text-secondary ng-scope\"></i></button></div><p \nng-if=\"!vm.editingList.valid_mileage\"><strong>Valid Mileage:</strong> {{ vm.autocartpackage.valid_mileage }} <button \nstyle=\"width: 24px\" ng-click=\"vm.editContent(\'valid_mileage\')\"><i class=\"icon-pen text-secondary ng-scope\"></i>\n</button></p><div ng-if=\"vm.editingList.valid_mileage\"><md-input-container flex=\"100\" \nclass=\"input-box small-input-box\"><br><input name=\"Valid Mileage\" ng-model=\" vm.autocartpackage.valid_mileage\" \nautocomplete=\"off\" placeholder=\"Valid Mileage\" min=\"0\" step=\"1\"></md-input-container><button style=\"width: 24px\" \nng-click=\"vm.finisheditContent(\'valid_mileage\')\"><i class=\"icon-check-all text-secondary ng-scope\"></i></button></div>\n<h4>Items</h4><ul><li ng-repeat=\"item in vm.autocartpackage.items\">{{item.id_preset_package_item}}<h5>\nPackage Item Name: {{ item.name }}<md-button class=\"bg-red pull-right\" \nng-click=\"vm.deleteItem(item, vm.autocartpackage)\">DELETE ITEM</md-button></h5><p>\nPackage Item ID: {{ item.id_preset_package_item }}</p><p>Quantity: {{ item.quantity }}</p><h6>Job</h6><ul \nng-if=\"item.fk_id_job\"><li><h6>Job ID: {{ item.fk_id_job }}</h6><h6>Job Labour</h6><ul \nng-if=\"item.coverage_json.job_labour && item.coverage_json.job_labour.length > 0\"><li \nng-repeat=\"labour in item.coverage_json.job_labour\"><p ng-if=\"labour.fk_id_labourtype\">\nLabour Type: {{ labour.fk_id_labourtype }}</p><p ng-if=\"labour.labour_name\">Labour Name: {{ labour.labour_name }}</p><p\n ng-if=\"labour.labour_quantity\">Labour Quantity: {{ labour.labour_quantity }}</p><p \nng-if=\"!vm.editingList[item.id_preset_package_item+\'editlabour\'+labour.fk_id_labourtype+\'labourindex\'+$index] && labour.labour_coverage\">\n<strong>Labour Coverage:</strong> ${{ labour.labour_coverage }} <button style=\"width: 24px\" \nng-click=\"vm.editContent(item.id_preset_package_item+\'editlabour\'+labour.fk_id_labourtype+\'labourindex\'+$index)\"><i \nclass=\"icon-pen text-secondary ng-scope\"></i></button></p><div \nng-if=\"vm.editingList[item.id_preset_package_item+\'editlabour\'+labour.fk_id_labourtype+\'labourindex\'+$index]\">\n<md-input-container flex=\"100\" class=\"input-box small-input-box\"><br><input name=\"Labour Coverage\" \nng-model=\"labour.labour_coverage\" autocomplete=\"off\" placeholder=\"Labour Coverage\" min=\"0\" step=\"0.01\">\n</md-input-container><button style=\"width: 24px\" \nng-click=\"vm.finisheditContent(item.id_preset_package_item+\'editlabour\'+labour.fk_id_labourtype+\'labourindex\'+$index)\">\n<i class=\"icon-check-all text-secondary ng-scope\"></i></button></div><p \nng-if=\"!labour.labour_name && !labour.labour_rate && !labour.labour_quantity && !labour.fk_id_labourtype\">\nNo job labour available.</p></li></ul><p \nng-if=\"!item.coverage_json.job_labour || item.coverage_json.job_labour.length === 0\">No job labour available.</p><h6>\nJob Misc Fee</h6><ul ng-if=\"item.coverage_json.job_miscfee && item.coverage_json.job_miscfee.length > 0\"><li \nng-repeat=\"miscfee in item.coverage_json.job_miscfee\"><p ng-if=\"miscfee.fk_id_miscfeestype\">\nMisc Fee Type: {{ miscfee.fk_id_miscfeestype }}</p><p ng-if=\"miscfee.miscfees_name\">\nMisc Fee Name: {{ miscfee.miscfees_name }}</p><p ng-if=\"miscfee.miscfees_quantity\">\nMisc Fee Quantity: {{ miscfee.miscfees_quantity }}</p><p \nng-if=\"!vm.editingList[item.id_preset_package_item+\'editmiscfee\'+miscfee.fk_id_miscfeestype+\'miscfeeindex\'+$index] && miscfee.miscfees_coverage\">\n<strong>Misc Fee Coverage:</strong> ${{ miscfee.miscfees_coverage }} <button style=\"width: 24px\" \nng-click=\"vm.editContent(item.id_preset_package_item+\'editmiscfee\'+miscfee.fk_id_miscfeestype+\'miscfeeindex\'+$index)\">\n<i class=\"icon-pen text-secondary ng-scope\"></i></button></p><div \nng-if=\"vm.editingList[item.id_preset_package_item+\'editmiscfee\'+miscfee.fk_id_miscfeestype+\'miscfeeindex\'+$index]\">\n<md-input-container flex=\"100\" class=\"input-box small-input-box\"><br><input name=\"Misc Fee Coverage\" \nng-model=\"miscfee.miscfees_coverage\" autocomplete=\"off\" placeholder=\"Misc Fee Coverage\" min=\"0\" step=\"0.01\">\n</md-input-container><button style=\"width: 24px\" \nng-click=\"vm.finisheditContent(item.id_preset_package_item+\'editmiscfee\'+miscfee.fk_id_miscfeestype+\'miscfeeindex\'+$index)\">\n<i class=\"icon-check-all text-secondary ng-scope\"></i></button></div><p \nng-if=\"!miscfee.miscfees_name && !miscfee.miscfees_quantity && !miscfee.fk_id_miscfeestype && !miscfee.default_retail_price\">\nNo job misc fee available.</p></li></ul><p \nng-if=\"!item.coverage_json.job_miscfee || item.coverage_json.job_miscfee.length === 0\">No job misc fee available.</p>\n<h6>Job Part</h6><ul ng-if=\"item.coverage_json.job_part && item.coverage_json.job_part.length > 0\"><li \nng-repeat=\"part in item.coverage_json.job_part\"><p ng-if=\"part.fk_id_parttype\">Part Type: {{ part.fk_id_parttype }}</p>\n<p ng-if=\"part.part_name\">Part Name: {{ part.part_name }}</p><p ng-if=\"part.part_code\">Part Code: {{ part.part_code }}\n</p><p ng-if=\"part.part_quantity\">Part Quantity: {{ part.part_quantity }}</p><p ng-if=\"part.part_coverage\">\nPart Coverage: ${{ part.part_coverage }}</p><p \nng-if=\"!vm.editingList[item.id_preset_package_item+\'editpart\'+part.fk_id_parttype+\'partindex\'+$index] && part.part_coverage\">\n<strong>Part Coverage:</strong> ${{ part.part_coverage }} <button style=\"width: 24px\" \nng-click=\"vm.editContent(item.id_preset_package_item+\'editpart\'+part.fk_id_parttype+\'partindex\'+$index)\"><i \nclass=\"icon-pen text-secondary ng-scope\"></i></button></p><div \nng-if=\"vm.editingList[item.id_preset_package_item+\'editpart\'+part.fk_id_parttype+\'partindex\'+$index] \">\n<md-input-container flex=\"100\" class=\"input-box small-input-box\"><br><input name=\"Part Coverage\" \nng-model=\"part.part_coverage\" autocomplete=\"off\" placeholder=\"Part Coverage\" min=\"0\" step=\"0.01\"></md-input-container>\n<button style=\"width: 24px\" \nng-click=\"vm.finisheditContent(item.id_preset_package_item+\'editpart\'+part.fk_id_parttype+\'partindex\'+$index)\"><i \nclass=\"icon-check-all text-secondary ng-scope\"></i></button></div><p \nng-if=\"!part.part_code && !part.part_name && !part.part_quantity && !part.fk_id_parttype\">No job part available.</p>\n</li></ul><p ng-if=\"!item.coverage_json.job_part || item.coverage_json.job_part.length === 0\">No job part available.\n</p></li></ul><ul ng-if=\"!item.fk_id_job\"><li>no job assigned to this package item</li></ul></li></ul><ul \nng-if=\"vm.autocartpackage.items.length == 0\"><li>no item assigned to this package item</li></ul></div><div \nlayout-algin=\"space-between center\"><div><form flex=\"100\" name=\"packageItemForm\" layout=\"row\" \nlayout-algin=\"start center\"><md-input-container flex=\"20\" class=\"small-input-box\"><input name=\"itemName\" \nng-required=\"true\" ng-model=\"vm.newPackageItemName\" autocomplete=\"off\" placeholder=\"Name\" maxlength=\"200\"><div \nng-messages=\"packageItemForm.itemName.$error\"><div ng-message=\"required\">Required</div></div></md-input-container>\n<md-input-container flex class=\"small-input-box\" flex=\"20\"><input name=\"itemQuantity\" ng-required=\"true\" \nng-model=\"vm.newPackageItemQuantity\" autocomplete=\"off\" placeholder=\"Quantity\" maxlength=\"3\" input-control \ninput-translate=\"vm.decimalTranslator\" input-options=\"vm.quantityInputOption\"><div \nng-messages=\"packageItemForm.itemQuantity.$error\"><div ng-message=\"required\">Required</div></div></md-input-container>\n<md-input-container flex=\"60\"><md-select ng-model=\"vm.newAssignedJobHolder\" placeholder=\"Job\"><md-option \nng-value=\"job\" ng-repeat=\"job in vm.jobTyppList\">{{ job.name }}</md-option></md-select></md-input-container></form>\n</div><div flex=\"100\"><form name=\"packageItemJobForm\"><div ng-repeat=\"Job in vm.newAssignedJobHolder track by $index\">\n<div flex=\"100\" ng-if=\"job_part.part_name\" ng-repeat=\"job_part in Job track by $index\">\nPart: {{job_part.part_name || \"None\"}} * {{job_part.part_quantity || 0 }} &nbsp;<md-input-container flex \nclass=\"small-input-box\"><input name=\"part_coverage\" ng-required=\"true\" \nng-model=\"vm.newAssignedJobHolder.job_part[$index].part_coverage\" autocomplete=\"off\" placeholder=\"Coverage\" \ninput-control input-translate=\"vm.decimalTranslator\" input-options=\"vm.quantityInputOption\"></md-input-container></div>\n<div flex=\"100\" ng-if=\"job_labour.labour_name\" ng-repeat=\"job_labour in Job track by $index\">\nLabour: {{job_labour.labour_name || \"None\"}} * {{job_labour.labour_quantity || 0 }} &nbsp;<md-input-container flex \nclass=\"small-input-box\"><input name=\"labour_coverage\" ng-required=\"true\" \nng-model=\"vm.newAssignedJobHolder.job_labour[$index].labour_coverage\" autocomplete=\"off\" placeholder=\"Coverage\" \ninput-control input-translate=\"vm.decimalTranslator\" input-options=\"vm.quantityInputOption\"></md-input-container></div>\n<div flex=\"100\" ng-if=\"job_miscfee.miscfees_name\" ng-repeat=\"job_miscfee in Job track by $index\">\nMisc Fees: {{job_miscfee.miscfees_name || \"None\"}} * {{job_miscfee.miscfees_quantity || 0 }} &nbsp;<md-input-container \nflex class=\"small-input-box\"><input name=\"miscfees_coverage\" ng-required=\"true\" \nng-model=\"vm.newAssignedJobHolder.job_miscfee[$index].miscfees_coverage\" autocomplete=\"off\" placeholder=\"Coverage\" \ninput-control input-translate=\"vm.decimalTranslator\" input-options=\"vm.quantityInputOption\"></md-input-container></div>\n</div></form></div></div><div layout=\"row\"><md-button flex class=\"mx-0 btn-sm btn-secondary\" \nng-disabled=\"vm.isDeleting\" ng-click=\"vm.addItem()\">Add package Item</md-button></div><div layout=\"row\"><md-button \nflex class=\"mx-0 btn-sm btn-secondary\" ng-disabled=\"vm.isDeleting\" ng-click=\"vm.updatePackage()\">Save and Update\n</md-button></div><div layout=\"row\"><md-button flex class=\"mx-0 btn-sm btn-danger\" ng-disabled=\"vm.isDeleting\" \nng-click=\"vm.cancelEdit()\">Cancel</md-button></div></div>");
$templateCache.put("app/main/settings/preset-packages/view-packages/view-packages.html","<div style=\"width: 100%\" class=\"bg-secondary header-backgroud\" layout=\"row\" layout-align=\"center center\"><div flex \nclass=\"content-max-width content-padding-full\"><span class=\"h2 white-fg\">Add Package</span></div></div><div \nstyle=\"width: 100%\" layout=\"row\" layout-align=\"center start\"><div flex class=\"content-max-width content-padding-half\">\n<div layout=\"row\" class=\"content-padding-half\"><div flex=\"100\" flex-gt-sm=\"50\"><form layout=\"row\" \nlayout-algin=\"start center\" name=\"newPackageForm\"><md-input-container flex class=\"small-input-box\"><input \nng-required=\"true\" name=\"newPackageName\" ng-model=\"vm.newPresetPackage.name\" autocomplete=\"off\" placeholder=\"Name\" \nmaxlength=\"200\"><div ng-messages=\"newPackageForm.newPackageName.$error\"><div ng-message=\"required\">Required</div></div>\n</md-input-container><md-input-container flex class=\"small-input-box\"><input ng-required=\"true\" name=\"newPackagePrice\" \nng-model=\"vm.newPresetPackage.price\" autocomplete=\"off\" placeholder=\"Price\" maxlength=\"10\" input-control \ninput-translate=\"vm.translateToDollar\"><div ng-messages=\"newPackageForm.newPackagePrice.$error\"><div \nng-message=\"required\">Required</div></div></md-input-container><md-input-container flex class=\"small-input-box\"><input \nng-required=\"true\" name=\"newPackageValidTime\" ng-model=\"vm.newPresetPackage.valid_time\" autocomplete=\"off\" \nplaceholder=\"Duration (month)\" maxlength=\"2\" input-control input-translate=\"vm.decimalTranslator\" \ninput-options=\"vm.quantityInputOption\"><div ng-messages=\"newPackageForm.newPackageValidTime.$error\"><div \nng-message=\"required\">Required</div></div></md-input-container></form><form layout=\"row\" layout-algin=\"start center\" \nname=\"newPackageForm2\"><md-input-container flex class=\"small-input-box\"><label>Expiry</label><md-datepicker \nmd-min-date=\"vm.today\" md-hide-icons=\"calendar\" ng-model=\"vm.newPackageActiveExpiryDate\" \nname=\"newPackageActiveExpiryDate\" ng-change=\"vm.setActiveExpDate()\"></md-datepicker><div \nng-messages=\"newPackageForm2.newPackageActiveExpiryDate.$error\"><div ng-message=\"valid\">Invalid date.</div><div \nng-message=\"mindate\">Should after today</div></div></md-input-container><md-input-container flex \nclass=\"small-input-box\"><label>Leave 0 or blank to have no limit</label><input ng-required=\"false\" \nname=\"newPackageMileage\" ng-model=\"vm.newPresetPackage.valid_mileage\" autocomplete=\"off\" placeholder=\"Expiry Mileage\" \nmaxlength=\"10\" type=\"number\" input-control><div ng-messages=\"newPackageForm2.newPackageMileage.$error\"><div \nng-message=\"maxlength\">Invalid number, must be less than 10 digit.</div><div ng-message=\"required\">Required</div></div>\n</md-input-container></form>Items:<md-divider class=\"mb-1\"></md-divider><div layout=\"row\" \nlayout-align=\"space-between center\" ng-repeat=\"item in vm.newPresetPackage.items track by $index\"><div>\n{{item.name}} * {{item.quantity}}</div><div>Job: {{item.job.name || \"None\"}}<div \nng-repeat=\"Job in item.job track by $index\"><div ng-if=\"job_part.part_name\" \nng-repeat=\"job_part in Job track by $index\">\n&nbsp; Part: {{job_part.part_name || \"None\"}} * {{job_part.part_quantity || 0 }}&nbsp;&nbsp;, Coverage: ${{job_part.part_coverage || 0 }}\n</div><div ng-if=\"job_labour.labour_name\" ng-repeat=\"job_labour in Job track by $index\">\n&nbsp; Labour: {{job_labour.labour_name || \"None\"}} * {{job_labour.labour_quantity || 0 }}&nbsp;&nbsp;, Coverage: ${{job_labour.labour_coverage || 0 }}\n</div><div ng-if=\"job_miscfee.miscfees_name\" ng-repeat=\"job_miscfee in Job track by $index\">\n&nbsp; Misc Fees: {{job_miscfee.miscfees_name || \"None\"}} * {{job_miscfee.miscfees_quantity || 0 }}&nbsp;&nbsp;, Coverage: ${{job_miscfee.miscfees_coverage || 0 }}\n</div></div><md-divider class=\"mb-1\"></md-divider></div><i class=\"text-red icon-delete-forever m-2\" \nng-click=\"vm.removeNewItem($index)\"></i></div><div class=\"mt-2\" ng-if=\"!(vm.newPresetPackage.items.length > 0)\">\nNo item added.</div><md-divider class=\"mt-1\"></md-divider><div layout=\"row\" layout-algin=\"space-between center\"><form \nflex=\"66\" name=\"packageItemForm\" layout=\"row\" layout-algin=\"start center\"><md-input-container flex \nclass=\"small-input-box\"><input name=\"itemName\" ng-required=\"true\" ng-model=\"vm.newPackageItemName\" autocomplete=\"off\" \nplaceholder=\"Name\" maxlength=\"200\"><div ng-messages=\"packageItemForm.itemName.$error\"><div ng-message=\"required\">\nRequired</div></div></md-input-container><md-input-container flex class=\"small-input-box\"><input name=\"itemQuantity\" \nng-required=\"true\" ng-model=\"vm.newPackageItemQuantity\" autocomplete=\"off\" placeholder=\"Quantity\" maxlength=\"3\" \ninput-control input-translate=\"vm.decimalTranslator\" input-options=\"vm.quantityInputOption\"><div \nng-messages=\"packageItemForm.itemQuantity.$error\"><div ng-message=\"required\">Required</div></div></md-input-container>\n<md-input-container><md-select ng-model=\"vm.newAssignedJobHolder\" placeholder=\"Job\"><md-option ng-value=\"job\" \nng-repeat=\"job in vm.jobTyppList\">{{ job.name }}</md-option></md-select></md-input-container></form><button flex=\"33\" \nclass=\"ml-2 mb-5\" ng-click=\"vm.addItem()\"><i tabindex=\"0\" class=\"tabbable-button icon-plus-circle text-green\"></i>\n</button></div><div layout=\"column\" layout-align=\"space-between start\"><form name=\"packageItemJobForm\"><div \nng-repeat=\"Job in vm.newAssignedJobHolder track by $index\"><div flex=\"100\" ng-if=\"job_part.part_name\" \nng-repeat=\"job_part in Job track by $index\">\nPart: {{job_part.part_name || \"None\"}} * {{job_part.part_quantity || 0 }} &nbsp;<md-input-container flex \nclass=\"small-input-box\"><input name=\"part_coverage\" ng-required=\"true\" \nng-model=\"vm.newAssignedJobHolder.job_part[$index].part_coverage\" autocomplete=\"off\" placeholder=\"coverage\" \ninput-control input-translate=\"vm.decimalTranslator\" input-options=\"vm.quantityInputOption\"></md-input-container><div \nng-messages=\"packageItemJobForm.part_coverage.$error\"><div ng-message=\"required\">Required</div></div></div><div \nflex=\"100\" ng-if=\"job_labour.labour_name\" ng-repeat=\"job_labour in Job track by $index\">\nLabour: {{job_labour.labour_name || \"None\"}} * {{job_labour.labour_quantity || 0 }} &nbsp;<md-input-container flex \nclass=\"small-input-box\"><input name=\"labour_coverage\" ng-required=\"true\" \nng-model=\"vm.newAssignedJobHolder.job_labour[$index].labour_coverage\" autocomplete=\"off\" placeholder=\"coverage\" \ninput-control input-translate=\"vm.decimalTranslator\" input-options=\"vm.quantityInputOption\"></md-input-container><div \nng-messages=\"packageItemJobForm.labour_coverage.$error\"><div ng-message=\"required\">Required</div></div></div><div \nflex=\"100\" ng-if=\"job_miscfee.miscfees_name\" ng-repeat=\"job_miscfee in Job track by $index\">\nMisc Fees: {{job_miscfee.miscfees_name || \"None\"}} * {{job_miscfee.miscfees_quantity || 0 }} &nbsp;<md-input-container \nflex class=\"small-input-box\"><input name=\"miscfees_coverage\" ng-required=\"true\" \nng-model=\"vm.newAssignedJobHolder.job_miscfee[$index].miscfees_coverage\" autocomplete=\"off\" placeholder=\"coverage\" \ninput-control input-translate=\"vm.decimalTranslator\" input-options=\"vm.quantityInputOption\"><div \nng-messages=\"packageItemJobForm.miscfees_coverage.$error\"><div ng-message=\"required\">Required</div></div>\n</md-input-container></div></div></form></div><md-button ng-disabled=\"vm.isSaving\" class=\"mx-0 btn-secondary\" \nng-click=\"vm.addPackage()\"><div tabindex=\"0\" class=\"tabbable-button\">Add package</div></md-button></div></div></div>\n</div>");
$templateCache.put("app/main/settings/miscfeestypes/add-miscfeestypes/add-miscfeestypes.html","<div class=\"content-wrapper\"><div class=\"header py-6 bg-primary text-auto px-2\"><span class=\"h3\">\nAdd Preset Miscellaneous Fees</span></div><div class=\"container-fluid px-10 py-7\"><div class=\"row\"><div \nclass=\"col px-0 profile-box info-box general card mx-2 my-3\"><header class=\"h6 bg-secondary text-auto p-4\"><div \nclass=\"title\">General Information</div></header><div class=\"jumbotron mx-3 my-7 row\"><div class=\"col-7\"><form \nname=\"addmiscfeestypes\"><div class=\"info-line mb-6\"><div class=\"title font-weight-bold mb-1\">Description<div \nclass=\"badge badge-pill badge-warning pull-right\" \nng-if=\"addmiscfeestypes.name.$dirty && addmiscfeestypes.name.$invalid\">Must be greater than 1 characters</div></div>\n<input name=\"name\" class=\"info form-control\" type=\"text\" ng-model=\"vm.miscfeestypes.name\" \nng-blur=\"vm.checkmiscfeestypesdescription(vm.miscfeestypes.name)\" ng-focus=\"vm.isUsernameAvailable = undefined\" \nrequired ng-pattern=\"regex\" ng-minlength=\"1\"></div><div class=\"info-line mb-6\"><div \nclass=\"title font-weight-bold mb-1\">Default Retail $</div><input name=\"default_retail_price\" class=\"info form-control\" \ntype=\"number\" ng-model=\"vm.miscfeestypes.default_retail_price\" required ng-maxlength=\"20\"></div><div \nclass=\"info-line mb-6\"><div class=\"title font-weight-bold mb-1\">Default Quantity</div><input name=\"default_quantity\" \nclass=\"info form-control\" type=\"number\" ng-model=\"vm.miscfeestypes.default_quantity\" required ng-maxlength=\"20\"></div>\n<div class=\"card-body\"><p><strong>Is Work Order Default Item:</strong><md-checkbox class=\"my-2 mb-0 p-0\" \nng-model=\"vm.miscfeestypes.is_default\"></md-checkbox></p></div><button type=\"submit\" class=\"btn bg-blue\" \nng-click=\"vm.addmiscfeestypes()\" ng-disabled=\"vm.disableAddButton\" style=\"width: 40rem\">Create Miscellaneous Fee\n</button></form></div></div></div></div></div></div>");
$templateCache.put("app/main/settings/miscfeestypes/dialogs/delete-prompt-dialog-miscfeestypes.html","<div class=\"card\"><div class=\"modal-header bg-red\"><h5 class=\"modal-title mr-5\">\nAre you sure to delete preset miscellaneous fee: \"{{vm.miscfeestypes.name}}\"</h5><button type=\"button\" class=\"close\" \nng-click=\"vm.closeDialog()\"><span aria-hidden=\"true\">&times;</span></button></div><div class=\"card-body\"><p>\nPlease type the \"{{vm.miscfeestypes.name}}\" below to confirm</p><input type=\"text\" class=\"form-control my-2\" \nplaceholder=\"Type here\" ng-model=\"vm.confirmmiscfeesname\" ng-change=\"vm.enableButton()\"><md-button \nclass=\"bg-red pull-right\" ng-click=\"vm.confirm()\" ng-disabled=\"!vm.isButtonActive\">Confirm!</md-button></div></div>");
$templateCache.put("app/main/settings/miscfeestypes/edit-miscfeestypes/edit-miscfeestypes.html","<div class=\"card\"><div class=\"modal-header bg-blue\"><h5 class=\"modal-title mr-5\">\nEdit fields to change preset miscellaneous fee ID: {{vm.miscfeestypes.id_miscfee}}</h5><button type=\"button\" \nclass=\"close\" ng-click=\"vm.closeDialog()\"><span aria-hidden=\"true\">&times;</span></button></div><div class=\"card-body\">\n<p>Description</p><div class=\"badge badge-pill badge-warning pull-left\">Must be greater than 1 characters</div><input \ntype=\"text\" class=\"form-control my-2\" placeholder=\"Type here\" ng-model=\"vm.name\" ng-change=\"vm.enableButton()\"></div>\n<div class=\"card-body\"><p>Default Retail $</p><input type=\"number\" class=\"form-control my-2\" placeholder=\"Type here\" \nng-model=\"vm.default_retail_price\" ng-change=\"vm.enableButton()\"></div><div class=\"card-body\"><p>Default Quantity</p>\n<input type=\"number\" class=\"form-control my-2\" placeholder=\"Type here\" ng-model=\"vm.default_quantity\" \nng-change=\"vm.enableButton()\"></div><div class=\"card-body\"><p><strong>Is Work Order Default Item:</strong><md-checkbox \nclass=\"my-2 mb-0 p-0\" ng-model=\"vm.is_default\"></md-checkbox></p></div><md-button class=\"bg-blue pull-right\" \nng-click=\"vm.confirm()\" ng-disabled=\"!vm.isButtonActive\">Confirm</md-button></div>");
$templateCache.put("app/main/settings/miscfeestypes/view-miscfeestypes/view-miscfeestypes.html","<div class=\"content-wrapper\"><div class=\"header row py-6 bg-primary text-auto px-2\"><span class=\"col h3\">\nTotal Preset Miscellaneous Fees: <span class=\"h3 text-blue\">{{vm.totalUser}}</span></span><div \nclass=\"col search-wrapper mr-10\" style=\"max-width: 40rem\"><div class=\"input-group\"><span class=\"input-group-btn\">\n<button type=\"button\" class=\"btn btn-icon\"><i class=\"icon icon-magnify\"></i></button> </span><input \nid=\"products-search-input\" type=\"text\" class=\"form-control\" placeholder=\"Search\" ng-model=\"vm.keyword\" \naria-label=\"Search\" ng-change=\"vm.search()\"></div></div></div><div class=\"container-fluid\"><div \nclass=\"row justify-content-center mx-10 my-10\"><div class=\"col bg-white\"><div class=\"page-content-card\"><table \nid=\"e-commerce-products-table\" class=\"table dataTable table-striped my-5\"><thead><tr><th><div class=\"table-header\">\n<span class=\"column-title\">Miscellaneous Fees ID</span></div></th><th><div class=\"table-header\"><span \nclass=\"column-title\">Description</span></div></th><th><div class=\"table-header\"><span class=\"column-title\">\nDefault Retail $</span></div></th><th><div class=\"table-header\"><span class=\"column-title\">Default Quantity</span>\n</div></th><th><div class=\"table-header\"><span class=\"column-title\">Default Item</span></div></th><th restrict \nrolescansee=\"developer company_manager\"><div class=\"table-header\"></div></th><th><form></form></th></tr></thead><tbody>\n<tr ng-repeat=\"miscfees in vm.miscfeestypes | filter:searchText\"><td>{{miscfees.id_miscfee}}</td><td>{{miscfees.name}}\n</td><td>${{miscfees.default_retail_price}}</td><td>{{miscfees.default_quantity}}</td><td>{{miscfees.is_default == 1}}\n</td><td><md-button class=\"bg-red\" restrict rolescansee=\"developer company_manager\" \nng-disabled=\"!miscfees.canBeChanged\" ng-click=\"vm.dialogTest(miscfees)\" ng-if=\"!user.isOwner\">Delete</md-button></td>\n<td><md-button class=\"bg-blue\" restrict rolescansee=\"developer company_manager\" ng-disabled=\"!miscfees.canBeChanged\" \nng-click=\"vm.dialogedit(miscfees)\" ng-if=\"!user.isOwner\">Edit</md-button></td></tr></tbody></table><div \nclass=\"row justify-content-center\"><ul class=\"pagination pagination-sm\"><li class=\"page-item\" \nng-click=\"vm.goToPage(1)\"><a class=\"page-link\" href=\"#\">&laquo;</a></li><li class=\"page-item {{page.isDisabled}}\" \nng-repeat=\"page in vm.pages\" ng-click=\"vm.goToPage(page.pageNumber)\"><a class=\"page-link\" href=\"#\">{{page.pageNumber}}\n</a></li><li class=\"page-item\" ng-click=\"vm.goToLastPage()\"><a class=\"page-link\" href=\"#\">&raquo;</a></li></ul></div>\n</div></div></div></div></div>");
$templateCache.put("app/main/settings/users/add-user/add-user.html","<div class=\"content-wrapper\"><div class=\"header py-6 bg-primary text-auto px-2\"><span class=\"h3\">Add New User</span>\n</div><div class=\"container-fluid px-10 py-7\"><div class=\"row\"><div \nclass=\"col px-0 profile-box info-box general card mx-2 my-3\"><header class=\"h6 bg-secondary text-auto p-4\"><div \nclass=\"title\">General Information</div></header><div class=\"jumbotron mx-3 my-7 row\"><div class=\"col-7\"><form \nname=\"addUser\"><div class=\"info-line mb-6\"><div class=\"title font-weight-bold mb-1\">Username <span \nclass=\"badge badge-pill badge-warning pull-right\" ng-if=\"addUser.username.$dirty && (vm.isUsernameAvailable == false)\">\nUsername in use</span><div class=\"badge badge-pill badge-warning pull-right\" \nng-if=\"addUser.username.$dirty && addUser.username.$invalid\">Must be between 6-20 characters</div><i \nclass=\"icon s-4 text-green icon-check-circle-outline\" \nng-if=\"addUser.username.$dirty && (vm.isUsernameAvailable == true) && addUser.username.$valid\"></i>\n<md-progress-circular class=\"pull-right mx-2\" md-diameter=\"20px\" \nng-if=\"addUser.username.$dirty && vm.isCheckingUsername\"></md-progress-circular></div><input name=\"username\" \nclass=\"info form-control\" type=\"text\" ng-model=\"vm.user.username\" ng-blur=\"vm.checkUsername(vm.user.username)\" \nng-focus=\"vm.isUsernameAvailable = undefined\" required ng-pattern=\"/^[a-zA-Z0-9]*$/\" ng-maxlength=\"20\" \nng-minlength=\"6\"></div><div class=\"info-line mb-6\"><div class=\"title font-weight-bold mb-1\">Password<div \nclass=\"badge badge-pill badge-warning pull-right\" role=\"alert\" \nng-if=\"addUser.password.$dirty && addUser.password.$invalid\">Must be between 6-20 characters</div></div><input \nname=\"password\" class=\"info form-control\" type=\"password\" ng-model=\"vm.user.password\" required ng-maxlength=\"20\" \nng-minlength=\"6\"></div><div class=\"info-line mb-6\"><div class=\"title font-weight-bold mb-1\">First Name<div \nclass=\"badge badge-pill badge-warning pull-right\" role=\"alert\" \nng-if=\"addUser.firstName.$dirty && addUser.firstName.$invalid\">Must be between 1-20 characters</div></div><input \nname=\"firstName\" class=\"info form-control\" type=\"text\" ng-model=\"vm.user.first_name\" required ng-maxlength=\"20\"></div>\n<div class=\"info-line mb-6\"><div class=\"title font-weight-bold mb-1\">Last Name<div \nclass=\"badge badge-pill badge-warning pull-right\" role=\"alert\" \nng-if=\"addUser.lastName.$dirty && addUser.lastName.$invalid\">Must be between 1-20 characters</div></div><input \nname=\"lastName\" class=\"info form-control\" type=\"text\" ng-model=\"vm.user.last_name\" required ng-maxlength=\"20\"></div>\n<div class=\"info-line mb-6\"><div class=\"title font-weight-bold mb-1\">Email <span \nclass=\"badge badge-pill badge-warning pull-right\" ng-if=\"addUser.email.$dirty && (vm.isEmailAvailable == false)\">\nE-mail already assigned to a different user</span><div class=\"badge badge-pill badge-warning pull-right\" \nng-if=\"addUser.email.$dirty && addUser.email.$invalid\">Invalid E-mail</div><i \nclass=\"icon s-4 text-green icon-check-circle-outline\" \nng-if=\"addUser.username.$dirty && (vm.isEmailAvailable == true) && addUser.email.$valid\"></i><md-progress-circular \nclass=\"pull-right mx-2\" md-diameter=\"20px\" ng-if=\"addUser.email.$dirty && vm.isCheckingEmail\"></md-progress-circular>\n</div><input name=\"email\" class=\"info form-control\" type=\"email\" ng-model=\"vm.user.email\" \nng-blur=\"vm.checkEmail(vm.user.email)\" ng-focus=\"vm.isEmailAvailable = undefined\" required ng-maxlength=\"50\"></div><div\n class=\"info-line mb-6\"><div class=\"title font-weight-bold mb-1\">Address</div><input class=\"info form-control\" \ntype=\"text\" ng-model=\"vm.user.address\"></div><div class=\"info-line mb-6\"><div class=\"title font-weight-bold mb-1\">\nRegistration Number<div class=\"badge badge-pill badge-warning pull-right\" role=\"alert\" \nng-if=\"addUser.registNumber.$dirty && addUser.registNumber.$invalid\">Can only contain maximum 10 digits</div></div>\n<input name=\"registNumber\" class=\"info form-control\" type=\"text\" ng-model=\"vm.user.registration_number\" \nng-pattern=\"/^[0-9]*$/\" ng-maxlength=\"10\"></div><button type=\"submit\" class=\"btn bg-blue\" ng-click=\"vm.addUser()\" \nng-disabled=\"vm.disableAddButton\" style=\"width: 15rem\">Create User</button></form></div><div class=\"col-4\"><div \nclass=\"info-line mb-6\"><div class=\"title font-weight-bold mb-1\">Profile Picture</div><div class=\"text-center\"><img \nclass=\"mx-3 my-3 rounded\" ng-if=\"vm.uploader.queue.length == 0\" ng-src=\"assets/images/default-user-profile-photo.png\" \nstyle=\"min-width: 100px; width: 70%;object-fit: cover\"><div><div ng-repeat=\"item in vm.uploader.queue\"><img \nclass=\"rounded\" ng-src=\"{{item.imageSrc}}\" style=\"min-width: 100px;width: 70%; object-fit: cover\"></div><button \nng-disabled=\"vm.disableAddButton\" class=\"btn\" style=\"width: 15rem\">Select Image <input class=\"fileInput\" \nnv-file-select=\"false\" uploader=\"vm.uploader\" type=\"file\"></button></div></div></div></div></div></div><div \nclass=\"col px-0 profile-box info-box general card mx-2 my-3\" style=\"max-width: 50rem\" restrict \nrolescansee=\"developer company_manager sales_manager\"><header class=\"h6 bg-secondary text-auto p-4\"><div class=\"title\">\nRoles & Permissions</div></header><div class=\"jumbotron mx-3 my-7\"><div class=\"card my-3\" ng-repeat=\"role in vm.roles\">\n<div class=\"card-header\"><input type=\"checkbox\" ng-model=\"role.isCheck\"> {{role.displayName || role.roleTitle}}</div>\n<div class=\"card-body\"><p class=\"card-text\">{{role.description}}</p></div><div class=\"card-footer\"><small \nclass=\"text-muted\"></small></div></div></div></div></div></div></div>");
$templateCache.put("app/main/settings/users/dialogs/delete-prompt-dialog.html","<div class=\"card\"><div class=\"modal-header bg-red\"><h5 class=\"modal-title mr-5\">\nAre you sure to delete user \"{{vm.user.username}}\"</h5><button type=\"button\" class=\"close\" ng-click=\"vm.closeDialog()\">\n<span aria-hidden=\"true\">&times;</span></button></div><div class=\"card-body\"><p>\nPlease type the \"{{vm.user.username}}\" below to confirm</p><input type=\"text\" class=\"form-control my-2\" \nplaceholder=\"Type here\" ng-model=\"vm.confirmUsername\" ng-change=\"vm.enableButton()\"><md-button \nclass=\"bg-red pull-right\" ng-click=\"vm.confirm()\" ng-disabled=\"!vm.isButtonActive\">Confirm!</md-button></div></div>");
$templateCache.put("app/main/settings/users/edit-user/edit-user.html","<div class=\"content-wrapper\"><div class=\"header py-6 bg-primary text-auto px-2\"><span class=\"h3\">Edit User : <span \nclass=\"h3 text-blue\">{{vm.headerFirstName}} {{vm.headerLastName}}</span></span></div><div \nclass=\"container-fluid px-10 py-7\"><div class=\"row\"><div class=\"col px-0 profile-box info-box general card mx-2 my-3\">\n<header class=\"h6 bg-secondary text-auto p-4\"><div class=\"title\">General Information</div></header><div \nclass=\"jumbotron mx-3 my-7 row\"><div class=\"col-7\"><form name=\"editUser\"><div class=\"info-line mb-6\"><div \nclass=\"title font-weight-bold mb-1\">Username <span class=\"badge badge-pill badge-warning pull-right\" \nng-if=\"(vm.isUsernameAvailable == false)\">Username in use</span><div class=\"badge badge-pill badge-warning pull-right\" \nng-if=\"!editUser.username.$valid\">Must be between 6-20 characters</div><i \nclass=\"icon s-4 text-green icon-check-circle-outline\" \nng-if=\"editUser.username.$dirty && (vm.isUsernameAvailable == true) && editUser.username.$valid\"></i>\n<md-progress-circular class=\"pull-right mx-2\" md-diameter=\"20px\" \nng-if=\"editUser.username.$dirty && vm.isCheckingUsername\"></md-progress-circular></div><input name=\"username\" \nclass=\"info form-control\" type=\"text\" ng-model=\"vm.user.username\" ng-blur=\"vm.checkUsername(vm.user.username)\" \nng-focus=\"vm.isUsernameAvailable = undefined\" required ng-pattern=\"/^[a-zA-Z0-9]*$/\" ng-maxlength=\"20\" \nng-minlength=\"6\" restrict rolescanedit=\"developer company_manager\"></div><div class=\"info-line mb-6\" restrict \nrolescansee=\"developer\"><div class=\"title font-weight-bold mb-1\">Password<div \nclass=\"badge badge-pill badge-warning pull-right\" role=\"alert\" ng-if=\"!editUser.password.$valid\">\nMust be between 6-20 characters</div></div><input name=\"password\" class=\"info form-control\" type=\"password\" \nng-model=\"vm.user.password\" ng-maxlength=\"20\" ng-minlength=\"6\" restrict rolescanedit=\"developer\"></div><div \nclass=\"info-line mb-6\"><div class=\"title font-weight-bold mb-1\">First Name<div \nclass=\"badge badge-pill badge-warning pull-right\" role=\"alert\" ng-if=\"!editUser.firstName.$valid\">\nMust be between 1-20 characters</div></div><input name=\"firstName\" class=\"info form-control\" type=\"text\" \nng-model=\"vm.user.first_name\" required ng-maxlength=\"20\" restrict rolescanedit=\"developer company_manager\"></div><div \nclass=\"info-line mb-6\"><div class=\"title font-weight-bold mb-1\">Last Name<div \nclass=\"badge badge-pill badge-warning pull-right\" role=\"alert\" ng-if=\"!editUser.lastName.$valid\">\nMust be between 1-20 characters</div></div><input name=\"lastName\" class=\"info form-control\" type=\"text\" \nng-model=\"vm.user.last_name\" required ng-maxlength=\"20\" restrict rolescanedit=\"developer company_manager\"></div><div \nclass=\"info-line mb-6\"><div class=\"title font-weight-bold mb-1\">Email <span \nclass=\"badge badge-pill badge-warning pull-right\" ng-if=\"(vm.isEmailAvailable == false)\">\nE-mail already assigned to a different user</span><div class=\"badge badge-pill badge-warning pull-right\" \nng-if=\"!editUser.email.$valid\">Invalid E-mail</div><i class=\"icon s-4 text-green icon-check-circle-outline\" \nng-if=\"editUser.email.$dirty && (vm.isEmailAvailable == true) && editUser.email.$valid\"></i><md-progress-circular \nclass=\"pull-right mx-2\" md-diameter=\"20px\" ng-if=\"editUser.email.$dirty && vm.isCheckingEmail\"></md-progress-circular>\n</div><input name=\"email\" class=\"info form-control\" type=\"email\" ng-model=\"vm.user.email\" ng-blur=\"vm.checkEmail()\" \nng-focus=\"vm.isEmailAvailable = undefined\" required ng-maxlength=\"50\" restrict \nrolescanedit=\"developer company_manager sales_manager\"></div><div class=\"info-line mb-6\" restrict \nrolescansee=\"developer company_manager\"><div class=\"title font-weight-bold mb-1\">Address</div><input \nclass=\"info form-control\" type=\"text\" ng-model=\"vm.user.address\" restrict rolescanedit=\"developer company_manager\">\n</div><div class=\"info-line mb-6\" restrict rolescansee=\"developer company_manager sales_manager\"><div \nclass=\"title font-weight-bold mb-1\">Registration Number<div class=\"badge badge-pill badge-warning pull-right\" \nrole=\"alert\" ng-if=\"!editUser.registNumber.$valid\">Can only contain maximum 10 digits</div></div><input \nname=\"registNumber\" class=\"info form-control\" type=\"text\" ng-model=\"vm.user.registration_number\" \nng-pattern=\"/^[0-9]*$/\" ng-maxlength=\"10\" restrict rolescanedit=\"developer company_manager sales_manager\"></div></form>\n</div><div class=\"col-4\"><div class=\"info-line mb-6\"><div class=\"title font-weight-bold mb-1\">Profile Picture</div><div\n class=\"text-center\"><img class=\"mx-3 my-3 rounded\" ng-if=\"vm.uploader.queue.length == 0\" \nng-src=\"{{vm.user.profileimage[0].url == null ? \'assets/images/default-user-profile-photo.png\': vm.user.profileimage[0].url}}\" \nstyle=\"min-width: 100px; width: 70%;object-fit: cover\"><div ng-repeat=\"item in vm.uploader.queue\"><img class=\"rounded\" \nng-src=\"{{item.imageSrc}}\" style=\"min-width: 100px;width: 70%; object-fit: cover\"></div><button \nng-disabled=\"vm.isDisableButton\" restrict rolescansee=\"developer company_manager\" class=\"btn\" style=\"width: 15rem\">\nUpdate Image <input class=\"fileInput\" nv-file-select=\"\" uploader=\"vm.uploader\" type=\"file\"></button></div></div></div>\n</div></div><div class=\"col px-0 profile-box info-box general card mx-2 my-3\" style=\"max-width: 50rem\" restrict \nrolescansee=\"developer company_manager sales_manager\"><header class=\"h6 bg-secondary text-auto p-4\"><div class=\"title\">\nRoles & Permissions</div></header><div class=\"jumbotron mx-3 my-7\"><div class=\"card my-3\" \nng-repeat=\"role in vm.rolesCanBeChanged\"><div class=\"card-header\"><input type=\"checkbox\" ng-model=\"role.isCheck\">\n {{role.displayName || role.roleTitle}}</div><div class=\"card-body\"><p class=\"card-text\">{{role.description}}</p></div>\n<div class=\"card-footer\"><small class=\"text-muted\"></small></div></div></div></div></div><button type=\"submit\" \nclass=\"btn bg-blue pull-right\" ng-click=\"vm.updateProfile()\" ng-disabled=\"vm.isDisableButton\">Update User</button>\n</div></div>");
$templateCache.put("app/main/settings/users/my-profile/my-profile.html","<div class=\"content-wrapper\"><div class=\"header py-6 bg-primary text-auto px-2\"><span class=\"h3\">My profile</span>\n</div><div class=\"container-fluid px-10 py-7\"><div class=\"row\"><div \nclass=\"col px-0 profile-box info-box general card mx-2 my-3\"><header class=\"h6 bg-secondary text-auto p-4\"><div \nclass=\"title\">General Information</div></header><div class=\"jumbotron mx-3 my-7 row\" style=\"height: 100%\"><div \nclass=\"col-7\"><form name=\"editUser\"><div class=\"info-line mb-6\"><div class=\"title font-weight-bold mb-1\">Username <span\n class=\"badge badge-pill badge-warning pull-right\" ng-if=\"(vm.isUsernameAvailable == false)\">Username in use</span><div\n class=\"badge badge-pill badge-warning pull-right\" ng-if=\"!editUser.username.$valid\">Must be between 6-20 characters\n</div><i class=\"icon s-4 text-green icon-check-circle-outline\" \nng-if=\"editUser.username.$dirty && (vm.isUsernameAvailable == true) && editUser.username.$valid\"></i>\n<md-progress-circular class=\"pull-right mx-2\" md-diameter=\"20px\" \nng-if=\"editUser.username.$dirty && vm.isCheckingUsername\"></md-progress-circular></div><input name=\"username\" \nclass=\"info form-control\" type=\"text\" ng-model=\"vm.user.username\" ng-blur=\"vm.checkUsername(vm.user.username)\" \nng-focus=\"vm.isUsernameAvailable = undefined\" required ng-pattern=\"/^[a-zA-Z0-9]*$/\" ng-maxlength=\"20\" \nng-minlength=\"6\" restrict rolescanedit=\"developer company_manager\"></div><div class=\"info-line mb-6\"><div \nclass=\"title font-weight-bold mb-1\">Password<div class=\"badge badge-pill badge-warning pull-right\" role=\"alert\" \nng-if=\"!editUser.password.$valid\">Must be between 6-20 characters</div></div><input name=\"password\" \nclass=\"info form-control\" type=\"password\" ng-model=\"vm.user.password\" required ng-maxlength=\"20\" ng-minlength=\"6\">\n</div><div class=\"info-line mb-6\"><div class=\"title font-weight-bold mb-1\">First Name<div \nclass=\"badge badge-pill badge-warning pull-right\" role=\"alert\" ng-if=\"!editUser.firstName.$valid\">\nMust be between 1-20 characters</div></div><input name=\"firstName\" class=\"info form-control\" type=\"text\" \nng-model=\"vm.user.first_name\" required ng-maxlength=\"20\" restrict rolescanedit=\"developer company_manager\"></div><div \nclass=\"info-line mb-6\"><div class=\"title font-weight-bold mb-1\">Last Name<div \nclass=\"badge badge-pill badge-warning pull-right\" role=\"alert\" ng-if=\"!editUser.lastName.$valid\">\nMust be between 1-20 characters</div></div><input name=\"lastName\" class=\"info form-control\" type=\"text\" \nng-model=\"vm.user.last_name\" required ng-maxlength=\"20\" restrict rolescanedit=\"developer company_manager\"></div><div \nclass=\"info-line mb-6\"><div class=\"title font-weight-bold mb-1\">Email <span \nclass=\"badge badge-pill badge-warning pull-right\" ng-if=\"(vm.isEmailAvailable == false)\">\nE-mail already assigned to a different user</span><div class=\"badge badge-pill badge-warning pull-right\" \nng-if=\"!editUser.email.$valid\">Invalid E-mail</div><i class=\"icon s-4 text-green icon-check-circle-outline\" \nng-if=\"editUser.email.$dirty && (vm.isEmailAvailable == true) && editUser.email.$valid\"></i><md-progress-circular \nclass=\"pull-right mx-2\" md-diameter=\"20px\" ng-if=\"editUser.email.$dirty && vm.isCheckingEmail\"></md-progress-circular>\n</div><input name=\"email\" class=\"info form-control\" type=\"email\" ng-model=\"vm.user.email\" \nng-blur=\"vm.checkEmail(vm.user.email)\" ng-focus=\"vm.isEmailAvailable = undefined\" required ng-maxlength=\"50\"></div><div\n class=\"info-line mb-6\"><div class=\"title font-weight-bold mb-1\">Address</div><input class=\"info form-control\" \ntype=\"text\" ng-model=\"vm.user.address\"></div><div class=\"info-line mb-6\"><div class=\"title font-weight-bold mb-1\">\nRegistration Number<div class=\"badge badge-pill badge-warning pull-right\" role=\"alert\" \nng-if=\"!editUser.registNumber.$valid\">Can only contain maximum 10 digits</div></div><input name=\"registNumber\" \nclass=\"info form-control\" type=\"text\" ng-model=\"vm.user.registration_number\" ng-pattern=\"/^[0-9]*$/\" restrict \nrolescanedit=\"developer company_manager sales_manager\" ng-maxlength=\"10\"></div><button type=\"submit\" \nclass=\"btn bg-blue\" ng-click=\"vm.updateProfile()\" ng-disabled=\"vm.isDisableButton\">Update My Profile</button></form>\n</div><div class=\"col-4\"><div class=\"info-line mb-6\"><div class=\"title font-weight-bold mb-1\">Profile Picture</div><div\n class=\"text-center\"><img class=\"mx-3 my-3 rounded\" ng-if=\"vm.uploader.queue.length == 0\" \nng-src=\"{{vm.user.profileimage[0].url == null ? \'assets/images/default-user-profile-photo.png\': vm.user.profileimage[0].url}}\" \nstyle=\"min-width: 100px; width: 70%;object-fit: cover\"><div><div ng-repeat=\"item in vm.uploader.queue\"><img \nclass=\"rounded\" ng-src=\"{{item.imageSrc}}\" style=\"min-width: 100px;width: 70%; object-fit: cover\"></div><button \nng-disabled=\"vm.isDisableButton\" class=\"btn\" style=\"width: 15rem\">Update Image <input class=\"fileInput\" \nnv-file-select=\"false\" uploader=\"vm.uploader\" type=\"file\"></button></div></div></div></div></div></div><div \nclass=\"col px-0 profile-box info-box general card mx-2 my-3\" style=\"max-width: 50rem\" ng-if=\"(vm.myRoles.length != 0)\">\n<header class=\"h6 bg-secondary text-auto p-4\"><div class=\"title\">Roles & Permissions</div></header><div \nclass=\"card mx-3 my-7\"><div class=\"card-header bg-secondary\">My Roles</div><ul class=\"list-group list-group-flush\"><li \nclass=\"list-group-item\" ng-repeat=\"myRole in vm.myRoles\"><span class=\"badge badge-pill badge-warning\">{{myRole}}</span>\n</li></ul></div><div class=\"card mx-3 my-7\" ng-if=\"(vm.rolesCanBeChanged.length != 0)\"><div \nclass=\"card-header bg-secondary\">Edit My Roles</div><div class=\"card my-3 mx-3\" \nng-repeat=\"role in vm.rolesCanBeChanged\"><div class=\"card-header\"><input type=\"checkbox\" ng-model=\"role.isCheck\" \nrestrict rolescansee=\"developer company_manager sales_manager\"> {{role.roleTitle}}</div><div class=\"card-body\"><p \nclass=\"card-text\">{{role.description}}</p></div><div class=\"card-footer\"><small class=\"text-muted\"></small></div></div>\n</div></div></div></div></div>");
$templateCache.put("app/main/settings/users/view-user/view-user.html","<div class=\"content-wrapper\"><div class=\"header row py-6 bg-primary text-auto px-2\"><span class=\"col h3\">Total User: \n<span class=\"h3 text-blue\">{{vm.totalUser}}</span></span><div class=\"col search-wrapper mr-10\" \nstyle=\"max-width: 40rem\"><div class=\"input-group\"><span class=\"input-group-btn\"><button type=\"button\" \nclass=\"btn btn-icon\"><i class=\"icon icon-magnify\"></i></button> </span><input id=\"products-search-input\" type=\"text\" \nclass=\"form-control\" placeholder=\"Search\" ng-model=\"vm.keyword\" aria-label=\"Search\" ng-change=\"vm.search()\"></div>\n</div></div><div class=\"container-fluid\"><div class=\"row justify-content-center mx-10 my-10\"><div class=\"col bg-white\">\n<div class=\"page-content-card\"><table id=\"e-commerce-products-table\" class=\"table dataTable table-striped my-5\"><thead>\n<tr><th><div class=\"table-header\"><span class=\"column-title\"></span></div></th><th><div class=\"table-header\"><span \nclass=\"column-title\">Username</span></div></th><th><div class=\"table-header\"><span class=\"column-title\">Name</span>\n</div></th><th restrict rolescansee=\"developer company_manager\"><div class=\"table-header\"><span class=\"column-title\">\nLast Login</span></div></th><th><div class=\"table-header\" restrict rolescansee=\"developer company_manager\"><span \nclass=\"column-title\">Last IP</span></div></th><th><div class=\"table-header\" restrict \nrolescansee=\"developer company_manager\"><span class=\"column-title\">Approx. Location</span></div></th><th><div \nclass=\"table-header\"><span class=\"column-title\">Roles</span></div></th><th restrict \nrolescansee=\"developer company_manager\"><div class=\"table-header\"></div></th><th><form><label>Display :</label><select \nid=\"itemPerPage\" ng-model=\"vm.itemPerPage\" ng-options=\"option for option in vm.options\" ng-change=\"vm.resetTable()\">\n</select></form></th></tr></thead><tbody><tr ng-repeat=\"user in vm.users | filter:searchText\"><td><img class=\"avatar\" \nng-src=\"{{user.profileimage[0].url == null ? \'assets/images/default-user-profile-photo.png\': user.profileimage[0].url}}\">\n</td><td>{{user.username}}</td><td>{{user.first_name}} {{user.last_name}}</td><td restrict \nrolescansee=\"developer company_manager\"><span ng-if=\"user.last_login_at\">\n{{user.last_login_at | date:\'yyyy-MM-dd h:mm a\'}} </span><span ng-if=\"!user.last_login_at\">Never</span></td><td \nrestrict rolescansee=\"developer company_manager\"><span ng-if=\"user.last_login_ip\">{{user.last_login_ip}}</span> <span \nng-if=\"!user.last_login_ip\">-</span></td><td restrict rolescansee=\"developer company_manager\"><div \nng-if=\"user.last_login_city || user.last_login_region || user.last_login_country\">\n{{user.last_login_city ? user.last_login_city + \', \' : \'\'}}{{user.last_login_region ? user.last_login_region + \', \' : \'\'}}{{user.last_login_country}}\n</div><small class=\"text-muted\" ng-if=\"user.last_login_timezone\">{{user.last_login_timezone}}</small> <span \nng-if=\"!user.last_login_city && !user.last_login_region && !user.last_login_country\">-</span></td><td><span \nclass=\"badge badge-pill badge-secondary\" ng-repeat=\"role in user.roles\">{{role}}</span></td><td><md-button \nclass=\"bg-blue\" restrict rolescansee=\"developer company_manager sales_manager\" ng-disabled=\"!user.canBeChanged\" \nng-click=\"vm.goToEditUser(user.id_user, user.fk_id_company)\" ng-if=\"!user.isOwner\">Edit</md-button><md-button \nclass=\"bg-blue\" ng-click=\"vm.goToMyProfile(user.id_user, user.fk_id_company)\" ng-if=\"user.isOwner\">My Profile\n</md-button><md-button class=\"bg-orange\" ng-if=\"vm.canUseForceLogout && !user.isOwner\" \nng-click=\"vm.forceLogoutUser(user)\">Force Logout</md-button></td><td><md-button class=\"bg-red\" restrict \nrolescansee=\"developer company_manager\" ng-disabled=\"!user.canBeChanged\" ng-click=\"vm.dialogTest(user)\" \nng-if=\"!user.isOwner\">delete</md-button></td></tr></tbody></table><div class=\"row justify-content-center\"><ul \nclass=\"pagination pagination-sm\"><li class=\"page-item\" ng-click=\"vm.goToPage(1)\"><a class=\"page-link\" href=\"#\">&laquo;\n</a></li><li class=\"page-item {{page.isDisabled}}\" ng-repeat=\"page in vm.pages\" \nng-click=\"vm.goToPage(page.pageNumber)\"><a class=\"page-link\" href=\"#\">{{page.pageNumber}}</a></li><li \nclass=\"page-item\" ng-click=\"vm.goToLastPage()\"><a class=\"page-link\" href=\"#\">&raquo;</a></li></ul></div></div></div>\n</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-1/template-1.html","<div class=\"template-1\"><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"content pv-24 ph-16\"><div class=\"title h1\" \nng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}\n</div><div class=\"text pt-16\" ng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-2/template-2.html","<div class=\"template-2\"><div class=\"header p-16\" layout=\"row\" layout-align=\"start center\"><div ng-if=\"card.avatar\"><img\n class=\"avatar mr-16\" ng-src=\"{{card.avatar.src}}\" alt=\"{{card.avatar.alt}}\"></div><div class=\"info\"><div \nclass=\"title\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div></div></div><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"text p-16\" ng-if=\"card.text\">{{card.text}}\n</div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-10/template-10.html","<div class=\"template-10 p-16\"><div class=\"pb-16\" layout=\"row\" layout-align=\"space-between center\"><div class=\"info\">\n<div class=\"title secondary-text\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle h2\" \nng-if=\"card.subtitle\">{{card.subtitle}}</div></div><div class=\"media ml-16\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div><div \nclass=\"text\">{{card.text}}</div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-5/template-5.html","<div class=\"template-5 p-16\" layout=\"row\" layout-align=\"space-between start\"><div class=\"info\"><div \nclass=\"title secondary-text\" ng-if=\"card.title\">{{card.title}}</div><div class=\"event h2\" ng-if=\"card.event\">\n{{card.event}}</div></div><div class=\"media ml-16\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-3/template-3.html","<div class=\"template-3 p-16 teal-bg white-fg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" \nlayout-align=\"space-between\"><div class=\"info\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}</div><div \nclass=\"subtitle h3 secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}</div></div><div class=\"cta\"><md-button \nclass=\"m-0\">{{card.cta}}</md-button></div></div><div class=\"media pl-16\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-6/template-6.html","<div class=\"template-6\"><div class=\"content pv-24 ph-16\"><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div><div class=\"title h2\" ng-if=\"card.title\">{{card.title}}</div><div class=\"text pt-8\" \nng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-8/template-8.html","<div class=\"template-8\"><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"content pv-24 ph-16\"><div class=\"title h1\" \nng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}\n</div><div class=\"buttons pt-16\"><md-button class=\"m-0\">{{card.button1}}</md-button><md-button class=\"m-0 md-accent\">\n{{card.button2}}</md-button></div><div class=\"text pt-16\" ng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-4/template-4.html","<div class=\"template-4\"><div class=\"info white-fg ph-16 pv-24\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}\n</div><div class=\"text\" ng-if=\"card.text\">{{card.text}}</div></div><div class=\"media\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-9/template-9.html","<div class=\"template-9\"><div class=\"header p-16\" layout=\"row\" layout-align=\"start center\"><div ng-if=\"card.avatar\"><img\n class=\"avatar mr-16\" ng-src=\"{{card.avatar.src}}\" alt=\"{{card.avatar.alt}}\"></div><div class=\"info\"><div \nclass=\"title\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div></div></div><div class=\"text ph-16 pb-16\" ng-if=\"card.text\">{{card.text}}</div><div \nclass=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" \nng-show=\"card.media.image\"></div><div class=\"buttons m-8\"><md-button class=\"md-icon-button mr-16\" \naria-label=\"Favorite\"><md-icon md-font-icon=\"icon-heart-outline\" class=\"s24\"></md-icon></md-button><md-button \nclass=\"md-icon-button\" aria-label=\"Share\"><md-icon md-font-icon=\"icon-share\" class=\"s24\"></md-icon></md-button></div>\n</div>");
$templateCache.put("app/core/directives/ms-card/templates/template-7/template-7.html","<div class=\"template-7\" layout=\"row\" layout-align=\"space-between\"><div class=\"info\" layout=\"column\" \nlayout-align=\"space-between\" layout-fill flex><div class=\"p-16\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}\n</div><div class=\"subtitle h4 secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}</div><div class=\"text h4 pt-8\" \nng-if=\"card.text\">{{card.text}}</div></div><div><md-divider></md-divider><div class=\"p-8\" layout=\"row\"><md-icon \nmd-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\">\n</md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" \nclass=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon></div></div></div><div \nclass=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" \nng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-stepper/templates/horizontal/horizontal.html","<div class=\"ms-stepper-horizontal\"><div class=\"ms-stepper-navigation-wrapper\"><div class=\"ms-stepper-navigation\" \nlayout=\"row\" layout-align=\"center center\"><md-button class=\"ms-stepper-navigation-item\" \nng-class=\"{\'current\': MsStepper.isStepCurrent(step.stepNumber), \'valid\': MsStepper.isStepValid(step.stepNumber), \'disabled\': MsStepper.isStepDisabled(step.stepNumber), \'optional\': MsStepper.isStepOptional(step.stepNumber)}\" \nng-click=\"MsStepper.gotoStep(step.stepNumber)\" ng-disabled=\"MsStepper.isStepDisabled(step.stepNumber, step)\" \nng-repeat=\"step in MsStepper.steps | filter:MsStepper.filterHiddenStep\" layout=\"row\" layout-align=\"start center\" \nng-if=\"!step.isHidden\"><div class=\"step md-accent-bg\" layout=\"row\" layout-align=\"center center\"><span>\n{{step.displayNumber}}</span></div><div layout=\"column\" layout-align=\"start start\"><div class=\"title\" \ntranslate=\"{{step.stepTitleTranslate}}\">{{step.stepTitle}}</div><div class=\"subtitle\" \nng-if=\"MsStepper.isStepOptional(step.stepNumber)\">Optional</div></div></md-button></div></div><div \nclass=\"ms-stepper-steps\" ng-transclude></div><div class=\"ms-stepper-controls\" layout=\"row\" \nlayout-align=\"center center\"><md-button class=\"md-accent md-raised\" ng-disabled=\"MsStepper.isFirstStep()\" \nng-click=\"MsStepper.gotoPreviousStep()\" \nng-if=\"!MsStepper.steps[MsStepper.currentStepNumber-1].hideActionButtons && !MsStepper.isFirstStep()\">Back</md-button>\n<md-button class=\"md-accent md-raised ms-stepper-dots\" ng-disabled=\"MsStepper.isFirstStep()\" \nng-click=\"MsStepper.gotoPreviousStep()\" ng-if=\"MsStepper.steps[MsStepper.currentStepNumber-1].hideActionButtons\">Back\n</md-button><div class=\"ms-stepper-dots\"><span ng-repeat=\"step in MsStepper.steps\" \nng-hide=\"MsStepper.isStepHidden(step.stepNumber)\" \nng-class=\"{\'selected md-accent-bg\':MsStepper.currentStepNumber === $index + 1}\"></span></div><md-button \nclass=\"md-accent md-raised ms-stepper-dots\" \nng-if=\"!MsStepper.isLastStep()  && MsStepper.steps[MsStepper.currentStepNumber-1].hideActionButtons\" \nng-disabled=\"!MsStepper.isStepValid(MsStepper.currentStepNumber)\" ng-click=\"MsStepper.gotoNextStep()\">Next</md-button>\n<md-button type=\"submit\" class=\"md-accent md-raised ms-stepper-dots\" ng-click=\"MsStepper.resetForm()\" \nng-if=\"MsStepper.isLastStep() && MsStepper.steps[MsStepper.currentStepNumber-1].hideActionButtons\" \nng-disabled=\"!MsStepper.isFormValid()\">Submit</md-button><md-button class=\"md-accent md-raised\" \nng-if=\"!MsStepper.isLastStep() && !MsStepper.steps[MsStepper.currentStepNumber-1].hideActionButtons\" \nng-disabled=\"!MsStepper.isStepValid(MsStepper.currentStepNumber)\" ng-click=\"MsStepper.gotoNextStep()\">Next</md-button>\n<md-button type=\"submit\" class=\"md-accent md-raised\" ng-click=\"MsStepper.resetForm()\" \nng-if=\"MsStepper.isLastStep() && !MsStepper.steps[MsStepper.currentStepNumber-1].hideActionButtons\" \nng-disabled=\"!MsStepper.isFormValid()\">Submit</md-button></div></div>");
$templateCache.put("app/core/directives/ms-stepper/templates/vertical/vertical.html","<div class=\"ms-stepper-vertical\"><div class=\"ms-stepper-vertical-line\"></div><div class=\"ms-stepper-steps\" \nng-transclude></div></div>");
$templateCache.put("app/core/directives/ms-stepper/templates/vertical/step/vertical-step.html","<md-button class=\"ms-stepper-navigation-item\" \nng-class=\"{\'current\': MsStepper.isStepCurrent(stepInfo.stepNumber), \'valid\': MsStepper.isStepValid(stepInfo.stepNumber), \'disabled\': MsStepper.isStepDisabled(stepInfo.stepNumber), \'optional\': MsStepper.isStepOptional(stepInfo.stepNumber)}\" \nng-click=\"MsStepper.gotoStep(stepInfo.stepNumber)\" ng-disabled=\"MsStepper.isStepDisabled(stepInfo.stepNumber)\" \nng-hide=\"MsStepper.isStepHidden(stepInfo.stepNumber)\" aria-label=\"Stepper navigation button\" layout=\"row\" \nlayout-align=\"start center\"><div class=\"step\" layout=\"row\" layout-align=\"center center\"><span \nng-if=\"!MsStepper.isStepValid(stepInfo.stepNumber) || MsStepper.isStepOptional(stepInfo.stepNumber)\"><i \nclass=\"icon icon-checkbox-blank-circle-outline s18 md-accent-fg\"></i> </span><span \nng-if=\"MsStepper.isStepValid(stepInfo.stepNumber) && !MsStepper.isStepOptional(stepInfo.stepNumber)\"><i \nclass=\"icon icon-check-circle s18 md-accent-fg\"></i></span></div><div layout=\"column\" layout-align=\"start start\"><div \nclass=\"title\" ng-if=\"stepInfo.stepTitleTranslate\">{{stepInfo.stepTitleTranslate | translate }}</div><div class=\"title\" \nng-if=\"!stepInfo.stepTitleTranslate\">{{stepInfo.stepTitle}}</div><div class=\"subtitle\" \nng-if=\"MsStepper.isStepOptional(stepInfo.stepNumber)\">Optional</div></div></md-button><div \nclass=\"ms-stepper-step-content\" ng-transclude></div><div class=\"ms-stepper-controls\" layout=\"row\" \nlayout-align=\"start center\" ng-show=\"MsStepper.isStepCurrent(stepInfo.stepNumber)\"><md-button \nclass=\"md-accent md-raised\" ng-disabled=\"MsStepper.isFirstStep()\" ng-click=\"MsStepper.gotoPreviousStep()\">Back\n</md-button><md-button class=\"md-accent md-raised\" ng-if=\"!MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isStepValid(MsStepper.currentStepNumber)\" ng-click=\"MsStepper.gotoNextStep()\">Next</md-button>\n<md-button type=\"submit\" class=\"md-accent md-raised\" ng-click=\"MsStepper.resetForm()\" ng-if=\"MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isFormValid()\">Submit</md-button></div>");}]);